(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".fr-inline-field{display:inline-block;margin-right:16px}.fr-inline-container{display:inline-flex;flex-wrap:wrap}.ant-form-item-optional-hide{padding:0 8px}.ant-form-item-optional-hide .ant-form-item-label>label{font-size:16px;font-weight:#000000d9;font-weight:600}.fr-desc{word-break:break-all;color:#00000073;line-height:22px;margin-left:5px;font-weight:400;font-size:14px}.fr-item-actions{margin-left:12px;display:inline-flex;align-items:center}.fr-hide-label>.ant-form-item-row>.ant-form-item-label{visibility:hidden}.fr-field .ant-form-item-row{flex-wrap:nowrap}.fr-field .ant-form-item-control-input-content{display:flex}.fr-field-visibility{width:0;height:0;visibility:hidden;position:absolute;opacity:0}.fr-form .ant-form-item-control{width:0}.fr-form .fr-inline-field .ant-form-item-control{width:auto}.rc-color-picker-panel-inner{position:relative;border-radius:4px;box-shadow:0 1px 5px #ccc;border:1px solid #ccc;padding-bottom:8px}.rc-color-picker-panel-wrap{margin:5px 0 0;height:30px;width:100%;position:relative}.rc-color-picker-panel-wrap-preview{position:absolute;right:8px}.rc-color-picker-panel-wrap-ribbon{position:absolute;left:8px;top:0;right:43px;height:30px}.rc-color-picker-panel-wrap-alpha{position:absolute;left:8px;right:43px;bottom:0;height:12.5px}.rc-color-picker-panel-wrap-has-alpha .rc-color-picker-panel-wrap-ribbon{height:12.5px}.rc-color-picker-trigger{border:1px solid #999;display:inline-block;padding:2px;border-radius:2px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:20px;height:20px;cursor:pointer;box-shadow:0 0 0 2px #fff inset}.rc-color-picker-trigger-open{box-shadow:0 0 3px #999}.rc-color-picker-panel{width:218px;background-color:#fff;box-sizing:border-box;outline:none;z-index:9;border-radius:4px;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel *{box-sizing:border-box}.rc-color-picker-panel-open{display:block}.rc-color-picker-panel-close{display:none}.rc-color-picker-panel-preview{height:30px;width:30px;overflow:hidden;border-radius:2px;background-image:url(data:image/png;base64,R0lGODdhCgAKAPAAAOXl5f///ywAAAAACgAKAEACEIQdqXt9GxyETrI279OIgwIAOw==)}.rc-color-picker-panel-preview span{box-shadow:0 0 2px gray inset}.rc-color-picker-panel-preview span,.rc-color-picker-panel-preview input[type=color]{position:absolute;display:block;height:100%;width:30px;border-radius:2px}.rc-color-picker-panel-preview input[type=color]{opacity:0}.rc-color-picker-panel-board{position:relative;font-size:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin:8px 8px 0}.rc-color-picker-panel-board span{position:absolute;border-radius:10px;border:1px solid #fff;width:9px;height:9px;margin:-4px 0 0 -4px;left:-999px;top:-999px;box-shadow:0 0 1px #787878b3;z-index:2}.rc-color-picker-panel-board-hsv{width:200px;height:150px;position:relative;z-index:1;border-radius:2px}.rc-color-picker-panel-board-value{border-radius:2px;position:absolute;width:100%;height:100%;left:0;top:0;z-index:2;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9InJnYigwLDAsMCkiIHN0b3Atb3BhY2l0eT0iMCIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzAwMDAwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:-webkit-linear-gradient(top,transparent 0%,#000000 100%);background-image:-moz-linear-gradient(top,transparent 0%,#000000 100%);background-image:-o-linear-gradient(top,transparent 0%,#000000 100%);background-image:linear-gradient(to bottom,transparent 0%,#000000 100%)}.rc-color-picker-panel-board-saturation{border-radius:2px;position:absolute;width:100%;height:100%;left:0;top:0;z-index:1;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmZmZmZmYiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0icmdiKDAsMCwwKSIgc3RvcC1vcGFjaXR5PSIwIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:-webkit-linear-gradient(left,#ffffff 0%,transparent 100%);background-image:-moz-linear-gradient(left,#ffffff 0%,transparent 100%);background-image:-o-linear-gradient(left,#ffffff 0%,transparent 100%);background-image:linear-gradient(to right,#ffffff 0%,transparent 100%)}.rc-color-picker-panel-board-handler{box-shadow:0 0 2px gray inset;border-radius:2px;cursor:crosshair;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:absolute;top:0;left:0;width:100%;height:100%;z-index:3}.rc-color-picker-panel-ribbon{position:relative;height:100%;border-radius:2px;box-shadow:0 0 2px gray inset;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmZjAwMDAiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAlIiBzdG9wLWNvbG9yPSIjZmY5OTAwIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjIwJSIgc3RvcC1jb2xvcj0iI2NkZmYwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSIzMCUiIHN0b3AtY29sb3I9IiMzNWZmMDAiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iNDAlIiBzdG9wLWNvbG9yPSIjMDBmZjY2IiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iIzAwZmZmZCIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSI2MCUiIHN0b3AtY29sb3I9IiMwMDY2ZmYiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iNzAlIiBzdG9wLWNvbG9yPSIjMzIwMGZmIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjgwJSIgc3RvcC1jb2xvcj0iI2NkMDBmZiIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSI5MCUiIHN0b3AtY29sb3I9IiNmZjAwOTkiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmMDAwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:-webkit-linear-gradient(left,#ff0000 0%,#ff9900 10%,#cdff00 20%,#35ff00 30%,#00ff66 40%,#00fffd 50%,#0066ff 60%,#3200ff 70%,#cd00ff 80%,#ff0099 90%,#ff0000 100%);background-image:-moz-linear-gradient(left,#ff0000 0%,#ff9900 10%,#cdff00 20%,#35ff00 30%,#00ff66 40%,#00fffd 50%,#0066ff 60%,#3200ff 70%,#cd00ff 80%,#ff0099 90%,#ff0000 100%);background-image:-o-linear-gradient(left,#ff0000 0%,#ff9900 10%,#cdff00 20%,#35ff00 30%,#00ff66 40%,#00fffd 50%,#0066ff 60%,#3200ff 70%,#cd00ff 80%,#ff0099 90%,#ff0000 100%);background-image:linear-gradient(to right,red,#f90,#cdff00,#35ff00,#0f6,#00fffd,#06f,#3200ff,#cd00ff,#f09,red)}.rc-color-picker-panel-ribbon span{position:absolute;top:0;height:100%;width:4px;border:1px solid #000000;padding:1px 0;margin-left:-2px;background-color:#fff;border-radius:3px}.rc-color-picker-panel-ribbon-handler{position:absolute;width:104%;height:100%;left:-2%;cursor:pointer}.rc-color-picker-panel-alpha{position:relative;height:100%;width:100%;border-radius:2px;background-image:url(data:image/png;base64,R0lGODdhCgAKAPAAAOXl5f///ywAAAAACgAKAEACEIQdqXt9GxyETrI279OIgwIAOw==);background-repeat:repeat;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel-alpha-bg{position:absolute;width:100%;height:100%;border-radius:2px;box-shadow:0 0 2px gray inset}.rc-color-picker-panel-alpha span{position:absolute;top:0;height:100%;width:4px;border:1px solid #000000;padding:1px 0;margin-left:-2px;background-color:#fff;border-radius:3px}.rc-color-picker-panel-alpha-handler{position:absolute;width:104%;height:100%;left:-2%;cursor:pointer}.rc-color-picker-panel-params{font-size:12px}.rc-color-picker-panel-params-input{overflow:hidden;padding:2px 8px}.rc-color-picker-panel-params input{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;text-align:center;padding:1px;margin:0;float:left;border-radius:2px;border:1px solid #CACACA;font-family:Helvetica Neue,Helvetica,sans-serif}.rc-color-picker-panel-params-hex{width:52px}.rc-color-picker-panel-params input[type=number]{margin-left:5px;width:44px}.rc-color-picker-panel-params input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}.rc-color-picker-panel-params-lable{padding:2px 8px;height:22px;line-height:18px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel-params-lable label{float:left;text-align:center}.rc-color-picker-panel-params-lable-hex{width:52px}.rc-color-picker-panel-params-lable-number,.rc-color-picker-panel-params-lable-alpha{margin-left:5px;width:44px;text-transform:uppercase}.rc-color-picker-panel-params-lable-number:hover{border-radius:2px;background-color:#eee;box-shadow:0 0 0 1px #ccc inset;cursor:pointer}.rc-color-picker-panel-params-has-alpha input[type=number],.rc-color-picker-panel-params-has-alpha .rc-color-picker-panel-params-lable-number,.rc-color-picker-panel-params-has-alpha .rc-color-picker-panel-params-lable-alpha{width:32px}.rc-color-picker{position:absolute;left:-9999px;top:-9999px;z-index:1000}.rc-color-picker-wrap{display:inline-block}.rc-color-picker-slide-up-enter,.rc-color-picker-slide-up-appear{animation-duration:.3s;animation-fill-mode:both;transform-origin:0 0;display:block!important;opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-play-state:paused}.rc-color-picker-slide-up-leave{animation-duration:.3s;animation-fill-mode:both;transform-origin:0 0;display:block!important;opacity:1;animation-timing-function:cubic-bezier(.6,.04,.98,.34);animation-play-state:paused}.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-bottomRight,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-bottomRight{animation-name:rcColorPickerSlideUpIn;animation-play-state:running}.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-topRight,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-topRight{animation-name:rcColorPickerSlideDownIn;animation-play-state:running}.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-bottomRight{animation-name:rcColorPickerSlideUpOut;animation-play-state:running}.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-topRight{animation-name:rcColorPickerSlideDownOut;animation-play-state:running}@keyframes rcColorPickerSlideUpIn{0%{opacity:0;transform-origin:0% 0%;transform:scaleY(0)}to{opacity:1;transform-origin:0% 0%;transform:scaleY(1)}}@keyframes rcColorPickerSlideUpOut{0%{opacity:1;transform-origin:0% 0%;transform:scaleY(1)}to{opacity:0;transform-origin:0% 0%;transform:scaleY(0)}}@keyframes rcColorPickerSlideDownIn{0%{opacity:0;transform-origin:100% 100%;transform:scaleY(0)}to{opacity:1;transform-origin:100% 100%;transform:scaleY(1)}}@keyframes rcColorPickerSlideDownOut{0%{opacity:1;transform-origin:100% 100%;transform:scaleY(1)}to{opacity:0;transform-origin:100% 100%;transform:scaleY(0)}}.fr-color-picker{width:100%;display:flex;flex-direction:row;align-items:center;color:#666}.fr-color-picker .rc-color-picker-trigger{margin-right:12px;height:32px;width:60px;border:1px solid #e5e5e5}.fr-color-picker>p{margin:0;font-size:14px;line-height:28px}.fr-color-picker .rc-color-picker-wrap{display:flex}.fr-preview-image{width:160px}.fr-preview{position:relative;cursor:pointer}.fr-slider{display:flex;width:100%;align-items:center}.fr-upload-mod,.fr-upload-file{display:flex}.fr-upload-mod{align-items:center}.fr-upload-mod .fr-upload-preview{margin:0 12px}.fr-upload-file .ant-upload-list-item{margin:5px 0 0 8px}.fr-upload-file .ant-upload-list-item-name{margin-right:6px}.fr-upload-file .ant-upload-list-item-info{cursor:pointer}.fr-upload-file .next-upload-list-text .next-upload-list-item-done,.fr-upload-file .next-upload-list-text .next-upload-list-item .next-icon{height:28px;line-height:28px;margin-left:12px}.fr-upload-file .next-upload-list-item-name-wrap{margin-top:-4px}.fr-panel-bordered{border-radius:4px;border:1px solid #f4f4f4;padding:52px 24px 0;margin-bottom:24px}.fr-obj-card{border-radius:4px;border-color:#f4f4f4;margin-bottom:24px!important}.fr-obj-card .ant-card-head{border:none}.fr-obj-card .ant-card-body{padding:12px 24px!important}.fr-obj-card .fr-header-desc{word-break:break-all;color:#00000073;margin-left:6px;font-weight:400}.fr-obj-collapse{border-radius:4px;border:1px solid #f1f1f1;margin-bottom:24px}.fr-obj-collapse .collapse-title{height:24px;color:#000000e0;font-weight:600;font-size:16px;line-height:24px}.fr-obj-collapse .fr-header-desc{word-break:break-all;color:#00000073;margin-left:6px;font-weight:400}.fr-obj-collapse .header-item-label{height:14px;margin-left:30px;color:#000;font-weight:600;font-size:14px;line-height:14px}.fr-obj-collapse .header-item-label span{color:#141414}.fr-obj-collapse .expand-icon-desc{margin-left:4px}.fr-obj-collapse .ant-collapse-header{display:flex;align-items:center!important;padding:16px!important;background-color:#fff;border-radius:4px!important}.fr-obj-collapse .ant-collapse-header-text{display:flex;align-items:center}.fr-obj-collapse .tag-no-data{color:#000000a6}.fr-obj-collapse .ant-collapse-content-box{padding:12px 24px!important}.fr-obj-collapse .ant-collapse-content-box .ant-skeleton-title,.fr-obj-collapse .ant-collapse-content-box .ant-skeleton-paragraph>li{animation:none!important}.fr-obj-subinline-label-hidden>.ant-form-item-row>.ant-form-item-label{visibility:hidden}.fr-obj-subinline-background>.ant-form-item-row>.ant-form-item-control{background-color:#f6f6f6;padding:24px 24px 0;border-radius:4px}.fr-obj-subinline .ant-form-item-row{flex-wrap:nowrap}.fr-obj-line-title .fr-obj-header{line-height:36px;border-bottom:1px solid #e9e9e9}.fr-obj-line-title .fr-header-title{color:#000000e0;font-size:16px;font-weight:600}.fr-obj-line-title .fr-header-desc{word-break:break-all;color:#00000073;margin-left:6px;font-weight:400}.fr-obj-line-title .fr-obj-content{padding:24px 0 0}.fr-list-simple{display:inline-block}.fr-list-simple .fr-inline-field{min-width:220px;margin-bottom:24px!important}.fr-list-simple .fr-list-item{display:flex;align-items:flex-start;position:relative}.fr-list-simple .fr-list-item-operate{height:32px;gap:0!important}.fr-list-simple-background{padding:24px 24px 0;background-color:#f6f6f6;border-radius:4px}.fr-list-simple-background .add-btn{margin-bottom:24px}.fr-list-simple-column .fr-list-item{align-items:center}.fr-list-card{margin-bottom:24px}.fr-list-card .fr-list-item{display:flex;align-items:flex-start;position:relative}.fr-list-card .fr-list-item-operate{padding:0 20px;height:32px;gap:0!important}.fr-list-card .fr-list-item-operate-fixed{position:absolute;right:8px}.fr-list-card .fr-list-add-btn{padding:0 8px}.fr-table-list{margin-bottom:24px}.fr-table-list .ant-form-item{margin-bottom:0}.fr-table-list .ant-form-item-label,.fr-table-list .ant-form-item-explain-error{display:none}.fr-table-list .fr-list-item-operate{gap:0!important}.fr-table-list-no-popover .ant-table-tbody .ant-table-cell{padding:24px 8px 0!important}.fr-table-list-no-popover .ant-form-item{margin-bottom:24px}.fr-table-list-no-popover .ant-form-item-explain-error{display:block;font-size:10px}.fr-list-drawer{margin-bottom:24px}.fr-list-drawer-table-header{width:100%;display:flex;justify-content:right;align-items:center;margin-bottom:10px}.fr-list-drawer .ant-form-item{margin-bottom:0}.fr-list-drawer .fr-list-item-operate{gap:0!important}.fr-virtual-list{margin-bottom:12px}.fr-virtual-list .ant-form-item{margin-bottom:0}.fr-virtual-list .ant-form-item-label,.fr-virtual-list .ant-form-item-explain-error{display:none}.fr-virtual-list .fr-list-item-operate{gap:0!important}.fr-popover-error .ant-popover-inner-content{color:#ff4d4f!important}.fr-virtual-list-no-popover .ant-table-tbody .ant-table-cell{padding:24px 8px 0!important}.fr-virtual-list-no-popover .ant-form-item{margin-bottom:24px}.fr-virtual-list-no-popover .ant-form-item-explain-error{display:block;font-size:10px}.fr-void-title{height:24px;color:#000000e0;font-weight:600;font-size:16px;line-height:24px}.fr-search{width:100%;background:#fff;padding:24px 24px 0 16px;margin-bottom:16px;box-sizing:border-box;position:relative}.fr-search .search-action-col{flex:1;display:flex;justify-content:flex-end;align-items:baseline;height:56px}.fr-search .search-action-fixed{position:absolute;right:0;bottom:0;background-color:#fff;padding-right:24px!important}.fr-search .search-action-column{height:auto}.fr-search .fr-form>.ant-row{align-items:center}.fr-column-search{padding-left:24px}")),document.head.appendChild(e)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
function _mergeNamespaces(a, s) {
  for (var c = 0; c < s.length; c++) {
    const u = s[c];
    if (typeof u != "string" && !Array.isArray(u)) {
      for (const d in u)
        if (d !== "default" && !(d in a)) {
          const p = Object.getOwnPropertyDescriptor(u, d);
          p && Object.defineProperty(a, d, p.get ? p : {
            enumerable: !0,
            get: () => u[d]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
function getAugmentedNamespace(a) {
  if (Object.prototype.hasOwnProperty.call(a, "__esModule")) return a;
  var s = a.default;
  if (typeof s == "function") {
    var c = function u() {
      var d = !1;
      try {
        d = this instanceof u;
      } catch {
      }
      return d ? Reflect.construct(s, arguments, this.constructor) : s.apply(this, arguments);
    };
    c.prototype = s.prototype;
  } else c = {};
  return Object.defineProperty(c, "__esModule", { value: !0 }), Object.keys(a).forEach(function(u) {
    var d = Object.getOwnPropertyDescriptor(a, u);
    Object.defineProperty(c, u, d.get ? d : {
      enumerable: !0,
      get: function() {
        return a[u];
      }
    });
  }), c;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {}, react = { exports: {} }, react_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var a = Object.getOwnPropertySymbols, s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
  function u(p) {
    if (p == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(p);
  }
  function d() {
    try {
      if (!Object.assign)
        return !1;
      var p = new String("abc");
      if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5")
        return !1;
      for (var v = {}, A = 0; A < 10; A++)
        v["_" + String.fromCharCode(A)] = A;
      var x = Object.getOwnPropertyNames(v).map(function(b) {
        return v[b];
      });
      if (x.join("") !== "0123456789")
        return !1;
      var g = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(b) {
        g[b] = b;
      }), Object.keys(Object.assign({}, g)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = d() ? Object.assign : function(p, v) {
    for (var A, x = u(p), g, b = 1; b < arguments.length; b++) {
      A = Object(arguments[b]);
      for (var y in A)
        s.call(A, y) && (x[y] = A[y]);
      if (a) {
        g = a(A);
        for (var f = 0; f < g.length; f++)
          c.call(A, g[f]) && (x[g[f]] = A[g[f]]);
      }
    }
    return x;
  }, objectAssign;
}
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_production_min;
function requireReact_production_min() {
  if (hasRequiredReact_production_min) return react_production_min;
  hasRequiredReact_production_min = 1;
  var a = requireObjectAssign(), s = typeof Symbol == "function" && Symbol.for, c = s ? Symbol.for("react.element") : 60103, u = s ? Symbol.for("react.portal") : 60106, d = s ? Symbol.for("react.fragment") : 60107, p = s ? Symbol.for("react.strict_mode") : 60108, v = s ? Symbol.for("react.profiler") : 60114, A = s ? Symbol.for("react.provider") : 60109, x = s ? Symbol.for("react.context") : 60110, g = s ? Symbol.for("react.forward_ref") : 60112, b = s ? Symbol.for("react.suspense") : 60113, y = s ? Symbol.for("react.memo") : 60115, f = s ? Symbol.for("react.lazy") : 60116, m = typeof Symbol == "function" && Symbol.iterator;
  function C(q) {
    for (var Y = "https://reactjs.org/docs/error-decoder.html?invariant=" + q, ee = 1; ee < arguments.length; ee++) Y += "&args[]=" + encodeURIComponent(arguments[ee]);
    return "Minified React error #" + q + "; visit " + Y + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var w = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, S = {};
  function $(q, Y, ee) {
    this.props = q, this.context = Y, this.refs = S, this.updater = ee || w;
  }
  $.prototype.isReactComponent = {}, $.prototype.setState = function(q, Y) {
    if (typeof q != "object" && typeof q != "function" && q != null) throw Error(C(85));
    this.updater.enqueueSetState(this, q, Y, "setState");
  }, $.prototype.forceUpdate = function(q) {
    this.updater.enqueueForceUpdate(this, q, "forceUpdate");
  };
  function T() {
  }
  T.prototype = $.prototype;
  function I(q, Y, ee) {
    this.props = q, this.context = Y, this.refs = S, this.updater = ee || w;
  }
  var _ = I.prototype = new T();
  _.constructor = I, a(_, $.prototype), _.isPureReactComponent = !0;
  var E = { current: null }, R = Object.prototype.hasOwnProperty, O = { key: !0, ref: !0, __self: !0, __source: !0 };
  function L(q, Y, ee) {
    var Q, J = {}, te = null, ae = null;
    if (Y != null) for (Q in Y.ref !== void 0 && (ae = Y.ref), Y.key !== void 0 && (te = "" + Y.key), Y) R.call(Y, Q) && !O.hasOwnProperty(Q) && (J[Q] = Y[Q]);
    var se = arguments.length - 2;
    if (se === 1) J.children = ee;
    else if (1 < se) {
      for (var ie = Array(se), fe = 0; fe < se; fe++) ie[fe] = arguments[fe + 2];
      J.children = ie;
    }
    if (q && q.defaultProps) for (Q in se = q.defaultProps, se) J[Q] === void 0 && (J[Q] = se[Q]);
    return { $$typeof: c, type: q, key: te, ref: ae, props: J, _owner: E.current };
  }
  function B(q, Y) {
    return { $$typeof: c, type: q.type, key: Y, ref: q.ref, props: q.props, _owner: q._owner };
  }
  function F(q) {
    return typeof q == "object" && q !== null && q.$$typeof === c;
  }
  function M(q) {
    var Y = { "=": "=0", ":": "=2" };
    return "$" + ("" + q).replace(/[=:]/g, function(ee) {
      return Y[ee];
    });
  }
  var W = /\/+/g, j = [];
  function G(q, Y, ee, Q) {
    if (j.length) {
      var J = j.pop();
      return J.result = q, J.keyPrefix = Y, J.func = ee, J.context = Q, J.count = 0, J;
    }
    return { result: q, keyPrefix: Y, func: ee, context: Q, count: 0 };
  }
  function U(q) {
    q.result = null, q.keyPrefix = null, q.func = null, q.context = null, q.count = 0, 10 > j.length && j.push(q);
  }
  function k(q, Y, ee, Q) {
    var J = typeof q;
    (J === "undefined" || J === "boolean") && (q = null);
    var te = !1;
    if (q === null) te = !0;
    else switch (J) {
      case "string":
      case "number":
        te = !0;
        break;
      case "object":
        switch (q.$$typeof) {
          case c:
          case u:
            te = !0;
        }
    }
    if (te) return ee(Q, q, Y === "" ? "." + P(q, 0) : Y), 1;
    if (te = 0, Y = Y === "" ? "." : Y + ":", Array.isArray(q)) for (var ae = 0; ae < q.length; ae++) {
      J = q[ae];
      var se = Y + P(J, ae);
      te += k(J, se, ee, Q);
    }
    else if (q === null || typeof q != "object" ? se = null : (se = m && q[m] || q["@@iterator"], se = typeof se == "function" ? se : null), typeof se == "function") for (q = se.call(q), ae = 0; !(J = q.next()).done; ) J = J.value, se = Y + P(J, ae++), te += k(J, se, ee, Q);
    else if (J === "object") throw ee = "" + q, Error(C(31, ee === "[object Object]" ? "object with keys {" + Object.keys(q).join(", ") + "}" : ee, ""));
    return te;
  }
  function N(q, Y, ee) {
    return q == null ? 0 : k(q, "", Y, ee);
  }
  function P(q, Y) {
    return typeof q == "object" && q !== null && q.key != null ? M(q.key) : Y.toString(36);
  }
  function D(q, Y) {
    q.func.call(q.context, Y, q.count++);
  }
  function H(q, Y, ee) {
    var Q = q.result, J = q.keyPrefix;
    q = q.func.call(q.context, Y, q.count++), Array.isArray(q) ? V(q, Q, ee, function(te) {
      return te;
    }) : q != null && (F(q) && (q = B(q, J + (!q.key || Y && Y.key === q.key ? "" : ("" + q.key).replace(W, "$&/") + "/") + ee)), Q.push(q));
  }
  function V(q, Y, ee, Q, J) {
    var te = "";
    ee != null && (te = ("" + ee).replace(W, "$&/") + "/"), Y = G(Y, te, Q, J), N(q, H, Y), U(Y);
  }
  var Z = { current: null };
  function ne() {
    var q = Z.current;
    if (q === null) throw Error(C(321));
    return q;
  }
  var K = { ReactCurrentDispatcher: Z, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: E, IsSomeRendererActing: { current: !1 }, assign: a };
  return react_production_min.Children = { map: function(q, Y, ee) {
    if (q == null) return q;
    var Q = [];
    return V(q, Q, null, Y, ee), Q;
  }, forEach: function(q, Y, ee) {
    if (q == null) return q;
    Y = G(null, null, Y, ee), N(q, D, Y), U(Y);
  }, count: function(q) {
    return N(q, function() {
      return null;
    }, null);
  }, toArray: function(q) {
    var Y = [];
    return V(q, Y, null, function(ee) {
      return ee;
    }), Y;
  }, only: function(q) {
    if (!F(q)) throw Error(C(143));
    return q;
  } }, react_production_min.Component = $, react_production_min.Fragment = d, react_production_min.Profiler = v, react_production_min.PureComponent = I, react_production_min.StrictMode = p, react_production_min.Suspense = b, react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = K, react_production_min.cloneElement = function(q, Y, ee) {
    if (q == null) throw Error(C(267, q));
    var Q = a({}, q.props), J = q.key, te = q.ref, ae = q._owner;
    if (Y != null) {
      if (Y.ref !== void 0 && (te = Y.ref, ae = E.current), Y.key !== void 0 && (J = "" + Y.key), q.type && q.type.defaultProps) var se = q.type.defaultProps;
      for (ie in Y) R.call(Y, ie) && !O.hasOwnProperty(ie) && (Q[ie] = Y[ie] === void 0 && se !== void 0 ? se[ie] : Y[ie]);
    }
    var ie = arguments.length - 2;
    if (ie === 1) Q.children = ee;
    else if (1 < ie) {
      se = Array(ie);
      for (var fe = 0; fe < ie; fe++) se[fe] = arguments[fe + 2];
      Q.children = se;
    }
    return {
      $$typeof: c,
      type: q.type,
      key: J,
      ref: te,
      props: Q,
      _owner: ae
    };
  }, react_production_min.createContext = function(q, Y) {
    return Y === void 0 && (Y = null), q = { $$typeof: x, _calculateChangedBits: Y, _currentValue: q, _currentValue2: q, _threadCount: 0, Provider: null, Consumer: null }, q.Provider = { $$typeof: A, _context: q }, q.Consumer = q;
  }, react_production_min.createElement = L, react_production_min.createFactory = function(q) {
    var Y = L.bind(null, q);
    return Y.type = q, Y;
  }, react_production_min.createRef = function() {
    return { current: null };
  }, react_production_min.forwardRef = function(q) {
    return { $$typeof: g, render: q };
  }, react_production_min.isValidElement = F, react_production_min.lazy = function(q) {
    return { $$typeof: f, _ctor: q, _status: -1, _result: null };
  }, react_production_min.memo = function(q, Y) {
    return { $$typeof: y, type: q, compare: Y === void 0 ? null : Y };
  }, react_production_min.useCallback = function(q, Y) {
    return ne().useCallback(q, Y);
  }, react_production_min.useContext = function(q, Y) {
    return ne().useContext(q, Y);
  }, react_production_min.useDebugValue = function() {
  }, react_production_min.useEffect = function(q, Y) {
    return ne().useEffect(q, Y);
  }, react_production_min.useImperativeHandle = function(q, Y, ee) {
    return ne().useImperativeHandle(q, Y, ee);
  }, react_production_min.useLayoutEffect = function(q, Y) {
    return ne().useLayoutEffect(q, Y);
  }, react_production_min.useMemo = function(q, Y) {
    return ne().useMemo(q, Y);
  }, react_production_min.useReducer = function(q, Y, ee) {
    return ne().useReducer(q, Y, ee);
  }, react_production_min.useRef = function(q) {
    return ne().useRef(q);
  }, react_production_min.useState = function(q) {
    return ne().useState(q);
  }, react_production_min.version = "16.14.0", react_production_min;
}
var hasRequiredReact;
function requireReact() {
  return hasRequiredReact || (hasRequiredReact = 1, react.exports = requireReact_production_min()), react.exports;
}
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var a = requireReact(), s = 60103;
  if (reactJsxRuntime_production_min.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var c = Symbol.for;
    s = c("react.element"), reactJsxRuntime_production_min.Fragment = c("react.fragment");
  }
  var u = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, d = Object.prototype.hasOwnProperty, p = { key: !0, ref: !0, __self: !0, __source: !0 };
  function v(A, x, g) {
    var b, y = {}, f = null, m = null;
    g !== void 0 && (f = "" + g), x.key !== void 0 && (f = "" + x.key), x.ref !== void 0 && (m = x.ref);
    for (b in x) d.call(x, b) && !p.hasOwnProperty(b) && (y[b] = x[b]);
    if (A && A.defaultProps) for (b in x = A.defaultProps, x) y[b] === void 0 && (y[b] = x[b]);
    return { $$typeof: s, type: A, key: f, ref: m, props: y, _owner: u.current };
  }
  return reactJsxRuntime_production_min.jsx = v, reactJsxRuntime_production_min.jsxs = v, reactJsxRuntime_production_min;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, jsxRuntime.exports = requireReactJsxRuntime_production_min()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime(), reactDom = { exports: {} }, reactDom_production_min = {}, scheduler = { exports: {} }, scheduler_production_min = {};
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_production_min;
function requireScheduler_production_min() {
  return hasRequiredScheduler_production_min || (hasRequiredScheduler_production_min = 1, function(a) {
    var s, c, u, d, p;
    if (typeof window > "u" || typeof MessageChannel != "function") {
      var v = null, A = null, x = function() {
        if (v !== null) try {
          var K = a.unstable_now();
          v(!0, K), v = null;
        } catch (q) {
          throw setTimeout(x, 0), q;
        }
      }, g = Date.now();
      a.unstable_now = function() {
        return Date.now() - g;
      }, s = function(K) {
        v !== null ? setTimeout(s, 0, K) : (v = K, setTimeout(x, 0));
      }, c = function(K, q) {
        A = setTimeout(K, q);
      }, u = function() {
        clearTimeout(A);
      }, d = function() {
        return !1;
      }, p = a.unstable_forceFrameRate = function() {
      };
    } else {
      var b = window.performance, y = window.Date, f = window.setTimeout, m = window.clearTimeout;
      if (typeof console < "u") {
        var C = window.cancelAnimationFrame;
        typeof window.requestAnimationFrame != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), typeof C != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
      }
      if (typeof b == "object" && typeof b.now == "function") a.unstable_now = function() {
        return b.now();
      };
      else {
        var w = y.now();
        a.unstable_now = function() {
          return y.now() - w;
        };
      }
      var S = !1, $ = null, T = -1, I = 5, _ = 0;
      d = function() {
        return a.unstable_now() >= _;
      }, p = function() {
      }, a.unstable_forceFrameRate = function(K) {
        0 > K || 125 < K ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : I = 0 < K ? Math.floor(1e3 / K) : 5;
      };
      var E = new MessageChannel(), R = E.port2;
      E.port1.onmessage = function() {
        if ($ !== null) {
          var K = a.unstable_now();
          _ = K + I;
          try {
            $(!0, K) ? R.postMessage(null) : (S = !1, $ = null);
          } catch (q) {
            throw R.postMessage(null), q;
          }
        } else S = !1;
      }, s = function(K) {
        $ = K, S || (S = !0, R.postMessage(null));
      }, c = function(K, q) {
        T = f(function() {
          K(a.unstable_now());
        }, q);
      }, u = function() {
        m(T), T = -1;
      };
    }
    function O(K, q) {
      var Y = K.length;
      K.push(q);
      e: for (; ; ) {
        var ee = Y - 1 >>> 1, Q = K[ee];
        if (Q !== void 0 && 0 < F(Q, q)) K[ee] = q, K[Y] = Q, Y = ee;
        else break e;
      }
    }
    function L(K) {
      return K = K[0], K === void 0 ? null : K;
    }
    function B(K) {
      var q = K[0];
      if (q !== void 0) {
        var Y = K.pop();
        if (Y !== q) {
          K[0] = Y;
          e: for (var ee = 0, Q = K.length; ee < Q; ) {
            var J = 2 * (ee + 1) - 1, te = K[J], ae = J + 1, se = K[ae];
            if (te !== void 0 && 0 > F(te, Y)) se !== void 0 && 0 > F(se, te) ? (K[ee] = se, K[ae] = Y, ee = ae) : (K[ee] = te, K[J] = Y, ee = J);
            else if (se !== void 0 && 0 > F(se, Y)) K[ee] = se, K[ae] = Y, ee = ae;
            else break e;
          }
        }
        return q;
      }
      return null;
    }
    function F(K, q) {
      var Y = K.sortIndex - q.sortIndex;
      return Y !== 0 ? Y : K.id - q.id;
    }
    var M = [], W = [], j = 1, G = null, U = 3, k = !1, N = !1, P = !1;
    function D(K) {
      for (var q = L(W); q !== null; ) {
        if (q.callback === null) B(W);
        else if (q.startTime <= K) B(W), q.sortIndex = q.expirationTime, O(M, q);
        else break;
        q = L(W);
      }
    }
    function H(K) {
      if (P = !1, D(K), !N) if (L(M) !== null) N = !0, s(V);
      else {
        var q = L(W);
        q !== null && c(H, q.startTime - K);
      }
    }
    function V(K, q) {
      N = !1, P && (P = !1, u()), k = !0;
      var Y = U;
      try {
        for (D(q), G = L(M); G !== null && (!(G.expirationTime > q) || K && !d()); ) {
          var ee = G.callback;
          if (ee !== null) {
            G.callback = null, U = G.priorityLevel;
            var Q = ee(G.expirationTime <= q);
            q = a.unstable_now(), typeof Q == "function" ? G.callback = Q : G === L(M) && B(M), D(q);
          } else B(M);
          G = L(M);
        }
        if (G !== null) var J = !0;
        else {
          var te = L(W);
          te !== null && c(H, te.startTime - q), J = !1;
        }
        return J;
      } finally {
        G = null, U = Y, k = !1;
      }
    }
    function Z(K) {
      switch (K) {
        case 1:
          return -1;
        case 2:
          return 250;
        case 5:
          return 1073741823;
        case 4:
          return 1e4;
        default:
          return 5e3;
      }
    }
    var ne = p;
    a.unstable_IdlePriority = 5, a.unstable_ImmediatePriority = 1, a.unstable_LowPriority = 4, a.unstable_NormalPriority = 3, a.unstable_Profiling = null, a.unstable_UserBlockingPriority = 2, a.unstable_cancelCallback = function(K) {
      K.callback = null;
    }, a.unstable_continueExecution = function() {
      N || k || (N = !0, s(V));
    }, a.unstable_getCurrentPriorityLevel = function() {
      return U;
    }, a.unstable_getFirstCallbackNode = function() {
      return L(M);
    }, a.unstable_next = function(K) {
      switch (U) {
        case 1:
        case 2:
        case 3:
          var q = 3;
          break;
        default:
          q = U;
      }
      var Y = U;
      U = q;
      try {
        return K();
      } finally {
        U = Y;
      }
    }, a.unstable_pauseExecution = function() {
    }, a.unstable_requestPaint = ne, a.unstable_runWithPriority = function(K, q) {
      switch (K) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          K = 3;
      }
      var Y = U;
      U = K;
      try {
        return q();
      } finally {
        U = Y;
      }
    }, a.unstable_scheduleCallback = function(K, q, Y) {
      var ee = a.unstable_now();
      if (typeof Y == "object" && Y !== null) {
        var Q = Y.delay;
        Q = typeof Q == "number" && 0 < Q ? ee + Q : ee, Y = typeof Y.timeout == "number" ? Y.timeout : Z(K);
      } else Y = Z(K), Q = ee;
      return Y = Q + Y, K = { id: j++, callback: q, priorityLevel: K, startTime: Q, expirationTime: Y, sortIndex: -1 }, Q > ee ? (K.sortIndex = Q, O(W, K), L(M) === null && K === L(W) && (P ? u() : P = !0, c(H, Q - ee))) : (K.sortIndex = Y, O(M, K), N || k || (N = !0, s(V))), K;
    }, a.unstable_shouldYield = function() {
      var K = a.unstable_now();
      D(K);
      var q = L(M);
      return q !== G && G !== null && q !== null && q.callback !== null && q.startTime <= K && q.expirationTime < G.expirationTime || d();
    }, a.unstable_wrapCallback = function(K) {
      var q = U;
      return function() {
        var Y = U;
        U = q;
        try {
          return K.apply(this, arguments);
        } finally {
          U = Y;
        }
      };
    };
  }(scheduler_production_min)), scheduler_production_min;
}
var hasRequiredScheduler;
function requireScheduler() {
  return hasRequiredScheduler || (hasRequiredScheduler = 1, scheduler.exports = requireScheduler_production_min()), scheduler.exports;
}
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDom_production_min;
function requireReactDom_production_min() {
  if (hasRequiredReactDom_production_min) return reactDom_production_min;
  hasRequiredReactDom_production_min = 1;
  var a = requireReact(), s = requireObjectAssign(), c = requireScheduler();
  function u(z) {
    for (var re = "https://reactjs.org/docs/error-decoder.html?invariant=" + z, de = 1; de < arguments.length; de++) re += "&args[]=" + encodeURIComponent(arguments[de]);
    return "Minified React error #" + z + "; visit " + re + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  if (!a) throw Error(u(227));
  function d(z, re, de, Se, Pe, He, ze, Ze, wt) {
    var St = Array.prototype.slice.call(arguments, 3);
    try {
      re.apply(de, St);
    } catch (tr) {
      this.onError(tr);
    }
  }
  var p = !1, v = null, A = !1, x = null, g = { onError: function(z) {
    p = !0, v = z;
  } };
  function b(z, re, de, Se, Pe, He, ze, Ze, wt) {
    p = !1, v = null, d.apply(g, arguments);
  }
  function y(z, re, de, Se, Pe, He, ze, Ze, wt) {
    if (b.apply(this, arguments), p) {
      if (p) {
        var St = v;
        p = !1, v = null;
      } else throw Error(u(198));
      A || (A = !0, x = St);
    }
  }
  var f = null, m = null, C = null;
  function w(z, re, de) {
    var Se = z.type || "unknown-event";
    z.currentTarget = C(de), y(Se, re, void 0, z), z.currentTarget = null;
  }
  var S = null, $ = {};
  function T() {
    if (S) for (var z in $) {
      var re = $[z], de = S.indexOf(z);
      if (!(-1 < de)) throw Error(u(96, z));
      if (!_[de]) {
        if (!re.extractEvents) throw Error(u(97, z));
        _[de] = re, de = re.eventTypes;
        for (var Se in de) {
          var Pe = void 0, He = de[Se], ze = re, Ze = Se;
          if (E.hasOwnProperty(Ze)) throw Error(u(99, Ze));
          E[Ze] = He;
          var wt = He.phasedRegistrationNames;
          if (wt) {
            for (Pe in wt) wt.hasOwnProperty(Pe) && I(wt[Pe], ze, Ze);
            Pe = !0;
          } else He.registrationName ? (I(He.registrationName, ze, Ze), Pe = !0) : Pe = !1;
          if (!Pe) throw Error(u(98, Se, z));
        }
      }
    }
  }
  function I(z, re, de) {
    if (R[z]) throw Error(u(100, z));
    R[z] = re, O[z] = re.eventTypes[de].dependencies;
  }
  var _ = [], E = {}, R = {}, O = {};
  function L(z) {
    var re = !1, de;
    for (de in z) if (z.hasOwnProperty(de)) {
      var Se = z[de];
      if (!$.hasOwnProperty(de) || $[de] !== Se) {
        if ($[de]) throw Error(u(102, de));
        $[de] = Se, re = !0;
      }
    }
    re && T();
  }
  var B = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), F = null, M = null, W = null;
  function j(z) {
    if (z = m(z)) {
      if (typeof F != "function") throw Error(u(280));
      var re = z.stateNode;
      re && (re = f(re), F(z.stateNode, z.type, re));
    }
  }
  function G(z) {
    M ? W ? W.push(z) : W = [z] : M = z;
  }
  function U() {
    if (M) {
      var z = M, re = W;
      if (W = M = null, j(z), re) for (z = 0; z < re.length; z++) j(re[z]);
    }
  }
  function k(z, re) {
    return z(re);
  }
  function N(z, re, de, Se, Pe) {
    return z(re, de, Se, Pe);
  }
  function P() {
  }
  var D = k, H = !1, V = !1;
  function Z() {
    (M !== null || W !== null) && (P(), U());
  }
  function ne(z, re, de) {
    if (V) return z(re, de);
    V = !0;
    try {
      return D(z, re, de);
    } finally {
      V = !1, Z();
    }
  }
  var K = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, q = Object.prototype.hasOwnProperty, Y = {}, ee = {};
  function Q(z) {
    return q.call(ee, z) ? !0 : q.call(Y, z) ? !1 : K.test(z) ? ee[z] = !0 : (Y[z] = !0, !1);
  }
  function J(z, re, de, Se) {
    if (de !== null && de.type === 0) return !1;
    switch (typeof re) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return Se ? !1 : de !== null ? !de.acceptsBooleans : (z = z.toLowerCase().slice(0, 5), z !== "data-" && z !== "aria-");
      default:
        return !1;
    }
  }
  function te(z, re, de, Se) {
    if (re === null || typeof re > "u" || J(z, re, de, Se)) return !0;
    if (Se) return !1;
    if (de !== null) switch (de.type) {
      case 3:
        return !re;
      case 4:
        return re === !1;
      case 5:
        return isNaN(re);
      case 6:
        return isNaN(re) || 1 > re;
    }
    return !1;
  }
  function ae(z, re, de, Se, Pe, He) {
    this.acceptsBooleans = re === 2 || re === 3 || re === 4, this.attributeName = Se, this.attributeNamespace = Pe, this.mustUseProperty = de, this.propertyName = z, this.type = re, this.sanitizeURL = He;
  }
  var se = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(z) {
    se[z] = new ae(z, 0, !1, z, null, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(z) {
    var re = z[0];
    se[re] = new ae(re, 1, !1, z[1], null, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(z) {
    se[z] = new ae(z, 2, !1, z.toLowerCase(), null, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(z) {
    se[z] = new ae(z, 2, !1, z, null, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(z) {
    se[z] = new ae(z, 3, !1, z.toLowerCase(), null, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(z) {
    se[z] = new ae(z, 3, !0, z, null, !1);
  }), ["capture", "download"].forEach(function(z) {
    se[z] = new ae(z, 4, !1, z, null, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(z) {
    se[z] = new ae(z, 6, !1, z, null, !1);
  }), ["rowSpan", "start"].forEach(function(z) {
    se[z] = new ae(z, 5, !1, z.toLowerCase(), null, !1);
  });
  var ie = /[\-:]([a-z])/g;
  function fe(z) {
    return z[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(z) {
    var re = z.replace(
      ie,
      fe
    );
    se[re] = new ae(re, 1, !1, z, null, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(z) {
    var re = z.replace(ie, fe);
    se[re] = new ae(re, 1, !1, z, "http://www.w3.org/1999/xlink", !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(z) {
    var re = z.replace(ie, fe);
    se[re] = new ae(re, 1, !1, z, "http://www.w3.org/XML/1998/namespace", !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(z) {
    se[z] = new ae(z, 1, !1, z.toLowerCase(), null, !1);
  }), se.xlinkHref = new ae("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function(z) {
    se[z] = new ae(z, 1, !1, z.toLowerCase(), null, !0);
  });
  var ge = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  ge.hasOwnProperty("ReactCurrentDispatcher") || (ge.ReactCurrentDispatcher = { current: null }), ge.hasOwnProperty("ReactCurrentBatchConfig") || (ge.ReactCurrentBatchConfig = { suspense: null });
  function me(z, re, de, Se) {
    var Pe = se.hasOwnProperty(re) ? se[re] : null, He = Pe !== null ? Pe.type === 0 : Se ? !1 : !(!(2 < re.length) || re[0] !== "o" && re[0] !== "O" || re[1] !== "n" && re[1] !== "N");
    He || (te(re, de, Pe, Se) && (de = null), Se || Pe === null ? Q(re) && (de === null ? z.removeAttribute(re) : z.setAttribute(re, "" + de)) : Pe.mustUseProperty ? z[Pe.propertyName] = de === null ? Pe.type === 3 ? !1 : "" : de : (re = Pe.attributeName, Se = Pe.attributeNamespace, de === null ? z.removeAttribute(re) : (Pe = Pe.type, de = Pe === 3 || Pe === 4 && de === !0 ? "" : "" + de, Se ? z.setAttributeNS(Se, re, de) : z.setAttribute(re, de))));
  }
  var pe = /^(.*)[\\\/]/, be = typeof Symbol == "function" && Symbol.for, le = be ? Symbol.for("react.element") : 60103, ve = be ? Symbol.for("react.portal") : 60106, he = be ? Symbol.for("react.fragment") : 60107, ye = be ? Symbol.for("react.strict_mode") : 60108, Ce = be ? Symbol.for("react.profiler") : 60114, xe = be ? Symbol.for("react.provider") : 60109, we = be ? Symbol.for("react.context") : 60110, $e = be ? Symbol.for("react.concurrent_mode") : 60111, Ae = be ? Symbol.for("react.forward_ref") : 60112, ue = be ? Symbol.for("react.suspense") : 60113, ce = be ? Symbol.for("react.suspense_list") : 60120, Ee = be ? Symbol.for("react.memo") : 60115, _e = be ? Symbol.for("react.lazy") : 60116, Te = be ? Symbol.for("react.block") : 60121, ke = typeof Symbol == "function" && Symbol.iterator;
  function Re(z) {
    return z === null || typeof z != "object" ? null : (z = ke && z[ke] || z["@@iterator"], typeof z == "function" ? z : null);
  }
  function Be(z) {
    if (z._status === -1) {
      z._status = 0;
      var re = z._ctor;
      re = re(), z._result = re, re.then(function(de) {
        z._status === 0 && (de = de.default, z._status = 1, z._result = de);
      }, function(de) {
        z._status === 0 && (z._status = 2, z._result = de);
      });
    }
  }
  function Oe(z) {
    if (z == null) return null;
    if (typeof z == "function") return z.displayName || z.name || null;
    if (typeof z == "string") return z;
    switch (z) {
      case he:
        return "Fragment";
      case ve:
        return "Portal";
      case Ce:
        return "Profiler";
      case ye:
        return "StrictMode";
      case ue:
        return "Suspense";
      case ce:
        return "SuspenseList";
    }
    if (typeof z == "object") switch (z.$$typeof) {
      case we:
        return "Context.Consumer";
      case xe:
        return "Context.Provider";
      case Ae:
        var re = z.render;
        return re = re.displayName || re.name || "", z.displayName || (re !== "" ? "ForwardRef(" + re + ")" : "ForwardRef");
      case Ee:
        return Oe(z.type);
      case Te:
        return Oe(z.render);
      case _e:
        if (z = z._status === 1 ? z._result : null) return Oe(z);
    }
    return null;
  }
  function Me(z) {
    var re = "";
    do {
      e: switch (z.tag) {
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 9:
          var de = "";
          break e;
        default:
          var Se = z._debugOwner, Pe = z._debugSource, He = Oe(z.type);
          de = null, Se && (de = Oe(Se.type)), Se = He, He = "", Pe ? He = " (at " + Pe.fileName.replace(pe, "") + ":" + Pe.lineNumber + ")" : de && (He = " (created by " + de + ")"), de = `
    in ` + (Se || "Unknown") + He;
      }
      re += de, z = z.return;
    } while (z);
    return re;
  }
  function Fe(z) {
    switch (typeof z) {
      case "boolean":
      case "number":
      case "object":
      case "string":
      case "undefined":
        return z;
      default:
        return "";
    }
  }
  function Ue(z) {
    var re = z.type;
    return (z = z.nodeName) && z.toLowerCase() === "input" && (re === "checkbox" || re === "radio");
  }
  function je(z) {
    var re = Ue(z) ? "checked" : "value", de = Object.getOwnPropertyDescriptor(z.constructor.prototype, re), Se = "" + z[re];
    if (!z.hasOwnProperty(re) && typeof de < "u" && typeof de.get == "function" && typeof de.set == "function") {
      var Pe = de.get, He = de.set;
      return Object.defineProperty(z, re, { configurable: !0, get: function() {
        return Pe.call(this);
      }, set: function(ze) {
        Se = "" + ze, He.call(this, ze);
      } }), Object.defineProperty(z, re, { enumerable: de.enumerable }), { getValue: function() {
        return Se;
      }, setValue: function(ze) {
        Se = "" + ze;
      }, stopTracking: function() {
        z._valueTracker = null, delete z[re];
      } };
    }
  }
  function Le(z) {
    z._valueTracker || (z._valueTracker = je(z));
  }
  function De(z) {
    if (!z) return !1;
    var re = z._valueTracker;
    if (!re) return !0;
    var de = re.getValue(), Se = "";
    return z && (Se = Ue(z) ? z.checked ? "true" : "false" : z.value), z = Se, z !== de ? (re.setValue(z), !0) : !1;
  }
  function Ne(z, re) {
    var de = re.checked;
    return s({}, re, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: de ?? z._wrapperState.initialChecked });
  }
  function Ge(z, re) {
    var de = re.defaultValue == null ? "" : re.defaultValue, Se = re.checked != null ? re.checked : re.defaultChecked;
    de = Fe(re.value != null ? re.value : de), z._wrapperState = { initialChecked: Se, initialValue: de, controlled: re.type === "checkbox" || re.type === "radio" ? re.checked != null : re.value != null };
  }
  function Xe(z, re) {
    re = re.checked, re != null && me(z, "checked", re, !1);
  }
  function nt(z, re) {
    Xe(z, re);
    var de = Fe(re.value), Se = re.type;
    if (de != null) Se === "number" ? (de === 0 && z.value === "" || z.value != de) && (z.value = "" + de) : z.value !== "" + de && (z.value = "" + de);
    else if (Se === "submit" || Se === "reset") {
      z.removeAttribute("value");
      return;
    }
    re.hasOwnProperty("value") ? it(z, re.type, de) : re.hasOwnProperty("defaultValue") && it(z, re.type, Fe(re.defaultValue)), re.checked == null && re.defaultChecked != null && (z.defaultChecked = !!re.defaultChecked);
  }
  function ct(z, re, de) {
    if (re.hasOwnProperty("value") || re.hasOwnProperty("defaultValue")) {
      var Se = re.type;
      if (!(Se !== "submit" && Se !== "reset" || re.value !== void 0 && re.value !== null)) return;
      re = "" + z._wrapperState.initialValue, de || re === z.value || (z.value = re), z.defaultValue = re;
    }
    de = z.name, de !== "" && (z.name = ""), z.defaultChecked = !!z._wrapperState.initialChecked, de !== "" && (z.name = de);
  }
  function it(z, re, de) {
    (re !== "number" || z.ownerDocument.activeElement !== z) && (de == null ? z.defaultValue = "" + z._wrapperState.initialValue : z.defaultValue !== "" + de && (z.defaultValue = "" + de));
  }
  function We(z) {
    var re = "";
    return a.Children.forEach(z, function(de) {
      de != null && (re += de);
    }), re;
  }
  function Ve(z, re) {
    return z = s({ children: void 0 }, re), (re = We(re.children)) && (z.children = re), z;
  }
  function ut(z, re, de, Se) {
    if (z = z.options, re) {
      re = {};
      for (var Pe = 0; Pe < de.length; Pe++) re["$" + de[Pe]] = !0;
      for (de = 0; de < z.length; de++) Pe = re.hasOwnProperty("$" + z[de].value), z[de].selected !== Pe && (z[de].selected = Pe), Pe && Se && (z[de].defaultSelected = !0);
    } else {
      for (de = "" + Fe(de), re = null, Pe = 0; Pe < z.length; Pe++) {
        if (z[Pe].value === de) {
          z[Pe].selected = !0, Se && (z[Pe].defaultSelected = !0);
          return;
        }
        re !== null || z[Pe].disabled || (re = z[Pe]);
      }
      re !== null && (re.selected = !0);
    }
  }
  function at(z, re) {
    if (re.dangerouslySetInnerHTML != null) throw Error(u(91));
    return s({}, re, { value: void 0, defaultValue: void 0, children: "" + z._wrapperState.initialValue });
  }
  function Qe(z, re) {
    var de = re.value;
    if (de == null) {
      if (de = re.children, re = re.defaultValue, de != null) {
        if (re != null) throw Error(u(92));
        if (Array.isArray(de)) {
          if (!(1 >= de.length)) throw Error(u(93));
          de = de[0];
        }
        re = de;
      }
      re == null && (re = ""), de = re;
    }
    z._wrapperState = { initialValue: Fe(de) };
  }
  function st(z, re) {
    var de = Fe(re.value), Se = Fe(re.defaultValue);
    de != null && (de = "" + de, de !== z.value && (z.value = de), re.defaultValue == null && z.defaultValue !== de && (z.defaultValue = de)), Se != null && (z.defaultValue = "" + Se);
  }
  function ft(z) {
    var re = z.textContent;
    re === z._wrapperState.initialValue && re !== "" && re !== null && (z.value = re);
  }
  var vt = { html: "http://www.w3.org/1999/xhtml", svg: "http://www.w3.org/2000/svg" };
  function Pt(z) {
    switch (z) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function dt(z, re) {
    return z == null || z === "http://www.w3.org/1999/xhtml" ? Pt(re) : z === "http://www.w3.org/2000/svg" && re === "foreignObject" ? "http://www.w3.org/1999/xhtml" : z;
  }
  var mt, pt = function(z) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(re, de, Se, Pe) {
      MSApp.execUnsafeLocalFunction(function() {
        return z(re, de, Se, Pe);
      });
    } : z;
  }(function(z, re) {
    if (z.namespaceURI !== vt.svg || "innerHTML" in z) z.innerHTML = re;
    else {
      for (mt = mt || document.createElement("div"), mt.innerHTML = "<svg>" + re.valueOf().toString() + "</svg>", re = mt.firstChild; z.firstChild; ) z.removeChild(z.firstChild);
      for (; re.firstChild; ) z.appendChild(re.firstChild);
    }
  });
  function Et(z, re) {
    if (re) {
      var de = z.firstChild;
      if (de && de === z.lastChild && de.nodeType === 3) {
        de.nodeValue = re;
        return;
      }
    }
    z.textContent = re;
  }
  function Mt(z, re) {
    var de = {};
    return de[z.toLowerCase()] = re.toLowerCase(), de["Webkit" + z] = "webkit" + re, de["Moz" + z] = "moz" + re, de;
  }
  var Nt = { animationend: Mt("Animation", "AnimationEnd"), animationiteration: Mt("Animation", "AnimationIteration"), animationstart: Mt("Animation", "AnimationStart"), transitionend: Mt("Transition", "TransitionEnd") }, _t = {}, Ot = {};
  B && (Ot = document.createElement("div").style, "AnimationEvent" in window || (delete Nt.animationend.animation, delete Nt.animationiteration.animation, delete Nt.animationstart.animation), "TransitionEvent" in window || delete Nt.transitionend.transition);
  function rt(z) {
    if (_t[z]) return _t[z];
    if (!Nt[z]) return z;
    var re = Nt[z], de;
    for (de in re) if (re.hasOwnProperty(de) && de in Ot) return _t[z] = re[de];
    return z;
  }
  var et = rt("animationend"), Ye = rt("animationiteration"), tt = rt("animationstart"), Ke = rt("transitionend"), qe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), ot = new (typeof WeakMap == "function" ? WeakMap : Map)();
  function Je(z) {
    var re = ot.get(z);
    return re === void 0 && (re = /* @__PURE__ */ new Map(), ot.set(z, re)), re;
  }
  function Ct(z) {
    var re = z, de = z;
    if (z.alternate) for (; re.return; ) re = re.return;
    else {
      z = re;
      do
        re = z, (re.effectTag & 1026) !== 0 && (de = re.return), z = re.return;
      while (z);
    }
    return re.tag === 3 ? de : null;
  }
  function Tt(z) {
    if (z.tag === 13) {
      var re = z.memoizedState;
      if (re === null && (z = z.alternate, z !== null && (re = z.memoizedState)), re !== null) return re.dehydrated;
    }
    return null;
  }
  function yt(z) {
    if (Ct(z) !== z) throw Error(u(188));
  }
  function bt(z) {
    var re = z.alternate;
    if (!re) {
      if (re = Ct(z), re === null) throw Error(u(188));
      return re !== z ? null : z;
    }
    for (var de = z, Se = re; ; ) {
      var Pe = de.return;
      if (Pe === null) break;
      var He = Pe.alternate;
      if (He === null) {
        if (Se = Pe.return, Se !== null) {
          de = Se;
          continue;
        }
        break;
      }
      if (Pe.child === He.child) {
        for (He = Pe.child; He; ) {
          if (He === de) return yt(Pe), z;
          if (He === Se) return yt(Pe), re;
          He = He.sibling;
        }
        throw Error(u(188));
      }
      if (de.return !== Se.return) de = Pe, Se = He;
      else {
        for (var ze = !1, Ze = Pe.child; Ze; ) {
          if (Ze === de) {
            ze = !0, de = Pe, Se = He;
            break;
          }
          if (Ze === Se) {
            ze = !0, Se = Pe, de = He;
            break;
          }
          Ze = Ze.sibling;
        }
        if (!ze) {
          for (Ze = He.child; Ze; ) {
            if (Ze === de) {
              ze = !0, de = He, Se = Pe;
              break;
            }
            if (Ze === Se) {
              ze = !0, Se = He, de = Pe;
              break;
            }
            Ze = Ze.sibling;
          }
          if (!ze) throw Error(u(189));
        }
      }
      if (de.alternate !== Se) throw Error(u(190));
    }
    if (de.tag !== 3) throw Error(u(188));
    return de.stateNode.current === de ? z : re;
  }
  function It(z) {
    if (z = bt(z), !z) return null;
    for (var re = z; ; ) {
      if (re.tag === 5 || re.tag === 6) return re;
      if (re.child) re.child.return = re, re = re.child;
      else {
        if (re === z) break;
        for (; !re.sibling; ) {
          if (!re.return || re.return === z) return null;
          re = re.return;
        }
        re.sibling.return = re.return, re = re.sibling;
      }
    }
    return null;
  }
  function kt(z, re) {
    if (re == null) throw Error(u(30));
    return z == null ? re : Array.isArray(z) ? Array.isArray(re) ? (z.push.apply(z, re), z) : (z.push(re), z) : Array.isArray(re) ? [z].concat(re) : [z, re];
  }
  function $t(z, re, de) {
    Array.isArray(z) ? z.forEach(re, de) : z && re.call(de, z);
  }
  var Lt = null;
  function Ft(z) {
    if (z) {
      var re = z._dispatchListeners, de = z._dispatchInstances;
      if (Array.isArray(re)) for (var Se = 0; Se < re.length && !z.isPropagationStopped(); Se++) w(z, re[Se], de[Se]);
      else re && w(z, re, de);
      z._dispatchListeners = null, z._dispatchInstances = null, z.isPersistent() || z.constructor.release(z);
    }
  }
  function Vt(z) {
    if (z !== null && (Lt = kt(Lt, z)), z = Lt, Lt = null, z) {
      if ($t(z, Ft), Lt) throw Error(u(95));
      if (A) throw z = x, A = !1, x = null, z;
    }
  }
  function rr(z) {
    return z = z.target || z.srcElement || window, z.correspondingUseElement && (z = z.correspondingUseElement), z.nodeType === 3 ? z.parentNode : z;
  }
  function br(z) {
    if (!B) return !1;
    z = "on" + z;
    var re = z in document;
    return re || (re = document.createElement("div"), re.setAttribute(z, "return;"), re = typeof re[z] == "function"), re;
  }
  var Gt = [];
  function qt(z) {
    z.topLevelType = null, z.nativeEvent = null, z.targetInst = null, z.ancestors.length = 0, 10 > Gt.length && Gt.push(z);
  }
  function Jt(z, re, de, Se) {
    if (Gt.length) {
      var Pe = Gt.pop();
      return Pe.topLevelType = z, Pe.eventSystemFlags = Se, Pe.nativeEvent = re, Pe.targetInst = de, Pe;
    }
    return { topLevelType: z, eventSystemFlags: Se, nativeEvent: re, targetInst: de, ancestors: [] };
  }
  function jt(z) {
    var re = z.targetInst, de = re;
    do {
      if (!de) {
        z.ancestors.push(de);
        break;
      }
      var Se = de;
      if (Se.tag === 3) Se = Se.stateNode.containerInfo;
      else {
        for (; Se.return; ) Se = Se.return;
        Se = Se.tag !== 3 ? null : Se.stateNode.containerInfo;
      }
      if (!Se) break;
      re = de.tag, re !== 5 && re !== 6 || z.ancestors.push(de), de = Sa(Se);
    } while (de);
    for (de = 0; de < z.ancestors.length; de++) {
      re = z.ancestors[de];
      var Pe = rr(z.nativeEvent);
      Se = z.topLevelType;
      var He = z.nativeEvent, ze = z.eventSystemFlags;
      de === 0 && (ze |= 64);
      for (var Ze = null, wt = 0; wt < _.length; wt++) {
        var St = _[wt];
        St && (St = St.extractEvents(Se, re, He, Pe, ze)) && (Ze = kt(Ze, St));
      }
      Vt(Ze);
    }
  }
  function Ht(z, re, de) {
    if (!de.has(z)) {
      switch (z) {
        case "scroll":
          er(re, "scroll", !0);
          break;
        case "focus":
        case "blur":
          er(re, "focus", !0), er(re, "blur", !0), de.set("blur", null), de.set("focus", null);
          break;
        case "cancel":
        case "close":
          br(z) && er(re, z, !0);
          break;
        case "invalid":
        case "submit":
        case "reset":
          break;
        default:
          qe.indexOf(z) === -1 && Ut(z, re);
      }
      de.set(z, null);
    }
  }
  var ur, Qt, Yt, dr = !1, Ar = [], wr = null, Ir = null, _r = null, kr = /* @__PURE__ */ new Map(), zt = /* @__PURE__ */ new Map(), Dt = [], nr = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), gr = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
  function lr(z, re) {
    var de = Je(re);
    nr.forEach(function(Se) {
      Ht(Se, re, de);
    }), gr.forEach(function(Se) {
      Ht(Se, re, de);
    });
  }
  function Nr(z, re, de, Se, Pe) {
    return { blockedOn: z, topLevelType: re, eventSystemFlags: de | 32, nativeEvent: Pe, container: Se };
  }
  function Wr(z, re) {
    switch (z) {
      case "focus":
      case "blur":
        wr = null;
        break;
      case "dragenter":
      case "dragleave":
        Ir = null;
        break;
      case "mouseover":
      case "mouseout":
        _r = null;
        break;
      case "pointerover":
      case "pointerout":
        kr.delete(re.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        zt.delete(re.pointerId);
    }
  }
  function Fr(z, re, de, Se, Pe, He) {
    return z === null || z.nativeEvent !== He ? (z = Nr(re, de, Se, Pe, He), re !== null && (re = $a(re), re !== null && Qt(re)), z) : (z.eventSystemFlags |= Se, z);
  }
  function Qr(z, re, de, Se, Pe) {
    switch (re) {
      case "focus":
        return wr = Fr(wr, z, re, de, Se, Pe), !0;
      case "dragenter":
        return Ir = Fr(Ir, z, re, de, Se, Pe), !0;
      case "mouseover":
        return _r = Fr(_r, z, re, de, Se, Pe), !0;
      case "pointerover":
        var He = Pe.pointerId;
        return kr.set(He, Fr(kr.get(He) || null, z, re, de, Se, Pe)), !0;
      case "gotpointercapture":
        return He = Pe.pointerId, zt.set(He, Fr(zt.get(He) || null, z, re, de, Se, Pe)), !0;
    }
    return !1;
  }
  function an(z) {
    var re = Sa(z.target);
    if (re !== null) {
      var de = Ct(re);
      if (de !== null) {
        if (re = de.tag, re === 13) {
          if (re = Tt(de), re !== null) {
            z.blockedOn = re, c.unstable_runWithPriority(z.priority, function() {
              Yt(de);
            });
            return;
          }
        } else if (re === 3 && de.stateNode.hydrate) {
          z.blockedOn = de.tag === 3 ? de.stateNode.containerInfo : null;
          return;
        }
      }
    }
    z.blockedOn = null;
  }
  function cn(z) {
    if (z.blockedOn !== null) return !1;
    var re = Sr(z.topLevelType, z.eventSystemFlags, z.container, z.nativeEvent);
    if (re !== null) {
      var de = $a(re);
      return de !== null && Qt(de), z.blockedOn = re, !1;
    }
    return !0;
  }
  function yn(z, re, de) {
    cn(z) && de.delete(re);
  }
  function _n() {
    for (dr = !1; 0 < Ar.length; ) {
      var z = Ar[0];
      if (z.blockedOn !== null) {
        z = $a(z.blockedOn), z !== null && ur(z);
        break;
      }
      var re = Sr(z.topLevelType, z.eventSystemFlags, z.container, z.nativeEvent);
      re !== null ? z.blockedOn = re : Ar.shift();
    }
    wr !== null && cn(wr) && (wr = null), Ir !== null && cn(Ir) && (Ir = null), _r !== null && cn(_r) && (_r = null), kr.forEach(yn), zt.forEach(yn);
  }
  function Xt(z, re) {
    z.blockedOn === re && (z.blockedOn = null, dr || (dr = !0, c.unstable_scheduleCallback(c.unstable_NormalPriority, _n)));
  }
  function sr(z) {
    function re(Pe) {
      return Xt(Pe, z);
    }
    if (0 < Ar.length) {
      Xt(Ar[0], z);
      for (var de = 1; de < Ar.length; de++) {
        var Se = Ar[de];
        Se.blockedOn === z && (Se.blockedOn = null);
      }
    }
    for (wr !== null && Xt(wr, z), Ir !== null && Xt(Ir, z), _r !== null && Xt(_r, z), kr.forEach(re), zt.forEach(re), de = 0; de < Dt.length; de++) Se = Dt[de], Se.blockedOn === z && (Se.blockedOn = null);
    for (; 0 < Dt.length && (de = Dt[0], de.blockedOn === null); ) an(de), de.blockedOn === null && Dt.shift();
  }
  var Tr = {}, Lr = /* @__PURE__ */ new Map(), Rr = /* @__PURE__ */ new Map(), ht = [
    "abort",
    "abort",
    et,
    "animationEnd",
    Ye,
    "animationIteration",
    tt,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Ke,
    "transitionEnd",
    "waiting",
    "waiting"
  ];
  function oe(z, re) {
    for (var de = 0; de < z.length; de += 2) {
      var Se = z[de], Pe = z[de + 1], He = "on" + (Pe[0].toUpperCase() + Pe.slice(1));
      He = { phasedRegistrationNames: { bubbled: He, captured: He + "Capture" }, dependencies: [Se], eventPriority: re }, Rr.set(Se, re), Lr.set(Se, He), Tr[Pe] = He;
    }
  }
  oe("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), oe("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), oe(ht, 2);
  for (var Ie = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), lt = 0; lt < Ie.length; lt++) Rr.set(Ie[lt], 0);
  var At = c.unstable_UserBlockingPriority, Bt = c.unstable_runWithPriority, Kt = !0;
  function Ut(z, re) {
    er(re, z, !1);
  }
  function er(z, re, de) {
    var Se = Rr.get(re);
    switch (Se === void 0 ? 2 : Se) {
      case 0:
        Se = cr.bind(null, re, 1, z);
        break;
      case 1:
        Se = xr.bind(null, re, 1, z);
        break;
      default:
        Se = Pr.bind(null, re, 1, z);
    }
    de ? z.addEventListener(re, Se, !0) : z.addEventListener(re, Se, !1);
  }
  function cr(z, re, de, Se) {
    H || P();
    var Pe = Pr, He = H;
    H = !0;
    try {
      N(Pe, z, re, de, Se);
    } finally {
      (H = He) || Z();
    }
  }
  function xr(z, re, de, Se) {
    Bt(At, Pr.bind(null, z, re, de, Se));
  }
  function Pr(z, re, de, Se) {
    if (Kt) if (0 < Ar.length && -1 < nr.indexOf(z)) z = Nr(null, z, re, de, Se), Ar.push(z);
    else {
      var Pe = Sr(z, re, de, Se);
      if (Pe === null) Wr(z, Se);
      else if (-1 < nr.indexOf(z)) z = Nr(Pe, z, re, de, Se), Ar.push(z);
      else if (!Qr(Pe, z, re, de, Se)) {
        Wr(z, Se), z = Jt(z, Se, null, re);
        try {
          ne(jt, z);
        } finally {
          qt(z);
        }
      }
    }
  }
  function Sr(z, re, de, Se) {
    if (de = rr(Se), de = Sa(de), de !== null) {
      var Pe = Ct(de);
      if (Pe === null) de = null;
      else {
        var He = Pe.tag;
        if (He === 13) {
          if (de = Tt(Pe), de !== null) return de;
          de = null;
        } else if (He === 3) {
          if (Pe.stateNode.hydrate) return Pe.tag === 3 ? Pe.stateNode.containerInfo : null;
          de = null;
        } else Pe !== de && (de = null);
      }
    }
    z = Jt(z, Se, de, re);
    try {
      ne(jt, z);
    } finally {
      qt(z);
    }
    return null;
  }
  var Or = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Dr = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Or).forEach(function(z) {
    Dr.forEach(function(re) {
      re = re + z.charAt(0).toUpperCase() + z.substring(1), Or[re] = Or[z];
    });
  });
  function pr(z, re, de) {
    return re == null || typeof re == "boolean" || re === "" ? "" : de || typeof re != "number" || re === 0 || Or.hasOwnProperty(z) && Or[z] ? ("" + re).trim() : re + "px";
  }
  function Hr(z, re) {
    z = z.style;
    for (var de in re) if (re.hasOwnProperty(de)) {
      var Se = de.indexOf("--") === 0, Pe = pr(de, re[de], Se);
      de === "float" && (de = "cssFloat"), Se ? z.setProperty(de, Pe) : z[de] = Pe;
    }
  }
  var fr = s({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function yr(z, re) {
    if (re) {
      if (fr[z] && (re.children != null || re.dangerouslySetInnerHTML != null)) throw Error(u(137, z, ""));
      if (re.dangerouslySetInnerHTML != null) {
        if (re.children != null) throw Error(u(60));
        if (!(typeof re.dangerouslySetInnerHTML == "object" && "__html" in re.dangerouslySetInnerHTML)) throw Error(u(61));
      }
      if (re.style != null && typeof re.style != "object") throw Error(u(62, ""));
    }
  }
  function qr(z, re) {
    if (z.indexOf("-") === -1) return typeof re.is == "string";
    switch (z) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var mr = vt.html;
  function Kr(z, re) {
    z = z.nodeType === 9 || z.nodeType === 11 ? z : z.ownerDocument;
    var de = Je(z);
    re = O[re];
    for (var Se = 0; Se < re.length; Se++) Ht(re[Se], z, de);
  }
  function nn() {
  }
  function Vr(z) {
    if (z = z || (typeof document < "u" ? document : void 0), typeof z > "u") return null;
    try {
      return z.activeElement || z.body;
    } catch {
      return z.body;
    }
  }
  function Dn(z) {
    for (; z && z.firstChild; ) z = z.firstChild;
    return z;
  }
  function Tn(z, re) {
    var de = Dn(z);
    z = 0;
    for (var Se; de; ) {
      if (de.nodeType === 3) {
        if (Se = z + de.textContent.length, z <= re && Se >= re) return { node: de, offset: re - z };
        z = Se;
      }
      e: {
        for (; de; ) {
          if (de.nextSibling) {
            de = de.nextSibling;
            break e;
          }
          de = de.parentNode;
        }
        de = void 0;
      }
      de = Dn(de);
    }
  }
  function Qa(z, re) {
    return z && re ? z === re ? !0 : z && z.nodeType === 3 ? !1 : re && re.nodeType === 3 ? Qa(z, re.parentNode) : "contains" in z ? z.contains(re) : z.compareDocumentPosition ? !!(z.compareDocumentPosition(re) & 16) : !1 : !1;
  }
  function Kn() {
    for (var z = window, re = Vr(); re instanceof z.HTMLIFrameElement; ) {
      try {
        var de = typeof re.contentWindow.location.href == "string";
      } catch {
        de = !1;
      }
      if (de) z = re.contentWindow;
      else break;
      re = Vr(z.document);
    }
    return re;
  }
  function Ni(z) {
    var re = z && z.nodeName && z.nodeName.toLowerCase();
    return re && (re === "input" && (z.type === "text" || z.type === "search" || z.type === "tel" || z.type === "url" || z.type === "password") || re === "textarea" || z.contentEditable === "true");
  }
  var Xo = "$", Zo = "/$", ji = "$?", Hi = "$!", Ui = null, zi = null;
  function Jo(z, re) {
    switch (z) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!re.autoFocus;
    }
    return !1;
  }
  function Wi(z, re) {
    return z === "textarea" || z === "option" || z === "noscript" || typeof re.children == "string" || typeof re.children == "number" || typeof re.dangerouslySetInnerHTML == "object" && re.dangerouslySetInnerHTML !== null && re.dangerouslySetInnerHTML.__html != null;
  }
  var Vi = typeof setTimeout == "function" ? setTimeout : void 0, Vl = typeof clearTimeout == "function" ? clearTimeout : void 0;
  function da(z) {
    for (; z != null; z = z.nextSibling) {
      var re = z.nodeType;
      if (re === 1 || re === 3) break;
    }
    return z;
  }
  function ts(z) {
    z = z.previousSibling;
    for (var re = 0; z; ) {
      if (z.nodeType === 8) {
        var de = z.data;
        if (de === Xo || de === Hi || de === ji) {
          if (re === 0) return z;
          re--;
        } else de === Zo && re++;
      }
      z = z.previousSibling;
    }
    return null;
  }
  var Gi = Math.random().toString(36).slice(2), Fn = "__reactInternalInstance$" + Gi, Ya = "__reactEventHandlers$" + Gi, wa = "__reactContainere$" + Gi;
  function Sa(z) {
    var re = z[Fn];
    if (re) return re;
    for (var de = z.parentNode; de; ) {
      if (re = de[wa] || de[Fn]) {
        if (de = re.alternate, re.child !== null || de !== null && de.child !== null) for (z = ts(z); z !== null; ) {
          if (de = z[Fn]) return de;
          z = ts(z);
        }
        return re;
      }
      z = de, de = z.parentNode;
    }
    return null;
  }
  function $a(z) {
    return z = z[Fn] || z[wa], !z || z.tag !== 5 && z.tag !== 6 && z.tag !== 13 && z.tag !== 3 ? null : z;
  }
  function Xn(z) {
    if (z.tag === 5 || z.tag === 6) return z.stateNode;
    throw Error(u(33));
  }
  function Qi(z) {
    return z[Ya] || null;
  }
  function Rn(z) {
    do
      z = z.return;
    while (z && z.tag !== 5);
    return z || null;
  }
  function rs(z, re) {
    var de = z.stateNode;
    if (!de) return null;
    var Se = f(de);
    if (!Se) return null;
    de = Se[re];
    e: switch (re) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (Se = !Se.disabled) || (z = z.type, Se = !(z === "button" || z === "input" || z === "select" || z === "textarea")), z = !Se;
        break e;
      default:
        z = !1;
    }
    if (z) return null;
    if (de && typeof de != "function") throw Error(u(
      231,
      re,
      typeof de
    ));
    return de;
  }
  function ns(z, re, de) {
    (re = rs(z, de.dispatchConfig.phasedRegistrationNames[re])) && (de._dispatchListeners = kt(de._dispatchListeners, re), de._dispatchInstances = kt(de._dispatchInstances, z));
  }
  function Gl(z) {
    if (z && z.dispatchConfig.phasedRegistrationNames) {
      for (var re = z._targetInst, de = []; re; ) de.push(re), re = Rn(re);
      for (re = de.length; 0 < re--; ) ns(de[re], "captured", z);
      for (re = 0; re < de.length; re++) ns(de[re], "bubbled", z);
    }
  }
  function Yi(z, re, de) {
    z && de && de.dispatchConfig.registrationName && (re = rs(z, de.dispatchConfig.registrationName)) && (de._dispatchListeners = kt(de._dispatchListeners, re), de._dispatchInstances = kt(de._dispatchInstances, z));
  }
  function Ql(z) {
    z && z.dispatchConfig.registrationName && Yi(z._targetInst, null, z);
  }
  function fa(z) {
    $t(z, Gl);
  }
  var Ln = null, qi = null, qa = null;
  function as() {
    if (qa) return qa;
    var z, re = qi, de = re.length, Se, Pe = "value" in Ln ? Ln.value : Ln.textContent, He = Pe.length;
    for (z = 0; z < de && re[z] === Pe[z]; z++) ;
    var ze = de - z;
    for (Se = 1; Se <= ze && re[de - Se] === Pe[He - Se]; Se++) ;
    return qa = Pe.slice(z, 1 < Se ? 1 - Se : void 0);
  }
  function Ka() {
    return !0;
  }
  function Xa() {
    return !1;
  }
  function un(z, re, de, Se) {
    this.dispatchConfig = z, this._targetInst = re, this.nativeEvent = de, z = this.constructor.Interface;
    for (var Pe in z) z.hasOwnProperty(Pe) && ((re = z[Pe]) ? this[Pe] = re(de) : Pe === "target" ? this.target = Se : this[Pe] = de[Pe]);
    return this.isDefaultPrevented = (de.defaultPrevented != null ? de.defaultPrevented : de.returnValue === !1) ? Ka : Xa, this.isPropagationStopped = Xa, this;
  }
  s(un.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var z = this.nativeEvent;
    z && (z.preventDefault ? z.preventDefault() : typeof z.returnValue != "unknown" && (z.returnValue = !1), this.isDefaultPrevented = Ka);
  }, stopPropagation: function() {
    var z = this.nativeEvent;
    z && (z.stopPropagation ? z.stopPropagation() : typeof z.cancelBubble != "unknown" && (z.cancelBubble = !0), this.isPropagationStopped = Ka);
  }, persist: function() {
    this.isPersistent = Ka;
  }, isPersistent: Xa, destructor: function() {
    var z = this.constructor.Interface, re;
    for (re in z) this[re] = null;
    this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = Xa, this._dispatchInstances = this._dispatchListeners = null;
  } }), un.Interface = { type: null, target: null, currentTarget: function() {
    return null;
  }, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function(z) {
    return z.timeStamp || Date.now();
  }, defaultPrevented: null, isTrusted: null }, un.extend = function(z) {
    function re() {
    }
    function de() {
      return Se.apply(this, arguments);
    }
    var Se = this;
    re.prototype = Se.prototype;
    var Pe = new re();
    return s(Pe, de.prototype), de.prototype = Pe, de.prototype.constructor = de, de.Interface = s({}, Se.Interface, z), de.extend = Se.extend, is(de), de;
  }, is(un);
  function Yl(z, re, de, Se) {
    if (this.eventPool.length) {
      var Pe = this.eventPool.pop();
      return this.call(Pe, z, re, de, Se), Pe;
    }
    return new this(z, re, de, Se);
  }
  function ql(z) {
    if (!(z instanceof this)) throw Error(u(279));
    z.destructor(), 10 > this.eventPool.length && this.eventPool.push(z);
  }
  function is(z) {
    z.eventPool = [], z.getPooled = Yl, z.release = ql;
  }
  var Kl = un.extend({ data: null }), Xl = un.extend({ data: null }), Zl = [9, 13, 27, 32], Ki = B && "CompositionEvent" in window, Ia = null;
  B && "documentMode" in document && (Ia = document.documentMode);
  var Jl = B && "TextEvent" in window && !Ia, os = B && (!Ki || Ia && 8 < Ia && 11 >= Ia), ss = " ", Pn = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: {
    bubbled: "onCompositionStart",
    captured: "onCompositionStartCapture"
  }, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } }, ls = !1;
  function cs(z, re) {
    switch (z) {
      case "keyup":
        return Zl.indexOf(re.keyCode) !== -1;
      case "keydown":
        return re.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "blur":
        return !0;
      default:
        return !1;
    }
  }
  function us(z) {
    return z = z.detail, typeof z == "object" && "data" in z ? z.data : null;
  }
  var ha = !1;
  function ec(z, re) {
    switch (z) {
      case "compositionend":
        return us(re);
      case "keypress":
        return re.which !== 32 ? null : (ls = !0, ss);
      case "textInput":
        return z = re.data, z === ss && ls ? null : z;
      default:
        return null;
    }
  }
  function tc(z, re) {
    if (ha) return z === "compositionend" || !Ki && cs(z, re) ? (z = as(), qa = qi = Ln = null, ha = !1, z) : null;
    switch (z) {
      case "paste":
        return null;
      case "keypress":
        if (!(re.ctrlKey || re.altKey || re.metaKey) || re.ctrlKey && re.altKey) {
          if (re.char && 1 < re.char.length) return re.char;
          if (re.which) return String.fromCharCode(re.which);
        }
        return null;
      case "compositionend":
        return os && re.locale !== "ko" ? null : re.data;
      default:
        return null;
    }
  }
  var rc = { eventTypes: Pn, extractEvents: function(z, re, de, Se) {
    var Pe;
    if (Ki) e: {
      switch (z) {
        case "compositionstart":
          var He = Pn.compositionStart;
          break e;
        case "compositionend":
          He = Pn.compositionEnd;
          break e;
        case "compositionupdate":
          He = Pn.compositionUpdate;
          break e;
      }
      He = void 0;
    }
    else ha ? cs(z, de) && (He = Pn.compositionEnd) : z === "keydown" && de.keyCode === 229 && (He = Pn.compositionStart);
    return He ? (os && de.locale !== "ko" && (ha || He !== Pn.compositionStart ? He === Pn.compositionEnd && ha && (Pe = as()) : (Ln = Se, qi = "value" in Ln ? Ln.value : Ln.textContent, ha = !0)), He = Kl.getPooled(
      He,
      re,
      de,
      Se
    ), Pe ? He.data = Pe : (Pe = us(de), Pe !== null && (He.data = Pe)), fa(He), Pe = He) : Pe = null, (z = Jl ? ec(z, de) : tc(z, de)) ? (re = Xl.getPooled(Pn.beforeInput, re, de, Se), re.data = z, fa(re)) : re = null, Pe === null ? re : re === null ? Pe : [Pe, re];
  } }, nc = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function ds(z) {
    var re = z && z.nodeName && z.nodeName.toLowerCase();
    return re === "input" ? !!nc[z.type] : re === "textarea";
  }
  var fs = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };
  function hs(z, re, de) {
    return z = un.getPooled(fs.change, z, re, de), z.type = "change", G(de), fa(z), z;
  }
  var _a = null, Ta = null;
  function ac(z) {
    Vt(z);
  }
  function Za(z) {
    var re = Xn(z);
    if (De(re)) return z;
  }
  function ic(z, re) {
    if (z === "change") return re;
  }
  var Xi = !1;
  B && (Xi = br("input") && (!document.documentMode || 9 < document.documentMode));
  function ps() {
    _a && (_a.detachEvent("onpropertychange", gs), Ta = _a = null);
  }
  function gs(z) {
    if (z.propertyName === "value" && Za(Ta)) if (z = hs(Ta, z, rr(z)), H) Vt(z);
    else {
      H = !0;
      try {
        k(ac, z);
      } finally {
        H = !1, Z();
      }
    }
  }
  function oc(z, re, de) {
    z === "focus" ? (ps(), _a = re, Ta = de, _a.attachEvent("onpropertychange", gs)) : z === "blur" && ps();
  }
  function sc(z) {
    if (z === "selectionchange" || z === "keyup" || z === "keydown") return Za(Ta);
  }
  function lc(z, re) {
    if (z === "click") return Za(re);
  }
  function cc(z, re) {
    if (z === "input" || z === "change") return Za(re);
  }
  var uc = { eventTypes: fs, _isInputEventSupported: Xi, extractEvents: function(z, re, de, Se) {
    var Pe = re ? Xn(re) : window, He = Pe.nodeName && Pe.nodeName.toLowerCase();
    if (He === "select" || He === "input" && Pe.type === "file") var ze = ic;
    else if (ds(Pe)) if (Xi) ze = cc;
    else {
      ze = sc;
      var Ze = oc;
    }
    else (He = Pe.nodeName) && He.toLowerCase() === "input" && (Pe.type === "checkbox" || Pe.type === "radio") && (ze = lc);
    if (ze && (ze = ze(z, re))) return hs(ze, de, Se);
    Ze && Ze(z, Pe, re), z === "blur" && (z = Pe._wrapperState) && z.controlled && Pe.type === "number" && it(Pe, "number", Pe.value);
  } }, Ra = un.extend({ view: null, detail: null }), dc = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function fc(z) {
    var re = this.nativeEvent;
    return re.getModifierState ? re.getModifierState(z) : (z = dc[z]) ? !!re[z] : !1;
  }
  function Zi() {
    return fc;
  }
  var ms = 0, As = 0, vs = !1, bs = !1, Pa = Ra.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Zi, button: null, buttons: null, relatedTarget: function(z) {
    return z.relatedTarget || (z.fromElement === z.srcElement ? z.toElement : z.fromElement);
  }, movementX: function(z) {
    if ("movementX" in z) return z.movementX;
    var re = ms;
    return ms = z.screenX, vs ? z.type === "mousemove" ? z.screenX - re : 0 : (vs = !0, 0);
  }, movementY: function(z) {
    if ("movementY" in z) return z.movementY;
    var re = As;
    return As = z.screenY, bs ? z.type === "mousemove" ? z.screenY - re : 0 : (bs = !0, 0);
  } }), xs = Pa.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null }), Ba = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: {
    registrationName: "onPointerLeave",
    dependencies: ["pointerout", "pointerover"]
  } }, hc = { eventTypes: Ba, extractEvents: function(z, re, de, Se, Pe) {
    var He = z === "mouseover" || z === "pointerover", ze = z === "mouseout" || z === "pointerout";
    if (He && (Pe & 32) === 0 && (de.relatedTarget || de.fromElement) || !ze && !He) return null;
    if (He = Se.window === Se ? Se : (He = Se.ownerDocument) ? He.defaultView || He.parentWindow : window, ze) {
      if (ze = re, re = (re = de.relatedTarget || de.toElement) ? Sa(re) : null, re !== null) {
        var Ze = Ct(re);
        (re !== Ze || re.tag !== 5 && re.tag !== 6) && (re = null);
      }
    } else ze = null;
    if (ze === re) return null;
    if (z === "mouseout" || z === "mouseover")
      var wt = Pa, St = Ba.mouseLeave, tr = Ba.mouseEnter, ar = "mouse";
    else (z === "pointerout" || z === "pointerover") && (wt = xs, St = Ba.pointerLeave, tr = Ba.pointerEnter, ar = "pointer");
    if (z = ze == null ? He : Xn(ze), He = re == null ? He : Xn(re), St = wt.getPooled(St, ze, de, Se), St.type = ar + "leave", St.target = z, St.relatedTarget = He, de = wt.getPooled(tr, re, de, Se), de.type = ar + "enter", de.target = He, de.relatedTarget = z, Se = ze, ar = re, Se && ar) e: {
      for (wt = Se, tr = ar, ze = 0, z = wt; z; z = Rn(z)) ze++;
      for (z = 0, re = tr; re; re = Rn(re)) z++;
      for (; 0 < ze - z; ) wt = Rn(wt), ze--;
      for (; 0 < z - ze; ) tr = Rn(tr), z--;
      for (; ze--; ) {
        if (wt === tr || wt === tr.alternate) break e;
        wt = Rn(wt), tr = Rn(tr);
      }
      wt = null;
    }
    else wt = null;
    for (tr = wt, wt = []; Se && Se !== tr && (ze = Se.alternate, !(ze !== null && ze === tr)); )
      wt.push(Se), Se = Rn(Se);
    for (Se = []; ar && ar !== tr && (ze = ar.alternate, !(ze !== null && ze === tr)); )
      Se.push(ar), ar = Rn(ar);
    for (ar = 0; ar < wt.length; ar++) Yi(wt[ar], "bubbled", St);
    for (ar = Se.length; 0 < ar--; ) Yi(Se[ar], "captured", de);
    return (Pe & 64) === 0 ? [St] : [St, de];
  } };
  function pc(z, re) {
    return z === re && (z !== 0 || 1 / z === 1 / re) || z !== z && re !== re;
  }
  var Zn = typeof Object.is == "function" ? Object.is : pc, gc = Object.prototype.hasOwnProperty;
  function Oa(z, re) {
    if (Zn(z, re)) return !0;
    if (typeof z != "object" || z === null || typeof re != "object" || re === null) return !1;
    var de = Object.keys(z), Se = Object.keys(re);
    if (de.length !== Se.length) return !1;
    for (Se = 0; Se < de.length; Se++) if (!gc.call(re, de[Se]) || !Zn(z[de[Se]], re[de[Se]])) return !1;
    return !0;
  }
  var mc = B && "documentMode" in document && 11 >= document.documentMode, ys = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } }, pa = null, Ji = null, Ma = null, eo = !1;
  function Cs(z, re) {
    var de = re.window === re ? re.document : re.nodeType === 9 ? re : re.ownerDocument;
    return eo || pa == null || pa !== Vr(de) ? null : (de = pa, "selectionStart" in de && Ni(de) ? de = { start: de.selectionStart, end: de.selectionEnd } : (de = (de.ownerDocument && de.ownerDocument.defaultView || window).getSelection(), de = { anchorNode: de.anchorNode, anchorOffset: de.anchorOffset, focusNode: de.focusNode, focusOffset: de.focusOffset }), Ma && Oa(Ma, de) ? null : (Ma = de, z = un.getPooled(ys.select, Ji, z, re), z.type = "select", z.target = pa, fa(z), z));
  }
  var Ac = { eventTypes: ys, extractEvents: function(z, re, de, Se, Pe, He) {
    if (Pe = He || (Se.window === Se ? Se.document : Se.nodeType === 9 ? Se : Se.ownerDocument), !(He = !Pe)) {
      e: {
        Pe = Je(Pe), He = O.onSelect;
        for (var ze = 0; ze < He.length; ze++) if (!Pe.has(He[ze])) {
          Pe = !1;
          break e;
        }
        Pe = !0;
      }
      He = !Pe;
    }
    if (He) return null;
    switch (Pe = re ? Xn(re) : window, z) {
      case "focus":
        (ds(Pe) || Pe.contentEditable === "true") && (pa = Pe, Ji = re, Ma = null);
        break;
      case "blur":
        Ma = Ji = pa = null;
        break;
      case "mousedown":
        eo = !0;
        break;
      case "contextmenu":
      case "mouseup":
      case "dragend":
        return eo = !1, Cs(de, Se);
      case "selectionchange":
        if (mc) break;
      case "keydown":
      case "keyup":
        return Cs(de, Se);
    }
    return null;
  } }, vc = un.extend({ animationName: null, elapsedTime: null, pseudoElement: null }), bc = un.extend({ clipboardData: function(z) {
    return "clipboardData" in z ? z.clipboardData : window.clipboardData;
  } }), xc = Ra.extend({ relatedTarget: null });
  function Ja(z) {
    var re = z.keyCode;
    return "charCode" in z ? (z = z.charCode, z === 0 && re === 13 && (z = 13)) : z = re, z === 10 && (z = 13), 32 <= z || z === 13 ? z : 0;
  }
  var yc = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, Cc = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Ec = Ra.extend({ key: function(z) {
    if (z.key) {
      var re = yc[z.key] || z.key;
      if (re !== "Unidentified") return re;
    }
    return z.type === "keypress" ? (z = Ja(z), z === 13 ? "Enter" : String.fromCharCode(z)) : z.type === "keydown" || z.type === "keyup" ? Cc[z.keyCode] || "Unidentified" : "";
  }, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Zi, charCode: function(z) {
    return z.type === "keypress" ? Ja(z) : 0;
  }, keyCode: function(z) {
    return z.type === "keydown" || z.type === "keyup" ? z.keyCode : 0;
  }, which: function(z) {
    return z.type === "keypress" ? Ja(z) : z.type === "keydown" || z.type === "keyup" ? z.keyCode : 0;
  } }), wc = Pa.extend({ dataTransfer: null }), Sc = Ra.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Zi }), $c = un.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }), Ic = Pa.extend({ deltaX: function(z) {
    return "deltaX" in z ? z.deltaX : "wheelDeltaX" in z ? -z.wheelDeltaX : 0;
  }, deltaY: function(z) {
    return "deltaY" in z ? z.deltaY : "wheelDeltaY" in z ? -z.wheelDeltaY : "wheelDelta" in z ? -z.wheelDelta : 0;
  }, deltaZ: null, deltaMode: null }), _c = { eventTypes: Tr, extractEvents: function(z, re, de, Se) {
    var Pe = Lr.get(z);
    if (!Pe) return null;
    switch (z) {
      case "keypress":
        if (Ja(de) === 0) return null;
      case "keydown":
      case "keyup":
        z = Ec;
        break;
      case "blur":
      case "focus":
        z = xc;
        break;
      case "click":
        if (de.button === 2) return null;
      case "auxclick":
      case "dblclick":
      case "mousedown":
      case "mousemove":
      case "mouseup":
      case "mouseout":
      case "mouseover":
      case "contextmenu":
        z = Pa;
        break;
      case "drag":
      case "dragend":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "dragstart":
      case "drop":
        z = wc;
        break;
      case "touchcancel":
      case "touchend":
      case "touchmove":
      case "touchstart":
        z = Sc;
        break;
      case et:
      case Ye:
      case tt:
        z = vc;
        break;
      case Ke:
        z = $c;
        break;
      case "scroll":
        z = Ra;
        break;
      case "wheel":
        z = Ic;
        break;
      case "copy":
      case "cut":
      case "paste":
        z = bc;
        break;
      case "gotpointercapture":
      case "lostpointercapture":
      case "pointercancel":
      case "pointerdown":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "pointerup":
        z = xs;
        break;
      default:
        z = un;
    }
    return re = z.getPooled(Pe, re, de, Se), fa(re), re;
  } };
  if (S) throw Error(u(101));
  S = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), T();
  var Tc = $a;
  f = Qi, m = Tc, C = Xn, L({ SimpleEventPlugin: _c, EnterLeaveEventPlugin: hc, ChangeEventPlugin: uc, SelectEventPlugin: Ac, BeforeInputEventPlugin: rc });
  var to = [], ga = -1;
  function jr(z) {
    0 > ga || (z.current = to[ga], to[ga] = null, ga--);
  }
  function Gr(z, re) {
    ga++, to[ga] = z.current, z.current = re;
  }
  var Nn = {}, en = { current: Nn }, on = { current: !1 }, Jn = Nn;
  function ma(z, re) {
    var de = z.type.contextTypes;
    if (!de) return Nn;
    var Se = z.stateNode;
    if (Se && Se.__reactInternalMemoizedUnmaskedChildContext === re) return Se.__reactInternalMemoizedMaskedChildContext;
    var Pe = {}, He;
    for (He in de) Pe[He] = re[He];
    return Se && (z = z.stateNode, z.__reactInternalMemoizedUnmaskedChildContext = re, z.__reactInternalMemoizedMaskedChildContext = Pe), Pe;
  }
  function sn(z) {
    return z = z.childContextTypes, z != null;
  }
  function ei() {
    jr(on), jr(en);
  }
  function Es(z, re, de) {
    if (en.current !== Nn) throw Error(u(168));
    Gr(en, re), Gr(on, de);
  }
  function ws(z, re, de) {
    var Se = z.stateNode;
    if (z = re.childContextTypes, typeof Se.getChildContext != "function") return de;
    Se = Se.getChildContext();
    for (var Pe in Se) if (!(Pe in z)) throw Error(u(108, Oe(re) || "Unknown", Pe));
    return s({}, de, {}, Se);
  }
  function ti(z) {
    return z = (z = z.stateNode) && z.__reactInternalMemoizedMergedChildContext || Nn, Jn = en.current, Gr(en, z), Gr(on, on.current), !0;
  }
  function Ss(z, re, de) {
    var Se = z.stateNode;
    if (!Se) throw Error(u(169));
    de ? (z = ws(z, re, Jn), Se.__reactInternalMemoizedMergedChildContext = z, jr(on), jr(en), Gr(en, z)) : jr(on), Gr(on, de);
  }
  var Rc = c.unstable_runWithPriority, ro = c.unstable_scheduleCallback, $s = c.unstable_cancelCallback, Is = c.unstable_requestPaint, no = c.unstable_now, Pc = c.unstable_getCurrentPriorityLevel, ri = c.unstable_ImmediatePriority, _s = c.unstable_UserBlockingPriority, Ts = c.unstable_NormalPriority, Rs = c.unstable_LowPriority, Ps = c.unstable_IdlePriority, Bs = {}, Bc = c.unstable_shouldYield, Oc = Is !== void 0 ? Is : function() {
  }, Bn = null, ni = null, ao = !1, Os = no(), gn = 1e4 > Os ? no : function() {
    return no() - Os;
  };
  function ai() {
    switch (Pc()) {
      case ri:
        return 99;
      case _s:
        return 98;
      case Ts:
        return 97;
      case Rs:
        return 96;
      case Ps:
        return 95;
      default:
        throw Error(u(332));
    }
  }
  function Ms(z) {
    switch (z) {
      case 99:
        return ri;
      case 98:
        return _s;
      case 97:
        return Ts;
      case 96:
        return Rs;
      case 95:
        return Ps;
      default:
        throw Error(u(332));
    }
  }
  function jn(z, re) {
    return z = Ms(z), Rc(z, re);
  }
  function ks(z, re, de) {
    return z = Ms(z), ro(z, re, de);
  }
  function Ds(z) {
    return Bn === null ? (Bn = [z], ni = ro(ri, Fs)) : Bn.push(z), Bs;
  }
  function Cn() {
    if (ni !== null) {
      var z = ni;
      ni = null, $s(z);
    }
    Fs();
  }
  function Fs() {
    if (!ao && Bn !== null) {
      ao = !0;
      var z = 0;
      try {
        var re = Bn;
        jn(99, function() {
          for (; z < re.length; z++) {
            var de = re[z];
            do
              de = de(!0);
            while (de !== null);
          }
        }), Bn = null;
      } catch (de) {
        throw Bn !== null && (Bn = Bn.slice(z + 1)), ro(ri, Cn), de;
      } finally {
        ao = !1;
      }
    }
  }
  function ii(z, re, de) {
    return de /= 10, 1073741821 - (((1073741821 - z + re / 10) / de | 0) + 1) * de;
  }
  function bn(z, re) {
    if (z && z.defaultProps) {
      re = s({}, re), z = z.defaultProps;
      for (var de in z) re[de] === void 0 && (re[de] = z[de]);
    }
    return re;
  }
  var oi = { current: null }, si = null, Aa = null, li = null;
  function io() {
    li = Aa = si = null;
  }
  function oo(z) {
    var re = oi.current;
    jr(oi), z.type._context._currentValue = re;
  }
  function Ls(z, re) {
    for (; z !== null; ) {
      var de = z.alternate;
      if (z.childExpirationTime < re) z.childExpirationTime = re, de !== null && de.childExpirationTime < re && (de.childExpirationTime = re);
      else if (de !== null && de.childExpirationTime < re) de.childExpirationTime = re;
      else break;
      z = z.return;
    }
  }
  function va(z, re) {
    si = z, li = Aa = null, z = z.dependencies, z !== null && z.firstContext !== null && (z.expirationTime >= re && (wn = !0), z.firstContext = null);
  }
  function mn(z, re) {
    if (li !== z && re !== !1 && re !== 0)
      if ((typeof re != "number" || re === 1073741823) && (li = z, re = 1073741823), re = { context: z, observedBits: re, next: null }, Aa === null) {
        if (si === null) throw Error(u(308));
        Aa = re, si.dependencies = { expirationTime: 0, firstContext: re, responders: null };
      } else Aa = Aa.next = re;
    return z._currentValue;
  }
  var Hn = !1;
  function so(z) {
    z.updateQueue = { baseState: z.memoizedState, baseQueue: null, shared: { pending: null }, effects: null };
  }
  function lo(z, re) {
    z = z.updateQueue, re.updateQueue === z && (re.updateQueue = { baseState: z.baseState, baseQueue: z.baseQueue, shared: z.shared, effects: z.effects });
  }
  function Un(z, re) {
    return z = { expirationTime: z, suspenseConfig: re, tag: 0, payload: null, callback: null, next: null }, z.next = z;
  }
  function zn(z, re) {
    if (z = z.updateQueue, z !== null) {
      z = z.shared;
      var de = z.pending;
      de === null ? re.next = re : (re.next = de.next, de.next = re), z.pending = re;
    }
  }
  function Ns(z, re) {
    var de = z.alternate;
    de !== null && lo(de, z), z = z.updateQueue, de = z.baseQueue, de === null ? (z.baseQueue = re.next = re, re.next = re) : (re.next = de.next, de.next = re);
  }
  function ka(z, re, de, Se) {
    var Pe = z.updateQueue;
    Hn = !1;
    var He = Pe.baseQueue, ze = Pe.shared.pending;
    if (ze !== null) {
      if (He !== null) {
        var Ze = He.next;
        He.next = ze.next, ze.next = Ze;
      }
      He = ze, Pe.shared.pending = null, Ze = z.alternate, Ze !== null && (Ze = Ze.updateQueue, Ze !== null && (Ze.baseQueue = ze));
    }
    if (He !== null) {
      Ze = He.next;
      var wt = Pe.baseState, St = 0, tr = null, ar = null, $r = null;
      if (Ze !== null) {
        var Mr = Ze;
        do {
          if (ze = Mr.expirationTime, ze < Se) {
            var vn = { expirationTime: Mr.expirationTime, suspenseConfig: Mr.suspenseConfig, tag: Mr.tag, payload: Mr.payload, callback: Mr.callback, next: null };
            $r === null ? (ar = $r = vn, tr = wt) : $r = $r.next = vn, ze > St && (St = ze);
          } else {
            $r !== null && ($r = $r.next = { expirationTime: 1073741823, suspenseConfig: Mr.suspenseConfig, tag: Mr.tag, payload: Mr.payload, callback: Mr.callback, next: null }), kl(ze, Mr.suspenseConfig);
            e: {
              var Jr = z, xt = Mr;
              switch (ze = re, vn = de, xt.tag) {
                case 1:
                  if (Jr = xt.payload, typeof Jr == "function") {
                    wt = Jr.call(vn, wt, ze);
                    break e;
                  }
                  wt = Jr;
                  break e;
                case 3:
                  Jr.effectTag = Jr.effectTag & -4097 | 64;
                case 0:
                  if (Jr = xt.payload, ze = typeof Jr == "function" ? Jr.call(vn, wt, ze) : Jr, ze == null) break e;
                  wt = s({}, wt, ze);
                  break e;
                case 2:
                  Hn = !0;
              }
            }
            Mr.callback !== null && (z.effectTag |= 32, ze = Pe.effects, ze === null ? Pe.effects = [Mr] : ze.push(Mr));
          }
          if (Mr = Mr.next, Mr === null || Mr === Ze) {
            if (ze = Pe.shared.pending, ze === null) break;
            Mr = He.next = ze.next, ze.next = Ze, Pe.baseQueue = He = ze, Pe.shared.pending = null;
          }
        } while (!0);
      }
      $r === null ? tr = wt : $r.next = ar, Pe.baseState = tr, Pe.baseQueue = $r, ki(St), z.expirationTime = St, z.memoizedState = wt;
    }
  }
  function js(z, re, de) {
    if (z = re.effects, re.effects = null, z !== null) for (re = 0; re < z.length; re++) {
      var Se = z[re], Pe = Se.callback;
      if (Pe !== null) {
        if (Se.callback = null, Se = Pe, Pe = de, typeof Se != "function") throw Error(u(191, Se));
        Se.call(Pe);
      }
    }
  }
  var Da = ge.ReactCurrentBatchConfig, Hs = new a.Component().refs;
  function ci(z, re, de, Se) {
    re = z.memoizedState, de = de(Se, re), de = de == null ? re : s({}, re, de), z.memoizedState = de, z.expirationTime === 0 && (z.updateQueue.baseState = de);
  }
  var ui = { isMounted: function(z) {
    return (z = z._reactInternalFiber) ? Ct(z) === z : !1;
  }, enqueueSetState: function(z, re, de) {
    z = z._reactInternalFiber;
    var Se = $n(), Pe = Da.suspense;
    Se = ia(Se, z, Pe), Pe = Un(Se, Pe), Pe.payload = re, de != null && (Pe.callback = de), zn(z, Pe), Qn(z, Se);
  }, enqueueReplaceState: function(z, re, de) {
    z = z._reactInternalFiber;
    var Se = $n(), Pe = Da.suspense;
    Se = ia(Se, z, Pe), Pe = Un(Se, Pe), Pe.tag = 1, Pe.payload = re, de != null && (Pe.callback = de), zn(z, Pe), Qn(z, Se);
  }, enqueueForceUpdate: function(z, re) {
    z = z._reactInternalFiber;
    var de = $n(), Se = Da.suspense;
    de = ia(de, z, Se), Se = Un(de, Se), Se.tag = 2, re != null && (Se.callback = re), zn(z, Se), Qn(z, de);
  } };
  function Us(z, re, de, Se, Pe, He, ze) {
    return z = z.stateNode, typeof z.shouldComponentUpdate == "function" ? z.shouldComponentUpdate(Se, He, ze) : re.prototype && re.prototype.isPureReactComponent ? !Oa(de, Se) || !Oa(Pe, He) : !0;
  }
  function zs(z, re, de) {
    var Se = !1, Pe = Nn, He = re.contextType;
    return typeof He == "object" && He !== null ? He = mn(He) : (Pe = sn(re) ? Jn : en.current, Se = re.contextTypes, He = (Se = Se != null) ? ma(z, Pe) : Nn), re = new re(de, He), z.memoizedState = re.state !== null && re.state !== void 0 ? re.state : null, re.updater = ui, z.stateNode = re, re._reactInternalFiber = z, Se && (z = z.stateNode, z.__reactInternalMemoizedUnmaskedChildContext = Pe, z.__reactInternalMemoizedMaskedChildContext = He), re;
  }
  function Ws(z, re, de, Se) {
    z = re.state, typeof re.componentWillReceiveProps == "function" && re.componentWillReceiveProps(de, Se), typeof re.UNSAFE_componentWillReceiveProps == "function" && re.UNSAFE_componentWillReceiveProps(de, Se), re.state !== z && ui.enqueueReplaceState(re, re.state, null);
  }
  function co(z, re, de, Se) {
    var Pe = z.stateNode;
    Pe.props = de, Pe.state = z.memoizedState, Pe.refs = Hs, so(z);
    var He = re.contextType;
    typeof He == "object" && He !== null ? Pe.context = mn(He) : (He = sn(re) ? Jn : en.current, Pe.context = ma(z, He)), ka(z, de, Pe, Se), Pe.state = z.memoizedState, He = re.getDerivedStateFromProps, typeof He == "function" && (ci(z, re, He, de), Pe.state = z.memoizedState), typeof re.getDerivedStateFromProps == "function" || typeof Pe.getSnapshotBeforeUpdate == "function" || typeof Pe.UNSAFE_componentWillMount != "function" && typeof Pe.componentWillMount != "function" || (re = Pe.state, typeof Pe.componentWillMount == "function" && Pe.componentWillMount(), typeof Pe.UNSAFE_componentWillMount == "function" && Pe.UNSAFE_componentWillMount(), re !== Pe.state && ui.enqueueReplaceState(Pe, Pe.state, null), ka(z, de, Pe, Se), Pe.state = z.memoizedState), typeof Pe.componentDidMount == "function" && (z.effectTag |= 4);
  }
  var di = Array.isArray;
  function Fa(z, re, de) {
    if (z = de.ref, z !== null && typeof z != "function" && typeof z != "object") {
      if (de._owner) {
        if (de = de._owner, de) {
          if (de.tag !== 1) throw Error(u(309));
          var Se = de.stateNode;
        }
        if (!Se) throw Error(u(147, z));
        var Pe = "" + z;
        return re !== null && re.ref !== null && typeof re.ref == "function" && re.ref._stringRef === Pe ? re.ref : (re = function(He) {
          var ze = Se.refs;
          ze === Hs && (ze = Se.refs = {}), He === null ? delete ze[Pe] : ze[Pe] = He;
        }, re._stringRef = Pe, re);
      }
      if (typeof z != "string") throw Error(u(284));
      if (!de._owner) throw Error(u(290, z));
    }
    return z;
  }
  function fi(z, re) {
    if (z.type !== "textarea") throw Error(u(31, Object.prototype.toString.call(re) === "[object Object]" ? "object with keys {" + Object.keys(re).join(", ") + "}" : re, ""));
  }
  function Vs(z) {
    function re(xt, gt) {
      if (z) {
        var Rt = xt.lastEffect;
        Rt !== null ? (Rt.nextEffect = gt, xt.lastEffect = gt) : xt.firstEffect = xt.lastEffect = gt, gt.nextEffect = null, gt.effectTag = 8;
      }
    }
    function de(xt, gt) {
      if (!z) return null;
      for (; gt !== null; ) re(xt, gt), gt = gt.sibling;
      return null;
    }
    function Se(xt, gt) {
      for (xt = /* @__PURE__ */ new Map(); gt !== null; ) gt.key !== null ? xt.set(gt.key, gt) : xt.set(gt.index, gt), gt = gt.sibling;
      return xt;
    }
    function Pe(xt, gt) {
      return xt = ca(xt, gt), xt.index = 0, xt.sibling = null, xt;
    }
    function He(xt, gt, Rt) {
      return xt.index = Rt, z ? (Rt = xt.alternate, Rt !== null ? (Rt = Rt.index, Rt < gt ? (xt.effectTag = 2, gt) : Rt) : (xt.effectTag = 2, gt)) : gt;
    }
    function ze(xt) {
      return z && xt.alternate === null && (xt.effectTag = 2), xt;
    }
    function Ze(xt, gt, Rt, Wt) {
      return gt === null || gt.tag !== 6 ? (gt = Vo(Rt, xt.mode, Wt), gt.return = xt, gt) : (gt = Pe(gt, Rt), gt.return = xt, gt);
    }
    function wt(xt, gt, Rt, Wt) {
      return gt !== null && gt.elementType === Rt.type ? (Wt = Pe(gt, Rt.props), Wt.ref = Fa(xt, gt, Rt), Wt.return = xt, Wt) : (Wt = Di(Rt.type, Rt.key, Rt.props, null, xt.mode, Wt), Wt.ref = Fa(xt, gt, Rt), Wt.return = xt, Wt);
    }
    function St(xt, gt, Rt, Wt) {
      return gt === null || gt.tag !== 4 || gt.stateNode.containerInfo !== Rt.containerInfo || gt.stateNode.implementation !== Rt.implementation ? (gt = Go(Rt, xt.mode, Wt), gt.return = xt, gt) : (gt = Pe(gt, Rt.children || []), gt.return = xt, gt);
    }
    function tr(xt, gt, Rt, Wt, Zt) {
      return gt === null || gt.tag !== 7 ? (gt = Yn(Rt, xt.mode, Wt, Zt), gt.return = xt, gt) : (gt = Pe(gt, Rt), gt.return = xt, gt);
    }
    function ar(xt, gt, Rt) {
      if (typeof gt == "string" || typeof gt == "number") return gt = Vo("" + gt, xt.mode, Rt), gt.return = xt, gt;
      if (typeof gt == "object" && gt !== null) {
        switch (gt.$$typeof) {
          case le:
            return Rt = Di(gt.type, gt.key, gt.props, null, xt.mode, Rt), Rt.ref = Fa(xt, null, gt), Rt.return = xt, Rt;
          case ve:
            return gt = Go(gt, xt.mode, Rt), gt.return = xt, gt;
        }
        if (di(gt) || Re(gt)) return gt = Yn(gt, xt.mode, Rt, null), gt.return = xt, gt;
        fi(xt, gt);
      }
      return null;
    }
    function $r(xt, gt, Rt, Wt) {
      var Zt = gt !== null ? gt.key : null;
      if (typeof Rt == "string" || typeof Rt == "number") return Zt !== null ? null : Ze(xt, gt, "" + Rt, Wt);
      if (typeof Rt == "object" && Rt !== null) {
        switch (Rt.$$typeof) {
          case le:
            return Rt.key === Zt ? Rt.type === he ? tr(xt, gt, Rt.props.children, Wt, Zt) : wt(xt, gt, Rt, Wt) : null;
          case ve:
            return Rt.key === Zt ? St(xt, gt, Rt, Wt) : null;
        }
        if (di(Rt) || Re(Rt)) return Zt !== null ? null : tr(xt, gt, Rt, Wt, null);
        fi(xt, Rt);
      }
      return null;
    }
    function Mr(xt, gt, Rt, Wt, Zt) {
      if (typeof Wt == "string" || typeof Wt == "number") return xt = xt.get(Rt) || null, Ze(gt, xt, "" + Wt, Zt);
      if (typeof Wt == "object" && Wt !== null) {
        switch (Wt.$$typeof) {
          case le:
            return xt = xt.get(Wt.key === null ? Rt : Wt.key) || null, Wt.type === he ? tr(gt, xt, Wt.props.children, Zt, Wt.key) : wt(gt, xt, Wt, Zt);
          case ve:
            return xt = xt.get(Wt.key === null ? Rt : Wt.key) || null, St(gt, xt, Wt, Zt);
        }
        if (di(Wt) || Re(Wt)) return xt = xt.get(Rt) || null, tr(gt, xt, Wt, Zt, null);
        fi(gt, Wt);
      }
      return null;
    }
    function vn(xt, gt, Rt, Wt) {
      for (var Zt = null, ir = null, hr = gt, Br = gt = 0, Ur = null; hr !== null && Br < Rt.length; Br++) {
        hr.index > Br ? (Ur = hr, hr = null) : Ur = hr.sibling;
        var Er = $r(xt, hr, Rt[Br], Wt);
        if (Er === null) {
          hr === null && (hr = Ur);
          break;
        }
        z && hr && Er.alternate === null && re(xt, hr), gt = He(Er, gt, Br), ir === null ? Zt = Er : ir.sibling = Er, ir = Er, hr = Ur;
      }
      if (Br === Rt.length) return de(xt, hr), Zt;
      if (hr === null) {
        for (; Br < Rt.length; Br++) hr = ar(xt, Rt[Br], Wt), hr !== null && (gt = He(hr, gt, Br), ir === null ? Zt = hr : ir.sibling = hr, ir = hr);
        return Zt;
      }
      for (hr = Se(xt, hr); Br < Rt.length; Br++) Ur = Mr(hr, xt, Br, Rt[Br], Wt), Ur !== null && (z && Ur.alternate !== null && hr.delete(Ur.key === null ? Br : Ur.key), gt = He(Ur, gt, Br), ir === null ? Zt = Ur : ir.sibling = Ur, ir = Ur);
      return z && hr.forEach(function(qn) {
        return re(xt, qn);
      }), Zt;
    }
    function Jr(xt, gt, Rt, Wt) {
      var Zt = Re(Rt);
      if (typeof Zt != "function") throw Error(u(150));
      if (Rt = Zt.call(Rt), Rt == null) throw Error(u(151));
      for (var ir = Zt = null, hr = gt, Br = gt = 0, Ur = null, Er = Rt.next(); hr !== null && !Er.done; Br++, Er = Rt.next()) {
        hr.index > Br ? (Ur = hr, hr = null) : Ur = hr.sibling;
        var qn = $r(xt, hr, Er.value, Wt);
        if (qn === null) {
          hr === null && (hr = Ur);
          break;
        }
        z && hr && qn.alternate === null && re(xt, hr), gt = He(qn, gt, Br), ir === null ? Zt = qn : ir.sibling = qn, ir = qn, hr = Ur;
      }
      if (Er.done) return de(xt, hr), Zt;
      if (hr === null) {
        for (; !Er.done; Br++, Er = Rt.next()) Er = ar(xt, Er.value, Wt), Er !== null && (gt = He(Er, gt, Br), ir === null ? Zt = Er : ir.sibling = Er, ir = Er);
        return Zt;
      }
      for (hr = Se(xt, hr); !Er.done; Br++, Er = Rt.next()) Er = Mr(hr, xt, Br, Er.value, Wt), Er !== null && (z && Er.alternate !== null && hr.delete(Er.key === null ? Br : Er.key), gt = He(Er, gt, Br), ir === null ? Zt = Er : ir.sibling = Er, ir = Er);
      return z && hr.forEach(function(su) {
        return re(xt, su);
      }), Zt;
    }
    return function(xt, gt, Rt, Wt) {
      var Zt = typeof Rt == "object" && Rt !== null && Rt.type === he && Rt.key === null;
      Zt && (Rt = Rt.props.children);
      var ir = typeof Rt == "object" && Rt !== null;
      if (ir) switch (Rt.$$typeof) {
        case le:
          e: {
            for (ir = Rt.key, Zt = gt; Zt !== null; ) {
              if (Zt.key === ir) {
                switch (Zt.tag) {
                  case 7:
                    if (Rt.type === he) {
                      de(xt, Zt.sibling), gt = Pe(Zt, Rt.props.children), gt.return = xt, xt = gt;
                      break e;
                    }
                    break;
                  default:
                    if (Zt.elementType === Rt.type) {
                      de(
                        xt,
                        Zt.sibling
                      ), gt = Pe(Zt, Rt.props), gt.ref = Fa(xt, Zt, Rt), gt.return = xt, xt = gt;
                      break e;
                    }
                }
                de(xt, Zt);
                break;
              } else re(xt, Zt);
              Zt = Zt.sibling;
            }
            Rt.type === he ? (gt = Yn(Rt.props.children, xt.mode, Wt, Rt.key), gt.return = xt, xt = gt) : (Wt = Di(Rt.type, Rt.key, Rt.props, null, xt.mode, Wt), Wt.ref = Fa(xt, gt, Rt), Wt.return = xt, xt = Wt);
          }
          return ze(xt);
        case ve:
          e: {
            for (Zt = Rt.key; gt !== null; ) {
              if (gt.key === Zt) if (gt.tag === 4 && gt.stateNode.containerInfo === Rt.containerInfo && gt.stateNode.implementation === Rt.implementation) {
                de(xt, gt.sibling), gt = Pe(gt, Rt.children || []), gt.return = xt, xt = gt;
                break e;
              } else {
                de(xt, gt);
                break;
              }
              else re(xt, gt);
              gt = gt.sibling;
            }
            gt = Go(Rt, xt.mode, Wt), gt.return = xt, xt = gt;
          }
          return ze(xt);
      }
      if (typeof Rt == "string" || typeof Rt == "number") return Rt = "" + Rt, gt !== null && gt.tag === 6 ? (de(xt, gt.sibling), gt = Pe(gt, Rt), gt.return = xt, xt = gt) : (de(xt, gt), gt = Vo(Rt, xt.mode, Wt), gt.return = xt, xt = gt), ze(xt);
      if (di(Rt)) return vn(xt, gt, Rt, Wt);
      if (Re(Rt)) return Jr(xt, gt, Rt, Wt);
      if (ir && fi(xt, Rt), typeof Rt > "u" && !Zt) switch (xt.tag) {
        case 1:
        case 0:
          throw xt = xt.type, Error(u(152, xt.displayName || xt.name || "Component"));
      }
      return de(xt, gt);
    };
  }
  var ba = Vs(!0), uo = Vs(!1), La = {}, En = { current: La }, Na = { current: La }, ja = { current: La };
  function ea(z) {
    if (z === La) throw Error(u(174));
    return z;
  }
  function fo(z, re) {
    switch (Gr(ja, re), Gr(Na, z), Gr(En, La), z = re.nodeType, z) {
      case 9:
      case 11:
        re = (re = re.documentElement) ? re.namespaceURI : dt(null, "");
        break;
      default:
        z = z === 8 ? re.parentNode : re, re = z.namespaceURI || null, z = z.tagName, re = dt(re, z);
    }
    jr(En), Gr(En, re);
  }
  function xa() {
    jr(En), jr(Na), jr(ja);
  }
  function Gs(z) {
    ea(ja.current);
    var re = ea(En.current), de = dt(re, z.type);
    re !== de && (Gr(Na, z), Gr(En, de));
  }
  function ho(z) {
    Na.current === z && (jr(En), jr(Na));
  }
  var zr = { current: 0 };
  function hi(z) {
    for (var re = z; re !== null; ) {
      if (re.tag === 13) {
        var de = re.memoizedState;
        if (de !== null && (de = de.dehydrated, de === null || de.data === ji || de.data === Hi)) return re;
      } else if (re.tag === 19 && re.memoizedProps.revealOrder !== void 0) {
        if ((re.effectTag & 64) !== 0) return re;
      } else if (re.child !== null) {
        re.child.return = re, re = re.child;
        continue;
      }
      if (re === z) break;
      for (; re.sibling === null; ) {
        if (re.return === null || re.return === z) return null;
        re = re.return;
      }
      re.sibling.return = re.return, re = re.sibling;
    }
    return null;
  }
  function po(z, re) {
    return { responder: z, props: re };
  }
  var pi = ge.ReactCurrentDispatcher, An = ge.ReactCurrentBatchConfig, Wn = 0, Yr = null, tn = null, rn = null, gi = !1;
  function dn() {
    throw Error(u(321));
  }
  function go(z, re) {
    if (re === null) return !1;
    for (var de = 0; de < re.length && de < z.length; de++) if (!Zn(z[de], re[de])) return !1;
    return !0;
  }
  function mo(z, re, de, Se, Pe, He) {
    if (Wn = He, Yr = re, re.memoizedState = null, re.updateQueue = null, re.expirationTime = 0, pi.current = z === null || z.memoizedState === null ? Mc : kc, z = de(Se, Pe), re.expirationTime === Wn) {
      He = 0;
      do {
        if (re.expirationTime = 0, !(25 > He)) throw Error(u(301));
        He += 1, rn = tn = null, re.updateQueue = null, pi.current = Dc, z = de(Se, Pe);
      } while (re.expirationTime === Wn);
    }
    if (pi.current = xi, re = tn !== null && tn.next !== null, Wn = 0, rn = tn = Yr = null, gi = !1, re) throw Error(u(300));
    return z;
  }
  function ya() {
    var z = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return rn === null ? Yr.memoizedState = rn = z : rn = rn.next = z, rn;
  }
  function Ca() {
    if (tn === null) {
      var z = Yr.alternate;
      z = z !== null ? z.memoizedState : null;
    } else z = tn.next;
    var re = rn === null ? Yr.memoizedState : rn.next;
    if (re !== null) rn = re, tn = z;
    else {
      if (z === null) throw Error(u(310));
      tn = z, z = { memoizedState: tn.memoizedState, baseState: tn.baseState, baseQueue: tn.baseQueue, queue: tn.queue, next: null }, rn === null ? Yr.memoizedState = rn = z : rn = rn.next = z;
    }
    return rn;
  }
  function ta(z, re) {
    return typeof re == "function" ? re(z) : re;
  }
  function mi(z) {
    var re = Ca(), de = re.queue;
    if (de === null) throw Error(u(311));
    de.lastRenderedReducer = z;
    var Se = tn, Pe = Se.baseQueue, He = de.pending;
    if (He !== null) {
      if (Pe !== null) {
        var ze = Pe.next;
        Pe.next = He.next, He.next = ze;
      }
      Se.baseQueue = Pe = He, de.pending = null;
    }
    if (Pe !== null) {
      Pe = Pe.next, Se = Se.baseState;
      var Ze = ze = He = null, wt = Pe;
      do {
        var St = wt.expirationTime;
        if (St < Wn) {
          var tr = { expirationTime: wt.expirationTime, suspenseConfig: wt.suspenseConfig, action: wt.action, eagerReducer: wt.eagerReducer, eagerState: wt.eagerState, next: null };
          Ze === null ? (ze = Ze = tr, He = Se) : Ze = Ze.next = tr, St > Yr.expirationTime && (Yr.expirationTime = St, ki(St));
        } else Ze !== null && (Ze = Ze.next = { expirationTime: 1073741823, suspenseConfig: wt.suspenseConfig, action: wt.action, eagerReducer: wt.eagerReducer, eagerState: wt.eagerState, next: null }), kl(St, wt.suspenseConfig), Se = wt.eagerReducer === z ? wt.eagerState : z(Se, wt.action);
        wt = wt.next;
      } while (wt !== null && wt !== Pe);
      Ze === null ? He = Se : Ze.next = ze, Zn(Se, re.memoizedState) || (wn = !0), re.memoizedState = Se, re.baseState = He, re.baseQueue = Ze, de.lastRenderedState = Se;
    }
    return [re.memoizedState, de.dispatch];
  }
  function Ai(z) {
    var re = Ca(), de = re.queue;
    if (de === null) throw Error(u(311));
    de.lastRenderedReducer = z;
    var Se = de.dispatch, Pe = de.pending, He = re.memoizedState;
    if (Pe !== null) {
      de.pending = null;
      var ze = Pe = Pe.next;
      do
        He = z(He, ze.action), ze = ze.next;
      while (ze !== Pe);
      Zn(He, re.memoizedState) || (wn = !0), re.memoizedState = He, re.baseQueue === null && (re.baseState = He), de.lastRenderedState = He;
    }
    return [He, Se];
  }
  function Ao(z) {
    var re = ya();
    return typeof z == "function" && (z = z()), re.memoizedState = re.baseState = z, z = re.queue = { pending: null, dispatch: null, lastRenderedReducer: ta, lastRenderedState: z }, z = z.dispatch = el.bind(null, Yr, z), [re.memoizedState, z];
  }
  function vo(z, re, de, Se) {
    return z = { tag: z, create: re, destroy: de, deps: Se, next: null }, re = Yr.updateQueue, re === null ? (re = { lastEffect: null }, Yr.updateQueue = re, re.lastEffect = z.next = z) : (de = re.lastEffect, de === null ? re.lastEffect = z.next = z : (Se = de.next, de.next = z, z.next = Se, re.lastEffect = z)), z;
  }
  function Qs() {
    return Ca().memoizedState;
  }
  function bo(z, re, de, Se) {
    var Pe = ya();
    Yr.effectTag |= z, Pe.memoizedState = vo(1 | re, de, void 0, Se === void 0 ? null : Se);
  }
  function xo(z, re, de, Se) {
    var Pe = Ca();
    Se = Se === void 0 ? null : Se;
    var He = void 0;
    if (tn !== null) {
      var ze = tn.memoizedState;
      if (He = ze.destroy, Se !== null && go(Se, ze.deps)) {
        vo(re, de, He, Se);
        return;
      }
    }
    Yr.effectTag |= z, Pe.memoizedState = vo(1 | re, de, He, Se);
  }
  function Ys(z, re) {
    return bo(516, 4, z, re);
  }
  function vi(z, re) {
    return xo(516, 4, z, re);
  }
  function qs(z, re) {
    return xo(4, 2, z, re);
  }
  function Ks(z, re) {
    if (typeof re == "function") return z = z(), re(z), function() {
      re(null);
    };
    if (re != null) return z = z(), re.current = z, function() {
      re.current = null;
    };
  }
  function Xs(z, re, de) {
    return de = de != null ? de.concat([z]) : null, xo(4, 2, Ks.bind(null, re, z), de);
  }
  function yo() {
  }
  function Zs(z, re) {
    return ya().memoizedState = [z, re === void 0 ? null : re], z;
  }
  function bi(z, re) {
    var de = Ca();
    re = re === void 0 ? null : re;
    var Se = de.memoizedState;
    return Se !== null && re !== null && go(re, Se[1]) ? Se[0] : (de.memoizedState = [z, re], z);
  }
  function Js(z, re) {
    var de = Ca();
    re = re === void 0 ? null : re;
    var Se = de.memoizedState;
    return Se !== null && re !== null && go(re, Se[1]) ? Se[0] : (z = z(), de.memoizedState = [z, re], z);
  }
  function Co(z, re, de) {
    var Se = ai();
    jn(98 > Se ? 98 : Se, function() {
      z(!0);
    }), jn(97 < Se ? 97 : Se, function() {
      var Pe = An.suspense;
      An.suspense = re === void 0 ? null : re;
      try {
        z(!1), de();
      } finally {
        An.suspense = Pe;
      }
    });
  }
  function el(z, re, de) {
    var Se = $n(), Pe = Da.suspense;
    Se = ia(Se, z, Pe), Pe = { expirationTime: Se, suspenseConfig: Pe, action: de, eagerReducer: null, eagerState: null, next: null };
    var He = re.pending;
    if (He === null ? Pe.next = Pe : (Pe.next = He.next, He.next = Pe), re.pending = Pe, He = z.alternate, z === Yr || He !== null && He === Yr) gi = !0, Pe.expirationTime = Wn, Yr.expirationTime = Wn;
    else {
      if (z.expirationTime === 0 && (He === null || He.expirationTime === 0) && (He = re.lastRenderedReducer, He !== null)) try {
        var ze = re.lastRenderedState, Ze = He(ze, de);
        if (Pe.eagerReducer = He, Pe.eagerState = Ze, Zn(Ze, ze)) return;
      } catch {
      } finally {
      }
      Qn(
        z,
        Se
      );
    }
  }
  var xi = { readContext: mn, useCallback: dn, useContext: dn, useEffect: dn, useImperativeHandle: dn, useLayoutEffect: dn, useMemo: dn, useReducer: dn, useRef: dn, useState: dn, useDebugValue: dn, useResponder: dn, useDeferredValue: dn, useTransition: dn }, Mc = { readContext: mn, useCallback: Zs, useContext: mn, useEffect: Ys, useImperativeHandle: function(z, re, de) {
    return de = de != null ? de.concat([z]) : null, bo(4, 2, Ks.bind(null, re, z), de);
  }, useLayoutEffect: function(z, re) {
    return bo(4, 2, z, re);
  }, useMemo: function(z, re) {
    var de = ya();
    return re = re === void 0 ? null : re, z = z(), de.memoizedState = [
      z,
      re
    ], z;
  }, useReducer: function(z, re, de) {
    var Se = ya();
    return re = de !== void 0 ? de(re) : re, Se.memoizedState = Se.baseState = re, z = Se.queue = { pending: null, dispatch: null, lastRenderedReducer: z, lastRenderedState: re }, z = z.dispatch = el.bind(null, Yr, z), [Se.memoizedState, z];
  }, useRef: function(z) {
    var re = ya();
    return z = { current: z }, re.memoizedState = z;
  }, useState: Ao, useDebugValue: yo, useResponder: po, useDeferredValue: function(z, re) {
    var de = Ao(z), Se = de[0], Pe = de[1];
    return Ys(function() {
      var He = An.suspense;
      An.suspense = re === void 0 ? null : re;
      try {
        Pe(z);
      } finally {
        An.suspense = He;
      }
    }, [z, re]), Se;
  }, useTransition: function(z) {
    var re = Ao(!1), de = re[0];
    return re = re[1], [Zs(Co.bind(null, re, z), [re, z]), de];
  } }, kc = { readContext: mn, useCallback: bi, useContext: mn, useEffect: vi, useImperativeHandle: Xs, useLayoutEffect: qs, useMemo: Js, useReducer: mi, useRef: Qs, useState: function() {
    return mi(ta);
  }, useDebugValue: yo, useResponder: po, useDeferredValue: function(z, re) {
    var de = mi(ta), Se = de[0], Pe = de[1];
    return vi(function() {
      var He = An.suspense;
      An.suspense = re === void 0 ? null : re;
      try {
        Pe(z);
      } finally {
        An.suspense = He;
      }
    }, [z, re]), Se;
  }, useTransition: function(z) {
    var re = mi(ta), de = re[0];
    return re = re[1], [bi(Co.bind(null, re, z), [re, z]), de];
  } }, Dc = { readContext: mn, useCallback: bi, useContext: mn, useEffect: vi, useImperativeHandle: Xs, useLayoutEffect: qs, useMemo: Js, useReducer: Ai, useRef: Qs, useState: function() {
    return Ai(ta);
  }, useDebugValue: yo, useResponder: po, useDeferredValue: function(z, re) {
    var de = Ai(ta), Se = de[0], Pe = de[1];
    return vi(function() {
      var He = An.suspense;
      An.suspense = re === void 0 ? null : re;
      try {
        Pe(z);
      } finally {
        An.suspense = He;
      }
    }, [z, re]), Se;
  }, useTransition: function(z) {
    var re = Ai(ta), de = re[0];
    return re = re[1], [bi(Co.bind(
      null,
      re,
      z
    ), [re, z]), de];
  } }, On = null, Vn = null, ra = !1;
  function tl(z, re) {
    var de = In(5, null, null, 0);
    de.elementType = "DELETED", de.type = "DELETED", de.stateNode = re, de.return = z, de.effectTag = 8, z.lastEffect !== null ? (z.lastEffect.nextEffect = de, z.lastEffect = de) : z.firstEffect = z.lastEffect = de;
  }
  function rl(z, re) {
    switch (z.tag) {
      case 5:
        var de = z.type;
        return re = re.nodeType !== 1 || de.toLowerCase() !== re.nodeName.toLowerCase() ? null : re, re !== null ? (z.stateNode = re, !0) : !1;
      case 6:
        return re = z.pendingProps === "" || re.nodeType !== 3 ? null : re, re !== null ? (z.stateNode = re, !0) : !1;
      case 13:
        return !1;
      default:
        return !1;
    }
  }
  function Eo(z) {
    if (ra) {
      var re = Vn;
      if (re) {
        var de = re;
        if (!rl(z, re)) {
          if (re = da(de.nextSibling), !re || !rl(z, re)) {
            z.effectTag = z.effectTag & -1025 | 2, ra = !1, On = z;
            return;
          }
          tl(On, de);
        }
        On = z, Vn = da(re.firstChild);
      } else z.effectTag = z.effectTag & -1025 | 2, ra = !1, On = z;
    }
  }
  function nl(z) {
    for (z = z.return; z !== null && z.tag !== 5 && z.tag !== 3 && z.tag !== 13; ) z = z.return;
    On = z;
  }
  function yi(z) {
    if (z !== On) return !1;
    if (!ra) return nl(z), ra = !0, !1;
    var re = z.type;
    if (z.tag !== 5 || re !== "head" && re !== "body" && !Wi(re, z.memoizedProps)) for (re = Vn; re; ) tl(z, re), re = da(re.nextSibling);
    if (nl(z), z.tag === 13) {
      if (z = z.memoizedState, z = z !== null ? z.dehydrated : null, !z) throw Error(u(317));
      e: {
        for (z = z.nextSibling, re = 0; z; ) {
          if (z.nodeType === 8) {
            var de = z.data;
            if (de === Zo) {
              if (re === 0) {
                Vn = da(z.nextSibling);
                break e;
              }
              re--;
            } else de !== Xo && de !== Hi && de !== ji || re++;
          }
          z = z.nextSibling;
        }
        Vn = null;
      }
    } else Vn = On ? da(z.stateNode.nextSibling) : null;
    return !0;
  }
  function wo() {
    Vn = On = null, ra = !1;
  }
  var Fc = ge.ReactCurrentOwner, wn = !1;
  function fn(z, re, de, Se) {
    re.child = z === null ? uo(re, null, de, Se) : ba(re, z.child, de, Se);
  }
  function al(z, re, de, Se, Pe) {
    de = de.render;
    var He = re.ref;
    return va(re, Pe), Se = mo(z, re, de, Se, He, Pe), z !== null && !wn ? (re.updateQueue = z.updateQueue, re.effectTag &= -517, z.expirationTime <= Pe && (z.expirationTime = 0), Mn(z, re, Pe)) : (re.effectTag |= 1, fn(z, re, Se, Pe), re.child);
  }
  function il(z, re, de, Se, Pe, He) {
    if (z === null) {
      var ze = de.type;
      return typeof ze == "function" && !Wo(ze) && ze.defaultProps === void 0 && de.compare === null && de.defaultProps === void 0 ? (re.tag = 15, re.type = ze, ol(z, re, ze, Se, Pe, He)) : (z = Di(de.type, null, Se, null, re.mode, He), z.ref = re.ref, z.return = re, re.child = z);
    }
    return ze = z.child, Pe < He && (Pe = ze.memoizedProps, de = de.compare, de = de !== null ? de : Oa, de(Pe, Se) && z.ref === re.ref) ? Mn(z, re, He) : (re.effectTag |= 1, z = ca(ze, Se), z.ref = re.ref, z.return = re, re.child = z);
  }
  function ol(z, re, de, Se, Pe, He) {
    return z !== null && Oa(z.memoizedProps, Se) && z.ref === re.ref && (wn = !1, Pe < He) ? (re.expirationTime = z.expirationTime, Mn(z, re, He)) : So(z, re, de, Se, He);
  }
  function sl(z, re) {
    var de = re.ref;
    (z === null && de !== null || z !== null && z.ref !== de) && (re.effectTag |= 128);
  }
  function So(z, re, de, Se, Pe) {
    var He = sn(de) ? Jn : en.current;
    return He = ma(re, He), va(re, Pe), de = mo(z, re, de, Se, He, Pe), z !== null && !wn ? (re.updateQueue = z.updateQueue, re.effectTag &= -517, z.expirationTime <= Pe && (z.expirationTime = 0), Mn(z, re, Pe)) : (re.effectTag |= 1, fn(z, re, de, Pe), re.child);
  }
  function ll(z, re, de, Se, Pe) {
    if (sn(de)) {
      var He = !0;
      ti(re);
    } else He = !1;
    if (va(re, Pe), re.stateNode === null) z !== null && (z.alternate = null, re.alternate = null, re.effectTag |= 2), zs(re, de, Se), co(re, de, Se, Pe), Se = !0;
    else if (z === null) {
      var ze = re.stateNode, Ze = re.memoizedProps;
      ze.props = Ze;
      var wt = ze.context, St = de.contextType;
      typeof St == "object" && St !== null ? St = mn(St) : (St = sn(de) ? Jn : en.current, St = ma(re, St));
      var tr = de.getDerivedStateFromProps, ar = typeof tr == "function" || typeof ze.getSnapshotBeforeUpdate == "function";
      ar || typeof ze.UNSAFE_componentWillReceiveProps != "function" && typeof ze.componentWillReceiveProps != "function" || (Ze !== Se || wt !== St) && Ws(re, ze, Se, St), Hn = !1;
      var $r = re.memoizedState;
      ze.state = $r, ka(re, Se, ze, Pe), wt = re.memoizedState, Ze !== Se || $r !== wt || on.current || Hn ? (typeof tr == "function" && (ci(re, de, tr, Se), wt = re.memoizedState), (Ze = Hn || Us(re, de, Ze, Se, $r, wt, St)) ? (ar || typeof ze.UNSAFE_componentWillMount != "function" && typeof ze.componentWillMount != "function" || (typeof ze.componentWillMount == "function" && ze.componentWillMount(), typeof ze.UNSAFE_componentWillMount == "function" && ze.UNSAFE_componentWillMount()), typeof ze.componentDidMount == "function" && (re.effectTag |= 4)) : (typeof ze.componentDidMount == "function" && (re.effectTag |= 4), re.memoizedProps = Se, re.memoizedState = wt), ze.props = Se, ze.state = wt, ze.context = St, Se = Ze) : (typeof ze.componentDidMount == "function" && (re.effectTag |= 4), Se = !1);
    } else ze = re.stateNode, lo(z, re), Ze = re.memoizedProps, ze.props = re.type === re.elementType ? Ze : bn(re.type, Ze), wt = ze.context, St = de.contextType, typeof St == "object" && St !== null ? St = mn(St) : (St = sn(de) ? Jn : en.current, St = ma(re, St)), tr = de.getDerivedStateFromProps, (ar = typeof tr == "function" || typeof ze.getSnapshotBeforeUpdate == "function") || typeof ze.UNSAFE_componentWillReceiveProps != "function" && typeof ze.componentWillReceiveProps != "function" || (Ze !== Se || wt !== St) && Ws(re, ze, Se, St), Hn = !1, wt = re.memoizedState, ze.state = wt, ka(re, Se, ze, Pe), $r = re.memoizedState, Ze !== Se || wt !== $r || on.current || Hn ? (typeof tr == "function" && (ci(re, de, tr, Se), $r = re.memoizedState), (tr = Hn || Us(re, de, Ze, Se, wt, $r, St)) ? (ar || typeof ze.UNSAFE_componentWillUpdate != "function" && typeof ze.componentWillUpdate != "function" || (typeof ze.componentWillUpdate == "function" && ze.componentWillUpdate(
      Se,
      $r,
      St
    ), typeof ze.UNSAFE_componentWillUpdate == "function" && ze.UNSAFE_componentWillUpdate(Se, $r, St)), typeof ze.componentDidUpdate == "function" && (re.effectTag |= 4), typeof ze.getSnapshotBeforeUpdate == "function" && (re.effectTag |= 256)) : (typeof ze.componentDidUpdate != "function" || Ze === z.memoizedProps && wt === z.memoizedState || (re.effectTag |= 4), typeof ze.getSnapshotBeforeUpdate != "function" || Ze === z.memoizedProps && wt === z.memoizedState || (re.effectTag |= 256), re.memoizedProps = Se, re.memoizedState = $r), ze.props = Se, ze.state = $r, ze.context = St, Se = tr) : (typeof ze.componentDidUpdate != "function" || Ze === z.memoizedProps && wt === z.memoizedState || (re.effectTag |= 4), typeof ze.getSnapshotBeforeUpdate != "function" || Ze === z.memoizedProps && wt === z.memoizedState || (re.effectTag |= 256), Se = !1);
    return $o(z, re, de, Se, He, Pe);
  }
  function $o(z, re, de, Se, Pe, He) {
    sl(z, re);
    var ze = (re.effectTag & 64) !== 0;
    if (!Se && !ze) return Pe && Ss(re, de, !1), Mn(z, re, He);
    Se = re.stateNode, Fc.current = re;
    var Ze = ze && typeof de.getDerivedStateFromError != "function" ? null : Se.render();
    return re.effectTag |= 1, z !== null && ze ? (re.child = ba(re, z.child, null, He), re.child = ba(re, null, Ze, He)) : fn(z, re, Ze, He), re.memoizedState = Se.state, Pe && Ss(re, de, !0), re.child;
  }
  function cl(z) {
    var re = z.stateNode;
    re.pendingContext ? Es(z, re.pendingContext, re.pendingContext !== re.context) : re.context && Es(z, re.context, !1), fo(z, re.containerInfo);
  }
  var Io = { dehydrated: null, retryTime: 0 };
  function ul(z, re, de) {
    var Se = re.mode, Pe = re.pendingProps, He = zr.current, ze = !1, Ze;
    if ((Ze = (re.effectTag & 64) !== 0) || (Ze = (He & 2) !== 0 && (z === null || z.memoizedState !== null)), Ze ? (ze = !0, re.effectTag &= -65) : z !== null && z.memoizedState === null || Pe.fallback === void 0 || Pe.unstable_avoidThisFallback === !0 || (He |= 1), Gr(zr, He & 1), z === null) {
      if (Pe.fallback !== void 0 && Eo(re), ze) {
        if (ze = Pe.fallback, Pe = Yn(null, Se, 0, null), Pe.return = re, (re.mode & 2) === 0) for (z = re.memoizedState !== null ? re.child.child : re.child, Pe.child = z; z !== null; ) z.return = Pe, z = z.sibling;
        return de = Yn(ze, Se, de, null), de.return = re, Pe.sibling = de, re.memoizedState = Io, re.child = Pe, de;
      }
      return Se = Pe.children, re.memoizedState = null, re.child = uo(re, null, Se, de);
    }
    if (z.memoizedState !== null) {
      if (z = z.child, Se = z.sibling, ze) {
        if (Pe = Pe.fallback, de = ca(z, z.pendingProps), de.return = re, (re.mode & 2) === 0 && (ze = re.memoizedState !== null ? re.child.child : re.child, ze !== z.child)) for (de.child = ze; ze !== null; ) ze.return = de, ze = ze.sibling;
        return Se = ca(Se, Pe), Se.return = re, de.sibling = Se, de.childExpirationTime = 0, re.memoizedState = Io, re.child = de, Se;
      }
      return de = ba(re, z.child, Pe.children, de), re.memoizedState = null, re.child = de;
    }
    if (z = z.child, ze) {
      if (ze = Pe.fallback, Pe = Yn(null, Se, 0, null), Pe.return = re, Pe.child = z, z !== null && (z.return = Pe), (re.mode & 2) === 0) for (z = re.memoizedState !== null ? re.child.child : re.child, Pe.child = z; z !== null; ) z.return = Pe, z = z.sibling;
      return de = Yn(ze, Se, de, null), de.return = re, Pe.sibling = de, de.effectTag |= 2, Pe.childExpirationTime = 0, re.memoizedState = Io, re.child = Pe, de;
    }
    return re.memoizedState = null, re.child = ba(re, z, Pe.children, de);
  }
  function dl(z, re) {
    z.expirationTime < re && (z.expirationTime = re);
    var de = z.alternate;
    de !== null && de.expirationTime < re && (de.expirationTime = re), Ls(z.return, re);
  }
  function _o(z, re, de, Se, Pe, He) {
    var ze = z.memoizedState;
    ze === null ? z.memoizedState = { isBackwards: re, rendering: null, renderingStartTime: 0, last: Se, tail: de, tailExpiration: 0, tailMode: Pe, lastEffect: He } : (ze.isBackwards = re, ze.rendering = null, ze.renderingStartTime = 0, ze.last = Se, ze.tail = de, ze.tailExpiration = 0, ze.tailMode = Pe, ze.lastEffect = He);
  }
  function fl(z, re, de) {
    var Se = re.pendingProps, Pe = Se.revealOrder, He = Se.tail;
    if (fn(z, re, Se.children, de), Se = zr.current, (Se & 2) !== 0) Se = Se & 1 | 2, re.effectTag |= 64;
    else {
      if (z !== null && (z.effectTag & 64) !== 0) e: for (z = re.child; z !== null; ) {
        if (z.tag === 13) z.memoizedState !== null && dl(z, de);
        else if (z.tag === 19) dl(z, de);
        else if (z.child !== null) {
          z.child.return = z, z = z.child;
          continue;
        }
        if (z === re) break e;
        for (; z.sibling === null; ) {
          if (z.return === null || z.return === re) break e;
          z = z.return;
        }
        z.sibling.return = z.return, z = z.sibling;
      }
      Se &= 1;
    }
    if (Gr(zr, Se), (re.mode & 2) === 0) re.memoizedState = null;
    else switch (Pe) {
      case "forwards":
        for (de = re.child, Pe = null; de !== null; ) z = de.alternate, z !== null && hi(z) === null && (Pe = de), de = de.sibling;
        de = Pe, de === null ? (Pe = re.child, re.child = null) : (Pe = de.sibling, de.sibling = null), _o(re, !1, Pe, de, He, re.lastEffect);
        break;
      case "backwards":
        for (de = null, Pe = re.child, re.child = null; Pe !== null; ) {
          if (z = Pe.alternate, z !== null && hi(z) === null) {
            re.child = Pe;
            break;
          }
          z = Pe.sibling, Pe.sibling = de, de = Pe, Pe = z;
        }
        _o(re, !0, de, null, He, re.lastEffect);
        break;
      case "together":
        _o(re, !1, null, null, void 0, re.lastEffect);
        break;
      default:
        re.memoizedState = null;
    }
    return re.child;
  }
  function Mn(z, re, de) {
    z !== null && (re.dependencies = z.dependencies);
    var Se = re.expirationTime;
    if (Se !== 0 && ki(Se), re.childExpirationTime < de) return null;
    if (z !== null && re.child !== z.child) throw Error(u(153));
    if (re.child !== null) {
      for (z = re.child, de = ca(z, z.pendingProps), re.child = de, de.return = re; z.sibling !== null; ) z = z.sibling, de = de.sibling = ca(z, z.pendingProps), de.return = re;
      de.sibling = null;
    }
    return re.child;
  }
  var hl, To, pl, gl;
  hl = function(z, re) {
    for (var de = re.child; de !== null; ) {
      if (de.tag === 5 || de.tag === 6) z.appendChild(de.stateNode);
      else if (de.tag !== 4 && de.child !== null) {
        de.child.return = de, de = de.child;
        continue;
      }
      if (de === re) break;
      for (; de.sibling === null; ) {
        if (de.return === null || de.return === re) return;
        de = de.return;
      }
      de.sibling.return = de.return, de = de.sibling;
    }
  }, To = function() {
  }, pl = function(z, re, de, Se, Pe) {
    var He = z.memoizedProps;
    if (He !== Se) {
      var ze = re.stateNode;
      switch (ea(En.current), z = null, de) {
        case "input":
          He = Ne(ze, He), Se = Ne(ze, Se), z = [];
          break;
        case "option":
          He = Ve(ze, He), Se = Ve(ze, Se), z = [];
          break;
        case "select":
          He = s({}, He, { value: void 0 }), Se = s({}, Se, { value: void 0 }), z = [];
          break;
        case "textarea":
          He = at(ze, He), Se = at(ze, Se), z = [];
          break;
        default:
          typeof He.onClick != "function" && typeof Se.onClick == "function" && (ze.onclick = nn);
      }
      yr(de, Se);
      var Ze, wt;
      de = null;
      for (Ze in He) if (!Se.hasOwnProperty(Ze) && He.hasOwnProperty(Ze) && He[Ze] != null) if (Ze === "style") for (wt in ze = He[Ze], ze) ze.hasOwnProperty(wt) && (de || (de = {}), de[wt] = "");
      else Ze !== "dangerouslySetInnerHTML" && Ze !== "children" && Ze !== "suppressContentEditableWarning" && Ze !== "suppressHydrationWarning" && Ze !== "autoFocus" && (R.hasOwnProperty(Ze) ? z || (z = []) : (z = z || []).push(Ze, null));
      for (Ze in Se) {
        var St = Se[Ze];
        if (ze = He?.[Ze], Se.hasOwnProperty(Ze) && St !== ze && (St != null || ze != null)) if (Ze === "style") if (ze) {
          for (wt in ze) !ze.hasOwnProperty(wt) || St && St.hasOwnProperty(wt) || (de || (de = {}), de[wt] = "");
          for (wt in St) St.hasOwnProperty(wt) && ze[wt] !== St[wt] && (de || (de = {}), de[wt] = St[wt]);
        } else de || (z || (z = []), z.push(Ze, de)), de = St;
        else Ze === "dangerouslySetInnerHTML" ? (St = St ? St.__html : void 0, ze = ze ? ze.__html : void 0, St != null && ze !== St && (z = z || []).push(Ze, St)) : Ze === "children" ? ze === St || typeof St != "string" && typeof St != "number" || (z = z || []).push(Ze, "" + St) : Ze !== "suppressContentEditableWarning" && Ze !== "suppressHydrationWarning" && (R.hasOwnProperty(Ze) ? (St != null && Kr(Pe, Ze), z || ze === St || (z = [])) : (z = z || []).push(Ze, St));
      }
      de && (z = z || []).push("style", de), Pe = z, (re.updateQueue = Pe) && (re.effectTag |= 4);
    }
  }, gl = function(z, re, de, Se) {
    de !== Se && (re.effectTag |= 4);
  };
  function Ci(z, re) {
    switch (z.tailMode) {
      case "hidden":
        re = z.tail;
        for (var de = null; re !== null; ) re.alternate !== null && (de = re), re = re.sibling;
        de === null ? z.tail = null : de.sibling = null;
        break;
      case "collapsed":
        de = z.tail;
        for (var Se = null; de !== null; ) de.alternate !== null && (Se = de), de = de.sibling;
        Se === null ? re || z.tail === null ? z.tail = null : z.tail.sibling = null : Se.sibling = null;
    }
  }
  function Lc(z, re, de) {
    var Se = re.pendingProps;
    switch (re.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return null;
      case 1:
        return sn(re.type) && ei(), null;
      case 3:
        return xa(), jr(on), jr(en), de = re.stateNode, de.pendingContext && (de.context = de.pendingContext, de.pendingContext = null), z !== null && z.child !== null || !yi(re) || (re.effectTag |= 4), To(re), null;
      case 5:
        ho(re), de = ea(ja.current);
        var Pe = re.type;
        if (z !== null && re.stateNode != null) pl(z, re, Pe, Se, de), z.ref !== re.ref && (re.effectTag |= 128);
        else {
          if (!Se) {
            if (re.stateNode === null) throw Error(u(166));
            return null;
          }
          if (z = ea(En.current), yi(re)) {
            Se = re.stateNode, Pe = re.type;
            var He = re.memoizedProps;
            switch (Se[Fn] = re, Se[Ya] = He, Pe) {
              case "iframe":
              case "object":
              case "embed":
                Ut("load", Se);
                break;
              case "video":
              case "audio":
                for (z = 0; z < qe.length; z++) Ut(qe[z], Se);
                break;
              case "source":
                Ut("error", Se);
                break;
              case "img":
              case "image":
              case "link":
                Ut("error", Se), Ut("load", Se);
                break;
              case "form":
                Ut("reset", Se), Ut("submit", Se);
                break;
              case "details":
                Ut("toggle", Se);
                break;
              case "input":
                Ge(Se, He), Ut("invalid", Se), Kr(de, "onChange");
                break;
              case "select":
                Se._wrapperState = { wasMultiple: !!He.multiple }, Ut("invalid", Se), Kr(de, "onChange");
                break;
              case "textarea":
                Qe(Se, He), Ut("invalid", Se), Kr(de, "onChange");
            }
            yr(Pe, He), z = null;
            for (var ze in He) if (He.hasOwnProperty(ze)) {
              var Ze = He[ze];
              ze === "children" ? typeof Ze == "string" ? Se.textContent !== Ze && (z = ["children", Ze]) : typeof Ze == "number" && Se.textContent !== "" + Ze && (z = ["children", "" + Ze]) : R.hasOwnProperty(ze) && Ze != null && Kr(de, ze);
            }
            switch (Pe) {
              case "input":
                Le(Se), ct(Se, He, !0);
                break;
              case "textarea":
                Le(Se), ft(Se);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof He.onClick == "function" && (Se.onclick = nn);
            }
            de = z, re.updateQueue = de, de !== null && (re.effectTag |= 4);
          } else {
            switch (ze = de.nodeType === 9 ? de : de.ownerDocument, z === mr && (z = Pt(Pe)), z === mr ? Pe === "script" ? (z = ze.createElement("div"), z.innerHTML = "<script><\/script>", z = z.removeChild(z.firstChild)) : typeof Se.is == "string" ? z = ze.createElement(Pe, { is: Se.is }) : (z = ze.createElement(Pe), Pe === "select" && (ze = z, Se.multiple ? ze.multiple = !0 : Se.size && (ze.size = Se.size))) : z = ze.createElementNS(z, Pe), z[Fn] = re, z[Ya] = Se, hl(z, re, !1, !1), re.stateNode = z, ze = qr(Pe, Se), Pe) {
              case "iframe":
              case "object":
              case "embed":
                Ut(
                  "load",
                  z
                ), Ze = Se;
                break;
              case "video":
              case "audio":
                for (Ze = 0; Ze < qe.length; Ze++) Ut(qe[Ze], z);
                Ze = Se;
                break;
              case "source":
                Ut("error", z), Ze = Se;
                break;
              case "img":
              case "image":
              case "link":
                Ut("error", z), Ut("load", z), Ze = Se;
                break;
              case "form":
                Ut("reset", z), Ut("submit", z), Ze = Se;
                break;
              case "details":
                Ut("toggle", z), Ze = Se;
                break;
              case "input":
                Ge(z, Se), Ze = Ne(z, Se), Ut("invalid", z), Kr(de, "onChange");
                break;
              case "option":
                Ze = Ve(z, Se);
                break;
              case "select":
                z._wrapperState = { wasMultiple: !!Se.multiple }, Ze = s({}, Se, { value: void 0 }), Ut("invalid", z), Kr(de, "onChange");
                break;
              case "textarea":
                Qe(
                  z,
                  Se
                ), Ze = at(z, Se), Ut("invalid", z), Kr(de, "onChange");
                break;
              default:
                Ze = Se;
            }
            yr(Pe, Ze);
            var wt = Ze;
            for (He in wt) if (wt.hasOwnProperty(He)) {
              var St = wt[He];
              He === "style" ? Hr(z, St) : He === "dangerouslySetInnerHTML" ? (St = St ? St.__html : void 0, St != null && pt(z, St)) : He === "children" ? typeof St == "string" ? (Pe !== "textarea" || St !== "") && Et(z, St) : typeof St == "number" && Et(z, "" + St) : He !== "suppressContentEditableWarning" && He !== "suppressHydrationWarning" && He !== "autoFocus" && (R.hasOwnProperty(He) ? St != null && Kr(de, He) : St != null && me(z, He, St, ze));
            }
            switch (Pe) {
              case "input":
                Le(z), ct(z, Se, !1);
                break;
              case "textarea":
                Le(z), ft(z);
                break;
              case "option":
                Se.value != null && z.setAttribute("value", "" + Fe(Se.value));
                break;
              case "select":
                z.multiple = !!Se.multiple, de = Se.value, de != null ? ut(z, !!Se.multiple, de, !1) : Se.defaultValue != null && ut(z, !!Se.multiple, Se.defaultValue, !0);
                break;
              default:
                typeof Ze.onClick == "function" && (z.onclick = nn);
            }
            Jo(Pe, Se) && (re.effectTag |= 4);
          }
          re.ref !== null && (re.effectTag |= 128);
        }
        return null;
      case 6:
        if (z && re.stateNode != null) gl(z, re, z.memoizedProps, Se);
        else {
          if (typeof Se != "string" && re.stateNode === null) throw Error(u(166));
          de = ea(ja.current), ea(En.current), yi(re) ? (de = re.stateNode, Se = re.memoizedProps, de[Fn] = re, de.nodeValue !== Se && (re.effectTag |= 4)) : (de = (de.nodeType === 9 ? de : de.ownerDocument).createTextNode(Se), de[Fn] = re, re.stateNode = de);
        }
        return null;
      case 13:
        return jr(zr), Se = re.memoizedState, (re.effectTag & 64) !== 0 ? (re.expirationTime = de, re) : (de = Se !== null, Se = !1, z === null ? re.memoizedProps.fallback !== void 0 && yi(re) : (Pe = z.memoizedState, Se = Pe !== null, de || Pe === null || (Pe = z.child.sibling, Pe !== null && (He = re.firstEffect, He !== null ? (re.firstEffect = Pe, Pe.nextEffect = He) : (re.firstEffect = re.lastEffect = Pe, Pe.nextEffect = null), Pe.effectTag = 8))), de && !Se && (re.mode & 2) !== 0 && (z === null && re.memoizedProps.unstable_avoidThisFallback !== !0 || (zr.current & 1) !== 0 ? Zr === na && (Zr = Si) : ((Zr === na || Zr === Si) && (Zr = $i), Ua !== 0 && hn !== null && (ua(hn, ln), Hl(hn, Ua)))), (de || Se) && (re.effectTag |= 4), null);
      case 4:
        return xa(), To(re), null;
      case 10:
        return oo(re), null;
      case 17:
        return sn(re.type) && ei(), null;
      case 19:
        if (jr(zr), Se = re.memoizedState, Se === null) return null;
        if (Pe = (re.effectTag & 64) !== 0, He = Se.rendering, He === null) {
          if (Pe) Ci(Se, !1);
          else if (Zr !== na || z !== null && (z.effectTag & 64) !== 0) for (He = re.child; He !== null; ) {
            if (z = hi(He), z !== null) {
              for (re.effectTag |= 64, Ci(Se, !1), Pe = z.updateQueue, Pe !== null && (re.updateQueue = Pe, re.effectTag |= 4), Se.lastEffect === null && (re.firstEffect = null), re.lastEffect = Se.lastEffect, Se = re.child; Se !== null; ) Pe = Se, He = de, Pe.effectTag &= 2, Pe.nextEffect = null, Pe.firstEffect = null, Pe.lastEffect = null, z = Pe.alternate, z === null ? (Pe.childExpirationTime = 0, Pe.expirationTime = He, Pe.child = null, Pe.memoizedProps = null, Pe.memoizedState = null, Pe.updateQueue = null, Pe.dependencies = null) : (Pe.childExpirationTime = z.childExpirationTime, Pe.expirationTime = z.expirationTime, Pe.child = z.child, Pe.memoizedProps = z.memoizedProps, Pe.memoizedState = z.memoizedState, Pe.updateQueue = z.updateQueue, He = z.dependencies, Pe.dependencies = He === null ? null : { expirationTime: He.expirationTime, firstContext: He.firstContext, responders: He.responders }), Se = Se.sibling;
              return Gr(zr, zr.current & 1 | 2), re.child;
            }
            He = He.sibling;
          }
        } else {
          if (!Pe) if (z = hi(He), z !== null) {
            if (re.effectTag |= 64, Pe = !0, de = z.updateQueue, de !== null && (re.updateQueue = de, re.effectTag |= 4), Ci(Se, !0), Se.tail === null && Se.tailMode === "hidden" && !He.alternate) return re = re.lastEffect = Se.lastEffect, re !== null && (re.nextEffect = null), null;
          } else 2 * gn() - Se.renderingStartTime > Se.tailExpiration && 1 < de && (re.effectTag |= 64, Pe = !0, Ci(Se, !1), re.expirationTime = re.childExpirationTime = de - 1);
          Se.isBackwards ? (He.sibling = re.child, re.child = He) : (de = Se.last, de !== null ? de.sibling = He : re.child = He, Se.last = He);
        }
        return Se.tail !== null ? (Se.tailExpiration === 0 && (Se.tailExpiration = gn() + 500), de = Se.tail, Se.rendering = de, Se.tail = de.sibling, Se.lastEffect = re.lastEffect, Se.renderingStartTime = gn(), de.sibling = null, re = zr.current, Gr(zr, Pe ? re & 1 | 2 : re & 1), de) : null;
    }
    throw Error(u(
      156,
      re.tag
    ));
  }
  function Nc(z) {
    switch (z.tag) {
      case 1:
        sn(z.type) && ei();
        var re = z.effectTag;
        return re & 4096 ? (z.effectTag = re & -4097 | 64, z) : null;
      case 3:
        if (xa(), jr(on), jr(en), re = z.effectTag, (re & 64) !== 0) throw Error(u(285));
        return z.effectTag = re & -4097 | 64, z;
      case 5:
        return ho(z), null;
      case 13:
        return jr(zr), re = z.effectTag, re & 4096 ? (z.effectTag = re & -4097 | 64, z) : null;
      case 19:
        return jr(zr), null;
      case 4:
        return xa(), null;
      case 10:
        return oo(z), null;
      default:
        return null;
    }
  }
  function Ro(z, re) {
    return { value: z, source: re, stack: Me(re) };
  }
  var jc = typeof WeakSet == "function" ? WeakSet : Set;
  function Po(z, re) {
    var de = re.source, Se = re.stack;
    Se === null && de !== null && (Se = Me(de)), de !== null && Oe(de.type), re = re.value, z !== null && z.tag === 1 && Oe(z.type);
    try {
      console.error(re);
    } catch (Pe) {
      setTimeout(function() {
        throw Pe;
      });
    }
  }
  function Hc(z, re) {
    try {
      re.props = z.memoizedProps, re.state = z.memoizedState, re.componentWillUnmount();
    } catch (de) {
      la(z, de);
    }
  }
  function ml(z) {
    var re = z.ref;
    if (re !== null) if (typeof re == "function") try {
      re(null);
    } catch (de) {
      la(z, de);
    }
    else re.current = null;
  }
  function Uc(z, re) {
    switch (re.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        return;
      case 1:
        if (re.effectTag & 256 && z !== null) {
          var de = z.memoizedProps, Se = z.memoizedState;
          z = re.stateNode, re = z.getSnapshotBeforeUpdate(re.elementType === re.type ? de : bn(re.type, de), Se), z.__reactInternalSnapshotBeforeUpdate = re;
        }
        return;
      case 3:
      case 5:
      case 6:
      case 4:
      case 17:
        return;
    }
    throw Error(u(163));
  }
  function Al(z, re) {
    if (re = re.updateQueue, re = re !== null ? re.lastEffect : null, re !== null) {
      var de = re = re.next;
      do {
        if ((de.tag & z) === z) {
          var Se = de.destroy;
          de.destroy = void 0, Se !== void 0 && Se();
        }
        de = de.next;
      } while (de !== re);
    }
  }
  function vl(z, re) {
    if (re = re.updateQueue, re = re !== null ? re.lastEffect : null, re !== null) {
      var de = re = re.next;
      do {
        if ((de.tag & z) === z) {
          var Se = de.create;
          de.destroy = Se();
        }
        de = de.next;
      } while (de !== re);
    }
  }
  function zc(z, re, de) {
    switch (de.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        vl(3, de);
        return;
      case 1:
        if (z = de.stateNode, de.effectTag & 4) if (re === null) z.componentDidMount();
        else {
          var Se = de.elementType === de.type ? re.memoizedProps : bn(de.type, re.memoizedProps);
          z.componentDidUpdate(Se, re.memoizedState, z.__reactInternalSnapshotBeforeUpdate);
        }
        re = de.updateQueue, re !== null && js(de, re, z);
        return;
      case 3:
        if (re = de.updateQueue, re !== null) {
          if (z = null, de.child !== null) switch (de.child.tag) {
            case 5:
              z = de.child.stateNode;
              break;
            case 1:
              z = de.child.stateNode;
          }
          js(de, re, z);
        }
        return;
      case 5:
        z = de.stateNode, re === null && de.effectTag & 4 && Jo(de.type, de.memoizedProps) && z.focus();
        return;
      case 6:
        return;
      case 4:
        return;
      case 12:
        return;
      case 13:
        de.memoizedState === null && (de = de.alternate, de !== null && (de = de.memoizedState, de !== null && (de = de.dehydrated, de !== null && sr(de))));
        return;
      case 19:
      case 17:
      case 20:
      case 21:
        return;
    }
    throw Error(u(163));
  }
  function bl(z, re, de) {
    switch (typeof zo == "function" && zo(re), re.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        if (z = re.updateQueue, z !== null && (z = z.lastEffect, z !== null)) {
          var Se = z.next;
          jn(97 < de ? 97 : de, function() {
            var Pe = Se;
            do {
              var He = Pe.destroy;
              if (He !== void 0) {
                var ze = re;
                try {
                  He();
                } catch (Ze) {
                  la(ze, Ze);
                }
              }
              Pe = Pe.next;
            } while (Pe !== Se);
          });
        }
        break;
      case 1:
        ml(re), de = re.stateNode, typeof de.componentWillUnmount == "function" && Hc(re, de);
        break;
      case 5:
        ml(re);
        break;
      case 4:
        El(z, re, de);
    }
  }
  function xl(z) {
    var re = z.alternate;
    z.return = null, z.child = null, z.memoizedState = null, z.updateQueue = null, z.dependencies = null, z.alternate = null, z.firstEffect = null, z.lastEffect = null, z.pendingProps = null, z.memoizedProps = null, z.stateNode = null, re !== null && xl(re);
  }
  function yl(z) {
    return z.tag === 5 || z.tag === 3 || z.tag === 4;
  }
  function Cl(z) {
    e: {
      for (var re = z.return; re !== null; ) {
        if (yl(re)) {
          var de = re;
          break e;
        }
        re = re.return;
      }
      throw Error(u(160));
    }
    switch (re = de.stateNode, de.tag) {
      case 5:
        var Se = !1;
        break;
      case 3:
        re = re.containerInfo, Se = !0;
        break;
      case 4:
        re = re.containerInfo, Se = !0;
        break;
      default:
        throw Error(u(161));
    }
    de.effectTag & 16 && (Et(re, ""), de.effectTag &= -17);
    e: t: for (de = z; ; ) {
      for (; de.sibling === null; ) {
        if (de.return === null || yl(de.return)) {
          de = null;
          break e;
        }
        de = de.return;
      }
      for (de.sibling.return = de.return, de = de.sibling; de.tag !== 5 && de.tag !== 6 && de.tag !== 18; ) {
        if (de.effectTag & 2 || de.child === null || de.tag === 4) continue t;
        de.child.return = de, de = de.child;
      }
      if (!(de.effectTag & 2)) {
        de = de.stateNode;
        break e;
      }
    }
    Se ? Bo(z, de, re) : Oo(z, de, re);
  }
  function Bo(z, re, de) {
    var Se = z.tag, Pe = Se === 5 || Se === 6;
    if (Pe) z = Pe ? z.stateNode : z.stateNode.instance, re ? de.nodeType === 8 ? de.parentNode.insertBefore(z, re) : de.insertBefore(z, re) : (de.nodeType === 8 ? (re = de.parentNode, re.insertBefore(z, de)) : (re = de, re.appendChild(z)), de = de._reactRootContainer, de != null || re.onclick !== null || (re.onclick = nn));
    else if (Se !== 4 && (z = z.child, z !== null)) for (Bo(z, re, de), z = z.sibling; z !== null; ) Bo(z, re, de), z = z.sibling;
  }
  function Oo(z, re, de) {
    var Se = z.tag, Pe = Se === 5 || Se === 6;
    if (Pe) z = Pe ? z.stateNode : z.stateNode.instance, re ? de.insertBefore(z, re) : de.appendChild(z);
    else if (Se !== 4 && (z = z.child, z !== null)) for (Oo(z, re, de), z = z.sibling; z !== null; ) Oo(z, re, de), z = z.sibling;
  }
  function El(z, re, de) {
    for (var Se = re, Pe = !1, He, ze; ; ) {
      if (!Pe) {
        Pe = Se.return;
        e: for (; ; ) {
          if (Pe === null) throw Error(u(160));
          switch (He = Pe.stateNode, Pe.tag) {
            case 5:
              ze = !1;
              break e;
            case 3:
              He = He.containerInfo, ze = !0;
              break e;
            case 4:
              He = He.containerInfo, ze = !0;
              break e;
          }
          Pe = Pe.return;
        }
        Pe = !0;
      }
      if (Se.tag === 5 || Se.tag === 6) {
        e: for (var Ze = z, wt = Se, St = de, tr = wt; ; ) if (bl(Ze, tr, St), tr.child !== null && tr.tag !== 4) tr.child.return = tr, tr = tr.child;
        else {
          if (tr === wt) break e;
          for (; tr.sibling === null; ) {
            if (tr.return === null || tr.return === wt) break e;
            tr = tr.return;
          }
          tr.sibling.return = tr.return, tr = tr.sibling;
        }
        ze ? (Ze = He, wt = Se.stateNode, Ze.nodeType === 8 ? Ze.parentNode.removeChild(wt) : Ze.removeChild(wt)) : He.removeChild(Se.stateNode);
      } else if (Se.tag === 4) {
        if (Se.child !== null) {
          He = Se.stateNode.containerInfo, ze = !0, Se.child.return = Se, Se = Se.child;
          continue;
        }
      } else if (bl(z, Se, de), Se.child !== null) {
        Se.child.return = Se, Se = Se.child;
        continue;
      }
      if (Se === re) break;
      for (; Se.sibling === null; ) {
        if (Se.return === null || Se.return === re) return;
        Se = Se.return, Se.tag === 4 && (Pe = !1);
      }
      Se.sibling.return = Se.return, Se = Se.sibling;
    }
  }
  function Mo(z, re) {
    switch (re.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        Al(3, re);
        return;
      case 1:
        return;
      case 5:
        var de = re.stateNode;
        if (de != null) {
          var Se = re.memoizedProps, Pe = z !== null ? z.memoizedProps : Se;
          z = re.type;
          var He = re.updateQueue;
          if (re.updateQueue = null, He !== null) {
            for (de[Ya] = Se, z === "input" && Se.type === "radio" && Se.name != null && Xe(de, Se), qr(z, Pe), re = qr(z, Se), Pe = 0; Pe < He.length; Pe += 2) {
              var ze = He[Pe], Ze = He[Pe + 1];
              ze === "style" ? Hr(de, Ze) : ze === "dangerouslySetInnerHTML" ? pt(de, Ze) : ze === "children" ? Et(de, Ze) : me(de, ze, Ze, re);
            }
            switch (z) {
              case "input":
                nt(de, Se);
                break;
              case "textarea":
                st(de, Se);
                break;
              case "select":
                re = de._wrapperState.wasMultiple, de._wrapperState.wasMultiple = !!Se.multiple, z = Se.value, z != null ? ut(de, !!Se.multiple, z, !1) : re !== !!Se.multiple && (Se.defaultValue != null ? ut(de, !!Se.multiple, Se.defaultValue, !0) : ut(de, !!Se.multiple, Se.multiple ? [] : "", !1));
            }
          }
        }
        return;
      case 6:
        if (re.stateNode === null) throw Error(u(162));
        re.stateNode.nodeValue = re.memoizedProps;
        return;
      case 3:
        re = re.stateNode, re.hydrate && (re.hydrate = !1, sr(re.containerInfo));
        return;
      case 12:
        return;
      case 13:
        if (de = re, re.memoizedState === null ? Se = !1 : (Se = !0, de = re.child, Fo = gn()), de !== null) e: for (z = de; ; ) {
          if (z.tag === 5) He = z.stateNode, Se ? (He = He.style, typeof He.setProperty == "function" ? He.setProperty("display", "none", "important") : He.display = "none") : (He = z.stateNode, Pe = z.memoizedProps.style, Pe = Pe != null && Pe.hasOwnProperty("display") ? Pe.display : null, He.style.display = pr("display", Pe));
          else if (z.tag === 6) z.stateNode.nodeValue = Se ? "" : z.memoizedProps;
          else if (z.tag === 13 && z.memoizedState !== null && z.memoizedState.dehydrated === null) {
            He = z.child.sibling, He.return = z, z = He;
            continue;
          } else if (z.child !== null) {
            z.child.return = z, z = z.child;
            continue;
          }
          if (z === de) break;
          for (; z.sibling === null; ) {
            if (z.return === null || z.return === de) break e;
            z = z.return;
          }
          z.sibling.return = z.return, z = z.sibling;
        }
        wl(re);
        return;
      case 19:
        wl(re);
        return;
      case 17:
        return;
    }
    throw Error(u(163));
  }
  function wl(z) {
    var re = z.updateQueue;
    if (re !== null) {
      z.updateQueue = null;
      var de = z.stateNode;
      de === null && (de = z.stateNode = new jc()), re.forEach(function(Se) {
        var Pe = Jc.bind(null, z, Se);
        de.has(Se) || (de.add(Se), Se.then(Pe, Pe));
      });
    }
  }
  var Wc = typeof WeakMap == "function" ? WeakMap : Map;
  function Sl(z, re, de) {
    de = Un(de, null), de.tag = 3, de.payload = { element: null };
    var Se = re.value;
    return de.callback = function() {
      Ri || (Ri = !0, Lo = Se), Po(z, re);
    }, de;
  }
  function $l(z, re, de) {
    de = Un(de, null), de.tag = 3;
    var Se = z.type.getDerivedStateFromError;
    if (typeof Se == "function") {
      var Pe = re.value;
      de.payload = function() {
        return Po(z, re), Se(Pe);
      };
    }
    var He = z.stateNode;
    return He !== null && typeof He.componentDidCatch == "function" && (de.callback = function() {
      typeof Se != "function" && (Gn === null ? Gn = /* @__PURE__ */ new Set([this]) : Gn.add(this), Po(z, re));
      var ze = re.stack;
      this.componentDidCatch(re.value, { componentStack: ze !== null ? ze : "" });
    }), de;
  }
  var Vc = Math.ceil, Ei = ge.ReactCurrentDispatcher, Il = ge.ReactCurrentOwner, Xr = 0, ko = 8, xn = 16, Sn = 32, na = 0, wi = 1, _l = 2, Si = 3, $i = 4, Do = 5, vr = Xr, hn = null, Cr = null, ln = 0, Zr = na, Ii = null, kn = 1073741823, Ha = 1073741823, _i = null, Ua = 0, Ti = !1, Fo = 0, Tl = 500, or = null, Ri = !1, Lo = null, Gn = null, Pi = !1, za = null, Wa = 90, aa = null, Va = 0, No = null, Bi = 0;
  function $n() {
    return (vr & (xn | Sn)) !== Xr ? 1073741821 - (gn() / 10 | 0) : Bi !== 0 ? Bi : Bi = 1073741821 - (gn() / 10 | 0);
  }
  function ia(z, re, de) {
    if (re = re.mode, (re & 2) === 0) return 1073741823;
    var Se = ai();
    if ((re & 4) === 0) return Se === 99 ? 1073741823 : 1073741822;
    if ((vr & xn) !== Xr) return ln;
    if (de !== null) z = ii(z, de.timeoutMs | 0 || 5e3, 250);
    else switch (Se) {
      case 99:
        z = 1073741823;
        break;
      case 98:
        z = ii(z, 150, 100);
        break;
      case 97:
      case 96:
        z = ii(z, 5e3, 250);
        break;
      case 95:
        z = 2;
        break;
      default:
        throw Error(u(326));
    }
    return hn !== null && z === ln && --z, z;
  }
  function Qn(z, re) {
    if (50 < Va) throw Va = 0, No = null, Error(u(185));
    if (z = Oi(z, re), z !== null) {
      var de = ai();
      re === 1073741823 ? (vr & ko) !== Xr && (vr & (xn | Sn)) === Xr ? jo(z) : (pn(z), vr === Xr && Cn()) : pn(z), (vr & 4) === Xr || de !== 98 && de !== 99 || (aa === null ? aa = /* @__PURE__ */ new Map([[z, re]]) : (de = aa.get(z), (de === void 0 || de > re) && aa.set(z, re)));
    }
  }
  function Oi(z, re) {
    z.expirationTime < re && (z.expirationTime = re);
    var de = z.alternate;
    de !== null && de.expirationTime < re && (de.expirationTime = re);
    var Se = z.return, Pe = null;
    if (Se === null && z.tag === 3) Pe = z.stateNode;
    else for (; Se !== null; ) {
      if (de = Se.alternate, Se.childExpirationTime < re && (Se.childExpirationTime = re), de !== null && de.childExpirationTime < re && (de.childExpirationTime = re), Se.return === null && Se.tag === 3) {
        Pe = Se.stateNode;
        break;
      }
      Se = Se.return;
    }
    return Pe !== null && (hn === Pe && (ki(re), Zr === $i && ua(Pe, ln)), Hl(Pe, re)), Pe;
  }
  function Mi(z) {
    var re = z.lastExpiredTime;
    if (re !== 0 || (re = z.firstPendingTime, !jl(z, re))) return re;
    var de = z.lastPingedTime;
    return z = z.nextKnownPendingLevel, z = de > z ? de : z, 2 >= z && re !== z ? 0 : z;
  }
  function pn(z) {
    if (z.lastExpiredTime !== 0) z.callbackExpirationTime = 1073741823, z.callbackPriority = 99, z.callbackNode = Ds(jo.bind(null, z));
    else {
      var re = Mi(z), de = z.callbackNode;
      if (re === 0) de !== null && (z.callbackNode = null, z.callbackExpirationTime = 0, z.callbackPriority = 90);
      else {
        var Se = $n();
        if (re === 1073741823 ? Se = 99 : re === 1 || re === 2 ? Se = 95 : (Se = 10 * (1073741821 - re) - 10 * (1073741821 - Se), Se = 0 >= Se ? 99 : 250 >= Se ? 98 : 5250 >= Se ? 97 : 95), de !== null) {
          var Pe = z.callbackPriority;
          if (z.callbackExpirationTime === re && Pe >= Se) return;
          de !== Bs && $s(de);
        }
        z.callbackExpirationTime = re, z.callbackPriority = Se, re = re === 1073741823 ? Ds(jo.bind(null, z)) : ks(Se, Rl.bind(null, z), { timeout: 10 * (1073741821 - re) - gn() }), z.callbackNode = re;
      }
    }
  }
  function Rl(z, re) {
    if (Bi = 0, re) return re = $n(), Qo(z, re), pn(z), null;
    var de = Mi(z);
    if (de !== 0) {
      if (re = z.callbackNode, (vr & (xn | Sn)) !== Xr) throw Error(u(327));
      if (Ea(), z === hn && de === ln || oa(z, de), Cr !== null) {
        var Se = vr;
        vr |= xn;
        var Pe = Ml();
        do
          try {
            Yc();
            break;
          } catch (Ze) {
            Ol(z, Ze);
          }
        while (!0);
        if (io(), vr = Se, Ei.current = Pe, Zr === wi) throw re = Ii, oa(z, de), ua(z, de), pn(z), re;
        if (Cr === null) switch (Pe = z.finishedWork = z.current.alternate, z.finishedExpirationTime = de, Se = Zr, hn = null, Se) {
          case na:
          case wi:
            throw Error(u(345));
          case _l:
            Qo(z, 2 < de ? 2 : de);
            break;
          case Si:
            if (ua(z, de), Se = z.lastSuspendedTime, de === Se && (z.nextKnownPendingLevel = Ho(Pe)), kn === 1073741823 && (Pe = Fo + Tl - gn(), 10 < Pe)) {
              if (Ti) {
                var He = z.lastPingedTime;
                if (He === 0 || He >= de) {
                  z.lastPingedTime = de, oa(z, de);
                  break;
                }
              }
              if (He = Mi(z), He !== 0 && He !== de) break;
              if (Se !== 0 && Se !== de) {
                z.lastPingedTime = Se;
                break;
              }
              z.timeoutHandle = Vi(sa.bind(null, z), Pe);
              break;
            }
            sa(z);
            break;
          case $i:
            if (ua(z, de), Se = z.lastSuspendedTime, de === Se && (z.nextKnownPendingLevel = Ho(Pe)), Ti && (Pe = z.lastPingedTime, Pe === 0 || Pe >= de)) {
              z.lastPingedTime = de, oa(z, de);
              break;
            }
            if (Pe = Mi(z), Pe !== 0 && Pe !== de) break;
            if (Se !== 0 && Se !== de) {
              z.lastPingedTime = Se;
              break;
            }
            if (Ha !== 1073741823 ? Se = 10 * (1073741821 - Ha) - gn() : kn === 1073741823 ? Se = 0 : (Se = 10 * (1073741821 - kn) - 5e3, Pe = gn(), de = 10 * (1073741821 - de) - Pe, Se = Pe - Se, 0 > Se && (Se = 0), Se = (120 > Se ? 120 : 480 > Se ? 480 : 1080 > Se ? 1080 : 1920 > Se ? 1920 : 3e3 > Se ? 3e3 : 4320 > Se ? 4320 : 1960 * Vc(Se / 1960)) - Se, de < Se && (Se = de)), 10 < Se) {
              z.timeoutHandle = Vi(sa.bind(null, z), Se);
              break;
            }
            sa(z);
            break;
          case Do:
            if (kn !== 1073741823 && _i !== null) {
              He = kn;
              var ze = _i;
              if (Se = ze.busyMinDurationMs | 0, 0 >= Se ? Se = 0 : (Pe = ze.busyDelayMs | 0, He = gn() - (10 * (1073741821 - He) - (ze.timeoutMs | 0 || 5e3)), Se = He <= Pe ? 0 : Pe + Se - He), 10 < Se) {
                ua(z, de), z.timeoutHandle = Vi(sa.bind(null, z), Se);
                break;
              }
            }
            sa(z);
            break;
          default:
            throw Error(u(329));
        }
        if (pn(z), z.callbackNode === re) return Rl.bind(null, z);
      }
    }
    return null;
  }
  function jo(z) {
    var re = z.lastExpiredTime;
    if (re = re !== 0 ? re : 1073741823, (vr & (xn | Sn)) !== Xr) throw Error(u(327));
    if (Ea(), z === hn && re === ln || oa(z, re), Cr !== null) {
      var de = vr;
      vr |= xn;
      var Se = Ml();
      do
        try {
          Qc();
          break;
        } catch (Pe) {
          Ol(z, Pe);
        }
      while (!0);
      if (io(), vr = de, Ei.current = Se, Zr === wi) throw de = Ii, oa(z, re), ua(z, re), pn(z), de;
      if (Cr !== null) throw Error(u(261));
      z.finishedWork = z.current.alternate, z.finishedExpirationTime = re, hn = null, sa(z), pn(z);
    }
    return null;
  }
  function Gc() {
    if (aa !== null) {
      var z = aa;
      aa = null, z.forEach(function(re, de) {
        Qo(de, re), pn(de);
      }), Cn();
    }
  }
  function Pl(z, re) {
    var de = vr;
    vr |= 1;
    try {
      return z(re);
    } finally {
      vr = de, vr === Xr && Cn();
    }
  }
  function Bl(z, re) {
    var de = vr;
    vr &= -2, vr |= ko;
    try {
      return z(re);
    } finally {
      vr = de, vr === Xr && Cn();
    }
  }
  function oa(z, re) {
    z.finishedWork = null, z.finishedExpirationTime = 0;
    var de = z.timeoutHandle;
    if (de !== -1 && (z.timeoutHandle = -1, Vl(de)), Cr !== null) for (de = Cr.return; de !== null; ) {
      var Se = de;
      switch (Se.tag) {
        case 1:
          Se = Se.type.childContextTypes, Se != null && ei();
          break;
        case 3:
          xa(), jr(on), jr(en);
          break;
        case 5:
          ho(Se);
          break;
        case 4:
          xa();
          break;
        case 13:
          jr(zr);
          break;
        case 19:
          jr(zr);
          break;
        case 10:
          oo(Se);
      }
      de = de.return;
    }
    hn = z, Cr = ca(z.current, null), ln = re, Zr = na, Ii = null, Ha = kn = 1073741823, _i = null, Ua = 0, Ti = !1;
  }
  function Ol(z, re) {
    do {
      try {
        if (io(), pi.current = xi, gi) for (var de = Yr.memoizedState; de !== null; ) {
          var Se = de.queue;
          Se !== null && (Se.pending = null), de = de.next;
        }
        if (Wn = 0, rn = tn = Yr = null, gi = !1, Cr === null || Cr.return === null) return Zr = wi, Ii = re, Cr = null;
        e: {
          var Pe = z, He = Cr.return, ze = Cr, Ze = re;
          if (re = ln, ze.effectTag |= 2048, ze.firstEffect = ze.lastEffect = null, Ze !== null && typeof Ze == "object" && typeof Ze.then == "function") {
            var wt = Ze;
            if ((ze.mode & 2) === 0) {
              var St = ze.alternate;
              St ? (ze.updateQueue = St.updateQueue, ze.memoizedState = St.memoizedState, ze.expirationTime = St.expirationTime) : (ze.updateQueue = null, ze.memoizedState = null);
            }
            var tr = (zr.current & 1) !== 0, ar = He;
            do {
              var $r;
              if ($r = ar.tag === 13) {
                var Mr = ar.memoizedState;
                if (Mr !== null) $r = Mr.dehydrated !== null;
                else {
                  var vn = ar.memoizedProps;
                  $r = vn.fallback === void 0 ? !1 : vn.unstable_avoidThisFallback !== !0 ? !0 : !tr;
                }
              }
              if ($r) {
                var Jr = ar.updateQueue;
                if (Jr === null) {
                  var xt = /* @__PURE__ */ new Set();
                  xt.add(wt), ar.updateQueue = xt;
                } else Jr.add(wt);
                if ((ar.mode & 2) === 0) {
                  if (ar.effectTag |= 64, ze.effectTag &= -2981, ze.tag === 1) if (ze.alternate === null) ze.tag = 17;
                  else {
                    var gt = Un(1073741823, null);
                    gt.tag = 2, zn(ze, gt);
                  }
                  ze.expirationTime = 1073741823;
                  break e;
                }
                Ze = void 0, ze = re;
                var Rt = Pe.pingCache;
                if (Rt === null ? (Rt = Pe.pingCache = new Wc(), Ze = /* @__PURE__ */ new Set(), Rt.set(wt, Ze)) : (Ze = Rt.get(wt), Ze === void 0 && (Ze = /* @__PURE__ */ new Set(), Rt.set(wt, Ze))), !Ze.has(ze)) {
                  Ze.add(ze);
                  var Wt = Zc.bind(null, Pe, wt, ze);
                  wt.then(Wt, Wt);
                }
                ar.effectTag |= 4096, ar.expirationTime = re;
                break e;
              }
              ar = ar.return;
            } while (ar !== null);
            Ze = Error((Oe(ze.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.` + Me(ze));
          }
          Zr !== Do && (Zr = _l), Ze = Ro(Ze, ze), ar = He;
          do {
            switch (ar.tag) {
              case 3:
                wt = Ze, ar.effectTag |= 4096, ar.expirationTime = re;
                var Zt = Sl(ar, wt, re);
                Ns(ar, Zt);
                break e;
              case 1:
                wt = Ze;
                var ir = ar.type, hr = ar.stateNode;
                if ((ar.effectTag & 64) === 0 && (typeof ir.getDerivedStateFromError == "function" || hr !== null && typeof hr.componentDidCatch == "function" && (Gn === null || !Gn.has(hr)))) {
                  ar.effectTag |= 4096, ar.expirationTime = re;
                  var Br = $l(ar, wt, re);
                  Ns(ar, Br);
                  break e;
                }
            }
            ar = ar.return;
          } while (ar !== null);
        }
        Cr = Fl(Cr);
      } catch (Ur) {
        re = Ur;
        continue;
      }
      break;
    } while (!0);
  }
  function Ml() {
    var z = Ei.current;
    return Ei.current = xi, z === null ? xi : z;
  }
  function kl(z, re) {
    z < kn && 2 < z && (kn = z), re !== null && z < Ha && 2 < z && (Ha = z, _i = re);
  }
  function ki(z) {
    z > Ua && (Ua = z);
  }
  function Qc() {
    for (; Cr !== null; ) Cr = Dl(Cr);
  }
  function Yc() {
    for (; Cr !== null && !Bc(); ) Cr = Dl(Cr);
  }
  function Dl(z) {
    var re = Nl(z.alternate, z, ln);
    return z.memoizedProps = z.pendingProps, re === null && (re = Fl(z)), Il.current = null, re;
  }
  function Fl(z) {
    Cr = z;
    do {
      var re = Cr.alternate;
      if (z = Cr.return, (Cr.effectTag & 2048) === 0) {
        if (re = Lc(re, Cr, ln), ln === 1 || Cr.childExpirationTime !== 1) {
          for (var de = 0, Se = Cr.child; Se !== null; ) {
            var Pe = Se.expirationTime, He = Se.childExpirationTime;
            Pe > de && (de = Pe), He > de && (de = He), Se = Se.sibling;
          }
          Cr.childExpirationTime = de;
        }
        if (re !== null) return re;
        z !== null && (z.effectTag & 2048) === 0 && (z.firstEffect === null && (z.firstEffect = Cr.firstEffect), Cr.lastEffect !== null && (z.lastEffect !== null && (z.lastEffect.nextEffect = Cr.firstEffect), z.lastEffect = Cr.lastEffect), 1 < Cr.effectTag && (z.lastEffect !== null ? z.lastEffect.nextEffect = Cr : z.firstEffect = Cr, z.lastEffect = Cr));
      } else {
        if (re = Nc(Cr), re !== null) return re.effectTag &= 2047, re;
        z !== null && (z.firstEffect = z.lastEffect = null, z.effectTag |= 2048);
      }
      if (re = Cr.sibling, re !== null) return re;
      Cr = z;
    } while (Cr !== null);
    return Zr === na && (Zr = Do), null;
  }
  function Ho(z) {
    var re = z.expirationTime;
    return z = z.childExpirationTime, re > z ? re : z;
  }
  function sa(z) {
    var re = ai();
    return jn(99, qc.bind(null, z, re)), null;
  }
  function qc(z, re) {
    do
      Ea();
    while (za !== null);
    if ((vr & (xn | Sn)) !== Xr) throw Error(u(327));
    var de = z.finishedWork, Se = z.finishedExpirationTime;
    if (de === null) return null;
    if (z.finishedWork = null, z.finishedExpirationTime = 0, de === z.current) throw Error(u(177));
    z.callbackNode = null, z.callbackExpirationTime = 0, z.callbackPriority = 90, z.nextKnownPendingLevel = 0;
    var Pe = Ho(de);
    if (z.firstPendingTime = Pe, Se <= z.lastSuspendedTime ? z.firstSuspendedTime = z.lastSuspendedTime = z.nextKnownPendingLevel = 0 : Se <= z.firstSuspendedTime && (z.firstSuspendedTime = Se - 1), Se <= z.lastPingedTime && (z.lastPingedTime = 0), Se <= z.lastExpiredTime && (z.lastExpiredTime = 0), z === hn && (Cr = hn = null, ln = 0), 1 < de.effectTag ? de.lastEffect !== null ? (de.lastEffect.nextEffect = de, Pe = de.firstEffect) : Pe = de : Pe = de.firstEffect, Pe !== null) {
      var He = vr;
      vr |= Sn, Il.current = null, Ui = Kt;
      var ze = Kn();
      if (Ni(ze)) {
        if ("selectionStart" in ze) var Ze = { start: ze.selectionStart, end: ze.selectionEnd };
        else e: {
          Ze = (Ze = ze.ownerDocument) && Ze.defaultView || window;
          var wt = Ze.getSelection && Ze.getSelection();
          if (wt && wt.rangeCount !== 0) {
            Ze = wt.anchorNode;
            var St = wt.anchorOffset, tr = wt.focusNode;
            wt = wt.focusOffset;
            try {
              Ze.nodeType, tr.nodeType;
            } catch {
              Ze = null;
              break e;
            }
            var ar = 0, $r = -1, Mr = -1, vn = 0, Jr = 0, xt = ze, gt = null;
            t: for (; ; ) {
              for (var Rt; xt !== Ze || St !== 0 && xt.nodeType !== 3 || ($r = ar + St), xt !== tr || wt !== 0 && xt.nodeType !== 3 || (Mr = ar + wt), xt.nodeType === 3 && (ar += xt.nodeValue.length), (Rt = xt.firstChild) !== null; )
                gt = xt, xt = Rt;
              for (; ; ) {
                if (xt === ze) break t;
                if (gt === Ze && ++vn === St && ($r = ar), gt === tr && ++Jr === wt && (Mr = ar), (Rt = xt.nextSibling) !== null) break;
                xt = gt, gt = xt.parentNode;
              }
              xt = Rt;
            }
            Ze = $r === -1 || Mr === -1 ? null : { start: $r, end: Mr };
          } else Ze = null;
        }
        Ze = Ze || { start: 0, end: 0 };
      } else Ze = null;
      zi = { activeElementDetached: null, focusedElem: ze, selectionRange: Ze }, Kt = !1, or = Pe;
      do
        try {
          Kc();
        } catch (Er) {
          if (or === null) throw Error(u(330));
          la(or, Er), or = or.nextEffect;
        }
      while (or !== null);
      or = Pe;
      do
        try {
          for (ze = z, Ze = re; or !== null; ) {
            var Wt = or.effectTag;
            if (Wt & 16 && Et(or.stateNode, ""), Wt & 128) {
              var Zt = or.alternate;
              if (Zt !== null) {
                var ir = Zt.ref;
                ir !== null && (typeof ir == "function" ? ir(null) : ir.current = null);
              }
            }
            switch (Wt & 1038) {
              case 2:
                Cl(or), or.effectTag &= -3;
                break;
              case 6:
                Cl(or), or.effectTag &= -3, Mo(or.alternate, or);
                break;
              case 1024:
                or.effectTag &= -1025;
                break;
              case 1028:
                or.effectTag &= -1025, Mo(or.alternate, or);
                break;
              case 4:
                Mo(or.alternate, or);
                break;
              case 8:
                St = or, El(ze, St, Ze), xl(St);
            }
            or = or.nextEffect;
          }
        } catch (Er) {
          if (or === null) throw Error(u(330));
          la(or, Er), or = or.nextEffect;
        }
      while (or !== null);
      if (ir = zi, Zt = Kn(), Wt = ir.focusedElem, Ze = ir.selectionRange, Zt !== Wt && Wt && Wt.ownerDocument && Qa(Wt.ownerDocument.documentElement, Wt)) {
        for (Ze !== null && Ni(Wt) && (Zt = Ze.start, ir = Ze.end, ir === void 0 && (ir = Zt), "selectionStart" in Wt ? (Wt.selectionStart = Zt, Wt.selectionEnd = Math.min(ir, Wt.value.length)) : (ir = (Zt = Wt.ownerDocument || document) && Zt.defaultView || window, ir.getSelection && (ir = ir.getSelection(), St = Wt.textContent.length, ze = Math.min(Ze.start, St), Ze = Ze.end === void 0 ? ze : Math.min(Ze.end, St), !ir.extend && ze > Ze && (St = Ze, Ze = ze, ze = St), St = Tn(Wt, ze), tr = Tn(Wt, Ze), St && tr && (ir.rangeCount !== 1 || ir.anchorNode !== St.node || ir.anchorOffset !== St.offset || ir.focusNode !== tr.node || ir.focusOffset !== tr.offset) && (Zt = Zt.createRange(), Zt.setStart(St.node, St.offset), ir.removeAllRanges(), ze > Ze ? (ir.addRange(Zt), ir.extend(tr.node, tr.offset)) : (Zt.setEnd(tr.node, tr.offset), ir.addRange(Zt)))))), Zt = [], ir = Wt; ir = ir.parentNode; ) ir.nodeType === 1 && Zt.push({
          element: ir,
          left: ir.scrollLeft,
          top: ir.scrollTop
        });
        for (typeof Wt.focus == "function" && Wt.focus(), Wt = 0; Wt < Zt.length; Wt++) ir = Zt[Wt], ir.element.scrollLeft = ir.left, ir.element.scrollTop = ir.top;
      }
      Kt = !!Ui, zi = Ui = null, z.current = de, or = Pe;
      do
        try {
          for (Wt = z; or !== null; ) {
            var hr = or.effectTag;
            if (hr & 36 && zc(Wt, or.alternate, or), hr & 128) {
              Zt = void 0;
              var Br = or.ref;
              if (Br !== null) {
                var Ur = or.stateNode;
                switch (or.tag) {
                  case 5:
                    Zt = Ur;
                    break;
                  default:
                    Zt = Ur;
                }
                typeof Br == "function" ? Br(Zt) : Br.current = Zt;
              }
            }
            or = or.nextEffect;
          }
        } catch (Er) {
          if (or === null) throw Error(u(330));
          la(or, Er), or = or.nextEffect;
        }
      while (or !== null);
      or = null, Oc(), vr = He;
    } else z.current = de;
    if (Pi) Pi = !1, za = z, Wa = re;
    else for (or = Pe; or !== null; ) re = or.nextEffect, or.nextEffect = null, or = re;
    if (re = z.firstPendingTime, re === 0 && (Gn = null), re === 1073741823 ? z === No ? Va++ : (Va = 0, No = z) : Va = 0, typeof Uo == "function" && Uo(de.stateNode, Se), pn(z), Ri) throw Ri = !1, z = Lo, Lo = null, z;
    return (vr & ko) !== Xr || Cn(), null;
  }
  function Kc() {
    for (; or !== null; ) {
      var z = or.effectTag;
      (z & 256) !== 0 && Uc(or.alternate, or), (z & 512) === 0 || Pi || (Pi = !0, ks(97, function() {
        return Ea(), null;
      })), or = or.nextEffect;
    }
  }
  function Ea() {
    if (Wa !== 90) {
      var z = 97 < Wa ? 97 : Wa;
      return Wa = 90, jn(z, Xc);
    }
  }
  function Xc() {
    if (za === null) return !1;
    var z = za;
    if (za = null, (vr & (xn | Sn)) !== Xr) throw Error(u(331));
    var re = vr;
    for (vr |= Sn, z = z.current.firstEffect; z !== null; ) {
      try {
        var de = z;
        if ((de.effectTag & 512) !== 0) switch (de.tag) {
          case 0:
          case 11:
          case 15:
          case 22:
            Al(5, de), vl(5, de);
        }
      } catch (Se) {
        if (z === null) throw Error(u(330));
        la(z, Se);
      }
      de = z.nextEffect, z.nextEffect = null, z = de;
    }
    return vr = re, Cn(), !0;
  }
  function Ll(z, re, de) {
    re = Ro(de, re), re = Sl(z, re, 1073741823), zn(z, re), z = Oi(z, 1073741823), z !== null && pn(z);
  }
  function la(z, re) {
    if (z.tag === 3) Ll(z, z, re);
    else for (var de = z.return; de !== null; ) {
      if (de.tag === 3) {
        Ll(de, z, re);
        break;
      } else if (de.tag === 1) {
        var Se = de.stateNode;
        if (typeof de.type.getDerivedStateFromError == "function" || typeof Se.componentDidCatch == "function" && (Gn === null || !Gn.has(Se))) {
          z = Ro(re, z), z = $l(de, z, 1073741823), zn(de, z), de = Oi(de, 1073741823), de !== null && pn(de);
          break;
        }
      }
      de = de.return;
    }
  }
  function Zc(z, re, de) {
    var Se = z.pingCache;
    Se !== null && Se.delete(re), hn === z && ln === de ? Zr === $i || Zr === Si && kn === 1073741823 && gn() - Fo < Tl ? oa(z, ln) : Ti = !0 : jl(z, de) && (re = z.lastPingedTime, re !== 0 && re < de || (z.lastPingedTime = de, pn(z)));
  }
  function Jc(z, re) {
    var de = z.stateNode;
    de !== null && de.delete(re), re = 0, re === 0 && (re = $n(), re = ia(re, z, null)), z = Oi(z, re), z !== null && pn(z);
  }
  var Nl;
  Nl = function(z, re, de) {
    var Se = re.expirationTime;
    if (z !== null) {
      var Pe = re.pendingProps;
      if (z.memoizedProps !== Pe || on.current) wn = !0;
      else {
        if (Se < de) {
          switch (wn = !1, re.tag) {
            case 3:
              cl(re), wo();
              break;
            case 5:
              if (Gs(re), re.mode & 4 && de !== 1 && Pe.hidden) return re.expirationTime = re.childExpirationTime = 1, null;
              break;
            case 1:
              sn(re.type) && ti(re);
              break;
            case 4:
              fo(re, re.stateNode.containerInfo);
              break;
            case 10:
              Se = re.memoizedProps.value, Pe = re.type._context, Gr(oi, Pe._currentValue), Pe._currentValue = Se;
              break;
            case 13:
              if (re.memoizedState !== null)
                return Se = re.child.childExpirationTime, Se !== 0 && Se >= de ? ul(z, re, de) : (Gr(zr, zr.current & 1), re = Mn(z, re, de), re !== null ? re.sibling : null);
              Gr(zr, zr.current & 1);
              break;
            case 19:
              if (Se = re.childExpirationTime >= de, (z.effectTag & 64) !== 0) {
                if (Se) return fl(z, re, de);
                re.effectTag |= 64;
              }
              if (Pe = re.memoizedState, Pe !== null && (Pe.rendering = null, Pe.tail = null), Gr(zr, zr.current), !Se) return null;
          }
          return Mn(z, re, de);
        }
        wn = !1;
      }
    } else wn = !1;
    switch (re.expirationTime = 0, re.tag) {
      case 2:
        if (Se = re.type, z !== null && (z.alternate = null, re.alternate = null, re.effectTag |= 2), z = re.pendingProps, Pe = ma(re, en.current), va(re, de), Pe = mo(
          null,
          re,
          Se,
          z,
          Pe,
          de
        ), re.effectTag |= 1, typeof Pe == "object" && Pe !== null && typeof Pe.render == "function" && Pe.$$typeof === void 0) {
          if (re.tag = 1, re.memoizedState = null, re.updateQueue = null, sn(Se)) {
            var He = !0;
            ti(re);
          } else He = !1;
          re.memoizedState = Pe.state !== null && Pe.state !== void 0 ? Pe.state : null, so(re);
          var ze = Se.getDerivedStateFromProps;
          typeof ze == "function" && ci(re, Se, ze, z), Pe.updater = ui, re.stateNode = Pe, Pe._reactInternalFiber = re, co(re, Se, z, de), re = $o(null, re, Se, !0, He, de);
        } else re.tag = 0, fn(null, re, Pe, de), re = re.child;
        return re;
      case 16:
        e: {
          if (Pe = re.elementType, z !== null && (z.alternate = null, re.alternate = null, re.effectTag |= 2), z = re.pendingProps, Be(Pe), Pe._status !== 1) throw Pe._result;
          switch (Pe = Pe._result, re.type = Pe, He = re.tag = ru(Pe), z = bn(Pe, z), He) {
            case 0:
              re = So(null, re, Pe, z, de);
              break e;
            case 1:
              re = ll(null, re, Pe, z, de);
              break e;
            case 11:
              re = al(null, re, Pe, z, de);
              break e;
            case 14:
              re = il(null, re, Pe, bn(Pe.type, z), Se, de);
              break e;
          }
          throw Error(u(306, Pe, ""));
        }
        return re;
      case 0:
        return Se = re.type, Pe = re.pendingProps, Pe = re.elementType === Se ? Pe : bn(Se, Pe), So(z, re, Se, Pe, de);
      case 1:
        return Se = re.type, Pe = re.pendingProps, Pe = re.elementType === Se ? Pe : bn(Se, Pe), ll(z, re, Se, Pe, de);
      case 3:
        if (cl(re), Se = re.updateQueue, z === null || Se === null) throw Error(u(282));
        if (Se = re.pendingProps, Pe = re.memoizedState, Pe = Pe !== null ? Pe.element : null, lo(z, re), ka(re, Se, null, de), Se = re.memoizedState.element, Se === Pe) wo(), re = Mn(z, re, de);
        else {
          if ((Pe = re.stateNode.hydrate) && (Vn = da(re.stateNode.containerInfo.firstChild), On = re, Pe = ra = !0), Pe) for (de = uo(re, null, Se, de), re.child = de; de; ) de.effectTag = de.effectTag & -3 | 1024, de = de.sibling;
          else fn(z, re, Se, de), wo();
          re = re.child;
        }
        return re;
      case 5:
        return Gs(re), z === null && Eo(re), Se = re.type, Pe = re.pendingProps, He = z !== null ? z.memoizedProps : null, ze = Pe.children, Wi(Se, Pe) ? ze = null : He !== null && Wi(Se, He) && (re.effectTag |= 16), sl(z, re), re.mode & 4 && de !== 1 && Pe.hidden ? (re.expirationTime = re.childExpirationTime = 1, re = null) : (fn(z, re, ze, de), re = re.child), re;
      case 6:
        return z === null && Eo(re), null;
      case 13:
        return ul(z, re, de);
      case 4:
        return fo(re, re.stateNode.containerInfo), Se = re.pendingProps, z === null ? re.child = ba(re, null, Se, de) : fn(z, re, Se, de), re.child;
      case 11:
        return Se = re.type, Pe = re.pendingProps, Pe = re.elementType === Se ? Pe : bn(Se, Pe), al(z, re, Se, Pe, de);
      case 7:
        return fn(z, re, re.pendingProps, de), re.child;
      case 8:
        return fn(
          z,
          re,
          re.pendingProps.children,
          de
        ), re.child;
      case 12:
        return fn(z, re, re.pendingProps.children, de), re.child;
      case 10:
        e: {
          Se = re.type._context, Pe = re.pendingProps, ze = re.memoizedProps, He = Pe.value;
          var Ze = re.type._context;
          if (Gr(oi, Ze._currentValue), Ze._currentValue = He, ze !== null) if (Ze = ze.value, He = Zn(Ze, He) ? 0 : (typeof Se._calculateChangedBits == "function" ? Se._calculateChangedBits(Ze, He) : 1073741823) | 0, He === 0) {
            if (ze.children === Pe.children && !on.current) {
              re = Mn(z, re, de);
              break e;
            }
          } else for (Ze = re.child, Ze !== null && (Ze.return = re); Ze !== null; ) {
            var wt = Ze.dependencies;
            if (wt !== null) {
              ze = Ze.child;
              for (var St = wt.firstContext; St !== null; ) {
                if (St.context === Se && (St.observedBits & He) !== 0) {
                  Ze.tag === 1 && (St = Un(de, null), St.tag = 2, zn(Ze, St)), Ze.expirationTime < de && (Ze.expirationTime = de), St = Ze.alternate, St !== null && St.expirationTime < de && (St.expirationTime = de), Ls(Ze.return, de), wt.expirationTime < de && (wt.expirationTime = de);
                  break;
                }
                St = St.next;
              }
            } else ze = Ze.tag === 10 && Ze.type === re.type ? null : Ze.child;
            if (ze !== null) ze.return = Ze;
            else for (ze = Ze; ze !== null; ) {
              if (ze === re) {
                ze = null;
                break;
              }
              if (Ze = ze.sibling, Ze !== null) {
                Ze.return = ze.return, ze = Ze;
                break;
              }
              ze = ze.return;
            }
            Ze = ze;
          }
          fn(z, re, Pe.children, de), re = re.child;
        }
        return re;
      case 9:
        return Pe = re.type, He = re.pendingProps, Se = He.children, va(re, de), Pe = mn(Pe, He.unstable_observedBits), Se = Se(Pe), re.effectTag |= 1, fn(z, re, Se, de), re.child;
      case 14:
        return Pe = re.type, He = bn(Pe, re.pendingProps), He = bn(Pe.type, He), il(z, re, Pe, He, Se, de);
      case 15:
        return ol(z, re, re.type, re.pendingProps, Se, de);
      case 17:
        return Se = re.type, Pe = re.pendingProps, Pe = re.elementType === Se ? Pe : bn(Se, Pe), z !== null && (z.alternate = null, re.alternate = null, re.effectTag |= 2), re.tag = 1, sn(Se) ? (z = !0, ti(re)) : z = !1, va(re, de), zs(re, Se, Pe), co(re, Se, Pe, de), $o(
          null,
          re,
          Se,
          !0,
          z,
          de
        );
      case 19:
        return fl(z, re, de);
    }
    throw Error(u(156, re.tag));
  };
  var Uo = null, zo = null;
  function eu(z) {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
    var re = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (re.isDisabled || !re.supportsFiber) return !0;
    try {
      var de = re.inject(z);
      Uo = function(Se) {
        try {
          re.onCommitFiberRoot(de, Se, void 0, (Se.current.effectTag & 64) === 64);
        } catch {
        }
      }, zo = function(Se) {
        try {
          re.onCommitFiberUnmount(de, Se);
        } catch {
        }
      };
    } catch {
    }
    return !0;
  }
  function tu(z, re, de, Se) {
    this.tag = z, this.key = de, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = re, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = Se, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
  }
  function In(z, re, de, Se) {
    return new tu(z, re, de, Se);
  }
  function Wo(z) {
    return z = z.prototype, !(!z || !z.isReactComponent);
  }
  function ru(z) {
    if (typeof z == "function") return Wo(z) ? 1 : 0;
    if (z != null) {
      if (z = z.$$typeof, z === Ae) return 11;
      if (z === Ee) return 14;
    }
    return 2;
  }
  function ca(z, re) {
    var de = z.alternate;
    return de === null ? (de = In(z.tag, re, z.key, z.mode), de.elementType = z.elementType, de.type = z.type, de.stateNode = z.stateNode, de.alternate = z, z.alternate = de) : (de.pendingProps = re, de.effectTag = 0, de.nextEffect = null, de.firstEffect = null, de.lastEffect = null), de.childExpirationTime = z.childExpirationTime, de.expirationTime = z.expirationTime, de.child = z.child, de.memoizedProps = z.memoizedProps, de.memoizedState = z.memoizedState, de.updateQueue = z.updateQueue, re = z.dependencies, de.dependencies = re === null ? null : {
      expirationTime: re.expirationTime,
      firstContext: re.firstContext,
      responders: re.responders
    }, de.sibling = z.sibling, de.index = z.index, de.ref = z.ref, de;
  }
  function Di(z, re, de, Se, Pe, He) {
    var ze = 2;
    if (Se = z, typeof z == "function") Wo(z) && (ze = 1);
    else if (typeof z == "string") ze = 5;
    else e: switch (z) {
      case he:
        return Yn(de.children, Pe, He, re);
      case $e:
        ze = 8, Pe |= 7;
        break;
      case ye:
        ze = 8, Pe |= 1;
        break;
      case Ce:
        return z = In(12, de, re, Pe | 8), z.elementType = Ce, z.type = Ce, z.expirationTime = He, z;
      case ue:
        return z = In(13, de, re, Pe), z.type = ue, z.elementType = ue, z.expirationTime = He, z;
      case ce:
        return z = In(19, de, re, Pe), z.elementType = ce, z.expirationTime = He, z;
      default:
        if (typeof z == "object" && z !== null) switch (z.$$typeof) {
          case xe:
            ze = 10;
            break e;
          case we:
            ze = 9;
            break e;
          case Ae:
            ze = 11;
            break e;
          case Ee:
            ze = 14;
            break e;
          case _e:
            ze = 16, Se = null;
            break e;
          case Te:
            ze = 22;
            break e;
        }
        throw Error(u(130, z == null ? z : typeof z, ""));
    }
    return re = In(ze, de, re, Pe), re.elementType = z, re.type = Se, re.expirationTime = He, re;
  }
  function Yn(z, re, de, Se) {
    return z = In(7, z, Se, re), z.expirationTime = de, z;
  }
  function Vo(z, re, de) {
    return z = In(6, z, null, re), z.expirationTime = de, z;
  }
  function Go(z, re, de) {
    return re = In(4, z.children !== null ? z.children : [], z.key, re), re.expirationTime = de, re.stateNode = { containerInfo: z.containerInfo, pendingChildren: null, implementation: z.implementation }, re;
  }
  function nu(z, re, de) {
    this.tag = re, this.current = null, this.containerInfo = z, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = de, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
  }
  function jl(z, re) {
    var de = z.firstSuspendedTime;
    return z = z.lastSuspendedTime, de !== 0 && de >= re && z <= re;
  }
  function ua(z, re) {
    var de = z.firstSuspendedTime, Se = z.lastSuspendedTime;
    de < re && (z.firstSuspendedTime = re), (Se > re || de === 0) && (z.lastSuspendedTime = re), re <= z.lastPingedTime && (z.lastPingedTime = 0), re <= z.lastExpiredTime && (z.lastExpiredTime = 0);
  }
  function Hl(z, re) {
    re > z.firstPendingTime && (z.firstPendingTime = re);
    var de = z.firstSuspendedTime;
    de !== 0 && (re >= de ? z.firstSuspendedTime = z.lastSuspendedTime = z.nextKnownPendingLevel = 0 : re >= z.lastSuspendedTime && (z.lastSuspendedTime = re + 1), re > z.nextKnownPendingLevel && (z.nextKnownPendingLevel = re));
  }
  function Qo(z, re) {
    var de = z.lastExpiredTime;
    (de === 0 || de > re) && (z.lastExpiredTime = re);
  }
  function Fi(z, re, de, Se) {
    var Pe = re.current, He = $n(), ze = Da.suspense;
    He = ia(He, Pe, ze);
    e: if (de) {
      de = de._reactInternalFiber;
      t: {
        if (Ct(de) !== de || de.tag !== 1) throw Error(u(170));
        var Ze = de;
        do {
          switch (Ze.tag) {
            case 3:
              Ze = Ze.stateNode.context;
              break t;
            case 1:
              if (sn(Ze.type)) {
                Ze = Ze.stateNode.__reactInternalMemoizedMergedChildContext;
                break t;
              }
          }
          Ze = Ze.return;
        } while (Ze !== null);
        throw Error(u(171));
      }
      if (de.tag === 1) {
        var wt = de.type;
        if (sn(wt)) {
          de = ws(de, wt, Ze);
          break e;
        }
      }
      de = Ze;
    } else de = Nn;
    return re.context === null ? re.context = de : re.pendingContext = de, re = Un(He, ze), re.payload = { element: z }, Se = Se === void 0 ? null : Se, Se !== null && (re.callback = Se), zn(Pe, re), Qn(Pe, He), He;
  }
  function Yo(z) {
    if (z = z.current, !z.child) return null;
    switch (z.child.tag) {
      case 5:
        return z.child.stateNode;
      default:
        return z.child.stateNode;
    }
  }
  function Ul(z, re) {
    z = z.memoizedState, z !== null && z.dehydrated !== null && z.retryTime < re && (z.retryTime = re);
  }
  function qo(z, re) {
    Ul(z, re), (z = z.alternate) && Ul(z, re);
  }
  function Ko(z, re, de) {
    de = de != null && de.hydrate === !0;
    var Se = new nu(z, re, de), Pe = In(3, null, null, re === 2 ? 7 : re === 1 ? 3 : 0);
    Se.current = Pe, Pe.stateNode = Se, so(Pe), z[wa] = Se.current, de && re !== 0 && lr(z, z.nodeType === 9 ? z : z.ownerDocument), this._internalRoot = Se;
  }
  Ko.prototype.render = function(z) {
    Fi(z, this._internalRoot, null, null);
  }, Ko.prototype.unmount = function() {
    var z = this._internalRoot, re = z.containerInfo;
    Fi(null, z, null, function() {
      re[wa] = null;
    });
  };
  function Ga(z) {
    return !(!z || z.nodeType !== 1 && z.nodeType !== 9 && z.nodeType !== 11 && (z.nodeType !== 8 || z.nodeValue !== " react-mount-point-unstable "));
  }
  function au(z, re) {
    if (re || (re = z ? z.nodeType === 9 ? z.documentElement : z.firstChild : null, re = !(!re || re.nodeType !== 1 || !re.hasAttribute("data-reactroot"))), !re) for (var de; de = z.lastChild; ) z.removeChild(de);
    return new Ko(z, 0, re ? { hydrate: !0 } : void 0);
  }
  function Li(z, re, de, Se, Pe) {
    var He = de._reactRootContainer;
    if (He) {
      var ze = He._internalRoot;
      if (typeof Pe == "function") {
        var Ze = Pe;
        Pe = function() {
          var St = Yo(ze);
          Ze.call(St);
        };
      }
      Fi(re, ze, z, Pe);
    } else {
      if (He = de._reactRootContainer = au(de, Se), ze = He._internalRoot, typeof Pe == "function") {
        var wt = Pe;
        Pe = function() {
          var St = Yo(ze);
          wt.call(St);
        };
      }
      Bl(function() {
        Fi(re, ze, z, Pe);
      });
    }
    return Yo(ze);
  }
  function iu(z, re, de) {
    var Se = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ve, key: Se == null ? null : "" + Se, children: z, containerInfo: re, implementation: de };
  }
  ur = function(z) {
    if (z.tag === 13) {
      var re = ii($n(), 150, 100);
      Qn(z, re), qo(z, re);
    }
  }, Qt = function(z) {
    z.tag === 13 && (Qn(z, 3), qo(z, 3));
  }, Yt = function(z) {
    if (z.tag === 13) {
      var re = $n();
      re = ia(re, z, null), Qn(z, re), qo(z, re);
    }
  }, F = function(z, re, de) {
    switch (re) {
      case "input":
        if (nt(z, de), re = de.name, de.type === "radio" && re != null) {
          for (de = z; de.parentNode; ) de = de.parentNode;
          for (de = de.querySelectorAll("input[name=" + JSON.stringify("" + re) + '][type="radio"]'), re = 0; re < de.length; re++) {
            var Se = de[re];
            if (Se !== z && Se.form === z.form) {
              var Pe = Qi(Se);
              if (!Pe) throw Error(u(90));
              De(Se), nt(Se, Pe);
            }
          }
        }
        break;
      case "textarea":
        st(z, de);
        break;
      case "select":
        re = de.value, re != null && ut(z, !!de.multiple, re, !1);
    }
  }, k = Pl, N = function(z, re, de, Se, Pe) {
    var He = vr;
    vr |= 4;
    try {
      return jn(98, z.bind(null, re, de, Se, Pe));
    } finally {
      vr = He, vr === Xr && Cn();
    }
  }, P = function() {
    (vr & (1 | xn | Sn)) === Xr && (Gc(), Ea());
  }, D = function(z, re) {
    var de = vr;
    vr |= 2;
    try {
      return z(re);
    } finally {
      vr = de, vr === Xr && Cn();
    }
  };
  function zl(z, re) {
    var de = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Ga(re)) throw Error(u(200));
    return iu(z, re, null, de);
  }
  var ou = { Events: [$a, Xn, Qi, L, E, fa, function(z) {
    $t(z, Ql);
  }, G, U, Pr, Vt, Ea, { current: !1 }] };
  return function(z) {
    var re = z.findFiberByHostInstance;
    return eu(s({}, z, { overrideHookState: null, overrideProps: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ge.ReactCurrentDispatcher, findHostInstanceByFiber: function(de) {
      return de = It(de), de === null ? null : de.stateNode;
    }, findFiberByHostInstance: function(de) {
      return re ? re(de) : null;
    }, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null }));
  }({
    findFiberByHostInstance: Sa,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
  }), reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ou, reactDom_production_min.createPortal = zl, reactDom_production_min.findDOMNode = function(z) {
    if (z == null) return null;
    if (z.nodeType === 1) return z;
    var re = z._reactInternalFiber;
    if (re === void 0)
      throw typeof z.render == "function" ? Error(u(188)) : Error(u(268, Object.keys(z)));
    return z = It(re), z = z === null ? null : z.stateNode, z;
  }, reactDom_production_min.flushSync = function(z, re) {
    if ((vr & (xn | Sn)) !== Xr) throw Error(u(187));
    var de = vr;
    vr |= 1;
    try {
      return jn(99, z.bind(null, re));
    } finally {
      vr = de, Cn();
    }
  }, reactDom_production_min.hydrate = function(z, re, de) {
    if (!Ga(re)) throw Error(u(200));
    return Li(null, z, re, !0, de);
  }, reactDom_production_min.render = function(z, re, de) {
    if (!Ga(re)) throw Error(u(200));
    return Li(null, z, re, !1, de);
  }, reactDom_production_min.unmountComponentAtNode = function(z) {
    if (!Ga(z)) throw Error(u(40));
    return z._reactRootContainer ? (Bl(function() {
      Li(null, null, z, !1, function() {
        z._reactRootContainer = null, z[wa] = null;
      });
    }), !0) : !1;
  }, reactDom_production_min.unstable_batchedUpdates = Pl, reactDom_production_min.unstable_createPortal = function(z, re) {
    return zl(z, re, 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null);
  }, reactDom_production_min.unstable_renderSubtreeIntoContainer = function(z, re, de, Se) {
    if (!Ga(de)) throw Error(u(200));
    if (z == null || z._reactInternalFiber === void 0) throw Error(u(38));
    return Li(z, re, de, !1, Se);
  }, reactDom_production_min.version = "16.14.0", reactDom_production_min;
}
var hasRequiredReactDom;
function requireReactDom() {
  if (hasRequiredReactDom) return reactDom.exports;
  hasRequiredReactDom = 1;
  function a() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
      } catch (s) {
        console.error(s);
      }
  }
  return a(), reactDom.exports = requireReactDom_production_min(), reactDom.exports;
}
var reactDomExports = requireReactDom();
const ReactDOM = /* @__PURE__ */ getDefaultExportFromCjs(reactDomExports), ReactDOM$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: ReactDOM
}, [reactDomExports]), PDFME_VERSION = "x.x.x", PT_TO_PX_RATIO = 1.333, PT_TO_MM_RATIO = 0.3528, MM_TO_PT_RATIO = 2.8346, ZOOM = 3.7795275591, DEFAULT_FONT_NAME = "Roboto", DEFAULT_FONT_VALUE = "data:font/ttf;base64,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";
var util$1;
(function(a) {
  a.assertEqual = (d) => {
  };
  function s(d) {
  }
  a.assertIs = s;
  function c(d) {
    throw new Error();
  }
  a.assertNever = c, a.arrayToEnum = (d) => {
    const p = {};
    for (const v of d)
      p[v] = v;
    return p;
  }, a.getValidEnumValues = (d) => {
    const p = a.objectKeys(d).filter((A) => typeof d[d[A]] != "number"), v = {};
    for (const A of p)
      v[A] = d[A];
    return a.objectValues(v);
  }, a.objectValues = (d) => a.objectKeys(d).map(function(p) {
    return d[p];
  }), a.objectKeys = typeof Object.keys == "function" ? (d) => Object.keys(d) : (d) => {
    const p = [];
    for (const v in d)
      Object.prototype.hasOwnProperty.call(d, v) && p.push(v);
    return p;
  }, a.find = (d, p) => {
    for (const v of d)
      if (p(v))
        return v;
  }, a.isInteger = typeof Number.isInteger == "function" ? (d) => Number.isInteger(d) : (d) => typeof d == "number" && Number.isFinite(d) && Math.floor(d) === d;
  function u(d, p = " | ") {
    return d.map((v) => typeof v == "string" ? `'${v}'` : v).join(p);
  }
  a.joinValues = u, a.jsonStringifyReplacer = (d, p) => typeof p == "bigint" ? p.toString() : p;
})(util$1 || (util$1 = {}));
var objectUtil;
(function(a) {
  a.mergeShapes = (s, c) => ({
    ...s,
    ...c
    // second overwrites first
  });
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util$1.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), getParsedType = (a) => {
  switch (typeof a) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return Number.isNaN(a) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      return Array.isArray(a) ? ZodParsedType.array : a === null ? ZodParsedType.null : a.then && typeof a.then == "function" && a.catch && typeof a.catch == "function" ? ZodParsedType.promise : typeof Map < "u" && a instanceof Map ? ZodParsedType.map : typeof Set < "u" && a instanceof Set ? ZodParsedType.set : typeof Date < "u" && a instanceof Date ? ZodParsedType.date : ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
}, ZodIssueCode = util$1.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class ZodError extends Error {
  get errors() {
    return this.issues;
  }
  constructor(s) {
    super(), this.issues = [], this.addIssue = (u) => {
      this.issues = [...this.issues, u];
    }, this.addIssues = (u = []) => {
      this.issues = [...this.issues, ...u];
    };
    const c = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, c) : this.__proto__ = c, this.name = "ZodError", this.issues = s;
  }
  format(s) {
    const c = s || function(p) {
      return p.message;
    }, u = { _errors: [] }, d = (p) => {
      for (const v of p.issues)
        if (v.code === "invalid_union")
          v.unionErrors.map(d);
        else if (v.code === "invalid_return_type")
          d(v.returnTypeError);
        else if (v.code === "invalid_arguments")
          d(v.argumentsError);
        else if (v.path.length === 0)
          u._errors.push(c(v));
        else {
          let A = u, x = 0;
          for (; x < v.path.length; ) {
            const g = v.path[x];
            x === v.path.length - 1 ? (A[g] = A[g] || { _errors: [] }, A[g]._errors.push(c(v))) : A[g] = A[g] || { _errors: [] }, A = A[g], x++;
          }
        }
    };
    return d(this), u;
  }
  static assert(s) {
    if (!(s instanceof ZodError))
      throw new Error(`Not a ZodError: ${s}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util$1.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(s = (c) => c.message) {
    const c = {}, u = [];
    for (const d of this.issues)
      d.path.length > 0 ? (c[d.path[0]] = c[d.path[0]] || [], c[d.path[0]].push(s(d))) : u.push(s(d));
    return { formErrors: u, fieldErrors: c };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (a) => new ZodError(a);
const errorMap = (a, s) => {
  let c;
  switch (a.code) {
    case ZodIssueCode.invalid_type:
      a.received === ZodParsedType.undefined ? c = "Required" : c = `Expected ${a.expected}, received ${a.received}`;
      break;
    case ZodIssueCode.invalid_literal:
      c = `Invalid literal value, expected ${JSON.stringify(a.expected, util$1.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      c = `Unrecognized key(s) in object: ${util$1.joinValues(a.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      c = "Invalid input";
      break;
    case ZodIssueCode.invalid_union_discriminator:
      c = `Invalid discriminator value. Expected ${util$1.joinValues(a.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      c = `Invalid enum value. Expected ${util$1.joinValues(a.options)}, received '${a.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      c = "Invalid function arguments";
      break;
    case ZodIssueCode.invalid_return_type:
      c = "Invalid function return type";
      break;
    case ZodIssueCode.invalid_date:
      c = "Invalid date";
      break;
    case ZodIssueCode.invalid_string:
      typeof a.validation == "object" ? "includes" in a.validation ? (c = `Invalid input: must include "${a.validation.includes}"`, typeof a.validation.position == "number" && (c = `${c} at one or more positions greater than or equal to ${a.validation.position}`)) : "startsWith" in a.validation ? c = `Invalid input: must start with "${a.validation.startsWith}"` : "endsWith" in a.validation ? c = `Invalid input: must end with "${a.validation.endsWith}"` : util$1.assertNever(a.validation) : a.validation !== "regex" ? c = `Invalid ${a.validation}` : c = "Invalid";
      break;
    case ZodIssueCode.too_small:
      a.type === "array" ? c = `Array must contain ${a.exact ? "exactly" : a.inclusive ? "at least" : "more than"} ${a.minimum} element(s)` : a.type === "string" ? c = `String must contain ${a.exact ? "exactly" : a.inclusive ? "at least" : "over"} ${a.minimum} character(s)` : a.type === "number" ? c = `Number must be ${a.exact ? "exactly equal to " : a.inclusive ? "greater than or equal to " : "greater than "}${a.minimum}` : a.type === "date" ? c = `Date must be ${a.exact ? "exactly equal to " : a.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(a.minimum))}` : c = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      a.type === "array" ? c = `Array must contain ${a.exact ? "exactly" : a.inclusive ? "at most" : "less than"} ${a.maximum} element(s)` : a.type === "string" ? c = `String must contain ${a.exact ? "exactly" : a.inclusive ? "at most" : "under"} ${a.maximum} character(s)` : a.type === "number" ? c = `Number must be ${a.exact ? "exactly" : a.inclusive ? "less than or equal to" : "less than"} ${a.maximum}` : a.type === "bigint" ? c = `BigInt must be ${a.exact ? "exactly" : a.inclusive ? "less than or equal to" : "less than"} ${a.maximum}` : a.type === "date" ? c = `Date must be ${a.exact ? "exactly" : a.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(a.maximum))}` : c = "Invalid input";
      break;
    case ZodIssueCode.custom:
      c = "Invalid input";
      break;
    case ZodIssueCode.invalid_intersection_types:
      c = "Intersection results could not be merged";
      break;
    case ZodIssueCode.not_multiple_of:
      c = `Number must be a multiple of ${a.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      c = "Number must be finite";
      break;
    default:
      c = s.defaultError, util$1.assertNever(a);
  }
  return { message: c };
};
let overrideErrorMap = errorMap;
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (a) => {
  const { data: s, path: c, errorMaps: u, issueData: d } = a, p = [...c, ...d.path || []], v = {
    ...d,
    path: p
  };
  if (d.message !== void 0)
    return {
      ...d,
      path: p,
      message: d.message
    };
  let A = "";
  const x = u.filter((g) => !!g).slice().reverse();
  for (const g of x)
    A = g(v, { data: s, defaultError: A }).message;
  return {
    ...d,
    path: p,
    message: A
  };
};
function addIssueToContext(a, s) {
  const c = getErrorMap(), u = makeIssue({
    issueData: s,
    data: a.data,
    path: a.path,
    errorMaps: [
      a.common.contextualErrorMap,
      // contextual error map is first priority
      a.schemaErrorMap,
      // then schema-bound map if available
      c,
      // then global override map
      c === errorMap ? void 0 : errorMap
      // then global default map
    ].filter((d) => !!d)
  });
  a.common.issues.push(u);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(s, c) {
    const u = [];
    for (const d of c) {
      if (d.status === "aborted")
        return INVALID;
      d.status === "dirty" && s.dirty(), u.push(d.value);
    }
    return { status: s.value, value: u };
  }
  static async mergeObjectAsync(s, c) {
    const u = [];
    for (const d of c) {
      const p = await d.key, v = await d.value;
      u.push({
        key: p,
        value: v
      });
    }
    return ParseStatus.mergeObjectSync(s, u);
  }
  static mergeObjectSync(s, c) {
    const u = {};
    for (const d of c) {
      const { key: p, value: v } = d;
      if (p.status === "aborted" || v.status === "aborted")
        return INVALID;
      p.status === "dirty" && s.dirty(), v.status === "dirty" && s.dirty(), p.value !== "__proto__" && (typeof v.value < "u" || d.alwaysSet) && (u[p.value] = v.value);
    }
    return { status: s.value, value: u };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
}), DIRTY = (a) => ({ status: "dirty", value: a }), OK = (a) => ({ status: "valid", value: a }), isAborted = (a) => a.status === "aborted", isDirty = (a) => a.status === "dirty", isValid = (a) => a.status === "valid", isAsync = (a) => typeof Promise < "u" && a instanceof Promise;
var errorUtil;
(function(a) {
  a.errToObj = (s) => typeof s == "string" ? { message: s } : s || {}, a.toString = (s) => typeof s == "string" ? s : s?.message;
})(errorUtil || (errorUtil = {}));
class ParseInputLazyPath {
  constructor(s, c, u, d) {
    this._cachedPath = [], this.parent = s, this.data = c, this._path = u, this._key = d;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const handleResult = (a, s) => {
  if (isValid(s))
    return { success: !0, data: s.value };
  if (!a.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const c = new ZodError(a.common.issues);
      return this._error = c, this._error;
    }
  };
};
function processCreateParams(a) {
  if (!a)
    return {};
  const { errorMap: s, invalid_type_error: c, required_error: u, description: d } = a;
  if (s && (c || u))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return s ? { errorMap: s, description: d } : { errorMap: (v, A) => {
    const { message: x } = a;
    return v.code === "invalid_enum_value" ? { message: x ?? A.defaultError } : typeof A.data > "u" ? { message: x ?? u ?? A.defaultError } : v.code !== "invalid_type" ? { message: A.defaultError } : { message: x ?? c ?? A.defaultError };
  }, description: d };
}
class ZodType {
  get description() {
    return this._def.description;
  }
  _getType(s) {
    return getParsedType(s.data);
  }
  _getOrReturnCtx(s, c) {
    return c || {
      common: s.parent.common,
      data: s.data,
      parsedType: getParsedType(s.data),
      schemaErrorMap: this._def.errorMap,
      path: s.path,
      parent: s.parent
    };
  }
  _processInputParams(s) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: s.parent.common,
        data: s.data,
        parsedType: getParsedType(s.data),
        schemaErrorMap: this._def.errorMap,
        path: s.path,
        parent: s.parent
      }
    };
  }
  _parseSync(s) {
    const c = this._parse(s);
    if (isAsync(c))
      throw new Error("Synchronous parse encountered promise.");
    return c;
  }
  _parseAsync(s) {
    const c = this._parse(s);
    return Promise.resolve(c);
  }
  parse(s, c) {
    const u = this.safeParse(s, c);
    if (u.success)
      return u.data;
    throw u.error;
  }
  safeParse(s, c) {
    const u = {
      common: {
        issues: [],
        async: c?.async ?? !1,
        contextualErrorMap: c?.errorMap
      },
      path: c?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: s,
      parsedType: getParsedType(s)
    }, d = this._parseSync({ data: s, path: u.path, parent: u });
    return handleResult(u, d);
  }
  "~validate"(s) {
    const c = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: s,
      parsedType: getParsedType(s)
    };
    if (!this["~standard"].async)
      try {
        const u = this._parseSync({ data: s, path: [], parent: c });
        return isValid(u) ? {
          value: u.value
        } : {
          issues: c.common.issues
        };
      } catch (u) {
        u?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), c.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: s, path: [], parent: c }).then((u) => isValid(u) ? {
      value: u.value
    } : {
      issues: c.common.issues
    });
  }
  async parseAsync(s, c) {
    const u = await this.safeParseAsync(s, c);
    if (u.success)
      return u.data;
    throw u.error;
  }
  async safeParseAsync(s, c) {
    const u = {
      common: {
        issues: [],
        contextualErrorMap: c?.errorMap,
        async: !0
      },
      path: c?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: s,
      parsedType: getParsedType(s)
    }, d = this._parse({ data: s, path: u.path, parent: u }), p = await (isAsync(d) ? d : Promise.resolve(d));
    return handleResult(u, p);
  }
  refine(s, c) {
    const u = (d) => typeof c == "string" || typeof c > "u" ? { message: c } : typeof c == "function" ? c(d) : c;
    return this._refinement((d, p) => {
      const v = s(d), A = () => p.addIssue({
        code: ZodIssueCode.custom,
        ...u(d)
      });
      return typeof Promise < "u" && v instanceof Promise ? v.then((x) => x ? !0 : (A(), !1)) : v ? !0 : (A(), !1);
    });
  }
  refinement(s, c) {
    return this._refinement((u, d) => s(u) ? !0 : (d.addIssue(typeof c == "function" ? c(u, d) : c), !1));
  }
  _refinement(s) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement: s }
    });
  }
  superRefine(s) {
    return this._refinement(s);
  }
  constructor(s) {
    this.spa = this.safeParseAsync, this._def = s, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (c) => this["~validate"](c)
    };
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(s) {
    return ZodUnion.create([this, s], this._def);
  }
  and(s) {
    return ZodIntersection.create(this, s, this._def);
  }
  transform(s) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform: s }
    });
  }
  default(s) {
    const c = typeof s == "function" ? s : () => s;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: c,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(s) {
    const c = typeof s == "function" ? s : () => s;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: c,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(s) {
    const c = this.constructor;
    return new c({
      ...this._def,
      description: s
    });
  }
  pipe(s) {
    return ZodPipeline.create(this, s);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i, cuid2Regex = /^[0-9a-z]+$/, ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i, uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, nanoidRegex = /^[a-z0-9_-]{21}$/i, jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let emojiRegex;
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, dateRegexSource = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(a) {
  let s = "[0-5]\\d";
  a.precision ? s = `${s}\\.\\d{${a.precision}}` : a.precision == null && (s = `${s}(\\.\\d+)?`);
  const c = a.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${s})${c}`;
}
function timeRegex(a) {
  return new RegExp(`^${timeRegexSource(a)}$`);
}
function datetimeRegex(a) {
  let s = `${dateRegexSource}T${timeRegexSource(a)}`;
  const c = [];
  return c.push(a.local ? "Z?" : "Z"), a.offset && c.push("([+-]\\d{2}:?\\d{2})"), s = `${s}(${c.join("|")})`, new RegExp(`^${s}$`);
}
function isValidIP(a, s) {
  return !!((s === "v4" || !s) && ipv4Regex.test(a) || (s === "v6" || !s) && ipv6Regex.test(a));
}
function isValidJWT(a, s) {
  if (!jwtRegex.test(a))
    return !1;
  try {
    const [c] = a.split("."), u = c.replace(/-/g, "+").replace(/_/g, "/").padEnd(c.length + (4 - c.length % 4) % 4, "="), d = JSON.parse(atob(u));
    return !(typeof d != "object" || d === null || "typ" in d && d?.typ !== "JWT" || !d.alg || s && d.alg !== s);
  } catch {
    return !1;
  }
}
function isValidCidr(a, s) {
  return !!((s === "v4" || !s) && ipv4CidrRegex.test(a) || (s === "v6" || !s) && ipv6CidrRegex.test(a));
}
class ZodString extends ZodType {
  _parse(s) {
    if (this._def.coerce && (s.data = String(s.data)), this._getType(s) !== ZodParsedType.string) {
      const p = this._getOrReturnCtx(s);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: p.parsedType
      }), INVALID;
    }
    const u = new ParseStatus();
    let d;
    for (const p of this._def.checks)
      if (p.kind === "min")
        s.data.length < p.value && (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          code: ZodIssueCode.too_small,
          minimum: p.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: p.message
        }), u.dirty());
      else if (p.kind === "max")
        s.data.length > p.value && (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          code: ZodIssueCode.too_big,
          maximum: p.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: p.message
        }), u.dirty());
      else if (p.kind === "length") {
        const v = s.data.length > p.value, A = s.data.length < p.value;
        (v || A) && (d = this._getOrReturnCtx(s, d), v ? addIssueToContext(d, {
          code: ZodIssueCode.too_big,
          maximum: p.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: p.message
        }) : A && addIssueToContext(d, {
          code: ZodIssueCode.too_small,
          minimum: p.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: p.message
        }), u.dirty());
      } else if (p.kind === "email")
        emailRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          validation: "email",
          code: ZodIssueCode.invalid_string,
          message: p.message
        }), u.dirty());
      else if (p.kind === "emoji")
        emojiRegex || (emojiRegex = new RegExp(_emojiRegex, "u")), emojiRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          validation: "emoji",
          code: ZodIssueCode.invalid_string,
          message: p.message
        }), u.dirty());
      else if (p.kind === "uuid")
        uuidRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          validation: "uuid",
          code: ZodIssueCode.invalid_string,
          message: p.message
        }), u.dirty());
      else if (p.kind === "nanoid")
        nanoidRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          validation: "nanoid",
          code: ZodIssueCode.invalid_string,
          message: p.message
        }), u.dirty());
      else if (p.kind === "cuid")
        cuidRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          validation: "cuid",
          code: ZodIssueCode.invalid_string,
          message: p.message
        }), u.dirty());
      else if (p.kind === "cuid2")
        cuid2Regex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          validation: "cuid2",
          code: ZodIssueCode.invalid_string,
          message: p.message
        }), u.dirty());
      else if (p.kind === "ulid")
        ulidRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
          validation: "ulid",
          code: ZodIssueCode.invalid_string,
          message: p.message
        }), u.dirty());
      else if (p.kind === "url")
        try {
          new URL(s.data);
        } catch {
          d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: p.message
          }), u.dirty();
        }
      else p.kind === "regex" ? (p.regex.lastIndex = 0, p.regex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        validation: "regex",
        code: ZodIssueCode.invalid_string,
        message: p.message
      }), u.dirty())) : p.kind === "trim" ? s.data = s.data.trim() : p.kind === "includes" ? s.data.includes(p.value, p.position) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: { includes: p.value, position: p.position },
        message: p.message
      }), u.dirty()) : p.kind === "toLowerCase" ? s.data = s.data.toLowerCase() : p.kind === "toUpperCase" ? s.data = s.data.toUpperCase() : p.kind === "startsWith" ? s.data.startsWith(p.value) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: { startsWith: p.value },
        message: p.message
      }), u.dirty()) : p.kind === "endsWith" ? s.data.endsWith(p.value) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: { endsWith: p.value },
        message: p.message
      }), u.dirty()) : p.kind === "datetime" ? datetimeRegex(p).test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: "datetime",
        message: p.message
      }), u.dirty()) : p.kind === "date" ? dateRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: "date",
        message: p.message
      }), u.dirty()) : p.kind === "time" ? timeRegex(p).test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        code: ZodIssueCode.invalid_string,
        validation: "time",
        message: p.message
      }), u.dirty()) : p.kind === "duration" ? durationRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        validation: "duration",
        code: ZodIssueCode.invalid_string,
        message: p.message
      }), u.dirty()) : p.kind === "ip" ? isValidIP(s.data, p.version) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        validation: "ip",
        code: ZodIssueCode.invalid_string,
        message: p.message
      }), u.dirty()) : p.kind === "jwt" ? isValidJWT(s.data, p.alg) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        validation: "jwt",
        code: ZodIssueCode.invalid_string,
        message: p.message
      }), u.dirty()) : p.kind === "cidr" ? isValidCidr(s.data, p.version) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        validation: "cidr",
        code: ZodIssueCode.invalid_string,
        message: p.message
      }), u.dirty()) : p.kind === "base64" ? base64Regex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        validation: "base64",
        code: ZodIssueCode.invalid_string,
        message: p.message
      }), u.dirty()) : p.kind === "base64url" ? base64urlRegex.test(s.data) || (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        validation: "base64url",
        code: ZodIssueCode.invalid_string,
        message: p.message
      }), u.dirty()) : util$1.assertNever(p);
    return { status: u.value, value: s.data };
  }
  _regex(s, c, u) {
    return this.refinement((d) => s.test(d), {
      validation: c,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(u)
    });
  }
  _addCheck(s) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, s]
    });
  }
  email(s) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(s) });
  }
  url(s) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(s) });
  }
  emoji(s) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(s) });
  }
  uuid(s) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(s) });
  }
  nanoid(s) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(s) });
  }
  cuid(s) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(s) });
  }
  cuid2(s) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(s) });
  }
  ulid(s) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(s) });
  }
  base64(s) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(s) });
  }
  base64url(s) {
    return this._addCheck({
      kind: "base64url",
      ...errorUtil.errToObj(s)
    });
  }
  jwt(s) {
    return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(s) });
  }
  ip(s) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(s) });
  }
  cidr(s) {
    return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(s) });
  }
  datetime(s) {
    return typeof s == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: s
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof s?.precision > "u" ? null : s?.precision,
      offset: s?.offset ?? !1,
      local: s?.local ?? !1,
      ...errorUtil.errToObj(s?.message)
    });
  }
  date(s) {
    return this._addCheck({ kind: "date", message: s });
  }
  time(s) {
    return typeof s == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: s
    }) : this._addCheck({
      kind: "time",
      precision: typeof s?.precision > "u" ? null : s?.precision,
      ...errorUtil.errToObj(s?.message)
    });
  }
  duration(s) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(s) });
  }
  regex(s, c) {
    return this._addCheck({
      kind: "regex",
      regex: s,
      ...errorUtil.errToObj(c)
    });
  }
  includes(s, c) {
    return this._addCheck({
      kind: "includes",
      value: s,
      position: c?.position,
      ...errorUtil.errToObj(c?.message)
    });
  }
  startsWith(s, c) {
    return this._addCheck({
      kind: "startsWith",
      value: s,
      ...errorUtil.errToObj(c)
    });
  }
  endsWith(s, c) {
    return this._addCheck({
      kind: "endsWith",
      value: s,
      ...errorUtil.errToObj(c)
    });
  }
  min(s, c) {
    return this._addCheck({
      kind: "min",
      value: s,
      ...errorUtil.errToObj(c)
    });
  }
  max(s, c) {
    return this._addCheck({
      kind: "max",
      value: s,
      ...errorUtil.errToObj(c)
    });
  }
  length(s, c) {
    return this._addCheck({
      kind: "length",
      value: s,
      ...errorUtil.errToObj(c)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(s) {
    return this.min(1, errorUtil.errToObj(s));
  }
  trim() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((s) => s.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((s) => s.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((s) => s.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((s) => s.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((s) => s.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((s) => s.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((s) => s.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((s) => s.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((s) => s.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((s) => s.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((s) => s.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((s) => s.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((s) => s.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((s) => s.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((s) => s.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((s) => s.kind === "base64url");
  }
  get minLength() {
    let s = null;
    for (const c of this._def.checks)
      c.kind === "min" && (s === null || c.value > s) && (s = c.value);
    return s;
  }
  get maxLength() {
    let s = null;
    for (const c of this._def.checks)
      c.kind === "max" && (s === null || c.value < s) && (s = c.value);
    return s;
  }
}
ZodString.create = (a) => new ZodString({
  checks: [],
  typeName: ZodFirstPartyTypeKind.ZodString,
  coerce: a?.coerce ?? !1,
  ...processCreateParams(a)
});
function floatSafeRemainder(a, s) {
  const c = (a.toString().split(".")[1] || "").length, u = (s.toString().split(".")[1] || "").length, d = c > u ? c : u, p = Number.parseInt(a.toFixed(d).replace(".", "")), v = Number.parseInt(s.toFixed(d).replace(".", ""));
  return p % v / 10 ** d;
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(s) {
    if (this._def.coerce && (s.data = Number(s.data)), this._getType(s) !== ZodParsedType.number) {
      const p = this._getOrReturnCtx(s);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: p.parsedType
      }), INVALID;
    }
    let u;
    const d = new ParseStatus();
    for (const p of this._def.checks)
      p.kind === "int" ? util$1.isInteger(s.data) || (u = this._getOrReturnCtx(s, u), addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: "integer",
        received: "float",
        message: p.message
      }), d.dirty()) : p.kind === "min" ? (p.inclusive ? s.data < p.value : s.data <= p.value) && (u = this._getOrReturnCtx(s, u), addIssueToContext(u, {
        code: ZodIssueCode.too_small,
        minimum: p.value,
        type: "number",
        inclusive: p.inclusive,
        exact: !1,
        message: p.message
      }), d.dirty()) : p.kind === "max" ? (p.inclusive ? s.data > p.value : s.data >= p.value) && (u = this._getOrReturnCtx(s, u), addIssueToContext(u, {
        code: ZodIssueCode.too_big,
        maximum: p.value,
        type: "number",
        inclusive: p.inclusive,
        exact: !1,
        message: p.message
      }), d.dirty()) : p.kind === "multipleOf" ? floatSafeRemainder(s.data, p.value) !== 0 && (u = this._getOrReturnCtx(s, u), addIssueToContext(u, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: p.value,
        message: p.message
      }), d.dirty()) : p.kind === "finite" ? Number.isFinite(s.data) || (u = this._getOrReturnCtx(s, u), addIssueToContext(u, {
        code: ZodIssueCode.not_finite,
        message: p.message
      }), d.dirty()) : util$1.assertNever(p);
    return { status: d.value, value: s.data };
  }
  gte(s, c) {
    return this.setLimit("min", s, !0, errorUtil.toString(c));
  }
  gt(s, c) {
    return this.setLimit("min", s, !1, errorUtil.toString(c));
  }
  lte(s, c) {
    return this.setLimit("max", s, !0, errorUtil.toString(c));
  }
  lt(s, c) {
    return this.setLimit("max", s, !1, errorUtil.toString(c));
  }
  setLimit(s, c, u, d) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: s,
          value: c,
          inclusive: u,
          message: errorUtil.toString(d)
        }
      ]
    });
  }
  _addCheck(s) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, s]
    });
  }
  int(s) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(s)
    });
  }
  positive(s) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(s)
    });
  }
  negative(s) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(s)
    });
  }
  nonpositive(s) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(s)
    });
  }
  nonnegative(s) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(s)
    });
  }
  multipleOf(s, c) {
    return this._addCheck({
      kind: "multipleOf",
      value: s,
      message: errorUtil.toString(c)
    });
  }
  finite(s) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(s)
    });
  }
  safe(s) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(s)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(s)
    });
  }
  get minValue() {
    let s = null;
    for (const c of this._def.checks)
      c.kind === "min" && (s === null || c.value > s) && (s = c.value);
    return s;
  }
  get maxValue() {
    let s = null;
    for (const c of this._def.checks)
      c.kind === "max" && (s === null || c.value < s) && (s = c.value);
    return s;
  }
  get isInt() {
    return !!this._def.checks.find((s) => s.kind === "int" || s.kind === "multipleOf" && util$1.isInteger(s.value));
  }
  get isFinite() {
    let s = null, c = null;
    for (const u of this._def.checks) {
      if (u.kind === "finite" || u.kind === "int" || u.kind === "multipleOf")
        return !0;
      u.kind === "min" ? (c === null || u.value > c) && (c = u.value) : u.kind === "max" && (s === null || u.value < s) && (s = u.value);
    }
    return Number.isFinite(c) && Number.isFinite(s);
  }
}
ZodNumber.create = (a) => new ZodNumber({
  checks: [],
  typeName: ZodFirstPartyTypeKind.ZodNumber,
  coerce: a?.coerce || !1,
  ...processCreateParams(a)
});
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(s) {
    if (this._def.coerce)
      try {
        s.data = BigInt(s.data);
      } catch {
        return this._getInvalidInput(s);
      }
    if (this._getType(s) !== ZodParsedType.bigint)
      return this._getInvalidInput(s);
    let u;
    const d = new ParseStatus();
    for (const p of this._def.checks)
      p.kind === "min" ? (p.inclusive ? s.data < p.value : s.data <= p.value) && (u = this._getOrReturnCtx(s, u), addIssueToContext(u, {
        code: ZodIssueCode.too_small,
        type: "bigint",
        minimum: p.value,
        inclusive: p.inclusive,
        message: p.message
      }), d.dirty()) : p.kind === "max" ? (p.inclusive ? s.data > p.value : s.data >= p.value) && (u = this._getOrReturnCtx(s, u), addIssueToContext(u, {
        code: ZodIssueCode.too_big,
        type: "bigint",
        maximum: p.value,
        inclusive: p.inclusive,
        message: p.message
      }), d.dirty()) : p.kind === "multipleOf" ? s.data % p.value !== BigInt(0) && (u = this._getOrReturnCtx(s, u), addIssueToContext(u, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: p.value,
        message: p.message
      }), d.dirty()) : util$1.assertNever(p);
    return { status: d.value, value: s.data };
  }
  _getInvalidInput(s) {
    const c = this._getOrReturnCtx(s);
    return addIssueToContext(c, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.bigint,
      received: c.parsedType
    }), INVALID;
  }
  gte(s, c) {
    return this.setLimit("min", s, !0, errorUtil.toString(c));
  }
  gt(s, c) {
    return this.setLimit("min", s, !1, errorUtil.toString(c));
  }
  lte(s, c) {
    return this.setLimit("max", s, !0, errorUtil.toString(c));
  }
  lt(s, c) {
    return this.setLimit("max", s, !1, errorUtil.toString(c));
  }
  setLimit(s, c, u, d) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: s,
          value: c,
          inclusive: u,
          message: errorUtil.toString(d)
        }
      ]
    });
  }
  _addCheck(s) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, s]
    });
  }
  positive(s) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(s)
    });
  }
  negative(s) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(s)
    });
  }
  nonpositive(s) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(s)
    });
  }
  nonnegative(s) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(s)
    });
  }
  multipleOf(s, c) {
    return this._addCheck({
      kind: "multipleOf",
      value: s,
      message: errorUtil.toString(c)
    });
  }
  get minValue() {
    let s = null;
    for (const c of this._def.checks)
      c.kind === "min" && (s === null || c.value > s) && (s = c.value);
    return s;
  }
  get maxValue() {
    let s = null;
    for (const c of this._def.checks)
      c.kind === "max" && (s === null || c.value < s) && (s = c.value);
    return s;
  }
}
ZodBigInt.create = (a) => new ZodBigInt({
  checks: [],
  typeName: ZodFirstPartyTypeKind.ZodBigInt,
  coerce: a?.coerce ?? !1,
  ...processCreateParams(a)
});
class ZodBoolean extends ZodType {
  _parse(s) {
    if (this._def.coerce && (s.data = !!s.data), this._getType(s) !== ZodParsedType.boolean) {
      const u = this._getOrReturnCtx(s);
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: u.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodBoolean.create = (a) => new ZodBoolean({
  typeName: ZodFirstPartyTypeKind.ZodBoolean,
  coerce: a?.coerce || !1,
  ...processCreateParams(a)
});
class ZodDate extends ZodType {
  _parse(s) {
    if (this._def.coerce && (s.data = new Date(s.data)), this._getType(s) !== ZodParsedType.date) {
      const p = this._getOrReturnCtx(s);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: p.parsedType
      }), INVALID;
    }
    if (Number.isNaN(s.data.getTime())) {
      const p = this._getOrReturnCtx(s);
      return addIssueToContext(p, {
        code: ZodIssueCode.invalid_date
      }), INVALID;
    }
    const u = new ParseStatus();
    let d;
    for (const p of this._def.checks)
      p.kind === "min" ? s.data.getTime() < p.value && (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        code: ZodIssueCode.too_small,
        message: p.message,
        inclusive: !0,
        exact: !1,
        minimum: p.value,
        type: "date"
      }), u.dirty()) : p.kind === "max" ? s.data.getTime() > p.value && (d = this._getOrReturnCtx(s, d), addIssueToContext(d, {
        code: ZodIssueCode.too_big,
        message: p.message,
        inclusive: !0,
        exact: !1,
        maximum: p.value,
        type: "date"
      }), u.dirty()) : util$1.assertNever(p);
    return {
      status: u.value,
      value: new Date(s.data.getTime())
    };
  }
  _addCheck(s) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, s]
    });
  }
  min(s, c) {
    return this._addCheck({
      kind: "min",
      value: s.getTime(),
      message: errorUtil.toString(c)
    });
  }
  max(s, c) {
    return this._addCheck({
      kind: "max",
      value: s.getTime(),
      message: errorUtil.toString(c)
    });
  }
  get minDate() {
    let s = null;
    for (const c of this._def.checks)
      c.kind === "min" && (s === null || c.value > s) && (s = c.value);
    return s != null ? new Date(s) : null;
  }
  get maxDate() {
    let s = null;
    for (const c of this._def.checks)
      c.kind === "max" && (s === null || c.value < s) && (s = c.value);
    return s != null ? new Date(s) : null;
  }
}
ZodDate.create = (a) => new ZodDate({
  checks: [],
  coerce: a?.coerce || !1,
  typeName: ZodFirstPartyTypeKind.ZodDate,
  ...processCreateParams(a)
});
class ZodSymbol extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.symbol) {
      const u = this._getOrReturnCtx(s);
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: u.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodSymbol.create = (a) => new ZodSymbol({
  typeName: ZodFirstPartyTypeKind.ZodSymbol,
  ...processCreateParams(a)
});
class ZodUndefined extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.undefined) {
      const u = this._getOrReturnCtx(s);
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: u.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodUndefined.create = (a) => new ZodUndefined({
  typeName: ZodFirstPartyTypeKind.ZodUndefined,
  ...processCreateParams(a)
});
class ZodNull extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.null) {
      const u = this._getOrReturnCtx(s);
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: u.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodNull.create = (a) => new ZodNull({
  typeName: ZodFirstPartyTypeKind.ZodNull,
  ...processCreateParams(a)
});
class ZodAny extends ZodType {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(s) {
    return OK(s.data);
  }
}
ZodAny.create = (a) => new ZodAny({
  typeName: ZodFirstPartyTypeKind.ZodAny,
  ...processCreateParams(a)
});
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(s) {
    return OK(s.data);
  }
}
ZodUnknown.create = (a) => new ZodUnknown({
  typeName: ZodFirstPartyTypeKind.ZodUnknown,
  ...processCreateParams(a)
});
class ZodNever extends ZodType {
  _parse(s) {
    const c = this._getOrReturnCtx(s);
    return addIssueToContext(c, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: c.parsedType
    }), INVALID;
  }
}
ZodNever.create = (a) => new ZodNever({
  typeName: ZodFirstPartyTypeKind.ZodNever,
  ...processCreateParams(a)
});
class ZodVoid extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.undefined) {
      const u = this._getOrReturnCtx(s);
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: u.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodVoid.create = (a) => new ZodVoid({
  typeName: ZodFirstPartyTypeKind.ZodVoid,
  ...processCreateParams(a)
});
class ZodArray extends ZodType {
  _parse(s) {
    const { ctx: c, status: u } = this._processInputParams(s), d = this._def;
    if (c.parsedType !== ZodParsedType.array)
      return addIssueToContext(c, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: c.parsedType
      }), INVALID;
    if (d.exactLength !== null) {
      const v = c.data.length > d.exactLength.value, A = c.data.length < d.exactLength.value;
      (v || A) && (addIssueToContext(c, {
        code: v ? ZodIssueCode.too_big : ZodIssueCode.too_small,
        minimum: A ? d.exactLength.value : void 0,
        maximum: v ? d.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: d.exactLength.message
      }), u.dirty());
    }
    if (d.minLength !== null && c.data.length < d.minLength.value && (addIssueToContext(c, {
      code: ZodIssueCode.too_small,
      minimum: d.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: d.minLength.message
    }), u.dirty()), d.maxLength !== null && c.data.length > d.maxLength.value && (addIssueToContext(c, {
      code: ZodIssueCode.too_big,
      maximum: d.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: d.maxLength.message
    }), u.dirty()), c.common.async)
      return Promise.all([...c.data].map((v, A) => d.type._parseAsync(new ParseInputLazyPath(c, v, c.path, A)))).then((v) => ParseStatus.mergeArray(u, v));
    const p = [...c.data].map((v, A) => d.type._parseSync(new ParseInputLazyPath(c, v, c.path, A)));
    return ParseStatus.mergeArray(u, p);
  }
  get element() {
    return this._def.type;
  }
  min(s, c) {
    return new ZodArray({
      ...this._def,
      minLength: { value: s, message: errorUtil.toString(c) }
    });
  }
  max(s, c) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: s, message: errorUtil.toString(c) }
    });
  }
  length(s, c) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: s, message: errorUtil.toString(c) }
    });
  }
  nonempty(s) {
    return this.min(1, s);
  }
}
ZodArray.create = (a, s) => new ZodArray({
  type: a,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ZodFirstPartyTypeKind.ZodArray,
  ...processCreateParams(s)
});
function deepPartialify(a) {
  if (a instanceof ZodObject) {
    const s = {};
    for (const c in a.shape) {
      const u = a.shape[c];
      s[c] = ZodOptional.create(deepPartialify(u));
    }
    return new ZodObject({
      ...a._def,
      shape: () => s
    });
  } else return a instanceof ZodArray ? new ZodArray({
    ...a._def,
    type: deepPartialify(a.element)
  }) : a instanceof ZodOptional ? ZodOptional.create(deepPartialify(a.unwrap())) : a instanceof ZodNullable ? ZodNullable.create(deepPartialify(a.unwrap())) : a instanceof ZodTuple ? ZodTuple.create(a.items.map((s) => deepPartialify(s))) : a;
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const s = this._def.shape(), c = util$1.objectKeys(s);
    return this._cached = { shape: s, keys: c }, this._cached;
  }
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.object) {
      const g = this._getOrReturnCtx(s);
      return addIssueToContext(g, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: g.parsedType
      }), INVALID;
    }
    const { status: u, ctx: d } = this._processInputParams(s), { shape: p, keys: v } = this._getCached(), A = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip"))
      for (const g in d.data)
        v.includes(g) || A.push(g);
    const x = [];
    for (const g of v) {
      const b = p[g], y = d.data[g];
      x.push({
        key: { status: "valid", value: g },
        value: b._parse(new ParseInputLazyPath(d, y, d.path, g)),
        alwaysSet: g in d.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const g = this._def.unknownKeys;
      if (g === "passthrough")
        for (const b of A)
          x.push({
            key: { status: "valid", value: b },
            value: { status: "valid", value: d.data[b] }
          });
      else if (g === "strict")
        A.length > 0 && (addIssueToContext(d, {
          code: ZodIssueCode.unrecognized_keys,
          keys: A
        }), u.dirty());
      else if (g !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const g = this._def.catchall;
      for (const b of A) {
        const y = d.data[b];
        x.push({
          key: { status: "valid", value: b },
          value: g._parse(
            new ParseInputLazyPath(d, y, d.path, b)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: b in d.data
        });
      }
    }
    return d.common.async ? Promise.resolve().then(async () => {
      const g = [];
      for (const b of x) {
        const y = await b.key, f = await b.value;
        g.push({
          key: y,
          value: f,
          alwaysSet: b.alwaysSet
        });
      }
      return g;
    }).then((g) => ParseStatus.mergeObjectSync(u, g)) : ParseStatus.mergeObjectSync(u, x);
  }
  get shape() {
    return this._def.shape();
  }
  strict(s) {
    return errorUtil.errToObj, new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...s !== void 0 ? {
        errorMap: (c, u) => {
          const d = this._def.errorMap?.(c, u).message ?? u.defaultError;
          return c.code === "unrecognized_keys" ? {
            message: errorUtil.errToObj(s).message ?? d
          } : {
            message: d
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(s) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...s
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(s) {
    return new ZodObject({
      unknownKeys: s._def.unknownKeys,
      catchall: s._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...s._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(s, c) {
    return this.augment({ [s]: c });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(s) {
    return new ZodObject({
      ...this._def,
      catchall: s
    });
  }
  pick(s) {
    const c = {};
    for (const u of util$1.objectKeys(s))
      s[u] && this.shape[u] && (c[u] = this.shape[u]);
    return new ZodObject({
      ...this._def,
      shape: () => c
    });
  }
  omit(s) {
    const c = {};
    for (const u of util$1.objectKeys(this.shape))
      s[u] || (c[u] = this.shape[u]);
    return new ZodObject({
      ...this._def,
      shape: () => c
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(s) {
    const c = {};
    for (const u of util$1.objectKeys(this.shape)) {
      const d = this.shape[u];
      s && !s[u] ? c[u] = d : c[u] = d.optional();
    }
    return new ZodObject({
      ...this._def,
      shape: () => c
    });
  }
  required(s) {
    const c = {};
    for (const u of util$1.objectKeys(this.shape))
      if (s && !s[u])
        c[u] = this.shape[u];
      else {
        let p = this.shape[u];
        for (; p instanceof ZodOptional; )
          p = p._def.innerType;
        c[u] = p;
      }
    return new ZodObject({
      ...this._def,
      shape: () => c
    });
  }
  keyof() {
    return createZodEnum(util$1.objectKeys(this.shape));
  }
}
ZodObject.create = (a, s) => new ZodObject({
  shape: () => a,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(s)
});
ZodObject.strictCreate = (a, s) => new ZodObject({
  shape: () => a,
  unknownKeys: "strict",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(s)
});
ZodObject.lazycreate = (a, s) => new ZodObject({
  shape: a,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(s)
});
class ZodUnion extends ZodType {
  _parse(s) {
    const { ctx: c } = this._processInputParams(s), u = this._def.options;
    function d(p) {
      for (const A of p)
        if (A.result.status === "valid")
          return A.result;
      for (const A of p)
        if (A.result.status === "dirty")
          return c.common.issues.push(...A.ctx.common.issues), A.result;
      const v = p.map((A) => new ZodError(A.ctx.common.issues));
      return addIssueToContext(c, {
        code: ZodIssueCode.invalid_union,
        unionErrors: v
      }), INVALID;
    }
    if (c.common.async)
      return Promise.all(u.map(async (p) => {
        const v = {
          ...c,
          common: {
            ...c.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await p._parseAsync({
            data: c.data,
            path: c.path,
            parent: v
          }),
          ctx: v
        };
      })).then(d);
    {
      let p;
      const v = [];
      for (const x of u) {
        const g = {
          ...c,
          common: {
            ...c.common,
            issues: []
          },
          parent: null
        }, b = x._parseSync({
          data: c.data,
          path: c.path,
          parent: g
        });
        if (b.status === "valid")
          return b;
        b.status === "dirty" && !p && (p = { result: b, ctx: g }), g.common.issues.length && v.push(g.common.issues);
      }
      if (p)
        return c.common.issues.push(...p.ctx.common.issues), p.result;
      const A = v.map((x) => new ZodError(x));
      return addIssueToContext(c, {
        code: ZodIssueCode.invalid_union,
        unionErrors: A
      }), INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (a, s) => new ZodUnion({
  options: a,
  typeName: ZodFirstPartyTypeKind.ZodUnion,
  ...processCreateParams(s)
});
function mergeValues(a, s) {
  const c = getParsedType(a), u = getParsedType(s);
  if (a === s)
    return { valid: !0, data: a };
  if (c === ZodParsedType.object && u === ZodParsedType.object) {
    const d = util$1.objectKeys(s), p = util$1.objectKeys(a).filter((A) => d.indexOf(A) !== -1), v = { ...a, ...s };
    for (const A of p) {
      const x = mergeValues(a[A], s[A]);
      if (!x.valid)
        return { valid: !1 };
      v[A] = x.data;
    }
    return { valid: !0, data: v };
  } else if (c === ZodParsedType.array && u === ZodParsedType.array) {
    if (a.length !== s.length)
      return { valid: !1 };
    const d = [];
    for (let p = 0; p < a.length; p++) {
      const v = a[p], A = s[p], x = mergeValues(v, A);
      if (!x.valid)
        return { valid: !1 };
      d.push(x.data);
    }
    return { valid: !0, data: d };
  } else return c === ZodParsedType.date && u === ZodParsedType.date && +a == +s ? { valid: !0, data: a } : { valid: !1 };
}
class ZodIntersection extends ZodType {
  _parse(s) {
    const { status: c, ctx: u } = this._processInputParams(s), d = (p, v) => {
      if (isAborted(p) || isAborted(v))
        return INVALID;
      const A = mergeValues(p.value, v.value);
      return A.valid ? ((isDirty(p) || isDirty(v)) && c.dirty(), { status: c.value, value: A.data }) : (addIssueToContext(u, {
        code: ZodIssueCode.invalid_intersection_types
      }), INVALID);
    };
    return u.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: u.data,
        path: u.path,
        parent: u
      }),
      this._def.right._parseAsync({
        data: u.data,
        path: u.path,
        parent: u
      })
    ]).then(([p, v]) => d(p, v)) : d(this._def.left._parseSync({
      data: u.data,
      path: u.path,
      parent: u
    }), this._def.right._parseSync({
      data: u.data,
      path: u.path,
      parent: u
    }));
  }
}
ZodIntersection.create = (a, s, c) => new ZodIntersection({
  left: a,
  right: s,
  typeName: ZodFirstPartyTypeKind.ZodIntersection,
  ...processCreateParams(c)
});
class ZodTuple extends ZodType {
  _parse(s) {
    const { status: c, ctx: u } = this._processInputParams(s);
    if (u.parsedType !== ZodParsedType.array)
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: u.parsedType
      }), INVALID;
    if (u.data.length < this._def.items.length)
      return addIssueToContext(u, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), INVALID;
    !this._def.rest && u.data.length > this._def.items.length && (addIssueToContext(u, {
      code: ZodIssueCode.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), c.dirty());
    const p = [...u.data].map((v, A) => {
      const x = this._def.items[A] || this._def.rest;
      return x ? x._parse(new ParseInputLazyPath(u, v, u.path, A)) : null;
    }).filter((v) => !!v);
    return u.common.async ? Promise.all(p).then((v) => ParseStatus.mergeArray(c, v)) : ParseStatus.mergeArray(c, p);
  }
  get items() {
    return this._def.items;
  }
  rest(s) {
    return new ZodTuple({
      ...this._def,
      rest: s
    });
  }
}
ZodTuple.create = (a, s) => {
  if (!Array.isArray(a))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ZodTuple({
    items: a,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(s)
  });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(s) {
    const { status: c, ctx: u } = this._processInputParams(s);
    if (u.parsedType !== ZodParsedType.object)
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: u.parsedType
      }), INVALID;
    const d = [], p = this._def.keyType, v = this._def.valueType;
    for (const A in u.data)
      d.push({
        key: p._parse(new ParseInputLazyPath(u, A, u.path, A)),
        value: v._parse(new ParseInputLazyPath(u, u.data[A], u.path, A)),
        alwaysSet: A in u.data
      });
    return u.common.async ? ParseStatus.mergeObjectAsync(c, d) : ParseStatus.mergeObjectSync(c, d);
  }
  get element() {
    return this._def.valueType;
  }
  static create(s, c, u) {
    return c instanceof ZodType ? new ZodRecord({
      keyType: s,
      valueType: c,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(u)
    }) : new ZodRecord({
      keyType: ZodString.create(),
      valueType: s,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(c)
    });
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(s) {
    const { status: c, ctx: u } = this._processInputParams(s);
    if (u.parsedType !== ZodParsedType.map)
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: u.parsedType
      }), INVALID;
    const d = this._def.keyType, p = this._def.valueType, v = [...u.data.entries()].map(([A, x], g) => ({
      key: d._parse(new ParseInputLazyPath(u, A, u.path, [g, "key"])),
      value: p._parse(new ParseInputLazyPath(u, x, u.path, [g, "value"]))
    }));
    if (u.common.async) {
      const A = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const x of v) {
          const g = await x.key, b = await x.value;
          if (g.status === "aborted" || b.status === "aborted")
            return INVALID;
          (g.status === "dirty" || b.status === "dirty") && c.dirty(), A.set(g.value, b.value);
        }
        return { status: c.value, value: A };
      });
    } else {
      const A = /* @__PURE__ */ new Map();
      for (const x of v) {
        const g = x.key, b = x.value;
        if (g.status === "aborted" || b.status === "aborted")
          return INVALID;
        (g.status === "dirty" || b.status === "dirty") && c.dirty(), A.set(g.value, b.value);
      }
      return { status: c.value, value: A };
    }
  }
}
ZodMap.create = (a, s, c) => new ZodMap({
  valueType: s,
  keyType: a,
  typeName: ZodFirstPartyTypeKind.ZodMap,
  ...processCreateParams(c)
});
class ZodSet extends ZodType {
  _parse(s) {
    const { status: c, ctx: u } = this._processInputParams(s);
    if (u.parsedType !== ZodParsedType.set)
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: u.parsedType
      }), INVALID;
    const d = this._def;
    d.minSize !== null && u.data.size < d.minSize.value && (addIssueToContext(u, {
      code: ZodIssueCode.too_small,
      minimum: d.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: d.minSize.message
    }), c.dirty()), d.maxSize !== null && u.data.size > d.maxSize.value && (addIssueToContext(u, {
      code: ZodIssueCode.too_big,
      maximum: d.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: d.maxSize.message
    }), c.dirty());
    const p = this._def.valueType;
    function v(x) {
      const g = /* @__PURE__ */ new Set();
      for (const b of x) {
        if (b.status === "aborted")
          return INVALID;
        b.status === "dirty" && c.dirty(), g.add(b.value);
      }
      return { status: c.value, value: g };
    }
    const A = [...u.data.values()].map((x, g) => p._parse(new ParseInputLazyPath(u, x, u.path, g)));
    return u.common.async ? Promise.all(A).then((x) => v(x)) : v(A);
  }
  min(s, c) {
    return new ZodSet({
      ...this._def,
      minSize: { value: s, message: errorUtil.toString(c) }
    });
  }
  max(s, c) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: s, message: errorUtil.toString(c) }
    });
  }
  size(s, c) {
    return this.min(s, c).max(s, c);
  }
  nonempty(s) {
    return this.min(1, s);
  }
}
ZodSet.create = (a, s) => new ZodSet({
  valueType: a,
  minSize: null,
  maxSize: null,
  typeName: ZodFirstPartyTypeKind.ZodSet,
  ...processCreateParams(s)
});
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(s) {
    const { ctx: c } = this._processInputParams(s);
    if (c.parsedType !== ZodParsedType.function)
      return addIssueToContext(c, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: c.parsedType
      }), INVALID;
    function u(A, x) {
      return makeIssue({
        data: A,
        path: c.path,
        errorMaps: [c.common.contextualErrorMap, c.schemaErrorMap, getErrorMap(), errorMap].filter((g) => !!g),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: x
        }
      });
    }
    function d(A, x) {
      return makeIssue({
        data: A,
        path: c.path,
        errorMaps: [c.common.contextualErrorMap, c.schemaErrorMap, getErrorMap(), errorMap].filter((g) => !!g),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: x
        }
      });
    }
    const p = { errorMap: c.common.contextualErrorMap }, v = c.data;
    if (this._def.returns instanceof ZodPromise) {
      const A = this;
      return OK(async function(...x) {
        const g = new ZodError([]), b = await A._def.args.parseAsync(x, p).catch((m) => {
          throw g.addIssue(u(x, m)), g;
        }), y = await Reflect.apply(v, this, b);
        return await A._def.returns._def.type.parseAsync(y, p).catch((m) => {
          throw g.addIssue(d(y, m)), g;
        });
      });
    } else {
      const A = this;
      return OK(function(...x) {
        const g = A._def.args.safeParse(x, p);
        if (!g.success)
          throw new ZodError([u(x, g.error)]);
        const b = Reflect.apply(v, this, g.data), y = A._def.returns.safeParse(b, p);
        if (!y.success)
          throw new ZodError([d(b, y.error)]);
        return y.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...s) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(s).rest(ZodUnknown.create())
    });
  }
  returns(s) {
    return new ZodFunction({
      ...this._def,
      returns: s
    });
  }
  implement(s) {
    return this.parse(s);
  }
  strictImplement(s) {
    return this.parse(s);
  }
  static create(s, c, u) {
    return new ZodFunction({
      args: s || ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: c || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(u)
    });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(s) {
    const { ctx: c } = this._processInputParams(s);
    return this._def.getter()._parse({ data: c.data, path: c.path, parent: c });
  }
}
ZodLazy.create = (a, s) => new ZodLazy({
  getter: a,
  typeName: ZodFirstPartyTypeKind.ZodLazy,
  ...processCreateParams(s)
});
class ZodLiteral extends ZodType {
  _parse(s) {
    if (s.data !== this._def.value) {
      const c = this._getOrReturnCtx(s);
      return addIssueToContext(c, {
        received: c.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      }), INVALID;
    }
    return { status: "valid", value: s.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (a, s) => new ZodLiteral({
  value: a,
  typeName: ZodFirstPartyTypeKind.ZodLiteral,
  ...processCreateParams(s)
});
function createZodEnum(a, s) {
  return new ZodEnum({
    values: a,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(s)
  });
}
class ZodEnum extends ZodType {
  _parse(s) {
    if (typeof s.data != "string") {
      const c = this._getOrReturnCtx(s), u = this._def.values;
      return addIssueToContext(c, {
        expected: util$1.joinValues(u),
        received: c.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(s.data)) {
      const c = this._getOrReturnCtx(s), u = this._def.values;
      return addIssueToContext(c, {
        received: c.data,
        code: ZodIssueCode.invalid_enum_value,
        options: u
      }), INVALID;
    }
    return OK(s.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const s = {};
    for (const c of this._def.values)
      s[c] = c;
    return s;
  }
  get Values() {
    const s = {};
    for (const c of this._def.values)
      s[c] = c;
    return s;
  }
  get Enum() {
    const s = {};
    for (const c of this._def.values)
      s[c] = c;
    return s;
  }
  extract(s, c = this._def) {
    return ZodEnum.create(s, {
      ...this._def,
      ...c
    });
  }
  exclude(s, c = this._def) {
    return ZodEnum.create(this.options.filter((u) => !s.includes(u)), {
      ...this._def,
      ...c
    });
  }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  _parse(s) {
    const c = util$1.getValidEnumValues(this._def.values), u = this._getOrReturnCtx(s);
    if (u.parsedType !== ZodParsedType.string && u.parsedType !== ZodParsedType.number) {
      const d = util$1.objectValues(c);
      return addIssueToContext(u, {
        expected: util$1.joinValues(d),
        received: u.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (this._cache || (this._cache = new Set(util$1.getValidEnumValues(this._def.values))), !this._cache.has(s.data)) {
      const d = util$1.objectValues(c);
      return addIssueToContext(u, {
        received: u.data,
        code: ZodIssueCode.invalid_enum_value,
        options: d
      }), INVALID;
    }
    return OK(s.data);
  }
  get enum() {
    return this._def.values;
  }
}
ZodNativeEnum.create = (a, s) => new ZodNativeEnum({
  values: a,
  typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
  ...processCreateParams(s)
});
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(s) {
    const { ctx: c } = this._processInputParams(s);
    if (c.parsedType !== ZodParsedType.promise && c.common.async === !1)
      return addIssueToContext(c, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: c.parsedType
      }), INVALID;
    const u = c.parsedType === ZodParsedType.promise ? c.data : Promise.resolve(c.data);
    return OK(u.then((d) => this._def.type.parseAsync(d, {
      path: c.path,
      errorMap: c.common.contextualErrorMap
    })));
  }
}
ZodPromise.create = (a, s) => new ZodPromise({
  type: a,
  typeName: ZodFirstPartyTypeKind.ZodPromise,
  ...processCreateParams(s)
});
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(s) {
    const { status: c, ctx: u } = this._processInputParams(s), d = this._def.effect || null, p = {
      addIssue: (v) => {
        addIssueToContext(u, v), v.fatal ? c.abort() : c.dirty();
      },
      get path() {
        return u.path;
      }
    };
    if (p.addIssue = p.addIssue.bind(p), d.type === "preprocess") {
      const v = d.transform(u.data, p);
      if (u.common.async)
        return Promise.resolve(v).then(async (A) => {
          if (c.value === "aborted")
            return INVALID;
          const x = await this._def.schema._parseAsync({
            data: A,
            path: u.path,
            parent: u
          });
          return x.status === "aborted" ? INVALID : x.status === "dirty" || c.value === "dirty" ? DIRTY(x.value) : x;
        });
      {
        if (c.value === "aborted")
          return INVALID;
        const A = this._def.schema._parseSync({
          data: v,
          path: u.path,
          parent: u
        });
        return A.status === "aborted" ? INVALID : A.status === "dirty" || c.value === "dirty" ? DIRTY(A.value) : A;
      }
    }
    if (d.type === "refinement") {
      const v = (A) => {
        const x = d.refinement(A, p);
        if (u.common.async)
          return Promise.resolve(x);
        if (x instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return A;
      };
      if (u.common.async === !1) {
        const A = this._def.schema._parseSync({
          data: u.data,
          path: u.path,
          parent: u
        });
        return A.status === "aborted" ? INVALID : (A.status === "dirty" && c.dirty(), v(A.value), { status: c.value, value: A.value });
      } else
        return this._def.schema._parseAsync({ data: u.data, path: u.path, parent: u }).then((A) => A.status === "aborted" ? INVALID : (A.status === "dirty" && c.dirty(), v(A.value).then(() => ({ status: c.value, value: A.value }))));
    }
    if (d.type === "transform")
      if (u.common.async === !1) {
        const v = this._def.schema._parseSync({
          data: u.data,
          path: u.path,
          parent: u
        });
        if (!isValid(v))
          return INVALID;
        const A = d.transform(v.value, p);
        if (A instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: c.value, value: A };
      } else
        return this._def.schema._parseAsync({ data: u.data, path: u.path, parent: u }).then((v) => isValid(v) ? Promise.resolve(d.transform(v.value, p)).then((A) => ({
          status: c.value,
          value: A
        })) : INVALID);
    util$1.assertNever(d);
  }
}
ZodEffects.create = (a, s, c) => new ZodEffects({
  schema: a,
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  effect: s,
  ...processCreateParams(c)
});
ZodEffects.createWithPreprocess = (a, s, c) => new ZodEffects({
  schema: s,
  effect: { type: "preprocess", transform: a },
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  ...processCreateParams(c)
});
class ZodOptional extends ZodType {
  _parse(s) {
    return this._getType(s) === ZodParsedType.undefined ? OK(void 0) : this._def.innerType._parse(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (a, s) => new ZodOptional({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodOptional,
  ...processCreateParams(s)
});
class ZodNullable extends ZodType {
  _parse(s) {
    return this._getType(s) === ZodParsedType.null ? OK(null) : this._def.innerType._parse(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (a, s) => new ZodNullable({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodNullable,
  ...processCreateParams(s)
});
class ZodDefault extends ZodType {
  _parse(s) {
    const { ctx: c } = this._processInputParams(s);
    let u = c.data;
    return c.parsedType === ZodParsedType.undefined && (u = this._def.defaultValue()), this._def.innerType._parse({
      data: u,
      path: c.path,
      parent: c
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (a, s) => new ZodDefault({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodDefault,
  defaultValue: typeof s.default == "function" ? s.default : () => s.default,
  ...processCreateParams(s)
});
class ZodCatch extends ZodType {
  _parse(s) {
    const { ctx: c } = this._processInputParams(s), u = {
      ...c,
      common: {
        ...c.common,
        issues: []
      }
    }, d = this._def.innerType._parse({
      data: u.data,
      path: u.path,
      parent: {
        ...u
      }
    });
    return isAsync(d) ? d.then((p) => ({
      status: "valid",
      value: p.status === "valid" ? p.value : this._def.catchValue({
        get error() {
          return new ZodError(u.common.issues);
        },
        input: u.data
      })
    })) : {
      status: "valid",
      value: d.status === "valid" ? d.value : this._def.catchValue({
        get error() {
          return new ZodError(u.common.issues);
        },
        input: u.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (a, s) => new ZodCatch({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodCatch,
  catchValue: typeof s.catch == "function" ? s.catch : () => s.catch,
  ...processCreateParams(s)
});
class ZodNaN extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.nan) {
      const u = this._getOrReturnCtx(s);
      return addIssueToContext(u, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: u.parsedType
      }), INVALID;
    }
    return { status: "valid", value: s.data };
  }
}
ZodNaN.create = (a) => new ZodNaN({
  typeName: ZodFirstPartyTypeKind.ZodNaN,
  ...processCreateParams(a)
});
class ZodBranded extends ZodType {
  _parse(s) {
    const { ctx: c } = this._processInputParams(s), u = c.data;
    return this._def.type._parse({
      data: u,
      path: c.path,
      parent: c
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(s) {
    const { status: c, ctx: u } = this._processInputParams(s);
    if (u.common.async)
      return (async () => {
        const p = await this._def.in._parseAsync({
          data: u.data,
          path: u.path,
          parent: u
        });
        return p.status === "aborted" ? INVALID : p.status === "dirty" ? (c.dirty(), DIRTY(p.value)) : this._def.out._parseAsync({
          data: p.value,
          path: u.path,
          parent: u
        });
      })();
    {
      const d = this._def.in._parseSync({
        data: u.data,
        path: u.path,
        parent: u
      });
      return d.status === "aborted" ? INVALID : d.status === "dirty" ? (c.dirty(), {
        status: "dirty",
        value: d.value
      }) : this._def.out._parseSync({
        data: d.value,
        path: u.path,
        parent: u
      });
    }
  }
  static create(s, c) {
    return new ZodPipeline({
      in: s,
      out: c,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
class ZodReadonly extends ZodType {
  _parse(s) {
    const c = this._def.innerType._parse(s), u = (d) => (isValid(d) && (d.value = Object.freeze(d.value)), d);
    return isAsync(c) ? c.then((d) => u(d)) : u(c);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodReadonly.create = (a, s) => new ZodReadonly({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodReadonly,
  ...processCreateParams(s)
});
var ZodFirstPartyTypeKind;
(function(a) {
  a.ZodString = "ZodString", a.ZodNumber = "ZodNumber", a.ZodNaN = "ZodNaN", a.ZodBigInt = "ZodBigInt", a.ZodBoolean = "ZodBoolean", a.ZodDate = "ZodDate", a.ZodSymbol = "ZodSymbol", a.ZodUndefined = "ZodUndefined", a.ZodNull = "ZodNull", a.ZodAny = "ZodAny", a.ZodUnknown = "ZodUnknown", a.ZodNever = "ZodNever", a.ZodVoid = "ZodVoid", a.ZodArray = "ZodArray", a.ZodObject = "ZodObject", a.ZodUnion = "ZodUnion", a.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", a.ZodIntersection = "ZodIntersection", a.ZodTuple = "ZodTuple", a.ZodRecord = "ZodRecord", a.ZodMap = "ZodMap", a.ZodSet = "ZodSet", a.ZodFunction = "ZodFunction", a.ZodLazy = "ZodLazy", a.ZodLiteral = "ZodLiteral", a.ZodEnum = "ZodEnum", a.ZodEffects = "ZodEffects", a.ZodNativeEnum = "ZodNativeEnum", a.ZodOptional = "ZodOptional", a.ZodNullable = "ZodNullable", a.ZodDefault = "ZodDefault", a.ZodCatch = "ZodCatch", a.ZodPromise = "ZodPromise", a.ZodBranded = "ZodBranded", a.ZodPipeline = "ZodPipeline", a.ZodReadonly = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const stringType = ZodString.create, numberType = ZodNumber.create, booleanType = ZodBoolean.create, dateType = ZodDate.create, anyType = ZodAny.create, unknownType = ZodUnknown.create;
ZodNever.create;
const arrayType = ZodArray.create, objectType = ZodObject.create, unionType = ZodUnion.create;
ZodIntersection.create;
const tupleType = ZodTuple.create, recordType = ZodRecord.create, functionType = ZodFunction.create, enumType = ZodEnum.create;
ZodPromise.create;
ZodOptional.create;
ZodNullable.create;
var buffer$1 = {}, base64Js = {}, hasRequiredBase64Js;
function requireBase64Js() {
  if (hasRequiredBase64Js) return base64Js;
  hasRequiredBase64Js = 1, base64Js.byteLength = A, base64Js.toByteArray = g, base64Js.fromByteArray = f;
  for (var a = [], s = [], c = typeof Uint8Array < "u" ? Uint8Array : Array, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", d = 0, p = u.length; d < p; ++d)
    a[d] = u[d], s[u.charCodeAt(d)] = d;
  s[45] = 62, s[95] = 63;
  function v(m) {
    var C = m.length;
    if (C % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var w = m.indexOf("=");
    w === -1 && (w = C);
    var S = w === C ? 0 : 4 - w % 4;
    return [w, S];
  }
  function A(m) {
    var C = v(m), w = C[0], S = C[1];
    return (w + S) * 3 / 4 - S;
  }
  function x(m, C, w) {
    return (C + w) * 3 / 4 - w;
  }
  function g(m) {
    var C, w = v(m), S = w[0], $ = w[1], T = new c(x(m, S, $)), I = 0, _ = $ > 0 ? S - 4 : S, E;
    for (E = 0; E < _; E += 4)
      C = s[m.charCodeAt(E)] << 18 | s[m.charCodeAt(E + 1)] << 12 | s[m.charCodeAt(E + 2)] << 6 | s[m.charCodeAt(E + 3)], T[I++] = C >> 16 & 255, T[I++] = C >> 8 & 255, T[I++] = C & 255;
    return $ === 2 && (C = s[m.charCodeAt(E)] << 2 | s[m.charCodeAt(E + 1)] >> 4, T[I++] = C & 255), $ === 1 && (C = s[m.charCodeAt(E)] << 10 | s[m.charCodeAt(E + 1)] << 4 | s[m.charCodeAt(E + 2)] >> 2, T[I++] = C >> 8 & 255, T[I++] = C & 255), T;
  }
  function b(m) {
    return a[m >> 18 & 63] + a[m >> 12 & 63] + a[m >> 6 & 63] + a[m & 63];
  }
  function y(m, C, w) {
    for (var S, $ = [], T = C; T < w; T += 3)
      S = (m[T] << 16 & 16711680) + (m[T + 1] << 8 & 65280) + (m[T + 2] & 255), $.push(b(S));
    return $.join("");
  }
  function f(m) {
    for (var C, w = m.length, S = w % 3, $ = [], T = 16383, I = 0, _ = w - S; I < _; I += T)
      $.push(y(m, I, I + T > _ ? _ : I + T));
    return S === 1 ? (C = m[w - 1], $.push(
      a[C >> 2] + a[C << 4 & 63] + "=="
    )) : S === 2 && (C = (m[w - 2] << 8) + m[w - 1], $.push(
      a[C >> 10] + a[C >> 4 & 63] + a[C << 2 & 63] + "="
    )), $.join("");
  }
  return base64Js;
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var hasRequiredIeee754;
function requireIeee754() {
  return hasRequiredIeee754 || (hasRequiredIeee754 = 1, ieee754.read = function(a, s, c, u, d) {
    var p, v, A = d * 8 - u - 1, x = (1 << A) - 1, g = x >> 1, b = -7, y = c ? d - 1 : 0, f = c ? -1 : 1, m = a[s + y];
    for (y += f, p = m & (1 << -b) - 1, m >>= -b, b += A; b > 0; p = p * 256 + a[s + y], y += f, b -= 8)
      ;
    for (v = p & (1 << -b) - 1, p >>= -b, b += u; b > 0; v = v * 256 + a[s + y], y += f, b -= 8)
      ;
    if (p === 0)
      p = 1 - g;
    else {
      if (p === x)
        return v ? NaN : (m ? -1 : 1) * (1 / 0);
      v = v + Math.pow(2, u), p = p - g;
    }
    return (m ? -1 : 1) * v * Math.pow(2, p - u);
  }, ieee754.write = function(a, s, c, u, d, p) {
    var v, A, x, g = p * 8 - d - 1, b = (1 << g) - 1, y = b >> 1, f = d === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, m = u ? 0 : p - 1, C = u ? 1 : -1, w = s < 0 || s === 0 && 1 / s < 0 ? 1 : 0;
    for (s = Math.abs(s), isNaN(s) || s === 1 / 0 ? (A = isNaN(s) ? 1 : 0, v = b) : (v = Math.floor(Math.log(s) / Math.LN2), s * (x = Math.pow(2, -v)) < 1 && (v--, x *= 2), v + y >= 1 ? s += f / x : s += f * Math.pow(2, 1 - y), s * x >= 2 && (v++, x /= 2), v + y >= b ? (A = 0, v = b) : v + y >= 1 ? (A = (s * x - 1) * Math.pow(2, d), v = v + y) : (A = s * Math.pow(2, y - 1) * Math.pow(2, d), v = 0)); d >= 8; a[c + m] = A & 255, m += C, A /= 256, d -= 8)
      ;
    for (v = v << d | A, g += d; g > 0; a[c + m] = v & 255, m += C, v /= 256, g -= 8)
      ;
    a[c + m - C] |= w * 128;
  }), ieee754;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var hasRequiredBuffer;
function requireBuffer() {
  return hasRequiredBuffer || (hasRequiredBuffer = 1, function(a) {
    const s = requireBase64Js(), c = requireIeee754(), u = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    a.Buffer = A, a.SlowBuffer = T, a.INSPECT_MAX_BYTES = 50;
    const d = 2147483647;
    a.kMaxLength = d, A.TYPED_ARRAY_SUPPORT = p(), !A.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function p() {
      try {
        const Ae = new Uint8Array(1), ue = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(ue, Uint8Array.prototype), Object.setPrototypeOf(Ae, ue), Ae.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(A.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (A.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(A.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (A.isBuffer(this))
          return this.byteOffset;
      }
    });
    function v(Ae) {
      if (Ae > d)
        throw new RangeError('The value "' + Ae + '" is invalid for option "size"');
      const ue = new Uint8Array(Ae);
      return Object.setPrototypeOf(ue, A.prototype), ue;
    }
    function A(Ae, ue, ce) {
      if (typeof Ae == "number") {
        if (typeof ue == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return y(Ae);
      }
      return x(Ae, ue, ce);
    }
    A.poolSize = 8192;
    function x(Ae, ue, ce) {
      if (typeof Ae == "string")
        return f(Ae, ue);
      if (ArrayBuffer.isView(Ae))
        return C(Ae);
      if (Ae == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ae
        );
      if (ye(Ae, ArrayBuffer) || Ae && ye(Ae.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ye(Ae, SharedArrayBuffer) || Ae && ye(Ae.buffer, SharedArrayBuffer)))
        return w(Ae, ue, ce);
      if (typeof Ae == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const Ee = Ae.valueOf && Ae.valueOf();
      if (Ee != null && Ee !== Ae)
        return A.from(Ee, ue, ce);
      const _e = S(Ae);
      if (_e) return _e;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Ae[Symbol.toPrimitive] == "function")
        return A.from(Ae[Symbol.toPrimitive]("string"), ue, ce);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ae
      );
    }
    A.from = function(Ae, ue, ce) {
      return x(Ae, ue, ce);
    }, Object.setPrototypeOf(A.prototype, Uint8Array.prototype), Object.setPrototypeOf(A, Uint8Array);
    function g(Ae) {
      if (typeof Ae != "number")
        throw new TypeError('"size" argument must be of type number');
      if (Ae < 0)
        throw new RangeError('The value "' + Ae + '" is invalid for option "size"');
    }
    function b(Ae, ue, ce) {
      return g(Ae), Ae <= 0 ? v(Ae) : ue !== void 0 ? typeof ce == "string" ? v(Ae).fill(ue, ce) : v(Ae).fill(ue) : v(Ae);
    }
    A.alloc = function(Ae, ue, ce) {
      return b(Ae, ue, ce);
    };
    function y(Ae) {
      return g(Ae), v(Ae < 0 ? 0 : $(Ae) | 0);
    }
    A.allocUnsafe = function(Ae) {
      return y(Ae);
    }, A.allocUnsafeSlow = function(Ae) {
      return y(Ae);
    };
    function f(Ae, ue) {
      if ((typeof ue != "string" || ue === "") && (ue = "utf8"), !A.isEncoding(ue))
        throw new TypeError("Unknown encoding: " + ue);
      const ce = I(Ae, ue) | 0;
      let Ee = v(ce);
      const _e = Ee.write(Ae, ue);
      return _e !== ce && (Ee = Ee.slice(0, _e)), Ee;
    }
    function m(Ae) {
      const ue = Ae.length < 0 ? 0 : $(Ae.length) | 0, ce = v(ue);
      for (let Ee = 0; Ee < ue; Ee += 1)
        ce[Ee] = Ae[Ee] & 255;
      return ce;
    }
    function C(Ae) {
      if (ye(Ae, Uint8Array)) {
        const ue = new Uint8Array(Ae);
        return w(ue.buffer, ue.byteOffset, ue.byteLength);
      }
      return m(Ae);
    }
    function w(Ae, ue, ce) {
      if (ue < 0 || Ae.byteLength < ue)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (Ae.byteLength < ue + (ce || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let Ee;
      return ue === void 0 && ce === void 0 ? Ee = new Uint8Array(Ae) : ce === void 0 ? Ee = new Uint8Array(Ae, ue) : Ee = new Uint8Array(Ae, ue, ce), Object.setPrototypeOf(Ee, A.prototype), Ee;
    }
    function S(Ae) {
      if (A.isBuffer(Ae)) {
        const ue = $(Ae.length) | 0, ce = v(ue);
        return ce.length === 0 || Ae.copy(ce, 0, 0, ue), ce;
      }
      if (Ae.length !== void 0)
        return typeof Ae.length != "number" || Ce(Ae.length) ? v(0) : m(Ae);
      if (Ae.type === "Buffer" && Array.isArray(Ae.data))
        return m(Ae.data);
    }
    function $(Ae) {
      if (Ae >= d)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + d.toString(16) + " bytes");
      return Ae | 0;
    }
    function T(Ae) {
      return +Ae != Ae && (Ae = 0), A.alloc(+Ae);
    }
    A.isBuffer = function(ue) {
      return ue != null && ue._isBuffer === !0 && ue !== A.prototype;
    }, A.compare = function(ue, ce) {
      if (ye(ue, Uint8Array) && (ue = A.from(ue, ue.offset, ue.byteLength)), ye(ce, Uint8Array) && (ce = A.from(ce, ce.offset, ce.byteLength)), !A.isBuffer(ue) || !A.isBuffer(ce))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (ue === ce) return 0;
      let Ee = ue.length, _e = ce.length;
      for (let Te = 0, ke = Math.min(Ee, _e); Te < ke; ++Te)
        if (ue[Te] !== ce[Te]) {
          Ee = ue[Te], _e = ce[Te];
          break;
        }
      return Ee < _e ? -1 : _e < Ee ? 1 : 0;
    }, A.isEncoding = function(ue) {
      switch (String(ue).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, A.concat = function(ue, ce) {
      if (!Array.isArray(ue))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (ue.length === 0)
        return A.alloc(0);
      let Ee;
      if (ce === void 0)
        for (ce = 0, Ee = 0; Ee < ue.length; ++Ee)
          ce += ue[Ee].length;
      const _e = A.allocUnsafe(ce);
      let Te = 0;
      for (Ee = 0; Ee < ue.length; ++Ee) {
        let ke = ue[Ee];
        if (ye(ke, Uint8Array))
          Te + ke.length > _e.length ? (A.isBuffer(ke) || (ke = A.from(ke)), ke.copy(_e, Te)) : Uint8Array.prototype.set.call(
            _e,
            ke,
            Te
          );
        else if (A.isBuffer(ke))
          ke.copy(_e, Te);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        Te += ke.length;
      }
      return _e;
    };
    function I(Ae, ue) {
      if (A.isBuffer(Ae))
        return Ae.length;
      if (ArrayBuffer.isView(Ae) || ye(Ae, ArrayBuffer))
        return Ae.byteLength;
      if (typeof Ae != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Ae
        );
      const ce = Ae.length, Ee = arguments.length > 2 && arguments[2] === !0;
      if (!Ee && ce === 0) return 0;
      let _e = !1;
      for (; ; )
        switch (ue) {
          case "ascii":
          case "latin1":
          case "binary":
            return ce;
          case "utf8":
          case "utf-8":
            return pe(Ae).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ce * 2;
          case "hex":
            return ce >>> 1;
          case "base64":
            return ve(Ae).length;
          default:
            if (_e)
              return Ee ? -1 : pe(Ae).length;
            ue = ("" + ue).toLowerCase(), _e = !0;
        }
    }
    A.byteLength = I;
    function _(Ae, ue, ce) {
      let Ee = !1;
      if ((ue === void 0 || ue < 0) && (ue = 0), ue > this.length || ((ce === void 0 || ce > this.length) && (ce = this.length), ce <= 0) || (ce >>>= 0, ue >>>= 0, ce <= ue))
        return "";
      for (Ae || (Ae = "utf8"); ; )
        switch (Ae) {
          case "hex":
            return D(this, ue, ce);
          case "utf8":
          case "utf-8":
            return G(this, ue, ce);
          case "ascii":
            return N(this, ue, ce);
          case "latin1":
          case "binary":
            return P(this, ue, ce);
          case "base64":
            return j(this, ue, ce);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return H(this, ue, ce);
          default:
            if (Ee) throw new TypeError("Unknown encoding: " + Ae);
            Ae = (Ae + "").toLowerCase(), Ee = !0;
        }
    }
    A.prototype._isBuffer = !0;
    function E(Ae, ue, ce) {
      const Ee = Ae[ue];
      Ae[ue] = Ae[ce], Ae[ce] = Ee;
    }
    A.prototype.swap16 = function() {
      const ue = this.length;
      if (ue % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let ce = 0; ce < ue; ce += 2)
        E(this, ce, ce + 1);
      return this;
    }, A.prototype.swap32 = function() {
      const ue = this.length;
      if (ue % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let ce = 0; ce < ue; ce += 4)
        E(this, ce, ce + 3), E(this, ce + 1, ce + 2);
      return this;
    }, A.prototype.swap64 = function() {
      const ue = this.length;
      if (ue % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let ce = 0; ce < ue; ce += 8)
        E(this, ce, ce + 7), E(this, ce + 1, ce + 6), E(this, ce + 2, ce + 5), E(this, ce + 3, ce + 4);
      return this;
    }, A.prototype.toString = function() {
      const ue = this.length;
      return ue === 0 ? "" : arguments.length === 0 ? G(this, 0, ue) : _.apply(this, arguments);
    }, A.prototype.toLocaleString = A.prototype.toString, A.prototype.equals = function(ue) {
      if (!A.isBuffer(ue)) throw new TypeError("Argument must be a Buffer");
      return this === ue ? !0 : A.compare(this, ue) === 0;
    }, A.prototype.inspect = function() {
      let ue = "";
      const ce = a.INSPECT_MAX_BYTES;
      return ue = this.toString("hex", 0, ce).replace(/(.{2})/g, "$1 ").trim(), this.length > ce && (ue += " ... "), "<Buffer " + ue + ">";
    }, u && (A.prototype[u] = A.prototype.inspect), A.prototype.compare = function(ue, ce, Ee, _e, Te) {
      if (ye(ue, Uint8Array) && (ue = A.from(ue, ue.offset, ue.byteLength)), !A.isBuffer(ue))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof ue
        );
      if (ce === void 0 && (ce = 0), Ee === void 0 && (Ee = ue ? ue.length : 0), _e === void 0 && (_e = 0), Te === void 0 && (Te = this.length), ce < 0 || Ee > ue.length || _e < 0 || Te > this.length)
        throw new RangeError("out of range index");
      if (_e >= Te && ce >= Ee)
        return 0;
      if (_e >= Te)
        return -1;
      if (ce >= Ee)
        return 1;
      if (ce >>>= 0, Ee >>>= 0, _e >>>= 0, Te >>>= 0, this === ue) return 0;
      let ke = Te - _e, Re = Ee - ce;
      const Be = Math.min(ke, Re), Oe = this.slice(_e, Te), Me = ue.slice(ce, Ee);
      for (let Fe = 0; Fe < Be; ++Fe)
        if (Oe[Fe] !== Me[Fe]) {
          ke = Oe[Fe], Re = Me[Fe];
          break;
        }
      return ke < Re ? -1 : Re < ke ? 1 : 0;
    };
    function R(Ae, ue, ce, Ee, _e) {
      if (Ae.length === 0) return -1;
      if (typeof ce == "string" ? (Ee = ce, ce = 0) : ce > 2147483647 ? ce = 2147483647 : ce < -2147483648 && (ce = -2147483648), ce = +ce, Ce(ce) && (ce = _e ? 0 : Ae.length - 1), ce < 0 && (ce = Ae.length + ce), ce >= Ae.length) {
        if (_e) return -1;
        ce = Ae.length - 1;
      } else if (ce < 0)
        if (_e) ce = 0;
        else return -1;
      if (typeof ue == "string" && (ue = A.from(ue, Ee)), A.isBuffer(ue))
        return ue.length === 0 ? -1 : O(Ae, ue, ce, Ee, _e);
      if (typeof ue == "number")
        return ue = ue & 255, typeof Uint8Array.prototype.indexOf == "function" ? _e ? Uint8Array.prototype.indexOf.call(Ae, ue, ce) : Uint8Array.prototype.lastIndexOf.call(Ae, ue, ce) : O(Ae, [ue], ce, Ee, _e);
      throw new TypeError("val must be string, number or Buffer");
    }
    function O(Ae, ue, ce, Ee, _e) {
      let Te = 1, ke = Ae.length, Re = ue.length;
      if (Ee !== void 0 && (Ee = String(Ee).toLowerCase(), Ee === "ucs2" || Ee === "ucs-2" || Ee === "utf16le" || Ee === "utf-16le")) {
        if (Ae.length < 2 || ue.length < 2)
          return -1;
        Te = 2, ke /= 2, Re /= 2, ce /= 2;
      }
      function Be(Me, Fe) {
        return Te === 1 ? Me[Fe] : Me.readUInt16BE(Fe * Te);
      }
      let Oe;
      if (_e) {
        let Me = -1;
        for (Oe = ce; Oe < ke; Oe++)
          if (Be(Ae, Oe) === Be(ue, Me === -1 ? 0 : Oe - Me)) {
            if (Me === -1 && (Me = Oe), Oe - Me + 1 === Re) return Me * Te;
          } else
            Me !== -1 && (Oe -= Oe - Me), Me = -1;
      } else
        for (ce + Re > ke && (ce = ke - Re), Oe = ce; Oe >= 0; Oe--) {
          let Me = !0;
          for (let Fe = 0; Fe < Re; Fe++)
            if (Be(Ae, Oe + Fe) !== Be(ue, Fe)) {
              Me = !1;
              break;
            }
          if (Me) return Oe;
        }
      return -1;
    }
    A.prototype.includes = function(ue, ce, Ee) {
      return this.indexOf(ue, ce, Ee) !== -1;
    }, A.prototype.indexOf = function(ue, ce, Ee) {
      return R(this, ue, ce, Ee, !0);
    }, A.prototype.lastIndexOf = function(ue, ce, Ee) {
      return R(this, ue, ce, Ee, !1);
    };
    function L(Ae, ue, ce, Ee) {
      ce = Number(ce) || 0;
      const _e = Ae.length - ce;
      Ee ? (Ee = Number(Ee), Ee > _e && (Ee = _e)) : Ee = _e;
      const Te = ue.length;
      Ee > Te / 2 && (Ee = Te / 2);
      let ke;
      for (ke = 0; ke < Ee; ++ke) {
        const Re = parseInt(ue.substr(ke * 2, 2), 16);
        if (Ce(Re)) return ke;
        Ae[ce + ke] = Re;
      }
      return ke;
    }
    function B(Ae, ue, ce, Ee) {
      return he(pe(ue, Ae.length - ce), Ae, ce, Ee);
    }
    function F(Ae, ue, ce, Ee) {
      return he(be(ue), Ae, ce, Ee);
    }
    function M(Ae, ue, ce, Ee) {
      return he(ve(ue), Ae, ce, Ee);
    }
    function W(Ae, ue, ce, Ee) {
      return he(le(ue, Ae.length - ce), Ae, ce, Ee);
    }
    A.prototype.write = function(ue, ce, Ee, _e) {
      if (ce === void 0)
        _e = "utf8", Ee = this.length, ce = 0;
      else if (Ee === void 0 && typeof ce == "string")
        _e = ce, Ee = this.length, ce = 0;
      else if (isFinite(ce))
        ce = ce >>> 0, isFinite(Ee) ? (Ee = Ee >>> 0, _e === void 0 && (_e = "utf8")) : (_e = Ee, Ee = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const Te = this.length - ce;
      if ((Ee === void 0 || Ee > Te) && (Ee = Te), ue.length > 0 && (Ee < 0 || ce < 0) || ce > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      _e || (_e = "utf8");
      let ke = !1;
      for (; ; )
        switch (_e) {
          case "hex":
            return L(this, ue, ce, Ee);
          case "utf8":
          case "utf-8":
            return B(this, ue, ce, Ee);
          case "ascii":
          case "latin1":
          case "binary":
            return F(this, ue, ce, Ee);
          case "base64":
            return M(this, ue, ce, Ee);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return W(this, ue, ce, Ee);
          default:
            if (ke) throw new TypeError("Unknown encoding: " + _e);
            _e = ("" + _e).toLowerCase(), ke = !0;
        }
    }, A.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function j(Ae, ue, ce) {
      return ue === 0 && ce === Ae.length ? s.fromByteArray(Ae) : s.fromByteArray(Ae.slice(ue, ce));
    }
    function G(Ae, ue, ce) {
      ce = Math.min(Ae.length, ce);
      const Ee = [];
      let _e = ue;
      for (; _e < ce; ) {
        const Te = Ae[_e];
        let ke = null, Re = Te > 239 ? 4 : Te > 223 ? 3 : Te > 191 ? 2 : 1;
        if (_e + Re <= ce) {
          let Be, Oe, Me, Fe;
          switch (Re) {
            case 1:
              Te < 128 && (ke = Te);
              break;
            case 2:
              Be = Ae[_e + 1], (Be & 192) === 128 && (Fe = (Te & 31) << 6 | Be & 63, Fe > 127 && (ke = Fe));
              break;
            case 3:
              Be = Ae[_e + 1], Oe = Ae[_e + 2], (Be & 192) === 128 && (Oe & 192) === 128 && (Fe = (Te & 15) << 12 | (Be & 63) << 6 | Oe & 63, Fe > 2047 && (Fe < 55296 || Fe > 57343) && (ke = Fe));
              break;
            case 4:
              Be = Ae[_e + 1], Oe = Ae[_e + 2], Me = Ae[_e + 3], (Be & 192) === 128 && (Oe & 192) === 128 && (Me & 192) === 128 && (Fe = (Te & 15) << 18 | (Be & 63) << 12 | (Oe & 63) << 6 | Me & 63, Fe > 65535 && Fe < 1114112 && (ke = Fe));
          }
        }
        ke === null ? (ke = 65533, Re = 1) : ke > 65535 && (ke -= 65536, Ee.push(ke >>> 10 & 1023 | 55296), ke = 56320 | ke & 1023), Ee.push(ke), _e += Re;
      }
      return k(Ee);
    }
    const U = 4096;
    function k(Ae) {
      const ue = Ae.length;
      if (ue <= U)
        return String.fromCharCode.apply(String, Ae);
      let ce = "", Ee = 0;
      for (; Ee < ue; )
        ce += String.fromCharCode.apply(
          String,
          Ae.slice(Ee, Ee += U)
        );
      return ce;
    }
    function N(Ae, ue, ce) {
      let Ee = "";
      ce = Math.min(Ae.length, ce);
      for (let _e = ue; _e < ce; ++_e)
        Ee += String.fromCharCode(Ae[_e] & 127);
      return Ee;
    }
    function P(Ae, ue, ce) {
      let Ee = "";
      ce = Math.min(Ae.length, ce);
      for (let _e = ue; _e < ce; ++_e)
        Ee += String.fromCharCode(Ae[_e]);
      return Ee;
    }
    function D(Ae, ue, ce) {
      const Ee = Ae.length;
      (!ue || ue < 0) && (ue = 0), (!ce || ce < 0 || ce > Ee) && (ce = Ee);
      let _e = "";
      for (let Te = ue; Te < ce; ++Te)
        _e += xe[Ae[Te]];
      return _e;
    }
    function H(Ae, ue, ce) {
      const Ee = Ae.slice(ue, ce);
      let _e = "";
      for (let Te = 0; Te < Ee.length - 1; Te += 2)
        _e += String.fromCharCode(Ee[Te] + Ee[Te + 1] * 256);
      return _e;
    }
    A.prototype.slice = function(ue, ce) {
      const Ee = this.length;
      ue = ~~ue, ce = ce === void 0 ? Ee : ~~ce, ue < 0 ? (ue += Ee, ue < 0 && (ue = 0)) : ue > Ee && (ue = Ee), ce < 0 ? (ce += Ee, ce < 0 && (ce = 0)) : ce > Ee && (ce = Ee), ce < ue && (ce = ue);
      const _e = this.subarray(ue, ce);
      return Object.setPrototypeOf(_e, A.prototype), _e;
    };
    function V(Ae, ue, ce) {
      if (Ae % 1 !== 0 || Ae < 0) throw new RangeError("offset is not uint");
      if (Ae + ue > ce) throw new RangeError("Trying to access beyond buffer length");
    }
    A.prototype.readUintLE = A.prototype.readUIntLE = function(ue, ce, Ee) {
      ue = ue >>> 0, ce = ce >>> 0, Ee || V(ue, ce, this.length);
      let _e = this[ue], Te = 1, ke = 0;
      for (; ++ke < ce && (Te *= 256); )
        _e += this[ue + ke] * Te;
      return _e;
    }, A.prototype.readUintBE = A.prototype.readUIntBE = function(ue, ce, Ee) {
      ue = ue >>> 0, ce = ce >>> 0, Ee || V(ue, ce, this.length);
      let _e = this[ue + --ce], Te = 1;
      for (; ce > 0 && (Te *= 256); )
        _e += this[ue + --ce] * Te;
      return _e;
    }, A.prototype.readUint8 = A.prototype.readUInt8 = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 1, this.length), this[ue];
    }, A.prototype.readUint16LE = A.prototype.readUInt16LE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 2, this.length), this[ue] | this[ue + 1] << 8;
    }, A.prototype.readUint16BE = A.prototype.readUInt16BE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 2, this.length), this[ue] << 8 | this[ue + 1];
    }, A.prototype.readUint32LE = A.prototype.readUInt32LE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 4, this.length), (this[ue] | this[ue + 1] << 8 | this[ue + 2] << 16) + this[ue + 3] * 16777216;
    }, A.prototype.readUint32BE = A.prototype.readUInt32BE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 4, this.length), this[ue] * 16777216 + (this[ue + 1] << 16 | this[ue + 2] << 8 | this[ue + 3]);
    }, A.prototype.readBigUInt64LE = we(function(ue) {
      ue = ue >>> 0, ie(ue, "offset");
      const ce = this[ue], Ee = this[ue + 7];
      (ce === void 0 || Ee === void 0) && fe(ue, this.length - 8);
      const _e = ce + this[++ue] * 2 ** 8 + this[++ue] * 2 ** 16 + this[++ue] * 2 ** 24, Te = this[++ue] + this[++ue] * 2 ** 8 + this[++ue] * 2 ** 16 + Ee * 2 ** 24;
      return BigInt(_e) + (BigInt(Te) << BigInt(32));
    }), A.prototype.readBigUInt64BE = we(function(ue) {
      ue = ue >>> 0, ie(ue, "offset");
      const ce = this[ue], Ee = this[ue + 7];
      (ce === void 0 || Ee === void 0) && fe(ue, this.length - 8);
      const _e = ce * 2 ** 24 + this[++ue] * 2 ** 16 + this[++ue] * 2 ** 8 + this[++ue], Te = this[++ue] * 2 ** 24 + this[++ue] * 2 ** 16 + this[++ue] * 2 ** 8 + Ee;
      return (BigInt(_e) << BigInt(32)) + BigInt(Te);
    }), A.prototype.readIntLE = function(ue, ce, Ee) {
      ue = ue >>> 0, ce = ce >>> 0, Ee || V(ue, ce, this.length);
      let _e = this[ue], Te = 1, ke = 0;
      for (; ++ke < ce && (Te *= 256); )
        _e += this[ue + ke] * Te;
      return Te *= 128, _e >= Te && (_e -= Math.pow(2, 8 * ce)), _e;
    }, A.prototype.readIntBE = function(ue, ce, Ee) {
      ue = ue >>> 0, ce = ce >>> 0, Ee || V(ue, ce, this.length);
      let _e = ce, Te = 1, ke = this[ue + --_e];
      for (; _e > 0 && (Te *= 256); )
        ke += this[ue + --_e] * Te;
      return Te *= 128, ke >= Te && (ke -= Math.pow(2, 8 * ce)), ke;
    }, A.prototype.readInt8 = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 1, this.length), this[ue] & 128 ? (255 - this[ue] + 1) * -1 : this[ue];
    }, A.prototype.readInt16LE = function(ue, ce) {
      ue = ue >>> 0, ce || V(ue, 2, this.length);
      const Ee = this[ue] | this[ue + 1] << 8;
      return Ee & 32768 ? Ee | 4294901760 : Ee;
    }, A.prototype.readInt16BE = function(ue, ce) {
      ue = ue >>> 0, ce || V(ue, 2, this.length);
      const Ee = this[ue + 1] | this[ue] << 8;
      return Ee & 32768 ? Ee | 4294901760 : Ee;
    }, A.prototype.readInt32LE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 4, this.length), this[ue] | this[ue + 1] << 8 | this[ue + 2] << 16 | this[ue + 3] << 24;
    }, A.prototype.readInt32BE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 4, this.length), this[ue] << 24 | this[ue + 1] << 16 | this[ue + 2] << 8 | this[ue + 3];
    }, A.prototype.readBigInt64LE = we(function(ue) {
      ue = ue >>> 0, ie(ue, "offset");
      const ce = this[ue], Ee = this[ue + 7];
      (ce === void 0 || Ee === void 0) && fe(ue, this.length - 8);
      const _e = this[ue + 4] + this[ue + 5] * 2 ** 8 + this[ue + 6] * 2 ** 16 + (Ee << 24);
      return (BigInt(_e) << BigInt(32)) + BigInt(ce + this[++ue] * 2 ** 8 + this[++ue] * 2 ** 16 + this[++ue] * 2 ** 24);
    }), A.prototype.readBigInt64BE = we(function(ue) {
      ue = ue >>> 0, ie(ue, "offset");
      const ce = this[ue], Ee = this[ue + 7];
      (ce === void 0 || Ee === void 0) && fe(ue, this.length - 8);
      const _e = (ce << 24) + // Overflow
      this[++ue] * 2 ** 16 + this[++ue] * 2 ** 8 + this[++ue];
      return (BigInt(_e) << BigInt(32)) + BigInt(this[++ue] * 2 ** 24 + this[++ue] * 2 ** 16 + this[++ue] * 2 ** 8 + Ee);
    }), A.prototype.readFloatLE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 4, this.length), c.read(this, ue, !0, 23, 4);
    }, A.prototype.readFloatBE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 4, this.length), c.read(this, ue, !1, 23, 4);
    }, A.prototype.readDoubleLE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 8, this.length), c.read(this, ue, !0, 52, 8);
    }, A.prototype.readDoubleBE = function(ue, ce) {
      return ue = ue >>> 0, ce || V(ue, 8, this.length), c.read(this, ue, !1, 52, 8);
    };
    function Z(Ae, ue, ce, Ee, _e, Te) {
      if (!A.isBuffer(Ae)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (ue > _e || ue < Te) throw new RangeError('"value" argument is out of bounds');
      if (ce + Ee > Ae.length) throw new RangeError("Index out of range");
    }
    A.prototype.writeUintLE = A.prototype.writeUIntLE = function(ue, ce, Ee, _e) {
      if (ue = +ue, ce = ce >>> 0, Ee = Ee >>> 0, !_e) {
        const Re = Math.pow(2, 8 * Ee) - 1;
        Z(this, ue, ce, Ee, Re, 0);
      }
      let Te = 1, ke = 0;
      for (this[ce] = ue & 255; ++ke < Ee && (Te *= 256); )
        this[ce + ke] = ue / Te & 255;
      return ce + Ee;
    }, A.prototype.writeUintBE = A.prototype.writeUIntBE = function(ue, ce, Ee, _e) {
      if (ue = +ue, ce = ce >>> 0, Ee = Ee >>> 0, !_e) {
        const Re = Math.pow(2, 8 * Ee) - 1;
        Z(this, ue, ce, Ee, Re, 0);
      }
      let Te = Ee - 1, ke = 1;
      for (this[ce + Te] = ue & 255; --Te >= 0 && (ke *= 256); )
        this[ce + Te] = ue / ke & 255;
      return ce + Ee;
    }, A.prototype.writeUint8 = A.prototype.writeUInt8 = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 1, 255, 0), this[ce] = ue & 255, ce + 1;
    }, A.prototype.writeUint16LE = A.prototype.writeUInt16LE = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 2, 65535, 0), this[ce] = ue & 255, this[ce + 1] = ue >>> 8, ce + 2;
    }, A.prototype.writeUint16BE = A.prototype.writeUInt16BE = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 2, 65535, 0), this[ce] = ue >>> 8, this[ce + 1] = ue & 255, ce + 2;
    }, A.prototype.writeUint32LE = A.prototype.writeUInt32LE = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 4, 4294967295, 0), this[ce + 3] = ue >>> 24, this[ce + 2] = ue >>> 16, this[ce + 1] = ue >>> 8, this[ce] = ue & 255, ce + 4;
    }, A.prototype.writeUint32BE = A.prototype.writeUInt32BE = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 4, 4294967295, 0), this[ce] = ue >>> 24, this[ce + 1] = ue >>> 16, this[ce + 2] = ue >>> 8, this[ce + 3] = ue & 255, ce + 4;
    };
    function ne(Ae, ue, ce, Ee, _e) {
      se(ue, Ee, _e, Ae, ce, 7);
      let Te = Number(ue & BigInt(4294967295));
      Ae[ce++] = Te, Te = Te >> 8, Ae[ce++] = Te, Te = Te >> 8, Ae[ce++] = Te, Te = Te >> 8, Ae[ce++] = Te;
      let ke = Number(ue >> BigInt(32) & BigInt(4294967295));
      return Ae[ce++] = ke, ke = ke >> 8, Ae[ce++] = ke, ke = ke >> 8, Ae[ce++] = ke, ke = ke >> 8, Ae[ce++] = ke, ce;
    }
    function K(Ae, ue, ce, Ee, _e) {
      se(ue, Ee, _e, Ae, ce, 7);
      let Te = Number(ue & BigInt(4294967295));
      Ae[ce + 7] = Te, Te = Te >> 8, Ae[ce + 6] = Te, Te = Te >> 8, Ae[ce + 5] = Te, Te = Te >> 8, Ae[ce + 4] = Te;
      let ke = Number(ue >> BigInt(32) & BigInt(4294967295));
      return Ae[ce + 3] = ke, ke = ke >> 8, Ae[ce + 2] = ke, ke = ke >> 8, Ae[ce + 1] = ke, ke = ke >> 8, Ae[ce] = ke, ce + 8;
    }
    A.prototype.writeBigUInt64LE = we(function(ue, ce = 0) {
      return ne(this, ue, ce, BigInt(0), BigInt("0xffffffffffffffff"));
    }), A.prototype.writeBigUInt64BE = we(function(ue, ce = 0) {
      return K(this, ue, ce, BigInt(0), BigInt("0xffffffffffffffff"));
    }), A.prototype.writeIntLE = function(ue, ce, Ee, _e) {
      if (ue = +ue, ce = ce >>> 0, !_e) {
        const Be = Math.pow(2, 8 * Ee - 1);
        Z(this, ue, ce, Ee, Be - 1, -Be);
      }
      let Te = 0, ke = 1, Re = 0;
      for (this[ce] = ue & 255; ++Te < Ee && (ke *= 256); )
        ue < 0 && Re === 0 && this[ce + Te - 1] !== 0 && (Re = 1), this[ce + Te] = (ue / ke >> 0) - Re & 255;
      return ce + Ee;
    }, A.prototype.writeIntBE = function(ue, ce, Ee, _e) {
      if (ue = +ue, ce = ce >>> 0, !_e) {
        const Be = Math.pow(2, 8 * Ee - 1);
        Z(this, ue, ce, Ee, Be - 1, -Be);
      }
      let Te = Ee - 1, ke = 1, Re = 0;
      for (this[ce + Te] = ue & 255; --Te >= 0 && (ke *= 256); )
        ue < 0 && Re === 0 && this[ce + Te + 1] !== 0 && (Re = 1), this[ce + Te] = (ue / ke >> 0) - Re & 255;
      return ce + Ee;
    }, A.prototype.writeInt8 = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 1, 127, -128), ue < 0 && (ue = 255 + ue + 1), this[ce] = ue & 255, ce + 1;
    }, A.prototype.writeInt16LE = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 2, 32767, -32768), this[ce] = ue & 255, this[ce + 1] = ue >>> 8, ce + 2;
    }, A.prototype.writeInt16BE = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 2, 32767, -32768), this[ce] = ue >>> 8, this[ce + 1] = ue & 255, ce + 2;
    }, A.prototype.writeInt32LE = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 4, 2147483647, -2147483648), this[ce] = ue & 255, this[ce + 1] = ue >>> 8, this[ce + 2] = ue >>> 16, this[ce + 3] = ue >>> 24, ce + 4;
    }, A.prototype.writeInt32BE = function(ue, ce, Ee) {
      return ue = +ue, ce = ce >>> 0, Ee || Z(this, ue, ce, 4, 2147483647, -2147483648), ue < 0 && (ue = 4294967295 + ue + 1), this[ce] = ue >>> 24, this[ce + 1] = ue >>> 16, this[ce + 2] = ue >>> 8, this[ce + 3] = ue & 255, ce + 4;
    }, A.prototype.writeBigInt64LE = we(function(ue, ce = 0) {
      return ne(this, ue, ce, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), A.prototype.writeBigInt64BE = we(function(ue, ce = 0) {
      return K(this, ue, ce, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function q(Ae, ue, ce, Ee, _e, Te) {
      if (ce + Ee > Ae.length) throw new RangeError("Index out of range");
      if (ce < 0) throw new RangeError("Index out of range");
    }
    function Y(Ae, ue, ce, Ee, _e) {
      return ue = +ue, ce = ce >>> 0, _e || q(Ae, ue, ce, 4), c.write(Ae, ue, ce, Ee, 23, 4), ce + 4;
    }
    A.prototype.writeFloatLE = function(ue, ce, Ee) {
      return Y(this, ue, ce, !0, Ee);
    }, A.prototype.writeFloatBE = function(ue, ce, Ee) {
      return Y(this, ue, ce, !1, Ee);
    };
    function ee(Ae, ue, ce, Ee, _e) {
      return ue = +ue, ce = ce >>> 0, _e || q(Ae, ue, ce, 8), c.write(Ae, ue, ce, Ee, 52, 8), ce + 8;
    }
    A.prototype.writeDoubleLE = function(ue, ce, Ee) {
      return ee(this, ue, ce, !0, Ee);
    }, A.prototype.writeDoubleBE = function(ue, ce, Ee) {
      return ee(this, ue, ce, !1, Ee);
    }, A.prototype.copy = function(ue, ce, Ee, _e) {
      if (!A.isBuffer(ue)) throw new TypeError("argument should be a Buffer");
      if (Ee || (Ee = 0), !_e && _e !== 0 && (_e = this.length), ce >= ue.length && (ce = ue.length), ce || (ce = 0), _e > 0 && _e < Ee && (_e = Ee), _e === Ee || ue.length === 0 || this.length === 0) return 0;
      if (ce < 0)
        throw new RangeError("targetStart out of bounds");
      if (Ee < 0 || Ee >= this.length) throw new RangeError("Index out of range");
      if (_e < 0) throw new RangeError("sourceEnd out of bounds");
      _e > this.length && (_e = this.length), ue.length - ce < _e - Ee && (_e = ue.length - ce + Ee);
      const Te = _e - Ee;
      return this === ue && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(ce, Ee, _e) : Uint8Array.prototype.set.call(
        ue,
        this.subarray(Ee, _e),
        ce
      ), Te;
    }, A.prototype.fill = function(ue, ce, Ee, _e) {
      if (typeof ue == "string") {
        if (typeof ce == "string" ? (_e = ce, ce = 0, Ee = this.length) : typeof Ee == "string" && (_e = Ee, Ee = this.length), _e !== void 0 && typeof _e != "string")
          throw new TypeError("encoding must be a string");
        if (typeof _e == "string" && !A.isEncoding(_e))
          throw new TypeError("Unknown encoding: " + _e);
        if (ue.length === 1) {
          const ke = ue.charCodeAt(0);
          (_e === "utf8" && ke < 128 || _e === "latin1") && (ue = ke);
        }
      } else typeof ue == "number" ? ue = ue & 255 : typeof ue == "boolean" && (ue = Number(ue));
      if (ce < 0 || this.length < ce || this.length < Ee)
        throw new RangeError("Out of range index");
      if (Ee <= ce)
        return this;
      ce = ce >>> 0, Ee = Ee === void 0 ? this.length : Ee >>> 0, ue || (ue = 0);
      let Te;
      if (typeof ue == "number")
        for (Te = ce; Te < Ee; ++Te)
          this[Te] = ue;
      else {
        const ke = A.isBuffer(ue) ? ue : A.from(ue, _e), Re = ke.length;
        if (Re === 0)
          throw new TypeError('The value "' + ue + '" is invalid for argument "value"');
        for (Te = 0; Te < Ee - ce; ++Te)
          this[Te + ce] = ke[Te % Re];
      }
      return this;
    };
    const Q = {};
    function J(Ae, ue, ce) {
      Q[Ae] = class extends ce {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: ue.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${Ae}]`, this.stack, delete this.name;
        }
        get code() {
          return Ae;
        }
        set code(_e) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: _e,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${Ae}]: ${this.message}`;
        }
      };
    }
    J(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(Ae) {
        return Ae ? `${Ae} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), J(
      "ERR_INVALID_ARG_TYPE",
      function(Ae, ue) {
        return `The "${Ae}" argument must be of type number. Received type ${typeof ue}`;
      },
      TypeError
    ), J(
      "ERR_OUT_OF_RANGE",
      function(Ae, ue, ce) {
        let Ee = `The value of "${Ae}" is out of range.`, _e = ce;
        return Number.isInteger(ce) && Math.abs(ce) > 2 ** 32 ? _e = te(String(ce)) : typeof ce == "bigint" && (_e = String(ce), (ce > BigInt(2) ** BigInt(32) || ce < -(BigInt(2) ** BigInt(32))) && (_e = te(_e)), _e += "n"), Ee += ` It must be ${ue}. Received ${_e}`, Ee;
      },
      RangeError
    );
    function te(Ae) {
      let ue = "", ce = Ae.length;
      const Ee = Ae[0] === "-" ? 1 : 0;
      for (; ce >= Ee + 4; ce -= 3)
        ue = `_${Ae.slice(ce - 3, ce)}${ue}`;
      return `${Ae.slice(0, ce)}${ue}`;
    }
    function ae(Ae, ue, ce) {
      ie(ue, "offset"), (Ae[ue] === void 0 || Ae[ue + ce] === void 0) && fe(ue, Ae.length - (ce + 1));
    }
    function se(Ae, ue, ce, Ee, _e, Te) {
      if (Ae > ce || Ae < ue) {
        const ke = typeof ue == "bigint" ? "n" : "";
        let Re;
        throw ue === 0 || ue === BigInt(0) ? Re = `>= 0${ke} and < 2${ke} ** ${(Te + 1) * 8}${ke}` : Re = `>= -(2${ke} ** ${(Te + 1) * 8 - 1}${ke}) and < 2 ** ${(Te + 1) * 8 - 1}${ke}`, new Q.ERR_OUT_OF_RANGE("value", Re, Ae);
      }
      ae(Ee, _e, Te);
    }
    function ie(Ae, ue) {
      if (typeof Ae != "number")
        throw new Q.ERR_INVALID_ARG_TYPE(ue, "number", Ae);
    }
    function fe(Ae, ue, ce) {
      throw Math.floor(Ae) !== Ae ? (ie(Ae, ce), new Q.ERR_OUT_OF_RANGE("offset", "an integer", Ae)) : ue < 0 ? new Q.ERR_BUFFER_OUT_OF_BOUNDS() : new Q.ERR_OUT_OF_RANGE(
        "offset",
        `>= 0 and <= ${ue}`,
        Ae
      );
    }
    const ge = /[^+/0-9A-Za-z-_]/g;
    function me(Ae) {
      if (Ae = Ae.split("=")[0], Ae = Ae.trim().replace(ge, ""), Ae.length < 2) return "";
      for (; Ae.length % 4 !== 0; )
        Ae = Ae + "=";
      return Ae;
    }
    function pe(Ae, ue) {
      ue = ue || 1 / 0;
      let ce;
      const Ee = Ae.length;
      let _e = null;
      const Te = [];
      for (let ke = 0; ke < Ee; ++ke) {
        if (ce = Ae.charCodeAt(ke), ce > 55295 && ce < 57344) {
          if (!_e) {
            if (ce > 56319) {
              (ue -= 3) > -1 && Te.push(239, 191, 189);
              continue;
            } else if (ke + 1 === Ee) {
              (ue -= 3) > -1 && Te.push(239, 191, 189);
              continue;
            }
            _e = ce;
            continue;
          }
          if (ce < 56320) {
            (ue -= 3) > -1 && Te.push(239, 191, 189), _e = ce;
            continue;
          }
          ce = (_e - 55296 << 10 | ce - 56320) + 65536;
        } else _e && (ue -= 3) > -1 && Te.push(239, 191, 189);
        if (_e = null, ce < 128) {
          if ((ue -= 1) < 0) break;
          Te.push(ce);
        } else if (ce < 2048) {
          if ((ue -= 2) < 0) break;
          Te.push(
            ce >> 6 | 192,
            ce & 63 | 128
          );
        } else if (ce < 65536) {
          if ((ue -= 3) < 0) break;
          Te.push(
            ce >> 12 | 224,
            ce >> 6 & 63 | 128,
            ce & 63 | 128
          );
        } else if (ce < 1114112) {
          if ((ue -= 4) < 0) break;
          Te.push(
            ce >> 18 | 240,
            ce >> 12 & 63 | 128,
            ce >> 6 & 63 | 128,
            ce & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return Te;
    }
    function be(Ae) {
      const ue = [];
      for (let ce = 0; ce < Ae.length; ++ce)
        ue.push(Ae.charCodeAt(ce) & 255);
      return ue;
    }
    function le(Ae, ue) {
      let ce, Ee, _e;
      const Te = [];
      for (let ke = 0; ke < Ae.length && !((ue -= 2) < 0); ++ke)
        ce = Ae.charCodeAt(ke), Ee = ce >> 8, _e = ce % 256, Te.push(_e), Te.push(Ee);
      return Te;
    }
    function ve(Ae) {
      return s.toByteArray(me(Ae));
    }
    function he(Ae, ue, ce, Ee) {
      let _e;
      for (_e = 0; _e < Ee && !(_e + ce >= ue.length || _e >= Ae.length); ++_e)
        ue[_e + ce] = Ae[_e];
      return _e;
    }
    function ye(Ae, ue) {
      return Ae instanceof ue || Ae != null && Ae.constructor != null && Ae.constructor.name != null && Ae.constructor.name === ue.name;
    }
    function Ce(Ae) {
      return Ae !== Ae;
    }
    const xe = function() {
      const Ae = "0123456789abcdef", ue = new Array(256);
      for (let ce = 0; ce < 16; ++ce) {
        const Ee = ce * 16;
        for (let _e = 0; _e < 16; ++_e)
          ue[Ee + _e] = Ae[ce] + Ae[_e];
      }
      return ue;
    }();
    function we(Ae) {
      return typeof BigInt > "u" ? $e : Ae;
    }
    function $e() {
      throw new Error("BigInt not supported");
    }
  }(buffer$1)), buffer$1;
}
var bufferExports = requireBuffer();
const langs = ["en", "zh", "ja", "ko", "ar", "th", "pl", "it", "de", "es", "fr"], Lang = enumType(langs);
objectType({
  // -----------------used in ui-----------------
  cancel: stringType(),
  close: stringType(),
  set: stringType(),
  clear: stringType(),
  field: stringType(),
  fieldName: stringType(),
  align: stringType(),
  width: stringType(),
  opacity: stringType(),
  height: stringType(),
  rotate: stringType(),
  edit: stringType(),
  required: stringType(),
  editable: stringType(),
  plsInputName: stringType(),
  fieldMustUniq: stringType(),
  notUniq: stringType(),
  noKeyName: stringType(),
  fieldsList: stringType(),
  editField: stringType(),
  type: stringType(),
  errorOccurred: stringType(),
  errorBulkUpdateFieldName: stringType(),
  commitBulkUpdateFieldName: stringType(),
  bulkUpdateFieldName: stringType(),
  addPageAfter: stringType(),
  removePage: stringType(),
  removePageConfirm: stringType(),
  // --------------------validation-------------------
  "validation.uniqueName": stringType(),
  "validation.hexColor": stringType(),
  "validation.dateTimeFormat": stringType(),
  // -----------------used in schemas-----------------
  "schemas.color": stringType(),
  "schemas.borderWidth": stringType(),
  "schemas.borderColor": stringType(),
  "schemas.backgroundColor": stringType(),
  "schemas.textColor": stringType(),
  "schemas.bgColor": stringType(),
  "schemas.horizontal": stringType(),
  "schemas.vertical": stringType(),
  "schemas.left": stringType(),
  "schemas.center": stringType(),
  "schemas.right": stringType(),
  "schemas.top": stringType(),
  "schemas.middle": stringType(),
  "schemas.bottom": stringType(),
  "schemas.padding": stringType(),
  "schemas.text.fontName": stringType(),
  "schemas.text.size": stringType(),
  "schemas.text.spacing": stringType(),
  "schemas.text.textAlign": stringType(),
  "schemas.text.verticalAlign": stringType(),
  "schemas.text.lineHeight": stringType(),
  "schemas.text.min": stringType(),
  "schemas.text.max": stringType(),
  "schemas.text.fit": stringType(),
  "schemas.text.dynamicFontSize": stringType(),
  "schemas.text.format": stringType(),
  "schemas.radius": stringType(),
  "schemas.mvt.typingInstructions": stringType(),
  "schemas.mvt.sampleField": stringType(),
  "schemas.mvt.variablesSampleData": stringType(),
  "schemas.barcodes.barColor": stringType(),
  "schemas.barcodes.includetext": stringType(),
  "schemas.table.alternateBackgroundColor": stringType(),
  "schemas.table.tableStyle": stringType(),
  "schemas.table.showHead": stringType(),
  "schemas.table.headStyle": stringType(),
  "schemas.table.bodyStyle": stringType(),
  "schemas.table.columnStyle": stringType(),
  "schemas.date.format": stringType(),
  "schemas.date.locale": stringType(),
  "schemas.select.options": stringType(),
  "schemas.select.optionPlaceholder": stringType(),
  "schemas.radioGroup.groupName": stringType()
});
enumType(["viewer", "form", "designer"]);
const ColorType = enumType(["rgb", "cmyk"]).optional();
objectType({ height: numberType(), width: numberType() });
const Schema$1 = objectType({
  name: stringType(),
  type: stringType(),
  content: stringType().optional(),
  position: objectType({ x: numberType(), y: numberType() }),
  width: numberType(),
  height: numberType(),
  rotate: numberType().optional(),
  opacity: numberType().optional(),
  readOnly: booleanType().optional(),
  required: booleanType().optional(),
  __bodyRange: objectType({ start: numberType(), end: numberType().optional() }).optional(),
  __isSplit: booleanType().optional()
}).passthrough(), SchemaForUIAdditionalInfo = objectType({ id: stringType() });
Schema$1.merge(SchemaForUIAdditionalInfo);
const ArrayBufferSchema = anyType().refine((a) => a instanceof ArrayBuffer), Uint8ArraySchema = anyType().refine((a) => a instanceof Uint8Array), BlankPdf = objectType({
  width: numberType(),
  height: numberType(),
  padding: tupleType([numberType(), numberType(), numberType(), numberType()]),
  staticSchema: arrayType(Schema$1).optional()
}), CustomPdf = unionType([stringType(), ArrayBufferSchema, Uint8ArraySchema]), BasePdf = unionType([CustomPdf, BlankPdf]);
arrayType(recordType(Schema$1));
const SchemaPageArray = arrayType(arrayType(Schema$1)), Template = objectType({
  schemas: SchemaPageArray,
  basePdf: BasePdf,
  pdfmeVersion: stringType().optional()
}).passthrough(), Inputs = arrayType(recordType(anyType())).min(1), Font = recordType(objectType({
  data: unionType([stringType(), ArrayBufferSchema, Uint8ArraySchema]),
  fallback: booleanType().optional(),
  subset: booleanType().optional()
})), Plugin = objectType({
  ui: functionType().args(anyType()).returns(anyType()),
  pdf: functionType().args(anyType()).returns(anyType()),
  propPanel: objectType({
    schema: unknownType(),
    widgets: recordType(anyType()).optional(),
    defaultSchema: Schema$1
  }),
  icon: stringType().optional()
}).passthrough(), CommonOptions = objectType({ font: Font.optional() }).passthrough(), CommonProps = objectType({
  template: Template,
  options: CommonOptions.optional(),
  plugins: recordType(Plugin).optional()
}), GeneratorOptions = CommonOptions.extend({
  colorType: ColorType,
  author: stringType().optional(),
  creationDate: dateType().optional(),
  creator: stringType().optional(),
  keywords: arrayType(stringType()).optional(),
  lang: Lang.optional(),
  modificationDate: dateType().optional(),
  producer: stringType().optional(),
  subject: stringType().optional(),
  title: stringType().optional()
});
CommonProps.extend({
  inputs: Inputs,
  options: GeneratorOptions.optional()
}).strict();
const UIOptions = CommonOptions.extend({
  lang: Lang.optional(),
  labels: recordType(stringType(), stringType()).optional(),
  theme: recordType(stringType(), unknownType()).optional(),
  icons: recordType(stringType(), stringType()).optional(),
  requiredByDefault: booleanType().optional(),
  maxZoom: numberType().optional(),
  sidebarOpen: booleanType().optional(),
  zoomLevel: numberType().optional()
}), HTMLElementSchema = anyType().refine((a) => a instanceof HTMLElement), UIProps = CommonProps.extend({
  domContainer: HTMLElementSchema,
  options: UIOptions.optional()
}), PreviewProps = UIProps.extend({ inputs: Inputs }).strict(), DesignerProps = UIProps.extend({}).strict(), cloneDeep$1 = structuredClone, uniq = (a) => Array.from(new Set(a)), getFallbackFontName = (a) => {
  const s = "", c = Object.entries(a).reduce((u, d) => {
    const [p, v] = d;
    return !u && v.fallback ? p : u;
  }, s);
  if (c === s)
    throw Error("[@pdfme/common] fallback flag is not found in font. true fallback flag must be only one.");
  return c;
}, getDefaultFont = () => ({
  [DEFAULT_FONT_NAME]: { data: b64toUint8Array(DEFAULT_FONT_VALUE), fallback: !0 }
}), mm2pt = (a) => parseFloat(String(a)) * MM_TO_PT_RATIO, pt2mm = (a) => a * PT_TO_MM_RATIO, pt2px = (a) => a * PT_TO_PX_RATIO, px2mm = (a) => parseFloat(String(a)) * 0.26458333333333, blob2Base64Pdf = (a) => new Promise((s, c) => {
  const u = new FileReader();
  u.onloadend = () => {
    u.result.startsWith("data:application/pdf;") ? s(u.result) : c(Error("[@pdfme/common] template.basePdf must be pdf data."));
  }, u.readAsDataURL(a);
}), isHexValid = (a) => /^#(?:[A-Fa-f0-9]{3,4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/i.test(a), migrateTemplate = (a) => {
  a.schemas && Array.isArray(a.schemas) && a.schemas.length > 0 && !Array.isArray(a.schemas[0]) && (a.schemas = a.schemas.map((s) => Object.entries(s).map(([c, u]) => ({
    ...u,
    name: c
  }))));
}, getB64BasePdf = async (a) => {
  if (typeof a == "string" && !a.startsWith("data:application/pdf;") && typeof window < "u") {
    const u = await (await fetch(a)).blob();
    return blob2Base64Pdf(u);
  }
  if (typeof a == "string")
    return a;
  const s = a instanceof Uint8Array ? a : new Uint8Array(a);
  return "data:application/pdf;base64," + bufferExports.Buffer.from(s).toString("base64");
}, isBlankPdf = (a) => BlankPdf.safeParse(a).success, getByteString = (a) => bufferExports.Buffer.from(a, "base64").toString("binary"), b64toUint8Array = (a) => {
  const s = a.split(";base64,")[1] ? a.split(";base64,")[1] : a, c = getByteString(s), u = new Uint8Array(c.length);
  for (let d = 0; d < c.length; d += 1)
    u[d] = c.charCodeAt(d);
  return u;
}, getFontNamesInSchemas = (a) => uniq(a.map((s) => s.map((c) => c.fontName ?? "")).reduce((s, c) => s.concat(c), []).filter(Boolean)), checkFont = (a) => {
  const { font: s, template: { schemas: c } } = a, d = Object.values(s).reduce((A, x) => x.fallback ? A + 1 : A, 0);
  if (d === 0)
    throw Error(`[@pdfme/common] fallback flag is not found in font. true fallback flag must be only one.
Check this document: https://pdfme.com/docs/custom-fonts#about-font-type`);
  if (d > 1)
    throw Error(`[@pdfme/common] ${d} fallback flags found in font. true fallback flag must be only one.
Check this document: https://pdfme.com/docs/custom-fonts#about-font-type`);
  const p = getFontNamesInSchemas(c), v = Object.keys(s);
  if (p.some((A) => !v.includes(A)))
    throw Error(`[@pdfme/common] ${p.filter((A) => !v.includes(A)).join()} of template.schemas is not found in font.
Check this document: https://pdfme.com/docs/custom-fonts`);
}, checkPlugins = (a) => {
  const { plugins: s, template: { schemas: c } } = a, u = uniq(c.map((p) => p.map((v) => v.type)).flat()), d = Object.values(s).map((p) => p ? p.propPanel.defaultSchema.type : void 0);
  if (u.some((p) => !d.includes(p)))
    throw Error(`[@pdfme/common] ${u.filter((p) => !d.includes(p)).join()} of template.schemas is not found in plugins.`);
}, checkProps = (a, s) => {
  try {
    s.parse(a);
  } catch (c) {
    if (c instanceof ZodError) {
      const u = c.issues.map((d) => `ERROR POSITION: ${d.path.join(".")}
ERROR MESSAGE: ${d.message}
--------------------------`);
      throw Error(`[@pdfme/common] Invalid argument:
--------------------------
${u.join(`
`)}`);
    } else
      throw Error(`[@pdfme/common] Unexpected parsing error: ${c instanceof Error ? c.message : String(c)}`);
  }
  if (a && typeof a == "object" && "template" in a && "options" in a) {
    const { template: c, options: u } = a;
    u && u.font && checkFont({ font: u.font, template: c });
  }
  if (a && typeof a == "object" && "template" in a && "plugins" in a) {
    const { template: c, plugins: u } = a;
    u && checkPlugins({ plugins: u, template: c });
  }
}, checkInputs = (a) => checkProps(a, Inputs), checkUIOptions = (a) => checkProps(a, UIOptions), checkPreviewProps = (a) => checkProps(a, PreviewProps), checkDesignerProps = (a) => checkProps(a, DesignerProps), checkUIProps = (a) => {
  typeof a == "object" && a !== null && "template" in a && migrateTemplate(a.template), checkProps(a, UIProps);
}, checkTemplate = (a) => {
  migrateTemplate(a), checkProps(a, Template);
};
class LayoutNode {
  constructor({ width: s = 0, height: c = 0 } = {}) {
    Object.defineProperty(this, "index", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "schema", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "children", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: []
    }), Object.defineProperty(this, "width", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "height", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "padding", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: [0, 0, 0, 0]
    }), Object.defineProperty(this, "position", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: { x: 0, y: 0 }
    }), this.width = s, this.height = c;
  }
  setIndex(s) {
    this.index = s;
  }
  setSchema(s) {
    this.schema = s;
  }
  setWidth(s) {
    this.width = s;
  }
  setHeight(s) {
    this.height = s;
  }
  setPadding(s) {
    this.padding = s;
  }
  setPosition(s) {
    this.position = s;
  }
  insertChild(s) {
    const c = this.getChildCount();
    s.setIndex(c), this.children.splice(c, 0, s);
  }
  getChildCount() {
    return this.children.length;
  }
  getChild(s) {
    return this.children[s];
  }
}
function createPage(a) {
  const s = new LayoutNode({ ...a });
  return s.setPadding(a.padding), s;
}
function createNode(a) {
  const { position: s, width: c, height: u, schema: d } = a, p = new LayoutNode({ width: c, height: u });
  return p.setPosition(s), p.setSchema(d), p;
}
function resortChildren(a, s) {
  a.children = a.children.sort((c, u) => {
    const d = s.get(c.schema?.name ?? ""), p = s.get(u.schema?.name ?? "");
    if (d === void 0 || p === void 0)
      throw new Error("[@pdfme/common] order is not defined");
    return d - p;
  }).map((c, u) => (c.setIndex(u), c));
}
async function createOnePage(a) {
  const { basePdf: s, schemaPage: c, orderMap: u, input: d, options: p, _cache: v, getDynamicHeights: A } = a, x = createPage(s), g = [], b = cloneDeep$1(c).sort((m, C) => m.position.y - C.position.y), y = /* @__PURE__ */ new Map();
  for (const m of b) {
    const { position: C, width: w } = m, S = { schema: m, basePdf: s, options: p, _cache: v }, $ = (m.readOnly ? m.content : d?.[m.name]) || "", T = await A($, S), I = T.reduce((E, R) => E + R, 0), _ = m.height;
    I !== _ && y.set(C.y + _, I - _), T.forEach((E, R) => {
      let O = m.position.y + T.reduce((B, F, M) => M < R ? B + F : B, 0);
      for (const [B, F] of y.entries())
        B <= m.position.y && (O += F);
      const L = createNode({ schema: m, position: { ...C, y: O }, width: w, height: E });
      g.push(O + E + s.padding[2]), x.insertChild(L);
    });
  }
  const f = Math.max(...g, s.height - s.padding[2]);
  return x.setHeight(f), resortChildren(x, u), x;
}
function breakIntoPages(a) {
  const { longPage: s, orderMap: c, basePdf: u } = a, d = [createPage(u)], [p, , v] = u.padding, A = [], x = (y) => u.height - v - (y > 0 ? p : 0), g = (y, f) => {
    const m = y - f * (u.height - p - v);
    for (; d.length <= f; )
      d[f] || (d.push(createPage(u)), A.push({ page: f, value: (m - p) * -1 }));
    return m + (A.find((C) => C.page === f)?.value || 0);
  }, b = s.children.sort((y, f) => y.position.y - f.position.y);
  for (let y = 0; y < b.length; y++) {
    const { schema: f, position: m, height: C, width: w } = b[y], { y: S, x: $ } = m;
    let T = Math.floor(S / x(d.length - 1)), I = g(S, T);
    if (I + C > u.height - v && (T++, I = g(S, T)), !f)
      throw new Error("[@pdfme/common] schema is undefined");
    const _ = createNode({ schema: f, position: { x: $, y: I }, width: w, height: C });
    d[T].insertChild(_);
  }
  return d.forEach((y) => resortChildren(y, c)), d;
}
function createNewTemplate(a, s) {
  const c = {
    schemas: Array.from({ length: a.length }, () => []),
    basePdf: s
  }, u = /* @__PURE__ */ new Map();
  return cloneDeep$1(a).forEach((d, p) => {
    d.children.forEach((v) => {
      const { schema: A } = v;
      if (!A)
        throw new Error("[@pdfme/common] schema is undefined");
      const x = A.name;
      u.has(x) || u.set(x, []), u.get(x).push(v);
      const g = d.children.filter((y) => y.schema?.name === x), b = u.get(x).length - g.length;
      if (g.length > 0) {
        if (!g[0].schema)
          throw new Error("[@pdfme/common] schema is undefined");
        const y = g[0].schema, f = g.reduce((S, $) => S + $.height, 0), m = g[0].position;
        y.__bodyRange = {
          start: Math.max(b - 1, 0),
          end: b + g.length - 1
        }, y.__isSplit = b > 0;
        const C = Object.assign({}, y, { position: m, height: f }), w = c.schemas[p].findIndex((S) => S.name === x);
        w !== -1 ? c.schemas[p][w] = C : c.schemas[p].push(C);
      }
    });
  }), c;
}
const getDynamicTemplate = async (a) => {
  const { template: s } = a;
  if (!isBlankPdf(s.basePdf))
    return s;
  const c = s.basePdf, u = [];
  for (const d of s.schemas) {
    const p = new Map(d.map((x, g) => [x.name, g])), v = await createOnePage({ basePdf: c, schemaPage: d, orderMap: p, ...a }), A = breakIntoPages({ longPage: v, basePdf: c, orderMap: p });
    u.push(...A);
  }
  return createNewTemplate(u, s.basePdf);
};
var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], nonASCIIidentifierChars = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", nonASCIIidentifierStartChars = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟍꟐꟑꟓꟕ-Ƛꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", reservedWords = {
  3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
  5: "class enum extends super const export import",
  6: "enum",
  strict: "implements interface let package private protected public static yield",
  strictBind: "eval arguments"
}, ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", keywords$1 = {
  5: ecma5AndLessKeywords,
  "5module": ecma5AndLessKeywords + " export import",
  6: ecma5AndLessKeywords + " const class extends export import super"
}, keywordRelationalOperator = /^in(stanceof)?$/, nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]"), nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
function isInAstralSet(a, s) {
  for (var c = 65536, u = 0; u < s.length; u += 2) {
    if (c += s[u], c > a)
      return !1;
    if (c += s[u + 1], c >= a)
      return !0;
  }
  return !1;
}
function isIdentifierStart(a, s) {
  return a < 65 ? a === 36 : a < 91 ? !0 : a < 97 ? a === 95 : a < 123 ? !0 : a <= 65535 ? a >= 170 && nonASCIIidentifierStart.test(String.fromCharCode(a)) : s === !1 ? !1 : isInAstralSet(a, astralIdentifierStartCodes);
}
function isIdentifierChar(a, s) {
  return a < 48 ? a === 36 : a < 58 ? !0 : a < 65 ? !1 : a < 91 ? !0 : a < 97 ? a === 95 : a < 123 ? !0 : a <= 65535 ? a >= 170 && nonASCIIidentifier.test(String.fromCharCode(a)) : s === !1 ? !1 : isInAstralSet(a, astralIdentifierStartCodes) || isInAstralSet(a, astralIdentifierCodes);
}
var TokenType = function(s, c) {
  c === void 0 && (c = {}), this.label = s, this.keyword = c.keyword, this.beforeExpr = !!c.beforeExpr, this.startsExpr = !!c.startsExpr, this.isLoop = !!c.isLoop, this.isAssign = !!c.isAssign, this.prefix = !!c.prefix, this.postfix = !!c.postfix, this.binop = c.binop || null, this.updateContext = null;
};
function binop(a, s) {
  return new TokenType(a, { beforeExpr: !0, binop: s });
}
var beforeExpr = { beforeExpr: !0 }, startsExpr = { startsExpr: !0 }, keywords = {};
function kw(a, s) {
  return s === void 0 && (s = {}), s.keyword = a, keywords[a] = new TokenType(a, s);
}
var types$1 = {
  num: new TokenType("num", startsExpr),
  regexp: new TokenType("regexp", startsExpr),
  string: new TokenType("string", startsExpr),
  name: new TokenType("name", startsExpr),
  privateId: new TokenType("privateId", startsExpr),
  eof: new TokenType("eof"),
  // Punctuation token types.
  bracketL: new TokenType("[", { beforeExpr: !0, startsExpr: !0 }),
  bracketR: new TokenType("]"),
  braceL: new TokenType("{", { beforeExpr: !0, startsExpr: !0 }),
  braceR: new TokenType("}"),
  parenL: new TokenType("(", { beforeExpr: !0, startsExpr: !0 }),
  parenR: new TokenType(")"),
  comma: new TokenType(",", beforeExpr),
  semi: new TokenType(";", beforeExpr),
  colon: new TokenType(":", beforeExpr),
  dot: new TokenType("."),
  question: new TokenType("?", beforeExpr),
  questionDot: new TokenType("?."),
  arrow: new TokenType("=>", beforeExpr),
  template: new TokenType("template"),
  invalidTemplate: new TokenType("invalidTemplate"),
  ellipsis: new TokenType("...", beforeExpr),
  backQuote: new TokenType("`", startsExpr),
  dollarBraceL: new TokenType("${", { beforeExpr: !0, startsExpr: !0 }),
  // Operators. These carry several kinds of properties to help the
  // parser use them properly (the presence of these properties is
  // what categorizes them as operators).
  //
  // `binop`, when present, specifies that this operator is a binary
  // operator, and will refer to its precedence.
  //
  // `prefix` and `postfix` mark the operator as a prefix or postfix
  // unary operator.
  //
  // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
  // binary operators with a very low precedence, that should result
  // in AssignmentExpression nodes.
  eq: new TokenType("=", { beforeExpr: !0, isAssign: !0 }),
  assign: new TokenType("_=", { beforeExpr: !0, isAssign: !0 }),
  incDec: new TokenType("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
  prefix: new TokenType("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  logicalOR: binop("||", 1),
  logicalAND: binop("&&", 2),
  bitwiseOR: binop("|", 3),
  bitwiseXOR: binop("^", 4),
  bitwiseAND: binop("&", 5),
  equality: binop("==/!=/===/!==", 6),
  relational: binop("</>/<=/>=", 7),
  bitShift: binop("<</>>/>>>", 8),
  plusMin: new TokenType("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
  modulo: binop("%", 10),
  star: binop("*", 10),
  slash: binop("/", 10),
  starstar: new TokenType("**", { beforeExpr: !0 }),
  coalesce: binop("??", 1),
  // Keyword token types.
  _break: kw("break"),
  _case: kw("case", beforeExpr),
  _catch: kw("catch"),
  _continue: kw("continue"),
  _debugger: kw("debugger"),
  _default: kw("default", beforeExpr),
  _do: kw("do", { isLoop: !0, beforeExpr: !0 }),
  _else: kw("else", beforeExpr),
  _finally: kw("finally"),
  _for: kw("for", { isLoop: !0 }),
  _function: kw("function", startsExpr),
  _if: kw("if"),
  _return: kw("return", beforeExpr),
  _switch: kw("switch"),
  _throw: kw("throw", beforeExpr),
  _try: kw("try"),
  _var: kw("var"),
  _const: kw("const"),
  _while: kw("while", { isLoop: !0 }),
  _with: kw("with"),
  _new: kw("new", { beforeExpr: !0, startsExpr: !0 }),
  _this: kw("this", startsExpr),
  _super: kw("super", startsExpr),
  _class: kw("class", startsExpr),
  _extends: kw("extends", beforeExpr),
  _export: kw("export"),
  _import: kw("import", startsExpr),
  _null: kw("null", startsExpr),
  _true: kw("true", startsExpr),
  _false: kw("false", startsExpr),
  _in: kw("in", { beforeExpr: !0, binop: 7 }),
  _instanceof: kw("instanceof", { beforeExpr: !0, binop: 7 }),
  _typeof: kw("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  _void: kw("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  _delete: kw("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
}, lineBreak = /\r\n?|\n|\u2028|\u2029/, lineBreakG = new RegExp(lineBreak.source, "g");
function isNewLine(a) {
  return a === 10 || a === 13 || a === 8232 || a === 8233;
}
function nextLineBreak(a, s, c) {
  c === void 0 && (c = a.length);
  for (var u = s; u < c; u++) {
    var d = a.charCodeAt(u);
    if (isNewLine(d))
      return u < c - 1 && d === 13 && a.charCodeAt(u + 1) === 10 ? u + 2 : u + 1;
  }
  return -1;
}
var nonASCIIwhitespace = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, ref$1 = Object.prototype, hasOwnProperty$d = ref$1.hasOwnProperty, toString$1 = ref$1.toString, hasOwn = Object.hasOwn || function(a, s) {
  return hasOwnProperty$d.call(a, s);
}, isArray$3 = Array.isArray || function(a) {
  return toString$1.call(a) === "[object Array]";
}, regexpCache = /* @__PURE__ */ Object.create(null);
function wordsRegexp(a) {
  return regexpCache[a] || (regexpCache[a] = new RegExp("^(?:" + a.replace(/ /g, "|") + ")$"));
}
function codePointToString(a) {
  return a <= 65535 ? String.fromCharCode(a) : (a -= 65536, String.fromCharCode((a >> 10) + 55296, (a & 1023) + 56320));
}
var loneSurrogate = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, Position = function(s, c) {
  this.line = s, this.column = c;
};
Position.prototype.offset = function(s) {
  return new Position(this.line, this.column + s);
};
var SourceLocation = function(s, c, u) {
  this.start = c, this.end = u, s.sourceFile !== null && (this.source = s.sourceFile);
};
function getLineInfo(a, s) {
  for (var c = 1, u = 0; ; ) {
    var d = nextLineBreak(a, u, s);
    if (d < 0)
      return new Position(c, s - u);
    ++c, u = d;
  }
}
var defaultOptions$1 = {
  // `ecmaVersion` indicates the ECMAScript version to parse. Must be
  // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
  // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
  // (the latest version the library supports). This influences
  // support for strict mode, the set of reserved words, and support
  // for new syntax features.
  ecmaVersion: null,
  // `sourceType` indicates the mode the code should be parsed in.
  // Can be either `"script"` or `"module"`. This influences global
  // strict mode and parsing of `import` and `export` declarations.
  sourceType: "script",
  // `onInsertedSemicolon` can be a callback that will be called when
  // a semicolon is automatically inserted. It will be passed the
  // position of the inserted semicolon as an offset, and if
  // `locations` is enabled, it is given the location as a `{line,
  // column}` object as second argument.
  onInsertedSemicolon: null,
  // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
  // trailing commas.
  onTrailingComma: null,
  // By default, reserved words are only enforced if ecmaVersion >= 5.
  // Set `allowReserved` to a boolean value to explicitly turn this on
  // an off. When this option has the value "never", reserved words
  // and keywords can also not be used as property names.
  allowReserved: null,
  // When enabled, a return at the top level is not considered an
  // error.
  allowReturnOutsideFunction: !1,
  // When enabled, import/export statements are not constrained to
  // appearing at the top of the program, and an import.meta expression
  // in a script isn't considered an error.
  allowImportExportEverywhere: !1,
  // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
  // When enabled, await identifiers are allowed to appear at the top-level scope,
  // but they are still not allowed in non-async functions.
  allowAwaitOutsideFunction: null,
  // When enabled, super identifiers are not constrained to
  // appearing in methods and do not raise an error when they appear elsewhere.
  allowSuperOutsideMethod: null,
  // When enabled, hashbang directive in the beginning of file is
  // allowed and treated as a line comment. Enabled by default when
  // `ecmaVersion` >= 2023.
  allowHashBang: !1,
  // By default, the parser will verify that private properties are
  // only used in places where they are valid and have been declared.
  // Set this to false to turn such checks off.
  checkPrivateFields: !0,
  // When `locations` is on, `loc` properties holding objects with
  // `start` and `end` properties in `{line, column}` form (with
  // line being 1-based and column 0-based) will be attached to the
  // nodes.
  locations: !1,
  // A function can be passed as `onToken` option, which will
  // cause Acorn to call that function with object in the same
  // format as tokens returned from `tokenizer().getToken()`. Note
  // that you are not allowed to call the parser from the
  // callback—that will corrupt its internal state.
  onToken: null,
  // A function can be passed as `onComment` option, which will
  // cause Acorn to call that function with `(block, text, start,
  // end)` parameters whenever a comment is skipped. `block` is a
  // boolean indicating whether this is a block (`/* */`) comment,
  // `text` is the content of the comment, and `start` and `end` are
  // character offsets that denote the start and end of the comment.
  // When the `locations` option is on, two more parameters are
  // passed, the full `{line, column}` locations of the start and
  // end of the comments. Note that you are not allowed to call the
  // parser from the callback—that will corrupt its internal state.
  // When this option has an array as value, objects representing the
  // comments are pushed to it.
  onComment: null,
  // Nodes have their start and end characters offsets recorded in
  // `start` and `end` properties (directly on the node, rather than
  // the `loc` object, which holds line/column data. To also add a
  // [semi-standardized][range] `range` property holding a `[start,
  // end]` array with the same numbers, set the `ranges` option to
  // `true`.
  //
  // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
  ranges: !1,
  // It is possible to parse multiple files into a single AST by
  // passing the tree produced by parsing the first file as
  // `program` option in subsequent parses. This will add the
  // toplevel forms of the parsed file to the `Program` (top) node
  // of an existing parse tree.
  program: null,
  // When `locations` is on, you can pass this to record the source
  // file in every node's `loc` object.
  sourceFile: null,
  // This value, if given, is stored in every node, whether
  // `locations` is on or off.
  directSourceFile: null,
  // When enabled, parenthesized expressions are represented by
  // (non-standard) ParenthesizedExpression nodes
  preserveParens: !1
}, warnedAboutEcmaVersion = !1;
function getOptions(a) {
  var s = {};
  for (var c in defaultOptions$1)
    s[c] = a && hasOwn(a, c) ? a[c] : defaultOptions$1[c];
  if (s.ecmaVersion === "latest" ? s.ecmaVersion = 1e8 : s.ecmaVersion == null ? (!warnedAboutEcmaVersion && typeof console == "object" && console.warn && (warnedAboutEcmaVersion = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), s.ecmaVersion = 11) : s.ecmaVersion >= 2015 && (s.ecmaVersion -= 2009), s.allowReserved == null && (s.allowReserved = s.ecmaVersion < 5), (!a || a.allowHashBang == null) && (s.allowHashBang = s.ecmaVersion >= 14), isArray$3(s.onToken)) {
    var u = s.onToken;
    s.onToken = function(d) {
      return u.push(d);
    };
  }
  return isArray$3(s.onComment) && (s.onComment = pushComment(s, s.onComment)), s;
}
function pushComment(a, s) {
  return function(c, u, d, p, v, A) {
    var x = {
      type: c ? "Block" : "Line",
      value: u,
      start: d,
      end: p
    };
    a.locations && (x.loc = new SourceLocation(this, v, A)), a.ranges && (x.range = [d, p]), s.push(x);
  };
}
var SCOPE_TOP = 1, SCOPE_FUNCTION = 2, SCOPE_ASYNC = 4, SCOPE_GENERATOR = 8, SCOPE_ARROW = 16, SCOPE_SIMPLE_CATCH = 32, SCOPE_SUPER = 64, SCOPE_DIRECT_SUPER = 128, SCOPE_CLASS_STATIC_BLOCK = 256, SCOPE_CLASS_FIELD_INIT = 512, SCOPE_VAR = SCOPE_TOP | SCOPE_FUNCTION | SCOPE_CLASS_STATIC_BLOCK;
function functionFlags(a, s) {
  return SCOPE_FUNCTION | (a ? SCOPE_ASYNC : 0) | (s ? SCOPE_GENERATOR : 0);
}
var BIND_NONE = 0, BIND_VAR = 1, BIND_LEXICAL = 2, BIND_FUNCTION = 3, BIND_SIMPLE_CATCH = 4, BIND_OUTSIDE = 5, Parser = function(s, c, u) {
  this.options = s = getOptions(s), this.sourceFile = s.sourceFile, this.keywords = wordsRegexp(keywords$1[s.ecmaVersion >= 6 ? 6 : s.sourceType === "module" ? "5module" : 5]);
  var d = "";
  s.allowReserved !== !0 && (d = reservedWords[s.ecmaVersion >= 6 ? 6 : s.ecmaVersion === 5 ? 5 : 3], s.sourceType === "module" && (d += " await")), this.reservedWords = wordsRegexp(d);
  var p = (d ? d + " " : "") + reservedWords.strict;
  this.reservedWordsStrict = wordsRegexp(p), this.reservedWordsStrictBind = wordsRegexp(p + " " + reservedWords.strictBind), this.input = String(c), this.containsEsc = !1, u ? (this.pos = u, this.lineStart = this.input.lastIndexOf(`
`, u - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(lineBreak).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = types$1.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = s.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && s.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(SCOPE_TOP), this.regexpState = null, this.privateNameStack = [];
}, prototypeAccessors = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
Parser.prototype.parse = function() {
  var s = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(s);
};
prototypeAccessors.inFunction.get = function() {
  return (this.currentVarScope().flags & SCOPE_FUNCTION) > 0;
};
prototypeAccessors.inGenerator.get = function() {
  return (this.currentVarScope().flags & SCOPE_GENERATOR) > 0;
};
prototypeAccessors.inAsync.get = function() {
  return (this.currentVarScope().flags & SCOPE_ASYNC) > 0;
};
prototypeAccessors.canAwait.get = function() {
  for (var a = this.scopeStack.length - 1; a >= 0; a--) {
    var s = this.scopeStack[a], c = s.flags;
    if (c & (SCOPE_CLASS_STATIC_BLOCK | SCOPE_CLASS_FIELD_INIT))
      return !1;
    if (c & SCOPE_FUNCTION)
      return (c & SCOPE_ASYNC) > 0;
  }
  return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
};
prototypeAccessors.allowSuper.get = function() {
  var a = this.currentThisScope(), s = a.flags;
  return (s & SCOPE_SUPER) > 0 || this.options.allowSuperOutsideMethod;
};
prototypeAccessors.allowDirectSuper.get = function() {
  return (this.currentThisScope().flags & SCOPE_DIRECT_SUPER) > 0;
};
prototypeAccessors.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
};
prototypeAccessors.allowNewDotTarget.get = function() {
  for (var a = this.scopeStack.length - 1; a >= 0; a--) {
    var s = this.scopeStack[a], c = s.flags;
    if (c & (SCOPE_CLASS_STATIC_BLOCK | SCOPE_CLASS_FIELD_INIT) || c & SCOPE_FUNCTION && !(c & SCOPE_ARROW))
      return !0;
  }
  return !1;
};
prototypeAccessors.inClassStaticBlock.get = function() {
  return (this.currentVarScope().flags & SCOPE_CLASS_STATIC_BLOCK) > 0;
};
Parser.extend = function() {
  for (var s = [], c = arguments.length; c--; ) s[c] = arguments[c];
  for (var u = this, d = 0; d < s.length; d++)
    u = s[d](u);
  return u;
};
Parser.parse = function(s, c) {
  return new this(c, s).parse();
};
Parser.parseExpressionAt = function(s, c, u) {
  var d = new this(u, s, c);
  return d.nextToken(), d.parseExpression();
};
Parser.tokenizer = function(s, c) {
  return new this(c, s);
};
Object.defineProperties(Parser.prototype, prototypeAccessors);
var pp$9 = Parser.prototype, literal = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
pp$9.strictDirective = function(a) {
  if (this.options.ecmaVersion < 5)
    return !1;
  for (; ; ) {
    skipWhiteSpace.lastIndex = a, a += skipWhiteSpace.exec(this.input)[0].length;
    var s = literal.exec(this.input.slice(a));
    if (!s)
      return !1;
    if ((s[1] || s[2]) === "use strict") {
      skipWhiteSpace.lastIndex = a + s[0].length;
      var c = skipWhiteSpace.exec(this.input), u = c.index + c[0].length, d = this.input.charAt(u);
      return d === ";" || d === "}" || lineBreak.test(c[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(d) || d === "!" && this.input.charAt(u + 1) === "=");
    }
    a += s[0].length, skipWhiteSpace.lastIndex = a, a += skipWhiteSpace.exec(this.input)[0].length, this.input[a] === ";" && a++;
  }
};
pp$9.eat = function(a) {
  return this.type === a ? (this.next(), !0) : !1;
};
pp$9.isContextual = function(a) {
  return this.type === types$1.name && this.value === a && !this.containsEsc;
};
pp$9.eatContextual = function(a) {
  return this.isContextual(a) ? (this.next(), !0) : !1;
};
pp$9.expectContextual = function(a) {
  this.eatContextual(a) || this.unexpected();
};
pp$9.canInsertSemicolon = function() {
  return this.type === types$1.eof || this.type === types$1.braceR || lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};
pp$9.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
};
pp$9.semicolon = function() {
  !this.eat(types$1.semi) && !this.insertSemicolon() && this.unexpected();
};
pp$9.afterTrailingComma = function(a, s) {
  if (this.type === a)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), s || this.next(), !0;
};
pp$9.expect = function(a) {
  this.eat(a) || this.unexpected();
};
pp$9.unexpected = function(a) {
  this.raise(a ?? this.start, "Unexpected token");
};
var DestructuringErrors = function() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
};
pp$9.checkPatternErrors = function(a, s) {
  if (a) {
    a.trailingComma > -1 && this.raiseRecoverable(a.trailingComma, "Comma is not permitted after the rest element");
    var c = s ? a.parenthesizedAssign : a.parenthesizedBind;
    c > -1 && this.raiseRecoverable(c, s ? "Assigning to rvalue" : "Parenthesized pattern");
  }
};
pp$9.checkExpressionErrors = function(a, s) {
  if (!a)
    return !1;
  var c = a.shorthandAssign, u = a.doubleProto;
  if (!s)
    return c >= 0 || u >= 0;
  c >= 0 && this.raise(c, "Shorthand property assignments are valid only in destructuring patterns"), u >= 0 && this.raiseRecoverable(u, "Redefinition of __proto__ property");
};
pp$9.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
};
pp$9.isSimpleAssignTarget = function(a) {
  return a.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(a.expression) : a.type === "Identifier" || a.type === "MemberExpression";
};
var pp$8 = Parser.prototype;
pp$8.parseTopLevel = function(a) {
  var s = /* @__PURE__ */ Object.create(null);
  for (a.body || (a.body = []); this.type !== types$1.eof; ) {
    var c = this.parseStatement(null, !0, s);
    a.body.push(c);
  }
  if (this.inModule)
    for (var u = 0, d = Object.keys(this.undefinedExports); u < d.length; u += 1) {
      var p = d[u];
      this.raiseRecoverable(this.undefinedExports[p].start, "Export '" + p + "' is not defined");
    }
  return this.adaptDirectivePrologue(a.body), this.next(), a.sourceType = this.options.sourceType, this.finishNode(a, "Program");
};
var loopLabel = { kind: "loop" }, switchLabel = { kind: "switch" };
pp$8.isLet = function(a) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return !1;
  skipWhiteSpace.lastIndex = this.pos;
  var s = skipWhiteSpace.exec(this.input), c = this.pos + s[0].length, u = this.input.charCodeAt(c);
  if (u === 91 || u === 92)
    return !0;
  if (a)
    return !1;
  if (u === 123 || u > 55295 && u < 56320)
    return !0;
  if (isIdentifierStart(u, !0)) {
    for (var d = c + 1; isIdentifierChar(u = this.input.charCodeAt(d), !0); )
      ++d;
    if (u === 92 || u > 55295 && u < 56320)
      return !0;
    var p = this.input.slice(c, d);
    if (!keywordRelationalOperator.test(p))
      return !0;
  }
  return !1;
};
pp$8.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return !1;
  skipWhiteSpace.lastIndex = this.pos;
  var a = skipWhiteSpace.exec(this.input), s = this.pos + a[0].length, c;
  return !lineBreak.test(this.input.slice(this.pos, s)) && this.input.slice(s, s + 8) === "function" && (s + 8 === this.input.length || !(isIdentifierChar(c = this.input.charCodeAt(s + 8)) || c > 55295 && c < 56320));
};
pp$8.isUsingKeyword = function(a, s) {
  if (this.options.ecmaVersion < 17 || !this.isContextual(a ? "await" : "using"))
    return !1;
  skipWhiteSpace.lastIndex = this.pos;
  var c = skipWhiteSpace.exec(this.input), u = this.pos + c[0].length;
  if (lineBreak.test(this.input.slice(this.pos, u)))
    return !1;
  if (a) {
    var d = u + 5, p;
    if (this.input.slice(u, d) !== "using" || d === this.input.length || isIdentifierChar(p = this.input.charCodeAt(d)) || p > 55295 && p < 56320)
      return !1;
    skipWhiteSpace.lastIndex = d;
    var v = skipWhiteSpace.exec(this.input);
    if (v && lineBreak.test(this.input.slice(d, d + v[0].length)))
      return !1;
  }
  if (s) {
    var A = u + 2, x;
    if (this.input.slice(u, A) === "of" && (A === this.input.length || !isIdentifierChar(x = this.input.charCodeAt(A)) && !(x > 55295 && x < 56320)))
      return !1;
  }
  var g = this.input.charCodeAt(u);
  return isIdentifierStart(g, !0) || g === 92;
};
pp$8.isAwaitUsing = function(a) {
  return this.isUsingKeyword(!0, a);
};
pp$8.isUsing = function(a) {
  return this.isUsingKeyword(!1, a);
};
pp$8.parseStatement = function(a, s, c) {
  var u = this.type, d = this.startNode(), p;
  switch (this.isLet(a) && (u = types$1._var, p = "let"), u) {
    case types$1._break:
    case types$1._continue:
      return this.parseBreakContinueStatement(d, u.keyword);
    case types$1._debugger:
      return this.parseDebuggerStatement(d);
    case types$1._do:
      return this.parseDoStatement(d);
    case types$1._for:
      return this.parseForStatement(d);
    case types$1._function:
      return a && (this.strict || a !== "if" && a !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(d, !1, !a);
    case types$1._class:
      return a && this.unexpected(), this.parseClass(d, !0);
    case types$1._if:
      return this.parseIfStatement(d);
    case types$1._return:
      return this.parseReturnStatement(d);
    case types$1._switch:
      return this.parseSwitchStatement(d);
    case types$1._throw:
      return this.parseThrowStatement(d);
    case types$1._try:
      return this.parseTryStatement(d);
    case types$1._const:
    case types$1._var:
      return p = p || this.value, a && p !== "var" && this.unexpected(), this.parseVarStatement(d, p);
    case types$1._while:
      return this.parseWhileStatement(d);
    case types$1._with:
      return this.parseWithStatement(d);
    case types$1.braceL:
      return this.parseBlock(!0, d);
    case types$1.semi:
      return this.parseEmptyStatement(d);
    case types$1._export:
    case types$1._import:
      if (this.options.ecmaVersion > 10 && u === types$1._import) {
        skipWhiteSpace.lastIndex = this.pos;
        var v = skipWhiteSpace.exec(this.input), A = this.pos + v[0].length, x = this.input.charCodeAt(A);
        if (x === 40 || x === 46)
          return this.parseExpressionStatement(d, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (s || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), u === types$1._import ? this.parseImport(d) : this.parseExport(d, c);
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    default:
      if (this.isAsyncFunction())
        return a && this.unexpected(), this.next(), this.parseFunctionStatement(d, !0, !a);
      var g = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
      if (g)
        return s && this.options.sourceType === "script" && this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script`"), g === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(d, !1, g), this.semicolon(), this.finishNode(d, "VariableDeclaration");
      var b = this.value, y = this.parseExpression();
      return u === types$1.name && y.type === "Identifier" && this.eat(types$1.colon) ? this.parseLabeledStatement(d, b, y, a) : this.parseExpressionStatement(d, y);
  }
};
pp$8.parseBreakContinueStatement = function(a, s) {
  var c = s === "break";
  this.next(), this.eat(types$1.semi) || this.insertSemicolon() ? a.label = null : this.type !== types$1.name ? this.unexpected() : (a.label = this.parseIdent(), this.semicolon());
  for (var u = 0; u < this.labels.length; ++u) {
    var d = this.labels[u];
    if ((a.label == null || d.name === a.label.name) && (d.kind != null && (c || d.kind === "loop") || a.label && c))
      break;
  }
  return u === this.labels.length && this.raise(a.start, "Unsyntactic " + s), this.finishNode(a, c ? "BreakStatement" : "ContinueStatement");
};
pp$8.parseDebuggerStatement = function(a) {
  return this.next(), this.semicolon(), this.finishNode(a, "DebuggerStatement");
};
pp$8.parseDoStatement = function(a) {
  return this.next(), this.labels.push(loopLabel), a.body = this.parseStatement("do"), this.labels.pop(), this.expect(types$1._while), a.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(types$1.semi) : this.semicolon(), this.finishNode(a, "DoWhileStatement");
};
pp$8.parseForStatement = function(a) {
  this.next();
  var s = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(loopLabel), this.enterScope(0), this.expect(types$1.parenL), this.type === types$1.semi)
    return s > -1 && this.unexpected(s), this.parseFor(a, null);
  var c = this.isLet();
  if (this.type === types$1._var || this.type === types$1._const || c) {
    var u = this.startNode(), d = c ? "let" : this.value;
    return this.next(), this.parseVar(u, !0, d), this.finishNode(u, "VariableDeclaration"), this.parseForAfterInit(a, u, s);
  }
  var p = this.isContextual("let"), v = !1, A = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
  if (A) {
    var x = this.startNode();
    return this.next(), A === "await using" && this.next(), this.parseVar(x, !0, A), this.finishNode(x, "VariableDeclaration"), this.parseForAfterInit(a, x, s);
  }
  var g = this.containsEsc, b = new DestructuringErrors(), y = this.start, f = s > -1 ? this.parseExprSubscripts(b, "await") : this.parseExpression(!0, b);
  return this.type === types$1._in || (v = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (s > -1 ? (this.type === types$1._in && this.unexpected(s), a.await = !0) : v && this.options.ecmaVersion >= 8 && (f.start === y && !g && f.type === "Identifier" && f.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (a.await = !1)), p && v && this.raise(f.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(f, !1, b), this.checkLValPattern(f), this.parseForIn(a, f)) : (this.checkExpressionErrors(b, !0), s > -1 && this.unexpected(s), this.parseFor(a, f));
};
pp$8.parseForAfterInit = function(a, s, c) {
  return (this.type === types$1._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && s.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === types$1._in ? c > -1 && this.unexpected(c) : a.await = c > -1), this.parseForIn(a, s)) : (c > -1 && this.unexpected(c), this.parseFor(a, s));
};
pp$8.parseFunctionStatement = function(a, s, c) {
  return this.next(), this.parseFunction(a, FUNC_STATEMENT | (c ? 0 : FUNC_HANGING_STATEMENT), !1, s);
};
pp$8.parseIfStatement = function(a) {
  return this.next(), a.test = this.parseParenExpression(), a.consequent = this.parseStatement("if"), a.alternate = this.eat(types$1._else) ? this.parseStatement("if") : null, this.finishNode(a, "IfStatement");
};
pp$8.parseReturnStatement = function(a) {
  return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(types$1.semi) || this.insertSemicolon() ? a.argument = null : (a.argument = this.parseExpression(), this.semicolon()), this.finishNode(a, "ReturnStatement");
};
pp$8.parseSwitchStatement = function(a) {
  this.next(), a.discriminant = this.parseParenExpression(), a.cases = [], this.expect(types$1.braceL), this.labels.push(switchLabel), this.enterScope(0);
  for (var s, c = !1; this.type !== types$1.braceR; )
    if (this.type === types$1._case || this.type === types$1._default) {
      var u = this.type === types$1._case;
      s && this.finishNode(s, "SwitchCase"), a.cases.push(s = this.startNode()), s.consequent = [], this.next(), u ? s.test = this.parseExpression() : (c && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), c = !0, s.test = null), this.expect(types$1.colon);
    } else
      s || this.unexpected(), s.consequent.push(this.parseStatement(null));
  return this.exitScope(), s && this.finishNode(s, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(a, "SwitchStatement");
};
pp$8.parseThrowStatement = function(a) {
  return this.next(), lineBreak.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), a.argument = this.parseExpression(), this.semicolon(), this.finishNode(a, "ThrowStatement");
};
var empty$1 = [];
pp$8.parseCatchClauseParam = function() {
  var a = this.parseBindingAtom(), s = a.type === "Identifier";
  return this.enterScope(s ? SCOPE_SIMPLE_CATCH : 0), this.checkLValPattern(a, s ? BIND_SIMPLE_CATCH : BIND_LEXICAL), this.expect(types$1.parenR), a;
};
pp$8.parseTryStatement = function(a) {
  if (this.next(), a.block = this.parseBlock(), a.handler = null, this.type === types$1._catch) {
    var s = this.startNode();
    this.next(), this.eat(types$1.parenL) ? s.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), s.param = null, this.enterScope(0)), s.body = this.parseBlock(!1), this.exitScope(), a.handler = this.finishNode(s, "CatchClause");
  }
  return a.finalizer = this.eat(types$1._finally) ? this.parseBlock() : null, !a.handler && !a.finalizer && this.raise(a.start, "Missing catch or finally clause"), this.finishNode(a, "TryStatement");
};
pp$8.parseVarStatement = function(a, s, c) {
  return this.next(), this.parseVar(a, !1, s, c), this.semicolon(), this.finishNode(a, "VariableDeclaration");
};
pp$8.parseWhileStatement = function(a) {
  return this.next(), a.test = this.parseParenExpression(), this.labels.push(loopLabel), a.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(a, "WhileStatement");
};
pp$8.parseWithStatement = function(a) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), a.object = this.parseParenExpression(), a.body = this.parseStatement("with"), this.finishNode(a, "WithStatement");
};
pp$8.parseEmptyStatement = function(a) {
  return this.next(), this.finishNode(a, "EmptyStatement");
};
pp$8.parseLabeledStatement = function(a, s, c, u) {
  for (var d = 0, p = this.labels; d < p.length; d += 1) {
    var v = p[d];
    v.name === s && this.raise(c.start, "Label '" + s + "' is already declared");
  }
  for (var A = this.type.isLoop ? "loop" : this.type === types$1._switch ? "switch" : null, x = this.labels.length - 1; x >= 0; x--) {
    var g = this.labels[x];
    if (g.statementStart === a.start)
      g.statementStart = this.start, g.kind = A;
    else
      break;
  }
  return this.labels.push({ name: s, kind: A, statementStart: this.start }), a.body = this.parseStatement(u ? u.indexOf("label") === -1 ? u + "label" : u : "label"), this.labels.pop(), a.label = c, this.finishNode(a, "LabeledStatement");
};
pp$8.parseExpressionStatement = function(a, s) {
  return a.expression = s, this.semicolon(), this.finishNode(a, "ExpressionStatement");
};
pp$8.parseBlock = function(a, s, c) {
  for (a === void 0 && (a = !0), s === void 0 && (s = this.startNode()), s.body = [], this.expect(types$1.braceL), a && this.enterScope(0); this.type !== types$1.braceR; ) {
    var u = this.parseStatement(null);
    s.body.push(u);
  }
  return c && (this.strict = !1), this.next(), a && this.exitScope(), this.finishNode(s, "BlockStatement");
};
pp$8.parseFor = function(a, s) {
  return a.init = s, this.expect(types$1.semi), a.test = this.type === types$1.semi ? null : this.parseExpression(), this.expect(types$1.semi), a.update = this.type === types$1.parenR ? null : this.parseExpression(), this.expect(types$1.parenR), a.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(a, "ForStatement");
};
pp$8.parseForIn = function(a, s) {
  var c = this.type === types$1._in;
  return this.next(), s.type === "VariableDeclaration" && s.declarations[0].init != null && (!c || this.options.ecmaVersion < 8 || this.strict || s.kind !== "var" || s.declarations[0].id.type !== "Identifier") && this.raise(
    s.start,
    (c ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
  ), a.left = s, a.right = c ? this.parseExpression() : this.parseMaybeAssign(), this.expect(types$1.parenR), a.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(a, c ? "ForInStatement" : "ForOfStatement");
};
pp$8.parseVar = function(a, s, c, u) {
  for (a.declarations = [], a.kind = c; ; ) {
    var d = this.startNode();
    if (this.parseVarId(d, c), this.eat(types$1.eq) ? d.init = this.parseMaybeAssign(s) : !u && c === "const" && !(this.type === types$1._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !u && (c === "using" || c === "await using") && this.options.ecmaVersion >= 17 && this.type !== types$1._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + c + " declaration") : !u && d.id.type !== "Identifier" && !(s && (this.type === types$1._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : d.init = null, a.declarations.push(this.finishNode(d, "VariableDeclarator")), !this.eat(types$1.comma))
      break;
  }
  return a;
};
pp$8.parseVarId = function(a, s) {
  a.id = s === "using" || s === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(a.id, s === "var" ? BIND_VAR : BIND_LEXICAL, !1);
};
var FUNC_STATEMENT = 1, FUNC_HANGING_STATEMENT = 2, FUNC_NULLABLE_ID = 4;
pp$8.parseFunction = function(a, s, c, u, d) {
  this.initFunction(a), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !u) && (this.type === types$1.star && s & FUNC_HANGING_STATEMENT && this.unexpected(), a.generator = this.eat(types$1.star)), this.options.ecmaVersion >= 8 && (a.async = !!u), s & FUNC_STATEMENT && (a.id = s & FUNC_NULLABLE_ID && this.type !== types$1.name ? null : this.parseIdent(), a.id && !(s & FUNC_HANGING_STATEMENT) && this.checkLValSimple(a.id, this.strict || a.generator || a.async ? this.treatFunctionsAsVar ? BIND_VAR : BIND_LEXICAL : BIND_FUNCTION));
  var p = this.yieldPos, v = this.awaitPos, A = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(functionFlags(a.async, a.generator)), s & FUNC_STATEMENT || (a.id = this.type === types$1.name ? this.parseIdent() : null), this.parseFunctionParams(a), this.parseFunctionBody(a, c, !1, d), this.yieldPos = p, this.awaitPos = v, this.awaitIdentPos = A, this.finishNode(a, s & FUNC_STATEMENT ? "FunctionDeclaration" : "FunctionExpression");
};
pp$8.parseFunctionParams = function(a) {
  this.expect(types$1.parenL), a.params = this.parseBindingList(types$1.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
};
pp$8.parseClass = function(a, s) {
  this.next();
  var c = this.strict;
  this.strict = !0, this.parseClassId(a, s), this.parseClassSuper(a);
  var u = this.enterClassBody(), d = this.startNode(), p = !1;
  for (d.body = [], this.expect(types$1.braceL); this.type !== types$1.braceR; ) {
    var v = this.parseClassElement(a.superClass !== null);
    v && (d.body.push(v), v.type === "MethodDefinition" && v.kind === "constructor" ? (p && this.raiseRecoverable(v.start, "Duplicate constructor in the same class"), p = !0) : v.key && v.key.type === "PrivateIdentifier" && isPrivateNameConflicted(u, v) && this.raiseRecoverable(v.key.start, "Identifier '#" + v.key.name + "' has already been declared"));
  }
  return this.strict = c, this.next(), a.body = this.finishNode(d, "ClassBody"), this.exitClassBody(), this.finishNode(a, s ? "ClassDeclaration" : "ClassExpression");
};
pp$8.parseClassElement = function(a) {
  if (this.eat(types$1.semi))
    return null;
  var s = this.options.ecmaVersion, c = this.startNode(), u = "", d = !1, p = !1, v = "method", A = !1;
  if (this.eatContextual("static")) {
    if (s >= 13 && this.eat(types$1.braceL))
      return this.parseClassStaticBlock(c), c;
    this.isClassElementNameStart() || this.type === types$1.star ? A = !0 : u = "static";
  }
  if (c.static = A, !u && s >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === types$1.star) && !this.canInsertSemicolon() ? p = !0 : u = "async"), !u && (s >= 9 || !p) && this.eat(types$1.star) && (d = !0), !u && !p && !d) {
    var x = this.value;
    (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? v = x : u = x);
  }
  if (u ? (c.computed = !1, c.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), c.key.name = u, this.finishNode(c.key, "Identifier")) : this.parseClassElementName(c), s < 13 || this.type === types$1.parenL || v !== "method" || d || p) {
    var g = !c.static && checkKeyName(c, "constructor"), b = g && a;
    g && v !== "method" && this.raise(c.key.start, "Constructor can't have get/set modifier"), c.kind = g ? "constructor" : v, this.parseClassMethod(c, d, p, b);
  } else
    this.parseClassField(c);
  return c;
};
pp$8.isClassElementNameStart = function() {
  return this.type === types$1.name || this.type === types$1.privateId || this.type === types$1.num || this.type === types$1.string || this.type === types$1.bracketL || this.type.keyword;
};
pp$8.parseClassElementName = function(a) {
  this.type === types$1.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), a.computed = !1, a.key = this.parsePrivateIdent()) : this.parsePropertyName(a);
};
pp$8.parseClassMethod = function(a, s, c, u) {
  var d = a.key;
  a.kind === "constructor" ? (s && this.raise(d.start, "Constructor can't be a generator"), c && this.raise(d.start, "Constructor can't be an async method")) : a.static && checkKeyName(a, "prototype") && this.raise(d.start, "Classes may not have a static property named prototype");
  var p = a.value = this.parseMethod(s, c, u);
  return a.kind === "get" && p.params.length !== 0 && this.raiseRecoverable(p.start, "getter should have no params"), a.kind === "set" && p.params.length !== 1 && this.raiseRecoverable(p.start, "setter should have exactly one param"), a.kind === "set" && p.params[0].type === "RestElement" && this.raiseRecoverable(p.params[0].start, "Setter cannot use rest params"), this.finishNode(a, "MethodDefinition");
};
pp$8.parseClassField = function(a) {
  return checkKeyName(a, "constructor") ? this.raise(a.key.start, "Classes can't have a field named 'constructor'") : a.static && checkKeyName(a, "prototype") && this.raise(a.key.start, "Classes can't have a static field named 'prototype'"), this.eat(types$1.eq) ? (this.enterScope(SCOPE_CLASS_FIELD_INIT | SCOPE_SUPER), a.value = this.parseMaybeAssign(), this.exitScope()) : a.value = null, this.semicolon(), this.finishNode(a, "PropertyDefinition");
};
pp$8.parseClassStaticBlock = function(a) {
  a.body = [];
  var s = this.labels;
  for (this.labels = [], this.enterScope(SCOPE_CLASS_STATIC_BLOCK | SCOPE_SUPER); this.type !== types$1.braceR; ) {
    var c = this.parseStatement(null);
    a.body.push(c);
  }
  return this.next(), this.exitScope(), this.labels = s, this.finishNode(a, "StaticBlock");
};
pp$8.parseClassId = function(a, s) {
  this.type === types$1.name ? (a.id = this.parseIdent(), s && this.checkLValSimple(a.id, BIND_LEXICAL, !1)) : (s === !0 && this.unexpected(), a.id = null);
};
pp$8.parseClassSuper = function(a) {
  a.superClass = this.eat(types$1._extends) ? this.parseExprSubscripts(null, !1) : null;
};
pp$8.enterClassBody = function() {
  var a = { declared: /* @__PURE__ */ Object.create(null), used: [] };
  return this.privateNameStack.push(a), a.declared;
};
pp$8.exitClassBody = function() {
  var a = this.privateNameStack.pop(), s = a.declared, c = a.used;
  if (this.options.checkPrivateFields)
    for (var u = this.privateNameStack.length, d = u === 0 ? null : this.privateNameStack[u - 1], p = 0; p < c.length; ++p) {
      var v = c[p];
      hasOwn(s, v.name) || (d ? d.used.push(v) : this.raiseRecoverable(v.start, "Private field '#" + v.name + "' must be declared in an enclosing class"));
    }
};
function isPrivateNameConflicted(a, s) {
  var c = s.key.name, u = a[c], d = "true";
  return s.type === "MethodDefinition" && (s.kind === "get" || s.kind === "set") && (d = (s.static ? "s" : "i") + s.kind), u === "iget" && d === "iset" || u === "iset" && d === "iget" || u === "sget" && d === "sset" || u === "sset" && d === "sget" ? (a[c] = "true", !1) : u ? !0 : (a[c] = d, !1);
}
function checkKeyName(a, s) {
  var c = a.computed, u = a.key;
  return !c && (u.type === "Identifier" && u.name === s || u.type === "Literal" && u.value === s);
}
pp$8.parseExportAllDeclaration = function(a, s) {
  return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (a.exported = this.parseModuleExportName(), this.checkExport(s, a.exported, this.lastTokStart)) : a.exported = null), this.expectContextual("from"), this.type !== types$1.string && this.unexpected(), a.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (a.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(a, "ExportAllDeclaration");
};
pp$8.parseExport = function(a, s) {
  if (this.next(), this.eat(types$1.star))
    return this.parseExportAllDeclaration(a, s);
  if (this.eat(types$1._default))
    return this.checkExport(s, "default", this.lastTokStart), a.declaration = this.parseExportDefaultDeclaration(), this.finishNode(a, "ExportDefaultDeclaration");
  if (this.shouldParseExportStatement())
    a.declaration = this.parseExportDeclaration(a), a.declaration.type === "VariableDeclaration" ? this.checkVariableExport(s, a.declaration.declarations) : this.checkExport(s, a.declaration.id, a.declaration.id.start), a.specifiers = [], a.source = null, this.options.ecmaVersion >= 16 && (a.attributes = []);
  else {
    if (a.declaration = null, a.specifiers = this.parseExportSpecifiers(s), this.eatContextual("from"))
      this.type !== types$1.string && this.unexpected(), a.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (a.attributes = this.parseWithClause());
    else {
      for (var c = 0, u = a.specifiers; c < u.length; c += 1) {
        var d = u[c];
        this.checkUnreserved(d.local), this.checkLocalExport(d.local), d.local.type === "Literal" && this.raise(d.local.start, "A string literal cannot be used as an exported binding without `from`.");
      }
      a.source = null, this.options.ecmaVersion >= 16 && (a.attributes = []);
    }
    this.semicolon();
  }
  return this.finishNode(a, "ExportNamedDeclaration");
};
pp$8.parseExportDeclaration = function(a) {
  return this.parseStatement(null);
};
pp$8.parseExportDefaultDeclaration = function() {
  var a;
  if (this.type === types$1._function || (a = this.isAsyncFunction())) {
    var s = this.startNode();
    return this.next(), a && this.next(), this.parseFunction(s, FUNC_STATEMENT | FUNC_NULLABLE_ID, !1, a);
  } else if (this.type === types$1._class) {
    var c = this.startNode();
    return this.parseClass(c, "nullableID");
  } else {
    var u = this.parseMaybeAssign();
    return this.semicolon(), u;
  }
};
pp$8.checkExport = function(a, s, c) {
  a && (typeof s != "string" && (s = s.type === "Identifier" ? s.name : s.value), hasOwn(a, s) && this.raiseRecoverable(c, "Duplicate export '" + s + "'"), a[s] = !0);
};
pp$8.checkPatternExport = function(a, s) {
  var c = s.type;
  if (c === "Identifier")
    this.checkExport(a, s, s.start);
  else if (c === "ObjectPattern")
    for (var u = 0, d = s.properties; u < d.length; u += 1) {
      var p = d[u];
      this.checkPatternExport(a, p);
    }
  else if (c === "ArrayPattern")
    for (var v = 0, A = s.elements; v < A.length; v += 1) {
      var x = A[v];
      x && this.checkPatternExport(a, x);
    }
  else c === "Property" ? this.checkPatternExport(a, s.value) : c === "AssignmentPattern" ? this.checkPatternExport(a, s.left) : c === "RestElement" && this.checkPatternExport(a, s.argument);
};
pp$8.checkVariableExport = function(a, s) {
  if (a)
    for (var c = 0, u = s; c < u.length; c += 1) {
      var d = u[c];
      this.checkPatternExport(a, d.id);
    }
};
pp$8.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
pp$8.parseExportSpecifier = function(a) {
  var s = this.startNode();
  return s.local = this.parseModuleExportName(), s.exported = this.eatContextual("as") ? this.parseModuleExportName() : s.local, this.checkExport(
    a,
    s.exported,
    s.exported.start
  ), this.finishNode(s, "ExportSpecifier");
};
pp$8.parseExportSpecifiers = function(a) {
  var s = [], c = !0;
  for (this.expect(types$1.braceL); !this.eat(types$1.braceR); ) {
    if (c)
      c = !1;
    else if (this.expect(types$1.comma), this.afterTrailingComma(types$1.braceR))
      break;
    s.push(this.parseExportSpecifier(a));
  }
  return s;
};
pp$8.parseImport = function(a) {
  return this.next(), this.type === types$1.string ? (a.specifiers = empty$1, a.source = this.parseExprAtom()) : (a.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), a.source = this.type === types$1.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (a.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(a, "ImportDeclaration");
};
pp$8.parseImportSpecifier = function() {
  var a = this.startNode();
  return a.imported = this.parseModuleExportName(), this.eatContextual("as") ? a.local = this.parseIdent() : (this.checkUnreserved(a.imported), a.local = a.imported), this.checkLValSimple(a.local, BIND_LEXICAL), this.finishNode(a, "ImportSpecifier");
};
pp$8.parseImportDefaultSpecifier = function() {
  var a = this.startNode();
  return a.local = this.parseIdent(), this.checkLValSimple(a.local, BIND_LEXICAL), this.finishNode(a, "ImportDefaultSpecifier");
};
pp$8.parseImportNamespaceSpecifier = function() {
  var a = this.startNode();
  return this.next(), this.expectContextual("as"), a.local = this.parseIdent(), this.checkLValSimple(a.local, BIND_LEXICAL), this.finishNode(a, "ImportNamespaceSpecifier");
};
pp$8.parseImportSpecifiers = function() {
  var a = [], s = !0;
  if (this.type === types$1.name && (a.push(this.parseImportDefaultSpecifier()), !this.eat(types$1.comma)))
    return a;
  if (this.type === types$1.star)
    return a.push(this.parseImportNamespaceSpecifier()), a;
  for (this.expect(types$1.braceL); !this.eat(types$1.braceR); ) {
    if (s)
      s = !1;
    else if (this.expect(types$1.comma), this.afterTrailingComma(types$1.braceR))
      break;
    a.push(this.parseImportSpecifier());
  }
  return a;
};
pp$8.parseWithClause = function() {
  var a = [];
  if (!this.eat(types$1._with))
    return a;
  this.expect(types$1.braceL);
  for (var s = {}, c = !0; !this.eat(types$1.braceR); ) {
    if (c)
      c = !1;
    else if (this.expect(types$1.comma), this.afterTrailingComma(types$1.braceR))
      break;
    var u = this.parseImportAttribute(), d = u.key.type === "Identifier" ? u.key.name : u.key.value;
    hasOwn(s, d) && this.raiseRecoverable(u.key.start, "Duplicate attribute key '" + d + "'"), s[d] = !0, a.push(u);
  }
  return a;
};
pp$8.parseImportAttribute = function() {
  var a = this.startNode();
  return a.key = this.type === types$1.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(types$1.colon), this.type !== types$1.string && this.unexpected(), a.value = this.parseExprAtom(), this.finishNode(a, "ImportAttribute");
};
pp$8.parseModuleExportName = function() {
  if (this.options.ecmaVersion >= 13 && this.type === types$1.string) {
    var a = this.parseLiteral(this.value);
    return loneSurrogate.test(a.value) && this.raise(a.start, "An export name cannot include a lone surrogate."), a;
  }
  return this.parseIdent(!0);
};
pp$8.adaptDirectivePrologue = function(a) {
  for (var s = 0; s < a.length && this.isDirectiveCandidate(a[s]); ++s)
    a[s].directive = a[s].expression.raw.slice(1, -1);
};
pp$8.isDirectiveCandidate = function(a) {
  return this.options.ecmaVersion >= 5 && a.type === "ExpressionStatement" && a.expression.type === "Literal" && typeof a.expression.value == "string" && // Reject parenthesized strings.
  (this.input[a.start] === '"' || this.input[a.start] === "'");
};
var pp$7 = Parser.prototype;
pp$7.toAssignable = function(a, s, c) {
  if (this.options.ecmaVersion >= 6 && a)
    switch (a.type) {
      case "Identifier":
        this.inAsync && a.name === "await" && this.raise(a.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "AssignmentPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        a.type = "ObjectPattern", c && this.checkPatternErrors(c, !0);
        for (var u = 0, d = a.properties; u < d.length; u += 1) {
          var p = d[u];
          this.toAssignable(p, s), p.type === "RestElement" && (p.argument.type === "ArrayPattern" || p.argument.type === "ObjectPattern") && this.raise(p.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        a.kind !== "init" && this.raise(a.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(a.value, s);
        break;
      case "ArrayExpression":
        a.type = "ArrayPattern", c && this.checkPatternErrors(c, !0), this.toAssignableList(a.elements, s);
        break;
      case "SpreadElement":
        a.type = "RestElement", this.toAssignable(a.argument, s), a.argument.type === "AssignmentPattern" && this.raise(a.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        a.operator !== "=" && this.raise(a.left.end, "Only '=' operator can be used for specifying default value."), a.type = "AssignmentPattern", delete a.operator, this.toAssignable(a.left, s);
        break;
      case "ParenthesizedExpression":
        this.toAssignable(a.expression, s, c);
        break;
      case "ChainExpression":
        this.raiseRecoverable(a.start, "Optional chaining cannot appear in left-hand side");
        break;
      case "MemberExpression":
        if (!s)
          break;
      default:
        this.raise(a.start, "Assigning to rvalue");
    }
  else c && this.checkPatternErrors(c, !0);
  return a;
};
pp$7.toAssignableList = function(a, s) {
  for (var c = a.length, u = 0; u < c; u++) {
    var d = a[u];
    d && this.toAssignable(d, s);
  }
  if (c) {
    var p = a[c - 1];
    this.options.ecmaVersion === 6 && s && p && p.type === "RestElement" && p.argument.type !== "Identifier" && this.unexpected(p.argument.start);
  }
  return a;
};
pp$7.parseSpread = function(a) {
  var s = this.startNode();
  return this.next(), s.argument = this.parseMaybeAssign(!1, a), this.finishNode(s, "SpreadElement");
};
pp$7.parseRestBinding = function() {
  var a = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== types$1.name && this.unexpected(), a.argument = this.parseBindingAtom(), this.finishNode(a, "RestElement");
};
pp$7.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case types$1.bracketL:
        var a = this.startNode();
        return this.next(), a.elements = this.parseBindingList(types$1.bracketR, !0, !0), this.finishNode(a, "ArrayPattern");
      case types$1.braceL:
        return this.parseObj(!0);
    }
  return this.parseIdent();
};
pp$7.parseBindingList = function(a, s, c, u) {
  for (var d = [], p = !0; !this.eat(a); )
    if (p ? p = !1 : this.expect(types$1.comma), s && this.type === types$1.comma)
      d.push(null);
    else {
      if (c && this.afterTrailingComma(a))
        break;
      if (this.type === types$1.ellipsis) {
        var v = this.parseRestBinding();
        this.parseBindingListItem(v), d.push(v), this.type === types$1.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(a);
        break;
      } else
        d.push(this.parseAssignableListItem(u));
    }
  return d;
};
pp$7.parseAssignableListItem = function(a) {
  var s = this.parseMaybeDefault(this.start, this.startLoc);
  return this.parseBindingListItem(s), s;
};
pp$7.parseBindingListItem = function(a) {
  return a;
};
pp$7.parseMaybeDefault = function(a, s, c) {
  if (c = c || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(types$1.eq))
    return c;
  var u = this.startNodeAt(a, s);
  return u.left = c, u.right = this.parseMaybeAssign(), this.finishNode(u, "AssignmentPattern");
};
pp$7.checkLValSimple = function(a, s, c) {
  s === void 0 && (s = BIND_NONE);
  var u = s !== BIND_NONE;
  switch (a.type) {
    case "Identifier":
      this.strict && this.reservedWordsStrictBind.test(a.name) && this.raiseRecoverable(a.start, (u ? "Binding " : "Assigning to ") + a.name + " in strict mode"), u && (s === BIND_LEXICAL && a.name === "let" && this.raiseRecoverable(a.start, "let is disallowed as a lexically bound name"), c && (hasOwn(c, a.name) && this.raiseRecoverable(a.start, "Argument name clash"), c[a.name] = !0), s !== BIND_OUTSIDE && this.declareName(a.name, s, a.start));
      break;
    case "ChainExpression":
      this.raiseRecoverable(a.start, "Optional chaining cannot appear in left-hand side");
      break;
    case "MemberExpression":
      u && this.raiseRecoverable(a.start, "Binding member expression");
      break;
    case "ParenthesizedExpression":
      return u && this.raiseRecoverable(a.start, "Binding parenthesized expression"), this.checkLValSimple(a.expression, s, c);
    default:
      this.raise(a.start, (u ? "Binding" : "Assigning to") + " rvalue");
  }
};
pp$7.checkLValPattern = function(a, s, c) {
  switch (s === void 0 && (s = BIND_NONE), a.type) {
    case "ObjectPattern":
      for (var u = 0, d = a.properties; u < d.length; u += 1) {
        var p = d[u];
        this.checkLValInnerPattern(p, s, c);
      }
      break;
    case "ArrayPattern":
      for (var v = 0, A = a.elements; v < A.length; v += 1) {
        var x = A[v];
        x && this.checkLValInnerPattern(x, s, c);
      }
      break;
    default:
      this.checkLValSimple(a, s, c);
  }
};
pp$7.checkLValInnerPattern = function(a, s, c) {
  switch (s === void 0 && (s = BIND_NONE), a.type) {
    case "Property":
      this.checkLValInnerPattern(a.value, s, c);
      break;
    case "AssignmentPattern":
      this.checkLValPattern(a.left, s, c);
      break;
    case "RestElement":
      this.checkLValPattern(a.argument, s, c);
      break;
    default:
      this.checkLValPattern(a, s, c);
  }
};
var TokContext = function(s, c, u, d, p) {
  this.token = s, this.isExpr = !!c, this.preserveSpace = !!u, this.override = d, this.generator = !!p;
}, types$2 = {
  b_stat: new TokContext("{", !1),
  b_expr: new TokContext("{", !0),
  b_tmpl: new TokContext("${", !1),
  p_stat: new TokContext("(", !1),
  p_expr: new TokContext("(", !0),
  q_tmpl: new TokContext("`", !0, !0, function(a) {
    return a.tryReadTemplateToken();
  }),
  f_stat: new TokContext("function", !1),
  f_expr: new TokContext("function", !0),
  f_expr_gen: new TokContext("function", !0, !1, null, !0),
  f_gen: new TokContext("function", !1, !1, null, !0)
}, pp$6 = Parser.prototype;
pp$6.initialContext = function() {
  return [types$2.b_stat];
};
pp$6.curContext = function() {
  return this.context[this.context.length - 1];
};
pp$6.braceIsBlock = function(a) {
  var s = this.curContext();
  return s === types$2.f_expr || s === types$2.f_stat ? !0 : a === types$1.colon && (s === types$2.b_stat || s === types$2.b_expr) ? !s.isExpr : a === types$1._return || a === types$1.name && this.exprAllowed ? lineBreak.test(this.input.slice(this.lastTokEnd, this.start)) : a === types$1._else || a === types$1.semi || a === types$1.eof || a === types$1.parenR || a === types$1.arrow ? !0 : a === types$1.braceL ? s === types$2.b_stat : a === types$1._var || a === types$1._const || a === types$1.name ? !1 : !this.exprAllowed;
};
pp$6.inGeneratorContext = function() {
  for (var a = this.context.length - 1; a >= 1; a--) {
    var s = this.context[a];
    if (s.token === "function")
      return s.generator;
  }
  return !1;
};
pp$6.updateContext = function(a) {
  var s, c = this.type;
  c.keyword && a === types$1.dot ? this.exprAllowed = !1 : (s = c.updateContext) ? s.call(this, a) : this.exprAllowed = c.beforeExpr;
};
pp$6.overrideContext = function(a) {
  this.curContext() !== a && (this.context[this.context.length - 1] = a);
};
types$1.parenR.updateContext = types$1.braceR.updateContext = function() {
  if (this.context.length === 1) {
    this.exprAllowed = !0;
    return;
  }
  var a = this.context.pop();
  a === types$2.b_stat && this.curContext().token === "function" && (a = this.context.pop()), this.exprAllowed = !a.isExpr;
};
types$1.braceL.updateContext = function(a) {
  this.context.push(this.braceIsBlock(a) ? types$2.b_stat : types$2.b_expr), this.exprAllowed = !0;
};
types$1.dollarBraceL.updateContext = function() {
  this.context.push(types$2.b_tmpl), this.exprAllowed = !0;
};
types$1.parenL.updateContext = function(a) {
  var s = a === types$1._if || a === types$1._for || a === types$1._with || a === types$1._while;
  this.context.push(s ? types$2.p_stat : types$2.p_expr), this.exprAllowed = !0;
};
types$1.incDec.updateContext = function() {
};
types$1._function.updateContext = types$1._class.updateContext = function(a) {
  a.beforeExpr && a !== types$1._else && !(a === types$1.semi && this.curContext() !== types$2.p_stat) && !(a === types$1._return && lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) && !((a === types$1.colon || a === types$1.braceL) && this.curContext() === types$2.b_stat) ? this.context.push(types$2.f_expr) : this.context.push(types$2.f_stat), this.exprAllowed = !1;
};
types$1.colon.updateContext = function() {
  this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
};
types$1.backQuote.updateContext = function() {
  this.curContext() === types$2.q_tmpl ? this.context.pop() : this.context.push(types$2.q_tmpl), this.exprAllowed = !1;
};
types$1.star.updateContext = function(a) {
  if (a === types$1._function) {
    var s = this.context.length - 1;
    this.context[s] === types$2.f_expr ? this.context[s] = types$2.f_expr_gen : this.context[s] = types$2.f_gen;
  }
  this.exprAllowed = !0;
};
types$1.name.updateContext = function(a) {
  var s = !1;
  this.options.ecmaVersion >= 6 && a !== types$1.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (s = !0), this.exprAllowed = s;
};
var pp$5 = Parser.prototype;
pp$5.checkPropClash = function(a, s, c) {
  if (!(this.options.ecmaVersion >= 9 && a.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (a.computed || a.method || a.shorthand))) {
    var u = a.key, d;
    switch (u.type) {
      case "Identifier":
        d = u.name;
        break;
      case "Literal":
        d = String(u.value);
        break;
      default:
        return;
    }
    var p = a.kind;
    if (this.options.ecmaVersion >= 6) {
      d === "__proto__" && p === "init" && (s.proto && (c ? c.doubleProto < 0 && (c.doubleProto = u.start) : this.raiseRecoverable(u.start, "Redefinition of __proto__ property")), s.proto = !0);
      return;
    }
    d = "$" + d;
    var v = s[d];
    if (v) {
      var A;
      p === "init" ? A = this.strict && v.init || v.get || v.set : A = v.init || v[p], A && this.raiseRecoverable(u.start, "Redefinition of property");
    } else
      v = s[d] = {
        init: !1,
        get: !1,
        set: !1
      };
    v[p] = !0;
  }
};
pp$5.parseExpression = function(a, s) {
  var c = this.start, u = this.startLoc, d = this.parseMaybeAssign(a, s);
  if (this.type === types$1.comma) {
    var p = this.startNodeAt(c, u);
    for (p.expressions = [d]; this.eat(types$1.comma); )
      p.expressions.push(this.parseMaybeAssign(a, s));
    return this.finishNode(p, "SequenceExpression");
  }
  return d;
};
pp$5.parseMaybeAssign = function(a, s, c) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(a);
    this.exprAllowed = !1;
  }
  var u = !1, d = -1, p = -1, v = -1;
  s ? (d = s.parenthesizedAssign, p = s.trailingComma, v = s.doubleProto, s.parenthesizedAssign = s.trailingComma = -1) : (s = new DestructuringErrors(), u = !0);
  var A = this.start, x = this.startLoc;
  (this.type === types$1.parenL || this.type === types$1.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = a === "await");
  var g = this.parseMaybeConditional(a, s);
  if (c && (g = c.call(this, g, A, x)), this.type.isAssign) {
    var b = this.startNodeAt(A, x);
    return b.operator = this.value, this.type === types$1.eq && (g = this.toAssignable(g, !1, s)), u || (s.parenthesizedAssign = s.trailingComma = s.doubleProto = -1), s.shorthandAssign >= g.start && (s.shorthandAssign = -1), this.type === types$1.eq ? this.checkLValPattern(g) : this.checkLValSimple(g), b.left = g, this.next(), b.right = this.parseMaybeAssign(a), v > -1 && (s.doubleProto = v), this.finishNode(b, "AssignmentExpression");
  } else
    u && this.checkExpressionErrors(s, !0);
  return d > -1 && (s.parenthesizedAssign = d), p > -1 && (s.trailingComma = p), g;
};
pp$5.parseMaybeConditional = function(a, s) {
  var c = this.start, u = this.startLoc, d = this.parseExprOps(a, s);
  if (this.checkExpressionErrors(s))
    return d;
  if (this.eat(types$1.question)) {
    var p = this.startNodeAt(c, u);
    return p.test = d, p.consequent = this.parseMaybeAssign(), this.expect(types$1.colon), p.alternate = this.parseMaybeAssign(a), this.finishNode(p, "ConditionalExpression");
  }
  return d;
};
pp$5.parseExprOps = function(a, s) {
  var c = this.start, u = this.startLoc, d = this.parseMaybeUnary(s, !1, !1, a);
  return this.checkExpressionErrors(s) || d.start === c && d.type === "ArrowFunctionExpression" ? d : this.parseExprOp(d, c, u, -1, a);
};
pp$5.parseExprOp = function(a, s, c, u, d) {
  var p = this.type.binop;
  if (p != null && (!d || this.type !== types$1._in) && p > u) {
    var v = this.type === types$1.logicalOR || this.type === types$1.logicalAND, A = this.type === types$1.coalesce;
    A && (p = types$1.logicalAND.binop);
    var x = this.value;
    this.next();
    var g = this.start, b = this.startLoc, y = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, d), g, b, p, d), f = this.buildBinary(s, c, a, y, x, v || A);
    return (v && this.type === types$1.coalesce || A && (this.type === types$1.logicalOR || this.type === types$1.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(f, s, c, u, d);
  }
  return a;
};
pp$5.buildBinary = function(a, s, c, u, d, p) {
  u.type === "PrivateIdentifier" && this.raise(u.start, "Private identifier can only be left side of binary expression");
  var v = this.startNodeAt(a, s);
  return v.left = c, v.operator = d, v.right = u, this.finishNode(v, p ? "LogicalExpression" : "BinaryExpression");
};
pp$5.parseMaybeUnary = function(a, s, c, u) {
  var d = this.start, p = this.startLoc, v;
  if (this.isContextual("await") && this.canAwait)
    v = this.parseAwait(u), s = !0;
  else if (this.type.prefix) {
    var A = this.startNode(), x = this.type === types$1.incDec;
    A.operator = this.value, A.prefix = !0, this.next(), A.argument = this.parseMaybeUnary(null, !0, x, u), this.checkExpressionErrors(a, !0), x ? this.checkLValSimple(A.argument) : this.strict && A.operator === "delete" && isLocalVariableAccess(A.argument) ? this.raiseRecoverable(A.start, "Deleting local variable in strict mode") : A.operator === "delete" && isPrivateFieldAccess(A.argument) ? this.raiseRecoverable(A.start, "Private fields can not be deleted") : s = !0, v = this.finishNode(A, x ? "UpdateExpression" : "UnaryExpression");
  } else if (!s && this.type === types$1.privateId)
    (u || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), v = this.parsePrivateIdent(), this.type !== types$1._in && this.unexpected();
  else {
    if (v = this.parseExprSubscripts(a, u), this.checkExpressionErrors(a))
      return v;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var g = this.startNodeAt(d, p);
      g.operator = this.value, g.prefix = !1, g.argument = v, this.checkLValSimple(v), this.next(), v = this.finishNode(g, "UpdateExpression");
    }
  }
  if (!c && this.eat(types$1.starstar))
    if (s)
      this.unexpected(this.lastTokStart);
    else
      return this.buildBinary(d, p, v, this.parseMaybeUnary(null, !1, !1, u), "**", !1);
  else
    return v;
};
function isLocalVariableAccess(a) {
  return a.type === "Identifier" || a.type === "ParenthesizedExpression" && isLocalVariableAccess(a.expression);
}
function isPrivateFieldAccess(a) {
  return a.type === "MemberExpression" && a.property.type === "PrivateIdentifier" || a.type === "ChainExpression" && isPrivateFieldAccess(a.expression) || a.type === "ParenthesizedExpression" && isPrivateFieldAccess(a.expression);
}
pp$5.parseExprSubscripts = function(a, s) {
  var c = this.start, u = this.startLoc, d = this.parseExprAtom(a, s);
  if (d.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
    return d;
  var p = this.parseSubscripts(d, c, u, !1, s);
  return a && p.type === "MemberExpression" && (a.parenthesizedAssign >= p.start && (a.parenthesizedAssign = -1), a.parenthesizedBind >= p.start && (a.parenthesizedBind = -1), a.trailingComma >= p.start && (a.trailingComma = -1)), p;
};
pp$5.parseSubscripts = function(a, s, c, u, d) {
  for (var p = this.options.ecmaVersion >= 8 && a.type === "Identifier" && a.name === "async" && this.lastTokEnd === a.end && !this.canInsertSemicolon() && a.end - a.start === 5 && this.potentialArrowAt === a.start, v = !1; ; ) {
    var A = this.parseSubscript(a, s, c, u, p, v, d);
    if (A.optional && (v = !0), A === a || A.type === "ArrowFunctionExpression") {
      if (v) {
        var x = this.startNodeAt(s, c);
        x.expression = A, A = this.finishNode(x, "ChainExpression");
      }
      return A;
    }
    a = A;
  }
};
pp$5.shouldParseAsyncArrow = function() {
  return !this.canInsertSemicolon() && this.eat(types$1.arrow);
};
pp$5.parseSubscriptAsyncArrow = function(a, s, c, u) {
  return this.parseArrowExpression(this.startNodeAt(a, s), c, !0, u);
};
pp$5.parseSubscript = function(a, s, c, u, d, p, v) {
  var A = this.options.ecmaVersion >= 11, x = A && this.eat(types$1.questionDot);
  u && x && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
  var g = this.eat(types$1.bracketL);
  if (g || x && this.type !== types$1.parenL && this.type !== types$1.backQuote || this.eat(types$1.dot)) {
    var b = this.startNodeAt(s, c);
    b.object = a, g ? (b.property = this.parseExpression(), this.expect(types$1.bracketR)) : this.type === types$1.privateId && a.type !== "Super" ? b.property = this.parsePrivateIdent() : b.property = this.parseIdent(this.options.allowReserved !== "never"), b.computed = !!g, A && (b.optional = x), a = this.finishNode(b, "MemberExpression");
  } else if (!u && this.eat(types$1.parenL)) {
    var y = new DestructuringErrors(), f = this.yieldPos, m = this.awaitPos, C = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var w = this.parseExprList(types$1.parenR, this.options.ecmaVersion >= 8, !1, y);
    if (d && !x && this.shouldParseAsyncArrow())
      return this.checkPatternErrors(y, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = f, this.awaitPos = m, this.awaitIdentPos = C, this.parseSubscriptAsyncArrow(s, c, w, v);
    this.checkExpressionErrors(y, !0), this.yieldPos = f || this.yieldPos, this.awaitPos = m || this.awaitPos, this.awaitIdentPos = C || this.awaitIdentPos;
    var S = this.startNodeAt(s, c);
    S.callee = a, S.arguments = w, A && (S.optional = x), a = this.finishNode(S, "CallExpression");
  } else if (this.type === types$1.backQuote) {
    (x || p) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
    var $ = this.startNodeAt(s, c);
    $.tag = a, $.quasi = this.parseTemplate({ isTagged: !0 }), a = this.finishNode($, "TaggedTemplateExpression");
  }
  return a;
};
pp$5.parseExprAtom = function(a, s, c) {
  this.type === types$1.slash && this.readRegexp();
  var u, d = this.potentialArrowAt === this.start;
  switch (this.type) {
    case types$1._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), u = this.startNode(), this.next(), this.type === types$1.parenL && !this.allowDirectSuper && this.raise(u.start, "super() call outside constructor of a subclass"), this.type !== types$1.dot && this.type !== types$1.bracketL && this.type !== types$1.parenL && this.unexpected(), this.finishNode(u, "Super");
    case types$1._this:
      return u = this.startNode(), this.next(), this.finishNode(u, "ThisExpression");
    case types$1.name:
      var p = this.start, v = this.startLoc, A = this.containsEsc, x = this.parseIdent(!1);
      if (this.options.ecmaVersion >= 8 && !A && x.name === "async" && !this.canInsertSemicolon() && this.eat(types$1._function))
        return this.overrideContext(types$2.f_expr), this.parseFunction(this.startNodeAt(p, v), 0, !1, !0, s);
      if (d && !this.canInsertSemicolon()) {
        if (this.eat(types$1.arrow))
          return this.parseArrowExpression(this.startNodeAt(p, v), [x], !1, s);
        if (this.options.ecmaVersion >= 8 && x.name === "async" && this.type === types$1.name && !A && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
          return x = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(types$1.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(p, v), [x], !0, s);
      }
      return x;
    case types$1.regexp:
      var g = this.value;
      return u = this.parseLiteral(g.value), u.regex = { pattern: g.pattern, flags: g.flags }, u;
    case types$1.num:
    case types$1.string:
      return this.parseLiteral(this.value);
    case types$1._null:
    case types$1._true:
    case types$1._false:
      return u = this.startNode(), u.value = this.type === types$1._null ? null : this.type === types$1._true, u.raw = this.type.keyword, this.next(), this.finishNode(u, "Literal");
    case types$1.parenL:
      var b = this.start, y = this.parseParenAndDistinguishExpression(d, s);
      return a && (a.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(y) && (a.parenthesizedAssign = b), a.parenthesizedBind < 0 && (a.parenthesizedBind = b)), y;
    case types$1.bracketL:
      return u = this.startNode(), this.next(), u.elements = this.parseExprList(types$1.bracketR, !0, !0, a), this.finishNode(u, "ArrayExpression");
    case types$1.braceL:
      return this.overrideContext(types$2.b_expr), this.parseObj(!1, a);
    case types$1._function:
      return u = this.startNode(), this.next(), this.parseFunction(u, 0);
    case types$1._class:
      return this.parseClass(this.startNode(), !1);
    case types$1._new:
      return this.parseNew();
    case types$1.backQuote:
      return this.parseTemplate();
    case types$1._import:
      return this.options.ecmaVersion >= 11 ? this.parseExprImport(c) : this.unexpected();
    default:
      return this.parseExprAtomDefault();
  }
};
pp$5.parseExprAtomDefault = function() {
  this.unexpected();
};
pp$5.parseExprImport = function(a) {
  var s = this.startNode();
  if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === types$1.parenL && !a)
    return this.parseDynamicImport(s);
  if (this.type === types$1.dot) {
    var c = this.startNodeAt(s.start, s.loc && s.loc.start);
    return c.name = "import", s.meta = this.finishNode(c, "Identifier"), this.parseImportMeta(s);
  } else
    this.unexpected();
};
pp$5.parseDynamicImport = function(a) {
  if (this.next(), a.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
    this.eat(types$1.parenR) ? a.options = null : (this.expect(types$1.comma), this.afterTrailingComma(types$1.parenR) ? a.options = null : (a.options = this.parseMaybeAssign(), this.eat(types$1.parenR) || (this.expect(types$1.comma), this.afterTrailingComma(types$1.parenR) || this.unexpected())));
  else if (!this.eat(types$1.parenR)) {
    var s = this.start;
    this.eat(types$1.comma) && this.eat(types$1.parenR) ? this.raiseRecoverable(s, "Trailing comma is not allowed in import()") : this.unexpected(s);
  }
  return this.finishNode(a, "ImportExpression");
};
pp$5.parseImportMeta = function(a) {
  this.next();
  var s = this.containsEsc;
  return a.property = this.parseIdent(!0), a.property.name !== "meta" && this.raiseRecoverable(a.property.start, "The only valid meta property for import is 'import.meta'"), s && this.raiseRecoverable(a.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(a.start, "Cannot use 'import.meta' outside a module"), this.finishNode(a, "MetaProperty");
};
pp$5.parseLiteral = function(a) {
  var s = this.startNode();
  return s.value = a, s.raw = this.input.slice(this.start, this.end), s.raw.charCodeAt(s.raw.length - 1) === 110 && (s.bigint = s.value != null ? s.value.toString() : s.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(s, "Literal");
};
pp$5.parseParenExpression = function() {
  this.expect(types$1.parenL);
  var a = this.parseExpression();
  return this.expect(types$1.parenR), a;
};
pp$5.shouldParseArrow = function(a) {
  return !this.canInsertSemicolon();
};
pp$5.parseParenAndDistinguishExpression = function(a, s) {
  var c = this.start, u = this.startLoc, d, p = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var v = this.start, A = this.startLoc, x = [], g = !0, b = !1, y = new DestructuringErrors(), f = this.yieldPos, m = this.awaitPos, C;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== types$1.parenR; )
      if (g ? g = !1 : this.expect(types$1.comma), p && this.afterTrailingComma(types$1.parenR, !0)) {
        b = !0;
        break;
      } else if (this.type === types$1.ellipsis) {
        C = this.start, x.push(this.parseParenItem(this.parseRestBinding())), this.type === types$1.comma && this.raiseRecoverable(
          this.start,
          "Comma is not permitted after the rest element"
        );
        break;
      } else
        x.push(this.parseMaybeAssign(!1, y, this.parseParenItem));
    var w = this.lastTokEnd, S = this.lastTokEndLoc;
    if (this.expect(types$1.parenR), a && this.shouldParseArrow(x) && this.eat(types$1.arrow))
      return this.checkPatternErrors(y, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = f, this.awaitPos = m, this.parseParenArrowList(c, u, x, s);
    (!x.length || b) && this.unexpected(this.lastTokStart), C && this.unexpected(C), this.checkExpressionErrors(y, !0), this.yieldPos = f || this.yieldPos, this.awaitPos = m || this.awaitPos, x.length > 1 ? (d = this.startNodeAt(v, A), d.expressions = x, this.finishNodeAt(d, "SequenceExpression", w, S)) : d = x[0];
  } else
    d = this.parseParenExpression();
  if (this.options.preserveParens) {
    var $ = this.startNodeAt(c, u);
    return $.expression = d, this.finishNode($, "ParenthesizedExpression");
  } else
    return d;
};
pp$5.parseParenItem = function(a) {
  return a;
};
pp$5.parseParenArrowList = function(a, s, c, u) {
  return this.parseArrowExpression(this.startNodeAt(a, s), c, !1, u);
};
var empty$2 = [];
pp$5.parseNew = function() {
  this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
  var a = this.startNode();
  if (this.next(), this.options.ecmaVersion >= 6 && this.type === types$1.dot) {
    var s = this.startNodeAt(a.start, a.loc && a.loc.start);
    s.name = "new", a.meta = this.finishNode(s, "Identifier"), this.next();
    var c = this.containsEsc;
    return a.property = this.parseIdent(!0), a.property.name !== "target" && this.raiseRecoverable(a.property.start, "The only valid meta property for new is 'new.target'"), c && this.raiseRecoverable(a.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(a.start, "'new.target' can only be used in functions and class static block"), this.finishNode(a, "MetaProperty");
  }
  var u = this.start, d = this.startLoc;
  return a.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), u, d, !0, !1), this.eat(types$1.parenL) ? a.arguments = this.parseExprList(types$1.parenR, this.options.ecmaVersion >= 8, !1) : a.arguments = empty$2, this.finishNode(a, "NewExpression");
};
pp$5.parseTemplateElement = function(a) {
  var s = a.isTagged, c = this.startNode();
  return this.type === types$1.invalidTemplate ? (s || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), c.value = {
    raw: this.value.replace(/\r\n?/g, `
`),
    cooked: null
  }) : c.value = {
    raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
    cooked: this.value
  }, this.next(), c.tail = this.type === types$1.backQuote, this.finishNode(c, "TemplateElement");
};
pp$5.parseTemplate = function(a) {
  a === void 0 && (a = {});
  var s = a.isTagged;
  s === void 0 && (s = !1);
  var c = this.startNode();
  this.next(), c.expressions = [];
  var u = this.parseTemplateElement({ isTagged: s });
  for (c.quasis = [u]; !u.tail; )
    this.type === types$1.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(types$1.dollarBraceL), c.expressions.push(this.parseExpression()), this.expect(types$1.braceR), c.quasis.push(u = this.parseTemplateElement({ isTagged: s }));
  return this.next(), this.finishNode(c, "TemplateLiteral");
};
pp$5.isAsyncProp = function(a) {
  return !a.computed && a.key.type === "Identifier" && a.key.name === "async" && (this.type === types$1.name || this.type === types$1.num || this.type === types$1.string || this.type === types$1.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === types$1.star) && !lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};
pp$5.parseObj = function(a, s) {
  var c = this.startNode(), u = !0, d = {};
  for (c.properties = [], this.next(); !this.eat(types$1.braceR); ) {
    if (u)
      u = !1;
    else if (this.expect(types$1.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(types$1.braceR))
      break;
    var p = this.parseProperty(a, s);
    a || this.checkPropClash(p, d, s), c.properties.push(p);
  }
  return this.finishNode(c, a ? "ObjectPattern" : "ObjectExpression");
};
pp$5.parseProperty = function(a, s) {
  var c = this.startNode(), u, d, p, v;
  if (this.options.ecmaVersion >= 9 && this.eat(types$1.ellipsis))
    return a ? (c.argument = this.parseIdent(!1), this.type === types$1.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(c, "RestElement")) : (c.argument = this.parseMaybeAssign(!1, s), this.type === types$1.comma && s && s.trailingComma < 0 && (s.trailingComma = this.start), this.finishNode(c, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (c.method = !1, c.shorthand = !1, (a || s) && (p = this.start, v = this.startLoc), a || (u = this.eat(types$1.star)));
  var A = this.containsEsc;
  return this.parsePropertyName(c), !a && !A && this.options.ecmaVersion >= 8 && !u && this.isAsyncProp(c) ? (d = !0, u = this.options.ecmaVersion >= 9 && this.eat(types$1.star), this.parsePropertyName(c)) : d = !1, this.parsePropertyValue(c, a, u, d, p, v, s, A), this.finishNode(c, "Property");
};
pp$5.parseGetterSetter = function(a) {
  var s = a.key.name;
  this.parsePropertyName(a), a.value = this.parseMethod(!1), a.kind = s;
  var c = a.kind === "get" ? 0 : 1;
  if (a.value.params.length !== c) {
    var u = a.value.start;
    a.kind === "get" ? this.raiseRecoverable(u, "getter should have no params") : this.raiseRecoverable(u, "setter should have exactly one param");
  } else
    a.kind === "set" && a.value.params[0].type === "RestElement" && this.raiseRecoverable(a.value.params[0].start, "Setter cannot use rest params");
};
pp$5.parsePropertyValue = function(a, s, c, u, d, p, v, A) {
  (c || u) && this.type === types$1.colon && this.unexpected(), this.eat(types$1.colon) ? (a.value = s ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, v), a.kind = "init") : this.options.ecmaVersion >= 6 && this.type === types$1.parenL ? (s && this.unexpected(), a.method = !0, a.value = this.parseMethod(c, u), a.kind = "init") : !s && !A && this.options.ecmaVersion >= 5 && !a.computed && a.key.type === "Identifier" && (a.key.name === "get" || a.key.name === "set") && this.type !== types$1.comma && this.type !== types$1.braceR && this.type !== types$1.eq ? ((c || u) && this.unexpected(), this.parseGetterSetter(a)) : this.options.ecmaVersion >= 6 && !a.computed && a.key.type === "Identifier" ? ((c || u) && this.unexpected(), this.checkUnreserved(a.key), a.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = d), s ? a.value = this.parseMaybeDefault(d, p, this.copyNode(a.key)) : this.type === types$1.eq && v ? (v.shorthandAssign < 0 && (v.shorthandAssign = this.start), a.value = this.parseMaybeDefault(d, p, this.copyNode(a.key))) : a.value = this.copyNode(a.key), a.kind = "init", a.shorthand = !0) : this.unexpected();
};
pp$5.parsePropertyName = function(a) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(types$1.bracketL))
      return a.computed = !0, a.key = this.parseMaybeAssign(), this.expect(types$1.bracketR), a.key;
    a.computed = !1;
  }
  return a.key = this.type === types$1.num || this.type === types$1.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
pp$5.initFunction = function(a) {
  a.id = null, this.options.ecmaVersion >= 6 && (a.generator = a.expression = !1), this.options.ecmaVersion >= 8 && (a.async = !1);
};
pp$5.parseMethod = function(a, s, c) {
  var u = this.startNode(), d = this.yieldPos, p = this.awaitPos, v = this.awaitIdentPos;
  return this.initFunction(u), this.options.ecmaVersion >= 6 && (u.generator = a), this.options.ecmaVersion >= 8 && (u.async = !!s), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(functionFlags(s, u.generator) | SCOPE_SUPER | (c ? SCOPE_DIRECT_SUPER : 0)), this.expect(types$1.parenL), u.params = this.parseBindingList(types$1.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(u, !1, !0, !1), this.yieldPos = d, this.awaitPos = p, this.awaitIdentPos = v, this.finishNode(u, "FunctionExpression");
};
pp$5.parseArrowExpression = function(a, s, c, u) {
  var d = this.yieldPos, p = this.awaitPos, v = this.awaitIdentPos;
  return this.enterScope(functionFlags(c, !1) | SCOPE_ARROW), this.initFunction(a), this.options.ecmaVersion >= 8 && (a.async = !!c), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, a.params = this.toAssignableList(s, !0), this.parseFunctionBody(a, !0, !1, u), this.yieldPos = d, this.awaitPos = p, this.awaitIdentPos = v, this.finishNode(a, "ArrowFunctionExpression");
};
pp$5.parseFunctionBody = function(a, s, c, u) {
  var d = s && this.type !== types$1.braceL, p = this.strict, v = !1;
  if (d)
    a.body = this.parseMaybeAssign(u), a.expression = !0, this.checkParams(a, !1);
  else {
    var A = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(a.params);
    (!p || A) && (v = this.strictDirective(this.end), v && A && this.raiseRecoverable(a.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
    var x = this.labels;
    this.labels = [], v && (this.strict = !0), this.checkParams(a, !p && !v && !s && !c && this.isSimpleParamList(a.params)), this.strict && a.id && this.checkLValSimple(a.id, BIND_OUTSIDE), a.body = this.parseBlock(!1, void 0, v && !p), a.expression = !1, this.adaptDirectivePrologue(a.body.body), this.labels = x;
  }
  this.exitScope();
};
pp$5.isSimpleParamList = function(a) {
  for (var s = 0, c = a; s < c.length; s += 1) {
    var u = c[s];
    if (u.type !== "Identifier")
      return !1;
  }
  return !0;
};
pp$5.checkParams = function(a, s) {
  for (var c = /* @__PURE__ */ Object.create(null), u = 0, d = a.params; u < d.length; u += 1) {
    var p = d[u];
    this.checkLValInnerPattern(p, BIND_VAR, s ? null : c);
  }
};
pp$5.parseExprList = function(a, s, c, u) {
  for (var d = [], p = !0; !this.eat(a); ) {
    if (p)
      p = !1;
    else if (this.expect(types$1.comma), s && this.afterTrailingComma(a))
      break;
    var v = void 0;
    c && this.type === types$1.comma ? v = null : this.type === types$1.ellipsis ? (v = this.parseSpread(u), u && this.type === types$1.comma && u.trailingComma < 0 && (u.trailingComma = this.start)) : v = this.parseMaybeAssign(!1, u), d.push(v);
  }
  return d;
};
pp$5.checkUnreserved = function(a) {
  var s = a.start, c = a.end, u = a.name;
  if (this.inGenerator && u === "yield" && this.raiseRecoverable(s, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && u === "await" && this.raiseRecoverable(s, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & SCOPE_VAR) && u === "arguments" && this.raiseRecoverable(s, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (u === "arguments" || u === "await") && this.raise(s, "Cannot use " + u + " in class static initialization block"), this.keywords.test(u) && this.raise(s, "Unexpected keyword '" + u + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(s, c).indexOf("\\") !== -1)) {
    var d = this.strict ? this.reservedWordsStrict : this.reservedWords;
    d.test(u) && (!this.inAsync && u === "await" && this.raiseRecoverable(s, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(s, "The keyword '" + u + "' is reserved"));
  }
};
pp$5.parseIdent = function(a) {
  var s = this.parseIdentNode();
  return this.next(!!a), this.finishNode(s, "Identifier"), a || (this.checkUnreserved(s), s.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = s.start)), s;
};
pp$5.parseIdentNode = function() {
  var a = this.startNode();
  return this.type === types$1.name ? a.name = this.value : this.type.keyword ? (a.name = this.type.keyword, (a.name === "class" || a.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = types$1.name) : this.unexpected(), a;
};
pp$5.parsePrivateIdent = function() {
  var a = this.startNode();
  return this.type === types$1.privateId ? a.name = this.value : this.unexpected(), this.next(), this.finishNode(a, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(a.start, "Private field '#" + a.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(a)), a;
};
pp$5.parseYield = function(a) {
  this.yieldPos || (this.yieldPos = this.start);
  var s = this.startNode();
  return this.next(), this.type === types$1.semi || this.canInsertSemicolon() || this.type !== types$1.star && !this.type.startsExpr ? (s.delegate = !1, s.argument = null) : (s.delegate = this.eat(types$1.star), s.argument = this.parseMaybeAssign(a)), this.finishNode(s, "YieldExpression");
};
pp$5.parseAwait = function(a) {
  this.awaitPos || (this.awaitPos = this.start);
  var s = this.startNode();
  return this.next(), s.argument = this.parseMaybeUnary(null, !0, !1, a), this.finishNode(s, "AwaitExpression");
};
var pp$4 = Parser.prototype;
pp$4.raise = function(a, s) {
  var c = getLineInfo(this.input, a);
  s += " (" + c.line + ":" + c.column + ")", this.sourceFile && (s += " in " + this.sourceFile);
  var u = new SyntaxError(s);
  throw u.pos = a, u.loc = c, u.raisedAt = this.pos, u;
};
pp$4.raiseRecoverable = pp$4.raise;
pp$4.curPosition = function() {
  if (this.options.locations)
    return new Position(this.curLine, this.pos - this.lineStart);
};
var pp$3 = Parser.prototype, Scope = function(s) {
  this.flags = s, this.var = [], this.lexical = [], this.functions = [];
};
pp$3.enterScope = function(a) {
  this.scopeStack.push(new Scope(a));
};
pp$3.exitScope = function() {
  this.scopeStack.pop();
};
pp$3.treatFunctionsAsVarInScope = function(a) {
  return a.flags & SCOPE_FUNCTION || !this.inModule && a.flags & SCOPE_TOP;
};
pp$3.declareName = function(a, s, c) {
  var u = !1;
  if (s === BIND_LEXICAL) {
    var d = this.currentScope();
    u = d.lexical.indexOf(a) > -1 || d.functions.indexOf(a) > -1 || d.var.indexOf(a) > -1, d.lexical.push(a), this.inModule && d.flags & SCOPE_TOP && delete this.undefinedExports[a];
  } else if (s === BIND_SIMPLE_CATCH) {
    var p = this.currentScope();
    p.lexical.push(a);
  } else if (s === BIND_FUNCTION) {
    var v = this.currentScope();
    this.treatFunctionsAsVar ? u = v.lexical.indexOf(a) > -1 : u = v.lexical.indexOf(a) > -1 || v.var.indexOf(a) > -1, v.functions.push(a);
  } else
    for (var A = this.scopeStack.length - 1; A >= 0; --A) {
      var x = this.scopeStack[A];
      if (x.lexical.indexOf(a) > -1 && !(x.flags & SCOPE_SIMPLE_CATCH && x.lexical[0] === a) || !this.treatFunctionsAsVarInScope(x) && x.functions.indexOf(a) > -1) {
        u = !0;
        break;
      }
      if (x.var.push(a), this.inModule && x.flags & SCOPE_TOP && delete this.undefinedExports[a], x.flags & SCOPE_VAR)
        break;
    }
  u && this.raiseRecoverable(c, "Identifier '" + a + "' has already been declared");
};
pp$3.checkLocalExport = function(a) {
  this.scopeStack[0].lexical.indexOf(a.name) === -1 && this.scopeStack[0].var.indexOf(a.name) === -1 && (this.undefinedExports[a.name] = a);
};
pp$3.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
};
pp$3.currentVarScope = function() {
  for (var a = this.scopeStack.length - 1; ; a--) {
    var s = this.scopeStack[a];
    if (s.flags & (SCOPE_VAR | SCOPE_CLASS_FIELD_INIT | SCOPE_CLASS_STATIC_BLOCK))
      return s;
  }
};
pp$3.currentThisScope = function() {
  for (var a = this.scopeStack.length - 1; ; a--) {
    var s = this.scopeStack[a];
    if (s.flags & (SCOPE_VAR | SCOPE_CLASS_FIELD_INIT | SCOPE_CLASS_STATIC_BLOCK) && !(s.flags & SCOPE_ARROW))
      return s;
  }
};
var Node = function(s, c, u) {
  this.type = "", this.start = c, this.end = 0, s.options.locations && (this.loc = new SourceLocation(s, u)), s.options.directSourceFile && (this.sourceFile = s.options.directSourceFile), s.options.ranges && (this.range = [c, 0]);
}, pp$2 = Parser.prototype;
pp$2.startNode = function() {
  return new Node(this, this.start, this.startLoc);
};
pp$2.startNodeAt = function(a, s) {
  return new Node(this, a, s);
};
function finishNodeAt(a, s, c, u) {
  return a.type = s, a.end = c, this.options.locations && (a.loc.end = u), this.options.ranges && (a.range[1] = c), a;
}
pp$2.finishNode = function(a, s) {
  return finishNodeAt.call(this, a, s, this.lastTokEnd, this.lastTokEndLoc);
};
pp$2.finishNodeAt = function(a, s, c, u) {
  return finishNodeAt.call(this, a, s, c, u);
};
pp$2.copyNode = function(a) {
  var s = new Node(this, a.start, this.startLoc);
  for (var c in a)
    s[c] = a[c];
  return s;
};
var scriptValuesAddedInUnicode = "Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz", ecma9BinaryProperties = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", ecma10BinaryProperties = ecma9BinaryProperties + " Extended_Pictographic", ecma11BinaryProperties = ecma10BinaryProperties, ecma12BinaryProperties = ecma11BinaryProperties + " EBase EComp EMod EPres ExtPict", ecma13BinaryProperties = ecma12BinaryProperties, ecma14BinaryProperties = ecma13BinaryProperties, unicodeBinaryProperties = {
  9: ecma9BinaryProperties,
  10: ecma10BinaryProperties,
  11: ecma11BinaryProperties,
  12: ecma12BinaryProperties,
  13: ecma13BinaryProperties,
  14: ecma14BinaryProperties
}, ecma14BinaryPropertiesOfStrings = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", unicodeBinaryPropertiesOfStrings = {
  9: "",
  10: "",
  11: "",
  12: "",
  13: "",
  14: ecma14BinaryPropertiesOfStrings
}, unicodeGeneralCategoryValues = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", ecma9ScriptValues = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", ecma10ScriptValues = ecma9ScriptValues + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", ecma11ScriptValues = ecma10ScriptValues + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", ecma12ScriptValues = ecma11ScriptValues + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", ecma13ScriptValues = ecma12ScriptValues + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", ecma14ScriptValues = ecma13ScriptValues + " " + scriptValuesAddedInUnicode, unicodeScriptValues = {
  9: ecma9ScriptValues,
  10: ecma10ScriptValues,
  11: ecma11ScriptValues,
  12: ecma12ScriptValues,
  13: ecma13ScriptValues,
  14: ecma14ScriptValues
}, data = {};
function buildUnicodeData(a) {
  var s = data[a] = {
    binary: wordsRegexp(unicodeBinaryProperties[a] + " " + unicodeGeneralCategoryValues),
    binaryOfStrings: wordsRegexp(unicodeBinaryPropertiesOfStrings[a]),
    nonBinary: {
      General_Category: wordsRegexp(unicodeGeneralCategoryValues),
      Script: wordsRegexp(unicodeScriptValues[a])
    }
  };
  s.nonBinary.Script_Extensions = s.nonBinary.Script, s.nonBinary.gc = s.nonBinary.General_Category, s.nonBinary.sc = s.nonBinary.Script, s.nonBinary.scx = s.nonBinary.Script_Extensions;
}
for (var i = 0, list = [9, 10, 11, 12, 13, 14]; i < list.length; i += 1) {
  var ecmaVersion = list[i];
  buildUnicodeData(ecmaVersion);
}
var pp$1 = Parser.prototype, BranchID = function(s, c) {
  this.parent = s, this.base = c || this;
};
BranchID.prototype.separatedFrom = function(s) {
  for (var c = this; c; c = c.parent)
    for (var u = s; u; u = u.parent)
      if (c.base === u.base && c !== u)
        return !0;
  return !1;
};
BranchID.prototype.sibling = function() {
  return new BranchID(this.parent, this.base);
};
var RegExpValidationState = function(s) {
  this.parser = s, this.validFlags = "gim" + (s.options.ecmaVersion >= 6 ? "uy" : "") + (s.options.ecmaVersion >= 9 ? "s" : "") + (s.options.ecmaVersion >= 13 ? "d" : "") + (s.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = data[s.options.ecmaVersion >= 14 ? 14 : s.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
};
RegExpValidationState.prototype.reset = function(s, c, u) {
  var d = u.indexOf("v") !== -1, p = u.indexOf("u") !== -1;
  this.start = s | 0, this.source = c + "", this.flags = u, d && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = p && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = p && this.parser.options.ecmaVersion >= 9);
};
RegExpValidationState.prototype.raise = function(s) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + s);
};
RegExpValidationState.prototype.at = function(s, c) {
  c === void 0 && (c = !1);
  var u = this.source, d = u.length;
  if (s >= d)
    return -1;
  var p = u.charCodeAt(s);
  if (!(c || this.switchU) || p <= 55295 || p >= 57344 || s + 1 >= d)
    return p;
  var v = u.charCodeAt(s + 1);
  return v >= 56320 && v <= 57343 ? (p << 10) + v - 56613888 : p;
};
RegExpValidationState.prototype.nextIndex = function(s, c) {
  c === void 0 && (c = !1);
  var u = this.source, d = u.length;
  if (s >= d)
    return d;
  var p = u.charCodeAt(s), v;
  return !(c || this.switchU) || p <= 55295 || p >= 57344 || s + 1 >= d || (v = u.charCodeAt(s + 1)) < 56320 || v > 57343 ? s + 1 : s + 2;
};
RegExpValidationState.prototype.current = function(s) {
  return s === void 0 && (s = !1), this.at(this.pos, s);
};
RegExpValidationState.prototype.lookahead = function(s) {
  return s === void 0 && (s = !1), this.at(this.nextIndex(this.pos, s), s);
};
RegExpValidationState.prototype.advance = function(s) {
  s === void 0 && (s = !1), this.pos = this.nextIndex(this.pos, s);
};
RegExpValidationState.prototype.eat = function(s, c) {
  return c === void 0 && (c = !1), this.current(c) === s ? (this.advance(c), !0) : !1;
};
RegExpValidationState.prototype.eatChars = function(s, c) {
  c === void 0 && (c = !1);
  for (var u = this.pos, d = 0, p = s; d < p.length; d += 1) {
    var v = p[d], A = this.at(u, c);
    if (A === -1 || A !== v)
      return !1;
    u = this.nextIndex(u, c);
  }
  return this.pos = u, !0;
};
pp$1.validateRegExpFlags = function(a) {
  for (var s = a.validFlags, c = a.flags, u = !1, d = !1, p = 0; p < c.length; p++) {
    var v = c.charAt(p);
    s.indexOf(v) === -1 && this.raise(a.start, "Invalid regular expression flag"), c.indexOf(v, p + 1) > -1 && this.raise(a.start, "Duplicate regular expression flag"), v === "u" && (u = !0), v === "v" && (d = !0);
  }
  this.options.ecmaVersion >= 15 && u && d && this.raise(a.start, "Invalid regular expression flag");
};
function hasProp(a) {
  for (var s in a)
    return !0;
  return !1;
}
pp$1.validateRegExpPattern = function(a) {
  this.regexp_pattern(a), !a.switchN && this.options.ecmaVersion >= 9 && hasProp(a.groupNames) && (a.switchN = !0, this.regexp_pattern(a));
};
pp$1.regexp_pattern = function(a) {
  a.pos = 0, a.lastIntValue = 0, a.lastStringValue = "", a.lastAssertionIsQuantifiable = !1, a.numCapturingParens = 0, a.maxBackReference = 0, a.groupNames = /* @__PURE__ */ Object.create(null), a.backReferenceNames.length = 0, a.branchID = null, this.regexp_disjunction(a), a.pos !== a.source.length && (a.eat(
    41
    /* ) */
  ) && a.raise("Unmatched ')'"), (a.eat(
    93
    /* ] */
  ) || a.eat(
    125
    /* } */
  )) && a.raise("Lone quantifier brackets")), a.maxBackReference > a.numCapturingParens && a.raise("Invalid escape");
  for (var s = 0, c = a.backReferenceNames; s < c.length; s += 1) {
    var u = c[s];
    a.groupNames[u] || a.raise("Invalid named capture referenced");
  }
};
pp$1.regexp_disjunction = function(a) {
  var s = this.options.ecmaVersion >= 16;
  for (s && (a.branchID = new BranchID(a.branchID, null)), this.regexp_alternative(a); a.eat(
    124
    /* | */
  ); )
    s && (a.branchID = a.branchID.sibling()), this.regexp_alternative(a);
  s && (a.branchID = a.branchID.parent), this.regexp_eatQuantifier(a, !0) && a.raise("Nothing to repeat"), a.eat(
    123
    /* { */
  ) && a.raise("Lone quantifier brackets");
};
pp$1.regexp_alternative = function(a) {
  for (; a.pos < a.source.length && this.regexp_eatTerm(a); )
    ;
};
pp$1.regexp_eatTerm = function(a) {
  return this.regexp_eatAssertion(a) ? (a.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(a) && a.switchU && a.raise("Invalid quantifier"), !0) : (a.switchU ? this.regexp_eatAtom(a) : this.regexp_eatExtendedAtom(a)) ? (this.regexp_eatQuantifier(a), !0) : !1;
};
pp$1.regexp_eatAssertion = function(a) {
  var s = a.pos;
  if (a.lastAssertionIsQuantifiable = !1, a.eat(
    94
    /* ^ */
  ) || a.eat(
    36
    /* $ */
  ))
    return !0;
  if (a.eat(
    92
    /* \ */
  )) {
    if (a.eat(
      66
      /* B */
    ) || a.eat(
      98
      /* b */
    ))
      return !0;
    a.pos = s;
  }
  if (a.eat(
    40
    /* ( */
  ) && a.eat(
    63
    /* ? */
  )) {
    var c = !1;
    if (this.options.ecmaVersion >= 9 && (c = a.eat(
      60
      /* < */
    )), a.eat(
      61
      /* = */
    ) || a.eat(
      33
      /* ! */
    ))
      return this.regexp_disjunction(a), a.eat(
        41
        /* ) */
      ) || a.raise("Unterminated group"), a.lastAssertionIsQuantifiable = !c, !0;
  }
  return a.pos = s, !1;
};
pp$1.regexp_eatQuantifier = function(a, s) {
  return s === void 0 && (s = !1), this.regexp_eatQuantifierPrefix(a, s) ? (a.eat(
    63
    /* ? */
  ), !0) : !1;
};
pp$1.regexp_eatQuantifierPrefix = function(a, s) {
  return a.eat(
    42
    /* * */
  ) || a.eat(
    43
    /* + */
  ) || a.eat(
    63
    /* ? */
  ) || this.regexp_eatBracedQuantifier(a, s);
};
pp$1.regexp_eatBracedQuantifier = function(a, s) {
  var c = a.pos;
  if (a.eat(
    123
    /* { */
  )) {
    var u = 0, d = -1;
    if (this.regexp_eatDecimalDigits(a) && (u = a.lastIntValue, a.eat(
      44
      /* , */
    ) && this.regexp_eatDecimalDigits(a) && (d = a.lastIntValue), a.eat(
      125
      /* } */
    )))
      return d !== -1 && d < u && !s && a.raise("numbers out of order in {} quantifier"), !0;
    a.switchU && !s && a.raise("Incomplete quantifier"), a.pos = c;
  }
  return !1;
};
pp$1.regexp_eatAtom = function(a) {
  return this.regexp_eatPatternCharacters(a) || a.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(a) || this.regexp_eatCharacterClass(a) || this.regexp_eatUncapturingGroup(a) || this.regexp_eatCapturingGroup(a);
};
pp$1.regexp_eatReverseSolidusAtomEscape = function(a) {
  var s = a.pos;
  if (a.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatAtomEscape(a))
      return !0;
    a.pos = s;
  }
  return !1;
};
pp$1.regexp_eatUncapturingGroup = function(a) {
  var s = a.pos;
  if (a.eat(
    40
    /* ( */
  )) {
    if (a.eat(
      63
      /* ? */
    )) {
      if (this.options.ecmaVersion >= 16) {
        var c = this.regexp_eatModifiers(a), u = a.eat(
          45
          /* - */
        );
        if (c || u) {
          for (var d = 0; d < c.length; d++) {
            var p = c.charAt(d);
            c.indexOf(p, d + 1) > -1 && a.raise("Duplicate regular expression modifiers");
          }
          if (u) {
            var v = this.regexp_eatModifiers(a);
            !c && !v && a.current() === 58 && a.raise("Invalid regular expression modifiers");
            for (var A = 0; A < v.length; A++) {
              var x = v.charAt(A);
              (v.indexOf(x, A + 1) > -1 || c.indexOf(x) > -1) && a.raise("Duplicate regular expression modifiers");
            }
          }
        }
      }
      if (a.eat(
        58
        /* : */
      )) {
        if (this.regexp_disjunction(a), a.eat(
          41
          /* ) */
        ))
          return !0;
        a.raise("Unterminated group");
      }
    }
    a.pos = s;
  }
  return !1;
};
pp$1.regexp_eatCapturingGroup = function(a) {
  if (a.eat(
    40
    /* ( */
  )) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(a) : a.current() === 63 && a.raise("Invalid group"), this.regexp_disjunction(a), a.eat(
      41
      /* ) */
    ))
      return a.numCapturingParens += 1, !0;
    a.raise("Unterminated group");
  }
  return !1;
};
pp$1.regexp_eatModifiers = function(a) {
  for (var s = "", c = 0; (c = a.current()) !== -1 && isRegularExpressionModifier(c); )
    s += codePointToString(c), a.advance();
  return s;
};
function isRegularExpressionModifier(a) {
  return a === 105 || a === 109 || a === 115;
}
pp$1.regexp_eatExtendedAtom = function(a) {
  return a.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(a) || this.regexp_eatCharacterClass(a) || this.regexp_eatUncapturingGroup(a) || this.regexp_eatCapturingGroup(a) || this.regexp_eatInvalidBracedQuantifier(a) || this.regexp_eatExtendedPatternCharacter(a);
};
pp$1.regexp_eatInvalidBracedQuantifier = function(a) {
  return this.regexp_eatBracedQuantifier(a, !0) && a.raise("Nothing to repeat"), !1;
};
pp$1.regexp_eatSyntaxCharacter = function(a) {
  var s = a.current();
  return isSyntaxCharacter(s) ? (a.lastIntValue = s, a.advance(), !0) : !1;
};
function isSyntaxCharacter(a) {
  return a === 36 || a >= 40 && a <= 43 || a === 46 || a === 63 || a >= 91 && a <= 94 || a >= 123 && a <= 125;
}
pp$1.regexp_eatPatternCharacters = function(a) {
  for (var s = a.pos, c = 0; (c = a.current()) !== -1 && !isSyntaxCharacter(c); )
    a.advance();
  return a.pos !== s;
};
pp$1.regexp_eatExtendedPatternCharacter = function(a) {
  var s = a.current();
  return s !== -1 && s !== 36 && !(s >= 40 && s <= 43) && s !== 46 && s !== 63 && s !== 91 && s !== 94 && s !== 124 ? (a.advance(), !0) : !1;
};
pp$1.regexp_groupSpecifier = function(a) {
  if (a.eat(
    63
    /* ? */
  )) {
    this.regexp_eatGroupName(a) || a.raise("Invalid group");
    var s = this.options.ecmaVersion >= 16, c = a.groupNames[a.lastStringValue];
    if (c)
      if (s)
        for (var u = 0, d = c; u < d.length; u += 1) {
          var p = d[u];
          p.separatedFrom(a.branchID) || a.raise("Duplicate capture group name");
        }
      else
        a.raise("Duplicate capture group name");
    s ? (c || (a.groupNames[a.lastStringValue] = [])).push(a.branchID) : a.groupNames[a.lastStringValue] = !0;
  }
};
pp$1.regexp_eatGroupName = function(a) {
  if (a.lastStringValue = "", a.eat(
    60
    /* < */
  )) {
    if (this.regexp_eatRegExpIdentifierName(a) && a.eat(
      62
      /* > */
    ))
      return !0;
    a.raise("Invalid capture group name");
  }
  return !1;
};
pp$1.regexp_eatRegExpIdentifierName = function(a) {
  if (a.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(a)) {
    for (a.lastStringValue += codePointToString(a.lastIntValue); this.regexp_eatRegExpIdentifierPart(a); )
      a.lastStringValue += codePointToString(a.lastIntValue);
    return !0;
  }
  return !1;
};
pp$1.regexp_eatRegExpIdentifierStart = function(a) {
  var s = a.pos, c = this.options.ecmaVersion >= 11, u = a.current(c);
  return a.advance(c), u === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(a, c) && (u = a.lastIntValue), isRegExpIdentifierStart(u) ? (a.lastIntValue = u, !0) : (a.pos = s, !1);
};
function isRegExpIdentifierStart(a) {
  return isIdentifierStart(a, !0) || a === 36 || a === 95;
}
pp$1.regexp_eatRegExpIdentifierPart = function(a) {
  var s = a.pos, c = this.options.ecmaVersion >= 11, u = a.current(c);
  return a.advance(c), u === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(a, c) && (u = a.lastIntValue), isRegExpIdentifierPart(u) ? (a.lastIntValue = u, !0) : (a.pos = s, !1);
};
function isRegExpIdentifierPart(a) {
  return isIdentifierChar(a, !0) || a === 36 || a === 95 || a === 8204 || a === 8205;
}
pp$1.regexp_eatAtomEscape = function(a) {
  return this.regexp_eatBackReference(a) || this.regexp_eatCharacterClassEscape(a) || this.regexp_eatCharacterEscape(a) || a.switchN && this.regexp_eatKGroupName(a) ? !0 : (a.switchU && (a.current() === 99 && a.raise("Invalid unicode escape"), a.raise("Invalid escape")), !1);
};
pp$1.regexp_eatBackReference = function(a) {
  var s = a.pos;
  if (this.regexp_eatDecimalEscape(a)) {
    var c = a.lastIntValue;
    if (a.switchU)
      return c > a.maxBackReference && (a.maxBackReference = c), !0;
    if (c <= a.numCapturingParens)
      return !0;
    a.pos = s;
  }
  return !1;
};
pp$1.regexp_eatKGroupName = function(a) {
  if (a.eat(
    107
    /* k */
  )) {
    if (this.regexp_eatGroupName(a))
      return a.backReferenceNames.push(a.lastStringValue), !0;
    a.raise("Invalid named reference");
  }
  return !1;
};
pp$1.regexp_eatCharacterEscape = function(a) {
  return this.regexp_eatControlEscape(a) || this.regexp_eatCControlLetter(a) || this.regexp_eatZero(a) || this.regexp_eatHexEscapeSequence(a) || this.regexp_eatRegExpUnicodeEscapeSequence(a, !1) || !a.switchU && this.regexp_eatLegacyOctalEscapeSequence(a) || this.regexp_eatIdentityEscape(a);
};
pp$1.regexp_eatCControlLetter = function(a) {
  var s = a.pos;
  if (a.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatControlLetter(a))
      return !0;
    a.pos = s;
  }
  return !1;
};
pp$1.regexp_eatZero = function(a) {
  return a.current() === 48 && !isDecimalDigit(a.lookahead()) ? (a.lastIntValue = 0, a.advance(), !0) : !1;
};
pp$1.regexp_eatControlEscape = function(a) {
  var s = a.current();
  return s === 116 ? (a.lastIntValue = 9, a.advance(), !0) : s === 110 ? (a.lastIntValue = 10, a.advance(), !0) : s === 118 ? (a.lastIntValue = 11, a.advance(), !0) : s === 102 ? (a.lastIntValue = 12, a.advance(), !0) : s === 114 ? (a.lastIntValue = 13, a.advance(), !0) : !1;
};
pp$1.regexp_eatControlLetter = function(a) {
  var s = a.current();
  return isControlLetter(s) ? (a.lastIntValue = s % 32, a.advance(), !0) : !1;
};
function isControlLetter(a) {
  return a >= 65 && a <= 90 || a >= 97 && a <= 122;
}
pp$1.regexp_eatRegExpUnicodeEscapeSequence = function(a, s) {
  s === void 0 && (s = !1);
  var c = a.pos, u = s || a.switchU;
  if (a.eat(
    117
    /* u */
  )) {
    if (this.regexp_eatFixedHexDigits(a, 4)) {
      var d = a.lastIntValue;
      if (u && d >= 55296 && d <= 56319) {
        var p = a.pos;
        if (a.eat(
          92
          /* \ */
        ) && a.eat(
          117
          /* u */
        ) && this.regexp_eatFixedHexDigits(a, 4)) {
          var v = a.lastIntValue;
          if (v >= 56320 && v <= 57343)
            return a.lastIntValue = (d - 55296) * 1024 + (v - 56320) + 65536, !0;
        }
        a.pos = p, a.lastIntValue = d;
      }
      return !0;
    }
    if (u && a.eat(
      123
      /* { */
    ) && this.regexp_eatHexDigits(a) && a.eat(
      125
      /* } */
    ) && isValidUnicode(a.lastIntValue))
      return !0;
    u && a.raise("Invalid unicode escape"), a.pos = c;
  }
  return !1;
};
function isValidUnicode(a) {
  return a >= 0 && a <= 1114111;
}
pp$1.regexp_eatIdentityEscape = function(a) {
  if (a.switchU)
    return this.regexp_eatSyntaxCharacter(a) ? !0 : a.eat(
      47
      /* / */
    ) ? (a.lastIntValue = 47, !0) : !1;
  var s = a.current();
  return s !== 99 && (!a.switchN || s !== 107) ? (a.lastIntValue = s, a.advance(), !0) : !1;
};
pp$1.regexp_eatDecimalEscape = function(a) {
  a.lastIntValue = 0;
  var s = a.current();
  if (s >= 49 && s <= 57) {
    do
      a.lastIntValue = 10 * a.lastIntValue + (s - 48), a.advance();
    while ((s = a.current()) >= 48 && s <= 57);
    return !0;
  }
  return !1;
};
var CharSetNone = 0, CharSetOk = 1, CharSetString = 2;
pp$1.regexp_eatCharacterClassEscape = function(a) {
  var s = a.current();
  if (isCharacterClassEscape(s))
    return a.lastIntValue = -1, a.advance(), CharSetOk;
  var c = !1;
  if (a.switchU && this.options.ecmaVersion >= 9 && ((c = s === 80) || s === 112)) {
    a.lastIntValue = -1, a.advance();
    var u;
    if (a.eat(
      123
      /* { */
    ) && (u = this.regexp_eatUnicodePropertyValueExpression(a)) && a.eat(
      125
      /* } */
    ))
      return c && u === CharSetString && a.raise("Invalid property name"), u;
    a.raise("Invalid property name");
  }
  return CharSetNone;
};
function isCharacterClassEscape(a) {
  return a === 100 || a === 68 || a === 115 || a === 83 || a === 119 || a === 87;
}
pp$1.regexp_eatUnicodePropertyValueExpression = function(a) {
  var s = a.pos;
  if (this.regexp_eatUnicodePropertyName(a) && a.eat(
    61
    /* = */
  )) {
    var c = a.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(a)) {
      var u = a.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(a, c, u), CharSetOk;
    }
  }
  if (a.pos = s, this.regexp_eatLoneUnicodePropertyNameOrValue(a)) {
    var d = a.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(a, d);
  }
  return CharSetNone;
};
pp$1.regexp_validateUnicodePropertyNameAndValue = function(a, s, c) {
  hasOwn(a.unicodeProperties.nonBinary, s) || a.raise("Invalid property name"), a.unicodeProperties.nonBinary[s].test(c) || a.raise("Invalid property value");
};
pp$1.regexp_validateUnicodePropertyNameOrValue = function(a, s) {
  if (a.unicodeProperties.binary.test(s))
    return CharSetOk;
  if (a.switchV && a.unicodeProperties.binaryOfStrings.test(s))
    return CharSetString;
  a.raise("Invalid property name");
};
pp$1.regexp_eatUnicodePropertyName = function(a) {
  var s = 0;
  for (a.lastStringValue = ""; isUnicodePropertyNameCharacter(s = a.current()); )
    a.lastStringValue += codePointToString(s), a.advance();
  return a.lastStringValue !== "";
};
function isUnicodePropertyNameCharacter(a) {
  return isControlLetter(a) || a === 95;
}
pp$1.regexp_eatUnicodePropertyValue = function(a) {
  var s = 0;
  for (a.lastStringValue = ""; isUnicodePropertyValueCharacter(s = a.current()); )
    a.lastStringValue += codePointToString(s), a.advance();
  return a.lastStringValue !== "";
};
function isUnicodePropertyValueCharacter(a) {
  return isUnicodePropertyNameCharacter(a) || isDecimalDigit(a);
}
pp$1.regexp_eatLoneUnicodePropertyNameOrValue = function(a) {
  return this.regexp_eatUnicodePropertyValue(a);
};
pp$1.regexp_eatCharacterClass = function(a) {
  if (a.eat(
    91
    /* [ */
  )) {
    var s = a.eat(
      94
      /* ^ */
    ), c = this.regexp_classContents(a);
    return a.eat(
      93
      /* ] */
    ) || a.raise("Unterminated character class"), s && c === CharSetString && a.raise("Negated character class may contain strings"), !0;
  }
  return !1;
};
pp$1.regexp_classContents = function(a) {
  return a.current() === 93 ? CharSetOk : a.switchV ? this.regexp_classSetExpression(a) : (this.regexp_nonEmptyClassRanges(a), CharSetOk);
};
pp$1.regexp_nonEmptyClassRanges = function(a) {
  for (; this.regexp_eatClassAtom(a); ) {
    var s = a.lastIntValue;
    if (a.eat(
      45
      /* - */
    ) && this.regexp_eatClassAtom(a)) {
      var c = a.lastIntValue;
      a.switchU && (s === -1 || c === -1) && a.raise("Invalid character class"), s !== -1 && c !== -1 && s > c && a.raise("Range out of order in character class");
    }
  }
};
pp$1.regexp_eatClassAtom = function(a) {
  var s = a.pos;
  if (a.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatClassEscape(a))
      return !0;
    if (a.switchU) {
      var c = a.current();
      (c === 99 || isOctalDigit(c)) && a.raise("Invalid class escape"), a.raise("Invalid escape");
    }
    a.pos = s;
  }
  var u = a.current();
  return u !== 93 ? (a.lastIntValue = u, a.advance(), !0) : !1;
};
pp$1.regexp_eatClassEscape = function(a) {
  var s = a.pos;
  if (a.eat(
    98
    /* b */
  ))
    return a.lastIntValue = 8, !0;
  if (a.switchU && a.eat(
    45
    /* - */
  ))
    return a.lastIntValue = 45, !0;
  if (!a.switchU && a.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatClassControlLetter(a))
      return !0;
    a.pos = s;
  }
  return this.regexp_eatCharacterClassEscape(a) || this.regexp_eatCharacterEscape(a);
};
pp$1.regexp_classSetExpression = function(a) {
  var s = CharSetOk, c;
  if (!this.regexp_eatClassSetRange(a)) if (c = this.regexp_eatClassSetOperand(a)) {
    c === CharSetString && (s = CharSetString);
    for (var u = a.pos; a.eatChars(
      [38, 38]
      /* && */
    ); ) {
      if (a.current() !== 38 && (c = this.regexp_eatClassSetOperand(a))) {
        c !== CharSetString && (s = CharSetOk);
        continue;
      }
      a.raise("Invalid character in character class");
    }
    if (u !== a.pos)
      return s;
    for (; a.eatChars(
      [45, 45]
      /* -- */
    ); )
      this.regexp_eatClassSetOperand(a) || a.raise("Invalid character in character class");
    if (u !== a.pos)
      return s;
  } else
    a.raise("Invalid character in character class");
  for (; ; )
    if (!this.regexp_eatClassSetRange(a)) {
      if (c = this.regexp_eatClassSetOperand(a), !c)
        return s;
      c === CharSetString && (s = CharSetString);
    }
};
pp$1.regexp_eatClassSetRange = function(a) {
  var s = a.pos;
  if (this.regexp_eatClassSetCharacter(a)) {
    var c = a.lastIntValue;
    if (a.eat(
      45
      /* - */
    ) && this.regexp_eatClassSetCharacter(a)) {
      var u = a.lastIntValue;
      return c !== -1 && u !== -1 && c > u && a.raise("Range out of order in character class"), !0;
    }
    a.pos = s;
  }
  return !1;
};
pp$1.regexp_eatClassSetOperand = function(a) {
  return this.regexp_eatClassSetCharacter(a) ? CharSetOk : this.regexp_eatClassStringDisjunction(a) || this.regexp_eatNestedClass(a);
};
pp$1.regexp_eatNestedClass = function(a) {
  var s = a.pos;
  if (a.eat(
    91
    /* [ */
  )) {
    var c = a.eat(
      94
      /* ^ */
    ), u = this.regexp_classContents(a);
    if (a.eat(
      93
      /* ] */
    ))
      return c && u === CharSetString && a.raise("Negated character class may contain strings"), u;
    a.pos = s;
  }
  if (a.eat(
    92
    /* \ */
  )) {
    var d = this.regexp_eatCharacterClassEscape(a);
    if (d)
      return d;
    a.pos = s;
  }
  return null;
};
pp$1.regexp_eatClassStringDisjunction = function(a) {
  var s = a.pos;
  if (a.eatChars(
    [92, 113]
    /* \q */
  )) {
    if (a.eat(
      123
      /* { */
    )) {
      var c = this.regexp_classStringDisjunctionContents(a);
      if (a.eat(
        125
        /* } */
      ))
        return c;
    } else
      a.raise("Invalid escape");
    a.pos = s;
  }
  return null;
};
pp$1.regexp_classStringDisjunctionContents = function(a) {
  for (var s = this.regexp_classString(a); a.eat(
    124
    /* | */
  ); )
    this.regexp_classString(a) === CharSetString && (s = CharSetString);
  return s;
};
pp$1.regexp_classString = function(a) {
  for (var s = 0; this.regexp_eatClassSetCharacter(a); )
    s++;
  return s === 1 ? CharSetOk : CharSetString;
};
pp$1.regexp_eatClassSetCharacter = function(a) {
  var s = a.pos;
  if (a.eat(
    92
    /* \ */
  ))
    return this.regexp_eatCharacterEscape(a) || this.regexp_eatClassSetReservedPunctuator(a) ? !0 : a.eat(
      98
      /* b */
    ) ? (a.lastIntValue = 8, !0) : (a.pos = s, !1);
  var c = a.current();
  return c < 0 || c === a.lookahead() && isClassSetReservedDoublePunctuatorCharacter(c) || isClassSetSyntaxCharacter(c) ? !1 : (a.advance(), a.lastIntValue = c, !0);
};
function isClassSetReservedDoublePunctuatorCharacter(a) {
  return a === 33 || a >= 35 && a <= 38 || a >= 42 && a <= 44 || a === 46 || a >= 58 && a <= 64 || a === 94 || a === 96 || a === 126;
}
function isClassSetSyntaxCharacter(a) {
  return a === 40 || a === 41 || a === 45 || a === 47 || a >= 91 && a <= 93 || a >= 123 && a <= 125;
}
pp$1.regexp_eatClassSetReservedPunctuator = function(a) {
  var s = a.current();
  return isClassSetReservedPunctuator(s) ? (a.lastIntValue = s, a.advance(), !0) : !1;
};
function isClassSetReservedPunctuator(a) {
  return a === 33 || a === 35 || a === 37 || a === 38 || a === 44 || a === 45 || a >= 58 && a <= 62 || a === 64 || a === 96 || a === 126;
}
pp$1.regexp_eatClassControlLetter = function(a) {
  var s = a.current();
  return isDecimalDigit(s) || s === 95 ? (a.lastIntValue = s % 32, a.advance(), !0) : !1;
};
pp$1.regexp_eatHexEscapeSequence = function(a) {
  var s = a.pos;
  if (a.eat(
    120
    /* x */
  )) {
    if (this.regexp_eatFixedHexDigits(a, 2))
      return !0;
    a.switchU && a.raise("Invalid escape"), a.pos = s;
  }
  return !1;
};
pp$1.regexp_eatDecimalDigits = function(a) {
  var s = a.pos, c = 0;
  for (a.lastIntValue = 0; isDecimalDigit(c = a.current()); )
    a.lastIntValue = 10 * a.lastIntValue + (c - 48), a.advance();
  return a.pos !== s;
};
function isDecimalDigit(a) {
  return a >= 48 && a <= 57;
}
pp$1.regexp_eatHexDigits = function(a) {
  var s = a.pos, c = 0;
  for (a.lastIntValue = 0; isHexDigit(c = a.current()); )
    a.lastIntValue = 16 * a.lastIntValue + hexToInt(c), a.advance();
  return a.pos !== s;
};
function isHexDigit(a) {
  return a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102;
}
function hexToInt(a) {
  return a >= 65 && a <= 70 ? 10 + (a - 65) : a >= 97 && a <= 102 ? 10 + (a - 97) : a - 48;
}
pp$1.regexp_eatLegacyOctalEscapeSequence = function(a) {
  if (this.regexp_eatOctalDigit(a)) {
    var s = a.lastIntValue;
    if (this.regexp_eatOctalDigit(a)) {
      var c = a.lastIntValue;
      s <= 3 && this.regexp_eatOctalDigit(a) ? a.lastIntValue = s * 64 + c * 8 + a.lastIntValue : a.lastIntValue = s * 8 + c;
    } else
      a.lastIntValue = s;
    return !0;
  }
  return !1;
};
pp$1.regexp_eatOctalDigit = function(a) {
  var s = a.current();
  return isOctalDigit(s) ? (a.lastIntValue = s - 48, a.advance(), !0) : (a.lastIntValue = 0, !1);
};
function isOctalDigit(a) {
  return a >= 48 && a <= 55;
}
pp$1.regexp_eatFixedHexDigits = function(a, s) {
  var c = a.pos;
  a.lastIntValue = 0;
  for (var u = 0; u < s; ++u) {
    var d = a.current();
    if (!isHexDigit(d))
      return a.pos = c, !1;
    a.lastIntValue = 16 * a.lastIntValue + hexToInt(d), a.advance();
  }
  return !0;
};
var Token = function(s) {
  this.type = s.type, this.value = s.value, this.start = s.start, this.end = s.end, s.options.locations && (this.loc = new SourceLocation(s, s.startLoc, s.endLoc)), s.options.ranges && (this.range = [s.start, s.end]);
}, pp = Parser.prototype;
pp.next = function(a) {
  !a && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new Token(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
};
pp.getToken = function() {
  return this.next(), new Token(this);
};
typeof Symbol < "u" && (pp[Symbol.iterator] = function() {
  var a = this;
  return {
    next: function() {
      var s = a.getToken();
      return {
        done: s.type === types$1.eof,
        value: s
      };
    }
  };
});
pp.nextToken = function() {
  var a = this.curContext();
  if ((!a || !a.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
    return this.finishToken(types$1.eof);
  if (a.override)
    return a.override(this);
  this.readToken(this.fullCharCodeAtPos());
};
pp.readToken = function(a) {
  return isIdentifierStart(a, this.options.ecmaVersion >= 6) || a === 92 ? this.readWord() : this.getTokenFromCode(a);
};
pp.fullCharCodeAtPos = function() {
  var a = this.input.charCodeAt(this.pos);
  if (a <= 55295 || a >= 56320)
    return a;
  var s = this.input.charCodeAt(this.pos + 1);
  return s <= 56319 || s >= 57344 ? a : (a << 10) + s - 56613888;
};
pp.skipBlockComment = function() {
  var a = this.options.onComment && this.curPosition(), s = this.pos, c = this.input.indexOf("*/", this.pos += 2);
  if (c === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = c + 2, this.options.locations)
    for (var u = void 0, d = s; (u = nextLineBreak(this.input, d, this.pos)) > -1; )
      ++this.curLine, d = this.lineStart = u;
  this.options.onComment && this.options.onComment(
    !0,
    this.input.slice(s + 2, c),
    s,
    this.pos,
    a,
    this.curPosition()
  );
};
pp.skipLineComment = function(a) {
  for (var s = this.pos, c = this.options.onComment && this.curPosition(), u = this.input.charCodeAt(this.pos += a); this.pos < this.input.length && !isNewLine(u); )
    u = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(
    !1,
    this.input.slice(s + a, this.pos),
    s,
    this.pos,
    c,
    this.curPosition()
  );
};
pp.skipSpace = function() {
  e: for (; this.pos < this.input.length; ) {
    var a = this.input.charCodeAt(this.pos);
    switch (a) {
      case 32:
      case 160:
        ++this.pos;
        break;
      case 13:
        this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
      case 10:
      case 8232:
      case 8233:
        ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
        break;
      case 47:
        switch (this.input.charCodeAt(this.pos + 1)) {
          case 42:
            this.skipBlockComment();
            break;
          case 47:
            this.skipLineComment(2);
            break;
          default:
            break e;
        }
        break;
      default:
        if (a > 8 && a < 14 || a >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(a)))
          ++this.pos;
        else
          break e;
    }
  }
};
pp.finishToken = function(a, s) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var c = this.type;
  this.type = a, this.value = s, this.updateContext(c);
};
pp.readToken_dot = function() {
  var a = this.input.charCodeAt(this.pos + 1);
  if (a >= 48 && a <= 57)
    return this.readNumber(!0);
  var s = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && a === 46 && s === 46 ? (this.pos += 3, this.finishToken(types$1.ellipsis)) : (++this.pos, this.finishToken(types$1.dot));
};
pp.readToken_slash = function() {
  var a = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : a === 61 ? this.finishOp(types$1.assign, 2) : this.finishOp(types$1.slash, 1);
};
pp.readToken_mult_modulo_exp = function(a) {
  var s = this.input.charCodeAt(this.pos + 1), c = 1, u = a === 42 ? types$1.star : types$1.modulo;
  return this.options.ecmaVersion >= 7 && a === 42 && s === 42 && (++c, u = types$1.starstar, s = this.input.charCodeAt(this.pos + 2)), s === 61 ? this.finishOp(types$1.assign, c + 1) : this.finishOp(u, c);
};
pp.readToken_pipe_amp = function(a) {
  var s = this.input.charCodeAt(this.pos + 1);
  if (s === a) {
    if (this.options.ecmaVersion >= 12) {
      var c = this.input.charCodeAt(this.pos + 2);
      if (c === 61)
        return this.finishOp(types$1.assign, 3);
    }
    return this.finishOp(a === 124 ? types$1.logicalOR : types$1.logicalAND, 2);
  }
  return s === 61 ? this.finishOp(types$1.assign, 2) : this.finishOp(a === 124 ? types$1.bitwiseOR : types$1.bitwiseAND, 1);
};
pp.readToken_caret = function() {
  var a = this.input.charCodeAt(this.pos + 1);
  return a === 61 ? this.finishOp(types$1.assign, 2) : this.finishOp(types$1.bitwiseXOR, 1);
};
pp.readToken_plus_min = function(a) {
  var s = this.input.charCodeAt(this.pos + 1);
  return s === a ? s === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || lineBreak.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(types$1.incDec, 2) : s === 61 ? this.finishOp(types$1.assign, 2) : this.finishOp(types$1.plusMin, 1);
};
pp.readToken_lt_gt = function(a) {
  var s = this.input.charCodeAt(this.pos + 1), c = 1;
  return s === a ? (c = a === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + c) === 61 ? this.finishOp(types$1.assign, c + 1) : this.finishOp(types$1.bitShift, c)) : s === 33 && a === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (s === 61 && (c = 2), this.finishOp(types$1.relational, c));
};
pp.readToken_eq_excl = function(a) {
  var s = this.input.charCodeAt(this.pos + 1);
  return s === 61 ? this.finishOp(types$1.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : a === 61 && s === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(types$1.arrow)) : this.finishOp(a === 61 ? types$1.eq : types$1.prefix, 1);
};
pp.readToken_question = function() {
  var a = this.options.ecmaVersion;
  if (a >= 11) {
    var s = this.input.charCodeAt(this.pos + 1);
    if (s === 46) {
      var c = this.input.charCodeAt(this.pos + 2);
      if (c < 48 || c > 57)
        return this.finishOp(types$1.questionDot, 2);
    }
    if (s === 63) {
      if (a >= 12) {
        var u = this.input.charCodeAt(this.pos + 2);
        if (u === 61)
          return this.finishOp(types$1.assign, 3);
      }
      return this.finishOp(types$1.coalesce, 2);
    }
  }
  return this.finishOp(types$1.question, 1);
};
pp.readToken_numberSign = function() {
  var a = this.options.ecmaVersion, s = 35;
  if (a >= 13 && (++this.pos, s = this.fullCharCodeAtPos(), isIdentifierStart(s, !0) || s === 92))
    return this.finishToken(types$1.privateId, this.readWord1());
  this.raise(this.pos, "Unexpected character '" + codePointToString(s) + "'");
};
pp.getTokenFromCode = function(a) {
  switch (a) {
    // The interpretation of a dot depends on whether it is followed
    // by a digit or another two dots.
    case 46:
      return this.readToken_dot();
    // Punctuation tokens.
    case 40:
      return ++this.pos, this.finishToken(types$1.parenL);
    case 41:
      return ++this.pos, this.finishToken(types$1.parenR);
    case 59:
      return ++this.pos, this.finishToken(types$1.semi);
    case 44:
      return ++this.pos, this.finishToken(types$1.comma);
    case 91:
      return ++this.pos, this.finishToken(types$1.bracketL);
    case 93:
      return ++this.pos, this.finishToken(types$1.bracketR);
    case 123:
      return ++this.pos, this.finishToken(types$1.braceL);
    case 125:
      return ++this.pos, this.finishToken(types$1.braceR);
    case 58:
      return ++this.pos, this.finishToken(types$1.colon);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken(types$1.backQuote);
    case 48:
      var s = this.input.charCodeAt(this.pos + 1);
      if (s === 120 || s === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (s === 111 || s === 79)
          return this.readRadixNumber(8);
        if (s === 98 || s === 66)
          return this.readRadixNumber(2);
      }
    // Anything else beginning with a digit is an integer, octal
    // number, or float.
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(!1);
    // Quotes produce strings.
    case 34:
    case 39:
      return this.readString(a);
    // Operators are parsed inline in tiny state machines. '=' (61) is
    // often referred to. `finishOp` simply skips the amount of
    // characters it is given as second argument, and returns a token
    // of the type given by its first argument.
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(a);
    case 124:
    case 38:
      return this.readToken_pipe_amp(a);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(a);
    case 60:
    case 62:
      return this.readToken_lt_gt(a);
    case 61:
    case 33:
      return this.readToken_eq_excl(a);
    case 63:
      return this.readToken_question();
    case 126:
      return this.finishOp(types$1.prefix, 1);
    case 35:
      return this.readToken_numberSign();
  }
  this.raise(this.pos, "Unexpected character '" + codePointToString(a) + "'");
};
pp.finishOp = function(a, s) {
  var c = this.input.slice(this.pos, this.pos + s);
  return this.pos += s, this.finishToken(a, c);
};
pp.readRegexp = function() {
  for (var a, s, c = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(c, "Unterminated regular expression");
    var u = this.input.charAt(this.pos);
    if (lineBreak.test(u) && this.raise(c, "Unterminated regular expression"), a)
      a = !1;
    else {
      if (u === "[")
        s = !0;
      else if (u === "]" && s)
        s = !1;
      else if (u === "/" && !s)
        break;
      a = u === "\\";
    }
    ++this.pos;
  }
  var d = this.input.slice(c, this.pos);
  ++this.pos;
  var p = this.pos, v = this.readWord1();
  this.containsEsc && this.unexpected(p);
  var A = this.regexpState || (this.regexpState = new RegExpValidationState(this));
  A.reset(c, d, v), this.validateRegExpFlags(A), this.validateRegExpPattern(A);
  var x = null;
  try {
    x = new RegExp(d, v);
  } catch {
  }
  return this.finishToken(types$1.regexp, { pattern: d, flags: v, value: x });
};
pp.readInt = function(a, s, c) {
  for (var u = this.options.ecmaVersion >= 12 && s === void 0, d = c && this.input.charCodeAt(this.pos) === 48, p = this.pos, v = 0, A = 0, x = 0, g = s ?? 1 / 0; x < g; ++x, ++this.pos) {
    var b = this.input.charCodeAt(this.pos), y = void 0;
    if (u && b === 95) {
      d && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), A === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), x === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), A = b;
      continue;
    }
    if (b >= 97 ? y = b - 97 + 10 : b >= 65 ? y = b - 65 + 10 : b >= 48 && b <= 57 ? y = b - 48 : y = 1 / 0, y >= a)
      break;
    A = b, v = v * a + y;
  }
  return u && A === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === p || s != null && this.pos - p !== s ? null : v;
};
function stringToNumber(a, s) {
  return s ? parseInt(a, 8) : parseFloat(a.replace(/_/g, ""));
}
function stringToBigInt(a) {
  return typeof BigInt != "function" ? null : BigInt(a.replace(/_/g, ""));
}
pp.readRadixNumber = function(a) {
  var s = this.pos;
  this.pos += 2;
  var c = this.readInt(a);
  return c == null && this.raise(this.start + 2, "Expected number in radix " + a), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (c = stringToBigInt(this.input.slice(s, this.pos)), ++this.pos) : isIdentifierStart(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(types$1.num, c);
};
pp.readNumber = function(a) {
  var s = this.pos;
  !a && this.readInt(10, void 0, !0) === null && this.raise(s, "Invalid number");
  var c = this.pos - s >= 2 && this.input.charCodeAt(s) === 48;
  c && this.strict && this.raise(s, "Invalid number");
  var u = this.input.charCodeAt(this.pos);
  if (!c && !a && this.options.ecmaVersion >= 11 && u === 110) {
    var d = stringToBigInt(this.input.slice(s, this.pos));
    return ++this.pos, isIdentifierStart(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(types$1.num, d);
  }
  c && /[89]/.test(this.input.slice(s, this.pos)) && (c = !1), u === 46 && !c && (++this.pos, this.readInt(10), u = this.input.charCodeAt(this.pos)), (u === 69 || u === 101) && !c && (u = this.input.charCodeAt(++this.pos), (u === 43 || u === 45) && ++this.pos, this.readInt(10) === null && this.raise(s, "Invalid number")), isIdentifierStart(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var p = stringToNumber(this.input.slice(s, this.pos), c);
  return this.finishToken(types$1.num, p);
};
pp.readCodePoint = function() {
  var a = this.input.charCodeAt(this.pos), s;
  if (a === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var c = ++this.pos;
    s = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, s > 1114111 && this.invalidStringToken(c, "Code point out of bounds");
  } else
    s = this.readHexChar(4);
  return s;
};
pp.readString = function(a) {
  for (var s = "", c = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var u = this.input.charCodeAt(this.pos);
    if (u === a)
      break;
    u === 92 ? (s += this.input.slice(c, this.pos), s += this.readEscapedChar(!1), c = this.pos) : u === 8232 || u === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (isNewLine(u) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return s += this.input.slice(c, this.pos++), this.finishToken(types$1.string, s);
};
var INVALID_TEMPLATE_ESCAPE_ERROR = {};
pp.tryReadTemplateToken = function() {
  this.inTemplateElement = !0;
  try {
    this.readTmplToken();
  } catch (a) {
    if (a === INVALID_TEMPLATE_ESCAPE_ERROR)
      this.readInvalidTemplateToken();
    else
      throw a;
  }
  this.inTemplateElement = !1;
};
pp.invalidStringToken = function(a, s) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw INVALID_TEMPLATE_ESCAPE_ERROR;
  this.raise(a, s);
};
pp.readTmplToken = function() {
  for (var a = "", s = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var c = this.input.charCodeAt(this.pos);
    if (c === 96 || c === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos === this.start && (this.type === types$1.template || this.type === types$1.invalidTemplate) ? c === 36 ? (this.pos += 2, this.finishToken(types$1.dollarBraceL)) : (++this.pos, this.finishToken(types$1.backQuote)) : (a += this.input.slice(s, this.pos), this.finishToken(types$1.template, a));
    if (c === 92)
      a += this.input.slice(s, this.pos), a += this.readEscapedChar(!0), s = this.pos;
    else if (isNewLine(c)) {
      switch (a += this.input.slice(s, this.pos), ++this.pos, c) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          a += `
`;
          break;
        default:
          a += String.fromCharCode(c);
          break;
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), s = this.pos;
    } else
      ++this.pos;
  }
};
pp.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      // fall through
      case "`":
        return this.finishToken(types$1.invalidTemplate, this.input.slice(this.start, this.pos));
      case "\r":
        this.input[this.pos + 1] === `
` && ++this.pos;
      // fall through
      case `
`:
      case "\u2028":
      case "\u2029":
        ++this.curLine, this.lineStart = this.pos + 1;
        break;
    }
  this.raise(this.start, "Unterminated template");
};
pp.readEscapedChar = function(a) {
  var s = this.input.charCodeAt(++this.pos);
  switch (++this.pos, s) {
    case 110:
      return `
`;
    // 'n' -> '\n'
    case 114:
      return "\r";
    // 'r' -> '\r'
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    // 'x'
    case 117:
      return codePointToString(this.readCodePoint());
    // 'u'
    case 116:
      return "	";
    // 't' -> '\t'
    case 98:
      return "\b";
    // 'b' -> '\b'
    case 118:
      return "\v";
    // 'v' -> '\u000b'
    case 102:
      return "\f";
    // 'f' -> '\f'
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    // '\r\n'
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    case 56:
    case 57:
      if (this.strict && this.invalidStringToken(
        this.pos - 1,
        "Invalid escape sequence"
      ), a) {
        var c = this.pos - 1;
        this.invalidStringToken(
          c,
          "Invalid escape sequence in template string"
        );
      }
    default:
      if (s >= 48 && s <= 55) {
        var u = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], d = parseInt(u, 8);
        return d > 255 && (u = u.slice(0, -1), d = parseInt(u, 8)), this.pos += u.length - 1, s = this.input.charCodeAt(this.pos), (u !== "0" || s === 56 || s === 57) && (this.strict || a) && this.invalidStringToken(
          this.pos - 1 - u.length,
          a ? "Octal literal in template string" : "Octal literal in strict mode"
        ), String.fromCharCode(d);
      }
      return isNewLine(s) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(s);
  }
};
pp.readHexChar = function(a) {
  var s = this.pos, c = this.readInt(16, a);
  return c === null && this.invalidStringToken(s, "Bad character escape sequence"), c;
};
pp.readWord1 = function() {
  this.containsEsc = !1;
  for (var a = "", s = !0, c = this.pos, u = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var d = this.fullCharCodeAtPos();
    if (isIdentifierChar(d, u))
      this.pos += d <= 65535 ? 1 : 2;
    else if (d === 92) {
      this.containsEsc = !0, a += this.input.slice(c, this.pos);
      var p = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var v = this.readCodePoint();
      (s ? isIdentifierStart : isIdentifierChar)(v, u) || this.invalidStringToken(p, "Invalid Unicode escape"), a += codePointToString(v), c = this.pos;
    } else
      break;
    s = !1;
  }
  return a + this.input.slice(c, this.pos);
};
pp.readWord = function() {
  var a = this.readWord1(), s = types$1.name;
  return this.keywords.test(a) && (s = keywords[a]), this.finishToken(s, a);
};
var version$2 = "8.15.0";
Parser.acorn = {
  Parser,
  version: version$2,
  defaultOptions: defaultOptions$1,
  Position,
  SourceLocation,
  getLineInfo,
  Node,
  TokenType,
  tokTypes: types$1,
  keywordTypes: keywords,
  TokContext,
  tokContexts: types$2,
  isIdentifierChar,
  isIdentifierStart,
  Token,
  isNewLine,
  lineBreak,
  lineBreakG,
  nonASCIIwhitespace
};
function parseExpressionAt(a, s, c) {
  return Parser.parseExpressionAt(a, s, c);
}
const expressionCache = /* @__PURE__ */ new Map(), parseDataCache = /* @__PURE__ */ new Map(), parseData = (a) => {
  const s = JSON.stringify(a);
  if (parseDataCache.has(s))
    return parseDataCache.get(s);
  const c = Object.fromEntries(Object.entries(a).map(([u, d]) => {
    if (typeof d == "string")
      try {
        const p = JSON.parse(d);
        return [u, p];
      } catch {
        return [u, d];
      }
    return [u, d];
  }));
  return parseDataCache.set(s, c), c;
}, padZero = (a) => String(a).padStart(2, "0"), formatDate = (a) => `${a.getFullYear()}/${padZero(a.getMonth() + 1)}/${padZero(a.getDate())}`, formatDateTime = (a) => `${formatDate(a)} ${padZero(a.getHours())}:${padZero(a.getMinutes())}`, safeAssign = (a, ...s) => {
  if (a == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const c = { ...a };
  for (const u of s)
    if (u != null)
      for (const d in u)
        d === "__proto__" || d === "constructor" || d === "prototype" || Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
  return c;
}, safeObject = {
  keys: Object.keys,
  values: Object.values,
  entries: Object.entries,
  fromEntries: Object.fromEntries,
  is: Object.is,
  hasOwnProperty: Object.hasOwnProperty,
  assign: safeAssign
  // Safe version of Object.assign
  // The following methods are excluded due to security concerns:
  // - Side effects: create, freeze, seal (can still be used for attacks)
  // - Prototype access: getOwnPropertyDescriptor, getPrototypeOf, setPrototypeOf,
  //   defineProperty, defineProperties, getOwnPropertyNames, getOwnPropertySymbols
}, allowedGlobals = {
  Math,
  String,
  Number,
  Boolean,
  Array,
  Object: safeObject,
  Date,
  JSON,
  isNaN,
  parseFloat,
  parseInt,
  decodeURI,
  decodeURIComponent,
  encodeURI,
  encodeURIComponent
}, validateAST = (a) => {
  switch (a.type) {
    case "Literal":
    case "Identifier":
      break;
    case "BinaryExpression":
    case "LogicalExpression": {
      const s = a;
      validateAST(s.left), validateAST(s.right);
      break;
    }
    case "UnaryExpression": {
      validateAST(a.argument);
      break;
    }
    case "ConditionalExpression": {
      const s = a;
      validateAST(s.test), validateAST(s.consequent), validateAST(s.alternate);
      break;
    }
    case "MemberExpression": {
      const s = a;
      if (validateAST(s.object), s.computed)
        validateAST(s.property);
      else {
        const c = s.property.name;
        if (["constructor", "__proto__", "prototype"].includes(c))
          throw new Error("Access to prohibited property");
        if (["__defineGetter__", "__defineSetter__", "__lookupGetter__", "__lookupSetter__"].includes(c))
          throw new Error(`Access to prohibited method: ${c}`);
        if (typeof c == "string" && ["toLocaleString", "valueOf"].includes(c))
          throw new Error(`Access to prohibited method: ${c}`);
      }
      break;
    }
    case "CallExpression": {
      const s = a;
      validateAST(s.callee), s.arguments.forEach(validateAST);
      break;
    }
    case "ArrayExpression": {
      a.elements.forEach((c) => {
        c && validateAST(c);
      });
      break;
    }
    case "ObjectExpression": {
      a.properties.forEach((c) => {
        const u = c;
        validateAST(u.key), validateAST(u.value);
      });
      break;
    }
    case "ArrowFunctionExpression": {
      const s = a;
      s.params.forEach((c) => {
        if (c.type !== "Identifier")
          throw new Error("Only identifier parameters are supported in arrow functions");
        validateAST(c);
      }), validateAST(s.body);
      break;
    }
    default:
      throw new Error(`Unsupported syntax in placeholder: ${a.type}`);
  }
}, evaluateAST = (a, s) => {
  switch (a.type) {
    case "Literal":
      return a.value;
    case "Identifier": {
      const c = a;
      if (Object.prototype.hasOwnProperty.call(s, c.name))
        return s[c.name];
      if (Object.prototype.hasOwnProperty.call(allowedGlobals, c.name))
        return allowedGlobals[c.name];
      throw new Error(`Undefined variable: ${c.name}`);
    }
    case "BinaryExpression": {
      const c = a, u = evaluateAST(c.left, s), d = evaluateAST(c.right, s);
      switch (c.operator) {
        case "+":
          return u + d;
        case "-":
          return u - d;
        case "*":
          return u * d;
        case "/":
          return u / d;
        case "%":
          return u % d;
        case "**":
          return u ** d;
        case "==":
          return u == d;
        case "!=":
          return u != d;
        case "===":
          return u === d;
        case "!==":
          return u !== d;
        case "<":
          return u < d;
        case ">":
          return u > d;
        case "<=":
          return u <= d;
        case ">=":
          return u >= d;
        default:
          throw new Error(`Unsupported operator: ${c.operator}`);
      }
    }
    case "LogicalExpression": {
      const c = a, u = evaluateAST(c.left, s), d = evaluateAST(c.right, s);
      switch (c.operator) {
        case "&&":
          return u && d;
        case "||":
          return u || d;
        default:
          throw new Error(`Unsupported operator: ${c.operator}`);
      }
    }
    case "UnaryExpression": {
      const c = a, u = evaluateAST(c.argument, s);
      switch (c.operator) {
        case "+":
          return +u;
        case "-":
          return -u;
        case "!":
          return !u;
        default:
          throw new Error(`Unsupported operator: ${c.operator}`);
      }
    }
    case "ConditionalExpression": {
      const c = a, u = evaluateAST(c.test, s);
      return evaluateAST(u ? c.consequent : c.alternate, s);
    }
    case "MemberExpression": {
      const c = a, u = evaluateAST(c.object, s);
      let d;
      if (c.computed ? d = evaluateAST(c.property, s) : d = c.property.name, typeof d == "string" || typeof d == "number") {
        if (typeof d == "string" && ["constructor", "__proto__", "prototype"].includes(d))
          throw new Error("Access to prohibited property");
        if (typeof d == "string" && ["__defineGetter__", "__defineSetter__", "__lookupGetter__", "__lookupSetter__"].includes(d))
          throw new Error(`Access to prohibited method: ${d}`);
        return u[d];
      } else
        throw new Error("Invalid property access");
    }
    case "CallExpression": {
      const c = a, u = evaluateAST(c.callee, s), d = c.arguments.map((p) => evaluateAST(p, s));
      if (typeof u == "function")
        if (c.callee.type === "MemberExpression") {
          const p = c.callee, v = evaluateAST(p.object, s);
          if (v !== null && (typeof v == "object" || typeof v == "number" || typeof v == "string" || typeof v == "boolean"))
            return u.call(v, ...d);
          throw new Error("Invalid object in member function call");
        } else
          return u(...d);
      else
        throw new Error("Attempted to call a non-function");
    }
    case "ArrowFunctionExpression": {
      const c = a, u = c.params.map((p) => p.name), d = c.body;
      return (...p) => {
        const v = { ...s };
        return u.forEach((A, x) => {
          v[A] = p[x];
        }), evaluateAST(d, v);
      };
    }
    case "ArrayExpression":
      return a.elements.map((u) => u ? evaluateAST(u, s) : null);
    case "ObjectExpression": {
      const c = a, u = {};
      return c.properties.forEach((d) => {
        const p = d;
        let v;
        if (p.key.type === "Identifier")
          v = p.key.name;
        else {
          const x = evaluateAST(p.key, s);
          if (typeof x != "string" && typeof x != "number")
            throw new Error("Object property keys must be strings or numbers");
          v = String(x);
        }
        const A = evaluateAST(p.value, s);
        u[v] = A;
      }), u;
    }
    default:
      throw new Error(`Unsupported syntax in placeholder: ${a.type}`);
  }
}, evaluatePlaceholders = (a) => {
  const { content: s, context: c } = a;
  let u = "", d = 0;
  for (; d < s.length; ) {
    const p = s.indexOf("{", d);
    if (p === -1) {
      u += s.slice(d);
      break;
    }
    u += s.slice(d, p);
    let v = 1, A = p + 1;
    for (; A < s.length && v > 0; )
      s[A] === "{" ? v++ : s[A] === "}" && v--, A++;
    if (v === 0) {
      const x = s.slice(p + 1, A - 1).trim();
      if (expressionCache.has(x)) {
        const g = expressionCache.get(x);
        try {
          const b = g(c);
          u += String(b);
        } catch {
          u += s.slice(p, A);
        }
      } else
        try {
          const g = parseExpressionAt(x, 0, { ecmaVersion: "latest" });
          validateAST(g);
          const b = (f) => evaluateAST(g, f);
          expressionCache.set(x, b);
          const y = b(c);
          u += String(y);
        } catch {
          u += s.slice(p, A);
        }
      d = A;
    } else
      throw new Error("Invalid placeholder");
  }
  return u;
}, replacePlaceholders = (a) => {
  const { content: s, variables: c, schemas: u } = a;
  if (!s || typeof s != "string" || !s.includes("{") || !s.includes("}"))
    return s;
  const d = /* @__PURE__ */ new Date(), p = formatDate(d), v = formatDateTime(d), A = {
    ...Object.fromEntries(u.flat().map((b) => [b.name, b.readOnly && b.content || ""])),
    ...c
  }, x = parseData(A), g = {
    date: p,
    dateTime: v,
    ...x
  };
  return Object.entries(g).forEach(([b, y]) => {
    typeof y == "string" && y.includes("{") && y.includes("}") && (g[b] = evaluatePlaceholders({ content: y, context: g }));
  }), evaluatePlaceholders({ content: s, context: g });
}, pluginRegistry = (a) => ({
  plugins: a,
  entries: () => Object.entries(a),
  values: () => Object.values(a),
  exists: () => Object.values(a).length > 0,
  findWithLabelByType(s) {
    for (const [c, u] of Object.entries(this.plugins)) {
      if (!u || typeof u != "object" || !u.propPanel || typeof u.propPanel != "object")
        continue;
      const d = u.propPanel.defaultSchema;
      if (d && "type" in d && d.type === s)
        return [c, u];
    }
    return ["", void 0];
  },
  findByType(s) {
    const [, c] = this.findWithLabelByType(s);
    return c;
  }
}), DEFAULT_LANG = "en", DESTROYED_ERR_MSG = "[@pdfme/ui] this instance is already destroyed", SELECTABLE_CLASSNAME = "selectable", RULER_HEIGHT = 30, PAGE_GAP = 10, LEFT_SIDEBAR_WIDTH = 45, RIGHT_SIDEBAR_WIDTH = 400, BACKGROUND_COLOR = "rgb(74, 74, 74)", DEFAULT_MAX_ZOOM = 2, isff = typeof navigator < "u" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1;
function addEvent$1(a, s, c, u) {
  a.addEventListener ? a.addEventListener(s, c, u) : a.attachEvent && a.attachEvent("on".concat(s), c);
}
function removeEvent$1(a, s, c, u) {
  a.removeEventListener ? a.removeEventListener(s, c, u) : a.detachEvent && a.detachEvent("on".concat(s), c);
}
function getMods(a, s) {
  const c = s.slice(0, s.length - 1);
  for (let u = 0; u < c.length; u++) c[u] = a[c[u].toLowerCase()];
  return c;
}
function getKeys$1(a) {
  typeof a != "string" && (a = ""), a = a.replace(/\s/g, "");
  const s = a.split(",");
  let c = s.lastIndexOf("");
  for (; c >= 0; )
    s[c - 1] += ",", s.splice(c, 1), c = s.lastIndexOf("");
  return s;
}
function compareArray(a, s) {
  const c = a.length >= s.length ? a : s, u = a.length >= s.length ? s : a;
  let d = !0;
  for (let p = 0; p < c.length; p++)
    u.indexOf(c[p]) === -1 && (d = !1);
  return d;
}
const _keyMap = {
  backspace: 8,
  "⌫": 8,
  tab: 9,
  clear: 12,
  enter: 13,
  "↩": 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  /// https://w3c.github.io/uievents/#events-keyboard-key-location
  arrowup: 38,
  arrowdown: 40,
  arrowleft: 37,
  arrowright: 39,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": isff ? 173 : 189,
  "=": isff ? 61 : 187,
  ";": isff ? 59 : 186,
  "'": 222,
  "{": 219,
  "}": 221,
  "[": 219,
  "]": 221,
  "\\": 220
}, _modifier = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  meta: 91,
  command: 91
}, modifierMap = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, _mods = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, _handlers = {};
for (let a = 1; a < 20; a++)
  _keyMap["f".concat(a)] = 111 + a;
let _downKeys = [], winListendFocus = null, _scope = "all";
const elementEventMap = /* @__PURE__ */ new Map(), code = (a) => _keyMap[a.toLowerCase()] || _modifier[a.toLowerCase()] || a.toUpperCase().charCodeAt(0), getKey$3 = (a) => Object.keys(_keyMap).find((s) => _keyMap[s] === a), getModifier = (a) => Object.keys(_modifier).find((s) => _modifier[s] === a);
function setScope(a) {
  _scope = a || "all";
}
function getScope() {
  return _scope || "all";
}
function getPressedKeyCodes() {
  return _downKeys.slice(0);
}
function getPressedKeyString() {
  return _downKeys.map((a) => getKey$3(a) || getModifier(a) || String.fromCharCode(a));
}
function getAllKeyCodes() {
  const a = [];
  return Object.keys(_handlers).forEach((s) => {
    _handlers[s].forEach((c) => {
      let {
        key: u,
        scope: d,
        mods: p,
        shortcut: v
      } = c;
      a.push({
        scope: d,
        shortcut: v,
        mods: p,
        keys: u.split("+").map((A) => code(A))
      });
    });
  }), a;
}
function filter$1(a) {
  const s = a.target || a.srcElement, {
    tagName: c
  } = s;
  let u = !0;
  const d = c === "INPUT" && !["checkbox", "radio", "range", "button", "file", "reset", "submit", "color"].includes(s.type);
  return (s.isContentEditable || (d || c === "TEXTAREA" || c === "SELECT") && !s.readOnly) && (u = !1), u;
}
function isPressed(a) {
  return typeof a == "string" && (a = code(a)), _downKeys.indexOf(a) !== -1;
}
function deleteScope(a, s) {
  let c, u;
  a || (a = getScope());
  for (const d in _handlers)
    if (Object.prototype.hasOwnProperty.call(_handlers, d))
      for (c = _handlers[d], u = 0; u < c.length; )
        c[u].scope === a ? c.splice(u, 1).forEach((v) => {
          let {
            element: A
          } = v;
          return removeKeyEvent(A);
        }) : u++;
  getScope() === a && setScope(s || "all");
}
function clearModifier(a) {
  let s = a.keyCode || a.which || a.charCode;
  a.key && a.key.toLowerCase() === "capslock" && (s = code(a.key));
  const c = _downKeys.indexOf(s);
  if (c >= 0 && _downKeys.splice(c, 1), a.key && a.key.toLowerCase() === "meta" && _downKeys.splice(0, _downKeys.length), (s === 93 || s === 224) && (s = 91), s in _mods) {
    _mods[s] = !1;
    for (const u in _modifier) _modifier[u] === s && (hotkeys$1[u] = !1);
  }
}
function unbind(a) {
  if (typeof a > "u")
    Object.keys(_handlers).forEach((d) => {
      Array.isArray(_handlers[d]) && _handlers[d].forEach((p) => eachUnbind(p)), delete _handlers[d];
    }), removeKeyEvent(null);
  else if (Array.isArray(a))
    a.forEach((d) => {
      d.key && eachUnbind(d);
    });
  else if (typeof a == "object")
    a.key && eachUnbind(a);
  else if (typeof a == "string") {
    for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++)
      c[u - 1] = arguments[u];
    let [d, p] = c;
    typeof d == "function" && (p = d, d = ""), eachUnbind({
      key: a,
      scope: d,
      method: p,
      splitKey: "+"
    });
  }
}
const eachUnbind = (a) => {
  let {
    key: s,
    scope: c,
    method: u,
    splitKey: d = "+"
  } = a;
  getKeys$1(s).forEach((v) => {
    const A = v.split(d), x = A.length, g = A[x - 1], b = g === "*" ? "*" : code(g);
    if (!_handlers[b]) return;
    c || (c = getScope());
    const y = x > 1 ? getMods(_modifier, A) : [], f = [];
    _handlers[b] = _handlers[b].filter((m) => {
      const w = (u ? m.method === u : !0) && m.scope === c && compareArray(m.mods, y);
      return w && f.push(m.element), !w;
    }), f.forEach((m) => removeKeyEvent(m));
  });
};
function eventHandler(a, s, c, u) {
  if (s.element !== u)
    return;
  let d;
  if (s.scope === c || s.scope === "all") {
    d = s.mods.length > 0;
    for (const p in _mods)
      Object.prototype.hasOwnProperty.call(_mods, p) && (!_mods[p] && s.mods.indexOf(+p) > -1 || _mods[p] && s.mods.indexOf(+p) === -1) && (d = !1);
    (s.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || d || s.shortcut === "*") && (s.keys = [], s.keys = s.keys.concat(_downKeys), s.method(a, s) === !1 && (a.preventDefault ? a.preventDefault() : a.returnValue = !1, a.stopPropagation && a.stopPropagation(), a.cancelBubble && (a.cancelBubble = !0)));
  }
}
function dispatch(a, s) {
  const c = _handlers["*"];
  let u = a.keyCode || a.which || a.charCode;
  if (a.key && a.key.toLowerCase() === "capslock" || !hotkeys$1.filter.call(this, a)) return;
  if ((u === 93 || u === 224) && (u = 91), _downKeys.indexOf(u) === -1 && u !== 229 && _downKeys.push(u), ["metaKey", "ctrlKey", "altKey", "shiftKey"].forEach((A) => {
    const x = modifierMap[A];
    a[A] && _downKeys.indexOf(x) === -1 ? _downKeys.push(x) : !a[A] && _downKeys.indexOf(x) > -1 ? _downKeys.splice(_downKeys.indexOf(x), 1) : A === "metaKey" && a[A] && (_downKeys = _downKeys.filter((g) => g in modifierMap || g === u));
  }), u in _mods) {
    _mods[u] = !0;
    for (const A in _modifier)
      if (Object.prototype.hasOwnProperty.call(_modifier, A)) {
        const x = modifierMap[_modifier[A]];
        hotkeys$1[A] = a[x];
      }
    if (!c) return;
  }
  for (const A in _mods)
    Object.prototype.hasOwnProperty.call(_mods, A) && (_mods[A] = a[modifierMap[A]]);
  a.getModifierState && !(a.altKey && !a.ctrlKey) && a.getModifierState("AltGraph") && (_downKeys.indexOf(17) === -1 && _downKeys.push(17), _downKeys.indexOf(18) === -1 && _downKeys.push(18), _mods[17] = !0, _mods[18] = !0);
  const d = getScope();
  if (c)
    for (let A = 0; A < c.length; A++)
      c[A].scope === d && (a.type === "keydown" && c[A].keydown || a.type === "keyup" && c[A].keyup) && eventHandler(a, c[A], d, s);
  if (!(u in _handlers)) return;
  const p = _handlers[u], v = p.length;
  for (let A = 0; A < v; A++)
    if ((a.type === "keydown" && p[A].keydown || a.type === "keyup" && p[A].keyup) && p[A].key) {
      const x = p[A], {
        splitKey: g
      } = x, b = x.key.split(g), y = [];
      for (let f = 0; f < b.length; f++)
        y.push(code(b[f]));
      y.sort().join("") === _downKeys.sort().join("") && eventHandler(a, x, d, s);
    }
}
function hotkeys$1(a, s, c) {
  _downKeys = [];
  const u = getKeys$1(a);
  let d = [], p = "all", v = document, A = 0, x = !1, g = !0, b = "+", y = !1, f = !1;
  for (c === void 0 && typeof s == "function" && (c = s), Object.prototype.toString.call(s) === "[object Object]" && (s.scope && (p = s.scope), s.element && (v = s.element), s.keyup && (x = s.keyup), s.keydown !== void 0 && (g = s.keydown), s.capture !== void 0 && (y = s.capture), typeof s.splitKey == "string" && (b = s.splitKey), s.single === !0 && (f = !0)), typeof s == "string" && (p = s), f && unbind(a, p); A < u.length; A++)
    a = u[A].split(b), d = [], a.length > 1 && (d = getMods(_modifier, a)), a = a[a.length - 1], a = a === "*" ? "*" : code(a), a in _handlers || (_handlers[a] = []), _handlers[a].push({
      keyup: x,
      keydown: g,
      scope: p,
      mods: d,
      shortcut: u[A],
      method: c,
      key: u[A],
      splitKey: b,
      element: v
    });
  if (typeof v < "u" && window) {
    if (!elementEventMap.has(v)) {
      const m = function() {
        let w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        return dispatch(w, v);
      }, C = function() {
        let w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        dispatch(w, v), clearModifier(w);
      };
      elementEventMap.set(v, {
        keydownListener: m,
        keyupListenr: C,
        capture: y
      }), addEvent$1(v, "keydown", m, y), addEvent$1(v, "keyup", C, y);
    }
    if (!winListendFocus) {
      const m = () => {
        _downKeys = [];
      };
      winListendFocus = {
        listener: m,
        capture: y
      }, addEvent$1(window, "focus", m, y);
    }
  }
}
function trigger(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
  Object.keys(_handlers).forEach((c) => {
    _handlers[c].filter((d) => d.scope === s && d.shortcut === a).forEach((d) => {
      d && d.method && d.method();
    });
  });
}
function removeKeyEvent(a) {
  const s = Object.values(_handlers).flat();
  if (s.findIndex((u) => {
    let {
      element: d
    } = u;
    return d === a;
  }) < 0) {
    const {
      keydownListener: u,
      keyupListenr: d,
      capture: p
    } = elementEventMap.get(a) || {};
    u && d && (removeEvent$1(a, "keyup", d, p), removeEvent$1(a, "keydown", u, p), elementEventMap.delete(a));
  }
  if ((s.length <= 0 || elementEventMap.size <= 0) && (Object.keys(elementEventMap).forEach((d) => {
    const {
      keydownListener: p,
      keyupListenr: v,
      capture: A
    } = elementEventMap.get(d) || {};
    p && v && (removeEvent$1(d, "keyup", v, A), removeEvent$1(d, "keydown", p, A), elementEventMap.delete(d));
  }), elementEventMap.clear(), Object.keys(_handlers).forEach((d) => delete _handlers[d]), winListendFocus)) {
    const {
      listener: d,
      capture: p
    } = winListendFocus;
    removeEvent$1(window, "focus", d, p), winListendFocus = null;
  }
}
const _api = {
  getPressedKeyString,
  setScope,
  getScope,
  deleteScope,
  getPressedKeyCodes,
  getAllKeyCodes,
  isPressed,
  filter: filter$1,
  trigger,
  unbind,
  keyMap: _keyMap,
  modifier: _modifier,
  modifierMap
};
for (const a in _api)
  Object.prototype.hasOwnProperty.call(_api, a) && (hotkeys$1[a] = _api[a]);
if (typeof window < "u") {
  const a = window.hotkeys;
  hotkeys$1.noConflict = (s) => (s && window.hotkeys === hotkeys$1 && (window.hotkeys = a), hotkeys$1), window.hotkeys = hotkeys$1;
}
var reactExports = requireReact();
const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports), React$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: React
}, [reactExports]);
function commonjsRequire(a) {
  throw new Error('Could not dynamically require "' + a + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$5 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasRequiredPdf;
function requirePdf() {
  return hasRequiredPdf || (hasRequiredPdf = 1, function(module, exports) {
    (function(s, c) {
      module.exports = s.pdfjsLib = c();
    })(globalThis, () => (
      /******/
      (() => {
        var __webpack_modules__ = [
          ,
          /* 1 */
          /***/
          (a, s) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.VerbosityLevel = s.Util = s.UnknownErrorException = s.UnexpectedResponseException = s.TextRenderingMode = s.RenderingIntentFlag = s.PromiseCapability = s.PermissionFlag = s.PasswordResponses = s.PasswordException = s.PageActionEventType = s.OPS = s.MissingPDFException = s.MAX_IMAGE_SIZE_TO_CACHE = s.LINE_FACTOR = s.LINE_DESCENT_FACTOR = s.InvalidPDFException = s.ImageKind = s.IDENTITY_MATRIX = s.FormatError = s.FeatureTest = s.FONT_IDENTITY_MATRIX = s.DocumentActionEventType = s.CMapCompressionType = s.BaseException = s.BASELINE_FACTOR = s.AnnotationType = s.AnnotationReplyType = s.AnnotationPrefix = s.AnnotationMode = s.AnnotationFlag = s.AnnotationFieldFlag = s.AnnotationEditorType = s.AnnotationEditorPrefix = s.AnnotationEditorParamsType = s.AnnotationBorderStyleType = s.AnnotationActionEventType = s.AbortException = void 0, s.assert = D, s.bytesToString = ae, s.createValidAbsoluteUrl = V, s.getModificationDate = Ae, s.getUuid = Te, s.getVerbosityLevel = U, s.info = k, s.isArrayBuffer = we, s.isArrayEqual = $e, s.isNodeJS = void 0, s.normalizeUnicode = _e, s.objectFromMap = ge, s.objectSize = fe, s.setVerbosityLevel = G, s.shadow = Z, s.string32 = ie, s.stringToBytes = se, s.stringToPDFString = ye, s.stringToUTF8String = Ce, s.unreachable = P, s.utf8StringToString = xe, s.warn = N;
            const c = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
            s.isNodeJS = c;
            const u = [1, 0, 0, 1, 0, 0];
            s.IDENTITY_MATRIX = u;
            const d = [1e-3, 0, 0, 1e-3, 0, 0];
            s.FONT_IDENTITY_MATRIX = d;
            const p = 1e7;
            s.MAX_IMAGE_SIZE_TO_CACHE = p;
            const v = 1.35;
            s.LINE_FACTOR = v;
            const A = 0.35;
            s.LINE_DESCENT_FACTOR = A;
            const x = A / v;
            s.BASELINE_FACTOR = x;
            const g = {
              ANY: 1,
              DISPLAY: 2,
              PRINT: 4,
              SAVE: 8,
              ANNOTATIONS_FORMS: 16,
              ANNOTATIONS_STORAGE: 32,
              ANNOTATIONS_DISABLE: 64,
              OPLIST: 256
            };
            s.RenderingIntentFlag = g;
            const b = {
              DISABLE: 0,
              ENABLE: 1,
              ENABLE_FORMS: 2,
              ENABLE_STORAGE: 3
            };
            s.AnnotationMode = b;
            const y = "pdfjs_internal_editor_";
            s.AnnotationEditorPrefix = y;
            const f = {
              DISABLE: -1,
              NONE: 0,
              FREETEXT: 3,
              STAMP: 13,
              INK: 15
            };
            s.AnnotationEditorType = f;
            const m = {
              RESIZE: 1,
              CREATE: 2,
              FREETEXT_SIZE: 11,
              FREETEXT_COLOR: 12,
              FREETEXT_OPACITY: 13,
              INK_COLOR: 21,
              INK_THICKNESS: 22,
              INK_OPACITY: 23
            };
            s.AnnotationEditorParamsType = m;
            const C = {
              PRINT: 4,
              MODIFY_CONTENTS: 8,
              COPY: 16,
              MODIFY_ANNOTATIONS: 32,
              FILL_INTERACTIVE_FORMS: 256,
              COPY_FOR_ACCESSIBILITY: 512,
              ASSEMBLE: 1024,
              PRINT_HIGH_QUALITY: 2048
            };
            s.PermissionFlag = C;
            const w = {
              FILL: 0,
              STROKE: 1,
              FILL_STROKE: 2,
              INVISIBLE: 3,
              FILL_ADD_TO_PATH: 4,
              STROKE_ADD_TO_PATH: 5,
              FILL_STROKE_ADD_TO_PATH: 6,
              ADD_TO_PATH: 7,
              FILL_STROKE_MASK: 3,
              ADD_TO_PATH_FLAG: 4
            };
            s.TextRenderingMode = w;
            const S = {
              GRAYSCALE_1BPP: 1,
              RGB_24BPP: 2,
              RGBA_32BPP: 3
            };
            s.ImageKind = S;
            const $ = {
              TEXT: 1,
              LINK: 2,
              FREETEXT: 3,
              LINE: 4,
              SQUARE: 5,
              CIRCLE: 6,
              POLYGON: 7,
              POLYLINE: 8,
              HIGHLIGHT: 9,
              UNDERLINE: 10,
              SQUIGGLY: 11,
              STRIKEOUT: 12,
              STAMP: 13,
              CARET: 14,
              INK: 15,
              POPUP: 16,
              FILEATTACHMENT: 17,
              SOUND: 18,
              MOVIE: 19,
              WIDGET: 20,
              SCREEN: 21,
              PRINTERMARK: 22,
              TRAPNET: 23,
              WATERMARK: 24,
              THREED: 25,
              REDACT: 26
            };
            s.AnnotationType = $;
            const T = {
              GROUP: "Group",
              REPLY: "R"
            };
            s.AnnotationReplyType = T;
            const I = {
              INVISIBLE: 1,
              HIDDEN: 2,
              PRINT: 4,
              NOZOOM: 8,
              NOROTATE: 16,
              NOVIEW: 32,
              READONLY: 64,
              LOCKED: 128,
              TOGGLENOVIEW: 256,
              LOCKEDCONTENTS: 512
            };
            s.AnnotationFlag = I;
            const _ = {
              READONLY: 1,
              REQUIRED: 2,
              NOEXPORT: 4,
              MULTILINE: 4096,
              PASSWORD: 8192,
              NOTOGGLETOOFF: 16384,
              RADIO: 32768,
              PUSHBUTTON: 65536,
              COMBO: 131072,
              EDIT: 262144,
              SORT: 524288,
              FILESELECT: 1048576,
              MULTISELECT: 2097152,
              DONOTSPELLCHECK: 4194304,
              DONOTSCROLL: 8388608,
              COMB: 16777216,
              RICHTEXT: 33554432,
              RADIOSINUNISON: 33554432,
              COMMITONSELCHANGE: 67108864
            };
            s.AnnotationFieldFlag = _;
            const E = {
              SOLID: 1,
              DASHED: 2,
              BEVELED: 3,
              INSET: 4,
              UNDERLINE: 5
            };
            s.AnnotationBorderStyleType = E;
            const R = {
              E: "Mouse Enter",
              X: "Mouse Exit",
              D: "Mouse Down",
              U: "Mouse Up",
              Fo: "Focus",
              Bl: "Blur",
              PO: "PageOpen",
              PC: "PageClose",
              PV: "PageVisible",
              PI: "PageInvisible",
              K: "Keystroke",
              F: "Format",
              V: "Validate",
              C: "Calculate"
            };
            s.AnnotationActionEventType = R;
            const O = {
              WC: "WillClose",
              WS: "WillSave",
              DS: "DidSave",
              WP: "WillPrint",
              DP: "DidPrint"
            };
            s.DocumentActionEventType = O;
            const L = {
              O: "PageOpen",
              C: "PageClose"
            };
            s.PageActionEventType = L;
            const B = {
              ERRORS: 0,
              WARNINGS: 1,
              INFOS: 5
            };
            s.VerbosityLevel = B;
            const F = {
              NONE: 0,
              BINARY: 1
            };
            s.CMapCompressionType = F;
            const M = {
              dependency: 1,
              setLineWidth: 2,
              setLineCap: 3,
              setLineJoin: 4,
              setMiterLimit: 5,
              setDash: 6,
              setRenderingIntent: 7,
              setFlatness: 8,
              setGState: 9,
              save: 10,
              restore: 11,
              transform: 12,
              moveTo: 13,
              lineTo: 14,
              curveTo: 15,
              curveTo2: 16,
              curveTo3: 17,
              closePath: 18,
              rectangle: 19,
              stroke: 20,
              closeStroke: 21,
              fill: 22,
              eoFill: 23,
              fillStroke: 24,
              eoFillStroke: 25,
              closeFillStroke: 26,
              closeEOFillStroke: 27,
              endPath: 28,
              clip: 29,
              eoClip: 30,
              beginText: 31,
              endText: 32,
              setCharSpacing: 33,
              setWordSpacing: 34,
              setHScale: 35,
              setLeading: 36,
              setFont: 37,
              setTextRenderingMode: 38,
              setTextRise: 39,
              moveText: 40,
              setLeadingMoveText: 41,
              setTextMatrix: 42,
              nextLine: 43,
              showText: 44,
              showSpacedText: 45,
              nextLineShowText: 46,
              nextLineSetSpacingShowText: 47,
              setCharWidth: 48,
              setCharWidthAndBounds: 49,
              setStrokeColorSpace: 50,
              setFillColorSpace: 51,
              setStrokeColor: 52,
              setStrokeColorN: 53,
              setFillColor: 54,
              setFillColorN: 55,
              setStrokeGray: 56,
              setFillGray: 57,
              setStrokeRGBColor: 58,
              setFillRGBColor: 59,
              setStrokeCMYKColor: 60,
              setFillCMYKColor: 61,
              shadingFill: 62,
              beginInlineImage: 63,
              beginImageData: 64,
              endInlineImage: 65,
              paintXObject: 66,
              markPoint: 67,
              markPointProps: 68,
              beginMarkedContent: 69,
              beginMarkedContentProps: 70,
              endMarkedContent: 71,
              beginCompat: 72,
              endCompat: 73,
              paintFormXObjectBegin: 74,
              paintFormXObjectEnd: 75,
              beginGroup: 76,
              endGroup: 77,
              beginAnnotation: 80,
              endAnnotation: 81,
              paintImageMaskXObject: 83,
              paintImageMaskXObjectGroup: 84,
              paintImageXObject: 85,
              paintInlineImageXObject: 86,
              paintInlineImageXObjectGroup: 87,
              paintImageXObjectRepeat: 88,
              paintImageMaskXObjectRepeat: 89,
              paintSolidColorImageMask: 90,
              constructPath: 91
            };
            s.OPS = M;
            const W = {
              NEED_PASSWORD: 1,
              INCORRECT_PASSWORD: 2
            };
            s.PasswordResponses = W;
            let j = B.WARNINGS;
            function G(Re) {
              Number.isInteger(Re) && (j = Re);
            }
            function U() {
              return j;
            }
            function k(Re) {
              j >= B.INFOS && console.log(`Info: ${Re}`);
            }
            function N(Re) {
              j >= B.WARNINGS && console.log(`Warning: ${Re}`);
            }
            function P(Re) {
              throw new Error(Re);
            }
            function D(Re, Be) {
              Re || P(Be);
            }
            function H(Re) {
              switch (Re?.protocol) {
                case "http:":
                case "https:":
                case "ftp:":
                case "mailto:":
                case "tel:":
                  return !0;
                default:
                  return !1;
              }
            }
            function V(Re, Be = null, Oe = null) {
              if (!Re)
                return null;
              try {
                if (Oe && typeof Re == "string" && (Oe.addDefaultProtocol && Re.startsWith("www.") && Re.match(/\./g)?.length >= 2 && (Re = `http://${Re}`), Oe.tryConvertEncoding))
                  try {
                    Re = Ce(Re);
                  } catch {
                  }
                const Me = Be ? new URL(Re, Be) : new URL(Re);
                if (H(Me))
                  return Me;
              } catch {
              }
              return null;
            }
            function Z(Re, Be, Oe, Me = !1) {
              return Object.defineProperty(Re, Be, {
                value: Oe,
                enumerable: !Me,
                configurable: !0,
                writable: !1
              }), Oe;
            }
            const ne = function() {
              function Be(Oe, Me) {
                this.constructor === Be && P("Cannot initialize BaseException."), this.message = Oe, this.name = Me;
              }
              return Be.prototype = new Error(), Be.constructor = Be, Be;
            }();
            s.BaseException = ne;
            class K extends ne {
              constructor(Be, Oe) {
                super(Be, "PasswordException"), this.code = Oe;
              }
            }
            s.PasswordException = K;
            class q extends ne {
              constructor(Be, Oe) {
                super(Be, "UnknownErrorException"), this.details = Oe;
              }
            }
            s.UnknownErrorException = q;
            class Y extends ne {
              constructor(Be) {
                super(Be, "InvalidPDFException");
              }
            }
            s.InvalidPDFException = Y;
            class ee extends ne {
              constructor(Be) {
                super(Be, "MissingPDFException");
              }
            }
            s.MissingPDFException = ee;
            class Q extends ne {
              constructor(Be, Oe) {
                super(Be, "UnexpectedResponseException"), this.status = Oe;
              }
            }
            s.UnexpectedResponseException = Q;
            class J extends ne {
              constructor(Be) {
                super(Be, "FormatError");
              }
            }
            s.FormatError = J;
            class te extends ne {
              constructor(Be) {
                super(Be, "AbortException");
              }
            }
            s.AbortException = te;
            function ae(Re) {
              (typeof Re != "object" || Re?.length === void 0) && P("Invalid argument for bytesToString");
              const Be = Re.length, Oe = 8192;
              if (Be < Oe)
                return String.fromCharCode.apply(null, Re);
              const Me = [];
              for (let Fe = 0; Fe < Be; Fe += Oe) {
                const Ue = Math.min(Fe + Oe, Be), je = Re.subarray(Fe, Ue);
                Me.push(String.fromCharCode.apply(null, je));
              }
              return Me.join("");
            }
            function se(Re) {
              typeof Re != "string" && P("Invalid argument for stringToBytes");
              const Be = Re.length, Oe = new Uint8Array(Be);
              for (let Me = 0; Me < Be; ++Me)
                Oe[Me] = Re.charCodeAt(Me) & 255;
              return Oe;
            }
            function ie(Re) {
              return String.fromCharCode(Re >> 24 & 255, Re >> 16 & 255, Re >> 8 & 255, Re & 255);
            }
            function fe(Re) {
              return Object.keys(Re).length;
            }
            function ge(Re) {
              const Be = /* @__PURE__ */ Object.create(null);
              for (const [Oe, Me] of Re)
                Be[Oe] = Me;
              return Be;
            }
            function me() {
              const Re = new Uint8Array(4);
              return Re[0] = 1, new Uint32Array(Re.buffer, 0, 1)[0] === 1;
            }
            function pe() {
              try {
                return new Function(""), !0;
              } catch {
                return !1;
              }
            }
            class be {
              static get isLittleEndian() {
                return Z(this, "isLittleEndian", me());
              }
              static get isEvalSupported() {
                return Z(this, "isEvalSupported", pe());
              }
              static get isOffscreenCanvasSupported() {
                return Z(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
              }
              static get platform() {
                return typeof navigator > "u" ? Z(this, "platform", {
                  isWin: !1,
                  isMac: !1
                }) : Z(this, "platform", {
                  isWin: navigator.platform.includes("Win"),
                  isMac: navigator.platform.includes("Mac")
                });
              }
              static get isCSSRoundSupported() {
                return Z(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
              }
            }
            s.FeatureTest = be;
            const le = [...Array(256).keys()].map((Re) => Re.toString(16).padStart(2, "0"));
            class ve {
              static makeHexColor(Be, Oe, Me) {
                return `#${le[Be]}${le[Oe]}${le[Me]}`;
              }
              static scaleMinMax(Be, Oe) {
                let Me;
                Be[0] ? (Be[0] < 0 && (Me = Oe[0], Oe[0] = Oe[1], Oe[1] = Me), Oe[0] *= Be[0], Oe[1] *= Be[0], Be[3] < 0 && (Me = Oe[2], Oe[2] = Oe[3], Oe[3] = Me), Oe[2] *= Be[3], Oe[3] *= Be[3]) : (Me = Oe[0], Oe[0] = Oe[2], Oe[2] = Me, Me = Oe[1], Oe[1] = Oe[3], Oe[3] = Me, Be[1] < 0 && (Me = Oe[2], Oe[2] = Oe[3], Oe[3] = Me), Oe[2] *= Be[1], Oe[3] *= Be[1], Be[2] < 0 && (Me = Oe[0], Oe[0] = Oe[1], Oe[1] = Me), Oe[0] *= Be[2], Oe[1] *= Be[2]), Oe[0] += Be[4], Oe[1] += Be[4], Oe[2] += Be[5], Oe[3] += Be[5];
              }
              static transform(Be, Oe) {
                return [Be[0] * Oe[0] + Be[2] * Oe[1], Be[1] * Oe[0] + Be[3] * Oe[1], Be[0] * Oe[2] + Be[2] * Oe[3], Be[1] * Oe[2] + Be[3] * Oe[3], Be[0] * Oe[4] + Be[2] * Oe[5] + Be[4], Be[1] * Oe[4] + Be[3] * Oe[5] + Be[5]];
              }
              static applyTransform(Be, Oe) {
                const Me = Be[0] * Oe[0] + Be[1] * Oe[2] + Oe[4], Fe = Be[0] * Oe[1] + Be[1] * Oe[3] + Oe[5];
                return [Me, Fe];
              }
              static applyInverseTransform(Be, Oe) {
                const Me = Oe[0] * Oe[3] - Oe[1] * Oe[2], Fe = (Be[0] * Oe[3] - Be[1] * Oe[2] + Oe[2] * Oe[5] - Oe[4] * Oe[3]) / Me, Ue = (-Be[0] * Oe[1] + Be[1] * Oe[0] + Oe[4] * Oe[1] - Oe[5] * Oe[0]) / Me;
                return [Fe, Ue];
              }
              static getAxialAlignedBoundingBox(Be, Oe) {
                const Me = this.applyTransform(Be, Oe), Fe = this.applyTransform(Be.slice(2, 4), Oe), Ue = this.applyTransform([Be[0], Be[3]], Oe), je = this.applyTransform([Be[2], Be[1]], Oe);
                return [Math.min(Me[0], Fe[0], Ue[0], je[0]), Math.min(Me[1], Fe[1], Ue[1], je[1]), Math.max(Me[0], Fe[0], Ue[0], je[0]), Math.max(Me[1], Fe[1], Ue[1], je[1])];
              }
              static inverseTransform(Be) {
                const Oe = Be[0] * Be[3] - Be[1] * Be[2];
                return [Be[3] / Oe, -Be[1] / Oe, -Be[2] / Oe, Be[0] / Oe, (Be[2] * Be[5] - Be[4] * Be[3]) / Oe, (Be[4] * Be[1] - Be[5] * Be[0]) / Oe];
              }
              static singularValueDecompose2dScale(Be) {
                const Oe = [Be[0], Be[2], Be[1], Be[3]], Me = Be[0] * Oe[0] + Be[1] * Oe[2], Fe = Be[0] * Oe[1] + Be[1] * Oe[3], Ue = Be[2] * Oe[0] + Be[3] * Oe[2], je = Be[2] * Oe[1] + Be[3] * Oe[3], Le = (Me + je) / 2, De = Math.sqrt((Me + je) ** 2 - 4 * (Me * je - Ue * Fe)) / 2, Ne = Le + De || 1, Ge = Le - De || 1;
                return [Math.sqrt(Ne), Math.sqrt(Ge)];
              }
              static normalizeRect(Be) {
                const Oe = Be.slice(0);
                return Be[0] > Be[2] && (Oe[0] = Be[2], Oe[2] = Be[0]), Be[1] > Be[3] && (Oe[1] = Be[3], Oe[3] = Be[1]), Oe;
              }
              static intersect(Be, Oe) {
                const Me = Math.max(Math.min(Be[0], Be[2]), Math.min(Oe[0], Oe[2])), Fe = Math.min(Math.max(Be[0], Be[2]), Math.max(Oe[0], Oe[2]));
                if (Me > Fe)
                  return null;
                const Ue = Math.max(Math.min(Be[1], Be[3]), Math.min(Oe[1], Oe[3])), je = Math.min(Math.max(Be[1], Be[3]), Math.max(Oe[1], Oe[3]));
                return Ue > je ? null : [Me, Ue, Fe, je];
              }
              static bezierBoundingBox(Be, Oe, Me, Fe, Ue, je, Le, De) {
                const Ne = [], Ge = [[], []];
                let Xe, nt, ct, it, We, Ve, ut, at;
                for (let vt = 0; vt < 2; ++vt) {
                  if (vt === 0 ? (nt = 6 * Be - 12 * Me + 6 * Ue, Xe = -3 * Be + 9 * Me - 9 * Ue + 3 * Le, ct = 3 * Me - 3 * Be) : (nt = 6 * Oe - 12 * Fe + 6 * je, Xe = -3 * Oe + 9 * Fe - 9 * je + 3 * De, ct = 3 * Fe - 3 * Oe), Math.abs(Xe) < 1e-12) {
                    if (Math.abs(nt) < 1e-12)
                      continue;
                    it = -ct / nt, 0 < it && it < 1 && Ne.push(it);
                    continue;
                  }
                  ut = nt * nt - 4 * ct * Xe, at = Math.sqrt(ut), !(ut < 0) && (We = (-nt + at) / (2 * Xe), 0 < We && We < 1 && Ne.push(We), Ve = (-nt - at) / (2 * Xe), 0 < Ve && Ve < 1 && Ne.push(Ve));
                }
                let Qe = Ne.length, st;
                const ft = Qe;
                for (; Qe--; )
                  it = Ne[Qe], st = 1 - it, Ge[0][Qe] = st * st * st * Be + 3 * st * st * it * Me + 3 * st * it * it * Ue + it * it * it * Le, Ge[1][Qe] = st * st * st * Oe + 3 * st * st * it * Fe + 3 * st * it * it * je + it * it * it * De;
                return Ge[0][ft] = Be, Ge[1][ft] = Oe, Ge[0][ft + 1] = Le, Ge[1][ft + 1] = De, Ge[0].length = Ge[1].length = ft + 2, [Math.min(...Ge[0]), Math.min(...Ge[1]), Math.max(...Ge[0]), Math.max(...Ge[1])];
              }
            }
            s.Util = ve;
            const he = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
            function ye(Re) {
              if (Re[0] >= "ï") {
                let Oe;
                if (Re[0] === "þ" && Re[1] === "ÿ" ? Oe = "utf-16be" : Re[0] === "ÿ" && Re[1] === "þ" ? Oe = "utf-16le" : Re[0] === "ï" && Re[1] === "»" && Re[2] === "¿" && (Oe = "utf-8"), Oe)
                  try {
                    const Me = new TextDecoder(Oe, {
                      fatal: !0
                    }), Fe = se(Re);
                    return Me.decode(Fe);
                  } catch (Me) {
                    N(`stringToPDFString: "${Me}".`);
                  }
              }
              const Be = [];
              for (let Oe = 0, Me = Re.length; Oe < Me; Oe++) {
                const Fe = he[Re.charCodeAt(Oe)];
                Be.push(Fe ? String.fromCharCode(Fe) : Re.charAt(Oe));
              }
              return Be.join("");
            }
            function Ce(Re) {
              return decodeURIComponent(escape(Re));
            }
            function xe(Re) {
              return unescape(encodeURIComponent(Re));
            }
            function we(Re) {
              return typeof Re == "object" && Re?.byteLength !== void 0;
            }
            function $e(Re, Be) {
              if (Re.length !== Be.length)
                return !1;
              for (let Oe = 0, Me = Re.length; Oe < Me; Oe++)
                if (Re[Oe] !== Be[Oe])
                  return !1;
              return !0;
            }
            function Ae(Re = /* @__PURE__ */ new Date()) {
              return [Re.getUTCFullYear().toString(), (Re.getUTCMonth() + 1).toString().padStart(2, "0"), Re.getUTCDate().toString().padStart(2, "0"), Re.getUTCHours().toString().padStart(2, "0"), Re.getUTCMinutes().toString().padStart(2, "0"), Re.getUTCSeconds().toString().padStart(2, "0")].join("");
            }
            class ue {
              #e = !1;
              constructor() {
                this.promise = new Promise((Be, Oe) => {
                  this.resolve = (Me) => {
                    this.#e = !0, Be(Me);
                  }, this.reject = (Me) => {
                    this.#e = !0, Oe(Me);
                  };
                });
              }
              get settled() {
                return this.#e;
              }
            }
            s.PromiseCapability = ue;
            let ce = null, Ee = null;
            function _e(Re) {
              return ce || (ce = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, Ee = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), Re.replaceAll(ce, (Be, Oe, Me) => Oe ? Oe.normalize("NFKC") : Ee.get(Me));
            }
            function Te() {
              if (typeof crypto < "u" && typeof crypto?.randomUUID == "function")
                return crypto.randomUUID();
              const Re = new Uint8Array(32);
              if (typeof crypto < "u" && typeof crypto?.getRandomValues == "function")
                crypto.getRandomValues(Re);
              else
                for (let Be = 0; Be < 32; Be++)
                  Re[Be] = Math.floor(Math.random() * 255);
              return ae(Re);
            }
            const ke = "pdfjs_internal_id_";
            s.AnnotationPrefix = ke;
          },
          /* 2 */
          /***/
          (__unused_webpack_module, exports, __w_pdfjs_require__) => {
            Object.defineProperty(exports, "__esModule", {
              value: !0
            }), exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0, Object.defineProperty(exports, "SVGGraphics", {
              enumerable: !0,
              get: function() {
                return _displaySvg.SVGGraphics;
              }
            }), exports.build = void 0, exports.getDocument = getDocument, exports.version = void 0;
            var _util = __w_pdfjs_require__(1), _annotation_storage = __w_pdfjs_require__(3), _display_utils = __w_pdfjs_require__(6), _font_loader = __w_pdfjs_require__(9), _displayNode_utils = __w_pdfjs_require__(10), _canvas = __w_pdfjs_require__(11), _worker_options = __w_pdfjs_require__(14), _message_handler = __w_pdfjs_require__(15), _metadata = __w_pdfjs_require__(16), _optional_content_config = __w_pdfjs_require__(17), _transport_stream = __w_pdfjs_require__(18), _displayFetch_stream = __w_pdfjs_require__(19), _displayNetwork = __w_pdfjs_require__(22), _displayNode_stream = __w_pdfjs_require__(23), _displaySvg = __w_pdfjs_require__(24), _xfa_text = __w_pdfjs_require__(25);
            const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100, DELAYED_CLEANUP_TIMEOUT = 5e3, DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
            exports.DefaultCanvasFactory = DefaultCanvasFactory;
            const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
            exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
            const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
            exports.DefaultFilterFactory = DefaultFilterFactory;
            const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
            exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
            function getDocument(a) {
              if (typeof a == "string" || a instanceof URL ? a = {
                url: a
              } : (0, _util.isArrayBuffer)(a) && (a = {
                data: a
              }), typeof a != "object")
                throw new Error("Invalid parameter in getDocument, need parameter object.");
              if (!a.url && !a.data && !a.range)
                throw new Error("Invalid parameter object: need either .data, .range or .url");
              const s = new PDFDocumentLoadingTask(), {
                docId: c
              } = s, u = a.url ? getUrlProp(a.url) : null, d = a.data ? getDataProp(a.data) : null, p = a.httpHeaders || null, v = a.withCredentials === !0, A = a.password ?? null, x = a.range instanceof PDFDataRangeTransport ? a.range : null, g = Number.isInteger(a.rangeChunkSize) && a.rangeChunkSize > 0 ? a.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
              let b = a.worker instanceof PDFWorker ? a.worker : null;
              const y = a.verbosity, f = typeof a.docBaseUrl == "string" && !(0, _display_utils.isDataScheme)(a.docBaseUrl) ? a.docBaseUrl : null, m = typeof a.cMapUrl == "string" ? a.cMapUrl : null, C = a.cMapPacked !== !1, w = a.CMapReaderFactory || DefaultCMapReaderFactory, S = typeof a.standardFontDataUrl == "string" ? a.standardFontDataUrl : null, $ = a.StandardFontDataFactory || DefaultStandardFontDataFactory, T = a.stopAtErrors !== !0, I = Number.isInteger(a.maxImageSize) && a.maxImageSize > -1 ? a.maxImageSize : -1, _ = a.isEvalSupported !== !1, E = typeof a.isOffscreenCanvasSupported == "boolean" ? a.isOffscreenCanvasSupported : !_util.isNodeJS, R = Number.isInteger(a.canvasMaxAreaInBytes) ? a.canvasMaxAreaInBytes : -1, O = typeof a.disableFontFace == "boolean" ? a.disableFontFace : _util.isNodeJS, L = a.fontExtraProperties === !0, B = a.enableXfa === !0, F = a.ownerDocument || globalThis.document, M = a.disableRange === !0, W = a.disableStream === !0, j = a.disableAutoFetch === !0, G = a.pdfBug === !0, U = x ? x.length : a.length ?? NaN, k = typeof a.useSystemFonts == "boolean" ? a.useSystemFonts : !_util.isNodeJS && !O, N = typeof a.useWorkerFetch == "boolean" ? a.useWorkerFetch : w === _display_utils.DOMCMapReaderFactory && $ === _display_utils.DOMStandardFontDataFactory && m && S && (0, _display_utils.isValidFetchUrl)(m, document.baseURI) && (0, _display_utils.isValidFetchUrl)(S, document.baseURI), P = a.canvasFactory || new DefaultCanvasFactory({
                ownerDocument: F
              }), D = a.filterFactory || new DefaultFilterFactory({
                docId: c,
                ownerDocument: F
              }), H = null;
              (0, _util.setVerbosityLevel)(y);
              const V = {
                canvasFactory: P,
                filterFactory: D
              };
              if (N || (V.cMapReaderFactory = new w({
                baseUrl: m,
                isCompressed: C
              }), V.standardFontDataFactory = new $({
                baseUrl: S
              })), !b) {
                const K = {
                  verbosity: y,
                  port: _worker_options.GlobalWorkerOptions.workerPort
                };
                b = K.port ? PDFWorker.fromPort(K) : new PDFWorker(K), s._worker = b;
              }
              const Z = {
                docId: c,
                apiVersion: "3.11.174",
                data: d,
                password: A,
                disableAutoFetch: j,
                rangeChunkSize: g,
                length: U,
                docBaseUrl: f,
                enableXfa: B,
                evaluatorOptions: {
                  maxImageSize: I,
                  disableFontFace: O,
                  ignoreErrors: T,
                  isEvalSupported: _,
                  isOffscreenCanvasSupported: E,
                  canvasMaxAreaInBytes: R,
                  fontExtraProperties: L,
                  useSystemFonts: k,
                  cMapUrl: N ? m : null,
                  standardFontDataUrl: N ? S : null
                }
              }, ne = {
                ignoreErrors: T,
                isEvalSupported: _,
                disableFontFace: O,
                fontExtraProperties: L,
                enableXfa: B,
                ownerDocument: F,
                disableAutoFetch: j,
                pdfBug: G,
                styleElement: H
              };
              return b.promise.then(function() {
                if (s.destroyed)
                  throw new Error("Loading aborted");
                const K = _fetchDocument(b, Z), q = new Promise(function(Y) {
                  let ee;
                  x ? ee = new _transport_stream.PDFDataTransportStream({
                    length: U,
                    initialData: x.initialData,
                    progressiveDone: x.progressiveDone,
                    contentDispositionFilename: x.contentDispositionFilename,
                    disableRange: M,
                    disableStream: W
                  }, x) : d || (ee = ((J) => _util.isNodeJS ? new _displayNode_stream.PDFNodeStream(J) : (0, _display_utils.isValidFetchUrl)(J.url) ? new _displayFetch_stream.PDFFetchStream(J) : new _displayNetwork.PDFNetworkStream(J))({
                    url: u,
                    length: U,
                    httpHeaders: p,
                    withCredentials: v,
                    rangeChunkSize: g,
                    disableRange: M,
                    disableStream: W
                  })), Y(ee);
                });
                return Promise.all([K, q]).then(function([Y, ee]) {
                  if (s.destroyed)
                    throw new Error("Loading aborted");
                  const Q = new _message_handler.MessageHandler(c, Y, b.port), J = new WorkerTransport(Q, s, ee, ne, V);
                  s._transport = J, Q.send("Ready", null);
                });
              }).catch(s._capability.reject), s;
            }
            async function _fetchDocument(a, s) {
              if (a.destroyed)
                throw new Error("Worker was destroyed");
              const c = await a.messageHandler.sendWithPromise("GetDocRequest", s, s.data ? [s.data.buffer] : null);
              if (a.destroyed)
                throw new Error("Worker was destroyed");
              return c;
            }
            function getUrlProp(a) {
              if (a instanceof URL)
                return a.href;
              try {
                return new URL(a, window.location).href;
              } catch {
                if (_util.isNodeJS && typeof a == "string")
                  return a;
              }
              throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
            }
            function getDataProp(a) {
              if (_util.isNodeJS && typeof Buffer < "u" && a instanceof Buffer)
                throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
              if (a instanceof Uint8Array && a.byteLength === a.buffer.byteLength)
                return a;
              if (typeof a == "string")
                return (0, _util.stringToBytes)(a);
              if (typeof a == "object" && !isNaN(a?.length) || (0, _util.isArrayBuffer)(a))
                return new Uint8Array(a);
              throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
            }
            class PDFDocumentLoadingTask {
              static #e = 0;
              constructor() {
                this._capability = new _util.PromiseCapability(), this._transport = null, this._worker = null, this.docId = `d${PDFDocumentLoadingTask.#e++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null;
              }
              get promise() {
                return this._capability.promise;
              }
              async destroy() {
                this.destroyed = !0;
                try {
                  this._worker?.port && (this._worker._pendingDestroy = !0), await this._transport?.destroy();
                } catch (s) {
                  throw this._worker?.port && delete this._worker._pendingDestroy, s;
                }
                this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
              }
            }
            exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
            class PDFDataRangeTransport {
              constructor(s, c, u = !1, d = null) {
                this.length = s, this.initialData = c, this.progressiveDone = u, this.contentDispositionFilename = d, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = new _util.PromiseCapability();
              }
              addRangeListener(s) {
                this._rangeListeners.push(s);
              }
              addProgressListener(s) {
                this._progressListeners.push(s);
              }
              addProgressiveReadListener(s) {
                this._progressiveReadListeners.push(s);
              }
              addProgressiveDoneListener(s) {
                this._progressiveDoneListeners.push(s);
              }
              onDataRange(s, c) {
                for (const u of this._rangeListeners)
                  u(s, c);
              }
              onDataProgress(s, c) {
                this._readyCapability.promise.then(() => {
                  for (const u of this._progressListeners)
                    u(s, c);
                });
              }
              onDataProgressiveRead(s) {
                this._readyCapability.promise.then(() => {
                  for (const c of this._progressiveReadListeners)
                    c(s);
                });
              }
              onDataProgressiveDone() {
                this._readyCapability.promise.then(() => {
                  for (const s of this._progressiveDoneListeners)
                    s();
                });
              }
              transportReady() {
                this._readyCapability.resolve();
              }
              requestDataRange(s, c) {
                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
              }
              abort() {
              }
            }
            exports.PDFDataRangeTransport = PDFDataRangeTransport;
            class PDFDocumentProxy {
              constructor(s, c) {
                this._pdfInfo = s, this._transport = c, Object.defineProperty(this, "getJavaScript", {
                  value: () => ((0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead."), this.getJSActions().then((u) => {
                    if (!u)
                      return u;
                    const d = [];
                    for (const p in u)
                      d.push(...u[p]);
                    return d;
                  }))
                });
              }
              get annotationStorage() {
                return this._transport.annotationStorage;
              }
              get filterFactory() {
                return this._transport.filterFactory;
              }
              get numPages() {
                return this._pdfInfo.numPages;
              }
              get fingerprints() {
                return this._pdfInfo.fingerprints;
              }
              get isPureXfa() {
                return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
              }
              get allXfaHtml() {
                return this._transport._htmlForXfa;
              }
              getPage(s) {
                return this._transport.getPage(s);
              }
              getPageIndex(s) {
                return this._transport.getPageIndex(s);
              }
              getDestinations() {
                return this._transport.getDestinations();
              }
              getDestination(s) {
                return this._transport.getDestination(s);
              }
              getPageLabels() {
                return this._transport.getPageLabels();
              }
              getPageLayout() {
                return this._transport.getPageLayout();
              }
              getPageMode() {
                return this._transport.getPageMode();
              }
              getViewerPreferences() {
                return this._transport.getViewerPreferences();
              }
              getOpenAction() {
                return this._transport.getOpenAction();
              }
              getAttachments() {
                return this._transport.getAttachments();
              }
              getJSActions() {
                return this._transport.getDocJSActions();
              }
              getOutline() {
                return this._transport.getOutline();
              }
              getOptionalContentConfig() {
                return this._transport.getOptionalContentConfig();
              }
              getPermissions() {
                return this._transport.getPermissions();
              }
              getMetadata() {
                return this._transport.getMetadata();
              }
              getMarkInfo() {
                return this._transport.getMarkInfo();
              }
              getData() {
                return this._transport.getData();
              }
              saveDocument() {
                return this._transport.saveDocument();
              }
              getDownloadInfo() {
                return this._transport.downloadInfoCapability.promise;
              }
              cleanup(s = !1) {
                return this._transport.startCleanup(s || this.isPureXfa);
              }
              destroy() {
                return this.loadingTask.destroy();
              }
              get loadingParams() {
                return this._transport.loadingParams;
              }
              get loadingTask() {
                return this._transport.loadingTask;
              }
              getFieldObjects() {
                return this._transport.getFieldObjects();
              }
              hasJSActions() {
                return this._transport.hasJSActions();
              }
              getCalculationOrderIds() {
                return this._transport.getCalculationOrderIds();
              }
            }
            exports.PDFDocumentProxy = PDFDocumentProxy;
            class PDFPageProxy {
              #e = null;
              #t = !1;
              constructor(s, c, u, d = !1) {
                this._pageIndex = s, this._pageInfo = c, this._transport = u, this._stats = d ? new _display_utils.StatTimer() : null, this._pdfBug = d, this.commonObjs = u.commonObjs, this.objs = new PDFObjects(), this._maybeCleanupAfterRender = !1, this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1;
              }
              get pageNumber() {
                return this._pageIndex + 1;
              }
              get rotate() {
                return this._pageInfo.rotate;
              }
              get ref() {
                return this._pageInfo.ref;
              }
              get userUnit() {
                return this._pageInfo.userUnit;
              }
              get view() {
                return this._pageInfo.view;
              }
              getViewport({
                scale: s,
                rotation: c = this.rotate,
                offsetX: u = 0,
                offsetY: d = 0,
                dontFlip: p = !1
              } = {}) {
                return new _display_utils.PageViewport({
                  viewBox: this.view,
                  scale: s,
                  rotation: c,
                  offsetX: u,
                  offsetY: d,
                  dontFlip: p
                });
              }
              getAnnotations({
                intent: s = "display"
              } = {}) {
                const c = this._transport.getRenderingIntent(s);
                return this._transport.getAnnotations(this._pageIndex, c.renderingIntent);
              }
              getJSActions() {
                return this._transport.getPageJSActions(this._pageIndex);
              }
              get filterFactory() {
                return this._transport.filterFactory;
              }
              get isPureXfa() {
                return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
              }
              async getXfa() {
                return this._transport._htmlForXfa?.children[this._pageIndex] || null;
              }
              render({
                canvasContext: s,
                viewport: c,
                intent: u = "display",
                annotationMode: d = _util.AnnotationMode.ENABLE,
                transform: p = null,
                background: v = null,
                optionalContentConfigPromise: A = null,
                annotationCanvasMap: x = null,
                pageColors: g = null,
                printAnnotationStorage: b = null
              }) {
                this._stats?.time("Overall");
                const y = this._transport.getRenderingIntent(u, d, b);
                this.#t = !1, this.#n(), A || (A = this._transport.getOptionalContentConfig());
                let f = this._intentStates.get(y.cacheKey);
                f || (f = /* @__PURE__ */ Object.create(null), this._intentStates.set(y.cacheKey, f)), f.streamReaderCancelTimeout && (clearTimeout(f.streamReaderCancelTimeout), f.streamReaderCancelTimeout = null);
                const m = !!(y.renderingIntent & _util.RenderingIntentFlag.PRINT);
                f.displayReadyCapability || (f.displayReadyCapability = new _util.PromiseCapability(), f.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats?.time("Page Request"), this._pumpOperatorList(y));
                const C = ($) => {
                  f.renderTasks.delete(w), (this._maybeCleanupAfterRender || m) && (this.#t = !0), this.#r(!m), $ ? (w.capability.reject($), this._abortOperatorList({
                    intentState: f,
                    reason: $ instanceof Error ? $ : new Error($)
                  })) : w.capability.resolve(), this._stats?.timeEnd("Rendering"), this._stats?.timeEnd("Overall");
                }, w = new InternalRenderTask({
                  callback: C,
                  params: {
                    canvasContext: s,
                    viewport: c,
                    transform: p,
                    background: v
                  },
                  objs: this.objs,
                  commonObjs: this.commonObjs,
                  annotationCanvasMap: x,
                  operatorList: f.operatorList,
                  pageIndex: this._pageIndex,
                  canvasFactory: this._transport.canvasFactory,
                  filterFactory: this._transport.filterFactory,
                  useRequestAnimationFrame: !m,
                  pdfBug: this._pdfBug,
                  pageColors: g
                });
                (f.renderTasks ||= /* @__PURE__ */ new Set()).add(w);
                const S = w.task;
                return Promise.all([f.displayReadyCapability.promise, A]).then(([$, T]) => {
                  if (this.destroyed) {
                    C();
                    return;
                  }
                  this._stats?.time("Rendering"), w.initializeGraphics({
                    transparency: $,
                    optionalContentConfig: T
                  }), w.operatorListChanged();
                }).catch(C), S;
              }
              getOperatorList({
                intent: s = "display",
                annotationMode: c = _util.AnnotationMode.ENABLE,
                printAnnotationStorage: u = null
              } = {}) {
                function d() {
                  v.operatorList.lastChunk && (v.opListReadCapability.resolve(v.operatorList), v.renderTasks.delete(A));
                }
                const p = this._transport.getRenderingIntent(s, c, u, !0);
                let v = this._intentStates.get(p.cacheKey);
                v || (v = /* @__PURE__ */ Object.create(null), this._intentStates.set(p.cacheKey, v));
                let A;
                return v.opListReadCapability || (A = /* @__PURE__ */ Object.create(null), A.operatorListChanged = d, v.opListReadCapability = new _util.PromiseCapability(), (v.renderTasks ||= /* @__PURE__ */ new Set()).add(A), v.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats?.time("Page Request"), this._pumpOperatorList(p)), v.opListReadCapability.promise;
              }
              streamTextContent({
                includeMarkedContent: s = !1,
                disableNormalization: c = !1
              } = {}) {
                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                  pageIndex: this._pageIndex,
                  includeMarkedContent: s === !0,
                  disableNormalization: c === !0
                }, {
                  highWaterMark: 100,
                  size(d) {
                    return d.items.length;
                  }
                });
              }
              getTextContent(s = {}) {
                if (this._transport._htmlForXfa)
                  return this.getXfa().then((u) => _xfa_text.XfaText.textContent(u));
                const c = this.streamTextContent(s);
                return new Promise(function(u, d) {
                  function p() {
                    v.read().then(function({
                      value: x,
                      done: g
                    }) {
                      if (g) {
                        u(A);
                        return;
                      }
                      Object.assign(A.styles, x.styles), A.items.push(...x.items), p();
                    }, d);
                  }
                  const v = c.getReader(), A = {
                    items: [],
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  p();
                });
              }
              getStructTree() {
                return this._transport.getStructTree(this._pageIndex);
              }
              _destroy() {
                this.destroyed = !0;
                const s = [];
                for (const c of this._intentStates.values())
                  if (this._abortOperatorList({
                    intentState: c,
                    reason: new Error("Page was destroyed."),
                    force: !0
                  }), !c.opListReadCapability)
                    for (const u of c.renderTasks)
                      s.push(u.completed), u.cancel();
                return this.objs.clear(), this.#t = !1, this.#n(), Promise.all(s);
              }
              cleanup(s = !1) {
                this.#t = !0;
                const c = this.#r(!1);
                return s && c && (this._stats &&= new _display_utils.StatTimer()), c;
              }
              #r(s = !1) {
                if (this.#n(), !this.#t || this.destroyed)
                  return !1;
                if (s)
                  return this.#e = setTimeout(() => {
                    this.#e = null, this.#r(!1);
                  }, DELAYED_CLEANUP_TIMEOUT), !1;
                for (const {
                  renderTasks: c,
                  operatorList: u
                } of this._intentStates.values())
                  if (c.size > 0 || !u.lastChunk)
                    return !1;
                return this._intentStates.clear(), this.objs.clear(), this.#t = !1, !0;
              }
              #n() {
                this.#e && (clearTimeout(this.#e), this.#e = null);
              }
              _startRenderPage(s, c) {
                const u = this._intentStates.get(c);
                u && (this._stats?.timeEnd("Page Request"), u.displayReadyCapability?.resolve(s));
              }
              _renderPageChunk(s, c) {
                for (let u = 0, d = s.length; u < d; u++)
                  c.operatorList.fnArray.push(s.fnArray[u]), c.operatorList.argsArray.push(s.argsArray[u]);
                c.operatorList.lastChunk = s.lastChunk, c.operatorList.separateAnnots = s.separateAnnots;
                for (const u of c.renderTasks)
                  u.operatorListChanged();
                s.lastChunk && this.#r(!0);
              }
              _pumpOperatorList({
                renderingIntent: s,
                cacheKey: c,
                annotationStorageSerializable: u
              }) {
                const {
                  map: d,
                  transfers: p
                } = u, A = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                  pageIndex: this._pageIndex,
                  intent: s,
                  cacheKey: c,
                  annotationStorage: d
                }, p).getReader(), x = this._intentStates.get(c);
                x.streamReader = A;
                const g = () => {
                  A.read().then(({
                    value: b,
                    done: y
                  }) => {
                    if (y) {
                      x.streamReader = null;
                      return;
                    }
                    this._transport.destroyed || (this._renderPageChunk(b, x), g());
                  }, (b) => {
                    if (x.streamReader = null, !this._transport.destroyed) {
                      if (x.operatorList) {
                        x.operatorList.lastChunk = !0;
                        for (const y of x.renderTasks)
                          y.operatorListChanged();
                        this.#r(!0);
                      }
                      if (x.displayReadyCapability)
                        x.displayReadyCapability.reject(b);
                      else if (x.opListReadCapability)
                        x.opListReadCapability.reject(b);
                      else
                        throw b;
                    }
                  });
                };
                g();
              }
              _abortOperatorList({
                intentState: s,
                reason: c,
                force: u = !1
              }) {
                if (s.streamReader) {
                  if (s.streamReaderCancelTimeout && (clearTimeout(s.streamReaderCancelTimeout), s.streamReaderCancelTimeout = null), !u) {
                    if (s.renderTasks.size > 0)
                      return;
                    if (c instanceof _display_utils.RenderingCancelledException) {
                      let d = RENDERING_CANCELLED_TIMEOUT;
                      c.extraDelay > 0 && c.extraDelay < 1e3 && (d += c.extraDelay), s.streamReaderCancelTimeout = setTimeout(() => {
                        s.streamReaderCancelTimeout = null, this._abortOperatorList({
                          intentState: s,
                          reason: c,
                          force: !0
                        });
                      }, d);
                      return;
                    }
                  }
                  if (s.streamReader.cancel(new _util.AbortException(c.message)).catch(() => {
                  }), s.streamReader = null, !this._transport.destroyed) {
                    for (const [d, p] of this._intentStates)
                      if (p === s) {
                        this._intentStates.delete(d);
                        break;
                      }
                    this.cleanup();
                  }
                }
              }
              get stats() {
                return this._stats;
              }
            }
            exports.PDFPageProxy = PDFPageProxy;
            class LoopbackPort {
              #e = /* @__PURE__ */ new Set();
              #t = Promise.resolve();
              postMessage(s, c) {
                const u = {
                  data: structuredClone(s, c ? {
                    transfer: c
                  } : null)
                };
                this.#t.then(() => {
                  for (const d of this.#e)
                    d.call(this, u);
                });
              }
              addEventListener(s, c) {
                this.#e.add(c);
              }
              removeEventListener(s, c) {
                this.#e.delete(c);
              }
              terminate() {
                this.#e.clear();
              }
            }
            exports.LoopbackPort = LoopbackPort;
            const PDFWorkerUtil = {
              isWorkerDisabled: !1,
              fallbackWorkerSrc: null,
              fakeWorkerId: 0
            };
            exports.PDFWorkerUtil = PDFWorkerUtil;
            {
              if (_util.isNodeJS && typeof commonjsRequire == "function")
                PDFWorkerUtil.isWorkerDisabled = !0, PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
              else if (typeof document == "object") {
                const a = document?.currentScript?.src;
                a && (PDFWorkerUtil.fallbackWorkerSrc = a.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
              }
              PDFWorkerUtil.isSameOrigin = function(a, s) {
                let c;
                try {
                  if (c = new URL(a), !c.origin || c.origin === "null")
                    return !1;
                } catch {
                  return !1;
                }
                const u = new URL(s, c);
                return c.origin === u.origin;
              }, PDFWorkerUtil.createCDNWrapper = function(a) {
                const s = `importScripts("${a}");`;
                return URL.createObjectURL(new Blob([s]));
              };
            }
            class PDFWorker {
              static #workerPorts;
              constructor({
                name: a = null,
                port: s = null,
                verbosity: c = (0, _util.getVerbosityLevel)()
              } = {}) {
                if (this.name = a, this.destroyed = !1, this.verbosity = c, this._readyCapability = new _util.PromiseCapability(), this._port = null, this._webWorker = null, this._messageHandler = null, s) {
                  if (PDFWorker.#workerPorts?.has(s))
                    throw new Error("Cannot use more than one PDFWorker per port.");
                  (PDFWorker.#workerPorts ||= /* @__PURE__ */ new WeakMap()).set(s, this), this._initializeFromPort(s);
                  return;
                }
                this._initialize();
              }
              get promise() {
                return this._readyCapability.promise;
              }
              get port() {
                return this._port;
              }
              get messageHandler() {
                return this._messageHandler;
              }
              _initializeFromPort(a) {
                this._port = a, this._messageHandler = new _message_handler.MessageHandler("main", "worker", a), this._messageHandler.on("ready", function() {
                }), this._readyCapability.resolve(), this._messageHandler.send("configure", {
                  verbosity: this.verbosity
                });
              }
              _initialize() {
                if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                  let {
                    workerSrc: a
                  } = PDFWorker;
                  try {
                    PDFWorkerUtil.isSameOrigin(window.location.href, a) || (a = PDFWorkerUtil.createCDNWrapper(new URL(a, window.location).href));
                    const s = new Worker(a), c = new _message_handler.MessageHandler("main", "worker", s), u = () => {
                      s.removeEventListener("error", d), c.destroy(), s.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                    }, d = () => {
                      this._webWorker || u();
                    };
                    s.addEventListener("error", d), c.on("test", (v) => {
                      if (s.removeEventListener("error", d), this.destroyed) {
                        u();
                        return;
                      }
                      v ? (this._messageHandler = c, this._port = s, this._webWorker = s, this._readyCapability.resolve(), c.send("configure", {
                        verbosity: this.verbosity
                      })) : (this._setupFakeWorker(), c.destroy(), s.terminate());
                    }), c.on("ready", (v) => {
                      if (s.removeEventListener("error", d), this.destroyed) {
                        u();
                        return;
                      }
                      try {
                        p();
                      } catch {
                        this._setupFakeWorker();
                      }
                    });
                    const p = () => {
                      const v = new Uint8Array();
                      c.send("test", v, [v.buffer]);
                    };
                    p();
                    return;
                  } catch {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
              _setupFakeWorker() {
                PDFWorkerUtil.isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), PDFWorker._setupFakeWorkerGlobal.then((a) => {
                  if (this.destroyed) {
                    this._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  const s = new LoopbackPort();
                  this._port = s;
                  const c = `fake${PDFWorkerUtil.fakeWorkerId++}`, u = new _message_handler.MessageHandler(c + "_worker", c, s);
                  a.setup(u, s);
                  const d = new _message_handler.MessageHandler(c, c + "_worker", s);
                  this._messageHandler = d, this._readyCapability.resolve(), d.send("configure", {
                    verbosity: this.verbosity
                  });
                }).catch((a) => {
                  this._readyCapability.reject(new Error(`Setting up fake worker failed: "${a.message}".`));
                });
              }
              destroy() {
                this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), PDFWorker.#workerPorts?.delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
              }
              static fromPort(a) {
                if (!a?.port)
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                const s = this.#workerPorts?.get(a.port);
                if (s) {
                  if (s._pendingDestroy)
                    throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                  return s;
                }
                return new PDFWorker(a);
              }
              static get workerSrc() {
                if (_worker_options.GlobalWorkerOptions.workerSrc)
                  return _worker_options.GlobalWorkerOptions.workerSrc;
                if (PDFWorkerUtil.fallbackWorkerSrc !== null)
                  return _util.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), PDFWorkerUtil.fallbackWorkerSrc;
                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
              }
              static get _mainThreadWorkerMessageHandler() {
                try {
                  return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                } catch {
                  return null;
                }
              }
              static get _setupFakeWorkerGlobal() {
                const loader = async () => {
                  const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                  if (mainWorkerMessageHandler)
                    return mainWorkerMessageHandler;
                  if (_util.isNodeJS && typeof commonjsRequire == "function") {
                    const worker = eval("require")(this.workerSrc);
                    return worker.WorkerMessageHandler;
                  }
                  return await (0, _display_utils.loadScript)(this.workerSrc), window.pdfjsWorker.WorkerMessageHandler;
                };
                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
              }
            }
            exports.PDFWorker = PDFWorker;
            class WorkerTransport {
              #e = /* @__PURE__ */ new Map();
              #t = /* @__PURE__ */ new Map();
              #r = /* @__PURE__ */ new Map();
              #n = null;
              constructor(s, c, u, d, p) {
                this.messageHandler = s, this.loadingTask = c, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                  ownerDocument: d.ownerDocument,
                  styleElement: d.styleElement
                }), this._params = d, this.canvasFactory = p.canvasFactory, this.filterFactory = p.filterFactory, this.cMapReaderFactory = p.cMapReaderFactory, this.standardFontDataFactory = p.standardFontDataFactory, this.destroyed = !1, this.destroyCapability = null, this._networkStream = u, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = new _util.PromiseCapability(), this.setupMessageHandler();
              }
              #s(s, c = null) {
                const u = this.#e.get(s);
                if (u)
                  return u;
                const d = this.messageHandler.sendWithPromise(s, c);
                return this.#e.set(s, d), d;
              }
              get annotationStorage() {
                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
              }
              getRenderingIntent(s, c = _util.AnnotationMode.ENABLE, u = null, d = !1) {
                let p = _util.RenderingIntentFlag.DISPLAY, v = _annotation_storage.SerializableEmpty;
                switch (s) {
                  case "any":
                    p = _util.RenderingIntentFlag.ANY;
                    break;
                  case "display":
                    break;
                  case "print":
                    p = _util.RenderingIntentFlag.PRINT;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid intent: ${s}`);
                }
                switch (c) {
                  case _util.AnnotationMode.DISABLE:
                    p += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                    break;
                  case _util.AnnotationMode.ENABLE:
                    break;
                  case _util.AnnotationMode.ENABLE_FORMS:
                    p += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                    break;
                  case _util.AnnotationMode.ENABLE_STORAGE:
                    p += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE, v = (p & _util.RenderingIntentFlag.PRINT && u instanceof _annotation_storage.PrintAnnotationStorage ? u : this.annotationStorage).serializable;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${c}`);
                }
                return d && (p += _util.RenderingIntentFlag.OPLIST), {
                  renderingIntent: p,
                  cacheKey: `${p}_${v.hash}`,
                  annotationStorageSerializable: v
                };
              }
              destroy() {
                if (this.destroyCapability)
                  return this.destroyCapability.promise;
                this.destroyed = !0, this.destroyCapability = new _util.PromiseCapability(), this.#n?.reject(new Error("Worker was destroyed during onPassword callback"));
                const s = [];
                for (const u of this.#t.values())
                  s.push(u._destroy());
                this.#t.clear(), this.#r.clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
                const c = this.messageHandler.sendWithPromise("Terminate", null);
                return s.push(c), Promise.all(s).then(() => {
                  this.commonObjs.clear(), this.fontLoader.clear(), this.#e.clear(), this.filterFactory.destroy(), this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
                }, this.destroyCapability.reject), this.destroyCapability.promise;
              }
              setupMessageHandler() {
                const {
                  messageHandler: s,
                  loadingTask: c
                } = this;
                s.on("GetReader", (u, d) => {
                  (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (p) => {
                    this._lastProgress = {
                      loaded: p.loaded,
                      total: p.total
                    };
                  }, d.onPull = () => {
                    this._fullReader.read().then(function({
                      value: p,
                      done: v
                    }) {
                      if (v) {
                        d.close();
                        return;
                      }
                      (0, _util.assert)(p instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer."), d.enqueue(new Uint8Array(p), 1, [p]);
                    }).catch((p) => {
                      d.error(p);
                    });
                  }, d.onCancel = (p) => {
                    this._fullReader.cancel(p), d.ready.catch((v) => {
                      if (!this.destroyed)
                        throw v;
                    });
                  };
                }), s.on("ReaderHeadersReady", (u) => {
                  const d = new _util.PromiseCapability(), p = this._fullReader;
                  return p.headersReady.then(() => {
                    (!p.isStreamingSupported || !p.isRangeSupported) && (this._lastProgress && c.onProgress?.(this._lastProgress), p.onProgress = (v) => {
                      c.onProgress?.({
                        loaded: v.loaded,
                        total: v.total
                      });
                    }), d.resolve({
                      isStreamingSupported: p.isStreamingSupported,
                      isRangeSupported: p.isRangeSupported,
                      contentLength: p.contentLength
                    });
                  }, d.reject), d.promise;
                }), s.on("GetRangeReader", (u, d) => {
                  (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                  const p = this._networkStream.getRangeReader(u.begin, u.end);
                  if (!p) {
                    d.close();
                    return;
                  }
                  d.onPull = () => {
                    p.read().then(function({
                      value: v,
                      done: A
                    }) {
                      if (A) {
                        d.close();
                        return;
                      }
                      (0, _util.assert)(v instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer."), d.enqueue(new Uint8Array(v), 1, [v]);
                    }).catch((v) => {
                      d.error(v);
                    });
                  }, d.onCancel = (v) => {
                    p.cancel(v), d.ready.catch((A) => {
                      if (!this.destroyed)
                        throw A;
                    });
                  };
                }), s.on("GetDoc", ({
                  pdfInfo: u
                }) => {
                  this._numPages = u.numPages, this._htmlForXfa = u.htmlForXfa, delete u.htmlForXfa, c._capability.resolve(new PDFDocumentProxy(u, this));
                }), s.on("DocException", function(u) {
                  let d;
                  switch (u.name) {
                    case "PasswordException":
                      d = new _util.PasswordException(u.message, u.code);
                      break;
                    case "InvalidPDFException":
                      d = new _util.InvalidPDFException(u.message);
                      break;
                    case "MissingPDFException":
                      d = new _util.MissingPDFException(u.message);
                      break;
                    case "UnexpectedResponseException":
                      d = new _util.UnexpectedResponseException(u.message, u.status);
                      break;
                    case "UnknownErrorException":
                      d = new _util.UnknownErrorException(u.message, u.details);
                      break;
                    default:
                      (0, _util.unreachable)("DocException - expected a valid Error.");
                  }
                  c._capability.reject(d);
                }), s.on("PasswordRequest", (u) => {
                  if (this.#n = new _util.PromiseCapability(), c.onPassword) {
                    const d = (p) => {
                      p instanceof Error ? this.#n.reject(p) : this.#n.resolve({
                        password: p
                      });
                    };
                    try {
                      c.onPassword(d, u.code);
                    } catch (p) {
                      this.#n.reject(p);
                    }
                  } else
                    this.#n.reject(new _util.PasswordException(u.message, u.code));
                  return this.#n.promise;
                }), s.on("DataLoaded", (u) => {
                  c.onProgress?.({
                    loaded: u.length,
                    total: u.length
                  }), this.downloadInfoCapability.resolve(u);
                }), s.on("StartRenderPage", (u) => {
                  if (this.destroyed)
                    return;
                  this.#t.get(u.pageIndex)._startRenderPage(u.transparency, u.cacheKey);
                }), s.on("commonobj", ([u, d, p]) => {
                  if (!this.destroyed && !this.commonObjs.has(u))
                    switch (d) {
                      case "Font":
                        const v = this._params;
                        if ("error" in p) {
                          const g = p.error;
                          (0, _util.warn)(`Error during font loading: ${g}`), this.commonObjs.resolve(u, g);
                          break;
                        }
                        const A = v.pdfBug && globalThis.FontInspector?.enabled ? (g, b) => globalThis.FontInspector.fontAdded(g, b) : null, x = new _font_loader.FontFaceObject(p, {
                          isEvalSupported: v.isEvalSupported,
                          disableFontFace: v.disableFontFace,
                          ignoreErrors: v.ignoreErrors,
                          inspectFont: A
                        });
                        this.fontLoader.bind(x).catch((g) => s.sendWithPromise("FontFallback", {
                          id: u
                        })).finally(() => {
                          !v.fontExtraProperties && x.data && (x.data = null), this.commonObjs.resolve(u, x);
                        });
                        break;
                      case "FontPath":
                      case "Image":
                      case "Pattern":
                        this.commonObjs.resolve(u, p);
                        break;
                      default:
                        throw new Error(`Got unknown common object type ${d}`);
                    }
                }), s.on("obj", ([u, d, p, v]) => {
                  if (this.destroyed)
                    return;
                  const A = this.#t.get(d);
                  if (!A.objs.has(u))
                    switch (p) {
                      case "Image":
                        if (A.objs.resolve(u, v), v) {
                          let x;
                          if (v.bitmap) {
                            const {
                              width: g,
                              height: b
                            } = v;
                            x = g * b * 4;
                          } else
                            x = v.data?.length || 0;
                          x > _util.MAX_IMAGE_SIZE_TO_CACHE && (A._maybeCleanupAfterRender = !0);
                        }
                        break;
                      case "Pattern":
                        A.objs.resolve(u, v);
                        break;
                      default:
                        throw new Error(`Got unknown object type ${p}`);
                    }
                }), s.on("DocProgress", (u) => {
                  this.destroyed || c.onProgress?.({
                    loaded: u.loaded,
                    total: u.total
                  });
                }), s.on("FetchBuiltInCMap", (u) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.cMapReaderFactory ? this.cMapReaderFactory.fetch(u) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), s.on("FetchStandardFontData", (u) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.standardFontDataFactory ? this.standardFontDataFactory.fetch(u) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
              }
              getData() {
                return this.messageHandler.sendWithPromise("GetData", null);
              }
              saveDocument() {
                this.annotationStorage.size <= 0 && (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                const {
                  map: s,
                  transfers: c
                } = this.annotationStorage.serializable;
                return this.messageHandler.sendWithPromise("SaveDocument", {
                  isPureXfa: !!this._htmlForXfa,
                  numPages: this._numPages,
                  annotationStorage: s,
                  filename: this._fullReader?.filename ?? null
                }, c).finally(() => {
                  this.annotationStorage.resetModified();
                });
              }
              getPage(s) {
                if (!Number.isInteger(s) || s <= 0 || s > this._numPages)
                  return Promise.reject(new Error("Invalid page request."));
                const c = s - 1, u = this.#r.get(c);
                if (u)
                  return u;
                const d = this.messageHandler.sendWithPromise("GetPage", {
                  pageIndex: c
                }).then((p) => {
                  if (this.destroyed)
                    throw new Error("Transport destroyed");
                  const v = new PDFPageProxy(c, p, this, this._params.pdfBug);
                  return this.#t.set(c, v), v;
                });
                return this.#r.set(c, d), d;
              }
              getPageIndex(s) {
                return typeof s != "object" || s === null || !Number.isInteger(s.num) || s.num < 0 || !Number.isInteger(s.gen) || s.gen < 0 ? Promise.reject(new Error("Invalid pageIndex request.")) : this.messageHandler.sendWithPromise("GetPageIndex", {
                  num: s.num,
                  gen: s.gen
                });
              }
              getAnnotations(s, c) {
                return this.messageHandler.sendWithPromise("GetAnnotations", {
                  pageIndex: s,
                  intent: c
                });
              }
              getFieldObjects() {
                return this.#s("GetFieldObjects");
              }
              hasJSActions() {
                return this.#s("HasJSActions");
              }
              getCalculationOrderIds() {
                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
              }
              getDestinations() {
                return this.messageHandler.sendWithPromise("GetDestinations", null);
              }
              getDestination(s) {
                return typeof s != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                  id: s
                });
              }
              getPageLabels() {
                return this.messageHandler.sendWithPromise("GetPageLabels", null);
              }
              getPageLayout() {
                return this.messageHandler.sendWithPromise("GetPageLayout", null);
              }
              getPageMode() {
                return this.messageHandler.sendWithPromise("GetPageMode", null);
              }
              getViewerPreferences() {
                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
              }
              getOpenAction() {
                return this.messageHandler.sendWithPromise("GetOpenAction", null);
              }
              getAttachments() {
                return this.messageHandler.sendWithPromise("GetAttachments", null);
              }
              getDocJSActions() {
                return this.#s("GetDocJSActions");
              }
              getPageJSActions(s) {
                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                  pageIndex: s
                });
              }
              getStructTree(s) {
                return this.messageHandler.sendWithPromise("GetStructTree", {
                  pageIndex: s
                });
              }
              getOutline() {
                return this.messageHandler.sendWithPromise("GetOutline", null);
              }
              getOptionalContentConfig() {
                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((s) => new _optional_content_config.OptionalContentConfig(s));
              }
              getPermissions() {
                return this.messageHandler.sendWithPromise("GetPermissions", null);
              }
              getMetadata() {
                const s = "GetMetadata", c = this.#e.get(s);
                if (c)
                  return c;
                const u = this.messageHandler.sendWithPromise(s, null).then((d) => ({
                  info: d[0],
                  metadata: d[1] ? new _metadata.Metadata(d[1]) : null,
                  contentDispositionFilename: this._fullReader?.filename ?? null,
                  contentLength: this._fullReader?.contentLength ?? null
                }));
                return this.#e.set(s, u), u;
              }
              getMarkInfo() {
                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
              }
              async startCleanup(s = !1) {
                if (!this.destroyed) {
                  await this.messageHandler.sendWithPromise("Cleanup", null);
                  for (const c of this.#t.values())
                    if (!c.cleanup())
                      throw new Error(`startCleanup: Page ${c.pageNumber} is currently rendering.`);
                  this.commonObjs.clear(), s || this.fontLoader.clear(), this.#e.clear(), this.filterFactory.destroy(!0);
                }
              }
              get loadingParams() {
                const {
                  disableAutoFetch: s,
                  enableXfa: c
                } = this._params;
                return (0, _util.shadow)(this, "loadingParams", {
                  disableAutoFetch: s,
                  enableXfa: c
                });
              }
            }
            class PDFObjects {
              #e = /* @__PURE__ */ Object.create(null);
              #t(s) {
                return this.#e[s] ||= {
                  capability: new _util.PromiseCapability(),
                  data: null
                };
              }
              get(s, c = null) {
                if (c) {
                  const d = this.#t(s);
                  return d.capability.promise.then(() => c(d.data)), null;
                }
                const u = this.#e[s];
                if (!u?.capability.settled)
                  throw new Error(`Requesting object that isn't resolved yet ${s}.`);
                return u.data;
              }
              has(s) {
                return this.#e[s]?.capability.settled || !1;
              }
              resolve(s, c = null) {
                const u = this.#t(s);
                u.data = c, u.capability.resolve();
              }
              clear() {
                for (const s in this.#e) {
                  const {
                    data: c
                  } = this.#e[s];
                  c?.bitmap?.close();
                }
                this.#e = /* @__PURE__ */ Object.create(null);
              }
            }
            class RenderTask {
              #e = null;
              constructor(s) {
                this.#e = s, this.onContinue = null;
              }
              get promise() {
                return this.#e.capability.promise;
              }
              cancel(s = 0) {
                this.#e.cancel(null, s);
              }
              get separateAnnots() {
                const {
                  separateAnnots: s
                } = this.#e.operatorList;
                if (!s)
                  return !1;
                const {
                  annotationCanvasMap: c
                } = this.#e;
                return s.form || s.canvas && c?.size > 0;
              }
            }
            exports.RenderTask = RenderTask;
            class InternalRenderTask {
              static #e = /* @__PURE__ */ new WeakSet();
              constructor({
                callback: s,
                params: c,
                objs: u,
                commonObjs: d,
                annotationCanvasMap: p,
                operatorList: v,
                pageIndex: A,
                canvasFactory: x,
                filterFactory: g,
                useRequestAnimationFrame: b = !1,
                pdfBug: y = !1,
                pageColors: f = null
              }) {
                this.callback = s, this.params = c, this.objs = u, this.commonObjs = d, this.annotationCanvasMap = p, this.operatorListIdx = null, this.operatorList = v, this._pageIndex = A, this.canvasFactory = x, this.filterFactory = g, this._pdfBug = y, this.pageColors = f, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = b === !0 && typeof window < "u", this.cancelled = !1, this.capability = new _util.PromiseCapability(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = c.canvasContext.canvas;
              }
              get completed() {
                return this.capability.promise.catch(function() {
                });
              }
              initializeGraphics({
                transparency: s = !1,
                optionalContentConfig: c
              }) {
                if (this.cancelled)
                  return;
                if (this._canvas) {
                  if (InternalRenderTask.#e.has(this._canvas))
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  InternalRenderTask.#e.add(this._canvas);
                }
                this._pdfBug && globalThis.StepperManager?.enabled && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
                const {
                  canvasContext: u,
                  viewport: d,
                  transform: p,
                  background: v
                } = this.params;
                this.gfx = new _canvas.CanvasGraphics(u, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                  optionalContentConfig: c
                }, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
                  transform: p,
                  viewport: d,
                  transparency: s,
                  background: v
                }), this.operatorListIdx = 0, this.graphicsReady = !0, this.graphicsReadyCallback?.();
              }
              cancel(s = null, c = 0) {
                this.running = !1, this.cancelled = !0, this.gfx?.endDrawing(), InternalRenderTask.#e.delete(this._canvas), this.callback(s || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, c));
              }
              operatorListChanged() {
                if (!this.graphicsReady) {
                  this.graphicsReadyCallback ||= this._continueBound;
                  return;
                }
                this.stepper?.updateOperatorList(this.operatorList), !this.running && this._continue();
              }
              _continue() {
                this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
              }
              _scheduleNext() {
                this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                  this._nextBound().catch(this._cancelBound);
                }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
              }
              async _next() {
                this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), InternalRenderTask.#e.delete(this._canvas), this.callback())));
              }
            }
            const version = "3.11.174";
            exports.version = version;
            const build = "ce8716743";
            exports.build = build;
          },
          /* 3 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.SerializableEmpty = s.PrintAnnotationStorage = s.AnnotationStorage = void 0;
            var u = c(1), d = c(4), p = c(8);
            const v = Object.freeze({
              map: null,
              hash: "",
              transfers: void 0
            });
            s.SerializableEmpty = v;
            class A {
              #e = !1;
              #t = /* @__PURE__ */ new Map();
              constructor() {
                this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
              }
              getValue(b, y) {
                const f = this.#t.get(b);
                return f === void 0 ? y : Object.assign(y, f);
              }
              getRawValue(b) {
                return this.#t.get(b);
              }
              remove(b) {
                if (this.#t.delete(b), this.#t.size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
                  for (const y of this.#t.values())
                    if (y instanceof d.AnnotationEditor)
                      return;
                  this.onAnnotationEditor(null);
                }
              }
              setValue(b, y) {
                const f = this.#t.get(b);
                let m = !1;
                if (f !== void 0)
                  for (const [C, w] of Object.entries(y))
                    f[C] !== w && (m = !0, f[C] = w);
                else
                  m = !0, this.#t.set(b, y);
                m && this.#r(), y instanceof d.AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(y.constructor._type);
              }
              has(b) {
                return this.#t.has(b);
              }
              getAll() {
                return this.#t.size > 0 ? (0, u.objectFromMap)(this.#t) : null;
              }
              setAll(b) {
                for (const [y, f] of Object.entries(b))
                  this.setValue(y, f);
              }
              get size() {
                return this.#t.size;
              }
              #r() {
                this.#e || (this.#e = !0, typeof this.onSetModified == "function" && this.onSetModified());
              }
              resetModified() {
                this.#e && (this.#e = !1, typeof this.onResetModified == "function" && this.onResetModified());
              }
              get print() {
                return new x(this);
              }
              get serializable() {
                if (this.#t.size === 0)
                  return v;
                const b = /* @__PURE__ */ new Map(), y = new p.MurmurHash3_64(), f = [], m = /* @__PURE__ */ Object.create(null);
                let C = !1;
                for (const [w, S] of this.#t) {
                  const $ = S instanceof d.AnnotationEditor ? S.serialize(!1, m) : S;
                  $ && (b.set(w, $), y.update(`${w}:${JSON.stringify($)}`), C ||= !!$.bitmap);
                }
                if (C)
                  for (const w of b.values())
                    w.bitmap && f.push(w.bitmap);
                return b.size > 0 ? {
                  map: b,
                  hash: y.hexdigest(),
                  transfers: f
                } : v;
              }
            }
            s.AnnotationStorage = A;
            class x extends A {
              #e;
              constructor(b) {
                super();
                const {
                  map: y,
                  hash: f,
                  transfers: m
                } = b.serializable, C = structuredClone(y, m ? {
                  transfer: m
                } : null);
                this.#e = {
                  map: C,
                  hash: f,
                  transfers: m
                };
              }
              get print() {
                (0, u.unreachable)("Should not call PrintAnnotationStorage.print");
              }
              get serializable() {
                return this.#e;
              }
            }
            s.PrintAnnotationStorage = x;
          },
          /* 4 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.AnnotationEditor = void 0;
            var u = c(5), d = c(1), p = c(6);
            class v {
              #e = "";
              #t = !1;
              #r = null;
              #n = null;
              #s = null;
              #o = !1;
              #i = null;
              #l = this.focusin.bind(this);
              #c = this.focusout.bind(this);
              #a = !1;
              #p = !1;
              #d = !1;
              _initialOptions = /* @__PURE__ */ Object.create(null);
              _uiManager = null;
              _focusEventsAllowed = !0;
              _l10nPromise = null;
              #f = !1;
              #h = v._zIndex++;
              static _borderLineWidth = -1;
              static _colorManager = new u.ColorManager();
              static _zIndex = 1;
              static SMALL_EDITOR_SIZE = 0;
              constructor(g) {
                this.constructor === v && (0, d.unreachable)("Cannot initialize AnnotationEditor."), this.parent = g.parent, this.id = g.id, this.width = this.height = null, this.pageIndex = g.parent.pageIndex, this.name = g.name, this.div = null, this._uiManager = g.uiManager, this.annotationElementId = null, this._willKeepAspectRatio = !1, this._initialOptions.isCentered = g.isCentered, this._structTreeParentId = null;
                const {
                  rotation: b,
                  rawDims: {
                    pageWidth: y,
                    pageHeight: f,
                    pageX: m,
                    pageY: C
                  }
                } = this.parent.viewport;
                this.rotation = b, this.pageRotation = (360 + b - this._uiManager.viewParameters.rotation) % 360, this.pageDimensions = [y, f], this.pageTranslation = [m, C];
                const [w, S] = this.parentDimensions;
                this.x = g.x / w, this.y = g.y / S, this.isAttachedToDOM = !1, this.deleted = !1;
              }
              get editorType() {
                return Object.getPrototypeOf(this).constructor._type;
              }
              static get _defaultLineColor() {
                return (0, d.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
              }
              static deleteAnnotationElement(g) {
                const b = new A({
                  id: g.parent.getNextId(),
                  parent: g.parent,
                  uiManager: g._uiManager
                });
                b.annotationElementId = g.annotationElementId, b.deleted = !0, b._uiManager.addToAnnotationStorage(b);
              }
              static initialize(g, b = null) {
                if (v._l10nPromise ||= new Map(["editor_alt_text_button_label", "editor_alt_text_edit_button_label", "editor_alt_text_decorative_tooltip"].map((f) => [f, g.get(f)])), b?.strings)
                  for (const f of b.strings)
                    v._l10nPromise.set(f, g.get(f));
                if (v._borderLineWidth !== -1)
                  return;
                const y = getComputedStyle(document.documentElement);
                v._borderLineWidth = parseFloat(y.getPropertyValue("--outline-width")) || 0;
              }
              static updateDefaultParams(g, b) {
              }
              static get defaultPropertiesToUpdate() {
                return [];
              }
              static isHandlingMimeForPasting(g) {
                return !1;
              }
              static paste(g, b) {
                (0, d.unreachable)("Not implemented");
              }
              get propertiesToUpdate() {
                return [];
              }
              get _isDraggable() {
                return this.#f;
              }
              set _isDraggable(g) {
                this.#f = g, this.div?.classList.toggle("draggable", g);
              }
              center() {
                const [g, b] = this.pageDimensions;
                switch (this.parentRotation) {
                  case 90:
                    this.x -= this.height * b / (g * 2), this.y += this.width * g / (b * 2);
                    break;
                  case 180:
                    this.x += this.width / 2, this.y += this.height / 2;
                    break;
                  case 270:
                    this.x += this.height * b / (g * 2), this.y -= this.width * g / (b * 2);
                    break;
                  default:
                    this.x -= this.width / 2, this.y -= this.height / 2;
                    break;
                }
                this.fixAndSetPosition();
              }
              addCommands(g) {
                this._uiManager.addCommands(g);
              }
              get currentLayer() {
                return this._uiManager.currentLayer;
              }
              setInBackground() {
                this.div.style.zIndex = 0;
              }
              setInForeground() {
                this.div.style.zIndex = this.#h;
              }
              setParent(g) {
                g !== null && (this.pageIndex = g.pageIndex, this.pageDimensions = g.pageDimensions), this.parent = g;
              }
              focusin(g) {
                this._focusEventsAllowed && (this.#a ? this.#a = !1 : this.parent.setSelected(this));
              }
              focusout(g) {
                !this._focusEventsAllowed || !this.isAttachedToDOM || g.relatedTarget?.closest(`#${this.id}`) || (g.preventDefault(), this.parent?.isMultipleSelection || this.commitOrRemove());
              }
              commitOrRemove() {
                this.isEmpty() ? this.remove() : this.commit();
              }
              commit() {
                this.addToAnnotationStorage();
              }
              addToAnnotationStorage() {
                this._uiManager.addToAnnotationStorage(this);
              }
              setAt(g, b, y, f) {
                const [m, C] = this.parentDimensions;
                [y, f] = this.screenToPageTranslation(y, f), this.x = (g + y) / m, this.y = (b + f) / C, this.fixAndSetPosition();
              }
              #A([g, b], y, f) {
                [y, f] = this.screenToPageTranslation(y, f), this.x += y / g, this.y += f / b, this.fixAndSetPosition();
              }
              translate(g, b) {
                this.#A(this.parentDimensions, g, b);
              }
              translateInPage(g, b) {
                this.#A(this.pageDimensions, g, b), this.div.scrollIntoView({
                  block: "nearest"
                });
              }
              drag(g, b) {
                const [y, f] = this.parentDimensions;
                if (this.x += g / y, this.y += b / f, this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                  const {
                    x: $,
                    y: T
                  } = this.div.getBoundingClientRect();
                  this.parent.findNewParent(this, $, T) && (this.x -= Math.floor(this.x), this.y -= Math.floor(this.y));
                }
                let {
                  x: m,
                  y: C
                } = this;
                const [w, S] = this.#m();
                m += w, C += S, this.div.style.left = `${(100 * m).toFixed(2)}%`, this.div.style.top = `${(100 * C).toFixed(2)}%`, this.div.scrollIntoView({
                  block: "nearest"
                });
              }
              #m() {
                const [g, b] = this.parentDimensions, {
                  _borderLineWidth: y
                } = v, f = y / g, m = y / b;
                switch (this.rotation) {
                  case 90:
                    return [-f, m];
                  case 180:
                    return [f, m];
                  case 270:
                    return [f, -m];
                  default:
                    return [-f, -m];
                }
              }
              fixAndSetPosition() {
                const [g, b] = this.pageDimensions;
                let {
                  x: y,
                  y: f,
                  width: m,
                  height: C
                } = this;
                switch (m *= g, C *= b, y *= g, f *= b, this.rotation) {
                  case 0:
                    y = Math.max(0, Math.min(g - m, y)), f = Math.max(0, Math.min(b - C, f));
                    break;
                  case 90:
                    y = Math.max(0, Math.min(g - C, y)), f = Math.min(b, Math.max(m, f));
                    break;
                  case 180:
                    y = Math.min(g, Math.max(m, y)), f = Math.min(b, Math.max(C, f));
                    break;
                  case 270:
                    y = Math.min(g, Math.max(C, y)), f = Math.max(0, Math.min(b - m, f));
                    break;
                }
                this.x = y /= g, this.y = f /= b;
                const [w, S] = this.#m();
                y += w, f += S;
                const {
                  style: $
                } = this.div;
                $.left = `${(100 * y).toFixed(2)}%`, $.top = `${(100 * f).toFixed(2)}%`, this.moveInDOM();
              }
              static #g(g, b, y) {
                switch (y) {
                  case 90:
                    return [b, -g];
                  case 180:
                    return [-g, -b];
                  case 270:
                    return [-b, g];
                  default:
                    return [g, b];
                }
              }
              screenToPageTranslation(g, b) {
                return v.#g(g, b, this.parentRotation);
              }
              pageTranslationToScreen(g, b) {
                return v.#g(g, b, 360 - this.parentRotation);
              }
              #u(g) {
                switch (g) {
                  case 90: {
                    const [b, y] = this.pageDimensions;
                    return [0, -b / y, y / b, 0];
                  }
                  case 180:
                    return [-1, 0, 0, -1];
                  case 270: {
                    const [b, y] = this.pageDimensions;
                    return [0, b / y, -y / b, 0];
                  }
                  default:
                    return [1, 0, 0, 1];
                }
              }
              get parentScale() {
                return this._uiManager.viewParameters.realScale;
              }
              get parentRotation() {
                return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
              }
              get parentDimensions() {
                const {
                  parentScale: g,
                  pageDimensions: [b, y]
                } = this, f = b * g, m = y * g;
                return d.FeatureTest.isCSSRoundSupported ? [Math.round(f), Math.round(m)] : [f, m];
              }
              setDims(g, b) {
                const [y, f] = this.parentDimensions;
                this.div.style.width = `${(100 * g / y).toFixed(2)}%`, this.#o || (this.div.style.height = `${(100 * b / f).toFixed(2)}%`), this.#r?.classList.toggle("small", g < v.SMALL_EDITOR_SIZE || b < v.SMALL_EDITOR_SIZE);
              }
              fixDims() {
                const {
                  style: g
                } = this.div, {
                  height: b,
                  width: y
                } = g, f = y.endsWith("%"), m = !this.#o && b.endsWith("%");
                if (f && m)
                  return;
                const [C, w] = this.parentDimensions;
                f || (g.width = `${(100 * parseFloat(y) / C).toFixed(2)}%`), !this.#o && !m && (g.height = `${(100 * parseFloat(b) / w).toFixed(2)}%`);
              }
              getInitialTranslation() {
                return [0, 0];
              }
              #v() {
                if (this.#i)
                  return;
                this.#i = document.createElement("div"), this.#i.classList.add("resizers");
                const g = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
                this._willKeepAspectRatio || g.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                for (const b of g) {
                  const y = document.createElement("div");
                  this.#i.append(y), y.classList.add("resizer", b), y.addEventListener("pointerdown", this.#E.bind(this, b)), y.addEventListener("contextmenu", p.noContextMenu);
                }
                this.div.prepend(this.#i);
              }
              #E(g, b) {
                b.preventDefault();
                const {
                  isMac: y
                } = d.FeatureTest.platform;
                if (b.button !== 0 || b.ctrlKey && y)
                  return;
                const f = this.#C.bind(this, g), m = this._isDraggable;
                this._isDraggable = !1;
                const C = {
                  passive: !0,
                  capture: !0
                };
                window.addEventListener("pointermove", f, C);
                const w = this.x, S = this.y, $ = this.width, T = this.height, I = this.parent.div.style.cursor, _ = this.div.style.cursor;
                this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(b.target).cursor;
                const E = () => {
                  this._isDraggable = m, window.removeEventListener("pointerup", E), window.removeEventListener("blur", E), window.removeEventListener("pointermove", f, C), this.parent.div.style.cursor = I, this.div.style.cursor = _;
                  const R = this.x, O = this.y, L = this.width, B = this.height;
                  R === w && O === S && L === $ && B === T || this.addCommands({
                    cmd: () => {
                      this.width = L, this.height = B, this.x = R, this.y = O;
                      const [F, M] = this.parentDimensions;
                      this.setDims(F * L, M * B), this.fixAndSetPosition();
                    },
                    undo: () => {
                      this.width = $, this.height = T, this.x = w, this.y = S;
                      const [F, M] = this.parentDimensions;
                      this.setDims(F * $, M * T), this.fixAndSetPosition();
                    },
                    mustExec: !0
                  });
                };
                window.addEventListener("pointerup", E), window.addEventListener("blur", E);
              }
              #C(g, b) {
                const [y, f] = this.parentDimensions, m = this.x, C = this.y, w = this.width, S = this.height, $ = v.MIN_SIZE / y, T = v.MIN_SIZE / f, I = (q) => Math.round(q * 1e4) / 1e4, _ = this.#u(this.rotation), E = (q, Y) => [_[0] * q + _[2] * Y, _[1] * q + _[3] * Y], R = this.#u(360 - this.rotation), O = (q, Y) => [R[0] * q + R[2] * Y, R[1] * q + R[3] * Y];
                let L, B, F = !1, M = !1;
                switch (g) {
                  case "topLeft":
                    F = !0, L = (q, Y) => [0, 0], B = (q, Y) => [q, Y];
                    break;
                  case "topMiddle":
                    L = (q, Y) => [q / 2, 0], B = (q, Y) => [q / 2, Y];
                    break;
                  case "topRight":
                    F = !0, L = (q, Y) => [q, 0], B = (q, Y) => [0, Y];
                    break;
                  case "middleRight":
                    M = !0, L = (q, Y) => [q, Y / 2], B = (q, Y) => [0, Y / 2];
                    break;
                  case "bottomRight":
                    F = !0, L = (q, Y) => [q, Y], B = (q, Y) => [0, 0];
                    break;
                  case "bottomMiddle":
                    L = (q, Y) => [q / 2, Y], B = (q, Y) => [q / 2, 0];
                    break;
                  case "bottomLeft":
                    F = !0, L = (q, Y) => [0, Y], B = (q, Y) => [q, 0];
                    break;
                  case "middleLeft":
                    M = !0, L = (q, Y) => [0, Y / 2], B = (q, Y) => [q, Y / 2];
                    break;
                }
                const W = L(w, S), j = B(w, S);
                let G = E(...j);
                const U = I(m + G[0]), k = I(C + G[1]);
                let N = 1, P = 1, [D, H] = this.screenToPageTranslation(b.movementX, b.movementY);
                if ([D, H] = O(D / y, H / f), F) {
                  const q = Math.hypot(w, S);
                  N = P = Math.max(Math.min(Math.hypot(j[0] - W[0] - D, j[1] - W[1] - H) / q, 1 / w, 1 / S), $ / w, T / S);
                } else M ? N = Math.max($, Math.min(1, Math.abs(j[0] - W[0] - D))) / w : P = Math.max(T, Math.min(1, Math.abs(j[1] - W[1] - H))) / S;
                const V = I(w * N), Z = I(S * P);
                G = E(...B(V, Z));
                const ne = U - G[0], K = k - G[1];
                this.width = V, this.height = Z, this.x = ne, this.y = K, this.setDims(y * V, f * Z), this.fixAndSetPosition();
              }
              async addAltTextButton() {
                if (this.#r)
                  return;
                const g = this.#r = document.createElement("button");
                g.className = "altText";
                const b = await v._l10nPromise.get("editor_alt_text_button_label");
                g.textContent = b, g.setAttribute("aria-label", b), g.tabIndex = "0", g.addEventListener("contextmenu", p.noContextMenu), g.addEventListener("pointerdown", (y) => y.stopPropagation()), g.addEventListener("click", (y) => {
                  y.preventDefault(), this._uiManager.editAltText(this);
                }, {
                  capture: !0
                }), g.addEventListener("keydown", (y) => {
                  y.target === g && y.key === "Enter" && (y.preventDefault(), this._uiManager.editAltText(this));
                }), this.#$(), this.div.append(g), v.SMALL_EDITOR_SIZE || (v.SMALL_EDITOR_SIZE = Math.min(128, Math.round(g.getBoundingClientRect().width * 1.4)));
              }
              async #$() {
                const g = this.#r;
                if (!g)
                  return;
                if (!this.#e && !this.#t) {
                  g.classList.remove("done"), this.#n?.remove();
                  return;
                }
                v._l10nPromise.get("editor_alt_text_edit_button_label").then((y) => {
                  g.setAttribute("aria-label", y);
                });
                let b = this.#n;
                if (!b) {
                  this.#n = b = document.createElement("span"), b.className = "tooltip", b.setAttribute("role", "tooltip");
                  const y = b.id = `alt-text-tooltip-${this.id}`;
                  g.setAttribute("aria-describedby", y);
                  const f = 100;
                  g.addEventListener("mouseenter", () => {
                    this.#s = setTimeout(() => {
                      this.#s = null, this.#n.classList.add("show"), this._uiManager._eventBus.dispatch("reporttelemetry", {
                        source: this,
                        details: {
                          type: "editing",
                          subtype: this.editorType,
                          data: {
                            action: "alt_text_tooltip"
                          }
                        }
                      });
                    }, f);
                  }), g.addEventListener("mouseleave", () => {
                    clearTimeout(this.#s), this.#s = null, this.#n?.classList.remove("show");
                  });
                }
                g.classList.add("done"), b.innerText = this.#t ? await v._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#e, b.parentNode || g.append(b);
              }
              getClientDimensions() {
                return this.div.getBoundingClientRect();
              }
              get altTextData() {
                return {
                  altText: this.#e,
                  decorative: this.#t
                };
              }
              set altTextData({
                altText: g,
                decorative: b
              }) {
                this.#e === g && this.#t === b || (this.#e = g, this.#t = b, this.#$());
              }
              render() {
                this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.setAttribute("tabIndex", 0), this.setInForeground(), this.div.addEventListener("focusin", this.#l), this.div.addEventListener("focusout", this.#c);
                const [g, b] = this.parentDimensions;
                this.parentRotation % 180 !== 0 && (this.div.style.maxWidth = `${(100 * b / g).toFixed(2)}%`, this.div.style.maxHeight = `${(100 * g / b).toFixed(2)}%`);
                const [y, f] = this.getInitialTranslation();
                return this.translate(y, f), (0, u.bindEvents)(this, this.div, ["pointerdown"]), this.div;
              }
              pointerdown(g) {
                const {
                  isMac: b
                } = d.FeatureTest.platform;
                if (g.button !== 0 || g.ctrlKey && b) {
                  g.preventDefault();
                  return;
                }
                this.#a = !0, this.#_(g);
              }
              #_(g) {
                if (!this._isDraggable)
                  return;
                const b = this._uiManager.isSelected(this);
                this._uiManager.setUpDragSession();
                let y, f;
                b && (y = {
                  passive: !0,
                  capture: !0
                }, f = (C) => {
                  const [w, S] = this.screenToPageTranslation(C.movementX, C.movementY);
                  this._uiManager.dragSelectedEditors(w, S);
                }, window.addEventListener("pointermove", f, y));
                const m = () => {
                  if (window.removeEventListener("pointerup", m), window.removeEventListener("blur", m), b && window.removeEventListener("pointermove", f, y), this.#a = !1, !this._uiManager.endDragSession()) {
                    const {
                      isMac: C
                    } = d.FeatureTest.platform;
                    g.ctrlKey && !C || g.shiftKey || g.metaKey && C ? this.parent.toggleSelected(this) : this.parent.setSelected(this);
                  }
                };
                window.addEventListener("pointerup", m), window.addEventListener("blur", m);
              }
              moveInDOM() {
                this.parent?.moveEditorInDOM(this);
              }
              _setParentAndPosition(g, b, y) {
                g.changeParent(this), this.x = b, this.y = y, this.fixAndSetPosition();
              }
              getRect(g, b) {
                const y = this.parentScale, [f, m] = this.pageDimensions, [C, w] = this.pageTranslation, S = g / y, $ = b / y, T = this.x * f, I = this.y * m, _ = this.width * f, E = this.height * m;
                switch (this.rotation) {
                  case 0:
                    return [T + S + C, m - I - $ - E + w, T + S + _ + C, m - I - $ + w];
                  case 90:
                    return [T + $ + C, m - I + S + w, T + $ + E + C, m - I + S + _ + w];
                  case 180:
                    return [T - S - _ + C, m - I + $ + w, T - S + C, m - I + $ + E + w];
                  case 270:
                    return [T - $ - E + C, m - I - S - _ + w, T - $ + C, m - I - S + w];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              getRectInCurrentCoords(g, b) {
                const [y, f, m, C] = g, w = m - y, S = C - f;
                switch (this.rotation) {
                  case 0:
                    return [y, b - C, w, S];
                  case 90:
                    return [y, b - f, S, w];
                  case 180:
                    return [m, b - f, w, S];
                  case 270:
                    return [m, b - C, S, w];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              onceAdded() {
              }
              isEmpty() {
                return !1;
              }
              enableEditMode() {
                this.#d = !0;
              }
              disableEditMode() {
                this.#d = !1;
              }
              isInEditMode() {
                return this.#d;
              }
              shouldGetKeyboardEvents() {
                return !1;
              }
              needsToBeRebuilt() {
                return this.div && !this.isAttachedToDOM;
              }
              rebuild() {
                this.div?.addEventListener("focusin", this.#l), this.div?.addEventListener("focusout", this.#c);
              }
              serialize(g = !1, b = null) {
                (0, d.unreachable)("An editor must be serializable");
              }
              static deserialize(g, b, y) {
                const f = new this.prototype.constructor({
                  parent: b,
                  id: b.getNextId(),
                  uiManager: y
                });
                f.rotation = g.rotation;
                const [m, C] = f.pageDimensions, [w, S, $, T] = f.getRectInCurrentCoords(g.rect, C);
                return f.x = w / m, f.y = S / C, f.width = $ / m, f.height = T / C, f;
              }
              remove() {
                this.div.removeEventListener("focusin", this.#l), this.div.removeEventListener("focusout", this.#c), this.isEmpty() || this.commit(), this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this), this.#r?.remove(), this.#r = null, this.#n = null;
              }
              get isResizable() {
                return !1;
              }
              makeResizable() {
                this.isResizable && (this.#v(), this.#i.classList.remove("hidden"));
              }
              select() {
                this.makeResizable(), this.div?.classList.add("selectedEditor");
              }
              unselect() {
                this.#i?.classList.add("hidden"), this.div?.classList.remove("selectedEditor"), this.div?.contains(document.activeElement) && this._uiManager.currentLayer.div.focus();
              }
              updateParams(g, b) {
              }
              disableEditing() {
                this.#r && (this.#r.hidden = !0);
              }
              enableEditing() {
                this.#r && (this.#r.hidden = !1);
              }
              enterInEditMode() {
              }
              get contentDiv() {
                return this.div;
              }
              get isEditing() {
                return this.#p;
              }
              set isEditing(g) {
                this.#p = g, this.parent && (g ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null));
              }
              setAspectRatio(g, b) {
                this.#o = !0;
                const y = g / b, {
                  style: f
                } = this.div;
                f.aspectRatio = y, f.height = "auto";
              }
              static get MIN_SIZE() {
                return 16;
              }
            }
            s.AnnotationEditor = v;
            class A extends v {
              constructor(g) {
                super(g), this.annotationElementId = g.annotationElementId, this.deleted = !0;
              }
              serialize() {
                return {
                  id: this.annotationElementId,
                  deleted: !0,
                  pageIndex: this.pageIndex
                };
              }
            }
          },
          /* 5 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.KeyboardManager = s.CommandManager = s.ColorManager = s.AnnotationEditorUIManager = void 0, s.bindEvents = p, s.opacityToHex = v;
            var u = c(1), d = c(6);
            function p(m, C, w) {
              for (const S of w)
                C.addEventListener(S, m[S].bind(m));
            }
            function v(m) {
              return Math.round(Math.min(255, Math.max(1, 255 * m))).toString(16).padStart(2, "0");
            }
            class A {
              #e = 0;
              getId() {
                return `${u.AnnotationEditorPrefix}${this.#e++}`;
              }
            }
            class x {
              #e = (0, u.getUuid)();
              #t = 0;
              #r = null;
              static get _isSVGFittingCanvas() {
                const C = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>', S = new OffscreenCanvas(1, 3).getContext("2d"), $ = new Image();
                $.src = C;
                const T = $.decode().then(() => (S.drawImage($, 0, 0, 1, 1, 0, 0, 1, 3), new Uint32Array(S.getImageData(0, 0, 1, 1).data.buffer)[0] === 0));
                return (0, u.shadow)(this, "_isSVGFittingCanvas", T);
              }
              async #n(C, w) {
                this.#r ||= /* @__PURE__ */ new Map();
                let S = this.#r.get(C);
                if (S === null)
                  return null;
                if (S?.bitmap)
                  return S.refCounter += 1, S;
                try {
                  S ||= {
                    bitmap: null,
                    id: `image_${this.#e}_${this.#t++}`,
                    refCounter: 0,
                    isSvg: !1
                  };
                  let $;
                  if (typeof w == "string") {
                    S.url = w;
                    const T = await fetch(w);
                    if (!T.ok)
                      throw new Error(T.statusText);
                    $ = await T.blob();
                  } else
                    $ = S.file = w;
                  if ($.type === "image/svg+xml") {
                    const T = x._isSVGFittingCanvas, I = new FileReader(), _ = new Image(), E = new Promise((R, O) => {
                      _.onload = () => {
                        S.bitmap = _, S.isSvg = !0, R();
                      }, I.onload = async () => {
                        const L = S.svgUrl = I.result;
                        _.src = await T ? `${L}#svgView(preserveAspectRatio(none))` : L;
                      }, _.onerror = I.onerror = O;
                    });
                    I.readAsDataURL($), await E;
                  } else
                    S.bitmap = await createImageBitmap($);
                  S.refCounter = 1;
                } catch ($) {
                  console.error($), S = null;
                }
                return this.#r.set(C, S), S && this.#r.set(S.id, S), S;
              }
              async getFromFile(C) {
                const {
                  lastModified: w,
                  name: S,
                  size: $,
                  type: T
                } = C;
                return this.#n(`${w}_${S}_${$}_${T}`, C);
              }
              async getFromUrl(C) {
                return this.#n(C, C);
              }
              async getFromId(C) {
                this.#r ||= /* @__PURE__ */ new Map();
                const w = this.#r.get(C);
                return w ? w.bitmap ? (w.refCounter += 1, w) : w.file ? this.getFromFile(w.file) : this.getFromUrl(w.url) : null;
              }
              getSvgUrl(C) {
                const w = this.#r.get(C);
                return w?.isSvg ? w.svgUrl : null;
              }
              deleteId(C) {
                this.#r ||= /* @__PURE__ */ new Map();
                const w = this.#r.get(C);
                w && (w.refCounter -= 1, w.refCounter === 0 && (w.bitmap = null));
              }
              isValidId(C) {
                return C.startsWith(`image_${this.#e}_`);
              }
            }
            class g {
              #e = [];
              #t = !1;
              #r;
              #n = -1;
              constructor(C = 128) {
                this.#r = C;
              }
              add({
                cmd: C,
                undo: w,
                mustExec: S,
                type: $ = NaN,
                overwriteIfSameType: T = !1,
                keepUndo: I = !1
              }) {
                if (S && C(), this.#t)
                  return;
                const _ = {
                  cmd: C,
                  undo: w,
                  type: $
                };
                if (this.#n === -1) {
                  this.#e.length > 0 && (this.#e.length = 0), this.#n = 0, this.#e.push(_);
                  return;
                }
                if (T && this.#e[this.#n].type === $) {
                  I && (_.undo = this.#e[this.#n].undo), this.#e[this.#n] = _;
                  return;
                }
                const E = this.#n + 1;
                E === this.#r ? this.#e.splice(0, 1) : (this.#n = E, E < this.#e.length && this.#e.splice(E)), this.#e.push(_);
              }
              undo() {
                this.#n !== -1 && (this.#t = !0, this.#e[this.#n].undo(), this.#t = !1, this.#n -= 1);
              }
              redo() {
                this.#n < this.#e.length - 1 && (this.#n += 1, this.#t = !0, this.#e[this.#n].cmd(), this.#t = !1);
              }
              hasSomethingToUndo() {
                return this.#n !== -1;
              }
              hasSomethingToRedo() {
                return this.#n < this.#e.length - 1;
              }
              destroy() {
                this.#e = null;
              }
            }
            s.CommandManager = g;
            class b {
              constructor(C) {
                this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
                const {
                  isMac: w
                } = u.FeatureTest.platform;
                for (const [S, $, T = {}] of C)
                  for (const I of S) {
                    const _ = I.startsWith("mac+");
                    w && _ ? (this.callbacks.set(I.slice(4), {
                      callback: $,
                      options: T
                    }), this.allKeys.add(I.split("+").at(-1))) : !w && !_ && (this.callbacks.set(I, {
                      callback: $,
                      options: T
                    }), this.allKeys.add(I.split("+").at(-1)));
                  }
              }
              #e(C) {
                C.altKey && this.buffer.push("alt"), C.ctrlKey && this.buffer.push("ctrl"), C.metaKey && this.buffer.push("meta"), C.shiftKey && this.buffer.push("shift"), this.buffer.push(C.key);
                const w = this.buffer.join("+");
                return this.buffer.length = 0, w;
              }
              exec(C, w) {
                if (!this.allKeys.has(w.key))
                  return;
                const S = this.callbacks.get(this.#e(w));
                if (!S)
                  return;
                const {
                  callback: $,
                  options: {
                    bubbles: T = !1,
                    args: I = [],
                    checker: _ = null
                  }
                } = S;
                _ && !_(C, w) || ($.bind(C, ...I)(), T || (w.stopPropagation(), w.preventDefault()));
              }
            }
            s.KeyboardManager = b;
            class y {
              static _colorsMapping = /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]);
              get _colors() {
                const C = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
                return (0, d.getColorValues)(C), (0, u.shadow)(this, "_colors", C);
              }
              convert(C) {
                const w = (0, d.getRGB)(C);
                if (!window.matchMedia("(forced-colors: active)").matches)
                  return w;
                for (const [S, $] of this._colors)
                  if ($.every((T, I) => T === w[I]))
                    return y._colorsMapping.get(S);
                return w;
              }
              getHexCode(C) {
                const w = this._colors.get(C);
                return w ? u.Util.makeHexColor(...w) : C;
              }
            }
            s.ColorManager = y;
            class f {
              #e = null;
              #t = /* @__PURE__ */ new Map();
              #r = /* @__PURE__ */ new Map();
              #n = null;
              #s = null;
              #o = new g();
              #i = 0;
              #l = /* @__PURE__ */ new Set();
              #c = null;
              #a = null;
              #p = /* @__PURE__ */ new Set();
              #d = null;
              #f = new A();
              #h = !1;
              #A = !1;
              #m = null;
              #g = u.AnnotationEditorType.NONE;
              #u = /* @__PURE__ */ new Set();
              #v = null;
              #E = this.blur.bind(this);
              #C = this.focus.bind(this);
              #$ = this.copy.bind(this);
              #_ = this.cut.bind(this);
              #M = this.paste.bind(this);
              #k = this.keydown.bind(this);
              #D = this.onEditingAction.bind(this);
              #b = this.onPageChanging.bind(this);
              #O = this.onScaleChanging.bind(this);
              #T = this.onRotationChanging.bind(this);
              #R = {
                isEditing: !1,
                isEmpty: !0,
                hasSomethingToUndo: !1,
                hasSomethingToRedo: !1,
                hasSelectedEditor: !1
              };
              #x = [0, 0];
              #I = null;
              #w = null;
              #F = null;
              static TRANSLATE_SMALL = 1;
              static TRANSLATE_BIG = 10;
              static get _keyboardManager() {
                const C = f.prototype, w = (T) => {
                  const {
                    activeElement: I
                  } = document;
                  return I && T.#w.contains(I) && T.hasSomethingToControl();
                }, S = this.TRANSLATE_SMALL, $ = this.TRANSLATE_BIG;
                return (0, u.shadow)(this, "_keyboardManager", new b([[["ctrl+a", "mac+meta+a"], C.selectAll], [["ctrl+z", "mac+meta+z"], C.undo], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], C.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], C.delete], [["Escape", "mac+Escape"], C.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], C.translateSelectedEditors, {
                  args: [-S, 0],
                  checker: w
                }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], C.translateSelectedEditors, {
                  args: [-$, 0],
                  checker: w
                }], [["ArrowRight", "mac+ArrowRight"], C.translateSelectedEditors, {
                  args: [S, 0],
                  checker: w
                }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], C.translateSelectedEditors, {
                  args: [$, 0],
                  checker: w
                }], [["ArrowUp", "mac+ArrowUp"], C.translateSelectedEditors, {
                  args: [0, -S],
                  checker: w
                }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], C.translateSelectedEditors, {
                  args: [0, -$],
                  checker: w
                }], [["ArrowDown", "mac+ArrowDown"], C.translateSelectedEditors, {
                  args: [0, S],
                  checker: w
                }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], C.translateSelectedEditors, {
                  args: [0, $],
                  checker: w
                }]]));
              }
              constructor(C, w, S, $, T, I) {
                this.#w = C, this.#F = w, this.#n = S, this._eventBus = $, this._eventBus._on("editingaction", this.#D), this._eventBus._on("pagechanging", this.#b), this._eventBus._on("scalechanging", this.#O), this._eventBus._on("rotationchanging", this.#T), this.#s = T.annotationStorage, this.#d = T.filterFactory, this.#v = I, this.viewParameters = {
                  realScale: d.PixelsPerInch.PDF_TO_CSS_UNITS,
                  rotation: 0
                };
              }
              destroy() {
                this.#P(), this.#N(), this._eventBus._off("editingaction", this.#D), this._eventBus._off("pagechanging", this.#b), this._eventBus._off("scalechanging", this.#O), this._eventBus._off("rotationchanging", this.#T);
                for (const C of this.#r.values())
                  C.destroy();
                this.#r.clear(), this.#t.clear(), this.#p.clear(), this.#e = null, this.#u.clear(), this.#o.destroy(), this.#n.destroy();
              }
              get hcmFilter() {
                return (0, u.shadow)(this, "hcmFilter", this.#v ? this.#d.addHCMFilter(this.#v.foreground, this.#v.background) : "none");
              }
              get direction() {
                return (0, u.shadow)(this, "direction", getComputedStyle(this.#w).direction);
              }
              editAltText(C) {
                this.#n?.editAltText(this, C);
              }
              onPageChanging({
                pageNumber: C
              }) {
                this.#i = C - 1;
              }
              focusMainContainer() {
                this.#w.focus();
              }
              findParent(C, w) {
                for (const S of this.#r.values()) {
                  const {
                    x: $,
                    y: T,
                    width: I,
                    height: _
                  } = S.div.getBoundingClientRect();
                  if (C >= $ && C <= $ + I && w >= T && w <= T + _)
                    return S;
                }
                return null;
              }
              disableUserSelect(C = !1) {
                this.#F.classList.toggle("noUserSelect", C);
              }
              addShouldRescale(C) {
                this.#p.add(C);
              }
              removeShouldRescale(C) {
                this.#p.delete(C);
              }
              onScaleChanging({
                scale: C
              }) {
                this.commitOrRemove(), this.viewParameters.realScale = C * d.PixelsPerInch.PDF_TO_CSS_UNITS;
                for (const w of this.#p)
                  w.onScaleChanging();
              }
              onRotationChanging({
                pagesRotation: C
              }) {
                this.commitOrRemove(), this.viewParameters.rotation = C;
              }
              addToAnnotationStorage(C) {
                !C.isEmpty() && this.#s && !this.#s.has(C.id) && this.#s.setValue(C.id, C);
              }
              #L() {
                window.addEventListener("focus", this.#C), window.addEventListener("blur", this.#E);
              }
              #N() {
                window.removeEventListener("focus", this.#C), window.removeEventListener("blur", this.#E);
              }
              blur() {
                if (!this.hasSelection)
                  return;
                const {
                  activeElement: C
                } = document;
                for (const w of this.#u)
                  if (w.div.contains(C)) {
                    this.#m = [w, C], w._focusEventsAllowed = !1;
                    break;
                  }
              }
              focus() {
                if (!this.#m)
                  return;
                const [C, w] = this.#m;
                this.#m = null, w.addEventListener("focusin", () => {
                  C._focusEventsAllowed = !0;
                }, {
                  once: !0
                }), w.focus();
              }
              #j() {
                window.addEventListener("keydown", this.#k, {
                  capture: !0
                });
              }
              #P() {
                window.removeEventListener("keydown", this.#k, {
                  capture: !0
                });
              }
              #B() {
                document.addEventListener("copy", this.#$), document.addEventListener("cut", this.#_), document.addEventListener("paste", this.#M);
              }
              #S() {
                document.removeEventListener("copy", this.#$), document.removeEventListener("cut", this.#_), document.removeEventListener("paste", this.#M);
              }
              addEditListeners() {
                this.#j(), this.#B();
              }
              removeEditListeners() {
                this.#P(), this.#S();
              }
              copy(C) {
                if (C.preventDefault(), this.#e?.commitOrRemove(), !this.hasSelection)
                  return;
                const w = [];
                for (const S of this.#u) {
                  const $ = S.serialize(!0);
                  $ && w.push($);
                }
                w.length !== 0 && C.clipboardData.setData("application/pdfjs", JSON.stringify(w));
              }
              cut(C) {
                this.copy(C), this.delete();
              }
              paste(C) {
                C.preventDefault();
                const {
                  clipboardData: w
                } = C;
                for (const T of w.items)
                  for (const I of this.#a)
                    if (I.isHandlingMimeForPasting(T.type)) {
                      I.paste(T, this.currentLayer);
                      return;
                    }
                let S = w.getData("application/pdfjs");
                if (!S)
                  return;
                try {
                  S = JSON.parse(S);
                } catch (T) {
                  (0, u.warn)(`paste: "${T.message}".`);
                  return;
                }
                if (!Array.isArray(S))
                  return;
                this.unselectAll();
                const $ = this.currentLayer;
                try {
                  const T = [];
                  for (const E of S) {
                    const R = $.deserialize(E);
                    if (!R)
                      return;
                    T.push(R);
                  }
                  const I = () => {
                    for (const E of T)
                      this.#z(E);
                    this.#W(T);
                  }, _ = () => {
                    for (const E of T)
                      E.remove();
                  };
                  this.addCommands({
                    cmd: I,
                    undo: _,
                    mustExec: !0
                  });
                } catch (T) {
                  (0, u.warn)(`paste: "${T.message}".`);
                }
              }
              keydown(C) {
                this.getActive()?.shouldGetKeyboardEvents() || f._keyboardManager.exec(this, C);
              }
              onEditingAction(C) {
                ["undo", "redo", "delete", "selectAll"].includes(C.name) && this[C.name]();
              }
              #y(C) {
                Object.entries(C).some(([S, $]) => this.#R[S] !== $) && this._eventBus.dispatch("annotationeditorstateschanged", {
                  source: this,
                  details: Object.assign(this.#R, C)
                });
              }
              #H(C) {
                this._eventBus.dispatch("annotationeditorparamschanged", {
                  source: this,
                  details: C
                });
              }
              setEditingState(C) {
                C ? (this.#L(), this.#j(), this.#B(), this.#y({
                  isEditing: this.#g !== u.AnnotationEditorType.NONE,
                  isEmpty: this.#U(),
                  hasSomethingToUndo: this.#o.hasSomethingToUndo(),
                  hasSomethingToRedo: this.#o.hasSomethingToRedo(),
                  hasSelectedEditor: !1
                })) : (this.#N(), this.#P(), this.#S(), this.#y({
                  isEditing: !1
                }), this.disableUserSelect(!1));
              }
              registerEditorTypes(C) {
                if (!this.#a) {
                  this.#a = C;
                  for (const w of this.#a)
                    this.#H(w.defaultPropertiesToUpdate);
                }
              }
              getId() {
                return this.#f.getId();
              }
              get currentLayer() {
                return this.#r.get(this.#i);
              }
              getLayer(C) {
                return this.#r.get(C);
              }
              get currentPageIndex() {
                return this.#i;
              }
              addLayer(C) {
                this.#r.set(C.pageIndex, C), this.#h ? C.enable() : C.disable();
              }
              removeLayer(C) {
                this.#r.delete(C.pageIndex);
              }
              updateMode(C, w = null) {
                if (this.#g !== C) {
                  if (this.#g = C, C === u.AnnotationEditorType.NONE) {
                    this.setEditingState(!1), this.#G();
                    return;
                  }
                  this.setEditingState(!0), this.#V(), this.unselectAll();
                  for (const S of this.#r.values())
                    S.updateMode(C);
                  if (w) {
                    for (const S of this.#t.values())
                      if (S.annotationElementId === w) {
                        this.setSelected(S), S.enterInEditMode();
                        break;
                      }
                  }
                }
              }
              updateToolbar(C) {
                C !== this.#g && this._eventBus.dispatch("switchannotationeditormode", {
                  source: this,
                  mode: C
                });
              }
              updateParams(C, w) {
                if (this.#a) {
                  if (C === u.AnnotationEditorParamsType.CREATE) {
                    this.currentLayer.addNewEditor(C);
                    return;
                  }
                  for (const S of this.#u)
                    S.updateParams(C, w);
                  for (const S of this.#a)
                    S.updateDefaultParams(C, w);
                }
              }
              enableWaiting(C = !1) {
                if (this.#A !== C) {
                  this.#A = C;
                  for (const w of this.#r.values())
                    C ? w.disableClick() : w.enableClick(), w.div.classList.toggle("waiting", C);
                }
              }
              #V() {
                if (!this.#h) {
                  this.#h = !0;
                  for (const C of this.#r.values())
                    C.enable();
                }
              }
              #G() {
                if (this.unselectAll(), this.#h) {
                  this.#h = !1;
                  for (const C of this.#r.values())
                    C.disable();
                }
              }
              getEditors(C) {
                const w = [];
                for (const S of this.#t.values())
                  S.pageIndex === C && w.push(S);
                return w;
              }
              getEditor(C) {
                return this.#t.get(C);
              }
              addEditor(C) {
                this.#t.set(C.id, C);
              }
              removeEditor(C) {
                this.#t.delete(C.id), this.unselect(C), (!C.annotationElementId || !this.#l.has(C.annotationElementId)) && this.#s?.remove(C.id);
              }
              addDeletedAnnotationElement(C) {
                this.#l.add(C.annotationElementId), C.deleted = !0;
              }
              isDeletedAnnotationElement(C) {
                return this.#l.has(C);
              }
              removeDeletedAnnotationElement(C) {
                this.#l.delete(C.annotationElementId), C.deleted = !1;
              }
              #z(C) {
                const w = this.#r.get(C.pageIndex);
                w ? w.addOrRebuild(C) : this.addEditor(C);
              }
              setActiveEditor(C) {
                this.#e !== C && (this.#e = C, C && this.#H(C.propertiesToUpdate));
              }
              toggleSelected(C) {
                if (this.#u.has(C)) {
                  this.#u.delete(C), C.unselect(), this.#y({
                    hasSelectedEditor: this.hasSelection
                  });
                  return;
                }
                this.#u.add(C), C.select(), this.#H(C.propertiesToUpdate), this.#y({
                  hasSelectedEditor: !0
                });
              }
              setSelected(C) {
                for (const w of this.#u)
                  w !== C && w.unselect();
                this.#u.clear(), this.#u.add(C), C.select(), this.#H(C.propertiesToUpdate), this.#y({
                  hasSelectedEditor: !0
                });
              }
              isSelected(C) {
                return this.#u.has(C);
              }
              unselect(C) {
                C.unselect(), this.#u.delete(C), this.#y({
                  hasSelectedEditor: this.hasSelection
                });
              }
              get hasSelection() {
                return this.#u.size !== 0;
              }
              undo() {
                this.#o.undo(), this.#y({
                  hasSomethingToUndo: this.#o.hasSomethingToUndo(),
                  hasSomethingToRedo: !0,
                  isEmpty: this.#U()
                });
              }
              redo() {
                this.#o.redo(), this.#y({
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: this.#o.hasSomethingToRedo(),
                  isEmpty: this.#U()
                });
              }
              addCommands(C) {
                this.#o.add(C), this.#y({
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: !1,
                  isEmpty: this.#U()
                });
              }
              #U() {
                if (this.#t.size === 0)
                  return !0;
                if (this.#t.size === 1)
                  for (const C of this.#t.values())
                    return C.isEmpty();
                return !1;
              }
              delete() {
                if (this.commitOrRemove(), !this.hasSelection)
                  return;
                const C = [...this.#u], w = () => {
                  for (const $ of C)
                    $.remove();
                }, S = () => {
                  for (const $ of C)
                    this.#z($);
                };
                this.addCommands({
                  cmd: w,
                  undo: S,
                  mustExec: !0
                });
              }
              commitOrRemove() {
                this.#e?.commitOrRemove();
              }
              hasSomethingToControl() {
                return this.#e || this.hasSelection;
              }
              #W(C) {
                this.#u.clear();
                for (const w of C)
                  w.isEmpty() || (this.#u.add(w), w.select());
                this.#y({
                  hasSelectedEditor: !0
                });
              }
              selectAll() {
                for (const C of this.#u)
                  C.commit();
                this.#W(this.#t.values());
              }
              unselectAll() {
                if (this.#e) {
                  this.#e.commitOrRemove();
                  return;
                }
                if (this.hasSelection) {
                  for (const C of this.#u)
                    C.unselect();
                  this.#u.clear(), this.#y({
                    hasSelectedEditor: !1
                  });
                }
              }
              translateSelectedEditors(C, w, S = !1) {
                if (S || this.commitOrRemove(), !this.hasSelection)
                  return;
                this.#x[0] += C, this.#x[1] += w;
                const [$, T] = this.#x, I = [...this.#u], _ = 1e3;
                this.#I && clearTimeout(this.#I), this.#I = setTimeout(() => {
                  this.#I = null, this.#x[0] = this.#x[1] = 0, this.addCommands({
                    cmd: () => {
                      for (const E of I)
                        this.#t.has(E.id) && E.translateInPage($, T);
                    },
                    undo: () => {
                      for (const E of I)
                        this.#t.has(E.id) && E.translateInPage(-$, -T);
                    },
                    mustExec: !1
                  });
                }, _);
                for (const E of I)
                  E.translateInPage(C, w);
              }
              setUpDragSession() {
                if (this.hasSelection) {
                  this.disableUserSelect(!0), this.#c = /* @__PURE__ */ new Map();
                  for (const C of this.#u)
                    this.#c.set(C, {
                      savedX: C.x,
                      savedY: C.y,
                      savedPageIndex: C.pageIndex,
                      newX: 0,
                      newY: 0,
                      newPageIndex: -1
                    });
                }
              }
              endDragSession() {
                if (!this.#c)
                  return !1;
                this.disableUserSelect(!1);
                const C = this.#c;
                this.#c = null;
                let w = !1;
                for (const [{
                  x: $,
                  y: T,
                  pageIndex: I
                }, _] of C)
                  _.newX = $, _.newY = T, _.newPageIndex = I, w ||= $ !== _.savedX || T !== _.savedY || I !== _.savedPageIndex;
                if (!w)
                  return !1;
                const S = ($, T, I, _) => {
                  if (this.#t.has($.id)) {
                    const E = this.#r.get(_);
                    E ? $._setParentAndPosition(E, T, I) : ($.pageIndex = _, $.x = T, $.y = I);
                  }
                };
                return this.addCommands({
                  cmd: () => {
                    for (const [$, {
                      newX: T,
                      newY: I,
                      newPageIndex: _
                    }] of C)
                      S($, T, I, _);
                  },
                  undo: () => {
                    for (const [$, {
                      savedX: T,
                      savedY: I,
                      savedPageIndex: _
                    }] of C)
                      S($, T, I, _);
                  },
                  mustExec: !0
                }), !0;
              }
              dragSelectedEditors(C, w) {
                if (this.#c)
                  for (const S of this.#c.keys())
                    S.drag(C, w);
              }
              rebuild(C) {
                if (C.parent === null) {
                  const w = this.getLayer(C.pageIndex);
                  w ? (w.changeParent(C), w.addOrRebuild(C)) : (this.addEditor(C), this.addToAnnotationStorage(C), C.rebuild());
                } else
                  C.parent.addOrRebuild(C);
              }
              isActive(C) {
                return this.#e === C;
              }
              getActive() {
                return this.#e;
              }
              getMode() {
                return this.#g;
              }
              get imageManager() {
                return (0, u.shadow)(this, "imageManager", new x());
              }
            }
            s.AnnotationEditorUIManager = f;
          },
          /* 6 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.StatTimer = s.RenderingCancelledException = s.PixelsPerInch = s.PageViewport = s.PDFDateString = s.DOMStandardFontDataFactory = s.DOMSVGFactory = s.DOMFilterFactory = s.DOMCanvasFactory = s.DOMCMapReaderFactory = void 0, s.deprecated = O, s.getColorValues = W, s.getCurrentTransform = j, s.getCurrentTransformInverse = G, s.getFilenameFromUrl = $, s.getPdfFilenameFromUrl = T, s.getRGB = M, s.getXfaPageViewport = F, s.isDataScheme = w, s.isPdfFile = S, s.isValidFetchUrl = _, s.loadScript = R, s.noContextMenu = E, s.setLayerDimensions = U;
            var u = c(7), d = c(1);
            const p = "http://www.w3.org/2000/svg";
            class v {
              static CSS = 96;
              static PDF = 72;
              static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
            }
            s.PixelsPerInch = v;
            class A extends u.BaseFilterFactory {
              #e;
              #t;
              #r;
              #n;
              #s;
              #o;
              #i;
              #l;
              #c;
              #a;
              #p = 0;
              constructor({
                docId: N,
                ownerDocument: P = globalThis.document
              } = {}) {
                super(), this.#r = N, this.#n = P;
              }
              get #d() {
                return this.#e ||= /* @__PURE__ */ new Map();
              }
              get #f() {
                if (!this.#t) {
                  const N = this.#n.createElement("div"), {
                    style: P
                  } = N;
                  P.visibility = "hidden", P.contain = "strict", P.width = P.height = 0, P.position = "absolute", P.top = P.left = 0, P.zIndex = -1;
                  const D = this.#n.createElementNS(p, "svg");
                  D.setAttribute("width", 0), D.setAttribute("height", 0), this.#t = this.#n.createElementNS(p, "defs"), N.append(D), D.append(this.#t), this.#n.body.append(N);
                }
                return this.#t;
              }
              addFilter(N) {
                if (!N)
                  return "none";
                let P = this.#d.get(N);
                if (P)
                  return P;
                let D, H, V, Z;
                if (N.length === 1) {
                  const Y = N[0], ee = new Array(256);
                  for (let Q = 0; Q < 256; Q++)
                    ee[Q] = Y[Q] / 255;
                  Z = D = H = V = ee.join(",");
                } else {
                  const [Y, ee, Q] = N, J = new Array(256), te = new Array(256), ae = new Array(256);
                  for (let se = 0; se < 256; se++)
                    J[se] = Y[se] / 255, te[se] = ee[se] / 255, ae[se] = Q[se] / 255;
                  D = J.join(","), H = te.join(","), V = ae.join(","), Z = `${D}${H}${V}`;
                }
                if (P = this.#d.get(Z), P)
                  return this.#d.set(N, P), P;
                const ne = `g_${this.#r}_transfer_map_${this.#p++}`, K = `url(#${ne})`;
                this.#d.set(N, K), this.#d.set(Z, K);
                const q = this.#A(ne);
                return this.#g(D, H, V, q), K;
              }
              addHCMFilter(N, P) {
                const D = `${N}-${P}`;
                if (this.#o === D)
                  return this.#i;
                if (this.#o = D, this.#i = "none", this.#s?.remove(), !N || !P)
                  return this.#i;
                const H = this.#u(N);
                N = d.Util.makeHexColor(...H);
                const V = this.#u(P);
                if (P = d.Util.makeHexColor(...V), this.#f.style.color = "", N === "#000000" && P === "#ffffff" || N === P)
                  return this.#i;
                const Z = new Array(256);
                for (let ee = 0; ee <= 255; ee++) {
                  const Q = ee / 255;
                  Z[ee] = Q <= 0.03928 ? Q / 12.92 : ((Q + 0.055) / 1.055) ** 2.4;
                }
                const ne = Z.join(","), K = `g_${this.#r}_hcm_filter`, q = this.#l = this.#A(K);
                this.#g(ne, ne, ne, q), this.#h(q);
                const Y = (ee, Q) => {
                  const J = H[ee] / 255, te = V[ee] / 255, ae = new Array(Q + 1);
                  for (let se = 0; se <= Q; se++)
                    ae[se] = J + se / Q * (te - J);
                  return ae.join(",");
                };
                return this.#g(Y(0, 5), Y(1, 5), Y(2, 5), q), this.#i = `url(#${K})`, this.#i;
              }
              addHighlightHCMFilter(N, P, D, H) {
                const V = `${N}-${P}-${D}-${H}`;
                if (this.#c === V)
                  return this.#a;
                if (this.#c = V, this.#a = "none", this.#l?.remove(), !N || !P)
                  return this.#a;
                const [Z, ne] = [N, P].map(this.#u.bind(this));
                let K = Math.round(0.2126 * Z[0] + 0.7152 * Z[1] + 0.0722 * Z[2]), q = Math.round(0.2126 * ne[0] + 0.7152 * ne[1] + 0.0722 * ne[2]), [Y, ee] = [D, H].map(this.#u.bind(this));
                q < K && ([K, q, Y, ee] = [q, K, ee, Y]), this.#f.style.color = "";
                const Q = (ae, se, ie) => {
                  const fe = new Array(256), ge = (q - K) / ie, me = ae / 255, pe = (se - ae) / (255 * ie);
                  let be = 0;
                  for (let le = 0; le <= ie; le++) {
                    const ve = Math.round(K + le * ge), he = me + le * pe;
                    for (let ye = be; ye <= ve; ye++)
                      fe[ye] = he;
                    be = ve + 1;
                  }
                  for (let le = be; le < 256; le++)
                    fe[le] = fe[be - 1];
                  return fe.join(",");
                }, J = `g_${this.#r}_hcm_highlight_filter`, te = this.#l = this.#A(J);
                return this.#h(te), this.#g(Q(Y[0], ee[0], 5), Q(Y[1], ee[1], 5), Q(Y[2], ee[2], 5), te), this.#a = `url(#${J})`, this.#a;
              }
              destroy(N = !1) {
                N && (this.#i || this.#a) || (this.#t && (this.#t.parentNode.parentNode.remove(), this.#t = null), this.#e && (this.#e.clear(), this.#e = null), this.#p = 0);
              }
              #h(N) {
                const P = this.#n.createElementNS(p, "feColorMatrix");
                P.setAttribute("type", "matrix"), P.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"), N.append(P);
              }
              #A(N) {
                const P = this.#n.createElementNS(p, "filter");
                return P.setAttribute("color-interpolation-filters", "sRGB"), P.setAttribute("id", N), this.#f.append(P), P;
              }
              #m(N, P, D) {
                const H = this.#n.createElementNS(p, P);
                H.setAttribute("type", "discrete"), H.setAttribute("tableValues", D), N.append(H);
              }
              #g(N, P, D, H) {
                const V = this.#n.createElementNS(p, "feComponentTransfer");
                H.append(V), this.#m(V, "feFuncR", N), this.#m(V, "feFuncG", P), this.#m(V, "feFuncB", D);
              }
              #u(N) {
                return this.#f.style.color = N, M(getComputedStyle(this.#f).getPropertyValue("color"));
              }
            }
            s.DOMFilterFactory = A;
            class x extends u.BaseCanvasFactory {
              constructor({
                ownerDocument: N = globalThis.document
              } = {}) {
                super(), this._document = N;
              }
              _createCanvas(N, P) {
                const D = this._document.createElement("canvas");
                return D.width = N, D.height = P, D;
              }
            }
            s.DOMCanvasFactory = x;
            async function g(k, N = !1) {
              if (_(k, document.baseURI)) {
                const P = await fetch(k);
                if (!P.ok)
                  throw new Error(P.statusText);
                return N ? new Uint8Array(await P.arrayBuffer()) : (0, d.stringToBytes)(await P.text());
              }
              return new Promise((P, D) => {
                const H = new XMLHttpRequest();
                H.open("GET", k, !0), N && (H.responseType = "arraybuffer"), H.onreadystatechange = () => {
                  if (H.readyState === XMLHttpRequest.DONE) {
                    if (H.status === 200 || H.status === 0) {
                      let V;
                      if (N && H.response ? V = new Uint8Array(H.response) : !N && H.responseText && (V = (0, d.stringToBytes)(H.responseText)), V) {
                        P(V);
                        return;
                      }
                    }
                    D(new Error(H.statusText));
                  }
                }, H.send(null);
              });
            }
            class b extends u.BaseCMapReaderFactory {
              _fetchData(N, P) {
                return g(N, this.isCompressed).then((D) => ({
                  cMapData: D,
                  compressionType: P
                }));
              }
            }
            s.DOMCMapReaderFactory = b;
            class y extends u.BaseStandardFontDataFactory {
              _fetchData(N) {
                return g(N, !0);
              }
            }
            s.DOMStandardFontDataFactory = y;
            class f extends u.BaseSVGFactory {
              _createSVG(N) {
                return document.createElementNS(p, N);
              }
            }
            s.DOMSVGFactory = f;
            class m {
              constructor({
                viewBox: N,
                scale: P,
                rotation: D,
                offsetX: H = 0,
                offsetY: V = 0,
                dontFlip: Z = !1
              }) {
                this.viewBox = N, this.scale = P, this.rotation = D, this.offsetX = H, this.offsetY = V;
                const ne = (N[2] + N[0]) / 2, K = (N[3] + N[1]) / 2;
                let q, Y, ee, Q;
                switch (D %= 360, D < 0 && (D += 360), D) {
                  case 180:
                    q = -1, Y = 0, ee = 0, Q = 1;
                    break;
                  case 90:
                    q = 0, Y = 1, ee = 1, Q = 0;
                    break;
                  case 270:
                    q = 0, Y = -1, ee = -1, Q = 0;
                    break;
                  case 0:
                    q = 1, Y = 0, ee = 0, Q = -1;
                    break;
                  default:
                    throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                }
                Z && (ee = -ee, Q = -Q);
                let J, te, ae, se;
                q === 0 ? (J = Math.abs(K - N[1]) * P + H, te = Math.abs(ne - N[0]) * P + V, ae = (N[3] - N[1]) * P, se = (N[2] - N[0]) * P) : (J = Math.abs(ne - N[0]) * P + H, te = Math.abs(K - N[1]) * P + V, ae = (N[2] - N[0]) * P, se = (N[3] - N[1]) * P), this.transform = [q * P, Y * P, ee * P, Q * P, J - q * P * ne - ee * P * K, te - Y * P * ne - Q * P * K], this.width = ae, this.height = se;
              }
              get rawDims() {
                const {
                  viewBox: N
                } = this;
                return (0, d.shadow)(this, "rawDims", {
                  pageWidth: N[2] - N[0],
                  pageHeight: N[3] - N[1],
                  pageX: N[0],
                  pageY: N[1]
                });
              }
              clone({
                scale: N = this.scale,
                rotation: P = this.rotation,
                offsetX: D = this.offsetX,
                offsetY: H = this.offsetY,
                dontFlip: V = !1
              } = {}) {
                return new m({
                  viewBox: this.viewBox.slice(),
                  scale: N,
                  rotation: P,
                  offsetX: D,
                  offsetY: H,
                  dontFlip: V
                });
              }
              convertToViewportPoint(N, P) {
                return d.Util.applyTransform([N, P], this.transform);
              }
              convertToViewportRectangle(N) {
                const P = d.Util.applyTransform([N[0], N[1]], this.transform), D = d.Util.applyTransform([N[2], N[3]], this.transform);
                return [P[0], P[1], D[0], D[1]];
              }
              convertToPdfPoint(N, P) {
                return d.Util.applyInverseTransform([N, P], this.transform);
              }
            }
            s.PageViewport = m;
            class C extends d.BaseException {
              constructor(N, P = 0) {
                super(N, "RenderingCancelledException"), this.extraDelay = P;
              }
            }
            s.RenderingCancelledException = C;
            function w(k) {
              const N = k.length;
              let P = 0;
              for (; P < N && k[P].trim() === ""; )
                P++;
              return k.substring(P, P + 5).toLowerCase() === "data:";
            }
            function S(k) {
              return typeof k == "string" && /\.pdf$/i.test(k);
            }
            function $(k, N = !1) {
              return N || ([k] = k.split(/[#?]/, 1)), k.substring(k.lastIndexOf("/") + 1);
            }
            function T(k, N = "document.pdf") {
              if (typeof k != "string")
                return N;
              if (w(k))
                return (0, d.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), N;
              const P = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, D = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, H = P.exec(k);
              let V = D.exec(H[1]) || D.exec(H[2]) || D.exec(H[3]);
              if (V && (V = V[0], V.includes("%")))
                try {
                  V = D.exec(decodeURIComponent(V))[0];
                } catch {
                }
              return V || N;
            }
            class I {
              started = /* @__PURE__ */ Object.create(null);
              times = [];
              time(N) {
                N in this.started && (0, d.warn)(`Timer is already running for ${N}`), this.started[N] = Date.now();
              }
              timeEnd(N) {
                N in this.started || (0, d.warn)(`Timer has not been started for ${N}`), this.times.push({
                  name: N,
                  start: this.started[N],
                  end: Date.now()
                }), delete this.started[N];
              }
              toString() {
                const N = [];
                let P = 0;
                for (const {
                  name: D
                } of this.times)
                  P = Math.max(D.length, P);
                for (const {
                  name: D,
                  start: H,
                  end: V
                } of this.times)
                  N.push(`${D.padEnd(P)} ${V - H}ms
`);
                return N.join("");
              }
            }
            s.StatTimer = I;
            function _(k, N) {
              try {
                const {
                  protocol: P
                } = N ? new URL(k, N) : new URL(k);
                return P === "http:" || P === "https:";
              } catch {
                return !1;
              }
            }
            function E(k) {
              k.preventDefault();
            }
            function R(k, N = !1) {
              return new Promise((P, D) => {
                const H = document.createElement("script");
                H.src = k, H.onload = function(V) {
                  N && H.remove(), P(V);
                }, H.onerror = function() {
                  D(new Error(`Cannot load script at: ${H.src}`));
                }, (document.head || document.documentElement).append(H);
              });
            }
            function O(k) {
              console.log("Deprecated API usage: " + k);
            }
            let L;
            class B {
              static toDateObject(N) {
                if (!N || typeof N != "string")
                  return null;
                L ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                const P = L.exec(N);
                if (!P)
                  return null;
                const D = parseInt(P[1], 10);
                let H = parseInt(P[2], 10);
                H = H >= 1 && H <= 12 ? H - 1 : 0;
                let V = parseInt(P[3], 10);
                V = V >= 1 && V <= 31 ? V : 1;
                let Z = parseInt(P[4], 10);
                Z = Z >= 0 && Z <= 23 ? Z : 0;
                let ne = parseInt(P[5], 10);
                ne = ne >= 0 && ne <= 59 ? ne : 0;
                let K = parseInt(P[6], 10);
                K = K >= 0 && K <= 59 ? K : 0;
                const q = P[7] || "Z";
                let Y = parseInt(P[8], 10);
                Y = Y >= 0 && Y <= 23 ? Y : 0;
                let ee = parseInt(P[9], 10) || 0;
                return ee = ee >= 0 && ee <= 59 ? ee : 0, q === "-" ? (Z += Y, ne += ee) : q === "+" && (Z -= Y, ne -= ee), new Date(Date.UTC(D, H, V, Z, ne, K));
              }
            }
            s.PDFDateString = B;
            function F(k, {
              scale: N = 1,
              rotation: P = 0
            }) {
              const {
                width: D,
                height: H
              } = k.attributes.style, V = [0, 0, parseInt(D), parseInt(H)];
              return new m({
                viewBox: V,
                scale: N,
                rotation: P
              });
            }
            function M(k) {
              if (k.startsWith("#")) {
                const N = parseInt(k.slice(1), 16);
                return [(N & 16711680) >> 16, (N & 65280) >> 8, N & 255];
              }
              return k.startsWith("rgb(") ? k.slice(4, -1).split(",").map((N) => parseInt(N)) : k.startsWith("rgba(") ? k.slice(5, -1).split(",").map((N) => parseInt(N)).slice(0, 3) : ((0, d.warn)(`Not a valid color format: "${k}"`), [0, 0, 0]);
            }
            function W(k) {
              const N = document.createElement("span");
              N.style.visibility = "hidden", document.body.append(N);
              for (const P of k.keys()) {
                N.style.color = P;
                const D = window.getComputedStyle(N).color;
                k.set(P, M(D));
              }
              N.remove();
            }
            function j(k) {
              const {
                a: N,
                b: P,
                c: D,
                d: H,
                e: V,
                f: Z
              } = k.getTransform();
              return [N, P, D, H, V, Z];
            }
            function G(k) {
              const {
                a: N,
                b: P,
                c: D,
                d: H,
                e: V,
                f: Z
              } = k.getTransform().invertSelf();
              return [N, P, D, H, V, Z];
            }
            function U(k, N, P = !1, D = !0) {
              if (N instanceof m) {
                const {
                  pageWidth: H,
                  pageHeight: V
                } = N.rawDims, {
                  style: Z
                } = k, ne = d.FeatureTest.isCSSRoundSupported, K = `var(--scale-factor) * ${H}px`, q = `var(--scale-factor) * ${V}px`, Y = ne ? `round(${K}, 1px)` : `calc(${K})`, ee = ne ? `round(${q}, 1px)` : `calc(${q})`;
                !P || N.rotation % 180 === 0 ? (Z.width = Y, Z.height = ee) : (Z.width = ee, Z.height = Y);
              }
              D && k.setAttribute("data-main-rotation", N.rotation);
            }
          },
          /* 7 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.BaseStandardFontDataFactory = s.BaseSVGFactory = s.BaseFilterFactory = s.BaseCanvasFactory = s.BaseCMapReaderFactory = void 0;
            var u = c(1);
            class d {
              constructor() {
                this.constructor === d && (0, u.unreachable)("Cannot initialize BaseFilterFactory.");
              }
              addFilter(b) {
                return "none";
              }
              addHCMFilter(b, y) {
                return "none";
              }
              addHighlightHCMFilter(b, y, f, m) {
                return "none";
              }
              destroy(b = !1) {
              }
            }
            s.BaseFilterFactory = d;
            class p {
              constructor() {
                this.constructor === p && (0, u.unreachable)("Cannot initialize BaseCanvasFactory.");
              }
              create(b, y) {
                if (b <= 0 || y <= 0)
                  throw new Error("Invalid canvas size");
                const f = this._createCanvas(b, y);
                return {
                  canvas: f,
                  context: f.getContext("2d")
                };
              }
              reset(b, y, f) {
                if (!b.canvas)
                  throw new Error("Canvas is not specified");
                if (y <= 0 || f <= 0)
                  throw new Error("Invalid canvas size");
                b.canvas.width = y, b.canvas.height = f;
              }
              destroy(b) {
                if (!b.canvas)
                  throw new Error("Canvas is not specified");
                b.canvas.width = 0, b.canvas.height = 0, b.canvas = null, b.context = null;
              }
              _createCanvas(b, y) {
                (0, u.unreachable)("Abstract method `_createCanvas` called.");
              }
            }
            s.BaseCanvasFactory = p;
            class v {
              constructor({
                baseUrl: b = null,
                isCompressed: y = !0
              }) {
                this.constructor === v && (0, u.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = b, this.isCompressed = y;
              }
              async fetch({
                name: b
              }) {
                if (!this.baseUrl)
                  throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                if (!b)
                  throw new Error("CMap name must be specified.");
                const y = this.baseUrl + b + (this.isCompressed ? ".bcmap" : ""), f = this.isCompressed ? u.CMapCompressionType.BINARY : u.CMapCompressionType.NONE;
                return this._fetchData(y, f).catch((m) => {
                  throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${y}`);
                });
              }
              _fetchData(b, y) {
                (0, u.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            s.BaseCMapReaderFactory = v;
            class A {
              constructor({
                baseUrl: b = null
              }) {
                this.constructor === A && (0, u.unreachable)("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = b;
              }
              async fetch({
                filename: b
              }) {
                if (!this.baseUrl)
                  throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                if (!b)
                  throw new Error("Font filename must be specified.");
                const y = `${this.baseUrl}${b}`;
                return this._fetchData(y).catch((f) => {
                  throw new Error(`Unable to load font data at: ${y}`);
                });
              }
              _fetchData(b) {
                (0, u.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            s.BaseStandardFontDataFactory = A;
            class x {
              constructor() {
                this.constructor === x && (0, u.unreachable)("Cannot initialize BaseSVGFactory.");
              }
              create(b, y, f = !1) {
                if (b <= 0 || y <= 0)
                  throw new Error("Invalid SVG dimensions");
                const m = this._createSVG("svg:svg");
                return m.setAttribute("version", "1.1"), f || (m.setAttribute("width", `${b}px`), m.setAttribute("height", `${y}px`)), m.setAttribute("preserveAspectRatio", "none"), m.setAttribute("viewBox", `0 0 ${b} ${y}`), m;
              }
              createElement(b) {
                if (typeof b != "string")
                  throw new Error("Invalid SVG element type");
                return this._createSVG(b);
              }
              _createSVG(b) {
                (0, u.unreachable)("Abstract method `_createSVG` called.");
              }
            }
            s.BaseSVGFactory = x;
          },
          /* 8 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.MurmurHash3_64 = void 0;
            var u = c(1);
            const d = 3285377520, p = 4294901760, v = 65535;
            class A {
              constructor(g) {
                this.h1 = g ? g & 4294967295 : d, this.h2 = g ? g & 4294967295 : d;
              }
              update(g) {
                let b, y;
                if (typeof g == "string") {
                  b = new Uint8Array(g.length * 2), y = 0;
                  for (let O = 0, L = g.length; O < L; O++) {
                    const B = g.charCodeAt(O);
                    B <= 255 ? b[y++] = B : (b[y++] = B >>> 8, b[y++] = B & 255);
                  }
                } else if ((0, u.isArrayBuffer)(g))
                  b = g.slice(), y = b.byteLength;
                else
                  throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                const f = y >> 2, m = y - f * 4, C = new Uint32Array(b.buffer, 0, f);
                let w = 0, S = 0, $ = this.h1, T = this.h2;
                const I = 3432918353, _ = 461845907, E = I & v, R = _ & v;
                for (let O = 0; O < f; O++)
                  O & 1 ? (w = C[O], w = w * I & p | w * E & v, w = w << 15 | w >>> 17, w = w * _ & p | w * R & v, $ ^= w, $ = $ << 13 | $ >>> 19, $ = $ * 5 + 3864292196) : (S = C[O], S = S * I & p | S * E & v, S = S << 15 | S >>> 17, S = S * _ & p | S * R & v, T ^= S, T = T << 13 | T >>> 19, T = T * 5 + 3864292196);
                switch (w = 0, m) {
                  case 3:
                    w ^= b[f * 4 + 2] << 16;
                  case 2:
                    w ^= b[f * 4 + 1] << 8;
                  case 1:
                    w ^= b[f * 4], w = w * I & p | w * E & v, w = w << 15 | w >>> 17, w = w * _ & p | w * R & v, f & 1 ? $ ^= w : T ^= w;
                }
                this.h1 = $, this.h2 = T;
              }
              hexdigest() {
                let g = this.h1, b = this.h2;
                return g ^= b >>> 1, g = g * 3981806797 & p | g * 36045 & v, b = b * 4283543511 & p | ((b << 16 | g >>> 16) * 2950163797 & p) >>> 16, g ^= b >>> 1, g = g * 444984403 & p | g * 60499 & v, b = b * 3301882366 & p | ((b << 16 | g >>> 16) * 3120437893 & p) >>> 16, g ^= b >>> 1, (g >>> 0).toString(16).padStart(8, "0") + (b >>> 0).toString(16).padStart(8, "0");
              }
            }
            s.MurmurHash3_64 = A;
          },
          /* 9 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.FontLoader = s.FontFaceObject = void 0;
            var u = c(1);
            class d {
              #e = /* @__PURE__ */ new Set();
              constructor({
                ownerDocument: A = globalThis.document,
                styleElement: x = null
              }) {
                this._document = A, this.nativeFontFaces = /* @__PURE__ */ new Set(), this.styleElement = null, this.loadingRequests = [], this.loadTestFontId = 0;
              }
              addNativeFontFace(A) {
                this.nativeFontFaces.add(A), this._document.fonts.add(A);
              }
              removeNativeFontFace(A) {
                this.nativeFontFaces.delete(A), this._document.fonts.delete(A);
              }
              insertRule(A) {
                this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
                const x = this.styleElement.sheet;
                x.insertRule(A, x.cssRules.length);
              }
              clear() {
                for (const A of this.nativeFontFaces)
                  this._document.fonts.delete(A);
                this.nativeFontFaces.clear(), this.#e.clear(), this.styleElement && (this.styleElement.remove(), this.styleElement = null);
              }
              async loadSystemFont(A) {
                if (!(!A || this.#e.has(A.loadedName))) {
                  if ((0, u.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set."), this.isFontLoadingAPISupported) {
                    const {
                      loadedName: x,
                      src: g,
                      style: b
                    } = A, y = new FontFace(x, g, b);
                    this.addNativeFontFace(y);
                    try {
                      await y.load(), this.#e.add(x);
                    } catch {
                      (0, u.warn)(`Cannot load system font: ${A.baseFontName}, installing it could help to improve PDF rendering.`), this.removeNativeFontFace(y);
                    }
                    return;
                  }
                  (0, u.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                }
              }
              async bind(A) {
                if (A.attached || A.missingFile && !A.systemFontInfo)
                  return;
                if (A.attached = !0, A.systemFontInfo) {
                  await this.loadSystemFont(A.systemFontInfo);
                  return;
                }
                if (this.isFontLoadingAPISupported) {
                  const g = A.createNativeFontFace();
                  if (g) {
                    this.addNativeFontFace(g);
                    try {
                      await g.loaded;
                    } catch (b) {
                      throw (0, u.warn)(`Failed to load font '${g.family}': '${b}'.`), A.disableFontFace = !0, b;
                    }
                  }
                  return;
                }
                const x = A.createFontFaceRule();
                if (x) {
                  if (this.insertRule(x), this.isSyncFontLoadingSupported)
                    return;
                  await new Promise((g) => {
                    const b = this._queueLoadingCallback(g);
                    this._prepareFontLoadEvent(A, b);
                  });
                }
              }
              get isFontLoadingAPISupported() {
                const A = !!this._document?.fonts;
                return (0, u.shadow)(this, "isFontLoadingAPISupported", A);
              }
              get isSyncFontLoadingSupported() {
                let A = !1;
                return (u.isNodeJS || typeof navigator < "u" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) && (A = !0), (0, u.shadow)(this, "isSyncFontLoadingSupported", A);
              }
              _queueLoadingCallback(A) {
                function x() {
                  for ((0, u.assert)(!b.done, "completeRequest() cannot be called twice."), b.done = !0; g.length > 0 && g[0].done; ) {
                    const y = g.shift();
                    setTimeout(y.callback, 0);
                  }
                }
                const {
                  loadingRequests: g
                } = this, b = {
                  done: !1,
                  complete: x,
                  callback: A
                };
                return g.push(b), b;
              }
              get _loadTestFont() {
                const A = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                return (0, u.shadow)(this, "_loadTestFont", A);
              }
              _prepareFontLoadEvent(A, x) {
                function g(F, M) {
                  return F.charCodeAt(M) << 24 | F.charCodeAt(M + 1) << 16 | F.charCodeAt(M + 2) << 8 | F.charCodeAt(M + 3) & 255;
                }
                function b(F, M, W, j) {
                  const G = F.substring(0, M), U = F.substring(M + W);
                  return G + j + U;
                }
                let y, f;
                const m = this._document.createElement("canvas");
                m.width = 1, m.height = 1;
                const C = m.getContext("2d");
                let w = 0;
                function S(F, M) {
                  if (++w > 30) {
                    (0, u.warn)("Load test font never loaded."), M();
                    return;
                  }
                  if (C.font = "30px " + F, C.fillText(".", 0, 20), C.getImageData(0, 0, 1, 1).data[3] > 0) {
                    M();
                    return;
                  }
                  setTimeout(S.bind(null, F, M));
                }
                const $ = `lt${Date.now()}${this.loadTestFontId++}`;
                let T = this._loadTestFont;
                T = b(T, 976, $.length, $);
                const _ = 16, E = 1482184792;
                let R = g(T, _);
                for (y = 0, f = $.length - 3; y < f; y += 4)
                  R = R - E + g($, y) | 0;
                y < $.length && (R = R - E + g($ + "XXX", y) | 0), T = b(T, _, 4, (0, u.string32)(R));
                const O = `url(data:font/opentype;base64,${btoa(T)});`, L = `@font-face {font-family:"${$}";src:${O}}`;
                this.insertRule(L);
                const B = this._document.createElement("div");
                B.style.visibility = "hidden", B.style.width = B.style.height = "10px", B.style.position = "absolute", B.style.top = B.style.left = "0px";
                for (const F of [A.loadedName, $]) {
                  const M = this._document.createElement("span");
                  M.textContent = "Hi", M.style.fontFamily = F, B.append(M);
                }
                this._document.body.append(B), S($, () => {
                  B.remove(), x.complete();
                });
              }
            }
            s.FontLoader = d;
            class p {
              constructor(A, {
                isEvalSupported: x = !0,
                disableFontFace: g = !1,
                ignoreErrors: b = !1,
                inspectFont: y = null
              }) {
                this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
                for (const f in A)
                  this[f] = A[f];
                this.isEvalSupported = x !== !1, this.disableFontFace = g === !0, this.ignoreErrors = b === !0, this._inspectFont = y;
              }
              createNativeFontFace() {
                if (!this.data || this.disableFontFace)
                  return null;
                let A;
                if (!this.cssFontInfo)
                  A = new FontFace(this.loadedName, this.data, {});
                else {
                  const x = {
                    weight: this.cssFontInfo.fontWeight
                  };
                  this.cssFontInfo.italicAngle && (x.style = `oblique ${this.cssFontInfo.italicAngle}deg`), A = new FontFace(this.cssFontInfo.fontFamily, this.data, x);
                }
                return this._inspectFont?.(this), A;
              }
              createFontFaceRule() {
                if (!this.data || this.disableFontFace)
                  return null;
                const A = (0, u.bytesToString)(this.data), x = `url(data:${this.mimetype};base64,${btoa(A)});`;
                let g;
                if (!this.cssFontInfo)
                  g = `@font-face {font-family:"${this.loadedName}";src:${x}}`;
                else {
                  let b = `font-weight: ${this.cssFontInfo.fontWeight};`;
                  this.cssFontInfo.italicAngle && (b += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), g = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${b}src:${x}}`;
                }
                return this._inspectFont?.(this, x), g;
              }
              getPathGenerator(A, x) {
                if (this.compiledGlyphs[x] !== void 0)
                  return this.compiledGlyphs[x];
                let g;
                try {
                  g = A.get(this.loadedName + "_path_" + x);
                } catch (b) {
                  if (!this.ignoreErrors)
                    throw b;
                  return (0, u.warn)(`getPathGenerator - ignoring character: "${b}".`), this.compiledGlyphs[x] = function(y, f) {
                  };
                }
                if (this.isEvalSupported && u.FeatureTest.isEvalSupported) {
                  const b = [];
                  for (const y of g) {
                    const f = y.args !== void 0 ? y.args.join(",") : "";
                    b.push("c.", y.cmd, "(", f, `);
`);
                  }
                  return this.compiledGlyphs[x] = new Function("c", "size", b.join(""));
                }
                return this.compiledGlyphs[x] = function(b, y) {
                  for (const f of g)
                    f.cmd === "scale" && (f.args = [y, -y]), b[f.cmd].apply(b, f.args);
                };
              }
            }
            s.FontFaceObject = p;
          },
          /* 10 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.NodeStandardFontDataFactory = s.NodeFilterFactory = s.NodeCanvasFactory = s.NodeCMapReaderFactory = void 0;
            var u = c(7);
            c(1);
            const d = function(g) {
              return new Promise((b, y) => {
                require$$5.readFile(g, (m, C) => {
                  if (m || !C) {
                    y(new Error(m));
                    return;
                  }
                  b(new Uint8Array(C));
                });
              });
            };
            class p extends u.BaseFilterFactory {
            }
            s.NodeFilterFactory = p;
            class v extends u.BaseCanvasFactory {
              _createCanvas(b, y) {
                return require$$5.createCanvas(b, y);
              }
            }
            s.NodeCanvasFactory = v;
            class A extends u.BaseCMapReaderFactory {
              _fetchData(b, y) {
                return d(b).then((f) => ({
                  cMapData: f,
                  compressionType: y
                }));
              }
            }
            s.NodeCMapReaderFactory = A;
            class x extends u.BaseStandardFontDataFactory {
              _fetchData(b) {
                return d(b);
              }
            }
            s.NodeStandardFontDataFactory = x;
          },
          /* 11 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.CanvasGraphics = void 0;
            var u = c(1), d = c(6), p = c(12), v = c(13);
            const A = 16, x = 100, g = 4096, b = 15, y = 10, f = 1e3, m = 16;
            function C(P, D) {
              if (P._removeMirroring)
                throw new Error("Context is already forwarding operations.");
              P.__originalSave = P.save, P.__originalRestore = P.restore, P.__originalRotate = P.rotate, P.__originalScale = P.scale, P.__originalTranslate = P.translate, P.__originalTransform = P.transform, P.__originalSetTransform = P.setTransform, P.__originalResetTransform = P.resetTransform, P.__originalClip = P.clip, P.__originalMoveTo = P.moveTo, P.__originalLineTo = P.lineTo, P.__originalBezierCurveTo = P.bezierCurveTo, P.__originalRect = P.rect, P.__originalClosePath = P.closePath, P.__originalBeginPath = P.beginPath, P._removeMirroring = () => {
                P.save = P.__originalSave, P.restore = P.__originalRestore, P.rotate = P.__originalRotate, P.scale = P.__originalScale, P.translate = P.__originalTranslate, P.transform = P.__originalTransform, P.setTransform = P.__originalSetTransform, P.resetTransform = P.__originalResetTransform, P.clip = P.__originalClip, P.moveTo = P.__originalMoveTo, P.lineTo = P.__originalLineTo, P.bezierCurveTo = P.__originalBezierCurveTo, P.rect = P.__originalRect, P.closePath = P.__originalClosePath, P.beginPath = P.__originalBeginPath, delete P._removeMirroring;
              }, P.save = function() {
                D.save(), this.__originalSave();
              }, P.restore = function() {
                D.restore(), this.__originalRestore();
              }, P.translate = function(V, Z) {
                D.translate(V, Z), this.__originalTranslate(V, Z);
              }, P.scale = function(V, Z) {
                D.scale(V, Z), this.__originalScale(V, Z);
              }, P.transform = function(V, Z, ne, K, q, Y) {
                D.transform(V, Z, ne, K, q, Y), this.__originalTransform(V, Z, ne, K, q, Y);
              }, P.setTransform = function(V, Z, ne, K, q, Y) {
                D.setTransform(V, Z, ne, K, q, Y), this.__originalSetTransform(V, Z, ne, K, q, Y);
              }, P.resetTransform = function() {
                D.resetTransform(), this.__originalResetTransform();
              }, P.rotate = function(V) {
                D.rotate(V), this.__originalRotate(V);
              }, P.clip = function(V) {
                D.clip(V), this.__originalClip(V);
              }, P.moveTo = function(H, V) {
                D.moveTo(H, V), this.__originalMoveTo(H, V);
              }, P.lineTo = function(H, V) {
                D.lineTo(H, V), this.__originalLineTo(H, V);
              }, P.bezierCurveTo = function(H, V, Z, ne, K, q) {
                D.bezierCurveTo(H, V, Z, ne, K, q), this.__originalBezierCurveTo(H, V, Z, ne, K, q);
              }, P.rect = function(H, V, Z, ne) {
                D.rect(H, V, Z, ne), this.__originalRect(H, V, Z, ne);
              }, P.closePath = function() {
                D.closePath(), this.__originalClosePath();
              }, P.beginPath = function() {
                D.beginPath(), this.__originalBeginPath();
              };
            }
            class w {
              constructor(D) {
                this.canvasFactory = D, this.cache = /* @__PURE__ */ Object.create(null);
              }
              getCanvas(D, H, V) {
                let Z;
                return this.cache[D] !== void 0 ? (Z = this.cache[D], this.canvasFactory.reset(Z, H, V)) : (Z = this.canvasFactory.create(H, V), this.cache[D] = Z), Z;
              }
              delete(D) {
                delete this.cache[D];
              }
              clear() {
                for (const D in this.cache) {
                  const H = this.cache[D];
                  this.canvasFactory.destroy(H), delete this.cache[D];
                }
              }
            }
            function S(P, D, H, V, Z, ne, K, q, Y, ee) {
              const [Q, J, te, ae, se, ie] = (0, d.getCurrentTransform)(P);
              if (J === 0 && te === 0) {
                const me = K * Q + se, pe = Math.round(me), be = q * ae + ie, le = Math.round(be), ve = (K + Y) * Q + se, he = Math.abs(Math.round(ve) - pe) || 1, ye = (q + ee) * ae + ie, Ce = Math.abs(Math.round(ye) - le) || 1;
                return P.setTransform(Math.sign(Q), 0, 0, Math.sign(ae), pe, le), P.drawImage(D, H, V, Z, ne, 0, 0, he, Ce), P.setTransform(Q, J, te, ae, se, ie), [he, Ce];
              }
              if (Q === 0 && ae === 0) {
                const me = q * te + se, pe = Math.round(me), be = K * J + ie, le = Math.round(be), ve = (q + ee) * te + se, he = Math.abs(Math.round(ve) - pe) || 1, ye = (K + Y) * J + ie, Ce = Math.abs(Math.round(ye) - le) || 1;
                return P.setTransform(0, Math.sign(J), Math.sign(te), 0, pe, le), P.drawImage(D, H, V, Z, ne, 0, 0, Ce, he), P.setTransform(Q, J, te, ae, se, ie), [Ce, he];
              }
              P.drawImage(D, H, V, Z, ne, K, q, Y, ee);
              const fe = Math.hypot(Q, J), ge = Math.hypot(te, ae);
              return [fe * Y, ge * ee];
            }
            function $(P) {
              const {
                width: D,
                height: H
              } = P;
              if (D > f || H > f)
                return null;
              const V = 1e3, Z = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), ne = D + 1;
              let K = new Uint8Array(ne * (H + 1)), q, Y, ee;
              const Q = D + 7 & -8;
              let J = new Uint8Array(Q * H), te = 0;
              for (const ge of P.data) {
                let me = 128;
                for (; me > 0; )
                  J[te++] = ge & me ? 0 : 255, me >>= 1;
              }
              let ae = 0;
              for (te = 0, J[te] !== 0 && (K[0] = 1, ++ae), Y = 1; Y < D; Y++)
                J[te] !== J[te + 1] && (K[Y] = J[te] ? 2 : 1, ++ae), te++;
              for (J[te] !== 0 && (K[Y] = 2, ++ae), q = 1; q < H; q++) {
                te = q * Q, ee = q * ne, J[te - Q] !== J[te] && (K[ee] = J[te] ? 1 : 8, ++ae);
                let ge = (J[te] ? 4 : 0) + (J[te - Q] ? 8 : 0);
                for (Y = 1; Y < D; Y++)
                  ge = (ge >> 2) + (J[te + 1] ? 4 : 0) + (J[te - Q + 1] ? 8 : 0), Z[ge] && (K[ee + Y] = Z[ge], ++ae), te++;
                if (J[te - Q] !== J[te] && (K[ee + Y] = J[te] ? 2 : 4, ++ae), ae > V)
                  return null;
              }
              for (te = Q * (H - 1), ee = q * ne, J[te] !== 0 && (K[ee] = 8, ++ae), Y = 1; Y < D; Y++)
                J[te] !== J[te + 1] && (K[ee + Y] = J[te] ? 4 : 8, ++ae), te++;
              if (J[te] !== 0 && (K[ee + Y] = 4, ++ae), ae > V)
                return null;
              const se = new Int32Array([0, ne, -1, 0, -ne, 0, 0, 0, 1]), ie = new Path2D();
              for (q = 0; ae && q <= H; q++) {
                let ge = q * ne;
                const me = ge + D;
                for (; ge < me && !K[ge]; )
                  ge++;
                if (ge === me)
                  continue;
                ie.moveTo(ge % ne, q);
                const pe = ge;
                let be = K[ge];
                do {
                  const le = se[be];
                  do
                    ge += le;
                  while (!K[ge]);
                  const ve = K[ge];
                  ve !== 5 && ve !== 10 ? (be = ve, K[ge] = 0) : (be = ve & 51 * be >> 4, K[ge] &= be >> 2 | be << 2), ie.lineTo(ge % ne, ge / ne | 0), K[ge] || --ae;
                } while (pe !== ge);
                --q;
              }
              return J = null, K = null, function(ge) {
                ge.save(), ge.scale(1 / D, -1 / H), ge.translate(0, -H), ge.fill(ie), ge.beginPath(), ge.restore();
              };
            }
            class T {
              constructor(D, H) {
                this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = u.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = u.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = u.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = "none", this.startNewPathAndClipBox([0, 0, D, H]);
              }
              clone() {
                const D = Object.create(this);
                return D.clipBox = this.clipBox.slice(), D;
              }
              setCurrentPoint(D, H) {
                this.x = D, this.y = H;
              }
              updatePathMinMax(D, H, V) {
                [H, V] = u.Util.applyTransform([H, V], D), this.minX = Math.min(this.minX, H), this.minY = Math.min(this.minY, V), this.maxX = Math.max(this.maxX, H), this.maxY = Math.max(this.maxY, V);
              }
              updateRectMinMax(D, H) {
                const V = u.Util.applyTransform(H, D), Z = u.Util.applyTransform(H.slice(2), D);
                this.minX = Math.min(this.minX, V[0], Z[0]), this.minY = Math.min(this.minY, V[1], Z[1]), this.maxX = Math.max(this.maxX, V[0], Z[0]), this.maxY = Math.max(this.maxY, V[1], Z[1]);
              }
              updateScalingPathMinMax(D, H) {
                u.Util.scaleMinMax(D, H), this.minX = Math.min(this.minX, H[0]), this.maxX = Math.max(this.maxX, H[1]), this.minY = Math.min(this.minY, H[2]), this.maxY = Math.max(this.maxY, H[3]);
              }
              updateCurvePathMinMax(D, H, V, Z, ne, K, q, Y, ee, Q) {
                const J = u.Util.bezierBoundingBox(H, V, Z, ne, K, q, Y, ee);
                if (Q) {
                  Q[0] = Math.min(Q[0], J[0], J[2]), Q[1] = Math.max(Q[1], J[0], J[2]), Q[2] = Math.min(Q[2], J[1], J[3]), Q[3] = Math.max(Q[3], J[1], J[3]);
                  return;
                }
                this.updateRectMinMax(D, J);
              }
              getPathBoundingBox(D = p.PathType.FILL, H = null) {
                const V = [this.minX, this.minY, this.maxX, this.maxY];
                if (D === p.PathType.STROKE) {
                  H || (0, u.unreachable)("Stroke bounding box must include transform.");
                  const Z = u.Util.singularValueDecompose2dScale(H), ne = Z[0] * this.lineWidth / 2, K = Z[1] * this.lineWidth / 2;
                  V[0] -= ne, V[1] -= K, V[2] += ne, V[3] += K;
                }
                return V;
              }
              updateClipFromPath() {
                const D = u.Util.intersect(this.clipBox, this.getPathBoundingBox());
                this.startNewPathAndClipBox(D || [0, 0, 0, 0]);
              }
              isEmptyClip() {
                return this.minX === 1 / 0;
              }
              startNewPathAndClipBox(D) {
                this.clipBox = D, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
              }
              getClippedPathBoundingBox(D = p.PathType.FILL, H = null) {
                return u.Util.intersect(this.clipBox, this.getPathBoundingBox(D, H));
              }
            }
            function I(P, D) {
              if (typeof ImageData < "u" && D instanceof ImageData) {
                P.putImageData(D, 0, 0);
                return;
              }
              const H = D.height, V = D.width, Z = H % m, ne = (H - Z) / m, K = Z === 0 ? ne : ne + 1, q = P.createImageData(V, m);
              let Y = 0, ee;
              const Q = D.data, J = q.data;
              let te, ae, se, ie;
              if (D.kind === u.ImageKind.GRAYSCALE_1BPP) {
                const fe = Q.byteLength, ge = new Uint32Array(J.buffer, 0, J.byteLength >> 2), me = ge.length, pe = V + 7 >> 3, be = 4294967295, le = u.FeatureTest.isLittleEndian ? 4278190080 : 255;
                for (te = 0; te < K; te++) {
                  for (se = te < ne ? m : Z, ee = 0, ae = 0; ae < se; ae++) {
                    const ve = fe - Y;
                    let he = 0;
                    const ye = ve > pe ? V : ve * 8 - 7, Ce = ye & -8;
                    let xe = 0, we = 0;
                    for (; he < Ce; he += 8)
                      we = Q[Y++], ge[ee++] = we & 128 ? be : le, ge[ee++] = we & 64 ? be : le, ge[ee++] = we & 32 ? be : le, ge[ee++] = we & 16 ? be : le, ge[ee++] = we & 8 ? be : le, ge[ee++] = we & 4 ? be : le, ge[ee++] = we & 2 ? be : le, ge[ee++] = we & 1 ? be : le;
                    for (; he < ye; he++)
                      xe === 0 && (we = Q[Y++], xe = 128), ge[ee++] = we & xe ? be : le, xe >>= 1;
                  }
                  for (; ee < me; )
                    ge[ee++] = 0;
                  P.putImageData(q, 0, te * m);
                }
              } else if (D.kind === u.ImageKind.RGBA_32BPP) {
                for (ae = 0, ie = V * m * 4, te = 0; te < ne; te++)
                  J.set(Q.subarray(Y, Y + ie)), Y += ie, P.putImageData(q, 0, ae), ae += m;
                te < K && (ie = V * Z * 4, J.set(Q.subarray(Y, Y + ie)), P.putImageData(q, 0, ae));
              } else if (D.kind === u.ImageKind.RGB_24BPP)
                for (se = m, ie = V * se, te = 0; te < K; te++) {
                  for (te >= ne && (se = Z, ie = V * se), ee = 0, ae = ie; ae--; )
                    J[ee++] = Q[Y++], J[ee++] = Q[Y++], J[ee++] = Q[Y++], J[ee++] = 255;
                  P.putImageData(q, 0, te * m);
                }
              else
                throw new Error(`bad image kind: ${D.kind}`);
            }
            function _(P, D) {
              if (D.bitmap) {
                P.drawImage(D.bitmap, 0, 0);
                return;
              }
              const H = D.height, V = D.width, Z = H % m, ne = (H - Z) / m, K = Z === 0 ? ne : ne + 1, q = P.createImageData(V, m);
              let Y = 0;
              const ee = D.data, Q = q.data;
              for (let J = 0; J < K; J++) {
                const te = J < ne ? m : Z;
                ({
                  srcPos: Y
                } = (0, v.convertBlackAndWhiteToRGBA)({
                  src: ee,
                  srcPos: Y,
                  dest: Q,
                  width: V,
                  height: te,
                  nonBlackColor: 0
                })), P.putImageData(q, 0, J * m);
              }
            }
            function E(P, D) {
              const H = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
              for (const V of H)
                P[V] !== void 0 && (D[V] = P[V]);
              P.setLineDash !== void 0 && (D.setLineDash(P.getLineDash()), D.lineDashOffset = P.lineDashOffset);
            }
            function R(P) {
              if (P.strokeStyle = P.fillStyle = "#000000", P.fillRule = "nonzero", P.globalAlpha = 1, P.lineWidth = 1, P.lineCap = "butt", P.lineJoin = "miter", P.miterLimit = 10, P.globalCompositeOperation = "source-over", P.font = "10px sans-serif", P.setLineDash !== void 0 && (P.setLineDash([]), P.lineDashOffset = 0), !u.isNodeJS) {
                const {
                  filter: D
                } = P;
                D !== "none" && D !== "" && (P.filter = "none");
              }
            }
            function O(P, D, H, V) {
              const Z = P.length;
              for (let ne = 3; ne < Z; ne += 4) {
                const K = P[ne];
                if (K === 0)
                  P[ne - 3] = D, P[ne - 2] = H, P[ne - 1] = V;
                else if (K < 255) {
                  const q = 255 - K;
                  P[ne - 3] = P[ne - 3] * K + D * q >> 8, P[ne - 2] = P[ne - 2] * K + H * q >> 8, P[ne - 1] = P[ne - 1] * K + V * q >> 8;
                }
              }
            }
            function L(P, D, H) {
              const V = P.length, Z = 1 / 255;
              for (let ne = 3; ne < V; ne += 4) {
                const K = H ? H[P[ne]] : P[ne];
                D[ne] = D[ne] * K * Z | 0;
              }
            }
            function B(P, D, H) {
              const V = P.length;
              for (let Z = 3; Z < V; Z += 4) {
                const ne = P[Z - 3] * 77 + P[Z - 2] * 152 + P[Z - 1] * 28;
                D[Z] = H ? D[Z] * H[ne >> 8] >> 8 : D[Z] * ne >> 16;
              }
            }
            function F(P, D, H, V, Z, ne, K, q, Y, ee, Q) {
              const J = !!ne, te = J ? ne[0] : 0, ae = J ? ne[1] : 0, se = J ? ne[2] : 0, ie = Z === "Luminosity" ? B : L, ge = Math.min(V, Math.ceil(1048576 / H));
              for (let me = 0; me < V; me += ge) {
                const pe = Math.min(ge, V - me), be = P.getImageData(q - ee, me + (Y - Q), H, pe), le = D.getImageData(q, me + Y, H, pe);
                J && O(be.data, te, ae, se), ie(be.data, le.data, K), D.putImageData(le, q, me + Y);
              }
            }
            function M(P, D, H, V) {
              const Z = V[0], ne = V[1], K = V[2] - Z, q = V[3] - ne;
              K === 0 || q === 0 || (F(D.context, H, K, q, D.subtype, D.backdrop, D.transferMap, Z, ne, D.offsetX, D.offsetY), P.save(), P.globalAlpha = 1, P.globalCompositeOperation = "source-over", P.setTransform(1, 0, 0, 1, 0, 0), P.drawImage(H.canvas, 0, 0), P.restore());
            }
            function W(P, D) {
              const H = u.Util.singularValueDecompose2dScale(P);
              H[0] = Math.fround(H[0]), H[1] = Math.fround(H[1]);
              const V = Math.fround((globalThis.devicePixelRatio || 1) * d.PixelsPerInch.PDF_TO_CSS_UNITS);
              return D !== void 0 ? D : H[0] <= V || H[1] <= V;
            }
            const j = ["butt", "round", "square"], G = ["miter", "round", "bevel"], U = {}, k = {};
            class N {
              constructor(D, H, V, Z, ne, {
                optionalContentConfig: K,
                markedContentStack: q = null
              }, Y, ee) {
                this.ctx = D, this.current = new T(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = H, this.objs = V, this.canvasFactory = Z, this.filterFactory = ne, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = q || [], this.optionalContentConfig = K, this.cachedCanvases = new w(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = Y, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.pageColors = ee, this._cachedScaleForStroking = [-1, 0], this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
              }
              getObject(D, H = null) {
                return typeof D == "string" ? D.startsWith("g_") ? this.commonObjs.get(D) : this.objs.get(D) : H;
              }
              beginDrawing({
                transform: D,
                viewport: H,
                transparency: V = !1,
                background: Z = null
              }) {
                const ne = this.ctx.canvas.width, K = this.ctx.canvas.height, q = this.ctx.fillStyle;
                if (this.ctx.fillStyle = Z || "#ffffff", this.ctx.fillRect(0, 0, ne, K), this.ctx.fillStyle = q, V) {
                  const Y = this.cachedCanvases.getCanvas("transparent", ne, K);
                  this.compositeCtx = this.ctx, this.transparentCanvas = Y.canvas, this.ctx = Y.context, this.ctx.save(), this.ctx.transform(...(0, d.getCurrentTransform)(this.compositeCtx));
                }
                this.ctx.save(), R(this.ctx), D && (this.ctx.transform(...D), this.outputScaleX = D[0], this.outputScaleY = D[0]), this.ctx.transform(...H.transform), this.viewportScale = H.scale, this.baseTransform = (0, d.getCurrentTransform)(this.ctx);
              }
              executeOperatorList(D, H, V, Z) {
                const ne = D.argsArray, K = D.fnArray;
                let q = H || 0;
                const Y = ne.length;
                if (Y === q)
                  return q;
                const ee = Y - q > y && typeof V == "function", Q = ee ? Date.now() + b : 0;
                let J = 0;
                const te = this.commonObjs, ae = this.objs;
                let se;
                for (; ; ) {
                  if (Z !== void 0 && q === Z.nextBreakPoint)
                    return Z.breakIt(q, V), q;
                  if (se = K[q], se !== u.OPS.dependency)
                    this[se].apply(this, ne[q]);
                  else
                    for (const ie of ne[q]) {
                      const fe = ie.startsWith("g_") ? te : ae;
                      if (!fe.has(ie))
                        return fe.get(ie, V), q;
                    }
                  if (q++, q === Y)
                    return q;
                  if (ee && ++J > y) {
                    if (Date.now() > Q)
                      return V(), q;
                    J = 0;
                  }
                }
              }
              #e() {
                for (; this.stateStack.length || this.inSMaskMode; )
                  this.restore();
                this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
              }
              endDrawing() {
                this.#e(), this.cachedCanvases.clear(), this.cachedPatterns.clear();
                for (const D of this._cachedBitmapsMap.values()) {
                  for (const H of D.values())
                    typeof HTMLCanvasElement < "u" && H instanceof HTMLCanvasElement && (H.width = H.height = 0);
                  D.clear();
                }
                this._cachedBitmapsMap.clear(), this.#t();
              }
              #t() {
                if (this.pageColors) {
                  const D = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                  if (D !== "none") {
                    const H = this.ctx.filter;
                    this.ctx.filter = D, this.ctx.drawImage(this.ctx.canvas, 0, 0), this.ctx.filter = H;
                  }
                }
              }
              _scaleImage(D, H) {
                const V = D.width, Z = D.height;
                let ne = Math.max(Math.hypot(H[0], H[1]), 1), K = Math.max(Math.hypot(H[2], H[3]), 1), q = V, Y = Z, ee = "prescale1", Q, J;
                for (; ne > 2 && q > 1 || K > 2 && Y > 1; ) {
                  let te = q, ae = Y;
                  ne > 2 && q > 1 && (te = q >= 16384 ? Math.floor(q / 2) - 1 || 1 : Math.ceil(q / 2), ne /= q / te), K > 2 && Y > 1 && (ae = Y >= 16384 ? Math.floor(Y / 2) - 1 || 1 : Math.ceil(Y) / 2, K /= Y / ae), Q = this.cachedCanvases.getCanvas(ee, te, ae), J = Q.context, J.clearRect(0, 0, te, ae), J.drawImage(D, 0, 0, q, Y, 0, 0, te, ae), D = Q.canvas, q = te, Y = ae, ee = ee === "prescale1" ? "prescale2" : "prescale1";
                }
                return {
                  img: D,
                  paintWidth: q,
                  paintHeight: Y
                };
              }
              _createMaskCanvas(D) {
                const H = this.ctx, {
                  width: V,
                  height: Z
                } = D, ne = this.current.fillColor, K = this.current.patternFill, q = (0, d.getCurrentTransform)(H);
                let Y, ee, Q, J;
                if ((D.bitmap || D.data) && D.count > 1) {
                  const he = D.bitmap || D.data.buffer;
                  ee = JSON.stringify(K ? q : [q.slice(0, 4), ne]), Y = this._cachedBitmapsMap.get(he), Y || (Y = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(he, Y));
                  const ye = Y.get(ee);
                  if (ye && !K) {
                    const Ce = Math.round(Math.min(q[0], q[2]) + q[4]), xe = Math.round(Math.min(q[1], q[3]) + q[5]);
                    return {
                      canvas: ye,
                      offsetX: Ce,
                      offsetY: xe
                    };
                  }
                  Q = ye;
                }
                Q || (J = this.cachedCanvases.getCanvas("maskCanvas", V, Z), _(J.context, D));
                let te = u.Util.transform(q, [1 / V, 0, 0, -1 / Z, 0, 0]);
                te = u.Util.transform(te, [1, 0, 0, 1, 0, -Z]);
                const ae = u.Util.applyTransform([0, 0], te), se = u.Util.applyTransform([V, Z], te), ie = u.Util.normalizeRect([ae[0], ae[1], se[0], se[1]]), fe = Math.round(ie[2] - ie[0]) || 1, ge = Math.round(ie[3] - ie[1]) || 1, me = this.cachedCanvases.getCanvas("fillCanvas", fe, ge), pe = me.context, be = Math.min(ae[0], se[0]), le = Math.min(ae[1], se[1]);
                pe.translate(-be, -le), pe.transform(...te), Q || (Q = this._scaleImage(J.canvas, (0, d.getCurrentTransformInverse)(pe)), Q = Q.img, Y && K && Y.set(ee, Q)), pe.imageSmoothingEnabled = W((0, d.getCurrentTransform)(pe), D.interpolate), S(pe, Q, 0, 0, Q.width, Q.height, 0, 0, V, Z), pe.globalCompositeOperation = "source-in";
                const ve = u.Util.transform((0, d.getCurrentTransformInverse)(pe), [1, 0, 0, 1, -be, -le]);
                return pe.fillStyle = K ? ne.getPattern(H, this, ve, p.PathType.FILL) : ne, pe.fillRect(0, 0, V, Z), Y && !K && (this.cachedCanvases.delete("fillCanvas"), Y.set(ee, me.canvas)), {
                  canvas: me.canvas,
                  offsetX: Math.round(be),
                  offsetY: Math.round(le)
                };
              }
              setLineWidth(D) {
                D !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1), this.current.lineWidth = D, this.ctx.lineWidth = D;
              }
              setLineCap(D) {
                this.ctx.lineCap = j[D];
              }
              setLineJoin(D) {
                this.ctx.lineJoin = G[D];
              }
              setMiterLimit(D) {
                this.ctx.miterLimit = D;
              }
              setDash(D, H) {
                const V = this.ctx;
                V.setLineDash !== void 0 && (V.setLineDash(D), V.lineDashOffset = H);
              }
              setRenderingIntent(D) {
              }
              setFlatness(D) {
              }
              setGState(D) {
                for (const [H, V] of D)
                  switch (H) {
                    case "LW":
                      this.setLineWidth(V);
                      break;
                    case "LC":
                      this.setLineCap(V);
                      break;
                    case "LJ":
                      this.setLineJoin(V);
                      break;
                    case "ML":
                      this.setMiterLimit(V);
                      break;
                    case "D":
                      this.setDash(V[0], V[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(V);
                      break;
                    case "FL":
                      this.setFlatness(V);
                      break;
                    case "Font":
                      this.setFont(V[0], V[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = V;
                      break;
                    case "ca":
                      this.current.fillAlpha = V, this.ctx.globalAlpha = V;
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = V;
                      break;
                    case "SMask":
                      this.current.activeSMask = V ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
                      break;
                    case "TR":
                      this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(V);
                      break;
                  }
              }
              get inSMaskMode() {
                return !!this.suspendedCtx;
              }
              checkSMaskState() {
                const D = this.inSMaskMode;
                this.current.activeSMask && !D ? this.beginSMaskMode() : !this.current.activeSMask && D && this.endSMaskMode();
              }
              beginSMaskMode() {
                if (this.inSMaskMode)
                  throw new Error("beginSMaskMode called while already in smask mode");
                const D = this.ctx.canvas.width, H = this.ctx.canvas.height, V = "smaskGroupAt" + this.groupLevel, Z = this.cachedCanvases.getCanvas(V, D, H);
                this.suspendedCtx = this.ctx, this.ctx = Z.context;
                const ne = this.ctx;
                ne.setTransform(...(0, d.getCurrentTransform)(this.suspendedCtx)), E(this.suspendedCtx, ne), C(ne, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
              }
              endSMaskMode() {
                if (!this.inSMaskMode)
                  throw new Error("endSMaskMode called while not in smask mode");
                this.ctx._removeMirroring(), E(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
              }
              compose(D) {
                if (!this.current.activeSMask)
                  return;
                D ? (D[0] = Math.floor(D[0]), D[1] = Math.floor(D[1]), D[2] = Math.ceil(D[2]), D[3] = Math.ceil(D[3])) : D = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
                const H = this.current.activeSMask, V = this.suspendedCtx;
                M(V, H, this.ctx, D), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
              }
              save() {
                this.inSMaskMode ? (E(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
                const D = this.current;
                this.stateStack.push(D), this.current = D.clone();
              }
              restore() {
                this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), E(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null);
              }
              transform(D, H, V, Z, ne, K) {
                this.ctx.transform(D, H, V, Z, ne, K), this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
              }
              constructPath(D, H, V) {
                const Z = this.ctx, ne = this.current;
                let K = ne.x, q = ne.y, Y, ee;
                const Q = (0, d.getCurrentTransform)(Z), J = Q[0] === 0 && Q[3] === 0 || Q[1] === 0 && Q[2] === 0, te = J ? V.slice(0) : null;
                for (let ae = 0, se = 0, ie = D.length; ae < ie; ae++)
                  switch (D[ae] | 0) {
                    case u.OPS.rectangle:
                      K = H[se++], q = H[se++];
                      const fe = H[se++], ge = H[se++], me = K + fe, pe = q + ge;
                      Z.moveTo(K, q), fe === 0 || ge === 0 ? Z.lineTo(me, pe) : (Z.lineTo(me, q), Z.lineTo(me, pe), Z.lineTo(K, pe)), J || ne.updateRectMinMax(Q, [K, q, me, pe]), Z.closePath();
                      break;
                    case u.OPS.moveTo:
                      K = H[se++], q = H[se++], Z.moveTo(K, q), J || ne.updatePathMinMax(Q, K, q);
                      break;
                    case u.OPS.lineTo:
                      K = H[se++], q = H[se++], Z.lineTo(K, q), J || ne.updatePathMinMax(Q, K, q);
                      break;
                    case u.OPS.curveTo:
                      Y = K, ee = q, K = H[se + 4], q = H[se + 5], Z.bezierCurveTo(H[se], H[se + 1], H[se + 2], H[se + 3], K, q), ne.updateCurvePathMinMax(Q, Y, ee, H[se], H[se + 1], H[se + 2], H[se + 3], K, q, te), se += 6;
                      break;
                    case u.OPS.curveTo2:
                      Y = K, ee = q, Z.bezierCurveTo(K, q, H[se], H[se + 1], H[se + 2], H[se + 3]), ne.updateCurvePathMinMax(Q, Y, ee, K, q, H[se], H[se + 1], H[se + 2], H[se + 3], te), K = H[se + 2], q = H[se + 3], se += 4;
                      break;
                    case u.OPS.curveTo3:
                      Y = K, ee = q, K = H[se + 2], q = H[se + 3], Z.bezierCurveTo(H[se], H[se + 1], K, q, K, q), ne.updateCurvePathMinMax(Q, Y, ee, H[se], H[se + 1], K, q, K, q, te), se += 4;
                      break;
                    case u.OPS.closePath:
                      Z.closePath();
                      break;
                  }
                J && ne.updateScalingPathMinMax(Q, te), ne.setCurrentPoint(K, q);
              }
              closePath() {
                this.ctx.closePath();
              }
              stroke(D = !0) {
                const H = this.ctx, V = this.current.strokeColor;
                H.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof V == "object" && V?.getPattern ? (H.save(), H.strokeStyle = V.getPattern(H, this, (0, d.getCurrentTransformInverse)(H), p.PathType.STROKE), this.rescaleAndStroke(!1), H.restore()) : this.rescaleAndStroke(!0)), D && this.consumePath(this.current.getClippedPathBoundingBox()), H.globalAlpha = this.current.fillAlpha;
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              fill(D = !0) {
                const H = this.ctx, V = this.current.fillColor, Z = this.current.patternFill;
                let ne = !1;
                Z && (H.save(), H.fillStyle = V.getPattern(H, this, (0, d.getCurrentTransformInverse)(H), p.PathType.FILL), ne = !0);
                const K = this.current.getClippedPathBoundingBox();
                this.contentVisible && K !== null && (this.pendingEOFill ? (H.fill("evenodd"), this.pendingEOFill = !1) : H.fill()), ne && H.restore(), D && this.consumePath(K);
              }
              eoFill() {
                this.pendingEOFill = !0, this.fill();
              }
              fillStroke() {
                this.fill(!1), this.stroke(!1), this.consumePath();
              }
              eoFillStroke() {
                this.pendingEOFill = !0, this.fillStroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.pendingEOFill = !0, this.closePath(), this.fillStroke();
              }
              endPath() {
                this.consumePath();
              }
              clip() {
                this.pendingClip = U;
              }
              eoClip() {
                this.pendingClip = k;
              }
              beginText() {
                this.current.textMatrix = u.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              endText() {
                const D = this.pendingTextPaths, H = this.ctx;
                if (D === void 0) {
                  H.beginPath();
                  return;
                }
                H.save(), H.beginPath();
                for (const V of D)
                  H.setTransform(...V.transform), H.translate(V.x, V.y), V.addToPath(H, V.fontSize);
                H.restore(), H.clip(), H.beginPath(), delete this.pendingTextPaths;
              }
              setCharSpacing(D) {
                this.current.charSpacing = D;
              }
              setWordSpacing(D) {
                this.current.wordSpacing = D;
              }
              setHScale(D) {
                this.current.textHScale = D / 100;
              }
              setLeading(D) {
                this.current.leading = -D;
              }
              setFont(D, H) {
                const V = this.commonObjs.get(D), Z = this.current;
                if (!V)
                  throw new Error(`Can't find font for ${D}`);
                if (Z.fontMatrix = V.fontMatrix || u.FONT_IDENTITY_MATRIX, (Z.fontMatrix[0] === 0 || Z.fontMatrix[3] === 0) && (0, u.warn)("Invalid font matrix for font " + D), H < 0 ? (H = -H, Z.fontDirection = -1) : Z.fontDirection = 1, this.current.font = V, this.current.fontSize = H, V.isType3Font)
                  return;
                const ne = V.loadedName || "sans-serif", K = V.systemFontInfo?.css || `"${ne}", ${V.fallbackName}`;
                let q = "normal";
                V.black ? q = "900" : V.bold && (q = "bold");
                const Y = V.italic ? "italic" : "normal";
                let ee = H;
                H < A ? ee = A : H > x && (ee = x), this.current.fontSizeScale = H / ee, this.ctx.font = `${Y} ${q} ${ee}px ${K}`;
              }
              setTextRenderingMode(D) {
                this.current.textRenderingMode = D;
              }
              setTextRise(D) {
                this.current.textRise = D;
              }
              moveText(D, H) {
                this.current.x = this.current.lineX += D, this.current.y = this.current.lineY += H;
              }
              setLeadingMoveText(D, H) {
                this.setLeading(-H), this.moveText(D, H);
              }
              setTextMatrix(D, H, V, Z, ne, K) {
                this.current.textMatrix = [D, H, V, Z, ne, K], this.current.textMatrixScale = Math.hypot(D, H), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              paintChar(D, H, V, Z) {
                const ne = this.ctx, K = this.current, q = K.font, Y = K.textRenderingMode, ee = K.fontSize / K.fontSizeScale, Q = Y & u.TextRenderingMode.FILL_STROKE_MASK, J = !!(Y & u.TextRenderingMode.ADD_TO_PATH_FLAG), te = K.patternFill && !q.missingFile;
                let ae;
                (q.disableFontFace || J || te) && (ae = q.getPathGenerator(this.commonObjs, D)), q.disableFontFace || te ? (ne.save(), ne.translate(H, V), ne.beginPath(), ae(ne, ee), Z && ne.setTransform(...Z), (Q === u.TextRenderingMode.FILL || Q === u.TextRenderingMode.FILL_STROKE) && ne.fill(), (Q === u.TextRenderingMode.STROKE || Q === u.TextRenderingMode.FILL_STROKE) && ne.stroke(), ne.restore()) : ((Q === u.TextRenderingMode.FILL || Q === u.TextRenderingMode.FILL_STROKE) && ne.fillText(D, H, V), (Q === u.TextRenderingMode.STROKE || Q === u.TextRenderingMode.FILL_STROKE) && ne.strokeText(D, H, V)), J && (this.pendingTextPaths ||= []).push({
                  transform: (0, d.getCurrentTransform)(ne),
                  x: H,
                  y: V,
                  fontSize: ee,
                  addToPath: ae
                });
              }
              get isFontSubpixelAAEnabled() {
                const {
                  context: D
                } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                D.scale(1.5, 1), D.fillText("I", 0, 10);
                const H = D.getImageData(0, 0, 10, 10).data;
                let V = !1;
                for (let Z = 3; Z < H.length; Z += 4)
                  if (H[Z] > 0 && H[Z] < 255) {
                    V = !0;
                    break;
                  }
                return (0, u.shadow)(this, "isFontSubpixelAAEnabled", V);
              }
              showText(D) {
                const H = this.current, V = H.font;
                if (V.isType3Font)
                  return this.showType3Text(D);
                const Z = H.fontSize;
                if (Z === 0)
                  return;
                const ne = this.ctx, K = H.fontSizeScale, q = H.charSpacing, Y = H.wordSpacing, ee = H.fontDirection, Q = H.textHScale * ee, J = D.length, te = V.vertical, ae = te ? 1 : -1, se = V.defaultVMetrics, ie = Z * H.fontMatrix[0], fe = H.textRenderingMode === u.TextRenderingMode.FILL && !V.disableFontFace && !H.patternFill;
                ne.save(), ne.transform(...H.textMatrix), ne.translate(H.x, H.y + H.textRise), ee > 0 ? ne.scale(Q, -1) : ne.scale(Q, 1);
                let ge;
                if (H.patternFill) {
                  ne.save();
                  const ve = H.fillColor.getPattern(ne, this, (0, d.getCurrentTransformInverse)(ne), p.PathType.FILL);
                  ge = (0, d.getCurrentTransform)(ne), ne.restore(), ne.fillStyle = ve;
                }
                let me = H.lineWidth;
                const pe = H.textMatrixScale;
                if (pe === 0 || me === 0) {
                  const ve = H.textRenderingMode & u.TextRenderingMode.FILL_STROKE_MASK;
                  (ve === u.TextRenderingMode.STROKE || ve === u.TextRenderingMode.FILL_STROKE) && (me = this.getSinglePixelWidth());
                } else
                  me /= pe;
                if (K !== 1 && (ne.scale(K, K), me /= K), ne.lineWidth = me, V.isInvalidPDFjsFont) {
                  const ve = [];
                  let he = 0;
                  for (const ye of D)
                    ve.push(ye.unicode), he += ye.width;
                  ne.fillText(ve.join(""), 0, 0), H.x += he * ie * Q, ne.restore(), this.compose();
                  return;
                }
                let be = 0, le;
                for (le = 0; le < J; ++le) {
                  const ve = D[le];
                  if (typeof ve == "number") {
                    be += ae * ve * Z / 1e3;
                    continue;
                  }
                  let he = !1;
                  const ye = (ve.isSpace ? Y : 0) + q, Ce = ve.fontChar, xe = ve.accent;
                  let we, $e, Ae = ve.width;
                  if (te) {
                    const ce = ve.vmetric || se, Ee = -(ve.vmetric ? ce[1] : Ae * 0.5) * ie, _e = ce[2] * ie;
                    Ae = ce ? -ce[0] : Ae, we = Ee / K, $e = (be + _e) / K;
                  } else
                    we = be / K, $e = 0;
                  if (V.remeasure && Ae > 0) {
                    const ce = ne.measureText(Ce).width * 1e3 / Z * K;
                    if (Ae < ce && this.isFontSubpixelAAEnabled) {
                      const Ee = Ae / ce;
                      he = !0, ne.save(), ne.scale(Ee, 1), we /= Ee;
                    } else Ae !== ce && (we += (Ae - ce) / 2e3 * Z / K);
                  }
                  if (this.contentVisible && (ve.isInFont || V.missingFile)) {
                    if (fe && !xe)
                      ne.fillText(Ce, we, $e);
                    else if (this.paintChar(Ce, we, $e, ge), xe) {
                      const ce = we + Z * xe.offset.x / K, Ee = $e - Z * xe.offset.y / K;
                      this.paintChar(xe.fontChar, ce, Ee, ge);
                    }
                  }
                  const ue = te ? Ae * ie - ye * ee : Ae * ie + ye * ee;
                  be += ue, he && ne.restore();
                }
                te ? H.y -= be : H.x += be * Q, ne.restore(), this.compose();
              }
              showType3Text(D) {
                const H = this.ctx, V = this.current, Z = V.font, ne = V.fontSize, K = V.fontDirection, q = Z.vertical ? 1 : -1, Y = V.charSpacing, ee = V.wordSpacing, Q = V.textHScale * K, J = V.fontMatrix || u.FONT_IDENTITY_MATRIX, te = D.length, ae = V.textRenderingMode === u.TextRenderingMode.INVISIBLE;
                let se, ie, fe, ge;
                if (!(ae || ne === 0)) {
                  for (this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null, H.save(), H.transform(...V.textMatrix), H.translate(V.x, V.y), H.scale(Q, K), se = 0; se < te; ++se) {
                    if (ie = D[se], typeof ie == "number") {
                      ge = q * ie * ne / 1e3, this.ctx.translate(ge, 0), V.x += ge * Q;
                      continue;
                    }
                    const me = (ie.isSpace ? ee : 0) + Y, pe = Z.charProcOperatorList[ie.operatorListId];
                    if (!pe) {
                      (0, u.warn)(`Type3 character "${ie.operatorListId}" is not available.`);
                      continue;
                    }
                    this.contentVisible && (this.processingType3 = ie, this.save(), H.scale(ne, ne), H.transform(...J), this.executeOperatorList(pe), this.restore()), fe = u.Util.applyTransform([ie.width, 0], J)[0] * ne + me, H.translate(fe, 0), V.x += fe * Q;
                  }
                  H.restore(), this.processingType3 = null;
                }
              }
              setCharWidth(D, H) {
              }
              setCharWidthAndBounds(D, H, V, Z, ne, K) {
                this.ctx.rect(V, Z, ne - V, K - Z), this.ctx.clip(), this.endPath();
              }
              getColorN_Pattern(D) {
                let H;
                if (D[0] === "TilingPattern") {
                  const V = D[1], Z = this.baseTransform || (0, d.getCurrentTransform)(this.ctx), ne = {
                    createCanvasGraphics: (K) => new N(K, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                      optionalContentConfig: this.optionalContentConfig,
                      markedContentStack: this.markedContentStack
                    })
                  };
                  H = new p.TilingPattern(D, V, this.ctx, ne, Z);
                } else
                  H = this._getPattern(D[1], D[2]);
                return H;
              }
              setStrokeColorN() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              }
              setFillColorN() {
                this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
              }
              setStrokeRGBColor(D, H, V) {
                const Z = u.Util.makeHexColor(D, H, V);
                this.ctx.strokeStyle = Z, this.current.strokeColor = Z;
              }
              setFillRGBColor(D, H, V) {
                const Z = u.Util.makeHexColor(D, H, V);
                this.ctx.fillStyle = Z, this.current.fillColor = Z, this.current.patternFill = !1;
              }
              _getPattern(D, H = null) {
                let V;
                return this.cachedPatterns.has(D) ? V = this.cachedPatterns.get(D) : (V = (0, p.getShadingPattern)(this.getObject(D)), this.cachedPatterns.set(D, V)), H && (V.matrix = H), V;
              }
              shadingFill(D) {
                if (!this.contentVisible)
                  return;
                const H = this.ctx;
                this.save();
                const V = this._getPattern(D);
                H.fillStyle = V.getPattern(H, this, (0, d.getCurrentTransformInverse)(H), p.PathType.SHADING);
                const Z = (0, d.getCurrentTransformInverse)(H);
                if (Z) {
                  const {
                    width: ne,
                    height: K
                  } = H.canvas, [q, Y, ee, Q] = u.Util.getAxialAlignedBoundingBox([0, 0, ne, K], Z);
                  this.ctx.fillRect(q, Y, ee - q, Q - Y);
                } else
                  this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                this.compose(this.current.getClippedPathBoundingBox()), this.restore();
              }
              beginInlineImage() {
                (0, u.unreachable)("Should not call beginInlineImage");
              }
              beginImageData() {
                (0, u.unreachable)("Should not call beginImageData");
              }
              paintFormXObjectBegin(D, H) {
                if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(D) && D.length === 6 && this.transform(...D), this.baseTransform = (0, d.getCurrentTransform)(this.ctx), H)) {
                  const V = H[2] - H[0], Z = H[3] - H[1];
                  this.ctx.rect(H[0], H[1], V, Z), this.current.updateRectMinMax((0, d.getCurrentTransform)(this.ctx), H), this.clip(), this.endPath();
                }
              }
              paintFormXObjectEnd() {
                this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
              }
              beginGroup(D) {
                if (!this.contentVisible)
                  return;
                this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
                const H = this.ctx;
                D.isolated || (0, u.info)("TODO: Support non-isolated groups."), D.knockout && (0, u.warn)("Knockout groups not supported.");
                const V = (0, d.getCurrentTransform)(H);
                if (D.matrix && H.transform(...D.matrix), !D.bbox)
                  throw new Error("Bounding box is required.");
                let Z = u.Util.getAxialAlignedBoundingBox(D.bbox, (0, d.getCurrentTransform)(H));
                const ne = [0, 0, H.canvas.width, H.canvas.height];
                Z = u.Util.intersect(Z, ne) || [0, 0, 0, 0];
                const K = Math.floor(Z[0]), q = Math.floor(Z[1]);
                let Y = Math.max(Math.ceil(Z[2]) - K, 1), ee = Math.max(Math.ceil(Z[3]) - q, 1), Q = 1, J = 1;
                Y > g && (Q = Y / g, Y = g), ee > g && (J = ee / g, ee = g), this.current.startNewPathAndClipBox([0, 0, Y, ee]);
                let te = "groupAt" + this.groupLevel;
                D.smask && (te += "_smask_" + this.smaskCounter++ % 2);
                const ae = this.cachedCanvases.getCanvas(te, Y, ee), se = ae.context;
                se.scale(1 / Q, 1 / J), se.translate(-K, -q), se.transform(...V), D.smask ? this.smaskStack.push({
                  canvas: ae.canvas,
                  context: se,
                  offsetX: K,
                  offsetY: q,
                  scaleX: Q,
                  scaleY: J,
                  subtype: D.smask.subtype,
                  backdrop: D.smask.backdrop,
                  transferMap: D.smask.transferMap || null,
                  startTransformInverse: null
                }) : (H.setTransform(1, 0, 0, 1, 0, 0), H.translate(K, q), H.scale(Q, J), H.save()), E(H, se), this.ctx = se, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(H), this.groupLevel++;
              }
              endGroup(D) {
                if (!this.contentVisible)
                  return;
                this.groupLevel--;
                const H = this.ctx, V = this.groupStack.pop();
                if (this.ctx = V, this.ctx.imageSmoothingEnabled = !1, D.smask)
                  this.tempSMask = this.smaskStack.pop(), this.restore();
                else {
                  this.ctx.restore();
                  const Z = (0, d.getCurrentTransform)(this.ctx);
                  this.restore(), this.ctx.save(), this.ctx.setTransform(...Z);
                  const ne = u.Util.getAxialAlignedBoundingBox([0, 0, H.canvas.width, H.canvas.height], Z);
                  this.ctx.drawImage(H.canvas, 0, 0), this.ctx.restore(), this.compose(ne);
                }
              }
              beginAnnotation(D, H, V, Z, ne) {
                if (this.#e(), R(this.ctx), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Array.isArray(H) && H.length === 4) {
                  const K = H[2] - H[0], q = H[3] - H[1];
                  if (ne && this.annotationCanvasMap) {
                    V = V.slice(), V[4] -= H[0], V[5] -= H[1], H = H.slice(), H[0] = H[1] = 0, H[2] = K, H[3] = q;
                    const [Y, ee] = u.Util.singularValueDecompose2dScale((0, d.getCurrentTransform)(this.ctx)), {
                      viewportScale: Q
                    } = this, J = Math.ceil(K * this.outputScaleX * Q), te = Math.ceil(q * this.outputScaleY * Q);
                    this.annotationCanvas = this.canvasFactory.create(J, te);
                    const {
                      canvas: ae,
                      context: se
                    } = this.annotationCanvas;
                    this.annotationCanvasMap.set(D, ae), this.annotationCanvas.savedCtx = this.ctx, this.ctx = se, this.ctx.save(), this.ctx.setTransform(Y, 0, 0, -ee, 0, q * ee), R(this.ctx);
                  } else
                    R(this.ctx), this.ctx.rect(H[0], H[1], K, q), this.ctx.clip(), this.endPath();
                }
                this.current = new T(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...V), this.transform(...Z);
              }
              endAnnotation() {
                this.annotationCanvas && (this.ctx.restore(), this.#t(), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
              }
              paintImageMaskXObject(D) {
                if (!this.contentVisible)
                  return;
                const H = D.count;
                D = this.getObject(D.data, D), D.count = H;
                const V = this.ctx, Z = this.processingType3;
                if (Z && (Z.compiled === void 0 && (Z.compiled = $(D)), Z.compiled)) {
                  Z.compiled(V);
                  return;
                }
                const ne = this._createMaskCanvas(D), K = ne.canvas;
                V.save(), V.setTransform(1, 0, 0, 1, 0, 0), V.drawImage(K, ne.offsetX, ne.offsetY), V.restore(), this.compose();
              }
              paintImageMaskXObjectRepeat(D, H, V = 0, Z = 0, ne, K) {
                if (!this.contentVisible)
                  return;
                D = this.getObject(D.data, D);
                const q = this.ctx;
                q.save();
                const Y = (0, d.getCurrentTransform)(q);
                q.transform(H, V, Z, ne, 0, 0);
                const ee = this._createMaskCanvas(D);
                q.setTransform(1, 0, 0, 1, ee.offsetX - Y[4], ee.offsetY - Y[5]);
                for (let Q = 0, J = K.length; Q < J; Q += 2) {
                  const te = u.Util.transform(Y, [H, V, Z, ne, K[Q], K[Q + 1]]), [ae, se] = u.Util.applyTransform([0, 0], te);
                  q.drawImage(ee.canvas, ae, se);
                }
                q.restore(), this.compose();
              }
              paintImageMaskXObjectGroup(D) {
                if (!this.contentVisible)
                  return;
                const H = this.ctx, V = this.current.fillColor, Z = this.current.patternFill;
                for (const ne of D) {
                  const {
                    data: K,
                    width: q,
                    height: Y,
                    transform: ee
                  } = ne, Q = this.cachedCanvases.getCanvas("maskCanvas", q, Y), J = Q.context;
                  J.save();
                  const te = this.getObject(K, ne);
                  _(J, te), J.globalCompositeOperation = "source-in", J.fillStyle = Z ? V.getPattern(J, this, (0, d.getCurrentTransformInverse)(H), p.PathType.FILL) : V, J.fillRect(0, 0, q, Y), J.restore(), H.save(), H.transform(...ee), H.scale(1, -1), S(H, Q.canvas, 0, 0, q, Y, 0, -1, 1, 1), H.restore();
                }
                this.compose();
              }
              paintImageXObject(D) {
                if (!this.contentVisible)
                  return;
                const H = this.getObject(D);
                if (!H) {
                  (0, u.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(H);
              }
              paintImageXObjectRepeat(D, H, V, Z) {
                if (!this.contentVisible)
                  return;
                const ne = this.getObject(D);
                if (!ne) {
                  (0, u.warn)("Dependent image isn't ready yet");
                  return;
                }
                const K = ne.width, q = ne.height, Y = [];
                for (let ee = 0, Q = Z.length; ee < Q; ee += 2)
                  Y.push({
                    transform: [H, 0, 0, V, Z[ee], Z[ee + 1]],
                    x: 0,
                    y: 0,
                    w: K,
                    h: q
                  });
                this.paintInlineImageXObjectGroup(ne, Y);
              }
              applyTransferMapsToCanvas(D) {
                return this.current.transferMaps !== "none" && (D.filter = this.current.transferMaps, D.drawImage(D.canvas, 0, 0), D.filter = "none"), D.canvas;
              }
              applyTransferMapsToBitmap(D) {
                if (this.current.transferMaps === "none")
                  return D.bitmap;
                const {
                  bitmap: H,
                  width: V,
                  height: Z
                } = D, ne = this.cachedCanvases.getCanvas("inlineImage", V, Z), K = ne.context;
                return K.filter = this.current.transferMaps, K.drawImage(H, 0, 0), K.filter = "none", ne.canvas;
              }
              paintInlineImageXObject(D) {
                if (!this.contentVisible)
                  return;
                const H = D.width, V = D.height, Z = this.ctx;
                if (this.save(), !u.isNodeJS) {
                  const {
                    filter: q
                  } = Z;
                  q !== "none" && q !== "" && (Z.filter = "none");
                }
                Z.scale(1 / H, -1 / V);
                let ne;
                if (D.bitmap)
                  ne = this.applyTransferMapsToBitmap(D);
                else if (typeof HTMLElement == "function" && D instanceof HTMLElement || !D.data)
                  ne = D;
                else {
                  const Y = this.cachedCanvases.getCanvas("inlineImage", H, V).context;
                  I(Y, D), ne = this.applyTransferMapsToCanvas(Y);
                }
                const K = this._scaleImage(ne, (0, d.getCurrentTransformInverse)(Z));
                Z.imageSmoothingEnabled = W((0, d.getCurrentTransform)(Z), D.interpolate), S(Z, K.img, 0, 0, K.paintWidth, K.paintHeight, 0, -V, H, V), this.compose(), this.restore();
              }
              paintInlineImageXObjectGroup(D, H) {
                if (!this.contentVisible)
                  return;
                const V = this.ctx;
                let Z;
                if (D.bitmap)
                  Z = D.bitmap;
                else {
                  const ne = D.width, K = D.height, Y = this.cachedCanvases.getCanvas("inlineImage", ne, K).context;
                  I(Y, D), Z = this.applyTransferMapsToCanvas(Y);
                }
                for (const ne of H)
                  V.save(), V.transform(...ne.transform), V.scale(1, -1), S(V, Z, ne.x, ne.y, ne.w, ne.h, 0, -1, 1, 1), V.restore();
                this.compose();
              }
              paintSolidColorImageMask() {
                this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
              }
              markPoint(D) {
              }
              markPointProps(D, H) {
              }
              beginMarkedContent(D) {
                this.markedContentStack.push({
                  visible: !0
                });
              }
              beginMarkedContentProps(D, H) {
                D === "OC" ? this.markedContentStack.push({
                  visible: this.optionalContentConfig.isVisible(H)
                }) : this.markedContentStack.push({
                  visible: !0
                }), this.contentVisible = this.isContentVisible();
              }
              endMarkedContent() {
                this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
              }
              beginCompat() {
              }
              endCompat() {
              }
              consumePath(D) {
                const H = this.current.isEmptyClip();
                this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(D);
                const V = this.ctx;
                this.pendingClip && (H || (this.pendingClip === k ? V.clip("evenodd") : V.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), V.beginPath();
              }
              getSinglePixelWidth() {
                if (!this._cachedGetSinglePixelWidth) {
                  const D = (0, d.getCurrentTransform)(this.ctx);
                  if (D[1] === 0 && D[2] === 0)
                    this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(D[0]), Math.abs(D[3]));
                  else {
                    const H = Math.abs(D[0] * D[3] - D[2] * D[1]), V = Math.hypot(D[0], D[2]), Z = Math.hypot(D[1], D[3]);
                    this._cachedGetSinglePixelWidth = Math.max(V, Z) / H;
                  }
                }
                return this._cachedGetSinglePixelWidth;
              }
              getScaleForStroking() {
                if (this._cachedScaleForStroking[0] === -1) {
                  const {
                    lineWidth: D
                  } = this.current, {
                    a: H,
                    b: V,
                    c: Z,
                    d: ne
                  } = this.ctx.getTransform();
                  let K, q;
                  if (V === 0 && Z === 0) {
                    const Y = Math.abs(H), ee = Math.abs(ne);
                    if (Y === ee)
                      if (D === 0)
                        K = q = 1 / Y;
                      else {
                        const Q = Y * D;
                        K = q = Q < 1 ? 1 / Q : 1;
                      }
                    else if (D === 0)
                      K = 1 / Y, q = 1 / ee;
                    else {
                      const Q = Y * D, J = ee * D;
                      K = Q < 1 ? 1 / Q : 1, q = J < 1 ? 1 / J : 1;
                    }
                  } else {
                    const Y = Math.abs(H * ne - V * Z), ee = Math.hypot(H, V), Q = Math.hypot(Z, ne);
                    if (D === 0)
                      K = Q / Y, q = ee / Y;
                    else {
                      const J = D * Y;
                      K = Q > J ? Q / J : 1, q = ee > J ? ee / J : 1;
                    }
                  }
                  this._cachedScaleForStroking[0] = K, this._cachedScaleForStroking[1] = q;
                }
                return this._cachedScaleForStroking;
              }
              rescaleAndStroke(D) {
                const {
                  ctx: H
                } = this, {
                  lineWidth: V
                } = this.current, [Z, ne] = this.getScaleForStroking();
                if (H.lineWidth = V || 1, Z === 1 && ne === 1) {
                  H.stroke();
                  return;
                }
                const K = H.getLineDash();
                if (D && H.save(), H.scale(Z, ne), K.length > 0) {
                  const q = Math.max(Z, ne);
                  H.setLineDash(K.map((Y) => Y / q)), H.lineDashOffset /= q;
                }
                H.stroke(), D && H.restore();
              }
              isContentVisible() {
                for (let D = this.markedContentStack.length - 1; D >= 0; D--)
                  if (!this.markedContentStack[D].visible)
                    return !1;
                return !0;
              }
            }
            s.CanvasGraphics = N;
            for (const P in u.OPS)
              N.prototype[P] !== void 0 && (N.prototype[u.OPS[P]] = N.prototype[P]);
          },
          /* 12 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.TilingPattern = s.PathType = void 0, s.getShadingPattern = m;
            var u = c(1), d = c(6);
            const p = {
              FILL: "Fill",
              STROKE: "Stroke",
              SHADING: "Shading"
            };
            s.PathType = p;
            function v(S, $) {
              if (!$)
                return;
              const T = $[2] - $[0], I = $[3] - $[1], _ = new Path2D();
              _.rect($[0], $[1], T, I), S.clip(_);
            }
            class A {
              constructor() {
                this.constructor === A && (0, u.unreachable)("Cannot initialize BaseShadingPattern.");
              }
              getPattern() {
                (0, u.unreachable)("Abstract method `getPattern` called.");
              }
            }
            class x extends A {
              constructor($) {
                super(), this._type = $[1], this._bbox = $[2], this._colorStops = $[3], this._p0 = $[4], this._p1 = $[5], this._r0 = $[6], this._r1 = $[7], this.matrix = null;
              }
              _createGradient($) {
                let T;
                this._type === "axial" ? T = $.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (T = $.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
                for (const I of this._colorStops)
                  T.addColorStop(I[0], I[1]);
                return T;
              }
              getPattern($, T, I, _) {
                let E;
                if (_ === p.STROKE || _ === p.FILL) {
                  const R = T.current.getClippedPathBoundingBox(_, (0, d.getCurrentTransform)($)) || [0, 0, 0, 0], O = Math.ceil(R[2] - R[0]) || 1, L = Math.ceil(R[3] - R[1]) || 1, B = T.cachedCanvases.getCanvas("pattern", O, L, !0), F = B.context;
                  F.clearRect(0, 0, F.canvas.width, F.canvas.height), F.beginPath(), F.rect(0, 0, F.canvas.width, F.canvas.height), F.translate(-R[0], -R[1]), I = u.Util.transform(I, [1, 0, 0, 1, R[0], R[1]]), F.transform(...T.baseTransform), this.matrix && F.transform(...this.matrix), v(F, this._bbox), F.fillStyle = this._createGradient(F), F.fill(), E = $.createPattern(B.canvas, "no-repeat");
                  const M = new DOMMatrix(I);
                  E.setTransform(M);
                } else
                  v($, this._bbox), E = this._createGradient($);
                return E;
              }
            }
            function g(S, $, T, I, _, E, R, O) {
              const L = $.coords, B = $.colors, F = S.data, M = S.width * 4;
              let W;
              L[T + 1] > L[I + 1] && (W = T, T = I, I = W, W = E, E = R, R = W), L[I + 1] > L[_ + 1] && (W = I, I = _, _ = W, W = R, R = O, O = W), L[T + 1] > L[I + 1] && (W = T, T = I, I = W, W = E, E = R, R = W);
              const j = (L[T] + $.offsetX) * $.scaleX, G = (L[T + 1] + $.offsetY) * $.scaleY, U = (L[I] + $.offsetX) * $.scaleX, k = (L[I + 1] + $.offsetY) * $.scaleY, N = (L[_] + $.offsetX) * $.scaleX, P = (L[_ + 1] + $.offsetY) * $.scaleY;
              if (G >= P)
                return;
              const D = B[E], H = B[E + 1], V = B[E + 2], Z = B[R], ne = B[R + 1], K = B[R + 2], q = B[O], Y = B[O + 1], ee = B[O + 2], Q = Math.round(G), J = Math.round(P);
              let te, ae, se, ie, fe, ge, me, pe;
              for (let be = Q; be <= J; be++) {
                if (be < k) {
                  const Ce = be < G ? 0 : (G - be) / (G - k);
                  te = j - (j - U) * Ce, ae = D - (D - Z) * Ce, se = H - (H - ne) * Ce, ie = V - (V - K) * Ce;
                } else {
                  let Ce;
                  be > P ? Ce = 1 : k === P ? Ce = 0 : Ce = (k - be) / (k - P), te = U - (U - N) * Ce, ae = Z - (Z - q) * Ce, se = ne - (ne - Y) * Ce, ie = K - (K - ee) * Ce;
                }
                let le;
                be < G ? le = 0 : be > P ? le = 1 : le = (G - be) / (G - P), fe = j - (j - N) * le, ge = D - (D - q) * le, me = H - (H - Y) * le, pe = V - (V - ee) * le;
                const ve = Math.round(Math.min(te, fe)), he = Math.round(Math.max(te, fe));
                let ye = M * be + ve * 4;
                for (let Ce = ve; Ce <= he; Ce++)
                  le = (te - Ce) / (te - fe), le < 0 ? le = 0 : le > 1 && (le = 1), F[ye++] = ae - (ae - ge) * le | 0, F[ye++] = se - (se - me) * le | 0, F[ye++] = ie - (ie - pe) * le | 0, F[ye++] = 255;
              }
            }
            function b(S, $, T) {
              const I = $.coords, _ = $.colors;
              let E, R;
              switch ($.type) {
                case "lattice":
                  const O = $.verticesPerRow, L = Math.floor(I.length / O) - 1, B = O - 1;
                  for (E = 0; E < L; E++) {
                    let F = E * O;
                    for (let M = 0; M < B; M++, F++)
                      g(S, T, I[F], I[F + 1], I[F + O], _[F], _[F + 1], _[F + O]), g(S, T, I[F + O + 1], I[F + 1], I[F + O], _[F + O + 1], _[F + 1], _[F + O]);
                  }
                  break;
                case "triangles":
                  for (E = 0, R = I.length; E < R; E += 3)
                    g(S, T, I[E], I[E + 1], I[E + 2], _[E], _[E + 1], _[E + 2]);
                  break;
                default:
                  throw new Error("illegal figure");
              }
            }
            class y extends A {
              constructor($) {
                super(), this._coords = $[2], this._colors = $[3], this._figures = $[4], this._bounds = $[5], this._bbox = $[7], this._background = $[8], this.matrix = null;
              }
              _createMeshCanvas($, T, I) {
                const O = Math.floor(this._bounds[0]), L = Math.floor(this._bounds[1]), B = Math.ceil(this._bounds[2]) - O, F = Math.ceil(this._bounds[3]) - L, M = Math.min(Math.ceil(Math.abs(B * $[0] * 1.1)), 3e3), W = Math.min(Math.ceil(Math.abs(F * $[1] * 1.1)), 3e3), j = B / M, G = F / W, U = {
                  coords: this._coords,
                  colors: this._colors,
                  offsetX: -O,
                  offsetY: -L,
                  scaleX: 1 / j,
                  scaleY: 1 / G
                }, k = M + 2 * 2, N = W + 2 * 2, P = I.getCanvas("mesh", k, N, !1), D = P.context, H = D.createImageData(M, W);
                if (T) {
                  const Z = H.data;
                  for (let ne = 0, K = Z.length; ne < K; ne += 4)
                    Z[ne] = T[0], Z[ne + 1] = T[1], Z[ne + 2] = T[2], Z[ne + 3] = 255;
                }
                for (const Z of this._figures)
                  b(H, Z, U);
                return D.putImageData(H, 2, 2), {
                  canvas: P.canvas,
                  offsetX: O - 2 * j,
                  offsetY: L - 2 * G,
                  scaleX: j,
                  scaleY: G
                };
              }
              getPattern($, T, I, _) {
                v($, this._bbox);
                let E;
                if (_ === p.SHADING)
                  E = u.Util.singularValueDecompose2dScale((0, d.getCurrentTransform)($));
                else if (E = u.Util.singularValueDecompose2dScale(T.baseTransform), this.matrix) {
                  const O = u.Util.singularValueDecompose2dScale(this.matrix);
                  E = [E[0] * O[0], E[1] * O[1]];
                }
                const R = this._createMeshCanvas(E, _ === p.SHADING ? null : this._background, T.cachedCanvases);
                return _ !== p.SHADING && ($.setTransform(...T.baseTransform), this.matrix && $.transform(...this.matrix)), $.translate(R.offsetX, R.offsetY), $.scale(R.scaleX, R.scaleY), $.createPattern(R.canvas, "no-repeat");
              }
            }
            class f extends A {
              getPattern() {
                return "hotpink";
              }
            }
            function m(S) {
              switch (S[0]) {
                case "RadialAxial":
                  return new x(S);
                case "Mesh":
                  return new y(S);
                case "Dummy":
                  return new f();
              }
              throw new Error(`Unknown IR type: ${S[0]}`);
            }
            const C = {
              COLORED: 1,
              UNCOLORED: 2
            };
            class w {
              static MAX_PATTERN_SIZE = 3e3;
              constructor($, T, I, _, E) {
                this.operatorList = $[2], this.matrix = $[3] || [1, 0, 0, 1, 0, 0], this.bbox = $[4], this.xstep = $[5], this.ystep = $[6], this.paintType = $[7], this.tilingType = $[8], this.color = T, this.ctx = I, this.canvasGraphicsFactory = _, this.baseTransform = E;
              }
              createPatternCanvas($) {
                const T = this.operatorList, I = this.bbox, _ = this.xstep, E = this.ystep, R = this.paintType, O = this.tilingType, L = this.color, B = this.canvasGraphicsFactory;
                (0, u.info)("TilingType: " + O);
                const F = I[0], M = I[1], W = I[2], j = I[3], G = u.Util.singularValueDecompose2dScale(this.matrix), U = u.Util.singularValueDecompose2dScale(this.baseTransform), k = [G[0] * U[0], G[1] * U[1]], N = this.getSizeAndScale(_, this.ctx.canvas.width, k[0]), P = this.getSizeAndScale(E, this.ctx.canvas.height, k[1]), D = $.cachedCanvases.getCanvas("pattern", N.size, P.size, !0), H = D.context, V = B.createCanvasGraphics(H);
                V.groupLevel = $.groupLevel, this.setFillAndStrokeStyleToContext(V, R, L);
                let Z = F, ne = M, K = W, q = j;
                return F < 0 && (Z = 0, K += Math.abs(F)), M < 0 && (ne = 0, q += Math.abs(M)), H.translate(-(N.scale * Z), -(P.scale * ne)), V.transform(N.scale, 0, 0, P.scale, 0, 0), H.save(), this.clipBbox(V, Z, ne, K, q), V.baseTransform = (0, d.getCurrentTransform)(V.ctx), V.executeOperatorList(T), V.endDrawing(), {
                  canvas: D.canvas,
                  scaleX: N.scale,
                  scaleY: P.scale,
                  offsetX: Z,
                  offsetY: ne
                };
              }
              getSizeAndScale($, T, I) {
                $ = Math.abs($);
                const _ = Math.max(w.MAX_PATTERN_SIZE, T);
                let E = Math.ceil($ * I);
                return E >= _ ? E = _ : I = E / $, {
                  scale: I,
                  size: E
                };
              }
              clipBbox($, T, I, _, E) {
                const R = _ - T, O = E - I;
                $.ctx.rect(T, I, R, O), $.current.updateRectMinMax((0, d.getCurrentTransform)($.ctx), [T, I, _, E]), $.clip(), $.endPath();
              }
              setFillAndStrokeStyleToContext($, T, I) {
                const _ = $.ctx, E = $.current;
                switch (T) {
                  case C.COLORED:
                    const R = this.ctx;
                    _.fillStyle = R.fillStyle, _.strokeStyle = R.strokeStyle, E.fillColor = R.fillStyle, E.strokeColor = R.strokeStyle;
                    break;
                  case C.UNCOLORED:
                    const O = u.Util.makeHexColor(I[0], I[1], I[2]);
                    _.fillStyle = O, _.strokeStyle = O, E.fillColor = O, E.strokeColor = O;
                    break;
                  default:
                    throw new u.FormatError(`Unsupported paint type: ${T}`);
                }
              }
              getPattern($, T, I, _) {
                let E = I;
                _ !== p.SHADING && (E = u.Util.transform(E, T.baseTransform), this.matrix && (E = u.Util.transform(E, this.matrix)));
                const R = this.createPatternCanvas(T);
                let O = new DOMMatrix(E);
                O = O.translate(R.offsetX, R.offsetY), O = O.scale(1 / R.scaleX, 1 / R.scaleY);
                const L = $.createPattern(R.canvas, "repeat");
                return L.setTransform(O), L;
              }
            }
            s.TilingPattern = w;
          },
          /* 13 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.convertBlackAndWhiteToRGBA = p, s.convertToRGBA = d, s.grayToRGBA = A;
            var u = c(1);
            function d(x) {
              switch (x.kind) {
                case u.ImageKind.GRAYSCALE_1BPP:
                  return p(x);
                case u.ImageKind.RGB_24BPP:
                  return v(x);
              }
              return null;
            }
            function p({
              src: x,
              srcPos: g = 0,
              dest: b,
              width: y,
              height: f,
              nonBlackColor: m = 4294967295,
              inverseDecode: C = !1
            }) {
              const w = u.FeatureTest.isLittleEndian ? 4278190080 : 255, [S, $] = C ? [m, w] : [w, m], T = y >> 3, I = y & 7, _ = x.length;
              b = new Uint32Array(b.buffer);
              let E = 0;
              for (let R = 0; R < f; R++) {
                for (const L = g + T; g < L; g++) {
                  const B = g < _ ? x[g] : 255;
                  b[E++] = B & 128 ? $ : S, b[E++] = B & 64 ? $ : S, b[E++] = B & 32 ? $ : S, b[E++] = B & 16 ? $ : S, b[E++] = B & 8 ? $ : S, b[E++] = B & 4 ? $ : S, b[E++] = B & 2 ? $ : S, b[E++] = B & 1 ? $ : S;
                }
                if (I === 0)
                  continue;
                const O = g < _ ? x[g++] : 255;
                for (let L = 0; L < I; L++)
                  b[E++] = O & 1 << 7 - L ? $ : S;
              }
              return {
                srcPos: g,
                destPos: E
              };
            }
            function v({
              src: x,
              srcPos: g = 0,
              dest: b,
              destPos: y = 0,
              width: f,
              height: m
            }) {
              let C = 0;
              const w = x.length >> 2, S = new Uint32Array(x.buffer, g, w);
              if (u.FeatureTest.isLittleEndian) {
                for (; C < w - 2; C += 3, y += 4) {
                  const $ = S[C], T = S[C + 1], I = S[C + 2];
                  b[y] = $ | 4278190080, b[y + 1] = $ >>> 24 | T << 8 | 4278190080, b[y + 2] = T >>> 16 | I << 16 | 4278190080, b[y + 3] = I >>> 8 | 4278190080;
                }
                for (let $ = C * 4, T = x.length; $ < T; $ += 3)
                  b[y++] = x[$] | x[$ + 1] << 8 | x[$ + 2] << 16 | 4278190080;
              } else {
                for (; C < w - 2; C += 3, y += 4) {
                  const $ = S[C], T = S[C + 1], I = S[C + 2];
                  b[y] = $ | 255, b[y + 1] = $ << 24 | T >>> 8 | 255, b[y + 2] = T << 16 | I >>> 16 | 255, b[y + 3] = I << 8 | 255;
                }
                for (let $ = C * 4, T = x.length; $ < T; $ += 3)
                  b[y++] = x[$] << 24 | x[$ + 1] << 16 | x[$ + 2] << 8 | 255;
              }
              return {
                srcPos: g,
                destPos: y
              };
            }
            function A(x, g) {
              if (u.FeatureTest.isLittleEndian)
                for (let b = 0, y = x.length; b < y; b++)
                  g[b] = x[b] * 65793 | 4278190080;
              else
                for (let b = 0, y = x.length; b < y; b++)
                  g[b] = x[b] * 16843008 | 255;
            }
          },
          /* 14 */
          /***/
          (a, s) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.GlobalWorkerOptions = void 0;
            const c = /* @__PURE__ */ Object.create(null);
            s.GlobalWorkerOptions = c, c.workerPort = null, c.workerSrc = "";
          },
          /* 15 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.MessageHandler = void 0;
            var u = c(1);
            const d = {
              DATA: 1,
              ERROR: 2
            }, p = {
              CANCEL: 1,
              CANCEL_COMPLETE: 2,
              CLOSE: 3,
              ENQUEUE: 4,
              ERROR: 5,
              PULL: 6,
              PULL_COMPLETE: 7,
              START_COMPLETE: 8
            };
            function v(x) {
              switch (x instanceof Error || typeof x == "object" && x !== null || (0, u.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), x.name) {
                case "AbortException":
                  return new u.AbortException(x.message);
                case "MissingPDFException":
                  return new u.MissingPDFException(x.message);
                case "PasswordException":
                  return new u.PasswordException(x.message, x.code);
                case "UnexpectedResponseException":
                  return new u.UnexpectedResponseException(x.message, x.status);
                case "UnknownErrorException":
                  return new u.UnknownErrorException(x.message, x.details);
                default:
                  return new u.UnknownErrorException(x.message, x.toString());
              }
            }
            class A {
              constructor(g, b, y) {
                this.sourceName = g, this.targetName = b, this.comObj = y, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (f) => {
                  const m = f.data;
                  if (m.targetName !== this.sourceName)
                    return;
                  if (m.stream) {
                    this.#t(m);
                    return;
                  }
                  if (m.callback) {
                    const w = m.callbackId, S = this.callbackCapabilities[w];
                    if (!S)
                      throw new Error(`Cannot resolve callback ${w}`);
                    if (delete this.callbackCapabilities[w], m.callback === d.DATA)
                      S.resolve(m.data);
                    else if (m.callback === d.ERROR)
                      S.reject(v(m.reason));
                    else
                      throw new Error("Unexpected callback case");
                    return;
                  }
                  const C = this.actionHandler[m.action];
                  if (!C)
                    throw new Error(`Unknown action from worker: ${m.action}`);
                  if (m.callbackId) {
                    const w = this.sourceName, S = m.sourceName;
                    new Promise(function($) {
                      $(C(m.data));
                    }).then(function($) {
                      y.postMessage({
                        sourceName: w,
                        targetName: S,
                        callback: d.DATA,
                        callbackId: m.callbackId,
                        data: $
                      });
                    }, function($) {
                      y.postMessage({
                        sourceName: w,
                        targetName: S,
                        callback: d.ERROR,
                        callbackId: m.callbackId,
                        reason: v($)
                      });
                    });
                    return;
                  }
                  if (m.streamId) {
                    this.#e(m);
                    return;
                  }
                  C(m.data);
                }, y.addEventListener("message", this._onComObjOnMessage);
              }
              on(g, b) {
                const y = this.actionHandler;
                if (y[g])
                  throw new Error(`There is already an actionName called "${g}"`);
                y[g] = b;
              }
              send(g, b, y) {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: g,
                  data: b
                }, y);
              }
              sendWithPromise(g, b, y) {
                const f = this.callbackId++, m = new u.PromiseCapability();
                this.callbackCapabilities[f] = m;
                try {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: g,
                    callbackId: f,
                    data: b
                  }, y);
                } catch (C) {
                  m.reject(C);
                }
                return m.promise;
              }
              sendWithStream(g, b, y, f) {
                const m = this.streamId++, C = this.sourceName, w = this.targetName, S = this.comObj;
                return new ReadableStream({
                  start: ($) => {
                    const T = new u.PromiseCapability();
                    return this.streamControllers[m] = {
                      controller: $,
                      startCall: T,
                      pullCall: null,
                      cancelCall: null,
                      isClosed: !1
                    }, S.postMessage({
                      sourceName: C,
                      targetName: w,
                      action: g,
                      streamId: m,
                      data: b,
                      desiredSize: $.desiredSize
                    }, f), T.promise;
                  },
                  pull: ($) => {
                    const T = new u.PromiseCapability();
                    return this.streamControllers[m].pullCall = T, S.postMessage({
                      sourceName: C,
                      targetName: w,
                      stream: p.PULL,
                      streamId: m,
                      desiredSize: $.desiredSize
                    }), T.promise;
                  },
                  cancel: ($) => {
                    (0, u.assert)($ instanceof Error, "cancel must have a valid reason");
                    const T = new u.PromiseCapability();
                    return this.streamControllers[m].cancelCall = T, this.streamControllers[m].isClosed = !0, S.postMessage({
                      sourceName: C,
                      targetName: w,
                      stream: p.CANCEL,
                      streamId: m,
                      reason: v($)
                    }), T.promise;
                  }
                }, y);
              }
              #e(g) {
                const b = g.streamId, y = this.sourceName, f = g.sourceName, m = this.comObj, C = this, w = this.actionHandler[g.action], S = {
                  enqueue($, T = 1, I) {
                    if (this.isCancelled)
                      return;
                    const _ = this.desiredSize;
                    this.desiredSize -= T, _ > 0 && this.desiredSize <= 0 && (this.sinkCapability = new u.PromiseCapability(), this.ready = this.sinkCapability.promise), m.postMessage({
                      sourceName: y,
                      targetName: f,
                      stream: p.ENQUEUE,
                      streamId: b,
                      chunk: $
                    }, I);
                  },
                  close() {
                    this.isCancelled || (this.isCancelled = !0, m.postMessage({
                      sourceName: y,
                      targetName: f,
                      stream: p.CLOSE,
                      streamId: b
                    }), delete C.streamSinks[b]);
                  },
                  error($) {
                    (0, u.assert)($ instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, m.postMessage({
                      sourceName: y,
                      targetName: f,
                      stream: p.ERROR,
                      streamId: b,
                      reason: v($)
                    }));
                  },
                  sinkCapability: new u.PromiseCapability(),
                  onPull: null,
                  onCancel: null,
                  isCancelled: !1,
                  desiredSize: g.desiredSize,
                  ready: null
                };
                S.sinkCapability.resolve(), S.ready = S.sinkCapability.promise, this.streamSinks[b] = S, new Promise(function($) {
                  $(w(g.data, S));
                }).then(function() {
                  m.postMessage({
                    sourceName: y,
                    targetName: f,
                    stream: p.START_COMPLETE,
                    streamId: b,
                    success: !0
                  });
                }, function($) {
                  m.postMessage({
                    sourceName: y,
                    targetName: f,
                    stream: p.START_COMPLETE,
                    streamId: b,
                    reason: v($)
                  });
                });
              }
              #t(g) {
                const b = g.streamId, y = this.sourceName, f = g.sourceName, m = this.comObj, C = this.streamControllers[b], w = this.streamSinks[b];
                switch (g.stream) {
                  case p.START_COMPLETE:
                    g.success ? C.startCall.resolve() : C.startCall.reject(v(g.reason));
                    break;
                  case p.PULL_COMPLETE:
                    g.success ? C.pullCall.resolve() : C.pullCall.reject(v(g.reason));
                    break;
                  case p.PULL:
                    if (!w) {
                      m.postMessage({
                        sourceName: y,
                        targetName: f,
                        stream: p.PULL_COMPLETE,
                        streamId: b,
                        success: !0
                      });
                      break;
                    }
                    w.desiredSize <= 0 && g.desiredSize > 0 && w.sinkCapability.resolve(), w.desiredSize = g.desiredSize, new Promise(function(S) {
                      S(w.onPull?.());
                    }).then(function() {
                      m.postMessage({
                        sourceName: y,
                        targetName: f,
                        stream: p.PULL_COMPLETE,
                        streamId: b,
                        success: !0
                      });
                    }, function(S) {
                      m.postMessage({
                        sourceName: y,
                        targetName: f,
                        stream: p.PULL_COMPLETE,
                        streamId: b,
                        reason: v(S)
                      });
                    });
                    break;
                  case p.ENQUEUE:
                    if ((0, u.assert)(C, "enqueue should have stream controller"), C.isClosed)
                      break;
                    C.controller.enqueue(g.chunk);
                    break;
                  case p.CLOSE:
                    if ((0, u.assert)(C, "close should have stream controller"), C.isClosed)
                      break;
                    C.isClosed = !0, C.controller.close(), this.#r(C, b);
                    break;
                  case p.ERROR:
                    (0, u.assert)(C, "error should have stream controller"), C.controller.error(v(g.reason)), this.#r(C, b);
                    break;
                  case p.CANCEL_COMPLETE:
                    g.success ? C.cancelCall.resolve() : C.cancelCall.reject(v(g.reason)), this.#r(C, b);
                    break;
                  case p.CANCEL:
                    if (!w)
                      break;
                    new Promise(function(S) {
                      S(w.onCancel?.(v(g.reason)));
                    }).then(function() {
                      m.postMessage({
                        sourceName: y,
                        targetName: f,
                        stream: p.CANCEL_COMPLETE,
                        streamId: b,
                        success: !0
                      });
                    }, function(S) {
                      m.postMessage({
                        sourceName: y,
                        targetName: f,
                        stream: p.CANCEL_COMPLETE,
                        streamId: b,
                        reason: v(S)
                      });
                    }), w.sinkCapability.reject(v(g.reason)), w.isCancelled = !0, delete this.streamSinks[b];
                    break;
                  default:
                    throw new Error("Unexpected stream case");
                }
              }
              async #r(g, b) {
                await Promise.allSettled([g.startCall?.promise, g.pullCall?.promise, g.cancelCall?.promise]), delete this.streamControllers[b];
              }
              destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }
            s.MessageHandler = A;
          },
          /* 16 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.Metadata = void 0;
            var u = c(1);
            class d {
              #e;
              #t;
              constructor({
                parsedData: v,
                rawData: A
              }) {
                this.#e = v, this.#t = A;
              }
              getRaw() {
                return this.#t;
              }
              get(v) {
                return this.#e.get(v) ?? null;
              }
              getAll() {
                return (0, u.objectFromMap)(this.#e);
              }
              has(v) {
                return this.#e.has(v);
              }
            }
            s.Metadata = d;
          },
          /* 17 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.OptionalContentConfig = void 0;
            var u = c(1), d = c(8);
            const p = Symbol("INTERNAL");
            class v {
              #e = !0;
              constructor(g, b) {
                this.name = g, this.intent = b;
              }
              get visible() {
                return this.#e;
              }
              _setVisible(g, b) {
                g !== p && (0, u.unreachable)("Internal method `_setVisible` called."), this.#e = b;
              }
            }
            class A {
              #e = null;
              #t = /* @__PURE__ */ new Map();
              #r = null;
              #n = null;
              constructor(g) {
                if (this.name = null, this.creator = null, g !== null) {
                  this.name = g.name, this.creator = g.creator, this.#n = g.order;
                  for (const b of g.groups)
                    this.#t.set(b.id, new v(b.name, b.intent));
                  if (g.baseState === "OFF")
                    for (const b of this.#t.values())
                      b._setVisible(p, !1);
                  for (const b of g.on)
                    this.#t.get(b)._setVisible(p, !0);
                  for (const b of g.off)
                    this.#t.get(b)._setVisible(p, !1);
                  this.#r = this.getHash();
                }
              }
              #s(g) {
                const b = g.length;
                if (b < 2)
                  return !0;
                const y = g[0];
                for (let f = 1; f < b; f++) {
                  const m = g[f];
                  let C;
                  if (Array.isArray(m))
                    C = this.#s(m);
                  else if (this.#t.has(m))
                    C = this.#t.get(m).visible;
                  else
                    return (0, u.warn)(`Optional content group not found: ${m}`), !0;
                  switch (y) {
                    case "And":
                      if (!C)
                        return !1;
                      break;
                    case "Or":
                      if (C)
                        return !0;
                      break;
                    case "Not":
                      return !C;
                    default:
                      return !0;
                  }
                }
                return y === "And";
              }
              isVisible(g) {
                if (this.#t.size === 0)
                  return !0;
                if (!g)
                  return (0, u.warn)("Optional content group not defined."), !0;
                if (g.type === "OCG")
                  return this.#t.has(g.id) ? this.#t.get(g.id).visible : ((0, u.warn)(`Optional content group not found: ${g.id}`), !0);
                if (g.type === "OCMD") {
                  if (g.expression)
                    return this.#s(g.expression);
                  if (!g.policy || g.policy === "AnyOn") {
                    for (const b of g.ids) {
                      if (!this.#t.has(b))
                        return (0, u.warn)(`Optional content group not found: ${b}`), !0;
                      if (this.#t.get(b).visible)
                        return !0;
                    }
                    return !1;
                  } else if (g.policy === "AllOn") {
                    for (const b of g.ids) {
                      if (!this.#t.has(b))
                        return (0, u.warn)(`Optional content group not found: ${b}`), !0;
                      if (!this.#t.get(b).visible)
                        return !1;
                    }
                    return !0;
                  } else if (g.policy === "AnyOff") {
                    for (const b of g.ids) {
                      if (!this.#t.has(b))
                        return (0, u.warn)(`Optional content group not found: ${b}`), !0;
                      if (!this.#t.get(b).visible)
                        return !0;
                    }
                    return !1;
                  } else if (g.policy === "AllOff") {
                    for (const b of g.ids) {
                      if (!this.#t.has(b))
                        return (0, u.warn)(`Optional content group not found: ${b}`), !0;
                      if (this.#t.get(b).visible)
                        return !1;
                    }
                    return !0;
                  }
                  return (0, u.warn)(`Unknown optional content policy ${g.policy}.`), !0;
                }
                return (0, u.warn)(`Unknown group type ${g.type}.`), !0;
              }
              setVisibility(g, b = !0) {
                if (!this.#t.has(g)) {
                  (0, u.warn)(`Optional content group not found: ${g}`);
                  return;
                }
                this.#t.get(g)._setVisible(p, !!b), this.#e = null;
              }
              get hasInitialVisibility() {
                return this.#r === null || this.getHash() === this.#r;
              }
              getOrder() {
                return this.#t.size ? this.#n ? this.#n.slice() : [...this.#t.keys()] : null;
              }
              getGroups() {
                return this.#t.size > 0 ? (0, u.objectFromMap)(this.#t) : null;
              }
              getGroup(g) {
                return this.#t.get(g) || null;
              }
              getHash() {
                if (this.#e !== null)
                  return this.#e;
                const g = new d.MurmurHash3_64();
                for (const [b, y] of this.#t)
                  g.update(`${b}:${y.visible}`);
                return this.#e = g.hexdigest();
              }
            }
            s.OptionalContentConfig = A;
          },
          /* 18 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.PDFDataTransportStream = void 0;
            var u = c(1), d = c(6);
            class p {
              constructor({
                length: g,
                initialData: b,
                progressiveDone: y = !1,
                contentDispositionFilename: f = null,
                disableRange: m = !1,
                disableStream: C = !1
              }, w) {
                if ((0, u.assert)(w, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = y, this._contentDispositionFilename = f, b?.length > 0) {
                  const S = b instanceof Uint8Array && b.byteLength === b.buffer.byteLength ? b.buffer : new Uint8Array(b).buffer;
                  this._queuedChunks.push(S);
                }
                this._pdfDataRangeTransport = w, this._isStreamingSupported = !C, this._isRangeSupported = !m, this._contentLength = g, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((S, $) => {
                  this._onReceiveData({
                    begin: S,
                    chunk: $
                  });
                }), this._pdfDataRangeTransport.addProgressListener((S, $) => {
                  this._onProgress({
                    loaded: S,
                    total: $
                  });
                }), this._pdfDataRangeTransport.addProgressiveReadListener((S) => {
                  this._onReceiveData({
                    chunk: S
                  });
                }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                  this._onProgressiveDone();
                }), this._pdfDataRangeTransport.transportReady();
              }
              _onReceiveData({
                begin: g,
                chunk: b
              }) {
                const y = b instanceof Uint8Array && b.byteLength === b.buffer.byteLength ? b.buffer : new Uint8Array(b).buffer;
                if (g === void 0)
                  this._fullRequestReader ? this._fullRequestReader._enqueue(y) : this._queuedChunks.push(y);
                else {
                  const f = this._rangeReaders.some(function(m) {
                    return m._begin !== g ? !1 : (m._enqueue(y), !0);
                  });
                  (0, u.assert)(f, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                }
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              _onProgress(g) {
                g.total === void 0 ? this._rangeReaders[0]?.onProgress?.({
                  loaded: g.loaded
                }) : this._fullRequestReader?.onProgress?.({
                  loaded: g.loaded,
                  total: g.total
                });
              }
              _onProgressiveDone() {
                this._fullRequestReader?.progressiveDone(), this._progressiveDone = !0;
              }
              _removeRangeReader(g) {
                const b = this._rangeReaders.indexOf(g);
                b >= 0 && this._rangeReaders.splice(b, 1);
              }
              getFullReader() {
                (0, u.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                const g = this._queuedChunks;
                return this._queuedChunks = null, new v(this, g, this._progressiveDone, this._contentDispositionFilename);
              }
              getRangeReader(g, b) {
                if (b <= this._progressiveDataLength)
                  return null;
                const y = new A(this, g, b);
                return this._pdfDataRangeTransport.requestDataRange(g, b), this._rangeReaders.push(y), y;
              }
              cancelAllRequests(g) {
                this._fullRequestReader?.cancel(g);
                for (const b of this._rangeReaders.slice(0))
                  b.cancel(g);
                this._pdfDataRangeTransport.abort();
              }
            }
            s.PDFDataTransportStream = p;
            class v {
              constructor(g, b, y = !1, f = null) {
                this._stream = g, this._done = y || !1, this._filename = (0, d.isPdfFile)(f) ? f : null, this._queuedChunks = b || [], this._loaded = 0;
                for (const m of this._queuedChunks)
                  this._loaded += m.byteLength;
                this._requests = [], this._headersReady = Promise.resolve(), g._fullRequestReader = this, this.onProgress = null;
              }
              _enqueue(g) {
                this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: g,
                  done: !1
                }) : this._queuedChunks.push(g), this._loaded += g.byteLength);
              }
              get headersReady() {
                return this._headersReady;
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._stream._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._stream._isStreamingSupported;
              }
              get contentLength() {
                return this._stream._contentLength;
              }
              async read() {
                if (this._queuedChunks.length > 0)
                  return {
                    value: this._queuedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const g = new u.PromiseCapability();
                return this._requests.push(g), g.promise;
              }
              cancel(g) {
                this._done = !0;
                for (const b of this._requests)
                  b.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0;
              }
              progressiveDone() {
                this._done || (this._done = !0);
              }
            }
            class A {
              constructor(g, b, y) {
                this._stream = g, this._begin = b, this._end = y, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
              }
              _enqueue(g) {
                if (!this._done) {
                  if (this._requests.length === 0)
                    this._queuedChunk = g;
                  else {
                    this._requests.shift().resolve({
                      value: g,
                      done: !1
                    });
                    for (const y of this._requests)
                      y.resolve({
                        value: void 0,
                        done: !0
                      });
                    this._requests.length = 0;
                  }
                  this._done = !0, this._stream._removeRangeReader(this);
                }
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._queuedChunk) {
                  const b = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: b,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const g = new u.PromiseCapability();
                return this._requests.push(g), g.promise;
              }
              cancel(g) {
                this._done = !0;
                for (const b of this._requests)
                  b.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._stream._removeRangeReader(this);
              }
            }
          },
          /* 19 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.PDFFetchStream = void 0;
            var u = c(1), d = c(20);
            function p(y, f, m) {
              return {
                method: "GET",
                headers: y,
                signal: m.signal,
                mode: "cors",
                credentials: f ? "include" : "same-origin",
                redirect: "follow"
              };
            }
            function v(y) {
              const f = new Headers();
              for (const m in y) {
                const C = y[m];
                C !== void 0 && f.append(m, C);
              }
              return f;
            }
            function A(y) {
              return y instanceof Uint8Array ? y.buffer : y instanceof ArrayBuffer ? y : ((0, u.warn)(`getArrayBuffer - unexpected data format: ${y}`), new Uint8Array(y).buffer);
            }
            class x {
              constructor(f) {
                this.source = f, this.isHttp = /^https?:/i.test(f.url), this.httpHeaders = this.isHttp && f.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, u.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new g(this), this._fullRequestReader;
              }
              getRangeReader(f, m) {
                if (m <= this._progressiveDataLength)
                  return null;
                const C = new b(this, f, m);
                return this._rangeRequestReaders.push(C), C;
              }
              cancelAllRequests(f) {
                this._fullRequestReader?.cancel(f);
                for (const m of this._rangeRequestReaders.slice(0))
                  m.cancel(f);
              }
            }
            s.PDFFetchStream = x;
            class g {
              constructor(f) {
                this._stream = f, this._reader = null, this._loaded = 0, this._filename = null;
                const m = f.source;
                this._withCredentials = m.withCredentials || !1, this._contentLength = m.length, this._headersCapability = new u.PromiseCapability(), this._disableRange = m.disableRange || !1, this._rangeChunkSize = m.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !m.disableStream, this._isRangeSupported = !m.disableRange, this._headers = v(this._stream.httpHeaders);
                const C = m.url;
                fetch(C, p(this._headers, this._withCredentials, this._abortController)).then((w) => {
                  if (!(0, d.validateResponseStatus)(w.status))
                    throw (0, d.createResponseStatusError)(w.status, C);
                  this._reader = w.body.getReader(), this._headersCapability.resolve();
                  const S = (I) => w.headers.get(I), {
                    allowRangeRequests: $,
                    suggestedLength: T
                  } = (0, d.validateRangeRequestCapabilities)({
                    getResponseHeader: S,
                    isHttp: this._stream.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = $, this._contentLength = T || this._contentLength, this._filename = (0, d.extractFilenameFromHeader)(S), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new u.AbortException("Streaming is disabled."));
                }).catch(this._headersCapability.reject), this.onProgress = null;
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._headersCapability.promise;
                const {
                  value: f,
                  done: m
                } = await this._reader.read();
                return m ? {
                  value: f,
                  done: m
                } : (this._loaded += f.byteLength, this.onProgress?.({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: A(f),
                  done: !1
                });
              }
              cancel(f) {
                this._reader?.cancel(f), this._abortController.abort();
              }
            }
            class b {
              constructor(f, m, C) {
                this._stream = f, this._reader = null, this._loaded = 0;
                const w = f.source;
                this._withCredentials = w.withCredentials || !1, this._readCapability = new u.PromiseCapability(), this._isStreamingSupported = !w.disableStream, this._abortController = new AbortController(), this._headers = v(this._stream.httpHeaders), this._headers.append("Range", `bytes=${m}-${C - 1}`);
                const S = w.url;
                fetch(S, p(this._headers, this._withCredentials, this._abortController)).then(($) => {
                  if (!(0, d.validateResponseStatus)($.status))
                    throw (0, d.createResponseStatusError)($.status, S);
                  this._readCapability.resolve(), this._reader = $.body.getReader();
                }).catch(this._readCapability.reject), this.onProgress = null;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._readCapability.promise;
                const {
                  value: f,
                  done: m
                } = await this._reader.read();
                return m ? {
                  value: f,
                  done: m
                } : (this._loaded += f.byteLength, this.onProgress?.({
                  loaded: this._loaded
                }), {
                  value: A(f),
                  done: !1
                });
              }
              cancel(f) {
                this._reader?.cancel(f), this._abortController.abort();
              }
            }
          },
          /* 20 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.createResponseStatusError = x, s.extractFilenameFromHeader = A, s.validateRangeRequestCapabilities = v, s.validateResponseStatus = g;
            var u = c(1), d = c(21), p = c(6);
            function v({
              getResponseHeader: b,
              isHttp: y,
              rangeChunkSize: f,
              disableRange: m
            }) {
              const C = {
                allowRangeRequests: !1,
                suggestedLength: void 0
              }, w = parseInt(b("Content-Length"), 10);
              return !Number.isInteger(w) || (C.suggestedLength = w, w <= 2 * f) || m || !y || b("Accept-Ranges") !== "bytes" || (b("Content-Encoding") || "identity") !== "identity" || (C.allowRangeRequests = !0), C;
            }
            function A(b) {
              const y = b("Content-Disposition");
              if (y) {
                let f = (0, d.getFilenameFromContentDispositionHeader)(y);
                if (f.includes("%"))
                  try {
                    f = decodeURIComponent(f);
                  } catch {
                  }
                if ((0, p.isPdfFile)(f))
                  return f;
              }
              return null;
            }
            function x(b, y) {
              return b === 404 || b === 0 && y.startsWith("file:") ? new u.MissingPDFException('Missing PDF "' + y + '".') : new u.UnexpectedResponseException(`Unexpected server response (${b}) while retrieving PDF "${y}".`, b);
            }
            function g(b) {
              return b === 200 || b === 206;
            }
          },
          /* 21 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.getFilenameFromContentDispositionHeader = d;
            var u = c(1);
            function d(p) {
              let v = !0, A = x("filename\\*", "i").exec(p);
              if (A) {
                A = A[1];
                let w = f(A);
                return w = unescape(w), w = m(w), w = C(w), b(w);
              }
              if (A = y(p), A) {
                const w = C(A);
                return b(w);
              }
              if (A = x("filename", "i").exec(p), A) {
                A = A[1];
                let w = f(A);
                return w = C(w), b(w);
              }
              function x(w, S) {
                return new RegExp("(?:^|;)\\s*" + w + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', S);
              }
              function g(w, S) {
                if (w) {
                  if (!/^[\x00-\xFF]+$/.test(S))
                    return S;
                  try {
                    const $ = new TextDecoder(w, {
                      fatal: !0
                    }), T = (0, u.stringToBytes)(S);
                    S = $.decode(T), v = !1;
                  } catch {
                  }
                }
                return S;
              }
              function b(w) {
                return v && /[\x80-\xff]/.test(w) && (w = g("utf-8", w), v && (w = g("iso-8859-1", w))), w;
              }
              function y(w) {
                const S = [];
                let $;
                const T = x("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                for (; ($ = T.exec(w)) !== null; ) {
                  let [, _, E, R] = $;
                  if (_ = parseInt(_, 10), _ in S) {
                    if (_ === 0)
                      break;
                    continue;
                  }
                  S[_] = [E, R];
                }
                const I = [];
                for (let _ = 0; _ < S.length && _ in S; ++_) {
                  let [E, R] = S[_];
                  R = f(R), E && (R = unescape(R), _ === 0 && (R = m(R))), I.push(R);
                }
                return I.join("");
              }
              function f(w) {
                if (w.startsWith('"')) {
                  const S = w.slice(1).split('\\"');
                  for (let $ = 0; $ < S.length; ++$) {
                    const T = S[$].indexOf('"');
                    T !== -1 && (S[$] = S[$].slice(0, T), S.length = $ + 1), S[$] = S[$].replaceAll(/\\(.)/g, "$1");
                  }
                  w = S.join('"');
                }
                return w;
              }
              function m(w) {
                const S = w.indexOf("'");
                if (S === -1)
                  return w;
                const $ = w.slice(0, S), I = w.slice(S + 1).replace(/^[^']*'/, "");
                return g($, I);
              }
              function C(w) {
                return !w.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(w) ? w : w.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(S, $, T, I) {
                  if (T === "q" || T === "Q")
                    return I = I.replaceAll("_", " "), I = I.replaceAll(/=([0-9a-fA-F]{2})/g, function(_, E) {
                      return String.fromCharCode(parseInt(E, 16));
                    }), g($, I);
                  try {
                    I = atob(I);
                  } catch {
                  }
                  return g($, I);
                });
              }
              return "";
            }
          },
          /* 22 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.PDFNetworkStream = void 0;
            var u = c(1), d = c(20);
            const p = 200, v = 206;
            function A(f) {
              const m = f.response;
              return typeof m != "string" ? m : (0, u.stringToBytes)(m).buffer;
            }
            class x {
              constructor(m, C = {}) {
                this.url = m, this.isHttp = /^https?:/i.test(m), this.httpHeaders = this.isHttp && C.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = C.withCredentials || !1, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
              }
              requestRange(m, C, w) {
                const S = {
                  begin: m,
                  end: C
                };
                for (const $ in w)
                  S[$] = w[$];
                return this.request(S);
              }
              requestFull(m) {
                return this.request(m);
              }
              request(m) {
                const C = new XMLHttpRequest(), w = this.currXhrId++, S = this.pendingRequests[w] = {
                  xhr: C
                };
                C.open("GET", this.url), C.withCredentials = this.withCredentials;
                for (const $ in this.httpHeaders) {
                  const T = this.httpHeaders[$];
                  T !== void 0 && C.setRequestHeader($, T);
                }
                return this.isHttp && "begin" in m && "end" in m ? (C.setRequestHeader("Range", `bytes=${m.begin}-${m.end - 1}`), S.expectedStatus = v) : S.expectedStatus = p, C.responseType = "arraybuffer", m.onError && (C.onerror = function($) {
                  m.onError(C.status);
                }), C.onreadystatechange = this.onStateChange.bind(this, w), C.onprogress = this.onProgress.bind(this, w), S.onHeadersReceived = m.onHeadersReceived, S.onDone = m.onDone, S.onError = m.onError, S.onProgress = m.onProgress, C.send(null), w;
              }
              onProgress(m, C) {
                const w = this.pendingRequests[m];
                w && w.onProgress?.(C);
              }
              onStateChange(m, C) {
                const w = this.pendingRequests[m];
                if (!w)
                  return;
                const S = w.xhr;
                if (S.readyState >= 2 && w.onHeadersReceived && (w.onHeadersReceived(), delete w.onHeadersReceived), S.readyState !== 4 || !(m in this.pendingRequests))
                  return;
                if (delete this.pendingRequests[m], S.status === 0 && this.isHttp) {
                  w.onError?.(S.status);
                  return;
                }
                const $ = S.status || p;
                if (!($ === p && w.expectedStatus === v) && $ !== w.expectedStatus) {
                  w.onError?.(S.status);
                  return;
                }
                const I = A(S);
                if ($ === v) {
                  const _ = S.getResponseHeader("Content-Range"), E = /bytes (\d+)-(\d+)\/(\d+)/.exec(_);
                  w.onDone({
                    begin: parseInt(E[1], 10),
                    chunk: I
                  });
                } else I ? w.onDone({
                  begin: 0,
                  chunk: I
                }) : w.onError?.(S.status);
              }
              getRequestXhr(m) {
                return this.pendingRequests[m].xhr;
              }
              isPendingRequest(m) {
                return m in this.pendingRequests;
              }
              abortRequest(m) {
                const C = this.pendingRequests[m].xhr;
                delete this.pendingRequests[m], C.abort();
              }
            }
            class g {
              constructor(m) {
                this._source = m, this._manager = new x(m.url, {
                  httpHeaders: m.httpHeaders,
                  withCredentials: m.withCredentials
                }), this._rangeChunkSize = m.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              _onRangeRequestReaderClosed(m) {
                const C = this._rangeRequestReaders.indexOf(m);
                C >= 0 && this._rangeRequestReaders.splice(C, 1);
              }
              getFullReader() {
                return (0, u.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new b(this._manager, this._source), this._fullRequestReader;
              }
              getRangeReader(m, C) {
                const w = new y(this._manager, m, C);
                return w.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(w), w;
              }
              cancelAllRequests(m) {
                this._fullRequestReader?.cancel(m);
                for (const C of this._rangeRequestReaders.slice(0))
                  C.cancel(m);
              }
            }
            s.PDFNetworkStream = g;
            class b {
              constructor(m, C) {
                this._manager = m;
                const w = {
                  onHeadersReceived: this._onHeadersReceived.bind(this),
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = C.url, this._fullRequestId = m.requestFull(w), this._headersReceivedCapability = new u.PromiseCapability(), this._disableRange = C.disableRange || !1, this._contentLength = C.length, this._rangeChunkSize = C.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
              }
              _onHeadersReceived() {
                const m = this._fullRequestId, C = this._manager.getRequestXhr(m), w = (T) => C.getResponseHeader(T), {
                  allowRangeRequests: S,
                  suggestedLength: $
                } = (0, d.validateRangeRequestCapabilities)({
                  getResponseHeader: w,
                  isHttp: this._manager.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                S && (this._isRangeSupported = !0), this._contentLength = $ || this._contentLength, this._filename = (0, d.extractFilenameFromHeader)(w), this._isRangeSupported && this._manager.abortRequest(m), this._headersReceivedCapability.resolve();
              }
              _onDone(m) {
                if (m && (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: m.chunk,
                  done: !1
                }) : this._cachedChunks.push(m.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
                  for (const C of this._requests)
                    C.resolve({
                      value: void 0,
                      done: !0
                    });
                  this._requests.length = 0;
                }
              }
              _onError(m) {
                this._storedError = (0, d.createResponseStatusError)(m, this._url), this._headersReceivedCapability.reject(this._storedError);
                for (const C of this._requests)
                  C.reject(this._storedError);
                this._requests.length = 0, this._cachedChunks.length = 0;
              }
              _onProgress(m) {
                this.onProgress?.({
                  loaded: m.loaded,
                  total: m.lengthComputable ? m.total : this._contentLength
                });
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              get contentLength() {
                return this._contentLength;
              }
              get headersReady() {
                return this._headersReceivedCapability.promise;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._cachedChunks.length > 0)
                  return {
                    value: this._cachedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const m = new u.PromiseCapability();
                return this._requests.push(m), m.promise;
              }
              cancel(m) {
                this._done = !0, this._headersReceivedCapability.reject(m);
                for (const C of this._requests)
                  C.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
              }
            }
            class y {
              constructor(m, C, w) {
                this._manager = m;
                const S = {
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = m.url, this._requestId = m.requestRange(C, w, S), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
              }
              _close() {
                this.onClosed?.(this);
              }
              _onDone(m) {
                const C = m.chunk;
                this._requests.length > 0 ? this._requests.shift().resolve({
                  value: C,
                  done: !1
                }) : this._queuedChunk = C, this._done = !0;
                for (const w of this._requests)
                  w.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._close();
              }
              _onError(m) {
                this._storedError = (0, d.createResponseStatusError)(m, this._url);
                for (const C of this._requests)
                  C.reject(this._storedError);
                this._requests.length = 0, this._queuedChunk = null;
              }
              _onProgress(m) {
                this.isStreamingSupported || this.onProgress?.({
                  loaded: m.loaded
                });
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._queuedChunk !== null) {
                  const C = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: C,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const m = new u.PromiseCapability();
                return this._requests.push(m), m.promise;
              }
              cancel(m) {
                this._done = !0;
                for (const C of this._requests)
                  C.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
              }
            }
          },
          /* 23 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.PDFNodeStream = void 0;
            var u = c(1), d = c(20);
            const p = /^file:\/\/\/[a-zA-Z]:\//;
            function v(w) {
              const S = require$$5, $ = S.parse(w);
              return $.protocol === "file:" || $.host ? $ : /^[a-z]:[/\\]/i.test(w) ? S.parse(`file:///${w}`) : ($.host || ($.protocol = "file:"), $);
            }
            class A {
              constructor(S) {
                this.source = S, this.url = v(S.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && S.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, u.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new m(this) : new y(this), this._fullRequestReader;
              }
              getRangeReader(S, $) {
                if ($ <= this._progressiveDataLength)
                  return null;
                const T = this.isFsUrl ? new C(this, S, $) : new f(this, S, $);
                return this._rangeRequestReaders.push(T), T;
              }
              cancelAllRequests(S) {
                this._fullRequestReader?.cancel(S);
                for (const $ of this._rangeRequestReaders.slice(0))
                  $.cancel(S);
              }
            }
            s.PDFNodeStream = A;
            class x {
              constructor(S) {
                this._url = S.url, this._done = !1, this._storedError = null, this.onProgress = null;
                const $ = S.source;
                this._contentLength = $.length, this._loaded = 0, this._filename = null, this._disableRange = $.disableRange || !1, this._rangeChunkSize = $.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !$.disableStream, this._isRangeSupported = !$.disableRange, this._readableStream = null, this._readCapability = new u.PromiseCapability(), this._headersCapability = new u.PromiseCapability();
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const S = this._readableStream.read();
                return S === null ? (this._readCapability = new u.PromiseCapability(), this.read()) : (this._loaded += S.length, this.onProgress?.({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: new Uint8Array(S).buffer,
                  done: !1
                });
              }
              cancel(S) {
                if (!this._readableStream) {
                  this._error(S);
                  return;
                }
                this._readableStream.destroy(S);
              }
              _error(S) {
                this._storedError = S, this._readCapability.resolve();
              }
              _setReadableStream(S) {
                this._readableStream = S, S.on("readable", () => {
                  this._readCapability.resolve();
                }), S.on("end", () => {
                  S.destroy(), this._done = !0, this._readCapability.resolve();
                }), S.on("error", ($) => {
                  this._error($);
                }), !this._isStreamingSupported && this._isRangeSupported && this._error(new u.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            class g {
              constructor(S) {
                this._url = S.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = new u.PromiseCapability();
                const $ = S.source;
                this._isStreamingSupported = !$.disableStream;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const S = this._readableStream.read();
                return S === null ? (this._readCapability = new u.PromiseCapability(), this.read()) : (this._loaded += S.length, this.onProgress?.({
                  loaded: this._loaded
                }), {
                  value: new Uint8Array(S).buffer,
                  done: !1
                });
              }
              cancel(S) {
                if (!this._readableStream) {
                  this._error(S);
                  return;
                }
                this._readableStream.destroy(S);
              }
              _error(S) {
                this._storedError = S, this._readCapability.resolve();
              }
              _setReadableStream(S) {
                this._readableStream = S, S.on("readable", () => {
                  this._readCapability.resolve();
                }), S.on("end", () => {
                  S.destroy(), this._done = !0, this._readCapability.resolve();
                }), S.on("error", ($) => {
                  this._error($);
                }), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            function b(w, S) {
              return {
                protocol: w.protocol,
                auth: w.auth,
                host: w.hostname,
                port: w.port,
                path: w.path,
                method: "GET",
                headers: S
              };
            }
            class y extends x {
              constructor(S) {
                super(S);
                const $ = (T) => {
                  if (T.statusCode === 404) {
                    const R = new u.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = R, this._headersCapability.reject(R);
                    return;
                  }
                  this._headersCapability.resolve(), this._setReadableStream(T);
                  const I = (R) => this._readableStream.headers[R.toLowerCase()], {
                    allowRangeRequests: _,
                    suggestedLength: E
                  } = (0, d.validateRangeRequestCapabilities)({
                    getResponseHeader: I,
                    isHttp: S.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = _, this._contentLength = E || this._contentLength, this._filename = (0, d.extractFilenameFromHeader)(I);
                };
                if (this._request = null, this._url.protocol === "http:") {
                  const T = require$$5;
                  this._request = T.request(b(this._url, S.httpHeaders), $);
                } else {
                  const T = require$$5;
                  this._request = T.request(b(this._url, S.httpHeaders), $);
                }
                this._request.on("error", (T) => {
                  this._storedError = T, this._headersCapability.reject(T);
                }), this._request.end();
              }
            }
            class f extends g {
              constructor(S, $, T) {
                super(S), this._httpHeaders = {};
                for (const _ in S.httpHeaders) {
                  const E = S.httpHeaders[_];
                  E !== void 0 && (this._httpHeaders[_] = E);
                }
                this._httpHeaders.Range = `bytes=${$}-${T - 1}`;
                const I = (_) => {
                  if (_.statusCode === 404) {
                    const E = new u.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = E;
                    return;
                  }
                  this._setReadableStream(_);
                };
                if (this._request = null, this._url.protocol === "http:") {
                  const _ = require$$5;
                  this._request = _.request(b(this._url, this._httpHeaders), I);
                } else {
                  const _ = require$$5;
                  this._request = _.request(b(this._url, this._httpHeaders), I);
                }
                this._request.on("error", (_) => {
                  this._storedError = _;
                }), this._request.end();
              }
            }
            class m extends x {
              constructor(S) {
                super(S);
                let $ = decodeURIComponent(this._url.path);
                p.test(this._url.href) && ($ = $.replace(/^\//, ""));
                const T = require$$5;
                T.lstat($, (I, _) => {
                  if (I) {
                    I.code === "ENOENT" && (I = new u.MissingPDFException(`Missing PDF "${$}".`)), this._storedError = I, this._headersCapability.reject(I);
                    return;
                  }
                  this._contentLength = _.size, this._setReadableStream(T.createReadStream($)), this._headersCapability.resolve();
                });
              }
            }
            class C extends g {
              constructor(S, $, T) {
                super(S);
                let I = decodeURIComponent(this._url.path);
                p.test(this._url.href) && (I = I.replace(/^\//, ""));
                const _ = require$$5;
                this._setReadableStream(_.createReadStream(I, {
                  start: $,
                  end: T - 1
                }));
              }
            }
          },
          /* 24 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.SVGGraphics = void 0;
            var u = c(6), d = c(1);
            const p = {
              fontStyle: "normal",
              fontWeight: "normal",
              fillColor: "#000000"
            }, v = "http://www.w3.org/XML/1998/namespace", A = "http://www.w3.org/1999/xlink", x = ["butt", "round", "square"], g = ["miter", "round", "bevel"], b = function(_, E = "", R = !1) {
              if (URL.createObjectURL && typeof Blob < "u" && !R)
                return URL.createObjectURL(new Blob([_], {
                  type: E
                }));
              const O = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
              let L = `data:${E};base64,`;
              for (let B = 0, F = _.length; B < F; B += 3) {
                const M = _[B] & 255, W = _[B + 1] & 255, j = _[B + 2] & 255, G = M >> 2, U = (M & 3) << 4 | W >> 4, k = B + 1 < F ? (W & 15) << 2 | j >> 6 : 64, N = B + 2 < F ? j & 63 : 64;
                L += O[G] + O[U] + O[k] + O[N];
              }
              return L;
            }, y = function() {
              const _ = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), E = 12, R = new Int32Array(256);
              for (let j = 0; j < 256; j++) {
                let G = j;
                for (let U = 0; U < 8; U++)
                  G = G & 1 ? 3988292384 ^ G >> 1 & 2147483647 : G >> 1 & 2147483647;
                R[j] = G;
              }
              function O(j, G, U) {
                let k = -1;
                for (let N = G; N < U; N++) {
                  const P = (k ^ j[N]) & 255, D = R[P];
                  k = k >>> 8 ^ D;
                }
                return k ^ -1;
              }
              function L(j, G, U, k) {
                let N = k;
                const P = G.length;
                U[N] = P >> 24 & 255, U[N + 1] = P >> 16 & 255, U[N + 2] = P >> 8 & 255, U[N + 3] = P & 255, N += 4, U[N] = j.charCodeAt(0) & 255, U[N + 1] = j.charCodeAt(1) & 255, U[N + 2] = j.charCodeAt(2) & 255, U[N + 3] = j.charCodeAt(3) & 255, N += 4, U.set(G, N), N += G.length;
                const D = O(U, k + 4, N);
                U[N] = D >> 24 & 255, U[N + 1] = D >> 16 & 255, U[N + 2] = D >> 8 & 255, U[N + 3] = D & 255;
              }
              function B(j, G, U) {
                let k = 1, N = 0;
                for (let P = G; P < U; ++P)
                  k = (k + (j[P] & 255)) % 65521, N = (N + k) % 65521;
                return N << 16 | k;
              }
              function F(j) {
                if (!d.isNodeJS)
                  return M(j);
                try {
                  const G = parseInt(process.versions.node) >= 8 ? j : Buffer.from(j), U = require$$5.deflateSync(G, {
                    level: 9
                  });
                  return U instanceof Uint8Array ? U : new Uint8Array(U);
                } catch (G) {
                  (0, d.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + G);
                }
                return M(j);
              }
              function M(j) {
                let G = j.length;
                const U = 65535, k = Math.ceil(G / U), N = new Uint8Array(2 + G + k * 5 + 4);
                let P = 0;
                N[P++] = 120, N[P++] = 156;
                let D = 0;
                for (; G > U; )
                  N[P++] = 0, N[P++] = 255, N[P++] = 255, N[P++] = 0, N[P++] = 0, N.set(j.subarray(D, D + U), P), P += U, D += U, G -= U;
                N[P++] = 1, N[P++] = G & 255, N[P++] = G >> 8 & 255, N[P++] = ~G & 65535 & 255, N[P++] = (~G & 65535) >> 8 & 255, N.set(j.subarray(D), P), P += j.length - D;
                const H = B(j, 0, j.length);
                return N[P++] = H >> 24 & 255, N[P++] = H >> 16 & 255, N[P++] = H >> 8 & 255, N[P++] = H & 255, N;
              }
              function W(j, G, U, k) {
                const N = j.width, P = j.height;
                let D, H, V;
                const Z = j.data;
                switch (G) {
                  case d.ImageKind.GRAYSCALE_1BPP:
                    H = 0, D = 1, V = N + 7 >> 3;
                    break;
                  case d.ImageKind.RGB_24BPP:
                    H = 2, D = 8, V = N * 3;
                    break;
                  case d.ImageKind.RGBA_32BPP:
                    H = 6, D = 8, V = N * 4;
                    break;
                  default:
                    throw new Error("invalid format");
                }
                const ne = new Uint8Array((1 + V) * P);
                let K = 0, q = 0;
                for (let ae = 0; ae < P; ++ae)
                  ne[K++] = 0, ne.set(Z.subarray(q, q + V), K), q += V, K += V;
                if (G === d.ImageKind.GRAYSCALE_1BPP && k) {
                  K = 0;
                  for (let ae = 0; ae < P; ae++) {
                    K++;
                    for (let se = 0; se < V; se++)
                      ne[K++] ^= 255;
                  }
                }
                const Y = new Uint8Array([N >> 24 & 255, N >> 16 & 255, N >> 8 & 255, N & 255, P >> 24 & 255, P >> 16 & 255, P >> 8 & 255, P & 255, D, H, 0, 0, 0]), ee = F(ne), Q = _.length + E * 3 + Y.length + ee.length, J = new Uint8Array(Q);
                let te = 0;
                return J.set(_, te), te += _.length, L("IHDR", Y, J, te), te += E + Y.length, L("IDATA", ee, J, te), te += E + ee.length, L("IEND", new Uint8Array(0), J, te), b(J, "image/png", U);
              }
              return function(G, U, k) {
                const N = G.kind === void 0 ? d.ImageKind.GRAYSCALE_1BPP : G.kind;
                return W(G, N, U, k);
              };
            }();
            class f {
              constructor() {
                this.fontSizeScale = 1, this.fontWeight = p.fontWeight, this.fontSize = 0, this.textMatrix = d.IDENTITY_MATRIX, this.fontMatrix = d.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = d.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = p.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
              }
              clone() {
                return Object.create(this);
              }
              setCurrentPoint(E, R) {
                this.x = E, this.y = R;
              }
            }
            function m(_) {
              let E = [];
              const R = [];
              for (const O of _) {
                if (O.fn === "save") {
                  E.push({
                    fnId: 92,
                    fn: "group",
                    items: []
                  }), R.push(E), E = E.at(-1).items;
                  continue;
                }
                O.fn === "restore" ? E = R.pop() : E.push(O);
              }
              return E;
            }
            function C(_) {
              if (Number.isInteger(_))
                return _.toString();
              const E = _.toFixed(10);
              let R = E.length - 1;
              if (E[R] !== "0")
                return E;
              do
                R--;
              while (E[R] === "0");
              return E.substring(0, E[R] === "." ? R : R + 1);
            }
            function w(_) {
              if (_[4] === 0 && _[5] === 0) {
                if (_[1] === 0 && _[2] === 0)
                  return _[0] === 1 && _[3] === 1 ? "" : `scale(${C(_[0])} ${C(_[3])})`;
                if (_[0] === _[3] && _[1] === -_[2]) {
                  const E = Math.acos(_[0]) * 180 / Math.PI;
                  return `rotate(${C(E)})`;
                }
              } else if (_[0] === 1 && _[1] === 0 && _[2] === 0 && _[3] === 1)
                return `translate(${C(_[4])} ${C(_[5])})`;
              return `matrix(${C(_[0])} ${C(_[1])} ${C(_[2])} ${C(_[3])} ${C(_[4])} ${C(_[5])})`;
            }
            let S = 0, $ = 0, T = 0;
            class I {
              constructor(E, R, O = !1) {
                (0, u.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future."), this.svgFactory = new u.DOMSVGFactory(), this.current = new f(), this.transformMatrix = d.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = E, this.objs = R, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!O, this._operatorIdMapping = [];
                for (const L in d.OPS)
                  this._operatorIdMapping[d.OPS[L]] = L;
              }
              getObject(E, R = null) {
                return typeof E == "string" ? E.startsWith("g_") ? this.commonObjs.get(E) : this.objs.get(E) : R;
              }
              save() {
                this.transformStack.push(this.transformMatrix);
                const E = this.current;
                this.extraStack.push(E), this.current = E.clone();
              }
              restore() {
                this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
              }
              group(E) {
                this.save(), this.executeOpTree(E), this.restore();
              }
              loadDependencies(E) {
                const R = E.fnArray, O = E.argsArray;
                for (let L = 0, B = R.length; L < B; L++)
                  if (R[L] === d.OPS.dependency)
                    for (const F of O[L]) {
                      const M = F.startsWith("g_") ? this.commonObjs : this.objs, W = new Promise((j) => {
                        M.get(F, j);
                      });
                      this.current.dependencies.push(W);
                    }
                return Promise.all(this.current.dependencies);
              }
              transform(E, R, O, L, B, F) {
                const M = [E, R, O, L, B, F];
                this.transformMatrix = d.Util.transform(this.transformMatrix, M), this.tgrp = null;
              }
              getSVG(E, R) {
                this.viewport = R;
                const O = this._initialize(R);
                return this.loadDependencies(E).then(() => (this.transformMatrix = d.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(E)), O));
              }
              convertOpList(E) {
                const R = this._operatorIdMapping, O = E.argsArray, L = E.fnArray, B = [];
                for (let F = 0, M = L.length; F < M; F++) {
                  const W = L[F];
                  B.push({
                    fnId: W,
                    fn: R[W],
                    args: O[F]
                  });
                }
                return m(B);
              }
              executeOpTree(E) {
                for (const R of E) {
                  const O = R.fn, L = R.fnId, B = R.args;
                  switch (L | 0) {
                    case d.OPS.beginText:
                      this.beginText();
                      break;
                    case d.OPS.dependency:
                      break;
                    case d.OPS.setLeading:
                      this.setLeading(B);
                      break;
                    case d.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(B[0], B[1]);
                      break;
                    case d.OPS.setFont:
                      this.setFont(B);
                      break;
                    case d.OPS.showText:
                      this.showText(B[0]);
                      break;
                    case d.OPS.showSpacedText:
                      this.showText(B[0]);
                      break;
                    case d.OPS.endText:
                      this.endText();
                      break;
                    case d.OPS.moveText:
                      this.moveText(B[0], B[1]);
                      break;
                    case d.OPS.setCharSpacing:
                      this.setCharSpacing(B[0]);
                      break;
                    case d.OPS.setWordSpacing:
                      this.setWordSpacing(B[0]);
                      break;
                    case d.OPS.setHScale:
                      this.setHScale(B[0]);
                      break;
                    case d.OPS.setTextMatrix:
                      this.setTextMatrix(B[0], B[1], B[2], B[3], B[4], B[5]);
                      break;
                    case d.OPS.setTextRise:
                      this.setTextRise(B[0]);
                      break;
                    case d.OPS.setTextRenderingMode:
                      this.setTextRenderingMode(B[0]);
                      break;
                    case d.OPS.setLineWidth:
                      this.setLineWidth(B[0]);
                      break;
                    case d.OPS.setLineJoin:
                      this.setLineJoin(B[0]);
                      break;
                    case d.OPS.setLineCap:
                      this.setLineCap(B[0]);
                      break;
                    case d.OPS.setMiterLimit:
                      this.setMiterLimit(B[0]);
                      break;
                    case d.OPS.setFillRGBColor:
                      this.setFillRGBColor(B[0], B[1], B[2]);
                      break;
                    case d.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(B[0], B[1], B[2]);
                      break;
                    case d.OPS.setStrokeColorN:
                      this.setStrokeColorN(B);
                      break;
                    case d.OPS.setFillColorN:
                      this.setFillColorN(B);
                      break;
                    case d.OPS.shadingFill:
                      this.shadingFill(B[0]);
                      break;
                    case d.OPS.setDash:
                      this.setDash(B[0], B[1]);
                      break;
                    case d.OPS.setRenderingIntent:
                      this.setRenderingIntent(B[0]);
                      break;
                    case d.OPS.setFlatness:
                      this.setFlatness(B[0]);
                      break;
                    case d.OPS.setGState:
                      this.setGState(B[0]);
                      break;
                    case d.OPS.fill:
                      this.fill();
                      break;
                    case d.OPS.eoFill:
                      this.eoFill();
                      break;
                    case d.OPS.stroke:
                      this.stroke();
                      break;
                    case d.OPS.fillStroke:
                      this.fillStroke();
                      break;
                    case d.OPS.eoFillStroke:
                      this.eoFillStroke();
                      break;
                    case d.OPS.clip:
                      this.clip("nonzero");
                      break;
                    case d.OPS.eoClip:
                      this.clip("evenodd");
                      break;
                    case d.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask();
                      break;
                    case d.OPS.paintImageXObject:
                      this.paintImageXObject(B[0]);
                      break;
                    case d.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(B[0]);
                      break;
                    case d.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(B[0]);
                      break;
                    case d.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(B[0], B[1]);
                      break;
                    case d.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd();
                      break;
                    case d.OPS.closePath:
                      this.closePath();
                      break;
                    case d.OPS.closeStroke:
                      this.closeStroke();
                      break;
                    case d.OPS.closeFillStroke:
                      this.closeFillStroke();
                      break;
                    case d.OPS.closeEOFillStroke:
                      this.closeEOFillStroke();
                      break;
                    case d.OPS.nextLine:
                      this.nextLine();
                      break;
                    case d.OPS.transform:
                      this.transform(B[0], B[1], B[2], B[3], B[4], B[5]);
                      break;
                    case d.OPS.constructPath:
                      this.constructPath(B[0], B[1]);
                      break;
                    case d.OPS.endPath:
                      this.endPath();
                      break;
                    case 92:
                      this.group(R.items);
                      break;
                    default:
                      (0, d.warn)(`Unimplemented operator ${O}`);
                      break;
                  }
                }
              }
              setWordSpacing(E) {
                this.current.wordSpacing = E;
              }
              setCharSpacing(E) {
                this.current.charSpacing = E;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              setTextMatrix(E, R, O, L, B, F) {
                const M = this.current;
                M.textMatrix = M.lineMatrix = [E, R, O, L, B, F], M.textMatrixScale = Math.hypot(E, R), M.x = M.lineX = 0, M.y = M.lineY = 0, M.xcoords = [], M.ycoords = [], M.tspan = this.svgFactory.createElement("svg:tspan"), M.tspan.setAttributeNS(null, "font-family", M.fontFamily), M.tspan.setAttributeNS(null, "font-size", `${C(M.fontSize)}px`), M.tspan.setAttributeNS(null, "y", C(-M.y)), M.txtElement = this.svgFactory.createElement("svg:text"), M.txtElement.append(M.tspan);
              }
              beginText() {
                const E = this.current;
                E.x = E.lineX = 0, E.y = E.lineY = 0, E.textMatrix = d.IDENTITY_MATRIX, E.lineMatrix = d.IDENTITY_MATRIX, E.textMatrixScale = 1, E.tspan = this.svgFactory.createElement("svg:tspan"), E.txtElement = this.svgFactory.createElement("svg:text"), E.txtgrp = this.svgFactory.createElement("svg:g"), E.xcoords = [], E.ycoords = [];
              }
              moveText(E, R) {
                const O = this.current;
                O.x = O.lineX += E, O.y = O.lineY += R, O.xcoords = [], O.ycoords = [], O.tspan = this.svgFactory.createElement("svg:tspan"), O.tspan.setAttributeNS(null, "font-family", O.fontFamily), O.tspan.setAttributeNS(null, "font-size", `${C(O.fontSize)}px`), O.tspan.setAttributeNS(null, "y", C(-O.y));
              }
              showText(E) {
                const R = this.current, O = R.font, L = R.fontSize;
                if (L === 0)
                  return;
                const B = R.fontSizeScale, F = R.charSpacing, M = R.wordSpacing, W = R.fontDirection, j = R.textHScale * W, G = O.vertical, U = G ? 1 : -1, k = O.defaultVMetrics, N = L * R.fontMatrix[0];
                let P = 0;
                for (const V of E) {
                  if (V === null) {
                    P += W * M;
                    continue;
                  } else if (typeof V == "number") {
                    P += U * V * L / 1e3;
                    continue;
                  }
                  const Z = (V.isSpace ? M : 0) + F, ne = V.fontChar;
                  let K, q, Y = V.width;
                  if (G) {
                    let Q;
                    const J = V.vmetric || k;
                    Q = V.vmetric ? J[1] : Y * 0.5, Q = -Q * N;
                    const te = J[2] * N;
                    Y = J ? -J[0] : Y, K = Q / B, q = (P + te) / B;
                  } else
                    K = P / B, q = 0;
                  (V.isInFont || O.missingFile) && (R.xcoords.push(R.x + K), G && R.ycoords.push(-R.y + q), R.tspan.textContent += ne);
                  const ee = G ? Y * N - Z * W : Y * N + Z * W;
                  P += ee;
                }
                R.tspan.setAttributeNS(null, "x", R.xcoords.map(C).join(" ")), G ? R.tspan.setAttributeNS(null, "y", R.ycoords.map(C).join(" ")) : R.tspan.setAttributeNS(null, "y", C(-R.y)), G ? R.y -= P : R.x += P * j, R.tspan.setAttributeNS(null, "font-family", R.fontFamily), R.tspan.setAttributeNS(null, "font-size", `${C(R.fontSize)}px`), R.fontStyle !== p.fontStyle && R.tspan.setAttributeNS(null, "font-style", R.fontStyle), R.fontWeight !== p.fontWeight && R.tspan.setAttributeNS(null, "font-weight", R.fontWeight);
                const D = R.textRenderingMode & d.TextRenderingMode.FILL_STROKE_MASK;
                if (D === d.TextRenderingMode.FILL || D === d.TextRenderingMode.FILL_STROKE ? (R.fillColor !== p.fillColor && R.tspan.setAttributeNS(null, "fill", R.fillColor), R.fillAlpha < 1 && R.tspan.setAttributeNS(null, "fill-opacity", R.fillAlpha)) : R.textRenderingMode === d.TextRenderingMode.ADD_TO_PATH ? R.tspan.setAttributeNS(null, "fill", "transparent") : R.tspan.setAttributeNS(null, "fill", "none"), D === d.TextRenderingMode.STROKE || D === d.TextRenderingMode.FILL_STROKE) {
                  const V = 1 / (R.textMatrixScale || 1);
                  this._setStrokeAttributes(R.tspan, V);
                }
                let H = R.textMatrix;
                R.textRise !== 0 && (H = H.slice(), H[5] += R.textRise), R.txtElement.setAttributeNS(null, "transform", `${w(H)} scale(${C(j)}, -1)`), R.txtElement.setAttributeNS(v, "xml:space", "preserve"), R.txtElement.append(R.tspan), R.txtgrp.append(R.txtElement), this._ensureTransformGroup().append(R.txtElement);
              }
              setLeadingMoveText(E, R) {
                this.setLeading(-R), this.moveText(E, R);
              }
              addFontStyle(E) {
                if (!E.data)
                  throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.append(this.cssStyle));
                const R = b(E.data, E.mimetype, this.forceDataSchema);
                this.cssStyle.textContent += `@font-face { font-family: "${E.loadedName}"; src: url(${R}); }
`;
              }
              setFont(E) {
                const R = this.current, O = this.commonObjs.get(E[0]);
                let L = E[1];
                R.font = O, this.embedFonts && !O.missingFile && !this.embeddedFonts[O.loadedName] && (this.addFontStyle(O), this.embeddedFonts[O.loadedName] = O), R.fontMatrix = O.fontMatrix || d.FONT_IDENTITY_MATRIX;
                let B = "normal";
                O.black ? B = "900" : O.bold && (B = "bold");
                const F = O.italic ? "italic" : "normal";
                L < 0 ? (L = -L, R.fontDirection = -1) : R.fontDirection = 1, R.fontSize = L, R.fontFamily = O.loadedName, R.fontWeight = B, R.fontStyle = F, R.tspan = this.svgFactory.createElement("svg:tspan"), R.tspan.setAttributeNS(null, "y", C(-R.y)), R.xcoords = [], R.ycoords = [];
              }
              endText() {
                const E = this.current;
                E.textRenderingMode & d.TextRenderingMode.ADD_TO_PATH_FLAG && E.txtElement?.hasChildNodes() && (E.element = E.txtElement, this.clip("nonzero"), this.endPath());
              }
              setLineWidth(E) {
                E > 0 && (this.current.lineWidth = E);
              }
              setLineCap(E) {
                this.current.lineCap = x[E];
              }
              setLineJoin(E) {
                this.current.lineJoin = g[E];
              }
              setMiterLimit(E) {
                this.current.miterLimit = E;
              }
              setStrokeAlpha(E) {
                this.current.strokeAlpha = E;
              }
              setStrokeRGBColor(E, R, O) {
                this.current.strokeColor = d.Util.makeHexColor(E, R, O);
              }
              setFillAlpha(E) {
                this.current.fillAlpha = E;
              }
              setFillRGBColor(E, R, O) {
                this.current.fillColor = d.Util.makeHexColor(E, R, O), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
              }
              setStrokeColorN(E) {
                this.current.strokeColor = this._makeColorN_Pattern(E);
              }
              setFillColorN(E) {
                this.current.fillColor = this._makeColorN_Pattern(E);
              }
              shadingFill(E) {
                const {
                  width: R,
                  height: O
                } = this.viewport, L = d.Util.inverseTransform(this.transformMatrix), [B, F, M, W] = d.Util.getAxialAlignedBoundingBox([0, 0, R, O], L), j = this.svgFactory.createElement("svg:rect");
                j.setAttributeNS(null, "x", B), j.setAttributeNS(null, "y", F), j.setAttributeNS(null, "width", M - B), j.setAttributeNS(null, "height", W - F), j.setAttributeNS(null, "fill", this._makeShadingPattern(E)), this.current.fillAlpha < 1 && j.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().append(j);
              }
              _makeColorN_Pattern(E) {
                return E[0] === "TilingPattern" ? this._makeTilingPattern(E) : this._makeShadingPattern(E);
              }
              _makeTilingPattern(E) {
                const R = E[1], O = E[2], L = E[3] || d.IDENTITY_MATRIX, [B, F, M, W] = E[4], j = E[5], G = E[6], U = E[7], k = `shading${T++}`, [N, P, D, H] = d.Util.normalizeRect([...d.Util.applyTransform([B, F], L), ...d.Util.applyTransform([M, W], L)]), [V, Z] = d.Util.singularValueDecompose2dScale(L), ne = j * V, K = G * Z, q = this.svgFactory.createElement("svg:pattern");
                q.setAttributeNS(null, "id", k), q.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), q.setAttributeNS(null, "width", ne), q.setAttributeNS(null, "height", K), q.setAttributeNS(null, "x", `${N}`), q.setAttributeNS(null, "y", `${P}`);
                const Y = this.svg, ee = this.transformMatrix, Q = this.current.fillColor, J = this.current.strokeColor, te = this.svgFactory.create(D - N, H - P);
                if (this.svg = te, this.transformMatrix = L, U === 2) {
                  const ae = d.Util.makeHexColor(...R);
                  this.current.fillColor = ae, this.current.strokeColor = ae;
                }
                return this.executeOpTree(this.convertOpList(O)), this.svg = Y, this.transformMatrix = ee, this.current.fillColor = Q, this.current.strokeColor = J, q.append(te.childNodes[0]), this.defs.append(q), `url(#${k})`;
              }
              _makeShadingPattern(E) {
                switch (typeof E == "string" && (E = this.objs.get(E)), E[0]) {
                  case "RadialAxial":
                    const R = `shading${T++}`, O = E[3];
                    let L;
                    switch (E[1]) {
                      case "axial":
                        const B = E[4], F = E[5];
                        L = this.svgFactory.createElement("svg:linearGradient"), L.setAttributeNS(null, "id", R), L.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), L.setAttributeNS(null, "x1", B[0]), L.setAttributeNS(null, "y1", B[1]), L.setAttributeNS(null, "x2", F[0]), L.setAttributeNS(null, "y2", F[1]);
                        break;
                      case "radial":
                        const M = E[4], W = E[5], j = E[6], G = E[7];
                        L = this.svgFactory.createElement("svg:radialGradient"), L.setAttributeNS(null, "id", R), L.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), L.setAttributeNS(null, "cx", W[0]), L.setAttributeNS(null, "cy", W[1]), L.setAttributeNS(null, "r", G), L.setAttributeNS(null, "fx", M[0]), L.setAttributeNS(null, "fy", M[1]), L.setAttributeNS(null, "fr", j);
                        break;
                      default:
                        throw new Error(`Unknown RadialAxial type: ${E[1]}`);
                    }
                    for (const B of O) {
                      const F = this.svgFactory.createElement("svg:stop");
                      F.setAttributeNS(null, "offset", B[0]), F.setAttributeNS(null, "stop-color", B[1]), L.append(F);
                    }
                    return this.defs.append(L), `url(#${R})`;
                  case "Mesh":
                    return (0, d.warn)("Unimplemented pattern Mesh"), null;
                  case "Dummy":
                    return "hotpink";
                  default:
                    throw new Error(`Unknown IR type: ${E[0]}`);
                }
              }
              setDash(E, R) {
                this.current.dashArray = E, this.current.dashPhase = R;
              }
              constructPath(E, R) {
                const O = this.current;
                let L = O.x, B = O.y, F = [], M = 0;
                for (const W of E)
                  switch (W | 0) {
                    case d.OPS.rectangle:
                      L = R[M++], B = R[M++];
                      const j = R[M++], G = R[M++], U = L + j, k = B + G;
                      F.push("M", C(L), C(B), "L", C(U), C(B), "L", C(U), C(k), "L", C(L), C(k), "Z");
                      break;
                    case d.OPS.moveTo:
                      L = R[M++], B = R[M++], F.push("M", C(L), C(B));
                      break;
                    case d.OPS.lineTo:
                      L = R[M++], B = R[M++], F.push("L", C(L), C(B));
                      break;
                    case d.OPS.curveTo:
                      L = R[M + 4], B = R[M + 5], F.push("C", C(R[M]), C(R[M + 1]), C(R[M + 2]), C(R[M + 3]), C(L), C(B)), M += 6;
                      break;
                    case d.OPS.curveTo2:
                      F.push("C", C(L), C(B), C(R[M]), C(R[M + 1]), C(R[M + 2]), C(R[M + 3])), L = R[M + 2], B = R[M + 3], M += 4;
                      break;
                    case d.OPS.curveTo3:
                      L = R[M + 2], B = R[M + 3], F.push("C", C(R[M]), C(R[M + 1]), C(L), C(B), C(L), C(B)), M += 4;
                      break;
                    case d.OPS.closePath:
                      F.push("Z");
                      break;
                  }
                F = F.join(" "), O.path && E.length > 0 && E[0] !== d.OPS.rectangle && E[0] !== d.OPS.moveTo ? F = O.path.getAttributeNS(null, "d") + F : (O.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().append(O.path)), O.path.setAttributeNS(null, "d", F), O.path.setAttributeNS(null, "fill", "none"), O.element = O.path, O.setCurrentPoint(L, B);
              }
              endPath() {
                const E = this.current;
                if (E.path = null, !this.pendingClip)
                  return;
                if (!E.element) {
                  this.pendingClip = null;
                  return;
                }
                const R = `clippath${S++}`, O = this.svgFactory.createElement("svg:clipPath");
                O.setAttributeNS(null, "id", R), O.setAttributeNS(null, "transform", w(this.transformMatrix));
                const L = E.element.cloneNode(!0);
                if (this.pendingClip === "evenodd" ? L.setAttributeNS(null, "clip-rule", "evenodd") : L.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, O.append(L), this.defs.append(O), E.activeClipUrl) {
                  E.clipGroup = null;
                  for (const B of this.extraStack)
                    B.clipGroup = null;
                  O.setAttributeNS(null, "clip-path", E.activeClipUrl);
                }
                E.activeClipUrl = `url(#${R})`, this.tgrp = null;
              }
              clip(E) {
                this.pendingClip = E;
              }
              closePath() {
                const E = this.current;
                if (E.path) {
                  const R = `${E.path.getAttributeNS(null, "d")}Z`;
                  E.path.setAttributeNS(null, "d", R);
                }
              }
              setLeading(E) {
                this.current.leading = -E;
              }
              setTextRise(E) {
                this.current.textRise = E;
              }
              setTextRenderingMode(E) {
                this.current.textRenderingMode = E;
              }
              setHScale(E) {
                this.current.textHScale = E / 100;
              }
              setRenderingIntent(E) {
              }
              setFlatness(E) {
              }
              setGState(E) {
                for (const [R, O] of E)
                  switch (R) {
                    case "LW":
                      this.setLineWidth(O);
                      break;
                    case "LC":
                      this.setLineCap(O);
                      break;
                    case "LJ":
                      this.setLineJoin(O);
                      break;
                    case "ML":
                      this.setMiterLimit(O);
                      break;
                    case "D":
                      this.setDash(O[0], O[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(O);
                      break;
                    case "FL":
                      this.setFlatness(O);
                      break;
                    case "Font":
                      this.setFont(O);
                      break;
                    case "CA":
                      this.setStrokeAlpha(O);
                      break;
                    case "ca":
                      this.setFillAlpha(O);
                      break;
                    default:
                      (0, d.warn)(`Unimplemented graphic state operator ${R}`);
                      break;
                  }
              }
              fill() {
                const E = this.current;
                E.element && (E.element.setAttributeNS(null, "fill", E.fillColor), E.element.setAttributeNS(null, "fill-opacity", E.fillAlpha), this.endPath());
              }
              stroke() {
                const E = this.current;
                E.element && (this._setStrokeAttributes(E.element), E.element.setAttributeNS(null, "fill", "none"), this.endPath());
              }
              _setStrokeAttributes(E, R = 1) {
                const O = this.current;
                let L = O.dashArray;
                R !== 1 && L.length > 0 && (L = L.map(function(B) {
                  return R * B;
                })), E.setAttributeNS(null, "stroke", O.strokeColor), E.setAttributeNS(null, "stroke-opacity", O.strokeAlpha), E.setAttributeNS(null, "stroke-miterlimit", C(O.miterLimit)), E.setAttributeNS(null, "stroke-linecap", O.lineCap), E.setAttributeNS(null, "stroke-linejoin", O.lineJoin), E.setAttributeNS(null, "stroke-width", C(R * O.lineWidth) + "px"), E.setAttributeNS(null, "stroke-dasharray", L.map(C).join(" ")), E.setAttributeNS(null, "stroke-dashoffset", C(R * O.dashPhase) + "px");
              }
              eoFill() {
                this.current.element?.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
              }
              fillStroke() {
                this.stroke(), this.fill();
              }
              eoFillStroke() {
                this.current.element?.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.closePath(), this.eoFillStroke();
              }
              paintSolidColorImageMask() {
                const E = this.svgFactory.createElement("svg:rect");
                E.setAttributeNS(null, "x", "0"), E.setAttributeNS(null, "y", "0"), E.setAttributeNS(null, "width", "1px"), E.setAttributeNS(null, "height", "1px"), E.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().append(E);
              }
              paintImageXObject(E) {
                const R = this.getObject(E);
                if (!R) {
                  (0, d.warn)(`Dependent image with object ID ${E} is not ready yet`);
                  return;
                }
                this.paintInlineImageXObject(R);
              }
              paintInlineImageXObject(E, R) {
                const O = E.width, L = E.height, B = y(E, this.forceDataSchema, !!R), F = this.svgFactory.createElement("svg:rect");
                F.setAttributeNS(null, "x", "0"), F.setAttributeNS(null, "y", "0"), F.setAttributeNS(null, "width", C(O)), F.setAttributeNS(null, "height", C(L)), this.current.element = F, this.clip("nonzero");
                const M = this.svgFactory.createElement("svg:image");
                M.setAttributeNS(A, "xlink:href", B), M.setAttributeNS(null, "x", "0"), M.setAttributeNS(null, "y", C(-L)), M.setAttributeNS(null, "width", C(O) + "px"), M.setAttributeNS(null, "height", C(L) + "px"), M.setAttributeNS(null, "transform", `scale(${C(1 / O)} ${C(-1 / L)})`), R ? R.append(M) : this._ensureTransformGroup().append(M);
              }
              paintImageMaskXObject(E) {
                const R = this.getObject(E.data, E);
                if (R.bitmap) {
                  (0, d.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                  return;
                }
                const O = this.current, L = R.width, B = R.height, F = O.fillColor;
                O.maskId = `mask${$++}`;
                const M = this.svgFactory.createElement("svg:mask");
                M.setAttributeNS(null, "id", O.maskId);
                const W = this.svgFactory.createElement("svg:rect");
                W.setAttributeNS(null, "x", "0"), W.setAttributeNS(null, "y", "0"), W.setAttributeNS(null, "width", C(L)), W.setAttributeNS(null, "height", C(B)), W.setAttributeNS(null, "fill", F), W.setAttributeNS(null, "mask", `url(#${O.maskId})`), this.defs.append(M), this._ensureTransformGroup().append(W), this.paintInlineImageXObject(R, M);
              }
              paintFormXObjectBegin(E, R) {
                if (Array.isArray(E) && E.length === 6 && this.transform(E[0], E[1], E[2], E[3], E[4], E[5]), R) {
                  const O = R[2] - R[0], L = R[3] - R[1], B = this.svgFactory.createElement("svg:rect");
                  B.setAttributeNS(null, "x", R[0]), B.setAttributeNS(null, "y", R[1]), B.setAttributeNS(null, "width", C(O)), B.setAttributeNS(null, "height", C(L)), this.current.element = B, this.clip("nonzero"), this.endPath();
                }
              }
              paintFormXObjectEnd() {
              }
              _initialize(E) {
                const R = this.svgFactory.create(E.width, E.height), O = this.svgFactory.createElement("svg:defs");
                R.append(O), this.defs = O;
                const L = this.svgFactory.createElement("svg:g");
                return L.setAttributeNS(null, "transform", w(E.transform)), R.append(L), this.svg = L, R;
              }
              _ensureClipGroup() {
                if (!this.current.clipGroup) {
                  const E = this.svgFactory.createElement("svg:g");
                  E.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.append(E), this.current.clipGroup = E;
                }
                return this.current.clipGroup;
              }
              _ensureTransformGroup() {
                return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", w(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().append(this.tgrp) : this.svg.append(this.tgrp)), this.tgrp;
              }
            }
            s.SVGGraphics = I;
          },
          /* 25 */
          /***/
          (a, s) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.XfaText = void 0;
            class c {
              static textContent(d) {
                const p = [], v = {
                  items: p,
                  styles: /* @__PURE__ */ Object.create(null)
                };
                function A(x) {
                  if (!x)
                    return;
                  let g = null;
                  const b = x.name;
                  if (b === "#text")
                    g = x.value;
                  else if (c.shouldBuildText(b))
                    x?.attributes?.textContent ? g = x.attributes.textContent : x.value && (g = x.value);
                  else return;
                  if (g !== null && p.push({
                    str: g
                  }), !!x.children)
                    for (const y of x.children)
                      A(y);
                }
                return A(d), v;
              }
              static shouldBuildText(d) {
                return !(d === "textarea" || d === "input" || d === "option" || d === "select");
              }
            }
            s.XfaText = c;
          },
          /* 26 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.TextLayerRenderTask = void 0, s.renderTextLayer = w, s.updateTextLayer = S;
            var u = c(1), d = c(6);
            const p = 1e5, v = 30, A = 0.8, x = /* @__PURE__ */ new Map();
            function g($, T) {
              let I;
              if (T && u.FeatureTest.isOffscreenCanvasSupported)
                I = new OffscreenCanvas($, $).getContext("2d", {
                  alpha: !1
                });
              else {
                const _ = document.createElement("canvas");
                _.width = _.height = $, I = _.getContext("2d", {
                  alpha: !1
                });
              }
              return I;
            }
            function b($, T) {
              const I = x.get($);
              if (I)
                return I;
              const _ = g(v, T);
              _.font = `${v}px ${$}`;
              const E = _.measureText("");
              let R = E.fontBoundingBoxAscent, O = Math.abs(E.fontBoundingBoxDescent);
              if (R) {
                const B = R / (R + O);
                return x.set($, B), _.canvas.width = _.canvas.height = 0, B;
              }
              _.strokeStyle = "red", _.clearRect(0, 0, v, v), _.strokeText("g", 0, 0);
              let L = _.getImageData(0, 0, v, v).data;
              O = 0;
              for (let B = L.length - 1 - 3; B >= 0; B -= 4)
                if (L[B] > 0) {
                  O = Math.ceil(B / 4 / v);
                  break;
                }
              _.clearRect(0, 0, v, v), _.strokeText("A", 0, v), L = _.getImageData(0, 0, v, v).data, R = 0;
              for (let B = 0, F = L.length; B < F; B += 4)
                if (L[B] > 0) {
                  R = v - Math.floor(B / 4 / v);
                  break;
                }
              if (_.canvas.width = _.canvas.height = 0, R) {
                const B = R / (R + O);
                return x.set($, B), B;
              }
              return x.set($, A), A;
            }
            function y($, T, I) {
              const _ = document.createElement("span"), E = {
                angle: 0,
                canvasWidth: 0,
                hasText: T.str !== "",
                hasEOL: T.hasEOL,
                fontSize: 0
              };
              $._textDivs.push(_);
              const R = u.Util.transform($._transform, T.transform);
              let O = Math.atan2(R[1], R[0]);
              const L = I[T.fontName];
              L.vertical && (O += Math.PI / 2);
              const B = Math.hypot(R[2], R[3]), F = B * b(L.fontFamily, $._isOffscreenCanvasSupported);
              let M, W;
              O === 0 ? (M = R[4], W = R[5] - F) : (M = R[4] + F * Math.sin(O), W = R[5] - F * Math.cos(O));
              const j = "calc(var(--scale-factor)*", G = _.style;
              $._container === $._rootContainer ? (G.left = `${(100 * M / $._pageWidth).toFixed(2)}%`, G.top = `${(100 * W / $._pageHeight).toFixed(2)}%`) : (G.left = `${j}${M.toFixed(2)}px)`, G.top = `${j}${W.toFixed(2)}px)`), G.fontSize = `${j}${B.toFixed(2)}px)`, G.fontFamily = L.fontFamily, E.fontSize = B, _.setAttribute("role", "presentation"), _.textContent = T.str, _.dir = T.dir, $._fontInspectorEnabled && (_.dataset.fontName = T.fontName), O !== 0 && (E.angle = O * (180 / Math.PI));
              let U = !1;
              if (T.str.length > 1)
                U = !0;
              else if (T.str !== " " && T.transform[0] !== T.transform[3]) {
                const k = Math.abs(T.transform[0]), N = Math.abs(T.transform[3]);
                k !== N && Math.max(k, N) / Math.min(k, N) > 1.5 && (U = !0);
              }
              U && (E.canvasWidth = L.vertical ? T.height : T.width), $._textDivProperties.set(_, E), $._isReadableStream && $._layoutText(_);
            }
            function f($) {
              const {
                div: T,
                scale: I,
                properties: _,
                ctx: E,
                prevFontSize: R,
                prevFontFamily: O
              } = $, {
                style: L
              } = T;
              let B = "";
              if (_.canvasWidth !== 0 && _.hasText) {
                const {
                  fontFamily: F
                } = L, {
                  canvasWidth: M,
                  fontSize: W
                } = _;
                (R !== W || O !== F) && (E.font = `${W * I}px ${F}`, $.prevFontSize = W, $.prevFontFamily = F);
                const {
                  width: j
                } = E.measureText(T.textContent);
                j > 0 && (B = `scaleX(${M * I / j})`);
              }
              _.angle !== 0 && (B = `rotate(${_.angle}deg) ${B}`), B.length > 0 && (L.transform = B);
            }
            function m($) {
              if ($._canceled)
                return;
              const T = $._textDivs, I = $._capability;
              if (T.length > p) {
                I.resolve();
                return;
              }
              if (!$._isReadableStream)
                for (const E of T)
                  $._layoutText(E);
              I.resolve();
            }
            class C {
              constructor({
                textContentSource: T,
                container: I,
                viewport: _,
                textDivs: E,
                textDivProperties: R,
                textContentItemsStr: O,
                isOffscreenCanvasSupported: L
              }) {
                this._textContentSource = T, this._isReadableStream = T instanceof ReadableStream, this._container = this._rootContainer = I, this._textDivs = E || [], this._textContentItemsStr = O || [], this._isOffscreenCanvasSupported = L, this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled, this._reader = null, this._textDivProperties = R || /* @__PURE__ */ new WeakMap(), this._canceled = !1, this._capability = new u.PromiseCapability(), this._layoutTextParams = {
                  prevFontSize: null,
                  prevFontFamily: null,
                  div: null,
                  scale: _.scale * (globalThis.devicePixelRatio || 1),
                  properties: null,
                  ctx: g(0, L)
                };
                const {
                  pageWidth: B,
                  pageHeight: F,
                  pageX: M,
                  pageY: W
                } = _.rawDims;
                this._transform = [1, 0, 0, -1, -M, W + F], this._pageWidth = B, this._pageHeight = F, (0, d.setLayerDimensions)(I, _), this._capability.promise.finally(() => {
                  this._layoutTextParams = null;
                }).catch(() => {
                });
              }
              get promise() {
                return this._capability.promise;
              }
              cancel() {
                this._canceled = !0, this._reader && (this._reader.cancel(new u.AbortException("TextLayer task cancelled.")).catch(() => {
                }), this._reader = null), this._capability.reject(new u.AbortException("TextLayer task cancelled."));
              }
              _processItems(T, I) {
                for (const _ of T) {
                  if (_.str === void 0) {
                    if (_.type === "beginMarkedContentProps" || _.type === "beginMarkedContent") {
                      const E = this._container;
                      this._container = document.createElement("span"), this._container.classList.add("markedContent"), _.id !== null && this._container.setAttribute("id", `${_.id}`), E.append(this._container);
                    } else _.type === "endMarkedContent" && (this._container = this._container.parentNode);
                    continue;
                  }
                  this._textContentItemsStr.push(_.str), y(this, _, I);
                }
              }
              _layoutText(T) {
                const I = this._layoutTextParams.properties = this._textDivProperties.get(T);
                if (this._layoutTextParams.div = T, f(this._layoutTextParams), I.hasText && this._container.append(T), I.hasEOL) {
                  const _ = document.createElement("br");
                  _.setAttribute("role", "presentation"), this._container.append(_);
                }
              }
              _render() {
                const T = new u.PromiseCapability();
                let I = /* @__PURE__ */ Object.create(null);
                if (this._isReadableStream) {
                  const _ = () => {
                    this._reader.read().then(({
                      value: E,
                      done: R
                    }) => {
                      if (R) {
                        T.resolve();
                        return;
                      }
                      Object.assign(I, E.styles), this._processItems(E.items, I), _();
                    }, T.reject);
                  };
                  this._reader = this._textContentSource.getReader(), _();
                } else if (this._textContentSource) {
                  const {
                    items: _,
                    styles: E
                  } = this._textContentSource;
                  this._processItems(_, E), T.resolve();
                } else
                  throw new Error('No "textContentSource" parameter specified.');
                T.promise.then(() => {
                  I = null, m(this);
                }, this._capability.reject);
              }
            }
            s.TextLayerRenderTask = C;
            function w($) {
              !$.textContentSource && ($.textContent || $.textContentStream) && ((0, d.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead."), $.textContentSource = $.textContent || $.textContentStream);
              const {
                container: T,
                viewport: I
              } = $, _ = getComputedStyle(T), E = _.getPropertyValue("visibility"), R = parseFloat(_.getPropertyValue("--scale-factor"));
              E === "visible" && (!R || Math.abs(R - I.scale) > 1e-5) && console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
              const O = new C($);
              return O._render(), O;
            }
            function S({
              container: $,
              viewport: T,
              textDivs: I,
              textDivProperties: _,
              isOffscreenCanvasSupported: E,
              mustRotate: R = !0,
              mustRescale: O = !0
            }) {
              if (R && (0, d.setLayerDimensions)($, {
                rotation: T.rotation
              }), O) {
                const L = g(0, E), F = {
                  prevFontSize: null,
                  prevFontFamily: null,
                  div: null,
                  scale: T.scale * (globalThis.devicePixelRatio || 1),
                  properties: null,
                  ctx: L
                };
                for (const M of I)
                  F.properties = _.get(M), F.div = M, f(F);
              }
            }
          },
          /* 27 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.AnnotationEditorLayer = void 0;
            var u = c(1), d = c(4), p = c(28), v = c(33), A = c(6), x = c(34);
            class g {
              #e;
              #t = !1;
              #r = null;
              #n = this.pointerup.bind(this);
              #s = this.pointerdown.bind(this);
              #o = /* @__PURE__ */ new Map();
              #i = !1;
              #l = !1;
              #c = !1;
              #a;
              static _initialized = !1;
              constructor({
                uiManager: y,
                pageIndex: f,
                div: m,
                accessibilityManager: C,
                annotationLayer: w,
                viewport: S,
                l10n: $
              }) {
                const T = [p.FreeTextEditor, v.InkEditor, x.StampEditor];
                if (!g._initialized) {
                  g._initialized = !0;
                  for (const I of T)
                    I.initialize($);
                }
                y.registerEditorTypes(T), this.#a = y, this.pageIndex = f, this.div = m, this.#e = C, this.#r = w, this.viewport = S, this.#a.addLayer(this);
              }
              get isEmpty() {
                return this.#o.size === 0;
              }
              updateToolbar(y) {
                this.#a.updateToolbar(y);
              }
              updateMode(y = this.#a.getMode()) {
                this.#h(), y === u.AnnotationEditorType.INK ? (this.addInkEditorIfNeeded(!1), this.disableClick()) : this.enableClick(), y !== u.AnnotationEditorType.NONE && (this.div.classList.toggle("freeTextEditing", y === u.AnnotationEditorType.FREETEXT), this.div.classList.toggle("inkEditing", y === u.AnnotationEditorType.INK), this.div.classList.toggle("stampEditing", y === u.AnnotationEditorType.STAMP), this.div.hidden = !1);
              }
              addInkEditorIfNeeded(y) {
                if (!y && this.#a.getMode() !== u.AnnotationEditorType.INK)
                  return;
                if (!y) {
                  for (const m of this.#o.values())
                    if (m.isEmpty()) {
                      m.setInBackground();
                      return;
                    }
                }
                this.#d({
                  offsetX: 0,
                  offsetY: 0
                }, !1).setInBackground();
              }
              setEditingState(y) {
                this.#a.setEditingState(y);
              }
              addCommands(y) {
                this.#a.addCommands(y);
              }
              enable() {
                this.div.style.pointerEvents = "auto";
                const y = /* @__PURE__ */ new Set();
                for (const m of this.#o.values())
                  m.enableEditing(), m.annotationElementId && y.add(m.annotationElementId);
                if (!this.#r)
                  return;
                const f = this.#r.getEditableAnnotations();
                for (const m of f) {
                  if (m.hide(), this.#a.isDeletedAnnotationElement(m.data.id) || y.has(m.data.id))
                    continue;
                  const C = this.deserialize(m);
                  C && (this.addOrRebuild(C), C.enableEditing());
                }
              }
              disable() {
                this.#c = !0, this.div.style.pointerEvents = "none";
                const y = /* @__PURE__ */ new Set();
                for (const f of this.#o.values()) {
                  if (f.disableEditing(), !f.annotationElementId || f.serialize() !== null) {
                    y.add(f.annotationElementId);
                    continue;
                  }
                  this.getEditableAnnotation(f.annotationElementId)?.show(), f.remove();
                }
                if (this.#r) {
                  const f = this.#r.getEditableAnnotations();
                  for (const m of f) {
                    const {
                      id: C
                    } = m.data;
                    y.has(C) || this.#a.isDeletedAnnotationElement(C) || m.show();
                  }
                }
                this.#h(), this.isEmpty && (this.div.hidden = !0), this.#c = !1;
              }
              getEditableAnnotation(y) {
                return this.#r?.getEditableAnnotation(y) || null;
              }
              setActiveEditor(y) {
                this.#a.getActive() !== y && this.#a.setActiveEditor(y);
              }
              enableClick() {
                this.div.addEventListener("pointerdown", this.#s), this.div.addEventListener("pointerup", this.#n);
              }
              disableClick() {
                this.div.removeEventListener("pointerdown", this.#s), this.div.removeEventListener("pointerup", this.#n);
              }
              attach(y) {
                this.#o.set(y.id, y);
                const {
                  annotationElementId: f
                } = y;
                f && this.#a.isDeletedAnnotationElement(f) && this.#a.removeDeletedAnnotationElement(y);
              }
              detach(y) {
                this.#o.delete(y.id), this.#e?.removePointerInTextLayer(y.contentDiv), !this.#c && y.annotationElementId && this.#a.addDeletedAnnotationElement(y);
              }
              remove(y) {
                this.detach(y), this.#a.removeEditor(y), y.div.contains(document.activeElement) && setTimeout(() => {
                  this.#a.focusMainContainer();
                }, 0), y.div.remove(), y.isAttachedToDOM = !1, this.#l || this.addInkEditorIfNeeded(!1);
              }
              changeParent(y) {
                y.parent !== this && (y.annotationElementId && (this.#a.addDeletedAnnotationElement(y.annotationElementId), d.AnnotationEditor.deleteAnnotationElement(y), y.annotationElementId = null), this.attach(y), y.parent?.detach(y), y.setParent(this), y.div && y.isAttachedToDOM && (y.div.remove(), this.div.append(y.div)));
              }
              add(y) {
                if (this.changeParent(y), this.#a.addEditor(y), this.attach(y), !y.isAttachedToDOM) {
                  const f = y.render();
                  this.div.append(f), y.isAttachedToDOM = !0;
                }
                y.fixAndSetPosition(), y.onceAdded(), this.#a.addToAnnotationStorage(y);
              }
              moveEditorInDOM(y) {
                if (!y.isAttachedToDOM)
                  return;
                const {
                  activeElement: f
                } = document;
                y.div.contains(f) && (y._focusEventsAllowed = !1, setTimeout(() => {
                  y.div.contains(document.activeElement) ? y._focusEventsAllowed = !0 : (y.div.addEventListener("focusin", () => {
                    y._focusEventsAllowed = !0;
                  }, {
                    once: !0
                  }), f.focus());
                }, 0)), y._structTreeParentId = this.#e?.moveElementInDOM(this.div, y.div, y.contentDiv, !0);
              }
              addOrRebuild(y) {
                y.needsToBeRebuilt() ? y.rebuild() : this.add(y);
              }
              addUndoableEditor(y) {
                const f = () => y._uiManager.rebuild(y), m = () => {
                  y.remove();
                };
                this.addCommands({
                  cmd: f,
                  undo: m,
                  mustExec: !1
                });
              }
              getNextId() {
                return this.#a.getId();
              }
              #p(y) {
                switch (this.#a.getMode()) {
                  case u.AnnotationEditorType.FREETEXT:
                    return new p.FreeTextEditor(y);
                  case u.AnnotationEditorType.INK:
                    return new v.InkEditor(y);
                  case u.AnnotationEditorType.STAMP:
                    return new x.StampEditor(y);
                }
                return null;
              }
              pasteEditor(y, f) {
                this.#a.updateToolbar(y), this.#a.updateMode(y);
                const {
                  offsetX: m,
                  offsetY: C
                } = this.#f(), w = this.getNextId(), S = this.#p({
                  parent: this,
                  id: w,
                  x: m,
                  y: C,
                  uiManager: this.#a,
                  isCentered: !0,
                  ...f
                });
                S && this.add(S);
              }
              deserialize(y) {
                switch (y.annotationType ?? y.annotationEditorType) {
                  case u.AnnotationEditorType.FREETEXT:
                    return p.FreeTextEditor.deserialize(y, this, this.#a);
                  case u.AnnotationEditorType.INK:
                    return v.InkEditor.deserialize(y, this, this.#a);
                  case u.AnnotationEditorType.STAMP:
                    return x.StampEditor.deserialize(y, this, this.#a);
                }
                return null;
              }
              #d(y, f) {
                const m = this.getNextId(), C = this.#p({
                  parent: this,
                  id: m,
                  x: y.offsetX,
                  y: y.offsetY,
                  uiManager: this.#a,
                  isCentered: f
                });
                return C && this.add(C), C;
              }
              #f() {
                const {
                  x: y,
                  y: f,
                  width: m,
                  height: C
                } = this.div.getBoundingClientRect(), w = Math.max(0, y), S = Math.max(0, f), $ = Math.min(window.innerWidth, y + m), T = Math.min(window.innerHeight, f + C), I = (w + $) / 2 - y, _ = (S + T) / 2 - f, [E, R] = this.viewport.rotation % 180 === 0 ? [I, _] : [_, I];
                return {
                  offsetX: E,
                  offsetY: R
                };
              }
              addNewEditor() {
                this.#d(this.#f(), !0);
              }
              setSelected(y) {
                this.#a.setSelected(y);
              }
              toggleSelected(y) {
                this.#a.toggleSelected(y);
              }
              isSelected(y) {
                return this.#a.isSelected(y);
              }
              unselect(y) {
                this.#a.unselect(y);
              }
              pointerup(y) {
                const {
                  isMac: f
                } = u.FeatureTest.platform;
                if (!(y.button !== 0 || y.ctrlKey && f) && y.target === this.div && this.#i) {
                  if (this.#i = !1, !this.#t) {
                    this.#t = !0;
                    return;
                  }
                  if (this.#a.getMode() === u.AnnotationEditorType.STAMP) {
                    this.#a.unselectAll();
                    return;
                  }
                  this.#d(y, !1);
                }
              }
              pointerdown(y) {
                if (this.#i) {
                  this.#i = !1;
                  return;
                }
                const {
                  isMac: f
                } = u.FeatureTest.platform;
                if (y.button !== 0 || y.ctrlKey && f || y.target !== this.div)
                  return;
                this.#i = !0;
                const m = this.#a.getActive();
                this.#t = !m || m.isEmpty();
              }
              findNewParent(y, f, m) {
                const C = this.#a.findParent(f, m);
                return C === null || C === this ? !1 : (C.changeParent(y), !0);
              }
              destroy() {
                this.#a.getActive()?.parent === this && (this.#a.commitOrRemove(), this.#a.setActiveEditor(null));
                for (const y of this.#o.values())
                  this.#e?.removePointerInTextLayer(y.contentDiv), y.setParent(null), y.isAttachedToDOM = !1, y.div.remove();
                this.div = null, this.#o.clear(), this.#a.removeLayer(this);
              }
              #h() {
                this.#l = !0;
                for (const y of this.#o.values())
                  y.isEmpty() && y.remove();
                this.#l = !1;
              }
              render({
                viewport: y
              }) {
                this.viewport = y, (0, A.setLayerDimensions)(this.div, y);
                for (const f of this.#a.getEditors(this.pageIndex))
                  this.add(f);
                this.updateMode();
              }
              update({
                viewport: y
              }) {
                this.#a.commitOrRemove(), this.viewport = y, (0, A.setLayerDimensions)(this.div, {
                  rotation: y.rotation
                }), this.updateMode();
              }
              get pageDimensions() {
                const {
                  pageWidth: y,
                  pageHeight: f
                } = this.viewport.rawDims;
                return [y, f];
              }
            }
            s.AnnotationEditorLayer = g;
          },
          /* 28 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.FreeTextEditor = void 0;
            var u = c(1), d = c(5), p = c(4), v = c(29);
            class A extends p.AnnotationEditor {
              #e = this.editorDivBlur.bind(this);
              #t = this.editorDivFocus.bind(this);
              #r = this.editorDivInput.bind(this);
              #n = this.editorDivKeydown.bind(this);
              #s;
              #o = "";
              #i = `${this.id}-editor`;
              #l;
              #c = null;
              static _freeTextDefaultContent = "";
              static _internalPadding = 0;
              static _defaultColor = null;
              static _defaultFontSize = 10;
              static get _keyboardManager() {
                const g = A.prototype, b = (m) => m.isEmpty(), y = d.AnnotationEditorUIManager.TRANSLATE_SMALL, f = d.AnnotationEditorUIManager.TRANSLATE_BIG;
                return (0, u.shadow)(this, "_keyboardManager", new d.KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], g.commitOrRemove, {
                  bubbles: !0
                }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], g.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], g._translateEmpty, {
                  args: [-y, 0],
                  checker: b
                }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], g._translateEmpty, {
                  args: [-f, 0],
                  checker: b
                }], [["ArrowRight", "mac+ArrowRight"], g._translateEmpty, {
                  args: [y, 0],
                  checker: b
                }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], g._translateEmpty, {
                  args: [f, 0],
                  checker: b
                }], [["ArrowUp", "mac+ArrowUp"], g._translateEmpty, {
                  args: [0, -y],
                  checker: b
                }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], g._translateEmpty, {
                  args: [0, -f],
                  checker: b
                }], [["ArrowDown", "mac+ArrowDown"], g._translateEmpty, {
                  args: [0, y],
                  checker: b
                }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], g._translateEmpty, {
                  args: [0, f],
                  checker: b
                }]]));
              }
              static _type = "freetext";
              constructor(g) {
                super({
                  ...g,
                  name: "freeTextEditor"
                }), this.#s = g.color || A._defaultColor || p.AnnotationEditor._defaultLineColor, this.#l = g.fontSize || A._defaultFontSize;
              }
              static initialize(g) {
                p.AnnotationEditor.initialize(g, {
                  strings: ["free_text2_default_content", "editor_free_text2_aria_label"]
                });
                const b = getComputedStyle(document.documentElement);
                this._internalPadding = parseFloat(b.getPropertyValue("--freetext-padding"));
              }
              static updateDefaultParams(g, b) {
                switch (g) {
                  case u.AnnotationEditorParamsType.FREETEXT_SIZE:
                    A._defaultFontSize = b;
                    break;
                  case u.AnnotationEditorParamsType.FREETEXT_COLOR:
                    A._defaultColor = b;
                    break;
                }
              }
              updateParams(g, b) {
                switch (g) {
                  case u.AnnotationEditorParamsType.FREETEXT_SIZE:
                    this.#a(b);
                    break;
                  case u.AnnotationEditorParamsType.FREETEXT_COLOR:
                    this.#p(b);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[u.AnnotationEditorParamsType.FREETEXT_SIZE, A._defaultFontSize], [u.AnnotationEditorParamsType.FREETEXT_COLOR, A._defaultColor || p.AnnotationEditor._defaultLineColor]];
              }
              get propertiesToUpdate() {
                return [[u.AnnotationEditorParamsType.FREETEXT_SIZE, this.#l], [u.AnnotationEditorParamsType.FREETEXT_COLOR, this.#s]];
              }
              #a(g) {
                const b = (f) => {
                  this.editorDiv.style.fontSize = `calc(${f}px * var(--scale-factor))`, this.translate(0, -(f - this.#l) * this.parentScale), this.#l = f, this.#f();
                }, y = this.#l;
                this.addCommands({
                  cmd: () => {
                    b(g);
                  },
                  undo: () => {
                    b(y);
                  },
                  mustExec: !0,
                  type: u.AnnotationEditorParamsType.FREETEXT_SIZE,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              #p(g) {
                const b = this.#s;
                this.addCommands({
                  cmd: () => {
                    this.#s = this.editorDiv.style.color = g;
                  },
                  undo: () => {
                    this.#s = this.editorDiv.style.color = b;
                  },
                  mustExec: !0,
                  type: u.AnnotationEditorParamsType.FREETEXT_COLOR,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              _translateEmpty(g, b) {
                this._uiManager.translateSelectedEditors(g, b, !0);
              }
              getInitialTranslation() {
                const g = this.parentScale;
                return [-A._internalPadding * g, -(A._internalPadding + this.#l) * g];
              }
              rebuild() {
                this.parent && (super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this)));
              }
              enableEditMode() {
                this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(u.AnnotationEditorType.FREETEXT), super.enableEditMode(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this._isDraggable = !1, this.div.removeAttribute("aria-activedescendant"), this.editorDiv.addEventListener("keydown", this.#n), this.editorDiv.addEventListener("focus", this.#t), this.editorDiv.addEventListener("blur", this.#e), this.editorDiv.addEventListener("input", this.#r));
              }
              disableEditMode() {
                this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", this.#i), this._isDraggable = !0, this.editorDiv.removeEventListener("keydown", this.#n), this.editorDiv.removeEventListener("focus", this.#t), this.editorDiv.removeEventListener("blur", this.#e), this.editorDiv.removeEventListener("input", this.#r), this.div.focus({
                  preventScroll: !0
                }), this.isEditing = !1, this.parent.div.classList.add("freeTextEditing"));
              }
              focusin(g) {
                this._focusEventsAllowed && (super.focusin(g), g.target !== this.editorDiv && this.editorDiv.focus());
              }
              onceAdded() {
                if (this.width) {
                  this.#m();
                  return;
                }
                this.enableEditMode(), this.editorDiv.focus(), this._initialOptions?.isCentered && this.center(), this._initialOptions = null;
              }
              isEmpty() {
                return !this.editorDiv || this.editorDiv.innerText.trim() === "";
              }
              remove() {
                this.isEditing = !1, this.parent && (this.parent.setEditingState(!0), this.parent.div.classList.add("freeTextEditing")), super.remove();
              }
              #d() {
                const g = this.editorDiv.getElementsByTagName("div");
                if (g.length === 0)
                  return this.editorDiv.innerText;
                const b = [];
                for (const y of g)
                  b.push(y.innerText.replace(/\r\n?|\n/, ""));
                return b.join(`
`);
              }
              #f() {
                const [g, b] = this.parentDimensions;
                let y;
                if (this.isAttachedToDOM)
                  y = this.div.getBoundingClientRect();
                else {
                  const {
                    currentLayer: f,
                    div: m
                  } = this, C = m.style.display;
                  m.style.display = "hidden", f.div.append(this.div), y = m.getBoundingClientRect(), m.remove(), m.style.display = C;
                }
                this.rotation % 180 === this.parentRotation % 180 ? (this.width = y.width / g, this.height = y.height / b) : (this.width = y.height / g, this.height = y.width / b), this.fixAndSetPosition();
              }
              commit() {
                if (!this.isInEditMode())
                  return;
                super.commit(), this.disableEditMode();
                const g = this.#o, b = this.#o = this.#d().trimEnd();
                if (g === b)
                  return;
                const y = (f) => {
                  if (this.#o = f, !f) {
                    this.remove();
                    return;
                  }
                  this.#h(), this._uiManager.rebuild(this), this.#f();
                };
                this.addCommands({
                  cmd: () => {
                    y(b);
                  },
                  undo: () => {
                    y(g);
                  },
                  mustExec: !1
                }), this.#f();
              }
              shouldGetKeyboardEvents() {
                return this.isInEditMode();
              }
              enterInEditMode() {
                this.enableEditMode(), this.editorDiv.focus();
              }
              dblclick(g) {
                this.enterInEditMode();
              }
              keydown(g) {
                g.target === this.div && g.key === "Enter" && (this.enterInEditMode(), g.preventDefault());
              }
              editorDivKeydown(g) {
                A._keyboardManager.exec(this, g);
              }
              editorDivFocus(g) {
                this.isEditing = !0;
              }
              editorDivBlur(g) {
                this.isEditing = !1;
              }
              editorDivInput(g) {
                this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
              }
              disableEditing() {
                this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
              }
              enableEditing() {
                this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
              }
              render() {
                if (this.div)
                  return this.div;
                let g, b;
                this.width && (g = this.x, b = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", this.#i), this.enableEditing(), p.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((f) => this.editorDiv?.setAttribute("aria-label", f)), p.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((f) => this.editorDiv?.setAttribute("default-content", f)), this.editorDiv.contentEditable = !0;
                const {
                  style: y
                } = this.editorDiv;
                if (y.fontSize = `calc(${this.#l}px * var(--scale-factor))`, y.color = this.#s, this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), (0, d.bindEvents)(this, this.div, ["dblclick", "keydown"]), this.width) {
                  const [f, m] = this.parentDimensions;
                  if (this.annotationElementId) {
                    const {
                      position: C
                    } = this.#c;
                    let [w, S] = this.getInitialTranslation();
                    [w, S] = this.pageTranslationToScreen(w, S);
                    const [$, T] = this.pageDimensions, [I, _] = this.pageTranslation;
                    let E, R;
                    switch (this.rotation) {
                      case 0:
                        E = g + (C[0] - I) / $, R = b + this.height - (C[1] - _) / T;
                        break;
                      case 90:
                        E = g + (C[0] - I) / $, R = b - (C[1] - _) / T, [w, S] = [S, -w];
                        break;
                      case 180:
                        E = g - this.width + (C[0] - I) / $, R = b - (C[1] - _) / T, [w, S] = [-w, -S];
                        break;
                      case 270:
                        E = g + (C[0] - I - this.height * T) / $, R = b + (C[1] - _ - this.width * $) / T, [w, S] = [-S, w];
                        break;
                    }
                    this.setAt(E * f, R * m, w, S);
                  } else
                    this.setAt(g * f, b * m, this.width * f, this.height * m);
                  this.#h(), this._isDraggable = !0, this.editorDiv.contentEditable = !1;
                } else
                  this._isDraggable = !1, this.editorDiv.contentEditable = !0;
                return this.div;
              }
              #h() {
                if (this.editorDiv.replaceChildren(), !!this.#o)
                  for (const g of this.#o.split(`
`)) {
                    const b = document.createElement("div");
                    b.append(g ? document.createTextNode(g) : document.createElement("br")), this.editorDiv.append(b);
                  }
              }
              get contentDiv() {
                return this.editorDiv;
              }
              static deserialize(g, b, y) {
                let f = null;
                if (g instanceof v.FreeTextAnnotationElement) {
                  const {
                    data: {
                      defaultAppearanceData: {
                        fontSize: C,
                        fontColor: w
                      },
                      rect: S,
                      rotation: $,
                      id: T
                    },
                    textContent: I,
                    textPosition: _,
                    parent: {
                      page: {
                        pageNumber: E
                      }
                    }
                  } = g;
                  if (!I || I.length === 0)
                    return null;
                  f = g = {
                    annotationType: u.AnnotationEditorType.FREETEXT,
                    color: Array.from(w),
                    fontSize: C,
                    value: I.join(`
`),
                    position: _,
                    pageIndex: E - 1,
                    rect: S,
                    rotation: $,
                    id: T,
                    deleted: !1
                  };
                }
                const m = super.deserialize(g, b, y);
                return m.#l = g.fontSize, m.#s = u.Util.makeHexColor(...g.color), m.#o = g.value, m.annotationElementId = g.id || null, m.#c = f, m;
              }
              serialize(g = !1) {
                if (this.isEmpty())
                  return null;
                if (this.deleted)
                  return {
                    pageIndex: this.pageIndex,
                    id: this.annotationElementId,
                    deleted: !0
                  };
                const b = A._internalPadding * this.parentScale, y = this.getRect(b, b), f = p.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#s), m = {
                  annotationType: u.AnnotationEditorType.FREETEXT,
                  color: f,
                  fontSize: this.#l,
                  value: this.#o,
                  pageIndex: this.pageIndex,
                  rect: y,
                  rotation: this.rotation,
                  structTreeParentId: this._structTreeParentId
                };
                return g ? m : this.annotationElementId && !this.#A(m) ? null : (m.id = this.annotationElementId, m);
              }
              #A(g) {
                const {
                  value: b,
                  fontSize: y,
                  color: f,
                  rect: m,
                  pageIndex: C
                } = this.#c;
                return g.value !== b || g.fontSize !== y || g.rect.some((w, S) => Math.abs(w - m[S]) >= 1) || g.color.some((w, S) => w !== f[S]) || g.pageIndex !== C;
              }
              #m(g = !1) {
                if (!this.annotationElementId)
                  return;
                if (this.#f(), !g && (this.width === 0 || this.height === 0)) {
                  setTimeout(() => this.#m(!0), 0);
                  return;
                }
                const b = A._internalPadding * this.parentScale;
                this.#c.rect = this.getRect(b, b);
              }
            }
            s.FreeTextEditor = A;
          },
          /* 29 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.StampAnnotationElement = s.InkAnnotationElement = s.FreeTextAnnotationElement = s.AnnotationLayer = void 0;
            var u = c(1), d = c(6), p = c(3), v = c(30), A = c(31), x = c(32);
            const g = 1e3, b = 9, y = /* @__PURE__ */ new WeakSet();
            function f(q) {
              return {
                width: q[2] - q[0],
                height: q[3] - q[1]
              };
            }
            class m {
              static create(Y) {
                switch (Y.data.annotationType) {
                  case u.AnnotationType.LINK:
                    return new w(Y);
                  case u.AnnotationType.TEXT:
                    return new S(Y);
                  case u.AnnotationType.WIDGET:
                    switch (Y.data.fieldType) {
                      case "Tx":
                        return new T(Y);
                      case "Btn":
                        return Y.data.radioButton ? new E(Y) : Y.data.checkBox ? new _(Y) : new R(Y);
                      case "Ch":
                        return new O(Y);
                      case "Sig":
                        return new I(Y);
                    }
                    return new $(Y);
                  case u.AnnotationType.POPUP:
                    return new L(Y);
                  case u.AnnotationType.FREETEXT:
                    return new F(Y);
                  case u.AnnotationType.LINE:
                    return new M(Y);
                  case u.AnnotationType.SQUARE:
                    return new W(Y);
                  case u.AnnotationType.CIRCLE:
                    return new j(Y);
                  case u.AnnotationType.POLYLINE:
                    return new G(Y);
                  case u.AnnotationType.CARET:
                    return new k(Y);
                  case u.AnnotationType.INK:
                    return new N(Y);
                  case u.AnnotationType.POLYGON:
                    return new U(Y);
                  case u.AnnotationType.HIGHLIGHT:
                    return new P(Y);
                  case u.AnnotationType.UNDERLINE:
                    return new D(Y);
                  case u.AnnotationType.SQUIGGLY:
                    return new H(Y);
                  case u.AnnotationType.STRIKEOUT:
                    return new V(Y);
                  case u.AnnotationType.STAMP:
                    return new Z(Y);
                  case u.AnnotationType.FILEATTACHMENT:
                    return new ne(Y);
                  default:
                    return new C(Y);
                }
              }
            }
            class C {
              #e = !1;
              constructor(Y, {
                isRenderable: ee = !1,
                ignoreBorder: Q = !1,
                createQuadrilaterals: J = !1
              } = {}) {
                this.isRenderable = ee, this.data = Y.data, this.layer = Y.layer, this.linkService = Y.linkService, this.downloadManager = Y.downloadManager, this.imageResourcesPath = Y.imageResourcesPath, this.renderForms = Y.renderForms, this.svgFactory = Y.svgFactory, this.annotationStorage = Y.annotationStorage, this.enableScripting = Y.enableScripting, this.hasJSActions = Y.hasJSActions, this._fieldObjects = Y.fieldObjects, this.parent = Y.parent, ee && (this.container = this._createContainer(Q)), J && this._createQuadrilaterals();
              }
              static _hasPopupData({
                titleObj: Y,
                contentsObj: ee,
                richText: Q
              }) {
                return !!(Y?.str || ee?.str || Q?.str);
              }
              get hasPopupData() {
                return C._hasPopupData(this.data);
              }
              _createContainer(Y) {
                const {
                  data: ee,
                  parent: {
                    page: Q,
                    viewport: J
                  }
                } = this, te = document.createElement("section");
                te.setAttribute("data-annotation-id", ee.id), this instanceof $ || (te.tabIndex = g), te.style.zIndex = this.parent.zIndex++, this.data.popupRef && te.setAttribute("aria-haspopup", "dialog"), ee.noRotate && te.classList.add("norotate");
                const {
                  pageWidth: ae,
                  pageHeight: se,
                  pageX: ie,
                  pageY: fe
                } = J.rawDims;
                if (!ee.rect || this instanceof L) {
                  const {
                    rotation: le
                  } = ee;
                  return !ee.hasOwnCanvas && le !== 0 && this.setRotation(le, te), te;
                }
                const {
                  width: ge,
                  height: me
                } = f(ee.rect), pe = u.Util.normalizeRect([ee.rect[0], Q.view[3] - ee.rect[1] + Q.view[1], ee.rect[2], Q.view[3] - ee.rect[3] + Q.view[1]]);
                if (!Y && ee.borderStyle.width > 0) {
                  te.style.borderWidth = `${ee.borderStyle.width}px`;
                  const le = ee.borderStyle.horizontalCornerRadius, ve = ee.borderStyle.verticalCornerRadius;
                  if (le > 0 || ve > 0) {
                    const ye = `calc(${le}px * var(--scale-factor)) / calc(${ve}px * var(--scale-factor))`;
                    te.style.borderRadius = ye;
                  } else if (this instanceof E) {
                    const ye = `calc(${ge}px * var(--scale-factor)) / calc(${me}px * var(--scale-factor))`;
                    te.style.borderRadius = ye;
                  }
                  switch (ee.borderStyle.style) {
                    case u.AnnotationBorderStyleType.SOLID:
                      te.style.borderStyle = "solid";
                      break;
                    case u.AnnotationBorderStyleType.DASHED:
                      te.style.borderStyle = "dashed";
                      break;
                    case u.AnnotationBorderStyleType.BEVELED:
                      (0, u.warn)("Unimplemented border style: beveled");
                      break;
                    case u.AnnotationBorderStyleType.INSET:
                      (0, u.warn)("Unimplemented border style: inset");
                      break;
                    case u.AnnotationBorderStyleType.UNDERLINE:
                      te.style.borderBottomStyle = "solid";
                      break;
                  }
                  const he = ee.borderColor || null;
                  he ? (this.#e = !0, te.style.borderColor = u.Util.makeHexColor(he[0] | 0, he[1] | 0, he[2] | 0)) : te.style.borderWidth = 0;
                }
                te.style.left = `${100 * (pe[0] - ie) / ae}%`, te.style.top = `${100 * (pe[1] - fe) / se}%`;
                const {
                  rotation: be
                } = ee;
                return ee.hasOwnCanvas || be === 0 ? (te.style.width = `${100 * ge / ae}%`, te.style.height = `${100 * me / se}%`) : this.setRotation(be, te), te;
              }
              setRotation(Y, ee = this.container) {
                if (!this.data.rect)
                  return;
                const {
                  pageWidth: Q,
                  pageHeight: J
                } = this.parent.viewport.rawDims, {
                  width: te,
                  height: ae
                } = f(this.data.rect);
                let se, ie;
                Y % 180 === 0 ? (se = 100 * te / Q, ie = 100 * ae / J) : (se = 100 * ae / Q, ie = 100 * te / J), ee.style.width = `${se}%`, ee.style.height = `${ie}%`, ee.setAttribute("data-main-rotation", (360 - Y) % 360);
              }
              get _commonActions() {
                const Y = (ee, Q, J) => {
                  const te = J.detail[ee], ae = te[0], se = te.slice(1);
                  J.target.style[Q] = v.ColorConverters[`${ae}_HTML`](se), this.annotationStorage.setValue(this.data.id, {
                    [Q]: v.ColorConverters[`${ae}_rgb`](se)
                  });
                };
                return (0, u.shadow)(this, "_commonActions", {
                  display: (ee) => {
                    const {
                      display: Q
                    } = ee.detail, J = Q % 2 === 1;
                    this.container.style.visibility = J ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      noView: J,
                      noPrint: Q === 1 || Q === 2
                    });
                  },
                  print: (ee) => {
                    this.annotationStorage.setValue(this.data.id, {
                      noPrint: !ee.detail.print
                    });
                  },
                  hidden: (ee) => {
                    const {
                      hidden: Q
                    } = ee.detail;
                    this.container.style.visibility = Q ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      noPrint: Q,
                      noView: Q
                    });
                  },
                  focus: (ee) => {
                    setTimeout(() => ee.target.focus({
                      preventScroll: !1
                    }), 0);
                  },
                  userName: (ee) => {
                    ee.target.title = ee.detail.userName;
                  },
                  readonly: (ee) => {
                    ee.target.disabled = ee.detail.readonly;
                  },
                  required: (ee) => {
                    this._setRequired(ee.target, ee.detail.required);
                  },
                  bgColor: (ee) => {
                    Y("bgColor", "backgroundColor", ee);
                  },
                  fillColor: (ee) => {
                    Y("fillColor", "backgroundColor", ee);
                  },
                  fgColor: (ee) => {
                    Y("fgColor", "color", ee);
                  },
                  textColor: (ee) => {
                    Y("textColor", "color", ee);
                  },
                  borderColor: (ee) => {
                    Y("borderColor", "borderColor", ee);
                  },
                  strokeColor: (ee) => {
                    Y("strokeColor", "borderColor", ee);
                  },
                  rotation: (ee) => {
                    const Q = ee.detail.rotation;
                    this.setRotation(Q), this.annotationStorage.setValue(this.data.id, {
                      rotation: Q
                    });
                  }
                });
              }
              _dispatchEventFromSandbox(Y, ee) {
                const Q = this._commonActions;
                for (const J of Object.keys(ee.detail))
                  (Y[J] || Q[J])?.(ee);
              }
              _setDefaultPropertiesFromJS(Y) {
                if (!this.enableScripting)
                  return;
                const ee = this.annotationStorage.getRawValue(this.data.id);
                if (!ee)
                  return;
                const Q = this._commonActions;
                for (const [J, te] of Object.entries(ee)) {
                  const ae = Q[J];
                  if (ae) {
                    const se = {
                      detail: {
                        [J]: te
                      },
                      target: Y
                    };
                    ae(se), delete ee[J];
                  }
                }
              }
              _createQuadrilaterals() {
                if (!this.container)
                  return;
                const {
                  quadPoints: Y
                } = this.data;
                if (!Y)
                  return;
                const [ee, Q, J, te] = this.data.rect;
                if (Y.length === 1) {
                  const [, {
                    x: ve,
                    y: he
                  }, {
                    x: ye,
                    y: Ce
                  }] = Y[0];
                  if (J === ve && te === he && ee === ye && Q === Ce)
                    return;
                }
                const {
                  style: ae
                } = this.container;
                let se;
                if (this.#e) {
                  const {
                    borderColor: ve,
                    borderWidth: he
                  } = ae;
                  ae.borderWidth = 0, se = ["url('data:image/svg+xml;utf8,", '<svg xmlns="http://www.w3.org/2000/svg"', ' preserveAspectRatio="none" viewBox="0 0 1 1">', `<g fill="transparent" stroke="${ve}" stroke-width="${he}">`], this.container.classList.add("hasBorder");
                }
                const ie = J - ee, fe = te - Q, {
                  svgFactory: ge
                } = this, me = ge.createElement("svg");
                me.classList.add("quadrilateralsContainer"), me.setAttribute("width", 0), me.setAttribute("height", 0);
                const pe = ge.createElement("defs");
                me.append(pe);
                const be = ge.createElement("clipPath"), le = `clippath_${this.data.id}`;
                be.setAttribute("id", le), be.setAttribute("clipPathUnits", "objectBoundingBox"), pe.append(be);
                for (const [, {
                  x: ve,
                  y: he
                }, {
                  x: ye,
                  y: Ce
                }] of Y) {
                  const xe = ge.createElement("rect"), we = (ye - ee) / ie, $e = (te - he) / fe, Ae = (ve - ye) / ie, ue = (he - Ce) / fe;
                  xe.setAttribute("x", we), xe.setAttribute("y", $e), xe.setAttribute("width", Ae), xe.setAttribute("height", ue), be.append(xe), se?.push(`<rect vector-effect="non-scaling-stroke" x="${we}" y="${$e}" width="${Ae}" height="${ue}"/>`);
                }
                this.#e && (se.push("</g></svg>')"), ae.backgroundImage = se.join("")), this.container.append(me), this.container.style.clipPath = `url(#${le})`;
              }
              _createPopup() {
                const {
                  container: Y,
                  data: ee
                } = this;
                Y.setAttribute("aria-haspopup", "dialog");
                const Q = new L({
                  data: {
                    color: ee.color,
                    titleObj: ee.titleObj,
                    modificationDate: ee.modificationDate,
                    contentsObj: ee.contentsObj,
                    richText: ee.richText,
                    parentRect: ee.rect,
                    borderStyle: 0,
                    id: `popup_${ee.id}`,
                    rotation: ee.rotation
                  },
                  parent: this.parent,
                  elements: [this]
                });
                this.parent.div.append(Q.render());
              }
              render() {
                (0, u.unreachable)("Abstract method `AnnotationElement.render` called");
              }
              _getElementsByName(Y, ee = null) {
                const Q = [];
                if (this._fieldObjects) {
                  const J = this._fieldObjects[Y];
                  if (J)
                    for (const {
                      page: te,
                      id: ae,
                      exportValues: se
                    } of J) {
                      if (te === -1 || ae === ee)
                        continue;
                      const ie = typeof se == "string" ? se : null, fe = document.querySelector(`[data-element-id="${ae}"]`);
                      if (fe && !y.has(fe)) {
                        (0, u.warn)(`_getElementsByName - element not allowed: ${ae}`);
                        continue;
                      }
                      Q.push({
                        id: ae,
                        exportValue: ie,
                        domElement: fe
                      });
                    }
                  return Q;
                }
                for (const J of document.getElementsByName(Y)) {
                  const {
                    exportValue: te
                  } = J, ae = J.getAttribute("data-element-id");
                  ae !== ee && y.has(J) && Q.push({
                    id: ae,
                    exportValue: te,
                    domElement: J
                  });
                }
                return Q;
              }
              show() {
                this.container && (this.container.hidden = !1), this.popup?.maybeShow();
              }
              hide() {
                this.container && (this.container.hidden = !0), this.popup?.forceHide();
              }
              getElementsToTriggerPopup() {
                return this.container;
              }
              addHighlightArea() {
                const Y = this.getElementsToTriggerPopup();
                if (Array.isArray(Y))
                  for (const ee of Y)
                    ee.classList.add("highlightArea");
                else
                  Y.classList.add("highlightArea");
              }
              _editOnDoubleClick() {
                const {
                  annotationEditorType: Y,
                  data: {
                    id: ee
                  }
                } = this;
                this.container.addEventListener("dblclick", () => {
                  this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                    source: this,
                    mode: Y,
                    editId: ee
                  });
                });
              }
            }
            class w extends C {
              constructor(Y, ee = null) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !!ee?.ignoreBorder,
                  createQuadrilaterals: !0
                }), this.isTooltipOnly = Y.data.isTooltipOnly;
              }
              render() {
                const {
                  data: Y,
                  linkService: ee
                } = this, Q = document.createElement("a");
                Q.setAttribute("data-element-id", Y.id);
                let J = !1;
                return Y.url ? (ee.addLinkAttributes(Q, Y.url, Y.newWindow), J = !0) : Y.action ? (this._bindNamedAction(Q, Y.action), J = !0) : Y.attachment ? (this._bindAttachment(Q, Y.attachment), J = !0) : Y.setOCGState ? (this.#t(Q, Y.setOCGState), J = !0) : Y.dest ? (this._bindLink(Q, Y.dest), J = !0) : (Y.actions && (Y.actions.Action || Y.actions["Mouse Up"] || Y.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(Q, Y), J = !0), Y.resetForm ? (this._bindResetFormAction(Q, Y.resetForm), J = !0) : this.isTooltipOnly && !J && (this._bindLink(Q, ""), J = !0)), this.container.classList.add("linkAnnotation"), J && this.container.append(Q), this.container;
              }
              #e() {
                this.container.setAttribute("data-internal-link", "");
              }
              _bindLink(Y, ee) {
                Y.href = this.linkService.getDestinationHash(ee), Y.onclick = () => (ee && this.linkService.goToDestination(ee), !1), (ee || ee === "") && this.#e();
              }
              _bindNamedAction(Y, ee) {
                Y.href = this.linkService.getAnchorUrl(""), Y.onclick = () => (this.linkService.executeNamedAction(ee), !1), this.#e();
              }
              _bindAttachment(Y, ee) {
                Y.href = this.linkService.getAnchorUrl(""), Y.onclick = () => (this.downloadManager?.openOrDownloadData(this.container, ee.content, ee.filename), !1), this.#e();
              }
              #t(Y, ee) {
                Y.href = this.linkService.getAnchorUrl(""), Y.onclick = () => (this.linkService.executeSetOCGState(ee), !1), this.#e();
              }
              _bindJSAction(Y, ee) {
                Y.href = this.linkService.getAnchorUrl("");
                const Q = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
                for (const J of Object.keys(ee.actions)) {
                  const te = Q.get(J);
                  te && (Y[te] = () => (this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: ee.id,
                      name: J
                    }
                  }), !1));
                }
                Y.onclick || (Y.onclick = () => !1), this.#e();
              }
              _bindResetFormAction(Y, ee) {
                const Q = Y.onclick;
                if (Q || (Y.href = this.linkService.getAnchorUrl("")), this.#e(), !this._fieldObjects) {
                  (0, u.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), Q || (Y.onclick = () => !1);
                  return;
                }
                Y.onclick = () => {
                  Q?.();
                  const {
                    fields: J,
                    refs: te,
                    include: ae
                  } = ee, se = [];
                  if (J.length !== 0 || te.length !== 0) {
                    const ge = new Set(te);
                    for (const me of J) {
                      const pe = this._fieldObjects[me] || [];
                      for (const {
                        id: be
                      } of pe)
                        ge.add(be);
                    }
                    for (const me of Object.values(this._fieldObjects))
                      for (const pe of me)
                        ge.has(pe.id) === ae && se.push(pe);
                  } else
                    for (const ge of Object.values(this._fieldObjects))
                      se.push(...ge);
                  const ie = this.annotationStorage, fe = [];
                  for (const ge of se) {
                    const {
                      id: me
                    } = ge;
                    switch (fe.push(me), ge.type) {
                      case "text": {
                        const be = ge.defaultValue || "";
                        ie.setValue(me, {
                          value: be
                        });
                        break;
                      }
                      case "checkbox":
                      case "radiobutton": {
                        const be = ge.defaultValue === ge.exportValues;
                        ie.setValue(me, {
                          value: be
                        });
                        break;
                      }
                      case "combobox":
                      case "listbox": {
                        const be = ge.defaultValue || "";
                        ie.setValue(me, {
                          value: be
                        });
                        break;
                      }
                      default:
                        continue;
                    }
                    const pe = document.querySelector(`[data-element-id="${me}"]`);
                    if (pe) {
                      if (!y.has(pe)) {
                        (0, u.warn)(`_bindResetFormAction - element not allowed: ${me}`);
                        continue;
                      }
                    } else continue;
                    pe.dispatchEvent(new Event("resetform"));
                  }
                  return this.enableScripting && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: "app",
                      ids: fe,
                      name: "ResetForm"
                    }
                  }), !1;
                };
              }
            }
            class S extends C {
              constructor(Y) {
                super(Y, {
                  isRenderable: !0
                });
              }
              render() {
                this.container.classList.add("textAnnotation");
                const Y = document.createElement("img");
                return Y.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", Y.alt = "[{{type}} Annotation]", Y.dataset.l10nId = "text_annotation_type", Y.dataset.l10nArgs = JSON.stringify({
                  type: this.data.name
                }), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.append(Y), this.container;
              }
            }
            class $ extends C {
              render() {
                return this.data.alternativeText && (this.container.title = this.data.alternativeText), this.container;
              }
              showElementAndHideCanvas(Y) {
                this.data.hasOwnCanvas && (Y.previousSibling?.nodeName === "CANVAS" && (Y.previousSibling.hidden = !0), Y.hidden = !1);
              }
              _getKeyModifier(Y) {
                const {
                  isWin: ee,
                  isMac: Q
                } = u.FeatureTest.platform;
                return ee && Y.ctrlKey || Q && Y.metaKey;
              }
              _setEventListener(Y, ee, Q, J, te) {
                Q.includes("mouse") ? Y.addEventListener(Q, (ae) => {
                  this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: J,
                      value: te(ae),
                      shift: ae.shiftKey,
                      modifier: this._getKeyModifier(ae)
                    }
                  });
                }) : Y.addEventListener(Q, (ae) => {
                  if (Q === "blur") {
                    if (!ee.focused || !ae.relatedTarget)
                      return;
                    ee.focused = !1;
                  } else if (Q === "focus") {
                    if (ee.focused)
                      return;
                    ee.focused = !0;
                  }
                  te && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: J,
                      value: te(ae)
                    }
                  });
                });
              }
              _setEventListeners(Y, ee, Q, J) {
                for (const [te, ae] of Q)
                  (ae === "Action" || this.data.actions?.[ae]) && ((ae === "Focus" || ae === "Blur") && (ee ||= {
                    focused: !1
                  }), this._setEventListener(Y, ee, te, ae, J), ae === "Focus" && !this.data.actions?.Blur ? this._setEventListener(Y, ee, "blur", "Blur", null) : ae === "Blur" && !this.data.actions?.Focus && this._setEventListener(Y, ee, "focus", "Focus", null));
              }
              _setBackgroundColor(Y) {
                const ee = this.data.backgroundColor || null;
                Y.style.backgroundColor = ee === null ? "transparent" : u.Util.makeHexColor(ee[0], ee[1], ee[2]);
              }
              _setTextStyle(Y) {
                const ee = ["left", "center", "right"], {
                  fontColor: Q
                } = this.data.defaultAppearanceData, J = this.data.defaultAppearanceData.fontSize || b, te = Y.style;
                let ae;
                const se = 2, ie = (fe) => Math.round(10 * fe) / 10;
                if (this.data.multiLine) {
                  const fe = Math.abs(this.data.rect[3] - this.data.rect[1] - se), ge = Math.round(fe / (u.LINE_FACTOR * J)) || 1, me = fe / ge;
                  ae = Math.min(J, ie(me / u.LINE_FACTOR));
                } else {
                  const fe = Math.abs(this.data.rect[3] - this.data.rect[1] - se);
                  ae = Math.min(J, ie(fe / u.LINE_FACTOR));
                }
                te.fontSize = `calc(${ae}px * var(--scale-factor))`, te.color = u.Util.makeHexColor(Q[0], Q[1], Q[2]), this.data.textAlignment !== null && (te.textAlign = ee[this.data.textAlignment]);
              }
              _setRequired(Y, ee) {
                ee ? Y.setAttribute("required", !0) : Y.removeAttribute("required"), Y.setAttribute("aria-required", ee);
              }
            }
            class T extends $ {
              constructor(Y) {
                const ee = Y.renderForms || !Y.data.hasAppearance && !!Y.data.fieldValue;
                super(Y, {
                  isRenderable: ee
                });
              }
              setPropertyOnSiblings(Y, ee, Q, J) {
                const te = this.annotationStorage;
                for (const ae of this._getElementsByName(Y.name, Y.id))
                  ae.domElement && (ae.domElement[ee] = Q), te.setValue(ae.id, {
                    [J]: Q
                  });
              }
              render() {
                const Y = this.annotationStorage, ee = this.data.id;
                this.container.classList.add("textWidgetAnnotation");
                let Q = null;
                if (this.renderForms) {
                  const J = Y.getValue(ee, {
                    value: this.data.fieldValue
                  });
                  let te = J.value || "";
                  const ae = Y.getValue(ee, {
                    charLimit: this.data.maxLen
                  }).charLimit;
                  ae && te.length > ae && (te = te.slice(0, ae));
                  let se = J.formattedValue || this.data.textContent?.join(`
`) || null;
                  se && this.data.comb && (se = se.replaceAll(/\s+/g, ""));
                  const ie = {
                    userValue: te,
                    formattedValue: se,
                    lastCommittedValue: null,
                    commitKey: 1,
                    focused: !1
                  };
                  this.data.multiLine ? (Q = document.createElement("textarea"), Q.textContent = se ?? te, this.data.doNotScroll && (Q.style.overflowY = "hidden")) : (Q = document.createElement("input"), Q.type = "text", Q.setAttribute("value", se ?? te), this.data.doNotScroll && (Q.style.overflowX = "hidden")), this.data.hasOwnCanvas && (Q.hidden = !0), y.add(Q), Q.setAttribute("data-element-id", ee), Q.disabled = this.data.readOnly, Q.name = this.data.fieldName, Q.tabIndex = g, this._setRequired(Q, this.data.required), ae && (Q.maxLength = ae), Q.addEventListener("input", (ge) => {
                    Y.setValue(ee, {
                      value: ge.target.value
                    }), this.setPropertyOnSiblings(Q, "value", ge.target.value, "value"), ie.formattedValue = null;
                  }), Q.addEventListener("resetform", (ge) => {
                    const me = this.data.defaultFieldValue ?? "";
                    Q.value = ie.userValue = me, ie.formattedValue = null;
                  });
                  let fe = (ge) => {
                    const {
                      formattedValue: me
                    } = ie;
                    me != null && (ge.target.value = me), ge.target.scrollLeft = 0;
                  };
                  if (this.enableScripting && this.hasJSActions) {
                    Q.addEventListener("focus", (me) => {
                      if (ie.focused)
                        return;
                      const {
                        target: pe
                      } = me;
                      ie.userValue && (pe.value = ie.userValue), ie.lastCommittedValue = pe.value, ie.commitKey = 1, ie.focused = !0;
                    }), Q.addEventListener("updatefromsandbox", (me) => {
                      this.showElementAndHideCanvas(me.target);
                      const pe = {
                        value(be) {
                          ie.userValue = be.detail.value ?? "", Y.setValue(ee, {
                            value: ie.userValue.toString()
                          }), be.target.value = ie.userValue;
                        },
                        formattedValue(be) {
                          const {
                            formattedValue: le
                          } = be.detail;
                          ie.formattedValue = le, le != null && be.target !== document.activeElement && (be.target.value = le), Y.setValue(ee, {
                            formattedValue: le
                          });
                        },
                        selRange(be) {
                          be.target.setSelectionRange(...be.detail.selRange);
                        },
                        charLimit: (be) => {
                          const {
                            charLimit: le
                          } = be.detail, {
                            target: ve
                          } = be;
                          if (le === 0) {
                            ve.removeAttribute("maxLength");
                            return;
                          }
                          ve.setAttribute("maxLength", le);
                          let he = ie.userValue;
                          !he || he.length <= le || (he = he.slice(0, le), ve.value = ie.userValue = he, Y.setValue(ee, {
                            value: he
                          }), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                            source: this,
                            detail: {
                              id: ee,
                              name: "Keystroke",
                              value: he,
                              willCommit: !0,
                              commitKey: 1,
                              selStart: ve.selectionStart,
                              selEnd: ve.selectionEnd
                            }
                          }));
                        }
                      };
                      this._dispatchEventFromSandbox(pe, me);
                    }), Q.addEventListener("keydown", (me) => {
                      ie.commitKey = 1;
                      let pe = -1;
                      if (me.key === "Escape" ? pe = 0 : me.key === "Enter" && !this.data.multiLine ? pe = 2 : me.key === "Tab" && (ie.commitKey = 3), pe === -1)
                        return;
                      const {
                        value: be
                      } = me.target;
                      ie.lastCommittedValue !== be && (ie.lastCommittedValue = be, ie.userValue = be, this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: ee,
                          name: "Keystroke",
                          value: be,
                          willCommit: !0,
                          commitKey: pe,
                          selStart: me.target.selectionStart,
                          selEnd: me.target.selectionEnd
                        }
                      }));
                    });
                    const ge = fe;
                    fe = null, Q.addEventListener("blur", (me) => {
                      if (!ie.focused || !me.relatedTarget)
                        return;
                      ie.focused = !1;
                      const {
                        value: pe
                      } = me.target;
                      ie.userValue = pe, ie.lastCommittedValue !== pe && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: ee,
                          name: "Keystroke",
                          value: pe,
                          willCommit: !0,
                          commitKey: ie.commitKey,
                          selStart: me.target.selectionStart,
                          selEnd: me.target.selectionEnd
                        }
                      }), ge(me);
                    }), this.data.actions?.Keystroke && Q.addEventListener("beforeinput", (me) => {
                      ie.lastCommittedValue = null;
                      const {
                        data: pe,
                        target: be
                      } = me, {
                        value: le,
                        selectionStart: ve,
                        selectionEnd: he
                      } = be;
                      let ye = ve, Ce = he;
                      switch (me.inputType) {
                        case "deleteWordBackward": {
                          const xe = le.substring(0, ve).match(/\w*[^\w]*$/);
                          xe && (ye -= xe[0].length);
                          break;
                        }
                        case "deleteWordForward": {
                          const xe = le.substring(ve).match(/^[^\w]*\w*/);
                          xe && (Ce += xe[0].length);
                          break;
                        }
                        case "deleteContentBackward":
                          ve === he && (ye -= 1);
                          break;
                        case "deleteContentForward":
                          ve === he && (Ce += 1);
                          break;
                      }
                      me.preventDefault(), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: ee,
                          name: "Keystroke",
                          value: le,
                          change: pe || "",
                          willCommit: !1,
                          selStart: ye,
                          selEnd: Ce
                        }
                      });
                    }), this._setEventListeners(Q, ie, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (me) => me.target.value);
                  }
                  if (fe && Q.addEventListener("blur", fe), this.data.comb) {
                    const me = (this.data.rect[2] - this.data.rect[0]) / ae;
                    Q.classList.add("comb"), Q.style.letterSpacing = `calc(${me}px * var(--scale-factor) - 1ch)`;
                  }
                } else
                  Q = document.createElement("div"), Q.textContent = this.data.fieldValue, Q.style.verticalAlign = "middle", Q.style.display = "table-cell";
                return this._setTextStyle(Q), this._setBackgroundColor(Q), this._setDefaultPropertiesFromJS(Q), this.container.append(Q), this.container;
              }
            }
            class I extends $ {
              constructor(Y) {
                super(Y, {
                  isRenderable: !!Y.data.hasOwnCanvas
                });
              }
            }
            class _ extends $ {
              constructor(Y) {
                super(Y, {
                  isRenderable: Y.renderForms
                });
              }
              render() {
                const Y = this.annotationStorage, ee = this.data, Q = ee.id;
                let J = Y.getValue(Q, {
                  value: ee.exportValue === ee.fieldValue
                }).value;
                typeof J == "string" && (J = J !== "Off", Y.setValue(Q, {
                  value: J
                })), this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                const te = document.createElement("input");
                return y.add(te), te.setAttribute("data-element-id", Q), te.disabled = ee.readOnly, this._setRequired(te, this.data.required), te.type = "checkbox", te.name = ee.fieldName, J && te.setAttribute("checked", !0), te.setAttribute("exportValue", ee.exportValue), te.tabIndex = g, te.addEventListener("change", (ae) => {
                  const {
                    name: se,
                    checked: ie
                  } = ae.target;
                  for (const fe of this._getElementsByName(se, Q)) {
                    const ge = ie && fe.exportValue === ee.exportValue;
                    fe.domElement && (fe.domElement.checked = ge), Y.setValue(fe.id, {
                      value: ge
                    });
                  }
                  Y.setValue(Q, {
                    value: ie
                  });
                }), te.addEventListener("resetform", (ae) => {
                  const se = ee.defaultFieldValue || "Off";
                  ae.target.checked = se === ee.exportValue;
                }), this.enableScripting && this.hasJSActions && (te.addEventListener("updatefromsandbox", (ae) => {
                  const se = {
                    value(ie) {
                      ie.target.checked = ie.detail.value !== "Off", Y.setValue(Q, {
                        value: ie.target.checked
                      });
                    }
                  };
                  this._dispatchEventFromSandbox(se, ae);
                }), this._setEventListeners(te, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (ae) => ae.target.checked)), this._setBackgroundColor(te), this._setDefaultPropertiesFromJS(te), this.container.append(te), this.container;
              }
            }
            class E extends $ {
              constructor(Y) {
                super(Y, {
                  isRenderable: Y.renderForms
                });
              }
              render() {
                this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                const Y = this.annotationStorage, ee = this.data, Q = ee.id;
                let J = Y.getValue(Q, {
                  value: ee.fieldValue === ee.buttonValue
                }).value;
                typeof J == "string" && (J = J !== ee.buttonValue, Y.setValue(Q, {
                  value: J
                }));
                const te = document.createElement("input");
                if (y.add(te), te.setAttribute("data-element-id", Q), te.disabled = ee.readOnly, this._setRequired(te, this.data.required), te.type = "radio", te.name = ee.fieldName, J && te.setAttribute("checked", !0), te.tabIndex = g, te.addEventListener("change", (ae) => {
                  const {
                    name: se,
                    checked: ie
                  } = ae.target;
                  for (const fe of this._getElementsByName(se, Q))
                    Y.setValue(fe.id, {
                      value: !1
                    });
                  Y.setValue(Q, {
                    value: ie
                  });
                }), te.addEventListener("resetform", (ae) => {
                  const se = ee.defaultFieldValue;
                  ae.target.checked = se != null && se === ee.buttonValue;
                }), this.enableScripting && this.hasJSActions) {
                  const ae = ee.buttonValue;
                  te.addEventListener("updatefromsandbox", (se) => {
                    const ie = {
                      value: (fe) => {
                        const ge = ae === fe.detail.value;
                        for (const me of this._getElementsByName(fe.target.name)) {
                          const pe = ge && me.id === Q;
                          me.domElement && (me.domElement.checked = pe), Y.setValue(me.id, {
                            value: pe
                          });
                        }
                      }
                    };
                    this._dispatchEventFromSandbox(ie, se);
                  }), this._setEventListeners(te, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (se) => se.target.checked);
                }
                return this._setBackgroundColor(te), this._setDefaultPropertiesFromJS(te), this.container.append(te), this.container;
              }
            }
            class R extends w {
              constructor(Y) {
                super(Y, {
                  ignoreBorder: Y.data.hasAppearance
                });
              }
              render() {
                const Y = super.render();
                Y.classList.add("buttonWidgetAnnotation", "pushButton"), this.data.alternativeText && (Y.title = this.data.alternativeText);
                const ee = Y.lastChild;
                return this.enableScripting && this.hasJSActions && ee && (this._setDefaultPropertiesFromJS(ee), ee.addEventListener("updatefromsandbox", (Q) => {
                  this._dispatchEventFromSandbox({}, Q);
                })), Y;
              }
            }
            class O extends $ {
              constructor(Y) {
                super(Y, {
                  isRenderable: Y.renderForms
                });
              }
              render() {
                this.container.classList.add("choiceWidgetAnnotation");
                const Y = this.annotationStorage, ee = this.data.id, Q = Y.getValue(ee, {
                  value: this.data.fieldValue
                }), J = document.createElement("select");
                y.add(J), J.setAttribute("data-element-id", ee), J.disabled = this.data.readOnly, this._setRequired(J, this.data.required), J.name = this.data.fieldName, J.tabIndex = g;
                let te = this.data.combo && this.data.options.length > 0;
                this.data.combo || (J.size = this.data.options.length, this.data.multiSelect && (J.multiple = !0)), J.addEventListener("resetform", (ge) => {
                  const me = this.data.defaultFieldValue;
                  for (const pe of J.options)
                    pe.selected = pe.value === me;
                });
                for (const ge of this.data.options) {
                  const me = document.createElement("option");
                  me.textContent = ge.displayValue, me.value = ge.exportValue, Q.value.includes(ge.exportValue) && (me.setAttribute("selected", !0), te = !1), J.append(me);
                }
                let ae = null;
                if (te) {
                  const ge = document.createElement("option");
                  ge.value = " ", ge.setAttribute("hidden", !0), ge.setAttribute("selected", !0), J.prepend(ge), ae = () => {
                    ge.remove(), J.removeEventListener("input", ae), ae = null;
                  }, J.addEventListener("input", ae);
                }
                const se = (ge) => {
                  const me = ge ? "value" : "textContent", {
                    options: pe,
                    multiple: be
                  } = J;
                  return be ? Array.prototype.filter.call(pe, (le) => le.selected).map((le) => le[me]) : pe.selectedIndex === -1 ? null : pe[pe.selectedIndex][me];
                };
                let ie = se(!1);
                const fe = (ge) => {
                  const me = ge.target.options;
                  return Array.prototype.map.call(me, (pe) => ({
                    displayValue: pe.textContent,
                    exportValue: pe.value
                  }));
                };
                return this.enableScripting && this.hasJSActions ? (J.addEventListener("updatefromsandbox", (ge) => {
                  const me = {
                    value(pe) {
                      ae?.();
                      const be = pe.detail.value, le = new Set(Array.isArray(be) ? be : [be]);
                      for (const ve of J.options)
                        ve.selected = le.has(ve.value);
                      Y.setValue(ee, {
                        value: se(!0)
                      }), ie = se(!1);
                    },
                    multipleSelection(pe) {
                      J.multiple = !0;
                    },
                    remove(pe) {
                      const be = J.options, le = pe.detail.remove;
                      be[le].selected = !1, J.remove(le), be.length > 0 && Array.prototype.findIndex.call(be, (he) => he.selected) === -1 && (be[0].selected = !0), Y.setValue(ee, {
                        value: se(!0),
                        items: fe(pe)
                      }), ie = se(!1);
                    },
                    clear(pe) {
                      for (; J.length !== 0; )
                        J.remove(0);
                      Y.setValue(ee, {
                        value: null,
                        items: []
                      }), ie = se(!1);
                    },
                    insert(pe) {
                      const {
                        index: be,
                        displayValue: le,
                        exportValue: ve
                      } = pe.detail.insert, he = J.children[be], ye = document.createElement("option");
                      ye.textContent = le, ye.value = ve, he ? he.before(ye) : J.append(ye), Y.setValue(ee, {
                        value: se(!0),
                        items: fe(pe)
                      }), ie = se(!1);
                    },
                    items(pe) {
                      const {
                        items: be
                      } = pe.detail;
                      for (; J.length !== 0; )
                        J.remove(0);
                      for (const le of be) {
                        const {
                          displayValue: ve,
                          exportValue: he
                        } = le, ye = document.createElement("option");
                        ye.textContent = ve, ye.value = he, J.append(ye);
                      }
                      J.options.length > 0 && (J.options[0].selected = !0), Y.setValue(ee, {
                        value: se(!0),
                        items: fe(pe)
                      }), ie = se(!1);
                    },
                    indices(pe) {
                      const be = new Set(pe.detail.indices);
                      for (const le of pe.target.options)
                        le.selected = be.has(le.index);
                      Y.setValue(ee, {
                        value: se(!0)
                      }), ie = se(!1);
                    },
                    editable(pe) {
                      pe.target.disabled = !pe.detail.editable;
                    }
                  };
                  this._dispatchEventFromSandbox(me, ge);
                }), J.addEventListener("input", (ge) => {
                  const me = se(!0);
                  Y.setValue(ee, {
                    value: me
                  }), ge.preventDefault(), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: ee,
                      name: "Keystroke",
                      value: ie,
                      changeEx: me,
                      willCommit: !1,
                      commitKey: 1,
                      keyDown: !1
                    }
                  });
                }), this._setEventListeners(J, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (ge) => ge.target.value)) : J.addEventListener("input", function(ge) {
                  Y.setValue(ee, {
                    value: se(!0)
                  });
                }), this.data.combo && this._setTextStyle(J), this._setBackgroundColor(J), this._setDefaultPropertiesFromJS(J), this.container.append(J), this.container;
              }
            }
            class L extends C {
              constructor(Y) {
                const {
                  data: ee,
                  elements: Q
                } = Y;
                super(Y, {
                  isRenderable: C._hasPopupData(ee)
                }), this.elements = Q;
              }
              render() {
                this.container.classList.add("popupAnnotation");
                const Y = new B({
                  container: this.container,
                  color: this.data.color,
                  titleObj: this.data.titleObj,
                  modificationDate: this.data.modificationDate,
                  contentsObj: this.data.contentsObj,
                  richText: this.data.richText,
                  rect: this.data.rect,
                  parentRect: this.data.parentRect || null,
                  parent: this.parent,
                  elements: this.elements,
                  open: this.data.open
                }), ee = [];
                for (const Q of this.elements)
                  Q.popup = Y, ee.push(Q.data.id), Q.addHighlightArea();
                return this.container.setAttribute("aria-controls", ee.map((Q) => `${u.AnnotationPrefix}${Q}`).join(",")), this.container;
              }
            }
            class B {
              #e = null;
              #t = this.#u.bind(this);
              #r = this.#C.bind(this);
              #n = this.#E.bind(this);
              #s = this.#v.bind(this);
              #o = null;
              #i = null;
              #l = null;
              #c = null;
              #a = null;
              #p = null;
              #d = !1;
              #f = null;
              #h = null;
              #A = null;
              #m = null;
              #g = !1;
              constructor({
                container: Y,
                color: ee,
                elements: Q,
                titleObj: J,
                modificationDate: te,
                contentsObj: ae,
                richText: se,
                parent: ie,
                rect: fe,
                parentRect: ge,
                open: me
              }) {
                this.#i = Y, this.#m = J, this.#l = ae, this.#A = se, this.#a = ie, this.#o = ee, this.#h = fe, this.#p = ge, this.#c = Q;
                const pe = d.PDFDateString.toDateObject(te);
                pe && (this.#e = ie.l10n.get("annotation_date_string", {
                  date: pe.toLocaleDateString(),
                  time: pe.toLocaleTimeString()
                })), this.trigger = Q.flatMap((be) => be.getElementsToTriggerPopup());
                for (const be of this.trigger)
                  be.addEventListener("click", this.#s), be.addEventListener("mouseenter", this.#n), be.addEventListener("mouseleave", this.#r), be.classList.add("popupTriggerArea");
                for (const be of Q)
                  be.container?.addEventListener("keydown", this.#t);
                this.#i.hidden = !0, me && this.#v();
              }
              render() {
                if (this.#f)
                  return;
                const {
                  page: {
                    view: Y
                  },
                  viewport: {
                    rawDims: {
                      pageWidth: ee,
                      pageHeight: Q,
                      pageX: J,
                      pageY: te
                    }
                  }
                } = this.#a, ae = this.#f = document.createElement("div");
                if (ae.className = "popup", this.#o) {
                  const xe = ae.style.outlineColor = u.Util.makeHexColor(...this.#o);
                  CSS.supports("background-color", "color-mix(in srgb, red 30%, white)") ? ae.style.backgroundColor = `color-mix(in srgb, ${xe} 30%, white)` : ae.style.backgroundColor = u.Util.makeHexColor(...this.#o.map(($e) => Math.floor(0.7 * (255 - $e) + $e)));
                }
                const se = document.createElement("span");
                se.className = "header";
                const ie = document.createElement("h1");
                if (se.append(ie), {
                  dir: ie.dir,
                  str: ie.textContent
                } = this.#m, ae.append(se), this.#e) {
                  const xe = document.createElement("span");
                  xe.classList.add("popupDate"), this.#e.then((we) => {
                    xe.textContent = we;
                  }), se.append(xe);
                }
                const fe = this.#l, ge = this.#A;
                if (ge?.str && (!fe?.str || fe.str === ge.str))
                  x.XfaLayer.render({
                    xfaHtml: ge.html,
                    intent: "richText",
                    div: ae
                  }), ae.lastChild.classList.add("richText", "popupContent");
                else {
                  const xe = this._formatContents(fe);
                  ae.append(xe);
                }
                let me = !!this.#p, pe = me ? this.#p : this.#h;
                for (const xe of this.#c)
                  if (!pe || u.Util.intersect(xe.data.rect, pe) !== null) {
                    pe = xe.data.rect, me = !0;
                    break;
                  }
                const be = u.Util.normalizeRect([pe[0], Y[3] - pe[1] + Y[1], pe[2], Y[3] - pe[3] + Y[1]]), ve = me ? pe[2] - pe[0] + 5 : 0, he = be[0] + ve, ye = be[1], {
                  style: Ce
                } = this.#i;
                Ce.left = `${100 * (he - J) / ee}%`, Ce.top = `${100 * (ye - te) / Q}%`, this.#i.append(ae);
              }
              _formatContents({
                str: Y,
                dir: ee
              }) {
                const Q = document.createElement("p");
                Q.classList.add("popupContent"), Q.dir = ee;
                const J = Y.split(/(?:\r\n?|\n)/);
                for (let te = 0, ae = J.length; te < ae; ++te) {
                  const se = J[te];
                  Q.append(document.createTextNode(se)), te < ae - 1 && Q.append(document.createElement("br"));
                }
                return Q;
              }
              #u(Y) {
                Y.altKey || Y.shiftKey || Y.ctrlKey || Y.metaKey || (Y.key === "Enter" || Y.key === "Escape" && this.#d) && this.#v();
              }
              #v() {
                this.#d = !this.#d, this.#d ? (this.#E(), this.#i.addEventListener("click", this.#s), this.#i.addEventListener("keydown", this.#t)) : (this.#C(), this.#i.removeEventListener("click", this.#s), this.#i.removeEventListener("keydown", this.#t));
              }
              #E() {
                this.#f || this.render(), this.isVisible ? this.#d && this.#i.classList.add("focused") : (this.#i.hidden = !1, this.#i.style.zIndex = parseInt(this.#i.style.zIndex) + 1e3);
              }
              #C() {
                this.#i.classList.remove("focused"), !(this.#d || !this.isVisible) && (this.#i.hidden = !0, this.#i.style.zIndex = parseInt(this.#i.style.zIndex) - 1e3);
              }
              forceHide() {
                this.#g = this.isVisible, this.#g && (this.#i.hidden = !0);
              }
              maybeShow() {
                this.#g && (this.#g = !1, this.#i.hidden = !1);
              }
              get isVisible() {
                return this.#i.hidden === !1;
              }
            }
            class F extends C {
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0
                }), this.textContent = Y.data.textContent, this.textPosition = Y.data.textPosition, this.annotationEditorType = u.AnnotationEditorType.FREETEXT;
              }
              render() {
                if (this.container.classList.add("freeTextAnnotation"), this.textContent) {
                  const Y = document.createElement("div");
                  Y.classList.add("annotationTextContent"), Y.setAttribute("role", "comment");
                  for (const ee of this.textContent) {
                    const Q = document.createElement("span");
                    Q.textContent = ee, Y.append(Q);
                  }
                  this.container.append(Y);
                }
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
              }
            }
            s.FreeTextAnnotationElement = F;
            class M extends C {
              #e = null;
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.classList.add("lineAnnotation");
                const Y = this.data, {
                  width: ee,
                  height: Q
                } = f(Y.rect), J = this.svgFactory.create(ee, Q, !0), te = this.#e = this.svgFactory.createElement("svg:line");
                return te.setAttribute("x1", Y.rect[2] - Y.lineCoordinates[0]), te.setAttribute("y1", Y.rect[3] - Y.lineCoordinates[1]), te.setAttribute("x2", Y.rect[2] - Y.lineCoordinates[2]), te.setAttribute("y2", Y.rect[3] - Y.lineCoordinates[3]), te.setAttribute("stroke-width", Y.borderStyle.width || 1), te.setAttribute("stroke", "transparent"), te.setAttribute("fill", "transparent"), J.append(te), this.container.append(J), !Y.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#e;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            class W extends C {
              #e = null;
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.classList.add("squareAnnotation");
                const Y = this.data, {
                  width: ee,
                  height: Q
                } = f(Y.rect), J = this.svgFactory.create(ee, Q, !0), te = Y.borderStyle.width, ae = this.#e = this.svgFactory.createElement("svg:rect");
                return ae.setAttribute("x", te / 2), ae.setAttribute("y", te / 2), ae.setAttribute("width", ee - te), ae.setAttribute("height", Q - te), ae.setAttribute("stroke-width", te || 1), ae.setAttribute("stroke", "transparent"), ae.setAttribute("fill", "transparent"), J.append(ae), this.container.append(J), !Y.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#e;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            class j extends C {
              #e = null;
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.classList.add("circleAnnotation");
                const Y = this.data, {
                  width: ee,
                  height: Q
                } = f(Y.rect), J = this.svgFactory.create(ee, Q, !0), te = Y.borderStyle.width, ae = this.#e = this.svgFactory.createElement("svg:ellipse");
                return ae.setAttribute("cx", ee / 2), ae.setAttribute("cy", Q / 2), ae.setAttribute("rx", ee / 2 - te / 2), ae.setAttribute("ry", Q / 2 - te / 2), ae.setAttribute("stroke-width", te || 1), ae.setAttribute("stroke", "transparent"), ae.setAttribute("fill", "transparent"), J.append(ae), this.container.append(J), !Y.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#e;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            class G extends C {
              #e = null;
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0
                }), this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.classList.add(this.containerClassName);
                const Y = this.data, {
                  width: ee,
                  height: Q
                } = f(Y.rect), J = this.svgFactory.create(ee, Q, !0);
                let te = [];
                for (const se of Y.vertices) {
                  const ie = se.x - Y.rect[0], fe = Y.rect[3] - se.y;
                  te.push(ie + "," + fe);
                }
                te = te.join(" ");
                const ae = this.#e = this.svgFactory.createElement(this.svgElementName);
                return ae.setAttribute("points", te), ae.setAttribute("stroke-width", Y.borderStyle.width || 1), ae.setAttribute("stroke", "transparent"), ae.setAttribute("fill", "transparent"), J.append(ae), this.container.append(J), !Y.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#e;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            class U extends G {
              constructor(Y) {
                super(Y), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
              }
            }
            class k extends C {
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.classList.add("caretAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
            }
            class N extends C {
              #e = [];
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0
                }), this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline", this.annotationEditorType = u.AnnotationEditorType.INK;
              }
              render() {
                this.container.classList.add(this.containerClassName);
                const Y = this.data, {
                  width: ee,
                  height: Q
                } = f(Y.rect), J = this.svgFactory.create(ee, Q, !0);
                for (const te of Y.inkLists) {
                  let ae = [];
                  for (const ie of te) {
                    const fe = ie.x - Y.rect[0], ge = Y.rect[3] - ie.y;
                    ae.push(`${fe},${ge}`);
                  }
                  ae = ae.join(" ");
                  const se = this.svgFactory.createElement(this.svgElementName);
                  this.#e.push(se), se.setAttribute("points", ae), se.setAttribute("stroke-width", Y.borderStyle.width || 1), se.setAttribute("stroke", "transparent"), se.setAttribute("fill", "transparent"), !Y.popupRef && this.hasPopupData && this._createPopup(), J.append(se);
                }
                return this.container.append(J), this.container;
              }
              getElementsToTriggerPopup() {
                return this.#e;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            s.InkAnnotationElement = N;
            class P extends C {
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("highlightAnnotation"), this.container;
              }
            }
            class D extends C {
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("underlineAnnotation"), this.container;
              }
            }
            class H extends C {
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("squigglyAnnotation"), this.container;
              }
            }
            class V extends C {
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("strikeoutAnnotation"), this.container;
              }
            }
            class Z extends C {
              constructor(Y) {
                super(Y, {
                  isRenderable: !0,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.classList.add("stampAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
              }
            }
            s.StampAnnotationElement = Z;
            class ne extends C {
              #e = null;
              constructor(Y) {
                super(Y, {
                  isRenderable: !0
                });
                const {
                  filename: ee,
                  content: Q
                } = this.data.file;
                this.filename = (0, d.getFilenameFromUrl)(ee, !0), this.content = Q, this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                  source: this,
                  filename: ee,
                  content: Q
                });
              }
              render() {
                this.container.classList.add("fileAttachmentAnnotation");
                const {
                  container: Y,
                  data: ee
                } = this;
                let Q;
                ee.hasAppearance || ee.fillAlpha === 0 ? Q = document.createElement("div") : (Q = document.createElement("img"), Q.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(ee.name) ? "paperclip" : "pushpin"}.svg`, ee.fillAlpha && ee.fillAlpha < 1 && (Q.style = `filter: opacity(${Math.round(ee.fillAlpha * 100)}%);`)), Q.addEventListener("dblclick", this.#t.bind(this)), this.#e = Q;
                const {
                  isMac: J
                } = u.FeatureTest.platform;
                return Y.addEventListener("keydown", (te) => {
                  te.key === "Enter" && (J ? te.metaKey : te.ctrlKey) && this.#t();
                }), !ee.popupRef && this.hasPopupData ? this._createPopup() : Q.classList.add("popupTriggerArea"), Y.append(Q), Y;
              }
              getElementsToTriggerPopup() {
                return this.#e;
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
              #t() {
                this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
              }
            }
            class K {
              #e = null;
              #t = null;
              #r = /* @__PURE__ */ new Map();
              constructor({
                div: Y,
                accessibilityManager: ee,
                annotationCanvasMap: Q,
                l10n: J,
                page: te,
                viewport: ae
              }) {
                this.div = Y, this.#e = ee, this.#t = Q, this.l10n = J, this.page = te, this.viewport = ae, this.zIndex = 0, this.l10n ||= A.NullL10n;
              }
              #n(Y, ee) {
                const Q = Y.firstChild || Y;
                Q.id = `${u.AnnotationPrefix}${ee}`, this.div.append(Y), this.#e?.moveElementInDOM(this.div, Y, Q, !1);
              }
              async render(Y) {
                const {
                  annotations: ee
                } = Y, Q = this.div;
                (0, d.setLayerDimensions)(Q, this.viewport);
                const J = /* @__PURE__ */ new Map(), te = {
                  data: null,
                  layer: Q,
                  linkService: Y.linkService,
                  downloadManager: Y.downloadManager,
                  imageResourcesPath: Y.imageResourcesPath || "",
                  renderForms: Y.renderForms !== !1,
                  svgFactory: new d.DOMSVGFactory(),
                  annotationStorage: Y.annotationStorage || new p.AnnotationStorage(),
                  enableScripting: Y.enableScripting === !0,
                  hasJSActions: Y.hasJSActions,
                  fieldObjects: Y.fieldObjects,
                  parent: this,
                  elements: null
                };
                for (const ae of ee) {
                  if (ae.noHTML)
                    continue;
                  const se = ae.annotationType === u.AnnotationType.POPUP;
                  if (se) {
                    const ge = J.get(ae.id);
                    if (!ge)
                      continue;
                    te.elements = ge;
                  } else {
                    const {
                      width: ge,
                      height: me
                    } = f(ae.rect);
                    if (ge <= 0 || me <= 0)
                      continue;
                  }
                  te.data = ae;
                  const ie = m.create(te);
                  if (!ie.isRenderable)
                    continue;
                  if (!se && ae.popupRef) {
                    const ge = J.get(ae.popupRef);
                    ge ? ge.push(ie) : J.set(ae.popupRef, [ie]);
                  }
                  ie.annotationEditorType > 0 && this.#r.set(ie.data.id, ie);
                  const fe = ie.render();
                  ae.hidden && (fe.style.visibility = "hidden"), this.#n(fe, ae.id);
                }
                this.#s(), await this.l10n.translate(Q);
              }
              update({
                viewport: Y
              }) {
                const ee = this.div;
                this.viewport = Y, (0, d.setLayerDimensions)(ee, {
                  rotation: Y.rotation
                }), this.#s(), ee.hidden = !1;
              }
              #s() {
                if (!this.#t)
                  return;
                const Y = this.div;
                for (const [ee, Q] of this.#t) {
                  const J = Y.querySelector(`[data-annotation-id="${ee}"]`);
                  if (!J)
                    continue;
                  const {
                    firstChild: te
                  } = J;
                  te ? te.nodeName === "CANVAS" ? te.replaceWith(Q) : te.before(Q) : J.append(Q);
                }
                this.#t.clear();
              }
              getEditableAnnotations() {
                return Array.from(this.#r.values());
              }
              getEditableAnnotation(Y) {
                return this.#r.get(Y);
              }
            }
            s.AnnotationLayer = K;
          },
          /* 30 */
          /***/
          (a, s) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.ColorConverters = void 0;
            function c(p) {
              return Math.floor(Math.max(0, Math.min(1, p)) * 255).toString(16).padStart(2, "0");
            }
            function u(p) {
              return Math.max(0, Math.min(255, 255 * p));
            }
            class d {
              static CMYK_G([v, A, x, g]) {
                return ["G", 1 - Math.min(1, 0.3 * v + 0.59 * x + 0.11 * A + g)];
              }
              static G_CMYK([v]) {
                return ["CMYK", 0, 0, 0, 1 - v];
              }
              static G_RGB([v]) {
                return ["RGB", v, v, v];
              }
              static G_rgb([v]) {
                return v = u(v), [v, v, v];
              }
              static G_HTML([v]) {
                const A = c(v);
                return `#${A}${A}${A}`;
              }
              static RGB_G([v, A, x]) {
                return ["G", 0.3 * v + 0.59 * A + 0.11 * x];
              }
              static RGB_rgb(v) {
                return v.map(u);
              }
              static RGB_HTML(v) {
                return `#${v.map(c).join("")}`;
              }
              static T_HTML() {
                return "#00000000";
              }
              static T_rgb() {
                return [null];
              }
              static CMYK_RGB([v, A, x, g]) {
                return ["RGB", 1 - Math.min(1, v + g), 1 - Math.min(1, x + g), 1 - Math.min(1, A + g)];
              }
              static CMYK_rgb([v, A, x, g]) {
                return [u(1 - Math.min(1, v + g)), u(1 - Math.min(1, x + g)), u(1 - Math.min(1, A + g))];
              }
              static CMYK_HTML(v) {
                const A = this.CMYK_RGB(v).slice(1);
                return this.RGB_HTML(A);
              }
              static RGB_CMYK([v, A, x]) {
                const g = 1 - v, b = 1 - A, y = 1 - x, f = Math.min(g, b, y);
                return ["CMYK", g, b, y, f];
              }
            }
            s.ColorConverters = d;
          },
          /* 31 */
          /***/
          (a, s) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.NullL10n = void 0, s.getL10nFallback = u;
            const c = {
              of_pages: "of {{pagesCount}}",
              page_of_pages: "({{pageNumber}} of {{pagesCount}})",
              document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
              document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
              document_properties_date_string: "{{date}}, {{time}}",
              document_properties_page_size_unit_inches: "in",
              document_properties_page_size_unit_millimeters: "mm",
              document_properties_page_size_orientation_portrait: "portrait",
              document_properties_page_size_orientation_landscape: "landscape",
              document_properties_page_size_name_a3: "A3",
              document_properties_page_size_name_a4: "A4",
              document_properties_page_size_name_letter: "Letter",
              document_properties_page_size_name_legal: "Legal",
              document_properties_page_size_dimension_string: "{{width}} × {{height}} {{unit}} ({{orientation}})",
              document_properties_page_size_dimension_name_string: "{{width}} × {{height}} {{unit}} ({{name}}, {{orientation}})",
              document_properties_linearized_yes: "Yes",
              document_properties_linearized_no: "No",
              additional_layers: "Additional Layers",
              page_landmark: "Page {{page}}",
              thumb_page_title: "Page {{page}}",
              thumb_page_canvas: "Thumbnail of Page {{page}}",
              find_reached_top: "Reached top of document, continued from bottom",
              find_reached_bottom: "Reached end of document, continued from top",
              "find_match_count[one]": "{{current}} of {{total}} match",
              "find_match_count[other]": "{{current}} of {{total}} matches",
              "find_match_count_limit[one]": "More than {{limit}} match",
              "find_match_count_limit[other]": "More than {{limit}} matches",
              find_not_found: "Phrase not found",
              page_scale_width: "Page Width",
              page_scale_fit: "Page Fit",
              page_scale_auto: "Automatic Zoom",
              page_scale_actual: "Actual Size",
              page_scale_percent: "{{scale}}%",
              loading_error: "An error occurred while loading the PDF.",
              invalid_file_error: "Invalid or corrupted PDF file.",
              missing_file_error: "Missing PDF file.",
              unexpected_response_error: "Unexpected server response.",
              rendering_error: "An error occurred while rendering the page.",
              annotation_date_string: "{{date}}, {{time}}",
              printing_not_supported: "Warning: Printing is not fully supported by this browser.",
              printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
              web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
              free_text2_default_content: "Start typing…",
              editor_free_text2_aria_label: "Text Editor",
              editor_ink2_aria_label: "Draw Editor",
              editor_ink_canvas_aria_label: "User-created image",
              editor_alt_text_button_label: "Alt text",
              editor_alt_text_edit_button_label: "Edit alt text",
              editor_alt_text_decorative_tooltip: "Marked as decorative"
            };
            c.print_progress_percent = "{{progress}}%";
            function u(v, A) {
              switch (v) {
                case "find_match_count":
                  v = `find_match_count[${A.total === 1 ? "one" : "other"}]`;
                  break;
                case "find_match_count_limit":
                  v = `find_match_count_limit[${A.limit === 1 ? "one" : "other"}]`;
                  break;
              }
              return c[v] || "";
            }
            function d(v, A) {
              return A ? v.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (x, g) => g in A ? A[g] : "{{" + g + "}}") : v;
            }
            const p = {
              async getLanguage() {
                return "en-us";
              },
              async getDirection() {
                return "ltr";
              },
              async get(v, A = null, x = u(v, A)) {
                return d(x, A);
              },
              async translate(v) {
              }
            };
            s.NullL10n = p;
          },
          /* 32 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.XfaLayer = void 0;
            var u = c(25);
            class d {
              static setupStorage(v, A, x, g, b) {
                const y = g.getValue(A, {
                  value: null
                });
                switch (x.name) {
                  case "textarea":
                    if (y.value !== null && (v.textContent = y.value), b === "print")
                      break;
                    v.addEventListener("input", (f) => {
                      g.setValue(A, {
                        value: f.target.value
                      });
                    });
                    break;
                  case "input":
                    if (x.attributes.type === "radio" || x.attributes.type === "checkbox") {
                      if (y.value === x.attributes.xfaOn ? v.setAttribute("checked", !0) : y.value === x.attributes.xfaOff && v.removeAttribute("checked"), b === "print")
                        break;
                      v.addEventListener("change", (f) => {
                        g.setValue(A, {
                          value: f.target.checked ? f.target.getAttribute("xfaOn") : f.target.getAttribute("xfaOff")
                        });
                      });
                    } else {
                      if (y.value !== null && v.setAttribute("value", y.value), b === "print")
                        break;
                      v.addEventListener("input", (f) => {
                        g.setValue(A, {
                          value: f.target.value
                        });
                      });
                    }
                    break;
                  case "select":
                    if (y.value !== null) {
                      v.setAttribute("value", y.value);
                      for (const f of x.children)
                        f.attributes.value === y.value ? f.attributes.selected = !0 : f.attributes.hasOwnProperty("selected") && delete f.attributes.selected;
                    }
                    v.addEventListener("input", (f) => {
                      const m = f.target.options, C = m.selectedIndex === -1 ? "" : m[m.selectedIndex].value;
                      g.setValue(A, {
                        value: C
                      });
                    });
                    break;
                }
              }
              static setAttributes({
                html: v,
                element: A,
                storage: x = null,
                intent: g,
                linkService: b
              }) {
                const {
                  attributes: y
                } = A, f = v instanceof HTMLAnchorElement;
                y.type === "radio" && (y.name = `${y.name}-${g}`);
                for (const [m, C] of Object.entries(y))
                  if (C != null)
                    switch (m) {
                      case "class":
                        C.length && v.setAttribute(m, C.join(" "));
                        break;
                      case "dataId":
                        break;
                      case "id":
                        v.setAttribute("data-element-id", C);
                        break;
                      case "style":
                        Object.assign(v.style, C);
                        break;
                      case "textContent":
                        v.textContent = C;
                        break;
                      default:
                        (!f || m !== "href" && m !== "newWindow") && v.setAttribute(m, C);
                    }
                f && b.addLinkAttributes(v, y.href, y.newWindow), x && y.dataId && this.setupStorage(v, y.dataId, A, x);
              }
              static render(v) {
                const A = v.annotationStorage, x = v.linkService, g = v.xfaHtml, b = v.intent || "display", y = document.createElement(g.name);
                g.attributes && this.setAttributes({
                  html: y,
                  element: g,
                  intent: b,
                  linkService: x
                });
                const f = [[g, -1, y]], m = v.div;
                if (m.append(y), v.viewport) {
                  const w = `matrix(${v.viewport.transform.join(",")})`;
                  m.style.transform = w;
                }
                b !== "richText" && m.setAttribute("class", "xfaLayer xfaFont");
                const C = [];
                for (; f.length > 0; ) {
                  const [w, S, $] = f.at(-1);
                  if (S + 1 === w.children.length) {
                    f.pop();
                    continue;
                  }
                  const T = w.children[++f.at(-1)[1]];
                  if (T === null)
                    continue;
                  const {
                    name: I
                  } = T;
                  if (I === "#text") {
                    const E = document.createTextNode(T.value);
                    C.push(E), $.append(E);
                    continue;
                  }
                  const _ = T?.attributes?.xmlns ? document.createElementNS(T.attributes.xmlns, I) : document.createElement(I);
                  if ($.append(_), T.attributes && this.setAttributes({
                    html: _,
                    element: T,
                    storage: A,
                    intent: b,
                    linkService: x
                  }), T.children && T.children.length > 0)
                    f.push([T, -1, _]);
                  else if (T.value) {
                    const E = document.createTextNode(T.value);
                    u.XfaText.shouldBuildText(I) && C.push(E), _.append(E);
                  }
                }
                for (const w of m.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
                  w.setAttribute("readOnly", !0);
                return {
                  textDivs: C
                };
              }
              static update(v) {
                const A = `matrix(${v.viewport.transform.join(",")})`;
                v.div.style.transform = A, v.div.hidden = !1;
              }
            }
            s.XfaLayer = d;
          },
          /* 33 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.InkEditor = void 0;
            var u = c(1), d = c(4), p = c(29), v = c(6), A = c(5);
            class x extends d.AnnotationEditor {
              #e = 0;
              #t = 0;
              #r = this.canvasPointermove.bind(this);
              #n = this.canvasPointerleave.bind(this);
              #s = this.canvasPointerup.bind(this);
              #o = this.canvasPointerdown.bind(this);
              #i = new Path2D();
              #l = !1;
              #c = !1;
              #a = !1;
              #p = null;
              #d = 0;
              #f = 0;
              #h = null;
              static _defaultColor = null;
              static _defaultOpacity = 1;
              static _defaultThickness = 1;
              static _type = "ink";
              constructor(b) {
                super({
                  ...b,
                  name: "inkEditor"
                }), this.color = b.color || null, this.thickness = b.thickness || null, this.opacity = b.opacity || null, this.paths = [], this.bezierPath2D = [], this.allRawPaths = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0, this._willKeepAspectRatio = !0;
              }
              static initialize(b) {
                d.AnnotationEditor.initialize(b, {
                  strings: ["editor_ink_canvas_aria_label", "editor_ink2_aria_label"]
                });
              }
              static updateDefaultParams(b, y) {
                switch (b) {
                  case u.AnnotationEditorParamsType.INK_THICKNESS:
                    x._defaultThickness = y;
                    break;
                  case u.AnnotationEditorParamsType.INK_COLOR:
                    x._defaultColor = y;
                    break;
                  case u.AnnotationEditorParamsType.INK_OPACITY:
                    x._defaultOpacity = y / 100;
                    break;
                }
              }
              updateParams(b, y) {
                switch (b) {
                  case u.AnnotationEditorParamsType.INK_THICKNESS:
                    this.#A(y);
                    break;
                  case u.AnnotationEditorParamsType.INK_COLOR:
                    this.#m(y);
                    break;
                  case u.AnnotationEditorParamsType.INK_OPACITY:
                    this.#g(y);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[u.AnnotationEditorParamsType.INK_THICKNESS, x._defaultThickness], [u.AnnotationEditorParamsType.INK_COLOR, x._defaultColor || d.AnnotationEditor._defaultLineColor], [u.AnnotationEditorParamsType.INK_OPACITY, Math.round(x._defaultOpacity * 100)]];
              }
              get propertiesToUpdate() {
                return [[u.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || x._defaultThickness], [u.AnnotationEditorParamsType.INK_COLOR, this.color || x._defaultColor || d.AnnotationEditor._defaultLineColor], [u.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? x._defaultOpacity))]];
              }
              #A(b) {
                const y = this.thickness;
                this.addCommands({
                  cmd: () => {
                    this.thickness = b, this.#S();
                  },
                  undo: () => {
                    this.thickness = y, this.#S();
                  },
                  mustExec: !0,
                  type: u.AnnotationEditorParamsType.INK_THICKNESS,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              #m(b) {
                const y = this.color;
                this.addCommands({
                  cmd: () => {
                    this.color = b, this.#b();
                  },
                  undo: () => {
                    this.color = y, this.#b();
                  },
                  mustExec: !0,
                  type: u.AnnotationEditorParamsType.INK_COLOR,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              #g(b) {
                b /= 100;
                const y = this.opacity;
                this.addCommands({
                  cmd: () => {
                    this.opacity = b, this.#b();
                  },
                  undo: () => {
                    this.opacity = y, this.#b();
                  },
                  mustExec: !0,
                  type: u.AnnotationEditorParamsType.INK_OPACITY,
                  overwriteIfSameType: !0,
                  keepUndo: !0
                });
              }
              rebuild() {
                this.parent && (super.rebuild(), this.div !== null && (this.canvas || (this.#T(), this.#R()), this.isAttachedToDOM || (this.parent.add(this), this.#x()), this.#S()));
              }
              remove() {
                this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, this.#p.disconnect(), this.#p = null, super.remove());
              }
              setParent(b) {
                !this.parent && b ? this._uiManager.removeShouldRescale(this) : this.parent && b === null && this._uiManager.addShouldRescale(this), super.setParent(b);
              }
              onScaleChanging() {
                const [b, y] = this.parentDimensions, f = this.width * b, m = this.height * y;
                this.setDimensions(f, m);
              }
              enableEditMode() {
                this.#l || this.canvas === null || (super.enableEditMode(), this._isDraggable = !1, this.canvas.addEventListener("pointerdown", this.#o));
              }
              disableEditMode() {
                !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this._isDraggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", this.#o));
              }
              onceAdded() {
                this._isDraggable = !this.isEmpty();
              }
              isEmpty() {
                return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
              }
              #u() {
                const {
                  parentRotation: b,
                  parentDimensions: [y, f]
                } = this;
                switch (b) {
                  case 90:
                    return [0, f, f, y];
                  case 180:
                    return [y, f, y, f];
                  case 270:
                    return [y, 0, f, y];
                  default:
                    return [0, 0, y, f];
                }
              }
              #v() {
                const {
                  ctx: b,
                  color: y,
                  opacity: f,
                  thickness: m,
                  parentScale: C,
                  scaleFactor: w
                } = this;
                b.lineWidth = m * C / w, b.lineCap = "round", b.lineJoin = "round", b.miterLimit = 10, b.strokeStyle = `${y}${(0, A.opacityToHex)(f)}`;
              }
              #E(b, y) {
                this.canvas.addEventListener("contextmenu", v.noContextMenu), this.canvas.addEventListener("pointerleave", this.#n), this.canvas.addEventListener("pointermove", this.#r), this.canvas.addEventListener("pointerup", this.#s), this.canvas.removeEventListener("pointerdown", this.#o), this.isEditing = !0, this.#a || (this.#a = !0, this.#x(), this.thickness ||= x._defaultThickness, this.color ||= x._defaultColor || d.AnnotationEditor._defaultLineColor, this.opacity ??= x._defaultOpacity), this.currentPath.push([b, y]), this.#c = !1, this.#v(), this.#h = () => {
                  this.#M(), this.#h && window.requestAnimationFrame(this.#h);
                }, window.requestAnimationFrame(this.#h);
              }
              #C(b, y) {
                const [f, m] = this.currentPath.at(-1);
                if (this.currentPath.length > 1 && b === f && y === m)
                  return;
                const C = this.currentPath;
                let w = this.#i;
                if (C.push([b, y]), this.#c = !0, C.length <= 2) {
                  w.moveTo(...C[0]), w.lineTo(b, y);
                  return;
                }
                C.length === 3 && (this.#i = w = new Path2D(), w.moveTo(...C[0])), this.#k(w, ...C.at(-3), ...C.at(-2), b, y);
              }
              #$() {
                if (this.currentPath.length === 0)
                  return;
                const b = this.currentPath.at(-1);
                this.#i.lineTo(...b);
              }
              #_(b, y) {
                this.#h = null, b = Math.min(Math.max(b, 0), this.canvas.width), y = Math.min(Math.max(y, 0), this.canvas.height), this.#C(b, y), this.#$();
                let f;
                if (this.currentPath.length !== 1)
                  f = this.#D();
                else {
                  const $ = [b, y];
                  f = [[$, $.slice(), $.slice(), $]];
                }
                const m = this.#i, C = this.currentPath;
                this.currentPath = [], this.#i = new Path2D();
                const w = () => {
                  this.allRawPaths.push(C), this.paths.push(f), this.bezierPath2D.push(m), this.rebuild();
                }, S = () => {
                  this.allRawPaths.pop(), this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (this.#T(), this.#R()), this.#S());
                };
                this.addCommands({
                  cmd: w,
                  undo: S,
                  mustExec: !0
                });
              }
              #M() {
                if (!this.#c)
                  return;
                this.#c = !1;
                const b = Math.ceil(this.thickness * this.parentScale), y = this.currentPath.slice(-3), f = y.map((w) => w[0]), m = y.map((w) => w[1]);
                Math.min(...f) - b, Math.max(...f) + b, Math.min(...m) - b, Math.max(...m) + b;
                const {
                  ctx: C
                } = this;
                C.save(), C.clearRect(0, 0, this.canvas.width, this.canvas.height);
                for (const w of this.bezierPath2D)
                  C.stroke(w);
                C.stroke(this.#i), C.restore();
              }
              #k(b, y, f, m, C, w, S) {
                const $ = (y + m) / 2, T = (f + C) / 2, I = (m + w) / 2, _ = (C + S) / 2;
                b.bezierCurveTo($ + 2 * (m - $) / 3, T + 2 * (C - T) / 3, I + 2 * (m - I) / 3, _ + 2 * (C - _) / 3, I, _);
              }
              #D() {
                const b = this.currentPath;
                if (b.length <= 2)
                  return [[b[0], b[0], b.at(-1), b.at(-1)]];
                const y = [];
                let f, [m, C] = b[0];
                for (f = 1; f < b.length - 2; f++) {
                  const [E, R] = b[f], [O, L] = b[f + 1], B = (E + O) / 2, F = (R + L) / 2, M = [m + 2 * (E - m) / 3, C + 2 * (R - C) / 3], W = [B + 2 * (E - B) / 3, F + 2 * (R - F) / 3];
                  y.push([[m, C], M, W, [B, F]]), [m, C] = [B, F];
                }
                const [w, S] = b[f], [$, T] = b[f + 1], I = [m + 2 * (w - m) / 3, C + 2 * (S - C) / 3], _ = [$ + 2 * (w - $) / 3, T + 2 * (S - T) / 3];
                return y.push([[m, C], I, _, [$, T]]), y;
              }
              #b() {
                if (this.isEmpty()) {
                  this.#w();
                  return;
                }
                this.#v();
                const {
                  canvas: b,
                  ctx: y
                } = this;
                y.setTransform(1, 0, 0, 1, 0, 0), y.clearRect(0, 0, b.width, b.height), this.#w();
                for (const f of this.bezierPath2D)
                  y.stroke(f);
              }
              commit() {
                this.#l || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), this.#l = !0, this.div.classList.add("disabled"), this.#S(!0), this.makeResizable(), this.parent.addInkEditorIfNeeded(!0), this.moveInDOM(), this.div.focus({
                  preventScroll: !0
                }));
              }
              focusin(b) {
                this._focusEventsAllowed && (super.focusin(b), this.enableEditMode());
              }
              canvasPointerdown(b) {
                b.button !== 0 || !this.isInEditMode() || this.#l || (this.setInForeground(), b.preventDefault(), b.type !== "mouse" && this.div.focus(), this.#E(b.offsetX, b.offsetY));
              }
              canvasPointermove(b) {
                b.preventDefault(), this.#C(b.offsetX, b.offsetY);
              }
              canvasPointerup(b) {
                b.preventDefault(), this.#O(b);
              }
              canvasPointerleave(b) {
                this.#O(b);
              }
              #O(b) {
                this.canvas.removeEventListener("pointerleave", this.#n), this.canvas.removeEventListener("pointermove", this.#r), this.canvas.removeEventListener("pointerup", this.#s), this.canvas.addEventListener("pointerdown", this.#o), setTimeout(() => {
                  this.canvas.removeEventListener("contextmenu", v.noContextMenu);
                }, 10), this.#_(b.offsetX, b.offsetY), this.addToAnnotationStorage(), this.setInBackground();
              }
              #T() {
                this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", d.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((b) => this.canvas?.setAttribute("aria-label", b)), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
              }
              #R() {
                this.#p = new ResizeObserver((b) => {
                  const y = b[0].contentRect;
                  y.width && y.height && this.setDimensions(y.width, y.height);
                }), this.#p.observe(this.div);
              }
              get isResizable() {
                return !this.isEmpty() && this.#l;
              }
              render() {
                if (this.div)
                  return this.div;
                let b, y;
                this.width && (b = this.x, y = this.y), super.render(), d.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((S) => this.div?.setAttribute("aria-label", S));
                const [f, m, C, w] = this.#u();
                if (this.setAt(f, m, 0, 0), this.setDims(C, w), this.#T(), this.width) {
                  const [S, $] = this.parentDimensions;
                  this.setAspectRatio(this.width * S, this.height * $), this.setAt(b * S, y * $, this.width * S, this.height * $), this.#a = !0, this.#x(), this.setDims(this.width * S, this.height * $), this.#b(), this.div.classList.add("disabled");
                } else
                  this.div.classList.add("editing"), this.enableEditMode();
                return this.#R(), this.div;
              }
              #x() {
                if (!this.#a)
                  return;
                const [b, y] = this.parentDimensions;
                this.canvas.width = Math.ceil(this.width * b), this.canvas.height = Math.ceil(this.height * y), this.#w();
              }
              setDimensions(b, y) {
                const f = Math.round(b), m = Math.round(y);
                if (this.#d === f && this.#f === m)
                  return;
                this.#d = f, this.#f = m, this.canvas.style.visibility = "hidden";
                const [C, w] = this.parentDimensions;
                this.width = b / C, this.height = y / w, this.fixAndSetPosition(), this.#l && this.#I(b, y), this.#x(), this.#b(), this.canvas.style.visibility = "visible", this.fixDims();
              }
              #I(b, y) {
                const f = this.#B(), m = (b - f) / this.#t, C = (y - f) / this.#e;
                this.scaleFactor = Math.min(m, C);
              }
              #w() {
                const b = this.#B() / 2;
                this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + b, this.translationY * this.scaleFactor + b);
              }
              static #F(b) {
                const y = new Path2D();
                for (let f = 0, m = b.length; f < m; f++) {
                  const [C, w, S, $] = b[f];
                  f === 0 && y.moveTo(...C), y.bezierCurveTo(w[0], w[1], S[0], S[1], $[0], $[1]);
                }
                return y;
              }
              static #L(b, y, f) {
                const [m, C, w, S] = y;
                switch (f) {
                  case 0:
                    for (let $ = 0, T = b.length; $ < T; $ += 2)
                      b[$] += m, b[$ + 1] = S - b[$ + 1];
                    break;
                  case 90:
                    for (let $ = 0, T = b.length; $ < T; $ += 2) {
                      const I = b[$];
                      b[$] = b[$ + 1] + m, b[$ + 1] = I + C;
                    }
                    break;
                  case 180:
                    for (let $ = 0, T = b.length; $ < T; $ += 2)
                      b[$] = w - b[$], b[$ + 1] += C;
                    break;
                  case 270:
                    for (let $ = 0, T = b.length; $ < T; $ += 2) {
                      const I = b[$];
                      b[$] = w - b[$ + 1], b[$ + 1] = S - I;
                    }
                    break;
                  default:
                    throw new Error("Invalid rotation");
                }
                return b;
              }
              static #N(b, y, f) {
                const [m, C, w, S] = y;
                switch (f) {
                  case 0:
                    for (let $ = 0, T = b.length; $ < T; $ += 2)
                      b[$] -= m, b[$ + 1] = S - b[$ + 1];
                    break;
                  case 90:
                    for (let $ = 0, T = b.length; $ < T; $ += 2) {
                      const I = b[$];
                      b[$] = b[$ + 1] - C, b[$ + 1] = I - m;
                    }
                    break;
                  case 180:
                    for (let $ = 0, T = b.length; $ < T; $ += 2)
                      b[$] = w - b[$], b[$ + 1] -= C;
                    break;
                  case 270:
                    for (let $ = 0, T = b.length; $ < T; $ += 2) {
                      const I = b[$];
                      b[$] = S - b[$ + 1], b[$ + 1] = w - I;
                    }
                    break;
                  default:
                    throw new Error("Invalid rotation");
                }
                return b;
              }
              #j(b, y, f, m) {
                const C = [], w = this.thickness / 2, S = b * y + w, $ = b * f + w;
                for (const T of this.paths) {
                  const I = [], _ = [];
                  for (let E = 0, R = T.length; E < R; E++) {
                    const [O, L, B, F] = T[E], M = b * O[0] + S, W = b * O[1] + $, j = b * L[0] + S, G = b * L[1] + $, U = b * B[0] + S, k = b * B[1] + $, N = b * F[0] + S, P = b * F[1] + $;
                    E === 0 && (I.push(M, W), _.push(M, W)), I.push(j, G, U, k, N, P), _.push(j, G), E === R - 1 && _.push(N, P);
                  }
                  C.push({
                    bezier: x.#L(I, m, this.rotation),
                    points: x.#L(_, m, this.rotation)
                  });
                }
                return C;
              }
              #P() {
                let b = 1 / 0, y = -1 / 0, f = 1 / 0, m = -1 / 0;
                for (const C of this.paths)
                  for (const [w, S, $, T] of C) {
                    const I = u.Util.bezierBoundingBox(...w, ...S, ...$, ...T);
                    b = Math.min(b, I[0]), f = Math.min(f, I[1]), y = Math.max(y, I[2]), m = Math.max(m, I[3]);
                  }
                return [b, f, y, m];
              }
              #B() {
                return this.#l ? Math.ceil(this.thickness * this.parentScale) : 0;
              }
              #S(b = !1) {
                if (this.isEmpty())
                  return;
                if (!this.#l) {
                  this.#b();
                  return;
                }
                const y = this.#P(), f = this.#B();
                this.#t = Math.max(d.AnnotationEditor.MIN_SIZE, y[2] - y[0]), this.#e = Math.max(d.AnnotationEditor.MIN_SIZE, y[3] - y[1]);
                const m = Math.ceil(f + this.#t * this.scaleFactor), C = Math.ceil(f + this.#e * this.scaleFactor), [w, S] = this.parentDimensions;
                this.width = m / w, this.height = C / S, this.setAspectRatio(m, C);
                const $ = this.translationX, T = this.translationY;
                this.translationX = -y[0], this.translationY = -y[1], this.#x(), this.#b(), this.#d = m, this.#f = C, this.setDims(m, C);
                const I = b ? f / this.scaleFactor / 2 : 0;
                this.translate($ - this.translationX - I, T - this.translationY - I);
              }
              static deserialize(b, y, f) {
                if (b instanceof p.InkAnnotationElement)
                  return null;
                const m = super.deserialize(b, y, f);
                m.thickness = b.thickness, m.color = u.Util.makeHexColor(...b.color), m.opacity = b.opacity;
                const [C, w] = m.pageDimensions, S = m.width * C, $ = m.height * w, T = m.parentScale, I = b.thickness / 2;
                m.#l = !0, m.#d = Math.round(S), m.#f = Math.round($);
                const {
                  paths: _,
                  rect: E,
                  rotation: R
                } = b;
                for (let {
                  bezier: L
                } of _) {
                  L = x.#N(L, E, R);
                  const B = [];
                  m.paths.push(B);
                  let F = T * (L[0] - I), M = T * (L[1] - I);
                  for (let j = 2, G = L.length; j < G; j += 6) {
                    const U = T * (L[j] - I), k = T * (L[j + 1] - I), N = T * (L[j + 2] - I), P = T * (L[j + 3] - I), D = T * (L[j + 4] - I), H = T * (L[j + 5] - I);
                    B.push([[F, M], [U, k], [N, P], [D, H]]), F = D, M = H;
                  }
                  const W = this.#F(B);
                  m.bezierPath2D.push(W);
                }
                const O = m.#P();
                return m.#t = Math.max(d.AnnotationEditor.MIN_SIZE, O[2] - O[0]), m.#e = Math.max(d.AnnotationEditor.MIN_SIZE, O[3] - O[1]), m.#I(S, $), m;
              }
              serialize() {
                if (this.isEmpty())
                  return null;
                const b = this.getRect(0, 0), y = d.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                return {
                  annotationType: u.AnnotationEditorType.INK,
                  color: y,
                  thickness: this.thickness,
                  opacity: this.opacity,
                  paths: this.#j(this.scaleFactor / this.parentScale, this.translationX, this.translationY, b),
                  pageIndex: this.pageIndex,
                  rect: b,
                  rotation: this.rotation,
                  structTreeParentId: this._structTreeParentId
                };
              }
            }
            s.InkEditor = x;
          },
          /* 34 */
          /***/
          (a, s, c) => {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.StampEditor = void 0;
            var u = c(1), d = c(4), p = c(6), v = c(29);
            class A extends d.AnnotationEditor {
              #e = null;
              #t = null;
              #r = null;
              #n = null;
              #s = null;
              #o = null;
              #i = null;
              #l = null;
              #c = !1;
              #a = !1;
              static _type = "stamp";
              constructor(g) {
                super({
                  ...g,
                  name: "stampEditor"
                }), this.#n = g.bitmapUrl, this.#s = g.bitmapFile;
              }
              static initialize(g) {
                d.AnnotationEditor.initialize(g);
              }
              static get supportedTypes() {
                const g = ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"];
                return (0, u.shadow)(this, "supportedTypes", g.map((b) => `image/${b}`));
              }
              static get supportedTypesStr() {
                return (0, u.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
              }
              static isHandlingMimeForPasting(g) {
                return this.supportedTypes.includes(g);
              }
              static paste(g, b) {
                b.pasteEditor(u.AnnotationEditorType.STAMP, {
                  bitmapFile: g.getAsFile()
                });
              }
              #p(g, b = !1) {
                if (!g) {
                  this.remove();
                  return;
                }
                this.#e = g.bitmap, b || (this.#t = g.id, this.#c = g.isSvg), this.#h();
              }
              #d() {
                this.#r = null, this._uiManager.enableWaiting(!1), this.#o && this.div.focus();
              }
              #f() {
                if (this.#t) {
                  this._uiManager.enableWaiting(!0), this._uiManager.imageManager.getFromId(this.#t).then((b) => this.#p(b, !0)).finally(() => this.#d());
                  return;
                }
                if (this.#n) {
                  const b = this.#n;
                  this.#n = null, this._uiManager.enableWaiting(!0), this.#r = this._uiManager.imageManager.getFromUrl(b).then((y) => this.#p(y)).finally(() => this.#d());
                  return;
                }
                if (this.#s) {
                  const b = this.#s;
                  this.#s = null, this._uiManager.enableWaiting(!0), this.#r = this._uiManager.imageManager.getFromFile(b).then((y) => this.#p(y)).finally(() => this.#d());
                  return;
                }
                const g = document.createElement("input");
                g.type = "file", g.accept = A.supportedTypesStr, this.#r = new Promise((b) => {
                  g.addEventListener("change", async () => {
                    if (!g.files || g.files.length === 0)
                      this.remove();
                    else {
                      this._uiManager.enableWaiting(!0);
                      const y = await this._uiManager.imageManager.getFromFile(g.files[0]);
                      this.#p(y);
                    }
                    b();
                  }), g.addEventListener("cancel", () => {
                    this.remove(), b();
                  });
                }).finally(() => this.#d()), g.click();
              }
              remove() {
                this.#t && (this.#e = null, this._uiManager.imageManager.deleteId(this.#t), this.#o?.remove(), this.#o = null, this.#i?.disconnect(), this.#i = null), super.remove();
              }
              rebuild() {
                if (!this.parent) {
                  this.#t && this.#f();
                  return;
                }
                super.rebuild(), this.div !== null && (this.#t && this.#f(), this.isAttachedToDOM || this.parent.add(this));
              }
              onceAdded() {
                this._isDraggable = !0, this.div.focus();
              }
              isEmpty() {
                return !(this.#r || this.#e || this.#n || this.#s);
              }
              get isResizable() {
                return !0;
              }
              render() {
                if (this.div)
                  return this.div;
                let g, b;
                if (this.width && (g = this.x, b = this.y), super.render(), this.div.hidden = !0, this.#e ? this.#h() : this.#f(), this.width) {
                  const [y, f] = this.parentDimensions;
                  this.setAt(g * y, b * f, this.width * y, this.height * f);
                }
                return this.div;
              }
              #h() {
                const {
                  div: g
                } = this;
                let {
                  width: b,
                  height: y
                } = this.#e;
                const [f, m] = this.pageDimensions, C = 0.75;
                if (this.width)
                  b = this.width * f, y = this.height * m;
                else if (b > C * f || y > C * m) {
                  const T = Math.min(C * f / b, C * m / y);
                  b *= T, y *= T;
                }
                const [w, S] = this.parentDimensions;
                this.setDims(b * w / f, y * S / m), this._uiManager.enableWaiting(!1);
                const $ = this.#o = document.createElement("canvas");
                g.append($), g.hidden = !1, this.#g(b, y), this.#v(), this.#a || (this.parent.addUndoableEditor(this), this.#a = !0), this._uiManager._eventBus.dispatch("reporttelemetry", {
                  source: this,
                  details: {
                    type: "editing",
                    subtype: this.editorType,
                    data: {
                      action: "inserted_image"
                    }
                  }
                }), this.addAltTextButton();
              }
              #A(g, b) {
                const [y, f] = this.parentDimensions;
                this.width = g / y, this.height = b / f, this.setDims(g, b), this._initialOptions?.isCentered ? this.center() : this.fixAndSetPosition(), this._initialOptions = null, this.#l !== null && clearTimeout(this.#l);
                const m = 200;
                this.#l = setTimeout(() => {
                  this.#l = null, this.#g(g, b);
                }, m);
              }
              #m(g, b) {
                const {
                  width: y,
                  height: f
                } = this.#e;
                let m = y, C = f, w = this.#e;
                for (; m > 2 * g || C > 2 * b; ) {
                  const S = m, $ = C;
                  m > 2 * g && (m = m >= 16384 ? Math.floor(m / 2) - 1 : Math.ceil(m / 2)), C > 2 * b && (C = C >= 16384 ? Math.floor(C / 2) - 1 : Math.ceil(C / 2));
                  const T = new OffscreenCanvas(m, C);
                  T.getContext("2d").drawImage(w, 0, 0, S, $, 0, 0, m, C), w = T.transferToImageBitmap();
                }
                return w;
              }
              #g(g, b) {
                g = Math.ceil(g), b = Math.ceil(b);
                const y = this.#o;
                if (!y || y.width === g && y.height === b)
                  return;
                y.width = g, y.height = b;
                const f = this.#c ? this.#e : this.#m(g, b), m = y.getContext("2d");
                m.filter = this._uiManager.hcmFilter, m.drawImage(f, 0, 0, f.width, f.height, 0, 0, g, b);
              }
              #u(g) {
                if (g) {
                  if (this.#c) {
                    const f = this._uiManager.imageManager.getSvgUrl(this.#t);
                    if (f)
                      return f;
                  }
                  const b = document.createElement("canvas");
                  return {
                    width: b.width,
                    height: b.height
                  } = this.#e, b.getContext("2d").drawImage(this.#e, 0, 0), b.toDataURL();
                }
                if (this.#c) {
                  const [b, y] = this.pageDimensions, f = Math.round(this.width * b * p.PixelsPerInch.PDF_TO_CSS_UNITS), m = Math.round(this.height * y * p.PixelsPerInch.PDF_TO_CSS_UNITS), C = new OffscreenCanvas(f, m);
                  return C.getContext("2d").drawImage(this.#e, 0, 0, this.#e.width, this.#e.height, 0, 0, f, m), C.transferToImageBitmap();
                }
                return structuredClone(this.#e);
              }
              #v() {
                this.#i = new ResizeObserver((g) => {
                  const b = g[0].contentRect;
                  b.width && b.height && this.#A(b.width, b.height);
                }), this.#i.observe(this.div);
              }
              static deserialize(g, b, y) {
                if (g instanceof v.StampAnnotationElement)
                  return null;
                const f = super.deserialize(g, b, y), {
                  rect: m,
                  bitmapUrl: C,
                  bitmapId: w,
                  isSvg: S,
                  accessibilityData: $
                } = g;
                w && y.imageManager.isValidId(w) ? f.#t = w : f.#n = C, f.#c = S;
                const [T, I] = f.pageDimensions;
                return f.width = (m[2] - m[0]) / T, f.height = (m[3] - m[1]) / I, $ && (f.altTextData = $), f;
              }
              serialize(g = !1, b = null) {
                if (this.isEmpty())
                  return null;
                const y = {
                  annotationType: u.AnnotationEditorType.STAMP,
                  bitmapId: this.#t,
                  pageIndex: this.pageIndex,
                  rect: this.getRect(0, 0),
                  rotation: this.rotation,
                  isSvg: this.#c,
                  structTreeParentId: this._structTreeParentId
                };
                if (g)
                  return y.bitmapUrl = this.#u(!0), y.accessibilityData = this.altTextData, y;
                const {
                  decorative: f,
                  altText: m
                } = this.altTextData;
                if (!f && m && (y.accessibilityData = {
                  type: "Figure",
                  alt: m
                }), b === null)
                  return y;
                b.stamps ||= /* @__PURE__ */ new Map();
                const C = this.#c ? (y.rect[2] - y.rect[0]) * (y.rect[3] - y.rect[1]) : null;
                if (!b.stamps.has(this.#t))
                  b.stamps.set(this.#t, {
                    area: C,
                    serialized: y
                  }), y.bitmap = this.#u(!1);
                else if (this.#c) {
                  const w = b.stamps.get(this.#t);
                  C > w.area && (w.area = C, w.serialized.bitmap.close(), w.serialized.bitmap = this.#u(!1));
                }
                return y;
              }
            }
            s.StampEditor = A;
          }
          /******/
        ], __webpack_module_cache__ = {};
        function __w_pdfjs_require__(a) {
          var s = __webpack_module_cache__[a];
          if (s !== void 0)
            return s.exports;
          var c = __webpack_module_cache__[a] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return __webpack_modules__[a](c, c.exports, __w_pdfjs_require__), c.exports;
        }
        var __webpack_exports__ = {};
        return (() => {
          var a = __webpack_exports__;
          Object.defineProperty(a, "__esModule", {
            value: !0
          }), Object.defineProperty(a, "AbortException", {
            enumerable: !0,
            get: function() {
              return s.AbortException;
            }
          }), Object.defineProperty(a, "AnnotationEditorLayer", {
            enumerable: !0,
            get: function() {
              return p.AnnotationEditorLayer;
            }
          }), Object.defineProperty(a, "AnnotationEditorParamsType", {
            enumerable: !0,
            get: function() {
              return s.AnnotationEditorParamsType;
            }
          }), Object.defineProperty(a, "AnnotationEditorType", {
            enumerable: !0,
            get: function() {
              return s.AnnotationEditorType;
            }
          }), Object.defineProperty(a, "AnnotationEditorUIManager", {
            enumerable: !0,
            get: function() {
              return v.AnnotationEditorUIManager;
            }
          }), Object.defineProperty(a, "AnnotationLayer", {
            enumerable: !0,
            get: function() {
              return A.AnnotationLayer;
            }
          }), Object.defineProperty(a, "AnnotationMode", {
            enumerable: !0,
            get: function() {
              return s.AnnotationMode;
            }
          }), Object.defineProperty(a, "CMapCompressionType", {
            enumerable: !0,
            get: function() {
              return s.CMapCompressionType;
            }
          }), Object.defineProperty(a, "DOMSVGFactory", {
            enumerable: !0,
            get: function() {
              return u.DOMSVGFactory;
            }
          }), Object.defineProperty(a, "FeatureTest", {
            enumerable: !0,
            get: function() {
              return s.FeatureTest;
            }
          }), Object.defineProperty(a, "GlobalWorkerOptions", {
            enumerable: !0,
            get: function() {
              return x.GlobalWorkerOptions;
            }
          }), Object.defineProperty(a, "ImageKind", {
            enumerable: !0,
            get: function() {
              return s.ImageKind;
            }
          }), Object.defineProperty(a, "InvalidPDFException", {
            enumerable: !0,
            get: function() {
              return s.InvalidPDFException;
            }
          }), Object.defineProperty(a, "MissingPDFException", {
            enumerable: !0,
            get: function() {
              return s.MissingPDFException;
            }
          }), Object.defineProperty(a, "OPS", {
            enumerable: !0,
            get: function() {
              return s.OPS;
            }
          }), Object.defineProperty(a, "PDFDataRangeTransport", {
            enumerable: !0,
            get: function() {
              return c.PDFDataRangeTransport;
            }
          }), Object.defineProperty(a, "PDFDateString", {
            enumerable: !0,
            get: function() {
              return u.PDFDateString;
            }
          }), Object.defineProperty(a, "PDFWorker", {
            enumerable: !0,
            get: function() {
              return c.PDFWorker;
            }
          }), Object.defineProperty(a, "PasswordResponses", {
            enumerable: !0,
            get: function() {
              return s.PasswordResponses;
            }
          }), Object.defineProperty(a, "PermissionFlag", {
            enumerable: !0,
            get: function() {
              return s.PermissionFlag;
            }
          }), Object.defineProperty(a, "PixelsPerInch", {
            enumerable: !0,
            get: function() {
              return u.PixelsPerInch;
            }
          }), Object.defineProperty(a, "PromiseCapability", {
            enumerable: !0,
            get: function() {
              return s.PromiseCapability;
            }
          }), Object.defineProperty(a, "RenderingCancelledException", {
            enumerable: !0,
            get: function() {
              return u.RenderingCancelledException;
            }
          }), Object.defineProperty(a, "SVGGraphics", {
            enumerable: !0,
            get: function() {
              return c.SVGGraphics;
            }
          }), Object.defineProperty(a, "UnexpectedResponseException", {
            enumerable: !0,
            get: function() {
              return s.UnexpectedResponseException;
            }
          }), Object.defineProperty(a, "Util", {
            enumerable: !0,
            get: function() {
              return s.Util;
            }
          }), Object.defineProperty(a, "VerbosityLevel", {
            enumerable: !0,
            get: function() {
              return s.VerbosityLevel;
            }
          }), Object.defineProperty(a, "XfaLayer", {
            enumerable: !0,
            get: function() {
              return g.XfaLayer;
            }
          }), Object.defineProperty(a, "build", {
            enumerable: !0,
            get: function() {
              return c.build;
            }
          }), Object.defineProperty(a, "createValidAbsoluteUrl", {
            enumerable: !0,
            get: function() {
              return s.createValidAbsoluteUrl;
            }
          }), Object.defineProperty(a, "getDocument", {
            enumerable: !0,
            get: function() {
              return c.getDocument;
            }
          }), Object.defineProperty(a, "getFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return u.getFilenameFromUrl;
            }
          }), Object.defineProperty(a, "getPdfFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return u.getPdfFilenameFromUrl;
            }
          }), Object.defineProperty(a, "getXfaPageViewport", {
            enumerable: !0,
            get: function() {
              return u.getXfaPageViewport;
            }
          }), Object.defineProperty(a, "isDataScheme", {
            enumerable: !0,
            get: function() {
              return u.isDataScheme;
            }
          }), Object.defineProperty(a, "isPdfFile", {
            enumerable: !0,
            get: function() {
              return u.isPdfFile;
            }
          }), Object.defineProperty(a, "loadScript", {
            enumerable: !0,
            get: function() {
              return u.loadScript;
            }
          }), Object.defineProperty(a, "noContextMenu", {
            enumerable: !0,
            get: function() {
              return u.noContextMenu;
            }
          }), Object.defineProperty(a, "normalizeUnicode", {
            enumerable: !0,
            get: function() {
              return s.normalizeUnicode;
            }
          }), Object.defineProperty(a, "renderTextLayer", {
            enumerable: !0,
            get: function() {
              return d.renderTextLayer;
            }
          }), Object.defineProperty(a, "setLayerDimensions", {
            enumerable: !0,
            get: function() {
              return u.setLayerDimensions;
            }
          }), Object.defineProperty(a, "shadow", {
            enumerable: !0,
            get: function() {
              return s.shadow;
            }
          }), Object.defineProperty(a, "updateTextLayer", {
            enumerable: !0,
            get: function() {
              return d.updateTextLayer;
            }
          }), Object.defineProperty(a, "version", {
            enumerable: !0,
            get: function() {
              return c.version;
            }
          });
          var s = __w_pdfjs_require__(1), c = __w_pdfjs_require__(2), u = __w_pdfjs_require__(6), d = __w_pdfjs_require__(26), p = __w_pdfjs_require__(27), v = __w_pdfjs_require__(5), A = __w_pdfjs_require__(29), x = __w_pdfjs_require__(14), g = __w_pdfjs_require__(32);
        })(), __webpack_exports__;
      })()
    ));
  }(pdf)), pdf.exports;
}
var pdfExports = requirePdf(), pdf_worker_entry = {}, pdf_worker = { exports: {} }, hasRequiredPdf_worker;
function requirePdf_worker() {
  return hasRequiredPdf_worker || (hasRequiredPdf_worker = 1, function(a, s) {
    (function(u, d) {
      a.exports = u.pdfjsWorker = d();
    })(globalThis, () => (
      /******/
      (() => {
        var c = [
          ,
          /* 1 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.WorkerTask = A.WorkerMessageHandler = void 0;
            var g = x(2), b = x(3), y = x(4), f = x(6), m = x(10), C = x(68), w = x(73), S = x(104), $ = x(105), T = x(72);
            class I {
              constructor(O) {
                this.name = O, this.terminated = !1, this._capability = new g.PromiseCapability();
              }
              get finished() {
                return this._capability.promise;
              }
              finish() {
                this._capability.resolve();
              }
              terminate() {
                this.terminated = !0;
              }
              ensureNotTerminated() {
                if (this.terminated)
                  throw new Error("Worker task was terminated");
              }
            }
            A.WorkerTask = I;
            class _ {
              static setup(O, L) {
                let B = !1;
                O.on("test", function(F) {
                  B || (B = !0, O.send("test", F instanceof Uint8Array));
                }), O.on("configure", function(F) {
                  (0, g.setVerbosityLevel)(F.verbosity);
                }), O.on("GetDocRequest", function(F) {
                  return _.createDocumentHandler(F, L);
                });
              }
              static createDocumentHandler(O, L) {
                let B, F = !1, M = null;
                const W = /* @__PURE__ */ new Set(), j = (0, g.getVerbosityLevel)(), {
                  docId: G,
                  apiVersion: U
                } = O, k = "3.11.174";
                if (U !== k)
                  throw new Error(`The API version "${U}" does not match the Worker version "${k}".`);
                const N = [];
                for (const Y in [])
                  N.push(Y);
                if (N.length)
                  throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + N.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
                const P = G + "_worker";
                let D = new S.MessageHandler(P, G, L);
                function H() {
                  if (F)
                    throw new Error("Worker was terminated");
                }
                function V(Y) {
                  W.add(Y);
                }
                function Z(Y) {
                  Y.finish(), W.delete(Y);
                }
                async function ne(Y) {
                  await B.ensureDoc("checkHeader"), await B.ensureDoc("parseStartXRef"), await B.ensureDoc("parse", [Y]), await B.ensureDoc("checkFirstPage", [Y]), await B.ensureDoc("checkLastPage", [Y]);
                  const ee = await B.ensureDoc("isPureXfa");
                  if (ee) {
                    const ae = new I("loadXfaFonts");
                    V(ae), await Promise.all([B.loadXfaFonts(D, ae).catch((se) => {
                    }).then(() => Z(ae)), B.loadXfaImages()]);
                  }
                  const [Q, J] = await Promise.all([B.ensureDoc("numPages"), B.ensureDoc("fingerprints")]), te = ee ? await B.ensureDoc("htmlForXfa") : null;
                  return {
                    numPages: Q,
                    fingerprints: J,
                    htmlForXfa: te
                  };
                }
                function K({
                  data: Y,
                  password: ee,
                  disableAutoFetch: Q,
                  rangeChunkSize: J,
                  length: te,
                  docBaseUrl: ae,
                  enableXfa: se,
                  evaluatorOptions: ie
                }) {
                  const fe = {
                    source: null,
                    disableAutoFetch: Q,
                    docBaseUrl: ae,
                    docId: G,
                    enableXfa: se,
                    evaluatorOptions: ie,
                    handler: D,
                    length: te,
                    password: ee,
                    rangeChunkSize: J
                  }, ge = new g.PromiseCapability();
                  let me;
                  if (Y) {
                    try {
                      fe.source = Y, me = new f.LocalPdfManager(fe), ge.resolve(me);
                    } catch (ye) {
                      ge.reject(ye);
                    }
                    return ge.promise;
                  }
                  let pe, be = [];
                  try {
                    pe = new $.PDFWorkerStream(D);
                  } catch (ye) {
                    return ge.reject(ye), ge.promise;
                  }
                  const le = pe.getFullReader();
                  le.headersReady.then(function() {
                    if (le.isRangeSupported) {
                      fe.source = pe, fe.length = le.contentLength, fe.disableAutoFetch ||= le.isStreamingSupported, me = new f.NetworkPdfManager(fe);
                      for (const ye of be)
                        me.sendProgressiveData(ye);
                      be = [], ge.resolve(me), M = null;
                    }
                  }).catch(function(ye) {
                    ge.reject(ye), M = null;
                  });
                  let ve = 0;
                  const he = function() {
                    const ye = (0, b.arrayBuffersToBytes)(be);
                    te && ye.length !== te && (0, g.warn)("reported HTTP length is different from actual");
                    try {
                      fe.source = ye, me = new f.LocalPdfManager(fe), ge.resolve(me);
                    } catch (Ce) {
                      ge.reject(Ce);
                    }
                    be = [];
                  };
                  return new Promise(function(ye, Ce) {
                    const xe = function({
                      value: we,
                      done: $e
                    }) {
                      try {
                        if (H(), $e) {
                          me || he(), M = null;
                          return;
                        }
                        ve += we.byteLength, le.isStreamingSupported || D.send("DocProgress", {
                          loaded: ve,
                          total: Math.max(ve, le.contentLength || 0)
                        }), me ? me.sendProgressiveData(we) : be.push(we), le.read().then(xe, Ce);
                      } catch (Ae) {
                        Ce(Ae);
                      }
                    };
                    le.read().then(xe, Ce);
                  }).catch(function(ye) {
                    ge.reject(ye), M = null;
                  }), M = function(ye) {
                    pe.cancelAllRequests(ye);
                  }, ge.promise;
                }
                function q(Y) {
                  function ee(te) {
                    H(), D.send("GetDoc", {
                      pdfInfo: te
                    });
                  }
                  function Q(te) {
                    if (H(), te instanceof g.PasswordException) {
                      const ae = new I(`PasswordException: response ${te.code}`);
                      V(ae), D.sendWithPromise("PasswordRequest", te).then(function({
                        password: se
                      }) {
                        Z(ae), B.updatePassword(se), J();
                      }).catch(function() {
                        Z(ae), D.send("DocException", te);
                      });
                    } else te instanceof g.InvalidPDFException || te instanceof g.MissingPDFException || te instanceof g.UnexpectedResponseException || te instanceof g.UnknownErrorException ? D.send("DocException", te) : D.send("DocException", new g.UnknownErrorException(te.message, te.toString()));
                  }
                  function J() {
                    H(), ne(!1).then(ee, function(te) {
                      if (H(), !(te instanceof b.XRefParseException)) {
                        Q(te);
                        return;
                      }
                      B.requestLoadedStream().then(function() {
                        H(), ne(!0).then(ee, Q);
                      });
                    });
                  }
                  H(), K(Y).then(function(te) {
                    if (F)
                      throw te.terminate(new g.AbortException("Worker was terminated.")), new Error("Worker was terminated");
                    B = te, B.requestLoadedStream(!0).then((ae) => {
                      D.send("DataLoaded", {
                        length: ae.bytes.byteLength
                      });
                    });
                  }).then(J, Q);
                }
                return D.on("GetPage", function(Y) {
                  return B.getPage(Y.pageIndex).then(function(ee) {
                    return Promise.all([B.ensure(ee, "rotate"), B.ensure(ee, "ref"), B.ensure(ee, "userUnit"), B.ensure(ee, "view")]).then(function([Q, J, te, ae]) {
                      return {
                        rotate: Q,
                        ref: J,
                        userUnit: te,
                        view: ae
                      };
                    });
                  });
                }), D.on("GetPageIndex", function(Y) {
                  const ee = y.Ref.get(Y.num, Y.gen);
                  return B.ensureCatalog("getPageIndex", [ee]);
                }), D.on("GetDestinations", function(Y) {
                  return B.ensureCatalog("destinations");
                }), D.on("GetDestination", function(Y) {
                  return B.ensureCatalog("getDestination", [Y.id]);
                }), D.on("GetPageLabels", function(Y) {
                  return B.ensureCatalog("pageLabels");
                }), D.on("GetPageLayout", function(Y) {
                  return B.ensureCatalog("pageLayout");
                }), D.on("GetPageMode", function(Y) {
                  return B.ensureCatalog("pageMode");
                }), D.on("GetViewerPreferences", function(Y) {
                  return B.ensureCatalog("viewerPreferences");
                }), D.on("GetOpenAction", function(Y) {
                  return B.ensureCatalog("openAction");
                }), D.on("GetAttachments", function(Y) {
                  return B.ensureCatalog("attachments");
                }), D.on("GetDocJSActions", function(Y) {
                  return B.ensureCatalog("jsActions");
                }), D.on("GetPageJSActions", function({
                  pageIndex: Y
                }) {
                  return B.getPage(Y).then(function(ee) {
                    return B.ensure(ee, "jsActions");
                  });
                }), D.on("GetOutline", function(Y) {
                  return B.ensureCatalog("documentOutline");
                }), D.on("GetOptionalContentConfig", function(Y) {
                  return B.ensureCatalog("optionalContentConfig");
                }), D.on("GetPermissions", function(Y) {
                  return B.ensureCatalog("permissions");
                }), D.on("GetMetadata", function(Y) {
                  return Promise.all([B.ensureDoc("documentInfo"), B.ensureCatalog("metadata")]);
                }), D.on("GetMarkInfo", function(Y) {
                  return B.ensureCatalog("markInfo");
                }), D.on("GetData", function(Y) {
                  return B.requestLoadedStream().then(function(ee) {
                    return ee.bytes;
                  });
                }), D.on("GetAnnotations", function({
                  pageIndex: Y,
                  intent: ee
                }) {
                  return B.getPage(Y).then(function(Q) {
                    const J = new I(`GetAnnotations: page ${Y}`);
                    return V(J), Q.getAnnotationsData(D, J, ee).then((te) => (Z(J), te), (te) => {
                      throw Z(J), te;
                    });
                  });
                }), D.on("GetFieldObjects", function(Y) {
                  return B.ensureDoc("fieldObjects");
                }), D.on("HasJSActions", function(Y) {
                  return B.ensureDoc("hasJSActions");
                }), D.on("GetCalculationOrderIds", function(Y) {
                  return B.ensureDoc("calculationOrderIds");
                }), D.on("SaveDocument", async function({
                  isPureXfa: Y,
                  numPages: ee,
                  annotationStorage: Q,
                  filename: J
                }) {
                  const te = [B.requestLoadedStream(), B.ensureCatalog("acroForm"), B.ensureCatalog("acroFormRef"), B.ensureDoc("startXRef"), B.ensureDoc("xref"), B.ensureDoc("linearization"), B.ensureCatalog("structTreeRoot")], ae = [], se = Y ? null : (0, b.getNewAnnotationsMap)(Q), [ie, fe, ge, me, pe, be, le] = await Promise.all(te), ve = pe.trailer.getRaw("Root") || null;
                  let he;
                  if (se) {
                    le ? await le.canUpdateStructTree({
                      pdfManager: B,
                      newAnnotationsByPage: se
                    }) && (he = le) : await T.StructTreeRoot.canCreateStructureTree({
                      catalogRef: ve,
                      pdfManager: B,
                      newAnnotationsByPage: se
                    }) && (he = null);
                    const Ee = m.AnnotationFactory.generateImages(Q.values(), pe, B.evaluatorOptions.isOffscreenCanvasSupported), _e = he === void 0 ? ae : [];
                    for (const [Te, ke] of se)
                      _e.push(B.getPage(Te).then((Re) => {
                        const Be = new I(`Save (editor): page ${Te}`);
                        return Re.saveNewAnnotations(D, Be, ke, Ee).finally(function() {
                          Z(Be);
                        });
                      }));
                    he === null ? ae.push(Promise.all(_e).then(async (Te) => (await T.StructTreeRoot.createStructureTree({
                      newAnnotationsByPage: se,
                      xref: pe,
                      catalogRef: ve,
                      pdfManager: B,
                      newRefs: Te
                    }), Te))) : he && ae.push(Promise.all(_e).then(async (Te) => (await he.updateStructureTree({
                      newAnnotationsByPage: se,
                      pdfManager: B,
                      newRefs: Te
                    }), Te)));
                  }
                  if (Y)
                    ae.push(B.serializeXfaData(Q));
                  else
                    for (let Ee = 0; Ee < ee; Ee++)
                      ae.push(B.getPage(Ee).then(function(_e) {
                        const Te = new I(`Save: page ${Ee}`);
                        return _e.save(D, Te, Q).finally(function() {
                          Z(Te);
                        });
                      }));
                  const ye = await Promise.all(ae);
                  let Ce = [], xe = null;
                  if (Y) {
                    if (xe = ye[0], !xe)
                      return ie.bytes;
                  } else if (Ce = ye.flat(2), Ce.length === 0)
                    return ie.bytes;
                  const we = ge && fe instanceof y.Dict && Ce.some((Ee) => Ee.needAppearances), $e = fe instanceof y.Dict && fe.get("XFA") || null;
                  let Ae = null, ue = !1;
                  if (Array.isArray($e)) {
                    for (let Ee = 0, _e = $e.length; Ee < _e; Ee += 2)
                      $e[Ee] === "datasets" && (Ae = $e[Ee + 1], ue = !0);
                    Ae === null && (Ae = pe.getNewTemporaryRef());
                  } else $e && (0, g.warn)("Unsupported XFA type.");
                  let ce = /* @__PURE__ */ Object.create(null);
                  if (pe.trailer) {
                    const Ee = /* @__PURE__ */ Object.create(null), _e = pe.trailer.get("Info") || null;
                    _e instanceof y.Dict && _e.forEach((Te, ke) => {
                      typeof ke == "string" && (Ee[Te] = (0, g.stringToPDFString)(ke));
                    }), ce = {
                      rootRef: ve,
                      encryptRef: pe.trailer.getRaw("Encrypt") || null,
                      newRef: pe.getNewTemporaryRef(),
                      infoRef: pe.trailer.getRaw("Info") || null,
                      info: Ee,
                      fileIds: pe.trailer.get("ID") || null,
                      startXRef: be ? me : pe.lastXRefStreamPos ?? me,
                      filename: J
                    };
                  }
                  return (0, w.incrementalUpdate)({
                    originalData: ie.bytes,
                    xrefInfo: ce,
                    newRefs: Ce,
                    xref: pe,
                    hasXfa: !!$e,
                    xfaDatasetsRef: Ae,
                    hasXfaDatasetsEntry: ue,
                    needAppearances: we,
                    acroFormRef: ge,
                    acroForm: fe,
                    xfaData: xe
                  }).finally(() => {
                    pe.resetNewTemporaryRef();
                  });
                }), D.on("GetOperatorList", function(Y, ee) {
                  const Q = Y.pageIndex;
                  B.getPage(Q).then(function(J) {
                    const te = new I(`GetOperatorList: page ${Q}`);
                    V(te);
                    const ae = j >= g.VerbosityLevel.INFOS ? Date.now() : 0;
                    J.getOperatorList({
                      handler: D,
                      sink: ee,
                      task: te,
                      intent: Y.intent,
                      cacheKey: Y.cacheKey,
                      annotationStorage: Y.annotationStorage
                    }).then(function(se) {
                      Z(te), ae && (0, g.info)(`page=${Q + 1} - getOperatorList: time=${Date.now() - ae}ms, len=${se.length}`), ee.close();
                    }, function(se) {
                      Z(te), !te.terminated && ee.error(se);
                    });
                  });
                }), D.on("GetTextContent", function(Y, ee) {
                  const {
                    pageIndex: Q,
                    includeMarkedContent: J,
                    disableNormalization: te
                  } = Y;
                  B.getPage(Q).then(function(ae) {
                    const se = new I("GetTextContent: page " + Q);
                    V(se);
                    const ie = j >= g.VerbosityLevel.INFOS ? Date.now() : 0;
                    ae.extractTextContent({
                      handler: D,
                      task: se,
                      sink: ee,
                      includeMarkedContent: J,
                      disableNormalization: te
                    }).then(function() {
                      Z(se), ie && (0, g.info)(`page=${Q + 1} - getTextContent: time=${Date.now() - ie}ms`), ee.close();
                    }, function(fe) {
                      Z(se), !se.terminated && ee.error(fe);
                    });
                  });
                }), D.on("GetStructTree", function(Y) {
                  return B.getPage(Y.pageIndex).then(function(ee) {
                    return B.ensure(ee, "getStructTree");
                  });
                }), D.on("FontFallback", function(Y) {
                  return B.fontFallback(Y.id, D);
                }), D.on("Cleanup", function(Y) {
                  return B.cleanup(!0);
                }), D.on("Terminate", function(Y) {
                  F = !0;
                  const ee = [];
                  if (B) {
                    B.terminate(new g.AbortException("Worker was terminated."));
                    const Q = B.cleanup();
                    ee.push(Q), B = null;
                  } else
                    (0, C.clearGlobalCaches)();
                  M && M(new g.AbortException("Worker was terminated."));
                  for (const Q of W)
                    ee.push(Q.finished), Q.terminate();
                  return Promise.all(ee).then(function() {
                    D.destroy(), D = null;
                  });
                }), D.on("Ready", function(Y) {
                  q(O), O = null;
                }), P;
              }
              static initializeFromPort(O) {
                const L = new S.MessageHandler("worker", "main", O);
                _.setup(L, O), L.send("ready", null);
              }
            }
            A.WorkerMessageHandler = _;
            function E(R) {
              return typeof R.postMessage == "function" && "onmessage" in R;
            }
            typeof window > "u" && !g.isNodeJS && typeof self < "u" && E(self) && _.initializeFromPort(self);
          },
          /* 2 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.VerbosityLevel = A.Util = A.UnknownErrorException = A.UnexpectedResponseException = A.TextRenderingMode = A.RenderingIntentFlag = A.PromiseCapability = A.PermissionFlag = A.PasswordResponses = A.PasswordException = A.PageActionEventType = A.OPS = A.MissingPDFException = A.MAX_IMAGE_SIZE_TO_CACHE = A.LINE_FACTOR = A.LINE_DESCENT_FACTOR = A.InvalidPDFException = A.ImageKind = A.IDENTITY_MATRIX = A.FormatError = A.FeatureTest = A.FONT_IDENTITY_MATRIX = A.DocumentActionEventType = A.CMapCompressionType = A.BaseException = A.BASELINE_FACTOR = A.AnnotationType = A.AnnotationReplyType = A.AnnotationPrefix = A.AnnotationMode = A.AnnotationFlag = A.AnnotationFieldFlag = A.AnnotationEditorType = A.AnnotationEditorPrefix = A.AnnotationEditorParamsType = A.AnnotationBorderStyleType = A.AnnotationActionEventType = A.AbortException = void 0, A.assert = q, A.bytesToString = pe, A.createValidAbsoluteUrl = ee, A.getModificationDate = ke, A.getUuid = Fe, A.getVerbosityLevel = V, A.info = Z, A.isArrayBuffer = _e, A.isArrayEqual = Te, A.isNodeJS = void 0, A.normalizeUnicode = Me, A.objectFromMap = he, A.objectSize = ve, A.setVerbosityLevel = H, A.shadow = Q, A.string32 = le, A.stringToBytes = be, A.stringToPDFString = ue, A.stringToUTF8String = ce, A.unreachable = K, A.utf8StringToString = Ee, A.warn = ne;
            const x = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
            A.isNodeJS = x;
            const g = [1, 0, 0, 1, 0, 0];
            A.IDENTITY_MATRIX = g;
            const b = [1e-3, 0, 0, 1e-3, 0, 0];
            A.FONT_IDENTITY_MATRIX = b;
            const y = 1e7;
            A.MAX_IMAGE_SIZE_TO_CACHE = y;
            const f = 1.35;
            A.LINE_FACTOR = f;
            const m = 0.35;
            A.LINE_DESCENT_FACTOR = m;
            const C = m / f;
            A.BASELINE_FACTOR = C;
            const w = {
              ANY: 1,
              DISPLAY: 2,
              PRINT: 4,
              SAVE: 8,
              ANNOTATIONS_FORMS: 16,
              ANNOTATIONS_STORAGE: 32,
              ANNOTATIONS_DISABLE: 64,
              OPLIST: 256
            };
            A.RenderingIntentFlag = w;
            const S = {
              DISABLE: 0,
              ENABLE: 1,
              ENABLE_FORMS: 2,
              ENABLE_STORAGE: 3
            };
            A.AnnotationMode = S;
            const $ = "pdfjs_internal_editor_";
            A.AnnotationEditorPrefix = $;
            const T = {
              DISABLE: -1,
              NONE: 0,
              FREETEXT: 3,
              STAMP: 13,
              INK: 15
            };
            A.AnnotationEditorType = T;
            const I = {
              RESIZE: 1,
              CREATE: 2,
              FREETEXT_SIZE: 11,
              FREETEXT_COLOR: 12,
              FREETEXT_OPACITY: 13,
              INK_COLOR: 21,
              INK_THICKNESS: 22,
              INK_OPACITY: 23
            };
            A.AnnotationEditorParamsType = I;
            const _ = {
              PRINT: 4,
              MODIFY_CONTENTS: 8,
              COPY: 16,
              MODIFY_ANNOTATIONS: 32,
              FILL_INTERACTIVE_FORMS: 256,
              COPY_FOR_ACCESSIBILITY: 512,
              ASSEMBLE: 1024,
              PRINT_HIGH_QUALITY: 2048
            };
            A.PermissionFlag = _;
            const E = {
              FILL: 0,
              STROKE: 1,
              FILL_STROKE: 2,
              INVISIBLE: 3,
              FILL_ADD_TO_PATH: 4,
              STROKE_ADD_TO_PATH: 5,
              FILL_STROKE_ADD_TO_PATH: 6,
              ADD_TO_PATH: 7,
              FILL_STROKE_MASK: 3,
              ADD_TO_PATH_FLAG: 4
            };
            A.TextRenderingMode = E;
            const R = {
              GRAYSCALE_1BPP: 1,
              RGB_24BPP: 2,
              RGBA_32BPP: 3
            };
            A.ImageKind = R;
            const O = {
              TEXT: 1,
              LINK: 2,
              FREETEXT: 3,
              LINE: 4,
              SQUARE: 5,
              CIRCLE: 6,
              POLYGON: 7,
              POLYLINE: 8,
              HIGHLIGHT: 9,
              UNDERLINE: 10,
              SQUIGGLY: 11,
              STRIKEOUT: 12,
              STAMP: 13,
              CARET: 14,
              INK: 15,
              POPUP: 16,
              FILEATTACHMENT: 17,
              SOUND: 18,
              MOVIE: 19,
              WIDGET: 20,
              SCREEN: 21,
              PRINTERMARK: 22,
              TRAPNET: 23,
              WATERMARK: 24,
              THREED: 25,
              REDACT: 26
            };
            A.AnnotationType = O;
            const L = {
              GROUP: "Group",
              REPLY: "R"
            };
            A.AnnotationReplyType = L;
            const B = {
              INVISIBLE: 1,
              HIDDEN: 2,
              PRINT: 4,
              NOZOOM: 8,
              NOROTATE: 16,
              NOVIEW: 32,
              READONLY: 64,
              LOCKED: 128,
              TOGGLENOVIEW: 256,
              LOCKEDCONTENTS: 512
            };
            A.AnnotationFlag = B;
            const F = {
              READONLY: 1,
              REQUIRED: 2,
              NOEXPORT: 4,
              MULTILINE: 4096,
              PASSWORD: 8192,
              NOTOGGLETOOFF: 16384,
              RADIO: 32768,
              PUSHBUTTON: 65536,
              COMBO: 131072,
              EDIT: 262144,
              SORT: 524288,
              FILESELECT: 1048576,
              MULTISELECT: 2097152,
              DONOTSPELLCHECK: 4194304,
              DONOTSCROLL: 8388608,
              COMB: 16777216,
              RICHTEXT: 33554432,
              RADIOSINUNISON: 33554432,
              COMMITONSELCHANGE: 67108864
            };
            A.AnnotationFieldFlag = F;
            const M = {
              SOLID: 1,
              DASHED: 2,
              BEVELED: 3,
              INSET: 4,
              UNDERLINE: 5
            };
            A.AnnotationBorderStyleType = M;
            const W = {
              E: "Mouse Enter",
              X: "Mouse Exit",
              D: "Mouse Down",
              U: "Mouse Up",
              Fo: "Focus",
              Bl: "Blur",
              PO: "PageOpen",
              PC: "PageClose",
              PV: "PageVisible",
              PI: "PageInvisible",
              K: "Keystroke",
              F: "Format",
              V: "Validate",
              C: "Calculate"
            };
            A.AnnotationActionEventType = W;
            const j = {
              WC: "WillClose",
              WS: "WillSave",
              DS: "DidSave",
              WP: "WillPrint",
              DP: "DidPrint"
            };
            A.DocumentActionEventType = j;
            const G = {
              O: "PageOpen",
              C: "PageClose"
            };
            A.PageActionEventType = G;
            const U = {
              ERRORS: 0,
              WARNINGS: 1,
              INFOS: 5
            };
            A.VerbosityLevel = U;
            const k = {
              NONE: 0,
              BINARY: 1
            };
            A.CMapCompressionType = k;
            const N = {
              dependency: 1,
              setLineWidth: 2,
              setLineCap: 3,
              setLineJoin: 4,
              setMiterLimit: 5,
              setDash: 6,
              setRenderingIntent: 7,
              setFlatness: 8,
              setGState: 9,
              save: 10,
              restore: 11,
              transform: 12,
              moveTo: 13,
              lineTo: 14,
              curveTo: 15,
              curveTo2: 16,
              curveTo3: 17,
              closePath: 18,
              rectangle: 19,
              stroke: 20,
              closeStroke: 21,
              fill: 22,
              eoFill: 23,
              fillStroke: 24,
              eoFillStroke: 25,
              closeFillStroke: 26,
              closeEOFillStroke: 27,
              endPath: 28,
              clip: 29,
              eoClip: 30,
              beginText: 31,
              endText: 32,
              setCharSpacing: 33,
              setWordSpacing: 34,
              setHScale: 35,
              setLeading: 36,
              setFont: 37,
              setTextRenderingMode: 38,
              setTextRise: 39,
              moveText: 40,
              setLeadingMoveText: 41,
              setTextMatrix: 42,
              nextLine: 43,
              showText: 44,
              showSpacedText: 45,
              nextLineShowText: 46,
              nextLineSetSpacingShowText: 47,
              setCharWidth: 48,
              setCharWidthAndBounds: 49,
              setStrokeColorSpace: 50,
              setFillColorSpace: 51,
              setStrokeColor: 52,
              setStrokeColorN: 53,
              setFillColor: 54,
              setFillColorN: 55,
              setStrokeGray: 56,
              setFillGray: 57,
              setStrokeRGBColor: 58,
              setFillRGBColor: 59,
              setStrokeCMYKColor: 60,
              setFillCMYKColor: 61,
              shadingFill: 62,
              beginInlineImage: 63,
              beginImageData: 64,
              endInlineImage: 65,
              paintXObject: 66,
              markPoint: 67,
              markPointProps: 68,
              beginMarkedContent: 69,
              beginMarkedContentProps: 70,
              endMarkedContent: 71,
              beginCompat: 72,
              endCompat: 73,
              paintFormXObjectBegin: 74,
              paintFormXObjectEnd: 75,
              beginGroup: 76,
              endGroup: 77,
              beginAnnotation: 80,
              endAnnotation: 81,
              paintImageMaskXObject: 83,
              paintImageMaskXObjectGroup: 84,
              paintImageXObject: 85,
              paintInlineImageXObject: 86,
              paintInlineImageXObjectGroup: 87,
              paintImageXObjectRepeat: 88,
              paintImageMaskXObjectRepeat: 89,
              paintSolidColorImageMask: 90,
              constructPath: 91
            };
            A.OPS = N;
            const P = {
              NEED_PASSWORD: 1,
              INCORRECT_PASSWORD: 2
            };
            A.PasswordResponses = P;
            let D = U.WARNINGS;
            function H(je) {
              Number.isInteger(je) && (D = je);
            }
            function V() {
              return D;
            }
            function Z(je) {
              D >= U.INFOS && console.log(`Info: ${je}`);
            }
            function ne(je) {
              D >= U.WARNINGS && console.log(`Warning: ${je}`);
            }
            function K(je) {
              throw new Error(je);
            }
            function q(je, Le) {
              je || K(Le);
            }
            function Y(je) {
              switch (je?.protocol) {
                case "http:":
                case "https:":
                case "ftp:":
                case "mailto:":
                case "tel:":
                  return !0;
                default:
                  return !1;
              }
            }
            function ee(je, Le = null, De = null) {
              if (!je)
                return null;
              try {
                if (De && typeof je == "string" && (De.addDefaultProtocol && je.startsWith("www.") && je.match(/\./g)?.length >= 2 && (je = `http://${je}`), De.tryConvertEncoding))
                  try {
                    je = ce(je);
                  } catch {
                  }
                const Ne = Le ? new URL(je, Le) : new URL(je);
                if (Y(Ne))
                  return Ne;
              } catch {
              }
              return null;
            }
            function Q(je, Le, De, Ne = !1) {
              return Object.defineProperty(je, Le, {
                value: De,
                enumerable: !Ne,
                configurable: !0,
                writable: !1
              }), De;
            }
            const J = function() {
              function Le(De, Ne) {
                this.constructor === Le && K("Cannot initialize BaseException."), this.message = De, this.name = Ne;
              }
              return Le.prototype = new Error(), Le.constructor = Le, Le;
            }();
            A.BaseException = J;
            class te extends J {
              constructor(Le, De) {
                super(Le, "PasswordException"), this.code = De;
              }
            }
            A.PasswordException = te;
            class ae extends J {
              constructor(Le, De) {
                super(Le, "UnknownErrorException"), this.details = De;
              }
            }
            A.UnknownErrorException = ae;
            class se extends J {
              constructor(Le) {
                super(Le, "InvalidPDFException");
              }
            }
            A.InvalidPDFException = se;
            class ie extends J {
              constructor(Le) {
                super(Le, "MissingPDFException");
              }
            }
            A.MissingPDFException = ie;
            class fe extends J {
              constructor(Le, De) {
                super(Le, "UnexpectedResponseException"), this.status = De;
              }
            }
            A.UnexpectedResponseException = fe;
            class ge extends J {
              constructor(Le) {
                super(Le, "FormatError");
              }
            }
            A.FormatError = ge;
            class me extends J {
              constructor(Le) {
                super(Le, "AbortException");
              }
            }
            A.AbortException = me;
            function pe(je) {
              (typeof je != "object" || je?.length === void 0) && K("Invalid argument for bytesToString");
              const Le = je.length, De = 8192;
              if (Le < De)
                return String.fromCharCode.apply(null, je);
              const Ne = [];
              for (let Ge = 0; Ge < Le; Ge += De) {
                const Xe = Math.min(Ge + De, Le), nt = je.subarray(Ge, Xe);
                Ne.push(String.fromCharCode.apply(null, nt));
              }
              return Ne.join("");
            }
            function be(je) {
              typeof je != "string" && K("Invalid argument for stringToBytes");
              const Le = je.length, De = new Uint8Array(Le);
              for (let Ne = 0; Ne < Le; ++Ne)
                De[Ne] = je.charCodeAt(Ne) & 255;
              return De;
            }
            function le(je) {
              return String.fromCharCode(je >> 24 & 255, je >> 16 & 255, je >> 8 & 255, je & 255);
            }
            function ve(je) {
              return Object.keys(je).length;
            }
            function he(je) {
              const Le = /* @__PURE__ */ Object.create(null);
              for (const [De, Ne] of je)
                Le[De] = Ne;
              return Le;
            }
            function ye() {
              const je = new Uint8Array(4);
              return je[0] = 1, new Uint32Array(je.buffer, 0, 1)[0] === 1;
            }
            function Ce() {
              try {
                return new Function(""), !0;
              } catch {
                return !1;
              }
            }
            class xe {
              static get isLittleEndian() {
                return Q(this, "isLittleEndian", ye());
              }
              static get isEvalSupported() {
                return Q(this, "isEvalSupported", Ce());
              }
              static get isOffscreenCanvasSupported() {
                return Q(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
              }
              static get platform() {
                return typeof navigator > "u" ? Q(this, "platform", {
                  isWin: !1,
                  isMac: !1
                }) : Q(this, "platform", {
                  isWin: navigator.platform.includes("Win"),
                  isMac: navigator.platform.includes("Mac")
                });
              }
              static get isCSSRoundSupported() {
                return Q(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
              }
            }
            A.FeatureTest = xe;
            const we = [...Array(256).keys()].map((je) => je.toString(16).padStart(2, "0"));
            class $e {
              static makeHexColor(Le, De, Ne) {
                return `#${we[Le]}${we[De]}${we[Ne]}`;
              }
              static scaleMinMax(Le, De) {
                let Ne;
                Le[0] ? (Le[0] < 0 && (Ne = De[0], De[0] = De[1], De[1] = Ne), De[0] *= Le[0], De[1] *= Le[0], Le[3] < 0 && (Ne = De[2], De[2] = De[3], De[3] = Ne), De[2] *= Le[3], De[3] *= Le[3]) : (Ne = De[0], De[0] = De[2], De[2] = Ne, Ne = De[1], De[1] = De[3], De[3] = Ne, Le[1] < 0 && (Ne = De[2], De[2] = De[3], De[3] = Ne), De[2] *= Le[1], De[3] *= Le[1], Le[2] < 0 && (Ne = De[0], De[0] = De[1], De[1] = Ne), De[0] *= Le[2], De[1] *= Le[2]), De[0] += Le[4], De[1] += Le[4], De[2] += Le[5], De[3] += Le[5];
              }
              static transform(Le, De) {
                return [Le[0] * De[0] + Le[2] * De[1], Le[1] * De[0] + Le[3] * De[1], Le[0] * De[2] + Le[2] * De[3], Le[1] * De[2] + Le[3] * De[3], Le[0] * De[4] + Le[2] * De[5] + Le[4], Le[1] * De[4] + Le[3] * De[5] + Le[5]];
              }
              static applyTransform(Le, De) {
                const Ne = Le[0] * De[0] + Le[1] * De[2] + De[4], Ge = Le[0] * De[1] + Le[1] * De[3] + De[5];
                return [Ne, Ge];
              }
              static applyInverseTransform(Le, De) {
                const Ne = De[0] * De[3] - De[1] * De[2], Ge = (Le[0] * De[3] - Le[1] * De[2] + De[2] * De[5] - De[4] * De[3]) / Ne, Xe = (-Le[0] * De[1] + Le[1] * De[0] + De[4] * De[1] - De[5] * De[0]) / Ne;
                return [Ge, Xe];
              }
              static getAxialAlignedBoundingBox(Le, De) {
                const Ne = this.applyTransform(Le, De), Ge = this.applyTransform(Le.slice(2, 4), De), Xe = this.applyTransform([Le[0], Le[3]], De), nt = this.applyTransform([Le[2], Le[1]], De);
                return [Math.min(Ne[0], Ge[0], Xe[0], nt[0]), Math.min(Ne[1], Ge[1], Xe[1], nt[1]), Math.max(Ne[0], Ge[0], Xe[0], nt[0]), Math.max(Ne[1], Ge[1], Xe[1], nt[1])];
              }
              static inverseTransform(Le) {
                const De = Le[0] * Le[3] - Le[1] * Le[2];
                return [Le[3] / De, -Le[1] / De, -Le[2] / De, Le[0] / De, (Le[2] * Le[5] - Le[4] * Le[3]) / De, (Le[4] * Le[1] - Le[5] * Le[0]) / De];
              }
              static singularValueDecompose2dScale(Le) {
                const De = [Le[0], Le[2], Le[1], Le[3]], Ne = Le[0] * De[0] + Le[1] * De[2], Ge = Le[0] * De[1] + Le[1] * De[3], Xe = Le[2] * De[0] + Le[3] * De[2], nt = Le[2] * De[1] + Le[3] * De[3], ct = (Ne + nt) / 2, it = Math.sqrt((Ne + nt) ** 2 - 4 * (Ne * nt - Xe * Ge)) / 2, We = ct + it || 1, Ve = ct - it || 1;
                return [Math.sqrt(We), Math.sqrt(Ve)];
              }
              static normalizeRect(Le) {
                const De = Le.slice(0);
                return Le[0] > Le[2] && (De[0] = Le[2], De[2] = Le[0]), Le[1] > Le[3] && (De[1] = Le[3], De[3] = Le[1]), De;
              }
              static intersect(Le, De) {
                const Ne = Math.max(Math.min(Le[0], Le[2]), Math.min(De[0], De[2])), Ge = Math.min(Math.max(Le[0], Le[2]), Math.max(De[0], De[2]));
                if (Ne > Ge)
                  return null;
                const Xe = Math.max(Math.min(Le[1], Le[3]), Math.min(De[1], De[3])), nt = Math.min(Math.max(Le[1], Le[3]), Math.max(De[1], De[3]));
                return Xe > nt ? null : [Ne, Xe, Ge, nt];
              }
              static bezierBoundingBox(Le, De, Ne, Ge, Xe, nt, ct, it) {
                const We = [], Ve = [[], []];
                let ut, at, Qe, st, ft, vt, Pt, dt;
                for (let Mt = 0; Mt < 2; ++Mt) {
                  if (Mt === 0 ? (at = 6 * Le - 12 * Ne + 6 * Xe, ut = -3 * Le + 9 * Ne - 9 * Xe + 3 * ct, Qe = 3 * Ne - 3 * Le) : (at = 6 * De - 12 * Ge + 6 * nt, ut = -3 * De + 9 * Ge - 9 * nt + 3 * it, Qe = 3 * Ge - 3 * De), Math.abs(ut) < 1e-12) {
                    if (Math.abs(at) < 1e-12)
                      continue;
                    st = -Qe / at, 0 < st && st < 1 && We.push(st);
                    continue;
                  }
                  Pt = at * at - 4 * Qe * ut, dt = Math.sqrt(Pt), !(Pt < 0) && (ft = (-at + dt) / (2 * ut), 0 < ft && ft < 1 && We.push(ft), vt = (-at - dt) / (2 * ut), 0 < vt && vt < 1 && We.push(vt));
                }
                let mt = We.length, pt;
                const Et = mt;
                for (; mt--; )
                  st = We[mt], pt = 1 - st, Ve[0][mt] = pt * pt * pt * Le + 3 * pt * pt * st * Ne + 3 * pt * st * st * Xe + st * st * st * ct, Ve[1][mt] = pt * pt * pt * De + 3 * pt * pt * st * Ge + 3 * pt * st * st * nt + st * st * st * it;
                return Ve[0][Et] = Le, Ve[1][Et] = De, Ve[0][Et + 1] = ct, Ve[1][Et + 1] = it, Ve[0].length = Ve[1].length = Et + 2, [Math.min(...Ve[0]), Math.min(...Ve[1]), Math.max(...Ve[0]), Math.max(...Ve[1])];
              }
            }
            A.Util = $e;
            const Ae = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
            function ue(je) {
              if (je[0] >= "ï") {
                let De;
                if (je[0] === "þ" && je[1] === "ÿ" ? De = "utf-16be" : je[0] === "ÿ" && je[1] === "þ" ? De = "utf-16le" : je[0] === "ï" && je[1] === "»" && je[2] === "¿" && (De = "utf-8"), De)
                  try {
                    const Ne = new TextDecoder(De, {
                      fatal: !0
                    }), Ge = be(je);
                    return Ne.decode(Ge);
                  } catch (Ne) {
                    ne(`stringToPDFString: "${Ne}".`);
                  }
              }
              const Le = [];
              for (let De = 0, Ne = je.length; De < Ne; De++) {
                const Ge = Ae[je.charCodeAt(De)];
                Le.push(Ge ? String.fromCharCode(Ge) : je.charAt(De));
              }
              return Le.join("");
            }
            function ce(je) {
              return decodeURIComponent(escape(je));
            }
            function Ee(je) {
              return unescape(encodeURIComponent(je));
            }
            function _e(je) {
              return typeof je == "object" && je?.byteLength !== void 0;
            }
            function Te(je, Le) {
              if (je.length !== Le.length)
                return !1;
              for (let De = 0, Ne = je.length; De < Ne; De++)
                if (je[De] !== Le[De])
                  return !1;
              return !0;
            }
            function ke(je = /* @__PURE__ */ new Date()) {
              return [je.getUTCFullYear().toString(), (je.getUTCMonth() + 1).toString().padStart(2, "0"), je.getUTCDate().toString().padStart(2, "0"), je.getUTCHours().toString().padStart(2, "0"), je.getUTCMinutes().toString().padStart(2, "0"), je.getUTCSeconds().toString().padStart(2, "0")].join("");
            }
            class Re {
              #e = !1;
              constructor() {
                this.promise = new Promise((Le, De) => {
                  this.resolve = (Ne) => {
                    this.#e = !0, Le(Ne);
                  }, this.reject = (Ne) => {
                    this.#e = !0, De(Ne);
                  };
                });
              }
              get settled() {
                return this.#e;
              }
            }
            A.PromiseCapability = Re;
            let Be = null, Oe = null;
            function Me(je) {
              return Be || (Be = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, Oe = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), je.replaceAll(Be, (Le, De, Ne) => De ? De.normalize("NFKC") : Oe.get(Ne));
            }
            function Fe() {
              if (typeof crypto < "u" && typeof crypto?.randomUUID == "function")
                return crypto.randomUUID();
              const je = new Uint8Array(32);
              if (typeof crypto < "u" && typeof crypto?.getRandomValues == "function")
                crypto.getRandomValues(je);
              else
                for (let Le = 0; Le < 32; Le++)
                  je[Le] = Math.floor(Math.random() * 255);
              return pe(je);
            }
            const Ue = "pdfjs_internal_id_";
            A.AnnotationPrefix = Ue;
          },
          /* 3 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.XRefParseException = A.XRefEntryException = A.ParserEOFException = A.PDF_VERSION_REGEXP = A.MissingDataException = void 0, A.arrayBuffersToBytes = T, A.collectActions = U, A.encodeToXmlString = N, A.escapePDFName = W, A.escapeString = j, A.getInheritableProperty = I, A.getLookupTableFactory = m, A.getNewAnnotationsMap = Z, A.getRotationMatrix = Y, A.isAscii = ne, A.isWhiteSpace = F, A.log2 = R, A.numberToString = V, A.parseXFAPath = M, A.readInt8 = O, A.readUint16 = L, A.readUint32 = B, A.recoverJsURL = H, A.stringToUTF16HexString = K, A.stringToUTF16String = q, A.toRomanNumerals = E, A.validateCSSFont = D, A.validateFontName = P;
            var g = x(2), b = x(4), y = x(5);
            const f = /^[1-9]\.\d$/;
            A.PDF_VERSION_REGEXP = f;
            function m(ee) {
              let Q;
              return function() {
                return ee && (Q = /* @__PURE__ */ Object.create(null), ee(Q), ee = null), Q;
              };
            }
            class C extends g.BaseException {
              constructor(Q, J) {
                super(`Missing data [${Q}, ${J})`, "MissingDataException"), this.begin = Q, this.end = J;
              }
            }
            A.MissingDataException = C;
            class w extends g.BaseException {
              constructor(Q) {
                super(Q, "ParserEOFException");
              }
            }
            A.ParserEOFException = w;
            class S extends g.BaseException {
              constructor(Q) {
                super(Q, "XRefEntryException");
              }
            }
            A.XRefEntryException = S;
            class $ extends g.BaseException {
              constructor(Q) {
                super(Q, "XRefParseException");
              }
            }
            A.XRefParseException = $;
            function T(ee) {
              const Q = ee.length;
              if (Q === 0)
                return new Uint8Array(0);
              if (Q === 1)
                return new Uint8Array(ee[0]);
              let J = 0;
              for (let se = 0; se < Q; se++)
                J += ee[se].byteLength;
              const te = new Uint8Array(J);
              let ae = 0;
              for (let se = 0; se < Q; se++) {
                const ie = new Uint8Array(ee[se]);
                te.set(ie, ae), ae += ie.byteLength;
              }
              return te;
            }
            function I({
              dict: ee,
              key: Q,
              getArray: J = !1,
              stopWhenFound: te = !0
            }) {
              let ae;
              const se = new b.RefSet();
              for (; ee instanceof b.Dict && !(ee.objId && se.has(ee.objId)); ) {
                ee.objId && se.put(ee.objId);
                const ie = J ? ee.getArray(Q) : ee.get(Q);
                if (ie !== void 0) {
                  if (te)
                    return ie;
                  (ae ||= []).push(ie);
                }
                ee = ee.get("Parent");
              }
              return ae;
            }
            const _ = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
            function E(ee, Q = !1) {
              (0, g.assert)(Number.isInteger(ee) && ee > 0, "The number should be a positive integer.");
              const J = [];
              let te;
              for (; ee >= 1e3; )
                ee -= 1e3, J.push("M");
              te = ee / 100 | 0, ee %= 100, J.push(_[te]), te = ee / 10 | 0, ee %= 10, J.push(_[10 + te]), J.push(_[20 + ee]);
              const ae = J.join("");
              return Q ? ae.toLowerCase() : ae;
            }
            function R(ee) {
              return ee <= 0 ? 0 : Math.ceil(Math.log2(ee));
            }
            function O(ee, Q) {
              return ee[Q] << 24 >> 24;
            }
            function L(ee, Q) {
              return ee[Q] << 8 | ee[Q + 1];
            }
            function B(ee, Q) {
              return (ee[Q] << 24 | ee[Q + 1] << 16 | ee[Q + 2] << 8 | ee[Q + 3]) >>> 0;
            }
            function F(ee) {
              return ee === 32 || ee === 9 || ee === 13 || ee === 10;
            }
            function M(ee) {
              const Q = /(.+)\[(\d+)\]$/;
              return ee.split(".").map((J) => {
                const te = J.match(Q);
                return te ? {
                  name: te[1],
                  pos: parseInt(te[2], 10)
                } : {
                  name: J,
                  pos: 0
                };
              });
            }
            function W(ee) {
              const Q = [];
              let J = 0;
              for (let te = 0, ae = ee.length; te < ae; te++) {
                const se = ee.charCodeAt(te);
                (se < 33 || se > 126 || se === 35 || se === 40 || se === 41 || se === 60 || se === 62 || se === 91 || se === 93 || se === 123 || se === 125 || se === 47 || se === 37) && (J < te && Q.push(ee.substring(J, te)), Q.push(`#${se.toString(16)}`), J = te + 1);
              }
              return Q.length === 0 ? ee : (J < ee.length && Q.push(ee.substring(J, ee.length)), Q.join(""));
            }
            function j(ee) {
              return ee.replaceAll(/([()\\\n\r])/g, (Q) => Q === `
` ? "\\n" : Q === "\r" ? "\\r" : `\\${Q}`);
            }
            function G(ee, Q, J, te) {
              if (!ee)
                return;
              let ae = null;
              if (ee instanceof b.Ref) {
                if (te.has(ee))
                  return;
                ae = ee, te.put(ae), ee = Q.fetch(ee);
              }
              if (Array.isArray(ee))
                for (const se of ee)
                  G(se, Q, J, te);
              else if (ee instanceof b.Dict) {
                if ((0, b.isName)(ee.get("S"), "JavaScript")) {
                  const se = ee.get("JS");
                  let ie;
                  se instanceof y.BaseStream ? ie = se.getString() : typeof se == "string" && (ie = se), ie &&= (0, g.stringToPDFString)(ie).replaceAll("\0", ""), ie && J.push(ie);
                }
                G(ee.getRaw("Next"), Q, J, te);
              }
              ae && te.remove(ae);
            }
            function U(ee, Q, J) {
              const te = /* @__PURE__ */ Object.create(null), ae = I({
                dict: Q,
                key: "AA",
                stopWhenFound: !1
              });
              if (ae)
                for (let se = ae.length - 1; se >= 0; se--) {
                  const ie = ae[se];
                  if (ie instanceof b.Dict)
                    for (const fe of ie.getKeys()) {
                      const ge = J[fe];
                      if (!ge)
                        continue;
                      const me = ie.getRaw(fe), pe = new b.RefSet(), be = [];
                      G(me, ee, be, pe), be.length > 0 && (te[ge] = be);
                    }
                }
              if (Q.has("A")) {
                const se = Q.get("A"), ie = new b.RefSet(), fe = [];
                G(se, ee, fe, ie), fe.length > 0 && (te.Action = fe);
              }
              return (0, g.objectSize)(te) > 0 ? te : null;
            }
            const k = {
              60: "&lt;",
              62: "&gt;",
              38: "&amp;",
              34: "&quot;",
              39: "&apos;"
            };
            function N(ee) {
              const Q = [];
              let J = 0;
              for (let te = 0, ae = ee.length; te < ae; te++) {
                const se = ee.codePointAt(te);
                if (32 <= se && se <= 126) {
                  const ie = k[se];
                  ie && (J < te && Q.push(ee.substring(J, te)), Q.push(ie), J = te + 1);
                } else
                  J < te && Q.push(ee.substring(J, te)), Q.push(`&#x${se.toString(16).toUpperCase()};`), se > 55295 && (se < 57344 || se > 65533) && te++, J = te + 1;
              }
              return Q.length === 0 ? ee : (J < ee.length && Q.push(ee.substring(J, ee.length)), Q.join(""));
            }
            function P(ee, Q = !1) {
              const J = /^("|').*("|')$/.exec(ee);
              if (J && J[1] === J[2]) {
                if (new RegExp(`[^\\\\]${J[1]}`).test(ee.slice(1, -1)))
                  return Q && (0, g.warn)(`FontFamily contains unescaped ${J[1]}: ${ee}.`), !1;
              } else
                for (const te of ee.split(/[ \t]+/))
                  if (/^(\d|(-(\d|-)))/.test(te) || !/^[\w-\\]+$/.test(te))
                    return Q && (0, g.warn)(`FontFamily contains invalid <custom-ident>: ${ee}.`), !1;
              return !0;
            }
            function D(ee) {
              const Q = "14", J = "400", te = /* @__PURE__ */ new Set(["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "normal", "bold", "bolder", "lighter"]), {
                fontFamily: ae,
                fontWeight: se,
                italicAngle: ie
              } = ee;
              if (!P(ae, !0))
                return !1;
              const fe = se ? se.toString() : "";
              ee.fontWeight = te.has(fe) ? fe : J;
              const ge = parseFloat(ie);
              return ee.italicAngle = isNaN(ge) || ge < -90 || ge > 90 ? Q : ie.toString(), !0;
            }
            function H(ee) {
              const Q = ["app.launchURL", "window.open", "xfa.host.gotoURL"], te = new RegExp("^\\s*(" + Q.join("|").replaceAll(".", "\\.") + `)\\((?:'|")([^'"]*)(?:'|")(?:,\\s*(\\w+)\\)|\\))`, "i").exec(ee);
              if (te?.[2]) {
                const ae = te[2];
                let se = !1;
                return te[3] === "true" && te[1] === "app.launchURL" && (se = !0), {
                  url: ae,
                  newWindow: se
                };
              }
              return null;
            }
            function V(ee) {
              if (Number.isInteger(ee))
                return ee.toString();
              const Q = Math.round(ee * 100);
              return Q % 100 === 0 ? (Q / 100).toString() : Q % 10 === 0 ? ee.toFixed(1) : ee.toFixed(2);
            }
            function Z(ee) {
              if (!ee)
                return null;
              const Q = /* @__PURE__ */ new Map();
              for (const [J, te] of ee) {
                if (!J.startsWith(g.AnnotationEditorPrefix))
                  continue;
                let ae = Q.get(te.pageIndex);
                ae || (ae = [], Q.set(te.pageIndex, ae)), ae.push(te);
              }
              return Q.size > 0 ? Q : null;
            }
            function ne(ee) {
              return /^[\x00-\x7F]*$/.test(ee);
            }
            function K(ee) {
              const Q = [];
              for (let J = 0, te = ee.length; J < te; J++) {
                const ae = ee.charCodeAt(J);
                Q.push((ae >> 8 & 255).toString(16).padStart(2, "0"), (ae & 255).toString(16).padStart(2, "0"));
              }
              return Q.join("");
            }
            function q(ee, Q = !1) {
              const J = [];
              Q && J.push("þÿ");
              for (let te = 0, ae = ee.length; te < ae; te++) {
                const se = ee.charCodeAt(te);
                J.push(String.fromCharCode(se >> 8 & 255), String.fromCharCode(se & 255));
              }
              return J.join("");
            }
            function Y(ee, Q, J) {
              switch (ee) {
                case 90:
                  return [0, 1, -1, 0, Q, 0];
                case 180:
                  return [-1, 0, 0, -1, Q, J];
                case 270:
                  return [0, -1, 1, 0, 0, J];
                default:
                  throw new Error("Invalid rotation");
              }
            }
          },
          /* 4 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.RefSetCache = A.RefSet = A.Ref = A.Name = A.EOF = A.Dict = A.Cmd = A.CIRCULAR_REF = void 0, A.clearPrimitiveCaches = w, A.isCmd = L, A.isDict = B, A.isName = O, A.isRefsEqual = F;
            var g = x(2);
            const b = Symbol("CIRCULAR_REF");
            A.CIRCULAR_REF = b;
            const y = Symbol("EOF");
            A.EOF = y;
            let f = /* @__PURE__ */ Object.create(null), m = /* @__PURE__ */ Object.create(null), C = /* @__PURE__ */ Object.create(null);
            function w() {
              f = /* @__PURE__ */ Object.create(null), m = /* @__PURE__ */ Object.create(null), C = /* @__PURE__ */ Object.create(null);
            }
            class S {
              constructor(W) {
                this.name = W;
              }
              static get(W) {
                return m[W] ||= new S(W);
              }
            }
            A.Name = S;
            class $ {
              constructor(W) {
                this.cmd = W;
              }
              static get(W) {
                return f[W] ||= new $(W);
              }
            }
            A.Cmd = $;
            const T = function() {
              return T;
            };
            class I {
              constructor(W = null) {
                this._map = /* @__PURE__ */ Object.create(null), this.xref = W, this.objId = null, this.suppressEncryption = !1, this.__nonSerializable__ = T;
              }
              assignXref(W) {
                this.xref = W;
              }
              get size() {
                return Object.keys(this._map).length;
              }
              get(W, j, G) {
                let U = this._map[W];
                return U === void 0 && j !== void 0 && (U = this._map[j], U === void 0 && G !== void 0 && (U = this._map[G])), U instanceof _ && this.xref ? this.xref.fetch(U, this.suppressEncryption) : U;
              }
              async getAsync(W, j, G) {
                let U = this._map[W];
                return U === void 0 && j !== void 0 && (U = this._map[j], U === void 0 && G !== void 0 && (U = this._map[G])), U instanceof _ && this.xref ? this.xref.fetchAsync(U, this.suppressEncryption) : U;
              }
              getArray(W, j, G) {
                let U = this._map[W];
                if (U === void 0 && j !== void 0 && (U = this._map[j], U === void 0 && G !== void 0 && (U = this._map[G])), U instanceof _ && this.xref && (U = this.xref.fetch(U, this.suppressEncryption)), Array.isArray(U)) {
                  U = U.slice();
                  for (let k = 0, N = U.length; k < N; k++)
                    U[k] instanceof _ && this.xref && (U[k] = this.xref.fetch(U[k], this.suppressEncryption));
                }
                return U;
              }
              getRaw(W) {
                return this._map[W];
              }
              getKeys() {
                return Object.keys(this._map);
              }
              getRawValues() {
                return Object.values(this._map);
              }
              set(W, j) {
                this._map[W] = j;
              }
              has(W) {
                return this._map[W] !== void 0;
              }
              forEach(W) {
                for (const j in this._map)
                  W(j, this.get(j));
              }
              static get empty() {
                const W = new I(null);
                return W.set = (j, G) => {
                  (0, g.unreachable)("Should not call `set` on the empty dictionary.");
                }, (0, g.shadow)(this, "empty", W);
              }
              static merge({
                xref: W,
                dictArray: j,
                mergeSubDicts: G = !1
              }) {
                const U = new I(W), k = /* @__PURE__ */ new Map();
                for (const N of j)
                  if (N instanceof I)
                    for (const [P, D] of Object.entries(N._map)) {
                      let H = k.get(P);
                      if (H === void 0)
                        H = [], k.set(P, H);
                      else if (!G || !(D instanceof I))
                        continue;
                      H.push(D);
                    }
                for (const [N, P] of k) {
                  if (P.length === 1 || !(P[0] instanceof I)) {
                    U._map[N] = P[0];
                    continue;
                  }
                  const D = new I(W);
                  for (const H of P)
                    for (const [V, Z] of Object.entries(H._map))
                      D._map[V] === void 0 && (D._map[V] = Z);
                  D.size > 0 && (U._map[N] = D);
                }
                return k.clear(), U.size > 0 ? U : I.empty;
              }
              clone() {
                const W = new I(this.xref);
                for (const j of this.getKeys())
                  W.set(j, this.getRaw(j));
                return W;
              }
            }
            A.Dict = I;
            class _ {
              constructor(W, j) {
                this.num = W, this.gen = j;
              }
              toString() {
                return this.gen === 0 ? `${this.num}R` : `${this.num}R${this.gen}`;
              }
              static fromString(W) {
                const j = C[W];
                if (j)
                  return j;
                const G = /^(\d+)R(\d*)$/.exec(W);
                return !G || G[1] === "0" ? null : C[W] = new _(parseInt(G[1]), G[2] ? parseInt(G[2]) : 0);
              }
              static get(W, j) {
                const G = j === 0 ? `${W}R` : `${W}R${j}`;
                return C[G] ||= new _(W, j);
              }
            }
            A.Ref = _;
            class E {
              constructor(W = null) {
                this._set = new Set(W?._set);
              }
              has(W) {
                return this._set.has(W.toString());
              }
              put(W) {
                this._set.add(W.toString());
              }
              remove(W) {
                this._set.delete(W.toString());
              }
              [Symbol.iterator]() {
                return this._set.values();
              }
              clear() {
                this._set.clear();
              }
            }
            A.RefSet = E;
            class R {
              constructor() {
                this._map = /* @__PURE__ */ new Map();
              }
              get size() {
                return this._map.size;
              }
              get(W) {
                return this._map.get(W.toString());
              }
              has(W) {
                return this._map.has(W.toString());
              }
              put(W, j) {
                this._map.set(W.toString(), j);
              }
              putAlias(W, j) {
                this._map.set(W.toString(), this.get(j));
              }
              [Symbol.iterator]() {
                return this._map.values();
              }
              clear() {
                this._map.clear();
              }
            }
            A.RefSetCache = R;
            function O(M, W) {
              return M instanceof S && (W === void 0 || M.name === W);
            }
            function L(M, W) {
              return M instanceof $ && (W === void 0 || M.cmd === W);
            }
            function B(M, W) {
              return M instanceof I && (W === void 0 || O(M.get("Type"), W));
            }
            function F(M, W) {
              return M.num === W.num && M.gen === W.gen;
            }
          },
          /* 5 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.BaseStream = void 0;
            var g = x(2);
            class b {
              constructor() {
                this.constructor === b && (0, g.unreachable)("Cannot initialize BaseStream.");
              }
              get length() {
                (0, g.unreachable)("Abstract getter `length` accessed");
              }
              get isEmpty() {
                (0, g.unreachable)("Abstract getter `isEmpty` accessed");
              }
              get isDataLoaded() {
                return (0, g.shadow)(this, "isDataLoaded", !0);
              }
              getByte() {
                (0, g.unreachable)("Abstract method `getByte` called");
              }
              getBytes(f) {
                (0, g.unreachable)("Abstract method `getBytes` called");
              }
              peekByte() {
                const f = this.getByte();
                return f !== -1 && this.pos--, f;
              }
              peekBytes(f) {
                const m = this.getBytes(f);
                return this.pos -= m.length, m;
              }
              getUint16() {
                const f = this.getByte(), m = this.getByte();
                return f === -1 || m === -1 ? -1 : (f << 8) + m;
              }
              getInt32() {
                const f = this.getByte(), m = this.getByte(), C = this.getByte(), w = this.getByte();
                return (f << 24) + (m << 16) + (C << 8) + w;
              }
              getByteRange(f, m) {
                (0, g.unreachable)("Abstract method `getByteRange` called");
              }
              getString(f) {
                return (0, g.bytesToString)(this.getBytes(f));
              }
              skip(f) {
                this.pos += f || 1;
              }
              reset() {
                (0, g.unreachable)("Abstract method `reset` called");
              }
              moveStart() {
                (0, g.unreachable)("Abstract method `moveStart` called");
              }
              makeSubStream(f, m, C = null) {
                (0, g.unreachable)("Abstract method `makeSubStream` called");
              }
              getBaseStreams() {
                return null;
              }
            }
            A.BaseStream = b;
          },
          /* 6 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.NetworkPdfManager = A.LocalPdfManager = void 0;
            var g = x(2), b = x(7), y = x(3), f = x(9), m = x(8);
            function C(T) {
              if (T) {
                const I = (0, g.createValidAbsoluteUrl)(T);
                if (I)
                  return I.href;
                (0, g.warn)(`Invalid absolute docBaseUrl: "${T}".`);
              }
              return null;
            }
            class w {
              constructor(I) {
                this.constructor === w && (0, g.unreachable)("Cannot initialize BasePdfManager."), this._docBaseUrl = C(I.docBaseUrl), this._docId = I.docId, this._password = I.password, this.enableXfa = I.enableXfa, I.evaluatorOptions.isOffscreenCanvasSupported &&= g.FeatureTest.isOffscreenCanvasSupported, this.evaluatorOptions = I.evaluatorOptions;
              }
              get docId() {
                return this._docId;
              }
              get password() {
                return this._password;
              }
              get docBaseUrl() {
                return this._docBaseUrl;
              }
              get catalog() {
                return this.pdfDocument.catalog;
              }
              ensureDoc(I, _) {
                return this.ensure(this.pdfDocument, I, _);
              }
              ensureXRef(I, _) {
                return this.ensure(this.pdfDocument.xref, I, _);
              }
              ensureCatalog(I, _) {
                return this.ensure(this.pdfDocument.catalog, I, _);
              }
              getPage(I) {
                return this.pdfDocument.getPage(I);
              }
              fontFallback(I, _) {
                return this.pdfDocument.fontFallback(I, _);
              }
              loadXfaFonts(I, _) {
                return this.pdfDocument.loadXfaFonts(I, _);
              }
              loadXfaImages() {
                return this.pdfDocument.loadXfaImages();
              }
              serializeXfaData(I) {
                return this.pdfDocument.serializeXfaData(I);
              }
              cleanup(I = !1) {
                return this.pdfDocument.cleanup(I);
              }
              async ensure(I, _, E) {
                (0, g.unreachable)("Abstract method `ensure` called");
              }
              requestRange(I, _) {
                (0, g.unreachable)("Abstract method `requestRange` called");
              }
              requestLoadedStream(I = !1) {
                (0, g.unreachable)("Abstract method `requestLoadedStream` called");
              }
              sendProgressiveData(I) {
                (0, g.unreachable)("Abstract method `sendProgressiveData` called");
              }
              updatePassword(I) {
                this._password = I;
              }
              terminate(I) {
                (0, g.unreachable)("Abstract method `terminate` called");
              }
            }
            class S extends w {
              constructor(I) {
                super(I);
                const _ = new m.Stream(I.source);
                this.pdfDocument = new f.PDFDocument(this, _), this._loadedStreamPromise = Promise.resolve(_);
              }
              async ensure(I, _, E) {
                const R = I[_];
                return typeof R == "function" ? R.apply(I, E) : R;
              }
              requestRange(I, _) {
                return Promise.resolve();
              }
              requestLoadedStream(I = !1) {
                return this._loadedStreamPromise;
              }
              terminate(I) {
              }
            }
            A.LocalPdfManager = S;
            class $ extends w {
              constructor(I) {
                super(I), this.streamManager = new b.ChunkedStreamManager(I.source, {
                  msgHandler: I.handler,
                  length: I.length,
                  disableAutoFetch: I.disableAutoFetch,
                  rangeChunkSize: I.rangeChunkSize
                }), this.pdfDocument = new f.PDFDocument(this, this.streamManager.getStream());
              }
              async ensure(I, _, E) {
                try {
                  const R = I[_];
                  return typeof R == "function" ? R.apply(I, E) : R;
                } catch (R) {
                  if (!(R instanceof y.MissingDataException))
                    throw R;
                  return await this.requestRange(R.begin, R.end), this.ensure(I, _, E);
                }
              }
              requestRange(I, _) {
                return this.streamManager.requestRange(I, _);
              }
              requestLoadedStream(I = !1) {
                return this.streamManager.requestAllChunks(I);
              }
              sendProgressiveData(I) {
                this.streamManager.onReceiveData({
                  chunk: I
                });
              }
              terminate(I) {
                this.streamManager.abort(I);
              }
            }
            A.NetworkPdfManager = $;
          },
          /* 7 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ChunkedStreamManager = A.ChunkedStream = void 0;
            var g = x(3), b = x(2), y = x(8);
            class f extends y.Stream {
              constructor(w, S, $) {
                super(new Uint8Array(w), 0, w, null), this.chunkSize = S, this._loadedChunks = /* @__PURE__ */ new Set(), this.numChunks = Math.ceil(w / S), this.manager = $, this.progressiveDataLength = 0, this.lastSuccessfulEnsureByteChunk = -1;
              }
              getMissingChunks() {
                const w = [];
                for (let S = 0, $ = this.numChunks; S < $; ++S)
                  this._loadedChunks.has(S) || w.push(S);
                return w;
              }
              get numChunksLoaded() {
                return this._loadedChunks.size;
              }
              get isDataLoaded() {
                return this.numChunksLoaded === this.numChunks;
              }
              onReceiveData(w, S) {
                const $ = this.chunkSize;
                if (w % $ !== 0)
                  throw new Error(`Bad begin offset: ${w}`);
                const T = w + S.byteLength;
                if (T % $ !== 0 && T !== this.bytes.length)
                  throw new Error(`Bad end offset: ${T}`);
                this.bytes.set(new Uint8Array(S), w);
                const I = Math.floor(w / $), _ = Math.floor((T - 1) / $) + 1;
                for (let E = I; E < _; ++E)
                  this._loadedChunks.add(E);
              }
              onReceiveProgressiveData(w) {
                let S = this.progressiveDataLength;
                const $ = Math.floor(S / this.chunkSize);
                this.bytes.set(new Uint8Array(w), S), S += w.byteLength, this.progressiveDataLength = S;
                const T = S >= this.end ? this.numChunks : Math.floor(S / this.chunkSize);
                for (let I = $; I < T; ++I)
                  this._loadedChunks.add(I);
              }
              ensureByte(w) {
                if (w < this.progressiveDataLength)
                  return;
                const S = Math.floor(w / this.chunkSize);
                if (!(S > this.numChunks) && S !== this.lastSuccessfulEnsureByteChunk) {
                  if (!this._loadedChunks.has(S))
                    throw new g.MissingDataException(w, w + 1);
                  this.lastSuccessfulEnsureByteChunk = S;
                }
              }
              ensureRange(w, S) {
                if (w >= S || S <= this.progressiveDataLength)
                  return;
                const $ = Math.floor(w / this.chunkSize);
                if ($ > this.numChunks)
                  return;
                const T = Math.min(Math.floor((S - 1) / this.chunkSize) + 1, this.numChunks);
                for (let I = $; I < T; ++I)
                  if (!this._loadedChunks.has(I))
                    throw new g.MissingDataException(w, S);
              }
              nextEmptyChunk(w) {
                const S = this.numChunks;
                for (let $ = 0; $ < S; ++$) {
                  const T = (w + $) % S;
                  if (!this._loadedChunks.has(T))
                    return T;
                }
                return null;
              }
              hasChunk(w) {
                return this._loadedChunks.has(w);
              }
              getByte() {
                const w = this.pos;
                return w >= this.end ? -1 : (w >= this.progressiveDataLength && this.ensureByte(w), this.bytes[this.pos++]);
              }
              getBytes(w) {
                const S = this.bytes, $ = this.pos, T = this.end;
                if (!w)
                  return T > this.progressiveDataLength && this.ensureRange($, T), S.subarray($, T);
                let I = $ + w;
                return I > T && (I = T), I > this.progressiveDataLength && this.ensureRange($, I), this.pos = I, S.subarray($, I);
              }
              getByteRange(w, S) {
                return w < 0 && (w = 0), S > this.end && (S = this.end), S > this.progressiveDataLength && this.ensureRange(w, S), this.bytes.subarray(w, S);
              }
              makeSubStream(w, S, $ = null) {
                S ? w + S > this.progressiveDataLength && this.ensureRange(w, w + S) : w >= this.progressiveDataLength && this.ensureByte(w);
                function T() {
                }
                T.prototype = Object.create(this), T.prototype.getMissingChunks = function() {
                  const _ = this.chunkSize, E = Math.floor(this.start / _), R = Math.floor((this.end - 1) / _) + 1, O = [];
                  for (let L = E; L < R; ++L)
                    this._loadedChunks.has(L) || O.push(L);
                  return O;
                }, Object.defineProperty(T.prototype, "isDataLoaded", {
                  get() {
                    return this.numChunksLoaded === this.numChunks ? !0 : this.getMissingChunks().length === 0;
                  },
                  configurable: !0
                });
                const I = new T();
                return I.pos = I.start = w, I.end = w + S || this.end, I.dict = $, I;
              }
              getBaseStreams() {
                return [this];
              }
            }
            A.ChunkedStream = f;
            class m {
              constructor(w, S) {
                this.length = S.length, this.chunkSize = S.rangeChunkSize, this.stream = new f(this.length, this.chunkSize, this), this.pdfNetworkStream = w, this.disableAutoFetch = S.disableAutoFetch, this.msgHandler = S.msgHandler, this.currRequestId = 0, this._chunksNeededByRequest = /* @__PURE__ */ new Map(), this._requestsByChunk = /* @__PURE__ */ new Map(), this._promisesByRequest = /* @__PURE__ */ new Map(), this.progressiveDataLength = 0, this.aborted = !1, this._loadedStreamCapability = new b.PromiseCapability();
              }
              sendRequest(w, S) {
                const $ = this.pdfNetworkStream.getRangeReader(w, S);
                $.isStreamingSupported || ($.onProgress = this.onProgress.bind(this));
                let T = [], I = 0;
                return new Promise((_, E) => {
                  const R = ({
                    value: O,
                    done: L
                  }) => {
                    try {
                      if (L) {
                        const B = (0, g.arrayBuffersToBytes)(T);
                        T = null, _(B);
                        return;
                      }
                      I += O.byteLength, $.isStreamingSupported && this.onProgress({
                        loaded: I
                      }), T.push(O), $.read().then(R, E);
                    } catch (B) {
                      E(B);
                    }
                  };
                  $.read().then(R, E);
                }).then((_) => {
                  this.aborted || this.onReceiveData({
                    chunk: _,
                    begin: w
                  });
                });
              }
              requestAllChunks(w = !1) {
                if (!w) {
                  const S = this.stream.getMissingChunks();
                  this._requestChunks(S);
                }
                return this._loadedStreamCapability.promise;
              }
              _requestChunks(w) {
                const S = this.currRequestId++, $ = /* @__PURE__ */ new Set();
                this._chunksNeededByRequest.set(S, $);
                for (const _ of w)
                  this.stream.hasChunk(_) || $.add(_);
                if ($.size === 0)
                  return Promise.resolve();
                const T = new b.PromiseCapability();
                this._promisesByRequest.set(S, T);
                const I = [];
                for (const _ of $) {
                  let E = this._requestsByChunk.get(_);
                  E || (E = [], this._requestsByChunk.set(_, E), I.push(_)), E.push(S);
                }
                if (I.length > 0) {
                  const _ = this.groupChunks(I);
                  for (const E of _) {
                    const R = E.beginChunk * this.chunkSize, O = Math.min(E.endChunk * this.chunkSize, this.length);
                    this.sendRequest(R, O).catch(T.reject);
                  }
                }
                return T.promise.catch((_) => {
                  if (!this.aborted)
                    throw _;
                });
              }
              getStream() {
                return this.stream;
              }
              requestRange(w, S) {
                S = Math.min(S, this.length);
                const $ = this.getBeginChunk(w), T = this.getEndChunk(S), I = [];
                for (let _ = $; _ < T; ++_)
                  I.push(_);
                return this._requestChunks(I);
              }
              requestRanges(w = []) {
                const S = [];
                for (const $ of w) {
                  const T = this.getBeginChunk($.begin), I = this.getEndChunk($.end);
                  for (let _ = T; _ < I; ++_)
                    S.includes(_) || S.push(_);
                }
                return S.sort(function($, T) {
                  return $ - T;
                }), this._requestChunks(S);
              }
              groupChunks(w) {
                const S = [];
                let $ = -1, T = -1;
                for (let I = 0, _ = w.length; I < _; ++I) {
                  const E = w[I];
                  $ < 0 && ($ = E), T >= 0 && T + 1 !== E && (S.push({
                    beginChunk: $,
                    endChunk: T + 1
                  }), $ = E), I + 1 === w.length && S.push({
                    beginChunk: $,
                    endChunk: E + 1
                  }), T = E;
                }
                return S;
              }
              onProgress(w) {
                this.msgHandler.send("DocProgress", {
                  loaded: this.stream.numChunksLoaded * this.chunkSize + w.loaded,
                  total: this.length
                });
              }
              onReceiveData(w) {
                const S = w.chunk, $ = w.begin === void 0, T = $ ? this.progressiveDataLength : w.begin, I = T + S.byteLength, _ = Math.floor(T / this.chunkSize), E = I < this.length ? Math.floor(I / this.chunkSize) : Math.ceil(I / this.chunkSize);
                $ ? (this.stream.onReceiveProgressiveData(S), this.progressiveDataLength = I) : this.stream.onReceiveData(T, S), this.stream.isDataLoaded && this._loadedStreamCapability.resolve(this.stream);
                const R = [];
                for (let O = _; O < E; ++O) {
                  const L = this._requestsByChunk.get(O);
                  if (L) {
                    this._requestsByChunk.delete(O);
                    for (const B of L) {
                      const F = this._chunksNeededByRequest.get(B);
                      F.has(O) && F.delete(O), !(F.size > 0) && R.push(B);
                    }
                  }
                }
                if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
                  let O;
                  if (this.stream.numChunksLoaded === 1) {
                    const L = this.stream.numChunks - 1;
                    this.stream.hasChunk(L) || (O = L);
                  } else
                    O = this.stream.nextEmptyChunk(E);
                  Number.isInteger(O) && this._requestChunks([O]);
                }
                for (const O of R) {
                  const L = this._promisesByRequest.get(O);
                  this._promisesByRequest.delete(O), L.resolve();
                }
                this.msgHandler.send("DocProgress", {
                  loaded: this.stream.numChunksLoaded * this.chunkSize,
                  total: this.length
                });
              }
              onError(w) {
                this._loadedStreamCapability.reject(w);
              }
              getBeginChunk(w) {
                return Math.floor(w / this.chunkSize);
              }
              getEndChunk(w) {
                return Math.floor((w - 1) / this.chunkSize) + 1;
              }
              abort(w) {
                this.aborted = !0, this.pdfNetworkStream?.cancelAllRequests(w);
                for (const S of this._promisesByRequest.values())
                  S.reject(w);
              }
            }
            A.ChunkedStreamManager = m;
          },
          /* 8 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.StringStream = A.Stream = A.NullStream = void 0;
            var g = x(5), b = x(2);
            class y extends g.BaseStream {
              constructor(w, S, $, T) {
                super(), this.bytes = w instanceof Uint8Array ? w : new Uint8Array(w), this.start = S || 0, this.pos = this.start, this.end = S + $ || this.bytes.length, this.dict = T;
              }
              get length() {
                return this.end - this.start;
              }
              get isEmpty() {
                return this.length === 0;
              }
              getByte() {
                return this.pos >= this.end ? -1 : this.bytes[this.pos++];
              }
              getBytes(w) {
                const S = this.bytes, $ = this.pos, T = this.end;
                if (!w)
                  return S.subarray($, T);
                let I = $ + w;
                return I > T && (I = T), this.pos = I, S.subarray($, I);
              }
              getByteRange(w, S) {
                return w < 0 && (w = 0), S > this.end && (S = this.end), this.bytes.subarray(w, S);
              }
              reset() {
                this.pos = this.start;
              }
              moveStart() {
                this.start = this.pos;
              }
              makeSubStream(w, S, $ = null) {
                return new y(this.bytes.buffer, w, S, $);
              }
            }
            A.Stream = y;
            class f extends y {
              constructor(w) {
                super((0, b.stringToBytes)(w));
              }
            }
            A.StringStream = f;
            class m extends y {
              constructor() {
                super(new Uint8Array(0));
              }
            }
            A.NullStream = m;
          },
          /* 9 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Page = A.PDFDocument = void 0;
            var g = x(2), b = x(10), y = x(3), f = x(4), m = x(51), C = x(5), w = x(74), S = x(66), $ = x(68), T = x(102), I = x(16), _ = x(8), E = x(76), R = x(64), O = x(13), L = x(18), B = x(72), F = x(73), M = x(77), W = x(103);
            const j = 1, G = [0, 0, 612, 792];
            class U {
              constructor({
                pdfManager: K,
                xref: q,
                pageIndex: Y,
                pageDict: ee,
                ref: Q,
                globalIdFactory: J,
                fontCache: te,
                builtInCMapCache: ae,
                standardFontDataCache: se,
                globalImageCache: ie,
                systemFontCache: fe,
                nonBlendModesSet: ge,
                xfaFactory: me
              }) {
                this.pdfManager = K, this.pageIndex = Y, this.pageDict = ee, this.xref = q, this.ref = Q, this.fontCache = te, this.builtInCMapCache = ae, this.standardFontDataCache = se, this.globalImageCache = ie, this.systemFontCache = fe, this.nonBlendModesSet = ge, this.evaluatorOptions = K.evaluatorOptions, this.resourcesPromise = null, this.xfaFactory = me;
                const pe = {
                  obj: 0
                };
                this._localIdFactory = class extends J {
                  static createObjId() {
                    return `p${Y}_${++pe.obj}`;
                  }
                  static getPageObjId() {
                    return `p${Q.toString()}`;
                  }
                };
              }
              _getInheritableProperty(K, q = !1) {
                const Y = (0, y.getInheritableProperty)({
                  dict: this.pageDict,
                  key: K,
                  getArray: q,
                  stopWhenFound: !1
                });
                return Array.isArray(Y) ? Y.length === 1 || !(Y[0] instanceof f.Dict) ? Y[0] : f.Dict.merge({
                  xref: this.xref,
                  dictArray: Y
                }) : Y;
              }
              get content() {
                return this.pageDict.getArray("Contents");
              }
              get resources() {
                const K = this._getInheritableProperty("Resources");
                return (0, g.shadow)(this, "resources", K instanceof f.Dict ? K : f.Dict.empty);
              }
              _getBoundingBox(K) {
                if (this.xfaData)
                  return this.xfaData.bbox;
                let q = this._getInheritableProperty(K, !0);
                if (Array.isArray(q) && q.length === 4) {
                  if (q = g.Util.normalizeRect(q), q[2] - q[0] > 0 && q[3] - q[1] > 0)
                    return q;
                  (0, g.warn)(`Empty, or invalid, /${K} entry.`);
                }
                return null;
              }
              get mediaBox() {
                return (0, g.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || G);
              }
              get cropBox() {
                return (0, g.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
              }
              get userUnit() {
                let K = this.pageDict.get("UserUnit");
                return (typeof K != "number" || K <= 0) && (K = j), (0, g.shadow)(this, "userUnit", K);
              }
              get view() {
                const {
                  cropBox: K,
                  mediaBox: q
                } = this;
                if (K !== q && !(0, g.isArrayEqual)(K, q)) {
                  const Y = g.Util.intersect(K, q);
                  if (Y && Y[2] - Y[0] > 0 && Y[3] - Y[1] > 0)
                    return (0, g.shadow)(this, "view", Y);
                  (0, g.warn)("Empty /CropBox and /MediaBox intersection.");
                }
                return (0, g.shadow)(this, "view", q);
              }
              get rotate() {
                let K = this._getInheritableProperty("Rotate") || 0;
                return K % 90 !== 0 ? K = 0 : K >= 360 ? K %= 360 : K < 0 && (K = (K % 360 + 360) % 360), (0, g.shadow)(this, "rotate", K);
              }
              _onSubStreamError(K, q) {
                if (this.evaluatorOptions.ignoreErrors) {
                  (0, g.warn)(`getContentStream - ignoring sub-stream (${q}): "${K}".`);
                  return;
                }
                throw K;
              }
              getContentStream() {
                return this.pdfManager.ensure(this, "content").then((K) => K instanceof C.BaseStream ? K : Array.isArray(K) ? new L.StreamsSequenceStream(K, this._onSubStreamError.bind(this)) : new _.NullStream());
              }
              get xfaData() {
                return (0, g.shadow)(this, "xfaData", this.xfaFactory ? {
                  bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
                } : null);
              }
              #e(K, q, Y) {
                for (const ee of K)
                  if (ee.id) {
                    const Q = f.Ref.fromString(ee.id);
                    if (!Q) {
                      (0, g.warn)(`A non-linked annotation cannot be modified: ${ee.id}`);
                      continue;
                    }
                    if (ee.deleted) {
                      q.put(Q);
                      continue;
                    }
                    Y?.put(Q), ee.ref = Q, delete ee.id;
                  }
              }
              async saveNewAnnotations(K, q, Y, ee) {
                if (this.xfaFactory)
                  throw new Error("XFA: Cannot save new annotations.");
                const Q = new O.PartialEvaluator({
                  xref: this.xref,
                  handler: K,
                  pageIndex: this.pageIndex,
                  idFactory: this._localIdFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  standardFontDataCache: this.standardFontDataCache,
                  globalImageCache: this.globalImageCache,
                  systemFontCache: this.systemFontCache,
                  options: this.evaluatorOptions
                }), J = new f.RefSet(), te = new f.RefSet();
                this.#e(Y, J, te);
                const ae = this.pageDict, se = this.annotations.filter((pe) => !(pe instanceof f.Ref && J.has(pe))), ie = await b.AnnotationFactory.saveNewAnnotations(Q, q, Y, ee);
                for (const {
                  ref: pe
                } of ie.annotations)
                  pe instanceof f.Ref && !te.has(pe) && se.push(pe);
                const fe = ae.get("Annots");
                ae.set("Annots", se);
                const ge = [];
                await (0, F.writeObject)(this.ref, ae, ge, this.xref), fe && ae.set("Annots", fe);
                const me = ie.dependencies;
                return me.push({
                  ref: this.ref,
                  data: ge.join("")
                }, ...ie.annotations), me;
              }
              save(K, q, Y) {
                const ee = new O.PartialEvaluator({
                  xref: this.xref,
                  handler: K,
                  pageIndex: this.pageIndex,
                  idFactory: this._localIdFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  standardFontDataCache: this.standardFontDataCache,
                  globalImageCache: this.globalImageCache,
                  systemFontCache: this.systemFontCache,
                  options: this.evaluatorOptions
                });
                return this._parsedAnnotations.then(function(Q) {
                  const J = [];
                  for (const te of Q)
                    te.mustBePrinted(Y) && J.push(te.save(ee, q, Y).catch(function(ae) {
                      return (0, g.warn)(`save - ignoring annotation data during "${q.name}" task: "${ae}".`), null;
                    }));
                  return Promise.all(J).then(function(te) {
                    return te.filter((ae) => !!ae);
                  });
                });
              }
              loadResources(K) {
                return this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, "resources")), this.resourcesPromise.then(() => new E.ObjectLoader(this.resources, K, this.xref).load());
              }
              getOperatorList({
                handler: K,
                sink: q,
                task: Y,
                intent: ee,
                cacheKey: Q,
                annotationStorage: J = null
              }) {
                const te = this.getContentStream(), ae = this.loadResources(["ColorSpace", "ExtGState", "Font", "Pattern", "Properties", "Shading", "XObject"]), se = new O.PartialEvaluator({
                  xref: this.xref,
                  handler: K,
                  pageIndex: this.pageIndex,
                  idFactory: this._localIdFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  standardFontDataCache: this.standardFontDataCache,
                  globalImageCache: this.globalImageCache,
                  systemFontCache: this.systemFontCache,
                  options: this.evaluatorOptions
                }), ie = this.xfaFactory ? null : (0, y.getNewAnnotationsMap)(J);
                let fe = null, ge = Promise.resolve(null);
                if (ie) {
                  const be = ie.get(this.pageIndex);
                  if (be) {
                    const le = this.pdfManager.ensureDoc("annotationGlobals");
                    let ve;
                    const he = /* @__PURE__ */ new Set();
                    for (const {
                      bitmapId: Ce,
                      bitmap: xe
                    } of be)
                      Ce && !xe && !he.has(Ce) && he.add(Ce);
                    const {
                      isOffscreenCanvasSupported: ye
                    } = this.evaluatorOptions;
                    if (he.size > 0) {
                      const Ce = be.slice();
                      for (const [xe, we] of J)
                        xe.startsWith(g.AnnotationEditorPrefix) && we.bitmap && he.has(we.bitmapId) && Ce.push(we);
                      ve = b.AnnotationFactory.generateImages(Ce, this.xref, ye);
                    } else
                      ve = b.AnnotationFactory.generateImages(be, this.xref, ye);
                    fe = new f.RefSet(), this.#e(be, fe, null), ge = le.then((Ce) => Ce ? b.AnnotationFactory.printNewAnnotations(Ce, se, Y, be, ve) : null);
                  }
                }
                const pe = Promise.all([te, ae]).then(([be]) => {
                  const le = new R.OperatorList(ee, q);
                  return K.send("StartRenderPage", {
                    transparency: se.hasBlendModes(this.resources, this.nonBlendModesSet),
                    pageIndex: this.pageIndex,
                    cacheKey: Q
                  }), se.getOperatorList({
                    stream: be,
                    task: Y,
                    resources: this.resources,
                    operatorList: le
                  }).then(function() {
                    return le;
                  });
                });
                return Promise.all([pe, this._parsedAnnotations, ge]).then(function([be, le, ve]) {
                  if (ve) {
                    le = le.filter(($e) => !($e.ref && fe.has($e.ref)));
                    for (let $e = 0, Ae = ve.length; $e < Ae; $e++) {
                      const ue = ve[$e];
                      if (ue.refToReplace) {
                        const ce = le.findIndex((Ee) => Ee.ref && (0, f.isRefsEqual)(Ee.ref, ue.refToReplace));
                        ce >= 0 && (le.splice(ce, 1, ue), ve.splice($e--, 1), Ae--);
                      }
                    }
                    le = le.concat(ve);
                  }
                  if (le.length === 0 || ee & g.RenderingIntentFlag.ANNOTATIONS_DISABLE)
                    return be.flush(!0), {
                      length: be.totalLength
                    };
                  const he = !!(ee & g.RenderingIntentFlag.ANNOTATIONS_FORMS), ye = !!(ee & g.RenderingIntentFlag.ANY), Ce = !!(ee & g.RenderingIntentFlag.DISPLAY), xe = !!(ee & g.RenderingIntentFlag.PRINT), we = [];
                  for (const $e of le)
                    (ye || Ce && $e.mustBeViewed(J, he) || xe && $e.mustBePrinted(J)) && we.push($e.getOperatorList(se, Y, ee, he, J).catch(function(Ae) {
                      return (0, g.warn)(`getOperatorList - ignoring annotation data during "${Y.name}" task: "${Ae}".`), {
                        opList: null,
                        separateForm: !1,
                        separateCanvas: !1
                      };
                    }));
                  return Promise.all(we).then(function($e) {
                    let Ae = !1, ue = !1;
                    for (const {
                      opList: ce,
                      separateForm: Ee,
                      separateCanvas: _e
                    } of $e)
                      be.addOpList(ce), Ae ||= Ee, ue ||= _e;
                    return be.flush(!0, {
                      form: Ae,
                      canvas: ue
                    }), {
                      length: be.totalLength
                    };
                  });
                });
              }
              extractTextContent({
                handler: K,
                task: q,
                includeMarkedContent: Y,
                disableNormalization: ee,
                sink: Q
              }) {
                const J = this.getContentStream(), te = this.loadResources(["ExtGState", "Font", "Properties", "XObject"]);
                return Promise.all([J, te]).then(([se]) => new O.PartialEvaluator({
                  xref: this.xref,
                  handler: K,
                  pageIndex: this.pageIndex,
                  idFactory: this._localIdFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  standardFontDataCache: this.standardFontDataCache,
                  globalImageCache: this.globalImageCache,
                  systemFontCache: this.systemFontCache,
                  options: this.evaluatorOptions
                }).getTextContent({
                  stream: se,
                  task: q,
                  resources: this.resources,
                  includeMarkedContent: Y,
                  disableNormalization: ee,
                  sink: Q,
                  viewBox: this.view
                }));
              }
              async getStructTree() {
                const K = await this.pdfManager.ensureCatalog("structTreeRoot");
                return K ? (await this._parsedAnnotations, (await this.pdfManager.ensure(this, "_parseStructTree", [K])).serializable) : null;
              }
              _parseStructTree(K) {
                const q = new B.StructTreePage(K, this.pageDict);
                return q.parse(this.ref), q;
              }
              async getAnnotationsData(K, q, Y) {
                const ee = await this._parsedAnnotations;
                if (ee.length === 0)
                  return ee;
                const Q = [], J = [];
                let te;
                const ae = !!(Y & g.RenderingIntentFlag.ANY), se = !!(Y & g.RenderingIntentFlag.DISPLAY), ie = !!(Y & g.RenderingIntentFlag.PRINT);
                for (const fe of ee) {
                  const ge = ae || se && fe.viewable;
                  (ge || ie && fe.printable) && Q.push(fe.data), fe.hasTextContent && ge && (te ||= new O.PartialEvaluator({
                    xref: this.xref,
                    handler: K,
                    pageIndex: this.pageIndex,
                    idFactory: this._localIdFactory,
                    fontCache: this.fontCache,
                    builtInCMapCache: this.builtInCMapCache,
                    standardFontDataCache: this.standardFontDataCache,
                    globalImageCache: this.globalImageCache,
                    systemFontCache: this.systemFontCache,
                    options: this.evaluatorOptions
                  }), J.push(fe.extractTextContent(te, q, [-1 / 0, -1 / 0, 1 / 0, 1 / 0]).catch(function(me) {
                    (0, g.warn)(`getAnnotationsData - ignoring textContent during "${q.name}" task: "${me}".`);
                  })));
                }
                return await Promise.all(J), Q;
              }
              get annotations() {
                const K = this._getInheritableProperty("Annots");
                return (0, g.shadow)(this, "annotations", Array.isArray(K) ? K : []);
              }
              get _parsedAnnotations() {
                const K = this.pdfManager.ensure(this, "annotations").then(async (q) => {
                  if (q.length === 0)
                    return q;
                  const Y = await this.pdfManager.ensureDoc("annotationGlobals");
                  if (!Y)
                    return [];
                  const ee = [];
                  for (const te of q)
                    ee.push(b.AnnotationFactory.create(this.xref, te, Y, this._localIdFactory, !1, this.ref).catch(function(ae) {
                      return (0, g.warn)(`_parsedAnnotations: "${ae}".`), null;
                    }));
                  const Q = [];
                  let J;
                  for (const te of await Promise.all(ee))
                    if (te) {
                      if (te instanceof b.PopupAnnotation) {
                        (J ||= []).push(te);
                        continue;
                      }
                      Q.push(te);
                    }
                  return J && Q.push(...J), Q;
                });
                return (0, g.shadow)(this, "_parsedAnnotations", K);
              }
              get jsActions() {
                const K = (0, y.collectActions)(this.xref, this.pageDict, g.PageActionEventType);
                return (0, g.shadow)(this, "jsActions", K);
              }
            }
            A.Page = U;
            const k = new Uint8Array([37, 80, 68, 70, 45]), N = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), P = new Uint8Array([101, 110, 100, 111, 98, 106]), D = 1024, H = "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
            function V(ne, K, q = 1024, Y = !1) {
              const ee = K.length, Q = ne.peekBytes(q), J = Q.length - ee;
              if (J <= 0)
                return !1;
              if (Y) {
                const te = ee - 1;
                let ae = Q.length - 1;
                for (; ae >= te; ) {
                  let se = 0;
                  for (; se < ee && Q[ae - se] === K[te - se]; )
                    se++;
                  if (se >= ee)
                    return ne.pos += ae - te, !0;
                  ae--;
                }
              } else {
                let te = 0;
                for (; te <= J; ) {
                  let ae = 0;
                  for (; ae < ee && Q[te + ae] === K[ae]; )
                    ae++;
                  if (ae >= ee)
                    return ne.pos += te, !0;
                  te++;
                }
              }
              return !1;
            }
            class Z {
              constructor(K, q) {
                if (q.length <= 0)
                  throw new g.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
                this.pdfManager = K, this.stream = q, this.xref = new W.XRef(q, K), this._pagePromises = /* @__PURE__ */ new Map(), this._version = null;
                const Y = {
                  font: 0
                };
                this._globalIdFactory = class {
                  static getDocId() {
                    return `g_${K.docId}`;
                  }
                  static createFontId() {
                    return `f${++Y.font}`;
                  }
                  static createObjId() {
                    (0, g.unreachable)("Abstract method `createObjId` called.");
                  }
                  static getPageObjId() {
                    (0, g.unreachable)("Abstract method `getPageObjId` called.");
                  }
                };
              }
              parse(K) {
                this.xref.parse(K), this.catalog = new S.Catalog(this.pdfManager, this.xref);
              }
              get linearization() {
                let K = null;
                try {
                  K = I.Linearization.create(this.stream);
                } catch (q) {
                  if (q instanceof y.MissingDataException)
                    throw q;
                  (0, g.info)(q);
                }
                return (0, g.shadow)(this, "linearization", K);
              }
              get startXRef() {
                const K = this.stream;
                let q = 0;
                if (this.linearization)
                  K.reset(), V(K, P) && (q = K.pos + 6 - K.start);
                else {
                  const ee = N.length;
                  let Q = !1, J = K.end;
                  for (; !Q && J > 0; )
                    J -= 1024 - ee, J < 0 && (J = 0), K.pos = J, Q = V(K, N, 1024, !0);
                  if (Q) {
                    K.skip(9);
                    let te;
                    do
                      te = K.getByte();
                    while ((0, y.isWhiteSpace)(te));
                    let ae = "";
                    for (; te >= 32 && te <= 57; )
                      ae += String.fromCharCode(te), te = K.getByte();
                    q = parseInt(ae, 10), isNaN(q) && (q = 0);
                  }
                }
                return (0, g.shadow)(this, "startXRef", q);
              }
              checkHeader() {
                const K = this.stream;
                if (K.reset(), !V(K, k))
                  return;
                K.moveStart(), K.skip(k.length);
                let q = "", Y;
                for (; (Y = K.getByte()) > 32 && q.length < 7; )
                  q += String.fromCharCode(Y);
                y.PDF_VERSION_REGEXP.test(q) ? this._version = q : (0, g.warn)(`Invalid PDF header version: ${q}`);
              }
              parseStartXRef() {
                this.xref.setStartXRef(this.startXRef);
              }
              get numPages() {
                let K = 0;
                return this.catalog.hasActualNumPages ? K = this.catalog.numPages : this.xfaFactory ? K = this.xfaFactory.getNumPages() : this.linearization ? K = this.linearization.numPages : K = this.catalog.numPages, (0, g.shadow)(this, "numPages", K);
              }
              _hasOnlyDocumentSignatures(K, q = 0) {
                return Array.isArray(K) ? K.every((ee) => {
                  if (ee = this.xref.fetchIfRef(ee), !(ee instanceof f.Dict))
                    return !1;
                  if (ee.has("Kids"))
                    return ++q > 10 ? ((0, g.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached"), !1) : this._hasOnlyDocumentSignatures(ee.get("Kids"), q);
                  const Q = (0, f.isName)(ee.get("FT"), "Sig"), J = ee.get("Rect"), te = Array.isArray(J) && J.every((ae) => ae === 0);
                  return Q && te;
                }) : !1;
              }
              get _xfaStreams() {
                const K = this.catalog.acroForm;
                if (!K)
                  return null;
                const q = K.get("XFA"), Y = {
                  "xdp:xdp": "",
                  template: "",
                  datasets: "",
                  config: "",
                  connectionSet: "",
                  localeSet: "",
                  stylesheet: "",
                  "/xdp:xdp": ""
                };
                if (q instanceof C.BaseStream && !q.isEmpty)
                  return Y["xdp:xdp"] = q, Y;
                if (!Array.isArray(q) || q.length === 0)
                  return null;
                for (let ee = 0, Q = q.length; ee < Q; ee += 2) {
                  let J;
                  if (ee === 0 ? J = "xdp:xdp" : ee === Q - 2 ? J = "/xdp:xdp" : J = q[ee], !Y.hasOwnProperty(J))
                    continue;
                  const te = this.xref.fetchIfRef(q[ee + 1]);
                  !(te instanceof C.BaseStream) || te.isEmpty || (Y[J] = te);
                }
                return Y;
              }
              get xfaDatasets() {
                const K = this._xfaStreams;
                if (!K)
                  return (0, g.shadow)(this, "xfaDatasets", null);
                for (const q of ["datasets", "xdp:xdp"]) {
                  const Y = K[q];
                  if (Y)
                    try {
                      const ee = (0, g.stringToUTF8String)(Y.getString()), Q = {
                        [q]: ee
                      };
                      return (0, g.shadow)(this, "xfaDatasets", new T.DatasetReader(Q));
                    } catch {
                      (0, g.warn)("XFA - Invalid utf-8 string.");
                      break;
                    }
                }
                return (0, g.shadow)(this, "xfaDatasets", null);
              }
              get xfaData() {
                const K = this._xfaStreams;
                if (!K)
                  return null;
                const q = /* @__PURE__ */ Object.create(null);
                for (const [Y, ee] of Object.entries(K))
                  if (ee)
                    try {
                      q[Y] = (0, g.stringToUTF8String)(ee.getString());
                    } catch {
                      return (0, g.warn)("XFA - Invalid utf-8 string."), null;
                    }
                return q;
              }
              get xfaFactory() {
                let K;
                return this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm && (K = this.xfaData), (0, g.shadow)(this, "xfaFactory", K ? new M.XFAFactory(K) : null);
              }
              get isPureXfa() {
                return this.xfaFactory ? this.xfaFactory.isValid() : !1;
              }
              get htmlForXfa() {
                return this.xfaFactory ? this.xfaFactory.getPages() : null;
              }
              async loadXfaImages() {
                const K = await this.pdfManager.ensureCatalog("xfaImages");
                if (!K)
                  return;
                const q = K.getKeys();
                await new E.ObjectLoader(K, q, this.xref).load();
                const ee = /* @__PURE__ */ new Map();
                for (const Q of q) {
                  const J = K.get(Q);
                  J instanceof C.BaseStream && ee.set(Q, J.getBytes());
                }
                this.xfaFactory.setImages(ee);
              }
              async loadXfaFonts(K, q) {
                const Y = await this.pdfManager.ensureCatalog("acroForm");
                if (!Y)
                  return;
                const ee = await Y.getAsync("DR");
                if (!(ee instanceof f.Dict))
                  return;
                await new E.ObjectLoader(ee, ["Font"], this.xref).load();
                const J = ee.get("Font");
                if (!(J instanceof f.Dict))
                  return;
                const te = Object.assign(/* @__PURE__ */ Object.create(null), this.pdfManager.evaluatorOptions);
                te.useSystemFonts = !1;
                const ae = new O.PartialEvaluator({
                  xref: this.xref,
                  handler: K,
                  pageIndex: -1,
                  idFactory: this._globalIdFactory,
                  fontCache: this.catalog.fontCache,
                  builtInCMapCache: this.catalog.builtInCMapCache,
                  standardFontDataCache: this.catalog.standardFontDataCache,
                  options: te
                }), se = new R.OperatorList(), ie = [], fe = {
                  get font() {
                    return ie.at(-1);
                  },
                  set font(le) {
                    ie.push(le);
                  },
                  clone() {
                    return this;
                  }
                }, ge = /* @__PURE__ */ new Map();
                J.forEach((le, ve) => {
                  ge.set(le, ve);
                });
                const me = [];
                for (const [le, ve] of ge) {
                  const he = ve.get("FontDescriptor");
                  if (!(he instanceof f.Dict))
                    continue;
                  let ye = he.get("FontFamily");
                  ye = ye.replaceAll(/[ ]+(\d)/g, "$1");
                  const Ce = he.get("FontWeight"), xe = -he.get("ItalicAngle"), we = {
                    fontFamily: ye,
                    fontWeight: Ce,
                    italicAngle: xe
                  };
                  (0, y.validateCSSFont)(we) && me.push(ae.handleSetFont(ee, [f.Name.get(le), 1], null, se, q, fe, null, we).catch(function($e) {
                    return (0, g.warn)(`loadXfaFonts: "${$e}".`), null;
                  }));
                }
                await Promise.all(me);
                const pe = this.xfaFactory.setFonts(ie);
                if (!pe)
                  return;
                te.ignoreErrors = !0, me.length = 0, ie.length = 0;
                const be = /* @__PURE__ */ new Set();
                for (const le of pe)
                  (0, m.getXfaFontName)(`${le}-Regular`) || be.add(le);
                be.size && pe.push("PdfJS-Fallback");
                for (const le of pe)
                  if (!be.has(le))
                    for (const ve of [{
                      name: "Regular",
                      fontWeight: 400,
                      italicAngle: 0
                    }, {
                      name: "Bold",
                      fontWeight: 700,
                      italicAngle: 0
                    }, {
                      name: "Italic",
                      fontWeight: 400,
                      italicAngle: 12
                    }, {
                      name: "BoldItalic",
                      fontWeight: 700,
                      italicAngle: 12
                    }]) {
                      const he = `${le}-${ve.name}`, ye = (0, m.getXfaFontDict)(he);
                      me.push(ae.handleSetFont(ee, [f.Name.get(he), 1], null, se, q, fe, ye, {
                        fontFamily: le,
                        fontWeight: ve.fontWeight,
                        italicAngle: ve.italicAngle
                      }).catch(function(Ce) {
                        return (0, g.warn)(`loadXfaFonts: "${Ce}".`), null;
                      }));
                    }
                await Promise.all(me), this.xfaFactory.appendFonts(ie, be);
              }
              async serializeXfaData(K) {
                return this.xfaFactory ? this.xfaFactory.serializeData(K) : null;
              }
              get version() {
                return this.catalog.version || this._version;
              }
              get formInfo() {
                const K = {
                  hasFields: !1,
                  hasAcroForm: !1,
                  hasXfa: !1,
                  hasSignatures: !1
                }, q = this.catalog.acroForm;
                if (!q)
                  return (0, g.shadow)(this, "formInfo", K);
                try {
                  const Y = q.get("Fields"), ee = Array.isArray(Y) && Y.length > 0;
                  K.hasFields = ee;
                  const Q = q.get("XFA");
                  K.hasXfa = Array.isArray(Q) && Q.length > 0 || Q instanceof C.BaseStream && !Q.isEmpty;
                  const te = !!(q.get("SigFlags") & 1), ae = te && this._hasOnlyDocumentSignatures(Y);
                  K.hasAcroForm = ee && !ae, K.hasSignatures = te;
                } catch (Y) {
                  if (Y instanceof y.MissingDataException)
                    throw Y;
                  (0, g.warn)(`Cannot fetch form information: "${Y}".`);
                }
                return (0, g.shadow)(this, "formInfo", K);
              }
              get documentInfo() {
                const K = {
                  PDFFormatVersion: this.version,
                  Language: this.catalog.lang,
                  EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
                  IsLinearized: !!this.linearization,
                  IsAcroFormPresent: this.formInfo.hasAcroForm,
                  IsXFAPresent: this.formInfo.hasXfa,
                  IsCollectionPresent: !!this.catalog.collection,
                  IsSignaturesPresent: this.formInfo.hasSignatures
                };
                let q;
                try {
                  q = this.xref.trailer.get("Info");
                } catch (Y) {
                  if (Y instanceof y.MissingDataException)
                    throw Y;
                  (0, g.info)("The document information dictionary is invalid.");
                }
                if (!(q instanceof f.Dict))
                  return (0, g.shadow)(this, "documentInfo", K);
                for (const Y of q.getKeys()) {
                  const ee = q.get(Y);
                  switch (Y) {
                    case "Title":
                    case "Author":
                    case "Subject":
                    case "Keywords":
                    case "Creator":
                    case "Producer":
                    case "CreationDate":
                    case "ModDate":
                      if (typeof ee == "string") {
                        K[Y] = (0, g.stringToPDFString)(ee);
                        continue;
                      }
                      break;
                    case "Trapped":
                      if (ee instanceof f.Name) {
                        K[Y] = ee;
                        continue;
                      }
                      break;
                    default:
                      let Q;
                      switch (typeof ee) {
                        case "string":
                          Q = (0, g.stringToPDFString)(ee);
                          break;
                        case "number":
                        case "boolean":
                          Q = ee;
                          break;
                        default:
                          ee instanceof f.Name && (Q = ee);
                          break;
                      }
                      if (Q === void 0) {
                        (0, g.warn)(`Bad value, for custom key "${Y}", in Info: ${ee}.`);
                        continue;
                      }
                      K.Custom || (K.Custom = /* @__PURE__ */ Object.create(null)), K.Custom[Y] = Q;
                      continue;
                  }
                  (0, g.warn)(`Bad value, for key "${Y}", in Info: ${ee}.`);
                }
                return (0, g.shadow)(this, "documentInfo", K);
              }
              get fingerprints() {
                function K(J) {
                  return typeof J == "string" && J.length > 0 && J !== H;
                }
                function q(J) {
                  const te = [];
                  for (const ae of J) {
                    const se = ae.toString(16);
                    te.push(se.padStart(2, "0"));
                  }
                  return te.join("");
                }
                const Y = this.xref.trailer.get("ID");
                let ee, Q;
                return Array.isArray(Y) && K(Y[0]) ? (ee = (0, g.stringToBytes)(Y[0]), Y[1] !== Y[0] && K(Y[1]) && (Q = (0, g.stringToBytes)(Y[1]))) : ee = (0, w.calculateMD5)(this.stream.getByteRange(0, D), 0, D), (0, g.shadow)(this, "fingerprints", [q(ee), Q ? q(Q) : null]);
              }
              async _getLinearizationPage(K) {
                const {
                  catalog: q,
                  linearization: Y,
                  xref: ee
                } = this, Q = f.Ref.get(Y.objectNumberFirst, 0);
                try {
                  const J = await ee.fetchAsync(Q);
                  if (J instanceof f.Dict) {
                    let te = J.getRaw("Type");
                    if (te instanceof f.Ref && (te = await ee.fetchAsync(te)), (0, f.isName)(te, "Page") || !J.has("Type") && !J.has("Kids"))
                      return q.pageKidsCountCache.has(Q) || q.pageKidsCountCache.put(Q, 1), q.pageIndexCache.has(Q) || q.pageIndexCache.put(Q, 0), [J, Q];
                  }
                  throw new g.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
                } catch (J) {
                  return (0, g.warn)(`_getLinearizationPage: "${J.message}".`), q.getPageDict(K);
                }
              }
              getPage(K) {
                const q = this._pagePromises.get(K);
                if (q)
                  return q;
                const {
                  catalog: Y,
                  linearization: ee,
                  xfaFactory: Q
                } = this;
                let J;
                return Q ? J = Promise.resolve([f.Dict.empty, null]) : ee?.pageFirst === K ? J = this._getLinearizationPage(K) : J = Y.getPageDict(K), J = J.then(([te, ae]) => new U({
                  pdfManager: this.pdfManager,
                  xref: this.xref,
                  pageIndex: K,
                  pageDict: te,
                  ref: ae,
                  globalIdFactory: this._globalIdFactory,
                  fontCache: Y.fontCache,
                  builtInCMapCache: Y.builtInCMapCache,
                  standardFontDataCache: Y.standardFontDataCache,
                  globalImageCache: Y.globalImageCache,
                  systemFontCache: Y.systemFontCache,
                  nonBlendModesSet: Y.nonBlendModesSet,
                  xfaFactory: Q
                })), this._pagePromises.set(K, J), J;
              }
              async checkFirstPage(K = !1) {
                if (!K)
                  try {
                    await this.getPage(0);
                  } catch (q) {
                    if (q instanceof y.XRefEntryException)
                      throw this._pagePromises.delete(0), await this.cleanup(), new y.XRefParseException();
                  }
              }
              async checkLastPage(K = !1) {
                const {
                  catalog: q,
                  pdfManager: Y
                } = this;
                q.setActualNumPages();
                let ee;
                try {
                  if (await Promise.all([Y.ensureDoc("xfaFactory"), Y.ensureDoc("linearization"), Y.ensureCatalog("numPages")]), this.xfaFactory)
                    return;
                  if (this.linearization ? ee = this.linearization.numPages : ee = q.numPages, Number.isInteger(ee)) {
                    if (ee <= 1)
                      return;
                  } else throw new g.FormatError("Page count is not an integer.");
                  await this.getPage(ee - 1);
                } catch (Q) {
                  if (this._pagePromises.delete(ee - 1), await this.cleanup(), Q instanceof y.XRefEntryException && !K)
                    throw new y.XRefParseException();
                  (0, g.warn)(`checkLastPage - invalid /Pages tree /Count: ${ee}.`);
                  let J;
                  try {
                    J = await q.getAllPageDicts(K);
                  } catch (te) {
                    if (te instanceof y.XRefEntryException && !K)
                      throw new y.XRefParseException();
                    q.setActualNumPages(1);
                    return;
                  }
                  for (const [te, [ae, se]] of J) {
                    let ie;
                    ae instanceof Error ? (ie = Promise.reject(ae), ie.catch(() => {
                    })) : ie = Promise.resolve(new U({
                      pdfManager: Y,
                      xref: this.xref,
                      pageIndex: te,
                      pageDict: ae,
                      ref: se,
                      globalIdFactory: this._globalIdFactory,
                      fontCache: q.fontCache,
                      builtInCMapCache: q.builtInCMapCache,
                      standardFontDataCache: q.standardFontDataCache,
                      globalImageCache: q.globalImageCache,
                      systemFontCache: q.systemFontCache,
                      nonBlendModesSet: q.nonBlendModesSet,
                      xfaFactory: null
                    })), this._pagePromises.set(te, ie);
                  }
                  q.setActualNumPages(J.size);
                }
              }
              fontFallback(K, q) {
                return this.catalog.fontFallback(K, q);
              }
              async cleanup(K = !1) {
                return this.catalog ? this.catalog.cleanup(K) : (0, $.clearGlobalCaches)();
              }
              #e(K, q, Y, ee) {
                const Q = this.xref.fetchIfRef(q);
                if (Q.has("T")) {
                  const J = (0, g.stringToPDFString)(Q.get("T"));
                  K = K === "" ? J : `${K}.${J}`;
                }
                if (Y.has(K) || Y.set(K, []), Y.get(K).push(b.AnnotationFactory.create(this.xref, q, ee, this._localIdFactory, !0, null).then((J) => J?.getFieldObject()).catch(function(J) {
                  return (0, g.warn)(`#collectFieldObjects: "${J}".`), null;
                })), Q.has("Kids"))
                  for (const J of Q.get("Kids"))
                    this.#e(K, J, Y, ee);
              }
              get fieldObjects() {
                if (!this.formInfo.hasFields)
                  return (0, g.shadow)(this, "fieldObjects", Promise.resolve(null));
                const K = this.pdfManager.ensureDoc("annotationGlobals").then(async (q) => {
                  if (!q)
                    return null;
                  const Y = /* @__PURE__ */ Object.create(null), ee = /* @__PURE__ */ new Map();
                  for (const J of this.catalog.acroForm.get("Fields"))
                    this.#e("", J, ee, q);
                  const Q = [];
                  for (const [J, te] of ee)
                    Q.push(Promise.all(te).then((ae) => {
                      ae = ae.filter((se) => !!se), ae.length > 0 && (Y[J] = ae);
                    }));
                  return await Promise.all(Q), Y;
                });
                return (0, g.shadow)(this, "fieldObjects", K);
              }
              get hasJSActions() {
                const K = this.pdfManager.ensureDoc("_parseHasJSActions");
                return (0, g.shadow)(this, "hasJSActions", K);
              }
              async _parseHasJSActions() {
                const [K, q] = await Promise.all([this.pdfManager.ensureCatalog("jsActions"), this.pdfManager.ensureDoc("fieldObjects")]);
                return K ? !0 : q ? Object.values(q).some((Y) => Y.some((ee) => ee.actions !== null)) : !1;
              }
              get calculationOrderIds() {
                const K = this.catalog.acroForm;
                if (!K?.has("CO"))
                  return (0, g.shadow)(this, "calculationOrderIds", null);
                const q = K.get("CO");
                if (!Array.isArray(q) || q.length === 0)
                  return (0, g.shadow)(this, "calculationOrderIds", null);
                const Y = [];
                for (const ee of q)
                  ee instanceof f.Ref && Y.push(ee.toString());
                return Y.length === 0 ? (0, g.shadow)(this, "calculationOrderIds", null) : (0, g.shadow)(this, "calculationOrderIds", Y);
              }
              get annotationGlobals() {
                return (0, g.shadow)(this, "annotationGlobals", b.AnnotationFactory.createGlobals(this.pdfManager));
              }
            }
            A.PDFDocument = Z;
          },
          /* 10 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.PopupAnnotation = A.MarkupAnnotation = A.AnnotationFactory = A.AnnotationBorderStyle = A.Annotation = void 0, A.getQuadPoints = M;
            var g = x(2), b = x(3), y = x(11), f = x(4), m = x(8), C = x(5), w = x(60), S = x(66), $ = x(12), T = x(69), I = x(26), _ = x(76), E = x(64), R = x(73), O = x(77);
            class L {
              static createGlobals(le) {
                return Promise.all([le.ensureCatalog("acroForm"), le.ensureDoc("xfaDatasets"), le.ensureCatalog("structTreeRoot"), le.ensureCatalog("baseUrl"), le.ensureCatalog("attachments")]).then(([ve, he, ye, Ce, xe]) => ({
                  pdfManager: le,
                  acroForm: ve instanceof f.Dict ? ve : f.Dict.empty,
                  xfaDatasets: he,
                  structTreeRoot: ye,
                  baseUrl: Ce,
                  attachments: xe
                }), (ve) => ((0, g.warn)(`createGlobals: "${ve}".`), null));
              }
              static async create(le, ve, he, ye, Ce, xe) {
                const we = Ce ? await this._getPageIndex(le, ve, he.pdfManager) : null;
                return he.pdfManager.ensure(this, "_create", [le, ve, he, ye, Ce, we, xe]);
              }
              static _create(le, ve, he, ye, Ce = !1, xe = null, we = null) {
                const $e = le.fetchIfRef(ve);
                if (!($e instanceof f.Dict))
                  return;
                const {
                  acroForm: Ae,
                  pdfManager: ue
                } = he, ce = ve instanceof f.Ref ? ve.toString() : `annot_${ye.createObjId()}`;
                let Ee = $e.get("Subtype");
                Ee = Ee instanceof f.Name ? Ee.name : null;
                const _e = {
                  xref: le,
                  ref: ve,
                  dict: $e,
                  subtype: Ee,
                  id: ce,
                  annotationGlobals: he,
                  collectFields: Ce,
                  needAppearances: !Ce && Ae.get("NeedAppearances") === !0,
                  pageIndex: xe,
                  evaluatorOptions: ue.evaluatorOptions,
                  pageRef: we
                };
                switch (Ee) {
                  case "Link":
                    return new Z(_e);
                  case "Text":
                    return new V(_e);
                  case "Widget":
                    let Te = (0, b.getInheritableProperty)({
                      dict: $e,
                      key: "FT"
                    });
                    switch (Te = Te instanceof f.Name ? Te.name : null, Te) {
                      case "Tx":
                        return new N(_e);
                      case "Btn":
                        return new P(_e);
                      case "Ch":
                        return new D(_e);
                      case "Sig":
                        return new H(_e);
                    }
                    return (0, g.warn)(`Unimplemented widget field type "${Te}", falling back to base field type.`), new k(_e);
                  case "Popup":
                    return new ne(_e);
                  case "FreeText":
                    return new K(_e);
                  case "Line":
                    return new q(_e);
                  case "Square":
                    return new Y(_e);
                  case "Circle":
                    return new ee(_e);
                  case "PolyLine":
                    return new Q(_e);
                  case "Polygon":
                    return new J(_e);
                  case "Caret":
                    return new te(_e);
                  case "Ink":
                    return new ae(_e);
                  case "Highlight":
                    return new se(_e);
                  case "Underline":
                    return new ie(_e);
                  case "Squiggly":
                    return new fe(_e);
                  case "StrikeOut":
                    return new ge(_e);
                  case "Stamp":
                    return new me(_e);
                  case "FileAttachment":
                    return new pe(_e);
                  default:
                    return Ce || (Ee ? (0, g.warn)(`Unimplemented annotation type "${Ee}", falling back to base annotation.`) : (0, g.warn)("Annotation is missing the required /Subtype.")), new j(_e);
                }
              }
              static async _getPageIndex(le, ve, he) {
                try {
                  const ye = await le.fetchIfRefAsync(ve);
                  if (!(ye instanceof f.Dict))
                    return -1;
                  const Ce = ye.getRaw("P");
                  if (Ce instanceof f.Ref)
                    try {
                      return await he.ensureCatalog("getPageIndex", [Ce]);
                    } catch (we) {
                      (0, g.info)(`_getPageIndex -- not a valid page reference: "${we}".`);
                    }
                  if (ye.has("Kids"))
                    return -1;
                  const xe = await he.ensureDoc("numPages");
                  for (let we = 0; we < xe; we++) {
                    const $e = await he.getPage(we), Ae = await he.ensure($e, "annotations");
                    for (const ue of Ae)
                      if (ue instanceof f.Ref && (0, f.isRefsEqual)(ue, ve))
                        return we;
                  }
                } catch (ye) {
                  (0, g.warn)(`_getPageIndex: "${ye}".`);
                }
                return -1;
              }
              static generateImages(le, ve, he) {
                if (!he)
                  return (0, g.warn)("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images."), null;
                let ye;
                for (const {
                  bitmapId: Ce,
                  bitmap: xe
                } of le)
                  xe && (ye ||= /* @__PURE__ */ new Map(), ye.set(Ce, me.createImage(xe, ve)));
                return ye;
              }
              static async saveNewAnnotations(le, ve, he, ye) {
                const Ce = le.xref;
                let xe;
                const we = [], $e = [], {
                  isOffscreenCanvasSupported: Ae
                } = le.options;
                for (const ue of he)
                  if (!ue.deleted)
                    switch (ue.annotationType) {
                      case g.AnnotationEditorType.FREETEXT:
                        if (!xe) {
                          const Ee = new f.Dict(Ce);
                          Ee.set("BaseFont", f.Name.get("Helvetica")), Ee.set("Type", f.Name.get("Font")), Ee.set("Subtype", f.Name.get("Type1")), Ee.set("Encoding", f.Name.get("WinAnsiEncoding"));
                          const _e = [];
                          xe = Ce.getNewTemporaryRef(), await (0, R.writeObject)(xe, Ee, _e, Ce), we.push({
                            ref: xe,
                            data: _e.join("")
                          });
                        }
                        $e.push(K.createNewAnnotation(Ce, ue, we, {
                          evaluator: le,
                          task: ve,
                          baseFontRef: xe
                        }));
                        break;
                      case g.AnnotationEditorType.INK:
                        $e.push(ae.createNewAnnotation(Ce, ue, we));
                        break;
                      case g.AnnotationEditorType.STAMP:
                        if (!Ae)
                          break;
                        const ce = await ye.get(ue.bitmapId);
                        if (ce.imageStream) {
                          const {
                            imageStream: Ee,
                            smaskStream: _e
                          } = ce, Te = [];
                          if (_e) {
                            const Re = Ce.getNewTemporaryRef();
                            await (0, R.writeObject)(Re, _e, Te, Ce), we.push({
                              ref: Re,
                              data: Te.join("")
                            }), Ee.dict.set("SMask", Re), Te.length = 0;
                          }
                          const ke = ce.imageRef = Ce.getNewTemporaryRef();
                          await (0, R.writeObject)(ke, Ee, Te, Ce), we.push({
                            ref: ke,
                            data: Te.join("")
                          }), ce.imageStream = ce.smaskStream = null;
                        }
                        $e.push(me.createNewAnnotation(Ce, ue, we, {
                          image: ce
                        }));
                        break;
                    }
                return {
                  annotations: await Promise.all($e),
                  dependencies: we
                };
              }
              static async printNewAnnotations(le, ve, he, ye, Ce) {
                if (!ye)
                  return null;
                const {
                  options: xe,
                  xref: we
                } = ve, $e = [];
                for (const Ae of ye)
                  if (!Ae.deleted)
                    switch (Ae.annotationType) {
                      case g.AnnotationEditorType.FREETEXT:
                        $e.push(K.createNewPrintAnnotation(le, we, Ae, {
                          evaluator: ve,
                          task: he,
                          evaluatorOptions: xe
                        }));
                        break;
                      case g.AnnotationEditorType.INK:
                        $e.push(ae.createNewPrintAnnotation(le, we, Ae, {
                          evaluatorOptions: xe
                        }));
                        break;
                      case g.AnnotationEditorType.STAMP:
                        if (!xe.isOffscreenCanvasSupported)
                          break;
                        const ue = await Ce.get(Ae.bitmapId);
                        if (ue.imageStream) {
                          const {
                            imageStream: ce,
                            smaskStream: Ee
                          } = ue;
                          Ee && ce.dict.set("SMask", Ee), ue.imageRef = new I.JpegStream(ce, ce.length), ue.imageStream = ue.smaskStream = null;
                        }
                        $e.push(me.createNewPrintAnnotation(le, we, Ae, {
                          image: ue,
                          evaluatorOptions: xe
                        }));
                        break;
                    }
                return Promise.all($e);
              }
            }
            A.AnnotationFactory = L;
            function B(be, le = new Uint8ClampedArray(3)) {
              if (!Array.isArray(be))
                return le;
              const ve = le || new Uint8ClampedArray(3);
              switch (be.length) {
                case 0:
                  return null;
                case 1:
                  return $.ColorSpace.singletons.gray.getRgbItem(be, 0, ve, 0), ve;
                case 3:
                  return $.ColorSpace.singletons.rgb.getRgbItem(be, 0, ve, 0), ve;
                case 4:
                  return $.ColorSpace.singletons.cmyk.getRgbItem(be, 0, ve, 0), ve;
                default:
                  return le;
              }
            }
            function F(be) {
              return Array.from(be, (le) => le / 255);
            }
            function M(be, le) {
              const ve = be.getArray("QuadPoints");
              if (!Array.isArray(ve) || ve.length === 0 || ve.length % 8 > 0)
                return null;
              const he = [];
              for (let ye = 0, Ce = ve.length / 8; ye < Ce; ye++) {
                let xe = 1 / 0, we = -1 / 0, $e = 1 / 0, Ae = -1 / 0;
                for (let ue = ye * 8, ce = ye * 8 + 8; ue < ce; ue += 2) {
                  const Ee = ve[ue], _e = ve[ue + 1];
                  xe = Math.min(Ee, xe), we = Math.max(Ee, we), $e = Math.min(_e, $e), Ae = Math.max(_e, Ae);
                }
                if (le !== null && (xe < le[0] || we > le[2] || $e < le[1] || Ae > le[3]))
                  return null;
                he.push([{
                  x: xe,
                  y: Ae
                }, {
                  x: we,
                  y: Ae
                }, {
                  x: xe,
                  y: $e
                }, {
                  x: we,
                  y: $e
                }]);
              }
              return he;
            }
            function W(be, le, ve) {
              const [he, ye, Ce, xe] = g.Util.getAxialAlignedBoundingBox(le, ve);
              if (he === Ce || ye === xe)
                return [1, 0, 0, 1, be[0], be[1]];
              const we = (be[2] - be[0]) / (Ce - he), $e = (be[3] - be[1]) / (xe - ye);
              return [we, 0, 0, $e, be[0] - he * we, be[1] - ye * $e];
            }
            class j {
              constructor(le) {
                const {
                  dict: ve,
                  xref: he,
                  annotationGlobals: ye
                } = le;
                this.setTitle(ve.get("T")), this.setContents(ve.get("Contents")), this.setModificationDate(ve.get("M")), this.setFlags(ve.get("F")), this.setRectangle(ve.getArray("Rect")), this.setColor(ve.getArray("C")), this.setBorderStyle(ve), this.setAppearance(ve), this.setOptionalContent(ve);
                const Ce = ve.get("MK");
                this.setBorderAndBackgroundColors(Ce), this.setRotation(Ce, ve), this.ref = le.ref instanceof f.Ref ? le.ref : null, this._streams = [], this.appearance && this._streams.push(this.appearance);
                const xe = !!(this.flags & g.AnnotationFlag.LOCKED), we = !!(this.flags & g.AnnotationFlag.LOCKEDCONTENTS);
                if (ye.structTreeRoot) {
                  let $e = ve.get("StructParent");
                  $e = Number.isInteger($e) && $e >= 0 ? $e : -1, ye.structTreeRoot.addAnnotationIdToPage(le.pageRef, $e);
                }
                if (this.data = {
                  annotationFlags: this.flags,
                  borderStyle: this.borderStyle,
                  color: this.color,
                  backgroundColor: this.backgroundColor,
                  borderColor: this.borderColor,
                  rotation: this.rotation,
                  contentsObj: this._contents,
                  hasAppearance: !!this.appearance,
                  id: le.id,
                  modificationDate: this.modificationDate,
                  rect: this.rectangle,
                  subtype: le.subtype,
                  hasOwnCanvas: !1,
                  noRotate: !!(this.flags & g.AnnotationFlag.NOROTATE),
                  noHTML: xe && we
                }, le.collectFields) {
                  const $e = ve.get("Kids");
                  if (Array.isArray($e)) {
                    const Ae = [];
                    for (const ue of $e)
                      ue instanceof f.Ref && Ae.push(ue.toString());
                    Ae.length !== 0 && (this.data.kidIds = Ae);
                  }
                  this.data.actions = (0, b.collectActions)(he, ve, g.AnnotationActionEventType), this.data.fieldName = this._constructFieldName(ve), this.data.pageIndex = le.pageIndex;
                }
                this._isOffscreenCanvasSupported = le.evaluatorOptions.isOffscreenCanvasSupported, this._fallbackFontDict = null, this._needAppearances = !1;
              }
              _hasFlag(le, ve) {
                return !!(le & ve);
              }
              _isViewable(le) {
                return !this._hasFlag(le, g.AnnotationFlag.INVISIBLE) && !this._hasFlag(le, g.AnnotationFlag.NOVIEW);
              }
              _isPrintable(le) {
                return this._hasFlag(le, g.AnnotationFlag.PRINT) && !this._hasFlag(le, g.AnnotationFlag.HIDDEN) && !this._hasFlag(le, g.AnnotationFlag.INVISIBLE);
              }
              mustBeViewed(le, ve) {
                const he = le?.get(this.data.id)?.noView;
                return he !== void 0 ? !he : this.viewable && !this._hasFlag(this.flags, g.AnnotationFlag.HIDDEN);
              }
              mustBePrinted(le) {
                const ve = le?.get(this.data.id)?.noPrint;
                return ve !== void 0 ? !ve : this.printable;
              }
              get viewable() {
                return this.data.quadPoints === null ? !1 : this.flags === 0 ? !0 : this._isViewable(this.flags);
              }
              get printable() {
                return this.data.quadPoints === null || this.flags === 0 ? !1 : this._isPrintable(this.flags);
              }
              _parseStringHelper(le) {
                const ve = typeof le == "string" ? (0, g.stringToPDFString)(le) : "", he = ve && (0, w.bidi)(ve).dir === "rtl" ? "rtl" : "ltr";
                return {
                  str: ve,
                  dir: he
                };
              }
              setDefaultAppearance(le) {
                const {
                  dict: ve,
                  annotationGlobals: he
                } = le, ye = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "DA"
                }) || he.acroForm.get("DA");
                this._defaultAppearance = typeof ye == "string" ? ye : "", this.data.defaultAppearanceData = (0, y.parseDefaultAppearance)(this._defaultAppearance);
              }
              setTitle(le) {
                this._title = this._parseStringHelper(le);
              }
              setContents(le) {
                this._contents = this._parseStringHelper(le);
              }
              setModificationDate(le) {
                this.modificationDate = typeof le == "string" ? le : null;
              }
              setFlags(le) {
                this.flags = Number.isInteger(le) && le > 0 ? le : 0;
              }
              hasFlag(le) {
                return this._hasFlag(this.flags, le);
              }
              setRectangle(le) {
                this.rectangle = Array.isArray(le) && le.length === 4 ? g.Util.normalizeRect(le) : [0, 0, 0, 0];
              }
              setColor(le) {
                this.color = B(le);
              }
              setLineEndings(le) {
                if (this.lineEndings = ["None", "None"], Array.isArray(le) && le.length === 2)
                  for (let ve = 0; ve < 2; ve++) {
                    const he = le[ve];
                    if (he instanceof f.Name)
                      switch (he.name) {
                        case "None":
                          continue;
                        case "Square":
                        case "Circle":
                        case "Diamond":
                        case "OpenArrow":
                        case "ClosedArrow":
                        case "Butt":
                        case "ROpenArrow":
                        case "RClosedArrow":
                        case "Slash":
                          this.lineEndings[ve] = he.name;
                          continue;
                      }
                    (0, g.warn)(`Ignoring invalid lineEnding: ${he}`);
                  }
              }
              setRotation(le, ve) {
                this.rotation = 0;
                let he = le instanceof f.Dict ? le.get("R") || 0 : ve.get("Rotate") || 0;
                Number.isInteger(he) && he !== 0 && (he %= 360, he < 0 && (he += 360), he % 90 === 0 && (this.rotation = he));
              }
              setBorderAndBackgroundColors(le) {
                le instanceof f.Dict ? (this.borderColor = B(le.getArray("BC"), null), this.backgroundColor = B(le.getArray("BG"), null)) : this.borderColor = this.backgroundColor = null;
              }
              setBorderStyle(le) {
                if (this.borderStyle = new G(), le instanceof f.Dict)
                  if (le.has("BS")) {
                    const ve = le.get("BS"), he = ve.get("Type");
                    (!he || (0, f.isName)(he, "Border")) && (this.borderStyle.setWidth(ve.get("W"), this.rectangle), this.borderStyle.setStyle(ve.get("S")), this.borderStyle.setDashArray(ve.getArray("D")));
                  } else if (le.has("Border")) {
                    const ve = le.getArray("Border");
                    Array.isArray(ve) && ve.length >= 3 && (this.borderStyle.setHorizontalCornerRadius(ve[0]), this.borderStyle.setVerticalCornerRadius(ve[1]), this.borderStyle.setWidth(ve[2], this.rectangle), ve.length === 4 && this.borderStyle.setDashArray(ve[3], !0));
                  } else
                    this.borderStyle.setWidth(0);
              }
              setAppearance(le) {
                this.appearance = null;
                const ve = le.get("AP");
                if (!(ve instanceof f.Dict))
                  return;
                const he = ve.get("N");
                if (he instanceof C.BaseStream) {
                  this.appearance = he;
                  return;
                }
                if (!(he instanceof f.Dict))
                  return;
                const ye = le.get("AS");
                if (!(ye instanceof f.Name) || !he.has(ye.name))
                  return;
                const Ce = he.get(ye.name);
                Ce instanceof C.BaseStream && (this.appearance = Ce);
              }
              setOptionalContent(le) {
                this.oc = null;
                const ve = le.get("OC");
                ve instanceof f.Name ? (0, g.warn)("setOptionalContent: Support for /Name-entry is not implemented.") : ve instanceof f.Dict && (this.oc = ve);
              }
              loadResources(le, ve) {
                return ve.dict.getAsync("Resources").then((he) => he ? new _.ObjectLoader(he, le, he.xref).load().then(function() {
                  return he;
                }) : void 0);
              }
              async getOperatorList(le, ve, he, ye, Ce) {
                const xe = this.data;
                let we = this.appearance;
                const $e = !!(this.data.hasOwnCanvas && he & g.RenderingIntentFlag.DISPLAY);
                if (!we) {
                  if (!$e)
                    return {
                      opList: new E.OperatorList(),
                      separateForm: !1,
                      separateCanvas: !1
                    };
                  we = new m.StringStream(""), we.dict = new f.Dict();
                }
                const Ae = we.dict, ue = await this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"], we), ce = Ae.getArray("BBox") || [0, 0, 1, 1], Ee = Ae.getArray("Matrix") || [1, 0, 0, 1, 0, 0], _e = W(xe.rect, ce, Ee), Te = new E.OperatorList();
                let ke;
                return this.oc && (ke = await le.parseMarkedContentProps(this.oc, null)), ke !== void 0 && Te.addOp(g.OPS.beginMarkedContentProps, ["OC", ke]), Te.addOp(g.OPS.beginAnnotation, [xe.id, xe.rect, _e, Ee, $e]), await le.getOperatorList({
                  stream: we,
                  task: ve,
                  resources: ue,
                  operatorList: Te,
                  fallbackFontDict: this._fallbackFontDict
                }), Te.addOp(g.OPS.endAnnotation, []), ke !== void 0 && Te.addOp(g.OPS.endMarkedContent, []), this.reset(), {
                  opList: Te,
                  separateForm: !1,
                  separateCanvas: $e
                };
              }
              async save(le, ve, he) {
                return null;
              }
              get hasTextContent() {
                return !1;
              }
              async extractTextContent(le, ve, he) {
                if (!this.appearance)
                  return;
                const ye = await this.loadResources(["ExtGState", "Font", "Properties", "XObject"], this.appearance), Ce = [], xe = [];
                let we = null;
                const $e = {
                  desiredSize: Math.Infinity,
                  ready: !0,
                  enqueue(Ae, ue) {
                    for (const ce of Ae.items)
                      ce.str !== void 0 && (we ||= ce.transform.slice(-2), xe.push(ce.str), ce.hasEOL && (Ce.push(xe.join("")), xe.length = 0));
                  }
                };
                if (await le.getTextContent({
                  stream: this.appearance,
                  task: ve,
                  resources: ye,
                  includeMarkedContent: !0,
                  sink: $e,
                  viewBox: he
                }), this.reset(), xe.length && Ce.push(xe.join("")), Ce.length > 1 || Ce[0]) {
                  const Ae = this.appearance.dict, ue = Ae.getArray("BBox") || [0, 0, 1, 1], ce = Ae.getArray("Matrix") || [1, 0, 0, 1, 0, 0], Ee = this.data.rect, _e = W(Ee, ue, ce);
                  _e[4] -= Ee[0], _e[5] -= Ee[1], we = g.Util.applyTransform(we, _e), we = g.Util.applyTransform(we, ce), this.data.textPosition = we, this.data.textContent = Ce;
                }
              }
              getFieldObject() {
                return this.data.kidIds ? {
                  id: this.data.id,
                  actions: this.data.actions,
                  name: this.data.fieldName,
                  strokeColor: this.data.borderColor,
                  fillColor: this.data.backgroundColor,
                  type: "",
                  kidIds: this.data.kidIds,
                  page: this.data.pageIndex,
                  rotation: this.rotation
                } : null;
              }
              reset() {
                for (const le of this._streams)
                  le.reset();
              }
              _constructFieldName(le) {
                if (!le.has("T") && !le.has("Parent"))
                  return (0, g.warn)("Unknown field name, falling back to empty field name."), "";
                if (!le.has("Parent"))
                  return (0, g.stringToPDFString)(le.get("T"));
                const ve = [];
                le.has("T") && ve.unshift((0, g.stringToPDFString)(le.get("T")));
                let he = le;
                const ye = new f.RefSet();
                for (le.objId && ye.put(le.objId); he.has("Parent") && (he = he.get("Parent"), !(!(he instanceof f.Dict) || he.objId && ye.has(he.objId))); )
                  he.objId && ye.put(he.objId), he.has("T") && ve.unshift((0, g.stringToPDFString)(he.get("T")));
                return ve.join(".");
              }
            }
            A.Annotation = j;
            class G {
              constructor() {
                this.width = 1, this.style = g.AnnotationBorderStyleType.SOLID, this.dashArray = [3], this.horizontalCornerRadius = 0, this.verticalCornerRadius = 0;
              }
              setWidth(le, ve = [0, 0, 0, 0]) {
                if (le instanceof f.Name) {
                  this.width = 0;
                  return;
                }
                if (typeof le == "number") {
                  if (le > 0) {
                    const he = (ve[2] - ve[0]) / 2, ye = (ve[3] - ve[1]) / 2;
                    he > 0 && ye > 0 && (le > he || le > ye) && ((0, g.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${le}`), le = 1);
                  }
                  this.width = le;
                }
              }
              setStyle(le) {
                if (le instanceof f.Name)
                  switch (le.name) {
                    case "S":
                      this.style = g.AnnotationBorderStyleType.SOLID;
                      break;
                    case "D":
                      this.style = g.AnnotationBorderStyleType.DASHED;
                      break;
                    case "B":
                      this.style = g.AnnotationBorderStyleType.BEVELED;
                      break;
                    case "I":
                      this.style = g.AnnotationBorderStyleType.INSET;
                      break;
                    case "U":
                      this.style = g.AnnotationBorderStyleType.UNDERLINE;
                      break;
                  }
              }
              setDashArray(le, ve = !1) {
                if (Array.isArray(le) && le.length > 0) {
                  let he = !0, ye = !0;
                  for (const Ce of le)
                    if (+Ce >= 0)
                      Ce > 0 && (ye = !1);
                    else {
                      he = !1;
                      break;
                    }
                  he && !ye ? (this.dashArray = le, ve && this.setStyle(f.Name.get("D"))) : this.width = 0;
                } else le && (this.width = 0);
              }
              setHorizontalCornerRadius(le) {
                Number.isInteger(le) && (this.horizontalCornerRadius = le);
              }
              setVerticalCornerRadius(le) {
                Number.isInteger(le) && (this.verticalCornerRadius = le);
              }
            }
            A.AnnotationBorderStyle = G;
            class U extends j {
              constructor(le) {
                super(le);
                const {
                  dict: ve
                } = le;
                if (ve.has("IRT")) {
                  const ye = ve.getRaw("IRT");
                  this.data.inReplyTo = ye instanceof f.Ref ? ye.toString() : null;
                  const Ce = ve.get("RT");
                  this.data.replyType = Ce instanceof f.Name ? Ce.name : g.AnnotationReplyType.REPLY;
                }
                let he = null;
                if (this.data.replyType === g.AnnotationReplyType.GROUP) {
                  const ye = ve.get("IRT");
                  this.setTitle(ye.get("T")), this.data.titleObj = this._title, this.setContents(ye.get("Contents")), this.data.contentsObj = this._contents, ye.has("CreationDate") ? (this.setCreationDate(ye.get("CreationDate")), this.data.creationDate = this.creationDate) : this.data.creationDate = null, ye.has("M") ? (this.setModificationDate(ye.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, he = ye.getRaw("Popup"), ye.has("C") ? (this.setColor(ye.getArray("C")), this.data.color = this.color) : this.data.color = null;
                } else
                  this.data.titleObj = this._title, this.setCreationDate(ve.get("CreationDate")), this.data.creationDate = this.creationDate, he = ve.getRaw("Popup"), ve.has("C") || (this.data.color = null);
                this.data.popupRef = he instanceof f.Ref ? he.toString() : null, ve.has("RC") && (this.data.richText = O.XFAFactory.getRichTextAsHtml(ve.get("RC")));
              }
              setCreationDate(le) {
                this.creationDate = typeof le == "string" ? le : null;
              }
              _setDefaultAppearance({
                xref: le,
                extra: ve,
                strokeColor: he,
                fillColor: ye,
                blendMode: Ce,
                strokeAlpha: xe,
                fillAlpha: we,
                pointsCallback: $e
              }) {
                let Ae = Number.MAX_VALUE, ue = Number.MAX_VALUE, ce = Number.MIN_VALUE, Ee = Number.MIN_VALUE;
                const _e = ["q"];
                ve && _e.push(ve), he && _e.push(`${he[0]} ${he[1]} ${he[2]} RG`), ye && _e.push(`${ye[0]} ${ye[1]} ${ye[2]} rg`);
                let Te = this.data.quadPoints;
                Te || (Te = [[{
                  x: this.rectangle[0],
                  y: this.rectangle[3]
                }, {
                  x: this.rectangle[2],
                  y: this.rectangle[3]
                }, {
                  x: this.rectangle[0],
                  y: this.rectangle[1]
                }, {
                  x: this.rectangle[2],
                  y: this.rectangle[1]
                }]]);
                for (const Le of Te) {
                  const [De, Ne, Ge, Xe] = $e(_e, Le);
                  Ae = Math.min(Ae, De), ce = Math.max(ce, Ne), ue = Math.min(ue, Ge), Ee = Math.max(Ee, Xe);
                }
                _e.push("Q");
                const ke = new f.Dict(le), Re = new f.Dict(le);
                Re.set("Subtype", f.Name.get("Form"));
                const Be = new m.StringStream(_e.join(" "));
                Be.dict = Re, ke.set("Fm0", Be);
                const Oe = new f.Dict(le);
                Ce && Oe.set("BM", f.Name.get(Ce)), typeof xe == "number" && Oe.set("CA", xe), typeof we == "number" && Oe.set("ca", we);
                const Me = new f.Dict(le);
                Me.set("GS0", Oe);
                const Fe = new f.Dict(le);
                Fe.set("ExtGState", Me), Fe.set("XObject", ke);
                const Ue = new f.Dict(le);
                Ue.set("Resources", Fe);
                const je = this.data.rect = [Ae, ue, ce, Ee];
                Ue.set("BBox", je), this.appearance = new m.StringStream("/GS0 gs /Fm0 Do"), this.appearance.dict = Ue, this._streams.push(this.appearance, Be);
              }
              static async createNewAnnotation(le, ve, he, ye) {
                const Ce = ve.ref ||= le.getNewTemporaryRef(), xe = await this.createNewAppearanceStream(ve, le, ye), we = [];
                let $e;
                if (xe) {
                  const Ae = le.getNewTemporaryRef();
                  $e = this.createNewDict(ve, le, {
                    apRef: Ae
                  }), await (0, R.writeObject)(Ae, xe, we, le), he.push({
                    ref: Ae,
                    data: we.join("")
                  });
                } else
                  $e = this.createNewDict(ve, le, {});
                return Number.isInteger(ve.parentTreeId) && $e.set("StructParent", ve.parentTreeId), we.length = 0, await (0, R.writeObject)(Ce, $e, we, le), {
                  ref: Ce,
                  data: we.join("")
                };
              }
              static async createNewPrintAnnotation(le, ve, he, ye) {
                const Ce = await this.createNewAppearanceStream(he, ve, ye), xe = this.createNewDict(he, ve, {
                  ap: Ce
                }), we = new this.prototype.constructor({
                  dict: xe,
                  xref: ve,
                  annotationGlobals: le,
                  evaluatorOptions: ye.evaluatorOptions
                });
                return he.ref && (we.ref = we.refToReplace = he.ref), we;
              }
            }
            A.MarkupAnnotation = U;
            class k extends j {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he,
                  annotationGlobals: ye
                } = le, Ce = this.data;
                this._needAppearances = le.needAppearances, Ce.annotationType = g.AnnotationType.WIDGET, Ce.fieldName === void 0 && (Ce.fieldName = this._constructFieldName(ve)), Ce.actions === void 0 && (Ce.actions = (0, b.collectActions)(he, ve, g.AnnotationActionEventType));
                let xe = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "V",
                  getArray: !0
                });
                Ce.fieldValue = this._decodeFormValue(xe);
                const we = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "DV",
                  getArray: !0
                });
                if (Ce.defaultFieldValue = this._decodeFormValue(we), xe === void 0 && ye.xfaDatasets) {
                  const Ee = this._title.str;
                  Ee && (this._hasValueFromXFA = !0, Ce.fieldValue = xe = ye.xfaDatasets.getValue(Ee));
                }
                xe === void 0 && Ce.defaultFieldValue !== null && (Ce.fieldValue = Ce.defaultFieldValue), Ce.alternativeText = (0, g.stringToPDFString)(ve.get("TU") || ""), this.setDefaultAppearance(le), Ce.hasAppearance ||= this._needAppearances && Ce.fieldValue !== void 0 && Ce.fieldValue !== null;
                const $e = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "FT"
                });
                Ce.fieldType = $e instanceof f.Name ? $e.name : null;
                const Ae = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "DR"
                }), ue = ye.acroForm.get("DR"), ce = this.appearance?.dict.get("Resources");
                this._fieldResources = {
                  localResources: Ae,
                  acroFormResources: ue,
                  appearanceResources: ce,
                  mergedResources: f.Dict.merge({
                    xref: he,
                    dictArray: [Ae, ce, ue],
                    mergeSubDicts: !0
                  })
                }, Ce.fieldFlags = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "Ff"
                }), (!Number.isInteger(Ce.fieldFlags) || Ce.fieldFlags < 0) && (Ce.fieldFlags = 0), Ce.readOnly = this.hasFieldFlag(g.AnnotationFieldFlag.READONLY), Ce.required = this.hasFieldFlag(g.AnnotationFieldFlag.REQUIRED), Ce.hidden = this._hasFlag(Ce.annotationFlags, g.AnnotationFlag.HIDDEN) || this._hasFlag(Ce.annotationFlags, g.AnnotationFlag.NOVIEW);
              }
              _decodeFormValue(le) {
                return Array.isArray(le) ? le.filter((ve) => typeof ve == "string").map((ve) => (0, g.stringToPDFString)(ve)) : le instanceof f.Name ? (0, g.stringToPDFString)(le.name) : typeof le == "string" ? (0, g.stringToPDFString)(le) : null;
              }
              hasFieldFlag(le) {
                return !!(this.data.fieldFlags & le);
              }
              _isViewable(le) {
                return !this._hasFlag(le, g.AnnotationFlag.INVISIBLE);
              }
              mustBeViewed(le, ve) {
                return ve ? this.viewable : super.mustBeViewed(le, ve) && !this._hasFlag(this.flags, g.AnnotationFlag.NOVIEW);
              }
              getRotationMatrix(le) {
                let ve = le?.get(this.data.id)?.rotation;
                if (ve === void 0 && (ve = this.rotation), ve === 0)
                  return g.IDENTITY_MATRIX;
                const he = this.data.rect[2] - this.data.rect[0], ye = this.data.rect[3] - this.data.rect[1];
                return (0, b.getRotationMatrix)(ve, he, ye);
              }
              getBorderAndBackgroundAppearances(le) {
                let ve = le?.get(this.data.id)?.rotation;
                if (ve === void 0 && (ve = this.rotation), !this.backgroundColor && !this.borderColor)
                  return "";
                const he = this.data.rect[2] - this.data.rect[0], ye = this.data.rect[3] - this.data.rect[1], Ce = ve === 0 || ve === 180 ? `0 0 ${he} ${ye} re` : `0 0 ${ye} ${he} re`;
                let xe = "";
                if (this.backgroundColor && (xe = `${(0, y.getPdfColor)(this.backgroundColor, !0)} ${Ce} f `), this.borderColor) {
                  const we = this.borderStyle.width || 1;
                  xe += `${we} w ${(0, y.getPdfColor)(this.borderColor, !1)} ${Ce} S `;
                }
                return xe;
              }
              async getOperatorList(le, ve, he, ye, Ce) {
                if (ye && !(this instanceof H) && !this.data.noHTML && !this.data.hasOwnCanvas)
                  return {
                    opList: new E.OperatorList(),
                    separateForm: !0,
                    separateCanvas: !1
                  };
                if (!this._hasText)
                  return super.getOperatorList(le, ve, he, ye, Ce);
                const xe = await this._getAppearance(le, ve, he, Ce);
                if (this.appearance && xe === null)
                  return super.getOperatorList(le, ve, he, ye, Ce);
                const we = new E.OperatorList();
                if (!this._defaultAppearance || xe === null)
                  return {
                    opList: we,
                    separateForm: !1,
                    separateCanvas: !1
                  };
                const $e = !!(this.data.hasOwnCanvas && he & g.RenderingIntentFlag.DISPLAY), Ae = [1, 0, 0, 1, 0, 0], ue = [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]], ce = W(this.data.rect, ue, Ae);
                let Ee;
                this.oc && (Ee = await le.parseMarkedContentProps(this.oc, null)), Ee !== void 0 && we.addOp(g.OPS.beginMarkedContentProps, ["OC", Ee]), we.addOp(g.OPS.beginAnnotation, [this.data.id, this.data.rect, ce, this.getRotationMatrix(Ce), $e]);
                const _e = new m.StringStream(xe);
                return await le.getOperatorList({
                  stream: _e,
                  task: ve,
                  resources: this._fieldResources.mergedResources,
                  operatorList: we
                }), we.addOp(g.OPS.endAnnotation, []), Ee !== void 0 && we.addOp(g.OPS.endMarkedContent, []), {
                  opList: we,
                  separateForm: !1,
                  separateCanvas: $e
                };
              }
              _getMKDict(le) {
                const ve = new f.Dict(null);
                return le && ve.set("R", le), this.borderColor && ve.set("BC", F(this.borderColor)), this.backgroundColor && ve.set("BG", F(this.backgroundColor)), ve.size > 0 ? ve : null;
              }
              amendSavedDict(le, ve) {
              }
              async save(le, ve, he) {
                const ye = he?.get(this.data.id);
                let Ce = ye?.value, xe = ye?.rotation;
                if (Ce === this.data.fieldValue || Ce === void 0) {
                  if (!this._hasValueFromXFA && xe === void 0)
                    return null;
                  Ce ||= this.data.fieldValue;
                }
                if (xe === void 0 && !this._hasValueFromXFA && Array.isArray(Ce) && Array.isArray(this.data.fieldValue) && Ce.length === this.data.fieldValue.length && Ce.every((Be, Oe) => Be === this.data.fieldValue[Oe]))
                  return null;
                xe === void 0 && (xe = this.rotation);
                let we = null;
                if (!this._needAppearances && (we = await this._getAppearance(le, ve, g.RenderingIntentFlag.SAVE, he), we === null))
                  return null;
                let $e = !1;
                we?.needAppearances && ($e = !0, we = null);
                const {
                  xref: Ae
                } = le, ue = Ae.fetchIfRef(this.ref);
                if (!(ue instanceof f.Dict))
                  return null;
                const ce = new f.Dict(Ae);
                for (const Be of ue.getKeys())
                  Be !== "AP" && ce.set(Be, ue.getRaw(Be));
                const Ee = {
                  path: this.data.fieldName,
                  value: Ce
                }, _e = (Be) => (0, b.isAscii)(Be) ? Be : (0, b.stringToUTF16String)(Be, !0);
                ce.set("V", Array.isArray(Ce) ? Ce.map(_e) : _e(Ce)), this.amendSavedDict(he, ce);
                const Te = this._getMKDict(xe);
                Te && ce.set("MK", Te);
                const ke = [], Re = [{
                  ref: this.ref,
                  data: "",
                  xfa: Ee,
                  needAppearances: $e
                }];
                if (we !== null) {
                  const Be = Ae.getNewTemporaryRef(), Oe = new f.Dict(Ae);
                  ce.set("AP", Oe), Oe.set("N", Be);
                  const Me = this._getSaveFieldResources(Ae), Fe = new m.StringStream(we), Ue = Fe.dict = new f.Dict(Ae);
                  Ue.set("Subtype", f.Name.get("Form")), Ue.set("Resources", Me), Ue.set("BBox", [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]]);
                  const je = this.getRotationMatrix(he);
                  je !== g.IDENTITY_MATRIX && Ue.set("Matrix", je), await (0, R.writeObject)(Be, Fe, ke, Ae), Re.push({
                    ref: Be,
                    data: ke.join(""),
                    xfa: null,
                    needAppearances: !1
                  }), ke.length = 0;
                }
                return ce.set("M", `D:${(0, g.getModificationDate)()}`), await (0, R.writeObject)(this.ref, ce, ke, Ae), Re[0].data = ke.join(""), Re;
              }
              async _getAppearance(le, ve, he, ye) {
                if (this.hasFieldFlag(g.AnnotationFieldFlag.PASSWORD))
                  return null;
                const xe = ye?.get(this.data.id);
                let we, $e;
                if (xe && (we = xe.formattedValue || xe.value, $e = xe.rotation), $e === void 0 && we === void 0 && !this._needAppearances && (!this._hasValueFromXFA || this.appearance))
                  return null;
                const Ae = this.getBorderAndBackgroundAppearances(ye);
                if (we === void 0 && (we = this.data.fieldValue, !we))
                  return `/Tx BMC q ${Ae}Q EMC`;
                if (Array.isArray(we) && we.length === 1 && (we = we[0]), (0, g.assert)(typeof we == "string", "Expected `value` to be a string."), we = we.trim(), this.data.combo && (we = this.data.options.find(({
                  exportValue: ct
                }) => we === ct)?.displayValue || we), we === "")
                  return `/Tx BMC q ${Ae}Q EMC`;
                $e === void 0 && ($e = this.rotation);
                let ue = -1, ce;
                this.data.multiLine ? (ce = we.split(/\r\n?|\n/).map((nt) => nt.normalize("NFC")), ue = ce.length) : ce = [we.replace(/\r\n?|\n/, "").normalize("NFC")];
                const Ee = 1, _e = 2;
                let Te = this.data.rect[3] - this.data.rect[1], ke = this.data.rect[2] - this.data.rect[0];
                ($e === 90 || $e === 270) && ([ke, Te] = [Te, ke]), this._defaultAppearance || (this.data.defaultAppearanceData = (0, y.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
                let Re = await k._getFontData(le, ve, this.data.defaultAppearanceData, this._fieldResources.mergedResources), Be, Oe, Me;
                const Fe = [];
                let Ue = !1;
                for (const nt of ce) {
                  const ct = Re.encodeString(nt);
                  ct.length > 1 && (Ue = !0), Fe.push(ct.join(""));
                }
                if (Ue && he & g.RenderingIntentFlag.SAVE)
                  return {
                    needAppearances: !0
                  };
                if (Ue && this._isOffscreenCanvasSupported) {
                  const nt = this.data.comb ? "monospace" : "sans-serif", ct = new y.FakeUnicodeFont(le.xref, nt), it = ct.createFontResources(ce.join("")), We = it.getRaw("Font");
                  if (this._fieldResources.mergedResources.has("Font")) {
                    const at = this._fieldResources.mergedResources.get("Font");
                    for (const Qe of We.getKeys())
                      at.set(Qe, We.getRaw(Qe));
                  } else
                    this._fieldResources.mergedResources.set("Font", We);
                  const Ve = ct.fontName.name;
                  Re = await k._getFontData(le, ve, {
                    fontName: Ve,
                    fontSize: 0
                  }, it);
                  for (let at = 0, Qe = Fe.length; at < Qe; at++)
                    Fe[at] = (0, b.stringToUTF16String)(ce[at]);
                  const ut = Object.assign(/* @__PURE__ */ Object.create(null), this.data.defaultAppearanceData);
                  this.data.defaultAppearanceData.fontSize = 0, this.data.defaultAppearanceData.fontName = Ve, [Be, Oe, Me] = this._computeFontSize(Te - 2 * Ee, ke - 2 * _e, we, Re, ue), this.data.defaultAppearanceData = ut;
                } else
                  this._isOffscreenCanvasSupported || (0, g.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly."), [Be, Oe, Me] = this._computeFontSize(Te - 2 * Ee, ke - 2 * _e, we, Re, ue);
                let je = Re.descent;
                isNaN(je) ? je = g.BASELINE_FACTOR * Me : je = Math.max(g.BASELINE_FACTOR * Me, Math.abs(je) * Oe);
                const Le = Math.min(Math.floor((Te - Oe) / 2), Ee), De = this.data.textAlignment;
                if (this.data.multiLine)
                  return this._getMultilineAppearance(Be, Fe, Re, Oe, ke, Te, De, _e, Le, je, Me, ye);
                if (this.data.comb)
                  return this._getCombAppearance(Be, Re, Fe[0], Oe, ke, Te, _e, Le, je, Me, ye);
                const Ne = Le + je;
                if (De === 0 || De > 2)
                  return `/Tx BMC q ${Ae}BT ` + Be + ` 1 0 0 1 ${(0, b.numberToString)(_e)} ${(0, b.numberToString)(Ne)} Tm (${(0, b.escapeString)(Fe[0])}) Tj ET Q EMC`;
                const Ge = {
                  shift: 0
                }, Xe = this._renderText(Fe[0], Re, Oe, ke, De, Ge, _e, Ne);
                return `/Tx BMC q ${Ae}BT ` + Be + ` 1 0 0 1 0 0 Tm ${Xe} ET Q EMC`;
              }
              static async _getFontData(le, ve, he, ye) {
                const Ce = new E.OperatorList(), xe = {
                  font: null,
                  clone() {
                    return this;
                  }
                }, {
                  fontName: we,
                  fontSize: $e
                } = he;
                return await le.handleSetFont(ye, [we && f.Name.get(we), $e], null, Ce, ve, xe, null), xe.font;
              }
              _getTextWidth(le, ve) {
                return ve.charsToGlyphs(le).reduce((he, ye) => he + ye.width, 0) / 1e3;
              }
              _computeFontSize(le, ve, he, ye, Ce) {
                let {
                  fontSize: xe
                } = this.data.defaultAppearanceData, we = (xe || 12) * g.LINE_FACTOR, $e = Math.round(le / we);
                if (!xe) {
                  const Ae = (Ee) => Math.floor(Ee * 100) / 100;
                  if (Ce === -1) {
                    const Ee = this._getTextWidth(he, ye);
                    xe = Ae(Math.min(le / g.LINE_FACTOR, Ee > ve ? ve / Ee : 1 / 0)), $e = 1;
                  } else {
                    const Ee = he.split(/\r\n?|\n/), _e = [];
                    for (const ke of Ee) {
                      const Re = ye.encodeString(ke).join(""), Be = ye.charsToGlyphs(Re), Oe = ye.getCharPositions(Re);
                      _e.push({
                        line: Re,
                        glyphs: Be,
                        positions: Oe
                      });
                    }
                    const Te = (ke) => {
                      let Re = 0;
                      for (const Be of _e) {
                        const Oe = this._splitLine(null, ye, ke, ve, Be);
                        if (Re += Oe.length * ke, Re > le)
                          return !0;
                      }
                      return !1;
                    };
                    for ($e = Math.max($e, Ce); ; ) {
                      if (we = le / $e, xe = Ae(we / g.LINE_FACTOR), Te(xe)) {
                        $e++;
                        continue;
                      }
                      break;
                    }
                  }
                  const {
                    fontName: ue,
                    fontColor: ce
                  } = this.data.defaultAppearanceData;
                  this._defaultAppearance = (0, y.createDefaultAppearance)({
                    fontSize: xe,
                    fontName: ue,
                    fontColor: ce
                  });
                }
                return [this._defaultAppearance, xe, le / $e];
              }
              _renderText(le, ve, he, ye, Ce, xe, we, $e) {
                let Ae;
                if (Ce === 1) {
                  const ce = this._getTextWidth(le, ve) * he;
                  Ae = (ye - ce) / 2;
                } else if (Ce === 2) {
                  const ce = this._getTextWidth(le, ve) * he;
                  Ae = ye - ce - we;
                } else
                  Ae = we;
                const ue = (0, b.numberToString)(Ae - xe.shift);
                return xe.shift = Ae, $e = (0, b.numberToString)($e), `${ue} ${$e} Td (${(0, b.escapeString)(le)}) Tj`;
              }
              _getSaveFieldResources(le) {
                const {
                  localResources: ve,
                  appearanceResources: he,
                  acroFormResources: ye
                } = this._fieldResources, Ce = this.data.defaultAppearanceData?.fontName;
                if (!Ce)
                  return ve || f.Dict.empty;
                for (const xe of [ve, he])
                  if (xe instanceof f.Dict) {
                    const we = xe.get("Font");
                    if (we instanceof f.Dict && we.has(Ce))
                      return xe;
                  }
                if (ye instanceof f.Dict) {
                  const xe = ye.get("Font");
                  if (xe instanceof f.Dict && xe.has(Ce)) {
                    const we = new f.Dict(le);
                    we.set(Ce, xe.getRaw(Ce));
                    const $e = new f.Dict(le);
                    return $e.set("Font", we), f.Dict.merge({
                      xref: le,
                      dictArray: [$e, ve],
                      mergeSubDicts: !0
                    });
                  }
                }
                return ve || f.Dict.empty;
              }
              getFieldObject() {
                return null;
              }
            }
            class N extends k {
              constructor(le) {
                super(le), this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML, this._hasText = !0;
                const ve = le.dict;
                typeof this.data.fieldValue != "string" && (this.data.fieldValue = "");
                let he = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "Q"
                });
                (!Number.isInteger(he) || he < 0 || he > 2) && (he = null), this.data.textAlignment = he;
                let ye = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "MaxLen"
                });
                (!Number.isInteger(ye) || ye < 0) && (ye = 0), this.data.maxLen = ye, this.data.multiLine = this.hasFieldFlag(g.AnnotationFieldFlag.MULTILINE), this.data.comb = this.hasFieldFlag(g.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(g.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(g.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(g.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== 0, this.data.doNotScroll = this.hasFieldFlag(g.AnnotationFieldFlag.DONOTSCROLL);
              }
              get hasTextContent() {
                return !!this.appearance && !this._needAppearances;
              }
              _getCombAppearance(le, ve, he, ye, Ce, xe, we, $e, Ae, ue, ce) {
                const Ee = Ce / this.data.maxLen, _e = this.getBorderAndBackgroundAppearances(ce), Te = [], ke = ve.getCharPositions(he);
                for (const [Be, Oe] of ke)
                  Te.push(`(${(0, b.escapeString)(he.substring(Be, Oe))}) Tj`);
                const Re = Te.join(` ${(0, b.numberToString)(Ee)} 0 Td `);
                return `/Tx BMC q ${_e}BT ` + le + ` 1 0 0 1 ${(0, b.numberToString)(we)} ${(0, b.numberToString)($e + Ae)} Tm ${Re} ET Q EMC`;
              }
              _getMultilineAppearance(le, ve, he, ye, Ce, xe, we, $e, Ae, ue, ce, Ee) {
                const _e = [], Te = Ce - 2 * $e, ke = {
                  shift: 0
                };
                for (let Oe = 0, Me = ve.length; Oe < Me; Oe++) {
                  const Fe = ve[Oe], Ue = this._splitLine(Fe, he, ye, Te);
                  for (let je = 0, Le = Ue.length; je < Le; je++) {
                    const De = Ue[je], Ne = Oe === 0 && je === 0 ? -Ae - (ce - ue) : -ce;
                    _e.push(this._renderText(De, he, ye, Ce, we, ke, $e, Ne));
                  }
                }
                const Re = this.getBorderAndBackgroundAppearances(Ee), Be = _e.join(`
`);
                return `/Tx BMC q ${Re}BT ` + le + ` 1 0 0 1 0 ${(0, b.numberToString)(xe)} Tm ${Be} ET Q EMC`;
              }
              _splitLine(le, ve, he, ye, Ce = {}) {
                le = Ce.line || le;
                const xe = Ce.glyphs || ve.charsToGlyphs(le);
                if (xe.length <= 1)
                  return [le];
                const we = Ce.positions || ve.getCharPositions(le), $e = he / 1e3, Ae = [];
                let ue = -1, ce = -1, Ee = -1, _e = 0, Te = 0;
                for (let ke = 0, Re = xe.length; ke < Re; ke++) {
                  const [Be, Oe] = we[ke], Me = xe[ke], Fe = Me.width * $e;
                  Me.unicode === " " ? Te + Fe > ye ? (Ae.push(le.substring(_e, Be)), _e = Be, Te = Fe, ue = -1, Ee = -1) : (Te += Fe, ue = Be, ce = Oe, Ee = ke) : Te + Fe > ye ? ue !== -1 ? (Ae.push(le.substring(_e, ce)), _e = ce, ke = Ee + 1, ue = -1, Te = 0) : (Ae.push(le.substring(_e, Be)), _e = Be, Te = Fe) : Te += Fe;
                }
                return _e < le.length && Ae.push(le.substring(_e, le.length)), Ae;
              }
              getFieldObject() {
                return {
                  id: this.data.id,
                  value: this.data.fieldValue,
                  defaultValue: this.data.defaultFieldValue || "",
                  multiline: this.data.multiLine,
                  password: this.hasFieldFlag(g.AnnotationFieldFlag.PASSWORD),
                  charLimit: this.data.maxLen,
                  comb: this.data.comb,
                  editable: !this.data.readOnly,
                  hidden: this.data.hidden,
                  name: this.data.fieldName,
                  rect: this.data.rect,
                  actions: this.data.actions,
                  page: this.data.pageIndex,
                  strokeColor: this.data.borderColor,
                  fillColor: this.data.backgroundColor,
                  rotation: this.rotation,
                  type: "text"
                };
              }
            }
            class P extends k {
              constructor(le) {
                super(le), this.checkedAppearance = null, this.uncheckedAppearance = null, this.data.checkBox = !this.hasFieldFlag(g.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(g.AnnotationFieldFlag.PUSHBUTTON), this.data.radioButton = this.hasFieldFlag(g.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(g.AnnotationFieldFlag.PUSHBUTTON), this.data.pushButton = this.hasFieldFlag(g.AnnotationFieldFlag.PUSHBUTTON), this.data.isTooltipOnly = !1, this.data.checkBox ? this._processCheckBox(le) : this.data.radioButton ? this._processRadioButton(le) : this.data.pushButton ? (this.data.hasOwnCanvas = !0, this._processPushButton(le)) : (0, g.warn)("Invalid field flags for button widget annotation");
              }
              async getOperatorList(le, ve, he, ye, Ce) {
                if (this.data.pushButton)
                  return super.getOperatorList(le, ve, he, !1, Ce);
                let xe = null, we = null;
                if (Ce) {
                  const Ae = Ce.get(this.data.id);
                  xe = Ae ? Ae.value : null, we = Ae ? Ae.rotation : null;
                }
                if (xe === null && this.appearance)
                  return super.getOperatorList(le, ve, he, ye, Ce);
                xe == null && (xe = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue);
                const $e = xe ? this.checkedAppearance : this.uncheckedAppearance;
                if ($e) {
                  const Ae = this.appearance, ue = $e.dict.getArray("Matrix") || g.IDENTITY_MATRIX;
                  we && $e.dict.set("Matrix", this.getRotationMatrix(Ce)), this.appearance = $e;
                  const ce = super.getOperatorList(le, ve, he, ye, Ce);
                  return this.appearance = Ae, $e.dict.set("Matrix", ue), ce;
                }
                return {
                  opList: new E.OperatorList(),
                  separateForm: !1,
                  separateCanvas: !1
                };
              }
              async save(le, ve, he) {
                return this.data.checkBox ? this._saveCheckbox(le, ve, he) : this.data.radioButton ? this._saveRadioButton(le, ve, he) : null;
              }
              async _saveCheckbox(le, ve, he) {
                if (!he)
                  return null;
                const ye = he.get(this.data.id);
                let Ce = ye?.rotation, xe = ye?.value;
                if (Ce === void 0 && (xe === void 0 || this.data.fieldValue === this.data.exportValue === xe))
                  return null;
                const we = le.xref.fetchIfRef(this.ref);
                if (!(we instanceof f.Dict))
                  return null;
                Ce === void 0 && (Ce = this.rotation), xe === void 0 && (xe = this.data.fieldValue === this.data.exportValue);
                const $e = {
                  path: this.data.fieldName,
                  value: xe ? this.data.exportValue : ""
                }, Ae = f.Name.get(xe ? this.data.exportValue : "Off");
                we.set("V", Ae), we.set("AS", Ae), we.set("M", `D:${(0, g.getModificationDate)()}`);
                const ue = this._getMKDict(Ce);
                ue && we.set("MK", ue);
                const ce = [];
                return await (0, R.writeObject)(this.ref, we, ce, le.xref), [{
                  ref: this.ref,
                  data: ce.join(""),
                  xfa: $e
                }];
              }
              async _saveRadioButton(le, ve, he) {
                if (!he)
                  return null;
                const ye = he.get(this.data.id);
                let Ce = ye?.rotation, xe = ye?.value;
                if (Ce === void 0 && (xe === void 0 || this.data.fieldValue === this.data.buttonValue === xe))
                  return null;
                const we = le.xref.fetchIfRef(this.ref);
                if (!(we instanceof f.Dict))
                  return null;
                xe === void 0 && (xe = this.data.fieldValue === this.data.buttonValue), Ce === void 0 && (Ce = this.rotation);
                const $e = {
                  path: this.data.fieldName,
                  value: xe ? this.data.buttonValue : ""
                }, Ae = f.Name.get(xe ? this.data.buttonValue : "Off"), ue = [];
                let ce = null;
                if (xe)
                  if (this.parent instanceof f.Ref) {
                    const Te = le.xref.fetch(this.parent);
                    Te.set("V", Ae), await (0, R.writeObject)(this.parent, Te, ue, le.xref), ce = ue.join(""), ue.length = 0;
                  } else this.parent instanceof f.Dict && this.parent.set("V", Ae);
                we.set("AS", Ae), we.set("M", `D:${(0, g.getModificationDate)()}`);
                const Ee = this._getMKDict(Ce);
                Ee && we.set("MK", Ee), await (0, R.writeObject)(this.ref, we, ue, le.xref);
                const _e = [{
                  ref: this.ref,
                  data: ue.join(""),
                  xfa: $e
                }];
                return ce && _e.push({
                  ref: this.parent,
                  data: ce,
                  xfa: null
                }), _e;
              }
              _getDefaultCheckedAppearance(le, ve) {
                const he = this.data.rect[2] - this.data.rect[0], ye = this.data.rect[3] - this.data.rect[1], Ce = [0, 0, he, ye], we = Math.min(he, ye) * 0.8;
                let $e, Ae;
                ve === "check" ? ($e = {
                  width: 0.755 * we,
                  height: 0.705 * we
                }, Ae = "3") : ve === "disc" ? ($e = {
                  width: 0.791 * we,
                  height: 0.705 * we
                }, Ae = "l") : (0, g.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${ve}`);
                const ue = (0, b.numberToString)((he - $e.width) / 2), ce = (0, b.numberToString)((ye - $e.height) / 2), Ee = `q BT /PdfJsZaDb ${we} Tf 0 g ${ue} ${ce} Td (${Ae}) Tj ET Q`, _e = new f.Dict(le.xref);
                _e.set("FormType", 1), _e.set("Subtype", f.Name.get("Form")), _e.set("Type", f.Name.get("XObject")), _e.set("BBox", Ce), _e.set("Matrix", [1, 0, 0, 1, 0, 0]), _e.set("Length", Ee.length);
                const Te = new f.Dict(le.xref), ke = new f.Dict(le.xref);
                ke.set("PdfJsZaDb", this.fallbackFontDict), Te.set("Font", ke), _e.set("Resources", Te), this.checkedAppearance = new m.StringStream(Ee), this.checkedAppearance.dict = _e, this._streams.push(this.checkedAppearance);
              }
              _processCheckBox(le) {
                const ve = le.dict.get("AP");
                if (!(ve instanceof f.Dict))
                  return;
                const he = ve.get("N");
                if (!(he instanceof f.Dict))
                  return;
                const ye = this._decodeFormValue(le.dict.get("AS"));
                typeof ye == "string" && (this.data.fieldValue = ye);
                const Ce = this.data.fieldValue !== null && this.data.fieldValue !== "Off" ? this.data.fieldValue : "Yes", xe = he.getKeys();
                if (xe.length === 0)
                  xe.push("Off", Ce);
                else if (xe.length === 1)
                  xe[0] === "Off" ? xe.push(Ce) : xe.unshift("Off");
                else if (xe.includes(Ce))
                  xe.length = 0, xe.push("Off", Ce);
                else {
                  const Ae = xe.find((ue) => ue !== "Off");
                  xe.length = 0, xe.push("Off", Ae);
                }
                xe.includes(this.data.fieldValue) || (this.data.fieldValue = "Off"), this.data.exportValue = xe[1];
                const we = he.get(this.data.exportValue);
                this.checkedAppearance = we instanceof C.BaseStream ? we : null;
                const $e = he.get("Off");
                this.uncheckedAppearance = $e instanceof C.BaseStream ? $e : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(le, "check"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict, this.data.defaultFieldValue === null && (this.data.defaultFieldValue = "Off");
              }
              _processRadioButton(le) {
                this.data.fieldValue = this.data.buttonValue = null;
                const ve = le.dict.get("Parent");
                if (ve instanceof f.Dict) {
                  this.parent = le.dict.getRaw("Parent");
                  const we = ve.get("V");
                  we instanceof f.Name && (this.data.fieldValue = this._decodeFormValue(we));
                }
                const he = le.dict.get("AP");
                if (!(he instanceof f.Dict))
                  return;
                const ye = he.get("N");
                if (!(ye instanceof f.Dict))
                  return;
                for (const we of ye.getKeys())
                  if (we !== "Off") {
                    this.data.buttonValue = this._decodeFormValue(we);
                    break;
                  }
                const Ce = ye.get(this.data.buttonValue);
                this.checkedAppearance = Ce instanceof C.BaseStream ? Ce : null;
                const xe = ye.get("Off");
                this.uncheckedAppearance = xe instanceof C.BaseStream ? xe : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(le, "disc"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict, this.data.defaultFieldValue === null && (this.data.defaultFieldValue = "Off");
              }
              _processPushButton(le) {
                const {
                  dict: ve,
                  annotationGlobals: he
                } = le;
                if (!ve.has("A") && !ve.has("AA") && !this.data.alternativeText) {
                  (0, g.warn)("Push buttons without action dictionaries are not supported");
                  return;
                }
                this.data.isTooltipOnly = !ve.has("A") && !ve.has("AA"), S.Catalog.parseDestDictionary({
                  destDict: ve,
                  resultObj: this.data,
                  docBaseUrl: he.baseUrl,
                  docAttachments: he.attachments
                });
              }
              getFieldObject() {
                let le = "button", ve;
                return this.data.checkBox ? (le = "checkbox", ve = this.data.exportValue) : this.data.radioButton && (le = "radiobutton", ve = this.data.buttonValue), {
                  id: this.data.id,
                  value: this.data.fieldValue || "Off",
                  defaultValue: this.data.defaultFieldValue,
                  exportValues: ve,
                  editable: !this.data.readOnly,
                  name: this.data.fieldName,
                  rect: this.data.rect,
                  hidden: this.data.hidden,
                  actions: this.data.actions,
                  page: this.data.pageIndex,
                  strokeColor: this.data.borderColor,
                  fillColor: this.data.backgroundColor,
                  rotation: this.rotation,
                  type: le
                };
              }
              get fallbackFontDict() {
                const le = new f.Dict();
                return le.set("BaseFont", f.Name.get("ZapfDingbats")), le.set("Type", f.Name.get("FallbackType")), le.set("Subtype", f.Name.get("FallbackType")), le.set("Encoding", f.Name.get("ZapfDingbatsEncoding")), (0, g.shadow)(this, "fallbackFontDict", le);
              }
            }
            class D extends k {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                this.indices = ve.getArray("I"), this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0, this.data.options = [];
                const ye = (0, b.getInheritableProperty)({
                  dict: ve,
                  key: "Opt"
                });
                if (Array.isArray(ye))
                  for (let Ce = 0, xe = ye.length; Ce < xe; Ce++) {
                    const we = he.fetchIfRef(ye[Ce]), $e = Array.isArray(we);
                    this.data.options[Ce] = {
                      exportValue: this._decodeFormValue($e ? he.fetchIfRef(we[0]) : we),
                      displayValue: this._decodeFormValue($e ? he.fetchIfRef(we[1]) : we)
                    };
                  }
                if (!this.hasIndices)
                  typeof this.data.fieldValue == "string" ? this.data.fieldValue = [this.data.fieldValue] : this.data.fieldValue || (this.data.fieldValue = []);
                else {
                  this.data.fieldValue = [];
                  const Ce = this.data.options.length;
                  for (const xe of this.indices)
                    Number.isInteger(xe) && xe >= 0 && xe < Ce && this.data.fieldValue.push(this.data.options[xe].exportValue);
                }
                this.data.combo = this.hasFieldFlag(g.AnnotationFieldFlag.COMBO), this.data.multiSelect = this.hasFieldFlag(g.AnnotationFieldFlag.MULTISELECT), this._hasText = !0;
              }
              getFieldObject() {
                const le = this.data.combo ? "combobox" : "listbox", ve = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
                return {
                  id: this.data.id,
                  value: ve,
                  defaultValue: this.data.defaultFieldValue,
                  editable: !this.data.readOnly,
                  name: this.data.fieldName,
                  rect: this.data.rect,
                  numItems: this.data.fieldValue.length,
                  multipleSelection: this.data.multiSelect,
                  hidden: this.data.hidden,
                  actions: this.data.actions,
                  items: this.data.options,
                  page: this.data.pageIndex,
                  strokeColor: this.data.borderColor,
                  fillColor: this.data.backgroundColor,
                  rotation: this.rotation,
                  type: le
                };
              }
              amendSavedDict(le, ve) {
                if (!this.hasIndices)
                  return;
                let he = le?.get(this.data.id)?.value;
                Array.isArray(he) || (he = [he]);
                const ye = [], {
                  options: Ce
                } = this.data;
                for (let xe = 0, we = 0, $e = Ce.length; xe < $e; xe++)
                  Ce[xe].exportValue === he[we] && (ye.push(xe), we += 1);
                ve.set("I", ye);
              }
              async _getAppearance(le, ve, he, ye) {
                if (this.data.combo)
                  return super._getAppearance(le, ve, he, ye);
                let Ce, xe;
                const we = ye?.get(this.data.id);
                if (we && (xe = we.rotation, Ce = we.value), xe === void 0 && Ce === void 0 && !this._needAppearances)
                  return null;
                Ce === void 0 ? Ce = this.data.fieldValue : Array.isArray(Ce) || (Ce = [Ce]);
                const $e = 1, Ae = 2;
                let ue = this.data.rect[3] - this.data.rect[1], ce = this.data.rect[2] - this.data.rect[0];
                (xe === 90 || xe === 270) && ([ce, ue] = [ue, ce]);
                const Ee = this.data.options.length, _e = [];
                for (let De = 0; De < Ee; De++) {
                  const {
                    exportValue: Ne
                  } = this.data.options[De];
                  Ce.includes(Ne) && _e.push(De);
                }
                this._defaultAppearance || (this.data.defaultAppearanceData = (0, y.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
                const Te = await k._getFontData(le, ve, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                let ke, {
                  fontSize: Re
                } = this.data.defaultAppearanceData;
                if (Re)
                  ke = this._defaultAppearance;
                else {
                  const De = (ue - $e) / Ee;
                  let Ne = -1, Ge;
                  for (const {
                    displayValue: Xe
                  } of this.data.options) {
                    const nt = this._getTextWidth(Xe, Te);
                    nt > Ne && (Ne = nt, Ge = Xe);
                  }
                  [ke, Re] = this._computeFontSize(De, ce - 2 * Ae, Ge, Te, -1);
                }
                const Be = Re * g.LINE_FACTOR, Oe = (Be - Re) / 2, Me = Math.floor(ue / Be);
                let Fe = 0;
                if (_e.length > 0) {
                  const De = Math.min(..._e), Ne = Math.max(..._e);
                  Fe = Math.max(0, Ne - Me + 1), Fe > De && (Fe = De);
                }
                const Ue = Math.min(Fe + Me + 1, Ee), je = ["/Tx BMC q", `1 1 ${ce} ${ue} re W n`];
                if (_e.length) {
                  je.push("0.600006 0.756866 0.854904 rg");
                  for (const De of _e)
                    Fe <= De && De < Ue && je.push(`1 ${ue - (De - Fe + 1) * Be} ${ce} ${Be} re f`);
                }
                je.push("BT", ke, `1 0 0 1 0 ${ue} Tm`);
                const Le = {
                  shift: 0
                };
                for (let De = Fe; De < Ue; De++) {
                  const {
                    displayValue: Ne
                  } = this.data.options[De], Ge = De === Fe ? Oe : 0;
                  je.push(this._renderText(Ne, Te, Re, ce, 0, Le, Ae, -Be + Ge));
                }
                return je.push("ET Q EMC"), je.join(`
`);
              }
            }
            class H extends k {
              constructor(le) {
                super(le), this.data.fieldValue = null, this.data.hasOwnCanvas = this.data.noRotate;
              }
              getFieldObject() {
                return {
                  id: this.data.id,
                  value: null,
                  page: this.data.pageIndex,
                  type: "signature"
                };
              }
            }
            class V extends U {
              constructor(le) {
                super(le), this.data.noRotate = !0, this.data.hasOwnCanvas = this.data.noRotate;
                const {
                  dict: he
                } = le;
                this.data.annotationType = g.AnnotationType.TEXT, this.data.hasAppearance ? this.data.name = "NoIcon" : (this.data.rect[1] = this.data.rect[3] - 22, this.data.rect[2] = this.data.rect[0] + 22, this.data.name = he.has("Name") ? he.get("Name").name : "Note"), he.has("State") ? (this.data.state = he.get("State") || null, this.data.stateModel = he.get("StateModel") || null) : (this.data.state = null, this.data.stateModel = null);
              }
            }
            class Z extends j {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  annotationGlobals: he
                } = le;
                this.data.annotationType = g.AnnotationType.LINK;
                const ye = M(ve, this.rectangle);
                ye && (this.data.quadPoints = ye), this.data.borderColor ||= this.data.color, S.Catalog.parseDestDictionary({
                  destDict: ve,
                  resultObj: this.data,
                  docBaseUrl: he.baseUrl,
                  docAttachments: he.attachments
                });
              }
            }
            class ne extends j {
              constructor(le) {
                super(le);
                const {
                  dict: ve
                } = le;
                this.data.annotationType = g.AnnotationType.POPUP, (this.data.rect[0] === this.data.rect[2] || this.data.rect[1] === this.data.rect[3]) && (this.data.rect = null);
                let he = ve.get("Parent");
                if (!he) {
                  (0, g.warn)("Popup annotation has a missing or invalid parent annotation.");
                  return;
                }
                const ye = he.getArray("Rect");
                this.data.parentRect = Array.isArray(ye) && ye.length === 4 ? g.Util.normalizeRect(ye) : null;
                const Ce = he.get("RT");
                if ((0, f.isName)(Ce, g.AnnotationReplyType.GROUP) && (he = he.get("IRT")), he.has("M") ? (this.setModificationDate(he.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, he.has("C") ? (this.setColor(he.getArray("C")), this.data.color = this.color) : this.data.color = null, !this.viewable) {
                  const xe = he.get("F");
                  this._isViewable(xe) && this.setFlags(xe);
                }
                this.setTitle(he.get("T")), this.data.titleObj = this._title, this.setContents(he.get("Contents")), this.data.contentsObj = this._contents, he.has("RC") && (this.data.richText = O.XFAFactory.getRichTextAsHtml(he.get("RC"))), this.data.open = !!ve.get("Open");
              }
            }
            A.PopupAnnotation = ne;
            class K extends U {
              constructor(le) {
                super(le), this.data.hasOwnCanvas = !0;
                const {
                  evaluatorOptions: ve,
                  xref: he
                } = le;
                if (this.data.annotationType = g.AnnotationType.FREETEXT, this.setDefaultAppearance(le), this.appearance) {
                  const {
                    fontColor: ye,
                    fontSize: Ce
                  } = (0, y.parseAppearanceStream)(this.appearance, ve, he);
                  this.data.defaultAppearanceData.fontColor = ye, this.data.defaultAppearanceData.fontSize = Ce || 10;
                } else if (this._isOffscreenCanvasSupported) {
                  const ye = le.dict.get("CA"), Ce = new y.FakeUnicodeFont(he, "sans-serif");
                  this.data.defaultAppearanceData.fontSize ||= 10;
                  const {
                    fontColor: xe,
                    fontSize: we
                  } = this.data.defaultAppearanceData;
                  this.appearance = Ce.createAppearance(this._contents.str, this.rectangle, this.rotation, we, xe, ye), this._streams.push(this.appearance, y.FakeUnicodeFont.toUnicodeStream);
                } else
                  (0, g.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
              }
              get hasTextContent() {
                return !!this.appearance;
              }
              static createNewDict(le, ve, {
                apRef: he,
                ap: ye
              }) {
                const {
                  color: Ce,
                  fontSize: xe,
                  rect: we,
                  rotation: $e,
                  user: Ae,
                  value: ue
                } = le, ce = new f.Dict(ve);
                ce.set("Type", f.Name.get("Annot")), ce.set("Subtype", f.Name.get("FreeText")), ce.set("CreationDate", `D:${(0, g.getModificationDate)()}`), ce.set("Rect", we);
                const Ee = `/Helv ${xe} Tf ${(0, y.getPdfColor)(Ce, !0)}`;
                if (ce.set("DA", Ee), ce.set("Contents", (0, b.isAscii)(ue) ? ue : (0, b.stringToUTF16String)(ue, !0)), ce.set("F", 4), ce.set("Border", [0, 0, 0]), ce.set("Rotate", $e), Ae && ce.set("T", (0, b.isAscii)(Ae) ? Ae : (0, b.stringToUTF16String)(Ae, !0)), he || ye) {
                  const _e = new f.Dict(ve);
                  ce.set("AP", _e), he ? _e.set("N", he) : _e.set("N", ye);
                }
                return ce;
              }
              static async createNewAppearanceStream(le, ve, he) {
                const {
                  baseFontRef: ye,
                  evaluator: Ce,
                  task: xe
                } = he, {
                  color: we,
                  fontSize: $e,
                  rect: Ae,
                  rotation: ue,
                  value: ce
                } = le, Ee = new f.Dict(ve), _e = new f.Dict(ve);
                if (ye)
                  _e.set("Helv", ye);
                else {
                  const dt = new f.Dict(ve);
                  dt.set("BaseFont", f.Name.get("Helvetica")), dt.set("Type", f.Name.get("Font")), dt.set("Subtype", f.Name.get("Type1")), dt.set("Encoding", f.Name.get("WinAnsiEncoding")), _e.set("Helv", dt);
                }
                Ee.set("Font", _e);
                const Te = await k._getFontData(Ce, xe, {
                  fontName: "Helv",
                  fontSize: $e
                }, Ee), [ke, Re, Be, Oe] = Ae;
                let Me = Be - ke, Fe = Oe - Re;
                ue % 180 !== 0 && ([Me, Fe] = [Fe, Me]);
                const Ue = ce.split(`
`), je = $e / 1e3;
                let Le = -1 / 0;
                const De = [];
                for (let dt of Ue) {
                  const mt = Te.encodeString(dt);
                  if (mt.length > 1)
                    return null;
                  dt = mt.join(""), De.push(dt);
                  let pt = 0;
                  const Et = Te.charsToGlyphs(dt);
                  for (const Mt of Et)
                    pt += Mt.width * je;
                  Le = Math.max(Le, pt);
                }
                let Ne = 1;
                Le > Me && (Ne = Me / Le);
                let Ge = 1;
                const Xe = g.LINE_FACTOR * $e, nt = (g.LINE_FACTOR - g.LINE_DESCENT_FACTOR) * $e, ct = Xe * Ue.length;
                ct > Fe && (Ge = Fe / ct);
                const it = Math.min(Ne, Ge), We = $e * it;
                let Ve, ut, at;
                switch (ue) {
                  case 0:
                    at = [1, 0, 0, 1], ut = [Ae[0], Ae[1], Me, Fe], Ve = [Ae[0], Ae[3] - nt];
                    break;
                  case 90:
                    at = [0, 1, -1, 0], ut = [Ae[1], -Ae[2], Me, Fe], Ve = [Ae[1], -Ae[0] - nt];
                    break;
                  case 180:
                    at = [-1, 0, 0, -1], ut = [-Ae[2], -Ae[3], Me, Fe], Ve = [-Ae[2], -Ae[1] - nt];
                    break;
                  case 270:
                    at = [0, -1, 1, 0], ut = [-Ae[3], Ae[0], Me, Fe], Ve = [-Ae[3], Ae[2] - nt];
                    break;
                }
                const Qe = ["q", `${at.join(" ")} 0 0 cm`, `${ut.join(" ")} re W n`, "BT", `${(0, y.getPdfColor)(we, !0)}`, `0 Tc /Helv ${(0, b.numberToString)(We)} Tf`];
                Qe.push(`${Ve.join(" ")} Td (${(0, b.escapeString)(De[0])}) Tj`);
                const st = (0, b.numberToString)(Xe);
                for (let dt = 1, mt = De.length; dt < mt; dt++) {
                  const pt = De[dt];
                  Qe.push(`0 -${st} Td (${(0, b.escapeString)(pt)}) Tj`);
                }
                Qe.push("ET", "Q");
                const ft = Qe.join(`
`), vt = new f.Dict(ve);
                vt.set("FormType", 1), vt.set("Subtype", f.Name.get("Form")), vt.set("Type", f.Name.get("XObject")), vt.set("BBox", Ae), vt.set("Resources", Ee), vt.set("Matrix", [1, 0, 0, 1, -Ae[0], -Ae[1]]);
                const Pt = new m.StringStream(ft);
                return Pt.dict = vt, Pt;
              }
            }
            class q extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                this.data.annotationType = g.AnnotationType.LINE, this.data.hasOwnCanvas = this.data.noRotate;
                const ye = ve.getArray("L");
                if (this.data.lineCoordinates = g.Util.normalizeRect(ye), this.setLineEndings(ve.getArray("LE")), this.data.lineEndings = this.lineEndings, !this.appearance) {
                  const Ce = this.color ? F(this.color) : [0, 0, 0], xe = ve.get("CA"), we = B(ve.getArray("IC"), null), $e = we ? F(we) : null, Ae = $e ? xe : null, ue = this.borderStyle.width || 1, ce = 2 * ue, Ee = [this.data.lineCoordinates[0] - ce, this.data.lineCoordinates[1] - ce, this.data.lineCoordinates[2] + ce, this.data.lineCoordinates[3] + ce];
                  g.Util.intersect(this.rectangle, Ee) || (this.rectangle = Ee), this._setDefaultAppearance({
                    xref: he,
                    extra: `${ue} w`,
                    strokeColor: Ce,
                    fillColor: $e,
                    strokeAlpha: xe,
                    fillAlpha: Ae,
                    pointsCallback: (_e, Te) => (_e.push(`${ye[0]} ${ye[1]} m`, `${ye[2]} ${ye[3]} l`, "S"), [Te[0].x - ue, Te[1].x + ue, Te[3].y - ue, Te[1].y + ue])
                  });
                }
              }
            }
            class Y extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                if (this.data.annotationType = g.AnnotationType.SQUARE, this.data.hasOwnCanvas = this.data.noRotate, !this.appearance) {
                  const ye = this.color ? F(this.color) : [0, 0, 0], Ce = ve.get("CA"), xe = B(ve.getArray("IC"), null), we = xe ? F(xe) : null, $e = we ? Ce : null;
                  if (this.borderStyle.width === 0 && !we)
                    return;
                  this._setDefaultAppearance({
                    xref: he,
                    extra: `${this.borderStyle.width} w`,
                    strokeColor: ye,
                    fillColor: we,
                    strokeAlpha: Ce,
                    fillAlpha: $e,
                    pointsCallback: (Ae, ue) => {
                      const ce = ue[2].x + this.borderStyle.width / 2, Ee = ue[2].y + this.borderStyle.width / 2, _e = ue[3].x - ue[2].x - this.borderStyle.width, Te = ue[1].y - ue[3].y - this.borderStyle.width;
                      return Ae.push(`${ce} ${Ee} ${_e} ${Te} re`), we ? Ae.push("B") : Ae.push("S"), [ue[0].x, ue[1].x, ue[3].y, ue[1].y];
                    }
                  });
                }
              }
            }
            class ee extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                if (this.data.annotationType = g.AnnotationType.CIRCLE, !this.appearance) {
                  const ye = this.color ? F(this.color) : [0, 0, 0], Ce = ve.get("CA"), xe = B(ve.getArray("IC"), null), we = xe ? F(xe) : null, $e = we ? Ce : null;
                  if (this.borderStyle.width === 0 && !we)
                    return;
                  const Ae = 4 / 3 * Math.tan(Math.PI / (2 * 4));
                  this._setDefaultAppearance({
                    xref: he,
                    extra: `${this.borderStyle.width} w`,
                    strokeColor: ye,
                    fillColor: we,
                    strokeAlpha: Ce,
                    fillAlpha: $e,
                    pointsCallback: (ue, ce) => {
                      const Ee = ce[0].x + this.borderStyle.width / 2, _e = ce[0].y - this.borderStyle.width / 2, Te = ce[3].x - this.borderStyle.width / 2, ke = ce[3].y + this.borderStyle.width / 2, Re = Ee + (Te - Ee) / 2, Be = _e + (ke - _e) / 2, Oe = (Te - Ee) / 2 * Ae, Me = (ke - _e) / 2 * Ae;
                      return ue.push(`${Re} ${ke} m`, `${Re + Oe} ${ke} ${Te} ${Be + Me} ${Te} ${Be} c`, `${Te} ${Be - Me} ${Re + Oe} ${_e} ${Re} ${_e} c`, `${Re - Oe} ${_e} ${Ee} ${Be - Me} ${Ee} ${Be} c`, `${Ee} ${Be + Me} ${Re - Oe} ${ke} ${Re} ${ke} c`, "h"), we ? ue.push("B") : ue.push("S"), [ce[0].x, ce[1].x, ce[3].y, ce[1].y];
                    }
                  });
                }
              }
            }
            class Q extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                this.data.annotationType = g.AnnotationType.POLYLINE, this.data.hasOwnCanvas = this.data.noRotate, this.data.vertices = [], this instanceof J || (this.setLineEndings(ve.getArray("LE")), this.data.lineEndings = this.lineEndings);
                const ye = ve.getArray("Vertices");
                if (Array.isArray(ye)) {
                  for (let Ce = 0, xe = ye.length; Ce < xe; Ce += 2)
                    this.data.vertices.push({
                      x: ye[Ce],
                      y: ye[Ce + 1]
                    });
                  if (!this.appearance) {
                    const Ce = this.color ? F(this.color) : [0, 0, 0], xe = ve.get("CA"), we = this.borderStyle.width || 1, $e = 2 * we, Ae = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                    for (const ue of this.data.vertices)
                      Ae[0] = Math.min(Ae[0], ue.x - $e), Ae[1] = Math.min(Ae[1], ue.y - $e), Ae[2] = Math.max(Ae[2], ue.x + $e), Ae[3] = Math.max(Ae[3], ue.y + $e);
                    g.Util.intersect(this.rectangle, Ae) || (this.rectangle = Ae), this._setDefaultAppearance({
                      xref: he,
                      extra: `${we} w`,
                      strokeColor: Ce,
                      strokeAlpha: xe,
                      pointsCallback: (ue, ce) => {
                        const Ee = this.data.vertices;
                        for (let _e = 0, Te = Ee.length; _e < Te; _e++)
                          ue.push(`${Ee[_e].x} ${Ee[_e].y} ${_e === 0 ? "m" : "l"}`);
                        return ue.push("S"), [ce[0].x, ce[1].x, ce[3].y, ce[1].y];
                      }
                    });
                  }
                }
              }
            }
            class J extends Q {
              constructor(le) {
                super(le), this.data.annotationType = g.AnnotationType.POLYGON;
              }
            }
            class te extends U {
              constructor(le) {
                super(le), this.data.annotationType = g.AnnotationType.CARET;
              }
            }
            class ae extends U {
              constructor(le) {
                super(le), this.data.hasOwnCanvas = this.data.noRotate;
                const {
                  dict: ve,
                  xref: he
                } = le;
                this.data.annotationType = g.AnnotationType.INK, this.data.inkLists = [];
                const ye = ve.getArray("InkList");
                if (Array.isArray(ye)) {
                  for (let Ce = 0, xe = ye.length; Ce < xe; ++Ce) {
                    this.data.inkLists.push([]);
                    for (let we = 0, $e = ye[Ce].length; we < $e; we += 2)
                      this.data.inkLists[Ce].push({
                        x: he.fetchIfRef(ye[Ce][we]),
                        y: he.fetchIfRef(ye[Ce][we + 1])
                      });
                  }
                  if (!this.appearance) {
                    const Ce = this.color ? F(this.color) : [0, 0, 0], xe = ve.get("CA"), we = this.borderStyle.width || 1, $e = 2 * we, Ae = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                    for (const ue of this.data.inkLists)
                      for (const ce of ue)
                        Ae[0] = Math.min(Ae[0], ce.x - $e), Ae[1] = Math.min(Ae[1], ce.y - $e), Ae[2] = Math.max(Ae[2], ce.x + $e), Ae[3] = Math.max(Ae[3], ce.y + $e);
                    g.Util.intersect(this.rectangle, Ae) || (this.rectangle = Ae), this._setDefaultAppearance({
                      xref: he,
                      extra: `${we} w`,
                      strokeColor: Ce,
                      strokeAlpha: xe,
                      pointsCallback: (ue, ce) => {
                        for (const Ee of this.data.inkLists) {
                          for (let _e = 0, Te = Ee.length; _e < Te; _e++)
                            ue.push(`${Ee[_e].x} ${Ee[_e].y} ${_e === 0 ? "m" : "l"}`);
                          ue.push("S");
                        }
                        return [ce[0].x, ce[1].x, ce[3].y, ce[1].y];
                      }
                    });
                  }
                }
              }
              static createNewDict(le, ve, {
                apRef: he,
                ap: ye
              }) {
                const {
                  color: Ce,
                  opacity: xe,
                  paths: we,
                  rect: $e,
                  rotation: Ae,
                  thickness: ue
                } = le, ce = new f.Dict(ve);
                ce.set("Type", f.Name.get("Annot")), ce.set("Subtype", f.Name.get("Ink")), ce.set("CreationDate", `D:${(0, g.getModificationDate)()}`), ce.set("Rect", $e), ce.set("InkList", we.map((Te) => Te.points)), ce.set("F", 4), ce.set("Rotate", Ae);
                const Ee = new f.Dict(ve);
                ce.set("BS", Ee), Ee.set("W", ue), ce.set("C", Array.from(Ce, (Te) => Te / 255)), ce.set("CA", xe);
                const _e = new f.Dict(ve);
                return ce.set("AP", _e), he ? _e.set("N", he) : _e.set("N", ye), ce;
              }
              static async createNewAppearanceStream(le, ve, he) {
                const {
                  color: ye,
                  rect: Ce,
                  paths: xe,
                  thickness: we,
                  opacity: $e
                } = le, Ae = [`${we} w 1 J 1 j`, `${(0, y.getPdfColor)(ye, !1)}`];
                $e !== 1 && Ae.push("/R0 gs");
                const ue = [];
                for (const {
                  bezier: Te
                } of xe) {
                  ue.length = 0, ue.push(`${(0, b.numberToString)(Te[0])} ${(0, b.numberToString)(Te[1])} m`);
                  for (let ke = 2, Re = Te.length; ke < Re; ke += 6) {
                    const Be = Te.slice(ke, ke + 6).map(b.numberToString).join(" ");
                    ue.push(`${Be} c`);
                  }
                  ue.push("S"), Ae.push(ue.join(`
`));
                }
                const ce = Ae.join(`
`), Ee = new f.Dict(ve);
                if (Ee.set("FormType", 1), Ee.set("Subtype", f.Name.get("Form")), Ee.set("Type", f.Name.get("XObject")), Ee.set("BBox", Ce), Ee.set("Length", ce.length), $e !== 1) {
                  const Te = new f.Dict(ve), ke = new f.Dict(ve), Re = new f.Dict(ve);
                  Re.set("CA", $e), Re.set("Type", f.Name.get("ExtGState")), ke.set("R0", Re), Te.set("ExtGState", ke), Ee.set("Resources", Te);
                }
                const _e = new m.StringStream(ce);
                return _e.dict = Ee, _e;
              }
            }
            class se extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                if (this.data.annotationType = g.AnnotationType.HIGHLIGHT, this.data.quadPoints = M(ve, null)) {
                  const Ce = this.appearance?.dict.get("Resources");
                  if (!this.appearance || !Ce?.has("ExtGState")) {
                    this.appearance && (0, g.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                    const xe = this.color ? F(this.color) : [1, 1, 0], we = ve.get("CA");
                    this._setDefaultAppearance({
                      xref: he,
                      fillColor: xe,
                      blendMode: "Multiply",
                      fillAlpha: we,
                      pointsCallback: ($e, Ae) => ($e.push(`${Ae[0].x} ${Ae[0].y} m`, `${Ae[1].x} ${Ae[1].y} l`, `${Ae[3].x} ${Ae[3].y} l`, `${Ae[2].x} ${Ae[2].y} l`, "f"), [Ae[0].x, Ae[1].x, Ae[3].y, Ae[1].y])
                    });
                  }
                } else
                  this.data.popupRef = null;
              }
            }
            class ie extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                if (this.data.annotationType = g.AnnotationType.UNDERLINE, this.data.quadPoints = M(ve, null)) {
                  if (!this.appearance) {
                    const Ce = this.color ? F(this.color) : [0, 0, 0], xe = ve.get("CA");
                    this._setDefaultAppearance({
                      xref: he,
                      extra: "[] 0 d 0.571 w",
                      strokeColor: Ce,
                      strokeAlpha: xe,
                      pointsCallback: (we, $e) => (we.push(`${$e[2].x} ${$e[2].y + 1.3} m`, `${$e[3].x} ${$e[3].y + 1.3} l`, "S"), [$e[0].x, $e[1].x, $e[3].y, $e[1].y])
                    });
                  }
                } else
                  this.data.popupRef = null;
              }
            }
            class fe extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                if (this.data.annotationType = g.AnnotationType.SQUIGGLY, this.data.quadPoints = M(ve, null)) {
                  if (!this.appearance) {
                    const Ce = this.color ? F(this.color) : [0, 0, 0], xe = ve.get("CA");
                    this._setDefaultAppearance({
                      xref: he,
                      extra: "[] 0 d 1 w",
                      strokeColor: Ce,
                      strokeAlpha: xe,
                      pointsCallback: (we, $e) => {
                        const Ae = ($e[0].y - $e[2].y) / 6;
                        let ue = Ae, ce = $e[2].x;
                        const Ee = $e[2].y, _e = $e[3].x;
                        we.push(`${ce} ${Ee + ue} m`);
                        do
                          ce += 2, ue = ue === 0 ? Ae : 0, we.push(`${ce} ${Ee + ue} l`);
                        while (ce < _e);
                        return we.push("S"), [$e[2].x, _e, Ee - 2 * Ae, Ee + 2 * Ae];
                      }
                    });
                  }
                } else
                  this.data.popupRef = null;
              }
            }
            class ge extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le;
                if (this.data.annotationType = g.AnnotationType.STRIKEOUT, this.data.quadPoints = M(ve, null)) {
                  if (!this.appearance) {
                    const Ce = this.color ? F(this.color) : [0, 0, 0], xe = ve.get("CA");
                    this._setDefaultAppearance({
                      xref: he,
                      extra: "[] 0 d 1 w",
                      strokeColor: Ce,
                      strokeAlpha: xe,
                      pointsCallback: (we, $e) => (we.push(`${($e[0].x + $e[2].x) / 2} ${($e[0].y + $e[2].y) / 2} m`, `${($e[1].x + $e[3].x) / 2} ${($e[1].y + $e[3].y) / 2} l`, "S"), [$e[0].x, $e[1].x, $e[3].y, $e[1].y])
                    });
                  }
                } else
                  this.data.popupRef = null;
              }
            }
            class me extends U {
              constructor(le) {
                super(le), this.data.annotationType = g.AnnotationType.STAMP, this.data.hasOwnCanvas = this.data.noRotate;
              }
              static async createImage(le, ve) {
                const {
                  width: he,
                  height: ye
                } = le, Ce = new OffscreenCanvas(he, ye), xe = Ce.getContext("2d", {
                  alpha: !0
                });
                xe.drawImage(le, 0, 0);
                const we = xe.getImageData(0, 0, he, ye).data, $e = new Uint32Array(we.buffer), Ae = $e.some(g.FeatureTest.isLittleEndian ? (Re) => Re >>> 24 !== 255 : (Re) => (Re & 255) !== 255);
                Ae && (xe.fillStyle = "white", xe.fillRect(0, 0, he, ye), xe.drawImage(le, 0, 0));
                const ue = Ce.convertToBlob({
                  type: "image/jpeg",
                  quality: 1
                }).then((Re) => Re.arrayBuffer()), ce = f.Name.get("XObject"), Ee = f.Name.get("Image"), _e = new f.Dict(ve);
                _e.set("Type", ce), _e.set("Subtype", Ee), _e.set("BitsPerComponent", 8), _e.set("ColorSpace", f.Name.get("DeviceRGB")), _e.set("Filter", f.Name.get("DCTDecode")), _e.set("BBox", [0, 0, he, ye]), _e.set("Width", he), _e.set("Height", ye);
                let Te = null;
                if (Ae) {
                  const Re = new Uint8Array($e.length);
                  if (g.FeatureTest.isLittleEndian)
                    for (let Oe = 0, Me = $e.length; Oe < Me; Oe++)
                      Re[Oe] = $e[Oe] >>> 24;
                  else
                    for (let Oe = 0, Me = $e.length; Oe < Me; Oe++)
                      Re[Oe] = $e[Oe] & 255;
                  const Be = new f.Dict(ve);
                  Be.set("Type", ce), Be.set("Subtype", Ee), Be.set("BitsPerComponent", 8), Be.set("ColorSpace", f.Name.get("DeviceGray")), Be.set("Width", he), Be.set("Height", ye), Te = new m.Stream(Re, 0, 0, Be);
                }
                return {
                  imageStream: new m.Stream(await ue, 0, 0, _e),
                  smaskStream: Te,
                  width: he,
                  height: ye
                };
              }
              static createNewDict(le, ve, {
                apRef: he,
                ap: ye
              }) {
                const {
                  rect: Ce,
                  rotation: xe,
                  user: we
                } = le, $e = new f.Dict(ve);
                if ($e.set("Type", f.Name.get("Annot")), $e.set("Subtype", f.Name.get("Stamp")), $e.set("CreationDate", `D:${(0, g.getModificationDate)()}`), $e.set("Rect", Ce), $e.set("F", 4), $e.set("Border", [0, 0, 0]), $e.set("Rotate", xe), we && $e.set("T", (0, b.isAscii)(we) ? we : (0, b.stringToUTF16String)(we, !0)), he || ye) {
                  const Ae = new f.Dict(ve);
                  $e.set("AP", Ae), he ? Ae.set("N", he) : Ae.set("N", ye);
                }
                return $e;
              }
              static async createNewAppearanceStream(le, ve, he) {
                const {
                  rotation: ye
                } = le, {
                  imageRef: Ce,
                  width: xe,
                  height: we
                } = he.image, $e = new f.Dict(ve), Ae = new f.Dict(ve);
                $e.set("XObject", Ae), Ae.set("Im0", Ce);
                const ue = `q ${xe} 0 0 ${we} 0 0 cm /Im0 Do Q`, ce = new f.Dict(ve);
                if (ce.set("FormType", 1), ce.set("Subtype", f.Name.get("Form")), ce.set("Type", f.Name.get("XObject")), ce.set("BBox", [0, 0, xe, we]), ce.set("Resources", $e), ye) {
                  const _e = (0, b.getRotationMatrix)(ye, xe, we);
                  ce.set("Matrix", _e);
                }
                const Ee = new m.StringStream(ue);
                return Ee.dict = ce, Ee;
              }
            }
            class pe extends U {
              constructor(le) {
                super(le);
                const {
                  dict: ve,
                  xref: he
                } = le, ye = new T.FileSpec(ve.get("FS"), he);
                this.data.annotationType = g.AnnotationType.FILEATTACHMENT, this.data.hasOwnCanvas = this.data.noRotate, this.data.file = ye.serializable;
                const Ce = ve.get("Name");
                this.data.name = Ce instanceof f.Name ? (0, g.stringToPDFString)(Ce.name) : "PushPin";
                const xe = ve.get("ca");
                this.data.fillAlpha = typeof xe == "number" && xe >= 0 && xe <= 1 ? xe : null;
              }
            }
          },
          /* 11 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.FakeUnicodeFont = void 0, A.createDefaultAppearance = R, A.getPdfColor = E, A.parseAppearanceStream = _, A.parseDefaultAppearance = T;
            var g = x(4), b = x(3), y = x(2), f = x(12), m = x(13), C = x(59), w = x(57), S = x(8);
            class $ extends m.EvaluatorPreprocessor {
              constructor(B) {
                super(new S.StringStream(B));
              }
              parse() {
                const B = {
                  fn: 0,
                  args: []
                }, F = {
                  fontSize: 0,
                  fontName: "",
                  fontColor: new Uint8ClampedArray(3)
                };
                try {
                  for (; B.args.length = 0, !!this.read(B); ) {
                    if (this.savedStatesDepth !== 0)
                      continue;
                    const {
                      fn: M,
                      args: W
                    } = B;
                    switch (M | 0) {
                      case y.OPS.setFont:
                        const [j, G] = W;
                        j instanceof g.Name && (F.fontName = j.name), typeof G == "number" && G > 0 && (F.fontSize = G);
                        break;
                      case y.OPS.setFillRGBColor:
                        f.ColorSpace.singletons.rgb.getRgbItem(W, 0, F.fontColor, 0);
                        break;
                      case y.OPS.setFillGray:
                        f.ColorSpace.singletons.gray.getRgbItem(W, 0, F.fontColor, 0);
                        break;
                      case y.OPS.setFillCMYKColor:
                        f.ColorSpace.singletons.cmyk.getRgbItem(W, 0, F.fontColor, 0);
                        break;
                    }
                  }
                } catch (M) {
                  (0, y.warn)(`parseDefaultAppearance - ignoring errors: "${M}".`);
                }
                return F;
              }
            }
            function T(L) {
              return new $(L).parse();
            }
            class I extends m.EvaluatorPreprocessor {
              constructor(B, F, M) {
                super(B), this.stream = B, this.evaluatorOptions = F, this.xref = M, this.resources = B.dict?.get("Resources");
              }
              parse() {
                const B = {
                  fn: 0,
                  args: []
                };
                let F = {
                  scaleFactor: 1,
                  fontSize: 0,
                  fontName: "",
                  fontColor: new Uint8ClampedArray(3),
                  fillColorSpace: f.ColorSpace.singletons.gray
                }, M = !1;
                const W = [];
                try {
                  for (; B.args.length = 0, !(M || !this.read(B)); ) {
                    const {
                      fn: j,
                      args: G
                    } = B;
                    switch (j | 0) {
                      case y.OPS.save:
                        W.push({
                          scaleFactor: F.scaleFactor,
                          fontSize: F.fontSize,
                          fontName: F.fontName,
                          fontColor: F.fontColor.slice(),
                          fillColorSpace: F.fillColorSpace
                        });
                        break;
                      case y.OPS.restore:
                        F = W.pop() || F;
                        break;
                      case y.OPS.setTextMatrix:
                        F.scaleFactor *= Math.hypot(G[0], G[1]);
                        break;
                      case y.OPS.setFont:
                        const [U, k] = G;
                        U instanceof g.Name && (F.fontName = U.name), typeof k == "number" && k > 0 && (F.fontSize = k * F.scaleFactor);
                        break;
                      case y.OPS.setFillColorSpace:
                        F.fillColorSpace = f.ColorSpace.parse({
                          cs: G[0],
                          xref: this.xref,
                          resources: this.resources,
                          pdfFunctionFactory: this._pdfFunctionFactory,
                          localColorSpaceCache: this._localColorSpaceCache
                        });
                        break;
                      case y.OPS.setFillColor:
                        F.fillColorSpace.getRgbItem(G, 0, F.fontColor, 0);
                        break;
                      case y.OPS.setFillRGBColor:
                        f.ColorSpace.singletons.rgb.getRgbItem(G, 0, F.fontColor, 0);
                        break;
                      case y.OPS.setFillGray:
                        f.ColorSpace.singletons.gray.getRgbItem(G, 0, F.fontColor, 0);
                        break;
                      case y.OPS.setFillCMYKColor:
                        f.ColorSpace.singletons.cmyk.getRgbItem(G, 0, F.fontColor, 0);
                        break;
                      case y.OPS.showText:
                      case y.OPS.showSpacedText:
                      case y.OPS.nextLineShowText:
                      case y.OPS.nextLineSetSpacingShowText:
                        M = !0;
                        break;
                    }
                  }
                } catch (j) {
                  (0, y.warn)(`parseAppearanceStream - ignoring errors: "${j}".`);
                }
                return this.stream.reset(), delete F.scaleFactor, delete F.fillColorSpace, F;
              }
              get _localColorSpaceCache() {
                return (0, y.shadow)(this, "_localColorSpaceCache", new C.LocalColorSpaceCache());
              }
              get _pdfFunctionFactory() {
                const B = new w.PDFFunctionFactory({
                  xref: this.xref,
                  isEvalSupported: this.evaluatorOptions.isEvalSupported
                });
                return (0, y.shadow)(this, "_pdfFunctionFactory", B);
              }
            }
            function _(L, B, F) {
              return new I(L, B, F).parse();
            }
            function E(L, B) {
              if (L[0] === L[1] && L[1] === L[2]) {
                const F = L[0] / 255;
                return `${(0, b.numberToString)(F)} ${B ? "g" : "G"}`;
              }
              return Array.from(L, (F) => (0, b.numberToString)(F / 255)).join(" ") + ` ${B ? "rg" : "RG"}`;
            }
            function R({
              fontSize: L,
              fontName: B,
              fontColor: F
            }) {
              return `/${(0, b.escapePDFName)(B)} ${L} Tf ${E(F, !0)}`;
            }
            class O {
              constructor(B, F) {
                this.xref = B, this.widths = null, this.firstChar = 1 / 0, this.lastChar = -1 / 0, this.fontFamily = F;
                const M = new OffscreenCanvas(1, 1);
                this.ctxMeasure = M.getContext("2d"), O._fontNameId || (O._fontNameId = 1), this.fontName = g.Name.get(`InvalidPDFjsFont_${F}_${O._fontNameId++}`);
              }
              get toUnicodeRef() {
                if (!O._toUnicodeRef) {
                  const B = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo
<< /Registry (Adobe)
/Ordering (UCS) /Supplement 0 >> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000> <FFFF>
endcodespacerange
1 beginbfrange
<0000> <FFFF> <0000>
endbfrange
endcmap CMapName currentdict /CMap defineresource pop end end`, F = O.toUnicodeStream = new S.StringStream(B), M = new g.Dict(this.xref);
                  F.dict = M, M.set("Length", B.length), O._toUnicodeRef = this.xref.getNewPersistentRef(F);
                }
                return O._toUnicodeRef;
              }
              get fontDescriptorRef() {
                if (!O._fontDescriptorRef) {
                  const B = new g.Dict(this.xref);
                  B.set("Type", g.Name.get("FontDescriptor")), B.set("FontName", this.fontName), B.set("FontFamily", "MyriadPro Regular"), B.set("FontBBox", [0, 0, 0, 0]), B.set("FontStretch", g.Name.get("Normal")), B.set("FontWeight", 400), B.set("ItalicAngle", 0), O._fontDescriptorRef = this.xref.getNewPersistentRef(B);
                }
                return O._fontDescriptorRef;
              }
              get descendantFontRef() {
                const B = new g.Dict(this.xref);
                B.set("BaseFont", this.fontName), B.set("Type", g.Name.get("Font")), B.set("Subtype", g.Name.get("CIDFontType0")), B.set("CIDToGIDMap", g.Name.get("Identity")), B.set("FirstChar", this.firstChar), B.set("LastChar", this.lastChar), B.set("FontDescriptor", this.fontDescriptorRef), B.set("DW", 1e3);
                const F = [], M = [...this.widths.entries()].sort();
                let W = null, j = null;
                for (const [U, k] of M) {
                  if (!W) {
                    W = U, j = [k];
                    continue;
                  }
                  U === W + j.length ? j.push(k) : (F.push(W, j), W = U, j = [k]);
                }
                W && F.push(W, j), B.set("W", F);
                const G = new g.Dict(this.xref);
                return G.set("Ordering", "Identity"), G.set("Registry", "Adobe"), G.set("Supplement", 0), B.set("CIDSystemInfo", G), this.xref.getNewPersistentRef(B);
              }
              get baseFontRef() {
                const B = new g.Dict(this.xref);
                return B.set("BaseFont", this.fontName), B.set("Type", g.Name.get("Font")), B.set("Subtype", g.Name.get("Type0")), B.set("Encoding", g.Name.get("Identity-H")), B.set("DescendantFonts", [this.descendantFontRef]), B.set("ToUnicode", this.toUnicodeRef), this.xref.getNewPersistentRef(B);
              }
              get resources() {
                const B = new g.Dict(this.xref), F = new g.Dict(this.xref);
                return F.set(this.fontName.name, this.baseFontRef), B.set("Font", F), B;
              }
              _createContext() {
                return this.widths = /* @__PURE__ */ new Map(), this.ctxMeasure.font = `1000px ${this.fontFamily}`, this.ctxMeasure;
              }
              createFontResources(B) {
                const F = this._createContext();
                for (const M of B.split(/\r\n?|\n/))
                  for (const W of M.split("")) {
                    const j = W.charCodeAt(0);
                    if (this.widths.has(j))
                      continue;
                    const G = F.measureText(W), U = Math.ceil(G.width);
                    this.widths.set(j, U), this.firstChar = Math.min(j, this.firstChar), this.lastChar = Math.max(j, this.lastChar);
                  }
                return this.resources;
              }
              createAppearance(B, F, M, W, j, G) {
                const U = this._createContext(), k = [];
                let N = -1 / 0;
                for (const pe of B.split(/\r\n?|\n/)) {
                  k.push(pe);
                  const be = U.measureText(pe).width;
                  N = Math.max(N, be);
                  for (const le of pe.split("")) {
                    const ve = le.charCodeAt(0);
                    let he = this.widths.get(ve);
                    if (he === void 0) {
                      const ye = U.measureText(le);
                      he = Math.ceil(ye.width), this.widths.set(ve, he), this.firstChar = Math.min(ve, this.firstChar), this.lastChar = Math.max(ve, this.lastChar);
                    }
                  }
                }
                N *= W / 1e3;
                const [P, D, H, V] = F;
                let Z = H - P, ne = V - D;
                M % 180 !== 0 && ([Z, ne] = [ne, Z]);
                let K = 1;
                N > Z && (K = Z / N);
                let q = 1;
                const Y = y.LINE_FACTOR * W, ee = y.LINE_DESCENT_FACTOR * W, Q = Y * k.length;
                Q > ne && (q = ne / Q);
                const J = Math.min(K, q), te = W * J, ae = ["q", `0 0 ${(0, b.numberToString)(Z)} ${(0, b.numberToString)(ne)} re W n`, "BT", `1 0 0 1 0 ${(0, b.numberToString)(ne + ee)} Tm 0 Tc ${E(j, !0)}`, `/${this.fontName.name} ${(0, b.numberToString)(te)} Tf`], {
                  resources: se
                } = this;
                if (G = typeof G == "number" && G >= 0 && G <= 1 ? G : 1, G !== 1) {
                  ae.push("/R0 gs");
                  const pe = new g.Dict(this.xref), be = new g.Dict(this.xref);
                  be.set("ca", G), be.set("CA", G), be.set("Type", g.Name.get("ExtGState")), pe.set("R0", be), se.set("ExtGState", pe);
                }
                const ie = (0, b.numberToString)(Y);
                for (const pe of k)
                  ae.push(`0 -${ie} Td <${(0, b.stringToUTF16HexString)(pe)}> Tj`);
                ae.push("ET", "Q");
                const fe = ae.join(`
`), ge = new g.Dict(this.xref);
                if (ge.set("Subtype", g.Name.get("Form")), ge.set("Type", g.Name.get("XObject")), ge.set("BBox", [0, 0, Z, ne]), ge.set("Length", fe.length), ge.set("Resources", se), M) {
                  const pe = (0, b.getRotationMatrix)(M, Z, ne);
                  ge.set("Matrix", pe);
                }
                const me = new S.StringStream(fe);
                return me.dict = ge, me;
              }
            }
            A.FakeUnicodeFont = O;
          },
          /* 12 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ColorSpace = void 0;
            var g = x(2), b = x(4), y = x(5), f = x(3);
            function m(L, B, F, M, W, j, G) {
              G = G !== 1 ? 0 : G;
              const k = F / W, N = M / j;
              let P = 0, D;
              const H = new Uint16Array(W), V = F * 3;
              for (let Z = 0; Z < W; Z++)
                H[Z] = Math.floor(Z * k) * 3;
              for (let Z = 0; Z < j; Z++) {
                const ne = Math.floor(Z * N) * V;
                for (let K = 0; K < W; K++)
                  D = ne + H[K], B[P++] = L[D++], B[P++] = L[D++], B[P++] = L[D++], P += G;
              }
            }
            class C {
              constructor(B, F) {
                this.constructor === C && (0, g.unreachable)("Cannot initialize ColorSpace."), this.name = B, this.numComps = F;
              }
              getRgb(B, F) {
                const M = new Uint8ClampedArray(3);
                return this.getRgbItem(B, F, M, 0), M;
              }
              getRgbItem(B, F, M, W) {
                (0, g.unreachable)("Should not call ColorSpace.getRgbItem");
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                (0, g.unreachable)("Should not call ColorSpace.getRgbBuffer");
              }
              getOutputLength(B, F) {
                (0, g.unreachable)("Should not call ColorSpace.getOutputLength");
              }
              isPassthrough(B) {
                return !1;
              }
              isDefaultDecode(B, F) {
                return C.isDefaultDecode(B, this.numComps);
              }
              fillRgb(B, F, M, W, j, G, U, k, N) {
                const P = F * M;
                let D = null;
                const H = 1 << U, V = M !== j || F !== W;
                if (this.isPassthrough(U))
                  D = k;
                else if (this.numComps === 1 && P > H && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
                  const Z = U <= 8 ? new Uint8Array(H) : new Uint16Array(H);
                  for (let K = 0; K < H; K++)
                    Z[K] = K;
                  const ne = new Uint8ClampedArray(H * 3);
                  if (this.getRgbBuffer(Z, 0, H, ne, 0, U, 0), V) {
                    D = new Uint8Array(P * 3);
                    let K = 0;
                    for (let q = 0; q < P; ++q) {
                      const Y = k[q] * 3;
                      D[K++] = ne[Y], D[K++] = ne[Y + 1], D[K++] = ne[Y + 2];
                    }
                  } else {
                    let K = 0;
                    for (let q = 0; q < P; ++q) {
                      const Y = k[q] * 3;
                      B[K++] = ne[Y], B[K++] = ne[Y + 1], B[K++] = ne[Y + 2], K += N;
                    }
                  }
                } else V ? (D = new Uint8ClampedArray(P * 3), this.getRgbBuffer(k, 0, P, D, 0, U, 0)) : this.getRgbBuffer(k, 0, W * G, B, 0, U, N);
                if (D)
                  if (V)
                    m(D, B, F, M, W, j, N);
                  else {
                    let Z = 0, ne = 0;
                    for (let K = 0, q = W * G; K < q; K++)
                      B[Z++] = D[ne++], B[Z++] = D[ne++], B[Z++] = D[ne++], Z += N;
                  }
              }
              get usesZeroToOneRange() {
                return (0, g.shadow)(this, "usesZeroToOneRange", !0);
              }
              static _cache(B, F, M, W) {
                if (!M)
                  throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
                if (!W)
                  throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
                let j, G;
                B instanceof b.Ref && (G = B, B = F.fetch(B)), B instanceof b.Name && (j = B.name), (j || G) && M.set(j, G, W);
              }
              static getCached(B, F, M) {
                if (!M)
                  throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
                if (B instanceof b.Ref) {
                  const W = M.getByRef(B);
                  if (W)
                    return W;
                  try {
                    B = F.fetch(B);
                  } catch (j) {
                    if (j instanceof f.MissingDataException)
                      throw j;
                  }
                }
                if (B instanceof b.Name) {
                  const W = M.getByName(B.name);
                  if (W)
                    return W;
                }
                return null;
              }
              static async parseAsync({
                cs: B,
                xref: F,
                resources: M = null,
                pdfFunctionFactory: W,
                localColorSpaceCache: j
              }) {
                const G = this._parse(B, F, M, W);
                return this._cache(B, F, j, G), G;
              }
              static parse({
                cs: B,
                xref: F,
                resources: M = null,
                pdfFunctionFactory: W,
                localColorSpaceCache: j
              }) {
                const G = this.getCached(B, F, j);
                if (G)
                  return G;
                const U = this._parse(B, F, M, W);
                return this._cache(B, F, j, U), U;
              }
              static _parse(B, F, M = null, W) {
                if (B = F.fetchIfRef(B), B instanceof b.Name)
                  switch (B.name) {
                    case "G":
                    case "DeviceGray":
                      return this.singletons.gray;
                    case "RGB":
                    case "DeviceRGB":
                      return this.singletons.rgb;
                    case "CMYK":
                    case "DeviceCMYK":
                      return this.singletons.cmyk;
                    case "Pattern":
                      return new S(null);
                    default:
                      if (M instanceof b.Dict) {
                        const j = M.get("ColorSpace");
                        if (j instanceof b.Dict) {
                          const G = j.get(B.name);
                          if (G) {
                            if (G instanceof b.Name)
                              return this._parse(G, F, M, W);
                            B = G;
                            break;
                          }
                        }
                      }
                      throw new g.FormatError(`Unrecognized ColorSpace: ${B.name}`);
                  }
                if (Array.isArray(B)) {
                  const j = F.fetchIfRef(B[0]).name;
                  let G, U, k, N, P, D;
                  switch (j) {
                    case "G":
                    case "DeviceGray":
                      return this.singletons.gray;
                    case "RGB":
                    case "DeviceRGB":
                      return this.singletons.rgb;
                    case "CMYK":
                    case "DeviceCMYK":
                      return this.singletons.cmyk;
                    case "CalGray":
                      return G = F.fetchIfRef(B[1]), N = G.getArray("WhitePoint"), P = G.getArray("BlackPoint"), D = G.get("Gamma"), new E(N, P, D);
                    case "CalRGB":
                      G = F.fetchIfRef(B[1]), N = G.getArray("WhitePoint"), P = G.getArray("BlackPoint"), D = G.getArray("Gamma");
                      const H = G.getArray("Matrix");
                      return new R(N, P, D, H);
                    case "ICCBased":
                      const Z = F.fetchIfRef(B[1]).dict;
                      U = Z.get("N");
                      const ne = Z.get("Alternate");
                      if (ne) {
                        const J = this._parse(ne, F, M, W);
                        if (J.numComps === U)
                          return J;
                        (0, g.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                      }
                      if (U === 1)
                        return this.singletons.gray;
                      if (U === 3)
                        return this.singletons.rgb;
                      if (U === 4)
                        return this.singletons.cmyk;
                      break;
                    case "Pattern":
                      return k = B[1] || null, k && (k = this._parse(k, F, M, W)), new S(k);
                    case "I":
                    case "Indexed":
                      k = this._parse(B[1], F, M, W);
                      const K = F.fetchIfRef(B[2]) + 1, q = F.fetchIfRef(B[3]);
                      return new $(k, K, q);
                    case "Separation":
                    case "DeviceN":
                      const Y = F.fetchIfRef(B[1]);
                      U = Array.isArray(Y) ? Y.length : 1, k = this._parse(B[2], F, M, W);
                      const ee = W.create(B[3]);
                      return new w(U, k, ee);
                    case "Lab":
                      G = F.fetchIfRef(B[1]), N = G.getArray("WhitePoint"), P = G.getArray("BlackPoint");
                      const Q = G.getArray("Range");
                      return new O(N, P, Q);
                    default:
                      throw new g.FormatError(`Unimplemented ColorSpace object: ${j}`);
                  }
                }
                throw new g.FormatError(`Unrecognized ColorSpace object: ${B}`);
              }
              static isDefaultDecode(B, F) {
                if (!Array.isArray(B))
                  return !0;
                if (F * 2 !== B.length)
                  return (0, g.warn)("The decode map is not the correct length"), !0;
                for (let M = 0, W = B.length; M < W; M += 2)
                  if (B[M] !== 0 || B[M + 1] !== 1)
                    return !1;
                return !0;
              }
              static get singletons() {
                return (0, g.shadow)(this, "singletons", {
                  get gray() {
                    return (0, g.shadow)(this, "gray", new T());
                  },
                  get rgb() {
                    return (0, g.shadow)(this, "rgb", new I());
                  },
                  get cmyk() {
                    return (0, g.shadow)(this, "cmyk", new _());
                  }
                });
              }
            }
            A.ColorSpace = C;
            class w extends C {
              constructor(B, F, M) {
                super("Alternate", B), this.base = F, this.tintFn = M, this.tmpBuf = new Float32Array(F.numComps);
              }
              getRgbItem(B, F, M, W) {
                const j = this.tmpBuf;
                this.tintFn(B, F, j, 0), this.base.getRgbItem(j, 0, M, W);
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                const k = this.tintFn, N = this.base, P = 1 / ((1 << G) - 1), D = N.numComps, H = N.usesZeroToOneRange, V = (N.isPassthrough(8) || !H) && U === 0;
                let Z = V ? j : 0;
                const ne = V ? W : new Uint8ClampedArray(D * M), K = this.numComps, q = new Float32Array(K), Y = new Float32Array(D);
                let ee, Q;
                for (ee = 0; ee < M; ee++) {
                  for (Q = 0; Q < K; Q++)
                    q[Q] = B[F++] * P;
                  if (k(q, 0, Y, 0), H)
                    for (Q = 0; Q < D; Q++)
                      ne[Z++] = Y[Q] * 255;
                  else
                    N.getRgbItem(Y, 0, ne, Z), Z += D;
                }
                V || N.getRgbBuffer(ne, 0, M, W, j, 8, U);
              }
              getOutputLength(B, F) {
                return this.base.getOutputLength(B * this.base.numComps / this.numComps, F);
              }
            }
            class S extends C {
              constructor(B) {
                super("Pattern", null), this.base = B;
              }
              isDefaultDecode(B, F) {
                (0, g.unreachable)("Should not call PatternCS.isDefaultDecode");
              }
            }
            class $ extends C {
              constructor(B, F, M) {
                super("Indexed", 1), this.base = B, this.highVal = F;
                const W = B.numComps * F;
                if (this.lookup = new Uint8Array(W), M instanceof y.BaseStream) {
                  const j = M.getBytes(W);
                  this.lookup.set(j);
                } else if (typeof M == "string")
                  for (let j = 0; j < W; ++j)
                    this.lookup[j] = M.charCodeAt(j) & 255;
                else
                  throw new g.FormatError(`IndexedCS - unrecognized lookup table: ${M}`);
              }
              getRgbItem(B, F, M, W) {
                const j = this.base.numComps, G = B[F] * j;
                this.base.getRgbBuffer(this.lookup, G, 1, M, W, 8, 0);
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                const k = this.base, N = k.numComps, P = k.getOutputLength(N, U), D = this.lookup;
                for (let H = 0; H < M; ++H) {
                  const V = B[F++] * N;
                  k.getRgbBuffer(D, V, 1, W, j, 8, U), j += P;
                }
              }
              getOutputLength(B, F) {
                return this.base.getOutputLength(B * this.base.numComps, F);
              }
              isDefaultDecode(B, F) {
                return Array.isArray(B) ? B.length !== 2 ? ((0, g.warn)("Decode map length is not correct"), !0) : !Number.isInteger(F) || F < 1 ? ((0, g.warn)("Bits per component is not correct"), !0) : B[0] === 0 && B[1] === (1 << F) - 1 : !0;
              }
            }
            class T extends C {
              constructor() {
                super("DeviceGray", 1);
              }
              getRgbItem(B, F, M, W) {
                const j = B[F] * 255;
                M[W] = M[W + 1] = M[W + 2] = j;
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                const k = 255 / ((1 << G) - 1);
                let N = F, P = j;
                for (let D = 0; D < M; ++D) {
                  const H = k * B[N++];
                  W[P++] = H, W[P++] = H, W[P++] = H, P += U;
                }
              }
              getOutputLength(B, F) {
                return B * (3 + F);
              }
            }
            class I extends C {
              constructor() {
                super("DeviceRGB", 3);
              }
              getRgbItem(B, F, M, W) {
                M[W] = B[F] * 255, M[W + 1] = B[F + 1] * 255, M[W + 2] = B[F + 2] * 255;
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                if (G === 8 && U === 0) {
                  W.set(B.subarray(F, F + M * 3), j);
                  return;
                }
                const k = 255 / ((1 << G) - 1);
                let N = F, P = j;
                for (let D = 0; D < M; ++D)
                  W[P++] = k * B[N++], W[P++] = k * B[N++], W[P++] = k * B[N++], P += U;
              }
              getOutputLength(B, F) {
                return B * (3 + F) / 3 | 0;
              }
              isPassthrough(B) {
                return B === 8;
              }
            }
            class _ extends C {
              constructor() {
                super("DeviceCMYK", 4);
              }
              #e(B, F, M, W, j) {
                const G = B[F] * M, U = B[F + 1] * M, k = B[F + 2] * M, N = B[F + 3] * M;
                W[j] = 255 + G * (-4.387332384609988 * G + 54.48615194189176 * U + 18.82290502165302 * k + 212.25662451639585 * N + -285.2331026137004) + U * (1.7149763477362134 * U - 5.6096736904047315 * k + -17.873870861415444 * N - 5.497006427196366) + k * (-2.5217340131683033 * k - 21.248923337353073 * N + 17.5119270841813) + N * (-21.86122147463605 * N - 189.48180835922747), W[j + 1] = 255 + G * (8.841041422036149 * G + 60.118027045597366 * U + 6.871425592049007 * k + 31.159100130055922 * N + -79.2970844816548) + U * (-15.310361306967817 * U + 17.575251261109482 * k + 131.35250912493976 * N - 190.9453302588951) + k * (4.444339102852739 * k + 9.8632861493405 * N - 24.86741582555878) + N * (-20.737325471181034 * N - 187.80453709719578), W[j + 2] = 255 + G * (0.8842522430003296 * G + 8.078677503112928 * U + 30.89978309703729 * k - 0.23883238689178934 * N + -14.183576799673286) + U * (10.49593273432072 * U + 63.02378494754052 * k + 50.606957656360734 * N - 112.23884253719248) + k * (0.03296041114873217 * k + 115.60384449646641 * N + -193.58209356861505) + N * (-22.33816807309886 * N - 180.12613974708367);
              }
              getRgbItem(B, F, M, W) {
                this.#e(B, F, 1, M, W);
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                const k = 1 / ((1 << G) - 1);
                for (let N = 0; N < M; N++)
                  this.#e(B, F, k, W, j), F += 4, j += 3 + U;
              }
              getOutputLength(B, F) {
                return B / 4 * (3 + F) | 0;
              }
            }
            class E extends C {
              constructor(B, F, M) {
                if (super("CalGray", 1), !B)
                  throw new g.FormatError("WhitePoint missing - required for color space CalGray");
                if ([this.XW, this.YW, this.ZW] = B, [this.XB, this.YB, this.ZB] = F || [0, 0, 0], this.G = M || 1, this.XW < 0 || this.ZW < 0 || this.YW !== 1)
                  throw new g.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, g.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`), this.XB = this.YB = this.ZB = 0), (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) && (0, g.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ZB: ${this.ZB}, only default values are supported.`), this.G < 1 && ((0, g.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`), this.G = 1);
              }
              #e(B, F, M, W, j) {
                const U = (B[F] * j) ** this.G, k = this.YW * U, N = Math.max(295.8 * k ** 0.3333333333333333 - 40.8, 0);
                M[W] = N, M[W + 1] = N, M[W + 2] = N;
              }
              getRgbItem(B, F, M, W) {
                this.#e(B, F, M, W, 1);
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                const k = 1 / ((1 << G) - 1);
                for (let N = 0; N < M; ++N)
                  this.#e(B, F, W, j, k), F += 1, j += 3 + U;
              }
              getOutputLength(B, F) {
                return B * (3 + F);
              }
            }
            class R extends C {
              static #e = new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296]);
              static #t = new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -85287e-7, 0.0400428, 0.9684867]);
              static #r = new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.969266, 1.8760108, 0.041556, 0.0556434, -0.2040259, 1.0572252]);
              static #n = new Float32Array([1, 1, 1]);
              static #s = new Float32Array(3);
              static #o = new Float32Array(3);
              static #i = new Float32Array(3);
              static #l = 0.0011070564598794539;
              constructor(B, F, M, W) {
                if (super("CalRGB", 3), !B)
                  throw new g.FormatError("WhitePoint missing - required for color space CalRGB");
                const [j, G, U] = this.whitePoint = B, [k, N, P] = this.blackPoint = F || new Float32Array(3);
                if ([this.GR, this.GG, this.GB] = M || new Float32Array([1, 1, 1]), [this.MXA, this.MYA, this.MZA, this.MXB, this.MYB, this.MZB, this.MXC, this.MYC, this.MZC] = W || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]), j < 0 || U < 0 || G !== 1)
                  throw new g.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                (k < 0 || N < 0 || P < 0) && ((0, g.info)(`Invalid BlackPoint for ${this.name} [${k}, ${N}, ${P}], falling back to default.`), this.blackPoint = new Float32Array(3)), (this.GR < 0 || this.GG < 0 || this.GB < 0) && ((0, g.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ${this.name}, falling back to default.`), this.GR = this.GG = this.GB = 1);
              }
              #c(B, F, M) {
                M[0] = B[0] * F[0] + B[1] * F[1] + B[2] * F[2], M[1] = B[3] * F[0] + B[4] * F[1] + B[5] * F[2], M[2] = B[6] * F[0] + B[7] * F[1] + B[8] * F[2];
              }
              #a(B, F, M) {
                M[0] = F[0] * 1 / B[0], M[1] = F[1] * 1 / B[1], M[2] = F[2] * 1 / B[2];
              }
              #p(B, F, M) {
                M[0] = F[0] * 0.95047 / B[0], M[1] = F[1] * 1 / B[1], M[2] = F[2] * 1.08883 / B[2];
              }
              #d(B) {
                return B <= 31308e-7 ? this.#f(0, 1, 12.92 * B) : B >= 0.99554525 ? 1 : this.#f(0, 1, 1.055 * B ** 0.4166666666666667 - 0.055);
              }
              #f(B, F, M) {
                return Math.max(B, Math.min(F, M));
              }
              #h(B) {
                return B < 0 ? -this.#h(-B) : B > 8 ? ((B + 16) / 116) ** 3 : B * R.#l;
              }
              #A(B, F, M) {
                if (B[0] === 0 && B[1] === 0 && B[2] === 0) {
                  M[0] = F[0], M[1] = F[1], M[2] = F[2];
                  return;
                }
                const W = this.#h(0), j = W, G = this.#h(B[0]), U = W, k = this.#h(B[1]), N = W, P = this.#h(B[2]), D = (1 - j) / (1 - G), H = 1 - D, V = (1 - U) / (1 - k), Z = 1 - V, ne = (1 - N) / (1 - P), K = 1 - ne;
                M[0] = F[0] * D + H, M[1] = F[1] * V + Z, M[2] = F[2] * ne + K;
              }
              #m(B, F, M) {
                if (B[0] === 1 && B[2] === 1) {
                  M[0] = F[0], M[1] = F[1], M[2] = F[2];
                  return;
                }
                const W = M;
                this.#c(R.#e, F, W);
                const j = R.#s;
                this.#a(B, W, j), this.#c(R.#t, j, M);
              }
              #g(B, F, M) {
                const W = M;
                this.#c(R.#e, F, W);
                const j = R.#s;
                this.#p(B, W, j), this.#c(R.#t, j, M);
              }
              #u(B, F, M, W, j) {
                const G = this.#f(0, 1, B[F] * j), U = this.#f(0, 1, B[F + 1] * j), k = this.#f(0, 1, B[F + 2] * j), N = G === 1 ? 1 : G ** this.GR, P = U === 1 ? 1 : U ** this.GG, D = k === 1 ? 1 : k ** this.GB, H = this.MXA * N + this.MXB * P + this.MXC * D, V = this.MYA * N + this.MYB * P + this.MYC * D, Z = this.MZA * N + this.MZB * P + this.MZC * D, ne = R.#o;
                ne[0] = H, ne[1] = V, ne[2] = Z;
                const K = R.#i;
                this.#m(this.whitePoint, ne, K);
                const q = R.#o;
                this.#A(this.blackPoint, K, q);
                const Y = R.#i;
                this.#g(R.#n, q, Y);
                const ee = R.#o;
                this.#c(R.#r, Y, ee), M[W] = this.#d(ee[0]) * 255, M[W + 1] = this.#d(ee[1]) * 255, M[W + 2] = this.#d(ee[2]) * 255;
              }
              getRgbItem(B, F, M, W) {
                this.#u(B, F, M, W, 1);
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                const k = 1 / ((1 << G) - 1);
                for (let N = 0; N < M; ++N)
                  this.#u(B, F, W, j, k), F += 3, j += 3 + U;
              }
              getOutputLength(B, F) {
                return B * (3 + F) / 3 | 0;
              }
            }
            class O extends C {
              constructor(B, F, M) {
                if (super("Lab", 3), !B)
                  throw new g.FormatError("WhitePoint missing - required for color space Lab");
                if ([this.XW, this.YW, this.ZW] = B, [this.amin, this.amax, this.bmin, this.bmax] = M || [-100, 100, -100, 100], [this.XB, this.YB, this.ZB] = F || [0, 0, 0], this.XW < 0 || this.ZW < 0 || this.YW !== 1)
                  throw new g.FormatError("Invalid WhitePoint components, no fallback available");
                (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, g.info)("Invalid BlackPoint, falling back to default"), this.XB = this.YB = this.ZB = 0), (this.amin > this.amax || this.bmin > this.bmax) && ((0, g.info)("Invalid Range, falling back to defaults"), this.amin = -100, this.amax = 100, this.bmin = -100, this.bmax = 100);
              }
              #e(B) {
                return B >= 0.20689655172413793 ? B ** 3 : 0.12841854934601665 * (B - 0.13793103448275862);
              }
              #t(B, F, M, W) {
                return M + B * (W - M) / F;
              }
              #r(B, F, M, W, j) {
                let G = B[F], U = B[F + 1], k = B[F + 2];
                M !== !1 && (G = this.#t(G, M, 0, 100), U = this.#t(U, M, this.amin, this.amax), k = this.#t(k, M, this.bmin, this.bmax)), U > this.amax ? U = this.amax : U < this.amin && (U = this.amin), k > this.bmax ? k = this.bmax : k < this.bmin && (k = this.bmin);
                const N = (G + 16) / 116, P = N + U / 500, D = N - k / 200, H = this.XW * this.#e(P), V = this.YW * this.#e(N), Z = this.ZW * this.#e(D);
                let ne, K, q;
                this.ZW < 1 ? (ne = H * 3.1339 + V * -1.617 + Z * -0.4906, K = H * -0.9785 + V * 1.916 + Z * 0.0333, q = H * 0.072 + V * -0.229 + Z * 1.4057) : (ne = H * 3.2406 + V * -1.5372 + Z * -0.4986, K = H * -0.9689 + V * 1.8758 + Z * 0.0415, q = H * 0.0557 + V * -0.204 + Z * 1.057), W[j] = Math.sqrt(ne) * 255, W[j + 1] = Math.sqrt(K) * 255, W[j + 2] = Math.sqrt(q) * 255;
              }
              getRgbItem(B, F, M, W) {
                this.#r(B, F, !1, M, W);
              }
              getRgbBuffer(B, F, M, W, j, G, U) {
                const k = (1 << G) - 1;
                for (let N = 0; N < M; N++)
                  this.#r(B, F, k, W, j), F += 3, j += 3 + U;
              }
              getOutputLength(B, F) {
                return B * (3 + F) / 3 | 0;
              }
              isDefaultDecode(B, F) {
                return !0;
              }
              get usesZeroToOneRange() {
                return (0, g.shadow)(this, "usesZeroToOneRange", !1);
              }
            }
          },
          /* 13 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.PartialEvaluator = A.EvaluatorPreprocessor = void 0;
            var g = x(2), b = x(14), y = x(4), f = x(34), m = x(37), C = x(41), w = x(50), S = x(51), $ = x(42), T = x(57), I = x(16), _ = x(59), E = x(8), R = x(5), O = x(60), L = x(12), B = x(18), F = x(38), M = x(61), W = x(39), j = x(45), G = x(40), U = x(62), k = x(63), N = x(64), P = x(65);
            const D = Object.freeze({
              maxImageSize: -1,
              disableFontFace: !1,
              ignoreErrors: !1,
              isEvalSupported: !0,
              isOffscreenCanvasSupported: !1,
              canvasMaxAreaInBytes: -1,
              fontExtraProperties: !1,
              useSystemFonts: !0,
              cMapUrl: null,
              standardFontDataUrl: null
            }), H = {
              TILING: 1,
              SHADING: 2
            }, V = 10, Z = Promise.resolve();
            function ne(se, ie = !1) {
              if (Array.isArray(se)) {
                for (const fe of se) {
                  const ge = ne(fe, !0);
                  if (ge)
                    return ge;
                }
                return (0, g.warn)(`Unsupported blend mode Array: ${se}`), "source-over";
              }
              if (!(se instanceof y.Name))
                return ie ? null : "source-over";
              switch (se.name) {
                case "Normal":
                case "Compatible":
                  return "source-over";
                case "Multiply":
                  return "multiply";
                case "Screen":
                  return "screen";
                case "Overlay":
                  return "overlay";
                case "Darken":
                  return "darken";
                case "Lighten":
                  return "lighten";
                case "ColorDodge":
                  return "color-dodge";
                case "ColorBurn":
                  return "color-burn";
                case "HardLight":
                  return "hard-light";
                case "SoftLight":
                  return "soft-light";
                case "Difference":
                  return "difference";
                case "Exclusion":
                  return "exclusion";
                case "Hue":
                  return "hue";
                case "Saturation":
                  return "saturation";
                case "Color":
                  return "color";
                case "Luminosity":
                  return "luminosity";
              }
              return ie ? null : ((0, g.warn)(`Unsupported blend mode: ${se.name}`), "source-over");
            }
            function K(se) {
              se.fn === g.OPS.paintImageMaskXObject && se.args[0]?.count > 0 && se.args[0].count++;
            }
            class q {
              static TIME_SLOT_DURATION_MS = 20;
              static CHECK_TIME_EVERY = 100;
              constructor() {
                this.reset();
              }
              check() {
                return ++this.checked < q.CHECK_TIME_EVERY ? !1 : (this.checked = 0, this.endTime <= Date.now());
              }
              reset() {
                this.endTime = Date.now() + q.TIME_SLOT_DURATION_MS, this.checked = 0;
              }
            }
            class Y {
              constructor({
                xref: ie,
                handler: fe,
                pageIndex: ge,
                idFactory: me,
                fontCache: pe,
                builtInCMapCache: be,
                standardFontDataCache: le,
                globalImageCache: ve,
                systemFontCache: he,
                options: ye = null
              }) {
                this.xref = ie, this.handler = fe, this.pageIndex = ge, this.idFactory = me, this.fontCache = pe, this.builtInCMapCache = be, this.standardFontDataCache = le, this.globalImageCache = ve, this.systemFontCache = he, this.options = ye || D, this.parsingType3Font = !1, this._regionalImageCache = new _.RegionalImageCache(), this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this), U.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
              }
              get _pdfFunctionFactory() {
                const ie = new T.PDFFunctionFactory({
                  xref: this.xref,
                  isEvalSupported: this.options.isEvalSupported
                });
                return (0, g.shadow)(this, "_pdfFunctionFactory", ie);
              }
              clone(ie = null) {
                const fe = Object.create(this);
                return fe.options = Object.assign(/* @__PURE__ */ Object.create(null), this.options, ie), fe;
              }
              hasBlendModes(ie, fe) {
                if (!(ie instanceof y.Dict) || ie.objId && fe.has(ie.objId))
                  return !1;
                const ge = new y.RefSet(fe);
                ie.objId && ge.put(ie.objId);
                const me = [ie], pe = this.xref;
                for (; me.length; ) {
                  const be = me.shift(), le = be.get("ExtGState");
                  if (le instanceof y.Dict)
                    for (let he of le.getRawValues()) {
                      if (he instanceof y.Ref) {
                        if (ge.has(he))
                          continue;
                        try {
                          he = pe.fetch(he);
                        } catch (Ce) {
                          ge.put(he), (0, g.info)(`hasBlendModes - ignoring ExtGState: "${Ce}".`);
                          continue;
                        }
                      }
                      if (!(he instanceof y.Dict))
                        continue;
                      he.objId && ge.put(he.objId);
                      const ye = he.get("BM");
                      if (ye instanceof y.Name) {
                        if (ye.name !== "Normal")
                          return !0;
                        continue;
                      }
                      if (ye !== void 0 && Array.isArray(ye)) {
                        for (const Ce of ye)
                          if (Ce instanceof y.Name && Ce.name !== "Normal")
                            return !0;
                      }
                    }
                  const ve = be.get("XObject");
                  if (ve instanceof y.Dict)
                    for (let he of ve.getRawValues()) {
                      if (he instanceof y.Ref) {
                        if (ge.has(he))
                          continue;
                        try {
                          he = pe.fetch(he);
                        } catch (Ce) {
                          ge.put(he), (0, g.info)(`hasBlendModes - ignoring XObject: "${Ce}".`);
                          continue;
                        }
                      }
                      if (!(he instanceof R.BaseStream))
                        continue;
                      he.dict.objId && ge.put(he.dict.objId);
                      const ye = he.dict.get("Resources");
                      ye instanceof y.Dict && (ye.objId && ge.has(ye.objId) || (me.push(ye), ye.objId && ge.put(ye.objId)));
                    }
                }
                for (const be of ge)
                  fe.put(be);
                return !1;
              }
              async fetchBuiltInCMap(ie) {
                const fe = this.builtInCMapCache.get(ie);
                if (fe)
                  return fe;
                let ge;
                if (this.options.cMapUrl !== null) {
                  const me = `${this.options.cMapUrl}${ie}.bcmap`, pe = await fetch(me);
                  if (!pe.ok)
                    throw new Error(`fetchBuiltInCMap: failed to fetch file "${me}" with "${pe.statusText}".`);
                  ge = {
                    cMapData: new Uint8Array(await pe.arrayBuffer()),
                    compressionType: g.CMapCompressionType.BINARY
                  };
                } else
                  ge = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                    name: ie
                  });
                return ge.compressionType !== g.CMapCompressionType.NONE && this.builtInCMapCache.set(ie, ge), ge;
              }
              async fetchStandardFontData(ie) {
                const fe = this.standardFontDataCache.get(ie);
                if (fe)
                  return new E.Stream(fe);
                if (this.options.useSystemFonts && ie !== "Symbol" && ie !== "ZapfDingbats")
                  return null;
                const ge = (0, C.getFontNameToFileMap)(), me = ge[ie];
                let pe;
                if (this.options.standardFontDataUrl !== null) {
                  const be = `${this.options.standardFontDataUrl}${me}`, le = await fetch(be);
                  le.ok ? pe = await le.arrayBuffer() : (0, g.warn)(`fetchStandardFontData: failed to fetch file "${be}" with "${le.statusText}".`);
                } else
                  try {
                    pe = await this.handler.sendWithPromise("FetchStandardFontData", {
                      filename: me
                    });
                  } catch (be) {
                    (0, g.warn)(`fetchStandardFontData: failed to fetch file "${me}" with "${be}".`);
                  }
                return pe ? (this.standardFontDataCache.set(ie, pe), new E.Stream(pe)) : null;
              }
              async buildFormXObject(ie, fe, ge, me, pe, be, le) {
                const ve = fe.dict, he = ve.getArray("Matrix");
                let ye = ve.getArray("BBox");
                ye = Array.isArray(ye) && ye.length === 4 ? g.Util.normalizeRect(ye) : null;
                let Ce, xe;
                ve.has("OC") && (Ce = await this.parseMarkedContentProps(ve.get("OC"), ie)), Ce !== void 0 && me.addOp(g.OPS.beginMarkedContentProps, ["OC", Ce]);
                const we = ve.get("Group");
                if (we) {
                  xe = {
                    matrix: he,
                    bbox: ye,
                    smask: ge,
                    isolated: !1,
                    knockout: !1
                  };
                  const Ae = we.get("S");
                  let ue = null;
                  if ((0, y.isName)(Ae, "Transparency") && (xe.isolated = we.get("I") || !1, xe.knockout = we.get("K") || !1, we.has("CS"))) {
                    const ce = we.getRaw("CS"), Ee = L.ColorSpace.getCached(ce, this.xref, le);
                    Ee ? ue = Ee : ue = await this.parseColorSpace({
                      cs: ce,
                      resources: ie,
                      localColorSpaceCache: le
                    });
                  }
                  ge?.backdrop && (ue ||= L.ColorSpace.singletons.rgb, ge.backdrop = ue.getRgb(ge.backdrop, 0)), me.addOp(g.OPS.beginGroup, [xe]);
                }
                const $e = we ? [he, null] : [he, ye];
                return me.addOp(g.OPS.paintFormXObjectBegin, $e), this.getOperatorList({
                  stream: fe,
                  task: pe,
                  resources: ve.get("Resources") || ie,
                  operatorList: me,
                  initialState: be
                }).then(function() {
                  me.addOp(g.OPS.paintFormXObjectEnd, []), we && me.addOp(g.OPS.endGroup, [xe]), Ce !== void 0 && me.addOp(g.OPS.endMarkedContent, []);
                });
              }
              _sendImgData(ie, fe, ge = !1) {
                const me = fe ? [fe.bitmap || fe.data.buffer] : null;
                return this.parsingType3Font || ge ? this.handler.send("commonobj", [ie, "Image", fe], me) : this.handler.send("obj", [ie, this.pageIndex, "Image", fe], me);
              }
              async buildPaintImageXObject({
                resources: ie,
                image: fe,
                isInline: ge = !1,
                operatorList: me,
                cacheKey: pe,
                localImageCache: be,
                localColorSpaceCache: le
              }) {
                const ve = fe.dict, he = ve.objId, ye = ve.get("W", "Width"), Ce = ve.get("H", "Height");
                if (!(ye && typeof ye == "number") || !(Ce && typeof Ce == "number")) {
                  (0, g.warn)("Image dimensions are missing, or not numbers.");
                  return;
                }
                const xe = this.options.maxImageSize;
                if (xe !== -1 && ye * Ce > xe) {
                  const Te = "Image exceeded maximum allowed size and was removed.";
                  if (this.options.ignoreErrors) {
                    (0, g.warn)(Te);
                    return;
                  }
                  throw new Error(Te);
                }
                let we;
                ve.has("OC") && (we = await this.parseMarkedContentProps(ve.get("OC"), ie));
                const $e = ve.get("IM", "ImageMask") || !1;
                let Ae, ue;
                if ($e) {
                  const Te = ve.get("I", "Interpolate"), ke = ye + 7 >> 3, Re = fe.getBytes(ke * Ce), Be = ve.getArray("D", "Decode");
                  if (this.parsingType3Font) {
                    if (Ae = P.PDFImage.createRawMask({
                      imgArray: Re,
                      width: ye,
                      height: Ce,
                      imageIsFromDecodeStream: fe instanceof B.DecodeStream,
                      inverseDecode: Be?.[0] > 0,
                      interpolate: Te
                    }), Ae.cached = !!pe, ue = [Ae], me.addImageOps(g.OPS.paintImageMaskXObject, ue, we), pe) {
                      const Me = {
                        fn: g.OPS.paintImageMaskXObject,
                        args: ue,
                        optionalContent: we
                      };
                      be.set(pe, he, Me), he && this._regionalImageCache.set(null, he, Me);
                    }
                    return;
                  }
                  if (Ae = await P.PDFImage.createMask({
                    imgArray: Re,
                    width: ye,
                    height: Ce,
                    imageIsFromDecodeStream: fe instanceof B.DecodeStream,
                    inverseDecode: Be?.[0] > 0,
                    interpolate: Te,
                    isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
                  }), Ae.isSingleOpaquePixel) {
                    if (me.addImageOps(g.OPS.paintSolidColorImageMask, [], we), pe) {
                      const Me = {
                        fn: g.OPS.paintSolidColorImageMask,
                        args: [],
                        optionalContent: we
                      };
                      be.set(pe, he, Me), he && this._regionalImageCache.set(null, he, Me);
                    }
                    return;
                  }
                  const Oe = `mask_${this.idFactory.createObjId()}`;
                  if (me.addDependency(Oe), this._sendImgData(Oe, Ae), ue = [{
                    data: Oe,
                    width: Ae.width,
                    height: Ae.height,
                    interpolate: Ae.interpolate,
                    count: 1
                  }], me.addImageOps(g.OPS.paintImageMaskXObject, ue, we), pe) {
                    const Me = {
                      fn: g.OPS.paintImageMaskXObject,
                      args: ue,
                      optionalContent: we
                    };
                    be.set(pe, he, Me), he && this._regionalImageCache.set(null, he, Me);
                  }
                  return;
                }
                if (ge && !ve.has("SMask") && !ve.has("Mask") && ye + Ce < 200) {
                  Ae = await new P.PDFImage({
                    xref: this.xref,
                    res: ie,
                    image: fe,
                    isInline: ge,
                    pdfFunctionFactory: this._pdfFunctionFactory,
                    localColorSpaceCache: le
                  }).createImageData(!0, !1), me.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported, me.addImageOps(g.OPS.paintInlineImageXObject, [Ae], we);
                  return;
                }
                let Ee = `img_${this.idFactory.createObjId()}`, _e = !1;
                if (this.parsingType3Font ? Ee = `${this.idFactory.getDocId()}_type3_${Ee}` : he && (_e = this.globalImageCache.shouldCache(he, this.pageIndex), _e && (Ee = `${this.idFactory.getDocId()}_${Ee}`)), me.addDependency(Ee), ue = [Ee, ye, Ce], P.PDFImage.buildImage({
                  xref: this.xref,
                  res: ie,
                  image: fe,
                  isInline: ge,
                  pdfFunctionFactory: this._pdfFunctionFactory,
                  localColorSpaceCache: le
                }).then(async (Te) => {
                  if (Ae = await Te.createImageData(!1, this.options.isOffscreenCanvasSupported), pe && he && _e) {
                    const ke = Ae.bitmap ? Ae.width * Ae.height * 4 : Ae.data.length;
                    this.globalImageCache.addByteSize(he, ke);
                  }
                  return this._sendImgData(Ee, Ae, _e);
                }).catch((Te) => ((0, g.warn)(`Unable to decode image "${Ee}": "${Te}".`), this._sendImgData(Ee, null, _e))), me.addImageOps(g.OPS.paintImageXObject, ue, we), pe) {
                  const Te = {
                    fn: g.OPS.paintImageXObject,
                    args: ue,
                    optionalContent: we
                  };
                  be.set(pe, he, Te), he && (this._regionalImageCache.set(null, he, Te), _e && ((0, g.assert)(!ge, "Cannot cache an inline image globally."), this.globalImageCache.setData(he, {
                    objId: Ee,
                    fn: g.OPS.paintImageXObject,
                    args: ue,
                    optionalContent: we,
                    byteSize: 0
                  })));
                }
              }
              handleSMask(ie, fe, ge, me, pe, be) {
                const le = ie.get("G"), ve = {
                  subtype: ie.get("S").name,
                  backdrop: ie.get("BC")
                }, he = ie.get("TR");
                if ((0, T.isPDFFunction)(he)) {
                  const ye = this._pdfFunctionFactory.create(he), Ce = new Uint8Array(256), xe = new Float32Array(1);
                  for (let we = 0; we < 256; we++)
                    xe[0] = we / 255, ye(xe, 0, xe, 0), Ce[we] = xe[0] * 255 | 0;
                  ve.transferMap = Ce;
                }
                return this.buildFormXObject(fe, le, ve, ge, me, pe.state.clone(), be);
              }
              handleTransferFunction(ie) {
                let fe;
                if (Array.isArray(ie))
                  fe = ie;
                else if ((0, T.isPDFFunction)(ie))
                  fe = [ie];
                else
                  return null;
                const ge = [];
                let me = 0, pe = 0;
                for (const be of fe) {
                  const le = this.xref.fetchIfRef(be);
                  if (me++, (0, y.isName)(le, "Identity")) {
                    ge.push(null);
                    continue;
                  } else if (!(0, T.isPDFFunction)(le))
                    return null;
                  const ve = this._pdfFunctionFactory.create(le), he = new Uint8Array(256), ye = new Float32Array(1);
                  for (let Ce = 0; Ce < 256; Ce++)
                    ye[0] = Ce / 255, ve(ye, 0, ye, 0), he[Ce] = ye[0] * 255 | 0;
                  ge.push(he), pe++;
                }
                return !(me === 1 || me === 4) || pe === 0 ? null : ge;
              }
              handleTilingType(ie, fe, ge, me, pe, be, le, ve) {
                const he = new N.OperatorList(), ye = y.Dict.merge({
                  xref: this.xref,
                  dictArray: [pe.get("Resources"), ge]
                });
                return this.getOperatorList({
                  stream: me,
                  task: le,
                  resources: ye,
                  operatorList: he
                }).then(function() {
                  const Ce = he.getIR(), xe = (0, w.getTilingPatternIR)(Ce, pe, fe);
                  be.addDependencies(he.dependencies), be.addOp(ie, xe), pe.objId && ve.set(null, pe.objId, {
                    operatorListIR: Ce,
                    dict: pe
                  });
                }).catch((Ce) => {
                  if (!(Ce instanceof g.AbortException)) {
                    if (this.options.ignoreErrors) {
                      (0, g.warn)(`handleTilingType - ignoring pattern: "${Ce}".`);
                      return;
                    }
                    throw Ce;
                  }
                });
              }
              handleSetFont(ie, fe, ge, me, pe, be, le = null, ve = null) {
                const he = fe?.[0] instanceof y.Name ? fe[0].name : null;
                return this.loadFont(he, ge, ie, le, ve).then((ye) => ye.font.isType3Font ? ye.loadType3Data(this, ie, pe).then(function() {
                  return me.addDependencies(ye.type3Dependencies), ye;
                }).catch((Ce) => new ee({
                  loadedName: "g_font_error",
                  font: new f.ErrorFont(`Type3 font load error: ${Ce}`),
                  dict: ye.font,
                  evaluatorOptions: this.options
                })) : ye).then((ye) => (be.font = ye.font, ye.send(this.handler), ye.loadedName));
              }
              handleText(ie, fe) {
                const ge = fe.font, me = ge.charsToGlyphs(ie);
                return ge.data && (fe.textRenderingMode & g.TextRenderingMode.ADD_TO_PATH_FLAG || fe.fillColorSpace.name === "Pattern" || ge.disableFontFace || this.options.disableFontFace) && Y.buildFontPaths(ge, me, this.handler, this.options), me;
              }
              ensureStateFont(ie) {
                if (ie.font)
                  return;
                const fe = new g.FormatError("Missing setFont (Tf) operator before text rendering operator.");
                if (this.options.ignoreErrors) {
                  (0, g.warn)(`ensureStateFont: "${fe}".`);
                  return;
                }
                throw fe;
              }
              async setGState({
                resources: ie,
                gState: fe,
                operatorList: ge,
                cacheKey: me,
                task: pe,
                stateManager: be,
                localGStateCache: le,
                localColorSpaceCache: ve
              }) {
                const he = fe.objId;
                let ye = !0;
                const Ce = [];
                let xe = Promise.resolve();
                for (const we of fe.getKeys()) {
                  const $e = fe.get(we);
                  switch (we) {
                    case "Type":
                      break;
                    case "LW":
                    case "LC":
                    case "LJ":
                    case "ML":
                    case "D":
                    case "RI":
                    case "FL":
                    case "CA":
                    case "ca":
                      Ce.push([we, $e]);
                      break;
                    case "Font":
                      ye = !1, xe = xe.then(() => this.handleSetFont(ie, null, $e[0], ge, pe, be.state).then(function(ue) {
                        ge.addDependency(ue), Ce.push([we, [ue, $e[1]]]);
                      }));
                      break;
                    case "BM":
                      Ce.push([we, ne($e)]);
                      break;
                    case "SMask":
                      if ((0, y.isName)($e, "None")) {
                        Ce.push([we, !1]);
                        break;
                      }
                      $e instanceof y.Dict ? (ye = !1, xe = xe.then(() => this.handleSMask($e, ie, ge, pe, be, ve)), Ce.push([we, !0])) : (0, g.warn)("Unsupported SMask type");
                      break;
                    case "TR":
                      const Ae = this.handleTransferFunction($e);
                      Ce.push([we, Ae]);
                      break;
                    case "OP":
                    case "op":
                    case "OPM":
                    case "BG":
                    case "BG2":
                    case "UCR":
                    case "UCR2":
                    case "TR2":
                    case "HT":
                    case "SM":
                    case "SA":
                    case "AIS":
                    case "TK":
                      (0, g.info)("graphic state operator " + we);
                      break;
                    default:
                      (0, g.info)("Unknown graphic state operator " + we);
                      break;
                  }
                }
                return xe.then(function() {
                  Ce.length > 0 && ge.addOp(g.OPS.setGState, [Ce]), ye && le.set(me, he, Ce);
                });
              }
              loadFont(ie, fe, ge, me = null, pe = null) {
                const be = async () => new ee({
                  loadedName: "g_font_error",
                  font: new f.ErrorFont(`Font "${ie}" is not available.`),
                  dict: fe,
                  evaluatorOptions: this.options
                });
                let le;
                if (fe)
                  fe instanceof y.Ref && (le = fe);
                else {
                  const $e = ge.get("Font");
                  $e && (le = $e.getRaw(ie));
                }
                if (le) {
                  if (this.parsingType3Font && this.type3FontRefs.has(le))
                    return be();
                  if (this.fontCache.has(le))
                    return this.fontCache.get(le);
                  fe = this.xref.fetchIfRef(le);
                }
                if (!(fe instanceof y.Dict)) {
                  if (!this.options.ignoreErrors && !this.parsingType3Font)
                    return (0, g.warn)(`Font "${ie}" is not available.`), be();
                  (0, g.warn)(`Font "${ie}" is not available -- attempting to fallback to a default font.`), fe = me || Y.fallbackFontDict;
                }
                if (fe.cacheKey && this.fontCache.has(fe.cacheKey))
                  return this.fontCache.get(fe.cacheKey);
                const ve = new g.PromiseCapability();
                let he;
                try {
                  he = this.preEvaluateFont(fe), he.cssFontInfo = pe;
                } catch ($e) {
                  return (0, g.warn)(`loadFont - preEvaluateFont failed: "${$e}".`), be();
                }
                const {
                  descriptor: ye,
                  hash: Ce
                } = he, xe = le instanceof y.Ref;
                let we;
                if (Ce && ye instanceof y.Dict) {
                  const $e = ye.fontAliases ||= /* @__PURE__ */ Object.create(null);
                  if ($e[Ce]) {
                    const Ae = $e[Ce].aliasRef;
                    if (xe && Ae && this.fontCache.has(Ae))
                      return this.fontCache.putAlias(le, Ae), this.fontCache.get(le);
                  } else
                    $e[Ce] = {
                      fontID: this.idFactory.createFontId()
                    };
                  xe && ($e[Ce].aliasRef = le), we = $e[Ce].fontID;
                } else
                  we = this.idFactory.createFontId();
                return (0, g.assert)(we?.startsWith("f"), 'The "fontID" must be (correctly) defined.'), xe ? this.fontCache.put(le, ve.promise) : (fe.cacheKey = `cacheKey_${we}`, this.fontCache.put(fe.cacheKey, ve.promise)), fe.loadedName = `${this.idFactory.getDocId()}_${we}`, this.translateFont(he).then(($e) => {
                  ve.resolve(new ee({
                    loadedName: fe.loadedName,
                    font: $e,
                    dict: fe,
                    evaluatorOptions: this.options
                  }));
                }).catch(($e) => {
                  (0, g.warn)(`loadFont - translateFont failed: "${$e}".`), ve.resolve(new ee({
                    loadedName: fe.loadedName,
                    font: new f.ErrorFont($e instanceof Error ? $e.message : $e),
                    dict: fe,
                    evaluatorOptions: this.options
                  }));
                }), ve.promise;
              }
              buildPath(ie, fe, ge, me = !1) {
                const pe = ie.length - 1;
                if (ge || (ge = []), pe < 0 || ie.fnArray[pe] !== g.OPS.constructPath) {
                  me && ((0, g.warn)(`Encountered path operator "${fe}" inside of a text object.`), ie.addOp(g.OPS.save, null));
                  let be;
                  switch (fe) {
                    case g.OPS.rectangle:
                      const le = ge[0] + ge[2], ve = ge[1] + ge[3];
                      be = [Math.min(ge[0], le), Math.max(ge[0], le), Math.min(ge[1], ve), Math.max(ge[1], ve)];
                      break;
                    case g.OPS.moveTo:
                    case g.OPS.lineTo:
                      be = [ge[0], ge[0], ge[1], ge[1]];
                      break;
                    default:
                      be = [1 / 0, -1 / 0, 1 / 0, -1 / 0];
                      break;
                  }
                  ie.addOp(g.OPS.constructPath, [[fe], ge, be]), me && ie.addOp(g.OPS.restore, null);
                } else {
                  const be = ie.argsArray[pe];
                  be[0].push(fe), be[1].push(...ge);
                  const le = be[2];
                  switch (fe) {
                    case g.OPS.rectangle:
                      const ve = ge[0] + ge[2], he = ge[1] + ge[3];
                      le[0] = Math.min(le[0], ge[0], ve), le[1] = Math.max(le[1], ge[0], ve), le[2] = Math.min(le[2], ge[1], he), le[3] = Math.max(le[3], ge[1], he);
                      break;
                    case g.OPS.moveTo:
                    case g.OPS.lineTo:
                      le[0] = Math.min(le[0], ge[0]), le[1] = Math.max(le[1], ge[0]), le[2] = Math.min(le[2], ge[1]), le[3] = Math.max(le[3], ge[1]);
                      break;
                  }
                }
              }
              parseColorSpace({
                cs: ie,
                resources: fe,
                localColorSpaceCache: ge
              }) {
                return L.ColorSpace.parseAsync({
                  cs: ie,
                  xref: this.xref,
                  resources: fe,
                  pdfFunctionFactory: this._pdfFunctionFactory,
                  localColorSpaceCache: ge
                }).catch((me) => {
                  if (me instanceof g.AbortException)
                    return null;
                  if (this.options.ignoreErrors)
                    return (0, g.warn)(`parseColorSpace - ignoring ColorSpace: "${me}".`), null;
                  throw me;
                });
              }
              parseShading({
                shading: ie,
                resources: fe,
                localColorSpaceCache: ge,
                localShadingPatternCache: me
              }) {
                let pe = me.get(ie);
                if (!pe) {
                  var be = w.Pattern.parseShading(ie, this.xref, fe, this._pdfFunctionFactory, ge);
                  const le = be.getIR();
                  pe = `pattern_${this.idFactory.createObjId()}`, this.parsingType3Font && (pe = `${this.idFactory.getDocId()}_type3_${pe}`), me.set(ie, pe), this.parsingType3Font ? this.handler.send("commonobj", [pe, "Pattern", le]) : this.handler.send("obj", [pe, this.pageIndex, "Pattern", le]);
                }
                return pe;
              }
              handleColorN(ie, fe, ge, me, pe, be, le, ve, he, ye) {
                const Ce = ge.pop();
                if (Ce instanceof y.Name) {
                  const xe = pe.getRaw(Ce.name), we = xe instanceof y.Ref && he.getByRef(xe);
                  if (we)
                    try {
                      const Ae = me.base ? me.base.getRgb(ge, 0) : null, ue = (0, w.getTilingPatternIR)(we.operatorListIR, we.dict, Ae);
                      ie.addOp(fe, ue);
                      return;
                    } catch {
                    }
                  const $e = this.xref.fetchIfRef(xe);
                  if ($e) {
                    const Ae = $e instanceof R.BaseStream ? $e.dict : $e, ue = Ae.get("PatternType");
                    if (ue === H.TILING) {
                      const ce = me.base ? me.base.getRgb(ge, 0) : null;
                      return this.handleTilingType(fe, ce, be, $e, Ae, ie, le, he);
                    } else if (ue === H.SHADING) {
                      const ce = Ae.get("Shading"), Ee = Ae.getArray("Matrix"), _e = this.parseShading({
                        shading: ce,
                        resources: be,
                        localColorSpaceCache: ve,
                        localShadingPatternCache: ye
                      });
                      ie.addOp(fe, ["Shading", _e, Ee]);
                      return;
                    }
                    throw new g.FormatError(`Unknown PatternType: ${ue}`);
                  }
                }
                throw new g.FormatError(`Unknown PatternName: ${Ce}`);
              }
              _parseVisibilityExpression(ie, fe, ge) {
                if (++fe > 10) {
                  (0, g.warn)("Visibility expression is too deeply nested");
                  return;
                }
                const pe = ie.length, be = this.xref.fetchIfRef(ie[0]);
                if (pe < 2 || !(be instanceof y.Name)) {
                  (0, g.warn)("Invalid visibility expression");
                  return;
                }
                switch (be.name) {
                  case "And":
                  case "Or":
                  case "Not":
                    ge.push(be.name);
                    break;
                  default:
                    (0, g.warn)(`Invalid operator ${be.name} in visibility expression`);
                    return;
                }
                for (let le = 1; le < pe; le++) {
                  const ve = ie[le], he = this.xref.fetchIfRef(ve);
                  if (Array.isArray(he)) {
                    const ye = [];
                    ge.push(ye), this._parseVisibilityExpression(he, fe, ye);
                  } else ve instanceof y.Ref && ge.push(ve.toString());
                }
              }
              async parseMarkedContentProps(ie, fe) {
                let ge;
                if (ie instanceof y.Name)
                  ge = fe.get("Properties").get(ie.name);
                else if (ie instanceof y.Dict)
                  ge = ie;
                else
                  throw new g.FormatError("Optional content properties malformed.");
                const me = ge.get("Type")?.name;
                if (me === "OCG")
                  return {
                    type: me,
                    id: ge.objId
                  };
                if (me === "OCMD") {
                  const pe = ge.get("VE");
                  if (Array.isArray(pe)) {
                    const le = [];
                    if (this._parseVisibilityExpression(pe, 0, le), le.length > 0)
                      return {
                        type: "OCMD",
                        expression: le
                      };
                  }
                  const be = ge.get("OCGs");
                  if (Array.isArray(be) || be instanceof y.Dict) {
                    const le = [];
                    if (Array.isArray(be))
                      for (const ve of be)
                        le.push(ve.toString());
                    else
                      le.push(be.objId);
                    return {
                      type: me,
                      ids: le,
                      policy: ge.get("P") instanceof y.Name ? ge.get("P").name : null,
                      expression: null
                    };
                  } else if (be instanceof y.Ref)
                    return {
                      type: me,
                      id: be.toString()
                    };
                }
                return null;
              }
              getOperatorList({
                stream: ie,
                task: fe,
                resources: ge,
                operatorList: me,
                initialState: pe = null,
                fallbackFontDict: be = null
              }) {
                if (ge ||= y.Dict.empty, pe ||= new te(), !me)
                  throw new Error('getOperatorList: missing "operatorList" parameter');
                const le = this, ve = this.xref;
                let he = !1;
                const ye = new _.LocalImageCache(), Ce = new _.LocalColorSpaceCache(), xe = new _.LocalGStateCache(), we = new _.LocalTilingPatternCache(), $e = /* @__PURE__ */ new Map(), Ae = ge.get("XObject") || y.Dict.empty, ue = ge.get("Pattern") || y.Dict.empty, ce = new Q(pe), Ee = new ae(ie, ve, ce), _e = new q();
                function Te(ke) {
                  for (let Re = 0, Be = Ee.savedStatesDepth; Re < Be; Re++)
                    me.addOp(g.OPS.restore, []);
                }
                return new Promise(function ke(Re, Be) {
                  const Oe = function(Ve) {
                    Promise.all([Ve, me.ready]).then(function() {
                      try {
                        ke(Re, Be);
                      } catch (ut) {
                        Be(ut);
                      }
                    }, Be);
                  };
                  fe.ensureNotTerminated(), _e.reset();
                  const Me = {};
                  let Fe, Ue, je, Le, De, Ne;
                  for (; !(Fe = _e.check()) && (Me.args = null, !!Ee.read(Me)); ) {
                    let Ve = Me.args, ut = Me.fn;
                    switch (ut | 0) {
                      case g.OPS.paintXObject:
                        if (Ne = Ve[0] instanceof y.Name, De = Ve[0].name, Ne) {
                          const Qe = ye.getByName(De);
                          if (Qe) {
                            me.addImageOps(Qe.fn, Qe.args, Qe.optionalContent), K(Qe), Ve = null;
                            continue;
                          }
                        }
                        Oe(new Promise(function(Qe, st) {
                          if (!Ne)
                            throw new g.FormatError("XObject must be referred to by name.");
                          let ft = Ae.getRaw(De);
                          if (ft instanceof y.Ref) {
                            const Pt = ye.getByRef(ft) || le._regionalImageCache.getByRef(ft);
                            if (Pt) {
                              me.addImageOps(Pt.fn, Pt.args, Pt.optionalContent), K(Pt), Qe();
                              return;
                            }
                            const dt = le.globalImageCache.getData(ft, le.pageIndex);
                            if (dt) {
                              me.addDependency(dt.objId), me.addImageOps(dt.fn, dt.args, dt.optionalContent), Qe();
                              return;
                            }
                            ft = ve.fetch(ft);
                          }
                          if (!(ft instanceof R.BaseStream))
                            throw new g.FormatError("XObject should be a stream");
                          const vt = ft.dict.get("Subtype");
                          if (!(vt instanceof y.Name))
                            throw new g.FormatError("XObject should have a Name subtype");
                          if (vt.name === "Form") {
                            ce.save(), le.buildFormXObject(ge, ft, null, me, fe, ce.state.clone(), Ce).then(function() {
                              ce.restore(), Qe();
                            }, st);
                            return;
                          } else if (vt.name === "Image") {
                            le.buildPaintImageXObject({
                              resources: ge,
                              image: ft,
                              operatorList: me,
                              cacheKey: De,
                              localImageCache: ye,
                              localColorSpaceCache: Ce
                            }).then(Qe, st);
                            return;
                          } else if (vt.name === "PS")
                            (0, g.info)("Ignored XObject subtype PS");
                          else
                            throw new g.FormatError(`Unhandled XObject subtype ${vt.name}`);
                          Qe();
                        }).catch(function(Qe) {
                          if (!(Qe instanceof g.AbortException)) {
                            if (le.options.ignoreErrors) {
                              (0, g.warn)(`getOperatorList - ignoring XObject: "${Qe}".`);
                              return;
                            }
                            throw Qe;
                          }
                        }));
                        return;
                      case g.OPS.setFont:
                        var Ge = Ve[1];
                        Oe(le.handleSetFont(ge, Ve, null, me, fe, ce.state, be).then(function(Qe) {
                          me.addDependency(Qe), me.addOp(g.OPS.setFont, [Qe, Ge]);
                        }));
                        return;
                      case g.OPS.beginText:
                        he = !0;
                        break;
                      case g.OPS.endText:
                        he = !1;
                        break;
                      case g.OPS.endInlineImage:
                        var Xe = Ve[0].cacheKey;
                        if (Xe) {
                          const Qe = ye.getByName(Xe);
                          if (Qe) {
                            me.addImageOps(Qe.fn, Qe.args, Qe.optionalContent), K(Qe), Ve = null;
                            continue;
                          }
                        }
                        Oe(le.buildPaintImageXObject({
                          resources: ge,
                          image: Ve[0],
                          isInline: !0,
                          operatorList: me,
                          cacheKey: Xe,
                          localImageCache: ye,
                          localColorSpaceCache: Ce
                        }));
                        return;
                      case g.OPS.showText:
                        if (!ce.state.font) {
                          le.ensureStateFont(ce.state);
                          continue;
                        }
                        Ve[0] = le.handleText(Ve[0], ce.state);
                        break;
                      case g.OPS.showSpacedText:
                        if (!ce.state.font) {
                          le.ensureStateFont(ce.state);
                          continue;
                        }
                        var nt = [], ct = ce.state;
                        for (const Qe of Ve[0])
                          typeof Qe == "string" ? nt.push(...le.handleText(Qe, ct)) : typeof Qe == "number" && nt.push(Qe);
                        Ve[0] = nt, ut = g.OPS.showText;
                        break;
                      case g.OPS.nextLineShowText:
                        if (!ce.state.font) {
                          le.ensureStateFont(ce.state);
                          continue;
                        }
                        me.addOp(g.OPS.nextLine), Ve[0] = le.handleText(Ve[0], ce.state), ut = g.OPS.showText;
                        break;
                      case g.OPS.nextLineSetSpacingShowText:
                        if (!ce.state.font) {
                          le.ensureStateFont(ce.state);
                          continue;
                        }
                        me.addOp(g.OPS.nextLine), me.addOp(g.OPS.setWordSpacing, [Ve.shift()]), me.addOp(g.OPS.setCharSpacing, [Ve.shift()]), Ve[0] = le.handleText(Ve[0], ce.state), ut = g.OPS.showText;
                        break;
                      case g.OPS.setTextRenderingMode:
                        ce.state.textRenderingMode = Ve[0];
                        break;
                      case g.OPS.setFillColorSpace: {
                        const Qe = L.ColorSpace.getCached(Ve[0], ve, Ce);
                        if (Qe) {
                          ce.state.fillColorSpace = Qe;
                          continue;
                        }
                        Oe(le.parseColorSpace({
                          cs: Ve[0],
                          resources: ge,
                          localColorSpaceCache: Ce
                        }).then(function(st) {
                          st && (ce.state.fillColorSpace = st);
                        }));
                        return;
                      }
                      case g.OPS.setStrokeColorSpace: {
                        const Qe = L.ColorSpace.getCached(Ve[0], ve, Ce);
                        if (Qe) {
                          ce.state.strokeColorSpace = Qe;
                          continue;
                        }
                        Oe(le.parseColorSpace({
                          cs: Ve[0],
                          resources: ge,
                          localColorSpaceCache: Ce
                        }).then(function(st) {
                          st && (ce.state.strokeColorSpace = st);
                        }));
                        return;
                      }
                      case g.OPS.setFillColor:
                        Le = ce.state.fillColorSpace, Ve = Le.getRgb(Ve, 0), ut = g.OPS.setFillRGBColor;
                        break;
                      case g.OPS.setStrokeColor:
                        Le = ce.state.strokeColorSpace, Ve = Le.getRgb(Ve, 0), ut = g.OPS.setStrokeRGBColor;
                        break;
                      case g.OPS.setFillGray:
                        ce.state.fillColorSpace = L.ColorSpace.singletons.gray, Ve = L.ColorSpace.singletons.gray.getRgb(Ve, 0), ut = g.OPS.setFillRGBColor;
                        break;
                      case g.OPS.setStrokeGray:
                        ce.state.strokeColorSpace = L.ColorSpace.singletons.gray, Ve = L.ColorSpace.singletons.gray.getRgb(Ve, 0), ut = g.OPS.setStrokeRGBColor;
                        break;
                      case g.OPS.setFillCMYKColor:
                        ce.state.fillColorSpace = L.ColorSpace.singletons.cmyk, Ve = L.ColorSpace.singletons.cmyk.getRgb(Ve, 0), ut = g.OPS.setFillRGBColor;
                        break;
                      case g.OPS.setStrokeCMYKColor:
                        ce.state.strokeColorSpace = L.ColorSpace.singletons.cmyk, Ve = L.ColorSpace.singletons.cmyk.getRgb(Ve, 0), ut = g.OPS.setStrokeRGBColor;
                        break;
                      case g.OPS.setFillRGBColor:
                        ce.state.fillColorSpace = L.ColorSpace.singletons.rgb, Ve = L.ColorSpace.singletons.rgb.getRgb(Ve, 0);
                        break;
                      case g.OPS.setStrokeRGBColor:
                        ce.state.strokeColorSpace = L.ColorSpace.singletons.rgb, Ve = L.ColorSpace.singletons.rgb.getRgb(Ve, 0);
                        break;
                      case g.OPS.setFillColorN:
                        if (Le = ce.state.fillColorSpace, Le.name === "Pattern") {
                          Oe(le.handleColorN(me, g.OPS.setFillColorN, Ve, Le, ue, ge, fe, Ce, we, $e));
                          return;
                        }
                        Ve = Le.getRgb(Ve, 0), ut = g.OPS.setFillRGBColor;
                        break;
                      case g.OPS.setStrokeColorN:
                        if (Le = ce.state.strokeColorSpace, Le.name === "Pattern") {
                          Oe(le.handleColorN(me, g.OPS.setStrokeColorN, Ve, Le, ue, ge, fe, Ce, we, $e));
                          return;
                        }
                        Ve = Le.getRgb(Ve, 0), ut = g.OPS.setStrokeRGBColor;
                        break;
                      case g.OPS.shadingFill:
                        var it = ge.get("Shading");
                        if (!it)
                          throw new g.FormatError("No shading resource found");
                        var We = it.get(Ve[0].name);
                        if (!We)
                          throw new g.FormatError("No shading object found");
                        Ve = [le.parseShading({
                          shading: We,
                          resources: ge,
                          localColorSpaceCache: Ce,
                          localShadingPatternCache: $e
                        })], ut = g.OPS.shadingFill;
                        break;
                      case g.OPS.setGState:
                        if (Ne = Ve[0] instanceof y.Name, De = Ve[0].name, Ne) {
                          const Qe = xe.getByName(De);
                          if (Qe) {
                            Qe.length > 0 && me.addOp(g.OPS.setGState, [Qe]), Ve = null;
                            continue;
                          }
                        }
                        Oe(new Promise(function(Qe, st) {
                          if (!Ne)
                            throw new g.FormatError("GState must be referred to by name.");
                          const ft = ge.get("ExtGState");
                          if (!(ft instanceof y.Dict))
                            throw new g.FormatError("ExtGState should be a dictionary.");
                          const vt = ft.get(De);
                          if (!(vt instanceof y.Dict))
                            throw new g.FormatError("GState should be a dictionary.");
                          le.setGState({
                            resources: ge,
                            gState: vt,
                            operatorList: me,
                            cacheKey: De,
                            task: fe,
                            stateManager: ce,
                            localGStateCache: xe,
                            localColorSpaceCache: Ce
                          }).then(Qe, st);
                        }).catch(function(Qe) {
                          if (!(Qe instanceof g.AbortException)) {
                            if (le.options.ignoreErrors) {
                              (0, g.warn)(`getOperatorList - ignoring ExtGState: "${Qe}".`);
                              return;
                            }
                            throw Qe;
                          }
                        }));
                        return;
                      case g.OPS.moveTo:
                      case g.OPS.lineTo:
                      case g.OPS.curveTo:
                      case g.OPS.curveTo2:
                      case g.OPS.curveTo3:
                      case g.OPS.closePath:
                      case g.OPS.rectangle:
                        le.buildPath(me, ut, Ve, he);
                        continue;
                      case g.OPS.markPoint:
                      case g.OPS.markPointProps:
                      case g.OPS.beginCompat:
                      case g.OPS.endCompat:
                        continue;
                      case g.OPS.beginMarkedContentProps:
                        if (!(Ve[0] instanceof y.Name)) {
                          (0, g.warn)(`Expected name for beginMarkedContentProps arg0=${Ve[0]}`);
                          continue;
                        }
                        if (Ve[0].name === "OC") {
                          Oe(le.parseMarkedContentProps(Ve[1], ge).then((Qe) => {
                            me.addOp(g.OPS.beginMarkedContentProps, ["OC", Qe]);
                          }).catch((Qe) => {
                            if (!(Qe instanceof g.AbortException)) {
                              if (le.options.ignoreErrors) {
                                (0, g.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${Qe}".`);
                                return;
                              }
                              throw Qe;
                            }
                          }));
                          return;
                        }
                        Ve = [Ve[0].name, Ve[1] instanceof y.Dict ? Ve[1].get("MCID") : null];
                        break;
                      case g.OPS.beginMarkedContent:
                      case g.OPS.endMarkedContent:
                      default:
                        if (Ve !== null) {
                          for (Ue = 0, je = Ve.length; Ue < je && !(Ve[Ue] instanceof y.Dict); Ue++)
                            ;
                          if (Ue < je) {
                            (0, g.warn)("getOperatorList - ignoring operator: " + ut);
                            continue;
                          }
                        }
                    }
                    me.addOp(ut, Ve);
                  }
                  if (Fe) {
                    Oe(Z);
                    return;
                  }
                  Te(), Re();
                }).catch((ke) => {
                  if (!(ke instanceof g.AbortException)) {
                    if (this.options.ignoreErrors) {
                      (0, g.warn)(`getOperatorList - ignoring errors during "${fe.name}" task: "${ke}".`), Te();
                      return;
                    }
                    throw ke;
                  }
                });
              }
              getTextContent({
                stream: ie,
                task: fe,
                resources: ge,
                stateManager: me = null,
                includeMarkedContent: pe = !1,
                sink: be,
                seenStyles: le = /* @__PURE__ */ new Set(),
                viewBox: ve,
                markedContentData: he = null,
                disableNormalization: ye = !1
              }) {
                ge ||= y.Dict.empty, me ||= new Q(new J()), pe && (he ||= {
                  level: 0
                });
                const Ce = {
                  items: [],
                  styles: /* @__PURE__ */ Object.create(null)
                }, xe = {
                  initialized: !1,
                  str: [],
                  totalWidth: 0,
                  totalHeight: 0,
                  width: 0,
                  height: 0,
                  vertical: !1,
                  prevTransform: null,
                  textAdvanceScale: 0,
                  spaceInFlowMin: 0,
                  spaceInFlowMax: 0,
                  trackingSpaceMin: 1 / 0,
                  negativeSpaceMax: -1 / 0,
                  notASpace: -1 / 0,
                  transform: null,
                  fontName: null,
                  hasEOL: !1
                }, we = [" ", " "];
                let $e = 0;
                function Ae(dt) {
                  const mt = ($e + 1) % 2, pt = we[$e] !== " " && we[mt] === " ";
                  return we[$e] = dt, $e = mt, pt;
                }
                function ue() {
                  return we[$e] !== " " && we[($e + 1) % 2] === " ";
                }
                function ce() {
                  we[0] = we[1] = " ", $e = 0;
                }
                const Ee = 0.102, _e = 0.03, Te = -0.2, ke = 0.102, Re = 0.6, Be = 0.25, Oe = this, Me = this.xref, Fe = [];
                let Ue = null;
                const je = new _.LocalImageCache(), Le = new _.LocalGStateCache(), De = new ae(ie, Me, me);
                let Ne;
                function Ge({
                  width: dt = 0,
                  height: mt = 0,
                  transform: pt = xe.prevTransform,
                  fontName: Et = xe.fontName
                }) {
                  Ce.items.push({
                    str: " ",
                    dir: "ltr",
                    width: dt,
                    height: mt,
                    transform: pt,
                    fontName: Et,
                    hasEOL: !1
                  });
                }
                function Xe() {
                  const dt = Ne.font, mt = [Ne.fontSize * Ne.textHScale, 0, 0, Ne.fontSize, 0, Ne.textRise];
                  if (dt.isType3Font && (Ne.fontSize <= 1 || dt.isCharBBox) && !(0, g.isArrayEqual)(Ne.fontMatrix, g.FONT_IDENTITY_MATRIX)) {
                    const pt = dt.bbox[3] - dt.bbox[1];
                    pt > 0 && (mt[3] *= pt * Ne.fontMatrix[3]);
                  }
                  return g.Util.transform(Ne.ctm, g.Util.transform(Ne.textMatrix, mt));
                }
                function nt() {
                  if (xe.initialized)
                    return xe;
                  const {
                    font: dt,
                    loadedName: mt
                  } = Ne;
                  le.has(mt) || (le.add(mt), Ce.styles[mt] = {
                    fontFamily: dt.fallbackName,
                    ascent: dt.ascent,
                    descent: dt.descent,
                    vertical: dt.vertical
                  }), xe.fontName = mt;
                  const pt = xe.transform = Xe();
                  dt.vertical ? (xe.width = xe.totalWidth = Math.hypot(pt[0], pt[1]), xe.height = xe.totalHeight = 0, xe.vertical = !0) : (xe.width = xe.totalWidth = 0, xe.height = xe.totalHeight = Math.hypot(pt[2], pt[3]), xe.vertical = !1);
                  const Et = Math.hypot(Ne.textLineMatrix[0], Ne.textLineMatrix[1]), Mt = Math.hypot(Ne.ctm[0], Ne.ctm[1]);
                  xe.textAdvanceScale = Mt * Et;
                  const {
                    fontSize: Nt
                  } = Ne;
                  return xe.trackingSpaceMin = Nt * Ee, xe.notASpace = Nt * _e, xe.negativeSpaceMax = Nt * Te, xe.spaceInFlowMin = Nt * ke, xe.spaceInFlowMax = Nt * Re, xe.hasEOL = !1, xe.initialized = !0, xe;
                }
                function ct() {
                  if (!xe.initialized)
                    return;
                  const dt = Math.hypot(Ne.textLineMatrix[0], Ne.textLineMatrix[1]), pt = Math.hypot(Ne.ctm[0], Ne.ctm[1]) * dt;
                  pt !== xe.textAdvanceScale && (xe.vertical ? (xe.totalHeight += xe.height * xe.textAdvanceScale, xe.height = 0) : (xe.totalWidth += xe.width * xe.textAdvanceScale, xe.width = 0), xe.textAdvanceScale = pt);
                }
                function it(dt) {
                  let mt = dt.str.join("");
                  ye || (mt = (0, g.normalizeUnicode)(mt));
                  const pt = (0, O.bidi)(mt, -1, dt.vertical);
                  return {
                    str: pt.str,
                    dir: pt.dir,
                    width: Math.abs(dt.totalWidth),
                    height: Math.abs(dt.totalHeight),
                    transform: dt.transform,
                    fontName: dt.fontName,
                    hasEOL: dt.hasEOL
                  };
                }
                function We(dt, mt) {
                  return Oe.loadFont(dt, mt, ge).then(function(pt) {
                    return pt.font.isType3Font ? pt.loadType3Data(Oe, ge, fe).catch(function() {
                    }).then(function() {
                      return pt;
                    }) : pt;
                  }).then(function(pt) {
                    Ne.loadedName = pt.loadedName, Ne.font = pt.font, Ne.fontMatrix = pt.font.fontMatrix || g.FONT_IDENTITY_MATRIX;
                  });
                }
                function Ve(dt, mt, pt) {
                  const Et = Math.hypot(pt[0], pt[1]);
                  return [(pt[0] * dt + pt[1] * mt) / Et, (pt[2] * dt + pt[3] * mt) / Et];
                }
                function ut(dt) {
                  const mt = Xe();
                  let pt = mt[4], Et = mt[5];
                  if (Ne.font?.vertical) {
                    if (pt < ve[0] || pt > ve[2] || Et + dt < ve[1] || Et > ve[3])
                      return !1;
                  } else if (pt + dt < ve[0] || pt > ve[2] || Et < ve[1] || Et > ve[3])
                    return !1;
                  if (!Ne.font || !xe.prevTransform)
                    return !0;
                  let Mt = xe.prevTransform[4], Nt = xe.prevTransform[5];
                  if (Mt === pt && Nt === Et)
                    return !0;
                  let _t = -1;
                  switch (mt[0] && mt[1] === 0 && mt[2] === 0 ? _t = mt[0] > 0 ? 0 : 180 : mt[1] && mt[0] === 0 && mt[3] === 0 && (_t = mt[1] > 0 ? 90 : 270), _t) {
                    case 0:
                      break;
                    case 90:
                      [pt, Et] = [Et, pt], [Mt, Nt] = [Nt, Mt];
                      break;
                    case 180:
                      [pt, Et, Mt, Nt] = [-pt, -Et, -Mt, -Nt];
                      break;
                    case 270:
                      [pt, Et] = [-Et, -pt], [Mt, Nt] = [-Nt, -Mt];
                      break;
                    default:
                      [pt, Et] = Ve(pt, Et, mt), [Mt, Nt] = Ve(Mt, Nt, xe.prevTransform);
                  }
                  if (Ne.font.vertical) {
                    const Ye = (Nt - Et) / xe.textAdvanceScale, tt = pt - Mt, Ke = Math.sign(xe.height);
                    return Ye < Ke * xe.negativeSpaceMax ? Math.abs(tt) > 0.5 * xe.width ? (Qe(), !0) : (ce(), ft(), !0) : Math.abs(tt) > xe.width ? (Qe(), !0) : (Ye <= Ke * xe.notASpace && ce(), Ye <= Ke * xe.trackingSpaceMin ? ue() ? (ce(), ft(), Ge({
                      height: Math.abs(Ye)
                    })) : xe.height += Ye : st(Ye, xe.prevTransform, Ke) || (xe.str.length === 0 ? (ce(), Ge({
                      height: Math.abs(Ye)
                    })) : xe.height += Ye), Math.abs(tt) > xe.width * Be && ft(), !0);
                  }
                  const Ot = (pt - Mt) / xe.textAdvanceScale, rt = Et - Nt, et = Math.sign(xe.width);
                  return Ot < et * xe.negativeSpaceMax ? Math.abs(rt) > 0.5 * xe.height ? (Qe(), !0) : (ce(), ft(), !0) : Math.abs(rt) > xe.height ? (Qe(), !0) : (Ot <= et * xe.notASpace && ce(), Ot <= et * xe.trackingSpaceMin ? ue() ? (ce(), ft(), Ge({
                    width: Math.abs(Ot)
                  })) : xe.width += Ot : st(Ot, xe.prevTransform, et) || (xe.str.length === 0 ? (ce(), Ge({
                    width: Math.abs(Ot)
                  })) : xe.width += Ot), Math.abs(rt) > xe.height * Be && ft(), !0);
                }
                function at({
                  chars: dt,
                  extraSpacing: mt
                }) {
                  const pt = Ne.font;
                  if (!dt) {
                    const Nt = Ne.charSpacing + mt;
                    Nt && (pt.vertical ? Ne.translateTextMatrix(0, -Nt) : Ne.translateTextMatrix(Nt * Ne.textHScale, 0));
                    return;
                  }
                  const Et = pt.charsToGlyphs(dt), Mt = Ne.fontMatrix[0] * Ne.fontSize;
                  for (let Nt = 0, _t = Et.length; Nt < _t; Nt++) {
                    const Ot = Et[Nt], {
                      category: rt
                    } = Ot;
                    if (rt.isInvisibleFormatMark)
                      continue;
                    let et = Ne.charSpacing + (Nt + 1 === _t ? mt : 0), Ye = Ot.width;
                    pt.vertical && (Ye = Ot.vmetric ? Ot.vmetric[0] : -Ye);
                    let tt = Ye * Mt;
                    if (rt.isWhitespace) {
                      pt.vertical ? (et += -tt + Ne.wordSpacing, Ne.translateTextMatrix(0, -et)) : (et += tt + Ne.wordSpacing, Ne.translateTextMatrix(et * Ne.textHScale, 0)), Ae(" ");
                      continue;
                    }
                    if (!rt.isZeroWidthDiacritic && !ut(tt)) {
                      pt.vertical ? Ne.translateTextMatrix(0, tt) : Ne.translateTextMatrix(tt * Ne.textHScale, 0);
                      continue;
                    }
                    const Ke = nt();
                    rt.isZeroWidthDiacritic && (tt = 0), pt.vertical ? (Ne.translateTextMatrix(0, tt), tt = Math.abs(tt), Ke.height += tt) : (tt *= Ne.textHScale, Ne.translateTextMatrix(tt, 0), Ke.width += tt), tt && (Ke.prevTransform = Xe());
                    const qe = Ot.unicode;
                    Ae(qe) && Ke.str.push(" "), Ke.str.push(qe), et && (pt.vertical ? Ne.translateTextMatrix(0, -et) : Ne.translateTextMatrix(et * Ne.textHScale, 0));
                  }
                }
                function Qe() {
                  ce(), xe.initialized ? (xe.hasEOL = !0, ft()) : Ce.items.push({
                    str: "",
                    dir: "ltr",
                    width: 0,
                    height: 0,
                    transform: Xe(),
                    fontName: Ne.loadedName,
                    hasEOL: !0
                  });
                }
                function st(dt, mt, pt) {
                  if (pt * xe.spaceInFlowMin <= dt && dt <= pt * xe.spaceInFlowMax)
                    return xe.initialized && (ce(), xe.str.push(" ")), !1;
                  const Et = xe.fontName;
                  let Mt = 0;
                  return xe.vertical && (Mt = dt, dt = 0), ft(), ce(), Ge({
                    width: Math.abs(dt),
                    height: Math.abs(Mt),
                    transform: mt || Xe(),
                    fontName: Et
                  }), !0;
                }
                function ft() {
                  !xe.initialized || !xe.str || (xe.vertical ? xe.totalHeight += xe.height * xe.textAdvanceScale : xe.totalWidth += xe.width * xe.textAdvanceScale, Ce.items.push(it(xe)), xe.initialized = !1, xe.str.length = 0);
                }
                function vt(dt = !1) {
                  const mt = Ce.items.length;
                  mt !== 0 && (dt && mt < V || (be.enqueue(Ce, mt), Ce.items = [], Ce.styles = /* @__PURE__ */ Object.create(null)));
                }
                const Pt = new q();
                return new Promise(function dt(mt, pt) {
                  const Et = function(tt) {
                    vt(!0), Promise.all([tt, be.ready]).then(function() {
                      try {
                        dt(mt, pt);
                      } catch (Ke) {
                        pt(Ke);
                      }
                    }, pt);
                  };
                  fe.ensureNotTerminated(), Pt.reset();
                  const Mt = {};
                  let Nt, _t = [];
                  for (; !(Nt = Pt.check()) && (_t.length = 0, Mt.args = _t, !!De.read(Mt)); ) {
                    const tt = Ne;
                    Ne = me.state;
                    const Ke = Mt.fn;
                    switch (_t = Mt.args, Ke | 0) {
                      case g.OPS.setFont:
                        var Ot = _t[0].name, rt = _t[1];
                        if (Ne.font && Ot === Ne.fontName && rt === Ne.fontSize)
                          break;
                        ft(), Ne.fontName = Ot, Ne.fontSize = rt, Et(We(Ot, null));
                        return;
                      case g.OPS.setTextRise:
                        Ne.textRise = _t[0];
                        break;
                      case g.OPS.setHScale:
                        Ne.textHScale = _t[0] / 100;
                        break;
                      case g.OPS.setLeading:
                        Ne.leading = _t[0];
                        break;
                      case g.OPS.moveText:
                        Ne.translateTextLineMatrix(_t[0], _t[1]), Ne.textMatrix = Ne.textLineMatrix.slice();
                        break;
                      case g.OPS.setLeadingMoveText:
                        Ne.leading = -_t[1], Ne.translateTextLineMatrix(_t[0], _t[1]), Ne.textMatrix = Ne.textLineMatrix.slice();
                        break;
                      case g.OPS.nextLine:
                        Ne.carriageReturn();
                        break;
                      case g.OPS.setTextMatrix:
                        Ne.setTextMatrix(_t[0], _t[1], _t[2], _t[3], _t[4], _t[5]), Ne.setTextLineMatrix(_t[0], _t[1], _t[2], _t[3], _t[4], _t[5]), ct();
                        break;
                      case g.OPS.setCharSpacing:
                        Ne.charSpacing = _t[0];
                        break;
                      case g.OPS.setWordSpacing:
                        Ne.wordSpacing = _t[0];
                        break;
                      case g.OPS.beginText:
                        Ne.textMatrix = g.IDENTITY_MATRIX.slice(), Ne.textLineMatrix = g.IDENTITY_MATRIX.slice();
                        break;
                      case g.OPS.showSpacedText:
                        if (!me.state.font) {
                          Oe.ensureStateFont(me.state);
                          continue;
                        }
                        const qe = (Ne.font.vertical ? 1 : -1) * Ne.fontSize / 1e3, ot = _t[0];
                        for (let Je = 0, Ct = ot.length; Je < Ct; Je++) {
                          const Tt = ot[Je];
                          if (typeof Tt == "string")
                            Fe.push(Tt);
                          else if (typeof Tt == "number" && Tt !== 0) {
                            const yt = Fe.join("");
                            Fe.length = 0, at({
                              chars: yt,
                              extraSpacing: Tt * qe
                            });
                          }
                        }
                        if (Fe.length > 0) {
                          const Je = Fe.join("");
                          Fe.length = 0, at({
                            chars: Je,
                            extraSpacing: 0
                          });
                        }
                        break;
                      case g.OPS.showText:
                        if (!me.state.font) {
                          Oe.ensureStateFont(me.state);
                          continue;
                        }
                        at({
                          chars: _t[0],
                          extraSpacing: 0
                        });
                        break;
                      case g.OPS.nextLineShowText:
                        if (!me.state.font) {
                          Oe.ensureStateFont(me.state);
                          continue;
                        }
                        Ne.carriageReturn(), at({
                          chars: _t[0],
                          extraSpacing: 0
                        });
                        break;
                      case g.OPS.nextLineSetSpacingShowText:
                        if (!me.state.font) {
                          Oe.ensureStateFont(me.state);
                          continue;
                        }
                        Ne.wordSpacing = _t[0], Ne.charSpacing = _t[1], Ne.carriageReturn(), at({
                          chars: _t[2],
                          extraSpacing: 0
                        });
                        break;
                      case g.OPS.paintXObject:
                        ft(), Ue || (Ue = ge.get("XObject") || y.Dict.empty);
                        var et = _t[0] instanceof y.Name, Ye = _t[0].name;
                        if (et && je.getByName(Ye))
                          break;
                        Et(new Promise(function(Je, Ct) {
                          if (!et)
                            throw new g.FormatError("XObject must be referred to by name.");
                          let Tt = Ue.getRaw(Ye);
                          if (Tt instanceof y.Ref) {
                            if (je.getByRef(Tt)) {
                              Je();
                              return;
                            }
                            if (Oe.globalImageCache.getData(Tt, Oe.pageIndex)) {
                              Je();
                              return;
                            }
                            Tt = Me.fetch(Tt);
                          }
                          if (!(Tt instanceof R.BaseStream))
                            throw new g.FormatError("XObject should be a stream");
                          const yt = Tt.dict.get("Subtype");
                          if (!(yt instanceof y.Name))
                            throw new g.FormatError("XObject should have a Name subtype");
                          if (yt.name !== "Form") {
                            je.set(Ye, Tt.dict.objId, !0), Je();
                            return;
                          }
                          const bt = me.state.clone(), It = new Q(bt), kt = Tt.dict.getArray("Matrix");
                          Array.isArray(kt) && kt.length === 6 && It.transform(kt), vt();
                          const $t = {
                            enqueueInvoked: !1,
                            enqueue(Lt, Ft) {
                              this.enqueueInvoked = !0, be.enqueue(Lt, Ft);
                            },
                            get desiredSize() {
                              return be.desiredSize;
                            },
                            get ready() {
                              return be.ready;
                            }
                          };
                          Oe.getTextContent({
                            stream: Tt,
                            task: fe,
                            resources: Tt.dict.get("Resources") || ge,
                            stateManager: It,
                            includeMarkedContent: pe,
                            sink: $t,
                            seenStyles: le,
                            viewBox: ve,
                            markedContentData: he,
                            disableNormalization: ye
                          }).then(function() {
                            $t.enqueueInvoked || je.set(Ye, Tt.dict.objId, !0), Je();
                          }, Ct);
                        }).catch(function(Je) {
                          if (!(Je instanceof g.AbortException)) {
                            if (Oe.options.ignoreErrors) {
                              (0, g.warn)(`getTextContent - ignoring XObject: "${Je}".`);
                              return;
                            }
                            throw Je;
                          }
                        }));
                        return;
                      case g.OPS.setGState:
                        if (et = _t[0] instanceof y.Name, Ye = _t[0].name, et && Le.getByName(Ye))
                          break;
                        Et(new Promise(function(Je, Ct) {
                          if (!et)
                            throw new g.FormatError("GState must be referred to by name.");
                          const Tt = ge.get("ExtGState");
                          if (!(Tt instanceof y.Dict))
                            throw new g.FormatError("ExtGState should be a dictionary.");
                          const yt = Tt.get(Ye);
                          if (!(yt instanceof y.Dict))
                            throw new g.FormatError("GState should be a dictionary.");
                          const bt = yt.get("Font");
                          if (!bt) {
                            Le.set(Ye, yt.objId, !0), Je();
                            return;
                          }
                          ft(), Ne.fontName = null, Ne.fontSize = bt[1], We(null, bt[0]).then(Je, Ct);
                        }).catch(function(Je) {
                          if (!(Je instanceof g.AbortException)) {
                            if (Oe.options.ignoreErrors) {
                              (0, g.warn)(`getTextContent - ignoring ExtGState: "${Je}".`);
                              return;
                            }
                            throw Je;
                          }
                        }));
                        return;
                      case g.OPS.beginMarkedContent:
                        ft(), pe && (he.level++, Ce.items.push({
                          type: "beginMarkedContent",
                          tag: _t[0] instanceof y.Name ? _t[0].name : null
                        }));
                        break;
                      case g.OPS.beginMarkedContentProps:
                        if (ft(), pe) {
                          he.level++;
                          let Je = null;
                          _t[1] instanceof y.Dict && (Je = _t[1].get("MCID")), Ce.items.push({
                            type: "beginMarkedContentProps",
                            id: Number.isInteger(Je) ? `${Oe.idFactory.getPageObjId()}_mc${Je}` : null,
                            tag: _t[0] instanceof y.Name ? _t[0].name : null
                          });
                        }
                        break;
                      case g.OPS.endMarkedContent:
                        if (ft(), pe) {
                          if (he.level === 0)
                            break;
                          he.level--, Ce.items.push({
                            type: "endMarkedContent"
                          });
                        }
                        break;
                      case g.OPS.restore:
                        tt && (tt.font !== Ne.font || tt.fontSize !== Ne.fontSize || tt.fontName !== Ne.fontName) && ft();
                        break;
                    }
                    if (Ce.items.length >= be.desiredSize) {
                      Nt = !0;
                      break;
                    }
                  }
                  if (Nt) {
                    Et(Z);
                    return;
                  }
                  ft(), vt(), mt();
                }).catch((dt) => {
                  if (!(dt instanceof g.AbortException)) {
                    if (this.options.ignoreErrors) {
                      (0, g.warn)(`getTextContent - ignoring errors during "${fe.name}" task: "${dt}".`), ft(), vt();
                      return;
                    }
                    throw dt;
                  }
                });
              }
              extractDataStructures(ie, fe, ge) {
                const me = this.xref;
                let pe;
                const be = this.readToUnicode(ge.toUnicode || ie.get("ToUnicode") || fe.get("ToUnicode"));
                if (ge.composite) {
                  const xe = ie.get("CIDSystemInfo");
                  xe instanceof y.Dict && (ge.cidSystemInfo = {
                    registry: (0, g.stringToPDFString)(xe.get("Registry")),
                    ordering: (0, g.stringToPDFString)(xe.get("Ordering")),
                    supplement: xe.get("Supplement")
                  });
                  try {
                    const we = ie.get("CIDToGIDMap");
                    we instanceof R.BaseStream && (pe = we.getBytes());
                  } catch (we) {
                    if (!this.options.ignoreErrors)
                      throw we;
                    (0, g.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${we}".`);
                  }
                }
                const le = [];
                let ve = null, he;
                if (ie.has("Encoding")) {
                  if (he = ie.get("Encoding"), he instanceof y.Dict) {
                    if (ve = he.get("BaseEncoding"), ve = ve instanceof y.Name ? ve.name : null, he.has("Differences")) {
                      const xe = he.get("Differences");
                      let we = 0;
                      for (const $e of xe) {
                        const Ae = me.fetchIfRef($e);
                        if (typeof Ae == "number")
                          we = Ae;
                        else if (Ae instanceof y.Name)
                          le[we++] = Ae.name;
                        else
                          throw new g.FormatError(`Invalid entry in 'Differences' array: ${Ae}`);
                      }
                    }
                  } else if (he instanceof y.Name)
                    ve = he.name;
                  else {
                    const xe = "Encoding is not a Name nor a Dict";
                    if (!this.options.ignoreErrors)
                      throw new g.FormatError(xe);
                    (0, g.warn)(xe);
                  }
                  ve !== "MacRomanEncoding" && ve !== "MacExpertEncoding" && ve !== "WinAnsiEncoding" && (ve = null);
                }
                const ye = !ge.file || ge.isInternalFont, Ce = (0, C.getSymbolsFonts)()[ge.name];
                if (ve && ye && Ce && (ve = null), ve)
                  ge.defaultEncoding = (0, m.getEncoding)(ve);
                else {
                  const xe = !!(ge.flags & F.FontFlags.Symbolic), we = !!(ge.flags & F.FontFlags.Nonsymbolic);
                  he = m.StandardEncoding, ge.type === "TrueType" && !we && (he = m.WinAnsiEncoding), (xe || Ce) && (he = m.MacRomanEncoding, ye && (/Symbol/i.test(ge.name) ? he = m.SymbolSetEncoding : /Dingbats/i.test(ge.name) ? he = m.ZapfDingbatsEncoding : /Wingdings/i.test(ge.name) && (he = m.WinAnsiEncoding))), ge.defaultEncoding = he;
                }
                return ge.differences = le, ge.baseEncodingName = ve, ge.hasEncoding = !!ve || le.length > 0, ge.dict = ie, be.then((xe) => (ge.toUnicode = xe, this.buildToUnicode(ge))).then((xe) => (ge.toUnicode = xe, pe && (ge.cidToGidMap = this.readCidToGidMap(pe, xe)), ge));
              }
              _simpleFontToUnicode(ie, fe = !1) {
                (0, g.assert)(!ie.composite, "Must be a simple font.");
                const ge = [], me = ie.defaultEncoding.slice(), pe = ie.baseEncodingName, be = ie.differences;
                for (const ve in be) {
                  const he = be[ve];
                  he !== ".notdef" && (me[ve] = he);
                }
                const le = (0, W.getGlyphsUnicode)();
                for (const ve in me) {
                  let he = me[ve];
                  if (he === "")
                    continue;
                  let ye = le[he];
                  if (ye !== void 0) {
                    ge[ve] = String.fromCharCode(ye);
                    continue;
                  }
                  let Ce = 0;
                  switch (he[0]) {
                    case "G":
                      he.length === 3 && (Ce = parseInt(he.substring(1), 16));
                      break;
                    case "g":
                      he.length === 5 && (Ce = parseInt(he.substring(1), 16));
                      break;
                    case "C":
                    case "c":
                      if (he.length >= 3 && he.length <= 4) {
                        const xe = he.substring(1);
                        if (fe) {
                          Ce = parseInt(xe, 16);
                          break;
                        }
                        if (Ce = +xe, Number.isNaN(Ce) && Number.isInteger(parseInt(xe, 16)))
                          return this._simpleFontToUnicode(ie, !0);
                      }
                      break;
                    case "u":
                      ye = (0, G.getUnicodeForGlyph)(he, le), ye !== -1 && (Ce = ye);
                      break;
                    default:
                      switch (he) {
                        case "f_h":
                        case "f_t":
                        case "T_h":
                          ge[ve] = he.replaceAll("_", "");
                          continue;
                      }
                      break;
                  }
                  if (Ce > 0 && Ce <= 1114111 && Number.isInteger(Ce)) {
                    if (pe && Ce === +ve) {
                      const xe = (0, m.getEncoding)(pe);
                      if (xe && (he = xe[ve])) {
                        ge[ve] = String.fromCharCode(le[he]);
                        continue;
                      }
                    }
                    ge[ve] = String.fromCodePoint(Ce);
                  }
                }
                return ge;
              }
              async buildToUnicode(ie) {
                if (ie.hasIncludedToUnicodeMap = ie.toUnicode?.length > 0, ie.hasIncludedToUnicodeMap)
                  return !ie.composite && ie.hasEncoding && (ie.fallbackToUnicode = this._simpleFontToUnicode(ie)), ie.toUnicode;
                if (!ie.composite)
                  return new $.ToUnicodeMap(this._simpleFontToUnicode(ie));
                if (ie.composite && (ie.cMap.builtInCMap && !(ie.cMap instanceof b.IdentityCMap) || ie.cidSystemInfo.registry === "Adobe" && (ie.cidSystemInfo.ordering === "GB1" || ie.cidSystemInfo.ordering === "CNS1" || ie.cidSystemInfo.ordering === "Japan1" || ie.cidSystemInfo.ordering === "Korea1"))) {
                  const {
                    registry: fe,
                    ordering: ge
                  } = ie.cidSystemInfo, me = y.Name.get(`${fe}-${ge}-UCS2`), pe = await b.CMapFactory.create({
                    encoding: me,
                    fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                    useCMap: null
                  }), be = [], le = [];
                  return ie.cMap.forEach(function(ve, he) {
                    if (he > 65535)
                      throw new g.FormatError("Max size of CID is 65,535");
                    const ye = pe.lookup(he);
                    if (ye) {
                      le.length = 0;
                      for (let Ce = 0, xe = ye.length; Ce < xe; Ce += 2)
                        le.push((ye.charCodeAt(Ce) << 8) + ye.charCodeAt(Ce + 1));
                      be[ve] = String.fromCharCode(...le);
                    }
                  }), new $.ToUnicodeMap(be);
                }
                return new $.IdentityToUnicodeMap(ie.firstChar, ie.lastChar);
              }
              readToUnicode(ie) {
                return ie ? ie instanceof y.Name ? b.CMapFactory.create({
                  encoding: ie,
                  fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                  useCMap: null
                }).then(function(fe) {
                  return fe instanceof b.IdentityCMap ? new $.IdentityToUnicodeMap(0, 65535) : new $.ToUnicodeMap(fe.getMap());
                }) : ie instanceof R.BaseStream ? b.CMapFactory.create({
                  encoding: ie,
                  fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                  useCMap: null
                }).then(function(fe) {
                  if (fe instanceof b.IdentityCMap)
                    return new $.IdentityToUnicodeMap(0, 65535);
                  const ge = new Array(fe.length);
                  return fe.forEach(function(me, pe) {
                    if (typeof pe == "number") {
                      ge[me] = String.fromCodePoint(pe);
                      return;
                    }
                    const be = [];
                    for (let le = 0; le < pe.length; le += 2) {
                      const ve = pe.charCodeAt(le) << 8 | pe.charCodeAt(le + 1);
                      if ((ve & 63488) !== 55296) {
                        be.push(ve);
                        continue;
                      }
                      le += 2;
                      const he = pe.charCodeAt(le) << 8 | pe.charCodeAt(le + 1);
                      be.push(((ve & 1023) << 10) + (he & 1023) + 65536);
                    }
                    ge[me] = String.fromCodePoint(...be);
                  }), new $.ToUnicodeMap(ge);
                }, (fe) => {
                  if (fe instanceof g.AbortException)
                    return null;
                  if (this.options.ignoreErrors)
                    return (0, g.warn)(`readToUnicode - ignoring ToUnicode data: "${fe}".`), null;
                  throw fe;
                }) : Promise.resolve(null) : Promise.resolve(null);
              }
              readCidToGidMap(ie, fe) {
                const ge = [];
                for (let me = 0, pe = ie.length; me < pe; me++) {
                  const be = ie[me++] << 8 | ie[me], le = me >> 1;
                  be === 0 && !fe.has(le) || (ge[le] = be);
                }
                return ge;
              }
              extractWidths(ie, fe, ge) {
                const me = this.xref;
                let pe = [], be = 0;
                const le = [];
                let ve, he, ye, Ce, xe, we, $e, Ae;
                if (ge.composite) {
                  if (be = ie.has("DW") ? ie.get("DW") : 1e3, Ae = ie.get("W"), Ae)
                    for (he = 0, ye = Ae.length; he < ye; he++)
                      if (we = me.fetchIfRef(Ae[he++]), $e = me.fetchIfRef(Ae[he]), Array.isArray($e))
                        for (Ce = 0, xe = $e.length; Ce < xe; Ce++)
                          pe[we++] = me.fetchIfRef($e[Ce]);
                      else {
                        const Ee = me.fetchIfRef(Ae[++he]);
                        for (Ce = we; Ce <= $e; Ce++)
                          pe[Ce] = Ee;
                      }
                  if (ge.vertical) {
                    let Ee = ie.getArray("DW2") || [880, -1e3];
                    if (ve = [Ee[1], be * 0.5, Ee[0]], Ee = ie.get("W2"), Ee)
                      for (he = 0, ye = Ee.length; he < ye; he++)
                        if (we = me.fetchIfRef(Ee[he++]), $e = me.fetchIfRef(Ee[he]), Array.isArray($e))
                          for (Ce = 0, xe = $e.length; Ce < xe; Ce++)
                            le[we++] = [me.fetchIfRef($e[Ce++]), me.fetchIfRef($e[Ce++]), me.fetchIfRef($e[Ce])];
                        else {
                          const _e = [me.fetchIfRef(Ee[++he]), me.fetchIfRef(Ee[++he]), me.fetchIfRef(Ee[++he])];
                          for (Ce = we; Ce <= $e; Ce++)
                            le[Ce] = _e;
                        }
                  }
                } else {
                  const Ee = ge.firstChar;
                  if (Ae = ie.get("Widths"), Ae) {
                    for (Ce = Ee, he = 0, ye = Ae.length; he < ye; he++)
                      pe[Ce++] = me.fetchIfRef(Ae[he]);
                    be = parseFloat(fe.get("MissingWidth")) || 0;
                  } else {
                    const _e = ie.get("BaseFont");
                    if (_e instanceof y.Name) {
                      const Te = this.getBaseFontMetrics(_e.name);
                      pe = this.buildCharCodeToWidth(Te.widths, ge), be = Te.defaultWidth;
                    }
                  }
                }
                let ue = !0, ce = be;
                for (const Ee in pe) {
                  const _e = pe[Ee];
                  if (_e) {
                    if (!ce) {
                      ce = _e;
                      continue;
                    }
                    if (ce !== _e) {
                      ue = !1;
                      break;
                    }
                  }
                }
                ue ? ge.flags |= F.FontFlags.FixedPitch : ge.flags &= ~F.FontFlags.FixedPitch, ge.defaultWidth = be, ge.widths = pe, ge.defaultVMetrics = ve, ge.vmetrics = le;
              }
              isSerifFont(ie) {
                const fe = ie.split("-")[0];
                return fe in (0, C.getSerifFonts)() || /serif/gi.test(fe);
              }
              getBaseFontMetrics(ie) {
                let fe = 0, ge = /* @__PURE__ */ Object.create(null), me = !1, be = (0, C.getStdFontMap)()[ie] || ie;
                const le = (0, j.getMetrics)();
                be in le || (be = this.isSerifFont(ie) ? "Times-Roman" : "Helvetica");
                const ve = le[be];
                return typeof ve == "number" ? (fe = ve, me = !0) : ge = ve(), {
                  defaultWidth: fe,
                  monospace: me,
                  widths: ge
                };
              }
              buildCharCodeToWidth(ie, fe) {
                const ge = /* @__PURE__ */ Object.create(null), me = fe.differences, pe = fe.defaultEncoding;
                for (let be = 0; be < 256; be++) {
                  if (be in me && ie[me[be]]) {
                    ge[be] = ie[me[be]];
                    continue;
                  }
                  if (be in pe && ie[pe[be]]) {
                    ge[be] = ie[pe[be]];
                    continue;
                  }
                }
                return ge;
              }
              preEvaluateFont(ie) {
                const fe = ie;
                let ge = ie.get("Subtype");
                if (!(ge instanceof y.Name))
                  throw new g.FormatError("invalid font Subtype");
                let me = !1, pe, be;
                if (ge.name === "Type0") {
                  const ye = ie.get("DescendantFonts");
                  if (!ye)
                    throw new g.FormatError("Descendant fonts are not specified");
                  if (ie = Array.isArray(ye) ? this.xref.fetchIfRef(ye[0]) : ye, !(ie instanceof y.Dict))
                    throw new g.FormatError("Descendant font is not a dictionary.");
                  if (ge = ie.get("Subtype"), !(ge instanceof y.Name))
                    throw new g.FormatError("invalid font Subtype");
                  me = !0;
                }
                const le = ie.get("FirstChar") || 0, ve = ie.get("LastChar") || (me ? 65535 : 255), he = ie.get("FontDescriptor");
                if (he) {
                  pe = new k.MurmurHash3_64();
                  const ye = fe.getRaw("Encoding");
                  if (ye instanceof y.Name)
                    pe.update(ye.name);
                  else if (ye instanceof y.Ref)
                    pe.update(ye.toString());
                  else if (ye instanceof y.Dict) {
                    for (const xe of ye.getRawValues())
                      if (xe instanceof y.Name)
                        pe.update(xe.name);
                      else if (xe instanceof y.Ref)
                        pe.update(xe.toString());
                      else if (Array.isArray(xe)) {
                        const we = xe.length, $e = new Array(we);
                        for (let Ae = 0; Ae < we; Ae++) {
                          const ue = xe[Ae];
                          ue instanceof y.Name ? $e[Ae] = ue.name : (typeof ue == "number" || ue instanceof y.Ref) && ($e[Ae] = ue.toString());
                        }
                        pe.update($e.join());
                      }
                  }
                  if (pe.update(`${le}-${ve}`), be = ie.get("ToUnicode") || fe.get("ToUnicode"), be instanceof R.BaseStream) {
                    const xe = be.str || be, we = xe.buffer ? new Uint8Array(xe.buffer.buffer, 0, xe.bufferLength) : new Uint8Array(xe.bytes.buffer, xe.start, xe.end - xe.start);
                    pe.update(we);
                  } else be instanceof y.Name && pe.update(be.name);
                  const Ce = ie.get("Widths") || fe.get("Widths");
                  if (Array.isArray(Ce)) {
                    const xe = [];
                    for (const we of Ce)
                      (typeof we == "number" || we instanceof y.Ref) && xe.push(we.toString());
                    pe.update(xe.join());
                  }
                  if (me) {
                    pe.update("compositeFont");
                    const xe = ie.get("W") || fe.get("W");
                    if (Array.isArray(xe)) {
                      const $e = [];
                      for (const Ae of xe)
                        if (typeof Ae == "number" || Ae instanceof y.Ref)
                          $e.push(Ae.toString());
                        else if (Array.isArray(Ae)) {
                          const ue = [];
                          for (const ce of Ae)
                            (typeof ce == "number" || ce instanceof y.Ref) && ue.push(ce.toString());
                          $e.push(`[${ue.join()}]`);
                        }
                      pe.update($e.join());
                    }
                    const we = ie.getRaw("CIDToGIDMap") || fe.getRaw("CIDToGIDMap");
                    we instanceof y.Name ? pe.update(we.name) : we instanceof y.Ref ? pe.update(we.toString()) : we instanceof R.BaseStream && pe.update(we.peekBytes());
                  }
                }
                return {
                  descriptor: he,
                  dict: ie,
                  baseDict: fe,
                  composite: me,
                  type: ge.name,
                  firstChar: le,
                  lastChar: ve,
                  toUnicode: be,
                  hash: pe ? pe.hexdigest() : ""
                };
              }
              async translateFont({
                descriptor: ie,
                dict: fe,
                baseDict: ge,
                composite: me,
                type: pe,
                firstChar: be,
                lastChar: le,
                toUnicode: ve,
                cssFontInfo: he
              }) {
                const ye = pe === "Type3";
                let Ce;
                if (!ie)
                  if (ye)
                    ie = new y.Dict(null), ie.set("FontName", y.Name.get(pe)), ie.set("FontBBox", fe.getArray("FontBBox") || [0, 0, 0, 0]);
                  else {
                    let Oe = fe.get("BaseFont");
                    if (!(Oe instanceof y.Name))
                      throw new g.FormatError("Base font is not specified");
                    Oe = Oe.name.replaceAll(/[,_]/g, "-");
                    const Me = this.getBaseFontMetrics(Oe), Fe = Oe.split("-")[0], Ue = (this.isSerifFont(Fe) ? F.FontFlags.Serif : 0) | (Me.monospace ? F.FontFlags.FixedPitch : 0) | ((0, C.getSymbolsFonts)()[Fe] ? F.FontFlags.Symbolic : F.FontFlags.Nonsymbolic);
                    Ce = {
                      type: pe,
                      name: Oe,
                      loadedName: ge.loadedName,
                      systemFontInfo: null,
                      widths: Me.widths,
                      defaultWidth: Me.defaultWidth,
                      isSimulatedFlags: !0,
                      flags: Ue,
                      firstChar: be,
                      lastChar: le,
                      toUnicode: ve,
                      xHeight: 0,
                      capHeight: 0,
                      italicAngle: 0,
                      isType3Font: ye
                    };
                    const je = fe.get("Widths"), Le = (0, C.getStandardFontName)(Oe);
                    let De = null;
                    return Le && (De = await this.fetchStandardFontData(Le), Ce.isInternalFont = !!De), !Ce.isInternalFont && this.options.useSystemFonts && (Ce.systemFontInfo = (0, M.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, Oe, Le)), this.extractDataStructures(fe, fe, Ce).then((Ne) => {
                      if (je) {
                        const Ge = [];
                        let Xe = be;
                        for (const nt of je)
                          Ge[Xe++] = this.xref.fetchIfRef(nt);
                        Ne.widths = Ge;
                      } else
                        Ne.widths = this.buildCharCodeToWidth(Me.widths, Ne);
                      return new f.Font(Oe, De, Ne);
                    });
                  }
                let xe = ie.get("FontName"), we = fe.get("BaseFont");
                typeof xe == "string" && (xe = y.Name.get(xe)), typeof we == "string" && (we = y.Name.get(we));
                const $e = xe?.name, Ae = we?.name;
                if (!ye && $e !== Ae && ((0, g.info)(`The FontDescriptor's FontName is "${$e}" but should be the same as the Font's BaseFont "${Ae}".`), $e && Ae && (Ae.startsWith($e) || !(0, C.isKnownFontName)($e) && (0, C.isKnownFontName)(Ae)) && (xe = null)), xe ||= we, !(xe instanceof y.Name))
                  throw new g.FormatError("invalid font name");
                let ue, ce, Ee, _e, Te;
                try {
                  ue = ie.get("FontFile", "FontFile2", "FontFile3");
                } catch (Oe) {
                  if (!this.options.ignoreErrors)
                    throw Oe;
                  (0, g.warn)(`translateFont - fetching "${xe.name}" font file: "${Oe}".`), ue = new E.NullStream();
                }
                let ke = !1, Re = null, Be = null;
                if (ue) {
                  if (ue.dict) {
                    const Oe = ue.dict.get("Subtype");
                    Oe instanceof y.Name && (ce = Oe.name), Ee = ue.dict.get("Length1"), _e = ue.dict.get("Length2"), Te = ue.dict.get("Length3");
                  }
                } else if (he) {
                  const Oe = (0, S.getXfaFontName)(xe.name);
                  Oe && (he.fontFamily = `${he.fontFamily}-PdfJS-XFA`, he.metrics = Oe.metrics || null, Re = Oe.factors || null, ue = await this.fetchStandardFontData(Oe.name), ke = !!ue, ge = fe = (0, S.getXfaFontDict)(xe.name), me = !0);
                } else if (!ye) {
                  const Oe = (0, C.getStandardFontName)(xe.name);
                  Oe && (ue = await this.fetchStandardFontData(Oe), ke = !!ue), !ke && this.options.useSystemFonts && (Be = (0, M.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, xe.name, Oe));
                }
                if (Ce = {
                  type: pe,
                  name: xe.name,
                  subtype: ce,
                  file: ue,
                  length1: Ee,
                  length2: _e,
                  length3: Te,
                  isInternalFont: ke,
                  loadedName: ge.loadedName,
                  composite: me,
                  fixedPitch: !1,
                  fontMatrix: fe.getArray("FontMatrix") || g.FONT_IDENTITY_MATRIX,
                  firstChar: be,
                  lastChar: le,
                  toUnicode: ve,
                  bbox: ie.getArray("FontBBox") || fe.getArray("FontBBox"),
                  ascent: ie.get("Ascent"),
                  descent: ie.get("Descent"),
                  xHeight: ie.get("XHeight") || 0,
                  capHeight: ie.get("CapHeight") || 0,
                  flags: ie.get("Flags"),
                  italicAngle: ie.get("ItalicAngle") || 0,
                  isType3Font: ye,
                  cssFontInfo: he,
                  scaleFactors: Re,
                  systemFontInfo: Be
                }, me) {
                  const Oe = ge.get("Encoding");
                  Oe instanceof y.Name && (Ce.cidEncoding = Oe.name);
                  const Me = await b.CMapFactory.create({
                    encoding: Oe,
                    fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                    useCMap: null
                  });
                  Ce.cMap = Me, Ce.vertical = Ce.cMap.vertical;
                }
                return this.extractDataStructures(fe, ge, Ce).then((Oe) => (this.extractWidths(fe, ie, Oe), new f.Font(xe.name, ue, Oe)));
              }
              static buildFontPaths(ie, fe, ge, me) {
                function pe(be) {
                  const le = `${ie.loadedName}_path_${be}`;
                  try {
                    if (ie.renderer.hasBuiltPath(be))
                      return;
                    ge.send("commonobj", [le, "FontPath", ie.renderer.getPathJs(be)]);
                  } catch (ve) {
                    if (me.ignoreErrors) {
                      (0, g.warn)(`buildFontPaths - ignoring ${le} glyph: "${ve}".`);
                      return;
                    }
                    throw ve;
                  }
                }
                for (const be of fe) {
                  pe(be.fontChar);
                  const le = be.accent;
                  le?.fontChar && pe(le.fontChar);
                }
              }
              static get fallbackFontDict() {
                const ie = new y.Dict();
                return ie.set("BaseFont", y.Name.get("Helvetica")), ie.set("Type", y.Name.get("FallbackType")), ie.set("Subtype", y.Name.get("FallbackType")), ie.set("Encoding", y.Name.get("WinAnsiEncoding")), (0, g.shadow)(this, "fallbackFontDict", ie);
              }
            }
            A.PartialEvaluator = Y;
            class ee {
              constructor({
                loadedName: ie,
                font: fe,
                dict: ge,
                evaluatorOptions: me
              }) {
                this.loadedName = ie, this.font = fe, this.dict = ge, this._evaluatorOptions = me || D, this.type3Loaded = null, this.type3Dependencies = fe.isType3Font ? /* @__PURE__ */ new Set() : null, this.sent = !1;
              }
              send(ie) {
                this.sent || (this.sent = !0, ie.send("commonobj", [this.loadedName, "Font", this.font.exportData(this._evaluatorOptions.fontExtraProperties)]));
              }
              fallback(ie) {
                this.font.data && (this.font.disableFontFace = !0, Y.buildFontPaths(this.font, this.font.glyphCacheValues, ie, this._evaluatorOptions));
              }
              loadType3Data(ie, fe, ge) {
                if (this.type3Loaded)
                  return this.type3Loaded;
                if (!this.font.isType3Font)
                  throw new Error("Must be a Type3 font.");
                const me = ie.clone({
                  ignoreErrors: !1
                });
                me.parsingType3Font = !0;
                const pe = new y.RefSet(ie.type3FontRefs);
                this.dict.objId && !pe.has(this.dict.objId) && pe.put(this.dict.objId), me.type3FontRefs = pe;
                const be = this.font, le = this.type3Dependencies;
                let ve = Promise.resolve();
                const he = this.dict.get("CharProcs"), ye = this.dict.get("Resources") || fe, Ce = /* @__PURE__ */ Object.create(null), xe = g.Util.normalizeRect(be.bbox || [0, 0, 0, 0]), we = xe[2] - xe[0], $e = xe[3] - xe[1], Ae = Math.hypot(we, $e);
                for (const ue of he.getKeys())
                  ve = ve.then(() => {
                    const ce = he.get(ue), Ee = new N.OperatorList();
                    return me.getOperatorList({
                      stream: ce,
                      task: ge,
                      resources: ye,
                      operatorList: Ee
                    }).then(() => {
                      Ee.fnArray[0] === g.OPS.setCharWidthAndBounds && this._removeType3ColorOperators(Ee, Ae), Ce[ue] = Ee.getIR();
                      for (const _e of Ee.dependencies)
                        le.add(_e);
                    }).catch(function(_e) {
                      (0, g.warn)(`Type3 font resource "${ue}" is not available.`);
                      const Te = new N.OperatorList();
                      Ce[ue] = Te.getIR();
                    });
                  });
                return this.type3Loaded = ve.then(() => {
                  be.charProcOperatorList = Ce, this._bbox && (be.isCharBBox = !0, be.bbox = this._bbox);
                }), this.type3Loaded;
              }
              _removeType3ColorOperators(ie, fe = NaN) {
                const ge = g.Util.normalizeRect(ie.argsArray[0].slice(2)), me = ge[2] - ge[0], pe = ge[3] - ge[1], be = Math.hypot(me, pe);
                me === 0 || pe === 0 ? (ie.fnArray.splice(0, 1), ie.argsArray.splice(0, 1)) : (fe === 0 || Math.round(be / fe) >= 10) && (this._bbox || (this._bbox = [1 / 0, 1 / 0, -1 / 0, -1 / 0]), this._bbox[0] = Math.min(this._bbox[0], ge[0]), this._bbox[1] = Math.min(this._bbox[1], ge[1]), this._bbox[2] = Math.max(this._bbox[2], ge[2]), this._bbox[3] = Math.max(this._bbox[3], ge[3]));
                let le = 0, ve = ie.length;
                for (; le < ve; ) {
                  switch (ie.fnArray[le]) {
                    case g.OPS.setCharWidthAndBounds:
                      break;
                    case g.OPS.setStrokeColorSpace:
                    case g.OPS.setFillColorSpace:
                    case g.OPS.setStrokeColor:
                    case g.OPS.setStrokeColorN:
                    case g.OPS.setFillColor:
                    case g.OPS.setFillColorN:
                    case g.OPS.setStrokeGray:
                    case g.OPS.setFillGray:
                    case g.OPS.setStrokeRGBColor:
                    case g.OPS.setFillRGBColor:
                    case g.OPS.setStrokeCMYKColor:
                    case g.OPS.setFillCMYKColor:
                    case g.OPS.shadingFill:
                    case g.OPS.setRenderingIntent:
                      ie.fnArray.splice(le, 1), ie.argsArray.splice(le, 1), ve--;
                      continue;
                    case g.OPS.setGState:
                      const [he] = ie.argsArray[le];
                      let ye = 0, Ce = he.length;
                      for (; ye < Ce; ) {
                        const [xe] = he[ye];
                        switch (xe) {
                          case "TR":
                          case "TR2":
                          case "HT":
                          case "BG":
                          case "BG2":
                          case "UCR":
                          case "UCR2":
                            he.splice(ye, 1), Ce--;
                            continue;
                        }
                        ye++;
                      }
                      break;
                  }
                  le++;
                }
              }
            }
            class Q {
              constructor(ie = new te()) {
                this.state = ie, this.stateStack = [];
              }
              save() {
                const ie = this.state;
                this.stateStack.push(this.state), this.state = ie.clone();
              }
              restore() {
                const ie = this.stateStack.pop();
                ie && (this.state = ie);
              }
              transform(ie) {
                this.state.ctm = g.Util.transform(this.state.ctm, ie);
              }
            }
            class J {
              constructor() {
                this.ctm = new Float32Array(g.IDENTITY_MATRIX), this.fontName = null, this.fontSize = 0, this.loadedName = null, this.font = null, this.fontMatrix = g.FONT_IDENTITY_MATRIX, this.textMatrix = g.IDENTITY_MATRIX.slice(), this.textLineMatrix = g.IDENTITY_MATRIX.slice(), this.charSpacing = 0, this.wordSpacing = 0, this.leading = 0, this.textHScale = 1, this.textRise = 0;
              }
              setTextMatrix(ie, fe, ge, me, pe, be) {
                const le = this.textMatrix;
                le[0] = ie, le[1] = fe, le[2] = ge, le[3] = me, le[4] = pe, le[5] = be;
              }
              setTextLineMatrix(ie, fe, ge, me, pe, be) {
                const le = this.textLineMatrix;
                le[0] = ie, le[1] = fe, le[2] = ge, le[3] = me, le[4] = pe, le[5] = be;
              }
              translateTextMatrix(ie, fe) {
                const ge = this.textMatrix;
                ge[4] = ge[0] * ie + ge[2] * fe + ge[4], ge[5] = ge[1] * ie + ge[3] * fe + ge[5];
              }
              translateTextLineMatrix(ie, fe) {
                const ge = this.textLineMatrix;
                ge[4] = ge[0] * ie + ge[2] * fe + ge[4], ge[5] = ge[1] * ie + ge[3] * fe + ge[5];
              }
              carriageReturn() {
                this.translateTextLineMatrix(0, -this.leading), this.textMatrix = this.textLineMatrix.slice();
              }
              clone() {
                const ie = Object.create(this);
                return ie.textMatrix = this.textMatrix.slice(), ie.textLineMatrix = this.textLineMatrix.slice(), ie.fontMatrix = this.fontMatrix.slice(), ie;
              }
            }
            class te {
              constructor() {
                this.ctm = new Float32Array(g.IDENTITY_MATRIX), this.font = null, this.textRenderingMode = g.TextRenderingMode.FILL, this.fillColorSpace = L.ColorSpace.singletons.gray, this.strokeColorSpace = L.ColorSpace.singletons.gray;
              }
              clone() {
                return Object.create(this);
              }
            }
            class ae {
              static get opMap() {
                return (0, g.shadow)(this, "opMap", {
                  w: {
                    id: g.OPS.setLineWidth,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  J: {
                    id: g.OPS.setLineCap,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  j: {
                    id: g.OPS.setLineJoin,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  M: {
                    id: g.OPS.setMiterLimit,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  d: {
                    id: g.OPS.setDash,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  ri: {
                    id: g.OPS.setRenderingIntent,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  i: {
                    id: g.OPS.setFlatness,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  gs: {
                    id: g.OPS.setGState,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  q: {
                    id: g.OPS.save,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  Q: {
                    id: g.OPS.restore,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  cm: {
                    id: g.OPS.transform,
                    numArgs: 6,
                    variableArgs: !1
                  },
                  m: {
                    id: g.OPS.moveTo,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  l: {
                    id: g.OPS.lineTo,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  c: {
                    id: g.OPS.curveTo,
                    numArgs: 6,
                    variableArgs: !1
                  },
                  v: {
                    id: g.OPS.curveTo2,
                    numArgs: 4,
                    variableArgs: !1
                  },
                  y: {
                    id: g.OPS.curveTo3,
                    numArgs: 4,
                    variableArgs: !1
                  },
                  h: {
                    id: g.OPS.closePath,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  re: {
                    id: g.OPS.rectangle,
                    numArgs: 4,
                    variableArgs: !1
                  },
                  S: {
                    id: g.OPS.stroke,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  s: {
                    id: g.OPS.closeStroke,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  f: {
                    id: g.OPS.fill,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  F: {
                    id: g.OPS.fill,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  "f*": {
                    id: g.OPS.eoFill,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  B: {
                    id: g.OPS.fillStroke,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  "B*": {
                    id: g.OPS.eoFillStroke,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  b: {
                    id: g.OPS.closeFillStroke,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  "b*": {
                    id: g.OPS.closeEOFillStroke,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  n: {
                    id: g.OPS.endPath,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  W: {
                    id: g.OPS.clip,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  "W*": {
                    id: g.OPS.eoClip,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  BT: {
                    id: g.OPS.beginText,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  ET: {
                    id: g.OPS.endText,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  Tc: {
                    id: g.OPS.setCharSpacing,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  Tw: {
                    id: g.OPS.setWordSpacing,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  Tz: {
                    id: g.OPS.setHScale,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  TL: {
                    id: g.OPS.setLeading,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  Tf: {
                    id: g.OPS.setFont,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  Tr: {
                    id: g.OPS.setTextRenderingMode,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  Ts: {
                    id: g.OPS.setTextRise,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  Td: {
                    id: g.OPS.moveText,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  TD: {
                    id: g.OPS.setLeadingMoveText,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  Tm: {
                    id: g.OPS.setTextMatrix,
                    numArgs: 6,
                    variableArgs: !1
                  },
                  "T*": {
                    id: g.OPS.nextLine,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  Tj: {
                    id: g.OPS.showText,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  TJ: {
                    id: g.OPS.showSpacedText,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  "'": {
                    id: g.OPS.nextLineShowText,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  '"': {
                    id: g.OPS.nextLineSetSpacingShowText,
                    numArgs: 3,
                    variableArgs: !1
                  },
                  d0: {
                    id: g.OPS.setCharWidth,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  d1: {
                    id: g.OPS.setCharWidthAndBounds,
                    numArgs: 6,
                    variableArgs: !1
                  },
                  CS: {
                    id: g.OPS.setStrokeColorSpace,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  cs: {
                    id: g.OPS.setFillColorSpace,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  SC: {
                    id: g.OPS.setStrokeColor,
                    numArgs: 4,
                    variableArgs: !0
                  },
                  SCN: {
                    id: g.OPS.setStrokeColorN,
                    numArgs: 33,
                    variableArgs: !0
                  },
                  sc: {
                    id: g.OPS.setFillColor,
                    numArgs: 4,
                    variableArgs: !0
                  },
                  scn: {
                    id: g.OPS.setFillColorN,
                    numArgs: 33,
                    variableArgs: !0
                  },
                  G: {
                    id: g.OPS.setStrokeGray,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  g: {
                    id: g.OPS.setFillGray,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  RG: {
                    id: g.OPS.setStrokeRGBColor,
                    numArgs: 3,
                    variableArgs: !1
                  },
                  rg: {
                    id: g.OPS.setFillRGBColor,
                    numArgs: 3,
                    variableArgs: !1
                  },
                  K: {
                    id: g.OPS.setStrokeCMYKColor,
                    numArgs: 4,
                    variableArgs: !1
                  },
                  k: {
                    id: g.OPS.setFillCMYKColor,
                    numArgs: 4,
                    variableArgs: !1
                  },
                  sh: {
                    id: g.OPS.shadingFill,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  BI: {
                    id: g.OPS.beginInlineImage,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  ID: {
                    id: g.OPS.beginImageData,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  EI: {
                    id: g.OPS.endInlineImage,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  Do: {
                    id: g.OPS.paintXObject,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  MP: {
                    id: g.OPS.markPoint,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  DP: {
                    id: g.OPS.markPointProps,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  BMC: {
                    id: g.OPS.beginMarkedContent,
                    numArgs: 1,
                    variableArgs: !1
                  },
                  BDC: {
                    id: g.OPS.beginMarkedContentProps,
                    numArgs: 2,
                    variableArgs: !1
                  },
                  EMC: {
                    id: g.OPS.endMarkedContent,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  BX: {
                    id: g.OPS.beginCompat,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  EX: {
                    id: g.OPS.endCompat,
                    numArgs: 0,
                    variableArgs: !1
                  },
                  BM: null,
                  BD: null,
                  true: null,
                  fa: null,
                  fal: null,
                  fals: null,
                  false: null,
                  nu: null,
                  nul: null,
                  null: null
                });
              }
              static MAX_INVALID_PATH_OPS = 10;
              constructor(ie, fe, ge = new Q()) {
                this.parser = new I.Parser({
                  lexer: new I.Lexer(ie, ae.opMap),
                  xref: fe
                }), this.stateManager = ge, this.nonProcessedArgs = [], this._isPathOp = !1, this._numInvalidPathOPS = 0;
              }
              get savedStatesDepth() {
                return this.stateManager.stateStack.length;
              }
              read(ie) {
                let fe = ie.args;
                for (; ; ) {
                  const ge = this.parser.getObj();
                  if (ge instanceof y.Cmd) {
                    const me = ge.cmd, pe = ae.opMap[me];
                    if (!pe) {
                      (0, g.warn)(`Unknown command "${me}".`);
                      continue;
                    }
                    const be = pe.id, le = pe.numArgs;
                    let ve = fe !== null ? fe.length : 0;
                    if (this._isPathOp || (this._numInvalidPathOPS = 0), this._isPathOp = be >= g.OPS.moveTo && be <= g.OPS.endPath, pe.variableArgs)
                      ve > le && (0, g.info)(`Command ${me}: expected [0, ${le}] args, but received ${ve} args.`);
                    else {
                      if (ve !== le) {
                        const he = this.nonProcessedArgs;
                        for (; ve > le; )
                          he.push(fe.shift()), ve--;
                        for (; ve < le && he.length !== 0; )
                          fe === null && (fe = []), fe.unshift(he.pop()), ve++;
                      }
                      if (ve < le) {
                        const he = `command ${me}: expected ${le} args, but received ${ve} args.`;
                        if (this._isPathOp && ++this._numInvalidPathOPS > ae.MAX_INVALID_PATH_OPS)
                          throw new g.FormatError(`Invalid ${he}`);
                        (0, g.warn)(`Skipping ${he}`), fe !== null && (fe.length = 0);
                        continue;
                      }
                    }
                    return this.preprocessCommand(be, fe), ie.fn = be, ie.args = fe, !0;
                  }
                  if (ge === y.EOF)
                    return !1;
                  if (ge !== null && (fe === null && (fe = []), fe.push(ge), fe.length > 33))
                    throw new g.FormatError("Too many arguments");
                }
              }
              preprocessCommand(ie, fe) {
                switch (ie | 0) {
                  case g.OPS.save:
                    this.stateManager.save();
                    break;
                  case g.OPS.restore:
                    this.stateManager.restore();
                    break;
                  case g.OPS.transform:
                    this.stateManager.transform(fe);
                    break;
                }
              }
            }
            A.EvaluatorPreprocessor = ae;
          },
          /* 14 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.IdentityCMap = A.CMapFactory = A.CMap = void 0;
            var g = x(2), b = x(4), y = x(5), f = x(15), m = x(16), C = x(3), w = x(8);
            const S = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"], $ = 2 ** 24 - 1;
            class T {
              constructor(D = !1) {
                this.codespaceRanges = [[], [], [], []], this.numCodespaceRanges = 0, this._map = [], this.name = "", this.vertical = !1, this.useCMap = null, this.builtInCMap = D;
              }
              addCodespaceRange(D, H, V) {
                this.codespaceRanges[D - 1].push(H, V), this.numCodespaceRanges++;
              }
              mapCidRange(D, H, V) {
                if (H - D > $)
                  throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
                for (; D <= H; )
                  this._map[D++] = V++;
              }
              mapBfRange(D, H, V) {
                if (H - D > $)
                  throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
                const Z = V.length - 1;
                for (; D <= H; ) {
                  this._map[D++] = V;
                  const ne = V.charCodeAt(Z) + 1;
                  if (ne > 255) {
                    V = V.substring(0, Z - 1) + String.fromCharCode(V.charCodeAt(Z - 1) + 1) + "\0";
                    continue;
                  }
                  V = V.substring(0, Z) + String.fromCharCode(ne);
                }
              }
              mapBfRangeToArray(D, H, V) {
                if (H - D > $)
                  throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
                const Z = V.length;
                let ne = 0;
                for (; D <= H && ne < Z; )
                  this._map[D] = V[ne++], ++D;
              }
              mapOne(D, H) {
                this._map[D] = H;
              }
              lookup(D) {
                return this._map[D];
              }
              contains(D) {
                return this._map[D] !== void 0;
              }
              forEach(D) {
                const H = this._map, V = H.length;
                if (V <= 65536)
                  for (let Z = 0; Z < V; Z++)
                    H[Z] !== void 0 && D(Z, H[Z]);
                else
                  for (const Z in H)
                    D(Z, H[Z]);
              }
              charCodeOf(D) {
                const H = this._map;
                if (H.length <= 65536)
                  return H.indexOf(D);
                for (const V in H)
                  if (H[V] === D)
                    return V | 0;
                return -1;
              }
              getMap() {
                return this._map;
              }
              readCharCode(D, H, V) {
                let Z = 0;
                const ne = this.codespaceRanges;
                for (let K = 0, q = ne.length; K < q; K++) {
                  Z = (Z << 8 | D.charCodeAt(H + K)) >>> 0;
                  const Y = ne[K];
                  for (let ee = 0, Q = Y.length; ee < Q; ) {
                    const J = Y[ee++], te = Y[ee++];
                    if (Z >= J && Z <= te) {
                      V.charcode = Z, V.length = K + 1;
                      return;
                    }
                  }
                }
                V.charcode = 0, V.length = 1;
              }
              getCharCodeLength(D) {
                const H = this.codespaceRanges;
                for (let V = 0, Z = H.length; V < Z; V++) {
                  const ne = H[V];
                  for (let K = 0, q = ne.length; K < q; ) {
                    const Y = ne[K++], ee = ne[K++];
                    if (D >= Y && D <= ee)
                      return V + 1;
                  }
                }
                return 1;
              }
              get length() {
                return this._map.length;
              }
              get isIdentityCMap() {
                if (!(this.name === "Identity-H" || this.name === "Identity-V") || this._map.length !== 65536)
                  return !1;
                for (let D = 0; D < 65536; D++)
                  if (this._map[D] !== D)
                    return !1;
                return !0;
              }
            }
            A.CMap = T;
            class I extends T {
              constructor(D, H) {
                super(), this.vertical = D, this.addCodespaceRange(H, 0, 65535);
              }
              mapCidRange(D, H, V) {
                (0, g.unreachable)("should not call mapCidRange");
              }
              mapBfRange(D, H, V) {
                (0, g.unreachable)("should not call mapBfRange");
              }
              mapBfRangeToArray(D, H, V) {
                (0, g.unreachable)("should not call mapBfRangeToArray");
              }
              mapOne(D, H) {
                (0, g.unreachable)("should not call mapCidOne");
              }
              lookup(D) {
                return Number.isInteger(D) && D <= 65535 ? D : void 0;
              }
              contains(D) {
                return Number.isInteger(D) && D <= 65535;
              }
              forEach(D) {
                for (let H = 0; H <= 65535; H++)
                  D(H, H);
              }
              charCodeOf(D) {
                return Number.isInteger(D) && D <= 65535 ? D : -1;
              }
              getMap() {
                const D = new Array(65536);
                for (let H = 0; H <= 65535; H++)
                  D[H] = H;
                return D;
              }
              get length() {
                return 65536;
              }
              get isIdentityCMap() {
                (0, g.unreachable)("should not access .isIdentityCMap");
              }
            }
            A.IdentityCMap = I;
            function _(P) {
              let D = 0;
              for (let H = 0; H < P.length; H++)
                D = D << 8 | P.charCodeAt(H);
              return D >>> 0;
            }
            function E(P) {
              if (typeof P != "string")
                throw new g.FormatError("Malformed CMap: expected string.");
            }
            function R(P) {
              if (!Number.isInteger(P))
                throw new g.FormatError("Malformed CMap: expected int.");
            }
            function O(P, D) {
              for (; ; ) {
                let H = D.getObj();
                if (H === b.EOF)
                  break;
                if ((0, b.isCmd)(H, "endbfchar"))
                  return;
                E(H);
                const V = _(H);
                H = D.getObj(), E(H);
                const Z = H;
                P.mapOne(V, Z);
              }
            }
            function L(P, D) {
              for (; ; ) {
                let H = D.getObj();
                if (H === b.EOF)
                  break;
                if ((0, b.isCmd)(H, "endbfrange"))
                  return;
                E(H);
                const V = _(H);
                H = D.getObj(), E(H);
                const Z = _(H);
                if (H = D.getObj(), Number.isInteger(H) || typeof H == "string") {
                  const ne = Number.isInteger(H) ? String.fromCharCode(H) : H;
                  P.mapBfRange(V, Z, ne);
                } else if ((0, b.isCmd)(H, "[")) {
                  H = D.getObj();
                  const ne = [];
                  for (; !(0, b.isCmd)(H, "]") && H !== b.EOF; )
                    ne.push(H), H = D.getObj();
                  P.mapBfRangeToArray(V, Z, ne);
                } else
                  break;
              }
              throw new g.FormatError("Invalid bf range.");
            }
            function B(P, D) {
              for (; ; ) {
                let H = D.getObj();
                if (H === b.EOF)
                  break;
                if ((0, b.isCmd)(H, "endcidchar"))
                  return;
                E(H);
                const V = _(H);
                H = D.getObj(), R(H);
                const Z = H;
                P.mapOne(V, Z);
              }
            }
            function F(P, D) {
              for (; ; ) {
                let H = D.getObj();
                if (H === b.EOF)
                  break;
                if ((0, b.isCmd)(H, "endcidrange"))
                  return;
                E(H);
                const V = _(H);
                H = D.getObj(), E(H);
                const Z = _(H);
                H = D.getObj(), R(H);
                const ne = H;
                P.mapCidRange(V, Z, ne);
              }
            }
            function M(P, D) {
              for (; ; ) {
                let H = D.getObj();
                if (H === b.EOF)
                  break;
                if ((0, b.isCmd)(H, "endcodespacerange"))
                  return;
                if (typeof H != "string")
                  break;
                const V = _(H);
                if (H = D.getObj(), typeof H != "string")
                  break;
                const Z = _(H);
                P.addCodespaceRange(H.length, V, Z);
              }
              throw new g.FormatError("Invalid codespace range.");
            }
            function W(P, D) {
              const H = D.getObj();
              Number.isInteger(H) && (P.vertical = !!H);
            }
            function j(P, D) {
              const H = D.getObj();
              H instanceof b.Name && (P.name = H.name);
            }
            async function G(P, D, H, V) {
              let Z, ne;
              e: for (; ; )
                try {
                  const K = D.getObj();
                  if (K === b.EOF)
                    break;
                  if (K instanceof b.Name)
                    K.name === "WMode" ? W(P, D) : K.name === "CMapName" && j(P, D), Z = K;
                  else if (K instanceof b.Cmd)
                    switch (K.cmd) {
                      case "endcmap":
                        break e;
                      case "usecmap":
                        Z instanceof b.Name && (ne = Z.name);
                        break;
                      case "begincodespacerange":
                        M(P, D);
                        break;
                      case "beginbfchar":
                        O(P, D);
                        break;
                      case "begincidchar":
                        B(P, D);
                        break;
                      case "beginbfrange":
                        L(P, D);
                        break;
                      case "begincidrange":
                        F(P, D);
                        break;
                    }
                } catch (K) {
                  if (K instanceof C.MissingDataException)
                    throw K;
                  (0, g.warn)("Invalid cMap data: " + K);
                  continue;
                }
              return !V && ne && (V = ne), V ? U(P, H, V) : P;
            }
            async function U(P, D, H) {
              if (P.useCMap = await k(H, D), P.numCodespaceRanges === 0) {
                const V = P.useCMap.codespaceRanges;
                for (let Z = 0; Z < V.length; Z++)
                  P.codespaceRanges[Z] = V[Z].slice();
                P.numCodespaceRanges = P.useCMap.numCodespaceRanges;
              }
              return P.useCMap.forEach(function(V, Z) {
                P.contains(V) || P.mapOne(V, P.useCMap.lookup(V));
              }), P;
            }
            async function k(P, D) {
              if (P === "Identity-H")
                return new I(!1, 2);
              if (P === "Identity-V")
                return new I(!0, 2);
              if (!S.includes(P))
                throw new Error("Unknown CMap name: " + P);
              if (!D)
                throw new Error("Built-in CMap parameters are not provided.");
              const {
                cMapData: H,
                compressionType: V
              } = await D(P), Z = new T(!0);
              if (V === g.CMapCompressionType.BINARY)
                return new f.BinaryCMapReader().process(H, Z, (ne) => U(Z, D, ne));
              if (V === g.CMapCompressionType.NONE) {
                const ne = new m.Lexer(new w.Stream(H));
                return G(Z, ne, D, null);
              }
              throw new Error(`Invalid CMap "compressionType" value: ${V}`);
            }
            class N {
              static async create({
                encoding: D,
                fetchBuiltInCMap: H,
                useCMap: V
              }) {
                if (D instanceof b.Name)
                  return k(D.name, H);
                if (D instanceof y.BaseStream) {
                  const Z = await G(new T(), new m.Lexer(D), H, V);
                  return Z.isIdentityCMap ? k(Z.name, H) : Z;
                }
                throw new Error("Encoding required.");
              }
            }
            A.CMapFactory = N;
          },
          /* 15 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.BinaryCMapReader = void 0;
            var g = x(2);
            function b(T, I) {
              let _ = 0;
              for (let E = 0; E <= I; E++)
                _ = _ << 8 | T[E];
              return _ >>> 0;
            }
            function y(T, I) {
              return I === 1 ? String.fromCharCode(T[0], T[1]) : I === 3 ? String.fromCharCode(T[0], T[1], T[2], T[3]) : String.fromCharCode(...T.subarray(0, I + 1));
            }
            function f(T, I, _) {
              let E = 0;
              for (let R = _; R >= 0; R--)
                E += T[R] + I[R], T[R] = E & 255, E >>= 8;
            }
            function m(T, I) {
              let _ = 1;
              for (let E = I; E >= 0 && _ > 0; E--)
                _ += T[E], T[E] = _ & 255, _ >>= 8;
            }
            const C = 16, w = 19;
            class S {
              constructor(I) {
                this.buffer = I, this.pos = 0, this.end = I.length, this.tmpBuf = new Uint8Array(w);
              }
              readByte() {
                return this.pos >= this.end ? -1 : this.buffer[this.pos++];
              }
              readNumber() {
                let I = 0, _;
                do {
                  const E = this.readByte();
                  if (E < 0)
                    throw new g.FormatError("unexpected EOF in bcmap");
                  _ = !(E & 128), I = I << 7 | E & 127;
                } while (!_);
                return I;
              }
              readSigned() {
                const I = this.readNumber();
                return I & 1 ? ~(I >>> 1) : I >>> 1;
              }
              readHex(I, _) {
                I.set(this.buffer.subarray(this.pos, this.pos + _ + 1)), this.pos += _ + 1;
              }
              readHexNumber(I, _) {
                let E;
                const R = this.tmpBuf;
                let O = 0;
                do {
                  const M = this.readByte();
                  if (M < 0)
                    throw new g.FormatError("unexpected EOF in bcmap");
                  E = !(M & 128), R[O++] = M & 127;
                } while (!E);
                let L = _, B = 0, F = 0;
                for (; L >= 0; ) {
                  for (; F < 8 && R.length > 0; )
                    B |= R[--O] << F, F += 7;
                  I[L] = B & 255, L--, B >>= 8, F -= 8;
                }
              }
              readHexSigned(I, _) {
                this.readHexNumber(I, _);
                const E = I[_] & 1 ? 255 : 0;
                let R = 0;
                for (let O = 0; O <= _; O++)
                  R = (R & 1) << 8 | I[O], I[O] = R >> 1 ^ E;
              }
              readString() {
                const I = this.readNumber(), _ = new Array(I);
                for (let E = 0; E < I; E++)
                  _[E] = this.readNumber();
                return String.fromCharCode(..._);
              }
            }
            class $ {
              async process(I, _, E) {
                const R = new S(I), O = R.readByte();
                _.vertical = !!(O & 1);
                let L = null;
                const B = new Uint8Array(C), F = new Uint8Array(C), M = new Uint8Array(C), W = new Uint8Array(C), j = new Uint8Array(C);
                let G, U;
                for (; (U = R.readByte()) >= 0; ) {
                  const k = U >> 5;
                  if (k === 7) {
                    switch (U & 31) {
                      case 0:
                        R.readString();
                        break;
                      case 1:
                        L = R.readString();
                        break;
                    }
                    continue;
                  }
                  const N = !!(U & 16), P = U & 15;
                  if (P + 1 > C)
                    throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                  const D = 1, H = R.readNumber();
                  switch (k) {
                    case 0:
                      R.readHex(B, P), R.readHexNumber(F, P), f(F, B, P), _.addCodespaceRange(P + 1, b(B, P), b(F, P));
                      for (let V = 1; V < H; V++)
                        m(F, P), R.readHexNumber(B, P), f(B, F, P), R.readHexNumber(F, P), f(F, B, P), _.addCodespaceRange(P + 1, b(B, P), b(F, P));
                      break;
                    case 1:
                      R.readHex(B, P), R.readHexNumber(F, P), f(F, B, P), R.readNumber();
                      for (let V = 1; V < H; V++)
                        m(F, P), R.readHexNumber(B, P), f(B, F, P), R.readHexNumber(F, P), f(F, B, P), R.readNumber();
                      break;
                    case 2:
                      R.readHex(M, P), G = R.readNumber(), _.mapOne(b(M, P), G);
                      for (let V = 1; V < H; V++)
                        m(M, P), N || (R.readHexNumber(j, P), f(M, j, P)), G = R.readSigned() + (G + 1), _.mapOne(b(M, P), G);
                      break;
                    case 3:
                      R.readHex(B, P), R.readHexNumber(F, P), f(F, B, P), G = R.readNumber(), _.mapCidRange(b(B, P), b(F, P), G);
                      for (let V = 1; V < H; V++)
                        m(F, P), N ? B.set(F) : (R.readHexNumber(B, P), f(B, F, P)), R.readHexNumber(F, P), f(F, B, P), G = R.readNumber(), _.mapCidRange(b(B, P), b(F, P), G);
                      break;
                    case 4:
                      R.readHex(M, D), R.readHex(W, P), _.mapOne(b(M, D), y(W, P));
                      for (let V = 1; V < H; V++)
                        m(M, D), N || (R.readHexNumber(j, D), f(M, j, D)), m(W, P), R.readHexSigned(j, P), f(W, j, P), _.mapOne(b(M, D), y(W, P));
                      break;
                    case 5:
                      R.readHex(B, D), R.readHexNumber(F, D), f(F, B, D), R.readHex(W, P), _.mapBfRange(b(B, D), b(F, D), y(W, P));
                      for (let V = 1; V < H; V++)
                        m(F, D), N ? B.set(F) : (R.readHexNumber(B, D), f(B, F, D)), R.readHexNumber(F, D), f(F, B, D), R.readHex(W, P), _.mapBfRange(b(B, D), b(F, D), y(W, P));
                      break;
                    default:
                      throw new Error(`BinaryCMapReader.process - unknown type: ${k}`);
                  }
                }
                return L ? E(L) : _;
              }
            }
            A.BinaryCMapReader = $;
          },
          /* 16 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Parser = A.Linearization = A.Lexer = void 0;
            var g = x(2), b = x(4), y = x(3), f = x(8), m = x(17), C = x(19), w = x(20), S = x(22), $ = x(23), T = x(26), I = x(29), _ = x(31), E = x(32), R = x(33);
            const O = 1e3;
            function L(G) {
              const U = [], k = G.length;
              let N = 0;
              for (; N < k - 1; )
                U.push(G[N++] << 8 | G[N++]);
              return N < k && U.push(G[N]), k + "_" + String.fromCharCode.apply(null, U);
            }
            class B {
              constructor({
                lexer: U,
                xref: k,
                allowStreams: N = !1,
                recoveryMode: P = !1
              }) {
                this.lexer = U, this.xref = k, this.allowStreams = N, this.recoveryMode = P, this.imageCache = /* @__PURE__ */ Object.create(null), this._imageId = 0, this.refill();
              }
              refill() {
                this.buf1 = this.lexer.getObj(), this.buf2 = this.lexer.getObj();
              }
              shift() {
                this.buf2 instanceof b.Cmd && this.buf2.cmd === "ID" ? (this.buf1 = this.buf2, this.buf2 = null) : (this.buf1 = this.buf2, this.buf2 = this.lexer.getObj());
              }
              tryShift() {
                try {
                  return this.shift(), !0;
                } catch (U) {
                  if (U instanceof y.MissingDataException)
                    throw U;
                  return !1;
                }
              }
              getObj(U = null) {
                const k = this.buf1;
                if (this.shift(), k instanceof b.Cmd)
                  switch (k.cmd) {
                    case "BI":
                      return this.makeInlineImage(U);
                    case "[":
                      const N = [];
                      for (; !(0, b.isCmd)(this.buf1, "]") && this.buf1 !== b.EOF; )
                        N.push(this.getObj(U));
                      if (this.buf1 === b.EOF) {
                        if (this.recoveryMode)
                          return N;
                        throw new y.ParserEOFException("End of file inside array.");
                      }
                      return this.shift(), N;
                    case "<<":
                      const P = new b.Dict(this.xref);
                      for (; !(0, b.isCmd)(this.buf1, ">>") && this.buf1 !== b.EOF; ) {
                        if (!(this.buf1 instanceof b.Name)) {
                          (0, g.info)("Malformed dictionary: key must be a name object"), this.shift();
                          continue;
                        }
                        const D = this.buf1.name;
                        if (this.shift(), this.buf1 === b.EOF)
                          break;
                        P.set(D, this.getObj(U));
                      }
                      if (this.buf1 === b.EOF) {
                        if (this.recoveryMode)
                          return P;
                        throw new y.ParserEOFException("End of file inside dictionary.");
                      }
                      return (0, b.isCmd)(this.buf2, "stream") ? this.allowStreams ? this.makeStream(P, U) : P : (this.shift(), P);
                    default:
                      return k;
                  }
                if (Number.isInteger(k)) {
                  if (Number.isInteger(this.buf1) && (0, b.isCmd)(this.buf2, "R")) {
                    const N = b.Ref.get(k, this.buf1);
                    return this.shift(), this.shift(), N;
                  }
                  return k;
                }
                return typeof k == "string" && U ? U.decryptString(k) : k;
              }
              findDefaultInlineStreamEnd(U) {
                const {
                  knownCommands: Z
                } = this.lexer, ne = U.pos, K = 15;
                let q = 0, Y, ee;
                for (; (Y = U.getByte()) !== -1; )
                  if (q === 0)
                    q = Y === 69 ? 1 : 0;
                  else if (q === 1)
                    q = Y === 73 ? 2 : 0;
                  else if (Y === 32 || Y === 10 || Y === 13) {
                    ee = U.pos;
                    const J = U.peekBytes(K), te = J.length;
                    if (te === 0)
                      break;
                    for (let ie = 0; ie < te; ie++)
                      if (Y = J[ie], !(Y === 0 && J[ie + 1] !== 0) && Y !== 10 && Y !== 13 && (Y < 32 || Y > 127)) {
                        q = 0;
                        break;
                      }
                    if (q !== 2)
                      continue;
                    if (!Z) {
                      (0, g.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                      continue;
                    }
                    const ae = new W(new f.Stream(J.slice()), Z);
                    ae._hexStringWarn = () => {
                    };
                    let se = 0;
                    for (; ; ) {
                      const ie = ae.getObj();
                      if (ie === b.EOF) {
                        q = 0;
                        break;
                      }
                      if (ie instanceof b.Cmd) {
                        const fe = Z[ie.cmd];
                        if (fe) {
                          if (fe.variableArgs ? se <= fe.numArgs : se === fe.numArgs)
                            break;
                        } else {
                          q = 0;
                          break;
                        }
                        se = 0;
                        continue;
                      }
                      se++;
                    }
                    if (q === 2)
                      break;
                  } else
                    q = 0;
                Y === -1 && ((0, g.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker"), ee && ((0, g.warn)('... trying to recover by using the last "EI" occurrence.'), U.skip(-(U.pos - ee))));
                let Q = 4;
                return U.skip(-Q), Y = U.peekByte(), U.skip(Q), (0, y.isWhiteSpace)(Y) || Q--, U.pos - Q - ne;
              }
              findDCTDecodeInlineStreamEnd(U) {
                const k = U.pos;
                let N = !1, P, D;
                for (; (P = U.getByte()) !== -1; )
                  if (P === 255) {
                    switch (U.getByte()) {
                      case 0:
                        break;
                      case 255:
                        U.skip(-1);
                        break;
                      case 217:
                        N = !0;
                        break;
                      case 192:
                      case 193:
                      case 194:
                      case 195:
                      case 197:
                      case 198:
                      case 199:
                      case 201:
                      case 202:
                      case 203:
                      case 205:
                      case 206:
                      case 207:
                      case 196:
                      case 204:
                      case 218:
                      case 219:
                      case 220:
                      case 221:
                      case 222:
                      case 223:
                      case 224:
                      case 225:
                      case 226:
                      case 227:
                      case 228:
                      case 229:
                      case 230:
                      case 231:
                      case 232:
                      case 233:
                      case 234:
                      case 235:
                      case 236:
                      case 237:
                      case 238:
                      case 239:
                      case 254:
                        D = U.getUint16(), D > 2 ? U.skip(D - 2) : U.skip(-2);
                        break;
                    }
                    if (N)
                      break;
                  }
                const H = U.pos - k;
                return P === -1 ? ((0, g.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead."), U.skip(-H), this.findDefaultInlineStreamEnd(U)) : (this.inlineStreamSkipEI(U), H);
              }
              findASCII85DecodeInlineStreamEnd(U) {
                const P = U.pos;
                let D;
                for (; (D = U.getByte()) !== -1; )
                  if (D === 126) {
                    const V = U.pos;
                    for (D = U.peekByte(); (0, y.isWhiteSpace)(D); )
                      U.skip(), D = U.peekByte();
                    if (D === 62) {
                      U.skip();
                      break;
                    }
                    if (U.pos > V) {
                      const Z = U.peekBytes(2);
                      if (Z[0] === 69 && Z[1] === 73)
                        break;
                    }
                  }
                const H = U.pos - P;
                return D === -1 ? ((0, g.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead."), U.skip(-H), this.findDefaultInlineStreamEnd(U)) : (this.inlineStreamSkipEI(U), H);
              }
              findASCIIHexDecodeInlineStreamEnd(U) {
                const N = U.pos;
                let P;
                for (; (P = U.getByte()) !== -1 && P !== 62; )
                  ;
                const D = U.pos - N;
                return P === -1 ? ((0, g.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead."), U.skip(-D), this.findDefaultInlineStreamEnd(U)) : (this.inlineStreamSkipEI(U), D);
              }
              inlineStreamSkipEI(U) {
                let P = 0, D;
                for (; (D = U.getByte()) !== -1; )
                  if (P === 0)
                    P = D === 69 ? 1 : 0;
                  else if (P === 1)
                    P = D === 73 ? 2 : 0;
                  else if (P === 2)
                    break;
              }
              makeInlineImage(U) {
                const k = this.lexer, N = k.stream, P = /* @__PURE__ */ Object.create(null);
                let D;
                for (; !(0, b.isCmd)(this.buf1, "ID") && this.buf1 !== b.EOF; ) {
                  if (!(this.buf1 instanceof b.Name))
                    throw new g.FormatError("Dictionary key must be a name object");
                  const ee = this.buf1.name;
                  if (this.shift(), this.buf1 === b.EOF)
                    break;
                  P[ee] = this.getObj(U);
                }
                k.beginInlineImagePos !== -1 && (D = N.pos - k.beginInlineImagePos);
                const H = this.xref.fetchIfRef(P.F || P.Filter);
                let V;
                if (H instanceof b.Name)
                  V = H.name;
                else if (Array.isArray(H)) {
                  const ee = this.xref.fetchIfRef(H[0]);
                  ee instanceof b.Name && (V = ee.name);
                }
                const Z = N.pos;
                let ne;
                switch (V) {
                  case "DCT":
                  case "DCTDecode":
                    ne = this.findDCTDecodeInlineStreamEnd(N);
                    break;
                  case "A85":
                  case "ASCII85Decode":
                    ne = this.findASCII85DecodeInlineStreamEnd(N);
                    break;
                  case "AHx":
                  case "ASCIIHexDecode":
                    ne = this.findASCIIHexDecodeInlineStreamEnd(N);
                    break;
                  default:
                    ne = this.findDefaultInlineStreamEnd(N);
                }
                let K;
                if (ne < O && D > 0) {
                  const ee = N.pos;
                  N.pos = k.beginInlineImagePos, K = L(N.getBytes(D + ne)), N.pos = ee;
                  const Q = this.imageCache[K];
                  if (Q !== void 0)
                    return this.buf2 = b.Cmd.get("EI"), this.shift(), Q.reset(), Q;
                }
                const q = new b.Dict(this.xref);
                for (const ee in P)
                  q.set(ee, P[ee]);
                let Y = N.makeSubStream(Z, ne, q);
                return U && (Y = U.createStream(Y, ne)), Y = this.filter(Y, q, ne), Y.dict = q, K !== void 0 && (Y.cacheKey = `inline_img_${++this._imageId}`, this.imageCache[K] = Y), this.buf2 = b.Cmd.get("EI"), this.shift(), Y;
              }
              _findStreamLength(U, k) {
                const {
                  stream: N
                } = this.lexer;
                N.pos = U;
                const P = 2048, D = k.length;
                for (; N.pos < N.end; ) {
                  const H = N.peekBytes(P), V = H.length - D;
                  if (V <= 0)
                    break;
                  let Z = 0;
                  for (; Z < V; ) {
                    let ne = 0;
                    for (; ne < D && H[Z + ne] === k[ne]; )
                      ne++;
                    if (ne >= D)
                      return N.pos += Z, N.pos - U;
                    Z++;
                  }
                  N.pos += V;
                }
                return -1;
              }
              makeStream(U, k) {
                const N = this.lexer;
                let P = N.stream;
                N.skipToNextLine();
                const D = P.pos - 1;
                let H = U.get("Length");
                if (Number.isInteger(H) || ((0, g.info)(`Bad length "${H && H.toString()}" in stream.`), H = 0), P.pos = D + H, N.nextChar(), this.tryShift() && (0, b.isCmd)(this.buf2, "endstream"))
                  this.shift();
                else {
                  const V = new Uint8Array([101, 110, 100, 115, 116, 114, 101, 97, 109]);
                  let Z = this._findStreamLength(D, V);
                  if (Z < 0) {
                    for (let K = 1; K <= 1; K++) {
                      const q = V.length - K, Y = V.slice(0, q), ee = this._findStreamLength(D, Y);
                      if (ee >= 0) {
                        const Q = P.peekBytes(q + 1)[q];
                        if (!(0, y.isWhiteSpace)(Q))
                          break;
                        (0, g.info)(`Found "${(0, g.bytesToString)(Y)}" when searching for endstream command.`), Z = ee;
                        break;
                      }
                    }
                    if (Z < 0)
                      throw new g.FormatError("Missing endstream command.");
                  }
                  H = Z, N.nextChar(), this.shift(), this.shift();
                }
                return this.shift(), P = P.makeSubStream(D, H, U), k && (P = k.createStream(P, H)), P = this.filter(P, U, H), P.dict = U, P;
              }
              filter(U, k, N) {
                let P = k.get("F", "Filter"), D = k.get("DP", "DecodeParms");
                if (P instanceof b.Name)
                  return Array.isArray(D) && (0, g.warn)("/DecodeParms should not be an Array, when /Filter is a Name."), this.makeFilter(U, P.name, N, D);
                let H = N;
                if (Array.isArray(P)) {
                  const V = P, Z = D;
                  for (let ne = 0, K = V.length; ne < K; ++ne) {
                    if (P = this.xref.fetchIfRef(V[ne]), !(P instanceof b.Name))
                      throw new g.FormatError(`Bad filter name "${P}"`);
                    D = null, Array.isArray(Z) && ne in Z && (D = this.xref.fetchIfRef(Z[ne])), U = this.makeFilter(U, P.name, H, D), H = null;
                  }
                }
                return U;
              }
              makeFilter(U, k, N, P) {
                if (N === 0)
                  return (0, g.warn)(`Empty "${k}" stream.`), new f.NullStream();
                try {
                  switch (k) {
                    case "Fl":
                    case "FlateDecode":
                      return P ? new E.PredictorStream(new S.FlateStream(U, N), N, P) : new S.FlateStream(U, N);
                    case "LZW":
                    case "LZWDecode":
                      let D = 1;
                      return P ? (P.has("EarlyChange") && (D = P.get("EarlyChange")), new E.PredictorStream(new _.LZWStream(U, N, D), N, P)) : new _.LZWStream(U, N, D);
                    case "DCT":
                    case "DCTDecode":
                      return new T.JpegStream(U, N, P);
                    case "JPX":
                    case "JPXDecode":
                      return new I.JpxStream(U, N, P);
                    case "A85":
                    case "ASCII85Decode":
                      return new m.Ascii85Stream(U, N);
                    case "AHx":
                    case "ASCIIHexDecode":
                      return new C.AsciiHexStream(U, N);
                    case "CCF":
                    case "CCITTFaxDecode":
                      return new w.CCITTFaxStream(U, N, P);
                    case "RL":
                    case "RunLengthDecode":
                      return new R.RunLengthStream(U, N);
                    case "JBIG2Decode":
                      return new $.Jbig2Stream(U, N, P);
                  }
                  return (0, g.warn)(`Filter "${k}" is not supported.`), U;
                } catch (D) {
                  if (D instanceof y.MissingDataException)
                    throw D;
                  return (0, g.warn)(`Invalid stream: "${D}"`), new f.NullStream();
                }
              }
            }
            A.Parser = B;
            const F = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            function M(G) {
              return G >= 48 && G <= 57 ? G & 15 : G >= 65 && G <= 70 || G >= 97 && G <= 102 ? (G & 15) + 9 : -1;
            }
            class W {
              constructor(U, k = null) {
                this.stream = U, this.nextChar(), this.strBuf = [], this.knownCommands = k, this._hexStringNumWarn = 0, this.beginInlineImagePos = -1;
              }
              nextChar() {
                return this.currentChar = this.stream.getByte();
              }
              peekChar() {
                return this.stream.peekByte();
              }
              getNumber() {
                let U = this.currentChar, k = !1, N = 0, P = 1;
                if (U === 45 ? (P = -1, U = this.nextChar(), U === 45 && (U = this.nextChar())) : U === 43 && (U = this.nextChar()), U === 10 || U === 13)
                  do
                    U = this.nextChar();
                  while (U === 10 || U === 13);
                if (U === 46 && (N = 10, U = this.nextChar()), U < 48 || U > 57) {
                  const Z = `Invalid number: ${String.fromCharCode(U)} (charCode ${U})`;
                  if ((0, y.isWhiteSpace)(U) || U === -1)
                    return (0, g.info)(`Lexer.getNumber - "${Z}".`), 0;
                  throw new g.FormatError(Z);
                }
                let D = U - 48, H = 0, V = 1;
                for (; (U = this.nextChar()) >= 0; )
                  if (U >= 48 && U <= 57) {
                    const Z = U - 48;
                    k ? H = H * 10 + Z : (N !== 0 && (N *= 10), D = D * 10 + Z);
                  } else if (U === 46)
                    if (N === 0)
                      N = 1;
                    else
                      break;
                  else if (U === 45)
                    (0, g.warn)("Badly formatted number: minus sign in the middle");
                  else if (U === 69 || U === 101) {
                    if (U = this.peekChar(), U === 43 || U === 45)
                      V = U === 45 ? -1 : 1, this.nextChar();
                    else if (U < 48 || U > 57)
                      break;
                    k = !0;
                  } else
                    break;
                return N !== 0 && (D /= N), k && (D *= 10 ** (V * H)), P * D;
              }
              getString() {
                let U = 1, k = !1;
                const N = this.strBuf;
                N.length = 0;
                let P = this.nextChar();
                for (; ; ) {
                  let D = !1;
                  switch (P | 0) {
                    case -1:
                      (0, g.warn)("Unterminated string"), k = !0;
                      break;
                    case 40:
                      ++U, N.push("(");
                      break;
                    case 41:
                      --U === 0 ? (this.nextChar(), k = !0) : N.push(")");
                      break;
                    case 92:
                      switch (P = this.nextChar(), P) {
                        case -1:
                          (0, g.warn)("Unterminated string"), k = !0;
                          break;
                        case 110:
                          N.push(`
`);
                          break;
                        case 114:
                          N.push("\r");
                          break;
                        case 116:
                          N.push("	");
                          break;
                        case 98:
                          N.push("\b");
                          break;
                        case 102:
                          N.push("\f");
                          break;
                        case 92:
                        case 40:
                        case 41:
                          N.push(String.fromCharCode(P));
                          break;
                        case 48:
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                          let H = P & 15;
                          P = this.nextChar(), D = !0, P >= 48 && P <= 55 && (H = (H << 3) + (P & 15), P = this.nextChar(), P >= 48 && P <= 55 && (D = !1, H = (H << 3) + (P & 15))), N.push(String.fromCharCode(H));
                          break;
                        case 13:
                          this.peekChar() === 10 && this.nextChar();
                          break;
                        case 10:
                          break;
                        default:
                          N.push(String.fromCharCode(P));
                          break;
                      }
                      break;
                    default:
                      N.push(String.fromCharCode(P));
                      break;
                  }
                  if (k)
                    break;
                  D || (P = this.nextChar());
                }
                return N.join("");
              }
              getName() {
                let U, k;
                const N = this.strBuf;
                for (N.length = 0; (U = this.nextChar()) >= 0 && !F[U]; )
                  if (U === 35) {
                    if (U = this.nextChar(), F[U]) {
                      (0, g.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number."), N.push("#");
                      break;
                    }
                    const P = M(U);
                    if (P !== -1) {
                      k = U, U = this.nextChar();
                      const D = M(U);
                      if (D === -1) {
                        if ((0, g.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(U)}) in hexadecimal number.`), N.push("#", String.fromCharCode(k)), F[U])
                          break;
                        N.push(String.fromCharCode(U));
                        continue;
                      }
                      N.push(String.fromCharCode(P << 4 | D));
                    } else
                      N.push("#", String.fromCharCode(U));
                  } else
                    N.push(String.fromCharCode(U));
                return N.length > 127 && (0, g.warn)(`Name token is longer than allowed by the spec: ${N.length}`), b.Name.get(N.join(""));
              }
              _hexStringWarn(U) {
                if (this._hexStringNumWarn++ === 5) {
                  (0, g.warn)("getHexString - ignoring additional invalid characters.");
                  return;
                }
                this._hexStringNumWarn > 5 || (0, g.warn)(`getHexString - ignoring invalid character: ${U}`);
              }
              getHexString() {
                const U = this.strBuf;
                U.length = 0;
                let k = this.currentChar, N = !0, P, D;
                for (this._hexStringNumWarn = 0; ; )
                  if (k < 0) {
                    (0, g.warn)("Unterminated hex string");
                    break;
                  } else if (k === 62) {
                    this.nextChar();
                    break;
                  } else if (F[k] === 1) {
                    k = this.nextChar();
                    continue;
                  } else {
                    if (N) {
                      if (P = M(k), P === -1) {
                        this._hexStringWarn(k), k = this.nextChar();
                        continue;
                      }
                    } else {
                      if (D = M(k), D === -1) {
                        this._hexStringWarn(k), k = this.nextChar();
                        continue;
                      }
                      U.push(String.fromCharCode(P << 4 | D));
                    }
                    N = !N, k = this.nextChar();
                  }
                return U.join("");
              }
              getObj() {
                let U = !1, k = this.currentChar;
                for (; ; ) {
                  if (k < 0)
                    return b.EOF;
                  if (U)
                    (k === 10 || k === 13) && (U = !1);
                  else if (k === 37)
                    U = !0;
                  else if (F[k] !== 1)
                    break;
                  k = this.nextChar();
                }
                switch (k | 0) {
                  case 48:
                  case 49:
                  case 50:
                  case 51:
                  case 52:
                  case 53:
                  case 54:
                  case 55:
                  case 56:
                  case 57:
                  case 43:
                  case 45:
                  case 46:
                    return this.getNumber();
                  case 40:
                    return this.getString();
                  case 47:
                    return this.getName();
                  case 91:
                    return this.nextChar(), b.Cmd.get("[");
                  case 93:
                    return this.nextChar(), b.Cmd.get("]");
                  case 60:
                    return k = this.nextChar(), k === 60 ? (this.nextChar(), b.Cmd.get("<<")) : this.getHexString();
                  case 62:
                    return k = this.nextChar(), k === 62 ? (this.nextChar(), b.Cmd.get(">>")) : b.Cmd.get(">");
                  case 123:
                    return this.nextChar(), b.Cmd.get("{");
                  case 125:
                    return this.nextChar(), b.Cmd.get("}");
                  case 41:
                    throw this.nextChar(), new g.FormatError(`Illegal character: ${k}`);
                }
                let N = String.fromCharCode(k);
                if (k < 32 || k > 127) {
                  const H = this.peekChar();
                  if (H >= 32 && H <= 127)
                    return this.nextChar(), b.Cmd.get(N);
                }
                const P = this.knownCommands;
                let D = P?.[N] !== void 0;
                for (; (k = this.nextChar()) >= 0 && !F[k]; ) {
                  const H = N + String.fromCharCode(k);
                  if (D && P[H] === void 0)
                    break;
                  if (N.length === 128)
                    throw new g.FormatError(`Command token too long: ${N.length}`);
                  N = H, D = P?.[N] !== void 0;
                }
                return N === "true" ? !0 : N === "false" ? !1 : N === "null" ? null : (N === "BI" && (this.beginInlineImagePos = this.stream.pos), b.Cmd.get(N));
              }
              skipToNextLine() {
                let U = this.currentChar;
                for (; U >= 0; ) {
                  if (U === 13) {
                    U = this.nextChar(), U === 10 && this.nextChar();
                    break;
                  } else if (U === 10) {
                    this.nextChar();
                    break;
                  }
                  U = this.nextChar();
                }
              }
            }
            A.Lexer = W;
            class j {
              static create(U) {
                function k(q, Y, ee = !1) {
                  const Q = q.get(Y);
                  if (Number.isInteger(Q) && (ee ? Q >= 0 : Q > 0))
                    return Q;
                  throw new Error(`The "${Y}" parameter in the linearization dictionary is invalid.`);
                }
                function N(q) {
                  const Y = q.get("H");
                  let ee;
                  if (Array.isArray(Y) && ((ee = Y.length) === 2 || ee === 4)) {
                    for (let Q = 0; Q < ee; Q++) {
                      const J = Y[Q];
                      if (!(Number.isInteger(J) && J > 0))
                        throw new Error(`Hint (${Q}) in the linearization dictionary is invalid.`);
                    }
                    return Y;
                  }
                  throw new Error("Hint array in the linearization dictionary is invalid.");
                }
                const P = new B({
                  lexer: new W(U),
                  xref: null
                }), D = P.getObj(), H = P.getObj(), V = P.getObj(), Z = P.getObj();
                let ne, K;
                if (Number.isInteger(D) && Number.isInteger(H) && (0, b.isCmd)(V, "obj") && Z instanceof b.Dict && typeof (ne = Z.get("Linearized")) == "number" && ne > 0) {
                  if ((K = k(Z, "L")) !== U.length)
                    throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
                } else return null;
                return {
                  length: K,
                  hints: N(Z),
                  objectNumberFirst: k(Z, "O"),
                  endFirst: k(Z, "E"),
                  numPages: k(Z, "N"),
                  mainXRefEntriesOffset: k(Z, "T"),
                  pageFirst: Z.has("P") ? k(Z, "P", !0) : 0
                };
              }
            }
            A.Linearization = j;
          },
          /* 17 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Ascii85Stream = void 0;
            var g = x(18), b = x(3);
            class y extends g.DecodeStream {
              constructor(m, C) {
                C && (C *= 0.8), super(C), this.str = m, this.dict = m.dict, this.input = new Uint8Array(5);
              }
              readBlock() {
                const S = this.str;
                let $ = S.getByte();
                for (; (0, b.isWhiteSpace)($); )
                  $ = S.getByte();
                if ($ === -1 || $ === 126) {
                  this.eof = !0;
                  return;
                }
                const T = this.bufferLength;
                let I, _;
                if ($ === 122) {
                  for (I = this.ensureBuffer(T + 4), _ = 0; _ < 4; ++_)
                    I[T + _] = 0;
                  this.bufferLength += 4;
                } else {
                  const E = this.input;
                  for (E[0] = $, _ = 1; _ < 5; ++_) {
                    for ($ = S.getByte(); (0, b.isWhiteSpace)($); )
                      $ = S.getByte();
                    if (E[_] = $, $ === -1 || $ === 126)
                      break;
                  }
                  if (I = this.ensureBuffer(T + _ - 1), this.bufferLength += _ - 1, _ < 5) {
                    for (; _ < 5; ++_)
                      E[_] = 117;
                    this.eof = !0;
                  }
                  let R = 0;
                  for (_ = 0; _ < 5; ++_)
                    R = R * 85 + (E[_] - 33);
                  for (_ = 3; _ >= 0; --_)
                    I[T + _] = R & 255, R >>= 8;
                }
              }
            }
            A.Ascii85Stream = y;
          },
          /* 18 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.StreamsSequenceStream = A.DecodeStream = void 0;
            var g = x(5), b = x(8);
            const y = new Uint8Array(0);
            class f extends g.BaseStream {
              constructor(w) {
                if (super(), this._rawMinBufferLength = w || 0, this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = y, this.minBufferLength = 512, w)
                  for (; this.minBufferLength < w; )
                    this.minBufferLength *= 2;
              }
              get isEmpty() {
                for (; !this.eof && this.bufferLength === 0; )
                  this.readBlock();
                return this.bufferLength === 0;
              }
              ensureBuffer(w) {
                const S = this.buffer;
                if (w <= S.byteLength)
                  return S;
                let $ = this.minBufferLength;
                for (; $ < w; )
                  $ *= 2;
                const T = new Uint8Array($);
                return T.set(S), this.buffer = T;
              }
              getByte() {
                const w = this.pos;
                for (; this.bufferLength <= w; ) {
                  if (this.eof)
                    return -1;
                  this.readBlock();
                }
                return this.buffer[this.pos++];
              }
              getBytes(w) {
                const S = this.pos;
                let $;
                if (w) {
                  for (this.ensureBuffer(S + w), $ = S + w; !this.eof && this.bufferLength < $; )
                    this.readBlock();
                  const T = this.bufferLength;
                  $ > T && ($ = T);
                } else {
                  for (; !this.eof; )
                    this.readBlock();
                  $ = this.bufferLength;
                }
                return this.pos = $, this.buffer.subarray(S, $);
              }
              reset() {
                this.pos = 0;
              }
              makeSubStream(w, S, $ = null) {
                if (S === void 0)
                  for (; !this.eof; )
                    this.readBlock();
                else {
                  const T = w + S;
                  for (; this.bufferLength <= T && !this.eof; )
                    this.readBlock();
                }
                return new b.Stream(this.buffer, w, S, $);
              }
              getBaseStreams() {
                return this.str ? this.str.getBaseStreams() : null;
              }
            }
            A.DecodeStream = f;
            class m extends f {
              constructor(w, S = null) {
                let $ = 0;
                for (const T of w)
                  $ += T instanceof f ? T._rawMinBufferLength : T.length;
                super($), this.streams = w, this._onError = S;
              }
              readBlock() {
                const w = this.streams;
                if (w.length === 0) {
                  this.eof = !0;
                  return;
                }
                const S = w.shift();
                let $;
                try {
                  $ = S.getBytes();
                } catch (E) {
                  if (this._onError) {
                    this._onError(E, S.dict?.objId);
                    return;
                  }
                  throw E;
                }
                const T = this.bufferLength, I = T + $.length;
                this.ensureBuffer(I).set($, T), this.bufferLength = I;
              }
              getBaseStreams() {
                const w = [];
                for (const S of this.streams) {
                  const $ = S.getBaseStreams();
                  $ && w.push(...$);
                }
                return w.length > 0 ? w : null;
              }
            }
            A.StreamsSequenceStream = m;
          },
          /* 19 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.AsciiHexStream = void 0;
            var g = x(18);
            class b extends g.DecodeStream {
              constructor(f, m) {
                m && (m *= 0.5), super(m), this.str = f, this.dict = f.dict, this.firstDigit = -1;
              }
              readBlock() {
                const m = this.str.getBytes(8e3);
                if (!m.length) {
                  this.eof = !0;
                  return;
                }
                const C = m.length + 1 >> 1, w = this.ensureBuffer(this.bufferLength + C);
                let S = this.bufferLength, $ = this.firstDigit;
                for (const T of m) {
                  let I;
                  if (T >= 48 && T <= 57)
                    I = T & 15;
                  else if (T >= 65 && T <= 70 || T >= 97 && T <= 102)
                    I = (T & 15) + 9;
                  else if (T === 62) {
                    this.eof = !0;
                    break;
                  } else
                    continue;
                  $ < 0 ? $ = I : (w[S++] = $ << 4 | I, $ = -1);
                }
                $ >= 0 && this.eof && (w[S++] = $ << 4, $ = -1), this.firstDigit = $, this.bufferLength = S;
              }
            }
            A.AsciiHexStream = b;
          },
          /* 20 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.CCITTFaxStream = void 0;
            var g = x(21), b = x(18), y = x(4);
            class f extends b.DecodeStream {
              constructor(C, w, S) {
                super(w), this.str = C, this.dict = C.dict, S instanceof y.Dict || (S = y.Dict.empty);
                const $ = {
                  next() {
                    return C.getByte();
                  }
                };
                this.ccittFaxDecoder = new g.CCITTFaxDecoder($, {
                  K: S.get("K"),
                  EndOfLine: S.get("EndOfLine"),
                  EncodedByteAlign: S.get("EncodedByteAlign"),
                  Columns: S.get("Columns"),
                  Rows: S.get("Rows"),
                  EndOfBlock: S.get("EndOfBlock"),
                  BlackIs1: S.get("BlackIs1")
                });
              }
              readBlock() {
                for (; !this.eof; ) {
                  const C = this.ccittFaxDecoder.readNextChar();
                  if (C === -1) {
                    this.eof = !0;
                    return;
                  }
                  this.ensureBuffer(this.bufferLength + 1), this.buffer[this.bufferLength++] = C;
                }
              }
            }
            A.CCITTFaxStream = f;
          },
          /* 21 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.CCITTFaxDecoder = void 0;
            var g = x(2);
            const b = -2, y = -1, f = 0, m = 1, C = 2, w = 3, S = 4, $ = 5, T = 6, I = 7, _ = 8, E = [[-1, -1], [-1, -1], [7, _], [7, I], [6, T], [6, T], [6, $], [6, $], [4, f], [4, f], [4, f], [4, f], [4, f], [4, f], [4, f], [4, f], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, m], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, S], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [3, w], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C], [1, C]], R = [[-1, -1], [12, b], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]], O = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]], L = [[-1, -1], [-1, -1], [12, b], [12, b], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]], B = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]], F = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
            class M {
              constructor(j, G = {}) {
                if (!j || typeof j.next != "function")
                  throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
                this.source = j, this.eof = !1, this.encoding = G.K || 0, this.eoline = G.EndOfLine || !1, this.byteAlign = G.EncodedByteAlign || !1, this.columns = G.Columns || 1728, this.rows = G.Rows || 0, this.eoblock = G.EndOfBlock ?? !0, this.black = G.BlackIs1 || !1, this.codingLine = new Uint32Array(this.columns + 1), this.refLine = new Uint32Array(this.columns + 2), this.codingLine[0] = this.columns, this.codingPos = 0, this.row = 0, this.nextLine2D = this.encoding < 0, this.inputBits = 0, this.inputBuf = 0, this.outputBits = 0, this.rowsDone = !1;
                let U;
                for (; (U = this._lookBits(12)) === 0; )
                  this._eatBits(1);
                U === 1 && this._eatBits(12), this.encoding > 0 && (this.nextLine2D = !this._lookBits(1), this._eatBits(1));
              }
              readNextChar() {
                if (this.eof)
                  return -1;
                const j = this.refLine, G = this.codingLine, U = this.columns;
                let k, N, P, D;
                if (this.outputBits === 0) {
                  if (this.rowsDone && (this.eof = !0), this.eof)
                    return -1;
                  this.err = !1;
                  let V, Z, ne;
                  if (this.nextLine2D) {
                    for (D = 0; G[D] < U; ++D)
                      j[D] = G[D];
                    for (j[D++] = U, j[D] = U, G[0] = 0, this.codingPos = 0, k = 0, N = 0; G[this.codingPos] < U; )
                      switch (V = this._getTwoDimCode(), V) {
                        case f:
                          this._addPixels(j[k + 1], N), j[k + 1] < U && (k += 2);
                          break;
                        case m:
                          if (V = Z = 0, N) {
                            do
                              V += ne = this._getBlackCode();
                            while (ne >= 64);
                            do
                              Z += ne = this._getWhiteCode();
                            while (ne >= 64);
                          } else {
                            do
                              V += ne = this._getWhiteCode();
                            while (ne >= 64);
                            do
                              Z += ne = this._getBlackCode();
                            while (ne >= 64);
                          }
                          for (this._addPixels(G[this.codingPos] + V, N), G[this.codingPos] < U && this._addPixels(G[this.codingPos] + Z, N ^ 1); j[k] <= G[this.codingPos] && j[k] < U; )
                            k += 2;
                          break;
                        case I:
                          if (this._addPixels(j[k] + 3, N), N ^= 1, G[this.codingPos] < U)
                            for (++k; j[k] <= G[this.codingPos] && j[k] < U; )
                              k += 2;
                          break;
                        case $:
                          if (this._addPixels(j[k] + 2, N), N ^= 1, G[this.codingPos] < U)
                            for (++k; j[k] <= G[this.codingPos] && j[k] < U; )
                              k += 2;
                          break;
                        case w:
                          if (this._addPixels(j[k] + 1, N), N ^= 1, G[this.codingPos] < U)
                            for (++k; j[k] <= G[this.codingPos] && j[k] < U; )
                              k += 2;
                          break;
                        case C:
                          if (this._addPixels(j[k], N), N ^= 1, G[this.codingPos] < U)
                            for (++k; j[k] <= G[this.codingPos] && j[k] < U; )
                              k += 2;
                          break;
                        case _:
                          if (this._addPixelsNeg(j[k] - 3, N), N ^= 1, G[this.codingPos] < U)
                            for (k > 0 ? --k : ++k; j[k] <= G[this.codingPos] && j[k] < U; )
                              k += 2;
                          break;
                        case T:
                          if (this._addPixelsNeg(j[k] - 2, N), N ^= 1, G[this.codingPos] < U)
                            for (k > 0 ? --k : ++k; j[k] <= G[this.codingPos] && j[k] < U; )
                              k += 2;
                          break;
                        case S:
                          if (this._addPixelsNeg(j[k] - 1, N), N ^= 1, G[this.codingPos] < U)
                            for (k > 0 ? --k : ++k; j[k] <= G[this.codingPos] && j[k] < U; )
                              k += 2;
                          break;
                        case y:
                          this._addPixels(U, 0), this.eof = !0;
                          break;
                        default:
                          (0, g.info)("bad 2d code"), this._addPixels(U, 0), this.err = !0;
                      }
                  } else
                    for (G[0] = 0, this.codingPos = 0, N = 0; G[this.codingPos] < U; ) {
                      if (V = 0, N)
                        do
                          V += ne = this._getBlackCode();
                        while (ne >= 64);
                      else
                        do
                          V += ne = this._getWhiteCode();
                        while (ne >= 64);
                      this._addPixels(G[this.codingPos] + V, N), N ^= 1;
                    }
                  let K = !1;
                  if (this.byteAlign && (this.inputBits &= -8), !this.eoblock && this.row === this.rows - 1)
                    this.rowsDone = !0;
                  else {
                    if (V = this._lookBits(12), this.eoline)
                      for (; V !== y && V !== 1; )
                        this._eatBits(1), V = this._lookBits(12);
                    else
                      for (; V === 0; )
                        this._eatBits(1), V = this._lookBits(12);
                    V === 1 ? (this._eatBits(12), K = !0) : V === y && (this.eof = !0);
                  }
                  if (!this.eof && this.encoding > 0 && !this.rowsDone && (this.nextLine2D = !this._lookBits(1), this._eatBits(1)), this.eoblock && K && this.byteAlign) {
                    if (V = this._lookBits(12), V === 1) {
                      if (this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1)), this.encoding >= 0)
                        for (D = 0; D < 4; ++D)
                          V = this._lookBits(12), V !== 1 && (0, g.info)("bad rtc code: " + V), this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1));
                      this.eof = !0;
                    }
                  } else if (this.err && this.eoline) {
                    for (; ; ) {
                      if (V = this._lookBits(13), V === y)
                        return this.eof = !0, -1;
                      if (V >> 1 === 1)
                        break;
                      this._eatBits(1);
                    }
                    this._eatBits(12), this.encoding > 0 && (this._eatBits(1), this.nextLine2D = !(V & 1));
                  }
                  this.outputBits = G[0] > 0 ? G[this.codingPos = 0] : G[this.codingPos = 1], this.row++;
                }
                let H;
                if (this.outputBits >= 8)
                  H = this.codingPos & 1 ? 0 : 255, this.outputBits -= 8, this.outputBits === 0 && G[this.codingPos] < U && (this.codingPos++, this.outputBits = G[this.codingPos] - G[this.codingPos - 1]);
                else {
                  P = 8, H = 0;
                  do {
                    if (typeof this.outputBits != "number")
                      throw new g.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
                    this.outputBits > P ? (H <<= P, this.codingPos & 1 || (H |= 255 >> 8 - P), this.outputBits -= P, P = 0) : (H <<= this.outputBits, this.codingPos & 1 || (H |= 255 >> 8 - this.outputBits), P -= this.outputBits, this.outputBits = 0, G[this.codingPos] < U ? (this.codingPos++, this.outputBits = G[this.codingPos] - G[this.codingPos - 1]) : P > 0 && (H <<= P, P = 0));
                  } while (P);
                }
                return this.black && (H ^= 255), H;
              }
              _addPixels(j, G) {
                const U = this.codingLine;
                let k = this.codingPos;
                j > U[k] && (j > this.columns && ((0, g.info)("row is wrong length"), this.err = !0, j = this.columns), k & 1 ^ G && ++k, U[k] = j), this.codingPos = k;
              }
              _addPixelsNeg(j, G) {
                const U = this.codingLine;
                let k = this.codingPos;
                if (j > U[k])
                  j > this.columns && ((0, g.info)("row is wrong length"), this.err = !0, j = this.columns), k & 1 ^ G && ++k, U[k] = j;
                else if (j < U[k]) {
                  for (j < 0 && ((0, g.info)("invalid code"), this.err = !0, j = 0); k > 0 && j < U[k - 1]; )
                    --k;
                  U[k] = j;
                }
                this.codingPos = k;
              }
              _findTableCode(j, G, U, k) {
                const N = k || 0;
                for (let P = j; P <= G; ++P) {
                  let D = this._lookBits(P);
                  if (D === y)
                    return [!0, 1, !1];
                  if (P < G && (D <<= G - P), !N || D >= N) {
                    const H = U[D - N];
                    if (H[0] === P)
                      return this._eatBits(P), [!0, H[1], !0];
                  }
                }
                return [!1, 0, !1];
              }
              _getTwoDimCode() {
                let j = 0, G;
                if (this.eoblock) {
                  if (j = this._lookBits(7), G = E[j], G?.[0] > 0)
                    return this._eatBits(G[0]), G[1];
                } else {
                  const U = this._findTableCode(1, 7, E);
                  if (U[0] && U[2])
                    return U[1];
                }
                return (0, g.info)("Bad two dim code"), y;
              }
              _getWhiteCode() {
                let j = 0, G;
                if (this.eoblock) {
                  if (j = this._lookBits(12), j === y)
                    return 1;
                  if (G = j >> 5 === 0 ? R[j] : O[j >> 3], G[0] > 0)
                    return this._eatBits(G[0]), G[1];
                } else {
                  let U = this._findTableCode(1, 9, O);
                  if (U[0] || (U = this._findTableCode(11, 12, R), U[0]))
                    return U[1];
                }
                return (0, g.info)("bad white code"), this._eatBits(1), 1;
              }
              _getBlackCode() {
                let j, G;
                if (this.eoblock) {
                  if (j = this._lookBits(13), j === y)
                    return 1;
                  if (j >> 7 === 0 ? G = L[j] : j >> 9 === 0 && j >> 7 !== 0 ? G = B[(j >> 1) - 64] : G = F[j >> 7], G[0] > 0)
                    return this._eatBits(G[0]), G[1];
                } else {
                  let U = this._findTableCode(2, 6, F);
                  if (U[0] || (U = this._findTableCode(7, 12, B, 64), U[0]) || (U = this._findTableCode(10, 13, L), U[0]))
                    return U[1];
                }
                return (0, g.info)("bad black code"), this._eatBits(1), 1;
              }
              _lookBits(j) {
                let G;
                for (; this.inputBits < j; ) {
                  if ((G = this.source.next()) === -1)
                    return this.inputBits === 0 ? y : this.inputBuf << j - this.inputBits & 65535 >> 16 - j;
                  this.inputBuf = this.inputBuf << 8 | G, this.inputBits += 8;
                }
                return this.inputBuf >> this.inputBits - j & 65535 >> 16 - j;
              }
              _eatBits(j) {
                (this.inputBits -= j) < 0 && (this.inputBits = 0);
              }
            }
            A.CCITTFaxDecoder = M;
          },
          /* 22 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.FlateStream = void 0;
            var g = x(18), b = x(2);
            const y = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), f = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]), m = new Int32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]), C = [new Int32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9], w = [new Int32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
            class S extends g.DecodeStream {
              constructor(T, I) {
                super(I), this.str = T, this.dict = T.dict;
                const _ = T.getByte(), E = T.getByte();
                if (_ === -1 || E === -1)
                  throw new b.FormatError(`Invalid header in flate stream: ${_}, ${E}`);
                if ((_ & 15) !== 8)
                  throw new b.FormatError(`Unknown compression method in flate stream: ${_}, ${E}`);
                if (((_ << 8) + E) % 31 !== 0)
                  throw new b.FormatError(`Bad FCHECK in flate stream: ${_}, ${E}`);
                if (E & 32)
                  throw new b.FormatError(`FDICT bit set in flate stream: ${_}, ${E}`);
                this.codeSize = 0, this.codeBuf = 0;
              }
              getBits(T) {
                const I = this.str;
                let _ = this.codeSize, E = this.codeBuf, R;
                for (; _ < T; ) {
                  if ((R = I.getByte()) === -1)
                    throw new b.FormatError("Bad encoding in flate stream");
                  E |= R << _, _ += 8;
                }
                return R = E & (1 << T) - 1, this.codeBuf = E >> T, this.codeSize = _ -= T, R;
              }
              getCode(T) {
                const I = this.str, _ = T[0], E = T[1];
                let R = this.codeSize, O = this.codeBuf, L;
                for (; R < E && (L = I.getByte()) !== -1; )
                  O |= L << R, R += 8;
                const B = _[O & (1 << E) - 1], F = B >> 16, M = B & 65535;
                if (F < 1 || R < F)
                  throw new b.FormatError("Bad encoding in flate stream");
                return this.codeBuf = O >> F, this.codeSize = R - F, M;
              }
              generateHuffmanTable(T) {
                const I = T.length;
                let _ = 0, E;
                for (E = 0; E < I; ++E)
                  T[E] > _ && (_ = T[E]);
                const R = 1 << _, O = new Int32Array(R);
                for (let L = 1, B = 0, F = 2; L <= _; ++L, B <<= 1, F <<= 1)
                  for (let M = 0; M < I; ++M)
                    if (T[M] === L) {
                      let W = 0, j = B;
                      for (E = 0; E < L; ++E)
                        W = W << 1 | j & 1, j >>= 1;
                      for (E = W; E < R; E += F)
                        O[E] = L << 16 | M;
                      ++B;
                    }
                return [O, _];
              }
              readBlock() {
                let T, I;
                const _ = this.str;
                let E = this.getBits(3);
                if (E & 1 && (this.eof = !0), E >>= 1, E === 0) {
                  let F;
                  if ((F = _.getByte()) === -1)
                    throw new b.FormatError("Bad block header in flate stream");
                  let M = F;
                  if ((F = _.getByte()) === -1)
                    throw new b.FormatError("Bad block header in flate stream");
                  if (M |= F << 8, (F = _.getByte()) === -1)
                    throw new b.FormatError("Bad block header in flate stream");
                  let W = F;
                  if ((F = _.getByte()) === -1)
                    throw new b.FormatError("Bad block header in flate stream");
                  if (W |= F << 8, W !== (~M & 65535) && (M !== 0 || W !== 0))
                    throw new b.FormatError("Bad uncompressed block length in flate stream");
                  this.codeBuf = 0, this.codeSize = 0;
                  const j = this.bufferLength, G = j + M;
                  if (T = this.ensureBuffer(G), this.bufferLength = G, M === 0)
                    _.peekByte() === -1 && (this.eof = !0);
                  else {
                    const U = _.getBytes(M);
                    T.set(U, j), U.length < M && (this.eof = !0);
                  }
                  return;
                }
                let R, O;
                if (E === 1)
                  R = C, O = w;
                else if (E === 2) {
                  const F = this.getBits(5) + 257, M = this.getBits(5) + 1, W = this.getBits(4) + 4, j = new Uint8Array(y.length);
                  let G;
                  for (G = 0; G < W; ++G)
                    j[y[G]] = this.getBits(3);
                  const U = this.generateHuffmanTable(j);
                  I = 0, G = 0;
                  const k = F + M, N = new Uint8Array(k);
                  let P, D, H;
                  for (; G < k; ) {
                    const V = this.getCode(U);
                    if (V === 16)
                      P = 2, D = 3, H = I;
                    else if (V === 17)
                      P = 3, D = 3, H = I = 0;
                    else if (V === 18)
                      P = 7, D = 11, H = I = 0;
                    else {
                      N[G++] = I = V;
                      continue;
                    }
                    let Z = this.getBits(P) + D;
                    for (; Z-- > 0; )
                      N[G++] = H;
                  }
                  R = this.generateHuffmanTable(N.subarray(0, F)), O = this.generateHuffmanTable(N.subarray(F, k));
                } else
                  throw new b.FormatError("Unknown block type in flate stream");
                T = this.buffer;
                let L = T ? T.length : 0, B = this.bufferLength;
                for (; ; ) {
                  let F = this.getCode(R);
                  if (F < 256) {
                    B + 1 >= L && (T = this.ensureBuffer(B + 1), L = T.length), T[B++] = F;
                    continue;
                  }
                  if (F === 256) {
                    this.bufferLength = B;
                    return;
                  }
                  F -= 257, F = f[F];
                  let M = F >> 16;
                  M > 0 && (M = this.getBits(M)), I = (F & 65535) + M, F = this.getCode(O), F = m[F], M = F >> 16, M > 0 && (M = this.getBits(M));
                  const W = (F & 65535) + M;
                  B + I >= L && (T = this.ensureBuffer(B + I), L = T.length);
                  for (let j = 0; j < I; ++j, ++B)
                    T[B] = T[B - W];
                }
              }
            }
            A.FlateStream = S;
          },
          /* 23 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Jbig2Stream = void 0;
            var g = x(5), b = x(18), y = x(4), f = x(24), m = x(2);
            class C extends b.DecodeStream {
              constructor(S, $, T) {
                super($), this.stream = S, this.dict = S.dict, this.maybeLength = $, this.params = T;
              }
              get bytes() {
                return (0, m.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
              }
              ensureBuffer(S) {
              }
              readBlock() {
                if (this.eof)
                  return;
                const S = new f.Jbig2Image(), $ = [];
                if (this.params instanceof y.Dict) {
                  const _ = this.params.get("JBIG2Globals");
                  if (_ instanceof g.BaseStream) {
                    const E = _.getBytes();
                    $.push({
                      data: E,
                      start: 0,
                      end: E.length
                    });
                  }
                }
                $.push({
                  data: this.bytes,
                  start: 0,
                  end: this.bytes.length
                });
                const T = S.parseChunks($), I = T.length;
                for (let _ = 0; _ < I; _++)
                  T[_] ^= 255;
                this.buffer = T, this.bufferLength = I, this.eof = !0;
              }
            }
            A.Jbig2Stream = C;
          },
          /* 24 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Jbig2Image = void 0;
            var g = x(2), b = x(3), y = x(25), f = x(21);
            class m extends g.BaseException {
              constructor(pe) {
                super(`JBIG2 error: ${pe}`, "Jbig2Error");
              }
            }
            class C {
              getContexts(pe) {
                return pe in this ? this[pe] : this[pe] = new Int8Array(65536);
              }
            }
            class w {
              constructor(pe, be, le) {
                this.data = pe, this.start = be, this.end = le;
              }
              get decoder() {
                const pe = new y.ArithmeticDecoder(this.data, this.start, this.end);
                return (0, g.shadow)(this, "decoder", pe);
              }
              get contextCache() {
                const pe = new C();
                return (0, g.shadow)(this, "contextCache", pe);
              }
            }
            const S = 2 ** 31 - 1, $ = -2147483648;
            function T(me, pe, be) {
              const le = me.getContexts(pe);
              let ve = 1;
              function he(we) {
                let $e = 0;
                for (let Ae = 0; Ae < we; Ae++) {
                  const ue = be.readBit(le, ve);
                  ve = ve < 256 ? ve << 1 | ue : (ve << 1 | ue) & 511 | 256, $e = $e << 1 | ue;
                }
                return $e >>> 0;
              }
              const ye = he(1), Ce = he(1) ? he(1) ? he(1) ? he(1) ? he(1) ? he(32) + 4436 : he(12) + 340 : he(8) + 84 : he(6) + 20 : he(4) + 4 : he(2);
              let xe;
              return ye === 0 ? xe = Ce : Ce > 0 && (xe = -Ce), xe >= $ && xe <= S ? xe : null;
            }
            function I(me, pe, be) {
              const le = me.getContexts("IAID");
              let ve = 1;
              for (let he = 0; he < be; he++) {
                const ye = pe.readBit(le, ve);
                ve = ve << 1 | ye;
              }
              return be < 31 ? ve & (1 << be) - 1 : ve & 2147483647;
            }
            const _ = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "PatternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"], E = [[{
              x: -1,
              y: -2
            }, {
              x: 0,
              y: -2
            }, {
              x: 1,
              y: -2
            }, {
              x: -2,
              y: -1
            }, {
              x: -1,
              y: -1
            }, {
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: 2,
              y: -1
            }, {
              x: -4,
              y: 0
            }, {
              x: -3,
              y: 0
            }, {
              x: -2,
              y: 0
            }, {
              x: -1,
              y: 0
            }], [{
              x: -1,
              y: -2
            }, {
              x: 0,
              y: -2
            }, {
              x: 1,
              y: -2
            }, {
              x: 2,
              y: -2
            }, {
              x: -2,
              y: -1
            }, {
              x: -1,
              y: -1
            }, {
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: 2,
              y: -1
            }, {
              x: -3,
              y: 0
            }, {
              x: -2,
              y: 0
            }, {
              x: -1,
              y: 0
            }], [{
              x: -1,
              y: -2
            }, {
              x: 0,
              y: -2
            }, {
              x: 1,
              y: -2
            }, {
              x: -2,
              y: -1
            }, {
              x: -1,
              y: -1
            }, {
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -2,
              y: 0
            }, {
              x: -1,
              y: 0
            }], [{
              x: -3,
              y: -1
            }, {
              x: -2,
              y: -1
            }, {
              x: -1,
              y: -1
            }, {
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -4,
              y: 0
            }, {
              x: -3,
              y: 0
            }, {
              x: -2,
              y: 0
            }, {
              x: -1,
              y: 0
            }]], R = [{
              coding: [{
                x: 0,
                y: -1
              }, {
                x: 1,
                y: -1
              }, {
                x: -1,
                y: 0
              }],
              reference: [{
                x: 0,
                y: -1
              }, {
                x: 1,
                y: -1
              }, {
                x: -1,
                y: 0
              }, {
                x: 0,
                y: 0
              }, {
                x: 1,
                y: 0
              }, {
                x: -1,
                y: 1
              }, {
                x: 0,
                y: 1
              }, {
                x: 1,
                y: 1
              }]
            }, {
              coding: [{
                x: -1,
                y: -1
              }, {
                x: 0,
                y: -1
              }, {
                x: 1,
                y: -1
              }, {
                x: -1,
                y: 0
              }],
              reference: [{
                x: 0,
                y: -1
              }, {
                x: -1,
                y: 0
              }, {
                x: 0,
                y: 0
              }, {
                x: 1,
                y: 0
              }, {
                x: 0,
                y: 1
              }, {
                x: 1,
                y: 1
              }]
            }], O = [39717, 1941, 229, 405];
            function L(me, pe, be) {
              const le = be.decoder, ve = be.contextCache.getContexts("GB"), he = [];
              let ye, Ce, xe, we, $e, Ae, ue;
              const ce = 31735;
              for (Ce = 0; Ce < pe; Ce++)
                for ($e = he[Ce] = new Uint8Array(me), Ae = Ce < 1 ? $e : he[Ce - 1], ue = Ce < 2 ? $e : he[Ce - 2], ye = ue[0] << 13 | ue[1] << 12 | ue[2] << 11 | Ae[0] << 7 | Ae[1] << 6 | Ae[2] << 5 | Ae[3] << 4, xe = 0; xe < me; xe++)
                  $e[xe] = we = le.readBit(ve, ye), ye = (ye & ce) << 1 | (xe + 3 < me ? ue[xe + 3] << 11 : 0) | (xe + 4 < me ? Ae[xe + 4] << 4 : 0) | we;
              return he;
            }
            function B(me, pe, be, le, ve, he, ye, Ce) {
              if (me) {
                const st = new J(Ce.data, Ce.start, Ce.end);
                return fe(st, pe, be, !1);
              }
              if (le === 0 && !ve && ye.length === 4 && ye[0].x === 3 && ye[0].y === -1 && ye[1].x === -3 && ye[1].y === -1 && ye[2].x === 2 && ye[2].y === -2 && ye[3].x === -2 && ye[3].y === -2)
                return L(pe, be, Ce);
              const xe = E[le].concat(ye);
              xe.sort(function(st, ft) {
                return st.y - ft.y || st.x - ft.x;
              });
              const we = xe.length, $e = new Int8Array(we), Ae = new Int8Array(we), ue = [];
              let ce = 0, Ee = 0, _e = 0, Te = 0, ke, Re;
              for (Re = 0; Re < we; Re++)
                $e[Re] = xe[Re].x, Ae[Re] = xe[Re].y, Ee = Math.min(Ee, xe[Re].x), _e = Math.max(_e, xe[Re].x), Te = Math.min(Te, xe[Re].y), Re < we - 1 && xe[Re].y === xe[Re + 1].y && xe[Re].x === xe[Re + 1].x - 1 ? ce |= 1 << we - 1 - Re : ue.push(Re);
              const Be = ue.length, Oe = new Int8Array(Be), Me = new Int8Array(Be), Fe = new Uint16Array(Be);
              for (ke = 0; ke < Be; ke++)
                Re = ue[ke], Oe[ke] = xe[Re].x, Me[ke] = xe[Re].y, Fe[ke] = 1 << we - 1 - Re;
              const Ue = -Ee, je = -Te, Le = pe - _e, De = O[le];
              let Ne = new Uint8Array(pe);
              const Ge = [], Xe = Ce.decoder, nt = Ce.contextCache.getContexts("GB");
              let ct = 0, it, We, Ve, ut = 0, at, Qe;
              for (let st = 0; st < be; st++) {
                if (ve) {
                  const ft = Xe.readBit(nt, De);
                  if (ct ^= ft, ct) {
                    Ge.push(Ne);
                    continue;
                  }
                }
                for (Ne = new Uint8Array(Ne), Ge.push(Ne), it = 0; it < pe; it++) {
                  if (it >= Ue && it < Le && st >= je)
                    for (ut = ut << 1 & ce, Re = 0; Re < Be; Re++)
                      We = st + Me[Re], Ve = it + Oe[Re], at = Ge[We][Ve], at && (at = Fe[Re], ut |= at);
                  else
                    for (ut = 0, Qe = we - 1, Re = 0; Re < we; Re++, Qe--)
                      Ve = it + $e[Re], Ve >= 0 && Ve < pe && (We = st + Ae[Re], We >= 0 && (at = Ge[We][Ve], at && (ut |= at << Qe)));
                  const ft = Xe.readBit(nt, ut);
                  Ne[it] = ft;
                }
              }
              return Ge;
            }
            function F(me, pe, be, le, ve, he, ye, Ce, xe) {
              let we = R[be].coding;
              be === 0 && (we = we.concat([Ce[0]]));
              const $e = we.length, Ae = new Int32Array($e), ue = new Int32Array($e);
              let ce;
              for (ce = 0; ce < $e; ce++)
                Ae[ce] = we[ce].x, ue[ce] = we[ce].y;
              let Ee = R[be].reference;
              be === 0 && (Ee = Ee.concat([Ce[1]]));
              const _e = Ee.length, Te = new Int32Array(_e), ke = new Int32Array(_e);
              for (ce = 0; ce < _e; ce++)
                Te[ce] = Ee[ce].x, ke[ce] = Ee[ce].y;
              const Re = le[0].length, Be = le.length, Oe = [], Me = xe.decoder, Fe = xe.contextCache.getContexts("GR");
              for (let Ue = 0; Ue < pe; Ue++) {
                const je = new Uint8Array(me);
                Oe.push(je);
                for (let Le = 0; Le < me; Le++) {
                  let De, Ne, Ge = 0;
                  for (ce = 0; ce < $e; ce++)
                    De = Ue + ue[ce], Ne = Le + Ae[ce], De < 0 || Ne < 0 || Ne >= me ? Ge <<= 1 : Ge = Ge << 1 | Oe[De][Ne];
                  for (ce = 0; ce < _e; ce++)
                    De = Ue + ke[ce] - he, Ne = Le + Te[ce] - ve, De < 0 || De >= Be || Ne < 0 || Ne >= Re ? Ge <<= 1 : Ge = Ge << 1 | le[De][Ne];
                  const Xe = Me.readBit(Fe, Ge);
                  je[Le] = Xe;
                }
              }
              return Oe;
            }
            function M(me, pe, be, le, ve, he, ye, Ce, xe, we, $e, Ae) {
              if (me && pe)
                throw new m("symbol refinement with Huffman is not supported");
              const ue = [];
              let ce = 0, Ee = (0, b.log2)(be.length + le);
              const _e = $e.decoder, Te = $e.contextCache;
              let ke, Re;
              for (me && (ke = Q(1), Re = [], Ee = Math.max(Ee, 1)); ue.length < le; ) {
                const Le = me ? he.tableDeltaHeight.decode(Ae) : T(Te, "IADH", _e);
                ce += Le;
                let De = 0, Ne = 0;
                const Ge = me ? Re.length : 0;
                for (; ; ) {
                  const Xe = me ? he.tableDeltaWidth.decode(Ae) : T(Te, "IADW", _e);
                  if (Xe === null)
                    break;
                  De += Xe, Ne += De;
                  let nt;
                  if (pe) {
                    const ct = T(Te, "IAAI", _e);
                    if (ct > 1)
                      nt = W(me, pe, De, ce, 0, ct, 1, be.concat(ue), Ee, 0, 0, 1, 0, he, xe, we, $e, 0, Ae);
                    else {
                      const it = I(Te, _e, Ee), We = T(Te, "IARDX", _e), Ve = T(Te, "IARDY", _e), ut = it < be.length ? be[it] : ue[it - be.length];
                      nt = F(De, ce, xe, ut, We, Ve, !1, we, $e);
                    }
                    ue.push(nt);
                  } else me ? Re.push(De) : (nt = B(!1, De, ce, ye, !1, null, Ce, $e), ue.push(nt));
                }
                if (me && !pe) {
                  const Xe = he.tableBitmapSize.decode(Ae);
                  Ae.byteAlign();
                  let nt;
                  if (Xe === 0)
                    nt = ie(Ae, Ne, ce);
                  else {
                    const it = Ae.end, We = Ae.position + Xe;
                    Ae.end = We, nt = fe(Ae, Ne, ce, !1), Ae.end = it, Ae.position = We;
                  }
                  const ct = Re.length;
                  if (Ge === ct - 1)
                    ue.push(nt);
                  else {
                    let it, We, Ve = 0, ut, at, Qe;
                    for (it = Ge; it < ct; it++) {
                      for (at = Re[it], ut = Ve + at, Qe = [], We = 0; We < ce; We++)
                        Qe.push(nt[We].subarray(Ve, ut));
                      ue.push(Qe), Ve = ut;
                    }
                  }
                }
              }
              const Be = [], Oe = [];
              let Me = !1, Fe, Ue;
              const je = be.length + le;
              for (; Oe.length < je; ) {
                let Le = me ? ke.decode(Ae) : T(Te, "IAEX", _e);
                for (; Le--; )
                  Oe.push(Me);
                Me = !Me;
              }
              for (Fe = 0, Ue = be.length; Fe < Ue; Fe++)
                Oe[Fe] && Be.push(be[Fe]);
              for (let Le = 0; Le < le; Fe++, Le++)
                Oe[Fe] && Be.push(ue[Le]);
              return Be;
            }
            function W(me, pe, be, le, ve, he, ye, Ce, xe, we, $e, Ae, ue, ce, Ee, _e, Te, ke, Re) {
              if (me && pe)
                throw new m("refinement with Huffman is not supported");
              const Be = [];
              let Oe, Me;
              for (Oe = 0; Oe < le; Oe++) {
                if (Me = new Uint8Array(be), ve)
                  for (let De = 0; De < be; De++)
                    Me[De] = ve;
                Be.push(Me);
              }
              const Fe = Te.decoder, Ue = Te.contextCache;
              let je = me ? -ce.tableDeltaT.decode(Re) : -T(Ue, "IADT", Fe), Le = 0;
              for (Oe = 0; Oe < he; ) {
                const De = me ? ce.tableDeltaT.decode(Re) : T(Ue, "IADT", Fe);
                je += De;
                const Ne = me ? ce.tableFirstS.decode(Re) : T(Ue, "IAFS", Fe);
                Le += Ne;
                let Ge = Le;
                do {
                  let Xe = 0;
                  ye > 1 && (Xe = me ? Re.readBits(ke) : T(Ue, "IAIT", Fe));
                  const nt = ye * je + Xe, ct = me ? ce.symbolIDTable.decode(Re) : I(Ue, Fe, xe), it = pe && (me ? Re.readBit() : T(Ue, "IARI", Fe));
                  let We = Ce[ct], Ve = We[0].length, ut = We.length;
                  if (it) {
                    const dt = T(Ue, "IARDW", Fe), mt = T(Ue, "IARDH", Fe), pt = T(Ue, "IARDX", Fe), Et = T(Ue, "IARDY", Fe);
                    Ve += dt, ut += mt, We = F(Ve, ut, Ee, We, (dt >> 1) + pt, (mt >> 1) + Et, !1, _e, Te);
                  }
                  const at = nt - (Ae & 1 ? 0 : ut - 1), Qe = Ge - (Ae & 2 ? Ve - 1 : 0);
                  let st, ft, vt;
                  if (we) {
                    for (st = 0; st < ut; st++) {
                      if (Me = Be[Qe + st], !Me)
                        continue;
                      vt = We[st];
                      const dt = Math.min(be - at, Ve);
                      switch (ue) {
                        case 0:
                          for (ft = 0; ft < dt; ft++)
                            Me[at + ft] |= vt[ft];
                          break;
                        case 2:
                          for (ft = 0; ft < dt; ft++)
                            Me[at + ft] ^= vt[ft];
                          break;
                        default:
                          throw new m(`operator ${ue} is not supported`);
                      }
                    }
                    Ge += ut - 1;
                  } else {
                    for (ft = 0; ft < ut; ft++)
                      if (Me = Be[at + ft], !!Me)
                        switch (vt = We[ft], ue) {
                          case 0:
                            for (st = 0; st < Ve; st++)
                              Me[Qe + st] |= vt[st];
                            break;
                          case 2:
                            for (st = 0; st < Ve; st++)
                              Me[Qe + st] ^= vt[st];
                            break;
                          default:
                            throw new m(`operator ${ue} is not supported`);
                        }
                    Ge += Ve - 1;
                  }
                  Oe++;
                  const Pt = me ? ce.tableDeltaS.decode(Re) : T(Ue, "IADS", Fe);
                  if (Pt === null)
                    break;
                  Ge += Pt + $e;
                } while (!0);
              }
              return Be;
            }
            function j(me, pe, be, le, ve, he) {
              const ye = [];
              me || (ye.push({
                x: -pe,
                y: 0
              }), ve === 0 && ye.push({
                x: -3,
                y: -1
              }, {
                x: 2,
                y: -2
              }, {
                x: -2,
                y: -2
              }));
              const Ce = (le + 1) * pe, xe = B(me, Ce, be, ve, !1, null, ye, he), we = [];
              for (let $e = 0; $e <= le; $e++) {
                const Ae = [], ue = pe * $e, ce = ue + pe;
                for (let Ee = 0; Ee < be; Ee++)
                  Ae.push(xe[Ee].subarray(ue, ce));
                we.push(Ae);
              }
              return we;
            }
            function G(me, pe, be, le, ve, he, ye, Ce, xe, we, $e, Ae, ue, ce, Ee) {
              if (ye)
                throw new m("skip is not supported");
              if (Ce !== 0)
                throw new m(`operator "${Ce}" is not supported in halftone region`);
              const Te = [];
              let ke, Re, Be;
              for (ke = 0; ke < ve; ke++) {
                if (Be = new Uint8Array(le), he)
                  for (Re = 0; Re < le; Re++)
                    Be[Re] = he;
                Te.push(Be);
              }
              const Oe = pe.length, Me = pe[0], Fe = Me[0].length, Ue = Me.length, je = (0, b.log2)(Oe), Le = [];
              me || (Le.push({
                x: be <= 1 ? 3 : 2,
                y: -1
              }), be === 0 && Le.push({
                x: -3,
                y: -1
              }, {
                x: 2,
                y: -2
              }, {
                x: -2,
                y: -2
              }));
              const De = [];
              let Ne, Ge;
              for (me && (Ne = new J(Ee.data, Ee.start, Ee.end)), ke = je - 1; ke >= 0; ke--)
                me ? Ge = fe(Ne, xe, we, !0) : Ge = B(!1, xe, we, be, !1, null, Le, Ee), De[ke] = Ge;
              let Xe, nt, ct, it, We, Ve, ut, at, Qe;
              for (Xe = 0; Xe < we; Xe++)
                for (nt = 0; nt < xe; nt++) {
                  for (ct = 0, it = 0, Re = je - 1; Re >= 0; Re--)
                    ct ^= De[Re][Xe][nt], it |= ct << Re;
                  if (We = pe[it], Ve = $e + Xe * ce + nt * ue >> 8, ut = Ae + Xe * ue - nt * ce >> 8, Ve >= 0 && Ve + Fe <= le && ut >= 0 && ut + Ue <= ve)
                    for (ke = 0; ke < Ue; ke++)
                      for (Qe = Te[ut + ke], at = We[ke], Re = 0; Re < Fe; Re++)
                        Qe[Ve + Re] |= at[Re];
                  else {
                    let st, ft;
                    for (ke = 0; ke < Ue; ke++)
                      if (ft = ut + ke, !(ft < 0 || ft >= ve))
                        for (Qe = Te[ft], at = We[ke], Re = 0; Re < Fe; Re++)
                          st = Ve + Re, st >= 0 && st < le && (Qe[st] |= at[Re]);
                  }
                }
              return Te;
            }
            function U(me, pe) {
              const be = {};
              be.number = (0, b.readUint32)(me, pe);
              const le = me[pe + 4], ve = le & 63;
              if (!_[ve])
                throw new m("invalid segment type: " + ve);
              be.type = ve, be.typeName = _[ve], be.deferredNonRetain = !!(le & 128);
              const he = !!(le & 64), ye = me[pe + 5];
              let Ce = ye >> 5 & 7;
              const xe = [ye & 31];
              let we = pe + 6;
              if (ye === 7) {
                Ce = (0, b.readUint32)(me, we - 1) & 536870911, we += 3;
                let Ee = Ce + 7 >> 3;
                for (xe[0] = me[we++]; --Ee > 0; )
                  xe.push(me[we++]);
              } else if (ye === 5 || ye === 6)
                throw new m("invalid referred-to flags");
              be.retainBits = xe;
              let $e = 4;
              be.number <= 256 ? $e = 1 : be.number <= 65536 && ($e = 2);
              const Ae = [];
              let ue, ce;
              for (ue = 0; ue < Ce; ue++) {
                let Ee;
                $e === 1 ? Ee = me[we] : $e === 2 ? Ee = (0, b.readUint16)(me, we) : Ee = (0, b.readUint32)(me, we), Ae.push(Ee), we += $e;
              }
              if (be.referredTo = Ae, he ? (be.pageAssociation = (0, b.readUint32)(me, we), we += 4) : be.pageAssociation = me[we++], be.length = (0, b.readUint32)(me, we), we += 4, be.length === 4294967295)
                if (ve === 38) {
                  const Ee = N(me, we), Te = !!(me[we + P] & 1), ke = 6, Re = new Uint8Array(ke);
                  for (Te || (Re[0] = 255, Re[1] = 172), Re[2] = Ee.height >>> 24 & 255, Re[3] = Ee.height >> 16 & 255, Re[4] = Ee.height >> 8 & 255, Re[5] = Ee.height & 255, ue = we, ce = me.length; ue < ce; ue++) {
                    let Be = 0;
                    for (; Be < ke && Re[Be] === me[ue + Be]; )
                      Be++;
                    if (Be === ke) {
                      be.length = ue + ke;
                      break;
                    }
                  }
                  if (be.length === 4294967295)
                    throw new m("segment end was not found");
                } else
                  throw new m("invalid unknown segment length");
              return be.headerEnd = we, be;
            }
            function k(me, pe, be, le) {
              const ve = [];
              let he = be;
              for (; he < le; ) {
                const ye = U(pe, he);
                he = ye.headerEnd;
                const Ce = {
                  header: ye,
                  data: pe
                };
                if (me.randomAccess || (Ce.start = he, he += ye.length, Ce.end = he), ve.push(Ce), ye.type === 51)
                  break;
              }
              if (me.randomAccess)
                for (let ye = 0, Ce = ve.length; ye < Ce; ye++)
                  ve[ye].start = he, he += ve[ye].header.length, ve[ye].end = he;
              return ve;
            }
            function N(me, pe) {
              return {
                width: (0, b.readUint32)(me, pe),
                height: (0, b.readUint32)(me, pe + 4),
                x: (0, b.readUint32)(me, pe + 8),
                y: (0, b.readUint32)(me, pe + 12),
                combinationOperator: me[pe + 16] & 7
              };
            }
            const P = 17;
            function D(me, pe) {
              const be = me.header, le = me.data, ve = me.end;
              let he = me.start, ye, Ce, xe, we;
              switch (be.type) {
                case 0:
                  const Ae = {}, ue = (0, b.readUint16)(le, he);
                  if (Ae.huffman = !!(ue & 1), Ae.refinement = !!(ue & 2), Ae.huffmanDHSelector = ue >> 2 & 3, Ae.huffmanDWSelector = ue >> 4 & 3, Ae.bitmapSizeSelector = ue >> 6 & 1, Ae.aggregationInstancesSelector = ue >> 7 & 1, Ae.bitmapCodingContextUsed = !!(ue & 256), Ae.bitmapCodingContextRetained = !!(ue & 512), Ae.template = ue >> 10 & 3, Ae.refinementTemplate = ue >> 12 & 1, he += 2, !Ae.huffman) {
                    for (we = Ae.template === 0 ? 4 : 1, Ce = [], xe = 0; xe < we; xe++)
                      Ce.push({
                        x: (0, b.readInt8)(le, he),
                        y: (0, b.readInt8)(le, he + 1)
                      }), he += 2;
                    Ae.at = Ce;
                  }
                  if (Ae.refinement && !Ae.refinementTemplate) {
                    for (Ce = [], xe = 0; xe < 2; xe++)
                      Ce.push({
                        x: (0, b.readInt8)(le, he),
                        y: (0, b.readInt8)(le, he + 1)
                      }), he += 2;
                    Ae.refinementAt = Ce;
                  }
                  Ae.numberOfExportedSymbols = (0, b.readUint32)(le, he), he += 4, Ae.numberOfNewSymbols = (0, b.readUint32)(le, he), he += 4, ye = [Ae, be.number, be.referredTo, le, he, ve];
                  break;
                case 6:
                case 7:
                  const ce = {};
                  ce.info = N(le, he), he += P;
                  const Ee = (0, b.readUint16)(le, he);
                  if (he += 2, ce.huffman = !!(Ee & 1), ce.refinement = !!(Ee & 2), ce.logStripSize = Ee >> 2 & 3, ce.stripSize = 1 << ce.logStripSize, ce.referenceCorner = Ee >> 4 & 3, ce.transposed = !!(Ee & 64), ce.combinationOperator = Ee >> 7 & 3, ce.defaultPixelValue = Ee >> 9 & 1, ce.dsOffset = Ee << 17 >> 27, ce.refinementTemplate = Ee >> 15 & 1, ce.huffman) {
                    const Ue = (0, b.readUint16)(le, he);
                    he += 2, ce.huffmanFS = Ue & 3, ce.huffmanDS = Ue >> 2 & 3, ce.huffmanDT = Ue >> 4 & 3, ce.huffmanRefinementDW = Ue >> 6 & 3, ce.huffmanRefinementDH = Ue >> 8 & 3, ce.huffmanRefinementDX = Ue >> 10 & 3, ce.huffmanRefinementDY = Ue >> 12 & 3, ce.huffmanRefinementSizeSelector = !!(Ue & 16384);
                  }
                  if (ce.refinement && !ce.refinementTemplate) {
                    for (Ce = [], xe = 0; xe < 2; xe++)
                      Ce.push({
                        x: (0, b.readInt8)(le, he),
                        y: (0, b.readInt8)(le, he + 1)
                      }), he += 2;
                    ce.refinementAt = Ce;
                  }
                  ce.numberOfSymbolInstances = (0, b.readUint32)(le, he), he += 4, ye = [ce, be.referredTo, le, he, ve];
                  break;
                case 16:
                  const _e = {}, Te = le[he++];
                  _e.mmr = !!(Te & 1), _e.template = Te >> 1 & 3, _e.patternWidth = le[he++], _e.patternHeight = le[he++], _e.maxPatternIndex = (0, b.readUint32)(le, he), he += 4, ye = [_e, be.number, le, he, ve];
                  break;
                case 22:
                case 23:
                  const ke = {};
                  ke.info = N(le, he), he += P;
                  const Re = le[he++];
                  ke.mmr = !!(Re & 1), ke.template = Re >> 1 & 3, ke.enableSkip = !!(Re & 8), ke.combinationOperator = Re >> 4 & 7, ke.defaultPixelValue = Re >> 7 & 1, ke.gridWidth = (0, b.readUint32)(le, he), he += 4, ke.gridHeight = (0, b.readUint32)(le, he), he += 4, ke.gridOffsetX = (0, b.readUint32)(le, he) & 4294967295, he += 4, ke.gridOffsetY = (0, b.readUint32)(le, he) & 4294967295, he += 4, ke.gridVectorX = (0, b.readUint16)(le, he), he += 2, ke.gridVectorY = (0, b.readUint16)(le, he), he += 2, ye = [ke, be.referredTo, le, he, ve];
                  break;
                case 38:
                case 39:
                  const Be = {};
                  Be.info = N(le, he), he += P;
                  const Oe = le[he++];
                  if (Be.mmr = !!(Oe & 1), Be.template = Oe >> 1 & 3, Be.prediction = !!(Oe & 8), !Be.mmr) {
                    for (we = Be.template === 0 ? 4 : 1, Ce = [], xe = 0; xe < we; xe++)
                      Ce.push({
                        x: (0, b.readInt8)(le, he),
                        y: (0, b.readInt8)(le, he + 1)
                      }), he += 2;
                    Be.at = Ce;
                  }
                  ye = [Be, le, he, ve];
                  break;
                case 48:
                  const Me = {
                    width: (0, b.readUint32)(le, he),
                    height: (0, b.readUint32)(le, he + 4),
                    resolutionX: (0, b.readUint32)(le, he + 8),
                    resolutionY: (0, b.readUint32)(le, he + 12)
                  };
                  Me.height === 4294967295 && delete Me.height;
                  const Fe = le[he + 16];
                  (0, b.readUint16)(le, he + 17), Me.lossless = !!(Fe & 1), Me.refinement = !!(Fe & 2), Me.defaultPixelValue = Fe >> 2 & 1, Me.combinationOperator = Fe >> 3 & 3, Me.requiresBuffer = !!(Fe & 32), Me.combinationOperatorOverride = !!(Fe & 64), ye = [Me];
                  break;
                case 49:
                  break;
                case 50:
                  break;
                case 51:
                  break;
                case 53:
                  ye = [be.number, le, he, ve];
                  break;
                case 62:
                  break;
                default:
                  throw new m(`segment type ${be.typeName}(${be.type}) is not implemented`);
              }
              const $e = "on" + be.typeName;
              $e in pe && pe[$e].apply(pe, ye);
            }
            function H(me, pe) {
              for (let be = 0, le = me.length; be < le; be++)
                D(me[be], pe);
            }
            function V(me) {
              const pe = new Z();
              for (let be = 0, le = me.length; be < le; be++) {
                const ve = me[be], he = k({}, ve.data, ve.start, ve.end);
                H(he, pe);
              }
              return pe.buffer;
            }
            class Z {
              onPageInformation(pe) {
                this.currentPageInfo = pe;
                const be = pe.width + 7 >> 3, le = new Uint8ClampedArray(be * pe.height);
                pe.defaultPixelValue && le.fill(255), this.buffer = le;
              }
              drawBitmap(pe, be) {
                const le = this.currentPageInfo, ve = pe.width, he = pe.height, ye = le.width + 7 >> 3, Ce = le.combinationOperatorOverride ? pe.combinationOperator : le.combinationOperator, xe = this.buffer, we = 128 >> (pe.x & 7);
                let $e = pe.y * ye + (pe.x >> 3), Ae, ue, ce, Ee;
                switch (Ce) {
                  case 0:
                    for (Ae = 0; Ae < he; Ae++) {
                      for (ce = we, Ee = $e, ue = 0; ue < ve; ue++)
                        be[Ae][ue] && (xe[Ee] |= ce), ce >>= 1, ce || (ce = 128, Ee++);
                      $e += ye;
                    }
                    break;
                  case 2:
                    for (Ae = 0; Ae < he; Ae++) {
                      for (ce = we, Ee = $e, ue = 0; ue < ve; ue++)
                        be[Ae][ue] && (xe[Ee] ^= ce), ce >>= 1, ce || (ce = 128, Ee++);
                      $e += ye;
                    }
                    break;
                  default:
                    throw new m(`operator ${Ce} is not supported`);
                }
              }
              onImmediateGenericRegion(pe, be, le, ve) {
                const he = pe.info, ye = new w(be, le, ve), Ce = B(pe.mmr, he.width, he.height, pe.template, pe.prediction, null, pe.at, ye);
                this.drawBitmap(he, Ce);
              }
              onImmediateLosslessGenericRegion() {
                this.onImmediateGenericRegion(...arguments);
              }
              onSymbolDictionary(pe, be, le, ve, he, ye) {
                let Ce, xe;
                pe.huffman && (Ce = se(pe, le, this.customTables), xe = new J(ve, he, ye));
                let we = this.symbols;
                we || (this.symbols = we = {});
                const $e = [];
                for (const ue of le) {
                  const ce = we[ue];
                  ce && $e.push(...ce);
                }
                const Ae = new w(ve, he, ye);
                we[be] = M(pe.huffman, pe.refinement, $e, pe.numberOfNewSymbols, pe.numberOfExportedSymbols, Ce, pe.template, pe.at, pe.refinementTemplate, pe.refinementAt, Ae, xe);
              }
              onImmediateTextRegion(pe, be, le, ve, he) {
                const ye = pe.info;
                let Ce, xe;
                const we = this.symbols, $e = [];
                for (const Ee of be) {
                  const _e = we[Ee];
                  _e && $e.push(..._e);
                }
                const Ae = (0, b.log2)($e.length);
                pe.huffman && (xe = new J(le, ve, he), Ce = ae(pe, be, this.customTables, $e.length, xe));
                const ue = new w(le, ve, he), ce = W(pe.huffman, pe.refinement, ye.width, ye.height, pe.defaultPixelValue, pe.numberOfSymbolInstances, pe.stripSize, $e, Ae, pe.transposed, pe.dsOffset, pe.referenceCorner, pe.combinationOperator, Ce, pe.refinementTemplate, pe.refinementAt, ue, pe.logStripSize, xe);
                this.drawBitmap(ye, ce);
              }
              onImmediateLosslessTextRegion() {
                this.onImmediateTextRegion(...arguments);
              }
              onPatternDictionary(pe, be, le, ve, he) {
                let ye = this.patterns;
                ye || (this.patterns = ye = {});
                const Ce = new w(le, ve, he);
                ye[be] = j(pe.mmr, pe.patternWidth, pe.patternHeight, pe.maxPatternIndex, pe.template, Ce);
              }
              onImmediateHalftoneRegion(pe, be, le, ve, he) {
                const ye = this.patterns[be[0]], Ce = pe.info, xe = new w(le, ve, he), we = G(pe.mmr, ye, pe.template, Ce.width, Ce.height, pe.defaultPixelValue, pe.enableSkip, pe.combinationOperator, pe.gridWidth, pe.gridHeight, pe.gridOffsetX, pe.gridOffsetY, pe.gridVectorX, pe.gridVectorY, xe);
                this.drawBitmap(Ce, we);
              }
              onImmediateLosslessHalftoneRegion() {
                this.onImmediateHalftoneRegion(...arguments);
              }
              onTables(pe, be, le, ve) {
                let he = this.customTables;
                he || (this.customTables = he = {}), he[pe] = Y(be, le, ve);
              }
            }
            class ne {
              constructor(pe) {
                pe.length === 2 ? (this.isOOB = !0, this.rangeLow = 0, this.prefixLength = pe[0], this.rangeLength = 0, this.prefixCode = pe[1], this.isLowerRange = !1) : (this.isOOB = !1, this.rangeLow = pe[0], this.prefixLength = pe[1], this.rangeLength = pe[2], this.prefixCode = pe[3], this.isLowerRange = pe[4] === "lower");
              }
            }
            class K {
              constructor(pe) {
                this.children = [], pe ? (this.isLeaf = !0, this.rangeLength = pe.rangeLength, this.rangeLow = pe.rangeLow, this.isLowerRange = pe.isLowerRange, this.isOOB = pe.isOOB) : this.isLeaf = !1;
              }
              buildTree(pe, be) {
                const le = pe.prefixCode >> be & 1;
                if (be <= 0)
                  this.children[le] = new K(pe);
                else {
                  let ve = this.children[le];
                  ve || (this.children[le] = ve = new K(null)), ve.buildTree(pe, be - 1);
                }
              }
              decodeNode(pe) {
                if (this.isLeaf) {
                  if (this.isOOB)
                    return null;
                  const le = pe.readBits(this.rangeLength);
                  return this.rangeLow + (this.isLowerRange ? -le : le);
                }
                const be = this.children[pe.readBit()];
                if (!be)
                  throw new m("invalid Huffman data");
                return be.decodeNode(pe);
              }
            }
            class q {
              constructor(pe, be) {
                be || this.assignPrefixCodes(pe), this.rootNode = new K(null);
                for (let le = 0, ve = pe.length; le < ve; le++) {
                  const he = pe[le];
                  he.prefixLength > 0 && this.rootNode.buildTree(he, he.prefixLength - 1);
                }
              }
              decode(pe) {
                return this.rootNode.decodeNode(pe);
              }
              assignPrefixCodes(pe) {
                const be = pe.length;
                let le = 0;
                for (let $e = 0; $e < be; $e++)
                  le = Math.max(le, pe[$e].prefixLength);
                const ve = new Uint32Array(le + 1);
                for (let $e = 0; $e < be; $e++)
                  ve[pe[$e].prefixLength]++;
                let he = 1, ye = 0, Ce, xe, we;
                for (ve[0] = 0; he <= le; ) {
                  for (ye = ye + ve[he - 1] << 1, Ce = ye, xe = 0; xe < be; )
                    we = pe[xe], we.prefixLength === he && (we.prefixCode = Ce, Ce++), xe++;
                  he++;
                }
              }
            }
            function Y(me, pe, be) {
              const le = me[pe], ve = (0, b.readUint32)(me, pe + 1) & 4294967295, he = (0, b.readUint32)(me, pe + 5) & 4294967295, ye = new J(me, pe + 9, be), Ce = (le >> 1 & 7) + 1, xe = (le >> 4 & 7) + 1, we = [];
              let $e, Ae, ue = ve;
              do
                $e = ye.readBits(Ce), Ae = ye.readBits(xe), we.push(new ne([ue, $e, Ae, 0])), ue += 1 << Ae;
              while (ue < he);
              return $e = ye.readBits(Ce), we.push(new ne([ve - 1, $e, 32, 0, "lower"])), $e = ye.readBits(Ce), we.push(new ne([he, $e, 32, 0])), le & 1 && ($e = ye.readBits(Ce), we.push(new ne([$e, 0]))), new q(we, !1);
            }
            const ee = {};
            function Q(me) {
              let pe = ee[me];
              if (pe)
                return pe;
              let be;
              switch (me) {
                case 1:
                  be = [[0, 1, 4, 0], [16, 2, 8, 2], [272, 3, 16, 6], [65808, 3, 32, 7]];
                  break;
                case 2:
                  be = [[0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [75, 6, 32, 62], [6, 63]];
                  break;
                case 3:
                  be = [[-256, 8, 8, 254], [0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [-257, 8, 32, 255, "lower"], [75, 7, 32, 126], [6, 62]];
                  break;
                case 4:
                  be = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [76, 5, 32, 31]];
                  break;
                case 5:
                  be = [[-255, 7, 8, 126], [1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [-256, 7, 32, 127, "lower"], [76, 6, 32, 62]];
                  break;
                case 6:
                  be = [[-2048, 5, 10, 28], [-1024, 4, 9, 8], [-512, 4, 8, 9], [-256, 4, 7, 10], [-128, 5, 6, 29], [-64, 5, 5, 30], [-32, 4, 5, 11], [0, 2, 7, 0], [128, 3, 7, 2], [256, 3, 8, 3], [512, 4, 9, 12], [1024, 4, 10, 13], [-2049, 6, 32, 62, "lower"], [2048, 6, 32, 63]];
                  break;
                case 7:
                  be = [[-1024, 4, 9, 8], [-512, 3, 8, 0], [-256, 4, 7, 9], [-128, 5, 6, 26], [-64, 5, 5, 27], [-32, 4, 5, 10], [0, 4, 5, 11], [32, 5, 5, 28], [64, 5, 6, 29], [128, 4, 7, 12], [256, 3, 8, 1], [512, 3, 9, 2], [1024, 3, 10, 3], [-1025, 5, 32, 30, "lower"], [2048, 5, 32, 31]];
                  break;
                case 8:
                  be = [[-15, 8, 3, 252], [-7, 9, 1, 508], [-5, 8, 1, 253], [-3, 9, 0, 509], [-2, 7, 0, 124], [-1, 4, 0, 10], [0, 2, 1, 0], [2, 5, 0, 26], [3, 6, 0, 58], [4, 3, 4, 4], [20, 6, 1, 59], [22, 4, 4, 11], [38, 4, 5, 12], [70, 5, 6, 27], [134, 5, 7, 28], [262, 6, 7, 60], [390, 7, 8, 125], [646, 6, 10, 61], [-16, 9, 32, 510, "lower"], [1670, 9, 32, 511], [2, 1]];
                  break;
                case 9:
                  be = [[-31, 8, 4, 252], [-15, 9, 2, 508], [-11, 8, 2, 253], [-7, 9, 1, 509], [-5, 7, 1, 124], [-3, 4, 1, 10], [-1, 3, 1, 2], [1, 3, 1, 3], [3, 5, 1, 26], [5, 6, 1, 58], [7, 3, 5, 4], [39, 6, 2, 59], [43, 4, 5, 11], [75, 4, 6, 12], [139, 5, 7, 27], [267, 5, 8, 28], [523, 6, 8, 60], [779, 7, 9, 125], [1291, 6, 11, 61], [-32, 9, 32, 510, "lower"], [3339, 9, 32, 511], [2, 0]];
                  break;
                case 10:
                  be = [[-21, 7, 4, 122], [-5, 8, 0, 252], [-4, 7, 0, 123], [-3, 5, 0, 24], [-2, 2, 2, 0], [2, 5, 0, 25], [3, 6, 0, 54], [4, 7, 0, 124], [5, 8, 0, 253], [6, 2, 6, 1], [70, 5, 5, 26], [102, 6, 5, 55], [134, 6, 6, 56], [198, 6, 7, 57], [326, 6, 8, 58], [582, 6, 9, 59], [1094, 6, 10, 60], [2118, 7, 11, 125], [-22, 8, 32, 254, "lower"], [4166, 8, 32, 255], [2, 2]];
                  break;
                case 11:
                  be = [[1, 1, 0, 0], [2, 2, 1, 2], [4, 4, 0, 12], [5, 4, 1, 13], [7, 5, 1, 28], [9, 5, 2, 29], [13, 6, 2, 60], [17, 7, 2, 122], [21, 7, 3, 123], [29, 7, 4, 124], [45, 7, 5, 125], [77, 7, 6, 126], [141, 7, 32, 127]];
                  break;
                case 12:
                  be = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 1, 6], [5, 5, 0, 28], [6, 5, 1, 29], [8, 6, 1, 60], [10, 7, 0, 122], [11, 7, 1, 123], [13, 7, 2, 124], [17, 7, 3, 125], [25, 7, 4, 126], [41, 8, 5, 254], [73, 8, 32, 255]];
                  break;
                case 13:
                  be = [[1, 1, 0, 0], [2, 3, 0, 4], [3, 4, 0, 12], [4, 5, 0, 28], [5, 4, 1, 13], [7, 3, 3, 5], [15, 6, 1, 58], [17, 6, 2, 59], [21, 6, 3, 60], [29, 6, 4, 61], [45, 6, 5, 62], [77, 7, 6, 126], [141, 7, 32, 127]];
                  break;
                case 14:
                  be = [[-2, 3, 0, 4], [-1, 3, 0, 5], [0, 1, 0, 0], [1, 3, 0, 6], [2, 3, 0, 7]];
                  break;
                case 15:
                  be = [[-24, 7, 4, 124], [-8, 6, 2, 60], [-4, 5, 1, 28], [-2, 4, 0, 12], [-1, 3, 0, 4], [0, 1, 0, 0], [1, 3, 0, 5], [2, 4, 0, 13], [3, 5, 1, 29], [5, 6, 2, 61], [9, 7, 4, 125], [-25, 7, 32, 126, "lower"], [25, 7, 32, 127]];
                  break;
                default:
                  throw new m(`standard table B.${me} does not exist`);
              }
              for (let le = 0, ve = be.length; le < ve; le++)
                be[le] = new ne(be[le]);
              return pe = new q(be, !0), ee[me] = pe, pe;
            }
            class J {
              constructor(pe, be, le) {
                this.data = pe, this.start = be, this.end = le, this.position = be, this.shift = -1, this.currentByte = 0;
              }
              readBit() {
                if (this.shift < 0) {
                  if (this.position >= this.end)
                    throw new m("end of data while reading bit");
                  this.currentByte = this.data[this.position++], this.shift = 7;
                }
                const pe = this.currentByte >> this.shift & 1;
                return this.shift--, pe;
              }
              readBits(pe) {
                let be = 0, le;
                for (le = pe - 1; le >= 0; le--)
                  be |= this.readBit() << le;
                return be;
              }
              byteAlign() {
                this.shift = -1;
              }
              next() {
                return this.position >= this.end ? -1 : this.data[this.position++];
              }
            }
            function te(me, pe, be) {
              let le = 0;
              for (let ve = 0, he = pe.length; ve < he; ve++) {
                const ye = be[pe[ve]];
                if (ye) {
                  if (me === le)
                    return ye;
                  le++;
                }
              }
              throw new m("can't find custom Huffman table");
            }
            function ae(me, pe, be, le, ve) {
              const he = [];
              for (let ue = 0; ue <= 34; ue++) {
                const ce = ve.readBits(4);
                he.push(new ne([ue, ce, 0, 0]));
              }
              const ye = new q(he, !1);
              he.length = 0;
              for (let ue = 0; ue < le; ) {
                const ce = ye.decode(ve);
                if (ce >= 32) {
                  let Ee, _e, Te;
                  switch (ce) {
                    case 32:
                      if (ue === 0)
                        throw new m("no previous value in symbol ID table");
                      _e = ve.readBits(2) + 3, Ee = he[ue - 1].prefixLength;
                      break;
                    case 33:
                      _e = ve.readBits(3) + 3, Ee = 0;
                      break;
                    case 34:
                      _e = ve.readBits(7) + 11, Ee = 0;
                      break;
                    default:
                      throw new m("invalid code length in symbol ID table");
                  }
                  for (Te = 0; Te < _e; Te++)
                    he.push(new ne([ue, Ee, 0, 0])), ue++;
                } else
                  he.push(new ne([ue, ce, 0, 0])), ue++;
              }
              ve.byteAlign();
              const Ce = new q(he, !1);
              let xe = 0, we, $e, Ae;
              switch (me.huffmanFS) {
                case 0:
                case 1:
                  we = Q(me.huffmanFS + 6);
                  break;
                case 3:
                  we = te(xe, pe, be), xe++;
                  break;
                default:
                  throw new m("invalid Huffman FS selector");
              }
              switch (me.huffmanDS) {
                case 0:
                case 1:
                case 2:
                  $e = Q(me.huffmanDS + 8);
                  break;
                case 3:
                  $e = te(xe, pe, be), xe++;
                  break;
                default:
                  throw new m("invalid Huffman DS selector");
              }
              switch (me.huffmanDT) {
                case 0:
                case 1:
                case 2:
                  Ae = Q(me.huffmanDT + 11);
                  break;
                case 3:
                  Ae = te(xe, pe, be), xe++;
                  break;
                default:
                  throw new m("invalid Huffman DT selector");
              }
              if (me.refinement)
                throw new m("refinement with Huffman is not supported");
              return {
                symbolIDTable: Ce,
                tableFirstS: we,
                tableDeltaS: $e,
                tableDeltaT: Ae
              };
            }
            function se(me, pe, be) {
              let le = 0, ve, he;
              switch (me.huffmanDHSelector) {
                case 0:
                case 1:
                  ve = Q(me.huffmanDHSelector + 4);
                  break;
                case 3:
                  ve = te(le, pe, be), le++;
                  break;
                default:
                  throw new m("invalid Huffman DH selector");
              }
              switch (me.huffmanDWSelector) {
                case 0:
                case 1:
                  he = Q(me.huffmanDWSelector + 2);
                  break;
                case 3:
                  he = te(le, pe, be), le++;
                  break;
                default:
                  throw new m("invalid Huffman DW selector");
              }
              let ye, Ce;
              return me.bitmapSizeSelector ? (ye = te(le, pe, be), le++) : ye = Q(1), me.aggregationInstancesSelector ? Ce = te(le, pe, be) : Ce = Q(1), {
                tableDeltaHeight: ve,
                tableDeltaWidth: he,
                tableBitmapSize: ye,
                tableAggregateInstances: Ce
              };
            }
            function ie(me, pe, be) {
              const le = [];
              for (let ve = 0; ve < be; ve++) {
                const he = new Uint8Array(pe);
                le.push(he);
                for (let ye = 0; ye < pe; ye++)
                  he[ye] = me.readBit();
                me.byteAlign();
              }
              return le;
            }
            function fe(me, pe, be, le) {
              const ve = {
                K: -1,
                Columns: pe,
                Rows: be,
                BlackIs1: !0,
                EndOfBlock: le
              }, he = new f.CCITTFaxDecoder(me, ve), ye = [];
              let Ce, xe = !1;
              for (let we = 0; we < be; we++) {
                const $e = new Uint8Array(pe);
                ye.push($e);
                let Ae = -1;
                for (let ue = 0; ue < pe; ue++)
                  Ae < 0 && (Ce = he.readNextChar(), Ce === -1 && (Ce = 0, xe = !0), Ae = 7), $e[ue] = Ce >> Ae & 1, Ae--;
              }
              if (le && !xe)
                for (let $e = 0; $e < 5 && he.readNextChar() !== -1; $e++)
                  ;
              return ye;
            }
            class ge {
              parseChunks(pe) {
                return V(pe);
              }
              parse(pe) {
                throw new Error("Not implemented: Jbig2Image.parse");
              }
            }
            A.Jbig2Image = ge;
          },
          /* 25 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ArithmeticDecoder = void 0;
            const x = [{
              qe: 22017,
              nmps: 1,
              nlps: 1,
              switchFlag: 1
            }, {
              qe: 13313,
              nmps: 2,
              nlps: 6,
              switchFlag: 0
            }, {
              qe: 6145,
              nmps: 3,
              nlps: 9,
              switchFlag: 0
            }, {
              qe: 2753,
              nmps: 4,
              nlps: 12,
              switchFlag: 0
            }, {
              qe: 1313,
              nmps: 5,
              nlps: 29,
              switchFlag: 0
            }, {
              qe: 545,
              nmps: 38,
              nlps: 33,
              switchFlag: 0
            }, {
              qe: 22017,
              nmps: 7,
              nlps: 6,
              switchFlag: 1
            }, {
              qe: 21505,
              nmps: 8,
              nlps: 14,
              switchFlag: 0
            }, {
              qe: 18433,
              nmps: 9,
              nlps: 14,
              switchFlag: 0
            }, {
              qe: 14337,
              nmps: 10,
              nlps: 14,
              switchFlag: 0
            }, {
              qe: 12289,
              nmps: 11,
              nlps: 17,
              switchFlag: 0
            }, {
              qe: 9217,
              nmps: 12,
              nlps: 18,
              switchFlag: 0
            }, {
              qe: 7169,
              nmps: 13,
              nlps: 20,
              switchFlag: 0
            }, {
              qe: 5633,
              nmps: 29,
              nlps: 21,
              switchFlag: 0
            }, {
              qe: 22017,
              nmps: 15,
              nlps: 14,
              switchFlag: 1
            }, {
              qe: 21505,
              nmps: 16,
              nlps: 14,
              switchFlag: 0
            }, {
              qe: 20737,
              nmps: 17,
              nlps: 15,
              switchFlag: 0
            }, {
              qe: 18433,
              nmps: 18,
              nlps: 16,
              switchFlag: 0
            }, {
              qe: 14337,
              nmps: 19,
              nlps: 17,
              switchFlag: 0
            }, {
              qe: 13313,
              nmps: 20,
              nlps: 18,
              switchFlag: 0
            }, {
              qe: 12289,
              nmps: 21,
              nlps: 19,
              switchFlag: 0
            }, {
              qe: 10241,
              nmps: 22,
              nlps: 19,
              switchFlag: 0
            }, {
              qe: 9217,
              nmps: 23,
              nlps: 20,
              switchFlag: 0
            }, {
              qe: 8705,
              nmps: 24,
              nlps: 21,
              switchFlag: 0
            }, {
              qe: 7169,
              nmps: 25,
              nlps: 22,
              switchFlag: 0
            }, {
              qe: 6145,
              nmps: 26,
              nlps: 23,
              switchFlag: 0
            }, {
              qe: 5633,
              nmps: 27,
              nlps: 24,
              switchFlag: 0
            }, {
              qe: 5121,
              nmps: 28,
              nlps: 25,
              switchFlag: 0
            }, {
              qe: 4609,
              nmps: 29,
              nlps: 26,
              switchFlag: 0
            }, {
              qe: 4353,
              nmps: 30,
              nlps: 27,
              switchFlag: 0
            }, {
              qe: 2753,
              nmps: 31,
              nlps: 28,
              switchFlag: 0
            }, {
              qe: 2497,
              nmps: 32,
              nlps: 29,
              switchFlag: 0
            }, {
              qe: 2209,
              nmps: 33,
              nlps: 30,
              switchFlag: 0
            }, {
              qe: 1313,
              nmps: 34,
              nlps: 31,
              switchFlag: 0
            }, {
              qe: 1089,
              nmps: 35,
              nlps: 32,
              switchFlag: 0
            }, {
              qe: 673,
              nmps: 36,
              nlps: 33,
              switchFlag: 0
            }, {
              qe: 545,
              nmps: 37,
              nlps: 34,
              switchFlag: 0
            }, {
              qe: 321,
              nmps: 38,
              nlps: 35,
              switchFlag: 0
            }, {
              qe: 273,
              nmps: 39,
              nlps: 36,
              switchFlag: 0
            }, {
              qe: 133,
              nmps: 40,
              nlps: 37,
              switchFlag: 0
            }, {
              qe: 73,
              nmps: 41,
              nlps: 38,
              switchFlag: 0
            }, {
              qe: 37,
              nmps: 42,
              nlps: 39,
              switchFlag: 0
            }, {
              qe: 21,
              nmps: 43,
              nlps: 40,
              switchFlag: 0
            }, {
              qe: 9,
              nmps: 44,
              nlps: 41,
              switchFlag: 0
            }, {
              qe: 5,
              nmps: 45,
              nlps: 42,
              switchFlag: 0
            }, {
              qe: 1,
              nmps: 45,
              nlps: 43,
              switchFlag: 0
            }, {
              qe: 22017,
              nmps: 46,
              nlps: 46,
              switchFlag: 0
            }];
            class g {
              constructor(y, f, m) {
                this.data = y, this.bp = f, this.dataEnd = m, this.chigh = y[f], this.clow = 0, this.byteIn(), this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127, this.clow = this.clow << 7 & 65535, this.ct -= 7, this.a = 32768;
              }
              byteIn() {
                const y = this.data;
                let f = this.bp;
                y[f] === 255 ? y[f + 1] > 143 ? (this.clow += 65280, this.ct = 8) : (f++, this.clow += y[f] << 9, this.ct = 7, this.bp = f) : (f++, this.clow += f < this.dataEnd ? y[f] << 8 : 65280, this.ct = 8, this.bp = f), this.clow > 65535 && (this.chigh += this.clow >> 16, this.clow &= 65535);
              }
              readBit(y, f) {
                let m = y[f] >> 1, C = y[f] & 1;
                const w = x[m], S = w.qe;
                let $, T = this.a - S;
                if (this.chigh < S)
                  T < S ? (T = S, $ = C, m = w.nmps) : (T = S, $ = 1 ^ C, w.switchFlag === 1 && (C = $), m = w.nlps);
                else {
                  if (this.chigh -= S, (T & 32768) !== 0)
                    return this.a = T, C;
                  T < S ? ($ = 1 ^ C, w.switchFlag === 1 && (C = $), m = w.nlps) : ($ = C, m = w.nmps);
                }
                do
                  this.ct === 0 && this.byteIn(), T <<= 1, this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1, this.clow = this.clow << 1 & 65535, this.ct--;
                while ((T & 32768) === 0);
                return this.a = T, y[f] = m << 1 | C, $;
              }
            }
            A.ArithmeticDecoder = g;
          },
          /* 26 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.JpegStream = void 0;
            var g = x(18), b = x(4), y = x(27), f = x(2);
            class m extends g.DecodeStream {
              constructor(w, S, $) {
                let T;
                for (; (T = w.getByte()) !== -1; )
                  if (T === 255) {
                    w.skip(-1);
                    break;
                  }
                super(S), this.stream = w, this.dict = w.dict, this.maybeLength = S, this.params = $;
              }
              get bytes() {
                return (0, f.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
              }
              ensureBuffer(w) {
              }
              readBlock() {
                if (this.eof)
                  return;
                const w = {
                  decodeTransform: void 0,
                  colorTransform: void 0
                }, S = this.dict.getArray("D", "Decode");
                if ((this.forceRGBA || this.forceRGB) && Array.isArray(S)) {
                  const I = this.dict.get("BPC", "BitsPerComponent") || 8, _ = S.length, E = new Int32Array(_);
                  let R = !1;
                  const O = (1 << I) - 1;
                  for (let L = 0; L < _; L += 2)
                    E[L] = (S[L + 1] - S[L]) * 256 | 0, E[L + 1] = S[L] * O | 0, (E[L] !== 256 || E[L + 1] !== 0) && (R = !0);
                  R && (w.decodeTransform = E);
                }
                if (this.params instanceof b.Dict) {
                  const I = this.params.get("ColorTransform");
                  Number.isInteger(I) && (w.colorTransform = I);
                }
                const $ = new y.JpegImage(w);
                $.parse(this.bytes);
                const T = $.getData({
                  width: this.drawWidth,
                  height: this.drawHeight,
                  forceRGBA: this.forceRGBA,
                  forceRGB: this.forceRGB,
                  isSourcePDF: !0
                });
                this.buffer = T, this.bufferLength = T.length, this.eof = !0;
              }
            }
            A.JpegStream = m;
          },
          /* 27 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.JpegImage = void 0;
            var g = x(2), b = x(28), y = x(3);
            class f extends g.BaseException {
              constructor(k) {
                super(`JPEG error: ${k}`, "JpegError");
              }
            }
            class m extends g.BaseException {
              constructor(k, N) {
                super(k, "DNLMarkerError"), this.scanLines = N;
              }
            }
            class C extends g.BaseException {
              constructor(k) {
                super(k, "EOIMarkerError");
              }
            }
            const w = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]), S = 4017, $ = 799, T = 3406, I = 2276, _ = 1567, E = 3784, R = 5793, O = 2896;
            function L(U, k) {
              let N = 0, P, D, H = 16;
              for (; H > 0 && !U[H - 1]; )
                H--;
              const V = [{
                children: [],
                index: 0
              }];
              let Z = V[0], ne;
              for (P = 0; P < H; P++) {
                for (D = 0; D < U[P]; D++) {
                  for (Z = V.pop(), Z.children[Z.index] = k[N]; Z.index > 0; )
                    Z = V.pop();
                  for (Z.index++, V.push(Z); V.length <= P; )
                    V.push(ne = {
                      children: [],
                      index: 0
                    }), Z.children[Z.index] = ne.children, Z = ne;
                  N++;
                }
                P + 1 < H && (V.push(ne = {
                  children: [],
                  index: 0
                }), Z.children[Z.index] = ne.children, Z = ne);
              }
              return V[0].children;
            }
            function B(U, k, N) {
              return 64 * ((U.blocksPerLine + 1) * k + N);
            }
            function F(U, k, N, P, D, H, V, Z, ne, K = !1) {
              const q = N.mcusPerLine, Y = N.progressive, ee = k;
              let Q = 0, J = 0;
              function te() {
                if (J > 0)
                  return J--, Q >> J & 1;
                if (Q = U[k++], Q === 255) {
                  const Me = U[k++];
                  if (Me) {
                    if (Me === 220 && K) {
                      k += 2;
                      const Fe = (0, y.readUint16)(U, k);
                      if (k += 2, Fe > 0 && Fe !== N.scanLines)
                        throw new m("Found DNL marker (0xFFDC) while parsing scan data", Fe);
                    } else if (Me === 217) {
                      if (K) {
                        const Fe = ye * (N.precision === 8 ? 8 : 0);
                        if (Fe > 0 && Math.round(N.scanLines / Fe) >= 5)
                          throw new m("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", Fe);
                      }
                      throw new C("Found EOI marker (0xFFD9) while parsing scan data");
                    }
                    throw new f(`unexpected marker ${(Q << 8 | Me).toString(16)}`);
                  }
                }
                return J = 7, Q >>> 7;
              }
              function ae(Me) {
                let Fe = Me;
                for (; ; ) {
                  switch (Fe = Fe[te()], typeof Fe) {
                    case "number":
                      return Fe;
                    case "object":
                      continue;
                  }
                  throw new f("invalid huffman sequence");
                }
              }
              function se(Me) {
                let Fe = 0;
                for (; Me > 0; )
                  Fe = Fe << 1 | te(), Me--;
                return Fe;
              }
              function ie(Me) {
                if (Me === 1)
                  return te() === 1 ? 1 : -1;
                const Fe = se(Me);
                return Fe >= 1 << Me - 1 ? Fe : Fe + (-1 << Me) + 1;
              }
              function fe(Me, Fe) {
                const Ue = ae(Me.huffmanTableDC), je = Ue === 0 ? 0 : ie(Ue);
                Me.blockData[Fe] = Me.pred += je;
                let Le = 1;
                for (; Le < 64; ) {
                  const De = ae(Me.huffmanTableAC), Ne = De & 15, Ge = De >> 4;
                  if (Ne === 0) {
                    if (Ge < 15)
                      break;
                    Le += 16;
                    continue;
                  }
                  Le += Ge;
                  const Xe = w[Le];
                  Me.blockData[Fe + Xe] = ie(Ne), Le++;
                }
              }
              function ge(Me, Fe) {
                const Ue = ae(Me.huffmanTableDC), je = Ue === 0 ? 0 : ie(Ue) << ne;
                Me.blockData[Fe] = Me.pred += je;
              }
              function me(Me, Fe) {
                Me.blockData[Fe] |= te() << ne;
              }
              let pe = 0;
              function be(Me, Fe) {
                if (pe > 0) {
                  pe--;
                  return;
                }
                let Ue = H;
                const je = V;
                for (; Ue <= je; ) {
                  const Le = ae(Me.huffmanTableAC), De = Le & 15, Ne = Le >> 4;
                  if (De === 0) {
                    if (Ne < 15) {
                      pe = se(Ne) + (1 << Ne) - 1;
                      break;
                    }
                    Ue += 16;
                    continue;
                  }
                  Ue += Ne;
                  const Ge = w[Ue];
                  Me.blockData[Fe + Ge] = ie(De) * (1 << ne), Ue++;
                }
              }
              let le = 0, ve;
              function he(Me, Fe) {
                let Ue = H;
                const je = V;
                let Le = 0, De, Ne;
                for (; Ue <= je; ) {
                  const Ge = Fe + w[Ue], Xe = Me.blockData[Ge] < 0 ? -1 : 1;
                  switch (le) {
                    case 0:
                      if (Ne = ae(Me.huffmanTableAC), De = Ne & 15, Le = Ne >> 4, De === 0)
                        Le < 15 ? (pe = se(Le) + (1 << Le), le = 4) : (Le = 16, le = 1);
                      else {
                        if (De !== 1)
                          throw new f("invalid ACn encoding");
                        ve = ie(De), le = Le ? 2 : 3;
                      }
                      continue;
                    case 1:
                    case 2:
                      Me.blockData[Ge] ? Me.blockData[Ge] += Xe * (te() << ne) : (Le--, Le === 0 && (le = le === 2 ? 3 : 0));
                      break;
                    case 3:
                      Me.blockData[Ge] ? Me.blockData[Ge] += Xe * (te() << ne) : (Me.blockData[Ge] = ve << ne, le = 0);
                      break;
                    case 4:
                      Me.blockData[Ge] && (Me.blockData[Ge] += Xe * (te() << ne));
                      break;
                  }
                  Ue++;
                }
                le === 4 && (pe--, pe === 0 && (le = 0));
              }
              let ye = 0;
              function Ce(Me, Fe, Ue, je, Le) {
                const De = Ue / q | 0, Ne = Ue % q;
                ye = De * Me.v + je;
                const Ge = Ne * Me.h + Le, Xe = B(Me, ye, Ge);
                Fe(Me, Xe);
              }
              function xe(Me, Fe, Ue) {
                ye = Ue / Me.blocksPerLine | 0;
                const je = Ue % Me.blocksPerLine, Le = B(Me, ye, je);
                Fe(Me, Le);
              }
              const we = P.length;
              let $e, Ae, ue, ce, Ee, _e;
              Y ? H === 0 ? _e = Z === 0 ? ge : me : _e = Z === 0 ? be : he : _e = fe;
              let Te = 0, ke;
              const Re = we === 1 ? P[0].blocksPerLine * P[0].blocksPerColumn : q * N.mcusPerColumn;
              let Be, Oe;
              for (; Te <= Re; ) {
                const Me = D ? Math.min(Re - Te, D) : Re;
                if (Me > 0) {
                  for (Ae = 0; Ae < we; Ae++)
                    P[Ae].pred = 0;
                  if (pe = 0, we === 1)
                    for ($e = P[0], Ee = 0; Ee < Me; Ee++)
                      xe($e, _e, Te), Te++;
                  else
                    for (Ee = 0; Ee < Me; Ee++) {
                      for (Ae = 0; Ae < we; Ae++)
                        for ($e = P[Ae], Be = $e.h, Oe = $e.v, ue = 0; ue < Oe; ue++)
                          for (ce = 0; ce < Be; ce++)
                            Ce($e, _e, Te, ue, ce);
                      Te++;
                    }
                }
                if (J = 0, ke = j(U, k), !ke)
                  break;
                if (ke.invalid) {
                  const Fe = Me > 0 ? "unexpected" : "excessive";
                  (0, g.warn)(`decodeScan - ${Fe} MCU data, current marker is: ${ke.invalid}`), k = ke.offset;
                }
                if (ke.marker >= 65488 && ke.marker <= 65495)
                  k += 2;
                else
                  break;
              }
              return k - ee;
            }
            function M(U, k, N) {
              const P = U.quantizationTable, D = U.blockData;
              let H, V, Z, ne, K, q, Y, ee, Q, J, te, ae, se, ie, fe, ge, me;
              if (!P)
                throw new f("missing required Quantization Table.");
              for (let pe = 0; pe < 64; pe += 8) {
                if (Q = D[k + pe], J = D[k + pe + 1], te = D[k + pe + 2], ae = D[k + pe + 3], se = D[k + pe + 4], ie = D[k + pe + 5], fe = D[k + pe + 6], ge = D[k + pe + 7], Q *= P[pe], (J | te | ae | se | ie | fe | ge) === 0) {
                  me = R * Q + 512 >> 10, N[pe] = me, N[pe + 1] = me, N[pe + 2] = me, N[pe + 3] = me, N[pe + 4] = me, N[pe + 5] = me, N[pe + 6] = me, N[pe + 7] = me;
                  continue;
                }
                J *= P[pe + 1], te *= P[pe + 2], ae *= P[pe + 3], se *= P[pe + 4], ie *= P[pe + 5], fe *= P[pe + 6], ge *= P[pe + 7], H = R * Q + 128 >> 8, V = R * se + 128 >> 8, Z = te, ne = fe, K = O * (J - ge) + 128 >> 8, ee = O * (J + ge) + 128 >> 8, q = ae << 4, Y = ie << 4, H = H + V + 1 >> 1, V = H - V, me = Z * E + ne * _ + 128 >> 8, Z = Z * _ - ne * E + 128 >> 8, ne = me, K = K + Y + 1 >> 1, Y = K - Y, ee = ee + q + 1 >> 1, q = ee - q, H = H + ne + 1 >> 1, ne = H - ne, V = V + Z + 1 >> 1, Z = V - Z, me = K * I + ee * T + 2048 >> 12, K = K * T - ee * I + 2048 >> 12, ee = me, me = q * $ + Y * S + 2048 >> 12, q = q * S - Y * $ + 2048 >> 12, Y = me, N[pe] = H + ee, N[pe + 7] = H - ee, N[pe + 1] = V + Y, N[pe + 6] = V - Y, N[pe + 2] = Z + q, N[pe + 5] = Z - q, N[pe + 3] = ne + K, N[pe + 4] = ne - K;
              }
              for (let pe = 0; pe < 8; ++pe) {
                if (Q = N[pe], J = N[pe + 8], te = N[pe + 16], ae = N[pe + 24], se = N[pe + 32], ie = N[pe + 40], fe = N[pe + 48], ge = N[pe + 56], (J | te | ae | se | ie | fe | ge) === 0) {
                  me = R * Q + 8192 >> 14, me < -2040 ? me = 0 : me >= 2024 ? me = 255 : me = me + 2056 >> 4, D[k + pe] = me, D[k + pe + 8] = me, D[k + pe + 16] = me, D[k + pe + 24] = me, D[k + pe + 32] = me, D[k + pe + 40] = me, D[k + pe + 48] = me, D[k + pe + 56] = me;
                  continue;
                }
                H = R * Q + 2048 >> 12, V = R * se + 2048 >> 12, Z = te, ne = fe, K = O * (J - ge) + 2048 >> 12, ee = O * (J + ge) + 2048 >> 12, q = ae, Y = ie, H = (H + V + 1 >> 1) + 4112, V = H - V, me = Z * E + ne * _ + 2048 >> 12, Z = Z * _ - ne * E + 2048 >> 12, ne = me, K = K + Y + 1 >> 1, Y = K - Y, ee = ee + q + 1 >> 1, q = ee - q, H = H + ne + 1 >> 1, ne = H - ne, V = V + Z + 1 >> 1, Z = V - Z, me = K * I + ee * T + 2048 >> 12, K = K * T - ee * I + 2048 >> 12, ee = me, me = q * $ + Y * S + 2048 >> 12, q = q * S - Y * $ + 2048 >> 12, Y = me, Q = H + ee, ge = H - ee, J = V + Y, fe = V - Y, te = Z + q, ie = Z - q, ae = ne + K, se = ne - K, Q < 16 ? Q = 0 : Q >= 4080 ? Q = 255 : Q >>= 4, J < 16 ? J = 0 : J >= 4080 ? J = 255 : J >>= 4, te < 16 ? te = 0 : te >= 4080 ? te = 255 : te >>= 4, ae < 16 ? ae = 0 : ae >= 4080 ? ae = 255 : ae >>= 4, se < 16 ? se = 0 : se >= 4080 ? se = 255 : se >>= 4, ie < 16 ? ie = 0 : ie >= 4080 ? ie = 255 : ie >>= 4, fe < 16 ? fe = 0 : fe >= 4080 ? fe = 255 : fe >>= 4, ge < 16 ? ge = 0 : ge >= 4080 ? ge = 255 : ge >>= 4, D[k + pe] = Q, D[k + pe + 8] = J, D[k + pe + 16] = te, D[k + pe + 24] = ae, D[k + pe + 32] = se, D[k + pe + 40] = ie, D[k + pe + 48] = fe, D[k + pe + 56] = ge;
              }
            }
            function W(U, k) {
              const N = k.blocksPerLine, P = k.blocksPerColumn, D = new Int16Array(64);
              for (let H = 0; H < P; H++)
                for (let V = 0; V < N; V++) {
                  const Z = B(k, H, V);
                  M(k, Z, D);
                }
              return k.blockData;
            }
            function j(U, k, N = k) {
              const P = U.length - 1;
              let D = N < k ? N : k;
              if (k >= P)
                return null;
              const H = (0, y.readUint16)(U, k);
              if (H >= 65472 && H <= 65534)
                return {
                  invalid: null,
                  marker: H,
                  offset: k
                };
              let V = (0, y.readUint16)(U, D);
              for (; !(V >= 65472 && V <= 65534); ) {
                if (++D >= P)
                  return null;
                V = (0, y.readUint16)(U, D);
              }
              return {
                invalid: H.toString(16),
                marker: V,
                offset: D
              };
            }
            class G {
              constructor({
                decodeTransform: k = null,
                colorTransform: N = -1
              } = {}) {
                this._decodeTransform = k, this._colorTransform = N;
              }
              parse(k, {
                dnlScanLines: N = null
              } = {}) {
                function P() {
                  const te = (0, y.readUint16)(k, H);
                  H += 2;
                  let ae = H + te - 2;
                  const se = j(k, ae, H);
                  se?.invalid && ((0, g.warn)("readDataBlock - incorrect length, current marker is: " + se.invalid), ae = se.offset);
                  const ie = k.subarray(H, ae);
                  return H += ie.length, ie;
                }
                function D(te) {
                  const ae = Math.ceil(te.samplesPerLine / 8 / te.maxH), se = Math.ceil(te.scanLines / 8 / te.maxV);
                  for (const ie of te.components) {
                    const fe = Math.ceil(Math.ceil(te.samplesPerLine / 8) * ie.h / te.maxH), ge = Math.ceil(Math.ceil(te.scanLines / 8) * ie.v / te.maxV), me = ae * ie.h, be = 64 * (se * ie.v) * (me + 1);
                    ie.blockData = new Int16Array(be), ie.blocksPerLine = fe, ie.blocksPerColumn = ge;
                  }
                  te.mcusPerLine = ae, te.mcusPerColumn = se;
                }
                let H = 0, V = null, Z = null, ne, K, q = 0;
                const Y = [], ee = [], Q = [];
                let J = (0, y.readUint16)(k, H);
                if (H += 2, J !== 65496)
                  throw new f("SOI not found");
                J = (0, y.readUint16)(k, H), H += 2;
                e: for (; J !== 65497; ) {
                  let te, ae, se;
                  switch (J) {
                    case 65504:
                    case 65505:
                    case 65506:
                    case 65507:
                    case 65508:
                    case 65509:
                    case 65510:
                    case 65511:
                    case 65512:
                    case 65513:
                    case 65514:
                    case 65515:
                    case 65516:
                    case 65517:
                    case 65518:
                    case 65519:
                    case 65534:
                      const ie = P();
                      J === 65504 && ie[0] === 74 && ie[1] === 70 && ie[2] === 73 && ie[3] === 70 && ie[4] === 0 && (V = {
                        version: {
                          major: ie[5],
                          minor: ie[6]
                        },
                        densityUnits: ie[7],
                        xDensity: ie[8] << 8 | ie[9],
                        yDensity: ie[10] << 8 | ie[11],
                        thumbWidth: ie[12],
                        thumbHeight: ie[13],
                        thumbData: ie.subarray(14, 14 + 3 * ie[12] * ie[13])
                      }), J === 65518 && ie[0] === 65 && ie[1] === 100 && ie[2] === 111 && ie[3] === 98 && ie[4] === 101 && (Z = {
                        version: ie[5] << 8 | ie[6],
                        flags0: ie[7] << 8 | ie[8],
                        flags1: ie[9] << 8 | ie[10],
                        transformCode: ie[11]
                      });
                      break;
                    case 65499:
                      const fe = (0, y.readUint16)(k, H);
                      H += 2;
                      const ge = fe + H - 2;
                      let me;
                      for (; H < ge; ) {
                        const ce = k[H++], Ee = new Uint16Array(64);
                        if (ce >> 4 === 0)
                          for (ae = 0; ae < 64; ae++)
                            me = w[ae], Ee[me] = k[H++];
                        else if (ce >> 4 === 1)
                          for (ae = 0; ae < 64; ae++)
                            me = w[ae], Ee[me] = (0, y.readUint16)(k, H), H += 2;
                        else
                          throw new f("DQT - invalid table spec");
                        Y[ce & 15] = Ee;
                      }
                      break;
                    case 65472:
                    case 65473:
                    case 65474:
                      if (ne)
                        throw new f("Only single frame JPEGs supported");
                      H += 2, ne = {}, ne.extended = J === 65473, ne.progressive = J === 65474, ne.precision = k[H++];
                      const pe = (0, y.readUint16)(k, H);
                      H += 2, ne.scanLines = N || pe, ne.samplesPerLine = (0, y.readUint16)(k, H), H += 2, ne.components = [], ne.componentIds = {};
                      const be = k[H++];
                      let le = 0, ve = 0;
                      for (te = 0; te < be; te++) {
                        const ce = k[H], Ee = k[H + 1] >> 4, _e = k[H + 1] & 15;
                        le < Ee && (le = Ee), ve < _e && (ve = _e);
                        const Te = k[H + 2];
                        se = ne.components.push({
                          h: Ee,
                          v: _e,
                          quantizationId: Te,
                          quantizationTable: null
                        }), ne.componentIds[ce] = se - 1, H += 3;
                      }
                      ne.maxH = le, ne.maxV = ve, D(ne);
                      break;
                    case 65476:
                      const he = (0, y.readUint16)(k, H);
                      for (H += 2, te = 2; te < he; ) {
                        const ce = k[H++], Ee = new Uint8Array(16);
                        let _e = 0;
                        for (ae = 0; ae < 16; ae++, H++)
                          _e += Ee[ae] = k[H];
                        const Te = new Uint8Array(_e);
                        for (ae = 0; ae < _e; ae++, H++)
                          Te[ae] = k[H];
                        te += 17 + _e, (ce >> 4 === 0 ? Q : ee)[ce & 15] = L(Ee, Te);
                      }
                      break;
                    case 65501:
                      H += 2, K = (0, y.readUint16)(k, H), H += 2;
                      break;
                    case 65498:
                      const ye = ++q === 1 && !N;
                      H += 2;
                      const Ce = k[H++], xe = [];
                      for (te = 0; te < Ce; te++) {
                        const ce = k[H++], Ee = ne.componentIds[ce], _e = ne.components[Ee];
                        _e.index = ce;
                        const Te = k[H++];
                        _e.huffmanTableDC = Q[Te >> 4], _e.huffmanTableAC = ee[Te & 15], xe.push(_e);
                      }
                      const we = k[H++], $e = k[H++], Ae = k[H++];
                      try {
                        const ce = F(k, H, ne, xe, K, we, $e, Ae >> 4, Ae & 15, ye);
                        H += ce;
                      } catch (ce) {
                        if (ce instanceof m)
                          return (0, g.warn)(`${ce.message} -- attempting to re-parse the JPEG image.`), this.parse(k, {
                            dnlScanLines: ce.scanLines
                          });
                        if (ce instanceof C) {
                          (0, g.warn)(`${ce.message} -- ignoring the rest of the image data.`);
                          break e;
                        }
                        throw ce;
                      }
                      break;
                    case 65500:
                      H += 4;
                      break;
                    case 65535:
                      k[H] !== 255 && H--;
                      break;
                    default:
                      const ue = j(k, H - 2, H - 3);
                      if (ue?.invalid) {
                        (0, g.warn)("JpegImage.parse - unexpected data, current marker is: " + ue.invalid), H = ue.offset;
                        break;
                      }
                      if (!ue || H >= k.length - 1) {
                        (0, g.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                        break e;
                      }
                      throw new f("JpegImage.parse - unknown marker: " + J.toString(16));
                  }
                  J = (0, y.readUint16)(k, H), H += 2;
                }
                this.width = ne.samplesPerLine, this.height = ne.scanLines, this.jfif = V, this.adobe = Z, this.components = [];
                for (const te of ne.components) {
                  const ae = Y[te.quantizationId];
                  ae && (te.quantizationTable = ae), this.components.push({
                    index: te.index,
                    output: W(ne, te),
                    scaleX: te.h / ne.maxH,
                    scaleY: te.v / ne.maxV,
                    blocksPerLine: te.blocksPerLine,
                    blocksPerColumn: te.blocksPerColumn
                  });
                }
                this.numComponents = this.components.length;
              }
              _getLinearizedBlockData(k, N, P = !1) {
                const D = this.width / k, H = this.height / N;
                let V, Z, ne, K, q, Y, ee, Q, J, te, ae = 0, se;
                const ie = this.components.length, fe = k * N * ie, ge = new Uint8ClampedArray(fe), me = new Uint32Array(k), pe = 4294967288;
                let be;
                for (ee = 0; ee < ie; ee++) {
                  if (V = this.components[ee], Z = V.scaleX * D, ne = V.scaleY * H, ae = ee, se = V.output, K = V.blocksPerLine + 1 << 3, Z !== be) {
                    for (q = 0; q < k; q++)
                      Q = 0 | q * Z, me[q] = (Q & pe) << 3 | Q & 7;
                    be = Z;
                  }
                  for (Y = 0; Y < N; Y++)
                    for (Q = 0 | Y * ne, te = K * (Q & pe) | (Q & 7) << 3, q = 0; q < k; q++)
                      ge[ae] = se[te + me[q]], ae += ie;
                }
                let le = this._decodeTransform;
                if (!P && ie === 4 && !le && (le = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255])), le)
                  for (ee = 0; ee < fe; )
                    for (Q = 0, J = 0; Q < ie; Q++, ee++, J += 2)
                      ge[ee] = (ge[ee] * le[J] >> 8) + le[J + 1];
                return ge;
              }
              get _isColorConversionNeeded() {
                return this.adobe ? !!this.adobe.transformCode : this.numComponents === 3 ? this._colorTransform === 0 ? !1 : !(this.components[0].index === 82 && this.components[1].index === 71 && this.components[2].index === 66) : this._colorTransform === 1;
              }
              _convertYccToRgb(k) {
                let N, P, D;
                for (let H = 0, V = k.length; H < V; H += 3)
                  N = k[H], P = k[H + 1], D = k[H + 2], k[H] = N - 179.456 + 1.402 * D, k[H + 1] = N + 135.459 - 0.344 * P - 0.714 * D, k[H + 2] = N - 226.816 + 1.772 * P;
                return k;
              }
              _convertYccToRgba(k, N) {
                for (let P = 0, D = 0, H = k.length; P < H; P += 3, D += 4) {
                  const V = k[P], Z = k[P + 1], ne = k[P + 2];
                  N[D] = V - 179.456 + 1.402 * ne, N[D + 1] = V + 135.459 - 0.344 * Z - 0.714 * ne, N[D + 2] = V - 226.816 + 1.772 * Z, N[D + 3] = 255;
                }
                return N;
              }
              _convertYcckToRgb(k) {
                let N, P, D, H, V = 0;
                for (let Z = 0, ne = k.length; Z < ne; Z += 4)
                  N = k[Z], P = k[Z + 1], D = k[Z + 2], H = k[Z + 3], k[V++] = -122.67195406894 + P * (-660635669420364e-19 * P + 437130475926232e-18 * D - 54080610064599e-18 * N + 48449797120281e-17 * H - 0.154362151871126) + D * (-957964378445773e-18 * D + 817076911346625e-18 * N - 0.00477271405408747 * H + 1.53380253221734) + N * (961250184130688e-18 * N - 0.00266257332283933 * H + 0.48357088451265) + H * (-336197177618394e-18 * H + 0.484791561490776), k[V++] = 107.268039397724 + P * (219927104525741e-19 * P - 640992018297945e-18 * D + 659397001245577e-18 * N + 426105652938837e-18 * H - 0.176491792462875) + D * (-778269941513683e-18 * D + 0.00130872261408275 * N + 770482631801132e-18 * H - 0.151051492775562) + N * (0.00126935368114843 * N - 0.00265090189010898 * H + 0.25802910206845) + H * (-318913117588328e-18 * H - 0.213742400323665), k[V++] = -20.810012546947 + P * (-570115196973677e-18 * P - 263409051004589e-19 * D + 0.0020741088115012 * N - 0.00288260236853442 * H + 0.814272968359295) + D * (-153496057440975e-19 * D - 132689043961446e-18 * N + 560833691242812e-18 * H - 0.195152027534049) + N * (0.00174418132927582 * N - 0.00255243321439347 * H + 0.116935020465145) + H * (-343531996510555e-18 * H + 0.24165260232407);
                return k.subarray(0, V);
              }
              _convertYcckToRgba(k) {
                for (let N = 0, P = k.length; N < P; N += 4) {
                  const D = k[N], H = k[N + 1], V = k[N + 2], Z = k[N + 3];
                  k[N] = -122.67195406894 + H * (-660635669420364e-19 * H + 437130475926232e-18 * V - 54080610064599e-18 * D + 48449797120281e-17 * Z - 0.154362151871126) + V * (-957964378445773e-18 * V + 817076911346625e-18 * D - 0.00477271405408747 * Z + 1.53380253221734) + D * (961250184130688e-18 * D - 0.00266257332283933 * Z + 0.48357088451265) + Z * (-336197177618394e-18 * Z + 0.484791561490776), k[N + 1] = 107.268039397724 + H * (219927104525741e-19 * H - 640992018297945e-18 * V + 659397001245577e-18 * D + 426105652938837e-18 * Z - 0.176491792462875) + V * (-778269941513683e-18 * V + 0.00130872261408275 * D + 770482631801132e-18 * Z - 0.151051492775562) + D * (0.00126935368114843 * D - 0.00265090189010898 * Z + 0.25802910206845) + Z * (-318913117588328e-18 * Z - 0.213742400323665), k[N + 2] = -20.810012546947 + H * (-570115196973677e-18 * H - 263409051004589e-19 * V + 0.0020741088115012 * D - 0.00288260236853442 * Z + 0.814272968359295) + V * (-153496057440975e-19 * V - 132689043961446e-18 * D + 560833691242812e-18 * Z - 0.195152027534049) + D * (0.00174418132927582 * D - 0.00255243321439347 * Z + 0.116935020465145) + Z * (-343531996510555e-18 * Z + 0.24165260232407), k[N + 3] = 255;
                }
                return k;
              }
              _convertYcckToCmyk(k) {
                let N, P, D;
                for (let H = 0, V = k.length; H < V; H += 4)
                  N = k[H], P = k[H + 1], D = k[H + 2], k[H] = 434.456 - N - 1.402 * D, k[H + 1] = 119.541 - N + 0.344 * P + 0.714 * D, k[H + 2] = 481.816 - N - 1.772 * P;
                return k;
              }
              _convertCmykToRgb(k) {
                let N, P, D, H, V = 0;
                for (let Z = 0, ne = k.length; Z < ne; Z += 4)
                  N = k[Z], P = k[Z + 1], D = k[Z + 2], H = k[Z + 3], k[V++] = 255 + N * (-6747147073602441e-20 * N + 8379262121013727e-19 * P + 2894718188643294e-19 * D + 0.003264231057537806 * H - 1.1185611867203937) + P * (26374107616089405e-21 * P - 8626949158638572e-20 * D - 2748769067499491e-19 * H - 0.02155688794978967) + D * (-3878099212869363e-20 * D - 3267808279485286e-19 * H + 0.0686742238595345) - H * (3361971776183937e-19 * H + 0.7430659151342254), k[V++] = 255 + N * (13596372813588848e-20 * N + 924537132573585e-18 * P + 10567359618683593e-20 * D + 4791864687436512e-19 * H - 0.3109689587515875) + P * (-23545346108370344e-20 * P + 2702845253534714e-19 * D + 0.0020200308977307156 * H - 0.7488052167015494) + D * (6834815998235662e-20 * D + 15168452363460973e-20 * H - 0.09751927774728933) - H * (3189131175883281e-19 * H + 0.7364883807733168), k[V++] = 255 + N * (13598650411385307e-21 * N + 12423956175490851e-20 * P + 4751985097583589e-19 * D - 36729317476630422e-22 * H - 0.05562186980264034) + P * (16141380598724676e-20 * P + 9692239130725186e-19 * D + 7782692450036253e-19 * H - 0.44015232367526463) + D * (5068882914068769e-22 * D + 0.0017778369011375071 * H - 0.7591454649749609) - H * (3435319965105553e-19 * H + 0.7063770186160144);
                return k.subarray(0, V);
              }
              _convertCmykToRgba(k) {
                for (let N = 0, P = k.length; N < P; N += 4) {
                  const D = k[N], H = k[N + 1], V = k[N + 2], Z = k[N + 3];
                  k[N] = 255 + D * (-6747147073602441e-20 * D + 8379262121013727e-19 * H + 2894718188643294e-19 * V + 0.003264231057537806 * Z - 1.1185611867203937) + H * (26374107616089405e-21 * H - 8626949158638572e-20 * V - 2748769067499491e-19 * Z - 0.02155688794978967) + V * (-3878099212869363e-20 * V - 3267808279485286e-19 * Z + 0.0686742238595345) - Z * (3361971776183937e-19 * Z + 0.7430659151342254), k[N + 1] = 255 + D * (13596372813588848e-20 * D + 924537132573585e-18 * H + 10567359618683593e-20 * V + 4791864687436512e-19 * Z - 0.3109689587515875) + H * (-23545346108370344e-20 * H + 2702845253534714e-19 * V + 0.0020200308977307156 * Z - 0.7488052167015494) + V * (6834815998235662e-20 * V + 15168452363460973e-20 * Z - 0.09751927774728933) - Z * (3189131175883281e-19 * Z + 0.7364883807733168), k[N + 2] = 255 + D * (13598650411385307e-21 * D + 12423956175490851e-20 * H + 4751985097583589e-19 * V - 36729317476630422e-22 * Z - 0.05562186980264034) + H * (16141380598724676e-20 * H + 9692239130725186e-19 * V + 7782692450036253e-19 * Z - 0.44015232367526463) + V * (5068882914068769e-22 * V + 0.0017778369011375071 * Z - 0.7591454649749609) - Z * (3435319965105553e-19 * Z + 0.7063770186160144), k[N + 3] = 255;
                }
                return k;
              }
              getData({
                width: k,
                height: N,
                forceRGBA: P = !1,
                forceRGB: D = !1,
                isSourcePDF: H = !1
              }) {
                if (this.numComponents > 4)
                  throw new f("Unsupported color mode");
                const V = this._getLinearizedBlockData(k, N, H);
                if (this.numComponents === 1 && (P || D)) {
                  const Z = V.length * (P ? 4 : 3), ne = new Uint8ClampedArray(Z);
                  let K = 0;
                  if (P)
                    (0, b.grayToRGBA)(V, new Uint32Array(ne.buffer));
                  else
                    for (const q of V)
                      ne[K++] = q, ne[K++] = q, ne[K++] = q;
                  return ne;
                } else if (this.numComponents === 3 && this._isColorConversionNeeded) {
                  if (P) {
                    const Z = new Uint8ClampedArray(V.length / 3 * 4);
                    return this._convertYccToRgba(V, Z);
                  }
                  return this._convertYccToRgb(V);
                } else if (this.numComponents === 4) {
                  if (this._isColorConversionNeeded)
                    return P ? this._convertYcckToRgba(V) : D ? this._convertYcckToRgb(V) : this._convertYcckToCmyk(V);
                  if (P)
                    return this._convertCmykToRgba(V);
                  if (D)
                    return this._convertCmykToRgb(V);
                }
                return V;
              }
            }
            A.JpegImage = G;
          },
          /* 28 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.convertBlackAndWhiteToRGBA = y, A.convertToRGBA = b, A.grayToRGBA = m;
            var g = x(2);
            function b(C) {
              switch (C.kind) {
                case g.ImageKind.GRAYSCALE_1BPP:
                  return y(C);
                case g.ImageKind.RGB_24BPP:
                  return f(C);
              }
              return null;
            }
            function y({
              src: C,
              srcPos: w = 0,
              dest: S,
              width: $,
              height: T,
              nonBlackColor: I = 4294967295,
              inverseDecode: _ = !1
            }) {
              const E = g.FeatureTest.isLittleEndian ? 4278190080 : 255, [R, O] = _ ? [I, E] : [E, I], L = $ >> 3, B = $ & 7, F = C.length;
              S = new Uint32Array(S.buffer);
              let M = 0;
              for (let W = 0; W < T; W++) {
                for (const G = w + L; w < G; w++) {
                  const U = w < F ? C[w] : 255;
                  S[M++] = U & 128 ? O : R, S[M++] = U & 64 ? O : R, S[M++] = U & 32 ? O : R, S[M++] = U & 16 ? O : R, S[M++] = U & 8 ? O : R, S[M++] = U & 4 ? O : R, S[M++] = U & 2 ? O : R, S[M++] = U & 1 ? O : R;
                }
                if (B === 0)
                  continue;
                const j = w < F ? C[w++] : 255;
                for (let G = 0; G < B; G++)
                  S[M++] = j & 1 << 7 - G ? O : R;
              }
              return {
                srcPos: w,
                destPos: M
              };
            }
            function f({
              src: C,
              srcPos: w = 0,
              dest: S,
              destPos: $ = 0,
              width: T,
              height: I
            }) {
              let _ = 0;
              const E = C.length >> 2, R = new Uint32Array(C.buffer, w, E);
              if (g.FeatureTest.isLittleEndian) {
                for (; _ < E - 2; _ += 3, $ += 4) {
                  const O = R[_], L = R[_ + 1], B = R[_ + 2];
                  S[$] = O | 4278190080, S[$ + 1] = O >>> 24 | L << 8 | 4278190080, S[$ + 2] = L >>> 16 | B << 16 | 4278190080, S[$ + 3] = B >>> 8 | 4278190080;
                }
                for (let O = _ * 4, L = C.length; O < L; O += 3)
                  S[$++] = C[O] | C[O + 1] << 8 | C[O + 2] << 16 | 4278190080;
              } else {
                for (; _ < E - 2; _ += 3, $ += 4) {
                  const O = R[_], L = R[_ + 1], B = R[_ + 2];
                  S[$] = O | 255, S[$ + 1] = O << 24 | L >>> 8 | 255, S[$ + 2] = L << 16 | B >>> 16 | 255, S[$ + 3] = B << 8 | 255;
                }
                for (let O = _ * 4, L = C.length; O < L; O += 3)
                  S[$++] = C[O] << 24 | C[O + 1] << 16 | C[O + 2] << 8 | 255;
              }
              return {
                srcPos: w,
                destPos: $
              };
            }
            function m(C, w) {
              if (g.FeatureTest.isLittleEndian)
                for (let S = 0, $ = C.length; S < $; S++)
                  w[S] = C[S] * 65793 | 4278190080;
              else
                for (let S = 0, $ = C.length; S < $; S++)
                  w[S] = C[S] * 16843008 | 255;
            }
          },
          /* 29 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.JpxStream = void 0;
            var g = x(18), b = x(30), y = x(2);
            class f extends g.DecodeStream {
              constructor(C, w, S) {
                super(w), this.stream = C, this.dict = C.dict, this.maybeLength = w, this.params = S;
              }
              get bytes() {
                return (0, y.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
              }
              ensureBuffer(C) {
              }
              readBlock() {
                if (this.eof)
                  return;
                const C = new b.JpxImage();
                C.parse(this.bytes);
                const w = C.width, S = C.height, $ = C.componentsCount, T = C.tiles.length;
                if (T === 1)
                  this.buffer = C.tiles[0].items;
                else {
                  const I = new Uint8ClampedArray(w * S * $);
                  for (let _ = 0; _ < T; _++) {
                    const E = C.tiles[_], R = E.width, O = E.height, L = E.left, B = E.top, F = E.items;
                    let M = 0, W = (w * B + L) * $;
                    const j = w * $, G = R * $;
                    for (let U = 0; U < O; U++) {
                      const k = F.subarray(M, M + G);
                      I.set(k, W), M += G, W += j;
                    }
                  }
                  this.buffer = I;
                }
                this.bufferLength = this.buffer.length, this.eof = !0;
              }
            }
            A.JpxStream = f;
          },
          /* 30 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.JpxImage = void 0;
            var g = x(2), b = x(3), y = x(25);
            class f extends g.BaseException {
              constructor(q) {
                super(`JPX error: ${q}`, "JpxError");
              }
            }
            const m = {
              LL: 0,
              LH: 1,
              HL: 1,
              HH: 2
            };
            class C {
              constructor() {
                this.failOnCorruptedImage = !1;
              }
              parse(q) {
                if ((0, b.readUint16)(q, 0) === 65359) {
                  this.parseCodestream(q, 0, q.length);
                  return;
                }
                const ee = q.length;
                let Q = 0;
                for (; Q < ee; ) {
                  let J = 8, te = (0, b.readUint32)(q, Q);
                  const ae = (0, b.readUint32)(q, Q + 4);
                  if (Q += J, te === 1 && (te = (0, b.readUint32)(q, Q) * 4294967296 + (0, b.readUint32)(q, Q + 4), Q += 8, J += 8), te === 0 && (te = ee - Q + J), te < J)
                    throw new f("Invalid box field size");
                  const se = te - J;
                  let ie = !0;
                  switch (ae) {
                    case 1785737832:
                      ie = !1;
                      break;
                    case 1668246642:
                      const fe = q[Q];
                      if (fe === 1) {
                        const me = (0, b.readUint32)(q, Q + 3);
                        switch (me) {
                          case 16:
                          case 17:
                          case 18:
                            break;
                          default:
                            (0, g.warn)("Unknown colorspace " + me);
                            break;
                        }
                      } else fe === 2 && (0, g.info)("ICC profile not supported");
                      break;
                    case 1785737827:
                      this.parseCodestream(q, Q, Q + se);
                      break;
                    case 1783636e3:
                      (0, b.readUint32)(q, Q) !== 218793738 && (0, g.warn)("Invalid JP2 signature");
                      break;
                    case 1783634458:
                    case 1718909296:
                    case 1920099697:
                    case 1919251232:
                    case 1768449138:
                      break;
                    default:
                      const ge = String.fromCharCode(ae >> 24 & 255, ae >> 16 & 255, ae >> 8 & 255, ae & 255);
                      (0, g.warn)(`Unsupported header type ${ae} (${ge}).`);
                      break;
                  }
                  ie && (Q += se);
                }
              }
              parseImageProperties(q) {
                let Y = q.getByte();
                for (; Y >= 0; ) {
                  const ee = Y;
                  if (Y = q.getByte(), (ee << 8 | Y) === 65361) {
                    q.skip(4);
                    const J = q.getInt32() >>> 0, te = q.getInt32() >>> 0, ae = q.getInt32() >>> 0, se = q.getInt32() >>> 0;
                    q.skip(16);
                    const ie = q.getUint16();
                    this.width = J - ae, this.height = te - se, this.componentsCount = ie, this.bitsPerComponent = 8;
                    return;
                  }
                }
                throw new f("No size marker found in JPX stream");
              }
              parseCodestream(q, Y, ee) {
                const Q = {};
                let J = !1;
                try {
                  let te = Y;
                  for (; te + 1 < ee; ) {
                    const ae = (0, b.readUint16)(q, te);
                    te += 2;
                    let se = 0, ie, fe, ge, me, pe, be;
                    switch (ae) {
                      case 65359:
                        Q.mainHeader = !0;
                        break;
                      case 65497:
                        break;
                      case 65361:
                        se = (0, b.readUint16)(q, te);
                        const le = {};
                        le.Xsiz = (0, b.readUint32)(q, te + 4), le.Ysiz = (0, b.readUint32)(q, te + 8), le.XOsiz = (0, b.readUint32)(q, te + 12), le.YOsiz = (0, b.readUint32)(q, te + 16), le.XTsiz = (0, b.readUint32)(q, te + 20), le.YTsiz = (0, b.readUint32)(q, te + 24), le.XTOsiz = (0, b.readUint32)(q, te + 28), le.YTOsiz = (0, b.readUint32)(q, te + 32);
                        const ve = (0, b.readUint16)(q, te + 36);
                        le.Csiz = ve;
                        const he = [];
                        ie = te + 38;
                        for (let ce = 0; ce < ve; ce++) {
                          const Ee = {
                            precision: (q[ie] & 127) + 1,
                            isSigned: !!(q[ie] & 128),
                            XRsiz: q[ie + 1],
                            YRsiz: q[ie + 2]
                          };
                          ie += 3, w(Ee, le), he.push(Ee);
                        }
                        Q.SIZ = le, Q.components = he, S(Q, he), Q.QCC = [], Q.COC = [];
                        break;
                      case 65372:
                        se = (0, b.readUint16)(q, te);
                        const ye = {};
                        switch (ie = te + 2, fe = q[ie++], fe & 31) {
                          case 0:
                            me = 8, pe = !0;
                            break;
                          case 1:
                            me = 16, pe = !1;
                            break;
                          case 2:
                            me = 16, pe = !0;
                            break;
                          default:
                            throw new Error("Invalid SQcd value " + fe);
                        }
                        for (ye.noQuantization = me === 8, ye.scalarExpounded = pe, ye.guardBits = fe >> 5, ge = []; ie < se + te; ) {
                          const ce = {};
                          me === 8 ? (ce.epsilon = q[ie++] >> 3, ce.mu = 0) : (ce.epsilon = q[ie] >> 3, ce.mu = (q[ie] & 7) << 8 | q[ie + 1], ie += 2), ge.push(ce);
                        }
                        ye.SPqcds = ge, Q.mainHeader ? Q.QCD = ye : (Q.currentTile.QCD = ye, Q.currentTile.QCC = []);
                        break;
                      case 65373:
                        se = (0, b.readUint16)(q, te);
                        const Ce = {};
                        ie = te + 2;
                        let xe;
                        switch (Q.SIZ.Csiz < 257 ? xe = q[ie++] : (xe = (0, b.readUint16)(q, ie), ie += 2), fe = q[ie++], fe & 31) {
                          case 0:
                            me = 8, pe = !0;
                            break;
                          case 1:
                            me = 16, pe = !1;
                            break;
                          case 2:
                            me = 16, pe = !0;
                            break;
                          default:
                            throw new Error("Invalid SQcd value " + fe);
                        }
                        for (Ce.noQuantization = me === 8, Ce.scalarExpounded = pe, Ce.guardBits = fe >> 5, ge = []; ie < se + te; ) {
                          const ce = {};
                          me === 8 ? (ce.epsilon = q[ie++] >> 3, ce.mu = 0) : (ce.epsilon = q[ie] >> 3, ce.mu = (q[ie] & 7) << 8 | q[ie + 1], ie += 2), ge.push(ce);
                        }
                        Ce.SPqcds = ge, Q.mainHeader ? Q.QCC[xe] = Ce : Q.currentTile.QCC[xe] = Ce;
                        break;
                      case 65362:
                        se = (0, b.readUint16)(q, te);
                        const we = {};
                        ie = te + 2;
                        const $e = q[ie++];
                        we.entropyCoderWithCustomPrecincts = !!($e & 1), we.sopMarkerUsed = !!($e & 2), we.ephMarkerUsed = !!($e & 4), we.progressionOrder = q[ie++], we.layersCount = (0, b.readUint16)(q, ie), ie += 2, we.multipleComponentTransform = q[ie++], we.decompositionLevelsCount = q[ie++], we.xcb = (q[ie++] & 15) + 2, we.ycb = (q[ie++] & 15) + 2;
                        const Ae = q[ie++];
                        if (we.selectiveArithmeticCodingBypass = !!(Ae & 1), we.resetContextProbabilities = !!(Ae & 2), we.terminationOnEachCodingPass = !!(Ae & 4), we.verticallyStripe = !!(Ae & 8), we.predictableTermination = !!(Ae & 16), we.segmentationSymbolUsed = !!(Ae & 32), we.reversibleTransformation = q[ie++], we.entropyCoderWithCustomPrecincts) {
                          const ce = [];
                          for (; ie < se + te; ) {
                            const Ee = q[ie++];
                            ce.push({
                              PPx: Ee & 15,
                              PPy: Ee >> 4
                            });
                          }
                          we.precinctsSizes = ce;
                        }
                        const ue = [];
                        we.selectiveArithmeticCodingBypass && ue.push("selectiveArithmeticCodingBypass"), we.terminationOnEachCodingPass && ue.push("terminationOnEachCodingPass"), we.verticallyStripe && ue.push("verticallyStripe"), we.predictableTermination && ue.push("predictableTermination"), ue.length > 0 && (J = !0, (0, g.warn)(`JPX: Unsupported COD options (${ue.join(", ")}).`)), Q.mainHeader ? Q.COD = we : (Q.currentTile.COD = we, Q.currentTile.COC = []);
                        break;
                      case 65424:
                        se = (0, b.readUint16)(q, te), be = {}, be.index = (0, b.readUint16)(q, te + 2), be.length = (0, b.readUint32)(q, te + 4), be.dataEnd = be.length + te - 2, be.partIndex = q[te + 8], be.partsCount = q[te + 9], Q.mainHeader = !1, be.partIndex === 0 && (be.COD = Q.COD, be.COC = Q.COC.slice(0), be.QCD = Q.QCD, be.QCC = Q.QCC.slice(0)), Q.currentTile = be;
                        break;
                      case 65427:
                        be = Q.currentTile, be.partIndex === 0 && (N(Q, be.index), W(Q)), se = be.dataEnd - te, j(Q, q, te, se);
                        break;
                      case 65363:
                        (0, g.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                      case 65365:
                      case 65367:
                      case 65368:
                      case 65380:
                        se = (0, b.readUint16)(q, te);
                        break;
                      default:
                        throw new Error("Unknown codestream code: " + ae.toString(16));
                    }
                    te += se;
                  }
                } catch (te) {
                  if (J || this.failOnCorruptedImage)
                    throw new f(te.message);
                  (0, g.warn)(`JPX: Trying to recover from: "${te.message}".`);
                }
                this.tiles = k(Q), this.width = Q.SIZ.Xsiz - Q.SIZ.XOsiz, this.height = Q.SIZ.Ysiz - Q.SIZ.YOsiz, this.componentsCount = Q.SIZ.Csiz;
              }
            }
            A.JpxImage = C;
            function w(K, q) {
              K.x0 = Math.ceil(q.XOsiz / K.XRsiz), K.x1 = Math.ceil(q.Xsiz / K.XRsiz), K.y0 = Math.ceil(q.YOsiz / K.YRsiz), K.y1 = Math.ceil(q.Ysiz / K.YRsiz), K.width = K.x1 - K.x0, K.height = K.y1 - K.y0;
            }
            function S(K, q) {
              const Y = K.SIZ, ee = [];
              let Q;
              const J = Math.ceil((Y.Xsiz - Y.XTOsiz) / Y.XTsiz), te = Math.ceil((Y.Ysiz - Y.YTOsiz) / Y.YTsiz);
              for (let se = 0; se < te; se++)
                for (let ie = 0; ie < J; ie++)
                  Q = {}, Q.tx0 = Math.max(Y.XTOsiz + ie * Y.XTsiz, Y.XOsiz), Q.ty0 = Math.max(Y.YTOsiz + se * Y.YTsiz, Y.YOsiz), Q.tx1 = Math.min(Y.XTOsiz + (ie + 1) * Y.XTsiz, Y.Xsiz), Q.ty1 = Math.min(Y.YTOsiz + (se + 1) * Y.YTsiz, Y.Ysiz), Q.width = Q.tx1 - Q.tx0, Q.height = Q.ty1 - Q.ty0, Q.components = [], ee.push(Q);
              K.tiles = ee;
              const ae = Y.Csiz;
              for (let se = 0, ie = ae; se < ie; se++) {
                const fe = q[se];
                for (let ge = 0, me = ee.length; ge < me; ge++) {
                  const pe = {};
                  Q = ee[ge], pe.tcx0 = Math.ceil(Q.tx0 / fe.XRsiz), pe.tcy0 = Math.ceil(Q.ty0 / fe.YRsiz), pe.tcx1 = Math.ceil(Q.tx1 / fe.XRsiz), pe.tcy1 = Math.ceil(Q.ty1 / fe.YRsiz), pe.width = pe.tcx1 - pe.tcx0, pe.height = pe.tcy1 - pe.tcy0, Q.components[se] = pe;
                }
              }
            }
            function $(K, q, Y) {
              const ee = q.codingStyleParameters, Q = {};
              return ee.entropyCoderWithCustomPrecincts ? (Q.PPx = ee.precinctsSizes[Y].PPx, Q.PPy = ee.precinctsSizes[Y].PPy) : (Q.PPx = 15, Q.PPy = 15), Q.xcb_ = Y > 0 ? Math.min(ee.xcb, Q.PPx - 1) : Math.min(ee.xcb, Q.PPx), Q.ycb_ = Y > 0 ? Math.min(ee.ycb, Q.PPy - 1) : Math.min(ee.ycb, Q.PPy), Q;
            }
            function T(K, q, Y) {
              const ee = 1 << Y.PPx, Q = 1 << Y.PPy, J = q.resLevel === 0, te = 1 << Y.PPx + (J ? 0 : -1), ae = 1 << Y.PPy + (J ? 0 : -1), se = q.trx1 > q.trx0 ? Math.ceil(q.trx1 / ee) - Math.floor(q.trx0 / ee) : 0, ie = q.try1 > q.try0 ? Math.ceil(q.try1 / Q) - Math.floor(q.try0 / Q) : 0, fe = se * ie;
              q.precinctParameters = {
                precinctWidth: ee,
                precinctHeight: Q,
                numprecinctswide: se,
                numprecinctshigh: ie,
                numprecincts: fe,
                precinctWidthInSubband: te,
                precinctHeightInSubband: ae
              };
            }
            function I(K, q, Y) {
              const ee = Y.xcb_, Q = Y.ycb_, J = 1 << ee, te = 1 << Q, ae = q.tbx0 >> ee, se = q.tby0 >> Q, ie = q.tbx1 + J - 1 >> ee, fe = q.tby1 + te - 1 >> Q, ge = q.resolution.precinctParameters, me = [], pe = [];
              let be, le, ve, he;
              for (le = se; le < fe; le++)
                for (be = ae; be < ie; be++) {
                  ve = {
                    cbx: be,
                    cby: le,
                    tbx0: J * be,
                    tby0: te * le,
                    tbx1: J * (be + 1),
                    tby1: te * (le + 1)
                  }, ve.tbx0_ = Math.max(q.tbx0, ve.tbx0), ve.tby0_ = Math.max(q.tby0, ve.tby0), ve.tbx1_ = Math.min(q.tbx1, ve.tbx1), ve.tby1_ = Math.min(q.tby1, ve.tby1);
                  const ye = Math.floor((ve.tbx0_ - q.tbx0) / ge.precinctWidthInSubband), Ce = Math.floor((ve.tby0_ - q.tby0) / ge.precinctHeightInSubband);
                  if (he = ye + Ce * ge.numprecinctswide, ve.precinctNumber = he, ve.subbandType = q.type, ve.Lblock = 3, ve.tbx1_ <= ve.tbx0_ || ve.tby1_ <= ve.tby0_)
                    continue;
                  me.push(ve);
                  let xe = pe[he];
                  xe !== void 0 ? (be < xe.cbxMin ? xe.cbxMin = be : be > xe.cbxMax && (xe.cbxMax = be), le < xe.cbyMin ? xe.cbxMin = le : le > xe.cbyMax && (xe.cbyMax = le)) : pe[he] = xe = {
                    cbxMin: be,
                    cbyMin: le,
                    cbxMax: be,
                    cbyMax: le
                  }, ve.precinct = xe;
                }
              q.codeblockParameters = {
                codeblockWidth: ee,
                codeblockHeight: Q,
                numcodeblockwide: ie - ae + 1,
                numcodeblockhigh: fe - se + 1
              }, q.codeblocks = me, q.precincts = pe;
            }
            function _(K, q, Y) {
              const ee = [], Q = K.subbands;
              for (let J = 0, te = Q.length; J < te; J++) {
                const se = Q[J].codeblocks;
                for (let ie = 0, fe = se.length; ie < fe; ie++) {
                  const ge = se[ie];
                  ge.precinctNumber === q && ee.push(ge);
                }
              }
              return {
                layerNumber: Y,
                codeblocks: ee
              };
            }
            function E(K) {
              const q = K.SIZ, Y = K.currentTile.index, ee = K.tiles[Y], Q = ee.codingStyleDefaultParameters.layersCount, J = q.Csiz;
              let te = 0;
              for (let ge = 0; ge < J; ge++)
                te = Math.max(te, ee.components[ge].codingStyleParameters.decompositionLevelsCount);
              let ae = 0, se = 0, ie = 0, fe = 0;
              this.nextPacket = function() {
                for (; ae < Q; ae++) {
                  for (; se <= te; se++) {
                    for (; ie < J; ie++) {
                      const me = ee.components[ie];
                      if (se > me.codingStyleParameters.decompositionLevelsCount)
                        continue;
                      const pe = me.resolutions[se], be = pe.precinctParameters.numprecincts;
                      for (; fe < be; ) {
                        const le = _(pe, fe, ae);
                        return fe++, le;
                      }
                      fe = 0;
                    }
                    ie = 0;
                  }
                  se = 0;
                }
                throw new f("Out of packets");
              };
            }
            function R(K) {
              const q = K.SIZ, Y = K.currentTile.index, ee = K.tiles[Y], Q = ee.codingStyleDefaultParameters.layersCount, J = q.Csiz;
              let te = 0;
              for (let ge = 0; ge < J; ge++)
                te = Math.max(te, ee.components[ge].codingStyleParameters.decompositionLevelsCount);
              let ae = 0, se = 0, ie = 0, fe = 0;
              this.nextPacket = function() {
                for (; ae <= te; ae++) {
                  for (; se < Q; se++) {
                    for (; ie < J; ie++) {
                      const me = ee.components[ie];
                      if (ae > me.codingStyleParameters.decompositionLevelsCount)
                        continue;
                      const pe = me.resolutions[ae], be = pe.precinctParameters.numprecincts;
                      for (; fe < be; ) {
                        const le = _(pe, fe, se);
                        return fe++, le;
                      }
                      fe = 0;
                    }
                    ie = 0;
                  }
                  se = 0;
                }
                throw new f("Out of packets");
              };
            }
            function O(K) {
              const q = K.SIZ, Y = K.currentTile.index, ee = K.tiles[Y], Q = ee.codingStyleDefaultParameters.layersCount, J = q.Csiz;
              let te, ae, se, ie, fe = 0;
              for (se = 0; se < J; se++) {
                const me = ee.components[se];
                fe = Math.max(fe, me.codingStyleParameters.decompositionLevelsCount);
              }
              const ge = new Int32Array(fe + 1);
              for (ae = 0; ae <= fe; ++ae) {
                let me = 0;
                for (se = 0; se < J; ++se) {
                  const pe = ee.components[se].resolutions;
                  ae < pe.length && (me = Math.max(me, pe[ae].precinctParameters.numprecincts));
                }
                ge[ae] = me;
              }
              te = 0, ae = 0, se = 0, ie = 0, this.nextPacket = function() {
                for (; ae <= fe; ae++) {
                  for (; ie < ge[ae]; ie++) {
                    for (; se < J; se++) {
                      const pe = ee.components[se];
                      if (ae > pe.codingStyleParameters.decompositionLevelsCount)
                        continue;
                      const be = pe.resolutions[ae], le = be.precinctParameters.numprecincts;
                      if (!(ie >= le)) {
                        for (; te < Q; ) {
                          const ve = _(be, ie, te);
                          return te++, ve;
                        }
                        te = 0;
                      }
                    }
                    se = 0;
                  }
                  ie = 0;
                }
                throw new f("Out of packets");
              };
            }
            function L(K) {
              const q = K.SIZ, Y = K.currentTile.index, ee = K.tiles[Y], Q = ee.codingStyleDefaultParameters.layersCount, J = q.Csiz, te = M(ee), ae = te;
              let se = 0, ie = 0, fe = 0, ge = 0, me = 0;
              this.nextPacket = function() {
                for (; me < ae.maxNumHigh; me++) {
                  for (; ge < ae.maxNumWide; ge++) {
                    for (; fe < J; fe++) {
                      const be = ee.components[fe], le = be.codingStyleParameters.decompositionLevelsCount;
                      for (; ie <= le; ie++) {
                        const ve = be.resolutions[ie], he = te.components[fe].resolutions[ie], ye = F(ge, me, he, ae, ve);
                        if (ye !== null) {
                          for (; se < Q; ) {
                            const Ce = _(ve, ye, se);
                            return se++, Ce;
                          }
                          se = 0;
                        }
                      }
                      ie = 0;
                    }
                    fe = 0;
                  }
                  ge = 0;
                }
                throw new f("Out of packets");
              };
            }
            function B(K) {
              const q = K.SIZ, Y = K.currentTile.index, ee = K.tiles[Y], Q = ee.codingStyleDefaultParameters.layersCount, J = q.Csiz, te = M(ee);
              let ae = 0, se = 0, ie = 0, fe = 0, ge = 0;
              this.nextPacket = function() {
                for (; ie < J; ++ie) {
                  const pe = ee.components[ie], be = te.components[ie], le = pe.codingStyleParameters.decompositionLevelsCount;
                  for (; ge < be.maxNumHigh; ge++) {
                    for (; fe < be.maxNumWide; fe++) {
                      for (; se <= le; se++) {
                        const ve = pe.resolutions[se], he = be.resolutions[se], ye = F(fe, ge, he, be, ve);
                        if (ye !== null) {
                          for (; ae < Q; ) {
                            const Ce = _(ve, ye, ae);
                            return ae++, Ce;
                          }
                          ae = 0;
                        }
                      }
                      se = 0;
                    }
                    fe = 0;
                  }
                  ge = 0;
                }
                throw new f("Out of packets");
              };
            }
            function F(K, q, Y, ee, Q) {
              const J = K * ee.minWidth, te = q * ee.minHeight;
              if (J % Y.width !== 0 || te % Y.height !== 0)
                return null;
              const ae = te / Y.width * Q.precinctParameters.numprecinctswide;
              return J / Y.height + ae;
            }
            function M(K) {
              const q = K.components.length;
              let Y = Number.MAX_VALUE, ee = Number.MAX_VALUE, Q = 0, J = 0;
              const te = new Array(q);
              for (let ae = 0; ae < q; ae++) {
                const se = K.components[ae], ie = se.codingStyleParameters.decompositionLevelsCount, fe = new Array(ie + 1);
                let ge = Number.MAX_VALUE, me = Number.MAX_VALUE, pe = 0, be = 0, le = 1;
                for (let ve = ie; ve >= 0; --ve) {
                  const he = se.resolutions[ve], ye = le * he.precinctParameters.precinctWidth, Ce = le * he.precinctParameters.precinctHeight;
                  ge = Math.min(ge, ye), me = Math.min(me, Ce), pe = Math.max(pe, he.precinctParameters.numprecinctswide), be = Math.max(be, he.precinctParameters.numprecinctshigh), fe[ve] = {
                    width: ye,
                    height: Ce
                  }, le <<= 1;
                }
                Y = Math.min(Y, ge), ee = Math.min(ee, me), Q = Math.max(Q, pe), J = Math.max(J, be), te[ae] = {
                  resolutions: fe,
                  minWidth: ge,
                  minHeight: me,
                  maxNumWide: pe,
                  maxNumHigh: be
                };
              }
              return {
                components: te,
                minWidth: Y,
                minHeight: ee,
                maxNumWide: Q,
                maxNumHigh: J
              };
            }
            function W(K) {
              const q = K.SIZ, Y = K.currentTile.index, ee = K.tiles[Y], Q = q.Csiz;
              for (let te = 0; te < Q; te++) {
                const ae = ee.components[te], se = ae.codingStyleParameters.decompositionLevelsCount, ie = [], fe = [];
                for (let ge = 0; ge <= se; ge++) {
                  const me = $(K, ae, ge), pe = {}, be = 1 << se - ge;
                  pe.trx0 = Math.ceil(ae.tcx0 / be), pe.try0 = Math.ceil(ae.tcy0 / be), pe.trx1 = Math.ceil(ae.tcx1 / be), pe.try1 = Math.ceil(ae.tcy1 / be), pe.resLevel = ge, T(K, pe, me), ie.push(pe);
                  let le;
                  if (ge === 0)
                    le = {}, le.type = "LL", le.tbx0 = Math.ceil(ae.tcx0 / be), le.tby0 = Math.ceil(ae.tcy0 / be), le.tbx1 = Math.ceil(ae.tcx1 / be), le.tby1 = Math.ceil(ae.tcy1 / be), le.resolution = pe, I(K, le, me), fe.push(le), pe.subbands = [le];
                  else {
                    const ve = 1 << se - ge + 1, he = [];
                    le = {}, le.type = "HL", le.tbx0 = Math.ceil(ae.tcx0 / ve - 0.5), le.tby0 = Math.ceil(ae.tcy0 / ve), le.tbx1 = Math.ceil(ae.tcx1 / ve - 0.5), le.tby1 = Math.ceil(ae.tcy1 / ve), le.resolution = pe, I(K, le, me), fe.push(le), he.push(le), le = {}, le.type = "LH", le.tbx0 = Math.ceil(ae.tcx0 / ve), le.tby0 = Math.ceil(ae.tcy0 / ve - 0.5), le.tbx1 = Math.ceil(ae.tcx1 / ve), le.tby1 = Math.ceil(ae.tcy1 / ve - 0.5), le.resolution = pe, I(K, le, me), fe.push(le), he.push(le), le = {}, le.type = "HH", le.tbx0 = Math.ceil(ae.tcx0 / ve - 0.5), le.tby0 = Math.ceil(ae.tcy0 / ve - 0.5), le.tbx1 = Math.ceil(ae.tcx1 / ve - 0.5), le.tby1 = Math.ceil(ae.tcy1 / ve - 0.5), le.resolution = pe, I(K, le, me), fe.push(le), he.push(le), pe.subbands = he;
                  }
                }
                ae.resolutions = ie, ae.subbands = fe;
              }
              const J = ee.codingStyleDefaultParameters.progressionOrder;
              switch (J) {
                case 0:
                  ee.packetsIterator = new E(K);
                  break;
                case 1:
                  ee.packetsIterator = new R(K);
                  break;
                case 2:
                  ee.packetsIterator = new O(K);
                  break;
                case 3:
                  ee.packetsIterator = new L(K);
                  break;
                case 4:
                  ee.packetsIterator = new B(K);
                  break;
                default:
                  throw new f(`Unsupported progression order ${J}`);
              }
            }
            function j(K, q, Y, ee) {
              let Q = 0, J, te = 0, ae = !1;
              function se(ye) {
                for (; te < ye; ) {
                  const Ce = q[Y + Q];
                  Q++, ae ? (J = J << 7 | Ce, te += 7, ae = !1) : (J = J << 8 | Ce, te += 8), Ce === 255 && (ae = !0);
                }
                return te -= ye, J >>> te & (1 << ye) - 1;
              }
              function ie(ye) {
                return q[Y + Q - 1] === 255 && q[Y + Q] === ye ? (fe(1), !0) : q[Y + Q] === 255 && q[Y + Q + 1] === ye ? (fe(2), !0) : !1;
              }
              function fe(ye) {
                Q += ye;
              }
              function ge() {
                te = 0, ae && (Q++, ae = !1);
              }
              function me() {
                if (se(1) === 0)
                  return 1;
                if (se(1) === 0)
                  return 2;
                let ye = se(2);
                return ye < 3 ? ye + 3 : (ye = se(5), ye < 31 ? ye + 6 : (ye = se(7), ye + 37));
              }
              const pe = K.currentTile.index, be = K.tiles[pe], le = K.COD.sopMarkerUsed, ve = K.COD.ephMarkerUsed, he = be.packetsIterator;
              for (; Q < ee; ) {
                ge(), le && ie(145) && fe(4);
                const ye = he.nextPacket();
                if (!se(1))
                  continue;
                const Ce = ye.layerNumber, xe = [];
                let we;
                for (let $e = 0, Ae = ye.codeblocks.length; $e < Ae; $e++) {
                  we = ye.codeblocks[$e];
                  let ue = we.precinct;
                  const ce = we.cbx - ue.cbxMin, Ee = we.cby - ue.cbyMin;
                  let _e = !1, Te = !1, ke, Re;
                  if (we.included !== void 0)
                    _e = !!se(1);
                  else {
                    ue = we.precinct;
                    let Ue;
                    if (ue.inclusionTree !== void 0)
                      Ue = ue.inclusionTree;
                    else {
                      const je = ue.cbxMax - ue.cbxMin + 1, Le = ue.cbyMax - ue.cbyMin + 1;
                      Ue = new D(je, Le, Ce), Re = new P(je, Le), ue.inclusionTree = Ue, ue.zeroBitPlanesTree = Re;
                      for (let De = 0; De < Ce; De++)
                        if (se(1) !== 0)
                          throw new f("Invalid tag tree");
                    }
                    if (Ue.reset(ce, Ee, Ce))
                      for (; ; )
                        if (se(1)) {
                          if (ke = !Ue.nextLevel(), ke) {
                            we.included = !0, _e = Te = !0;
                            break;
                          }
                        } else {
                          Ue.incrementValue(Ce);
                          break;
                        }
                  }
                  if (!_e)
                    continue;
                  if (Te) {
                    for (Re = ue.zeroBitPlanesTree, Re.reset(ce, Ee); ; )
                      if (se(1)) {
                        if (ke = !Re.nextLevel(), ke)
                          break;
                      } else
                        Re.incrementValue();
                    we.zeroBitPlanes = Re.value;
                  }
                  const Be = me();
                  for (; se(1); )
                    we.Lblock++;
                  const Oe = (0, b.log2)(Be), Me = (Be < 1 << Oe ? Oe - 1 : Oe) + we.Lblock, Fe = se(Me);
                  xe.push({
                    codeblock: we,
                    codingpasses: Be,
                    dataLength: Fe
                  });
                }
                for (ge(), ve && ie(146); xe.length > 0; ) {
                  const $e = xe.shift();
                  we = $e.codeblock, we.data === void 0 && (we.data = []), we.data.push({
                    data: q,
                    start: Y + Q,
                    end: Y + Q + $e.dataLength,
                    codingpasses: $e.codingpasses
                  }), Q += $e.dataLength;
                }
              }
              return Q;
            }
            function G(K, q, Y, ee, Q, J, te, ae, se) {
              const ie = ee.tbx0, fe = ee.tby0, ge = ee.tbx1 - ee.tbx0, me = ee.codeblocks, pe = ee.type.charAt(0) === "H" ? 1 : 0, be = ee.type.charAt(1) === "H" ? q : 0;
              for (let le = 0, ve = me.length; le < ve; ++le) {
                const he = me[le], ye = he.tbx1_ - he.tbx0_, Ce = he.tby1_ - he.tby0_;
                if (ye === 0 || Ce === 0 || he.data === void 0)
                  continue;
                const xe = new H(ye, Ce, he.subbandType, he.zeroBitPlanes, J);
                let we = 2;
                const $e = he.data;
                let Ae = 0, ue = 0, ce, Ee, _e;
                for (ce = 0, Ee = $e.length; ce < Ee; ce++)
                  _e = $e[ce], Ae += _e.end - _e.start, ue += _e.codingpasses;
                const Te = new Uint8Array(Ae);
                let ke = 0;
                for (ce = 0, Ee = $e.length; ce < Ee; ce++) {
                  _e = $e[ce];
                  const Ge = _e.data.subarray(_e.start, _e.end);
                  Te.set(Ge, ke), ke += Ge.length;
                }
                const Re = new y.ArithmeticDecoder(Te, 0, Ae);
                for (xe.setDecoder(Re), ce = 0; ce < ue; ce++) {
                  switch (we) {
                    case 0:
                      xe.runSignificancePropagationPass();
                      break;
                    case 1:
                      xe.runMagnitudeRefinementPass();
                      break;
                    case 2:
                      xe.runCleanupPass(), ae && xe.checkSegmentationSymbol();
                      break;
                  }
                  se && xe.reset(), we = (we + 1) % 3;
                }
                let Be = he.tbx0_ - ie + (he.tby0_ - fe) * ge;
                const Oe = xe.coefficentsSign, Me = xe.coefficentsMagnitude, Fe = xe.bitsDecoded, Ue = te ? 0 : 0.5;
                let je, Le, De;
                ke = 0;
                const Ne = ee.type !== "LL";
                for (ce = 0; ce < Ce; ce++) {
                  const Xe = 2 * (Be / ge | 0) * (q - ge) + pe + be;
                  for (je = 0; je < ye; je++) {
                    if (Le = Me[ke], Le !== 0) {
                      Le = (Le + Ue) * Q, Oe[ke] !== 0 && (Le = -Le), De = Fe[ke];
                      const nt = Ne ? Xe + (Be << 1) : Be;
                      K[nt] = te && De >= J ? Le : Le * (1 << J - De);
                    }
                    Be++, ke++;
                  }
                  Be += ge - ye;
                }
              }
            }
            function U(K, q, Y) {
              const ee = q.components[Y], Q = ee.codingStyleParameters, J = ee.quantizationParameters, te = Q.decompositionLevelsCount, ae = J.SPqcds, se = J.scalarExpounded, ie = J.guardBits, fe = Q.segmentationSymbolUsed, ge = Q.resetContextProbabilities, me = K.components[Y].precision, pe = Q.reversibleTransformation, be = pe ? new ne() : new Z(), le = [];
              let ve = 0;
              for (let ye = 0; ye <= te; ye++) {
                const Ce = ee.resolutions[ye], xe = Ce.trx1 - Ce.trx0, we = Ce.try1 - Ce.try0, $e = new Float32Array(xe * we);
                for (let Ae = 0, ue = Ce.subbands.length; Ae < ue; Ae++) {
                  let ce, Ee;
                  se ? (ce = ae[ve].mu, Ee = ae[ve].epsilon, ve++) : (ce = ae[0].mu, Ee = ae[0].epsilon + (ye > 0 ? 1 - ye : 0));
                  const _e = Ce.subbands[Ae], Te = m[_e.type], ke = pe ? 1 : 2 ** (me + Te - Ee) * (1 + ce / 2048), Re = ie + Ee - 1;
                  G($e, xe, we, _e, ke, Re, pe, fe, ge);
                }
                le.push({
                  width: xe,
                  height: we,
                  items: $e
                });
              }
              const he = be.calculate(le, ee.tcx0, ee.tcy0);
              return {
                left: ee.tcx0,
                top: ee.tcy0,
                width: he.width,
                height: he.height,
                items: he.items
              };
            }
            function k(K) {
              const q = K.SIZ, Y = K.components, ee = q.Csiz, Q = [];
              for (let J = 0, te = K.tiles.length; J < te; J++) {
                const ae = K.tiles[J], se = [];
                for (let xe = 0; xe < ee; xe++)
                  se[xe] = U(K, ae, xe);
                const ie = se[0], fe = new Uint8ClampedArray(ie.items.length * ee), ge = {
                  left: ie.left,
                  top: ie.top,
                  width: ie.width,
                  height: ie.height,
                  items: fe
                };
                let me, pe, be = 0, le, ve, he, ye, Ce;
                if (ae.codingStyleDefaultParameters.multipleComponentTransform) {
                  const xe = ee === 4, we = se[0].items, $e = se[1].items, Ae = se[2].items, ue = xe ? se[3].items : null;
                  me = Y[0].precision - 8, pe = (128 << me) + 0.5;
                  const ce = ae.components[0], Ee = ee - 3;
                  if (ve = we.length, ce.codingStyleParameters.reversibleTransformation)
                    for (le = 0; le < ve; le++, be += Ee) {
                      he = we[le] + pe, ye = $e[le], Ce = Ae[le];
                      const _e = he - (Ce + ye >> 2);
                      fe[be++] = _e + Ce >> me, fe[be++] = _e >> me, fe[be++] = _e + ye >> me;
                    }
                  else
                    for (le = 0; le < ve; le++, be += Ee)
                      he = we[le] + pe, ye = $e[le], Ce = Ae[le], fe[be++] = he + 1.402 * Ce >> me, fe[be++] = he - 0.34413 * ye - 0.71414 * Ce >> me, fe[be++] = he + 1.772 * ye >> me;
                  if (xe)
                    for (le = 0, be = 3; le < ve; le++, be += 4)
                      fe[be] = ue[le] + pe >> me;
                } else
                  for (let xe = 0; xe < ee; xe++) {
                    const we = se[xe].items;
                    for (me = Y[xe].precision - 8, pe = (128 << me) + 0.5, be = xe, le = 0, ve = we.length; le < ve; le++)
                      fe[be] = we[le] + pe >> me, be += ee;
                  }
                Q.push(ge);
              }
              return Q;
            }
            function N(K, q) {
              const ee = K.SIZ.Csiz, Q = K.tiles[q];
              for (let J = 0; J < ee; J++) {
                const te = Q.components[J], ae = K.currentTile.QCC[J] !== void 0 ? K.currentTile.QCC[J] : K.currentTile.QCD;
                te.quantizationParameters = ae;
                const se = K.currentTile.COC[J] !== void 0 ? K.currentTile.COC[J] : K.currentTile.COD;
                te.codingStyleParameters = se;
              }
              Q.codingStyleDefaultParameters = K.currentTile.COD;
            }
            class P {
              constructor(q, Y) {
                const ee = (0, b.log2)(Math.max(q, Y)) + 1;
                this.levels = [];
                for (let Q = 0; Q < ee; Q++) {
                  const J = {
                    width: q,
                    height: Y,
                    items: []
                  };
                  this.levels.push(J), q = Math.ceil(q / 2), Y = Math.ceil(Y / 2);
                }
              }
              reset(q, Y) {
                let ee = 0, Q = 0, J;
                for (; ee < this.levels.length; ) {
                  J = this.levels[ee];
                  const te = q + Y * J.width;
                  if (J.items[te] !== void 0) {
                    Q = J.items[te];
                    break;
                  }
                  J.index = te, q >>= 1, Y >>= 1, ee++;
                }
                ee--, J = this.levels[ee], J.items[J.index] = Q, this.currentLevel = ee, delete this.value;
              }
              incrementValue() {
                const q = this.levels[this.currentLevel];
                q.items[q.index]++;
              }
              nextLevel() {
                let q = this.currentLevel, Y = this.levels[q];
                const ee = Y.items[Y.index];
                return q--, q < 0 ? (this.value = ee, !1) : (this.currentLevel = q, Y = this.levels[q], Y.items[Y.index] = ee, !0);
              }
            }
            class D {
              constructor(q, Y, ee) {
                const Q = (0, b.log2)(Math.max(q, Y)) + 1;
                this.levels = [];
                for (let J = 0; J < Q; J++) {
                  const te = new Uint8Array(q * Y);
                  for (let se = 0, ie = te.length; se < ie; se++)
                    te[se] = ee;
                  const ae = {
                    width: q,
                    height: Y,
                    items: te
                  };
                  this.levels.push(ae), q = Math.ceil(q / 2), Y = Math.ceil(Y / 2);
                }
              }
              reset(q, Y, ee) {
                let Q = 0;
                for (; Q < this.levels.length; ) {
                  const J = this.levels[Q], te = q + Y * J.width;
                  J.index = te;
                  const ae = J.items[te];
                  if (ae === 255)
                    break;
                  if (ae > ee)
                    return this.currentLevel = Q, this.propagateValues(), !1;
                  q >>= 1, Y >>= 1, Q++;
                }
                return this.currentLevel = Q - 1, !0;
              }
              incrementValue(q) {
                const Y = this.levels[this.currentLevel];
                Y.items[Y.index] = q + 1, this.propagateValues();
              }
              propagateValues() {
                let q = this.currentLevel, Y = this.levels[q];
                const ee = Y.items[Y.index];
                for (; --q >= 0; )
                  Y = this.levels[q], Y.items[Y.index] = ee;
              }
              nextLevel() {
                let q = this.currentLevel, Y = this.levels[q];
                const ee = Y.items[Y.index];
                return Y.items[Y.index] = 255, q--, q < 0 ? !1 : (this.currentLevel = q, Y = this.levels[q], Y.items[Y.index] = ee, !0);
              }
            }
            class H {
              static UNIFORM_CONTEXT = 17;
              static RUNLENGTH_CONTEXT = 18;
              static LLAndLHContextsLabel = new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8]);
              static HLContextLabel = new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8]);
              static HHContextLabel = new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]);
              constructor(q, Y, ee, Q, J) {
                this.width = q, this.height = Y;
                let te;
                ee === "HH" ? te = H.HHContextLabel : ee === "HL" ? te = H.HLContextLabel : te = H.LLAndLHContextsLabel, this.contextLabelTable = te;
                const ae = q * Y;
                this.neighborsSignificance = new Uint8Array(ae), this.coefficentsSign = new Uint8Array(ae);
                let se;
                J > 14 ? se = new Uint32Array(ae) : J > 6 ? se = new Uint16Array(ae) : se = new Uint8Array(ae), this.coefficentsMagnitude = se, this.processingFlags = new Uint8Array(ae);
                const ie = new Uint8Array(ae);
                if (Q !== 0)
                  for (let fe = 0; fe < ae; fe++)
                    ie[fe] = Q;
                this.bitsDecoded = ie, this.reset();
              }
              setDecoder(q) {
                this.decoder = q;
              }
              reset() {
                this.contexts = new Int8Array(19), this.contexts[0] = 8, this.contexts[H.UNIFORM_CONTEXT] = 92, this.contexts[H.RUNLENGTH_CONTEXT] = 6;
              }
              setNeighborsSignificance(q, Y, ee) {
                const Q = this.neighborsSignificance, J = this.width, te = this.height, ae = Y > 0, se = Y + 1 < J;
                let ie;
                q > 0 && (ie = ee - J, ae && (Q[ie - 1] += 16), se && (Q[ie + 1] += 16), Q[ie] += 4), q + 1 < te && (ie = ee + J, ae && (Q[ie - 1] += 16), se && (Q[ie + 1] += 16), Q[ie] += 4), ae && (Q[ee - 1] += 1), se && (Q[ee + 1] += 1), Q[ee] |= 128;
              }
              runSignificancePropagationPass() {
                const q = this.decoder, Y = this.width, ee = this.height, Q = this.coefficentsMagnitude, J = this.coefficentsSign, te = this.neighborsSignificance, ae = this.processingFlags, se = this.contexts, ie = this.contextLabelTable, fe = this.bitsDecoded, ge = -2, me = 1, pe = 2;
                for (let be = 0; be < ee; be += 4)
                  for (let le = 0; le < Y; le++) {
                    let ve = be * Y + le;
                    for (let he = 0; he < 4; he++, ve += Y) {
                      const ye = be + he;
                      if (ye >= ee)
                        break;
                      if (ae[ve] &= ge, Q[ve] || !te[ve])
                        continue;
                      const Ce = ie[te[ve]];
                      if (q.readBit(se, Ce)) {
                        const we = this.decodeSignBit(ye, le, ve);
                        J[ve] = we, Q[ve] = 1, this.setNeighborsSignificance(ye, le, ve), ae[ve] |= pe;
                      }
                      fe[ve]++, ae[ve] |= me;
                    }
                  }
              }
              decodeSignBit(q, Y, ee) {
                const Q = this.width, J = this.height, te = this.coefficentsMagnitude, ae = this.coefficentsSign;
                let se, ie, fe, ge, me, pe;
                ge = Y > 0 && te[ee - 1] !== 0, Y + 1 < Q && te[ee + 1] !== 0 ? (fe = ae[ee + 1], ge ? (ie = ae[ee - 1], se = 1 - fe - ie) : se = 1 - fe - fe) : ge ? (ie = ae[ee - 1], se = 1 - ie - ie) : se = 0;
                const be = 3 * se;
                return ge = q > 0 && te[ee - Q] !== 0, q + 1 < J && te[ee + Q] !== 0 ? (fe = ae[ee + Q], ge ? (ie = ae[ee - Q], se = 1 - fe - ie + be) : se = 1 - fe - fe + be) : ge ? (ie = ae[ee - Q], se = 1 - ie - ie + be) : se = be, se >= 0 ? (me = 9 + se, pe = this.decoder.readBit(this.contexts, me)) : (me = 9 - se, pe = this.decoder.readBit(this.contexts, me) ^ 1), pe;
              }
              runMagnitudeRefinementPass() {
                const q = this.decoder, Y = this.width, ee = this.height, Q = this.coefficentsMagnitude, J = this.neighborsSignificance, te = this.contexts, ae = this.bitsDecoded, se = this.processingFlags, ie = 1, fe = 2, ge = Y * ee, me = Y * 4;
                for (let pe = 0, be; pe < ge; pe = be) {
                  be = Math.min(ge, pe + me);
                  for (let le = 0; le < Y; le++)
                    for (let ve = pe + le; ve < be; ve += Y) {
                      if (!Q[ve] || (se[ve] & ie) !== 0)
                        continue;
                      let he = 16;
                      (se[ve] & fe) !== 0 && (se[ve] ^= fe, he = (J[ve] & 127) === 0 ? 15 : 14);
                      const ye = q.readBit(te, he);
                      Q[ve] = Q[ve] << 1 | ye, ae[ve]++, se[ve] |= ie;
                    }
                }
              }
              runCleanupPass() {
                const q = this.decoder, Y = this.width, ee = this.height, Q = this.neighborsSignificance, J = this.coefficentsMagnitude, te = this.coefficentsSign, ae = this.contexts, se = this.contextLabelTable, ie = this.bitsDecoded, fe = this.processingFlags, ge = 1, me = 2, pe = Y, be = Y * 2, le = Y * 3;
                let ve;
                for (let he = 0; he < ee; he = ve) {
                  ve = Math.min(he + 4, ee);
                  const ye = he * Y, Ce = he + 3 < ee;
                  for (let xe = 0; xe < Y; xe++) {
                    const we = ye + xe, $e = Ce && fe[we] === 0 && fe[we + pe] === 0 && fe[we + be] === 0 && fe[we + le] === 0 && Q[we] === 0 && Q[we + pe] === 0 && Q[we + be] === 0 && Q[we + le] === 0;
                    let Ae = 0, ue = we, ce = he, Ee;
                    if ($e) {
                      if (!q.readBit(ae, H.RUNLENGTH_CONTEXT)) {
                        ie[we]++, ie[we + pe]++, ie[we + be]++, ie[we + le]++;
                        continue;
                      }
                      Ae = q.readBit(ae, H.UNIFORM_CONTEXT) << 1 | q.readBit(ae, H.UNIFORM_CONTEXT), Ae !== 0 && (ce = he + Ae, ue += Ae * Y), Ee = this.decodeSignBit(ce, xe, ue), te[ue] = Ee, J[ue] = 1, this.setNeighborsSignificance(ce, xe, ue), fe[ue] |= me, ue = we;
                      for (let Te = he; Te <= ce; Te++, ue += Y)
                        ie[ue]++;
                      Ae++;
                    }
                    for (ce = he + Ae; ce < ve; ce++, ue += Y) {
                      if (J[ue] || (fe[ue] & ge) !== 0)
                        continue;
                      const _e = se[Q[ue]];
                      q.readBit(ae, _e) === 1 && (Ee = this.decodeSignBit(ce, xe, ue), te[ue] = Ee, J[ue] = 1, this.setNeighborsSignificance(ce, xe, ue), fe[ue] |= me), ie[ue]++;
                    }
                  }
                }
              }
              checkSegmentationSymbol() {
                const q = this.decoder, Y = this.contexts;
                if ((q.readBit(Y, H.UNIFORM_CONTEXT) << 3 | q.readBit(Y, H.UNIFORM_CONTEXT) << 2 | q.readBit(Y, H.UNIFORM_CONTEXT) << 1 | q.readBit(Y, H.UNIFORM_CONTEXT)) !== 10)
                  throw new f("Invalid segmentation symbol");
              }
            }
            class V {
              constructor() {
                this.constructor === V && (0, g.unreachable)("Cannot initialize Transform.");
              }
              calculate(q, Y, ee) {
                let Q = q[0];
                for (let J = 1, te = q.length; J < te; J++)
                  Q = this.iterate(Q, q[J], Y, ee);
                return Q;
              }
              extend(q, Y, ee) {
                let Q = Y - 1, J = Y + 1, te = Y + ee - 2, ae = Y + ee;
                q[Q--] = q[J++], q[ae++] = q[te--], q[Q--] = q[J++], q[ae++] = q[te--], q[Q--] = q[J++], q[ae++] = q[te--], q[Q] = q[J], q[ae] = q[te];
              }
              filter(q, Y, ee) {
                (0, g.unreachable)("Abstract method `filter` called");
              }
              iterate(q, Y, ee, Q) {
                const J = q.width, te = q.height;
                let ae = q.items;
                const se = Y.width, ie = Y.height, fe = Y.items;
                let ge, me, pe, be, le, ve;
                for (pe = 0, ge = 0; ge < te; ge++)
                  for (be = ge * 2 * se, me = 0; me < J; me++, pe++, be += 2)
                    fe[be] = ae[pe];
                ae = q.items = null;
                const he = 4, ye = new Float32Array(se + 2 * he);
                if (se === 1) {
                  if ((ee & 1) !== 0)
                    for (ve = 0, pe = 0; ve < ie; ve++, pe += se)
                      fe[pe] *= 0.5;
                } else
                  for (ve = 0, pe = 0; ve < ie; ve++, pe += se)
                    ye.set(fe.subarray(pe, pe + se), he), this.extend(ye, he, se), this.filter(ye, he, se), fe.set(ye.subarray(he, he + se), pe);
                let Ce = 16;
                const xe = [];
                for (ge = 0; ge < Ce; ge++)
                  xe.push(new Float32Array(ie + 2 * he));
                let we, $e = 0;
                if (q = he + ie, ie === 1) {
                  if ((Q & 1) !== 0)
                    for (le = 0; le < se; le++)
                      fe[le] *= 0.5;
                } else
                  for (le = 0; le < se; le++) {
                    if ($e === 0) {
                      for (Ce = Math.min(se - le, Ce), pe = le, be = he; be < q; pe += se, be++)
                        for (we = 0; we < Ce; we++)
                          xe[we][be] = fe[pe + we];
                      $e = Ce;
                    }
                    $e--;
                    const Ae = xe[$e];
                    if (this.extend(Ae, he, ie), this.filter(Ae, he, ie), $e === 0)
                      for (pe = le - Ce + 1, be = he; be < q; pe += se, be++)
                        for (we = 0; we < Ce; we++)
                          fe[pe + we] = xe[we][be];
                  }
                return {
                  width: se,
                  height: ie,
                  items: fe
                };
              }
            }
            class Z extends V {
              filter(q, Y, ee) {
                const Q = ee >> 1;
                Y |= 0;
                let J, te, ae, se;
                const ie = -1.586134342059924, fe = -0.052980118572961, ge = 0.882911075530934, me = 0.443506852043971, pe = 1.230174104914001, be = 1 / pe;
                for (J = Y - 3, te = Q + 4; te--; J += 2)
                  q[J] *= be;
                for (J = Y - 2, ae = me * q[J - 1], te = Q + 3; te-- && (se = me * q[J + 1], q[J] = pe * q[J] - ae - se, te--); J += 2)
                  J += 2, ae = me * q[J + 1], q[J] = pe * q[J] - ae - se;
                for (J = Y - 1, ae = ge * q[J - 1], te = Q + 2; te-- && (se = ge * q[J + 1], q[J] -= ae + se, te--); J += 2)
                  J += 2, ae = ge * q[J + 1], q[J] -= ae + se;
                for (J = Y, ae = fe * q[J - 1], te = Q + 1; te-- && (se = fe * q[J + 1], q[J] -= ae + se, te--); J += 2)
                  J += 2, ae = fe * q[J + 1], q[J] -= ae + se;
                if (Q !== 0)
                  for (J = Y + 1, ae = ie * q[J - 1], te = Q; te-- && (se = ie * q[J + 1], q[J] -= ae + se, te--); J += 2)
                    J += 2, ae = ie * q[J + 1], q[J] -= ae + se;
              }
            }
            class ne extends V {
              filter(q, Y, ee) {
                const Q = ee >> 1;
                Y |= 0;
                let J, te;
                for (J = Y, te = Q + 1; te--; J += 2)
                  q[J] -= q[J - 1] + q[J + 1] + 2 >> 2;
                for (J = Y + 1, te = Q; te--; J += 2)
                  q[J] += q[J - 1] + q[J + 1] >> 1;
              }
            }
          },
          /* 31 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.LZWStream = void 0;
            var g = x(18);
            class b extends g.DecodeStream {
              constructor(f, m, C) {
                super(m), this.str = f, this.dict = f.dict, this.cachedData = 0, this.bitsCached = 0;
                const w = 4096, S = {
                  earlyChange: C,
                  codeLength: 9,
                  nextCode: 258,
                  dictionaryValues: new Uint8Array(w),
                  dictionaryLengths: new Uint16Array(w),
                  dictionaryPrevCodes: new Uint16Array(w),
                  currentSequence: new Uint8Array(w),
                  currentSequenceLength: 0
                };
                for (let $ = 0; $ < 256; ++$)
                  S.dictionaryValues[$] = $, S.dictionaryLengths[$] = 1;
                this.lzwState = S;
              }
              readBits(f) {
                let m = this.bitsCached, C = this.cachedData;
                for (; m < f; ) {
                  const w = this.str.getByte();
                  if (w === -1)
                    return this.eof = !0, null;
                  C = C << 8 | w, m += 8;
                }
                return this.bitsCached = m -= f, this.cachedData = C, this.lastCode = null, C >>> m & (1 << f) - 1;
              }
              readBlock() {
                let C = 1024, w, S, $;
                const T = this.lzwState;
                if (!T)
                  return;
                const I = T.earlyChange;
                let _ = T.nextCode;
                const E = T.dictionaryValues, R = T.dictionaryLengths, O = T.dictionaryPrevCodes;
                let L = T.codeLength, B = T.prevCode;
                const F = T.currentSequence;
                let M = T.currentSequenceLength, W = 0, j = this.bufferLength, G = this.ensureBuffer(this.bufferLength + C);
                for (w = 0; w < 512; w++) {
                  const U = this.readBits(L), k = M > 0;
                  if (U < 256)
                    F[0] = U, M = 1;
                  else if (U >= 258)
                    if (U < _)
                      for (M = R[U], S = M - 1, $ = U; S >= 0; S--)
                        F[S] = E[$], $ = O[$];
                    else
                      F[M++] = F[0];
                  else if (U === 256) {
                    L = 9, _ = 258, M = 0;
                    continue;
                  } else {
                    this.eof = !0, delete this.lzwState;
                    break;
                  }
                  if (k && (O[_] = B, R[_] = R[B] + 1, E[_] = F[0], _++, L = _ + I & _ + I - 1 ? L : Math.min(Math.log(_ + I) / 0.6931471805599453 + 1, 12) | 0), B = U, W += M, C < W) {
                    do
                      C += 512;
                    while (C < W);
                    G = this.ensureBuffer(this.bufferLength + C);
                  }
                  for (S = 0; S < M; S++)
                    G[j++] = F[S];
                }
                T.nextCode = _, T.codeLength = L, T.prevCode = B, T.currentSequenceLength = M, this.bufferLength = j;
              }
            }
            A.LZWStream = b;
          },
          /* 32 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.PredictorStream = void 0;
            var g = x(18), b = x(4), y = x(2);
            class f extends g.DecodeStream {
              constructor(C, w, S) {
                if (super(w), !(S instanceof b.Dict))
                  return C;
                const $ = this.predictor = S.get("Predictor") || 1;
                if ($ <= 1)
                  return C;
                if ($ !== 2 && ($ < 10 || $ > 15))
                  throw new y.FormatError(`Unsupported predictor: ${$}`);
                this.readBlock = $ === 2 ? this.readBlockTiff : this.readBlockPng, this.str = C, this.dict = C.dict;
                const T = this.colors = S.get("Colors") || 1, I = this.bits = S.get("BPC", "BitsPerComponent") || 8, _ = this.columns = S.get("Columns") || 1;
                return this.pixBytes = T * I + 7 >> 3, this.rowBytes = _ * T * I + 7 >> 3, this;
              }
              readBlockTiff() {
                const C = this.rowBytes, w = this.bufferLength, S = this.ensureBuffer(w + C), $ = this.bits, T = this.colors, I = this.str.getBytes(C);
                if (this.eof = !I.length, this.eof)
                  return;
                let _ = 0, E = 0, R = 0, O = 0, L = w, B;
                if ($ === 1 && T === 1)
                  for (B = 0; B < C; ++B) {
                    let F = I[B] ^ _;
                    F ^= F >> 1, F ^= F >> 2, F ^= F >> 4, _ = (F & 1) << 7, S[L++] = F;
                  }
                else if ($ === 8) {
                  for (B = 0; B < T; ++B)
                    S[L++] = I[B];
                  for (; B < C; ++B)
                    S[L] = S[L - T] + I[B], L++;
                } else if ($ === 16) {
                  const F = T * 2;
                  for (B = 0; B < F; ++B)
                    S[L++] = I[B];
                  for (; B < C; B += 2) {
                    const M = ((I[B] & 255) << 8) + (I[B + 1] & 255) + ((S[L - F] & 255) << 8) + (S[L - F + 1] & 255);
                    S[L++] = M >> 8 & 255, S[L++] = M & 255;
                  }
                } else {
                  const F = new Uint8Array(T + 1), M = (1 << $) - 1;
                  let W = 0, j = w;
                  const G = this.columns;
                  for (B = 0; B < G; ++B)
                    for (let U = 0; U < T; ++U)
                      R < $ && (_ = _ << 8 | I[W++] & 255, R += 8), F[U] = F[U] + (_ >> R - $) & M, R -= $, E = E << $ | F[U], O += $, O >= 8 && (S[j++] = E >> O - 8 & 255, O -= 8);
                  O > 0 && (S[j++] = (E << 8 - O) + (_ & (1 << 8 - O) - 1));
                }
                this.bufferLength += C;
              }
              readBlockPng() {
                const C = this.rowBytes, w = this.pixBytes, S = this.str.getByte(), $ = this.str.getBytes(C);
                if (this.eof = !$.length, this.eof)
                  return;
                const T = this.bufferLength, I = this.ensureBuffer(T + C);
                let _ = I.subarray(T - C, T);
                _.length === 0 && (_ = new Uint8Array(C));
                let E, R = T, O, L;
                switch (S) {
                  case 0:
                    for (E = 0; E < C; ++E)
                      I[R++] = $[E];
                    break;
                  case 1:
                    for (E = 0; E < w; ++E)
                      I[R++] = $[E];
                    for (; E < C; ++E)
                      I[R] = I[R - w] + $[E] & 255, R++;
                    break;
                  case 2:
                    for (E = 0; E < C; ++E)
                      I[R++] = _[E] + $[E] & 255;
                    break;
                  case 3:
                    for (E = 0; E < w; ++E)
                      I[R++] = (_[E] >> 1) + $[E];
                    for (; E < C; ++E)
                      I[R] = (_[E] + I[R - w] >> 1) + $[E] & 255, R++;
                    break;
                  case 4:
                    for (E = 0; E < w; ++E)
                      O = _[E], L = $[E], I[R++] = O + L;
                    for (; E < C; ++E) {
                      O = _[E];
                      const B = _[E - w], F = I[R - w], M = F + O - B;
                      let W = M - F;
                      W < 0 && (W = -W);
                      let j = M - O;
                      j < 0 && (j = -j);
                      let G = M - B;
                      G < 0 && (G = -G), L = $[E], W <= j && W <= G ? I[R++] = F + L : j <= G ? I[R++] = O + L : I[R++] = B + L;
                    }
                    break;
                  default:
                    throw new y.FormatError(`Unsupported predictor: ${S}`);
                }
                this.bufferLength += C;
              }
            }
            A.PredictorStream = f;
          },
          /* 33 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.RunLengthStream = void 0;
            var g = x(18);
            class b extends g.DecodeStream {
              constructor(f, m) {
                super(m), this.str = f, this.dict = f.dict;
              }
              readBlock() {
                const f = this.str.getBytes(2);
                if (!f || f.length < 2 || f[0] === 128) {
                  this.eof = !0;
                  return;
                }
                let m, C = this.bufferLength, w = f[0];
                if (w < 128) {
                  if (m = this.ensureBuffer(C + w + 1), m[C++] = f[1], w > 0) {
                    const S = this.str.getBytes(w);
                    m.set(S, C), C += w;
                  }
                } else {
                  w = 257 - w;
                  const S = f[1];
                  m = this.ensureBuffer(C + w + 1);
                  for (let $ = 0; $ < w; $++)
                    m[C++] = S;
                }
                this.bufferLength = C;
              }
            }
            A.RunLengthStream = b;
          },
          /* 34 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Font = A.ErrorFont = void 0;
            var g = x(2), b = x(35), y = x(38), f = x(40), m = x(39), C = x(37), w = x(41), S = x(42), $ = x(43), T = x(44), I = x(45), _ = x(46), E = x(14), R = x(47), O = x(3), L = x(8), B = x(48);
            const F = [[57344, 63743], [1048576, 1114109]], M = 1e3, W = ["ascent", "bbox", "black", "bold", "charProcOperatorList", "composite", "cssFontInfo", "data", "defaultVMetrics", "defaultWidth", "descent", "fallbackName", "fontMatrix", "isInvalidPDFjsFont", "isType3Font", "italic", "loadedName", "mimetype", "missingFile", "name", "remeasure", "subtype", "systemFontInfo", "type", "vertical"], j = ["cMap", "defaultEncoding", "differences", "isMonospace", "isSerifFont", "isSymbolicFont", "seacMap", "toFontChar", "toUnicode", "vmetrics", "widths"];
            function G($e) {
              if (!$e.fontMatrix || $e.fontMatrix[0] === g.FONT_IDENTITY_MATRIX[0])
                return;
              const Ae = 1e-3 / $e.fontMatrix[0], ue = $e.widths;
              for (const ce in ue)
                ue[ce] *= Ae;
              $e.defaultWidth *= Ae;
            }
            function U($e, Ae, ue) {
              if ($e.isInternalFont || $e.hasIncludedToUnicodeMap || $e.hasEncoding || $e.toUnicode instanceof S.IdentityToUnicodeMap || !Ae || ue.length === 0 || $e.defaultEncoding === C.WinAnsiEncoding)
                return;
              for (const Te of ue)
                if (!fe(Te))
                  return;
              const ce = C.WinAnsiEncoding, Ee = [], _e = (0, m.getGlyphsUnicode)();
              for (const Te in ce) {
                const ke = ce[Te];
                if (ke === "")
                  continue;
                const Re = _e[ke];
                Re !== void 0 && (Ee[Te] = String.fromCharCode(Re));
              }
              Ee.length > 0 && $e.toUnicode.amend(Ee);
            }
            function k($e, Ae) {
              if ($e.isInternalFont || $e.hasIncludedToUnicodeMap || Ae === $e.defaultEncoding || $e.toUnicode instanceof S.IdentityToUnicodeMap)
                return;
              const ue = [], ce = (0, m.getGlyphsUnicode)();
              for (const Ee in Ae) {
                if ($e.hasEncoding && ($e.baseEncodingName || $e.differences[Ee] !== void 0))
                  continue;
                const _e = Ae[Ee], Te = (0, f.getUnicodeForGlyph)(_e, ce);
                Te !== -1 && (ue[Ee] = String.fromCharCode(Te));
              }
              ue.length > 0 && $e.toUnicode.amend(ue);
            }
            function N($e) {
              if (!$e.fallbackToUnicode || $e.toUnicode instanceof S.IdentityToUnicodeMap)
                return;
              const Ae = [];
              for (const ue in $e.fallbackToUnicode)
                $e.toUnicode.has(ue) || (Ae[ue] = $e.fallbackToUnicode[ue]);
              Ae.length > 0 && $e.toUnicode.amend(Ae);
            }
            class P {
              constructor(Ae, ue, ce, Ee, _e, Te, ke, Re, Be) {
                this.originalCharCode = Ae, this.fontChar = ue, this.unicode = ce, this.accent = Ee, this.width = _e, this.vmetric = Te, this.operatorListId = ke, this.isSpace = Re, this.isInFont = Be;
              }
              get category() {
                return (0, g.shadow)(this, "category", (0, f.getCharUnicodeCategory)(this.unicode), !0);
              }
            }
            function D($e, Ae) {
              return ($e << 8) + Ae;
            }
            function H($e, Ae, ue) {
              $e[Ae + 1] = ue, $e[Ae] = ue >>> 8;
            }
            function V($e, Ae) {
              const ue = ($e << 8) + Ae;
              return ue & 32768 ? ue - 65536 : ue;
            }
            function Z($e, Ae, ue, ce) {
              return ($e << 24) + (Ae << 16) + (ue << 8) + ce;
            }
            function ne($e) {
              return String.fromCharCode($e >> 8 & 255, $e & 255);
            }
            function K($e) {
              return $e > 32767 ? $e = 32767 : $e < -32768 && ($e = -32768), String.fromCharCode($e >> 8 & 255, $e & 255);
            }
            function q($e) {
              const Ae = $e.peekBytes(4);
              return (0, O.readUint32)(Ae, 0) === 65536 || (0, g.bytesToString)(Ae) === "true";
            }
            function Y($e) {
              const Ae = $e.peekBytes(4);
              return (0, g.bytesToString)(Ae) === "ttcf";
            }
            function ee($e) {
              const Ae = $e.peekBytes(4);
              return (0, g.bytesToString)(Ae) === "OTTO";
            }
            function Q($e) {
              const Ae = $e.peekBytes(2);
              return Ae[0] === 37 && Ae[1] === 33 || Ae[0] === 128 && Ae[1] === 1;
            }
            function J($e) {
              const Ae = $e.peekBytes(4);
              return Ae[0] >= 1 && Ae[3] >= 1 && Ae[3] <= 4;
            }
            function te($e, {
              type: Ae,
              subtype: ue,
              composite: ce
            }) {
              let Ee, _e;
              return q($e) || Y($e) ? Ee = ce ? "CIDFontType2" : "TrueType" : ee($e) ? Ee = ce ? "CIDFontType2" : "OpenType" : Q($e) ? ce ? Ee = "CIDFontType0" : Ee = Ae === "MMType1" ? "MMType1" : "Type1" : J($e) ? ce ? (Ee = "CIDFontType0", _e = "CIDFontType0C") : (Ee = Ae === "MMType1" ? "MMType1" : "Type1", _e = "Type1C") : ((0, g.warn)("getFontFileType: Unable to detect correct font file Type/Subtype."), Ee = Ae, _e = ue), [Ee, _e];
            }
            function ae($e, Ae) {
              for (const ue in Ae)
                $e[+ue] = Ae[ue];
            }
            function se($e, Ae, ue) {
              const ce = [];
              let Ee;
              for (let _e = 0, Te = $e.length; _e < Te; _e++)
                Ee = (0, f.getUnicodeForGlyph)($e[_e], Ae), Ee !== -1 && (ce[_e] = Ee);
              for (const _e in ue)
                Ee = (0, f.getUnicodeForGlyph)(ue[_e], Ae), Ee !== -1 && (ce[+_e] = Ee);
              return ce;
            }
            function ie($e) {
              return $e.platform === 1 && $e.encoding === 0 && $e.language === 0;
            }
            function fe($e) {
              return $e.platform === 3 && $e.encoding === 1 && $e.language === 1033;
            }
            function ge($e, Ae, ue = !1) {
              switch (Ae.length) {
                case 1:
                  return Ae.charCodeAt(0);
                case 2:
                  return Ae.charCodeAt(0) << 8 | Ae.charCodeAt(1);
              }
              const ce = `Unsupported CID string (charCode ${$e}): "${Ae}".`;
              if (ue)
                throw new g.FormatError(ce);
              return (0, g.warn)(ce), Ae;
            }
            function me($e, Ae, ue, ce) {
              const Ee = /* @__PURE__ */ Object.create(null), _e = /* @__PURE__ */ new Map(), Te = [], ke = /* @__PURE__ */ new Set();
              let Re = 0, Oe = F[Re][0], Me = F[Re][1];
              const Fe = (Ue) => F[0][0] <= Ue && Ue <= F[0][1] || F[1][0] <= Ue && Ue <= F[1][1];
              for (let Ue in $e) {
                Ue |= 0;
                let je = $e[Ue];
                if (!Ae(je))
                  continue;
                if (Oe > Me) {
                  if (Re++, Re >= F.length) {
                    (0, g.warn)("Ran out of space in font private use area.");
                    break;
                  }
                  Oe = F[Re][0], Me = F[Re][1];
                }
                const Le = Oe++;
                je === 0 && (je = ue);
                let De = ce.get(Ue);
                typeof De == "string" && (De = De.codePointAt(0)), De && !Fe(De) && !ke.has(je) && (_e.set(De, je), ke.add(je)), Ee[Le] = je, Te[Ue] = Le;
              }
              return {
                toFontChar: Te,
                charCodeToGlyphId: Ee,
                toUnicodeExtraMap: _e,
                nextAvailableFontCharCode: Oe
              };
            }
            function pe($e, Ae, ue) {
              const ce = [];
              for (const Te in $e)
                $e[Te] >= ue || ce.push({
                  fontCharCode: Te | 0,
                  glyphId: $e[Te]
                });
              if (Ae)
                for (const [Te, ke] of Ae)
                  ke >= ue || ce.push({
                    fontCharCode: Te,
                    glyphId: ke
                  });
              ce.length === 0 && ce.push({
                fontCharCode: 0,
                glyphId: 0
              }), ce.sort(function(ke, Re) {
                return ke.fontCharCode - Re.fontCharCode;
              });
              const Ee = [], _e = ce.length;
              for (let Te = 0; Te < _e; ) {
                const ke = ce[Te].fontCharCode, Re = [ce[Te].glyphId];
                ++Te;
                let Be = ke;
                for (; Te < _e && Be + 1 === ce[Te].fontCharCode && (Re.push(ce[Te].glyphId), ++Be, ++Te, Be !== 65535); )
                  ;
                Ee.push([ke, Be, Re]);
              }
              return Ee;
            }
            function be($e, Ae, ue) {
              const ce = pe($e, Ae, ue), Ee = ce.at(-1)[1] > 65535 ? 2 : 1;
              let _e = "\0\0" + ne(Ee) + "\0\0" + (0, g.string32)(4 + Ee * 8), Te, ke, Re, Be;
              for (Te = ce.length - 1; Te >= 0 && !(ce[Te][0] <= 65535); --Te)
                ;
              const Oe = Te + 1;
              ce[Te][0] < 65535 && ce[Te][1] === 65535 && (ce[Te][1] = 65534);
              const Me = ce[Te][1] < 65535 ? 1 : 0, Fe = Oe + Me, Ue = R.OpenTypeFileBuilder.getSearchParams(Fe, 2);
              let je = "", Le = "", De = "", Ne = "", Ge = "", Xe = 0, nt, ct, it, We;
              for (Te = 0, ke = Oe; Te < ke; Te++) {
                nt = ce[Te], ct = nt[0], it = nt[1], je += ne(ct), Le += ne(it), We = nt[2];
                let Qe = !0;
                for (Re = 1, Be = We.length; Re < Be; ++Re)
                  if (We[Re] !== We[Re - 1] + 1) {
                    Qe = !1;
                    break;
                  }
                if (Qe) {
                  const st = We[0];
                  De += ne(st - ct & 65535), Ne += ne(0);
                } else {
                  const st = (Fe - Te) * 2 + Xe * 2;
                  for (Xe += it - ct + 1, De += ne(0), Ne += ne(st), Re = 0, Be = We.length; Re < Be; ++Re)
                    Ge += ne(We[Re]);
                }
              }
              Me > 0 && (Le += "ÿÿ", je += "ÿÿ", De += "\0", Ne += "\0\0");
              const Ve = "\0\0" + ne(2 * Fe) + ne(Ue.range) + ne(Ue.entry) + ne(Ue.rangeShift) + Le + "\0\0" + je + De + Ne + Ge;
              let ut = "", at = "";
              if (Ee > 1) {
                for (_e += `\0\0
` + (0, g.string32)(4 + Ee * 8 + 4 + Ve.length), ut = "", Te = 0, ke = ce.length; Te < ke; Te++) {
                  nt = ce[Te], ct = nt[0], We = nt[2];
                  let Qe = We[0];
                  for (Re = 1, Be = We.length; Re < Be; ++Re)
                    We[Re] !== We[Re - 1] + 1 && (it = nt[0] + Re - 1, ut += (0, g.string32)(ct) + (0, g.string32)(it) + (0, g.string32)(Qe), ct = it + 1, Qe = We[Re]);
                  ut += (0, g.string32)(ct) + (0, g.string32)(nt[1]) + (0, g.string32)(Qe);
                }
                at = "\0\f\0\0" + (0, g.string32)(ut.length + 16) + "\0\0\0\0" + (0, g.string32)(ut.length / 12);
              }
              return _e + "\0" + ne(Ve.length + 4) + Ve + at + ut;
            }
            function le($e, Ae) {
              Ae.pos = (Ae.start || 0) + $e.offset;
              const ue = Ae.getUint16();
              Ae.skip(60);
              const ce = Ae.getUint16();
              if (ue < 4 && ce & 768)
                return !1;
              const Ee = Ae.getUint16(), _e = Ae.getUint16();
              return Ee > _e || (Ae.skip(6), Ae.getUint16() === 0) ? !1 : ($e.data[8] = $e.data[9] = 0, !0);
            }
            function ve($e, Ae, ue) {
              ue ||= {
                unitsPerEm: 0,
                yMax: 0,
                yMin: 0,
                ascent: 0,
                descent: 0
              };
              let ce = 0, Ee = 0, _e = 0, Te = 0, ke = null, Re = 0, Be = -1;
              if (Ae) {
                for (let Ne in Ae)
                  if (Ne |= 0, (ke > Ne || !ke) && (ke = Ne), Re < Ne && (Re = Ne), Be = (0, f.getUnicodeRangeFor)(Ne, Be), Be < 32)
                    ce |= 1 << Be;
                  else if (Be < 64)
                    Ee |= 1 << Be - 32;
                  else if (Be < 96)
                    _e |= 1 << Be - 64;
                  else if (Be < 123)
                    Te |= 1 << Be - 96;
                  else
                    throw new g.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
                Re > 65535 && (Re = 65535);
              } else
                ke = 0, Re = 255;
              const Oe = $e.bbox || [0, 0, 0, 0], Me = ue.unitsPerEm || 1 / ($e.fontMatrix || g.FONT_IDENTITY_MATRIX)[0], Fe = $e.ascentScaled ? 1 : Me / M, Ue = ue.ascent || Math.round(Fe * ($e.ascent || Oe[3]));
              let je = ue.descent || Math.round(Fe * ($e.descent || Oe[1]));
              je > 0 && $e.descent > 0 && Oe[1] < 0 && (je = -je);
              const Le = ue.yMax || Ue, De = -ue.yMin || -je;
              return "\0$ô\0\0\0»\0\0\0»\0\0ß\x001\0\0\0\0" + String.fromCharCode($e.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + (0, g.string32)(ce) + (0, g.string32)(Ee) + (0, g.string32)(_e) + (0, g.string32)(Te) + "*21*" + ne($e.italicAngle ? 1 : 0) + ne(ke || $e.firstChar) + ne(Re || $e.lastChar) + ne(Ue) + ne(je) + "\0d" + ne(Le) + ne(De) + "\0\0\0\0\0\0\0\0" + ne($e.xHeight) + ne($e.capHeight) + ne(0) + ne(ke || $e.firstChar) + "\0";
            }
            function he($e) {
              const Ae = Math.floor($e.italicAngle * 65536);
              return "\0\0\0" + (0, g.string32)(Ae) + "\0\0\0\0" + (0, g.string32)($e.fixedPitch ? 1 : 0) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
            }
            function ye($e) {
              return $e.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
            }
            function Ce($e, Ae) {
              Ae || (Ae = [[], []]);
              const ue = [Ae[0][0] || "Original licence", Ae[0][1] || $e, Ae[0][2] || "Unknown", Ae[0][3] || "uniqueID", Ae[0][4] || $e, Ae[0][5] || "Version 0.11", Ae[0][6] || ye($e), Ae[0][7] || "Unknown", Ae[0][8] || "Unknown", Ae[0][9] || "Unknown"], ce = [];
              let Ee, _e, Te, ke, Re;
              for (Ee = 0, _e = ue.length; Ee < _e; Ee++) {
                Re = Ae[1][Ee] || ue[Ee];
                const De = [];
                for (Te = 0, ke = Re.length; Te < ke; Te++)
                  De.push(ne(Re.charCodeAt(Te)));
                ce.push(De.join(""));
              }
              const Be = [ue, ce], Oe = ["\0", "\0"], Me = ["\0\0", "\0"], Fe = ["\0\0", "	"], Ue = ue.length * Oe.length;
              let je = "\0\0" + ne(Ue) + ne(Ue * 12 + 6), Le = 0;
              for (Ee = 0, _e = Oe.length; Ee < _e; Ee++) {
                const De = Be[Ee];
                for (Te = 0, ke = De.length; Te < ke; Te++) {
                  Re = De[Te];
                  const Ne = Oe[Ee] + Me[Ee] + Fe[Ee] + ne(Te) + ne(Re.length) + ne(Le);
                  je += Ne, Le += Re.length;
                }
              }
              return je += ue.join("") + ce.join(""), je;
            }
            class xe {
              constructor(Ae, ue, ce) {
                this.name = Ae, this.psName = null, this.mimetype = null, this.disableFontFace = !1, this.loadedName = ce.loadedName, this.isType3Font = ce.isType3Font, this.missingFile = !1, this.cssFontInfo = ce.cssFontInfo, this._charsCache = /* @__PURE__ */ Object.create(null), this._glyphCache = /* @__PURE__ */ Object.create(null);
                let Ee = !!(ce.flags & y.FontFlags.Serif);
                if (!Ee && !ce.isSimulatedFlags) {
                  const Be = Ae.replaceAll(/[,_]/g, "-").split("-")[0], Oe = (0, w.getSerifFonts)();
                  for (const Me of Be.split("+"))
                    if (Oe[Me]) {
                      Ee = !0;
                      break;
                    }
                }
                this.isSerifFont = Ee, this.isSymbolicFont = !!(ce.flags & y.FontFlags.Symbolic), this.isMonospace = !!(ce.flags & y.FontFlags.FixedPitch);
                let {
                  type: _e,
                  subtype: Te
                } = ce;
                this.type = _e, this.subtype = Te, this.systemFontInfo = ce.systemFontInfo;
                const ke = Ae.match(/^InvalidPDFjsFont_(.*)_\d+$/);
                if (this.isInvalidPDFjsFont = !!ke, this.isInvalidPDFjsFont ? this.fallbackName = ke[1] : this.isMonospace ? this.fallbackName = "monospace" : this.isSerifFont ? this.fallbackName = "serif" : this.fallbackName = "sans-serif", this.systemFontInfo?.guessFallback && (this.systemFontInfo.guessFallback = !1, this.systemFontInfo.css += `,${this.fallbackName}`), this.differences = ce.differences, this.widths = ce.widths, this.defaultWidth = ce.defaultWidth, this.composite = ce.composite, this.cMap = ce.cMap, this.capHeight = ce.capHeight / M, this.ascent = ce.ascent / M, this.descent = ce.descent / M, this.lineHeight = this.ascent - this.descent, this.fontMatrix = ce.fontMatrix, this.bbox = ce.bbox, this.defaultEncoding = ce.defaultEncoding, this.toUnicode = ce.toUnicode, this.toFontChar = [], ce.type === "Type3") {
                  for (let Be = 0; Be < 256; Be++)
                    this.toFontChar[Be] = this.differences[Be] || ce.defaultEncoding[Be];
                  return;
                }
                if (this.cidEncoding = ce.cidEncoding || "", this.vertical = !!ce.vertical, this.vertical && (this.vmetrics = ce.vmetrics, this.defaultVMetrics = ce.defaultVMetrics), !ue || ue.isEmpty) {
                  ue && (0, g.warn)('Font file is empty in "' + Ae + '" (' + this.loadedName + ")"), this.fallbackToSystemFont(ce);
                  return;
                }
                [_e, Te] = te(ue, ce), (_e !== this.type || Te !== this.subtype) && (0, g.info)(`Inconsistent font file Type/SubType, expected: ${this.type}/${this.subtype} but found: ${_e}/${Te}.`);
                let Re;
                try {
                  switch (_e) {
                    case "MMType1":
                      (0, g.info)("MMType1 font (" + Ae + "), falling back to Type1.");
                    case "Type1":
                    case "CIDFontType0":
                      this.mimetype = "font/opentype";
                      const Be = Te === "Type1C" || Te === "CIDFontType0C" ? new $.CFFFont(ue, ce) : new B.Type1Font(Ae, ue, ce);
                      G(ce), Re = this.convert(Ae, Be, ce);
                      break;
                    case "OpenType":
                    case "TrueType":
                    case "CIDFontType2":
                      this.mimetype = "font/opentype", Re = this.checkAndRepair(Ae, ue, ce), this.isOpenType && (G(ce), _e = "OpenType");
                      break;
                    default:
                      throw new g.FormatError(`Font ${_e} is not supported`);
                  }
                } catch (Be) {
                  (0, g.warn)(Be), this.fallbackToSystemFont(ce);
                  return;
                }
                N(ce), this.data = Re, this.type = _e, this.subtype = Te, this.fontMatrix = ce.fontMatrix, this.widths = ce.widths, this.defaultWidth = ce.defaultWidth, this.toUnicode = ce.toUnicode, this.seacMap = ce.seacMap;
              }
              get renderer() {
                const Ae = T.FontRendererFactory.create(this, y.SEAC_ANALYSIS_ENABLED);
                return (0, g.shadow)(this, "renderer", Ae);
              }
              exportData(Ae = !1) {
                const ue = Ae ? [...W, ...j] : W, ce = /* @__PURE__ */ Object.create(null);
                let Ee, _e;
                for (Ee of ue)
                  _e = this[Ee], _e !== void 0 && (ce[Ee] = _e);
                return ce;
              }
              fallbackToSystemFont(Ae) {
                this.missingFile = !0;
                const {
                  name: ue,
                  type: ce
                } = this;
                let Ee = (0, y.normalizeFontName)(ue);
                const _e = (0, w.getStdFontMap)(), Te = (0, w.getNonStdFontMap)(), ke = !!_e[Ee], Re = !!(Te[Ee] && _e[Te[Ee]]);
                Ee = _e[Ee] || Te[Ee] || Ee;
                const Oe = (0, I.getFontBasicMetrics)()[Ee];
                Oe && (isNaN(this.ascent) && (this.ascent = Oe.ascent / M), isNaN(this.descent) && (this.descent = Oe.descent / M), isNaN(this.capHeight) && (this.capHeight = Oe.capHeight / M)), this.bold = /bold/gi.test(Ee), this.italic = /oblique|italic/gi.test(Ee), this.black = /Black/g.test(ue);
                const Me = /Narrow/g.test(ue);
                if (this.remeasure = (!ke || Me) && Object.keys(this.widths).length > 0, (ke || Re) && ce === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
                  const Fe = Ae.cidToGidMap, Ue = [];
                  if (ae(Ue, (0, w.getGlyphMapForStandardFonts)()), /Arial-?Black/i.test(ue) ? ae(Ue, (0, w.getSupplementalGlyphMapForArialBlack)()) : /Calibri/i.test(ue) && ae(Ue, (0, w.getSupplementalGlyphMapForCalibri)()), Fe) {
                    for (const je in Ue) {
                      const Le = Ue[je];
                      Fe[Le] !== void 0 && (Ue[+je] = Fe[Le]);
                    }
                    Fe.length !== this.toUnicode.length && Ae.hasIncludedToUnicodeMap && this.toUnicode instanceof S.IdentityToUnicodeMap && this.toUnicode.forEach(function(je, Le) {
                      const De = Ue[je];
                      Fe[De] === void 0 && (Ue[+je] = Le);
                    });
                  }
                  this.toUnicode instanceof S.IdentityToUnicodeMap || this.toUnicode.forEach(function(je, Le) {
                    Ue[+je] = Le;
                  }), this.toFontChar = Ue, this.toUnicode = new S.ToUnicodeMap(Ue);
                } else if (/Symbol/i.test(Ee))
                  this.toFontChar = se(C.SymbolSetEncoding, (0, m.getGlyphsUnicode)(), this.differences);
                else if (/Dingbats/i.test(Ee))
                  this.toFontChar = se(C.ZapfDingbatsEncoding, (0, m.getDingbatsGlyphsUnicode)(), this.differences);
                else if (ke) {
                  const Fe = se(this.defaultEncoding, (0, m.getGlyphsUnicode)(), this.differences);
                  ce === "CIDFontType2" && !this.cidEncoding.startsWith("Identity-") && !(this.toUnicode instanceof S.IdentityToUnicodeMap) && this.toUnicode.forEach(function(Ue, je) {
                    Fe[+Ue] = je;
                  }), this.toFontChar = Fe;
                } else {
                  const Fe = (0, m.getGlyphsUnicode)(), Ue = [];
                  this.toUnicode.forEach((je, Le) => {
                    if (!this.composite) {
                      const De = this.differences[je] || this.defaultEncoding[je], Ne = (0, f.getUnicodeForGlyph)(De, Fe);
                      Ne !== -1 && (Le = Ne);
                    }
                    Ue[+je] = Le;
                  }), this.composite && this.toUnicode instanceof S.IdentityToUnicodeMap && /Tahoma|Verdana/i.test(ue) && ae(Ue, (0, w.getGlyphMapForStandardFonts)()), this.toFontChar = Ue;
                }
                N(Ae), this.loadedName = Ee.split("-")[0];
              }
              checkAndRepair(Ae, ue, ce) {
                const Ee = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "];
                function _e(rt, et) {
                  const Ye = /* @__PURE__ */ Object.create(null);
                  Ye["OS/2"] = null, Ye.cmap = null, Ye.head = null, Ye.hhea = null, Ye.hmtx = null, Ye.maxp = null, Ye.name = null, Ye.post = null;
                  for (let tt = 0; tt < et; tt++) {
                    const Ke = Te(rt);
                    Ee.includes(Ke.tag) && Ke.length !== 0 && (Ye[Ke.tag] = Ke);
                  }
                  return Ye;
                }
                function Te(rt) {
                  const et = rt.getString(4), Ye = rt.getInt32() >>> 0, tt = rt.getInt32() >>> 0, Ke = rt.getInt32() >>> 0, qe = rt.pos;
                  rt.pos = rt.start || 0, rt.skip(tt);
                  const ot = rt.getBytes(Ke);
                  return rt.pos = qe, et === "head" && (ot[8] = ot[9] = ot[10] = ot[11] = 0, ot[17] |= 32), {
                    tag: et,
                    checksum: Ye,
                    length: Ke,
                    offset: tt,
                    data: ot
                  };
                }
                function ke(rt) {
                  return {
                    version: rt.getString(4),
                    numTables: rt.getUint16(),
                    searchRange: rt.getUint16(),
                    entrySelector: rt.getUint16(),
                    rangeShift: rt.getUint16()
                  };
                }
                function Re(rt) {
                  const et = rt.getString(4);
                  (0, g.assert)(et === "ttcf", "Must be a TrueType Collection font.");
                  const Ye = rt.getUint16(), tt = rt.getUint16(), Ke = rt.getInt32() >>> 0, qe = [];
                  for (let Je = 0; Je < Ke; Je++)
                    qe.push(rt.getInt32() >>> 0);
                  const ot = {
                    ttcTag: et,
                    majorVersion: Ye,
                    minorVersion: tt,
                    numFonts: Ke,
                    offsetTable: qe
                  };
                  switch (Ye) {
                    case 1:
                      return ot;
                    case 2:
                      return ot.dsigTag = rt.getInt32() >>> 0, ot.dsigLength = rt.getInt32() >>> 0, ot.dsigOffset = rt.getInt32() >>> 0, ot;
                  }
                  throw new g.FormatError(`Invalid TrueType Collection majorVersion: ${Ye}.`);
                }
                function Be(rt, et) {
                  const {
                    numFonts: Ye,
                    offsetTable: tt
                  } = Re(rt), Ke = et.split("+");
                  let qe;
                  for (let ot = 0; ot < Ye; ot++) {
                    rt.pos = (rt.start || 0) + tt[ot];
                    const Je = ke(rt), Ct = _e(rt, Je.numTables);
                    if (!Ct.name)
                      throw new g.FormatError('TrueType Collection font must contain a "name" table.');
                    const [Tt] = De(Ct.name);
                    for (let yt = 0, bt = Tt.length; yt < bt; yt++)
                      for (let It = 0, kt = Tt[yt].length; It < kt; It++) {
                        const $t = Tt[yt][It]?.replaceAll(/\s/g, "");
                        if ($t) {
                          if ($t === et)
                            return {
                              header: Je,
                              tables: Ct
                            };
                          if (!(Ke.length < 2))
                            for (const Lt of Ke)
                              $t === Lt && (qe = {
                                name: Lt,
                                header: Je,
                                tables: Ct
                              });
                        }
                      }
                  }
                  if (qe)
                    return (0, g.warn)(`TrueType Collection does not contain "${et}" font, falling back to "${qe.name}" font instead.`), {
                      header: qe.header,
                      tables: qe.tables
                    };
                  throw new g.FormatError(`TrueType Collection does not contain "${et}" font.`);
                }
                function Oe(rt, et, Ye, tt) {
                  if (!rt)
                    return (0, g.warn)("No cmap table available."), {
                      platformId: -1,
                      encodingId: -1,
                      mappings: [],
                      hasShortCmap: !1
                    };
                  let Ke, qe = (et.start || 0) + rt.offset;
                  et.pos = qe, et.skip(2);
                  const ot = et.getUint16();
                  let Je, Ct = !1;
                  for (let $t = 0; $t < ot; $t++) {
                    const Lt = et.getUint16(), Ft = et.getUint16(), Vt = et.getInt32() >>> 0;
                    let rr = !1;
                    if (!(Je?.platformId === Lt && Je?.encodingId === Ft)) {
                      if (Lt === 0 && (Ft === 0 || Ft === 1 || Ft === 3))
                        rr = !0;
                      else if (Lt === 1 && Ft === 0)
                        rr = !0;
                      else if (Lt === 3 && Ft === 1 && (tt || !Je))
                        rr = !0, Ye || (Ct = !0);
                      else if (Ye && Lt === 3 && Ft === 0) {
                        rr = !0;
                        let br = !0;
                        if ($t < ot - 1) {
                          const Gt = et.peekBytes(2);
                          D(Gt[0], Gt[1]) < Lt && (br = !1);
                        }
                        br && (Ct = !0);
                      }
                      if (rr && (Je = {
                        platformId: Lt,
                        encodingId: Ft,
                        offset: Vt
                      }), Ct)
                        break;
                    }
                  }
                  if (Je && (et.pos = qe + Je.offset), !Je || et.peekByte() === -1)
                    return (0, g.warn)("Could not find a preferred cmap table."), {
                      platformId: -1,
                      encodingId: -1,
                      mappings: [],
                      hasShortCmap: !1
                    };
                  const Tt = et.getUint16();
                  let yt = !1;
                  const bt = [];
                  let It, kt;
                  if (Tt === 0) {
                    for (et.skip(4), It = 0; It < 256; It++) {
                      const $t = et.getByte();
                      $t && bt.push({
                        charCode: It,
                        glyphId: $t
                      });
                    }
                    yt = !0;
                  } else if (Tt === 2) {
                    et.skip(4);
                    const $t = [];
                    let Lt = 0;
                    for (let Vt = 0; Vt < 256; Vt++) {
                      const rr = et.getUint16() >> 3;
                      $t.push(rr), Lt = Math.max(rr, Lt);
                    }
                    const Ft = [];
                    for (let Vt = 0; Vt <= Lt; Vt++)
                      Ft.push({
                        firstCode: et.getUint16(),
                        entryCount: et.getUint16(),
                        idDelta: V(et.getByte(), et.getByte()),
                        idRangePos: et.pos + et.getUint16()
                      });
                    for (let Vt = 0; Vt < 256; Vt++)
                      if ($t[Vt] === 0)
                        et.pos = Ft[0].idRangePos + 2 * Vt, kt = et.getUint16(), bt.push({
                          charCode: Vt,
                          glyphId: kt
                        });
                      else {
                        const rr = Ft[$t[Vt]];
                        for (It = 0; It < rr.entryCount; It++) {
                          const br = (Vt << 8) + It + rr.firstCode;
                          et.pos = rr.idRangePos + 2 * It, kt = et.getUint16(), kt !== 0 && (kt = (kt + rr.idDelta) % 65536), bt.push({
                            charCode: br,
                            glyphId: kt
                          });
                        }
                      }
                  } else if (Tt === 4) {
                    et.skip(4);
                    const $t = et.getUint16() >> 1;
                    et.skip(6);
                    const Lt = [];
                    let Ft;
                    for (Ft = 0; Ft < $t; Ft++)
                      Lt.push({
                        end: et.getUint16()
                      });
                    for (et.skip(2), Ft = 0; Ft < $t; Ft++)
                      Lt[Ft].start = et.getUint16();
                    for (Ft = 0; Ft < $t; Ft++)
                      Lt[Ft].delta = et.getUint16();
                    let Vt = 0, rr;
                    for (Ft = 0; Ft < $t; Ft++) {
                      Ke = Lt[Ft];
                      const Gt = et.getUint16();
                      if (!Gt) {
                        Ke.offsetIndex = -1;
                        continue;
                      }
                      rr = (Gt >> 1) - ($t - Ft), Ke.offsetIndex = rr, Vt = Math.max(Vt, rr + Ke.end - Ke.start + 1);
                    }
                    const br = [];
                    for (It = 0; It < Vt; It++)
                      br.push(et.getUint16());
                    for (Ft = 0; Ft < $t; Ft++) {
                      Ke = Lt[Ft], qe = Ke.start;
                      const Gt = Ke.end, qt = Ke.delta;
                      for (rr = Ke.offsetIndex, It = qe; It <= Gt; It++)
                        It !== 65535 && (kt = rr < 0 ? It : br[rr + It - qe], kt = kt + qt & 65535, bt.push({
                          charCode: It,
                          glyphId: kt
                        }));
                    }
                  } else if (Tt === 6) {
                    et.skip(4);
                    const $t = et.getUint16(), Lt = et.getUint16();
                    for (It = 0; It < Lt; It++) {
                      kt = et.getUint16();
                      const Ft = $t + It;
                      bt.push({
                        charCode: Ft,
                        glyphId: kt
                      });
                    }
                  } else if (Tt === 12) {
                    et.skip(10);
                    const $t = et.getInt32() >>> 0;
                    for (It = 0; It < $t; It++) {
                      const Lt = et.getInt32() >>> 0, Ft = et.getInt32() >>> 0;
                      let Vt = et.getInt32() >>> 0;
                      for (let rr = Lt; rr <= Ft; rr++)
                        bt.push({
                          charCode: rr,
                          glyphId: Vt++
                        });
                    }
                  } else
                    return (0, g.warn)("cmap table has unsupported format: " + Tt), {
                      platformId: -1,
                      encodingId: -1,
                      mappings: [],
                      hasShortCmap: !1
                    };
                  bt.sort(function($t, Lt) {
                    return $t.charCode - Lt.charCode;
                  });
                  for (let $t = 1; $t < bt.length; $t++)
                    bt[$t - 1].charCode === bt[$t].charCode && (bt.splice($t, 1), $t--);
                  return {
                    platformId: Je.platformId,
                    encodingId: Je.encodingId,
                    mappings: bt,
                    hasShortCmap: yt
                  };
                }
                function Me(rt, et, Ye, tt, Ke, qe) {
                  if (!et) {
                    Ye && (Ye.data = null);
                    return;
                  }
                  rt.pos = (rt.start || 0) + et.offset, rt.pos += 4, rt.pos += 2, rt.pos += 2, rt.pos += 2, rt.pos += 2, rt.pos += 2, rt.pos += 2, rt.pos += 2, rt.pos += 2, rt.pos += 2;
                  const ot = rt.getUint16();
                  rt.pos += 8, rt.pos += 2;
                  let Je = rt.getUint16();
                  ot !== 0 && (D(tt.data[44], tt.data[45]) & 2 || (et.data[22] = 0, et.data[23] = 0)), Je > Ke && ((0, g.info)(`The numOfMetrics (${Je}) should not be greater than the numGlyphs (${Ke}).`), Je = Ke, et.data[34] = (Je & 65280) >> 8, et.data[35] = Je & 255);
                  const Tt = Ke - Je - (Ye.length - Je * 4 >> 1);
                  if (Tt > 0) {
                    const yt = new Uint8Array(Ye.length + Tt * 2);
                    yt.set(Ye.data), qe && (yt[Ye.length] = Ye.data[2], yt[Ye.length + 1] = Ye.data[3]), Ye.data = yt;
                  }
                }
                function Fe(rt, et, Ye, tt, Ke, qe) {
                  const ot = {
                    length: 0,
                    sizeOfInstructions: 0
                  };
                  if (et < 0 || et >= rt.length || Ye > rt.length || Ye - et <= 12)
                    return ot;
                  const Je = rt.subarray(et, Ye), Ct = V(Je[2], Je[3]), Tt = V(Je[4], Je[5]), yt = V(Je[6], Je[7]), bt = V(Je[8], Je[9]);
                  Ct > yt && (H(Je, 2, yt), H(Je, 6, Ct)), Tt > bt && (H(Je, 4, bt), H(Je, 8, Tt));
                  const It = V(Je[0], Je[1]);
                  if (It < 0)
                    return It < -1 || (tt.set(Je, Ke), ot.length = Je.length), ot;
                  let kt, $t = 10, Lt = 0;
                  for (kt = 0; kt < It; kt++)
                    Lt = (Je[$t] << 8 | Je[$t + 1]) + 1, $t += 2;
                  const Ft = $t, Vt = Je[$t] << 8 | Je[$t + 1];
                  ot.sizeOfInstructions = Vt, $t += 2 + Vt;
                  const rr = $t;
                  let br = 0;
                  for (kt = 0; kt < Lt; kt++) {
                    const qt = Je[$t++];
                    qt & 192 && (Je[$t - 1] = qt & 63);
                    let Jt = 2;
                    qt & 2 ? Jt = 1 : qt & 16 && (Jt = 0);
                    let jt = 2;
                    qt & 4 ? jt = 1 : qt & 32 && (jt = 0);
                    const Ht = Jt + jt;
                    if (br += Ht, qt & 8) {
                      const ur = Je[$t++];
                      ur === 0 && (Je[$t - 1] ^= 8), kt += ur, br += ur * Ht;
                    }
                  }
                  if (br === 0)
                    return ot;
                  let Gt = $t + br;
                  return Gt > Je.length ? ot : !qe && Vt > 0 ? (tt.set(Je.subarray(0, Ft), Ke), tt.set([0, 0], Ke + Ft), tt.set(Je.subarray(rr, Gt), Ke + Ft + 2), Gt -= Vt, Je.length - Gt > 3 && (Gt = Gt + 3 & -4), ot.length = Gt, ot) : Je.length - Gt > 3 ? (Gt = Gt + 3 & -4, tt.set(Je.subarray(0, Gt), Ke), ot.length = Gt, ot) : (tt.set(Je, Ke), ot.length = Je.length, ot);
                }
                function Ue(rt, et, Ye) {
                  const tt = rt.data, Ke = Z(tt[0], tt[1], tt[2], tt[3]);
                  Ke >> 16 !== 1 && ((0, g.info)("Attempting to fix invalid version in head table: " + Ke), tt[0] = 0, tt[1] = 1, tt[2] = 0, tt[3] = 0);
                  const qe = D(tt[50], tt[51]);
                  if (qe < 0 || qe > 1) {
                    (0, g.info)("Attempting to fix invalid indexToLocFormat in head table: " + qe);
                    const ot = et + 1;
                    if (Ye === ot << 1)
                      tt[50] = 0, tt[51] = 0;
                    else if (Ye === ot << 2)
                      tt[50] = 0, tt[51] = 1;
                    else
                      throw new g.FormatError("Could not fix indexToLocFormat: " + qe);
                  }
                }
                function je(rt, et, Ye, tt, Ke, qe, ot) {
                  let Je, Ct, Tt;
                  tt ? (Je = 4, Ct = function(Jt, jt) {
                    return Jt[jt] << 24 | Jt[jt + 1] << 16 | Jt[jt + 2] << 8 | Jt[jt + 3];
                  }, Tt = function(Jt, jt, Ht) {
                    Jt[jt] = Ht >>> 24 & 255, Jt[jt + 1] = Ht >> 16 & 255, Jt[jt + 2] = Ht >> 8 & 255, Jt[jt + 3] = Ht & 255;
                  }) : (Je = 2, Ct = function(Jt, jt) {
                    return Jt[jt] << 9 | Jt[jt + 1] << 1;
                  }, Tt = function(Jt, jt, Ht) {
                    Jt[jt] = Ht >> 9 & 255, Jt[jt + 1] = Ht >> 1 & 255;
                  });
                  const yt = qe ? Ye + 1 : Ye, bt = Je * (1 + yt), It = new Uint8Array(bt);
                  It.set(rt.data.subarray(0, bt)), rt.data = It;
                  const kt = et.data, $t = kt.length, Lt = new Uint8Array($t);
                  let Ft, Vt;
                  const rr = [];
                  for (Ft = 0, Vt = 0; Ft < Ye + 1; Ft++, Vt += Je) {
                    let qt = Ct(It, Vt);
                    qt > $t && (qt = $t), rr.push({
                      index: Ft,
                      offset: qt,
                      endOffset: 0
                    });
                  }
                  for (rr.sort((qt, Jt) => qt.offset - Jt.offset), Ft = 0; Ft < Ye; Ft++)
                    rr[Ft].endOffset = rr[Ft + 1].offset;
                  for (rr.sort((qt, Jt) => qt.index - Jt.index), Ft = 0; Ft < Ye; Ft++) {
                    const {
                      offset: qt,
                      endOffset: Jt
                    } = rr[Ft];
                    if (qt !== 0 || Jt !== 0)
                      break;
                    const jt = rr[Ft + 1].offset;
                    if (jt !== 0) {
                      rr[Ft].endOffset = jt;
                      break;
                    }
                  }
                  const br = /* @__PURE__ */ Object.create(null);
                  let Gt = 0;
                  for (Tt(It, 0, Gt), Ft = 0, Vt = Je; Ft < Ye; Ft++, Vt += Je) {
                    const qt = Fe(kt, rr[Ft].offset, rr[Ft].endOffset, Lt, Gt, Ke), Jt = qt.length;
                    Jt === 0 && (br[Ft] = !0), qt.sizeOfInstructions > ot && (ot = qt.sizeOfInstructions), Gt += Jt, Tt(It, Vt, Gt);
                  }
                  if (Gt === 0) {
                    const qt = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                    for (Ft = 0, Vt = Je; Ft < yt; Ft++, Vt += Je)
                      Tt(It, Vt, qt.length);
                    et.data = qt;
                  } else if (qe) {
                    const qt = Ct(It, Je);
                    Lt.length > qt + Gt ? et.data = Lt.subarray(0, qt + Gt) : (et.data = new Uint8Array(qt + Gt), et.data.set(Lt.subarray(0, Gt))), et.data.set(Lt.subarray(0, qt), Gt), Tt(rt.data, It.length - Je, Gt + qt);
                  } else
                    et.data = Lt.subarray(0, Gt);
                  return {
                    missingGlyphs: br,
                    maxSizeOfInstructions: ot
                  };
                }
                function Le(rt, et, Ye) {
                  const tt = (ue.start || 0) + rt.offset;
                  ue.pos = tt;
                  const Ke = rt.length, qe = tt + Ke, ot = ue.getInt32();
                  ue.skip(28);
                  let Je, Ct = !0, Tt;
                  switch (ot) {
                    case 65536:
                      Je = y.MacStandardGlyphOrdering;
                      break;
                    case 131072:
                      const yt = ue.getUint16();
                      if (yt !== Ye) {
                        Ct = !1;
                        break;
                      }
                      const bt = [];
                      for (Tt = 0; Tt < yt; ++Tt) {
                        const $t = ue.getUint16();
                        if ($t >= 32768) {
                          Ct = !1;
                          break;
                        }
                        bt.push($t);
                      }
                      if (!Ct)
                        break;
                      const It = [], kt = [];
                      for (; ue.pos < qe; ) {
                        const $t = ue.getByte();
                        for (kt.length = $t, Tt = 0; Tt < $t; ++Tt)
                          kt[Tt] = String.fromCharCode(ue.getByte());
                        It.push(kt.join(""));
                      }
                      for (Je = [], Tt = 0; Tt < yt; ++Tt) {
                        const $t = bt[Tt];
                        if ($t < 258) {
                          Je.push(y.MacStandardGlyphOrdering[$t]);
                          continue;
                        }
                        Je.push(It[$t - 258]);
                      }
                      break;
                    case 196608:
                      break;
                    default:
                      (0, g.warn)("Unknown/unsupported post table version " + ot), Ct = !1, et.defaultEncoding && (Je = et.defaultEncoding);
                      break;
                  }
                  return et.glyphNames = Je, Ct;
                }
                function De(rt) {
                  const et = (ue.start || 0) + rt.offset;
                  ue.pos = et;
                  const Ye = [[], []], tt = [], Ke = rt.length, qe = et + Ke;
                  if (ue.getUint16() !== 0 || Ke < 6)
                    return [Ye, tt];
                  const Ct = ue.getUint16(), Tt = ue.getUint16(), yt = 12;
                  let bt, It;
                  for (bt = 0; bt < Ct && ue.pos + yt <= qe; bt++) {
                    const kt = {
                      platform: ue.getUint16(),
                      encoding: ue.getUint16(),
                      language: ue.getUint16(),
                      name: ue.getUint16(),
                      length: ue.getUint16(),
                      offset: ue.getUint16()
                    };
                    (ie(kt) || fe(kt)) && tt.push(kt);
                  }
                  for (bt = 0, It = tt.length; bt < It; bt++) {
                    const kt = tt[bt];
                    if (kt.length <= 0)
                      continue;
                    const $t = et + Tt + kt.offset;
                    if ($t + kt.length > qe)
                      continue;
                    ue.pos = $t;
                    const Lt = kt.name;
                    if (kt.encoding) {
                      let Ft = "";
                      for (let Vt = 0, rr = kt.length; Vt < rr; Vt += 2)
                        Ft += String.fromCharCode(ue.getUint16());
                      Ye[1][Lt] = Ft;
                    } else
                      Ye[0][Lt] = ue.getString(kt.length);
                  }
                  return [Ye, tt];
                }
                const Ne = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
                function Ge(rt, et) {
                  let Ye = rt.data, tt = 0, Ke, qe, ot, Je, Ct, Tt = 0, yt = 0;
                  const bt = [], It = [], kt = [];
                  let $t = et.tooComplexToFollowFunctions, Lt = !1, Ft = 0, Vt = 0;
                  for (let br = Ye.length; tt < br; ) {
                    const Gt = Ye[tt++];
                    if (Gt === 64)
                      if (qe = Ye[tt++], Lt || Vt)
                        tt += qe;
                      else
                        for (Ke = 0; Ke < qe; Ke++)
                          bt.push(Ye[tt++]);
                    else if (Gt === 65)
                      if (qe = Ye[tt++], Lt || Vt)
                        tt += qe * 2;
                      else
                        for (Ke = 0; Ke < qe; Ke++)
                          ot = Ye[tt++], bt.push(ot << 8 | Ye[tt++]);
                    else if ((Gt & 248) === 176)
                      if (qe = Gt - 176 + 1, Lt || Vt)
                        tt += qe;
                      else
                        for (Ke = 0; Ke < qe; Ke++)
                          bt.push(Ye[tt++]);
                    else if ((Gt & 248) === 184)
                      if (qe = Gt - 184 + 1, Lt || Vt)
                        tt += qe * 2;
                      else
                        for (Ke = 0; Ke < qe; Ke++)
                          ot = Ye[tt++], bt.push(ot << 8 | Ye[tt++]);
                    else if (Gt === 43 && !$t) {
                      if (!Lt && !Vt) {
                        if (Je = bt.at(-1), isNaN(Je))
                          (0, g.info)("TT: CALL empty stack (or invalid entry).");
                        else if (et.functionsUsed[Je] = !0, Je in et.functionsStackDeltas) {
                          const qt = bt.length + et.functionsStackDeltas[Je];
                          if (qt < 0) {
                            (0, g.warn)("TT: CALL invalid functions stack delta."), et.hintsValid = !1;
                            return;
                          }
                          bt.length = qt;
                        } else if (Je in et.functionsDefined && !kt.includes(Je)) {
                          if (It.push({
                            data: Ye,
                            i: tt,
                            stackTop: bt.length - 1
                          }), kt.push(Je), Ct = et.functionsDefined[Je], !Ct) {
                            (0, g.warn)("TT: CALL non-existent function"), et.hintsValid = !1;
                            return;
                          }
                          Ye = Ct.data, tt = Ct.i;
                        }
                      }
                    } else if (Gt === 44 && !$t)
                      (Lt || Vt) && ((0, g.warn)("TT: nested FDEFs not allowed"), $t = !0), Lt = !0, yt = tt, Je = bt.pop(), et.functionsDefined[Je] = {
                        data: Ye,
                        i: tt
                      };
                    else if (Gt === 45)
                      if (Lt)
                        Lt = !1, Tt = tt;
                      else {
                        if (Ct = It.pop(), !Ct) {
                          (0, g.warn)("TT: ENDF bad stack"), et.hintsValid = !1;
                          return;
                        }
                        Je = kt.pop(), Ye = Ct.data, tt = Ct.i, et.functionsStackDeltas[Je] = bt.length - Ct.stackTop;
                      }
                    else if (Gt === 137)
                      (Lt || Vt) && ((0, g.warn)("TT: nested IDEFs not allowed"), $t = !0), Lt = !0, yt = tt;
                    else if (Gt === 88)
                      ++Ft;
                    else if (Gt === 27)
                      Vt = Ft;
                    else if (Gt === 89)
                      Vt === Ft && (Vt = 0), --Ft;
                    else if (Gt === 28 && !Lt && !Vt) {
                      const qt = bt.at(-1);
                      qt > 0 && (tt += qt - 1);
                    }
                    if (!Lt && !Vt) {
                      let qt = 0;
                      for (Gt <= 142 ? qt = Ne[Gt] : Gt >= 192 && Gt <= 223 ? qt = -1 : Gt >= 224 && (qt = -2), Gt >= 113 && Gt <= 117 && (qe = bt.pop(), isNaN(qe) || (qt = -qe * 2)); qt < 0 && bt.length > 0; )
                        bt.pop(), qt++;
                      for (; qt > 0; )
                        bt.push(NaN), qt--;
                    }
                  }
                  et.tooComplexToFollowFunctions = $t;
                  const rr = [Ye];
                  tt > Ye.length && rr.push(new Uint8Array(tt - Ye.length)), yt > Tt && ((0, g.warn)("TT: complementing a missing function tail"), rr.push(new Uint8Array([34, 45]))), nt(rt, rr);
                }
                function Xe(rt, et) {
                  if (!rt.tooComplexToFollowFunctions) {
                    if (rt.functionsDefined.length > et) {
                      (0, g.warn)("TT: more functions defined than expected"), rt.hintsValid = !1;
                      return;
                    }
                    for (let Ye = 0, tt = rt.functionsUsed.length; Ye < tt; Ye++) {
                      if (Ye > et) {
                        (0, g.warn)("TT: invalid function id: " + Ye), rt.hintsValid = !1;
                        return;
                      }
                      if (rt.functionsUsed[Ye] && !rt.functionsDefined[Ye]) {
                        (0, g.warn)("TT: undefined function: " + Ye), rt.hintsValid = !1;
                        return;
                      }
                    }
                  }
                }
                function nt(rt, et) {
                  if (et.length > 1) {
                    let Ye = 0, tt, Ke;
                    for (tt = 0, Ke = et.length; tt < Ke; tt++)
                      Ye += et[tt].length;
                    Ye = Ye + 3 & -4;
                    const qe = new Uint8Array(Ye);
                    let ot = 0;
                    for (tt = 0, Ke = et.length; tt < Ke; tt++)
                      qe.set(et[tt], ot), ot += et[tt].length;
                    rt.data = qe, rt.length = Ye;
                  }
                }
                function ct(rt, et, Ye, tt) {
                  const Ke = {
                    functionsDefined: [],
                    functionsUsed: [],
                    functionsStackDeltas: [],
                    tooComplexToFollowFunctions: !1,
                    hintsValid: !0
                  };
                  if (rt && Ge(rt, Ke), et && Ge(et, Ke), rt && Xe(Ke, tt), Ye && Ye.length & 1) {
                    const qe = new Uint8Array(Ye.length + 1);
                    qe.set(Ye.data), Ye.data = qe;
                  }
                  return Ke.hintsValid;
                }
                ue = new L.Stream(new Uint8Array(ue.getBytes()));
                let it, We;
                if (Y(ue)) {
                  const rt = Be(ue, this.name);
                  it = rt.header, We = rt.tables;
                } else
                  it = ke(ue), We = _e(ue, it.numTables);
                let Ve, ut;
                const at = !We["CFF "];
                if (at) {
                  if (!We.loca)
                    throw new g.FormatError('Required "loca" table is not found');
                  We.glyf || ((0, g.warn)('Required "glyf" table is not found -- trying to recover.'), We.glyf = {
                    tag: "glyf",
                    data: new Uint8Array(0)
                  }), this.isOpenType = !1;
                } else {
                  const rt = ce.composite && (ce.cidToGidMap?.length > 0 || !(ce.cMap instanceof E.IdentityCMap));
                  if (it.version === "OTTO" && !rt || !We.head || !We.hhea || !We.maxp || !We.post)
                    return ut = new L.Stream(We["CFF "].data), Ve = new $.CFFFont(ut, ce), G(ce), this.convert(Ae, Ve, ce);
                  delete We.glyf, delete We.loca, delete We.fpgm, delete We.prep, delete We["cvt "], this.isOpenType = !0;
                }
                if (!We.maxp)
                  throw new g.FormatError('Required "maxp" table is not found');
                ue.pos = (ue.start || 0) + We.maxp.offset;
                const Qe = ue.getInt32(), st = ue.getUint16();
                if (ce.scaleFactors?.length === st && at) {
                  const {
                    scaleFactors: rt
                  } = ce, et = D(We.head.data[50], We.head.data[51]), Ye = new _.GlyfTable({
                    glyfTable: We.glyf.data,
                    isGlyphLocationsLong: et,
                    locaTable: We.loca.data,
                    numGlyphs: st
                  });
                  Ye.scale(rt);
                  const {
                    glyf: tt,
                    loca: Ke,
                    isLocationLong: qe
                  } = Ye.write();
                  We.glyf.data = tt, We.loca.data = Ke, qe !== !!et && (We.head.data[50] = 0, We.head.data[51] = qe ? 1 : 0);
                  const ot = We.hmtx.data;
                  for (let Je = 0; Je < st; Je++) {
                    const Ct = 4 * Je, Tt = Math.round(rt[Je] * D(ot[Ct], ot[Ct + 1]));
                    ot[Ct] = Tt >> 8 & 255, ot[Ct + 1] = Tt & 255;
                    const yt = Math.round(rt[Je] * V(ot[Ct + 2], ot[Ct + 3]));
                    H(ot, Ct + 2, yt);
                  }
                }
                let ft = st + 1, vt = !0;
                ft > 65535 && (vt = !1, ft = st, (0, g.warn)("Not enough space in glyfs to duplicate first glyph."));
                let Pt = 0, dt = 0;
                Qe >= 65536 && We.maxp.length >= 22 && (ue.pos += 8, ue.getUint16() > 2 && (We.maxp.data[14] = 0, We.maxp.data[15] = 2), ue.pos += 4, Pt = ue.getUint16(), ue.pos += 4, dt = ue.getUint16()), We.maxp.data[4] = ft >> 8, We.maxp.data[5] = ft & 255;
                const mt = ct(We.fpgm, We.prep, We["cvt "], Pt);
                if (mt || (delete We.fpgm, delete We.prep, delete We["cvt "]), Me(ue, We.hhea, We.hmtx, We.head, ft, vt), !We.head)
                  throw new g.FormatError('Required "head" table is not found');
                Ue(We.head, st, at ? We.loca.length : 0);
                let pt = /* @__PURE__ */ Object.create(null);
                if (at) {
                  const rt = D(We.head.data[50], We.head.data[51]), et = je(We.loca, We.glyf, st, rt, mt, vt, dt);
                  pt = et.missingGlyphs, Qe >= 65536 && We.maxp.length >= 22 && (We.maxp.data[26] = et.maxSizeOfInstructions >> 8, We.maxp.data[27] = et.maxSizeOfInstructions & 255);
                }
                if (!We.hhea)
                  throw new g.FormatError('Required "hhea" table is not found');
                We.hhea.data[10] === 0 && We.hhea.data[11] === 0 && (We.hhea.data[10] = 255, We.hhea.data[11] = 255);
                const Et = {
                  unitsPerEm: D(We.head.data[18], We.head.data[19]),
                  yMax: V(We.head.data[42], We.head.data[43]),
                  yMin: V(We.head.data[38], We.head.data[39]),
                  ascent: V(We.hhea.data[4], We.hhea.data[5]),
                  descent: V(We.hhea.data[6], We.hhea.data[7]),
                  lineGap: V(We.hhea.data[8], We.hhea.data[9])
                };
                this.ascent = Et.ascent / Et.unitsPerEm, this.descent = Et.descent / Et.unitsPerEm, this.lineGap = Et.lineGap / Et.unitsPerEm, this.cssFontInfo?.lineHeight ? (this.lineHeight = this.cssFontInfo.metrics.lineHeight, this.lineGap = this.cssFontInfo.metrics.lineGap) : this.lineHeight = this.ascent - this.descent + this.lineGap, We.post && Le(We.post, ce, st), We.post = {
                  tag: "post",
                  data: he(ce)
                };
                const Mt = [];
                function Nt(rt) {
                  return !pt[rt];
                }
                if (ce.composite) {
                  const rt = ce.cidToGidMap || [], et = rt.length === 0;
                  ce.cMap.forEach(function(Ye, tt) {
                    if (typeof tt == "string" && (tt = ge(Ye, tt, !0)), tt > 65535)
                      throw new g.FormatError("Max size of CID is 65,535");
                    let Ke = -1;
                    et ? Ke = tt : rt[tt] !== void 0 && (Ke = rt[tt]), Ke >= 0 && Ke < st && Nt(Ke) && (Mt[Ye] = Ke);
                  });
                } else {
                  const rt = Oe(We.cmap, ue, this.isSymbolicFont, ce.hasEncoding), et = rt.platformId, Ye = rt.encodingId, tt = rt.mappings;
                  let Ke = [], qe = !1;
                  if (ce.hasEncoding && (ce.baseEncodingName === "MacRomanEncoding" || ce.baseEncodingName === "WinAnsiEncoding") && (Ke = (0, C.getEncoding)(ce.baseEncodingName)), ce.hasEncoding && !this.isSymbolicFont && (et === 3 && Ye === 1 || et === 1 && Ye === 0)) {
                    const ot = (0, m.getGlyphsUnicode)();
                    for (let Je = 0; Je < 256; Je++) {
                      let Ct;
                      if (this.differences[Je] !== void 0 ? Ct = this.differences[Je] : Ke.length && Ke[Je] !== "" ? Ct = Ke[Je] : Ct = C.StandardEncoding[Je], !Ct)
                        continue;
                      const Tt = (0, y.recoverGlyphName)(Ct, ot);
                      let yt;
                      if (et === 3 && Ye === 1 ? yt = ot[Tt] : et === 1 && Ye === 0 && (yt = C.MacRomanEncoding.indexOf(Tt)), yt === void 0) {
                        if (!ce.glyphNames && ce.hasIncludedToUnicodeMap && !(this.toUnicode instanceof S.IdentityToUnicodeMap)) {
                          const bt = this.toUnicode.get(Je);
                          bt && (yt = bt.codePointAt(0));
                        }
                        if (yt === void 0)
                          continue;
                      }
                      for (const bt of tt)
                        if (bt.charCode === yt) {
                          Mt[Je] = bt.glyphId;
                          break;
                        }
                    }
                  } else if (et === 0) {
                    for (const ot of tt)
                      Mt[ot.charCode] = ot.glyphId;
                    qe = !0;
                  } else
                    for (const ot of tt) {
                      let Je = ot.charCode;
                      et === 3 && Je >= 61440 && Je <= 61695 && (Je &= 255), Mt[Je] = ot.glyphId;
                    }
                  if (ce.glyphNames && (Ke.length || this.differences.length))
                    for (let ot = 0; ot < 256; ++ot) {
                      if (!qe && Mt[ot] !== void 0)
                        continue;
                      const Je = this.differences[ot] || Ke[ot];
                      if (!Je)
                        continue;
                      const Ct = ce.glyphNames.indexOf(Je);
                      Ct > 0 && Nt(Ct) && (Mt[ot] = Ct);
                    }
                }
                Mt.length === 0 && (Mt[0] = 0);
                let _t = ft - 1;
                if (vt || (_t = 0), !ce.cssFontInfo) {
                  const rt = me(Mt, Nt, _t, this.toUnicode);
                  this.toFontChar = rt.toFontChar, We.cmap = {
                    tag: "cmap",
                    data: be(rt.charCodeToGlyphId, rt.toUnicodeExtraMap, ft)
                  }, (!We["OS/2"] || !le(We["OS/2"], ue)) && (We["OS/2"] = {
                    tag: "OS/2",
                    data: ve(ce, rt.charCodeToGlyphId, Et)
                  });
                }
                if (!at)
                  try {
                    ut = new L.Stream(We["CFF "].data), Ve = new b.CFFParser(ut, ce, y.SEAC_ANALYSIS_ENABLED).parse(), Ve.duplicateFirstGlyph();
                    const et = new b.CFFCompiler(Ve);
                    We["CFF "].data = et.compile();
                  } catch {
                    (0, g.warn)("Failed to compile font " + ce.loadedName);
                  }
                if (!We.name)
                  We.name = {
                    tag: "name",
                    data: Ce(this.name)
                  };
                else {
                  const [rt, et] = De(We.name);
                  We.name.data = Ce(Ae, rt), this.psName = rt[0][6] || null, ce.composite || U(ce, this.isSymbolicFont, et);
                }
                const Ot = new R.OpenTypeFileBuilder(it.version);
                for (const rt in We)
                  Ot.addTable(rt, We[rt].data);
                return Ot.toArray();
              }
              convert(Ae, ue, ce) {
                ce.fixedPitch = !1, ce.builtInEncoding && k(ce, ce.builtInEncoding);
                let Ee = 1;
                ue instanceof $.CFFFont && (Ee = ue.numGlyphs - 1);
                const _e = ue.getGlyphMapping(ce);
                let Te = null, ke = _e, Re = null;
                ce.cssFontInfo || (Te = me(_e, ue.hasGlyphId.bind(ue), Ee, this.toUnicode), this.toFontChar = Te.toFontChar, ke = Te.charCodeToGlyphId, Re = Te.toUnicodeExtraMap);
                const Be = ue.numGlyphs;
                function Oe(Le, De) {
                  let Ne = null;
                  for (const Ge in Le)
                    De === Le[Ge] && (Ne ||= []).push(Ge | 0);
                  return Ne;
                }
                function Me(Le, De) {
                  for (const Ne in Le)
                    if (De === Le[Ne])
                      return Ne | 0;
                  return Te.charCodeToGlyphId[Te.nextAvailableFontCharCode] = De, Te.nextAvailableFontCharCode++;
                }
                const Fe = ue.seacs;
                if (Te && y.SEAC_ANALYSIS_ENABLED && Fe?.length) {
                  const Le = ce.fontMatrix || g.FONT_IDENTITY_MATRIX, De = ue.getCharset(), Ne = /* @__PURE__ */ Object.create(null);
                  for (let Ge in Fe) {
                    Ge |= 0;
                    const Xe = Fe[Ge], nt = C.StandardEncoding[Xe[2]], ct = C.StandardEncoding[Xe[3]], it = De.indexOf(nt), We = De.indexOf(ct);
                    if (it < 0 || We < 0)
                      continue;
                    const Ve = {
                      x: Xe[0] * Le[0] + Xe[1] * Le[2] + Le[4],
                      y: Xe[0] * Le[1] + Xe[1] * Le[3] + Le[5]
                    }, ut = Oe(_e, Ge);
                    if (ut)
                      for (const at of ut) {
                        const Qe = Te.charCodeToGlyphId, st = Me(Qe, it), ft = Me(Qe, We);
                        Ne[at] = {
                          baseFontCharCode: st,
                          accentFontCharCode: ft,
                          accentOffset: Ve
                        };
                      }
                  }
                  ce.seacMap = Ne;
                }
                const Ue = 1 / (ce.fontMatrix || g.FONT_IDENTITY_MATRIX)[0], je = new R.OpenTypeFileBuilder("OTTO");
                return je.addTable("CFF ", ue.data), je.addTable("OS/2", ve(ce, ke)), je.addTable("cmap", be(ke, Re, Be)), je.addTable("head", "\0\0\0\0\0\0\0\0\0\0_<õ\0\0" + K(Ue) + "\0\0\0\0\v~'\0\0\0\0\v~'\0\0" + K(ce.descent) + "ÿ" + K(ce.ascent) + ne(ce.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0"), je.addTable("hhea", "\0\0\0" + K(ce.ascent) + K(ce.descent) + "\0\0ÿÿ\0\0\0\0\0\0" + K(ce.capHeight) + K(Math.tan(ce.italicAngle) * ce.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + ne(Be)), je.addTable("hmtx", function() {
                  const De = ue.charstrings, Ne = ue.cff ? ue.cff.widths : null;
                  let Ge = "\0\0\0\0";
                  for (let Xe = 1, nt = Be; Xe < nt; Xe++) {
                    let ct = 0;
                    if (De) {
                      const it = De[Xe - 1];
                      ct = "width" in it ? it.width : 0;
                    } else Ne && (ct = Math.ceil(Ne[Xe] || 0));
                    Ge += ne(ct) + ne(0);
                  }
                  return Ge;
                }()), je.addTable("maxp", "\0\0P\0" + ne(Be)), je.addTable("name", Ce(Ae)), je.addTable("post", he(ce)), je.toArray();
              }
              get spaceWidth() {
                const Ae = ["space", "minus", "one", "i", "I"];
                let ue;
                for (const ce of Ae) {
                  if (ce in this.widths) {
                    ue = this.widths[ce];
                    break;
                  }
                  const _e = (0, m.getGlyphsUnicode)()[ce];
                  let Te = 0;
                  if (this.composite && this.cMap.contains(_e) && (Te = this.cMap.lookup(_e), typeof Te == "string" && (Te = ge(_e, Te))), !Te && this.toUnicode && (Te = this.toUnicode.charCodeOf(_e)), Te <= 0 && (Te = _e), ue = this.widths[Te], ue)
                    break;
                }
                return (0, g.shadow)(this, "spaceWidth", ue || this.defaultWidth);
              }
              _charToGlyph(Ae, ue = !1) {
                let ce = this._glyphCache[Ae];
                if (ce?.isSpace === ue)
                  return ce;
                let Ee, _e, Te, ke = Ae;
                this.cMap?.contains(Ae) && (ke = this.cMap.lookup(Ae), typeof ke == "string" && (ke = ge(Ae, ke))), _e = this.widths[ke], typeof _e != "number" && (_e = this.defaultWidth);
                const Re = this.vmetrics?.[ke];
                let Be = this.toUnicode.get(Ae) || Ae;
                typeof Be == "number" && (Be = String.fromCharCode(Be));
                let Oe = this.toFontChar[Ae] !== void 0;
                if (Ee = this.toFontChar[Ae] || Ae, this.missingFile) {
                  const Ue = this.differences[Ae] || this.defaultEncoding[Ae];
                  (Ue === ".notdef" || Ue === "") && this.type === "Type1" && (Ee = 32), Ee = (0, f.mapSpecialUnicodeValues)(Ee);
                }
                this.isType3Font && (Te = Ee);
                let Me = null;
                if (this.seacMap?.[Ae]) {
                  Oe = !0;
                  const Ue = this.seacMap[Ae];
                  Ee = Ue.baseFontCharCode, Me = {
                    fontChar: String.fromCodePoint(Ue.accentFontCharCode),
                    offset: Ue.accentOffset
                  };
                }
                let Fe = "";
                return typeof Ee == "number" && (Ee <= 1114111 ? Fe = String.fromCodePoint(Ee) : (0, g.warn)(`charToGlyph - invalid fontCharCode: ${Ee}`)), ce = new P(Ae, Fe, Be, Me, _e, Re, Te, ue, Oe), this._glyphCache[Ae] = ce;
              }
              charsToGlyphs(Ae) {
                let ue = this._charsCache[Ae];
                if (ue)
                  return ue;
                if (ue = [], this.cMap) {
                  const ce = /* @__PURE__ */ Object.create(null), Ee = Ae.length;
                  let _e = 0;
                  for (; _e < Ee; ) {
                    this.cMap.readCharCode(Ae, _e, ce);
                    const {
                      charcode: Te,
                      length: ke
                    } = ce;
                    _e += ke;
                    const Re = this._charToGlyph(Te, ke === 1 && Ae.charCodeAt(_e - 1) === 32);
                    ue.push(Re);
                  }
                } else
                  for (let ce = 0, Ee = Ae.length; ce < Ee; ++ce) {
                    const _e = Ae.charCodeAt(ce), Te = this._charToGlyph(_e, _e === 32);
                    ue.push(Te);
                  }
                return this._charsCache[Ae] = ue;
              }
              getCharPositions(Ae) {
                const ue = [];
                if (this.cMap) {
                  const ce = /* @__PURE__ */ Object.create(null);
                  let Ee = 0;
                  for (; Ee < Ae.length; ) {
                    this.cMap.readCharCode(Ae, Ee, ce);
                    const _e = ce.length;
                    ue.push([Ee, Ee + _e]), Ee += _e;
                  }
                } else
                  for (let ce = 0, Ee = Ae.length; ce < Ee; ++ce)
                    ue.push([ce, ce + 1]);
                return ue;
              }
              get glyphCacheValues() {
                return Object.values(this._glyphCache);
              }
              encodeString(Ae) {
                const ue = [], ce = [], Ee = () => ue.length % 2 === 1, _e = this.toUnicode instanceof S.IdentityToUnicodeMap ? (Te) => this.toUnicode.charCodeOf(Te) : (Te) => this.toUnicode.charCodeOf(String.fromCodePoint(Te));
                for (let Te = 0, ke = Ae.length; Te < ke; Te++) {
                  const Re = Ae.codePointAt(Te);
                  if (Re > 55295 && (Re < 57344 || Re > 65533) && Te++, this.toUnicode) {
                    const Be = _e(Re);
                    if (Be !== -1) {
                      Ee() && (ue.push(ce.join("")), ce.length = 0);
                      const Oe = this.cMap ? this.cMap.getCharCodeLength(Be) : 1;
                      for (let Me = Oe - 1; Me >= 0; Me--)
                        ce.push(String.fromCharCode(Be >> 8 * Me & 255));
                      continue;
                    }
                  }
                  Ee() || (ue.push(ce.join("")), ce.length = 0), ce.push(String.fromCodePoint(Re));
                }
                return ue.push(ce.join("")), ue;
              }
            }
            A.Font = xe;
            class we {
              constructor(Ae) {
                this.error = Ae, this.loadedName = "g_font_error", this.missingFile = !0;
              }
              charsToGlyphs() {
                return [];
              }
              encodeString(Ae) {
                return [Ae];
              }
              exportData(Ae = !1) {
                return {
                  error: this.error
                };
              }
            }
            A.ErrorFont = we;
          },
          /* 35 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.CFFTopDict = A.CFFStrings = A.CFFStandardStrings = A.CFFPrivateDict = A.CFFParser = A.CFFIndex = A.CFFHeader = A.CFFFDSelect = A.CFFCompiler = A.CFFCharset = A.CFF = void 0;
            var g = x(2), b = x(36), y = x(37);
            const f = 10, m = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];
            A.CFFStandardStrings = m;
            const C = 391, w = [null, {
              id: "hstem",
              min: 2,
              stackClearing: !0,
              stem: !0
            }, null, {
              id: "vstem",
              min: 2,
              stackClearing: !0,
              stem: !0
            }, {
              id: "vmoveto",
              min: 1,
              stackClearing: !0
            }, {
              id: "rlineto",
              min: 2,
              resetStack: !0
            }, {
              id: "hlineto",
              min: 1,
              resetStack: !0
            }, {
              id: "vlineto",
              min: 1,
              resetStack: !0
            }, {
              id: "rrcurveto",
              min: 6,
              resetStack: !0
            }, null, {
              id: "callsubr",
              min: 1,
              undefStack: !0
            }, {
              id: "return",
              min: 0,
              undefStack: !0
            }, null, null, {
              id: "endchar",
              min: 0,
              stackClearing: !0
            }, null, null, null, {
              id: "hstemhm",
              min: 2,
              stackClearing: !0,
              stem: !0
            }, {
              id: "hintmask",
              min: 0,
              stackClearing: !0
            }, {
              id: "cntrmask",
              min: 0,
              stackClearing: !0
            }, {
              id: "rmoveto",
              min: 2,
              stackClearing: !0
            }, {
              id: "hmoveto",
              min: 1,
              stackClearing: !0
            }, {
              id: "vstemhm",
              min: 2,
              stackClearing: !0,
              stem: !0
            }, {
              id: "rcurveline",
              min: 8,
              resetStack: !0
            }, {
              id: "rlinecurve",
              min: 8,
              resetStack: !0
            }, {
              id: "vvcurveto",
              min: 4,
              resetStack: !0
            }, {
              id: "hhcurveto",
              min: 4,
              resetStack: !0
            }, null, {
              id: "callgsubr",
              min: 1,
              undefStack: !0
            }, {
              id: "vhcurveto",
              min: 4,
              resetStack: !0
            }, {
              id: "hvcurveto",
              min: 4,
              resetStack: !0
            }], S = [null, null, null, {
              id: "and",
              min: 2,
              stackDelta: -1
            }, {
              id: "or",
              min: 2,
              stackDelta: -1
            }, {
              id: "not",
              min: 1,
              stackDelta: 0
            }, null, null, null, {
              id: "abs",
              min: 1,
              stackDelta: 0
            }, {
              id: "add",
              min: 2,
              stackDelta: -1,
              stackFn(N, P) {
                N[P - 2] = N[P - 2] + N[P - 1];
              }
            }, {
              id: "sub",
              min: 2,
              stackDelta: -1,
              stackFn(N, P) {
                N[P - 2] = N[P - 2] - N[P - 1];
              }
            }, {
              id: "div",
              min: 2,
              stackDelta: -1,
              stackFn(N, P) {
                N[P - 2] = N[P - 2] / N[P - 1];
              }
            }, null, {
              id: "neg",
              min: 1,
              stackDelta: 0,
              stackFn(N, P) {
                N[P - 1] = -N[P - 1];
              }
            }, {
              id: "eq",
              min: 2,
              stackDelta: -1
            }, null, null, {
              id: "drop",
              min: 1,
              stackDelta: -1
            }, null, {
              id: "put",
              min: 2,
              stackDelta: -2
            }, {
              id: "get",
              min: 1,
              stackDelta: 0
            }, {
              id: "ifelse",
              min: 4,
              stackDelta: -3
            }, {
              id: "random",
              min: 0,
              stackDelta: 1
            }, {
              id: "mul",
              min: 2,
              stackDelta: -1,
              stackFn(N, P) {
                N[P - 2] = N[P - 2] * N[P - 1];
              }
            }, null, {
              id: "sqrt",
              min: 1,
              stackDelta: 0
            }, {
              id: "dup",
              min: 1,
              stackDelta: 1
            }, {
              id: "exch",
              min: 2,
              stackDelta: 0
            }, {
              id: "index",
              min: 2,
              stackDelta: 0
            }, {
              id: "roll",
              min: 3,
              stackDelta: -2
            }, null, null, null, {
              id: "hflex",
              min: 7,
              resetStack: !0
            }, {
              id: "flex",
              min: 13,
              resetStack: !0
            }, {
              id: "hflex1",
              min: 9,
              resetStack: !0
            }, {
              id: "flex1",
              min: 11,
              resetStack: !0
            }];
            class $ {
              constructor(P, D, H) {
                this.bytes = P.getBytes(), this.properties = D, this.seacAnalysisEnabled = !!H;
              }
              parse() {
                const P = this.properties, D = new T();
                this.cff = D;
                const H = this.parseHeader(), V = this.parseIndex(H.endPos), Z = this.parseIndex(V.endPos), ne = this.parseIndex(Z.endPos), K = this.parseIndex(ne.endPos), q = this.parseDict(Z.obj.get(0)), Y = this.createDict(L, q, D.strings);
                D.header = H.obj, D.names = this.parseNameIndex(V.obj), D.strings = this.parseStringIndex(ne.obj), D.topDict = Y, D.globalSubrIndex = K.obj, this.parsePrivateDict(D.topDict), D.isCIDFont = Y.hasName("ROS");
                const ee = Y.getByName("CharStrings"), Q = this.parseIndex(ee).obj, J = Y.getByName("FontMatrix");
                J && (P.fontMatrix = J);
                const te = Y.getByName("FontBBox");
                te && (P.ascent = Math.max(te[3], te[1]), P.descent = Math.min(te[1], te[3]), P.ascentScaled = !0);
                let ae, se;
                if (D.isCIDFont) {
                  const fe = this.parseIndex(Y.getByName("FDArray")).obj;
                  for (let ge = 0, me = fe.count; ge < me; ++ge) {
                    const pe = fe.get(ge), be = this.createDict(L, this.parseDict(pe), D.strings);
                    this.parsePrivateDict(be), D.fdArray.push(be);
                  }
                  se = null, ae = this.parseCharsets(Y.getByName("charset"), Q.count, D.strings, !0), D.fdSelect = this.parseFDSelect(Y.getByName("FDSelect"), Q.count);
                } else
                  ae = this.parseCharsets(Y.getByName("charset"), Q.count, D.strings, !1), se = this.parseEncoding(Y.getByName("Encoding"), P, D.strings, ae.charset);
                D.charset = ae, D.encoding = se;
                const ie = this.parseCharStrings({
                  charStrings: Q,
                  localSubrIndex: Y.privateDict.subrsIndex,
                  globalSubrIndex: K.obj,
                  fdSelect: D.fdSelect,
                  fdArray: D.fdArray,
                  privateDict: Y.privateDict
                });
                return D.charStrings = ie.charStrings, D.seacs = ie.seacs, D.widths = ie.widths, D;
              }
              parseHeader() {
                let P = this.bytes;
                const D = P.length;
                let H = 0;
                for (; H < D && P[H] !== 1; )
                  ++H;
                if (H >= D)
                  throw new g.FormatError("Invalid CFF header");
                H !== 0 && ((0, g.info)("cff data is shifted"), P = P.subarray(H), this.bytes = P);
                const V = P[0], Z = P[1], ne = P[2], K = P[3];
                return {
                  obj: new I(V, Z, ne, K),
                  endPos: ne
                };
              }
              parseDict(P) {
                let D = 0;
                function H() {
                  let q = P[D++];
                  return q === 30 ? V() : q === 28 ? (q = P[D++], q = (q << 24 | P[D++] << 16) >> 16, q) : q === 29 ? (q = P[D++], q = q << 8 | P[D++], q = q << 8 | P[D++], q = q << 8 | P[D++], q) : q >= 32 && q <= 246 ? q - 139 : q >= 247 && q <= 250 ? (q - 247) * 256 + P[D++] + 108 : q >= 251 && q <= 254 ? -((q - 251) * 256) - P[D++] - 108 : ((0, g.warn)('CFFParser_parseDict: "' + q + '" is a reserved command.'), NaN);
                }
                function V() {
                  let q = "";
                  const ee = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"], Q = P.length;
                  for (; D < Q; ) {
                    const J = P[D++], te = J >> 4, ae = J & 15;
                    if (te === 15 || (q += ee[te], ae === 15))
                      break;
                    q += ee[ae];
                  }
                  return parseFloat(q);
                }
                let Z = [];
                const ne = [];
                D = 0;
                const K = P.length;
                for (; D < K; ) {
                  let q = P[D];
                  q <= 21 ? (q === 12 && (q = q << 8 | P[++D]), ne.push([q, Z]), Z = [], ++D) : Z.push(H());
                }
                return ne;
              }
              parseIndex(P) {
                const D = new E(), H = this.bytes, V = H[P++] << 8 | H[P++], Z = [];
                let ne = P, K, q;
                if (V !== 0) {
                  const Y = H[P++], ee = P + (V + 1) * Y - 1;
                  for (K = 0, q = V + 1; K < q; ++K) {
                    let Q = 0;
                    for (let J = 0; J < Y; ++J)
                      Q <<= 8, Q += H[P++];
                    Z.push(ee + Q);
                  }
                  ne = Z[V];
                }
                for (K = 0, q = Z.length - 1; K < q; ++K) {
                  const Y = Z[K], ee = Z[K + 1];
                  D.add(H.subarray(Y, ee));
                }
                return {
                  obj: D,
                  endPos: ne
                };
              }
              parseNameIndex(P) {
                const D = [];
                for (let H = 0, V = P.count; H < V; ++H) {
                  const Z = P.get(H);
                  D.push((0, g.bytesToString)(Z));
                }
                return D;
              }
              parseStringIndex(P) {
                const D = new _();
                for (let H = 0, V = P.count; H < V; ++H) {
                  const Z = P.get(H);
                  D.add((0, g.bytesToString)(Z));
                }
                return D;
              }
              createDict(P, D, H) {
                const V = new P(H);
                for (const [Z, ne] of D)
                  V.setByKey(Z, ne);
                return V;
              }
              parseCharString(P, D, H, V) {
                if (!D || P.callDepth > f)
                  return !1;
                let Z = P.stackSize;
                const ne = P.stack;
                let K = D.length;
                for (let q = 0; q < K; ) {
                  const Y = D[q++];
                  let ee = null;
                  if (Y === 12) {
                    const Q = D[q++];
                    Q === 0 ? (D[q - 2] = 139, D[q - 1] = 22, Z = 0) : ee = S[Q];
                  } else if (Y === 28)
                    ne[Z] = (D[q] << 24 | D[q + 1] << 16) >> 16, q += 2, Z++;
                  else if (Y === 14) {
                    if (Z >= 4 && (Z -= 4, this.seacAnalysisEnabled))
                      return P.seac = ne.slice(Z, Z + 4), !1;
                    ee = w[Y];
                  } else if (Y >= 32 && Y <= 246)
                    ne[Z] = Y - 139, Z++;
                  else if (Y >= 247 && Y <= 254)
                    ne[Z] = Y < 251 ? (Y - 247 << 8) + D[q] + 108 : -(Y - 251 << 8) - D[q] - 108, q++, Z++;
                  else if (Y === 255)
                    ne[Z] = (D[q] << 24 | D[q + 1] << 16 | D[q + 2] << 8 | D[q + 3]) / 65536, q += 4, Z++;
                  else if (Y === 19 || Y === 20) {
                    if (P.hints += Z >> 1, P.hints === 0) {
                      D.copyWithin(q - 1, q, -1), q -= 1, K -= 1;
                      continue;
                    }
                    q += P.hints + 7 >> 3, Z %= 2, ee = w[Y];
                  } else if (Y === 10 || Y === 29) {
                    const Q = Y === 10 ? H : V;
                    if (!Q)
                      return ee = w[Y], (0, g.warn)("Missing subrsIndex for " + ee.id), !1;
                    let J = 32768;
                    Q.count < 1240 ? J = 107 : Q.count < 33900 && (J = 1131);
                    const te = ne[--Z] + J;
                    if (te < 0 || te >= Q.count || isNaN(te))
                      return ee = w[Y], (0, g.warn)("Out of bounds subrIndex for " + ee.id), !1;
                    if (P.stackSize = Z, P.callDepth++, !this.parseCharString(P, Q.get(te), H, V))
                      return !1;
                    P.callDepth--, Z = P.stackSize;
                    continue;
                  } else {
                    if (Y === 11)
                      return P.stackSize = Z, !0;
                    if (Y === 0 && q === D.length)
                      D[q - 1] = 14, ee = w[14];
                    else if (Y === 9) {
                      D.copyWithin(q - 1, q, -1), q -= 1, K -= 1;
                      continue;
                    } else
                      ee = w[Y];
                  }
                  if (ee) {
                    if (ee.stem && (P.hints += Z >> 1, Y === 3 || Y === 23 ? P.hasVStems = !0 : P.hasVStems && (Y === 1 || Y === 18) && ((0, g.warn)("CFF stem hints are in wrong order"), D[q - 1] = Y === 1 ? 3 : 23)), "min" in ee && !P.undefStack && Z < ee.min)
                      return (0, g.warn)("Not enough parameters for " + ee.id + "; actual: " + Z + ", expected: " + ee.min), Z === 0 ? (D[q - 1] = 14, !0) : !1;
                    P.firstStackClearing && ee.stackClearing && (P.firstStackClearing = !1, Z -= ee.min, Z >= 2 && ee.stem ? Z %= 2 : Z > 1 && (0, g.warn)("Found too many parameters for stack-clearing command"), Z > 0 && (P.width = ne[Z - 1])), "stackDelta" in ee ? ("stackFn" in ee && ee.stackFn(ne, Z), Z += ee.stackDelta) : ee.stackClearing ? Z = 0 : ee.resetStack ? (Z = 0, P.undefStack = !1) : ee.undefStack && (Z = 0, P.undefStack = !0, P.firstStackClearing = !1);
                  }
                }
                return K < D.length && D.fill(14, K), P.stackSize = Z, !0;
              }
              parseCharStrings({
                charStrings: P,
                localSubrIndex: D,
                globalSubrIndex: H,
                fdSelect: V,
                fdArray: Z,
                privateDict: ne
              }) {
                const K = [], q = [], Y = P.count;
                for (let ee = 0; ee < Y; ee++) {
                  const Q = P.get(ee), J = {
                    callDepth: 0,
                    stackSize: 0,
                    stack: [],
                    undefStack: !0,
                    hints: 0,
                    firstStackClearing: !0,
                    seac: null,
                    width: null,
                    hasVStems: !1
                  };
                  let te = !0, ae = null, se = ne;
                  if (V && Z.length) {
                    const ie = V.getFDIndex(ee);
                    ie === -1 && ((0, g.warn)("Glyph index is not in fd select."), te = !1), ie >= Z.length && ((0, g.warn)("Invalid fd index for glyph index."), te = !1), te && (se = Z[ie].privateDict, ae = se.subrsIndex);
                  } else D && (ae = D);
                  if (te && (te = this.parseCharString(J, Q, ae, H)), J.width !== null) {
                    const ie = se.getByName("nominalWidthX");
                    q[ee] = ie + J.width;
                  } else {
                    const ie = se.getByName("defaultWidthX");
                    q[ee] = ie;
                  }
                  J.seac !== null && (K[ee] = J.seac), te || P.set(ee, new Uint8Array([14]));
                }
                return {
                  charStrings: P,
                  seacs: K,
                  widths: q
                };
              }
              emptyPrivateDictionary(P) {
                const D = this.createDict(F, [], P.strings);
                P.setByKey(18, [0, 0]), P.privateDict = D;
              }
              parsePrivateDict(P) {
                if (!P.hasName("Private")) {
                  this.emptyPrivateDictionary(P);
                  return;
                }
                const D = P.getByName("Private");
                if (!Array.isArray(D) || D.length !== 2) {
                  P.removeByName("Private");
                  return;
                }
                const H = D[0], V = D[1];
                if (H === 0 || V >= this.bytes.length) {
                  this.emptyPrivateDictionary(P);
                  return;
                }
                const Z = V + H, ne = this.bytes.subarray(V, Z), K = this.parseDict(ne), q = this.createDict(F, K, P.strings);
                if (P.privateDict = q, q.getByName("ExpansionFactor") === 0 && q.setByName("ExpansionFactor", 0.06), !q.getByName("Subrs"))
                  return;
                const Y = q.getByName("Subrs"), ee = V + Y;
                if (Y === 0 || ee >= this.bytes.length) {
                  this.emptyPrivateDictionary(P);
                  return;
                }
                const Q = this.parseIndex(ee);
                q.subrsIndex = Q.obj;
              }
              parseCharsets(P, D, H, V) {
                if (P === 0)
                  return new W(!0, M.ISO_ADOBE, b.ISOAdobeCharset);
                if (P === 1)
                  return new W(!0, M.EXPERT, b.ExpertCharset);
                if (P === 2)
                  return new W(!0, M.EXPERT_SUBSET, b.ExpertSubsetCharset);
                const Z = this.bytes, ne = P, K = Z[P++], q = [V ? 0 : ".notdef"];
                let Y, ee, Q;
                switch (D -= 1, K) {
                  case 0:
                    for (Q = 0; Q < D; Q++)
                      Y = Z[P++] << 8 | Z[P++], q.push(V ? Y : H.get(Y));
                    break;
                  case 1:
                    for (; q.length <= D; )
                      for (Y = Z[P++] << 8 | Z[P++], ee = Z[P++], Q = 0; Q <= ee; Q++)
                        q.push(V ? Y++ : H.get(Y++));
                    break;
                  case 2:
                    for (; q.length <= D; )
                      for (Y = Z[P++] << 8 | Z[P++], ee = Z[P++] << 8 | Z[P++], Q = 0; Q <= ee; Q++)
                        q.push(V ? Y++ : H.get(Y++));
                    break;
                  default:
                    throw new g.FormatError("Unknown charset format");
                }
                const J = P, te = Z.subarray(ne, J);
                return new W(!1, K, q, te);
              }
              parseEncoding(P, D, H, V) {
                const Z = /* @__PURE__ */ Object.create(null), ne = this.bytes;
                let K = !1, q, Y, ee, Q = null;
                function J() {
                  const te = ne[P++];
                  for (Y = 0; Y < te; Y++) {
                    const ae = ne[P++], se = (ne[P++] << 8) + (ne[P++] & 255);
                    Z[ae] = V.indexOf(H.get(se));
                  }
                }
                if (P === 0 || P === 1) {
                  K = !0, q = P;
                  const te = P ? y.ExpertEncoding : y.StandardEncoding;
                  for (Y = 0, ee = V.length; Y < ee; Y++) {
                    const ae = te.indexOf(V[Y]);
                    ae !== -1 && (Z[ae] = Y);
                  }
                } else {
                  const te = P;
                  switch (q = ne[P++], q & 127) {
                    case 0:
                      const se = ne[P++];
                      for (Y = 1; Y <= se; Y++)
                        Z[ne[P++]] = Y;
                      break;
                    case 1:
                      const ie = ne[P++];
                      let fe = 1;
                      for (Y = 0; Y < ie; Y++) {
                        const ge = ne[P++], me = ne[P++];
                        for (let pe = ge; pe <= ge + me; pe++)
                          Z[pe] = fe++;
                      }
                      break;
                    default:
                      throw new g.FormatError(`Unknown encoding format: ${q} in CFF`);
                  }
                  const ae = P;
                  q & 128 && (ne[te] &= 127, J()), Q = ne.subarray(te, ae);
                }
                return q &= 127, new j(K, q, Z, Q);
              }
              parseFDSelect(P, D) {
                const H = this.bytes, V = H[P++], Z = [];
                let ne;
                switch (V) {
                  case 0:
                    for (ne = 0; ne < D; ++ne) {
                      const q = H[P++];
                      Z.push(q);
                    }
                    break;
                  case 3:
                    const K = H[P++] << 8 | H[P++];
                    for (ne = 0; ne < K; ++ne) {
                      let q = H[P++] << 8 | H[P++];
                      ne === 0 && q !== 0 && ((0, g.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover."), q = 0);
                      const Y = H[P++], ee = H[P] << 8 | H[P + 1];
                      for (let Q = q; Q < ee; ++Q)
                        Z.push(Y);
                    }
                    P += 2;
                    break;
                  default:
                    throw new g.FormatError(`parseFDSelect: Unknown format "${V}".`);
                }
                if (Z.length !== D)
                  throw new g.FormatError("parseFDSelect: Invalid font data.");
                return new G(V, Z);
              }
            }
            A.CFFParser = $;
            class T {
              constructor() {
                this.header = null, this.names = [], this.topDict = null, this.strings = new _(), this.globalSubrIndex = null, this.encoding = null, this.charset = null, this.charStrings = null, this.fdArray = [], this.fdSelect = null, this.isCIDFont = !1;
              }
              duplicateFirstGlyph() {
                if (this.charStrings.count >= 65535) {
                  (0, g.warn)("Not enough space in charstrings to duplicate first glyph.");
                  return;
                }
                const P = this.charStrings.get(0);
                this.charStrings.add(P), this.isCIDFont && this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
              }
              hasGlyphId(P) {
                return P < 0 || P >= this.charStrings.count ? !1 : this.charStrings.get(P).length > 0;
              }
            }
            A.CFF = T;
            class I {
              constructor(P, D, H, V) {
                this.major = P, this.minor = D, this.hdrSize = H, this.offSize = V;
              }
            }
            A.CFFHeader = I;
            class _ {
              constructor() {
                this.strings = [];
              }
              get(P) {
                return P >= 0 && P <= C - 1 ? m[P] : P - C <= this.strings.length ? this.strings[P - C] : m[0];
              }
              getSID(P) {
                let D = m.indexOf(P);
                return D !== -1 ? D : (D = this.strings.indexOf(P), D !== -1 ? D + C : -1);
              }
              add(P) {
                this.strings.push(P);
              }
              get count() {
                return this.strings.length;
              }
            }
            A.CFFStrings = _;
            class E {
              constructor() {
                this.objects = [], this.length = 0;
              }
              add(P) {
                this.length += P.length, this.objects.push(P);
              }
              set(P, D) {
                this.length += D.length - this.objects[P].length, this.objects[P] = D;
              }
              get(P) {
                return this.objects[P];
              }
              get count() {
                return this.objects.length;
              }
            }
            A.CFFIndex = E;
            class R {
              constructor(P, D) {
                this.keyToNameMap = P.keyToNameMap, this.nameToKeyMap = P.nameToKeyMap, this.defaults = P.defaults, this.types = P.types, this.opcodes = P.opcodes, this.order = P.order, this.strings = D, this.values = /* @__PURE__ */ Object.create(null);
              }
              setByKey(P, D) {
                if (!(P in this.keyToNameMap))
                  return !1;
                if (D.length === 0)
                  return !0;
                for (const V of D)
                  if (isNaN(V))
                    return (0, g.warn)(`Invalid CFFDict value: "${D}" for key "${P}".`), !0;
                const H = this.types[P];
                return (H === "num" || H === "sid" || H === "offset") && (D = D[0]), this.values[P] = D, !0;
              }
              setByName(P, D) {
                if (!(P in this.nameToKeyMap))
                  throw new g.FormatError(`Invalid dictionary name "${P}"`);
                this.values[this.nameToKeyMap[P]] = D;
              }
              hasName(P) {
                return this.nameToKeyMap[P] in this.values;
              }
              getByName(P) {
                if (!(P in this.nameToKeyMap))
                  throw new g.FormatError(`Invalid dictionary name ${P}"`);
                const D = this.nameToKeyMap[P];
                return D in this.values ? this.values[D] : this.defaults[D];
              }
              removeByName(P) {
                delete this.values[this.nameToKeyMap[P]];
              }
              static createTables(P) {
                const D = {
                  keyToNameMap: {},
                  nameToKeyMap: {},
                  defaults: {},
                  types: {},
                  opcodes: {},
                  order: []
                };
                for (const H of P) {
                  const V = Array.isArray(H[0]) ? (H[0][0] << 8) + H[0][1] : H[0];
                  D.keyToNameMap[V] = H[1], D.nameToKeyMap[H[1]] = V, D.types[V] = H[2], D.defaults[V] = H[3], D.opcodes[V] = Array.isArray(H[0]) ? H[0] : [H[0]], D.order.push(V);
                }
                return D;
              }
            }
            const O = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [1e-3, 0, 0, 1e-3, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]];
            class L extends R {
              static get tables() {
                return (0, g.shadow)(this, "tables", this.createTables(O));
              }
              constructor(P) {
                super(L.tables, P), this.privateDict = null;
              }
            }
            A.CFFTopDict = L;
            const B = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", 0.039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", 0.06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]];
            class F extends R {
              static get tables() {
                return (0, g.shadow)(this, "tables", this.createTables(B));
              }
              constructor(P) {
                super(F.tables, P), this.subrsIndex = null;
              }
            }
            A.CFFPrivateDict = F;
            const M = {
              ISO_ADOBE: 0,
              EXPERT: 1,
              EXPERT_SUBSET: 2
            };
            class W {
              constructor(P, D, H, V) {
                this.predefined = P, this.format = D, this.charset = H, this.raw = V;
              }
            }
            A.CFFCharset = W;
            class j {
              constructor(P, D, H, V) {
                this.predefined = P, this.format = D, this.encoding = H, this.raw = V;
              }
            }
            class G {
              constructor(P, D) {
                this.format = P, this.fdSelect = D;
              }
              getFDIndex(P) {
                return P < 0 || P >= this.fdSelect.length ? -1 : this.fdSelect[P];
              }
            }
            A.CFFFDSelect = G;
            class U {
              constructor() {
                this.offsets = /* @__PURE__ */ Object.create(null);
              }
              isTracking(P) {
                return P in this.offsets;
              }
              track(P, D) {
                if (P in this.offsets)
                  throw new g.FormatError(`Already tracking location of ${P}`);
                this.offsets[P] = D;
              }
              offset(P) {
                for (const D in this.offsets)
                  this.offsets[D] += P;
              }
              setEntryLocation(P, D, H) {
                if (!(P in this.offsets))
                  throw new g.FormatError(`Not tracking location of ${P}`);
                const V = H.data, Z = this.offsets[P], ne = 5;
                for (let K = 0, q = D.length; K < q; ++K) {
                  const Y = K * ne + Z, ee = Y + 1, Q = Y + 2, J = Y + 3, te = Y + 4;
                  if (V[Y] !== 29 || V[ee] !== 0 || V[Q] !== 0 || V[J] !== 0 || V[te] !== 0)
                    throw new g.FormatError("writing to an offset that is not empty");
                  const ae = D[K];
                  V[Y] = 29, V[ee] = ae >> 24 & 255, V[Q] = ae >> 16 & 255, V[J] = ae >> 8 & 255, V[te] = ae & 255;
                }
              }
            }
            class k {
              constructor(P) {
                this.cff = P;
              }
              compile() {
                const P = this.cff, D = {
                  data: [],
                  length: 0,
                  add(J) {
                    try {
                      this.data.push(...J);
                    } catch {
                      this.data = this.data.concat(J);
                    }
                    this.length = this.data.length;
                  }
                }, H = this.compileHeader(P.header);
                D.add(H);
                const V = this.compileNameIndex(P.names);
                if (D.add(V), P.isCIDFont && P.topDict.hasName("FontMatrix")) {
                  const J = P.topDict.getByName("FontMatrix");
                  P.topDict.removeByName("FontMatrix");
                  for (const te of P.fdArray) {
                    let ae = J.slice(0);
                    te.hasName("FontMatrix") && (ae = g.Util.transform(ae, te.getByName("FontMatrix"))), te.setByName("FontMatrix", ae);
                  }
                }
                P.topDict.getByName("XUID")?.length > 16 && P.topDict.removeByName("XUID"), P.topDict.setByName("charset", 0);
                let ne = this.compileTopDicts([P.topDict], D.length, P.isCIDFont);
                D.add(ne.output);
                const K = ne.trackers[0], q = this.compileStringIndex(P.strings.strings);
                D.add(q);
                const Y = this.compileIndex(P.globalSubrIndex);
                if (D.add(Y), P.encoding && P.topDict.hasName("Encoding"))
                  if (P.encoding.predefined)
                    K.setEntryLocation("Encoding", [P.encoding.format], D);
                  else {
                    const J = this.compileEncoding(P.encoding);
                    K.setEntryLocation("Encoding", [D.length], D), D.add(J);
                  }
                const ee = this.compileCharset(P.charset, P.charStrings.count, P.strings, P.isCIDFont);
                K.setEntryLocation("charset", [D.length], D), D.add(ee);
                const Q = this.compileCharStrings(P.charStrings);
                if (K.setEntryLocation("CharStrings", [D.length], D), D.add(Q), P.isCIDFont) {
                  K.setEntryLocation("FDSelect", [D.length], D);
                  const J = this.compileFDSelect(P.fdSelect);
                  D.add(J), ne = this.compileTopDicts(P.fdArray, D.length, !0), K.setEntryLocation("FDArray", [D.length], D), D.add(ne.output);
                  const te = ne.trackers;
                  this.compilePrivateDicts(P.fdArray, te, D);
                }
                return this.compilePrivateDicts([P.topDict], [K], D), D.add([0]), D.data;
              }
              encodeNumber(P) {
                return Number.isInteger(P) ? this.encodeInteger(P) : this.encodeFloat(P);
              }
              static get EncodeFloatRegExp() {
                return (0, g.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
              }
              encodeFloat(P) {
                let D = P.toString();
                const H = k.EncodeFloatRegExp.exec(D);
                if (H) {
                  const q = parseFloat("1e" + ((H[2] ? +H[2] : 0) + H[1].length));
                  D = (Math.round(P * q) / q).toString();
                }
                let V = "", Z, ne;
                for (Z = 0, ne = D.length; Z < ne; ++Z) {
                  const q = D[Z];
                  q === "e" ? V += D[++Z] === "-" ? "c" : "b" : q === "." ? V += "a" : q === "-" ? V += "e" : V += q;
                }
                V += V.length & 1 ? "f" : "ff";
                const K = [30];
                for (Z = 0, ne = V.length; Z < ne; Z += 2)
                  K.push(parseInt(V.substring(Z, Z + 2), 16));
                return K;
              }
              encodeInteger(P) {
                let D;
                return P >= -107 && P <= 107 ? D = [P + 139] : P >= 108 && P <= 1131 ? (P -= 108, D = [(P >> 8) + 247, P & 255]) : P >= -1131 && P <= -108 ? (P = -P - 108, D = [(P >> 8) + 251, P & 255]) : P >= -32768 && P <= 32767 ? D = [28, P >> 8 & 255, P & 255] : D = [29, P >> 24 & 255, P >> 16 & 255, P >> 8 & 255, P & 255], D;
              }
              compileHeader(P) {
                return [P.major, P.minor, 4, P.offSize];
              }
              compileNameIndex(P) {
                const D = new E();
                for (const H of P) {
                  const V = Math.min(H.length, 127);
                  let Z = new Array(V);
                  for (let ne = 0; ne < V; ne++) {
                    let K = H[ne];
                    (K < "!" || K > "~" || K === "[" || K === "]" || K === "(" || K === ")" || K === "{" || K === "}" || K === "<" || K === ">" || K === "/" || K === "%") && (K = "_"), Z[ne] = K;
                  }
                  Z = Z.join(""), Z === "" && (Z = "Bad_Font_Name"), D.add((0, g.stringToBytes)(Z));
                }
                return this.compileIndex(D);
              }
              compileTopDicts(P, D, H) {
                const V = [];
                let Z = new E();
                for (const ne of P) {
                  H && (ne.removeByName("CIDFontVersion"), ne.removeByName("CIDFontRevision"), ne.removeByName("CIDFontType"), ne.removeByName("CIDCount"), ne.removeByName("UIDBase"));
                  const K = new U(), q = this.compileDict(ne, K);
                  V.push(K), Z.add(q), K.offset(D);
                }
                return Z = this.compileIndex(Z, V), {
                  trackers: V,
                  output: Z
                };
              }
              compilePrivateDicts(P, D, H) {
                for (let V = 0, Z = P.length; V < Z; ++V) {
                  const ne = P[V], K = ne.privateDict;
                  if (!K || !ne.hasName("Private"))
                    throw new g.FormatError("There must be a private dictionary.");
                  const q = new U(), Y = this.compileDict(K, q);
                  let ee = H.length;
                  if (q.offset(ee), Y.length || (ee = 0), D[V].setEntryLocation("Private", [Y.length, ee], H), H.add(Y), K.subrsIndex && K.hasName("Subrs")) {
                    const Q = this.compileIndex(K.subrsIndex);
                    q.setEntryLocation("Subrs", [Y.length], H), H.add(Q);
                  }
                }
              }
              compileDict(P, D) {
                const H = [];
                for (const V of P.order) {
                  if (!(V in P.values))
                    continue;
                  let Z = P.values[V], ne = P.types[V];
                  if (Array.isArray(ne) || (ne = [ne]), Array.isArray(Z) || (Z = [Z]), Z.length !== 0) {
                    for (let K = 0, q = ne.length; K < q; ++K) {
                      const Y = ne[K], ee = Z[K];
                      switch (Y) {
                        case "num":
                        case "sid":
                          H.push(...this.encodeNumber(ee));
                          break;
                        case "offset":
                          const Q = P.keyToNameMap[V];
                          D.isTracking(Q) || D.track(Q, H.length), H.push(29, 0, 0, 0, 0);
                          break;
                        case "array":
                        case "delta":
                          H.push(...this.encodeNumber(ee));
                          for (let J = 1, te = Z.length; J < te; ++J)
                            H.push(...this.encodeNumber(Z[J]));
                          break;
                        default:
                          throw new g.FormatError(`Unknown data type of ${Y}`);
                      }
                    }
                    H.push(...P.opcodes[V]);
                  }
                }
                return H;
              }
              compileStringIndex(P) {
                const D = new E();
                for (const H of P)
                  D.add((0, g.stringToBytes)(H));
                return this.compileIndex(D);
              }
              compileCharStrings(P) {
                const D = new E();
                for (let H = 0; H < P.count; H++) {
                  const V = P.get(H);
                  if (V.length === 0) {
                    D.add(new Uint8Array([139, 14]));
                    continue;
                  }
                  D.add(V);
                }
                return this.compileIndex(D);
              }
              compileCharset(P, D, H, V) {
                let Z;
                const ne = D - 1;
                if (V)
                  Z = new Uint8Array([2, 0, 0, ne >> 8 & 255, ne & 255]);
                else {
                  const K = 1 + ne * 2;
                  Z = new Uint8Array(K), Z[0] = 0;
                  let q = 0;
                  const Y = P.charset.length;
                  let ee = !1;
                  for (let Q = 1; Q < Z.length; Q += 2) {
                    let J = 0;
                    if (q < Y) {
                      const te = P.charset[q++];
                      J = H.getSID(te), J === -1 && (J = 0, ee || (ee = !0, (0, g.warn)(`Couldn't find ${te} in CFF strings`)));
                    }
                    Z[Q] = J >> 8 & 255, Z[Q + 1] = J & 255;
                  }
                }
                return this.compileTypedArray(Z);
              }
              compileEncoding(P) {
                return this.compileTypedArray(P.raw);
              }
              compileFDSelect(P) {
                const D = P.format;
                let H, V;
                switch (D) {
                  case 0:
                    for (H = new Uint8Array(1 + P.fdSelect.length), H[0] = D, V = 0; V < P.fdSelect.length; V++)
                      H[V + 1] = P.fdSelect[V];
                    break;
                  case 3:
                    const Z = 0;
                    let ne = P.fdSelect[0];
                    const K = [D, 0, 0, Z >> 8 & 255, Z & 255, ne];
                    for (V = 1; V < P.fdSelect.length; V++) {
                      const Y = P.fdSelect[V];
                      Y !== ne && (K.push(V >> 8 & 255, V & 255, Y), ne = Y);
                    }
                    const q = (K.length - 3) / 3;
                    K[1] = q >> 8 & 255, K[2] = q & 255, K.push(V >> 8 & 255, V & 255), H = new Uint8Array(K);
                    break;
                }
                return this.compileTypedArray(H);
              }
              compileTypedArray(P) {
                return Array.from(P);
              }
              compileIndex(P, D = []) {
                const H = P.objects, V = H.length;
                if (V === 0)
                  return [0, 0];
                const Z = [V >> 8 & 255, V & 255];
                let ne = 1, K;
                for (K = 0; K < V; ++K)
                  ne += H[K].length;
                let q;
                ne < 256 ? q = 1 : ne < 65536 ? q = 2 : ne < 16777216 ? q = 3 : q = 4, Z.push(q);
                let Y = 1;
                for (K = 0; K < V + 1; K++)
                  q === 1 ? Z.push(Y & 255) : q === 2 ? Z.push(Y >> 8 & 255, Y & 255) : q === 3 ? Z.push(Y >> 16 & 255, Y >> 8 & 255, Y & 255) : Z.push(Y >>> 24 & 255, Y >> 16 & 255, Y >> 8 & 255, Y & 255), H[K] && (Y += H[K].length);
                for (K = 0; K < V; K++)
                  D[K] && D[K].offset(Z.length), Z.push(...H[K]);
                return Z;
              }
            }
            A.CFFCompiler = k;
          },
          /* 36 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ISOAdobeCharset = A.ExpertSubsetCharset = A.ExpertCharset = void 0;
            const x = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"];
            A.ISOAdobeCharset = x;
            const g = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
            A.ExpertCharset = g;
            const b = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"];
            A.ExpertSubsetCharset = b;
          },
          /* 37 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ZapfDingbatsEncoding = A.WinAnsiEncoding = A.SymbolSetEncoding = A.StandardEncoding = A.MacRomanEncoding = A.ExpertEncoding = void 0, A.getEncoding = w;
            const x = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
            A.ExpertEncoding = x;
            const g = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall", "", "", "", ""], b = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"];
            A.MacRomanEncoding = b;
            const y = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls", "", "", "", ""];
            A.StandardEncoding = y;
            const f = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"];
            A.WinAnsiEncoding = f;
            const m = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt", ""];
            A.SymbolSetEncoding = m;
            const C = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191", ""];
            A.ZapfDingbatsEncoding = C;
            function w(S) {
              switch (S) {
                case "WinAnsiEncoding":
                  return f;
                case "StandardEncoding":
                  return y;
                case "MacRomanEncoding":
                  return b;
                case "SymbolSetEncoding":
                  return m;
                case "ZapfDingbatsEncoding":
                  return C;
                case "ExpertEncoding":
                  return x;
                case "MacExpertEncoding":
                  return g;
                default:
                  return null;
              }
            }
          },
          /* 38 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.SEAC_ANALYSIS_ENABLED = A.MacStandardGlyphOrdering = A.FontFlags = void 0, A.normalizeFontName = T, A.recoverGlyphName = S, A.type1FontGlyphMapping = $;
            var g = x(37), b = x(39), y = x(40), f = x(2);
            const m = !0;
            A.SEAC_ANALYSIS_ENABLED = m;
            const C = {
              FixedPitch: 1,
              Serif: 2,
              Symbolic: 4,
              Script: 8,
              Nonsymbolic: 32,
              Italic: 64,
              AllCap: 65536,
              SmallCap: 131072,
              ForceBold: 262144
            };
            A.FontFlags = C;
            const w = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"];
            A.MacStandardGlyphOrdering = w;
            function S(I, _) {
              if (_[I] !== void 0)
                return I;
              const E = (0, y.getUnicodeForGlyph)(I, _);
              if (E !== -1) {
                for (const R in _)
                  if (_[R] === E)
                    return R;
              }
              return (0, f.info)("Unable to recover a standard glyph name for: " + I), I;
            }
            function $(I, _, E) {
              const R = /* @__PURE__ */ Object.create(null);
              let O, L, B;
              const F = !!(I.flags & C.Symbolic);
              if (I.isInternalFont)
                for (B = _, L = 0; L < B.length; L++)
                  O = E.indexOf(B[L]), R[L] = O >= 0 ? O : 0;
              else if (I.baseEncodingName)
                for (B = (0, g.getEncoding)(I.baseEncodingName), L = 0; L < B.length; L++)
                  O = E.indexOf(B[L]), R[L] = O >= 0 ? O : 0;
              else if (F)
                for (L in _)
                  R[L] = _[L];
              else
                for (B = g.StandardEncoding, L = 0; L < B.length; L++)
                  O = E.indexOf(B[L]), R[L] = O >= 0 ? O : 0;
              const M = I.differences;
              let W;
              if (M)
                for (L in M) {
                  const j = M[L];
                  if (O = E.indexOf(j), O === -1) {
                    W || (W = (0, b.getGlyphsUnicode)());
                    const G = S(j, W);
                    G !== j && (O = E.indexOf(G));
                  }
                  R[L] = O >= 0 ? O : 0;
                }
              return R;
            }
            function T(I) {
              return I.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
            }
          },
          /* 39 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.getGlyphsUnicode = A.getDingbatsGlyphsUnicode = void 0;
            var g = x(3);
            const b = (0, g.getLookupTableFactory)(function(f) {
              f.A = 65, f.AE = 198, f.AEacute = 508, f.AEmacron = 482, f.AEsmall = 63462, f.Aacute = 193, f.Aacutesmall = 63457, f.Abreve = 258, f.Abreveacute = 7854, f.Abrevecyrillic = 1232, f.Abrevedotbelow = 7862, f.Abrevegrave = 7856, f.Abrevehookabove = 7858, f.Abrevetilde = 7860, f.Acaron = 461, f.Acircle = 9398, f.Acircumflex = 194, f.Acircumflexacute = 7844, f.Acircumflexdotbelow = 7852, f.Acircumflexgrave = 7846, f.Acircumflexhookabove = 7848, f.Acircumflexsmall = 63458, f.Acircumflextilde = 7850, f.Acute = 63177, f.Acutesmall = 63412, f.Acyrillic = 1040, f.Adblgrave = 512, f.Adieresis = 196, f.Adieresiscyrillic = 1234, f.Adieresismacron = 478, f.Adieresissmall = 63460, f.Adotbelow = 7840, f.Adotmacron = 480, f.Agrave = 192, f.Agravesmall = 63456, f.Ahookabove = 7842, f.Aiecyrillic = 1236, f.Ainvertedbreve = 514, f.Alpha = 913, f.Alphatonos = 902, f.Amacron = 256, f.Amonospace = 65313, f.Aogonek = 260, f.Aring = 197, f.Aringacute = 506, f.Aringbelow = 7680, f.Aringsmall = 63461, f.Asmall = 63329, f.Atilde = 195, f.Atildesmall = 63459, f.Aybarmenian = 1329, f.B = 66, f.Bcircle = 9399, f.Bdotaccent = 7682, f.Bdotbelow = 7684, f.Becyrillic = 1041, f.Benarmenian = 1330, f.Beta = 914, f.Bhook = 385, f.Blinebelow = 7686, f.Bmonospace = 65314, f.Brevesmall = 63220, f.Bsmall = 63330, f.Btopbar = 386, f.C = 67, f.Caarmenian = 1342, f.Cacute = 262, f.Caron = 63178, f.Caronsmall = 63221, f.Ccaron = 268, f.Ccedilla = 199, f.Ccedillaacute = 7688, f.Ccedillasmall = 63463, f.Ccircle = 9400, f.Ccircumflex = 264, f.Cdot = 266, f.Cdotaccent = 266, f.Cedillasmall = 63416, f.Chaarmenian = 1353, f.Cheabkhasiancyrillic = 1212, f.Checyrillic = 1063, f.Chedescenderabkhasiancyrillic = 1214, f.Chedescendercyrillic = 1206, f.Chedieresiscyrillic = 1268, f.Cheharmenian = 1347, f.Chekhakassiancyrillic = 1227, f.Cheverticalstrokecyrillic = 1208, f.Chi = 935, f.Chook = 391, f.Circumflexsmall = 63222, f.Cmonospace = 65315, f.Coarmenian = 1361, f.Csmall = 63331, f.D = 68, f.DZ = 497, f.DZcaron = 452, f.Daarmenian = 1332, f.Dafrican = 393, f.Dcaron = 270, f.Dcedilla = 7696, f.Dcircle = 9401, f.Dcircumflexbelow = 7698, f.Dcroat = 272, f.Ddotaccent = 7690, f.Ddotbelow = 7692, f.Decyrillic = 1044, f.Deicoptic = 1006, f.Delta = 8710, f.Deltagreek = 916, f.Dhook = 394, f.Dieresis = 63179, f.DieresisAcute = 63180, f.DieresisGrave = 63181, f.Dieresissmall = 63400, f.Digammagreek = 988, f.Djecyrillic = 1026, f.Dlinebelow = 7694, f.Dmonospace = 65316, f.Dotaccentsmall = 63223, f.Dslash = 272, f.Dsmall = 63332, f.Dtopbar = 395, f.Dz = 498, f.Dzcaron = 453, f.Dzeabkhasiancyrillic = 1248, f.Dzecyrillic = 1029, f.Dzhecyrillic = 1039, f.E = 69, f.Eacute = 201, f.Eacutesmall = 63465, f.Ebreve = 276, f.Ecaron = 282, f.Ecedillabreve = 7708, f.Echarmenian = 1333, f.Ecircle = 9402, f.Ecircumflex = 202, f.Ecircumflexacute = 7870, f.Ecircumflexbelow = 7704, f.Ecircumflexdotbelow = 7878, f.Ecircumflexgrave = 7872, f.Ecircumflexhookabove = 7874, f.Ecircumflexsmall = 63466, f.Ecircumflextilde = 7876, f.Ecyrillic = 1028, f.Edblgrave = 516, f.Edieresis = 203, f.Edieresissmall = 63467, f.Edot = 278, f.Edotaccent = 278, f.Edotbelow = 7864, f.Efcyrillic = 1060, f.Egrave = 200, f.Egravesmall = 63464, f.Eharmenian = 1335, f.Ehookabove = 7866, f.Eightroman = 8551, f.Einvertedbreve = 518, f.Eiotifiedcyrillic = 1124, f.Elcyrillic = 1051, f.Elevenroman = 8554, f.Emacron = 274, f.Emacronacute = 7702, f.Emacrongrave = 7700, f.Emcyrillic = 1052, f.Emonospace = 65317, f.Encyrillic = 1053, f.Endescendercyrillic = 1186, f.Eng = 330, f.Enghecyrillic = 1188, f.Enhookcyrillic = 1223, f.Eogonek = 280, f.Eopen = 400, f.Epsilon = 917, f.Epsilontonos = 904, f.Ercyrillic = 1056, f.Ereversed = 398, f.Ereversedcyrillic = 1069, f.Escyrillic = 1057, f.Esdescendercyrillic = 1194, f.Esh = 425, f.Esmall = 63333, f.Eta = 919, f.Etarmenian = 1336, f.Etatonos = 905, f.Eth = 208, f.Ethsmall = 63472, f.Etilde = 7868, f.Etildebelow = 7706, f.Euro = 8364, f.Ezh = 439, f.Ezhcaron = 494, f.Ezhreversed = 440, f.F = 70, f.Fcircle = 9403, f.Fdotaccent = 7710, f.Feharmenian = 1366, f.Feicoptic = 996, f.Fhook = 401, f.Fitacyrillic = 1138, f.Fiveroman = 8548, f.Fmonospace = 65318, f.Fourroman = 8547, f.Fsmall = 63334, f.G = 71, f.GBsquare = 13191, f.Gacute = 500, f.Gamma = 915, f.Gammaafrican = 404, f.Gangiacoptic = 1002, f.Gbreve = 286, f.Gcaron = 486, f.Gcedilla = 290, f.Gcircle = 9404, f.Gcircumflex = 284, f.Gcommaaccent = 290, f.Gdot = 288, f.Gdotaccent = 288, f.Gecyrillic = 1043, f.Ghadarmenian = 1346, f.Ghemiddlehookcyrillic = 1172, f.Ghestrokecyrillic = 1170, f.Gheupturncyrillic = 1168, f.Ghook = 403, f.Gimarmenian = 1331, f.Gjecyrillic = 1027, f.Gmacron = 7712, f.Gmonospace = 65319, f.Grave = 63182, f.Gravesmall = 63328, f.Gsmall = 63335, f.Gsmallhook = 667, f.Gstroke = 484, f.H = 72, f.H18533 = 9679, f.H18543 = 9642, f.H18551 = 9643, f.H22073 = 9633, f.HPsquare = 13259, f.Haabkhasiancyrillic = 1192, f.Hadescendercyrillic = 1202, f.Hardsigncyrillic = 1066, f.Hbar = 294, f.Hbrevebelow = 7722, f.Hcedilla = 7720, f.Hcircle = 9405, f.Hcircumflex = 292, f.Hdieresis = 7718, f.Hdotaccent = 7714, f.Hdotbelow = 7716, f.Hmonospace = 65320, f.Hoarmenian = 1344, f.Horicoptic = 1e3, f.Hsmall = 63336, f.Hungarumlaut = 63183, f.Hungarumlautsmall = 63224, f.Hzsquare = 13200, f.I = 73, f.IAcyrillic = 1071, f.IJ = 306, f.IUcyrillic = 1070, f.Iacute = 205, f.Iacutesmall = 63469, f.Ibreve = 300, f.Icaron = 463, f.Icircle = 9406, f.Icircumflex = 206, f.Icircumflexsmall = 63470, f.Icyrillic = 1030, f.Idblgrave = 520, f.Idieresis = 207, f.Idieresisacute = 7726, f.Idieresiscyrillic = 1252, f.Idieresissmall = 63471, f.Idot = 304, f.Idotaccent = 304, f.Idotbelow = 7882, f.Iebrevecyrillic = 1238, f.Iecyrillic = 1045, f.Ifraktur = 8465, f.Igrave = 204, f.Igravesmall = 63468, f.Ihookabove = 7880, f.Iicyrillic = 1048, f.Iinvertedbreve = 522, f.Iishortcyrillic = 1049, f.Imacron = 298, f.Imacroncyrillic = 1250, f.Imonospace = 65321, f.Iniarmenian = 1339, f.Iocyrillic = 1025, f.Iogonek = 302, f.Iota = 921, f.Iotaafrican = 406, f.Iotadieresis = 938, f.Iotatonos = 906, f.Ismall = 63337, f.Istroke = 407, f.Itilde = 296, f.Itildebelow = 7724, f.Izhitsacyrillic = 1140, f.Izhitsadblgravecyrillic = 1142, f.J = 74, f.Jaarmenian = 1345, f.Jcircle = 9407, f.Jcircumflex = 308, f.Jecyrillic = 1032, f.Jheharmenian = 1355, f.Jmonospace = 65322, f.Jsmall = 63338, f.K = 75, f.KBsquare = 13189, f.KKsquare = 13261, f.Kabashkircyrillic = 1184, f.Kacute = 7728, f.Kacyrillic = 1050, f.Kadescendercyrillic = 1178, f.Kahookcyrillic = 1219, f.Kappa = 922, f.Kastrokecyrillic = 1182, f.Kaverticalstrokecyrillic = 1180, f.Kcaron = 488, f.Kcedilla = 310, f.Kcircle = 9408, f.Kcommaaccent = 310, f.Kdotbelow = 7730, f.Keharmenian = 1364, f.Kenarmenian = 1343, f.Khacyrillic = 1061, f.Kheicoptic = 998, f.Khook = 408, f.Kjecyrillic = 1036, f.Klinebelow = 7732, f.Kmonospace = 65323, f.Koppacyrillic = 1152, f.Koppagreek = 990, f.Ksicyrillic = 1134, f.Ksmall = 63339, f.L = 76, f.LJ = 455, f.LL = 63167, f.Lacute = 313, f.Lambda = 923, f.Lcaron = 317, f.Lcedilla = 315, f.Lcircle = 9409, f.Lcircumflexbelow = 7740, f.Lcommaaccent = 315, f.Ldot = 319, f.Ldotaccent = 319, f.Ldotbelow = 7734, f.Ldotbelowmacron = 7736, f.Liwnarmenian = 1340, f.Lj = 456, f.Ljecyrillic = 1033, f.Llinebelow = 7738, f.Lmonospace = 65324, f.Lslash = 321, f.Lslashsmall = 63225, f.Lsmall = 63340, f.M = 77, f.MBsquare = 13190, f.Macron = 63184, f.Macronsmall = 63407, f.Macute = 7742, f.Mcircle = 9410, f.Mdotaccent = 7744, f.Mdotbelow = 7746, f.Menarmenian = 1348, f.Mmonospace = 65325, f.Msmall = 63341, f.Mturned = 412, f.Mu = 924, f.N = 78, f.NJ = 458, f.Nacute = 323, f.Ncaron = 327, f.Ncedilla = 325, f.Ncircle = 9411, f.Ncircumflexbelow = 7754, f.Ncommaaccent = 325, f.Ndotaccent = 7748, f.Ndotbelow = 7750, f.Nhookleft = 413, f.Nineroman = 8552, f.Nj = 459, f.Njecyrillic = 1034, f.Nlinebelow = 7752, f.Nmonospace = 65326, f.Nowarmenian = 1350, f.Nsmall = 63342, f.Ntilde = 209, f.Ntildesmall = 63473, f.Nu = 925, f.O = 79, f.OE = 338, f.OEsmall = 63226, f.Oacute = 211, f.Oacutesmall = 63475, f.Obarredcyrillic = 1256, f.Obarreddieresiscyrillic = 1258, f.Obreve = 334, f.Ocaron = 465, f.Ocenteredtilde = 415, f.Ocircle = 9412, f.Ocircumflex = 212, f.Ocircumflexacute = 7888, f.Ocircumflexdotbelow = 7896, f.Ocircumflexgrave = 7890, f.Ocircumflexhookabove = 7892, f.Ocircumflexsmall = 63476, f.Ocircumflextilde = 7894, f.Ocyrillic = 1054, f.Odblacute = 336, f.Odblgrave = 524, f.Odieresis = 214, f.Odieresiscyrillic = 1254, f.Odieresissmall = 63478, f.Odotbelow = 7884, f.Ogoneksmall = 63227, f.Ograve = 210, f.Ogravesmall = 63474, f.Oharmenian = 1365, f.Ohm = 8486, f.Ohookabove = 7886, f.Ohorn = 416, f.Ohornacute = 7898, f.Ohorndotbelow = 7906, f.Ohorngrave = 7900, f.Ohornhookabove = 7902, f.Ohorntilde = 7904, f.Ohungarumlaut = 336, f.Oi = 418, f.Oinvertedbreve = 526, f.Omacron = 332, f.Omacronacute = 7762, f.Omacrongrave = 7760, f.Omega = 8486, f.Omegacyrillic = 1120, f.Omegagreek = 937, f.Omegaroundcyrillic = 1146, f.Omegatitlocyrillic = 1148, f.Omegatonos = 911, f.Omicron = 927, f.Omicrontonos = 908, f.Omonospace = 65327, f.Oneroman = 8544, f.Oogonek = 490, f.Oogonekmacron = 492, f.Oopen = 390, f.Oslash = 216, f.Oslashacute = 510, f.Oslashsmall = 63480, f.Osmall = 63343, f.Ostrokeacute = 510, f.Otcyrillic = 1150, f.Otilde = 213, f.Otildeacute = 7756, f.Otildedieresis = 7758, f.Otildesmall = 63477, f.P = 80, f.Pacute = 7764, f.Pcircle = 9413, f.Pdotaccent = 7766, f.Pecyrillic = 1055, f.Peharmenian = 1354, f.Pemiddlehookcyrillic = 1190, f.Phi = 934, f.Phook = 420, f.Pi = 928, f.Piwrarmenian = 1363, f.Pmonospace = 65328, f.Psi = 936, f.Psicyrillic = 1136, f.Psmall = 63344, f.Q = 81, f.Qcircle = 9414, f.Qmonospace = 65329, f.Qsmall = 63345, f.R = 82, f.Raarmenian = 1356, f.Racute = 340, f.Rcaron = 344, f.Rcedilla = 342, f.Rcircle = 9415, f.Rcommaaccent = 342, f.Rdblgrave = 528, f.Rdotaccent = 7768, f.Rdotbelow = 7770, f.Rdotbelowmacron = 7772, f.Reharmenian = 1360, f.Rfraktur = 8476, f.Rho = 929, f.Ringsmall = 63228, f.Rinvertedbreve = 530, f.Rlinebelow = 7774, f.Rmonospace = 65330, f.Rsmall = 63346, f.Rsmallinverted = 641, f.Rsmallinvertedsuperior = 694, f.S = 83, f.SF010000 = 9484, f.SF020000 = 9492, f.SF030000 = 9488, f.SF040000 = 9496, f.SF050000 = 9532, f.SF060000 = 9516, f.SF070000 = 9524, f.SF080000 = 9500, f.SF090000 = 9508, f.SF100000 = 9472, f.SF110000 = 9474, f.SF190000 = 9569, f.SF200000 = 9570, f.SF210000 = 9558, f.SF220000 = 9557, f.SF230000 = 9571, f.SF240000 = 9553, f.SF250000 = 9559, f.SF260000 = 9565, f.SF270000 = 9564, f.SF280000 = 9563, f.SF360000 = 9566, f.SF370000 = 9567, f.SF380000 = 9562, f.SF390000 = 9556, f.SF400000 = 9577, f.SF410000 = 9574, f.SF420000 = 9568, f.SF430000 = 9552, f.SF440000 = 9580, f.SF450000 = 9575, f.SF460000 = 9576, f.SF470000 = 9572, f.SF480000 = 9573, f.SF490000 = 9561, f.SF500000 = 9560, f.SF510000 = 9554, f.SF520000 = 9555, f.SF530000 = 9579, f.SF540000 = 9578, f.Sacute = 346, f.Sacutedotaccent = 7780, f.Sampigreek = 992, f.Scaron = 352, f.Scarondotaccent = 7782, f.Scaronsmall = 63229, f.Scedilla = 350, f.Schwa = 399, f.Schwacyrillic = 1240, f.Schwadieresiscyrillic = 1242, f.Scircle = 9416, f.Scircumflex = 348, f.Scommaaccent = 536, f.Sdotaccent = 7776, f.Sdotbelow = 7778, f.Sdotbelowdotaccent = 7784, f.Seharmenian = 1357, f.Sevenroman = 8550, f.Shaarmenian = 1351, f.Shacyrillic = 1064, f.Shchacyrillic = 1065, f.Sheicoptic = 994, f.Shhacyrillic = 1210, f.Shimacoptic = 1004, f.Sigma = 931, f.Sixroman = 8549, f.Smonospace = 65331, f.Softsigncyrillic = 1068, f.Ssmall = 63347, f.Stigmagreek = 986, f.T = 84, f.Tau = 932, f.Tbar = 358, f.Tcaron = 356, f.Tcedilla = 354, f.Tcircle = 9417, f.Tcircumflexbelow = 7792, f.Tcommaaccent = 354, f.Tdotaccent = 7786, f.Tdotbelow = 7788, f.Tecyrillic = 1058, f.Tedescendercyrillic = 1196, f.Tenroman = 8553, f.Tetsecyrillic = 1204, f.Theta = 920, f.Thook = 428, f.Thorn = 222, f.Thornsmall = 63486, f.Threeroman = 8546, f.Tildesmall = 63230, f.Tiwnarmenian = 1359, f.Tlinebelow = 7790, f.Tmonospace = 65332, f.Toarmenian = 1337, f.Tonefive = 444, f.Tonesix = 388, f.Tonetwo = 423, f.Tretroflexhook = 430, f.Tsecyrillic = 1062, f.Tshecyrillic = 1035, f.Tsmall = 63348, f.Twelveroman = 8555, f.Tworoman = 8545, f.U = 85, f.Uacute = 218, f.Uacutesmall = 63482, f.Ubreve = 364, f.Ucaron = 467, f.Ucircle = 9418, f.Ucircumflex = 219, f.Ucircumflexbelow = 7798, f.Ucircumflexsmall = 63483, f.Ucyrillic = 1059, f.Udblacute = 368, f.Udblgrave = 532, f.Udieresis = 220, f.Udieresisacute = 471, f.Udieresisbelow = 7794, f.Udieresiscaron = 473, f.Udieresiscyrillic = 1264, f.Udieresisgrave = 475, f.Udieresismacron = 469, f.Udieresissmall = 63484, f.Udotbelow = 7908, f.Ugrave = 217, f.Ugravesmall = 63481, f.Uhookabove = 7910, f.Uhorn = 431, f.Uhornacute = 7912, f.Uhorndotbelow = 7920, f.Uhorngrave = 7914, f.Uhornhookabove = 7916, f.Uhorntilde = 7918, f.Uhungarumlaut = 368, f.Uhungarumlautcyrillic = 1266, f.Uinvertedbreve = 534, f.Ukcyrillic = 1144, f.Umacron = 362, f.Umacroncyrillic = 1262, f.Umacrondieresis = 7802, f.Umonospace = 65333, f.Uogonek = 370, f.Upsilon = 933, f.Upsilon1 = 978, f.Upsilonacutehooksymbolgreek = 979, f.Upsilonafrican = 433, f.Upsilondieresis = 939, f.Upsilondieresishooksymbolgreek = 980, f.Upsilonhooksymbol = 978, f.Upsilontonos = 910, f.Uring = 366, f.Ushortcyrillic = 1038, f.Usmall = 63349, f.Ustraightcyrillic = 1198, f.Ustraightstrokecyrillic = 1200, f.Utilde = 360, f.Utildeacute = 7800, f.Utildebelow = 7796, f.V = 86, f.Vcircle = 9419, f.Vdotbelow = 7806, f.Vecyrillic = 1042, f.Vewarmenian = 1358, f.Vhook = 434, f.Vmonospace = 65334, f.Voarmenian = 1352, f.Vsmall = 63350, f.Vtilde = 7804, f.W = 87, f.Wacute = 7810, f.Wcircle = 9420, f.Wcircumflex = 372, f.Wdieresis = 7812, f.Wdotaccent = 7814, f.Wdotbelow = 7816, f.Wgrave = 7808, f.Wmonospace = 65335, f.Wsmall = 63351, f.X = 88, f.Xcircle = 9421, f.Xdieresis = 7820, f.Xdotaccent = 7818, f.Xeharmenian = 1341, f.Xi = 926, f.Xmonospace = 65336, f.Xsmall = 63352, f.Y = 89, f.Yacute = 221, f.Yacutesmall = 63485, f.Yatcyrillic = 1122, f.Ycircle = 9422, f.Ycircumflex = 374, f.Ydieresis = 376, f.Ydieresissmall = 63487, f.Ydotaccent = 7822, f.Ydotbelow = 7924, f.Yericyrillic = 1067, f.Yerudieresiscyrillic = 1272, f.Ygrave = 7922, f.Yhook = 435, f.Yhookabove = 7926, f.Yiarmenian = 1349, f.Yicyrillic = 1031, f.Yiwnarmenian = 1362, f.Ymonospace = 65337, f.Ysmall = 63353, f.Ytilde = 7928, f.Yusbigcyrillic = 1130, f.Yusbigiotifiedcyrillic = 1132, f.Yuslittlecyrillic = 1126, f.Yuslittleiotifiedcyrillic = 1128, f.Z = 90, f.Zaarmenian = 1334, f.Zacute = 377, f.Zcaron = 381, f.Zcaronsmall = 63231, f.Zcircle = 9423, f.Zcircumflex = 7824, f.Zdot = 379, f.Zdotaccent = 379, f.Zdotbelow = 7826, f.Zecyrillic = 1047, f.Zedescendercyrillic = 1176, f.Zedieresiscyrillic = 1246, f.Zeta = 918, f.Zhearmenian = 1338, f.Zhebrevecyrillic = 1217, f.Zhecyrillic = 1046, f.Zhedescendercyrillic = 1174, f.Zhedieresiscyrillic = 1244, f.Zlinebelow = 7828, f.Zmonospace = 65338, f.Zsmall = 63354, f.Zstroke = 437, f.a = 97, f.aabengali = 2438, f.aacute = 225, f.aadeva = 2310, f.aagujarati = 2694, f.aagurmukhi = 2566, f.aamatragurmukhi = 2622, f.aarusquare = 13059, f.aavowelsignbengali = 2494, f.aavowelsigndeva = 2366, f.aavowelsigngujarati = 2750, f.abbreviationmarkarmenian = 1375, f.abbreviationsigndeva = 2416, f.abengali = 2437, f.abopomofo = 12570, f.abreve = 259, f.abreveacute = 7855, f.abrevecyrillic = 1233, f.abrevedotbelow = 7863, f.abrevegrave = 7857, f.abrevehookabove = 7859, f.abrevetilde = 7861, f.acaron = 462, f.acircle = 9424, f.acircumflex = 226, f.acircumflexacute = 7845, f.acircumflexdotbelow = 7853, f.acircumflexgrave = 7847, f.acircumflexhookabove = 7849, f.acircumflextilde = 7851, f.acute = 180, f.acutebelowcmb = 791, f.acutecmb = 769, f.acutecomb = 769, f.acutedeva = 2388, f.acutelowmod = 719, f.acutetonecmb = 833, f.acyrillic = 1072, f.adblgrave = 513, f.addakgurmukhi = 2673, f.adeva = 2309, f.adieresis = 228, f.adieresiscyrillic = 1235, f.adieresismacron = 479, f.adotbelow = 7841, f.adotmacron = 481, f.ae = 230, f.aeacute = 509, f.aekorean = 12624, f.aemacron = 483, f.afii00208 = 8213, f.afii08941 = 8356, f.afii10017 = 1040, f.afii10018 = 1041, f.afii10019 = 1042, f.afii10020 = 1043, f.afii10021 = 1044, f.afii10022 = 1045, f.afii10023 = 1025, f.afii10024 = 1046, f.afii10025 = 1047, f.afii10026 = 1048, f.afii10027 = 1049, f.afii10028 = 1050, f.afii10029 = 1051, f.afii10030 = 1052, f.afii10031 = 1053, f.afii10032 = 1054, f.afii10033 = 1055, f.afii10034 = 1056, f.afii10035 = 1057, f.afii10036 = 1058, f.afii10037 = 1059, f.afii10038 = 1060, f.afii10039 = 1061, f.afii10040 = 1062, f.afii10041 = 1063, f.afii10042 = 1064, f.afii10043 = 1065, f.afii10044 = 1066, f.afii10045 = 1067, f.afii10046 = 1068, f.afii10047 = 1069, f.afii10048 = 1070, f.afii10049 = 1071, f.afii10050 = 1168, f.afii10051 = 1026, f.afii10052 = 1027, f.afii10053 = 1028, f.afii10054 = 1029, f.afii10055 = 1030, f.afii10056 = 1031, f.afii10057 = 1032, f.afii10058 = 1033, f.afii10059 = 1034, f.afii10060 = 1035, f.afii10061 = 1036, f.afii10062 = 1038, f.afii10063 = 63172, f.afii10064 = 63173, f.afii10065 = 1072, f.afii10066 = 1073, f.afii10067 = 1074, f.afii10068 = 1075, f.afii10069 = 1076, f.afii10070 = 1077, f.afii10071 = 1105, f.afii10072 = 1078, f.afii10073 = 1079, f.afii10074 = 1080, f.afii10075 = 1081, f.afii10076 = 1082, f.afii10077 = 1083, f.afii10078 = 1084, f.afii10079 = 1085, f.afii10080 = 1086, f.afii10081 = 1087, f.afii10082 = 1088, f.afii10083 = 1089, f.afii10084 = 1090, f.afii10085 = 1091, f.afii10086 = 1092, f.afii10087 = 1093, f.afii10088 = 1094, f.afii10089 = 1095, f.afii10090 = 1096, f.afii10091 = 1097, f.afii10092 = 1098, f.afii10093 = 1099, f.afii10094 = 1100, f.afii10095 = 1101, f.afii10096 = 1102, f.afii10097 = 1103, f.afii10098 = 1169, f.afii10099 = 1106, f.afii10100 = 1107, f.afii10101 = 1108, f.afii10102 = 1109, f.afii10103 = 1110, f.afii10104 = 1111, f.afii10105 = 1112, f.afii10106 = 1113, f.afii10107 = 1114, f.afii10108 = 1115, f.afii10109 = 1116, f.afii10110 = 1118, f.afii10145 = 1039, f.afii10146 = 1122, f.afii10147 = 1138, f.afii10148 = 1140, f.afii10192 = 63174, f.afii10193 = 1119, f.afii10194 = 1123, f.afii10195 = 1139, f.afii10196 = 1141, f.afii10831 = 63175, f.afii10832 = 63176, f.afii10846 = 1241, f.afii299 = 8206, f.afii300 = 8207, f.afii301 = 8205, f.afii57381 = 1642, f.afii57388 = 1548, f.afii57392 = 1632, f.afii57393 = 1633, f.afii57394 = 1634, f.afii57395 = 1635, f.afii57396 = 1636, f.afii57397 = 1637, f.afii57398 = 1638, f.afii57399 = 1639, f.afii57400 = 1640, f.afii57401 = 1641, f.afii57403 = 1563, f.afii57407 = 1567, f.afii57409 = 1569, f.afii57410 = 1570, f.afii57411 = 1571, f.afii57412 = 1572, f.afii57413 = 1573, f.afii57414 = 1574, f.afii57415 = 1575, f.afii57416 = 1576, f.afii57417 = 1577, f.afii57418 = 1578, f.afii57419 = 1579, f.afii57420 = 1580, f.afii57421 = 1581, f.afii57422 = 1582, f.afii57423 = 1583, f.afii57424 = 1584, f.afii57425 = 1585, f.afii57426 = 1586, f.afii57427 = 1587, f.afii57428 = 1588, f.afii57429 = 1589, f.afii57430 = 1590, f.afii57431 = 1591, f.afii57432 = 1592, f.afii57433 = 1593, f.afii57434 = 1594, f.afii57440 = 1600, f.afii57441 = 1601, f.afii57442 = 1602, f.afii57443 = 1603, f.afii57444 = 1604, f.afii57445 = 1605, f.afii57446 = 1606, f.afii57448 = 1608, f.afii57449 = 1609, f.afii57450 = 1610, f.afii57451 = 1611, f.afii57452 = 1612, f.afii57453 = 1613, f.afii57454 = 1614, f.afii57455 = 1615, f.afii57456 = 1616, f.afii57457 = 1617, f.afii57458 = 1618, f.afii57470 = 1607, f.afii57505 = 1700, f.afii57506 = 1662, f.afii57507 = 1670, f.afii57508 = 1688, f.afii57509 = 1711, f.afii57511 = 1657, f.afii57512 = 1672, f.afii57513 = 1681, f.afii57514 = 1722, f.afii57519 = 1746, f.afii57534 = 1749, f.afii57636 = 8362, f.afii57645 = 1470, f.afii57658 = 1475, f.afii57664 = 1488, f.afii57665 = 1489, f.afii57666 = 1490, f.afii57667 = 1491, f.afii57668 = 1492, f.afii57669 = 1493, f.afii57670 = 1494, f.afii57671 = 1495, f.afii57672 = 1496, f.afii57673 = 1497, f.afii57674 = 1498, f.afii57675 = 1499, f.afii57676 = 1500, f.afii57677 = 1501, f.afii57678 = 1502, f.afii57679 = 1503, f.afii57680 = 1504, f.afii57681 = 1505, f.afii57682 = 1506, f.afii57683 = 1507, f.afii57684 = 1508, f.afii57685 = 1509, f.afii57686 = 1510, f.afii57687 = 1511, f.afii57688 = 1512, f.afii57689 = 1513, f.afii57690 = 1514, f.afii57694 = 64298, f.afii57695 = 64299, f.afii57700 = 64331, f.afii57705 = 64287, f.afii57716 = 1520, f.afii57717 = 1521, f.afii57718 = 1522, f.afii57723 = 64309, f.afii57793 = 1460, f.afii57794 = 1461, f.afii57795 = 1462, f.afii57796 = 1467, f.afii57797 = 1464, f.afii57798 = 1463, f.afii57799 = 1456, f.afii57800 = 1458, f.afii57801 = 1457, f.afii57802 = 1459, f.afii57803 = 1474, f.afii57804 = 1473, f.afii57806 = 1465, f.afii57807 = 1468, f.afii57839 = 1469, f.afii57841 = 1471, f.afii57842 = 1472, f.afii57929 = 700, f.afii61248 = 8453, f.afii61289 = 8467, f.afii61352 = 8470, f.afii61573 = 8236, f.afii61574 = 8237, f.afii61575 = 8238, f.afii61664 = 8204, f.afii63167 = 1645, f.afii64937 = 701, f.agrave = 224, f.agujarati = 2693, f.agurmukhi = 2565, f.ahiragana = 12354, f.ahookabove = 7843, f.aibengali = 2448, f.aibopomofo = 12574, f.aideva = 2320, f.aiecyrillic = 1237, f.aigujarati = 2704, f.aigurmukhi = 2576, f.aimatragurmukhi = 2632, f.ainarabic = 1593, f.ainfinalarabic = 65226, f.aininitialarabic = 65227, f.ainmedialarabic = 65228, f.ainvertedbreve = 515, f.aivowelsignbengali = 2504, f.aivowelsigndeva = 2376, f.aivowelsigngujarati = 2760, f.akatakana = 12450, f.akatakanahalfwidth = 65393, f.akorean = 12623, f.alef = 1488, f.alefarabic = 1575, f.alefdageshhebrew = 64304, f.aleffinalarabic = 65166, f.alefhamzaabovearabic = 1571, f.alefhamzaabovefinalarabic = 65156, f.alefhamzabelowarabic = 1573, f.alefhamzabelowfinalarabic = 65160, f.alefhebrew = 1488, f.aleflamedhebrew = 64335, f.alefmaddaabovearabic = 1570, f.alefmaddaabovefinalarabic = 65154, f.alefmaksuraarabic = 1609, f.alefmaksurafinalarabic = 65264, f.alefmaksurainitialarabic = 65267, f.alefmaksuramedialarabic = 65268, f.alefpatahhebrew = 64302, f.alefqamatshebrew = 64303, f.aleph = 8501, f.allequal = 8780, f.alpha = 945, f.alphatonos = 940, f.amacron = 257, f.amonospace = 65345, f.ampersand = 38, f.ampersandmonospace = 65286, f.ampersandsmall = 63270, f.amsquare = 13250, f.anbopomofo = 12578, f.angbopomofo = 12580, f.angbracketleft = 12296, f.angbracketright = 12297, f.angkhankhuthai = 3674, f.angle = 8736, f.anglebracketleft = 12296, f.anglebracketleftvertical = 65087, f.anglebracketright = 12297, f.anglebracketrightvertical = 65088, f.angleleft = 9001, f.angleright = 9002, f.angstrom = 8491, f.anoteleia = 903, f.anudattadeva = 2386, f.anusvarabengali = 2434, f.anusvaradeva = 2306, f.anusvaragujarati = 2690, f.aogonek = 261, f.apaatosquare = 13056, f.aparen = 9372, f.apostrophearmenian = 1370, f.apostrophemod = 700, f.apple = 63743, f.approaches = 8784, f.approxequal = 8776, f.approxequalorimage = 8786, f.approximatelyequal = 8773, f.araeaekorean = 12686, f.araeakorean = 12685, f.arc = 8978, f.arighthalfring = 7834, f.aring = 229, f.aringacute = 507, f.aringbelow = 7681, f.arrowboth = 8596, f.arrowdashdown = 8675, f.arrowdashleft = 8672, f.arrowdashright = 8674, f.arrowdashup = 8673, f.arrowdblboth = 8660, f.arrowdbldown = 8659, f.arrowdblleft = 8656, f.arrowdblright = 8658, f.arrowdblup = 8657, f.arrowdown = 8595, f.arrowdownleft = 8601, f.arrowdownright = 8600, f.arrowdownwhite = 8681, f.arrowheaddownmod = 709, f.arrowheadleftmod = 706, f.arrowheadrightmod = 707, f.arrowheadupmod = 708, f.arrowhorizex = 63719, f.arrowleft = 8592, f.arrowleftdbl = 8656, f.arrowleftdblstroke = 8653, f.arrowleftoverright = 8646, f.arrowleftwhite = 8678, f.arrowright = 8594, f.arrowrightdblstroke = 8655, f.arrowrightheavy = 10142, f.arrowrightoverleft = 8644, f.arrowrightwhite = 8680, f.arrowtableft = 8676, f.arrowtabright = 8677, f.arrowup = 8593, f.arrowupdn = 8597, f.arrowupdnbse = 8616, f.arrowupdownbase = 8616, f.arrowupleft = 8598, f.arrowupleftofdown = 8645, f.arrowupright = 8599, f.arrowupwhite = 8679, f.arrowvertex = 63718, f.asciicircum = 94, f.asciicircummonospace = 65342, f.asciitilde = 126, f.asciitildemonospace = 65374, f.ascript = 593, f.ascriptturned = 594, f.asmallhiragana = 12353, f.asmallkatakana = 12449, f.asmallkatakanahalfwidth = 65383, f.asterisk = 42, f.asteriskaltonearabic = 1645, f.asteriskarabic = 1645, f.asteriskmath = 8727, f.asteriskmonospace = 65290, f.asterisksmall = 65121, f.asterism = 8258, f.asuperior = 63209, f.asymptoticallyequal = 8771, f.at = 64, f.atilde = 227, f.atmonospace = 65312, f.atsmall = 65131, f.aturned = 592, f.aubengali = 2452, f.aubopomofo = 12576, f.audeva = 2324, f.augujarati = 2708, f.augurmukhi = 2580, f.aulengthmarkbengali = 2519, f.aumatragurmukhi = 2636, f.auvowelsignbengali = 2508, f.auvowelsigndeva = 2380, f.auvowelsigngujarati = 2764, f.avagrahadeva = 2365, f.aybarmenian = 1377, f.ayin = 1506, f.ayinaltonehebrew = 64288, f.ayinhebrew = 1506, f.b = 98, f.babengali = 2476, f.backslash = 92, f.backslashmonospace = 65340, f.badeva = 2348, f.bagujarati = 2732, f.bagurmukhi = 2604, f.bahiragana = 12400, f.bahtthai = 3647, f.bakatakana = 12496, f.bar = 124, f.barmonospace = 65372, f.bbopomofo = 12549, f.bcircle = 9425, f.bdotaccent = 7683, f.bdotbelow = 7685, f.beamedsixteenthnotes = 9836, f.because = 8757, f.becyrillic = 1073, f.beharabic = 1576, f.behfinalarabic = 65168, f.behinitialarabic = 65169, f.behiragana = 12409, f.behmedialarabic = 65170, f.behmeeminitialarabic = 64671, f.behmeemisolatedarabic = 64520, f.behnoonfinalarabic = 64621, f.bekatakana = 12505, f.benarmenian = 1378, f.bet = 1489, f.beta = 946, f.betasymbolgreek = 976, f.betdagesh = 64305, f.betdageshhebrew = 64305, f.bethebrew = 1489, f.betrafehebrew = 64332, f.bhabengali = 2477, f.bhadeva = 2349, f.bhagujarati = 2733, f.bhagurmukhi = 2605, f.bhook = 595, f.bihiragana = 12403, f.bikatakana = 12499, f.bilabialclick = 664, f.bindigurmukhi = 2562, f.birusquare = 13105, f.blackcircle = 9679, f.blackdiamond = 9670, f.blackdownpointingtriangle = 9660, f.blackleftpointingpointer = 9668, f.blackleftpointingtriangle = 9664, f.blacklenticularbracketleft = 12304, f.blacklenticularbracketleftvertical = 65083, f.blacklenticularbracketright = 12305, f.blacklenticularbracketrightvertical = 65084, f.blacklowerlefttriangle = 9699, f.blacklowerrighttriangle = 9698, f.blackrectangle = 9644, f.blackrightpointingpointer = 9658, f.blackrightpointingtriangle = 9654, f.blacksmallsquare = 9642, f.blacksmilingface = 9787, f.blacksquare = 9632, f.blackstar = 9733, f.blackupperlefttriangle = 9700, f.blackupperrighttriangle = 9701, f.blackuppointingsmalltriangle = 9652, f.blackuppointingtriangle = 9650, f.blank = 9251, f.blinebelow = 7687, f.block = 9608, f.bmonospace = 65346, f.bobaimaithai = 3610, f.bohiragana = 12412, f.bokatakana = 12508, f.bparen = 9373, f.bqsquare = 13251, f.braceex = 63732, f.braceleft = 123, f.braceleftbt = 63731, f.braceleftmid = 63730, f.braceleftmonospace = 65371, f.braceleftsmall = 65115, f.bracelefttp = 63729, f.braceleftvertical = 65079, f.braceright = 125, f.bracerightbt = 63742, f.bracerightmid = 63741, f.bracerightmonospace = 65373, f.bracerightsmall = 65116, f.bracerighttp = 63740, f.bracerightvertical = 65080, f.bracketleft = 91, f.bracketleftbt = 63728, f.bracketleftex = 63727, f.bracketleftmonospace = 65339, f.bracketlefttp = 63726, f.bracketright = 93, f.bracketrightbt = 63739, f.bracketrightex = 63738, f.bracketrightmonospace = 65341, f.bracketrighttp = 63737, f.breve = 728, f.brevebelowcmb = 814, f.brevecmb = 774, f.breveinvertedbelowcmb = 815, f.breveinvertedcmb = 785, f.breveinverteddoublecmb = 865, f.bridgebelowcmb = 810, f.bridgeinvertedbelowcmb = 826, f.brokenbar = 166, f.bstroke = 384, f.bsuperior = 63210, f.btopbar = 387, f.buhiragana = 12406, f.bukatakana = 12502, f.bullet = 8226, f.bulletinverse = 9688, f.bulletoperator = 8729, f.bullseye = 9678, f.c = 99, f.caarmenian = 1390, f.cabengali = 2458, f.cacute = 263, f.cadeva = 2330, f.cagujarati = 2714, f.cagurmukhi = 2586, f.calsquare = 13192, f.candrabindubengali = 2433, f.candrabinducmb = 784, f.candrabindudeva = 2305, f.candrabindugujarati = 2689, f.capslock = 8682, f.careof = 8453, f.caron = 711, f.caronbelowcmb = 812, f.caroncmb = 780, f.carriagereturn = 8629, f.cbopomofo = 12568, f.ccaron = 269, f.ccedilla = 231, f.ccedillaacute = 7689, f.ccircle = 9426, f.ccircumflex = 265, f.ccurl = 597, f.cdot = 267, f.cdotaccent = 267, f.cdsquare = 13253, f.cedilla = 184, f.cedillacmb = 807, f.cent = 162, f.centigrade = 8451, f.centinferior = 63199, f.centmonospace = 65504, f.centoldstyle = 63394, f.centsuperior = 63200, f.chaarmenian = 1401, f.chabengali = 2459, f.chadeva = 2331, f.chagujarati = 2715, f.chagurmukhi = 2587, f.chbopomofo = 12564, f.cheabkhasiancyrillic = 1213, f.checkmark = 10003, f.checyrillic = 1095, f.chedescenderabkhasiancyrillic = 1215, f.chedescendercyrillic = 1207, f.chedieresiscyrillic = 1269, f.cheharmenian = 1395, f.chekhakassiancyrillic = 1228, f.cheverticalstrokecyrillic = 1209, f.chi = 967, f.chieuchacirclekorean = 12919, f.chieuchaparenkorean = 12823, f.chieuchcirclekorean = 12905, f.chieuchkorean = 12618, f.chieuchparenkorean = 12809, f.chochangthai = 3594, f.chochanthai = 3592, f.chochingthai = 3593, f.chochoethai = 3596, f.chook = 392, f.cieucacirclekorean = 12918, f.cieucaparenkorean = 12822, f.cieuccirclekorean = 12904, f.cieuckorean = 12616, f.cieucparenkorean = 12808, f.cieucuparenkorean = 12828, f.circle = 9675, f.circlecopyrt = 169, f.circlemultiply = 8855, f.circleot = 8857, f.circleplus = 8853, f.circlepostalmark = 12342, f.circlewithlefthalfblack = 9680, f.circlewithrighthalfblack = 9681, f.circumflex = 710, f.circumflexbelowcmb = 813, f.circumflexcmb = 770, f.clear = 8999, f.clickalveolar = 450, f.clickdental = 448, f.clicklateral = 449, f.clickretroflex = 451, f.club = 9827, f.clubsuitblack = 9827, f.clubsuitwhite = 9831, f.cmcubedsquare = 13220, f.cmonospace = 65347, f.cmsquaredsquare = 13216, f.coarmenian = 1409, f.colon = 58, f.colonmonetary = 8353, f.colonmonospace = 65306, f.colonsign = 8353, f.colonsmall = 65109, f.colontriangularhalfmod = 721, f.colontriangularmod = 720, f.comma = 44, f.commaabovecmb = 787, f.commaaboverightcmb = 789, f.commaaccent = 63171, f.commaarabic = 1548, f.commaarmenian = 1373, f.commainferior = 63201, f.commamonospace = 65292, f.commareversedabovecmb = 788, f.commareversedmod = 701, f.commasmall = 65104, f.commasuperior = 63202, f.commaturnedabovecmb = 786, f.commaturnedmod = 699, f.compass = 9788, f.congruent = 8773, f.contourintegral = 8750, f.control = 8963, f.controlACK = 6, f.controlBEL = 7, f.controlBS = 8, f.controlCAN = 24, f.controlCR = 13, f.controlDC1 = 17, f.controlDC2 = 18, f.controlDC3 = 19, f.controlDC4 = 20, f.controlDEL = 127, f.controlDLE = 16, f.controlEM = 25, f.controlENQ = 5, f.controlEOT = 4, f.controlESC = 27, f.controlETB = 23, f.controlETX = 3, f.controlFF = 12, f.controlFS = 28, f.controlGS = 29, f.controlHT = 9, f.controlLF = 10, f.controlNAK = 21, f.controlNULL = 0, f.controlRS = 30, f.controlSI = 15, f.controlSO = 14, f.controlSOT = 2, f.controlSTX = 1, f.controlSUB = 26, f.controlSYN = 22, f.controlUS = 31, f.controlVT = 11, f.copyright = 169, f.copyrightsans = 63721, f.copyrightserif = 63193, f.cornerbracketleft = 12300, f.cornerbracketlefthalfwidth = 65378, f.cornerbracketleftvertical = 65089, f.cornerbracketright = 12301, f.cornerbracketrighthalfwidth = 65379, f.cornerbracketrightvertical = 65090, f.corporationsquare = 13183, f.cosquare = 13255, f.coverkgsquare = 13254, f.cparen = 9374, f.cruzeiro = 8354, f.cstretched = 663, f.curlyand = 8911, f.curlyor = 8910, f.currency = 164, f.cyrBreve = 63185, f.cyrFlex = 63186, f.cyrbreve = 63188, f.cyrflex = 63189, f.d = 100, f.daarmenian = 1380, f.dabengali = 2470, f.dadarabic = 1590, f.dadeva = 2342, f.dadfinalarabic = 65214, f.dadinitialarabic = 65215, f.dadmedialarabic = 65216, f.dagesh = 1468, f.dageshhebrew = 1468, f.dagger = 8224, f.daggerdbl = 8225, f.dagujarati = 2726, f.dagurmukhi = 2598, f.dahiragana = 12384, f.dakatakana = 12480, f.dalarabic = 1583, f.dalet = 1491, f.daletdagesh = 64307, f.daletdageshhebrew = 64307, f.dalethebrew = 1491, f.dalfinalarabic = 65194, f.dammaarabic = 1615, f.dammalowarabic = 1615, f.dammatanaltonearabic = 1612, f.dammatanarabic = 1612, f.danda = 2404, f.dargahebrew = 1447, f.dargalefthebrew = 1447, f.dasiapneumatacyrilliccmb = 1157, f.dblGrave = 63187, f.dblanglebracketleft = 12298, f.dblanglebracketleftvertical = 65085, f.dblanglebracketright = 12299, f.dblanglebracketrightvertical = 65086, f.dblarchinvertedbelowcmb = 811, f.dblarrowleft = 8660, f.dblarrowright = 8658, f.dbldanda = 2405, f.dblgrave = 63190, f.dblgravecmb = 783, f.dblintegral = 8748, f.dbllowline = 8215, f.dbllowlinecmb = 819, f.dbloverlinecmb = 831, f.dblprimemod = 698, f.dblverticalbar = 8214, f.dblverticallineabovecmb = 782, f.dbopomofo = 12553, f.dbsquare = 13256, f.dcaron = 271, f.dcedilla = 7697, f.dcircle = 9427, f.dcircumflexbelow = 7699, f.dcroat = 273, f.ddabengali = 2465, f.ddadeva = 2337, f.ddagujarati = 2721, f.ddagurmukhi = 2593, f.ddalarabic = 1672, f.ddalfinalarabic = 64393, f.dddhadeva = 2396, f.ddhabengali = 2466, f.ddhadeva = 2338, f.ddhagujarati = 2722, f.ddhagurmukhi = 2594, f.ddotaccent = 7691, f.ddotbelow = 7693, f.decimalseparatorarabic = 1643, f.decimalseparatorpersian = 1643, f.decyrillic = 1076, f.degree = 176, f.dehihebrew = 1453, f.dehiragana = 12391, f.deicoptic = 1007, f.dekatakana = 12487, f.deleteleft = 9003, f.deleteright = 8998, f.delta = 948, f.deltaturned = 397, f.denominatorminusonenumeratorbengali = 2552, f.dezh = 676, f.dhabengali = 2471, f.dhadeva = 2343, f.dhagujarati = 2727, f.dhagurmukhi = 2599, f.dhook = 599, f.dialytikatonos = 901, f.dialytikatonoscmb = 836, f.diamond = 9830, f.diamondsuitwhite = 9826, f.dieresis = 168, f.dieresisacute = 63191, f.dieresisbelowcmb = 804, f.dieresiscmb = 776, f.dieresisgrave = 63192, f.dieresistonos = 901, f.dihiragana = 12386, f.dikatakana = 12482, f.dittomark = 12291, f.divide = 247, f.divides = 8739, f.divisionslash = 8725, f.djecyrillic = 1106, f.dkshade = 9619, f.dlinebelow = 7695, f.dlsquare = 13207, f.dmacron = 273, f.dmonospace = 65348, f.dnblock = 9604, f.dochadathai = 3598, f.dodekthai = 3604, f.dohiragana = 12393, f.dokatakana = 12489, f.dollar = 36, f.dollarinferior = 63203, f.dollarmonospace = 65284, f.dollaroldstyle = 63268, f.dollarsmall = 65129, f.dollarsuperior = 63204, f.dong = 8363, f.dorusquare = 13094, f.dotaccent = 729, f.dotaccentcmb = 775, f.dotbelowcmb = 803, f.dotbelowcomb = 803, f.dotkatakana = 12539, f.dotlessi = 305, f.dotlessj = 63166, f.dotlessjstrokehook = 644, f.dotmath = 8901, f.dottedcircle = 9676, f.doubleyodpatah = 64287, f.doubleyodpatahhebrew = 64287, f.downtackbelowcmb = 798, f.downtackmod = 725, f.dparen = 9375, f.dsuperior = 63211, f.dtail = 598, f.dtopbar = 396, f.duhiragana = 12389, f.dukatakana = 12485, f.dz = 499, f.dzaltone = 675, f.dzcaron = 454, f.dzcurl = 677, f.dzeabkhasiancyrillic = 1249, f.dzecyrillic = 1109, f.dzhecyrillic = 1119, f.e = 101, f.eacute = 233, f.earth = 9793, f.ebengali = 2447, f.ebopomofo = 12572, f.ebreve = 277, f.ecandradeva = 2317, f.ecandragujarati = 2701, f.ecandravowelsigndeva = 2373, f.ecandravowelsigngujarati = 2757, f.ecaron = 283, f.ecedillabreve = 7709, f.echarmenian = 1381, f.echyiwnarmenian = 1415, f.ecircle = 9428, f.ecircumflex = 234, f.ecircumflexacute = 7871, f.ecircumflexbelow = 7705, f.ecircumflexdotbelow = 7879, f.ecircumflexgrave = 7873, f.ecircumflexhookabove = 7875, f.ecircumflextilde = 7877, f.ecyrillic = 1108, f.edblgrave = 517, f.edeva = 2319, f.edieresis = 235, f.edot = 279, f.edotaccent = 279, f.edotbelow = 7865, f.eegurmukhi = 2575, f.eematragurmukhi = 2631, f.efcyrillic = 1092, f.egrave = 232, f.egujarati = 2703, f.eharmenian = 1383, f.ehbopomofo = 12573, f.ehiragana = 12360, f.ehookabove = 7867, f.eibopomofo = 12575, f.eight = 56, f.eightarabic = 1640, f.eightbengali = 2542, f.eightcircle = 9319, f.eightcircleinversesansserif = 10129, f.eightdeva = 2414, f.eighteencircle = 9329, f.eighteenparen = 9349, f.eighteenperiod = 9369, f.eightgujarati = 2798, f.eightgurmukhi = 2670, f.eighthackarabic = 1640, f.eighthangzhou = 12328, f.eighthnotebeamed = 9835, f.eightideographicparen = 12839, f.eightinferior = 8328, f.eightmonospace = 65304, f.eightoldstyle = 63288, f.eightparen = 9339, f.eightperiod = 9359, f.eightpersian = 1784, f.eightroman = 8567, f.eightsuperior = 8312, f.eightthai = 3672, f.einvertedbreve = 519, f.eiotifiedcyrillic = 1125, f.ekatakana = 12456, f.ekatakanahalfwidth = 65396, f.ekonkargurmukhi = 2676, f.ekorean = 12628, f.elcyrillic = 1083, f.element = 8712, f.elevencircle = 9322, f.elevenparen = 9342, f.elevenperiod = 9362, f.elevenroman = 8570, f.ellipsis = 8230, f.ellipsisvertical = 8942, f.emacron = 275, f.emacronacute = 7703, f.emacrongrave = 7701, f.emcyrillic = 1084, f.emdash = 8212, f.emdashvertical = 65073, f.emonospace = 65349, f.emphasismarkarmenian = 1371, f.emptyset = 8709, f.enbopomofo = 12579, f.encyrillic = 1085, f.endash = 8211, f.endashvertical = 65074, f.endescendercyrillic = 1187, f.eng = 331, f.engbopomofo = 12581, f.enghecyrillic = 1189, f.enhookcyrillic = 1224, f.enspace = 8194, f.eogonek = 281, f.eokorean = 12627, f.eopen = 603, f.eopenclosed = 666, f.eopenreversed = 604, f.eopenreversedclosed = 606, f.eopenreversedhook = 605, f.eparen = 9376, f.epsilon = 949, f.epsilontonos = 941, f.equal = 61, f.equalmonospace = 65309, f.equalsmall = 65126, f.equalsuperior = 8316, f.equivalence = 8801, f.erbopomofo = 12582, f.ercyrillic = 1088, f.ereversed = 600, f.ereversedcyrillic = 1101, f.escyrillic = 1089, f.esdescendercyrillic = 1195, f.esh = 643, f.eshcurl = 646, f.eshortdeva = 2318, f.eshortvowelsigndeva = 2374, f.eshreversedloop = 426, f.eshsquatreversed = 645, f.esmallhiragana = 12359, f.esmallkatakana = 12455, f.esmallkatakanahalfwidth = 65386, f.estimated = 8494, f.esuperior = 63212, f.eta = 951, f.etarmenian = 1384, f.etatonos = 942, f.eth = 240, f.etilde = 7869, f.etildebelow = 7707, f.etnahtafoukhhebrew = 1425, f.etnahtafoukhlefthebrew = 1425, f.etnahtahebrew = 1425, f.etnahtalefthebrew = 1425, f.eturned = 477, f.eukorean = 12641, f.euro = 8364, f.evowelsignbengali = 2503, f.evowelsigndeva = 2375, f.evowelsigngujarati = 2759, f.exclam = 33, f.exclamarmenian = 1372, f.exclamdbl = 8252, f.exclamdown = 161, f.exclamdownsmall = 63393, f.exclammonospace = 65281, f.exclamsmall = 63265, f.existential = 8707, f.ezh = 658, f.ezhcaron = 495, f.ezhcurl = 659, f.ezhreversed = 441, f.ezhtail = 442, f.f = 102, f.fadeva = 2398, f.fagurmukhi = 2654, f.fahrenheit = 8457, f.fathaarabic = 1614, f.fathalowarabic = 1614, f.fathatanarabic = 1611, f.fbopomofo = 12552, f.fcircle = 9429, f.fdotaccent = 7711, f.feharabic = 1601, f.feharmenian = 1414, f.fehfinalarabic = 65234, f.fehinitialarabic = 65235, f.fehmedialarabic = 65236, f.feicoptic = 997, f.female = 9792, f.ff = 64256, f.f_f = 64256, f.ffi = 64259, f.f_f_i = 64259, f.ffl = 64260, f.f_f_l = 64260, f.fi = 64257, f.f_i = 64257, f.fifteencircle = 9326, f.fifteenparen = 9346, f.fifteenperiod = 9366, f.figuredash = 8210, f.filledbox = 9632, f.filledrect = 9644, f.finalkaf = 1498, f.finalkafdagesh = 64314, f.finalkafdageshhebrew = 64314, f.finalkafhebrew = 1498, f.finalmem = 1501, f.finalmemhebrew = 1501, f.finalnun = 1503, f.finalnunhebrew = 1503, f.finalpe = 1507, f.finalpehebrew = 1507, f.finaltsadi = 1509, f.finaltsadihebrew = 1509, f.firsttonechinese = 713, f.fisheye = 9673, f.fitacyrillic = 1139, f.five = 53, f.fivearabic = 1637, f.fivebengali = 2539, f.fivecircle = 9316, f.fivecircleinversesansserif = 10126, f.fivedeva = 2411, f.fiveeighths = 8541, f.fivegujarati = 2795, f.fivegurmukhi = 2667, f.fivehackarabic = 1637, f.fivehangzhou = 12325, f.fiveideographicparen = 12836, f.fiveinferior = 8325, f.fivemonospace = 65301, f.fiveoldstyle = 63285, f.fiveparen = 9336, f.fiveperiod = 9356, f.fivepersian = 1781, f.fiveroman = 8564, f.fivesuperior = 8309, f.fivethai = 3669, f.fl = 64258, f.f_l = 64258, f.florin = 402, f.fmonospace = 65350, f.fmsquare = 13209, f.fofanthai = 3615, f.fofathai = 3613, f.fongmanthai = 3663, f.forall = 8704, f.four = 52, f.fourarabic = 1636, f.fourbengali = 2538, f.fourcircle = 9315, f.fourcircleinversesansserif = 10125, f.fourdeva = 2410, f.fourgujarati = 2794, f.fourgurmukhi = 2666, f.fourhackarabic = 1636, f.fourhangzhou = 12324, f.fourideographicparen = 12835, f.fourinferior = 8324, f.fourmonospace = 65300, f.fournumeratorbengali = 2551, f.fouroldstyle = 63284, f.fourparen = 9335, f.fourperiod = 9355, f.fourpersian = 1780, f.fourroman = 8563, f.foursuperior = 8308, f.fourteencircle = 9325, f.fourteenparen = 9345, f.fourteenperiod = 9365, f.fourthai = 3668, f.fourthtonechinese = 715, f.fparen = 9377, f.fraction = 8260, f.franc = 8355, f.g = 103, f.gabengali = 2455, f.gacute = 501, f.gadeva = 2327, f.gafarabic = 1711, f.gaffinalarabic = 64403, f.gafinitialarabic = 64404, f.gafmedialarabic = 64405, f.gagujarati = 2711, f.gagurmukhi = 2583, f.gahiragana = 12364, f.gakatakana = 12460, f.gamma = 947, f.gammalatinsmall = 611, f.gammasuperior = 736, f.gangiacoptic = 1003, f.gbopomofo = 12557, f.gbreve = 287, f.gcaron = 487, f.gcedilla = 291, f.gcircle = 9430, f.gcircumflex = 285, f.gcommaaccent = 291, f.gdot = 289, f.gdotaccent = 289, f.gecyrillic = 1075, f.gehiragana = 12370, f.gekatakana = 12466, f.geometricallyequal = 8785, f.gereshaccenthebrew = 1436, f.gereshhebrew = 1523, f.gereshmuqdamhebrew = 1437, f.germandbls = 223, f.gershayimaccenthebrew = 1438, f.gershayimhebrew = 1524, f.getamark = 12307, f.ghabengali = 2456, f.ghadarmenian = 1394, f.ghadeva = 2328, f.ghagujarati = 2712, f.ghagurmukhi = 2584, f.ghainarabic = 1594, f.ghainfinalarabic = 65230, f.ghaininitialarabic = 65231, f.ghainmedialarabic = 65232, f.ghemiddlehookcyrillic = 1173, f.ghestrokecyrillic = 1171, f.gheupturncyrillic = 1169, f.ghhadeva = 2394, f.ghhagurmukhi = 2650, f.ghook = 608, f.ghzsquare = 13203, f.gihiragana = 12366, f.gikatakana = 12462, f.gimarmenian = 1379, f.gimel = 1490, f.gimeldagesh = 64306, f.gimeldageshhebrew = 64306, f.gimelhebrew = 1490, f.gjecyrillic = 1107, f.glottalinvertedstroke = 446, f.glottalstop = 660, f.glottalstopinverted = 662, f.glottalstopmod = 704, f.glottalstopreversed = 661, f.glottalstopreversedmod = 705, f.glottalstopreversedsuperior = 740, f.glottalstopstroke = 673, f.glottalstopstrokereversed = 674, f.gmacron = 7713, f.gmonospace = 65351, f.gohiragana = 12372, f.gokatakana = 12468, f.gparen = 9378, f.gpasquare = 13228, f.gradient = 8711, f.grave = 96, f.gravebelowcmb = 790, f.gravecmb = 768, f.gravecomb = 768, f.gravedeva = 2387, f.gravelowmod = 718, f.gravemonospace = 65344, f.gravetonecmb = 832, f.greater = 62, f.greaterequal = 8805, f.greaterequalorless = 8923, f.greatermonospace = 65310, f.greaterorequivalent = 8819, f.greaterorless = 8823, f.greateroverequal = 8807, f.greatersmall = 65125, f.gscript = 609, f.gstroke = 485, f.guhiragana = 12368, f.guillemotleft = 171, f.guillemotright = 187, f.guilsinglleft = 8249, f.guilsinglright = 8250, f.gukatakana = 12464, f.guramusquare = 13080, f.gysquare = 13257, f.h = 104, f.haabkhasiancyrillic = 1193, f.haaltonearabic = 1729, f.habengali = 2489, f.hadescendercyrillic = 1203, f.hadeva = 2361, f.hagujarati = 2745, f.hagurmukhi = 2617, f.haharabic = 1581, f.hahfinalarabic = 65186, f.hahinitialarabic = 65187, f.hahiragana = 12399, f.hahmedialarabic = 65188, f.haitusquare = 13098, f.hakatakana = 12495, f.hakatakanahalfwidth = 65418, f.halantgurmukhi = 2637, f.hamzaarabic = 1569, f.hamzalowarabic = 1569, f.hangulfiller = 12644, f.hardsigncyrillic = 1098, f.harpoonleftbarbup = 8636, f.harpoonrightbarbup = 8640, f.hasquare = 13258, f.hatafpatah = 1458, f.hatafpatah16 = 1458, f.hatafpatah23 = 1458, f.hatafpatah2f = 1458, f.hatafpatahhebrew = 1458, f.hatafpatahnarrowhebrew = 1458, f.hatafpatahquarterhebrew = 1458, f.hatafpatahwidehebrew = 1458, f.hatafqamats = 1459, f.hatafqamats1b = 1459, f.hatafqamats28 = 1459, f.hatafqamats34 = 1459, f.hatafqamatshebrew = 1459, f.hatafqamatsnarrowhebrew = 1459, f.hatafqamatsquarterhebrew = 1459, f.hatafqamatswidehebrew = 1459, f.hatafsegol = 1457, f.hatafsegol17 = 1457, f.hatafsegol24 = 1457, f.hatafsegol30 = 1457, f.hatafsegolhebrew = 1457, f.hatafsegolnarrowhebrew = 1457, f.hatafsegolquarterhebrew = 1457, f.hatafsegolwidehebrew = 1457, f.hbar = 295, f.hbopomofo = 12559, f.hbrevebelow = 7723, f.hcedilla = 7721, f.hcircle = 9431, f.hcircumflex = 293, f.hdieresis = 7719, f.hdotaccent = 7715, f.hdotbelow = 7717, f.he = 1492, f.heart = 9829, f.heartsuitblack = 9829, f.heartsuitwhite = 9825, f.hedagesh = 64308, f.hedageshhebrew = 64308, f.hehaltonearabic = 1729, f.heharabic = 1607, f.hehebrew = 1492, f.hehfinalaltonearabic = 64423, f.hehfinalalttwoarabic = 65258, f.hehfinalarabic = 65258, f.hehhamzaabovefinalarabic = 64421, f.hehhamzaaboveisolatedarabic = 64420, f.hehinitialaltonearabic = 64424, f.hehinitialarabic = 65259, f.hehiragana = 12408, f.hehmedialaltonearabic = 64425, f.hehmedialarabic = 65260, f.heiseierasquare = 13179, f.hekatakana = 12504, f.hekatakanahalfwidth = 65421, f.hekutaarusquare = 13110, f.henghook = 615, f.herutusquare = 13113, f.het = 1495, f.hethebrew = 1495, f.hhook = 614, f.hhooksuperior = 689, f.hieuhacirclekorean = 12923, f.hieuhaparenkorean = 12827, f.hieuhcirclekorean = 12909, f.hieuhkorean = 12622, f.hieuhparenkorean = 12813, f.hihiragana = 12402, f.hikatakana = 12498, f.hikatakanahalfwidth = 65419, f.hiriq = 1460, f.hiriq14 = 1460, f.hiriq21 = 1460, f.hiriq2d = 1460, f.hiriqhebrew = 1460, f.hiriqnarrowhebrew = 1460, f.hiriqquarterhebrew = 1460, f.hiriqwidehebrew = 1460, f.hlinebelow = 7830, f.hmonospace = 65352, f.hoarmenian = 1392, f.hohipthai = 3627, f.hohiragana = 12411, f.hokatakana = 12507, f.hokatakanahalfwidth = 65422, f.holam = 1465, f.holam19 = 1465, f.holam26 = 1465, f.holam32 = 1465, f.holamhebrew = 1465, f.holamnarrowhebrew = 1465, f.holamquarterhebrew = 1465, f.holamwidehebrew = 1465, f.honokhukthai = 3630, f.hookabovecomb = 777, f.hookcmb = 777, f.hookpalatalizedbelowcmb = 801, f.hookretroflexbelowcmb = 802, f.hoonsquare = 13122, f.horicoptic = 1001, f.horizontalbar = 8213, f.horncmb = 795, f.hotsprings = 9832, f.house = 8962, f.hparen = 9379, f.hsuperior = 688, f.hturned = 613, f.huhiragana = 12405, f.huiitosquare = 13107, f.hukatakana = 12501, f.hukatakanahalfwidth = 65420, f.hungarumlaut = 733, f.hungarumlautcmb = 779, f.hv = 405, f.hyphen = 45, f.hypheninferior = 63205, f.hyphenmonospace = 65293, f.hyphensmall = 65123, f.hyphensuperior = 63206, f.hyphentwo = 8208, f.i = 105, f.iacute = 237, f.iacyrillic = 1103, f.ibengali = 2439, f.ibopomofo = 12583, f.ibreve = 301, f.icaron = 464, f.icircle = 9432, f.icircumflex = 238, f.icyrillic = 1110, f.idblgrave = 521, f.ideographearthcircle = 12943, f.ideographfirecircle = 12939, f.ideographicallianceparen = 12863, f.ideographiccallparen = 12858, f.ideographiccentrecircle = 12965, f.ideographicclose = 12294, f.ideographiccomma = 12289, f.ideographiccommaleft = 65380, f.ideographiccongratulationparen = 12855, f.ideographiccorrectcircle = 12963, f.ideographicearthparen = 12847, f.ideographicenterpriseparen = 12861, f.ideographicexcellentcircle = 12957, f.ideographicfestivalparen = 12864, f.ideographicfinancialcircle = 12950, f.ideographicfinancialparen = 12854, f.ideographicfireparen = 12843, f.ideographichaveparen = 12850, f.ideographichighcircle = 12964, f.ideographiciterationmark = 12293, f.ideographiclaborcircle = 12952, f.ideographiclaborparen = 12856, f.ideographicleftcircle = 12967, f.ideographiclowcircle = 12966, f.ideographicmedicinecircle = 12969, f.ideographicmetalparen = 12846, f.ideographicmoonparen = 12842, f.ideographicnameparen = 12852, f.ideographicperiod = 12290, f.ideographicprintcircle = 12958, f.ideographicreachparen = 12867, f.ideographicrepresentparen = 12857, f.ideographicresourceparen = 12862, f.ideographicrightcircle = 12968, f.ideographicsecretcircle = 12953, f.ideographicselfparen = 12866, f.ideographicsocietyparen = 12851, f.ideographicspace = 12288, f.ideographicspecialparen = 12853, f.ideographicstockparen = 12849, f.ideographicstudyparen = 12859, f.ideographicsunparen = 12848, f.ideographicsuperviseparen = 12860, f.ideographicwaterparen = 12844, f.ideographicwoodparen = 12845, f.ideographiczero = 12295, f.ideographmetalcircle = 12942, f.ideographmooncircle = 12938, f.ideographnamecircle = 12948, f.ideographsuncircle = 12944, f.ideographwatercircle = 12940, f.ideographwoodcircle = 12941, f.ideva = 2311, f.idieresis = 239, f.idieresisacute = 7727, f.idieresiscyrillic = 1253, f.idotbelow = 7883, f.iebrevecyrillic = 1239, f.iecyrillic = 1077, f.ieungacirclekorean = 12917, f.ieungaparenkorean = 12821, f.ieungcirclekorean = 12903, f.ieungkorean = 12615, f.ieungparenkorean = 12807, f.igrave = 236, f.igujarati = 2695, f.igurmukhi = 2567, f.ihiragana = 12356, f.ihookabove = 7881, f.iibengali = 2440, f.iicyrillic = 1080, f.iideva = 2312, f.iigujarati = 2696, f.iigurmukhi = 2568, f.iimatragurmukhi = 2624, f.iinvertedbreve = 523, f.iishortcyrillic = 1081, f.iivowelsignbengali = 2496, f.iivowelsigndeva = 2368, f.iivowelsigngujarati = 2752, f.ij = 307, f.ikatakana = 12452, f.ikatakanahalfwidth = 65394, f.ikorean = 12643, f.ilde = 732, f.iluyhebrew = 1452, f.imacron = 299, f.imacroncyrillic = 1251, f.imageorapproximatelyequal = 8787, f.imatragurmukhi = 2623, f.imonospace = 65353, f.increment = 8710, f.infinity = 8734, f.iniarmenian = 1387, f.integral = 8747, f.integralbottom = 8993, f.integralbt = 8993, f.integralex = 63733, f.integraltop = 8992, f.integraltp = 8992, f.intersection = 8745, f.intisquare = 13061, f.invbullet = 9688, f.invcircle = 9689, f.invsmileface = 9787, f.iocyrillic = 1105, f.iogonek = 303, f.iota = 953, f.iotadieresis = 970, f.iotadieresistonos = 912, f.iotalatin = 617, f.iotatonos = 943, f.iparen = 9380, f.irigurmukhi = 2674, f.ismallhiragana = 12355, f.ismallkatakana = 12451, f.ismallkatakanahalfwidth = 65384, f.issharbengali = 2554, f.istroke = 616, f.isuperior = 63213, f.iterationhiragana = 12445, f.iterationkatakana = 12541, f.itilde = 297, f.itildebelow = 7725, f.iubopomofo = 12585, f.iucyrillic = 1102, f.ivowelsignbengali = 2495, f.ivowelsigndeva = 2367, f.ivowelsigngujarati = 2751, f.izhitsacyrillic = 1141, f.izhitsadblgravecyrillic = 1143, f.j = 106, f.jaarmenian = 1393, f.jabengali = 2460, f.jadeva = 2332, f.jagujarati = 2716, f.jagurmukhi = 2588, f.jbopomofo = 12560, f.jcaron = 496, f.jcircle = 9433, f.jcircumflex = 309, f.jcrossedtail = 669, f.jdotlessstroke = 607, f.jecyrillic = 1112, f.jeemarabic = 1580, f.jeemfinalarabic = 65182, f.jeeminitialarabic = 65183, f.jeemmedialarabic = 65184, f.jeharabic = 1688, f.jehfinalarabic = 64395, f.jhabengali = 2461, f.jhadeva = 2333, f.jhagujarati = 2717, f.jhagurmukhi = 2589, f.jheharmenian = 1403, f.jis = 12292, f.jmonospace = 65354, f.jparen = 9381, f.jsuperior = 690, f.k = 107, f.kabashkircyrillic = 1185, f.kabengali = 2453, f.kacute = 7729, f.kacyrillic = 1082, f.kadescendercyrillic = 1179, f.kadeva = 2325, f.kaf = 1499, f.kafarabic = 1603, f.kafdagesh = 64315, f.kafdageshhebrew = 64315, f.kaffinalarabic = 65242, f.kafhebrew = 1499, f.kafinitialarabic = 65243, f.kafmedialarabic = 65244, f.kafrafehebrew = 64333, f.kagujarati = 2709, f.kagurmukhi = 2581, f.kahiragana = 12363, f.kahookcyrillic = 1220, f.kakatakana = 12459, f.kakatakanahalfwidth = 65398, f.kappa = 954, f.kappasymbolgreek = 1008, f.kapyeounmieumkorean = 12657, f.kapyeounphieuphkorean = 12676, f.kapyeounpieupkorean = 12664, f.kapyeounssangpieupkorean = 12665, f.karoriisquare = 13069, f.kashidaautoarabic = 1600, f.kashidaautonosidebearingarabic = 1600, f.kasmallkatakana = 12533, f.kasquare = 13188, f.kasraarabic = 1616, f.kasratanarabic = 1613, f.kastrokecyrillic = 1183, f.katahiraprolongmarkhalfwidth = 65392, f.kaverticalstrokecyrillic = 1181, f.kbopomofo = 12558, f.kcalsquare = 13193, f.kcaron = 489, f.kcedilla = 311, f.kcircle = 9434, f.kcommaaccent = 311, f.kdotbelow = 7731, f.keharmenian = 1412, f.kehiragana = 12369, f.kekatakana = 12465, f.kekatakanahalfwidth = 65401, f.kenarmenian = 1391, f.kesmallkatakana = 12534, f.kgreenlandic = 312, f.khabengali = 2454, f.khacyrillic = 1093, f.khadeva = 2326, f.khagujarati = 2710, f.khagurmukhi = 2582, f.khaharabic = 1582, f.khahfinalarabic = 65190, f.khahinitialarabic = 65191, f.khahmedialarabic = 65192, f.kheicoptic = 999, f.khhadeva = 2393, f.khhagurmukhi = 2649, f.khieukhacirclekorean = 12920, f.khieukhaparenkorean = 12824, f.khieukhcirclekorean = 12906, f.khieukhkorean = 12619, f.khieukhparenkorean = 12810, f.khokhaithai = 3586, f.khokhonthai = 3589, f.khokhuatthai = 3587, f.khokhwaithai = 3588, f.khomutthai = 3675, f.khook = 409, f.khorakhangthai = 3590, f.khzsquare = 13201, f.kihiragana = 12365, f.kikatakana = 12461, f.kikatakanahalfwidth = 65399, f.kiroguramusquare = 13077, f.kiromeetorusquare = 13078, f.kirosquare = 13076, f.kiyeokacirclekorean = 12910, f.kiyeokaparenkorean = 12814, f.kiyeokcirclekorean = 12896, f.kiyeokkorean = 12593, f.kiyeokparenkorean = 12800, f.kiyeoksioskorean = 12595, f.kjecyrillic = 1116, f.klinebelow = 7733, f.klsquare = 13208, f.kmcubedsquare = 13222, f.kmonospace = 65355, f.kmsquaredsquare = 13218, f.kohiragana = 12371, f.kohmsquare = 13248, f.kokaithai = 3585, f.kokatakana = 12467, f.kokatakanahalfwidth = 65402, f.kooposquare = 13086, f.koppacyrillic = 1153, f.koreanstandardsymbol = 12927, f.koroniscmb = 835, f.kparen = 9382, f.kpasquare = 13226, f.ksicyrillic = 1135, f.ktsquare = 13263, f.kturned = 670, f.kuhiragana = 12367, f.kukatakana = 12463, f.kukatakanahalfwidth = 65400, f.kvsquare = 13240, f.kwsquare = 13246, f.l = 108, f.labengali = 2482, f.lacute = 314, f.ladeva = 2354, f.lagujarati = 2738, f.lagurmukhi = 2610, f.lakkhangyaothai = 3653, f.lamaleffinalarabic = 65276, f.lamalefhamzaabovefinalarabic = 65272, f.lamalefhamzaaboveisolatedarabic = 65271, f.lamalefhamzabelowfinalarabic = 65274, f.lamalefhamzabelowisolatedarabic = 65273, f.lamalefisolatedarabic = 65275, f.lamalefmaddaabovefinalarabic = 65270, f.lamalefmaddaaboveisolatedarabic = 65269, f.lamarabic = 1604, f.lambda = 955, f.lambdastroke = 411, f.lamed = 1500, f.lameddagesh = 64316, f.lameddageshhebrew = 64316, f.lamedhebrew = 1500, f.lamfinalarabic = 65246, f.lamhahinitialarabic = 64714, f.laminitialarabic = 65247, f.lamjeeminitialarabic = 64713, f.lamkhahinitialarabic = 64715, f.lamlamhehisolatedarabic = 65010, f.lammedialarabic = 65248, f.lammeemhahinitialarabic = 64904, f.lammeeminitialarabic = 64716, f.largecircle = 9711, f.lbar = 410, f.lbelt = 620, f.lbopomofo = 12556, f.lcaron = 318, f.lcedilla = 316, f.lcircle = 9435, f.lcircumflexbelow = 7741, f.lcommaaccent = 316, f.ldot = 320, f.ldotaccent = 320, f.ldotbelow = 7735, f.ldotbelowmacron = 7737, f.leftangleabovecmb = 794, f.lefttackbelowcmb = 792, f.less = 60, f.lessequal = 8804, f.lessequalorgreater = 8922, f.lessmonospace = 65308, f.lessorequivalent = 8818, f.lessorgreater = 8822, f.lessoverequal = 8806, f.lesssmall = 65124, f.lezh = 622, f.lfblock = 9612, f.lhookretroflex = 621, f.lira = 8356, f.liwnarmenian = 1388, f.lj = 457, f.ljecyrillic = 1113, f.ll = 63168, f.lladeva = 2355, f.llagujarati = 2739, f.llinebelow = 7739, f.llladeva = 2356, f.llvocalicbengali = 2529, f.llvocalicdeva = 2401, f.llvocalicvowelsignbengali = 2531, f.llvocalicvowelsigndeva = 2403, f.lmiddletilde = 619, f.lmonospace = 65356, f.lmsquare = 13264, f.lochulathai = 3628, f.logicaland = 8743, f.logicalnot = 172, f.logicalnotreversed = 8976, f.logicalor = 8744, f.lolingthai = 3621, f.longs = 383, f.lowlinecenterline = 65102, f.lowlinecmb = 818, f.lowlinedashed = 65101, f.lozenge = 9674, f.lparen = 9383, f.lslash = 322, f.lsquare = 8467, f.lsuperior = 63214, f.ltshade = 9617, f.luthai = 3622, f.lvocalicbengali = 2444, f.lvocalicdeva = 2316, f.lvocalicvowelsignbengali = 2530, f.lvocalicvowelsigndeva = 2402, f.lxsquare = 13267, f.m = 109, f.mabengali = 2478, f.macron = 175, f.macronbelowcmb = 817, f.macroncmb = 772, f.macronlowmod = 717, f.macronmonospace = 65507, f.macute = 7743, f.madeva = 2350, f.magujarati = 2734, f.magurmukhi = 2606, f.mahapakhhebrew = 1444, f.mahapakhlefthebrew = 1444, f.mahiragana = 12414, f.maichattawalowleftthai = 63637, f.maichattawalowrightthai = 63636, f.maichattawathai = 3659, f.maichattawaupperleftthai = 63635, f.maieklowleftthai = 63628, f.maieklowrightthai = 63627, f.maiekthai = 3656, f.maiekupperleftthai = 63626, f.maihanakatleftthai = 63620, f.maihanakatthai = 3633, f.maitaikhuleftthai = 63625, f.maitaikhuthai = 3655, f.maitholowleftthai = 63631, f.maitholowrightthai = 63630, f.maithothai = 3657, f.maithoupperleftthai = 63629, f.maitrilowleftthai = 63634, f.maitrilowrightthai = 63633, f.maitrithai = 3658, f.maitriupperleftthai = 63632, f.maiyamokthai = 3654, f.makatakana = 12510, f.makatakanahalfwidth = 65423, f.male = 9794, f.mansyonsquare = 13127, f.maqafhebrew = 1470, f.mars = 9794, f.masoracirclehebrew = 1455, f.masquare = 13187, f.mbopomofo = 12551, f.mbsquare = 13268, f.mcircle = 9436, f.mcubedsquare = 13221, f.mdotaccent = 7745, f.mdotbelow = 7747, f.meemarabic = 1605, f.meemfinalarabic = 65250, f.meeminitialarabic = 65251, f.meemmedialarabic = 65252, f.meemmeeminitialarabic = 64721, f.meemmeemisolatedarabic = 64584, f.meetorusquare = 13133, f.mehiragana = 12417, f.meizierasquare = 13182, f.mekatakana = 12513, f.mekatakanahalfwidth = 65426, f.mem = 1502, f.memdagesh = 64318, f.memdageshhebrew = 64318, f.memhebrew = 1502, f.menarmenian = 1396, f.merkhahebrew = 1445, f.merkhakefulahebrew = 1446, f.merkhakefulalefthebrew = 1446, f.merkhalefthebrew = 1445, f.mhook = 625, f.mhzsquare = 13202, f.middledotkatakanahalfwidth = 65381, f.middot = 183, f.mieumacirclekorean = 12914, f.mieumaparenkorean = 12818, f.mieumcirclekorean = 12900, f.mieumkorean = 12609, f.mieumpansioskorean = 12656, f.mieumparenkorean = 12804, f.mieumpieupkorean = 12654, f.mieumsioskorean = 12655, f.mihiragana = 12415, f.mikatakana = 12511, f.mikatakanahalfwidth = 65424, f.minus = 8722, f.minusbelowcmb = 800, f.minuscircle = 8854, f.minusmod = 727, f.minusplus = 8723, f.minute = 8242, f.miribaarusquare = 13130, f.mirisquare = 13129, f.mlonglegturned = 624, f.mlsquare = 13206, f.mmcubedsquare = 13219, f.mmonospace = 65357, f.mmsquaredsquare = 13215, f.mohiragana = 12418, f.mohmsquare = 13249, f.mokatakana = 12514, f.mokatakanahalfwidth = 65427, f.molsquare = 13270, f.momathai = 3617, f.moverssquare = 13223, f.moverssquaredsquare = 13224, f.mparen = 9384, f.mpasquare = 13227, f.mssquare = 13235, f.msuperior = 63215, f.mturned = 623, f.mu = 181, f.mu1 = 181, f.muasquare = 13186, f.muchgreater = 8811, f.muchless = 8810, f.mufsquare = 13196, f.mugreek = 956, f.mugsquare = 13197, f.muhiragana = 12416, f.mukatakana = 12512, f.mukatakanahalfwidth = 65425, f.mulsquare = 13205, f.multiply = 215, f.mumsquare = 13211, f.munahhebrew = 1443, f.munahlefthebrew = 1443, f.musicalnote = 9834, f.musicalnotedbl = 9835, f.musicflatsign = 9837, f.musicsharpsign = 9839, f.mussquare = 13234, f.muvsquare = 13238, f.muwsquare = 13244, f.mvmegasquare = 13241, f.mvsquare = 13239, f.mwmegasquare = 13247, f.mwsquare = 13245, f.n = 110, f.nabengali = 2472, f.nabla = 8711, f.nacute = 324, f.nadeva = 2344, f.nagujarati = 2728, f.nagurmukhi = 2600, f.nahiragana = 12394, f.nakatakana = 12490, f.nakatakanahalfwidth = 65413, f.napostrophe = 329, f.nasquare = 13185, f.nbopomofo = 12555, f.nbspace = 160, f.ncaron = 328, f.ncedilla = 326, f.ncircle = 9437, f.ncircumflexbelow = 7755, f.ncommaaccent = 326, f.ndotaccent = 7749, f.ndotbelow = 7751, f.nehiragana = 12397, f.nekatakana = 12493, f.nekatakanahalfwidth = 65416, f.newsheqelsign = 8362, f.nfsquare = 13195, f.ngabengali = 2457, f.ngadeva = 2329, f.ngagujarati = 2713, f.ngagurmukhi = 2585, f.ngonguthai = 3591, f.nhiragana = 12435, f.nhookleft = 626, f.nhookretroflex = 627, f.nieunacirclekorean = 12911, f.nieunaparenkorean = 12815, f.nieuncieuckorean = 12597, f.nieuncirclekorean = 12897, f.nieunhieuhkorean = 12598, f.nieunkorean = 12596, f.nieunpansioskorean = 12648, f.nieunparenkorean = 12801, f.nieunsioskorean = 12647, f.nieuntikeutkorean = 12646, f.nihiragana = 12395, f.nikatakana = 12491, f.nikatakanahalfwidth = 65414, f.nikhahitleftthai = 63641, f.nikhahitthai = 3661, f.nine = 57, f.ninearabic = 1641, f.ninebengali = 2543, f.ninecircle = 9320, f.ninecircleinversesansserif = 10130, f.ninedeva = 2415, f.ninegujarati = 2799, f.ninegurmukhi = 2671, f.ninehackarabic = 1641, f.ninehangzhou = 12329, f.nineideographicparen = 12840, f.nineinferior = 8329, f.ninemonospace = 65305, f.nineoldstyle = 63289, f.nineparen = 9340, f.nineperiod = 9360, f.ninepersian = 1785, f.nineroman = 8568, f.ninesuperior = 8313, f.nineteencircle = 9330, f.nineteenparen = 9350, f.nineteenperiod = 9370, f.ninethai = 3673, f.nj = 460, f.njecyrillic = 1114, f.nkatakana = 12531, f.nkatakanahalfwidth = 65437, f.nlegrightlong = 414, f.nlinebelow = 7753, f.nmonospace = 65358, f.nmsquare = 13210, f.nnabengali = 2467, f.nnadeva = 2339, f.nnagujarati = 2723, f.nnagurmukhi = 2595, f.nnnadeva = 2345, f.nohiragana = 12398, f.nokatakana = 12494, f.nokatakanahalfwidth = 65417, f.nonbreakingspace = 160, f.nonenthai = 3603, f.nonuthai = 3609, f.noonarabic = 1606, f.noonfinalarabic = 65254, f.noonghunnaarabic = 1722, f.noonghunnafinalarabic = 64415, f.nooninitialarabic = 65255, f.noonjeeminitialarabic = 64722, f.noonjeemisolatedarabic = 64587, f.noonmedialarabic = 65256, f.noonmeeminitialarabic = 64725, f.noonmeemisolatedarabic = 64590, f.noonnoonfinalarabic = 64653, f.notcontains = 8716, f.notelement = 8713, f.notelementof = 8713, f.notequal = 8800, f.notgreater = 8815, f.notgreaternorequal = 8817, f.notgreaternorless = 8825, f.notidentical = 8802, f.notless = 8814, f.notlessnorequal = 8816, f.notparallel = 8742, f.notprecedes = 8832, f.notsubset = 8836, f.notsucceeds = 8833, f.notsuperset = 8837, f.nowarmenian = 1398, f.nparen = 9385, f.nssquare = 13233, f.nsuperior = 8319, f.ntilde = 241, f.nu = 957, f.nuhiragana = 12396, f.nukatakana = 12492, f.nukatakanahalfwidth = 65415, f.nuktabengali = 2492, f.nuktadeva = 2364, f.nuktagujarati = 2748, f.nuktagurmukhi = 2620, f.numbersign = 35, f.numbersignmonospace = 65283, f.numbersignsmall = 65119, f.numeralsigngreek = 884, f.numeralsignlowergreek = 885, f.numero = 8470, f.nun = 1504, f.nundagesh = 64320, f.nundageshhebrew = 64320, f.nunhebrew = 1504, f.nvsquare = 13237, f.nwsquare = 13243, f.nyabengali = 2462, f.nyadeva = 2334, f.nyagujarati = 2718, f.nyagurmukhi = 2590, f.o = 111, f.oacute = 243, f.oangthai = 3629, f.obarred = 629, f.obarredcyrillic = 1257, f.obarreddieresiscyrillic = 1259, f.obengali = 2451, f.obopomofo = 12571, f.obreve = 335, f.ocandradeva = 2321, f.ocandragujarati = 2705, f.ocandravowelsigndeva = 2377, f.ocandravowelsigngujarati = 2761, f.ocaron = 466, f.ocircle = 9438, f.ocircumflex = 244, f.ocircumflexacute = 7889, f.ocircumflexdotbelow = 7897, f.ocircumflexgrave = 7891, f.ocircumflexhookabove = 7893, f.ocircumflextilde = 7895, f.ocyrillic = 1086, f.odblacute = 337, f.odblgrave = 525, f.odeva = 2323, f.odieresis = 246, f.odieresiscyrillic = 1255, f.odotbelow = 7885, f.oe = 339, f.oekorean = 12634, f.ogonek = 731, f.ogonekcmb = 808, f.ograve = 242, f.ogujarati = 2707, f.oharmenian = 1413, f.ohiragana = 12362, f.ohookabove = 7887, f.ohorn = 417, f.ohornacute = 7899, f.ohorndotbelow = 7907, f.ohorngrave = 7901, f.ohornhookabove = 7903, f.ohorntilde = 7905, f.ohungarumlaut = 337, f.oi = 419, f.oinvertedbreve = 527, f.okatakana = 12458, f.okatakanahalfwidth = 65397, f.okorean = 12631, f.olehebrew = 1451, f.omacron = 333, f.omacronacute = 7763, f.omacrongrave = 7761, f.omdeva = 2384, f.omega = 969, f.omega1 = 982, f.omegacyrillic = 1121, f.omegalatinclosed = 631, f.omegaroundcyrillic = 1147, f.omegatitlocyrillic = 1149, f.omegatonos = 974, f.omgujarati = 2768, f.omicron = 959, f.omicrontonos = 972, f.omonospace = 65359, f.one = 49, f.onearabic = 1633, f.onebengali = 2535, f.onecircle = 9312, f.onecircleinversesansserif = 10122, f.onedeva = 2407, f.onedotenleader = 8228, f.oneeighth = 8539, f.onefitted = 63196, f.onegujarati = 2791, f.onegurmukhi = 2663, f.onehackarabic = 1633, f.onehalf = 189, f.onehangzhou = 12321, f.oneideographicparen = 12832, f.oneinferior = 8321, f.onemonospace = 65297, f.onenumeratorbengali = 2548, f.oneoldstyle = 63281, f.oneparen = 9332, f.oneperiod = 9352, f.onepersian = 1777, f.onequarter = 188, f.oneroman = 8560, f.onesuperior = 185, f.onethai = 3665, f.onethird = 8531, f.oogonek = 491, f.oogonekmacron = 493, f.oogurmukhi = 2579, f.oomatragurmukhi = 2635, f.oopen = 596, f.oparen = 9386, f.openbullet = 9702, f.option = 8997, f.ordfeminine = 170, f.ordmasculine = 186, f.orthogonal = 8735, f.oshortdeva = 2322, f.oshortvowelsigndeva = 2378, f.oslash = 248, f.oslashacute = 511, f.osmallhiragana = 12361, f.osmallkatakana = 12457, f.osmallkatakanahalfwidth = 65387, f.ostrokeacute = 511, f.osuperior = 63216, f.otcyrillic = 1151, f.otilde = 245, f.otildeacute = 7757, f.otildedieresis = 7759, f.oubopomofo = 12577, f.overline = 8254, f.overlinecenterline = 65098, f.overlinecmb = 773, f.overlinedashed = 65097, f.overlinedblwavy = 65100, f.overlinewavy = 65099, f.overscore = 175, f.ovowelsignbengali = 2507, f.ovowelsigndeva = 2379, f.ovowelsigngujarati = 2763, f.p = 112, f.paampssquare = 13184, f.paasentosquare = 13099, f.pabengali = 2474, f.pacute = 7765, f.padeva = 2346, f.pagedown = 8671, f.pageup = 8670, f.pagujarati = 2730, f.pagurmukhi = 2602, f.pahiragana = 12401, f.paiyannoithai = 3631, f.pakatakana = 12497, f.palatalizationcyrilliccmb = 1156, f.palochkacyrillic = 1216, f.pansioskorean = 12671, f.paragraph = 182, f.parallel = 8741, f.parenleft = 40, f.parenleftaltonearabic = 64830, f.parenleftbt = 63725, f.parenleftex = 63724, f.parenleftinferior = 8333, f.parenleftmonospace = 65288, f.parenleftsmall = 65113, f.parenleftsuperior = 8317, f.parenlefttp = 63723, f.parenleftvertical = 65077, f.parenright = 41, f.parenrightaltonearabic = 64831, f.parenrightbt = 63736, f.parenrightex = 63735, f.parenrightinferior = 8334, f.parenrightmonospace = 65289, f.parenrightsmall = 65114, f.parenrightsuperior = 8318, f.parenrighttp = 63734, f.parenrightvertical = 65078, f.partialdiff = 8706, f.paseqhebrew = 1472, f.pashtahebrew = 1433, f.pasquare = 13225, f.patah = 1463, f.patah11 = 1463, f.patah1d = 1463, f.patah2a = 1463, f.patahhebrew = 1463, f.patahnarrowhebrew = 1463, f.patahquarterhebrew = 1463, f.patahwidehebrew = 1463, f.pazerhebrew = 1441, f.pbopomofo = 12550, f.pcircle = 9439, f.pdotaccent = 7767, f.pe = 1508, f.pecyrillic = 1087, f.pedagesh = 64324, f.pedageshhebrew = 64324, f.peezisquare = 13115, f.pefinaldageshhebrew = 64323, f.peharabic = 1662, f.peharmenian = 1402, f.pehebrew = 1508, f.pehfinalarabic = 64343, f.pehinitialarabic = 64344, f.pehiragana = 12410, f.pehmedialarabic = 64345, f.pekatakana = 12506, f.pemiddlehookcyrillic = 1191, f.perafehebrew = 64334, f.percent = 37, f.percentarabic = 1642, f.percentmonospace = 65285, f.percentsmall = 65130, f.period = 46, f.periodarmenian = 1417, f.periodcentered = 183, f.periodhalfwidth = 65377, f.periodinferior = 63207, f.periodmonospace = 65294, f.periodsmall = 65106, f.periodsuperior = 63208, f.perispomenigreekcmb = 834, f.perpendicular = 8869, f.perthousand = 8240, f.peseta = 8359, f.pfsquare = 13194, f.phabengali = 2475, f.phadeva = 2347, f.phagujarati = 2731, f.phagurmukhi = 2603, f.phi = 966, f.phi1 = 981, f.phieuphacirclekorean = 12922, f.phieuphaparenkorean = 12826, f.phieuphcirclekorean = 12908, f.phieuphkorean = 12621, f.phieuphparenkorean = 12812, f.philatin = 632, f.phinthuthai = 3642, f.phisymbolgreek = 981, f.phook = 421, f.phophanthai = 3614, f.phophungthai = 3612, f.phosamphaothai = 3616, f.pi = 960, f.pieupacirclekorean = 12915, f.pieupaparenkorean = 12819, f.pieupcieuckorean = 12662, f.pieupcirclekorean = 12901, f.pieupkiyeokkorean = 12658, f.pieupkorean = 12610, f.pieupparenkorean = 12805, f.pieupsioskiyeokkorean = 12660, f.pieupsioskorean = 12612, f.pieupsiostikeutkorean = 12661, f.pieupthieuthkorean = 12663, f.pieuptikeutkorean = 12659, f.pihiragana = 12404, f.pikatakana = 12500, f.pisymbolgreek = 982, f.piwrarmenian = 1411, f.planckover2pi = 8463, f.planckover2pi1 = 8463, f.plus = 43, f.plusbelowcmb = 799, f.pluscircle = 8853, f.plusminus = 177, f.plusmod = 726, f.plusmonospace = 65291, f.plussmall = 65122, f.plussuperior = 8314, f.pmonospace = 65360, f.pmsquare = 13272, f.pohiragana = 12413, f.pointingindexdownwhite = 9759, f.pointingindexleftwhite = 9756, f.pointingindexrightwhite = 9758, f.pointingindexupwhite = 9757, f.pokatakana = 12509, f.poplathai = 3611, f.postalmark = 12306, f.postalmarkface = 12320, f.pparen = 9387, f.precedes = 8826, f.prescription = 8478, f.primemod = 697, f.primereversed = 8245, f.product = 8719, f.projective = 8965, f.prolongedkana = 12540, f.propellor = 8984, f.propersubset = 8834, f.propersuperset = 8835, f.proportion = 8759, f.proportional = 8733, f.psi = 968, f.psicyrillic = 1137, f.psilipneumatacyrilliccmb = 1158, f.pssquare = 13232, f.puhiragana = 12407, f.pukatakana = 12503, f.pvsquare = 13236, f.pwsquare = 13242, f.q = 113, f.qadeva = 2392, f.qadmahebrew = 1448, f.qafarabic = 1602, f.qaffinalarabic = 65238, f.qafinitialarabic = 65239, f.qafmedialarabic = 65240, f.qamats = 1464, f.qamats10 = 1464, f.qamats1a = 1464, f.qamats1c = 1464, f.qamats27 = 1464, f.qamats29 = 1464, f.qamats33 = 1464, f.qamatsde = 1464, f.qamatshebrew = 1464, f.qamatsnarrowhebrew = 1464, f.qamatsqatanhebrew = 1464, f.qamatsqatannarrowhebrew = 1464, f.qamatsqatanquarterhebrew = 1464, f.qamatsqatanwidehebrew = 1464, f.qamatsquarterhebrew = 1464, f.qamatswidehebrew = 1464, f.qarneyparahebrew = 1439, f.qbopomofo = 12561, f.qcircle = 9440, f.qhook = 672, f.qmonospace = 65361, f.qof = 1511, f.qofdagesh = 64327, f.qofdageshhebrew = 64327, f.qofhebrew = 1511, f.qparen = 9388, f.quarternote = 9833, f.qubuts = 1467, f.qubuts18 = 1467, f.qubuts25 = 1467, f.qubuts31 = 1467, f.qubutshebrew = 1467, f.qubutsnarrowhebrew = 1467, f.qubutsquarterhebrew = 1467, f.qubutswidehebrew = 1467, f.question = 63, f.questionarabic = 1567, f.questionarmenian = 1374, f.questiondown = 191, f.questiondownsmall = 63423, f.questiongreek = 894, f.questionmonospace = 65311, f.questionsmall = 63295, f.quotedbl = 34, f.quotedblbase = 8222, f.quotedblleft = 8220, f.quotedblmonospace = 65282, f.quotedblprime = 12318, f.quotedblprimereversed = 12317, f.quotedblright = 8221, f.quoteleft = 8216, f.quoteleftreversed = 8219, f.quotereversed = 8219, f.quoteright = 8217, f.quoterightn = 329, f.quotesinglbase = 8218, f.quotesingle = 39, f.quotesinglemonospace = 65287, f.r = 114, f.raarmenian = 1404, f.rabengali = 2480, f.racute = 341, f.radeva = 2352, f.radical = 8730, f.radicalex = 63717, f.radoverssquare = 13230, f.radoverssquaredsquare = 13231, f.radsquare = 13229, f.rafe = 1471, f.rafehebrew = 1471, f.ragujarati = 2736, f.ragurmukhi = 2608, f.rahiragana = 12425, f.rakatakana = 12521, f.rakatakanahalfwidth = 65431, f.ralowerdiagonalbengali = 2545, f.ramiddlediagonalbengali = 2544, f.ramshorn = 612, f.ratio = 8758, f.rbopomofo = 12566, f.rcaron = 345, f.rcedilla = 343, f.rcircle = 9441, f.rcommaaccent = 343, f.rdblgrave = 529, f.rdotaccent = 7769, f.rdotbelow = 7771, f.rdotbelowmacron = 7773, f.referencemark = 8251, f.reflexsubset = 8838, f.reflexsuperset = 8839, f.registered = 174, f.registersans = 63720, f.registerserif = 63194, f.reharabic = 1585, f.reharmenian = 1408, f.rehfinalarabic = 65198, f.rehiragana = 12428, f.rekatakana = 12524, f.rekatakanahalfwidth = 65434, f.resh = 1512, f.reshdageshhebrew = 64328, f.reshhebrew = 1512, f.reversedtilde = 8765, f.reviahebrew = 1431, f.reviamugrashhebrew = 1431, f.revlogicalnot = 8976, f.rfishhook = 638, f.rfishhookreversed = 639, f.rhabengali = 2525, f.rhadeva = 2397, f.rho = 961, f.rhook = 637, f.rhookturned = 635, f.rhookturnedsuperior = 693, f.rhosymbolgreek = 1009, f.rhotichookmod = 734, f.rieulacirclekorean = 12913, f.rieulaparenkorean = 12817, f.rieulcirclekorean = 12899, f.rieulhieuhkorean = 12608, f.rieulkiyeokkorean = 12602, f.rieulkiyeoksioskorean = 12649, f.rieulkorean = 12601, f.rieulmieumkorean = 12603, f.rieulpansioskorean = 12652, f.rieulparenkorean = 12803, f.rieulphieuphkorean = 12607, f.rieulpieupkorean = 12604, f.rieulpieupsioskorean = 12651, f.rieulsioskorean = 12605, f.rieulthieuthkorean = 12606, f.rieultikeutkorean = 12650, f.rieulyeorinhieuhkorean = 12653, f.rightangle = 8735, f.righttackbelowcmb = 793, f.righttriangle = 8895, f.rihiragana = 12426, f.rikatakana = 12522, f.rikatakanahalfwidth = 65432, f.ring = 730, f.ringbelowcmb = 805, f.ringcmb = 778, f.ringhalfleft = 703, f.ringhalfleftarmenian = 1369, f.ringhalfleftbelowcmb = 796, f.ringhalfleftcentered = 723, f.ringhalfright = 702, f.ringhalfrightbelowcmb = 825, f.ringhalfrightcentered = 722, f.rinvertedbreve = 531, f.rittorusquare = 13137, f.rlinebelow = 7775, f.rlongleg = 636, f.rlonglegturned = 634, f.rmonospace = 65362, f.rohiragana = 12429, f.rokatakana = 12525, f.rokatakanahalfwidth = 65435, f.roruathai = 3619, f.rparen = 9389, f.rrabengali = 2524, f.rradeva = 2353, f.rragurmukhi = 2652, f.rreharabic = 1681, f.rrehfinalarabic = 64397, f.rrvocalicbengali = 2528, f.rrvocalicdeva = 2400, f.rrvocalicgujarati = 2784, f.rrvocalicvowelsignbengali = 2500, f.rrvocalicvowelsigndeva = 2372, f.rrvocalicvowelsigngujarati = 2756, f.rsuperior = 63217, f.rtblock = 9616, f.rturned = 633, f.rturnedsuperior = 692, f.ruhiragana = 12427, f.rukatakana = 12523, f.rukatakanahalfwidth = 65433, f.rupeemarkbengali = 2546, f.rupeesignbengali = 2547, f.rupiah = 63197, f.ruthai = 3620, f.rvocalicbengali = 2443, f.rvocalicdeva = 2315, f.rvocalicgujarati = 2699, f.rvocalicvowelsignbengali = 2499, f.rvocalicvowelsigndeva = 2371, f.rvocalicvowelsigngujarati = 2755, f.s = 115, f.sabengali = 2488, f.sacute = 347, f.sacutedotaccent = 7781, f.sadarabic = 1589, f.sadeva = 2360, f.sadfinalarabic = 65210, f.sadinitialarabic = 65211, f.sadmedialarabic = 65212, f.sagujarati = 2744, f.sagurmukhi = 2616, f.sahiragana = 12373, f.sakatakana = 12469, f.sakatakanahalfwidth = 65403, f.sallallahoualayhewasallamarabic = 65018, f.samekh = 1505, f.samekhdagesh = 64321, f.samekhdageshhebrew = 64321, f.samekhhebrew = 1505, f.saraaathai = 3634, f.saraaethai = 3649, f.saraaimaimalaithai = 3652, f.saraaimaimuanthai = 3651, f.saraamthai = 3635, f.saraathai = 3632, f.saraethai = 3648, f.saraiileftthai = 63622, f.saraiithai = 3637, f.saraileftthai = 63621, f.saraithai = 3636, f.saraothai = 3650, f.saraueeleftthai = 63624, f.saraueethai = 3639, f.saraueleftthai = 63623, f.sarauethai = 3638, f.sarauthai = 3640, f.sarauuthai = 3641, f.sbopomofo = 12569, f.scaron = 353, f.scarondotaccent = 7783, f.scedilla = 351, f.schwa = 601, f.schwacyrillic = 1241, f.schwadieresiscyrillic = 1243, f.schwahook = 602, f.scircle = 9442, f.scircumflex = 349, f.scommaaccent = 537, f.sdotaccent = 7777, f.sdotbelow = 7779, f.sdotbelowdotaccent = 7785, f.seagullbelowcmb = 828, f.second = 8243, f.secondtonechinese = 714, f.section = 167, f.seenarabic = 1587, f.seenfinalarabic = 65202, f.seeninitialarabic = 65203, f.seenmedialarabic = 65204, f.segol = 1462, f.segol13 = 1462, f.segol1f = 1462, f.segol2c = 1462, f.segolhebrew = 1462, f.segolnarrowhebrew = 1462, f.segolquarterhebrew = 1462, f.segoltahebrew = 1426, f.segolwidehebrew = 1462, f.seharmenian = 1405, f.sehiragana = 12379, f.sekatakana = 12475, f.sekatakanahalfwidth = 65406, f.semicolon = 59, f.semicolonarabic = 1563, f.semicolonmonospace = 65307, f.semicolonsmall = 65108, f.semivoicedmarkkana = 12444, f.semivoicedmarkkanahalfwidth = 65439, f.sentisquare = 13090, f.sentosquare = 13091, f.seven = 55, f.sevenarabic = 1639, f.sevenbengali = 2541, f.sevencircle = 9318, f.sevencircleinversesansserif = 10128, f.sevendeva = 2413, f.seveneighths = 8542, f.sevengujarati = 2797, f.sevengurmukhi = 2669, f.sevenhackarabic = 1639, f.sevenhangzhou = 12327, f.sevenideographicparen = 12838, f.seveninferior = 8327, f.sevenmonospace = 65303, f.sevenoldstyle = 63287, f.sevenparen = 9338, f.sevenperiod = 9358, f.sevenpersian = 1783, f.sevenroman = 8566, f.sevensuperior = 8311, f.seventeencircle = 9328, f.seventeenparen = 9348, f.seventeenperiod = 9368, f.seventhai = 3671, f.sfthyphen = 173, f.shaarmenian = 1399, f.shabengali = 2486, f.shacyrillic = 1096, f.shaddaarabic = 1617, f.shaddadammaarabic = 64609, f.shaddadammatanarabic = 64606, f.shaddafathaarabic = 64608, f.shaddakasraarabic = 64610, f.shaddakasratanarabic = 64607, f.shade = 9618, f.shadedark = 9619, f.shadelight = 9617, f.shademedium = 9618, f.shadeva = 2358, f.shagujarati = 2742, f.shagurmukhi = 2614, f.shalshelethebrew = 1427, f.shbopomofo = 12565, f.shchacyrillic = 1097, f.sheenarabic = 1588, f.sheenfinalarabic = 65206, f.sheeninitialarabic = 65207, f.sheenmedialarabic = 65208, f.sheicoptic = 995, f.sheqel = 8362, f.sheqelhebrew = 8362, f.sheva = 1456, f.sheva115 = 1456, f.sheva15 = 1456, f.sheva22 = 1456, f.sheva2e = 1456, f.shevahebrew = 1456, f.shevanarrowhebrew = 1456, f.shevaquarterhebrew = 1456, f.shevawidehebrew = 1456, f.shhacyrillic = 1211, f.shimacoptic = 1005, f.shin = 1513, f.shindagesh = 64329, f.shindageshhebrew = 64329, f.shindageshshindot = 64300, f.shindageshshindothebrew = 64300, f.shindageshsindot = 64301, f.shindageshsindothebrew = 64301, f.shindothebrew = 1473, f.shinhebrew = 1513, f.shinshindot = 64298, f.shinshindothebrew = 64298, f.shinsindot = 64299, f.shinsindothebrew = 64299, f.shook = 642, f.sigma = 963, f.sigma1 = 962, f.sigmafinal = 962, f.sigmalunatesymbolgreek = 1010, f.sihiragana = 12375, f.sikatakana = 12471, f.sikatakanahalfwidth = 65404, f.siluqhebrew = 1469, f.siluqlefthebrew = 1469, f.similar = 8764, f.sindothebrew = 1474, f.siosacirclekorean = 12916, f.siosaparenkorean = 12820, f.sioscieuckorean = 12670, f.sioscirclekorean = 12902, f.sioskiyeokkorean = 12666, f.sioskorean = 12613, f.siosnieunkorean = 12667, f.siosparenkorean = 12806, f.siospieupkorean = 12669, f.siostikeutkorean = 12668, f.six = 54, f.sixarabic = 1638, f.sixbengali = 2540, f.sixcircle = 9317, f.sixcircleinversesansserif = 10127, f.sixdeva = 2412, f.sixgujarati = 2796, f.sixgurmukhi = 2668, f.sixhackarabic = 1638, f.sixhangzhou = 12326, f.sixideographicparen = 12837, f.sixinferior = 8326, f.sixmonospace = 65302, f.sixoldstyle = 63286, f.sixparen = 9337, f.sixperiod = 9357, f.sixpersian = 1782, f.sixroman = 8565, f.sixsuperior = 8310, f.sixteencircle = 9327, f.sixteencurrencydenominatorbengali = 2553, f.sixteenparen = 9347, f.sixteenperiod = 9367, f.sixthai = 3670, f.slash = 47, f.slashmonospace = 65295, f.slong = 383, f.slongdotaccent = 7835, f.smileface = 9786, f.smonospace = 65363, f.sofpasuqhebrew = 1475, f.softhyphen = 173, f.softsigncyrillic = 1100, f.sohiragana = 12381, f.sokatakana = 12477, f.sokatakanahalfwidth = 65407, f.soliduslongoverlaycmb = 824, f.solidusshortoverlaycmb = 823, f.sorusithai = 3625, f.sosalathai = 3624, f.sosothai = 3595, f.sosuathai = 3626, f.space = 32, f.spacehackarabic = 32, f.spade = 9824, f.spadesuitblack = 9824, f.spadesuitwhite = 9828, f.sparen = 9390, f.squarebelowcmb = 827, f.squarecc = 13252, f.squarecm = 13213, f.squarediagonalcrosshatchfill = 9641, f.squarehorizontalfill = 9636, f.squarekg = 13199, f.squarekm = 13214, f.squarekmcapital = 13262, f.squareln = 13265, f.squarelog = 13266, f.squaremg = 13198, f.squaremil = 13269, f.squaremm = 13212, f.squaremsquared = 13217, f.squareorthogonalcrosshatchfill = 9638, f.squareupperlefttolowerrightfill = 9639, f.squareupperrighttolowerleftfill = 9640, f.squareverticalfill = 9637, f.squarewhitewithsmallblack = 9635, f.srsquare = 13275, f.ssabengali = 2487, f.ssadeva = 2359, f.ssagujarati = 2743, f.ssangcieuckorean = 12617, f.ssanghieuhkorean = 12677, f.ssangieungkorean = 12672, f.ssangkiyeokkorean = 12594, f.ssangnieunkorean = 12645, f.ssangpieupkorean = 12611, f.ssangsioskorean = 12614, f.ssangtikeutkorean = 12600, f.ssuperior = 63218, f.sterling = 163, f.sterlingmonospace = 65505, f.strokelongoverlaycmb = 822, f.strokeshortoverlaycmb = 821, f.subset = 8834, f.subsetnotequal = 8842, f.subsetorequal = 8838, f.succeeds = 8827, f.suchthat = 8715, f.suhiragana = 12377, f.sukatakana = 12473, f.sukatakanahalfwidth = 65405, f.sukunarabic = 1618, f.summation = 8721, f.sun = 9788, f.superset = 8835, f.supersetnotequal = 8843, f.supersetorequal = 8839, f.svsquare = 13276, f.syouwaerasquare = 13180, f.t = 116, f.tabengali = 2468, f.tackdown = 8868, f.tackleft = 8867, f.tadeva = 2340, f.tagujarati = 2724, f.tagurmukhi = 2596, f.taharabic = 1591, f.tahfinalarabic = 65218, f.tahinitialarabic = 65219, f.tahiragana = 12383, f.tahmedialarabic = 65220, f.taisyouerasquare = 13181, f.takatakana = 12479, f.takatakanahalfwidth = 65408, f.tatweelarabic = 1600, f.tau = 964, f.tav = 1514, f.tavdages = 64330, f.tavdagesh = 64330, f.tavdageshhebrew = 64330, f.tavhebrew = 1514, f.tbar = 359, f.tbopomofo = 12554, f.tcaron = 357, f.tccurl = 680, f.tcedilla = 355, f.tcheharabic = 1670, f.tchehfinalarabic = 64379, f.tchehinitialarabic = 64380, f.tchehmedialarabic = 64381, f.tcircle = 9443, f.tcircumflexbelow = 7793, f.tcommaaccent = 355, f.tdieresis = 7831, f.tdotaccent = 7787, f.tdotbelow = 7789, f.tecyrillic = 1090, f.tedescendercyrillic = 1197, f.teharabic = 1578, f.tehfinalarabic = 65174, f.tehhahinitialarabic = 64674, f.tehhahisolatedarabic = 64524, f.tehinitialarabic = 65175, f.tehiragana = 12390, f.tehjeeminitialarabic = 64673, f.tehjeemisolatedarabic = 64523, f.tehmarbutaarabic = 1577, f.tehmarbutafinalarabic = 65172, f.tehmedialarabic = 65176, f.tehmeeminitialarabic = 64676, f.tehmeemisolatedarabic = 64526, f.tehnoonfinalarabic = 64627, f.tekatakana = 12486, f.tekatakanahalfwidth = 65411, f.telephone = 8481, f.telephoneblack = 9742, f.telishagedolahebrew = 1440, f.telishaqetanahebrew = 1449, f.tencircle = 9321, f.tenideographicparen = 12841, f.tenparen = 9341, f.tenperiod = 9361, f.tenroman = 8569, f.tesh = 679, f.tet = 1496, f.tetdagesh = 64312, f.tetdageshhebrew = 64312, f.tethebrew = 1496, f.tetsecyrillic = 1205, f.tevirhebrew = 1435, f.tevirlefthebrew = 1435, f.thabengali = 2469, f.thadeva = 2341, f.thagujarati = 2725, f.thagurmukhi = 2597, f.thalarabic = 1584, f.thalfinalarabic = 65196, f.thanthakhatlowleftthai = 63640, f.thanthakhatlowrightthai = 63639, f.thanthakhatthai = 3660, f.thanthakhatupperleftthai = 63638, f.theharabic = 1579, f.thehfinalarabic = 65178, f.thehinitialarabic = 65179, f.thehmedialarabic = 65180, f.thereexists = 8707, f.therefore = 8756, f.theta = 952, f.theta1 = 977, f.thetasymbolgreek = 977, f.thieuthacirclekorean = 12921, f.thieuthaparenkorean = 12825, f.thieuthcirclekorean = 12907, f.thieuthkorean = 12620, f.thieuthparenkorean = 12811, f.thirteencircle = 9324, f.thirteenparen = 9344, f.thirteenperiod = 9364, f.thonangmonthothai = 3601, f.thook = 429, f.thophuthaothai = 3602, f.thorn = 254, f.thothahanthai = 3607, f.thothanthai = 3600, f.thothongthai = 3608, f.thothungthai = 3606, f.thousandcyrillic = 1154, f.thousandsseparatorarabic = 1644, f.thousandsseparatorpersian = 1644, f.three = 51, f.threearabic = 1635, f.threebengali = 2537, f.threecircle = 9314, f.threecircleinversesansserif = 10124, f.threedeva = 2409, f.threeeighths = 8540, f.threegujarati = 2793, f.threegurmukhi = 2665, f.threehackarabic = 1635, f.threehangzhou = 12323, f.threeideographicparen = 12834, f.threeinferior = 8323, f.threemonospace = 65299, f.threenumeratorbengali = 2550, f.threeoldstyle = 63283, f.threeparen = 9334, f.threeperiod = 9354, f.threepersian = 1779, f.threequarters = 190, f.threequartersemdash = 63198, f.threeroman = 8562, f.threesuperior = 179, f.threethai = 3667, f.thzsquare = 13204, f.tihiragana = 12385, f.tikatakana = 12481, f.tikatakanahalfwidth = 65409, f.tikeutacirclekorean = 12912, f.tikeutaparenkorean = 12816, f.tikeutcirclekorean = 12898, f.tikeutkorean = 12599, f.tikeutparenkorean = 12802, f.tilde = 732, f.tildebelowcmb = 816, f.tildecmb = 771, f.tildecomb = 771, f.tildedoublecmb = 864, f.tildeoperator = 8764, f.tildeoverlaycmb = 820, f.tildeverticalcmb = 830, f.timescircle = 8855, f.tipehahebrew = 1430, f.tipehalefthebrew = 1430, f.tippigurmukhi = 2672, f.titlocyrilliccmb = 1155, f.tiwnarmenian = 1407, f.tlinebelow = 7791, f.tmonospace = 65364, f.toarmenian = 1385, f.tohiragana = 12392, f.tokatakana = 12488, f.tokatakanahalfwidth = 65412, f.tonebarextrahighmod = 741, f.tonebarextralowmod = 745, f.tonebarhighmod = 742, f.tonebarlowmod = 744, f.tonebarmidmod = 743, f.tonefive = 445, f.tonesix = 389, f.tonetwo = 424, f.tonos = 900, f.tonsquare = 13095, f.topatakthai = 3599, f.tortoiseshellbracketleft = 12308, f.tortoiseshellbracketleftsmall = 65117, f.tortoiseshellbracketleftvertical = 65081, f.tortoiseshellbracketright = 12309, f.tortoiseshellbracketrightsmall = 65118, f.tortoiseshellbracketrightvertical = 65082, f.totaothai = 3605, f.tpalatalhook = 427, f.tparen = 9391, f.trademark = 8482, f.trademarksans = 63722, f.trademarkserif = 63195, f.tretroflexhook = 648, f.triagdn = 9660, f.triaglf = 9668, f.triagrt = 9658, f.triagup = 9650, f.ts = 678, f.tsadi = 1510, f.tsadidagesh = 64326, f.tsadidageshhebrew = 64326, f.tsadihebrew = 1510, f.tsecyrillic = 1094, f.tsere = 1461, f.tsere12 = 1461, f.tsere1e = 1461, f.tsere2b = 1461, f.tserehebrew = 1461, f.tserenarrowhebrew = 1461, f.tserequarterhebrew = 1461, f.tserewidehebrew = 1461, f.tshecyrillic = 1115, f.tsuperior = 63219, f.ttabengali = 2463, f.ttadeva = 2335, f.ttagujarati = 2719, f.ttagurmukhi = 2591, f.tteharabic = 1657, f.ttehfinalarabic = 64359, f.ttehinitialarabic = 64360, f.ttehmedialarabic = 64361, f.tthabengali = 2464, f.tthadeva = 2336, f.tthagujarati = 2720, f.tthagurmukhi = 2592, f.tturned = 647, f.tuhiragana = 12388, f.tukatakana = 12484, f.tukatakanahalfwidth = 65410, f.tusmallhiragana = 12387, f.tusmallkatakana = 12483, f.tusmallkatakanahalfwidth = 65391, f.twelvecircle = 9323, f.twelveparen = 9343, f.twelveperiod = 9363, f.twelveroman = 8571, f.twentycircle = 9331, f.twentyhangzhou = 21316, f.twentyparen = 9351, f.twentyperiod = 9371, f.two = 50, f.twoarabic = 1634, f.twobengali = 2536, f.twocircle = 9313, f.twocircleinversesansserif = 10123, f.twodeva = 2408, f.twodotenleader = 8229, f.twodotleader = 8229, f.twodotleadervertical = 65072, f.twogujarati = 2792, f.twogurmukhi = 2664, f.twohackarabic = 1634, f.twohangzhou = 12322, f.twoideographicparen = 12833, f.twoinferior = 8322, f.twomonospace = 65298, f.twonumeratorbengali = 2549, f.twooldstyle = 63282, f.twoparen = 9333, f.twoperiod = 9353, f.twopersian = 1778, f.tworoman = 8561, f.twostroke = 443, f.twosuperior = 178, f.twothai = 3666, f.twothirds = 8532, f.u = 117, f.uacute = 250, f.ubar = 649, f.ubengali = 2441, f.ubopomofo = 12584, f.ubreve = 365, f.ucaron = 468, f.ucircle = 9444, f.ucircumflex = 251, f.ucircumflexbelow = 7799, f.ucyrillic = 1091, f.udattadeva = 2385, f.udblacute = 369, f.udblgrave = 533, f.udeva = 2313, f.udieresis = 252, f.udieresisacute = 472, f.udieresisbelow = 7795, f.udieresiscaron = 474, f.udieresiscyrillic = 1265, f.udieresisgrave = 476, f.udieresismacron = 470, f.udotbelow = 7909, f.ugrave = 249, f.ugujarati = 2697, f.ugurmukhi = 2569, f.uhiragana = 12358, f.uhookabove = 7911, f.uhorn = 432, f.uhornacute = 7913, f.uhorndotbelow = 7921, f.uhorngrave = 7915, f.uhornhookabove = 7917, f.uhorntilde = 7919, f.uhungarumlaut = 369, f.uhungarumlautcyrillic = 1267, f.uinvertedbreve = 535, f.ukatakana = 12454, f.ukatakanahalfwidth = 65395, f.ukcyrillic = 1145, f.ukorean = 12636, f.umacron = 363, f.umacroncyrillic = 1263, f.umacrondieresis = 7803, f.umatragurmukhi = 2625, f.umonospace = 65365, f.underscore = 95, f.underscoredbl = 8215, f.underscoremonospace = 65343, f.underscorevertical = 65075, f.underscorewavy = 65103, f.union = 8746, f.universal = 8704, f.uogonek = 371, f.uparen = 9392, f.upblock = 9600, f.upperdothebrew = 1476, f.upsilon = 965, f.upsilondieresis = 971, f.upsilondieresistonos = 944, f.upsilonlatin = 650, f.upsilontonos = 973, f.uptackbelowcmb = 797, f.uptackmod = 724, f.uragurmukhi = 2675, f.uring = 367, f.ushortcyrillic = 1118, f.usmallhiragana = 12357, f.usmallkatakana = 12453, f.usmallkatakanahalfwidth = 65385, f.ustraightcyrillic = 1199, f.ustraightstrokecyrillic = 1201, f.utilde = 361, f.utildeacute = 7801, f.utildebelow = 7797, f.uubengali = 2442, f.uudeva = 2314, f.uugujarati = 2698, f.uugurmukhi = 2570, f.uumatragurmukhi = 2626, f.uuvowelsignbengali = 2498, f.uuvowelsigndeva = 2370, f.uuvowelsigngujarati = 2754, f.uvowelsignbengali = 2497, f.uvowelsigndeva = 2369, f.uvowelsigngujarati = 2753, f.v = 118, f.vadeva = 2357, f.vagujarati = 2741, f.vagurmukhi = 2613, f.vakatakana = 12535, f.vav = 1493, f.vavdagesh = 64309, f.vavdagesh65 = 64309, f.vavdageshhebrew = 64309, f.vavhebrew = 1493, f.vavholam = 64331, f.vavholamhebrew = 64331, f.vavvavhebrew = 1520, f.vavyodhebrew = 1521, f.vcircle = 9445, f.vdotbelow = 7807, f.vecyrillic = 1074, f.veharabic = 1700, f.vehfinalarabic = 64363, f.vehinitialarabic = 64364, f.vehmedialarabic = 64365, f.vekatakana = 12537, f.venus = 9792, f.verticalbar = 124, f.verticallineabovecmb = 781, f.verticallinebelowcmb = 809, f.verticallinelowmod = 716, f.verticallinemod = 712, f.vewarmenian = 1406, f.vhook = 651, f.vikatakana = 12536, f.viramabengali = 2509, f.viramadeva = 2381, f.viramagujarati = 2765, f.visargabengali = 2435, f.visargadeva = 2307, f.visargagujarati = 2691, f.vmonospace = 65366, f.voarmenian = 1400, f.voicediterationhiragana = 12446, f.voicediterationkatakana = 12542, f.voicedmarkkana = 12443, f.voicedmarkkanahalfwidth = 65438, f.vokatakana = 12538, f.vparen = 9393, f.vtilde = 7805, f.vturned = 652, f.vuhiragana = 12436, f.vukatakana = 12532, f.w = 119, f.wacute = 7811, f.waekorean = 12633, f.wahiragana = 12431, f.wakatakana = 12527, f.wakatakanahalfwidth = 65436, f.wakorean = 12632, f.wasmallhiragana = 12430, f.wasmallkatakana = 12526, f.wattosquare = 13143, f.wavedash = 12316, f.wavyunderscorevertical = 65076, f.wawarabic = 1608, f.wawfinalarabic = 65262, f.wawhamzaabovearabic = 1572, f.wawhamzaabovefinalarabic = 65158, f.wbsquare = 13277, f.wcircle = 9446, f.wcircumflex = 373, f.wdieresis = 7813, f.wdotaccent = 7815, f.wdotbelow = 7817, f.wehiragana = 12433, f.weierstrass = 8472, f.wekatakana = 12529, f.wekorean = 12638, f.weokorean = 12637, f.wgrave = 7809, f.whitebullet = 9702, f.whitecircle = 9675, f.whitecircleinverse = 9689, f.whitecornerbracketleft = 12302, f.whitecornerbracketleftvertical = 65091, f.whitecornerbracketright = 12303, f.whitecornerbracketrightvertical = 65092, f.whitediamond = 9671, f.whitediamondcontainingblacksmalldiamond = 9672, f.whitedownpointingsmalltriangle = 9663, f.whitedownpointingtriangle = 9661, f.whiteleftpointingsmalltriangle = 9667, f.whiteleftpointingtriangle = 9665, f.whitelenticularbracketleft = 12310, f.whitelenticularbracketright = 12311, f.whiterightpointingsmalltriangle = 9657, f.whiterightpointingtriangle = 9655, f.whitesmallsquare = 9643, f.whitesmilingface = 9786, f.whitesquare = 9633, f.whitestar = 9734, f.whitetelephone = 9743, f.whitetortoiseshellbracketleft = 12312, f.whitetortoiseshellbracketright = 12313, f.whiteuppointingsmalltriangle = 9653, f.whiteuppointingtriangle = 9651, f.wihiragana = 12432, f.wikatakana = 12528, f.wikorean = 12639, f.wmonospace = 65367, f.wohiragana = 12434, f.wokatakana = 12530, f.wokatakanahalfwidth = 65382, f.won = 8361, f.wonmonospace = 65510, f.wowaenthai = 3623, f.wparen = 9394, f.wring = 7832, f.wsuperior = 695, f.wturned = 653, f.wynn = 447, f.x = 120, f.xabovecmb = 829, f.xbopomofo = 12562, f.xcircle = 9447, f.xdieresis = 7821, f.xdotaccent = 7819, f.xeharmenian = 1389, f.xi = 958, f.xmonospace = 65368, f.xparen = 9395, f.xsuperior = 739, f.y = 121, f.yaadosquare = 13134, f.yabengali = 2479, f.yacute = 253, f.yadeva = 2351, f.yaekorean = 12626, f.yagujarati = 2735, f.yagurmukhi = 2607, f.yahiragana = 12420, f.yakatakana = 12516, f.yakatakanahalfwidth = 65428, f.yakorean = 12625, f.yamakkanthai = 3662, f.yasmallhiragana = 12419, f.yasmallkatakana = 12515, f.yasmallkatakanahalfwidth = 65388, f.yatcyrillic = 1123, f.ycircle = 9448, f.ycircumflex = 375, f.ydieresis = 255, f.ydotaccent = 7823, f.ydotbelow = 7925, f.yeharabic = 1610, f.yehbarreearabic = 1746, f.yehbarreefinalarabic = 64431, f.yehfinalarabic = 65266, f.yehhamzaabovearabic = 1574, f.yehhamzaabovefinalarabic = 65162, f.yehhamzaaboveinitialarabic = 65163, f.yehhamzaabovemedialarabic = 65164, f.yehinitialarabic = 65267, f.yehmedialarabic = 65268, f.yehmeeminitialarabic = 64733, f.yehmeemisolatedarabic = 64600, f.yehnoonfinalarabic = 64660, f.yehthreedotsbelowarabic = 1745, f.yekorean = 12630, f.yen = 165, f.yenmonospace = 65509, f.yeokorean = 12629, f.yeorinhieuhkorean = 12678, f.yerahbenyomohebrew = 1450, f.yerahbenyomolefthebrew = 1450, f.yericyrillic = 1099, f.yerudieresiscyrillic = 1273, f.yesieungkorean = 12673, f.yesieungpansioskorean = 12675, f.yesieungsioskorean = 12674, f.yetivhebrew = 1434, f.ygrave = 7923, f.yhook = 436, f.yhookabove = 7927, f.yiarmenian = 1397, f.yicyrillic = 1111, f.yikorean = 12642, f.yinyang = 9775, f.yiwnarmenian = 1410, f.ymonospace = 65369, f.yod = 1497, f.yoddagesh = 64313, f.yoddageshhebrew = 64313, f.yodhebrew = 1497, f.yodyodhebrew = 1522, f.yodyodpatahhebrew = 64287, f.yohiragana = 12424, f.yoikorean = 12681, f.yokatakana = 12520, f.yokatakanahalfwidth = 65430, f.yokorean = 12635, f.yosmallhiragana = 12423, f.yosmallkatakana = 12519, f.yosmallkatakanahalfwidth = 65390, f.yotgreek = 1011, f.yoyaekorean = 12680, f.yoyakorean = 12679, f.yoyakthai = 3618, f.yoyingthai = 3597, f.yparen = 9396, f.ypogegrammeni = 890, f.ypogegrammenigreekcmb = 837, f.yr = 422, f.yring = 7833, f.ysuperior = 696, f.ytilde = 7929, f.yturned = 654, f.yuhiragana = 12422, f.yuikorean = 12684, f.yukatakana = 12518, f.yukatakanahalfwidth = 65429, f.yukorean = 12640, f.yusbigcyrillic = 1131, f.yusbigiotifiedcyrillic = 1133, f.yuslittlecyrillic = 1127, f.yuslittleiotifiedcyrillic = 1129, f.yusmallhiragana = 12421, f.yusmallkatakana = 12517, f.yusmallkatakanahalfwidth = 65389, f.yuyekorean = 12683, f.yuyeokorean = 12682, f.yyabengali = 2527, f.yyadeva = 2399, f.z = 122, f.zaarmenian = 1382, f.zacute = 378, f.zadeva = 2395, f.zagurmukhi = 2651, f.zaharabic = 1592, f.zahfinalarabic = 65222, f.zahinitialarabic = 65223, f.zahiragana = 12374, f.zahmedialarabic = 65224, f.zainarabic = 1586, f.zainfinalarabic = 65200, f.zakatakana = 12470, f.zaqefgadolhebrew = 1429, f.zaqefqatanhebrew = 1428, f.zarqahebrew = 1432, f.zayin = 1494, f.zayindagesh = 64310, f.zayindageshhebrew = 64310, f.zayinhebrew = 1494, f.zbopomofo = 12567, f.zcaron = 382, f.zcircle = 9449, f.zcircumflex = 7825, f.zcurl = 657, f.zdot = 380, f.zdotaccent = 380, f.zdotbelow = 7827, f.zecyrillic = 1079, f.zedescendercyrillic = 1177, f.zedieresiscyrillic = 1247, f.zehiragana = 12380, f.zekatakana = 12476, f.zero = 48, f.zeroarabic = 1632, f.zerobengali = 2534, f.zerodeva = 2406, f.zerogujarati = 2790, f.zerogurmukhi = 2662, f.zerohackarabic = 1632, f.zeroinferior = 8320, f.zeromonospace = 65296, f.zerooldstyle = 63280, f.zeropersian = 1776, f.zerosuperior = 8304, f.zerothai = 3664, f.zerowidthjoiner = 65279, f.zerowidthnonjoiner = 8204, f.zerowidthspace = 8203, f.zeta = 950, f.zhbopomofo = 12563, f.zhearmenian = 1386, f.zhebrevecyrillic = 1218, f.zhecyrillic = 1078, f.zhedescendercyrillic = 1175, f.zhedieresiscyrillic = 1245, f.zihiragana = 12376, f.zikatakana = 12472, f.zinorhebrew = 1454, f.zlinebelow = 7829, f.zmonospace = 65370, f.zohiragana = 12382, f.zokatakana = 12478, f.zparen = 9397, f.zretroflexhook = 656, f.zstroke = 438, f.zuhiragana = 12378, f.zukatakana = 12474, f[".notdef"] = 0, f.angbracketleftbig = 9001, f.angbracketleftBig = 9001, f.angbracketleftbigg = 9001, f.angbracketleftBigg = 9001, f.angbracketrightBig = 9002, f.angbracketrightbig = 9002, f.angbracketrightBigg = 9002, f.angbracketrightbigg = 9002, f.arrowhookleft = 8618, f.arrowhookright = 8617, f.arrowlefttophalf = 8636, f.arrowleftbothalf = 8637, f.arrownortheast = 8599, f.arrownorthwest = 8598, f.arrowrighttophalf = 8640, f.arrowrightbothalf = 8641, f.arrowsoutheast = 8600, f.arrowsouthwest = 8601, f.backslashbig = 8726, f.backslashBig = 8726, f.backslashBigg = 8726, f.backslashbigg = 8726, f.bardbl = 8214, f.bracehtipdownleft = 65079, f.bracehtipdownright = 65079, f.bracehtipupleft = 65080, f.bracehtipupright = 65080, f.braceleftBig = 123, f.braceleftbig = 123, f.braceleftbigg = 123, f.braceleftBigg = 123, f.bracerightBig = 125, f.bracerightbig = 125, f.bracerightbigg = 125, f.bracerightBigg = 125, f.bracketleftbig = 91, f.bracketleftBig = 91, f.bracketleftbigg = 91, f.bracketleftBigg = 91, f.bracketrightBig = 93, f.bracketrightbig = 93, f.bracketrightbigg = 93, f.bracketrightBigg = 93, f.ceilingleftbig = 8968, f.ceilingleftBig = 8968, f.ceilingleftBigg = 8968, f.ceilingleftbigg = 8968, f.ceilingrightbig = 8969, f.ceilingrightBig = 8969, f.ceilingrightbigg = 8969, f.ceilingrightBigg = 8969, f.circledotdisplay = 8857, f.circledottext = 8857, f.circlemultiplydisplay = 8855, f.circlemultiplytext = 8855, f.circleplusdisplay = 8853, f.circleplustext = 8853, f.contintegraldisplay = 8750, f.contintegraltext = 8750, f.coproductdisplay = 8720, f.coproducttext = 8720, f.floorleftBig = 8970, f.floorleftbig = 8970, f.floorleftbigg = 8970, f.floorleftBigg = 8970, f.floorrightbig = 8971, f.floorrightBig = 8971, f.floorrightBigg = 8971, f.floorrightbigg = 8971, f.hatwide = 770, f.hatwider = 770, f.hatwidest = 770, f.intercal = 7488, f.integraldisplay = 8747, f.integraltext = 8747, f.intersectiondisplay = 8898, f.intersectiontext = 8898, f.logicalanddisplay = 8743, f.logicalandtext = 8743, f.logicalordisplay = 8744, f.logicalortext = 8744, f.parenleftBig = 40, f.parenleftbig = 40, f.parenleftBigg = 40, f.parenleftbigg = 40, f.parenrightBig = 41, f.parenrightbig = 41, f.parenrightBigg = 41, f.parenrightbigg = 41, f.prime = 8242, f.productdisplay = 8719, f.producttext = 8719, f.radicalbig = 8730, f.radicalBig = 8730, f.radicalBigg = 8730, f.radicalbigg = 8730, f.radicalbt = 8730, f.radicaltp = 8730, f.radicalvertex = 8730, f.slashbig = 47, f.slashBig = 47, f.slashBigg = 47, f.slashbigg = 47, f.summationdisplay = 8721, f.summationtext = 8721, f.tildewide = 732, f.tildewider = 732, f.tildewidest = 732, f.uniondisplay = 8899, f.unionmultidisplay = 8846, f.unionmultitext = 8846, f.unionsqdisplay = 8852, f.unionsqtext = 8852, f.uniontext = 8899, f.vextenddouble = 8741, f.vextendsingle = 8739;
            });
            A.getGlyphsUnicode = b;
            const y = (0, g.getLookupTableFactory)(function(f) {
              f.space = 32, f.a1 = 9985, f.a2 = 9986, f.a202 = 9987, f.a3 = 9988, f.a4 = 9742, f.a5 = 9990, f.a119 = 9991, f.a118 = 9992, f.a117 = 9993, f.a11 = 9755, f.a12 = 9758, f.a13 = 9996, f.a14 = 9997, f.a15 = 9998, f.a16 = 9999, f.a105 = 1e4, f.a17 = 10001, f.a18 = 10002, f.a19 = 10003, f.a20 = 10004, f.a21 = 10005, f.a22 = 10006, f.a23 = 10007, f.a24 = 10008, f.a25 = 10009, f.a26 = 10010, f.a27 = 10011, f.a28 = 10012, f.a6 = 10013, f.a7 = 10014, f.a8 = 10015, f.a9 = 10016, f.a10 = 10017, f.a29 = 10018, f.a30 = 10019, f.a31 = 10020, f.a32 = 10021, f.a33 = 10022, f.a34 = 10023, f.a35 = 9733, f.a36 = 10025, f.a37 = 10026, f.a38 = 10027, f.a39 = 10028, f.a40 = 10029, f.a41 = 10030, f.a42 = 10031, f.a43 = 10032, f.a44 = 10033, f.a45 = 10034, f.a46 = 10035, f.a47 = 10036, f.a48 = 10037, f.a49 = 10038, f.a50 = 10039, f.a51 = 10040, f.a52 = 10041, f.a53 = 10042, f.a54 = 10043, f.a55 = 10044, f.a56 = 10045, f.a57 = 10046, f.a58 = 10047, f.a59 = 10048, f.a60 = 10049, f.a61 = 10050, f.a62 = 10051, f.a63 = 10052, f.a64 = 10053, f.a65 = 10054, f.a66 = 10055, f.a67 = 10056, f.a68 = 10057, f.a69 = 10058, f.a70 = 10059, f.a71 = 9679, f.a72 = 10061, f.a73 = 9632, f.a74 = 10063, f.a203 = 10064, f.a75 = 10065, f.a204 = 10066, f.a76 = 9650, f.a77 = 9660, f.a78 = 9670, f.a79 = 10070, f.a81 = 9687, f.a82 = 10072, f.a83 = 10073, f.a84 = 10074, f.a97 = 10075, f.a98 = 10076, f.a99 = 10077, f.a100 = 10078, f.a101 = 10081, f.a102 = 10082, f.a103 = 10083, f.a104 = 10084, f.a106 = 10085, f.a107 = 10086, f.a108 = 10087, f.a112 = 9827, f.a111 = 9830, f.a110 = 9829, f.a109 = 9824, f.a120 = 9312, f.a121 = 9313, f.a122 = 9314, f.a123 = 9315, f.a124 = 9316, f.a125 = 9317, f.a126 = 9318, f.a127 = 9319, f.a128 = 9320, f.a129 = 9321, f.a130 = 10102, f.a131 = 10103, f.a132 = 10104, f.a133 = 10105, f.a134 = 10106, f.a135 = 10107, f.a136 = 10108, f.a137 = 10109, f.a138 = 10110, f.a139 = 10111, f.a140 = 10112, f.a141 = 10113, f.a142 = 10114, f.a143 = 10115, f.a144 = 10116, f.a145 = 10117, f.a146 = 10118, f.a147 = 10119, f.a148 = 10120, f.a149 = 10121, f.a150 = 10122, f.a151 = 10123, f.a152 = 10124, f.a153 = 10125, f.a154 = 10126, f.a155 = 10127, f.a156 = 10128, f.a157 = 10129, f.a158 = 10130, f.a159 = 10131, f.a160 = 10132, f.a161 = 8594, f.a163 = 8596, f.a164 = 8597, f.a196 = 10136, f.a165 = 10137, f.a192 = 10138, f.a166 = 10139, f.a167 = 10140, f.a168 = 10141, f.a169 = 10142, f.a170 = 10143, f.a171 = 10144, f.a172 = 10145, f.a173 = 10146, f.a162 = 10147, f.a174 = 10148, f.a175 = 10149, f.a176 = 10150, f.a177 = 10151, f.a178 = 10152, f.a179 = 10153, f.a193 = 10154, f.a180 = 10155, f.a199 = 10156, f.a181 = 10157, f.a200 = 10158, f.a182 = 10159, f.a201 = 10161, f.a183 = 10162, f.a184 = 10163, f.a197 = 10164, f.a185 = 10165, f.a194 = 10166, f.a198 = 10167, f.a186 = 10168, f.a195 = 10169, f.a187 = 10170, f.a188 = 10171, f.a189 = 10172, f.a190 = 10173, f.a191 = 10174, f.a89 = 10088, f.a90 = 10089, f.a93 = 10090, f.a94 = 10091, f.a91 = 10092, f.a92 = 10093, f.a205 = 10094, f.a85 = 10095, f.a206 = 10096, f.a86 = 10097, f.a87 = 10098, f.a88 = 10099, f.a95 = 10100, f.a96 = 10101, f[".notdef"] = 0;
            });
            A.getDingbatsGlyphsUnicode = y;
          },
          /* 40 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.clearUnicodeCaches = T, A.getCharUnicodeCategory = $, A.getUnicodeForGlyph = f, A.getUnicodeRangeFor = C, A.mapSpecialUnicodeValues = y;
            var g = x(3);
            const b = (0, g.getLookupTableFactory)(function(I) {
              I[63721] = 169, I[63193] = 169, I[63720] = 174, I[63194] = 174, I[63722] = 8482, I[63195] = 8482, I[63729] = 9127, I[63730] = 9128, I[63731] = 9129, I[63740] = 9131, I[63741] = 9132, I[63742] = 9133, I[63726] = 9121, I[63727] = 9122, I[63728] = 9123, I[63737] = 9124, I[63738] = 9125, I[63739] = 9126, I[63723] = 9115, I[63724] = 9116, I[63725] = 9117, I[63734] = 9118, I[63735] = 9119, I[63736] = 9120;
            });
            function y(I) {
              return I >= 65520 && I <= 65535 ? 0 : I >= 62976 && I <= 63743 ? b()[I] || I : I === 173 ? 45 : I;
            }
            function f(I, _) {
              let E = _[I];
              if (E !== void 0)
                return E;
              if (!I)
                return -1;
              if (I[0] === "u") {
                const R = I.length;
                let O;
                if (R === 7 && I[1] === "n" && I[2] === "i")
                  O = I.substring(3);
                else if (R >= 5 && R <= 7)
                  O = I.substring(1);
                else
                  return -1;
                if (O === O.toUpperCase() && (E = parseInt(O, 16), E >= 0))
                  return E;
              }
              return -1;
            }
            const m = [[0, 127], [128, 255], [256, 383], [384, 591], [592, 687, 7424, 7551, 7552, 7615], [688, 767, 42752, 42783], [768, 879, 7616, 7679], [880, 1023], [11392, 11519], [1024, 1279, 1280, 1327, 11744, 11775, 42560, 42655], [1328, 1423], [1424, 1535], [42240, 42559], [1536, 1791, 1872, 1919], [1984, 2047], [2304, 2431], [2432, 2559], [2560, 2687], [2688, 2815], [2816, 2943], [2944, 3071], [3072, 3199], [3200, 3327], [3328, 3455], [3584, 3711], [3712, 3839], [4256, 4351, 11520, 11567], [6912, 7039], [4352, 4607], [7680, 7935, 11360, 11391, 42784, 43007], [7936, 8191], [8192, 8303, 11776, 11903], [8304, 8351], [8352, 8399], [8400, 8447], [8448, 8527], [8528, 8591], [8592, 8703, 10224, 10239, 10496, 10623, 11008, 11263], [8704, 8959, 10752, 11007, 10176, 10223, 10624, 10751], [8960, 9215], [9216, 9279], [9280, 9311], [9312, 9471], [9472, 9599], [9600, 9631], [9632, 9727], [9728, 9983], [9984, 10175], [12288, 12351], [12352, 12447], [12448, 12543, 12784, 12799], [12544, 12591, 12704, 12735], [12592, 12687], [43072, 43135], [12800, 13055], [13056, 13311], [44032, 55215], [55296, 57343], [67840, 67871], [19968, 40959, 11904, 12031, 12032, 12255, 12272, 12287, 13312, 19903, 131072, 173791, 12688, 12703], [57344, 63743], [12736, 12783, 63744, 64255, 194560, 195103], [64256, 64335], [64336, 65023], [65056, 65071], [65040, 65055], [65104, 65135], [65136, 65279], [65280, 65519], [65520, 65535], [3840, 4095], [1792, 1871], [1920, 1983], [3456, 3583], [4096, 4255], [4608, 4991, 4992, 5023, 11648, 11743], [5024, 5119], [5120, 5759], [5760, 5791], [5792, 5887], [6016, 6143], [6144, 6319], [10240, 10495], [40960, 42127], [5888, 5919, 5920, 5951, 5952, 5983, 5984, 6015], [66304, 66351], [66352, 66383], [66560, 66639], [118784, 119039, 119040, 119295, 119296, 119375], [119808, 120831], [1044480, 1048573], [65024, 65039, 917760, 917999], [917504, 917631], [6400, 6479], [6480, 6527], [6528, 6623], [6656, 6687], [11264, 11359], [11568, 11647], [19904, 19967], [43008, 43055], [65536, 65663, 65664, 65791, 65792, 65855], [65856, 65935], [66432, 66463], [66464, 66527], [66640, 66687], [66688, 66735], [67584, 67647], [68096, 68191], [119552, 119647], [73728, 74751, 74752, 74879], [119648, 119679], [7040, 7103], [7168, 7247], [7248, 7295], [43136, 43231], [43264, 43311], [43312, 43359], [43520, 43615], [65936, 65999], [66e3, 66047], [66208, 66271, 66176, 66207, 67872, 67903], [127024, 127135, 126976, 127023]];
            function C(I, _ = -1) {
              if (_ !== -1) {
                const E = m[_];
                for (let R = 0, O = E.length; R < O; R += 2)
                  if (I >= E[R] && I <= E[R + 1])
                    return _;
              }
              for (let E = 0, R = m.length; E < R; E++) {
                const O = m[E];
                for (let L = 0, B = O.length; L < B; L += 2)
                  if (I >= O[L] && I <= O[L + 1])
                    return E;
              }
              return -1;
            }
            const w = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u"), S = /* @__PURE__ */ new Map();
            function $(I) {
              const _ = S.get(I);
              if (_)
                return _;
              const E = I.match(w), R = {
                isWhitespace: !!E?.[1],
                isZeroWidthDiacritic: !!E?.[2],
                isInvisibleFormatMark: !!E?.[3]
              };
              return S.set(I, R), R;
            }
            function T() {
              S.clear();
            }
          },
          /* 41 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.getSerifFonts = A.getNonStdFontMap = A.getGlyphMapForStandardFonts = A.getFontNameToFileMap = void 0, A.getStandardFontName = I, A.getSymbolsFonts = A.getSupplementalGlyphMapForCalibri = A.getSupplementalGlyphMapForArialBlack = A.getStdFontMap = void 0, A.isKnownFontName = _;
            var g = x(3), b = x(38);
            const y = (0, g.getLookupTableFactory)(function(E) {
              E["Times-Roman"] = "Times-Roman", E.Helvetica = "Helvetica", E.Courier = "Courier", E.Symbol = "Symbol", E["Times-Bold"] = "Times-Bold", E["Helvetica-Bold"] = "Helvetica-Bold", E["Courier-Bold"] = "Courier-Bold", E.ZapfDingbats = "ZapfDingbats", E["Times-Italic"] = "Times-Italic", E["Helvetica-Oblique"] = "Helvetica-Oblique", E["Courier-Oblique"] = "Courier-Oblique", E["Times-BoldItalic"] = "Times-BoldItalic", E["Helvetica-BoldOblique"] = "Helvetica-BoldOblique", E["Courier-BoldOblique"] = "Courier-BoldOblique", E.ArialNarrow = "Helvetica", E["ArialNarrow-Bold"] = "Helvetica-Bold", E["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique", E["ArialNarrow-Italic"] = "Helvetica-Oblique", E.ArialBlack = "Helvetica", E["ArialBlack-Bold"] = "Helvetica-Bold", E["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique", E["ArialBlack-Italic"] = "Helvetica-Oblique", E["Arial-Black"] = "Helvetica", E["Arial-Black-Bold"] = "Helvetica-Bold", E["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique", E["Arial-Black-Italic"] = "Helvetica-Oblique", E.Arial = "Helvetica", E["Arial-Bold"] = "Helvetica-Bold", E["Arial-BoldItalic"] = "Helvetica-BoldOblique", E["Arial-Italic"] = "Helvetica-Oblique", E.ArialMT = "Helvetica", E["Arial-BoldItalicMT"] = "Helvetica-BoldOblique", E["Arial-BoldMT"] = "Helvetica-Bold", E["Arial-ItalicMT"] = "Helvetica-Oblique", E["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique", E["Arial-BoldMT-Bold"] = "Helvetica-Bold", E["Arial-ItalicMT-Italic"] = "Helvetica-Oblique", E.ArialUnicodeMS = "Helvetica", E["ArialUnicodeMS-Bold"] = "Helvetica-Bold", E["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique", E["ArialUnicodeMS-Italic"] = "Helvetica-Oblique", E["Courier-BoldItalic"] = "Courier-BoldOblique", E["Courier-Italic"] = "Courier-Oblique", E.CourierNew = "Courier", E["CourierNew-Bold"] = "Courier-Bold", E["CourierNew-BoldItalic"] = "Courier-BoldOblique", E["CourierNew-Italic"] = "Courier-Oblique", E["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique", E["CourierNewPS-BoldMT"] = "Courier-Bold", E["CourierNewPS-ItalicMT"] = "Courier-Oblique", E.CourierNewPSMT = "Courier", E["Helvetica-BoldItalic"] = "Helvetica-BoldOblique", E["Helvetica-Italic"] = "Helvetica-Oblique", E["Symbol-Bold"] = "Symbol", E["Symbol-BoldItalic"] = "Symbol", E["Symbol-Italic"] = "Symbol", E.TimesNewRoman = "Times-Roman", E["TimesNewRoman-Bold"] = "Times-Bold", E["TimesNewRoman-BoldItalic"] = "Times-BoldItalic", E["TimesNewRoman-Italic"] = "Times-Italic", E.TimesNewRomanPS = "Times-Roman", E["TimesNewRomanPS-Bold"] = "Times-Bold", E["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic", E["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic", E["TimesNewRomanPS-BoldMT"] = "Times-Bold", E["TimesNewRomanPS-Italic"] = "Times-Italic", E["TimesNewRomanPS-ItalicMT"] = "Times-Italic", E.TimesNewRomanPSMT = "Times-Roman", E["TimesNewRomanPSMT-Bold"] = "Times-Bold", E["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic", E["TimesNewRomanPSMT-Italic"] = "Times-Italic";
            });
            A.getStdFontMap = y;
            const f = (0, g.getLookupTableFactory)(function(E) {
              E.Courier = "FoxitFixed.pfb", E["Courier-Bold"] = "FoxitFixedBold.pfb", E["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb", E["Courier-Oblique"] = "FoxitFixedItalic.pfb", E.Helvetica = "LiberationSans-Regular.ttf", E["Helvetica-Bold"] = "LiberationSans-Bold.ttf", E["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf", E["Helvetica-Oblique"] = "LiberationSans-Italic.ttf", E["Times-Roman"] = "FoxitSerif.pfb", E["Times-Bold"] = "FoxitSerifBold.pfb", E["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb", E["Times-Italic"] = "FoxitSerifItalic.pfb", E.Symbol = "FoxitSymbol.pfb", E.ZapfDingbats = "FoxitDingbats.pfb", E["LiberationSans-Regular"] = "LiberationSans-Regular.ttf", E["LiberationSans-Bold"] = "LiberationSans-Bold.ttf", E["LiberationSans-Italic"] = "LiberationSans-Italic.ttf", E["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
            });
            A.getFontNameToFileMap = f;
            const m = (0, g.getLookupTableFactory)(function(E) {
              E.Calibri = "Helvetica", E["Calibri-Bold"] = "Helvetica-Bold", E["Calibri-BoldItalic"] = "Helvetica-BoldOblique", E["Calibri-Italic"] = "Helvetica-Oblique", E.CenturyGothic = "Helvetica", E["CenturyGothic-Bold"] = "Helvetica-Bold", E["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique", E["CenturyGothic-Italic"] = "Helvetica-Oblique", E.ComicSansMS = "Comic Sans MS", E["ComicSansMS-Bold"] = "Comic Sans MS-Bold", E["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic", E["ComicSansMS-Italic"] = "Comic Sans MS-Italic", E.Impact = "Helvetica", E["ItcSymbol-Bold"] = "Helvetica-Bold", E["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique", E["ItcSymbol-Book"] = "Helvetica", E["ItcSymbol-BookItalic"] = "Helvetica-Oblique", E["ItcSymbol-Medium"] = "Helvetica", E["ItcSymbol-MediumItalic"] = "Helvetica-Oblique", E.LucidaConsole = "Courier", E["LucidaConsole-Bold"] = "Courier-Bold", E["LucidaConsole-BoldItalic"] = "Courier-BoldOblique", E["LucidaConsole-Italic"] = "Courier-Oblique", E["LucidaSans-Demi"] = "Helvetica-Bold", E["MS-Gothic"] = "MS Gothic", E["MS-Gothic-Bold"] = "MS Gothic-Bold", E["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic", E["MS-Gothic-Italic"] = "MS Gothic-Italic", E["MS-Mincho"] = "MS Mincho", E["MS-Mincho-Bold"] = "MS Mincho-Bold", E["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic", E["MS-Mincho-Italic"] = "MS Mincho-Italic", E["MS-PGothic"] = "MS PGothic", E["MS-PGothic-Bold"] = "MS PGothic-Bold", E["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic", E["MS-PGothic-Italic"] = "MS PGothic-Italic", E["MS-PMincho"] = "MS PMincho", E["MS-PMincho-Bold"] = "MS PMincho-Bold", E["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic", E["MS-PMincho-Italic"] = "MS PMincho-Italic", E.NuptialScript = "Times-Italic", E.SegoeUISymbol = "Helvetica";
            });
            A.getNonStdFontMap = m;
            const C = (0, g.getLookupTableFactory)(function(E) {
              E["Adobe Jenson"] = !0, E["Adobe Text"] = !0, E.Albertus = !0, E.Aldus = !0, E.Alexandria = !0, E.Algerian = !0, E["American Typewriter"] = !0, E.Antiqua = !0, E.Apex = !0, E.Arno = !0, E.Aster = !0, E.Aurora = !0, E.Baskerville = !0, E.Bell = !0, E.Bembo = !0, E["Bembo Schoolbook"] = !0, E.Benguiat = !0, E["Berkeley Old Style"] = !0, E["Bernhard Modern"] = !0, E["Berthold City"] = !0, E.Bodoni = !0, E["Bauer Bodoni"] = !0, E["Book Antiqua"] = !0, E.Bookman = !0, E["Bordeaux Roman"] = !0, E["Californian FB"] = !0, E.Calisto = !0, E.Calvert = !0, E.Capitals = !0, E.Cambria = !0, E.Cartier = !0, E.Caslon = !0, E.Catull = !0, E.Centaur = !0, E["Century Old Style"] = !0, E["Century Schoolbook"] = !0, E.Chaparral = !0, E["Charis SIL"] = !0, E.Cheltenham = !0, E["Cholla Slab"] = !0, E.Clarendon = !0, E.Clearface = !0, E.Cochin = !0, E.Colonna = !0, E["Computer Modern"] = !0, E["Concrete Roman"] = !0, E.Constantia = !0, E["Cooper Black"] = !0, E.Corona = !0, E.Ecotype = !0, E.Egyptienne = !0, E.Elephant = !0, E.Excelsior = !0, E.Fairfield = !0, E["FF Scala"] = !0, E.Folkard = !0, E.Footlight = !0, E.FreeSerif = !0, E["Friz Quadrata"] = !0, E.Garamond = !0, E.Gentium = !0, E.Georgia = !0, E.Gloucester = !0, E["Goudy Old Style"] = !0, E["Goudy Schoolbook"] = !0, E["Goudy Pro Font"] = !0, E.Granjon = !0, E["Guardian Egyptian"] = !0, E.Heather = !0, E.Hercules = !0, E["High Tower Text"] = !0, E.Hiroshige = !0, E["Hoefler Text"] = !0, E["Humana Serif"] = !0, E.Imprint = !0, E["Ionic No. 5"] = !0, E.Janson = !0, E.Joanna = !0, E.Korinna = !0, E.Lexicon = !0, E.LiberationSerif = !0, E["Liberation Serif"] = !0, E["Linux Libertine"] = !0, E.Literaturnaya = !0, E.Lucida = !0, E["Lucida Bright"] = !0, E.Melior = !0, E.Memphis = !0, E.Miller = !0, E.Minion = !0, E.Modern = !0, E["Mona Lisa"] = !0, E["Mrs Eaves"] = !0, E["MS Serif"] = !0, E["Museo Slab"] = !0, E["New York"] = !0, E["Nimbus Roman"] = !0, E["NPS Rawlinson Roadway"] = !0, E.NuptialScript = !0, E.Palatino = !0, E.Perpetua = !0, E.Plantin = !0, E["Plantin Schoolbook"] = !0, E.Playbill = !0, E["Poor Richard"] = !0, E["Rawlinson Roadway"] = !0, E.Renault = !0, E.Requiem = !0, E.Rockwell = !0, E.Roman = !0, E["Rotis Serif"] = !0, E.Sabon = !0, E.Scala = !0, E.Seagull = !0, E.Sistina = !0, E.Souvenir = !0, E.STIX = !0, E["Stone Informal"] = !0, E["Stone Serif"] = !0, E.Sylfaen = !0, E.Times = !0, E.Trajan = !0, E.Trinité = !0, E["Trump Mediaeval"] = !0, E.Utopia = !0, E["Vale Type"] = !0, E["Bitstream Vera"] = !0, E["Vera Serif"] = !0, E.Versailles = !0, E.Wanted = !0, E.Weiss = !0, E["Wide Latin"] = !0, E.Windsor = !0, E.XITS = !0;
            });
            A.getSerifFonts = C;
            const w = (0, g.getLookupTableFactory)(function(E) {
              E.Dingbats = !0, E.Symbol = !0, E.ZapfDingbats = !0, E.Wingdings = !0, E["Wingdings-Bold"] = !0, E["Wingdings-Regular"] = !0;
            });
            A.getSymbolsFonts = w;
            const S = (0, g.getLookupTableFactory)(function(E) {
              E[2] = 10, E[3] = 32, E[4] = 33, E[5] = 34, E[6] = 35, E[7] = 36, E[8] = 37, E[9] = 38, E[10] = 39, E[11] = 40, E[12] = 41, E[13] = 42, E[14] = 43, E[15] = 44, E[16] = 45, E[17] = 46, E[18] = 47, E[19] = 48, E[20] = 49, E[21] = 50, E[22] = 51, E[23] = 52, E[24] = 53, E[25] = 54, E[26] = 55, E[27] = 56, E[28] = 57, E[29] = 58, E[30] = 894, E[31] = 60, E[32] = 61, E[33] = 62, E[34] = 63, E[35] = 64, E[36] = 65, E[37] = 66, E[38] = 67, E[39] = 68, E[40] = 69, E[41] = 70, E[42] = 71, E[43] = 72, E[44] = 73, E[45] = 74, E[46] = 75, E[47] = 76, E[48] = 77, E[49] = 78, E[50] = 79, E[51] = 80, E[52] = 81, E[53] = 82, E[54] = 83, E[55] = 84, E[56] = 85, E[57] = 86, E[58] = 87, E[59] = 88, E[60] = 89, E[61] = 90, E[62] = 91, E[63] = 92, E[64] = 93, E[65] = 94, E[66] = 95, E[67] = 96, E[68] = 97, E[69] = 98, E[70] = 99, E[71] = 100, E[72] = 101, E[73] = 102, E[74] = 103, E[75] = 104, E[76] = 105, E[77] = 106, E[78] = 107, E[79] = 108, E[80] = 109, E[81] = 110, E[82] = 111, E[83] = 112, E[84] = 113, E[85] = 114, E[86] = 115, E[87] = 116, E[88] = 117, E[89] = 118, E[90] = 119, E[91] = 120, E[92] = 121, E[93] = 122, E[94] = 123, E[95] = 124, E[96] = 125, E[97] = 126, E[98] = 196, E[99] = 197, E[100] = 199, E[101] = 201, E[102] = 209, E[103] = 214, E[104] = 220, E[105] = 225, E[106] = 224, E[107] = 226, E[108] = 228, E[109] = 227, E[110] = 229, E[111] = 231, E[112] = 233, E[113] = 232, E[114] = 234, E[115] = 235, E[116] = 237, E[117] = 236, E[118] = 238, E[119] = 239, E[120] = 241, E[121] = 243, E[122] = 242, E[123] = 244, E[124] = 246, E[125] = 245, E[126] = 250, E[127] = 249, E[128] = 251, E[129] = 252, E[130] = 8224, E[131] = 176, E[132] = 162, E[133] = 163, E[134] = 167, E[135] = 8226, E[136] = 182, E[137] = 223, E[138] = 174, E[139] = 169, E[140] = 8482, E[141] = 180, E[142] = 168, E[143] = 8800, E[144] = 198, E[145] = 216, E[146] = 8734, E[147] = 177, E[148] = 8804, E[149] = 8805, E[150] = 165, E[151] = 181, E[152] = 8706, E[153] = 8721, E[154] = 8719, E[156] = 8747, E[157] = 170, E[158] = 186, E[159] = 8486, E[160] = 230, E[161] = 248, E[162] = 191, E[163] = 161, E[164] = 172, E[165] = 8730, E[166] = 402, E[167] = 8776, E[168] = 8710, E[169] = 171, E[170] = 187, E[171] = 8230, E[179] = 8220, E[180] = 8221, E[181] = 8216, E[182] = 8217, E[200] = 193, E[203] = 205, E[207] = 211, E[210] = 218, E[223] = 711, E[224] = 321, E[225] = 322, E[226] = 352, E[227] = 353, E[228] = 381, E[229] = 382, E[233] = 221, E[234] = 253, E[252] = 263, E[253] = 268, E[254] = 269, E[258] = 258, E[260] = 260, E[261] = 261, E[265] = 280, E[266] = 281, E[267] = 282, E[268] = 283, E[269] = 313, E[275] = 323, E[276] = 324, E[278] = 328, E[283] = 344, E[284] = 345, E[285] = 346, E[286] = 347, E[292] = 367, E[295] = 377, E[296] = 378, E[298] = 380, E[305] = 963, E[306] = 964, E[307] = 966, E[308] = 8215, E[309] = 8252, E[310] = 8319, E[311] = 8359, E[312] = 8592, E[313] = 8593, E[337] = 9552, E[493] = 1039, E[494] = 1040, E[672] = 1488, E[673] = 1489, E[674] = 1490, E[675] = 1491, E[676] = 1492, E[677] = 1493, E[678] = 1494, E[679] = 1495, E[680] = 1496, E[681] = 1497, E[682] = 1498, E[683] = 1499, E[684] = 1500, E[685] = 1501, E[686] = 1502, E[687] = 1503, E[688] = 1504, E[689] = 1505, E[690] = 1506, E[691] = 1507, E[692] = 1508, E[693] = 1509, E[694] = 1510, E[695] = 1511, E[696] = 1512, E[697] = 1513, E[698] = 1514, E[705] = 1524, E[706] = 8362, E[710] = 64288, E[711] = 64298, E[759] = 1617, E[761] = 1776, E[763] = 1778, E[775] = 1652, E[777] = 1764, E[778] = 1780, E[779] = 1781, E[780] = 1782, E[782] = 771, E[783] = 64726, E[786] = 8363, E[788] = 8532, E[790] = 768, E[791] = 769, E[792] = 768, E[795] = 803, E[797] = 64336, E[798] = 64337, E[799] = 64342, E[800] = 64343, E[801] = 64344, E[802] = 64345, E[803] = 64362, E[804] = 64363, E[805] = 64364, E[2424] = 7821, E[2425] = 7822, E[2426] = 7823, E[2427] = 7824, E[2428] = 7825, E[2429] = 7826, E[2430] = 7827, E[2433] = 7682, E[2678] = 8045, E[2679] = 8046, E[2830] = 1552, E[2838] = 686, E[2840] = 751, E[2842] = 753, E[2843] = 754, E[2844] = 755, E[2846] = 757, E[2856] = 767, E[2857] = 848, E[2858] = 849, E[2862] = 853, E[2863] = 854, E[2864] = 855, E[2865] = 861, E[2866] = 862, E[2906] = 7460, E[2908] = 7462, E[2909] = 7463, E[2910] = 7464, E[2912] = 7466, E[2913] = 7467, E[2914] = 7468, E[2916] = 7470, E[2917] = 7471, E[2918] = 7472, E[2920] = 7474, E[2921] = 7475, E[2922] = 7476, E[2924] = 7478, E[2925] = 7479, E[2926] = 7480, E[2928] = 7482, E[2929] = 7483, E[2930] = 7484, E[2932] = 7486, E[2933] = 7487, E[2934] = 7488, E[2936] = 7490, E[2937] = 7491, E[2938] = 7492, E[2940] = 7494, E[2941] = 7495, E[2942] = 7496, E[2944] = 7498, E[2946] = 7500, E[2948] = 7502, E[2950] = 7504, E[2951] = 7505, E[2952] = 7506, E[2954] = 7508, E[2955] = 7509, E[2956] = 7510, E[2958] = 7512, E[2959] = 7513, E[2960] = 7514, E[2962] = 7516, E[2963] = 7517, E[2964] = 7518, E[2966] = 7520, E[2967] = 7521, E[2968] = 7522, E[2970] = 7524, E[2971] = 7525, E[2972] = 7526, E[2974] = 7528, E[2975] = 7529, E[2976] = 7530, E[2978] = 1537, E[2979] = 1538, E[2980] = 1539, E[2982] = 1549, E[2983] = 1551, E[2984] = 1552, E[2986] = 1554, E[2987] = 1555, E[2988] = 1556, E[2990] = 1623, E[2991] = 1624, E[2995] = 1775, E[2999] = 1791, E[3002] = 64290, E[3003] = 64291, E[3004] = 64292, E[3006] = 64294, E[3007] = 64295, E[3008] = 64296, E[3011] = 1900, E[3014] = 8223, E[3015] = 8244, E[3017] = 7532, E[3018] = 7533, E[3019] = 7534, E[3075] = 7590, E[3076] = 7591, E[3079] = 7594, E[3080] = 7595, E[3083] = 7598, E[3084] = 7599, E[3087] = 7602, E[3088] = 7603, E[3091] = 7606, E[3092] = 7607, E[3095] = 7610, E[3096] = 7611, E[3099] = 7614, E[3100] = 7615, E[3103] = 7618, E[3104] = 7619, E[3107] = 8337, E[3108] = 8338, E[3116] = 1884, E[3119] = 1885, E[3120] = 1885, E[3123] = 1886, E[3124] = 1886, E[3127] = 1887, E[3128] = 1887, E[3131] = 1888, E[3132] = 1888, E[3135] = 1889, E[3136] = 1889, E[3139] = 1890, E[3140] = 1890, E[3143] = 1891, E[3144] = 1891, E[3147] = 1892, E[3148] = 1892, E[3153] = 580, E[3154] = 581, E[3157] = 584, E[3158] = 585, E[3161] = 588, E[3162] = 589, E[3165] = 891, E[3166] = 892, E[3169] = 1274, E[3170] = 1275, E[3173] = 1278, E[3174] = 1279, E[3181] = 7622, E[3182] = 7623, E[3282] = 11799, E[3316] = 578, E[3379] = 42785, E[3393] = 1159, E[3416] = 8377;
            });
            A.getGlyphMapForStandardFonts = S;
            const $ = (0, g.getLookupTableFactory)(function(E) {
              E[227] = 322, E[264] = 261, E[291] = 346;
            });
            A.getSupplementalGlyphMapForArialBlack = $;
            const T = (0, g.getLookupTableFactory)(function(E) {
              E[1] = 32, E[4] = 65, E[5] = 192, E[6] = 193, E[9] = 196, E[17] = 66, E[18] = 67, E[21] = 268, E[24] = 68, E[28] = 69, E[29] = 200, E[30] = 201, E[32] = 282, E[38] = 70, E[39] = 71, E[44] = 72, E[47] = 73, E[48] = 204, E[49] = 205, E[58] = 74, E[60] = 75, E[62] = 76, E[68] = 77, E[69] = 78, E[75] = 79, E[76] = 210, E[80] = 214, E[87] = 80, E[89] = 81, E[90] = 82, E[92] = 344, E[94] = 83, E[97] = 352, E[100] = 84, E[104] = 85, E[109] = 220, E[115] = 86, E[116] = 87, E[121] = 88, E[122] = 89, E[124] = 221, E[127] = 90, E[129] = 381, E[258] = 97, E[259] = 224, E[260] = 225, E[263] = 228, E[268] = 261, E[271] = 98, E[272] = 99, E[273] = 263, E[275] = 269, E[282] = 100, E[286] = 101, E[287] = 232, E[288] = 233, E[290] = 283, E[295] = 281, E[296] = 102, E[336] = 103, E[346] = 104, E[349] = 105, E[350] = 236, E[351] = 237, E[361] = 106, E[364] = 107, E[367] = 108, E[371] = 322, E[373] = 109, E[374] = 110, E[381] = 111, E[382] = 242, E[383] = 243, E[386] = 246, E[393] = 112, E[395] = 113, E[396] = 114, E[398] = 345, E[400] = 115, E[401] = 347, E[403] = 353, E[410] = 116, E[437] = 117, E[442] = 252, E[448] = 118, E[449] = 119, E[454] = 120, E[455] = 121, E[457] = 253, E[460] = 122, E[462] = 382, E[463] = 380, E[853] = 44, E[855] = 58, E[856] = 46, E[876] = 47, E[878] = 45, E[882] = 45, E[894] = 40, E[895] = 41, E[896] = 91, E[897] = 93, E[923] = 64, E[1004] = 48, E[1005] = 49, E[1006] = 50, E[1007] = 51, E[1008] = 52, E[1009] = 53, E[1010] = 54, E[1011] = 55, E[1012] = 56, E[1013] = 57, E[1081] = 37, E[1085] = 43, E[1086] = 45;
            });
            A.getSupplementalGlyphMapForCalibri = T;
            function I(E) {
              const R = (0, b.normalizeFontName)(E);
              return y()[R];
            }
            function _(E) {
              const R = (0, b.normalizeFontName)(E);
              return !!(y()[R] || m()[R] || C()[R] || w()[R]);
            }
          },
          /* 42 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ToUnicodeMap = A.IdentityToUnicodeMap = void 0;
            var g = x(2);
            class b {
              constructor(m = []) {
                this._map = m;
              }
              get length() {
                return this._map.length;
              }
              forEach(m) {
                for (const C in this._map)
                  m(C, this._map[C].charCodeAt(0));
              }
              has(m) {
                return this._map[m] !== void 0;
              }
              get(m) {
                return this._map[m];
              }
              charCodeOf(m) {
                const C = this._map;
                if (C.length <= 65536)
                  return C.indexOf(m);
                for (const w in C)
                  if (C[w] === m)
                    return w | 0;
                return -1;
              }
              amend(m) {
                for (const C in m)
                  this._map[C] = m[C];
              }
            }
            A.ToUnicodeMap = b;
            class y {
              constructor(m, C) {
                this.firstChar = m, this.lastChar = C;
              }
              get length() {
                return this.lastChar + 1 - this.firstChar;
              }
              forEach(m) {
                for (let C = this.firstChar, w = this.lastChar; C <= w; C++)
                  m(C, C);
              }
              has(m) {
                return this.firstChar <= m && m <= this.lastChar;
              }
              get(m) {
                if (this.firstChar <= m && m <= this.lastChar)
                  return String.fromCharCode(m);
              }
              charCodeOf(m) {
                return Number.isInteger(m) && m >= this.firstChar && m <= this.lastChar ? m : -1;
              }
              amend(m) {
                (0, g.unreachable)("Should not call amend()");
              }
            }
            A.IdentityToUnicodeMap = y;
          },
          /* 43 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.CFFFont = void 0;
            var g = x(35), b = x(38), y = x(2);
            class f {
              constructor(C, w) {
                this.properties = w;
                const S = new g.CFFParser(C, w, b.SEAC_ANALYSIS_ENABLED);
                this.cff = S.parse(), this.cff.duplicateFirstGlyph();
                const $ = new g.CFFCompiler(this.cff);
                this.seacs = this.cff.seacs;
                try {
                  this.data = $.compile();
                } catch {
                  (0, y.warn)("Failed to compile font " + w.loadedName), this.data = C;
                }
                this._createBuiltInEncoding();
              }
              get numGlyphs() {
                return this.cff.charStrings.count;
              }
              getCharset() {
                return this.cff.charset.charset;
              }
              getGlyphMapping() {
                const C = this.cff, w = this.properties, {
                  cidToGidMap: S,
                  cMap: $
                } = w, T = C.charset.charset;
                let I, _;
                if (w.composite) {
                  let R;
                  if (S?.length > 0) {
                    R = /* @__PURE__ */ Object.create(null);
                    for (let L = 0, B = S.length; L < B; L++) {
                      const F = S[L];
                      F !== void 0 && (R[F] = L);
                    }
                  }
                  I = /* @__PURE__ */ Object.create(null);
                  let O;
                  if (C.isCIDFont)
                    for (_ = 0; _ < T.length; _++) {
                      const L = T[_];
                      O = $.charCodeOf(L), R?.[O] !== void 0 && (O = R[O]), I[O] = _;
                    }
                  else
                    for (_ = 0; _ < C.charStrings.count; _++)
                      O = $.charCodeOf(_), I[O] = _;
                  return I;
                }
                let E = C.encoding ? C.encoding.encoding : null;
                return w.isInternalFont && (E = w.defaultEncoding), I = (0, b.type1FontGlyphMapping)(w, E, T), I;
              }
              hasGlyphId(C) {
                return this.cff.hasGlyphId(C);
              }
              _createBuiltInEncoding() {
                const {
                  charset: C,
                  encoding: w
                } = this.cff;
                if (!C || !w)
                  return;
                const S = C.charset, $ = w.encoding, T = [];
                for (const I in $) {
                  const _ = $[I];
                  if (_ >= 0) {
                    const E = S[_];
                    E && (T[I] = E);
                  }
                }
                T.length > 0 && (this.properties.builtInEncoding = T);
              }
            }
            A.CFFFont = f;
          },
          /* 44 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.FontRendererFactory = void 0;
            var g = x(2), b = x(35), y = x(39), f = x(37), m = x(8);
            function C(U, k) {
              return (U[k] << 24 | U[k + 1] << 16 | U[k + 2] << 8 | U[k + 3]) >>> 0;
            }
            function w(U, k) {
              return U[k] << 8 | U[k + 1];
            }
            function S(U, k) {
              return (U[k] << 24 | U[k + 1] << 16) >> 16;
            }
            function $(U, k) {
              return U[k] << 24 >> 24;
            }
            function T(U, k) {
              return S(U, k) / 16384;
            }
            function I(U) {
              const k = U.length;
              let N = 32768;
              return k < 1240 ? N = 107 : k < 33900 && (N = 1131), N;
            }
            function _(U, k, N) {
              const P = w(U, k + 2) === 1 ? C(U, k + 8) : C(U, k + 16), D = w(U, k + P);
              let H, V, Z;
              if (D === 4) {
                w(U, k + P + 2);
                const ne = w(U, k + P + 6) >> 1;
                for (V = k + P + 14, H = [], Z = 0; Z < ne; Z++, V += 2)
                  H[Z] = {
                    end: w(U, V)
                  };
                for (V += 2, Z = 0; Z < ne; Z++, V += 2)
                  H[Z].start = w(U, V);
                for (Z = 0; Z < ne; Z++, V += 2)
                  H[Z].idDelta = w(U, V);
                for (Z = 0; Z < ne; Z++, V += 2) {
                  let K = w(U, V);
                  if (K !== 0) {
                    H[Z].ids = [];
                    for (let q = 0, Y = H[Z].end - H[Z].start + 1; q < Y; q++)
                      H[Z].ids[q] = w(U, V + K), K += 2;
                  }
                }
                return H;
              } else if (D === 12) {
                const ne = C(U, k + P + 12);
                for (V = k + P + 16, H = [], Z = 0; Z < ne; Z++)
                  k = C(U, V), H.push({
                    start: k,
                    end: C(U, V + 4),
                    idDelta: C(U, V + 8) - k
                  }), V += 12;
                return H;
              }
              throw new g.FormatError(`unsupported cmap: ${D}`);
            }
            function E(U, k, N, P) {
              const D = {}, V = new b.CFFParser(new m.Stream(U, k, N - k), D, P).parse();
              return {
                glyphs: V.charStrings.objects,
                subrs: V.topDict.privateDict?.subrsIndex?.objects,
                gsubrs: V.globalSubrIndex?.objects,
                isCFFCIDFont: V.isCIDFont,
                fdSelect: V.fdSelect,
                fdArray: V.fdArray
              };
            }
            function R(U, k, N) {
              let P, D;
              N ? (P = 4, D = C) : (P = 2, D = (Z, ne) => 2 * w(Z, ne));
              const H = [];
              let V = D(k, 0);
              for (let Z = P; Z < k.length; Z += P) {
                const ne = D(k, Z);
                H.push(U.subarray(V, ne)), V = ne;
              }
              return H;
            }
            function O(U, k) {
              const N = k.codePointAt(0);
              let P = 0, D = 0, H = U.length - 1;
              for (; D < H; ) {
                const V = D + H + 1 >> 1;
                N < U[V].start ? H = V - 1 : D = V;
              }
              return U[D].start <= N && N <= U[D].end && (P = U[D].idDelta + (U[D].ids ? U[D].ids[N - U[D].start] : N) & 65535), {
                charCode: N,
                glyphId: P
              };
            }
            function L(U, k, N) {
              function P(Y, ee) {
                k.push({
                  cmd: "moveTo",
                  args: [Y, ee]
                });
              }
              function D(Y, ee) {
                k.push({
                  cmd: "lineTo",
                  args: [Y, ee]
                });
              }
              function H(Y, ee, Q, J) {
                k.push({
                  cmd: "quadraticCurveTo",
                  args: [Y, ee, Q, J]
                });
              }
              let V = 0;
              const Z = S(U, V);
              let ne, K = 0, q = 0;
              if (V += 10, Z < 0)
                do {
                  ne = w(U, V);
                  const Y = w(U, V + 2);
                  V += 4;
                  let ee, Q;
                  ne & 1 ? (ne & 2 ? (ee = S(U, V), Q = S(U, V + 2)) : (ee = w(U, V), Q = w(U, V + 2)), V += 4) : ne & 2 ? (ee = $(U, V++), Q = $(U, V++)) : (ee = U[V++], Q = U[V++]), ne & 2 ? (K = ee, q = Q) : (K = 0, q = 0);
                  let J = 1, te = 1, ae = 0, se = 0;
                  ne & 8 ? (J = te = T(U, V), V += 2) : ne & 64 ? (J = T(U, V), te = T(U, V + 2), V += 4) : ne & 128 && (J = T(U, V), ae = T(U, V + 2), se = T(U, V + 4), te = T(U, V + 6), V += 8);
                  const ie = N.glyphs[Y];
                  ie && (k.push({
                    cmd: "save"
                  }, {
                    cmd: "transform",
                    args: [J, ae, se, te, K, q]
                  }), L(ie, k, N), k.push({
                    cmd: "restore"
                  }));
                } while (ne & 32);
              else {
                const Y = [];
                let ee, Q;
                for (ee = 0; ee < Z; ee++)
                  Y.push(w(U, V)), V += 2;
                const J = w(U, V);
                V += 2 + J;
                const te = Y.at(-1) + 1, ae = [];
                for (; ae.length < te; ) {
                  ne = U[V++];
                  let ie = 1;
                  for (ne & 8 && (ie += U[V++]); ie-- > 0; )
                    ae.push({
                      flags: ne
                    });
                }
                for (ee = 0; ee < te; ee++) {
                  switch (ae[ee].flags & 18) {
                    case 0:
                      K += S(U, V), V += 2;
                      break;
                    case 2:
                      K -= U[V++];
                      break;
                    case 18:
                      K += U[V++];
                      break;
                  }
                  ae[ee].x = K;
                }
                for (ee = 0; ee < te; ee++) {
                  switch (ae[ee].flags & 36) {
                    case 0:
                      q += S(U, V), V += 2;
                      break;
                    case 4:
                      q -= U[V++];
                      break;
                    case 36:
                      q += U[V++];
                      break;
                  }
                  ae[ee].y = q;
                }
                let se = 0;
                for (V = 0; V < Z; V++) {
                  const ie = Y[V], fe = ae.slice(se, ie + 1);
                  if (fe[0].flags & 1)
                    fe.push(fe[0]);
                  else if (fe.at(-1).flags & 1)
                    fe.unshift(fe.at(-1));
                  else {
                    const ge = {
                      flags: 1,
                      x: (fe[0].x + fe.at(-1).x) / 2,
                      y: (fe[0].y + fe.at(-1).y) / 2
                    };
                    fe.unshift(ge), fe.push(ge);
                  }
                  for (P(fe[0].x, fe[0].y), ee = 1, Q = fe.length; ee < Q; ee++)
                    fe[ee].flags & 1 ? D(fe[ee].x, fe[ee].y) : fe[ee + 1].flags & 1 ? (H(fe[ee].x, fe[ee].y, fe[ee + 1].x, fe[ee + 1].y), ee++) : H(fe[ee].x, fe[ee].y, (fe[ee].x + fe[ee + 1].x) / 2, (fe[ee].y + fe[ee + 1].y) / 2);
                  se = ie + 1;
                }
              }
            }
            function B(U, k, N, P) {
              function D(ee, Q) {
                k.push({
                  cmd: "moveTo",
                  args: [ee, Q]
                });
              }
              function H(ee, Q) {
                k.push({
                  cmd: "lineTo",
                  args: [ee, Q]
                });
              }
              function V(ee, Q, J, te, ae, se) {
                k.push({
                  cmd: "bezierCurveTo",
                  args: [ee, Q, J, te, ae, se]
                });
              }
              const Z = [];
              let ne = 0, K = 0, q = 0;
              function Y(ee) {
                let Q = 0;
                for (; Q < ee.length; ) {
                  let J = !1, te = ee[Q++], ae, se, ie, fe, ge, me, pe, be, le;
                  switch (te) {
                    case 1:
                      q += Z.length >> 1, J = !0;
                      break;
                    case 3:
                      q += Z.length >> 1, J = !0;
                      break;
                    case 4:
                      K += Z.pop(), D(ne, K), J = !0;
                      break;
                    case 5:
                      for (; Z.length > 0; )
                        ne += Z.shift(), K += Z.shift(), H(ne, K);
                      break;
                    case 6:
                      for (; Z.length > 0 && (ne += Z.shift(), H(ne, K), Z.length !== 0); )
                        K += Z.shift(), H(ne, K);
                      break;
                    case 7:
                      for (; Z.length > 0 && (K += Z.shift(), H(ne, K), Z.length !== 0); )
                        ne += Z.shift(), H(ne, K);
                      break;
                    case 8:
                      for (; Z.length > 0; )
                        ae = ne + Z.shift(), ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe + Z.shift(), V(ae, ie, se, fe, ne, K);
                      break;
                    case 10:
                      if (be = Z.pop(), le = null, N.isCFFCIDFont) {
                        const ve = N.fdSelect.getFDIndex(P);
                        if (ve >= 0 && ve < N.fdArray.length) {
                          const he = N.fdArray[ve];
                          let ye;
                          he.privateDict?.subrsIndex && (ye = he.privateDict.subrsIndex.objects), ye && (be += I(ye), le = ye[be]);
                        } else
                          (0, g.warn)("Invalid fd index for glyph index.");
                      } else
                        le = N.subrs[be + N.subrsBias];
                      le && Y(le);
                      break;
                    case 11:
                      return;
                    case 12:
                      switch (te = ee[Q++], te) {
                        case 34:
                          ae = ne + Z.shift(), se = ae + Z.shift(), ge = K + Z.shift(), ne = se + Z.shift(), V(ae, K, se, ge, ne, ge), ae = ne + Z.shift(), se = ae + Z.shift(), ne = se + Z.shift(), V(ae, ge, se, K, ne, K);
                          break;
                        case 35:
                          ae = ne + Z.shift(), ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe + Z.shift(), V(ae, ie, se, fe, ne, K), ae = ne + Z.shift(), ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe + Z.shift(), V(ae, ie, se, fe, ne, K), Z.pop();
                          break;
                        case 36:
                          ae = ne + Z.shift(), ge = K + Z.shift(), se = ae + Z.shift(), me = ge + Z.shift(), ne = se + Z.shift(), V(ae, ge, se, me, ne, me), ae = ne + Z.shift(), se = ae + Z.shift(), pe = me + Z.shift(), ne = se + Z.shift(), V(ae, me, se, pe, ne, K);
                          break;
                        case 37:
                          const ve = ne, he = K;
                          ae = ne + Z.shift(), ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe + Z.shift(), V(ae, ie, se, fe, ne, K), ae = ne + Z.shift(), ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se, K = fe, Math.abs(ne - ve) > Math.abs(K - he) ? ne += Z.shift() : K += Z.shift(), V(ae, ie, se, fe, ne, K);
                          break;
                        default:
                          throw new g.FormatError(`unknown operator: 12 ${te}`);
                      }
                      break;
                    case 14:
                      if (Z.length >= 4) {
                        const ve = Z.pop(), he = Z.pop();
                        K = Z.pop(), ne = Z.pop(), k.push({
                          cmd: "save"
                        }, {
                          cmd: "translate",
                          args: [ne, K]
                        });
                        let ye = O(N.cmap, String.fromCharCode(N.glyphNameMap[f.StandardEncoding[ve]]));
                        B(N.glyphs[ye.glyphId], k, N, ye.glyphId), k.push({
                          cmd: "restore"
                        }), ye = O(N.cmap, String.fromCharCode(N.glyphNameMap[f.StandardEncoding[he]])), B(N.glyphs[ye.glyphId], k, N, ye.glyphId);
                      }
                      return;
                    case 18:
                      q += Z.length >> 1, J = !0;
                      break;
                    case 19:
                      q += Z.length >> 1, Q += q + 7 >> 3, J = !0;
                      break;
                    case 20:
                      q += Z.length >> 1, Q += q + 7 >> 3, J = !0;
                      break;
                    case 21:
                      K += Z.pop(), ne += Z.pop(), D(ne, K), J = !0;
                      break;
                    case 22:
                      ne += Z.pop(), D(ne, K), J = !0;
                      break;
                    case 23:
                      q += Z.length >> 1, J = !0;
                      break;
                    case 24:
                      for (; Z.length > 2; )
                        ae = ne + Z.shift(), ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe + Z.shift(), V(ae, ie, se, fe, ne, K);
                      ne += Z.shift(), K += Z.shift(), H(ne, K);
                      break;
                    case 25:
                      for (; Z.length > 6; )
                        ne += Z.shift(), K += Z.shift(), H(ne, K);
                      ae = ne + Z.shift(), ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe + Z.shift(), V(ae, ie, se, fe, ne, K);
                      break;
                    case 26:
                      for (Z.length % 2 && (ne += Z.shift()); Z.length > 0; )
                        ae = ne, ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se, K = fe + Z.shift(), V(ae, ie, se, fe, ne, K);
                      break;
                    case 27:
                      for (Z.length % 2 && (K += Z.shift()); Z.length > 0; )
                        ae = ne + Z.shift(), ie = K, se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe, V(ae, ie, se, fe, ne, K);
                      break;
                    case 28:
                      Z.push((ee[Q] << 24 | ee[Q + 1] << 16) >> 16), Q += 2;
                      break;
                    case 29:
                      be = Z.pop() + N.gsubrsBias, le = N.gsubrs[be], le && Y(le);
                      break;
                    case 30:
                      for (; Z.length > 0 && (ae = ne, ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe + (Z.length === 1 ? Z.shift() : 0), V(ae, ie, se, fe, ne, K), Z.length !== 0); )
                        ae = ne + Z.shift(), ie = K, se = ae + Z.shift(), fe = ie + Z.shift(), K = fe + Z.shift(), ne = se + (Z.length === 1 ? Z.shift() : 0), V(ae, ie, se, fe, ne, K);
                      break;
                    case 31:
                      for (; Z.length > 0 && (ae = ne + Z.shift(), ie = K, se = ae + Z.shift(), fe = ie + Z.shift(), K = fe + Z.shift(), ne = se + (Z.length === 1 ? Z.shift() : 0), V(ae, ie, se, fe, ne, K), Z.length !== 0); )
                        ae = ne, ie = K + Z.shift(), se = ae + Z.shift(), fe = ie + Z.shift(), ne = se + Z.shift(), K = fe + (Z.length === 1 ? Z.shift() : 0), V(ae, ie, se, fe, ne, K);
                      break;
                    default:
                      if (te < 32)
                        throw new g.FormatError(`unknown operator: ${te}`);
                      te < 247 ? Z.push(te - 139) : te < 251 ? Z.push((te - 247) * 256 + ee[Q++] + 108) : te < 255 ? Z.push(-(te - 251) * 256 - ee[Q++] - 108) : (Z.push((ee[Q] << 24 | ee[Q + 1] << 16 | ee[Q + 2] << 8 | ee[Q + 3]) / 65536), Q += 4);
                      break;
                  }
                  J && (Z.length = 0);
                }
              }
              Y(U);
            }
            const F = [];
            class M {
              constructor(k) {
                this.constructor === M && (0, g.unreachable)("Cannot initialize CompiledFont."), this.fontMatrix = k, this.compiledGlyphs = /* @__PURE__ */ Object.create(null), this.compiledCharCodeToGlyphId = /* @__PURE__ */ Object.create(null);
              }
              getPathJs(k) {
                const {
                  charCode: N,
                  glyphId: P
                } = O(this.cmap, k);
                let D = this.compiledGlyphs[P];
                if (!D)
                  try {
                    D = this.compileGlyph(this.glyphs[P], P), this.compiledGlyphs[P] = D;
                  } catch (H) {
                    throw this.compiledGlyphs[P] = F, this.compiledCharCodeToGlyphId[N] === void 0 && (this.compiledCharCodeToGlyphId[N] = P), H;
                  }
                return this.compiledCharCodeToGlyphId[N] === void 0 && (this.compiledCharCodeToGlyphId[N] = P), D;
              }
              compileGlyph(k, N) {
                if (!k || k.length === 0 || k[0] === 14)
                  return F;
                let P = this.fontMatrix;
                if (this.isCFFCIDFont) {
                  const H = this.fdSelect.getFDIndex(N);
                  H >= 0 && H < this.fdArray.length ? P = this.fdArray[H].getByName("FontMatrix") || g.FONT_IDENTITY_MATRIX : (0, g.warn)("Invalid fd index for glyph index.");
                }
                const D = [{
                  cmd: "save"
                }, {
                  cmd: "transform",
                  args: P.slice()
                }, {
                  cmd: "scale",
                  args: ["size", "-size"]
                }];
                return this.compileGlyphImpl(k, D, N), D.push({
                  cmd: "restore"
                }), D;
              }
              compileGlyphImpl() {
                (0, g.unreachable)("Children classes should implement this.");
              }
              hasBuiltPath(k) {
                const {
                  charCode: N,
                  glyphId: P
                } = O(this.cmap, k);
                return this.compiledGlyphs[P] !== void 0 && this.compiledCharCodeToGlyphId[N] !== void 0;
              }
            }
            class W extends M {
              constructor(k, N, P) {
                super(P || [488e-6, 0, 0, 488e-6, 0, 0]), this.glyphs = k, this.cmap = N;
              }
              compileGlyphImpl(k, N) {
                L(k, N, this);
              }
            }
            class j extends M {
              constructor(k, N, P, D) {
                super(P || [1e-3, 0, 0, 1e-3, 0, 0]), this.glyphs = k.glyphs, this.gsubrs = k.gsubrs || [], this.subrs = k.subrs || [], this.cmap = N, this.glyphNameMap = D || (0, y.getGlyphsUnicode)(), this.gsubrsBias = I(this.gsubrs), this.subrsBias = I(this.subrs), this.isCFFCIDFont = k.isCFFCIDFont, this.fdSelect = k.fdSelect, this.fdArray = k.fdArray;
              }
              compileGlyphImpl(k, N, P) {
                B(k, N, this, P);
              }
            }
            class G {
              static create(k, N) {
                const P = new Uint8Array(k.data);
                let D, H, V, Z, ne, K;
                const q = w(P, 4);
                for (let Y = 0, ee = 12; Y < q; Y++, ee += 16) {
                  const Q = (0, g.bytesToString)(P.subarray(ee, ee + 4)), J = C(P, ee + 8), te = C(P, ee + 12);
                  switch (Q) {
                    case "cmap":
                      D = _(P, J);
                      break;
                    case "glyf":
                      H = P.subarray(J, J + te);
                      break;
                    case "loca":
                      V = P.subarray(J, J + te);
                      break;
                    case "head":
                      K = w(P, J + 18), ne = w(P, J + 50);
                      break;
                    case "CFF ":
                      Z = E(P, J, J + te, N);
                      break;
                  }
                }
                if (H) {
                  const Y = K ? [1 / K, 0, 0, 1 / K, 0, 0] : k.fontMatrix;
                  return new W(R(H, V, ne), D, Y);
                }
                return new j(Z, D, k.fontMatrix, k.glyphNameMap);
              }
            }
            A.FontRendererFactory = G;
          },
          /* 45 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.getMetrics = A.getFontBasicMetrics = void 0;
            var g = x(3);
            const b = (0, g.getLookupTableFactory)(function(f) {
              f.Courier = 600, f["Courier-Bold"] = 600, f["Courier-BoldOblique"] = 600, f["Courier-Oblique"] = 600, f.Helvetica = (0, g.getLookupTableFactory)(function(m) {
                m.space = 278, m.exclam = 278, m.quotedbl = 355, m.numbersign = 556, m.dollar = 556, m.percent = 889, m.ampersand = 667, m.quoteright = 222, m.parenleft = 333, m.parenright = 333, m.asterisk = 389, m.plus = 584, m.comma = 278, m.hyphen = 333, m.period = 278, m.slash = 278, m.zero = 556, m.one = 556, m.two = 556, m.three = 556, m.four = 556, m.five = 556, m.six = 556, m.seven = 556, m.eight = 556, m.nine = 556, m.colon = 278, m.semicolon = 278, m.less = 584, m.equal = 584, m.greater = 584, m.question = 556, m.at = 1015, m.A = 667, m.B = 667, m.C = 722, m.D = 722, m.E = 667, m.F = 611, m.G = 778, m.H = 722, m.I = 278, m.J = 500, m.K = 667, m.L = 556, m.M = 833, m.N = 722, m.O = 778, m.P = 667, m.Q = 778, m.R = 722, m.S = 667, m.T = 611, m.U = 722, m.V = 667, m.W = 944, m.X = 667, m.Y = 667, m.Z = 611, m.bracketleft = 278, m.backslash = 278, m.bracketright = 278, m.asciicircum = 469, m.underscore = 556, m.quoteleft = 222, m.a = 556, m.b = 556, m.c = 500, m.d = 556, m.e = 556, m.f = 278, m.g = 556, m.h = 556, m.i = 222, m.j = 222, m.k = 500, m.l = 222, m.m = 833, m.n = 556, m.o = 556, m.p = 556, m.q = 556, m.r = 333, m.s = 500, m.t = 278, m.u = 556, m.v = 500, m.w = 722, m.x = 500, m.y = 500, m.z = 500, m.braceleft = 334, m.bar = 260, m.braceright = 334, m.asciitilde = 584, m.exclamdown = 333, m.cent = 556, m.sterling = 556, m.fraction = 167, m.yen = 556, m.florin = 556, m.section = 556, m.currency = 556, m.quotesingle = 191, m.quotedblleft = 333, m.guillemotleft = 556, m.guilsinglleft = 333, m.guilsinglright = 333, m.fi = 500, m.fl = 500, m.endash = 556, m.dagger = 556, m.daggerdbl = 556, m.periodcentered = 278, m.paragraph = 537, m.bullet = 350, m.quotesinglbase = 222, m.quotedblbase = 333, m.quotedblright = 333, m.guillemotright = 556, m.ellipsis = 1e3, m.perthousand = 1e3, m.questiondown = 611, m.grave = 333, m.acute = 333, m.circumflex = 333, m.tilde = 333, m.macron = 333, m.breve = 333, m.dotaccent = 333, m.dieresis = 333, m.ring = 333, m.cedilla = 333, m.hungarumlaut = 333, m.ogonek = 333, m.caron = 333, m.emdash = 1e3, m.AE = 1e3, m.ordfeminine = 370, m.Lslash = 556, m.Oslash = 778, m.OE = 1e3, m.ordmasculine = 365, m.ae = 889, m.dotlessi = 278, m.lslash = 222, m.oslash = 611, m.oe = 944, m.germandbls = 611, m.Idieresis = 278, m.eacute = 556, m.abreve = 556, m.uhungarumlaut = 556, m.ecaron = 556, m.Ydieresis = 667, m.divide = 584, m.Yacute = 667, m.Acircumflex = 667, m.aacute = 556, m.Ucircumflex = 722, m.yacute = 500, m.scommaaccent = 500, m.ecircumflex = 556, m.Uring = 722, m.Udieresis = 722, m.aogonek = 556, m.Uacute = 722, m.uogonek = 556, m.Edieresis = 667, m.Dcroat = 722, m.commaaccent = 250, m.copyright = 737, m.Emacron = 667, m.ccaron = 500, m.aring = 556, m.Ncommaaccent = 722, m.lacute = 222, m.agrave = 556, m.Tcommaaccent = 611, m.Cacute = 722, m.atilde = 556, m.Edotaccent = 667, m.scaron = 500, m.scedilla = 500, m.iacute = 278, m.lozenge = 471, m.Rcaron = 722, m.Gcommaaccent = 778, m.ucircumflex = 556, m.acircumflex = 556, m.Amacron = 667, m.rcaron = 333, m.ccedilla = 500, m.Zdotaccent = 611, m.Thorn = 667, m.Omacron = 778, m.Racute = 722, m.Sacute = 667, m.dcaron = 643, m.Umacron = 722, m.uring = 556, m.threesuperior = 333, m.Ograve = 778, m.Agrave = 667, m.Abreve = 667, m.multiply = 584, m.uacute = 556, m.Tcaron = 611, m.partialdiff = 476, m.ydieresis = 500, m.Nacute = 722, m.icircumflex = 278, m.Ecircumflex = 667, m.adieresis = 556, m.edieresis = 556, m.cacute = 500, m.nacute = 556, m.umacron = 556, m.Ncaron = 722, m.Iacute = 278, m.plusminus = 584, m.brokenbar = 260, m.registered = 737, m.Gbreve = 778, m.Idotaccent = 278, m.summation = 600, m.Egrave = 667, m.racute = 333, m.omacron = 556, m.Zacute = 611, m.Zcaron = 611, m.greaterequal = 549, m.Eth = 722, m.Ccedilla = 722, m.lcommaaccent = 222, m.tcaron = 317, m.eogonek = 556, m.Uogonek = 722, m.Aacute = 667, m.Adieresis = 667, m.egrave = 556, m.zacute = 500, m.iogonek = 222, m.Oacute = 778, m.oacute = 556, m.amacron = 556, m.sacute = 500, m.idieresis = 278, m.Ocircumflex = 778, m.Ugrave = 722, m.Delta = 612, m.thorn = 556, m.twosuperior = 333, m.Odieresis = 778, m.mu = 556, m.igrave = 278, m.ohungarumlaut = 556, m.Eogonek = 667, m.dcroat = 556, m.threequarters = 834, m.Scedilla = 667, m.lcaron = 299, m.Kcommaaccent = 667, m.Lacute = 556, m.trademark = 1e3, m.edotaccent = 556, m.Igrave = 278, m.Imacron = 278, m.Lcaron = 556, m.onehalf = 834, m.lessequal = 549, m.ocircumflex = 556, m.ntilde = 556, m.Uhungarumlaut = 722, m.Eacute = 667, m.emacron = 556, m.gbreve = 556, m.onequarter = 834, m.Scaron = 667, m.Scommaaccent = 667, m.Ohungarumlaut = 778, m.degree = 400, m.ograve = 556, m.Ccaron = 722, m.ugrave = 556, m.radical = 453, m.Dcaron = 722, m.rcommaaccent = 333, m.Ntilde = 722, m.otilde = 556, m.Rcommaaccent = 722, m.Lcommaaccent = 556, m.Atilde = 667, m.Aogonek = 667, m.Aring = 667, m.Otilde = 778, m.zdotaccent = 500, m.Ecaron = 667, m.Iogonek = 278, m.kcommaaccent = 500, m.minus = 584, m.Icircumflex = 278, m.ncaron = 556, m.tcommaaccent = 278, m.logicalnot = 584, m.odieresis = 556, m.udieresis = 556, m.notequal = 549, m.gcommaaccent = 556, m.eth = 556, m.zcaron = 500, m.ncommaaccent = 556, m.onesuperior = 333, m.imacron = 278, m.Euro = 556;
              }), f["Helvetica-Bold"] = (0, g.getLookupTableFactory)(function(m) {
                m.space = 278, m.exclam = 333, m.quotedbl = 474, m.numbersign = 556, m.dollar = 556, m.percent = 889, m.ampersand = 722, m.quoteright = 278, m.parenleft = 333, m.parenright = 333, m.asterisk = 389, m.plus = 584, m.comma = 278, m.hyphen = 333, m.period = 278, m.slash = 278, m.zero = 556, m.one = 556, m.two = 556, m.three = 556, m.four = 556, m.five = 556, m.six = 556, m.seven = 556, m.eight = 556, m.nine = 556, m.colon = 333, m.semicolon = 333, m.less = 584, m.equal = 584, m.greater = 584, m.question = 611, m.at = 975, m.A = 722, m.B = 722, m.C = 722, m.D = 722, m.E = 667, m.F = 611, m.G = 778, m.H = 722, m.I = 278, m.J = 556, m.K = 722, m.L = 611, m.M = 833, m.N = 722, m.O = 778, m.P = 667, m.Q = 778, m.R = 722, m.S = 667, m.T = 611, m.U = 722, m.V = 667, m.W = 944, m.X = 667, m.Y = 667, m.Z = 611, m.bracketleft = 333, m.backslash = 278, m.bracketright = 333, m.asciicircum = 584, m.underscore = 556, m.quoteleft = 278, m.a = 556, m.b = 611, m.c = 556, m.d = 611, m.e = 556, m.f = 333, m.g = 611, m.h = 611, m.i = 278, m.j = 278, m.k = 556, m.l = 278, m.m = 889, m.n = 611, m.o = 611, m.p = 611, m.q = 611, m.r = 389, m.s = 556, m.t = 333, m.u = 611, m.v = 556, m.w = 778, m.x = 556, m.y = 556, m.z = 500, m.braceleft = 389, m.bar = 280, m.braceright = 389, m.asciitilde = 584, m.exclamdown = 333, m.cent = 556, m.sterling = 556, m.fraction = 167, m.yen = 556, m.florin = 556, m.section = 556, m.currency = 556, m.quotesingle = 238, m.quotedblleft = 500, m.guillemotleft = 556, m.guilsinglleft = 333, m.guilsinglright = 333, m.fi = 611, m.fl = 611, m.endash = 556, m.dagger = 556, m.daggerdbl = 556, m.periodcentered = 278, m.paragraph = 556, m.bullet = 350, m.quotesinglbase = 278, m.quotedblbase = 500, m.quotedblright = 500, m.guillemotright = 556, m.ellipsis = 1e3, m.perthousand = 1e3, m.questiondown = 611, m.grave = 333, m.acute = 333, m.circumflex = 333, m.tilde = 333, m.macron = 333, m.breve = 333, m.dotaccent = 333, m.dieresis = 333, m.ring = 333, m.cedilla = 333, m.hungarumlaut = 333, m.ogonek = 333, m.caron = 333, m.emdash = 1e3, m.AE = 1e3, m.ordfeminine = 370, m.Lslash = 611, m.Oslash = 778, m.OE = 1e3, m.ordmasculine = 365, m.ae = 889, m.dotlessi = 278, m.lslash = 278, m.oslash = 611, m.oe = 944, m.germandbls = 611, m.Idieresis = 278, m.eacute = 556, m.abreve = 556, m.uhungarumlaut = 611, m.ecaron = 556, m.Ydieresis = 667, m.divide = 584, m.Yacute = 667, m.Acircumflex = 722, m.aacute = 556, m.Ucircumflex = 722, m.yacute = 556, m.scommaaccent = 556, m.ecircumflex = 556, m.Uring = 722, m.Udieresis = 722, m.aogonek = 556, m.Uacute = 722, m.uogonek = 611, m.Edieresis = 667, m.Dcroat = 722, m.commaaccent = 250, m.copyright = 737, m.Emacron = 667, m.ccaron = 556, m.aring = 556, m.Ncommaaccent = 722, m.lacute = 278, m.agrave = 556, m.Tcommaaccent = 611, m.Cacute = 722, m.atilde = 556, m.Edotaccent = 667, m.scaron = 556, m.scedilla = 556, m.iacute = 278, m.lozenge = 494, m.Rcaron = 722, m.Gcommaaccent = 778, m.ucircumflex = 611, m.acircumflex = 556, m.Amacron = 722, m.rcaron = 389, m.ccedilla = 556, m.Zdotaccent = 611, m.Thorn = 667, m.Omacron = 778, m.Racute = 722, m.Sacute = 667, m.dcaron = 743, m.Umacron = 722, m.uring = 611, m.threesuperior = 333, m.Ograve = 778, m.Agrave = 722, m.Abreve = 722, m.multiply = 584, m.uacute = 611, m.Tcaron = 611, m.partialdiff = 494, m.ydieresis = 556, m.Nacute = 722, m.icircumflex = 278, m.Ecircumflex = 667, m.adieresis = 556, m.edieresis = 556, m.cacute = 556, m.nacute = 611, m.umacron = 611, m.Ncaron = 722, m.Iacute = 278, m.plusminus = 584, m.brokenbar = 280, m.registered = 737, m.Gbreve = 778, m.Idotaccent = 278, m.summation = 600, m.Egrave = 667, m.racute = 389, m.omacron = 611, m.Zacute = 611, m.Zcaron = 611, m.greaterequal = 549, m.Eth = 722, m.Ccedilla = 722, m.lcommaaccent = 278, m.tcaron = 389, m.eogonek = 556, m.Uogonek = 722, m.Aacute = 722, m.Adieresis = 722, m.egrave = 556, m.zacute = 500, m.iogonek = 278, m.Oacute = 778, m.oacute = 611, m.amacron = 556, m.sacute = 556, m.idieresis = 278, m.Ocircumflex = 778, m.Ugrave = 722, m.Delta = 612, m.thorn = 611, m.twosuperior = 333, m.Odieresis = 778, m.mu = 611, m.igrave = 278, m.ohungarumlaut = 611, m.Eogonek = 667, m.dcroat = 611, m.threequarters = 834, m.Scedilla = 667, m.lcaron = 400, m.Kcommaaccent = 722, m.Lacute = 611, m.trademark = 1e3, m.edotaccent = 556, m.Igrave = 278, m.Imacron = 278, m.Lcaron = 611, m.onehalf = 834, m.lessequal = 549, m.ocircumflex = 611, m.ntilde = 611, m.Uhungarumlaut = 722, m.Eacute = 667, m.emacron = 556, m.gbreve = 611, m.onequarter = 834, m.Scaron = 667, m.Scommaaccent = 667, m.Ohungarumlaut = 778, m.degree = 400, m.ograve = 611, m.Ccaron = 722, m.ugrave = 611, m.radical = 549, m.Dcaron = 722, m.rcommaaccent = 389, m.Ntilde = 722, m.otilde = 611, m.Rcommaaccent = 722, m.Lcommaaccent = 611, m.Atilde = 722, m.Aogonek = 722, m.Aring = 722, m.Otilde = 778, m.zdotaccent = 500, m.Ecaron = 667, m.Iogonek = 278, m.kcommaaccent = 556, m.minus = 584, m.Icircumflex = 278, m.ncaron = 611, m.tcommaaccent = 333, m.logicalnot = 584, m.odieresis = 611, m.udieresis = 611, m.notequal = 549, m.gcommaaccent = 611, m.eth = 611, m.zcaron = 500, m.ncommaaccent = 611, m.onesuperior = 333, m.imacron = 278, m.Euro = 556;
              }), f["Helvetica-BoldOblique"] = (0, g.getLookupTableFactory)(function(m) {
                m.space = 278, m.exclam = 333, m.quotedbl = 474, m.numbersign = 556, m.dollar = 556, m.percent = 889, m.ampersand = 722, m.quoteright = 278, m.parenleft = 333, m.parenright = 333, m.asterisk = 389, m.plus = 584, m.comma = 278, m.hyphen = 333, m.period = 278, m.slash = 278, m.zero = 556, m.one = 556, m.two = 556, m.three = 556, m.four = 556, m.five = 556, m.six = 556, m.seven = 556, m.eight = 556, m.nine = 556, m.colon = 333, m.semicolon = 333, m.less = 584, m.equal = 584, m.greater = 584, m.question = 611, m.at = 975, m.A = 722, m.B = 722, m.C = 722, m.D = 722, m.E = 667, m.F = 611, m.G = 778, m.H = 722, m.I = 278, m.J = 556, m.K = 722, m.L = 611, m.M = 833, m.N = 722, m.O = 778, m.P = 667, m.Q = 778, m.R = 722, m.S = 667, m.T = 611, m.U = 722, m.V = 667, m.W = 944, m.X = 667, m.Y = 667, m.Z = 611, m.bracketleft = 333, m.backslash = 278, m.bracketright = 333, m.asciicircum = 584, m.underscore = 556, m.quoteleft = 278, m.a = 556, m.b = 611, m.c = 556, m.d = 611, m.e = 556, m.f = 333, m.g = 611, m.h = 611, m.i = 278, m.j = 278, m.k = 556, m.l = 278, m.m = 889, m.n = 611, m.o = 611, m.p = 611, m.q = 611, m.r = 389, m.s = 556, m.t = 333, m.u = 611, m.v = 556, m.w = 778, m.x = 556, m.y = 556, m.z = 500, m.braceleft = 389, m.bar = 280, m.braceright = 389, m.asciitilde = 584, m.exclamdown = 333, m.cent = 556, m.sterling = 556, m.fraction = 167, m.yen = 556, m.florin = 556, m.section = 556, m.currency = 556, m.quotesingle = 238, m.quotedblleft = 500, m.guillemotleft = 556, m.guilsinglleft = 333, m.guilsinglright = 333, m.fi = 611, m.fl = 611, m.endash = 556, m.dagger = 556, m.daggerdbl = 556, m.periodcentered = 278, m.paragraph = 556, m.bullet = 350, m.quotesinglbase = 278, m.quotedblbase = 500, m.quotedblright = 500, m.guillemotright = 556, m.ellipsis = 1e3, m.perthousand = 1e3, m.questiondown = 611, m.grave = 333, m.acute = 333, m.circumflex = 333, m.tilde = 333, m.macron = 333, m.breve = 333, m.dotaccent = 333, m.dieresis = 333, m.ring = 333, m.cedilla = 333, m.hungarumlaut = 333, m.ogonek = 333, m.caron = 333, m.emdash = 1e3, m.AE = 1e3, m.ordfeminine = 370, m.Lslash = 611, m.Oslash = 778, m.OE = 1e3, m.ordmasculine = 365, m.ae = 889, m.dotlessi = 278, m.lslash = 278, m.oslash = 611, m.oe = 944, m.germandbls = 611, m.Idieresis = 278, m.eacute = 556, m.abreve = 556, m.uhungarumlaut = 611, m.ecaron = 556, m.Ydieresis = 667, m.divide = 584, m.Yacute = 667, m.Acircumflex = 722, m.aacute = 556, m.Ucircumflex = 722, m.yacute = 556, m.scommaaccent = 556, m.ecircumflex = 556, m.Uring = 722, m.Udieresis = 722, m.aogonek = 556, m.Uacute = 722, m.uogonek = 611, m.Edieresis = 667, m.Dcroat = 722, m.commaaccent = 250, m.copyright = 737, m.Emacron = 667, m.ccaron = 556, m.aring = 556, m.Ncommaaccent = 722, m.lacute = 278, m.agrave = 556, m.Tcommaaccent = 611, m.Cacute = 722, m.atilde = 556, m.Edotaccent = 667, m.scaron = 556, m.scedilla = 556, m.iacute = 278, m.lozenge = 494, m.Rcaron = 722, m.Gcommaaccent = 778, m.ucircumflex = 611, m.acircumflex = 556, m.Amacron = 722, m.rcaron = 389, m.ccedilla = 556, m.Zdotaccent = 611, m.Thorn = 667, m.Omacron = 778, m.Racute = 722, m.Sacute = 667, m.dcaron = 743, m.Umacron = 722, m.uring = 611, m.threesuperior = 333, m.Ograve = 778, m.Agrave = 722, m.Abreve = 722, m.multiply = 584, m.uacute = 611, m.Tcaron = 611, m.partialdiff = 494, m.ydieresis = 556, m.Nacute = 722, m.icircumflex = 278, m.Ecircumflex = 667, m.adieresis = 556, m.edieresis = 556, m.cacute = 556, m.nacute = 611, m.umacron = 611, m.Ncaron = 722, m.Iacute = 278, m.plusminus = 584, m.brokenbar = 280, m.registered = 737, m.Gbreve = 778, m.Idotaccent = 278, m.summation = 600, m.Egrave = 667, m.racute = 389, m.omacron = 611, m.Zacute = 611, m.Zcaron = 611, m.greaterequal = 549, m.Eth = 722, m.Ccedilla = 722, m.lcommaaccent = 278, m.tcaron = 389, m.eogonek = 556, m.Uogonek = 722, m.Aacute = 722, m.Adieresis = 722, m.egrave = 556, m.zacute = 500, m.iogonek = 278, m.Oacute = 778, m.oacute = 611, m.amacron = 556, m.sacute = 556, m.idieresis = 278, m.Ocircumflex = 778, m.Ugrave = 722, m.Delta = 612, m.thorn = 611, m.twosuperior = 333, m.Odieresis = 778, m.mu = 611, m.igrave = 278, m.ohungarumlaut = 611, m.Eogonek = 667, m.dcroat = 611, m.threequarters = 834, m.Scedilla = 667, m.lcaron = 400, m.Kcommaaccent = 722, m.Lacute = 611, m.trademark = 1e3, m.edotaccent = 556, m.Igrave = 278, m.Imacron = 278, m.Lcaron = 611, m.onehalf = 834, m.lessequal = 549, m.ocircumflex = 611, m.ntilde = 611, m.Uhungarumlaut = 722, m.Eacute = 667, m.emacron = 556, m.gbreve = 611, m.onequarter = 834, m.Scaron = 667, m.Scommaaccent = 667, m.Ohungarumlaut = 778, m.degree = 400, m.ograve = 611, m.Ccaron = 722, m.ugrave = 611, m.radical = 549, m.Dcaron = 722, m.rcommaaccent = 389, m.Ntilde = 722, m.otilde = 611, m.Rcommaaccent = 722, m.Lcommaaccent = 611, m.Atilde = 722, m.Aogonek = 722, m.Aring = 722, m.Otilde = 778, m.zdotaccent = 500, m.Ecaron = 667, m.Iogonek = 278, m.kcommaaccent = 556, m.minus = 584, m.Icircumflex = 278, m.ncaron = 611, m.tcommaaccent = 333, m.logicalnot = 584, m.odieresis = 611, m.udieresis = 611, m.notequal = 549, m.gcommaaccent = 611, m.eth = 611, m.zcaron = 500, m.ncommaaccent = 611, m.onesuperior = 333, m.imacron = 278, m.Euro = 556;
              }), f["Helvetica-Oblique"] = (0, g.getLookupTableFactory)(function(m) {
                m.space = 278, m.exclam = 278, m.quotedbl = 355, m.numbersign = 556, m.dollar = 556, m.percent = 889, m.ampersand = 667, m.quoteright = 222, m.parenleft = 333, m.parenright = 333, m.asterisk = 389, m.plus = 584, m.comma = 278, m.hyphen = 333, m.period = 278, m.slash = 278, m.zero = 556, m.one = 556, m.two = 556, m.three = 556, m.four = 556, m.five = 556, m.six = 556, m.seven = 556, m.eight = 556, m.nine = 556, m.colon = 278, m.semicolon = 278, m.less = 584, m.equal = 584, m.greater = 584, m.question = 556, m.at = 1015, m.A = 667, m.B = 667, m.C = 722, m.D = 722, m.E = 667, m.F = 611, m.G = 778, m.H = 722, m.I = 278, m.J = 500, m.K = 667, m.L = 556, m.M = 833, m.N = 722, m.O = 778, m.P = 667, m.Q = 778, m.R = 722, m.S = 667, m.T = 611, m.U = 722, m.V = 667, m.W = 944, m.X = 667, m.Y = 667, m.Z = 611, m.bracketleft = 278, m.backslash = 278, m.bracketright = 278, m.asciicircum = 469, m.underscore = 556, m.quoteleft = 222, m.a = 556, m.b = 556, m.c = 500, m.d = 556, m.e = 556, m.f = 278, m.g = 556, m.h = 556, m.i = 222, m.j = 222, m.k = 500, m.l = 222, m.m = 833, m.n = 556, m.o = 556, m.p = 556, m.q = 556, m.r = 333, m.s = 500, m.t = 278, m.u = 556, m.v = 500, m.w = 722, m.x = 500, m.y = 500, m.z = 500, m.braceleft = 334, m.bar = 260, m.braceright = 334, m.asciitilde = 584, m.exclamdown = 333, m.cent = 556, m.sterling = 556, m.fraction = 167, m.yen = 556, m.florin = 556, m.section = 556, m.currency = 556, m.quotesingle = 191, m.quotedblleft = 333, m.guillemotleft = 556, m.guilsinglleft = 333, m.guilsinglright = 333, m.fi = 500, m.fl = 500, m.endash = 556, m.dagger = 556, m.daggerdbl = 556, m.periodcentered = 278, m.paragraph = 537, m.bullet = 350, m.quotesinglbase = 222, m.quotedblbase = 333, m.quotedblright = 333, m.guillemotright = 556, m.ellipsis = 1e3, m.perthousand = 1e3, m.questiondown = 611, m.grave = 333, m.acute = 333, m.circumflex = 333, m.tilde = 333, m.macron = 333, m.breve = 333, m.dotaccent = 333, m.dieresis = 333, m.ring = 333, m.cedilla = 333, m.hungarumlaut = 333, m.ogonek = 333, m.caron = 333, m.emdash = 1e3, m.AE = 1e3, m.ordfeminine = 370, m.Lslash = 556, m.Oslash = 778, m.OE = 1e3, m.ordmasculine = 365, m.ae = 889, m.dotlessi = 278, m.lslash = 222, m.oslash = 611, m.oe = 944, m.germandbls = 611, m.Idieresis = 278, m.eacute = 556, m.abreve = 556, m.uhungarumlaut = 556, m.ecaron = 556, m.Ydieresis = 667, m.divide = 584, m.Yacute = 667, m.Acircumflex = 667, m.aacute = 556, m.Ucircumflex = 722, m.yacute = 500, m.scommaaccent = 500, m.ecircumflex = 556, m.Uring = 722, m.Udieresis = 722, m.aogonek = 556, m.Uacute = 722, m.uogonek = 556, m.Edieresis = 667, m.Dcroat = 722, m.commaaccent = 250, m.copyright = 737, m.Emacron = 667, m.ccaron = 500, m.aring = 556, m.Ncommaaccent = 722, m.lacute = 222, m.agrave = 556, m.Tcommaaccent = 611, m.Cacute = 722, m.atilde = 556, m.Edotaccent = 667, m.scaron = 500, m.scedilla = 500, m.iacute = 278, m.lozenge = 471, m.Rcaron = 722, m.Gcommaaccent = 778, m.ucircumflex = 556, m.acircumflex = 556, m.Amacron = 667, m.rcaron = 333, m.ccedilla = 500, m.Zdotaccent = 611, m.Thorn = 667, m.Omacron = 778, m.Racute = 722, m.Sacute = 667, m.dcaron = 643, m.Umacron = 722, m.uring = 556, m.threesuperior = 333, m.Ograve = 778, m.Agrave = 667, m.Abreve = 667, m.multiply = 584, m.uacute = 556, m.Tcaron = 611, m.partialdiff = 476, m.ydieresis = 500, m.Nacute = 722, m.icircumflex = 278, m.Ecircumflex = 667, m.adieresis = 556, m.edieresis = 556, m.cacute = 500, m.nacute = 556, m.umacron = 556, m.Ncaron = 722, m.Iacute = 278, m.plusminus = 584, m.brokenbar = 260, m.registered = 737, m.Gbreve = 778, m.Idotaccent = 278, m.summation = 600, m.Egrave = 667, m.racute = 333, m.omacron = 556, m.Zacute = 611, m.Zcaron = 611, m.greaterequal = 549, m.Eth = 722, m.Ccedilla = 722, m.lcommaaccent = 222, m.tcaron = 317, m.eogonek = 556, m.Uogonek = 722, m.Aacute = 667, m.Adieresis = 667, m.egrave = 556, m.zacute = 500, m.iogonek = 222, m.Oacute = 778, m.oacute = 556, m.amacron = 556, m.sacute = 500, m.idieresis = 278, m.Ocircumflex = 778, m.Ugrave = 722, m.Delta = 612, m.thorn = 556, m.twosuperior = 333, m.Odieresis = 778, m.mu = 556, m.igrave = 278, m.ohungarumlaut = 556, m.Eogonek = 667, m.dcroat = 556, m.threequarters = 834, m.Scedilla = 667, m.lcaron = 299, m.Kcommaaccent = 667, m.Lacute = 556, m.trademark = 1e3, m.edotaccent = 556, m.Igrave = 278, m.Imacron = 278, m.Lcaron = 556, m.onehalf = 834, m.lessequal = 549, m.ocircumflex = 556, m.ntilde = 556, m.Uhungarumlaut = 722, m.Eacute = 667, m.emacron = 556, m.gbreve = 556, m.onequarter = 834, m.Scaron = 667, m.Scommaaccent = 667, m.Ohungarumlaut = 778, m.degree = 400, m.ograve = 556, m.Ccaron = 722, m.ugrave = 556, m.radical = 453, m.Dcaron = 722, m.rcommaaccent = 333, m.Ntilde = 722, m.otilde = 556, m.Rcommaaccent = 722, m.Lcommaaccent = 556, m.Atilde = 667, m.Aogonek = 667, m.Aring = 667, m.Otilde = 778, m.zdotaccent = 500, m.Ecaron = 667, m.Iogonek = 278, m.kcommaaccent = 500, m.minus = 584, m.Icircumflex = 278, m.ncaron = 556, m.tcommaaccent = 278, m.logicalnot = 584, m.odieresis = 556, m.udieresis = 556, m.notequal = 549, m.gcommaaccent = 556, m.eth = 556, m.zcaron = 500, m.ncommaaccent = 556, m.onesuperior = 333, m.imacron = 278, m.Euro = 556;
              }), f.Symbol = (0, g.getLookupTableFactory)(function(m) {
                m.space = 250, m.exclam = 333, m.universal = 713, m.numbersign = 500, m.existential = 549, m.percent = 833, m.ampersand = 778, m.suchthat = 439, m.parenleft = 333, m.parenright = 333, m.asteriskmath = 500, m.plus = 549, m.comma = 250, m.minus = 549, m.period = 250, m.slash = 278, m.zero = 500, m.one = 500, m.two = 500, m.three = 500, m.four = 500, m.five = 500, m.six = 500, m.seven = 500, m.eight = 500, m.nine = 500, m.colon = 278, m.semicolon = 278, m.less = 549, m.equal = 549, m.greater = 549, m.question = 444, m.congruent = 549, m.Alpha = 722, m.Beta = 667, m.Chi = 722, m.Delta = 612, m.Epsilon = 611, m.Phi = 763, m.Gamma = 603, m.Eta = 722, m.Iota = 333, m.theta1 = 631, m.Kappa = 722, m.Lambda = 686, m.Mu = 889, m.Nu = 722, m.Omicron = 722, m.Pi = 768, m.Theta = 741, m.Rho = 556, m.Sigma = 592, m.Tau = 611, m.Upsilon = 690, m.sigma1 = 439, m.Omega = 768, m.Xi = 645, m.Psi = 795, m.Zeta = 611, m.bracketleft = 333, m.therefore = 863, m.bracketright = 333, m.perpendicular = 658, m.underscore = 500, m.radicalex = 500, m.alpha = 631, m.beta = 549, m.chi = 549, m.delta = 494, m.epsilon = 439, m.phi = 521, m.gamma = 411, m.eta = 603, m.iota = 329, m.phi1 = 603, m.kappa = 549, m.lambda = 549, m.mu = 576, m.nu = 521, m.omicron = 549, m.pi = 549, m.theta = 521, m.rho = 549, m.sigma = 603, m.tau = 439, m.upsilon = 576, m.omega1 = 713, m.omega = 686, m.xi = 493, m.psi = 686, m.zeta = 494, m.braceleft = 480, m.bar = 200, m.braceright = 480, m.similar = 549, m.Euro = 750, m.Upsilon1 = 620, m.minute = 247, m.lessequal = 549, m.fraction = 167, m.infinity = 713, m.florin = 500, m.club = 753, m.diamond = 753, m.heart = 753, m.spade = 753, m.arrowboth = 1042, m.arrowleft = 987, m.arrowup = 603, m.arrowright = 987, m.arrowdown = 603, m.degree = 400, m.plusminus = 549, m.second = 411, m.greaterequal = 549, m.multiply = 549, m.proportional = 713, m.partialdiff = 494, m.bullet = 460, m.divide = 549, m.notequal = 549, m.equivalence = 549, m.approxequal = 549, m.ellipsis = 1e3, m.arrowvertex = 603, m.arrowhorizex = 1e3, m.carriagereturn = 658, m.aleph = 823, m.Ifraktur = 686, m.Rfraktur = 795, m.weierstrass = 987, m.circlemultiply = 768, m.circleplus = 768, m.emptyset = 823, m.intersection = 768, m.union = 768, m.propersuperset = 713, m.reflexsuperset = 713, m.notsubset = 713, m.propersubset = 713, m.reflexsubset = 713, m.element = 713, m.notelement = 713, m.angle = 768, m.gradient = 713, m.registerserif = 790, m.copyrightserif = 790, m.trademarkserif = 890, m.product = 823, m.radical = 549, m.dotmath = 250, m.logicalnot = 713, m.logicaland = 603, m.logicalor = 603, m.arrowdblboth = 1042, m.arrowdblleft = 987, m.arrowdblup = 603, m.arrowdblright = 987, m.arrowdbldown = 603, m.lozenge = 494, m.angleleft = 329, m.registersans = 790, m.copyrightsans = 790, m.trademarksans = 786, m.summation = 713, m.parenlefttp = 384, m.parenleftex = 384, m.parenleftbt = 384, m.bracketlefttp = 384, m.bracketleftex = 384, m.bracketleftbt = 384, m.bracelefttp = 494, m.braceleftmid = 494, m.braceleftbt = 494, m.braceex = 494, m.angleright = 329, m.integral = 274, m.integraltp = 686, m.integralex = 686, m.integralbt = 686, m.parenrighttp = 384, m.parenrightex = 384, m.parenrightbt = 384, m.bracketrighttp = 384, m.bracketrightex = 384, m.bracketrightbt = 384, m.bracerighttp = 494, m.bracerightmid = 494, m.bracerightbt = 494, m.apple = 790;
              }), f["Times-Roman"] = (0, g.getLookupTableFactory)(function(m) {
                m.space = 250, m.exclam = 333, m.quotedbl = 408, m.numbersign = 500, m.dollar = 500, m.percent = 833, m.ampersand = 778, m.quoteright = 333, m.parenleft = 333, m.parenright = 333, m.asterisk = 500, m.plus = 564, m.comma = 250, m.hyphen = 333, m.period = 250, m.slash = 278, m.zero = 500, m.one = 500, m.two = 500, m.three = 500, m.four = 500, m.five = 500, m.six = 500, m.seven = 500, m.eight = 500, m.nine = 500, m.colon = 278, m.semicolon = 278, m.less = 564, m.equal = 564, m.greater = 564, m.question = 444, m.at = 921, m.A = 722, m.B = 667, m.C = 667, m.D = 722, m.E = 611, m.F = 556, m.G = 722, m.H = 722, m.I = 333, m.J = 389, m.K = 722, m.L = 611, m.M = 889, m.N = 722, m.O = 722, m.P = 556, m.Q = 722, m.R = 667, m.S = 556, m.T = 611, m.U = 722, m.V = 722, m.W = 944, m.X = 722, m.Y = 722, m.Z = 611, m.bracketleft = 333, m.backslash = 278, m.bracketright = 333, m.asciicircum = 469, m.underscore = 500, m.quoteleft = 333, m.a = 444, m.b = 500, m.c = 444, m.d = 500, m.e = 444, m.f = 333, m.g = 500, m.h = 500, m.i = 278, m.j = 278, m.k = 500, m.l = 278, m.m = 778, m.n = 500, m.o = 500, m.p = 500, m.q = 500, m.r = 333, m.s = 389, m.t = 278, m.u = 500, m.v = 500, m.w = 722, m.x = 500, m.y = 500, m.z = 444, m.braceleft = 480, m.bar = 200, m.braceright = 480, m.asciitilde = 541, m.exclamdown = 333, m.cent = 500, m.sterling = 500, m.fraction = 167, m.yen = 500, m.florin = 500, m.section = 500, m.currency = 500, m.quotesingle = 180, m.quotedblleft = 444, m.guillemotleft = 500, m.guilsinglleft = 333, m.guilsinglright = 333, m.fi = 556, m.fl = 556, m.endash = 500, m.dagger = 500, m.daggerdbl = 500, m.periodcentered = 250, m.paragraph = 453, m.bullet = 350, m.quotesinglbase = 333, m.quotedblbase = 444, m.quotedblright = 444, m.guillemotright = 500, m.ellipsis = 1e3, m.perthousand = 1e3, m.questiondown = 444, m.grave = 333, m.acute = 333, m.circumflex = 333, m.tilde = 333, m.macron = 333, m.breve = 333, m.dotaccent = 333, m.dieresis = 333, m.ring = 333, m.cedilla = 333, m.hungarumlaut = 333, m.ogonek = 333, m.caron = 333, m.emdash = 1e3, m.AE = 889, m.ordfeminine = 276, m.Lslash = 611, m.Oslash = 722, m.OE = 889, m.ordmasculine = 310, m.ae = 667, m.dotlessi = 278, m.lslash = 278, m.oslash = 500, m.oe = 722, m.germandbls = 500, m.Idieresis = 333, m.eacute = 444, m.abreve = 444, m.uhungarumlaut = 500, m.ecaron = 444, m.Ydieresis = 722, m.divide = 564, m.Yacute = 722, m.Acircumflex = 722, m.aacute = 444, m.Ucircumflex = 722, m.yacute = 500, m.scommaaccent = 389, m.ecircumflex = 444, m.Uring = 722, m.Udieresis = 722, m.aogonek = 444, m.Uacute = 722, m.uogonek = 500, m.Edieresis = 611, m.Dcroat = 722, m.commaaccent = 250, m.copyright = 760, m.Emacron = 611, m.ccaron = 444, m.aring = 444, m.Ncommaaccent = 722, m.lacute = 278, m.agrave = 444, m.Tcommaaccent = 611, m.Cacute = 667, m.atilde = 444, m.Edotaccent = 611, m.scaron = 389, m.scedilla = 389, m.iacute = 278, m.lozenge = 471, m.Rcaron = 667, m.Gcommaaccent = 722, m.ucircumflex = 500, m.acircumflex = 444, m.Amacron = 722, m.rcaron = 333, m.ccedilla = 444, m.Zdotaccent = 611, m.Thorn = 556, m.Omacron = 722, m.Racute = 667, m.Sacute = 556, m.dcaron = 588, m.Umacron = 722, m.uring = 500, m.threesuperior = 300, m.Ograve = 722, m.Agrave = 722, m.Abreve = 722, m.multiply = 564, m.uacute = 500, m.Tcaron = 611, m.partialdiff = 476, m.ydieresis = 500, m.Nacute = 722, m.icircumflex = 278, m.Ecircumflex = 611, m.adieresis = 444, m.edieresis = 444, m.cacute = 444, m.nacute = 500, m.umacron = 500, m.Ncaron = 722, m.Iacute = 333, m.plusminus = 564, m.brokenbar = 200, m.registered = 760, m.Gbreve = 722, m.Idotaccent = 333, m.summation = 600, m.Egrave = 611, m.racute = 333, m.omacron = 500, m.Zacute = 611, m.Zcaron = 611, m.greaterequal = 549, m.Eth = 722, m.Ccedilla = 667, m.lcommaaccent = 278, m.tcaron = 326, m.eogonek = 444, m.Uogonek = 722, m.Aacute = 722, m.Adieresis = 722, m.egrave = 444, m.zacute = 444, m.iogonek = 278, m.Oacute = 722, m.oacute = 500, m.amacron = 444, m.sacute = 389, m.idieresis = 278, m.Ocircumflex = 722, m.Ugrave = 722, m.Delta = 612, m.thorn = 500, m.twosuperior = 300, m.Odieresis = 722, m.mu = 500, m.igrave = 278, m.ohungarumlaut = 500, m.Eogonek = 611, m.dcroat = 500, m.threequarters = 750, m.Scedilla = 556, m.lcaron = 344, m.Kcommaaccent = 722, m.Lacute = 611, m.trademark = 980, m.edotaccent = 444, m.Igrave = 333, m.Imacron = 333, m.Lcaron = 611, m.onehalf = 750, m.lessequal = 549, m.ocircumflex = 500, m.ntilde = 500, m.Uhungarumlaut = 722, m.Eacute = 611, m.emacron = 444, m.gbreve = 500, m.onequarter = 750, m.Scaron = 556, m.Scommaaccent = 556, m.Ohungarumlaut = 722, m.degree = 400, m.ograve = 500, m.Ccaron = 667, m.ugrave = 500, m.radical = 453, m.Dcaron = 722, m.rcommaaccent = 333, m.Ntilde = 722, m.otilde = 500, m.Rcommaaccent = 667, m.Lcommaaccent = 611, m.Atilde = 722, m.Aogonek = 722, m.Aring = 722, m.Otilde = 722, m.zdotaccent = 444, m.Ecaron = 611, m.Iogonek = 333, m.kcommaaccent = 500, m.minus = 564, m.Icircumflex = 333, m.ncaron = 500, m.tcommaaccent = 278, m.logicalnot = 564, m.odieresis = 500, m.udieresis = 500, m.notequal = 549, m.gcommaaccent = 500, m.eth = 500, m.zcaron = 444, m.ncommaaccent = 500, m.onesuperior = 300, m.imacron = 278, m.Euro = 500;
              }), f["Times-Bold"] = (0, g.getLookupTableFactory)(function(m) {
                m.space = 250, m.exclam = 333, m.quotedbl = 555, m.numbersign = 500, m.dollar = 500, m.percent = 1e3, m.ampersand = 833, m.quoteright = 333, m.parenleft = 333, m.parenright = 333, m.asterisk = 500, m.plus = 570, m.comma = 250, m.hyphen = 333, m.period = 250, m.slash = 278, m.zero = 500, m.one = 500, m.two = 500, m.three = 500, m.four = 500, m.five = 500, m.six = 500, m.seven = 500, m.eight = 500, m.nine = 500, m.colon = 333, m.semicolon = 333, m.less = 570, m.equal = 570, m.greater = 570, m.question = 500, m.at = 930, m.A = 722, m.B = 667, m.C = 722, m.D = 722, m.E = 667, m.F = 611, m.G = 778, m.H = 778, m.I = 389, m.J = 500, m.K = 778, m.L = 667, m.M = 944, m.N = 722, m.O = 778, m.P = 611, m.Q = 778, m.R = 722, m.S = 556, m.T = 667, m.U = 722, m.V = 722, m.W = 1e3, m.X = 722, m.Y = 722, m.Z = 667, m.bracketleft = 333, m.backslash = 278, m.bracketright = 333, m.asciicircum = 581, m.underscore = 500, m.quoteleft = 333, m.a = 500, m.b = 556, m.c = 444, m.d = 556, m.e = 444, m.f = 333, m.g = 500, m.h = 556, m.i = 278, m.j = 333, m.k = 556, m.l = 278, m.m = 833, m.n = 556, m.o = 500, m.p = 556, m.q = 556, m.r = 444, m.s = 389, m.t = 333, m.u = 556, m.v = 500, m.w = 722, m.x = 500, m.y = 500, m.z = 444, m.braceleft = 394, m.bar = 220, m.braceright = 394, m.asciitilde = 520, m.exclamdown = 333, m.cent = 500, m.sterling = 500, m.fraction = 167, m.yen = 500, m.florin = 500, m.section = 500, m.currency = 500, m.quotesingle = 278, m.quotedblleft = 500, m.guillemotleft = 500, m.guilsinglleft = 333, m.guilsinglright = 333, m.fi = 556, m.fl = 556, m.endash = 500, m.dagger = 500, m.daggerdbl = 500, m.periodcentered = 250, m.paragraph = 540, m.bullet = 350, m.quotesinglbase = 333, m.quotedblbase = 500, m.quotedblright = 500, m.guillemotright = 500, m.ellipsis = 1e3, m.perthousand = 1e3, m.questiondown = 500, m.grave = 333, m.acute = 333, m.circumflex = 333, m.tilde = 333, m.macron = 333, m.breve = 333, m.dotaccent = 333, m.dieresis = 333, m.ring = 333, m.cedilla = 333, m.hungarumlaut = 333, m.ogonek = 333, m.caron = 333, m.emdash = 1e3, m.AE = 1e3, m.ordfeminine = 300, m.Lslash = 667, m.Oslash = 778, m.OE = 1e3, m.ordmasculine = 330, m.ae = 722, m.dotlessi = 278, m.lslash = 278, m.oslash = 500, m.oe = 722, m.germandbls = 556, m.Idieresis = 389, m.eacute = 444, m.abreve = 500, m.uhungarumlaut = 556, m.ecaron = 444, m.Ydieresis = 722, m.divide = 570, m.Yacute = 722, m.Acircumflex = 722, m.aacute = 500, m.Ucircumflex = 722, m.yacute = 500, m.scommaaccent = 389, m.ecircumflex = 444, m.Uring = 722, m.Udieresis = 722, m.aogonek = 500, m.Uacute = 722, m.uogonek = 556, m.Edieresis = 667, m.Dcroat = 722, m.commaaccent = 250, m.copyright = 747, m.Emacron = 667, m.ccaron = 444, m.aring = 500, m.Ncommaaccent = 722, m.lacute = 278, m.agrave = 500, m.Tcommaaccent = 667, m.Cacute = 722, m.atilde = 500, m.Edotaccent = 667, m.scaron = 389, m.scedilla = 389, m.iacute = 278, m.lozenge = 494, m.Rcaron = 722, m.Gcommaaccent = 778, m.ucircumflex = 556, m.acircumflex = 500, m.Amacron = 722, m.rcaron = 444, m.ccedilla = 444, m.Zdotaccent = 667, m.Thorn = 611, m.Omacron = 778, m.Racute = 722, m.Sacute = 556, m.dcaron = 672, m.Umacron = 722, m.uring = 556, m.threesuperior = 300, m.Ograve = 778, m.Agrave = 722, m.Abreve = 722, m.multiply = 570, m.uacute = 556, m.Tcaron = 667, m.partialdiff = 494, m.ydieresis = 500, m.Nacute = 722, m.icircumflex = 278, m.Ecircumflex = 667, m.adieresis = 500, m.edieresis = 444, m.cacute = 444, m.nacute = 556, m.umacron = 556, m.Ncaron = 722, m.Iacute = 389, m.plusminus = 570, m.brokenbar = 220, m.registered = 747, m.Gbreve = 778, m.Idotaccent = 389, m.summation = 600, m.Egrave = 667, m.racute = 444, m.omacron = 500, m.Zacute = 667, m.Zcaron = 667, m.greaterequal = 549, m.Eth = 722, m.Ccedilla = 722, m.lcommaaccent = 278, m.tcaron = 416, m.eogonek = 444, m.Uogonek = 722, m.Aacute = 722, m.Adieresis = 722, m.egrave = 444, m.zacute = 444, m.iogonek = 278, m.Oacute = 778, m.oacute = 500, m.amacron = 500, m.sacute = 389, m.idieresis = 278, m.Ocircumflex = 778, m.Ugrave = 722, m.Delta = 612, m.thorn = 556, m.twosuperior = 300, m.Odieresis = 778, m.mu = 556, m.igrave = 278, m.ohungarumlaut = 500, m.Eogonek = 667, m.dcroat = 556, m.threequarters = 750, m.Scedilla = 556, m.lcaron = 394, m.Kcommaaccent = 778, m.Lacute = 667, m.trademark = 1e3, m.edotaccent = 444, m.Igrave = 389, m.Imacron = 389, m.Lcaron = 667, m.onehalf = 750, m.lessequal = 549, m.ocircumflex = 500, m.ntilde = 556, m.Uhungarumlaut = 722, m.Eacute = 667, m.emacron = 444, m.gbreve = 500, m.onequarter = 750, m.Scaron = 556, m.Scommaaccent = 556, m.Ohungarumlaut = 778, m.degree = 400, m.ograve = 500, m.Ccaron = 722, m.ugrave = 556, m.radical = 549, m.Dcaron = 722, m.rcommaaccent = 444, m.Ntilde = 722, m.otilde = 500, m.Rcommaaccent = 722, m.Lcommaaccent = 667, m.Atilde = 722, m.Aogonek = 722, m.Aring = 722, m.Otilde = 778, m.zdotaccent = 444, m.Ecaron = 667, m.Iogonek = 389, m.kcommaaccent = 556, m.minus = 570, m.Icircumflex = 389, m.ncaron = 556, m.tcommaaccent = 333, m.logicalnot = 570, m.odieresis = 500, m.udieresis = 556, m.notequal = 549, m.gcommaaccent = 500, m.eth = 500, m.zcaron = 444, m.ncommaaccent = 556, m.onesuperior = 300, m.imacron = 278, m.Euro = 500;
              }), f["Times-BoldItalic"] = (0, g.getLookupTableFactory)(function(m) {
                m.space = 250, m.exclam = 389, m.quotedbl = 555, m.numbersign = 500, m.dollar = 500, m.percent = 833, m.ampersand = 778, m.quoteright = 333, m.parenleft = 333, m.parenright = 333, m.asterisk = 500, m.plus = 570, m.comma = 250, m.hyphen = 333, m.period = 250, m.slash = 278, m.zero = 500, m.one = 500, m.two = 500, m.three = 500, m.four = 500, m.five = 500, m.six = 500, m.seven = 500, m.eight = 500, m.nine = 500, m.colon = 333, m.semicolon = 333, m.less = 570, m.equal = 570, m.greater = 570, m.question = 500, m.at = 832, m.A = 667, m.B = 667, m.C = 667, m.D = 722, m.E = 667, m.F = 667, m.G = 722, m.H = 778, m.I = 389, m.J = 500, m.K = 667, m.L = 611, m.M = 889, m.N = 722, m.O = 722, m.P = 611, m.Q = 722, m.R = 667, m.S = 556, m.T = 611, m.U = 722, m.V = 667, m.W = 889, m.X = 667, m.Y = 611, m.Z = 611, m.bracketleft = 333, m.backslash = 278, m.bracketright = 333, m.asciicircum = 570, m.underscore = 500, m.quoteleft = 333, m.a = 500, m.b = 500, m.c = 444, m.d = 500, m.e = 444, m.f = 333, m.g = 500, m.h = 556, m.i = 278, m.j = 278, m.k = 500, m.l = 278, m.m = 778, m.n = 556, m.o = 500, m.p = 500, m.q = 500, m.r = 389, m.s = 389, m.t = 278, m.u = 556, m.v = 444, m.w = 667, m.x = 500, m.y = 444, m.z = 389, m.braceleft = 348, m.bar = 220, m.braceright = 348, m.asciitilde = 570, m.exclamdown = 389, m.cent = 500, m.sterling = 500, m.fraction = 167, m.yen = 500, m.florin = 500, m.section = 500, m.currency = 500, m.quotesingle = 278, m.quotedblleft = 500, m.guillemotleft = 500, m.guilsinglleft = 333, m.guilsinglright = 333, m.fi = 556, m.fl = 556, m.endash = 500, m.dagger = 500, m.daggerdbl = 500, m.periodcentered = 250, m.paragraph = 500, m.bullet = 350, m.quotesinglbase = 333, m.quotedblbase = 500, m.quotedblright = 500, m.guillemotright = 500, m.ellipsis = 1e3, m.perthousand = 1e3, m.questiondown = 500, m.grave = 333, m.acute = 333, m.circumflex = 333, m.tilde = 333, m.macron = 333, m.breve = 333, m.dotaccent = 333, m.dieresis = 333, m.ring = 333, m.cedilla = 333, m.hungarumlaut = 333, m.ogonek = 333, m.caron = 333, m.emdash = 1e3, m.AE = 944, m.ordfeminine = 266, m.Lslash = 611, m.Oslash = 722, m.OE = 944, m.ordmasculine = 300, m.ae = 722, m.dotlessi = 278, m.lslash = 278, m.oslash = 500, m.oe = 722, m.germandbls = 500, m.Idieresis = 389, m.eacute = 444, m.abreve = 500, m.uhungarumlaut = 556, m.ecaron = 444, m.Ydieresis = 611, m.divide = 570, m.Yacute = 611, m.Acircumflex = 667, m.aacute = 500, m.Ucircumflex = 722, m.yacute = 444, m.scommaaccent = 389, m.ecircumflex = 444, m.Uring = 722, m.Udieresis = 722, m.aogonek = 500, m.Uacute = 722, m.uogonek = 556, m.Edieresis = 667, m.Dcroat = 722, m.commaaccent = 250, m.copyright = 747, m.Emacron = 667, m.ccaron = 444, m.aring = 500, m.Ncommaaccent = 722, m.lacute = 278, m.agrave = 500, m.Tcommaaccent = 611, m.Cacute = 667, m.atilde = 500, m.Edotaccent = 667, m.scaron = 389, m.scedilla = 389, m.iacute = 278, m.lozenge = 494, m.Rcaron = 667, m.Gcommaaccent = 722, m.ucircumflex = 556, m.acircumflex = 500, m.Amacron = 667, m.rcaron = 389, m.ccedilla = 444, m.Zdotaccent = 611, m.Thorn = 611, m.Omacron = 722, m.Racute = 667, m.Sacute = 556, m.dcaron = 608, m.Umacron = 722, m.uring = 556, m.threesuperior = 300, m.Ograve = 722, m.Agrave = 667, m.Abreve = 667, m.multiply = 570, m.uacute = 556, m.Tcaron = 611, m.partialdiff = 494, m.ydieresis = 444, m.Nacute = 722, m.icircumflex = 278, m.Ecircumflex = 667, m.adieresis = 500, m.edieresis = 444, m.cacute = 444, m.nacute = 556, m.umacron = 556, m.Ncaron = 722, m.Iacute = 389, m.plusminus = 570, m.brokenbar = 220, m.registered = 747, m.Gbreve = 722, m.Idotaccent = 389, m.summation = 600, m.Egrave = 667, m.racute = 389, m.omacron = 500, m.Zacute = 611, m.Zcaron = 611, m.greaterequal = 549, m.Eth = 722, m.Ccedilla = 667, m.lcommaaccent = 278, m.tcaron = 366, m.eogonek = 444, m.Uogonek = 722, m.Aacute = 667, m.Adieresis = 667, m.egrave = 444, m.zacute = 389, m.iogonek = 278, m.Oacute = 722, m.oacute = 500, m.amacron = 500, m.sacute = 389, m.idieresis = 278, m.Ocircumflex = 722, m.Ugrave = 722, m.Delta = 612, m.thorn = 500, m.twosuperior = 300, m.Odieresis = 722, m.mu = 576, m.igrave = 278, m.ohungarumlaut = 500, m.Eogonek = 667, m.dcroat = 500, m.threequarters = 750, m.Scedilla = 556, m.lcaron = 382, m.Kcommaaccent = 667, m.Lacute = 611, m.trademark = 1e3, m.edotaccent = 444, m.Igrave = 389, m.Imacron = 389, m.Lcaron = 611, m.onehalf = 750, m.lessequal = 549, m.ocircumflex = 500, m.ntilde = 556, m.Uhungarumlaut = 722, m.Eacute = 667, m.emacron = 444, m.gbreve = 500, m.onequarter = 750, m.Scaron = 556, m.Scommaaccent = 556, m.Ohungarumlaut = 722, m.degree = 400, m.ograve = 500, m.Ccaron = 667, m.ugrave = 556, m.radical = 549, m.Dcaron = 722, m.rcommaaccent = 389, m.Ntilde = 722, m.otilde = 500, m.Rcommaaccent = 667, m.Lcommaaccent = 611, m.Atilde = 667, m.Aogonek = 667, m.Aring = 667, m.Otilde = 722, m.zdotaccent = 389, m.Ecaron = 667, m.Iogonek = 389, m.kcommaaccent = 500, m.minus = 606, m.Icircumflex = 389, m.ncaron = 556, m.tcommaaccent = 278, m.logicalnot = 606, m.odieresis = 500, m.udieresis = 556, m.notequal = 549, m.gcommaaccent = 500, m.eth = 500, m.zcaron = 389, m.ncommaaccent = 556, m.onesuperior = 300, m.imacron = 278, m.Euro = 500;
              }), f["Times-Italic"] = (0, g.getLookupTableFactory)(function(m) {
                m.space = 250, m.exclam = 333, m.quotedbl = 420, m.numbersign = 500, m.dollar = 500, m.percent = 833, m.ampersand = 778, m.quoteright = 333, m.parenleft = 333, m.parenright = 333, m.asterisk = 500, m.plus = 675, m.comma = 250, m.hyphen = 333, m.period = 250, m.slash = 278, m.zero = 500, m.one = 500, m.two = 500, m.three = 500, m.four = 500, m.five = 500, m.six = 500, m.seven = 500, m.eight = 500, m.nine = 500, m.colon = 333, m.semicolon = 333, m.less = 675, m.equal = 675, m.greater = 675, m.question = 500, m.at = 920, m.A = 611, m.B = 611, m.C = 667, m.D = 722, m.E = 611, m.F = 611, m.G = 722, m.H = 722, m.I = 333, m.J = 444, m.K = 667, m.L = 556, m.M = 833, m.N = 667, m.O = 722, m.P = 611, m.Q = 722, m.R = 611, m.S = 500, m.T = 556, m.U = 722, m.V = 611, m.W = 833, m.X = 611, m.Y = 556, m.Z = 556, m.bracketleft = 389, m.backslash = 278, m.bracketright = 389, m.asciicircum = 422, m.underscore = 500, m.quoteleft = 333, m.a = 500, m.b = 500, m.c = 444, m.d = 500, m.e = 444, m.f = 278, m.g = 500, m.h = 500, m.i = 278, m.j = 278, m.k = 444, m.l = 278, m.m = 722, m.n = 500, m.o = 500, m.p = 500, m.q = 500, m.r = 389, m.s = 389, m.t = 278, m.u = 500, m.v = 444, m.w = 667, m.x = 444, m.y = 444, m.z = 389, m.braceleft = 400, m.bar = 275, m.braceright = 400, m.asciitilde = 541, m.exclamdown = 389, m.cent = 500, m.sterling = 500, m.fraction = 167, m.yen = 500, m.florin = 500, m.section = 500, m.currency = 500, m.quotesingle = 214, m.quotedblleft = 556, m.guillemotleft = 500, m.guilsinglleft = 333, m.guilsinglright = 333, m.fi = 500, m.fl = 500, m.endash = 500, m.dagger = 500, m.daggerdbl = 500, m.periodcentered = 250, m.paragraph = 523, m.bullet = 350, m.quotesinglbase = 333, m.quotedblbase = 556, m.quotedblright = 556, m.guillemotright = 500, m.ellipsis = 889, m.perthousand = 1e3, m.questiondown = 500, m.grave = 333, m.acute = 333, m.circumflex = 333, m.tilde = 333, m.macron = 333, m.breve = 333, m.dotaccent = 333, m.dieresis = 333, m.ring = 333, m.cedilla = 333, m.hungarumlaut = 333, m.ogonek = 333, m.caron = 333, m.emdash = 889, m.AE = 889, m.ordfeminine = 276, m.Lslash = 556, m.Oslash = 722, m.OE = 944, m.ordmasculine = 310, m.ae = 667, m.dotlessi = 278, m.lslash = 278, m.oslash = 500, m.oe = 667, m.germandbls = 500, m.Idieresis = 333, m.eacute = 444, m.abreve = 500, m.uhungarumlaut = 500, m.ecaron = 444, m.Ydieresis = 556, m.divide = 675, m.Yacute = 556, m.Acircumflex = 611, m.aacute = 500, m.Ucircumflex = 722, m.yacute = 444, m.scommaaccent = 389, m.ecircumflex = 444, m.Uring = 722, m.Udieresis = 722, m.aogonek = 500, m.Uacute = 722, m.uogonek = 500, m.Edieresis = 611, m.Dcroat = 722, m.commaaccent = 250, m.copyright = 760, m.Emacron = 611, m.ccaron = 444, m.aring = 500, m.Ncommaaccent = 667, m.lacute = 278, m.agrave = 500, m.Tcommaaccent = 556, m.Cacute = 667, m.atilde = 500, m.Edotaccent = 611, m.scaron = 389, m.scedilla = 389, m.iacute = 278, m.lozenge = 471, m.Rcaron = 611, m.Gcommaaccent = 722, m.ucircumflex = 500, m.acircumflex = 500, m.Amacron = 611, m.rcaron = 389, m.ccedilla = 444, m.Zdotaccent = 556, m.Thorn = 611, m.Omacron = 722, m.Racute = 611, m.Sacute = 500, m.dcaron = 544, m.Umacron = 722, m.uring = 500, m.threesuperior = 300, m.Ograve = 722, m.Agrave = 611, m.Abreve = 611, m.multiply = 675, m.uacute = 500, m.Tcaron = 556, m.partialdiff = 476, m.ydieresis = 444, m.Nacute = 667, m.icircumflex = 278, m.Ecircumflex = 611, m.adieresis = 500, m.edieresis = 444, m.cacute = 444, m.nacute = 500, m.umacron = 500, m.Ncaron = 667, m.Iacute = 333, m.plusminus = 675, m.brokenbar = 275, m.registered = 760, m.Gbreve = 722, m.Idotaccent = 333, m.summation = 600, m.Egrave = 611, m.racute = 389, m.omacron = 500, m.Zacute = 556, m.Zcaron = 556, m.greaterequal = 549, m.Eth = 722, m.Ccedilla = 667, m.lcommaaccent = 278, m.tcaron = 300, m.eogonek = 444, m.Uogonek = 722, m.Aacute = 611, m.Adieresis = 611, m.egrave = 444, m.zacute = 389, m.iogonek = 278, m.Oacute = 722, m.oacute = 500, m.amacron = 500, m.sacute = 389, m.idieresis = 278, m.Ocircumflex = 722, m.Ugrave = 722, m.Delta = 612, m.thorn = 500, m.twosuperior = 300, m.Odieresis = 722, m.mu = 500, m.igrave = 278, m.ohungarumlaut = 500, m.Eogonek = 611, m.dcroat = 500, m.threequarters = 750, m.Scedilla = 500, m.lcaron = 300, m.Kcommaaccent = 667, m.Lacute = 556, m.trademark = 980, m.edotaccent = 444, m.Igrave = 333, m.Imacron = 333, m.Lcaron = 611, m.onehalf = 750, m.lessequal = 549, m.ocircumflex = 500, m.ntilde = 500, m.Uhungarumlaut = 722, m.Eacute = 611, m.emacron = 444, m.gbreve = 500, m.onequarter = 750, m.Scaron = 500, m.Scommaaccent = 500, m.Ohungarumlaut = 722, m.degree = 400, m.ograve = 500, m.Ccaron = 667, m.ugrave = 500, m.radical = 453, m.Dcaron = 722, m.rcommaaccent = 389, m.Ntilde = 667, m.otilde = 500, m.Rcommaaccent = 611, m.Lcommaaccent = 556, m.Atilde = 611, m.Aogonek = 611, m.Aring = 611, m.Otilde = 722, m.zdotaccent = 389, m.Ecaron = 611, m.Iogonek = 333, m.kcommaaccent = 444, m.minus = 675, m.Icircumflex = 333, m.ncaron = 500, m.tcommaaccent = 278, m.logicalnot = 675, m.odieresis = 500, m.udieresis = 500, m.notequal = 549, m.gcommaaccent = 500, m.eth = 500, m.zcaron = 389, m.ncommaaccent = 500, m.onesuperior = 300, m.imacron = 278, m.Euro = 500;
              }), f.ZapfDingbats = (0, g.getLookupTableFactory)(function(m) {
                m.space = 278, m.a1 = 974, m.a2 = 961, m.a202 = 974, m.a3 = 980, m.a4 = 719, m.a5 = 789, m.a119 = 790, m.a118 = 791, m.a117 = 690, m.a11 = 960, m.a12 = 939, m.a13 = 549, m.a14 = 855, m.a15 = 911, m.a16 = 933, m.a105 = 911, m.a17 = 945, m.a18 = 974, m.a19 = 755, m.a20 = 846, m.a21 = 762, m.a22 = 761, m.a23 = 571, m.a24 = 677, m.a25 = 763, m.a26 = 760, m.a27 = 759, m.a28 = 754, m.a6 = 494, m.a7 = 552, m.a8 = 537, m.a9 = 577, m.a10 = 692, m.a29 = 786, m.a30 = 788, m.a31 = 788, m.a32 = 790, m.a33 = 793, m.a34 = 794, m.a35 = 816, m.a36 = 823, m.a37 = 789, m.a38 = 841, m.a39 = 823, m.a40 = 833, m.a41 = 816, m.a42 = 831, m.a43 = 923, m.a44 = 744, m.a45 = 723, m.a46 = 749, m.a47 = 790, m.a48 = 792, m.a49 = 695, m.a50 = 776, m.a51 = 768, m.a52 = 792, m.a53 = 759, m.a54 = 707, m.a55 = 708, m.a56 = 682, m.a57 = 701, m.a58 = 826, m.a59 = 815, m.a60 = 789, m.a61 = 789, m.a62 = 707, m.a63 = 687, m.a64 = 696, m.a65 = 689, m.a66 = 786, m.a67 = 787, m.a68 = 713, m.a69 = 791, m.a70 = 785, m.a71 = 791, m.a72 = 873, m.a73 = 761, m.a74 = 762, m.a203 = 762, m.a75 = 759, m.a204 = 759, m.a76 = 892, m.a77 = 892, m.a78 = 788, m.a79 = 784, m.a81 = 438, m.a82 = 138, m.a83 = 277, m.a84 = 415, m.a97 = 392, m.a98 = 392, m.a99 = 668, m.a100 = 668, m.a89 = 390, m.a90 = 390, m.a93 = 317, m.a94 = 317, m.a91 = 276, m.a92 = 276, m.a205 = 509, m.a85 = 509, m.a206 = 410, m.a86 = 410, m.a87 = 234, m.a88 = 234, m.a95 = 334, m.a96 = 334, m.a101 = 732, m.a102 = 544, m.a103 = 544, m.a104 = 910, m.a106 = 667, m.a107 = 760, m.a108 = 760, m.a112 = 776, m.a111 = 595, m.a110 = 694, m.a109 = 626, m.a120 = 788, m.a121 = 788, m.a122 = 788, m.a123 = 788, m.a124 = 788, m.a125 = 788, m.a126 = 788, m.a127 = 788, m.a128 = 788, m.a129 = 788, m.a130 = 788, m.a131 = 788, m.a132 = 788, m.a133 = 788, m.a134 = 788, m.a135 = 788, m.a136 = 788, m.a137 = 788, m.a138 = 788, m.a139 = 788, m.a140 = 788, m.a141 = 788, m.a142 = 788, m.a143 = 788, m.a144 = 788, m.a145 = 788, m.a146 = 788, m.a147 = 788, m.a148 = 788, m.a149 = 788, m.a150 = 788, m.a151 = 788, m.a152 = 788, m.a153 = 788, m.a154 = 788, m.a155 = 788, m.a156 = 788, m.a157 = 788, m.a158 = 788, m.a159 = 788, m.a160 = 894, m.a161 = 838, m.a163 = 1016, m.a164 = 458, m.a196 = 748, m.a165 = 924, m.a192 = 748, m.a166 = 918, m.a167 = 927, m.a168 = 928, m.a169 = 928, m.a170 = 834, m.a171 = 873, m.a172 = 828, m.a173 = 924, m.a162 = 924, m.a174 = 917, m.a175 = 930, m.a176 = 931, m.a177 = 463, m.a178 = 883, m.a179 = 836, m.a193 = 836, m.a180 = 867, m.a199 = 867, m.a181 = 696, m.a200 = 696, m.a182 = 874, m.a201 = 874, m.a183 = 760, m.a184 = 946, m.a197 = 771, m.a185 = 865, m.a194 = 771, m.a198 = 888, m.a186 = 967, m.a195 = 888, m.a187 = 831, m.a188 = 873, m.a189 = 927, m.a190 = 970, m.a191 = 918;
              });
            });
            A.getMetrics = b;
            const y = (0, g.getLookupTableFactory)(function(f) {
              f.Courier = {
                ascent: 629,
                descent: -157,
                capHeight: 562,
                xHeight: -426
              }, f["Courier-Bold"] = {
                ascent: 629,
                descent: -157,
                capHeight: 562,
                xHeight: 439
              }, f["Courier-Oblique"] = {
                ascent: 629,
                descent: -157,
                capHeight: 562,
                xHeight: 426
              }, f["Courier-BoldOblique"] = {
                ascent: 629,
                descent: -157,
                capHeight: 562,
                xHeight: 426
              }, f.Helvetica = {
                ascent: 718,
                descent: -207,
                capHeight: 718,
                xHeight: 523
              }, f["Helvetica-Bold"] = {
                ascent: 718,
                descent: -207,
                capHeight: 718,
                xHeight: 532
              }, f["Helvetica-Oblique"] = {
                ascent: 718,
                descent: -207,
                capHeight: 718,
                xHeight: 523
              }, f["Helvetica-BoldOblique"] = {
                ascent: 718,
                descent: -207,
                capHeight: 718,
                xHeight: 532
              }, f["Times-Roman"] = {
                ascent: 683,
                descent: -217,
                capHeight: 662,
                xHeight: 450
              }, f["Times-Bold"] = {
                ascent: 683,
                descent: -217,
                capHeight: 676,
                xHeight: 461
              }, f["Times-Italic"] = {
                ascent: 683,
                descent: -217,
                capHeight: 653,
                xHeight: 441
              }, f["Times-BoldItalic"] = {
                ascent: 683,
                descent: -217,
                capHeight: 669,
                xHeight: 462
              }, f.Symbol = {
                ascent: Math.NaN,
                descent: Math.NaN,
                capHeight: Math.NaN,
                xHeight: Math.NaN
              }, f.ZapfDingbats = {
                ascent: Math.NaN,
                descent: Math.NaN,
                capHeight: Math.NaN,
                xHeight: Math.NaN
              };
            });
            A.getFontBasicMetrics = y;
          },
          /* 46 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.GlyfTable = void 0;
            const x = 1, g = 2, b = 4, y = 8, f = 16, m = 32, C = 64, w = 1, S = 2, $ = 8, T = 32, I = 64, _ = 128, E = 256;
            class R {
              constructor({
                glyfTable: j,
                isGlyphLocationsLong: G,
                locaTable: U,
                numGlyphs: k
              }) {
                this.glyphs = [];
                const N = new DataView(U.buffer, U.byteOffset, U.byteLength), P = new DataView(j.buffer, j.byteOffset, j.byteLength), D = G ? 4 : 2;
                let H = G ? N.getUint32(0) : 2 * N.getUint16(0), V = 0;
                for (let Z = 0; Z < k; Z++) {
                  V += D;
                  const ne = G ? N.getUint32(V) : 2 * N.getUint16(V);
                  if (ne === H) {
                    this.glyphs.push(new O({}));
                    continue;
                  }
                  const K = O.parse(H, P);
                  this.glyphs.push(K), H = ne;
                }
              }
              getSize() {
                return this.glyphs.reduce((j, G) => {
                  const U = G.getSize();
                  return j + (U + 3 & -4);
                }, 0);
              }
              write() {
                const j = this.getSize(), G = new DataView(new ArrayBuffer(j)), U = j > 131070, k = U ? 4 : 2, N = new DataView(new ArrayBuffer((this.glyphs.length + 1) * k));
                U ? N.setUint32(0, 0) : N.setUint16(0, 0);
                let P = 0, D = 0;
                for (const H of this.glyphs)
                  P += H.write(P, G), P = P + 3 & -4, D += k, U ? N.setUint32(D, P) : N.setUint16(D, P >> 1);
                return {
                  isLocationLong: U,
                  loca: new Uint8Array(N.buffer),
                  glyf: new Uint8Array(G.buffer)
                };
              }
              scale(j) {
                for (let G = 0, U = this.glyphs.length; G < U; G++)
                  this.glyphs[G].scale(j[G]);
              }
            }
            A.GlyfTable = R;
            class O {
              constructor({
                header: j = null,
                simple: G = null,
                composites: U = null
              }) {
                this.header = j, this.simple = G, this.composites = U;
              }
              static parse(j, G) {
                const [U, k] = L.parse(j, G);
                if (j += U, k.numberOfContours < 0) {
                  const P = [];
                  for (; ; ) {
                    const [D, H] = M.parse(j, G);
                    if (j += D, P.push(H), !(H.flags & T))
                      break;
                  }
                  return new O({
                    header: k,
                    composites: P
                  });
                }
                const N = F.parse(j, G, k.numberOfContours);
                return new O({
                  header: k,
                  simple: N
                });
              }
              getSize() {
                if (!this.header)
                  return 0;
                const j = this.simple ? this.simple.getSize() : this.composites.reduce((G, U) => G + U.getSize(), 0);
                return this.header.getSize() + j;
              }
              write(j, G) {
                if (!this.header)
                  return 0;
                const U = j;
                if (j += this.header.write(j, G), this.simple)
                  j += this.simple.write(j, G);
                else
                  for (const k of this.composites)
                    j += k.write(j, G);
                return j - U;
              }
              scale(j) {
                if (!this.header)
                  return;
                const G = (this.header.xMin + this.header.xMax) / 2;
                if (this.header.scale(G, j), this.simple)
                  this.simple.scale(G, j);
                else
                  for (const U of this.composites)
                    U.scale(G, j);
              }
            }
            class L {
              constructor({
                numberOfContours: j,
                xMin: G,
                yMin: U,
                xMax: k,
                yMax: N
              }) {
                this.numberOfContours = j, this.xMin = G, this.yMin = U, this.xMax = k, this.yMax = N;
              }
              static parse(j, G) {
                return [10, new L({
                  numberOfContours: G.getInt16(j),
                  xMin: G.getInt16(j + 2),
                  yMin: G.getInt16(j + 4),
                  xMax: G.getInt16(j + 6),
                  yMax: G.getInt16(j + 8)
                })];
              }
              getSize() {
                return 10;
              }
              write(j, G) {
                return G.setInt16(j, this.numberOfContours), G.setInt16(j + 2, this.xMin), G.setInt16(j + 4, this.yMin), G.setInt16(j + 6, this.xMax), G.setInt16(j + 8, this.yMax), 10;
              }
              scale(j, G) {
                this.xMin = Math.round(j + (this.xMin - j) * G), this.xMax = Math.round(j + (this.xMax - j) * G);
              }
            }
            class B {
              constructor({
                flags: j,
                xCoordinates: G,
                yCoordinates: U
              }) {
                this.xCoordinates = G, this.yCoordinates = U, this.flags = j;
              }
            }
            class F {
              constructor({
                contours: j,
                instructions: G
              }) {
                this.contours = j, this.instructions = G;
              }
              static parse(j, G, U) {
                const k = [];
                for (let Q = 0; Q < U; Q++) {
                  const J = G.getUint16(j);
                  j += 2, k.push(J);
                }
                const N = k[U - 1] + 1, P = G.getUint16(j);
                j += 2;
                const D = new Uint8Array(G).slice(j, j + P);
                j += P;
                const H = [];
                for (let Q = 0; Q < N; j++, Q++) {
                  let J = G.getUint8(j);
                  if (H.push(J), J & y) {
                    const te = G.getUint8(++j);
                    J ^= y;
                    for (let ae = 0; ae < te; ae++)
                      H.push(J);
                    Q += te;
                  }
                }
                const V = [];
                let Z = [], ne = [], K = [];
                const q = [];
                let Y = 0, ee = 0;
                for (let Q = 0; Q < N; Q++) {
                  const J = H[Q];
                  if (J & g) {
                    const te = G.getUint8(j++);
                    ee += J & f ? te : -te, Z.push(ee);
                  } else J & f || (ee += G.getInt16(j), j += 2), Z.push(ee);
                  k[Y] === Q && (Y++, V.push(Z), Z = []);
                }
                ee = 0, Y = 0;
                for (let Q = 0; Q < N; Q++) {
                  const J = H[Q];
                  if (J & b) {
                    const te = G.getUint8(j++);
                    ee += J & m ? te : -te, ne.push(ee);
                  } else J & m || (ee += G.getInt16(j), j += 2), ne.push(ee);
                  K.push(J & x | J & C), k[Y] === Q && (Z = V[Y], Y++, q.push(new B({
                    flags: K,
                    xCoordinates: Z,
                    yCoordinates: ne
                  })), ne = [], K = []);
                }
                return new F({
                  contours: q,
                  instructions: D
                });
              }
              getSize() {
                let j = this.contours.length * 2 + 2 + this.instructions.length, G = 0, U = 0;
                for (const k of this.contours) {
                  j += k.flags.length;
                  for (let N = 0, P = k.xCoordinates.length; N < P; N++) {
                    const D = k.xCoordinates[N], H = k.yCoordinates[N];
                    let V = Math.abs(D - G);
                    V > 255 ? j += 2 : V > 0 && (j += 1), G = D, V = Math.abs(H - U), V > 255 ? j += 2 : V > 0 && (j += 1), U = H;
                  }
                }
                return j;
              }
              write(j, G) {
                const U = j, k = [], N = [], P = [];
                let D = 0, H = 0;
                for (const V of this.contours) {
                  for (let Z = 0, ne = V.xCoordinates.length; Z < ne; Z++) {
                    let K = V.flags[Z];
                    const q = V.xCoordinates[Z];
                    let Y = q - D;
                    if (Y === 0)
                      K |= f, k.push(0);
                    else {
                      const Q = Math.abs(Y);
                      Q <= 255 ? (K |= Y >= 0 ? g | f : g, k.push(Q)) : k.push(Y);
                    }
                    D = q;
                    const ee = V.yCoordinates[Z];
                    if (Y = ee - H, Y === 0)
                      K |= m, N.push(0);
                    else {
                      const Q = Math.abs(Y);
                      Q <= 255 ? (K |= Y >= 0 ? b | m : b, N.push(Q)) : N.push(Y);
                    }
                    H = ee, P.push(K);
                  }
                  G.setUint16(j, k.length - 1), j += 2;
                }
                G.setUint16(j, this.instructions.length), j += 2, this.instructions.length && (new Uint8Array(G.buffer, 0, G.buffer.byteLength).set(this.instructions, j), j += this.instructions.length);
                for (const V of P)
                  G.setUint8(j++, V);
                for (let V = 0, Z = k.length; V < Z; V++) {
                  const ne = k[V], K = P[V];
                  K & g ? G.setUint8(j++, ne) : K & f || (G.setInt16(j, ne), j += 2);
                }
                for (let V = 0, Z = N.length; V < Z; V++) {
                  const ne = N[V], K = P[V];
                  K & b ? G.setUint8(j++, ne) : K & m || (G.setInt16(j, ne), j += 2);
                }
                return j - U;
              }
              scale(j, G) {
                for (const U of this.contours)
                  if (U.xCoordinates.length !== 0)
                    for (let k = 0, N = U.xCoordinates.length; k < N; k++)
                      U.xCoordinates[k] = Math.round(j + (U.xCoordinates[k] - j) * G);
              }
            }
            class M {
              constructor({
                flags: j,
                glyphIndex: G,
                argument1: U,
                argument2: k,
                transf: N,
                instructions: P
              }) {
                this.flags = j, this.glyphIndex = G, this.argument1 = U, this.argument2 = k, this.transf = N, this.instructions = P;
              }
              static parse(j, G) {
                const U = j, k = [];
                let N = G.getUint16(j);
                const P = G.getUint16(j + 2);
                j += 4;
                let D, H;
                N & w ? (N & S ? (D = G.getInt16(j), H = G.getInt16(j + 2)) : (D = G.getUint16(j), H = G.getUint16(j + 2)), j += 4, N ^= w) : (N & S ? (D = G.getInt8(j), H = G.getInt8(j + 1)) : (D = G.getUint8(j), H = G.getUint8(j + 1)), j += 2), N & $ ? (k.push(G.getUint16(j)), j += 2) : N & I ? (k.push(G.getUint16(j), G.getUint16(j + 2)), j += 4) : N & _ && (k.push(G.getUint16(j), G.getUint16(j + 2), G.getUint16(j + 4), G.getUint16(j + 6)), j += 8);
                let V = null;
                if (N & E) {
                  const Z = G.getUint16(j);
                  j += 2, V = new Uint8Array(G).slice(j, j + Z), j += Z;
                }
                return [j - U, new M({
                  flags: N,
                  glyphIndex: P,
                  argument1: D,
                  argument2: H,
                  transf: k,
                  instructions: V
                })];
              }
              getSize() {
                let j = 4 + this.transf.length * 2;
                return this.flags & E && (j += 2 + this.instructions.length), j += 2, this.flags & 2 ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (j += 2) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (j += 2), j;
              }
              write(j, G) {
                const U = j;
                return this.flags & S ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (this.flags |= w) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (this.flags |= w), G.setUint16(j, this.flags), G.setUint16(j + 2, this.glyphIndex), j += 4, this.flags & w ? (this.flags & S ? (G.setInt16(j, this.argument1), G.setInt16(j + 2, this.argument2)) : (G.setUint16(j, this.argument1), G.setUint16(j + 2, this.argument2)), j += 4) : (G.setUint8(j, this.argument1), G.setUint8(j + 1, this.argument2), j += 2), this.flags & E && (G.setUint16(j, this.instructions.length), j += 2, this.instructions.length && (new Uint8Array(G.buffer, 0, G.buffer.byteLength).set(this.instructions, j), j += this.instructions.length)), j - U;
              }
              scale(j, G) {
              }
            }
          },
          /* 47 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.OpenTypeFileBuilder = void 0;
            var g = x(3), b = x(2);
            function y($, T, I) {
              $[T] = I >> 8 & 255, $[T + 1] = I & 255;
            }
            function f($, T, I) {
              $[T] = I >> 24 & 255, $[T + 1] = I >> 16 & 255, $[T + 2] = I >> 8 & 255, $[T + 3] = I & 255;
            }
            function m($, T, I) {
              if (I instanceof Uint8Array)
                $.set(I, T);
              else if (typeof I == "string")
                for (let _ = 0, E = I.length; _ < E; _++)
                  $[T++] = I.charCodeAt(_) & 255;
              else
                for (const _ of I)
                  $[T++] = _ & 255;
            }
            const C = 12, w = 16;
            class S {
              constructor(T) {
                this.sfnt = T, this.tables = /* @__PURE__ */ Object.create(null);
              }
              static getSearchParams(T, I) {
                let _ = 1, E = 0;
                for (; (_ ^ T) > _; )
                  _ <<= 1, E++;
                const R = _ * I;
                return {
                  range: R,
                  entry: E,
                  rangeShift: I * T - R
                };
              }
              toArray() {
                let T = this.sfnt;
                const I = this.tables, _ = Object.keys(I);
                _.sort();
                const E = _.length;
                let R, O, L, B, F, M = C + E * w;
                const W = [M];
                for (R = 0; R < E; R++) {
                  B = I[_[R]];
                  const U = (B.length + 3 & -4) >>> 0;
                  M += U, W.push(M);
                }
                const j = new Uint8Array(M);
                for (R = 0; R < E; R++)
                  B = I[_[R]], m(j, W[R], B);
                T === "true" && (T = (0, b.string32)(65536)), j[0] = T.charCodeAt(0) & 255, j[1] = T.charCodeAt(1) & 255, j[2] = T.charCodeAt(2) & 255, j[3] = T.charCodeAt(3) & 255, y(j, 4, E);
                const G = S.getSearchParams(E, 16);
                for (y(j, 6, G.range), y(j, 8, G.entry), y(j, 10, G.rangeShift), M = C, R = 0; R < E; R++) {
                  F = _[R], j[M] = F.charCodeAt(0) & 255, j[M + 1] = F.charCodeAt(1) & 255, j[M + 2] = F.charCodeAt(2) & 255, j[M + 3] = F.charCodeAt(3) & 255;
                  let U = 0;
                  for (O = W[R], L = W[R + 1]; O < L; O += 4) {
                    const k = (0, g.readUint32)(j, O);
                    U = U + k >>> 0;
                  }
                  f(j, M + 4, U), f(j, M + 8, W[R]), f(j, M + 12, I[F].length), M += w;
                }
                return j;
              }
              addTable(T, I) {
                if (T in this.tables)
                  throw new Error("Table " + T + " already exists");
                this.tables[T] = I;
              }
            }
            A.OpenTypeFileBuilder = S;
          },
          /* 48 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Type1Font = void 0;
            var g = x(35), b = x(2), y = x(38), f = x(3), m = x(8), C = x(49);
            function w(I, _, E) {
              const R = I.length, O = _.length, L = R - O;
              let B = E, F = !1;
              for (; B < L; ) {
                let M = 0;
                for (; M < O && I[B + M] === _[M]; )
                  M++;
                if (M >= O) {
                  for (B += M; B < R && (0, f.isWhiteSpace)(I[B]); )
                    B++;
                  F = !0;
                  break;
                }
                B++;
              }
              return {
                found: F,
                length: B
              };
            }
            function S(I, _) {
              const E = [101, 101, 120, 101, 99], R = I.pos;
              let O, L, B;
              try {
                O = I.getBytes(_), L = O.length;
              } catch {
              }
              if (L === _ && (B = w(O, E, _ - 2 * E.length), B.found && B.length === _))
                return {
                  stream: new m.Stream(O),
                  length: _
                };
              (0, b.warn)('Invalid "Length1" property in Type1 font -- trying to recover.'), I.pos = R;
              const F = 2048;
              let M;
              for (; ; ) {
                const W = I.peekBytes(F);
                if (B = w(W, E, 0), B.length === 0)
                  break;
                if (I.pos += B.length, B.found) {
                  M = I.pos - R;
                  break;
                }
              }
              return I.pos = R, M ? {
                stream: new m.Stream(I.getBytes(M)),
                length: M
              } : ((0, b.warn)('Unable to recover "Length1" property in Type1 font -- using as is.'), {
                stream: new m.Stream(I.getBytes(_)),
                length: _
              });
            }
            function $(I, _) {
              const E = I.getBytes();
              if (E.length === 0)
                throw new b.FormatError("getEexecBlock - no font program found.");
              return {
                stream: new m.Stream(E),
                length: E.length
              };
            }
            class T {
              constructor(_, E, R) {
                let L = R.length1;
                R.length2;
                let B = E.peekBytes(6);
                const F = B[0] === 128 && B[1] === 1;
                F && (E.skip(6), L = B[5] << 24 | B[4] << 16 | B[3] << 8 | B[2]);
                const M = S(E, L);
                new C.Type1Parser(M.stream, !1, y.SEAC_ANALYSIS_ENABLED).extractFontHeader(R), F && (B = E.getBytes(6), B[5] << 24 | B[4] << 16 | B[3] << 8 | B[2]);
                const j = $(E), U = new C.Type1Parser(j.stream, !0, y.SEAC_ANALYSIS_ENABLED).extractFontProgram(R);
                for (const D in U.properties)
                  R[D] = U.properties[D];
                const k = U.charstrings, N = this.getType2Charstrings(k), P = this.getType2Subrs(U.subrs);
                this.charstrings = k, this.data = this.wrap(_, N, this.charstrings, P, R), this.seacs = this.getSeacs(U.charstrings);
              }
              get numGlyphs() {
                return this.charstrings.length + 1;
              }
              getCharset() {
                const _ = [".notdef"];
                for (const {
                  glyphName: E
                } of this.charstrings)
                  _.push(E);
                return _;
              }
              getGlyphMapping(_) {
                const E = this.charstrings;
                if (_.composite) {
                  const F = /* @__PURE__ */ Object.create(null);
                  for (let M = 0, W = E.length; M < W; M++) {
                    const j = _.cMap.charCodeOf(M);
                    F[j] = M + 1;
                  }
                  return F;
                }
                const R = [".notdef"];
                let O, L;
                for (L = 0; L < E.length; L++)
                  R.push(E[L].glyphName);
                const B = _.builtInEncoding;
                if (B) {
                  O = /* @__PURE__ */ Object.create(null);
                  for (const F in B)
                    L = R.indexOf(B[F]), L >= 0 && (O[F] = L);
                }
                return (0, y.type1FontGlyphMapping)(_, O, R);
              }
              hasGlyphId(_) {
                return _ < 0 || _ >= this.numGlyphs ? !1 : _ === 0 ? !0 : this.charstrings[_ - 1].charstring.length > 0;
              }
              getSeacs(_) {
                const E = [];
                for (let R = 0, O = _.length; R < O; R++) {
                  const L = _[R];
                  L.seac && (E[R + 1] = L.seac);
                }
                return E;
              }
              getType2Charstrings(_) {
                const E = [];
                for (const R of _)
                  E.push(R.charstring);
                return E;
              }
              getType2Subrs(_) {
                let E = 0;
                const R = _.length;
                R < 1133 ? E = 107 : R < 33769 ? E = 1131 : E = 32768;
                const O = [];
                let L;
                for (L = 0; L < E; L++)
                  O.push([11]);
                for (L = 0; L < R; L++)
                  O.push(_[L]);
                return O;
              }
              wrap(_, E, R, O, L) {
                const B = new g.CFF();
                B.header = new g.CFFHeader(1, 0, 4, 4), B.names = [_];
                const F = new g.CFFTopDict();
                F.setByName("version", 391), F.setByName("Notice", 392), F.setByName("FullName", 393), F.setByName("FamilyName", 394), F.setByName("Weight", 395), F.setByName("Encoding", null), F.setByName("FontMatrix", L.fontMatrix), F.setByName("FontBBox", L.bbox), F.setByName("charset", null), F.setByName("CharStrings", null), F.setByName("Private", null), B.topDict = F;
                const M = new g.CFFStrings();
                M.add("Version 0.11"), M.add("See original notice"), M.add(_), M.add(_), M.add("Medium"), B.strings = M, B.globalSubrIndex = new g.CFFIndex();
                const W = E.length, j = [".notdef"];
                let G, U;
                for (G = 0; G < W; G++) {
                  const V = R[G].glyphName;
                  g.CFFStandardStrings.indexOf(V) === -1 && M.add(V), j.push(V);
                }
                B.charset = new g.CFFCharset(!1, 0, j);
                const k = new g.CFFIndex();
                for (k.add([139, 14]), G = 0; G < W; G++)
                  k.add(E[G]);
                B.charStrings = k;
                const N = new g.CFFPrivateDict();
                N.setByName("Subrs", null);
                const P = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
                for (G = 0, U = P.length; G < U; G++) {
                  const V = P[G];
                  if (!(V in L.privateData))
                    continue;
                  const Z = L.privateData[V];
                  if (Array.isArray(Z))
                    for (let ne = Z.length - 1; ne > 0; ne--)
                      Z[ne] -= Z[ne - 1];
                  N.setByName(V, Z);
                }
                B.topDict.privateDict = N;
                const D = new g.CFFIndex();
                for (G = 0, U = O.length; G < U; G++)
                  D.add(O[G]);
                return N.subrsIndex = D, new g.CFFCompiler(B).compile();
              }
            }
            A.Type1Font = T;
          },
          /* 49 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Type1Parser = void 0;
            var g = x(37), b = x(3), y = x(8), f = x(2);
            const m = !1, C = {
              vmoveto: [4],
              rlineto: [5],
              hlineto: [6],
              vlineto: [7],
              rrcurveto: [8],
              flex: [12, 35],
              endchar: [14],
              rmoveto: [21],
              hmoveto: [22],
              vhcurveto: [30],
              hvcurveto: [31]
            };
            class w {
              constructor() {
                this.width = 0, this.lsb = 0, this.flexing = !1, this.output = [], this.stack = [];
              }
              convert(L, B, F) {
                const M = L.length;
                let W = !1, j, G, U;
                for (let k = 0; k < M; k++) {
                  let N = L[k];
                  if (N < 32) {
                    switch (N === 12 && (N = (N << 8) + L[++k]), N) {
                      case 1: {
                        this.stack = [];
                        break;
                      }
                      case 3: {
                        this.stack = [];
                        break;
                      }
                      case 4:
                        if (this.flexing) {
                          if (this.stack.length < 1) {
                            W = !0;
                            break;
                          }
                          const Z = this.stack.pop();
                          this.stack.push(0, Z);
                          break;
                        }
                        W = this.executeCommand(1, C.vmoveto);
                        break;
                      case 5:
                        W = this.executeCommand(2, C.rlineto);
                        break;
                      case 6:
                        W = this.executeCommand(1, C.hlineto);
                        break;
                      case 7:
                        W = this.executeCommand(1, C.vlineto);
                        break;
                      case 8:
                        W = this.executeCommand(6, C.rrcurveto);
                        break;
                      case 9:
                        this.stack = [];
                        break;
                      case 10:
                        if (this.stack.length < 1) {
                          W = !0;
                          break;
                        }
                        if (U = this.stack.pop(), !B[U]) {
                          W = !0;
                          break;
                        }
                        W = this.convert(B[U], B, F);
                        break;
                      case 11:
                        return W;
                      case 13:
                        if (this.stack.length < 2) {
                          W = !0;
                          break;
                        }
                        j = this.stack.pop(), G = this.stack.pop(), this.lsb = G, this.width = j, this.stack.push(j, G), W = this.executeCommand(2, C.hmoveto);
                        break;
                      case 14:
                        this.output.push(C.endchar[0]);
                        break;
                      case 21:
                        if (this.flexing)
                          break;
                        W = this.executeCommand(2, C.rmoveto);
                        break;
                      case 22:
                        if (this.flexing) {
                          this.stack.push(0);
                          break;
                        }
                        W = this.executeCommand(1, C.hmoveto);
                        break;
                      case 30:
                        W = this.executeCommand(4, C.vhcurveto);
                        break;
                      case 31:
                        W = this.executeCommand(4, C.hvcurveto);
                        break;
                      case 3072:
                        this.stack = [];
                        break;
                      case 3073: {
                        this.stack = [];
                        break;
                      }
                      case 3074: {
                        this.stack = [];
                        break;
                      }
                      case 3078:
                        if (F) {
                          const Z = this.stack.at(-5);
                          this.seac = this.stack.splice(-4, 4), this.seac[0] += this.lsb - Z, W = this.executeCommand(0, C.endchar);
                        } else
                          W = this.executeCommand(4, C.endchar);
                        break;
                      case 3079:
                        if (this.stack.length < 4) {
                          W = !0;
                          break;
                        }
                        this.stack.pop(), j = this.stack.pop();
                        const P = this.stack.pop();
                        G = this.stack.pop(), this.lsb = G, this.width = j, this.stack.push(j, G, P), W = this.executeCommand(3, C.rmoveto);
                        break;
                      case 3084:
                        if (this.stack.length < 2) {
                          W = !0;
                          break;
                        }
                        const D = this.stack.pop(), H = this.stack.pop();
                        this.stack.push(H / D);
                        break;
                      case 3088:
                        if (this.stack.length < 2) {
                          W = !0;
                          break;
                        }
                        U = this.stack.pop();
                        const V = this.stack.pop();
                        if (U === 0 && V === 3) {
                          const Z = this.stack.splice(-17, 17);
                          this.stack.push(Z[2] + Z[0], Z[3] + Z[1], Z[4], Z[5], Z[6], Z[7], Z[8], Z[9], Z[10], Z[11], Z[12], Z[13], Z[14]), W = this.executeCommand(13, C.flex, !0), this.flexing = !1, this.stack.push(Z[15], Z[16]);
                        } else U === 1 && V === 0 && (this.flexing = !0);
                        break;
                      case 3089:
                        break;
                      case 3105:
                        this.stack = [];
                        break;
                      default:
                        (0, f.warn)('Unknown type 1 charstring command of "' + N + '"');
                        break;
                    }
                    if (W)
                      break;
                    continue;
                  } else N <= 246 ? N -= 139 : N <= 250 ? N = (N - 247) * 256 + L[++k] + 108 : N <= 254 ? N = -((N - 251) * 256) - L[++k] - 108 : N = (L[++k] & 255) << 24 | (L[++k] & 255) << 16 | (L[++k] & 255) << 8 | (L[++k] & 255) << 0;
                  this.stack.push(N);
                }
                return W;
              }
              executeCommand(L, B, F) {
                const M = this.stack.length;
                if (L > M)
                  return !0;
                const W = M - L;
                for (let j = W; j < M; j++) {
                  let G = this.stack[j];
                  Number.isInteger(G) ? this.output.push(28, G >> 8 & 255, G & 255) : (G = 65536 * G | 0, this.output.push(255, G >> 24 & 255, G >> 16 & 255, G >> 8 & 255, G & 255));
                }
                return this.output.push(...B), F ? this.stack.splice(W, L) : this.stack.length = 0, !1;
              }
            }
            const S = 55665, $ = 4330;
            function T(O) {
              return O >= 48 && O <= 57 || O >= 65 && O <= 70 || O >= 97 && O <= 102;
            }
            function I(O, L, B) {
              if (B >= O.length)
                return new Uint8Array(0);
              const F = 52845, M = 22719;
              let W = L | 0, j, G;
              for (j = 0; j < B; j++)
                W = (O[j] + W) * F + M & 65535;
              const U = O.length - B, k = new Uint8Array(U);
              for (j = B, G = 0; G < U; j++, G++) {
                const N = O[j];
                k[G] = N ^ W >> 8, W = (N + W) * F + M & 65535;
              }
              return k;
            }
            function _(O, L, B) {
              let W = L | 0;
              const j = O.length, G = j >>> 1, U = new Uint8Array(G);
              let k, N;
              for (k = 0, N = 0; k < j; k++) {
                const P = O[k];
                if (!T(P))
                  continue;
                k++;
                let D;
                for (; k < j && !T(D = O[k]); )
                  k++;
                if (k < j) {
                  const H = parseInt(String.fromCharCode(P, D), 16);
                  U[N++] = H ^ W >> 8, W = (H + W) * 52845 + 22719 & 65535;
                }
              }
              return U.slice(B, N);
            }
            function E(O) {
              return O === 47 || O === 91 || O === 93 || O === 123 || O === 125 || O === 40 || O === 41;
            }
            class R {
              constructor(L, B, F) {
                if (B) {
                  const M = L.getBytes(), W = !((T(M[0]) || (0, b.isWhiteSpace)(M[0])) && T(M[1]) && T(M[2]) && T(M[3]) && T(M[4]) && T(M[5]) && T(M[6]) && T(M[7]));
                  L = new y.Stream(W ? I(M, S, 4) : _(M, S, 4));
                }
                this.seacAnalysisEnabled = !!F, this.stream = L, this.nextChar();
              }
              readNumberArray() {
                this.getToken();
                const L = [];
                for (; ; ) {
                  const B = this.getToken();
                  if (B === null || B === "]" || B === "}")
                    break;
                  L.push(parseFloat(B || 0));
                }
                return L;
              }
              readNumber() {
                const L = this.getToken();
                return parseFloat(L || 0);
              }
              readInt() {
                const L = this.getToken();
                return parseInt(L || 0, 10) | 0;
              }
              readBoolean() {
                return this.getToken() === "true" ? 1 : 0;
              }
              nextChar() {
                return this.currentChar = this.stream.getByte();
              }
              prevChar() {
                return this.stream.skip(-2), this.currentChar = this.stream.getByte();
              }
              getToken() {
                let L = !1, B = this.currentChar;
                for (; ; ) {
                  if (B === -1)
                    return null;
                  if (L)
                    (B === 10 || B === 13) && (L = !1);
                  else if (B === 37)
                    L = !0;
                  else if (!(0, b.isWhiteSpace)(B))
                    break;
                  B = this.nextChar();
                }
                if (E(B))
                  return this.nextChar(), String.fromCharCode(B);
                let F = "";
                do
                  F += String.fromCharCode(B), B = this.nextChar();
                while (B >= 0 && !(0, b.isWhiteSpace)(B) && !E(B));
                return F;
              }
              readCharStrings(L, B) {
                return B === -1 ? L : I(L, $, B);
              }
              extractFontProgram(L) {
                const B = this.stream, F = [], M = [], W = /* @__PURE__ */ Object.create(null);
                W.lenIV = 4;
                const j = {
                  subrs: [],
                  charstrings: [],
                  properties: {
                    privateData: W
                  }
                };
                let G, U, k, N;
                for (; (G = this.getToken()) !== null; )
                  if (G === "/")
                    switch (G = this.getToken(), G) {
                      case "CharStrings":
                        for (this.getToken(), this.getToken(), this.getToken(), this.getToken(); G = this.getToken(), !(G === null || G === "end"); ) {
                          if (G !== "/")
                            continue;
                          const D = this.getToken();
                          U = this.readInt(), this.getToken(), k = U > 0 ? B.getBytes(U) : new Uint8Array(0), N = j.properties.privateData.lenIV;
                          const H = this.readCharStrings(k, N);
                          this.nextChar(), G = this.getToken(), G === "noaccess" ? this.getToken() : G === "/" && this.prevChar(), M.push({
                            glyph: D,
                            encoded: H
                          });
                        }
                        break;
                      case "Subrs":
                        for (this.readInt(), this.getToken(); this.getToken() === "dup"; ) {
                          const D = this.readInt();
                          U = this.readInt(), this.getToken(), k = U > 0 ? B.getBytes(U) : new Uint8Array(0), N = j.properties.privateData.lenIV;
                          const H = this.readCharStrings(k, N);
                          this.nextChar(), G = this.getToken(), G === "noaccess" && this.getToken(), F[D] = H;
                        }
                        break;
                      case "BlueValues":
                      case "OtherBlues":
                      case "FamilyBlues":
                      case "FamilyOtherBlues":
                        const P = this.readNumberArray();
                        P.length > 0 && P.length % 2;
                        break;
                      case "StemSnapH":
                      case "StemSnapV":
                        j.properties.privateData[G] = this.readNumberArray();
                        break;
                      case "StdHW":
                      case "StdVW":
                        j.properties.privateData[G] = this.readNumberArray()[0];
                        break;
                      case "BlueShift":
                      case "lenIV":
                      case "BlueFuzz":
                      case "BlueScale":
                      case "LanguageGroup":
                        j.properties.privateData[G] = this.readNumber();
                        break;
                      case "ExpansionFactor":
                        j.properties.privateData[G] = this.readNumber() || 0.06;
                        break;
                      case "ForceBold":
                        j.properties.privateData[G] = this.readBoolean();
                        break;
                    }
                for (const {
                  encoded: P,
                  glyph: D
                } of M) {
                  const H = new w(), V = H.convert(P, F, this.seacAnalysisEnabled);
                  let Z = H.output;
                  V && (Z = [14]);
                  const ne = {
                    glyphName: D,
                    charstring: Z,
                    width: H.width,
                    lsb: H.lsb,
                    seac: H.seac
                  };
                  if (D === ".notdef" ? j.charstrings.unshift(ne) : j.charstrings.push(ne), L.builtInEncoding) {
                    const K = L.builtInEncoding.indexOf(D);
                    K > -1 && L.widths[K] === void 0 && K >= L.firstChar && K <= L.lastChar && (L.widths[K] = H.width);
                  }
                }
                return j;
              }
              extractFontHeader(L) {
                let B;
                for (; (B = this.getToken()) !== null; )
                  if (B === "/")
                    switch (B = this.getToken(), B) {
                      case "FontMatrix":
                        const F = this.readNumberArray();
                        L.fontMatrix = F;
                        break;
                      case "Encoding":
                        const M = this.getToken();
                        let W;
                        if (!/^\d+$/.test(M))
                          W = (0, g.getEncoding)(M);
                        else {
                          W = [];
                          const G = parseInt(M, 10) | 0;
                          this.getToken();
                          for (let U = 0; U < G; U++) {
                            for (B = this.getToken(); B !== "dup" && B !== "def"; )
                              if (B = this.getToken(), B === null)
                                return;
                            if (B === "def")
                              break;
                            const k = this.readInt();
                            this.getToken();
                            const N = this.getToken();
                            W[k] = N, this.getToken();
                          }
                        }
                        L.builtInEncoding = W;
                        break;
                      case "FontBBox":
                        const j = this.readNumberArray();
                        L.ascent = Math.max(j[3], j[1]), L.descent = Math.min(j[1], j[3]), L.ascentScaled = !0;
                        break;
                    }
              }
            }
            A.Type1Parser = R;
          },
          /* 50 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Pattern = void 0, A.clearPatternCaches = E, A.getTilingPatternIR = L;
            var g = x(2), b = x(5), y = x(12), f = x(3);
            const m = {
              FUNCTION_BASED: 1,
              AXIAL: 2,
              RADIAL: 3,
              FREE_FORM_MESH: 4,
              LATTICE_FORM_MESH: 5,
              COONS_PATCH_MESH: 6,
              TENSOR_PATCH_MESH: 7
            };
            class C {
              constructor() {
                (0, g.unreachable)("Cannot initialize Pattern.");
              }
              static parseShading(F, M, W, j, G) {
                const U = F instanceof b.BaseStream ? F.dict : F, k = U.get("ShadingType");
                try {
                  switch (k) {
                    case m.AXIAL:
                    case m.RADIAL:
                      return new S(U, M, W, j, G);
                    case m.FREE_FORM_MESH:
                    case m.LATTICE_FORM_MESH:
                    case m.COONS_PATCH_MESH:
                    case m.TENSOR_PATCH_MESH:
                      return new R(F, M, W, j, G);
                    default:
                      throw new g.FormatError("Unsupported ShadingType: " + k);
                  }
                } catch (N) {
                  if (N instanceof f.MissingDataException)
                    throw N;
                  return (0, g.warn)(N), new O();
                }
              }
            }
            A.Pattern = C;
            class w {
              static SMALL_NUMBER = 1e-6;
              constructor() {
                this.constructor === w && (0, g.unreachable)("Cannot initialize BaseShading.");
              }
              getIR() {
                (0, g.unreachable)("Abstract method `getIR` called.");
              }
            }
            class S extends w {
              constructor(F, M, W, j, G) {
                super(), this.coordsArr = F.getArray("Coords"), this.shadingType = F.get("ShadingType");
                const U = y.ColorSpace.parse({
                  cs: F.getRaw("CS") || F.getRaw("ColorSpace"),
                  xref: M,
                  resources: W,
                  pdfFunctionFactory: j,
                  localColorSpaceCache: G
                }), k = F.getArray("BBox");
                this.bbox = Array.isArray(k) && k.length === 4 ? g.Util.normalizeRect(k) : null;
                let N = 0, P = 1;
                if (F.has("Domain")) {
                  const ye = F.getArray("Domain");
                  N = ye[0], P = ye[1];
                }
                let D = !1, H = !1;
                if (F.has("Extend")) {
                  const ye = F.getArray("Extend");
                  D = ye[0], H = ye[1];
                }
                if (this.shadingType === m.RADIAL && (!D || !H)) {
                  const [ye, Ce, xe, we, $e, Ae] = this.coordsArr, ue = Math.hypot(ye - we, Ce - $e);
                  xe <= Ae + ue && Ae <= xe + ue && (0, g.warn)("Unsupported radial gradient.");
                }
                this.extendStart = D, this.extendEnd = H;
                const V = F.getRaw("Function"), Z = j.createFromArray(V), ne = 840, K = (P - N) / ne, q = this.colorStops = [];
                if (N >= P || K <= 0) {
                  (0, g.info)("Bad shading domain.");
                  return;
                }
                const Y = new Float32Array(U.numComps), ee = new Float32Array(1);
                let Q, J = 0;
                ee[0] = N, Z(ee, 0, Y, 0);
                let te = U.getRgb(Y, 0);
                const ae = g.Util.makeHexColor(te[0], te[1], te[2]);
                q.push([0, ae]);
                let se = 1;
                ee[0] = N + K, Z(ee, 0, Y, 0);
                let ie = U.getRgb(Y, 0), fe = ie[0] - te[0] + 1, ge = ie[1] - te[1] + 1, me = ie[2] - te[2] + 1, pe = ie[0] - te[0] - 1, be = ie[1] - te[1] - 1, le = ie[2] - te[2] - 1;
                for (let ye = 2; ye < ne; ye++) {
                  ee[0] = N + ye * K, Z(ee, 0, Y, 0), Q = U.getRgb(Y, 0);
                  const Ce = ye - J;
                  if (fe = Math.min(fe, (Q[0] - te[0] + 1) / Ce), ge = Math.min(ge, (Q[1] - te[1] + 1) / Ce), me = Math.min(me, (Q[2] - te[2] + 1) / Ce), pe = Math.max(pe, (Q[0] - te[0] - 1) / Ce), be = Math.max(be, (Q[1] - te[1] - 1) / Ce), le = Math.max(le, (Q[2] - te[2] - 1) / Ce), !(pe <= fe && be <= ge && le <= me)) {
                    const we = g.Util.makeHexColor(ie[0], ie[1], ie[2]);
                    q.push([se / ne, we]), fe = Q[0] - ie[0] + 1, ge = Q[1] - ie[1] + 1, me = Q[2] - ie[2] + 1, pe = Q[0] - ie[0] - 1, be = Q[1] - ie[1] - 1, le = Q[2] - ie[2] - 1, J = se, te = ie;
                  }
                  se = ye, ie = Q;
                }
                const ve = g.Util.makeHexColor(ie[0], ie[1], ie[2]);
                q.push([1, ve]);
                let he = "transparent";
                F.has("Background") && (Q = U.getRgb(F.get("Background"), 0), he = g.Util.makeHexColor(Q[0], Q[1], Q[2])), D || (q.unshift([0, he]), q[1][0] += w.SMALL_NUMBER), H || (q.at(-1)[0] -= w.SMALL_NUMBER, q.push([1, he])), this.colorStops = q;
              }
              getIR() {
                const F = this.coordsArr, M = this.shadingType;
                let W, j, G, U, k;
                return M === m.AXIAL ? (j = [F[0], F[1]], G = [F[2], F[3]], U = null, k = null, W = "axial") : M === m.RADIAL ? (j = [F[0], F[1]], G = [F[3], F[4]], U = F[2], k = F[5], W = "radial") : (0, g.unreachable)(`getPattern type unknown: ${M}`), ["RadialAxial", W, this.bbox, this.colorStops, j, G, U, k];
              }
            }
            class $ {
              constructor(F, M) {
                this.stream = F, this.context = M, this.buffer = 0, this.bufferLength = 0;
                const W = M.numComps;
                this.tmpCompsBuf = new Float32Array(W);
                const j = M.colorSpace.numComps;
                this.tmpCsCompsBuf = M.colorFn ? new Float32Array(j) : this.tmpCompsBuf;
              }
              get hasData() {
                if (this.stream.end)
                  return this.stream.pos < this.stream.end;
                if (this.bufferLength > 0)
                  return !0;
                const F = this.stream.getByte();
                return F < 0 ? !1 : (this.buffer = F, this.bufferLength = 8, !0);
              }
              readBits(F) {
                let M = this.buffer, W = this.bufferLength;
                if (F === 32) {
                  if (W === 0)
                    return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                  M = M << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                  const j = this.stream.getByte();
                  return this.buffer = j & (1 << W) - 1, (M << 8 - W | (j & 255) >> W) >>> 0;
                }
                if (F === 8 && W === 0)
                  return this.stream.getByte();
                for (; W < F; )
                  M = M << 8 | this.stream.getByte(), W += 8;
                return W -= F, this.bufferLength = W, this.buffer = M & (1 << W) - 1, M >> W;
              }
              align() {
                this.buffer = 0, this.bufferLength = 0;
              }
              readFlag() {
                return this.readBits(this.context.bitsPerFlag);
              }
              readCoordinate() {
                const F = this.context.bitsPerCoordinate, M = this.readBits(F), W = this.readBits(F), j = this.context.decode, G = F < 32 ? 1 / ((1 << F) - 1) : 23283064365386963e-26;
                return [M * G * (j[1] - j[0]) + j[0], W * G * (j[3] - j[2]) + j[2]];
              }
              readComponents() {
                const F = this.context.numComps, M = this.context.bitsPerComponent, W = M < 32 ? 1 / ((1 << M) - 1) : 23283064365386963e-26, j = this.context.decode, G = this.tmpCompsBuf;
                for (let k = 0, N = 4; k < F; k++, N += 2) {
                  const P = this.readBits(M);
                  G[k] = P * W * (j[N + 1] - j[N]) + j[N];
                }
                const U = this.tmpCsCompsBuf;
                return this.context.colorFn && this.context.colorFn(G, 0, U, 0), this.context.colorSpace.getRgb(U, 0);
              }
            }
            let T = /* @__PURE__ */ Object.create(null);
            function I(B) {
              const F = [];
              for (let M = 0; M <= B; M++) {
                const W = M / B, j = 1 - W;
                F.push(new Float32Array([j ** 3, 3 * W * j ** 2, 3 * W ** 2 * j, W ** 3]));
              }
              return F;
            }
            function _(B) {
              return T[B] ||= I(B);
            }
            function E() {
              T = /* @__PURE__ */ Object.create(null);
            }
            class R extends w {
              static MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
              static MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
              static TRIANGLE_DENSITY = 20;
              constructor(F, M, W, j, G) {
                if (super(), !(F instanceof b.BaseStream))
                  throw new g.FormatError("Mesh data is not a stream");
                const U = F.dict;
                this.shadingType = U.get("ShadingType");
                const k = U.getArray("BBox");
                this.bbox = Array.isArray(k) && k.length === 4 ? g.Util.normalizeRect(k) : null;
                const N = y.ColorSpace.parse({
                  cs: U.getRaw("CS") || U.getRaw("ColorSpace"),
                  xref: M,
                  resources: W,
                  pdfFunctionFactory: j,
                  localColorSpaceCache: G
                });
                this.background = U.has("Background") ? N.getRgb(U.get("Background"), 0) : null;
                const P = U.getRaw("Function"), D = P ? j.createFromArray(P) : null;
                this.coords = [], this.colors = [], this.figures = [];
                const H = {
                  bitsPerCoordinate: U.get("BitsPerCoordinate"),
                  bitsPerComponent: U.get("BitsPerComponent"),
                  bitsPerFlag: U.get("BitsPerFlag"),
                  decode: U.getArray("Decode"),
                  colorFn: D,
                  colorSpace: N,
                  numComps: D ? 1 : N.numComps
                }, V = new $(F, H);
                let Z = !1;
                switch (this.shadingType) {
                  case m.FREE_FORM_MESH:
                    this._decodeType4Shading(V);
                    break;
                  case m.LATTICE_FORM_MESH:
                    const ne = U.get("VerticesPerRow") | 0;
                    if (ne < 2)
                      throw new g.FormatError("Invalid VerticesPerRow");
                    this._decodeType5Shading(V, ne);
                    break;
                  case m.COONS_PATCH_MESH:
                    this._decodeType6Shading(V), Z = !0;
                    break;
                  case m.TENSOR_PATCH_MESH:
                    this._decodeType7Shading(V), Z = !0;
                    break;
                  default:
                    (0, g.unreachable)("Unsupported mesh type.");
                    break;
                }
                if (Z) {
                  this._updateBounds();
                  for (let ne = 0, K = this.figures.length; ne < K; ne++)
                    this._buildFigureFromPatch(ne);
                }
                this._updateBounds(), this._packData();
              }
              _decodeType4Shading(F) {
                const M = this.coords, W = this.colors, j = [];
                let G = 0;
                for (; F.hasData; ) {
                  const U = F.readFlag(), k = F.readCoordinate(), N = F.readComponents();
                  if (G === 0) {
                    if (!(0 <= U && U <= 2))
                      throw new g.FormatError("Unknown type4 flag");
                    switch (U) {
                      case 0:
                        G = 3;
                        break;
                      case 1:
                        j.push(j.at(-2), j.at(-1)), G = 1;
                        break;
                      case 2:
                        j.push(j.at(-3), j.at(-1)), G = 1;
                        break;
                    }
                  }
                  j.push(M.length), M.push(k), W.push(N), G--, F.align();
                }
                this.figures.push({
                  type: "triangles",
                  coords: new Int32Array(j),
                  colors: new Int32Array(j)
                });
              }
              _decodeType5Shading(F, M) {
                const W = this.coords, j = this.colors, G = [];
                for (; F.hasData; ) {
                  const U = F.readCoordinate(), k = F.readComponents();
                  G.push(W.length), W.push(U), j.push(k);
                }
                this.figures.push({
                  type: "lattice",
                  coords: new Int32Array(G),
                  colors: new Int32Array(G),
                  verticesPerRow: M
                });
              }
              _decodeType6Shading(F) {
                const M = this.coords, W = this.colors, j = new Int32Array(16), G = new Int32Array(4);
                for (; F.hasData; ) {
                  const U = F.readFlag();
                  if (!(0 <= U && U <= 3))
                    throw new g.FormatError("Unknown type6 flag");
                  const k = M.length;
                  for (let Z = 0, ne = U !== 0 ? 8 : 12; Z < ne; Z++)
                    M.push(F.readCoordinate());
                  const N = W.length;
                  for (let Z = 0, ne = U !== 0 ? 2 : 4; Z < ne; Z++)
                    W.push(F.readComponents());
                  let P, D, H, V;
                  switch (U) {
                    case 0:
                      j[12] = k + 3, j[13] = k + 4, j[14] = k + 5, j[15] = k + 6, j[8] = k + 2, j[11] = k + 7, j[4] = k + 1, j[7] = k + 8, j[0] = k, j[1] = k + 11, j[2] = k + 10, j[3] = k + 9, G[2] = N + 1, G[3] = N + 2, G[0] = N, G[1] = N + 3;
                      break;
                    case 1:
                      P = j[12], D = j[13], H = j[14], V = j[15], j[12] = V, j[13] = k + 0, j[14] = k + 1, j[15] = k + 2, j[8] = H, j[11] = k + 3, j[4] = D, j[7] = k + 4, j[0] = P, j[1] = k + 7, j[2] = k + 6, j[3] = k + 5, P = G[2], D = G[3], G[2] = D, G[3] = N, G[0] = P, G[1] = N + 1;
                      break;
                    case 2:
                      P = j[15], D = j[11], j[12] = j[3], j[13] = k + 0, j[14] = k + 1, j[15] = k + 2, j[8] = j[7], j[11] = k + 3, j[4] = D, j[7] = k + 4, j[0] = P, j[1] = k + 7, j[2] = k + 6, j[3] = k + 5, P = G[3], G[2] = G[1], G[3] = N, G[0] = P, G[1] = N + 1;
                      break;
                    case 3:
                      j[12] = j[0], j[13] = k + 0, j[14] = k + 1, j[15] = k + 2, j[8] = j[1], j[11] = k + 3, j[4] = j[2], j[7] = k + 4, j[0] = j[3], j[1] = k + 7, j[2] = k + 6, j[3] = k + 5, G[2] = G[0], G[3] = N, G[0] = G[1], G[1] = N + 1;
                      break;
                  }
                  j[5] = M.length, M.push([(-4 * M[j[0]][0] - M[j[15]][0] + 6 * (M[j[4]][0] + M[j[1]][0]) - 2 * (M[j[12]][0] + M[j[3]][0]) + 3 * (M[j[13]][0] + M[j[7]][0])) / 9, (-4 * M[j[0]][1] - M[j[15]][1] + 6 * (M[j[4]][1] + M[j[1]][1]) - 2 * (M[j[12]][1] + M[j[3]][1]) + 3 * (M[j[13]][1] + M[j[7]][1])) / 9]), j[6] = M.length, M.push([(-4 * M[j[3]][0] - M[j[12]][0] + 6 * (M[j[2]][0] + M[j[7]][0]) - 2 * (M[j[0]][0] + M[j[15]][0]) + 3 * (M[j[4]][0] + M[j[14]][0])) / 9, (-4 * M[j[3]][1] - M[j[12]][1] + 6 * (M[j[2]][1] + M[j[7]][1]) - 2 * (M[j[0]][1] + M[j[15]][1]) + 3 * (M[j[4]][1] + M[j[14]][1])) / 9]), j[9] = M.length, M.push([(-4 * M[j[12]][0] - M[j[3]][0] + 6 * (M[j[8]][0] + M[j[13]][0]) - 2 * (M[j[0]][0] + M[j[15]][0]) + 3 * (M[j[11]][0] + M[j[1]][0])) / 9, (-4 * M[j[12]][1] - M[j[3]][1] + 6 * (M[j[8]][1] + M[j[13]][1]) - 2 * (M[j[0]][1] + M[j[15]][1]) + 3 * (M[j[11]][1] + M[j[1]][1])) / 9]), j[10] = M.length, M.push([(-4 * M[j[15]][0] - M[j[0]][0] + 6 * (M[j[11]][0] + M[j[14]][0]) - 2 * (M[j[12]][0] + M[j[3]][0]) + 3 * (M[j[2]][0] + M[j[8]][0])) / 9, (-4 * M[j[15]][1] - M[j[0]][1] + 6 * (M[j[11]][1] + M[j[14]][1]) - 2 * (M[j[12]][1] + M[j[3]][1]) + 3 * (M[j[2]][1] + M[j[8]][1])) / 9]), this.figures.push({
                    type: "patch",
                    coords: new Int32Array(j),
                    colors: new Int32Array(G)
                  });
                }
              }
              _decodeType7Shading(F) {
                const M = this.coords, W = this.colors, j = new Int32Array(16), G = new Int32Array(4);
                for (; F.hasData; ) {
                  const U = F.readFlag();
                  if (!(0 <= U && U <= 3))
                    throw new g.FormatError("Unknown type7 flag");
                  const k = M.length;
                  for (let Z = 0, ne = U !== 0 ? 12 : 16; Z < ne; Z++)
                    M.push(F.readCoordinate());
                  const N = W.length;
                  for (let Z = 0, ne = U !== 0 ? 2 : 4; Z < ne; Z++)
                    W.push(F.readComponents());
                  let P, D, H, V;
                  switch (U) {
                    case 0:
                      j[12] = k + 3, j[13] = k + 4, j[14] = k + 5, j[15] = k + 6, j[8] = k + 2, j[9] = k + 13, j[10] = k + 14, j[11] = k + 7, j[4] = k + 1, j[5] = k + 12, j[6] = k + 15, j[7] = k + 8, j[0] = k, j[1] = k + 11, j[2] = k + 10, j[3] = k + 9, G[2] = N + 1, G[3] = N + 2, G[0] = N, G[1] = N + 3;
                      break;
                    case 1:
                      P = j[12], D = j[13], H = j[14], V = j[15], j[12] = V, j[13] = k + 0, j[14] = k + 1, j[15] = k + 2, j[8] = H, j[9] = k + 9, j[10] = k + 10, j[11] = k + 3, j[4] = D, j[5] = k + 8, j[6] = k + 11, j[7] = k + 4, j[0] = P, j[1] = k + 7, j[2] = k + 6, j[3] = k + 5, P = G[2], D = G[3], G[2] = D, G[3] = N, G[0] = P, G[1] = N + 1;
                      break;
                    case 2:
                      P = j[15], D = j[11], j[12] = j[3], j[13] = k + 0, j[14] = k + 1, j[15] = k + 2, j[8] = j[7], j[9] = k + 9, j[10] = k + 10, j[11] = k + 3, j[4] = D, j[5] = k + 8, j[6] = k + 11, j[7] = k + 4, j[0] = P, j[1] = k + 7, j[2] = k + 6, j[3] = k + 5, P = G[3], G[2] = G[1], G[3] = N, G[0] = P, G[1] = N + 1;
                      break;
                    case 3:
                      j[12] = j[0], j[13] = k + 0, j[14] = k + 1, j[15] = k + 2, j[8] = j[1], j[9] = k + 9, j[10] = k + 10, j[11] = k + 3, j[4] = j[2], j[5] = k + 8, j[6] = k + 11, j[7] = k + 4, j[0] = j[3], j[1] = k + 7, j[2] = k + 6, j[3] = k + 5, G[2] = G[0], G[3] = N, G[0] = G[1], G[1] = N + 1;
                      break;
                  }
                  this.figures.push({
                    type: "patch",
                    coords: new Int32Array(j),
                    colors: new Int32Array(G)
                  });
                }
              }
              _buildFigureFromPatch(F) {
                const M = this.figures[F];
                (0, g.assert)(M.type === "patch", "Unexpected patch mesh figure");
                const W = this.coords, j = this.colors, G = M.coords, U = M.colors, k = Math.min(W[G[0]][0], W[G[3]][0], W[G[12]][0], W[G[15]][0]), N = Math.min(W[G[0]][1], W[G[3]][1], W[G[12]][1], W[G[15]][1]), P = Math.max(W[G[0]][0], W[G[3]][0], W[G[12]][0], W[G[15]][0]), D = Math.max(W[G[0]][1], W[G[3]][1], W[G[12]][1], W[G[15]][1]);
                let H = Math.ceil((P - k) * R.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
                H = Math.max(R.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(R.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, H));
                let V = Math.ceil((D - N) * R.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
                V = Math.max(R.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(R.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, V));
                const Z = H + 1, ne = new Int32Array((V + 1) * Z), K = new Int32Array((V + 1) * Z);
                let q = 0;
                const Y = new Uint8Array(3), ee = new Uint8Array(3), Q = j[U[0]], J = j[U[1]], te = j[U[2]], ae = j[U[3]], se = _(V), ie = _(H);
                for (let fe = 0; fe <= V; fe++) {
                  Y[0] = (Q[0] * (V - fe) + te[0] * fe) / V | 0, Y[1] = (Q[1] * (V - fe) + te[1] * fe) / V | 0, Y[2] = (Q[2] * (V - fe) + te[2] * fe) / V | 0, ee[0] = (J[0] * (V - fe) + ae[0] * fe) / V | 0, ee[1] = (J[1] * (V - fe) + ae[1] * fe) / V | 0, ee[2] = (J[2] * (V - fe) + ae[2] * fe) / V | 0;
                  for (let ge = 0; ge <= H; ge++, q++) {
                    if ((fe === 0 || fe === V) && (ge === 0 || ge === H))
                      continue;
                    let me = 0, pe = 0, be = 0;
                    for (let ve = 0; ve <= 3; ve++)
                      for (let he = 0; he <= 3; he++, be++) {
                        const ye = se[fe][ve] * ie[ge][he];
                        me += W[G[be]][0] * ye, pe += W[G[be]][1] * ye;
                      }
                    ne[q] = W.length, W.push([me, pe]), K[q] = j.length;
                    const le = new Uint8Array(3);
                    le[0] = (Y[0] * (H - ge) + ee[0] * ge) / H | 0, le[1] = (Y[1] * (H - ge) + ee[1] * ge) / H | 0, le[2] = (Y[2] * (H - ge) + ee[2] * ge) / H | 0, j.push(le);
                  }
                }
                ne[0] = G[0], K[0] = U[0], ne[H] = G[3], K[H] = U[1], ne[Z * V] = G[12], K[Z * V] = U[2], ne[Z * V + H] = G[15], K[Z * V + H] = U[3], this.figures[F] = {
                  type: "lattice",
                  coords: ne,
                  colors: K,
                  verticesPerRow: Z
                };
              }
              _updateBounds() {
                let F = this.coords[0][0], M = this.coords[0][1], W = F, j = M;
                for (let G = 1, U = this.coords.length; G < U; G++) {
                  const k = this.coords[G][0], N = this.coords[G][1];
                  F = F > k ? k : F, M = M > N ? N : M, W = W < k ? k : W, j = j < N ? N : j;
                }
                this.bounds = [F, M, W, j];
              }
              _packData() {
                let F, M, W, j;
                const G = this.coords, U = new Float32Array(G.length * 2);
                for (F = 0, W = 0, M = G.length; F < M; F++) {
                  const D = G[F];
                  U[W++] = D[0], U[W++] = D[1];
                }
                this.coords = U;
                const k = this.colors, N = new Uint8Array(k.length * 3);
                for (F = 0, W = 0, M = k.length; F < M; F++) {
                  const D = k[F];
                  N[W++] = D[0], N[W++] = D[1], N[W++] = D[2];
                }
                this.colors = N;
                const P = this.figures;
                for (F = 0, M = P.length; F < M; F++) {
                  const D = P[F], H = D.coords, V = D.colors;
                  for (W = 0, j = H.length; W < j; W++)
                    H[W] *= 2, V[W] *= 3;
                }
              }
              getIR() {
                return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.bbox, this.background];
              }
            }
            class O extends w {
              getIR() {
                return ["Dummy"];
              }
            }
            function L(B, F, M) {
              const W = F.getArray("Matrix"), j = g.Util.normalizeRect(F.getArray("BBox")), G = F.get("XStep"), U = F.get("YStep"), k = F.get("PaintType"), N = F.get("TilingType");
              if (j[2] - j[0] === 0 || j[3] - j[1] === 0)
                throw new g.FormatError(`Invalid getTilingPatternIR /BBox array: [${j}].`);
              return ["TilingPattern", M, B, W, j, G, U, k, N];
            }
          },
          /* 51 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.getXfaFontDict = _, A.getXfaFontName = T;
            var g = x(52), b = x(4), y = x(53), f = x(54), m = x(55), C = x(56), w = x(3), S = x(38);
            const $ = (0, w.getLookupTableFactory)(function(E) {
              E["MyriadPro-Regular"] = E["PdfJS-Fallback-Regular"] = {
                name: "LiberationSans-Regular",
                factors: m.MyriadProRegularFactors,
                baseWidths: f.LiberationSansRegularWidths,
                baseMapping: f.LiberationSansRegularMapping,
                metrics: m.MyriadProRegularMetrics
              }, E["MyriadPro-Bold"] = E["PdfJS-Fallback-Bold"] = {
                name: "LiberationSans-Bold",
                factors: m.MyriadProBoldFactors,
                baseWidths: f.LiberationSansBoldWidths,
                baseMapping: f.LiberationSansBoldMapping,
                metrics: m.MyriadProBoldMetrics
              }, E["MyriadPro-It"] = E["MyriadPro-Italic"] = E["PdfJS-Fallback-Italic"] = {
                name: "LiberationSans-Italic",
                factors: m.MyriadProItalicFactors,
                baseWidths: f.LiberationSansItalicWidths,
                baseMapping: f.LiberationSansItalicMapping,
                metrics: m.MyriadProItalicMetrics
              }, E["MyriadPro-BoldIt"] = E["MyriadPro-BoldItalic"] = E["PdfJS-Fallback-BoldItalic"] = {
                name: "LiberationSans-BoldItalic",
                factors: m.MyriadProBoldItalicFactors,
                baseWidths: f.LiberationSansBoldItalicWidths,
                baseMapping: f.LiberationSansBoldItalicMapping,
                metrics: m.MyriadProBoldItalicMetrics
              }, E.ArialMT = E.Arial = E["Arial-Regular"] = {
                name: "LiberationSans-Regular",
                baseWidths: f.LiberationSansRegularWidths,
                baseMapping: f.LiberationSansRegularMapping
              }, E["Arial-BoldMT"] = E["Arial-Bold"] = {
                name: "LiberationSans-Bold",
                baseWidths: f.LiberationSansBoldWidths,
                baseMapping: f.LiberationSansBoldMapping
              }, E["Arial-ItalicMT"] = E["Arial-Italic"] = {
                name: "LiberationSans-Italic",
                baseWidths: f.LiberationSansItalicWidths,
                baseMapping: f.LiberationSansItalicMapping
              }, E["Arial-BoldItalicMT"] = E["Arial-BoldItalic"] = {
                name: "LiberationSans-BoldItalic",
                baseWidths: f.LiberationSansBoldItalicWidths,
                baseMapping: f.LiberationSansBoldItalicMapping
              }, E["Calibri-Regular"] = {
                name: "LiberationSans-Regular",
                factors: g.CalibriRegularFactors,
                baseWidths: f.LiberationSansRegularWidths,
                baseMapping: f.LiberationSansRegularMapping,
                metrics: g.CalibriRegularMetrics
              }, E["Calibri-Bold"] = {
                name: "LiberationSans-Bold",
                factors: g.CalibriBoldFactors,
                baseWidths: f.LiberationSansBoldWidths,
                baseMapping: f.LiberationSansBoldMapping,
                metrics: g.CalibriBoldMetrics
              }, E["Calibri-Italic"] = {
                name: "LiberationSans-Italic",
                factors: g.CalibriItalicFactors,
                baseWidths: f.LiberationSansItalicWidths,
                baseMapping: f.LiberationSansItalicMapping,
                metrics: g.CalibriItalicMetrics
              }, E["Calibri-BoldItalic"] = {
                name: "LiberationSans-BoldItalic",
                factors: g.CalibriBoldItalicFactors,
                baseWidths: f.LiberationSansBoldItalicWidths,
                baseMapping: f.LiberationSansBoldItalicMapping,
                metrics: g.CalibriBoldItalicMetrics
              }, E["Segoeui-Regular"] = {
                name: "LiberationSans-Regular",
                factors: C.SegoeuiRegularFactors,
                baseWidths: f.LiberationSansRegularWidths,
                baseMapping: f.LiberationSansRegularMapping,
                metrics: C.SegoeuiRegularMetrics
              }, E["Segoeui-Bold"] = {
                name: "LiberationSans-Bold",
                factors: C.SegoeuiBoldFactors,
                baseWidths: f.LiberationSansBoldWidths,
                baseMapping: f.LiberationSansBoldMapping,
                metrics: C.SegoeuiBoldMetrics
              }, E["Segoeui-Italic"] = {
                name: "LiberationSans-Italic",
                factors: C.SegoeuiItalicFactors,
                baseWidths: f.LiberationSansItalicWidths,
                baseMapping: f.LiberationSansItalicMapping,
                metrics: C.SegoeuiItalicMetrics
              }, E["Segoeui-BoldItalic"] = {
                name: "LiberationSans-BoldItalic",
                factors: C.SegoeuiBoldItalicFactors,
                baseWidths: f.LiberationSansBoldItalicWidths,
                baseMapping: f.LiberationSansBoldItalicMapping,
                metrics: C.SegoeuiBoldItalicMetrics
              }, E["Helvetica-Regular"] = E.Helvetica = {
                name: "LiberationSans-Regular",
                factors: y.HelveticaRegularFactors,
                baseWidths: f.LiberationSansRegularWidths,
                baseMapping: f.LiberationSansRegularMapping,
                metrics: y.HelveticaRegularMetrics
              }, E["Helvetica-Bold"] = {
                name: "LiberationSans-Bold",
                factors: y.HelveticaBoldFactors,
                baseWidths: f.LiberationSansBoldWidths,
                baseMapping: f.LiberationSansBoldMapping,
                metrics: y.HelveticaBoldMetrics
              }, E["Helvetica-Italic"] = {
                name: "LiberationSans-Italic",
                factors: y.HelveticaItalicFactors,
                baseWidths: f.LiberationSansItalicWidths,
                baseMapping: f.LiberationSansItalicMapping,
                metrics: y.HelveticaItalicMetrics
              }, E["Helvetica-BoldItalic"] = {
                name: "LiberationSans-BoldItalic",
                factors: y.HelveticaBoldItalicFactors,
                baseWidths: f.LiberationSansBoldItalicWidths,
                baseMapping: f.LiberationSansBoldItalicMapping,
                metrics: y.HelveticaBoldItalicMetrics
              };
            });
            function T(E) {
              const R = (0, S.normalizeFontName)(E);
              return $()[R];
            }
            function I(E) {
              const R = T(E);
              if (!R)
                return null;
              const {
                baseWidths: O,
                baseMapping: L,
                factors: B
              } = R, F = B ? O.map((G, U) => G * B[U]) : O;
              let M = -2, W;
              const j = [];
              for (const [G, U] of L.map((k, N) => [k, N]).sort(([k], [N]) => k - N))
                G !== -1 && (G === M + 1 ? (W.push(F[U]), M += 1) : (M = G, W = [F[U]], j.push(G, W)));
              return j;
            }
            function _(E) {
              const R = I(E), O = new b.Dict(null);
              O.set("BaseFont", b.Name.get(E)), O.set("Type", b.Name.get("Font")), O.set("Subtype", b.Name.get("CIDFontType2")), O.set("Encoding", b.Name.get("Identity-H")), O.set("CIDToGIDMap", b.Name.get("Identity")), O.set("W", R), O.set("FirstChar", R[0]), O.set("LastChar", R.at(-2) + R.at(-1).length - 1);
              const L = new b.Dict(null);
              O.set("FontDescriptor", L);
              const B = new b.Dict(null);
              return B.set("Ordering", "Identity"), B.set("Registry", "Adobe"), B.set("Supplement", 0), O.set("CIDSystemInfo", B), O;
            }
          },
          /* 52 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.CalibriRegularMetrics = A.CalibriRegularFactors = A.CalibriItalicMetrics = A.CalibriItalicFactors = A.CalibriBoldMetrics = A.CalibriBoldItalicMetrics = A.CalibriBoldItalicFactors = A.CalibriBoldFactors = void 0;
            const x = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.54657, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.73293, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.9121, 0.86943, 0.79795, 0.88198, 0.77958, 0.70864, 0.81055, 0.90399, 0.88653, 0.96017, 0.82577, 0.77892, 0.78257, 0.97507, 1.54657, 0.97507, 0.85284, 0.89552, 0.90176, 0.88762, 0.8785, 0.75241, 0.8785, 0.90518, 0.95015, 0.77618, 0.8785, 0.88401, 0.91916, 0.86304, 0.88401, 0.91488, 0.8785, 0.8801, 0.8785, 0.8785, 0.91343, 0.7173, 1.04106, 0.8785, 0.85075, 0.95794, 0.82616, 0.85162, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.12401, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.73293, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.9121, 0.86943, 0.86943, 0.86943, 0.86943, 0.86943, 0.85284, 0.87508, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.8715, 0.75241, 0.90518, 0.90518, 0.90518, 0.90518, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.8785, 0.8801, 0.8801, 0.8801, 0.8801, 0.8801, 0.90747, 0.89049, 0.8785, 0.8785, 0.8785, 0.8785, 0.85162, 0.8785, 0.85162, 0.83908, 0.88762, 0.83908, 0.88762, 0.83908, 0.88762, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.87289, 0.83016, 0.88506, 0.93125, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.81921, 0.77618, 0.81921, 0.77618, 0.81921, 0.77618, 1, 1, 0.87356, 0.8785, 0.91075, 0.89608, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76229, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.79468, 0.91926, 0.88175, 0.70823, 0.94903, 0.9121, 0.8785, 1, 1, 0.9121, 0.8785, 0.87802, 0.88656, 0.8785, 0.86943, 0.8801, 0.86943, 0.8801, 0.86943, 0.8801, 0.87402, 0.89291, 0.77958, 0.91343, 1, 1, 0.77958, 0.91343, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.96017, 0.95794, 0.77892, 0.85162, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.88762, 0.77539, 0.8715, 0.87508, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70674, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.06303, 0.83908, 0.80352, 0.57184, 0.6965, 0.56289, 0.82001, 0.56029, 0.81235, 1.02988, 0.83908, 0.7762, 0.68156, 0.80367, 0.73133, 0.78257, 0.87356, 0.86943, 0.95958, 0.75727, 0.89019, 1.04924, 0.9121, 0.7648, 0.86943, 0.87356, 0.79795, 0.78275, 0.81055, 0.77892, 0.9762, 0.82577, 0.99819, 0.84896, 0.95958, 0.77892, 0.96108, 1.01407, 0.89049, 1.02988, 0.94211, 0.96108, 0.8936, 0.84021, 0.87842, 0.96399, 0.79109, 0.89049, 1.00813, 1.02988, 0.86077, 0.87445, 0.92099, 0.84723, 0.86513, 0.8801, 0.75638, 0.85714, 0.78216, 0.79586, 0.87965, 0.94211, 0.97747, 0.78287, 0.97926, 0.84971, 1.02988, 0.94211, 0.8801, 0.94211, 0.84971, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90264, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90518, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90548, 1, 1, 1, 1, 1, 1, 0.96017, 0.95794, 0.96017, 0.95794, 0.96017, 0.95794, 0.77892, 0.85162, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.92794, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71143, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.93835, 0.83406, 0.91133, 0.84107, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90527, 1.81055, 0.90527, 1.81055, 1.31006, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.CalibriBoldFactors = x;
            const g = {
              lineHeight: 1.2207,
              lineGap: 0.2207
            };
            A.CalibriBoldMetrics = g;
            const b = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.56239, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.71805, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.90872, 0.85938, 0.79795, 0.87068, 0.77958, 0.69766, 0.81055, 0.90399, 0.88653, 0.96068, 0.82577, 0.77892, 0.78257, 0.97507, 1.529, 0.97507, 0.85284, 0.89552, 0.90176, 0.94908, 0.86411, 0.74012, 0.86411, 0.88323, 0.95015, 0.86411, 0.86331, 0.88401, 0.91916, 0.86304, 0.88401, 0.9039, 0.86331, 0.86331, 0.86411, 0.86411, 0.90464, 0.70852, 1.04106, 0.86331, 0.84372, 0.95794, 0.82616, 0.84548, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.19129, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.71805, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.90872, 0.85938, 0.85938, 0.85938, 0.85938, 0.85938, 0.85284, 0.87068, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.85887, 0.74012, 0.88323, 0.88323, 0.88323, 0.88323, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.90747, 0.89049, 0.86331, 0.86331, 0.86331, 0.86331, 0.84548, 0.86411, 0.84548, 0.83908, 0.94908, 0.83908, 0.94908, 0.83908, 0.94908, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.87289, 0.79538, 0.88506, 0.92726, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.81921, 0.86411, 0.81921, 0.86411, 0.81921, 0.86411, 1, 1, 0.87356, 0.86331, 0.91075, 0.8777, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76467, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.77312, 0.91926, 0.88175, 0.70823, 0.94903, 0.90872, 0.86331, 1, 1, 0.90872, 0.86331, 0.86906, 0.88116, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.87402, 0.86549, 0.77958, 0.90464, 1, 1, 0.77958, 0.90464, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.96068, 0.95794, 0.77892, 0.84548, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.94908, 0.77539, 0.85887, 0.87068, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70088, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.48387, 0.83908, 0.80352, 0.57118, 0.6965, 0.56347, 0.79179, 0.55853, 0.80346, 1.02988, 0.83908, 0.7762, 0.67174, 0.86036, 0.73133, 0.78257, 0.87356, 0.86441, 0.95958, 0.75727, 0.89019, 1.04924, 0.90872, 0.74889, 0.85938, 0.87891, 0.79795, 0.7957, 0.81055, 0.77892, 0.97447, 0.82577, 0.97466, 0.87179, 0.95958, 0.77892, 0.94252, 0.95612, 0.8753, 1.02988, 0.92733, 0.94252, 0.87411, 0.84021, 0.8728, 0.95612, 0.74081, 0.8753, 1.02189, 1.02988, 0.84814, 0.87445, 0.91822, 0.84723, 0.85668, 0.86331, 0.81344, 0.87581, 0.76422, 0.82046, 0.96057, 0.92733, 0.99375, 0.78022, 0.95452, 0.86015, 1.02988, 0.92733, 0.86331, 0.92733, 0.86015, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90631, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88323, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85174, 1, 1, 1, 1, 1, 1, 0.96068, 0.95794, 0.96068, 0.95794, 0.96068, 0.95794, 0.77892, 0.84548, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.89807, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71094, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.92972, 0.83406, 0.91133, 0.83326, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90616, 1.81055, 0.90527, 1.81055, 1.3107, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.CalibriBoldItalicFactors = b;
            const y = {
              lineHeight: 1.2207,
              lineGap: 0.2207
            };
            A.CalibriBoldItalicMetrics = y;
            const f = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39543, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.72346, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89249, 0.84118, 0.77452, 0.85374, 0.75186, 0.67789, 0.79776, 0.88844, 0.85066, 0.94309, 0.77818, 0.7306, 0.76659, 1.10369, 1.38313, 1.10369, 1.06139, 0.89552, 0.8739, 0.9245, 0.9245, 0.83203, 0.9245, 0.85865, 1.09842, 0.9245, 0.9245, 1.03297, 1.07692, 0.90918, 1.03297, 0.94959, 0.9245, 0.92274, 0.9245, 0.9245, 1.02933, 0.77832, 1.20562, 0.9245, 0.8916, 0.98986, 0.86621, 0.89453, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.16359, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.72346, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89249, 0.84118, 0.84118, 0.84118, 0.84118, 0.84118, 0.85284, 0.84557, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.84843, 0.83203, 0.85865, 0.85865, 0.85865, 0.85865, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.9245, 0.92274, 0.92274, 0.92274, 0.92274, 0.92274, 0.90747, 0.86651, 0.9245, 0.9245, 0.9245, 0.9245, 0.89453, 0.9245, 0.89453, 0.8675, 0.9245, 0.8675, 0.9245, 0.8675, 0.9245, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.85193, 0.8875, 0.86477, 0.99034, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.81105, 0.9245, 0.81105, 0.9245, 0.81105, 0.9245, 1, 1, 0.86275, 0.9245, 0.90872, 0.93591, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77896, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.9375, 0.98156, 0.93407, 0.77261, 1.11429, 0.89249, 0.9245, 1, 1, 0.89249, 0.9245, 0.92534, 0.86698, 0.9245, 0.84118, 0.92274, 0.84118, 0.92274, 0.84118, 0.92274, 0.8667, 0.86291, 0.75186, 1.02933, 1, 1, 0.75186, 1.02933, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 1, 1, 0.79776, 0.97655, 0.79776, 1.23023, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.94309, 0.98986, 0.7306, 0.89453, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.9245, 0.76318, 0.84843, 0.84557, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67009, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.8675, 0.90861, 0.6192, 0.7363, 0.64824, 0.82411, 0.56321, 0.85696, 1.23516, 0.8675, 0.81552, 0.7286, 0.84134, 0.73206, 0.76659, 0.86275, 0.84369, 0.90685, 0.77892, 0.85871, 1.02638, 0.89249, 0.75828, 0.84118, 0.85984, 0.77452, 0.76466, 0.79776, 0.7306, 0.90782, 0.77818, 0.903, 0.87291, 0.90685, 0.7306, 0.99058, 1.03667, 0.94635, 1.23516, 0.9849, 0.99058, 0.92393, 0.8916, 0.942, 1.03667, 0.75026, 0.94635, 1.0297, 1.23516, 0.90918, 0.94048, 0.98217, 0.89746, 0.84153, 0.92274, 0.82507, 0.88832, 0.84438, 0.88178, 1.03525, 0.9849, 1.00225, 0.78086, 0.97248, 0.89404, 1.23516, 0.9849, 0.92274, 0.9849, 0.89404, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89693, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85865, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90933, 1, 1, 1, 1, 1, 1, 0.94309, 0.98986, 0.94309, 0.98986, 0.94309, 0.98986, 0.7306, 0.89453, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.68994, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.97858, 0.82616, 0.91133, 0.83437, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90572, 1.81055, 0.90749, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85284, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.CalibriItalicFactors = f;
            const m = {
              lineHeight: 1.2207,
              lineGap: 0.2207
            };
            A.CalibriItalicMetrics = m;
            const C = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39016, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.73834, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89385, 0.85122, 0.77452, 0.86503, 0.75186, 0.68887, 0.79776, 0.88844, 0.85066, 0.94258, 0.77818, 0.7306, 0.76659, 1.10369, 1.39016, 1.10369, 1.06139, 0.89552, 0.8739, 0.86128, 0.94469, 0.8457, 0.94469, 0.89464, 1.09842, 0.84636, 0.94469, 1.03297, 1.07692, 0.90918, 1.03297, 0.95897, 0.94469, 0.9482, 0.94469, 0.94469, 1.04692, 0.78223, 1.20562, 0.94469, 0.90332, 0.98986, 0.86621, 0.90527, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.08707, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.73834, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89385, 0.85122, 0.85122, 0.85122, 0.85122, 0.85122, 0.85284, 0.85311, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.8693, 0.8457, 0.89464, 0.89464, 0.89464, 0.89464, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.94469, 0.9482, 0.9482, 0.9482, 0.9482, 0.9482, 0.90747, 0.86651, 0.94469, 0.94469, 0.94469, 0.94469, 0.90527, 0.94469, 0.90527, 0.8675, 0.86128, 0.8675, 0.86128, 0.8675, 0.86128, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.85193, 0.92454, 0.86477, 0.9921, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.81105, 0.84636, 0.81105, 0.84636, 0.81105, 0.84636, 1, 1, 0.86275, 0.94469, 0.90872, 0.95786, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77741, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.90452, 0.98156, 1.11842, 0.77261, 1.11429, 0.89385, 0.94469, 1, 1, 0.89385, 0.94469, 0.95877, 0.86901, 0.94469, 0.85122, 0.9482, 0.85122, 0.9482, 0.85122, 0.9482, 0.8667, 0.90016, 0.75186, 1.04692, 1, 1, 0.75186, 1.04692, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 1, 1, 0.79776, 0.92188, 0.79776, 1.23023, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.94258, 0.98986, 0.7306, 0.90527, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.86128, 0.76318, 0.8693, 0.85311, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67742, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.86686, 0.90861, 0.62267, 0.74359, 0.65649, 0.85498, 0.56963, 0.88254, 1.23516, 0.8675, 0.81552, 0.75443, 0.84503, 0.73206, 0.76659, 0.86275, 0.85122, 0.90685, 0.77892, 0.85746, 1.02638, 0.89385, 0.75657, 0.85122, 0.86275, 0.77452, 0.74171, 0.79776, 0.7306, 0.95165, 0.77818, 0.89772, 0.88831, 0.90685, 0.7306, 0.98142, 1.02191, 0.96576, 1.23516, 0.99018, 0.98142, 0.9236, 0.89258, 0.94035, 1.02191, 0.78848, 0.96576, 0.9561, 1.23516, 0.90918, 0.92578, 0.95424, 0.89746, 0.83969, 0.9482, 0.80113, 0.89442, 0.85208, 0.86155, 0.98022, 0.99018, 1.00452, 0.81209, 0.99247, 0.89181, 1.23516, 0.99018, 0.9482, 0.99018, 0.89181, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88844, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89464, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96766, 1, 1, 1, 1, 1, 1, 0.94258, 0.98986, 0.94258, 0.98986, 0.94258, 0.98986, 0.7306, 0.90527, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.69043, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.99331, 0.82616, 0.91133, 0.84286, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90527, 1.81055, 0.90527, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1.07185, 0.99413, 0.96334, 1.08065, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.CalibriRegularFactors = C;
            const w = {
              lineHeight: 1.2207,
              lineGap: 0.2207
            };
            A.CalibriRegularMetrics = w;
          },
          /* 53 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.HelveticaRegularMetrics = A.HelveticaRegularFactors = A.HelveticaItalicMetrics = A.HelveticaItalicFactors = A.HelveticaBoldMetrics = A.HelveticaBoldItalicMetrics = A.HelveticaBoldItalicFactors = A.HelveticaBoldFactors = void 0;
            const x = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.03374, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.00042, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.03828, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00034, 0.99977, 1, 0.99997, 1.00026, 1.00078, 1.00036, 0.99973, 1.00013, 1.0006, 0.99977, 0.99977, 0.99988, 0.85148, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 1.00069, 1.00022, 0.99977, 1.00001, 0.99984, 1.00026, 1.00001, 1.00024, 1.00001, 0.9999, 1, 1.0006, 1.00001, 1.00041, 0.99962, 1.00026, 1.0006, 0.99995, 1.00041, 0.99942, 0.99973, 0.99927, 1.00082, 0.99902, 1.00026, 1.00087, 1.0006, 1.00069, 0.99973, 0.99867, 0.99973, 0.9993, 1.00026, 1.00049, 1.00056, 1, 0.99988, 0.99935, 0.99995, 0.99954, 1.00055, 0.99945, 1.00032, 1.0006, 0.99995, 1.00026, 0.99995, 1.00032, 1.00001, 1.00008, 0.99971, 1.00019, 0.9994, 1.00001, 1.0006, 1.00044, 0.99973, 1.00023, 1.00047, 1, 0.99942, 0.99561, 0.99989, 1.00035, 0.99977, 1.00035, 0.99977, 1.00019, 0.99944, 1.00001, 1.00021, 0.99926, 1.00035, 1.00035, 0.99942, 1.00048, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.99989, 1.00057, 1.00001, 0.99936, 1.00052, 1.00012, 0.99996, 1.00043, 1, 1.00035, 0.9994, 0.99976, 1.00035, 0.99973, 1.00052, 1.00041, 1.00119, 1.00037, 0.99973, 1.00002, 0.99986, 1.00041, 1.00041, 0.99902, 0.9996, 1.00034, 0.99999, 1.00026, 0.99999, 1.00026, 0.99973, 1.00052, 0.99973, 1, 0.99973, 1.00041, 1.00075, 0.9994, 1.0003, 0.99999, 1, 1.00041, 0.99955, 1, 0.99915, 0.99973, 0.99973, 1.00026, 1.00119, 0.99955, 0.99973, 1.0006, 0.99911, 1.0006, 1.00026, 0.99972, 1.00026, 0.99902, 1.00041, 0.99973, 0.99999, 1, 1, 1.00038, 1.0005, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 1.00047, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.HelveticaBoldFactors = x;
            const g = {
              lineHeight: 1.2,
              lineGap: 0.2
            };
            A.HelveticaBoldMetrics = g;
            const b = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.0044, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99971, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.01011, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99977, 1, 1, 1.00026, 0.99969, 0.99972, 0.99981, 0.9998, 1.0006, 0.99977, 0.99977, 1.00022, 0.91155, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 0.99966, 1.00022, 1.00032, 1.00001, 0.99944, 1.00026, 1.00001, 0.99968, 1.00001, 1.00047, 1, 1.0006, 1.00001, 0.99981, 1.00101, 1.00026, 1.0006, 0.99948, 0.99981, 1.00064, 0.99973, 0.99942, 1.00101, 1.00061, 1.00026, 1.00069, 1.0006, 1.00014, 0.99973, 1.01322, 0.99973, 1.00065, 1.00026, 1.00012, 0.99923, 1, 1.00064, 1.00076, 0.99948, 1.00055, 1.00063, 1.00007, 0.99943, 1.0006, 0.99948, 1.00026, 0.99948, 0.99943, 1.00001, 1.00001, 1.00029, 1.00038, 1.00035, 1.00001, 1.0006, 1.0006, 0.99973, 0.99978, 1.00001, 1.00057, 0.99989, 0.99967, 0.99964, 0.99967, 0.99977, 0.99999, 0.99977, 1.00038, 0.99977, 1.00001, 0.99973, 1.00066, 0.99967, 0.99967, 1.00041, 0.99998, 0.99999, 0.99977, 1.00022, 0.99967, 1.00001, 0.99977, 1.00026, 0.99964, 1.00031, 1.00001, 0.99999, 0.99999, 1, 1.00023, 1, 1, 0.99999, 1.00035, 1.00001, 0.99999, 0.99973, 0.99977, 0.99999, 1.00058, 0.99973, 0.99973, 0.99955, 0.9995, 1.00026, 1.00026, 1.00032, 0.99989, 1.00034, 0.99999, 1.00026, 1.00026, 1.00026, 0.99973, 0.45998, 0.99973, 1.00026, 0.99973, 1.00001, 0.99999, 0.99982, 0.99994, 0.99996, 1, 1.00042, 1.00044, 1.00029, 1.00023, 0.99973, 0.99973, 1.00026, 0.99949, 1.00002, 0.99973, 1.0006, 1.0006, 1.0006, 0.99975, 1.00026, 1.00026, 1.00032, 0.98685, 0.99973, 1.00026, 1, 1, 0.99966, 1.00044, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1, 0.99973, 0.99971, 0.99978, 1, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00098, 1, 1, 1, 1.00049, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.HelveticaBoldItalicFactors = b;
            const y = {
              lineHeight: 1.35,
              lineGap: 0.2
            };
            A.HelveticaBoldItalicMetrics = y;
            const f = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.0288, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 0.99946, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.06311, 0.99973, 1.00024, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00041, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.89547, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00001, 1, 1.00054, 0.99977, 1.00084, 1.00007, 0.99973, 1.00013, 0.99924, 1.00001, 1.00001, 0.99945, 0.91221, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00001, 0.99999, 0.99977, 0.99933, 1.00022, 1.00054, 1.00001, 1.00065, 1.00026, 1.00001, 1.0001, 1.00001, 1.00052, 1, 1.0006, 1.00001, 0.99945, 0.99897, 0.99968, 0.99924, 1.00036, 0.99945, 0.99949, 1, 1.0006, 0.99897, 0.99918, 0.99968, 0.99911, 0.99924, 1, 0.99962, 1.01487, 1, 1.0005, 0.99973, 1.00012, 1.00043, 1, 0.99995, 0.99994, 1.00036, 0.99947, 1.00019, 1.00063, 1.00025, 0.99924, 1.00036, 0.99973, 1.00036, 1.00025, 1.00001, 1.00001, 1.00027, 1.0001, 1.00068, 1.00001, 1.0006, 1.0006, 1, 1.00008, 0.99957, 0.99972, 0.9994, 0.99954, 0.99975, 1.00051, 1.00001, 1.00019, 1.00001, 1.0001, 0.99986, 1.00001, 1.00001, 1.00038, 0.99954, 0.99954, 0.9994, 1.00066, 0.99999, 0.99977, 1.00022, 1.00054, 1.00001, 0.99977, 1.00026, 0.99975, 1.0001, 1.00001, 0.99993, 0.9995, 0.99955, 1.00016, 0.99978, 0.99974, 1.00019, 1.00022, 0.99955, 1.00053, 0.99973, 1.00089, 1.00005, 0.99967, 1.00048, 0.99973, 1.00002, 1.00034, 0.99973, 0.99973, 0.99964, 1.00006, 1.00066, 0.99947, 0.99973, 0.98894, 0.99973, 1, 0.44898, 1, 0.99946, 1, 1.00039, 1.00082, 0.99991, 0.99991, 0.99985, 1.00022, 1.00023, 1.00061, 1.00006, 0.99966, 0.99973, 0.99973, 0.99973, 1.00019, 1.0008, 1, 0.99924, 0.99924, 0.99924, 0.99983, 1.00044, 0.99973, 0.99964, 0.98332, 1, 0.99973, 1, 1, 0.99962, 0.99895, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 1.00423, 0.99925, 0.99999, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00049, 1, 1.00245, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 1.00003, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.HelveticaItalicFactors = f;
            const m = {
              lineHeight: 1.35,
              lineGap: 0.2
            };
            A.HelveticaItalicMetrics = m;
            const C = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.04596, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 1.00019, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.02572, 0.99973, 1.00005, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99999, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.84533, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99928, 1, 0.99977, 1.00013, 1.00055, 0.99947, 0.99945, 0.99941, 0.99924, 1.00001, 1.00001, 1.0004, 0.91621, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00005, 0.99999, 0.99977, 1.00015, 1.00022, 0.99977, 1.00001, 0.99973, 1.00026, 1.00001, 1.00019, 1.00001, 0.99946, 1, 1.0006, 1.00001, 0.99978, 1.00045, 0.99973, 0.99924, 1.00023, 0.99978, 0.99966, 1, 1.00065, 1.00045, 1.00019, 0.99973, 0.99973, 0.99924, 1, 1, 0.96499, 1, 1.00055, 0.99973, 1.00008, 1.00027, 1, 0.9997, 0.99995, 1.00023, 0.99933, 1.00019, 1.00015, 1.00031, 0.99924, 1.00023, 0.99973, 1.00023, 1.00031, 1.00001, 0.99928, 1.00029, 1.00092, 1.00035, 1.00001, 1.0006, 1.0006, 1, 0.99988, 0.99975, 1, 1.00082, 0.99561, 0.9996, 1.00035, 1.00001, 0.99962, 1.00001, 1.00092, 0.99964, 1.00001, 0.99963, 0.99999, 1.00035, 1.00035, 1.00082, 0.99962, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.9996, 0.99967, 1.00001, 1.00034, 1.00074, 1.00054, 1.00053, 1.00063, 0.99971, 0.99962, 1.00035, 0.99975, 0.99977, 0.99973, 1.00043, 0.99953, 1.0007, 0.99915, 0.99973, 1.00008, 0.99892, 1.00073, 1.00073, 1.00114, 0.99915, 1.00073, 0.99955, 0.99973, 1.00092, 0.99973, 1, 0.99998, 1, 1.0003, 1, 1.00043, 1.00001, 0.99969, 1.0003, 1, 1.00035, 1.00001, 0.9995, 1, 1.00092, 0.99973, 0.99973, 0.99973, 1.0007, 0.9995, 1, 0.99924, 1.0006, 0.99924, 0.99972, 1.00062, 0.99973, 1.00114, 1.00073, 1, 0.99955, 1, 1, 1.00047, 0.99968, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 0.99925, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.HelveticaRegularFactors = C;
            const w = {
              lineHeight: 1.2,
              lineGap: 0.2
            };
            A.HelveticaRegularMetrics = w;
          },
          /* 54 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.LiberationSansRegularWidths = A.LiberationSansRegularMapping = A.LiberationSansItalicWidths = A.LiberationSansItalicMapping = A.LiberationSansBoldWidths = A.LiberationSansBoldMapping = A.LiberationSansBoldItalicWidths = A.LiberationSansBoldItalicMapping = void 0;
            const x = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 719, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 785, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 385, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 465, 722, 333, 853, 906, 474, 825, 927, 838, 278, 722, 722, 601, 719, 667, 611, 722, 778, 278, 722, 667, 833, 722, 644, 778, 722, 667, 600, 611, 667, 821, 667, 809, 802, 278, 667, 615, 451, 611, 278, 582, 615, 610, 556, 606, 475, 460, 611, 541, 278, 558, 556, 612, 556, 445, 611, 766, 619, 520, 684, 446, 582, 715, 576, 753, 845, 278, 582, 611, 582, 845, 667, 669, 885, 567, 711, 667, 278, 276, 556, 1094, 1062, 875, 610, 722, 622, 719, 722, 719, 722, 567, 712, 667, 904, 626, 719, 719, 610, 702, 833, 722, 778, 719, 667, 722, 611, 622, 854, 667, 730, 703, 1005, 1019, 870, 979, 719, 711, 1031, 719, 556, 618, 615, 417, 635, 556, 709, 497, 615, 615, 500, 635, 740, 604, 611, 604, 611, 556, 490, 556, 875, 556, 615, 581, 833, 844, 729, 854, 615, 552, 854, 583, 556, 556, 611, 417, 552, 556, 278, 281, 278, 969, 906, 611, 500, 615, 556, 604, 778, 611, 487, 447, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1094, 556, 885, 489, 1115, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
            A.LiberationSansBoldWidths = x;
            const g = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
            A.LiberationSansBoldMapping = g;
            const b = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 740, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 782, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 396, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 722, 333, 854, 906, 473, 844, 930, 847, 278, 722, 722, 610, 671, 667, 611, 722, 778, 278, 722, 667, 833, 722, 657, 778, 718, 667, 590, 611, 667, 822, 667, 829, 781, 278, 667, 620, 479, 611, 278, 591, 620, 621, 556, 610, 479, 492, 611, 558, 278, 566, 556, 603, 556, 450, 611, 712, 605, 532, 664, 409, 591, 704, 578, 773, 834, 278, 591, 611, 591, 834, 667, 667, 886, 614, 719, 667, 278, 278, 556, 1094, 1042, 854, 622, 719, 677, 719, 722, 708, 722, 614, 722, 667, 927, 643, 719, 719, 615, 687, 833, 722, 778, 719, 667, 722, 611, 677, 781, 667, 729, 708, 979, 989, 854, 1e3, 708, 719, 1042, 729, 556, 619, 604, 534, 618, 556, 736, 510, 611, 611, 507, 622, 740, 604, 611, 611, 611, 556, 889, 556, 885, 556, 646, 583, 889, 935, 707, 854, 594, 552, 865, 589, 556, 556, 611, 469, 563, 556, 278, 278, 278, 969, 906, 611, 507, 619, 556, 611, 778, 611, 575, 467, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1104, 556, 885, 516, 1146, 1e3, 768, 600, 834, 834, 834, 834, 999, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
            A.LiberationSansBoldItalicWidths = b;
            const y = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
            A.LiberationSansBoldItalicMapping = y;
            const f = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 625, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 733, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 281, 556, 400, 556, 222, 722, 556, 722, 556, 722, 556, 615, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 354, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 789, 846, 389, 794, 865, 775, 222, 667, 667, 570, 671, 667, 611, 722, 778, 278, 667, 667, 833, 722, 648, 778, 725, 667, 600, 611, 667, 837, 667, 831, 761, 278, 667, 570, 439, 555, 222, 550, 570, 571, 500, 556, 439, 463, 555, 542, 222, 500, 492, 548, 500, 447, 556, 670, 573, 486, 603, 374, 550, 652, 546, 728, 779, 222, 550, 556, 550, 779, 667, 667, 843, 544, 708, 667, 278, 278, 500, 1066, 982, 844, 589, 715, 639, 724, 667, 651, 667, 544, 704, 667, 917, 614, 715, 715, 589, 686, 833, 722, 778, 725, 667, 722, 611, 639, 795, 667, 727, 673, 920, 923, 805, 886, 651, 694, 1022, 682, 556, 562, 522, 493, 553, 556, 688, 465, 556, 556, 472, 564, 686, 550, 556, 556, 556, 500, 833, 500, 835, 500, 572, 518, 830, 851, 621, 736, 526, 492, 752, 534, 556, 556, 556, 378, 496, 500, 222, 222, 222, 910, 828, 556, 472, 565, 500, 556, 778, 556, 492, 339, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1083, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 998, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 584, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
            A.LiberationSansItalicWidths = f;
            const m = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
            A.LiberationSansItalicMapping = m;
            const C = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 615, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 735, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 292, 556, 334, 556, 222, 722, 556, 722, 556, 722, 556, 604, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 375, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 784, 838, 384, 774, 855, 752, 222, 667, 667, 551, 668, 667, 611, 722, 778, 278, 667, 668, 833, 722, 650, 778, 722, 667, 618, 611, 667, 798, 667, 835, 748, 278, 667, 578, 446, 556, 222, 547, 578, 575, 500, 557, 446, 441, 556, 556, 222, 500, 500, 576, 500, 448, 556, 690, 569, 482, 617, 395, 547, 648, 525, 713, 781, 222, 547, 556, 547, 781, 667, 667, 865, 542, 719, 667, 278, 278, 500, 1057, 1010, 854, 583, 722, 635, 719, 667, 656, 667, 542, 677, 667, 923, 604, 719, 719, 583, 656, 833, 722, 778, 719, 667, 722, 611, 635, 760, 667, 740, 667, 917, 938, 792, 885, 656, 719, 1010, 722, 556, 573, 531, 365, 583, 556, 669, 458, 559, 559, 438, 583, 688, 552, 556, 542, 556, 500, 458, 500, 823, 500, 573, 521, 802, 823, 625, 719, 521, 510, 750, 542, 556, 556, 556, 365, 510, 500, 222, 278, 222, 906, 812, 556, 438, 559, 500, 552, 778, 556, 489, 411, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1073, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
            A.LiberationSansRegularWidths = C;
            const w = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
            A.LiberationSansRegularMapping = w;
          },
          /* 55 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.MyriadProRegularMetrics = A.MyriadProRegularFactors = A.MyriadProItalicMetrics = A.MyriadProItalicFactors = A.MyriadProBoldMetrics = A.MyriadProBoldItalicMetrics = A.MyriadProBoldItalicFactors = A.MyriadProBoldFactors = void 0;
            const x = [1.36898, 1, 1, 0.72706, 0.80479, 0.83734, 0.98894, 0.99793, 0.9897, 0.93884, 0.86209, 0.94292, 0.94292, 1.16661, 1.02058, 0.93582, 0.96694, 0.93582, 1.19137, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.72851, 0.78966, 0.90838, 0.83637, 0.82391, 0.96376, 0.80061, 0.86275, 0.8768, 0.95407, 1.0258, 0.73901, 0.85022, 0.83655, 1.0156, 0.95546, 0.92179, 0.87107, 0.92179, 0.82114, 0.8096, 0.89713, 0.94438, 0.95353, 0.94083, 0.91905, 0.90406, 0.9446, 0.94292, 1.18777, 0.94292, 1.02058, 0.89903, 0.90088, 0.94938, 0.97898, 0.81093, 0.97571, 0.94938, 1.024, 0.9577, 0.95933, 0.98621, 1.0474, 0.97455, 0.98981, 0.9672, 0.95933, 0.9446, 0.97898, 0.97407, 0.97646, 0.78036, 1.10208, 0.95442, 0.95298, 0.97579, 0.9332, 0.94039, 0.938, 0.80687, 1.01149, 0.80687, 1.02058, 0.80479, 0.99793, 0.99793, 0.99793, 0.99793, 1.01149, 1.00872, 0.90088, 0.91882, 1.0213, 0.8361, 1.02058, 0.62295, 0.54324, 0.89022, 1.08595, 1, 1, 0.90088, 1, 0.97455, 0.93582, 0.90088, 1, 1.05686, 0.8361, 0.99642, 0.99642, 0.99642, 0.72851, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.868, 0.82391, 0.80061, 0.80061, 0.80061, 0.80061, 1.0258, 1.0258, 1.0258, 1.0258, 0.97484, 0.95546, 0.92179, 0.92179, 0.92179, 0.92179, 0.92179, 1.02058, 0.92179, 0.94438, 0.94438, 0.94438, 0.94438, 0.90406, 0.86958, 0.98225, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.9031, 0.81093, 0.94938, 0.94938, 0.94938, 0.94938, 0.98621, 0.98621, 0.98621, 0.98621, 0.93969, 0.95933, 0.9446, 0.9446, 0.9446, 0.9446, 0.9446, 1.08595, 0.9446, 0.95442, 0.95442, 0.95442, 0.95442, 0.94039, 0.97898, 0.94039, 0.90838, 0.94938, 0.90838, 0.94938, 0.90838, 0.94938, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.96376, 0.84313, 0.97484, 0.97571, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.8768, 0.9577, 0.8768, 0.9577, 0.8768, 0.9577, 1, 1, 0.95407, 0.95933, 0.97069, 0.95933, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 0.887, 1.01591, 0.73901, 1.0474, 1, 1, 0.97455, 0.83655, 0.98981, 1, 1, 0.83655, 0.73977, 0.83655, 0.73903, 0.84638, 1.033, 0.95546, 0.95933, 1, 1, 0.95546, 0.95933, 0.8271, 0.95417, 0.95933, 0.92179, 0.9446, 0.92179, 0.9446, 0.92179, 0.9446, 0.936, 0.91964, 0.82114, 0.97646, 1, 1, 0.82114, 0.97646, 0.8096, 0.78036, 0.8096, 0.78036, 1, 1, 0.8096, 0.78036, 1, 1, 0.89713, 0.77452, 0.89713, 1.10208, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94083, 0.97579, 0.90406, 0.94039, 0.90406, 0.9446, 0.938, 0.9446, 0.938, 0.9446, 0.938, 1, 0.99793, 0.90838, 0.94938, 0.868, 0.9031, 0.92179, 0.9446, 1, 1, 0.89713, 1.10208, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90989, 0.9358, 0.91945, 0.83181, 0.75261, 0.87992, 0.82976, 0.96034, 0.83689, 0.97268, 1.0078, 0.90838, 0.83637, 0.8019, 0.90157, 0.80061, 0.9446, 0.95407, 0.92436, 1.0258, 0.85022, 0.97153, 1.0156, 0.95546, 0.89192, 0.92179, 0.92361, 0.87107, 0.96318, 0.89713, 0.93704, 0.95638, 0.91905, 0.91709, 0.92796, 1.0258, 0.93704, 0.94836, 1.0373, 0.95933, 1.0078, 0.95871, 0.94836, 0.96174, 0.92601, 0.9498, 0.98607, 0.95776, 0.95933, 1.05453, 1.0078, 0.98275, 0.9314, 0.95617, 0.91701, 1.05993, 0.9446, 0.78367, 0.9553, 1, 0.86832, 1.0128, 0.95871, 0.99394, 0.87548, 0.96361, 0.86774, 1.0078, 0.95871, 0.9446, 0.95871, 0.86774, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.94083, 0.97579, 0.94083, 0.97579, 0.94083, 0.97579, 0.90406, 0.94039, 0.96694, 1, 0.89903, 1, 1, 1, 0.93582, 0.93582, 0.93582, 1, 0.908, 0.908, 0.918, 0.94219, 0.94219, 0.96544, 1, 1.285, 1, 1, 0.81079, 0.81079, 1, 1, 0.74854, 1, 1, 1, 1, 0.99793, 1, 1, 1, 0.65, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.17173, 1, 0.80535, 0.76169, 1.02058, 1.0732, 1.05486, 1, 1, 1.30692, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.16161, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.MyriadProBoldFactors = x;
            const g = {
              lineHeight: 1.2,
              lineGap: 0.2
            };
            A.MyriadProBoldMetrics = g;
            const b = [1.36898, 1, 1, 0.66227, 0.80779, 0.81625, 0.97276, 0.97276, 0.97733, 0.92222, 0.83266, 0.94292, 0.94292, 1.16148, 1.02058, 0.93582, 0.96694, 0.93582, 1.17337, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.71541, 0.76813, 0.85576, 0.80591, 0.80729, 0.94299, 0.77512, 0.83655, 0.86523, 0.92222, 0.98621, 0.71743, 0.81698, 0.79726, 0.98558, 0.92222, 0.90637, 0.83809, 0.90637, 0.80729, 0.76463, 0.86275, 0.90699, 0.91605, 0.9154, 0.85308, 0.85458, 0.90531, 0.94292, 1.21296, 0.94292, 1.02058, 0.89903, 1.18616, 0.99613, 0.91677, 0.78216, 0.91677, 0.90083, 0.98796, 0.9135, 0.92168, 0.95381, 0.98981, 0.95298, 0.95381, 0.93459, 0.92168, 0.91513, 0.92004, 0.91677, 0.95077, 0.748, 1.04502, 0.91677, 0.92061, 0.94236, 0.89544, 0.89364, 0.9, 0.80687, 0.8578, 0.80687, 1.02058, 0.80779, 0.97276, 0.97276, 0.97276, 0.97276, 0.8578, 0.99973, 1.18616, 0.91339, 1.08074, 0.82891, 1.02058, 0.55509, 0.71526, 0.89022, 1.08595, 1, 1, 1.18616, 1, 0.96736, 0.93582, 1.18616, 1, 1.04864, 0.82711, 0.99043, 0.99043, 0.99043, 0.71541, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.845, 0.80729, 0.77512, 0.77512, 0.77512, 0.77512, 0.98621, 0.98621, 0.98621, 0.98621, 0.95961, 0.92222, 0.90637, 0.90637, 0.90637, 0.90637, 0.90637, 1.02058, 0.90251, 0.90699, 0.90699, 0.90699, 0.90699, 0.85458, 0.83659, 0.94951, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.85811, 0.78216, 0.90083, 0.90083, 0.90083, 0.90083, 0.95381, 0.95381, 0.95381, 0.95381, 0.9135, 0.92168, 0.91513, 0.91513, 0.91513, 0.91513, 0.91513, 1.08595, 0.91677, 0.91677, 0.91677, 0.91677, 0.91677, 0.89364, 0.92332, 0.89364, 0.85576, 0.99613, 0.85576, 0.99613, 0.85576, 0.99613, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.94299, 0.76783, 0.95961, 0.91677, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.86523, 0.9135, 0.86523, 0.9135, 0.86523, 0.9135, 1, 1, 0.92222, 0.92168, 0.92222, 0.92168, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.86036, 0.97096, 0.71743, 0.98981, 1, 1, 0.95298, 0.79726, 0.95381, 1, 1, 0.79726, 0.6894, 0.79726, 0.74321, 0.81691, 1.0006, 0.92222, 0.92168, 1, 1, 0.92222, 0.92168, 0.79464, 0.92098, 0.92168, 0.90637, 0.91513, 0.90637, 0.91513, 0.90637, 0.91513, 0.909, 0.87514, 0.80729, 0.95077, 1, 1, 0.80729, 0.95077, 0.76463, 0.748, 0.76463, 0.748, 1, 1, 0.76463, 0.748, 1, 1, 0.86275, 0.72651, 0.86275, 1.04502, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.9154, 0.94236, 0.85458, 0.89364, 0.85458, 0.90531, 0.9, 0.90531, 0.9, 0.90531, 0.9, 1, 0.97276, 0.85576, 0.99613, 0.845, 0.85811, 0.90251, 0.91677, 1, 1, 0.86275, 1.04502, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.00899, 1.30628, 0.85576, 0.80178, 0.66862, 0.7927, 0.69323, 0.88127, 0.72459, 0.89711, 0.95381, 0.85576, 0.80591, 0.7805, 0.94729, 0.77512, 0.90531, 0.92222, 0.90637, 0.98621, 0.81698, 0.92655, 0.98558, 0.92222, 0.85359, 0.90637, 0.90976, 0.83809, 0.94523, 0.86275, 0.83509, 0.93157, 0.85308, 0.83392, 0.92346, 0.98621, 0.83509, 0.92886, 0.91324, 0.92168, 0.95381, 0.90646, 0.92886, 0.90557, 0.86847, 0.90276, 0.91324, 0.86842, 0.92168, 0.99531, 0.95381, 0.9224, 0.85408, 0.92699, 0.86847, 1.0051, 0.91513, 0.80487, 0.93481, 1, 0.88159, 1.05214, 0.90646, 0.97355, 0.81539, 0.89398, 0.85923, 0.95381, 0.90646, 0.91513, 0.90646, 0.85923, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9154, 0.94236, 0.9154, 0.94236, 0.9154, 0.94236, 0.85458, 0.89364, 0.96694, 1, 0.89903, 1, 1, 1, 0.91782, 0.91782, 0.91782, 1, 0.896, 0.896, 0.896, 0.9332, 0.9332, 0.95973, 1, 1.26, 1, 1, 0.80479, 0.80178, 1, 1, 0.85633, 1, 1, 1, 1, 0.97276, 1, 1, 1, 0.698, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.14542, 1, 0.79199, 0.78694, 1.02058, 1.03493, 1.05486, 1, 1, 1.23026, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.20006, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.MyriadProBoldItalicFactors = b;
            const y = {
              lineHeight: 1.2,
              lineGap: 0.2
            };
            A.MyriadProBoldItalicMetrics = y;
            const f = [1.36898, 1, 1, 0.65507, 0.84943, 0.85639, 0.88465, 0.88465, 0.86936, 0.88307, 0.86948, 0.85283, 0.85283, 1.06383, 1.02058, 0.75945, 0.9219, 0.75945, 1.17337, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.75945, 0.75945, 1.02058, 1.02058, 1.02058, 0.69046, 0.70926, 0.85158, 0.77812, 0.76852, 0.89591, 0.70466, 0.76125, 0.80094, 0.86822, 0.83864, 0.728, 0.77212, 0.79475, 0.93637, 0.87514, 0.8588, 0.76013, 0.8588, 0.72421, 0.69866, 0.77598, 0.85991, 0.80811, 0.87832, 0.78112, 0.77512, 0.8562, 1.0222, 1.18417, 1.0222, 1.27014, 0.89903, 1.15012, 0.93859, 0.94399, 0.846, 0.94399, 0.81453, 1.0186, 0.94219, 0.96017, 1.03075, 1.02175, 0.912, 1.03075, 0.96998, 0.96017, 0.93859, 0.94399, 0.94399, 0.95493, 0.746, 1.12658, 0.94578, 0.91, 0.979, 0.882, 0.882, 0.83, 0.85034, 0.83537, 0.85034, 1.02058, 0.70869, 0.88465, 0.88465, 0.88465, 0.88465, 0.83537, 0.90083, 1.15012, 0.9161, 0.94565, 0.73541, 1.02058, 0.53609, 0.69353, 0.79519, 1.08595, 1, 1, 1.15012, 1, 0.91974, 0.75945, 1.15012, 1, 0.9446, 0.73361, 0.9005, 0.9005, 0.9005, 0.62864, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.773, 0.76852, 0.70466, 0.70466, 0.70466, 0.70466, 0.83864, 0.83864, 0.83864, 0.83864, 0.90561, 0.87514, 0.8588, 0.8588, 0.8588, 0.8588, 0.8588, 1.02058, 0.85751, 0.85991, 0.85991, 0.85991, 0.85991, 0.77512, 0.76013, 0.88075, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.8075, 0.846, 0.81453, 0.81453, 0.81453, 0.81453, 0.82424, 0.82424, 0.82424, 0.82424, 0.9278, 0.96017, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 1.08595, 0.8562, 0.94578, 0.94578, 0.94578, 0.94578, 0.882, 0.94578, 0.882, 0.85158, 0.93859, 0.85158, 0.93859, 0.85158, 0.93859, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.89591, 0.8544, 0.90561, 0.94399, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.80094, 0.94219, 0.80094, 0.94219, 0.80094, 0.94219, 1, 1, 0.86822, 0.96017, 0.86822, 0.96017, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 1.03075, 0.83864, 0.82424, 0.81402, 1.02738, 0.728, 1.02175, 1, 1, 0.912, 0.79475, 1.03075, 1, 1, 0.79475, 0.83911, 0.79475, 0.66266, 0.80553, 1.06676, 0.87514, 0.96017, 1, 1, 0.87514, 0.96017, 0.86865, 0.87396, 0.96017, 0.8588, 0.93859, 0.8588, 0.93859, 0.8588, 0.93859, 0.867, 0.84759, 0.72421, 0.95493, 1, 1, 0.72421, 0.95493, 0.69866, 0.746, 0.69866, 0.746, 1, 1, 0.69866, 0.746, 1, 1, 0.77598, 0.88417, 0.77598, 1.12658, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.87832, 0.979, 0.77512, 0.882, 0.77512, 0.8562, 0.83, 0.8562, 0.83, 0.8562, 0.83, 1, 0.88465, 0.85158, 0.93859, 0.773, 0.8075, 0.85751, 0.8562, 1, 1, 0.77598, 1.12658, 1.15012, 1.15012, 1.15012, 1.15012, 1.15012, 1.15313, 1.15012, 1.15012, 1.15012, 1.08106, 1.03901, 0.85158, 0.77025, 0.62264, 0.7646, 0.65351, 0.86026, 0.69461, 0.89947, 1.03075, 0.85158, 0.77812, 0.76449, 0.88836, 0.70466, 0.8562, 0.86822, 0.8588, 0.83864, 0.77212, 0.85308, 0.93637, 0.87514, 0.82352, 0.8588, 0.85701, 0.76013, 0.89058, 0.77598, 0.8156, 0.82565, 0.78112, 0.77899, 0.89386, 0.83864, 0.8156, 0.9486, 0.92388, 0.96186, 1.03075, 0.91123, 0.9486, 0.93298, 0.878, 0.93942, 0.92388, 0.84596, 0.96186, 0.95119, 1.03075, 0.922, 0.88787, 0.95829, 0.88, 0.93559, 0.93859, 0.78815, 0.93758, 1, 0.89217, 1.03737, 0.91123, 0.93969, 0.77487, 0.85769, 0.86799, 1.03075, 0.91123, 0.93859, 0.91123, 0.86799, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87832, 0.979, 0.87832, 0.979, 0.87832, 0.979, 0.77512, 0.882, 0.9219, 1, 0.89903, 1, 1, 1, 0.87321, 0.87321, 0.87321, 1, 1.027, 1.027, 1.027, 0.86847, 0.86847, 0.79121, 1, 1.124, 1, 1, 0.73572, 0.73572, 1, 1, 0.85034, 1, 1, 1, 1, 0.88465, 1, 1, 1, 0.669, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04828, 1, 0.74948, 0.75187, 1.02058, 0.98391, 1.02119, 1, 1, 1.06233, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05233, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.MyriadProItalicFactors = f;
            const m = {
              lineHeight: 1.2,
              lineGap: 0.2
            };
            A.MyriadProItalicMetrics = m;
            const C = [1.36898, 1, 1, 0.76305, 0.82784, 0.94935, 0.89364, 0.92241, 0.89073, 0.90706, 0.98472, 0.85283, 0.85283, 1.0664, 1.02058, 0.74505, 0.9219, 0.74505, 1.23456, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.74505, 0.74505, 1.02058, 1.02058, 1.02058, 0.73002, 0.72601, 0.91755, 0.8126, 0.80314, 0.92222, 0.73764, 0.79726, 0.83051, 0.90284, 0.86023, 0.74, 0.8126, 0.84869, 0.96518, 0.91115, 0.8858, 0.79761, 0.8858, 0.74498, 0.73914, 0.81363, 0.89591, 0.83659, 0.89633, 0.85608, 0.8111, 0.90531, 1.0222, 1.22736, 1.0222, 1.27014, 0.89903, 0.90088, 0.86667, 1.0231, 0.896, 1.01411, 0.90083, 1.05099, 1.00512, 0.99793, 1.05326, 1.09377, 0.938, 1.06226, 1.00119, 0.99793, 0.98714, 1.0231, 1.01231, 0.98196, 0.792, 1.19137, 0.99074, 0.962, 1.01915, 0.926, 0.942, 0.856, 0.85034, 0.92006, 0.85034, 1.02058, 0.69067, 0.92241, 0.92241, 0.92241, 0.92241, 0.92006, 0.9332, 0.90088, 0.91882, 0.93484, 0.75339, 1.02058, 0.56866, 0.54324, 0.79519, 1.08595, 1, 1, 0.90088, 1, 0.95325, 0.74505, 0.90088, 1, 0.97198, 0.75339, 0.91009, 0.91009, 0.91009, 0.66466, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.788, 0.80314, 0.73764, 0.73764, 0.73764, 0.73764, 0.86023, 0.86023, 0.86023, 0.86023, 0.92915, 0.91115, 0.8858, 0.8858, 0.8858, 0.8858, 0.8858, 1.02058, 0.8858, 0.89591, 0.89591, 0.89591, 0.89591, 0.8111, 0.79611, 0.89713, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86936, 0.896, 0.90083, 0.90083, 0.90083, 0.90083, 0.84224, 0.84224, 0.84224, 0.84224, 0.97276, 0.99793, 0.98714, 0.98714, 0.98714, 0.98714, 0.98714, 1.08595, 0.89876, 0.99074, 0.99074, 0.99074, 0.99074, 0.942, 1.0231, 0.942, 0.91755, 0.86667, 0.91755, 0.86667, 0.91755, 0.86667, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.92222, 0.93372, 0.92915, 1.01411, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.83051, 1.00512, 0.83051, 1.00512, 0.83051, 1.00512, 1, 1, 0.90284, 0.99793, 0.90976, 0.99793, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 1.05326, 0.86023, 0.84224, 0.82873, 1.07469, 0.74, 1.09377, 1, 1, 0.938, 0.84869, 1.06226, 1, 1, 0.84869, 0.83704, 0.84869, 0.81441, 0.85588, 1.08927, 0.91115, 0.99793, 1, 1, 0.91115, 0.99793, 0.91887, 0.90991, 0.99793, 0.8858, 0.98714, 0.8858, 0.98714, 0.8858, 0.98714, 0.894, 0.91434, 0.74498, 0.98196, 1, 1, 0.74498, 0.98196, 0.73914, 0.792, 0.73914, 0.792, 1, 1, 0.73914, 0.792, 1, 1, 0.81363, 0.904, 0.81363, 1.19137, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89633, 1.01915, 0.8111, 0.942, 0.8111, 0.90531, 0.856, 0.90531, 0.856, 0.90531, 0.856, 1, 0.92241, 0.91755, 0.86667, 0.788, 0.86936, 0.8858, 0.89876, 1, 1, 0.81363, 1.19137, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90388, 1.03901, 0.92138, 0.78105, 0.7154, 0.86169, 0.80513, 0.94007, 0.82528, 0.98612, 1.06226, 0.91755, 0.8126, 0.81884, 0.92819, 0.73764, 0.90531, 0.90284, 0.8858, 0.86023, 0.8126, 0.91172, 0.96518, 0.91115, 0.83089, 0.8858, 0.87791, 0.79761, 0.89297, 0.81363, 0.88157, 0.89992, 0.85608, 0.81992, 0.94307, 0.86023, 0.88157, 0.95308, 0.98699, 0.99793, 1.06226, 0.95817, 0.95308, 0.97358, 0.928, 0.98088, 0.98699, 0.92761, 0.99793, 0.96017, 1.06226, 0.986, 0.944, 0.95978, 0.938, 0.96705, 0.98714, 0.80442, 0.98972, 1, 0.89762, 1.04552, 0.95817, 0.99007, 0.87064, 0.91879, 0.88888, 1.06226, 0.95817, 0.98714, 0.95817, 0.88888, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89633, 1.01915, 0.89633, 1.01915, 0.89633, 1.01915, 0.8111, 0.942, 0.9219, 1, 0.89903, 1, 1, 1, 0.93173, 0.93173, 0.93173, 1, 1.06304, 1.06304, 1.06904, 0.89903, 0.89903, 0.80549, 1, 1.156, 1, 1, 0.76575, 0.76575, 1, 1, 0.72458, 1, 1, 1, 1, 0.92241, 1, 1, 1, 0.619, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.07257, 1, 0.74705, 0.71119, 1.02058, 1.024, 1.02119, 1, 1, 1.1536, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05638, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.MyriadProRegularFactors = C;
            const w = {
              lineHeight: 1.2,
              lineGap: 0.2
            };
            A.MyriadProRegularMetrics = w;
          },
          /* 56 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.SegoeuiRegularMetrics = A.SegoeuiRegularFactors = A.SegoeuiItalicMetrics = A.SegoeuiItalicFactors = A.SegoeuiBoldMetrics = A.SegoeuiBoldItalicMetrics = A.SegoeuiBoldItalicFactors = A.SegoeuiBoldFactors = void 0;
            const x = [1.76738, 1, 1, 0.99297, 0.9824, 1.04016, 1.06497, 1.03424, 0.97529, 1.17647, 1.23203, 1.1085, 1.1085, 1.16939, 1.2107, 0.9754, 1.21408, 0.9754, 1.59578, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 0.81378, 0.81378, 1.2107, 1.2107, 1.2107, 0.71703, 0.97847, 0.97363, 0.88776, 0.8641, 1.02096, 0.79795, 0.85132, 0.914, 1.06085, 1.1406, 0.8007, 0.89858, 0.83693, 1.14889, 1.09398, 0.97489, 0.92094, 0.97489, 0.90399, 0.84041, 0.95923, 1.00135, 1, 1.06467, 0.98243, 0.90996, 0.99361, 1.1085, 1.56942, 1.1085, 1.2107, 0.74627, 0.94282, 0.96752, 1.01519, 0.86304, 1.01359, 0.97278, 1.15103, 1.01359, 0.98561, 1.02285, 1.02285, 1.00527, 1.02285, 1.0302, 0.99041, 1.0008, 1.01519, 1.01359, 1.02258, 0.79104, 1.16862, 0.99041, 0.97454, 1.02511, 0.99298, 0.96752, 0.95801, 0.94856, 1.16579, 0.94856, 1.2107, 0.9824, 1.03424, 1.03424, 1, 1.03424, 1.16579, 0.8727, 1.3871, 1.18622, 1.10818, 1.04478, 1.2107, 1.18622, 0.75155, 0.94994, 1.28826, 1.21408, 1.21408, 0.91056, 1, 0.91572, 0.9754, 0.64663, 1.18328, 1.24866, 1.04478, 1.14169, 1.15749, 1.17389, 0.71703, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.93506, 0.8641, 0.79795, 0.79795, 0.79795, 0.79795, 1.1406, 1.1406, 1.1406, 1.1406, 1.02096, 1.09398, 0.97426, 0.97426, 0.97426, 0.97426, 0.97426, 1.2107, 0.97489, 1.00135, 1.00135, 1.00135, 1.00135, 0.90996, 0.92094, 1.02798, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.93136, 0.86304, 0.97278, 0.97278, 0.97278, 0.97278, 1.02285, 1.02285, 1.02285, 1.02285, 0.97122, 0.99041, 1, 1, 1, 1, 1, 1.28826, 1.0008, 0.99041, 0.99041, 0.99041, 0.99041, 0.96752, 1.01519, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 1.02096, 1.03057, 1.02096, 1.03517, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.914, 1.01359, 0.914, 1.01359, 0.914, 1.01359, 1, 1, 1.06085, 0.98561, 1.06085, 1.00879, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 0.97138, 1.08692, 0.8007, 1.02285, 1, 1, 1.00527, 0.83693, 1.02285, 1, 1, 0.83693, 0.9455, 0.83693, 0.90418, 0.83693, 1.13005, 1.09398, 0.99041, 1, 1, 1.09398, 0.99041, 0.96692, 1.09251, 0.99041, 0.97489, 1.0008, 0.97489, 1.0008, 0.97489, 1.0008, 0.93994, 0.97931, 0.90399, 1.02258, 1, 1, 0.90399, 1.02258, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 1, 1, 0.95923, 1.07034, 0.95923, 1.16862, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.06467, 1.02511, 0.90996, 0.96752, 0.90996, 0.99361, 0.95801, 0.99361, 0.95801, 0.99361, 0.95801, 1.07733, 1.03424, 0.97363, 0.96752, 0.93506, 0.93136, 0.97489, 1.0008, 1, 1, 0.95923, 1.16862, 1.15103, 1.15103, 1.01173, 1.03959, 0.75953, 0.81378, 0.79912, 1.15103, 1.21994, 0.95161, 0.87815, 1.01149, 0.81525, 0.7676, 0.98167, 1.01134, 1.02546, 0.84097, 1.03089, 1.18102, 0.97363, 0.88776, 0.85134, 0.97826, 0.79795, 0.99361, 1.06085, 0.97489, 1.1406, 0.89858, 1.0388, 1.14889, 1.09398, 0.86039, 0.97489, 1.0595, 0.92094, 0.94793, 0.95923, 0.90996, 0.99346, 0.98243, 1.02112, 0.95493, 1.1406, 0.90996, 1.03574, 1.02597, 1.0008, 1.18102, 1.06628, 1.03574, 1.0192, 1.01932, 1.00886, 0.97531, 1.0106, 1.0008, 1.13189, 1.18102, 1.02277, 0.98683, 1.0016, 0.99561, 1.07237, 1.0008, 0.90434, 0.99921, 0.93803, 0.8965, 1.23085, 1.06628, 1.04983, 0.96268, 1.0499, 0.98439, 1.18102, 1.06628, 1.0008, 1.06628, 0.98439, 0.79795, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09466, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.97278, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.02065, 1, 1, 1, 1, 1, 1, 1.06467, 1.02511, 1.06467, 1.02511, 1.06467, 1.02511, 0.90996, 0.96752, 1, 1.21408, 0.89903, 1, 1, 0.75155, 1.04394, 1.04394, 1.04394, 1.04394, 0.98633, 0.98633, 0.98633, 0.73047, 0.73047, 1.20642, 0.91211, 1.25635, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.12454, 0.93503, 1.03424, 1.19687, 1.03424, 1, 1, 1, 0.771, 1, 1, 1.15749, 1.15749, 1.15749, 1.10948, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.16897, 1, 0.96085, 0.90137, 1.2107, 1.18416, 1.13973, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21172, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18874, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.09193, 1.09193, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.SegoeuiBoldFactors = x;
            const g = {
              lineHeight: 1.33008,
              lineGap: 0
            };
            A.SegoeuiBoldMetrics = g;
            const b = [1.76738, 1, 1, 0.98946, 1.03959, 1.04016, 1.02809, 1.036, 0.97639, 1.10953, 1.23203, 1.11144, 1.11144, 1.16939, 1.21237, 0.9754, 1.21261, 0.9754, 1.59754, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 0.81378, 0.81378, 1.21237, 1.21237, 1.21237, 0.73541, 0.97847, 0.97363, 0.89723, 0.87897, 1.0426, 0.79429, 0.85292, 0.91149, 1.05815, 1.1406, 0.79631, 0.90128, 0.83853, 1.04396, 1.10615, 0.97552, 0.94436, 0.97552, 0.88641, 0.80527, 0.96083, 1.00135, 1, 1.06777, 0.9817, 0.91142, 0.99361, 1.11144, 1.57293, 1.11144, 1.21237, 0.74627, 1.31818, 1.06585, 0.97042, 0.83055, 0.97042, 0.93503, 1.1261, 0.97042, 0.97922, 1.14236, 0.94552, 1.01054, 1.14236, 1.02471, 0.97922, 0.94165, 0.97042, 0.97042, 1.0276, 0.78929, 1.1261, 0.97922, 0.95874, 1.02197, 0.98507, 0.96752, 0.97168, 0.95107, 1.16579, 0.95107, 1.21237, 1.03959, 1.036, 1.036, 1, 1.036, 1.16579, 0.87357, 1.31818, 1.18754, 1.26781, 1.05356, 1.21237, 1.18622, 0.79487, 0.94994, 1.29004, 1.24047, 1.24047, 1.31818, 1, 0.91484, 0.9754, 1.31818, 1.1349, 1.24866, 1.05356, 1.13934, 1.15574, 1.17389, 0.73541, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.94385, 0.87897, 0.79429, 0.79429, 0.79429, 0.79429, 1.1406, 1.1406, 1.1406, 1.1406, 1.0426, 1.10615, 0.97552, 0.97552, 0.97552, 0.97552, 0.97552, 1.21237, 0.97552, 1.00135, 1.00135, 1.00135, 1.00135, 0.91142, 0.94436, 0.98721, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 0.96705, 0.83055, 0.93503, 0.93503, 0.93503, 0.93503, 1.14236, 1.14236, 1.14236, 1.14236, 0.93125, 0.97922, 0.94165, 0.94165, 0.94165, 0.94165, 0.94165, 1.29004, 0.94165, 0.97922, 0.97922, 0.97922, 0.97922, 0.96752, 0.97042, 0.96752, 0.97363, 1.06585, 0.97363, 1.06585, 0.97363, 1.06585, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 1.0426, 1.0033, 1.0426, 0.97042, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.91149, 0.97042, 0.91149, 0.97042, 0.91149, 0.97042, 1, 1, 1.05815, 0.97922, 1.05815, 0.97922, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 0.97441, 1.04302, 0.79631, 1.01582, 1, 1, 1.01054, 0.83853, 1.14236, 1, 1, 0.83853, 1.09125, 0.83853, 0.90418, 0.83853, 1.19508, 1.10615, 0.97922, 1, 1, 1.10615, 0.97922, 1.01034, 1.10466, 0.97922, 0.97552, 0.94165, 0.97552, 0.94165, 0.97552, 0.94165, 0.91602, 0.91981, 0.88641, 1.0276, 1, 1, 0.88641, 1.0276, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 1, 1, 0.96083, 1.05403, 0.95923, 1.16862, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.06777, 1.02197, 0.91142, 0.96752, 0.91142, 0.99361, 0.97168, 0.99361, 0.97168, 0.99361, 0.97168, 1.23199, 1.036, 0.97363, 1.06585, 0.94385, 0.96705, 0.97552, 0.94165, 1, 1, 0.96083, 1.1261, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 0.95161, 1.27126, 1.00811, 0.83284, 0.77702, 0.99137, 0.95253, 1.0347, 0.86142, 1.07205, 1.14236, 0.97363, 0.89723, 0.86869, 1.09818, 0.79429, 0.99361, 1.05815, 0.97552, 1.1406, 0.90128, 1.06662, 1.04396, 1.10615, 0.84918, 0.97552, 1.04694, 0.94436, 0.98015, 0.96083, 0.91142, 1.00356, 0.9817, 1.01945, 0.98999, 1.1406, 0.91142, 1.04961, 0.9898, 1.00639, 1.14236, 1.07514, 1.04961, 0.99607, 1.02897, 1.008, 0.9898, 0.95134, 1.00639, 1.11121, 1.14236, 1.00518, 0.97981, 1.02186, 1, 1.08578, 0.94165, 0.99314, 0.98387, 0.93028, 0.93377, 1.35125, 1.07514, 1.10687, 0.93491, 1.04232, 1.00351, 1.14236, 1.07514, 0.94165, 1.07514, 1.00351, 0.79429, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09097, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.93503, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96609, 1, 1, 1, 1, 1, 1, 1.06777, 1.02197, 1.06777, 1.02197, 1.06777, 1.02197, 0.91142, 0.96752, 1, 1.21261, 0.89903, 1, 1, 0.75155, 1.04745, 1.04745, 1.04745, 1.04394, 0.98633, 0.98633, 0.98633, 0.72959, 0.72959, 1.20502, 0.91406, 1.26514, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.09125, 0.93327, 1.03336, 1.16541, 1.036, 1, 1, 1, 0.771, 1, 1, 1.15574, 1.15574, 1.15574, 1.15574, 0.86364, 0.94434, 0.86279, 0.94434, 0.86224, 1, 1, 1.16798, 1, 0.96085, 0.90068, 1.21237, 1.18416, 1.13904, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21339, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18775, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.13269, 1.13269, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.SegoeuiBoldItalicFactors = b;
            const y = {
              lineHeight: 1.33008,
              lineGap: 0
            };
            A.SegoeuiBoldItalicMetrics = y;
            const f = [1.76738, 1, 1, 0.98946, 1.14763, 1.05365, 1.06234, 0.96927, 0.92586, 1.15373, 1.18414, 0.91349, 0.91349, 1.07403, 1.17308, 0.78383, 1.20088, 0.78383, 1.42531, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78383, 0.78383, 1.17308, 1.17308, 1.17308, 0.77349, 0.94565, 0.94729, 0.85944, 0.88506, 0.9858, 0.74817, 0.80016, 0.88449, 0.98039, 0.95782, 0.69238, 0.89898, 0.83231, 0.98183, 1.03989, 0.96924, 0.86237, 0.96924, 0.80595, 0.74524, 0.86091, 0.95402, 0.94143, 0.98448, 0.8858, 0.83089, 0.93285, 1.0949, 1.39016, 1.0949, 1.45994, 0.74627, 1.04839, 0.97454, 0.97454, 0.87207, 0.97454, 0.87533, 1.06151, 0.97454, 1.00176, 1.16484, 1.08132, 0.98047, 1.16484, 1.02989, 1.01054, 0.96225, 0.97454, 0.97454, 1.06598, 0.79004, 1.16344, 1.00351, 0.94629, 0.9973, 0.91016, 0.96777, 0.9043, 0.91082, 0.92481, 0.91082, 1.17308, 0.95748, 0.96927, 0.96927, 1, 0.96927, 0.92481, 0.80597, 1.04839, 1.23393, 1.1781, 0.9245, 1.17308, 1.20808, 0.63218, 0.94261, 1.24822, 1.09971, 1.09971, 1.04839, 1, 0.85273, 0.78032, 1.04839, 1.09971, 1.22326, 0.9245, 1.09836, 1.13525, 1.15222, 0.70424, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.85498, 0.88506, 0.74817, 0.74817, 0.74817, 0.74817, 0.95782, 0.95782, 0.95782, 0.95782, 0.9858, 1.03989, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.17308, 0.96924, 0.95402, 0.95402, 0.95402, 0.95402, 0.83089, 0.86237, 0.88409, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.92916, 0.87207, 0.87533, 0.87533, 0.87533, 0.87533, 0.93146, 0.93146, 0.93146, 0.93146, 0.93854, 1.01054, 0.96225, 0.96225, 0.96225, 0.96225, 0.96225, 1.24822, 0.8761, 1.00351, 1.00351, 1.00351, 1.00351, 0.96777, 0.97454, 0.96777, 0.94729, 0.97454, 0.94729, 0.97454, 0.94729, 0.97454, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.9858, 0.95391, 0.9858, 0.97454, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.88449, 0.97454, 0.88449, 0.97454, 0.88449, 0.97454, 1, 1, 0.98039, 1.00176, 0.98039, 1.00176, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 1.16484, 0.95782, 0.93146, 0.84421, 1.12761, 0.69238, 1.08132, 1, 1, 0.98047, 0.83231, 1.16484, 1, 1, 0.84723, 1.04861, 0.84723, 0.78755, 0.83231, 1.23736, 1.03989, 1.01054, 1, 1, 1.03989, 1.01054, 0.9857, 1.03849, 1.01054, 0.96924, 0.96225, 0.96924, 0.96225, 0.96924, 0.96225, 0.92383, 0.90171, 0.80595, 1.06598, 1, 1, 0.80595, 1.06598, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 1, 1, 0.86091, 1.02759, 0.85771, 1.16344, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.98448, 0.9973, 0.83089, 0.96777, 0.83089, 0.93285, 0.9043, 0.93285, 0.9043, 0.93285, 0.9043, 1.31868, 0.96927, 0.94729, 0.97454, 0.85498, 0.92916, 0.96924, 0.8761, 1, 1, 0.86091, 1.16344, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 0.81965, 0.81965, 0.94729, 0.78032, 0.71022, 0.90883, 0.84171, 0.99877, 0.77596, 1.05734, 1.2, 0.94729, 0.85944, 0.82791, 0.9607, 0.74817, 0.93285, 0.98039, 0.96924, 0.95782, 0.89898, 0.98316, 0.98183, 1.03989, 0.78614, 0.96924, 0.97642, 0.86237, 0.86075, 0.86091, 0.83089, 0.90082, 0.8858, 0.97296, 1.01284, 0.95782, 0.83089, 1.0976, 1.04, 1.03342, 1.2, 1.0675, 1.0976, 0.98205, 1.03809, 1.05097, 1.04, 0.95364, 1.03342, 1.05401, 1.2, 1.02148, 1.0119, 1.04724, 1.0127, 1.02732, 0.96225, 0.8965, 0.97783, 0.93574, 0.94818, 1.30679, 1.0675, 1.11826, 0.99821, 1.0557, 1.0326, 1.2, 1.0675, 0.96225, 1.0675, 1.0326, 0.74817, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03754, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87533, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.98705, 1, 1, 1, 1, 1, 1, 0.98448, 0.9973, 0.98448, 0.9973, 0.98448, 0.9973, 0.83089, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 0.94945, 0.94945, 0.94945, 0.94945, 1.12317, 1.12317, 1.12317, 0.67603, 0.67603, 1.15621, 0.73584, 1.21191, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87709, 0.96927, 1.01473, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.09836, 1.09836, 1.09836, 1.01522, 0.86321, 0.94434, 0.8649, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86438, 1.17308, 1.18416, 1.14589, 0.69825, 0.97622, 1.96791, 1.24822, 1.24822, 1.17308, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.17984, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10742, 1.10742, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.SegoeuiItalicFactors = f;
            const m = {
              lineHeight: 1.33008,
              lineGap: 0
            };
            A.SegoeuiItalicMetrics = m;
            const C = [1.76738, 1, 1, 0.98594, 1.02285, 1.10454, 1.06234, 0.96927, 0.92037, 1.19985, 1.2046, 0.90616, 0.90616, 1.07152, 1.1714, 0.78032, 1.20088, 0.78032, 1.40246, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78032, 0.78032, 1.1714, 1.1714, 1.1714, 0.80597, 0.94084, 0.96706, 0.85944, 0.85734, 0.97093, 0.75842, 0.79936, 0.88198, 0.9831, 0.95782, 0.71387, 0.86969, 0.84636, 1.07796, 1.03584, 0.96924, 0.83968, 0.96924, 0.82826, 0.79649, 0.85771, 0.95132, 0.93119, 0.98965, 0.88433, 0.8287, 0.93365, 1.08612, 1.3638, 1.08612, 1.45786, 0.74627, 0.80499, 0.91484, 1.05707, 0.92383, 1.05882, 0.9403, 1.12654, 1.05882, 1.01756, 1.09011, 1.09011, 0.99414, 1.09011, 1.034, 1.01756, 1.05356, 1.05707, 1.05882, 1.04399, 0.84863, 1.21968, 1.01756, 0.95801, 1.00068, 0.91797, 0.96777, 0.9043, 0.90351, 0.92105, 0.90351, 1.1714, 0.85337, 0.96927, 0.96927, 0.99912, 0.96927, 0.92105, 0.80597, 1.2434, 1.20808, 1.05937, 0.90957, 1.1714, 1.20808, 0.75155, 0.94261, 1.24644, 1.09971, 1.09971, 0.84751, 1, 0.85273, 0.78032, 0.61584, 1.05425, 1.17914, 0.90957, 1.08665, 1.11593, 1.14169, 0.73381, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.86035, 0.85734, 0.75842, 0.75842, 0.75842, 0.75842, 0.95782, 0.95782, 0.95782, 0.95782, 0.97093, 1.03584, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.1714, 0.96924, 0.95132, 0.95132, 0.95132, 0.95132, 0.8287, 0.83968, 0.89049, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.93575, 0.92383, 0.9403, 0.9403, 0.9403, 0.9403, 0.8717, 0.8717, 0.8717, 0.8717, 1.00527, 1.01756, 1.05356, 1.05356, 1.05356, 1.05356, 1.05356, 1.24644, 0.95923, 1.01756, 1.01756, 1.01756, 1.01756, 0.96777, 1.05707, 0.96777, 0.96706, 0.91484, 0.96706, 0.91484, 0.96706, 0.91484, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.97093, 1.0969, 0.97093, 1.05882, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.88198, 1.05882, 0.88198, 1.05882, 0.88198, 1.05882, 1, 1, 0.9831, 1.01756, 0.9831, 1.01756, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 1.09011, 0.95782, 0.8717, 0.84784, 1.11551, 0.71387, 1.09011, 1, 1, 0.99414, 0.84636, 1.09011, 1, 1, 0.84636, 1.0536, 0.84636, 0.94298, 0.84636, 1.23297, 1.03584, 1.01756, 1, 1, 1.03584, 1.01756, 1.00323, 1.03444, 1.01756, 0.96924, 1.05356, 0.96924, 1.05356, 0.96924, 1.05356, 0.93066, 0.98293, 0.82826, 1.04399, 1, 1, 0.82826, 1.04399, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 1, 1, 0.85771, 1.17318, 0.85771, 1.21968, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.98965, 1.00068, 0.8287, 0.96777, 0.8287, 0.93365, 0.9043, 0.93365, 0.9043, 0.93365, 0.9043, 1.08571, 0.96927, 0.96706, 0.91484, 0.86035, 0.93575, 0.96924, 0.95923, 1, 1, 0.85771, 1.21968, 1.11437, 1.11437, 0.93109, 0.91202, 0.60411, 0.84164, 0.55572, 1.01173, 0.97361, 0.81818, 0.81818, 0.96635, 0.78032, 0.72727, 0.92366, 0.98601, 1.03405, 0.77968, 1.09799, 1.2, 0.96706, 0.85944, 0.85638, 0.96491, 0.75842, 0.93365, 0.9831, 0.96924, 0.95782, 0.86969, 0.94152, 1.07796, 1.03584, 0.78437, 0.96924, 0.98715, 0.83968, 0.83491, 0.85771, 0.8287, 0.94492, 0.88433, 0.9287, 1.0098, 0.95782, 0.8287, 1.0625, 0.98248, 1.03424, 1.2, 1.01071, 1.0625, 0.95246, 1.03809, 1.04912, 0.98248, 1.00221, 1.03424, 1.05443, 1.2, 1.04785, 0.99609, 1.00169, 1.05176, 0.99346, 1.05356, 0.9087, 1.03004, 0.95542, 0.93117, 1.23362, 1.01071, 1.07831, 1.02512, 1.05205, 1.03502, 1.2, 1.01071, 1.05356, 1.01071, 1.03502, 0.75842, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03719, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9403, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04021, 1, 1, 1, 1, 1, 1, 0.98965, 1.00068, 0.98965, 1.00068, 0.98965, 1.00068, 0.8287, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 1.03077, 1.03077, 1.03077, 1.03077, 1.13196, 1.13196, 1.13196, 0.67428, 0.67428, 1.16039, 0.73291, 1.20996, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87796, 0.96927, 1.01518, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.10539, 1.10539, 1.11358, 1.06967, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86507, 1.1714, 1.18416, 1.14589, 0.69825, 0.97622, 1.9697, 1.24822, 1.24822, 1.17238, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18083, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10938, 1.10938, 1, 1, 1, 1.05425, 1.09971, 1.09971, 1.09971, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
            A.SegoeuiRegularFactors = C;
            const w = {
              lineHeight: 1.33008,
              lineGap: 0
            };
            A.SegoeuiRegularMetrics = w;
          },
          /* 57 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.PostScriptEvaluator = A.PostScriptCompiler = A.PDFFunctionFactory = void 0, A.isPDFFunction = $;
            var g = x(4), b = x(2), y = x(58), f = x(5), m = x(59);
            class C {
              constructor({
                xref: P,
                isEvalSupported: D = !0
              }) {
                this.xref = P, this.isEvalSupported = D !== !1;
              }
              create(P) {
                const D = this.getCached(P);
                if (D)
                  return D;
                const H = S.parse({
                  xref: this.xref,
                  isEvalSupported: this.isEvalSupported,
                  fn: P instanceof g.Ref ? this.xref.fetch(P) : P
                });
                return this._cache(P, H), H;
              }
              createFromArray(P) {
                const D = this.getCached(P);
                if (D)
                  return D;
                const H = S.parseArray({
                  xref: this.xref,
                  isEvalSupported: this.isEvalSupported,
                  fnObj: P instanceof g.Ref ? this.xref.fetch(P) : P
                });
                return this._cache(P, H), H;
              }
              getCached(P) {
                let D;
                if (P instanceof g.Ref ? D = P : P instanceof g.Dict ? D = P.objId : P instanceof f.BaseStream && (D = P.dict?.objId), D) {
                  const H = this._localFunctionCache.getByRef(D);
                  if (H)
                    return H;
                }
                return null;
              }
              _cache(P, D) {
                if (!D)
                  throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
                let H;
                P instanceof g.Ref ? H = P : P instanceof g.Dict ? H = P.objId : P instanceof f.BaseStream && (H = P.dict?.objId), H && this._localFunctionCache.set(null, H, D);
              }
              get _localFunctionCache() {
                return (0, b.shadow)(this, "_localFunctionCache", new m.LocalFunctionCache());
              }
            }
            A.PDFFunctionFactory = C;
            function w(N) {
              if (!Array.isArray(N))
                return null;
              const P = N.length;
              for (let D = 0; D < P; D++)
                if (typeof N[D] != "number") {
                  const H = new Array(P);
                  for (let V = 0; V < P; V++)
                    H[V] = +N[V];
                  return H;
                }
              return N;
            }
            class S {
              static getSampleArray(P, D, H, V) {
                let Z, ne, K = 1;
                for (Z = 0, ne = P.length; Z < ne; Z++)
                  K *= P[Z];
                K *= D;
                const q = new Array(K);
                let Y = 0, ee = 0;
                const Q = 1 / (2 ** H - 1), J = V.getBytes((K * H + 7) / 8);
                let te = 0;
                for (Z = 0; Z < K; Z++) {
                  for (; Y < H; )
                    ee <<= 8, ee |= J[te++], Y += 8;
                  Y -= H, q[Z] = (ee >> Y) * Q, ee &= (1 << Y) - 1;
                }
                return q;
              }
              static parse({
                xref: P,
                isEvalSupported: D,
                fn: H
              }) {
                const V = H.dict || H;
                switch (V.get("FunctionType")) {
                  case 0:
                    return this.constructSampled({
                      xref: P,
                      isEvalSupported: D,
                      fn: H,
                      dict: V
                    });
                  case 1:
                    break;
                  case 2:
                    return this.constructInterpolated({
                      xref: P,
                      isEvalSupported: D,
                      dict: V
                    });
                  case 3:
                    return this.constructStiched({
                      xref: P,
                      isEvalSupported: D,
                      dict: V
                    });
                  case 4:
                    return this.constructPostScript({
                      xref: P,
                      isEvalSupported: D,
                      fn: H,
                      dict: V
                    });
                }
                throw new b.FormatError("Unknown type of function");
              }
              static parseArray({
                xref: P,
                isEvalSupported: D,
                fnObj: H
              }) {
                if (!Array.isArray(H))
                  return this.parse({
                    xref: P,
                    isEvalSupported: D,
                    fn: H
                  });
                const V = [];
                for (const Z of H)
                  V.push(this.parse({
                    xref: P,
                    isEvalSupported: D,
                    fn: P.fetchIfRef(Z)
                  }));
                return function(Z, ne, K, q) {
                  for (let Y = 0, ee = V.length; Y < ee; Y++)
                    V[Y](Z, ne, K, q + Y);
                };
              }
              static constructSampled({
                xref: P,
                isEvalSupported: D,
                fn: H,
                dict: V
              }) {
                function Z(fe) {
                  const ge = fe.length, me = [];
                  let pe = 0;
                  for (let be = 0; be < ge; be += 2)
                    me[pe++] = [fe[be], fe[be + 1]];
                  return me;
                }
                function ne(fe, ge, me, pe, be) {
                  return pe + (fe - ge) * ((be - pe) / (me - ge));
                }
                let K = w(V.getArray("Domain")), q = w(V.getArray("Range"));
                if (!K || !q)
                  throw new b.FormatError("No domain or range");
                const Y = K.length / 2, ee = q.length / 2;
                K = Z(K), q = Z(q);
                const Q = w(V.getArray("Size")), J = V.get("BitsPerSample"), te = V.get("Order") || 1;
                te !== 1 && (0, b.info)("No support for cubic spline interpolation: " + te);
                let ae = w(V.getArray("Encode"));
                if (ae)
                  ae = Z(ae);
                else {
                  ae = [];
                  for (let fe = 0; fe < Y; ++fe)
                    ae.push([0, Q[fe] - 1]);
                }
                let se = w(V.getArray("Decode"));
                se = se ? Z(se) : q;
                const ie = this.getSampleArray(Q, ee, J, H);
                return function(ge, me, pe, be) {
                  const le = 1 << Y, ve = new Float64Array(le), he = new Uint32Array(le);
                  let ye, Ce;
                  for (Ce = 0; Ce < le; Ce++)
                    ve[Ce] = 1;
                  let xe = ee, we = 1;
                  for (ye = 0; ye < Y; ++ye) {
                    const $e = K[ye][0], Ae = K[ye][1], ue = Math.min(Math.max(ge[me + ye], $e), Ae);
                    let ce = ne(ue, $e, Ae, ae[ye][0], ae[ye][1]);
                    const Ee = Q[ye];
                    ce = Math.min(Math.max(ce, 0), Ee - 1);
                    const _e = ce < Ee - 1 ? Math.floor(ce) : ce - 1, Te = _e + 1 - ce, ke = ce - _e, Re = _e * xe, Be = Re + xe;
                    for (Ce = 0; Ce < le; Ce++)
                      Ce & we ? (ve[Ce] *= ke, he[Ce] += Be) : (ve[Ce] *= Te, he[Ce] += Re);
                    xe *= Ee, we <<= 1;
                  }
                  for (Ce = 0; Ce < ee; ++Ce) {
                    let $e = 0;
                    for (ye = 0; ye < le; ye++)
                      $e += ie[he[ye] + Ce] * ve[ye];
                    $e = ne($e, 0, 1, se[Ce][0], se[Ce][1]), pe[be + Ce] = Math.min(Math.max($e, q[Ce][0]), q[Ce][1]);
                  }
                };
              }
              static constructInterpolated({
                xref: P,
                isEvalSupported: D,
                dict: H
              }) {
                const V = w(H.getArray("C0")) || [0], Z = w(H.getArray("C1")) || [1], ne = H.get("N"), K = [];
                for (let Y = 0, ee = V.length; Y < ee; ++Y)
                  K.push(Z[Y] - V[Y]);
                const q = K.length;
                return function(ee, Q, J, te) {
                  const ae = ne === 1 ? ee[Q] : ee[Q] ** ne;
                  for (let se = 0; se < q; ++se)
                    J[te + se] = V[se] + ae * K[se];
                };
              }
              static constructStiched({
                xref: P,
                isEvalSupported: D,
                dict: H
              }) {
                const V = w(H.getArray("Domain"));
                if (!V)
                  throw new b.FormatError("No domain");
                if (V.length / 2 !== 1)
                  throw new b.FormatError("Bad domain for stiched function");
                const ne = [];
                for (const ee of H.get("Functions"))
                  ne.push(this.parse({
                    xref: P,
                    isEvalSupported: D,
                    fn: P.fetchIfRef(ee)
                  }));
                const K = w(H.getArray("Bounds")), q = w(H.getArray("Encode")), Y = new Float32Array(1);
                return function(Q, J, te, ae) {
                  const ie = function(he, ye, Ce) {
                    return he > Ce ? he = Ce : he < ye && (he = ye), he;
                  }(Q[J], V[0], V[1]), fe = K.length;
                  let ge;
                  for (ge = 0; ge < fe && !(ie < K[ge]); ++ge)
                    ;
                  let me = V[0];
                  ge > 0 && (me = K[ge - 1]);
                  let pe = V[1];
                  ge < K.length && (pe = K[ge]);
                  const be = q[2 * ge], le = q[2 * ge + 1];
                  Y[0] = me === pe ? be : be + (ie - me) * (le - be) / (pe - me), ne[ge](Y, 0, te, ae);
                };
              }
              static constructPostScript({
                xref: P,
                isEvalSupported: D,
                fn: H,
                dict: V
              }) {
                const Z = w(V.getArray("Domain")), ne = w(V.getArray("Range"));
                if (!Z)
                  throw new b.FormatError("No domain.");
                if (!ne)
                  throw new b.FormatError("No range.");
                const K = new y.PostScriptLexer(H), Y = new y.PostScriptParser(K).parse();
                if (D && b.FeatureTest.isEvalSupported) {
                  const fe = new k().compile(Y, Z, ne);
                  if (fe)
                    return new Function("src", "srcOffset", "dest", "destOffset", fe);
                }
                (0, b.info)("Unable to compile PS function");
                const ee = ne.length >> 1, Q = Z.length >> 1, J = new I(Y), te = /* @__PURE__ */ Object.create(null);
                let se = 2048 * 4;
                const ie = new Float32Array(Q);
                return function(ge, me, pe, be) {
                  let le, ve, he = "";
                  const ye = ie;
                  for (le = 0; le < Q; le++)
                    ve = ge[me + le], ye[le] = ve, he += ve + "_";
                  const Ce = te[he];
                  if (Ce !== void 0) {
                    pe.set(Ce, be);
                    return;
                  }
                  const xe = new Float32Array(ee), we = J.execute(ye), $e = we.length - ee;
                  for (le = 0; le < ee; le++) {
                    ve = we[$e + le];
                    let Ae = ne[le * 2];
                    ve < Ae ? ve = Ae : (Ae = ne[le * 2 + 1], ve > Ae && (ve = Ae)), xe[le] = ve;
                  }
                  se > 0 && (se--, te[he] = xe), pe.set(xe, be);
                };
              }
            }
            function $(N) {
              let P;
              if (N instanceof g.Dict)
                P = N;
              else if (N instanceof f.BaseStream)
                P = N.dict;
              else
                return !1;
              return P.has("FunctionType");
            }
            class T {
              static MAX_STACK_SIZE = 100;
              constructor(P) {
                this.stack = P ? Array.from(P) : [];
              }
              push(P) {
                if (this.stack.length >= T.MAX_STACK_SIZE)
                  throw new Error("PostScript function stack overflow.");
                this.stack.push(P);
              }
              pop() {
                if (this.stack.length <= 0)
                  throw new Error("PostScript function stack underflow.");
                return this.stack.pop();
              }
              copy(P) {
                if (this.stack.length + P >= T.MAX_STACK_SIZE)
                  throw new Error("PostScript function stack overflow.");
                const D = this.stack;
                for (let H = D.length - P, V = P - 1; V >= 0; V--, H++)
                  D.push(D[H]);
              }
              index(P) {
                this.push(this.stack[this.stack.length - P - 1]);
              }
              roll(P, D) {
                const H = this.stack, V = H.length - P, Z = H.length - 1, ne = V + (D - Math.floor(D / P) * P);
                for (let K = V, q = Z; K < q; K++, q--) {
                  const Y = H[K];
                  H[K] = H[q], H[q] = Y;
                }
                for (let K = V, q = ne - 1; K < q; K++, q--) {
                  const Y = H[K];
                  H[K] = H[q], H[q] = Y;
                }
                for (let K = ne, q = Z; K < q; K++, q--) {
                  const Y = H[K];
                  H[K] = H[q], H[q] = Y;
                }
              }
            }
            class I {
              constructor(P) {
                this.operators = P;
              }
              execute(P) {
                const D = new T(P);
                let H = 0;
                const V = this.operators, Z = V.length;
                let ne, K, q;
                for (; H < Z; ) {
                  if (ne = V[H++], typeof ne == "number") {
                    D.push(ne);
                    continue;
                  }
                  switch (ne) {
                    case "jz":
                      q = D.pop(), K = D.pop(), K || (H = q);
                      break;
                    case "j":
                      K = D.pop(), H = K;
                      break;
                    case "abs":
                      K = D.pop(), D.push(Math.abs(K));
                      break;
                    case "add":
                      q = D.pop(), K = D.pop(), D.push(K + q);
                      break;
                    case "and":
                      q = D.pop(), K = D.pop(), typeof K == "boolean" && typeof q == "boolean" ? D.push(K && q) : D.push(K & q);
                      break;
                    case "atan":
                      q = D.pop(), K = D.pop(), K = Math.atan2(K, q) / Math.PI * 180, K < 0 && (K += 360), D.push(K);
                      break;
                    case "bitshift":
                      q = D.pop(), K = D.pop(), K > 0 ? D.push(K << q) : D.push(K >> q);
                      break;
                    case "ceiling":
                      K = D.pop(), D.push(Math.ceil(K));
                      break;
                    case "copy":
                      K = D.pop(), D.copy(K);
                      break;
                    case "cos":
                      K = D.pop(), D.push(Math.cos(K % 360 / 180 * Math.PI));
                      break;
                    case "cvi":
                      K = D.pop() | 0, D.push(K);
                      break;
                    case "cvr":
                      break;
                    case "div":
                      q = D.pop(), K = D.pop(), D.push(K / q);
                      break;
                    case "dup":
                      D.copy(1);
                      break;
                    case "eq":
                      q = D.pop(), K = D.pop(), D.push(K === q);
                      break;
                    case "exch":
                      D.roll(2, 1);
                      break;
                    case "exp":
                      q = D.pop(), K = D.pop(), D.push(K ** q);
                      break;
                    case "false":
                      D.push(!1);
                      break;
                    case "floor":
                      K = D.pop(), D.push(Math.floor(K));
                      break;
                    case "ge":
                      q = D.pop(), K = D.pop(), D.push(K >= q);
                      break;
                    case "gt":
                      q = D.pop(), K = D.pop(), D.push(K > q);
                      break;
                    case "idiv":
                      q = D.pop(), K = D.pop(), D.push(K / q | 0);
                      break;
                    case "index":
                      K = D.pop(), D.index(K);
                      break;
                    case "le":
                      q = D.pop(), K = D.pop(), D.push(K <= q);
                      break;
                    case "ln":
                      K = D.pop(), D.push(Math.log(K));
                      break;
                    case "log":
                      K = D.pop(), D.push(Math.log10(K));
                      break;
                    case "lt":
                      q = D.pop(), K = D.pop(), D.push(K < q);
                      break;
                    case "mod":
                      q = D.pop(), K = D.pop(), D.push(K % q);
                      break;
                    case "mul":
                      q = D.pop(), K = D.pop(), D.push(K * q);
                      break;
                    case "ne":
                      q = D.pop(), K = D.pop(), D.push(K !== q);
                      break;
                    case "neg":
                      K = D.pop(), D.push(-K);
                      break;
                    case "not":
                      K = D.pop(), typeof K == "boolean" ? D.push(!K) : D.push(~K);
                      break;
                    case "or":
                      q = D.pop(), K = D.pop(), typeof K == "boolean" && typeof q == "boolean" ? D.push(K || q) : D.push(K | q);
                      break;
                    case "pop":
                      D.pop();
                      break;
                    case "roll":
                      q = D.pop(), K = D.pop(), D.roll(K, q);
                      break;
                    case "round":
                      K = D.pop(), D.push(Math.round(K));
                      break;
                    case "sin":
                      K = D.pop(), D.push(Math.sin(K % 360 / 180 * Math.PI));
                      break;
                    case "sqrt":
                      K = D.pop(), D.push(Math.sqrt(K));
                      break;
                    case "sub":
                      q = D.pop(), K = D.pop(), D.push(K - q);
                      break;
                    case "true":
                      D.push(!0);
                      break;
                    case "truncate":
                      K = D.pop(), K = K < 0 ? Math.ceil(K) : Math.floor(K), D.push(K);
                      break;
                    case "xor":
                      q = D.pop(), K = D.pop(), typeof K == "boolean" && typeof q == "boolean" ? D.push(K !== q) : D.push(K ^ q);
                      break;
                    default:
                      throw new b.FormatError(`Unknown operator ${ne}`);
                  }
                }
                return D.stack;
              }
            }
            A.PostScriptEvaluator = I;
            class _ {
              constructor(P) {
                this.type = P;
              }
              visit(P) {
                (0, b.unreachable)("abstract method");
              }
            }
            class E extends _ {
              constructor(P, D, H) {
                super("args"), this.index = P, this.min = D, this.max = H;
              }
              visit(P) {
                P.visitArgument(this);
              }
            }
            class R extends _ {
              constructor(P) {
                super("literal"), this.number = P, this.min = P, this.max = P;
              }
              visit(P) {
                P.visitLiteral(this);
              }
            }
            class O extends _ {
              constructor(P, D, H, V, Z) {
                super("binary"), this.op = P, this.arg1 = D, this.arg2 = H, this.min = V, this.max = Z;
              }
              visit(P) {
                P.visitBinaryOperation(this);
              }
            }
            class L extends _ {
              constructor(P, D) {
                super("max"), this.arg = P, this.min = P.min, this.max = D;
              }
              visit(P) {
                P.visitMin(this);
              }
            }
            class B extends _ {
              constructor(P, D, H) {
                super("var"), this.index = P, this.min = D, this.max = H;
              }
              visit(P) {
                P.visitVariable(this);
              }
            }
            class F extends _ {
              constructor(P, D) {
                super("definition"), this.variable = P, this.arg = D;
              }
              visit(P) {
                P.visitVariableDefinition(this);
              }
            }
            class M {
              constructor() {
                this.parts = [];
              }
              visitArgument(P) {
                this.parts.push("Math.max(", P.min, ", Math.min(", P.max, ", src[srcOffset + ", P.index, "]))");
              }
              visitVariable(P) {
                this.parts.push("v", P.index);
              }
              visitLiteral(P) {
                this.parts.push(P.number);
              }
              visitBinaryOperation(P) {
                this.parts.push("("), P.arg1.visit(this), this.parts.push(" ", P.op, " "), P.arg2.visit(this), this.parts.push(")");
              }
              visitVariableDefinition(P) {
                this.parts.push("var "), P.variable.visit(this), this.parts.push(" = "), P.arg.visit(this), this.parts.push(";");
              }
              visitMin(P) {
                this.parts.push("Math.min("), P.arg.visit(this), this.parts.push(", ", P.max, ")");
              }
              toString() {
                return this.parts.join("");
              }
            }
            function W(N, P) {
              return P.type === "literal" && P.number === 0 ? N : N.type === "literal" && N.number === 0 ? P : P.type === "literal" && N.type === "literal" ? new R(N.number + P.number) : new O("+", N, P, N.min + P.min, N.max + P.max);
            }
            function j(N, P) {
              if (P.type === "literal") {
                if (P.number === 0)
                  return new R(0);
                if (P.number === 1)
                  return N;
                if (N.type === "literal")
                  return new R(N.number * P.number);
              }
              if (N.type === "literal") {
                if (N.number === 0)
                  return new R(0);
                if (N.number === 1)
                  return P;
              }
              const D = Math.min(N.min * P.min, N.min * P.max, N.max * P.min, N.max * P.max), H = Math.max(N.min * P.min, N.min * P.max, N.max * P.min, N.max * P.max);
              return new O("*", N, P, D, H);
            }
            function G(N, P) {
              if (P.type === "literal") {
                if (P.number === 0)
                  return N;
                if (N.type === "literal")
                  return new R(N.number - P.number);
              }
              return P.type === "binary" && P.op === "-" && N.type === "literal" && N.number === 1 && P.arg1.type === "literal" && P.arg1.number === 1 ? P.arg2 : new O("-", N, P, N.min - P.max, N.max - P.min);
            }
            function U(N, P) {
              return N.min >= P ? new R(P) : N.max <= P ? N : new L(N, P);
            }
            class k {
              compile(P, D, H) {
                const V = [], Z = [], ne = D.length >> 1, K = H.length >> 1;
                let q = 0, Y, ee, Q, J, te, ae, se, ie;
                for (let ge = 0; ge < ne; ge++)
                  V.push(new E(ge, D[ge * 2], D[ge * 2 + 1]));
                for (let ge = 0, me = P.length; ge < me; ge++) {
                  if (ie = P[ge], typeof ie == "number") {
                    V.push(new R(ie));
                    continue;
                  }
                  switch (ie) {
                    case "add":
                      if (V.length < 2)
                        return null;
                      J = V.pop(), Q = V.pop(), V.push(W(Q, J));
                      break;
                    case "cvr":
                      if (V.length < 1)
                        return null;
                      break;
                    case "mul":
                      if (V.length < 2)
                        return null;
                      J = V.pop(), Q = V.pop(), V.push(j(Q, J));
                      break;
                    case "sub":
                      if (V.length < 2)
                        return null;
                      J = V.pop(), Q = V.pop(), V.push(G(Q, J));
                      break;
                    case "exch":
                      if (V.length < 2)
                        return null;
                      te = V.pop(), ae = V.pop(), V.push(te, ae);
                      break;
                    case "pop":
                      if (V.length < 1)
                        return null;
                      V.pop();
                      break;
                    case "index":
                      if (V.length < 1 || (Q = V.pop(), Q.type !== "literal") || (Y = Q.number, Y < 0 || !Number.isInteger(Y) || V.length < Y))
                        return null;
                      if (te = V[V.length - Y - 1], te.type === "literal" || te.type === "var") {
                        V.push(te);
                        break;
                      }
                      se = new B(q++, te.min, te.max), V[V.length - Y - 1] = se, V.push(se), Z.push(new F(se, te));
                      break;
                    case "dup":
                      if (V.length < 1)
                        return null;
                      if (typeof P[ge + 1] == "number" && P[ge + 2] === "gt" && P[ge + 3] === ge + 7 && P[ge + 4] === "jz" && P[ge + 5] === "pop" && P[ge + 6] === P[ge + 1]) {
                        Q = V.pop(), V.push(U(Q, P[ge + 1])), ge += 6;
                        break;
                      }
                      if (te = V.at(-1), te.type === "literal" || te.type === "var") {
                        V.push(te);
                        break;
                      }
                      se = new B(q++, te.min, te.max), V[V.length - 1] = se, V.push(se), Z.push(new F(se, te));
                      break;
                    case "roll":
                      if (V.length < 2 || (J = V.pop(), Q = V.pop(), J.type !== "literal" || Q.type !== "literal") || (ee = J.number, Y = Q.number, Y <= 0 || !Number.isInteger(Y) || !Number.isInteger(ee) || V.length < Y))
                        return null;
                      if (ee = (ee % Y + Y) % Y, ee === 0)
                        break;
                      V.push(...V.splice(V.length - Y, Y - ee));
                      break;
                    default:
                      return null;
                  }
                }
                if (V.length !== K)
                  return null;
                const fe = [];
                for (const ge of Z) {
                  const me = new M();
                  ge.visit(me), fe.push(me.toString());
                }
                for (let ge = 0, me = V.length; ge < me; ge++) {
                  const pe = V[ge], be = new M();
                  pe.visit(be);
                  const le = H[ge * 2], ve = H[ge * 2 + 1], he = [be.toString()];
                  le > pe.min && (he.unshift("Math.max(", le, ", "), he.push(")")), ve < pe.max && (he.unshift("Math.min(", ve, ", "), he.push(")")), he.unshift("dest[destOffset + ", ge, "] = "), he.push(";"), fe.push(he.join(""));
                }
                return fe.join(`
`);
              }
            }
            A.PostScriptCompiler = k;
          },
          /* 58 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.PostScriptParser = A.PostScriptLexer = void 0;
            var g = x(2), b = x(4), y = x(3);
            class f {
              constructor($) {
                this.lexer = $, this.operators = [], this.token = null, this.prev = null;
              }
              nextToken() {
                this.prev = this.token, this.token = this.lexer.getToken();
              }
              accept($) {
                return this.token.type === $ ? (this.nextToken(), !0) : !1;
              }
              expect($) {
                if (this.accept($))
                  return !0;
                throw new g.FormatError(`Unexpected symbol: found ${this.token.type} expected ${$}.`);
              }
              parse() {
                return this.nextToken(), this.expect(m.LBRACE), this.parseBlock(), this.expect(m.RBRACE), this.operators;
              }
              parseBlock() {
                for (; ; )
                  if (this.accept(m.NUMBER))
                    this.operators.push(this.prev.value);
                  else if (this.accept(m.OPERATOR))
                    this.operators.push(this.prev.value);
                  else if (this.accept(m.LBRACE))
                    this.parseCondition();
                  else
                    return;
              }
              parseCondition() {
                const $ = this.operators.length;
                if (this.operators.push(null, null), this.parseBlock(), this.expect(m.RBRACE), this.accept(m.IF))
                  this.operators[$] = this.operators.length, this.operators[$ + 1] = "jz";
                else if (this.accept(m.LBRACE)) {
                  const T = this.operators.length;
                  this.operators.push(null, null);
                  const I = this.operators.length;
                  this.parseBlock(), this.expect(m.RBRACE), this.expect(m.IFELSE), this.operators[T] = this.operators.length, this.operators[T + 1] = "j", this.operators[$] = I, this.operators[$ + 1] = "jz";
                } else
                  throw new g.FormatError("PS Function: error parsing conditional.");
              }
            }
            A.PostScriptParser = f;
            const m = {
              LBRACE: 0,
              RBRACE: 1,
              NUMBER: 2,
              OPERATOR: 3,
              IF: 4,
              IFELSE: 5
            };
            class C {
              static get opCache() {
                return (0, g.shadow)(this, "opCache", /* @__PURE__ */ Object.create(null));
              }
              constructor($, T) {
                this.type = $, this.value = T;
              }
              static getOperator($) {
                return C.opCache[$] ||= new C(m.OPERATOR, $);
              }
              static get LBRACE() {
                return (0, g.shadow)(this, "LBRACE", new C(m.LBRACE, "{"));
              }
              static get RBRACE() {
                return (0, g.shadow)(this, "RBRACE", new C(m.RBRACE, "}"));
              }
              static get IF() {
                return (0, g.shadow)(this, "IF", new C(m.IF, "IF"));
              }
              static get IFELSE() {
                return (0, g.shadow)(this, "IFELSE", new C(m.IFELSE, "IFELSE"));
              }
            }
            class w {
              constructor($) {
                this.stream = $, this.nextChar(), this.strBuf = [];
              }
              nextChar() {
                return this.currentChar = this.stream.getByte();
              }
              getToken() {
                let $ = !1, T = this.currentChar;
                for (; ; ) {
                  if (T < 0)
                    return b.EOF;
                  if ($)
                    (T === 10 || T === 13) && ($ = !1);
                  else if (T === 37)
                    $ = !0;
                  else if (!(0, y.isWhiteSpace)(T))
                    break;
                  T = this.nextChar();
                }
                switch (T | 0) {
                  case 48:
                  case 49:
                  case 50:
                  case 51:
                  case 52:
                  case 53:
                  case 54:
                  case 55:
                  case 56:
                  case 57:
                  case 43:
                  case 45:
                  case 46:
                    return new C(m.NUMBER, this.getNumber());
                  case 123:
                    return this.nextChar(), C.LBRACE;
                  case 125:
                    return this.nextChar(), C.RBRACE;
                }
                const I = this.strBuf;
                for (I.length = 0, I[0] = String.fromCharCode(T); (T = this.nextChar()) >= 0 && (T >= 65 && T <= 90 || T >= 97 && T <= 122); )
                  I.push(String.fromCharCode(T));
                const _ = I.join("");
                switch (_.toLowerCase()) {
                  case "if":
                    return C.IF;
                  case "ifelse":
                    return C.IFELSE;
                  default:
                    return C.getOperator(_);
                }
              }
              getNumber() {
                let $ = this.currentChar;
                const T = this.strBuf;
                for (T.length = 0, T[0] = String.fromCharCode($); ($ = this.nextChar()) >= 0 && ($ >= 48 && $ <= 57 || $ === 45 || $ === 46); )
                  T.push(String.fromCharCode($));
                const I = parseFloat(T.join(""));
                if (isNaN(I))
                  throw new g.FormatError(`Invalid floating point number: ${I}`);
                return I;
              }
            }
            A.PostScriptLexer = w;
          },
          /* 59 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.RegionalImageCache = A.LocalTilingPatternCache = A.LocalImageCache = A.LocalGStateCache = A.LocalFunctionCache = A.LocalColorSpaceCache = A.GlobalImageCache = void 0;
            var g = x(2), b = x(4);
            class y {
              constructor(_) {
                this.constructor === y && (0, g.unreachable)("Cannot initialize BaseLocalCache."), this._onlyRefs = _?.onlyRefs === !0, this._onlyRefs || (this._nameRefMap = /* @__PURE__ */ new Map(), this._imageMap = /* @__PURE__ */ new Map()), this._imageCache = new b.RefSetCache();
              }
              getByName(_) {
                this._onlyRefs && (0, g.unreachable)("Should not call `getByName` method.");
                const E = this._nameRefMap.get(_);
                return E ? this.getByRef(E) : this._imageMap.get(_) || null;
              }
              getByRef(_) {
                return this._imageCache.get(_) || null;
              }
              set(_, E, R) {
                (0, g.unreachable)("Abstract method `set` called.");
              }
            }
            class f extends y {
              set(_, E = null, R) {
                if (typeof _ != "string")
                  throw new Error('LocalImageCache.set - expected "name" argument.');
                if (E) {
                  if (this._imageCache.has(E))
                    return;
                  this._nameRefMap.set(_, E), this._imageCache.put(E, R);
                  return;
                }
                this._imageMap.has(_) || this._imageMap.set(_, R);
              }
            }
            A.LocalImageCache = f;
            class m extends y {
              set(_ = null, E = null, R) {
                if (typeof _ != "string" && !E)
                  throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
                if (E) {
                  if (this._imageCache.has(E))
                    return;
                  _ !== null && this._nameRefMap.set(_, E), this._imageCache.put(E, R);
                  return;
                }
                this._imageMap.has(_) || this._imageMap.set(_, R);
              }
            }
            A.LocalColorSpaceCache = m;
            class C extends y {
              constructor(_) {
                super({
                  onlyRefs: !0
                });
              }
              set(_ = null, E, R) {
                if (!E)
                  throw new Error('LocalFunctionCache.set - expected "ref" argument.');
                this._imageCache.has(E) || this._imageCache.put(E, R);
              }
            }
            A.LocalFunctionCache = C;
            class w extends y {
              set(_, E = null, R) {
                if (typeof _ != "string")
                  throw new Error('LocalGStateCache.set - expected "name" argument.');
                if (E) {
                  if (this._imageCache.has(E))
                    return;
                  this._nameRefMap.set(_, E), this._imageCache.put(E, R);
                  return;
                }
                this._imageMap.has(_) || this._imageMap.set(_, R);
              }
            }
            A.LocalGStateCache = w;
            class S extends y {
              constructor(_) {
                super({
                  onlyRefs: !0
                });
              }
              set(_ = null, E, R) {
                if (!E)
                  throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
                this._imageCache.has(E) || this._imageCache.put(E, R);
              }
            }
            A.LocalTilingPatternCache = S;
            class $ extends y {
              constructor(_) {
                super({
                  onlyRefs: !0
                });
              }
              set(_ = null, E, R) {
                if (!E)
                  throw new Error('RegionalImageCache.set - expected "ref" argument.');
                this._imageCache.has(E) || this._imageCache.put(E, R);
              }
            }
            A.RegionalImageCache = $;
            class T {
              static NUM_PAGES_THRESHOLD = 2;
              static MIN_IMAGES_TO_CACHE = 10;
              static MAX_BYTE_SIZE = 5 * g.MAX_IMAGE_SIZE_TO_CACHE;
              constructor() {
                this._refCache = new b.RefSetCache(), this._imageCache = new b.RefSetCache();
              }
              get _byteSize() {
                let _ = 0;
                for (const E of this._imageCache)
                  _ += E.byteSize;
                return _;
              }
              get _cacheLimitReached() {
                return !(this._imageCache.size < T.MIN_IMAGES_TO_CACHE || this._byteSize < T.MAX_BYTE_SIZE);
              }
              shouldCache(_, E) {
                let R = this._refCache.get(_);
                return R || (R = /* @__PURE__ */ new Set(), this._refCache.put(_, R)), R.add(E), !(R.size < T.NUM_PAGES_THRESHOLD || !this._imageCache.has(_) && this._cacheLimitReached);
              }
              addByteSize(_, E) {
                const R = this._imageCache.get(_);
                R && (R.byteSize || (R.byteSize = E));
              }
              getData(_, E) {
                const R = this._refCache.get(_);
                if (!R || R.size < T.NUM_PAGES_THRESHOLD)
                  return null;
                const O = this._imageCache.get(_);
                return O ? (R.add(E), O) : null;
              }
              setData(_, E) {
                if (!this._refCache.has(_))
                  throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
                if (!this._imageCache.has(_)) {
                  if (this._cacheLimitReached) {
                    (0, g.warn)("GlobalImageCache.setData - cache limit reached.");
                    return;
                  }
                  this._imageCache.put(_, E);
                }
              }
              clear(_ = !1) {
                _ || this._refCache.clear(), this._imageCache.clear();
              }
            }
            A.GlobalImageCache = T;
          },
          /* 60 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.bidi = _;
            var g = x(2);
            const b = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"], y = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"];
            function f(E) {
              return (E & 1) !== 0;
            }
            function m(E) {
              return (E & 1) === 0;
            }
            function C(E, R, O) {
              let L, B;
              for (L = R, B = E.length; L < B; ++L)
                if (E[L] !== O)
                  return L;
              return L;
            }
            function w(E, R, O, L) {
              for (let B = R; B < O; ++B)
                E[B] = L;
            }
            function S(E, R, O) {
              for (let L = R, B = O - 1; L < B; ++L, --B) {
                const F = E[L];
                E[L] = E[B], E[B] = F;
              }
            }
            function $(E, R, O = !1) {
              let L = "ltr";
              return O ? L = "ttb" : R || (L = "rtl"), {
                str: E,
                dir: L
              };
            }
            const T = [], I = [];
            function _(E, R = -1, O = !1) {
              let L = !0;
              const B = E.length;
              if (B === 0 || O)
                return $(E, L, O);
              T.length = B, I.length = B;
              let F = 0, M, W;
              for (M = 0; M < B; ++M) {
                T[M] = E.charAt(M);
                const Z = E.charCodeAt(M);
                let ne = "L";
                Z <= 255 ? ne = b[Z] : 1424 <= Z && Z <= 1524 ? ne = "R" : 1536 <= Z && Z <= 1791 ? (ne = y[Z & 255], ne || (0, g.warn)("Bidi: invalid Unicode character " + Z.toString(16))) : (1792 <= Z && Z <= 2220 || 64336 <= Z && Z <= 65023 || 65136 <= Z && Z <= 65279) && (ne = "AL"), (ne === "R" || ne === "AL" || ne === "AN") && F++, I[M] = ne;
              }
              if (F === 0)
                return L = !0, $(E, L);
              R === -1 && (F / B < 0.3 && B > 4 ? (L = !0, R = 0) : (L = !1, R = 1));
              const j = [];
              for (M = 0; M < B; ++M)
                j[M] = R;
              const G = f(R) ? "R" : "L", U = G, k = U;
              let N = U;
              for (M = 0; M < B; ++M)
                I[M] === "NSM" ? I[M] = N : N = I[M];
              N = U;
              let P;
              for (M = 0; M < B; ++M)
                P = I[M], P === "EN" ? I[M] = N === "AL" ? "AN" : "EN" : (P === "R" || P === "L" || P === "AL") && (N = P);
              for (M = 0; M < B; ++M)
                P = I[M], P === "AL" && (I[M] = "R");
              for (M = 1; M < B - 1; ++M)
                I[M] === "ES" && I[M - 1] === "EN" && I[M + 1] === "EN" && (I[M] = "EN"), I[M] === "CS" && (I[M - 1] === "EN" || I[M - 1] === "AN") && I[M + 1] === I[M - 1] && (I[M] = I[M - 1]);
              for (M = 0; M < B; ++M)
                if (I[M] === "EN") {
                  for (let Z = M - 1; Z >= 0 && I[Z] === "ET"; --Z)
                    I[Z] = "EN";
                  for (let Z = M + 1; Z < B && I[Z] === "ET"; ++Z)
                    I[Z] = "EN";
                }
              for (M = 0; M < B; ++M)
                P = I[M], (P === "WS" || P === "ES" || P === "ET" || P === "CS") && (I[M] = "ON");
              for (N = U, M = 0; M < B; ++M)
                P = I[M], P === "EN" ? I[M] = N === "L" ? "L" : "EN" : (P === "R" || P === "L") && (N = P);
              for (M = 0; M < B; ++M)
                if (I[M] === "ON") {
                  const Z = C(I, M + 1, "ON");
                  let ne = U;
                  M > 0 && (ne = I[M - 1]);
                  let K = k;
                  Z + 1 < B && (K = I[Z + 1]), ne !== "L" && (ne = "R"), K !== "L" && (K = "R"), ne === K && w(I, M, Z, ne), M = Z - 1;
                }
              for (M = 0; M < B; ++M)
                I[M] === "ON" && (I[M] = G);
              for (M = 0; M < B; ++M)
                P = I[M], m(j[M]) ? P === "R" ? j[M] += 1 : (P === "AN" || P === "EN") && (j[M] += 2) : (P === "L" || P === "AN" || P === "EN") && (j[M] += 1);
              let D = -1, H = 99, V;
              for (M = 0, W = j.length; M < W; ++M)
                V = j[M], D < V && (D = V), H > V && f(V) && (H = V);
              for (V = D; V >= H; --V) {
                let Z = -1;
                for (M = 0, W = j.length; M < W; ++M)
                  j[M] < V ? Z >= 0 && (S(T, Z, M), Z = -1) : Z < 0 && (Z = M);
                Z >= 0 && S(T, Z, j.length);
              }
              for (M = 0, W = T.length; M < W; ++M) {
                const Z = T[M];
                (Z === "<" || Z === ">") && (T[M] = "");
              }
              return $(T.join(""), L);
            }
          },
          /* 61 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.getFontSubstitution = I;
            var g = x(38), b = x(3);
            const y = {
              style: "normal",
              weight: "normal"
            }, f = {
              style: "normal",
              weight: "bold"
            }, m = {
              style: "italic",
              weight: "normal"
            }, C = {
              style: "italic",
              weight: "bold"
            }, w = /* @__PURE__ */ new Map([["Times-Roman", {
              local: ["Times New Roman", "Times-Roman", "Times", "Liberation Serif", "Nimbus Roman", "Nimbus Roman L", "Tinos", "Thorndale", "TeX Gyre Termes", "FreeSerif", "DejaVu Serif", "Bitstream Vera Serif", "Ubuntu"],
              style: y,
              ultimate: "serif"
            }], ["Times-Bold", {
              alias: "Times-Roman",
              style: f,
              ultimate: "serif"
            }], ["Times-Italic", {
              alias: "Times-Roman",
              style: m,
              ultimate: "serif"
            }], ["Times-BoldItalic", {
              alias: "Times-Roman",
              style: C,
              ultimate: "serif"
            }], ["Helvetica", {
              local: ["Helvetica", "Helvetica Neue", "Arial", "Arial Nova", "Liberation Sans", "Arimo", "Nimbus Sans", "Nimbus Sans L", "A030", "TeX Gyre Heros", "FreeSans", "DejaVu Sans", "Albany", "Bitstream Vera Sans", "Arial Unicode MS", "Microsoft Sans Serif", "Apple Symbols", "Cantarell"],
              path: "LiberationSans-Regular.ttf",
              style: y,
              ultimate: "sans-serif"
            }], ["Helvetica-Bold", {
              alias: "Helvetica",
              path: "LiberationSans-Bold.ttf",
              style: f,
              ultimate: "sans-serif"
            }], ["Helvetica-Oblique", {
              alias: "Helvetica",
              path: "LiberationSans-Italic.ttf",
              style: m,
              ultimate: "sans-serif"
            }], ["Helvetica-BoldOblique", {
              alias: "Helvetica",
              path: "LiberationSans-BoldItalic.ttf",
              style: C,
              ultimate: "sans-serif"
            }], ["Courier", {
              local: ["Courier", "Courier New", "Liberation Mono", "Nimbus Mono", "Nimbus Mono L", "Cousine", "Cumberland", "TeX Gyre Cursor", "FreeMono"],
              style: y,
              ultimate: "monospace"
            }], ["Courier-Bold", {
              alias: "Courier",
              style: f,
              ultimate: "monospace"
            }], ["Courier-Oblique", {
              alias: "Courier",
              style: m,
              ultimate: "monospace"
            }], ["Courier-BoldOblique", {
              alias: "Courier",
              style: C,
              ultimate: "monospace"
            }], ["ArialBlack", {
              local: ["Arial Black"],
              style: {
                style: "normal",
                weight: "900"
              },
              fallback: "Helvetica-Bold"
            }], ["ArialBlack-Bold", {
              alias: "ArialBlack"
            }], ["ArialBlack-Italic", {
              alias: "ArialBlack",
              style: {
                style: "italic",
                weight: "900"
              },
              fallback: "Helvetica-BoldOblique"
            }], ["ArialBlack-BoldItalic", {
              alias: "ArialBlack-Italic"
            }], ["ArialNarrow", {
              local: ["Arial Narrow", "Liberation Sans Narrow", "Helvetica Condensed", "Nimbus Sans Narrow", "TeX Gyre Heros Cn"],
              style: y,
              fallback: "Helvetica"
            }], ["ArialNarrow-Bold", {
              alias: "ArialNarrow",
              style: f,
              fallback: "Helvetica-Bold"
            }], ["ArialNarrow-Italic", {
              alias: "ArialNarrow",
              style: m,
              fallback: "Helvetica-Oblique"
            }], ["ArialNarrow-BoldItalic", {
              alias: "ArialNarrow",
              style: C,
              fallback: "Helvetica-BoldOblique"
            }], ["Calibri", {
              local: ["Calibri", "Carlito"],
              style: y,
              fallback: "Helvetica"
            }], ["Calibri-Bold", {
              alias: "Calibri",
              style: f,
              fallback: "Helvetica-Bold"
            }], ["Calibri-Italic", {
              alias: "Calibri",
              style: m,
              fallback: "Helvetica-Oblique"
            }], ["Calibri-BoldItalic", {
              alias: "Calibri",
              style: C,
              fallback: "Helvetica-BoldOblique"
            }], ["Wingdings", {
              local: ["Wingdings", "URW Dingbats"],
              style: y
            }], ["Wingdings-Regular", {
              alias: "Wingdings"
            }], ["Wingdings-Bold", {
              alias: "Wingdings"
            }]]), S = /* @__PURE__ */ new Map([["Arial-Black", "ArialBlack"]]);
            function $(_) {
              switch (_) {
                case f:
                  return "Bold";
                case m:
                  return "Italic";
                case C:
                  return "Bold Italic";
                default:
                  if (_?.weight === "bold")
                    return "Bold";
                  if (_?.style === "italic")
                    return "Italic";
              }
              return "";
            }
            function T({
              alias: _,
              local: E,
              path: R,
              fallback: O,
              style: L,
              ultimate: B
            }, F, M, W = !0, j = !0, G = "") {
              const U = {
                style: null,
                ultimate: null
              };
              if (E) {
                const k = G ? ` ${G}` : "";
                for (const N of E)
                  F.push(`local(${N}${k})`);
              }
              if (_) {
                const k = w.get(_), N = G || $(L);
                Object.assign(U, T(k, F, M, W && !O, j && !R, N));
              }
              if (L && (U.style = L), B && (U.ultimate = B), W && O) {
                const k = w.get(O), {
                  ultimate: N
                } = T(k, F, M, W, j && !R, G);
                U.ultimate ||= N;
              }
              return j && R && M && F.push(`url(${M}${R})`), U;
            }
            function I(_, E, R, O, L) {
              O = (0, g.normalizeFontName)(O);
              const B = O;
              let F = _.get(B);
              if (F)
                return F;
              let M = w.get(O);
              if (!M) {
                for (const [D, H] of S)
                  if (O.startsWith(D)) {
                    O = `${H}${O.substring(D.length)}`, M = w.get(O);
                    break;
                  }
              }
              let W = !1;
              M || (M = w.get(L), W = !0);
              const j = `${E.getDocId()}_s${E.createFontId()}`;
              if (!M) {
                if (!(0, b.validateFontName)(O))
                  return _.set(B, null), null;
                const D = /bold/gi.test(O), H = /oblique|italic/gi.test(O), V = D && H && C || D && f || H && m || y;
                return F = {
                  css: j,
                  guessFallback: !0,
                  loadedName: j,
                  baseFontName: O,
                  src: `local(${O})`,
                  style: V
                }, _.set(B, F), F;
              }
              const G = [];
              W && (0, b.validateFontName)(O) && G.push(`local(${O})`);
              const {
                style: U,
                ultimate: k
              } = T(M, G, R), N = k === null, P = N ? "" : `,${k}`;
              return F = {
                css: `${j}${P}`,
                guessFallback: N,
                loadedName: j,
                baseFontName: O,
                src: G.join(","),
                style: U
              }, _.set(B, F), F;
            }
          },
          /* 62 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ImageResizer = void 0;
            var g = x(2);
            const b = 2048, y = 65537, f = 128;
            class m {
              constructor(w, S) {
                this._imgData = w, this._isMask = S;
              }
              static needsToBeResized(w, S) {
                if (w <= this._goodSquareLength && S <= this._goodSquareLength)
                  return !1;
                const {
                  MAX_DIM: $
                } = this;
                if (w > $ || S > $)
                  return !0;
                const T = w * S;
                if (this._hasMaxArea)
                  return T > this.MAX_AREA;
                if (T < this._goodSquareLength ** 2)
                  return !1;
                if (this._areGoodDims(w, S))
                  return this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(w * S))), !1;
                this._goodSquareLength = this._guessMax(this._goodSquareLength, $, f, 0);
                const I = this.MAX_AREA = this._goodSquareLength ** 2;
                return T > I;
              }
              static get MAX_DIM() {
                return (0, g.shadow)(this, "MAX_DIM", this._guessMax(b, y, 0, 1));
              }
              static get MAX_AREA() {
                return this._hasMaxArea = !0, (0, g.shadow)(this, "MAX_AREA", this._guessMax(m._goodSquareLength, this.MAX_DIM, f, 0) ** 2);
              }
              static set MAX_AREA(w) {
                w >= 0 && (this._hasMaxArea = !0, (0, g.shadow)(this, "MAX_AREA", w));
              }
              static setMaxArea(w) {
                this._hasMaxArea || (this.MAX_AREA = w >> 2);
              }
              static _areGoodDims(w, S) {
                try {
                  const $ = new OffscreenCanvas(w, S), T = $.getContext("2d");
                  T.fillRect(0, 0, 1, 1);
                  const I = T.getImageData(0, 0, 1, 1).data[3];
                  return $.width = $.height = 1, I !== 0;
                } catch {
                  return !1;
                }
              }
              static _guessMax(w, S, $, T) {
                for (; w + $ + 1 < S; ) {
                  const I = Math.floor((w + S) / 2), _ = T || I;
                  this._areGoodDims(I, _) ? w = I : S = I;
                }
                return w;
              }
              static async createImage(w, S = !1) {
                return new m(w, S)._createImage();
              }
              async _createImage() {
                const w = this._encodeBMP(), S = new Blob([w.buffer], {
                  type: "image/bmp"
                }), $ = createImageBitmap(S), {
                  MAX_AREA: T,
                  MAX_DIM: I
                } = m, {
                  _imgData: _
                } = this, {
                  width: E,
                  height: R
                } = _, O = Math.max(E / I, R / I, Math.sqrt(E * R / T)), L = Math.max(O, 2), B = Math.round(10 * (O + 1.25)) / 10 / L, F = Math.floor(Math.log2(B)), M = new Array(F + 2).fill(2);
                M[0] = L, M.splice(-1, 1, B / (1 << F));
                let W = E, j = R, G = await $;
                for (const U of M) {
                  const k = W, N = j;
                  W = Math.floor(W / U) - 1, j = Math.floor(j / U) - 1;
                  const P = new OffscreenCanvas(W, j);
                  P.getContext("2d").drawImage(G, 0, 0, k, N, 0, 0, W, j), G = P.transferToImageBitmap();
                }
                return _.data = null, _.bitmap = G, _.width = W, _.height = j, _;
              }
              _encodeBMP() {
                const {
                  width: w,
                  height: S,
                  kind: $
                } = this._imgData;
                let T = this._imgData.data, I, _ = new Uint8Array(0), E = _, R = 0;
                switch ($) {
                  case g.ImageKind.GRAYSCALE_1BPP: {
                    I = 1, _ = new Uint8Array(this._isMask ? [255, 255, 255, 255, 0, 0, 0, 0] : [0, 0, 0, 0, 255, 255, 255, 255]);
                    const j = w + 7 >> 3, G = j + 3 & -4;
                    if (j !== G) {
                      const U = new Uint8Array(G * S);
                      let k = 0;
                      for (let N = 0, P = S * j; N < P; N += j, k += G)
                        U.set(T.subarray(N, N + j), k);
                      T = U;
                    }
                    break;
                  }
                  case g.ImageKind.RGB_24BPP: {
                    if (I = 24, w & 3) {
                      const j = 3 * w, G = j + 3 & -4, U = G - j, k = new Uint8Array(G * S);
                      let N = 0;
                      for (let P = 0, D = S * j; P < D; P += j) {
                        const H = T.subarray(P, P + j);
                        for (let V = 0; V < j; V += 3)
                          k[N++] = H[V + 2], k[N++] = H[V + 1], k[N++] = H[V];
                        N += U;
                      }
                      T = k;
                    } else
                      for (let j = 0, G = T.length; j < G; j += 3) {
                        const U = T[j];
                        T[j] = T[j + 2], T[j + 2] = U;
                      }
                    break;
                  }
                  case g.ImageKind.RGBA_32BPP:
                    I = 32, R = 3, E = new Uint8Array(68);
                    const W = new DataView(E.buffer);
                    g.FeatureTest.isLittleEndian ? (W.setUint32(0, 255, !0), W.setUint32(4, 65280, !0), W.setUint32(8, 16711680, !0), W.setUint32(12, 4278190080, !0)) : (W.setUint32(0, 4278190080, !0), W.setUint32(4, 16711680, !0), W.setUint32(8, 65280, !0), W.setUint32(12, 255, !0));
                    break;
                  default:
                    throw new Error("invalid format");
                }
                let O = 0;
                const L = 40 + E.length, B = 14 + L + _.length + T.length, F = new Uint8Array(B), M = new DataView(F.buffer);
                return M.setUint16(O, 19778, !0), O += 2, M.setUint32(O, B, !0), O += 4, M.setUint32(O, 0, !0), O += 4, M.setUint32(O, 14 + L + _.length, !0), O += 4, M.setUint32(O, L, !0), O += 4, M.setInt32(O, w, !0), O += 4, M.setInt32(O, -S, !0), O += 4, M.setUint16(O, 1, !0), O += 2, M.setUint16(O, I, !0), O += 2, M.setUint32(O, R, !0), O += 4, M.setUint32(O, 0, !0), O += 4, M.setInt32(O, 0, !0), O += 4, M.setInt32(O, 0, !0), O += 4, M.setUint32(O, _.length / 4, !0), O += 4, M.setUint32(O, 0, !0), O += 4, F.set(E, O), O += E.length, F.set(_, O), O += _.length, F.set(T, O), F;
              }
            }
            A.ImageResizer = m, m._goodSquareLength = b;
          },
          /* 63 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.MurmurHash3_64 = void 0;
            var g = x(2);
            const b = 3285377520, y = 4294901760, f = 65535;
            class m {
              constructor(w) {
                this.h1 = w ? w & 4294967295 : b, this.h2 = w ? w & 4294967295 : b;
              }
              update(w) {
                let S, $;
                if (typeof w == "string") {
                  S = new Uint8Array(w.length * 2), $ = 0;
                  for (let j = 0, G = w.length; j < G; j++) {
                    const U = w.charCodeAt(j);
                    U <= 255 ? S[$++] = U : (S[$++] = U >>> 8, S[$++] = U & 255);
                  }
                } else if ((0, g.isArrayBuffer)(w))
                  S = w.slice(), $ = S.byteLength;
                else
                  throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                const T = $ >> 2, I = $ - T * 4, _ = new Uint32Array(S.buffer, 0, T);
                let E = 0, R = 0, O = this.h1, L = this.h2;
                const B = 3432918353, F = 461845907, M = B & f, W = F & f;
                for (let j = 0; j < T; j++)
                  j & 1 ? (E = _[j], E = E * B & y | E * M & f, E = E << 15 | E >>> 17, E = E * F & y | E * W & f, O ^= E, O = O << 13 | O >>> 19, O = O * 5 + 3864292196) : (R = _[j], R = R * B & y | R * M & f, R = R << 15 | R >>> 17, R = R * F & y | R * W & f, L ^= R, L = L << 13 | L >>> 19, L = L * 5 + 3864292196);
                switch (E = 0, I) {
                  case 3:
                    E ^= S[T * 4 + 2] << 16;
                  case 2:
                    E ^= S[T * 4 + 1] << 8;
                  case 1:
                    E ^= S[T * 4], E = E * B & y | E * M & f, E = E << 15 | E >>> 17, E = E * F & y | E * W & f, T & 1 ? O ^= E : L ^= E;
                }
                this.h1 = O, this.h2 = L;
              }
              hexdigest() {
                let w = this.h1, S = this.h2;
                return w ^= S >>> 1, w = w * 3981806797 & y | w * 36045 & f, S = S * 4283543511 & y | ((S << 16 | w >>> 16) * 2950163797 & y) >>> 16, w ^= S >>> 1, w = w * 444984403 & y | w * 60499 & f, S = S * 3301882366 & y | ((S << 16 | w >>> 16) * 3120437893 & y) >>> 16, w ^= S >>> 1, (w >>> 0).toString(16).padStart(8, "0") + (S >>> 0).toString(16).padStart(8, "0");
              }
            }
            A.MurmurHash3_64 = m;
          },
          /* 64 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.OperatorList = void 0;
            var g = x(2);
            function b(w, S, $, T, I) {
              let _ = w;
              for (let E = 0, R = S.length - 1; E < R; E++) {
                const O = S[E];
                _ = _[O] ||= [];
              }
              _[S.at(-1)] = {
                checkFn: $,
                iterateFn: T,
                processFn: I
              };
            }
            const y = [];
            b(y, [g.OPS.save, g.OPS.transform, g.OPS.paintInlineImageXObject, g.OPS.restore], null, function(S, $) {
              const T = S.fnArray, I = S.iCurr - 3, _ = ($ - I) % 4;
              switch (_) {
                case 0:
                  return T[$] === g.OPS.save;
                case 1:
                  return T[$] === g.OPS.transform;
                case 2:
                  return T[$] === g.OPS.paintInlineImageXObject;
                case 3:
                  return T[$] === g.OPS.restore;
              }
              throw new Error(`iterateInlineImageGroup - invalid pos: ${_}`);
            }, function(S, $) {
              const R = S.fnArray, O = S.argsArray, L = S.iCurr, B = L - 3, F = L - 2, M = L - 1, W = Math.min(Math.floor(($ - B) / 4), 200);
              if (W < 10)
                return $ - ($ - B) % 4;
              let j = 0;
              const G = [];
              let U = 0, k = 1, N = 1;
              for (let ne = 0; ne < W; ne++) {
                const K = O[F + (ne << 2)], q = O[M + (ne << 2)][0];
                k + q.width > 1e3 && (j = Math.max(j, k), N += U + 2, k = 0, U = 0), G.push({
                  transform: K,
                  x: k,
                  y: N,
                  w: q.width,
                  h: q.height
                }), k += q.width + 2, U = Math.max(U, q.height);
              }
              const P = Math.max(j, k) + 1, D = N + U + 1, H = new Uint8Array(P * D * 4), V = P << 2;
              for (let ne = 0; ne < W; ne++) {
                const K = O[M + (ne << 2)][0].data, q = G[ne].w << 2;
                let Y = 0, ee = G[ne].x + G[ne].y * P << 2;
                H.set(K.subarray(0, q), ee - V);
                for (let Q = 0, J = G[ne].h; Q < J; Q++)
                  H.set(K.subarray(Y, Y + q), ee), Y += q, ee += V;
                for (H.set(K.subarray(Y - q, Y), ee); ee >= 0; )
                  K[ee - 4] = K[ee], K[ee - 3] = K[ee + 1], K[ee - 2] = K[ee + 2], K[ee - 1] = K[ee + 3], K[ee + q] = K[ee + q - 4], K[ee + q + 1] = K[ee + q - 3], K[ee + q + 2] = K[ee + q - 2], K[ee + q + 3] = K[ee + q - 1], ee -= V;
              }
              const Z = {
                width: P,
                height: D
              };
              if (S.isOffscreenCanvasSupported) {
                const ne = new OffscreenCanvas(P, D);
                ne.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(H.buffer), P, D), 0, 0), Z.bitmap = ne.transferToImageBitmap(), Z.data = null;
              } else
                Z.kind = g.ImageKind.RGBA_32BPP, Z.data = H;
              return R.splice(B, W * 4, g.OPS.paintInlineImageXObjectGroup), O.splice(B, W * 4, [Z, G]), B + 1;
            }), b(y, [g.OPS.save, g.OPS.transform, g.OPS.paintImageMaskXObject, g.OPS.restore], null, function(S, $) {
              const T = S.fnArray, I = S.iCurr - 3, _ = ($ - I) % 4;
              switch (_) {
                case 0:
                  return T[$] === g.OPS.save;
                case 1:
                  return T[$] === g.OPS.transform;
                case 2:
                  return T[$] === g.OPS.paintImageMaskXObject;
                case 3:
                  return T[$] === g.OPS.restore;
              }
              throw new Error(`iterateImageMaskGroup - invalid pos: ${_}`);
            }, function(S, $) {
              const E = S.fnArray, R = S.argsArray, O = S.iCurr, L = O - 3, B = O - 2, F = O - 1;
              let M = Math.floor(($ - L) / 4);
              if (M < 10)
                return $ - ($ - L) % 4;
              let W = !1, j, G;
              const U = R[F][0], k = R[B][0], N = R[B][1], P = R[B][2], D = R[B][3];
              if (N === P) {
                W = !0, j = B + 4;
                let H = F + 4;
                for (let V = 1; V < M; V++, j += 4, H += 4)
                  if (G = R[j], R[H][0] !== U || G[0] !== k || G[1] !== N || G[2] !== P || G[3] !== D) {
                    V < 10 ? W = !1 : M = V;
                    break;
                  }
              }
              if (W) {
                M = Math.min(M, 1e3);
                const H = new Float32Array(M * 2);
                j = B;
                for (let V = 0; V < M; V++, j += 4)
                  G = R[j], H[V << 1] = G[4], H[(V << 1) + 1] = G[5];
                E.splice(L, M * 4, g.OPS.paintImageMaskXObjectRepeat), R.splice(L, M * 4, [U, k, N, P, D, H]);
              } else {
                M = Math.min(M, 100);
                const H = [];
                for (let V = 0; V < M; V++) {
                  G = R[B + (V << 2)];
                  const Z = R[F + (V << 2)][0];
                  H.push({
                    data: Z.data,
                    width: Z.width,
                    height: Z.height,
                    interpolate: Z.interpolate,
                    count: Z.count,
                    transform: G
                  });
                }
                E.splice(L, M * 4, g.OPS.paintImageMaskXObjectGroup), R.splice(L, M * 4, [H]);
              }
              return L + 1;
            }), b(y, [g.OPS.save, g.OPS.transform, g.OPS.paintImageXObject, g.OPS.restore], function(w) {
              const S = w.argsArray, $ = w.iCurr - 2;
              return S[$][1] === 0 && S[$][2] === 0;
            }, function(S, $) {
              const T = S.fnArray, I = S.argsArray, _ = S.iCurr - 3, E = ($ - _) % 4;
              switch (E) {
                case 0:
                  return T[$] === g.OPS.save;
                case 1:
                  if (T[$] !== g.OPS.transform)
                    return !1;
                  const R = S.iCurr - 2, O = I[R][0], L = I[R][3];
                  return !(I[$][0] !== O || I[$][1] !== 0 || I[$][2] !== 0 || I[$][3] !== L);
                case 2:
                  if (T[$] !== g.OPS.paintImageXObject)
                    return !1;
                  const B = S.iCurr - 1, F = I[B][0];
                  return I[$][0] === F;
                case 3:
                  return T[$] === g.OPS.restore;
              }
              throw new Error(`iterateImageGroup - invalid pos: ${E}`);
            }, function(w, S) {
              const I = w.fnArray, _ = w.argsArray, E = w.iCurr, R = E - 3, O = E - 2, L = E - 1, B = _[L][0], F = _[O][0], M = _[O][3], W = Math.min(Math.floor((S - R) / 4), 1e3);
              if (W < 3)
                return S - (S - R) % 4;
              const j = new Float32Array(W * 2);
              let G = O;
              for (let k = 0; k < W; k++, G += 4) {
                const N = _[G];
                j[k << 1] = N[4], j[(k << 1) + 1] = N[5];
              }
              const U = [B, F, M, j];
              return I.splice(R, W * 4, g.OPS.paintImageXObjectRepeat), _.splice(R, W * 4, U), R + 1;
            }), b(y, [g.OPS.beginText, g.OPS.setFont, g.OPS.setTextMatrix, g.OPS.showText, g.OPS.endText], null, function(S, $) {
              const T = S.fnArray, I = S.argsArray, _ = S.iCurr - 4, E = ($ - _) % 5;
              switch (E) {
                case 0:
                  return T[$] === g.OPS.beginText;
                case 1:
                  return T[$] === g.OPS.setFont;
                case 2:
                  return T[$] === g.OPS.setTextMatrix;
                case 3:
                  if (T[$] !== g.OPS.showText)
                    return !1;
                  const R = S.iCurr - 3, O = I[R][0], L = I[R][1];
                  return !(I[$][0] !== O || I[$][1] !== L);
                case 4:
                  return T[$] === g.OPS.endText;
              }
              throw new Error(`iterateShowTextGroup - invalid pos: ${E}`);
            }, function(w, S) {
              const I = w.fnArray, _ = w.argsArray, E = w.iCurr, R = E - 4, O = E - 3, L = E - 2, B = E - 1, F = E, M = _[O][0], W = _[O][1];
              let j = Math.min(Math.floor((S - R) / 5), 1e3);
              if (j < 3)
                return S - (S - R) % 5;
              let G = R;
              R >= 4 && I[R - 4] === I[O] && I[R - 3] === I[L] && I[R - 2] === I[B] && I[R - 1] === I[F] && _[R - 4][0] === M && _[R - 4][1] === W && (j++, G -= 5);
              let U = G + 4;
              for (let k = 1; k < j; k++)
                I.splice(U, 3), _.splice(U, 3), U += 2;
              return U + 1;
            });
            class f {
              constructor(S) {
                this.queue = S;
              }
              _optimize() {
              }
              push(S, $) {
                this.queue.fnArray.push(S), this.queue.argsArray.push($), this._optimize();
              }
              flush() {
              }
              reset() {
              }
            }
            class m extends f {
              constructor(S) {
                super(S), this.state = null, this.context = {
                  iCurr: 0,
                  fnArray: S.fnArray,
                  argsArray: S.argsArray,
                  isOffscreenCanvasSupported: !1
                }, this.match = null, this.lastProcessed = 0;
              }
              set isOffscreenCanvasSupported(S) {
                this.context.isOffscreenCanvasSupported = S;
              }
              _optimize() {
                const S = this.queue.fnArray;
                let $ = this.lastProcessed, T = S.length, I = this.state, _ = this.match;
                if (!I && !_ && $ + 1 === T && !y[S[$]]) {
                  this.lastProcessed = T;
                  return;
                }
                const E = this.context;
                for (; $ < T; ) {
                  if (_) {
                    if ((0, _.iterateFn)(E, $)) {
                      $++;
                      continue;
                    }
                    if ($ = (0, _.processFn)(E, $ + 1), T = S.length, _ = null, I = null, $ >= T)
                      break;
                  }
                  if (I = (I || y)[S[$]], !I || Array.isArray(I)) {
                    $++;
                    continue;
                  }
                  if (E.iCurr = $, $++, I.checkFn && !(0, I.checkFn)(E)) {
                    I = null;
                    continue;
                  }
                  _ = I, I = null;
                }
                this.state = I, this.match = _, this.lastProcessed = $;
              }
              flush() {
                for (; this.match; ) {
                  const S = this.queue.fnArray.length;
                  this.lastProcessed = (0, this.match.processFn)(this.context, S), this.match = null, this.state = null, this._optimize();
                }
              }
              reset() {
                this.state = null, this.match = null, this.lastProcessed = 0;
              }
            }
            class C {
              static CHUNK_SIZE = 1e3;
              static CHUNK_SIZE_ABOUT = this.CHUNK_SIZE - 5;
              constructor(S = 0, $) {
                this._streamSink = $, this.fnArray = [], this.argsArray = [], this.optimizer = $ && !(S & g.RenderingIntentFlag.OPLIST) ? new m(this) : new f(this), this.dependencies = /* @__PURE__ */ new Set(), this._totalLength = 0, this.weight = 0, this._resolved = $ ? null : Promise.resolve();
              }
              set isOffscreenCanvasSupported(S) {
                this.optimizer.isOffscreenCanvasSupported = S;
              }
              get length() {
                return this.argsArray.length;
              }
              get ready() {
                return this._resolved || this._streamSink.ready;
              }
              get totalLength() {
                return this._totalLength + this.length;
              }
              addOp(S, $) {
                this.optimizer.push(S, $), this.weight++, this._streamSink && (this.weight >= C.CHUNK_SIZE ? this.flush() : this.weight >= C.CHUNK_SIZE_ABOUT && (S === g.OPS.restore || S === g.OPS.endText) && this.flush());
              }
              addImageOps(S, $, T) {
                T !== void 0 && this.addOp(g.OPS.beginMarkedContentProps, ["OC", T]), this.addOp(S, $), T !== void 0 && this.addOp(g.OPS.endMarkedContent, []);
              }
              addDependency(S) {
                this.dependencies.has(S) || (this.dependencies.add(S), this.addOp(g.OPS.dependency, [S]));
              }
              addDependencies(S) {
                for (const $ of S)
                  this.addDependency($);
              }
              addOpList(S) {
                if (!(S instanceof C)) {
                  (0, g.warn)('addOpList - ignoring invalid "opList" parameter.');
                  return;
                }
                for (const $ of S.dependencies)
                  this.dependencies.add($);
                for (let $ = 0, T = S.length; $ < T; $++)
                  this.addOp(S.fnArray[$], S.argsArray[$]);
              }
              getIR() {
                return {
                  fnArray: this.fnArray,
                  argsArray: this.argsArray,
                  length: this.length
                };
              }
              get _transfers() {
                const S = [], {
                  fnArray: $,
                  argsArray: T,
                  length: I
                } = this;
                for (let _ = 0; _ < I; _++)
                  switch ($[_]) {
                    case g.OPS.paintInlineImageXObject:
                    case g.OPS.paintInlineImageXObjectGroup:
                    case g.OPS.paintImageMaskXObject:
                      const E = T[_][0];
                      !E.cached && E.data?.buffer instanceof ArrayBuffer && S.push(E.data.buffer);
                      break;
                  }
                return S;
              }
              flush(S = !1, $ = null) {
                this.optimizer.flush();
                const T = this.length;
                this._totalLength += T, this._streamSink.enqueue({
                  fnArray: this.fnArray,
                  argsArray: this.argsArray,
                  lastChunk: S,
                  separateAnnots: $,
                  length: T
                }, 1, this._transfers), this.dependencies.clear(), this.fnArray.length = 0, this.argsArray.length = 0, this.weight = 0, this.optimizer.reset();
              }
            }
            A.OperatorList = C;
          },
          /* 65 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.PDFImage = void 0;
            var g = x(2), b = x(28), y = x(5), f = x(12), m = x(18), C = x(62), w = x(26), S = x(30), $ = x(4);
            function T(E, R, O, L) {
              return E = R + E * O, E < 0 ? E = 0 : E > L && (E = L), E;
            }
            function I(E, R, O, L, B, F) {
              const M = B * F;
              let W;
              R <= 8 ? W = new Uint8Array(M) : R <= 16 ? W = new Uint16Array(M) : W = new Uint32Array(M);
              const j = O / B, G = L / F;
              let U, k, N, P = 0, D;
              const H = new Uint16Array(B), V = O;
              for (U = 0; U < B; U++)
                H[U] = Math.floor(U * j);
              for (U = 0; U < F; U++)
                for (N = Math.floor(U * G) * V, k = 0; k < B; k++)
                  D = N + H[k], W[P++] = E[D];
              return W;
            }
            class _ {
              constructor({
                xref: R,
                res: O,
                image: L,
                isInline: B = !1,
                smask: F = null,
                mask: M = null,
                isMask: W = !1,
                pdfFunctionFactory: j,
                localColorSpaceCache: G
              }) {
                this.image = L;
                const U = L.dict, k = U.get("F", "Filter");
                let N;
                if (k instanceof $.Name)
                  N = k.name;
                else if (Array.isArray(k)) {
                  const V = R.fetchIfRef(k[0]);
                  V instanceof $.Name && (N = V.name);
                }
                switch (N) {
                  case "JPXDecode":
                    const V = new S.JpxImage();
                    V.parseImageProperties(L.stream), L.stream.reset(), L.width = V.width, L.height = V.height, L.bitsPerComponent = V.bitsPerComponent, L.numComps = V.componentsCount;
                    break;
                  case "JBIG2Decode":
                    L.bitsPerComponent = 1, L.numComps = 1;
                    break;
                }
                let P = U.get("W", "Width"), D = U.get("H", "Height");
                if (Number.isInteger(L.width) && L.width > 0 && Number.isInteger(L.height) && L.height > 0 && (L.width !== P || L.height !== D) && ((0, g.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary."), P = L.width, D = L.height), P < 1 || D < 1)
                  throw new g.FormatError(`Invalid image width: ${P} or height: ${D}`);
                this.width = P, this.height = D, this.interpolate = U.get("I", "Interpolate"), this.imageMask = U.get("IM", "ImageMask") || !1, this.matte = U.get("Matte") || !1;
                let H = L.bitsPerComponent;
                if (!H && (H = U.get("BPC", "BitsPerComponent"), !H))
                  if (this.imageMask)
                    H = 1;
                  else
                    throw new g.FormatError(`Bits per component missing in image: ${this.imageMask}`);
                if (this.bpc = H, !this.imageMask) {
                  let V = U.getRaw("CS") || U.getRaw("ColorSpace");
                  if (!V)
                    switch ((0, g.info)("JPX images (which do not require color spaces)"), L.numComps) {
                      case 1:
                        V = $.Name.get("DeviceGray");
                        break;
                      case 3:
                        V = $.Name.get("DeviceRGB");
                        break;
                      case 4:
                        V = $.Name.get("DeviceCMYK");
                        break;
                      default:
                        throw new Error(`JPX images with ${L.numComps} color components not supported.`);
                    }
                  this.colorSpace = f.ColorSpace.parse({
                    cs: V,
                    xref: R,
                    resources: B ? O : null,
                    pdfFunctionFactory: j,
                    localColorSpaceCache: G
                  }), this.numComps = this.colorSpace.numComps;
                }
                if (this.decode = U.getArray("D", "Decode"), this.needsDecode = !1, this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, H) || W && !f.ColorSpace.isDefaultDecode(this.decode, 1))) {
                  this.needsDecode = !0;
                  const V = (1 << H) - 1;
                  this.decodeCoefficients = [], this.decodeAddends = [];
                  const Z = this.colorSpace?.name === "Indexed";
                  for (let ne = 0, K = 0; ne < this.decode.length; ne += 2, ++K) {
                    const q = this.decode[ne], Y = this.decode[ne + 1];
                    this.decodeCoefficients[K] = Z ? (Y - q) / V : Y - q, this.decodeAddends[K] = Z ? q : V * q;
                  }
                }
                F ? this.smask = new _({
                  xref: R,
                  res: O,
                  image: F,
                  isInline: B,
                  pdfFunctionFactory: j,
                  localColorSpaceCache: G
                }) : M && (M instanceof y.BaseStream ? M.dict.get("IM", "ImageMask") ? this.mask = new _({
                  xref: R,
                  res: O,
                  image: M,
                  isInline: B,
                  isMask: !0,
                  pdfFunctionFactory: j,
                  localColorSpaceCache: G
                }) : (0, g.warn)("Ignoring /Mask in image without /ImageMask.") : this.mask = M);
              }
              static async buildImage({
                xref: R,
                res: O,
                image: L,
                isInline: B = !1,
                pdfFunctionFactory: F,
                localColorSpaceCache: M
              }) {
                const W = L;
                let j = null, G = null;
                const U = L.dict.get("SMask"), k = L.dict.get("Mask");
                return U ? U instanceof y.BaseStream ? j = U : (0, g.warn)("Unsupported /SMask format.") : k && (k instanceof y.BaseStream || Array.isArray(k) ? G = k : (0, g.warn)("Unsupported /Mask format.")), new _({
                  xref: R,
                  res: O,
                  image: W,
                  isInline: B,
                  smask: j,
                  mask: G,
                  pdfFunctionFactory: F,
                  localColorSpaceCache: M
                });
              }
              static createRawMask({
                imgArray: R,
                width: O,
                height: L,
                imageIsFromDecodeStream: B,
                inverseDecode: F,
                interpolate: M
              }) {
                const W = (O + 7 >> 3) * L, j = R.byteLength, G = W === j;
                let U, k;
                if (B && (!F || G) ? U = R : F ? (U = new Uint8Array(W), U.set(R), U.fill(255, j)) : U = new Uint8Array(R), F)
                  for (k = 0; k < j; k++)
                    U[k] ^= 255;
                return {
                  data: U,
                  width: O,
                  height: L,
                  interpolate: M
                };
              }
              static async createMask({
                imgArray: R,
                width: O,
                height: L,
                imageIsFromDecodeStream: B,
                inverseDecode: F,
                interpolate: M,
                isOffscreenCanvasSupported: W = !1
              }) {
                const j = O === 1 && L === 1 && F === (R.length === 0 || !!(R[0] & 128));
                if (j)
                  return {
                    isSingleOpaquePixel: j
                  };
                if (W) {
                  if (C.ImageResizer.needsToBeResized(O, L)) {
                    const P = new Uint8ClampedArray(O * L * 4);
                    return (0, b.convertBlackAndWhiteToRGBA)({
                      src: R,
                      dest: P,
                      width: O,
                      height: L,
                      nonBlackColor: 0,
                      inverseDecode: F
                    }), C.ImageResizer.createImage({
                      kind: g.ImageKind.RGBA_32BPP,
                      data: P,
                      width: O,
                      height: L,
                      interpolate: M
                    });
                  }
                  const G = new OffscreenCanvas(O, L), U = G.getContext("2d"), k = U.createImageData(O, L);
                  (0, b.convertBlackAndWhiteToRGBA)({
                    src: R,
                    dest: k.data,
                    width: O,
                    height: L,
                    nonBlackColor: 0,
                    inverseDecode: F
                  }), U.putImageData(k, 0, 0);
                  const N = G.transferToImageBitmap();
                  return {
                    data: null,
                    width: O,
                    height: L,
                    interpolate: M,
                    bitmap: N
                  };
                }
                return this.createRawMask({
                  imgArray: R,
                  width: O,
                  height: L,
                  inverseDecode: F,
                  imageIsFromDecodeStream: B,
                  interpolate: M
                });
              }
              get drawWidth() {
                return Math.max(this.width, this.smask?.width || 0, this.mask?.width || 0);
              }
              get drawHeight() {
                return Math.max(this.height, this.smask?.height || 0, this.mask?.height || 0);
              }
              decodeBuffer(R) {
                const O = this.bpc, L = this.numComps, B = this.decodeAddends, F = this.decodeCoefficients, M = (1 << O) - 1;
                let W, j;
                if (O === 1) {
                  for (W = 0, j = R.length; W < j; W++)
                    R[W] = +!R[W];
                  return;
                }
                let G = 0;
                for (W = 0, j = this.width * this.height; W < j; W++)
                  for (let U = 0; U < L; U++)
                    R[G] = T(R[G], B[U], F[U], M), G++;
              }
              getComponents(R) {
                const O = this.bpc;
                if (O === 8)
                  return R;
                const L = this.width, B = this.height, F = this.numComps, M = L * B * F;
                let W = 0, j;
                O <= 8 ? j = new Uint8Array(M) : O <= 16 ? j = new Uint16Array(M) : j = new Uint32Array(M);
                const G = L * F, U = (1 << O) - 1;
                let k = 0, N, P;
                if (O === 1) {
                  let D, H, V;
                  for (let Z = 0; Z < B; Z++) {
                    for (H = k + (G & -8), V = k + G; k < H; )
                      P = R[W++], j[k] = P >> 7 & 1, j[k + 1] = P >> 6 & 1, j[k + 2] = P >> 5 & 1, j[k + 3] = P >> 4 & 1, j[k + 4] = P >> 3 & 1, j[k + 5] = P >> 2 & 1, j[k + 6] = P >> 1 & 1, j[k + 7] = P & 1, k += 8;
                    if (k < V)
                      for (P = R[W++], D = 128; k < V; )
                        j[k++] = +!!(P & D), D >>= 1;
                  }
                } else {
                  let D = 0;
                  for (P = 0, k = 0, N = M; k < N; ++k) {
                    for (k % G === 0 && (P = 0, D = 0); D < O; )
                      P = P << 8 | R[W++], D += 8;
                    const H = D - O;
                    let V = P >> H;
                    V < 0 ? V = 0 : V > U && (V = U), j[k] = V, P &= (1 << H) - 1, D = H;
                  }
                }
                return j;
              }
              fillOpacity(R, O, L, B, F) {
                const M = this.smask, W = this.mask;
                let j, G, U, k, N, P;
                if (M)
                  G = M.width, U = M.height, j = new Uint8ClampedArray(G * U), M.fillGrayBuffer(j), (G !== O || U !== L) && (j = I(j, M.bpc, G, U, O, L));
                else if (W)
                  if (W instanceof _) {
                    for (G = W.width, U = W.height, j = new Uint8ClampedArray(G * U), W.numComps = 1, W.fillGrayBuffer(j), k = 0, N = G * U; k < N; ++k)
                      j[k] = 255 - j[k];
                    (G !== O || U !== L) && (j = I(j, W.bpc, G, U, O, L));
                  } else if (Array.isArray(W)) {
                    j = new Uint8ClampedArray(O * L);
                    const D = this.numComps;
                    for (k = 0, N = O * L; k < N; ++k) {
                      let H = 0;
                      const V = k * D;
                      for (P = 0; P < D; ++P) {
                        const Z = F[V + P], ne = P * 2;
                        if (Z < W[ne] || Z > W[ne + 1]) {
                          H = 255;
                          break;
                        }
                      }
                      j[k] = H;
                    }
                  } else
                    throw new g.FormatError("Unknown mask format.");
                if (j)
                  for (k = 0, P = 3, N = O * B; k < N; ++k, P += 4)
                    R[P] = j[k];
                else
                  for (k = 0, P = 3, N = O * B; k < N; ++k, P += 4)
                    R[P] = 255;
              }
              undoPreblend(R, O, L) {
                const B = this.smask?.matte;
                if (!B)
                  return;
                const F = this.colorSpace.getRgb(B, 0), M = F[0], W = F[1], j = F[2], G = O * L * 4;
                for (let U = 0; U < G; U += 4) {
                  const k = R[U + 3];
                  if (k === 0) {
                    R[U] = 255, R[U + 1] = 255, R[U + 2] = 255;
                    continue;
                  }
                  const N = 255 / k;
                  R[U] = (R[U] - M) * N + M, R[U + 1] = (R[U + 1] - W) * N + W, R[U + 2] = (R[U + 2] - j) * N + j;
                }
              }
              async createImageData(R = !1, O = !1) {
                const L = this.drawWidth, B = this.drawHeight, F = {
                  width: L,
                  height: B,
                  interpolate: this.interpolate,
                  kind: 0,
                  data: null
                }, M = this.numComps, W = this.width, j = this.height, G = this.bpc, U = W * M * G + 7 >> 3, k = O && C.ImageResizer.needsToBeResized(L, B);
                if (!R) {
                  let Y;
                  if (this.colorSpace.name === "DeviceGray" && G === 1 ? Y = g.ImageKind.GRAYSCALE_1BPP : this.colorSpace.name === "DeviceRGB" && G === 8 && !this.needsDecode && (Y = g.ImageKind.RGB_24BPP), Y && !this.smask && !this.mask && L === W && B === j) {
                    const ee = this.getImageBytes(j * U, {});
                    if (O)
                      return k ? C.ImageResizer.createImage({
                        data: ee,
                        kind: Y,
                        width: L,
                        height: B,
                        interpolate: this.interpolate
                      }, this.needsDecode) : this.createBitmap(Y, W, j, ee);
                    if (F.kind = Y, F.data = ee, this.needsDecode) {
                      (0, g.assert)(Y === g.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                      const Q = F.data;
                      for (let J = 0, te = Q.length; J < te; J++)
                        Q[J] ^= 255;
                    }
                    return F;
                  }
                  if (this.image instanceof w.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
                    let ee = j * U;
                    if (O && !k) {
                      let Q = !1;
                      switch (this.colorSpace.name) {
                        case "DeviceGray":
                          ee *= 4, Q = !0;
                          break;
                        case "DeviceRGB":
                          ee = ee / 3 * 4, Q = !0;
                          break;
                        case "DeviceCMYK":
                          Q = !0;
                          break;
                      }
                      if (Q) {
                        const J = this.getImageBytes(ee, {
                          drawWidth: L,
                          drawHeight: B,
                          forceRGBA: !0
                        });
                        return this.createBitmap(g.ImageKind.RGBA_32BPP, L, B, J);
                      }
                    } else
                      switch (this.colorSpace.name) {
                        case "DeviceGray":
                          ee *= 3;
                        case "DeviceRGB":
                        case "DeviceCMYK":
                          return F.kind = g.ImageKind.RGB_24BPP, F.data = this.getImageBytes(ee, {
                            drawWidth: L,
                            drawHeight: B,
                            forceRGB: !0
                          }), k ? C.ImageResizer.createImage(F) : F;
                      }
                  }
                }
                const N = this.getImageBytes(j * U, {
                  internal: !0
                }), P = 0 | N.length / U * B / j, D = this.getComponents(N);
                let H, V, Z, ne, K, q;
                if (O && !k && (Z = new OffscreenCanvas(L, B), ne = Z.getContext("2d"), K = ne.createImageData(L, B), q = K.data), F.kind = g.ImageKind.RGBA_32BPP, !R && !this.smask && !this.mask ? (!O || k ? (F.kind = g.ImageKind.RGB_24BPP, q = new Uint8ClampedArray(L * B * 3), H = 0) : (new Uint32Array(q.buffer).fill(g.FeatureTest.isLittleEndian ? 4278190080 : 255), H = 1), V = !1) : ((!O || k) && (q = new Uint8ClampedArray(L * B * 4)), H = 1, V = !0, this.fillOpacity(q, L, B, P, D)), this.needsDecode && this.decodeBuffer(D), this.colorSpace.fillRgb(q, W, j, L, B, P, G, D, H), V && this.undoPreblend(q, L, P), O && !k) {
                  ne.putImageData(K, 0, 0);
                  const Y = Z.transferToImageBitmap();
                  return {
                    data: null,
                    width: L,
                    height: B,
                    bitmap: Y,
                    interpolate: this.interpolate
                  };
                }
                return F.data = q, k ? C.ImageResizer.createImage(F) : F;
              }
              fillGrayBuffer(R) {
                const O = this.numComps;
                if (O !== 1)
                  throw new g.FormatError(`Reading gray scale from a color image: ${O}`);
                const L = this.width, B = this.height, F = this.bpc, M = L * O * F + 7 >> 3, W = this.getImageBytes(B * M, {
                  internal: !0
                }), j = this.getComponents(W);
                let G, U;
                if (F === 1) {
                  if (U = L * B, this.needsDecode)
                    for (G = 0; G < U; ++G)
                      R[G] = j[G] - 1 & 255;
                  else
                    for (G = 0; G < U; ++G)
                      R[G] = -j[G] & 255;
                  return;
                }
                this.needsDecode && this.decodeBuffer(j), U = L * B;
                const k = 255 / ((1 << F) - 1);
                for (G = 0; G < U; ++G)
                  R[G] = k * j[G];
              }
              createBitmap(R, O, L, B) {
                const F = new OffscreenCanvas(O, L), M = F.getContext("2d");
                let W;
                R === g.ImageKind.RGBA_32BPP ? W = new ImageData(B, O, L) : (W = M.createImageData(O, L), (0, b.convertToRGBA)({
                  kind: R,
                  src: B,
                  dest: new Uint32Array(W.data.buffer),
                  width: O,
                  height: L,
                  inverseDecode: this.needsDecode
                })), M.putImageData(W, 0, 0);
                const j = F.transferToImageBitmap();
                return {
                  data: null,
                  width: O,
                  height: L,
                  bitmap: j,
                  interpolate: this.interpolate
                };
              }
              getImageBytes(R, {
                drawWidth: O,
                drawHeight: L,
                forceRGBA: B = !1,
                forceRGB: F = !1,
                internal: M = !1
              }) {
                this.image.reset(), this.image.drawWidth = O || this.width, this.image.drawHeight = L || this.height, this.image.forceRGBA = !!B, this.image.forceRGB = !!F;
                const W = this.image.getBytes(R);
                return M || this.image instanceof m.DecodeStream ? W : ((0, g.assert)(W instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.'), new Uint8Array(W));
              }
            }
            A.PDFImage = _;
          },
          /* 66 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Catalog = void 0;
            var g = x(3), b = x(2), y = x(4), f = x(67), m = x(5), C = x(68), w = x(12), S = x(69), $ = x(59), T = x(70), I = x(72);
            function _(R) {
              return R instanceof y.Dict && (R = R.get("D")), Array.isArray(R) ? R : null;
            }
            class E {
              constructor(O, L) {
                if (this.pdfManager = O, this.xref = L, this._catDict = L.getCatalogObj(), !(this._catDict instanceof y.Dict))
                  throw new b.FormatError("Catalog object is not a dictionary.");
                this.toplevelPagesDict, this._actualNumPages = null, this.fontCache = new y.RefSetCache(), this.builtInCMapCache = /* @__PURE__ */ new Map(), this.standardFontDataCache = /* @__PURE__ */ new Map(), this.globalImageCache = new $.GlobalImageCache(), this.pageKidsCountCache = new y.RefSetCache(), this.pageIndexCache = new y.RefSetCache(), this.nonBlendModesSet = new y.RefSet(), this.systemFontCache = /* @__PURE__ */ new Map();
              }
              cloneDict() {
                return this._catDict.clone();
              }
              get version() {
                const O = this._catDict.get("Version");
                if (O instanceof y.Name) {
                  if (g.PDF_VERSION_REGEXP.test(O.name))
                    return (0, b.shadow)(this, "version", O.name);
                  (0, b.warn)(`Invalid PDF catalog version: ${O.name}`);
                }
                return (0, b.shadow)(this, "version", null);
              }
              get lang() {
                const O = this._catDict.get("Lang");
                return (0, b.shadow)(this, "lang", typeof O == "string" ? (0, b.stringToPDFString)(O) : null);
              }
              get needsRendering() {
                const O = this._catDict.get("NeedsRendering");
                return (0, b.shadow)(this, "needsRendering", typeof O == "boolean" ? O : !1);
              }
              get collection() {
                let O = null;
                try {
                  const L = this._catDict.get("Collection");
                  L instanceof y.Dict && L.size > 0 && (O = L);
                } catch (L) {
                  if (L instanceof g.MissingDataException)
                    throw L;
                  (0, b.info)("Cannot fetch Collection entry; assuming no collection is present.");
                }
                return (0, b.shadow)(this, "collection", O);
              }
              get acroForm() {
                let O = null;
                try {
                  const L = this._catDict.get("AcroForm");
                  L instanceof y.Dict && L.size > 0 && (O = L);
                } catch (L) {
                  if (L instanceof g.MissingDataException)
                    throw L;
                  (0, b.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
                }
                return (0, b.shadow)(this, "acroForm", O);
              }
              get acroFormRef() {
                const O = this._catDict.getRaw("AcroForm");
                return (0, b.shadow)(this, "acroFormRef", O instanceof y.Ref ? O : null);
              }
              get metadata() {
                const O = this._catDict.getRaw("Metadata");
                if (!(O instanceof y.Ref))
                  return (0, b.shadow)(this, "metadata", null);
                let L = null;
                try {
                  const B = this.xref.fetch(O, !this.xref.encrypt?.encryptMetadata);
                  if (B instanceof m.BaseStream && B.dict instanceof y.Dict) {
                    const F = B.dict.get("Type"), M = B.dict.get("Subtype");
                    if ((0, y.isName)(F, "Metadata") && (0, y.isName)(M, "XML")) {
                      const W = (0, b.stringToUTF8String)(B.getString());
                      W && (L = new T.MetadataParser(W).serializable);
                    }
                  }
                } catch (B) {
                  if (B instanceof g.MissingDataException)
                    throw B;
                  (0, b.info)(`Skipping invalid Metadata: "${B}".`);
                }
                return (0, b.shadow)(this, "metadata", L);
              }
              get markInfo() {
                let O = null;
                try {
                  O = this._readMarkInfo();
                } catch (L) {
                  if (L instanceof g.MissingDataException)
                    throw L;
                  (0, b.warn)("Unable to read mark info.");
                }
                return (0, b.shadow)(this, "markInfo", O);
              }
              _readMarkInfo() {
                const O = this._catDict.get("MarkInfo");
                if (!(O instanceof y.Dict))
                  return null;
                const L = {
                  Marked: !1,
                  UserProperties: !1,
                  Suspects: !1
                };
                for (const B in L) {
                  const F = O.get(B);
                  typeof F == "boolean" && (L[B] = F);
                }
                return L;
              }
              get structTreeRoot() {
                let O = null;
                try {
                  O = this._readStructTreeRoot();
                } catch (L) {
                  if (L instanceof g.MissingDataException)
                    throw L;
                  (0, b.warn)("Unable read to structTreeRoot info.");
                }
                return (0, b.shadow)(this, "structTreeRoot", O);
              }
              _readStructTreeRoot() {
                const O = this._catDict.getRaw("StructTreeRoot"), L = this.xref.fetchIfRef(O);
                if (!(L instanceof y.Dict))
                  return null;
                const B = new I.StructTreeRoot(L, O);
                return B.init(), B;
              }
              get toplevelPagesDict() {
                const O = this._catDict.get("Pages");
                if (!(O instanceof y.Dict))
                  throw new b.FormatError("Invalid top-level pages dictionary.");
                return (0, b.shadow)(this, "toplevelPagesDict", O);
              }
              get documentOutline() {
                let O = null;
                try {
                  O = this._readDocumentOutline();
                } catch (L) {
                  if (L instanceof g.MissingDataException)
                    throw L;
                  (0, b.warn)("Unable to read document outline.");
                }
                return (0, b.shadow)(this, "documentOutline", O);
              }
              _readDocumentOutline() {
                let O = this._catDict.get("Outlines");
                if (!(O instanceof y.Dict) || (O = O.getRaw("First"), !(O instanceof y.Ref)))
                  return null;
                const L = {
                  items: []
                }, B = [{
                  obj: O,
                  parent: L
                }], F = new y.RefSet();
                F.put(O);
                const M = this.xref, W = new Uint8ClampedArray(3);
                for (; B.length > 0; ) {
                  const j = B.shift(), G = M.fetchIfRef(j.obj);
                  if (G === null)
                    continue;
                  if (!G.has("Title"))
                    throw new b.FormatError("Invalid outline item encountered.");
                  const U = {
                    url: null,
                    dest: null,
                    action: null
                  };
                  E.parseDestDictionary({
                    destDict: G,
                    resultObj: U,
                    docBaseUrl: this.baseUrl,
                    docAttachments: this.attachments
                  });
                  const k = G.get("Title"), N = G.get("F") || 0, P = G.getArray("C"), D = G.get("Count");
                  let H = W;
                  Array.isArray(P) && P.length === 3 && (P[0] !== 0 || P[1] !== 0 || P[2] !== 0) && (H = w.ColorSpace.singletons.rgb.getRgb(P, 0));
                  const V = {
                    action: U.action,
                    attachment: U.attachment,
                    dest: U.dest,
                    url: U.url,
                    unsafeUrl: U.unsafeUrl,
                    newWindow: U.newWindow,
                    setOCGState: U.setOCGState,
                    title: (0, b.stringToPDFString)(k),
                    color: H,
                    count: Number.isInteger(D) ? D : void 0,
                    bold: !!(N & 2),
                    italic: !!(N & 1),
                    items: []
                  };
                  j.parent.items.push(V), O = G.getRaw("First"), O instanceof y.Ref && !F.has(O) && (B.push({
                    obj: O,
                    parent: V
                  }), F.put(O)), O = G.getRaw("Next"), O instanceof y.Ref && !F.has(O) && (B.push({
                    obj: O,
                    parent: j.parent
                  }), F.put(O));
                }
                return L.items.length > 0 ? L.items : null;
              }
              get permissions() {
                let O = null;
                try {
                  O = this._readPermissions();
                } catch (L) {
                  if (L instanceof g.MissingDataException)
                    throw L;
                  (0, b.warn)("Unable to read permissions.");
                }
                return (0, b.shadow)(this, "permissions", O);
              }
              _readPermissions() {
                const O = this.xref.trailer.get("Encrypt");
                if (!(O instanceof y.Dict))
                  return null;
                let L = O.get("P");
                if (typeof L != "number")
                  return null;
                L += 4294967296;
                const B = [];
                for (const F in b.PermissionFlag) {
                  const M = b.PermissionFlag[F];
                  L & M && B.push(M);
                }
                return B;
              }
              get optionalContentConfig() {
                let O = null;
                try {
                  const L = this._catDict.get("OCProperties");
                  if (!L)
                    return (0, b.shadow)(this, "optionalContentConfig", null);
                  const B = L.get("D");
                  if (!B)
                    return (0, b.shadow)(this, "optionalContentConfig", null);
                  const F = L.get("OCGs");
                  if (!Array.isArray(F))
                    return (0, b.shadow)(this, "optionalContentConfig", null);
                  const M = [], W = [];
                  for (const j of F) {
                    if (!(j instanceof y.Ref))
                      continue;
                    W.push(j);
                    const G = this.xref.fetchIfRef(j);
                    M.push({
                      id: j.toString(),
                      name: typeof G.get("Name") == "string" ? (0, b.stringToPDFString)(G.get("Name")) : null,
                      intent: typeof G.get("Intent") == "string" ? (0, b.stringToPDFString)(G.get("Intent")) : null
                    });
                  }
                  O = this._readOptionalContentConfig(B, W), O.groups = M;
                } catch (L) {
                  if (L instanceof g.MissingDataException)
                    throw L;
                  (0, b.warn)(`Unable to read optional content config: ${L}`);
                }
                return (0, b.shadow)(this, "optionalContentConfig", O);
              }
              _readOptionalContentConfig(O, L) {
                function B(U) {
                  const k = [];
                  if (Array.isArray(U))
                    for (const N of U)
                      N instanceof y.Ref && L.includes(N) && k.push(N.toString());
                  return k;
                }
                function F(U, k = 0) {
                  if (!Array.isArray(U))
                    return null;
                  const N = [];
                  for (const D of U) {
                    if (D instanceof y.Ref && L.includes(D)) {
                      j.put(D), N.push(D.toString());
                      continue;
                    }
                    const H = M(D, k);
                    H && N.push(H);
                  }
                  if (k > 0)
                    return N;
                  const P = [];
                  for (const D of L)
                    j.has(D) || P.push(D.toString());
                  return P.length && N.push({
                    name: null,
                    order: P
                  }), N;
                }
                function M(U, k) {
                  if (++k > G)
                    return (0, b.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS."), null;
                  const N = W.fetchIfRef(U);
                  if (!Array.isArray(N))
                    return null;
                  const P = W.fetchIfRef(N[0]);
                  if (typeof P != "string")
                    return null;
                  const D = F(N.slice(1), k);
                  return !D || !D.length ? null : {
                    name: (0, b.stringToPDFString)(P),
                    order: D
                  };
                }
                const W = this.xref, j = new y.RefSet(), G = 10;
                return {
                  name: typeof O.get("Name") == "string" ? (0, b.stringToPDFString)(O.get("Name")) : null,
                  creator: typeof O.get("Creator") == "string" ? (0, b.stringToPDFString)(O.get("Creator")) : null,
                  baseState: O.get("BaseState") instanceof y.Name ? O.get("BaseState").name : null,
                  on: B(O.get("ON")),
                  off: B(O.get("OFF")),
                  order: F(O.get("Order")),
                  groups: null
                };
              }
              setActualNumPages(O = null) {
                this._actualNumPages = O;
              }
              get hasActualNumPages() {
                return this._actualNumPages !== null;
              }
              get _pagesCount() {
                const O = this.toplevelPagesDict.get("Count");
                if (!Number.isInteger(O))
                  throw new b.FormatError("Page count in top-level pages dictionary is not an integer.");
                return (0, b.shadow)(this, "_pagesCount", O);
              }
              get numPages() {
                return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
              }
              get destinations() {
                const O = this._readDests(), L = /* @__PURE__ */ Object.create(null);
                if (O instanceof f.NameTree)
                  for (const [B, F] of O.getAll()) {
                    const M = _(F);
                    M && (L[(0, b.stringToPDFString)(B)] = M);
                  }
                else O instanceof y.Dict && O.forEach(function(B, F) {
                  const M = _(F);
                  M && (L[B] = M);
                });
                return (0, b.shadow)(this, "destinations", L);
              }
              getDestination(O) {
                const L = this._readDests();
                if (L instanceof f.NameTree) {
                  const B = _(L.get(O));
                  if (B)
                    return B;
                  const F = this.destinations[O];
                  if (F)
                    return (0, b.warn)(`Found "${O}" at an incorrect position in the NameTree.`), F;
                } else if (L instanceof y.Dict) {
                  const B = _(L.get(O));
                  if (B)
                    return B;
                }
                return null;
              }
              _readDests() {
                const O = this._catDict.get("Names");
                if (O?.has("Dests"))
                  return new f.NameTree(O.getRaw("Dests"), this.xref);
                if (this._catDict.has("Dests"))
                  return this._catDict.get("Dests");
              }
              get pageLabels() {
                let O = null;
                try {
                  O = this._readPageLabels();
                } catch (L) {
                  if (L instanceof g.MissingDataException)
                    throw L;
                  (0, b.warn)("Unable to read page labels.");
                }
                return (0, b.shadow)(this, "pageLabels", O);
              }
              _readPageLabels() {
                const O = this._catDict.getRaw("PageLabels");
                if (!O)
                  return null;
                const L = new Array(this.numPages);
                let B = null, F = "";
                const W = new f.NumberTree(O, this.xref).getAll();
                let j = "", G = 1;
                for (let U = 0, k = this.numPages; U < k; U++) {
                  const N = W.get(U);
                  if (N !== void 0) {
                    if (!(N instanceof y.Dict))
                      throw new b.FormatError("PageLabel is not a dictionary.");
                    if (N.has("Type") && !(0, y.isName)(N.get("Type"), "PageLabel"))
                      throw new b.FormatError("Invalid type in PageLabel dictionary.");
                    if (N.has("S")) {
                      const P = N.get("S");
                      if (!(P instanceof y.Name))
                        throw new b.FormatError("Invalid style in PageLabel dictionary.");
                      B = P.name;
                    } else
                      B = null;
                    if (N.has("P")) {
                      const P = N.get("P");
                      if (typeof P != "string")
                        throw new b.FormatError("Invalid prefix in PageLabel dictionary.");
                      F = (0, b.stringToPDFString)(P);
                    } else
                      F = "";
                    if (N.has("St")) {
                      const P = N.get("St");
                      if (!(Number.isInteger(P) && P >= 1))
                        throw new b.FormatError("Invalid start in PageLabel dictionary.");
                      G = P;
                    } else
                      G = 1;
                  }
                  switch (B) {
                    case "D":
                      j = G;
                      break;
                    case "R":
                    case "r":
                      j = (0, g.toRomanNumerals)(G, B === "r");
                      break;
                    case "A":
                    case "a":
                      const P = 26, V = B === "a" ? 97 : 65, Z = G - 1;
                      j = String.fromCharCode(V + Z % P).repeat(Math.floor(Z / P) + 1);
                      break;
                    default:
                      if (B)
                        throw new b.FormatError(`Invalid style "${B}" in PageLabel dictionary.`);
                      j = "";
                  }
                  L[U] = F + j, G++;
                }
                return L;
              }
              get pageLayout() {
                const O = this._catDict.get("PageLayout");
                let L = "";
                if (O instanceof y.Name)
                  switch (O.name) {
                    case "SinglePage":
                    case "OneColumn":
                    case "TwoColumnLeft":
                    case "TwoColumnRight":
                    case "TwoPageLeft":
                    case "TwoPageRight":
                      L = O.name;
                  }
                return (0, b.shadow)(this, "pageLayout", L);
              }
              get pageMode() {
                const O = this._catDict.get("PageMode");
                let L = "UseNone";
                if (O instanceof y.Name)
                  switch (O.name) {
                    case "UseNone":
                    case "UseOutlines":
                    case "UseThumbs":
                    case "FullScreen":
                    case "UseOC":
                    case "UseAttachments":
                      L = O.name;
                  }
                return (0, b.shadow)(this, "pageMode", L);
              }
              get viewerPreferences() {
                const O = this._catDict.get("ViewerPreferences");
                if (!(O instanceof y.Dict))
                  return (0, b.shadow)(this, "viewerPreferences", null);
                let L = null;
                for (const B of O.getKeys()) {
                  const F = O.get(B);
                  let M;
                  switch (B) {
                    case "HideToolbar":
                    case "HideMenubar":
                    case "HideWindowUI":
                    case "FitWindow":
                    case "CenterWindow":
                    case "DisplayDocTitle":
                    case "PickTrayByPDFSize":
                      typeof F == "boolean" && (M = F);
                      break;
                    case "NonFullScreenPageMode":
                      if (F instanceof y.Name)
                        switch (F.name) {
                          case "UseNone":
                          case "UseOutlines":
                          case "UseThumbs":
                          case "UseOC":
                            M = F.name;
                            break;
                          default:
                            M = "UseNone";
                        }
                      break;
                    case "Direction":
                      if (F instanceof y.Name)
                        switch (F.name) {
                          case "L2R":
                          case "R2L":
                            M = F.name;
                            break;
                          default:
                            M = "L2R";
                        }
                      break;
                    case "ViewArea":
                    case "ViewClip":
                    case "PrintArea":
                    case "PrintClip":
                      if (F instanceof y.Name)
                        switch (F.name) {
                          case "MediaBox":
                          case "CropBox":
                          case "BleedBox":
                          case "TrimBox":
                          case "ArtBox":
                            M = F.name;
                            break;
                          default:
                            M = "CropBox";
                        }
                      break;
                    case "PrintScaling":
                      if (F instanceof y.Name)
                        switch (F.name) {
                          case "None":
                          case "AppDefault":
                            M = F.name;
                            break;
                          default:
                            M = "AppDefault";
                        }
                      break;
                    case "Duplex":
                      if (F instanceof y.Name)
                        switch (F.name) {
                          case "Simplex":
                          case "DuplexFlipShortEdge":
                          case "DuplexFlipLongEdge":
                            M = F.name;
                            break;
                          default:
                            M = "None";
                        }
                      break;
                    case "PrintPageRange":
                      Array.isArray(F) && F.length % 2 === 0 && F.every((j, G, U) => Number.isInteger(j) && j > 0 && (G === 0 || j >= U[G - 1]) && j <= this.numPages) && (M = F);
                      break;
                    case "NumCopies":
                      Number.isInteger(F) && F > 0 && (M = F);
                      break;
                    default:
                      (0, b.warn)(`Ignoring non-standard key in ViewerPreferences: ${B}.`);
                      continue;
                  }
                  if (M === void 0) {
                    (0, b.warn)(`Bad value, for key "${B}", in ViewerPreferences: ${F}.`);
                    continue;
                  }
                  L || (L = /* @__PURE__ */ Object.create(null)), L[B] = M;
                }
                return (0, b.shadow)(this, "viewerPreferences", L);
              }
              get openAction() {
                const O = this._catDict.get("OpenAction"), L = /* @__PURE__ */ Object.create(null);
                if (O instanceof y.Dict) {
                  const B = new y.Dict(this.xref);
                  B.set("A", O);
                  const F = {
                    url: null,
                    dest: null,
                    action: null
                  };
                  E.parseDestDictionary({
                    destDict: B,
                    resultObj: F
                  }), Array.isArray(F.dest) ? L.dest = F.dest : F.action && (L.action = F.action);
                } else Array.isArray(O) && (L.dest = O);
                return (0, b.shadow)(this, "openAction", (0, b.objectSize)(L) > 0 ? L : null);
              }
              get attachments() {
                const O = this._catDict.get("Names");
                let L = null;
                if (O instanceof y.Dict && O.has("EmbeddedFiles")) {
                  const B = new f.NameTree(O.getRaw("EmbeddedFiles"), this.xref);
                  for (const [F, M] of B.getAll()) {
                    const W = new S.FileSpec(M, this.xref);
                    L || (L = /* @__PURE__ */ Object.create(null)), L[(0, b.stringToPDFString)(F)] = W.serializable;
                  }
                }
                return (0, b.shadow)(this, "attachments", L);
              }
              get xfaImages() {
                const O = this._catDict.get("Names");
                let L = null;
                if (O instanceof y.Dict && O.has("XFAImages")) {
                  const B = new f.NameTree(O.getRaw("XFAImages"), this.xref);
                  for (const [F, M] of B.getAll())
                    L || (L = new y.Dict(this.xref)), L.set((0, b.stringToPDFString)(F), M);
                }
                return (0, b.shadow)(this, "xfaImages", L);
              }
              _collectJavaScript() {
                const O = this._catDict.get("Names");
                let L = null;
                function B(M, W) {
                  if (!(W instanceof y.Dict) || !(0, y.isName)(W.get("S"), "JavaScript"))
                    return;
                  let j = W.get("JS");
                  if (j instanceof m.BaseStream)
                    j = j.getString();
                  else if (typeof j != "string")
                    return;
                  j = (0, b.stringToPDFString)(j).replaceAll("\0", ""), j && (L ||= /* @__PURE__ */ new Map()).set(M, j);
                }
                if (O instanceof y.Dict && O.has("JavaScript")) {
                  const M = new f.NameTree(O.getRaw("JavaScript"), this.xref);
                  for (const [W, j] of M.getAll())
                    B((0, b.stringToPDFString)(W), j);
                }
                const F = this._catDict.get("OpenAction");
                return F && B("OpenAction", F), L;
              }
              get jsActions() {
                const O = this._collectJavaScript();
                let L = (0, g.collectActions)(this.xref, this._catDict, b.DocumentActionEventType);
                if (O) {
                  L ||= /* @__PURE__ */ Object.create(null);
                  for (const [B, F] of O)
                    B in L ? L[B].push(F) : L[B] = [F];
                }
                return (0, b.shadow)(this, "jsActions", L);
              }
              async fontFallback(O, L) {
                const B = await Promise.all(this.fontCache);
                for (const F of B)
                  if (F.loadedName === O) {
                    F.fallback(L);
                    return;
                  }
              }
              async cleanup(O = !1) {
                (0, C.clearGlobalCaches)(), this.globalImageCache.clear(O), this.pageKidsCountCache.clear(), this.pageIndexCache.clear(), this.nonBlendModesSet.clear();
                const L = await Promise.all(this.fontCache);
                for (const {
                  dict: B
                } of L)
                  delete B.cacheKey;
                this.fontCache.clear(), this.builtInCMapCache.clear(), this.standardFontDataCache.clear(), this.systemFontCache.clear();
              }
              async getPageDict(O) {
                const L = [this.toplevelPagesDict], B = new y.RefSet(), F = this._catDict.getRaw("Pages");
                F instanceof y.Ref && B.put(F);
                const M = this.xref, W = this.pageKidsCountCache, j = this.pageIndexCache;
                let G = 0;
                for (; L.length; ) {
                  const U = L.pop();
                  if (U instanceof y.Ref) {
                    const D = W.get(U);
                    if (D >= 0 && G + D <= O) {
                      G += D;
                      continue;
                    }
                    if (B.has(U))
                      throw new b.FormatError("Pages tree contains circular reference.");
                    B.put(U);
                    const H = await M.fetchAsync(U);
                    if (H instanceof y.Dict) {
                      let V = H.getRaw("Type");
                      if (V instanceof y.Ref && (V = await M.fetchAsync(V)), (0, y.isName)(V, "Page") || !H.has("Kids")) {
                        if (W.has(U) || W.put(U, 1), j.has(U) || j.put(U, G), G === O)
                          return [H, U];
                        G++;
                        continue;
                      }
                    }
                    L.push(H);
                    continue;
                  }
                  if (!(U instanceof y.Dict))
                    throw new b.FormatError("Page dictionary kid reference points to wrong type of object.");
                  const {
                    objId: k
                  } = U;
                  let N = U.getRaw("Count");
                  if (N instanceof y.Ref && (N = await M.fetchAsync(N)), Number.isInteger(N) && N >= 0 && (k && !W.has(k) && W.put(k, N), G + N <= O)) {
                    G += N;
                    continue;
                  }
                  let P = U.getRaw("Kids");
                  if (P instanceof y.Ref && (P = await M.fetchAsync(P)), !Array.isArray(P)) {
                    let D = U.getRaw("Type");
                    if (D instanceof y.Ref && (D = await M.fetchAsync(D)), (0, y.isName)(D, "Page") || !U.has("Kids")) {
                      if (G === O)
                        return [U, null];
                      G++;
                      continue;
                    }
                    throw new b.FormatError("Page dictionary kids object is not an array.");
                  }
                  for (let D = P.length - 1; D >= 0; D--)
                    L.push(P[D]);
                }
                throw new Error(`Page index ${O} not found.`);
              }
              async getAllPageDicts(O = !1) {
                const {
                  ignoreErrors: L
                } = this.pdfManager.evaluatorOptions, B = [{
                  currentNode: this.toplevelPagesDict,
                  posInKids: 0
                }], F = new y.RefSet(), M = this._catDict.getRaw("Pages");
                M instanceof y.Ref && F.put(M);
                const W = /* @__PURE__ */ new Map(), j = this.xref, G = this.pageIndexCache;
                let U = 0;
                function k(P, D) {
                  D && !G.has(D) && G.put(D, U), W.set(U++, [P, D]);
                }
                function N(P) {
                  if (P instanceof g.XRefEntryException && !O)
                    throw P;
                  O && L && U === 0 && ((0, b.warn)(`getAllPageDicts - Skipping invalid first page: "${P}".`), P = y.Dict.empty), W.set(U++, [P, null]);
                }
                for (; B.length > 0; ) {
                  const P = B.at(-1), {
                    currentNode: D,
                    posInKids: H
                  } = P;
                  let V = D.getRaw("Kids");
                  if (V instanceof y.Ref)
                    try {
                      V = await j.fetchAsync(V);
                    } catch (q) {
                      N(q);
                      break;
                    }
                  if (!Array.isArray(V)) {
                    N(new b.FormatError("Page dictionary kids object is not an array."));
                    break;
                  }
                  if (H >= V.length) {
                    B.pop();
                    continue;
                  }
                  const Z = V[H];
                  let ne;
                  if (Z instanceof y.Ref) {
                    if (F.has(Z)) {
                      N(new b.FormatError("Pages tree contains circular reference."));
                      break;
                    }
                    F.put(Z);
                    try {
                      ne = await j.fetchAsync(Z);
                    } catch (q) {
                      N(q);
                      break;
                    }
                  } else
                    ne = Z;
                  if (!(ne instanceof y.Dict)) {
                    N(new b.FormatError("Page dictionary kid reference points to wrong type of object."));
                    break;
                  }
                  let K = ne.getRaw("Type");
                  if (K instanceof y.Ref)
                    try {
                      K = await j.fetchAsync(K);
                    } catch (q) {
                      N(q);
                      break;
                    }
                  (0, y.isName)(K, "Page") || !ne.has("Kids") ? k(ne, Z instanceof y.Ref ? Z : null) : B.push({
                    currentNode: ne,
                    posInKids: 0
                  }), P.posInKids++;
                }
                return W;
              }
              getPageIndex(O) {
                const L = this.pageIndexCache.get(O);
                if (L !== void 0)
                  return Promise.resolve(L);
                const B = this.xref;
                function F(j) {
                  let G = 0, U;
                  return B.fetchAsync(j).then(function(k) {
                    if ((0, y.isRefsEqual)(j, O) && !(0, y.isDict)(k, "Page") && !(k instanceof y.Dict && !k.has("Type") && k.has("Contents")))
                      throw new b.FormatError("The reference does not point to a /Page dictionary.");
                    if (!k)
                      return null;
                    if (!(k instanceof y.Dict))
                      throw new b.FormatError("Node must be a dictionary.");
                    return U = k.getRaw("Parent"), k.getAsync("Parent");
                  }).then(function(k) {
                    if (!k)
                      return null;
                    if (!(k instanceof y.Dict))
                      throw new b.FormatError("Parent must be a dictionary.");
                    return k.getAsync("Kids");
                  }).then(function(k) {
                    if (!k)
                      return null;
                    const N = [];
                    let P = !1;
                    for (const D of k) {
                      if (!(D instanceof y.Ref))
                        throw new b.FormatError("Kid must be a reference.");
                      if ((0, y.isRefsEqual)(D, j)) {
                        P = !0;
                        break;
                      }
                      N.push(B.fetchAsync(D).then(function(H) {
                        if (!(H instanceof y.Dict))
                          throw new b.FormatError("Kid node must be a dictionary.");
                        H.has("Count") ? G += H.get("Count") : G++;
                      }));
                    }
                    if (!P)
                      throw new b.FormatError("Kid reference not found in parent's kids.");
                    return Promise.all(N).then(function() {
                      return [G, U];
                    });
                  });
                }
                let M = 0;
                const W = (j) => F(j).then((G) => {
                  if (!G)
                    return this.pageIndexCache.put(O, M), M;
                  const [U, k] = G;
                  return M += U, W(k);
                });
                return W(O);
              }
              get baseUrl() {
                const O = this._catDict.get("URI");
                if (O instanceof y.Dict) {
                  const L = O.get("Base");
                  if (typeof L == "string") {
                    const B = (0, b.createValidAbsoluteUrl)(L, null, {
                      tryConvertEncoding: !0
                    });
                    if (B)
                      return (0, b.shadow)(this, "baseUrl", B.href);
                  }
                }
                return (0, b.shadow)(this, "baseUrl", this.pdfManager.docBaseUrl);
              }
              static parseDestDictionary({
                destDict: O,
                resultObj: L,
                docBaseUrl: B = null,
                docAttachments: F = null
              }) {
                if (!(O instanceof y.Dict)) {
                  (0, b.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                  return;
                }
                let M = O.get("A"), W, j;
                if (M instanceof y.Dict || (O.has("Dest") ? M = O.get("Dest") : (M = O.get("AA"), M instanceof y.Dict && (M.has("D") ? M = M.get("D") : M.has("U") && (M = M.get("U"))))), M instanceof y.Dict) {
                  const G = M.get("S");
                  if (!(G instanceof y.Name)) {
                    (0, b.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                    return;
                  }
                  const U = G.name;
                  switch (U) {
                    case "ResetForm":
                      const k = M.get("Flags"), N = ((typeof k == "number" ? k : 0) & 1) === 0, P = [], D = [];
                      for (const se of M.get("Fields") || [])
                        se instanceof y.Ref ? D.push(se.toString()) : typeof se == "string" && P.push((0, b.stringToPDFString)(se));
                      L.resetForm = {
                        fields: P,
                        refs: D,
                        include: N
                      };
                      break;
                    case "URI":
                      W = M.get("URI"), W instanceof y.Name && (W = "/" + W.name);
                      break;
                    case "GoTo":
                      j = M.get("D");
                      break;
                    case "Launch":
                    case "GoToR":
                      const H = M.get("F");
                      H instanceof y.Dict ? W = H.get("F") || null : typeof H == "string" && (W = H);
                      let V = M.get("D");
                      if (V && (V instanceof y.Name && (V = V.name), typeof W == "string")) {
                        const se = W.split("#")[0];
                        typeof V == "string" ? W = se + "#" + V : Array.isArray(V) && (W = se + "#" + JSON.stringify(V));
                      }
                      const Z = M.get("NewWindow");
                      typeof Z == "boolean" && (L.newWindow = Z);
                      break;
                    case "GoToE":
                      const ne = M.get("T");
                      let K;
                      if (F && ne instanceof y.Dict) {
                        const se = ne.get("R"), ie = ne.get("N");
                        (0, y.isName)(se, "C") && typeof ie == "string" && (K = F[(0, b.stringToPDFString)(ie)]);
                      }
                      K ? L.attachment = K : (0, b.warn)('parseDestDictionary - unimplemented "GoToE" action.');
                      break;
                    case "Named":
                      const q = M.get("N");
                      q instanceof y.Name && (L.action = q.name);
                      break;
                    case "SetOCGState":
                      const Y = M.get("State"), ee = M.get("PreserveRB");
                      if (!Array.isArray(Y) || Y.length === 0)
                        break;
                      const Q = [];
                      for (const se of Y)
                        if (se instanceof y.Name)
                          switch (se.name) {
                            case "ON":
                            case "OFF":
                            case "Toggle":
                              Q.push(se.name);
                              break;
                          }
                        else se instanceof y.Ref && Q.push(se.toString());
                      if (Q.length !== Y.length)
                        break;
                      L.setOCGState = {
                        state: Q,
                        preserveRB: typeof ee == "boolean" ? ee : !0
                      };
                      break;
                    case "JavaScript":
                      const J = M.get("JS");
                      let te;
                      J instanceof m.BaseStream ? te = J.getString() : typeof J == "string" && (te = J);
                      const ae = te && (0, g.recoverJsURL)((0, b.stringToPDFString)(te));
                      if (ae) {
                        W = ae.url, L.newWindow = ae.newWindow;
                        break;
                      }
                    default:
                      if (U === "JavaScript" || U === "SubmitForm")
                        break;
                      (0, b.warn)(`parseDestDictionary - unsupported action: "${U}".`);
                      break;
                  }
                } else O.has("Dest") && (j = O.get("Dest"));
                if (typeof W == "string") {
                  const G = (0, b.createValidAbsoluteUrl)(W, B, {
                    addDefaultProtocol: !0,
                    tryConvertEncoding: !0
                  });
                  G && (L.url = G.href), L.unsafeUrl = W;
                }
                j && (j instanceof y.Name && (j = j.name), typeof j == "string" ? L.dest = (0, b.stringToPDFString)(j) : Array.isArray(j) && (L.dest = j));
              }
            }
            A.Catalog = E;
          },
          /* 67 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.NumberTree = A.NameTree = void 0;
            var g = x(4), b = x(2);
            class y {
              constructor(w, S, $) {
                this.constructor === y && (0, b.unreachable)("Cannot initialize NameOrNumberTree."), this.root = w, this.xref = S, this._type = $;
              }
              getAll() {
                const w = /* @__PURE__ */ new Map();
                if (!this.root)
                  return w;
                const S = this.xref, $ = new g.RefSet();
                $.put(this.root);
                const T = [this.root];
                for (; T.length > 0; ) {
                  const I = S.fetchIfRef(T.shift());
                  if (!(I instanceof g.Dict))
                    continue;
                  if (I.has("Kids")) {
                    const E = I.get("Kids");
                    if (!Array.isArray(E))
                      continue;
                    for (const R of E) {
                      if ($.has(R))
                        throw new b.FormatError(`Duplicate entry in "${this._type}" tree.`);
                      T.push(R), $.put(R);
                    }
                    continue;
                  }
                  const _ = I.get(this._type);
                  if (Array.isArray(_))
                    for (let E = 0, R = _.length; E < R; E += 2)
                      w.set(S.fetchIfRef(_[E]), S.fetchIfRef(_[E + 1]));
                }
                return w;
              }
              get(w) {
                if (!this.root)
                  return null;
                const S = this.xref;
                let $ = S.fetchIfRef(this.root), T = 0;
                const I = 10;
                for (; $.has("Kids"); ) {
                  if (++T > I)
                    return (0, b.warn)(`Search depth limit reached for "${this._type}" tree.`), null;
                  const E = $.get("Kids");
                  if (!Array.isArray(E))
                    return null;
                  let R = 0, O = E.length - 1;
                  for (; R <= O; ) {
                    const L = R + O >> 1, B = S.fetchIfRef(E[L]), F = B.get("Limits");
                    if (w < S.fetchIfRef(F[0]))
                      O = L - 1;
                    else if (w > S.fetchIfRef(F[1]))
                      R = L + 1;
                    else {
                      $ = B;
                      break;
                    }
                  }
                  if (R > O)
                    return null;
                }
                const _ = $.get(this._type);
                if (Array.isArray(_)) {
                  let E = 0, R = _.length - 2;
                  for (; E <= R; ) {
                    const O = E + R >> 1, L = O + (O & 1), B = S.fetchIfRef(_[L]);
                    if (w < B)
                      R = L - 2;
                    else if (w > B)
                      E = L + 2;
                    else
                      return S.fetchIfRef(_[L + 1]);
                  }
                }
                return null;
              }
            }
            class f extends y {
              constructor(w, S) {
                super(w, S, "Names");
              }
            }
            A.NameTree = f;
            class m extends y {
              constructor(w, S) {
                super(w, S, "Nums");
              }
            }
            A.NumberTree = m;
          },
          /* 68 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.clearGlobalCaches = f;
            var g = x(50), b = x(4), y = x(40);
            function f() {
              (0, g.clearPatternCaches)(), (0, b.clearPrimitiveCaches)(), (0, y.clearUnicodeCaches)();
            }
          },
          /* 69 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.FileSpec = void 0;
            var g = x(2), b = x(5), y = x(4);
            function f(C) {
              return C.has("UF") ? C.get("UF") : C.has("F") ? C.get("F") : C.has("Unix") ? C.get("Unix") : C.has("Mac") ? C.get("Mac") : C.has("DOS") ? C.get("DOS") : null;
            }
            class m {
              constructor(w, S) {
                w instanceof y.Dict && (this.xref = S, this.root = w, w.has("FS") && (this.fs = w.get("FS")), this.description = w.has("Desc") ? (0, g.stringToPDFString)(w.get("Desc")) : "", w.has("RF") && (0, g.warn)("Related file specifications are not supported"), this.contentAvailable = !0, w.has("EF") || (this.contentAvailable = !1, (0, g.warn)("Non-embedded file specifications are not supported")));
              }
              get filename() {
                if (!this._filename && this.root) {
                  const w = f(this.root) || "unnamed";
                  this._filename = (0, g.stringToPDFString)(w).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
                }
                return this._filename;
              }
              get content() {
                if (!this.contentAvailable)
                  return null;
                !this.contentRef && this.root && (this.contentRef = f(this.root.get("EF")));
                let w = null;
                if (this.contentRef) {
                  const S = this.xref.fetchIfRef(this.contentRef);
                  S instanceof b.BaseStream ? w = S.getBytes() : (0, g.warn)("Embedded file specification points to non-existing/invalid content");
                } else
                  (0, g.warn)("Embedded file specification does not have a content");
                return w;
              }
              get serializable() {
                return {
                  filename: this.filename,
                  content: this.content
                };
              }
            }
            A.FileSpec = m;
          },
          /* 70 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.MetadataParser = void 0;
            var g = x(71);
            class b {
              constructor(f) {
                f = this._repair(f);
                const C = new g.SimpleXMLParser({
                  lowerCaseName: !0
                }).parseFromString(f);
                this._metadataMap = /* @__PURE__ */ new Map(), this._data = f, C && this._parse(C);
              }
              _repair(f) {
                return f.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(m, C) {
                  const w = C.replaceAll(/\\([0-3])([0-7])([0-7])/g, function($, T, I, _) {
                    return String.fromCharCode(T * 64 + I * 8 + _ * 1);
                  }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function($, T) {
                    switch (T) {
                      case "amp":
                        return "&";
                      case "apos":
                        return "'";
                      case "gt":
                        return ">";
                      case "lt":
                        return "<";
                      case "quot":
                        return '"';
                    }
                    throw new Error(`_repair: ${T} isn't defined.`);
                  }), S = [">"];
                  for (let $ = 0, T = w.length; $ < T; $ += 2) {
                    const I = w.charCodeAt($) * 256 + w.charCodeAt($ + 1);
                    I >= 32 && I < 127 && I !== 60 && I !== 62 && I !== 38 ? S.push(String.fromCharCode(I)) : S.push("&#x" + (65536 + I).toString(16).substring(1) + ";");
                  }
                  return S.join("");
                });
              }
              _getSequence(f) {
                const m = f.nodeName;
                return m !== "rdf:bag" && m !== "rdf:seq" && m !== "rdf:alt" ? null : f.childNodes.filter((C) => C.nodeName === "rdf:li");
              }
              _parseArray(f) {
                if (!f.hasChildNodes())
                  return;
                const [m] = f.childNodes, C = this._getSequence(m) || [];
                this._metadataMap.set(f.nodeName, C.map((w) => w.textContent.trim()));
              }
              _parse(f) {
                let m = f.documentElement;
                if (m.nodeName !== "rdf:rdf")
                  for (m = m.firstChild; m && m.nodeName !== "rdf:rdf"; )
                    m = m.nextSibling;
                if (!(!m || m.nodeName !== "rdf:rdf" || !m.hasChildNodes())) {
                  for (const C of m.childNodes)
                    if (C.nodeName === "rdf:description")
                      for (const w of C.childNodes) {
                        const S = w.nodeName;
                        switch (S) {
                          case "#text":
                            continue;
                          case "dc:creator":
                          case "dc:subject":
                            this._parseArray(w);
                            continue;
                        }
                        this._metadataMap.set(S, w.textContent.trim());
                      }
                }
              }
              get serializable() {
                return {
                  parsedData: this._metadataMap,
                  rawData: this._data
                };
              }
            }
            A.MetadataParser = b;
          },
          /* 71 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.XMLParserErrorCode = A.XMLParserBase = A.SimpleXMLParser = A.SimpleDOMNode = void 0;
            var g = x(3);
            const b = {
              NoError: 0,
              EndOfDocument: -1,
              UnterminatedCdat: -2,
              UnterminatedXmlDeclaration: -3,
              UnterminatedDoctypeDeclaration: -4,
              UnterminatedComment: -5,
              MalformedElement: -6,
              OutOfMemory: -7,
              UnterminatedAttributeValue: -8,
              UnterminatedElement: -9,
              ElementNeverBegun: -10
            };
            A.XMLParserErrorCode = b;
            function y(S, $) {
              const T = S[$];
              return T === " " || T === `
` || T === "\r" || T === "	";
            }
            function f(S) {
              for (let $ = 0, T = S.length; $ < T; $++)
                if (!y(S, $))
                  return !1;
              return !0;
            }
            class m {
              _resolveEntities($) {
                return $.replaceAll(/&([^;]+);/g, (T, I) => {
                  if (I.substring(0, 2) === "#x")
                    return String.fromCodePoint(parseInt(I.substring(2), 16));
                  if (I.substring(0, 1) === "#")
                    return String.fromCodePoint(parseInt(I.substring(1), 10));
                  switch (I) {
                    case "lt":
                      return "<";
                    case "gt":
                      return ">";
                    case "amp":
                      return "&";
                    case "quot":
                      return '"';
                    case "apos":
                      return "'";
                  }
                  return this.onResolveEntity(I);
                });
              }
              _parseContent($, T) {
                const I = [];
                let _ = T;
                function E() {
                  for (; _ < $.length && y($, _); )
                    ++_;
                }
                for (; _ < $.length && !y($, _) && $[_] !== ">" && $[_] !== "/"; )
                  ++_;
                const R = $.substring(T, _);
                for (E(); _ < $.length && $[_] !== ">" && $[_] !== "/" && $[_] !== "?"; ) {
                  E();
                  let O = "", L = "";
                  for (; _ < $.length && !y($, _) && $[_] !== "="; )
                    O += $[_], ++_;
                  if (E(), $[_] !== "=")
                    return null;
                  ++_, E();
                  const B = $[_];
                  if (B !== '"' && B !== "'")
                    return null;
                  const F = $.indexOf(B, ++_);
                  if (F < 0)
                    return null;
                  L = $.substring(_, F), I.push({
                    name: O,
                    value: this._resolveEntities(L)
                  }), _ = F + 1, E();
                }
                return {
                  name: R,
                  attributes: I,
                  parsed: _ - T
                };
              }
              _parseProcessingInstruction($, T) {
                let I = T;
                function _() {
                  for (; I < $.length && y($, I); )
                    ++I;
                }
                for (; I < $.length && !y($, I) && $[I] !== ">" && $[I] !== "?" && $[I] !== "/"; )
                  ++I;
                const E = $.substring(T, I);
                _();
                const R = I;
                for (; I < $.length && ($[I] !== "?" || $[I + 1] !== ">"); )
                  ++I;
                const O = $.substring(R, I);
                return {
                  name: E,
                  value: O,
                  parsed: I - T
                };
              }
              parseXml($) {
                let T = 0;
                for (; T < $.length; ) {
                  const I = $[T];
                  let _ = T;
                  if (I === "<") {
                    ++_;
                    const E = $[_];
                    let R;
                    switch (E) {
                      case "/":
                        if (++_, R = $.indexOf(">", _), R < 0) {
                          this.onError(b.UnterminatedElement);
                          return;
                        }
                        this.onEndElement($.substring(_, R)), _ = R + 1;
                        break;
                      case "?":
                        ++_;
                        const O = this._parseProcessingInstruction($, _);
                        if ($.substring(_ + O.parsed, _ + O.parsed + 2) !== "?>") {
                          this.onError(b.UnterminatedXmlDeclaration);
                          return;
                        }
                        this.onPi(O.name, O.value), _ += O.parsed + 2;
                        break;
                      case "!":
                        if ($.substring(_ + 1, _ + 3) === "--") {
                          if (R = $.indexOf("-->", _ + 3), R < 0) {
                            this.onError(b.UnterminatedComment);
                            return;
                          }
                          this.onComment($.substring(_ + 3, R)), _ = R + 3;
                        } else if ($.substring(_ + 1, _ + 8) === "[CDATA[") {
                          if (R = $.indexOf("]]>", _ + 8), R < 0) {
                            this.onError(b.UnterminatedCdat);
                            return;
                          }
                          this.onCdata($.substring(_ + 8, R)), _ = R + 3;
                        } else if ($.substring(_ + 1, _ + 8) === "DOCTYPE") {
                          const F = $.indexOf("[", _ + 8);
                          let M = !1;
                          if (R = $.indexOf(">", _ + 8), R < 0) {
                            this.onError(b.UnterminatedDoctypeDeclaration);
                            return;
                          }
                          if (F > 0 && R > F) {
                            if (R = $.indexOf("]>", _ + 8), R < 0) {
                              this.onError(b.UnterminatedDoctypeDeclaration);
                              return;
                            }
                            M = !0;
                          }
                          const W = $.substring(_ + 8, R + (M ? 1 : 0));
                          this.onDoctype(W), _ = R + (M ? 2 : 1);
                        } else {
                          this.onError(b.MalformedElement);
                          return;
                        }
                        break;
                      default:
                        const L = this._parseContent($, _);
                        if (L === null) {
                          this.onError(b.MalformedElement);
                          return;
                        }
                        let B = !1;
                        if ($.substring(_ + L.parsed, _ + L.parsed + 2) === "/>")
                          B = !0;
                        else if ($.substring(_ + L.parsed, _ + L.parsed + 1) !== ">") {
                          this.onError(b.UnterminatedElement);
                          return;
                        }
                        this.onBeginElement(L.name, L.attributes, B), _ += L.parsed + (B ? 2 : 1);
                        break;
                    }
                  } else {
                    for (; _ < $.length && $[_] !== "<"; )
                      _++;
                    const E = $.substring(T, _);
                    this.onText(this._resolveEntities(E));
                  }
                  T = _;
                }
              }
              onResolveEntity($) {
                return `&${$};`;
              }
              onPi($, T) {
              }
              onComment($) {
              }
              onCdata($) {
              }
              onDoctype($) {
              }
              onText($) {
              }
              onBeginElement($, T, I) {
              }
              onEndElement($) {
              }
              onError($) {
              }
            }
            A.XMLParserBase = m;
            class C {
              constructor($, T) {
                this.nodeName = $, this.nodeValue = T, Object.defineProperty(this, "parentNode", {
                  value: null,
                  writable: !0
                });
              }
              get firstChild() {
                return this.childNodes?.[0];
              }
              get nextSibling() {
                const $ = this.parentNode.childNodes;
                if (!$)
                  return;
                const T = $.indexOf(this);
                if (T !== -1)
                  return $[T + 1];
              }
              get textContent() {
                return this.childNodes ? this.childNodes.map(function($) {
                  return $.textContent;
                }).join("") : this.nodeValue || "";
              }
              get children() {
                return this.childNodes || [];
              }
              hasChildNodes() {
                return this.childNodes?.length > 0;
              }
              searchNode($, T) {
                if (T >= $.length)
                  return this;
                const I = $[T];
                if (I.name.startsWith("#") && T < $.length - 1)
                  return this.searchNode($, T + 1);
                const _ = [];
                let E = this;
                for (; ; ) {
                  if (I.name === E.nodeName)
                    if (I.pos === 0) {
                      const R = E.searchNode($, T + 1);
                      if (R !== null)
                        return R;
                    } else {
                      if (_.length === 0)
                        return null;
                      {
                        const [R] = _.pop();
                        let O = 0;
                        for (const L of R.childNodes)
                          if (I.name === L.nodeName) {
                            if (O === I.pos)
                              return L.searchNode($, T + 1);
                            O++;
                          }
                        return E.searchNode($, T + 1);
                      }
                    }
                  if (E.childNodes?.length > 0)
                    _.push([E, 0]), E = E.childNodes[0];
                  else {
                    if (_.length === 0)
                      return null;
                    for (; _.length !== 0; ) {
                      const [R, O] = _.pop(), L = O + 1;
                      if (L < R.childNodes.length) {
                        _.push([R, L]), E = R.childNodes[L];
                        break;
                      }
                    }
                    if (_.length === 0)
                      return null;
                  }
                }
              }
              dump($) {
                if (this.nodeName === "#text") {
                  $.push((0, g.encodeToXmlString)(this.nodeValue));
                  return;
                }
                if ($.push(`<${this.nodeName}`), this.attributes)
                  for (const T of this.attributes)
                    $.push(` ${T.name}="${(0, g.encodeToXmlString)(T.value)}"`);
                if (this.hasChildNodes()) {
                  $.push(">");
                  for (const T of this.childNodes)
                    T.dump($);
                  $.push(`</${this.nodeName}>`);
                } else this.nodeValue ? $.push(`>${(0, g.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`) : $.push("/>");
              }
            }
            A.SimpleDOMNode = C;
            class w extends m {
              constructor({
                hasAttributes: $ = !1,
                lowerCaseName: T = !1
              }) {
                super(), this._currentFragment = null, this._stack = null, this._errorCode = b.NoError, this._hasAttributes = $, this._lowerCaseName = T;
              }
              parseFromString($) {
                if (this._currentFragment = [], this._stack = [], this._errorCode = b.NoError, this.parseXml($), this._errorCode !== b.NoError)
                  return;
                const [T] = this._currentFragment;
                if (T)
                  return {
                    documentElement: T
                  };
              }
              onText($) {
                if (f($))
                  return;
                const T = new C("#text", $);
                this._currentFragment.push(T);
              }
              onCdata($) {
                const T = new C("#text", $);
                this._currentFragment.push(T);
              }
              onBeginElement($, T, I) {
                this._lowerCaseName && ($ = $.toLowerCase());
                const _ = new C($);
                _.childNodes = [], this._hasAttributes && (_.attributes = T), this._currentFragment.push(_), !I && (this._stack.push(this._currentFragment), this._currentFragment = _.childNodes);
              }
              onEndElement($) {
                this._currentFragment = this._stack.pop() || [];
                const T = this._currentFragment.at(-1);
                if (!T)
                  return null;
                for (const I of T.childNodes)
                  I.parentNode = T;
                return T;
              }
              onError($) {
                this._errorCode = $;
              }
            }
            A.SimpleXMLParser = w;
          },
          /* 72 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.StructTreeRoot = A.StructTreePage = void 0;
            var g = x(2), b = x(4), y = x(67), f = x(73);
            const m = 40, C = {
              PAGE_CONTENT: 1,
              STREAM_CONTENT: 2,
              OBJECT: 3,
              ANNOTATION: 4,
              ELEMENT: 5
            };
            class w {
              constructor(_, E) {
                this.dict = _, this.ref = E instanceof b.Ref ? E : null, this.roleMap = /* @__PURE__ */ new Map(), this.structParentIds = null;
              }
              init() {
                this.readRoleMap();
              }
              #e(_, E, R) {
                if (!(_ instanceof b.Ref) || E < 0)
                  return;
                this.structParentIds ||= new b.RefSetCache();
                let O = this.structParentIds.get(_);
                O || (O = [], this.structParentIds.put(_, O)), O.push([E, R]);
              }
              addAnnotationIdToPage(_, E) {
                this.#e(_, E, C.ANNOTATION);
              }
              readRoleMap() {
                const _ = this.dict.get("RoleMap");
                _ instanceof b.Dict && _.forEach((E, R) => {
                  R instanceof b.Name && this.roleMap.set(E, R.name);
                });
              }
              static async canCreateStructureTree({
                catalogRef: _,
                pdfManager: E,
                newAnnotationsByPage: R
              }) {
                if (!(_ instanceof b.Ref))
                  return (0, g.warn)("Cannot save the struct tree: no catalog reference."), !1;
                let O = 0, L = !0;
                for (const [B, F] of R) {
                  const {
                    ref: M
                  } = await E.getPage(B);
                  if (!(M instanceof b.Ref)) {
                    (0, g.warn)(`Cannot save the struct tree: page ${B} has no ref.`), L = !0;
                    break;
                  }
                  for (const W of F)
                    W.accessibilityData?.type && (W.parentTreeId = O++, L = !1);
                }
                if (L) {
                  for (const B of R.values())
                    for (const F of B)
                      delete F.parentTreeId;
                  return !1;
                }
                return !0;
              }
              static async createStructureTree({
                newAnnotationsByPage: _,
                xref: E,
                catalogRef: R,
                pdfManager: O,
                newRefs: L
              }) {
                const B = O.catalog.cloneDict(), F = E.getNewTemporaryRef();
                B.set("StructTreeRoot", F);
                const M = [];
                await (0, f.writeObject)(R, B, M, E), L.push({
                  ref: R,
                  data: M.join("")
                });
                const W = new b.Dict(E);
                W.set("Type", b.Name.get("StructTreeRoot"));
                const j = E.getNewTemporaryRef();
                W.set("ParentTree", j);
                const G = [];
                W.set("K", G);
                const U = new b.Dict(E), k = [];
                U.set("Nums", k);
                const N = await this.#t({
                  newAnnotationsByPage: _,
                  structTreeRootRef: F,
                  kids: G,
                  nums: k,
                  xref: E,
                  pdfManager: O,
                  newRefs: L,
                  buffer: M
                });
                W.set("ParentTreeNextKey", N), M.length = 0, await (0, f.writeObject)(j, U, M, E), L.push({
                  ref: j,
                  data: M.join("")
                }), M.length = 0, await (0, f.writeObject)(F, W, M, E), L.push({
                  ref: F,
                  data: M.join("")
                });
              }
              async canUpdateStructTree({
                pdfManager: _,
                newAnnotationsByPage: E
              }) {
                if (!this.ref)
                  return (0, g.warn)("Cannot update the struct tree: no root reference."), !1;
                let R = this.dict.get("ParentTreeNextKey");
                if (!Number.isInteger(R) || R < 0)
                  return (0, g.warn)("Cannot update the struct tree: invalid next key."), !1;
                const O = this.dict.get("ParentTree");
                if (!(O instanceof b.Dict))
                  return (0, g.warn)("Cannot update the struct tree: ParentTree isn't a dict."), !1;
                const L = O.get("Nums");
                if (!Array.isArray(L))
                  return (0, g.warn)("Cannot update the struct tree: nums isn't an array."), !1;
                const {
                  numPages: B
                } = _.catalog;
                for (const M of E.keys()) {
                  const {
                    pageDict: W,
                    ref: j
                  } = await _.getPage(M);
                  if (!(j instanceof b.Ref))
                    return (0, g.warn)(`Cannot save the struct tree: page ${M} has no ref.`), !1;
                  const G = W.get("StructParents");
                  if (!Number.isInteger(G) || G < 0 || G >= B)
                    return (0, g.warn)(`Cannot save the struct tree: page ${M} has no id.`), !1;
                }
                let F = !0;
                for (const [M, W] of E) {
                  const {
                    pageDict: j
                  } = await _.getPage(M);
                  w.#r({
                    elements: W,
                    xref: this.dict.xref,
                    pageDict: j,
                    parentTree: O
                  });
                  for (const G of W)
                    G.accessibilityData?.type && (G.parentTreeId = R++, F = !1);
                }
                if (F) {
                  for (const M of E.values())
                    for (const W of M)
                      delete W.parentTreeId, delete W.structTreeParent;
                  return !1;
                }
                return !0;
              }
              async updateStructureTree({
                newAnnotationsByPage: _,
                pdfManager: E,
                newRefs: R
              }) {
                const O = this.dict.xref, L = this.dict.clone(), B = this.ref;
                let F = L.getRaw("ParentTree"), M;
                F instanceof b.Ref ? M = O.fetch(F) : (M = F, F = O.getNewTemporaryRef(), L.set("ParentTree", F)), M = M.clone();
                let W = M.getRaw("Nums"), j = null;
                W instanceof b.Ref && (j = W, W = O.fetch(j)), W = W.slice(), j || M.set("Nums", W);
                let G = L.getRaw("K"), U = null;
                G instanceof b.Ref ? (U = G, G = O.fetch(U)) : (U = O.getNewTemporaryRef(), L.set("K", U)), G = Array.isArray(G) ? G.slice() : [G];
                const k = [], N = await w.#t({
                  newAnnotationsByPage: _,
                  structTreeRootRef: B,
                  kids: G,
                  nums: W,
                  xref: O,
                  pdfManager: E,
                  newRefs: R,
                  buffer: k
                });
                L.set("ParentTreeNextKey", N), k.length = 0, await (0, f.writeObject)(U, G, k, O), R.push({
                  ref: U,
                  data: k.join("")
                }), j && (k.length = 0, await (0, f.writeObject)(j, W, k, O), R.push({
                  ref: j,
                  data: k.join("")
                })), k.length = 0, await (0, f.writeObject)(F, M, k, O), R.push({
                  ref: F,
                  data: k.join("")
                }), k.length = 0, await (0, f.writeObject)(B, L, k, O), R.push({
                  ref: B,
                  data: k.join("")
                });
              }
              static async #t({
                newAnnotationsByPage: _,
                structTreeRootRef: E,
                kids: R,
                nums: O,
                xref: L,
                pdfManager: B,
                newRefs: F,
                buffer: M
              }) {
                const W = b.Name.get("OBJR");
                let j = -1 / 0;
                for (const [G, U] of _) {
                  const {
                    ref: k
                  } = await B.getPage(G);
                  for (const {
                    accessibilityData: {
                      type: N,
                      title: P,
                      lang: D,
                      alt: H,
                      expanded: V,
                      actualText: Z
                    },
                    ref: ne,
                    parentTreeId: K,
                    structTreeParent: q
                  } of U) {
                    j = Math.max(j, K);
                    const Y = L.getNewTemporaryRef(), ee = new b.Dict(L);
                    ee.set("S", b.Name.get(N)), P && ee.set("T", P), D && ee.set("Lang", D), H && ee.set("Alt", H), V && ee.set("E", V), Z && ee.set("ActualText", Z), q ? await this.#n({
                      structTreeParent: q,
                      tagDict: ee,
                      newTagRef: Y,
                      fallbackRef: E,
                      xref: L,
                      newRefs: F,
                      buffer: M
                    }) : ee.set("P", E);
                    const Q = new b.Dict(L);
                    ee.set("K", Q), Q.set("Type", W), Q.set("Pg", k), Q.set("Obj", ne), M.length = 0, await (0, f.writeObject)(Y, ee, M, L), F.push({
                      ref: Y,
                      data: M.join("")
                    }), O.push(K, Y), R.push(Y);
                  }
                }
                return j + 1;
              }
              static #r({
                elements: _,
                xref: E,
                pageDict: R,
                parentTree: O
              }) {
                const L = /* @__PURE__ */ new Map();
                for (const j of _)
                  if (j.structTreeParentId) {
                    const G = parseInt(j.structTreeParentId.split("_mc")[1], 10);
                    L.set(G, j);
                  }
                const B = R.get("StructParents"), M = new y.NumberTree(O, E).get(B);
                if (!Array.isArray(M))
                  return;
                const W = (j, G, U) => {
                  const k = L.get(j);
                  if (k) {
                    const N = G.getRaw("P"), P = E.fetchIfRef(N);
                    return N instanceof b.Ref && P instanceof b.Dict && (k.structTreeParent = {
                      ref: U,
                      dict: G
                    }), !0;
                  }
                  return !1;
                };
                for (const j of M) {
                  if (!(j instanceof b.Ref))
                    continue;
                  const G = E.fetch(j), U = G.get("K");
                  if (Number.isInteger(U)) {
                    W(U, G, j);
                    continue;
                  }
                  if (Array.isArray(U)) {
                    for (let k of U)
                      if (k = E.fetchIfRef(k), Number.isInteger(k) && W(k, G, j))
                        break;
                  }
                }
              }
              static async #n({
                structTreeParent: {
                  ref: _,
                  dict: E
                },
                tagDict: R,
                newTagRef: O,
                fallbackRef: L,
                xref: B,
                newRefs: F,
                buffer: M
              }) {
                const W = E.getRaw("P");
                let j = B.fetchIfRef(W);
                R.set("P", W);
                let G = !1, U, k = j.getRaw("K");
                if (k instanceof b.Ref ? U = B.fetch(k) : (U = k, k = B.getNewTemporaryRef(), j = j.clone(), j.set("K", k), G = !0), Array.isArray(U)) {
                  const N = U.indexOf(_);
                  if (N >= 0)
                    U = U.slice(), U.splice(N + 1, 0, O);
                  else {
                    (0, g.warn)("Cannot update the struct tree: parent kid not found."), R.set("P", L);
                    return;
                  }
                } else U instanceof b.Dict && (U = [k, O], k = B.getNewTemporaryRef(), j.set("K", k), G = !0);
                M.length = 0, await (0, f.writeObject)(k, U, M, B), F.push({
                  ref: k,
                  data: M.join("")
                }), G && (M.length = 0, await (0, f.writeObject)(W, j, M, B), F.push({
                  ref: W,
                  data: M.join("")
                }));
              }
            }
            A.StructTreeRoot = w;
            class S {
              constructor(_, E) {
                this.tree = _, this.dict = E, this.kids = [], this.parseKids();
              }
              get role() {
                const _ = this.dict.get("S"), E = _ instanceof b.Name ? _.name : "", {
                  root: R
                } = this.tree;
                return R.roleMap.has(E) ? R.roleMap.get(E) : E;
              }
              parseKids() {
                let _ = null;
                const E = this.dict.getRaw("Pg");
                E instanceof b.Ref && (_ = E.toString());
                const R = this.dict.get("K");
                if (Array.isArray(R))
                  for (const O of R) {
                    const L = this.parseKid(_, O);
                    L && this.kids.push(L);
                  }
                else {
                  const O = this.parseKid(_, R);
                  O && this.kids.push(O);
                }
              }
              parseKid(_, E) {
                if (Number.isInteger(E))
                  return this.tree.pageDict.objId !== _ ? null : new $({
                    type: C.PAGE_CONTENT,
                    mcid: E,
                    pageObjId: _
                  });
                let R = null;
                if (E instanceof b.Ref ? R = this.dict.xref.fetch(E) : E instanceof b.Dict && (R = E), !R)
                  return null;
                const O = R.getRaw("Pg");
                O instanceof b.Ref && (_ = O.toString());
                const L = R.get("Type") instanceof b.Name ? R.get("Type").name : null;
                if (L === "MCR") {
                  if (this.tree.pageDict.objId !== _)
                    return null;
                  const B = R.getRaw("Stm");
                  return new $({
                    type: C.STREAM_CONTENT,
                    refObjId: B instanceof b.Ref ? B.toString() : null,
                    pageObjId: _,
                    mcid: R.get("MCID")
                  });
                }
                if (L === "OBJR") {
                  if (this.tree.pageDict.objId !== _)
                    return null;
                  const B = R.getRaw("Obj");
                  return new $({
                    type: C.OBJECT,
                    refObjId: B instanceof b.Ref ? B.toString() : null,
                    pageObjId: _
                  });
                }
                return new $({
                  type: C.ELEMENT,
                  dict: R
                });
              }
            }
            class $ {
              constructor({
                type: _,
                dict: E = null,
                mcid: R = null,
                pageObjId: O = null,
                refObjId: L = null
              }) {
                this.type = _, this.dict = E, this.mcid = R, this.pageObjId = O, this.refObjId = L, this.parentNode = null;
              }
            }
            class T {
              constructor(_, E) {
                this.root = _, this.rootDict = _ ? _.dict : null, this.pageDict = E, this.nodes = [];
              }
              parse(_) {
                if (!this.root || !this.rootDict)
                  return;
                const E = this.rootDict.get("ParentTree");
                if (!E)
                  return;
                const R = this.pageDict.get("StructParents"), O = _ instanceof b.Ref && this.root.structParentIds?.get(_);
                if (!Number.isInteger(R) && !O)
                  return;
                const L = /* @__PURE__ */ new Map(), B = new y.NumberTree(E, this.rootDict.xref);
                if (Number.isInteger(R)) {
                  const F = B.get(R);
                  if (Array.isArray(F))
                    for (const M of F)
                      M instanceof b.Ref && this.addNode(this.rootDict.xref.fetch(M), L);
                }
                if (O)
                  for (const [F, M] of O) {
                    const W = B.get(F);
                    if (W) {
                      const j = this.addNode(this.rootDict.xref.fetchIfRef(W), L);
                      j?.kids?.length === 1 && j.kids[0].type === C.OBJECT && (j.kids[0].type = M);
                    }
                  }
              }
              addNode(_, E, R = 0) {
                if (R > m)
                  return (0, g.warn)("StructTree MAX_DEPTH reached."), null;
                if (E.has(_))
                  return E.get(_);
                const O = new S(this, _);
                E.set(_, O);
                const L = _.get("P");
                if (!L || (0, b.isName)(L.get("Type"), "StructTreeRoot"))
                  return this.addTopLevelNode(_, O) || E.delete(_), O;
                const B = this.addNode(L, E, R + 1);
                if (!B)
                  return O;
                let F = !1;
                for (const M of B.kids)
                  M.type === C.ELEMENT && M.dict === _ && (M.parentNode = O, F = !0);
                return F || E.delete(_), O;
              }
              addTopLevelNode(_, E) {
                const R = this.rootDict.get("K");
                if (!R)
                  return !1;
                if (R instanceof b.Dict)
                  return R.objId !== _.objId ? !1 : (this.nodes[0] = E, !0);
                if (!Array.isArray(R))
                  return !0;
                let O = !1;
                for (let L = 0; L < R.length; L++)
                  R[L]?.toString() === _.objId && (this.nodes[L] = E, O = !0);
                return O;
              }
              get serializable() {
                function _(R, O, L = 0) {
                  if (L > m) {
                    (0, g.warn)("StructTree too deep to be fully serialized.");
                    return;
                  }
                  const B = /* @__PURE__ */ Object.create(null);
                  B.role = R.role, B.children = [], O.children.push(B);
                  const F = R.dict.get("Alt");
                  typeof F == "string" && (B.alt = (0, g.stringToPDFString)(F));
                  const M = R.dict.get("Lang");
                  typeof M == "string" && (B.lang = (0, g.stringToPDFString)(M));
                  for (const W of R.kids) {
                    const j = W.type === C.ELEMENT ? W.parentNode : null;
                    if (j) {
                      _(j, B, L + 1);
                      continue;
                    } else W.type === C.PAGE_CONTENT || W.type === C.STREAM_CONTENT ? B.children.push({
                      type: "content",
                      id: `p${W.pageObjId}_mc${W.mcid}`
                    }) : W.type === C.OBJECT ? B.children.push({
                      type: "object",
                      id: W.refObjId
                    }) : W.type === C.ANNOTATION && B.children.push({
                      type: "annotation",
                      id: `${g.AnnotationPrefix}${W.refObjId}`
                    });
                  }
                }
                const E = /* @__PURE__ */ Object.create(null);
                E.children = [], E.role = "Root";
                for (const R of this.nodes)
                  R && _(R, E);
                return E;
              }
            }
            A.StructTreePage = T;
          },
          /* 73 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.incrementalUpdate = F, A.writeDict = S, A.writeObject = w;
            var g = x(2), b = x(4), y = x(3), f = x(71), m = x(5), C = x(74);
            async function w(M, W, j, {
              encrypt: G = null
            }) {
              const U = G?.createCipherTransform(M.num, M.gen);
              j.push(`${M.num} ${M.gen} obj
`), W instanceof b.Dict ? await S(W, j, U) : W instanceof m.BaseStream ? await $(W, j, U) : Array.isArray(W) && await T(W, j, U), j.push(`
endobj
`);
            }
            async function S(M, W, j) {
              W.push("<<");
              for (const G of M.getKeys())
                W.push(` /${(0, y.escapePDFName)(G)} `), await I(M.getRaw(G), W, j);
              W.push(">>");
            }
            async function $(M, W, j) {
              let G = M.getString();
              const {
                dict: U
              } = M, [k, N] = await Promise.all([U.getAsync("Filter"), U.getAsync("DecodeParms")]), P = Array.isArray(k) ? await U.xref.fetchIfRefAsync(k[0]) : k, D = (0, b.isName)(P, "FlateDecode");
              if (typeof CompressionStream < "u" && (G.length >= 256 || D))
                try {
                  const V = (0, g.stringToBytes)(G), Z = new CompressionStream("deflate"), ne = Z.writable.getWriter();
                  ne.write(V), ne.close();
                  const K = await new Response(Z.readable).arrayBuffer();
                  G = (0, g.bytesToString)(new Uint8Array(K));
                  let q, Y;
                  k ? D || (q = Array.isArray(k) ? [b.Name.get("FlateDecode"), ...k] : [b.Name.get("FlateDecode"), k], N && (Y = Array.isArray(N) ? [null, ...N] : [null, N])) : q = b.Name.get("FlateDecode"), q && U.set("Filter", q), Y && U.set("DecodeParms", Y);
                } catch (V) {
                  (0, g.info)(`writeStream - cannot compress data: "${V}".`);
                }
              j && (G = j.encryptString(G)), U.set("Length", G.length), await S(U, W, j), W.push(` stream
`, G, `
endstream`);
            }
            async function T(M, W, j) {
              W.push("[");
              let G = !0;
              for (const U of M)
                G ? G = !1 : W.push(" "), await I(U, W, j);
              W.push("]");
            }
            async function I(M, W, j) {
              M instanceof b.Name ? W.push(`/${(0, y.escapePDFName)(M.name)}`) : M instanceof b.Ref ? W.push(`${M.num} ${M.gen} R`) : Array.isArray(M) ? await T(M, W, j) : typeof M == "string" ? (j && (M = j.encryptString(M)), W.push(`(${(0, y.escapeString)(M)})`)) : typeof M == "number" ? W.push((0, y.numberToString)(M)) : typeof M == "boolean" ? W.push(M.toString()) : M instanceof b.Dict ? await S(M, W, j) : M instanceof m.BaseStream ? await $(M, W, j) : M === null ? W.push("null") : (0, g.warn)(`Unhandled value in writer: ${typeof M}, please file a bug.`);
            }
            function _(M, W, j, G) {
              for (let U = W + j - 1; U > j - 1; U--)
                G[U] = M & 255, M >>= 8;
              return j + W;
            }
            function E(M, W, j) {
              for (let G = 0, U = M.length; G < U; G++)
                j[W + G] = M.charCodeAt(G) & 255;
            }
            function R(M, W) {
              const j = Math.floor(Date.now() / 1e3), G = W.filename || "", U = [j.toString(), G, M.toString()];
              let k = U.reduce((D, H) => D + H.length, 0);
              for (const D of Object.values(W.info))
                U.push(D), k += D.length;
              const N = new Uint8Array(k);
              let P = 0;
              for (const D of U)
                E(D, P, N), P += D.length;
              return (0, g.bytesToString)((0, C.calculateMD5)(N));
            }
            function O(M, W) {
              const j = new f.SimpleXMLParser({
                hasAttributes: !0
              }).parseFromString(M);
              for (const {
                xfa: U
              } of W) {
                if (!U)
                  continue;
                const {
                  path: k,
                  value: N
                } = U;
                if (!k)
                  continue;
                const P = (0, y.parseXFAPath)(k);
                let D = j.documentElement.searchNode(P, 0);
                !D && P.length > 1 && (D = j.documentElement.searchNode([P.at(-1)], 0)), D ? D.childNodes = Array.isArray(N) ? N.map((H) => new f.SimpleDOMNode("value", H)) : [new f.SimpleDOMNode("#text", N)] : (0, g.warn)(`Node not found for path: ${k}`);
              }
              const G = [];
              return j.documentElement.dump(G), G.join("");
            }
            async function L({
              xref: M,
              acroForm: W,
              acroFormRef: j,
              hasXfa: G,
              hasXfaDatasetsEntry: U,
              xfaDatasetsRef: k,
              needAppearances: N,
              newRefs: P
            }) {
              if (G && !U && !k && (0, g.warn)("XFA - Cannot save it"), !N && (!G || !k || U))
                return;
              const D = W.clone();
              if (G && !U) {
                const V = W.get("XFA").slice();
                V.splice(2, 0, "datasets"), V.splice(3, 0, k), D.set("XFA", V);
              }
              N && D.set("NeedAppearances", !0);
              const H = [];
              await w(j, D, H, M), P.push({
                ref: j,
                data: H.join("")
              });
            }
            function B({
              xfaData: M,
              xfaDatasetsRef: W,
              newRefs: j,
              xref: G
            }) {
              if (M === null) {
                const N = G.fetchIfRef(W);
                M = O(N.getString(), j);
              }
              const U = G.encrypt;
              U && (M = U.createCipherTransform(W.num, W.gen).encryptString(M));
              const k = `${W.num} ${W.gen} obj
<< /Type /EmbeddedFile /Length ${M.length}>>
stream
` + M + `
endstream
endobj
`;
              j.push({
                ref: W,
                data: k
              });
            }
            async function F({
              originalData: M,
              xrefInfo: W,
              newRefs: j,
              xref: G = null,
              hasXfa: U = !1,
              xfaDatasetsRef: k = null,
              hasXfaDatasetsEntry: N = !1,
              needAppearances: P,
              acroFormRef: D = null,
              acroForm: H = null,
              xfaData: V = null
            }) {
              await L({
                xref: G,
                acroForm: H,
                acroFormRef: D,
                hasXfa: U,
                hasXfaDatasetsEntry: N,
                xfaDatasetsRef: k,
                needAppearances: P,
                newRefs: j
              }), U && B({
                xfaData: V,
                xfaDatasetsRef: k,
                newRefs: j,
                xref: G
              });
              const Z = new b.Dict(null), ne = W.newRef;
              let K, q;
              const Y = M.at(-1);
              Y === 10 || Y === 13 ? (K = [], q = M.length) : (K = [`
`], q = M.length + 1), Z.set("Size", ne.num + 1), Z.set("Prev", W.startXRef), Z.set("Type", b.Name.get("XRef")), W.rootRef !== null && Z.set("Root", W.rootRef), W.infoRef !== null && Z.set("Info", W.infoRef), W.encryptRef !== null && Z.set("Encrypt", W.encryptRef), j.push({
                ref: ne,
                data: ""
              }), j = j.sort((be, le) => be.ref.num - le.ref.num);
              const ee = [[0, 1, 65535]], Q = [0, 1];
              let J = 0;
              for (const {
                ref: be,
                data: le
              } of j)
                J = Math.max(J, q), ee.push([1, q, Math.min(be.gen, 65535)]), q += le.length, Q.push(be.num, 1), K.push(le);
              if (Z.set("Index", Q), Array.isArray(W.fileIds) && W.fileIds.length > 0) {
                const be = R(q, W);
                Z.set("ID", [W.fileIds[0], be]);
              }
              const ae = [1, Math.ceil(Math.log2(J) / 8), 2], ie = (ae[0] + ae[1] + ae[2]) * ee.length;
              Z.set("W", ae), Z.set("Length", ie), K.push(`${ne.num} ${ne.gen} obj
`), await S(Z, K, null), K.push(` stream
`);
              const fe = K.reduce((be, le) => be + le.length, 0), ge = `
endstream
endobj
startxref
${q}
%%EOF
`, me = new Uint8Array(M.length + fe + ie + ge.length);
              me.set(M);
              let pe = M.length;
              for (const be of K)
                E(be, pe, me), pe += be.length;
              for (const [be, le, ve] of ee)
                pe = _(be, ae[0], pe, me), pe = _(le, ae[1], pe, me), pe = _(ve, ae[2], pe, me);
              return E(ge, pe, me), me;
            }
          },
          /* 74 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.calculateSHA256 = A.calculateMD5 = A.PDF20 = A.PDF17 = A.CipherTransformFactory = A.ARCFourCipher = A.AES256Cipher = A.AES128Cipher = void 0, A.calculateSHA384 = $, A.calculateSHA512 = void 0;
            var g = x(2), b = x(4), y = x(75);
            class f {
              constructor(M) {
                this.a = 0, this.b = 0;
                const W = new Uint8Array(256), j = M.length;
                for (let G = 0; G < 256; ++G)
                  W[G] = G;
                for (let G = 0, U = 0; G < 256; ++G) {
                  const k = W[G];
                  U = U + k + M[G % j] & 255, W[G] = W[U], W[U] = k;
                }
                this.s = W;
              }
              encryptBlock(M) {
                let W = this.a, j = this.b;
                const G = this.s, U = M.length, k = new Uint8Array(U);
                for (let N = 0; N < U; ++N) {
                  W = W + 1 & 255;
                  const P = G[W];
                  j = j + P & 255;
                  const D = G[j];
                  G[W] = D, G[j] = P, k[N] = M[N] ^ G[P + D & 255];
                }
                return this.a = W, this.b = j, k;
              }
              decryptBlock(M) {
                return this.encryptBlock(M);
              }
              encrypt(M) {
                return this.encryptBlock(M);
              }
            }
            A.ARCFourCipher = f;
            const m = function() {
              const M = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]), W = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
              function j(G, U, k) {
                let N = 1732584193, P = -271733879, D = -1732584194, H = 271733878;
                const V = k + 72 & -64, Z = new Uint8Array(V);
                let ne, K;
                for (ne = 0; ne < k; ++ne)
                  Z[ne] = G[U++];
                Z[ne++] = 128;
                const q = V - 8;
                for (; ne < q; )
                  Z[ne++] = 0;
                Z[ne++] = k << 3 & 255, Z[ne++] = k >> 5 & 255, Z[ne++] = k >> 13 & 255, Z[ne++] = k >> 21 & 255, Z[ne++] = k >>> 29 & 255, Z[ne++] = 0, Z[ne++] = 0, Z[ne++] = 0;
                const Y = new Int32Array(16);
                for (ne = 0; ne < V; ) {
                  for (K = 0; K < 16; ++K, ne += 4)
                    Y[K] = Z[ne] | Z[ne + 1] << 8 | Z[ne + 2] << 16 | Z[ne + 3] << 24;
                  let ee = N, Q = P, J = D, te = H, ae, se;
                  for (K = 0; K < 64; ++K) {
                    K < 16 ? (ae = Q & J | ~Q & te, se = K) : K < 32 ? (ae = te & Q | ~te & J, se = 5 * K + 1 & 15) : K < 48 ? (ae = Q ^ J ^ te, se = 3 * K + 5 & 15) : (ae = J ^ (Q | ~te), se = 7 * K & 15);
                    const ie = te, fe = ee + ae + W[K] + Y[se] | 0, ge = M[K];
                    te = J, J = Q, Q = Q + (fe << ge | fe >>> 32 - ge) | 0, ee = ie;
                  }
                  N = N + ee | 0, P = P + Q | 0, D = D + J | 0, H = H + te | 0;
                }
                return new Uint8Array([N & 255, N >> 8 & 255, N >> 16 & 255, N >>> 24 & 255, P & 255, P >> 8 & 255, P >> 16 & 255, P >>> 24 & 255, D & 255, D >> 8 & 255, D >> 16 & 255, D >>> 24 & 255, H & 255, H >> 8 & 255, H >> 16 & 255, H >>> 24 & 255]);
              }
              return j;
            }();
            A.calculateMD5 = m;
            class C {
              constructor(M, W) {
                this.high = M | 0, this.low = W | 0;
              }
              and(M) {
                this.high &= M.high, this.low &= M.low;
              }
              xor(M) {
                this.high ^= M.high, this.low ^= M.low;
              }
              or(M) {
                this.high |= M.high, this.low |= M.low;
              }
              shiftRight(M) {
                M >= 32 ? (this.low = this.high >>> M - 32 | 0, this.high = 0) : (this.low = this.low >>> M | this.high << 32 - M, this.high = this.high >>> M | 0);
              }
              shiftLeft(M) {
                M >= 32 ? (this.high = this.low << M - 32, this.low = 0) : (this.high = this.high << M | this.low >>> 32 - M, this.low <<= M);
              }
              rotateRight(M) {
                let W, j;
                M & 32 ? (j = this.low, W = this.high) : (W = this.low, j = this.high), M &= 31, this.low = W >>> M | j << 32 - M, this.high = j >>> M | W << 32 - M;
              }
              not() {
                this.high = ~this.high, this.low = ~this.low;
              }
              add(M) {
                const W = (this.low >>> 0) + (M.low >>> 0);
                let j = (this.high >>> 0) + (M.high >>> 0);
                W > 4294967295 && (j += 1), this.low = W | 0, this.high = j | 0;
              }
              copyTo(M, W) {
                M[W] = this.high >>> 24 & 255, M[W + 1] = this.high >> 16 & 255, M[W + 2] = this.high >> 8 & 255, M[W + 3] = this.high & 255, M[W + 4] = this.low >>> 24 & 255, M[W + 5] = this.low >> 16 & 255, M[W + 6] = this.low >> 8 & 255, M[W + 7] = this.low & 255;
              }
              assign(M) {
                this.high = M.high, this.low = M.low;
              }
            }
            const w = /* @__PURE__ */ function() {
              function M(H, V) {
                return H >>> V | H << 32 - V;
              }
              function W(H, V, Z) {
                return H & V ^ ~H & Z;
              }
              function j(H, V, Z) {
                return H & V ^ H & Z ^ V & Z;
              }
              function G(H) {
                return M(H, 2) ^ M(H, 13) ^ M(H, 22);
              }
              function U(H) {
                return M(H, 6) ^ M(H, 11) ^ M(H, 25);
              }
              function k(H) {
                return M(H, 7) ^ M(H, 18) ^ H >>> 3;
              }
              function N(H) {
                return M(H, 17) ^ M(H, 19) ^ H >>> 10;
              }
              const P = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
              function D(H, V, Z) {
                let ne = 1779033703, K = 3144134277, q = 1013904242, Y = 2773480762, ee = 1359893119, Q = 2600822924, J = 528734635, te = 1541459225;
                const ae = Math.ceil((Z + 9) / 64) * 64, se = new Uint8Array(ae);
                let ie, fe;
                for (ie = 0; ie < Z; ++ie)
                  se[ie] = H[V++];
                se[ie++] = 128;
                const ge = ae - 8;
                for (; ie < ge; )
                  se[ie++] = 0;
                se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = Z >>> 29 & 255, se[ie++] = Z >> 21 & 255, se[ie++] = Z >> 13 & 255, se[ie++] = Z >> 5 & 255, se[ie++] = Z << 3 & 255;
                const me = new Uint32Array(64);
                for (ie = 0; ie < ae; ) {
                  for (fe = 0; fe < 16; ++fe)
                    me[fe] = se[ie] << 24 | se[ie + 1] << 16 | se[ie + 2] << 8 | se[ie + 3], ie += 4;
                  for (fe = 16; fe < 64; ++fe)
                    me[fe] = N(me[fe - 2]) + me[fe - 7] + k(me[fe - 15]) + me[fe - 16] | 0;
                  let pe = ne, be = K, le = q, ve = Y, he = ee, ye = Q, Ce = J, xe = te, we, $e;
                  for (fe = 0; fe < 64; ++fe)
                    we = xe + U(he) + W(he, ye, Ce) + P[fe] + me[fe], $e = G(pe) + j(pe, be, le), xe = Ce, Ce = ye, ye = he, he = ve + we | 0, ve = le, le = be, be = pe, pe = we + $e | 0;
                  ne = ne + pe | 0, K = K + be | 0, q = q + le | 0, Y = Y + ve | 0, ee = ee + he | 0, Q = Q + ye | 0, J = J + Ce | 0, te = te + xe | 0;
                }
                return new Uint8Array([ne >> 24 & 255, ne >> 16 & 255, ne >> 8 & 255, ne & 255, K >> 24 & 255, K >> 16 & 255, K >> 8 & 255, K & 255, q >> 24 & 255, q >> 16 & 255, q >> 8 & 255, q & 255, Y >> 24 & 255, Y >> 16 & 255, Y >> 8 & 255, Y & 255, ee >> 24 & 255, ee >> 16 & 255, ee >> 8 & 255, ee & 255, Q >> 24 & 255, Q >> 16 & 255, Q >> 8 & 255, Q & 255, J >> 24 & 255, J >> 16 & 255, J >> 8 & 255, J & 255, te >> 24 & 255, te >> 16 & 255, te >> 8 & 255, te & 255]);
              }
              return D;
            }();
            A.calculateSHA256 = w;
            const S = function() {
              function M(D, H, V, Z, ne) {
                D.assign(H), D.and(V), ne.assign(H), ne.not(), ne.and(Z), D.xor(ne);
              }
              function W(D, H, V, Z, ne) {
                D.assign(H), D.and(V), ne.assign(H), ne.and(Z), D.xor(ne), ne.assign(V), ne.and(Z), D.xor(ne);
              }
              function j(D, H, V) {
                D.assign(H), D.rotateRight(28), V.assign(H), V.rotateRight(34), D.xor(V), V.assign(H), V.rotateRight(39), D.xor(V);
              }
              function G(D, H, V) {
                D.assign(H), D.rotateRight(14), V.assign(H), V.rotateRight(18), D.xor(V), V.assign(H), V.rotateRight(41), D.xor(V);
              }
              function U(D, H, V) {
                D.assign(H), D.rotateRight(1), V.assign(H), V.rotateRight(8), D.xor(V), V.assign(H), V.shiftRight(7), D.xor(V);
              }
              function k(D, H, V) {
                D.assign(H), D.rotateRight(19), V.assign(H), V.rotateRight(61), D.xor(V), V.assign(H), V.shiftRight(6), D.xor(V);
              }
              const N = [new C(1116352408, 3609767458), new C(1899447441, 602891725), new C(3049323471, 3964484399), new C(3921009573, 2173295548), new C(961987163, 4081628472), new C(1508970993, 3053834265), new C(2453635748, 2937671579), new C(2870763221, 3664609560), new C(3624381080, 2734883394), new C(310598401, 1164996542), new C(607225278, 1323610764), new C(1426881987, 3590304994), new C(1925078388, 4068182383), new C(2162078206, 991336113), new C(2614888103, 633803317), new C(3248222580, 3479774868), new C(3835390401, 2666613458), new C(4022224774, 944711139), new C(264347078, 2341262773), new C(604807628, 2007800933), new C(770255983, 1495990901), new C(1249150122, 1856431235), new C(1555081692, 3175218132), new C(1996064986, 2198950837), new C(2554220882, 3999719339), new C(2821834349, 766784016), new C(2952996808, 2566594879), new C(3210313671, 3203337956), new C(3336571891, 1034457026), new C(3584528711, 2466948901), new C(113926993, 3758326383), new C(338241895, 168717936), new C(666307205, 1188179964), new C(773529912, 1546045734), new C(1294757372, 1522805485), new C(1396182291, 2643833823), new C(1695183700, 2343527390), new C(1986661051, 1014477480), new C(2177026350, 1206759142), new C(2456956037, 344077627), new C(2730485921, 1290863460), new C(2820302411, 3158454273), new C(3259730800, 3505952657), new C(3345764771, 106217008), new C(3516065817, 3606008344), new C(3600352804, 1432725776), new C(4094571909, 1467031594), new C(275423344, 851169720), new C(430227734, 3100823752), new C(506948616, 1363258195), new C(659060556, 3750685593), new C(883997877, 3785050280), new C(958139571, 3318307427), new C(1322822218, 3812723403), new C(1537002063, 2003034995), new C(1747873779, 3602036899), new C(1955562222, 1575990012), new C(2024104815, 1125592928), new C(2227730452, 2716904306), new C(2361852424, 442776044), new C(2428436474, 593698344), new C(2756734187, 3733110249), new C(3204031479, 2999351573), new C(3329325298, 3815920427), new C(3391569614, 3928383900), new C(3515267271, 566280711), new C(3940187606, 3454069534), new C(4118630271, 4000239992), new C(116418474, 1914138554), new C(174292421, 2731055270), new C(289380356, 3203993006), new C(460393269, 320620315), new C(685471733, 587496836), new C(852142971, 1086792851), new C(1017036298, 365543100), new C(1126000580, 2618297676), new C(1288033470, 3409855158), new C(1501505948, 4234509866), new C(1607167915, 987167468), new C(1816402316, 1246189591)];
              function P(D, H, V, Z = !1) {
                let ne, K, q, Y, ee, Q, J, te;
                Z ? (ne = new C(3418070365, 3238371032), K = new C(1654270250, 914150663), q = new C(2438529370, 812702999), Y = new C(355462360, 4144912697), ee = new C(1731405415, 4290775857), Q = new C(2394180231, 1750603025), J = new C(3675008525, 1694076839), te = new C(1203062813, 3204075428)) : (ne = new C(1779033703, 4089235720), K = new C(3144134277, 2227873595), q = new C(1013904242, 4271175723), Y = new C(2773480762, 1595750129), ee = new C(1359893119, 2917565137), Q = new C(2600822924, 725511199), J = new C(528734635, 4215389547), te = new C(1541459225, 327033209));
                const ae = Math.ceil((V + 17) / 128) * 128, se = new Uint8Array(ae);
                let ie, fe;
                for (ie = 0; ie < V; ++ie)
                  se[ie] = D[H++];
                se[ie++] = 128;
                const ge = ae - 16;
                for (; ie < ge; )
                  se[ie++] = 0;
                se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = 0, se[ie++] = V >>> 29 & 255, se[ie++] = V >> 21 & 255, se[ie++] = V >> 13 & 255, se[ie++] = V >> 5 & 255, se[ie++] = V << 3 & 255;
                const me = new Array(80);
                for (ie = 0; ie < 80; ie++)
                  me[ie] = new C(0, 0);
                let pe = new C(0, 0), be = new C(0, 0), le = new C(0, 0), ve = new C(0, 0), he = new C(0, 0), ye = new C(0, 0), Ce = new C(0, 0), xe = new C(0, 0);
                const we = new C(0, 0), $e = new C(0, 0), Ae = new C(0, 0), ue = new C(0, 0);
                let ce;
                for (ie = 0; ie < ae; ) {
                  for (fe = 0; fe < 16; ++fe)
                    me[fe].high = se[ie] << 24 | se[ie + 1] << 16 | se[ie + 2] << 8 | se[ie + 3], me[fe].low = se[ie + 4] << 24 | se[ie + 5] << 16 | se[ie + 6] << 8 | se[ie + 7], ie += 8;
                  for (fe = 16; fe < 80; ++fe)
                    ce = me[fe], k(ce, me[fe - 2], ue), ce.add(me[fe - 7]), U(Ae, me[fe - 15], ue), ce.add(Ae), ce.add(me[fe - 16]);
                  for (pe.assign(ne), be.assign(K), le.assign(q), ve.assign(Y), he.assign(ee), ye.assign(Q), Ce.assign(J), xe.assign(te), fe = 0; fe < 80; ++fe)
                    we.assign(xe), G(Ae, he, ue), we.add(Ae), M(Ae, he, ye, Ce, ue), we.add(Ae), we.add(N[fe]), we.add(me[fe]), j($e, pe, ue), W(Ae, pe, be, le, ue), $e.add(Ae), ce = xe, xe = Ce, Ce = ye, ye = he, ve.add(we), he = ve, ve = le, le = be, be = pe, ce.assign(we), ce.add($e), pe = ce;
                  ne.add(pe), K.add(be), q.add(le), Y.add(ve), ee.add(he), Q.add(ye), J.add(Ce), te.add(xe);
                }
                let Ee;
                return Z ? (Ee = new Uint8Array(48), ne.copyTo(Ee, 0), K.copyTo(Ee, 8), q.copyTo(Ee, 16), Y.copyTo(Ee, 24), ee.copyTo(Ee, 32), Q.copyTo(Ee, 40)) : (Ee = new Uint8Array(64), ne.copyTo(Ee, 0), K.copyTo(Ee, 8), q.copyTo(Ee, 16), Y.copyTo(Ee, 24), ee.copyTo(Ee, 32), Q.copyTo(Ee, 40), J.copyTo(Ee, 48), te.copyTo(Ee, 56)), Ee;
              }
              return P;
            }();
            A.calculateSHA512 = S;
            function $(F, M, W) {
              return S(F, M, W, !0);
            }
            class T {
              decryptBlock(M) {
                return M;
              }
              encrypt(M) {
                return M;
              }
            }
            class I {
              constructor() {
                this.constructor === I && (0, g.unreachable)("Cannot initialize AESBaseCipher."), this._s = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]), this._inv_s = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]), this._mix = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]), this._mixCol = new Uint8Array(256);
                for (let M = 0; M < 256; M++)
                  this._mixCol[M] = M < 128 ? M << 1 : M << 1 ^ 27;
                this.buffer = new Uint8Array(16), this.bufferPosition = 0;
              }
              _expandKey(M) {
                (0, g.unreachable)("Cannot call `_expandKey` on the base class");
              }
              _decrypt(M, W) {
                let j, G, U;
                const k = new Uint8Array(16);
                k.set(M);
                for (let N = 0, P = this._keySize; N < 16; ++N, ++P)
                  k[N] ^= W[P];
                for (let N = this._cyclesOfRepetition - 1; N >= 1; --N) {
                  j = k[13], k[13] = k[9], k[9] = k[5], k[5] = k[1], k[1] = j, j = k[14], G = k[10], k[14] = k[6], k[10] = k[2], k[6] = j, k[2] = G, j = k[15], G = k[11], U = k[7], k[15] = k[3], k[11] = j, k[7] = G, k[3] = U;
                  for (let P = 0; P < 16; ++P)
                    k[P] = this._inv_s[k[P]];
                  for (let P = 0, D = N * 16; P < 16; ++P, ++D)
                    k[P] ^= W[D];
                  for (let P = 0; P < 16; P += 4) {
                    const D = this._mix[k[P]], H = this._mix[k[P + 1]], V = this._mix[k[P + 2]], Z = this._mix[k[P + 3]];
                    j = D ^ H >>> 8 ^ H << 24 ^ V >>> 16 ^ V << 16 ^ Z >>> 24 ^ Z << 8, k[P] = j >>> 24 & 255, k[P + 1] = j >> 16 & 255, k[P + 2] = j >> 8 & 255, k[P + 3] = j & 255;
                  }
                }
                j = k[13], k[13] = k[9], k[9] = k[5], k[5] = k[1], k[1] = j, j = k[14], G = k[10], k[14] = k[6], k[10] = k[2], k[6] = j, k[2] = G, j = k[15], G = k[11], U = k[7], k[15] = k[3], k[11] = j, k[7] = G, k[3] = U;
                for (let N = 0; N < 16; ++N)
                  k[N] = this._inv_s[k[N]], k[N] ^= W[N];
                return k;
              }
              _encrypt(M, W) {
                const j = this._s;
                let G, U, k;
                const N = new Uint8Array(16);
                N.set(M);
                for (let P = 0; P < 16; ++P)
                  N[P] ^= W[P];
                for (let P = 1; P < this._cyclesOfRepetition; P++) {
                  for (let D = 0; D < 16; ++D)
                    N[D] = j[N[D]];
                  k = N[1], N[1] = N[5], N[5] = N[9], N[9] = N[13], N[13] = k, k = N[2], U = N[6], N[2] = N[10], N[6] = N[14], N[10] = k, N[14] = U, k = N[3], U = N[7], G = N[11], N[3] = N[15], N[7] = k, N[11] = U, N[15] = G;
                  for (let D = 0; D < 16; D += 4) {
                    const H = N[D + 0], V = N[D + 1], Z = N[D + 2], ne = N[D + 3];
                    G = H ^ V ^ Z ^ ne, N[D + 0] ^= G ^ this._mixCol[H ^ V], N[D + 1] ^= G ^ this._mixCol[V ^ Z], N[D + 2] ^= G ^ this._mixCol[Z ^ ne], N[D + 3] ^= G ^ this._mixCol[ne ^ H];
                  }
                  for (let D = 0, H = P * 16; D < 16; ++D, ++H)
                    N[D] ^= W[H];
                }
                for (let P = 0; P < 16; ++P)
                  N[P] = j[N[P]];
                k = N[1], N[1] = N[5], N[5] = N[9], N[9] = N[13], N[13] = k, k = N[2], U = N[6], N[2] = N[10], N[6] = N[14], N[10] = k, N[14] = U, k = N[3], U = N[7], G = N[11], N[3] = N[15], N[7] = k, N[11] = U, N[15] = G;
                for (let P = 0, D = this._keySize; P < 16; ++P, ++D)
                  N[P] ^= W[D];
                return N;
              }
              _decryptBlock2(M, W) {
                const j = M.length;
                let G = this.buffer, U = this.bufferPosition;
                const k = [];
                let N = this.iv;
                for (let H = 0; H < j; ++H) {
                  if (G[U] = M[H], ++U, U < 16)
                    continue;
                  const V = this._decrypt(G, this._key);
                  for (let Z = 0; Z < 16; ++Z)
                    V[Z] ^= N[Z];
                  N = G, k.push(V), G = new Uint8Array(16), U = 0;
                }
                if (this.buffer = G, this.bufferLength = U, this.iv = N, k.length === 0)
                  return new Uint8Array(0);
                let P = 16 * k.length;
                if (W) {
                  const H = k.at(-1);
                  let V = H[15];
                  if (V <= 16) {
                    for (let Z = 15, ne = 16 - V; Z >= ne; --Z)
                      if (H[Z] !== V) {
                        V = 0;
                        break;
                      }
                    P -= V, k[k.length - 1] = H.subarray(0, 16 - V);
                  }
                }
                const D = new Uint8Array(P);
                for (let H = 0, V = 0, Z = k.length; H < Z; ++H, V += 16)
                  D.set(k[H], V);
                return D;
              }
              decryptBlock(M, W, j = null) {
                const G = M.length, U = this.buffer;
                let k = this.bufferPosition;
                if (j)
                  this.iv = j;
                else {
                  for (let N = 0; k < 16 && N < G; ++N, ++k)
                    U[k] = M[N];
                  if (k < 16)
                    return this.bufferLength = k, new Uint8Array(0);
                  this.iv = U, M = M.subarray(16);
                }
                return this.buffer = new Uint8Array(16), this.bufferLength = 0, this.decryptBlock = this._decryptBlock2, this.decryptBlock(M, W);
              }
              encrypt(M, W) {
                const j = M.length;
                let G = this.buffer, U = this.bufferPosition;
                const k = [];
                W || (W = new Uint8Array(16));
                for (let D = 0; D < j; ++D) {
                  if (G[U] = M[D], ++U, U < 16)
                    continue;
                  for (let V = 0; V < 16; ++V)
                    G[V] ^= W[V];
                  const H = this._encrypt(G, this._key);
                  W = H, k.push(H), G = new Uint8Array(16), U = 0;
                }
                if (this.buffer = G, this.bufferLength = U, this.iv = W, k.length === 0)
                  return new Uint8Array(0);
                const N = 16 * k.length, P = new Uint8Array(N);
                for (let D = 0, H = 0, V = k.length; D < V; ++D, H += 16)
                  P.set(k[D], H);
                return P;
              }
            }
            class _ extends I {
              constructor(M) {
                super(), this._cyclesOfRepetition = 10, this._keySize = 160, this._rcon = new Uint8Array([141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141]), this._key = this._expandKey(M);
              }
              _expandKey(M) {
                const j = this._s, G = this._rcon, U = new Uint8Array(176);
                U.set(M);
                for (let k = 16, N = 1; k < 176; ++N) {
                  let P = U[k - 3], D = U[k - 2], H = U[k - 1], V = U[k - 4];
                  P = j[P], D = j[D], H = j[H], V = j[V], P ^= G[N];
                  for (let Z = 0; Z < 4; ++Z)
                    U[k] = P ^= U[k - 16], k++, U[k] = D ^= U[k - 16], k++, U[k] = H ^= U[k - 16], k++, U[k] = V ^= U[k - 16], k++;
                }
                return U;
              }
            }
            A.AES128Cipher = _;
            class E extends I {
              constructor(M) {
                super(), this._cyclesOfRepetition = 14, this._keySize = 224, this._key = this._expandKey(M);
              }
              _expandKey(M) {
                const j = this._s, G = new Uint8Array(240);
                G.set(M);
                let U = 1, k, N, P, D;
                for (let H = 32, V = 1; H < 240; ++V) {
                  H % 32 === 16 ? (k = j[k], N = j[N], P = j[P], D = j[D]) : H % 32 === 0 && (k = G[H - 3], N = G[H - 2], P = G[H - 1], D = G[H - 4], k = j[k], N = j[N], P = j[P], D = j[D], k ^= U, (U <<= 1) >= 256 && (U = (U ^ 27) & 255));
                  for (let Z = 0; Z < 4; ++Z)
                    G[H] = k ^= G[H - 32], H++, G[H] = N ^= G[H - 32], H++, G[H] = P ^= G[H - 32], H++, G[H] = D ^= G[H - 32], H++;
                }
                return G;
              }
            }
            A.AES256Cipher = E;
            class R {
              checkOwnerPassword(M, W, j, G) {
                const U = new Uint8Array(M.length + 56);
                U.set(M, 0), U.set(W, M.length), U.set(j, M.length + W.length);
                const k = w(U, 0, U.length);
                return (0, g.isArrayEqual)(k, G);
              }
              checkUserPassword(M, W, j) {
                const G = new Uint8Array(M.length + 8);
                G.set(M, 0), G.set(W, M.length);
                const U = w(G, 0, G.length);
                return (0, g.isArrayEqual)(U, j);
              }
              getOwnerKey(M, W, j, G) {
                const U = new Uint8Array(M.length + 56);
                U.set(M, 0), U.set(W, M.length), U.set(j, M.length + W.length);
                const k = w(U, 0, U.length);
                return new E(k).decryptBlock(G, !1, new Uint8Array(16));
              }
              getUserKey(M, W, j) {
                const G = new Uint8Array(M.length + 8);
                G.set(M, 0), G.set(W, M.length);
                const U = w(G, 0, G.length);
                return new E(U).decryptBlock(j, !1, new Uint8Array(16));
              }
            }
            A.PDF17 = R;
            class O {
              _hash(M, W, j) {
                let G = w(W, 0, W.length).subarray(0, 32), U = [0], k = 0;
                for (; k < 64 || U.at(-1) > k - 32; ) {
                  const N = M.length + G.length + j.length, P = new Uint8Array(N);
                  let D = 0;
                  P.set(M, D), D += M.length, P.set(G, D), D += G.length, P.set(j, D);
                  const H = new Uint8Array(N * 64);
                  for (let ne = 0, K = 0; ne < 64; ne++, K += N)
                    H.set(P, K);
                  U = new _(G.subarray(0, 16)).encrypt(H, G.subarray(16, 32));
                  const Z = U.slice(0, 16).reduce((ne, K) => ne + K, 0) % 3;
                  Z === 0 ? G = w(U, 0, U.length) : Z === 1 ? G = $(U, 0, U.length) : Z === 2 && (G = S(U, 0, U.length)), k++;
                }
                return G.subarray(0, 32);
              }
              checkOwnerPassword(M, W, j, G) {
                const U = new Uint8Array(M.length + 56);
                U.set(M, 0), U.set(W, M.length), U.set(j, M.length + W.length);
                const k = this._hash(M, U, j);
                return (0, g.isArrayEqual)(k, G);
              }
              checkUserPassword(M, W, j) {
                const G = new Uint8Array(M.length + 8);
                G.set(M, 0), G.set(W, M.length);
                const U = this._hash(M, G, []);
                return (0, g.isArrayEqual)(U, j);
              }
              getOwnerKey(M, W, j, G) {
                const U = new Uint8Array(M.length + 56);
                U.set(M, 0), U.set(W, M.length), U.set(j, M.length + W.length);
                const k = this._hash(M, U, j);
                return new E(k).decryptBlock(G, !1, new Uint8Array(16));
              }
              getUserKey(M, W, j) {
                const G = new Uint8Array(M.length + 8);
                G.set(M, 0), G.set(W, M.length);
                const U = this._hash(M, G, []);
                return new E(U).decryptBlock(j, !1, new Uint8Array(16));
              }
            }
            A.PDF20 = O;
            class L {
              constructor(M, W) {
                this.StringCipherConstructor = M, this.StreamCipherConstructor = W;
              }
              createStream(M, W) {
                const j = new this.StreamCipherConstructor();
                return new y.DecryptStream(M, W, function(U, k) {
                  return j.decryptBlock(U, k);
                });
              }
              decryptString(M) {
                const W = new this.StringCipherConstructor();
                let j = (0, g.stringToBytes)(M);
                return j = W.decryptBlock(j, !0), (0, g.bytesToString)(j);
              }
              encryptString(M) {
                const W = new this.StringCipherConstructor();
                if (W instanceof I) {
                  const U = 16 - M.length % 16;
                  M += String.fromCharCode(U).repeat(U);
                  const k = new Uint8Array(16);
                  if (typeof crypto < "u")
                    crypto.getRandomValues(k);
                  else
                    for (let D = 0; D < 16; D++)
                      k[D] = Math.floor(256 * Math.random());
                  let N = (0, g.stringToBytes)(M);
                  N = W.encrypt(N, k);
                  const P = new Uint8Array(16 + N.length);
                  return P.set(k), P.set(N, 16), (0, g.bytesToString)(P);
                }
                let j = (0, g.stringToBytes)(M);
                return j = W.encrypt(j), (0, g.bytesToString)(j);
              }
            }
            class B {
              static #e = new Uint8Array([40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122]);
              #t(M, W, j, G, U, k, N, P, D, H, V, Z) {
                if (W) {
                  const K = Math.min(127, W.length);
                  W = W.subarray(0, K);
                } else
                  W = [];
                const ne = M === 6 ? new O() : new R();
                return ne.checkUserPassword(W, P, N) ? ne.getUserKey(W, D, V) : W.length && ne.checkOwnerPassword(W, G, k, j) ? ne.getOwnerKey(W, U, k, H) : null;
              }
              #r(M, W, j, G, U, k, N, P) {
                const D = 40 + j.length + M.length, H = new Uint8Array(D);
                let V = 0, Z, ne;
                if (W)
                  for (ne = Math.min(32, W.length); V < ne; ++V)
                    H[V] = W[V];
                for (Z = 0; V < 32; )
                  H[V++] = B.#e[Z++];
                for (Z = 0, ne = j.length; Z < ne; ++Z)
                  H[V++] = j[Z];
                for (H[V++] = U & 255, H[V++] = U >> 8 & 255, H[V++] = U >> 16 & 255, H[V++] = U >>> 24 & 255, Z = 0, ne = M.length; Z < ne; ++Z)
                  H[V++] = M[Z];
                k >= 4 && !P && (H[V++] = 255, H[V++] = 255, H[V++] = 255, H[V++] = 255);
                let K = m(H, 0, V);
                const q = N >> 3;
                if (k >= 3)
                  for (Z = 0; Z < 50; ++Z)
                    K = m(K, 0, q);
                const Y = K.subarray(0, q);
                let ee, Q;
                if (k >= 3) {
                  for (V = 0; V < 32; ++V)
                    H[V] = B.#e[V];
                  for (Z = 0, ne = M.length; Z < ne; ++Z)
                    H[V++] = M[Z];
                  ee = new f(Y), Q = ee.encryptBlock(m(H, 0, V)), ne = Y.length;
                  const J = new Uint8Array(ne);
                  for (Z = 1; Z <= 19; ++Z) {
                    for (let te = 0; te < ne; ++te)
                      J[te] = Y[te] ^ Z;
                    ee = new f(J), Q = ee.encryptBlock(Q);
                  }
                  for (Z = 0, ne = Q.length; Z < ne; ++Z)
                    if (G[Z] !== Q[Z])
                      return null;
                } else
                  for (ee = new f(Y), Q = ee.encryptBlock(B.#e), Z = 0, ne = Q.length; Z < ne; ++Z)
                    if (G[Z] !== Q[Z])
                      return null;
                return Y;
              }
              #n(M, W, j, G) {
                const U = new Uint8Array(32);
                let k = 0;
                const N = Math.min(32, M.length);
                for (; k < N; ++k)
                  U[k] = M[k];
                let P = 0;
                for (; k < 32; )
                  U[k++] = B.#e[P++];
                let D = m(U, 0, k);
                const H = G >> 3;
                if (j >= 3)
                  for (P = 0; P < 50; ++P)
                    D = m(D, 0, D.length);
                let V, Z;
                if (j >= 3) {
                  Z = W;
                  const ne = new Uint8Array(H);
                  for (P = 19; P >= 0; P--) {
                    for (let K = 0; K < H; ++K)
                      ne[K] = D[K] ^ P;
                    V = new f(ne), Z = V.encryptBlock(Z);
                  }
                } else
                  V = new f(D.subarray(0, H)), Z = V.encryptBlock(W);
                return Z;
              }
              #s(M, W, j, G = !1) {
                const U = new Uint8Array(j.length + 9), k = j.length;
                let N;
                for (N = 0; N < k; ++N)
                  U[N] = j[N];
                return U[N++] = M & 255, U[N++] = M >> 8 & 255, U[N++] = M >> 16 & 255, U[N++] = W & 255, U[N++] = W >> 8 & 255, G && (U[N++] = 115, U[N++] = 65, U[N++] = 108, U[N++] = 84), m(U, 0, N).subarray(0, Math.min(j.length + 5, 16));
              }
              #o(M, W, j, G, U) {
                if (!(W instanceof b.Name))
                  throw new g.FormatError("Invalid crypt filter name.");
                const k = this, P = M.get(W.name)?.get("CFM");
                if (!P || P.name === "None")
                  return function() {
                    return new T();
                  };
                if (P.name === "V2")
                  return function() {
                    return new f(k.#s(j, G, U, !1));
                  };
                if (P.name === "AESV2")
                  return function() {
                    return new _(k.#s(j, G, U, !0));
                  };
                if (P.name === "AESV3")
                  return function() {
                    return new E(U);
                  };
                throw new g.FormatError("Unknown crypto method");
              }
              constructor(M, W, j) {
                const G = M.get("Filter");
                if (!(0, b.isName)(G, "Standard"))
                  throw new g.FormatError("unknown encryption method");
                this.filterName = G.name, this.dict = M;
                const U = M.get("V");
                if (!Number.isInteger(U) || U !== 1 && U !== 2 && U !== 4 && U !== 5)
                  throw new g.FormatError("unsupported encryption algorithm");
                this.algorithm = U;
                let k = M.get("Length");
                if (!k)
                  if (U <= 3)
                    k = 40;
                  else {
                    const ee = M.get("CF"), Q = M.get("StmF");
                    ee instanceof b.Dict && Q instanceof b.Name && (ee.suppressEncryption = !0, k = ee.get(Q.name)?.get("Length") || 128, k < 40 && (k <<= 3));
                  }
                if (!Number.isInteger(k) || k < 40 || k % 8 !== 0)
                  throw new g.FormatError("invalid key length");
                const N = (0, g.stringToBytes)(M.get("O")), P = (0, g.stringToBytes)(M.get("U")), D = N.subarray(0, 32), H = P.subarray(0, 32), V = M.get("P"), Z = M.get("R"), ne = (U === 4 || U === 5) && M.get("EncryptMetadata") !== !1;
                this.encryptMetadata = ne;
                const K = (0, g.stringToBytes)(W);
                let q;
                if (j) {
                  if (Z === 6)
                    try {
                      j = (0, g.utf8StringToString)(j);
                    } catch {
                      (0, g.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                    }
                  q = (0, g.stringToBytes)(j);
                }
                let Y;
                if (U !== 5)
                  Y = this.#r(K, q, D, H, V, Z, k, ne);
                else {
                  const ee = N.subarray(32, 40), Q = N.subarray(40, 48), J = P.subarray(0, 48), te = P.subarray(32, 40), ae = P.subarray(40, 48), se = (0, g.stringToBytes)(M.get("OE")), ie = (0, g.stringToBytes)(M.get("UE")), fe = (0, g.stringToBytes)(M.get("Perms"));
                  Y = this.#t(Z, q, D, ee, Q, J, H, te, ae, se, ie, fe);
                }
                if (!Y && !j)
                  throw new g.PasswordException("No password given", g.PasswordResponses.NEED_PASSWORD);
                if (!Y && j) {
                  const ee = this.#n(q, D, Z, k);
                  Y = this.#r(K, ee, D, H, V, Z, k, ne);
                }
                if (!Y)
                  throw new g.PasswordException("Incorrect Password", g.PasswordResponses.INCORRECT_PASSWORD);
                if (this.encryptionKey = Y, U >= 4) {
                  const ee = M.get("CF");
                  ee instanceof b.Dict && (ee.suppressEncryption = !0), this.cf = ee, this.stmf = M.get("StmF") || b.Name.get("Identity"), this.strf = M.get("StrF") || b.Name.get("Identity"), this.eff = M.get("EFF") || this.stmf;
                }
              }
              createCipherTransform(M, W) {
                if (this.algorithm === 4 || this.algorithm === 5)
                  return new L(this.#o(this.cf, this.strf, M, W, this.encryptionKey), this.#o(this.cf, this.stmf, M, W, this.encryptionKey));
                const j = this.#s(M, W, this.encryptionKey, !1), G = function() {
                  return new f(j);
                };
                return new L(G, G);
              }
            }
            A.CipherTransformFactory = B;
          },
          /* 75 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.DecryptStream = void 0;
            var g = x(18);
            const b = 512;
            class y extends g.DecodeStream {
              constructor(m, C, w) {
                super(C), this.str = m, this.dict = m.dict, this.decrypt = w, this.nextChunk = null, this.initialized = !1;
              }
              readBlock() {
                let m;
                if (this.initialized ? m = this.nextChunk : (m = this.str.getBytes(b), this.initialized = !0), !m || m.length === 0) {
                  this.eof = !0;
                  return;
                }
                this.nextChunk = this.str.getBytes(b);
                const C = this.nextChunk?.length > 0, w = this.decrypt;
                m = w(m, !C);
                const S = this.bufferLength, $ = S + m.length;
                this.ensureBuffer($).set(m, S), this.bufferLength = $;
              }
            }
            A.DecryptStream = y;
          },
          /* 76 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ObjectLoader = void 0;
            var g = x(4), b = x(5), y = x(3), f = x(2);
            function m(S) {
              return S instanceof g.Ref || S instanceof g.Dict || S instanceof b.BaseStream || Array.isArray(S);
            }
            function C(S, $) {
              if (S instanceof g.Dict)
                S = S.getRawValues();
              else if (S instanceof b.BaseStream)
                S = S.dict.getRawValues();
              else if (!Array.isArray(S))
                return;
              for (const T of S)
                m(T) && $.push(T);
            }
            class w {
              constructor($, T, I) {
                this.dict = $, this.keys = T, this.xref = I, this.refSet = null;
              }
              async load() {
                if (this.xref.stream.isDataLoaded)
                  return;
                const {
                  keys: $,
                  dict: T
                } = this;
                this.refSet = new g.RefSet();
                const I = [];
                for (const _ of $) {
                  const E = T.getRaw(_);
                  E !== void 0 && I.push(E);
                }
                return this._walk(I);
              }
              async _walk($) {
                const T = [], I = [];
                for (; $.length; ) {
                  let _ = $.pop();
                  if (_ instanceof g.Ref) {
                    if (this.refSet.has(_))
                      continue;
                    try {
                      this.refSet.put(_), _ = this.xref.fetch(_);
                    } catch (E) {
                      if (!(E instanceof y.MissingDataException)) {
                        (0, f.warn)(`ObjectLoader._walk - requesting all data: "${E}".`), this.refSet = null;
                        const {
                          manager: R
                        } = this.xref.stream;
                        return R.requestAllChunks();
                      }
                      T.push(_), I.push({
                        begin: E.begin,
                        end: E.end
                      });
                    }
                  }
                  if (_ instanceof b.BaseStream) {
                    const E = _.getBaseStreams();
                    if (E) {
                      let R = !1;
                      for (const O of E)
                        O.isDataLoaded || (R = !0, I.push({
                          begin: O.start,
                          end: O.end
                        }));
                      R && T.push(_);
                    }
                  }
                  C(_, $);
                }
                if (I.length) {
                  await this.xref.stream.manager.requestRanges(I);
                  for (const _ of T)
                    _ instanceof g.Ref && this.refSet.remove(_);
                  return this._walk(T);
                }
                this.refSet = null;
              }
            }
            A.ObjectLoader = w;
          },
          /* 77 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.XFAFactory = void 0;
            var g = x(78), b = x(79), y = x(89), f = x(85), m = x(84), C = x(2), w = x(90), S = x(100);
            class $ {
              constructor(I) {
                try {
                  this.root = new w.XFAParser().parse($._createDocument(I));
                  const _ = new b.Binder(this.root);
                  this.form = _.bind(), this.dataHandler = new y.DataHandler(this.root, _.getData()), this.form[g.$globalData].template = this.form;
                } catch (_) {
                  (0, C.warn)(`XFA - an error occurred during parsing and binding: ${_}`);
                }
              }
              isValid() {
                return this.root && this.form;
              }
              _createPagesHelper() {
                const I = this.form[g.$toPages]();
                return new Promise((_, E) => {
                  const R = () => {
                    try {
                      const O = I.next();
                      O.done ? _(O.value) : setTimeout(R, 0);
                    } catch (O) {
                      E(O);
                    }
                  };
                  setTimeout(R, 0);
                });
              }
              async _createPages() {
                try {
                  this.pages = await this._createPagesHelper(), this.dims = this.pages.children.map((I) => {
                    const {
                      width: _,
                      height: E
                    } = I.attributes.style;
                    return [0, 0, parseInt(_), parseInt(E)];
                  });
                } catch (I) {
                  (0, C.warn)(`XFA - an error occurred during layout: ${I}`);
                }
              }
              getBoundingBox(I) {
                return this.dims[I];
              }
              async getNumPages() {
                return this.pages || await this._createPages(), this.dims.length;
              }
              setImages(I) {
                this.form[g.$globalData].images = I;
              }
              setFonts(I) {
                this.form[g.$globalData].fontFinder = new f.FontFinder(I);
                const _ = [];
                for (let E of this.form[g.$globalData].usedTypefaces)
                  E = (0, m.stripQuotes)(E), this.form[g.$globalData].fontFinder.find(E) || _.push(E);
                return _.length > 0 ? _ : null;
              }
              appendFonts(I, _) {
                this.form[g.$globalData].fontFinder.add(I, _);
              }
              async getPages() {
                this.pages || await this._createPages();
                const I = this.pages;
                return this.pages = null, I;
              }
              serializeData(I) {
                return this.dataHandler.serialize(I);
              }
              static _createDocument(I) {
                return I["/xdp:xdp"] ? Object.values(I).join("") : I["xdp:xdp"];
              }
              static getRichTextAsHtml(I) {
                if (!I || typeof I != "string")
                  return null;
                try {
                  let _ = new w.XFAParser(S.XhtmlNamespace, !0).parse(I);
                  if (!["body", "xhtml"].includes(_[g.$nodeName])) {
                    const L = S.XhtmlNamespace.body({});
                    L[g.$appendChild](_), _ = L;
                  }
                  const E = _[g.$toHTML]();
                  if (!E.success)
                    return null;
                  const {
                    html: R
                  } = E, {
                    attributes: O
                  } = R;
                  return O && (O.class && (O.class = O.class.filter((L) => !L.startsWith("xfa"))), O.dir = "auto"), {
                    html: R,
                    str: _[g.$text]()
                  };
                } catch (_) {
                  (0, C.warn)(`XFA - an error occurred during parsing of rich text: ${_}`);
                }
                return null;
              }
            }
            A.XFAFactory = $;
          },
          /* 78 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.$uid = A.$toStyle = A.$toString = A.$toPages = A.$toHTML = A.$text = A.$tabIndex = A.$setValue = A.$setSetAttributes = A.$setId = A.$searchNode = A.$root = A.$resolvePrototypes = A.$removeChild = A.$pushPara = A.$pushGlyphs = A.$popPara = A.$onText = A.$onChildCheck = A.$onChild = A.$nsAttributes = A.$nodeName = A.$namespaceId = A.$lastAttribute = A.$isUsable = A.$isTransparent = A.$isThereMoreWidth = A.$isSplittable = A.$isNsAgnostic = A.$isDescendent = A.$isDataValue = A.$isCDATAXml = A.$isBindable = A.$insertAt = A.$indexOf = A.$ids = A.$hasSettableValue = A.$globalData = A.$getTemplateRoot = A.$getSubformParent = A.$getRealChildrenByNameIt = A.$getParent = A.$getNextPage = A.$getExtra = A.$getDataValue = A.$getContainedChildren = A.$getChildrenByNameIt = A.$getChildrenByName = A.$getChildrenByClass = A.$getChildren = A.$getAvailableSpace = A.$getAttributes = A.$getAttributeIt = A.$flushHTML = A.$finalize = A.$extra = A.$dump = A.$data = A.$content = A.$consumed = A.$clone = A.$cleanup = A.$cleanPage = A.$clean = A.$childrenToHTML = A.$appendChild = A.$addHTML = A.$acceptWhitespace = void 0;
            const x = Symbol();
            A.$acceptWhitespace = x;
            const g = Symbol();
            A.$addHTML = g;
            const b = Symbol();
            A.$appendChild = b;
            const y = Symbol();
            A.$childrenToHTML = y;
            const f = Symbol();
            A.$clean = f;
            const m = Symbol();
            A.$cleanPage = m;
            const C = Symbol();
            A.$cleanup = C;
            const w = Symbol();
            A.$clone = w;
            const S = Symbol();
            A.$consumed = S;
            const $ = Symbol("content");
            A.$content = $;
            const T = Symbol("data");
            A.$data = T;
            const I = Symbol();
            A.$dump = I;
            const _ = Symbol("extra");
            A.$extra = _;
            const E = Symbol();
            A.$finalize = E;
            const R = Symbol();
            A.$flushHTML = R;
            const O = Symbol();
            A.$getAttributeIt = O;
            const L = Symbol();
            A.$getAttributes = L;
            const B = Symbol();
            A.$getAvailableSpace = B;
            const F = Symbol();
            A.$getChildrenByClass = F;
            const M = Symbol();
            A.$getChildrenByName = M;
            const W = Symbol();
            A.$getChildrenByNameIt = W;
            const j = Symbol();
            A.$getDataValue = j;
            const G = Symbol();
            A.$getExtra = G;
            const U = Symbol();
            A.$getRealChildrenByNameIt = U;
            const k = Symbol();
            A.$getChildren = k;
            const N = Symbol();
            A.$getContainedChildren = N;
            const P = Symbol();
            A.$getNextPage = P;
            const D = Symbol();
            A.$getSubformParent = D;
            const H = Symbol();
            A.$getParent = H;
            const V = Symbol();
            A.$getTemplateRoot = V;
            const Z = Symbol();
            A.$globalData = Z;
            const ne = Symbol();
            A.$hasSettableValue = ne;
            const K = Symbol();
            A.$ids = K;
            const q = Symbol();
            A.$indexOf = q;
            const Y = Symbol();
            A.$insertAt = Y;
            const ee = Symbol();
            A.$isCDATAXml = ee;
            const Q = Symbol();
            A.$isBindable = Q;
            const J = Symbol();
            A.$isDataValue = J;
            const te = Symbol();
            A.$isDescendent = te;
            const ae = Symbol();
            A.$isNsAgnostic = ae;
            const se = Symbol();
            A.$isSplittable = se;
            const ie = Symbol();
            A.$isThereMoreWidth = ie;
            const fe = Symbol();
            A.$isTransparent = fe;
            const ge = Symbol();
            A.$isUsable = ge;
            const me = Symbol();
            A.$lastAttribute = me;
            const pe = Symbol("namespaceId");
            A.$namespaceId = pe;
            const be = Symbol("nodeName");
            A.$nodeName = be;
            const le = Symbol();
            A.$nsAttributes = le;
            const ve = Symbol();
            A.$onChild = ve;
            const he = Symbol();
            A.$onChildCheck = he;
            const ye = Symbol();
            A.$onText = ye;
            const Ce = Symbol();
            A.$pushGlyphs = Ce;
            const xe = Symbol();
            A.$popPara = xe;
            const we = Symbol();
            A.$pushPara = we;
            const $e = Symbol();
            A.$removeChild = $e;
            const Ae = Symbol("root");
            A.$root = Ae;
            const ue = Symbol();
            A.$resolvePrototypes = ue;
            const ce = Symbol();
            A.$searchNode = ce;
            const Ee = Symbol();
            A.$setId = Ee;
            const _e = Symbol();
            A.$setSetAttributes = _e;
            const Te = Symbol();
            A.$setValue = Te;
            const ke = Symbol();
            A.$tabIndex = ke;
            const Re = Symbol();
            A.$text = Re;
            const Be = Symbol();
            A.$toPages = Be;
            const Oe = Symbol();
            A.$toHTML = Oe;
            const Me = Symbol();
            A.$toString = Me;
            const Fe = Symbol();
            A.$toStyle = Fe;
            const Ue = Symbol("uid");
            A.$uid = Ue;
          },
          /* 79 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Binder = void 0;
            var g = x(78), b = x(80), y = x(88), f = x(87), m = x(81), C = x(2);
            const w = m.NamespaceIds.datasets.id;
            function S(T) {
              const I = new b.Text({});
              return I[g.$content] = T, I;
            }
            class $ {
              constructor(I) {
                this.root = I, this.datasets = I.datasets, this.data = I.datasets?.data || new f.XmlObject(m.NamespaceIds.datasets.id, "data"), this.emptyMerge = this.data[g.$getChildren]().length === 0, this.root.form = this.form = I.template[g.$clone]();
              }
              _isConsumeData() {
                return !this.emptyMerge && this._mergeMode;
              }
              _isMatchTemplate() {
                return !this._isConsumeData();
              }
              bind() {
                return this._bindElement(this.form, this.data), this.form;
              }
              getData() {
                return this.data;
              }
              _bindValue(I, _, E) {
                if (I[g.$data] = _, I[g.$hasSettableValue]())
                  if (_[g.$isDataValue]()) {
                    const R = _[g.$getDataValue]();
                    I[g.$setValue](S(R));
                  } else if (I instanceof b.Field && I.ui?.choiceList?.open === "multiSelect") {
                    const R = _[g.$getChildren]().map((O) => O[g.$content].trim()).join(`
`);
                    I[g.$setValue](S(R));
                  } else this._isConsumeData() && (0, C.warn)("XFA - Nodes haven't the same type.");
                else !_[g.$isDataValue]() || this._isMatchTemplate() ? this._bindElement(I, _) : (0, C.warn)("XFA - Nodes haven't the same type.");
              }
              _findDataByNameToConsume(I, _, E, R) {
                if (!I)
                  return null;
                let O, L;
                for (let B = 0; B < 3; B++) {
                  for (O = E[g.$getRealChildrenByNameIt](I, !1, !0); L = O.next().value, !!L; )
                    if (_ === L[g.$isDataValue]())
                      return L;
                  if (E[g.$namespaceId] === m.NamespaceIds.datasets.id && E[g.$nodeName] === "data")
                    break;
                  E = E[g.$getParent]();
                }
                return R ? (O = this.data[g.$getRealChildrenByNameIt](I, !0, !1), L = O.next().value, L || (O = this.data[g.$getAttributeIt](I, !0), L = O.next().value, L?.[g.$isDataValue]()) ? L : null) : null;
              }
              _setProperties(I, _) {
                if (I.hasOwnProperty("setProperty"))
                  for (const {
                    ref: E,
                    target: R,
                    connection: O
                  } of I.setProperty.children) {
                    if (O || !E)
                      continue;
                    const L = (0, y.searchNode)(this.root, _, E, !1, !1);
                    if (!L) {
                      (0, C.warn)(`XFA - Invalid reference: ${E}.`);
                      continue;
                    }
                    const [B] = L;
                    if (!B[g.$isDescendent](this.data)) {
                      (0, C.warn)("XFA - Invalid node: must be a data node.");
                      continue;
                    }
                    const F = (0, y.searchNode)(this.root, I, R, !1, !1);
                    if (!F) {
                      (0, C.warn)(`XFA - Invalid target: ${R}.`);
                      continue;
                    }
                    const [M] = F;
                    if (!M[g.$isDescendent](I)) {
                      (0, C.warn)("XFA - Invalid target: must be a property or subproperty.");
                      continue;
                    }
                    const W = M[g.$getParent]();
                    if (M instanceof b.SetProperty || W instanceof b.SetProperty) {
                      (0, C.warn)("XFA - Invalid target: cannot be a setProperty or one of its properties.");
                      continue;
                    }
                    if (M instanceof b.BindItems || W instanceof b.BindItems) {
                      (0, C.warn)("XFA - Invalid target: cannot be a bindItems or one of its properties.");
                      continue;
                    }
                    const j = B[g.$text](), G = M[g.$nodeName];
                    if (M instanceof f.XFAAttribute) {
                      const U = /* @__PURE__ */ Object.create(null);
                      U[G] = j;
                      const k = Reflect.construct(Object.getPrototypeOf(W).constructor, [U]);
                      W[G] = k[G];
                      continue;
                    }
                    if (!M.hasOwnProperty(g.$content)) {
                      (0, C.warn)("XFA - Invalid node to use in setProperty");
                      continue;
                    }
                    M[g.$data] = B, M[g.$content] = j, M[g.$finalize]();
                  }
              }
              _bindItems(I, _) {
                if (!I.hasOwnProperty("items") || !I.hasOwnProperty("bindItems") || I.bindItems.isEmpty())
                  return;
                for (const O of I.items.children)
                  I[g.$removeChild](O);
                I.items.clear();
                const E = new b.Items({}), R = new b.Items({});
                I[g.$appendChild](E), I.items.push(E), I[g.$appendChild](R), I.items.push(R);
                for (const {
                  ref: O,
                  labelRef: L,
                  valueRef: B,
                  connection: F
                } of I.bindItems.children) {
                  if (F || !O)
                    continue;
                  const M = (0, y.searchNode)(this.root, _, O, !1, !1);
                  if (!M) {
                    (0, C.warn)(`XFA - Invalid reference: ${O}.`);
                    continue;
                  }
                  for (const W of M) {
                    if (!W[g.$isDescendent](this.datasets)) {
                      (0, C.warn)(`XFA - Invalid ref (${O}): must be a datasets child.`);
                      continue;
                    }
                    const j = (0, y.searchNode)(this.root, W, L, !0, !1);
                    if (!j) {
                      (0, C.warn)(`XFA - Invalid label: ${L}.`);
                      continue;
                    }
                    const [G] = j;
                    if (!G[g.$isDescendent](this.datasets)) {
                      (0, C.warn)("XFA - Invalid label: must be a datasets child.");
                      continue;
                    }
                    const U = (0, y.searchNode)(this.root, W, B, !0, !1);
                    if (!U) {
                      (0, C.warn)(`XFA - Invalid value: ${B}.`);
                      continue;
                    }
                    const [k] = U;
                    if (!k[g.$isDescendent](this.datasets)) {
                      (0, C.warn)("XFA - Invalid value: must be a datasets child.");
                      continue;
                    }
                    const N = S(G[g.$text]()), P = S(k[g.$text]());
                    E[g.$appendChild](N), E.text.push(N), R[g.$appendChild](P), R.text.push(P);
                  }
                }
              }
              _bindOccurrences(I, _, E) {
                let R;
                if (_.length > 1 && (R = I[g.$clone](), R[g.$removeChild](R.occur), R.occur = null), this._bindValue(I, _[0], E), this._setProperties(I, _[0]), this._bindItems(I, _[0]), _.length === 1)
                  return;
                const O = I[g.$getParent](), L = I[g.$nodeName], B = O[g.$indexOf](I);
                for (let F = 1, M = _.length; F < M; F++) {
                  const W = _[F], j = R[g.$clone]();
                  O[L].push(j), O[g.$insertAt](B + F, j), this._bindValue(j, W, E), this._setProperties(j, W), this._bindItems(j, W);
                }
              }
              _createOccurrences(I) {
                if (!this.emptyMerge)
                  return;
                const {
                  occur: _
                } = I;
                if (!_ || _.initial <= 1)
                  return;
                const E = I[g.$getParent](), R = I[g.$nodeName];
                if (!(E[R] instanceof f.XFAObjectArray))
                  return;
                let O;
                I.name ? O = E[R].children.filter((F) => F.name === I.name).length : O = E[R].children.length;
                const L = E[g.$indexOf](I) + 1, B = _.initial - O;
                if (B) {
                  const F = I[g.$clone]();
                  F[g.$removeChild](F.occur), F.occur = null, E[R].push(F), E[g.$insertAt](L, F);
                  for (let M = 1; M < B; M++) {
                    const W = F[g.$clone]();
                    E[R].push(W), E[g.$insertAt](L + M, W);
                  }
                }
              }
              _getOccurInfo(I) {
                const {
                  name: _,
                  occur: E
                } = I;
                if (!E || !_)
                  return [1, 1];
                const R = E.max === -1 ? 1 / 0 : E.max;
                return [E.min, R];
              }
              _setAndBind(I, _) {
                this._setProperties(I, _), this._bindItems(I, _), this._bindElement(I, _);
              }
              _bindElement(I, _) {
                const E = [];
                this._createOccurrences(I);
                for (const R of I[g.$getChildren]()) {
                  if (R[g.$data])
                    continue;
                  if (this._mergeMode === void 0 && R[g.$nodeName] === "subform") {
                    this._mergeMode = R.mergeMode === "consumeData";
                    const j = _[g.$getChildren]();
                    if (j.length > 0)
                      this._bindOccurrences(R, [j[0]], null);
                    else if (this.emptyMerge) {
                      const G = _[g.$namespaceId] === w ? -1 : _[g.$namespaceId], U = R[g.$data] = new f.XmlObject(G, R.name || "root");
                      _[g.$appendChild](U), this._bindElement(R, U);
                    }
                    continue;
                  }
                  if (!R[g.$isBindable]())
                    continue;
                  let O = !1, L = null, B = null, F = null;
                  if (R.bind) {
                    switch (R.bind.match) {
                      case "none":
                        this._setAndBind(R, _);
                        continue;
                      case "global":
                        O = !0;
                        break;
                      case "dataRef":
                        if (!R.bind.ref) {
                          (0, C.warn)(`XFA - ref is empty in node ${R[g.$nodeName]}.`), this._setAndBind(R, _);
                          continue;
                        }
                        B = R.bind.ref;
                        break;
                    }
                    R.bind.picture && (L = R.bind.picture[g.$content]);
                  }
                  const [M, W] = this._getOccurInfo(R);
                  if (B)
                    if (F = (0, y.searchNode)(this.root, _, B, !0, !1), F === null) {
                      if (F = (0, y.createDataNode)(this.data, _, B), !F)
                        continue;
                      this._isConsumeData() && (F[g.$consumed] = !0), this._setAndBind(R, F);
                      continue;
                    } else
                      this._isConsumeData() && (F = F.filter((j) => !j[g.$consumed])), F.length > W ? F = F.slice(0, W) : F.length === 0 && (F = null), F && this._isConsumeData() && F.forEach((j) => {
                        j[g.$consumed] = !0;
                      });
                  else {
                    if (!R.name) {
                      this._setAndBind(R, _);
                      continue;
                    }
                    if (this._isConsumeData()) {
                      const j = [];
                      for (; j.length < W; ) {
                        const G = this._findDataByNameToConsume(R.name, R[g.$hasSettableValue](), _, O);
                        if (!G)
                          break;
                        G[g.$consumed] = !0, j.push(G);
                      }
                      F = j.length > 0 ? j : null;
                    } else {
                      if (F = _[g.$getRealChildrenByNameIt](R.name, !1, this.emptyMerge).next().value, !F) {
                        if (M === 0) {
                          E.push(R);
                          continue;
                        }
                        const j = _[g.$namespaceId] === w ? -1 : _[g.$namespaceId];
                        F = R[g.$data] = new f.XmlObject(j, R.name), this.emptyMerge && (F[g.$consumed] = !0), _[g.$appendChild](F), this._setAndBind(R, F);
                        continue;
                      }
                      this.emptyMerge && (F[g.$consumed] = !0), F = [F];
                    }
                  }
                  F ? this._bindOccurrences(R, F, L) : M > 0 ? this._setAndBind(R, _) : E.push(R);
                }
                E.forEach((R) => R[g.$getParent]()[g.$removeChild](R));
              }
            }
            A.Binder = $;
          },
          /* 80 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Value = A.Text = A.TemplateNamespace = A.Template = A.SetProperty = A.Items = A.Field = A.BindItems = void 0;
            var g = x(78), b = x(81), y = x(82), f = x(83), m = x(87), C = x(84), w = x(2), S = x(85), $ = x(3), T = x(88);
            const I = b.NamespaceIds.template.id, _ = "http://www.w3.org/2000/svg", E = 2, R = 3, O = 5e3, L = /^H(\d+)$/, B = /* @__PURE__ */ new Set(["image/gif", "image/jpeg", "image/jpg", "image/pjpeg", "image/png", "image/apng", "image/x-png", "image/bmp", "image/x-ms-bmp", "image/tiff", "image/tif", "application/octet-stream"]), F = [[[66, 77], "image/bmp"], [[255, 216, 255], "image/jpeg"], [[73, 73, 42, 0], "image/tiff"], [[77, 77, 0, 42], "image/tiff"], [[71, 73, 70, 56, 57, 97], "image/gif"], [[137, 80, 78, 71, 13, 10, 26, 10], "image/png"]];
            function M(ht) {
              if (!ht || !ht.border)
                return {
                  w: 0,
                  h: 0
                };
              const oe = ht.border[g.$getExtra]();
              return oe ? {
                w: oe.widths[0] + oe.widths[2] + oe.insets[0] + oe.insets[2],
                h: oe.widths[1] + oe.widths[3] + oe.insets[1] + oe.insets[3]
              } : {
                w: 0,
                h: 0
              };
            }
            function W(ht) {
              return ht.margin && (ht.margin.topInset || ht.margin.rightInset || ht.margin.bottomInset || ht.margin.leftInset);
            }
            function j(ht, oe) {
              if (!ht.value) {
                const Ie = new Tr({});
                ht[g.$appendChild](Ie), ht.value = Ie;
              }
              ht.value[g.$setValue](oe);
            }
            function* G(ht) {
              for (const oe of ht[g.$getChildren]()) {
                if (oe instanceof Dt) {
                  yield* oe[g.$getContainedChildren]();
                  continue;
                }
                yield oe;
              }
            }
            function U(ht) {
              return ht.validate?.nullTest === "error";
            }
            function k(ht) {
              for (; ht; ) {
                if (!ht.traversal) {
                  ht[g.$tabIndex] = ht[g.$getParent]()[g.$tabIndex];
                  return;
                }
                if (ht[g.$tabIndex])
                  return;
                let oe = null;
                for (const At of ht.traversal[g.$getChildren]())
                  if (At.operation === "next") {
                    oe = At;
                    break;
                  }
                if (!oe || !oe.ref) {
                  ht[g.$tabIndex] = ht[g.$getParent]()[g.$tabIndex];
                  return;
                }
                const Ie = ht[g.$getTemplateRoot]();
                ht[g.$tabIndex] = ++Ie[g.$tabIndex];
                const lt = Ie[g.$searchNode](oe.ref, ht);
                if (!lt)
                  return;
                ht = lt[0];
              }
            }
            function N(ht, oe) {
              const Ie = ht.assist;
              if (Ie) {
                const lt = Ie[g.$toHTML]();
                lt && (oe.title = lt);
                const Bt = Ie.role.match(L);
                if (Bt) {
                  const Kt = "heading", Ut = Bt[1];
                  oe.role = Kt, oe["aria-level"] = Ut;
                }
              }
              if (ht.layout === "table")
                oe.role = "table";
              else if (ht.layout === "row")
                oe.role = "row";
              else {
                const lt = ht[g.$getParent]();
                lt.layout === "row" && (oe.role = lt.assist?.role === "TH" ? "columnheader" : "cell");
              }
            }
            function P(ht) {
              if (!ht.assist)
                return null;
              const oe = ht.assist;
              return oe.speak && oe.speak[g.$content] !== "" ? oe.speak[g.$content] : oe.toolTip ? oe.toolTip[g.$content] : null;
            }
            function D(ht) {
              return C.HTMLResult.success({
                name: "div",
                attributes: {
                  class: ["xfaRich"],
                  style: /* @__PURE__ */ Object.create(null)
                },
                children: [{
                  name: "span",
                  attributes: {
                    style: /* @__PURE__ */ Object.create(null)
                  },
                  value: ht
                }]
              });
            }
            function H(ht) {
              const oe = ht[g.$getTemplateRoot]();
              oe[g.$extra].firstUnsplittable === null && (oe[g.$extra].firstUnsplittable = ht, oe[g.$extra].noLayoutFailure = !0);
            }
            function V(ht) {
              const oe = ht[g.$getTemplateRoot]();
              oe[g.$extra].firstUnsplittable === ht && (oe[g.$extra].noLayoutFailure = !1);
            }
            function Z(ht) {
              if (ht[g.$extra] || (ht[g.$extra] = /* @__PURE__ */ Object.create(null), ht.targetType === "auto"))
                return !1;
              const oe = ht[g.$getTemplateRoot]();
              let Ie = null;
              if (ht.target) {
                if (Ie = oe[g.$searchNode](ht.target, ht[g.$getParent]()), !Ie)
                  return !1;
                Ie = Ie[0];
              }
              const {
                currentPageArea: lt,
                currentContentArea: At
              } = oe[g.$extra];
              if (ht.targetType === "pageArea")
                return Ie instanceof $t || (Ie = null), ht.startNew ? (ht[g.$extra].target = Ie || lt, !0) : Ie && Ie !== lt ? (ht[g.$extra].target = Ie, !0) : !1;
              Ie instanceof Ae || (Ie = null);
              const Bt = Ie && Ie[g.$getParent]();
              let Kt, Ut = Bt;
              if (ht.startNew)
                if (Ie) {
                  const er = Bt.contentArea.children, cr = er.indexOf(At), xr = er.indexOf(Ie);
                  cr !== -1 && cr < xr && (Ut = null), Kt = xr - 1;
                } else
                  Kt = lt.contentArea.children.indexOf(At);
              else if (Ie && Ie !== At)
                Kt = Bt.contentArea.children.indexOf(Ie) - 1, Ut = Bt === lt ? null : Bt;
              else
                return !1;
              return ht[g.$extra].target = Ut, ht[g.$extra].index = Kt, !0;
            }
            function ne(ht, oe, Ie) {
              const lt = ht[g.$getTemplateRoot](), At = lt[g.$extra].noLayoutFailure, Bt = oe[g.$getSubformParent];
              oe[g.$getSubformParent] = () => ht, lt[g.$extra].noLayoutFailure = !0;
              const Kt = oe[g.$toHTML](Ie);
              ht[g.$addHTML](Kt.html, Kt.bbox), lt[g.$extra].noLayoutFailure = At, oe[g.$getSubformParent] = Bt;
            }
            class K extends m.StringObject {
              constructor(oe) {
                super(I, "appearanceFilter"), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class q extends m.XFAObject {
              constructor(oe) {
                super(I, "arc", !0), this.circular = (0, C.getInteger)({
                  data: oe.circular,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.hand = (0, C.getStringOption)(oe.hand, ["even", "left", "right"]), this.id = oe.id || "", this.startAngle = (0, C.getFloat)({
                  data: oe.startAngle,
                  defaultValue: 0,
                  validate: (Ie) => !0
                }), this.sweepAngle = (0, C.getFloat)({
                  data: oe.sweepAngle,
                  defaultValue: 360,
                  validate: (Ie) => !0
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.edge = null, this.fill = null;
              }
              [g.$toHTML]() {
                const oe = this.edge || new Fe({}), Ie = oe[g.$toStyle](), lt = /* @__PURE__ */ Object.create(null);
                this.fill?.presence === "visible" ? Object.assign(lt, this.fill[g.$toStyle]()) : lt.fill = "transparent", lt.strokeWidth = (0, f.measureToString)(oe.presence === "visible" ? oe.thickness : 0), lt.stroke = Ie.color;
                let At;
                const Bt = {
                  xmlns: _,
                  style: {
                    width: "100%",
                    height: "100%",
                    overflow: "visible"
                  }
                };
                if (this.sweepAngle === 360)
                  At = {
                    name: "ellipse",
                    attributes: {
                      xmlns: _,
                      cx: "50%",
                      cy: "50%",
                      rx: "50%",
                      ry: "50%",
                      style: lt
                    }
                  };
                else {
                  const er = this.startAngle * Math.PI / 180, cr = this.sweepAngle * Math.PI / 180, xr = this.sweepAngle > 180 ? 1 : 0, [Pr, Sr, Or, Dr] = [50 * (1 + Math.cos(er)), 50 * (1 - Math.sin(er)), 50 * (1 + Math.cos(er + cr)), 50 * (1 - Math.sin(er + cr))];
                  At = {
                    name: "path",
                    attributes: {
                      xmlns: _,
                      d: `M ${Pr} ${Sr} A 50 50 0 ${xr} 0 ${Or} ${Dr}`,
                      vectorEffect: "non-scaling-stroke",
                      style: lt
                    }
                  }, Object.assign(Bt, {
                    viewBox: "0 0 100 100",
                    preserveAspectRatio: "none"
                  });
                }
                const Kt = {
                  name: "svg",
                  children: [At],
                  attributes: Bt
                }, Ut = this[g.$getParent]()[g.$getParent]();
                return W(Ut) ? C.HTMLResult.success({
                  name: "div",
                  attributes: {
                    style: {
                      display: "inline",
                      width: "100%",
                      height: "100%"
                    }
                  },
                  children: [Kt]
                }) : (Kt.attributes.style.position = "absolute", C.HTMLResult.success(Kt));
              }
            }
            class Y extends m.XFAObject {
              constructor(oe) {
                super(I, "area", !0), this.colSpan = (0, C.getInteger)({
                  data: oe.colSpan,
                  defaultValue: 1,
                  validate: (Ie) => Ie >= 1 || Ie === -1
                }), this.id = oe.id || "", this.name = oe.name || "", this.relevant = (0, C.getRelevant)(oe.relevant), this.use = oe.use || "", this.usehref = oe.usehref || "", this.x = (0, C.getMeasurement)(oe.x, "0pt"), this.y = (0, C.getMeasurement)(oe.y, "0pt"), this.desc = null, this.extras = null, this.area = new m.XFAObjectArray(), this.draw = new m.XFAObjectArray(), this.exObject = new m.XFAObjectArray(), this.exclGroup = new m.XFAObjectArray(), this.field = new m.XFAObjectArray(), this.subform = new m.XFAObjectArray(), this.subformSet = new m.XFAObjectArray();
              }
              *[g.$getContainedChildren]() {
                yield* G(this);
              }
              [g.$isTransparent]() {
                return !0;
              }
              [g.$isBindable]() {
                return !0;
              }
              [g.$addHTML](oe, Ie) {
                const [lt, At, Bt, Kt] = Ie;
                this[g.$extra].width = Math.max(this[g.$extra].width, lt + Bt), this[g.$extra].height = Math.max(this[g.$extra].height, At + Kt), this[g.$extra].children.push(oe);
              }
              [g.$getAvailableSpace]() {
                return this[g.$extra].availableSpace;
              }
              [g.$toHTML](oe) {
                const Ie = (0, f.toStyle)(this, "position"), lt = {
                  style: Ie,
                  id: this[g.$uid],
                  class: ["xfaArea"]
                };
                (0, f.isPrintOnly)(this) && lt.class.push("xfaPrintOnly"), this.name && (lt.xfaName = this.name);
                const At = [];
                this[g.$extra] = {
                  children: At,
                  width: 0,
                  height: 0,
                  availableSpace: oe
                };
                const Bt = this[g.$childrenToHTML]({
                  filter: /* @__PURE__ */ new Set(["area", "draw", "field", "exclGroup", "subform", "subformSet"]),
                  include: !0
                });
                if (!Bt.success)
                  return Bt.isBreak() ? Bt : (delete this[g.$extra], C.HTMLResult.FAILURE);
                Ie.width = (0, f.measureToString)(this[g.$extra].width), Ie.height = (0, f.measureToString)(this[g.$extra].height);
                const Kt = {
                  name: "div",
                  attributes: lt,
                  children: At
                }, Ut = [this.x, this.y, this[g.$extra].width, this[g.$extra].height];
                return delete this[g.$extra], C.HTMLResult.success(Kt, Ut);
              }
            }
            class ee extends m.XFAObject {
              constructor(oe) {
                super(I, "assist", !0), this.id = oe.id || "", this.role = oe.role || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.speak = null, this.toolTip = null;
              }
              [g.$toHTML]() {
                return this.toolTip?.[g.$content] || null;
              }
            }
            class Q extends m.XFAObject {
              constructor(oe) {
                super(I, "barcode", !0), this.charEncoding = (0, C.getKeyword)({
                  data: oe.charEncoding ? oe.charEncoding.toLowerCase() : "",
                  defaultValue: "",
                  validate: (Ie) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(Ie) || Ie.match(/iso-8859-\d{2}/)
                }), this.checksum = (0, C.getStringOption)(oe.checksum, ["none", "1mod10", "1mod10_1mod11", "2mod10", "auto"]), this.dataColumnCount = (0, C.getInteger)({
                  data: oe.dataColumnCount,
                  defaultValue: -1,
                  validate: (Ie) => Ie >= 0
                }), this.dataLength = (0, C.getInteger)({
                  data: oe.dataLength,
                  defaultValue: -1,
                  validate: (Ie) => Ie >= 0
                }), this.dataPrep = (0, C.getStringOption)(oe.dataPrep, ["none", "flateCompress"]), this.dataRowCount = (0, C.getInteger)({
                  data: oe.dataRowCount,
                  defaultValue: -1,
                  validate: (Ie) => Ie >= 0
                }), this.endChar = oe.endChar || "", this.errorCorrectionLevel = (0, C.getInteger)({
                  data: oe.errorCorrectionLevel,
                  defaultValue: -1,
                  validate: (Ie) => Ie >= 0 && Ie <= 8
                }), this.id = oe.id || "", this.moduleHeight = (0, C.getMeasurement)(oe.moduleHeight, "5mm"), this.moduleWidth = (0, C.getMeasurement)(oe.moduleWidth, "0.25mm"), this.printCheckDigit = (0, C.getInteger)({
                  data: oe.printCheckDigit,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.rowColumnRatio = (0, C.getRatio)(oe.rowColumnRatio), this.startChar = oe.startChar || "", this.textLocation = (0, C.getStringOption)(oe.textLocation, ["below", "above", "aboveEmbedded", "belowEmbedded", "none"]), this.truncate = (0, C.getInteger)({
                  data: oe.truncate,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.type = (0, C.getStringOption)(oe.type ? oe.type.toLowerCase() : "", ["aztec", "codabar", "code2of5industrial", "code2of5interleaved", "code2of5matrix", "code2of5standard", "code3of9", "code3of9extended", "code11", "code49", "code93", "code128", "code128a", "code128b", "code128c", "code128sscc", "datamatrix", "ean8", "ean8add2", "ean8add5", "ean13", "ean13add2", "ean13add5", "ean13pwcd", "fim", "logmars", "maxicode", "msi", "pdf417", "pdf417macro", "plessey", "postauscust2", "postauscust3", "postausreplypaid", "postausstandard", "postukrm4scc", "postusdpbc", "postusimb", "postusstandard", "postus5zip", "qrcode", "rfid", "rss14", "rss14expanded", "rss14limited", "rss14stacked", "rss14stackedomni", "rss14truncated", "telepen", "ucc128", "ucc128random", "ucc128sscc", "upca", "upcaadd2", "upcaadd5", "upcapwcd", "upce", "upceadd2", "upceadd5", "upcean2", "upcean5", "upsmaxicode"]), this.upsMode = (0, C.getStringOption)(oe.upsMode, ["usCarrier", "internationalCarrier", "secureSymbol", "standardSymbol"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.wideNarrowRatio = (0, C.getRatio)(oe.wideNarrowRatio), this.encrypt = null, this.extras = null;
              }
            }
            class J extends m.XFAObject {
              constructor(oe) {
                super(I, "bind", !0), this.match = (0, C.getStringOption)(oe.match, ["once", "dataRef", "global", "none"]), this.ref = oe.ref || "", this.picture = null;
              }
            }
            class te extends m.XFAObject {
              constructor(oe) {
                super(I, "bindItems"), this.connection = oe.connection || "", this.labelRef = oe.labelRef || "", this.ref = oe.ref || "", this.valueRef = oe.valueRef || "";
              }
            }
            A.BindItems = te;
            class ae extends m.XFAObject {
              constructor(oe) {
                super(I, "bookend"), this.id = oe.id || "", this.leader = oe.leader || "", this.trailer = oe.trailer || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class se extends m.Option01 {
              constructor(oe) {
                super(I, "boolean"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$toHTML](oe) {
                return D(this[g.$content] === 1 ? "1" : "0");
              }
            }
            class ie extends m.XFAObject {
              constructor(oe) {
                super(I, "border", !0), this.break = (0, C.getStringOption)(oe.break, ["close", "open"]), this.hand = (0, C.getStringOption)(oe.hand, ["even", "left", "right"]), this.id = oe.id || "", this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, C.getRelevant)(oe.relevant), this.use = oe.use || "", this.usehref = oe.usehref || "", this.corner = new m.XFAObjectArray(4), this.edge = new m.XFAObjectArray(4), this.extras = null, this.fill = null, this.margin = null;
              }
              [g.$getExtra]() {
                if (!this[g.$extra]) {
                  const oe = this.edge.children.slice();
                  if (oe.length < 4) {
                    const At = oe.at(-1) || new Fe({});
                    for (let Bt = oe.length; Bt < 4; Bt++)
                      oe.push(At);
                  }
                  const Ie = oe.map((At) => At.thickness), lt = [0, 0, 0, 0];
                  this.margin && (lt[0] = this.margin.topInset, lt[1] = this.margin.rightInset, lt[2] = this.margin.bottomInset, lt[3] = this.margin.leftInset), this[g.$extra] = {
                    widths: Ie,
                    insets: lt,
                    edges: oe
                  };
                }
                return this[g.$extra];
              }
              [g.$toStyle]() {
                const {
                  edges: oe
                } = this[g.$getExtra](), Ie = oe.map((At) => {
                  const Bt = At[g.$toStyle]();
                  return Bt.color ||= "#000000", Bt;
                }), lt = /* @__PURE__ */ Object.create(null);
                if (this.margin && Object.assign(lt, this.margin[g.$toStyle]()), this.fill?.presence === "visible" && Object.assign(lt, this.fill[g.$toStyle]()), this.corner.children.some((At) => At.radius !== 0)) {
                  const At = this.corner.children.map((Bt) => Bt[g.$toStyle]());
                  if (At.length === 2 || At.length === 3) {
                    const Bt = At.at(-1);
                    for (let Kt = At.length; Kt < 4; Kt++)
                      At.push(Bt);
                  }
                  lt.borderRadius = At.map((Bt) => Bt.radius).join(" ");
                }
                switch (this.presence) {
                  case "invisible":
                  case "hidden":
                    lt.borderStyle = "";
                    break;
                  case "inactive":
                    lt.borderStyle = "none";
                    break;
                  default:
                    lt.borderStyle = Ie.map((At) => At.style).join(" ");
                    break;
                }
                return lt.borderWidth = Ie.map((At) => At.width).join(" "), lt.borderColor = Ie.map((At) => At.color).join(" "), lt;
              }
            }
            class fe extends m.XFAObject {
              constructor(oe) {
                super(I, "break", !0), this.after = (0, C.getStringOption)(oe.after, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.afterTarget = oe.afterTarget || "", this.before = (0, C.getStringOption)(oe.before, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.beforeTarget = oe.beforeTarget || "", this.bookendLeader = oe.bookendLeader || "", this.bookendTrailer = oe.bookendTrailer || "", this.id = oe.id || "", this.overflowLeader = oe.overflowLeader || "", this.overflowTarget = oe.overflowTarget || "", this.overflowTrailer = oe.overflowTrailer || "", this.startNew = (0, C.getInteger)({
                  data: oe.startNew,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null;
              }
            }
            class ge extends m.XFAObject {
              constructor(oe) {
                super(I, "breakAfter", !0), this.id = oe.id || "", this.leader = oe.leader || "", this.startNew = (0, C.getInteger)({
                  data: oe.startNew,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.target = oe.target || "", this.targetType = (0, C.getStringOption)(oe.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = oe.trailer || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.script = null;
              }
            }
            class me extends m.XFAObject {
              constructor(oe) {
                super(I, "breakBefore", !0), this.id = oe.id || "", this.leader = oe.leader || "", this.startNew = (0, C.getInteger)({
                  data: oe.startNew,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.target = oe.target || "", this.targetType = (0, C.getStringOption)(oe.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = oe.trailer || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.script = null;
              }
              [g.$toHTML](oe) {
                return this[g.$extra] = {}, C.HTMLResult.FAILURE;
              }
            }
            class pe extends m.XFAObject {
              constructor(oe) {
                super(I, "button", !0), this.highlight = (0, C.getStringOption)(oe.highlight, ["inverted", "none", "outline", "push"]), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null;
              }
              [g.$toHTML](oe) {
                const lt = this[g.$getParent]()[g.$getParent](), At = {
                  name: "button",
                  attributes: {
                    id: this[g.$uid],
                    class: ["xfaButton"],
                    style: {}
                  },
                  children: []
                };
                for (const Bt of lt.event.children) {
                  if (Bt.activity !== "click" || !Bt.script)
                    continue;
                  const Kt = (0, $.recoverJsURL)(Bt.script[g.$content]);
                  if (!Kt)
                    continue;
                  const Ut = (0, f.fixURL)(Kt.url);
                  Ut && At.children.push({
                    name: "a",
                    attributes: {
                      id: "link" + this[g.$uid],
                      href: Ut,
                      newWindow: Kt.newWindow,
                      class: ["xfaLink"],
                      style: {}
                    },
                    children: []
                  });
                }
                return C.HTMLResult.success(At);
              }
            }
            class be extends m.XFAObject {
              constructor(oe) {
                super(I, "calculate", !0), this.id = oe.id || "", this.override = (0, C.getStringOption)(oe.override, ["disabled", "error", "ignore", "warning"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.message = null, this.script = null;
              }
            }
            class le extends m.XFAObject {
              constructor(oe) {
                super(I, "caption", !0), this.id = oe.id || "", this.placement = (0, C.getStringOption)(oe.placement, ["left", "bottom", "inline", "right", "top"]), this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.reserve = Math.ceil((0, C.getMeasurement)(oe.reserve)), this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.font = null, this.margin = null, this.para = null, this.value = null;
              }
              [g.$setValue](oe) {
                j(this, oe);
              }
              [g.$getExtra](oe) {
                if (!this[g.$extra]) {
                  let {
                    width: Ie,
                    height: lt
                  } = oe;
                  switch (this.placement) {
                    case "left":
                    case "right":
                    case "inline":
                      Ie = this.reserve <= 0 ? Ie : this.reserve;
                      break;
                    case "top":
                    case "bottom":
                      lt = this.reserve <= 0 ? lt : this.reserve;
                      break;
                  }
                  this[g.$extra] = (0, f.layoutNode)(this, {
                    width: Ie,
                    height: lt
                  });
                }
                return this[g.$extra];
              }
              [g.$toHTML](oe) {
                if (!this.value)
                  return C.HTMLResult.EMPTY;
                this[g.$pushPara]();
                const Ie = this.value[g.$toHTML](oe).html;
                if (!Ie)
                  return this[g.$popPara](), C.HTMLResult.EMPTY;
                const lt = this.reserve;
                if (this.reserve <= 0) {
                  const {
                    w: Kt,
                    h: Ut
                  } = this[g.$getExtra](oe);
                  switch (this.placement) {
                    case "left":
                    case "right":
                    case "inline":
                      this.reserve = Kt;
                      break;
                    case "top":
                    case "bottom":
                      this.reserve = Ut;
                      break;
                  }
                }
                const At = [];
                typeof Ie == "string" ? At.push({
                  name: "#text",
                  value: Ie
                }) : At.push(Ie);
                const Bt = (0, f.toStyle)(this, "font", "margin", "visibility");
                switch (this.placement) {
                  case "left":
                  case "right":
                    this.reserve > 0 && (Bt.width = (0, f.measureToString)(this.reserve));
                    break;
                  case "top":
                  case "bottom":
                    this.reserve > 0 && (Bt.height = (0, f.measureToString)(this.reserve));
                    break;
                }
                return (0, f.setPara)(this, null, Ie), this[g.$popPara](), this.reserve = lt, C.HTMLResult.success({
                  name: "div",
                  attributes: {
                    style: Bt,
                    class: ["xfaCaption"]
                  },
                  children: At
                });
              }
            }
            class ve extends m.StringObject {
              constructor(oe) {
                super(I, "certificate"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class he extends m.XFAObject {
              constructor(oe) {
                super(I, "certificates", !0), this.credentialServerPolicy = (0, C.getStringOption)(oe.credentialServerPolicy, ["optional", "required"]), this.id = oe.id || "", this.url = oe.url || "", this.urlPolicy = oe.urlPolicy || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.encryption = null, this.issuers = null, this.keyUsage = null, this.oids = null, this.signing = null, this.subjectDNs = null;
              }
            }
            class ye extends m.XFAObject {
              constructor(oe) {
                super(I, "checkButton", !0), this.id = oe.id || "", this.mark = (0, C.getStringOption)(oe.mark, ["default", "check", "circle", "cross", "diamond", "square", "star"]), this.shape = (0, C.getStringOption)(oe.shape, ["square", "round"]), this.size = (0, C.getMeasurement)(oe.size, "10pt"), this.use = oe.use || "", this.usehref = oe.usehref || "", this.border = null, this.extras = null, this.margin = null;
              }
              [g.$toHTML](oe) {
                const Ie = (0, f.toStyle)("margin"), lt = (0, f.measureToString)(this.size);
                Ie.width = Ie.height = lt;
                let At, Bt, Kt;
                const Ut = this[g.$getParent]()[g.$getParent](), er = Ut.items.children.length && Ut.items.children[0][g.$toHTML]().html || [], cr = {
                  on: (er[0] !== void 0 ? er[0] : "on").toString(),
                  off: (er[1] !== void 0 ? er[1] : "off").toString()
                }, Pr = (Ut.value?.[g.$text]() || "off") === cr.on || void 0, Sr = Ut[g.$getSubformParent](), Or = Ut[g.$uid];
                let Dr;
                Sr instanceof We ? (Kt = Sr[g.$uid], At = "radio", Bt = "xfaRadio", Dr = Sr[g.$data]?.[g.$uid] || Sr[g.$uid]) : (At = "checkbox", Bt = "xfaCheckbox", Dr = Ut[g.$data]?.[g.$uid] || Ut[g.$uid]);
                const pr = {
                  name: "input",
                  attributes: {
                    class: [Bt],
                    style: Ie,
                    fieldId: Or,
                    dataId: Dr,
                    type: At,
                    checked: Pr,
                    xfaOn: cr.on,
                    xfaOff: cr.off,
                    "aria-label": P(Ut),
                    "aria-required": !1
                  }
                };
                return Kt && (pr.attributes.name = Kt), U(Ut) && (pr.attributes["aria-required"] = !0, pr.attributes.required = !0), C.HTMLResult.success({
                  name: "label",
                  attributes: {
                    class: ["xfaLabel"]
                  },
                  children: [pr]
                });
              }
            }
            class Ce extends m.XFAObject {
              constructor(oe) {
                super(I, "choiceList", !0), this.commitOn = (0, C.getStringOption)(oe.commitOn, ["select", "exit"]), this.id = oe.id || "", this.open = (0, C.getStringOption)(oe.open, ["userControl", "always", "multiSelect", "onEntry"]), this.textEntry = (0, C.getInteger)({
                  data: oe.textEntry,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.border = null, this.extras = null, this.margin = null;
              }
              [g.$toHTML](oe) {
                const Ie = (0, f.toStyle)(this, "border", "margin"), At = this[g.$getParent]()[g.$getParent](), Kt = {
                  fontSize: `calc(${At.font?.size || 10}px * var(--scale-factor))`
                }, Ut = [];
                if (At.items.children.length > 0) {
                  const cr = At.items;
                  let xr = 0, Pr = 0;
                  cr.children.length === 2 && (xr = cr.children[0].save, Pr = 1 - xr);
                  const Sr = cr.children[xr][g.$toHTML]().html, Or = cr.children[Pr][g.$toHTML]().html;
                  let Dr = !1;
                  const pr = At.value?.[g.$text]() || "";
                  for (let Hr = 0, fr = Sr.length; Hr < fr; Hr++) {
                    const yr = {
                      name: "option",
                      attributes: {
                        value: Or[Hr] || Sr[Hr],
                        style: Kt
                      },
                      value: Sr[Hr]
                    };
                    Or[Hr] === pr && (yr.attributes.selected = Dr = !0), Ut.push(yr);
                  }
                  Dr || Ut.splice(0, 0, {
                    name: "option",
                    attributes: {
                      hidden: !0,
                      selected: !0
                    },
                    value: " "
                  });
                }
                const er = {
                  class: ["xfaSelect"],
                  fieldId: At[g.$uid],
                  dataId: At[g.$data]?.[g.$uid] || At[g.$uid],
                  style: Ie,
                  "aria-label": P(At),
                  "aria-required": !1
                };
                return U(At) && (er["aria-required"] = !0, er.required = !0), this.open === "multiSelect" && (er.multiple = !0), C.HTMLResult.success({
                  name: "label",
                  attributes: {
                    class: ["xfaLabel"]
                  },
                  children: [{
                    name: "select",
                    children: Ut,
                    attributes: er
                  }]
                });
              }
            }
            class xe extends m.XFAObject {
              constructor(oe) {
                super(I, "color", !0), this.cSpace = (0, C.getStringOption)(oe.cSpace, ["SRGB"]), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.value = oe.value ? (0, C.getColor)(oe.value) : "", this.extras = null;
              }
              [g.$hasSettableValue]() {
                return !1;
              }
              [g.$toStyle]() {
                return this.value ? w.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
              }
            }
            class we extends m.XFAObject {
              constructor(oe) {
                super(I, "comb"), this.id = oe.id || "", this.numberOfCells = (0, C.getInteger)({
                  data: oe.numberOfCells,
                  defaultValue: 0,
                  validate: (Ie) => Ie >= 0
                }), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class $e extends m.XFAObject {
              constructor(oe) {
                super(I, "connect", !0), this.connection = oe.connection || "", this.id = oe.id || "", this.ref = oe.ref || "", this.usage = (0, C.getStringOption)(oe.usage, ["exportAndImport", "exportOnly", "importOnly"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.picture = null;
              }
            }
            class Ae extends m.XFAObject {
              constructor(oe) {
                super(I, "contentArea", !0), this.h = (0, C.getMeasurement)(oe.h), this.id = oe.id || "", this.name = oe.name || "", this.relevant = (0, C.getRelevant)(oe.relevant), this.use = oe.use || "", this.usehref = oe.usehref || "", this.w = (0, C.getMeasurement)(oe.w), this.x = (0, C.getMeasurement)(oe.x, "0pt"), this.y = (0, C.getMeasurement)(oe.y, "0pt"), this.desc = null, this.extras = null;
              }
              [g.$toHTML](oe) {
                const Ie = (0, f.measureToString)(this.x), lt = (0, f.measureToString)(this.y), At = {
                  left: Ie,
                  top: lt,
                  width: (0, f.measureToString)(this.w),
                  height: (0, f.measureToString)(this.h)
                }, Bt = ["xfaContentarea"];
                return (0, f.isPrintOnly)(this) && Bt.push("xfaPrintOnly"), C.HTMLResult.success({
                  name: "div",
                  children: [],
                  attributes: {
                    style: At,
                    class: Bt,
                    id: this[g.$uid]
                  }
                });
              }
            }
            class ue extends m.XFAObject {
              constructor(oe) {
                super(I, "corner", !0), this.id = oe.id || "", this.inverted = (0, C.getInteger)({
                  data: oe.inverted,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.join = (0, C.getStringOption)(oe.join, ["square", "round"]), this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.radius = (0, C.getMeasurement)(oe.radius), this.stroke = (0, C.getStringOption)(oe.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, C.getMeasurement)(oe.thickness, "0.5pt"), this.use = oe.use || "", this.usehref = oe.usehref || "", this.color = null, this.extras = null;
              }
              [g.$toStyle]() {
                const oe = (0, f.toStyle)(this, "visibility");
                return oe.radius = (0, f.measureToString)(this.join === "square" ? 0 : this.radius), oe;
              }
            }
            class ce extends m.ContentObject {
              constructor(oe) {
                super(I, "date"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$finalize]() {
                const oe = this[g.$content].trim();
                this[g.$content] = oe ? new Date(oe) : null;
              }
              [g.$toHTML](oe) {
                return D(this[g.$content] ? this[g.$content].toString() : "");
              }
            }
            class Ee extends m.ContentObject {
              constructor(oe) {
                super(I, "dateTime"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$finalize]() {
                const oe = this[g.$content].trim();
                this[g.$content] = oe ? new Date(oe) : null;
              }
              [g.$toHTML](oe) {
                return D(this[g.$content] ? this[g.$content].toString() : "");
              }
            }
            class _e extends m.XFAObject {
              constructor(oe) {
                super(I, "dateTimeEdit", !0), this.hScrollPolicy = (0, C.getStringOption)(oe.hScrollPolicy, ["auto", "off", "on"]), this.id = oe.id || "", this.picker = (0, C.getStringOption)(oe.picker, ["host", "none"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
              }
              [g.$toHTML](oe) {
                const Ie = (0, f.toStyle)(this, "border", "font", "margin"), lt = this[g.$getParent]()[g.$getParent](), At = {
                  name: "input",
                  attributes: {
                    type: "text",
                    fieldId: lt[g.$uid],
                    dataId: lt[g.$data]?.[g.$uid] || lt[g.$uid],
                    class: ["xfaTextfield"],
                    style: Ie,
                    "aria-label": P(lt),
                    "aria-required": !1
                  }
                };
                return U(lt) && (At.attributes["aria-required"] = !0, At.attributes.required = !0), C.HTMLResult.success({
                  name: "label",
                  attributes: {
                    class: ["xfaLabel"]
                  },
                  children: [At]
                });
              }
            }
            class Te extends m.ContentObject {
              constructor(oe) {
                super(I, "decimal"), this.fracDigits = (0, C.getInteger)({
                  data: oe.fracDigits,
                  defaultValue: 2,
                  validate: (Ie) => !0
                }), this.id = oe.id || "", this.leadDigits = (0, C.getInteger)({
                  data: oe.leadDigits,
                  defaultValue: -1,
                  validate: (Ie) => !0
                }), this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$finalize]() {
                const oe = parseFloat(this[g.$content].trim());
                this[g.$content] = isNaN(oe) ? null : oe;
              }
              [g.$toHTML](oe) {
                return D(this[g.$content] !== null ? this[g.$content].toString() : "");
              }
            }
            class ke extends m.XFAObject {
              constructor(oe) {
                super(I, "defaultUi", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null;
              }
            }
            class Re extends m.XFAObject {
              constructor(oe) {
                super(I, "desc", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.boolean = new m.XFAObjectArray(), this.date = new m.XFAObjectArray(), this.dateTime = new m.XFAObjectArray(), this.decimal = new m.XFAObjectArray(), this.exData = new m.XFAObjectArray(), this.float = new m.XFAObjectArray(), this.image = new m.XFAObjectArray(), this.integer = new m.XFAObjectArray(), this.text = new m.XFAObjectArray(), this.time = new m.XFAObjectArray();
              }
            }
            class Be extends m.OptionObject {
              constructor(oe) {
                super(I, "digestMethod", ["", "SHA1", "SHA256", "SHA512", "RIPEMD160"]), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class Oe extends m.XFAObject {
              constructor(oe) {
                super(I, "digestMethods", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.digestMethod = new m.XFAObjectArray();
              }
            }
            class Me extends m.XFAObject {
              constructor(oe) {
                super(I, "draw", !0), this.anchorType = (0, C.getStringOption)(oe.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, C.getInteger)({
                  data: oe.colSpan,
                  defaultValue: 1,
                  validate: (Ie) => Ie >= 1 || Ie === -1
                }), this.h = oe.h ? (0, C.getMeasurement)(oe.h) : "", this.hAlign = (0, C.getStringOption)(oe.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = oe.id || "", this.locale = oe.locale || "", this.maxH = (0, C.getMeasurement)(oe.maxH, "0pt"), this.maxW = (0, C.getMeasurement)(oe.maxW, "0pt"), this.minH = (0, C.getMeasurement)(oe.minH, "0pt"), this.minW = (0, C.getMeasurement)(oe.minW, "0pt"), this.name = oe.name || "", this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, C.getRelevant)(oe.relevant), this.rotate = (0, C.getInteger)({
                  data: oe.rotate,
                  defaultValue: 0,
                  validate: (Ie) => Ie % 90 === 0
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.w = oe.w ? (0, C.getMeasurement)(oe.w) : "", this.x = (0, C.getMeasurement)(oe.x, "0pt"), this.y = (0, C.getMeasurement)(oe.y, "0pt"), this.assist = null, this.border = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.value = null, this.setProperty = new m.XFAObjectArray();
              }
              [g.$setValue](oe) {
                j(this, oe);
              }
              [g.$toHTML](oe) {
                if (k(this), this.presence === "hidden" || this.presence === "inactive")
                  return C.HTMLResult.EMPTY;
                (0, f.fixDimensions)(this), this[g.$pushPara]();
                const Ie = this.w, lt = this.h, {
                  w: At,
                  h: Bt,
                  isBroken: Kt
                } = (0, f.layoutNode)(this, oe);
                if (At && this.w === "") {
                  if (Kt && this[g.$getSubformParent]()[g.$isThereMoreWidth]())
                    return this[g.$popPara](), C.HTMLResult.FAILURE;
                  this.w = At;
                }
                if (Bt && this.h === "" && (this.h = Bt), H(this), !(0, y.checkDimensions)(this, oe))
                  return this.w = Ie, this.h = lt, this[g.$popPara](), C.HTMLResult.FAILURE;
                V(this);
                const Ut = (0, f.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
                (0, f.setMinMaxDimensions)(this, Ut), Ut.margin && (Ut.padding = Ut.margin, delete Ut.margin);
                const er = ["xfaDraw"];
                this.font && er.push("xfaFont"), (0, f.isPrintOnly)(this) && er.push("xfaPrintOnly");
                const cr = {
                  style: Ut,
                  id: this[g.$uid],
                  class: er
                };
                this.name && (cr.xfaName = this.name);
                const xr = {
                  name: "div",
                  attributes: cr,
                  children: []
                };
                N(this, cr);
                const Pr = (0, f.computeBbox)(this, xr, oe), Sr = this.value ? this.value[g.$toHTML](oe).html : null;
                return Sr === null ? (this.w = Ie, this.h = lt, this[g.$popPara](), C.HTMLResult.success((0, f.createWrapper)(this, xr), Pr)) : (xr.children.push(Sr), (0, f.setPara)(this, Ut, Sr), this.w = Ie, this.h = lt, this[g.$popPara](), C.HTMLResult.success((0, f.createWrapper)(this, xr), Pr));
              }
            }
            class Fe extends m.XFAObject {
              constructor(oe) {
                super(I, "edge", !0), this.cap = (0, C.getStringOption)(oe.cap, ["square", "butt", "round"]), this.id = oe.id || "", this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.stroke = (0, C.getStringOption)(oe.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, C.getMeasurement)(oe.thickness, "0.5pt"), this.use = oe.use || "", this.usehref = oe.usehref || "", this.color = null, this.extras = null;
              }
              [g.$toStyle]() {
                const oe = (0, f.toStyle)(this, "visibility");
                if (Object.assign(oe, {
                  linecap: this.cap,
                  width: (0, f.measureToString)(this.thickness),
                  color: this.color ? this.color[g.$toStyle]() : "#000000",
                  style: ""
                }), this.presence !== "visible")
                  oe.style = "none";
                else
                  switch (this.stroke) {
                    case "solid":
                      oe.style = "solid";
                      break;
                    case "dashDot":
                      oe.style = "dashed";
                      break;
                    case "dashDotDot":
                      oe.style = "dashed";
                      break;
                    case "dashed":
                      oe.style = "dashed";
                      break;
                    case "dotted":
                      oe.style = "dotted";
                      break;
                    case "embossed":
                      oe.style = "ridge";
                      break;
                    case "etched":
                      oe.style = "groove";
                      break;
                    case "lowered":
                      oe.style = "inset";
                      break;
                    case "raised":
                      oe.style = "outset";
                      break;
                  }
                return oe;
              }
            }
            class Ue extends m.OptionObject {
              constructor(oe) {
                super(I, "encoding", ["adbe.x509.rsa_sha1", "adbe.pkcs7.detached", "adbe.pkcs7.sha1"]), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class je extends m.XFAObject {
              constructor(oe) {
                super(I, "encodings", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.encoding = new m.XFAObjectArray();
              }
            }
            class Le extends m.XFAObject {
              constructor(oe) {
                super(I, "encrypt", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.certificate = null;
              }
            }
            class De extends m.XFAObject {
              constructor(oe) {
                super(I, "encryptData", !0), this.id = oe.id || "", this.operation = (0, C.getStringOption)(oe.operation, ["encrypt", "decrypt"]), this.target = oe.target || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.filter = null, this.manifest = null;
              }
            }
            class Ne extends m.XFAObject {
              constructor(oe) {
                super(I, "encryption", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.certificate = new m.XFAObjectArray();
              }
            }
            class Ge extends m.OptionObject {
              constructor(oe) {
                super(I, "encryptionMethod", ["", "AES256-CBC", "TRIPLEDES-CBC", "AES128-CBC", "AES192-CBC"]), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class Xe extends m.XFAObject {
              constructor(oe) {
                super(I, "encryptionMethods", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.encryptionMethod = new m.XFAObjectArray();
              }
            }
            class nt extends m.XFAObject {
              constructor(oe) {
                super(I, "event", !0), this.activity = (0, C.getStringOption)(oe.activity, ["click", "change", "docClose", "docReady", "enter", "exit", "full", "indexChange", "initialize", "mouseDown", "mouseEnter", "mouseExit", "mouseUp", "postExecute", "postOpen", "postPrint", "postSave", "postSign", "postSubmit", "preExecute", "preOpen", "prePrint", "preSave", "preSign", "preSubmit", "ready", "validationState"]), this.id = oe.id || "", this.listen = (0, C.getStringOption)(oe.listen, ["refOnly", "refAndDescendents"]), this.name = oe.name || "", this.ref = oe.ref || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.encryptData = null, this.execute = null, this.script = null, this.signData = null, this.submit = null;
              }
            }
            class ct extends m.ContentObject {
              constructor(oe) {
                super(I, "exData"), this.contentType = oe.contentType || "", this.href = oe.href || "", this.id = oe.id || "", this.maxLength = (0, C.getInteger)({
                  data: oe.maxLength,
                  defaultValue: -1,
                  validate: (Ie) => Ie >= -1
                }), this.name = oe.name || "", this.rid = oe.rid || "", this.transferEncoding = (0, C.getStringOption)(oe.transferEncoding, ["none", "base64", "package"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$isCDATAXml]() {
                return this.contentType === "text/html";
              }
              [g.$onChild](oe) {
                return this.contentType === "text/html" && oe[g.$namespaceId] === b.NamespaceIds.xhtml.id ? (this[g.$content] = oe, !0) : this.contentType === "text/xml" ? (this[g.$content] = oe, !0) : !1;
              }
              [g.$toHTML](oe) {
                return this.contentType !== "text/html" || !this[g.$content] ? C.HTMLResult.EMPTY : this[g.$content][g.$toHTML](oe);
              }
            }
            class it extends m.XFAObject {
              constructor(oe) {
                super(I, "exObject", !0), this.archive = oe.archive || "", this.classId = oe.classId || "", this.codeBase = oe.codeBase || "", this.codeType = oe.codeType || "", this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.boolean = new m.XFAObjectArray(), this.date = new m.XFAObjectArray(), this.dateTime = new m.XFAObjectArray(), this.decimal = new m.XFAObjectArray(), this.exData = new m.XFAObjectArray(), this.exObject = new m.XFAObjectArray(), this.float = new m.XFAObjectArray(), this.image = new m.XFAObjectArray(), this.integer = new m.XFAObjectArray(), this.text = new m.XFAObjectArray(), this.time = new m.XFAObjectArray();
              }
            }
            class We extends m.XFAObject {
              constructor(oe) {
                super(I, "exclGroup", !0), this.access = (0, C.getStringOption)(oe.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = oe.accessKey || "", this.anchorType = (0, C.getStringOption)(oe.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, C.getInteger)({
                  data: oe.colSpan,
                  defaultValue: 1,
                  validate: (Ie) => Ie >= 1 || Ie === -1
                }), this.h = oe.h ? (0, C.getMeasurement)(oe.h) : "", this.hAlign = (0, C.getStringOption)(oe.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = oe.id || "", this.layout = (0, C.getStringOption)(oe.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.maxH = (0, C.getMeasurement)(oe.maxH, "0pt"), this.maxW = (0, C.getMeasurement)(oe.maxW, "0pt"), this.minH = (0, C.getMeasurement)(oe.minH, "0pt"), this.minW = (0, C.getMeasurement)(oe.minW, "0pt"), this.name = oe.name || "", this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, C.getRelevant)(oe.relevant), this.use = oe.use || "", this.usehref = oe.usehref || "", this.w = oe.w ? (0, C.getMeasurement)(oe.w) : "", this.x = (0, C.getMeasurement)(oe.x, "0pt"), this.y = (0, C.getMeasurement)(oe.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.margin = null, this.para = null, this.traversal = null, this.validate = null, this.connect = new m.XFAObjectArray(), this.event = new m.XFAObjectArray(), this.field = new m.XFAObjectArray(), this.setProperty = new m.XFAObjectArray();
              }
              [g.$isBindable]() {
                return !0;
              }
              [g.$hasSettableValue]() {
                return !0;
              }
              [g.$setValue](oe) {
                for (const Ie of this.field.children) {
                  if (!Ie.value) {
                    const lt = new Tr({});
                    Ie[g.$appendChild](lt), Ie.value = lt;
                  }
                  Ie.value[g.$setValue](oe);
                }
              }
              [g.$isThereMoreWidth]() {
                return this.layout.endsWith("-tb") && this[g.$extra].attempt === 0 && this[g.$extra].numberInLine > 0 || this[g.$getParent]()[g.$isThereMoreWidth]();
              }
              [g.$isSplittable]() {
                const oe = this[g.$getSubformParent]();
                return oe[g.$isSplittable]() ? this[g.$extra]._isSplittable !== void 0 ? this[g.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[g.$extra]._isSplittable = !1, !1) : oe.layout?.endsWith("-tb") && oe[g.$extra].numberInLine !== 0 ? !1 : (this[g.$extra]._isSplittable = !0, !0) : !1;
              }
              [g.$flushHTML]() {
                return (0, y.flushHTML)(this);
              }
              [g.$addHTML](oe, Ie) {
                (0, y.addHTML)(this, oe, Ie);
              }
              [g.$getAvailableSpace]() {
                return (0, y.getAvailableSpace)(this);
              }
              [g.$toHTML](oe) {
                if (k(this), this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0)
                  return C.HTMLResult.EMPTY;
                (0, f.fixDimensions)(this);
                const Ie = [], lt = {
                  id: this[g.$uid],
                  class: []
                };
                (0, f.setAccess)(this, lt.class), this[g.$extra] || (this[g.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[g.$extra], {
                  children: Ie,
                  attributes: lt,
                  attempt: 0,
                  line: null,
                  numberInLine: 0,
                  availableSpace: {
                    width: Math.min(this.w || 1 / 0, oe.width),
                    height: Math.min(this.h || 1 / 0, oe.height)
                  },
                  width: 0,
                  height: 0,
                  prevHeight: 0,
                  currentWidth: 0
                });
                const At = this[g.$isSplittable]();
                if (At || H(this), !(0, y.checkDimensions)(this, oe))
                  return C.HTMLResult.FAILURE;
                const Bt = /* @__PURE__ */ new Set(["field"]);
                if (this.layout.includes("row")) {
                  const fr = this[g.$getSubformParent]().columnWidths;
                  Array.isArray(fr) && fr.length > 0 && (this[g.$extra].columnWidths = fr, this[g.$extra].currentColumn = 0);
                }
                const Kt = (0, f.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), Ut = ["xfaExclgroup"], er = (0, f.layoutClass)(this);
                er && Ut.push(er), (0, f.isPrintOnly)(this) && Ut.push("xfaPrintOnly"), lt.style = Kt, lt.class = Ut, this.name && (lt.xfaName = this.name), this[g.$pushPara]();
                const cr = this.layout === "lr-tb" || this.layout === "rl-tb", xr = cr ? E : 1;
                for (; this[g.$extra].attempt < xr; this[g.$extra].attempt++) {
                  cr && this[g.$extra].attempt === E - 1 && (this[g.$extra].numberInLine = 0);
                  const fr = this[g.$childrenToHTML]({
                    filter: Bt,
                    include: !0
                  });
                  if (fr.success)
                    break;
                  if (fr.isBreak())
                    return this[g.$popPara](), fr;
                  if (cr && this[g.$extra].attempt === 0 && this[g.$extra].numberInLine === 0 && !this[g.$getTemplateRoot]()[g.$extra].noLayoutFailure) {
                    this[g.$extra].attempt = xr;
                    break;
                  }
                }
                if (this[g.$popPara](), At || V(this), this[g.$extra].attempt === xr)
                  return At || delete this[g.$extra], C.HTMLResult.FAILURE;
                let Pr = 0, Sr = 0;
                this.margin && (Pr = this.margin.leftInset + this.margin.rightInset, Sr = this.margin.topInset + this.margin.bottomInset);
                const Or = Math.max(this[g.$extra].width + Pr, this.w || 0), Dr = Math.max(this[g.$extra].height + Sr, this.h || 0), pr = [this.x, this.y, Or, Dr];
                this.w === "" && (Kt.width = (0, f.measureToString)(Or)), this.h === "" && (Kt.height = (0, f.measureToString)(Dr));
                const Hr = {
                  name: "div",
                  attributes: lt,
                  children: Ie
                };
                return N(this, lt), delete this[g.$extra], C.HTMLResult.success((0, f.createWrapper)(this, Hr), pr);
              }
            }
            class Ve extends m.XFAObject {
              constructor(oe) {
                super(I, "execute"), this.connection = oe.connection || "", this.executeType = (0, C.getStringOption)(oe.executeType, ["import", "remerge"]), this.id = oe.id || "", this.runAt = (0, C.getStringOption)(oe.runAt, ["client", "both", "server"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class ut extends m.XFAObject {
              constructor(oe) {
                super(I, "extras", !0), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.boolean = new m.XFAObjectArray(), this.date = new m.XFAObjectArray(), this.dateTime = new m.XFAObjectArray(), this.decimal = new m.XFAObjectArray(), this.exData = new m.XFAObjectArray(), this.extras = new m.XFAObjectArray(), this.float = new m.XFAObjectArray(), this.image = new m.XFAObjectArray(), this.integer = new m.XFAObjectArray(), this.text = new m.XFAObjectArray(), this.time = new m.XFAObjectArray();
              }
            }
            class at extends m.XFAObject {
              constructor(oe) {
                super(I, "field", !0), this.access = (0, C.getStringOption)(oe.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = oe.accessKey || "", this.anchorType = (0, C.getStringOption)(oe.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, C.getInteger)({
                  data: oe.colSpan,
                  defaultValue: 1,
                  validate: (Ie) => Ie >= 1 || Ie === -1
                }), this.h = oe.h ? (0, C.getMeasurement)(oe.h) : "", this.hAlign = (0, C.getStringOption)(oe.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = oe.id || "", this.locale = oe.locale || "", this.maxH = (0, C.getMeasurement)(oe.maxH, "0pt"), this.maxW = (0, C.getMeasurement)(oe.maxW, "0pt"), this.minH = (0, C.getMeasurement)(oe.minH, "0pt"), this.minW = (0, C.getMeasurement)(oe.minW, "0pt"), this.name = oe.name || "", this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, C.getRelevant)(oe.relevant), this.rotate = (0, C.getInteger)({
                  data: oe.rotate,
                  defaultValue: 0,
                  validate: (Ie) => Ie % 90 === 0
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.w = oe.w ? (0, C.getMeasurement)(oe.w) : "", this.x = (0, C.getMeasurement)(oe.x, "0pt"), this.y = (0, C.getMeasurement)(oe.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.format = null, this.items = new m.XFAObjectArray(2), this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.validate = null, this.value = null, this.bindItems = new m.XFAObjectArray(), this.connect = new m.XFAObjectArray(), this.event = new m.XFAObjectArray(), this.setProperty = new m.XFAObjectArray();
              }
              [g.$isBindable]() {
                return !0;
              }
              [g.$setValue](oe) {
                j(this, oe);
              }
              [g.$toHTML](oe) {
                if (k(this), !this.ui) {
                  this.ui = new Xt({}), this.ui[g.$globalData] = this[g.$globalData], this[g.$appendChild](this.ui);
                  let fr;
                  switch (this.items.children.length) {
                    case 0:
                      fr = new Fr({}), this.ui.textEdit = fr;
                      break;
                    case 1:
                      fr = new ye({}), this.ui.checkButton = fr;
                      break;
                    case 2:
                      fr = new Ce({}), this.ui.choiceList = fr;
                      break;
                  }
                  this.ui[g.$appendChild](fr);
                }
                if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0)
                  return C.HTMLResult.EMPTY;
                this.caption && delete this.caption[g.$extra], this[g.$pushPara]();
                const Ie = this.caption ? this.caption[g.$toHTML](oe).html : null, lt = this.w, At = this.h;
                let Bt = 0, Kt = 0;
                this.margin && (Bt = this.margin.leftInset + this.margin.rightInset, Kt = this.margin.topInset + this.margin.bottomInset);
                let Ut = null;
                if (this.w === "" || this.h === "") {
                  let fr = null, yr = null, qr = 0, mr = 0;
                  if (this.ui.checkButton)
                    qr = mr = this.ui.checkButton.size;
                  else {
                    const {
                      w: Kr,
                      h: nn
                    } = (0, f.layoutNode)(this, oe);
                    Kr !== null ? (qr = Kr, mr = nn) : mr = (0, S.getMetrics)(this.font, !0).lineNoGap;
                  }
                  if (Ut = M(this.ui[g.$getExtra]()), qr += Ut.w, mr += Ut.h, this.caption) {
                    const {
                      w: Kr,
                      h: nn,
                      isBroken: Vr
                    } = this.caption[g.$getExtra](oe);
                    if (Vr && this[g.$getSubformParent]()[g.$isThereMoreWidth]())
                      return this[g.$popPara](), C.HTMLResult.FAILURE;
                    switch (fr = Kr, yr = nn, this.caption.placement) {
                      case "left":
                      case "right":
                      case "inline":
                        fr += qr;
                        break;
                      case "top":
                      case "bottom":
                        yr += mr;
                        break;
                    }
                  } else
                    fr = qr, yr = mr;
                  fr && this.w === "" && (fr += Bt, this.w = Math.min(this.maxW <= 0 ? 1 / 0 : this.maxW, this.minW + 1 < fr ? fr : this.minW)), yr && this.h === "" && (yr += Kt, this.h = Math.min(this.maxH <= 0 ? 1 / 0 : this.maxH, this.minH + 1 < yr ? yr : this.minH));
                }
                if (this[g.$popPara](), (0, f.fixDimensions)(this), H(this), !(0, y.checkDimensions)(this, oe))
                  return this.w = lt, this.h = At, this[g.$popPara](), C.HTMLResult.FAILURE;
                V(this);
                const er = (0, f.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
                (0, f.setMinMaxDimensions)(this, er);
                const cr = ["xfaField"];
                this.font && cr.push("xfaFont"), (0, f.isPrintOnly)(this) && cr.push("xfaPrintOnly");
                const xr = {
                  style: er,
                  id: this[g.$uid],
                  class: cr
                };
                er.margin && (er.padding = er.margin, delete er.margin), (0, f.setAccess)(this, cr), this.name && (xr.xfaName = this.name);
                const Pr = [], Sr = {
                  name: "div",
                  attributes: xr,
                  children: Pr
                };
                N(this, xr);
                const Or = this.border ? this.border[g.$toStyle]() : null, Dr = (0, f.computeBbox)(this, Sr, oe), pr = this.ui[g.$toHTML]().html;
                if (!pr)
                  return Object.assign(er, Or), C.HTMLResult.success((0, f.createWrapper)(this, Sr), Dr);
                this[g.$tabIndex] && (pr.children?.[0] ? pr.children[0].attributes.tabindex = this[g.$tabIndex] : pr.attributes.tabindex = this[g.$tabIndex]), pr.attributes.style || (pr.attributes.style = /* @__PURE__ */ Object.create(null));
                let Hr = null;
                if (this.ui.button ? (pr.children.length === 1 && ([Hr] = pr.children.splice(0, 1)), Object.assign(pr.attributes.style, Or)) : Object.assign(er, Or), Pr.push(pr), this.value) {
                  if (this.ui.imageEdit)
                    pr.children.push(this.value[g.$toHTML]().html);
                  else if (!this.ui.button) {
                    let fr = "";
                    if (this.value.exData)
                      fr = this.value.exData[g.$text]();
                    else if (this.value.text)
                      fr = this.value.text[g.$getExtra]();
                    else {
                      const yr = this.value[g.$toHTML]().html;
                      yr !== null && (fr = yr.children[0].value);
                    }
                    this.ui.textEdit && this.value.text?.maxChars && (pr.children[0].attributes.maxLength = this.value.text.maxChars), fr && (this.ui.numericEdit && (fr = parseFloat(fr), fr = isNaN(fr) ? "" : fr.toString()), pr.children[0].name === "textarea" ? pr.children[0].attributes.textContent = fr : pr.children[0].attributes.value = fr);
                  }
                }
                if (!this.ui.imageEdit && pr.children?.[0] && this.h) {
                  Ut = Ut || M(this.ui[g.$getExtra]());
                  let fr = 0;
                  if (this.caption && ["top", "bottom"].includes(this.caption.placement)) {
                    fr = this.caption.reserve, fr <= 0 && (fr = this.caption[g.$getExtra](oe).h);
                    const yr = this.h - fr - Kt - Ut.h;
                    pr.children[0].attributes.style.height = (0, f.measureToString)(yr);
                  } else
                    pr.children[0].attributes.style.height = "100%";
                }
                if (Hr && pr.children.push(Hr), !Ie)
                  return pr.attributes.class && pr.attributes.class.push("xfaLeft"), this.w = lt, this.h = At, C.HTMLResult.success((0, f.createWrapper)(this, Sr), Dr);
                if (this.ui.button)
                  return er.padding && delete er.padding, Ie.name === "div" && (Ie.name = "span"), pr.children.push(Ie), C.HTMLResult.success(Sr, Dr);
                switch (this.ui.checkButton && (Ie.attributes.class[0] = "xfaCaptionForCheckButton"), pr.attributes.class || (pr.attributes.class = []), pr.children.splice(0, 0, Ie), this.caption.placement) {
                  case "left":
                    pr.attributes.class.push("xfaLeft");
                    break;
                  case "right":
                    pr.attributes.class.push("xfaRight");
                    break;
                  case "top":
                    pr.attributes.class.push("xfaTop");
                    break;
                  case "bottom":
                    pr.attributes.class.push("xfaBottom");
                    break;
                  case "inline":
                    pr.attributes.class.push("xfaLeft");
                    break;
                }
                return this.w = lt, this.h = At, C.HTMLResult.success((0, f.createWrapper)(this, Sr), Dr);
              }
            }
            A.Field = at;
            class Qe extends m.XFAObject {
              constructor(oe) {
                super(I, "fill", !0), this.id = oe.id || "", this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.color = null, this.extras = null, this.linear = null, this.pattern = null, this.radial = null, this.solid = null, this.stipple = null;
              }
              [g.$toStyle]() {
                const oe = this[g.$getParent](), lt = oe[g.$getParent]()[g.$getParent](), At = /* @__PURE__ */ Object.create(null);
                let Bt = "color", Kt = Bt;
                oe instanceof ie && (Bt = "background-color", Kt = "background", lt instanceof Xt && (At.backgroundColor = "white")), (oe instanceof Ht || oe instanceof q) && (Bt = Kt = "fill", At.fill = "white");
                for (const Ut of Object.getOwnPropertyNames(this)) {
                  if (Ut === "extras" || Ut === "color")
                    continue;
                  const er = this[Ut];
                  if (!(er instanceof m.XFAObject))
                    continue;
                  const cr = er[g.$toStyle](this.color);
                  return cr && (At[cr.startsWith("#") ? Bt : Kt] = cr), At;
                }
                if (this.color?.value) {
                  const Ut = this.color[g.$toStyle]();
                  At[Ut.startsWith("#") ? Bt : Kt] = Ut;
                }
                return At;
              }
            }
            class st extends m.XFAObject {
              constructor(oe) {
                super(I, "filter", !0), this.addRevocationInfo = (0, C.getStringOption)(oe.addRevocationInfo, ["", "required", "optional", "none"]), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.version = (0, C.getInteger)({
                  data: this.version,
                  defaultValue: 5,
                  validate: (Ie) => Ie >= 1 && Ie <= 5
                }), this.appearanceFilter = null, this.certificates = null, this.digestMethods = null, this.encodings = null, this.encryptionMethods = null, this.handler = null, this.lockDocument = null, this.mdp = null, this.reasons = null, this.timeStamp = null;
              }
            }
            class ft extends m.ContentObject {
              constructor(oe) {
                super(I, "float"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$finalize]() {
                const oe = parseFloat(this[g.$content].trim());
                this[g.$content] = isNaN(oe) ? null : oe;
              }
              [g.$toHTML](oe) {
                return D(this[g.$content] !== null ? this[g.$content].toString() : "");
              }
            }
            class vt extends m.XFAObject {
              constructor(oe) {
                super(I, "font", !0), this.baselineShift = (0, C.getMeasurement)(oe.baselineShift), this.fontHorizontalScale = (0, C.getFloat)({
                  data: oe.fontHorizontalScale,
                  defaultValue: 100,
                  validate: (Ie) => Ie >= 0
                }), this.fontVerticalScale = (0, C.getFloat)({
                  data: oe.fontVerticalScale,
                  defaultValue: 100,
                  validate: (Ie) => Ie >= 0
                }), this.id = oe.id || "", this.kerningMode = (0, C.getStringOption)(oe.kerningMode, ["none", "pair"]), this.letterSpacing = (0, C.getMeasurement)(oe.letterSpacing, "0"), this.lineThrough = (0, C.getInteger)({
                  data: oe.lineThrough,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1 || Ie === 2
                }), this.lineThroughPeriod = (0, C.getStringOption)(oe.lineThroughPeriod, ["all", "word"]), this.overline = (0, C.getInteger)({
                  data: oe.overline,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1 || Ie === 2
                }), this.overlinePeriod = (0, C.getStringOption)(oe.overlinePeriod, ["all", "word"]), this.posture = (0, C.getStringOption)(oe.posture, ["normal", "italic"]), this.size = (0, C.getMeasurement)(oe.size, "10pt"), this.typeface = oe.typeface || "Courier", this.underline = (0, C.getInteger)({
                  data: oe.underline,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1 || Ie === 2
                }), this.underlinePeriod = (0, C.getStringOption)(oe.underlinePeriod, ["all", "word"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.weight = (0, C.getStringOption)(oe.weight, ["normal", "bold"]), this.extras = null, this.fill = null;
              }
              [g.$clean](oe) {
                super[g.$clean](oe), this[g.$globalData].usedTypefaces.add(this.typeface);
              }
              [g.$toStyle]() {
                const oe = (0, f.toStyle)(this, "fill"), Ie = oe.color;
                return Ie && (Ie === "#000000" ? delete oe.color : Ie.startsWith("#") || (oe.background = Ie, oe.backgroundClip = "text", oe.color = "transparent")), this.baselineShift && (oe.verticalAlign = (0, f.measureToString)(this.baselineShift)), oe.fontKerning = this.kerningMode === "none" ? "none" : "normal", oe.letterSpacing = (0, f.measureToString)(this.letterSpacing), this.lineThrough !== 0 && (oe.textDecoration = "line-through", this.lineThrough === 2 && (oe.textDecorationStyle = "double")), this.overline !== 0 && (oe.textDecoration = "overline", this.overline === 2 && (oe.textDecorationStyle = "double")), oe.fontStyle = this.posture, oe.fontSize = (0, f.measureToString)(0.99 * this.size), (0, f.setFontFamily)(this, this, this[g.$globalData].fontFinder, oe), this.underline !== 0 && (oe.textDecoration = "underline", this.underline === 2 && (oe.textDecorationStyle = "double")), oe.fontWeight = this.weight, oe;
              }
            }
            class Pt extends m.XFAObject {
              constructor(oe) {
                super(I, "format", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.picture = null;
              }
            }
            class dt extends m.StringObject {
              constructor(oe) {
                super(I, "handler"), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class mt extends m.XFAObject {
              constructor(oe) {
                super(I, "hyphenation"), this.excludeAllCaps = (0, C.getInteger)({
                  data: oe.excludeAllCaps,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.excludeInitialCap = (0, C.getInteger)({
                  data: oe.excludeInitialCap,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.hyphenate = (0, C.getInteger)({
                  data: oe.hyphenate,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.id = oe.id || "", this.pushCharacterCount = (0, C.getInteger)({
                  data: oe.pushCharacterCount,
                  defaultValue: 3,
                  validate: (Ie) => Ie >= 0
                }), this.remainCharacterCount = (0, C.getInteger)({
                  data: oe.remainCharacterCount,
                  defaultValue: 3,
                  validate: (Ie) => Ie >= 0
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.wordCharacterCount = (0, C.getInteger)({
                  data: oe.wordCharacterCount,
                  defaultValue: 7,
                  validate: (Ie) => Ie >= 0
                });
              }
            }
            class pt extends m.StringObject {
              constructor(oe) {
                super(I, "image"), this.aspect = (0, C.getStringOption)(oe.aspect, ["fit", "actual", "height", "none", "width"]), this.contentType = oe.contentType || "", this.href = oe.href || "", this.id = oe.id || "", this.name = oe.name || "", this.transferEncoding = (0, C.getStringOption)(oe.transferEncoding, ["base64", "none", "package"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$toHTML]() {
                if (this.contentType && !B.has(this.contentType.toLowerCase()))
                  return C.HTMLResult.EMPTY;
                let oe = this[g.$globalData].images && this[g.$globalData].images.get(this.href);
                if (!oe && (this.href || !this[g.$content]) || (!oe && this.transferEncoding === "base64" && (oe = (0, w.stringToBytes)(atob(this[g.$content]))), !oe))
                  return C.HTMLResult.EMPTY;
                if (!this.contentType) {
                  for (const [Bt, Kt] of F)
                    if (oe.length > Bt.length && Bt.every((Ut, er) => Ut === oe[er])) {
                      this.contentType = Kt;
                      break;
                    }
                  if (!this.contentType)
                    return C.HTMLResult.EMPTY;
                }
                const Ie = new Blob([oe], {
                  type: this.contentType
                });
                let lt;
                switch (this.aspect) {
                  case "fit":
                  case "actual":
                    break;
                  case "height":
                    lt = {
                      height: "100%",
                      objectFit: "fill"
                    };
                    break;
                  case "none":
                    lt = {
                      width: "100%",
                      height: "100%",
                      objectFit: "fill"
                    };
                    break;
                  case "width":
                    lt = {
                      width: "100%",
                      objectFit: "fill"
                    };
                    break;
                }
                const At = this[g.$getParent]();
                return C.HTMLResult.success({
                  name: "img",
                  attributes: {
                    class: ["xfaImage"],
                    style: lt,
                    src: URL.createObjectURL(Ie),
                    alt: At ? P(At[g.$getParent]()) : null
                  }
                });
              }
            }
            class Et extends m.XFAObject {
              constructor(oe) {
                super(I, "imageEdit", !0), this.data = (0, C.getStringOption)(oe.data, ["link", "embed"]), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.border = null, this.extras = null, this.margin = null;
              }
              [g.$toHTML](oe) {
                return this.data === "embed" ? C.HTMLResult.success({
                  name: "div",
                  children: [],
                  attributes: {}
                }) : C.HTMLResult.EMPTY;
              }
            }
            class Mt extends m.ContentObject {
              constructor(oe) {
                super(I, "integer"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$finalize]() {
                const oe = parseInt(this[g.$content].trim(), 10);
                this[g.$content] = isNaN(oe) ? null : oe;
              }
              [g.$toHTML](oe) {
                return D(this[g.$content] !== null ? this[g.$content].toString() : "");
              }
            }
            class Nt extends m.XFAObject {
              constructor(oe) {
                super(I, "issuers", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.certificate = new m.XFAObjectArray();
              }
            }
            class _t extends m.XFAObject {
              constructor(oe) {
                super(I, "items", !0), this.id = oe.id || "", this.name = oe.name || "", this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.ref = oe.ref || "", this.save = (0, C.getInteger)({
                  data: oe.save,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.boolean = new m.XFAObjectArray(), this.date = new m.XFAObjectArray(), this.dateTime = new m.XFAObjectArray(), this.decimal = new m.XFAObjectArray(), this.exData = new m.XFAObjectArray(), this.float = new m.XFAObjectArray(), this.image = new m.XFAObjectArray(), this.integer = new m.XFAObjectArray(), this.text = new m.XFAObjectArray(), this.time = new m.XFAObjectArray();
              }
              [g.$toHTML]() {
                const oe = [];
                for (const Ie of this[g.$getChildren]())
                  oe.push(Ie[g.$text]());
                return C.HTMLResult.success(oe);
              }
            }
            A.Items = _t;
            class Ot extends m.XFAObject {
              constructor(oe) {
                super(I, "keep", !0), this.id = oe.id || "";
                const Ie = ["none", "contentArea", "pageArea"];
                this.intact = (0, C.getStringOption)(oe.intact, Ie), this.next = (0, C.getStringOption)(oe.next, Ie), this.previous = (0, C.getStringOption)(oe.previous, Ie), this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null;
              }
            }
            class rt extends m.XFAObject {
              constructor(oe) {
                super(I, "keyUsage");
                const Ie = ["", "yes", "no"];
                this.crlSign = (0, C.getStringOption)(oe.crlSign, Ie), this.dataEncipherment = (0, C.getStringOption)(oe.dataEncipherment, Ie), this.decipherOnly = (0, C.getStringOption)(oe.decipherOnly, Ie), this.digitalSignature = (0, C.getStringOption)(oe.digitalSignature, Ie), this.encipherOnly = (0, C.getStringOption)(oe.encipherOnly, Ie), this.id = oe.id || "", this.keyAgreement = (0, C.getStringOption)(oe.keyAgreement, Ie), this.keyCertSign = (0, C.getStringOption)(oe.keyCertSign, Ie), this.keyEncipherment = (0, C.getStringOption)(oe.keyEncipherment, Ie), this.nonRepudiation = (0, C.getStringOption)(oe.nonRepudiation, Ie), this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class et extends m.XFAObject {
              constructor(oe) {
                super(I, "line", !0), this.hand = (0, C.getStringOption)(oe.hand, ["even", "left", "right"]), this.id = oe.id || "", this.slope = (0, C.getStringOption)(oe.slope, ["\\", "/"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.edge = null;
              }
              [g.$toHTML]() {
                const oe = this[g.$getParent]()[g.$getParent](), Ie = this.edge || new Fe({}), lt = Ie[g.$toStyle](), At = /* @__PURE__ */ Object.create(null), Bt = Ie.presence === "visible" ? Ie.thickness : 0;
                At.strokeWidth = (0, f.measureToString)(Bt), At.stroke = lt.color;
                let Kt, Ut, er, cr, xr = "100%", Pr = "100%";
                oe.w <= Bt ? ([Kt, Ut, er, cr] = ["50%", 0, "50%", "100%"], xr = At.strokeWidth) : oe.h <= Bt ? ([Kt, Ut, er, cr] = [0, "50%", "100%", "50%"], Pr = At.strokeWidth) : this.slope === "\\" ? [Kt, Ut, er, cr] = [0, 0, "100%", "100%"] : [Kt, Ut, er, cr] = [0, "100%", "100%", 0];
                const Or = {
                  name: "svg",
                  children: [{
                    name: "line",
                    attributes: {
                      xmlns: _,
                      x1: Kt,
                      y1: Ut,
                      x2: er,
                      y2: cr,
                      style: At
                    }
                  }],
                  attributes: {
                    xmlns: _,
                    width: xr,
                    height: Pr,
                    style: {
                      overflow: "visible"
                    }
                  }
                };
                return W(oe) ? C.HTMLResult.success({
                  name: "div",
                  attributes: {
                    style: {
                      display: "inline",
                      width: "100%",
                      height: "100%"
                    }
                  },
                  children: [Or]
                }) : (Or.attributes.style.position = "absolute", C.HTMLResult.success(Or));
              }
            }
            class Ye extends m.XFAObject {
              constructor(oe) {
                super(I, "linear", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["toRight", "toBottom", "toLeft", "toTop"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.color = null, this.extras = null;
              }
              [g.$toStyle](oe) {
                oe = oe ? oe[g.$toStyle]() : "#FFFFFF";
                const Ie = this.type.replace(/([RBLT])/, " $1").toLowerCase(), lt = this.color ? this.color[g.$toStyle]() : "#000000";
                return `linear-gradient(${Ie}, ${oe}, ${lt})`;
              }
            }
            class tt extends m.ContentObject {
              constructor(oe) {
                super(I, "lockDocument"), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$finalize]() {
                this[g.$content] = (0, C.getStringOption)(this[g.$content], ["auto", "0", "1"]);
              }
            }
            class Ke extends m.XFAObject {
              constructor(oe) {
                super(I, "manifest", !0), this.action = (0, C.getStringOption)(oe.action, ["include", "all", "exclude"]), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.ref = new m.XFAObjectArray();
              }
            }
            class qe extends m.XFAObject {
              constructor(oe) {
                super(I, "margin", !0), this.bottomInset = (0, C.getMeasurement)(oe.bottomInset, "0"), this.id = oe.id || "", this.leftInset = (0, C.getMeasurement)(oe.leftInset, "0"), this.rightInset = (0, C.getMeasurement)(oe.rightInset, "0"), this.topInset = (0, C.getMeasurement)(oe.topInset, "0"), this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null;
              }
              [g.$toStyle]() {
                return {
                  margin: (0, f.measureToString)(this.topInset) + " " + (0, f.measureToString)(this.rightInset) + " " + (0, f.measureToString)(this.bottomInset) + " " + (0, f.measureToString)(this.leftInset)
                };
              }
            }
            class ot extends m.XFAObject {
              constructor(oe) {
                super(I, "mdp"), this.id = oe.id || "", this.permissions = (0, C.getInteger)({
                  data: oe.permissions,
                  defaultValue: 2,
                  validate: (Ie) => Ie === 1 || Ie === 3
                }), this.signatureType = (0, C.getStringOption)(oe.signatureType, ["filler", "author"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class Je extends m.XFAObject {
              constructor(oe) {
                super(I, "medium"), this.id = oe.id || "", this.imagingBBox = (0, C.getBBox)(oe.imagingBBox), this.long = (0, C.getMeasurement)(oe.long), this.orientation = (0, C.getStringOption)(oe.orientation, ["portrait", "landscape"]), this.short = (0, C.getMeasurement)(oe.short), this.stock = oe.stock || "", this.trayIn = (0, C.getStringOption)(oe.trayIn, ["auto", "delegate", "pageFront"]), this.trayOut = (0, C.getStringOption)(oe.trayOut, ["auto", "delegate"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class Ct extends m.XFAObject {
              constructor(oe) {
                super(I, "message", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.text = new m.XFAObjectArray();
              }
            }
            class Tt extends m.XFAObject {
              constructor(oe) {
                super(I, "numericEdit", !0), this.hScrollPolicy = (0, C.getStringOption)(oe.hScrollPolicy, ["auto", "off", "on"]), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
              }
              [g.$toHTML](oe) {
                const Ie = (0, f.toStyle)(this, "border", "font", "margin"), lt = this[g.$getParent]()[g.$getParent](), At = {
                  name: "input",
                  attributes: {
                    type: "text",
                    fieldId: lt[g.$uid],
                    dataId: lt[g.$data]?.[g.$uid] || lt[g.$uid],
                    class: ["xfaTextfield"],
                    style: Ie,
                    "aria-label": P(lt),
                    "aria-required": !1
                  }
                };
                return U(lt) && (At.attributes["aria-required"] = !0, At.attributes.required = !0), C.HTMLResult.success({
                  name: "label",
                  attributes: {
                    class: ["xfaLabel"]
                  },
                  children: [At]
                });
              }
            }
            class yt extends m.XFAObject {
              constructor(oe) {
                super(I, "occur", !0), this.id = oe.id || "", this.initial = oe.initial !== "" ? (0, C.getInteger)({
                  data: oe.initial,
                  defaultValue: "",
                  validate: (Ie) => !0
                }) : "", this.max = oe.max !== "" ? (0, C.getInteger)({
                  data: oe.max,
                  defaultValue: 1,
                  validate: (Ie) => !0
                }) : "", this.min = oe.min !== "" ? (0, C.getInteger)({
                  data: oe.min,
                  defaultValue: 1,
                  validate: (Ie) => !0
                }) : "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null;
              }
              [g.$clean]() {
                const oe = this[g.$getParent](), Ie = this.min;
                this.min === "" && (this.min = oe instanceof $t || oe instanceof Lt ? 0 : 1), this.max === "" && (Ie === "" ? this.max = oe instanceof $t || oe instanceof Lt ? -1 : 1 : this.max = this.min), this.max !== -1 && this.max < this.min && (this.max = this.min), this.initial === "" && (this.initial = oe instanceof Nr ? 1 : this.min);
              }
            }
            class bt extends m.StringObject {
              constructor(oe) {
                super(I, "oid"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class It extends m.XFAObject {
              constructor(oe) {
                super(I, "oids", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.oid = new m.XFAObjectArray();
              }
            }
            class kt extends m.XFAObject {
              constructor(oe) {
                super(I, "overflow"), this.id = oe.id || "", this.leader = oe.leader || "", this.target = oe.target || "", this.trailer = oe.trailer || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$getExtra]() {
                if (!this[g.$extra]) {
                  const oe = this[g.$getParent](), Ie = this[g.$getTemplateRoot](), lt = Ie[g.$searchNode](this.target, oe), At = Ie[g.$searchNode](this.leader, oe), Bt = Ie[g.$searchNode](this.trailer, oe);
                  this[g.$extra] = {
                    target: lt?.[0] || null,
                    leader: At?.[0] || null,
                    trailer: Bt?.[0] || null,
                    addLeader: !1,
                    addTrailer: !1
                  };
                }
                return this[g.$extra];
              }
            }
            class $t extends m.XFAObject {
              constructor(oe) {
                super(I, "pageArea", !0), this.blankOrNotBlank = (0, C.getStringOption)(oe.blankOrNotBlank, ["any", "blank", "notBlank"]), this.id = oe.id || "", this.initialNumber = (0, C.getInteger)({
                  data: oe.initialNumber,
                  defaultValue: 1,
                  validate: (Ie) => !0
                }), this.name = oe.name || "", this.numbered = (0, C.getInteger)({
                  data: oe.numbered,
                  defaultValue: 1,
                  validate: (Ie) => !0
                }), this.oddOrEven = (0, C.getStringOption)(oe.oddOrEven, ["any", "even", "odd"]), this.pagePosition = (0, C.getStringOption)(oe.pagePosition, ["any", "first", "last", "only", "rest"]), this.relevant = (0, C.getRelevant)(oe.relevant), this.use = oe.use || "", this.usehref = oe.usehref || "", this.desc = null, this.extras = null, this.medium = null, this.occur = null, this.area = new m.XFAObjectArray(), this.contentArea = new m.XFAObjectArray(), this.draw = new m.XFAObjectArray(), this.exclGroup = new m.XFAObjectArray(), this.field = new m.XFAObjectArray(), this.subform = new m.XFAObjectArray();
              }
              [g.$isUsable]() {
                return this[g.$extra] ? !this.occur || this.occur.max === -1 || this[g.$extra].numberOfUse < this.occur.max : (this[g.$extra] = {
                  numberOfUse: 0
                }, !0);
              }
              [g.$cleanPage]() {
                delete this[g.$extra];
              }
              [g.$getNextPage]() {
                this[g.$extra] || (this[g.$extra] = {
                  numberOfUse: 0
                });
                const oe = this[g.$getParent]();
                return oe.relation === "orderedOccurrence" && this[g.$isUsable]() ? (this[g.$extra].numberOfUse += 1, this) : oe[g.$getNextPage]();
              }
              [g.$getAvailableSpace]() {
                return this[g.$extra].space || {
                  width: 0,
                  height: 0
                };
              }
              [g.$toHTML]() {
                this[g.$extra] || (this[g.$extra] = {
                  numberOfUse: 1
                });
                const oe = [];
                this[g.$extra].children = oe;
                const Ie = /* @__PURE__ */ Object.create(null);
                if (this.medium && this.medium.short && this.medium.long) {
                  if (Ie.width = (0, f.measureToString)(this.medium.short), Ie.height = (0, f.measureToString)(this.medium.long), this[g.$extra].space = {
                    width: this.medium.short,
                    height: this.medium.long
                  }, this.medium.orientation === "landscape") {
                    const lt = Ie.width;
                    Ie.width = Ie.height, Ie.height = lt, this[g.$extra].space = {
                      width: this.medium.long,
                      height: this.medium.short
                    };
                  }
                } else
                  (0, w.warn)("XFA - No medium specified in pageArea: please file a bug.");
                return this[g.$childrenToHTML]({
                  filter: /* @__PURE__ */ new Set(["area", "draw", "field", "subform"]),
                  include: !0
                }), this[g.$childrenToHTML]({
                  filter: /* @__PURE__ */ new Set(["contentArea"]),
                  include: !0
                }), C.HTMLResult.success({
                  name: "div",
                  children: oe,
                  attributes: {
                    class: ["xfaPage"],
                    id: this[g.$uid],
                    style: Ie,
                    xfaName: this.name
                  }
                });
              }
            }
            class Lt extends m.XFAObject {
              constructor(oe) {
                super(I, "pageSet", !0), this.duplexImposition = (0, C.getStringOption)(oe.duplexImposition, ["longEdge", "shortEdge"]), this.id = oe.id || "", this.name = oe.name || "", this.relation = (0, C.getStringOption)(oe.relation, ["orderedOccurrence", "duplexPaginated", "simplexPaginated"]), this.relevant = (0, C.getRelevant)(oe.relevant), this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.occur = null, this.pageArea = new m.XFAObjectArray(), this.pageSet = new m.XFAObjectArray();
              }
              [g.$cleanPage]() {
                for (const oe of this.pageArea.children)
                  oe[g.$cleanPage]();
                for (const oe of this.pageSet.children)
                  oe[g.$cleanPage]();
              }
              [g.$isUsable]() {
                return !this.occur || this.occur.max === -1 || this[g.$extra].numberOfUse < this.occur.max;
              }
              [g.$getNextPage]() {
                if (this[g.$extra] || (this[g.$extra] = {
                  numberOfUse: 1,
                  pageIndex: -1,
                  pageSetIndex: -1
                }), this.relation === "orderedOccurrence") {
                  if (this[g.$extra].pageIndex + 1 < this.pageArea.children.length)
                    return this[g.$extra].pageIndex += 1, this.pageArea.children[this[g.$extra].pageIndex][g.$getNextPage]();
                  if (this[g.$extra].pageSetIndex + 1 < this.pageSet.children.length)
                    return this[g.$extra].pageSetIndex += 1, this.pageSet.children[this[g.$extra].pageSetIndex][g.$getNextPage]();
                  if (this[g.$isUsable]())
                    return this[g.$extra].numberOfUse += 1, this[g.$extra].pageIndex = -1, this[g.$extra].pageSetIndex = -1, this[g.$getNextPage]();
                  const Bt = this[g.$getParent]();
                  return Bt instanceof Lt ? Bt[g.$getNextPage]() : (this[g.$cleanPage](), this[g.$getNextPage]());
                }
                const oe = this[g.$getTemplateRoot]()[g.$extra].pageNumber, Ie = oe % 2 === 0 ? "even" : "odd", lt = oe === 0 ? "first" : "rest";
                let At = this.pageArea.children.find((Bt) => Bt.oddOrEven === Ie && Bt.pagePosition === lt);
                return At || (At = this.pageArea.children.find((Bt) => Bt.oddOrEven === "any" && Bt.pagePosition === lt), At) || (At = this.pageArea.children.find((Bt) => Bt.oddOrEven === "any" && Bt.pagePosition === "any"), At) ? At : this.pageArea.children[0];
              }
            }
            class Ft extends m.XFAObject {
              constructor(oe) {
                super(I, "para", !0), this.hAlign = (0, C.getStringOption)(oe.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = oe.id || "", this.lineHeight = oe.lineHeight ? (0, C.getMeasurement)(oe.lineHeight, "0pt") : "", this.marginLeft = oe.marginLeft ? (0, C.getMeasurement)(oe.marginLeft, "0pt") : "", this.marginRight = oe.marginRight ? (0, C.getMeasurement)(oe.marginRight, "0pt") : "", this.orphans = (0, C.getInteger)({
                  data: oe.orphans,
                  defaultValue: 0,
                  validate: (Ie) => Ie >= 0
                }), this.preserve = oe.preserve || "", this.radixOffset = oe.radixOffset ? (0, C.getMeasurement)(oe.radixOffset, "0pt") : "", this.spaceAbove = oe.spaceAbove ? (0, C.getMeasurement)(oe.spaceAbove, "0pt") : "", this.spaceBelow = oe.spaceBelow ? (0, C.getMeasurement)(oe.spaceBelow, "0pt") : "", this.tabDefault = oe.tabDefault ? (0, C.getMeasurement)(this.tabDefault) : "", this.tabStops = (oe.tabStops || "").trim().split(/\s+/).map((Ie, lt) => lt % 2 === 1 ? (0, C.getMeasurement)(Ie) : Ie), this.textIndent = oe.textIndent ? (0, C.getMeasurement)(oe.textIndent, "0pt") : "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.vAlign = (0, C.getStringOption)(oe.vAlign, ["top", "bottom", "middle"]), this.widows = (0, C.getInteger)({
                  data: oe.widows,
                  defaultValue: 0,
                  validate: (Ie) => Ie >= 0
                }), this.hyphenation = null;
              }
              [g.$toStyle]() {
                const oe = (0, f.toStyle)(this, "hAlign");
                return this.marginLeft !== "" && (oe.paddingLeft = (0, f.measureToString)(this.marginLeft)), this.marginRight !== "" && (oe.paddingight = (0, f.measureToString)(this.marginRight)), this.spaceAbove !== "" && (oe.paddingTop = (0, f.measureToString)(this.spaceAbove)), this.spaceBelow !== "" && (oe.paddingBottom = (0, f.measureToString)(this.spaceBelow)), this.textIndent !== "" && (oe.textIndent = (0, f.measureToString)(this.textIndent), (0, f.fixTextIndent)(oe)), this.lineHeight > 0 && (oe.lineHeight = (0, f.measureToString)(this.lineHeight)), this.tabDefault !== "" && (oe.tabSize = (0, f.measureToString)(this.tabDefault)), this.tabStops.length > 0, this.hyphenatation && Object.assign(oe, this.hyphenatation[g.$toStyle]()), oe;
              }
            }
            class Vt extends m.XFAObject {
              constructor(oe) {
                super(I, "passwordEdit", !0), this.hScrollPolicy = (0, C.getStringOption)(oe.hScrollPolicy, ["auto", "off", "on"]), this.id = oe.id || "", this.passwordChar = oe.passwordChar || "*", this.use = oe.use || "", this.usehref = oe.usehref || "", this.border = null, this.extras = null, this.margin = null;
              }
            }
            class rr extends m.XFAObject {
              constructor(oe) {
                super(I, "pattern", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["crossHatch", "crossDiagonal", "diagonalLeft", "diagonalRight", "horizontal", "vertical"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.color = null, this.extras = null;
              }
              [g.$toStyle](oe) {
                oe = oe ? oe[g.$toStyle]() : "#FFFFFF";
                const Ie = this.color ? this.color[g.$toStyle]() : "#000000", lt = 5, At = "repeating-linear-gradient", Bt = `${oe},${oe} ${lt}px,${Ie} ${lt}px,${Ie} ${2 * lt}px`;
                switch (this.type) {
                  case "crossHatch":
                    return `${At}(to top,${Bt}) ${At}(to right,${Bt})`;
                  case "crossDiagonal":
                    return `${At}(45deg,${Bt}) ${At}(-45deg,${Bt})`;
                  case "diagonalLeft":
                    return `${At}(45deg,${Bt})`;
                  case "diagonalRight":
                    return `${At}(-45deg,${Bt})`;
                  case "horizontal":
                    return `${At}(to top,${Bt})`;
                  case "vertical":
                    return `${At}(to right,${Bt})`;
                }
                return "";
              }
            }
            class br extends m.StringObject {
              constructor(oe) {
                super(I, "picture"), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class Gt extends m.XFAObject {
              constructor(oe) {
                super(I, "proto", !0), this.appearanceFilter = new m.XFAObjectArray(), this.arc = new m.XFAObjectArray(), this.area = new m.XFAObjectArray(), this.assist = new m.XFAObjectArray(), this.barcode = new m.XFAObjectArray(), this.bindItems = new m.XFAObjectArray(), this.bookend = new m.XFAObjectArray(), this.boolean = new m.XFAObjectArray(), this.border = new m.XFAObjectArray(), this.break = new m.XFAObjectArray(), this.breakAfter = new m.XFAObjectArray(), this.breakBefore = new m.XFAObjectArray(), this.button = new m.XFAObjectArray(), this.calculate = new m.XFAObjectArray(), this.caption = new m.XFAObjectArray(), this.certificate = new m.XFAObjectArray(), this.certificates = new m.XFAObjectArray(), this.checkButton = new m.XFAObjectArray(), this.choiceList = new m.XFAObjectArray(), this.color = new m.XFAObjectArray(), this.comb = new m.XFAObjectArray(), this.connect = new m.XFAObjectArray(), this.contentArea = new m.XFAObjectArray(), this.corner = new m.XFAObjectArray(), this.date = new m.XFAObjectArray(), this.dateTime = new m.XFAObjectArray(), this.dateTimeEdit = new m.XFAObjectArray(), this.decimal = new m.XFAObjectArray(), this.defaultUi = new m.XFAObjectArray(), this.desc = new m.XFAObjectArray(), this.digestMethod = new m.XFAObjectArray(), this.digestMethods = new m.XFAObjectArray(), this.draw = new m.XFAObjectArray(), this.edge = new m.XFAObjectArray(), this.encoding = new m.XFAObjectArray(), this.encodings = new m.XFAObjectArray(), this.encrypt = new m.XFAObjectArray(), this.encryptData = new m.XFAObjectArray(), this.encryption = new m.XFAObjectArray(), this.encryptionMethod = new m.XFAObjectArray(), this.encryptionMethods = new m.XFAObjectArray(), this.event = new m.XFAObjectArray(), this.exData = new m.XFAObjectArray(), this.exObject = new m.XFAObjectArray(), this.exclGroup = new m.XFAObjectArray(), this.execute = new m.XFAObjectArray(), this.extras = new m.XFAObjectArray(), this.field = new m.XFAObjectArray(), this.fill = new m.XFAObjectArray(), this.filter = new m.XFAObjectArray(), this.float = new m.XFAObjectArray(), this.font = new m.XFAObjectArray(), this.format = new m.XFAObjectArray(), this.handler = new m.XFAObjectArray(), this.hyphenation = new m.XFAObjectArray(), this.image = new m.XFAObjectArray(), this.imageEdit = new m.XFAObjectArray(), this.integer = new m.XFAObjectArray(), this.issuers = new m.XFAObjectArray(), this.items = new m.XFAObjectArray(), this.keep = new m.XFAObjectArray(), this.keyUsage = new m.XFAObjectArray(), this.line = new m.XFAObjectArray(), this.linear = new m.XFAObjectArray(), this.lockDocument = new m.XFAObjectArray(), this.manifest = new m.XFAObjectArray(), this.margin = new m.XFAObjectArray(), this.mdp = new m.XFAObjectArray(), this.medium = new m.XFAObjectArray(), this.message = new m.XFAObjectArray(), this.numericEdit = new m.XFAObjectArray(), this.occur = new m.XFAObjectArray(), this.oid = new m.XFAObjectArray(), this.oids = new m.XFAObjectArray(), this.overflow = new m.XFAObjectArray(), this.pageArea = new m.XFAObjectArray(), this.pageSet = new m.XFAObjectArray(), this.para = new m.XFAObjectArray(), this.passwordEdit = new m.XFAObjectArray(), this.pattern = new m.XFAObjectArray(), this.picture = new m.XFAObjectArray(), this.radial = new m.XFAObjectArray(), this.reason = new m.XFAObjectArray(), this.reasons = new m.XFAObjectArray(), this.rectangle = new m.XFAObjectArray(), this.ref = new m.XFAObjectArray(), this.script = new m.XFAObjectArray(), this.setProperty = new m.XFAObjectArray(), this.signData = new m.XFAObjectArray(), this.signature = new m.XFAObjectArray(), this.signing = new m.XFAObjectArray(), this.solid = new m.XFAObjectArray(), this.speak = new m.XFAObjectArray(), this.stipple = new m.XFAObjectArray(), this.subform = new m.XFAObjectArray(), this.subformSet = new m.XFAObjectArray(), this.subjectDN = new m.XFAObjectArray(), this.subjectDNs = new m.XFAObjectArray(), this.submit = new m.XFAObjectArray(), this.text = new m.XFAObjectArray(), this.textEdit = new m.XFAObjectArray(), this.time = new m.XFAObjectArray(), this.timeStamp = new m.XFAObjectArray(), this.toolTip = new m.XFAObjectArray(), this.traversal = new m.XFAObjectArray(), this.traverse = new m.XFAObjectArray(), this.ui = new m.XFAObjectArray(), this.validate = new m.XFAObjectArray(), this.value = new m.XFAObjectArray(), this.variables = new m.XFAObjectArray();
              }
            }
            class qt extends m.XFAObject {
              constructor(oe) {
                super(I, "radial", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["toEdge", "toCenter"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.color = null, this.extras = null;
              }
              [g.$toStyle](oe) {
                oe = oe ? oe[g.$toStyle]() : "#FFFFFF";
                const Ie = this.color ? this.color[g.$toStyle]() : "#000000";
                return `radial-gradient(circle at center, ${this.type === "toEdge" ? `${oe},${Ie}` : `${Ie},${oe}`})`;
              }
            }
            class Jt extends m.StringObject {
              constructor(oe) {
                super(I, "reason"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class jt extends m.XFAObject {
              constructor(oe) {
                super(I, "reasons", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.reason = new m.XFAObjectArray();
              }
            }
            class Ht extends m.XFAObject {
              constructor(oe) {
                super(I, "rectangle", !0), this.hand = (0, C.getStringOption)(oe.hand, ["even", "left", "right"]), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.corner = new m.XFAObjectArray(4), this.edge = new m.XFAObjectArray(4), this.fill = null;
              }
              [g.$toHTML]() {
                const oe = this.edge.children.length ? this.edge.children[0] : new Fe({}), Ie = oe[g.$toStyle](), lt = /* @__PURE__ */ Object.create(null);
                this.fill?.presence === "visible" ? Object.assign(lt, this.fill[g.$toStyle]()) : lt.fill = "transparent", lt.strokeWidth = (0, f.measureToString)(oe.presence === "visible" ? oe.thickness : 0), lt.stroke = Ie.color;
                const Bt = (this.corner.children.length ? this.corner.children[0] : new ue({}))[g.$toStyle](), Ut = {
                  name: "svg",
                  children: [{
                    name: "rect",
                    attributes: {
                      xmlns: _,
                      width: "100%",
                      height: "100%",
                      x: 0,
                      y: 0,
                      rx: Bt.radius,
                      ry: Bt.radius,
                      style: lt
                    }
                  }],
                  attributes: {
                    xmlns: _,
                    style: {
                      overflow: "visible"
                    },
                    width: "100%",
                    height: "100%"
                  }
                }, er = this[g.$getParent]()[g.$getParent]();
                return W(er) ? C.HTMLResult.success({
                  name: "div",
                  attributes: {
                    style: {
                      display: "inline",
                      width: "100%",
                      height: "100%"
                    }
                  },
                  children: [Ut]
                }) : (Ut.attributes.style.position = "absolute", C.HTMLResult.success(Ut));
              }
            }
            class ur extends m.StringObject {
              constructor(oe) {
                super(I, "ref"), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class Qt extends m.StringObject {
              constructor(oe) {
                super(I, "script"), this.binding = oe.binding || "", this.contentType = oe.contentType || "", this.id = oe.id || "", this.name = oe.name || "", this.runAt = (0, C.getStringOption)(oe.runAt, ["client", "both", "server"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class Yt extends m.XFAObject {
              constructor(oe) {
                super(I, "setProperty"), this.connection = oe.connection || "", this.ref = oe.ref || "", this.target = oe.target || "";
              }
            }
            A.SetProperty = Yt;
            class dr extends m.XFAObject {
              constructor(oe) {
                super(I, "signData", !0), this.id = oe.id || "", this.operation = (0, C.getStringOption)(oe.operation, ["sign", "clear", "verify"]), this.ref = oe.ref || "", this.target = oe.target || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.filter = null, this.manifest = null;
              }
            }
            class Ar extends m.XFAObject {
              constructor(oe) {
                super(I, "signature", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["PDF1.3", "PDF1.6"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.border = null, this.extras = null, this.filter = null, this.manifest = null, this.margin = null;
              }
            }
            class wr extends m.XFAObject {
              constructor(oe) {
                super(I, "signing", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.certificate = new m.XFAObjectArray();
              }
            }
            class Ir extends m.XFAObject {
              constructor(oe) {
                super(I, "solid", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null;
              }
              [g.$toStyle](oe) {
                return oe ? oe[g.$toStyle]() : "#FFFFFF";
              }
            }
            class _r extends m.StringObject {
              constructor(oe) {
                super(I, "speak"), this.disable = (0, C.getInteger)({
                  data: oe.disable,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.id = oe.id || "", this.priority = (0, C.getStringOption)(oe.priority, ["custom", "caption", "name", "toolTip"]), this.rid = oe.rid || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class kr extends m.XFAObject {
              constructor(oe) {
                super(I, "stipple", !0), this.id = oe.id || "", this.rate = (0, C.getInteger)({
                  data: oe.rate,
                  defaultValue: 50,
                  validate: (Ie) => Ie >= 0 && Ie <= 100
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.color = null, this.extras = null;
              }
              [g.$toStyle](oe) {
                const Ie = this.rate / 100;
                return w.Util.makeHexColor(Math.round(oe.value.r * (1 - Ie) + this.value.r * Ie), Math.round(oe.value.g * (1 - Ie) + this.value.g * Ie), Math.round(oe.value.b * (1 - Ie) + this.value.b * Ie));
              }
            }
            class zt extends m.XFAObject {
              constructor(oe) {
                super(I, "subform", !0), this.access = (0, C.getStringOption)(oe.access, ["open", "nonInteractive", "protected", "readOnly"]), this.allowMacro = (0, C.getInteger)({
                  data: oe.allowMacro,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.anchorType = (0, C.getStringOption)(oe.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, C.getInteger)({
                  data: oe.colSpan,
                  defaultValue: 1,
                  validate: (Ie) => Ie >= 1 || Ie === -1
                }), this.columnWidths = (oe.columnWidths || "").trim().split(/\s+/).map((Ie) => Ie === "-1" ? -1 : (0, C.getMeasurement)(Ie)), this.h = oe.h ? (0, C.getMeasurement)(oe.h) : "", this.hAlign = (0, C.getStringOption)(oe.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = oe.id || "", this.layout = (0, C.getStringOption)(oe.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.locale = oe.locale || "", this.maxH = (0, C.getMeasurement)(oe.maxH, "0pt"), this.maxW = (0, C.getMeasurement)(oe.maxW, "0pt"), this.mergeMode = (0, C.getStringOption)(oe.mergeMode, ["consumeData", "matchTemplate"]), this.minH = (0, C.getMeasurement)(oe.minH, "0pt"), this.minW = (0, C.getMeasurement)(oe.minW, "0pt"), this.name = oe.name || "", this.presence = (0, C.getStringOption)(oe.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, C.getRelevant)(oe.relevant), this.restoreState = (0, C.getStringOption)(oe.restoreState, ["manual", "auto"]), this.scope = (0, C.getStringOption)(oe.scope, ["name", "none"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.w = oe.w ? (0, C.getMeasurement)(oe.w) : "", this.x = (0, C.getMeasurement)(oe.x, "0pt"), this.y = (0, C.getMeasurement)(oe.y, "0pt"), this.assist = null, this.bind = null, this.bookend = null, this.border = null, this.break = null, this.calculate = null, this.desc = null, this.extras = null, this.keep = null, this.margin = null, this.occur = null, this.overflow = null, this.pageSet = null, this.para = null, this.traversal = null, this.validate = null, this.variables = null, this.area = new m.XFAObjectArray(), this.breakAfter = new m.XFAObjectArray(), this.breakBefore = new m.XFAObjectArray(), this.connect = new m.XFAObjectArray(), this.draw = new m.XFAObjectArray(), this.event = new m.XFAObjectArray(), this.exObject = new m.XFAObjectArray(), this.exclGroup = new m.XFAObjectArray(), this.field = new m.XFAObjectArray(), this.proto = new m.XFAObjectArray(), this.setProperty = new m.XFAObjectArray(), this.subform = new m.XFAObjectArray(), this.subformSet = new m.XFAObjectArray();
              }
              [g.$getSubformParent]() {
                const oe = this[g.$getParent]();
                return oe instanceof Dt ? oe[g.$getSubformParent]() : oe;
              }
              [g.$isBindable]() {
                return !0;
              }
              [g.$isThereMoreWidth]() {
                return this.layout.endsWith("-tb") && this[g.$extra].attempt === 0 && this[g.$extra].numberInLine > 0 || this[g.$getParent]()[g.$isThereMoreWidth]();
              }
              *[g.$getContainedChildren]() {
                yield* G(this);
              }
              [g.$flushHTML]() {
                return (0, y.flushHTML)(this);
              }
              [g.$addHTML](oe, Ie) {
                (0, y.addHTML)(this, oe, Ie);
              }
              [g.$getAvailableSpace]() {
                return (0, y.getAvailableSpace)(this);
              }
              [g.$isSplittable]() {
                const oe = this[g.$getSubformParent]();
                return oe[g.$isSplittable]() ? this[g.$extra]._isSplittable !== void 0 ? this[g.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[g.$extra]._isSplittable = !1, !1) : this.keep && this.keep.intact !== "none" ? (this[g.$extra]._isSplittable = !1, !1) : oe.layout?.endsWith("-tb") && oe[g.$extra].numberInLine !== 0 ? !1 : (this[g.$extra]._isSplittable = !0, !0) : !1;
              }
              [g.$toHTML](oe) {
                if (k(this), this.break) {
                  if (this.break.after !== "auto" || this.break.afterTarget !== "") {
                    const mr = new ge({
                      targetType: this.break.after,
                      target: this.break.afterTarget,
                      startNew: this.break.startNew.toString()
                    });
                    mr[g.$globalData] = this[g.$globalData], this[g.$appendChild](mr), this.breakAfter.push(mr);
                  }
                  if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
                    const mr = new me({
                      targetType: this.break.before,
                      target: this.break.beforeTarget,
                      startNew: this.break.startNew.toString()
                    });
                    mr[g.$globalData] = this[g.$globalData], this[g.$appendChild](mr), this.breakBefore.push(mr);
                  }
                  if (this.break.overflowTarget !== "") {
                    const mr = new kt({
                      target: this.break.overflowTarget,
                      leader: this.break.overflowLeader,
                      trailer: this.break.overflowTrailer
                    });
                    mr[g.$globalData] = this[g.$globalData], this[g.$appendChild](mr), this.overflow.push(mr);
                  }
                  this[g.$removeChild](this.break), this.break = null;
                }
                if (this.presence === "hidden" || this.presence === "inactive")
                  return C.HTMLResult.EMPTY;
                if ((this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) && (0, w.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug."), this.breakBefore.children.length >= 1) {
                  const mr = this.breakBefore.children[0];
                  if (Z(mr))
                    return C.HTMLResult.breakNode(mr);
                }
                if (this[g.$extra]?.afterBreakAfter)
                  return C.HTMLResult.EMPTY;
                (0, f.fixDimensions)(this);
                const Ie = [], lt = {
                  id: this[g.$uid],
                  class: []
                };
                (0, f.setAccess)(this, lt.class), this[g.$extra] || (this[g.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[g.$extra], {
                  children: Ie,
                  line: null,
                  attributes: lt,
                  attempt: 0,
                  numberInLine: 0,
                  availableSpace: {
                    width: Math.min(this.w || 1 / 0, oe.width),
                    height: Math.min(this.h || 1 / 0, oe.height)
                  },
                  width: 0,
                  height: 0,
                  prevHeight: 0,
                  currentWidth: 0
                });
                const At = this[g.$getTemplateRoot](), Bt = At[g.$extra].noLayoutFailure, Kt = this[g.$isSplittable]();
                if (Kt || H(this), !(0, y.checkDimensions)(this, oe))
                  return C.HTMLResult.FAILURE;
                const Ut = /* @__PURE__ */ new Set(["area", "draw", "exclGroup", "field", "subform", "subformSet"]);
                if (this.layout.includes("row")) {
                  const mr = this[g.$getSubformParent]().columnWidths;
                  Array.isArray(mr) && mr.length > 0 && (this[g.$extra].columnWidths = mr, this[g.$extra].currentColumn = 0);
                }
                const er = (0, f.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), cr = ["xfaSubform"], xr = (0, f.layoutClass)(this);
                if (xr && cr.push(xr), lt.style = er, lt.class = cr, this.name && (lt.xfaName = this.name), this.overflow) {
                  const mr = this.overflow[g.$getExtra]();
                  mr.addLeader && (mr.addLeader = !1, ne(this, mr.leader, oe));
                }
                this[g.$pushPara]();
                const Pr = this.layout === "lr-tb" || this.layout === "rl-tb", Sr = Pr ? E : 1;
                for (; this[g.$extra].attempt < Sr; this[g.$extra].attempt++) {
                  Pr && this[g.$extra].attempt === E - 1 && (this[g.$extra].numberInLine = 0);
                  const mr = this[g.$childrenToHTML]({
                    filter: Ut,
                    include: !0
                  });
                  if (mr.success)
                    break;
                  if (mr.isBreak())
                    return this[g.$popPara](), mr;
                  if (Pr && this[g.$extra].attempt === 0 && this[g.$extra].numberInLine === 0 && !At[g.$extra].noLayoutFailure) {
                    this[g.$extra].attempt = Sr;
                    break;
                  }
                }
                if (this[g.$popPara](), Kt || V(this), At[g.$extra].noLayoutFailure = Bt, this[g.$extra].attempt === Sr)
                  return this.overflow && (this[g.$getTemplateRoot]()[g.$extra].overflowNode = this.overflow), Kt || delete this[g.$extra], C.HTMLResult.FAILURE;
                if (this.overflow) {
                  const mr = this.overflow[g.$getExtra]();
                  mr.addTrailer && (mr.addTrailer = !1, ne(this, mr.trailer, oe));
                }
                let Or = 0, Dr = 0;
                this.margin && (Or = this.margin.leftInset + this.margin.rightInset, Dr = this.margin.topInset + this.margin.bottomInset);
                const pr = Math.max(this[g.$extra].width + Or, this.w || 0), Hr = Math.max(this[g.$extra].height + Dr, this.h || 0), fr = [this.x, this.y, pr, Hr];
                if (this.w === "" && (er.width = (0, f.measureToString)(pr)), this.h === "" && (er.height = (0, f.measureToString)(Hr)), (er.width === "0px" || er.height === "0px") && Ie.length === 0)
                  return C.HTMLResult.EMPTY;
                const yr = {
                  name: "div",
                  attributes: lt,
                  children: Ie
                };
                N(this, lt);
                const qr = C.HTMLResult.success((0, f.createWrapper)(this, yr), fr);
                if (this.breakAfter.children.length >= 1) {
                  const mr = this.breakAfter.children[0];
                  if (Z(mr))
                    return this[g.$extra].afterBreakAfter = qr, C.HTMLResult.breakNode(mr);
                }
                return delete this[g.$extra], qr;
              }
            }
            class Dt extends m.XFAObject {
              constructor(oe) {
                super(I, "subformSet", !0), this.id = oe.id || "", this.name = oe.name || "", this.relation = (0, C.getStringOption)(oe.relation, ["ordered", "choice", "unordered"]), this.relevant = (0, C.getRelevant)(oe.relevant), this.use = oe.use || "", this.usehref = oe.usehref || "", this.bookend = null, this.break = null, this.desc = null, this.extras = null, this.occur = null, this.overflow = null, this.breakAfter = new m.XFAObjectArray(), this.breakBefore = new m.XFAObjectArray(), this.subform = new m.XFAObjectArray(), this.subformSet = new m.XFAObjectArray();
              }
              *[g.$getContainedChildren]() {
                yield* G(this);
              }
              [g.$getSubformParent]() {
                let oe = this[g.$getParent]();
                for (; !(oe instanceof zt); )
                  oe = oe[g.$getParent]();
                return oe;
              }
              [g.$isBindable]() {
                return !0;
              }
            }
            class nr extends m.ContentObject {
              constructor(oe) {
                super(I, "subjectDN"), this.delimiter = oe.delimiter || ",", this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$finalize]() {
                this[g.$content] = new Map(this[g.$content].split(this.delimiter).map((oe) => (oe = oe.split("=", 2), oe[0] = oe[0].trim(), oe)));
              }
            }
            class gr extends m.XFAObject {
              constructor(oe) {
                super(I, "subjectDNs", !0), this.id = oe.id || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.subjectDN = new m.XFAObjectArray();
              }
            }
            class lr extends m.XFAObject {
              constructor(oe) {
                super(I, "submit", !0), this.embedPDF = (0, C.getInteger)({
                  data: oe.embedPDF,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.format = (0, C.getStringOption)(oe.format, ["xdp", "formdata", "pdf", "urlencoded", "xfd", "xml"]), this.id = oe.id || "", this.target = oe.target || "", this.textEncoding = (0, C.getKeyword)({
                  data: oe.textEncoding ? oe.textEncoding.toLowerCase() : "",
                  defaultValue: "",
                  validate: (Ie) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(Ie) || Ie.match(/iso-8859-\d{2}/)
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.xdpContent = oe.xdpContent || "", this.encrypt = null, this.encryptData = new m.XFAObjectArray(), this.signData = new m.XFAObjectArray();
              }
            }
            class Nr extends m.XFAObject {
              constructor(oe) {
                super(I, "template", !0), this.baseProfile = (0, C.getStringOption)(oe.baseProfile, ["full", "interactiveForms"]), this.extras = null, this.subform = new m.XFAObjectArray();
              }
              [g.$finalize]() {
                this.subform.children.length === 0 && (0, w.warn)("XFA - No subforms in template node."), this.subform.children.length >= 2 && (0, w.warn)("XFA - Several subforms in template node: please file a bug."), this[g.$tabIndex] = O;
              }
              [g.$isSplittable]() {
                return !0;
              }
              [g.$searchNode](oe, Ie) {
                return oe.startsWith("#") ? [this[g.$ids].get(oe.slice(1))] : (0, T.searchNode)(this, Ie, oe, !0, !0);
              }
              *[g.$toPages]() {
                if (!this.subform.children.length)
                  return C.HTMLResult.success({
                    name: "div",
                    children: []
                  });
                this[g.$extra] = {
                  overflowNode: null,
                  firstUnsplittable: null,
                  currentContentArea: null,
                  currentPageArea: null,
                  noLayoutFailure: !1,
                  pageNumber: 1,
                  pagePosition: "first",
                  oddOrEven: "odd",
                  blankOrNotBlank: "nonBlank",
                  paraStack: []
                };
                const oe = this.subform.children[0];
                oe.pageSet[g.$cleanPage]();
                const Ie = oe.pageSet.pageArea.children, lt = {
                  name: "div",
                  children: []
                };
                let At = null, Bt = null, Kt = null;
                if (oe.breakBefore.children.length >= 1 ? (Bt = oe.breakBefore.children[0], Kt = Bt.target) : oe.subform.children.length >= 1 && oe.subform.children[0].breakBefore.children.length >= 1 ? (Bt = oe.subform.children[0].breakBefore.children[0], Kt = Bt.target) : oe.break?.beforeTarget ? (Bt = oe.break, Kt = Bt.beforeTarget) : oe.subform.children.length >= 1 && oe.subform.children[0].break?.beforeTarget && (Bt = oe.subform.children[0].break, Kt = Bt.beforeTarget), Bt) {
                  const Dr = this[g.$searchNode](Kt, Bt[g.$getParent]());
                  Dr instanceof $t && (At = Dr, Bt[g.$extra] = {});
                }
                At || (At = Ie[0]), At[g.$extra] = {
                  numberOfUse: 1
                };
                const Ut = At[g.$getParent]();
                Ut[g.$extra] = {
                  numberOfUse: 1,
                  pageIndex: Ut.pageArea.children.indexOf(At),
                  pageSetIndex: 0
                };
                let er, cr = null, xr = null, Pr = !0, Sr = 0, Or = 0;
                for (; ; ) {
                  if (Pr)
                    Sr = 0;
                  else if (lt.children.pop(), ++Sr === R)
                    return (0, w.warn)("XFA - Something goes wrong: please file a bug."), lt;
                  er = null, this[g.$extra].currentPageArea = At;
                  const Dr = At[g.$toHTML]().html;
                  lt.children.push(Dr), cr && (this[g.$extra].noLayoutFailure = !0, Dr.children.push(cr[g.$toHTML](At[g.$extra].space).html), cr = null), xr && (this[g.$extra].noLayoutFailure = !0, Dr.children.push(xr[g.$toHTML](At[g.$extra].space).html), xr = null);
                  const pr = At.contentArea.children, Hr = Dr.children.filter((yr) => yr.attributes.class.includes("xfaContentarea"));
                  Pr = !1, this[g.$extra].firstUnsplittable = null, this[g.$extra].noLayoutFailure = !1;
                  const fr = (yr) => {
                    const qr = oe[g.$flushHTML]();
                    qr && (Pr ||= qr.children?.length > 0, Hr[yr].children.push(qr));
                  };
                  for (let yr = Or, qr = pr.length; yr < qr; yr++) {
                    const mr = this[g.$extra].currentContentArea = pr[yr], Kr = {
                      width: mr.w,
                      height: mr.h
                    };
                    Or = 0, cr && (Hr[yr].children.push(cr[g.$toHTML](Kr).html), cr = null), xr && (Hr[yr].children.push(xr[g.$toHTML](Kr).html), xr = null);
                    const nn = oe[g.$toHTML](Kr);
                    if (nn.success)
                      return nn.html ? (Pr ||= nn.html.children?.length > 0, Hr[yr].children.push(nn.html)) : !Pr && lt.children.length > 1 && lt.children.pop(), lt;
                    if (nn.isBreak()) {
                      const Vr = nn.breakNode;
                      if (fr(yr), Vr.targetType === "auto")
                        continue;
                      Vr.leader && (cr = this[g.$searchNode](Vr.leader, Vr[g.$getParent]()), cr = cr ? cr[0] : null), Vr.trailer && (xr = this[g.$searchNode](Vr.trailer, Vr[g.$getParent]()), xr = xr ? xr[0] : null), Vr.targetType === "pageArea" ? (er = Vr[g.$extra].target, yr = 1 / 0) : Vr[g.$extra].target ? (er = Vr[g.$extra].target, Or = Vr[g.$extra].index + 1, yr = 1 / 0) : yr = Vr[g.$extra].index;
                      continue;
                    }
                    if (this[g.$extra].overflowNode) {
                      const Vr = this[g.$extra].overflowNode;
                      this[g.$extra].overflowNode = null;
                      const Dn = Vr[g.$getExtra](), Tn = Dn.target;
                      Dn.addLeader = Dn.leader !== null, Dn.addTrailer = Dn.trailer !== null, fr(yr);
                      const Qa = yr;
                      if (yr = 1 / 0, Tn instanceof $t)
                        er = Tn;
                      else if (Tn instanceof Ae) {
                        const Kn = pr.indexOf(Tn);
                        Kn !== -1 ? Kn > Qa ? yr = Kn - 1 : Or = Kn : (er = Tn[g.$getParent](), Or = er.contentArea.children.indexOf(Tn));
                      }
                      continue;
                    }
                    fr(yr);
                  }
                  this[g.$extra].pageNumber += 1, er && (er[g.$isUsable]() ? er[g.$extra].numberOfUse += 1 : er = null), At = er || At[g.$getNextPage](), yield null;
                }
              }
            }
            A.Template = Nr;
            class Wr extends m.ContentObject {
              constructor(oe) {
                super(I, "text"), this.id = oe.id || "", this.maxChars = (0, C.getInteger)({
                  data: oe.maxChars,
                  defaultValue: 0,
                  validate: (Ie) => Ie >= 0
                }), this.name = oe.name || "", this.rid = oe.rid || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$acceptWhitespace]() {
                return !0;
              }
              [g.$onChild](oe) {
                return oe[g.$namespaceId] === b.NamespaceIds.xhtml.id ? (this[g.$content] = oe, !0) : ((0, w.warn)(`XFA - Invalid content in Text: ${oe[g.$nodeName]}.`), !1);
              }
              [g.$onText](oe) {
                this[g.$content] instanceof m.XFAObject || super[g.$onText](oe);
              }
              [g.$finalize]() {
                typeof this[g.$content] == "string" && (this[g.$content] = this[g.$content].replaceAll(`\r
`, `
`));
              }
              [g.$getExtra]() {
                return typeof this[g.$content] == "string" ? this[g.$content].split(/[\u2029\u2028\n]/).reduce((oe, Ie) => (Ie && oe.push(Ie), oe), []).join(`
`) : this[g.$content][g.$text]();
              }
              [g.$toHTML](oe) {
                if (typeof this[g.$content] == "string") {
                  const Ie = D(this[g.$content]).html;
                  return this[g.$content].includes("\u2029") ? (Ie.name = "div", Ie.children = [], this[g.$content].split("\u2029").map((lt) => lt.split(/[\u2028\n]/).reduce((At, Bt) => (At.push({
                    name: "span",
                    value: Bt
                  }, {
                    name: "br"
                  }), At), [])).forEach((lt) => {
                    Ie.children.push({
                      name: "p",
                      children: lt
                    });
                  })) : /[\u2028\n]/.test(this[g.$content]) && (Ie.name = "div", Ie.children = [], this[g.$content].split(/[\u2028\n]/).forEach((lt) => {
                    Ie.children.push({
                      name: "span",
                      value: lt
                    }, {
                      name: "br"
                    });
                  })), C.HTMLResult.success(Ie);
                }
                return this[g.$content][g.$toHTML](oe);
              }
            }
            A.Text = Wr;
            class Fr extends m.XFAObject {
              constructor(oe) {
                super(I, "textEdit", !0), this.allowRichText = (0, C.getInteger)({
                  data: oe.allowRichText,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.hScrollPolicy = (0, C.getStringOption)(oe.hScrollPolicy, ["auto", "off", "on"]), this.id = oe.id || "", this.multiLine = (0, C.getInteger)({
                  data: oe.multiLine,
                  defaultValue: "",
                  validate: (Ie) => Ie === 0 || Ie === 1
                }), this.use = oe.use || "", this.usehref = oe.usehref || "", this.vScrollPolicy = (0, C.getStringOption)(oe.vScrollPolicy, ["auto", "off", "on"]), this.border = null, this.comb = null, this.extras = null, this.margin = null;
              }
              [g.$toHTML](oe) {
                const Ie = (0, f.toStyle)(this, "border", "font", "margin");
                let lt;
                const At = this[g.$getParent]()[g.$getParent]();
                return this.multiLine === "" && (this.multiLine = At instanceof Me ? 1 : 0), this.multiLine === 1 ? lt = {
                  name: "textarea",
                  attributes: {
                    dataId: At[g.$data]?.[g.$uid] || At[g.$uid],
                    fieldId: At[g.$uid],
                    class: ["xfaTextfield"],
                    style: Ie,
                    "aria-label": P(At),
                    "aria-required": !1
                  }
                } : lt = {
                  name: "input",
                  attributes: {
                    type: "text",
                    dataId: At[g.$data]?.[g.$uid] || At[g.$uid],
                    fieldId: At[g.$uid],
                    class: ["xfaTextfield"],
                    style: Ie,
                    "aria-label": P(At),
                    "aria-required": !1
                  }
                }, U(At) && (lt.attributes["aria-required"] = !0, lt.attributes.required = !0), C.HTMLResult.success({
                  name: "label",
                  attributes: {
                    class: ["xfaLabel"]
                  },
                  children: [lt]
                });
              }
            }
            class Qr extends m.StringObject {
              constructor(oe) {
                super(I, "time"), this.id = oe.id || "", this.name = oe.name || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
              [g.$finalize]() {
                const oe = this[g.$content].trim();
                this[g.$content] = oe ? new Date(oe) : null;
              }
              [g.$toHTML](oe) {
                return D(this[g.$content] ? this[g.$content].toString() : "");
              }
            }
            class an extends m.XFAObject {
              constructor(oe) {
                super(I, "timeStamp"), this.id = oe.id || "", this.server = oe.server || "", this.type = (0, C.getStringOption)(oe.type, ["optional", "required"]), this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class cn extends m.StringObject {
              constructor(oe) {
                super(I, "toolTip"), this.id = oe.id || "", this.rid = oe.rid || "", this.use = oe.use || "", this.usehref = oe.usehref || "";
              }
            }
            class yn extends m.XFAObject {
              constructor(oe) {
                super(I, "traversal", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.traverse = new m.XFAObjectArray();
              }
            }
            class _n extends m.XFAObject {
              constructor(oe) {
                super(I, "traverse", !0), this.id = oe.id || "", this.operation = (0, C.getStringOption)(oe.operation, ["next", "back", "down", "first", "left", "right", "up"]), this.ref = oe.ref || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.script = null;
              }
              get name() {
                return this.operation;
              }
              [g.$isTransparent]() {
                return !1;
              }
            }
            class Xt extends m.XFAObject {
              constructor(oe) {
                super(I, "ui", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.picture = null, this.barcode = null, this.button = null, this.checkButton = null, this.choiceList = null, this.dateTimeEdit = null, this.defaultUi = null, this.imageEdit = null, this.numericEdit = null, this.passwordEdit = null, this.signature = null, this.textEdit = null;
              }
              [g.$getExtra]() {
                if (this[g.$extra] === void 0) {
                  for (const oe of Object.getOwnPropertyNames(this)) {
                    if (oe === "extras" || oe === "picture")
                      continue;
                    const Ie = this[oe];
                    if (Ie instanceof m.XFAObject)
                      return this[g.$extra] = Ie, Ie;
                  }
                  this[g.$extra] = null;
                }
                return this[g.$extra];
              }
              [g.$toHTML](oe) {
                const Ie = this[g.$getExtra]();
                return Ie ? Ie[g.$toHTML](oe) : C.HTMLResult.EMPTY;
              }
            }
            class sr extends m.XFAObject {
              constructor(oe) {
                super(I, "validate", !0), this.formatTest = (0, C.getStringOption)(oe.formatTest, ["warning", "disabled", "error"]), this.id = oe.id || "", this.nullTest = (0, C.getStringOption)(oe.nullTest, ["disabled", "error", "warning"]), this.scriptTest = (0, C.getStringOption)(oe.scriptTest, ["error", "disabled", "warning"]), this.use = oe.use || "", this.usehref = oe.usehref || "", this.extras = null, this.message = null, this.picture = null, this.script = null;
              }
            }
            class Tr extends m.XFAObject {
              constructor(oe) {
                super(I, "value", !0), this.id = oe.id || "", this.override = (0, C.getInteger)({
                  data: oe.override,
                  defaultValue: 0,
                  validate: (Ie) => Ie === 1
                }), this.relevant = (0, C.getRelevant)(oe.relevant), this.use = oe.use || "", this.usehref = oe.usehref || "", this.arc = null, this.boolean = null, this.date = null, this.dateTime = null, this.decimal = null, this.exData = null, this.float = null, this.image = null, this.integer = null, this.line = null, this.rectangle = null, this.text = null, this.time = null;
              }
              [g.$setValue](oe) {
                const Ie = this[g.$getParent]();
                if (Ie instanceof at && Ie.ui?.imageEdit) {
                  this.image || (this.image = new pt({}), this[g.$appendChild](this.image)), this.image[g.$content] = oe[g.$content];
                  return;
                }
                const lt = oe[g.$nodeName];
                if (this[lt] !== null) {
                  this[lt][g.$content] = oe[g.$content];
                  return;
                }
                for (const At of Object.getOwnPropertyNames(this)) {
                  const Bt = this[At];
                  Bt instanceof m.XFAObject && (this[At] = null, this[g.$removeChild](Bt));
                }
                this[oe[g.$nodeName]] = oe, this[g.$appendChild](oe);
              }
              [g.$text]() {
                if (this.exData)
                  return typeof this.exData[g.$content] == "string" ? this.exData[g.$content].trim() : this.exData[g.$content][g.$text]().trim();
                for (const oe of Object.getOwnPropertyNames(this)) {
                  if (oe === "image")
                    continue;
                  const Ie = this[oe];
                  if (Ie instanceof m.XFAObject)
                    return (Ie[g.$content] || "").toString().trim();
                }
                return null;
              }
              [g.$toHTML](oe) {
                for (const Ie of Object.getOwnPropertyNames(this)) {
                  const lt = this[Ie];
                  if (lt instanceof m.XFAObject)
                    return lt[g.$toHTML](oe);
                }
                return C.HTMLResult.EMPTY;
              }
            }
            A.Value = Tr;
            class Lr extends m.XFAObject {
              constructor(oe) {
                super(I, "variables", !0), this.id = oe.id || "", this.use = oe.use || "", this.usehref = oe.usehref || "", this.boolean = new m.XFAObjectArray(), this.date = new m.XFAObjectArray(), this.dateTime = new m.XFAObjectArray(), this.decimal = new m.XFAObjectArray(), this.exData = new m.XFAObjectArray(), this.float = new m.XFAObjectArray(), this.image = new m.XFAObjectArray(), this.integer = new m.XFAObjectArray(), this.manifest = new m.XFAObjectArray(), this.script = new m.XFAObjectArray(), this.text = new m.XFAObjectArray(), this.time = new m.XFAObjectArray();
              }
              [g.$isTransparent]() {
                return !0;
              }
            }
            class Rr {
              static [b.$buildXFAObject](oe, Ie) {
                if (Rr.hasOwnProperty(oe)) {
                  const lt = Rr[oe](Ie);
                  return lt[g.$setSetAttributes](Ie), lt;
                }
              }
              static appearanceFilter(oe) {
                return new K(oe);
              }
              static arc(oe) {
                return new q(oe);
              }
              static area(oe) {
                return new Y(oe);
              }
              static assist(oe) {
                return new ee(oe);
              }
              static barcode(oe) {
                return new Q(oe);
              }
              static bind(oe) {
                return new J(oe);
              }
              static bindItems(oe) {
                return new te(oe);
              }
              static bookend(oe) {
                return new ae(oe);
              }
              static boolean(oe) {
                return new se(oe);
              }
              static border(oe) {
                return new ie(oe);
              }
              static break(oe) {
                return new fe(oe);
              }
              static breakAfter(oe) {
                return new ge(oe);
              }
              static breakBefore(oe) {
                return new me(oe);
              }
              static button(oe) {
                return new pe(oe);
              }
              static calculate(oe) {
                return new be(oe);
              }
              static caption(oe) {
                return new le(oe);
              }
              static certificate(oe) {
                return new ve(oe);
              }
              static certificates(oe) {
                return new he(oe);
              }
              static checkButton(oe) {
                return new ye(oe);
              }
              static choiceList(oe) {
                return new Ce(oe);
              }
              static color(oe) {
                return new xe(oe);
              }
              static comb(oe) {
                return new we(oe);
              }
              static connect(oe) {
                return new $e(oe);
              }
              static contentArea(oe) {
                return new Ae(oe);
              }
              static corner(oe) {
                return new ue(oe);
              }
              static date(oe) {
                return new ce(oe);
              }
              static dateTime(oe) {
                return new Ee(oe);
              }
              static dateTimeEdit(oe) {
                return new _e(oe);
              }
              static decimal(oe) {
                return new Te(oe);
              }
              static defaultUi(oe) {
                return new ke(oe);
              }
              static desc(oe) {
                return new Re(oe);
              }
              static digestMethod(oe) {
                return new Be(oe);
              }
              static digestMethods(oe) {
                return new Oe(oe);
              }
              static draw(oe) {
                return new Me(oe);
              }
              static edge(oe) {
                return new Fe(oe);
              }
              static encoding(oe) {
                return new Ue(oe);
              }
              static encodings(oe) {
                return new je(oe);
              }
              static encrypt(oe) {
                return new Le(oe);
              }
              static encryptData(oe) {
                return new De(oe);
              }
              static encryption(oe) {
                return new Ne(oe);
              }
              static encryptionMethod(oe) {
                return new Ge(oe);
              }
              static encryptionMethods(oe) {
                return new Xe(oe);
              }
              static event(oe) {
                return new nt(oe);
              }
              static exData(oe) {
                return new ct(oe);
              }
              static exObject(oe) {
                return new it(oe);
              }
              static exclGroup(oe) {
                return new We(oe);
              }
              static execute(oe) {
                return new Ve(oe);
              }
              static extras(oe) {
                return new ut(oe);
              }
              static field(oe) {
                return new at(oe);
              }
              static fill(oe) {
                return new Qe(oe);
              }
              static filter(oe) {
                return new st(oe);
              }
              static float(oe) {
                return new ft(oe);
              }
              static font(oe) {
                return new vt(oe);
              }
              static format(oe) {
                return new Pt(oe);
              }
              static handler(oe) {
                return new dt(oe);
              }
              static hyphenation(oe) {
                return new mt(oe);
              }
              static image(oe) {
                return new pt(oe);
              }
              static imageEdit(oe) {
                return new Et(oe);
              }
              static integer(oe) {
                return new Mt(oe);
              }
              static issuers(oe) {
                return new Nt(oe);
              }
              static items(oe) {
                return new _t(oe);
              }
              static keep(oe) {
                return new Ot(oe);
              }
              static keyUsage(oe) {
                return new rt(oe);
              }
              static line(oe) {
                return new et(oe);
              }
              static linear(oe) {
                return new Ye(oe);
              }
              static lockDocument(oe) {
                return new tt(oe);
              }
              static manifest(oe) {
                return new Ke(oe);
              }
              static margin(oe) {
                return new qe(oe);
              }
              static mdp(oe) {
                return new ot(oe);
              }
              static medium(oe) {
                return new Je(oe);
              }
              static message(oe) {
                return new Ct(oe);
              }
              static numericEdit(oe) {
                return new Tt(oe);
              }
              static occur(oe) {
                return new yt(oe);
              }
              static oid(oe) {
                return new bt(oe);
              }
              static oids(oe) {
                return new It(oe);
              }
              static overflow(oe) {
                return new kt(oe);
              }
              static pageArea(oe) {
                return new $t(oe);
              }
              static pageSet(oe) {
                return new Lt(oe);
              }
              static para(oe) {
                return new Ft(oe);
              }
              static passwordEdit(oe) {
                return new Vt(oe);
              }
              static pattern(oe) {
                return new rr(oe);
              }
              static picture(oe) {
                return new br(oe);
              }
              static proto(oe) {
                return new Gt(oe);
              }
              static radial(oe) {
                return new qt(oe);
              }
              static reason(oe) {
                return new Jt(oe);
              }
              static reasons(oe) {
                return new jt(oe);
              }
              static rectangle(oe) {
                return new Ht(oe);
              }
              static ref(oe) {
                return new ur(oe);
              }
              static script(oe) {
                return new Qt(oe);
              }
              static setProperty(oe) {
                return new Yt(oe);
              }
              static signData(oe) {
                return new dr(oe);
              }
              static signature(oe) {
                return new Ar(oe);
              }
              static signing(oe) {
                return new wr(oe);
              }
              static solid(oe) {
                return new Ir(oe);
              }
              static speak(oe) {
                return new _r(oe);
              }
              static stipple(oe) {
                return new kr(oe);
              }
              static subform(oe) {
                return new zt(oe);
              }
              static subformSet(oe) {
                return new Dt(oe);
              }
              static subjectDN(oe) {
                return new nr(oe);
              }
              static subjectDNs(oe) {
                return new gr(oe);
              }
              static submit(oe) {
                return new lr(oe);
              }
              static template(oe) {
                return new Nr(oe);
              }
              static text(oe) {
                return new Wr(oe);
              }
              static textEdit(oe) {
                return new Fr(oe);
              }
              static time(oe) {
                return new Qr(oe);
              }
              static timeStamp(oe) {
                return new an(oe);
              }
              static toolTip(oe) {
                return new cn(oe);
              }
              static traversal(oe) {
                return new yn(oe);
              }
              static traverse(oe) {
                return new _n(oe);
              }
              static ui(oe) {
                return new Xt(oe);
              }
              static validate(oe) {
                return new sr(oe);
              }
              static value(oe) {
                return new Tr(oe);
              }
              static variables(oe) {
                return new Lr(oe);
              }
            }
            A.TemplateNamespace = Rr;
          },
          /* 81 */
          /***/
          (v, A) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.NamespaceIds = A.$buildXFAObject = void 0;
            const x = Symbol();
            A.$buildXFAObject = x;
            const g = {
              config: {
                id: 0,
                check: (b) => b.startsWith("http://www.xfa.org/schema/xci/")
              },
              connectionSet: {
                id: 1,
                check: (b) => b.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
              },
              datasets: {
                id: 2,
                check: (b) => b.startsWith("http://www.xfa.org/schema/xfa-data/")
              },
              form: {
                id: 3,
                check: (b) => b.startsWith("http://www.xfa.org/schema/xfa-form/")
              },
              localeSet: {
                id: 4,
                check: (b) => b.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
              },
              pdf: {
                id: 5,
                check: (b) => b === "http://ns.adobe.com/xdp/pdf/"
              },
              signature: {
                id: 6,
                check: (b) => b === "http://www.w3.org/2000/09/xmldsig#"
              },
              sourceSet: {
                id: 7,
                check: (b) => b.startsWith("http://www.xfa.org/schema/xfa-source-set/")
              },
              stylesheet: {
                id: 8,
                check: (b) => b === "http://www.w3.org/1999/XSL/Transform"
              },
              template: {
                id: 9,
                check: (b) => b.startsWith("http://www.xfa.org/schema/xfa-template/")
              },
              xdc: {
                id: 10,
                check: (b) => b.startsWith("http://www.xfa.org/schema/xdc/")
              },
              xdp: {
                id: 11,
                check: (b) => b === "http://ns.adobe.com/xdp/"
              },
              xfdf: {
                id: 12,
                check: (b) => b === "http://ns.adobe.com/xfdf/"
              },
              xhtml: {
                id: 13,
                check: (b) => b === "http://www.w3.org/1999/xhtml"
              },
              xmpmeta: {
                id: 14,
                check: (b) => b === "http://ns.adobe.com/xmpmeta/"
              }
            };
            A.NamespaceIds = g;
          },
          /* 82 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.addHTML = m, A.checkDimensions = S, A.flushHTML = f, A.getAvailableSpace = C;
            var g = x(78), b = x(83);
            function y($, T) {
              return {
                name: "div",
                attributes: {
                  class: [$.layout === "lr-tb" ? "xfaLr" : "xfaRl"]
                },
                children: T
              };
            }
            function f($) {
              if (!$[g.$extra])
                return null;
              const I = {
                name: "div",
                attributes: $[g.$extra].attributes,
                children: $[g.$extra].children
              };
              if ($[g.$extra].failingNode) {
                const _ = $[g.$extra].failingNode[g.$flushHTML]();
                _ && ($.layout.endsWith("-tb") ? I.children.push(y($, [_])) : I.children.push(_));
              }
              return I.children.length === 0 ? null : I;
            }
            function m($, T, I) {
              const _ = $[g.$extra], E = _.availableSpace, [R, O, L, B] = I;
              switch ($.layout) {
                case "position": {
                  _.width = Math.max(_.width, R + L), _.height = Math.max(_.height, O + B), _.children.push(T);
                  break;
                }
                case "lr-tb":
                case "rl-tb":
                  (!_.line || _.attempt === 1) && (_.line = y($, []), _.children.push(_.line), _.numberInLine = 0), _.numberInLine += 1, _.line.children.push(T), _.attempt === 0 ? (_.currentWidth += L, _.height = Math.max(_.height, _.prevHeight + B)) : (_.currentWidth = L, _.prevHeight = _.height, _.height += B, _.attempt = 0), _.width = Math.max(_.width, _.currentWidth);
                  break;
                case "rl-row":
                case "row": {
                  _.children.push(T), _.width += L, _.height = Math.max(_.height, B);
                  const F = (0, b.measureToString)(_.height);
                  for (const M of _.children)
                    M.attributes.style.height = F;
                  break;
                }
                case "table": {
                  _.width = Math.min(E.width, Math.max(_.width, L)), _.height += B, _.children.push(T);
                  break;
                }
                case "tb": {
                  _.width = Math.min(E.width, Math.max(_.width, L)), _.height += B, _.children.push(T);
                  break;
                }
              }
            }
            function C($) {
              const T = $[g.$extra].availableSpace, I = $.margin ? $.margin.topInset + $.margin.bottomInset : 0, _ = $.margin ? $.margin.leftInset + $.margin.rightInset : 0;
              switch ($.layout) {
                case "lr-tb":
                case "rl-tb":
                  return $[g.$extra].attempt === 0 ? {
                    width: T.width - _ - $[g.$extra].currentWidth,
                    height: T.height - I - $[g.$extra].prevHeight
                  } : {
                    width: T.width - _,
                    height: T.height - I - $[g.$extra].height
                  };
                case "rl-row":
                case "row":
                  return {
                    width: $[g.$extra].columnWidths.slice($[g.$extra].currentColumn).reduce((R, O) => R + O),
                    height: T.height - _
                  };
                case "table":
                case "tb":
                  return {
                    width: T.width - _,
                    height: T.height - I - $[g.$extra].height
                  };
                case "position":
                default:
                  return T;
              }
            }
            function w($) {
              let T = $.w === "" ? NaN : $.w, I = $.h === "" ? NaN : $.h, [_, E] = [0, 0];
              switch ($.anchorType || "") {
                case "bottomCenter":
                  [_, E] = [T / 2, I];
                  break;
                case "bottomLeft":
                  [_, E] = [0, I];
                  break;
                case "bottomRight":
                  [_, E] = [T, I];
                  break;
                case "middleCenter":
                  [_, E] = [T / 2, I / 2];
                  break;
                case "middleLeft":
                  [_, E] = [0, I / 2];
                  break;
                case "middleRight":
                  [_, E] = [T, I / 2];
                  break;
                case "topCenter":
                  [_, E] = [T / 2, 0];
                  break;
                case "topRight":
                  [_, E] = [T, 0];
                  break;
              }
              let R, O;
              switch ($.rotate || 0) {
                case 0:
                  [R, O] = [-_, -E];
                  break;
                case 90:
                  [R, O] = [-E, _], [T, I] = [I, -T];
                  break;
                case 180:
                  [R, O] = [_, E], [T, I] = [-T, -I];
                  break;
                case 270:
                  [R, O] = [E, -_], [T, I] = [-I, T];
                  break;
              }
              return [$.x + R + Math.min(0, T), $.y + O + Math.min(0, I), Math.abs(T), Math.abs(I)];
            }
            function S($, T) {
              if ($[g.$getTemplateRoot]()[g.$extra].firstUnsplittable === null || $.w === 0 || $.h === 0)
                return !0;
              const I = 2, _ = $[g.$getSubformParent](), E = _[g.$extra]?.attempt || 0, [, R, O, L] = w($);
              switch (_.layout) {
                case "lr-tb":
                case "rl-tb":
                  return E === 0 ? $[g.$getTemplateRoot]()[g.$extra].noLayoutFailure ? $.w !== "" ? Math.round(O - T.width) <= I : T.width > I : $.h !== "" && Math.round(L - T.height) > I ? !1 : $.w !== "" ? Math.round(O - T.width) <= I ? !0 : _[g.$extra].numberInLine === 0 ? T.height > I : !1 : T.width > I : $[g.$getTemplateRoot]()[g.$extra].noLayoutFailure ? !0 : $.h !== "" && Math.round(L - T.height) > I ? !1 : $.w === "" || Math.round(O - T.width) <= I ? T.height > I : _[g.$isThereMoreWidth]() ? !1 : T.height > I;
                case "table":
                case "tb":
                  return $[g.$getTemplateRoot]()[g.$extra].noLayoutFailure ? !0 : $.h !== "" && !$[g.$isSplittable]() ? Math.round(L - T.height) <= I : $.w === "" || Math.round(O - T.width) <= I ? T.height > I : _[g.$isThereMoreWidth]() ? !1 : T.height > I;
                case "position":
                  if ($[g.$getTemplateRoot]()[g.$extra].noLayoutFailure || $.h === "" || Math.round(L + R - T.height) <= I)
                    return !0;
                  const B = $[g.$getTemplateRoot]()[g.$extra].currentContentArea;
                  return L + R > B.h;
                case "rl-row":
                case "row":
                  return $[g.$getTemplateRoot]()[g.$extra].noLayoutFailure ? !0 : $.h !== "" ? Math.round(L - T.height) <= I : !0;
                default:
                  return !0;
              }
            }
          },
          /* 83 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.computeBbox = _, A.createWrapper = L, A.fixDimensions = E, A.fixTextIndent = B, A.fixURL = U, A.isPrintOnly = M, A.layoutClass = R, A.layoutNode = I, A.measureToString = w, A.setAccess = F, A.setFontFamily = G, A.setMinMaxDimensions = $, A.setPara = j, A.toStyle = O;
            var g = x(78), b = x(2), y = x(84), f = x(85), m = x(86), C = x(87);
            function w(k) {
              return typeof k == "string" ? "0px" : Number.isInteger(k) ? `${k}px` : `${k.toFixed(2)}px`;
            }
            const S = {
              anchorType(k, N) {
                const P = k[g.$getSubformParent]();
                if (!(!P || P.layout && P.layout !== "position"))
                  switch ("transform" in N || (N.transform = ""), k.anchorType) {
                    case "bottomCenter":
                      N.transform += "translate(-50%, -100%)";
                      break;
                    case "bottomLeft":
                      N.transform += "translate(0,-100%)";
                      break;
                    case "bottomRight":
                      N.transform += "translate(-100%,-100%)";
                      break;
                    case "middleCenter":
                      N.transform += "translate(-50%,-50%)";
                      break;
                    case "middleLeft":
                      N.transform += "translate(0,-50%)";
                      break;
                    case "middleRight":
                      N.transform += "translate(-100%,-50%)";
                      break;
                    case "topCenter":
                      N.transform += "translate(-50%,0)";
                      break;
                    case "topRight":
                      N.transform += "translate(-100%,0)";
                      break;
                  }
              },
              dimensions(k, N) {
                const P = k[g.$getSubformParent]();
                let D = k.w;
                const H = k.h;
                if (P.layout?.includes("row")) {
                  const V = P[g.$extra], Z = k.colSpan;
                  let ne;
                  Z === -1 ? (ne = V.columnWidths.slice(V.currentColumn).reduce((K, q) => K + q, 0), V.currentColumn = 0) : (ne = V.columnWidths.slice(V.currentColumn, V.currentColumn + Z).reduce((K, q) => K + q, 0), V.currentColumn = (V.currentColumn + k.colSpan) % V.columnWidths.length), isNaN(ne) || (D = k.w = ne);
                }
                N.width = D !== "" ? w(D) : "auto", N.height = H !== "" ? w(H) : "auto";
              },
              position(k, N) {
                const P = k[g.$getSubformParent]();
                P?.layout && P.layout !== "position" || (N.position = "absolute", N.left = w(k.x), N.top = w(k.y));
              },
              rotate(k, N) {
                k.rotate && ("transform" in N || (N.transform = ""), N.transform += `rotate(-${k.rotate}deg)`, N.transformOrigin = "top left");
              },
              presence(k, N) {
                switch (k.presence) {
                  case "invisible":
                    N.visibility = "hidden";
                    break;
                  case "hidden":
                  case "inactive":
                    N.display = "none";
                    break;
                }
              },
              hAlign(k, N) {
                if (k[g.$nodeName] === "para")
                  switch (k.hAlign) {
                    case "justifyAll":
                      N.textAlign = "justify-all";
                      break;
                    case "radix":
                      N.textAlign = "left";
                      break;
                    default:
                      N.textAlign = k.hAlign;
                  }
                else
                  switch (k.hAlign) {
                    case "left":
                      N.alignSelf = "start";
                      break;
                    case "center":
                      N.alignSelf = "center";
                      break;
                    case "right":
                      N.alignSelf = "end";
                      break;
                  }
              },
              margin(k, N) {
                k.margin && (N.margin = k.margin[g.$toStyle]().margin);
              }
            };
            function $(k, N) {
              k[g.$getSubformParent]().layout === "position" && (k.minW > 0 && (N.minWidth = w(k.minW)), k.maxW > 0 && (N.maxWidth = w(k.maxW)), k.minH > 0 && (N.minHeight = w(k.minH)), k.maxH > 0 && (N.maxHeight = w(k.maxH)));
            }
            function T(k, N, P, D, H, V) {
              const Z = new m.TextMeasure(N, P, D, H);
              return typeof k == "string" ? Z.addString(k) : k[g.$pushGlyphs](Z), Z.compute(V);
            }
            function I(k, N) {
              let P = null, D = null, H = !1;
              if ((!k.w || !k.h) && k.value) {
                let V = 0, Z = 0;
                k.margin && (V = k.margin.leftInset + k.margin.rightInset, Z = k.margin.topInset + k.margin.bottomInset);
                let ne = null, K = null;
                k.para && (K = /* @__PURE__ */ Object.create(null), ne = k.para.lineHeight === "" ? null : k.para.lineHeight, K.top = k.para.spaceAbove === "" ? 0 : k.para.spaceAbove, K.bottom = k.para.spaceBelow === "" ? 0 : k.para.spaceBelow, K.left = k.para.marginLeft === "" ? 0 : k.para.marginLeft, K.right = k.para.marginRight === "" ? 0 : k.para.marginRight);
                let q = k.font;
                if (!q) {
                  const Q = k[g.$getTemplateRoot]();
                  let J = k[g.$getParent]();
                  for (; J && J !== Q; ) {
                    if (J.font) {
                      q = J.font;
                      break;
                    }
                    J = J[g.$getParent]();
                  }
                }
                const Y = (k.w || N.width) - V, ee = k[g.$globalData].fontFinder;
                if (k.value.exData && k.value.exData[g.$content] && k.value.exData.contentType === "text/html") {
                  const Q = T(k.value.exData[g.$content], q, K, ne, ee, Y);
                  D = Q.width, P = Q.height, H = Q.isBroken;
                } else {
                  const Q = k.value[g.$text]();
                  if (Q) {
                    const J = T(Q, q, K, ne, ee, Y);
                    D = J.width, P = J.height, H = J.isBroken;
                  }
                }
                D !== null && !k.w && (D += V), P !== null && !k.h && (P += Z);
              }
              return {
                w: D,
                h: P,
                isBroken: H
              };
            }
            function _(k, N, P) {
              let D;
              if (k.w !== "" && k.h !== "")
                D = [k.x, k.y, k.w, k.h];
              else {
                if (!P)
                  return null;
                let H = k.w;
                if (H === "") {
                  if (k.maxW === 0) {
                    const Z = k[g.$getSubformParent]();
                    H = Z.layout === "position" && Z.w !== "" ? 0 : k.minW;
                  } else
                    H = Math.min(k.maxW, P.width);
                  N.attributes.style.width = w(H);
                }
                let V = k.h;
                if (V === "") {
                  if (k.maxH === 0) {
                    const Z = k[g.$getSubformParent]();
                    V = Z.layout === "position" && Z.h !== "" ? 0 : k.minH;
                  } else
                    V = Math.min(k.maxH, P.height);
                  N.attributes.style.height = w(V);
                }
                D = [k.x, k.y, H, V];
              }
              return D;
            }
            function E(k) {
              const N = k[g.$getSubformParent]();
              if (N.layout?.includes("row")) {
                const P = N[g.$extra], D = k.colSpan;
                let H;
                D === -1 ? H = P.columnWidths.slice(P.currentColumn).reduce((V, Z) => V + Z, 0) : H = P.columnWidths.slice(P.currentColumn, P.currentColumn + D).reduce((V, Z) => V + Z, 0), isNaN(H) || (k.w = H);
              }
              N.layout && N.layout !== "position" && (k.x = k.y = 0), k.layout === "table" && k.w === "" && Array.isArray(k.columnWidths) && (k.w = k.columnWidths.reduce((P, D) => P + D, 0));
            }
            function R(k) {
              switch (k.layout) {
                case "position":
                  return "xfaPosition";
                case "lr-tb":
                  return "xfaLrTb";
                case "rl-row":
                  return "xfaRlRow";
                case "rl-tb":
                  return "xfaRlTb";
                case "row":
                  return "xfaRow";
                case "table":
                  return "xfaTable";
                case "tb":
                  return "xfaTb";
                default:
                  return "xfaPosition";
              }
            }
            function O(k, ...N) {
              const P = /* @__PURE__ */ Object.create(null);
              for (const D of N) {
                const H = k[D];
                if (H !== null) {
                  if (S.hasOwnProperty(D)) {
                    S[D](k, P);
                    continue;
                  }
                  if (H instanceof C.XFAObject) {
                    const V = H[g.$toStyle]();
                    V ? Object.assign(P, V) : (0, b.warn)(`(DEBUG) - XFA - style for ${D} not implemented yet`);
                  }
                }
              }
              return P;
            }
            function L(k, N) {
              const {
                attributes: P
              } = N, {
                style: D
              } = P, H = {
                name: "div",
                attributes: {
                  class: ["xfaWrapper"],
                  style: /* @__PURE__ */ Object.create(null)
                },
                children: []
              };
              if (P.class.push("xfaWrapped"), k.border) {
                const {
                  widths: V,
                  insets: Z
                } = k.border[g.$extra];
                let ne, K, q = Z[0], Y = Z[3];
                const ee = Z[0] + Z[2], Q = Z[1] + Z[3];
                switch (k.border.hand) {
                  case "even":
                    q -= V[0] / 2, Y -= V[3] / 2, ne = `calc(100% + ${(V[1] + V[3]) / 2 - Q}px)`, K = `calc(100% + ${(V[0] + V[2]) / 2 - ee}px)`;
                    break;
                  case "left":
                    q -= V[0], Y -= V[3], ne = `calc(100% + ${V[1] + V[3] - Q}px)`, K = `calc(100% + ${V[0] + V[2] - ee}px)`;
                    break;
                  case "right":
                    ne = Q ? `calc(100% - ${Q}px)` : "100%", K = ee ? `calc(100% - ${ee}px)` : "100%";
                    break;
                }
                const J = ["xfaBorder"];
                M(k.border) && J.push("xfaPrintOnly");
                const te = {
                  name: "div",
                  attributes: {
                    class: J,
                    style: {
                      top: `${q}px`,
                      left: `${Y}px`,
                      width: ne,
                      height: K
                    }
                  },
                  children: []
                };
                for (const ae of ["border", "borderWidth", "borderColor", "borderRadius", "borderStyle"])
                  D[ae] !== void 0 && (te.attributes.style[ae] = D[ae], delete D[ae]);
                H.children.push(te, N);
              } else
                H.children.push(N);
              for (const V of ["background", "backgroundClip", "top", "left", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "transform", "transformOrigin", "visibility"])
                D[V] !== void 0 && (H.attributes.style[V] = D[V], delete D[V]);
              return H.attributes.style.position = D.position === "absolute" ? "absolute" : "relative", delete D.position, D.alignSelf && (H.attributes.style.alignSelf = D.alignSelf, delete D.alignSelf), H;
            }
            function B(k) {
              const N = (0, y.getMeasurement)(k.textIndent, "0px");
              if (N >= 0)
                return;
              const D = "padding" + ((k.textAlign === "right" ? "right" : "left") === "left" ? "Left" : "Right"), H = (0, y.getMeasurement)(k[D], "0px");
              k[D] = `${H - N}px`;
            }
            function F(k, N) {
              switch (k.access) {
                case "nonInteractive":
                  N.push("xfaNonInteractive");
                  break;
                case "readOnly":
                  N.push("xfaReadOnly");
                  break;
                case "protected":
                  N.push("xfaDisabled");
                  break;
              }
            }
            function M(k) {
              return k.relevant.length > 0 && !k.relevant[0].excluded && k.relevant[0].viewname === "print";
            }
            function W(k) {
              const N = k[g.$getTemplateRoot]()[g.$extra].paraStack;
              return N.length ? N.at(-1) : null;
            }
            function j(k, N, P) {
              if (P.attributes.class?.includes("xfaRich")) {
                N && (k.h === "" && (N.height = "auto"), k.w === "" && (N.width = "auto"));
                const D = W(k);
                if (D) {
                  const H = P.attributes.style;
                  switch (H.display = "flex", H.flexDirection = "column", D.vAlign) {
                    case "top":
                      H.justifyContent = "start";
                      break;
                    case "bottom":
                      H.justifyContent = "end";
                      break;
                    case "middle":
                      H.justifyContent = "center";
                      break;
                  }
                  const V = D[g.$toStyle]();
                  for (const [Z, ne] of Object.entries(V))
                    Z in H || (H[Z] = ne);
                }
              }
            }
            function G(k, N, P, D) {
              if (!P) {
                delete D.fontFamily;
                return;
              }
              const H = (0, y.stripQuotes)(k.typeface);
              D.fontFamily = `"${H}"`;
              const V = P.find(H);
              if (V) {
                const {
                  fontFamily: Z
                } = V.regular.cssFontInfo;
                Z !== H && (D.fontFamily = `"${Z}"`);
                const ne = W(N);
                if (ne && ne.lineHeight !== "" || D.lineHeight)
                  return;
                const K = (0, f.selectFont)(k, V);
                K && (D.lineHeight = Math.max(1.2, K.lineHeight));
              }
            }
            function U(k) {
              const N = (0, b.createValidAbsoluteUrl)(k, null, {
                addDefaultProtocol: !0,
                tryConvertEncoding: !0
              });
              return N ? N.href : null;
            }
          },
          /* 84 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.HTMLResult = void 0, A.getBBox = E, A.getColor = _, A.getFloat = C, A.getInteger = m, A.getKeyword = w, A.getMeasurement = $, A.getRatio = T, A.getRelevant = I, A.getStringOption = S, A.stripQuotes = f;
            var g = x(2);
            const b = {
              pt: (O) => O,
              cm: (O) => O / 2.54 * 72,
              mm: (O) => O / (10 * 2.54) * 72,
              in: (O) => O * 72,
              px: (O) => O
            }, y = /([+-]?\d+\.?\d*)(.*)/;
            function f(O) {
              return O.startsWith("'") || O.startsWith('"') ? O.slice(1, -1) : O;
            }
            function m({
              data: O,
              defaultValue: L,
              validate: B
            }) {
              if (!O)
                return L;
              O = O.trim();
              const F = parseInt(O, 10);
              return !isNaN(F) && B(F) ? F : L;
            }
            function C({
              data: O,
              defaultValue: L,
              validate: B
            }) {
              if (!O)
                return L;
              O = O.trim();
              const F = parseFloat(O);
              return !isNaN(F) && B(F) ? F : L;
            }
            function w({
              data: O,
              defaultValue: L,
              validate: B
            }) {
              return O ? (O = O.trim(), B(O) ? O : L) : L;
            }
            function S(O, L) {
              return w({
                data: O,
                defaultValue: L[0],
                validate: (B) => L.includes(B)
              });
            }
            function $(O, L = "0") {
              if (L ||= "0", !O)
                return $(L);
              const B = O.trim().match(y);
              if (!B)
                return $(L);
              const [, F, M] = B, W = parseFloat(F);
              if (isNaN(W))
                return $(L);
              if (W === 0)
                return 0;
              const j = b[M];
              return j ? j(W) : W;
            }
            function T(O) {
              if (!O)
                return {
                  num: 1,
                  den: 1
                };
              const L = O.trim().split(/\s*:\s*/).map((M) => parseFloat(M)).filter((M) => !isNaN(M));
              if (L.length === 1 && L.push(1), L.length === 0)
                return {
                  num: 1,
                  den: 1
                };
              const [B, F] = L;
              return {
                num: B,
                den: F
              };
            }
            function I(O) {
              return O ? O.trim().split(/\s+/).map((L) => ({
                excluded: L[0] === "-",
                viewname: L.substring(1)
              })) : [];
            }
            function _(O, L = [0, 0, 0]) {
              let [B, F, M] = L;
              if (!O)
                return {
                  r: B,
                  g: F,
                  b: M
                };
              const W = O.trim().split(/\s*,\s*/).map((j) => Math.min(Math.max(0, parseInt(j.trim(), 10)), 255)).map((j) => isNaN(j) ? 0 : j);
              return W.length < 3 ? {
                r: B,
                g: F,
                b: M
              } : ([B, F, M] = W, {
                r: B,
                g: F,
                b: M
              });
            }
            function E(O) {
              if (!O)
                return {
                  x: -1,
                  y: -1,
                  width: -1,
                  height: -1
                };
              const B = O.trim().split(/\s*,\s*/).map((G) => $(G, "-1"));
              if (B.length < 4 || B[2] < 0 || B[3] < 0)
                return {
                  x: -1,
                  y: -1,
                  width: -1,
                  height: -1
                };
              const [F, M, W, j] = B;
              return {
                x: F,
                y: M,
                width: W,
                height: j
              };
            }
            class R {
              static get FAILURE() {
                return (0, g.shadow)(this, "FAILURE", new R(!1, null, null, null));
              }
              static get EMPTY() {
                return (0, g.shadow)(this, "EMPTY", new R(!0, null, null, null));
              }
              constructor(L, B, F, M) {
                this.success = L, this.html = B, this.bbox = F, this.breakNode = M;
              }
              isBreak() {
                return !!this.breakNode;
              }
              static breakNode(L) {
                return new R(!1, null, null, L);
              }
              static success(L, B = null) {
                return new R(!0, L, B, null);
              }
            }
            A.HTMLResult = R;
          },
          /* 85 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.FontFinder = void 0, A.getMetrics = C, A.selectFont = m;
            var g = x(78), b = x(84), y = x(2);
            class f {
              constructor(S) {
                this.fonts = /* @__PURE__ */ new Map(), this.cache = /* @__PURE__ */ new Map(), this.warned = /* @__PURE__ */ new Set(), this.defaultFont = null, this.add(S);
              }
              add(S, $ = null) {
                for (const I of S)
                  this.addPdfFont(I);
                for (const I of this.fonts.values())
                  I.regular || (I.regular = I.italic || I.bold || I.bolditalic);
                if (!$ || $.size === 0)
                  return;
                const T = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
                for (const I of $)
                  this.fonts.set(I, T);
              }
              addPdfFont(S) {
                const $ = S.cssFontInfo, T = $.fontFamily;
                let I = this.fonts.get(T);
                I || (I = /* @__PURE__ */ Object.create(null), this.fonts.set(T, I), this.defaultFont || (this.defaultFont = I));
                let _ = "";
                const E = parseFloat($.fontWeight);
                parseFloat($.italicAngle) !== 0 ? _ = E >= 700 ? "bolditalic" : "italic" : E >= 700 && (_ = "bold"), _ || ((S.name.includes("Bold") || S.psName?.includes("Bold")) && (_ = "bold"), (S.name.includes("Italic") || S.name.endsWith("It") || S.psName?.includes("Italic") || S.psName?.endsWith("It")) && (_ += "italic")), _ || (_ = "regular"), I[_] = S;
              }
              getDefault() {
                return this.defaultFont;
              }
              find(S, $ = !0) {
                let T = this.fonts.get(S) || this.cache.get(S);
                if (T)
                  return T;
                const I = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
                let _ = S.replaceAll(I, "");
                if (T = this.fonts.get(_), T)
                  return this.cache.set(S, T), T;
                _ = _.toLowerCase();
                const E = [];
                for (const [R, O] of this.fonts.entries())
                  R.replaceAll(I, "").toLowerCase().startsWith(_) && E.push(O);
                if (E.length === 0)
                  for (const [, R] of this.fonts.entries())
                    R.regular.name?.replaceAll(I, "").toLowerCase().startsWith(_) && E.push(R);
                if (E.length === 0) {
                  _ = _.replaceAll(/psmt|mt/gi, "");
                  for (const [R, O] of this.fonts.entries())
                    R.replaceAll(I, "").toLowerCase().startsWith(_) && E.push(O);
                }
                if (E.length === 0)
                  for (const R of this.fonts.values())
                    R.regular.name?.replaceAll(I, "").toLowerCase().startsWith(_) && E.push(R);
                return E.length >= 1 ? (E.length !== 1 && $ && (0, y.warn)(`XFA - Too many choices to guess the correct font: ${S}`), this.cache.set(S, E[0]), E[0]) : ($ && !this.warned.has(S) && (this.warned.add(S), (0, y.warn)(`XFA - Cannot find the font: ${S}`)), null);
              }
            }
            A.FontFinder = f;
            function m(w, S) {
              return w.posture === "italic" ? w.weight === "bold" ? S.bolditalic : S.italic : w.weight === "bold" ? S.bold : S.regular;
            }
            function C(w, S = !1) {
              let $ = null;
              if (w) {
                const E = (0, b.stripQuotes)(w.typeface), R = w[g.$globalData].fontFinder.find(E);
                $ = m(w, R);
              }
              if (!$)
                return {
                  lineHeight: 12,
                  lineGap: 2,
                  lineNoGap: 10
                };
              const T = w.size || 10, I = $.lineHeight ? Math.max(S ? 0 : 1.2, $.lineHeight) : 1.2, _ = $.lineGap === void 0 ? 0.2 : $.lineGap;
              return {
                lineHeight: I * T,
                lineGap: _ * T,
                lineNoGap: Math.max(1, I - _) * T
              };
            }
          },
          /* 86 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.TextMeasure = void 0;
            var g = x(85);
            const b = 1.02;
            class y {
              constructor(w, S, $, T) {
                if (this.lineHeight = $, this.paraMargin = S || {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0
                }, !w) {
                  [this.pdfFont, this.xfaFont] = this.defaultFont(T);
                  return;
                }
                this.xfaFont = {
                  typeface: w.typeface,
                  posture: w.posture,
                  weight: w.weight,
                  size: w.size,
                  letterSpacing: w.letterSpacing
                };
                const I = T.find(w.typeface);
                if (!I) {
                  [this.pdfFont, this.xfaFont] = this.defaultFont(T);
                  return;
                }
                this.pdfFont = (0, g.selectFont)(w, I), this.pdfFont || ([this.pdfFont, this.xfaFont] = this.defaultFont(T));
              }
              defaultFont(w) {
                const S = w.find("Helvetica", !1) || w.find("Myriad Pro", !1) || w.find("Arial", !1) || w.getDefault();
                if (S?.regular) {
                  const T = S.regular, _ = {
                    typeface: T.cssFontInfo.fontFamily,
                    posture: "normal",
                    weight: "normal",
                    size: 10,
                    letterSpacing: 0
                  };
                  return [T, _];
                }
                return [null, {
                  typeface: "Courier",
                  posture: "normal",
                  weight: "normal",
                  size: 10,
                  letterSpacing: 0
                }];
              }
            }
            class f {
              constructor(w, S, $, T) {
                this.fontFinder = T, this.stack = [new y(w, S, $, T)];
              }
              pushData(w, S, $) {
                const T = this.stack.at(-1);
                for (const _ of ["typeface", "posture", "weight", "size", "letterSpacing"])
                  w[_] || (w[_] = T.xfaFont[_]);
                for (const _ of ["top", "bottom", "left", "right"])
                  isNaN(S[_]) && (S[_] = T.paraMargin[_]);
                const I = new y(w, S, $ || T.lineHeight, this.fontFinder);
                I.pdfFont || (I.pdfFont = T.pdfFont), this.stack.push(I);
              }
              popFont() {
                this.stack.pop();
              }
              topFont() {
                return this.stack.at(-1);
              }
            }
            class m {
              constructor(w, S, $, T) {
                this.glyphs = [], this.fontSelector = new f(w, S, $, T), this.extraHeight = 0;
              }
              pushData(w, S, $) {
                this.fontSelector.pushData(w, S, $);
              }
              popFont(w) {
                return this.fontSelector.popFont();
              }
              addPara() {
                const w = this.fontSelector.topFont();
                this.extraHeight += w.paraMargin.top + w.paraMargin.bottom;
              }
              addString(w) {
                if (!w)
                  return;
                const S = this.fontSelector.topFont(), $ = S.xfaFont.size;
                if (S.pdfFont) {
                  const T = S.xfaFont.letterSpacing, I = S.pdfFont, _ = I.lineHeight || 1.2, E = S.lineHeight || Math.max(1.2, _) * $, R = I.lineGap === void 0 ? 0.2 : I.lineGap, O = _ - R, L = Math.max(1, O) * $, B = $ / 1e3, F = I.defaultWidth || I.charsToGlyphs(" ")[0].width;
                  for (const M of w.split(/[\u2029\n]/)) {
                    const W = I.encodeString(M).join(""), j = I.charsToGlyphs(W);
                    for (const G of j) {
                      const U = G.width || F;
                      this.glyphs.push([U * B + T, E, L, G.unicode, !1]);
                    }
                    this.glyphs.push([0, 0, 0, `
`, !0]);
                  }
                  this.glyphs.pop();
                  return;
                }
                for (const T of w.split(/[\u2029\n]/)) {
                  for (const I of T.split(""))
                    this.glyphs.push([$, 1.2 * $, $, I, !1]);
                  this.glyphs.push([0, 0, 0, `
`, !0]);
                }
                this.glyphs.pop();
              }
              compute(w) {
                let S = -1, $ = 0, T = 0, I = 0, _ = 0, E = 0, R = !1, O = !0;
                for (let L = 0, B = this.glyphs.length; L < B; L++) {
                  const [F, M, W, j, G] = this.glyphs[L], U = j === " ", k = O ? W : M;
                  if (G) {
                    T = Math.max(T, _), _ = 0, I += E, E = k, S = -1, $ = 0, O = !1;
                    continue;
                  }
                  if (U) {
                    _ + F > w ? (T = Math.max(T, _), _ = 0, I += E, E = k, S = -1, $ = 0, R = !0, O = !1) : (E = Math.max(k, E), $ = _, _ += F, S = L);
                    continue;
                  }
                  if (_ + F > w) {
                    I += E, E = k, S !== -1 ? (L = S, T = Math.max(T, $), _ = 0, S = -1, $ = 0) : (T = Math.max(T, _), _ = F), R = !0, O = !1;
                    continue;
                  }
                  _ += F, E = Math.max(k, E);
                }
                return T = Math.max(T, _), I += E + this.extraHeight, {
                  width: b * T,
                  height: I,
                  isBroken: R
                };
              }
            }
            A.TextMeasure = m;
          },
          /* 87 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.XmlObject = A.XFAObjectArray = A.XFAObject = A.XFAAttribute = A.StringObject = A.OptionObject = A.Option10 = A.Option01 = A.IntegerObject = A.ContentObject = void 0;
            var g = x(78), b = x(84), y = x(2), f = x(3), m = x(81), C = x(88);
            const w = Symbol(), S = Symbol(), $ = Symbol(), T = Symbol("_children"), I = Symbol(), _ = Symbol(), E = Symbol(), R = Symbol(), O = Symbol(), L = Symbol(), B = Symbol(), F = Symbol(), M = Symbol(), W = Symbol("parent"), j = Symbol(), G = Symbol(), U = Symbol();
            let k = 0;
            const N = m.NamespaceIds.datasets.id;
            class P {
              constructor(J, te, ae = !1) {
                this[g.$namespaceId] = J, this[g.$nodeName] = te, this[B] = ae, this[W] = null, this[T] = [], this[g.$uid] = `${te}${k++}`, this[g.$globalData] = null;
              }
              get isXFAObject() {
                return !0;
              }
              get isXFAObjectArray() {
                return !1;
              }
              createNodes(J) {
                let te = this, ae = null;
                for (const {
                  name: se,
                  index: ie
                } of J) {
                  for (let fe = 0, ge = isFinite(ie) ? ie : 0; fe <= ge; fe++) {
                    const me = te[g.$namespaceId] === N ? -1 : te[g.$namespaceId];
                    ae = new V(me, se), te[g.$appendChild](ae);
                  }
                  te = ae;
                }
                return ae;
              }
              [g.$onChild](J) {
                if (!this[B] || !this[g.$onChildCheck](J))
                  return !1;
                const te = J[g.$nodeName], ae = this[te];
                if (ae instanceof D) {
                  if (ae.push(J))
                    return this[g.$appendChild](J), !0;
                } else
                  return ae !== null && this[g.$removeChild](ae), this[te] = J, this[g.$appendChild](J), !0;
                let se = "";
                return this.id ? se = ` (id: ${this.id})` : this.name && (se = ` (name: ${this.name} ${this.h.value})`), (0, y.warn)(`XFA - node "${this[g.$nodeName]}"${se} has already enough "${te}"!`), !1;
              }
              [g.$onChildCheck](J) {
                return this.hasOwnProperty(J[g.$nodeName]) && J[g.$namespaceId] === this[g.$namespaceId];
              }
              [g.$isNsAgnostic]() {
                return !1;
              }
              [g.$acceptWhitespace]() {
                return !1;
              }
              [g.$isCDATAXml]() {
                return !1;
              }
              [g.$isBindable]() {
                return !1;
              }
              [g.$popPara]() {
                this.para && this[g.$getTemplateRoot]()[g.$extra].paraStack.pop();
              }
              [g.$pushPara]() {
                this[g.$getTemplateRoot]()[g.$extra].paraStack.push(this.para);
              }
              [g.$setId](J) {
                this.id && this[g.$namespaceId] === m.NamespaceIds.template.id && J.set(this.id, this);
              }
              [g.$getTemplateRoot]() {
                return this[g.$globalData].template;
              }
              [g.$isSplittable]() {
                return !1;
              }
              [g.$isThereMoreWidth]() {
                return !1;
              }
              [g.$appendChild](J) {
                J[W] = this, this[T].push(J), !J[g.$globalData] && this[g.$globalData] && (J[g.$globalData] = this[g.$globalData]);
              }
              [g.$removeChild](J) {
                const te = this[T].indexOf(J);
                this[T].splice(te, 1);
              }
              [g.$hasSettableValue]() {
                return this.hasOwnProperty("value");
              }
              [g.$setValue](J) {
              }
              [g.$onText](J) {
              }
              [g.$finalize]() {
              }
              [g.$clean](J) {
                delete this[B], this[g.$cleanup] && (J.clean(this[g.$cleanup]), delete this[g.$cleanup]);
              }
              [g.$indexOf](J) {
                return this[T].indexOf(J);
              }
              [g.$insertAt](J, te) {
                te[W] = this, this[T].splice(J, 0, te), !te[g.$globalData] && this[g.$globalData] && (te[g.$globalData] = this[g.$globalData]);
              }
              [g.$isTransparent]() {
                return !this.name;
              }
              [g.$lastAttribute]() {
                return "";
              }
              [g.$text]() {
                return this[T].length === 0 ? this[g.$content] : this[T].map((J) => J[g.$text]()).join("");
              }
              get [$]() {
                const J = Object.getPrototypeOf(this);
                if (!J._attributes) {
                  const te = J._attributes = /* @__PURE__ */ new Set();
                  for (const ae of Object.getOwnPropertyNames(this)) {
                    if (this[ae] === null || this[ae] instanceof P || this[ae] instanceof D)
                      break;
                    te.add(ae);
                  }
                }
                return (0, y.shadow)(this, $, J._attributes);
              }
              [g.$isDescendent](J) {
                let te = this;
                for (; te; ) {
                  if (te === J)
                    return !0;
                  te = te[g.$getParent]();
                }
                return !1;
              }
              [g.$getParent]() {
                return this[W];
              }
              [g.$getSubformParent]() {
                return this[g.$getParent]();
              }
              [g.$getChildren](J = null) {
                return J ? this[J] : this[T];
              }
              [g.$dump]() {
                const J = /* @__PURE__ */ Object.create(null);
                this[g.$content] && (J.$content = this[g.$content]);
                for (const te of Object.getOwnPropertyNames(this)) {
                  const ae = this[te];
                  ae !== null && (ae instanceof P ? J[te] = ae[g.$dump]() : ae instanceof D ? ae.isEmpty() || (J[te] = ae.dump()) : J[te] = ae);
                }
                return J;
              }
              [g.$toStyle]() {
                return null;
              }
              [g.$toHTML]() {
                return b.HTMLResult.EMPTY;
              }
              *[g.$getContainedChildren]() {
                for (const J of this[g.$getChildren]())
                  yield J;
              }
              *[R](J, te) {
                for (const ae of this[g.$getContainedChildren]())
                  if (!J || te === J.has(ae[g.$nodeName])) {
                    const se = this[g.$getAvailableSpace](), ie = ae[g.$toHTML](se);
                    ie.success || (this[g.$extra].failingNode = ae), yield ie;
                  }
              }
              [g.$flushHTML]() {
                return null;
              }
              [g.$addHTML](J, te) {
                this[g.$extra].children.push(J);
              }
              [g.$getAvailableSpace]() {
              }
              [g.$childrenToHTML]({
                filter: J = null,
                include: te = !0
              }) {
                if (!this[g.$extra].generator)
                  this[g.$extra].generator = this[R](J, te);
                else {
                  const ae = this[g.$getAvailableSpace](), se = this[g.$extra].failingNode[g.$toHTML](ae);
                  if (!se.success)
                    return se;
                  se.html && this[g.$addHTML](se.html, se.bbox), delete this[g.$extra].failingNode;
                }
                for (; ; ) {
                  const ae = this[g.$extra].generator.next();
                  if (ae.done)
                    break;
                  const se = ae.value;
                  if (!se.success)
                    return se;
                  se.html && this[g.$addHTML](se.html, se.bbox);
                }
                return this[g.$extra].generator = null, b.HTMLResult.EMPTY;
              }
              [g.$setSetAttributes](J) {
                this[G] = new Set(Object.keys(J));
              }
              [L](J) {
                const te = this[$], ae = this[G];
                return [...J].filter((se) => te.has(se) && !ae.has(se));
              }
              [g.$resolvePrototypes](J, te = /* @__PURE__ */ new Set()) {
                for (const ae of this[T])
                  ae[j](J, te);
              }
              [j](J, te) {
                const ae = this[O](J, te);
                ae ? this[w](ae, J, te) : this[g.$resolvePrototypes](J, te);
              }
              [O](J, te) {
                const {
                  use: ae,
                  usehref: se
                } = this;
                if (!ae && !se)
                  return null;
                let ie = null, fe = null, ge = null, me = ae;
                if (se ? (me = se, se.startsWith("#som(") && se.endsWith(")") ? fe = se.slice(5, -1) : se.startsWith(".#som(") && se.endsWith(")") ? fe = se.slice(6, -1) : se.startsWith("#") ? ge = se.slice(1) : se.startsWith(".#") && (ge = se.slice(2))) : ae.startsWith("#") ? ge = ae.slice(1) : fe = ae, this.use = this.usehref = "", ge ? ie = J.get(ge) : (ie = (0, C.searchNode)(J.get(g.$root), this, fe, !0, !1), ie && (ie = ie[0])), !ie)
                  return (0, y.warn)(`XFA - Invalid prototype reference: ${me}.`), null;
                if (ie[g.$nodeName] !== this[g.$nodeName])
                  return (0, y.warn)(`XFA - Incompatible prototype: ${ie[g.$nodeName]} !== ${this[g.$nodeName]}.`), null;
                if (te.has(ie))
                  return (0, y.warn)("XFA - Cycle detected in prototypes use."), null;
                te.add(ie);
                const pe = ie[O](J, te);
                return pe && ie[w](pe, J, te), ie[g.$resolvePrototypes](J, te), te.delete(ie), ie;
              }
              [w](J, te, ae) {
                if (ae.has(J)) {
                  (0, y.warn)("XFA - Cycle detected in prototypes use.");
                  return;
                }
                !this[g.$content] && J[g.$content] && (this[g.$content] = J[g.$content]), new Set(ae).add(J);
                for (const ie of this[L](J[G]))
                  this[ie] = J[ie], this[G] && this[G].add(ie);
                for (const ie of Object.getOwnPropertyNames(this)) {
                  if (this[$].has(ie))
                    continue;
                  const fe = this[ie], ge = J[ie];
                  if (fe instanceof D) {
                    for (const me of fe[T])
                      me[j](te, ae);
                    for (let me = fe[T].length, pe = ge[T].length; me < pe; me++) {
                      const be = J[T][me][g.$clone]();
                      if (fe.push(be))
                        be[W] = this, this[T].push(be), be[j](te, ae);
                      else
                        break;
                    }
                    continue;
                  }
                  if (fe !== null) {
                    fe[g.$resolvePrototypes](te, ae), ge && fe[w](ge, te, ae);
                    continue;
                  }
                  if (ge !== null) {
                    const me = ge[g.$clone]();
                    me[W] = this, this[ie] = me, this[T].push(me), me[j](te, ae);
                  }
                }
              }
              static [I](J) {
                return Array.isArray(J) ? J.map((te) => P[I](te)) : typeof J == "object" && J !== null ? Object.assign({}, J) : J;
              }
              [g.$clone]() {
                const J = Object.create(Object.getPrototypeOf(this));
                for (const te of Object.getOwnPropertySymbols(this))
                  try {
                    J[te] = this[te];
                  } catch {
                    (0, y.shadow)(J, te, this[te]);
                  }
                J[g.$uid] = `${J[g.$nodeName]}${k++}`, J[T] = [];
                for (const te of Object.getOwnPropertyNames(this)) {
                  if (this[$].has(te)) {
                    J[te] = P[I](this[te]);
                    continue;
                  }
                  const ae = this[te];
                  J[te] = ae instanceof D ? new D(ae[F]) : null;
                }
                for (const te of this[T]) {
                  const ae = te[g.$nodeName], se = te[g.$clone]();
                  J[T].push(se), se[W] = J, J[ae] === null ? J[ae] = se : J[ae][T].push(se);
                }
                return J;
              }
              [g.$getChildren](J = null) {
                return J ? this[T].filter((te) => te[g.$nodeName] === J) : this[T];
              }
              [g.$getChildrenByClass](J) {
                return this[J];
              }
              [g.$getChildrenByName](J, te, ae = !0) {
                return Array.from(this[g.$getChildrenByNameIt](J, te, ae));
              }
              *[g.$getChildrenByNameIt](J, te, ae = !0) {
                if (J === "parent") {
                  yield this[W];
                  return;
                }
                for (const se of this[T])
                  se[g.$nodeName] === J && (yield se), se.name === J && (yield se), (te || se[g.$isTransparent]()) && (yield* se[g.$getChildrenByNameIt](J, te, !1));
                ae && this[$].has(J) && (yield new H(this, J, this[J]));
              }
            }
            A.XFAObject = P;
            class D {
              constructor(J = 1 / 0) {
                this[F] = J, this[T] = [];
              }
              get isXFAObject() {
                return !1;
              }
              get isXFAObjectArray() {
                return !0;
              }
              push(J) {
                return this[T].length <= this[F] ? (this[T].push(J), !0) : ((0, y.warn)(`XFA - node "${J[g.$nodeName]}" accepts no more than ${this[F]} children`), !1);
              }
              isEmpty() {
                return this[T].length === 0;
              }
              dump() {
                return this[T].length === 1 ? this[T][0][g.$dump]() : this[T].map((J) => J[g.$dump]());
              }
              [g.$clone]() {
                const J = new D(this[F]);
                return J[T] = this[T].map((te) => te[g.$clone]()), J;
              }
              get children() {
                return this[T];
              }
              clear() {
                this[T].length = 0;
              }
            }
            A.XFAObjectArray = D;
            class H {
              constructor(J, te, ae) {
                this[W] = J, this[g.$nodeName] = te, this[g.$content] = ae, this[g.$consumed] = !1, this[g.$uid] = `attribute${k++}`;
              }
              [g.$getParent]() {
                return this[W];
              }
              [g.$isDataValue]() {
                return !0;
              }
              [g.$getDataValue]() {
                return this[g.$content].trim();
              }
              [g.$setValue](J) {
                J = J.value || "", this[g.$content] = J.toString();
              }
              [g.$text]() {
                return this[g.$content];
              }
              [g.$isDescendent](J) {
                return this[W] === J || this[W][g.$isDescendent](J);
              }
            }
            A.XFAAttribute = H;
            class V extends P {
              constructor(J, te, ae = {}) {
                if (super(J, te), this[g.$content] = "", this[_] = null, te !== "#text") {
                  const se = /* @__PURE__ */ new Map();
                  this[S] = se;
                  for (const [ie, fe] of Object.entries(ae))
                    se.set(ie, new H(this, ie, fe));
                  if (ae.hasOwnProperty(g.$nsAttributes)) {
                    const ie = ae[g.$nsAttributes].xfa.dataNode;
                    ie !== void 0 && (ie === "dataGroup" ? this[_] = !1 : ie === "dataValue" && (this[_] = !0));
                  }
                }
                this[g.$consumed] = !1;
              }
              [g.$toString](J) {
                const te = this[g.$nodeName];
                if (te === "#text") {
                  J.push((0, f.encodeToXmlString)(this[g.$content]));
                  return;
                }
                const ae = (0, y.utf8StringToString)(te), se = this[g.$namespaceId] === N ? "xfa:" : "";
                J.push(`<${se}${ae}`);
                for (const [ie, fe] of this[S].entries()) {
                  const ge = (0, y.utf8StringToString)(ie);
                  J.push(` ${ge}="${(0, f.encodeToXmlString)(fe[g.$content])}"`);
                }
                if (this[_] !== null && (this[_] ? J.push(' xfa:dataNode="dataValue"') : J.push(' xfa:dataNode="dataGroup"')), !this[g.$content] && this[T].length === 0) {
                  J.push("/>");
                  return;
                }
                if (J.push(">"), this[g.$content])
                  typeof this[g.$content] == "string" ? J.push((0, f.encodeToXmlString)(this[g.$content])) : this[g.$content][g.$toString](J);
                else
                  for (const ie of this[T])
                    ie[g.$toString](J);
                J.push(`</${se}${ae}>`);
              }
              [g.$onChild](J) {
                if (this[g.$content]) {
                  const te = new V(this[g.$namespaceId], "#text");
                  this[g.$appendChild](te), te[g.$content] = this[g.$content], this[g.$content] = "";
                }
                return this[g.$appendChild](J), !0;
              }
              [g.$onText](J) {
                this[g.$content] += J;
              }
              [g.$finalize]() {
                if (this[g.$content] && this[T].length > 0) {
                  const J = new V(this[g.$namespaceId], "#text");
                  this[g.$appendChild](J), J[g.$content] = this[g.$content], delete this[g.$content];
                }
              }
              [g.$toHTML]() {
                return this[g.$nodeName] === "#text" ? b.HTMLResult.success({
                  name: "#text",
                  value: this[g.$content]
                }) : b.HTMLResult.EMPTY;
              }
              [g.$getChildren](J = null) {
                return J ? this[T].filter((te) => te[g.$nodeName] === J) : this[T];
              }
              [g.$getAttributes]() {
                return this[S];
              }
              [g.$getChildrenByClass](J) {
                const te = this[S].get(J);
                return te !== void 0 ? te : this[g.$getChildren](J);
              }
              *[g.$getChildrenByNameIt](J, te) {
                const ae = this[S].get(J);
                ae && (yield ae);
                for (const se of this[T])
                  se[g.$nodeName] === J && (yield se), te && (yield* se[g.$getChildrenByNameIt](J, te));
              }
              *[g.$getAttributeIt](J, te) {
                const ae = this[S].get(J);
                ae && (!te || !ae[g.$consumed]) && (yield ae);
                for (const se of this[T])
                  yield* se[g.$getAttributeIt](J, te);
              }
              *[g.$getRealChildrenByNameIt](J, te, ae) {
                for (const se of this[T])
                  se[g.$nodeName] === J && (!ae || !se[g.$consumed]) && (yield se), te && (yield* se[g.$getRealChildrenByNameIt](J, te, ae));
              }
              [g.$isDataValue]() {
                return this[_] === null ? this[T].length === 0 || this[T][0][g.$namespaceId] === m.NamespaceIds.xhtml.id : this[_];
              }
              [g.$getDataValue]() {
                return this[_] === null ? this[T].length === 0 ? this[g.$content].trim() : this[T][0][g.$namespaceId] === m.NamespaceIds.xhtml.id ? this[T][0][g.$text]().trim() : null : this[g.$content].trim();
              }
              [g.$setValue](J) {
                J = J.value || "", this[g.$content] = J.toString();
              }
              [g.$dump](J = !1) {
                const te = /* @__PURE__ */ Object.create(null);
                J && (te.$ns = this[g.$namespaceId]), this[g.$content] && (te.$content = this[g.$content]), te.$name = this[g.$nodeName], te.children = [];
                for (const ae of this[T])
                  te.children.push(ae[g.$dump](J));
                te.attributes = /* @__PURE__ */ Object.create(null);
                for (const [ae, se] of this[S])
                  te.attributes[ae] = se[g.$content];
                return te;
              }
            }
            A.XmlObject = V;
            class Z extends P {
              constructor(J, te) {
                super(J, te), this[g.$content] = "";
              }
              [g.$onText](J) {
                this[g.$content] += J;
              }
              [g.$finalize]() {
              }
            }
            A.ContentObject = Z;
            class ne extends Z {
              constructor(J, te, ae) {
                super(J, te), this[M] = ae;
              }
              [g.$finalize]() {
                this[g.$content] = (0, b.getKeyword)({
                  data: this[g.$content],
                  defaultValue: this[M][0],
                  validate: (J) => this[M].includes(J)
                });
              }
              [g.$clean](J) {
                super[g.$clean](J), delete this[M];
              }
            }
            A.OptionObject = ne;
            class K extends Z {
              [g.$finalize]() {
                this[g.$content] = this[g.$content].trim();
              }
            }
            A.StringObject = K;
            class q extends Z {
              constructor(J, te, ae, se) {
                super(J, te), this[E] = ae, this[U] = se;
              }
              [g.$finalize]() {
                this[g.$content] = (0, b.getInteger)({
                  data: this[g.$content],
                  defaultValue: this[E],
                  validate: this[U]
                });
              }
              [g.$clean](J) {
                super[g.$clean](J), delete this[E], delete this[U];
              }
            }
            A.IntegerObject = q;
            class Y extends q {
              constructor(J, te) {
                super(J, te, 0, (ae) => ae === 1);
              }
            }
            A.Option01 = Y;
            class ee extends q {
              constructor(J, te) {
                super(J, te, 1, (ae) => ae === 0);
              }
            }
            A.Option10 = ee;
          },
          /* 88 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.createDataNode = I, A.searchNode = T;
            var g = x(78), b = x(2);
            const y = /^[^.[]+/, f = /^[^\]]+/, m = {
              dot: 0,
              dotDot: 1,
              dotHash: 2,
              dotBracket: 3,
              dotParen: 4
            }, C = /* @__PURE__ */ new Map([["$data", (_, E) => _.datasets ? _.datasets.data : _], ["$record", (_, E) => (_.datasets ? _.datasets.data : _)[g.$getChildren]()[0]], ["$template", (_, E) => _.template], ["$connectionSet", (_, E) => _.connectionSet], ["$form", (_, E) => _.form], ["$layout", (_, E) => _.layout], ["$host", (_, E) => _.host], ["$dataWindow", (_, E) => _.dataWindow], ["$event", (_, E) => _.event], ["!", (_, E) => _.datasets], ["$xfa", (_, E) => _], ["xfa", (_, E) => _], ["$", (_, E) => E]]), w = /* @__PURE__ */ new WeakMap();
            function S(_) {
              return _ = _.trim(), _ === "*" ? 1 / 0 : parseInt(_, 10) || 0;
            }
            function $(_, E, R = !0) {
              let O = _.match(y);
              if (!O)
                return null;
              let [L] = O;
              const B = [{
                name: L,
                cacheName: "." + L,
                index: 0,
                js: null,
                formCalc: null,
                operator: m.dot
              }];
              let F = L.length;
              for (; F < _.length; ) {
                const M = F;
                if (_.charAt(F++) === "[") {
                  if (O = _.slice(F).match(f), !O)
                    return (0, b.warn)("XFA - Invalid index in SOM expression"), null;
                  B.at(-1).index = S(O[0]), F += O[0].length + 1;
                  continue;
                }
                let j;
                switch (_.charAt(F)) {
                  case ".":
                    if (!E)
                      return null;
                    F++, j = m.dotDot;
                    break;
                  case "#":
                    F++, j = m.dotHash;
                    break;
                  case "[":
                    if (R)
                      return (0, b.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now."), null;
                    j = m.dotBracket;
                    break;
                  case "(":
                    if (R)
                      return (0, b.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now."), null;
                    j = m.dotParen;
                    break;
                  default:
                    j = m.dot;
                    break;
                }
                if (O = _.slice(F).match(y), !O)
                  break;
                [L] = O, F += L.length, B.push({
                  name: L,
                  cacheName: _.slice(M, F),
                  operator: j,
                  index: 0,
                  js: null,
                  formCalc: null
                });
              }
              return B;
            }
            function T(_, E, R, O = !0, L = !0) {
              const B = $(R, O);
              if (!B)
                return null;
              const F = C.get(B[0].name);
              let M = 0, W;
              F ? (W = !0, _ = [F(_, E)], M = 1) : (W = E === null, _ = [E || _]);
              for (let j = B.length; M < j; M++) {
                const {
                  name: G,
                  cacheName: U,
                  operator: k,
                  index: N
                } = B[M], P = [];
                for (const D of _) {
                  if (!D.isXFAObject)
                    continue;
                  let H, V;
                  if (L && (V = w.get(D), V || (V = /* @__PURE__ */ new Map(), w.set(D, V)), H = V.get(U)), !H) {
                    switch (k) {
                      case m.dot:
                        H = D[g.$getChildrenByName](G, !1);
                        break;
                      case m.dotDot:
                        H = D[g.$getChildrenByName](G, !0);
                        break;
                      case m.dotHash:
                        H = D[g.$getChildrenByClass](G), H = H.isXFAObjectArray ? H.children : [H];
                        break;
                    }
                    L && V.set(U, H);
                  }
                  H.length > 0 && P.push(H);
                }
                if (P.length === 0 && !W && M === 0) {
                  if (E = E[g.$getParent](), !E)
                    return null;
                  M = -1, _ = [E];
                  continue;
                }
                _ = isFinite(N) ? P.filter((D) => N < D.length).map((D) => D[N]) : P.flat();
              }
              return _.length === 0 ? null : _;
            }
            function I(_, E, R) {
              const O = $(R);
              if (!O || O.some((F) => F.operator === m.dotDot))
                return null;
              const L = C.get(O[0].name);
              let B = 0;
              L ? (_ = L(_, E), B = 1) : _ = E || _;
              for (let F = O.length; B < F; B++) {
                const {
                  name: M,
                  operator: W,
                  index: j
                } = O[B];
                if (!isFinite(j))
                  return O[B].index = 0, _.createNodes(O.slice(B));
                let G;
                switch (W) {
                  case m.dot:
                    G = _[g.$getChildrenByName](M, !1);
                    break;
                  case m.dotDot:
                    G = _[g.$getChildrenByName](M, !0);
                    break;
                  case m.dotHash:
                    G = _[g.$getChildrenByClass](M), G = G.isXFAObjectArray ? G.children : [G];
                    break;
                }
                if (G.length === 0)
                  return _.createNodes(O.slice(B));
                if (j < G.length) {
                  const U = G[j];
                  if (!U.isXFAObject)
                    return (0, b.warn)("XFA - Cannot create a node."), null;
                  _ = U;
                } else
                  return O[B].index = j - G.length, _.createNodes(O.slice(B));
              }
              return null;
            }
          },
          /* 89 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.DataHandler = void 0;
            var g = x(78);
            class b {
              constructor(f, m) {
                this.data = m, this.dataset = f.datasets || null;
              }
              serialize(f) {
                const m = [[-1, this.data[g.$getChildren]()]];
                for (; m.length > 0; ) {
                  const w = m.at(-1), [S, $] = w;
                  if (S + 1 === $.length) {
                    m.pop();
                    continue;
                  }
                  const T = $[++w[0]], I = f.get(T[g.$uid]);
                  if (I)
                    T[g.$setValue](I);
                  else {
                    const E = T[g.$getAttributes]();
                    for (const R of E.values()) {
                      const O = f.get(R[g.$uid]);
                      if (O) {
                        R[g.$setValue](O);
                        break;
                      }
                    }
                  }
                  const _ = T[g.$getChildren]();
                  _.length > 0 && m.push([-1, _]);
                }
                const C = ['<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">'];
                if (this.dataset)
                  for (const w of this.dataset[g.$getChildren]())
                    w[g.$nodeName] !== "data" && w[g.$toString](C);
                return this.data[g.$toString](C), C.push("</xfa:datasets>"), C.join("");
              }
            }
            A.DataHandler = b;
          },
          /* 90 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.XFAParser = void 0;
            var g = x(78), b = x(71), y = x(91), f = x(2);
            class m extends b.XMLParserBase {
              constructor(w = null, S = !1) {
                super(), this._builder = new y.Builder(w), this._stack = [], this._globalData = {
                  usedTypefaces: /* @__PURE__ */ new Set()
                }, this._ids = /* @__PURE__ */ new Map(), this._current = this._builder.buildRoot(this._ids), this._errorCode = b.XMLParserErrorCode.NoError, this._whiteRegex = /^\s+$/, this._nbsps = /\xa0+/g, this._richText = S;
              }
              parse(w) {
                if (this.parseXml(w), this._errorCode === b.XMLParserErrorCode.NoError)
                  return this._current[g.$finalize](), this._current.element;
              }
              onText(w) {
                if (w = w.replace(this._nbsps, (S) => S.slice(1) + " "), this._richText || this._current[g.$acceptWhitespace]()) {
                  this._current[g.$onText](w, this._richText);
                  return;
                }
                this._whiteRegex.test(w) || this._current[g.$onText](w.trim());
              }
              onCdata(w) {
                this._current[g.$onText](w);
              }
              _mkAttributes(w, S) {
                let $ = null, T = null;
                const I = /* @__PURE__ */ Object.create({});
                for (const {
                  name: _,
                  value: E
                } of w)
                  if (_ === "xmlns")
                    $ ? (0, f.warn)(`XFA - multiple namespace definition in <${S}>`) : $ = E;
                  else if (_.startsWith("xmlns:")) {
                    const R = _.substring(6);
                    T || (T = []), T.push({
                      prefix: R,
                      value: E
                    });
                  } else {
                    const R = _.indexOf(":");
                    if (R === -1)
                      I[_] = E;
                    else {
                      let O = I[g.$nsAttributes];
                      O || (O = I[g.$nsAttributes] = /* @__PURE__ */ Object.create(null));
                      const [L, B] = [_.slice(0, R), _.slice(R + 1)], F = O[L] ||= /* @__PURE__ */ Object.create(null);
                      F[B] = E;
                    }
                  }
                return [$, T, I];
              }
              _getNameAndPrefix(w, S) {
                const $ = w.indexOf(":");
                return $ === -1 ? [w, null] : [w.substring($ + 1), S ? "" : w.substring(0, $)];
              }
              onBeginElement(w, S, $) {
                const [T, I, _] = this._mkAttributes(S, w), [E, R] = this._getNameAndPrefix(w, this._builder.isNsAgnostic()), O = this._builder.build({
                  nsPrefix: R,
                  name: E,
                  attributes: _,
                  namespace: T,
                  prefixes: I
                });
                if (O[g.$globalData] = this._globalData, $) {
                  O[g.$finalize](), this._current[g.$onChild](O) && O[g.$setId](this._ids), O[g.$clean](this._builder);
                  return;
                }
                this._stack.push(this._current), this._current = O;
              }
              onEndElement(w) {
                const S = this._current;
                if (S[g.$isCDATAXml]() && typeof S[g.$content] == "string") {
                  const $ = new m();
                  $._globalData = this._globalData;
                  const T = $.parse(S[g.$content]);
                  S[g.$content] = null, S[g.$onChild](T);
                }
                S[g.$finalize](), this._current = this._stack.pop(), this._current[g.$onChild](S) && S[g.$setId](this._ids), S[g.$clean](this._builder);
              }
              onError(w) {
                this._errorCode = w;
              }
            }
            A.XFAParser = m;
          },
          /* 91 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.Builder = void 0;
            var g = x(81), b = x(78), y = x(92), f = x(80), m = x(101), C = x(2), w = x(87);
            class S extends w.XFAObject {
              constructor(_) {
                super(-1, "root", /* @__PURE__ */ Object.create(null)), this.element = null, this[b.$ids] = _;
              }
              [b.$onChild](_) {
                return this.element = _, !0;
              }
              [b.$finalize]() {
                super[b.$finalize](), this.element.template instanceof f.Template && (this[b.$ids].set(b.$root, this.element), this.element.template[b.$resolvePrototypes](this[b.$ids]), this.element.template[b.$ids] = this[b.$ids]);
              }
            }
            class $ extends w.XFAObject {
              constructor() {
                super(-1, "", /* @__PURE__ */ Object.create(null));
              }
              [b.$onChild](_) {
                return !1;
              }
            }
            class T {
              constructor(_ = null) {
                this._namespaceStack = [], this._nsAgnosticLevel = 0, this._namespacePrefixes = /* @__PURE__ */ new Map(), this._namespaces = /* @__PURE__ */ new Map(), this._nextNsId = Math.max(...Object.values(g.NamespaceIds).map(({
                  id: E
                }) => E)), this._currentNamespace = _ || new m.UnknownNamespace(++this._nextNsId);
              }
              buildRoot(_) {
                return new S(_);
              }
              build({
                nsPrefix: _,
                name: E,
                attributes: R,
                namespace: O,
                prefixes: L
              }) {
                const B = O !== null;
                if (B && (this._namespaceStack.push(this._currentNamespace), this._currentNamespace = this._searchNamespace(O)), L && this._addNamespacePrefix(L), R.hasOwnProperty(b.$nsAttributes)) {
                  const W = y.NamespaceSetUp.datasets, j = R[b.$nsAttributes];
                  let G = null;
                  for (const [U, k] of Object.entries(j))
                    if (this._getNamespaceToUse(U) === W) {
                      G = {
                        xfa: k
                      };
                      break;
                    }
                  G ? R[b.$nsAttributes] = G : delete R[b.$nsAttributes];
                }
                const M = this._getNamespaceToUse(_)?.[g.$buildXFAObject](E, R) || new $();
                return M[b.$isNsAgnostic]() && this._nsAgnosticLevel++, (B || L || M[b.$isNsAgnostic]()) && (M[b.$cleanup] = {
                  hasNamespace: B,
                  prefixes: L,
                  nsAgnostic: M[b.$isNsAgnostic]()
                }), M;
              }
              isNsAgnostic() {
                return this._nsAgnosticLevel > 0;
              }
              _searchNamespace(_) {
                let E = this._namespaces.get(_);
                if (E)
                  return E;
                for (const [R, {
                  check: O
                }] of Object.entries(g.NamespaceIds))
                  if (O(_)) {
                    if (E = y.NamespaceSetUp[R], E)
                      return this._namespaces.set(_, E), E;
                    break;
                  }
                return E = new m.UnknownNamespace(++this._nextNsId), this._namespaces.set(_, E), E;
              }
              _addNamespacePrefix(_) {
                for (const {
                  prefix: E,
                  value: R
                } of _) {
                  const O = this._searchNamespace(R);
                  let L = this._namespacePrefixes.get(E);
                  L || (L = [], this._namespacePrefixes.set(E, L)), L.push(O);
                }
              }
              _getNamespaceToUse(_) {
                if (!_)
                  return this._currentNamespace;
                const E = this._namespacePrefixes.get(_);
                return E?.length > 0 ? E.at(-1) : ((0, C.warn)(`Unknown namespace prefix: ${_}.`), null);
              }
              clean(_) {
                const {
                  hasNamespace: E,
                  prefixes: R,
                  nsAgnostic: O
                } = _;
                E && (this._currentNamespace = this._namespaceStack.pop()), R && R.forEach(({
                  prefix: L
                }) => {
                  this._namespacePrefixes.get(L).pop();
                }), O && this._nsAgnosticLevel--;
              }
            }
            A.Builder = T;
          },
          /* 92 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.NamespaceSetUp = void 0;
            var g = x(93), b = x(94), y = x(95), f = x(96), m = x(97), C = x(98), w = x(80), S = x(99), $ = x(100);
            const T = {
              config: g.ConfigNamespace,
              connection: b.ConnectionSetNamespace,
              datasets: y.DatasetsNamespace,
              localeSet: f.LocaleSetNamespace,
              signature: m.SignatureNamespace,
              stylesheet: C.StylesheetNamespace,
              template: w.TemplateNamespace,
              xdp: S.XdpNamespace,
              xhtml: $.XhtmlNamespace
            };
            A.NamespaceSetUp = T;
          },
          /* 93 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ConfigNamespace = void 0;
            var g = x(81), b = x(78), y = x(87), f = x(84), m = x(2);
            const C = g.NamespaceIds.config.id;
            class w extends y.XFAObject {
              constructor(Ie) {
                super(C, "acrobat", !0), this.acrobat7 = null, this.autoSave = null, this.common = null, this.validate = null, this.validateApprovalSignatures = null, this.submitUrl = new y.XFAObjectArray();
              }
            }
            class S extends y.XFAObject {
              constructor(Ie) {
                super(C, "acrobat7", !0), this.dynamicRender = null;
              }
            }
            class $ extends y.OptionObject {
              constructor(Ie) {
                super(C, "ADBE_JSConsole", ["delegate", "Enable", "Disable"]);
              }
            }
            class T extends y.OptionObject {
              constructor(Ie) {
                super(C, "ADBE_JSDebugger", ["delegate", "Enable", "Disable"]);
              }
            }
            class I extends y.Option01 {
              constructor(Ie) {
                super(C, "addSilentPrint");
              }
            }
            class _ extends y.Option01 {
              constructor(Ie) {
                super(C, "addViewerPreferences");
              }
            }
            class E extends y.Option10 {
              constructor(Ie) {
                super(C, "adjustData");
              }
            }
            class R extends y.IntegerObject {
              constructor(Ie) {
                super(C, "adobeExtensionLevel", 0, (lt) => lt >= 1 && lt <= 8);
              }
            }
            class O extends y.XFAObject {
              constructor(Ie) {
                super(C, "agent", !0), this.name = Ie.name ? Ie.name.trim() : "", this.common = new y.XFAObjectArray();
              }
            }
            class L extends y.ContentObject {
              constructor(Ie) {
                super(C, "alwaysEmbed");
              }
            }
            class B extends y.StringObject {
              constructor(Ie) {
                super(C, "amd");
              }
            }
            class F extends y.XFAObject {
              constructor(Ie) {
                super(C, "area"), this.level = (0, f.getInteger)({
                  data: Ie.level,
                  defaultValue: 0,
                  validate: (lt) => lt >= 1 && lt <= 3
                }), this.name = (0, f.getStringOption)(Ie.name, ["", "barcode", "coreinit", "deviceDriver", "font", "general", "layout", "merge", "script", "signature", "sourceSet", "templateCache"]);
              }
            }
            class M extends y.OptionObject {
              constructor(Ie) {
                super(C, "attributes", ["preserve", "delegate", "ignore"]);
              }
            }
            class W extends y.OptionObject {
              constructor(Ie) {
                super(C, "autoSave", ["disabled", "enabled"]);
              }
            }
            class j extends y.StringObject {
              constructor(Ie) {
                super(C, "base");
              }
            }
            class G extends y.XFAObject {
              constructor(Ie) {
                super(C, "batchOutput"), this.format = (0, f.getStringOption)(Ie.format, ["none", "concat", "zip", "zipCompress"]);
              }
            }
            class U extends y.ContentObject {
              constructor(Ie) {
                super(C, "behaviorOverride");
              }
              [b.$finalize]() {
                this[b.$content] = new Map(this[b.$content].trim().split(/\s+/).filter((Ie) => Ie.includes(":")).map((Ie) => Ie.split(":", 2)));
              }
            }
            class k extends y.XFAObject {
              constructor(Ie) {
                super(C, "cache", !0), this.templateCache = null;
              }
            }
            class N extends y.Option01 {
              constructor(Ie) {
                super(C, "change");
              }
            }
            class P extends y.XFAObject {
              constructor(Ie) {
                super(C, "common", !0), this.data = null, this.locale = null, this.localeSet = null, this.messaging = null, this.suppressBanner = null, this.template = null, this.validationMessaging = null, this.versionControl = null, this.log = new y.XFAObjectArray();
              }
            }
            class D extends y.XFAObject {
              constructor(Ie) {
                super(C, "compress"), this.scope = (0, f.getStringOption)(Ie.scope, ["imageOnly", "document"]);
              }
            }
            class H extends y.Option01 {
              constructor(Ie) {
                super(C, "compressLogicalStructure");
              }
            }
            class V extends y.Option10 {
              constructor(Ie) {
                super(C, "compressObjectStream");
              }
            }
            class Z extends y.XFAObject {
              constructor(Ie) {
                super(C, "compression", !0), this.compressLogicalStructure = null, this.compressObjectStream = null, this.level = null, this.type = null;
              }
            }
            class ne extends y.XFAObject {
              constructor(Ie) {
                super(C, "config", !0), this.acrobat = null, this.present = null, this.trace = null, this.agent = new y.XFAObjectArray();
              }
            }
            class K extends y.OptionObject {
              constructor(Ie) {
                super(C, "conformance", ["A", "B"]);
              }
            }
            class q extends y.Option01 {
              constructor(Ie) {
                super(C, "contentCopy");
              }
            }
            class Y extends y.IntegerObject {
              constructor(Ie) {
                super(C, "copies", 1, (lt) => lt >= 1);
              }
            }
            class ee extends y.StringObject {
              constructor(Ie) {
                super(C, "creator");
              }
            }
            class Q extends y.IntegerObject {
              constructor(Ie) {
                super(C, "currentPage", 0, (lt) => lt >= 0);
              }
            }
            class J extends y.XFAObject {
              constructor(Ie) {
                super(C, "data", !0), this.adjustData = null, this.attributes = null, this.incrementalLoad = null, this.outputXSL = null, this.range = null, this.record = null, this.startNode = null, this.uri = null, this.window = null, this.xsl = null, this.excludeNS = new y.XFAObjectArray(), this.transform = new y.XFAObjectArray();
              }
            }
            class te extends y.XFAObject {
              constructor(Ie) {
                super(C, "debug", !0), this.uri = null;
              }
            }
            class ae extends y.ContentObject {
              constructor(Ie) {
                super(C, "defaultTypeface"), this.writingScript = (0, f.getStringOption)(Ie.writingScript, ["*", "Arabic", "Cyrillic", "EastEuropeanRoman", "Greek", "Hebrew", "Japanese", "Korean", "Roman", "SimplifiedChinese", "Thai", "TraditionalChinese", "Vietnamese"]);
              }
            }
            class se extends y.OptionObject {
              constructor(Ie) {
                super(C, "destination", ["pdf", "pcl", "ps", "webClient", "zpl"]);
              }
            }
            class ie extends y.Option01 {
              constructor(Ie) {
                super(C, "documentAssembly");
              }
            }
            class fe extends y.XFAObject {
              constructor(Ie) {
                super(C, "driver", !0), this.name = Ie.name ? Ie.name.trim() : "", this.fontInfo = null, this.xdc = null;
              }
            }
            class ge extends y.OptionObject {
              constructor(Ie) {
                super(C, "duplexOption", ["simplex", "duplexFlipLongEdge", "duplexFlipShortEdge"]);
              }
            }
            class me extends y.OptionObject {
              constructor(Ie) {
                super(C, "dynamicRender", ["forbidden", "required"]);
              }
            }
            class pe extends y.Option01 {
              constructor(Ie) {
                super(C, "embed");
              }
            }
            class be extends y.Option01 {
              constructor(Ie) {
                super(C, "encrypt");
              }
            }
            class le extends y.XFAObject {
              constructor(Ie) {
                super(C, "encryption", !0), this.encrypt = null, this.encryptionLevel = null, this.permissions = null;
              }
            }
            class ve extends y.OptionObject {
              constructor(Ie) {
                super(C, "encryptionLevel", ["40bit", "128bit"]);
              }
            }
            class he extends y.StringObject {
              constructor(Ie) {
                super(C, "enforce");
              }
            }
            class ye extends y.XFAObject {
              constructor(Ie) {
                super(C, "equate"), this.force = (0, f.getInteger)({
                  data: Ie.force,
                  defaultValue: 1,
                  validate: (lt) => lt === 0
                }), this.from = Ie.from || "", this.to = Ie.to || "";
              }
            }
            class Ce extends y.XFAObject {
              constructor(Ie) {
                super(C, "equateRange"), this.from = Ie.from || "", this.to = Ie.to || "", this._unicodeRange = Ie.unicodeRange || "";
              }
              get unicodeRange() {
                const Ie = [], lt = /U\+([0-9a-fA-F]+)/, At = this._unicodeRange;
                for (let Bt of At.split(",").map((Kt) => Kt.trim()).filter((Kt) => !!Kt))
                  Bt = Bt.split("-", 2).map((Kt) => {
                    const Ut = Kt.match(lt);
                    return Ut ? parseInt(Ut[1], 16) : 0;
                  }), Bt.length === 1 && Bt.push(Bt[0]), Ie.push(Bt);
                return (0, m.shadow)(this, "unicodeRange", Ie);
              }
            }
            class xe extends y.ContentObject {
              constructor(Ie) {
                super(C, "exclude");
              }
              [b.$finalize]() {
                this[b.$content] = this[b.$content].trim().split(/\s+/).filter((Ie) => Ie && ["calculate", "close", "enter", "exit", "initialize", "ready", "validate"].includes(Ie));
              }
            }
            class we extends y.StringObject {
              constructor(Ie) {
                super(C, "excludeNS");
              }
            }
            class $e extends y.OptionObject {
              constructor(Ie) {
                super(C, "flipLabel", ["usePrinterSetting", "on", "off"]);
              }
            }
            class Ae extends y.XFAObject {
              constructor(Ie) {
                super(C, "fontInfo", !0), this.embed = null, this.map = null, this.subsetBelow = null, this.alwaysEmbed = new y.XFAObjectArray(), this.defaultTypeface = new y.XFAObjectArray(), this.neverEmbed = new y.XFAObjectArray();
              }
            }
            class ue extends y.Option01 {
              constructor(Ie) {
                super(C, "formFieldFilling");
              }
            }
            class ce extends y.StringObject {
              constructor(Ie) {
                super(C, "groupParent");
              }
            }
            class Ee extends y.OptionObject {
              constructor(Ie) {
                super(C, "ifEmpty", ["dataValue", "dataGroup", "ignore", "remove"]);
              }
            }
            class _e extends y.StringObject {
              constructor(Ie) {
                super(C, "includeXDPContent");
              }
            }
            class Te extends y.OptionObject {
              constructor(Ie) {
                super(C, "incrementalLoad", ["none", "forwardOnly"]);
              }
            }
            class ke extends y.Option01 {
              constructor(Ie) {
                super(C, "incrementalMerge");
              }
            }
            class Re extends y.Option01 {
              constructor(Ie) {
                super(C, "interactive");
              }
            }
            class Be extends y.OptionObject {
              constructor(Ie) {
                super(C, "jog", ["usePrinterSetting", "none", "pageSet"]);
              }
            }
            class Oe extends y.XFAObject {
              constructor(Ie) {
                super(C, "labelPrinter", !0), this.name = (0, f.getStringOption)(Ie.name, ["zpl", "dpl", "ipl", "tcpl"]), this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
              }
            }
            class Me extends y.OptionObject {
              constructor(Ie) {
                super(C, "layout", ["paginate", "panel"]);
              }
            }
            class Fe extends y.IntegerObject {
              constructor(Ie) {
                super(C, "level", 0, (lt) => lt > 0);
              }
            }
            class Ue extends y.Option01 {
              constructor(Ie) {
                super(C, "linearized");
              }
            }
            class je extends y.StringObject {
              constructor(Ie) {
                super(C, "locale");
              }
            }
            class Le extends y.StringObject {
              constructor(Ie) {
                super(C, "localeSet");
              }
            }
            class De extends y.XFAObject {
              constructor(Ie) {
                super(C, "log", !0), this.mode = null, this.threshold = null, this.to = null, this.uri = null;
              }
            }
            class Ne extends y.XFAObject {
              constructor(Ie) {
                super(C, "map", !0), this.equate = new y.XFAObjectArray(), this.equateRange = new y.XFAObjectArray();
              }
            }
            class Ge extends y.XFAObject {
              constructor(Ie) {
                super(C, "mediumInfo", !0), this.map = null;
              }
            }
            class Xe extends y.XFAObject {
              constructor(Ie) {
                super(C, "message", !0), this.msgId = null, this.severity = null;
              }
            }
            class nt extends y.XFAObject {
              constructor(Ie) {
                super(C, "messaging", !0), this.message = new y.XFAObjectArray();
              }
            }
            class ct extends y.OptionObject {
              constructor(Ie) {
                super(C, "mode", ["append", "overwrite"]);
              }
            }
            class it extends y.Option01 {
              constructor(Ie) {
                super(C, "modifyAnnots");
              }
            }
            class We extends y.IntegerObject {
              constructor(Ie) {
                super(C, "msgId", 1, (lt) => lt >= 1);
              }
            }
            class Ve extends y.StringObject {
              constructor(Ie) {
                super(C, "nameAttr");
              }
            }
            class ut extends y.ContentObject {
              constructor(Ie) {
                super(C, "neverEmbed");
              }
            }
            class at extends y.IntegerObject {
              constructor(Ie) {
                super(C, "numberOfCopies", null, (lt) => lt >= 2 && lt <= 5);
              }
            }
            class Qe extends y.XFAObject {
              constructor(Ie) {
                super(C, "openAction", !0), this.destination = null;
              }
            }
            class st extends y.XFAObject {
              constructor(Ie) {
                super(C, "output", !0), this.to = null, this.type = null, this.uri = null;
              }
            }
            class ft extends y.StringObject {
              constructor(Ie) {
                super(C, "outputBin");
              }
            }
            class vt extends y.XFAObject {
              constructor(Ie) {
                super(C, "outputXSL", !0), this.uri = null;
              }
            }
            class Pt extends y.OptionObject {
              constructor(Ie) {
                super(C, "overprint", ["none", "both", "draw", "field"]);
              }
            }
            class dt extends y.StringObject {
              constructor(Ie) {
                super(C, "packets");
              }
              [b.$finalize]() {
                this[b.$content] !== "*" && (this[b.$content] = this[b.$content].trim().split(/\s+/).filter((Ie) => ["config", "datasets", "template", "xfdf", "xslt"].includes(Ie)));
              }
            }
            class mt extends y.XFAObject {
              constructor(Ie) {
                super(C, "pageOffset"), this.x = (0, f.getInteger)({
                  data: Ie.x,
                  defaultValue: "useXDCSetting",
                  validate: (lt) => !0
                }), this.y = (0, f.getInteger)({
                  data: Ie.y,
                  defaultValue: "useXDCSetting",
                  validate: (lt) => !0
                });
              }
            }
            class pt extends y.StringObject {
              constructor(Ie) {
                super(C, "pageRange");
              }
              [b.$finalize]() {
                const Ie = this[b.$content].trim().split(/\s+/).map((At) => parseInt(At, 10)), lt = [];
                for (let At = 0, Bt = Ie.length; At < Bt; At += 2)
                  lt.push(Ie.slice(At, At + 2));
                this[b.$content] = lt;
              }
            }
            class Et extends y.OptionObject {
              constructor(Ie) {
                super(C, "pagination", ["simplex", "duplexShortEdge", "duplexLongEdge"]);
              }
            }
            class Mt extends y.OptionObject {
              constructor(Ie) {
                super(C, "paginationOverride", ["none", "forceDuplex", "forceDuplexLongEdge", "forceDuplexShortEdge", "forceSimplex"]);
              }
            }
            class Nt extends y.IntegerObject {
              constructor(Ie) {
                super(C, "part", 1, (lt) => !1);
              }
            }
            class _t extends y.XFAObject {
              constructor(Ie) {
                super(C, "pcl", !0), this.name = Ie.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.pageOffset = null, this.staple = null, this.xdc = null;
              }
            }
            class Ot extends y.XFAObject {
              constructor(Ie) {
                super(C, "pdf", !0), this.name = Ie.name || "", this.adobeExtensionLevel = null, this.batchOutput = null, this.compression = null, this.creator = null, this.encryption = null, this.fontInfo = null, this.interactive = null, this.linearized = null, this.openAction = null, this.pdfa = null, this.producer = null, this.renderPolicy = null, this.scriptModel = null, this.silentPrint = null, this.submitFormat = null, this.tagged = null, this.version = null, this.viewerPreferences = null, this.xdc = null;
              }
            }
            class rt extends y.XFAObject {
              constructor(Ie) {
                super(C, "pdfa", !0), this.amd = null, this.conformance = null, this.includeXDPContent = null, this.part = null;
              }
            }
            class et extends y.XFAObject {
              constructor(Ie) {
                super(C, "permissions", !0), this.accessibleContent = null, this.change = null, this.contentCopy = null, this.documentAssembly = null, this.formFieldFilling = null, this.modifyAnnots = null, this.plaintextMetadata = null, this.print = null, this.printHighQuality = null;
              }
            }
            class Ye extends y.Option01 {
              constructor(Ie) {
                super(C, "pickTrayByPDFSize");
              }
            }
            class tt extends y.StringObject {
              constructor(Ie) {
                super(C, "picture");
              }
            }
            class Ke extends y.Option01 {
              constructor(Ie) {
                super(C, "plaintextMetadata");
              }
            }
            class qe extends y.OptionObject {
              constructor(Ie) {
                super(C, "presence", ["preserve", "dissolve", "dissolveStructure", "ignore", "remove"]);
              }
            }
            class ot extends y.XFAObject {
              constructor(Ie) {
                super(C, "present", !0), this.behaviorOverride = null, this.cache = null, this.common = null, this.copies = null, this.destination = null, this.incrementalMerge = null, this.layout = null, this.output = null, this.overprint = null, this.pagination = null, this.paginationOverride = null, this.script = null, this.validate = null, this.xdp = null, this.driver = new y.XFAObjectArray(), this.labelPrinter = new y.XFAObjectArray(), this.pcl = new y.XFAObjectArray(), this.pdf = new y.XFAObjectArray(), this.ps = new y.XFAObjectArray(), this.submitUrl = new y.XFAObjectArray(), this.webClient = new y.XFAObjectArray(), this.zpl = new y.XFAObjectArray();
              }
            }
            class Je extends y.Option01 {
              constructor(Ie) {
                super(C, "print");
              }
            }
            class Ct extends y.Option01 {
              constructor(Ie) {
                super(C, "printHighQuality");
              }
            }
            class Tt extends y.OptionObject {
              constructor(Ie) {
                super(C, "printScaling", ["appdefault", "noScaling"]);
              }
            }
            class yt extends y.StringObject {
              constructor(Ie) {
                super(C, "printerName");
              }
            }
            class bt extends y.StringObject {
              constructor(Ie) {
                super(C, "producer");
              }
            }
            class It extends y.XFAObject {
              constructor(Ie) {
                super(C, "ps", !0), this.name = Ie.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.staple = null, this.xdc = null;
              }
            }
            class kt extends y.ContentObject {
              constructor(Ie) {
                super(C, "range");
              }
              [b.$finalize]() {
                this[b.$content] = this[b.$content].trim().split(/\s*,\s*/, 2).map((Ie) => Ie.split("-").map((lt) => parseInt(lt.trim(), 10))).filter((Ie) => Ie.every((lt) => !isNaN(lt))).map((Ie) => (Ie.length === 1 && Ie.push(Ie[0]), Ie));
              }
            }
            class $t extends y.ContentObject {
              constructor(Ie) {
                super(C, "record");
              }
              [b.$finalize]() {
                this[b.$content] = this[b.$content].trim();
                const Ie = parseInt(this[b.$content], 10);
                !isNaN(Ie) && Ie >= 0 && (this[b.$content] = Ie);
              }
            }
            class Lt extends y.ContentObject {
              constructor(Ie) {
                super(C, "relevant");
              }
              [b.$finalize]() {
                this[b.$content] = this[b.$content].trim().split(/\s+/);
              }
            }
            class Ft extends y.ContentObject {
              constructor(Ie) {
                super(C, "rename");
              }
              [b.$finalize]() {
                this[b.$content] = this[b.$content].trim(), (this[b.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[b.$content])) && (0, m.warn)("XFA - Rename: invalid XFA name");
              }
            }
            class Vt extends y.OptionObject {
              constructor(Ie) {
                super(C, "renderPolicy", ["server", "client"]);
              }
            }
            class rr extends y.OptionObject {
              constructor(Ie) {
                super(C, "runScripts", ["both", "client", "none", "server"]);
              }
            }
            class br extends y.XFAObject {
              constructor(Ie) {
                super(C, "script", !0), this.currentPage = null, this.exclude = null, this.runScripts = null;
              }
            }
            class Gt extends y.OptionObject {
              constructor(Ie) {
                super(C, "scriptModel", ["XFA", "none"]);
              }
            }
            class qt extends y.OptionObject {
              constructor(Ie) {
                super(C, "severity", ["ignore", "error", "information", "trace", "warning"]);
              }
            }
            class Jt extends y.XFAObject {
              constructor(Ie) {
                super(C, "silentPrint", !0), this.addSilentPrint = null, this.printerName = null;
              }
            }
            class jt extends y.XFAObject {
              constructor(Ie) {
                super(C, "staple"), this.mode = (0, f.getStringOption)(Ie.mode, ["usePrinterSetting", "on", "off"]);
              }
            }
            class Ht extends y.StringObject {
              constructor(Ie) {
                super(C, "startNode");
              }
            }
            class ur extends y.IntegerObject {
              constructor(Ie) {
                super(C, "startPage", 0, (lt) => !0);
              }
            }
            class Qt extends y.OptionObject {
              constructor(Ie) {
                super(C, "submitFormat", ["html", "delegate", "fdf", "xml", "pdf"]);
              }
            }
            class Yt extends y.StringObject {
              constructor(Ie) {
                super(C, "submitUrl");
              }
            }
            class dr extends y.IntegerObject {
              constructor(Ie) {
                super(C, "subsetBelow", 100, (lt) => lt >= 0 && lt <= 100);
              }
            }
            class Ar extends y.Option01 {
              constructor(Ie) {
                super(C, "suppressBanner");
              }
            }
            class wr extends y.Option01 {
              constructor(Ie) {
                super(C, "tagged");
              }
            }
            class Ir extends y.XFAObject {
              constructor(Ie) {
                super(C, "template", !0), this.base = null, this.relevant = null, this.startPage = null, this.uri = null, this.xsl = null;
              }
            }
            class _r extends y.OptionObject {
              constructor(Ie) {
                super(C, "threshold", ["trace", "error", "information", "warning"]);
              }
            }
            class kr extends y.OptionObject {
              constructor(Ie) {
                super(C, "to", ["null", "memory", "stderr", "stdout", "system", "uri"]);
              }
            }
            class zt extends y.XFAObject {
              constructor(Ie) {
                super(C, "templateCache"), this.maxEntries = (0, f.getInteger)({
                  data: Ie.maxEntries,
                  defaultValue: 5,
                  validate: (lt) => lt >= 0
                });
              }
            }
            class Dt extends y.XFAObject {
              constructor(Ie) {
                super(C, "trace", !0), this.area = new y.XFAObjectArray();
              }
            }
            class nr extends y.XFAObject {
              constructor(Ie) {
                super(C, "transform", !0), this.groupParent = null, this.ifEmpty = null, this.nameAttr = null, this.picture = null, this.presence = null, this.rename = null, this.whitespace = null;
              }
            }
            class gr extends y.OptionObject {
              constructor(Ie) {
                super(C, "type", ["none", "ascii85", "asciiHex", "ccittfax", "flate", "lzw", "runLength", "native", "xdp", "mergedXDP"]);
              }
            }
            class lr extends y.StringObject {
              constructor(Ie) {
                super(C, "uri");
              }
            }
            class Nr extends y.OptionObject {
              constructor(Ie) {
                super(C, "validate", ["preSubmit", "prePrint", "preExecute", "preSave"]);
              }
            }
            class Wr extends y.ContentObject {
              constructor(Ie) {
                super(C, "validateApprovalSignatures");
              }
              [b.$finalize]() {
                this[b.$content] = this[b.$content].trim().split(/\s+/).filter((Ie) => ["docReady", "postSign"].includes(Ie));
              }
            }
            class Fr extends y.OptionObject {
              constructor(Ie) {
                super(C, "validationMessaging", ["allMessagesIndividually", "allMessagesTogether", "firstMessageOnly", "noMessages"]);
              }
            }
            class Qr extends y.OptionObject {
              constructor(Ie) {
                super(C, "version", ["1.7", "1.6", "1.5", "1.4", "1.3", "1.2"]);
              }
            }
            class an extends y.XFAObject {
              constructor(Ie) {
                super(C, "VersionControl"), this.outputBelow = (0, f.getStringOption)(Ie.outputBelow, ["warn", "error", "update"]), this.sourceAbove = (0, f.getStringOption)(Ie.sourceAbove, ["warn", "error"]), this.sourceBelow = (0, f.getStringOption)(Ie.sourceBelow, ["update", "maintain"]);
              }
            }
            class cn extends y.XFAObject {
              constructor(Ie) {
                super(C, "viewerPreferences", !0), this.ADBE_JSConsole = null, this.ADBE_JSDebugger = null, this.addViewerPreferences = null, this.duplexOption = null, this.enforce = null, this.numberOfCopies = null, this.pageRange = null, this.pickTrayByPDFSize = null, this.printScaling = null;
              }
            }
            class yn extends y.XFAObject {
              constructor(Ie) {
                super(C, "webClient", !0), this.name = Ie.name ? Ie.name.trim() : "", this.fontInfo = null, this.xdc = null;
              }
            }
            class _n extends y.OptionObject {
              constructor(Ie) {
                super(C, "whitespace", ["preserve", "ltrim", "normalize", "rtrim", "trim"]);
              }
            }
            class Xt extends y.ContentObject {
              constructor(Ie) {
                super(C, "window");
              }
              [b.$finalize]() {
                const Ie = this[b.$content].trim().split(/\s*,\s*/, 2).map((lt) => parseInt(lt, 10));
                if (Ie.some((lt) => isNaN(lt))) {
                  this[b.$content] = [0, 0];
                  return;
                }
                Ie.length === 1 && Ie.push(Ie[0]), this[b.$content] = Ie;
              }
            }
            class sr extends y.XFAObject {
              constructor(Ie) {
                super(C, "xdc", !0), this.uri = new y.XFAObjectArray(), this.xsl = new y.XFAObjectArray();
              }
            }
            class Tr extends y.XFAObject {
              constructor(Ie) {
                super(C, "xdp", !0), this.packets = null;
              }
            }
            class Lr extends y.XFAObject {
              constructor(Ie) {
                super(C, "xsl", !0), this.debug = null, this.uri = null;
              }
            }
            class Rr extends y.XFAObject {
              constructor(Ie) {
                super(C, "zpl", !0), this.name = Ie.name ? Ie.name.trim() : "", this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
              }
            }
            class ht {
              static [g.$buildXFAObject](Ie, lt) {
                if (ht.hasOwnProperty(Ie))
                  return ht[Ie](lt);
              }
              static acrobat(Ie) {
                return new w(Ie);
              }
              static acrobat7(Ie) {
                return new S(Ie);
              }
              static ADBE_JSConsole(Ie) {
                return new $(Ie);
              }
              static ADBE_JSDebugger(Ie) {
                return new T(Ie);
              }
              static addSilentPrint(Ie) {
                return new I(Ie);
              }
              static addViewerPreferences(Ie) {
                return new _(Ie);
              }
              static adjustData(Ie) {
                return new E(Ie);
              }
              static adobeExtensionLevel(Ie) {
                return new R(Ie);
              }
              static agent(Ie) {
                return new O(Ie);
              }
              static alwaysEmbed(Ie) {
                return new L(Ie);
              }
              static amd(Ie) {
                return new B(Ie);
              }
              static area(Ie) {
                return new F(Ie);
              }
              static attributes(Ie) {
                return new M(Ie);
              }
              static autoSave(Ie) {
                return new W(Ie);
              }
              static base(Ie) {
                return new j(Ie);
              }
              static batchOutput(Ie) {
                return new G(Ie);
              }
              static behaviorOverride(Ie) {
                return new U(Ie);
              }
              static cache(Ie) {
                return new k(Ie);
              }
              static change(Ie) {
                return new N(Ie);
              }
              static common(Ie) {
                return new P(Ie);
              }
              static compress(Ie) {
                return new D(Ie);
              }
              static compressLogicalStructure(Ie) {
                return new H(Ie);
              }
              static compressObjectStream(Ie) {
                return new V(Ie);
              }
              static compression(Ie) {
                return new Z(Ie);
              }
              static config(Ie) {
                return new ne(Ie);
              }
              static conformance(Ie) {
                return new K(Ie);
              }
              static contentCopy(Ie) {
                return new q(Ie);
              }
              static copies(Ie) {
                return new Y(Ie);
              }
              static creator(Ie) {
                return new ee(Ie);
              }
              static currentPage(Ie) {
                return new Q(Ie);
              }
              static data(Ie) {
                return new J(Ie);
              }
              static debug(Ie) {
                return new te(Ie);
              }
              static defaultTypeface(Ie) {
                return new ae(Ie);
              }
              static destination(Ie) {
                return new se(Ie);
              }
              static documentAssembly(Ie) {
                return new ie(Ie);
              }
              static driver(Ie) {
                return new fe(Ie);
              }
              static duplexOption(Ie) {
                return new ge(Ie);
              }
              static dynamicRender(Ie) {
                return new me(Ie);
              }
              static embed(Ie) {
                return new pe(Ie);
              }
              static encrypt(Ie) {
                return new be(Ie);
              }
              static encryption(Ie) {
                return new le(Ie);
              }
              static encryptionLevel(Ie) {
                return new ve(Ie);
              }
              static enforce(Ie) {
                return new he(Ie);
              }
              static equate(Ie) {
                return new ye(Ie);
              }
              static equateRange(Ie) {
                return new Ce(Ie);
              }
              static exclude(Ie) {
                return new xe(Ie);
              }
              static excludeNS(Ie) {
                return new we(Ie);
              }
              static flipLabel(Ie) {
                return new $e(Ie);
              }
              static fontInfo(Ie) {
                return new Ae(Ie);
              }
              static formFieldFilling(Ie) {
                return new ue(Ie);
              }
              static groupParent(Ie) {
                return new ce(Ie);
              }
              static ifEmpty(Ie) {
                return new Ee(Ie);
              }
              static includeXDPContent(Ie) {
                return new _e(Ie);
              }
              static incrementalLoad(Ie) {
                return new Te(Ie);
              }
              static incrementalMerge(Ie) {
                return new ke(Ie);
              }
              static interactive(Ie) {
                return new Re(Ie);
              }
              static jog(Ie) {
                return new Be(Ie);
              }
              static labelPrinter(Ie) {
                return new Oe(Ie);
              }
              static layout(Ie) {
                return new Me(Ie);
              }
              static level(Ie) {
                return new Fe(Ie);
              }
              static linearized(Ie) {
                return new Ue(Ie);
              }
              static locale(Ie) {
                return new je(Ie);
              }
              static localeSet(Ie) {
                return new Le(Ie);
              }
              static log(Ie) {
                return new De(Ie);
              }
              static map(Ie) {
                return new Ne(Ie);
              }
              static mediumInfo(Ie) {
                return new Ge(Ie);
              }
              static message(Ie) {
                return new Xe(Ie);
              }
              static messaging(Ie) {
                return new nt(Ie);
              }
              static mode(Ie) {
                return new ct(Ie);
              }
              static modifyAnnots(Ie) {
                return new it(Ie);
              }
              static msgId(Ie) {
                return new We(Ie);
              }
              static nameAttr(Ie) {
                return new Ve(Ie);
              }
              static neverEmbed(Ie) {
                return new ut(Ie);
              }
              static numberOfCopies(Ie) {
                return new at(Ie);
              }
              static openAction(Ie) {
                return new Qe(Ie);
              }
              static output(Ie) {
                return new st(Ie);
              }
              static outputBin(Ie) {
                return new ft(Ie);
              }
              static outputXSL(Ie) {
                return new vt(Ie);
              }
              static overprint(Ie) {
                return new Pt(Ie);
              }
              static packets(Ie) {
                return new dt(Ie);
              }
              static pageOffset(Ie) {
                return new mt(Ie);
              }
              static pageRange(Ie) {
                return new pt(Ie);
              }
              static pagination(Ie) {
                return new Et(Ie);
              }
              static paginationOverride(Ie) {
                return new Mt(Ie);
              }
              static part(Ie) {
                return new Nt(Ie);
              }
              static pcl(Ie) {
                return new _t(Ie);
              }
              static pdf(Ie) {
                return new Ot(Ie);
              }
              static pdfa(Ie) {
                return new rt(Ie);
              }
              static permissions(Ie) {
                return new et(Ie);
              }
              static pickTrayByPDFSize(Ie) {
                return new Ye(Ie);
              }
              static picture(Ie) {
                return new tt(Ie);
              }
              static plaintextMetadata(Ie) {
                return new Ke(Ie);
              }
              static presence(Ie) {
                return new qe(Ie);
              }
              static present(Ie) {
                return new ot(Ie);
              }
              static print(Ie) {
                return new Je(Ie);
              }
              static printHighQuality(Ie) {
                return new Ct(Ie);
              }
              static printScaling(Ie) {
                return new Tt(Ie);
              }
              static printerName(Ie) {
                return new yt(Ie);
              }
              static producer(Ie) {
                return new bt(Ie);
              }
              static ps(Ie) {
                return new It(Ie);
              }
              static range(Ie) {
                return new kt(Ie);
              }
              static record(Ie) {
                return new $t(Ie);
              }
              static relevant(Ie) {
                return new Lt(Ie);
              }
              static rename(Ie) {
                return new Ft(Ie);
              }
              static renderPolicy(Ie) {
                return new Vt(Ie);
              }
              static runScripts(Ie) {
                return new rr(Ie);
              }
              static script(Ie) {
                return new br(Ie);
              }
              static scriptModel(Ie) {
                return new Gt(Ie);
              }
              static severity(Ie) {
                return new qt(Ie);
              }
              static silentPrint(Ie) {
                return new Jt(Ie);
              }
              static staple(Ie) {
                return new jt(Ie);
              }
              static startNode(Ie) {
                return new Ht(Ie);
              }
              static startPage(Ie) {
                return new ur(Ie);
              }
              static submitFormat(Ie) {
                return new Qt(Ie);
              }
              static submitUrl(Ie) {
                return new Yt(Ie);
              }
              static subsetBelow(Ie) {
                return new dr(Ie);
              }
              static suppressBanner(Ie) {
                return new Ar(Ie);
              }
              static tagged(Ie) {
                return new wr(Ie);
              }
              static template(Ie) {
                return new Ir(Ie);
              }
              static templateCache(Ie) {
                return new zt(Ie);
              }
              static threshold(Ie) {
                return new _r(Ie);
              }
              static to(Ie) {
                return new kr(Ie);
              }
              static trace(Ie) {
                return new Dt(Ie);
              }
              static transform(Ie) {
                return new nr(Ie);
              }
              static type(Ie) {
                return new gr(Ie);
              }
              static uri(Ie) {
                return new lr(Ie);
              }
              static validate(Ie) {
                return new Nr(Ie);
              }
              static validateApprovalSignatures(Ie) {
                return new Wr(Ie);
              }
              static validationMessaging(Ie) {
                return new Fr(Ie);
              }
              static version(Ie) {
                return new Qr(Ie);
              }
              static versionControl(Ie) {
                return new an(Ie);
              }
              static viewerPreferences(Ie) {
                return new cn(Ie);
              }
              static webClient(Ie) {
                return new yn(Ie);
              }
              static whitespace(Ie) {
                return new _n(Ie);
              }
              static window(Ie) {
                return new Xt(Ie);
              }
              static xdc(Ie) {
                return new sr(Ie);
              }
              static xdp(Ie) {
                return new Tr(Ie);
              }
              static xsl(Ie) {
                return new Lr(Ie);
              }
              static zpl(Ie) {
                return new Rr(Ie);
              }
            }
            A.ConfigNamespace = ht;
          },
          /* 94 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.ConnectionSetNamespace = void 0;
            var g = x(81), b = x(87);
            const y = g.NamespaceIds.connectionSet.id;
            class f extends b.XFAObject {
              constructor(F) {
                super(y, "connectionSet", !0), this.wsdlConnection = new b.XFAObjectArray(), this.xmlConnection = new b.XFAObjectArray(), this.xsdConnection = new b.XFAObjectArray();
              }
            }
            class m extends b.XFAObject {
              constructor(F) {
                super(y, "effectiveInputPolicy"), this.id = F.id || "", this.name = F.name || "", this.use = F.use || "", this.usehref = F.usehref || "";
              }
            }
            class C extends b.XFAObject {
              constructor(F) {
                super(y, "effectiveOutputPolicy"), this.id = F.id || "", this.name = F.name || "", this.use = F.use || "", this.usehref = F.usehref || "";
              }
            }
            class w extends b.StringObject {
              constructor(F) {
                super(y, "operation"), this.id = F.id || "", this.input = F.input || "", this.name = F.name || "", this.output = F.output || "", this.use = F.use || "", this.usehref = F.usehref || "";
              }
            }
            class S extends b.StringObject {
              constructor(F) {
                super(y, "rootElement"), this.id = F.id || "", this.name = F.name || "", this.use = F.use || "", this.usehref = F.usehref || "";
              }
            }
            class $ extends b.StringObject {
              constructor(F) {
                super(y, "soapAction"), this.id = F.id || "", this.name = F.name || "", this.use = F.use || "", this.usehref = F.usehref || "";
              }
            }
            class T extends b.StringObject {
              constructor(F) {
                super(y, "soapAddress"), this.id = F.id || "", this.name = F.name || "", this.use = F.use || "", this.usehref = F.usehref || "";
              }
            }
            class I extends b.StringObject {
              constructor(F) {
                super(y, "uri"), this.id = F.id || "", this.name = F.name || "", this.use = F.use || "", this.usehref = F.usehref || "";
              }
            }
            class _ extends b.StringObject {
              constructor(F) {
                super(y, "wsdlAddress"), this.id = F.id || "", this.name = F.name || "", this.use = F.use || "", this.usehref = F.usehref || "";
              }
            }
            class E extends b.XFAObject {
              constructor(F) {
                super(y, "wsdlConnection", !0), this.dataDescription = F.dataDescription || "", this.name = F.name || "", this.effectiveInputPolicy = null, this.effectiveOutputPolicy = null, this.operation = null, this.soapAction = null, this.soapAddress = null, this.wsdlAddress = null;
              }
            }
            class R extends b.XFAObject {
              constructor(F) {
                super(y, "xmlConnection", !0), this.dataDescription = F.dataDescription || "", this.name = F.name || "", this.uri = null;
              }
            }
            class O extends b.XFAObject {
              constructor(F) {
                super(y, "xsdConnection", !0), this.dataDescription = F.dataDescription || "", this.name = F.name || "", this.rootElement = null, this.uri = null;
              }
            }
            class L {
              static [g.$buildXFAObject](F, M) {
                if (L.hasOwnProperty(F))
                  return L[F](M);
              }
              static connectionSet(F) {
                return new f(F);
              }
              static effectiveInputPolicy(F) {
                return new m(F);
              }
              static effectiveOutputPolicy(F) {
                return new C(F);
              }
              static operation(F) {
                return new w(F);
              }
              static rootElement(F) {
                return new S(F);
              }
              static soapAction(F) {
                return new $(F);
              }
              static soapAddress(F) {
                return new T(F);
              }
              static uri(F) {
                return new I(F);
              }
              static wsdlAddress(F) {
                return new _(F);
              }
              static wsdlConnection(F) {
                return new E(F);
              }
              static xmlConnection(F) {
                return new R(F);
              }
              static xsdConnection(F) {
                return new O(F);
              }
            }
            A.ConnectionSetNamespace = L;
          },
          /* 95 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.DatasetsNamespace = void 0;
            var g = x(78), b = x(81), y = x(87);
            const f = b.NamespaceIds.datasets.id;
            class m extends y.XmlObject {
              constructor($) {
                super(f, "data", $);
              }
              [g.$isNsAgnostic]() {
                return !0;
              }
            }
            class C extends y.XFAObject {
              constructor($) {
                super(f, "datasets", !0), this.data = null, this.Signature = null;
              }
              [g.$onChild]($) {
                const T = $[g.$nodeName];
                (T === "data" && $[g.$namespaceId] === f || T === "Signature" && $[g.$namespaceId] === b.NamespaceIds.signature.id) && (this[T] = $), this[g.$appendChild]($);
              }
            }
            class w {
              static [b.$buildXFAObject]($, T) {
                if (w.hasOwnProperty($))
                  return w[$](T);
              }
              static datasets($) {
                return new C($);
              }
              static data($) {
                return new m($);
              }
            }
            A.DatasetsNamespace = w;
          },
          /* 96 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.LocaleSetNamespace = void 0;
            var g = x(81), b = x(87), y = x(84);
            const f = g.NamespaceIds.localeSet.id;
            class m extends b.XFAObject {
              constructor(ne) {
                super(f, "calendarSymbols", !0), this.name = "gregorian", this.dayNames = new b.XFAObjectArray(2), this.eraNames = null, this.meridiemNames = null, this.monthNames = new b.XFAObjectArray(2);
              }
            }
            class C extends b.StringObject {
              constructor(ne) {
                super(f, "currencySymbol"), this.name = (0, y.getStringOption)(ne.name, ["symbol", "isoname", "decimal"]);
              }
            }
            class w extends b.XFAObject {
              constructor(ne) {
                super(f, "currencySymbols", !0), this.currencySymbol = new b.XFAObjectArray(3);
              }
            }
            class S extends b.StringObject {
              constructor(ne) {
                super(f, "datePattern"), this.name = (0, y.getStringOption)(ne.name, ["full", "long", "med", "short"]);
              }
            }
            class $ extends b.XFAObject {
              constructor(ne) {
                super(f, "datePatterns", !0), this.datePattern = new b.XFAObjectArray(4);
              }
            }
            class T extends b.ContentObject {
              constructor(ne) {
                super(f, "dateTimeSymbols");
              }
            }
            class I extends b.StringObject {
              constructor(ne) {
                super(f, "day");
              }
            }
            class _ extends b.XFAObject {
              constructor(ne) {
                super(f, "dayNames", !0), this.abbr = (0, y.getInteger)({
                  data: ne.abbr,
                  defaultValue: 0,
                  validate: (K) => K === 1
                }), this.day = new b.XFAObjectArray(7);
              }
            }
            class E extends b.StringObject {
              constructor(ne) {
                super(f, "era");
              }
            }
            class R extends b.XFAObject {
              constructor(ne) {
                super(f, "eraNames", !0), this.era = new b.XFAObjectArray(2);
              }
            }
            class O extends b.XFAObject {
              constructor(ne) {
                super(f, "locale", !0), this.desc = ne.desc || "", this.name = "isoname", this.calendarSymbols = null, this.currencySymbols = null, this.datePatterns = null, this.dateTimeSymbols = null, this.numberPatterns = null, this.numberSymbols = null, this.timePatterns = null, this.typeFaces = null;
              }
            }
            class L extends b.XFAObject {
              constructor(ne) {
                super(f, "localeSet", !0), this.locale = new b.XFAObjectArray();
              }
            }
            class B extends b.StringObject {
              constructor(ne) {
                super(f, "meridiem");
              }
            }
            class F extends b.XFAObject {
              constructor(ne) {
                super(f, "meridiemNames", !0), this.meridiem = new b.XFAObjectArray(2);
              }
            }
            class M extends b.StringObject {
              constructor(ne) {
                super(f, "month");
              }
            }
            class W extends b.XFAObject {
              constructor(ne) {
                super(f, "monthNames", !0), this.abbr = (0, y.getInteger)({
                  data: ne.abbr,
                  defaultValue: 0,
                  validate: (K) => K === 1
                }), this.month = new b.XFAObjectArray(12);
              }
            }
            class j extends b.StringObject {
              constructor(ne) {
                super(f, "numberPattern"), this.name = (0, y.getStringOption)(ne.name, ["full", "long", "med", "short"]);
              }
            }
            class G extends b.XFAObject {
              constructor(ne) {
                super(f, "numberPatterns", !0), this.numberPattern = new b.XFAObjectArray(4);
              }
            }
            class U extends b.StringObject {
              constructor(ne) {
                super(f, "numberSymbol"), this.name = (0, y.getStringOption)(ne.name, ["decimal", "grouping", "percent", "minus", "zero"]);
              }
            }
            class k extends b.XFAObject {
              constructor(ne) {
                super(f, "numberSymbols", !0), this.numberSymbol = new b.XFAObjectArray(5);
              }
            }
            class N extends b.StringObject {
              constructor(ne) {
                super(f, "timePattern"), this.name = (0, y.getStringOption)(ne.name, ["full", "long", "med", "short"]);
              }
            }
            class P extends b.XFAObject {
              constructor(ne) {
                super(f, "timePatterns", !0), this.timePattern = new b.XFAObjectArray(4);
              }
            }
            class D extends b.XFAObject {
              constructor(ne) {
                super(f, "typeFace", !0), this.name = ne.name | "";
              }
            }
            class H extends b.XFAObject {
              constructor(ne) {
                super(f, "typeFaces", !0), this.typeFace = new b.XFAObjectArray();
              }
            }
            class V {
              static [g.$buildXFAObject](ne, K) {
                if (V.hasOwnProperty(ne))
                  return V[ne](K);
              }
              static calendarSymbols(ne) {
                return new m(ne);
              }
              static currencySymbol(ne) {
                return new C(ne);
              }
              static currencySymbols(ne) {
                return new w(ne);
              }
              static datePattern(ne) {
                return new S(ne);
              }
              static datePatterns(ne) {
                return new $(ne);
              }
              static dateTimeSymbols(ne) {
                return new T(ne);
              }
              static day(ne) {
                return new I(ne);
              }
              static dayNames(ne) {
                return new _(ne);
              }
              static era(ne) {
                return new E(ne);
              }
              static eraNames(ne) {
                return new R(ne);
              }
              static locale(ne) {
                return new O(ne);
              }
              static localeSet(ne) {
                return new L(ne);
              }
              static meridiem(ne) {
                return new B(ne);
              }
              static meridiemNames(ne) {
                return new F(ne);
              }
              static month(ne) {
                return new M(ne);
              }
              static monthNames(ne) {
                return new W(ne);
              }
              static numberPattern(ne) {
                return new j(ne);
              }
              static numberPatterns(ne) {
                return new G(ne);
              }
              static numberSymbol(ne) {
                return new U(ne);
              }
              static numberSymbols(ne) {
                return new k(ne);
              }
              static timePattern(ne) {
                return new N(ne);
              }
              static timePatterns(ne) {
                return new P(ne);
              }
              static typeFace(ne) {
                return new D(ne);
              }
              static typeFaces(ne) {
                return new H(ne);
              }
            }
            A.LocaleSetNamespace = V;
          },
          /* 97 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.SignatureNamespace = void 0;
            var g = x(81), b = x(87);
            const y = g.NamespaceIds.signature.id;
            class f extends b.XFAObject {
              constructor(w) {
                super(y, "signature", !0);
              }
            }
            class m {
              static [g.$buildXFAObject](w, S) {
                if (m.hasOwnProperty(w))
                  return m[w](S);
              }
              static signature(w) {
                return new f(w);
              }
            }
            A.SignatureNamespace = m;
          },
          /* 98 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.StylesheetNamespace = void 0;
            var g = x(81), b = x(87);
            const y = g.NamespaceIds.stylesheet.id;
            class f extends b.XFAObject {
              constructor(w) {
                super(y, "stylesheet", !0);
              }
            }
            class m {
              static [g.$buildXFAObject](w, S) {
                if (m.hasOwnProperty(w))
                  return m[w](S);
              }
              static stylesheet(w) {
                return new f(w);
              }
            }
            A.StylesheetNamespace = m;
          },
          /* 99 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.XdpNamespace = void 0;
            var g = x(81), b = x(78), y = x(87);
            const f = g.NamespaceIds.xdp.id;
            class m extends y.XFAObject {
              constructor(S) {
                super(f, "xdp", !0), this.uuid = S.uuid || "", this.timeStamp = S.timeStamp || "", this.config = null, this.connectionSet = null, this.datasets = null, this.localeSet = null, this.stylesheet = new y.XFAObjectArray(), this.template = null;
              }
              [b.$onChildCheck](S) {
                const $ = g.NamespaceIds[S[b.$nodeName]];
                return $ && S[b.$namespaceId] === $.id;
              }
            }
            class C {
              static [g.$buildXFAObject](S, $) {
                if (C.hasOwnProperty(S))
                  return C[S]($);
              }
              static xdp(S) {
                return new m(S);
              }
            }
            A.XdpNamespace = C;
          },
          /* 100 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.XhtmlNamespace = void 0;
            var g = x(78), b = x(81), y = x(83), f = x(84), m = x(87);
            const C = b.NamespaceIds.xhtml.id, w = Symbol(), S = /* @__PURE__ */ new Set(["color", "font", "font-family", "font-size", "font-stretch", "font-style", "font-weight", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "letter-spacing", "line-height", "orphans", "page-break-after", "page-break-before", "page-break-inside", "tab-interval", "tab-stop", "text-align", "text-decoration", "text-indent", "vertical-align", "widows", "kerning-mode", "xfa-font-horizontal-scale", "xfa-font-vertical-scale", "xfa-spacerun", "xfa-tab-stops"]), $ = /* @__PURE__ */ new Map([["page-break-after", "breakAfter"], ["page-break-before", "breakBefore"], ["page-break-inside", "breakInside"], ["kerning-mode", (ne) => ne === "none" ? "none" : "normal"], ["xfa-font-horizontal-scale", (ne) => `scaleX(${Math.max(0, Math.min(parseInt(ne) / 100)).toFixed(2)})`], ["xfa-font-vertical-scale", (ne) => `scaleY(${Math.max(0, Math.min(parseInt(ne) / 100)).toFixed(2)})`], ["xfa-spacerun", ""], ["xfa-tab-stops", ""], ["font-size", (ne, K) => (ne = K.fontSize = (0, f.getMeasurement)(ne), (0, y.measureToString)(0.99 * ne))], ["letter-spacing", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))], ["line-height", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))], ["margin", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))], ["margin-bottom", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))], ["margin-left", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))], ["margin-right", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))], ["margin-top", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))], ["text-indent", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))], ["font-family", (ne) => ne], ["vertical-align", (ne) => (0, y.measureToString)((0, f.getMeasurement)(ne))]]), T = /\s+/g, I = /[\r\n]+/g, _ = /\r\n?/g;
            function E(ne, K, q) {
              const Y = /* @__PURE__ */ Object.create(null);
              if (!ne)
                return Y;
              const ee = /* @__PURE__ */ Object.create(null);
              for (const [Q, J] of ne.split(";").map((te) => te.split(":", 2))) {
                const te = $.get(Q);
                if (te === "")
                  continue;
                let ae = J;
                te && (ae = typeof te == "string" ? te : te(J, ee)), Q.endsWith("scale") ? Y.transform = Y.transform ? `${Y[Q]} ${ae}` : ae : Y[Q.replaceAll(/-([a-zA-Z])/g, (se, ie) => ie.toUpperCase())] = ae;
              }
              if (Y.fontFamily && (0, y.setFontFamily)({
                typeface: Y.fontFamily,
                weight: Y.fontWeight || "normal",
                posture: Y.fontStyle || "normal",
                size: ee.fontSize || 0
              }, K, K[g.$globalData].fontFinder, Y), q && Y.verticalAlign && Y.verticalAlign !== "0px" && Y.fontSize) {
                const te = (0, f.getMeasurement)(Y.fontSize);
                Y.fontSize = (0, y.measureToString)(te * 0.583), Y.verticalAlign = (0, y.measureToString)(Math.sign((0, f.getMeasurement)(Y.verticalAlign)) * te * 0.333);
              }
              return q && Y.fontSize && (Y.fontSize = `calc(${Y.fontSize} * var(--scale-factor))`), (0, y.fixTextIndent)(Y), Y;
            }
            function R(ne) {
              return ne.style ? ne.style.trim().split(/\s*;\s*/).filter((K) => !!K).map((K) => K.split(/\s*:\s*/, 2)).filter(([K, q]) => (K === "font-family" && ne[g.$globalData].usedTypefaces.add(q), S.has(K))).map((K) => K.join(":")).join(";") : "";
            }
            const O = /* @__PURE__ */ new Set(["body", "html"]);
            class L extends m.XmlObject {
              constructor(K, q) {
                super(C, q), this[w] = !1, this.style = K.style || "";
              }
              [g.$clean](K) {
                super[g.$clean](K), this.style = R(this);
              }
              [g.$acceptWhitespace]() {
                return !O.has(this[g.$nodeName]);
              }
              [g.$onText](K, q = !1) {
                q ? this[w] = !0 : (K = K.replaceAll(I, ""), this.style.includes("xfa-spacerun:yes") || (K = K.replaceAll(T, " "))), K && (this[g.$content] += K);
              }
              [g.$pushGlyphs](K, q = !0) {
                const Y = /* @__PURE__ */ Object.create(null), ee = {
                  top: NaN,
                  bottom: NaN,
                  left: NaN,
                  right: NaN
                };
                let Q = null;
                for (const [J, te] of this.style.split(";").map((ae) => ae.split(":", 2)))
                  switch (J) {
                    case "font-family":
                      Y.typeface = (0, f.stripQuotes)(te);
                      break;
                    case "font-size":
                      Y.size = (0, f.getMeasurement)(te);
                      break;
                    case "font-weight":
                      Y.weight = te;
                      break;
                    case "font-style":
                      Y.posture = te;
                      break;
                    case "letter-spacing":
                      Y.letterSpacing = (0, f.getMeasurement)(te);
                      break;
                    case "margin":
                      const ae = te.split(/ \t/).map((se) => (0, f.getMeasurement)(se));
                      switch (ae.length) {
                        case 1:
                          ee.top = ee.bottom = ee.left = ee.right = ae[0];
                          break;
                        case 2:
                          ee.top = ee.bottom = ae[0], ee.left = ee.right = ae[1];
                          break;
                        case 3:
                          ee.top = ae[0], ee.bottom = ae[2], ee.left = ee.right = ae[1];
                          break;
                        case 4:
                          ee.top = ae[0], ee.left = ae[1], ee.bottom = ae[2], ee.right = ae[3];
                          break;
                      }
                      break;
                    case "margin-top":
                      ee.top = (0, f.getMeasurement)(te);
                      break;
                    case "margin-bottom":
                      ee.bottom = (0, f.getMeasurement)(te);
                      break;
                    case "margin-left":
                      ee.left = (0, f.getMeasurement)(te);
                      break;
                    case "margin-right":
                      ee.right = (0, f.getMeasurement)(te);
                      break;
                    case "line-height":
                      Q = (0, f.getMeasurement)(te);
                      break;
                  }
                if (K.pushData(Y, ee, Q), this[g.$content])
                  K.addString(this[g.$content]);
                else
                  for (const J of this[g.$getChildren]()) {
                    if (J[g.$nodeName] === "#text") {
                      K.addString(J[g.$content]);
                      continue;
                    }
                    J[g.$pushGlyphs](K);
                  }
                q && K.popFont();
              }
              [g.$toHTML](K) {
                const q = [];
                if (this[g.$extra] = {
                  children: q
                }, this[g.$childrenToHTML]({}), q.length === 0 && !this[g.$content])
                  return f.HTMLResult.EMPTY;
                let Y;
                return this[w] ? Y = this[g.$content] ? this[g.$content].replaceAll(_, `
`) : void 0 : Y = this[g.$content] || void 0, f.HTMLResult.success({
                  name: this[g.$nodeName],
                  attributes: {
                    href: this.href,
                    style: E(this.style, this, this[w])
                  },
                  children: q,
                  value: Y
                });
              }
            }
            class B extends L {
              constructor(K) {
                super(K, "a"), this.href = (0, y.fixURL)(K.href) || "";
              }
            }
            class F extends L {
              constructor(K) {
                super(K, "b");
              }
              [g.$pushGlyphs](K) {
                K.pushFont({
                  weight: "bold"
                }), super[g.$pushGlyphs](K), K.popFont();
              }
            }
            class M extends L {
              constructor(K) {
                super(K, "body");
              }
              [g.$toHTML](K) {
                const q = super[g.$toHTML](K), {
                  html: Y
                } = q;
                return Y ? (Y.name = "div", Y.attributes.class = ["xfaRich"], q) : f.HTMLResult.EMPTY;
              }
            }
            class W extends L {
              constructor(K) {
                super(K, "br");
              }
              [g.$text]() {
                return `
`;
              }
              [g.$pushGlyphs](K) {
                K.addString(`
`);
              }
              [g.$toHTML](K) {
                return f.HTMLResult.success({
                  name: "br"
                });
              }
            }
            class j extends L {
              constructor(K) {
                super(K, "html");
              }
              [g.$toHTML](K) {
                const q = [];
                if (this[g.$extra] = {
                  children: q
                }, this[g.$childrenToHTML]({}), q.length === 0)
                  return f.HTMLResult.success({
                    name: "div",
                    attributes: {
                      class: ["xfaRich"],
                      style: {}
                    },
                    value: this[g.$content] || ""
                  });
                if (q.length === 1) {
                  const Y = q[0];
                  if (Y.attributes?.class.includes("xfaRich"))
                    return f.HTMLResult.success(Y);
                }
                return f.HTMLResult.success({
                  name: "div",
                  attributes: {
                    class: ["xfaRich"],
                    style: {}
                  },
                  children: q
                });
              }
            }
            class G extends L {
              constructor(K) {
                super(K, "i");
              }
              [g.$pushGlyphs](K) {
                K.pushFont({
                  posture: "italic"
                }), super[g.$pushGlyphs](K), K.popFont();
              }
            }
            class U extends L {
              constructor(K) {
                super(K, "li");
              }
            }
            class k extends L {
              constructor(K) {
                super(K, "ol");
              }
            }
            class N extends L {
              constructor(K) {
                super(K, "p");
              }
              [g.$pushGlyphs](K) {
                super[g.$pushGlyphs](K, !1), K.addString(`
`), K.addPara(), K.popFont();
              }
              [g.$text]() {
                return this[g.$getParent]()[g.$getChildren]().at(-1) === this ? super[g.$text]() : super[g.$text]() + `
`;
              }
            }
            class P extends L {
              constructor(K) {
                super(K, "span");
              }
            }
            class D extends L {
              constructor(K) {
                super(K, "sub");
              }
            }
            class H extends L {
              constructor(K) {
                super(K, "sup");
              }
            }
            class V extends L {
              constructor(K) {
                super(K, "ul");
              }
            }
            class Z {
              static [b.$buildXFAObject](K, q) {
                if (Z.hasOwnProperty(K))
                  return Z[K](q);
              }
              static a(K) {
                return new B(K);
              }
              static b(K) {
                return new F(K);
              }
              static body(K) {
                return new M(K);
              }
              static br(K) {
                return new W(K);
              }
              static html(K) {
                return new j(K);
              }
              static i(K) {
                return new G(K);
              }
              static li(K) {
                return new U(K);
              }
              static ol(K) {
                return new k(K);
              }
              static p(K) {
                return new N(K);
              }
              static span(K) {
                return new P(K);
              }
              static sub(K) {
                return new D(K);
              }
              static sup(K) {
                return new H(K);
              }
              static ul(K) {
                return new V(K);
              }
            }
            A.XhtmlNamespace = Z;
          },
          /* 101 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.UnknownNamespace = void 0;
            var g = x(81), b = x(87);
            class y {
              constructor(m) {
                this.namespaceId = m;
              }
              [g.$buildXFAObject](m, C) {
                return new b.XmlObject(this.namespaceId, m, C);
              }
            }
            A.UnknownNamespace = y;
          },
          /* 102 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.DatasetReader = void 0;
            var g = x(2), b = x(3), y = x(71);
            function f(w) {
              try {
                return (0, g.stringToUTF8String)(w);
              } catch (S) {
                return (0, g.warn)(`UTF-8 decoding failed: "${S}".`), w;
              }
            }
            class m extends y.SimpleXMLParser {
              constructor(S) {
                super(S), this.node = null;
              }
              onEndElement(S) {
                const $ = super.onEndElement(S);
                if ($ && S === "xfa:datasets")
                  throw this.node = $, new Error("Aborting DatasetXMLParser.");
              }
            }
            class C {
              constructor(S) {
                if (S.datasets)
                  this.node = new y.SimpleXMLParser({
                    hasAttributes: !0
                  }).parseFromString(S.datasets).documentElement;
                else {
                  const $ = new m({
                    hasAttributes: !0
                  });
                  try {
                    $.parseFromString(S["xdp:xdp"]);
                  } catch {
                  }
                  this.node = $.node;
                }
              }
              getValue(S) {
                if (!this.node || !S)
                  return "";
                const $ = this.node.searchNode((0, b.parseXFAPath)(S), 0);
                return $ ? $.firstChild?.nodeName === "value" ? $.children.map((I) => f(I.textContent)) : f($.textContent) : "";
              }
            }
            A.DatasetReader = C;
          },
          /* 103 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.XRef = void 0;
            var g = x(2), b = x(4), y = x(16), f = x(3), m = x(5), C = x(74);
            class w {
              #e = null;
              constructor($, T) {
                this.stream = $, this.pdfManager = T, this.entries = [], this._xrefStms = /* @__PURE__ */ new Set(), this._cacheMap = /* @__PURE__ */ new Map(), this._pendingRefs = new b.RefSet(), this._newPersistentRefNum = null, this._newTemporaryRefNum = null;
              }
              getNewPersistentRef($) {
                this._newPersistentRefNum === null && (this._newPersistentRefNum = this.entries.length || 1);
                const T = this._newPersistentRefNum++;
                return this._cacheMap.set(T, $), b.Ref.get(T, 0);
              }
              getNewTemporaryRef() {
                return this._newTemporaryRefNum === null && (this._newTemporaryRefNum = this.entries.length || 1), b.Ref.get(this._newTemporaryRefNum++, 0);
              }
              resetNewTemporaryRef() {
                this._newTemporaryRefNum = null;
              }
              setStartXRef($) {
                this.startXRefQueue = [$];
              }
              parse($ = !1) {
                let T;
                $ ? ((0, g.warn)("Indexing all PDF objects"), T = this.indexObjects()) : T = this.readXRef(), T.assignXref(this), this.trailer = T;
                let I;
                try {
                  I = T.get("Encrypt");
                } catch (E) {
                  if (E instanceof f.MissingDataException)
                    throw E;
                  (0, g.warn)(`XRef.parse - Invalid "Encrypt" reference: "${E}".`);
                }
                if (I instanceof b.Dict) {
                  const E = T.get("ID"), R = E?.length ? E[0] : "";
                  I.suppressEncryption = !0, this.encrypt = new C.CipherTransformFactory(I, R, this.pdfManager.password);
                }
                let _;
                try {
                  _ = T.get("Root");
                } catch (E) {
                  if (E instanceof f.MissingDataException)
                    throw E;
                  (0, g.warn)(`XRef.parse - Invalid "Root" reference: "${E}".`);
                }
                if (_ instanceof b.Dict)
                  try {
                    if (_.get("Pages") instanceof b.Dict) {
                      this.root = _;
                      return;
                    }
                  } catch (E) {
                    if (E instanceof f.MissingDataException)
                      throw E;
                    (0, g.warn)(`XRef.parse - Invalid "Pages" reference: "${E}".`);
                  }
                throw $ ? new g.InvalidPDFException("Invalid Root reference.") : new f.XRefParseException();
              }
              processXRefTable($) {
                "tableState" in this || (this.tableState = {
                  entryNum: 0,
                  streamPos: $.lexer.stream.pos,
                  parserBuf1: $.buf1,
                  parserBuf2: $.buf2
                });
                const T = this.readXRefTable($);
                if (!(0, b.isCmd)(T, "trailer"))
                  throw new g.FormatError("Invalid XRef table: could not find trailer dictionary");
                let I = $.getObj();
                if (!(I instanceof b.Dict) && I.dict && (I = I.dict), !(I instanceof b.Dict))
                  throw new g.FormatError("Invalid XRef table: could not parse trailer dictionary");
                return delete this.tableState, I;
              }
              readXRefTable($) {
                const T = $.lexer.stream, I = this.tableState;
                T.pos = I.streamPos, $.buf1 = I.parserBuf1, $.buf2 = I.parserBuf2;
                let _;
                for (; ; ) {
                  if (!("firstEntryNum" in I) || !("entryCount" in I)) {
                    if ((0, b.isCmd)(_ = $.getObj(), "trailer"))
                      break;
                    I.firstEntryNum = _, I.entryCount = $.getObj();
                  }
                  let E = I.firstEntryNum;
                  const R = I.entryCount;
                  if (!Number.isInteger(E) || !Number.isInteger(R))
                    throw new g.FormatError("Invalid XRef table: wrong types in subsection header");
                  for (let O = I.entryNum; O < R; O++) {
                    I.streamPos = T.pos, I.entryNum = O, I.parserBuf1 = $.buf1, I.parserBuf2 = $.buf2;
                    const L = {};
                    L.offset = $.getObj(), L.gen = $.getObj();
                    const B = $.getObj();
                    if (B instanceof b.Cmd)
                      switch (B.cmd) {
                        case "f":
                          L.free = !0;
                          break;
                        case "n":
                          L.uncompressed = !0;
                          break;
                      }
                    if (!Number.isInteger(L.offset) || !Number.isInteger(L.gen) || !(L.free || L.uncompressed))
                      throw new g.FormatError(`Invalid entry in XRef subsection: ${E}, ${R}`);
                    O === 0 && L.free && E === 1 && (E = 0), this.entries[O + E] || (this.entries[O + E] = L);
                  }
                  I.entryNum = 0, I.streamPos = T.pos, I.parserBuf1 = $.buf1, I.parserBuf2 = $.buf2, delete I.firstEntryNum, delete I.entryCount;
                }
                if (this.entries[0] && !this.entries[0].free)
                  throw new g.FormatError("Invalid XRef table: unexpected first object");
                return _;
              }
              processXRefStream($) {
                if (!("streamState" in this)) {
                  const T = $.dict, I = T.get("W");
                  let _ = T.get("Index");
                  _ || (_ = [0, T.get("Size")]), this.streamState = {
                    entryRanges: _,
                    byteWidths: I,
                    entryNum: 0,
                    streamPos: $.pos
                  };
                }
                return this.readXRefStream($), delete this.streamState, $.dict;
              }
              readXRefStream($) {
                const T = this.streamState;
                $.pos = T.streamPos;
                const [I, _, E] = T.byteWidths, R = T.entryRanges;
                for (; R.length > 0; ) {
                  const [O, L] = R;
                  if (!Number.isInteger(O) || !Number.isInteger(L))
                    throw new g.FormatError(`Invalid XRef range fields: ${O}, ${L}`);
                  if (!Number.isInteger(I) || !Number.isInteger(_) || !Number.isInteger(E))
                    throw new g.FormatError(`Invalid XRef entry fields length: ${O}, ${L}`);
                  for (let B = T.entryNum; B < L; ++B) {
                    T.entryNum = B, T.streamPos = $.pos;
                    let F = 0, M = 0, W = 0;
                    for (let G = 0; G < I; ++G) {
                      const U = $.getByte();
                      if (U === -1)
                        throw new g.FormatError("Invalid XRef byteWidths 'type'.");
                      F = F << 8 | U;
                    }
                    I === 0 && (F = 1);
                    for (let G = 0; G < _; ++G) {
                      const U = $.getByte();
                      if (U === -1)
                        throw new g.FormatError("Invalid XRef byteWidths 'offset'.");
                      M = M << 8 | U;
                    }
                    for (let G = 0; G < E; ++G) {
                      const U = $.getByte();
                      if (U === -1)
                        throw new g.FormatError("Invalid XRef byteWidths 'generation'.");
                      W = W << 8 | U;
                    }
                    const j = {};
                    switch (j.offset = M, j.gen = W, F) {
                      case 0:
                        j.free = !0;
                        break;
                      case 1:
                        j.uncompressed = !0;
                        break;
                      case 2:
                        break;
                      default:
                        throw new g.FormatError(`Invalid XRef entry type: ${F}`);
                    }
                    this.entries[O + B] || (this.entries[O + B] = j);
                  }
                  T.entryNum = 0, T.streamPos = $.pos, R.splice(0, 2);
                }
              }
              indexObjects() {
                function O(Y, ee) {
                  let Q = "", J = Y[ee];
                  for (; J !== 10 && J !== 13 && J !== 60 && !(++ee >= Y.length); )
                    Q += String.fromCharCode(J), J = Y[ee];
                  return Q;
                }
                function L(Y, ee, Q) {
                  const J = Q.length, te = Y.length;
                  let ae = 0;
                  for (; ee < te; ) {
                    let se = 0;
                    for (; se < J && Y[ee + se] === Q[se]; )
                      ++se;
                    if (se >= J)
                      break;
                    ee++, ae++;
                  }
                  return ae;
                }
                const B = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g, F = /\b(startxref|\d+\s+\d+\s+obj)\b/g, M = /^(\d+)\s+(\d+)\s+obj\b/, W = new Uint8Array([116, 114, 97, 105, 108, 101, 114]), j = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), G = new Uint8Array([47, 88, 82, 101, 102]);
                this.entries.length = 0, this._cacheMap.clear();
                const U = this.stream;
                U.pos = 0;
                const k = U.getBytes(), N = (0, g.bytesToString)(k), P = k.length;
                let D = U.start;
                const H = [], V = [];
                for (; D < P; ) {
                  let Y = k[D];
                  if (Y === 9 || Y === 10 || Y === 13 || Y === 32) {
                    ++D;
                    continue;
                  }
                  if (Y === 37) {
                    do {
                      if (++D, D >= P)
                        break;
                      Y = k[D];
                    } while (Y !== 10 && Y !== 13);
                    continue;
                  }
                  const ee = O(k, D);
                  let Q;
                  if (ee.startsWith("xref") && (ee.length === 4 || /\s/.test(ee[4])))
                    D += L(k, D, W), H.push(D), D += L(k, D, j);
                  else if (Q = M.exec(ee)) {
                    const J = Q[1] | 0, te = Q[2] | 0, ae = D + ee.length;
                    let se, ie = !1;
                    if (!this.entries[J])
                      ie = !0;
                    else if (this.entries[J].gen === te)
                      try {
                        new y.Parser({
                          lexer: new y.Lexer(U.makeSubStream(ae))
                        }).getObj(), ie = !0;
                      } catch (pe) {
                        pe instanceof f.ParserEOFException ? (0, g.warn)(`indexObjects -- checking object (${ee}): "${pe}".`) : ie = !0;
                      }
                    ie && (this.entries[J] = {
                      offset: D - U.start,
                      gen: te,
                      uncompressed: !0
                    }), B.lastIndex = ae;
                    const fe = B.exec(N);
                    fe ? (se = B.lastIndex + 1 - D, fe[1] !== "endobj" && ((0, g.warn)(`indexObjects: Found "${fe[1]}" inside of another "obj", caused by missing "endobj" -- trying to recover.`), se -= fe[1].length + 1)) : se = P - D;
                    const ge = k.subarray(D, D + se), me = L(ge, 0, G);
                    me < se && ge[me + 5] < 64 && (V.push(D - U.start), this._xrefStms.add(D - U.start)), D += se;
                  } else if (ee.startsWith("trailer") && (ee.length === 7 || /\s/.test(ee[7]))) {
                    H.push(D);
                    const J = D + ee.length;
                    let te;
                    F.lastIndex = J;
                    const ae = F.exec(N);
                    ae ? (te = F.lastIndex + 1 - D, ae[1] !== "startxref" && ((0, g.warn)(`indexObjects: Found "${ae[1]}" after "trailer", caused by missing "startxref" -- trying to recover.`), te -= ae[1].length + 1)) : te = P - D, D += te;
                  } else
                    D += ee.length + 1;
                }
                for (const Y of V)
                  this.startXRefQueue.push(Y), this.readXRef(!0);
                const Z = [];
                let ne = !1;
                for (const Y of H) {
                  U.pos = Y;
                  const ee = new y.Parser({
                    lexer: new y.Lexer(U),
                    xref: this,
                    allowStreams: !0,
                    recoveryMode: !0
                  }), Q = ee.getObj();
                  if (!(0, b.isCmd)(Q, "trailer"))
                    continue;
                  const J = ee.getObj();
                  J instanceof b.Dict && (Z.push(J), J.has("Encrypt") && (ne = !0));
                }
                let K, q;
                for (const Y of [...Z, "genFallback", ...Z]) {
                  if (Y === "genFallback") {
                    if (!q)
                      break;
                    this._generationFallback = !0;
                    continue;
                  }
                  let ee = !1;
                  try {
                    const Q = Y.get("Root");
                    if (!(Q instanceof b.Dict))
                      continue;
                    const J = Q.get("Pages");
                    if (!(J instanceof b.Dict))
                      continue;
                    const te = J.get("Count");
                    Number.isInteger(te) && (ee = !0);
                  } catch (Q) {
                    q = Q;
                    continue;
                  }
                  if (ee && (!ne || Y.has("Encrypt")) && Y.has("ID"))
                    return Y;
                  K = Y;
                }
                if (K)
                  return K;
                if (this.topDict)
                  return this.topDict;
                throw new g.InvalidPDFException("Invalid PDF structure.");
              }
              readXRef($ = !1) {
                const T = this.stream, I = /* @__PURE__ */ new Set();
                for (; this.startXRefQueue.length; ) {
                  try {
                    const _ = this.startXRefQueue[0];
                    if (I.has(_)) {
                      (0, g.warn)("readXRef - skipping XRef table since it was already parsed."), this.startXRefQueue.shift();
                      continue;
                    }
                    I.add(_), T.pos = _ + T.start;
                    const E = new y.Parser({
                      lexer: new y.Lexer(T),
                      xref: this,
                      allowStreams: !0
                    });
                    let R = E.getObj(), O;
                    if ((0, b.isCmd)(R, "xref"))
                      O = this.processXRefTable(E), this.topDict || (this.topDict = O), R = O.get("XRefStm"), Number.isInteger(R) && !this._xrefStms.has(R) && (this._xrefStms.add(R), this.startXRefQueue.push(R), this.#e ??= R);
                    else if (Number.isInteger(R)) {
                      if (!Number.isInteger(E.getObj()) || !(0, b.isCmd)(E.getObj(), "obj") || !((R = E.getObj()) instanceof m.BaseStream))
                        throw new g.FormatError("Invalid XRef stream");
                      if (O = this.processXRefStream(R), this.topDict || (this.topDict = O), !O)
                        throw new g.FormatError("Failed to read XRef stream");
                    } else
                      throw new g.FormatError("Invalid XRef stream header");
                    R = O.get("Prev"), Number.isInteger(R) ? this.startXRefQueue.push(R) : R instanceof b.Ref && this.startXRefQueue.push(R.num);
                  } catch (_) {
                    if (_ instanceof f.MissingDataException)
                      throw _;
                    (0, g.info)("(while reading XRef): " + _);
                  }
                  this.startXRefQueue.shift();
                }
                if (this.topDict)
                  return this.topDict;
                if (!$)
                  throw new f.XRefParseException();
              }
              get lastXRefStreamPos() {
                return this.#e ?? (this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null);
              }
              getEntry($) {
                const T = this.entries[$];
                return T && !T.free && T.offset ? T : null;
              }
              fetchIfRef($, T = !1) {
                return $ instanceof b.Ref ? this.fetch($, T) : $;
              }
              fetch($, T = !1) {
                if (!($ instanceof b.Ref))
                  throw new Error("ref object is not a reference");
                const I = $.num, _ = this._cacheMap.get(I);
                if (_ !== void 0)
                  return _ instanceof b.Dict && !_.objId && (_.objId = $.toString()), _;
                let E = this.getEntry(I);
                if (E === null)
                  return this._cacheMap.set(I, E), E;
                if (this._pendingRefs.has($))
                  return this._pendingRefs.remove($), (0, g.warn)(`Ignoring circular reference: ${$}.`), b.CIRCULAR_REF;
                this._pendingRefs.put($);
                try {
                  E = E.uncompressed ? this.fetchUncompressed($, E, T) : this.fetchCompressed($, E, T), this._pendingRefs.remove($);
                } catch (R) {
                  throw this._pendingRefs.remove($), R;
                }
                return E instanceof b.Dict ? E.objId = $.toString() : E instanceof m.BaseStream && (E.dict.objId = $.toString()), E;
              }
              fetchUncompressed($, T, I = !1) {
                const _ = $.gen;
                let E = $.num;
                if (T.gen !== _) {
                  const M = `Inconsistent generation in XRef: ${$}`;
                  if (this._generationFallback && T.gen < _)
                    return (0, g.warn)(M), this.fetchUncompressed(b.Ref.get(E, T.gen), T, I);
                  throw new f.XRefEntryException(M);
                }
                const R = this.stream.makeSubStream(T.offset + this.stream.start), O = new y.Parser({
                  lexer: new y.Lexer(R),
                  xref: this,
                  allowStreams: !0
                }), L = O.getObj(), B = O.getObj(), F = O.getObj();
                if (L !== E || B !== _ || !(F instanceof b.Cmd))
                  throw new f.XRefEntryException(`Bad (uncompressed) XRef entry: ${$}`);
                if (F.cmd !== "obj") {
                  if (F.cmd.startsWith("obj") && (E = parseInt(F.cmd.substring(3), 10), !Number.isNaN(E)))
                    return E;
                  throw new f.XRefEntryException(`Bad (uncompressed) XRef entry: ${$}`);
                }
                return T = this.encrypt && !I ? O.getObj(this.encrypt.createCipherTransform(E, _)) : O.getObj(), T instanceof m.BaseStream || this._cacheMap.set(E, T), T;
              }
              fetchCompressed($, T, I = !1) {
                const _ = T.offset, E = this.fetch(b.Ref.get(_, 0));
                if (!(E instanceof m.BaseStream))
                  throw new g.FormatError("bad ObjStm stream");
                const R = E.dict.get("First"), O = E.dict.get("N");
                if (!Number.isInteger(R) || !Number.isInteger(O))
                  throw new g.FormatError("invalid first and n parameters for ObjStm stream");
                let L = new y.Parser({
                  lexer: new y.Lexer(E),
                  xref: this,
                  allowStreams: !0
                });
                const B = new Array(O), F = new Array(O);
                for (let j = 0; j < O; ++j) {
                  const G = L.getObj();
                  if (!Number.isInteger(G))
                    throw new g.FormatError(`invalid object number in the ObjStm stream: ${G}`);
                  const U = L.getObj();
                  if (!Number.isInteger(U))
                    throw new g.FormatError(`invalid object offset in the ObjStm stream: ${U}`);
                  B[j] = G, F[j] = U;
                }
                const M = (E.start || 0) + R, W = new Array(O);
                for (let j = 0; j < O; ++j) {
                  const G = j < O - 1 ? F[j + 1] - F[j] : void 0;
                  if (G < 0)
                    throw new g.FormatError("Invalid offset in the ObjStm stream.");
                  L = new y.Parser({
                    lexer: new y.Lexer(E.makeSubStream(M + F[j], G, E.dict)),
                    xref: this,
                    allowStreams: !0
                  });
                  const U = L.getObj();
                  if (W[j] = U, U instanceof m.BaseStream)
                    continue;
                  const k = B[j], N = this.entries[k];
                  N && N.offset === _ && N.gen === j && this._cacheMap.set(k, U);
                }
                if (T = W[T.gen], T === void 0)
                  throw new f.XRefEntryException(`Bad (compressed) XRef entry: ${$}`);
                return T;
              }
              async fetchIfRefAsync($, T) {
                return $ instanceof b.Ref ? this.fetchAsync($, T) : $;
              }
              async fetchAsync($, T) {
                try {
                  return this.fetch($, T);
                } catch (I) {
                  if (!(I instanceof f.MissingDataException))
                    throw I;
                  return await this.pdfManager.requestRange(I.begin, I.end), this.fetchAsync($, T);
                }
              }
              getCatalogObj() {
                return this.root;
              }
            }
            A.XRef = w;
          },
          /* 104 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.MessageHandler = void 0;
            var g = x(2);
            const b = {
              DATA: 1,
              ERROR: 2
            }, y = {
              CANCEL: 1,
              CANCEL_COMPLETE: 2,
              CLOSE: 3,
              ENQUEUE: 4,
              ERROR: 5,
              PULL: 6,
              PULL_COMPLETE: 7,
              START_COMPLETE: 8
            };
            function f(C) {
              switch (C instanceof Error || typeof C == "object" && C !== null || (0, g.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), C.name) {
                case "AbortException":
                  return new g.AbortException(C.message);
                case "MissingPDFException":
                  return new g.MissingPDFException(C.message);
                case "PasswordException":
                  return new g.PasswordException(C.message, C.code);
                case "UnexpectedResponseException":
                  return new g.UnexpectedResponseException(C.message, C.status);
                case "UnknownErrorException":
                  return new g.UnknownErrorException(C.message, C.details);
                default:
                  return new g.UnknownErrorException(C.message, C.toString());
              }
            }
            class m {
              constructor(w, S, $) {
                this.sourceName = w, this.targetName = S, this.comObj = $, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (T) => {
                  const I = T.data;
                  if (I.targetName !== this.sourceName)
                    return;
                  if (I.stream) {
                    this.#t(I);
                    return;
                  }
                  if (I.callback) {
                    const E = I.callbackId, R = this.callbackCapabilities[E];
                    if (!R)
                      throw new Error(`Cannot resolve callback ${E}`);
                    if (delete this.callbackCapabilities[E], I.callback === b.DATA)
                      R.resolve(I.data);
                    else if (I.callback === b.ERROR)
                      R.reject(f(I.reason));
                    else
                      throw new Error("Unexpected callback case");
                    return;
                  }
                  const _ = this.actionHandler[I.action];
                  if (!_)
                    throw new Error(`Unknown action from worker: ${I.action}`);
                  if (I.callbackId) {
                    const E = this.sourceName, R = I.sourceName;
                    new Promise(function(O) {
                      O(_(I.data));
                    }).then(function(O) {
                      $.postMessage({
                        sourceName: E,
                        targetName: R,
                        callback: b.DATA,
                        callbackId: I.callbackId,
                        data: O
                      });
                    }, function(O) {
                      $.postMessage({
                        sourceName: E,
                        targetName: R,
                        callback: b.ERROR,
                        callbackId: I.callbackId,
                        reason: f(O)
                      });
                    });
                    return;
                  }
                  if (I.streamId) {
                    this.#e(I);
                    return;
                  }
                  _(I.data);
                }, $.addEventListener("message", this._onComObjOnMessage);
              }
              on(w, S) {
                const $ = this.actionHandler;
                if ($[w])
                  throw new Error(`There is already an actionName called "${w}"`);
                $[w] = S;
              }
              send(w, S, $) {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: w,
                  data: S
                }, $);
              }
              sendWithPromise(w, S, $) {
                const T = this.callbackId++, I = new g.PromiseCapability();
                this.callbackCapabilities[T] = I;
                try {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: w,
                    callbackId: T,
                    data: S
                  }, $);
                } catch (_) {
                  I.reject(_);
                }
                return I.promise;
              }
              sendWithStream(w, S, $, T) {
                const I = this.streamId++, _ = this.sourceName, E = this.targetName, R = this.comObj;
                return new ReadableStream({
                  start: (O) => {
                    const L = new g.PromiseCapability();
                    return this.streamControllers[I] = {
                      controller: O,
                      startCall: L,
                      pullCall: null,
                      cancelCall: null,
                      isClosed: !1
                    }, R.postMessage({
                      sourceName: _,
                      targetName: E,
                      action: w,
                      streamId: I,
                      data: S,
                      desiredSize: O.desiredSize
                    }, T), L.promise;
                  },
                  pull: (O) => {
                    const L = new g.PromiseCapability();
                    return this.streamControllers[I].pullCall = L, R.postMessage({
                      sourceName: _,
                      targetName: E,
                      stream: y.PULL,
                      streamId: I,
                      desiredSize: O.desiredSize
                    }), L.promise;
                  },
                  cancel: (O) => {
                    (0, g.assert)(O instanceof Error, "cancel must have a valid reason");
                    const L = new g.PromiseCapability();
                    return this.streamControllers[I].cancelCall = L, this.streamControllers[I].isClosed = !0, R.postMessage({
                      sourceName: _,
                      targetName: E,
                      stream: y.CANCEL,
                      streamId: I,
                      reason: f(O)
                    }), L.promise;
                  }
                }, $);
              }
              #e(w) {
                const S = w.streamId, $ = this.sourceName, T = w.sourceName, I = this.comObj, _ = this, E = this.actionHandler[w.action], R = {
                  enqueue(O, L = 1, B) {
                    if (this.isCancelled)
                      return;
                    const F = this.desiredSize;
                    this.desiredSize -= L, F > 0 && this.desiredSize <= 0 && (this.sinkCapability = new g.PromiseCapability(), this.ready = this.sinkCapability.promise), I.postMessage({
                      sourceName: $,
                      targetName: T,
                      stream: y.ENQUEUE,
                      streamId: S,
                      chunk: O
                    }, B);
                  },
                  close() {
                    this.isCancelled || (this.isCancelled = !0, I.postMessage({
                      sourceName: $,
                      targetName: T,
                      stream: y.CLOSE,
                      streamId: S
                    }), delete _.streamSinks[S]);
                  },
                  error(O) {
                    (0, g.assert)(O instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, I.postMessage({
                      sourceName: $,
                      targetName: T,
                      stream: y.ERROR,
                      streamId: S,
                      reason: f(O)
                    }));
                  },
                  sinkCapability: new g.PromiseCapability(),
                  onPull: null,
                  onCancel: null,
                  isCancelled: !1,
                  desiredSize: w.desiredSize,
                  ready: null
                };
                R.sinkCapability.resolve(), R.ready = R.sinkCapability.promise, this.streamSinks[S] = R, new Promise(function(O) {
                  O(E(w.data, R));
                }).then(function() {
                  I.postMessage({
                    sourceName: $,
                    targetName: T,
                    stream: y.START_COMPLETE,
                    streamId: S,
                    success: !0
                  });
                }, function(O) {
                  I.postMessage({
                    sourceName: $,
                    targetName: T,
                    stream: y.START_COMPLETE,
                    streamId: S,
                    reason: f(O)
                  });
                });
              }
              #t(w) {
                const S = w.streamId, $ = this.sourceName, T = w.sourceName, I = this.comObj, _ = this.streamControllers[S], E = this.streamSinks[S];
                switch (w.stream) {
                  case y.START_COMPLETE:
                    w.success ? _.startCall.resolve() : _.startCall.reject(f(w.reason));
                    break;
                  case y.PULL_COMPLETE:
                    w.success ? _.pullCall.resolve() : _.pullCall.reject(f(w.reason));
                    break;
                  case y.PULL:
                    if (!E) {
                      I.postMessage({
                        sourceName: $,
                        targetName: T,
                        stream: y.PULL_COMPLETE,
                        streamId: S,
                        success: !0
                      });
                      break;
                    }
                    E.desiredSize <= 0 && w.desiredSize > 0 && E.sinkCapability.resolve(), E.desiredSize = w.desiredSize, new Promise(function(R) {
                      R(E.onPull?.());
                    }).then(function() {
                      I.postMessage({
                        sourceName: $,
                        targetName: T,
                        stream: y.PULL_COMPLETE,
                        streamId: S,
                        success: !0
                      });
                    }, function(R) {
                      I.postMessage({
                        sourceName: $,
                        targetName: T,
                        stream: y.PULL_COMPLETE,
                        streamId: S,
                        reason: f(R)
                      });
                    });
                    break;
                  case y.ENQUEUE:
                    if ((0, g.assert)(_, "enqueue should have stream controller"), _.isClosed)
                      break;
                    _.controller.enqueue(w.chunk);
                    break;
                  case y.CLOSE:
                    if ((0, g.assert)(_, "close should have stream controller"), _.isClosed)
                      break;
                    _.isClosed = !0, _.controller.close(), this.#r(_, S);
                    break;
                  case y.ERROR:
                    (0, g.assert)(_, "error should have stream controller"), _.controller.error(f(w.reason)), this.#r(_, S);
                    break;
                  case y.CANCEL_COMPLETE:
                    w.success ? _.cancelCall.resolve() : _.cancelCall.reject(f(w.reason)), this.#r(_, S);
                    break;
                  case y.CANCEL:
                    if (!E)
                      break;
                    new Promise(function(R) {
                      R(E.onCancel?.(f(w.reason)));
                    }).then(function() {
                      I.postMessage({
                        sourceName: $,
                        targetName: T,
                        stream: y.CANCEL_COMPLETE,
                        streamId: S,
                        success: !0
                      });
                    }, function(R) {
                      I.postMessage({
                        sourceName: $,
                        targetName: T,
                        stream: y.CANCEL_COMPLETE,
                        streamId: S,
                        reason: f(R)
                      });
                    }), E.sinkCapability.reject(f(w.reason)), E.isCancelled = !0, delete this.streamSinks[S];
                    break;
                  default:
                    throw new Error("Unexpected stream case");
                }
              }
              async #r(w, S) {
                await Promise.allSettled([w.startCall?.promise, w.pullCall?.promise, w.cancelCall?.promise]), delete this.streamControllers[S];
              }
              destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }
            A.MessageHandler = m;
          },
          /* 105 */
          /***/
          (v, A, x) => {
            Object.defineProperty(A, "__esModule", {
              value: !0
            }), A.PDFWorkerStream = void 0;
            var g = x(2);
            class b {
              constructor(C) {
                this._msgHandler = C, this._contentLength = null, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              getFullReader() {
                return (0, g.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once."), this._fullRequestReader = new y(this._msgHandler), this._fullRequestReader;
              }
              getRangeReader(C, w) {
                const S = new f(C, w, this._msgHandler);
                return this._rangeRequestReaders.push(S), S;
              }
              cancelAllRequests(C) {
                this._fullRequestReader?.cancel(C);
                for (const w of this._rangeRequestReaders.slice(0))
                  w.cancel(C);
              }
            }
            A.PDFWorkerStream = b;
            class y {
              constructor(C) {
                this._msgHandler = C, this.onProgress = null, this._contentLength = null, this._isRangeSupported = !1, this._isStreamingSupported = !1;
                const w = this._msgHandler.sendWithStream("GetReader");
                this._reader = w.getReader(), this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((S) => {
                  this._isStreamingSupported = S.isStreamingSupported, this._isRangeSupported = S.isRangeSupported, this._contentLength = S.contentLength;
                });
              }
              get headersReady() {
                return this._headersReady;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              async read() {
                const {
                  value: C,
                  done: w
                } = await this._reader.read();
                return w ? {
                  value: void 0,
                  done: !0
                } : {
                  value: C.buffer,
                  done: !1
                };
              }
              cancel(C) {
                this._reader.cancel(C);
              }
            }
            class f {
              constructor(C, w, S) {
                this._msgHandler = S, this.onProgress = null;
                const $ = this._msgHandler.sendWithStream("GetRangeReader", {
                  begin: C,
                  end: w
                });
                this._reader = $.getReader();
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                const {
                  value: C,
                  done: w
                } = await this._reader.read();
                return w ? {
                  value: void 0,
                  done: !0
                } : {
                  value: C.buffer,
                  done: !1
                };
              }
              cancel(C) {
                this._reader.cancel(C);
              }
            }
          }
          /******/
        ], u = {};
        function d(v) {
          var A = u[v];
          if (A !== void 0)
            return A.exports;
          var x = u[v] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return c[v](x, x.exports, d), x.exports;
        }
        var p = {};
        return (() => {
          var v = p;
          Object.defineProperty(v, "__esModule", {
            value: !0
          }), Object.defineProperty(v, "WorkerMessageHandler", {
            enumerable: !0,
            get: function() {
              return A.WorkerMessageHandler;
            }
          });
          var A = d(1);
        })(), p;
      })()
    ));
  }(pdf_worker)), pdf_worker.exports;
}
var hasRequiredPdf_worker_entry;
function requirePdf_worker_entry() {
  return hasRequiredPdf_worker_entry || (hasRequiredPdf_worker_entry = 1, (typeof window < "u" ? window : {}).pdfjsWorker = requirePdf_worker()), pdf_worker_entry;
}
var pdf_worker_entryExports = requirePdf_worker_entry();
const PDFJSWorker = /* @__PURE__ */ getDefaultExportFromCjs(pdf_worker_entryExports);
async function pdf2img$1(a, s = {}, c) {
  try {
    const { scale: u = 1, imageType: d = "jpeg", range: p = {} } = s, { start: v = 0, end: A = 1 / 0 } = p, { getDocument: x, createCanvas: g, canvasToArrayBuffer: b } = c, y = await x(a), f = y.numPages, m = Math.max(v + 1, 1), C = Math.min(A + 1, f), w = [];
    for (let S = m; S <= C; S++) {
      const $ = await y.getPage(S), T = $.getViewport({ scale: u }), I = g(T.width, T.height);
      if (!I)
        throw new Error("Failed to create canvas");
      const _ = I.getContext("2d");
      if (!_)
        throw new Error("Failed to get canvas context");
      await $.render({ canvasContext: _, viewport: T }).promise;
      const E = b(I, d);
      w.push(E);
    }
    return w;
  } catch (u) {
    throw new Error(`[@pdfme/converter] pdf2img failed: ${u.message}`);
  }
}
async function pdf2size$1(a, s = {}, c) {
  const { scale: u = 1 } = s, { getDocument: d } = c, p = await d(a);
  return Promise.all(new Array(p.numPages).fill("").map(async (A, x) => await p.getPage(x + 1).then((g) => {
    const { height: b, width: y } = g.getViewport({ scale: u, rotation: 0 });
    return { height: pt2mm(b), width: pt2mm(y) };
  })));
}
const backtick = (a) => `\`${a}\``, getType = (a) => a === null ? "null" : a === void 0 ? "undefined" : typeof a == "string" ? "string" : isNaN(a) ? "NaN" : typeof a == "number" ? "number" : typeof a == "boolean" ? "boolean" : typeof a == "symbol" ? "symbol" : typeof a == "bigint" ? "bigint" : a.constructor && a.constructor.name ? a.constructor.name : a.name ? a.name : a.constructor ? String(a.constructor) : String(a), isType = (a, s) => s === "null" ? a === null : s === "undefined" ? a === void 0 : s === "string" ? typeof a == "string" : s === "number" ? typeof a == "number" && !isNaN(a) : s === "boolean" ? typeof a == "boolean" : s === "symbol" ? typeof a == "symbol" : s === "bigint" ? typeof a == "bigint" : s === Date ? a instanceof Date : s === Array ? a instanceof Array : s === Uint8Array ? a instanceof Uint8Array : s === ArrayBuffer ? a instanceof ArrayBuffer : s === Function ? a instanceof Function : a instanceof s[0], createTypeErrorMsg = (a, s, c) => {
  const u = new Array(c.length);
  for (let p = 0, v = c.length; p < v; p++) {
    const A = c[p];
    A === "null" && (u[p] = backtick("null")), A === "undefined" && (u[p] = backtick("undefined")), A === "string" ? u[p] = backtick("string") : A === "number" ? u[p] = backtick("number") : A === "boolean" ? u[p] = backtick("boolean") : A === "symbol" ? u[p] = backtick("symbol") : A === "bigint" ? u[p] = backtick("bigint") : A === Array ? u[p] = backtick("Array") : A === Uint8Array ? u[p] = backtick("Uint8Array") : A === ArrayBuffer ? u[p] = backtick("ArrayBuffer") : u[p] = backtick(A[1]);
  }
  const d = u.join(" or ");
  return `${backtick(s)} must be of type ${d}, but was actually of type ${backtick(getType(a))}`;
}, assertIs = (a, s, c) => {
  for (let u = 0, d = c.length; u < d; u++)
    if (isType(a, c[u]))
      return;
  throw new TypeError(createTypeErrorMsg(a, s, c));
}, assertRange = (a, s, c, u) => {
  if (assertIs(a, s, ["number"]), assertIs(c, "min", ["number"]), assertIs(u, "max", ["number"]), u = Math.max(c, u), a < c || a > u)
    throw new Error(`${backtick(s)} must be at least ${c} and at most ${u}, but was actually ${a}`);
};
var RotationTypes;
(function(a) {
  a.Degrees = "degrees", a.Radians = "radians";
})(RotationTypes || (RotationTypes = {}));
const degrees = (a) => (assertIs(a, "degreeAngle", ["number"]), { type: RotationTypes.Degrees, angle: a }), { Radians, Degrees } = RotationTypes, degreesToRadians = (a) => a * Math.PI / 180;
var colorString = { exports: {} }, colorName$1, hasRequiredColorName$1;
function requireColorName$1() {
  return hasRequiredColorName$1 || (hasRequiredColorName$1 = 1, colorName$1 = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  }), colorName$1;
}
var simpleSwizzle = { exports: {} }, isArrayish, hasRequiredIsArrayish;
function requireIsArrayish() {
  return hasRequiredIsArrayish || (hasRequiredIsArrayish = 1, isArrayish = function(s) {
    return !s || typeof s == "string" ? !1 : s instanceof Array || Array.isArray(s) || s.length >= 0 && (s.splice instanceof Function || Object.getOwnPropertyDescriptor(s, s.length - 1) && s.constructor.name !== "String");
  }), isArrayish;
}
var hasRequiredSimpleSwizzle;
function requireSimpleSwizzle() {
  if (hasRequiredSimpleSwizzle) return simpleSwizzle.exports;
  hasRequiredSimpleSwizzle = 1;
  var a = requireIsArrayish(), s = Array.prototype.concat, c = Array.prototype.slice, u = simpleSwizzle.exports = function(p) {
    for (var v = [], A = 0, x = p.length; A < x; A++) {
      var g = p[A];
      a(g) ? v = s.call(v, c.call(g)) : v.push(g);
    }
    return v;
  };
  return u.wrap = function(d) {
    return function() {
      return d(u(arguments));
    };
  }, simpleSwizzle.exports;
}
var hasRequiredColorString;
function requireColorString() {
  if (hasRequiredColorString) return colorString.exports;
  hasRequiredColorString = 1;
  var a = requireColorName$1(), s = requireSimpleSwizzle(), c = Object.hasOwnProperty, u = /* @__PURE__ */ Object.create(null);
  for (var d in a)
    c.call(a, d) && (u[a[d]] = d);
  var p = colorString.exports = {
    to: {},
    get: {}
  };
  p.get = function(x) {
    var g = x.substring(0, 3).toLowerCase(), b, y;
    switch (g) {
      case "hsl":
        b = p.get.hsl(x), y = "hsl";
        break;
      case "hwb":
        b = p.get.hwb(x), y = "hwb";
        break;
      default:
        b = p.get.rgb(x), y = "rgb";
        break;
    }
    return b ? { model: y, value: b } : null;
  }, p.get.rgb = function(x) {
    if (!x)
      return null;
    var g = /^#([a-f0-9]{3,4})$/i, b = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, y = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, f = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, m = /^(\w+)$/, C = [0, 0, 0, 1], w, S, $;
    if (w = x.match(b)) {
      for ($ = w[2], w = w[1], S = 0; S < 3; S++) {
        var T = S * 2;
        C[S] = parseInt(w.slice(T, T + 2), 16);
      }
      $ && (C[3] = parseInt($, 16) / 255);
    } else if (w = x.match(g)) {
      for (w = w[1], $ = w[3], S = 0; S < 3; S++)
        C[S] = parseInt(w[S] + w[S], 16);
      $ && (C[3] = parseInt($ + $, 16) / 255);
    } else if (w = x.match(y)) {
      for (S = 0; S < 3; S++)
        C[S] = parseInt(w[S + 1], 0);
      w[4] && (w[5] ? C[3] = parseFloat(w[4]) * 0.01 : C[3] = parseFloat(w[4]));
    } else if (w = x.match(f)) {
      for (S = 0; S < 3; S++)
        C[S] = Math.round(parseFloat(w[S + 1]) * 2.55);
      w[4] && (w[5] ? C[3] = parseFloat(w[4]) * 0.01 : C[3] = parseFloat(w[4]));
    } else return (w = x.match(m)) ? w[1] === "transparent" ? [0, 0, 0, 0] : c.call(a, w[1]) ? (C = a[w[1]], C[3] = 1, C) : null : null;
    for (S = 0; S < 3; S++)
      C[S] = v(C[S], 0, 255);
    return C[3] = v(C[3], 0, 1), C;
  }, p.get.hsl = function(x) {
    if (!x)
      return null;
    var g = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, b = x.match(g);
    if (b) {
      var y = parseFloat(b[4]), f = (parseFloat(b[1]) % 360 + 360) % 360, m = v(parseFloat(b[2]), 0, 100), C = v(parseFloat(b[3]), 0, 100), w = v(isNaN(y) ? 1 : y, 0, 1);
      return [f, m, C, w];
    }
    return null;
  }, p.get.hwb = function(x) {
    if (!x)
      return null;
    var g = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, b = x.match(g);
    if (b) {
      var y = parseFloat(b[4]), f = (parseFloat(b[1]) % 360 + 360) % 360, m = v(parseFloat(b[2]), 0, 100), C = v(parseFloat(b[3]), 0, 100), w = v(isNaN(y) ? 1 : y, 0, 1);
      return [f, m, C, w];
    }
    return null;
  }, p.to.hex = function() {
    var x = s(arguments);
    return "#" + A(x[0]) + A(x[1]) + A(x[2]) + (x[3] < 1 ? A(Math.round(x[3] * 255)) : "");
  }, p.to.rgb = function() {
    var x = s(arguments);
    return x.length < 4 || x[3] === 1 ? "rgb(" + Math.round(x[0]) + ", " + Math.round(x[1]) + ", " + Math.round(x[2]) + ")" : "rgba(" + Math.round(x[0]) + ", " + Math.round(x[1]) + ", " + Math.round(x[2]) + ", " + x[3] + ")";
  }, p.to.rgb.percent = function() {
    var x = s(arguments), g = Math.round(x[0] / 255 * 100), b = Math.round(x[1] / 255 * 100), y = Math.round(x[2] / 255 * 100);
    return x.length < 4 || x[3] === 1 ? "rgb(" + g + "%, " + b + "%, " + y + "%)" : "rgba(" + g + "%, " + b + "%, " + y + "%, " + x[3] + ")";
  }, p.to.hsl = function() {
    var x = s(arguments);
    return x.length < 4 || x[3] === 1 ? "hsl(" + x[0] + ", " + x[1] + "%, " + x[2] + "%)" : "hsla(" + x[0] + ", " + x[1] + "%, " + x[2] + "%, " + x[3] + ")";
  }, p.to.hwb = function() {
    var x = s(arguments), g = "";
    return x.length >= 4 && x[3] !== 1 && (g = ", " + x[3]), "hwb(" + x[0] + ", " + x[1] + "%, " + x[2] + "%" + g + ")";
  }, p.to.keyword = function(x) {
    return u[x.slice(0, 3)];
  };
  function v(x, g, b) {
    return Math.min(Math.max(g, x), b);
  }
  function A(x) {
    var g = Math.round(x).toString(16).toUpperCase();
    return g.length < 2 ? "0" + g : g;
  }
  return colorString.exports;
}
var ColorTypes;
(function(a) {
  a.Grayscale = "Grayscale", a.RGB = "RGB", a.CMYK = "CMYK";
})(ColorTypes || (ColorTypes = {}));
const rgb = (a, s, c) => (assertRange(a, "red", 0, 1), assertRange(s, "green", 0, 1), assertRange(c, "blue", 0, 1), { type: ColorTypes.RGB, red: a, green: s, blue: c }), cmyk = (a, s, c, u) => (assertRange(a, "cyan", 0, 1), assertRange(s, "magenta", 0, 1), assertRange(c, "yellow", 0, 1), assertRange(u, "key", 0, 1), { type: ColorTypes.CMYK, cyan: a, magenta: s, yellow: c, key: u }), { Grayscale, RGB, CMYK } = ColorTypes;
pdfExports.GlobalWorkerOptions.workerSrc = PDFJSWorker;
function dataURLToArrayBuffer(a) {
  const s = a.split(",")[1], c = atob(s), u = new ArrayBuffer(c.length), d = new Uint8Array(u);
  for (let p = 0; p < c.length; p++)
    d[p] = c.charCodeAt(p);
  return u;
}
const pdf2img = async (a, s = {}) => pdf2img$1(a, s, {
  getDocument: (c) => pdfExports.getDocument(c).promise,
  createCanvas: (c, u) => {
    const d = document.createElement("canvas");
    return d.width = c, d.height = u, d;
  },
  canvasToArrayBuffer: (c, u) => {
    const d = c.toDataURL(`image/${u}`);
    return dataURLToArrayBuffer(d);
  }
}), pdf2size = async (a, s = {}) => pdf2size$1(a, s, {
  getDocument: (c) => pdfExports.getDocument(c).promise
}), dictEn = {
  cancel: "Cancel",
  close: "Close",
  clear: "Clear",
  set: "Set",
  field: "field",
  fieldName: "Name",
  align: "Align",
  width: "Width",
  height: "Height",
  opacity: "Opacity",
  rotate: "Rotate",
  required: "Required",
  editable: "Editable",
  edit: "Edit",
  plsInputName: "Please input name",
  fieldMustUniq: "Name of field is not unique",
  notUniq: "(Not unique name)",
  noKeyName: "No name",
  fieldsList: "Field List",
  editField: "Edit Field",
  type: "Type",
  errorOccurred: "An error occurred",
  errorBulkUpdateFieldName: "Cannot commit the change because the number of items has been changed.",
  commitBulkUpdateFieldName: "Commit Changes",
  bulkUpdateFieldName: "Bulk update field names",
  addPageAfter: "Add Page After",
  removePage: "Remove Current Page",
  removePageConfirm: "Are you sure you want to delete this page? This action cannot be undone.",
  "validation.hexColor": "Please enter a valid hex color code.",
  "validation.uniqueName": "Please enter a unique name.",
  "validation.dateTimeFormat": "Invalid date time format.",
  "schemas.color": "Color",
  "schemas.borderWidth": "Border Width",
  "schemas.borderColor": "Border Color",
  "schemas.backgroundColor": "Background Color",
  "schemas.textColor": "Text Color",
  "schemas.bgColor": "Background Color",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertical",
  "schemas.left": "Left",
  "schemas.center": "Center",
  "schemas.right": "Right",
  "schemas.top": "Top",
  "schemas.middle": "Middle",
  "schemas.bottom": "Bottom",
  "schemas.padding": "Padding",
  "schemas.text.fontName": "Font Name",
  "schemas.text.size": "Size",
  "schemas.text.spacing": "Spacing",
  "schemas.text.textAlign": "Text Align",
  "schemas.text.verticalAlign": "Vertical Align",
  "schemas.text.lineHeight": "Line Height",
  "schemas.text.min": "Min",
  "schemas.text.max": "Max",
  "schemas.text.fit": "Fit",
  "schemas.text.dynamicFontSize": "Dynamic Font Size",
  "schemas.text.format": "Format",
  "schemas.radius": "Radius",
  "schemas.mvt.typingInstructions": "Add variables by typing words surrounded by curly brackets, e.g.",
  "schemas.mvt.sampleField": "name",
  "schemas.mvt.variablesSampleData": "Variables Sample Data",
  "schemas.barcodes.barColor": "Bar Color",
  "schemas.barcodes.includetext": "Include Text",
  "schemas.table.alternateBackgroundColor": "Alternate Background Color",
  "schemas.table.tableStyle": "Table Style",
  "schemas.table.showHead": "Show Head",
  "schemas.table.headStyle": "Header Style",
  "schemas.table.bodyStyle": "Body Style",
  "schemas.table.columnStyle": "Column Style",
  "schemas.date.format": "Date Format",
  "schemas.date.locale": "Locale",
  "schemas.select.options": "Options",
  "schemas.select.optionPlaceholder": "Enter an option",
  "schemas.radioGroup.groupName": "Group Name"
}, dictZh = {
  cancel: "取消",
  close: "关闭",
  clear: "清除",
  set: "设置",
  field: "字段",
  fieldName: "名称",
  align: "对齐",
  width: "宽度",
  height: "高度",
  opacity: "透明度",
  rotate: "旋转",
  required: "必需的",
  editable: "可编辑的",
  edit: "编辑",
  plsInputName: "请输入名称",
  fieldMustUniq: "字段名称必须唯一",
  notUniq: "（名称不唯一）",
  noKeyName: "无名称",
  fieldsList: "字段列表",
  editField: "编辑字段",
  type: "类型",
  errorOccurred: "发生错误",
  errorBulkUpdateFieldName: "由于项目数量已更改，无法提交更改。",
  commitBulkUpdateFieldName: "提交更改",
  bulkUpdateFieldName: "批量更新字段名称",
  addPageAfter: "在之后添加页面",
  removePage: "删除当前页面",
  removePageConfirm: "您确定要删除此页面吗？此操作无法撤销。",
  "validation.hexColor": "请输入有效的十六进制颜色代码。",
  "validation.uniqueName": "请输入一个唯一的名称。",
  "validation.dateTimeFormat": "日期时间格式无效。",
  "schemas.color": "颜色",
  "schemas.borderWidth": "边框宽度",
  "schemas.borderColor": "边框颜色",
  "schemas.backgroundColor": "背景颜色",
  "schemas.textColor": "文字颜色",
  "schemas.bgColor": "背景颜色",
  "schemas.horizontal": "水平",
  "schemas.vertical": "垂直",
  "schemas.left": "左",
  "schemas.center": "中",
  "schemas.right": "右",
  "schemas.top": "顶",
  "schemas.middle": "中间",
  "schemas.bottom": "底",
  "schemas.padding": "填充",
  "schemas.text.fontName": "字体名称",
  "schemas.text.size": "大小",
  "schemas.text.spacing": "间距",
  "schemas.text.textAlign": "文本对齐",
  "schemas.text.verticalAlign": "垂直对齐",
  "schemas.text.lineHeight": "行高",
  "schemas.text.min": "最小",
  "schemas.text.max": "最大",
  "schemas.text.fit": "适应",
  "schemas.text.dynamicFontSize": "动态字体大小",
  "schemas.text.format": "格式",
  "schemas.radius": "半径",
  "schemas.mvt.typingInstructions": "通过输入用花括号括起来的单词来添加变量，例如",
  "schemas.mvt.sampleField": "姓名",
  "schemas.mvt.variablesSampleData": "变量样本数据",
  "schemas.barcodes.barColor": "条码颜色",
  "schemas.barcodes.includetext": "包括文本",
  "schemas.table.alternateBackgroundColor": "交替背景颜色",
  "schemas.table.tableStyle": "表格样式",
  "schemas.table.showHead": "显示标题",
  "schemas.table.headStyle": "表头样式",
  "schemas.table.bodyStyle": "表体样式",
  "schemas.table.columnStyle": "列样式",
  "schemas.date.format": "日期格式",
  "schemas.date.locale": " 语言环境",
  "schemas.select.options": "选项",
  "schemas.select.optionPlaceholder": "请输入选项",
  "schemas.radioGroup.groupName": "组名"
}, dictJa = {
  cancel: "キャンセル",
  close: "閉じる",
  clear: "クリア",
  set: "設定",
  field: "入力項目",
  fieldName: "項目名",
  align: "整列",
  width: "幅",
  height: "高さ",
  opacity: "不透明度",
  rotate: "回転",
  required: "必須",
  editable: "編集可能",
  edit: "編集する",
  plsInputName: "項目名を入力してください",
  fieldMustUniq: "他の入力項目名と被っています",
  notUniq: "(他の項目名と重複しています)",
  noKeyName: "項目名なし",
  fieldsList: "入力項目一覧",
  editField: "入力項目を編集",
  type: "タイプ",
  errorOccurred: "エラーが発生しました",
  errorBulkUpdateFieldName: "項目数が変更されているため変更をコミットできません。",
  commitBulkUpdateFieldName: "変更を反映",
  bulkUpdateFieldName: "項目名を一括変更",
  addPageAfter: "次にページを追加",
  removePage: "現在のページを削除",
  removePageConfirm: "ページを削除してもよろしいですか？この操作は元に戻せません。",
  "validation.hexColor": "有効な16進数のカラーコードを入力してください。",
  "validation.uniqueName": "一意の名前を入力してください。",
  "validation.dateTimeFormat": "日付と時刻のフォーマットが無効です。",
  "schemas.color": "色",
  "schemas.borderWidth": "枠線の太さ",
  "schemas.borderColor": "枠線の色",
  "schemas.backgroundColor": "背景色",
  "schemas.textColor": "テキストの色",
  "schemas.bgColor": "背景色",
  "schemas.horizontal": "水平",
  "schemas.vertical": "垂直",
  "schemas.left": "左",
  "schemas.center": "中央",
  "schemas.right": "右",
  "schemas.top": "上",
  "schemas.middle": "中間",
  "schemas.bottom": "下",
  "schemas.padding": "パディング",
  "schemas.text.fontName": "フォント名",
  "schemas.text.size": "サイズ",
  "schemas.text.spacing": "間隔",
  "schemas.text.textAlign": "テキストの揃え",
  "schemas.text.verticalAlign": "垂直方向の揃え",
  "schemas.text.lineHeight": "行の高さ",
  "schemas.text.min": "最小",
  "schemas.text.max": "最大",
  "schemas.text.fit": "フィット",
  "schemas.text.dynamicFontSize": "動的フォントサイズ",
  "schemas.text.format": "書式",
  "schemas.radius": "角丸",
  "schemas.mvt.typingInstructions": "中括弧で囲まれた単語を入力して変数を追加します。例:",
  "schemas.mvt.sampleField": "名前",
  "schemas.mvt.variablesSampleData": "変数サンプルデータ",
  "schemas.barcodes.barColor": "バーの色",
  "schemas.barcodes.includetext": "テキストを含める",
  "schemas.table.alternateBackgroundColor": "交互の背景色",
  "schemas.table.tableStyle": "テーブルスタイル",
  "schemas.table.showHead": "ヘッダーを表示",
  "schemas.table.headStyle": "ヘッダースタイル",
  "schemas.table.bodyStyle": "ボディスタイル",
  "schemas.table.columnStyle": "カラムスタイル",
  "schemas.date.format": "日付形式",
  "schemas.date.locale": "ロケール",
  "schemas.select.options": "オプション",
  "schemas.select.optionPlaceholder": "オプションを入力してください",
  "schemas.radioGroup.groupName": "グループ名"
}, dictKo = {
  cancel: "취소",
  close: "닫기",
  clear: "지우기",
  set: "설정",
  field: "필드",
  fieldName: "이름",
  align: "정렬",
  width: "너비",
  height: "높이",
  opacity: "투명도",
  rotate: "회전",
  required: "필수의",
  editable: "편집 가능한",
  edit: "편집",
  plsInputName: "이름을 입력하세요",
  fieldMustUniq: "필드 이름은 유일해야 합니다",
  notUniq: "（유일하지 않은 이름）",
  noKeyName: "이름 없음",
  fieldsList: "필드 목록",
  editField: "필드 편집",
  type: "유형",
  errorOccurred: "오류 발생",
  errorBulkUpdateFieldName: "항목 수가 변경되어 변경을 커밋할 수 없습니다.",
  commitBulkUpdateFieldName: "변경 사항 커밋",
  bulkUpdateFieldName: "필드 이름 일괄 업데이트",
  addPageAfter: "다음에 페이지 추가",
  removePage: "현재 페이지 제거",
  removePageConfirm: "이 페이지를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
  "validation.hexColor": "유효한 16진수 색상 코드를 입력하세요.",
  "validation.uniqueName": "고유한 이름을 입력하세요.",
  "validation.dateTimeFormat": "날짜/시간 형식이 잘못되었습니다.",
  "schemas.color": "색상",
  "schemas.borderWidth": "테두리 너비",
  "schemas.borderColor": "테두리 색상",
  "schemas.backgroundColor": "배경색",
  "schemas.textColor": "텍스트 색상",
  "schemas.bgColor": "배경색",
  "schemas.horizontal": "수평",
  "schemas.vertical": "수직",
  "schemas.left": "왼쪽",
  "schemas.center": "중앙",
  "schemas.right": "오른쪽",
  "schemas.top": "상단",
  "schemas.middle": "중간",
  "schemas.bottom": "하단",
  "schemas.padding": "패딩",
  "schemas.text.fontName": "글꼴 이름",
  "schemas.text.size": "크기",
  "schemas.text.spacing": "간격",
  "schemas.text.textAlign": "텍스트 정렬",
  "schemas.text.verticalAlign": "수직 정렬",
  "schemas.text.lineHeight": "줄 높이",
  "schemas.text.min": "최소",
  "schemas.text.max": "최대",
  "schemas.text.fit": "맞춤",
  "schemas.text.dynamicFontSize": "동적 폰트 크기",
  "schemas.text.format": "형식",
  "schemas.radius": "반경",
  "schemas.mvt.typingInstructions": "중괄호로 묶인 단어를 입력하여 변수를 추가하세요.",
  "schemas.mvt.sampleField": "이름",
  "schemas.mvt.variablesSampleData": "변수 샘플 데이터",
  "schemas.barcodes.barColor": "바코드 색상",
  "schemas.barcodes.includetext": "텍스트 포함",
  "schemas.table.alternateBackgroundColor": "대체 배경색",
  "schemas.table.tableStyle": "테이블 스타일",
  "schemas.table.showHead": "헤드 표시",
  "schemas.table.headStyle": "헤더 스타일",
  "schemas.table.bodyStyle": "본문 스타일",
  "schemas.table.columnStyle": "열 스타일",
  "schemas.date.format": "날짜 형식",
  "schemas.date.locale": " 장소",
  "schemas.select.options": "옵션",
  "schemas.select.optionPlaceholder": "옵션을 입력하세요",
  "schemas.radioGroup.groupName": "그룹 이름"
}, dictAr = {
  cancel: "إلغاء",
  close: "إغلاق",
  clear: "مسح",
  set: "تعيين",
  field: "الحقل",
  fieldName: "اسم الحقل",
  align: "محاذاة",
  width: "العرض",
  height: "الارتفاع",
  opacity: "الشفافية",
  rotate: "تدوير",
  required: "مطلوب",
  editable: "قابل للتحرير",
  edit: "تعديل",
  plsInputName: "الرجاء إدخال الاسم",
  fieldMustUniq: "يجب أن يكون الحقل فريداً",
  notUniq: "(غير فريد)",
  noKeyName: "لا يوجد اسم للحقل",
  fieldsList: "قائمة الحقول",
  editField: "تعديل الحقل",
  type: "النوع",
  errorOccurred: "حدث خطأ",
  errorBulkUpdateFieldName: "لا يمكن تنفيذ التغيير لأنه تم تغيير عدد العناصر.",
  commitBulkUpdateFieldName: "تنفيذ التغييرات",
  bulkUpdateFieldName: "تغيير الأسماء",
  addPageAfter: "إضافة صفحة بعد",
  removePage: "احذف الصفحة الحالية",
  removePageConfirm: "هل أنت متأكد من رغبتك في حذف هذه الصفحة؟ لا يمكن التراجع عن هذا الإجراء.",
  "validation.hexColor": "الرجاء إدخال رمز لون سداسي عشري صالح.",
  "validation.uniqueName": "الرجاء إدخال اسم فريد.",
  "validation.dateTimeFormat": "تنسيق التاريخ والوقت غير صالح.",
  "schemas.color": "اللون",
  "schemas.borderWidth": "عرض الحدود",
  "schemas.borderColor": "لون الحدود",
  "schemas.backgroundColor": "لون الخلفية",
  "schemas.textColor": "لون الخط",
  "schemas.bgColor": "لون الخلفية",
  "schemas.horizontal": "أفقي",
  "schemas.vertical": "عمودي",
  "schemas.left": "يسار",
  "schemas.center": "مركز",
  "schemas.right": "يمين",
  "schemas.top": "أعلى",
  "schemas.middle": "وسط",
  "schemas.bottom": "أسفل",
  "schemas.padding": "التبطين",
  "schemas.text.fontName": "اسم الخط",
  "schemas.text.size": "الحجم",
  "schemas.text.spacing": "التباعد",
  "schemas.text.textAlign": "محاذاة النص",
  "schemas.text.verticalAlign": "محاذاة عمودية",
  "schemas.text.lineHeight": "ارتفاع السطر",
  "schemas.text.min": "الحد الأدنى",
  "schemas.text.max": "الحد الأقصى",
  "schemas.text.fit": "ملاءمة",
  "schemas.text.dynamicFontSize": "حجم الخط الديناميكي",
  "schemas.text.format": "تنسيق",
  "schemas.radius": "نصف القطر",
  "schemas.mvt.typingInstructions": "قم بإضافة المتغيرات عن طريق كتابة الكلمات المحاطة بأقواس متعرجة، على سبيل المثال:",
  "schemas.mvt.sampleField": "اسم",
  "schemas.mvt.variablesSampleData": "بيانات عينة المتغيرات",
  "schemas.barcodes.barColor": "لون الشريط",
  "schemas.barcodes.includetext": "تضمين النص",
  "schemas.table.alternateBackgroundColor": "لون الخلفية البديل",
  "schemas.table.tableStyle": "أسلوب الجدول",
  "schemas.table.showHead": "إظهار الرأس",
  "schemas.table.headStyle": "أسلوب الرأس",
  "schemas.table.bodyStyle": "أسلوب الجسم",
  "schemas.table.columnStyle": "أسلوب العمود",
  "schemas.date.format": "تنسيق التاريخ",
  "schemas.date.locale": "لغة",
  "schemas.select.options": "خيارات",
  "schemas.select.optionPlaceholder": "أدخل خيارًا",
  "schemas.radioGroup.groupName": "اسم المجموعة"
}, dictTh = {
  cancel: "ยกเลิก",
  close: "ปิด",
  clear: "ล้าง",
  set: "ตั้งค่า",
  field: "ฟิลด์",
  fieldName: "ชื่อฟิลด์",
  align: "จัดเรียง",
  width: "ความกว้าง",
  height: "ความสูง",
  opacity: "ความทึบ",
  rotate: "หมุน",
  required: "ที่จำเป็น",
  editable: "แก้ไขได้",
  edit: "แก้ไข",
  plsInputName: "กรุณาใส่ชื่อ",
  fieldMustUniq: "ชื่อฟิลด์ต้องไม่ซ้ำกัน",
  notUniq: "(ชื่อฟิลด์ซ้ำกัน)",
  noKeyName: "ไม่มีชื่อ",
  fieldsList: "รายการฟิลด์ทั้งหมด",
  editField: "แก้ไขฟิลด์",
  type: "ประเภท",
  errorOccurred: "เกิดข้อผิดพลาด",
  errorBulkUpdateFieldName: "ไม่สามารถยืนยันการแก้ไขได้เนื่องจากจำนวนรายการมีการเปลี่ยนแปลง",
  commitBulkUpdateFieldName: "ยืนยันการแก้ไข",
  bulkUpdateFieldName: "แก้ไขชื่อฟิลด์เป็นชุด",
  addPageAfter: "เพิ่มหน้าถัดไป",
  removePage: "ลบหน้าปัจจุบัน",
  removePageConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบหน้านี้? การกระทำนี้ไม่สามารถย้อนกลับได้",
  "validation.hexColor": "กรุณาใส่รหัสสีแบบฐานสิบหกที่ถูกต้อง",
  "validation.uniqueName": "กรุณาระบุชื่อที่ไม่ซ้ำ",
  "validation.dateTimeFormat": "รูปแบบวันที่และเวลาไม่ถูกต้อง",
  "schemas.color": "สี",
  "schemas.borderWidth": "ความกว้างของเส้นขอบ",
  "schemas.borderColor": "สีขอบ",
  "schemas.backgroundColor": "สีพื้นหลัง",
  "schemas.textColor": "สีข้อความ",
  "schemas.bgColor": "สีพื้นหลัง",
  "schemas.horizontal": "แนวนอน",
  "schemas.vertical": "แนวตั้ง",
  "schemas.left": "ซ้าย",
  "schemas.center": "ตรงกลาง",
  "schemas.right": "ขวา",
  "schemas.top": "ด้านบน",
  "schemas.middle": "ตรงกลาง",
  "schemas.bottom": "ด้านล่าง",
  "schemas.padding": "การเพิ่มพื้นที่",
  "schemas.text.fontName": "ชื่อแบบอักษร",
  "schemas.text.size": "ขนาด",
  "schemas.text.spacing": "ระยะห่าง",
  "schemas.text.textAlign": "จัดแนวข้อความ",
  "schemas.text.verticalAlign": "จัดแนวแนวตั้ง",
  "schemas.text.lineHeight": "ความสูงของบรรทัด",
  "schemas.text.min": "ต่ำสุด",
  "schemas.text.max": "สูงสุด",
  "schemas.text.fit": "พอดี",
  "schemas.text.dynamicFontSize": "ขนาดตัวอักษรแบบไดนามิก",
  "schemas.text.format": "รูปแบบ",
  "schemas.radius": "รัศมี",
  "schemas.mvt.typingInstructions": "เพิ่มตัวแปรโดยพิมพ์คำที่ล้อมรอบด้วยวงเล็บปีกกา เช่น",
  "schemas.mvt.sampleField": "ชื่อ",
  "schemas.mvt.variablesSampleData": "ข้อมูลตัวอย่างตัวแปร",
  "schemas.barcodes.barColor": "สีบาร์",
  "schemas.barcodes.includetext": "รวมข้อความ",
  "schemas.table.alternateBackgroundColor": "สีพื้นหลังสลับกัน",
  "schemas.table.tableStyle": "สไตล์ตาราง",
  "schemas.table.headStyle": "สไตล์หัวข้อ",
  "schemas.table.showHead": "แสดงหัวข้อ",
  "schemas.table.bodyStyle": "สไตล์เนื้อหา",
  "schemas.table.columnStyle": "สไตล์คอลัมน์",
  "schemas.date.format": "รูปแบบวันที่",
  "schemas.date.locale": "สถาน",
  "schemas.select.options": "ตัวเลือก",
  "schemas.select.optionPlaceholder": "กรอกตัวเลือก",
  "schemas.radioGroup.groupName": "ชื่อกลุ่ม"
}, dictIt = {
  cancel: "Annulla",
  close: "Chiudi",
  clear: "Wyczyść",
  set: "Ustaw",
  field: "Campo",
  fieldName: "Nome",
  align: "Allinea",
  width: "Larghezza",
  height: "Altezza",
  opacity: "Opacità",
  rotate: "Ruota",
  required: "Necessaria",
  editable: "Modificabile",
  edit: "Modifica",
  plsInputName: "Inserisci il nome per favore",
  fieldMustUniq: "Il nome del campo non è univoco",
  notUniq: "(Nome non univoco)",
  noKeyName: "Nessun nome",
  fieldsList: "Lista campi",
  editField: "Modifica campo",
  type: "Tipo",
  errorOccurred: "Riscontrato errore",
  errorBulkUpdateFieldName: "Non è possibile salvare le modifiche perché il numero di elementi è cambiato.",
  commitBulkUpdateFieldName: "Salva cambiamenti",
  bulkUpdateFieldName: "Modifica nomi campi in blocco",
  addPageAfter: "Aggiungi pagina dopo",
  removePage: "Rimuovi la Pagina Corrente",
  removePageConfirm: "Sei sicuro di voler eliminare questa pagina? Questa azione non può essere annullata.",
  "validation.hexColor": "Inserisci un codice colore esadecimale valido.",
  "validation.uniqueName": "Inserisci un nome univoco.",
  "validation.dateTimeFormat": "Formato data-ora non valido.",
  "schemas.color": "Colore",
  "schemas.borderWidth": "Spessore bordo",
  "schemas.borderColor": "Colore bordo",
  "schemas.backgroundColor": "Colore di Sfondo",
  "schemas.textColor": "Colore testo",
  "schemas.bgColor": "Colore sfondo",
  "schemas.horizontal": "Orizzontale",
  "schemas.vertical": "Verticale",
  "schemas.left": "Sinistra",
  "schemas.center": "Centro",
  "schemas.right": "Destra",
  "schemas.top": "Sopra",
  "schemas.middle": "Medio",
  "schemas.bottom": "Sotto",
  "schemas.padding": "Padding",
  "schemas.text.fontName": "Nome del font",
  "schemas.text.size": "Dimensione",
  "schemas.text.spacing": "Spaziatura",
  "schemas.text.textAlign": "Allineamento testo",
  "schemas.text.verticalAlign": "Allineamento verticale",
  "schemas.text.lineHeight": "Altezza della linea",
  "schemas.text.min": "Minimo",
  "schemas.text.max": "Massimo",
  "schemas.text.fit": "Adatta",
  "schemas.text.dynamicFontSize": "Dimensione font dinamica",
  "schemas.text.format": "Formato",
  "schemas.radius": "Raggio",
  "schemas.mvt.typingInstructions": "Aggiungi variabili digitando parole circondate da parentesi graffe, ad es.",
  "schemas.mvt.sampleField": "nome",
  "schemas.mvt.variablesSampleData": "Dati di esempio variabili",
  "schemas.barcodes.barColor": "Colore barra",
  "schemas.barcodes.includetext": "Includi testo",
  "schemas.table.alternateBackgroundColor": "Colore di Sfondo Alternato",
  "schemas.table.tableStyle": "Stile della Tabella",
  "schemas.table.showHead": "Mostra Intestazione",
  "schemas.table.headStyle": "Stile dell'Intestazione",
  "schemas.table.bodyStyle": "Stile del Corpo",
  "schemas.table.columnStyle": "Stile della Colonna",
  "schemas.date.format": "Formato data",
  "schemas.date.locale": "Locale",
  "schemas.select.options": "Opzioni",
  "schemas.select.optionPlaceholder": "Inserisci un'opzione",
  "schemas.radioGroup.groupName": "Nome del Gruppo"
}, dictPl = {
  cancel: "Anuluj",
  close: "Zamknij",
  clear: "Cancella",
  set: "Imposta",
  field: "pole",
  fieldName: "Klucz pola",
  align: "Wyrównanie",
  width: "Szerokość",
  height: "Wysokość",
  opacity: "przezroczystość",
  rotate: "Obrót",
  required: "Wymagany",
  editable: "Edytowalny",
  edit: "Edytuj",
  plsInputName: "Wymagane wprowadzenie klucza pola",
  fieldMustUniq: "Klucz pola nie jest unikalny",
  notUniq: "(Klucz pola nie jest unikalny)",
  noKeyName: "Brak nazwy klucza pola",
  fieldsList: "Lista pól",
  editField: "Edytuj pole",
  type: "Typ pola",
  errorOccurred: "Wystąpił błąd",
  errorBulkUpdateFieldName: "Nie można wprowadzić zmian ponieważ liczba elementów uległa zmianie.",
  commitBulkUpdateFieldName: "Zaakceptuj zmiany",
  bulkUpdateFieldName: "Masowo aktualizuj klucze pól",
  addPageAfter: "Dodaj stronę po",
  removePage: "Usuń Bieżącą Stronę",
  removePageConfirm: "Czy na pewno chcesz usunąć tę stronę? Tej operacji nie można cofnąć.",
  "validation.hexColor": "Wprowadź poprawny kod koloru szesnastkowego.",
  "validation.uniqueName": "Proszę wpisać unikalną nazwę.",
  "validation.dateTimeFormat": "Nieprawidłowy format daty i godziny.",
  "schemas.color": "Kolor",
  "schemas.borderWidth": "Szerokość obramowania",
  "schemas.borderColor": "Kolor obramowania",
  "schemas.backgroundColor": "Kolor tła",
  "schemas.textColor": "Kolor tekstu",
  "schemas.bgColor": "Kolor tła",
  "schemas.horizontal": "Poziomo",
  "schemas.vertical": "Pionowo",
  "schemas.left": "Lewo",
  "schemas.center": "Centrum",
  "schemas.right": "Prawo",
  "schemas.top": "Góra",
  "schemas.middle": "Środek",
  "schemas.bottom": "Dół",
  "schemas.padding": "Odsadzenie",
  "schemas.text.fontName": "Nazwa czcionki",
  "schemas.text.size": "Rozmiar",
  "schemas.text.spacing": "Odstępy",
  "schemas.text.textAlign": "Wyrównanie tekstu",
  "schemas.text.verticalAlign": "Wyrównanie pionowe",
  "schemas.text.lineHeight": "Wysokość linii",
  "schemas.text.min": "Minimum",
  "schemas.text.max": "Maksimum",
  "schemas.text.fit": "Dopasowanie",
  "schemas.text.dynamicFontSize": "Dynamiczny rozmiar czcionki",
  "schemas.text.format": "Format",
  "schemas.radius": "Promień",
  "schemas.mvt.typingInstructions": "Dodaj zmienne, wpisując słowa ujęte w nawiasy klamrowe, np.",
  "schemas.mvt.sampleField": "nazwa",
  "schemas.mvt.variablesSampleData": "Zmienne Przykładowe dane",
  "schemas.barcodes.barColor": "Kolor paska",
  "schemas.barcodes.includetext": "Dołącz tekst",
  "schemas.table.alternateBackgroundColor": "Alternatywny kolor tła",
  "schemas.table.tableStyle": "Styl tabeli",
  "schemas.table.showHead": "Pokaż nagłówek",
  "schemas.table.headStyle": "Styl nagłówka",
  "schemas.table.bodyStyle": "Styl ciała",
  "schemas.table.columnStyle": "Styl kolumny",
  "schemas.date.format": "Format daty",
  "schemas.date.locale": "Widownia",
  "schemas.select.options": "Opcje",
  "schemas.select.optionPlaceholder": "Wpisz opcję",
  "schemas.radioGroup.groupName": "Nazwa grupy"
}, dictDe = {
  cancel: "Abbrechen",
  close: "Schließen",
  clear: "Löschen",
  set: "Festlegen",
  field: "Feld",
  fieldName: "Name",
  align: "Ausrichten",
  width: "Breite",
  height: "Höhe",
  opacity: "Opazität",
  rotate: "Drehen",
  required: "Erforderlich",
  editable: "Bearbeitbar",
  edit: "Bearbeiten",
  plsInputName: "Bitte geben Sie einen Namen ein",
  fieldMustUniq: "Feldname ist nicht eindeutig",
  notUniq: "(Nicht eindeutiger Name)",
  noKeyName: "Kein Name",
  fieldsList: "Feldliste",
  editField: "Feld bearbeiten",
  type: "Typ",
  errorOccurred: "Ein Fehler ist aufgetreten",
  errorBulkUpdateFieldName: "Die Änderung kann nicht übernommen werden, weil die Anzahl der Elemente geändert wurde.",
  commitBulkUpdateFieldName: "Änderungen übernehmen",
  bulkUpdateFieldName: "Mehrfachaktualisierung der Feldnamen",
  addPageAfter: "Seite danach hinzufügen",
  removePage: "Aktuelle Seite entfernen",
  removePageConfirm: "Sind Sie sicher, dass Sie diese Seite löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
  "validation.hexColor": "Bitte geben Sie einen gültigen Hex-Farbcode ein.",
  "validation.uniqueName": "Bitte geben Sie einen eindeutigen Namen ein.",
  "validation.dateTimeFormat": "Ungültiges Datums- und Zeitformat.",
  "schemas.color": "Farbe",
  "schemas.borderWidth": "Rahmenbreite",
  "schemas.borderColor": "Rahmenfarbe",
  "schemas.backgroundColor": "Hintergrundfarbe",
  "schemas.textColor": "Textfarbe",
  "schemas.bgColor": "Hintergrundfarbe",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertikal",
  "schemas.left": "Links",
  "schemas.center": "Zentriert",
  "schemas.right": "Rechts",
  "schemas.top": "Oben",
  "schemas.middle": "Mitte",
  "schemas.bottom": "Unten",
  "schemas.padding": "Polsterung",
  "schemas.text.fontName": "Schriftart",
  "schemas.text.size": "Größe",
  "schemas.text.spacing": "Abstand",
  "schemas.text.textAlign": "Ausrichtung",
  "schemas.text.verticalAlign": "vert. Ausr.",
  "schemas.text.lineHeight": "Zeilenhöhe",
  "schemas.text.min": "Min",
  "schemas.text.max": "Max",
  "schemas.text.fit": "Anpassen",
  "schemas.text.dynamicFontSize": "Dynamische Schriftgröße",
  "schemas.text.format": "Format",
  "schemas.radius": "Radius",
  "schemas.mvt.typingInstructions": "Fügen Sie Variablen hinzu, indem Sie Wörter in geschweiften Klammern eingeben, z. B.",
  "schemas.mvt.sampleField": "Name",
  "schemas.mvt.variablesSampleData": "Variablen Beispieldaten",
  "schemas.barcodes.barColor": "Strichcodefarbe",
  "schemas.barcodes.includetext": "Text anzeigen",
  "schemas.table.alternateBackgroundColor": "Wechselnde Hintergrundfarbe",
  "schemas.table.tableStyle": "Tabellenstil",
  "schemas.table.headStyle": "Kopfzeilenstil",
  "schemas.table.showHead": "Kopfzeile anzeigen",
  "schemas.table.bodyStyle": "Körperstil",
  "schemas.table.columnStyle": "Spaltenstil",
  "schemas.date.format": "Datumsformat",
  "schemas.date.locale": "Gebietsschema",
  "schemas.select.options": "Optionen",
  "schemas.select.optionPlaceholder": "Geben Sie eine Option ein",
  "schemas.radioGroup.groupName": "Gruppenname"
}, dictEs = {
  cancel: "Cancelar",
  close: "Cerrar",
  clear: "Limpiar",
  set: "Establecer",
  field: "campo",
  fieldName: "Nombre",
  align: "Alinear",
  width: "Anchura",
  height: "Altura",
  opacity: "Opacidad",
  rotate: "Rotar",
  required: "Requerido",
  editable: "Editable",
  edit: "Editar",
  plsInputName: "Introduce el nombre",
  fieldMustUniq: "El nombre del campo no es único",
  notUniq: "(Nombre no único)",
  noKeyName: "Sin nombre",
  fieldsList: "Lista de campos",
  editField: "Editar campo",
  type: "Tipo",
  errorOccurred: "Ocurrió un error",
  errorBulkUpdateFieldName: "No se puede confirmar el cambio porque el número de elementos ha cambiado.",
  commitBulkUpdateFieldName: "Confirmar cambios",
  bulkUpdateFieldName: "Actualizar en bloque el nombre de los campos",
  addPageAfter: "Insertar página",
  removePage: "Eliminar página actual",
  removePageConfirm: "¿Estás seguro de que quieres eliminar esta página? Esta acción no se puede deshacer.",
  "validation.hexColor": "Introduce un código de color hexadecimal válido.",
  "validation.uniqueName": "Por favor, introduzca un nombre único.",
  "validation.dateTimeFormat": "Formato de fecha y hora no válido.",
  "schemas.color": "Color",
  "schemas.borderWidth": "Ancho del borde",
  "schemas.borderColor": "Color del borde",
  "schemas.backgroundColor": "Color de fondo",
  "schemas.textColor": "Color del texto",
  "schemas.bgColor": "Color del fondo",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertical",
  "schemas.left": "Izquierda",
  "schemas.center": "Centro",
  "schemas.right": "Derecha",
  "schemas.top": "Arriba",
  "schemas.middle": "Medio",
  "schemas.bottom": "Abajo",
  "schemas.padding": "Relleno",
  "schemas.text.fontName": "Nombre de la fuente",
  "schemas.text.size": "Tamaño",
  "schemas.text.spacing": "Espaciado",
  "schemas.text.textAlign": "Alineación del texto",
  "schemas.text.verticalAlign": "Alineación vertical",
  "schemas.text.lineHeight": "Altura de línea",
  "schemas.text.min": "Mín",
  "schemas.text.max": "Máx",
  "schemas.text.fit": "Ajustar",
  "schemas.text.dynamicFontSize": "Tamaño de fuente dinámico",
  "schemas.text.format": "Formato",
  "schemas.radius": "Radio",
  "schemas.mvt.typingInstructions": "Agregue variables escribiendo palabras entre llaves, p.",
  "schemas.mvt.sampleField": "nombre",
  "schemas.mvt.variablesSampleData": "Variables Datos de muestra",
  "schemas.barcodes.barColor": "Color de la barra",
  "schemas.barcodes.includetext": "Incluir texto",
  "schemas.table.alternateBackgroundColor": "Color de fondo alternativo",
  "schemas.table.tableStyle": "Estilo de tabla",
  "schemas.table.showHead": "Mostrar encabezado",
  "schemas.table.headStyle": "Estilo de cabecera",
  "schemas.table.bodyStyle": "Estilo de cuerpo",
  "schemas.table.columnStyle": "Estilo de columna",
  "schemas.date.format": "Formato de fecha",
  "schemas.date.locale": "Lugar",
  "schemas.select.options": "Opciones",
  "schemas.select.optionPlaceholder": "Ingrese una opción",
  "schemas.radioGroup.groupName": "Nombre del grupo"
}, dictFr = {
  cancel: "Annuler",
  close: "Fermer",
  clear: "Effacer",
  set: "Définir",
  field: "Champ",
  fieldName: "Nom",
  align: "Aligner",
  width: "Largeur",
  height: "Hauteur",
  opacity: "Opacité",
  rotate: "Rotation",
  required: "Requis",
  editable: "Modifiable",
  edit: "Éditer",
  plsInputName: "Veuillez saisir le nom",
  fieldMustUniq: "Le nom du champ n'est pas unique",
  notUniq: "(Nombre non unique)",
  noKeyName: "Pas de nom",
  fieldsList: "Liste des champs",
  editField: "Éditer le champ",
  type: "Type",
  errorOccurred: "Une erreur est survenue",
  errorBulkUpdateFieldName: "Impossible de confirmer le changement car le nombre d'éléments a changé.",
  commitBulkUpdateFieldName: "Confirmer les changements",
  bulkUpdateFieldName: "Modifier les noms de champs en masse",
  addPageAfter: "Ajouter une page après",
  removePage: "Supprimer la page actuelle",
  removePageConfirm: "Êtes-vous sûr de vouloir supprimer cette page ? Cette action est irréversible.",
  "validation.hexColor": "Veuillez entrer un code couleur hexadécimal valide.",
  "validation.uniqueName": "Veuillez saisir un nom unique.",
  "validation.dateTimeFormat": "Format de date et d'heure non valide.",
  "schemas.color": "Couleur",
  "schemas.borderWidth": "Largeur de la bordure",
  "schemas.borderColor": "Couleur de la bordure",
  "schemas.backgroundColor": "Couleur de fond",
  "schemas.textColor": "Couleur du texte",
  "schemas.bgColor": "Couleur de fond",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertical",
  "schemas.left": "Gauche",
  "schemas.center": "Centre",
  "schemas.right": "Droite",
  "schemas.top": "Haut",
  "schemas.middle": "Milieu",
  "schemas.bottom": "Bas",
  "schemas.padding": "Zone de remplissage",
  "schemas.text.fontName": "Nom de la police",
  "schemas.text.size": "Taille",
  "schemas.text.spacing": "Espacement",
  "schemas.text.textAlign": "Alignement du texte",
  "schemas.text.verticalAlign": "Alignement vertical",
  "schemas.text.lineHeight": "Hauteur de ligne",
  "schemas.text.min": "Min",
  "schemas.text.max": "Max",
  "schemas.text.fit": "Ajustement",
  "schemas.text.dynamicFontSize": "Taille de police dynamique",
  "schemas.text.format": "Format",
  "schemas.radius": "Rayon",
  "schemas.mvt.typingInstructions": "Ajoutez des variables en tapant des mots entourés d'accolades, par ex.",
  "schemas.mvt.sampleField": "nom",
  "schemas.mvt.variablesSampleData": "Variables Exemples de données",
  "schemas.barcodes.barColor": "Couleur de la barre",
  "schemas.barcodes.includetext": "Inclure le texte",
  "schemas.table.alternateBackgroundColor": "Couleur de fond alternative",
  "schemas.table.tableStyle": "Style de tableau",
  "schemas.table.showHead": "Afficher l’en-tête",
  "schemas.table.headStyle": "Style d'en-tête",
  "schemas.table.bodyStyle": "Style de corps",
  "schemas.table.columnStyle": "Style de colonne",
  "schemas.date.format": "Format de date",
  "schemas.date.locale": "Lieu",
  "schemas.select.options": "Options",
  "schemas.select.optionPlaceholder": "Entrez une option",
  "schemas.radioGroup.groupName": "Nom du groupe"
}, dictionaries = {
  en: dictEn,
  zh: dictZh,
  ja: dictJa,
  ko: dictKo,
  ar: dictAr,
  th: dictTh,
  it: dictIt,
  pl: dictPl,
  de: dictDe,
  es: dictEs,
  fr: dictFr
}, getDict = (a) => dictionaries[a] || dictionaries[DEFAULT_LANG], i18n = (a, s) => (s || getDict(DEFAULT_LANG))[a], DEFAULT_FONT_SIZE = 13, ALIGN_LEFT = "left", ALIGN_CENTER = "center", ALIGN_RIGHT = "right", ALIGN_JUSTIFY = "justify", DEFAULT_ALIGNMENT = ALIGN_LEFT, VERTICAL_ALIGN_TOP = "top", VERTICAL_ALIGN_MIDDLE = "middle", VERTICAL_ALIGN_BOTTOM = "bottom", DEFAULT_VERTICAL_ALIGNMENT = VERTICAL_ALIGN_TOP, DEFAULT_LINE_HEIGHT = 1, DEFAULT_CHARACTER_SPACING = 0, DEFAULT_FONT_COLOR = "#000000", PLACEHOLDER_FONT_COLOR = "#A0A0A0", DYNAMIC_FIT_VERTICAL = "vertical", DYNAMIC_FIT_HORIZONTAL = "horizontal", DEFAULT_DYNAMIC_FIT = DYNAMIC_FIT_VERTICAL, DEFAULT_DYNAMIC_MIN_FONT_SIZE = 4, DEFAULT_DYNAMIC_MAX_FONT_SIZE = 72, FONT_SIZE_ADJUSTMENT = 0.25, LINE_START_FORBIDDEN_CHARS = [
  // 句読点
  "、",
  "。",
  ",",
  ".",
  // 閉じカッコ類
  "」",
  "』",
  ")",
  "}",
  "】",
  ">",
  "≫",
  "]",
  // 記号
  "・",
  "ー",
  "―",
  "-",
  // 約物
  "!",
  "！",
  "?",
  "？",
  ":",
  "：",
  ";",
  "；",
  "/",
  "／",
  // 繰り返し記号
  "ゝ",
  "々",
  "〃",
  // 拗音・促音（小書きのかな）
  "ぁ",
  "ぃ",
  "ぅ",
  "ぇ",
  "ぉ",
  "っ",
  "ゃ",
  "ゅ",
  "ょ",
  "ァ",
  "ィ",
  "ゥ",
  "ェ",
  "ォ",
  "ッ",
  "ャ",
  "ュ",
  "ョ"
], LINE_END_FORBIDDEN_CHARS = [
  // 始め括弧類
  "「",
  "『",
  "（",
  "｛",
  "【",
  "＜",
  "≪",
  "［",
  "〘",
  "〖",
  "〝",
  "‘",
  "“",
  "｟",
  "«"
], ENCODING_MAPPING = {
  utf16le: "utf-16le",
  ucs2: "utf-16le",
  utf16be: "utf-16be"
};
class DecodeStream {
  constructor(s) {
    this.buffer = s, this.view = new DataView(s.buffer, s.byteOffset, s.byteLength), this.pos = 0, this.length = this.buffer.length;
  }
  readString(s, c = "ascii") {
    c = ENCODING_MAPPING[c] || c;
    let u = this.readBuffer(s);
    try {
      return new TextDecoder(c).decode(u);
    } catch {
      return u;
    }
  }
  readBuffer(s) {
    return this.buffer.slice(this.pos, this.pos += s);
  }
  readUInt24BE() {
    return (this.readUInt16BE() << 8) + this.readUInt8();
  }
  readUInt24LE() {
    return this.readUInt16LE() + (this.readUInt8() << 16);
  }
  readInt24BE() {
    return (this.readInt16BE() << 8) + this.readUInt8();
  }
  readInt24LE() {
    return this.readUInt16LE() + (this.readInt8() << 16);
  }
}
DecodeStream.TYPES = {
  UInt8: 1,
  UInt16: 2,
  UInt24: 3,
  UInt32: 4,
  Int8: 1,
  Int16: 2,
  Int24: 3,
  Int32: 4,
  Float: 4,
  Double: 8
};
for (let a of Object.getOwnPropertyNames(DataView.prototype))
  if (a.slice(0, 3) === "get") {
    let s = a.slice(3).replace("Ui", "UI");
    s === "Float32" ? s = "Float" : s === "Float64" && (s = "Double");
    let c = DecodeStream.TYPES[s];
    DecodeStream.prototype["read" + s + (c === 1 ? "" : "BE")] = function() {
      const u = this.view[a](this.pos, !1);
      return this.pos += c, u;
    }, c !== 1 && (DecodeStream.prototype["read" + s + "LE"] = function() {
      const u = this.view[a](this.pos, !0);
      return this.pos += c, u;
    });
  }
const textEncoder = new TextEncoder(), isBigEndian = new Uint8Array(new Uint16Array([4660]).buffer)[0] == 18;
class EncodeStream {
  constructor(s) {
    this.buffer = s, this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), this.pos = 0;
  }
  writeBuffer(s) {
    this.buffer.set(s, this.pos), this.pos += s.length;
  }
  writeString(s, c = "ascii") {
    let u;
    switch (c) {
      case "utf16le":
      case "utf16-le":
      case "ucs2":
        u = stringToUtf16(s, isBigEndian);
        break;
      case "utf16be":
      case "utf16-be":
        u = stringToUtf16(s, !isBigEndian);
        break;
      case "utf8":
        u = textEncoder.encode(s);
        break;
      case "ascii":
        u = stringToAscii(s);
        break;
      default:
        throw new Error(`Unsupported encoding: ${c}`);
    }
    this.writeBuffer(u);
  }
  writeUInt24BE(s) {
    this.buffer[this.pos++] = s >>> 16 & 255, this.buffer[this.pos++] = s >>> 8 & 255, this.buffer[this.pos++] = s & 255;
  }
  writeUInt24LE(s) {
    this.buffer[this.pos++] = s & 255, this.buffer[this.pos++] = s >>> 8 & 255, this.buffer[this.pos++] = s >>> 16 & 255;
  }
  writeInt24BE(s) {
    s >= 0 ? this.writeUInt24BE(s) : this.writeUInt24BE(s + 16777215 + 1);
  }
  writeInt24LE(s) {
    s >= 0 ? this.writeUInt24LE(s) : this.writeUInt24LE(s + 16777215 + 1);
  }
  fill(s, c) {
    if (c < this.buffer.length)
      this.buffer.fill(s, this.pos, this.pos + c), this.pos += c;
    else {
      const u = new Uint8Array(c);
      u.fill(s), this.writeBuffer(u);
    }
  }
}
function stringToUtf16(a, s) {
  let c = new Uint16Array(a.length);
  for (let u = 0; u < a.length; u++) {
    let d = a.charCodeAt(u);
    s && (d = d >> 8 | (d & 255) << 8), c[u] = d;
  }
  return new Uint8Array(c.buffer);
}
function stringToAscii(a) {
  let s = new Uint8Array(a.length);
  for (let c = 0; c < a.length; c++)
    s[c] = a.charCodeAt(c);
  return s;
}
for (let a of Object.getOwnPropertyNames(DataView.prototype))
  if (a.slice(0, 3) === "set") {
    let s = a.slice(3).replace("Ui", "UI");
    s === "Float32" ? s = "Float" : s === "Float64" && (s = "Double");
    let c = DecodeStream.TYPES[s];
    EncodeStream.prototype["write" + s + (c === 1 ? "" : "BE")] = function(u) {
      this.view[a](this.pos, u, !1), this.pos += c;
    }, c !== 1 && (EncodeStream.prototype["write" + s + "LE"] = function(u) {
      this.view[a](this.pos, u, !0), this.pos += c;
    });
  }
let Base$1 = class {
  fromBuffer(s) {
    let c = new DecodeStream(s);
    return this.decode(c);
  }
  toBuffer(s) {
    let c = this.size(s), u = new Uint8Array(c), d = new EncodeStream(u);
    return this.encode(d, s), u;
  }
};
class NumberT extends Base$1 {
  constructor(s, c = "BE") {
    super(), this.type = s, this.endian = c, this.fn = this.type, this.type[this.type.length - 1] !== "8" && (this.fn += this.endian);
  }
  size() {
    return DecodeStream.TYPES[this.type];
  }
  decode(s) {
    return s[`read${this.fn}`]();
  }
  encode(s, c) {
    return s[`write${this.fn}`](c);
  }
}
const uint8 = new NumberT("UInt8"), uint16be = new NumberT("UInt16", "BE"), uint16 = uint16be;
new NumberT("UInt16", "LE");
const uint24be = new NumberT("UInt24", "BE"), uint24 = uint24be;
new NumberT("UInt24", "LE");
const uint32be = new NumberT("UInt32", "BE"), uint32 = uint32be;
new NumberT("UInt32", "LE");
const int8 = new NumberT("Int8"), int16be = new NumberT("Int16", "BE"), int16 = int16be;
new NumberT("Int16", "LE");
new NumberT("Int24", "BE");
new NumberT("Int24", "LE");
const int32be = new NumberT("Int32", "BE"), int32 = int32be;
new NumberT("Int32", "LE");
new NumberT("Float", "BE");
new NumberT("Float", "LE");
new NumberT("Double", "BE");
new NumberT("Double", "LE");
class Fixed extends NumberT {
  constructor(s, c, u = s >> 1) {
    super(`Int${s}`, c), this._point = 1 << u;
  }
  decode(s) {
    return super.decode(s) / this._point;
  }
  encode(s, c) {
    return super.encode(s, c * this._point | 0);
  }
}
const fixed16be = new Fixed(16, "BE"), fixed16 = fixed16be;
new Fixed(16, "LE");
const fixed32be = new Fixed(32, "BE"), fixed32 = fixed32be;
new Fixed(32, "LE");
function resolveLength(a, s, c) {
  let u;
  if (typeof a == "number" ? u = a : typeof a == "function" ? u = a.call(c, c) : c && typeof a == "string" ? u = c[a] : s && a instanceof NumberT && (u = a.decode(s)), isNaN(u))
    throw new Error("Not a fixed size");
  return u;
}
class PropertyDescriptor {
  constructor(s = {}) {
    this.enumerable = !0, this.configurable = !0;
    for (let c in s) {
      const u = s[c];
      this[c] = u;
    }
  }
}
class ArrayT extends Base$1 {
  constructor(s, c, u = "count") {
    super(), this.type = s, this.length = c, this.lengthType = u;
  }
  decode(s, c) {
    let u;
    const { pos: d } = s, p = [];
    let v = c;
    if (this.length != null && (u = resolveLength(this.length, s, c)), this.length instanceof NumberT && (Object.defineProperties(p, {
      parent: { value: c },
      _startOffset: { value: d },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: u }
    }), v = p), u == null || this.lengthType === "bytes") {
      const A = u != null ? s.pos + u : c?._length ? c._startOffset + c._length : s.length;
      for (; s.pos < A; )
        p.push(this.type.decode(s, v));
    } else
      for (let A = 0, x = u; A < x; A++)
        p.push(this.type.decode(s, v));
    return p;
  }
  size(s, c, u = !0) {
    if (!s)
      return this.type.size(null, c) * resolveLength(this.length, null, c);
    let d = 0;
    this.length instanceof NumberT && (d += this.length.size(), c = { parent: c, pointerSize: 0 });
    for (let p of s)
      d += this.type.size(p, c);
    return c && u && this.length instanceof NumberT && (d += c.pointerSize), d;
  }
  encode(s, c, u) {
    let d = u;
    this.length instanceof NumberT && (d = {
      pointers: [],
      startOffset: s.pos,
      parent: u
    }, d.pointerOffset = s.pos + this.size(c, d, !1), this.length.encode(s, c.length));
    for (let p of c)
      this.type.encode(s, p, d);
    if (this.length instanceof NumberT) {
      let p = 0;
      for (; p < d.pointers.length; ) {
        const v = d.pointers[p++];
        v.type.encode(s, v.val, v.parent);
      }
    }
  }
}
class LazyArray extends ArrayT {
  decode(s, c) {
    const { pos: u } = s, d = resolveLength(this.length, s, c);
    this.length instanceof NumberT && (c = {
      parent: c,
      _startOffset: u,
      _currentOffset: 0,
      _length: d
    });
    const p = new LazyArrayValue(this.type, d, s, c);
    return s.pos += d * this.type.size(null, c), p;
  }
  size(s, c) {
    return s instanceof LazyArrayValue && (s = s.toArray()), super.size(s, c);
  }
  encode(s, c, u) {
    return c instanceof LazyArrayValue && (c = c.toArray()), super.encode(s, c, u);
  }
}
class LazyArrayValue {
  constructor(s, c, u, d) {
    this.type = s, this.length = c, this.stream = u, this.ctx = d, this.base = this.stream.pos, this.items = [];
  }
  get(s) {
    if (!(s < 0 || s >= this.length)) {
      if (this.items[s] == null) {
        const { pos: c } = this.stream;
        this.stream.pos = this.base + this.type.size(null, this.ctx) * s, this.items[s] = this.type.decode(this.stream, this.ctx), this.stream.pos = c;
      }
      return this.items[s];
    }
  }
  toArray() {
    const s = [];
    for (let c = 0, u = this.length; c < u; c++)
      s.push(this.get(c));
    return s;
  }
}
class Bitfield extends Base$1 {
  constructor(s, c = []) {
    super(), this.type = s, this.flags = c;
  }
  decode(s) {
    const c = this.type.decode(s), u = {};
    for (let d = 0; d < this.flags.length; d++) {
      const p = this.flags[d];
      p != null && (u[p] = !!(c & 1 << d));
    }
    return u;
  }
  size() {
    return this.type.size();
  }
  encode(s, c) {
    let u = 0;
    for (let d = 0; d < this.flags.length; d++) {
      const p = this.flags[d];
      p != null && c[p] && (u |= 1 << d);
    }
    return this.type.encode(s, u);
  }
}
class BufferT extends Base$1 {
  constructor(s) {
    super(), this.length = s;
  }
  decode(s, c) {
    const u = resolveLength(this.length, s, c);
    return s.readBuffer(u);
  }
  size(s, c) {
    if (!s)
      return resolveLength(this.length, null, c);
    let u = s.length;
    return this.length instanceof NumberT && (u += this.length.size()), u;
  }
  encode(s, c, u) {
    return this.length instanceof NumberT && this.length.encode(s, c.length), s.writeBuffer(c);
  }
}
class Optional extends Base$1 {
  constructor(s, c = !0) {
    super(), this.type = s, this.condition = c;
  }
  decode(s, c) {
    let { condition: u } = this;
    if (typeof u == "function" && (u = u.call(c, c)), u)
      return this.type.decode(s, c);
  }
  size(s, c) {
    let { condition: u } = this;
    return typeof u == "function" && (u = u.call(c, c)), u ? this.type.size(s, c) : 0;
  }
  encode(s, c, u) {
    let { condition: d } = this;
    if (typeof d == "function" && (d = d.call(u, u)), d)
      return this.type.encode(s, c, u);
  }
}
class Reserved extends Base$1 {
  constructor(s, c = 1) {
    super(), this.type = s, this.count = c;
  }
  decode(s, c) {
    s.pos += this.size(null, c);
  }
  size(s, c) {
    const u = resolveLength(this.count, null, c);
    return this.type.size() * u;
  }
  encode(s, c, u) {
    return s.fill(0, this.size(c, u));
  }
}
class StringT extends Base$1 {
  constructor(s, c = "ascii") {
    super(), this.length = s, this.encoding = c;
  }
  decode(s, c) {
    let u, d, { encoding: p } = this;
    typeof p == "function" && (p = p.call(c, c) || "ascii");
    let v = encodingWidth(p);
    if (this.length != null)
      u = resolveLength(this.length, s, c);
    else {
      let x;
      for ({ buffer: x, length: u, pos: d } = s; d < u - v + 1 && (x[d] !== 0 || v === 2 && x[d + 1] !== 0); )
        d += v;
      u = d - s.pos;
    }
    const A = s.readString(u, p);
    return this.length == null && s.pos < s.length && (s.pos += v), A;
  }
  size(s, c) {
    if (s == null)
      return resolveLength(this.length, null, c);
    let { encoding: u } = this;
    typeof u == "function" && (u = u.call(c?.val, c?.val) || "ascii"), u === "utf16be" && (u = "utf16le");
    let d = byteLength(s, u);
    return this.length instanceof NumberT && (d += this.length.size()), this.length == null && (d += encodingWidth(u)), d;
  }
  encode(s, c, u) {
    let { encoding: d } = this;
    if (typeof d == "function" && (d = d.call(u?.val, u?.val) || "ascii"), this.length instanceof NumberT && this.length.encode(s, byteLength(c, d)), s.writeString(c, d), this.length == null)
      return encodingWidth(d) == 2 ? s.writeUInt16LE(0) : s.writeUInt8(0);
  }
}
function encodingWidth(a) {
  switch (a) {
    case "ascii":
    case "utf8":
      return 1;
    case "utf16le":
    case "utf16-le":
    case "utf-16be":
    case "utf-16le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return 2;
    default:
      return 1;
  }
}
function byteLength(a, s) {
  switch (s) {
    case "ascii":
      return a.length;
    case "utf8":
      let c = 0;
      for (let u = 0; u < a.length; u++) {
        let d = a.charCodeAt(u);
        if (d >= 55296 && d <= 56319 && u < a.length - 1) {
          let p = a.charCodeAt(++u);
          (p & 64512) === 56320 ? d = ((d & 1023) << 10) + (p & 1023) + 65536 : u--;
        }
        (d & 4294967168) === 0 ? c++ : (d & 4294965248) === 0 ? c += 2 : (d & 4294901760) === 0 ? c += 3 : (d & 4292870144) === 0 && (c += 4);
      }
      return c;
    case "utf16le":
    case "utf16-le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return a.length * 2;
    default:
      throw new Error("Unknown encoding " + s);
  }
}
class Struct extends Base$1 {
  constructor(s = {}) {
    super(), this.fields = s;
  }
  decode(s, c, u = 0) {
    const d = this._setup(s, c, u);
    return this._parseFields(s, d, this.fields), this.process != null && this.process.call(d, s), d;
  }
  _setup(s, c, u) {
    const d = {};
    return Object.defineProperties(d, {
      parent: { value: c },
      _startOffset: { value: s.pos },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: u }
    }), d;
  }
  _parseFields(s, c, u) {
    for (let p in u) {
      var d;
      const v = u[p];
      typeof v == "function" ? d = v.call(c, c) : d = v.decode(s, c), d !== void 0 && (d instanceof PropertyDescriptor ? Object.defineProperty(c, p, d) : c[p] = d), c._currentOffset = s.pos - c._startOffset;
    }
  }
  size(s, c, u = !0) {
    s == null && (s = {});
    const d = {
      parent: c,
      val: s,
      pointerSize: 0
    };
    this.preEncode != null && this.preEncode.call(s);
    let p = 0;
    for (let v in this.fields) {
      const A = this.fields[v];
      A.size != null && (p += A.size(s[v], d));
    }
    return u && (p += d.pointerSize), p;
  }
  encode(s, c, u) {
    let d;
    this.preEncode != null && this.preEncode.call(c, s);
    const p = {
      pointers: [],
      startOffset: s.pos,
      parent: u,
      val: c,
      pointerSize: 0
    };
    p.pointerOffset = s.pos + this.size(c, p, !1);
    for (let A in this.fields)
      d = this.fields[A], d.encode != null && d.encode(s, c[A], p);
    let v = 0;
    for (; v < p.pointers.length; ) {
      const A = p.pointers[v++];
      A.type.encode(s, A.val, A.parent);
    }
  }
}
const getPath$1 = (a, s) => s.reduce((c, u) => c && c[u], a);
class VersionedStruct extends Struct {
  constructor(s, c = {}) {
    super(), this.type = s, this.versions = c, typeof s == "string" && (this.versionPath = s.split("."));
  }
  decode(s, c, u = 0) {
    const d = this._setup(s, c, u);
    typeof this.type == "string" ? d.version = getPath$1(c, this.versionPath) : d.version = this.type.decode(s), this.versions.header && this._parseFields(s, d, this.versions.header);
    const p = this.versions[d.version];
    if (p == null)
      throw new Error(`Unknown version ${d.version}`);
    return p instanceof VersionedStruct ? p.decode(s, c) : (this._parseFields(s, d, p), this.process != null && this.process.call(d, s), d);
  }
  size(s, c, u = !0) {
    let d, p;
    if (!s)
      throw new Error("Not a fixed size");
    this.preEncode != null && this.preEncode.call(s);
    const v = {
      parent: c,
      val: s,
      pointerSize: 0
    };
    let A = 0;
    if (typeof this.type != "string" && (A += this.type.size(s.version, v)), this.versions.header)
      for (d in this.versions.header)
        p = this.versions.header[d], p.size != null && (A += p.size(s[d], v));
    const x = this.versions[s.version];
    if (x == null)
      throw new Error(`Unknown version ${s.version}`);
    for (d in x)
      p = x[d], p.size != null && (A += p.size(s[d], v));
    return u && (A += v.pointerSize), A;
  }
  encode(s, c, u) {
    let d, p;
    this.preEncode != null && this.preEncode.call(c, s);
    const v = {
      pointers: [],
      startOffset: s.pos,
      parent: u,
      val: c,
      pointerSize: 0
    };
    if (v.pointerOffset = s.pos + this.size(c, v, !1), typeof this.type != "string" && this.type.encode(s, c.version), this.versions.header)
      for (d in this.versions.header)
        p = this.versions.header[d], p.encode != null && p.encode(s, c[d], v);
    const A = this.versions[c.version];
    for (d in A)
      p = A[d], p.encode != null && p.encode(s, c[d], v);
    let x = 0;
    for (; x < v.pointers.length; ) {
      const g = v.pointers[x++];
      g.type.encode(s, g.val, g.parent);
    }
  }
}
class Pointer extends Base$1 {
  constructor(s, c, u = {}) {
    if (super(), this.offsetType = s, this.type = c, this.options = u, this.type === "void" && (this.type = null), this.options.type == null && (this.options.type = "local"), this.options.allowNull == null && (this.options.allowNull = !0), this.options.nullValue == null && (this.options.nullValue = 0), this.options.lazy == null && (this.options.lazy = !1), this.options.relativeTo) {
      if (typeof this.options.relativeTo != "function")
        throw new Error("relativeTo option must be a function");
      this.relativeToGetter = u.relativeTo;
    }
  }
  decode(s, c) {
    const u = this.offsetType.decode(s, c);
    if (u === this.options.nullValue && this.options.allowNull)
      return null;
    let d;
    switch (this.options.type) {
      case "local":
        d = c._startOffset;
        break;
      case "immediate":
        d = s.pos - this.offsetType.size();
        break;
      case "parent":
        d = c.parent._startOffset;
        break;
      default:
        for (var p = c; p.parent; )
          p = p.parent;
        d = p._startOffset || 0;
    }
    this.options.relativeTo && (d += this.relativeToGetter(c));
    const v = u + d;
    if (this.type != null) {
      let A = null;
      const x = () => {
        if (A != null)
          return A;
        const { pos: g } = s;
        return s.pos = v, A = this.type.decode(s, c), s.pos = g, A;
      };
      return this.options.lazy ? new PropertyDescriptor({
        get: x
      }) : x();
    } else
      return v;
  }
  size(s, c) {
    const u = c;
    switch (this.options.type) {
      case "local":
      case "immediate":
        break;
      case "parent":
        c = c.parent;
        break;
      default:
        for (; c.parent; )
          c = c.parent;
    }
    let { type: d } = this;
    if (d == null) {
      if (!(s instanceof VoidPointer))
        throw new Error("Must be a VoidPointer");
      ({ type: d } = s), s = s.value;
    }
    if (s && c) {
      let p = d.size(s, u);
      c.pointerSize += p;
    }
    return this.offsetType.size();
  }
  encode(s, c, u) {
    let d;
    const p = u;
    if (c == null) {
      this.offsetType.encode(s, this.options.nullValue);
      return;
    }
    switch (this.options.type) {
      case "local":
        d = u.startOffset;
        break;
      case "immediate":
        d = s.pos + this.offsetType.size(c, p);
        break;
      case "parent":
        u = u.parent, d = u.startOffset;
        break;
      default:
        for (d = 0; u.parent; )
          u = u.parent;
    }
    this.options.relativeTo && (d += this.relativeToGetter(p.val)), this.offsetType.encode(s, u.pointerOffset - d);
    let { type: v } = this;
    if (v == null) {
      if (!(c instanceof VoidPointer))
        throw new Error("Must be a VoidPointer");
      ({ type: v } = c), c = c.value;
    }
    return u.pointers.push({
      type: v,
      val: c,
      parent: p
    }), u.pointerOffset += v.size(c, p);
  }
}
class VoidPointer {
  constructor(s, c) {
    this.type = s, this.value = c;
  }
}
function _define_property(a, s, c) {
  return s in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function __rest$15(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
      s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
}
function __decorate$3(a, s, c, u) {
  var d = arguments.length, p = d < 3 ? s : u === null ? u = Object.getOwnPropertyDescriptor(s, c) : u, v;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") p = Reflect.decorate(a, s, c, u);
  else for (var A = a.length - 1; A >= 0; A--) (v = a[A]) && (p = (d < 3 ? v(p) : d > 3 ? v(s, c, p) : v(s, c)) || p);
  return d > 3 && p && Object.defineProperty(s, c, p), p;
}
function __awaiter$2(a, s, c, u) {
  function d(p) {
    return p instanceof c ? p : new c(function(v) {
      v(p);
    });
  }
  return new (c || (c = Promise))(function(p, v) {
    function A(b) {
      try {
        g(u.next(b));
      } catch (y) {
        v(y);
      }
    }
    function x(b) {
      try {
        g(u.throw(b));
      } catch (y) {
        v(y);
      }
    }
    function g(b) {
      b.done ? p(b.value) : d(b.value).then(A, x);
    }
    g((u = u.apply(a, s || [])).next());
  });
}
typeof SuppressedError == "function" && SuppressedError;
var fastDeepEqual, hasRequiredFastDeepEqual;
function requireFastDeepEqual() {
  return hasRequiredFastDeepEqual || (hasRequiredFastDeepEqual = 1, fastDeepEqual = function a(s, c) {
    if (s === c) return !0;
    if (s && c && typeof s == "object" && typeof c == "object") {
      if (s.constructor !== c.constructor) return !1;
      var u, d, p;
      if (Array.isArray(s)) {
        if (u = s.length, u != c.length) return !1;
        for (d = u; d-- !== 0; )
          if (!a(s[d], c[d])) return !1;
        return !0;
      }
      if (s.constructor === RegExp) return s.source === c.source && s.flags === c.flags;
      if (s.valueOf !== Object.prototype.valueOf) return s.valueOf() === c.valueOf();
      if (s.toString !== Object.prototype.toString) return s.toString() === c.toString();
      if (p = Object.keys(s), u = p.length, u !== Object.keys(c).length) return !1;
      for (d = u; d-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(c, p[d])) return !1;
      for (d = u; d-- !== 0; ) {
        var v = p[d];
        if (!a(s[v], c[v])) return !1;
      }
      return !0;
    }
    return s !== s && c !== c;
  }), fastDeepEqual;
}
var fastDeepEqualExports = requireFastDeepEqual();
const $6uUbQ$fastdeepequal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqualExports);
var base64JsExports = requireBase64Js();
const $bdjGp$base64js = /* @__PURE__ */ getDefaultExportFromCjs(base64JsExports);
var tinyInflate, hasRequiredTinyInflate;
function requireTinyInflate() {
  if (hasRequiredTinyInflate) return tinyInflate;
  hasRequiredTinyInflate = 1;
  var a = 0, s = -3;
  function c() {
    this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
  }
  function u(L, B) {
    this.source = L, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = B, this.destLen = 0, this.ltree = new c(), this.dtree = new c();
  }
  var d = new c(), p = new c(), v = new Uint8Array(30), A = new Uint16Array(30), x = new Uint8Array(30), g = new Uint16Array(30), b = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
  ]), y = new c(), f = new Uint8Array(320);
  function m(L, B, F, M) {
    var W, j;
    for (W = 0; W < F; ++W) L[W] = 0;
    for (W = 0; W < 30 - F; ++W) L[W + F] = W / F | 0;
    for (j = M, W = 0; W < 30; ++W)
      B[W] = j, j += 1 << L[W];
  }
  function C(L, B) {
    var F;
    for (F = 0; F < 7; ++F) L.table[F] = 0;
    for (L.table[7] = 24, L.table[8] = 152, L.table[9] = 112, F = 0; F < 24; ++F) L.trans[F] = 256 + F;
    for (F = 0; F < 144; ++F) L.trans[24 + F] = F;
    for (F = 0; F < 8; ++F) L.trans[168 + F] = 280 + F;
    for (F = 0; F < 112; ++F) L.trans[176 + F] = 144 + F;
    for (F = 0; F < 5; ++F) B.table[F] = 0;
    for (B.table[5] = 32, F = 0; F < 32; ++F) B.trans[F] = F;
  }
  var w = new Uint16Array(16);
  function S(L, B, F, M) {
    var W, j;
    for (W = 0; W < 16; ++W) L.table[W] = 0;
    for (W = 0; W < M; ++W) L.table[B[F + W]]++;
    for (L.table[0] = 0, j = 0, W = 0; W < 16; ++W)
      w[W] = j, j += L.table[W];
    for (W = 0; W < M; ++W)
      B[F + W] && (L.trans[w[B[F + W]]++] = W);
  }
  function $(L) {
    L.bitcount-- || (L.tag = L.source[L.sourceIndex++], L.bitcount = 7);
    var B = L.tag & 1;
    return L.tag >>>= 1, B;
  }
  function T(L, B, F) {
    if (!B)
      return F;
    for (; L.bitcount < 24; )
      L.tag |= L.source[L.sourceIndex++] << L.bitcount, L.bitcount += 8;
    var M = L.tag & 65535 >>> 16 - B;
    return L.tag >>>= B, L.bitcount -= B, M + F;
  }
  function I(L, B) {
    for (; L.bitcount < 24; )
      L.tag |= L.source[L.sourceIndex++] << L.bitcount, L.bitcount += 8;
    var F = 0, M = 0, W = 0, j = L.tag;
    do
      M = 2 * M + (j & 1), j >>>= 1, ++W, F += B.table[W], M -= B.table[W];
    while (M >= 0);
    return L.tag = j, L.bitcount -= W, B.trans[F + M];
  }
  function _(L, B, F) {
    var M, W, j, G, U, k;
    for (M = T(L, 5, 257), W = T(L, 5, 1), j = T(L, 4, 4), G = 0; G < 19; ++G) f[G] = 0;
    for (G = 0; G < j; ++G) {
      var N = T(L, 3, 0);
      f[b[G]] = N;
    }
    for (S(y, f, 0, 19), U = 0; U < M + W; ) {
      var P = I(L, y);
      switch (P) {
        case 16:
          var D = f[U - 1];
          for (k = T(L, 2, 3); k; --k)
            f[U++] = D;
          break;
        case 17:
          for (k = T(L, 3, 3); k; --k)
            f[U++] = 0;
          break;
        case 18:
          for (k = T(L, 7, 11); k; --k)
            f[U++] = 0;
          break;
        default:
          f[U++] = P;
          break;
      }
    }
    S(B, f, 0, M), S(F, f, M, W);
  }
  function E(L, B, F) {
    for (; ; ) {
      var M = I(L, B);
      if (M === 256)
        return a;
      if (M < 256)
        L.dest[L.destLen++] = M;
      else {
        var W, j, G, U;
        for (M -= 257, W = T(L, v[M], A[M]), j = I(L, F), G = L.destLen - T(L, x[j], g[j]), U = G; U < G + W; ++U)
          L.dest[L.destLen++] = L.dest[U];
      }
    }
  }
  function R(L) {
    for (var B, F, M; L.bitcount > 8; )
      L.sourceIndex--, L.bitcount -= 8;
    if (B = L.source[L.sourceIndex + 1], B = 256 * B + L.source[L.sourceIndex], F = L.source[L.sourceIndex + 3], F = 256 * F + L.source[L.sourceIndex + 2], B !== (~F & 65535))
      return s;
    for (L.sourceIndex += 4, M = B; M; --M)
      L.dest[L.destLen++] = L.source[L.sourceIndex++];
    return L.bitcount = 0, a;
  }
  function O(L, B) {
    var F = new u(L, B), M, W, j;
    do {
      switch (M = $(F), W = T(F, 2, 0), W) {
        case 0:
          j = R(F);
          break;
        case 1:
          j = E(F, d, p);
          break;
        case 2:
          _(F, F.ltree, F.dtree), j = E(F, F.ltree, F.dtree);
          break;
        default:
          j = s;
      }
      if (j !== a)
        throw new Error("Data error");
    } while (!M);
    return F.destLen < F.dest.length ? typeof F.dest.slice == "function" ? F.dest.slice(0, F.destLen) : F.dest.subarray(0, F.destLen) : F.dest;
  }
  return C(d, p), m(v, A, 4, 3), m(x, g, 2, 1), v[28] = 0, A[28] = 258, tinyInflate = O, tinyInflate;
}
var swap_1, hasRequiredSwap;
function requireSwap() {
  if (hasRequiredSwap) return swap_1;
  hasRequiredSwap = 1;
  const a = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, s = (d, p, v) => {
    let A = d[p];
    d[p] = d[v], d[v] = A;
  }, c = (d) => {
    const p = d.length;
    for (let v = 0; v < p; v += 4)
      s(d, v, v + 3), s(d, v + 1, v + 2);
  };
  return swap_1 = {
    swap32LE: (d) => {
      a && c(d);
    }
  }, swap_1;
}
var unicodeTrie, hasRequiredUnicodeTrie;
function requireUnicodeTrie() {
  if (hasRequiredUnicodeTrie) return unicodeTrie;
  hasRequiredUnicodeTrie = 1;
  const a = requireTinyInflate(), { swap32LE: s } = requireSwap(), c = 11, u = 5, d = c - u, p = 65536 >> c, A = (1 << d) - 1, x = 2, b = (1 << u) - 1, y = 65536 >> u, f = 1024 >> u, S = y + f + 32, $ = 1 << x;
  class T {
    constructor(_) {
      const E = typeof _.readUInt32BE == "function" && typeof _.slice == "function";
      if (E || _ instanceof Uint8Array) {
        let R;
        if (E)
          this.highStart = _.readUInt32LE(0), this.errorValue = _.readUInt32LE(4), R = _.readUInt32LE(8), _ = _.slice(12);
        else {
          const O = new DataView(_.buffer);
          this.highStart = O.getUint32(0, !0), this.errorValue = O.getUint32(4, !0), R = O.getUint32(8, !0), _ = _.subarray(12);
        }
        _ = a(_, new Uint8Array(R)), _ = a(_, new Uint8Array(R)), s(_), this.data = new Uint32Array(_.buffer);
      } else
        ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = _);
    }
    get(_) {
      let E;
      return _ < 0 || _ > 1114111 ? this.errorValue : _ < 55296 || _ > 56319 && _ <= 65535 ? (E = (this.data[_ >> u] << x) + (_ & b), this.data[E]) : _ <= 65535 ? (E = (this.data[y + (_ - 55296 >> u)] << x) + (_ & b), this.data[E]) : _ < this.highStart ? (E = this.data[S - p + (_ >> c)], E = this.data[E + (_ >> u & A)], E = (E << x) + (_ & b), this.data[E]) : this.data[this.data.length - $];
    }
  }
  return unicodeTrie = T, unicodeTrie;
}
var unicodeTrieExports = requireUnicodeTrie();
const $6uUbQ$unicodetrie = /* @__PURE__ */ getDefaultExportFromCjs(unicodeTrieExports);
function $parcel$interopDefault$1(a) {
  return a && a.__esModule ? a.default : a;
}
var $f4087201da764553$exports = {};
$f4087201da764553$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const $747425b437e121da$var$trie = new $6uUbQ$unicodetrie($bdjGp$base64js.toByteArray("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")), $747425b437e121da$var$log2 = Math.log2 || ((a) => Math.log(a) / Math.LN2), $747425b437e121da$var$bits = (a) => $747425b437e121da$var$log2(a) + 1 | 0, $747425b437e121da$var$CATEGORY_BITS = $747425b437e121da$var$bits((/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).categories.length - 1), $747425b437e121da$var$COMBINING_BITS = $747425b437e121da$var$bits((/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).combiningClasses.length - 1), $747425b437e121da$var$SCRIPT_BITS = $747425b437e121da$var$bits((/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).scripts.length - 1), $747425b437e121da$var$EAW_BITS = $747425b437e121da$var$bits((/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).eaw.length - 1), $747425b437e121da$var$NUMBER_BITS = 10, $747425b437e121da$var$CATEGORY_SHIFT = $747425b437e121da$var$COMBINING_BITS + $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS, $747425b437e121da$var$COMBINING_SHIFT = $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS, $747425b437e121da$var$SCRIPT_SHIFT = $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS, $747425b437e121da$var$CATEGORY_MASK = (1 << $747425b437e121da$var$CATEGORY_BITS) - 1, $747425b437e121da$var$COMBINING_MASK = (1 << $747425b437e121da$var$COMBINING_BITS) - 1, $747425b437e121da$var$SCRIPT_MASK = (1 << $747425b437e121da$var$SCRIPT_BITS) - 1;
function $747425b437e121da$export$410364bbb673ddbc(a) {
  const s = $747425b437e121da$var$trie.get(a);
  return (/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).categories[s >> $747425b437e121da$var$CATEGORY_SHIFT & $747425b437e121da$var$CATEGORY_MASK];
}
function $747425b437e121da$export$c03b919c6651ed55(a) {
  const s = $747425b437e121da$var$trie.get(a);
  return (/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).combiningClasses[s >> $747425b437e121da$var$COMBINING_SHIFT & $747425b437e121da$var$COMBINING_MASK];
}
function $747425b437e121da$export$941569448d136665(a) {
  const s = $747425b437e121da$var$trie.get(a);
  return (/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).scripts[s >> $747425b437e121da$var$SCRIPT_SHIFT & $747425b437e121da$var$SCRIPT_MASK];
}
function $747425b437e121da$export$727d9dbc4fbb948f(a) {
  return $747425b437e121da$export$410364bbb673ddbc(a) === "Nd";
}
function $747425b437e121da$export$e33ad6871e762338(a) {
  const s = $747425b437e121da$export$410364bbb673ddbc(a);
  return s === "Mn" || s === "Me" || s === "Mc";
}
var dfa, hasRequiredDfa;
function requireDfa() {
  if (hasRequiredDfa) return dfa;
  hasRequiredDfa = 1;
  var a = 1, s = 0;
  class c {
    constructor(d) {
      this.stateTable = d.stateTable, this.accepting = d.accepting, this.tags = d.tags;
    }
    /**
     * Returns an iterable object that yields pattern matches over the input sequence.
     * Matches are of the form [startIndex, endIndex, tags].
     */
    match(d) {
      var p = this;
      return {
        *[Symbol.iterator]() {
          for (var v = a, A = null, x = null, g = null, b = 0; b < d.length; b++) {
            var y = d[b];
            g = v, v = p.stateTable[v][y], v === s && (A != null && x != null && x >= A && (yield [A, x, p.tags[g]]), v = p.stateTable[a][y], A = null), v !== s && A == null && (A = b), p.accepting[v] && (x = b), v === s && (v = a);
          }
          A != null && x != null && x >= A && (yield [A, x, p.tags[v]]);
        }
      };
    }
    /**
     * For each match over the input sequence, action functions matching
     * the tag definitions in the input pattern are called with the startIndex,
     * endIndex, and sub-match sequence.
     */
    apply(d, p) {
      for (var [v, A, x] of this.match(d))
        for (var g of x)
          typeof p[g] == "function" && p[g](v, A, d.slice(v, A + 1));
    }
  }
  return dfa = c, dfa;
}
var dfaExports = requireDfa();
const $6uUbQ$dfa = /* @__PURE__ */ getDefaultExportFromCjs(dfaExports);
var clone = { exports: {} }, hasRequiredClone;
function requireClone() {
  return hasRequiredClone || (hasRequiredClone = 1, function(a) {
    var s = function() {
      function c(f, m) {
        return m != null && f instanceof m;
      }
      var u;
      try {
        u = Map;
      } catch {
        u = function() {
        };
      }
      var d;
      try {
        d = Set;
      } catch {
        d = function() {
        };
      }
      var p;
      try {
        p = Promise;
      } catch {
        p = function() {
        };
      }
      function v(f, m, C, w, S) {
        typeof m == "object" && (C = m.depth, w = m.prototype, S = m.includeNonEnumerable, m = m.circular);
        var $ = [], T = [], I = typeof Buffer < "u";
        typeof m > "u" && (m = !0), typeof C > "u" && (C = 1 / 0);
        function _(E, R) {
          if (E === null)
            return null;
          if (R === 0)
            return E;
          var O, L;
          if (typeof E != "object")
            return E;
          if (c(E, u))
            O = new u();
          else if (c(E, d))
            O = new d();
          else if (c(E, p))
            O = new p(function(N, P) {
              E.then(function(D) {
                N(_(D, R - 1));
              }, function(D) {
                P(_(D, R - 1));
              });
            });
          else if (v.__isArray(E))
            O = [];
          else if (v.__isRegExp(E))
            O = new RegExp(E.source, y(E)), E.lastIndex && (O.lastIndex = E.lastIndex);
          else if (v.__isDate(E))
            O = new Date(E.getTime());
          else {
            if (I && Buffer.isBuffer(E))
              return Buffer.allocUnsafe ? O = Buffer.allocUnsafe(E.length) : O = new Buffer(E.length), E.copy(O), O;
            c(E, Error) ? O = Object.create(E) : typeof w > "u" ? (L = Object.getPrototypeOf(E), O = Object.create(L)) : (O = Object.create(w), L = w);
          }
          if (m) {
            var B = $.indexOf(E);
            if (B != -1)
              return T[B];
            $.push(E), T.push(O);
          }
          c(E, u) && E.forEach(function(N, P) {
            var D = _(P, R - 1), H = _(N, R - 1);
            O.set(D, H);
          }), c(E, d) && E.forEach(function(N) {
            var P = _(N, R - 1);
            O.add(P);
          });
          for (var F in E) {
            var M;
            L && (M = Object.getOwnPropertyDescriptor(L, F)), !(M && M.set == null) && (O[F] = _(E[F], R - 1));
          }
          if (Object.getOwnPropertySymbols)
            for (var W = Object.getOwnPropertySymbols(E), F = 0; F < W.length; F++) {
              var j = W[F], G = Object.getOwnPropertyDescriptor(E, j);
              G && !G.enumerable && !S || (O[j] = _(E[j], R - 1), G.enumerable || Object.defineProperty(O, j, {
                enumerable: !1
              }));
            }
          if (S)
            for (var U = Object.getOwnPropertyNames(E), F = 0; F < U.length; F++) {
              var k = U[F], G = Object.getOwnPropertyDescriptor(E, k);
              G && G.enumerable || (O[k] = _(E[k], R - 1), Object.defineProperty(O, k, {
                enumerable: !1
              }));
            }
          return O;
        }
        return _(f, C);
      }
      v.clonePrototype = function(m) {
        if (m === null)
          return null;
        var C = function() {
        };
        return C.prototype = m, new C();
      };
      function A(f) {
        return Object.prototype.toString.call(f);
      }
      v.__objToStr = A;
      function x(f) {
        return typeof f == "object" && A(f) === "[object Date]";
      }
      v.__isDate = x;
      function g(f) {
        return typeof f == "object" && A(f) === "[object Array]";
      }
      v.__isArray = g;
      function b(f) {
        return typeof f == "object" && A(f) === "[object RegExp]";
      }
      v.__isRegExp = b;
      function y(f) {
        var m = "";
        return f.global && (m += "g"), f.ignoreCase && (m += "i"), f.multiline && (m += "m"), m;
      }
      return v.__getRegExpFlags = y, v;
    }();
    a.exports && (a.exports = s);
  }(clone)), clone.exports;
}
var cloneExports = requireClone();
const $6uUbQ$clone = /* @__PURE__ */ getDefaultExportFromCjs(cloneExports);
var tinyInflateExports = requireTinyInflate();
const $6uUbQ$tinyinflate = /* @__PURE__ */ getDefaultExportFromCjs(tinyInflateExports);
var decode = {}, streams = {}, hasRequiredStreams;
function requireStreams() {
  if (hasRequiredStreams) return streams;
  hasRequiredStreams = 1;
  function a(c) {
    this.buffer = c, this.pos = 0;
  }
  a.prototype.read = function(c, u, d) {
    this.pos + d > this.buffer.length && (d = this.buffer.length - this.pos);
    for (var p = 0; p < d; p++)
      c[u + p] = this.buffer[this.pos + p];
    return this.pos += d, d;
  }, streams.BrotliInput = a;
  function s(c) {
    this.buffer = c, this.pos = 0;
  }
  return s.prototype.write = function(c, u) {
    if (this.pos + u > this.buffer.length)
      throw new Error("Output buffer is not large enough");
    return this.buffer.set(c.subarray(0, u), this.pos), this.pos += u, u;
  }, streams.BrotliOutput = s, streams;
}
var bit_reader, hasRequiredBit_reader;
function requireBit_reader() {
  if (hasRequiredBit_reader) return bit_reader;
  hasRequiredBit_reader = 1;
  var a = 4096, s = 2 * a + 32, c = 2 * a - 1, u = new Uint32Array([
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023,
    2047,
    4095,
    8191,
    16383,
    32767,
    65535,
    131071,
    262143,
    524287,
    1048575,
    2097151,
    4194303,
    8388607,
    16777215
  ]);
  function d(p) {
    this.buf_ = new Uint8Array(s), this.input_ = p, this.reset();
  }
  return d.READ_SIZE = a, d.IBUF_MASK = c, d.prototype.reset = function() {
    this.buf_ptr_ = 0, this.val_ = 0, this.pos_ = 0, this.bit_pos_ = 0, this.bit_end_pos_ = 0, this.eos_ = 0, this.readMoreInput();
    for (var p = 0; p < 4; p++)
      this.val_ |= this.buf_[this.pos_] << 8 * p, ++this.pos_;
    return this.bit_end_pos_ > 0;
  }, d.prototype.readMoreInput = function() {
    if (!(this.bit_end_pos_ > 256))
      if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_)
          throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
      } else {
        var p = this.buf_ptr_, v = this.input_.read(this.buf_, p, a);
        if (v < 0)
          throw new Error("Unexpected end of input");
        if (v < a) {
          this.eos_ = 1;
          for (var A = 0; A < 32; A++)
            this.buf_[p + v + A] = 0;
        }
        if (p === 0) {
          for (var A = 0; A < 32; A++)
            this.buf_[(a << 1) + A] = this.buf_[A];
          this.buf_ptr_ = a;
        } else
          this.buf_ptr_ = 0;
        this.bit_end_pos_ += v << 3;
      }
  }, d.prototype.fillBitWindow = function() {
    for (; this.bit_pos_ >= 8; )
      this.val_ >>>= 8, this.val_ |= this.buf_[this.pos_ & c] << 24, ++this.pos_, this.bit_pos_ = this.bit_pos_ - 8 >>> 0, this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
  }, d.prototype.readBits = function(p) {
    32 - this.bit_pos_ < p && this.fillBitWindow();
    var v = this.val_ >>> this.bit_pos_ & u[p];
    return this.bit_pos_ += p, v;
  }, bit_reader = d, bit_reader;
}
var dictionary = {}, dictionaryBrowser = {}, dictionary_bin, hasRequiredDictionary_bin;
function requireDictionary_bin() {
  return hasRequiredDictionary_bin || (hasRequiredDictionary_bin = 1, dictionary_bin = "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"), dictionary_bin;
}
var hasRequiredDictionaryBrowser;
function requireDictionaryBrowser() {
  if (hasRequiredDictionaryBrowser) return dictionaryBrowser;
  hasRequiredDictionaryBrowser = 1;
  var a = requireBase64Js();
  return dictionaryBrowser.init = function() {
    var s = requireDecode().BrotliDecompressBuffer, c = a.toByteArray(requireDictionary_bin());
    return s(c);
  }, dictionaryBrowser;
}
var hasRequiredDictionary;
function requireDictionary() {
  if (hasRequiredDictionary) return dictionary;
  hasRequiredDictionary = 1;
  var a = requireDictionaryBrowser();
  return dictionary.init = function() {
    dictionary.dictionary = a.init();
  }, dictionary.offsetsByLength = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
  ]), dictionary.sizeBitsByLength = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
  ]), dictionary.minDictionaryWordLength = 4, dictionary.maxDictionaryWordLength = 24, dictionary;
}
var huffman = {}, hasRequiredHuffman;
function requireHuffman() {
  if (hasRequiredHuffman) return huffman;
  hasRequiredHuffman = 1;
  function a(p, v) {
    this.bits = p, this.value = v;
  }
  huffman.HuffmanCode = a;
  var s = 15;
  function c(p, v) {
    for (var A = 1 << v - 1; p & A; )
      A >>= 1;
    return (p & A - 1) + A;
  }
  function u(p, v, A, x, g) {
    do
      x -= A, p[v + x] = new a(g.bits, g.value);
    while (x > 0);
  }
  function d(p, v, A) {
    for (var x = 1 << v - A; v < s && (x -= p[v], !(x <= 0)); )
      ++v, x <<= 1;
    return v - A;
  }
  return huffman.BrotliBuildHuffmanTable = function(p, v, A, x, g) {
    var b = v, y, f, m, C, w, S, $, T, I, _, E, R = new Int32Array(s + 1), O = new Int32Array(s + 1);
    for (E = new Int32Array(g), m = 0; m < g; m++)
      R[x[m]]++;
    for (O[1] = 0, f = 1; f < s; f++)
      O[f + 1] = O[f] + R[f];
    for (m = 0; m < g; m++)
      x[m] !== 0 && (E[O[x[m]]++] = m);
    if (T = A, I = 1 << T, _ = I, O[s] === 1) {
      for (C = 0; C < _; ++C)
        p[v + C] = new a(0, E[0] & 65535);
      return _;
    }
    for (C = 0, m = 0, f = 1, w = 2; f <= A; ++f, w <<= 1)
      for (; R[f] > 0; --R[f])
        y = new a(f & 255, E[m++] & 65535), u(p, v + C, w, I, y), C = c(C, f);
    for ($ = _ - 1, S = -1, f = A + 1, w = 2; f <= s; ++f, w <<= 1)
      for (; R[f] > 0; --R[f])
        (C & $) !== S && (v += I, T = d(R, f, A), I = 1 << T, _ += I, S = C & $, p[b + S] = new a(T + A & 255, v - b - S & 65535)), y = new a(f - A & 255, E[m++] & 65535), u(p, v + (C >> A), w, I, y), C = c(C, f);
    return _;
  }, huffman;
}
var context = {}, hasRequiredContext$1;
function requireContext$1() {
  return hasRequiredContext$1 || (hasRequiredContext$1 = 1, context.lookup = new Uint8Array([
    /* CONTEXT_UTF8, last byte. */
    /* ASCII range. */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    4,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    8,
    12,
    16,
    12,
    12,
    20,
    12,
    16,
    24,
    28,
    12,
    12,
    32,
    12,
    36,
    12,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    32,
    32,
    24,
    40,
    28,
    12,
    12,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    24,
    12,
    28,
    12,
    12,
    12,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    24,
    12,
    28,
    12,
    0,
    /* UTF8 continuation byte range. */
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    /* UTF8 lead byte range. */
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    /* CONTEXT_UTF8 second last byte. */
    /* ASCII range. */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    0,
    /* UTF8 continuation byte range. */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    /* UTF8 lead byte range. */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    /* CONTEXT_SIGNED, second last byte. */
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
    0,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    56,
    /* CONTEXT_LSB6, last byte. */
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    /* CONTEXT_MSB6, last byte. */
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    30,
    30,
    30,
    31,
    31,
    31,
    31,
    32,
    32,
    32,
    32,
    33,
    33,
    33,
    33,
    34,
    34,
    34,
    34,
    35,
    35,
    35,
    35,
    36,
    36,
    36,
    36,
    37,
    37,
    37,
    37,
    38,
    38,
    38,
    38,
    39,
    39,
    39,
    39,
    40,
    40,
    40,
    40,
    41,
    41,
    41,
    41,
    42,
    42,
    42,
    42,
    43,
    43,
    43,
    43,
    44,
    44,
    44,
    44,
    45,
    45,
    45,
    45,
    46,
    46,
    46,
    46,
    47,
    47,
    47,
    47,
    48,
    48,
    48,
    48,
    49,
    49,
    49,
    49,
    50,
    50,
    50,
    50,
    51,
    51,
    51,
    51,
    52,
    52,
    52,
    52,
    53,
    53,
    53,
    53,
    54,
    54,
    54,
    54,
    55,
    55,
    55,
    55,
    56,
    56,
    56,
    56,
    57,
    57,
    57,
    57,
    58,
    58,
    58,
    58,
    59,
    59,
    59,
    59,
    60,
    60,
    60,
    60,
    61,
    61,
    61,
    61,
    62,
    62,
    62,
    62,
    63,
    63,
    63,
    63,
    /* CONTEXT_{M,L}SB6, second last byte, */
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ]), context.lookupOffsets = new Uint16Array([
    /* CONTEXT_LSB6 */
    1024,
    1536,
    /* CONTEXT_MSB6 */
    1280,
    1536,
    /* CONTEXT_UTF8 */
    0,
    256,
    /* CONTEXT_SIGNED */
    768,
    512
  ])), context;
}
var prefix$2 = {}, hasRequiredPrefix;
function requirePrefix() {
  if (hasRequiredPrefix) return prefix$2;
  hasRequiredPrefix = 1;
  function a(s, c) {
    this.offset = s, this.nbits = c;
  }
  return prefix$2.kBlockLengthPrefixCode = [
    new a(1, 2),
    new a(5, 2),
    new a(9, 2),
    new a(13, 2),
    new a(17, 3),
    new a(25, 3),
    new a(33, 3),
    new a(41, 3),
    new a(49, 4),
    new a(65, 4),
    new a(81, 4),
    new a(97, 4),
    new a(113, 5),
    new a(145, 5),
    new a(177, 5),
    new a(209, 5),
    new a(241, 6),
    new a(305, 6),
    new a(369, 7),
    new a(497, 8),
    new a(753, 9),
    new a(1265, 10),
    new a(2289, 11),
    new a(4337, 12),
    new a(8433, 13),
    new a(16625, 24)
  ], prefix$2.kInsertLengthPrefixCode = [
    new a(0, 0),
    new a(1, 0),
    new a(2, 0),
    new a(3, 0),
    new a(4, 0),
    new a(5, 0),
    new a(6, 1),
    new a(8, 1),
    new a(10, 2),
    new a(14, 2),
    new a(18, 3),
    new a(26, 3),
    new a(34, 4),
    new a(50, 4),
    new a(66, 5),
    new a(98, 5),
    new a(130, 6),
    new a(194, 7),
    new a(322, 8),
    new a(578, 9),
    new a(1090, 10),
    new a(2114, 12),
    new a(6210, 14),
    new a(22594, 24)
  ], prefix$2.kCopyLengthPrefixCode = [
    new a(2, 0),
    new a(3, 0),
    new a(4, 0),
    new a(5, 0),
    new a(6, 0),
    new a(7, 0),
    new a(8, 0),
    new a(9, 0),
    new a(10, 1),
    new a(12, 1),
    new a(14, 2),
    new a(18, 2),
    new a(22, 3),
    new a(30, 3),
    new a(38, 4),
    new a(54, 4),
    new a(70, 5),
    new a(102, 5),
    new a(134, 6),
    new a(198, 7),
    new a(326, 8),
    new a(582, 9),
    new a(1094, 10),
    new a(2118, 24)
  ], prefix$2.kInsertRangeLut = [
    0,
    0,
    8,
    8,
    0,
    16,
    8,
    16,
    16
  ], prefix$2.kCopyRangeLut = [
    0,
    8,
    0,
    8,
    16,
    0,
    16,
    8,
    16
  ], prefix$2;
}
var transform = {}, hasRequiredTransform;
function requireTransform() {
  if (hasRequiredTransform) return transform;
  hasRequiredTransform = 1;
  var a = requireDictionary(), s = 0, c = 1, u = 2, d = 3, p = 4, v = 5, A = 6, x = 7, g = 8, b = 9, y = 10, f = 11, m = 12, C = 13, w = 14, S = 15, $ = 16, T = 17, I = 18, _ = 20;
  function E(L, B, F) {
    this.prefix = new Uint8Array(L.length), this.transform = B, this.suffix = new Uint8Array(F.length);
    for (var M = 0; M < L.length; M++)
      this.prefix[M] = L.charCodeAt(M);
    for (var M = 0; M < F.length; M++)
      this.suffix[M] = F.charCodeAt(M);
  }
  var R = [
    new E("", s, ""),
    new E("", s, " "),
    new E(" ", s, " "),
    new E("", m, ""),
    new E("", y, " "),
    new E("", s, " the "),
    new E(" ", s, ""),
    new E("s ", s, " "),
    new E("", s, " of "),
    new E("", y, ""),
    new E("", s, " and "),
    new E("", C, ""),
    new E("", c, ""),
    new E(", ", s, " "),
    new E("", s, ", "),
    new E(" ", y, " "),
    new E("", s, " in "),
    new E("", s, " to "),
    new E("e ", s, " "),
    new E("", s, '"'),
    new E("", s, "."),
    new E("", s, '">'),
    new E("", s, `
`),
    new E("", d, ""),
    new E("", s, "]"),
    new E("", s, " for "),
    new E("", w, ""),
    new E("", u, ""),
    new E("", s, " a "),
    new E("", s, " that "),
    new E(" ", y, ""),
    new E("", s, ". "),
    new E(".", s, ""),
    new E(" ", s, ", "),
    new E("", S, ""),
    new E("", s, " with "),
    new E("", s, "'"),
    new E("", s, " from "),
    new E("", s, " by "),
    new E("", $, ""),
    new E("", T, ""),
    new E(" the ", s, ""),
    new E("", p, ""),
    new E("", s, ". The "),
    new E("", f, ""),
    new E("", s, " on "),
    new E("", s, " as "),
    new E("", s, " is "),
    new E("", x, ""),
    new E("", c, "ing "),
    new E("", s, `
	`),
    new E("", s, ":"),
    new E(" ", s, ". "),
    new E("", s, "ed "),
    new E("", _, ""),
    new E("", I, ""),
    new E("", A, ""),
    new E("", s, "("),
    new E("", y, ", "),
    new E("", g, ""),
    new E("", s, " at "),
    new E("", s, "ly "),
    new E(" the ", s, " of "),
    new E("", v, ""),
    new E("", b, ""),
    new E(" ", y, ", "),
    new E("", y, '"'),
    new E(".", s, "("),
    new E("", f, " "),
    new E("", y, '">'),
    new E("", s, '="'),
    new E(" ", s, "."),
    new E(".com/", s, ""),
    new E(" the ", s, " of the "),
    new E("", y, "'"),
    new E("", s, ". This "),
    new E("", s, ","),
    new E(".", s, " "),
    new E("", y, "("),
    new E("", y, "."),
    new E("", s, " not "),
    new E(" ", s, '="'),
    new E("", s, "er "),
    new E(" ", f, " "),
    new E("", s, "al "),
    new E(" ", f, ""),
    new E("", s, "='"),
    new E("", f, '"'),
    new E("", y, ". "),
    new E(" ", s, "("),
    new E("", s, "ful "),
    new E(" ", y, ". "),
    new E("", s, "ive "),
    new E("", s, "less "),
    new E("", f, "'"),
    new E("", s, "est "),
    new E(" ", y, "."),
    new E("", f, '">'),
    new E(" ", s, "='"),
    new E("", y, ","),
    new E("", s, "ize "),
    new E("", f, "."),
    new E("Â ", s, ""),
    new E(" ", s, ","),
    new E("", y, '="'),
    new E("", f, '="'),
    new E("", s, "ous "),
    new E("", f, ", "),
    new E("", y, "='"),
    new E(" ", y, ","),
    new E(" ", f, '="'),
    new E(" ", f, ", "),
    new E("", f, ","),
    new E("", f, "("),
    new E("", f, ". "),
    new E(" ", f, "."),
    new E("", f, "='"),
    new E(" ", f, ". "),
    new E(" ", y, '="'),
    new E(" ", f, "='"),
    new E(" ", y, "='")
  ];
  transform.kTransforms = R, transform.kNumTransforms = R.length;
  function O(L, B) {
    return L[B] < 192 ? (L[B] >= 97 && L[B] <= 122 && (L[B] ^= 32), 1) : L[B] < 224 ? (L[B + 1] ^= 32, 2) : (L[B + 2] ^= 5, 3);
  }
  return transform.transformDictionaryWord = function(L, B, F, M, W) {
    var j = R[W].prefix, G = R[W].suffix, U = R[W].transform, k = U < m ? 0 : U - (m - 1), N = 0, P = B, D;
    k > M && (k = M);
    for (var H = 0; H < j.length; )
      L[B++] = j[H++];
    for (F += k, M -= k, U <= b && (M -= U), N = 0; N < M; N++)
      L[B++] = a.dictionary[F + N];
    if (D = B - M, U === y)
      O(L, D);
    else if (U === f)
      for (; M > 0; ) {
        var V = O(L, D);
        D += V, M -= V;
      }
    for (var Z = 0; Z < G.length; )
      L[B++] = G[Z++];
    return B - P;
  }, transform;
}
var hasRequiredDecode;
function requireDecode() {
  if (hasRequiredDecode) return decode;
  hasRequiredDecode = 1;
  var a = requireStreams().BrotliInput, s = requireStreams().BrotliOutput, c = requireBit_reader(), u = requireDictionary(), d = requireHuffman().HuffmanCode, p = requireHuffman().BrotliBuildHuffmanTable, v = requireContext$1(), A = requirePrefix(), x = requireTransform(), g = 8, b = 16, y = 256, f = 704, m = 26, C = 6, w = 2, S = 8, $ = 255, T = 1080, I = 18, _ = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
  ]), E = 16, R = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
  ]), O = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
  ]), L = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
  ]);
  function B(Q) {
    var J;
    return Q.readBits(1) === 0 ? 16 : (J = Q.readBits(3), J > 0 ? 17 + J : (J = Q.readBits(3), J > 0 ? 8 + J : 17));
  }
  function F(Q) {
    if (Q.readBits(1)) {
      var J = Q.readBits(3);
      return J === 0 ? 1 : Q.readBits(J) + (1 << J);
    }
    return 0;
  }
  function M() {
    this.meta_block_length = 0, this.input_end = 0, this.is_uncompressed = 0, this.is_metadata = !1;
  }
  function W(Q) {
    var J = new M(), te, ae, se;
    if (J.input_end = Q.readBits(1), J.input_end && Q.readBits(1))
      return J;
    if (te = Q.readBits(2) + 4, te === 7) {
      if (J.is_metadata = !0, Q.readBits(1) !== 0)
        throw new Error("Invalid reserved bit");
      if (ae = Q.readBits(2), ae === 0)
        return J;
      for (se = 0; se < ae; se++) {
        var ie = Q.readBits(8);
        if (se + 1 === ae && ae > 1 && ie === 0)
          throw new Error("Invalid size byte");
        J.meta_block_length |= ie << se * 8;
      }
    } else
      for (se = 0; se < te; ++se) {
        var fe = Q.readBits(4);
        if (se + 1 === te && te > 4 && fe === 0)
          throw new Error("Invalid size nibble");
        J.meta_block_length |= fe << se * 4;
      }
    return ++J.meta_block_length, !J.input_end && !J.is_metadata && (J.is_uncompressed = Q.readBits(1)), J;
  }
  function j(Q, J, te) {
    var ae;
    return te.fillBitWindow(), J += te.val_ >>> te.bit_pos_ & $, ae = Q[J].bits - S, ae > 0 && (te.bit_pos_ += S, J += Q[J].value, J += te.val_ >>> te.bit_pos_ & (1 << ae) - 1), te.bit_pos_ += Q[J].bits, Q[J].value;
  }
  function G(Q, J, te, ae) {
    for (var se = 0, ie = g, fe = 0, ge = 0, me = 32768, pe = [], be = 0; be < 32; be++)
      pe.push(new d(0, 0));
    for (p(pe, 0, 5, Q, I); se < J && me > 0; ) {
      var le = 0, ve;
      if (ae.readMoreInput(), ae.fillBitWindow(), le += ae.val_ >>> ae.bit_pos_ & 31, ae.bit_pos_ += pe[le].bits, ve = pe[le].value & 255, ve < b)
        fe = 0, te[se++] = ve, ve !== 0 && (ie = ve, me -= 32768 >> ve);
      else {
        var he = ve - 14, ye, Ce, xe = 0;
        if (ve === b && (xe = ie), ge !== xe && (fe = 0, ge = xe), ye = fe, fe > 0 && (fe -= 2, fe <<= he), fe += ae.readBits(he) + 3, Ce = fe - ye, se + Ce > J)
          throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
        for (var we = 0; we < Ce; we++)
          te[se + we] = ge;
        se += Ce, ge !== 0 && (me -= Ce << 15 - ge);
      }
    }
    if (me !== 0)
      throw new Error("[ReadHuffmanCodeLengths] space = " + me);
    for (; se < J; se++)
      te[se] = 0;
  }
  function U(Q, J, te, ae) {
    var se = 0, ie, fe = new Uint8Array(Q);
    if (ae.readMoreInput(), ie = ae.readBits(2), ie === 1) {
      for (var ge, me = Q - 1, pe = 0, be = new Int32Array(4), le = ae.readBits(2) + 1; me; )
        me >>= 1, ++pe;
      for (ge = 0; ge < le; ++ge)
        be[ge] = ae.readBits(pe) % Q, fe[be[ge]] = 2;
      switch (fe[be[0]] = 1, le) {
        case 1:
          break;
        case 3:
          if (be[0] === be[1] || be[0] === be[2] || be[1] === be[2])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          break;
        case 2:
          if (be[0] === be[1])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          fe[be[1]] = 1;
          break;
        case 4:
          if (be[0] === be[1] || be[0] === be[2] || be[0] === be[3] || be[1] === be[2] || be[1] === be[3] || be[2] === be[3])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          ae.readBits(1) ? (fe[be[2]] = 3, fe[be[3]] = 3) : fe[be[0]] = 2;
          break;
      }
    } else {
      var ge, ve = new Uint8Array(I), he = 32, ye = 0, Ce = [
        new d(2, 0),
        new d(2, 4),
        new d(2, 3),
        new d(3, 2),
        new d(2, 0),
        new d(2, 4),
        new d(2, 3),
        new d(4, 1),
        new d(2, 0),
        new d(2, 4),
        new d(2, 3),
        new d(3, 2),
        new d(2, 0),
        new d(2, 4),
        new d(2, 3),
        new d(4, 5)
      ];
      for (ge = ie; ge < I && he > 0; ++ge) {
        var xe = _[ge], we = 0, $e;
        ae.fillBitWindow(), we += ae.val_ >>> ae.bit_pos_ & 15, ae.bit_pos_ += Ce[we].bits, $e = Ce[we].value, ve[xe] = $e, $e !== 0 && (he -= 32 >> $e, ++ye);
      }
      if (!(ye === 1 || he === 0))
        throw new Error("[ReadHuffmanCode] invalid num_codes or space");
      G(ve, Q, fe, ae);
    }
    if (se = p(J, te, S, fe, Q), se === 0)
      throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return se;
  }
  function k(Q, J, te) {
    var ae, se;
    return ae = j(Q, J, te), se = A.kBlockLengthPrefixCode[ae].nbits, A.kBlockLengthPrefixCode[ae].offset + te.readBits(se);
  }
  function N(Q, J, te) {
    var ae;
    return Q < E ? (te += R[Q], te &= 3, ae = J[te] + O[Q]) : ae = Q - E + 1, ae;
  }
  function P(Q, J) {
    for (var te = Q[J], ae = J; ae; --ae) Q[ae] = Q[ae - 1];
    Q[0] = te;
  }
  function D(Q, J) {
    var te = new Uint8Array(256), ae;
    for (ae = 0; ae < 256; ++ae)
      te[ae] = ae;
    for (ae = 0; ae < J; ++ae) {
      var se = Q[ae];
      Q[ae] = te[se], se && P(te, se);
    }
  }
  function H(Q, J) {
    this.alphabet_size = Q, this.num_htrees = J, this.codes = new Array(J + J * L[Q + 31 >>> 5]), this.htrees = new Uint32Array(J);
  }
  H.prototype.decode = function(Q) {
    var J, te, ae = 0;
    for (J = 0; J < this.num_htrees; ++J)
      this.htrees[J] = ae, te = U(this.alphabet_size, this.codes, ae, Q), ae += te;
  };
  function V(Q, J) {
    var te = { num_htrees: null, context_map: null }, ae, se = 0, ie, fe;
    J.readMoreInput();
    var ge = te.num_htrees = F(J) + 1, me = te.context_map = new Uint8Array(Q);
    if (ge <= 1)
      return te;
    for (ae = J.readBits(1), ae && (se = J.readBits(4) + 1), ie = [], fe = 0; fe < T; fe++)
      ie[fe] = new d(0, 0);
    for (U(ge + se, ie, 0, J), fe = 0; fe < Q; ) {
      var pe;
      if (J.readMoreInput(), pe = j(ie, 0, J), pe === 0)
        me[fe] = 0, ++fe;
      else if (pe <= se)
        for (var be = 1 + (1 << pe) + J.readBits(pe); --be; ) {
          if (fe >= Q)
            throw new Error("[DecodeContextMap] i >= context_map_size");
          me[fe] = 0, ++fe;
        }
      else
        me[fe] = pe - se, ++fe;
    }
    return J.readBits(1) && D(me, Q), te;
  }
  function Z(Q, J, te, ae, se, ie, fe) {
    var ge = te * 2, me = te, pe = j(J, te * T, fe), be;
    pe === 0 ? be = se[ge + (ie[me] & 1)] : pe === 1 ? be = se[ge + (ie[me] - 1 & 1)] + 1 : be = pe - 2, be >= Q && (be -= Q), ae[te] = be, se[ge + (ie[me] & 1)] = be, ++ie[me];
  }
  function ne(Q, J, te, ae, se, ie) {
    var fe = se + 1, ge = te & se, me = ie.pos_ & c.IBUF_MASK, pe;
    if (J < 8 || ie.bit_pos_ + (J << 3) < ie.bit_end_pos_) {
      for (; J-- > 0; )
        ie.readMoreInput(), ae[ge++] = ie.readBits(8), ge === fe && (Q.write(ae, fe), ge = 0);
      return;
    }
    if (ie.bit_end_pos_ < 32)
      throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
    for (; ie.bit_pos_ < 32; )
      ae[ge] = ie.val_ >>> ie.bit_pos_, ie.bit_pos_ += 8, ++ge, --J;
    if (pe = ie.bit_end_pos_ - ie.bit_pos_ >> 3, me + pe > c.IBUF_MASK) {
      for (var be = c.IBUF_MASK + 1 - me, le = 0; le < be; le++)
        ae[ge + le] = ie.buf_[me + le];
      pe -= be, ge += be, J -= be, me = 0;
    }
    for (var le = 0; le < pe; le++)
      ae[ge + le] = ie.buf_[me + le];
    if (ge += pe, J -= pe, ge >= fe) {
      Q.write(ae, fe), ge -= fe;
      for (var le = 0; le < ge; le++)
        ae[le] = ae[fe + le];
    }
    for (; ge + J >= fe; ) {
      if (pe = fe - ge, ie.input_.read(ae, ge, pe) < pe)
        throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
      Q.write(ae, fe), J -= pe, ge = 0;
    }
    if (ie.input_.read(ae, ge, J) < J)
      throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
    ie.reset();
  }
  function K(Q) {
    var J = Q.bit_pos_ + 7 & -8, te = Q.readBits(J - Q.bit_pos_);
    return te == 0;
  }
  function q(Q) {
    var J = new a(Q), te = new c(J);
    B(te);
    var ae = W(te);
    return ae.meta_block_length;
  }
  decode.BrotliDecompressedSize = q;
  function Y(Q, J) {
    var te = new a(Q);
    J == null && (J = q(Q));
    var ae = new Uint8Array(J), se = new s(ae);
    return ee(te, se), se.pos < se.buffer.length && (se.buffer = se.buffer.subarray(0, se.pos)), se.buffer;
  }
  decode.BrotliDecompressBuffer = Y;
  function ee(Q, J) {
    var te, ae = 0, se = 0, ie = 0, fe, ge = 0, me, pe, be, le, ve = [16, 15, 11, 4], he = 0, ye = 0, Ce = 0, xe = [new H(0, 0), new H(0, 0), new H(0, 0)], we, $e, Ae, ue = 128 + c.READ_SIZE;
    Ae = new c(Q), ie = B(Ae), fe = (1 << ie) - 16, me = 1 << ie, pe = me - 1, be = new Uint8Array(me + ue + u.maxDictionaryWordLength), le = me, we = [], $e = [];
    for (var ce = 0; ce < 3 * T; ce++)
      we[ce] = new d(0, 0), $e[ce] = new d(0, 0);
    for (; !se; ) {
      var Ee = 0, _e, Te = [1 << 28, 1 << 28, 1 << 28], ke = [0], Re = [1, 1, 1], Be = [0, 1, 0, 1, 0, 1], Oe = [0], Me, Fe, Ue, je, Le = null, De = null, Ne, Ge = null, Xe, nt = 0, ct = null, it = 0, We = 0, Ve = null, ut = 0, at = 0, Qe = 0, st, ft;
      for (te = 0; te < 3; ++te)
        xe[te].codes = null, xe[te].htrees = null;
      Ae.readMoreInput();
      var vt = W(Ae);
      if (Ee = vt.meta_block_length, ae + Ee > J.buffer.length) {
        var Pt = new Uint8Array(ae + Ee);
        Pt.set(J.buffer), J.buffer = Pt;
      }
      if (se = vt.input_end, _e = vt.is_uncompressed, vt.is_metadata) {
        for (K(Ae); Ee > 0; --Ee)
          Ae.readMoreInput(), Ae.readBits(8);
        continue;
      }
      if (Ee !== 0) {
        if (_e) {
          Ae.bit_pos_ = Ae.bit_pos_ + 7 & -8, ne(
            J,
            Ee,
            ae,
            be,
            pe,
            Ae
          ), ae += Ee;
          continue;
        }
        for (te = 0; te < 3; ++te)
          Re[te] = F(Ae) + 1, Re[te] >= 2 && (U(Re[te] + 2, we, te * T, Ae), U(m, $e, te * T, Ae), Te[te] = k($e, te * T, Ae), Oe[te] = 1);
        for (Ae.readMoreInput(), Me = Ae.readBits(2), Fe = E + (Ae.readBits(4) << Me), Ue = (1 << Me) - 1, je = Fe + (48 << Me), De = new Uint8Array(Re[0]), te = 0; te < Re[0]; ++te)
          Ae.readMoreInput(), De[te] = Ae.readBits(2) << 1;
        var dt = V(Re[0] << C, Ae);
        Ne = dt.num_htrees, Le = dt.context_map;
        var mt = V(Re[2] << w, Ae);
        for (Xe = mt.num_htrees, Ge = mt.context_map, xe[0] = new H(y, Ne), xe[1] = new H(f, Re[1]), xe[2] = new H(je, Xe), te = 0; te < 3; ++te)
          xe[te].decode(Ae);
        for (ct = 0, Ve = 0, st = De[ke[0]], at = v.lookupOffsets[st], Qe = v.lookupOffsets[st + 1], ft = xe[1].htrees[0]; Ee > 0; ) {
          var pt, Et, Mt, Nt, _t, Ot, rt, et, Ye, tt, Ke;
          for (Ae.readMoreInput(), Te[1] === 0 && (Z(
            Re[1],
            we,
            1,
            ke,
            Be,
            Oe,
            Ae
          ), Te[1] = k($e, T, Ae), ft = xe[1].htrees[ke[1]]), --Te[1], pt = j(xe[1].codes, ft, Ae), Et = pt >> 6, Et >= 2 ? (Et -= 2, rt = -1) : rt = 0, Mt = A.kInsertRangeLut[Et] + (pt >> 3 & 7), Nt = A.kCopyRangeLut[Et] + (pt & 7), _t = A.kInsertLengthPrefixCode[Mt].offset + Ae.readBits(A.kInsertLengthPrefixCode[Mt].nbits), Ot = A.kCopyLengthPrefixCode[Nt].offset + Ae.readBits(A.kCopyLengthPrefixCode[Nt].nbits), ye = be[ae - 1 & pe], Ce = be[ae - 2 & pe], tt = 0; tt < _t; ++tt)
            Ae.readMoreInput(), Te[0] === 0 && (Z(
              Re[0],
              we,
              0,
              ke,
              Be,
              Oe,
              Ae
            ), Te[0] = k($e, 0, Ae), nt = ke[0] << C, ct = nt, st = De[ke[0]], at = v.lookupOffsets[st], Qe = v.lookupOffsets[st + 1]), Ye = v.lookup[at + ye] | v.lookup[Qe + Ce], it = Le[ct + Ye], --Te[0], Ce = ye, ye = j(xe[0].codes, xe[0].htrees[it], Ae), be[ae & pe] = ye, (ae & pe) === pe && J.write(be, me), ++ae;
          if (Ee -= _t, Ee <= 0) break;
          if (rt < 0) {
            var Ye;
            if (Ae.readMoreInput(), Te[2] === 0 && (Z(
              Re[2],
              we,
              2,
              ke,
              Be,
              Oe,
              Ae
            ), Te[2] = k($e, 2 * T, Ae), We = ke[2] << w, Ve = We), --Te[2], Ye = (Ot > 4 ? 3 : Ot - 2) & 255, ut = Ge[Ve + Ye], rt = j(xe[2].codes, xe[2].htrees[ut], Ae), rt >= Fe) {
              var qe, ot, Je;
              rt -= Fe, ot = rt & Ue, rt >>= Me, qe = (rt >> 1) + 1, Je = (2 + (rt & 1) << qe) - 4, rt = Fe + (Je + Ae.readBits(qe) << Me) + ot;
            }
          }
          if (et = N(rt, ve, he), et < 0)
            throw new Error("[BrotliDecompress] invalid distance");
          if (ae < fe && ge !== fe ? ge = ae : ge = fe, Ke = ae & pe, et > ge)
            if (Ot >= u.minDictionaryWordLength && Ot <= u.maxDictionaryWordLength) {
              var Je = u.offsetsByLength[Ot], Ct = et - ge - 1, Tt = u.sizeBitsByLength[Ot], yt = (1 << Tt) - 1, bt = Ct & yt, It = Ct >> Tt;
              if (Je += bt * Ot, It < x.kNumTransforms) {
                var kt = x.transformDictionaryWord(be, Ke, Je, Ot, It);
                if (Ke += kt, ae += kt, Ee -= kt, Ke >= le) {
                  J.write(be, me);
                  for (var $t = 0; $t < Ke - le; $t++)
                    be[$t] = be[le + $t];
                }
              } else
                throw new Error("Invalid backward reference. pos: " + ae + " distance: " + et + " len: " + Ot + " bytes left: " + Ee);
            } else
              throw new Error("Invalid backward reference. pos: " + ae + " distance: " + et + " len: " + Ot + " bytes left: " + Ee);
          else {
            if (rt > 0 && (ve[he & 3] = et, ++he), Ot > Ee)
              throw new Error("Invalid backward reference. pos: " + ae + " distance: " + et + " len: " + Ot + " bytes left: " + Ee);
            for (tt = 0; tt < Ot; ++tt)
              be[ae & pe] = be[ae - et & pe], (ae & pe) === pe && J.write(be, me), ++ae, --Ee;
          }
          ye = be[ae - 1 & pe], Ce = be[ae - 2 & pe];
        }
        ae &= 1073741823;
      }
    }
    J.write(be, ae & pe);
  }
  return decode.BrotliDecompress = ee, u.init(), decode;
}
var decompress, hasRequiredDecompress;
function requireDecompress() {
  return hasRequiredDecompress || (hasRequiredDecompress = 1, decompress = requireDecode().BrotliDecompressBuffer), decompress;
}
var decompressExports = requireDecompress();
const $6uUbQ$brotlidecompressjs = /* @__PURE__ */ getDefaultExportFromCjs(decompressExports);
function $parcel$export(a, s, c, u) {
  Object.defineProperty(a, s, { get: c, set: u, enumerable: !0, configurable: !0 });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $d636bc798e7178db$exports = {};
$parcel$export($d636bc798e7178db$exports, "logErrors", () => $d636bc798e7178db$export$bd5c5d8b8dcafd78);
$parcel$export($d636bc798e7178db$exports, "registerFormat", () => $d636bc798e7178db$export$36b2f24e97d43be);
$parcel$export($d636bc798e7178db$exports, "create", () => $d636bc798e7178db$export$185802fd694ee1f5);
$parcel$export($d636bc798e7178db$exports, "defaultLanguage", () => $d636bc798e7178db$export$42940898df819940);
$parcel$export($d636bc798e7178db$exports, "setDefaultLanguage", () => $d636bc798e7178db$export$5157e7780d44cc36);
let $d636bc798e7178db$export$bd5c5d8b8dcafd78 = !1, $d636bc798e7178db$var$formats = [];
function $d636bc798e7178db$export$36b2f24e97d43be(a) {
  $d636bc798e7178db$var$formats.push(a);
}
function $d636bc798e7178db$export$185802fd694ee1f5(a, s) {
  for (let c = 0; c < $d636bc798e7178db$var$formats.length; c++) {
    let u = $d636bc798e7178db$var$formats[c];
    if (u.probe(a)) {
      let d = new u(new DecodeStream(a));
      return s ? d.getFont(s) : d;
    }
  }
  throw new Error("Unknown font format");
}
let $d636bc798e7178db$export$42940898df819940 = "en";
function $d636bc798e7178db$export$5157e7780d44cc36(a = "en") {
  $d636bc798e7178db$export$42940898df819940 = a;
}
function $e71565f2ce09cb6b$export$69a3209f1a06c04d(a, s, c) {
  if (c.get) {
    let u = c.get;
    c.get = function() {
      let d = u.call(this);
      return Object.defineProperty(this, s, {
        value: d
      }), d;
    };
  } else if (typeof c.value == "function") {
    let u = c.value;
    return {
      get() {
        let d = /* @__PURE__ */ new Map();
        function p(...v) {
          let A = v.length > 0 ? v[0] : "value";
          if (d.has(A)) return d.get(A);
          let x = u.apply(this, v);
          return d.set(A, x), x;
        }
        return Object.defineProperty(this, s, {
          value: p
        }), p;
      }
    };
  }
}
let $26a62205ad06574e$var$SubHeader = new Struct({
  firstCode: uint16,
  entryCount: uint16,
  idDelta: int16,
  idRangeOffset: uint16
}), $26a62205ad06574e$var$CmapGroup = new Struct({
  startCharCode: uint32,
  endCharCode: uint32,
  glyphID: uint32
}), $26a62205ad06574e$var$UnicodeValueRange = new Struct({
  startUnicodeValue: uint24,
  additionalCount: uint8
}), $26a62205ad06574e$var$UVSMapping = new Struct({
  unicodeValue: uint24,
  glyphID: uint16
}), $26a62205ad06574e$var$DefaultUVS = new ArrayT($26a62205ad06574e$var$UnicodeValueRange, uint32), $26a62205ad06574e$var$NonDefaultUVS = new ArrayT($26a62205ad06574e$var$UVSMapping, uint32), $26a62205ad06574e$var$VarSelectorRecord = new Struct({
  varSelector: uint24,
  defaultUVS: new Pointer(uint32, $26a62205ad06574e$var$DefaultUVS, {
    type: "parent"
  }),
  nonDefaultUVS: new Pointer(uint32, $26a62205ad06574e$var$NonDefaultUVS, {
    type: "parent"
  })
}), $26a62205ad06574e$var$CmapSubtable = new VersionedStruct(uint16, {
  0: {
    length: uint16,
    language: uint16,
    codeMap: new LazyArray(uint8, 256)
  },
  2: {
    length: uint16,
    language: uint16,
    subHeaderKeys: new ArrayT(uint16, 256),
    subHeaderCount: (a) => Math.max.apply(Math, a.subHeaderKeys),
    subHeaders: new LazyArray($26a62205ad06574e$var$SubHeader, "subHeaderCount"),
    glyphIndexArray: new LazyArray(uint16, "subHeaderCount")
  },
  4: {
    length: uint16,
    language: uint16,
    segCountX2: uint16,
    segCount: (a) => a.segCountX2 >> 1,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16,
    endCode: new LazyArray(uint16, "segCount"),
    reservedPad: new Reserved(uint16),
    startCode: new LazyArray(uint16, "segCount"),
    idDelta: new LazyArray(int16, "segCount"),
    idRangeOffset: new LazyArray(uint16, "segCount"),
    glyphIndexArray: new LazyArray(uint16, (a) => (a.length - a._currentOffset) / 2)
  },
  6: {
    length: uint16,
    language: uint16,
    firstCode: uint16,
    entryCount: uint16,
    glyphIndices: new LazyArray(uint16, "entryCount")
  },
  8: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint16,
    is32: new LazyArray(uint8, 8192),
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  10: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    firstCode: uint32,
    entryCount: uint32,
    glyphIndices: new LazyArray(uint16, "numChars")
  },
  12: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  13: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  14: {
    length: uint32,
    numRecords: uint32,
    varSelectors: new LazyArray($26a62205ad06574e$var$VarSelectorRecord, "numRecords")
  }
}), $26a62205ad06574e$var$CmapEntry = new Struct({
  platformID: uint16,
  encodingID: uint16,
  table: new Pointer(uint32, $26a62205ad06574e$var$CmapSubtable, {
    type: "parent",
    lazy: !0
  })
});
var $26a62205ad06574e$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numSubtables: uint16,
  tables: new ArrayT($26a62205ad06574e$var$CmapEntry, "numSubtables")
}), $f2612a29f92ac062$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  revision: int32,
  checkSumAdjustment: uint32,
  magicNumber: uint32,
  flags: uint16,
  unitsPerEm: uint16,
  created: new ArrayT(int32, 2),
  modified: new ArrayT(int32, 2),
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16,
  macStyle: new Bitfield(uint16, [
    "bold",
    "italic",
    "underline",
    "outline",
    "shadow",
    "condensed",
    "extended"
  ]),
  lowestRecPPEM: uint16,
  fontDirectionHint: int16,
  indexToLocFormat: int16,
  glyphDataFormat: int16
  // 0 for current format
}), $2c179dd593583073$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  ascent: int16,
  descent: int16,
  lineGap: int16,
  advanceWidthMax: uint16,
  minLeftSideBearing: int16,
  minRightSideBearing: int16,
  xMaxExtent: int16,
  caretSlopeRise: int16,
  caretSlopeRun: int16,
  caretOffset: int16,
  reserved: new Reserved(int16, 4),
  metricDataFormat: int16,
  numberOfMetrics: uint16
  // Number of advance widths in 'hmtx' table
});
let $bdc9060542264b85$var$HmtxEntry = new Struct({
  advance: uint16,
  bearing: int16
});
var $bdc9060542264b85$export$2e2bcd8739ae039 = new Struct({
  metrics: new LazyArray($bdc9060542264b85$var$HmtxEntry, (a) => a.parent.hhea.numberOfMetrics),
  bearings: new LazyArray(int16, (a) => a.parent.maxp.numGlyphs - a.parent.hhea.numberOfMetrics)
}), $dbf51cb3d3fe409d$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  numGlyphs: uint16,
  maxPoints: uint16,
  maxContours: uint16,
  maxComponentPoints: uint16,
  maxComponentContours: uint16,
  maxZones: uint16,
  maxTwilightPoints: uint16,
  maxStorage: uint16,
  maxFunctionDefs: uint16,
  maxInstructionDefs: uint16,
  maxStackElements: uint16,
  maxSizeOfInstructions: uint16,
  maxComponentElements: uint16,
  maxComponentDepth: uint16
  // Maximum levels of recursion; 1 for simple components
});
function $e449ad78d50845fe$export$badc544e0651b6b1(a, s, c = 0) {
  return a === 1 && $e449ad78d50845fe$export$479e671907f486d1[c] ? $e449ad78d50845fe$export$479e671907f486d1[c] : $e449ad78d50845fe$export$6fef87b7618bdf0b[a][s];
}
const $e449ad78d50845fe$var$SINGLE_BYTE_ENCODINGS = /* @__PURE__ */ new Set([
  "x-mac-roman",
  "x-mac-cyrillic",
  "iso-8859-6",
  "iso-8859-8"
]), $e449ad78d50845fe$var$MAC_ENCODINGS = {
  "x-mac-croatian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ",
  "x-mac-gaelic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ",
  "x-mac-greek": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­",
  "x-mac-icelandic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-inuit": "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł",
  "x-mac-ce": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
  "x-mac-romanian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-turkish": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
}, $e449ad78d50845fe$var$encodingCache = /* @__PURE__ */ new Map();
function $e449ad78d50845fe$export$1dceb3c14ed68bee(a) {
  let s = $e449ad78d50845fe$var$encodingCache.get(a);
  if (s) return s;
  let c = $e449ad78d50845fe$var$MAC_ENCODINGS[a];
  if (c) {
    let u = /* @__PURE__ */ new Map();
    for (let d = 0; d < c.length; d++) u.set(c.charCodeAt(d), 128 + d);
    return $e449ad78d50845fe$var$encodingCache.set(a, u), u;
  }
  if ($e449ad78d50845fe$var$SINGLE_BYTE_ENCODINGS.has(a)) {
    let u = new TextDecoder(a), d = new Uint8Array(128);
    for (let A = 0; A < 128; A++) d[A] = 128 + A;
    let p = /* @__PURE__ */ new Map(), v = u.decode(d);
    for (let A = 0; A < 128; A++) p.set(v.charCodeAt(A), 128 + A);
    return $e449ad78d50845fe$var$encodingCache.set(a, p), p;
  }
}
const $e449ad78d50845fe$export$6fef87b7618bdf0b = [
  // unicode
  [
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be"
  ],
  // macintosh
  // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
  // 0	Roman                 17	Malayalam
  // 1	Japanese	            18	Sinhalese
  // 2	Traditional Chinese	  19	Burmese
  // 3	Korean	              20	Khmer
  // 4	Arabic	              21	Thai
  // 5	Hebrew	              22	Laotian
  // 6	Greek	                23	Georgian
  // 7	Russian	              24	Armenian
  // 8	RSymbol	              25	Simplified Chinese
  // 9	Devanagari	          26	Tibetan
  // 10	Gurmukhi	            27	Mongolian
  // 11	Gujarati	            28	Geez
  // 12	Oriya	                29	Slavic
  // 13	Bengali	              30	Vietnamese
  // 14	Tamil	                31	Sindhi
  // 15	Telugu	              32	(Uninterpreted)
  // 16	Kannada
  [
    "x-mac-roman",
    "shift-jis",
    "big5",
    "euc-kr",
    "iso-8859-6",
    "iso-8859-8",
    "x-mac-greek",
    "x-mac-cyrillic",
    "x-mac-symbol",
    "x-mac-devanagari",
    "x-mac-gurmukhi",
    "x-mac-gujarati",
    "Oriya",
    "Bengali",
    "Tamil",
    "Telugu",
    "Kannada",
    "Malayalam",
    "Sinhalese",
    "Burmese",
    "Khmer",
    "iso-8859-11",
    "Laotian",
    "Georgian",
    "Armenian",
    "gbk",
    "Tibetan",
    "Mongolian",
    "Geez",
    "x-mac-ce",
    "Vietnamese",
    "Sindhi"
  ],
  // ISO (deprecated)
  [
    "ascii",
    null,
    "iso-8859-1"
  ],
  // windows
  // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
  [
    "symbol",
    "utf-16be",
    "shift-jis",
    "gb18030",
    "big5",
    "euc-kr",
    "johab",
    null,
    null,
    null,
    "utf-16be"
  ]
], $e449ad78d50845fe$export$479e671907f486d1 = {
  15: "x-mac-icelandic",
  17: "x-mac-turkish",
  18: "x-mac-croatian",
  24: "x-mac-ce",
  25: "x-mac-ce",
  26: "x-mac-ce",
  27: "x-mac-ce",
  28: "x-mac-ce",
  30: "x-mac-icelandic",
  37: "x-mac-romanian",
  38: "x-mac-ce",
  39: "x-mac-ce",
  40: "x-mac-ce",
  143: "x-mac-inuit",
  146: "x-mac-gaelic"
}, $e449ad78d50845fe$export$2092376fd002e13 = [
  // unicode
  [],
  {
    0: "en",
    30: "fo",
    60: "ks",
    90: "rw",
    1: "fr",
    31: "fa",
    61: "ku",
    91: "rn",
    2: "de",
    32: "ru",
    62: "sd",
    92: "ny",
    3: "it",
    33: "zh",
    63: "bo",
    93: "mg",
    4: "nl",
    34: "nl-BE",
    64: "ne",
    94: "eo",
    5: "sv",
    35: "ga",
    65: "sa",
    128: "cy",
    6: "es",
    36: "sq",
    66: "mr",
    129: "eu",
    7: "da",
    37: "ro",
    67: "bn",
    130: "ca",
    8: "pt",
    38: "cz",
    68: "as",
    131: "la",
    9: "no",
    39: "sk",
    69: "gu",
    132: "qu",
    10: "he",
    40: "si",
    70: "pa",
    133: "gn",
    11: "ja",
    41: "yi",
    71: "or",
    134: "ay",
    12: "ar",
    42: "sr",
    72: "ml",
    135: "tt",
    13: "fi",
    43: "mk",
    73: "kn",
    136: "ug",
    14: "el",
    44: "bg",
    74: "ta",
    137: "dz",
    15: "is",
    45: "uk",
    75: "te",
    138: "jv",
    16: "mt",
    46: "be",
    76: "si",
    139: "su",
    17: "tr",
    47: "uz",
    77: "my",
    140: "gl",
    18: "hr",
    48: "kk",
    78: "km",
    141: "af",
    19: "zh-Hant",
    49: "az-Cyrl",
    79: "lo",
    142: "br",
    20: "ur",
    50: "az-Arab",
    80: "vi",
    143: "iu",
    21: "hi",
    51: "hy",
    81: "id",
    144: "gd",
    22: "th",
    52: "ka",
    82: "tl",
    145: "gv",
    23: "ko",
    53: "mo",
    83: "ms",
    146: "ga",
    24: "lt",
    54: "ky",
    84: "ms-Arab",
    147: "to",
    25: "pl",
    55: "tg",
    85: "am",
    148: "el-polyton",
    26: "hu",
    56: "tk",
    86: "ti",
    149: "kl",
    27: "es",
    57: "mn-CN",
    87: "om",
    150: "az",
    28: "lv",
    58: "mn",
    88: "so",
    151: "nn",
    29: "se",
    59: "ps",
    89: "sw"
  },
  // ISO (deprecated)
  [],
  {
    1078: "af",
    16393: "en-IN",
    1159: "rw",
    1074: "tn",
    1052: "sq",
    6153: "en-IE",
    1089: "sw",
    1115: "si",
    1156: "gsw",
    8201: "en-JM",
    1111: "kok",
    1051: "sk",
    1118: "am",
    17417: "en-MY",
    1042: "ko",
    1060: "sl",
    5121: "ar-DZ",
    5129: "en-NZ",
    1088: "ky",
    11274: "es-AR",
    15361: "ar-BH",
    13321: "en-PH",
    1108: "lo",
    16394: "es-BO",
    3073: "ar",
    18441: "en-SG",
    1062: "lv",
    13322: "es-CL",
    2049: "ar-IQ",
    7177: "en-ZA",
    1063: "lt",
    9226: "es-CO",
    11265: "ar-JO",
    11273: "en-TT",
    2094: "dsb",
    5130: "es-CR",
    13313: "ar-KW",
    2057: "en-GB",
    1134: "lb",
    7178: "es-DO",
    12289: "ar-LB",
    1033: "en",
    1071: "mk",
    12298: "es-EC",
    4097: "ar-LY",
    12297: "en-ZW",
    2110: "ms-BN",
    17418: "es-SV",
    6145: "ary",
    1061: "et",
    1086: "ms",
    4106: "es-GT",
    8193: "ar-OM",
    1080: "fo",
    1100: "ml",
    18442: "es-HN",
    16385: "ar-QA",
    1124: "fil",
    1082: "mt",
    2058: "es-MX",
    1025: "ar-SA",
    1035: "fi",
    1153: "mi",
    19466: "es-NI",
    10241: "ar-SY",
    2060: "fr-BE",
    1146: "arn",
    6154: "es-PA",
    7169: "aeb",
    3084: "fr-CA",
    1102: "mr",
    15370: "es-PY",
    14337: "ar-AE",
    1036: "fr",
    1148: "moh",
    10250: "es-PE",
    9217: "ar-YE",
    5132: "fr-LU",
    1104: "mn",
    20490: "es-PR",
    1067: "hy",
    6156: "fr-MC",
    2128: "mn-CN",
    3082: "es",
    1101: "as",
    4108: "fr-CH",
    1121: "ne",
    1034: "es",
    2092: "az-Cyrl",
    1122: "fy",
    1044: "nb",
    21514: "es-US",
    1068: "az",
    1110: "gl",
    2068: "nn",
    14346: "es-UY",
    1133: "ba",
    1079: "ka",
    1154: "oc",
    8202: "es-VE",
    1069: "eu",
    3079: "de-AT",
    1096: "or",
    2077: "sv-FI",
    1059: "be",
    1031: "de",
    1123: "ps",
    1053: "sv",
    2117: "bn",
    5127: "de-LI",
    1045: "pl",
    1114: "syr",
    1093: "bn-IN",
    4103: "de-LU",
    1046: "pt",
    1064: "tg",
    8218: "bs-Cyrl",
    2055: "de-CH",
    2070: "pt-PT",
    2143: "tzm",
    5146: "bs",
    1032: "el",
    1094: "pa",
    1097: "ta",
    1150: "br",
    1135: "kl",
    1131: "qu-BO",
    1092: "tt",
    1026: "bg",
    1095: "gu",
    2155: "qu-EC",
    1098: "te",
    1027: "ca",
    1128: "ha",
    3179: "qu",
    1054: "th",
    3076: "zh-HK",
    1037: "he",
    1048: "ro",
    1105: "bo",
    5124: "zh-MO",
    1081: "hi",
    1047: "rm",
    1055: "tr",
    2052: "zh",
    1038: "hu",
    1049: "ru",
    1090: "tk",
    4100: "zh-SG",
    1039: "is",
    9275: "smn",
    1152: "ug",
    1028: "zh-TW",
    1136: "ig",
    4155: "smj-NO",
    1058: "uk",
    1155: "co",
    1057: "id",
    5179: "smj",
    1070: "hsb",
    1050: "hr",
    1117: "iu",
    3131: "se-FI",
    1056: "ur",
    4122: "hr-BA",
    2141: "iu-Latn",
    1083: "se",
    2115: "uz-Cyrl",
    1029: "cs",
    2108: "ga",
    2107: "se-SE",
    1091: "uz",
    1030: "da",
    1076: "xh",
    8251: "sms",
    1066: "vi",
    1164: "prs",
    1077: "zu",
    6203: "sma-NO",
    1106: "cy",
    1125: "dv",
    1040: "it",
    7227: "sms",
    1160: "wo",
    2067: "nl-BE",
    2064: "it-CH",
    1103: "sa",
    1157: "sah",
    1043: "nl",
    1041: "ja",
    7194: "sr-Cyrl-BA",
    1144: "ii",
    3081: "en-AU",
    1099: "kn",
    3098: "sr",
    1130: "yo",
    10249: "en-BZ",
    1087: "kk",
    6170: "sr-Latn-BA",
    4105: "en-CA",
    1107: "km",
    2074: "sr-Latn",
    9225: "en-029",
    1158: "quc",
    1132: "nso"
  }
];
let $2bcf221753ec8e32$var$NameRecord = new Struct({
  platformID: uint16,
  encodingID: uint16,
  languageID: uint16,
  nameID: uint16,
  length: uint16,
  string: new Pointer(uint16, new StringT("length", (a) => $e449ad78d50845fe$export$badc544e0651b6b1(a.platformID, a.encodingID, a.languageID)), {
    type: "parent",
    relativeTo: (a) => a.parent.stringOffset,
    allowNull: !1
  })
}), $2bcf221753ec8e32$var$LangTagRecord = new Struct({
  length: uint16,
  tag: new Pointer(uint16, new StringT("length", "utf16be"), {
    type: "parent",
    relativeTo: (a) => a.stringOffset
  })
});
var $2bcf221753ec8e32$var$NameTable = new VersionedStruct(uint16, {
  0: {
    count: uint16,
    stringOffset: uint16,
    records: new ArrayT($2bcf221753ec8e32$var$NameRecord, "count")
  },
  1: {
    count: uint16,
    stringOffset: uint16,
    records: new ArrayT($2bcf221753ec8e32$var$NameRecord, "count"),
    langTagCount: uint16,
    langTags: new ArrayT($2bcf221753ec8e32$var$LangTagRecord, "langTagCount")
  }
}), $2bcf221753ec8e32$export$2e2bcd8739ae039 = $2bcf221753ec8e32$var$NameTable;
const $2bcf221753ec8e32$var$NAMES = [
  "copyright",
  "fontFamily",
  "fontSubfamily",
  "uniqueSubfamily",
  "fullName",
  "version",
  "postscriptName",
  "trademark",
  "manufacturer",
  "designer",
  "description",
  "vendorURL",
  "designerURL",
  "license",
  "licenseURL",
  null,
  "preferredFamily",
  "preferredSubfamily",
  "compatibleFull",
  "sampleText",
  "postscriptCIDFontName",
  "wwsFamilyName",
  "wwsSubfamilyName"
];
$2bcf221753ec8e32$var$NameTable.process = function(a) {
  var s = {};
  for (let c of this.records) {
    let u = $e449ad78d50845fe$export$2092376fd002e13[c.platformID][c.languageID];
    u == null && this.langTags != null && c.languageID >= 32768 && (u = this.langTags[c.languageID - 32768].tag), u == null && (u = c.platformID + "-" + c.languageID);
    let d = c.nameID >= 256 ? "fontFeatures" : $2bcf221753ec8e32$var$NAMES[c.nameID] || c.nameID;
    s[d] == null && (s[d] = {});
    let p = s[d];
    c.nameID >= 256 && (p = p[c.nameID] || (p[c.nameID] = {})), (typeof c.string == "string" || typeof p[u] != "string") && (p[u] = c.string);
  }
  this.records = s;
};
$2bcf221753ec8e32$var$NameTable.preEncode = function() {
  if (Array.isArray(this.records)) return;
  this.version = 0;
  let a = [];
  for (let s in this.records) {
    let c = this.records[s];
    s !== "fontFeatures" && (a.push({
      platformID: 3,
      encodingID: 1,
      languageID: 1033,
      nameID: $2bcf221753ec8e32$var$NAMES.indexOf(s),
      length: c.en.length * 2,
      string: c.en
    }), s === "postscriptName" && a.push({
      platformID: 1,
      encodingID: 0,
      languageID: 0,
      nameID: $2bcf221753ec8e32$var$NAMES.indexOf(s),
      length: c.en.length,
      string: c.en
    }));
  }
  this.records = a, this.count = a.length, this.stringOffset = $2bcf221753ec8e32$var$NameTable.size(this, null, !1);
};
var $84b272aa31b70606$var$OS2 = new VersionedStruct(uint16, {
  header: {
    xAvgCharWidth: int16,
    usWeightClass: uint16,
    usWidthClass: uint16,
    fsType: new Bitfield(uint16, [
      null,
      "noEmbedding",
      "viewOnly",
      "editable",
      null,
      null,
      null,
      null,
      "noSubsetting",
      "bitmapOnly"
    ]),
    ySubscriptXSize: int16,
    ySubscriptYSize: int16,
    ySubscriptXOffset: int16,
    ySubscriptYOffset: int16,
    ySuperscriptXSize: int16,
    ySuperscriptYSize: int16,
    ySuperscriptXOffset: int16,
    ySuperscriptYOffset: int16,
    yStrikeoutSize: int16,
    yStrikeoutPosition: int16,
    sFamilyClass: int16,
    panose: new ArrayT(uint8, 10),
    ulCharRange: new ArrayT(uint32, 4),
    vendorID: new StringT(4),
    fsSelection: new Bitfield(uint16, [
      "italic",
      "underscore",
      "negative",
      "outlined",
      "strikeout",
      "bold",
      "regular",
      "useTypoMetrics",
      "wws",
      "oblique"
    ]),
    usFirstCharIndex: uint16,
    usLastCharIndex: uint16
    // The maximum Unicode index in this font
  },
  // The Apple version of this table ends here, but the Microsoft one continues on...
  0: {},
  1: {
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2)
  },
  2: {
    // these should be common with version 1 somehow
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2),
    xHeight: int16,
    capHeight: int16,
    defaultChar: uint16,
    breakChar: uint16,
    maxContent: uint16
  },
  5: {
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2),
    xHeight: int16,
    capHeight: int16,
    defaultChar: uint16,
    breakChar: uint16,
    maxContent: uint16,
    usLowerOpticalPointSize: uint16,
    usUpperOpticalPointSize: uint16
  }
});
let $84b272aa31b70606$var$versions = $84b272aa31b70606$var$OS2.versions;
$84b272aa31b70606$var$versions[3] = $84b272aa31b70606$var$versions[4] = $84b272aa31b70606$var$versions[2];
var $84b272aa31b70606$export$2e2bcd8739ae039 = $84b272aa31b70606$var$OS2, $32d9e2eb9565d93c$export$2e2bcd8739ae039 = new VersionedStruct(fixed32, {
  header: {
    italicAngle: fixed32,
    underlinePosition: int16,
    underlineThickness: int16,
    isFixedPitch: uint32,
    minMemType42: uint32,
    maxMemType42: uint32,
    minMemType1: uint32,
    maxMemType1: uint32
    // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
  },
  1: {},
  2: {
    numberOfGlyphs: uint16,
    glyphNameIndex: new ArrayT(uint16, "numberOfGlyphs"),
    names: new ArrayT(new StringT(uint8))
  },
  2.5: {
    numberOfGlyphs: uint16,
    offsets: new ArrayT(uint8, "numberOfGlyphs")
  },
  3: {},
  4: {
    map: new ArrayT(uint32, (a) => a.parent.maxp.numGlyphs)
  }
}), $5202bd9d9ad8eaac$export$2e2bcd8739ae039 = new Struct({
  controlValues: new ArrayT(int16)
}), $5c0f37ca5ffb1850$export$2e2bcd8739ae039 = new Struct({
  instructions: new ArrayT(uint8)
});
let $2b2b260902b1c57e$var$loca = new VersionedStruct("head.indexToLocFormat", {
  0: {
    offsets: new ArrayT(uint16)
  },
  1: {
    offsets: new ArrayT(uint32)
  }
});
$2b2b260902b1c57e$var$loca.process = function() {
  if (this.version === 0 && !this._processed) {
    for (let a = 0; a < this.offsets.length; a++) this.offsets[a] <<= 1;
    this._processed = !0;
  }
};
$2b2b260902b1c57e$var$loca.preEncode = function() {
  if (this.version === 0 && this._processed !== !1) {
    for (let a = 0; a < this.offsets.length; a++) this.offsets[a] >>>= 1;
    this._processed = !1;
  }
};
var $2b2b260902b1c57e$export$2e2bcd8739ae039 = $2b2b260902b1c57e$var$loca, $7afb878c7bea4f66$export$2e2bcd8739ae039 = new Struct({
  controlValueProgram: new ArrayT(uint8)
}), $6c92b6371bce8bd9$export$2e2bcd8739ae039 = new ArrayT(new BufferT());
class $43e9821ef3717eec$export$2e2bcd8739ae039 {
  getCFFVersion(s) {
    for (; s && !s.hdrSize; ) s = s.parent;
    return s ? s.version : -1;
  }
  decode(s, c) {
    let d = this.getCFFVersion(c) >= 2 ? s.readUInt32BE() : s.readUInt16BE();
    if (d === 0) return [];
    let p = s.readUInt8(), v;
    if (p === 1) v = uint8;
    else if (p === 2) v = uint16;
    else if (p === 3) v = uint24;
    else if (p === 4) v = uint32;
    else throw new Error(`Bad offset size in CFFIndex: ${p} ${s.pos}`);
    let A = [], x = s.pos + (d + 1) * p - 1, g = v.decode(s);
    for (let b = 0; b < d; b++) {
      let y = v.decode(s);
      if (this.type != null) {
        let f = s.pos;
        s.pos = x + g, c.length = y - g, A.push(this.type.decode(s, c)), s.pos = f;
      } else A.push({
        offset: x + g,
        length: y - g
      });
      g = y;
    }
    return s.pos = x + g, A;
  }
  size(s, c) {
    let u = 2;
    if (s.length === 0) return u;
    let d = this.type || new BufferT(), p = 1;
    for (let A = 0; A < s.length; A++) {
      let x = s[A];
      p += d.size(x, c);
    }
    let v;
    if (p <= 255) v = uint8;
    else if (p <= 65535) v = uint16;
    else if (p <= 16777215) v = uint24;
    else if (p <= 4294967295) v = uint32;
    else throw new Error("Bad offset in CFFIndex");
    return u += 1 + v.size() * (s.length + 1), u += p - 1, u;
  }
  encode(s, c, u) {
    if (s.writeUInt16BE(c.length), c.length === 0) return;
    let d = this.type || new BufferT(), p = [], v = 1;
    for (let x of c) {
      let g = d.size(x, u);
      p.push(g), v += g;
    }
    let A;
    if (v <= 255) A = uint8;
    else if (v <= 65535) A = uint16;
    else if (v <= 16777215) A = uint24;
    else if (v <= 4294967295) A = uint32;
    else throw new Error("Bad offset in CFFIndex");
    s.writeUInt8(A.size()), v = 1, A.encode(s, v);
    for (let x of p)
      v += x, A.encode(s, v);
    for (let x of c) d.encode(s, x, u);
  }
  constructor(s) {
    this.type = s;
  }
}
const $c2d28e92708f99da$var$FLOAT_EOF = 15, $c2d28e92708f99da$var$FLOAT_LOOKUP = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  "E",
  "E-",
  null,
  "-"
], $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP = {
  ".": 10,
  E: 11,
  "E-": 12,
  "-": 14
};
class $c2d28e92708f99da$export$2e2bcd8739ae039 {
  static decode(s, c) {
    if (32 <= c && c <= 246) return c - 139;
    if (247 <= c && c <= 250) return (c - 247) * 256 + s.readUInt8() + 108;
    if (251 <= c && c <= 254) return -(c - 251) * 256 - s.readUInt8() - 108;
    if (c === 28) return s.readInt16BE();
    if (c === 29) return s.readInt32BE();
    if (c === 30) {
      let u = "";
      for (; ; ) {
        let d = s.readUInt8(), p = d >> 4;
        if (p === $c2d28e92708f99da$var$FLOAT_EOF) break;
        u += $c2d28e92708f99da$var$FLOAT_LOOKUP[p];
        let v = d & 15;
        if (v === $c2d28e92708f99da$var$FLOAT_EOF) break;
        u += $c2d28e92708f99da$var$FLOAT_LOOKUP[v];
      }
      return parseFloat(u);
    }
    return null;
  }
  static size(s) {
    if (s.forceLarge && (s = 32768), (s | 0) !== s) {
      let c = "" + s;
      return 1 + Math.ceil((c.length + 1) / 2);
    } else return -107 <= s && s <= 107 ? 1 : 108 <= s && s <= 1131 || -1131 <= s && s <= -108 ? 2 : -32768 <= s && s <= 32767 ? 3 : 5;
  }
  static encode(s, c) {
    let u = Number(c);
    if (c.forceLarge)
      return s.writeUInt8(29), s.writeInt32BE(u);
    if ((u | 0) !== u) {
      s.writeUInt8(30);
      let p = "" + u;
      for (let v = 0; v < p.length; v += 2) {
        let A = p[v], x = $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP[A] || +A;
        if (v === p.length - 1) var d = $c2d28e92708f99da$var$FLOAT_EOF;
        else {
          let g = p[v + 1];
          var d = $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP[g] || +g;
        }
        s.writeUInt8(x << 4 | d & 15);
      }
      if (d !== $c2d28e92708f99da$var$FLOAT_EOF) return s.writeUInt8($c2d28e92708f99da$var$FLOAT_EOF << 4);
    } else return -107 <= u && u <= 107 ? s.writeUInt8(u + 139) : 108 <= u && u <= 1131 ? (u -= 108, s.writeUInt8((u >> 8) + 247), s.writeUInt8(u & 255)) : -1131 <= u && u <= -108 ? (u = -u - 108, s.writeUInt8((u >> 8) + 251), s.writeUInt8(u & 255)) : -32768 <= u && u <= 32767 ? (s.writeUInt8(28), s.writeInt16BE(u)) : (s.writeUInt8(29), s.writeInt32BE(u));
  }
}
class $61aa549f16d58b9b$export$2e2bcd8739ae039 {
  decodeOperands(s, c, u, d) {
    if (Array.isArray(s)) return d.map((p, v) => this.decodeOperands(s[v], c, u, [
      p
    ]));
    if (s.decode != null) return s.decode(c, u, d);
    switch (s) {
      case "number":
      case "offset":
      case "sid":
        return d[0];
      case "boolean":
        return !!d[0];
      default:
        return d;
    }
  }
  encodeOperands(s, c, u, d) {
    return Array.isArray(s) ? d.map((p, v) => this.encodeOperands(s[v], c, u, p)[0]) : s.encode != null ? s.encode(c, d, u) : typeof d == "number" ? [
      d
    ] : typeof d == "boolean" ? [
      +d
    ] : Array.isArray(d) ? d : [
      d
    ];
  }
  decode(s, c) {
    let u = s.pos + c.length, d = {}, p = [];
    Object.defineProperties(d, {
      parent: {
        value: c
      },
      _startOffset: {
        value: s.pos
      }
    });
    for (let v in this.fields) {
      let A = this.fields[v];
      d[A[1]] = A[3];
    }
    for (; s.pos < u; ) {
      let v = s.readUInt8();
      if (v < 28) {
        v === 12 && (v = v << 8 | s.readUInt8());
        let A = this.fields[v];
        if (!A) throw new Error(`Unknown operator ${v}`);
        let x = this.decodeOperands(A[2], s, d, p);
        x != null && (x instanceof PropertyDescriptor ? Object.defineProperty(d, A[1], x) : d[A[1]] = x), p = [];
      } else p.push($c2d28e92708f99da$export$2e2bcd8739ae039.decode(s, v));
    }
    return d;
  }
  size(s, c, u = !0) {
    let d = {
      parent: c,
      val: s,
      pointerSize: 0,
      startOffset: c.startOffset || 0
    }, p = 0;
    for (let v in this.fields) {
      let A = this.fields[v], x = s[A[1]];
      if (x == null || $6uUbQ$fastdeepequal(x, A[3])) continue;
      let g = this.encodeOperands(A[2], null, d, x);
      for (let y of g) p += $c2d28e92708f99da$export$2e2bcd8739ae039.size(y);
      let b = Array.isArray(A[0]) ? A[0] : [
        A[0]
      ];
      p += b.length;
    }
    return u && (p += d.pointerSize), p;
  }
  encode(s, c, u) {
    let d = {
      pointers: [],
      startOffset: s.pos,
      parent: u,
      val: c,
      pointerSize: 0
    };
    d.pointerOffset = s.pos + this.size(c, d, !1);
    for (let v of this.ops) {
      let A = c[v[1]];
      if (A == null || $6uUbQ$fastdeepequal(A, v[3])) continue;
      let x = this.encodeOperands(v[2], s, d, A);
      for (let b of x) $c2d28e92708f99da$export$2e2bcd8739ae039.encode(s, b);
      let g = Array.isArray(v[0]) ? v[0] : [
        v[0]
      ];
      for (let b of g) s.writeUInt8(b);
    }
    let p = 0;
    for (; p < d.pointers.length; ) {
      let v = d.pointers[p++];
      v.type.encode(s, v.val, v.parent);
    }
  }
  constructor(s = []) {
    this.ops = s, this.fields = {};
    for (let c of s) {
      let u = Array.isArray(c[0]) ? c[0][0] << 8 | c[0][1] : c[0];
      this.fields[u] = c;
    }
  }
}
class $0e34a43d05bde82c$export$2e2bcd8739ae039 extends Pointer {
  decode(s, c, u) {
    return this.offsetType = {
      decode: () => u[0]
    }, super.decode(s, c, u);
  }
  encode(s, c, u) {
    if (!s)
      return this.offsetType = {
        size: () => 0
      }, this.size(c, u), [
        new $0e34a43d05bde82c$var$Ptr(0)
      ];
    let d = null;
    return this.offsetType = {
      encode: (p, v) => d = v
    }, super.encode(s, c, u), [
      new $0e34a43d05bde82c$var$Ptr(d)
    ];
  }
  constructor(s, c = {}) {
    c.type == null && (c.type = "global"), super(null, s, c);
  }
}
class $0e34a43d05bde82c$var$Ptr {
  valueOf() {
    return this.val;
  }
  constructor(s) {
    this.val = s, this.forceLarge = !0;
  }
}
class $6d59db2e29cc77b3$var$CFFBlendOp {
  static decode(s, c, u) {
    let d = u.pop();
    for (; u.length > d; ) u.pop();
  }
}
var $6d59db2e29cc77b3$export$2e2bcd8739ae039 = new $61aa549f16d58b9b$export$2e2bcd8739ae039([
  // key       name                    type                                          default
  [
    6,
    "BlueValues",
    "delta",
    null
  ],
  [
    7,
    "OtherBlues",
    "delta",
    null
  ],
  [
    8,
    "FamilyBlues",
    "delta",
    null
  ],
  [
    9,
    "FamilyOtherBlues",
    "delta",
    null
  ],
  [
    [
      12,
      9
    ],
    "BlueScale",
    "number",
    0.039625
  ],
  [
    [
      12,
      10
    ],
    "BlueShift",
    "number",
    7
  ],
  [
    [
      12,
      11
    ],
    "BlueFuzz",
    "number",
    1
  ],
  [
    10,
    "StdHW",
    "number",
    null
  ],
  [
    11,
    "StdVW",
    "number",
    null
  ],
  [
    [
      12,
      12
    ],
    "StemSnapH",
    "delta",
    null
  ],
  [
    [
      12,
      13
    ],
    "StemSnapV",
    "delta",
    null
  ],
  [
    [
      12,
      14
    ],
    "ForceBold",
    "boolean",
    !1
  ],
  [
    [
      12,
      17
    ],
    "LanguageGroup",
    "number",
    0
  ],
  [
    [
      12,
      18
    ],
    "ExpansionFactor",
    "number",
    0.06
  ],
  [
    [
      12,
      19
    ],
    "initialRandomSeed",
    "number",
    0
  ],
  [
    20,
    "defaultWidthX",
    "number",
    0
  ],
  [
    21,
    "nominalWidthX",
    "number",
    0
  ],
  [
    22,
    "vsindex",
    "number",
    0
  ],
  [
    23,
    "blend",
    $6d59db2e29cc77b3$var$CFFBlendOp,
    null
  ],
  [
    19,
    "Subrs",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039(), {
      type: "local"
    }),
    null
  ]
]), $229224aec43783c5$export$2e2bcd8739ae039 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
];
let $bc0433d9b7e41f5f$export$dee0027060fa13bd = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
], $bc0433d9b7e41f5f$export$4f58f497e14a53c3 = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], $ef658f5c9a1488b2$export$c33b50336c234f16 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron"
], $ef658f5c9a1488b2$export$3ed0f9e1fee8d489 = [
  ".notdef",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], $ef658f5c9a1488b2$export$dc28be11139d4120 = [
  ".notdef",
  "space",
  "dollaroldstyle",
  "dollarsuperior",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "hyphensuperior",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "centoldstyle",
  "figuredash",
  "hypheninferior",
  "onequarter",
  "onehalf",
  "threequarters",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior"
], $7cbbe4e24ef3cb75$var$LangSysTable = new Struct({
  reserved: new Reserved(uint16),
  reqFeatureIndex: uint16,
  featureCount: uint16,
  featureIndexes: new ArrayT(uint16, "featureCount")
}), $7cbbe4e24ef3cb75$var$LangSysRecord = new Struct({
  tag: new StringT(4),
  langSys: new Pointer(uint16, $7cbbe4e24ef3cb75$var$LangSysTable, {
    type: "parent"
  })
}), $7cbbe4e24ef3cb75$var$Script = new Struct({
  defaultLangSys: new Pointer(uint16, $7cbbe4e24ef3cb75$var$LangSysTable),
  count: uint16,
  langSysRecords: new ArrayT($7cbbe4e24ef3cb75$var$LangSysRecord, "count")
}), $7cbbe4e24ef3cb75$var$ScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $7cbbe4e24ef3cb75$var$Script, {
    type: "parent"
  })
}), $7cbbe4e24ef3cb75$export$3e15fc05ce864229 = new ArrayT($7cbbe4e24ef3cb75$var$ScriptRecord, uint16), $7cbbe4e24ef3cb75$var$FeatureParams = new Struct({
  version: uint16,
  nameID: uint16
}), $7cbbe4e24ef3cb75$export$6e91cf7616333d5 = new Struct({
  featureParams: new Pointer(uint16, $7cbbe4e24ef3cb75$var$FeatureParams),
  lookupCount: uint16,
  lookupListIndexes: new ArrayT(uint16, "lookupCount")
}), $7cbbe4e24ef3cb75$var$FeatureRecord = new Struct({
  tag: new StringT(4),
  feature: new Pointer(uint16, $7cbbe4e24ef3cb75$export$6e91cf7616333d5, {
    type: "parent"
  })
}), $7cbbe4e24ef3cb75$export$aa18130def4b6cb4 = new ArrayT($7cbbe4e24ef3cb75$var$FeatureRecord, uint16), $7cbbe4e24ef3cb75$var$LookupFlags = new Struct({
  markAttachmentType: uint8,
  flags: new Bitfield(uint8, [
    "rightToLeft",
    "ignoreBaseGlyphs",
    "ignoreLigatures",
    "ignoreMarks",
    "useMarkFilteringSet"
  ])
});
function $7cbbe4e24ef3cb75$export$df0008c6ff2da22a(a) {
  let s = new Struct({
    lookupType: uint16,
    flags: $7cbbe4e24ef3cb75$var$LookupFlags,
    subTableCount: uint16,
    subTables: new ArrayT(new Pointer(uint16, a), "subTableCount"),
    markFilteringSet: new Optional(uint16, (c) => c.flags.flags.useMarkFilteringSet)
  });
  return new LazyArray(new Pointer(uint16, s), uint16);
}
let $7cbbe4e24ef3cb75$var$RangeRecord = new Struct({
  start: uint16,
  end: uint16,
  startCoverageIndex: uint16
}), $7cbbe4e24ef3cb75$export$17608c3f81a6111 = new VersionedStruct(uint16, {
  1: {
    glyphCount: uint16,
    glyphs: new ArrayT(uint16, "glyphCount")
  },
  2: {
    rangeCount: uint16,
    rangeRecords: new ArrayT($7cbbe4e24ef3cb75$var$RangeRecord, "rangeCount")
  }
}), $7cbbe4e24ef3cb75$var$ClassRangeRecord = new Struct({
  start: uint16,
  end: uint16,
  class: uint16
}), $7cbbe4e24ef3cb75$export$843d551fbbafef71 = new VersionedStruct(uint16, {
  1: {
    startGlyph: uint16,
    glyphCount: uint16,
    classValueArray: new ArrayT(uint16, "glyphCount")
  },
  2: {
    classRangeCount: uint16,
    classRangeRecord: new ArrayT($7cbbe4e24ef3cb75$var$ClassRangeRecord, "classRangeCount")
  }
}), $7cbbe4e24ef3cb75$export$8215d14a63d9fb10 = new Struct({
  a: uint16,
  b: uint16,
  deltaFormat: uint16
}), $7cbbe4e24ef3cb75$var$LookupRecord = new Struct({
  sequenceIndex: uint16,
  lookupListIndex: uint16
}), $7cbbe4e24ef3cb75$var$Rule = new Struct({
  glyphCount: uint16,
  lookupCount: uint16,
  input: new ArrayT(uint16, (a) => a.glyphCount - 1),
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
}), $7cbbe4e24ef3cb75$var$RuleSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$Rule), uint16), $7cbbe4e24ef3cb75$var$ClassRule = new Struct({
  glyphCount: uint16,
  lookupCount: uint16,
  classes: new ArrayT(uint16, (a) => a.glyphCount - 1),
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
}), $7cbbe4e24ef3cb75$var$ClassSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ClassRule), uint16), $7cbbe4e24ef3cb75$export$841858b892ce1f4c = new VersionedStruct(uint16, {
  1: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    ruleSetCount: uint16,
    ruleSets: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$RuleSet), "ruleSetCount")
  },
  2: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    classSetCnt: uint16,
    classSet: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ClassSet), "classSetCnt")
  },
  3: {
    glyphCount: uint16,
    lookupCount: uint16,
    coverages: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "glyphCount"),
    lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
  }
}), $7cbbe4e24ef3cb75$var$ChainRule = new Struct({
  backtrackGlyphCount: uint16,
  backtrack: new ArrayT(uint16, "backtrackGlyphCount"),
  inputGlyphCount: uint16,
  input: new ArrayT(uint16, (a) => a.inputGlyphCount - 1),
  lookaheadGlyphCount: uint16,
  lookahead: new ArrayT(uint16, "lookaheadGlyphCount"),
  lookupCount: uint16,
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
}), $7cbbe4e24ef3cb75$var$ChainRuleSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRule), uint16), $7cbbe4e24ef3cb75$export$5e6d09e6861162f6 = new VersionedStruct(uint16, {
  1: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    chainCount: uint16,
    chainRuleSets: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRuleSet), "chainCount")
  },
  2: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    backtrackClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    inputClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    lookaheadClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    chainCount: uint16,
    chainClassSet: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRuleSet), "chainCount")
  },
  3: {
    backtrackGlyphCount: uint16,
    backtrackCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "backtrackGlyphCount"),
    inputGlyphCount: uint16,
    inputCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "inputGlyphCount"),
    lookaheadGlyphCount: uint16,
    lookaheadCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "lookaheadGlyphCount"),
    lookupCount: uint16,
    lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
  }
}), $1a47b0c45c1c22fe$var$F2DOT14 = new Fixed(16, "BE", 14), $1a47b0c45c1c22fe$var$RegionAxisCoordinates = new Struct({
  startCoord: $1a47b0c45c1c22fe$var$F2DOT14,
  peakCoord: $1a47b0c45c1c22fe$var$F2DOT14,
  endCoord: $1a47b0c45c1c22fe$var$F2DOT14
}), $1a47b0c45c1c22fe$var$VariationRegionList = new Struct({
  axisCount: uint16,
  regionCount: uint16,
  variationRegions: new ArrayT(new ArrayT($1a47b0c45c1c22fe$var$RegionAxisCoordinates, "axisCount"), "regionCount")
}), $1a47b0c45c1c22fe$var$DeltaSet = new Struct({
  shortDeltas: new ArrayT(int16, (a) => a.parent.shortDeltaCount),
  regionDeltas: new ArrayT(int8, (a) => a.parent.regionIndexCount - a.parent.shortDeltaCount),
  deltas: (a) => a.shortDeltas.concat(a.regionDeltas)
}), $1a47b0c45c1c22fe$var$ItemVariationData = new Struct({
  itemCount: uint16,
  shortDeltaCount: uint16,
  regionIndexCount: uint16,
  regionIndexes: new ArrayT(uint16, "regionIndexCount"),
  deltaSets: new ArrayT($1a47b0c45c1c22fe$var$DeltaSet, "itemCount")
}), $1a47b0c45c1c22fe$export$fe1b122a2710f241 = new Struct({
  format: uint16,
  variationRegionList: new Pointer(uint32, $1a47b0c45c1c22fe$var$VariationRegionList),
  variationDataCount: uint16,
  itemVariationData: new ArrayT(new Pointer(uint32, $1a47b0c45c1c22fe$var$ItemVariationData), "variationDataCount")
}), $1a47b0c45c1c22fe$var$ConditionTable = new VersionedStruct(uint16, {
  1: {
    axisIndex: uint16,
    axisIndex: uint16,
    filterRangeMinValue: $1a47b0c45c1c22fe$var$F2DOT14,
    filterRangeMaxValue: $1a47b0c45c1c22fe$var$F2DOT14
  }
}), $1a47b0c45c1c22fe$var$ConditionSet = new Struct({
  conditionCount: uint16,
  conditionTable: new ArrayT(new Pointer(uint32, $1a47b0c45c1c22fe$var$ConditionTable), "conditionCount")
}), $1a47b0c45c1c22fe$var$FeatureTableSubstitutionRecord = new Struct({
  featureIndex: uint16,
  alternateFeatureTable: new Pointer(uint32, $7cbbe4e24ef3cb75$export$6e91cf7616333d5, {
    type: "parent"
  })
}), $1a47b0c45c1c22fe$var$FeatureTableSubstitution = new Struct({
  version: fixed32,
  substitutionCount: uint16,
  substitutions: new ArrayT($1a47b0c45c1c22fe$var$FeatureTableSubstitutionRecord, "substitutionCount")
}), $1a47b0c45c1c22fe$var$FeatureVariationRecord = new Struct({
  conditionSet: new Pointer(uint32, $1a47b0c45c1c22fe$var$ConditionSet, {
    type: "parent"
  }),
  featureTableSubstitution: new Pointer(uint32, $1a47b0c45c1c22fe$var$FeatureTableSubstitution, {
    type: "parent"
  })
}), $1a47b0c45c1c22fe$export$441b70b7971dd419 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  featureVariationRecordCount: uint32,
  featureVariationRecords: new ArrayT($1a47b0c45c1c22fe$var$FeatureVariationRecord, "featureVariationRecordCount")
});
class $b84fd3dd9d8eddb2$var$PredefinedOp {
  decode(s, c, u) {
    return this.predefinedOps[u[0]] ? this.predefinedOps[u[0]] : this.type.decode(s, c, u);
  }
  size(s, c) {
    return this.type.size(s, c);
  }
  encode(s, c, u) {
    let d = this.predefinedOps.indexOf(c);
    return d !== -1 ? d : this.type.encode(s, c, u);
  }
  constructor(s, c) {
    this.predefinedOps = s, this.type = c;
  }
}
class $b84fd3dd9d8eddb2$var$CFFEncodingVersion extends NumberT {
  decode(s) {
    return uint8.decode(s) & 127;
  }
  constructor() {
    super("UInt8");
  }
}
let $b84fd3dd9d8eddb2$var$Range1 = new Struct({
  first: uint16,
  nLeft: uint8
}), $b84fd3dd9d8eddb2$var$Range2 = new Struct({
  first: uint16,
  nLeft: uint16
}), $b84fd3dd9d8eddb2$var$CFFCustomEncoding = new VersionedStruct(new $b84fd3dd9d8eddb2$var$CFFEncodingVersion(), {
  0: {
    nCodes: uint8,
    codes: new ArrayT(uint8, "nCodes")
  },
  1: {
    nRanges: uint8,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$Range1, "nRanges")
  }
}), $b84fd3dd9d8eddb2$var$CFFEncoding = new $b84fd3dd9d8eddb2$var$PredefinedOp([
  $bc0433d9b7e41f5f$export$dee0027060fa13bd,
  $bc0433d9b7e41f5f$export$4f58f497e14a53c3
], new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$CFFCustomEncoding, {
  lazy: !0
}));
class $b84fd3dd9d8eddb2$var$RangeArray extends ArrayT {
  decode(s, c) {
    let u = resolveLength(this.length, s, c), d = 0, p = [];
    for (; d < u; ) {
      let v = this.type.decode(s, c);
      v.offset = d, d += v.nLeft + 1, p.push(v);
    }
    return p;
  }
}
let $b84fd3dd9d8eddb2$var$CFFCustomCharset = new VersionedStruct(uint8, {
  0: {
    glyphs: new ArrayT(uint16, (a) => a.parent.CharStrings.length - 1)
  },
  1: {
    ranges: new $b84fd3dd9d8eddb2$var$RangeArray($b84fd3dd9d8eddb2$var$Range1, (a) => a.parent.CharStrings.length - 1)
  },
  2: {
    ranges: new $b84fd3dd9d8eddb2$var$RangeArray($b84fd3dd9d8eddb2$var$Range2, (a) => a.parent.CharStrings.length - 1)
  }
}), $b84fd3dd9d8eddb2$var$CFFCharset = new $b84fd3dd9d8eddb2$var$PredefinedOp([
  $ef658f5c9a1488b2$export$c33b50336c234f16,
  $ef658f5c9a1488b2$export$3ed0f9e1fee8d489,
  $ef658f5c9a1488b2$export$dc28be11139d4120
], new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$CFFCustomCharset, {
  lazy: !0
})), $b84fd3dd9d8eddb2$var$FDRange3 = new Struct({
  first: uint16,
  fd: uint8
}), $b84fd3dd9d8eddb2$var$FDRange4 = new Struct({
  first: uint32,
  fd: uint16
}), $b84fd3dd9d8eddb2$var$FDSelect = new VersionedStruct(uint8, {
  0: {
    fds: new ArrayT(uint8, (a) => a.parent.CharStrings.length)
  },
  3: {
    nRanges: uint16,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$FDRange3, "nRanges"),
    sentinel: uint16
  },
  4: {
    nRanges: uint32,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$FDRange4, "nRanges"),
    sentinel: uint32
  }
}), $b84fd3dd9d8eddb2$var$ptr = new $0e34a43d05bde82c$export$2e2bcd8739ae039($6d59db2e29cc77b3$export$2e2bcd8739ae039);
class $b84fd3dd9d8eddb2$var$CFFPrivateOp {
  decode(s, c, u) {
    return c.length = u[0], $b84fd3dd9d8eddb2$var$ptr.decode(s, c, [
      u[1]
    ]);
  }
  size(s, c) {
    return [
      $6d59db2e29cc77b3$export$2e2bcd8739ae039.size(s, c, !1),
      $b84fd3dd9d8eddb2$var$ptr.size(s, c)[0]
    ];
  }
  encode(s, c, u) {
    return [
      $6d59db2e29cc77b3$export$2e2bcd8739ae039.size(c, u, !1),
      $b84fd3dd9d8eddb2$var$ptr.encode(s, c, u)[0]
    ];
  }
}
let $b84fd3dd9d8eddb2$var$FontDict = new $61aa549f16d58b9b$export$2e2bcd8739ae039([
  // key       name                   type(s)                                 default
  [
    18,
    "Private",
    new $b84fd3dd9d8eddb2$var$CFFPrivateOp(),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ]
]), $b84fd3dd9d8eddb2$var$CFFTopDict = new $61aa549f16d58b9b$export$2e2bcd8739ae039([
  // key       name                   type(s)                                 default
  [
    [
      12,
      30
    ],
    "ROS",
    [
      "sid",
      "sid",
      "number"
    ],
    null
  ],
  [
    0,
    "version",
    "sid",
    null
  ],
  [
    1,
    "Notice",
    "sid",
    null
  ],
  [
    [
      12,
      0
    ],
    "Copyright",
    "sid",
    null
  ],
  [
    2,
    "FullName",
    "sid",
    null
  ],
  [
    3,
    "FamilyName",
    "sid",
    null
  ],
  [
    4,
    "Weight",
    "sid",
    null
  ],
  [
    [
      12,
      1
    ],
    "isFixedPitch",
    "boolean",
    !1
  ],
  [
    [
      12,
      2
    ],
    "ItalicAngle",
    "number",
    0
  ],
  [
    [
      12,
      3
    ],
    "UnderlinePosition",
    "number",
    -100
  ],
  [
    [
      12,
      4
    ],
    "UnderlineThickness",
    "number",
    50
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ],
  [
    [
      12,
      6
    ],
    "CharstringType",
    "number",
    2
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    13,
    "UniqueID",
    "number",
    null
  ],
  [
    5,
    "FontBBox",
    "array",
    [
      0,
      0,
      0,
      0
    ]
  ],
  [
    [
      12,
      8
    ],
    "StrokeWidth",
    "number",
    0
  ],
  [
    14,
    "XUID",
    "array",
    null
  ],
  [
    15,
    "charset",
    $b84fd3dd9d8eddb2$var$CFFCharset,
    $ef658f5c9a1488b2$export$c33b50336c234f16
  ],
  [
    16,
    "Encoding",
    $b84fd3dd9d8eddb2$var$CFFEncoding,
    $bc0433d9b7e41f5f$export$dee0027060fa13bd
  ],
  [
    17,
    "CharStrings",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039()),
    null
  ],
  [
    18,
    "Private",
    new $b84fd3dd9d8eddb2$var$CFFPrivateOp(),
    null
  ],
  [
    [
      12,
      20
    ],
    "SyntheticBase",
    "number",
    null
  ],
  [
    [
      12,
      21
    ],
    "PostScript",
    "sid",
    null
  ],
  [
    [
      12,
      22
    ],
    "BaseFontName",
    "sid",
    null
  ],
  [
    [
      12,
      23
    ],
    "BaseFontBlend",
    "delta",
    null
  ],
  // CID font specific
  [
    [
      12,
      31
    ],
    "CIDFontVersion",
    "number",
    0
  ],
  [
    [
      12,
      32
    ],
    "CIDFontRevision",
    "number",
    0
  ],
  [
    [
      12,
      33
    ],
    "CIDFontType",
    "number",
    0
  ],
  [
    [
      12,
      34
    ],
    "CIDCount",
    "number",
    8720
  ],
  [
    [
      12,
      35
    ],
    "UIDBase",
    "number",
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$FDSelect),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$FontDict)),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ]
]), $b84fd3dd9d8eddb2$var$VariationStore = new Struct({
  length: uint16,
  itemVariationStore: $1a47b0c45c1c22fe$export$fe1b122a2710f241
}), $b84fd3dd9d8eddb2$var$CFF2TopDict = new $61aa549f16d58b9b$export$2e2bcd8739ae039([
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    17,
    "CharStrings",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039()),
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$FDSelect),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$FontDict)),
    null
  ],
  [
    24,
    "vstore",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$VariationStore),
    null
  ],
  [
    25,
    "maxstack",
    "number",
    193
  ]
]), $b84fd3dd9d8eddb2$var$CFFTop = new VersionedStruct(fixed16, {
  1: {
    hdrSize: uint8,
    offSize: uint8,
    nameIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039(new StringT("length")),
    topDictIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$CFFTopDict),
    stringIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039(new StringT("length")),
    globalSubrIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039()
  },
  2: {
    hdrSize: uint8,
    length: uint16,
    topDict: $b84fd3dd9d8eddb2$var$CFF2TopDict,
    globalSubrIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039()
  }
});
var $b84fd3dd9d8eddb2$export$2e2bcd8739ae039 = $b84fd3dd9d8eddb2$var$CFFTop;
class $822ac0d589e4e237$var$CFFFont {
  static decode(s) {
    return new $822ac0d589e4e237$var$CFFFont(s);
  }
  decode() {
    this.stream.pos;
    let s = $b84fd3dd9d8eddb2$export$2e2bcd8739ae039.decode(this.stream);
    for (let c in s) {
      let u = s[c];
      this[c] = u;
    }
    if (this.version < 2) {
      if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
      this.topDict = this.topDictIndex[0];
    }
    return this.isCIDFont = this.topDict.ROS != null, this;
  }
  string(s) {
    return this.version >= 2 ? null : s < $229224aec43783c5$export$2e2bcd8739ae039.length ? $229224aec43783c5$export$2e2bcd8739ae039[s] : this.stringIndex[s - $229224aec43783c5$export$2e2bcd8739ae039.length];
  }
  get postscriptName() {
    return this.version < 2 ? this.nameIndex[0] : null;
  }
  get fullName() {
    return this.string(this.topDict.FullName);
  }
  get familyName() {
    return this.string(this.topDict.FamilyName);
  }
  getCharString(s) {
    return this.stream.pos = this.topDict.CharStrings[s].offset, this.stream.readBuffer(this.topDict.CharStrings[s].length);
  }
  getGlyphName(s) {
    if (this.version >= 2 || this.isCIDFont) return null;
    let { charset: c } = this.topDict;
    if (Array.isArray(c)) return c[s];
    if (s === 0) return ".notdef";
    switch (s -= 1, c.version) {
      case 0:
        return this.string(c.glyphs[s]);
      case 1:
      case 2:
        for (let u = 0; u < c.ranges.length; u++) {
          let d = c.ranges[u];
          if (d.offset <= s && s <= d.offset + d.nLeft) return this.string(d.first + (s - d.offset));
        }
        break;
    }
    return null;
  }
  fdForGlyph(s) {
    if (!this.topDict.FDSelect) return null;
    switch (this.topDict.FDSelect.version) {
      case 0:
        return this.topDict.FDSelect.fds[s];
      case 3:
      case 4:
        let { ranges: c } = this.topDict.FDSelect, u = 0, d = c.length - 1;
        for (; u <= d; ) {
          let p = u + d >> 1;
          if (s < c[p].first) d = p - 1;
          else if (p < d && s >= c[p + 1].first) u = p + 1;
          else return c[p].fd;
        }
      default:
        throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
    }
  }
  privateDictForGlyph(s) {
    if (this.topDict.FDSelect) {
      let c = this.fdForGlyph(s);
      return this.topDict.FDArray[c] ? this.topDict.FDArray[c].Private : null;
    }
    return this.version < 2 ? this.topDict.Private : this.topDict.FDArray[0].Private;
  }
  constructor(s) {
    this.stream = s, this.decode();
  }
}
var $822ac0d589e4e237$export$2e2bcd8739ae039 = $822ac0d589e4e237$var$CFFFont;
let $2bbf2bc1ce37cd8f$var$VerticalOrigin = new Struct({
  glyphIndex: uint16,
  vertOriginY: int16
});
var $2bbf2bc1ce37cd8f$export$2e2bcd8739ae039 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  defaultVertOriginY: int16,
  numVertOriginYMetrics: uint16,
  metrics: new ArrayT($2bbf2bc1ce37cd8f$var$VerticalOrigin, "numVertOriginYMetrics")
});
let $0941618dc22a946d$export$16b227cb15d716a0 = new Struct({
  height: uint8,
  width: uint8,
  horiBearingX: int8,
  horiBearingY: int8,
  horiAdvance: uint8,
  vertBearingX: int8,
  vertBearingY: int8,
  vertAdvance: uint8
}), $0941618dc22a946d$export$62c53e75f69bfe12 = new Struct({
  height: uint8,
  width: uint8,
  bearingX: int8,
  bearingY: int8,
  advance: uint8
}), $0941618dc22a946d$var$EBDTComponent = new Struct({
  glyph: uint16,
  xOffset: int8,
  yOffset: int8
});
class $0941618dc22a946d$var$ByteAligned {
}
class $0941618dc22a946d$var$BitAligned {
}
new VersionedStruct("version", {
  1: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    data: $0941618dc22a946d$var$ByteAligned
  },
  2: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    data: $0941618dc22a946d$var$BitAligned
  },
  // format 3 is deprecated
  // format 4 is not supported by Microsoft
  5: {
    data: $0941618dc22a946d$var$BitAligned
  },
  6: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    data: $0941618dc22a946d$var$ByteAligned
  },
  7: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    data: $0941618dc22a946d$var$BitAligned
  },
  8: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    pad: new Reserved(uint8),
    numComponents: uint16,
    components: new ArrayT($0941618dc22a946d$var$EBDTComponent, "numComponents")
  },
  9: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    pad: new Reserved(uint8),
    numComponents: uint16,
    components: new ArrayT($0941618dc22a946d$var$EBDTComponent, "numComponents")
  },
  17: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    dataLen: uint32,
    data: new BufferT("dataLen")
  },
  18: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    dataLen: uint32,
    data: new BufferT("dataLen")
  },
  19: {
    dataLen: uint32,
    data: new BufferT("dataLen")
  }
});
let $9911c4c7201c13de$var$SBitLineMetrics = new Struct({
  ascender: int8,
  descender: int8,
  widthMax: uint8,
  caretSlopeNumerator: int8,
  caretSlopeDenominator: int8,
  caretOffset: int8,
  minOriginSB: int8,
  minAdvanceSB: int8,
  maxBeforeBL: int8,
  minAfterBL: int8,
  pad: new Reserved(int8, 2)
}), $9911c4c7201c13de$var$CodeOffsetPair = new Struct({
  glyphCode: uint16,
  offset: uint16
}), $9911c4c7201c13de$var$IndexSubtable = new VersionedStruct(uint16, {
  header: {
    imageFormat: uint16,
    imageDataOffset: uint32
  },
  1: {
    offsetArray: new ArrayT(uint32, (a) => a.parent.lastGlyphIndex - a.parent.firstGlyphIndex + 1)
  },
  2: {
    imageSize: uint32,
    bigMetrics: $0941618dc22a946d$export$16b227cb15d716a0
  },
  3: {
    offsetArray: new ArrayT(uint16, (a) => a.parent.lastGlyphIndex - a.parent.firstGlyphIndex + 1)
  },
  4: {
    numGlyphs: uint32,
    glyphArray: new ArrayT($9911c4c7201c13de$var$CodeOffsetPair, (a) => a.numGlyphs + 1)
  },
  5: {
    imageSize: uint32,
    bigMetrics: $0941618dc22a946d$export$16b227cb15d716a0,
    numGlyphs: uint32,
    glyphCodeArray: new ArrayT(uint16, "numGlyphs")
  }
}), $9911c4c7201c13de$var$IndexSubtableArray = new Struct({
  firstGlyphIndex: uint16,
  lastGlyphIndex: uint16,
  subtable: new Pointer(uint32, $9911c4c7201c13de$var$IndexSubtable)
}), $9911c4c7201c13de$var$BitmapSizeTable = new Struct({
  indexSubTableArray: new Pointer(uint32, new ArrayT($9911c4c7201c13de$var$IndexSubtableArray, 1), {
    type: "parent"
  }),
  indexTablesSize: uint32,
  numberOfIndexSubTables: uint32,
  colorRef: uint32,
  hori: $9911c4c7201c13de$var$SBitLineMetrics,
  vert: $9911c4c7201c13de$var$SBitLineMetrics,
  startGlyphIndex: uint16,
  endGlyphIndex: uint16,
  ppemX: uint8,
  ppemY: uint8,
  bitDepth: uint8,
  flags: new Bitfield(uint8, [
    "horizontal",
    "vertical"
  ])
});
var $9911c4c7201c13de$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  numSizes: uint32,
  sizes: new ArrayT($9911c4c7201c13de$var$BitmapSizeTable, "numSizes")
});
let $abb847051efd51b1$var$ImageTable = new Struct({
  ppem: uint16,
  resolution: uint16,
  imageOffsets: new ArrayT(new Pointer(uint32, "void"), (a) => a.parent.parent.maxp.numGlyphs + 1)
});
var $abb847051efd51b1$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  flags: new Bitfield(uint16, [
    "renderOutlines"
  ]),
  numImgTables: uint32,
  imageTables: new ArrayT(new Pointer(uint32, $abb847051efd51b1$var$ImageTable), "numImgTables")
});
let $eb629188f3dfefdd$var$LayerRecord = new Struct({
  gid: uint16,
  paletteIndex: uint16
  // Index value to use in the appropriate palette. This value must
}), $eb629188f3dfefdd$var$BaseGlyphRecord = new Struct({
  gid: uint16,
  // and is not rendered for color.
  firstLayerIndex: uint16,
  // There will be numLayers consecutive entries for this base glyph.
  numLayers: uint16
});
var $eb629188f3dfefdd$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numBaseGlyphRecords: uint16,
  baseGlyphRecord: new Pointer(uint32, new ArrayT($eb629188f3dfefdd$var$BaseGlyphRecord, "numBaseGlyphRecords")),
  layerRecords: new Pointer(uint32, new ArrayT($eb629188f3dfefdd$var$LayerRecord, "numLayerRecords"), {
    lazy: !0
  }),
  numLayerRecords: uint16
});
let $08734b8e7dc64587$var$ColorRecord = new Struct({
  blue: uint8,
  green: uint8,
  red: uint8,
  alpha: uint8
});
var $08734b8e7dc64587$export$2e2bcd8739ae039 = new VersionedStruct(uint16, {
  header: {
    numPaletteEntries: uint16,
    numPalettes: uint16,
    numColorRecords: uint16,
    colorRecords: new Pointer(uint32, new ArrayT($08734b8e7dc64587$var$ColorRecord, "numColorRecords")),
    colorRecordIndices: new ArrayT(uint16, "numPalettes")
  },
  0: {},
  1: {
    offsetPaletteTypeArray: new Pointer(uint32, new ArrayT(uint32, "numPalettes")),
    offsetPaletteLabelArray: new Pointer(uint32, new ArrayT(uint16, "numPalettes")),
    offsetPaletteEntryLabelArray: new Pointer(uint32, new ArrayT(uint16, "numPaletteEntries"))
  }
});
let $497cef411d884e34$var$BaseCoord = new VersionedStruct(uint16, {
  1: {
    coordinate: int16
    // X or Y value, in design units
  },
  2: {
    coordinate: int16,
    referenceGlyph: uint16,
    baseCoordPoint: uint16
    // Index of contour point on the referenceGlyph
  },
  3: {
    coordinate: int16,
    deviceTable: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10)
    // Device table for X or Y value
  }
}), $497cef411d884e34$var$BaseValues = new Struct({
  defaultIndex: uint16,
  baseCoordCount: uint16,
  baseCoords: new ArrayT(new Pointer(uint16, $497cef411d884e34$var$BaseCoord), "baseCoordCount")
}), $497cef411d884e34$var$FeatMinMaxRecord = new Struct({
  tag: new StringT(4),
  minCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord, {
    type: "parent"
  }),
  maxCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord, {
    type: "parent"
  })
  // May be NULL
}), $497cef411d884e34$var$MinMax = new Struct({
  minCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord),
  maxCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord),
  featMinMaxCount: uint16,
  featMinMaxRecords: new ArrayT($497cef411d884e34$var$FeatMinMaxRecord, "featMinMaxCount")
  // In alphabetical order
}), $497cef411d884e34$var$BaseLangSysRecord = new Struct({
  tag: new StringT(4),
  minMax: new Pointer(uint16, $497cef411d884e34$var$MinMax, {
    type: "parent"
  })
}), $497cef411d884e34$var$BaseScript = new Struct({
  baseValues: new Pointer(uint16, $497cef411d884e34$var$BaseValues),
  defaultMinMax: new Pointer(uint16, $497cef411d884e34$var$MinMax),
  baseLangSysCount: uint16,
  baseLangSysRecords: new ArrayT($497cef411d884e34$var$BaseLangSysRecord, "baseLangSysCount")
  // in alphabetical order by BaseLangSysTag
}), $497cef411d884e34$var$BaseScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $497cef411d884e34$var$BaseScript, {
    type: "parent"
  })
}), $497cef411d884e34$var$BaseScriptList = new ArrayT($497cef411d884e34$var$BaseScriptRecord, uint16), $497cef411d884e34$var$BaseTagList = new ArrayT(new StringT(4), uint16), $497cef411d884e34$var$Axis = new Struct({
  baseTagList: new Pointer(uint16, $497cef411d884e34$var$BaseTagList),
  baseScriptList: new Pointer(uint16, $497cef411d884e34$var$BaseScriptList)
});
var $497cef411d884e34$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    horizAxis: new Pointer(uint16, $497cef411d884e34$var$Axis),
    vertAxis: new Pointer(uint16, $497cef411d884e34$var$Axis)
    // May be NULL
  },
  65536: {},
  65537: {
    itemVariationStore: new Pointer(uint32, $1a47b0c45c1c22fe$export$fe1b122a2710f241)
  }
});
let $cf5f33c63ef209e6$var$AttachPoint = new ArrayT(uint16, uint16), $cf5f33c63ef209e6$var$AttachList = new Struct({
  coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
  glyphCount: uint16,
  attachPoints: new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$AttachPoint), "glyphCount")
}), $cf5f33c63ef209e6$var$CaretValue = new VersionedStruct(uint16, {
  1: {
    coordinate: int16
  },
  2: {
    caretValuePoint: uint16
  },
  3: {
    coordinate: int16,
    deviceTable: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10)
  }
}), $cf5f33c63ef209e6$var$LigGlyph = new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$CaretValue), uint16), $cf5f33c63ef209e6$var$LigCaretList = new Struct({
  coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
  ligGlyphCount: uint16,
  ligGlyphs: new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$LigGlyph), "ligGlyphCount")
}), $cf5f33c63ef209e6$var$MarkGlyphSetsDef = new Struct({
  markSetTableFormat: uint16,
  markSetCount: uint16,
  coverage: new ArrayT(new Pointer(uint32, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "markSetCount")
});
var $cf5f33c63ef209e6$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    glyphClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    attachList: new Pointer(uint16, $cf5f33c63ef209e6$var$AttachList),
    ligCaretList: new Pointer(uint16, $cf5f33c63ef209e6$var$LigCaretList),
    markAttachClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71)
  },
  65536: {},
  65538: {
    markGlyphSetsDef: new Pointer(uint16, $cf5f33c63ef209e6$var$MarkGlyphSetsDef)
  },
  65539: {
    markGlyphSetsDef: new Pointer(uint16, $cf5f33c63ef209e6$var$MarkGlyphSetsDef),
    itemVariationStore: new Pointer(uint32, $1a47b0c45c1c22fe$export$fe1b122a2710f241)
  }
});
let $47e0e8ef515d9903$var$ValueFormat = new Bitfield(uint16, [
  "xPlacement",
  "yPlacement",
  "xAdvance",
  "yAdvance",
  "xPlaDevice",
  "yPlaDevice",
  "xAdvDevice",
  "yAdvDevice"
]), $47e0e8ef515d9903$var$types = {
  xPlacement: int16,
  yPlacement: int16,
  xAdvance: int16,
  yAdvance: int16,
  xPlaDevice: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
    type: "global",
    relativeTo: (a) => a.rel
  }),
  yPlaDevice: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
    type: "global",
    relativeTo: (a) => a.rel
  }),
  xAdvDevice: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
    type: "global",
    relativeTo: (a) => a.rel
  }),
  yAdvDevice: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
    type: "global",
    relativeTo: (a) => a.rel
  })
};
class $47e0e8ef515d9903$var$ValueRecord {
  buildStruct(s) {
    let c = s;
    for (; !c[this.key] && c.parent; ) c = c.parent;
    if (!c[this.key]) return;
    let u = {};
    u.rel = () => c._startOffset;
    let d = c[this.key];
    for (let p in d) d[p] && (u[p] = $47e0e8ef515d9903$var$types[p]);
    return new Struct(u);
  }
  size(s, c) {
    return this.buildStruct(c).size(s, c);
  }
  decode(s, c) {
    let u = this.buildStruct(c).decode(s, c);
    return delete u.rel, u;
  }
  constructor(s = "valueFormat") {
    this.key = s;
  }
}
let $47e0e8ef515d9903$var$PairValueRecord = new Struct({
  secondGlyph: uint16,
  value1: new $47e0e8ef515d9903$var$ValueRecord("valueFormat1"),
  value2: new $47e0e8ef515d9903$var$ValueRecord("valueFormat2")
}), $47e0e8ef515d9903$var$PairSet = new ArrayT($47e0e8ef515d9903$var$PairValueRecord, uint16), $47e0e8ef515d9903$var$Class2Record = new Struct({
  value1: new $47e0e8ef515d9903$var$ValueRecord("valueFormat1"),
  value2: new $47e0e8ef515d9903$var$ValueRecord("valueFormat2")
}), $47e0e8ef515d9903$var$Anchor = new VersionedStruct(uint16, {
  1: {
    xCoordinate: int16,
    yCoordinate: int16
  },
  2: {
    xCoordinate: int16,
    yCoordinate: int16,
    anchorPoint: uint16
  },
  3: {
    xCoordinate: int16,
    yCoordinate: int16,
    xDeviceTable: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10),
    yDeviceTable: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10)
  }
}), $47e0e8ef515d9903$var$EntryExitRecord = new Struct({
  entryAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  }),
  exitAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  })
}), $47e0e8ef515d9903$var$MarkRecord = new Struct({
  class: uint16,
  markAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  })
}), $47e0e8ef515d9903$var$MarkArray = new ArrayT($47e0e8ef515d9903$var$MarkRecord, uint16), $47e0e8ef515d9903$var$BaseRecord = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$Anchor), (a) => a.parent.classCount), $47e0e8ef515d9903$var$BaseArray = new ArrayT($47e0e8ef515d9903$var$BaseRecord, uint16), $47e0e8ef515d9903$var$ComponentRecord = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$Anchor), (a) => a.parent.parent.classCount), $47e0e8ef515d9903$var$LigatureAttach = new ArrayT($47e0e8ef515d9903$var$ComponentRecord, uint16), $47e0e8ef515d9903$var$LigatureArray = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$LigatureAttach), uint16), $47e0e8ef515d9903$export$73a8cfb19cd43a0f = new VersionedStruct("lookupType", {
  1: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      valueFormat: $47e0e8ef515d9903$var$ValueFormat,
      value: new $47e0e8ef515d9903$var$ValueRecord()
    },
    2: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      valueFormat: $47e0e8ef515d9903$var$ValueFormat,
      valueCount: uint16,
      values: new LazyArray(new $47e0e8ef515d9903$var$ValueRecord(), "valueCount")
    }
  }),
  2: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      valueFormat1: $47e0e8ef515d9903$var$ValueFormat,
      valueFormat2: $47e0e8ef515d9903$var$ValueFormat,
      pairSetCount: uint16,
      pairSets: new LazyArray(new Pointer(uint16, $47e0e8ef515d9903$var$PairSet), "pairSetCount")
    },
    2: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      valueFormat1: $47e0e8ef515d9903$var$ValueFormat,
      valueFormat2: $47e0e8ef515d9903$var$ValueFormat,
      classDef1: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
      classDef2: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
      class1Count: uint16,
      class2Count: uint16,
      classRecords: new LazyArray(new LazyArray($47e0e8ef515d9903$var$Class2Record, "class2Count"), "class1Count")
    }
  }),
  3: {
    format: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    entryExitCount: uint16,
    entryExitRecords: new ArrayT($47e0e8ef515d9903$var$EntryExitRecord, "entryExitCount")
  },
  4: {
    format: uint16,
    markCoverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    baseCoverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classCount: uint16,
    markArray: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    baseArray: new Pointer(uint16, $47e0e8ef515d9903$var$BaseArray)
  },
  5: {
    format: uint16,
    markCoverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    ligatureCoverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classCount: uint16,
    markArray: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    ligatureArray: new Pointer(uint16, $47e0e8ef515d9903$var$LigatureArray)
  },
  6: {
    format: uint16,
    mark1Coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    mark2Coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classCount: uint16,
    mark1Array: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    mark2Array: new Pointer(uint16, $47e0e8ef515d9903$var$BaseArray)
  },
  7: $7cbbe4e24ef3cb75$export$841858b892ce1f4c,
  8: $7cbbe4e24ef3cb75$export$5e6d09e6861162f6,
  9: {
    posFormat: uint16,
    lookupType: uint16,
    extension: new Pointer(uint32, null)
  }
});
$47e0e8ef515d9903$export$73a8cfb19cd43a0f.versions[9].extension.type = $47e0e8ef515d9903$export$73a8cfb19cd43a0f;
var $47e0e8ef515d9903$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    scriptList: new Pointer(uint16, $7cbbe4e24ef3cb75$export$3e15fc05ce864229),
    featureList: new Pointer(uint16, $7cbbe4e24ef3cb75$export$aa18130def4b6cb4),
    lookupList: new Pointer(uint16, new $7cbbe4e24ef3cb75$export$df0008c6ff2da22a($47e0e8ef515d9903$export$73a8cfb19cd43a0f))
  },
  65536: {},
  65537: {
    featureVariations: new Pointer(uint32, $1a47b0c45c1c22fe$export$441b70b7971dd419)
  }
});
let $d3f442064af66e06$var$Sequence = new ArrayT(uint16, uint16), $d3f442064af66e06$var$AlternateSet = $d3f442064af66e06$var$Sequence, $d3f442064af66e06$var$Ligature = new Struct({
  glyph: uint16,
  compCount: uint16,
  components: new ArrayT(uint16, (a) => a.compCount - 1)
}), $d3f442064af66e06$var$LigatureSet = new ArrayT(new Pointer(uint16, $d3f442064af66e06$var$Ligature), uint16), $d3f442064af66e06$var$GSUBLookup = new VersionedStruct("lookupType", {
  1: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      deltaGlyphID: int16
    },
    2: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      glyphCount: uint16,
      substitute: new LazyArray(uint16, "glyphCount")
    }
  }),
  2: {
    substFormat: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    count: uint16,
    sequences: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$Sequence), "count")
  },
  3: {
    substFormat: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    count: uint16,
    alternateSet: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$AlternateSet), "count")
  },
  4: {
    substFormat: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    count: uint16,
    ligatureSets: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$LigatureSet), "count")
  },
  5: $7cbbe4e24ef3cb75$export$841858b892ce1f4c,
  6: $7cbbe4e24ef3cb75$export$5e6d09e6861162f6,
  7: {
    substFormat: uint16,
    lookupType: uint16,
    extension: new Pointer(uint32, null)
  },
  8: {
    substFormat: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    backtrackCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "backtrackGlyphCount"),
    lookaheadGlyphCount: uint16,
    lookaheadCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "lookaheadGlyphCount"),
    glyphCount: uint16,
    substitutes: new ArrayT(uint16, "glyphCount")
  }
});
$d3f442064af66e06$var$GSUBLookup.versions[7].extension.type = $d3f442064af66e06$var$GSUBLookup;
var $d3f442064af66e06$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    scriptList: new Pointer(uint16, $7cbbe4e24ef3cb75$export$3e15fc05ce864229),
    featureList: new Pointer(uint16, $7cbbe4e24ef3cb75$export$aa18130def4b6cb4),
    lookupList: new Pointer(uint16, new $7cbbe4e24ef3cb75$export$df0008c6ff2da22a($d3f442064af66e06$var$GSUBLookup))
  },
  65536: {},
  65537: {
    featureVariations: new Pointer(uint32, $1a47b0c45c1c22fe$export$441b70b7971dd419)
  }
});
let $71cfb3c4767fbd0c$var$JstfGSUBModList = new ArrayT(uint16, uint16), $71cfb3c4767fbd0c$var$JstfPriority = new Struct({
  shrinkageEnableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageDisableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageEnableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageDisableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageJstfMax: new Pointer(uint16, new $7cbbe4e24ef3cb75$export$df0008c6ff2da22a($47e0e8ef515d9903$export$73a8cfb19cd43a0f)),
  extensionEnableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionDisableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionEnableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionDisableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionJstfMax: new Pointer(uint16, new $7cbbe4e24ef3cb75$export$df0008c6ff2da22a($47e0e8ef515d9903$export$73a8cfb19cd43a0f))
}), $71cfb3c4767fbd0c$var$JstfLangSys = new ArrayT(new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfPriority), uint16), $71cfb3c4767fbd0c$var$JstfLangSysRecord = new Struct({
  tag: new StringT(4),
  jstfLangSys: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfLangSys)
}), $71cfb3c4767fbd0c$var$JstfScript = new Struct({
  extenderGlyphs: new Pointer(uint16, new ArrayT(uint16, uint16)),
  defaultLangSys: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfLangSys),
  langSysCount: uint16,
  langSysRecords: new ArrayT($71cfb3c4767fbd0c$var$JstfLangSysRecord, "langSysCount")
}), $71cfb3c4767fbd0c$var$JstfScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfScript, {
    type: "parent"
  })
});
var $71cfb3c4767fbd0c$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  scriptCount: uint16,
  scriptList: new ArrayT($71cfb3c4767fbd0c$var$JstfScriptRecord, "scriptCount")
});
class $d059a6bd2d3b5b63$var$VariableSizeNumber {
  decode(s, c) {
    switch (this.size(0, c)) {
      case 1:
        return s.readUInt8();
      case 2:
        return s.readUInt16BE();
      case 3:
        return s.readUInt24BE();
      case 4:
        return s.readUInt32BE();
    }
  }
  size(s, c) {
    return resolveLength(this._size, null, c);
  }
  constructor(s) {
    this._size = s;
  }
}
let $d059a6bd2d3b5b63$var$MapDataEntry = new Struct({
  entry: new $d059a6bd2d3b5b63$var$VariableSizeNumber((a) => ((a.parent.entryFormat & 48) >> 4) + 1),
  outerIndex: (a) => a.entry >> (a.parent.entryFormat & 15) + 1,
  innerIndex: (a) => a.entry & (1 << (a.parent.entryFormat & 15) + 1) - 1
}), $d059a6bd2d3b5b63$var$DeltaSetIndexMap = new Struct({
  entryFormat: uint16,
  mapCount: uint16,
  mapData: new ArrayT($d059a6bd2d3b5b63$var$MapDataEntry, "mapCount")
});
var $d059a6bd2d3b5b63$export$2e2bcd8739ae039 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  itemVariationStore: new Pointer(uint32, $1a47b0c45c1c22fe$export$fe1b122a2710f241),
  advanceWidthMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap),
  LSBMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap),
  RSBMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap)
});
let $dceeca3e1977ce30$var$Signature = new Struct({
  format: uint32,
  length: uint32,
  offset: uint32
}), $dceeca3e1977ce30$var$SignatureBlock = new Struct({
  reserved: new Reserved(uint16, 2),
  cbSignature: uint32,
  signature: new BufferT("cbSignature")
});
var $dceeca3e1977ce30$export$2e2bcd8739ae039 = new Struct({
  ulVersion: uint32,
  usNumSigs: uint16,
  usFlag: uint16,
  signatures: new ArrayT($dceeca3e1977ce30$var$Signature, "usNumSigs"),
  signatureBlocks: new ArrayT($dceeca3e1977ce30$var$SignatureBlock, "usNumSigs")
});
let $8acd740a9435aad0$var$GaspRange = new Struct({
  rangeMaxPPEM: uint16,
  rangeGaspBehavior: new Bitfield(uint16, [
    "grayscale",
    "gridfit",
    "symmetricSmoothing",
    "symmetricGridfit"
    // only in version 1, for ClearType
  ])
});
var $8acd740a9435aad0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRanges: uint16,
  gaspRanges: new ArrayT($8acd740a9435aad0$var$GaspRange, "numRanges")
  // Sorted by ppem
});
let $b5f380243c34d6a0$var$DeviceRecord = new Struct({
  pixelSize: uint8,
  maximumWidth: uint8,
  widths: new ArrayT(uint8, (a) => a.parent.parent.maxp.numGlyphs)
});
var $b5f380243c34d6a0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRecords: int16,
  sizeDeviceRecord: int32,
  records: new ArrayT($b5f380243c34d6a0$var$DeviceRecord, "numRecords")
});
let $ca2df1256966e313$var$KernPair = new Struct({
  left: uint16,
  right: uint16,
  value: int16
}), $ca2df1256966e313$var$ClassTable = new Struct({
  firstGlyph: uint16,
  nGlyphs: uint16,
  offsets: new ArrayT(uint16, "nGlyphs"),
  max: (a) => a.offsets.length && Math.max.apply(Math, a.offsets)
}), $ca2df1256966e313$var$Kern2Array = new Struct({
  off: (a) => a._startOffset - a.parent.parent._startOffset,
  len: (a) => ((a.parent.leftTable.max - a.off) / a.parent.rowWidth + 1) * (a.parent.rowWidth / 2),
  values: new LazyArray(int16, "len")
}), $ca2df1256966e313$var$KernSubtable = new VersionedStruct("format", {
  0: {
    nPairs: uint16,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16,
    pairs: new ArrayT($ca2df1256966e313$var$KernPair, "nPairs")
  },
  2: {
    rowWidth: uint16,
    leftTable: new Pointer(uint16, $ca2df1256966e313$var$ClassTable, {
      type: "parent"
    }),
    rightTable: new Pointer(uint16, $ca2df1256966e313$var$ClassTable, {
      type: "parent"
    }),
    array: new Pointer(uint16, $ca2df1256966e313$var$Kern2Array, {
      type: "parent"
    })
  },
  3: {
    glyphCount: uint16,
    kernValueCount: uint8,
    leftClassCount: uint8,
    rightClassCount: uint8,
    flags: uint8,
    kernValue: new ArrayT(int16, "kernValueCount"),
    leftClass: new ArrayT(uint8, "glyphCount"),
    rightClass: new ArrayT(uint8, "glyphCount"),
    kernIndex: new ArrayT(uint8, (a) => a.leftClassCount * a.rightClassCount)
  }
}), $ca2df1256966e313$var$KernTable = new VersionedStruct("version", {
  0: {
    subVersion: uint16,
    length: uint16,
    format: uint8,
    coverage: new Bitfield(uint8, [
      "horizontal",
      "minimum",
      "crossStream",
      "override"
      // If set to 1 the value in this table replaces the accumulated value
    ]),
    subtable: $ca2df1256966e313$var$KernSubtable,
    padding: new Reserved(uint8, (a) => a.length - a._currentOffset)
  },
  1: {
    length: uint32,
    coverage: new Bitfield(uint8, [
      null,
      null,
      null,
      null,
      null,
      "variation",
      "crossStream",
      "vertical"
      // Set if table has vertical kerning values
    ]),
    format: uint8,
    tupleIndex: uint16,
    subtable: $ca2df1256966e313$var$KernSubtable,
    padding: new Reserved(uint8, (a) => a.length - a._currentOffset)
  }
});
var $ca2df1256966e313$export$2e2bcd8739ae039 = new VersionedStruct(uint16, {
  0: {
    nTables: uint16,
    tables: new ArrayT($ca2df1256966e313$var$KernTable, "nTables")
  },
  1: {
    reserved: new Reserved(uint16),
    nTables: uint32,
    tables: new ArrayT($ca2df1256966e313$var$KernTable, "nTables")
  }
}), $7a9f92b0c46ebe33$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numGlyphs: uint16,
  yPels: new ArrayT(uint8, "numGlyphs")
}), $2b2ccc419d152631$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  fontNumber: uint32,
  pitch: uint16,
  xHeight: uint16,
  style: uint16,
  typeFamily: uint16,
  capHeight: uint16,
  symbolSet: uint16,
  typeface: new StringT(16),
  characterComplement: new StringT(8),
  fileName: new StringT(6),
  strokeWeight: new StringT(1),
  widthType: new StringT(1),
  serifStyle: uint8,
  reserved: new Reserved(uint8)
});
let $ca5b40b9bcda9c9b$var$Ratio = new Struct({
  bCharSet: uint8,
  xRatio: uint8,
  yStartRatio: uint8,
  yEndRatio: uint8
  // Ending y-Ratio value
}), $ca5b40b9bcda9c9b$var$vTable = new Struct({
  yPelHeight: uint16,
  yMax: int16,
  yMin: int16
  // Minimum value (in pels) for this yPelHeight
}), $ca5b40b9bcda9c9b$var$VdmxGroup = new Struct({
  recs: uint16,
  startsz: uint8,
  endsz: uint8,
  entries: new ArrayT($ca5b40b9bcda9c9b$var$vTable, "recs")
  // The VDMX records
});
var $ca5b40b9bcda9c9b$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRecs: uint16,
  numRatios: uint16,
  ratioRanges: new ArrayT($ca5b40b9bcda9c9b$var$Ratio, "numRatios"),
  offsets: new ArrayT(uint16, "numRatios"),
  groups: new ArrayT($ca5b40b9bcda9c9b$var$VdmxGroup, "numRecs")
  // The actual VDMX groupings
}), $69530a3c40755af0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  ascent: int16,
  descent: int16,
  lineGap: int16,
  advanceHeightMax: int16,
  minTopSideBearing: int16,
  minBottomSideBearing: int16,
  yMaxExtent: int16,
  caretSlopeRise: int16,
  caretSlopeRun: int16,
  caretOffset: int16,
  reserved: new Reserved(int16, 4),
  metricDataFormat: int16,
  numberOfMetrics: uint16
  // Number of advance heights in the Vertical Metrics table
});
let $344073dd270f0e62$var$VmtxEntry = new Struct({
  advance: uint16,
  bearing: int16
  // The top sidebearing of the glyph
});
var $344073dd270f0e62$export$2e2bcd8739ae039 = new Struct({
  metrics: new LazyArray($344073dd270f0e62$var$VmtxEntry, (a) => a.parent.vhea.numberOfMetrics),
  bearings: new LazyArray(int16, (a) => a.parent.maxp.numGlyphs - a.parent.vhea.numberOfMetrics)
});
let $3793b781918cfced$var$shortFrac = new Fixed(16, "BE", 14), $3793b781918cfced$var$Correspondence = new Struct({
  fromCoord: $3793b781918cfced$var$shortFrac,
  toCoord: $3793b781918cfced$var$shortFrac
}), $3793b781918cfced$var$Segment = new Struct({
  pairCount: uint16,
  correspondence: new ArrayT($3793b781918cfced$var$Correspondence, "pairCount")
});
var $3793b781918cfced$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  axisCount: uint32,
  segment: new ArrayT($3793b781918cfced$var$Segment, "axisCount")
});
class $6cb7dd5f47d82580$var$UnboundedArrayAccessor {
  getItem(s) {
    if (this._items[s] == null) {
      let c = this.stream.pos;
      this.stream.pos = this.base + this.type.size(null, this.parent) * s, this._items[s] = this.type.decode(this.stream, this.parent), this.stream.pos = c;
    }
    return this._items[s];
  }
  inspect() {
    return `[UnboundedArray ${this.type.constructor.name}]`;
  }
  constructor(s, c, u) {
    this.type = s, this.stream = c, this.parent = u, this.base = this.stream.pos, this._items = [];
  }
}
class $6cb7dd5f47d82580$export$c5af1eebc882e39a extends ArrayT {
  decode(s, c) {
    return new $6cb7dd5f47d82580$var$UnboundedArrayAccessor(this.type, s, c);
  }
  constructor(s) {
    super(s, 0);
  }
}
let $6cb7dd5f47d82580$export$8351f8c2ae2f103c = function(a = uint16) {
  class s {
    decode(A, x) {
      return x = x.parent.parent, this.type.decode(A, x);
    }
    size(A, x) {
      return x = x.parent.parent, this.type.size(A, x);
    }
    encode(A, x, g) {
      return g = g.parent.parent, this.type.encode(A, x, g);
    }
    constructor(A) {
      this.type = A;
    }
  }
  a = new s(a);
  let c = new Struct({
    unitSize: uint16,
    nUnits: uint16,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16
  }), u = new Struct({
    lastGlyph: uint16,
    firstGlyph: uint16,
    value: a
  }), d = new Struct({
    lastGlyph: uint16,
    firstGlyph: uint16,
    values: new Pointer(uint16, new ArrayT(a, (v) => v.lastGlyph - v.firstGlyph + 1), {
      type: "parent"
    })
  }), p = new Struct({
    glyph: uint16,
    value: a
  });
  return new VersionedStruct(uint16, {
    0: {
      values: new $6cb7dd5f47d82580$export$c5af1eebc882e39a(a)
      // length == number of glyphs maybe?
    },
    2: {
      binarySearchHeader: c,
      segments: new ArrayT(u, (v) => v.binarySearchHeader.nUnits)
    },
    4: {
      binarySearchHeader: c,
      segments: new ArrayT(d, (v) => v.binarySearchHeader.nUnits)
    },
    6: {
      binarySearchHeader: c,
      segments: new ArrayT(p, (v) => v.binarySearchHeader.nUnits)
    },
    8: {
      firstGlyph: uint16,
      count: uint16,
      values: new ArrayT(a, "count")
    }
  });
};
function $6cb7dd5f47d82580$export$79f7d93d790934ba(a = {}, s = uint16) {
  let c = Object.assign({
    newState: uint16,
    flags: uint16
  }, a), u = new Struct(c), d = new $6cb7dd5f47d82580$export$c5af1eebc882e39a(new ArrayT(uint16, (v) => v.nClasses));
  return new Struct({
    nClasses: uint32,
    classTable: new Pointer(uint32, new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(s)),
    stateArray: new Pointer(uint32, d),
    entryTable: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(u))
  });
}
function $6cb7dd5f47d82580$export$105027425199cc51(a = {}, s = uint16) {
  let c = new Struct({
    version() {
      return 8;
    },
    firstGlyph: uint16,
    values: new ArrayT(uint8, uint16)
  }), u = Object.assign({
    newStateOffset: uint16,
    // convert offset to stateArray index
    newState: (A) => (A.newStateOffset - (A.parent.stateArray.base - A.parent._startOffset)) / A.parent.nClasses,
    flags: uint16
  }, a), d = new Struct(u), p = new $6cb7dd5f47d82580$export$c5af1eebc882e39a(new ArrayT(uint8, (A) => A.nClasses));
  return new Struct({
    nClasses: uint16,
    classTable: new Pointer(uint16, c),
    stateArray: new Pointer(uint16, p),
    entryTable: new Pointer(uint16, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(d))
  });
}
let $6a3746e8c708f5a3$var$BslnSubtable = new VersionedStruct("format", {
  0: {
    deltas: new ArrayT(int16, 32)
  },
  1: {
    deltas: new ArrayT(int16, 32),
    mappingData: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(uint16)
  },
  2: {
    standardGlyph: uint16,
    controlPoints: new ArrayT(uint16, 32)
  },
  3: {
    standardGlyph: uint16,
    controlPoints: new ArrayT(uint16, 32),
    mappingData: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(uint16)
  }
});
var $6a3746e8c708f5a3$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  format: uint16,
  defaultBaseline: uint16,
  subtable: $6a3746e8c708f5a3$var$BslnSubtable
});
let $d0c76fac617b308a$var$Setting = new Struct({
  setting: uint16,
  nameIndex: int16,
  name: (a) => a.parent.parent.parent.name.records.fontFeatures[a.nameIndex]
}), $d0c76fac617b308a$var$FeatureName = new Struct({
  feature: uint16,
  nSettings: uint16,
  settingTable: new Pointer(uint32, new ArrayT($d0c76fac617b308a$var$Setting, "nSettings"), {
    type: "parent"
  }),
  featureFlags: new Bitfield(uint8, [
    null,
    null,
    null,
    null,
    null,
    null,
    "hasDefault",
    "exclusive"
  ]),
  defaultSetting: uint8,
  nameIndex: int16,
  name: (a) => a.parent.parent.name.records.fontFeatures[a.nameIndex]
});
var $d0c76fac617b308a$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  featureNameCount: uint16,
  reserved1: new Reserved(uint16),
  reserved2: new Reserved(uint32),
  featureNames: new ArrayT($d0c76fac617b308a$var$FeatureName, "featureNameCount")
});
let $e83fd065f00fcd01$var$Axis = new Struct({
  axisTag: new StringT(4),
  minValue: fixed32,
  defaultValue: fixed32,
  maxValue: fixed32,
  flags: uint16,
  nameID: uint16,
  name: (a) => a.parent.parent.name.records.fontFeatures[a.nameID]
}), $e83fd065f00fcd01$var$Instance = new Struct({
  nameID: uint16,
  name: (a) => a.parent.parent.name.records.fontFeatures[a.nameID],
  flags: uint16,
  coord: new ArrayT(fixed32, (a) => a.parent.axisCount),
  postscriptNameID: new Optional(uint16, (a) => a.parent.instanceSize - a._currentOffset > 0)
});
var $e83fd065f00fcd01$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  offsetToData: uint16,
  countSizePairs: uint16,
  axisCount: uint16,
  axisSize: uint16,
  instanceCount: uint16,
  instanceSize: uint16,
  axis: new ArrayT($e83fd065f00fcd01$var$Axis, "axisCount"),
  instance: new ArrayT($e83fd065f00fcd01$var$Instance, "instanceCount")
});
let $dbe33c8d3a7f131c$var$shortFrac = new Fixed(16, "BE", 14);
class $dbe33c8d3a7f131c$var$Offset {
  static decode(s, c) {
    return c.flags ? s.readUInt32BE() : s.readUInt16BE() * 2;
  }
}
let $dbe33c8d3a7f131c$var$gvar = new Struct({
  version: uint16,
  reserved: new Reserved(uint16),
  axisCount: uint16,
  globalCoordCount: uint16,
  globalCoords: new Pointer(uint32, new ArrayT(new ArrayT($dbe33c8d3a7f131c$var$shortFrac, "axisCount"), "globalCoordCount")),
  glyphCount: uint16,
  flags: uint16,
  offsetToData: uint32,
  offsets: new ArrayT(new Pointer($dbe33c8d3a7f131c$var$Offset, "void", {
    relativeTo: (a) => a.offsetToData,
    allowNull: !1
  }), (a) => a.glyphCount + 1)
});
var $dbe33c8d3a7f131c$export$2e2bcd8739ae039 = $dbe33c8d3a7f131c$var$gvar;
let $05b01887df96c4ee$var$ClassTable = new Struct({
  length: uint16,
  coverage: uint16,
  subFeatureFlags: uint32,
  stateTable: new $6cb7dd5f47d82580$export$105027425199cc51()
}), $05b01887df96c4ee$var$WidthDeltaRecord = new Struct({
  justClass: uint32,
  beforeGrowLimit: fixed32,
  beforeShrinkLimit: fixed32,
  afterGrowLimit: fixed32,
  afterShrinkLimit: fixed32,
  growFlags: uint16,
  shrinkFlags: uint16
}), $05b01887df96c4ee$var$WidthDeltaCluster = new ArrayT($05b01887df96c4ee$var$WidthDeltaRecord, uint32), $05b01887df96c4ee$var$ActionData = new VersionedStruct("actionType", {
  0: {
    lowerLimit: fixed32,
    upperLimit: fixed32,
    order: uint16,
    glyphs: new ArrayT(uint16, uint16)
  },
  1: {
    addGlyph: uint16
  },
  2: {
    substThreshold: fixed32,
    addGlyph: uint16,
    substGlyph: uint16
  },
  3: {},
  4: {
    variationAxis: uint32,
    minimumLimit: fixed32,
    noStretchValue: fixed32,
    maximumLimit: fixed32
  },
  5: {
    flags: uint16,
    glyph: uint16
  }
}), $05b01887df96c4ee$var$Action = new Struct({
  actionClass: uint16,
  actionType: uint16,
  actionLength: uint32,
  actionData: $05b01887df96c4ee$var$ActionData,
  padding: new Reserved(uint8, (a) => a.actionLength - a._currentOffset)
}), $05b01887df96c4ee$var$PostcompensationAction = new ArrayT($05b01887df96c4ee$var$Action, uint32), $05b01887df96c4ee$var$PostCompensationTable = new Struct({
  lookupTable: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(new Pointer(uint16, $05b01887df96c4ee$var$PostcompensationAction))
}), $05b01887df96c4ee$var$JustificationTable = new Struct({
  classTable: new Pointer(uint16, $05b01887df96c4ee$var$ClassTable, {
    type: "parent"
  }),
  wdcOffset: uint16,
  postCompensationTable: new Pointer(uint16, $05b01887df96c4ee$var$PostCompensationTable, {
    type: "parent"
  }),
  widthDeltaClusters: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(new Pointer(uint16, $05b01887df96c4ee$var$WidthDeltaCluster, {
    type: "parent",
    relativeTo: (a) => a.wdcOffset
  }))
});
var $05b01887df96c4ee$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  format: uint16,
  horizontal: new Pointer(uint16, $05b01887df96c4ee$var$JustificationTable),
  vertical: new Pointer(uint16, $05b01887df96c4ee$var$JustificationTable)
});
let $03ee6ebd54db1053$var$LigatureData = {
  action: uint16
}, $03ee6ebd54db1053$var$ContextualData = {
  markIndex: uint16,
  currentIndex: uint16
}, $03ee6ebd54db1053$var$InsertionData = {
  currentInsertIndex: uint16,
  markedInsertIndex: uint16
}, $03ee6ebd54db1053$var$SubstitutionTable = new Struct({
  items: new $6cb7dd5f47d82580$export$c5af1eebc882e39a(new Pointer(uint32, new $6cb7dd5f47d82580$export$8351f8c2ae2f103c()))
}), $03ee6ebd54db1053$var$SubtableData = new VersionedStruct("type", {
  0: {
    stateTable: new $6cb7dd5f47d82580$export$79f7d93d790934ba()
  },
  1: {
    stateTable: new $6cb7dd5f47d82580$export$79f7d93d790934ba($03ee6ebd54db1053$var$ContextualData),
    substitutionTable: new Pointer(uint32, $03ee6ebd54db1053$var$SubstitutionTable)
  },
  2: {
    stateTable: new $6cb7dd5f47d82580$export$79f7d93d790934ba($03ee6ebd54db1053$var$LigatureData),
    ligatureActions: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(uint32)),
    components: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(uint16)),
    ligatureList: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(uint16))
  },
  4: {
    lookupTable: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c()
  },
  5: {
    stateTable: new $6cb7dd5f47d82580$export$79f7d93d790934ba($03ee6ebd54db1053$var$InsertionData),
    insertionActions: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(uint16))
  }
}), $03ee6ebd54db1053$var$Subtable = new Struct({
  length: uint32,
  coverage: uint24,
  type: uint8,
  subFeatureFlags: uint32,
  table: $03ee6ebd54db1053$var$SubtableData,
  padding: new Reserved(uint8, (a) => a.length - a._currentOffset)
}), $03ee6ebd54db1053$var$FeatureEntry = new Struct({
  featureType: uint16,
  featureSetting: uint16,
  enableFlags: uint32,
  disableFlags: uint32
}), $03ee6ebd54db1053$var$MorxChain = new Struct({
  defaultFlags: uint32,
  chainLength: uint32,
  nFeatureEntries: uint32,
  nSubtables: uint32,
  features: new ArrayT($03ee6ebd54db1053$var$FeatureEntry, "nFeatureEntries"),
  subtables: new ArrayT($03ee6ebd54db1053$var$Subtable, "nSubtables")
});
var $03ee6ebd54db1053$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  unused: new Reserved(uint16),
  nChains: uint32,
  chains: new ArrayT($03ee6ebd54db1053$var$MorxChain, "nChains")
});
let $b7492a80b0d1a056$var$OpticalBounds = new Struct({
  left: int16,
  top: int16,
  right: int16,
  bottom: int16
});
var $b7492a80b0d1a056$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  format: uint16,
  lookupTable: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c($b7492a80b0d1a056$var$OpticalBounds)
});
let $c3395722bea751e2$var$tables = {};
var $c3395722bea751e2$export$2e2bcd8739ae039 = $c3395722bea751e2$var$tables;
$c3395722bea751e2$var$tables.cmap = $26a62205ad06574e$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.head = $f2612a29f92ac062$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.hhea = $2c179dd593583073$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.hmtx = $bdc9060542264b85$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.maxp = $dbf51cb3d3fe409d$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.name = $2bcf221753ec8e32$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables["OS/2"] = $84b272aa31b70606$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.post = $32d9e2eb9565d93c$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.fpgm = $5c0f37ca5ffb1850$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.loca = $2b2b260902b1c57e$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.prep = $7afb878c7bea4f66$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables["cvt "] = $5202bd9d9ad8eaac$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.glyf = $6c92b6371bce8bd9$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables["CFF "] = $822ac0d589e4e237$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.CFF2 = $822ac0d589e4e237$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.VORG = $2bbf2bc1ce37cd8f$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.EBLC = $9911c4c7201c13de$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.CBLC = $c3395722bea751e2$var$tables.EBLC;
$c3395722bea751e2$var$tables.sbix = $abb847051efd51b1$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.COLR = $eb629188f3dfefdd$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.CPAL = $08734b8e7dc64587$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.BASE = $497cef411d884e34$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.GDEF = $cf5f33c63ef209e6$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.GPOS = $47e0e8ef515d9903$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.GSUB = $d3f442064af66e06$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.JSTF = $71cfb3c4767fbd0c$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.HVAR = $d059a6bd2d3b5b63$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.DSIG = $dceeca3e1977ce30$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.gasp = $8acd740a9435aad0$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.hdmx = $b5f380243c34d6a0$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.kern = $ca2df1256966e313$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.LTSH = $7a9f92b0c46ebe33$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.PCLT = $2b2ccc419d152631$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.VDMX = $ca5b40b9bcda9c9b$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.vhea = $69530a3c40755af0$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.vmtx = $344073dd270f0e62$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.avar = $3793b781918cfced$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.bsln = $6a3746e8c708f5a3$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.feat = $d0c76fac617b308a$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.fvar = $e83fd065f00fcd01$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.gvar = $dbe33c8d3a7f131c$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.just = $05b01887df96c4ee$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.morx = $03ee6ebd54db1053$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.opbd = $b7492a80b0d1a056$export$2e2bcd8739ae039;
let $816c07a04b6dba87$var$TableEntry = new Struct({
  tag: new StringT(4),
  checkSum: uint32,
  offset: new Pointer(uint32, "void", {
    type: "global"
  }),
  length: uint32
}), $816c07a04b6dba87$var$Directory = new Struct({
  tag: new StringT(4),
  numTables: uint16,
  searchRange: uint16,
  entrySelector: uint16,
  rangeShift: uint16,
  tables: new ArrayT($816c07a04b6dba87$var$TableEntry, "numTables")
});
$816c07a04b6dba87$var$Directory.process = function() {
  let a = {};
  for (let s of this.tables) a[s.tag] = s;
  this.tables = a;
};
$816c07a04b6dba87$var$Directory.preEncode = function() {
  if (!Array.isArray(this.tables)) {
    let c = [];
    for (let u in this.tables) {
      let d = this.tables[u];
      d && c.push({
        tag: u,
        checkSum: 0,
        offset: new VoidPointer($c3395722bea751e2$export$2e2bcd8739ae039[u], d),
        length: $c3395722bea751e2$export$2e2bcd8739ae039[u].size(d)
      });
    }
    this.tables = c;
  }
  this.tag = "true", this.numTables = this.tables.length;
  let a = Math.floor(Math.log(this.numTables) / Math.LN2), s = Math.pow(2, a);
  this.searchRange = s * 16, this.entrySelector = Math.log(s) / Math.LN2, this.rangeShift = this.numTables * 16 - this.searchRange;
};
var $816c07a04b6dba87$export$2e2bcd8739ae039 = $816c07a04b6dba87$var$Directory;
function $12727730ddfc8bfe$export$2e0ae67339d5f1ac(a, s) {
  let c = 0, u = a.length - 1;
  for (; c <= u; ) {
    let d = c + u >> 1, p = s(a[d]);
    if (p < 0) u = d - 1;
    else if (p > 0) c = d + 1;
    else return d;
  }
  return -1;
}
function $12727730ddfc8bfe$export$d02631cccf789723(a, s) {
  let c = [];
  for (; a < s; ) c.push(a++);
  return c;
}
const $12727730ddfc8bfe$export$3d28c1996ced1f14 = new TextDecoder("ascii"), $12727730ddfc8bfe$var$CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $12727730ddfc8bfe$var$LOOKUP = new Uint8Array(256);
for (let a = 0; a < $12727730ddfc8bfe$var$CHARS.length; a++) $12727730ddfc8bfe$var$LOOKUP[$12727730ddfc8bfe$var$CHARS.charCodeAt(a)] = a;
function $12727730ddfc8bfe$export$94fdf11bafc8de6b(a) {
  let s = a.length * 0.75;
  a[a.length - 1] === "=" && (s--, a[a.length - 2] === "=" && s--);
  let c = new Uint8Array(s), u = 0;
  for (let d = 0, p = a.length; d < p; d += 4) {
    let v = $12727730ddfc8bfe$var$LOOKUP[a.charCodeAt(d)], A = $12727730ddfc8bfe$var$LOOKUP[a.charCodeAt(d + 1)], x = $12727730ddfc8bfe$var$LOOKUP[a.charCodeAt(d + 2)], g = $12727730ddfc8bfe$var$LOOKUP[a.charCodeAt(d + 3)];
    c[u++] = v << 2 | A >> 4, c[u++] = (A & 15) << 4 | x >> 2, c[u++] = (x & 3) << 6 | g & 63;
  }
  return c;
}
class $f08dd41ef10b694c$export$2e2bcd8739ae039 {
  findSubtable(s, c) {
    for (let [u, d] of c) for (let p of s.tables)
      if (p.platformID === u && p.encodingID === d) return p.table;
    return null;
  }
  lookup(s, c) {
    if (this.encoding) s = this.encoding.get(s) || s;
    else if (c) {
      let d = this.getVariationSelector(s, c);
      if (d) return d;
    }
    let u = this.cmap;
    switch (u.version) {
      case 0:
        return u.codeMap.get(s) || 0;
      case 4: {
        let d = 0, p = u.segCount - 1;
        for (; d <= p; ) {
          let v = d + p >> 1;
          if (s < u.startCode.get(v)) p = v - 1;
          else if (s > u.endCode.get(v)) d = v + 1;
          else {
            let A = u.idRangeOffset.get(v), x;
            if (A === 0) x = s + u.idDelta.get(v);
            else {
              let g = A / 2 + (s - u.startCode.get(v)) - (u.segCount - v);
              x = u.glyphIndexArray.get(g) || 0, x !== 0 && (x += u.idDelta.get(v));
            }
            return x & 65535;
          }
        }
        return 0;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return u.glyphIndices.get(s - u.firstCode) || 0;
      case 12:
      case 13: {
        let d = 0, p = u.nGroups - 1;
        for (; d <= p; ) {
          let v = d + p >> 1, A = u.groups.get(v);
          if (s < A.startCharCode) p = v - 1;
          else if (s > A.endCharCode) d = v + 1;
          else
            return u.version === 12 ? A.glyphID + (s - A.startCharCode) : A.glyphID;
        }
        return 0;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${u.version}`);
    }
  }
  getVariationSelector(s, c) {
    if (!this.uvs) return 0;
    let u = this.uvs.varSelectors.toArray(), d = $12727730ddfc8bfe$export$2e0ae67339d5f1ac(u, (v) => c - v.varSelector), p = u[d];
    return d !== -1 && p.defaultUVS && (d = $12727730ddfc8bfe$export$2e0ae67339d5f1ac(p.defaultUVS, (v) => s < v.startUnicodeValue ? -1 : s > v.startUnicodeValue + v.additionalCount ? 1 : 0)), d !== -1 && p.nonDefaultUVS && (d = $12727730ddfc8bfe$export$2e0ae67339d5f1ac(p.nonDefaultUVS, (v) => s - v.unicodeValue), d !== -1) ? p.nonDefaultUVS[d].glyphID : 0;
  }
  getCharacterSet() {
    let s = this.cmap;
    switch (s.version) {
      case 0:
        return $12727730ddfc8bfe$export$d02631cccf789723(0, s.codeMap.length);
      case 4: {
        let c = [], u = s.endCode.toArray();
        for (let d = 0; d < u.length; d++) {
          let p = u[d] + 1, v = s.startCode.get(d);
          c.push(...$12727730ddfc8bfe$export$d02631cccf789723(v, p));
        }
        return c;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return $12727730ddfc8bfe$export$d02631cccf789723(s.firstCode, s.firstCode + s.glyphIndices.length);
      case 12:
      case 13: {
        let c = [];
        for (let u of s.groups.toArray()) c.push(...$12727730ddfc8bfe$export$d02631cccf789723(u.startCharCode, u.endCharCode + 1));
        return c;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${s.version}`);
    }
  }
  codePointsForGlyph(s) {
    let c = this.cmap;
    switch (c.version) {
      case 0: {
        let d = [];
        for (let p = 0; p < 256; p++) c.codeMap.get(p) === s && d.push(p);
        return d;
      }
      case 4: {
        let d = [];
        for (let p = 0; p < c.segCount; p++) {
          let v = c.endCode.get(p), A = c.startCode.get(p), x = c.idRangeOffset.get(p), g = c.idDelta.get(p);
          for (var u = A; u <= v; u++) {
            let b = 0;
            if (x === 0) b = u + g;
            else {
              let y = x / 2 + (u - A) - (c.segCount - p);
              b = c.glyphIndexArray.get(y) || 0, b !== 0 && (b += g);
            }
            b === s && d.push(u);
          }
        }
        return d;
      }
      case 12: {
        let d = [];
        for (let p of c.groups.toArray()) s >= p.glyphID && s <= p.glyphID + (p.endCharCode - p.startCharCode) && d.push(p.startCharCode + (s - p.glyphID));
        return d;
      }
      case 13: {
        let d = [];
        for (let p of c.groups.toArray()) s === p.glyphID && d.push(...$12727730ddfc8bfe$export$d02631cccf789723(p.startCharCode, p.endCharCode + 1));
        return d;
      }
      default:
        throw new Error(`Unknown cmap format ${c.version}`);
    }
  }
  constructor(s) {
    if (this.encoding = null, this.cmap = this.findSubtable(s, [
      // 32-bit subtables
      [
        3,
        10
      ],
      [
        0,
        6
      ],
      [
        0,
        4
      ],
      // 16-bit subtables
      [
        3,
        1
      ],
      [
        0,
        3
      ],
      [
        0,
        2
      ],
      [
        0,
        1
      ],
      [
        0,
        0
      ]
    ]), !this.cmap) for (let c of s.tables) {
      let u = $e449ad78d50845fe$export$badc544e0651b6b1(c.platformID, c.encodingID, c.table.language - 1), d = $e449ad78d50845fe$export$1dceb3c14ed68bee(u);
      d && (this.cmap = c.table, this.encoding = d);
    }
    if (!this.cmap) throw new Error("Could not find a supported cmap table");
    this.uvs = this.findSubtable(s, [
      [
        0,
        5
      ]
    ]), this.uvs && this.uvs.version !== 14 && (this.uvs = null);
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f08dd41ef10b694c$export$2e2bcd8739ae039.prototype, "getCharacterSet", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f08dd41ef10b694c$export$2e2bcd8739ae039.prototype, "codePointsForGlyph", null);
class $0bba3a9db57637f3$export$2e2bcd8739ae039 {
  process(s, c) {
    for (let u = 0; u < s.length - 1; u++) {
      let d = s[u].id, p = s[u + 1].id;
      c[u].xAdvance += this.getKerning(d, p);
    }
  }
  getKerning(s, c) {
    let u = 0;
    for (let d of this.kern.tables) {
      if (d.coverage.crossStream) continue;
      switch (d.version) {
        case 0:
          if (!d.coverage.horizontal) continue;
          break;
        case 1:
          if (d.coverage.vertical || d.coverage.variation) continue;
          break;
        default:
          throw new Error(`Unsupported kerning table version ${d.version}`);
      }
      let p = 0, v = d.subtable;
      switch (d.format) {
        case 0:
          let A = $12727730ddfc8bfe$export$2e0ae67339d5f1ac(v.pairs, function(y) {
            return s - y.left || c - y.right;
          });
          A >= 0 && (p = v.pairs[A].value);
          break;
        case 2:
          let x = 0, g = 0;
          s >= v.leftTable.firstGlyph && s < v.leftTable.firstGlyph + v.leftTable.nGlyphs ? x = v.leftTable.offsets[s - v.leftTable.firstGlyph] : x = v.array.off, c >= v.rightTable.firstGlyph && c < v.rightTable.firstGlyph + v.rightTable.nGlyphs && (g = v.rightTable.offsets[c - v.rightTable.firstGlyph]);
          let b = (x + g - v.array.off) / 2;
          p = v.array.values.get(b);
          break;
        case 3:
          if (s >= v.glyphCount || c >= v.glyphCount) return 0;
          p = v.kernValue[v.kernIndex[v.leftClass[s] * v.rightClassCount + v.rightClass[c]]];
          break;
        default:
          throw new Error(`Unsupported kerning sub-table format ${d.format}`);
      }
      d.coverage.override ? u = p : u += p;
    }
    return u;
  }
  constructor(s) {
    this.kern = s.kern;
  }
}
class $0a4bdfeb6dfd6f5e$export$2e2bcd8739ae039 {
  positionGlyphs(s, c) {
    let u = 0, d = 0;
    for (let p = 0; p < s.length; p++)
      s[p].isMark ? d = p : (u !== d && this.positionCluster(s, c, u, d), u = d = p);
    return u !== d && this.positionCluster(s, c, u, d), c;
  }
  positionCluster(s, c, u, d) {
    let p = s[u], v = p.cbox.copy();
    p.codePoints.length > 1 && (v.minX += (p.codePoints.length - 1) * v.width / p.codePoints.length);
    let A = -c[u].xAdvance, x = 0, g = this.font.unitsPerEm / 16;
    for (let b = u + 1; b <= d; b++) {
      let y = s[b], f = y.cbox, m = c[b], C = this.getCombiningClass(y.codePoints[0]);
      if (C !== "Not_Reordered") {
        switch (m.xOffset = m.yOffset = 0, C) {
          case "Double_Above":
          case "Double_Below":
            m.xOffset += v.minX - f.width / 2 - f.minX;
            break;
          case "Attached_Below_Left":
          case "Below_Left":
          case "Above_Left":
            m.xOffset += v.minX - f.minX;
            break;
          case "Attached_Above_Right":
          case "Below_Right":
          case "Above_Right":
            m.xOffset += v.maxX - f.width - f.minX;
            break;
          default:
            m.xOffset += v.minX + (v.width - f.width) / 2 - f.minX;
        }
        switch (C) {
          case "Double_Below":
          case "Below_Left":
          case "Below":
          case "Below_Right":
          case "Attached_Below_Left":
          case "Attached_Below":
            (C === "Attached_Below_Left" || C === "Attached_Below") && (v.minY += g), m.yOffset = -v.minY - f.maxY, v.minY += f.height;
            break;
          case "Double_Above":
          case "Above_Left":
          case "Above":
          case "Above_Right":
          case "Attached_Above":
          case "Attached_Above_Right":
            (C === "Attached_Above" || C === "Attached_Above_Right") && (v.maxY += g), m.yOffset = v.maxY - f.minY, v.maxY += f.height;
            break;
        }
        m.xAdvance = m.yAdvance = 0, m.xOffset += A, m.yOffset += x;
      } else
        A -= m.xAdvance, x -= m.yAdvance;
    }
  }
  getCombiningClass(s) {
    let c = $747425b437e121da$export$c03b919c6651ed55(s);
    if ((s & -256) === 3584) {
      if (c === "Not_Reordered") switch (s) {
        case 3633:
        case 3636:
        case 3637:
        case 3638:
        case 3639:
        case 3655:
        case 3660:
        case 3645:
        case 3662:
          return "Above_Right";
        case 3761:
        case 3764:
        case 3765:
        case 3766:
        case 3767:
        case 3771:
        case 3788:
        case 3789:
          return "Above";
        case 3772:
          return "Below";
      }
      else if (s === 3642) return "Below_Right";
    }
    switch (c) {
      // Hebrew
      case "CCC10":
      case "CCC11":
      case "CCC12":
      case "CCC13":
      case "CCC14":
      case "CCC15":
      case "CCC16":
      case "CCC17":
      case "CCC18":
      case "CCC20":
      case "CCC22":
        return "Below";
      case "CCC23":
        return "Attached_Above";
      case "CCC24":
        return "Above_Right";
      case "CCC25":
      case "CCC19":
        return "Above_Left";
      case "CCC26":
        return "Above";
      case "CCC21":
        break;
      // Arabic and Syriac
      case "CCC27":
      case "CCC28":
      case "CCC30":
      case "CCC31":
      case "CCC33":
      case "CCC34":
      case "CCC35":
      case "CCC36":
        return "Above";
      case "CCC29":
      case "CCC32":
        return "Below";
      // Thai
      case "CCC103":
        return "Below_Right";
      case "CCC107":
        return "Above_Right";
      // Lao
      case "CCC118":
        return "Below";
      case "CCC122":
        return "Above";
      // Tibetan
      case "CCC129":
      case "CCC132":
        return "Below";
      case "CCC130":
        return "Above";
    }
    return c;
  }
  constructor(s) {
    this.font = s;
  }
}
class $f34600ab9d7f70d8$export$2e2bcd8739ae039 {
  /**
  * The width of the bounding box
  * @type {number}
  */
  get width() {
    return this.maxX - this.minX;
  }
  /**
  * The height of the bounding box
  * @type {number}
  */
  get height() {
    return this.maxY - this.minY;
  }
  addPoint(s, c) {
    Math.abs(s) !== 1 / 0 && (s < this.minX && (this.minX = s), s > this.maxX && (this.maxX = s)), Math.abs(c) !== 1 / 0 && (c < this.minY && (this.minY = c), c > this.maxY && (this.maxY = c));
  }
  copy() {
    return new $f34600ab9d7f70d8$export$2e2bcd8739ae039(this.minX, this.minY, this.maxX, this.maxY);
  }
  constructor(s = 1 / 0, c = 1 / 0, u = -1 / 0, d = -1 / 0) {
    this.minX = s, this.minY = c, this.maxX = u, this.maxY = d;
  }
}
const $130d1a642ebcd2b7$var$UNICODE_SCRIPTS = {
  Caucasian_Albanian: "aghb",
  Arabic: "arab",
  Imperial_Aramaic: "armi",
  Armenian: "armn",
  Avestan: "avst",
  Balinese: "bali",
  Bamum: "bamu",
  Bassa_Vah: "bass",
  Batak: "batk",
  Bengali: [
    "bng2",
    "beng"
  ],
  Bopomofo: "bopo",
  Brahmi: "brah",
  Braille: "brai",
  Buginese: "bugi",
  Buhid: "buhd",
  Chakma: "cakm",
  Canadian_Aboriginal: "cans",
  Carian: "cari",
  Cham: "cham",
  Cherokee: "cher",
  Coptic: "copt",
  Cypriot: "cprt",
  Cyrillic: "cyrl",
  Devanagari: [
    "dev2",
    "deva"
  ],
  Deseret: "dsrt",
  Duployan: "dupl",
  Egyptian_Hieroglyphs: "egyp",
  Elbasan: "elba",
  Ethiopic: "ethi",
  Georgian: "geor",
  Glagolitic: "glag",
  Gothic: "goth",
  Grantha: "gran",
  Greek: "grek",
  Gujarati: [
    "gjr2",
    "gujr"
  ],
  Gurmukhi: [
    "gur2",
    "guru"
  ],
  Hangul: "hang",
  Han: "hani",
  Hanunoo: "hano",
  Hebrew: "hebr",
  Hiragana: "hira",
  Pahawh_Hmong: "hmng",
  Katakana_Or_Hiragana: "hrkt",
  Old_Italic: "ital",
  Javanese: "java",
  Kayah_Li: "kali",
  Katakana: "kana",
  Kharoshthi: "khar",
  Khmer: "khmr",
  Khojki: "khoj",
  Kannada: [
    "knd2",
    "knda"
  ],
  Kaithi: "kthi",
  Tai_Tham: "lana",
  Lao: "lao ",
  Latin: "latn",
  Lepcha: "lepc",
  Limbu: "limb",
  Linear_A: "lina",
  Linear_B: "linb",
  Lisu: "lisu",
  Lycian: "lyci",
  Lydian: "lydi",
  Mahajani: "mahj",
  Mandaic: "mand",
  Manichaean: "mani",
  Mende_Kikakui: "mend",
  Meroitic_Cursive: "merc",
  Meroitic_Hieroglyphs: "mero",
  Malayalam: [
    "mlm2",
    "mlym"
  ],
  Modi: "modi",
  Mongolian: "mong",
  Mro: "mroo",
  Meetei_Mayek: "mtei",
  Myanmar: [
    "mym2",
    "mymr"
  ],
  Old_North_Arabian: "narb",
  Nabataean: "nbat",
  Nko: "nko ",
  Ogham: "ogam",
  Ol_Chiki: "olck",
  Old_Turkic: "orkh",
  Oriya: [
    "ory2",
    "orya"
  ],
  Osmanya: "osma",
  Palmyrene: "palm",
  Pau_Cin_Hau: "pauc",
  Old_Permic: "perm",
  Phags_Pa: "phag",
  Inscriptional_Pahlavi: "phli",
  Psalter_Pahlavi: "phlp",
  Phoenician: "phnx",
  Miao: "plrd",
  Inscriptional_Parthian: "prti",
  Rejang: "rjng",
  Runic: "runr",
  Samaritan: "samr",
  Old_South_Arabian: "sarb",
  Saurashtra: "saur",
  Shavian: "shaw",
  Sharada: "shrd",
  Siddham: "sidd",
  Khudawadi: "sind",
  Sinhala: "sinh",
  Sora_Sompeng: "sora",
  Sundanese: "sund",
  Syloti_Nagri: "sylo",
  Syriac: "syrc",
  Tagbanwa: "tagb",
  Takri: "takr",
  Tai_Le: "tale",
  New_Tai_Lue: "talu",
  Tamil: [
    "tml2",
    "taml"
  ],
  Tai_Viet: "tavt",
  Telugu: [
    "tel2",
    "telu"
  ],
  Tifinagh: "tfng",
  Tagalog: "tglg",
  Thaana: "thaa",
  Thai: "thai",
  Tibetan: "tibt",
  Tirhuta: "tirh",
  Ugaritic: "ugar",
  Vai: "vai ",
  Warang_Citi: "wara",
  Old_Persian: "xpeo",
  Cuneiform: "xsux",
  Yi: "yi  ",
  Inherited: "zinh",
  Common: "zyyy",
  Unknown: "zzzz"
}, $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS = {};
for (let a in $130d1a642ebcd2b7$var$UNICODE_SCRIPTS) {
  let s = $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[a];
  if (Array.isArray(s)) for (let c of s) $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[c] = a;
  else $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[s] = a;
}
function $130d1a642ebcd2b7$export$ce50e82f12a827a4(a) {
  return $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[a];
}
function $130d1a642ebcd2b7$export$e5cb25e204fb8450(a) {
  let s = a.length, c = 0;
  for (; c < s; ) {
    let u = a.charCodeAt(c++);
    if (55296 <= u && u <= 56319 && c < s) {
      let p = a.charCodeAt(c);
      56320 <= p && p <= 57343 && (c++, u = ((u & 1023) << 10) + (p & 1023) + 65536);
    }
    let d = $747425b437e121da$export$941569448d136665(u);
    if (d !== "Common" && d !== "Inherited" && d !== "Unknown") return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[d];
  }
  return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS.Unknown;
}
function $130d1a642ebcd2b7$export$16fab0757cfc223d(a) {
  for (let s = 0; s < a.length; s++) {
    let c = a[s], u = $747425b437e121da$export$941569448d136665(c);
    if (u !== "Common" && u !== "Inherited" && u !== "Unknown") return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[u];
  }
  return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS.Unknown;
}
const $130d1a642ebcd2b7$var$RTL = {
  arab: !0,
  hebr: !0,
  syrc: !0,
  thaa: !0,
  cprt: !0,
  khar: !0,
  phnx: !0,
  "nko ": !0,
  lydi: !0,
  avst: !0,
  armi: !0,
  phli: !0,
  prti: !0,
  sarb: !0,
  orkh: !0,
  samr: !0,
  mand: !0,
  merc: !0,
  mero: !0,
  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
  mani: !0,
  mend: !0,
  nbat: !0,
  narb: !0,
  palm: !0,
  phlp: !0
  // Psalter Pahlavi
};
function $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(a) {
  return $130d1a642ebcd2b7$var$RTL[a] ? "rtl" : "ltr";
}
class $be07b3e97a42687a$export$2e2bcd8739ae039 {
  /**
  * The total advance width of the run.
  * @type {number}
  */
  get advanceWidth() {
    let s = 0;
    for (let c of this.positions) s += c.xAdvance;
    return s;
  }
  /**
  * The total advance height of the run.
  * @type {number}
  */
  get advanceHeight() {
    let s = 0;
    for (let c of this.positions) s += c.yAdvance;
    return s;
  }
  /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */
  get bbox() {
    let s = new $f34600ab9d7f70d8$export$2e2bcd8739ae039(), c = 0, u = 0;
    for (let d = 0; d < this.glyphs.length; d++) {
      let p = this.glyphs[d], v = this.positions[d], A = p.bbox;
      s.addPoint(A.minX + c + v.xOffset, A.minY + u + v.yOffset), s.addPoint(A.maxX + c + v.xOffset, A.maxY + u + v.yOffset), c += v.xAdvance, u += v.yAdvance;
    }
    return s;
  }
  constructor(s, c, u, d, p) {
    if (this.glyphs = s, this.positions = null, this.script = u, this.language = d || null, this.direction = p || $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(u), this.features = {}, Array.isArray(c)) for (let v of c) this.features[v] = !0;
    else typeof c == "object" && (this.features = c);
  }
}
class $1ac75d9a55b67f01$export$2e2bcd8739ae039 {
  constructor(s = 0, c = 0, u = 0, d = 0) {
    this.xAdvance = s, this.yAdvance = c, this.xOffset = u, this.yOffset = d;
  }
}
const $3b6302b64eccc32c$var$features = {
  allTypographicFeatures: {
    code: 0,
    exclusive: !1,
    allTypeFeatures: 0
  },
  ligatures: {
    code: 1,
    exclusive: !1,
    requiredLigatures: 0,
    commonLigatures: 2,
    rareLigatures: 4,
    // logos: 6
    rebusPictures: 8,
    diphthongLigatures: 10,
    squaredLigatures: 12,
    abbrevSquaredLigatures: 14,
    symbolLigatures: 16,
    contextualLigatures: 18,
    historicalLigatures: 20
  },
  cursiveConnection: {
    code: 2,
    exclusive: !0,
    unconnected: 0,
    partiallyConnected: 1,
    cursive: 2
  },
  letterCase: {
    code: 3,
    exclusive: !0
  },
  // upperAndLowerCase: 0          # deprecated
  // allCaps: 1                    # deprecated
  // allLowerCase: 2               # deprecated
  // smallCaps: 3                  # deprecated
  // initialCaps: 4                # deprecated
  // initialCapsAndSmallCaps: 5    # deprecated
  verticalSubstitution: {
    code: 4,
    exclusive: !1,
    substituteVerticalForms: 0
  },
  linguisticRearrangement: {
    code: 5,
    exclusive: !1,
    linguisticRearrangement: 0
  },
  numberSpacing: {
    code: 6,
    exclusive: !0,
    monospacedNumbers: 0,
    proportionalNumbers: 1,
    thirdWidthNumbers: 2,
    quarterWidthNumbers: 3
  },
  smartSwash: {
    code: 8,
    exclusive: !1,
    wordInitialSwashes: 0,
    wordFinalSwashes: 2,
    // lineInitialSwashes: 4
    // lineFinalSwashes: 6
    nonFinalSwashes: 8
  },
  diacritics: {
    code: 9,
    exclusive: !0,
    showDiacritics: 0,
    hideDiacritics: 1,
    decomposeDiacritics: 2
  },
  verticalPosition: {
    code: 10,
    exclusive: !0,
    normalPosition: 0,
    superiors: 1,
    inferiors: 2,
    ordinals: 3,
    scientificInferiors: 4
  },
  fractions: {
    code: 11,
    exclusive: !0,
    noFractions: 0,
    verticalFractions: 1,
    diagonalFractions: 2
  },
  overlappingCharacters: {
    code: 13,
    exclusive: !1,
    preventOverlap: 0
  },
  typographicExtras: {
    code: 14,
    exclusive: !1,
    // hyphensToEmDash: 0
    // hyphenToEnDash: 2
    slashedZero: 4
  },
  // formInterrobang: 6
  // smartQuotes: 8
  // periodsToEllipsis: 10
  mathematicalExtras: {
    code: 15,
    exclusive: !1,
    // hyphenToMinus: 0
    // asteristoMultiply: 2
    // slashToDivide: 4
    // inequalityLigatures: 6
    // exponents: 8
    mathematicalGreek: 10
  },
  ornamentSets: {
    code: 16,
    exclusive: !0,
    noOrnaments: 0,
    dingbats: 1,
    piCharacters: 2,
    fleurons: 3,
    decorativeBorders: 4,
    internationalSymbols: 5,
    mathSymbols: 6
  },
  characterAlternatives: {
    code: 17,
    exclusive: !0,
    noAlternates: 0
  },
  // user defined options
  designComplexity: {
    code: 18,
    exclusive: !0,
    designLevel1: 0,
    designLevel2: 1,
    designLevel3: 2,
    designLevel4: 3,
    designLevel5: 4
  },
  styleOptions: {
    code: 19,
    exclusive: !0,
    noStyleOptions: 0,
    displayText: 1,
    engravedText: 2,
    illuminatedCaps: 3,
    titlingCaps: 4,
    tallCaps: 5
  },
  characterShape: {
    code: 20,
    exclusive: !0,
    traditionalCharacters: 0,
    simplifiedCharacters: 1,
    JIS1978Characters: 2,
    JIS1983Characters: 3,
    JIS1990Characters: 4,
    traditionalAltOne: 5,
    traditionalAltTwo: 6,
    traditionalAltThree: 7,
    traditionalAltFour: 8,
    traditionalAltFive: 9,
    expertCharacters: 10,
    JIS2004Characters: 11,
    hojoCharacters: 12,
    NLCCharacters: 13,
    traditionalNamesCharacters: 14
  },
  numberCase: {
    code: 21,
    exclusive: !0,
    lowerCaseNumbers: 0,
    upperCaseNumbers: 1
  },
  textSpacing: {
    code: 22,
    exclusive: !0,
    proportionalText: 0,
    monospacedText: 1,
    halfWidthText: 2,
    thirdWidthText: 3,
    quarterWidthText: 4,
    altProportionalText: 5,
    altHalfWidthText: 6
  },
  transliteration: {
    code: 23,
    exclusive: !0,
    noTransliteration: 0
  },
  // hanjaToHangul: 1
  // hiraganaToKatakana: 2
  // katakanaToHiragana: 3
  // kanaToRomanization: 4
  // romanizationToHiragana: 5
  // romanizationToKatakana: 6
  // hanjaToHangulAltOne: 7
  // hanjaToHangulAltTwo: 8
  // hanjaToHangulAltThree: 9
  annotation: {
    code: 24,
    exclusive: !0,
    noAnnotation: 0,
    boxAnnotation: 1,
    roundedBoxAnnotation: 2,
    circleAnnotation: 3,
    invertedCircleAnnotation: 4,
    parenthesisAnnotation: 5,
    periodAnnotation: 6,
    romanNumeralAnnotation: 7,
    diamondAnnotation: 8,
    invertedBoxAnnotation: 9,
    invertedRoundedBoxAnnotation: 10
  },
  kanaSpacing: {
    code: 25,
    exclusive: !0,
    fullWidthKana: 0,
    proportionalKana: 1
  },
  ideographicSpacing: {
    code: 26,
    exclusive: !0,
    fullWidthIdeographs: 0,
    proportionalIdeographs: 1,
    halfWidthIdeographs: 2
  },
  unicodeDecomposition: {
    code: 27,
    exclusive: !1,
    canonicalComposition: 0,
    compatibilityComposition: 2,
    transcodingComposition: 4
  },
  rubyKana: {
    code: 28,
    exclusive: !1,
    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
    // rubyKana: 1     # deprecated - use rubyKanaOn instead
    rubyKana: 2
  },
  CJKSymbolAlternatives: {
    code: 29,
    exclusive: !0,
    noCJKSymbolAlternatives: 0,
    CJKSymbolAltOne: 1,
    CJKSymbolAltTwo: 2,
    CJKSymbolAltThree: 3,
    CJKSymbolAltFour: 4,
    CJKSymbolAltFive: 5
  },
  ideographicAlternatives: {
    code: 30,
    exclusive: !0,
    noIdeographicAlternatives: 0,
    ideographicAltOne: 1,
    ideographicAltTwo: 2,
    ideographicAltThree: 3,
    ideographicAltFour: 4,
    ideographicAltFive: 5
  },
  CJKVerticalRomanPlacement: {
    code: 31,
    exclusive: !0,
    CJKVerticalRomanCentered: 0,
    CJKVerticalRomanHBaseline: 1
  },
  italicCJKRoman: {
    code: 32,
    exclusive: !1,
    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
    CJKItalicRoman: 2
  },
  caseSensitiveLayout: {
    code: 33,
    exclusive: !1,
    caseSensitiveLayout: 0,
    caseSensitiveSpacing: 2
  },
  alternateKana: {
    code: 34,
    exclusive: !1,
    alternateHorizKana: 0,
    alternateVertKana: 2
  },
  stylisticAlternatives: {
    code: 35,
    exclusive: !1,
    noStylisticAlternates: 0,
    stylisticAltOne: 2,
    stylisticAltTwo: 4,
    stylisticAltThree: 6,
    stylisticAltFour: 8,
    stylisticAltFive: 10,
    stylisticAltSix: 12,
    stylisticAltSeven: 14,
    stylisticAltEight: 16,
    stylisticAltNine: 18,
    stylisticAltTen: 20,
    stylisticAltEleven: 22,
    stylisticAltTwelve: 24,
    stylisticAltThirteen: 26,
    stylisticAltFourteen: 28,
    stylisticAltFifteen: 30,
    stylisticAltSixteen: 32,
    stylisticAltSeventeen: 34,
    stylisticAltEighteen: 36,
    stylisticAltNineteen: 38,
    stylisticAltTwenty: 40
  },
  contextualAlternates: {
    code: 36,
    exclusive: !1,
    contextualAlternates: 0,
    swashAlternates: 2,
    contextualSwashAlternates: 4
  },
  lowerCase: {
    code: 37,
    exclusive: !0,
    defaultLowerCase: 0,
    lowerCaseSmallCaps: 1,
    lowerCasePetiteCaps: 2
  },
  upperCase: {
    code: 38,
    exclusive: !0,
    defaultUpperCase: 0,
    upperCaseSmallCaps: 1,
    upperCasePetiteCaps: 2
  },
  languageTag: {
    code: 39,
    exclusive: !0
  },
  CJKRomanSpacing: {
    code: 103,
    exclusive: !0,
    halfWidthCJKRoman: 0,
    proportionalCJKRoman: 1,
    defaultCJKRoman: 2,
    fullWidthCJKRoman: 3
  }
}, $3b6302b64eccc32c$var$feature = (a, s) => [
  $3b6302b64eccc32c$var$features[a].code,
  $3b6302b64eccc32c$var$features[a][s]
], $3b6302b64eccc32c$var$OTMapping = {
  rlig: $3b6302b64eccc32c$var$feature("ligatures", "requiredLigatures"),
  clig: $3b6302b64eccc32c$var$feature("ligatures", "contextualLigatures"),
  dlig: $3b6302b64eccc32c$var$feature("ligatures", "rareLigatures"),
  hlig: $3b6302b64eccc32c$var$feature("ligatures", "historicalLigatures"),
  liga: $3b6302b64eccc32c$var$feature("ligatures", "commonLigatures"),
  hist: $3b6302b64eccc32c$var$feature("ligatures", "historicalLigatures"),
  smcp: $3b6302b64eccc32c$var$feature("lowerCase", "lowerCaseSmallCaps"),
  pcap: $3b6302b64eccc32c$var$feature("lowerCase", "lowerCasePetiteCaps"),
  frac: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  dnom: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  numr: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  afrc: $3b6302b64eccc32c$var$feature("fractions", "verticalFractions"),
  // aalt
  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
  // unic, vatu, vhal, vjmo, vpal, vrt2
  // dist -> trak table?
  // kern, vkrn -> kern table
  // lfbd + opbd + rtbd -> opbd table?
  // mark, mkmk -> acnt table?
  // locl -> languageTag + ltag table
  case: $3b6302b64eccc32c$var$feature("caseSensitiveLayout", "caseSensitiveLayout"),
  ccmp: $3b6302b64eccc32c$var$feature("unicodeDecomposition", "canonicalComposition"),
  cpct: $3b6302b64eccc32c$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  valt: $3b6302b64eccc32c$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  swsh: $3b6302b64eccc32c$var$feature("contextualAlternates", "swashAlternates"),
  cswh: $3b6302b64eccc32c$var$feature("contextualAlternates", "contextualSwashAlternates"),
  curs: $3b6302b64eccc32c$var$feature("cursiveConnection", "cursive"),
  c2pc: $3b6302b64eccc32c$var$feature("upperCase", "upperCasePetiteCaps"),
  c2sc: $3b6302b64eccc32c$var$feature("upperCase", "upperCaseSmallCaps"),
  init: $3b6302b64eccc32c$var$feature("smartSwash", "wordInitialSwashes"),
  fin2: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  medi: $3b6302b64eccc32c$var$feature("smartSwash", "nonFinalSwashes"),
  med2: $3b6302b64eccc32c$var$feature("smartSwash", "nonFinalSwashes"),
  fin3: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  fina: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  pkna: $3b6302b64eccc32c$var$feature("kanaSpacing", "proportionalKana"),
  half: $3b6302b64eccc32c$var$feature("textSpacing", "halfWidthText"),
  halt: $3b6302b64eccc32c$var$feature("textSpacing", "altHalfWidthText"),
  hkna: $3b6302b64eccc32c$var$feature("alternateKana", "alternateHorizKana"),
  vkna: $3b6302b64eccc32c$var$feature("alternateKana", "alternateVertKana"),
  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
  ital: $3b6302b64eccc32c$var$feature("italicCJKRoman", "CJKItalicRoman"),
  lnum: $3b6302b64eccc32c$var$feature("numberCase", "upperCaseNumbers"),
  onum: $3b6302b64eccc32c$var$feature("numberCase", "lowerCaseNumbers"),
  mgrk: $3b6302b64eccc32c$var$feature("mathematicalExtras", "mathematicalGreek"),
  // nalt: not enough info. what type of annotation?
  // ornm: ditto, which ornament style?
  calt: $3b6302b64eccc32c$var$feature("contextualAlternates", "contextualAlternates"),
  vrt2: $3b6302b64eccc32c$var$feature("verticalSubstitution", "substituteVerticalForms"),
  vert: $3b6302b64eccc32c$var$feature("verticalSubstitution", "substituteVerticalForms"),
  tnum: $3b6302b64eccc32c$var$feature("numberSpacing", "monospacedNumbers"),
  pnum: $3b6302b64eccc32c$var$feature("numberSpacing", "proportionalNumbers"),
  sups: $3b6302b64eccc32c$var$feature("verticalPosition", "superiors"),
  subs: $3b6302b64eccc32c$var$feature("verticalPosition", "inferiors"),
  ordn: $3b6302b64eccc32c$var$feature("verticalPosition", "ordinals"),
  pwid: $3b6302b64eccc32c$var$feature("textSpacing", "proportionalText"),
  hwid: $3b6302b64eccc32c$var$feature("textSpacing", "halfWidthText"),
  qwid: $3b6302b64eccc32c$var$feature("textSpacing", "quarterWidthText"),
  twid: $3b6302b64eccc32c$var$feature("textSpacing", "thirdWidthText"),
  fwid: $3b6302b64eccc32c$var$feature("textSpacing", "proportionalText"),
  palt: $3b6302b64eccc32c$var$feature("textSpacing", "altProportionalText"),
  trad: $3b6302b64eccc32c$var$feature("characterShape", "traditionalCharacters"),
  smpl: $3b6302b64eccc32c$var$feature("characterShape", "simplifiedCharacters"),
  jp78: $3b6302b64eccc32c$var$feature("characterShape", "JIS1978Characters"),
  jp83: $3b6302b64eccc32c$var$feature("characterShape", "JIS1983Characters"),
  jp90: $3b6302b64eccc32c$var$feature("characterShape", "JIS1990Characters"),
  jp04: $3b6302b64eccc32c$var$feature("characterShape", "JIS2004Characters"),
  expt: $3b6302b64eccc32c$var$feature("characterShape", "expertCharacters"),
  hojo: $3b6302b64eccc32c$var$feature("characterShape", "hojoCharacters"),
  nlck: $3b6302b64eccc32c$var$feature("characterShape", "NLCCharacters"),
  tnam: $3b6302b64eccc32c$var$feature("characterShape", "traditionalNamesCharacters"),
  ruby: $3b6302b64eccc32c$var$feature("rubyKana", "rubyKana"),
  titl: $3b6302b64eccc32c$var$feature("styleOptions", "titlingCaps"),
  zero: $3b6302b64eccc32c$var$feature("typographicExtras", "slashedZero"),
  ss01: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltOne"),
  ss02: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwo"),
  ss03: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltThree"),
  ss04: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFour"),
  ss05: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFive"),
  ss06: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSix"),
  ss07: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSeven"),
  ss08: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEight"),
  ss09: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltNine"),
  ss10: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTen"),
  ss11: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEleven"),
  ss12: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwelve"),
  ss13: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltThirteen"),
  ss14: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFourteen"),
  ss15: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFifteen"),
  ss16: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSixteen"),
  ss17: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSeventeen"),
  ss18: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEighteen"),
  ss19: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltNineteen"),
  ss20: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwenty")
};
for (let a = 1; a <= 99; a++) $3b6302b64eccc32c$var$OTMapping[`cv${`00${a}`.slice(-2)}`] = [
  $3b6302b64eccc32c$var$features.characterAlternatives.code,
  a
];
let $3b6302b64eccc32c$var$AATMapping = {};
for (let a in $3b6302b64eccc32c$var$OTMapping) {
  let s = $3b6302b64eccc32c$var$OTMapping[a];
  $3b6302b64eccc32c$var$AATMapping[s[0]] == null && ($3b6302b64eccc32c$var$AATMapping[s[0]] = {}), $3b6302b64eccc32c$var$AATMapping[s[0]][s[1]] = a;
}
function $3b6302b64eccc32c$export$b813f7d2a1677c16(a) {
  let s = {};
  for (let c in a) {
    let u;
    (u = $3b6302b64eccc32c$var$OTMapping[c]) && (s[u[0]] == null && (s[u[0]] = {}), s[u[0]][u[1]] = a[c]);
  }
  return s;
}
function $3b6302b64eccc32c$var$mapFeatureStrings(a) {
  let [s, c] = a;
  if (isNaN(s)) var u = $3b6302b64eccc32c$var$features[s] && $3b6302b64eccc32c$var$features[s].code;
  else var u = s;
  if (isNaN(c)) var d = $3b6302b64eccc32c$var$features[s] && $3b6302b64eccc32c$var$features[s][c];
  else var d = c;
  return [
    u,
    d
  ];
}
function $3b6302b64eccc32c$export$bd6df347a4f391c4(a) {
  let s = {};
  if (Array.isArray(a)) for (let c = 0; c < a.length; c++) {
    let u, d = $3b6302b64eccc32c$var$mapFeatureStrings(a[c]);
    (u = $3b6302b64eccc32c$var$AATMapping[d[0]] && $3b6302b64eccc32c$var$AATMapping[d[0]][d[1]]) && (s[u] = !0);
  }
  else if (typeof a == "object") for (let c in a) {
    let u = a[c];
    for (let d in u) {
      let p, v = $3b6302b64eccc32c$var$mapFeatureStrings([
        c,
        d
      ]);
      u[d] && (p = $3b6302b64eccc32c$var$AATMapping[v[0]] && $3b6302b64eccc32c$var$AATMapping[v[0]][v[1]]) && (s[p] = !0);
    }
  }
  return Object.keys(s);
}
class $ff5ce077dae0f144$export$2e2bcd8739ae039 {
  lookup(s) {
    switch (this.table.version) {
      case 0:
        return this.table.values.getItem(s);
      case 2:
      case 4: {
        let d = 0, p = this.table.binarySearchHeader.nUnits - 1;
        for (; d <= p; ) {
          var c = d + p >> 1, u = this.table.segments[c];
          if (u.firstGlyph === 65535) return null;
          if (s < u.firstGlyph) p = c - 1;
          else if (s > u.lastGlyph) d = c + 1;
          else
            return this.table.version === 2 ? u.value : u.values[s - u.firstGlyph];
        }
        return null;
      }
      case 6: {
        let d = 0, p = this.table.binarySearchHeader.nUnits - 1;
        for (; d <= p; ) {
          var c = d + p >> 1, u = this.table.segments[c];
          if (u.glyph === 65535) return null;
          if (s < u.glyph) p = c - 1;
          else if (s > u.glyph) d = c + 1;
          else return u.value;
        }
        return null;
      }
      case 8:
        return this.table.values[s - this.table.firstGlyph];
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
  }
  glyphsForValue(s) {
    let c = [];
    switch (this.table.version) {
      case 2:
      case 4:
        for (let u of this.table.segments) if (this.table.version === 2 && u.value === s) c.push(...$12727730ddfc8bfe$export$d02631cccf789723(u.firstGlyph, u.lastGlyph + 1));
        else
          for (let d = 0; d < u.values.length; d++) u.values[d] === s && c.push(u.firstGlyph + d);
        break;
      case 6:
        for (let u of this.table.segments) u.value === s && c.push(u.glyph);
        break;
      case 8:
        for (let u = 0; u < this.table.values.length; u++) this.table.values[u] === s && c.push(this.table.firstGlyph + u);
        break;
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
    return c;
  }
  constructor(s) {
    this.table = s;
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $ff5ce077dae0f144$export$2e2bcd8739ae039.prototype, "glyphsForValue", null);
const $50c7aac9316f2948$var$START_OF_TEXT_STATE = 0, $50c7aac9316f2948$var$END_OF_TEXT_CLASS = 0, $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS = 1, $50c7aac9316f2948$var$DELETED_GLYPH_CLASS = 2, $50c7aac9316f2948$var$DONT_ADVANCE = 16384;
class $50c7aac9316f2948$export$2e2bcd8739ae039 {
  process(s, c, u) {
    let d = $50c7aac9316f2948$var$START_OF_TEXT_STATE, p = c ? s.length - 1 : 0, v = c ? -1 : 1;
    for (; v === 1 && p <= s.length || v === -1 && p >= -1; ) {
      let A = null, x = $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS, g = !0;
      p === s.length || p === -1 ? x = $50c7aac9316f2948$var$END_OF_TEXT_CLASS : (A = s[p], A.id === 65535 ? x = $50c7aac9316f2948$var$DELETED_GLYPH_CLASS : (x = this.lookupTable.lookup(A.id), x == null && (x = $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS)));
      let y = this.stateTable.stateArray.getItem(d)[x], f = this.stateTable.entryTable.getItem(y);
      x !== $50c7aac9316f2948$var$END_OF_TEXT_CLASS && x !== $50c7aac9316f2948$var$DELETED_GLYPH_CLASS && (u(A, f, p), g = !(f.flags & $50c7aac9316f2948$var$DONT_ADVANCE)), d = f.newState, g && (p += v);
    }
    return s;
  }
  /**
  * Performs a depth-first traversal of the glyph strings
  * represented by the state machine.
  */
  traverse(s, c = 0, u = /* @__PURE__ */ new Set()) {
    if (u.has(c)) return;
    u.add(c);
    let { nClasses: d, stateArray: p, entryTable: v } = this.stateTable, A = p.getItem(c);
    for (let x = 4; x < d; x++) {
      let g = A[x], b = v.getItem(g);
      for (let y of this.lookupTable.glyphsForValue(x))
        s.enter && s.enter(y, b), b.newState !== 0 && this.traverse(s, b.newState, u), s.exit && s.exit(y, b);
    }
  }
  constructor(s) {
    this.stateTable = s, this.lookupTable = new $ff5ce077dae0f144$export$2e2bcd8739ae039(s.classTable);
  }
}
const $55f71433a605c87d$var$MARK_FIRST = 32768, $55f71433a605c87d$var$MARK_LAST = 8192, $55f71433a605c87d$var$VERB = 15, $55f71433a605c87d$var$SET_MARK = 32768, $55f71433a605c87d$var$SET_COMPONENT = 32768, $55f71433a605c87d$var$PERFORM_ACTION = 8192, $55f71433a605c87d$var$LAST_MASK = 2147483648, $55f71433a605c87d$var$STORE_MASK = 1073741824, $55f71433a605c87d$var$OFFSET_MASK = 1073741823, $55f71433a605c87d$var$REVERSE_DIRECTION = 4194304, $55f71433a605c87d$var$CURRENT_INSERT_BEFORE = 2048, $55f71433a605c87d$var$MARKED_INSERT_BEFORE = 1024, $55f71433a605c87d$var$CURRENT_INSERT_COUNT = 992, $55f71433a605c87d$var$MARKED_INSERT_COUNT = 31;
class $55f71433a605c87d$export$2e2bcd8739ae039 {
  // Processes an array of glyphs and applies the specified features
  // Features should be in the form of {featureType:{featureSetting:boolean}}
  process(s, c = {}) {
    for (let d of this.morx.chains) {
      let p = d.defaultFlags;
      for (let v of d.features) {
        let A;
        (A = c[v.featureType]) && (A[v.featureSetting] ? (p &= v.disableFlags, p |= v.enableFlags) : A[v.featureSetting] === !1 && (p |= ~v.disableFlags, p &= ~v.enableFlags));
      }
      for (let v of d.subtables) v.subFeatureFlags & p && this.processSubtable(v, s);
    }
    let u = s.length - 1;
    for (; u >= 0; )
      s[u].id === 65535 && s.splice(u, 1), u--;
    return s;
  }
  processSubtable(s, c) {
    if (this.subtable = s, this.glyphs = c, this.subtable.type === 4) {
      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
      return;
    }
    this.ligatureStack = [], this.markedGlyph = null, this.firstGlyph = null, this.lastGlyph = null, this.markedIndex = null;
    let u = this.getStateMachine(s), d = this.getProcessor(), p = !!(this.subtable.coverage & $55f71433a605c87d$var$REVERSE_DIRECTION);
    return u.process(this.glyphs, p, d);
  }
  getStateMachine(s) {
    return new $50c7aac9316f2948$export$2e2bcd8739ae039(s.table.stateTable);
  }
  getProcessor() {
    switch (this.subtable.type) {
      case 0:
        return this.processIndicRearragement;
      case 1:
        return this.processContextualSubstitution;
      case 2:
        return this.processLigature;
      case 4:
        return this.processNoncontextualSubstitutions;
      case 5:
        return this.processGlyphInsertion;
      default:
        throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
    }
  }
  processIndicRearragement(s, c, u) {
    c.flags & $55f71433a605c87d$var$MARK_FIRST && (this.firstGlyph = u), c.flags & $55f71433a605c87d$var$MARK_LAST && (this.lastGlyph = u), $55f71433a605c87d$var$reorderGlyphs(this.glyphs, c.flags & $55f71433a605c87d$var$VERB, this.firstGlyph, this.lastGlyph);
  }
  processContextualSubstitution(s, c, u) {
    let d = this.subtable.table.substitutionTable.items;
    if (c.markIndex !== 65535) {
      let v = d.getItem(c.markIndex), A = new $ff5ce077dae0f144$export$2e2bcd8739ae039(v);
      s = this.glyphs[this.markedGlyph];
      var p = A.lookup(s.id);
      p && (this.glyphs[this.markedGlyph] = this.font.getGlyph(p, s.codePoints));
    }
    if (c.currentIndex !== 65535) {
      let v = d.getItem(c.currentIndex), A = new $ff5ce077dae0f144$export$2e2bcd8739ae039(v);
      s = this.glyphs[u];
      var p = A.lookup(s.id);
      p && (this.glyphs[u] = this.font.getGlyph(p, s.codePoints));
    }
    c.flags & $55f71433a605c87d$var$SET_MARK && (this.markedGlyph = u);
  }
  processLigature(s, c, u) {
    if (c.flags & $55f71433a605c87d$var$SET_COMPONENT && this.ligatureStack.push(u), c.flags & $55f71433a605c87d$var$PERFORM_ACTION) {
      let d = this.subtable.table.ligatureActions, p = this.subtable.table.components, v = this.subtable.table.ligatureList, A = c.action, x = !1, g = 0, b = [], y = [];
      for (; !x; ) {
        let f = this.ligatureStack.pop();
        b.unshift(...this.glyphs[f].codePoints);
        let m = d.getItem(A++);
        x = !!(m & $55f71433a605c87d$var$LAST_MASK);
        let C = !!(m & $55f71433a605c87d$var$STORE_MASK), w = (m & $55f71433a605c87d$var$OFFSET_MASK) << 2 >> 2;
        w += this.glyphs[f].id;
        let S = p.getItem(w);
        if (g += S, x || C) {
          let $ = v.getItem(g);
          this.glyphs[f] = this.font.getGlyph($, b), y.push(f), g = 0, b = [];
        } else this.glyphs[f] = this.font.getGlyph(65535);
      }
      this.ligatureStack.push(...y);
    }
  }
  processNoncontextualSubstitutions(s, c, u) {
    let d = new $ff5ce077dae0f144$export$2e2bcd8739ae039(s.table.lookupTable);
    for (u = 0; u < c.length; u++) {
      let p = c[u];
      if (p.id !== 65535) {
        let v = d.lookup(p.id);
        v && (c[u] = this.font.getGlyph(v, p.codePoints));
      }
    }
  }
  _insertGlyphs(s, c, u, d) {
    let p = [];
    for (; u--; ) {
      let v = this.subtable.table.insertionActions.getItem(c++);
      p.push(this.font.getGlyph(v));
    }
    d || s++, this.glyphs.splice(s, 0, ...p);
  }
  processGlyphInsertion(s, c, u) {
    if (c.flags & $55f71433a605c87d$var$SET_MARK && (this.markedIndex = u), c.markedInsertIndex !== 65535) {
      let d = (c.flags & $55f71433a605c87d$var$MARKED_INSERT_COUNT) >>> 5, p = !!(c.flags & $55f71433a605c87d$var$MARKED_INSERT_BEFORE);
      this._insertGlyphs(this.markedIndex, c.markedInsertIndex, d, p);
    }
    if (c.currentInsertIndex !== 65535) {
      let d = (c.flags & $55f71433a605c87d$var$CURRENT_INSERT_COUNT) >>> 5, p = !!(c.flags & $55f71433a605c87d$var$CURRENT_INSERT_BEFORE);
      this._insertGlyphs(u, c.currentInsertIndex, d, p);
    }
  }
  getSupportedFeatures() {
    let s = [];
    for (let c of this.morx.chains) for (let u of c.features) s.push([
      u.featureType,
      u.featureSetting
    ]);
    return s;
  }
  generateInputs(s) {
    return this.inputCache || this.generateInputCache(), this.inputCache[s] || [];
  }
  generateInputCache() {
    this.inputCache = {};
    for (let s of this.morx.chains) {
      let c = s.defaultFlags;
      for (let u of s.subtables) u.subFeatureFlags & c && this.generateInputsForSubtable(u);
    }
  }
  generateInputsForSubtable(s) {
    if (s.type !== 2) return;
    if (!!(s.coverage & $55f71433a605c87d$var$REVERSE_DIRECTION)) throw new Error("Reverse subtable, not supported.");
    this.subtable = s, this.ligatureStack = [];
    let u = this.getStateMachine(s), d = this.getProcessor(), p = [], v = [];
    this.glyphs = [], u.traverse({
      enter: (A, x) => {
        let g = this.glyphs;
        v.push({
          glyphs: g.slice(),
          ligatureStack: this.ligatureStack.slice()
        });
        let b = this.font.getGlyph(A);
        p.push(b), g.push(p[p.length - 1]), d(g[g.length - 1], x, g.length - 1);
        let y = 0, f = 0;
        for (let m = 0; m < g.length && y <= 1; m++) g[m].id !== 65535 && (y++, f = g[m].id);
        if (y === 1) {
          let m = p.map((w) => w.id), C = this.inputCache[f];
          C ? C.push(m) : this.inputCache[f] = [
            m
          ];
        }
      },
      exit: () => {
        ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = v.pop()), p.pop();
      }
    });
  }
  constructor(s) {
    this.processIndicRearragement = this.processIndicRearragement.bind(this), this.processContextualSubstitution = this.processContextualSubstitution.bind(this), this.processLigature = this.processLigature.bind(this), this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this), this.processGlyphInsertion = this.processGlyphInsertion.bind(this), this.font = s, this.morx = s.morx, this.inputCache = null;
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $55f71433a605c87d$export$2e2bcd8739ae039.prototype, "getStateMachine", null);
function $55f71433a605c87d$var$swap(a, s, c, u = !1, d = !1) {
  let p = a.splice(c[0] - (c[1] - 1), c[1]);
  d && p.reverse();
  let v = a.splice(s[0], s[1], ...p);
  return u && v.reverse(), a.splice(c[0] - (s[1] - 1), 0, ...v), a;
}
function $55f71433a605c87d$var$reorderGlyphs(a, s, c, u) {
  switch (s) {
    case 0:
      return a;
    case 1:
      return $55f71433a605c87d$var$swap(a, [
        c,
        1
      ], [
        u,
        0
      ]);
    case 2:
      return $55f71433a605c87d$var$swap(a, [
        c,
        0
      ], [
        u,
        1
      ]);
    case 3:
      return $55f71433a605c87d$var$swap(a, [
        c,
        1
      ], [
        u,
        1
      ]);
    case 4:
      return $55f71433a605c87d$var$swap(a, [
        c,
        2
      ], [
        u,
        0
      ]);
    case 5:
      return $55f71433a605c87d$var$swap(a, [
        c,
        2
      ], [
        u,
        0
      ], !0, !1);
    case 6:
      return $55f71433a605c87d$var$swap(a, [
        c,
        0
      ], [
        u,
        2
      ]);
    case 7:
      return $55f71433a605c87d$var$swap(a, [
        c,
        0
      ], [
        u,
        2
      ], !1, !0);
    case 8:
      return $55f71433a605c87d$var$swap(a, [
        c,
        1
      ], [
        u,
        2
      ]);
    case 9:
      return $55f71433a605c87d$var$swap(a, [
        c,
        1
      ], [
        u,
        2
      ], !1, !0);
    case 10:
      return $55f71433a605c87d$var$swap(a, [
        c,
        2
      ], [
        u,
        1
      ]);
    case 11:
      return $55f71433a605c87d$var$swap(a, [
        c,
        2
      ], [
        u,
        1
      ], !0, !1);
    case 12:
      return $55f71433a605c87d$var$swap(a, [
        c,
        2
      ], [
        u,
        2
      ]);
    case 13:
      return $55f71433a605c87d$var$swap(a, [
        c,
        2
      ], [
        u,
        2
      ], !0, !1);
    case 14:
      return $55f71433a605c87d$var$swap(a, [
        c,
        2
      ], [
        u,
        2
      ], !1, !0);
    case 15:
      return $55f71433a605c87d$var$swap(a, [
        c,
        2
      ], [
        u,
        2
      ], !0, !0);
    default:
      throw new Error(`Unknown verb: ${s}`);
  }
}
class $ba6dd74203be8728$export$2e2bcd8739ae039 {
  substitute(s) {
    s.direction === "rtl" && s.glyphs.reverse(), this.morxProcessor.process(s.glyphs, $3b6302b64eccc32c$export$b813f7d2a1677c16(s.features));
  }
  getAvailableFeatures(s, c) {
    return $3b6302b64eccc32c$export$bd6df347a4f391c4(this.morxProcessor.getSupportedFeatures());
  }
  stringsForGlyph(s) {
    let c = this.morxProcessor.generateInputs(s), u = /* @__PURE__ */ new Set();
    for (let d of c) this._addStrings(d, 0, u, "");
    return u;
  }
  _addStrings(s, c, u, d) {
    let p = this.font._cmapProcessor.codePointsForGlyph(s[c]);
    for (let v of p) {
      let A = d + String.fromCodePoint(v);
      c < s.length - 1 ? this._addStrings(s, c + 1, u, A) : u.add(A);
    }
  }
  constructor(s) {
    this.font = s, this.morxProcessor = new $55f71433a605c87d$export$2e2bcd8739ae039(s), this.fallbackPosition = !1;
  }
}
class $94d7a73bd2edfc9a$export$2e2bcd8739ae039 {
  /**
  * Adds the given features to the last stage.
  * Ignores features that have already been applied.
  */
  _addFeatures(s, c) {
    let u = this.stages.length - 1, d = this.stages[u];
    for (let p of s) this.allFeatures[p] == null && (d.push(p), this.allFeatures[p] = u, c && (this.globalFeatures[p] = !0));
  }
  /**
  * Add features to the last stage
  */
  add(s, c = !0) {
    if (this.stages.length === 0 && this.stages.push([]), typeof s == "string" && (s = [
      s
    ]), Array.isArray(s)) this._addFeatures(s, c);
    else if (typeof s == "object")
      this._addFeatures(s.global || [], !0), this._addFeatures(s.local || [], !1);
    else throw new Error("Unsupported argument to ShapingPlan#add");
  }
  /**
  * Add a new stage
  */
  addStage(s, c) {
    typeof s == "function" ? this.stages.push(s, []) : (this.stages.push([]), this.add(s, c));
  }
  setFeatureOverrides(s) {
    if (Array.isArray(s)) this.add(s);
    else if (typeof s == "object") {
      for (let c in s)
        if (s[c]) this.add(c);
        else if (this.allFeatures[c] != null) {
          let u = this.stages[this.allFeatures[c]];
          u.splice(u.indexOf(c), 1), delete this.allFeatures[c], delete this.globalFeatures[c];
        }
    }
  }
  /**
  * Assigns the global features to the given glyphs
  */
  assignGlobalFeatures(s) {
    for (let c of s) for (let u in this.globalFeatures) c.features[u] = !0;
  }
  /**
  * Executes the planned stages using the given OTProcessor
  */
  process(s, c, u) {
    for (let d of this.stages)
      typeof d == "function" ? u || d(this.font, c, this) : d.length > 0 && s.applyFeatures(d, c, u);
  }
  constructor(s, c, u) {
    this.font = s, this.script = c, this.direction = u, this.stages = [], this.globalFeatures = {}, this.allFeatures = {};
  }
}
const $649970d87335b30f$var$VARIATION_FEATURES = [
  "rvrn"
], $649970d87335b30f$var$COMMON_FEATURES = [
  "ccmp",
  "locl",
  "rlig",
  "mark",
  "mkmk"
], $649970d87335b30f$var$FRACTIONAL_FEATURES = [
  "frac",
  "numr",
  "dnom"
], $649970d87335b30f$var$HORIZONTAL_FEATURES = [
  "calt",
  "clig",
  "liga",
  "rclt",
  "curs",
  "kern"
], $649970d87335b30f$var$DIRECTIONAL_FEATURES = {
  ltr: [
    "ltra",
    "ltrm"
  ],
  rtl: [
    "rtla",
    "rtlm"
  ]
};
class $649970d87335b30f$export$2e2bcd8739ae039 {
  static plan(s, c, u) {
    this.planPreprocessing(s), this.planFeatures(s), this.planPostprocessing(s, u), s.assignGlobalFeatures(c), this.assignFeatures(s, c);
  }
  static planPreprocessing(s) {
    s.add({
      global: [
        ...$649970d87335b30f$var$VARIATION_FEATURES,
        ...$649970d87335b30f$var$DIRECTIONAL_FEATURES[s.direction]
      ],
      local: $649970d87335b30f$var$FRACTIONAL_FEATURES
    });
  }
  static planFeatures(s) {
  }
  static planPostprocessing(s, c) {
    s.add([
      ...$649970d87335b30f$var$COMMON_FEATURES,
      ...$649970d87335b30f$var$HORIZONTAL_FEATURES
    ]), s.setFeatureOverrides(c);
  }
  static assignFeatures(s, c) {
    for (let u = 0; u < c.length; u++) {
      let d = c[u];
      if (d.codePoints[0] === 8260) {
        let p = u, v = u + 1;
        for (; p > 0 && $747425b437e121da$export$727d9dbc4fbb948f(c[p - 1].codePoints[0]); )
          c[p - 1].features.numr = !0, c[p - 1].features.frac = !0, p--;
        for (; v < c.length && $747425b437e121da$export$727d9dbc4fbb948f(c[v].codePoints[0]); )
          c[v].features.dnom = !0, c[v].features.frac = !0, v++;
        d.features.frac = !0, u = v - 1;
      }
    }
  }
}
_define_property($649970d87335b30f$export$2e2bcd8739ae039, "zeroMarkWidths", "AFTER_GPOS");
const $764eb544bbe1ccf0$var$trie = new $6uUbQ$unicodetrie($12727730ddfc8bfe$export$94fdf11bafc8de6b("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==")), $764eb544bbe1ccf0$var$FEATURES = [
  "isol",
  "fina",
  "fin2",
  "fin3",
  "medi",
  "med2",
  "init"
], $764eb544bbe1ccf0$var$ShapingClasses = {
  Non_Joining: 0,
  Transparent: 6
}, $764eb544bbe1ccf0$var$ISOL = "isol", $764eb544bbe1ccf0$var$FINA = "fina", $764eb544bbe1ccf0$var$FIN2 = "fin2", $764eb544bbe1ccf0$var$FIN3 = "fin3", $764eb544bbe1ccf0$var$MEDI = "medi", $764eb544bbe1ccf0$var$MED2 = "med2", $764eb544bbe1ccf0$var$INIT = "init", $764eb544bbe1ccf0$var$NONE = null, $764eb544bbe1ccf0$var$STATE_TABLE = [
  //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
  // State 0: prev was U,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 1: prev was R or ISOL/ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 2: prev was D/L in ISOL form,  willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      1
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      3
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      4
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      6
    ]
  ],
  // State 3: prev was D in FINA form,  willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      1
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      3
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      4
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      6
    ]
  ],
  // State 4: prev was FINA ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 6: prev was DALATH/RISH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$FIN3,
      5
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ]
];
class $764eb544bbe1ccf0$export$2e2bcd8739ae039 extends $649970d87335b30f$export$2e2bcd8739ae039 {
  static planFeatures(s) {
    s.add([
      "ccmp",
      "locl"
    ]);
    for (let c = 0; c < $764eb544bbe1ccf0$var$FEATURES.length; c++) {
      let u = $764eb544bbe1ccf0$var$FEATURES[c];
      s.addStage(u, !1);
    }
    s.addStage("mset");
  }
  static assignFeatures(s, c) {
    super.assignFeatures(s, c);
    let u = -1, d = 0, p = [];
    for (let A = 0; A < c.length; A++) {
      let x, g;
      var v = c[A];
      let b = $764eb544bbe1ccf0$var$getShapingClass(v.codePoints[0]);
      if (b === $764eb544bbe1ccf0$var$ShapingClasses.Transparent) {
        p[A] = $764eb544bbe1ccf0$var$NONE;
        continue;
      }
      [g, x, d] = $764eb544bbe1ccf0$var$STATE_TABLE[d][b], g !== $764eb544bbe1ccf0$var$NONE && u !== -1 && (p[u] = g), p[A] = x, u = A;
    }
    for (let A = 0; A < c.length; A++) {
      let x;
      var v = c[A];
      (x = p[A]) && (v.features[x] = !0);
    }
  }
}
function $764eb544bbe1ccf0$var$getShapingClass(a) {
  let s = $764eb544bbe1ccf0$var$trie.get(a);
  if (s) return s - 1;
  let c = $747425b437e121da$export$410364bbb673ddbc(a);
  return c === "Mn" || c === "Me" || c === "Cf" ? $764eb544bbe1ccf0$var$ShapingClasses.Transparent : $764eb544bbe1ccf0$var$ShapingClasses.Non_Joining;
}
class $85d408632270248b$export$2e2bcd8739ae039 {
  reset(s = {}, c = 0) {
    this.options = s, this.flags = s.flags || {}, this.markAttachmentType = s.markAttachmentType || 0, this.index = c;
  }
  get cur() {
    return this.glyphs[this.index] || null;
  }
  shouldIgnore(s) {
    return this.flags.ignoreMarks && s.isMark || this.flags.ignoreBaseGlyphs && s.isBase || this.flags.ignoreLigatures && s.isLigature || this.markAttachmentType && s.isMark && s.markAttachmentType !== this.markAttachmentType;
  }
  move(s) {
    for (this.index += s; 0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]); ) this.index += s;
    return 0 > this.index || this.index >= this.glyphs.length ? null : this.glyphs[this.index];
  }
  next() {
    return this.move(1);
  }
  prev() {
    return this.move(-1);
  }
  peek(s = 1) {
    let c = this.index, u = this.increment(s);
    return this.index = c, u;
  }
  peekIndex(s = 1) {
    let c = this.index;
    this.increment(s);
    let u = this.index;
    return this.index = c, u;
  }
  increment(s = 1) {
    let c = s < 0 ? -1 : 1;
    for (s = Math.abs(s); s--; ) this.move(c);
    return this.glyphs[this.index];
  }
  constructor(s, c) {
    this.glyphs = s, this.reset(c);
  }
}
const $a83b9c36aaa94fd3$var$DEFAULT_SCRIPTS = [
  "DFLT",
  "dflt",
  "latn"
];
class $a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
  findScript(s) {
    if (this.table.scriptList == null) return null;
    Array.isArray(s) || (s = [
      s
    ]);
    for (let c of s) for (let u of this.table.scriptList)
      if (u.tag === c) return u;
    return null;
  }
  selectScript(s, c, u) {
    let d = !1, p;
    if (!this.script || s !== this.scriptTag) {
      if (p = this.findScript(s), p || (p = this.findScript($a83b9c36aaa94fd3$var$DEFAULT_SCRIPTS)), !p) return this.scriptTag;
      this.scriptTag = p.tag, this.script = p.script, this.language = null, this.languageTag = null, d = !0;
    }
    if ((!u || u !== this.direction) && (this.direction = u || $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(s)), c && c.length < 4 && (c += " ".repeat(4 - c.length)), !c || c !== this.languageTag) {
      this.language = null;
      for (let v of this.script.langSysRecords) if (v.tag === c) {
        this.language = v.langSys, this.languageTag = v.tag;
        break;
      }
      this.language || (this.language = this.script.defaultLangSys, this.languageTag = null), d = !0;
    }
    if (d && (this.features = {}, this.language))
      for (let v of this.language.featureIndexes) {
        let A = this.table.featureList[v], x = this.substituteFeatureForVariations(v);
        this.features[A.tag] = x || A.feature;
      }
    return this.scriptTag;
  }
  lookupsForFeatures(s = [], c) {
    let u = [];
    for (let d of s) {
      let p = this.features[d];
      if (p)
        for (let v of p.lookupListIndexes)
          c && c.indexOf(v) !== -1 || u.push({
            feature: d,
            index: v,
            lookup: this.table.lookupList.get(v)
          });
    }
    return u.sort((d, p) => d.index - p.index), u;
  }
  substituteFeatureForVariations(s) {
    if (this.variationsIndex === -1) return null;
    let u = this.table.featureVariations.featureVariationRecords[this.variationsIndex].featureTableSubstitution.substitutions;
    for (let d of u)
      if (d.featureIndex === s) return d.alternateFeatureTable;
    return null;
  }
  findVariationsIndex(s) {
    let c = this.table.featureVariations;
    if (!c) return -1;
    let u = c.featureVariationRecords;
    for (let d = 0; d < u.length; d++) {
      let p = u[d].conditionSet.conditionTable;
      if (this.variationConditionsMatch(p, s)) return d;
    }
    return -1;
  }
  variationConditionsMatch(s, c) {
    return s.every((u) => {
      let d = u.axisIndex < c.length ? c[u.axisIndex] : 0;
      return u.filterRangeMinValue <= d && d <= u.filterRangeMaxValue;
    });
  }
  applyFeatures(s, c, u) {
    let d = this.lookupsForFeatures(s);
    this.applyLookups(d, c, u);
  }
  applyLookups(s, c, u) {
    this.glyphs = c, this.positions = u, this.glyphIterator = new $85d408632270248b$export$2e2bcd8739ae039(c);
    for (let { feature: d, lookup: p } of s)
      for (this.currentFeature = d, this.glyphIterator.reset(p.flags); this.glyphIterator.index < c.length; ) {
        if (!(d in this.glyphIterator.cur.features)) {
          this.glyphIterator.next();
          continue;
        }
        for (let v of p.subTables)
          if (this.applyLookup(p.lookupType, v)) break;
        this.glyphIterator.next();
      }
  }
  applyLookup(s, c) {
    throw new Error("applyLookup must be implemented by subclasses");
  }
  applyLookupList(s) {
    let c = this.glyphIterator.options, u = this.glyphIterator.index;
    for (let d of s) {
      this.glyphIterator.reset(c, u), this.glyphIterator.increment(d.sequenceIndex);
      let p = this.table.lookupList.get(d.lookupListIndex);
      this.glyphIterator.reset(p.flags, this.glyphIterator.index);
      for (let v of p.subTables)
        if (this.applyLookup(p.lookupType, v)) break;
    }
    return this.glyphIterator.reset(c, u), !0;
  }
  coverageIndex(s, c) {
    switch (c == null && (c = this.glyphIterator.cur.id), s.version) {
      case 1:
        return s.glyphs.indexOf(c);
      case 2:
        for (let u of s.rangeRecords)
          if (u.start <= c && c <= u.end) return u.startCoverageIndex + c - u.start;
        break;
    }
    return -1;
  }
  match(s, c, u, d) {
    let p = this.glyphIterator.index, v = this.glyphIterator.increment(s), A = 0;
    for (; A < c.length && v && u(c[A], v); )
      d && d.push(this.glyphIterator.index), A++, v = this.glyphIterator.next();
    return this.glyphIterator.index = p, A < c.length ? !1 : d || !0;
  }
  sequenceMatches(s, c) {
    return this.match(s, c, (u, d) => u === d.id);
  }
  sequenceMatchIndices(s, c) {
    return this.match(s, c, (u, d) => this.currentFeature in d.features ? u === d.id : !1, []);
  }
  coverageSequenceMatches(s, c) {
    return this.match(s, c, (u, d) => this.coverageIndex(u, d.id) >= 0);
  }
  getClassID(s, c) {
    switch (c.version) {
      case 1:
        let u = s - c.startGlyph;
        if (u >= 0 && u < c.classValueArray.length) return c.classValueArray[u];
        break;
      case 2:
        for (let d of c.classRangeRecord)
          if (d.start <= s && s <= d.end) return d.class;
        break;
    }
    return 0;
  }
  classSequenceMatches(s, c, u) {
    return this.match(s, c, (d, p) => d === this.getClassID(p.id, u));
  }
  applyContext(s) {
    let c, u;
    switch (s.version) {
      case 1:
        if (c = this.coverageIndex(s.coverage), c === -1) return !1;
        u = s.ruleSets[c];
        for (let d of u)
          if (this.sequenceMatches(1, d.input)) return this.applyLookupList(d.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(s.coverage) === -1 || (c = this.getClassID(this.glyphIterator.cur.id, s.classDef), c === -1)) return !1;
        u = s.classSet[c];
        for (let d of u)
          if (this.classSequenceMatches(1, d.classes, s.classDef)) return this.applyLookupList(d.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(0, s.coverages)) return this.applyLookupList(s.lookupRecords);
        break;
    }
    return !1;
  }
  applyChainingContext(s) {
    let c;
    switch (s.version) {
      case 1:
        if (c = this.coverageIndex(s.coverage), c === -1) return !1;
        let u = s.chainRuleSets[c];
        for (let p of u)
          if (this.sequenceMatches(-p.backtrack.length, p.backtrack) && this.sequenceMatches(1, p.input) && this.sequenceMatches(1 + p.input.length, p.lookahead)) return this.applyLookupList(p.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(s.coverage) === -1) return !1;
        c = this.getClassID(this.glyphIterator.cur.id, s.inputClassDef);
        let d = s.chainClassSet[c];
        if (!d) return !1;
        for (let p of d)
          if (this.classSequenceMatches(-p.backtrack.length, p.backtrack, s.backtrackClassDef) && this.classSequenceMatches(1, p.input, s.inputClassDef) && this.classSequenceMatches(1 + p.input.length, p.lookahead, s.lookaheadClassDef)) return this.applyLookupList(p.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(-s.backtrackGlyphCount, s.backtrackCoverage) && this.coverageSequenceMatches(0, s.inputCoverage) && this.coverageSequenceMatches(s.inputGlyphCount, s.lookaheadCoverage)) return this.applyLookupList(s.lookupRecords);
        break;
    }
    return !1;
  }
  constructor(s, c) {
    this.font = s, this.table = c, this.script = null, this.scriptTag = null, this.language = null, this.languageTag = null, this.features = {}, this.lookups = {}, this.variationsIndex = s._variationProcessor ? this.findVariationsIndex(s._variationProcessor.normalizedCoords) : -1, this.selectScript(), this.glyphs = [], this.positions = [], this.ligatureID = 1, this.currentFeature = null;
  }
}
class $10e7b257e1a9a756$export$2e2bcd8739ae039 {
  get id() {
    return this._id;
  }
  set id(s) {
    this._id = s, this.substituted = !0;
    let c = this._font.GDEF;
    if (c && c.glyphClassDef) {
      let u = $a83b9c36aaa94fd3$export$2e2bcd8739ae039.prototype.getClassID(s, c.glyphClassDef);
      this.isBase = u === 1, this.isLigature = u === 2, this.isMark = u === 3, this.markAttachmentType = c.markAttachClassDef ? $a83b9c36aaa94fd3$export$2e2bcd8739ae039.prototype.getClassID(s, c.markAttachClassDef) : 0;
    } else
      this.isMark = this.codePoints.length > 0 && this.codePoints.every($747425b437e121da$export$e33ad6871e762338), this.isBase = !this.isMark, this.isLigature = this.codePoints.length > 1, this.markAttachmentType = 0;
  }
  copy() {
    return new $10e7b257e1a9a756$export$2e2bcd8739ae039(this._font, this.id, this.codePoints, this.features);
  }
  constructor(s, c, u = [], d) {
    if (this._font = s, this.codePoints = u, this.id = c, this.features = {}, Array.isArray(d)) for (let p = 0; p < d.length; p++) {
      let v = d[p];
      this.features[v] = !0;
    }
    else typeof d == "object" && Object.assign(this.features, d);
    this.ligatureID = null, this.ligatureComponent = null, this.isLigated = !1, this.cursiveAttachment = null, this.markAttachment = null, this.shaperInfo = null, this.substituted = !1, this.isMultiplied = !1;
  }
}
class $e1c6bbc8cb416f8c$export$2e2bcd8739ae039 extends $649970d87335b30f$export$2e2bcd8739ae039 {
  static planFeatures(s) {
    s.add([
      "ljmo",
      "vjmo",
      "tjmo"
    ], !1);
  }
  static assignFeatures(s, c) {
    let u = 0, d = 0;
    for (; d < c.length; ) {
      let p, A = c[d].codePoints[0], x = $e1c6bbc8cb416f8c$var$getType(A);
      switch ([p, u] = $e1c6bbc8cb416f8c$var$STATE_TABLE[u][x], p) {
        case $e1c6bbc8cb416f8c$var$DECOMPOSE:
          s.font.hasGlyphForCodePoint(A) || (d = $e1c6bbc8cb416f8c$var$decompose(c, d, s.font));
          break;
        case $e1c6bbc8cb416f8c$var$COMPOSE:
          d = $e1c6bbc8cb416f8c$var$compose(c, d, s.font);
          break;
        case $e1c6bbc8cb416f8c$var$TONE_MARK:
          $e1c6bbc8cb416f8c$var$reorderToneMark(c, d, s.font);
          break;
        case $e1c6bbc8cb416f8c$var$INVALID:
          d = $e1c6bbc8cb416f8c$var$insertDottedCircle(c, d, s.font);
          break;
      }
      d++;
    }
  }
}
_define_property($e1c6bbc8cb416f8c$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
const $e1c6bbc8cb416f8c$var$HANGUL_BASE = 44032, $e1c6bbc8cb416f8c$var$HANGUL_END = 55204, $e1c6bbc8cb416f8c$var$HANGUL_COUNT = $e1c6bbc8cb416f8c$var$HANGUL_END - $e1c6bbc8cb416f8c$var$HANGUL_BASE + 1, $e1c6bbc8cb416f8c$var$L_BASE = 4352, $e1c6bbc8cb416f8c$var$V_BASE = 4449, $e1c6bbc8cb416f8c$var$T_BASE = 4519, $e1c6bbc8cb416f8c$var$L_COUNT = 19, $e1c6bbc8cb416f8c$var$V_COUNT = 21, $e1c6bbc8cb416f8c$var$T_COUNT = 28, $e1c6bbc8cb416f8c$var$L_END = $e1c6bbc8cb416f8c$var$L_BASE + $e1c6bbc8cb416f8c$var$L_COUNT - 1, $e1c6bbc8cb416f8c$var$V_END = $e1c6bbc8cb416f8c$var$V_BASE + $e1c6bbc8cb416f8c$var$V_COUNT - 1, $e1c6bbc8cb416f8c$var$T_END = $e1c6bbc8cb416f8c$var$T_BASE + $e1c6bbc8cb416f8c$var$T_COUNT - 1, $e1c6bbc8cb416f8c$var$DOTTED_CIRCLE = 9676, $e1c6bbc8cb416f8c$var$isL = (a) => 4352 <= a && a <= 4447 || 43360 <= a && a <= 43388, $e1c6bbc8cb416f8c$var$isV = (a) => 4448 <= a && a <= 4519 || 55216 <= a && a <= 55238, $e1c6bbc8cb416f8c$var$isT = (a) => 4520 <= a && a <= 4607 || 55243 <= a && a <= 55291, $e1c6bbc8cb416f8c$var$isTone = (a) => 12334 <= a && a <= 12335, $e1c6bbc8cb416f8c$var$isLVT = (a) => $e1c6bbc8cb416f8c$var$HANGUL_BASE <= a && a <= $e1c6bbc8cb416f8c$var$HANGUL_END, $e1c6bbc8cb416f8c$var$isLV = (a) => a - $e1c6bbc8cb416f8c$var$HANGUL_BASE < $e1c6bbc8cb416f8c$var$HANGUL_COUNT && (a - $e1c6bbc8cb416f8c$var$HANGUL_BASE) % $e1c6bbc8cb416f8c$var$T_COUNT === 0, $e1c6bbc8cb416f8c$var$isCombiningL = (a) => $e1c6bbc8cb416f8c$var$L_BASE <= a && a <= $e1c6bbc8cb416f8c$var$L_END, $e1c6bbc8cb416f8c$var$isCombiningV = (a) => $e1c6bbc8cb416f8c$var$V_BASE <= a && a <= $e1c6bbc8cb416f8c$var$V_END, $e1c6bbc8cb416f8c$var$isCombiningT = (a) => 1 <= a && a <= $e1c6bbc8cb416f8c$var$T_END, $e1c6bbc8cb416f8c$var$X = 0, $e1c6bbc8cb416f8c$var$L = 1, $e1c6bbc8cb416f8c$var$V = 2, $e1c6bbc8cb416f8c$var$T = 3, $e1c6bbc8cb416f8c$var$LV = 4, $e1c6bbc8cb416f8c$var$LVT = 5, $e1c6bbc8cb416f8c$var$M = 6;
function $e1c6bbc8cb416f8c$var$getType(a) {
  return $e1c6bbc8cb416f8c$var$isL(a) ? $e1c6bbc8cb416f8c$var$L : $e1c6bbc8cb416f8c$var$isV(a) ? $e1c6bbc8cb416f8c$var$V : $e1c6bbc8cb416f8c$var$isT(a) ? $e1c6bbc8cb416f8c$var$T : $e1c6bbc8cb416f8c$var$isLV(a) ? $e1c6bbc8cb416f8c$var$LV : $e1c6bbc8cb416f8c$var$isLVT(a) ? $e1c6bbc8cb416f8c$var$LVT : $e1c6bbc8cb416f8c$var$isTone(a) ? $e1c6bbc8cb416f8c$var$M : $e1c6bbc8cb416f8c$var$X;
}
const $e1c6bbc8cb416f8c$var$NO_ACTION = 0, $e1c6bbc8cb416f8c$var$DECOMPOSE = 1, $e1c6bbc8cb416f8c$var$COMPOSE = 2, $e1c6bbc8cb416f8c$var$TONE_MARK = 4, $e1c6bbc8cb416f8c$var$INVALID = 5, $e1c6bbc8cb416f8c$var$STATE_TABLE = [
  //       X                 L                 V                T                  LV                LVT               M
  // State 0: start state
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$INVALID,
      0
    ]
  ],
  // State 1: <L>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$COMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$INVALID,
      0
    ]
  ],
  // State 2: <L,V> or <LV>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$COMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$TONE_MARK,
      0
    ]
  ],
  // State 3: <L,V,T> or <LVT>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$TONE_MARK,
      0
    ]
  ]
];
function $e1c6bbc8cb416f8c$var$getGlyph(a, s, c) {
  return new $10e7b257e1a9a756$export$2e2bcd8739ae039(a, a.glyphForCodePoint(s).id, [
    s
  ], c);
}
function $e1c6bbc8cb416f8c$var$decompose(a, s, c) {
  let u = a[s], p = u.codePoints[0] - $e1c6bbc8cb416f8c$var$HANGUL_BASE, v = $e1c6bbc8cb416f8c$var$T_BASE + p % $e1c6bbc8cb416f8c$var$T_COUNT;
  p = p / $e1c6bbc8cb416f8c$var$T_COUNT | 0;
  let A = $e1c6bbc8cb416f8c$var$L_BASE + p / $e1c6bbc8cb416f8c$var$V_COUNT | 0, x = $e1c6bbc8cb416f8c$var$V_BASE + p % $e1c6bbc8cb416f8c$var$V_COUNT;
  if (!c.hasGlyphForCodePoint(A) || !c.hasGlyphForCodePoint(x) || v !== $e1c6bbc8cb416f8c$var$T_BASE && !c.hasGlyphForCodePoint(v)) return s;
  let g = $e1c6bbc8cb416f8c$var$getGlyph(c, A, u.features);
  g.features.ljmo = !0;
  let b = $e1c6bbc8cb416f8c$var$getGlyph(c, x, u.features);
  b.features.vjmo = !0;
  let y = [
    g,
    b
  ];
  if (v > $e1c6bbc8cb416f8c$var$T_BASE) {
    let f = $e1c6bbc8cb416f8c$var$getGlyph(c, v, u.features);
    f.features.tjmo = !0, y.push(f);
  }
  return a.splice(s, 1, ...y), s + y.length - 1;
}
function $e1c6bbc8cb416f8c$var$compose(a, s, c) {
  let u = a[s], d = a[s].codePoints[0], p = $e1c6bbc8cb416f8c$var$getType(d), v = a[s - 1].codePoints[0], A = $e1c6bbc8cb416f8c$var$getType(v), x, g, b, y;
  if (A === $e1c6bbc8cb416f8c$var$LV && p === $e1c6bbc8cb416f8c$var$T)
    x = v, y = u;
  else {
    p === $e1c6bbc8cb416f8c$var$V ? (g = a[s - 1], b = u) : (g = a[s - 2], b = a[s - 1], y = u);
    let m = g.codePoints[0], C = b.codePoints[0];
    $e1c6bbc8cb416f8c$var$isCombiningL(m) && $e1c6bbc8cb416f8c$var$isCombiningV(C) && (x = $e1c6bbc8cb416f8c$var$HANGUL_BASE + ((m - $e1c6bbc8cb416f8c$var$L_BASE) * $e1c6bbc8cb416f8c$var$V_COUNT + (C - $e1c6bbc8cb416f8c$var$V_BASE)) * $e1c6bbc8cb416f8c$var$T_COUNT);
  }
  let f = y && y.codePoints[0] || $e1c6bbc8cb416f8c$var$T_BASE;
  if (x != null && (f === $e1c6bbc8cb416f8c$var$T_BASE || $e1c6bbc8cb416f8c$var$isCombiningT(f))) {
    let m = x + (f - $e1c6bbc8cb416f8c$var$T_BASE);
    if (c.hasGlyphForCodePoint(m)) {
      let C = A === $e1c6bbc8cb416f8c$var$V ? 3 : 2;
      return a.splice(s - C + 1, C, $e1c6bbc8cb416f8c$var$getGlyph(c, m, u.features)), s - C + 1;
    }
  }
  return g && (g.features.ljmo = !0), b && (b.features.vjmo = !0), y && (y.features.tjmo = !0), A === $e1c6bbc8cb416f8c$var$LV ? ($e1c6bbc8cb416f8c$var$decompose(a, s - 1, c), s + 1) : s;
}
function $e1c6bbc8cb416f8c$var$getLength(a) {
  switch ($e1c6bbc8cb416f8c$var$getType(a)) {
    case $e1c6bbc8cb416f8c$var$LV:
    case $e1c6bbc8cb416f8c$var$LVT:
      return 1;
    case $e1c6bbc8cb416f8c$var$V:
      return 2;
    case $e1c6bbc8cb416f8c$var$T:
      return 3;
  }
}
function $e1c6bbc8cb416f8c$var$reorderToneMark(a, s, c) {
  let u = a[s], d = a[s].codePoints[0];
  if (c.glyphForCodePoint(d).advanceWidth === 0) return;
  let p = a[s - 1].codePoints[0], v = $e1c6bbc8cb416f8c$var$getLength(p);
  return a.splice(s, 1), a.splice(s - v, 0, u);
}
function $e1c6bbc8cb416f8c$var$insertDottedCircle(a, s, c) {
  let u = a[s], d = a[s].codePoints[0];
  if (c.hasGlyphForCodePoint($e1c6bbc8cb416f8c$var$DOTTED_CIRCLE)) {
    let p = $e1c6bbc8cb416f8c$var$getGlyph(c, $e1c6bbc8cb416f8c$var$DOTTED_CIRCLE, u.features), v = c.glyphForCodePoint(d).advanceWidth === 0 ? s : s + 1;
    a.splice(v, 0, p), s++;
  }
  return s;
}
var $4b0735ca6c692ea5$exports = {};
$4b0735ca6c692ea5$exports = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
var $aa333a9607471296$exports = {};
$aa333a9607471296$exports = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","null","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","M","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,0,23,0,0,2,0,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
const $90a9d3398ee54fe5$export$a513ea61a7bee91c = {
  X: 1,
  C: 2,
  V: 4,
  N: 8,
  H: 16,
  ZWNJ: 32,
  ZWJ: 64,
  M: 128,
  Placeholder: 2048,
  Dotted_Circle: 4096,
  RS: 8192,
  Coeng: 16384,
  Repha: 32768,
  Ra: 65536,
  CM: 131072
}, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0 = {
  Start: 1,
  Ra_To_Become_Reph: 2,
  Pre_M: 4,
  Pre_C: 8,
  Base_C: 16,
  After_Main: 32,
  Before_Sub: 128,
  Below_C: 256,
  After_Sub: 512,
  Before_Post: 1024,
  Post_C: 2048,
  After_Post: 4096,
  Final_C: 8192,
  SMVD: 16384,
  End: 32768
}, $90a9d3398ee54fe5$export$8519deaa7de2b07 = $90a9d3398ee54fe5$export$a513ea61a7bee91c.C | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Ra | $90a9d3398ee54fe5$export$a513ea61a7bee91c.CM | $90a9d3398ee54fe5$export$a513ea61a7bee91c.V | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Placeholder | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Dotted_Circle, $90a9d3398ee54fe5$export$bbcd928767338e0d = $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ | $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWNJ, $90a9d3398ee54fe5$export$ca9599b2a300afc = $90a9d3398ee54fe5$export$a513ea61a7bee91c.H | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Coeng, $90a9d3398ee54fe5$export$e99d119da76a0fc5 = {
  Default: {
    hasOldSpec: !1,
    virama: 0,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Devanagari: {
    hasOldSpec: !0,
    virama: 2381,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Bengali: {
    hasOldSpec: !0,
    virama: 2509,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gurmukhi: {
    hasOldSpec: !0,
    virama: 2637,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gujarati: {
    hasOldSpec: !0,
    virama: 2765,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Oriya: {
    hasOldSpec: !0,
    virama: 2893,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Tamil: {
    hasOldSpec: !0,
    virama: 3021,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Telugu: {
    hasOldSpec: !0,
    virama: 3149,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Explicit",
    blwfMode: "Post_Only"
  },
  Kannada: {
    hasOldSpec: !0,
    virama: 3277,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Implicit",
    blwfMode: "Post_Only"
  },
  Malayalam: {
    hasOldSpec: !0,
    virama: 3405,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main,
    rephMode: "Log_Repha",
    blwfMode: "Pre_And_Post"
  },
  // Handled by UniversalShaper
  // Sinhala: {
  //   hasOldSpec: false,
  //   virama: 0x0DCA,
  //   basePos: 'Last_Sinhala',
  //   rephPos: POSITIONS.After_Main,
  //   rephMode: 'Explicit',
  //   blwfMode: 'Pre_And_Post'
  // },
  Khmer: {
    hasOldSpec: !1,
    virama: 6098,
    basePos: "First",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph,
    rephMode: "Vis_Repha",
    blwfMode: "Pre_And_Post"
  }
}, $90a9d3398ee54fe5$export$f647c9cfdd77d95a = {
  // Khmer
  6078: [
    6081,
    6078
  ],
  6079: [
    6081,
    6079
  ],
  6080: [
    6081,
    6080
  ],
  6084: [
    6081,
    6084
  ],
  6085: [
    6081,
    6085
  ]
}, { decompositions: $7826f90f6f0cecc9$var$decompositions } = /* @__PURE__ */ $parcel$interopDefault($aa333a9607471296$exports), $7826f90f6f0cecc9$var$trie = new $6uUbQ$unicodetrie($12727730ddfc8bfe$export$94fdf11bafc8de6b("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")), $7826f90f6f0cecc9$var$stateMachine = new $6uUbQ$dfa(/* @__PURE__ */ $parcel$interopDefault($4b0735ca6c692ea5$exports));
class $7826f90f6f0cecc9$export$2e2bcd8739ae039 extends $649970d87335b30f$export$2e2bcd8739ae039 {
  static planFeatures(s) {
    s.addStage($7826f90f6f0cecc9$var$setupSyllables), s.addStage([
      "locl",
      "ccmp"
    ]), s.addStage($7826f90f6f0cecc9$var$initialReordering), s.addStage("nukt"), s.addStage("akhn"), s.addStage("rphf", !1), s.addStage("rkrf"), s.addStage("pref", !1), s.addStage("blwf", !1), s.addStage("abvf", !1), s.addStage("half", !1), s.addStage("pstf", !1), s.addStage("vatu"), s.addStage("cjct"), s.addStage("cfar", !1), s.addStage($7826f90f6f0cecc9$var$finalReordering), s.addStage({
      local: [
        "init"
      ],
      global: [
        "pres",
        "abvs",
        "blws",
        "psts",
        "haln",
        "dist",
        "abvm",
        "blwm",
        "calt",
        "clig"
      ]
    }), s.unicodeScript = $130d1a642ebcd2b7$export$ce50e82f12a827a4(s.script), s.indicConfig = $90a9d3398ee54fe5$export$e99d119da76a0fc5[s.unicodeScript] || $90a9d3398ee54fe5$export$e99d119da76a0fc5.Default, s.isOldSpec = s.indicConfig.hasOldSpec && s.script[s.script.length - 1] !== "2";
  }
  static assignFeatures(s, c) {
    for (let u = c.length - 1; u >= 0; u--) {
      let d = c[u].codePoints[0], p = $90a9d3398ee54fe5$export$f647c9cfdd77d95a[d] || $7826f90f6f0cecc9$var$decompositions[d];
      if (p) {
        let v = p.map((A) => {
          let x = s.font.glyphForCodePoint(A);
          return new $10e7b257e1a9a756$export$2e2bcd8739ae039(s.font, x.id, [
            A
          ], c[u].features);
        });
        c.splice(u, 1, ...v);
      }
    }
  }
}
_define_property($7826f90f6f0cecc9$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
function $7826f90f6f0cecc9$var$indicCategory(a) {
  return $7826f90f6f0cecc9$var$trie.get(a.codePoints[0]) >> 8;
}
function $7826f90f6f0cecc9$var$indicPosition(a) {
  return 1 << ($7826f90f6f0cecc9$var$trie.get(a.codePoints[0]) & 255);
}
class $7826f90f6f0cecc9$var$IndicInfo {
  constructor(s, c, u, d) {
    this.category = s, this.position = c, this.syllableType = u, this.syllable = d;
  }
}
function $7826f90f6f0cecc9$var$setupSyllables(a, s) {
  let c = 0, u = 0;
  for (let [d, p, v] of $7826f90f6f0cecc9$var$stateMachine.match(s.map($7826f90f6f0cecc9$var$indicCategory))) {
    if (d > u) {
      ++c;
      for (let A = u; A < d; A++) s[A].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo($90a9d3398ee54fe5$export$a513ea61a7bee91c.X, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.End, "non_indic_cluster", c);
    }
    ++c;
    for (let A = d; A <= p; A++) s[A].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo(1 << $7826f90f6f0cecc9$var$indicCategory(s[A]), $7826f90f6f0cecc9$var$indicPosition(s[A]), v[0], c);
    u = p + 1;
  }
  if (u < s.length) {
    ++c;
    for (let d = u; d < s.length; d++) s[d].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo($90a9d3398ee54fe5$export$a513ea61a7bee91c.X, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.End, "non_indic_cluster", c);
  }
}
function $7826f90f6f0cecc9$var$isConsonant(a) {
  return a.shaperInfo.category & $90a9d3398ee54fe5$export$8519deaa7de2b07;
}
function $7826f90f6f0cecc9$var$isJoiner(a) {
  return a.shaperInfo.category & $90a9d3398ee54fe5$export$bbcd928767338e0d;
}
function $7826f90f6f0cecc9$var$isHalantOrCoeng(a) {
  return a.shaperInfo.category & $90a9d3398ee54fe5$export$ca9599b2a300afc;
}
function $7826f90f6f0cecc9$var$wouldSubstitute(a, s) {
  for (let u of a) u.features = {
    [s]: !0
  };
  return a[0]._font._layoutEngine.engine.GSUBProcessor.applyFeatures([
    s
  ], a), a.length === 1;
}
function $7826f90f6f0cecc9$var$consonantPosition(a, s, c) {
  let u = [
    c,
    s,
    c
  ];
  return $7826f90f6f0cecc9$var$wouldSubstitute(u.slice(0, 2), "blwf") || $7826f90f6f0cecc9$var$wouldSubstitute(u.slice(1, 3), "blwf") ? $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C : $7826f90f6f0cecc9$var$wouldSubstitute(u.slice(0, 2), "pstf") || $7826f90f6f0cecc9$var$wouldSubstitute(u.slice(1, 3), "pstf") || $7826f90f6f0cecc9$var$wouldSubstitute(u.slice(0, 2), "pref") || $7826f90f6f0cecc9$var$wouldSubstitute(u.slice(1, 3), "pref") ? $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C : $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C;
}
function $7826f90f6f0cecc9$var$initialReordering(a, s, c) {
  let u = c.indicConfig, d = a._layoutEngine.engine.GSUBProcessor.features, p = a.glyphForCodePoint(9676).id, v = a.glyphForCodePoint(u.virama).id;
  if (v) {
    let A = new $10e7b257e1a9a756$export$2e2bcd8739ae039(a, v, [
      u.virama
    ]);
    for (let x = 0; x < s.length; x++) s[x].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C && (s[x].shaperInfo.position = $7826f90f6f0cecc9$var$consonantPosition(a, s[x].copy(), A));
  }
  for (let A = 0, x = $7826f90f6f0cecc9$var$nextSyllable(s, 0); A < s.length; A = x, x = $7826f90f6f0cecc9$var$nextSyllable(s, A)) {
    let { category: g, syllableType: b } = s[A].shaperInfo;
    if (b === "symbol_cluster" || b === "non_indic_cluster") continue;
    if (b === "broken_cluster" && p) {
      let I = new $10e7b257e1a9a756$export$2e2bcd8739ae039(a, p, [
        9676
      ]);
      I.shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo(1 << $7826f90f6f0cecc9$var$indicCategory(I), $7826f90f6f0cecc9$var$indicPosition(I), s[A].shaperInfo.syllableType, s[A].shaperInfo.syllable);
      let _ = A;
      for (; _ < x && s[_].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha; ) _++;
      s.splice(_++, 0, I), x++;
    }
    let y = x, f = A, m = !1;
    if (u.rephPos !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && d.rphf && A + 3 <= x && (u.rephMode === "Implicit" && !$7826f90f6f0cecc9$var$isJoiner(s[A + 2]) || u.rephMode === "Explicit" && s[A + 2].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ)) {
      let I = [
        s[A].copy(),
        s[A + 1].copy(),
        s[A + 2].copy()
      ];
      if ($7826f90f6f0cecc9$var$wouldSubstitute(I.slice(0, 2), "rphf") || u.rephMode === "Explicit" && $7826f90f6f0cecc9$var$wouldSubstitute(I, "rphf")) {
        for (f += 2; f < x && $7826f90f6f0cecc9$var$isJoiner(s[f]); ) f++;
        y = A, m = !0;
      }
    } else if (u.rephMode === "Log_Repha" && s[A].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha) {
      for (f++; f < x && $7826f90f6f0cecc9$var$isJoiner(s[f]); ) f++;
      y = A, m = !0;
    }
    switch (u.basePos) {
      case "Last": {
        let I = x, _ = !1;
        do {
          let E = s[--I].shaperInfo;
          if ($7826f90f6f0cecc9$var$isConsonant(s[I])) {
            if (E.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C && (E.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C || _)) {
              y = I;
              break;
            }
            E.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C && (_ = !0), y = I;
          } else if (A < I && E.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ && s[I - 1].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H) break;
        } while (I > f);
        break;
      }
      case "First":
        y = A;
        for (let I = y + 1; I < x; I++) $7826f90f6f0cecc9$var$isConsonant(s[I]) && (s[I].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C);
    }
    m && y === A && f - y <= 2 && (m = !1);
    for (let I = A; I < y; I++) {
      let _ = s[I].shaperInfo;
      _.position = Math.min($90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_C, _.position);
    }
    y < x && (s[y].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C);
    for (let I = y + 1; I < x; I++) if (s[I].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
      for (let _ = I + 1; _ < x; _++) if ($7826f90f6f0cecc9$var$isConsonant(s[_])) {
        s[_].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Final_C;
        break;
      }
      break;
    }
    if (m && (s[A].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph), c.isOldSpec) {
      let I = c.unicodeScript !== "Malayalam";
      for (let _ = y + 1; _ < x; _++) if (s[_].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H) {
        let E;
        for (E = x - 1; E > _ && !($7826f90f6f0cecc9$var$isConsonant(s[E]) || I && s[E].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H); E--)
          ;
        if (s[E].shaperInfo.category !== $90a9d3398ee54fe5$export$a513ea61a7bee91c.H && E > _) {
          let R = s[_];
          s.splice(_, 0, ...s.splice(_ + 1, E - _)), s[E] = R;
        }
        break;
      }
    }
    let C = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Start;
    for (let I = A; I < x; I++) {
      let _ = s[I].shaperInfo;
      if (_.category & ($90a9d3398ee54fe5$export$bbcd928767338e0d | $90a9d3398ee54fe5$export$a513ea61a7bee91c.N | $90a9d3398ee54fe5$export$a513ea61a7bee91c.RS | $90a9d3398ee54fe5$export$a513ea61a7bee91c.CM | $90a9d3398ee54fe5$export$ca9599b2a300afc & _.category)) {
        if (_.position = C, _.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H && _.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
          for (let E = I; E > A; E--) if (s[E - 1].shaperInfo.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
            _.position = s[E - 1].shaperInfo.position;
            break;
          }
        }
      } else _.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD && (C = _.position);
    }
    let w = y;
    for (let I = y + 1; I < x; I++)
      if ($7826f90f6f0cecc9$var$isConsonant(s[I])) {
        for (let _ = w + 1; _ < I; _++) s[_].shaperInfo.position < $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD && (s[_].shaperInfo.position = s[I].shaperInfo.position);
        w = I;
      } else s[I].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M && (w = I);
    let S = s.slice(A, x);
    S.sort((I, _) => I.shaperInfo.position - _.shaperInfo.position), s.splice(A, S.length, ...S);
    for (let I = A; I < x; I++) if (s[I].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C) {
      y = I;
      break;
    }
    for (let I = A; I < x && s[I].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph; I++) s[I].features.rphf = !0;
    let $ = !c.isOldSpec && u.blwfMode === "Pre_And_Post";
    for (let I = A; I < y; I++)
      s[I].features.half = !0, $ && (s[I].features.blwf = !0);
    for (let I = y + 1; I < x; I++)
      s[I].features.abvf = !0, s[I].features.pstf = !0, s[I].features.blwf = !0;
    if (c.isOldSpec && c.unicodeScript === "Devanagari")
      for (let I = A; I + 1 < y; I++) s[I].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.Ra && s[I + 1].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H && (I + 1 === y || s[I + 2].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ) && (s[I].features.blwf = !0, s[I + 1].features.blwf = !0);
    let T = 2;
    if (d.pref && y + T < x)
      for (let I = y + 1; I + T - 1 < x; I++) {
        let _ = [
          s[I].copy(),
          s[I + 1].copy()
        ];
        if ($7826f90f6f0cecc9$var$wouldSubstitute(_, "pref")) {
          for (let E = 0; E < T; E++) s[I++].features.pref = !0;
          if (d.cfar) for (; I < x; I++) s[I].features.cfar = !0;
          break;
        }
      }
    for (let I = A + 1; I < x; I++) if ($7826f90f6f0cecc9$var$isJoiner(s[I])) {
      let _ = s[I].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWNJ, E = I;
      do
        E--, _ && delete s[E].features.half;
      while (E > A && !$7826f90f6f0cecc9$var$isConsonant(s[E]));
    }
  }
}
function $7826f90f6f0cecc9$var$finalReordering(a, s, c) {
  let u = c.indicConfig, d = a._layoutEngine.engine.GSUBProcessor.features;
  for (let p = 0, v = $7826f90f6f0cecc9$var$nextSyllable(s, 0); p < s.length; p = v, v = $7826f90f6f0cecc9$var$nextSyllable(s, p)) {
    let A = !!d.pref, x = p;
    for (; x < v; x++) if (s[x].shaperInfo.position >= $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C) {
      if (A && x + 1 < v) {
        for (let g = x + 1; g < v; g++) if (s[g].features.pref) {
          if (!(s[g].substituted && s[g].isLigated && !s[g].isMultiplied)) {
            for (x = g; x < v && $7826f90f6f0cecc9$var$isHalantOrCoeng(s[x]); ) x++;
            s[x].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.BASE_C, A = !1;
          }
          break;
        }
      }
      if (c.unicodeScript === "Malayalam") for (let g = x + 1; g < v; g++) {
        for (; g < v && $7826f90f6f0cecc9$var$isJoiner(s[g]); ) g++;
        if (g === v || !$7826f90f6f0cecc9$var$isHalantOrCoeng(s[g])) break;
        for (g++; g < v && $7826f90f6f0cecc9$var$isJoiner(s[g]); ) g++;
        g < v && $7826f90f6f0cecc9$var$isConsonant(s[g]) && s[g].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C && (x = g, s[x].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C);
      }
      p < x && s[x].shaperInfo.position > $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C && x--;
      break;
    }
    if (x === v && p < x && s[x - 1].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ && x--, x < v) for (; p < x && s[x].shaperInfo.category & ($90a9d3398ee54fe5$export$a513ea61a7bee91c.N | $90a9d3398ee54fe5$export$ca9599b2a300afc); ) x--;
    if (p + 1 < v && p < x) {
      let g = x === v ? x - 2 : x - 1;
      if (c.unicodeScript !== "Malayalam" && c.unicodeScript !== "Tamil") {
        for (; g > p && !(s[g].shaperInfo.category & ($90a9d3398ee54fe5$export$a513ea61a7bee91c.M | $90a9d3398ee54fe5$export$ca9599b2a300afc)); ) g--;
        $7826f90f6f0cecc9$var$isHalantOrCoeng(s[g]) && s[g].shaperInfo.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M ? g + 1 < v && $7826f90f6f0cecc9$var$isJoiner(s[g + 1]) && g++ : g = p;
      }
      if (p < g && s[g].shaperInfo.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
        for (let b = g; b > p; b--) if (s[b - 1].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
          let y = b - 1;
          y < x && x <= g && x--;
          let f = s[y];
          s.splice(y, 0, ...s.splice(y + 1, g - y)), s[g] = f, g--;
        }
      }
    }
    if (p + 1 < v && s[p].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && s[p].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha !== (s[p].isLigated && !s[p].isMultiplied)) {
      let g, b = u.rephPos, y = !1;
      if (b !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post) {
        for (g = p + 1; g < x && !$7826f90f6f0cecc9$var$isHalantOrCoeng(s[g]); ) g++;
        if (g < x && $7826f90f6f0cecc9$var$isHalantOrCoeng(s[g]) && (g + 1 < x && $7826f90f6f0cecc9$var$isJoiner(s[g + 1]) && g++, y = !0), !y && b === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main) {
          for (g = x; g + 1 < v && s[g + 1].shaperInfo.position <= $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main; ) g++;
          y = g < v;
        }
        if (!y && b === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Sub) {
          for (g = x; g + 1 < v && !(s[g + 1].shaperInfo.position & ($90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C | $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post | $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD)); ) g++;
          y = g < v;
        }
      }
      if (!y) {
        for (g = p + 1; g < x && !$7826f90f6f0cecc9$var$isHalantOrCoeng(s[g]); ) g++;
        g < x && $7826f90f6f0cecc9$var$isHalantOrCoeng(s[g]) && (g + 1 < x && $7826f90f6f0cecc9$var$isJoiner(s[g + 1]) && g++, y = !0);
      }
      if (!y) {
        for (g = v - 1; g > p && s[g].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD; ) g--;
        if ($7826f90f6f0cecc9$var$isHalantOrCoeng(s[g]))
          for (let m = x + 1; m < g; m++) s[m].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M && g--;
      }
      let f = s[p];
      s.splice(p, 0, ...s.splice(p + 1, g - p)), s[g] = f, p < x && x <= g && x--;
    }
    if (A && x + 1 < v) {
      for (let g = x + 1; g < v; g++) if (s[g].features.pref) {
        if (s[g].isLigated && !s[g].isMultiplied) {
          let b = x;
          if (c.unicodeScript !== "Malayalam" && c.unicodeScript !== "Tamil") {
            for (; b > p && !(s[b - 1].shaperInfo.category & ($90a9d3398ee54fe5$export$a513ea61a7bee91c.M | $90a9d3398ee54fe5$export$ca9599b2a300afc)); ) b--;
            if (b > p && s[b - 1].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
              let m = g;
              for (let C = x + 1; C < m; C++) if (s[C].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
                b--;
                break;
              }
            }
          }
          b > p && $7826f90f6f0cecc9$var$isHalantOrCoeng(s[b - 1]) && b < v && $7826f90f6f0cecc9$var$isJoiner(s[b]) && b++;
          let y = g, f = s[y];
          s.splice(b + 1, 0, ...s.splice(b, y - b)), s[b] = f, b <= x && x < y && x++;
        }
        break;
      }
    }
    s[p].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M && (!p || !/Cf|Mn/.test($747425b437e121da$export$410364bbb673ddbc(s[p - 1].codePoints[0]))) && (s[p].features.init = !0);
  }
}
function $7826f90f6f0cecc9$var$nextSyllable(a, s) {
  if (s >= a.length) return s;
  let c = a[s].shaperInfo.syllable;
  for (; ++s < a.length && a[s].shaperInfo.syllable === c; ) ;
  return s;
}
const { categories: $7ab494fe977143c6$var$categories, decompositions: $7ab494fe977143c6$var$decompositions } = /* @__PURE__ */ $parcel$interopDefault($aa333a9607471296$exports), $7ab494fe977143c6$var$trie = new $6uUbQ$unicodetrie($12727730ddfc8bfe$export$94fdf11bafc8de6b("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")), $7ab494fe977143c6$var$stateMachine = new $6uUbQ$dfa(/* @__PURE__ */ $parcel$interopDefault($aa333a9607471296$exports));
class $7ab494fe977143c6$export$2e2bcd8739ae039 extends $649970d87335b30f$export$2e2bcd8739ae039 {
  static planFeatures(s) {
    s.addStage($7ab494fe977143c6$var$setupSyllables), s.addStage([
      "locl",
      "ccmp",
      "nukt",
      "akhn"
    ]), s.addStage($7ab494fe977143c6$var$clearSubstitutionFlags), s.addStage([
      "rphf"
    ], !1), s.addStage($7ab494fe977143c6$var$recordRphf), s.addStage($7ab494fe977143c6$var$clearSubstitutionFlags), s.addStage([
      "pref"
    ]), s.addStage($7ab494fe977143c6$var$recordPref), s.addStage([
      "rkrf",
      "abvf",
      "blwf",
      "half",
      "pstf",
      "vatu",
      "cjct"
    ]), s.addStage($7ab494fe977143c6$var$reorder), s.addStage([
      "abvs",
      "blws",
      "pres",
      "psts",
      "dist",
      "abvm",
      "blwm"
    ]);
  }
  static assignFeatures(s, c) {
    for (let u = c.length - 1; u >= 0; u--) {
      let d = c[u].codePoints[0];
      if ($7ab494fe977143c6$var$decompositions[d]) {
        let p = $7ab494fe977143c6$var$decompositions[d].map((v) => {
          let A = s.font.glyphForCodePoint(v);
          return new $10e7b257e1a9a756$export$2e2bcd8739ae039(s.font, A.id, [
            v
          ], c[u].features);
        });
        c.splice(u, 1, ...p);
      }
    }
  }
}
_define_property($7ab494fe977143c6$export$2e2bcd8739ae039, "zeroMarkWidths", "BEFORE_GPOS");
function $7ab494fe977143c6$var$useCategory(a) {
  return $7ab494fe977143c6$var$trie.get(a.codePoints[0]);
}
class $7ab494fe977143c6$var$USEInfo {
  constructor(s, c, u) {
    this.category = s, this.syllableType = c, this.syllable = u;
  }
}
function $7ab494fe977143c6$var$setupSyllables(a, s) {
  let c = 0;
  for (let [u, d, p] of $7ab494fe977143c6$var$stateMachine.match(s.map($7ab494fe977143c6$var$useCategory))) {
    ++c;
    for (let A = u; A <= d; A++) s[A].shaperInfo = new $7ab494fe977143c6$var$USEInfo($7ab494fe977143c6$var$categories[$7ab494fe977143c6$var$useCategory(s[A])], p[0], c);
    let v = s[u].shaperInfo.category === "R" ? 1 : Math.min(3, d - u);
    for (let A = u; A < u + v; A++) s[A].features.rphf = !0;
  }
}
function $7ab494fe977143c6$var$clearSubstitutionFlags(a, s) {
  for (let c of s) c.substituted = !1;
}
function $7ab494fe977143c6$var$recordRphf(a, s) {
  for (let c of s) c.substituted && c.features.rphf && (c.shaperInfo.category = "R");
}
function $7ab494fe977143c6$var$recordPref(a, s) {
  for (let c of s) c.substituted && (c.shaperInfo.category = "VPre");
}
function $7ab494fe977143c6$var$reorder(a, s) {
  let c = a.glyphForCodePoint(9676).id;
  for (let u = 0, d = $7ab494fe977143c6$var$nextSyllable(s, 0); u < s.length; u = d, d = $7ab494fe977143c6$var$nextSyllable(s, u)) {
    let p, v, A = s[u].shaperInfo, x = A.syllableType;
    if (!(x !== "virama_terminated_cluster" && x !== "standard_cluster" && x !== "broken_cluster")) {
      if (x === "broken_cluster" && c) {
        let g = new $10e7b257e1a9a756$export$2e2bcd8739ae039(a, c, [
          9676
        ]);
        for (g.shaperInfo = A, p = u; p < d && s[p].shaperInfo.category === "R"; p++) ;
        s.splice(++p, 0, g), d++;
      }
      if (A.category === "R" && d - u > 1) {
        for (p = u + 1; p < d; p++)
          if (A = s[p].shaperInfo, $7ab494fe977143c6$var$isBase(A) || $7ab494fe977143c6$var$isHalant(s[p])) {
            $7ab494fe977143c6$var$isHalant(s[p]) && p--, s.splice(u, 0, ...s.splice(u + 1, p - u), s[p]);
            break;
          }
      }
      for (p = u, v = d; p < d; p++)
        A = s[p].shaperInfo, $7ab494fe977143c6$var$isBase(A) || $7ab494fe977143c6$var$isHalant(s[p]) ? v = $7ab494fe977143c6$var$isHalant(s[p]) ? p + 1 : p : (A.category === "VPre" || A.category === "VMPre") && v < p && s.splice(v, 1, s[p], ...s.splice(v, p - v));
    }
  }
}
function $7ab494fe977143c6$var$nextSyllable(a, s) {
  if (s >= a.length) return s;
  let c = a[s].shaperInfo.syllable;
  for (; ++s < a.length && a[s].shaperInfo.syllable === c; ) ;
  return s;
}
function $7ab494fe977143c6$var$isHalant(a) {
  return a.shaperInfo.category === "H" && !a.isLigated;
}
function $7ab494fe977143c6$var$isBase(a) {
  return a.category === "B" || a.category === "GB";
}
const $102b6fe50f1d50b4$var$SHAPERS = {
  arab: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  mong: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  syrc: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  "nko ": $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  phag: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  mand: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  mani: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  phlp: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  hang: $e1c6bbc8cb416f8c$export$2e2bcd8739ae039,
  bng2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  beng: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  dev2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  deva: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  gjr2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  gujr: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  guru: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  gur2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  knda: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  knd2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  mlm2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  mlym: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  ory2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  orya: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  taml: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  tml2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  telu: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  tel2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  khmr: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  bali: $7ab494fe977143c6$export$2e2bcd8739ae039,
  batk: $7ab494fe977143c6$export$2e2bcd8739ae039,
  brah: $7ab494fe977143c6$export$2e2bcd8739ae039,
  bugi: $7ab494fe977143c6$export$2e2bcd8739ae039,
  buhd: $7ab494fe977143c6$export$2e2bcd8739ae039,
  cakm: $7ab494fe977143c6$export$2e2bcd8739ae039,
  cham: $7ab494fe977143c6$export$2e2bcd8739ae039,
  dupl: $7ab494fe977143c6$export$2e2bcd8739ae039,
  egyp: $7ab494fe977143c6$export$2e2bcd8739ae039,
  gran: $7ab494fe977143c6$export$2e2bcd8739ae039,
  hano: $7ab494fe977143c6$export$2e2bcd8739ae039,
  java: $7ab494fe977143c6$export$2e2bcd8739ae039,
  kthi: $7ab494fe977143c6$export$2e2bcd8739ae039,
  kali: $7ab494fe977143c6$export$2e2bcd8739ae039,
  khar: $7ab494fe977143c6$export$2e2bcd8739ae039,
  khoj: $7ab494fe977143c6$export$2e2bcd8739ae039,
  sind: $7ab494fe977143c6$export$2e2bcd8739ae039,
  lepc: $7ab494fe977143c6$export$2e2bcd8739ae039,
  limb: $7ab494fe977143c6$export$2e2bcd8739ae039,
  mahj: $7ab494fe977143c6$export$2e2bcd8739ae039,
  // mand: UniversalShaper, // Mandaic
  // mani: UniversalShaper, // Manichaean
  mtei: $7ab494fe977143c6$export$2e2bcd8739ae039,
  modi: $7ab494fe977143c6$export$2e2bcd8739ae039,
  // mong: UniversalShaper, // Mongolian
  // 'nko ': UniversalShaper, // N’Ko
  hmng: $7ab494fe977143c6$export$2e2bcd8739ae039,
  // phag: UniversalShaper, // Phags-pa
  // phlp: UniversalShaper, // Psalter Pahlavi
  rjng: $7ab494fe977143c6$export$2e2bcd8739ae039,
  saur: $7ab494fe977143c6$export$2e2bcd8739ae039,
  shrd: $7ab494fe977143c6$export$2e2bcd8739ae039,
  sidd: $7ab494fe977143c6$export$2e2bcd8739ae039,
  sinh: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  sund: $7ab494fe977143c6$export$2e2bcd8739ae039,
  sylo: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tglg: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tagb: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tale: $7ab494fe977143c6$export$2e2bcd8739ae039,
  lana: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tavt: $7ab494fe977143c6$export$2e2bcd8739ae039,
  takr: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tibt: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tfng: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tirh: $7ab494fe977143c6$export$2e2bcd8739ae039,
  latn: $649970d87335b30f$export$2e2bcd8739ae039,
  DFLT: $649970d87335b30f$export$2e2bcd8739ae039
};
function $102b6fe50f1d50b4$export$7877a478dd30fd3d(a) {
  Array.isArray(a) || (a = [
    a
  ]);
  for (let s of a) {
    let c = $102b6fe50f1d50b4$var$SHAPERS[s];
    if (c) return c;
  }
  return $649970d87335b30f$export$2e2bcd8739ae039;
}
class $0a876c45f1f7c41c$export$2e2bcd8739ae039 extends $a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
  applyLookup(s, c) {
    switch (s) {
      case 1: {
        let d = this.coverageIndex(c.coverage);
        if (d === -1) return !1;
        let p = this.glyphIterator.cur;
        switch (c.version) {
          case 1:
            p.id = p.id + c.deltaGlyphID & 65535;
            break;
          case 2:
            p.id = c.substitute.get(d);
            break;
        }
        return !0;
      }
      case 2: {
        let d = this.coverageIndex(c.coverage);
        if (d !== -1) {
          let p = c.sequences.get(d);
          if (p.length === 0)
            return this.glyphs.splice(this.glyphIterator.index, 1), !0;
          this.glyphIterator.cur.id = p[0], this.glyphIterator.cur.ligatureComponent = 0;
          let v = this.glyphIterator.cur.features, A = this.glyphIterator.cur, x = p.slice(1).map((g, b) => {
            let y = new $10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, g, void 0, v);
            return y.shaperInfo = A.shaperInfo, y.isLigated = A.isLigated, y.ligatureComponent = b + 1, y.substituted = !0, y.isMultiplied = !0, y;
          });
          return this.glyphs.splice(this.glyphIterator.index + 1, 0, ...x), !0;
        }
        return !1;
      }
      case 3: {
        let d = this.coverageIndex(c.coverage);
        if (d !== -1) {
          let p = 0;
          return this.glyphIterator.cur.id = c.alternateSet.get(d)[p], !0;
        }
        return !1;
      }
      case 4: {
        let d = this.coverageIndex(c.coverage);
        if (d === -1) return !1;
        for (let p of c.ligatureSets.get(d)) {
          let v = this.sequenceMatchIndices(1, p.components);
          if (!v) continue;
          let A = this.glyphIterator.cur, x = A.codePoints.slice();
          for (let w of v) x.push(...this.glyphs[w].codePoints);
          let g = new $10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, p.glyph, x, A.features);
          g.shaperInfo = A.shaperInfo, g.isLigated = !0, g.substituted = !0;
          let b = A.isMark;
          for (let w = 0; w < v.length && b; w++) b = this.glyphs[v[w]].isMark;
          g.ligatureID = b ? null : this.ligatureID++;
          let y = A.ligatureID, f = A.codePoints.length, m = f, C = this.glyphIterator.index + 1;
          for (let w of v) {
            if (b) C = w;
            else for (; C < w; ) {
              var u = m - f + Math.min(this.glyphs[C].ligatureComponent || 1, f);
              this.glyphs[C].ligatureID = g.ligatureID, this.glyphs[C].ligatureComponent = u, C++;
            }
            y = this.glyphs[C].ligatureID, f = this.glyphs[C].codePoints.length, m += f, C++;
          }
          if (y && !b) for (let w = C; w < this.glyphs.length && this.glyphs[w].ligatureID === y; w++) {
            var u = m - f + Math.min(this.glyphs[w].ligatureComponent || 1, f);
            this.glyphs[w].ligatureComponent = u;
          }
          for (let w = v.length - 1; w >= 0; w--) this.glyphs.splice(v[w], 1);
          return this.glyphs[this.glyphIterator.index] = g, !0;
        }
        return !1;
      }
      case 5:
        return this.applyContext(c);
      case 6:
        return this.applyChainingContext(c);
      case 7:
        return this.applyLookup(c.lookupType, c.extension);
      default:
        throw new Error(`GSUB lookupType ${s} is not supported`);
    }
  }
}
class $c96c93587d49c14d$export$2e2bcd8739ae039 extends $a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
  applyPositionValue(s, c) {
    let u = this.positions[this.glyphIterator.peekIndex(s)];
    c.xAdvance != null && (u.xAdvance += c.xAdvance), c.yAdvance != null && (u.yAdvance += c.yAdvance), c.xPlacement != null && (u.xOffset += c.xPlacement), c.yPlacement != null && (u.yOffset += c.yPlacement);
    let d = this.font._variationProcessor, p = this.font.GDEF && this.font.GDEF.itemVariationStore;
    d && p && (c.xPlaDevice && (u.xOffset += d.getDelta(p, c.xPlaDevice.a, c.xPlaDevice.b)), c.yPlaDevice && (u.yOffset += d.getDelta(p, c.yPlaDevice.a, c.yPlaDevice.b)), c.xAdvDevice && (u.xAdvance += d.getDelta(p, c.xAdvDevice.a, c.xAdvDevice.b)), c.yAdvDevice && (u.yAdvance += d.getDelta(p, c.yAdvDevice.a, c.yAdvDevice.b)));
  }
  applyLookup(s, c) {
    switch (s) {
      case 1: {
        let d = this.coverageIndex(c.coverage);
        if (d === -1) return !1;
        switch (c.version) {
          case 1:
            this.applyPositionValue(0, c.value);
            break;
          case 2:
            this.applyPositionValue(0, c.values.get(d));
            break;
        }
        return !0;
      }
      case 2: {
        let d = this.glyphIterator.peek();
        if (!d) return !1;
        let p = this.coverageIndex(c.coverage);
        if (p === -1) return !1;
        switch (c.version) {
          case 1:
            let v = c.pairSets.get(p);
            for (let g of v) if (g.secondGlyph === d.id)
              return this.applyPositionValue(0, g.value1), this.applyPositionValue(1, g.value2), !0;
            return !1;
          case 2:
            let A = this.getClassID(this.glyphIterator.cur.id, c.classDef1), x = this.getClassID(d.id, c.classDef2);
            if (A === -1 || x === -1) return !1;
            var u = c.classRecords.get(A).get(x);
            return this.applyPositionValue(0, u.value1), this.applyPositionValue(1, u.value2), !0;
        }
      }
      case 3: {
        let d = this.glyphIterator.peekIndex(), p = this.glyphs[d];
        if (!p) return !1;
        let v = c.entryExitRecords[this.coverageIndex(c.coverage)];
        if (!v || !v.exitAnchor) return !1;
        let A = c.entryExitRecords[this.coverageIndex(c.coverage, p.id)];
        if (!A || !A.entryAnchor) return !1;
        let x = this.getAnchor(A.entryAnchor), g = this.getAnchor(v.exitAnchor), b = this.positions[this.glyphIterator.index], y = this.positions[d], f;
        switch (this.direction) {
          case "ltr":
            b.xAdvance = g.x + b.xOffset, f = x.x + y.xOffset, y.xAdvance -= f, y.xOffset -= f;
            break;
          case "rtl":
            f = g.x + b.xOffset, b.xAdvance -= f, b.xOffset -= f, y.xAdvance = x.x + y.xOffset;
            break;
        }
        return this.glyphIterator.flags.rightToLeft ? (this.glyphIterator.cur.cursiveAttachment = d, b.yOffset = x.y - g.y) : (p.cursiveAttachment = this.glyphIterator.index, b.yOffset = g.y - x.y), !0;
      }
      case 4: {
        let d = this.coverageIndex(c.markCoverage);
        if (d === -1) return !1;
        let p = this.glyphIterator.index;
        for (; --p >= 0 && (this.glyphs[p].isMark || this.glyphs[p].ligatureComponent > 0); ) ;
        if (p < 0) return !1;
        let v = this.coverageIndex(c.baseCoverage, this.glyphs[p].id);
        if (v === -1) return !1;
        let A = c.markArray[d], x = c.baseArray[v][A.class];
        return this.applyAnchor(A, x, p), !0;
      }
      case 5: {
        let d = this.coverageIndex(c.markCoverage);
        if (d === -1) return !1;
        let p = this.glyphIterator.index;
        for (; --p >= 0 && this.glyphs[p].isMark; ) ;
        if (p < 0) return !1;
        let v = this.coverageIndex(c.ligatureCoverage, this.glyphs[p].id);
        if (v === -1) return !1;
        let A = c.ligatureArray[v], x = this.glyphIterator.cur, g = this.glyphs[p], b = g.ligatureID && g.ligatureID === x.ligatureID && x.ligatureComponent > 0 ? Math.min(x.ligatureComponent, g.codePoints.length) - 1 : g.codePoints.length - 1, y = c.markArray[d], f = A[b][y.class];
        return this.applyAnchor(y, f, p), !0;
      }
      case 6: {
        let d = this.coverageIndex(c.mark1Coverage);
        if (d === -1) return !1;
        let p = this.glyphIterator.peekIndex(-1), v = this.glyphs[p];
        if (!v || !v.isMark) return !1;
        let A = this.glyphIterator.cur, x = !1;
        if (A.ligatureID === v.ligatureID ? A.ligatureID ? A.ligatureComponent === v.ligatureComponent && (x = !0) : x = !0 : (A.ligatureID && !A.ligatureComponent || v.ligatureID && !v.ligatureComponent) && (x = !0), !x) return !1;
        let g = this.coverageIndex(c.mark2Coverage, v.id);
        if (g === -1) return !1;
        let b = c.mark1Array[d], y = c.mark2Array[g][b.class];
        return this.applyAnchor(b, y, p), !0;
      }
      case 7:
        return this.applyContext(c);
      case 8:
        return this.applyChainingContext(c);
      case 9:
        return this.applyLookup(c.lookupType, c.extension);
      default:
        throw new Error(`Unsupported GPOS table: ${s}`);
    }
  }
  applyAnchor(s, c, u) {
    let d = this.getAnchor(c), p = this.getAnchor(s.markAnchor);
    this.positions[u];
    let v = this.positions[this.glyphIterator.index];
    v.xOffset = d.x - p.x, v.yOffset = d.y - p.y, this.glyphIterator.cur.markAttachment = u;
  }
  getAnchor(s) {
    let c = s.xCoordinate, u = s.yCoordinate, d = this.font._variationProcessor, p = this.font.GDEF && this.font.GDEF.itemVariationStore;
    return d && p && (s.xDeviceTable && (c += d.getDelta(p, s.xDeviceTable.a, s.xDeviceTable.b)), s.yDeviceTable && (u += d.getDelta(p, s.yDeviceTable.a, s.yDeviceTable.b))), {
      x: c,
      y: u
    };
  }
  applyFeatures(s, c, u) {
    super.applyFeatures(s, c, u);
    for (var d = 0; d < this.glyphs.length; d++) this.fixCursiveAttachment(d);
    this.fixMarkAttachment();
  }
  fixCursiveAttachment(s) {
    let c = this.glyphs[s];
    if (c.cursiveAttachment != null) {
      let u = c.cursiveAttachment;
      c.cursiveAttachment = null, this.fixCursiveAttachment(u), this.positions[s].yOffset += this.positions[u].yOffset;
    }
  }
  fixMarkAttachment() {
    for (let s = 0; s < this.glyphs.length; s++) {
      let c = this.glyphs[s];
      if (c.markAttachment != null) {
        let u = c.markAttachment;
        if (this.positions[s].xOffset += this.positions[u].xOffset, this.positions[s].yOffset += this.positions[u].yOffset, this.direction === "ltr") for (let d = u; d < s; d++)
          this.positions[s].xOffset -= this.positions[d].xAdvance, this.positions[s].yOffset -= this.positions[d].yAdvance;
        else for (let d = u + 1; d < s + 1; d++)
          this.positions[s].xOffset += this.positions[d].xAdvance, this.positions[s].yOffset += this.positions[d].yAdvance;
      }
    }
  }
}
class $a62492810de27e3d$export$2e2bcd8739ae039 {
  setup(s) {
    this.glyphInfos = s.glyphs.map((u) => new $10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, u.id, [
      ...u.codePoints
    ]));
    let c = null;
    this.GPOSProcessor && (c = this.GPOSProcessor.selectScript(s.script, s.language, s.direction)), this.GSUBProcessor && (c = this.GSUBProcessor.selectScript(s.script, s.language, s.direction)), this.shaper = $102b6fe50f1d50b4$export$7877a478dd30fd3d(c), this.plan = new $94d7a73bd2edfc9a$export$2e2bcd8739ae039(this.font, c, s.direction), this.shaper.plan(this.plan, this.glyphInfos, s.features);
    for (let u in this.plan.allFeatures) s.features[u] = !0;
  }
  substitute(s) {
    this.GSUBProcessor && (this.plan.process(this.GSUBProcessor, this.glyphInfos), s.glyphs = this.glyphInfos.map((c) => this.font.getGlyph(c.id, c.codePoints)));
  }
  position(s) {
    return this.shaper.zeroMarkWidths === "BEFORE_GPOS" && this.zeroMarkAdvances(s.positions), this.GPOSProcessor && this.plan.process(this.GPOSProcessor, this.glyphInfos, s.positions), this.shaper.zeroMarkWidths === "AFTER_GPOS" && this.zeroMarkAdvances(s.positions), s.direction === "rtl" && (s.glyphs.reverse(), s.positions.reverse()), this.GPOSProcessor && this.GPOSProcessor.features;
  }
  zeroMarkAdvances(s) {
    for (let c = 0; c < this.glyphInfos.length; c++) this.glyphInfos[c].isMark && (s[c].xAdvance = 0, s[c].yAdvance = 0);
  }
  cleanup() {
    this.glyphInfos = null, this.plan = null, this.shaper = null;
  }
  getAvailableFeatures(s, c) {
    let u = [];
    return this.GSUBProcessor && (this.GSUBProcessor.selectScript(s, c), u.push(...Object.keys(this.GSUBProcessor.features))), this.GPOSProcessor && (this.GPOSProcessor.selectScript(s, c), u.push(...Object.keys(this.GPOSProcessor.features))), u;
  }
  constructor(s) {
    this.font = s, this.glyphInfos = null, this.plan = null, this.GSUBProcessor = null, this.GPOSProcessor = null, this.fallbackPosition = !0, s.GSUB && (this.GSUBProcessor = new $0a876c45f1f7c41c$export$2e2bcd8739ae039(s, s.GSUB)), s.GPOS && (this.GPOSProcessor = new $c96c93587d49c14d$export$2e2bcd8739ae039(s, s.GPOS));
  }
}
class $4c0a7fa5df7a9ab1$export$2e2bcd8739ae039 {
  layout(s, c, u, d, p) {
    if (typeof c == "string" && (p = d, d = u, u = c, c = []), typeof s == "string") {
      u == null && (u = $130d1a642ebcd2b7$export$e5cb25e204fb8450(s));
      var v = this.font.glyphsForString(s);
    } else {
      if (u == null) {
        let g = [];
        for (let b of s) g.push(...b.codePoints);
        u = $130d1a642ebcd2b7$export$16fab0757cfc223d(g);
      }
      var v = s;
    }
    let A = new $be07b3e97a42687a$export$2e2bcd8739ae039(v, c, u, d, p);
    return v.length === 0 ? (A.positions = [], A) : (this.engine && this.engine.setup && this.engine.setup(A), this.substitute(A), this.position(A), this.hideDefaultIgnorables(A.glyphs, A.positions), this.engine && this.engine.cleanup && this.engine.cleanup(), A);
  }
  substitute(s) {
    this.engine && this.engine.substitute && this.engine.substitute(s);
  }
  position(s) {
    s.positions = s.glyphs.map((u) => new $1ac75d9a55b67f01$export$2e2bcd8739ae039(u.advanceWidth));
    let c = null;
    this.engine && this.engine.position && (c = this.engine.position(s)), !c && (!this.engine || this.engine.fallbackPosition) && (this.unicodeLayoutEngine || (this.unicodeLayoutEngine = new $0a4bdfeb6dfd6f5e$export$2e2bcd8739ae039(this.font)), this.unicodeLayoutEngine.positionGlyphs(s.glyphs, s.positions)), (!c || !c.kern) && s.features.kern !== !1 && this.font.kern && (this.kernProcessor || (this.kernProcessor = new $0bba3a9db57637f3$export$2e2bcd8739ae039(this.font)), this.kernProcessor.process(s.glyphs, s.positions), s.features.kern = !0);
  }
  hideDefaultIgnorables(s, c) {
    let u = this.font.glyphForCodePoint(32);
    for (let d = 0; d < s.length; d++) this.isDefaultIgnorable(s[d].codePoints[0]) && (s[d] = u, c[d].xAdvance = 0, c[d].yAdvance = 0);
  }
  isDefaultIgnorable(s) {
    let c = s >> 16;
    if (c === 0)
      switch (s >> 8) {
        case 0:
          return s === 173;
        case 3:
          return s === 847;
        case 6:
          return s === 1564;
        case 23:
          return 6068 <= s && s <= 6069;
        case 24:
          return 6155 <= s && s <= 6158;
        case 32:
          return 8203 <= s && s <= 8207 || 8234 <= s && s <= 8238 || 8288 <= s && s <= 8303;
        case 254:
          return 65024 <= s && s <= 65039 || s === 65279;
        case 255:
          return 65520 <= s && s <= 65528;
        default:
          return !1;
      }
    else
      switch (c) {
        case 1:
          return 113824 <= s && s <= 113827 || 119155 <= s && s <= 119162;
        case 14:
          return 917504 <= s && s <= 921599;
        default:
          return !1;
      }
  }
  getAvailableFeatures(s, c) {
    let u = [];
    return this.engine && u.push(...this.engine.getAvailableFeatures(s, c)), this.font.kern && u.indexOf("kern") === -1 && u.push("kern"), u;
  }
  stringsForGlyph(s) {
    let c = /* @__PURE__ */ new Set(), u = this.font._cmapProcessor.codePointsForGlyph(s);
    for (let d of u) c.add(String.fromCodePoint(d));
    if (this.engine && this.engine.stringsForGlyph) for (let d of this.engine.stringsForGlyph(s)) c.add(d);
    return Array.from(c);
  }
  constructor(s) {
    this.font = s, this.unicodeLayoutEngine = null, this.kernProcessor = null, this.font.morx ? this.engine = new $ba6dd74203be8728$export$2e2bcd8739ae039(this.font) : (this.font.GSUB || this.font.GPOS) && (this.engine = new $a62492810de27e3d$export$2e2bcd8739ae039(this.font));
  }
}
const $f43aec954cdfdf21$var$SVG_COMMANDS = {
  moveTo: "M",
  lineTo: "L",
  quadraticCurveTo: "Q",
  bezierCurveTo: "C",
  closePath: "Z"
};
class $f43aec954cdfdf21$export$2e2bcd8739ae039 {
  /**
  * Compiles the path to a JavaScript function that can be applied with
  * a graphics context in order to render the path.
  * @return {string}
  */
  toFunction() {
    return (s) => {
      this.commands.forEach((c) => s[c.command].apply(s, c.args));
    };
  }
  /**
  * Converts the path to an SVG path data string
  * @return {string}
  */
  toSVG() {
    return this.commands.map((c) => {
      let u = c.args.map((d) => Math.round(d * 100) / 100);
      return `${$f43aec954cdfdf21$var$SVG_COMMANDS[c.command]}${u.join(" ")}`;
    }).join("");
  }
  /**
  * Gets the "control box" of a path.
  * This is like the bounding box, but it includes all points including
  * control points of bezier segments and is much faster to compute than
  * the real bounding box.
  * @type {BBox}
  */
  get cbox() {
    if (!this._cbox) {
      let s = new $f34600ab9d7f70d8$export$2e2bcd8739ae039();
      for (let c of this.commands) for (let u = 0; u < c.args.length; u += 2) s.addPoint(c.args[u], c.args[u + 1]);
      this._cbox = Object.freeze(s);
    }
    return this._cbox;
  }
  /**
  * Gets the exact bounding box of the path by evaluating curve segments.
  * Slower to compute than the control box, but more accurate.
  * @type {BBox}
  */
  get bbox() {
    if (this._bbox) return this._bbox;
    let s = new $f34600ab9d7f70d8$export$2e2bcd8739ae039(), c = 0, u = 0, d = (T) => Math.pow(1 - T, 3) * m[$] + 3 * Math.pow(1 - T, 2) * T * C[$] + 3 * (1 - T) * Math.pow(T, 2) * w[$] + Math.pow(T, 3) * S[$];
    for (let T of this.commands) switch (T.command) {
      case "moveTo":
      case "lineTo":
        let [I, _] = T.args;
        s.addPoint(I, _), c = I, u = _;
        break;
      case "quadraticCurveTo":
      case "bezierCurveTo":
        if (T.command === "quadraticCurveTo")
          var [p, v, y, f] = T.args, A = c + 2 / 3 * (p - c), x = u + 2 / 3 * (v - u), g = y + 2 / 3 * (p - y), b = f + 2 / 3 * (v - f);
        else var [A, x, g, b, y, f] = T.args;
        s.addPoint(y, f);
        for (var m = [
          c,
          u
        ], C = [
          A,
          x
        ], w = [
          g,
          b
        ], S = [
          y,
          f
        ], $ = 0; $ <= 1; $++) {
          let E = 6 * m[$] - 12 * C[$] + 6 * w[$], R = -3 * m[$] + 9 * C[$] - 9 * w[$] + 3 * S[$];
          if (T = 3 * C[$] - 3 * m[$], R === 0) {
            if (E === 0) continue;
            let F = -T / E;
            0 < F && F < 1 && ($ === 0 ? s.addPoint(d(F), s.maxY) : $ === 1 && s.addPoint(s.maxX, d(F)));
            continue;
          }
          let O = Math.pow(E, 2) - 4 * T * R;
          if (O < 0) continue;
          let L = (-E + Math.sqrt(O)) / (2 * R);
          0 < L && L < 1 && ($ === 0 ? s.addPoint(d(L), s.maxY) : $ === 1 && s.addPoint(s.maxX, d(L)));
          let B = (-E - Math.sqrt(O)) / (2 * R);
          0 < B && B < 1 && ($ === 0 ? s.addPoint(d(B), s.maxY) : $ === 1 && s.addPoint(s.maxX, d(B)));
        }
        c = y, u = f;
        break;
    }
    return this._bbox = Object.freeze(s);
  }
  /**
  * Applies a mapping function to each point in the path.
  * @param {function} fn
  * @return {Path}
  */
  mapPoints(s) {
    let c = new $f43aec954cdfdf21$export$2e2bcd8739ae039();
    for (let u of this.commands) {
      let d = [];
      for (let p = 0; p < u.args.length; p += 2) {
        let [v, A] = s(u.args[p], u.args[p + 1]);
        d.push(v, A);
      }
      c[u.command](...d);
    }
    return c;
  }
  /**
  * Transforms the path by the given matrix.
  */
  transform(s, c, u, d, p, v) {
    return this.mapPoints((A, x) => {
      const g = s * A + u * x + p, b = c * A + d * x + v;
      return [
        g,
        b
      ];
    });
  }
  /**
  * Translates the path by the given offset.
  */
  translate(s, c) {
    return this.transform(1, 0, 0, 1, s, c);
  }
  /**
  * Rotates the path by the given angle (in radians).
  */
  rotate(s) {
    let c = Math.cos(s), u = Math.sin(s);
    return this.transform(c, u, -u, c, 0, 0);
  }
  /**
  * Scales the path.
  */
  scale(s, c = s) {
    return this.transform(s, 0, 0, c, 0, 0);
  }
  constructor() {
    this.commands = [], this._bbox = null, this._cbox = null;
  }
}
for (let a of [
  "moveTo",
  "lineTo",
  "quadraticCurveTo",
  "bezierCurveTo",
  "closePath"
]) $f43aec954cdfdf21$export$2e2bcd8739ae039.prototype[a] = function(...s) {
  return this._bbox = this._cbox = null, this.commands.push({
    command: a,
    args: s
  }), this;
};
var $7713b9b7b438dff8$export$2e2bcd8739ae039 = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
class $f92906be28e61769$export$2e2bcd8739ae039 {
  _getPath() {
    return new $f43aec954cdfdf21$export$2e2bcd8739ae039();
  }
  _getCBox() {
    return this.path.cbox;
  }
  _getBBox() {
    return this.path.bbox;
  }
  _getTableMetrics(s) {
    if (this.id < s.metrics.length) return s.metrics.get(this.id);
    let c = s.metrics.get(s.metrics.length - 1);
    return {
      advance: c ? c.advance : 0,
      bearing: s.bearings.get(this.id - s.metrics.length) || 0
    };
  }
  _getMetrics(s) {
    if (this._metrics) return this._metrics;
    let { advance: c, bearing: u } = this._getTableMetrics(this._font.hmtx);
    if (this._font.vmtx) var { advance: d, bearing: p } = this._getTableMetrics(this._font.vmtx);
    else {
      let v;
      if ((typeof s > "u" || s === null) && ({ cbox: s } = this), (v = this._font["OS/2"]) && v.version > 0)
        var d = Math.abs(v.typoAscender - v.typoDescender), p = v.typoAscender - s.maxY;
      else {
        let { hhea: A } = this._font;
        var d = Math.abs(A.ascent - A.descent), p = A.ascent - s.maxY;
      }
    }
    return this._font._variationProcessor && this._font.HVAR && (c += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR)), this._metrics = {
      advanceWidth: c,
      advanceHeight: d,
      leftBearing: u,
      topBearing: p
    };
  }
  /**
  * The glyph’s control box.
  * This is often the same as the bounding box, but is faster to compute.
  * Because of the way bezier curves are defined, some of the control points
  * can be outside of the bounding box. Where `bbox` takes this into account,
  * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
  * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
  * for a more detailed description.
  *
  * @type {BBox}
  */
  get cbox() {
    return this._getCBox();
  }
  /**
  * The glyph’s bounding box, i.e. the rectangle that encloses the
  * glyph outline as tightly as possible.
  * @type {BBox}
  */
  get bbox() {
    return this._getBBox();
  }
  /**
  * A vector Path object representing the glyph outline.
  * @type {Path}
  */
  get path() {
    return this._getPath();
  }
  /**
  * Returns a path scaled to the given font size.
  * @param {number} size
  * @return {Path}
  */
  getScaledPath(s) {
    let c = 1 / this._font.unitsPerEm * s;
    return this.path.scale(c);
  }
  /**
  * The glyph's advance width.
  * @type {number}
  */
  get advanceWidth() {
    return this._getMetrics().advanceWidth;
  }
  /**
  * The glyph's advance height.
  * @type {number}
  */
  get advanceHeight() {
    return this._getMetrics().advanceHeight;
  }
  get ligatureCaretPositions() {
  }
  _getName() {
    let { post: s } = this._font;
    if (!s) return null;
    switch (s.version) {
      case 1:
        return $7713b9b7b438dff8$export$2e2bcd8739ae039[this.id];
      case 2:
        let c = s.glyphNameIndex[this.id];
        return c < $7713b9b7b438dff8$export$2e2bcd8739ae039.length ? $7713b9b7b438dff8$export$2e2bcd8739ae039[c] : s.names[c - $7713b9b7b438dff8$export$2e2bcd8739ae039.length];
      case 2.5:
        return $7713b9b7b438dff8$export$2e2bcd8739ae039[this.id + s.offsets[this.id]];
      case 4:
        return String.fromCharCode(s.map[this.id]);
    }
  }
  /**
  * The glyph's name
  * @type {string}
  */
  get name() {
    return this._getName();
  }
  /**
  * Renders the glyph to the given graphics context, at the specified font size.
  * @param {CanvasRenderingContext2d} ctx
  * @param {number} size
  */
  render(s, c) {
    s.save();
    let u = 1 / this._font.head.unitsPerEm * c;
    s.scale(u, u), this.path.toFunction()(s), s.fill(), s.restore();
  }
  constructor(s, c, u) {
    this.id = s, this.codePoints = c, this._font = u, this.isMark = this.codePoints.length > 0 && this.codePoints.every($747425b437e121da$export$e33ad6871e762338), this.isLigature = this.codePoints.length > 1;
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "cbox", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "bbox", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "path", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "advanceWidth", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "advanceHeight", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "name", null);
let $69aac16029968692$var$GlyfHeader = new Struct({
  numberOfContours: int16,
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16
});
const $69aac16029968692$var$ON_CURVE = 1, $69aac16029968692$var$X_SHORT_VECTOR = 2, $69aac16029968692$var$Y_SHORT_VECTOR = 4, $69aac16029968692$var$REPEAT = 8, $69aac16029968692$var$SAME_X = 16, $69aac16029968692$var$SAME_Y = 32, $69aac16029968692$var$ARG_1_AND_2_ARE_WORDS = 1, $69aac16029968692$var$WE_HAVE_A_SCALE = 8, $69aac16029968692$var$MORE_COMPONENTS = 32, $69aac16029968692$var$WE_HAVE_AN_X_AND_Y_SCALE = 64, $69aac16029968692$var$WE_HAVE_A_TWO_BY_TWO = 128, $69aac16029968692$var$WE_HAVE_INSTRUCTIONS = 256;
class $69aac16029968692$export$baf26146a414f24a {
  copy() {
    return new $69aac16029968692$export$baf26146a414f24a(this.onCurve, this.endContour, this.x, this.y);
  }
  constructor(s, c, u = 0, d = 0) {
    this.onCurve = s, this.endContour = c, this.x = u, this.y = d;
  }
}
class $69aac16029968692$var$Component {
  constructor(s, c, u) {
    this.glyphID = s, this.dx = c, this.dy = u, this.pos = 0, this.scaleX = this.scaleY = 1, this.scale01 = this.scale10 = 0;
  }
}
class $69aac16029968692$export$2e2bcd8739ae039 extends $f92906be28e61769$export$2e2bcd8739ae039 {
  // Parses just the glyph header and returns the bounding box
  _getCBox(s) {
    if (this._font._variationProcessor && !s) return this.path.cbox;
    let c = this._font._getTableStream("glyf");
    c.pos += this._font.loca.offsets[this.id];
    let u = $69aac16029968692$var$GlyfHeader.decode(c), d = new $f34600ab9d7f70d8$export$2e2bcd8739ae039(u.xMin, u.yMin, u.xMax, u.yMax);
    return Object.freeze(d);
  }
  // Parses a single glyph coordinate
  _parseGlyphCoord(s, c, u, d) {
    if (u) {
      var p = s.readUInt8();
      d || (p = -p), p += c;
    } else if (d) var p = c;
    else var p = c + s.readInt16BE();
    return p;
  }
  // Decodes the glyph data into points for simple glyphs,
  // or components for composite glyphs
  _decode() {
    let s = this._font.loca.offsets[this.id], c = this._font.loca.offsets[this.id + 1];
    if (s === c) return null;
    let u = this._font._getTableStream("glyf");
    u.pos += s;
    let d = u.pos, p = $69aac16029968692$var$GlyfHeader.decode(u);
    return p.numberOfContours > 0 ? this._decodeSimple(p, u) : p.numberOfContours < 0 && this._decodeComposite(p, u, d), p;
  }
  _decodeSimple(s, c) {
    s.points = [];
    let u = new ArrayT(uint16, s.numberOfContours).decode(c);
    s.instructions = new ArrayT(uint8, uint16).decode(c);
    let d = [], p = u[u.length - 1] + 1;
    for (; d.length < p; ) {
      var v = c.readUInt8();
      if (d.push(v), v & $69aac16029968692$var$REPEAT) {
        let b = c.readUInt8();
        for (let y = 0; y < b; y++) d.push(v);
      }
    }
    for (var A = 0; A < d.length; A++) {
      var v = d[A];
      let y = new $69aac16029968692$export$baf26146a414f24a(!!(v & $69aac16029968692$var$ON_CURVE), u.indexOf(A) >= 0, 0, 0);
      s.points.push(y);
    }
    let x = 0;
    for (var A = 0; A < d.length; A++) {
      var v = d[A];
      s.points[A].x = x = this._parseGlyphCoord(c, x, v & $69aac16029968692$var$X_SHORT_VECTOR, v & $69aac16029968692$var$SAME_X);
    }
    let g = 0;
    for (var A = 0; A < d.length; A++) {
      var v = d[A];
      s.points[A].y = g = this._parseGlyphCoord(c, g, v & $69aac16029968692$var$Y_SHORT_VECTOR, v & $69aac16029968692$var$SAME_Y);
    }
    if (this._font._variationProcessor) {
      let b = s.points.slice();
      b.push(...this._getPhantomPoints(s)), this._font._variationProcessor.transformPoints(this.id, b), s.phantomPoints = b.slice(-4);
    }
  }
  _decodeComposite(s, c, u = 0) {
    s.components = [];
    let d = !1, p = $69aac16029968692$var$MORE_COMPONENTS;
    for (; p & $69aac16029968692$var$MORE_COMPONENTS; ) {
      p = c.readUInt16BE();
      let g = c.pos - u, b = c.readUInt16BE();
      if (d || (d = (p & $69aac16029968692$var$WE_HAVE_INSTRUCTIONS) !== 0), p & $69aac16029968692$var$ARG_1_AND_2_ARE_WORDS)
        var v = c.readInt16BE(), A = c.readInt16BE();
      else
        var v = c.readInt8(), A = c.readInt8();
      var x = new $69aac16029968692$var$Component(b, v, A);
      x.pos = g, p & $69aac16029968692$var$WE_HAVE_A_SCALE ? x.scaleX = x.scaleY = (c.readUInt8() << 24 | c.readUInt8() << 16) / 1073741824 : p & $69aac16029968692$var$WE_HAVE_AN_X_AND_Y_SCALE ? (x.scaleX = (c.readUInt8() << 24 | c.readUInt8() << 16) / 1073741824, x.scaleY = (c.readUInt8() << 24 | c.readUInt8() << 16) / 1073741824) : p & $69aac16029968692$var$WE_HAVE_A_TWO_BY_TWO && (x.scaleX = (c.readUInt8() << 24 | c.readUInt8() << 16) / 1073741824, x.scale01 = (c.readUInt8() << 24 | c.readUInt8() << 16) / 1073741824, x.scale10 = (c.readUInt8() << 24 | c.readUInt8() << 16) / 1073741824, x.scaleY = (c.readUInt8() << 24 | c.readUInt8() << 16) / 1073741824), s.components.push(x);
    }
    if (this._font._variationProcessor) {
      let g = [];
      for (let b = 0; b < s.components.length; b++) {
        var x = s.components[b];
        g.push(new $69aac16029968692$export$baf26146a414f24a(!0, !0, x.dx, x.dy));
      }
      g.push(...this._getPhantomPoints(s)), this._font._variationProcessor.transformPoints(this.id, g), s.phantomPoints = g.splice(-4, 4);
      for (let b = 0; b < g.length; b++) {
        let y = g[b];
        s.components[b].dx = y.x, s.components[b].dy = y.y;
      }
    }
    return d;
  }
  _getPhantomPoints(s) {
    let c = this._getCBox(!0);
    this._metrics == null && (this._metrics = $f92906be28e61769$export$2e2bcd8739ae039.prototype._getMetrics.call(this, c));
    let { advanceWidth: u, advanceHeight: d, leftBearing: p, topBearing: v } = this._metrics;
    return [
      new $69aac16029968692$export$baf26146a414f24a(!1, !0, s.xMin - p, 0),
      new $69aac16029968692$export$baf26146a414f24a(!1, !0, s.xMin - p + u, 0),
      new $69aac16029968692$export$baf26146a414f24a(!1, !0, 0, s.yMax + v),
      new $69aac16029968692$export$baf26146a414f24a(!1, !0, 0, s.yMax + v + d)
    ];
  }
  // Decodes font data, resolves composite glyphs, and returns an array of contours
  _getContours() {
    let s = this._decode();
    if (!s) return [];
    let c = [];
    if (s.numberOfContours < 0)
      for (let v of s.components) {
        let A = this._font.getGlyph(v.glyphID)._getContours();
        for (let x = 0; x < A.length; x++) {
          let g = A[x];
          for (let b = 0; b < g.length; b++) {
            let y = g[b], f = y.x * v.scaleX + y.y * v.scale01 + v.dx, m = y.y * v.scaleY + y.x * v.scale10 + v.dy;
            c.push(new $69aac16029968692$export$baf26146a414f24a(y.onCurve, y.endContour, f, m));
          }
        }
      }
    else c = s.points || [];
    s.phantomPoints && !this._font.directory.tables.HVAR && (this._metrics.advanceWidth = s.phantomPoints[1].x - s.phantomPoints[0].x, this._metrics.advanceHeight = s.phantomPoints[3].y - s.phantomPoints[2].y, this._metrics.leftBearing = s.xMin - s.phantomPoints[0].x, this._metrics.topBearing = s.phantomPoints[2].y - s.yMax);
    let u = [], d = [];
    for (let v = 0; v < c.length; v++) {
      var p = c[v];
      d.push(p), p.endContour && (u.push(d), d = []);
    }
    return u;
  }
  _getMetrics() {
    if (this._metrics) return this._metrics;
    let s = this._getCBox(!0);
    return super._getMetrics(s), this._font._variationProcessor && !this._font.HVAR && this.path, this._metrics;
  }
  // Converts contours to a Path object that can be rendered
  _getPath() {
    let s = this._getContours(), c = new $f43aec954cdfdf21$export$2e2bcd8739ae039();
    for (let d = 0; d < s.length; d++) {
      let p = s[d], v = p[0], A = p[p.length - 1], x = 0;
      if (v.onCurve) {
        var u = null;
        x = 1;
      } else {
        A.onCurve ? v = A : v = new $69aac16029968692$export$baf26146a414f24a(!1, !1, (v.x + A.x) / 2, (v.y + A.y) / 2);
        var u = v;
      }
      c.moveTo(v.x, v.y);
      for (let g = x; g < p.length; g++) {
        let b = p[g], y = g === 0 ? v : p[g - 1];
        if (y.onCurve && b.onCurve) c.lineTo(b.x, b.y);
        else if (y.onCurve && !b.onCurve) var u = b;
        else if (!y.onCurve && !b.onCurve) {
          let m = (y.x + b.x) / 2, C = (y.y + b.y) / 2;
          c.quadraticCurveTo(y.x, y.y, m, C);
          var u = b;
        } else if (!y.onCurve && b.onCurve) {
          c.quadraticCurveTo(u.x, u.y, b.x, b.y);
          var u = null;
        } else throw new Error("Unknown TTF path state");
      }
      u && c.quadraticCurveTo(u.x, u.y, v.x, v.y), c.closePath();
    }
    return c;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "TTF");
  }
}
class $62cc5109c6101893$export$2e2bcd8739ae039 extends $f92906be28e61769$export$2e2bcd8739ae039 {
  _getName() {
    return this._font.CFF2 ? super._getName() : this._font["CFF "].getGlyphName(this.id);
  }
  bias(s) {
    return s.length < 1240 ? 107 : s.length < 33900 ? 1131 : 32768;
  }
  _getPath() {
    let s = this._font.CFF2 || this._font["CFF "], { stream: c } = s, u = s.topDict.CharStrings[this.id], d = u.offset + u.length;
    c.pos = u.offset;
    let p = new $f43aec954cdfdf21$export$2e2bcd8739ae039(), v = [], A = [], x = null, g = 0, b = 0, y = 0, f, m, C = !1;
    this._usedGsubrs = f = {}, this._usedSubrs = m = {};
    let w = s.globalSubrIndex || [], S = this.bias(w), $ = s.privateDictForGlyph(this.id) || {}, T = $.Subrs || [], I = this.bias(T), _ = s.topDict.vstore && s.topDict.vstore.itemVariationStore, E = $.vsindex, R = this._font._variationProcessor;
    function O() {
      x == null && (x = v.shift() + $.nominalWidthX);
    }
    function L() {
      return v.length % 2 !== 0 && O(), g += v.length >> 1, v.length = 0;
    }
    function B(M, W) {
      C && p.closePath(), p.moveTo(M, W), C = !0;
    }
    let F = function() {
      for (; c.pos < d; ) {
        let j = c.readUInt8();
        if (j < 32) {
          let G, U, k, N, P, D, H, V, Z, ne, K, q, Y, ee, Q, J;
          switch (j) {
            case 1:
            case 3:
            case 18:
            case 23:
              L();
              break;
            case 4:
              v.length > 1 && O(), y += v.shift(), B(b, y);
              break;
            case 5:
              for (; v.length >= 2; )
                b += v.shift(), y += v.shift(), p.lineTo(b, y);
              break;
            case 6:
            case 7:
              for (k = j === 6; v.length >= 1; )
                k ? b += v.shift() : y += v.shift(), p.lineTo(b, y), k = !k;
              break;
            case 8:
              for (; v.length > 0; )
                N = b + v.shift(), P = y + v.shift(), D = N + v.shift(), H = P + v.shift(), b = D + v.shift(), y = H + v.shift(), p.bezierCurveTo(N, P, D, H, b, y);
              break;
            case 10:
              if (G = v.pop() + I, U = T[G], U) {
                m[G] = !0;
                let te = c.pos, ae = d;
                c.pos = U.offset, d = U.offset + U.length, F(), c.pos = te, d = ae;
              }
              break;
            case 11:
              if (s.version >= 2) break;
              return;
            case 14:
              if (s.version >= 2) break;
              v.length > 0 && O(), C && (p.closePath(), C = !1);
              break;
            case 15:
              if (s.version < 2) throw new Error("vsindex operator not supported in CFF v1");
              E = v.pop();
              break;
            case 16: {
              if (s.version < 2) throw new Error("blend operator not supported in CFF v1");
              if (!R) throw new Error("blend operator in non-variation font");
              let te = R.getBlendVector(_, E), ae = v.pop(), se = ae * te.length, ie = v.length - se, fe = ie - ae;
              for (let ge = 0; ge < ae; ge++) {
                let me = v[fe + ge];
                for (let pe = 0; pe < te.length; pe++) me += te[pe] * v[ie++];
                v[fe + ge] = me;
              }
              for (; se--; ) v.pop();
              break;
            }
            case 19:
            case 20:
              L(), c.pos += g + 7 >> 3;
              break;
            case 21:
              v.length > 2 && O(), b += v.shift(), y += v.shift(), B(b, y);
              break;
            case 22:
              v.length > 1 && O(), b += v.shift(), B(b, y);
              break;
            case 24:
              for (; v.length >= 8; )
                N = b + v.shift(), P = y + v.shift(), D = N + v.shift(), H = P + v.shift(), b = D + v.shift(), y = H + v.shift(), p.bezierCurveTo(N, P, D, H, b, y);
              b += v.shift(), y += v.shift(), p.lineTo(b, y);
              break;
            case 25:
              for (; v.length >= 8; )
                b += v.shift(), y += v.shift(), p.lineTo(b, y);
              N = b + v.shift(), P = y + v.shift(), D = N + v.shift(), H = P + v.shift(), b = D + v.shift(), y = H + v.shift(), p.bezierCurveTo(N, P, D, H, b, y);
              break;
            case 26:
              for (v.length % 2 && (b += v.shift()); v.length >= 4; )
                N = b, P = y + v.shift(), D = N + v.shift(), H = P + v.shift(), b = D, y = H + v.shift(), p.bezierCurveTo(N, P, D, H, b, y);
              break;
            case 27:
              for (v.length % 2 && (y += v.shift()); v.length >= 4; )
                N = b + v.shift(), P = y, D = N + v.shift(), H = P + v.shift(), b = D + v.shift(), y = H, p.bezierCurveTo(N, P, D, H, b, y);
              break;
            case 28:
              v.push(c.readInt16BE());
              break;
            case 29:
              if (G = v.pop() + S, U = w[G], U) {
                f[G] = !0;
                let te = c.pos, ae = d;
                c.pos = U.offset, d = U.offset + U.length, F(), c.pos = te, d = ae;
              }
              break;
            case 30:
            case 31:
              for (k = j === 31; v.length >= 4; )
                k ? (N = b + v.shift(), P = y, D = N + v.shift(), H = P + v.shift(), y = H + v.shift(), b = D + (v.length === 1 ? v.shift() : 0)) : (N = b, P = y + v.shift(), D = N + v.shift(), H = P + v.shift(), b = D + v.shift(), y = H + (v.length === 1 ? v.shift() : 0)), p.bezierCurveTo(N, P, D, H, b, y), k = !k;
              break;
            case 12:
              switch (j = c.readUInt8(), j) {
                case 3:
                  let te = v.pop(), ae = v.pop();
                  v.push(te && ae ? 1 : 0);
                  break;
                case 4:
                  te = v.pop(), ae = v.pop(), v.push(te || ae ? 1 : 0);
                  break;
                case 5:
                  te = v.pop(), v.push(te ? 0 : 1);
                  break;
                case 9:
                  te = v.pop(), v.push(Math.abs(te));
                  break;
                case 10:
                  te = v.pop(), ae = v.pop(), v.push(te + ae);
                  break;
                case 11:
                  te = v.pop(), ae = v.pop(), v.push(te - ae);
                  break;
                case 12:
                  te = v.pop(), ae = v.pop(), v.push(te / ae);
                  break;
                case 14:
                  te = v.pop(), v.push(-te);
                  break;
                case 15:
                  te = v.pop(), ae = v.pop(), v.push(te === ae ? 1 : 0);
                  break;
                case 18:
                  v.pop();
                  break;
                case 20:
                  let se = v.pop(), ie = v.pop();
                  A[ie] = se;
                  break;
                case 21:
                  ie = v.pop(), v.push(A[ie] || 0);
                  break;
                case 22:
                  let fe = v.pop(), ge = v.pop(), me = v.pop(), pe = v.pop();
                  v.push(me <= pe ? fe : ge);
                  break;
                case 23:
                  v.push(Math.random());
                  break;
                case 24:
                  te = v.pop(), ae = v.pop(), v.push(te * ae);
                  break;
                case 26:
                  te = v.pop(), v.push(Math.sqrt(te));
                  break;
                case 27:
                  te = v.pop(), v.push(te, te);
                  break;
                case 28:
                  te = v.pop(), ae = v.pop(), v.push(ae, te);
                  break;
                case 29:
                  ie = v.pop(), ie < 0 ? ie = 0 : ie > v.length - 1 && (ie = v.length - 1), v.push(v[ie]);
                  break;
                case 30:
                  let be = v.pop(), le = v.pop();
                  if (le >= 0) for (; le > 0; ) {
                    var M = v[be - 1];
                    for (let ye = be - 2; ye >= 0; ye--) v[ye + 1] = v[ye];
                    v[0] = M, le--;
                  }
                  else for (; le < 0; ) {
                    var M = v[0];
                    for (let Ce = 0; Ce <= be; Ce++) v[Ce] = v[Ce + 1];
                    v[be - 1] = M, le++;
                  }
                  break;
                case 34:
                  N = b + v.shift(), P = y, D = N + v.shift(), H = P + v.shift(), V = D + v.shift(), Z = H, ne = V + v.shift(), K = Z, q = ne + v.shift(), Y = K, ee = q + v.shift(), Q = Y, b = ee, y = Q, p.bezierCurveTo(N, P, D, H, V, Z), p.bezierCurveTo(ne, K, q, Y, ee, Q);
                  break;
                case 35:
                  J = [];
                  for (let ye = 0; ye <= 5; ye++)
                    b += v.shift(), y += v.shift(), J.push(b, y);
                  p.bezierCurveTo(...J.slice(0, 6)), p.bezierCurveTo(...J.slice(6)), v.shift();
                  break;
                case 36:
                  N = b + v.shift(), P = y + v.shift(), D = N + v.shift(), H = P + v.shift(), V = D + v.shift(), Z = H, ne = V + v.shift(), K = Z, q = ne + v.shift(), Y = K + v.shift(), ee = q + v.shift(), Q = Y, b = ee, y = Q, p.bezierCurveTo(N, P, D, H, V, Z), p.bezierCurveTo(ne, K, q, Y, ee, Q);
                  break;
                case 37:
                  let ve = b, he = y;
                  J = [];
                  for (let ye = 0; ye <= 4; ye++)
                    b += v.shift(), y += v.shift(), J.push(b, y);
                  Math.abs(b - ve) > Math.abs(y - he) ? (b += v.shift(), y = he) : (b = ve, y += v.shift()), J.push(b, y), p.bezierCurveTo(...J.slice(0, 6)), p.bezierCurveTo(...J.slice(6));
                  break;
                default:
                  throw new Error(`Unknown op: 12 ${j}`);
              }
              break;
            default:
              throw new Error(`Unknown op: ${j}`);
          }
        } else if (j < 247) v.push(j - 139);
        else if (j < 251) {
          var W = c.readUInt8();
          v.push((j - 247) * 256 + W + 108);
        } else if (j < 255) {
          var W = c.readUInt8();
          v.push(-(j - 251) * 256 - W - 108);
        } else v.push(c.readInt32BE() / 65536);
      }
    };
    return F(), C && p.closePath(), p;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "CFF");
  }
}
let $25d8f049c222084c$var$SBIXImage = new Struct({
  originX: uint16,
  originY: uint16,
  type: new StringT(4),
  data: new BufferT((a) => a.parent.buflen - a._currentOffset)
});
class $25d8f049c222084c$export$2e2bcd8739ae039 extends $69aac16029968692$export$2e2bcd8739ae039 {
  /**
  * Returns an object representing a glyph image at the given point size.
  * The object has a data property with a Buffer containing the actual image data,
  * along with the image type, and origin.
  *
  * @param {number} size
  * @return {object}
  */
  getImageForSize(s) {
    for (let v = 0; v < this._font.sbix.imageTables.length; v++) {
      var c = this._font.sbix.imageTables[v];
      if (c.ppem >= s) break;
    }
    let u = c.imageOffsets, d = u[this.id], p = u[this.id + 1];
    return d === p ? null : (this._font.stream.pos = d, $25d8f049c222084c$var$SBIXImage.decode(this._font.stream, {
      buflen: p - d
    }));
  }
  render(s, c) {
    let u = this.getImageForSize(c);
    if (u != null) {
      let d = c / this._font.unitsPerEm;
      s.image(u.data, {
        height: c,
        x: u.originX,
        y: (this.bbox.minY - u.originY) * d
      });
    }
    this._font.sbix.flags.renderOutlines && super.render(s, c);
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "SBIX");
  }
}
class $0d411f0165859681$var$COLRLayer {
  constructor(s, c) {
    this.glyph = s, this.color = c;
  }
}
class $0d411f0165859681$export$2e2bcd8739ae039 extends $f92906be28e61769$export$2e2bcd8739ae039 {
  _getBBox() {
    let s = new $f34600ab9d7f70d8$export$2e2bcd8739ae039();
    for (let c = 0; c < this.layers.length; c++) {
      let d = this.layers[c].glyph.bbox;
      s.addPoint(d.minX, d.minY), s.addPoint(d.maxX, d.maxY);
    }
    return s;
  }
  /**
  * Returns an array of objects containing the glyph and color for
  * each layer in the composite color glyph.
  * @type {object[]}
  */
  get layers() {
    let s = this._font.CPAL, c = this._font.COLR, u = 0, d = c.baseGlyphRecord.length - 1;
    for (; u <= d; ) {
      let b = u + d >> 1;
      var p = c.baseGlyphRecord[b];
      if (this.id < p.gid) d = b - 1;
      else if (this.id > p.gid) u = b + 1;
      else {
        var v = p;
        break;
      }
    }
    if (v == null) {
      var A = this._font._getBaseGlyph(this.id), x = {
        red: 0,
        green: 0,
        blue: 0,
        alpha: 255
      };
      return [
        new $0d411f0165859681$var$COLRLayer(A, x)
      ];
    }
    let g = [];
    for (let b = v.firstLayerIndex; b < v.firstLayerIndex + v.numLayers; b++) {
      var p = c.layerRecords[b], x = s.colorRecords[p.paletteIndex], A = this._font._getBaseGlyph(p.gid);
      g.push(new $0d411f0165859681$var$COLRLayer(A, x));
    }
    return g;
  }
  render(s, c) {
    for (let { glyph: u, color: d } of this.layers)
      s.fillColor([
        d.red,
        d.green,
        d.blue
      ], d.alpha / 255 * 100), u.render(s, c);
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "COLR");
  }
}
const $0bb840cac04e911b$var$TUPLES_SHARE_POINT_NUMBERS = 32768, $0bb840cac04e911b$var$TUPLE_COUNT_MASK = 4095, $0bb840cac04e911b$var$EMBEDDED_TUPLE_COORD = 32768, $0bb840cac04e911b$var$INTERMEDIATE_TUPLE = 16384, $0bb840cac04e911b$var$PRIVATE_POINT_NUMBERS = 8192, $0bb840cac04e911b$var$TUPLE_INDEX_MASK = 4095, $0bb840cac04e911b$var$POINTS_ARE_WORDS = 128, $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK = 127, $0bb840cac04e911b$var$DELTAS_ARE_ZERO = 128, $0bb840cac04e911b$var$DELTAS_ARE_WORDS = 64, $0bb840cac04e911b$var$DELTA_RUN_COUNT_MASK = 63;
class $0bb840cac04e911b$export$2e2bcd8739ae039 {
  normalizeCoords(s) {
    let c = [];
    for (var u = 0; u < this.font.fvar.axis.length; u++) {
      let d = this.font.fvar.axis[u];
      s[u] < d.defaultValue ? c.push((s[u] - d.defaultValue + Number.EPSILON) / (d.defaultValue - d.minValue + Number.EPSILON)) : c.push((s[u] - d.defaultValue + Number.EPSILON) / (d.maxValue - d.defaultValue + Number.EPSILON));
    }
    if (this.font.avar) for (var u = 0; u < this.font.avar.segment.length; u++) {
      let p = this.font.avar.segment[u];
      for (let v = 0; v < p.correspondence.length; v++) {
        let A = p.correspondence[v];
        if (v >= 1 && c[u] < A.fromCoord) {
          let x = p.correspondence[v - 1];
          c[u] = ((c[u] - x.fromCoord) * (A.toCoord - x.toCoord) + Number.EPSILON) / (A.fromCoord - x.fromCoord + Number.EPSILON) + x.toCoord;
          break;
        }
      }
    }
    return c;
  }
  transformPoints(s, c) {
    if (!this.font.fvar || !this.font.gvar) return;
    let { gvar: u } = this.font;
    if (s >= u.glyphCount) return;
    let d = u.offsets[s];
    if (d === u.offsets[s + 1]) return;
    let { stream: p } = this.font;
    if (p.pos = d, p.pos >= p.length) return;
    let v = p.readUInt16BE(), A = d + p.readUInt16BE();
    if (v & $0bb840cac04e911b$var$TUPLES_SHARE_POINT_NUMBERS) {
      var x = p.pos;
      p.pos = A;
      var g = this.decodePoints();
      A = p.pos, p.pos = x;
    }
    let b = c.map((S) => S.copy());
    v &= $0bb840cac04e911b$var$TUPLE_COUNT_MASK;
    for (let S = 0; S < v; S++) {
      let $ = p.readUInt16BE(), T = p.readUInt16BE();
      if (T & $0bb840cac04e911b$var$EMBEDDED_TUPLE_COORD) {
        var y = [];
        for (let L = 0; L < u.axisCount; L++) y.push(p.readInt16BE() / 16384);
      } else {
        if ((T & $0bb840cac04e911b$var$TUPLE_INDEX_MASK) >= u.globalCoordCount) throw new Error("Invalid gvar table");
        var y = u.globalCoords[T & $0bb840cac04e911b$var$TUPLE_INDEX_MASK];
      }
      if (T & $0bb840cac04e911b$var$INTERMEDIATE_TUPLE) {
        var f = [];
        for (let L = 0; L < u.axisCount; L++) f.push(p.readInt16BE() / 16384);
        var m = [];
        for (let L = 0; L < u.axisCount; L++) m.push(p.readInt16BE() / 16384);
      }
      let I = this.tupleFactor(T, y, f, m);
      if (I === 0) {
        A += $;
        continue;
      }
      var x = p.pos;
      if (p.pos = A, T & $0bb840cac04e911b$var$PRIVATE_POINT_NUMBERS) var C = this.decodePoints();
      else var C = g;
      let E = C.length === 0 ? c.length : C.length, R = this.decodeDeltas(E), O = this.decodeDeltas(E);
      if (C.length === 0) for (let L = 0; L < c.length; L++) {
        var w = c[L];
        w.x += Math.round(R[L] * I), w.y += Math.round(O[L] * I);
      }
      else {
        let L = b.map((F) => F.copy()), B = c.map(() => !1);
        for (let F = 0; F < C.length; F++) {
          let M = C[F];
          if (M < c.length) {
            let W = L[M];
            B[M] = !0, W.x += R[F] * I, W.y += O[F] * I;
          }
        }
        this.interpolateMissingDeltas(L, b, B);
        for (let F = 0; F < c.length; F++) {
          let M = L[F].x - b[F].x, W = L[F].y - b[F].y;
          c[F].x = Math.round(c[F].x + M), c[F].y = Math.round(c[F].y + W);
        }
      }
      A += $, p.pos = x;
    }
  }
  decodePoints() {
    let s = this.font.stream, c = s.readUInt8();
    c & $0bb840cac04e911b$var$POINTS_ARE_WORDS && (c = (c & $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK) << 8 | s.readUInt8());
    let u = new Uint16Array(c), d = 0, p = 0;
    for (; d < c; ) {
      let v = s.readUInt8(), A = (v & $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK) + 1, x = v & $0bb840cac04e911b$var$POINTS_ARE_WORDS ? s.readUInt16 : s.readUInt8;
      for (let g = 0; g < A && d < c; g++)
        p += x.call(s), u[d++] = p;
    }
    return u;
  }
  decodeDeltas(s) {
    let c = this.font.stream, u = 0, d = new Int16Array(s);
    for (; u < s; ) {
      let p = c.readUInt8(), v = (p & $0bb840cac04e911b$var$DELTA_RUN_COUNT_MASK) + 1;
      if (p & $0bb840cac04e911b$var$DELTAS_ARE_ZERO) u += v;
      else {
        let A = p & $0bb840cac04e911b$var$DELTAS_ARE_WORDS ? c.readInt16BE : c.readInt8;
        for (let x = 0; x < v && u < s; x++) d[u++] = A.call(c);
      }
    }
    return d;
  }
  tupleFactor(s, c, u, d) {
    let p = this.normalizedCoords, { gvar: v } = this.font, A = 1;
    for (let x = 0; x < v.axisCount; x++)
      if (c[x] !== 0) {
        if (p[x] === 0) return 0;
        if ((s & $0bb840cac04e911b$var$INTERMEDIATE_TUPLE) === 0) {
          if (p[x] < Math.min(0, c[x]) || p[x] > Math.max(0, c[x])) return 0;
          A = (A * p[x] + Number.EPSILON) / (c[x] + Number.EPSILON);
        } else {
          if (p[x] < u[x] || p[x] > d[x]) return 0;
          p[x] < c[x] ? A = A * (p[x] - u[x] + Number.EPSILON) / (c[x] - u[x] + Number.EPSILON) : A = A * (d[x] - p[x] + Number.EPSILON) / (d[x] - c[x] + Number.EPSILON);
        }
      }
    return A;
  }
  // Interpolates points without delta values.
  // Needed for the Ø and Q glyphs in Skia.
  // Algorithm from Freetype.
  interpolateMissingDeltas(s, c, u) {
    if (s.length === 0) return;
    let d = 0;
    for (; d < s.length; ) {
      let p = d, v = d, A = s[v];
      for (; !A.endContour; ) A = s[++v];
      for (; d <= v && !u[d]; ) d++;
      if (d > v) continue;
      let x = d, g = d;
      for (d++; d <= v; )
        u[d] && (this.deltaInterpolate(g + 1, d - 1, g, d, c, s), g = d), d++;
      g === x ? this.deltaShift(p, v, g, c, s) : (this.deltaInterpolate(g + 1, v, g, x, c, s), x > 0 && this.deltaInterpolate(p, x - 1, g, x, c, s)), d = v + 1;
    }
  }
  deltaInterpolate(s, c, u, d, p, v) {
    if (s > c) return;
    let A = [
      "x",
      "y"
    ];
    for (let g = 0; g < A.length; g++) {
      let b = A[g];
      if (p[u][b] > p[d][b]) {
        var x = u;
        u = d, d = x;
      }
      let y = p[u][b], f = p[d][b], m = v[u][b], C = v[d][b];
      if (y !== f || m === C) {
        let w = y === f ? 0 : (C - m) / (f - y);
        for (let S = s; S <= c; S++) {
          let $ = p[S][b];
          $ <= y ? $ += m - y : $ >= f ? $ += C - f : $ = m + ($ - y) * w, v[S][b] = $;
        }
      }
    }
  }
  deltaShift(s, c, u, d, p) {
    let v = p[u].x - d[u].x, A = p[u].y - d[u].y;
    if (!(v === 0 && A === 0))
      for (let x = s; x <= c; x++) x !== u && (p[x].x += v, p[x].y += A);
  }
  getAdvanceAdjustment(s, c) {
    let u, d;
    if (c.advanceWidthMapping) {
      let p = s;
      p >= c.advanceWidthMapping.mapCount && (p = c.advanceWidthMapping.mapCount - 1), c.advanceWidthMapping.entryFormat, { outerIndex: u, innerIndex: d } = c.advanceWidthMapping.mapData[p];
    } else
      u = 0, d = s;
    return this.getDelta(c.itemVariationStore, u, d);
  }
  // See pseudo code from `Font Variations Overview'
  // in the OpenType specification.
  getDelta(s, c, u) {
    if (c >= s.itemVariationData.length) return 0;
    let d = s.itemVariationData[c];
    if (u >= d.deltaSets.length) return 0;
    let p = d.deltaSets[u], v = this.getBlendVector(s, c), A = 0;
    for (let x = 0; x < d.regionIndexCount; x++) A += p.deltas[x] * v[x];
    return A;
  }
  getBlendVector(s, c) {
    let u = s.itemVariationData[c];
    if (this.blendVectors.has(u)) return this.blendVectors.get(u);
    let d = this.normalizedCoords, p = [];
    for (let v = 0; v < u.regionIndexCount; v++) {
      let A = 1, x = u.regionIndexes[v], g = s.variationRegionList.variationRegions[x];
      for (let b = 0; b < g.length; b++) {
        let y = g[b], f;
        y.startCoord > y.peakCoord || y.peakCoord > y.endCoord || y.startCoord < 0 && y.endCoord > 0 && y.peakCoord !== 0 || y.peakCoord === 0 ? f = 1 : d[b] < y.startCoord || d[b] > y.endCoord ? f = 0 : d[b] === y.peakCoord ? f = 1 : d[b] < y.peakCoord ? f = (d[b] - y.startCoord + Number.EPSILON) / (y.peakCoord - y.startCoord + Number.EPSILON) : f = (y.endCoord - d[b] + Number.EPSILON) / (y.endCoord - y.peakCoord + Number.EPSILON), A *= f;
      }
      p[v] = A;
    }
    return this.blendVectors.set(u, p), p;
  }
  constructor(s, c) {
    this.font = s, this.normalizedCoords = this.normalizeCoords(c), this.blendVectors = /* @__PURE__ */ new Map();
  }
}
Promise.resolve();
class $5cc7476da92df375$export$2e2bcd8739ae039 {
  includeGlyph(s) {
    return typeof s == "object" && (s = s.id), this.mapping[s] == null && (this.glyphs.push(s), this.mapping[s] = this.glyphs.length - 1), this.mapping[s];
  }
  constructor(s) {
    this.font = s, this.glyphs = [], this.mapping = {}, this.includeGlyph(0);
  }
}
const $807e58506be70005$var$ON_CURVE = 1, $807e58506be70005$var$X_SHORT_VECTOR = 2, $807e58506be70005$var$Y_SHORT_VECTOR = 4, $807e58506be70005$var$REPEAT = 8, $807e58506be70005$var$SAME_X = 16, $807e58506be70005$var$SAME_Y = 32;
class $807e58506be70005$var$Point {
  static size(s) {
    return s >= 0 && s <= 255 ? 1 : 2;
  }
  static encode(s, c) {
    c >= 0 && c <= 255 ? s.writeUInt8(c) : s.writeInt16BE(c);
  }
}
let $807e58506be70005$var$Glyf = new Struct({
  numberOfContours: int16,
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16,
  endPtsOfContours: new ArrayT(uint16, "numberOfContours"),
  instructions: new ArrayT(uint8, uint16),
  flags: new ArrayT(uint8, 0),
  xPoints: new ArrayT($807e58506be70005$var$Point, 0),
  yPoints: new ArrayT($807e58506be70005$var$Point, 0)
});
class $807e58506be70005$export$2e2bcd8739ae039 {
  encodeSimple(s, c = []) {
    let u = [], d = [], p = [], v = [], A = 0, x = 0, g = 0, b = 0, y = 0;
    for (let $ = 0; $ < s.commands.length; $++) {
      let T = s.commands[$];
      for (let I = 0; I < T.args.length; I += 2) {
        let _ = T.args[I], E = T.args[I + 1], R = 0;
        if (T.command === "quadraticCurveTo" && I === 2) {
          let O = s.commands[$ + 1];
          if (O && O.command === "quadraticCurveTo") {
            let L = (x + O.args[0]) / 2, B = (g + O.args[1]) / 2;
            if (_ === L && E === B) continue;
          }
        }
        T.command === "quadraticCurveTo" && I === 0 || (R |= $807e58506be70005$var$ON_CURVE), R = this._encodePoint(_, x, d, R, $807e58506be70005$var$X_SHORT_VECTOR, $807e58506be70005$var$SAME_X), R = this._encodePoint(E, g, p, R, $807e58506be70005$var$Y_SHORT_VECTOR, $807e58506be70005$var$SAME_Y), R === b && A < 255 ? (v[v.length - 1] |= $807e58506be70005$var$REPEAT, A++) : (A > 0 && (v.push(A), A = 0), v.push(R), b = R), x = _, g = E, y++;
      }
      T.command === "closePath" && u.push(y - 1);
    }
    s.commands.length > 1 && s.commands[s.commands.length - 1].command !== "closePath" && u.push(y - 1);
    let f = s.bbox, m = {
      numberOfContours: u.length,
      xMin: f.minX,
      yMin: f.minY,
      xMax: f.maxX,
      yMax: f.maxY,
      endPtsOfContours: u,
      instructions: c,
      flags: v,
      xPoints: d,
      yPoints: p
    }, C = $807e58506be70005$var$Glyf.size(m), w = 4 - C % 4, S = new EncodeStream(C + w);
    return $807e58506be70005$var$Glyf.encode(S, m), w !== 0 && S.fill(0, w), S.buffer;
  }
  _encodePoint(s, c, u, d, p, v) {
    let A = s - c;
    return s === c ? d |= v : (-255 <= A && A <= 255 && (d |= p, A < 0 ? A = -A : d |= v), u.push(A)), d;
  }
}
class $4abbb6a5dbdc441a$export$2e2bcd8739ae039 extends $5cc7476da92df375$export$2e2bcd8739ae039 {
  _addGlyph(s) {
    let c = this.font.getGlyph(s), u = c._decode(), d = this.font.loca.offsets[s], p = this.font.loca.offsets[s + 1], v = this.font._getTableStream("glyf");
    v.pos += d;
    let A = v.readBuffer(p - d);
    if (u && u.numberOfContours < 0) {
      A = new Uint8Array(A);
      let x = new DataView(A.buffer);
      for (let g of u.components)
        s = this.includeGlyph(g.glyphID), x.setUint16(g.pos, s);
    } else u && this.font._variationProcessor && (A = this.glyphEncoder.encodeSimple(c.path, u.instructions));
    return this.glyf.push(A), this.loca.offsets.push(this.offset), this.hmtx.metrics.push({
      advance: c.advanceWidth,
      bearing: c._getMetrics().leftBearing
    }), this.offset += A.length, this.glyf.length - 1;
  }
  encode() {
    this.glyf = [], this.offset = 0, this.loca = {
      offsets: [],
      version: this.font.loca.version
    }, this.hmtx = {
      metrics: [],
      bearings: []
    };
    let s = 0;
    for (; s < this.glyphs.length; ) this._addGlyph(this.glyphs[s++]);
    let c = $6uUbQ$clone(this.font.maxp);
    c.numGlyphs = this.glyf.length, this.loca.offsets.push(this.offset);
    let u = $6uUbQ$clone(this.font.head);
    u.indexToLocFormat = this.loca.version;
    let d = $6uUbQ$clone(this.font.hhea);
    return d.numberOfMetrics = this.hmtx.metrics.length, $816c07a04b6dba87$export$2e2bcd8739ae039.toBuffer({
      tables: {
        head: u,
        hhea: d,
        loca: this.loca,
        maxp: c,
        "cvt ": this.font["cvt "],
        prep: this.font.prep,
        glyf: this.glyf,
        hmtx: this.hmtx,
        fpgm: this.font.fpgm
      }
    });
  }
  constructor(s) {
    super(s), this.glyphEncoder = new $807e58506be70005$export$2e2bcd8739ae039();
  }
}
class $001d739428a71d5a$export$2e2bcd8739ae039 extends $5cc7476da92df375$export$2e2bcd8739ae039 {
  subsetCharstrings() {
    this.charstrings = [];
    let s = {};
    for (let c of this.glyphs) {
      this.charstrings.push(this.cff.getCharString(c));
      let u = this.font.getGlyph(c);
      u.path;
      for (let d in u._usedGsubrs) s[d] = !0;
    }
    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, s);
  }
  subsetSubrs(s, c) {
    let u = [];
    for (let d = 0; d < s.length; d++) {
      let p = s[d];
      c[d] ? (this.cff.stream.pos = p.offset, u.push(this.cff.stream.readBuffer(p.length))) : u.push(new Uint8Array([
        11
      ]));
    }
    return u;
  }
  subsetFontdict(s) {
    s.FDArray = [], s.FDSelect = {
      version: 0,
      fds: []
    };
    let c = {}, u = [], d = {};
    for (let p of this.glyphs) {
      let v = this.cff.fdForGlyph(p);
      if (v == null) continue;
      c[v] || (s.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[v])), u.push({}), d[v] = s.FDArray.length - 1), c[v] = !0, s.FDSelect.fds.push(d[v]);
      let A = this.font.getGlyph(p);
      A.path;
      for (let x in A._usedSubrs) u[d[v]][x] = !0;
    }
    for (let p = 0; p < s.FDArray.length; p++) {
      let v = s.FDArray[p];
      delete v.FontName, v.Private && v.Private.Subrs && (v.Private = Object.assign({}, v.Private), v.Private.Subrs = this.subsetSubrs(v.Private.Subrs, u[p]));
    }
  }
  createCIDFontdict(s) {
    let c = {};
    for (let d of this.glyphs) {
      let p = this.font.getGlyph(d);
      p.path;
      for (let v in p._usedSubrs) c[v] = !0;
    }
    let u = Object.assign({}, this.cff.topDict.Private);
    return this.cff.topDict.Private && this.cff.topDict.Private.Subrs && (u.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, c)), s.FDArray = [
      {
        Private: u
      }
    ], s.FDSelect = {
      version: 3,
      nRanges: 1,
      ranges: [
        {
          first: 0,
          fd: 0
        }
      ],
      sentinel: this.charstrings.length
    };
  }
  addString(s) {
    return s ? (this.strings || (this.strings = []), this.strings.push(s), $229224aec43783c5$export$2e2bcd8739ae039.length + this.strings.length - 1) : null;
  }
  encode() {
    this.subsetCharstrings();
    let s = {
      version: this.charstrings.length > 255 ? 2 : 1,
      ranges: [
        {
          first: 1,
          nLeft: this.charstrings.length - 2
        }
      ]
    }, c = Object.assign({}, this.cff.topDict);
    c.Private = null, c.charset = s, c.Encoding = null, c.CharStrings = this.charstrings;
    for (let d of [
      "version",
      "Notice",
      "Copyright",
      "FullName",
      "FamilyName",
      "Weight",
      "PostScript",
      "BaseFontName",
      "FontName"
    ]) c[d] = this.addString(this.cff.string(c[d]));
    c.ROS = [
      this.addString("Adobe"),
      this.addString("Identity"),
      0
    ], c.CIDCount = this.charstrings.length, this.cff.isCIDFont ? this.subsetFontdict(c) : this.createCIDFontdict(c);
    let u = {
      version: 1,
      hdrSize: this.cff.hdrSize,
      offSize: 4,
      header: this.cff.header,
      nameIndex: [
        this.cff.postscriptName
      ],
      topDictIndex: [
        c
      ],
      stringIndex: this.strings,
      globalSubrIndex: this.gsubrs
    };
    return $b84fd3dd9d8eddb2$export$2e2bcd8739ae039.toBuffer(u);
  }
  constructor(s) {
    if (super(s), this.cff = this.font["CFF "], !this.cff) throw new Error("Not a CFF Font");
  }
}
class $4c1709dee528ea76$export$2e2bcd8739ae039 {
  static probe(s) {
    let c = $12727730ddfc8bfe$export$3d28c1996ced1f14.decode(s.slice(0, 4));
    return c === "true" || c === "OTTO" || c === "\0\0\0";
  }
  setDefaultLanguage(s = null) {
    this.defaultLanguage = s;
  }
  _getTable(s) {
    if (!(s.tag in this._tables)) try {
      this._tables[s.tag] = this._decodeTable(s);
    } catch {
    }
    return this._tables[s.tag];
  }
  _getTableStream(s) {
    let c = this.directory.tables[s];
    return c ? (this.stream.pos = c.offset, this.stream) : null;
  }
  _decodeDirectory() {
    return this.directory = $816c07a04b6dba87$export$2e2bcd8739ae039.decode(this.stream, {
      _startOffset: 0
    });
  }
  _decodeTable(s) {
    let c = this.stream.pos, u = this._getTableStream(s.tag), d = $c3395722bea751e2$export$2e2bcd8739ae039[s.tag].decode(u, this, s.length);
    return this.stream.pos = c, d;
  }
  /**
  * Gets a string from the font's `name` table
  * `lang` is a BCP-47 language code.
  * @return {string}
  */
  getName(s, c = this.defaultLanguage || $d636bc798e7178db$export$42940898df819940) {
    let u = this.name && this.name.records[s];
    return u && (u[c] || u[this.defaultLanguage] || u[$d636bc798e7178db$export$42940898df819940] || u.en || u[Object.keys(u)[0]]) || null;
  }
  /**
  * The unique PostScript name for this font, e.g. "Helvetica-Bold"
  * @type {string}
  */
  get postscriptName() {
    return this.getName("postscriptName");
  }
  /**
  * The font's full name, e.g. "Helvetica Bold"
  * @type {string}
  */
  get fullName() {
    return this.getName("fullName");
  }
  /**
  * The font's family name, e.g. "Helvetica"
  * @type {string}
  */
  get familyName() {
    return this.getName("fontFamily");
  }
  /**
  * The font's sub-family, e.g. "Bold".
  * @type {string}
  */
  get subfamilyName() {
    return this.getName("fontSubfamily");
  }
  /**
  * The font's copyright information
  * @type {string}
  */
  get copyright() {
    return this.getName("copyright");
  }
  /**
  * The font's version number
  * @type {string}
  */
  get version() {
    return this.getName("version");
  }
  /**
  * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
  * @type {number}
  */
  get ascent() {
    return this.hhea.ascent;
  }
  /**
  * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
  * @type {number}
  */
  get descent() {
    return this.hhea.descent;
  }
  /**
  * The amount of space that should be included between lines
  * @type {number}
  */
  get lineGap() {
    return this.hhea.lineGap;
  }
  /**
  * The offset from the normal underline position that should be used
  * @type {number}
  */
  get underlinePosition() {
    return this.post.underlinePosition;
  }
  /**
  * The weight of the underline that should be used
  * @type {number}
  */
  get underlineThickness() {
    return this.post.underlineThickness;
  }
  /**
  * If this is an italic font, the angle the cursor should be drawn at to match the font design
  * @type {number}
  */
  get italicAngle() {
    return this.post.italicAngle;
  }
  /**
  * The height of capital letters above the baseline.
  * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
  * @type {number}
  */
  get capHeight() {
    let s = this["OS/2"];
    return s ? s.capHeight : this.ascent;
  }
  /**
  * The height of lower case letters in the font.
  * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
  * @type {number}
  */
  get xHeight() {
    let s = this["OS/2"];
    return s ? s.xHeight : 0;
  }
  /**
  * The number of glyphs in the font.
  * @type {number}
  */
  get numGlyphs() {
    return this.maxp.numGlyphs;
  }
  /**
  * The size of the font’s internal coordinate grid
  * @type {number}
  */
  get unitsPerEm() {
    return this.head.unitsPerEm;
  }
  /**
  * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
  * @type {BBox}
  */
  get bbox() {
    return Object.freeze(new $f34600ab9d7f70d8$export$2e2bcd8739ae039(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
  }
  get _cmapProcessor() {
    return new $f08dd41ef10b694c$export$2e2bcd8739ae039(this.cmap);
  }
  /**
  * An array of all of the unicode code points supported by the font.
  * @type {number[]}
  */
  get characterSet() {
    return this._cmapProcessor.getCharacterSet();
  }
  /**
  * Returns whether there is glyph in the font for the given unicode code point.
  *
  * @param {number} codePoint
  * @return {boolean}
  */
  hasGlyphForCodePoint(s) {
    return !!this._cmapProcessor.lookup(s);
  }
  /**
  * Maps a single unicode code point to a Glyph object.
  * Does not perform any advanced substitutions (there is no context to do so).
  *
  * @param {number} codePoint
  * @return {Glyph}
  */
  glyphForCodePoint(s) {
    return this.getGlyph(this._cmapProcessor.lookup(s), [
      s
    ]);
  }
  /**
  * Returns an array of Glyph objects for the given string.
  * This is only a one-to-one mapping from characters to glyphs.
  * For most uses, you should use font.layout (described below), which
  * provides a much more advanced mapping supporting AAT and OpenType shaping.
  *
  * @param {string} string
  * @return {Glyph[]}
  */
  glyphsForString(s) {
    let c = [], u = s.length, d = 0, p = -1, v = -1;
    for (; d <= u; ) {
      let A = 0, x = 0;
      if (d < u) {
        if (A = s.charCodeAt(d++), 55296 <= A && A <= 56319 && d < u) {
          let g = s.charCodeAt(d);
          56320 <= g && g <= 57343 && (d++, A = ((A & 1023) << 10) + (g & 1023) + 65536);
        }
        x = 65024 <= A && A <= 65039 || 917760 <= A && A <= 917999 ? 1 : 0;
      } else d++;
      v === 0 && x === 1 ? c.push(this.getGlyph(this._cmapProcessor.lookup(p, A), [
        p,
        A
      ])) : v === 0 && x === 0 && c.push(this.glyphForCodePoint(p)), p = A, v = x;
    }
    return c;
  }
  get _layoutEngine() {
    return new $4c0a7fa5df7a9ab1$export$2e2bcd8739ae039(this);
  }
  /**
  * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
  *
  * @param {string} string
  * @param {string[]} [userFeatures]
  * @param {string} [script]
  * @param {string} [language]
  * @param {string} [direction]
  * @return {GlyphRun}
  */
  layout(s, c, u, d, p) {
    return this._layoutEngine.layout(s, c, u, d, p);
  }
  /**
  * Returns an array of strings that map to the given glyph id.
  * @param {number} gid - glyph id
  */
  stringsForGlyph(s) {
    return this._layoutEngine.stringsForGlyph(s);
  }
  /**
  * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
  * (or mapped AAT tags) supported by the font.
  * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
  * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
  *
  * @type {string[]}
  */
  get availableFeatures() {
    return this._layoutEngine.getAvailableFeatures();
  }
  getAvailableFeatures(s, c) {
    return this._layoutEngine.getAvailableFeatures(s, c);
  }
  _getBaseGlyph(s, c = []) {
    return this._glyphs[s] || (this.directory.tables.glyf ? this._glyphs[s] = new $69aac16029968692$export$2e2bcd8739ae039(s, c, this) : (this.directory.tables["CFF "] || this.directory.tables.CFF2) && (this._glyphs[s] = new $62cc5109c6101893$export$2e2bcd8739ae039(s, c, this))), this._glyphs[s] || null;
  }
  /**
  * Returns a glyph object for the given glyph id.
  * You can pass the array of code points this glyph represents for
  * your use later, and it will be stored in the glyph object.
  *
  * @param {number} glyph
  * @param {number[]} characters
  * @return {Glyph}
  */
  getGlyph(s, c = []) {
    return this._glyphs[s] || (this.directory.tables.sbix ? this._glyphs[s] = new $25d8f049c222084c$export$2e2bcd8739ae039(s, c, this) : this.directory.tables.COLR && this.directory.tables.CPAL ? this._glyphs[s] = new $0d411f0165859681$export$2e2bcd8739ae039(s, c, this) : this._getBaseGlyph(s, c)), this._glyphs[s] || null;
  }
  /**
  * Returns a Subset for this font.
  * @return {Subset}
  */
  createSubset() {
    return this.directory.tables["CFF "] ? new $001d739428a71d5a$export$2e2bcd8739ae039(this) : new $4abbb6a5dbdc441a$export$2e2bcd8739ae039(this);
  }
  /**
  * Returns an object describing the available variation axes
  * that this font supports. Keys are setting tags, and values
  * contain the axis name, range, and default value.
  *
  * @type {object}
  */
  get variationAxes() {
    let s = {};
    if (!this.fvar) return s;
    for (let c of this.fvar.axis) s[c.axisTag.trim()] = {
      name: c.name.en,
      min: c.minValue,
      default: c.defaultValue,
      max: c.maxValue
    };
    return s;
  }
  /**
  * Returns an object describing the named variation instances
  * that the font designer has specified. Keys are variation names
  * and values are the variation settings for this instance.
  *
  * @type {object}
  */
  get namedVariations() {
    let s = {};
    if (!this.fvar) return s;
    for (let c of this.fvar.instance) {
      let u = {};
      for (let d = 0; d < this.fvar.axis.length; d++) {
        let p = this.fvar.axis[d];
        u[p.axisTag.trim()] = c.coord[d];
      }
      s[c.name.en] = u;
    }
    return s;
  }
  /**
  * Returns a new font with the given variation settings applied.
  * Settings can either be an instance name, or an object containing
  * variation tags as specified by the `variationAxes` property.
  *
  * @param {object} settings
  * @return {TTFFont}
  */
  getVariation(s) {
    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
    if (typeof s == "string" && (s = this.namedVariations[s]), typeof s != "object") throw new Error("Variation settings must be either a variation name or settings object.");
    let c = this.fvar.axis.map((p, v) => {
      let A = p.axisTag.trim();
      return A in s ? Math.max(p.minValue, Math.min(p.maxValue, s[A])) : p.defaultValue;
    }), u = new DecodeStream(this.stream.buffer);
    u.pos = this._directoryPos;
    let d = new $4c1709dee528ea76$export$2e2bcd8739ae039(u, c);
    return d._tables = this._tables, d;
  }
  get _variationProcessor() {
    if (!this.fvar) return null;
    let s = this.variationCoords;
    return !s && !this.CFF2 ? null : (s || (s = this.fvar.axis.map((c) => c.defaultValue)), new $0bb840cac04e911b$export$2e2bcd8739ae039(this, s));
  }
  // Standardized format plugin API
  getFont(s) {
    return this.getVariation(s);
  }
  constructor(s, c = null) {
    _define_property(this, "type", "TTF"), this.defaultLanguage = null, this.stream = s, this.variationCoords = c, this._directoryPos = this.stream.pos, this._tables = {}, this._glyphs = {}, this._decodeDirectory();
    for (let u in this.directory.tables) {
      let d = this.directory.tables[u];
      $c3395722bea751e2$export$2e2bcd8739ae039[u] && d.length > 0 && Object.defineProperty(this, u, {
        get: this._getTable.bind(this, d)
      });
    }
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "bbox", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_cmapProcessor", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "characterSet", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_layoutEngine", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "variationAxes", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "namedVariations", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_variationProcessor", null);
let $c1726355ecc5b889$var$WOFFDirectoryEntry = new Struct({
  tag: new StringT(4),
  offset: new Pointer(uint32, "void", {
    type: "global"
  }),
  compLength: uint32,
  length: uint32,
  origChecksum: uint32
}), $c1726355ecc5b889$var$WOFFDirectory = new Struct({
  tag: new StringT(4),
  flavor: uint32,
  length: uint32,
  numTables: uint16,
  reserved: new Reserved(uint16),
  totalSfntSize: uint32,
  majorVersion: uint16,
  minorVersion: uint16,
  metaOffset: uint32,
  metaLength: uint32,
  metaOrigLength: uint32,
  privOffset: uint32,
  privLength: uint32,
  tables: new ArrayT($c1726355ecc5b889$var$WOFFDirectoryEntry, "numTables")
});
$c1726355ecc5b889$var$WOFFDirectory.process = function() {
  let a = {};
  for (let s of this.tables) a[s.tag] = s;
  this.tables = a;
};
var $c1726355ecc5b889$export$2e2bcd8739ae039 = $c1726355ecc5b889$var$WOFFDirectory;
class $760785214b9fc52c$export$2e2bcd8739ae039 extends $4c1709dee528ea76$export$2e2bcd8739ae039 {
  static probe(s) {
    return $12727730ddfc8bfe$export$3d28c1996ced1f14.decode(s.slice(0, 4)) === "wOFF";
  }
  _decodeDirectory() {
    this.directory = $c1726355ecc5b889$export$2e2bcd8739ae039.decode(this.stream, {
      _startOffset: 0
    });
  }
  _getTableStream(s) {
    let c = this.directory.tables[s];
    if (c)
      if (this.stream.pos = c.offset, c.compLength < c.length) {
        this.stream.pos += 2;
        let u = new Uint8Array(c.length), d = $6uUbQ$tinyinflate(this.stream.readBuffer(c.compLength - 2), u);
        return new DecodeStream(d);
      } else return this.stream;
    return null;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "WOFF");
  }
}
class $8046190c9f1ad19e$export$2e2bcd8739ae039 extends $69aac16029968692$export$2e2bcd8739ae039 {
  _decode() {
    return this._font._transformedGlyphs[this.id];
  }
  _getCBox() {
    return this.path.bbox;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "WOFF2");
  }
}
const $c28ec7bbb3b8de3a$var$Base128 = {
  decode(a) {
    let s = 0, c = [
      0,
      1,
      2,
      3,
      4
    ];
    for (let u = 0; u < c.length; u++) {
      let d = a.readUInt8();
      if (s & 3758096384) throw new Error("Overflow");
      if (s = s << 7 | d & 127, (d & 128) === 0) return s;
    }
    throw new Error("Bad base 128 number");
  }
};
let $c28ec7bbb3b8de3a$var$knownTags = [
  "cmap",
  "head",
  "hhea",
  "hmtx",
  "maxp",
  "name",
  "OS/2",
  "post",
  "cvt ",
  "fpgm",
  "glyf",
  "loca",
  "prep",
  "CFF ",
  "VORG",
  "EBDT",
  "EBLC",
  "gasp",
  "hdmx",
  "kern",
  "LTSH",
  "PCLT",
  "VDMX",
  "vhea",
  "vmtx",
  "BASE",
  "GDEF",
  "GPOS",
  "GSUB",
  "EBSC",
  "JSTF",
  "MATH",
  "CBDT",
  "CBLC",
  "COLR",
  "CPAL",
  "SVG ",
  "sbix",
  "acnt",
  "avar",
  "bdat",
  "bloc",
  "bsln",
  "cvar",
  "fdsc",
  "feat",
  "fmtx",
  "fvar",
  "gvar",
  "hsty",
  "just",
  "lcar",
  "mort",
  "morx",
  "opbd",
  "prop",
  "trak",
  "Zapf",
  "Silf",
  "Glat",
  "Gloc",
  "Feat",
  "Sill"
], $c28ec7bbb3b8de3a$var$WOFF2DirectoryEntry = new Struct({
  flags: uint8,
  customTag: new Optional(new StringT(4), (a) => (a.flags & 63) === 63),
  tag: (a) => a.customTag || $c28ec7bbb3b8de3a$var$knownTags[a.flags & 63],
  length: $c28ec7bbb3b8de3a$var$Base128,
  transformVersion: (a) => a.flags >>> 6 & 3,
  transformed: (a) => a.tag === "glyf" || a.tag === "loca" ? a.transformVersion === 0 : a.transformVersion !== 0,
  transformLength: new Optional($c28ec7bbb3b8de3a$var$Base128, (a) => a.transformed)
}), $c28ec7bbb3b8de3a$var$WOFF2Directory = new Struct({
  tag: new StringT(4),
  flavor: uint32,
  length: uint32,
  numTables: uint16,
  reserved: new Reserved(uint16),
  totalSfntSize: uint32,
  totalCompressedSize: uint32,
  majorVersion: uint16,
  minorVersion: uint16,
  metaOffset: uint32,
  metaLength: uint32,
  metaOrigLength: uint32,
  privOffset: uint32,
  privLength: uint32,
  tables: new ArrayT($c28ec7bbb3b8de3a$var$WOFF2DirectoryEntry, "numTables")
});
$c28ec7bbb3b8de3a$var$WOFF2Directory.process = function() {
  let a = {};
  for (let s = 0; s < this.tables.length; s++) {
    let c = this.tables[s];
    a[c.tag] = c;
  }
  return this.tables = a;
};
var $c28ec7bbb3b8de3a$export$2e2bcd8739ae039 = $c28ec7bbb3b8de3a$var$WOFF2Directory;
class $21ee218f84ac7f32$export$2e2bcd8739ae039 extends $4c1709dee528ea76$export$2e2bcd8739ae039 {
  static probe(s) {
    return $12727730ddfc8bfe$export$3d28c1996ced1f14.decode(s.slice(0, 4)) === "wOF2";
  }
  _decodeDirectory() {
    this.directory = $c28ec7bbb3b8de3a$export$2e2bcd8739ae039.decode(this.stream), this._dataPos = this.stream.pos;
  }
  _decompress() {
    if (!this._decompressed) {
      this.stream.pos = this._dataPos;
      let s = this.stream.readBuffer(this.directory.totalCompressedSize), c = 0;
      for (let d in this.directory.tables) {
        let p = this.directory.tables[d];
        p.offset = c, c += p.transformLength != null ? p.transformLength : p.length;
      }
      let u = $6uUbQ$brotlidecompressjs(s, c);
      if (!u) throw new Error("Error decoding compressed data in WOFF2");
      this.stream = new DecodeStream(u), this._decompressed = !0;
    }
  }
  _decodeTable(s) {
    return this._decompress(), super._decodeTable(s);
  }
  // Override this method to get a glyph and return our
  // custom subclass if there is a glyf table.
  _getBaseGlyph(s, c = []) {
    if (!this._glyphs[s])
      return this.directory.tables.glyf && this.directory.tables.glyf.transformed ? (this._transformedGlyphs || this._transformGlyfTable(), this._glyphs[s] = new $8046190c9f1ad19e$export$2e2bcd8739ae039(s, c, this)) : super._getBaseGlyph(s, c);
  }
  _transformGlyfTable() {
    this._decompress(), this.stream.pos = this.directory.tables.glyf.offset;
    let s = $21ee218f84ac7f32$var$GlyfTable.decode(this.stream), c = [];
    for (let d = 0; d < s.numGlyphs; d++) {
      let p = {}, v = s.nContours.readInt16BE();
      if (p.numberOfContours = v, v > 0) {
        let A = [], x = 0;
        for (let g = 0; g < v; g++) {
          let b = $21ee218f84ac7f32$var$read255UInt16(s.nPoints);
          x += b, A.push(x);
        }
        p.points = $21ee218f84ac7f32$var$decodeTriplet(s.flags, s.glyphs, x);
        for (let g = 0; g < v; g++) p.points[A[g] - 1].endContour = !0;
        var u = $21ee218f84ac7f32$var$read255UInt16(s.glyphs);
      } else if (v < 0 && $69aac16029968692$export$2e2bcd8739ae039.prototype._decodeComposite.call({
        _font: this
      }, p, s.composites))
        var u = $21ee218f84ac7f32$var$read255UInt16(s.glyphs);
      c.push(p);
    }
    this._transformedGlyphs = c;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "WOFF2");
  }
}
class $21ee218f84ac7f32$var$Substream {
  decode(s, c) {
    return new DecodeStream(this._buf.decode(s, c));
  }
  constructor(s) {
    this.length = s, this._buf = new BufferT(s);
  }
}
let $21ee218f84ac7f32$var$GlyfTable = new Struct({
  version: uint32,
  numGlyphs: uint16,
  indexFormat: uint16,
  nContourStreamSize: uint32,
  nPointsStreamSize: uint32,
  flagStreamSize: uint32,
  glyphStreamSize: uint32,
  compositeStreamSize: uint32,
  bboxStreamSize: uint32,
  instructionStreamSize: uint32,
  nContours: new $21ee218f84ac7f32$var$Substream("nContourStreamSize"),
  nPoints: new $21ee218f84ac7f32$var$Substream("nPointsStreamSize"),
  flags: new $21ee218f84ac7f32$var$Substream("flagStreamSize"),
  glyphs: new $21ee218f84ac7f32$var$Substream("glyphStreamSize"),
  composites: new $21ee218f84ac7f32$var$Substream("compositeStreamSize"),
  bboxes: new $21ee218f84ac7f32$var$Substream("bboxStreamSize"),
  instructions: new $21ee218f84ac7f32$var$Substream("instructionStreamSize")
});
const $21ee218f84ac7f32$var$WORD_CODE = 253, $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE2 = 254, $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE1 = 255, $21ee218f84ac7f32$var$LOWEST_U_CODE = 253;
function $21ee218f84ac7f32$var$read255UInt16(a) {
  let s = a.readUInt8();
  return s === $21ee218f84ac7f32$var$WORD_CODE ? a.readUInt16BE() : s === $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE1 ? a.readUInt8() + $21ee218f84ac7f32$var$LOWEST_U_CODE : s === $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE2 ? a.readUInt8() + $21ee218f84ac7f32$var$LOWEST_U_CODE * 2 : s;
}
function $21ee218f84ac7f32$var$withSign(a, s) {
  return a & 1 ? s : -s;
}
function $21ee218f84ac7f32$var$decodeTriplet(a, s, c) {
  let u, d = u = 0, p = [];
  for (let x = 0; x < c; x++) {
    let g = 0, b = 0, y = a.readUInt8(), f = !(y >> 7);
    if (y &= 127, y < 10)
      g = 0, b = $21ee218f84ac7f32$var$withSign(y, ((y & 14) << 7) + s.readUInt8());
    else if (y < 20)
      g = $21ee218f84ac7f32$var$withSign(y, ((y - 10 & 14) << 7) + s.readUInt8()), b = 0;
    else if (y < 84) {
      var v = y - 20, A = s.readUInt8();
      g = $21ee218f84ac7f32$var$withSign(y, 1 + (v & 48) + (A >> 4)), b = $21ee218f84ac7f32$var$withSign(y >> 1, 1 + ((v & 12) << 2) + (A & 15));
    } else if (y < 120) {
      var v = y - 84;
      g = $21ee218f84ac7f32$var$withSign(y, 1 + (v / 12 << 8) + s.readUInt8()), b = $21ee218f84ac7f32$var$withSign(y >> 1, 1 + (v % 12 >> 2 << 8) + s.readUInt8());
    } else if (y < 124) {
      var A = s.readUInt8();
      let C = s.readUInt8();
      g = $21ee218f84ac7f32$var$withSign(y, (A << 4) + (C >> 4)), b = $21ee218f84ac7f32$var$withSign(y >> 1, ((C & 15) << 8) + s.readUInt8());
    } else
      g = $21ee218f84ac7f32$var$withSign(y, s.readUInt16BE()), b = $21ee218f84ac7f32$var$withSign(y >> 1, s.readUInt16BE());
    d += g, u += b, p.push(new $69aac16029968692$export$baf26146a414f24a(f, !1, d, u));
  }
  return p;
}
let $cd5853a56c68fec7$var$TTCHeader = new VersionedStruct(uint32, {
  65536: {
    numFonts: uint32,
    offsets: new ArrayT(uint32, "numFonts")
  },
  131072: {
    numFonts: uint32,
    offsets: new ArrayT(uint32, "numFonts"),
    dsigTag: uint32,
    dsigLength: uint32,
    dsigOffset: uint32
  }
});
class $cd5853a56c68fec7$export$2e2bcd8739ae039 {
  static probe(s) {
    return $12727730ddfc8bfe$export$3d28c1996ced1f14.decode(s.slice(0, 4)) === "ttcf";
  }
  getFont(s) {
    for (let c of this.header.offsets) {
      let u = new DecodeStream(this.stream.buffer);
      u.pos = c;
      let d = new $4c1709dee528ea76$export$2e2bcd8739ae039(u);
      if (d.postscriptName === s || d.postscriptName instanceof Uint8Array && s instanceof Uint8Array && d.postscriptName.every((p, v) => s[v] === p)) return d;
    }
    return null;
  }
  get fonts() {
    let s = [];
    for (let c of this.header.offsets) {
      let u = new DecodeStream(this.stream.buffer);
      u.pos = c, s.push(new $4c1709dee528ea76$export$2e2bcd8739ae039(u));
    }
    return s;
  }
  constructor(s) {
    if (_define_property(this, "type", "TTC"), this.stream = s, s.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
    this.header = $cd5853a56c68fec7$var$TTCHeader.decode(s);
  }
}
let $05f49f930186144e$var$DFontName = new StringT(uint8);
new Struct({
  len: uint32,
  buf: new BufferT("len")
});
let $05f49f930186144e$var$Ref = new Struct({
  id: uint16,
  nameOffset: int16,
  attr: uint8,
  dataOffset: uint24,
  handle: uint32
}), $05f49f930186144e$var$Type = new Struct({
  name: new StringT(4),
  maxTypeIndex: uint16,
  refList: new Pointer(uint16, new ArrayT($05f49f930186144e$var$Ref, (a) => a.maxTypeIndex + 1), {
    type: "parent"
  })
}), $05f49f930186144e$var$TypeList = new Struct({
  length: uint16,
  types: new ArrayT($05f49f930186144e$var$Type, (a) => a.length + 1)
}), $05f49f930186144e$var$DFontMap = new Struct({
  reserved: new Reserved(uint8, 24),
  typeList: new Pointer(uint16, $05f49f930186144e$var$TypeList),
  nameListOffset: new Pointer(uint16, "void")
}), $05f49f930186144e$var$DFontHeader = new Struct({
  dataOffset: uint32,
  map: new Pointer(uint32, $05f49f930186144e$var$DFontMap),
  dataLength: uint32,
  mapLength: uint32
});
class $05f49f930186144e$export$2e2bcd8739ae039 {
  static probe(s) {
    let c = new DecodeStream(s);
    try {
      var u = $05f49f930186144e$var$DFontHeader.decode(c);
    } catch {
      return !1;
    }
    for (let d of u.map.typeList.types)
      if (d.name === "sfnt") return !0;
    return !1;
  }
  getFont(s) {
    if (!this.sfnt) return null;
    for (let c of this.sfnt.refList) {
      let u = this.header.dataOffset + c.dataOffset + 4, d = new DecodeStream(this.stream.buffer.slice(u)), p = new $4c1709dee528ea76$export$2e2bcd8739ae039(d);
      if (p.postscriptName === s || p.postscriptName instanceof Uint8Array && s instanceof Uint8Array && p.postscriptName.every((v, A) => s[A] === v)) return p;
    }
    return null;
  }
  get fonts() {
    let s = [];
    for (let c of this.sfnt.refList) {
      let u = this.header.dataOffset + c.dataOffset + 4, d = new DecodeStream(this.stream.buffer.slice(u));
      s.push(new $4c1709dee528ea76$export$2e2bcd8739ae039(d));
    }
    return s;
  }
  constructor(s) {
    _define_property(this, "type", "DFont"), this.stream = s, this.header = $05f49f930186144e$var$DFontHeader.decode(this.stream);
    for (let c of this.header.map.typeList.types) {
      for (let u of c.refList) u.nameOffset >= 0 ? (this.stream.pos = u.nameOffset + this.header.map.nameListOffset, u.name = $05f49f930186144e$var$DFontName.decode(this.stream)) : u.name = null;
      c.name === "sfnt" && (this.sfnt = c);
    }
  }
}
$d636bc798e7178db$export$36b2f24e97d43be($4c1709dee528ea76$export$2e2bcd8739ae039);
$d636bc798e7178db$export$36b2f24e97d43be($760785214b9fc52c$export$2e2bcd8739ae039);
$d636bc798e7178db$export$36b2f24e97d43be($21ee218f84ac7f32$export$2e2bcd8739ae039);
$d636bc798e7178db$export$36b2f24e97d43be($cd5853a56c68fec7$export$2e2bcd8739ae039);
$d636bc798e7178db$export$36b2f24e97d43be($05f49f930186144e$export$2e2bcd8739ae039);
const getBrowserVerticalFontAdjustments = (a, s, c, u) => {
  const { ascent: d, descent: p, unitsPerEm: v } = a, A = (d - p) / v, x = (A * s - s) / 2;
  if (u === VERTICAL_ALIGN_TOP)
    return { topAdj: pt2px(x), bottomAdj: 0 };
  let g = 0;
  return c < A && (g = (A - c) * s / 2), { topAdj: 0, bottomAdj: pt2px(g) };
}, getFontDescentInPt = (a, s) => {
  const { descent: c, unitsPerEm: u } = a;
  return c / u * s;
}, heightOfFontAtSize = (a, s) => {
  const { ascent: c, descent: u, bbox: d, unitsPerEm: p } = a, v = 1e3 / p, A = (c || d.maxY) * v, x = (u || d.minY) * v;
  let g = A - x;
  return g -= Math.abs(u * v) || 0, g / 1e3 * s;
}, calculateCharacterSpacing = (a, s) => (a.length - 1) * s, widthOfTextAtSize = (a, s, c, u) => {
  const { glyphs: d } = s.layout(a), p = 1e3 / s.unitsPerEm;
  return d.reduce((A, x) => A + x.advanceWidth * p, 0) * (c / 1e3) + calculateCharacterSpacing(a, u);
}, getFallbackFont = (a) => {
  const s = getFallbackFontName(a);
  return a[s];
}, getCacheKey = (a) => `getFontKitFont-${a}`, getFontKitFont = async (a, s, c) => {
  const u = a || getFallbackFontName(s), d = getCacheKey(u);
  if (c.has(d))
    return c.get(d);
  let v = (s[u] || getFallbackFont(s) || getDefaultFont()[DEFAULT_FONT_NAME]).data;
  typeof v == "string" && (v = v.startsWith("http") ? await fetch(v).then((g) => g.arrayBuffer()) : b64toUint8Array(v));
  let A;
  v instanceof bufferExports.Buffer ? A = v : A = bufferExports.Buffer.from(v);
  const x = $d636bc798e7178db$export$185802fd694ee1f5(A);
  return c.set(d, x), x;
}, calculateDynamicFontSize = ({ textSchema: a, fontKitFont: s, value: c, startingFontSize: u }) => {
  const { fontSize: d, dynamicFontSize: p, characterSpacing: v, width: A, height: x, lineHeight: g = DEFAULT_LINE_HEIGHT } = a, b = u || d || DEFAULT_FONT_SIZE;
  if (!p || p.max < p.min)
    return b;
  const y = v ?? DEFAULT_CHARACTER_SPACING, f = c.split(`
`);
  let m = b;
  m < p.min ? m = p.min : m > p.max && (m = p.max);
  const C = p.fit ?? DEFAULT_DYNAMIC_FIT, w = (_) => {
    let E = 0, R = 0;
    const O = mm2pt(A), L = heightOfFontAtSize(s, _), B = pt2mm(L * g), F = pt2mm(_ * g);
    return f.forEach((M, W) => {
      if (getSplittedLinesBySegmenter(M, {
        font: s,
        fontSize: _,
        characterSpacing: y,
        boxWidthInPt: O
      }).forEach((G, U) => {
        if (C === DYNAMIC_FIT_VERTICAL) {
          const k = widthOfTextAtSize(G.replace(`
`, ""), s, _, y), N = pt2mm(k);
          E = Math.max(E, N);
        }
        W + U === 0 ? R += B : R += F;
      }), C === DYNAMIC_FIT_HORIZONTAL) {
        const G = widthOfTextAtSize(M, s, _, y), U = pt2mm(G);
        E = Math.max(E, U);
      }
    }), { totalWidthInMm: E, totalHeightInMm: R };
  }, S = (_, E) => m >= p.max ? !1 : C === DYNAMIC_FIT_HORIZONTAL ? _ < A : E < x, $ = (_, E) => m <= p.min || m <= 0 ? !1 : _ > A || E > x;
  let { totalWidthInMm: T, totalHeightInMm: I } = w(m);
  for (; S(T, I); ) {
    m += FONT_SIZE_ADJUSTMENT;
    const { totalWidthInMm: _, totalHeightInMm: E } = w(m);
    if (E < x)
      T = _, I = E;
    else {
      m -= FONT_SIZE_ADJUSTMENT;
      break;
    }
  }
  for (; $(T, I); )
    m -= FONT_SIZE_ADJUSTMENT, { totalWidthInMm: T, totalHeightInMm: I } = w(m);
  return m;
}, splitTextToSize = (a) => {
  const { value: s, characterSpacing: c, fontSize: u, fontKitFont: d, boxWidthInPt: p } = a, v = {
    font: d,
    fontSize: u,
    characterSpacing: c,
    boxWidthInPt: p
  };
  let A = [];
  return s.split(/\r\n|\r|\n|\f|\u000B/g).forEach((x) => {
    A = A.concat(getSplittedLinesBySegmenter(x, v));
  }), A;
}, isFirefox = () => navigator.userAgent.toLowerCase().indexOf("firefox") > -1, getSplittedLinesBySegmenter = (a, s) => {
  if (a.trim() === "")
    return [""];
  const { font: c, fontSize: u, characterSpacing: d, boxWidthInPt: p } = s, A = new Intl.Segmenter(void 0, { granularity: "word" }).segment(a.trimEnd())[Symbol.iterator]();
  let x = [], g = 0, b = 0;
  for (; ; ) {
    const y = A.next();
    if (y.done)
      break;
    const f = y.value.segment, m = widthOfTextAtSize(f, c, u, d);
    if (b + m <= p)
      x[g] ? (x[g] += f, b += m + d) : (x[g] = f, b = m + d);
    else if (f.trim() === "")
      x[++g] = "", b = 0;
    else if (m <= p)
      x[++g] = f, b = m + d;
    else
      for (const C of f) {
        const w = widthOfTextAtSize(C, c, u, d);
        b + w <= p ? x[g] ? (x[g] += C, b += w + d) : (x[g] = C, b = w + d) : (x[++g] = C, b = w + d);
      }
  }
  return x.some(containsJapanese) ? adjustEndOfLine(filterEndJP(filterStartJP(x))) : adjustEndOfLine(x);
}, adjustEndOfLine = (a) => a.map((s, c) => c === a.length - 1 ? s.trimEnd() + `
` : s.trimEnd());
function containsJapanese(a) {
  return /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]/u.test(a);
}
const filterStartJP = (a) => {
  const s = [];
  let c = null;
  if (a.slice().reverse().forEach((u) => {
    if (u.trim().length === 0)
      s.push("");
    else {
      const d = u.charAt(0);
      LINE_START_FORBIDDEN_CHARS.includes(d) ? u.trim().length === 1 ? (s.push(u), c = null) : (c ? s.push(u.slice(1) + c) : s.push(u.slice(1)), c = d) : c ? (s.push(u + c), c = null) : s.push(u);
    }
  }), c) {
    const u = s.length > 0 ? s[0] : "";
    return [String(c) + String(u), ...s.slice(1)].reverse();
  } else
    return s.reverse();
}, filterEndJP = (a) => {
  const s = [];
  let c = null;
  if (a.forEach((u) => {
    if (u.trim().length === 0)
      s.push("");
    else {
      const d = u.slice(-1);
      LINE_END_FORBIDDEN_CHARS.includes(d) ? u.trim().length === 1 ? (s.push(u), c = null) : (c ? s.push(c + u.slice(0, -1)) : s.push(u.slice(0, -1)), c = d) : c ? (s.push(c + u), c = null) : s.push(u);
    }
  }), c) {
    const u = s.length > 0 ? s[s.length - 1] : "", d = String(u) + String(c);
    return [...s.slice(0, -1), d];
  } else
    return s;
};
let Cell$2 = class {
  constructor(s, c, u) {
    Object.defineProperty(this, "raw", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "text", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "styles", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "section", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contentHeight", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "contentWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "wrappedWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "minReadableWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "minWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "width", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "height", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "x", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "y", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), this.styles = c, this.section = u, this.raw = s;
    const d = /\r\n|\r|\n/g;
    this.text = s.split(d);
  }
  getContentHeight() {
    const s = Array.isArray(this.text) ? this.text.length : 1, c = pt2mm(this.styles.fontSize) * this.styles.lineHeight, u = this.padding("top") + this.padding("bottom"), d = s * c + u;
    return Math.max(d, this.styles.minCellHeight);
  }
  padding(s) {
    return this.styles.cellPadding[s];
  }
}, Column$2 = class {
  constructor(s) {
    Object.defineProperty(this, "index", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "wrappedWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "minReadableWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "minWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "width", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), this.index = s;
  }
  getMaxCustomCellWidth(s) {
    let c = 0;
    for (const u of s.allRows()) {
      const d = u.cells[this.index];
      c = Math.max(c, d.styles.cellWidth);
    }
    return c;
  }
}, Row$1 = class {
  constructor(s, c, u, d) {
    Object.defineProperty(this, "raw", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "index", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "section", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cells", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "height", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), this.raw = s, this.index = c, this.section = u, this.cells = d;
  }
  getMaxCellHeight(s) {
    return s.reduce((c, u) => Math.max(c, this.cells[u.index]?.height || 0), 0);
  }
  getMinimumRowHeight(s) {
    return s.reduce((c, u) => {
      const d = this.cells[u.index];
      if (!d)
        return 0;
      const v = d.padding("top") + d.padding("bottom") + d.styles.lineHeight;
      return v > c ? v : c;
    }, 0);
  }
}, Table$2 = class Wl {
  constructor(s, c) {
    Object.defineProperty(this, "settings", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "styles", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "columns", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "head", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.settings = s.settings, this.styles = s.styles, this.columns = c.columns, this.head = c.head, this.body = c.body;
  }
  static async create(s) {
    const { input: c, content: u, font: d, _cache: p } = s, v = new Wl(c, u);
    return await calculateWidths({ table: v, font: d, _cache: p }), v;
  }
  getHeadHeight() {
    return this.head.reduce((s, c) => s + c.getMaxCellHeight(this.columns), 0);
  }
  getBodyHeight() {
    return this.body.reduce((s, c) => s + c.getMaxCellHeight(this.columns), 0);
  }
  allRows() {
    return this.head.concat(this.body);
  }
  getWidth() {
    return this.settings.tableWidth;
  }
  getHeight() {
    return (this.settings.showHead ? this.getHeadHeight() : 0) + this.getBodyHeight();
  }
};
async function calculateWidths(a) {
  const { table: s, font: c, _cache: u } = a, d = (x) => getFontKitFont(x, c, u);
  await calculate$1(s, d);
  const p = [];
  let v = 0;
  s.columns.forEach((x) => {
    const g = x.getMaxCustomCellWidth(s);
    g ? x.width = g : (x.width = x.wrappedWidth, p.push(x)), v += x.width;
  });
  let A = s.getWidth() - v;
  A && (A = resizeColumns(p, A, (x) => Math.max(x.minReadableWidth, x.minWidth))), A && (A = resizeColumns(p, A, (x) => x.minWidth)), A = Math.abs(A), applyColSpans(s), await fitContent(s, d), applyRowSpans(s);
}
function applyRowSpans(a) {
  const s = {};
  let c = 1;
  const u = a.allRows();
  for (let d = 0; d < u.length; d++) {
    const p = u[d];
    for (const v of a.columns) {
      const A = s[v.index];
      if (c > 1)
        c--, delete p.cells[v.index];
      else if (A)
        A.cell.height += p.height, c = 1, delete p.cells[v.index], A.left--, A.left <= 1 && delete s[v.index];
      else {
        const x = p.cells[v.index];
        if (!x)
          continue;
        x.height = p.height;
      }
    }
  }
}
function applyColSpans(a) {
  const s = a.allRows();
  for (let c = 0; c < s.length; c++) {
    const u = s[c];
    let d = 0, p = 0;
    for (let v = 0; v < a.columns.length; v++) {
      const A = a.columns[v];
      if (p -= 1, p > 1 && a.columns[v + 1])
        d += A.width, delete u.cells[A.index];
      else {
        const x = u.cells[A.index];
        if (!x)
          continue;
        p = 1, d = 0, x.width = A.width + d;
      }
    }
  }
}
async function fitContent(a, s) {
  const c = { count: 0, height: 0 };
  for (const u of a.allRows()) {
    for (const d of a.columns) {
      const p = u.cells[d.index];
      if (!p)
        continue;
      const v = await s(p.styles.fontName);
      p.text = splitTextToSize({
        value: p.raw,
        characterSpacing: p.styles.characterSpacing,
        boxWidthInPt: mm2pt(p.width),
        fontSize: p.styles.fontSize,
        fontKitFont: v
      }), p.contentHeight = p.getContentHeight();
      let A = p.contentHeight;
      c && c.count > 0 && c.height > A && (A = c.height), A > u.height && (u.height = A);
    }
    c.count--;
  }
}
function resizeColumns(a, s, c) {
  const u = s, d = a.reduce((p, v) => p + v.wrappedWidth, 0);
  for (let p = 0; p < a.length; p++) {
    const v = a[p], A = v.wrappedWidth / d, x = u * A, g = v.width + x, b = c(v), y = g < b ? b : g;
    s -= y - v.width, v.width = y;
  }
  if (s = Math.round(s * 1e10) / 1e10, s) {
    const p = a.filter((v) => s < 0 ? v.width > c(v) : !0);
    p.length && (s = resizeColumns(p, s, c));
  }
  return s;
}
async function calculate$1(a, s) {
  for (const c of a.allRows())
    for (const u of a.columns) {
      const d = c.cells[u.index];
      if (!d)
        continue;
      const p = d.padding("right") + d.padding("left"), v = await s(d.styles.fontName);
      d.contentWidth = getStringWidth(d, v) + p;
      const A = getStringWidth(Object.assign(d, { text: d.text.join(" ").split(/\s+/) }), v);
      d.minReadableWidth = A + p, d.minWidth = d.styles.cellWidth, d.wrappedWidth = d.styles.cellWidth;
    }
  for (const c of a.allRows())
    for (const u of a.columns) {
      const d = c.cells[u.index];
      if (d)
        u.wrappedWidth = Math.max(u.wrappedWidth, d.wrappedWidth), u.minWidth = Math.max(u.minWidth, d.minWidth), u.minReadableWidth = Math.max(u.minReadableWidth, d.minReadableWidth);
      else {
        const p = a.styles.columnStyles[u.index] || {}, v = p.cellWidth || p.minCellWidth;
        v && (u.minWidth = v, u.wrappedWidth = v);
      }
    }
}
function getStringWidth(a, s) {
  const c = a.text, u = Array.isArray(c) ? c : [c], d = a.styles.fontSize, p = a.styles.characterSpacing;
  return u.map((A) => widthOfTextAtSize(A, s, d, p)).reduce((A, x) => Math.max(A, x), 0);
}
function parseSection(a, s, c, u, d) {
  const p = {};
  return s.map((A, x) => {
    let g = 0;
    const b = {};
    let y = 0, f = 0;
    for (const m of c)
      if (p[m.index] == null || p[m.index].left === 0)
        if (f === 0) {
          let C;
          Array.isArray(A) ? C = A[m.index - y - g] : C = A[m.index];
          const w = cellStyles(a, m, x, u, d), S = new Cell$2(C, w, a);
          b[m.index] = S, f = 0, p[m.index] = {
            left: 0,
            times: f
          };
        } else
          f--, y++;
      else
        p[m.index].left--, f = p[m.index].times, g++;
    return new Row$1(A, x, a, b);
  });
}
function parseContent4Table(a, s) {
  const c = a.content, u = c.columns.map((p) => new Column$2(p)), d = a.styles;
  return {
    columns: u,
    head: parseSection("head", c.head, u, d, s),
    body: parseSection("body", c.body, u, d, s)
  };
}
function cellStyles(a, s, c, u, d) {
  let p;
  a === "head" ? p = u.headStyles : a === "body" && (p = u.bodyStyles);
  const v = Object.assign({}, u.styles, p), A = u.columnStyles[s.index] || u.columnStyles[s.index] || {}, x = a === "body" && c % 2 === 0 ? Object.assign({}, u.alternateRowStyles) : {};
  return Object.assign({
    fontName: d,
    backgroundColor: "",
    textColor: "#000000",
    lineHeight: 1,
    characterSpacing: 0,
    alignment: "left",
    verticalAlignment: "middle",
    fontSize: 10,
    cellPadding: 5,
    lineColor: "#000000",
    lineWidth: 0,
    minCellHeight: 0,
    minCellWidth: 0
  }, v, x, A);
}
function mapCellStyle(a) {
  return {
    fontName: a.fontName,
    alignment: a.alignment,
    verticalAlignment: a.verticalAlignment,
    fontSize: a.fontSize,
    lineHeight: a.lineHeight,
    characterSpacing: a.characterSpacing,
    backgroundColor: a.backgroundColor,
    // ---
    textColor: a.fontColor,
    lineColor: a.borderColor,
    lineWidth: a.borderWidth,
    cellPadding: a.padding
  };
}
function getTableOptions(a, s) {
  const c = a.headWidthPercentages.reduce((v, A, x) => ({ ...v, [x]: { cellWidth: a.width * (A / 100) } }), {}), u = Object.entries(a.columnStyles.alignment || {}).reduce((v, [A, x]) => ({ ...v, [A]: { alignment: x } }), {}), d = /* @__PURE__ */ new Set([
    ...Object.keys(c).map(Number),
    ...Object.keys(u).map(Number)
  ]), p = Array.from(d).reduce((v, A) => {
    const x = c[A] || {}, g = u[A] || {};
    return { ...v, [A]: { ...x, ...g } };
  }, {});
  return {
    head: [a.head],
    body: s,
    showHead: a.showHead,
    startY: a.position.y,
    tableWidth: a.width,
    tableLineColor: a.tableStyles.borderColor,
    tableLineWidth: a.tableStyles.borderWidth,
    headStyles: mapCellStyle(a.headStyles),
    bodyStyles: mapCellStyle(a.bodyStyles),
    alternateRowStyles: { backgroundColor: a.bodyStyles.alternateBackgroundColor },
    columnStyles: p,
    margin: { top: 0, right: 0, left: a.position.x, bottom: 0 }
  };
}
function parseStyles(a) {
  const s = {
    styles: {},
    headStyles: {},
    bodyStyles: {},
    alternateRowStyles: {},
    columnStyles: {}
  };
  for (const c of Object.keys(s))
    if (c === "columnStyles") {
      const u = a[c];
      s.columnStyles = Object.assign({}, u);
    } else {
      const d = [a].map((p) => p[c] || {});
      s[c] = Object.assign({}, d[0], d[1], d[2]);
    }
  return s;
}
function parseContent4Input(a) {
  const s = a.head || [], c = a.body || [];
  return { columns: (s[0] || c[0] || []).map((d, p) => p), head: s, body: c };
}
function parseInput(a, s) {
  const c = getTableOptions(a, s), u = parseStyles(c), d = {
    startY: c.startY,
    margin: c.margin,
    tableWidth: c.tableWidth,
    showHead: c.showHead,
    tableLineWidth: c.tableLineWidth ?? 0,
    tableLineColor: c.tableLineColor ?? ""
  };
  return { content: parseContent4Input(c), styles: u, settings: d };
}
function createSingleTable(a, s) {
  const { options: c, _cache: u, basePdf: d } = s;
  isBlankPdf(d) || console.warn(`[@pdfme/schema/table]When specifying a custom PDF for basePdf, you cannot use features such as page breaks or re-layout of other elements.To utilize these features, please define basePdf as follows:
{ width: number; height: number; padding: [number, number, number, number]; }`);
  const p = cloneDeep$1(s.schema), { start: v } = p.__bodyRange || { start: 0 };
  if (v % 2 === 1) {
    const y = p.bodyStyles.alternateBackgroundColor;
    p.bodyStyles.alternateBackgroundColor = p.bodyStyles.backgroundColor, p.bodyStyles.backgroundColor = y;
  }
  p.showHead = p.showHead === !1 ? !1 : !p.__isSplit;
  const A = parseInput(p, a), x = c.font || getDefaultFont(), g = getFallbackFontName(x), b = parseContent4Table(A, g);
  return Table$2.create({
    input: A,
    content: b,
    font: x,
    _cache: u
  });
}
const DEFAULT_OPACITY = 1, HEX_COLOR_PATTERN = "^#(?:[A-Fa-f0-9]{6})$", getBody$1 = (a) => typeof a == "string" ? JSON.parse(a || "[]") : a || [], getBodyWithRange = (a, s) => {
  const c = getBody$1(a);
  return s ? c.slice(s.start, s.end) : c;
}, getDynamicHeightsForTable$1 = async (a, s) => {
  if (s.schema.type !== "table")
    return Promise.resolve([s.schema.height]);
  const c = s.schema, u = c.__bodyRange?.start === 0 ? getBody$1(a) : getBodyWithRange(a, c.__bodyRange), d = await createSingleTable(u, s);
  return c.showHead ? d.allRows().map((p) => p.height) : [0].concat(d.body.map((p) => p.height));
}, convertForPdfLayoutProps = ({ schema: a, pageHeight: s, applyRotateTranslate: c = !0 }) => {
  const { width: u, height: d, position: p, rotate: v, opacity: A } = a, { x, y: g } = p, b = v ? -v : 0, y = mm2pt(u), f = mm2pt(d);
  let m = mm2pt(x), C = s - mm2pt(g) - f;
  if (b && c) {
    const w = { x: m + y / 2, y: s - mm2pt(g) - f / 2 }, S = rotatePoint({ x: m, y: C }, w, b);
    m = S.x, C = S.y;
  }
  return {
    position: { x: m, y: C },
    height: f,
    width: y,
    rotate: degrees(b),
    opacity: A
  };
}, rotatePoint = (a, s, c) => {
  const u = degreesToRadians(c), d = Math.cos(u) * (a.x - s.x) - Math.sin(u) * (a.y - s.y) + s.x, p = Math.sin(u) * (a.x - s.x) + Math.cos(u) * (a.y - s.y) + s.y;
  return { x: d, y: p };
}, getDynamicHeightsForTable = getDynamicHeightsForTable$1, isEditable = (a, s) => a === "designer" || a === "form" && s.readOnly !== !0, hex2rgb = (a) => (a.slice(0, 1) === "#" && (a = a.slice(1)), a.length === 3 && (a = a.slice(0, 1) + a.slice(0, 1) + a.slice(1, 2) + a.slice(1, 2) + a.slice(2, 3) + a.slice(2, 3)), [a.slice(0, 2), a.slice(2, 4), a.slice(4, 6)].map((s) => parseInt(s, 16))), hex2RgbColor = (a) => {
  if (a) {
    if (!isHexValid(a))
      throw new Error(`Invalid hex color value ${a}`);
    const [c, u, d] = hex2rgb(a);
    return rgb(c / 255, u / 255, d / 255);
  }
}, hex2CmykColor = (a) => {
  if (a) {
    if (!isHexValid(a))
      throw new Error(`Invalid hex color value ${a}`);
    a = a.replace("#", "");
    const c = a.substring(0, 6), u = a.substring(6, 8), d = u ? parseInt(u, 16) / 255 : 1;
    let p = parseInt(c.substring(0, 2), 16) / 255, v = parseInt(c.substring(2, 4), 16) / 255, A = parseInt(c.substring(4, 6), 16) / 255;
    p = p * d + (1 - d), v = v * d + (1 - d), A = A * d + (1 - d);
    const x = 1 - Math.max(p, v, A), g = p === 0 ? 0 : (1 - p - x) / (1 - x), b = v === 0 ? 0 : (1 - v - x) / (1 - x), y = A === 0 ? 0 : (1 - A - x) / (1 - x);
    return cmyk(g, b, y, x);
  }
}, hex2PrintingColor = (a, s) => typeof a == "object" ? a : s?.toLowerCase() == "cmyk" ? hex2CmykColor(a) : hex2RgbColor(a), createSvgStr = (a, s) => {
  if (!Array.isArray(a))
    return String(a);
  const u = Object.entries({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }).map(([v, A]) => `${v}="${A}"`).join(" "), d = (v) => {
    if (!Array.isArray(v))
      return String(v);
    const [A, x = {}, g = []] = v, b = String(A), y = Object.entries(x).map(([m, C]) => `${m}="${C}"`).join(" ");
    let f = "";
    return Array.isArray(g) && g.length > 0 && (f = g.map((m) => d(m)).join("")), f ? `<${String(b)}${y ? " " + String(y) : ""}>${f}</${String(b)}>` : `<${String(b)}${y ? " " + String(y) : ""}/>`;
  }, p = Array.isArray(a) ? a.map((v) => d(v)).join("") : d(a);
  return `<svg ${u}>${p}</svg>`;
}, embedAndGetFontObj = async (a) => {
  const { pdfDoc: s, font: c, _cache: u } = a;
  if (u.has(s))
    return u.get(s);
  const d = await Promise.all(Object.values(c).map(async (v) => {
    let A = v.data;
    return typeof A == "string" && A.startsWith("http") && (A = await fetch(A).then((x) => x.arrayBuffer())), s.embedFont(A, {
      subset: typeof v.subset > "u" ? !0 : v.subset
    });
  })), p = Object.keys(c).reduce((v, A, x) => Object.assign(v, { [A]: d[x] }), {});
  return u.set(s, p), p;
}, getFontProp = ({ value: a, fontKitFont: s, schema: c, colorType: u }) => {
  const d = c.dynamicFontSize ? calculateDynamicFontSize({ textSchema: c, fontKitFont: s, value: a }) : c.fontSize ?? DEFAULT_FONT_SIZE, p = hex2PrintingColor(c.fontColor || DEFAULT_FONT_COLOR, u);
  return {
    alignment: c.alignment ?? DEFAULT_ALIGNMENT,
    verticalAlignment: c.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT,
    lineHeight: c.lineHeight ?? DEFAULT_LINE_HEIGHT,
    characterSpacing: c.characterSpacing ?? DEFAULT_CHARACTER_SPACING,
    fontSize: d,
    color: p
  };
}, pdfRender = async (a) => {
  const { value: s, pdfDoc: c, pdfLib: u, page: d, options: p, schema: v, _cache: A } = a;
  if (!s)
    return;
  const { font: x = getDefaultFont(), colorType: g } = p, [b, y] = await Promise.all([
    embedAndGetFontObj({
      pdfDoc: c,
      font: x,
      _cache: A
    }),
    getFontKitFont(v.fontName, x, A)
  ]), f = getFontProp({ value: s, fontKitFont: y, schema: v, colorType: g }), { fontSize: m, color: C, alignment: w, verticalAlignment: S, lineHeight: $, characterSpacing: T } = f, I = v.fontName ? v.fontName : getFallbackFontName(x), _ = b && b[I], E = d.getHeight(), { width: R, height: O, rotate: L, position: { x: B, y: F }, opacity: M } = convertForPdfLayoutProps({ schema: v, pageHeight: E, applyRotateTranslate: !1 });
  if (v.backgroundColor) {
    const D = hex2PrintingColor(v.backgroundColor, g);
    d.drawRectangle({ x: B, y: F, width: R, height: O, rotate: L, color: D });
  }
  const W = heightOfFontAtSize(y, m), j = getFontDescentInPt(y, m), G = $ === 0 ? 0 : ($ - 1) * m / 2, U = splitTextToSize({
    value: s,
    characterSpacing: T,
    fontSize: m,
    fontKitFont: y,
    boxWidthInPt: R
  });
  let k = 0;
  if (S === VERTICAL_ALIGN_TOP)
    k = W + G;
  else {
    const D = $ * m * (U.length - 1);
    S === VERTICAL_ALIGN_BOTTOM ? k = O - D + j - G : S === VERTICAL_ALIGN_MIDDLE && (k = (O - D - W + j) / 2 + W);
  }
  const N = { x: B + R / 2, y: E - mm2pt(v.position.y) - O / 2 }, P = new Intl.Segmenter(void 0, { granularity: "grapheme" });
  U.forEach((D, H) => {
    const V = D.replace(`
`, ""), Z = widthOfTextAtSize(V, y, m, T), ne = heightOfFontAtSize(y, m), K = $ * m * H;
    D === "" && (D = `\r
`);
    let q = B;
    w === "center" ? q += (R - Z) / 2 : w === "right" && (q += R - Z);
    let Y = E - mm2pt(v.position.y) - k - K;
    if (v.strikethrough && Z > 0) {
      const Q = q + Z + 1, J = Y + ne / 3;
      d.drawLine({
        start: rotatePoint({ x: q, y: J }, N, L.angle),
        end: rotatePoint({ x: Q, y: J }, N, L.angle),
        thickness: 1 / 12 * m,
        color: C,
        opacity: M
      });
    }
    if (v.underline && Z > 0) {
      const Q = q + Z + 1, J = Y - ne / 12;
      d.drawLine({
        start: rotatePoint({ x: q, y: J }, N, L.angle),
        end: rotatePoint({ x: Q, y: J }, N, L.angle),
        thickness: 1 / 12 * m,
        color: C,
        opacity: M
      });
    }
    if (L.angle !== 0) {
      const Q = rotatePoint({ x: q, y: Y }, N, L.angle);
      q = Q.x, Y = Q.y;
    }
    let ee = T;
    if (w === "justify" && D.slice(-1) !== `
`) {
      const Q = P.segment(V)[Symbol.iterator](), J = Array.from(Q).length;
      ee += (R - Z) / J;
    }
    d.pushOperators(u.setCharacterSpacing(ee)), d.drawText(V, {
      x: q,
      y: Y,
      rotate: L,
      size: m,
      color: C,
      lineHeight: $ * m,
      font: _,
      opacity: M
    });
  });
};
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignCenter = [
  ["path", { d: "M17 12H7" }],
  ["path", { d: "M19 18H5" }],
  ["path", { d: "M21 6H3" }]
];
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignJustify = [
  ["path", { d: "M3 12h18" }],
  ["path", { d: "M3 18h18" }],
  ["path", { d: "M3 6h18" }]
];
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignLeft = [
  ["path", { d: "M15 12H3" }],
  ["path", { d: "M17 18H3" }],
  ["path", { d: "M21 6H3" }]
];
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignRight = [
  ["path", { d: "M21 12H9" }],
  ["path", { d: "M21 18H7" }],
  ["path", { d: "M21 6H3" }]
];
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownToLine = [
  ["path", { d: "M12 17V3" }],
  ["path", { d: "m6 11 6 6 6-6" }],
  ["path", { d: "M19 21H5" }]
];
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpToLine = [
  ["path", { d: "M5 3h14" }],
  ["path", { d: "m18 13-6-6-6 6" }],
  ["path", { d: "M12 7v14" }]
];
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Strikethrough = [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12" }]
];
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TextCursorInput = [
  ["path", { d: "M12 20h-1a2 2 0 0 1-2-2 2 2 0 0 1-2 2H6" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1" }],
  ["path", { d: "M6 4h1a2 2 0 0 1 2 2 2 2 0 0 1 2-2h1" }],
  ["path", { d: "M9 6v12" }]
];
/**
 * @license lucide v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Underline = [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20" }]
], TextStrikethroughIcon = createSvgStr(Strikethrough), TextUnderlineIcon = createSvgStr(Underline), TextAlignLeftIcon = createSvgStr(AlignLeft), TextAlignCenterIcon = createSvgStr(AlignCenter), TextAlignRightIcon = createSvgStr(AlignRight), TextAlignJustifyIcon = createSvgStr(AlignJustify), TextVerticalAlignTopIcon = createSvgStr(ArrowUpToLine), TextVerticalAlignMiddleIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M8 19h3v4h2v-4h3l-4-4l-4 4zm8-14h-3V1h-2v4H8l4 4l4-4zM4 11v2h16v-2H4z" fill="currentColor"></path></svg>', TextVerticalAlignBottomIcon = createSvgStr(ArrowDownToLine);
var Formatter;
(function(a) {
  a.STRIKETHROUGH = "strikethrough", a.UNDERLINE = "underline", a.ALIGNMENT = "alignment", a.VERTICAL_ALIGNMENT = "verticalAlignment";
})(Formatter || (Formatter = {}));
function getExtraFormatterSchema(a) {
  const s = [
    { key: Formatter.STRIKETHROUGH, icon: TextStrikethroughIcon, type: "boolean" },
    { key: Formatter.UNDERLINE, icon: TextUnderlineIcon, type: "boolean" },
    { key: Formatter.ALIGNMENT, icon: TextAlignLeftIcon, type: "select", value: DEFAULT_ALIGNMENT },
    { key: Formatter.ALIGNMENT, icon: TextAlignCenterIcon, type: "select", value: ALIGN_CENTER },
    { key: Formatter.ALIGNMENT, icon: TextAlignRightIcon, type: "select", value: ALIGN_RIGHT },
    { key: Formatter.ALIGNMENT, icon: TextAlignJustifyIcon, type: "select", value: ALIGN_JUSTIFY },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignTopIcon,
      type: "select",
      value: DEFAULT_VERTICAL_ALIGNMENT
    },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignMiddleIcon,
      type: "select",
      value: VERTICAL_ALIGN_MIDDLE
    },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignBottomIcon,
      type: "select",
      value: VERTICAL_ALIGN_BOTTOM
    }
  ];
  return {
    title: a("schemas.text.format"),
    widget: "ButtonGroup",
    buttons: s,
    span: 24
  };
}
const UseDynamicFontSize = (a) => {
  const { rootElement: s, changeSchemas: c, activeSchema: u, i18n: d } = a, p = document.createElement("input");
  p.type = "checkbox", p.checked = !!u?.dynamicFontSize, p.onchange = (x) => {
    const g = x.target.checked ? {
      min: DEFAULT_DYNAMIC_MIN_FONT_SIZE,
      max: DEFAULT_DYNAMIC_MAX_FONT_SIZE,
      fit: DEFAULT_DYNAMIC_FIT
    } : void 0;
    c([{ key: "dynamicFontSize", value: g, schemaId: u.id }]);
  };
  const v = document.createElement("label"), A = document.createElement("span");
  A.innerText = d("schemas.text.dynamicFontSize") || "", A.style.cssText = "margin-left: 0.5rem", v.style.cssText = "display: flex; width: 100%;", v.appendChild(p), v.appendChild(A), s.appendChild(v);
}, propPanel = {
  schema: ({ options: a, activeSchema: s, i18n: c }) => {
    const u = a.font || { [DEFAULT_FONT_NAME]: { data: "", fallback: !0 } }, d = Object.keys(u), p = getFallbackFontName(u), v = !!s?.dynamicFontSize;
    return {
      fontName: {
        title: c("schemas.text.fontName"),
        type: "string",
        widget: "select",
        default: p,
        placeholder: p,
        props: { options: d.map((x) => ({ label: x, value: x })) },
        span: 12
      },
      fontSize: {
        title: c("schemas.text.size"),
        type: "number",
        widget: "inputNumber",
        span: 6,
        disabled: v,
        props: { min: 0 }
      },
      characterSpacing: {
        title: c("schemas.text.spacing"),
        type: "number",
        widget: "inputNumber",
        span: 6,
        props: { min: 0 }
      },
      formatter: getExtraFormatterSchema(c),
      lineHeight: {
        title: c("schemas.text.lineHeight"),
        type: "number",
        widget: "inputNumber",
        props: { step: 0.1, min: 0 },
        span: 8
      },
      useDynamicFontSize: { type: "boolean", widget: "UseDynamicFontSize", bind: !1, span: 16 },
      dynamicFontSize: {
        type: "object",
        widget: "card",
        column: 3,
        properties: {
          min: {
            title: c("schemas.text.min"),
            type: "number",
            widget: "inputNumber",
            hidden: !v,
            props: { min: 0 }
          },
          max: {
            title: c("schemas.text.max"),
            type: "number",
            widget: "inputNumber",
            hidden: !v,
            props: { min: 0 }
          },
          fit: {
            title: c("schemas.text.fit"),
            type: "string",
            widget: "select",
            hidden: !v,
            props: {
              options: [
                { label: c("schemas.horizontal"), value: DYNAMIC_FIT_HORIZONTAL },
                { label: c("schemas.vertical"), value: DYNAMIC_FIT_VERTICAL }
              ]
            }
          }
        }
      },
      fontColor: {
        title: c("schemas.textColor"),
        type: "string",
        widget: "color",
        props: {
          disabledAlpha: !0
        },
        rules: [
          {
            pattern: HEX_COLOR_PATTERN,
            message: c("validation.hexColor")
          }
        ]
      },
      backgroundColor: {
        title: c("schemas.bgColor"),
        type: "string",
        widget: "color",
        props: {
          disabledAlpha: !0
        },
        rules: [
          {
            pattern: HEX_COLOR_PATTERN,
            message: c("validation.hexColor")
          }
        ]
      }
    };
  },
  widgets: { UseDynamicFontSize },
  defaultSchema: {
    name: "",
    type: "text",
    content: "Type Something...",
    position: { x: 0, y: 0 },
    width: 45,
    height: 10,
    // If the value of "rotate" is set to undefined or not set at all, rotation will be disabled in the UI.
    // Check this document: https://pdfme.com//docs/custom-schemas#learning-how-to-create-from-pdfmeschemas-code
    rotate: 0,
    alignment: DEFAULT_ALIGNMENT,
    verticalAlignment: DEFAULT_VERTICAL_ALIGNMENT,
    fontSize: DEFAULT_FONT_SIZE,
    lineHeight: DEFAULT_LINE_HEIGHT,
    characterSpacing: DEFAULT_CHARACTER_SPACING,
    dynamicFontSize: void 0,
    fontColor: DEFAULT_FONT_COLOR,
    fontName: void 0,
    backgroundColor: "",
    opacity: DEFAULT_OPACITY,
    strikethrough: !1,
    underline: !1
  }
}, replaceUnsupportedChars = (a, s) => {
  const c = {}, u = (p) => {
    if (p in c)
      return c[p];
    const v = s.hasGlyphForCodePoint(p.codePointAt(0) || 0);
    return c[p] = v, v;
  };
  return a.split(/(\r\n|\n|\r)/).map((p) => /\r\n|\n|\r/.test(p) ? p : p.split("").map((v) => /\s/.test(v) || v.charCodeAt(0) < 32 || u(v) ? v : "〿").join("")).join("");
}, uiRender = async (a) => {
  const { value: s, schema: c, mode: u, onChange: d, stopEditing: p, tabIndex: v, placeholder: A, options: x, _cache: g } = a, b = isEditable(u, c) && A && !s, y = (S) => {
    let $ = S.innerText;
    return $.endsWith(`
`) && ($ = $.slice(0, -1)), $;
  }, f = x?.font || getDefaultFont(), m = await getFontKitFont(c.fontName, f, g), C = buildStyledTextContainer(a, m, b ? A : s), w = replaceUnsupportedChars(s, m);
  if (!isEditable(u, c)) {
    C.innerHTML = w.split("").map((S, $) => `<span style="letter-spacing:${String(s).length === $ + 1 ? 0 : "inherit"};">${S}</span>`).join("");
    return;
  }
  if (makeElementPlainTextContentEditable(C), C.tabIndex = v || 0, C.innerText = u === "designer" ? s : w, C.addEventListener("blur", (S) => {
    d && d({ key: "content", value: y(S.target) }), p && p();
  }), c.dynamicFontSize) {
    let S;
    C.addEventListener("keyup", () => {
      setTimeout(() => {
        (() => {
          if (!C.textContent)
            return;
          S = calculateDynamicFontSize({
            textSchema: c,
            fontKitFont: m,
            value: y(C),
            startingFontSize: S
          }), C.style.fontSize = `${S}pt`;
          const { topAdj: $, bottomAdj: T } = getBrowserVerticalFontAdjustments(m, S ?? c.fontSize ?? DEFAULT_FONT_SIZE, c.lineHeight ?? DEFAULT_LINE_HEIGHT, c.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT);
          C.style.paddingTop = `${$}px`, C.style.marginBottom = `${T}px`;
        })();
      }, 0);
    });
  }
  b && (C.style.color = PLACEHOLDER_FONT_COLOR, C.addEventListener("focus", () => {
    C.innerText === A && (C.innerText = "", C.style.color = c.fontColor ?? DEFAULT_FONT_COLOR);
  })), u === "designer" && setTimeout(() => {
    C.focus();
    const S = window.getSelection(), $ = document.createRange();
    S && $ && ($.selectNodeContents(C), $.collapse(!1), S?.removeAllRanges(), S?.addRange($));
  });
}, buildStyledTextContainer = (a, s, c) => {
  const { schema: u, rootElement: d, mode: p } = a;
  let v;
  u.dynamicFontSize && c && (v = calculateDynamicFontSize({
    textSchema: u,
    fontKitFont: s,
    value: c,
    startingFontSize: v
  }));
  const { topAdj: A, bottomAdj: x } = getBrowserVerticalFontAdjustments(s, v ?? u.fontSize ?? DEFAULT_FONT_SIZE, u.lineHeight ?? DEFAULT_LINE_HEIGHT, u.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT), g = A.toString(), b = x.toString(), y = document.createElement("div"), f = {
    padding: 0,
    resize: "none",
    backgroundColor: getBackgroundColor(c, u),
    border: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: mapVerticalAlignToFlex(u.verticalAlignment),
    width: "100%",
    height: "100%",
    cursor: isEditable(p, u) ? "text" : "default"
  };
  Object.assign(y.style, f), d.innerHTML = "", d.appendChild(y);
  const m = [];
  u.strikethrough && m.push("line-through"), u.underline && m.push("underline");
  const C = {
    // Font formatting styles
    fontFamily: u.fontName ? `'${u.fontName}'` : "inherit",
    color: u.fontColor ? u.fontColor : DEFAULT_FONT_COLOR,
    fontSize: `${v ?? u.fontSize ?? DEFAULT_FONT_SIZE}pt`,
    letterSpacing: `${u.characterSpacing ?? DEFAULT_CHARACTER_SPACING}pt`,
    lineHeight: `${u.lineHeight ?? DEFAULT_LINE_HEIGHT}em`,
    textAlign: u.alignment ?? DEFAULT_ALIGNMENT,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    // Block layout styles
    resize: "none",
    border: "none",
    outline: "none",
    marginBottom: `${b}px`,
    paddingTop: `${g}px`,
    backgroundColor: "transparent",
    textDecoration: m.join(" ")
  }, w = document.createElement("div");
  return w.id = "text-" + String(u.id), Object.assign(w.style, C), y.appendChild(w), w;
}, makeElementPlainTextContentEditable = (a) => {
  if (!isFirefox()) {
    a.contentEditable = "plaintext-only";
    return;
  }
  a.contentEditable = "true", a.addEventListener("keydown", (s) => {
    s.key === "Enter" && !s.shiftKey && (s.preventDefault(), document.execCommand("insertLineBreak", !1, void 0));
  }), a.addEventListener("paste", (s) => {
    s.preventDefault();
    const c = s.clipboardData?.getData("text"), u = window.getSelection();
    u?.rangeCount && (u.deleteFromDocument(), u.getRangeAt(0).insertNode(document.createTextNode(c || "")), u.collapseToEnd());
  });
}, mapVerticalAlignToFlex = (a) => {
  switch (a) {
    case VERTICAL_ALIGN_TOP:
      return "flex-start";
    case VERTICAL_ALIGN_MIDDLE:
      return "center";
    case VERTICAL_ALIGN_BOTTOM:
      return "flex-end";
  }
  return "flex-start";
}, getBackgroundColor = (a, s) => !a || !s.backgroundColor ? "transparent" : s.backgroundColor, textSchema = {
  pdf: pdfRender,
  ui: uiRender,
  propPanel,
  icon: createSvgStr(TextCursorInput)
}, builtInPlugins = { Text: textSchema }, I18nContext = reactExports.createContext(i18n), FontContext = reactExports.createContext(getDefaultFont()), PluginsRegistry = reactExports.createContext(pluginRegistry(builtInPlugins)), OptionsContext = reactExports.createContext({}), CacheContext = reactExports.createContext(/* @__PURE__ */ new Map()), hotkeys = function(a, s) {
  return hotkeys$1(a, s);
};
hotkeys.shift = !1;
hotkeys.unbind = function(a) {
  const s = hotkeys$1;
  typeof s.unbind == "function" && s.unbind(a);
};
const uuid$6 = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (a) => {
  const s = Math.random() * 16 | 0;
  return (a == "x" ? s : s & 3 | 8).toString(16);
}), set$2 = (a, s, c) => {
  s = Array.isArray(s) ? s : s.replace("[", ".").replace("]", "").split(".");
  let u = a;
  s.forEach((d, p, v) => {
    if (p == s.length - 1)
      u[d] = c;
    else {
      if (!Object.prototype.hasOwnProperty.call(u, d)) {
        const A = v[p + 1];
        u[d] = String(Number(A)) === A ? [] : {};
      }
      u = u[d];
    }
  });
}, debounce$1 = (a, s = 20) => {
  let c = null;
  return (...d) => {
    c && clearTimeout(c), c = setTimeout(() => a(...d), s);
  };
}, shift = (a, s, c) => {
  c && (s = -s);
  const u = `${a}`.split("e");
  return +`${u[0]}e${u[1] ? Number(u[1]) + s : s}`;
}, round$1 = (a, s) => shift(Math.round(shift(a, s, !1)), s, !0), flatten = (a) => [].concat(...a), up = "up", shiftUp = "shift+up", down = "down", shiftDown = "shift+down", left = "left", shiftLeft = "shift+left", right = "right", shiftRight = "shift+right", rmWin = "backspace", rmMac = "delete", esc = "esc", copyWin = "ctrl+c", copyMac = "command+c", pasteWin = "ctrl+v", pasteMac = "command+v", redoWin = "ctrl+y", redoMac = "shift+command+z", undoWin = "ctrl+z", undoMac = "command+z", saveWin = "ctrl+s", saveMac = "command+s", selectAllWin = "ctrl+a", selectAllMac = "command+a", keys$2 = [
  up,
  shiftUp,
  down,
  shiftDown,
  left,
  shiftLeft,
  right,
  shiftRight,
  rmMac,
  rmWin,
  esc,
  copyWin,
  copyMac,
  pasteWin,
  pasteMac,
  redoWin,
  redoMac,
  undoWin,
  undoMac,
  saveWin,
  saveMac,
  selectAllWin,
  selectAllMac
], initShortCuts = (a) => {
  hotkeys(keys$2.join(), (s, c) => {
    switch (c.shortcut) {
      case up:
      case shiftUp:
        s.preventDefault(), a.move("up", hotkeys.shift);
        break;
      case down:
      case shiftDown:
        s.preventDefault(), a.move("down", hotkeys.shift);
        break;
      case left:
      case shiftLeft:
        s.preventDefault(), a.move("left", hotkeys.shift);
        break;
      case right:
      case shiftRight:
        s.preventDefault(), a.move("right", hotkeys.shift);
        break;
      case rmWin:
      case rmMac:
        a.remove();
        break;
      case esc:
        a.esc();
        break;
      case copyWin:
      case copyMac:
        a.copy();
        break;
      case pasteWin:
      case pasteMac:
        a.paste();
        break;
      case redoWin:
      case redoMac:
        a.redo();
        break;
      case undoWin:
      case undoMac:
        a.undo();
        break;
      case saveWin:
      case saveMac:
        s.preventDefault(), a.save();
        break;
      case selectAllWin:
      case selectAllMac:
        s.preventDefault(), a.selectAll();
        break;
    }
  });
}, destroyShortCuts = () => {
  hotkeys.unbind(keys$2.join());
};
function detectMimeType(a) {
  const s = new DataView(a);
  return s.getUint8(0) === 137 && s.getUint8(1) === 80 && s.getUint8(2) === 78 && s.getUint8(3) === 71 ? "image/png" : s.getUint8(0) === 255 && s.getUint8(1) === 216 && s.getUint8(2) === 255 ? "image/jpeg" : "";
}
const arrayBufferToBase64 = (a) => {
  const s = detectMimeType(a), c = new Uint8Array(a);
  let u = "";
  for (let p = 0; p < c.length; p++)
    u += String.fromCharCode(c[p]);
  const d = btoa(u);
  return s ? `data:${s};base64,${d}` : `data:application/octet-stream;base64,${d}`;
}, convertSchemasForUI = (a) => (a.schemas.forEach((s) => {
  s.forEach((c) => {
    c.id = uuid$6(), c.content = c.content || "";
  });
}), a.schemas), template2SchemasList = async (a) => {
  const s = cloneDeep$1(a), { basePdf: c, schemas: u } = s, d = convertSchemasForUI(s);
  let p = [];
  if (isBlankPdf(c))
    p = u.map(() => ({
      width: c.width,
      height: c.height
    }));
  else {
    const x = await getB64BasePdf(c), g = b64toUint8Array(x);
    p = await pdf2size(g);
  }
  const v = d.length, A = p.length;
  return (v < A ? d.concat(new Array(A - v).fill(cloneDeep$1([]))) : d.slice(0, p.length)).map((x, g) => (Object.values(x).forEach((b) => {
    const { width: y, height: f } = p[g], m = b.position.x + b.width, C = b.position.y + b.height;
    if (y < m) {
      const w = m - y;
      b.position.x += w;
    }
    if (f < C) {
      const w = C - f;
      b.position.y += w;
    }
  }), x));
}, schemasList2template = (a, s) => ({
  schemas: cloneDeep$1(a).map(
    (c) => c.map((u) => (delete u.id, u))
  ),
  basePdf: s
}), getUniqueSchemaName = (a) => {
  const { copiedSchemaName: s, schema: c, stackUniqueSchemaNames: u } = a, d = c.map((g) => g.name).concat(u), p = d.reduce(
    (g, b) => Object.assign(g, { originalName: b, copiedNum: 0 }),
    {}
  ), v = (g) => g.replace(/ copy$| copy [0-9]*$/, "");
  d.filter((g) => / copy$| copy [0-9]*$/.test(g)).forEach((g) => {
    const b = v(g), y = g.match(/[0-9]*$/), f = y && y[0] ? Number(y[0]) : 1;
    (p[b] ?? 0) < f && (p[b] = f);
  });
  const A = v(s);
  if (p[A]) {
    const g = p[A], b = `${A} copy ${g + 1}`;
    return u.push(b), b;
  }
  const x = `${s} copy`;
  return u.push(x), x;
}, moveCommandToChangeSchemasArg = (a) => {
  const { command: s, activeSchemas: c, isShift: u, pageSize: d } = a, p = s === "up" || s === "down" ? "y" : "x", v = u ? 0.1 : 1, A = (x) => {
    let g = 0;
    const { position: b } = x;
    switch (s) {
      case "up":
        g = round$1(b.y - v, 2);
        break;
      case "down":
        g = round$1(b.y + v, 2);
        break;
      case "left":
        g = round$1(b.x - v, 2);
        break;
      case "right":
        g = round$1(b.x + v, 2);
        break;
    }
    return g > 0 ? g : 0;
  };
  return c.map((x) => {
    let g = A(x);
    const { width: b, height: y } = x;
    return p === "x" ? g = g > d.width - b ? round$1(d.width - b, 2) : g : g = g > d.height - y ? round$1(d.height - y, 2) : g, { key: `position.${p}`, value: g, schemaId: x.id };
  });
}, getPagesScrollTopByIndex = (a, s, c) => a.slice(0, s).reduce((u, d) => u + (d.height * ZOOM + RULER_HEIGHT * c) * c, 0), getSidebarContentHeight = (a) => a - RULER_HEIGHT - RULER_HEIGHT / 2 - 30, handlePositionSizeChange = (a, s, c, u, d) => {
  const p = isBlankPdf(u) ? u.padding : [0, 0, 0, 0], [v, A, x, g] = p, { width: b, height: y } = d, f = (m, C, w) => Math.min(Math.max(Number(m), C), w);
  s === "position.x" ? a.position.x = f(c, g, b - a.width - A) : s === "position.y" ? a.position.y = f(c, v, y - a.height - x) : s === "width" ? a.width = f(c, 0, b - a.position.x - A) : s === "height" && (a.height = f(c, 0, y - a.position.y - x));
}, handleTypeChange = (a, s, c, u) => {
  if (s !== "type") return;
  const d = ["id", "name", "type", "position", "required"];
  Object.keys(a).forEach((v) => {
    d.includes(v) || delete a[v];
  });
  const p = u.findByType(c);
  if (p?.propPanel.defaultSchema) {
    const v = p.propPanel.defaultSchema, A = a;
    for (const x of Object.keys(v))
      if (!Object.prototype.hasOwnProperty.call(a, x)) {
        const g = v[x];
        g !== void 0 && (A[x] = g);
      }
  }
  a.readOnly && (a.required = !1);
}, changeSchemas = (a) => {
  const { objs: s, schemas: c, basePdf: u, pluginsRegistry: d, pageSize: p, commitSchemas: v } = a, A = s.reduce((x, { key: g, value: b, schemaId: y }) => {
    const f = x.find((m) => m.id === y);
    return f && (set$2(f, g, b), g === "type" ? handleTypeChange(f, g, b, d) : ["position.x", "position.y", "width", "height"].includes(g) && handlePositionSizeChange(f, g, b, u, p)), x;
  }, cloneDeep$1(c));
  v(A);
}, useMaxZoom = () => {
  const a = reactExports.useContext(OptionsContext);
  return a.maxZoom ? a.maxZoom / 100 : DEFAULT_MAX_ZOOM;
}, setFontNameRecursively = (a, s, c = /* @__PURE__ */ new WeakSet()) => {
  if (!(!a || typeof a != "object" || c.has(a))) {
    c.add(a);
    for (const u in a)
      u === "fontName" && Object.prototype.hasOwnProperty.call(a, u) && a[u] === void 0 ? a[u] = s : typeof a[u] == "object" && a[u] !== null && setFontNameRecursively(a[u], s, c);
  }
};
class BaseUIClass {
  constructor(s) {
    this.lang = DEFAULT_LANG, this.font = getDefaultFont(), this.pluginsRegistry = pluginRegistry(builtInPlugins), this.options = {}, this.setSize = debounce$1(() => {
      this.domContainer && (this.size = {
        height: this.domContainer.clientHeight || window.innerHeight,
        width: this.domContainer.clientWidth || window.innerWidth
      }, this.render());
    }, 100), this.resizeObserver = new ResizeObserver(this.setSize), checkUIProps(s);
    const { domContainer: c, template: u, options: d = {}, plugins: p = {} } = s;
    this.domContainer = c, this.template = cloneDeep$1(u), this.options = d, this.size = {
      height: this.domContainer.clientHeight || window.innerHeight,
      width: this.domContainer.clientWidth || window.innerWidth
    }, this.resizeObserver.observe(this.domContainer);
    const { lang: v, font: A } = d;
    v && (this.lang = v), A && (this.font = A), Object.values(p).length > 0 && (this.pluginsRegistry = pluginRegistry(p));
  }
  getLang() {
    return this.lang;
  }
  getFont() {
    return this.font;
  }
  getPluginsRegistry() {
    return this.pluginsRegistry;
  }
  getOptions() {
    return this.options;
  }
  getTemplate() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    return this.template;
  }
  updateTemplate(s) {
    if (checkTemplate(s), !this.domContainer) throw Error(DESTROYED_ERR_MSG);
    this.template = cloneDeep$1(s), this.render();
  }
  updateOptions(s) {
    checkUIOptions(s);
    const { lang: c, font: u } = s || {};
    c && (this.lang = c), u && (this.font = u), this.options = Object.assign(this.options, s), this.render();
  }
  destroy() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    ReactDOM.unmountComponentAtNode(this.domContainer), this.resizeObserver.unobserve(this.domContainer), this.domContainer = null;
  }
}
class PreviewUI extends BaseUIClass {
  constructor(s) {
    super(s), checkPreviewProps(s), this.inputs = convertToStingObjectArray(cloneDeep$1(s.inputs));
  }
  getInputs() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    return this.inputs;
  }
  setInputs(s) {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    checkInputs(s), this.inputs = convertToStingObjectArray(s), this.render();
  }
}
function convertToStingObjectArray(a) {
  return a.map((s) => {
    const c = {};
    return Object.keys(s).forEach((u) => {
      const d = s[u];
      Array.isArray(d) ? c[u] = JSON.stringify(d) : c[u] = d;
    }), c;
  });
}
function useCombinedRefs() {
  for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
    s[c] = arguments[c];
  return reactExports.useMemo(
    () => (u) => {
      s.forEach((d) => d(u));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    s
  );
}
const canUseDOM = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function isWindow$4(a) {
  const s = Object.prototype.toString.call(a);
  return s === "[object Window]" || // In Electron context the Window object serializes to [object global]
  s === "[object global]";
}
function isNode$1(a) {
  return "nodeType" in a;
}
function getWindow$1(a) {
  var s, c;
  return a ? isWindow$4(a) ? a : isNode$1(a) && (s = (c = a.ownerDocument) == null ? void 0 : c.defaultView) != null ? s : window : window;
}
function isDocument(a) {
  const {
    Document: s
  } = getWindow$1(a);
  return a instanceof s;
}
function isHTMLElement(a) {
  return isWindow$4(a) ? !1 : a instanceof getWindow$1(a).HTMLElement;
}
function isSVGElement(a) {
  return a instanceof getWindow$1(a).SVGElement;
}
function getOwnerDocument(a) {
  return a ? isWindow$4(a) ? a.document : isNode$1(a) ? isDocument(a) ? a : isHTMLElement(a) || isSVGElement(a) ? a.ownerDocument : document : document : document;
}
const useIsomorphicLayoutEffect$1 = canUseDOM ? reactExports.useLayoutEffect : reactExports.useEffect;
function useEvent$1(a) {
  const s = reactExports.useRef(a);
  return useIsomorphicLayoutEffect$1(() => {
    s.current = a;
  }), reactExports.useCallback(function() {
    for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
      u[d] = arguments[d];
    return s.current == null ? void 0 : s.current(...u);
  }, []);
}
function useInterval() {
  const a = reactExports.useRef(null), s = reactExports.useCallback((u, d) => {
    a.current = setInterval(u, d);
  }, []), c = reactExports.useCallback(() => {
    a.current !== null && (clearInterval(a.current), a.current = null);
  }, []);
  return [s, c];
}
function useLatestValue(a, s) {
  s === void 0 && (s = [a]);
  const c = reactExports.useRef(a);
  return useIsomorphicLayoutEffect$1(() => {
    c.current !== a && (c.current = a);
  }, s), c;
}
function useLazyMemo(a, s) {
  const c = reactExports.useRef();
  return reactExports.useMemo(
    () => {
      const u = a(c.current);
      return c.current = u, u;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...s]
  );
}
function useNodeRef(a) {
  const s = useEvent$1(a), c = reactExports.useRef(null), u = reactExports.useCallback(
    (d) => {
      d !== c.current && s?.(d, c.current), c.current = d;
    },
    //eslint-disable-next-line
    []
  );
  return [c, u];
}
function usePrevious$2(a) {
  const s = reactExports.useRef();
  return reactExports.useEffect(() => {
    s.current = a;
  }, [a]), s.current;
}
let ids = {};
function useUniqueId(a, s) {
  return reactExports.useMemo(() => {
    if (s)
      return s;
    const c = ids[a] == null ? 0 : ids[a] + 1;
    return ids[a] = c, a + "-" + c;
  }, [a, s]);
}
function createAdjustmentFn(a) {
  return function(s) {
    for (var c = arguments.length, u = new Array(c > 1 ? c - 1 : 0), d = 1; d < c; d++)
      u[d - 1] = arguments[d];
    return u.reduce((p, v) => {
      const A = Object.entries(v);
      for (const [x, g] of A) {
        const b = p[x];
        b != null && (p[x] = b + a * g);
      }
      return p;
    }, {
      ...s
    });
  };
}
const add$1 = /* @__PURE__ */ createAdjustmentFn(1), subtract = /* @__PURE__ */ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(a) {
  return "clientX" in a && "clientY" in a;
}
function isKeyboardEvent(a) {
  if (!a)
    return !1;
  const {
    KeyboardEvent: s
  } = getWindow$1(a.target);
  return s && a instanceof s;
}
function isTouchEvent(a) {
  if (!a)
    return !1;
  const {
    TouchEvent: s
  } = getWindow$1(a.target);
  return s && a instanceof s;
}
function getEventCoordinates(a) {
  if (isTouchEvent(a)) {
    if (a.touches && a.touches.length) {
      const {
        clientX: s,
        clientY: c
      } = a.touches[0];
      return {
        x: s,
        y: c
      };
    } else if (a.changedTouches && a.changedTouches.length) {
      const {
        clientX: s,
        clientY: c
      } = a.changedTouches[0];
      return {
        x: s,
        y: c
      };
    }
  }
  return hasViewportRelativeCoordinates(a) ? {
    x: a.clientX,
    y: a.clientY
  } : null;
}
const CSS$1 = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(a) {
      if (!a)
        return;
      const {
        x: s,
        y: c
      } = a;
      return "translate3d(" + (s ? Math.round(s) : 0) + "px, " + (c ? Math.round(c) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(a) {
      if (!a)
        return;
      const {
        scaleX: s,
        scaleY: c
      } = a;
      return "scaleX(" + s + ") scaleY(" + c + ")";
    }
  },
  Transform: {
    toString(a) {
      if (a)
        return [CSS$1.Translate.toString(a), CSS$1.Scale.toString(a)].join(" ");
    }
  },
  Transition: {
    toString(a) {
      let {
        property: s,
        duration: c,
        easing: u
      } = a;
      return s + " " + c + "ms " + u;
    }
  }
}), SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function findFirstFocusableNode(a) {
  return a.matches(SELECTOR) ? a : a.querySelector(SELECTOR);
}
const hiddenStyles = {
  display: "none"
};
function HiddenText(a) {
  let {
    id: s,
    value: c
  } = a;
  return React.createElement("div", {
    id: s,
    style: hiddenStyles
  }, c);
}
function LiveRegion(a) {
  let {
    id: s,
    announcement: c,
    ariaLiveType: u = "assertive"
  } = a;
  const d = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return React.createElement("div", {
    id: s,
    style: d,
    role: "status",
    "aria-live": u,
    "aria-atomic": !0
  }, c);
}
function useAnnouncement() {
  const [a, s] = reactExports.useState("");
  return {
    announce: reactExports.useCallback((u) => {
      u != null && s(u);
    }, []),
    announcement: a
  };
}
const DndMonitorContext = /* @__PURE__ */ reactExports.createContext(null);
function useDndMonitor(a) {
  const s = reactExports.useContext(DndMonitorContext);
  reactExports.useEffect(() => {
    if (!s)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return s(a);
  }, [a, s]);
}
function useDndMonitorProvider() {
  const [a] = reactExports.useState(() => /* @__PURE__ */ new Set()), s = reactExports.useCallback((u) => (a.add(u), () => a.delete(u)), [a]);
  return [reactExports.useCallback((u) => {
    let {
      type: d,
      event: p
    } = u;
    a.forEach((v) => {
      var A;
      return (A = v[d]) == null ? void 0 : A.call(v, p);
    });
  }, [a]), s];
}
const defaultScreenReaderInstructions = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, defaultAnnouncements = {
  onDragStart(a) {
    let {
      active: s
    } = a;
    return "Picked up draggable item " + s.id + ".";
  },
  onDragOver(a) {
    let {
      active: s,
      over: c
    } = a;
    return c ? "Draggable item " + s.id + " was moved over droppable area " + c.id + "." : "Draggable item " + s.id + " is no longer over a droppable area.";
  },
  onDragEnd(a) {
    let {
      active: s,
      over: c
    } = a;
    return c ? "Draggable item " + s.id + " was dropped over droppable area " + c.id : "Draggable item " + s.id + " was dropped.";
  },
  onDragCancel(a) {
    let {
      active: s
    } = a;
    return "Dragging was cancelled. Draggable item " + s.id + " was dropped.";
  }
};
function Accessibility(a) {
  let {
    announcements: s = defaultAnnouncements,
    container: c,
    hiddenTextDescribedById: u,
    screenReaderInstructions: d = defaultScreenReaderInstructions
  } = a;
  const {
    announce: p,
    announcement: v
  } = useAnnouncement(), A = useUniqueId("DndLiveRegion"), [x, g] = reactExports.useState(!1);
  if (reactExports.useEffect(() => {
    g(!0);
  }, []), useDndMonitor(reactExports.useMemo(() => ({
    onDragStart(y) {
      let {
        active: f
      } = y;
      p(s.onDragStart({
        active: f
      }));
    },
    onDragMove(y) {
      let {
        active: f,
        over: m
      } = y;
      s.onDragMove && p(s.onDragMove({
        active: f,
        over: m
      }));
    },
    onDragOver(y) {
      let {
        active: f,
        over: m
      } = y;
      p(s.onDragOver({
        active: f,
        over: m
      }));
    },
    onDragEnd(y) {
      let {
        active: f,
        over: m
      } = y;
      p(s.onDragEnd({
        active: f,
        over: m
      }));
    },
    onDragCancel(y) {
      let {
        active: f,
        over: m
      } = y;
      p(s.onDragCancel({
        active: f,
        over: m
      }));
    }
  }), [p, s])), !x)
    return null;
  const b = React.createElement(React.Fragment, null, React.createElement(HiddenText, {
    id: u,
    value: d.draggable
  }), React.createElement(LiveRegion, {
    id: A,
    announcement: v
  }));
  return c ? reactDomExports.createPortal(b, c) : b;
}
var Action;
(function(a) {
  a.DragStart = "dragStart", a.DragMove = "dragMove", a.DragEnd = "dragEnd", a.DragCancel = "dragCancel", a.DragOver = "dragOver", a.RegisterDroppable = "registerDroppable", a.SetDroppableDisabled = "setDroppableDisabled", a.UnregisterDroppable = "unregisterDroppable";
})(Action || (Action = {}));
function noop$6() {
}
function useSensor(a, s) {
  return reactExports.useMemo(
    () => ({
      sensor: a,
      options: s ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a, s]
  );
}
function useSensors() {
  for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
    s[c] = arguments[c];
  return reactExports.useMemo(
    () => [...s].filter((u) => u != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...s]
  );
}
const defaultCoordinates = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function distanceBetween(a, s) {
  return Math.sqrt(Math.pow(a.x - s.x, 2) + Math.pow(a.y - s.y, 2));
}
function getRelativeTransformOrigin(a, s) {
  const c = getEventCoordinates(a);
  if (!c)
    return "0 0";
  const u = {
    x: (c.x - s.left) / s.width * 100,
    y: (c.y - s.top) / s.height * 100
  };
  return u.x + "% " + u.y + "%";
}
function sortCollisionsAsc(a, s) {
  let {
    data: {
      value: c
    }
  } = a, {
    data: {
      value: u
    }
  } = s;
  return c - u;
}
function sortCollisionsDesc(a, s) {
  let {
    data: {
      value: c
    }
  } = a, {
    data: {
      value: u
    }
  } = s;
  return u - c;
}
function cornersOfRectangle(a) {
  let {
    left: s,
    top: c,
    height: u,
    width: d
  } = a;
  return [{
    x: s,
    y: c
  }, {
    x: s + d,
    y: c
  }, {
    x: s,
    y: c + u
  }, {
    x: s + d,
    y: c + u
  }];
}
function getFirstCollision(a, s) {
  if (!a || a.length === 0)
    return null;
  const [c] = a;
  return c[s];
}
const closestCorners = (a) => {
  let {
    collisionRect: s,
    droppableRects: c,
    droppableContainers: u
  } = a;
  const d = cornersOfRectangle(s), p = [];
  for (const v of u) {
    const {
      id: A
    } = v, x = c.get(A);
    if (x) {
      const g = cornersOfRectangle(x), b = d.reduce((f, m, C) => f + distanceBetween(g[C], m), 0), y = Number((b / 4).toFixed(4));
      p.push({
        id: A,
        data: {
          droppableContainer: v,
          value: y
        }
      });
    }
  }
  return p.sort(sortCollisionsAsc);
};
function getIntersectionRatio(a, s) {
  const c = Math.max(s.top, a.top), u = Math.max(s.left, a.left), d = Math.min(s.left + s.width, a.left + a.width), p = Math.min(s.top + s.height, a.top + a.height), v = d - u, A = p - c;
  if (u < d && c < p) {
    const x = s.width * s.height, g = a.width * a.height, b = v * A, y = b / (x + g - b);
    return Number(y.toFixed(4));
  }
  return 0;
}
const rectIntersection = (a) => {
  let {
    collisionRect: s,
    droppableRects: c,
    droppableContainers: u
  } = a;
  const d = [];
  for (const p of u) {
    const {
      id: v
    } = p, A = c.get(v);
    if (A) {
      const x = getIntersectionRatio(A, s);
      x > 0 && d.push({
        id: v,
        data: {
          droppableContainer: p,
          value: x
        }
      });
    }
  }
  return d.sort(sortCollisionsDesc);
};
function adjustScale(a, s, c) {
  return {
    ...a,
    scaleX: s && c ? s.width / c.width : 1,
    scaleY: s && c ? s.height / c.height : 1
  };
}
function getRectDelta(a, s) {
  return a && s ? {
    x: a.left - s.left,
    y: a.top - s.top
  } : defaultCoordinates;
}
function createRectAdjustmentFn(a) {
  return function(c) {
    for (var u = arguments.length, d = new Array(u > 1 ? u - 1 : 0), p = 1; p < u; p++)
      d[p - 1] = arguments[p];
    return d.reduce((v, A) => ({
      ...v,
      top: v.top + a * A.y,
      bottom: v.bottom + a * A.y,
      left: v.left + a * A.x,
      right: v.right + a * A.x
    }), {
      ...c
    });
  };
}
const getAdjustedRect = /* @__PURE__ */ createRectAdjustmentFn(1);
function parseTransform(a) {
  if (a.startsWith("matrix3d(")) {
    const s = a.slice(9, -1).split(/, /);
    return {
      x: +s[12],
      y: +s[13],
      scaleX: +s[0],
      scaleY: +s[5]
    };
  } else if (a.startsWith("matrix(")) {
    const s = a.slice(7, -1).split(/, /);
    return {
      x: +s[4],
      y: +s[5],
      scaleX: +s[0],
      scaleY: +s[3]
    };
  }
  return null;
}
function inverseTransform(a, s, c) {
  const u = parseTransform(s);
  if (!u)
    return a;
  const {
    scaleX: d,
    scaleY: p,
    x: v,
    y: A
  } = u, x = a.left - v - (1 - d) * parseFloat(c), g = a.top - A - (1 - p) * parseFloat(c.slice(c.indexOf(" ") + 1)), b = d ? a.width / d : a.width, y = p ? a.height / p : a.height;
  return {
    width: b,
    height: y,
    top: g,
    right: x + b,
    bottom: g + y,
    left: x
  };
}
const defaultOptions = {
  ignoreTransform: !1
};
function getClientRect$1(a, s) {
  s === void 0 && (s = defaultOptions);
  let c = a.getBoundingClientRect();
  if (s.ignoreTransform) {
    const {
      transform: g,
      transformOrigin: b
    } = getWindow$1(a).getComputedStyle(a);
    g && (c = inverseTransform(c, g, b));
  }
  const {
    top: u,
    left: d,
    width: p,
    height: v,
    bottom: A,
    right: x
  } = c;
  return {
    top: u,
    left: d,
    width: p,
    height: v,
    bottom: A,
    right: x
  };
}
function getTransformAgnosticClientRect(a) {
  return getClientRect$1(a, {
    ignoreTransform: !0
  });
}
function getWindowClientRect(a) {
  const s = a.innerWidth, c = a.innerHeight;
  return {
    top: 0,
    left: 0,
    right: s,
    bottom: c,
    width: s,
    height: c
  };
}
function isFixed(a, s) {
  return s === void 0 && (s = getWindow$1(a).getComputedStyle(a)), s.position === "fixed";
}
function isScrollable(a, s) {
  s === void 0 && (s = getWindow$1(a).getComputedStyle(a));
  const c = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((d) => {
    const p = s[d];
    return typeof p == "string" ? c.test(p) : !1;
  });
}
function getScrollableAncestors(a, s) {
  const c = [];
  function u(d) {
    if (s != null && c.length >= s || !d)
      return c;
    if (isDocument(d) && d.scrollingElement != null && !c.includes(d.scrollingElement))
      return c.push(d.scrollingElement), c;
    if (!isHTMLElement(d) || isSVGElement(d) || c.includes(d))
      return c;
    const p = getWindow$1(a).getComputedStyle(d);
    return d !== a && isScrollable(d, p) && c.push(d), isFixed(d, p) ? c : u(d.parentNode);
  }
  return a ? u(a) : c;
}
function getFirstScrollableAncestor(a) {
  const [s] = getScrollableAncestors(a, 1);
  return s ?? null;
}
function getScrollableElement(a) {
  return !canUseDOM || !a ? null : isWindow$4(a) ? a : isNode$1(a) ? isDocument(a) || a === getOwnerDocument(a).scrollingElement ? window : isHTMLElement(a) ? a : null : null;
}
function getScrollXCoordinate(a) {
  return isWindow$4(a) ? a.scrollX : a.scrollLeft;
}
function getScrollYCoordinate(a) {
  return isWindow$4(a) ? a.scrollY : a.scrollTop;
}
function getScrollCoordinates(a) {
  return {
    x: getScrollXCoordinate(a),
    y: getScrollYCoordinate(a)
  };
}
var Direction;
(function(a) {
  a[a.Forward = 1] = "Forward", a[a.Backward = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(a) {
  return !canUseDOM || !a ? !1 : a === document.scrollingElement;
}
function getScrollPosition(a) {
  const s = {
    x: 0,
    y: 0
  }, c = isDocumentScrollingElement(a) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: a.clientHeight,
    width: a.clientWidth
  }, u = {
    x: a.scrollWidth - c.width,
    y: a.scrollHeight - c.height
  }, d = a.scrollTop <= s.y, p = a.scrollLeft <= s.x, v = a.scrollTop >= u.y, A = a.scrollLeft >= u.x;
  return {
    isTop: d,
    isLeft: p,
    isBottom: v,
    isRight: A,
    maxScroll: u,
    minScroll: s
  };
}
const defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(a, s, c, u, d) {
  let {
    top: p,
    left: v,
    right: A,
    bottom: x
  } = c;
  u === void 0 && (u = 10), d === void 0 && (d = defaultThreshold);
  const {
    isTop: g,
    isBottom: b,
    isLeft: y,
    isRight: f
  } = getScrollPosition(a), m = {
    x: 0,
    y: 0
  }, C = {
    x: 0,
    y: 0
  }, w = {
    height: s.height * d.y,
    width: s.width * d.x
  };
  return !g && p <= s.top + w.height ? (m.y = Direction.Backward, C.y = u * Math.abs((s.top + w.height - p) / w.height)) : !b && x >= s.bottom - w.height && (m.y = Direction.Forward, C.y = u * Math.abs((s.bottom - w.height - x) / w.height)), !f && A >= s.right - w.width ? (m.x = Direction.Forward, C.x = u * Math.abs((s.right - w.width - A) / w.width)) : !y && v <= s.left + w.width && (m.x = Direction.Backward, C.x = u * Math.abs((s.left + w.width - v) / w.width)), {
    direction: m,
    speed: C
  };
}
function getScrollElementRect(a) {
  if (a === document.scrollingElement) {
    const {
      innerWidth: p,
      innerHeight: v
    } = window;
    return {
      top: 0,
      left: 0,
      right: p,
      bottom: v,
      width: p,
      height: v
    };
  }
  const {
    top: s,
    left: c,
    right: u,
    bottom: d
  } = a.getBoundingClientRect();
  return {
    top: s,
    left: c,
    right: u,
    bottom: d,
    width: a.clientWidth,
    height: a.clientHeight
  };
}
function getScrollOffsets(a) {
  return a.reduce((s, c) => add$1(s, getScrollCoordinates(c)), defaultCoordinates);
}
function getScrollXOffset(a) {
  return a.reduce((s, c) => s + getScrollXCoordinate(c), 0);
}
function getScrollYOffset(a) {
  return a.reduce((s, c) => s + getScrollYCoordinate(c), 0);
}
function scrollIntoViewIfNeeded(a, s) {
  if (s === void 0 && (s = getClientRect$1), !a)
    return;
  const {
    top: c,
    left: u,
    bottom: d,
    right: p
  } = s(a);
  getFirstScrollableAncestor(a) && (d <= 0 || p <= 0 || c >= window.innerHeight || u >= window.innerWidth) && a.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const properties = [["x", ["left", "right"], getScrollXOffset], ["y", ["top", "bottom"], getScrollYOffset]];
class Rect {
  constructor(s, c) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const u = getScrollableAncestors(c), d = getScrollOffsets(u);
    this.rect = {
      ...s
    }, this.width = s.width, this.height = s.height;
    for (const [p, v, A] of properties)
      for (const x of v)
        Object.defineProperty(this, x, {
          get: () => {
            const g = A(u), b = d[p] - g;
            return this.rect[x] + b;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class Listeners {
  constructor(s) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((c) => {
        var u;
        return (u = this.target) == null ? void 0 : u.removeEventListener(...c);
      });
    }, this.target = s;
  }
  add(s, c, u) {
    var d;
    (d = this.target) == null || d.addEventListener(s, c, u), this.listeners.push([s, c, u]);
  }
}
function getEventListenerTarget(a) {
  const {
    EventTarget: s
  } = getWindow$1(a);
  return a instanceof s ? a : getOwnerDocument(a);
}
function hasExceededDistance(a, s) {
  const c = Math.abs(a.x), u = Math.abs(a.y);
  return typeof s == "number" ? Math.sqrt(c ** 2 + u ** 2) > s : "x" in s && "y" in s ? c > s.x && u > s.y : "x" in s ? c > s.x : "y" in s ? u > s.y : !1;
}
var EventName;
(function(a) {
  a.Click = "click", a.DragStart = "dragstart", a.Keydown = "keydown", a.ContextMenu = "contextmenu", a.Resize = "resize", a.SelectionChange = "selectionchange", a.VisibilityChange = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(a) {
  a.preventDefault();
}
function stopPropagation(a) {
  a.stopPropagation();
}
var KeyboardCode;
(function(a) {
  a.Space = "Space", a.Down = "ArrowDown", a.Right = "ArrowRight", a.Left = "ArrowLeft", a.Up = "ArrowUp", a.Esc = "Escape", a.Enter = "Enter", a.Tab = "Tab";
})(KeyboardCode || (KeyboardCode = {}));
const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter, KeyboardCode.Tab]
}, defaultKeyboardCoordinateGetter = (a, s) => {
  let {
    currentCoordinates: c
  } = s;
  switch (a.code) {
    case KeyboardCode.Right:
      return {
        ...c,
        x: c.x + 25
      };
    case KeyboardCode.Left:
      return {
        ...c,
        x: c.x - 25
      };
    case KeyboardCode.Down:
      return {
        ...c,
        y: c.y + 25
      };
    case KeyboardCode.Up:
      return {
        ...c,
        y: c.y - 25
      };
  }
};
class KeyboardSensor {
  constructor(s) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = s;
    const {
      event: {
        target: c
      }
    } = s;
    this.props = s, this.listeners = new Listeners(getOwnerDocument(c)), this.windowListeners = new Listeners(getWindow$1(c)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(EventName.Resize, this.handleCancel), this.windowListeners.add(EventName.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: s,
      onStart: c
    } = this.props, u = s.node.current;
    u && scrollIntoViewIfNeeded(u), c(defaultCoordinates);
  }
  handleKeyDown(s) {
    if (isKeyboardEvent(s)) {
      const {
        active: c,
        context: u,
        options: d
      } = this.props, {
        keyboardCodes: p = defaultKeyboardCodes,
        coordinateGetter: v = defaultKeyboardCoordinateGetter,
        scrollBehavior: A = "smooth"
      } = d, {
        code: x
      } = s;
      if (p.end.includes(x)) {
        this.handleEnd(s);
        return;
      }
      if (p.cancel.includes(x)) {
        this.handleCancel(s);
        return;
      }
      const {
        collisionRect: g
      } = u.current, b = g ? {
        x: g.left,
        y: g.top
      } : defaultCoordinates;
      this.referenceCoordinates || (this.referenceCoordinates = b);
      const y = v(s, {
        active: c,
        context: u.current,
        currentCoordinates: b
      });
      if (y) {
        const f = subtract(y, b), m = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: C
        } = u.current;
        for (const w of C) {
          const S = s.code, {
            isTop: $,
            isRight: T,
            isLeft: I,
            isBottom: _,
            maxScroll: E,
            minScroll: R
          } = getScrollPosition(w), O = getScrollElementRect(w), L = {
            x: Math.min(S === KeyboardCode.Right ? O.right - O.width / 2 : O.right, Math.max(S === KeyboardCode.Right ? O.left : O.left + O.width / 2, y.x)),
            y: Math.min(S === KeyboardCode.Down ? O.bottom - O.height / 2 : O.bottom, Math.max(S === KeyboardCode.Down ? O.top : O.top + O.height / 2, y.y))
          }, B = S === KeyboardCode.Right && !T || S === KeyboardCode.Left && !I, F = S === KeyboardCode.Down && !_ || S === KeyboardCode.Up && !$;
          if (B && L.x !== y.x) {
            const M = w.scrollLeft + f.x, W = S === KeyboardCode.Right && M <= E.x || S === KeyboardCode.Left && M >= R.x;
            if (W && !f.y) {
              w.scrollTo({
                left: M,
                behavior: A
              });
              return;
            }
            W ? m.x = w.scrollLeft - M : m.x = S === KeyboardCode.Right ? w.scrollLeft - E.x : w.scrollLeft - R.x, m.x && w.scrollBy({
              left: -m.x,
              behavior: A
            });
            break;
          } else if (F && L.y !== y.y) {
            const M = w.scrollTop + f.y, W = S === KeyboardCode.Down && M <= E.y || S === KeyboardCode.Up && M >= R.y;
            if (W && !f.x) {
              w.scrollTo({
                top: M,
                behavior: A
              });
              return;
            }
            W ? m.y = w.scrollTop - M : m.y = S === KeyboardCode.Down ? w.scrollTop - E.y : w.scrollTop - R.y, m.y && w.scrollBy({
              top: -m.y,
              behavior: A
            });
            break;
          }
        }
        this.handleMove(s, add$1(subtract(y, this.referenceCoordinates), m));
      }
    }
  }
  handleMove(s, c) {
    const {
      onMove: u
    } = this.props;
    s.preventDefault(), u(c);
  }
  handleEnd(s) {
    const {
      onEnd: c
    } = this.props;
    s.preventDefault(), this.detach(), c();
  }
  handleCancel(s) {
    const {
      onCancel: c
    } = this.props;
    s.preventDefault(), this.detach(), c();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
KeyboardSensor.activators = [{
  eventName: "onKeyDown",
  handler: (a, s, c) => {
    let {
      keyboardCodes: u = defaultKeyboardCodes,
      onActivation: d
    } = s, {
      active: p
    } = c;
    const {
      code: v
    } = a.nativeEvent;
    if (u.start.includes(v)) {
      const A = p.activatorNode.current;
      return A && a.target !== A ? !1 : (a.preventDefault(), d?.({
        event: a.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function isDistanceConstraint(a) {
  return !!(a && "distance" in a);
}
function isDelayConstraint(a) {
  return !!(a && "delay" in a);
}
class AbstractPointerSensor {
  constructor(s, c, u) {
    var d;
    u === void 0 && (u = getEventListenerTarget(s.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = s, this.events = c;
    const {
      event: p
    } = s, {
      target: v
    } = p;
    this.props = s, this.events = c, this.document = getOwnerDocument(v), this.documentListeners = new Listeners(this.document), this.listeners = new Listeners(u), this.windowListeners = new Listeners(getWindow$1(v)), this.initialCoordinates = (d = getEventCoordinates(p)) != null ? d : defaultCoordinates, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: s,
      props: {
        options: {
          activationConstraint: c,
          bypassActivationConstraint: u
        }
      }
    } = this;
    if (this.listeners.add(s.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(s.end.name, this.handleEnd), s.cancel && this.listeners.add(s.cancel.name, this.handleCancel), this.windowListeners.add(EventName.Resize, this.handleCancel), this.windowListeners.add(EventName.DragStart, preventDefault), this.windowListeners.add(EventName.VisibilityChange, this.handleCancel), this.windowListeners.add(EventName.ContextMenu, preventDefault), this.documentListeners.add(EventName.Keydown, this.handleKeydown), c) {
      if (u != null && u({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (isDelayConstraint(c)) {
        this.timeoutId = setTimeout(this.handleStart, c.delay), this.handlePending(c);
        return;
      }
      if (isDistanceConstraint(c)) {
        this.handlePending(c);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(s, c) {
    const {
      active: u,
      onPending: d
    } = this.props;
    d(u, s, this.initialCoordinates, c);
  }
  handleStart() {
    const {
      initialCoordinates: s
    } = this, {
      onStart: c
    } = this.props;
    s && (this.activated = !0, this.documentListeners.add(EventName.Click, stopPropagation, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection), c(s));
  }
  handleMove(s) {
    var c;
    const {
      activated: u,
      initialCoordinates: d,
      props: p
    } = this, {
      onMove: v,
      options: {
        activationConstraint: A
      }
    } = p;
    if (!d)
      return;
    const x = (c = getEventCoordinates(s)) != null ? c : defaultCoordinates, g = subtract(d, x);
    if (!u && A) {
      if (isDistanceConstraint(A)) {
        if (A.tolerance != null && hasExceededDistance(g, A.tolerance))
          return this.handleCancel();
        if (hasExceededDistance(g, A.distance))
          return this.handleStart();
      }
      if (isDelayConstraint(A) && hasExceededDistance(g, A.tolerance))
        return this.handleCancel();
      this.handlePending(A, g);
      return;
    }
    s.cancelable && s.preventDefault(), v(x);
  }
  handleEnd() {
    const {
      onAbort: s,
      onEnd: c
    } = this.props;
    this.detach(), this.activated || s(this.props.active), c();
  }
  handleCancel() {
    const {
      onAbort: s,
      onCancel: c
    } = this.props;
    this.detach(), this.activated || s(this.props.active), c();
  }
  handleKeydown(s) {
    s.code === KeyboardCode.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var s;
    (s = this.document.getSelection()) == null || s.removeAllRanges();
  }
}
const events = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class PointerSensor extends AbstractPointerSensor {
  constructor(s) {
    const {
      event: c
    } = s, u = getOwnerDocument(c.target);
    super(s, events, u);
  }
}
PointerSensor.activators = [{
  eventName: "onPointerDown",
  handler: (a, s) => {
    let {
      nativeEvent: c
    } = a, {
      onActivation: u
    } = s;
    return !c.isPrimary || c.button !== 0 ? !1 : (u?.({
      event: c
    }), !0);
  }
}];
const events$1 = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var MouseButton;
(function(a) {
  a[a.RightClick = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
class MouseSensor extends AbstractPointerSensor {
  constructor(s) {
    super(s, events$1, getOwnerDocument(s.event.target));
  }
}
MouseSensor.activators = [{
  eventName: "onMouseDown",
  handler: (a, s) => {
    let {
      nativeEvent: c
    } = a, {
      onActivation: u
    } = s;
    return c.button === MouseButton.RightClick ? !1 : (u?.({
      event: c
    }), !0);
  }
}];
const events$2 = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class TouchSensor extends AbstractPointerSensor {
  constructor(s) {
    super(s, events$2);
  }
  static setup() {
    return window.addEventListener(events$2.move.name, s, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(events$2.move.name, s);
    };
    function s() {
    }
  }
}
TouchSensor.activators = [{
  eventName: "onTouchStart",
  handler: (a, s) => {
    let {
      nativeEvent: c
    } = a, {
      onActivation: u
    } = s;
    const {
      touches: d
    } = c;
    return d.length > 1 ? !1 : (u?.({
      event: c
    }), !0);
  }
}];
var AutoScrollActivator;
(function(a) {
  a[a.Pointer = 0] = "Pointer", a[a.DraggableRect = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(a) {
  a[a.TreeOrder = 0] = "TreeOrder", a[a.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(a) {
  let {
    acceleration: s,
    activator: c = AutoScrollActivator.Pointer,
    canScroll: u,
    draggingRect: d,
    enabled: p,
    interval: v = 5,
    order: A = TraversalOrder.TreeOrder,
    pointerCoordinates: x,
    scrollableAncestors: g,
    scrollableAncestorRects: b,
    delta: y,
    threshold: f
  } = a;
  const m = useScrollIntent({
    delta: y,
    disabled: !p
  }), [C, w] = useInterval(), S = reactExports.useRef({
    x: 0,
    y: 0
  }), $ = reactExports.useRef({
    x: 0,
    y: 0
  }), T = reactExports.useMemo(() => {
    switch (c) {
      case AutoScrollActivator.Pointer:
        return x ? {
          top: x.y,
          bottom: x.y,
          left: x.x,
          right: x.x
        } : null;
      case AutoScrollActivator.DraggableRect:
        return d;
    }
  }, [c, d, x]), I = reactExports.useRef(null), _ = reactExports.useCallback(() => {
    const R = I.current;
    if (!R)
      return;
    const O = S.current.x * $.current.x, L = S.current.y * $.current.y;
    R.scrollBy(O, L);
  }, []), E = reactExports.useMemo(() => A === TraversalOrder.TreeOrder ? [...g].reverse() : g, [A, g]);
  reactExports.useEffect(
    () => {
      if (!p || !g.length || !T) {
        w();
        return;
      }
      for (const R of E) {
        if (u?.(R) === !1)
          continue;
        const O = g.indexOf(R), L = b[O];
        if (!L)
          continue;
        const {
          direction: B,
          speed: F
        } = getScrollDirectionAndSpeed(R, L, T, s, f);
        for (const M of ["x", "y"])
          m[M][B[M]] || (F[M] = 0, B[M] = 0);
        if (F.x > 0 || F.y > 0) {
          w(), I.current = R, C(_, v), S.current = F, $.current = B;
          return;
        }
      }
      S.current = {
        x: 0,
        y: 0
      }, $.current = {
        x: 0,
        y: 0
      }, w();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      s,
      _,
      u,
      w,
      p,
      v,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(T),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(m),
      C,
      g,
      E,
      b,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(f)
    ]
  );
}
const defaultScrollIntent = {
  x: {
    [Direction.Backward]: !1,
    [Direction.Forward]: !1
  },
  y: {
    [Direction.Backward]: !1,
    [Direction.Forward]: !1
  }
};
function useScrollIntent(a) {
  let {
    delta: s,
    disabled: c
  } = a;
  const u = usePrevious$2(s);
  return useLazyMemo((d) => {
    if (c || !u || !d)
      return defaultScrollIntent;
    const p = {
      x: Math.sign(s.x - u.x),
      y: Math.sign(s.y - u.y)
    };
    return {
      x: {
        [Direction.Backward]: d.x[Direction.Backward] || p.x === -1,
        [Direction.Forward]: d.x[Direction.Forward] || p.x === 1
      },
      y: {
        [Direction.Backward]: d.y[Direction.Backward] || p.y === -1,
        [Direction.Forward]: d.y[Direction.Forward] || p.y === 1
      }
    };
  }, [c, s, u]);
}
function useCachedNode(a, s) {
  const c = s != null ? a.get(s) : void 0, u = c ? c.node.current : null;
  return useLazyMemo((d) => {
    var p;
    return s == null ? null : (p = u ?? d) != null ? p : null;
  }, [u, s]);
}
function useCombineActivators(a, s) {
  return reactExports.useMemo(() => a.reduce((c, u) => {
    const {
      sensor: d
    } = u, p = d.activators.map((v) => ({
      eventName: v.eventName,
      handler: s(v.handler, u)
    }));
    return [...c, ...p];
  }, []), [a, s]);
}
var MeasuringStrategy;
(function(a) {
  a[a.Always = 0] = "Always", a[a.BeforeDragging = 1] = "BeforeDragging", a[a.WhileDragging = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(a) {
  a.Optimized = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
const defaultValue = /* @__PURE__ */ new Map();
function useDroppableMeasuring(a, s) {
  let {
    dragging: c,
    dependencies: u,
    config: d
  } = s;
  const [p, v] = reactExports.useState(null), {
    frequency: A,
    measure: x,
    strategy: g
  } = d, b = reactExports.useRef(a), y = S(), f = useLatestValue(y), m = reactExports.useCallback(function($) {
    $ === void 0 && ($ = []), !f.current && v((T) => T === null ? $ : T.concat($.filter((I) => !T.includes(I))));
  }, [f]), C = reactExports.useRef(null), w = useLazyMemo(($) => {
    if (y && !c)
      return defaultValue;
    if (!$ || $ === defaultValue || b.current !== a || p != null) {
      const T = /* @__PURE__ */ new Map();
      for (let I of a) {
        if (!I)
          continue;
        if (p && p.length > 0 && !p.includes(I.id) && I.rect.current) {
          T.set(I.id, I.rect.current);
          continue;
        }
        const _ = I.node.current, E = _ ? new Rect(x(_), _) : null;
        I.rect.current = E, E && T.set(I.id, E);
      }
      return T;
    }
    return $;
  }, [a, p, c, y, x]);
  return reactExports.useEffect(() => {
    b.current = a;
  }, [a]), reactExports.useEffect(
    () => {
      y || m();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [c, y]
  ), reactExports.useEffect(
    () => {
      p && p.length > 0 && v(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(p)]
  ), reactExports.useEffect(
    () => {
      y || typeof A != "number" || C.current !== null || (C.current = setTimeout(() => {
        m(), C.current = null;
      }, A));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [A, y, m, ...u]
  ), {
    droppableRects: w,
    measureDroppableContainers: m,
    measuringScheduled: p != null
  };
  function S() {
    switch (g) {
      case MeasuringStrategy.Always:
        return !1;
      case MeasuringStrategy.BeforeDragging:
        return c;
      default:
        return !c;
    }
  }
}
function useInitialValue(a, s) {
  return useLazyMemo((c) => a ? c || (typeof s == "function" ? s(a) : a) : null, [s, a]);
}
function useInitialRect(a, s) {
  return useInitialValue(a, s);
}
function useMutationObserver(a) {
  let {
    callback: s,
    disabled: c
  } = a;
  const u = useEvent$1(s), d = reactExports.useMemo(() => {
    if (c || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: p
    } = window;
    return new p(u);
  }, [u, c]);
  return reactExports.useEffect(() => () => d?.disconnect(), [d]), d;
}
function useResizeObserver(a) {
  let {
    callback: s,
    disabled: c
  } = a;
  const u = useEvent$1(s), d = reactExports.useMemo(
    () => {
      if (c || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: p
      } = window;
      return new p(u);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [c]
  );
  return reactExports.useEffect(() => () => d?.disconnect(), [d]), d;
}
function defaultMeasure(a) {
  return new Rect(getClientRect$1(a), a);
}
function useRect(a, s, c) {
  s === void 0 && (s = defaultMeasure);
  const [u, d] = reactExports.useState(null);
  function p() {
    d((x) => {
      if (!a)
        return null;
      if (a.isConnected === !1) {
        var g;
        return (g = x ?? c) != null ? g : null;
      }
      const b = s(a);
      return JSON.stringify(x) === JSON.stringify(b) ? x : b;
    });
  }
  const v = useMutationObserver({
    callback(x) {
      if (a)
        for (const g of x) {
          const {
            type: b,
            target: y
          } = g;
          if (b === "childList" && y instanceof HTMLElement && y.contains(a)) {
            p();
            break;
          }
        }
    }
  }), A = useResizeObserver({
    callback: p
  });
  return useIsomorphicLayoutEffect$1(() => {
    p(), a ? (A?.observe(a), v?.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (A?.disconnect(), v?.disconnect());
  }, [a]), u;
}
function useRectDelta(a) {
  const s = useInitialValue(a);
  return getRectDelta(a, s);
}
const defaultValue$1 = [];
function useScrollableAncestors(a) {
  const s = reactExports.useRef(a), c = useLazyMemo((u) => a ? u && u !== defaultValue$1 && a && s.current && a.parentNode === s.current.parentNode ? u : getScrollableAncestors(a) : defaultValue$1, [a]);
  return reactExports.useEffect(() => {
    s.current = a;
  }, [a]), c;
}
function useScrollOffsets(a) {
  const [s, c] = reactExports.useState(null), u = reactExports.useRef(a), d = reactExports.useCallback((p) => {
    const v = getScrollableElement(p.target);
    v && c((A) => A ? (A.set(v, getScrollCoordinates(v)), new Map(A)) : null);
  }, []);
  return reactExports.useEffect(() => {
    const p = u.current;
    if (a !== p) {
      v(p);
      const A = a.map((x) => {
        const g = getScrollableElement(x);
        return g ? (g.addEventListener("scroll", d, {
          passive: !0
        }), [g, getScrollCoordinates(g)]) : null;
      }).filter((x) => x != null);
      c(A.length ? new Map(A) : null), u.current = a;
    }
    return () => {
      v(a), v(p);
    };
    function v(A) {
      A.forEach((x) => {
        const g = getScrollableElement(x);
        g?.removeEventListener("scroll", d);
      });
    }
  }, [d, a]), reactExports.useMemo(() => a.length ? s ? Array.from(s.values()).reduce((p, v) => add$1(p, v), defaultCoordinates) : getScrollOffsets(a) : defaultCoordinates, [a, s]);
}
function useScrollOffsetsDelta(a, s) {
  s === void 0 && (s = []);
  const c = reactExports.useRef(null);
  return reactExports.useEffect(
    () => {
      c.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    s
  ), reactExports.useEffect(() => {
    const u = a !== defaultCoordinates;
    u && !c.current && (c.current = a), !u && c.current && (c.current = null);
  }, [a]), c.current ? subtract(a, c.current) : defaultCoordinates;
}
function useSensorSetup(a) {
  reactExports.useEffect(
    () => {
      if (!canUseDOM)
        return;
      const s = a.map((c) => {
        let {
          sensor: u
        } = c;
        return u.setup == null ? void 0 : u.setup();
      });
      return () => {
        for (const c of s)
          c?.();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    a.map((s) => {
      let {
        sensor: c
      } = s;
      return c;
    })
  );
}
function useSyntheticListeners(a, s) {
  return reactExports.useMemo(() => a.reduce((c, u) => {
    let {
      eventName: d,
      handler: p
    } = u;
    return c[d] = (v) => {
      p(v, s);
    }, c;
  }, {}), [a, s]);
}
function useWindowRect(a) {
  return reactExports.useMemo(() => a ? getWindowClientRect(a) : null, [a]);
}
const defaultValue$2 = [];
function useRects(a, s) {
  s === void 0 && (s = getClientRect$1);
  const [c] = a, u = useWindowRect(c ? getWindow$1(c) : null), [d, p] = reactExports.useState(defaultValue$2);
  function v() {
    p(() => a.length ? a.map((x) => isDocumentScrollingElement(x) ? u : new Rect(s(x), x)) : defaultValue$2);
  }
  const A = useResizeObserver({
    callback: v
  });
  return useIsomorphicLayoutEffect$1(() => {
    A?.disconnect(), v(), a.forEach((x) => A?.observe(x));
  }, [a]), d;
}
function getMeasurableNode(a) {
  if (!a)
    return null;
  if (a.children.length > 1)
    return a;
  const s = a.children[0];
  return isHTMLElement(s) ? s : a;
}
function useDragOverlayMeasuring(a) {
  let {
    measure: s
  } = a;
  const [c, u] = reactExports.useState(null), d = reactExports.useCallback((g) => {
    for (const {
      target: b
    } of g)
      if (isHTMLElement(b)) {
        u((y) => {
          const f = s(b);
          return y ? {
            ...y,
            width: f.width,
            height: f.height
          } : f;
        });
        break;
      }
  }, [s]), p = useResizeObserver({
    callback: d
  }), v = reactExports.useCallback((g) => {
    const b = getMeasurableNode(g);
    p?.disconnect(), b && p?.observe(b), u(b ? s(b) : null);
  }, [s, p]), [A, x] = useNodeRef(v);
  return reactExports.useMemo(() => ({
    nodeRef: A,
    rect: c,
    setRef: x
  }), [c, A, x]);
}
const defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}], defaultData = {
  current: {}
}, defaultMeasuringConfiguration = {
  draggable: {
    measure: getTransformAgnosticClientRect
  },
  droppable: {
    measure: getTransformAgnosticClientRect,
    strategy: MeasuringStrategy.WhileDragging,
    frequency: MeasuringFrequency.Optimized
  },
  dragOverlay: {
    measure: getClientRect$1
  }
};
class DroppableContainersMap extends Map {
  get(s) {
    var c;
    return s != null && (c = super.get(s)) != null ? c : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((s) => {
      let {
        disabled: c
      } = s;
      return !c;
    });
  }
  getNodeFor(s) {
    var c, u;
    return (c = (u = this.get(s)) == null ? void 0 : u.node.current) != null ? c : void 0;
  }
}
const defaultPublicContext = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new DroppableContainersMap(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: noop$6
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: defaultMeasuringConfiguration,
  measureDroppableContainers: noop$6,
  windowRect: null,
  measuringScheduled: !1
}, defaultInternalContext = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: noop$6,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: noop$6
}, InternalContext = /* @__PURE__ */ reactExports.createContext(defaultInternalContext), PublicContext = /* @__PURE__ */ reactExports.createContext(defaultPublicContext);
function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new DroppableContainersMap()
    }
  };
}
function reducer(a, s) {
  switch (s.type) {
    case Action.DragStart:
      return {
        ...a,
        draggable: {
          ...a.draggable,
          initialCoordinates: s.initialCoordinates,
          active: s.active
        }
      };
    case Action.DragMove:
      return a.draggable.active == null ? a : {
        ...a,
        draggable: {
          ...a.draggable,
          translate: {
            x: s.coordinates.x - a.draggable.initialCoordinates.x,
            y: s.coordinates.y - a.draggable.initialCoordinates.y
          }
        }
      };
    case Action.DragEnd:
    case Action.DragCancel:
      return {
        ...a,
        draggable: {
          ...a.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Action.RegisterDroppable: {
      const {
        element: c
      } = s, {
        id: u
      } = c, d = new DroppableContainersMap(a.droppable.containers);
      return d.set(u, c), {
        ...a,
        droppable: {
          ...a.droppable,
          containers: d
        }
      };
    }
    case Action.SetDroppableDisabled: {
      const {
        id: c,
        key: u,
        disabled: d
      } = s, p = a.droppable.containers.get(c);
      if (!p || u !== p.key)
        return a;
      const v = new DroppableContainersMap(a.droppable.containers);
      return v.set(c, {
        ...p,
        disabled: d
      }), {
        ...a,
        droppable: {
          ...a.droppable,
          containers: v
        }
      };
    }
    case Action.UnregisterDroppable: {
      const {
        id: c,
        key: u
      } = s, d = a.droppable.containers.get(c);
      if (!d || u !== d.key)
        return a;
      const p = new DroppableContainersMap(a.droppable.containers);
      return p.delete(c), {
        ...a,
        droppable: {
          ...a.droppable,
          containers: p
        }
      };
    }
    default:
      return a;
  }
}
function RestoreFocus(a) {
  let {
    disabled: s
  } = a;
  const {
    active: c,
    activatorEvent: u,
    draggableNodes: d
  } = reactExports.useContext(InternalContext), p = usePrevious$2(u), v = usePrevious$2(c?.id);
  return reactExports.useEffect(() => {
    if (!s && !u && p && v != null) {
      if (!isKeyboardEvent(p) || document.activeElement === p.target)
        return;
      const A = d.get(v);
      if (!A)
        return;
      const {
        activatorNode: x,
        node: g
      } = A;
      if (!x.current && !g.current)
        return;
      requestAnimationFrame(() => {
        for (const b of [x.current, g.current]) {
          if (!b)
            continue;
          const y = findFirstFocusableNode(b);
          if (y) {
            y.focus();
            break;
          }
        }
      });
    }
  }, [u, s, d, v, p]), null;
}
function applyModifiers(a, s) {
  let {
    transform: c,
    ...u
  } = s;
  return a != null && a.length ? a.reduce((d, p) => p({
    transform: d,
    ...u
  }), c) : c;
}
function useMeasuringConfiguration(a) {
  return reactExports.useMemo(
    () => ({
      draggable: {
        ...defaultMeasuringConfiguration.draggable,
        ...a?.draggable
      },
      droppable: {
        ...defaultMeasuringConfiguration.droppable,
        ...a?.droppable
      },
      dragOverlay: {
        ...defaultMeasuringConfiguration.dragOverlay,
        ...a?.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a?.draggable, a?.droppable, a?.dragOverlay]
  );
}
function useLayoutShiftScrollCompensation(a) {
  let {
    activeNode: s,
    measure: c,
    initialRect: u,
    config: d = !0
  } = a;
  const p = reactExports.useRef(!1), {
    x: v,
    y: A
  } = typeof d == "boolean" ? {
    x: d,
    y: d
  } : d;
  useIsomorphicLayoutEffect$1(() => {
    if (!v && !A || !s) {
      p.current = !1;
      return;
    }
    if (p.current || !u)
      return;
    const g = s?.node.current;
    if (!g || g.isConnected === !1)
      return;
    const b = c(g), y = getRectDelta(b, u);
    if (v || (y.x = 0), A || (y.y = 0), p.current = !0, Math.abs(y.x) > 0 || Math.abs(y.y) > 0) {
      const f = getFirstScrollableAncestor(g);
      f && f.scrollBy({
        top: y.y,
        left: y.x
      });
    }
  }, [s, v, A, u, c]);
}
const ActiveDraggableContext = /* @__PURE__ */ reactExports.createContext({
  ...defaultCoordinates,
  scaleX: 1,
  scaleY: 1
});
var Status;
(function(a) {
  a[a.Uninitialized = 0] = "Uninitialized", a[a.Initializing = 1] = "Initializing", a[a.Initialized = 2] = "Initialized";
})(Status || (Status = {}));
const DndContext = /* @__PURE__ */ reactExports.memo(function a(s) {
  var c, u, d, p;
  let {
    id: v,
    accessibility: A,
    autoScroll: x = !0,
    children: g,
    sensors: b = defaultSensors,
    collisionDetection: y = rectIntersection,
    measuring: f,
    modifiers: m,
    ...C
  } = s;
  const w = reactExports.useReducer(reducer, void 0, getInitialState), [S, $] = w, [T, I] = useDndMonitorProvider(), [_, E] = reactExports.useState(Status.Uninitialized), R = _ === Status.Initialized, {
    draggable: {
      active: O,
      nodes: L,
      translate: B
    },
    droppable: {
      containers: F
    }
  } = S, M = O != null ? L.get(O) : null, W = reactExports.useRef({
    initial: null,
    translated: null
  }), j = reactExports.useMemo(() => {
    var De;
    return O != null ? {
      id: O,
      // It's possible for the active node to unmount while dragging
      data: (De = M?.data) != null ? De : defaultData,
      rect: W
    } : null;
  }, [O, M]), G = reactExports.useRef(null), [U, k] = reactExports.useState(null), [N, P] = reactExports.useState(null), D = useLatestValue(C, Object.values(C)), H = useUniqueId("DndDescribedBy", v), V = reactExports.useMemo(() => F.getEnabled(), [F]), Z = useMeasuringConfiguration(f), {
    droppableRects: ne,
    measureDroppableContainers: K,
    measuringScheduled: q
  } = useDroppableMeasuring(V, {
    dragging: R,
    dependencies: [B.x, B.y],
    config: Z.droppable
  }), Y = useCachedNode(L, O), ee = reactExports.useMemo(() => N ? getEventCoordinates(N) : null, [N]), Q = Le(), J = useInitialRect(Y, Z.draggable.measure);
  useLayoutShiftScrollCompensation({
    activeNode: O != null ? L.get(O) : null,
    config: Q.layoutShiftCompensation,
    initialRect: J,
    measure: Z.draggable.measure
  });
  const te = useRect(Y, Z.draggable.measure, J), ae = useRect(Y ? Y.parentElement : null), se = reactExports.useRef({
    activatorEvent: null,
    active: null,
    activeNode: Y,
    collisionRect: null,
    collisions: null,
    droppableRects: ne,
    draggableNodes: L,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: F,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), ie = F.getNodeFor((c = se.current.over) == null ? void 0 : c.id), fe = useDragOverlayMeasuring({
    measure: Z.dragOverlay.measure
  }), ge = (u = fe.nodeRef.current) != null ? u : Y, me = R ? (d = fe.rect) != null ? d : te : null, pe = !!(fe.nodeRef.current && fe.rect), be = useRectDelta(pe ? null : te), le = useWindowRect(ge ? getWindow$1(ge) : null), ve = useScrollableAncestors(R ? ie ?? Y : null), he = useRects(ve), ye = applyModifiers(m, {
    transform: {
      x: B.x - be.x,
      y: B.y - be.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: N,
    active: j,
    activeNodeRect: te,
    containerNodeRect: ae,
    draggingNodeRect: me,
    over: se.current.over,
    overlayNodeRect: fe.rect,
    scrollableAncestors: ve,
    scrollableAncestorRects: he,
    windowRect: le
  }), Ce = ee ? add$1(ee, B) : null, xe = useScrollOffsets(ve), we = useScrollOffsetsDelta(xe), $e = useScrollOffsetsDelta(xe, [te]), Ae = add$1(ye, we), ue = me ? getAdjustedRect(me, ye) : null, ce = j && ue ? y({
    active: j,
    collisionRect: ue,
    droppableRects: ne,
    droppableContainers: V,
    pointerCoordinates: Ce
  }) : null, Ee = getFirstCollision(ce, "id"), [_e, Te] = reactExports.useState(null), ke = pe ? ye : add$1(ye, $e), Re = adjustScale(ke, (p = _e?.rect) != null ? p : null, te), Be = reactExports.useRef(null), Oe = reactExports.useCallback(
    (De, Ne) => {
      let {
        sensor: Ge,
        options: Xe
      } = Ne;
      if (G.current == null)
        return;
      const nt = L.get(G.current);
      if (!nt)
        return;
      const ct = De.nativeEvent, it = new Ge({
        active: G.current,
        activeNode: nt,
        event: ct,
        options: Xe,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: se,
        onAbort(Ve) {
          if (!L.get(Ve))
            return;
          const {
            onDragAbort: at
          } = D.current, Qe = {
            id: Ve
          };
          at?.(Qe), T({
            type: "onDragAbort",
            event: Qe
          });
        },
        onPending(Ve, ut, at, Qe) {
          if (!L.get(Ve))
            return;
          const {
            onDragPending: ft
          } = D.current, vt = {
            id: Ve,
            constraint: ut,
            initialCoordinates: at,
            offset: Qe
          };
          ft?.(vt), T({
            type: "onDragPending",
            event: vt
          });
        },
        onStart(Ve) {
          const ut = G.current;
          if (ut == null)
            return;
          const at = L.get(ut);
          if (!at)
            return;
          const {
            onDragStart: Qe
          } = D.current, st = {
            activatorEvent: ct,
            active: {
              id: ut,
              data: at.data,
              rect: W
            }
          };
          reactDomExports.unstable_batchedUpdates(() => {
            Qe?.(st), E(Status.Initializing), $({
              type: Action.DragStart,
              initialCoordinates: Ve,
              active: ut
            }), T({
              type: "onDragStart",
              event: st
            }), k(Be.current), P(ct);
          });
        },
        onMove(Ve) {
          $({
            type: Action.DragMove,
            coordinates: Ve
          });
        },
        onEnd: We(Action.DragEnd),
        onCancel: We(Action.DragCancel)
      });
      Be.current = it;
      function We(Ve) {
        return async function() {
          const {
            active: at,
            collisions: Qe,
            over: st,
            scrollAdjustedTranslate: ft
          } = se.current;
          let vt = null;
          if (at && ft) {
            const {
              cancelDrop: Pt
            } = D.current;
            vt = {
              activatorEvent: ct,
              active: at,
              collisions: Qe,
              delta: ft,
              over: st
            }, Ve === Action.DragEnd && typeof Pt == "function" && await Promise.resolve(Pt(vt)) && (Ve = Action.DragCancel);
          }
          G.current = null, reactDomExports.unstable_batchedUpdates(() => {
            $({
              type: Ve
            }), E(Status.Uninitialized), Te(null), k(null), P(null), Be.current = null;
            const Pt = Ve === Action.DragEnd ? "onDragEnd" : "onDragCancel";
            if (vt) {
              const dt = D.current[Pt];
              dt?.(vt), T({
                type: Pt,
                event: vt
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [L]
  ), Me = reactExports.useCallback((De, Ne) => (Ge, Xe) => {
    const nt = Ge.nativeEvent, ct = L.get(Xe);
    if (
      // Another sensor is already instantiating
      G.current !== null || // No active draggable
      !ct || // Event has already been captured
      nt.dndKit || nt.defaultPrevented
    )
      return;
    const it = {
      active: ct
    };
    De(Ge, Ne.options, it) === !0 && (nt.dndKit = {
      capturedBy: Ne.sensor
    }, G.current = Xe, Oe(Ge, Ne));
  }, [L, Oe]), Fe = useCombineActivators(b, Me);
  useSensorSetup(b), useIsomorphicLayoutEffect$1(() => {
    te && _ === Status.Initializing && E(Status.Initialized);
  }, [te, _]), reactExports.useEffect(
    () => {
      const {
        onDragMove: De
      } = D.current, {
        active: Ne,
        activatorEvent: Ge,
        collisions: Xe,
        over: nt
      } = se.current;
      if (!Ne || !Ge)
        return;
      const ct = {
        active: Ne,
        activatorEvent: Ge,
        collisions: Xe,
        delta: {
          x: Ae.x,
          y: Ae.y
        },
        over: nt
      };
      reactDomExports.unstable_batchedUpdates(() => {
        De?.(ct), T({
          type: "onDragMove",
          event: ct
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Ae.x, Ae.y]
  ), reactExports.useEffect(
    () => {
      const {
        active: De,
        activatorEvent: Ne,
        collisions: Ge,
        droppableContainers: Xe,
        scrollAdjustedTranslate: nt
      } = se.current;
      if (!De || G.current == null || !Ne || !nt)
        return;
      const {
        onDragOver: ct
      } = D.current, it = Xe.get(Ee), We = it && it.rect.current ? {
        id: it.id,
        rect: it.rect.current,
        data: it.data,
        disabled: it.disabled
      } : null, Ve = {
        active: De,
        activatorEvent: Ne,
        collisions: Ge,
        delta: {
          x: nt.x,
          y: nt.y
        },
        over: We
      };
      reactDomExports.unstable_batchedUpdates(() => {
        Te(We), ct?.(Ve), T({
          type: "onDragOver",
          event: Ve
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Ee]
  ), useIsomorphicLayoutEffect$1(() => {
    se.current = {
      activatorEvent: N,
      active: j,
      activeNode: Y,
      collisionRect: ue,
      collisions: ce,
      droppableRects: ne,
      draggableNodes: L,
      draggingNode: ge,
      draggingNodeRect: me,
      droppableContainers: F,
      over: _e,
      scrollableAncestors: ve,
      scrollAdjustedTranslate: Ae
    }, W.current = {
      initial: me,
      translated: ue
    };
  }, [j, Y, ce, ue, L, ge, me, ne, F, _e, ve, Ae]), useAutoScroller({
    ...Q,
    delta: B,
    draggingRect: ue,
    pointerCoordinates: Ce,
    scrollableAncestors: ve,
    scrollableAncestorRects: he
  });
  const Ue = reactExports.useMemo(() => ({
    active: j,
    activeNode: Y,
    activeNodeRect: te,
    activatorEvent: N,
    collisions: ce,
    containerNodeRect: ae,
    dragOverlay: fe,
    draggableNodes: L,
    droppableContainers: F,
    droppableRects: ne,
    over: _e,
    measureDroppableContainers: K,
    scrollableAncestors: ve,
    scrollableAncestorRects: he,
    measuringConfiguration: Z,
    measuringScheduled: q,
    windowRect: le
  }), [j, Y, te, N, ce, ae, fe, L, F, ne, _e, K, ve, he, Z, q, le]), je = reactExports.useMemo(() => ({
    activatorEvent: N,
    activators: Fe,
    active: j,
    activeNodeRect: te,
    ariaDescribedById: {
      draggable: H
    },
    dispatch: $,
    draggableNodes: L,
    over: _e,
    measureDroppableContainers: K
  }), [N, Fe, j, te, $, H, L, _e, K]);
  return React.createElement(DndMonitorContext.Provider, {
    value: I
  }, React.createElement(InternalContext.Provider, {
    value: je
  }, React.createElement(PublicContext.Provider, {
    value: Ue
  }, React.createElement(ActiveDraggableContext.Provider, {
    value: Re
  }, g)), React.createElement(RestoreFocus, {
    disabled: A?.restoreFocus === !1
  })), React.createElement(Accessibility, {
    ...A,
    hiddenTextDescribedById: H
  }));
  function Le() {
    const De = U?.autoScrollEnabled === !1, Ne = typeof x == "object" ? x.enabled === !1 : x === !1, Ge = R && !De && !Ne;
    return typeof x == "object" ? {
      ...x,
      enabled: Ge
    } : {
      enabled: Ge
    };
  }
}), NullContext = /* @__PURE__ */ reactExports.createContext(null), defaultRole = "button", ID_PREFIX$1 = "Draggable";
function useDraggable(a) {
  let {
    id: s,
    data: c,
    disabled: u = !1,
    attributes: d
  } = a;
  const p = useUniqueId(ID_PREFIX$1), {
    activators: v,
    activatorEvent: A,
    active: x,
    activeNodeRect: g,
    ariaDescribedById: b,
    draggableNodes: y,
    over: f
  } = reactExports.useContext(InternalContext), {
    role: m = defaultRole,
    roleDescription: C = "draggable",
    tabIndex: w = 0
  } = d ?? {}, S = x?.id === s, $ = reactExports.useContext(S ? ActiveDraggableContext : NullContext), [T, I] = useNodeRef(), [_, E] = useNodeRef(), R = useSyntheticListeners(v, s), O = useLatestValue(c);
  useIsomorphicLayoutEffect$1(
    () => (y.set(s, {
      id: s,
      key: p,
      node: T,
      activatorNode: _,
      data: O
    }), () => {
      const B = y.get(s);
      B && B.key === p && y.delete(s);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y, s]
  );
  const L = reactExports.useMemo(() => ({
    role: m,
    tabIndex: w,
    "aria-disabled": u,
    "aria-pressed": S && m === defaultRole ? !0 : void 0,
    "aria-roledescription": C,
    "aria-describedby": b.draggable
  }), [u, m, w, S, C, b.draggable]);
  return {
    active: x,
    activatorEvent: A,
    activeNodeRect: g,
    attributes: L,
    isDragging: S,
    listeners: u ? void 0 : R,
    node: T,
    over: f,
    setNodeRef: I,
    setActivatorNodeRef: E,
    transform: $
  };
}
function useDndContext() {
  return reactExports.useContext(PublicContext);
}
const ID_PREFIX$1$1 = "Droppable", defaultResizeObserverConfig = {
  timeout: 25
};
function useDroppable(a) {
  let {
    data: s,
    disabled: c = !1,
    id: u,
    resizeObserverConfig: d
  } = a;
  const p = useUniqueId(ID_PREFIX$1$1), {
    active: v,
    dispatch: A,
    over: x,
    measureDroppableContainers: g
  } = reactExports.useContext(InternalContext), b = reactExports.useRef({
    disabled: c
  }), y = reactExports.useRef(!1), f = reactExports.useRef(null), m = reactExports.useRef(null), {
    disabled: C,
    updateMeasurementsFor: w,
    timeout: S
  } = {
    ...defaultResizeObserverConfig,
    ...d
  }, $ = useLatestValue(w ?? u), T = reactExports.useCallback(
    () => {
      if (!y.current) {
        y.current = !0;
        return;
      }
      m.current != null && clearTimeout(m.current), m.current = setTimeout(() => {
        g(Array.isArray($.current) ? $.current : [$.current]), m.current = null;
      }, S);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [S]
  ), I = useResizeObserver({
    callback: T,
    disabled: C || !v
  }), _ = reactExports.useCallback((L, B) => {
    I && (B && (I.unobserve(B), y.current = !1), L && I.observe(L));
  }, [I]), [E, R] = useNodeRef(_), O = useLatestValue(s);
  return reactExports.useEffect(() => {
    !I || !E.current || (I.disconnect(), y.current = !1, I.observe(E.current));
  }, [E, I]), reactExports.useEffect(
    () => (A({
      type: Action.RegisterDroppable,
      element: {
        id: u,
        key: p,
        disabled: c,
        node: E,
        rect: f,
        data: O
      }
    }), () => A({
      type: Action.UnregisterDroppable,
      key: p,
      id: u
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [u]
  ), reactExports.useEffect(() => {
    c !== b.current.disabled && (A({
      type: Action.SetDroppableDisabled,
      id: u,
      key: p,
      disabled: c
    }), b.current.disabled = c);
  }, [u, p, c, A]), {
    active: v,
    rect: f,
    isOver: x?.id === u,
    node: E,
    over: x,
    setNodeRef: R
  };
}
function AnimationManager(a) {
  let {
    animation: s,
    children: c
  } = a;
  const [u, d] = reactExports.useState(null), [p, v] = reactExports.useState(null), A = usePrevious$2(c);
  return !c && !u && A && d(A), useIsomorphicLayoutEffect$1(() => {
    if (!p)
      return;
    const x = u?.key, g = u?.props.id;
    if (x == null || g == null) {
      d(null);
      return;
    }
    Promise.resolve(s(g, p)).then(() => {
      d(null);
    });
  }, [s, u, p]), React.createElement(React.Fragment, null, c, u ? reactExports.cloneElement(u, {
    ref: v
  }) : null);
}
const defaultTransform = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function NullifiedContextProvider(a) {
  let {
    children: s
  } = a;
  return React.createElement(InternalContext.Provider, {
    value: defaultInternalContext
  }, React.createElement(ActiveDraggableContext.Provider, {
    value: defaultTransform
  }, s));
}
const baseStyles = {
  position: "fixed",
  touchAction: "none"
}, defaultTransition$1 = (a) => isKeyboardEvent(a) ? "transform 250ms ease" : void 0, PositionedOverlay = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  let {
    as: c,
    activatorEvent: u,
    adjustScale: d,
    children: p,
    className: v,
    rect: A,
    style: x,
    transform: g,
    transition: b = defaultTransition$1
  } = a;
  if (!A)
    return null;
  const y = d ? g : {
    ...g,
    scaleX: 1,
    scaleY: 1
  }, f = {
    ...baseStyles,
    width: A.width,
    height: A.height,
    top: A.top,
    left: A.left,
    transform: CSS$1.Transform.toString(y),
    transformOrigin: d && u ? getRelativeTransformOrigin(u, A) : void 0,
    transition: typeof b == "function" ? b(u) : b,
    ...x
  };
  return React.createElement(c, {
    className: v,
    style: f,
    ref: s
  }, p);
}), defaultDropAnimationSideEffects = (a) => (s) => {
  let {
    active: c,
    dragOverlay: u
  } = s;
  const d = {}, {
    styles: p,
    className: v
  } = a;
  if (p != null && p.active)
    for (const [A, x] of Object.entries(p.active))
      x !== void 0 && (d[A] = c.node.style.getPropertyValue(A), c.node.style.setProperty(A, x));
  if (p != null && p.dragOverlay)
    for (const [A, x] of Object.entries(p.dragOverlay))
      x !== void 0 && u.node.style.setProperty(A, x);
  return v != null && v.active && c.node.classList.add(v.active), v != null && v.dragOverlay && u.node.classList.add(v.dragOverlay), function() {
    for (const [x, g] of Object.entries(d))
      c.node.style.setProperty(x, g);
    v != null && v.active && c.node.classList.remove(v.active);
  };
}, defaultKeyframeResolver = (a) => {
  let {
    transform: {
      initial: s,
      final: c
    }
  } = a;
  return [{
    transform: CSS$1.Transform.toString(s)
  }, {
    transform: CSS$1.Transform.toString(c)
  }];
}, defaultDropAnimationConfiguration = {
  duration: 250,
  easing: "ease",
  keyframes: defaultKeyframeResolver,
  sideEffects: /* @__PURE__ */ defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function useDropAnimation(a) {
  let {
    config: s,
    draggableNodes: c,
    droppableContainers: u,
    measuringConfiguration: d
  } = a;
  return useEvent$1((p, v) => {
    if (s === null)
      return;
    const A = c.get(p);
    if (!A)
      return;
    const x = A.node.current;
    if (!x)
      return;
    const g = getMeasurableNode(v);
    if (!g)
      return;
    const {
      transform: b
    } = getWindow$1(v).getComputedStyle(v), y = parseTransform(b);
    if (!y)
      return;
    const f = typeof s == "function" ? s : createDefaultDropAnimation(s);
    return scrollIntoViewIfNeeded(x, d.draggable.measure), f({
      active: {
        id: p,
        data: A.data,
        node: x,
        rect: d.draggable.measure(x)
      },
      draggableNodes: c,
      dragOverlay: {
        node: v,
        rect: d.dragOverlay.measure(g)
      },
      droppableContainers: u,
      measuringConfiguration: d,
      transform: y
    });
  });
}
function createDefaultDropAnimation(a) {
  const {
    duration: s,
    easing: c,
    sideEffects: u,
    keyframes: d
  } = {
    ...defaultDropAnimationConfiguration,
    ...a
  };
  return (p) => {
    let {
      active: v,
      dragOverlay: A,
      transform: x,
      ...g
    } = p;
    if (!s)
      return;
    const b = {
      x: A.rect.left - v.rect.left,
      y: A.rect.top - v.rect.top
    }, y = {
      scaleX: x.scaleX !== 1 ? v.rect.width * x.scaleX / A.rect.width : 1,
      scaleY: x.scaleY !== 1 ? v.rect.height * x.scaleY / A.rect.height : 1
    }, f = {
      x: x.x - b.x,
      y: x.y - b.y,
      ...y
    }, m = d({
      ...g,
      active: v,
      dragOverlay: A,
      transform: {
        initial: x,
        final: f
      }
    }), [C] = m, w = m[m.length - 1];
    if (JSON.stringify(C) === JSON.stringify(w))
      return;
    const S = u?.({
      active: v,
      dragOverlay: A,
      ...g
    }), $ = A.node.animate(m, {
      duration: s,
      easing: c,
      fill: "forwards"
    });
    return new Promise((T) => {
      $.onfinish = () => {
        S?.(), T();
      };
    });
  };
}
let key = 0;
function useKey(a) {
  return reactExports.useMemo(() => {
    if (a != null)
      return key++, key;
  }, [a]);
}
const DragOverlay = /* @__PURE__ */ React.memo((a) => {
  let {
    adjustScale: s = !1,
    children: c,
    dropAnimation: u,
    style: d,
    transition: p,
    modifiers: v,
    wrapperElement: A = "div",
    className: x,
    zIndex: g = 999
  } = a;
  const {
    activatorEvent: b,
    active: y,
    activeNodeRect: f,
    containerNodeRect: m,
    draggableNodes: C,
    droppableContainers: w,
    dragOverlay: S,
    over: $,
    measuringConfiguration: T,
    scrollableAncestors: I,
    scrollableAncestorRects: _,
    windowRect: E
  } = useDndContext(), R = reactExports.useContext(ActiveDraggableContext), O = useKey(y?.id), L = applyModifiers(v, {
    activatorEvent: b,
    active: y,
    activeNodeRect: f,
    containerNodeRect: m,
    draggingNodeRect: S.rect,
    over: $,
    overlayNodeRect: S.rect,
    scrollableAncestors: I,
    scrollableAncestorRects: _,
    transform: R,
    windowRect: E
  }), B = useInitialValue(f), F = useDropAnimation({
    config: u,
    draggableNodes: C,
    droppableContainers: w,
    measuringConfiguration: T
  }), M = B ? S.setRef : void 0;
  return React.createElement(NullifiedContextProvider, null, React.createElement(AnimationManager, {
    animation: F
  }, y && O ? React.createElement(PositionedOverlay, {
    key: O,
    id: y.id,
    ref: M,
    as: A,
    activatorEvent: b,
    adjustScale: s,
    className: x,
    transition: p,
    rect: B,
    style: {
      zIndex: g,
      ...d
    },
    transform: L
  }, c) : null));
});
var classnames$1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, function(a) {
    (function() {
      var s = {}.hasOwnProperty;
      function c() {
        for (var p = "", v = 0; v < arguments.length; v++) {
          var A = arguments[v];
          A && (p = d(p, u(A)));
        }
        return p;
      }
      function u(p) {
        if (typeof p == "string" || typeof p == "number")
          return p;
        if (typeof p != "object")
          return "";
        if (Array.isArray(p))
          return c.apply(null, p);
        if (p.toString !== Object.prototype.toString && !p.toString.toString().includes("[native code]"))
          return p.toString();
        var v = "";
        for (var A in p)
          s.call(p, A) && p[A] && (v = d(v, A));
        return v;
      }
      function d(p, v) {
        return v ? p ? p + " " + v : p + v : p;
      }
      a.exports ? (c.default = c, a.exports = c) : window.classNames = c;
    })();
  }(classnames$1)), classnames$1.exports;
}
var classnamesExports = requireClassnames();
const classnames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(a) {
    for (var s = 1; s < arguments.length; s++) {
      var c = arguments[s];
      for (var u in c) ({}).hasOwnProperty.call(c, u) && (a[u] = c[u]);
    }
    return a;
  }, _extends$3.apply(null, arguments);
}
function _typeof$h(a) {
  "@babel/helpers - typeof";
  return _typeof$h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$h(a);
}
var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function isFragment$1(a) {
  return (
    // Base object type
    a && _typeof$h(a) === "object" && // React Element type
    (a.$$typeof === REACT_ELEMENT_TYPE_18 || a.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    a.type === REACT_FRAGMENT_TYPE
  );
}
function toArray$8(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = [];
  return React.Children.forEach(a, function(u) {
    u == null && !s.keepEmpty || (Array.isArray(u) ? c = c.concat(toArray$8(u)) : isFragment$1(u) && u.props ? c = c.concat(toArray$8(u.props.children, s)) : c.push(u));
  }), c;
}
var warned = {}, preMessage = function a(s) {
};
function warning$3(a, s) {
}
function note(a, s) {
}
function resetWarned() {
  warned = {};
}
function call(a, s, c) {
  !s && !warned[c] && (a(!1, c), warned[c] = !0);
}
function warningOnce(a, s) {
  call(warning$3, a, s);
}
function noteOnce(a, s) {
  call(note, a, s);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
function toPrimitive$1(a, s) {
  if (_typeof$h(a) != "object" || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof$h(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function toPropertyKey$1(a) {
  var s = toPrimitive$1(a, "string");
  return _typeof$h(s) == "symbol" ? s : s + "";
}
function _defineProperty$a(a, s, c) {
  return (s = toPropertyKey$1(s)) in a ? Object.defineProperty(a, s, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[s] = c, a;
}
function ownKeys$2(a, s) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(a);
    s && (u = u.filter(function(d) {
      return Object.getOwnPropertyDescriptor(a, d).enumerable;
    })), c.push.apply(c, u);
  }
  return c;
}
function _objectSpread2$1(a) {
  for (var s = 1; s < arguments.length; s++) {
    var c = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$2(Object(c), !0).forEach(function(u) {
      _defineProperty$a(a, u, c[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(c)) : ownKeys$2(Object(c)).forEach(function(u) {
      Object.defineProperty(a, u, Object.getOwnPropertyDescriptor(c, u));
    });
  }
  return a;
}
function isDOM(a) {
  return a instanceof HTMLElement || a instanceof SVGElement;
}
function getDOM(a) {
  return a && _typeof$h(a) === "object" && isDOM(a.nativeElement) ? a.nativeElement : isDOM(a) ? a : null;
}
function findDOMNode(a) {
  var s = getDOM(a);
  if (s)
    return s;
  if (a instanceof React.Component) {
    var c;
    return (c = ReactDOM.findDOMNode) === null || c === void 0 ? void 0 : c.call(ReactDOM, a);
  }
  return null;
}
var reactIs = { exports: {} }, reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var a = Symbol.for("react.element"), s = Symbol.for("react.portal"), c = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), p = Symbol.for("react.provider"), v = Symbol.for("react.context"), A = Symbol.for("react.server_context"), x = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), C;
  C = Symbol.for("react.module.reference");
  function w(S) {
    if (typeof S == "object" && S !== null) {
      var $ = S.$$typeof;
      switch ($) {
        case a:
          switch (S = S.type, S) {
            case c:
            case d:
            case u:
            case g:
            case b:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case A:
                case v:
                case x:
                case f:
                case y:
                case p:
                  return S;
                default:
                  return $;
              }
          }
        case s:
          return $;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = v, reactIs_production_min.ContextProvider = p, reactIs_production_min.Element = a, reactIs_production_min.ForwardRef = x, reactIs_production_min.Fragment = c, reactIs_production_min.Lazy = f, reactIs_production_min.Memo = y, reactIs_production_min.Portal = s, reactIs_production_min.Profiler = d, reactIs_production_min.StrictMode = u, reactIs_production_min.Suspense = g, reactIs_production_min.SuspenseList = b, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(S) {
    return w(S) === v;
  }, reactIs_production_min.isContextProvider = function(S) {
    return w(S) === p;
  }, reactIs_production_min.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === a;
  }, reactIs_production_min.isForwardRef = function(S) {
    return w(S) === x;
  }, reactIs_production_min.isFragment = function(S) {
    return w(S) === c;
  }, reactIs_production_min.isLazy = function(S) {
    return w(S) === f;
  }, reactIs_production_min.isMemo = function(S) {
    return w(S) === y;
  }, reactIs_production_min.isPortal = function(S) {
    return w(S) === s;
  }, reactIs_production_min.isProfiler = function(S) {
    return w(S) === d;
  }, reactIs_production_min.isStrictMode = function(S) {
    return w(S) === u;
  }, reactIs_production_min.isSuspense = function(S) {
    return w(S) === g;
  }, reactIs_production_min.isSuspenseList = function(S) {
    return w(S) === b;
  }, reactIs_production_min.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === c || S === d || S === u || S === g || S === b || S === m || typeof S == "object" && S !== null && (S.$$typeof === f || S.$$typeof === y || S.$$typeof === p || S.$$typeof === v || S.$$typeof === x || S.$$typeof === C || S.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = w, reactIs_production_min;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, reactIs.exports = requireReactIs_production_min()), reactIs.exports;
}
var reactIsExports = requireReactIs();
function useMemo(a, s, c) {
  var u = reactExports.useRef({});
  return (!("value" in u.current) || c(u.current.condition, s)) && (u.current.value = a(), u.current.condition = s), u.current.value;
}
var ReactMajorVersion = Number(reactExports.version.split(".")[0]), fillRef = function a(s, c) {
  typeof s == "function" ? s(c) : _typeof$h(s) === "object" && s && "current" in s && (s.current = c);
}, composeRef = function a() {
  for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++)
    c[u] = arguments[u];
  var d = c.filter(Boolean);
  return d.length <= 1 ? d[0] : function(p) {
    c.forEach(function(v) {
      fillRef(v, p);
    });
  };
}, useComposeRef = function a() {
  for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++)
    c[u] = arguments[u];
  return useMemo(function() {
    return composeRef.apply(void 0, c);
  }, c, function(d, p) {
    return d.length !== p.length || d.every(function(v, A) {
      return v !== p[A];
    });
  });
}, supportRef = function a(s) {
  var c, u;
  if (!s)
    return !1;
  if (isReactElement(s) && ReactMajorVersion >= 19)
    return !0;
  var d = reactIsExports.isMemo(s) ? s.type.type : s.type;
  return !(typeof d == "function" && !((c = d.prototype) !== null && c !== void 0 && c.render) && d.$$typeof !== reactIsExports.ForwardRef || typeof s == "function" && !((u = s.prototype) !== null && u !== void 0 && u.render) && s.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(a) {
  return /* @__PURE__ */ reactExports.isValidElement(a) && !isFragment$1(a);
}
var supportNodeRef = function a(s) {
  return isReactElement(s) && supportRef(s);
}, getNodeRef = function a(s) {
  if (s && isReactElement(s)) {
    var c = s;
    return c.props.propertyIsEnumerable("ref") ? c.props.ref : c.ref;
  }
  return null;
}, CollectionContext = /* @__PURE__ */ reactExports.createContext(null);
function Collection(a) {
  var s = a.children, c = a.onBatchResize, u = reactExports.useRef(0), d = reactExports.useRef([]), p = reactExports.useContext(CollectionContext), v = reactExports.useCallback(function(A, x, g) {
    u.current += 1;
    var b = u.current;
    d.current.push({
      size: A,
      element: x,
      data: g
    }), Promise.resolve().then(function() {
      b === u.current && (c?.(d.current), d.current = []);
    }), p?.(A, x, g);
  }, [c, p]);
  return /* @__PURE__ */ reactExports.createElement(CollectionContext.Provider, {
    value: v
  }, s);
}
var MapShim = function() {
  if (typeof Map < "u")
    return Map;
  function a(s, c) {
    var u = -1;
    return s.some(function(d, p) {
      return d[0] === c ? (u = p, !0) : !1;
    }), u;
  }
  return (
    /** @class */
    function() {
      function s() {
        this.__entries__ = [];
      }
      return Object.defineProperty(s.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), s.prototype.get = function(c) {
        var u = a(this.__entries__, c), d = this.__entries__[u];
        return d && d[1];
      }, s.prototype.set = function(c, u) {
        var d = a(this.__entries__, c);
        ~d ? this.__entries__[d][1] = u : this.__entries__.push([c, u]);
      }, s.prototype.delete = function(c) {
        var u = this.__entries__, d = a(u, c);
        ~d && u.splice(d, 1);
      }, s.prototype.has = function(c) {
        return !!~a(this.__entries__, c);
      }, s.prototype.clear = function() {
        this.__entries__.splice(0);
      }, s.prototype.forEach = function(c, u) {
        u === void 0 && (u = null);
        for (var d = 0, p = this.__entries__; d < p.length; d++) {
          var v = p[d];
          c.call(u, v[1], v[0]);
        }
      }, s;
    }()
  );
}(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1 = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), requestAnimationFrame$1$1 = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(a) {
    return setTimeout(function() {
      return a(Date.now());
    }, 1e3 / 60);
  };
}(), trailingTimeout = 2;
function throttle$2(a, s) {
  var c = !1, u = !1, d = 0;
  function p() {
    c && (c = !1, a()), u && A();
  }
  function v() {
    requestAnimationFrame$1$1(p);
  }
  function A() {
    var x = Date.now();
    if (c) {
      if (x - d < trailingTimeout)
        return;
      u = !0;
    } else
      c = !0, u = !1, setTimeout(v, s);
    d = x;
  }
  return A;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  function() {
    function a() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle$2(this.refresh.bind(this), REFRESH_DELAY);
    }
    return a.prototype.addObserver = function(s) {
      ~this.observers_.indexOf(s) || this.observers_.push(s), this.connected_ || this.connect_();
    }, a.prototype.removeObserver = function(s) {
      var c = this.observers_, u = c.indexOf(s);
      ~u && c.splice(u, 1), !c.length && this.connected_ && this.disconnect_();
    }, a.prototype.refresh = function() {
      var s = this.updateObservers_();
      s && this.refresh();
    }, a.prototype.updateObservers_ = function() {
      var s = this.observers_.filter(function(c) {
        return c.gatherActive(), c.hasActive();
      });
      return s.forEach(function(c) {
        return c.broadcastActive();
      }), s.length > 0;
    }, a.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, a.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, a.prototype.onTransitionEnd_ = function(s) {
      var c = s.propertyName, u = c === void 0 ? "" : c, d = transitionKeys.some(function(p) {
        return !!~u.indexOf(p);
      });
      d && this.refresh();
    }, a.getInstance = function() {
      return this.instance_ || (this.instance_ = new a()), this.instance_;
    }, a.instance_ = null, a;
  }()
), defineConfigurable = function(a, s) {
  for (var c = 0, u = Object.keys(s); c < u.length; c++) {
    var d = u[c];
    Object.defineProperty(a, d, {
      value: s[d],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return a;
}, getWindowOf = function(a) {
  var s = a && a.ownerDocument && a.ownerDocument.defaultView;
  return s || global$1;
}, emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(a) {
  return parseFloat(a) || 0;
}
function getBordersSize(a) {
  for (var s = [], c = 1; c < arguments.length; c++)
    s[c - 1] = arguments[c];
  return s.reduce(function(u, d) {
    var p = a["border-" + d + "-width"];
    return u + toFloat(p);
  }, 0);
}
function getPaddings(a) {
  for (var s = ["top", "right", "bottom", "left"], c = {}, u = 0, d = s; u < d.length; u++) {
    var p = d[u], v = a["padding-" + p];
    c[p] = toFloat(v);
  }
  return c;
}
function getSVGContentRect(a) {
  var s = a.getBBox();
  return createRectInit(0, 0, s.width, s.height);
}
function getHTMLElementContentRect(a) {
  var s = a.clientWidth, c = a.clientHeight;
  if (!s && !c)
    return emptyRect;
  var u = getWindowOf(a).getComputedStyle(a), d = getPaddings(u), p = d.left + d.right, v = d.top + d.bottom, A = toFloat(u.width), x = toFloat(u.height);
  if (u.boxSizing === "border-box" && (Math.round(A + p) !== s && (A -= getBordersSize(u, "left", "right") + p), Math.round(x + v) !== c && (x -= getBordersSize(u, "top", "bottom") + v)), !isDocumentElement(a)) {
    var g = Math.round(A + p) - s, b = Math.round(x + v) - c;
    Math.abs(g) !== 1 && (A -= g), Math.abs(b) !== 1 && (x -= b);
  }
  return createRectInit(d.left, d.top, A, x);
}
var isSVGGraphicsElement = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(a) {
    return a instanceof getWindowOf(a).SVGGraphicsElement;
  } : function(a) {
    return a instanceof getWindowOf(a).SVGElement && typeof a.getBBox == "function";
  };
}();
function isDocumentElement(a) {
  return a === getWindowOf(a).document.documentElement;
}
function getContentRect(a) {
  return isBrowser ? isSVGGraphicsElement(a) ? getSVGContentRect(a) : getHTMLElementContentRect(a) : emptyRect;
}
function createReadOnlyRect(a) {
  var s = a.x, c = a.y, u = a.width, d = a.height, p = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, v = Object.create(p.prototype);
  return defineConfigurable(v, {
    x: s,
    y: c,
    width: u,
    height: d,
    top: c,
    right: s + u,
    bottom: d + c,
    left: s
  }), v;
}
function createRectInit(a, s, c, u) {
  return { x: a, y: s, width: c, height: u };
}
var ResizeObservation = (
  /** @class */
  function() {
    function a(s) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = s;
    }
    return a.prototype.isActive = function() {
      var s = getContentRect(this.target);
      return this.contentRect_ = s, s.width !== this.broadcastWidth || s.height !== this.broadcastHeight;
    }, a.prototype.broadcastRect = function() {
      var s = this.contentRect_;
      return this.broadcastWidth = s.width, this.broadcastHeight = s.height, s;
    }, a;
  }()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function a(s, c) {
      var u = createReadOnlyRect(c);
      defineConfigurable(this, { target: s, contentRect: u });
    }
    return a;
  }()
), ResizeObserverSPI = (
  /** @class */
  function() {
    function a(s, c, u) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof s != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = s, this.controller_ = c, this.callbackCtx_ = u;
    }
    return a.prototype.observe = function(s) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(s instanceof getWindowOf(s).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var c = this.observations_;
        c.has(s) || (c.set(s, new ResizeObservation(s)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, a.prototype.unobserve = function(s) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(s instanceof getWindowOf(s).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var c = this.observations_;
        c.has(s) && (c.delete(s), c.size || this.controller_.removeObserver(this));
      }
    }, a.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, a.prototype.gatherActive = function() {
      var s = this;
      this.clearActive(), this.observations_.forEach(function(c) {
        c.isActive() && s.activeObservations_.push(c);
      });
    }, a.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var s = this.callbackCtx_, c = this.activeObservations_.map(function(u) {
          return new ResizeObserverEntry(u.target, u.broadcastRect());
        });
        this.callback_.call(s, c, s), this.clearActive();
      }
    }, a.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, a.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, a;
  }()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function a(s) {
      if (!(this instanceof a))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var c = ResizeObserverController.getInstance(), u = new ResizeObserverSPI(s, c, this);
      observers.set(this, u);
    }
    return a;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(a) {
  ResizeObserver$2.prototype[a] = function() {
    var s;
    return (s = observers.get(this))[a].apply(s, arguments);
  };
});
var index$3 = function() {
  return typeof global$1.ResizeObserver < "u" ? global$1.ResizeObserver : ResizeObserver$2;
}(), elementListeners = /* @__PURE__ */ new Map();
function onResize(a) {
  a.forEach(function(s) {
    var c, u = s.target;
    (c = elementListeners.get(u)) === null || c === void 0 || c.forEach(function(d) {
      return d(u);
    });
  });
}
var resizeObserver = new index$3(onResize);
function observe(a, s) {
  elementListeners.has(a) || (elementListeners.set(a, /* @__PURE__ */ new Set()), resizeObserver.observe(a)), elementListeners.get(a).add(s);
}
function unobserve(a, s) {
  elementListeners.has(a) && (elementListeners.get(a).delete(s), elementListeners.get(a).size || (resizeObserver.unobserve(a), elementListeners.delete(a)));
}
function _classCallCheck$1(a, s) {
  if (!(a instanceof s)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(a, s) {
  for (var c = 0; c < s.length; c++) {
    var u = s[c];
    u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(a, toPropertyKey$1(u.key), u);
  }
}
function _createClass$1(a, s, c) {
  return s && _defineProperties(a.prototype, s), c && _defineProperties(a, c), Object.defineProperty(a, "prototype", {
    writable: !1
  }), a;
}
function _setPrototypeOf(a, s) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(c, u) {
    return c.__proto__ = u, c;
  }, _setPrototypeOf(a, s);
}
function _inherits$1(a, s) {
  if (typeof s != "function" && s !== null) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(s && s.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(a, "prototype", {
    writable: !1
  }), s && _setPrototypeOf(a, s);
}
function _getPrototypeOf(a) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(s) {
    return s.__proto__ || Object.getPrototypeOf(s);
  }, _getPrototypeOf(a);
}
function _isNativeReflectConstruct() {
  try {
    var a = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!a;
  })();
}
function _assertThisInitialized(a) {
  if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function _possibleConstructorReturn$1(a, s) {
  if (s && (_typeof$h(s) == "object" || typeof s == "function")) return s;
  if (s !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(a);
}
function _createSuper(a) {
  var s = _isNativeReflectConstruct();
  return function() {
    var c, u = _getPrototypeOf(a);
    if (s) {
      var d = _getPrototypeOf(this).constructor;
      c = Reflect.construct(u, arguments, d);
    } else c = u.apply(this, arguments);
    return _possibleConstructorReturn$1(this, c);
  };
}
var DomWrapper$1 = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c() {
    return _classCallCheck$1(this, c), s.apply(this, arguments);
  }
  return _createClass$1(c, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), c;
}(reactExports.Component);
function SingleObserver(a, s) {
  var c = a.children, u = a.disabled, d = reactExports.useRef(null), p = reactExports.useRef(null), v = reactExports.useContext(CollectionContext), A = typeof c == "function", x = A ? c(d) : c, g = reactExports.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), b = !A && /* @__PURE__ */ reactExports.isValidElement(x) && supportRef(x), y = b ? getNodeRef(x) : null, f = useComposeRef(y, d), m = function() {
    var $;
    return findDOMNode(d.current) || // Support `nativeElement` format
    (d.current && _typeof$h(d.current) === "object" ? findDOMNode(($ = d.current) === null || $ === void 0 ? void 0 : $.nativeElement) : null) || findDOMNode(p.current);
  };
  reactExports.useImperativeHandle(s, function() {
    return m();
  });
  var C = reactExports.useRef(a);
  C.current = a;
  var w = reactExports.useCallback(function(S) {
    var $ = C.current, T = $.onResize, I = $.data, _ = S.getBoundingClientRect(), E = _.width, R = _.height, O = S.offsetWidth, L = S.offsetHeight, B = Math.floor(E), F = Math.floor(R);
    if (g.current.width !== B || g.current.height !== F || g.current.offsetWidth !== O || g.current.offsetHeight !== L) {
      var M = {
        width: B,
        height: F,
        offsetWidth: O,
        offsetHeight: L
      };
      g.current = M;
      var W = O === Math.round(E) ? E : O, j = L === Math.round(R) ? R : L, G = _objectSpread2$1(_objectSpread2$1({}, M), {}, {
        offsetWidth: W,
        offsetHeight: j
      });
      v?.(G, S, I), T && Promise.resolve().then(function() {
        T(G, S);
      });
    }
  }, []);
  return reactExports.useEffect(function() {
    var S = m();
    return S && !u && observe(S, w), function() {
      return unobserve(S, w);
    };
  }, [d.current, u]), /* @__PURE__ */ reactExports.createElement(DomWrapper$1, {
    ref: p
  }, b ? /* @__PURE__ */ reactExports.cloneElement(x, {
    ref: f
  }) : x);
}
var RefSingleObserver = /* @__PURE__ */ reactExports.forwardRef(SingleObserver), INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(a, s) {
  var c = a.children, u = typeof c == "function" ? [c] : toArray$8(c);
  return u.map(function(d, p) {
    var v = d?.key || "".concat(INTERNAL_PREFIX_KEY, "-").concat(p);
    return /* @__PURE__ */ reactExports.createElement(RefSingleObserver, _extends$3({}, a, {
      key: v,
      ref: p === 0 ? s : void 0
    }), d);
  });
}
var RefResizeObserver = /* @__PURE__ */ reactExports.forwardRef(ResizeObserver$1);
RefResizeObserver.Collection = Collection;
function _arrayLikeToArray$m(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _arrayWithoutHoles$e(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$m(a);
}
function _iterableToArray$e(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _unsupportedIterableToArray$m(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$m(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$m(a, s) : void 0;
  }
}
function _nonIterableSpread$e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray$e(a) {
  return _arrayWithoutHoles$e(a) || _iterableToArray$e(a) || _unsupportedIterableToArray$m(a) || _nonIterableSpread$e();
}
var raf = function a(s) {
  return +setTimeout(s, 16);
}, caf = function a(s) {
  return clearTimeout(s);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf = function(s) {
  return window.requestAnimationFrame(s);
}, caf = function(s) {
  return window.cancelAnimationFrame(s);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(a) {
  rafIds.delete(a);
}
var wrapperRaf = function a(s) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var u = rafUUID;
  function d(p) {
    if (p === 0)
      cleanup(u), s();
    else {
      var v = raf(function() {
        d(p - 1);
      });
      rafIds.set(u, v);
    }
  }
  return d(c), u;
};
wrapperRaf.cancel = function(a) {
  var s = rafIds.get(a);
  return cleanup(a), caf(s);
};
function _arrayWithHoles$f(a) {
  if (Array.isArray(a)) return a;
}
function _iterableToArrayLimit$e(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s === 0) {
        if (Object(c) !== c) return;
        x = !1;
      } else for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _nonIterableRest$f() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray$e(a, s) {
  return _arrayWithHoles$f(a) || _iterableToArrayLimit$e(a, s) || _unsupportedIterableToArray$m(a, s) || _nonIterableRest$f();
}
function murmur2(a) {
  for (var s = 0, c, u = 0, d = a.length; d >= 4; ++u, d -= 4)
    c = a.charCodeAt(u) & 255 | (a.charCodeAt(++u) & 255) << 8 | (a.charCodeAt(++u) & 255) << 16 | (a.charCodeAt(++u) & 255) << 24, c = /* Math.imul(k, m): */
    (c & 65535) * 1540483477 + ((c >>> 16) * 59797 << 16), c ^= /* k >>> r: */
    c >>> 24, s = /* Math.imul(k, m): */
    (c & 65535) * 1540483477 + ((c >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (s & 65535) * 1540483477 + ((s >>> 16) * 59797 << 16);
  switch (d) {
    case 3:
      s ^= (a.charCodeAt(u + 2) & 255) << 16;
    case 2:
      s ^= (a.charCodeAt(u + 1) & 255) << 8;
    case 1:
      s ^= a.charCodeAt(u) & 255, s = /* Math.imul(h, m): */
      (s & 65535) * 1540483477 + ((s >>> 16) * 59797 << 16);
  }
  return s ^= s >>> 13, s = /* Math.imul(h, m): */
  (s & 65535) * 1540483477 + ((s >>> 16) * 59797 << 16), ((s ^ s >>> 15) >>> 0).toString(36);
}
function canUseDom$1() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function contains$3(a, s) {
  if (!a)
    return !1;
  if (a.contains)
    return a.contains(s);
  for (var c = s; c; ) {
    if (c === a)
      return !0;
    c = c.parentNode;
  }
  return !1;
}
var APPEND_ORDER = "data-rc-order", APPEND_PRIORITY = "data-rc-priority", MARK_KEY = "rc-util-key", containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = a.mark;
  return s ? s.startsWith("data-") ? s : "data-".concat(s) : MARK_KEY;
}
function getContainer(a) {
  if (a.attachTo)
    return a.attachTo;
  var s = document.querySelector("head");
  return s || document.body;
}
function getOrder(a) {
  return a === "queue" ? "prependQueue" : a ? "prepend" : "append";
}
function findStyles(a) {
  return Array.from((containerCache.get(a) || a).children).filter(function(s) {
    return s.tagName === "STYLE";
  });
}
function injectCSS(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom$1())
    return null;
  var c = s.csp, u = s.prepend, d = s.priority, p = d === void 0 ? 0 : d, v = getOrder(u), A = v === "prependQueue", x = document.createElement("style");
  x.setAttribute(APPEND_ORDER, v), A && p && x.setAttribute(APPEND_PRIORITY, "".concat(p)), c != null && c.nonce && (x.nonce = c?.nonce), x.innerHTML = a;
  var g = getContainer(s), b = g.firstChild;
  if (u) {
    if (A) {
      var y = (s.styles || findStyles(g)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(APPEND_ORDER)))
          return !1;
        var m = Number(f.getAttribute(APPEND_PRIORITY) || 0);
        return p >= m;
      });
      if (y.length)
        return g.insertBefore(x, y[y.length - 1].nextSibling), x;
    }
    g.insertBefore(x, b);
  } else
    g.appendChild(x);
  return x;
}
function findExistNode(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = getContainer(s);
  return (s.styles || findStyles(c)).find(function(u) {
    return u.getAttribute(getMark(s)) === a;
  });
}
function removeCSS(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = findExistNode(a, s);
  if (c) {
    var u = getContainer(s);
    u.removeChild(c);
  }
}
function syncRealContainer(a, s) {
  var c = containerCache.get(a);
  if (!c || !contains$3(document, c)) {
    var u = injectCSS("", s), d = u.parentNode;
    containerCache.set(a, d), a.removeChild(u);
  }
}
function updateCSS(a, s) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, u = getContainer(c), d = findStyles(u), p = _objectSpread2$1(_objectSpread2$1({}, c), {}, {
    styles: d
  });
  syncRealContainer(u, p);
  var v = findExistNode(s, p);
  if (v) {
    var A, x;
    if ((A = p.csp) !== null && A !== void 0 && A.nonce && v.nonce !== ((x = p.csp) === null || x === void 0 ? void 0 : x.nonce)) {
      var g;
      v.nonce = (g = p.csp) === null || g === void 0 ? void 0 : g.nonce;
    }
    return v.innerHTML !== a && (v.innerHTML = a), v;
  }
  var b = injectCSS(a, p);
  return b.setAttribute(getMark(p), s), b;
}
function _objectWithoutPropertiesLoose$1(a, s) {
  if (a == null) return {};
  var c = {};
  for (var u in a) if ({}.hasOwnProperty.call(a, u)) {
    if (s.indexOf(u) !== -1) continue;
    c[u] = a[u];
  }
  return c;
}
function _objectWithoutProperties$2(a, s) {
  if (a == null) return {};
  var c, u, d = _objectWithoutPropertiesLoose$1(a, s);
  if (Object.getOwnPropertySymbols) {
    var p = Object.getOwnPropertySymbols(a);
    for (u = 0; u < p.length; u++) c = p[u], s.indexOf(c) === -1 && {}.propertyIsEnumerable.call(a, c) && (d[c] = a[c]);
  }
  return d;
}
function isEqual(a, s) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, u = /* @__PURE__ */ new Set();
  function d(p, v) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, x = u.has(p);
    if (warningOnce(!x, "Warning: There may be circular references"), x)
      return !1;
    if (p === v)
      return !0;
    if (c && A > 1)
      return !1;
    u.add(p);
    var g = A + 1;
    if (Array.isArray(p)) {
      if (!Array.isArray(v) || p.length !== v.length)
        return !1;
      for (var b = 0; b < p.length; b++)
        if (!d(p[b], v[b], g))
          return !1;
      return !0;
    }
    if (p && v && _typeof$h(p) === "object" && _typeof$h(v) === "object") {
      var y = Object.keys(p);
      return y.length !== Object.keys(v).length ? !1 : y.every(function(f) {
        return d(p[f], v[f], g);
      });
    }
    return !1;
  }
  return d(a, s);
}
var SPLIT$1 = "%";
function pathKey(a) {
  return a.join(SPLIT$1);
}
var Entity = /* @__PURE__ */ function() {
  function a(s) {
    _classCallCheck$1(this, a), _defineProperty$a(this, "instanceId", void 0), _defineProperty$a(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = s;
  }
  return _createClass$1(a, [{
    key: "get",
    value: function(c) {
      return this.opGet(pathKey(c));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(c) {
      return this.cache.get(c) || null;
    }
  }, {
    key: "update",
    value: function(c, u) {
      return this.opUpdate(pathKey(c), u);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(c, u) {
      var d = this.cache.get(c), p = u(d);
      p === null ? this.cache.delete(c) : this.cache.set(c, p);
    }
  }]), a;
}(), ATTR_TOKEN = "data-token-hash", ATTR_MARK = "data-css-hash", CSS_IN_JS_INSTANCE = "__cssinjs_instance__";
function createCache() {
  var a = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var s = document.body.querySelectorAll("style[".concat(ATTR_MARK, "]")) || [], c = document.head.firstChild;
    Array.from(s).forEach(function(d) {
      d[CSS_IN_JS_INSTANCE] = d[CSS_IN_JS_INSTANCE] || a, d[CSS_IN_JS_INSTANCE] === a && document.head.insertBefore(d, c);
    });
    var u = {};
    Array.from(document.querySelectorAll("style[".concat(ATTR_MARK, "]"))).forEach(function(d) {
      var p = d.getAttribute(ATTR_MARK);
      if (u[p]) {
        if (d[CSS_IN_JS_INSTANCE] === a) {
          var v;
          (v = d.parentNode) === null || v === void 0 || v.removeChild(d);
        }
      } else
        u[p] = !0;
    });
  }
  return new Entity(a);
}
var StyleContext = /* @__PURE__ */ reactExports.createContext({
  hashPriority: "low",
  cache: createCache(),
  defaultCache: !0
});
function sameDerivativeOption(a, s) {
  if (a.length !== s.length)
    return !1;
  for (var c = 0; c < a.length; c++)
    if (a[c] !== s[c])
      return !1;
  return !0;
}
var ThemeCache = /* @__PURE__ */ function() {
  function a() {
    _classCallCheck$1(this, a), _defineProperty$a(this, "cache", void 0), _defineProperty$a(this, "keys", void 0), _defineProperty$a(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return _createClass$1(a, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(c) {
      var u, d, p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, v = {
        map: this.cache
      };
      return c.forEach(function(A) {
        if (!v)
          v = void 0;
        else {
          var x;
          v = (x = v) === null || x === void 0 || (x = x.map) === null || x === void 0 ? void 0 : x.get(A);
        }
      }), (u = v) !== null && u !== void 0 && u.value && p && (v.value[1] = this.cacheCallTimes++), (d = v) === null || d === void 0 ? void 0 : d.value;
    }
  }, {
    key: "get",
    value: function(c) {
      var u;
      return (u = this.internalGet(c, !0)) === null || u === void 0 ? void 0 : u[0];
    }
  }, {
    key: "has",
    value: function(c) {
      return !!this.internalGet(c);
    }
  }, {
    key: "set",
    value: function(c, u) {
      var d = this;
      if (!this.has(c)) {
        if (this.size() + 1 > a.MAX_CACHE_SIZE + a.MAX_CACHE_OFFSET) {
          var p = this.keys.reduce(function(g, b) {
            var y = _slicedToArray$e(g, 2), f = y[1];
            return d.internalGet(b)[1] < f ? [b, d.internalGet(b)[1]] : g;
          }, [this.keys[0], this.cacheCallTimes]), v = _slicedToArray$e(p, 1), A = v[0];
          this.delete(A);
        }
        this.keys.push(c);
      }
      var x = this.cache;
      c.forEach(function(g, b) {
        if (b === c.length - 1)
          x.set(g, {
            value: [u, d.cacheCallTimes++]
          });
        else {
          var y = x.get(g);
          y ? y.map || (y.map = /* @__PURE__ */ new Map()) : x.set(g, {
            map: /* @__PURE__ */ new Map()
          }), x = x.get(g).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(c, u) {
      var d = c.get(u[0]);
      if (u.length === 1) {
        var p;
        return d.map ? c.set(u[0], {
          map: d.map
        }) : c.delete(u[0]), (p = d.value) === null || p === void 0 ? void 0 : p[0];
      }
      var v = this.deleteByPath(d.map, u.slice(1));
      return (!d.map || d.map.size === 0) && !d.value && c.delete(u[0]), v;
    }
  }, {
    key: "delete",
    value: function(c) {
      if (this.has(c))
        return this.keys = this.keys.filter(function(u) {
          return !sameDerivativeOption(u, c);
        }), this.deleteByPath(this.cache, c);
    }
  }]), a;
}();
_defineProperty$a(ThemeCache, "MAX_CACHE_SIZE", 20);
_defineProperty$a(ThemeCache, "MAX_CACHE_OFFSET", 5);
var uuid$5 = 0, Theme = /* @__PURE__ */ function() {
  function a(s) {
    _classCallCheck$1(this, a), _defineProperty$a(this, "derivatives", void 0), _defineProperty$a(this, "id", void 0), this.derivatives = Array.isArray(s) ? s : [s], this.id = uuid$5, s.length === 0 && (s.length > 0, void 0), uuid$5 += 1;
  }
  return _createClass$1(a, [{
    key: "getDerivativeToken",
    value: function(c) {
      return this.derivatives.reduce(function(u, d) {
        return d(c, u);
      }, void 0);
    }
  }]), a;
}(), cacheThemes = new ThemeCache();
function createTheme(a) {
  var s = Array.isArray(a) ? a : [a];
  return cacheThemes.has(s) || cacheThemes.set(s, new Theme(s)), cacheThemes.get(s);
}
var resultCache = /* @__PURE__ */ new WeakMap(), RESULT_VALUE = {};
function memoResult(a, s) {
  for (var c = resultCache, u = 0; u < s.length; u += 1) {
    var d = s[u];
    c.has(d) || c.set(d, /* @__PURE__ */ new WeakMap()), c = c.get(d);
  }
  return c.has(RESULT_VALUE) || c.set(RESULT_VALUE, a()), c.get(RESULT_VALUE);
}
var flattenTokenCache = /* @__PURE__ */ new WeakMap();
function flattenToken(a) {
  var s = flattenTokenCache.get(a) || "";
  return s || (Object.keys(a).forEach(function(c) {
    var u = a[c];
    s += c, u instanceof Theme ? s += u.id : u && _typeof$h(u) === "object" ? s += flattenToken(u) : s += u;
  }), s = murmur2(s), flattenTokenCache.set(a, s)), s;
}
function token2key(a, s) {
  return murmur2("".concat(s, "_").concat(flattenToken(a)));
}
var isClientSide = canUseDom$1();
function unit$1(a) {
  return typeof a == "number" ? "".concat(a, "px") : a;
}
function toStyleStr(a, s, c) {
  var u, d = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, p = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (p)
    return a;
  var v = _objectSpread2$1(_objectSpread2$1({}, d), {}, (u = {}, _defineProperty$a(u, ATTR_TOKEN, s), _defineProperty$a(u, ATTR_MARK, c), u)), A = Object.keys(v).map(function(x) {
    var g = v[x];
    return g ? "".concat(x, '="').concat(g, '"') : null;
  }).filter(function(x) {
    return x;
  }).join(" ");
  return "<style ".concat(A, ">").concat(a, "</style>");
}
var token2CSSVar = function a(s) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(c ? "".concat(c, "-") : "").concat(s).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, serializeCSSVar = function a(s, c, u) {
  return Object.keys(s).length ? ".".concat(c).concat(u != null && u.scope ? ".".concat(u.scope) : "", "{").concat(Object.entries(s).map(function(d) {
    var p = _slicedToArray$e(d, 2), v = p[0], A = p[1];
    return "".concat(v, ":").concat(A, ";");
  }).join(""), "}") : "";
}, transformToken = function a(s, c, u) {
  var d = {}, p = {};
  return Object.entries(s).forEach(function(v) {
    var A, x, g = _slicedToArray$e(v, 2), b = g[0], y = g[1];
    if (u != null && (A = u.preserve) !== null && A !== void 0 && A[b])
      p[b] = y;
    else if ((typeof y == "string" || typeof y == "number") && !(u != null && (x = u.ignore) !== null && x !== void 0 && x[b])) {
      var f, m = token2CSSVar(b, u?.prefix);
      d[m] = typeof y == "number" && !(u != null && (f = u.unitless) !== null && f !== void 0 && f[b]) ? "".concat(y, "px") : String(y), p[b] = "var(".concat(m, ")");
    }
  }), [p, serializeCSSVar(d, c, {
    scope: u?.scope
  })];
}, useInternalLayoutEffect = canUseDom$1() ? reactExports.useLayoutEffect : reactExports.useEffect, useLayoutEffect$1 = function a(s, c) {
  var u = reactExports.useRef(!0);
  useInternalLayoutEffect(function() {
    return s(u.current);
  }, c), useInternalLayoutEffect(function() {
    return u.current = !1, function() {
      u.current = !0;
    };
  }, []);
}, useLayoutUpdateEffect = function a(s, c) {
  useLayoutEffect$1(function(u) {
    if (!u)
      return s();
  }, c);
}, fullClone$3 = _objectSpread2$1({}, React$1), useInsertionEffect$1 = fullClone$3.useInsertionEffect, useInsertionEffectPolyfill = function a(s, c, u) {
  reactExports.useMemo(s, u), useLayoutEffect$1(function() {
    return c(!0);
  }, u);
}, useCompatibleInsertionEffect = useInsertionEffect$1 ? function(a, s, c) {
  return useInsertionEffect$1(function() {
    return a(), s();
  }, c);
} : useInsertionEffectPolyfill, fullClone$2 = _objectSpread2$1({}, React$1), useInsertionEffect = fullClone$2.useInsertionEffect, useCleanupRegister = function a(s) {
  var c = [], u = !1;
  function d(p) {
    u || c.push(p);
  }
  return reactExports.useEffect(function() {
    return u = !1, function() {
      u = !0, c.length && c.forEach(function(p) {
        return p();
      });
    };
  }, s), d;
}, useRun = function a() {
  return function(s) {
    s();
  };
}, useEffectCleanupRegister = typeof useInsertionEffect < "u" ? useCleanupRegister : useRun;
function useGlobalCache(a, s, c, u, d) {
  var p = reactExports.useContext(StyleContext), v = p.cache, A = [a].concat(_toConsumableArray$e(s)), x = pathKey(A), g = useEffectCleanupRegister([x]), b = function(C) {
    v.opUpdate(x, function(w) {
      var S = w || [void 0, void 0], $ = _slicedToArray$e(S, 2), T = $[0], I = T === void 0 ? 0 : T, _ = $[1], E = _, R = E || c(), O = [I, R];
      return C ? C(O) : O;
    });
  };
  reactExports.useMemo(
    function() {
      b();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [x]
    /* eslint-enable */
  );
  var y = v.opGet(x), f = y[1];
  return useCompatibleInsertionEffect(function() {
    d?.(f);
  }, function(m) {
    return b(function(C) {
      var w = _slicedToArray$e(C, 2), S = w[0], $ = w[1];
      return m && S === 0 && d?.(f), [S + 1, $];
    }), function() {
      v.opUpdate(x, function(C) {
        var w = C || [], S = _slicedToArray$e(w, 2), $ = S[0], T = $ === void 0 ? 0 : $, I = S[1], _ = T - 1;
        return _ === 0 ? (g(function() {
          (m || !v.opGet(x)) && u?.(I, !1);
        }), null) : [T - 1, I];
      });
    };
  }, [x]), f;
}
var EMPTY_OVERRIDE = {}, hashPrefix = "css", tokenKeys = /* @__PURE__ */ new Map();
function recordCleanToken(a) {
  tokenKeys.set(a, (tokenKeys.get(a) || 0) + 1);
}
function removeStyleTags(a, s) {
  if (typeof document < "u") {
    var c = document.querySelectorAll("style[".concat(ATTR_TOKEN, '="').concat(a, '"]'));
    c.forEach(function(u) {
      if (u[CSS_IN_JS_INSTANCE] === s) {
        var d;
        (d = u.parentNode) === null || d === void 0 || d.removeChild(u);
      }
    });
  }
}
var TOKEN_THRESHOLD = 0;
function cleanTokenStyle(a, s) {
  tokenKeys.set(a, (tokenKeys.get(a) || 0) - 1);
  var c = Array.from(tokenKeys.keys()), u = c.filter(function(d) {
    var p = tokenKeys.get(d) || 0;
    return p <= 0;
  });
  c.length - u.length > TOKEN_THRESHOLD && u.forEach(function(d) {
    removeStyleTags(d, s), tokenKeys.delete(d);
  });
}
var getComputedToken$1 = function a(s, c, u, d) {
  var p = u.getDerivativeToken(s), v = _objectSpread2$1(_objectSpread2$1({}, p), c);
  return d && (v = d(v)), v;
}, TOKEN_PREFIX = "token";
function useCacheToken(a, s) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, u = reactExports.useContext(StyleContext), d = u.cache.instanceId, p = u.container, v = c.salt, A = v === void 0 ? "" : v, x = c.override, g = x === void 0 ? EMPTY_OVERRIDE : x, b = c.formatToken, y = c.getComputedToken, f = c.cssVar, m = memoResult(function() {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray$e(s)));
  }, s), C = flattenToken(m), w = flattenToken(g), S = f ? flattenToken(f) : "", $ = useGlobalCache(TOKEN_PREFIX, [A, a.id, C, w, S], function() {
    var T, I = y ? y(m, g, a) : getComputedToken$1(m, g, a, b), _ = _objectSpread2$1({}, I), E = "";
    if (f) {
      var R = transformToken(I, f.key, {
        prefix: f.prefix,
        ignore: f.ignore,
        unitless: f.unitless,
        preserve: f.preserve
      }), O = _slicedToArray$e(R, 2);
      I = O[0], E = O[1];
    }
    var L = token2key(I, A);
    I._tokenKey = L, _._tokenKey = token2key(_, A);
    var B = (T = f?.key) !== null && T !== void 0 ? T : L;
    I._themeKey = B, recordCleanToken(B);
    var F = "".concat(hashPrefix, "-").concat(murmur2(L));
    return I._hashId = F, [I, F, _, E, f?.key || ""];
  }, function(T) {
    cleanTokenStyle(T[0]._themeKey, d);
  }, function(T) {
    var I = _slicedToArray$e(T, 4), _ = I[0], E = I[3];
    if (f && E) {
      var R = updateCSS(E, murmur2("css-variables-".concat(_._themeKey)), {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: p,
        priority: -999
      });
      R[CSS_IN_JS_INSTANCE] = d, R.setAttribute(ATTR_TOKEN, _._themeKey);
    }
  });
  return $;
}
var extract$2 = function a(s, c, u) {
  var d = _slicedToArray$e(s, 5), p = d[2], v = d[3], A = d[4], x = u || {}, g = x.plain;
  if (!v)
    return null;
  var b = p._tokenKey, y = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(y)
  }, m = toStyleStr(v, A, b, f, g);
  return [y, b, m];
}, unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", NAMESPACE = "@namespace", KEYFRAMES = "@keyframes", LAYER = "@layer", abs$1 = Math.abs, from = String.fromCharCode;
function trim(a) {
  return a.trim();
}
function replace(a, s, c) {
  return a.replace(s, c);
}
function indexof(a, s, c) {
  return a.indexOf(s, c);
}
function charat(a, s) {
  return a.charCodeAt(s) | 0;
}
function substr(a, s, c) {
  return a.slice(s, c);
}
function strlen(a) {
  return a.length;
}
function sizeof(a) {
  return a.length;
}
function append(a, s) {
  return s.push(a), a;
}
var line = 1, column = 1, length = 0, position$1 = 0, character = 0, characters = "";
function node(a, s, c, u, d, p, v, A) {
  return { value: a, root: s, parent: c, type: u, props: d, children: p, line, column, length: v, return: "", siblings: A };
}
function char() {
  return character;
}
function prev() {
  return character = position$1 > 0 ? charat(characters, --position$1) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position$1 < length ? charat(characters, position$1++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position$1);
}
function caret() {
  return position$1;
}
function slice(a, s) {
  return substr(characters, a, s);
}
function token(a) {
  switch (a) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(a) {
  return line = column = 1, length = strlen(characters = a), position$1 = 0, [];
}
function dealloc(a) {
  return characters = "", a;
}
function delimit(a) {
  return trim(slice(position$1 - 1, delimiter(a === 91 ? a + 2 : a === 40 ? a + 1 : a)));
}
function whitespace$1(a) {
  for (; (character = peek()) && character < 33; )
    next();
  return token(a) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(a, s) {
  for (; --s && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(a, caret() + (s < 6 && peek() == 32 && next() == 32));
}
function delimiter(a) {
  for (; next(); )
    switch (character) {
      // ] ) " '
      case a:
        return position$1;
      // " '
      case 34:
      case 39:
        a !== 34 && a !== 39 && delimiter(character);
        break;
      // (
      case 40:
        a === 41 && delimiter(a);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position$1;
}
function commenter(a, s) {
  for (; next() && a + character !== 57; )
    if (a + character === 84 && peek() === 47)
      break;
  return "/*" + slice(s, position$1 - 1) + "*" + from(a === 47 ? a : next());
}
function identifier(a) {
  for (; !token(peek()); )
    next();
  return slice(a, position$1);
}
function compile(a) {
  return dealloc(parse$1("", null, null, null, [""], a = alloc(a), 0, [0], a));
}
function parse$1(a, s, c, u, d, p, v, A, x) {
  for (var g = 0, b = 0, y = v, f = 0, m = 0, C = 0, w = 1, S = 1, $ = 1, T = 0, I = "", _ = d, E = p, R = u, O = I; S; )
    switch (C = T, T = next()) {
      // (
      case 40:
        if (C != 108 && charat(O, y - 1) == 58) {
          indexof(O += replace(delimit(T), "&", "&\f"), "&\f", abs$1(g ? A[g - 1] : 0)) != -1 && ($ = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        O += delimit(T);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        O += whitespace$1(C);
        break;
      // \
      case 92:
        O += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), s, c, x), x), (token(C || 1) == 5 || token(peek() || 1) == 5) && strlen(O) && substr(O, -1, void 0) !== " " && (O += " ");
            break;
          default:
            O += "/";
        }
        break;
      // {
      case 123 * w:
        A[g++] = strlen(O) * $;
      // } ; \0
      case 125 * w:
      case 59:
      case 0:
        switch (T) {
          // \0 }
          case 0:
          case 125:
            S = 0;
          // ;
          case 59 + b:
            $ == -1 && (O = replace(O, /\f/g, "")), m > 0 && (strlen(O) - y || w === 0 && C === 47) && append(m > 32 ? declaration(O + ";", u, c, y - 1, x) : declaration(replace(O, " ", "") + ";", u, c, y - 2, x), x);
            break;
          // @ ;
          case 59:
            O += ";";
          // { rule/at-rule
          default:
            if (append(R = ruleset(O, s, c, g, b, d, A, I, _ = [], E = [], y, p), p), T === 123)
              if (b === 0)
                parse$1(O, s, R, R, _, p, y, A, E);
              else {
                switch (f) {
                  // c(ontainer)
                  case 99:
                    if (charat(O, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (charat(O, 2) === 97) break;
                  default:
                    b = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                b ? parse$1(a, R, R, u && append(ruleset(a, R, R, 0, 0, d, A, I, d, _ = [], y, E), E), d, E, y, A, u ? _ : E) : parse$1(O, R, R, R, [""], E, 0, A, E);
              }
        }
        g = b = m = 0, w = $ = 1, I = O = "", y = v;
        break;
      // :
      case 58:
        y = 1 + strlen(O), m = C;
      default:
        if (w < 1) {
          if (T == 123)
            --w;
          else if (T == 125 && w++ == 0 && prev() == 125)
            continue;
        }
        switch (O += from(T), T * w) {
          // &
          case 38:
            $ = b > 0 ? 1 : (O += "\f", -1);
            break;
          // ,
          case 44:
            A[g++] = (strlen(O) - 1) * $, $ = 1;
            break;
          // @
          case 64:
            peek() === 45 && (O += delimit(next())), f = peek(), b = y = strlen(I = O += identifier(caret())), T++;
            break;
          // -
          case 45:
            C === 45 && strlen(O) == 2 && (w = 0);
        }
    }
  return p;
}
function ruleset(a, s, c, u, d, p, v, A, x, g, b, y) {
  for (var f = d - 1, m = d === 0 ? p : [""], C = sizeof(m), w = 0, S = 0, $ = 0; w < u; ++w)
    for (var T = 0, I = substr(a, f + 1, f = abs$1(S = v[w])), _ = a; T < C; ++T)
      (_ = trim(S > 0 ? m[T] + " " + I : replace(I, /&\f/g, m[T]))) && (x[$++] = _);
  return node(a, s, c, d === 0 ? RULESET : A, x, g, b, y);
}
function comment(a, s, c, u) {
  return node(a, s, c, COMMENT, from(char()), substr(a, 2, -2), 0, u);
}
function declaration(a, s, c, u, d) {
  return node(a, s, c, DECLARATION, substr(a, 0, u), substr(a, u + 1, -1), u, d);
}
function serialize(a, s) {
  for (var c = "", u = 0; u < a.length; u++)
    c += s(a[u], u, a, s) || "";
  return c;
}
function stringify$2(a, s, c, u) {
  switch (a.type) {
    case LAYER:
      if (a.children.length) break;
    case IMPORT:
    case NAMESPACE:
    case DECLARATION:
      return a.return = a.return || a.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return a.return = a.value + "{" + serialize(a.children, u) + "}";
    case RULESET:
      if (!strlen(a.value = a.props.join(","))) return "";
  }
  return strlen(c = serialize(a.children, u)) ? a.return = a.value + "{" + c + "}" : "";
}
var ATTR_CACHE_MAP = "data-ant-cssinjs-cache-path", CSS_FILE_STYLE = "_FILE_STYLE__", cachePathMap, fromCSSFile = !0;
function prepare() {
  if (!cachePathMap && (cachePathMap = {}, canUseDom$1())) {
    var a = document.createElement("div");
    a.className = ATTR_CACHE_MAP, a.style.position = "fixed", a.style.visibility = "hidden", a.style.top = "-9999px", document.body.appendChild(a);
    var s = getComputedStyle(a).content || "";
    s = s.replace(/^"/, "").replace(/"$/, ""), s.split(";").forEach(function(d) {
      var p = d.split(":"), v = _slicedToArray$e(p, 2), A = v[0], x = v[1];
      cachePathMap[A] = x;
    });
    var c = document.querySelector("style[".concat(ATTR_CACHE_MAP, "]"));
    if (c) {
      var u;
      fromCSSFile = !1, (u = c.parentNode) === null || u === void 0 || u.removeChild(c);
    }
    document.body.removeChild(a);
  }
}
function existPath(a) {
  return prepare(), !!cachePathMap[a];
}
function getStyleAndHash(a) {
  var s = cachePathMap[a], c = null;
  if (s && canUseDom$1())
    if (fromCSSFile)
      c = CSS_FILE_STYLE;
    else {
      var u = document.querySelector("style[".concat(ATTR_MARK, '="').concat(cachePathMap[a], '"]'));
      u ? c = u.innerHTML : delete cachePathMap[a];
    }
  return [c, s];
}
var SKIP_CHECK = "_skip_check_", MULTI_VALUE = "_multi_value_";
function normalizeStyle(a) {
  var s = serialize(compile(a), stringify$2);
  return s.replace(/\{%%%\:[^;];}/g, ";");
}
function isCompoundCSSProperty(a) {
  return _typeof$h(a) === "object" && a && (SKIP_CHECK in a || MULTI_VALUE in a);
}
function injectSelectorHash(a, s, c) {
  if (!s)
    return a;
  var u = ".".concat(s), d = c === "low" ? ":where(".concat(u, ")") : u, p = a.split(",").map(function(v) {
    var A, x = v.trim().split(/\s+/), g = x[0] || "", b = ((A = g.match(/^\w+/)) === null || A === void 0 ? void 0 : A[0]) || "";
    return g = "".concat(b).concat(d).concat(g.slice(b.length)), [g].concat(_toConsumableArray$e(x.slice(1))).join(" ");
  });
  return p.join(",");
}
var parseStyle = function a(s) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, d = u.root, p = u.injectHash, v = u.parentSelectors, A = c.hashId, x = c.layer;
  c.path;
  var g = c.hashPriority, b = c.transformers, y = b === void 0 ? [] : b;
  c.linters;
  var f = "", m = {};
  function C($) {
    var T = $.getName(A);
    if (!m[T]) {
      var I = a($.style, c, {
        root: !1,
        parentSelectors: v
      }), _ = _slicedToArray$e(I, 1), E = _[0];
      m[T] = "@keyframes ".concat($.getName(A)).concat(E);
    }
  }
  function w($) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return $.forEach(function(I) {
      Array.isArray(I) ? w(I, T) : I && T.push(I);
    }), T;
  }
  var S = w(Array.isArray(s) ? s : [s]);
  return S.forEach(function($) {
    var T = typeof $ == "string" && !d ? {} : $;
    if (typeof T == "string")
      f += "".concat(T, `
`);
    else if (T._keyframe)
      C(T);
    else {
      var I = y.reduce(function(_, E) {
        var R;
        return (E == null || (R = E.visit) === null || R === void 0 ? void 0 : R.call(E, _)) || _;
      }, T);
      Object.keys(I).forEach(function(_) {
        var E = I[_];
        if (_typeof$h(E) === "object" && E && (_ !== "animationName" || !E._keyframe) && !isCompoundCSSProperty(E)) {
          var R = !1, O = _.trim(), L = !1;
          (d || p) && A ? O.startsWith("@") ? R = !0 : O === "&" ? O = injectSelectorHash("", A, g) : O = injectSelectorHash(_, A, g) : d && !A && (O === "&" || O === "") && (O = "", L = !0);
          var B = a(E, c, {
            root: L,
            injectHash: R,
            parentSelectors: [].concat(_toConsumableArray$e(v), [O])
          }), F = _slicedToArray$e(B, 2), M = F[0], W = F[1];
          m = _objectSpread2$1(_objectSpread2$1({}, m), W), f += "".concat(O).concat(M);
        } else {
          let U = function(k, N) {
            var P = k.replace(/[A-Z]/g, function(H) {
              return "-".concat(H.toLowerCase());
            }), D = N;
            !unitlessKeys[k] && typeof D == "number" && D !== 0 && (D = "".concat(D, "px")), k === "animationName" && N !== null && N !== void 0 && N._keyframe && (C(N), D = N.getName(A)), f += "".concat(P, ":").concat(D, ";");
          };
          var j, G = (j = E?.value) !== null && j !== void 0 ? j : E;
          _typeof$h(E) === "object" && E !== null && E !== void 0 && E[MULTI_VALUE] && Array.isArray(G) ? G.forEach(function(k) {
            U(_, k);
          }) : U(_, G);
        }
      });
    }
  }), d ? x && (f && (f = "@layer ".concat(x.name, " {").concat(f, "}")), x.dependencies && (m["@layer ".concat(x.name)] = x.dependencies.map(function($) {
    return "@layer ".concat($, ", ").concat(x.name, ";");
  }).join(`
`))) : f = "{".concat(f, "}"), [f, m];
};
function uniqueHash(a, s) {
  return murmur2("".concat(a.join("%")).concat(s));
}
function Empty$2() {
  return null;
}
var STYLE_PREFIX = "style";
function useStyleRegister(a, s) {
  var c = a.token, u = a.path, d = a.hashId, p = a.layer, v = a.nonce, A = a.clientOnly, x = a.order, g = x === void 0 ? 0 : x, b = reactExports.useContext(StyleContext), y = b.autoClear;
  b.mock;
  var f = b.defaultCache, m = b.hashPriority, C = b.container, w = b.ssrInline, S = b.transformers, $ = b.linters, T = b.cache, I = b.layer, _ = c._tokenKey, E = [_];
  I && E.push("layer"), E.push.apply(E, _toConsumableArray$e(u));
  var R = isClientSide, O = useGlobalCache(
    STYLE_PREFIX,
    E,
    // Create cache if needed
    function() {
      var W = E.join("|");
      if (existPath(W)) {
        var j = getStyleAndHash(W), G = _slicedToArray$e(j, 2), U = G[0], k = G[1];
        if (U)
          return [U, _, k, {}, A, g];
      }
      var N = s(), P = parseStyle(N, {
        hashId: d,
        hashPriority: m,
        layer: I ? p : void 0,
        path: u.join("-"),
        transformers: S,
        linters: $
      }), D = _slicedToArray$e(P, 2), H = D[0], V = D[1], Z = normalizeStyle(H), ne = uniqueHash(E, Z);
      return [Z, _, ne, V, A, g];
    },
    // Remove cache if no need
    function(W, j) {
      var G = _slicedToArray$e(W, 3), U = G[2];
      (j || y) && isClientSide && removeCSS(U, {
        mark: ATTR_MARK
      });
    },
    // Effect: Inject style here
    function(W) {
      var j = _slicedToArray$e(W, 4), G = j[0];
      j[1];
      var U = j[2], k = j[3];
      if (R && G !== CSS_FILE_STYLE) {
        var N = {
          mark: ATTR_MARK,
          prepend: I ? !1 : "queue",
          attachTo: C,
          priority: g
        }, P = typeof v == "function" ? v() : v;
        P && (N.csp = {
          nonce: P
        });
        var D = [], H = [];
        Object.keys(k).forEach(function(Z) {
          Z.startsWith("@layer") ? D.push(Z) : H.push(Z);
        }), D.forEach(function(Z) {
          updateCSS(normalizeStyle(k[Z]), "_layer-".concat(Z), _objectSpread2$1(_objectSpread2$1({}, N), {}, {
            prepend: !0
          }));
        });
        var V = updateCSS(G, U, N);
        V[CSS_IN_JS_INSTANCE] = T.instanceId, V.setAttribute(ATTR_TOKEN, _), H.forEach(function(Z) {
          updateCSS(normalizeStyle(k[Z]), "_effect-".concat(Z), N);
        });
      }
    }
  ), L = _slicedToArray$e(O, 3), B = L[0], F = L[1], M = L[2];
  return function(W) {
    var j;
    if (!w || R || !f)
      j = /* @__PURE__ */ reactExports.createElement(Empty$2, null);
    else {
      var G;
      j = /* @__PURE__ */ reactExports.createElement("style", _extends$3({}, (G = {}, _defineProperty$a(G, ATTR_TOKEN, F), _defineProperty$a(G, ATTR_MARK, M), G), {
        dangerouslySetInnerHTML: {
          __html: B
        }
      }));
    }
    return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, j, W);
  };
}
var extract$1 = function a(s, c, u) {
  var d = _slicedToArray$e(s, 6), p = d[0], v = d[1], A = d[2], x = d[3], g = d[4], b = d[5], y = u || {}, f = y.plain;
  if (g)
    return null;
  var m = p, C = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(b)
  };
  return m = toStyleStr(p, v, A, C, f), x && Object.keys(x).forEach(function(w) {
    if (!c[w]) {
      c[w] = !0;
      var S = normalizeStyle(x[w]), $ = toStyleStr(S, v, "_effect-".concat(w), C, f);
      w.startsWith("@layer") ? m = $ + m : m += $;
    }
  }), [b, A, m];
}, CSS_VAR_PREFIX = "cssVar", useCSSVarRegister = function a(s, c) {
  var u = s.key, d = s.prefix, p = s.unitless, v = s.ignore, A = s.token, x = s.scope, g = x === void 0 ? "" : x, b = reactExports.useContext(StyleContext), y = b.cache.instanceId, f = b.container, m = A._tokenKey, C = [].concat(_toConsumableArray$e(s.path), [u, g, m]), w = useGlobalCache(CSS_VAR_PREFIX, C, function() {
    var S = c(), $ = transformToken(S, u, {
      prefix: d,
      unitless: p,
      ignore: v,
      scope: g
    }), T = _slicedToArray$e($, 2), I = T[0], _ = T[1], E = uniqueHash(C, _);
    return [I, _, E, u];
  }, function(S) {
    var $ = _slicedToArray$e(S, 3), T = $[2];
    isClientSide && removeCSS(T, {
      mark: ATTR_MARK
    });
  }, function(S) {
    var $ = _slicedToArray$e(S, 3), T = $[1], I = $[2];
    if (T) {
      var _ = updateCSS(T, I, {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: f,
        priority: -999
      });
      _[CSS_IN_JS_INSTANCE] = y, _.setAttribute(ATTR_TOKEN, u);
    }
  });
  return w;
}, extract = function a(s, c, u) {
  var d = _slicedToArray$e(s, 4), p = d[1], v = d[2], A = d[3], x = u || {}, g = x.plain;
  if (!p)
    return null;
  var b = -999, y = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(b)
  }, f = toStyleStr(p, A, v, y, g);
  return [b, v, f];
}, _ExtractStyleFns;
_ExtractStyleFns = {}, _defineProperty$a(_ExtractStyleFns, STYLE_PREFIX, extract$1), _defineProperty$a(_ExtractStyleFns, TOKEN_PREFIX, extract$2), _defineProperty$a(_ExtractStyleFns, CSS_VAR_PREFIX, extract);
var Keyframe = /* @__PURE__ */ function() {
  function a(s, c) {
    _classCallCheck$1(this, a), _defineProperty$a(this, "name", void 0), _defineProperty$a(this, "style", void 0), _defineProperty$a(this, "_keyframe", !0), this.name = s, this.style = c;
  }
  return _createClass$1(a, [{
    key: "getName",
    value: function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return c ? "".concat(c, "-").concat(this.name) : this.name;
    }
  }]), a;
}();
function noSplit(a) {
  return a.notSplit = !0, a;
}
noSplit(["borderTop", "borderBottom"]), noSplit(["borderTop"]), noSplit(["borderBottom"]), noSplit(["borderLeft", "borderRight"]), noSplit(["borderLeft"]), noSplit(["borderRight"]);
var IconContext = /* @__PURE__ */ reactExports.createContext({});
function _toArray$1(a) {
  return _arrayWithHoles$f(a) || _iterableToArray$e(a) || _unsupportedIterableToArray$m(a) || _nonIterableRest$f();
}
function get$1(a, s) {
  for (var c = a, u = 0; u < s.length; u += 1) {
    if (c == null)
      return;
    c = c[s[u]];
  }
  return c;
}
function internalSet(a, s, c, u) {
  if (!s.length)
    return c;
  var d = _toArray$1(s), p = d[0], v = d.slice(1), A;
  return !a && typeof p == "number" ? A = [] : Array.isArray(a) ? A = _toConsumableArray$e(a) : A = _objectSpread2$1({}, a), u && c === void 0 && v.length === 1 ? delete A[p][v[0]] : A[p] = internalSet(A[p], v, c, u), A;
}
function set$1(a, s, c) {
  var u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return s.length && u && c === void 0 && !get$1(a, s.slice(0, -1)) ? a : internalSet(a, s, c, u);
}
function isObject$4(a) {
  return _typeof$h(a) === "object" && a !== null && Object.getPrototypeOf(a) === Object.prototype;
}
function createEmpty(a) {
  return Array.isArray(a) ? [] : {};
}
var keys$1 = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function merge$1() {
  for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
    s[c] = arguments[c];
  var u = createEmpty(s[0]);
  return s.forEach(function(d) {
    function p(v, A) {
      var x = new Set(A), g = get$1(d, v), b = Array.isArray(g);
      if (b || isObject$4(g)) {
        if (!x.has(g)) {
          x.add(g);
          var y = get$1(u, v);
          b ? u = set$1(u, v, []) : (!y || _typeof$h(y) !== "object") && (u = set$1(u, v, createEmpty(g))), keys$1(g).forEach(function(f) {
            p([].concat(_toConsumableArray$e(v), [f]), x);
          });
        }
      } else
        u = set$1(u, v, g);
    }
    p([]);
  }), u;
}
function noop$5() {
}
const WarningContext = /* @__PURE__ */ reactExports.createContext({}), devUseWarning = () => {
  const a = () => {
  };
  return a.deprecated = noop$5, a;
}, ValidateMessagesContext = /* @__PURE__ */ reactExports.createContext(void 0);
var locale$4 = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, commonLocale = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
}, locale$3 = _objectSpread2$1(_objectSpread2$1({}, commonLocale), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  week: "Week",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
const locale$2 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, locale$1 = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, locale$3),
  timePickerLocale: Object.assign({}, locale$2)
}, typeTemplate$2 = "${label} is not a valid ${type}", localeValues = {
  locale: "en",
  Pagination: locale$4,
  DatePicker: locale$1,
  TimePicker: locale$2,
  Calendar: locale$1,
  global: {
    placeholder: "Please select",
    close: "Close"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckAll: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate$2,
        method: typeTemplate$2,
        array: typeTemplate$2,
        object: typeTemplate$2,
        number: typeTemplate$2,
        date: typeTemplate$2,
        boolean: typeTemplate$2,
        integer: typeTemplate$2,
        float: typeTemplate$2,
        regexp: typeTemplate$2,
        email: typeTemplate$2,
        url: typeTemplate$2,
        hex: typeTemplate$2
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
Object.assign({}, localeValues.Modal);
let localeList = [];
const generateLocale = () => localeList.reduce((a, s) => Object.assign(Object.assign({}, a), s), localeValues.Modal);
function changeConfirmLocale(a) {
  if (a) {
    const s = Object.assign({}, a);
    return localeList.push(s), generateLocale(), () => {
      localeList = localeList.filter((c) => c !== s), generateLocale();
    };
  }
  Object.assign({}, localeValues.Modal);
}
const LocaleContext = /* @__PURE__ */ reactExports.createContext(void 0), useLocale$1 = (a, s) => {
  const c = reactExports.useContext(LocaleContext), u = reactExports.useMemo(() => {
    var p;
    const v = s || localeValues[a], A = (p = c?.[a]) !== null && p !== void 0 ? p : {};
    return Object.assign(Object.assign({}, typeof v == "function" ? v() : v), A || {});
  }, [a, s, c]), d = reactExports.useMemo(() => {
    const p = c?.locale;
    return c?.exist && !p ? localeValues.locale : p;
  }, [c]);
  return [u, d];
}, ANT_MARK = "internalMark", LocaleProvider = (a) => {
  const {
    locale: s = {},
    children: c,
    _ANT_MARK__: u
  } = a;
  reactExports.useEffect(() => changeConfirmLocale(s?.Modal), [s]);
  const d = reactExports.useMemo(() => Object.assign(Object.assign({}, s), {
    exist: !0
  }), [s]);
  return /* @__PURE__ */ reactExports.createElement(LocaleContext.Provider, {
    value: d
  }, c);
}, defaultPresetColors = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), round = Math.round;
function splitColorStr(a, s) {
  const c = a.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], u = c.map((d) => parseFloat(d));
  for (let d = 0; d < 3; d += 1)
    u[d] = s(u[d] || 0, c[d] || "", d);
  return c[3] ? u[3] = c[3].includes("%") ? u[3] / 100 : u[3] : u[3] = 1, u;
}
const parseHSVorHSL = (a, s, c) => c === 0 ? a : a / 100;
function limitRange(a, s) {
  const c = s || 255;
  return a > c ? c : a < 0 ? 0 : a;
}
class FastColor {
  constructor(s) {
    _defineProperty$a(this, "isValid", !0), _defineProperty$a(this, "r", 0), _defineProperty$a(this, "g", 0), _defineProperty$a(this, "b", 0), _defineProperty$a(this, "a", 1), _defineProperty$a(this, "_h", void 0), _defineProperty$a(this, "_s", void 0), _defineProperty$a(this, "_l", void 0), _defineProperty$a(this, "_v", void 0), _defineProperty$a(this, "_max", void 0), _defineProperty$a(this, "_min", void 0), _defineProperty$a(this, "_brightness", void 0);
    function c(u) {
      return u[0] in s && u[1] in s && u[2] in s;
    }
    if (s) if (typeof s == "string") {
      let d = function(p) {
        return u.startsWith(p);
      };
      const u = s.trim();
      /^#?[A-F\d]{3,8}$/i.test(u) ? this.fromHexString(u) : d("rgb") ? this.fromRgbString(u) : d("hsl") ? this.fromHslString(u) : (d("hsv") || d("hsb")) && this.fromHsvString(u);
    } else if (s instanceof FastColor)
      this.r = s.r, this.g = s.g, this.b = s.b, this.a = s.a, this._h = s._h, this._s = s._s, this._l = s._l, this._v = s._v;
    else if (c("rgb"))
      this.r = limitRange(s.r), this.g = limitRange(s.g), this.b = limitRange(s.b), this.a = typeof s.a == "number" ? limitRange(s.a, 1) : 1;
    else if (c("hsl"))
      this.fromHsl(s);
    else if (c("hsv"))
      this.fromHsv(s);
    else
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(s));
  }
  // ======================= Setter =======================
  setR(s) {
    return this._sc("r", s);
  }
  setG(s) {
    return this._sc("g", s);
  }
  setB(s) {
    return this._sc("b", s);
  }
  setA(s) {
    return this._sc("a", s, 1);
  }
  setHue(s) {
    const c = this.toHsv();
    return c.h = s, this._c(c);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function s(p) {
      const v = p / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    }
    const c = s(this.r), u = s(this.g), d = s(this.b);
    return 0.2126 * c + 0.7152 * u + 0.0722 * d;
  }
  getHue() {
    if (typeof this._h > "u") {
      const s = this.getMax() - this.getMin();
      s === 0 ? this._h = 0 : this._h = round(60 * (this.r === this.getMax() ? (this.g - this.b) / s + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / s + 2 : (this.r - this.g) / s + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const s = this.getMax() - this.getMin();
      s === 0 ? this._s = 0 : this._s = s / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(s = 10) {
    const c = this.getHue(), u = this.getSaturation();
    let d = this.getLightness() - s / 100;
    return d < 0 && (d = 0), this._c({
      h: c,
      s: u,
      l: d,
      a: this.a
    });
  }
  lighten(s = 10) {
    const c = this.getHue(), u = this.getSaturation();
    let d = this.getLightness() + s / 100;
    return d > 1 && (d = 1), this._c({
      h: c,
      s: u,
      l: d,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(s, c = 50) {
    const u = this._c(s), d = c / 100, p = (A) => (u[A] - this[A]) * d + this[A], v = {
      r: round(p("r")),
      g: round(p("g")),
      b: round(p("b")),
      a: round(p("a") * 100) / 100
    };
    return this._c(v);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(s = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, s);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(s = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, s);
  }
  onBackground(s) {
    const c = this._c(s), u = this.a + c.a * (1 - this.a), d = (p) => round((this[p] * this.a + c[p] * c.a * (1 - this.a)) / u);
    return this._c({
      r: d("r"),
      g: d("g"),
      b: d("b"),
      a: u
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(s) {
    return this.r === s.r && this.g === s.g && this.b === s.b && this.a === s.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let s = "#";
    const c = (this.r || 0).toString(16);
    s += c.length === 2 ? c : "0" + c;
    const u = (this.g || 0).toString(16);
    s += u.length === 2 ? u : "0" + u;
    const d = (this.b || 0).toString(16);
    if (s += d.length === 2 ? d : "0" + d, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const p = round(this.a * 255).toString(16);
      s += p.length === 2 ? p : "0" + p;
    }
    return s;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const s = this.getHue(), c = round(this.getSaturation() * 100), u = round(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${s},${c}%,${u}%,${this.a})` : `hsl(${s},${c}%,${u}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(s, c, u) {
    const d = this.clone();
    return d[s] = limitRange(c, u), d;
  }
  _c(s) {
    return new this.constructor(s);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(s) {
    const c = s.replace("#", "");
    function u(d, p) {
      return parseInt(c[d] + c[p || d], 16);
    }
    c.length < 6 ? (this.r = u(0), this.g = u(1), this.b = u(2), this.a = c[3] ? u(3) / 255 : 1) : (this.r = u(0, 1), this.g = u(2, 3), this.b = u(4, 5), this.a = c[6] ? u(6, 7) / 255 : 1);
  }
  fromHsl({
    h: s,
    s: c,
    l: u,
    a: d
  }) {
    if (this._h = s % 360, this._s = c, this._l = u, this.a = typeof d == "number" ? d : 1, c <= 0) {
      const f = round(u * 255);
      this.r = f, this.g = f, this.b = f;
    }
    let p = 0, v = 0, A = 0;
    const x = s / 60, g = (1 - Math.abs(2 * u - 1)) * c, b = g * (1 - Math.abs(x % 2 - 1));
    x >= 0 && x < 1 ? (p = g, v = b) : x >= 1 && x < 2 ? (p = b, v = g) : x >= 2 && x < 3 ? (v = g, A = b) : x >= 3 && x < 4 ? (v = b, A = g) : x >= 4 && x < 5 ? (p = b, A = g) : x >= 5 && x < 6 && (p = g, A = b);
    const y = u - g / 2;
    this.r = round((p + y) * 255), this.g = round((v + y) * 255), this.b = round((A + y) * 255);
  }
  fromHsv({
    h: s,
    s: c,
    v: u,
    a: d
  }) {
    this._h = s % 360, this._s = c, this._v = u, this.a = typeof d == "number" ? d : 1;
    const p = round(u * 255);
    if (this.r = p, this.g = p, this.b = p, c <= 0)
      return;
    const v = s / 60, A = Math.floor(v), x = v - A, g = round(u * (1 - c) * 255), b = round(u * (1 - c * x) * 255), y = round(u * (1 - c * (1 - x)) * 255);
    switch (A) {
      case 0:
        this.g = y, this.b = g;
        break;
      case 1:
        this.r = b, this.b = g;
        break;
      case 2:
        this.r = g, this.b = y;
        break;
      case 3:
        this.r = g, this.g = b;
        break;
      case 4:
        this.r = y, this.g = g;
        break;
      case 5:
      default:
        this.g = g, this.b = b;
        break;
    }
  }
  fromHsvString(s) {
    const c = splitColorStr(s, parseHSVorHSL);
    this.fromHsv({
      h: c[0],
      s: c[1],
      v: c[2],
      a: c[3]
    });
  }
  fromHslString(s) {
    const c = splitColorStr(s, parseHSVorHSL);
    this.fromHsl({
      h: c[0],
      s: c[1],
      l: c[2],
      a: c[3]
    });
  }
  fromRgbString(s) {
    const c = splitColorStr(s, (u, d) => (
      // Convert percentage to number. e.g. 50% -> 128
      d.includes("%") ? round(u / 100 * 255) : u
    ));
    this.r = c[0], this.g = c[1], this.b = c[2], this.a = c[3];
  }
}
var hueStep$1 = 2, saturationStep$1 = 0.16, saturationStep2$1 = 0.05, brightnessStep1$1 = 0.05, brightnessStep2$1 = 0.15, lightColorCount$1 = 5, darkColorCount$1 = 4, darkColorMap$1 = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function getHue$1(a, s, c) {
  var u;
  return Math.round(a.h) >= 60 && Math.round(a.h) <= 240 ? u = c ? Math.round(a.h) - hueStep$1 * s : Math.round(a.h) + hueStep$1 * s : u = c ? Math.round(a.h) + hueStep$1 * s : Math.round(a.h) - hueStep$1 * s, u < 0 ? u += 360 : u >= 360 && (u -= 360), u;
}
function getSaturation$1(a, s, c) {
  if (a.h === 0 && a.s === 0)
    return a.s;
  var u;
  return c ? u = a.s - saturationStep$1 * s : s === darkColorCount$1 ? u = a.s + saturationStep$1 : u = a.s + saturationStep2$1 * s, u > 1 && (u = 1), c && s === lightColorCount$1 && u > 0.1 && (u = 0.1), u < 0.06 && (u = 0.06), Math.round(u * 100) / 100;
}
function getValue$3(a, s, c) {
  var u;
  return c ? u = a.v + brightnessStep1$1 * s : u = a.v - brightnessStep2$1 * s, u = Math.max(0, Math.min(1, u)), Math.round(u * 100) / 100;
}
function generate$2(a) {
  for (var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = [], u = new FastColor(a), d = u.toHsv(), p = lightColorCount$1; p > 0; p -= 1) {
    var v = new FastColor({
      h: getHue$1(d, p, !0),
      s: getSaturation$1(d, p, !0),
      v: getValue$3(d, p, !0)
    });
    c.push(v);
  }
  c.push(u);
  for (var A = 1; A <= darkColorCount$1; A += 1) {
    var x = new FastColor({
      h: getHue$1(d, A),
      s: getSaturation$1(d, A),
      v: getValue$3(d, A)
    });
    c.push(x);
  }
  return s.theme === "dark" ? darkColorMap$1.map(function(g) {
    var b = g.index, y = g.amount;
    return new FastColor(s.backgroundColor || "#141414").mix(c[b], y).toHexString();
  }) : c.map(function(g) {
    return g.toHexString();
  });
}
var presetPrimaryColors$1 = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, red$1 = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
red$1.primary = red$1[5];
var volcano$1 = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
volcano$1.primary = volcano$1[5];
var orange$1 = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
orange$1.primary = orange$1[5];
var gold$1 = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
gold$1.primary = gold$1[5];
var yellow$1 = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
yellow$1.primary = yellow$1[5];
var lime$1 = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
lime$1.primary = lime$1[5];
var green$1 = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
green$1.primary = green$1[5];
var cyan$1 = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
cyan$1.primary = cyan$1[5];
var blue$1 = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
blue$1.primary = blue$1[5];
var geekblue$1 = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
geekblue$1.primary = geekblue$1[5];
var purple$1 = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
purple$1.primary = purple$1[5];
var magenta$1 = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
magenta$1.primary = magenta$1[5];
var grey$1 = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
grey$1.primary = grey$1[5];
var presetPalettes$1 = {
  red: red$1,
  volcano: volcano$1,
  orange: orange$1,
  gold: gold$1,
  yellow: yellow$1,
  lime: lime$1,
  green: green$1,
  cyan: cyan$1,
  blue: blue$1,
  geekblue: geekblue$1,
  purple: purple$1,
  magenta: magenta$1,
  grey: grey$1
};
function genColorMapToken(a, {
  generateColorPalettes: s,
  generateNeutralColorPalettes: c
}) {
  const {
    colorSuccess: u,
    colorWarning: d,
    colorError: p,
    colorInfo: v,
    colorPrimary: A,
    colorBgBase: x,
    colorTextBase: g
  } = a, b = s(A), y = s(u), f = s(d), m = s(p), C = s(v), w = c(x, g), S = a.colorLink || a.colorInfo, $ = s(S), T = new FastColor(m[1]).mix(new FastColor(m[3]), 50).toHexString();
  return Object.assign(Object.assign({}, w), {
    colorPrimaryBg: b[1],
    colorPrimaryBgHover: b[2],
    colorPrimaryBorder: b[3],
    colorPrimaryBorderHover: b[4],
    colorPrimaryHover: b[5],
    colorPrimary: b[6],
    colorPrimaryActive: b[7],
    colorPrimaryTextHover: b[8],
    colorPrimaryText: b[9],
    colorPrimaryTextActive: b[10],
    colorSuccessBg: y[1],
    colorSuccessBgHover: y[2],
    colorSuccessBorder: y[3],
    colorSuccessBorderHover: y[4],
    colorSuccessHover: y[4],
    colorSuccess: y[6],
    colorSuccessActive: y[7],
    colorSuccessTextHover: y[8],
    colorSuccessText: y[9],
    colorSuccessTextActive: y[10],
    colorErrorBg: m[1],
    colorErrorBgHover: m[2],
    colorErrorBgFilledHover: T,
    colorErrorBgActive: m[3],
    colorErrorBorder: m[3],
    colorErrorBorderHover: m[4],
    colorErrorHover: m[5],
    colorError: m[6],
    colorErrorActive: m[7],
    colorErrorTextHover: m[8],
    colorErrorText: m[9],
    colorErrorTextActive: m[10],
    colorWarningBg: f[1],
    colorWarningBgHover: f[2],
    colorWarningBorder: f[3],
    colorWarningBorderHover: f[4],
    colorWarningHover: f[4],
    colorWarning: f[6],
    colorWarningActive: f[7],
    colorWarningTextHover: f[8],
    colorWarningText: f[9],
    colorWarningTextActive: f[10],
    colorInfoBg: C[1],
    colorInfoBgHover: C[2],
    colorInfoBorder: C[3],
    colorInfoBorderHover: C[4],
    colorInfoHover: C[4],
    colorInfo: C[6],
    colorInfoActive: C[7],
    colorInfoTextHover: C[8],
    colorInfoText: C[9],
    colorInfoTextActive: C[10],
    colorLinkHover: $[4],
    colorLink: $[6],
    colorLinkActive: $[7],
    colorBgMask: new FastColor("#000").setA(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const genRadius = (a) => {
  let s = a, c = a, u = a, d = a;
  return a < 6 && a >= 5 ? s = a + 1 : a < 16 && a >= 6 ? s = a + 2 : a >= 16 && (s = 16), a < 7 && a >= 5 ? c = 4 : a < 8 && a >= 7 ? c = 5 : a < 14 && a >= 8 ? c = 6 : a < 16 && a >= 14 ? c = 7 : a >= 16 && (c = 8), a < 6 && a >= 2 ? u = 1 : a >= 6 && (u = 2), a > 4 && a < 8 ? d = 4 : a >= 8 && (d = 6), {
    borderRadius: a,
    borderRadiusXS: u,
    borderRadiusSM: c,
    borderRadiusLG: s,
    borderRadiusOuter: d
  };
};
function genCommonMapToken(a) {
  const {
    motionUnit: s,
    motionBase: c,
    borderRadius: u,
    lineWidth: d
  } = a;
  return Object.assign({
    // motion
    motionDurationFast: `${(c + s).toFixed(1)}s`,
    motionDurationMid: `${(c + s * 2).toFixed(1)}s`,
    motionDurationSlow: `${(c + s * 3).toFixed(1)}s`,
    // line
    lineWidthBold: d + 1
  }, genRadius(u));
}
const genControlHeight = (a) => {
  const {
    controlHeight: s
  } = a;
  return {
    controlHeightSM: s * 0.75,
    controlHeightXS: s * 0.5,
    controlHeightLG: s * 1.25
  };
};
function getLineHeight(a) {
  return (a + 8) / a;
}
function getFontSizes(a) {
  const s = Array.from({
    length: 10
  }).map((c, u) => {
    const d = u - 1, p = a * Math.pow(Math.E, d / 5), v = u > 1 ? Math.floor(p) : Math.ceil(p);
    return Math.floor(v / 2) * 2;
  });
  return s[1] = a, s.map((c) => ({
    size: c,
    lineHeight: getLineHeight(c)
  }));
}
const genFontMapToken = (a) => {
  const s = getFontSizes(a), c = s.map((b) => b.size), u = s.map((b) => b.lineHeight), d = c[1], p = c[0], v = c[2], A = u[1], x = u[0], g = u[2];
  return {
    fontSizeSM: p,
    fontSize: d,
    fontSizeLG: v,
    fontSizeXL: c[3],
    fontSizeHeading1: c[6],
    fontSizeHeading2: c[5],
    fontSizeHeading3: c[4],
    fontSizeHeading4: c[3],
    fontSizeHeading5: c[2],
    lineHeight: A,
    lineHeightLG: g,
    lineHeightSM: x,
    fontHeight: Math.round(A * d),
    fontHeightLG: Math.round(g * v),
    fontHeightSM: Math.round(x * p),
    lineHeightHeading1: u[6],
    lineHeightHeading2: u[5],
    lineHeightHeading3: u[4],
    lineHeightHeading4: u[3],
    lineHeightHeading5: u[2]
  };
};
function genSizeMapToken$1(a) {
  const {
    sizeUnit: s,
    sizeStep: c
  } = a;
  return {
    sizeXXL: s * (c + 8),
    // 48
    sizeXL: s * (c + 4),
    // 32
    sizeLG: s * (c + 2),
    // 24
    sizeMD: s * (c + 1),
    // 20
    sizeMS: s * c,
    // 16
    size: s * c,
    // 16
    sizeSM: s * (c - 1),
    // 12
    sizeXS: s * (c - 2),
    // 8
    sizeXXS: s * (c - 3)
    // 4
  };
}
const getAlphaColor$2 = (a, s) => new FastColor(a).setA(s).toRgbString(), getSolidColor$1 = (a, s) => new FastColor(a).darken(s).toHexString(), generateColorPalettes$1 = (a) => {
  const s = generate$2(a);
  return {
    1: s[0],
    2: s[1],
    3: s[2],
    4: s[3],
    5: s[4],
    6: s[5],
    7: s[6],
    8: s[4],
    9: s[5],
    10: s[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, generateNeutralColorPalettes$1 = (a, s) => {
  const c = a || "#fff", u = s || "#000";
  return {
    colorBgBase: c,
    colorTextBase: u,
    colorText: getAlphaColor$2(u, 0.88),
    colorTextSecondary: getAlphaColor$2(u, 0.65),
    colorTextTertiary: getAlphaColor$2(u, 0.45),
    colorTextQuaternary: getAlphaColor$2(u, 0.25),
    colorFill: getAlphaColor$2(u, 0.15),
    colorFillSecondary: getAlphaColor$2(u, 0.06),
    colorFillTertiary: getAlphaColor$2(u, 0.04),
    colorFillQuaternary: getAlphaColor$2(u, 0.02),
    colorBgSolid: getAlphaColor$2(u, 1),
    colorBgSolidHover: getAlphaColor$2(u, 0.75),
    colorBgSolidActive: getAlphaColor$2(u, 0.95),
    colorBgLayout: getSolidColor$1(c, 4),
    colorBgContainer: getSolidColor$1(c, 0),
    colorBgElevated: getSolidColor$1(c, 0),
    colorBgSpotlight: getAlphaColor$2(u, 0.85),
    colorBgBlur: "transparent",
    colorBorder: getSolidColor$1(c, 15),
    colorBorderSecondary: getSolidColor$1(c, 6)
  };
};
function derivative$2(a) {
  presetPrimaryColors$1.pink = presetPrimaryColors$1.magenta, presetPalettes$1.pink = presetPalettes$1.magenta;
  const s = Object.keys(defaultPresetColors).map((c) => {
    const u = a[c] === presetPrimaryColors$1[c] ? presetPalettes$1[c] : generate$2(a[c]);
    return Array.from({
      length: 10
    }, () => 1).reduce((d, p, v) => (d[`${c}-${v + 1}`] = u[v], d[`${c}${v + 1}`] = u[v], d), {});
  }).reduce((c, u) => (c = Object.assign(Object.assign({}, c), u), c), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, a), s), genColorMapToken(a, {
    generateColorPalettes: generateColorPalettes$1,
    generateNeutralColorPalettes: generateNeutralColorPalettes$1
  })), genFontMapToken(a.fontSize)), genSizeMapToken$1(a)), genControlHeight(a)), genCommonMapToken(a));
}
const defaultTheme$1 = createTheme(derivative$2), defaultConfig = {
  token: seedToken,
  override: {
    override: seedToken
  },
  hashed: !0
}, DesignTokenContext = /* @__PURE__ */ React.createContext(defaultConfig), defaultPrefixCls = "ant", defaultIconPrefixCls = "anticon", Variants = ["outlined", "borderless", "filled", "underlined"], defaultGetPrefixCls = (a, s) => s || (a ? `${defaultPrefixCls}-${a}` : defaultPrefixCls), ConfigContext$1 = /* @__PURE__ */ reactExports.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  iconPrefixCls: defaultIconPrefixCls
}), {
  Consumer: ConfigConsumer
} = ConfigContext$1, EMPTY_OBJECT = {};
function useComponentConfig(a) {
  const s = reactExports.useContext(ConfigContext$1), {
    getPrefixCls: c,
    direction: u,
    getPopupContainer: d
  } = s, p = s[a];
  return Object.assign(Object.assign({
    classNames: EMPTY_OBJECT,
    styles: EMPTY_OBJECT
  }, p), {
    getPrefixCls: c,
    direction: u,
    getPopupContainer: d
  });
}
const dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function getStyle$2(a, s) {
  const c = {}, u = (v, A) => {
    let x = v.clone();
    return x = A?.(x) || x, x.toRgbString();
  }, d = (v, A) => {
    const x = new FastColor(v), g = generate$2(x.toRgbString());
    c[`${A}-color`] = u(x), c[`${A}-color-disabled`] = g[1], c[`${A}-color-hover`] = g[4], c[`${A}-color-active`] = g[6], c[`${A}-color-outline`] = x.clone().setA(0.2).toRgbString(), c[`${A}-color-deprecated-bg`] = g[0], c[`${A}-color-deprecated-border`] = g[2];
  };
  if (s.primaryColor) {
    d(s.primaryColor, "primary");
    const v = new FastColor(s.primaryColor), A = generate$2(v.toRgbString());
    A.forEach((g, b) => {
      c[`primary-${b + 1}`] = g;
    }), c["primary-color-deprecated-l-35"] = u(v, (g) => g.lighten(35)), c["primary-color-deprecated-l-20"] = u(v, (g) => g.lighten(20)), c["primary-color-deprecated-t-20"] = u(v, (g) => g.tint(20)), c["primary-color-deprecated-t-50"] = u(v, (g) => g.tint(50)), c["primary-color-deprecated-f-12"] = u(v, (g) => g.setA(g.a * 0.12));
    const x = new FastColor(A[0]);
    c["primary-color-active-deprecated-f-30"] = u(x, (g) => g.setA(g.a * 0.3)), c["primary-color-active-deprecated-d-02"] = u(x, (g) => g.darken(2));
  }
  return s.successColor && d(s.successColor, "success"), s.warningColor && d(s.warningColor, "warning"), s.errorColor && d(s.errorColor, "error"), s.infoColor && d(s.infoColor, "info"), `
  :root {
    ${Object.keys(c).map((v) => `--${a}-${v}: ${c[v]};`).join(`
`)}
  }
  `.trim();
}
function registerTheme(a, s) {
  const c = getStyle$2(a, s);
  canUseDom$1() && updateCSS(c, `${dynamicStyleMark}-dynamic-theme`);
}
const DisabledContext = /* @__PURE__ */ reactExports.createContext(!1), DisabledContextProvider = ({
  children: a,
  disabled: s
}) => {
  const c = reactExports.useContext(DisabledContext);
  return /* @__PURE__ */ reactExports.createElement(DisabledContext.Provider, {
    value: s ?? c
  }, a);
}, SizeContext = /* @__PURE__ */ reactExports.createContext(void 0), SizeContextProvider = ({
  children: a,
  size: s
}) => {
  const c = reactExports.useContext(SizeContext);
  return /* @__PURE__ */ reactExports.createElement(SizeContext.Provider, {
    value: s || c
  }, a);
};
function useConfig() {
  const a = reactExports.useContext(DisabledContext), s = reactExports.useContext(SizeContext);
  return {
    componentDisabled: a,
    componentSize: s
  };
}
var AbstractCalculator = /* @__PURE__ */ _createClass$1(function a() {
  _classCallCheck$1(this, a);
}), CALC_UNIT = "CALC_UNIT", regexp$1 = new RegExp(CALC_UNIT, "g");
function unit(a) {
  return typeof a == "number" ? "".concat(a).concat(CALC_UNIT) : a;
}
var CSSCalculator = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c(u, d) {
    var p;
    _classCallCheck$1(this, c), p = s.call(this), _defineProperty$a(_assertThisInitialized(p), "result", ""), _defineProperty$a(_assertThisInitialized(p), "unitlessCssVar", void 0), _defineProperty$a(_assertThisInitialized(p), "lowPriority", void 0);
    var v = _typeof$h(u);
    return p.unitlessCssVar = d, u instanceof c ? p.result = "(".concat(u.result, ")") : v === "number" ? p.result = unit(u) : v === "string" && (p.result = u), p;
  }
  return _createClass$1(c, [{
    key: "add",
    value: function(d) {
      return d instanceof c ? this.result = "".concat(this.result, " + ").concat(d.getResult()) : (typeof d == "number" || typeof d == "string") && (this.result = "".concat(this.result, " + ").concat(unit(d))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(d) {
      return d instanceof c ? this.result = "".concat(this.result, " - ").concat(d.getResult()) : (typeof d == "number" || typeof d == "string") && (this.result = "".concat(this.result, " - ").concat(unit(d))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(d) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), d instanceof c ? this.result = "".concat(this.result, " * ").concat(d.getResult(!0)) : (typeof d == "number" || typeof d == "string") && (this.result = "".concat(this.result, " * ").concat(d)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(d) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), d instanceof c ? this.result = "".concat(this.result, " / ").concat(d.getResult(!0)) : (typeof d == "number" || typeof d == "string") && (this.result = "".concat(this.result, " / ").concat(d)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(d) {
      return this.lowPriority || d ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(d) {
      var p = this, v = d || {}, A = v.unit, x = !0;
      return typeof A == "boolean" ? x = A : Array.from(this.unitlessCssVar).some(function(g) {
        return p.result.includes(g);
      }) && (x = !1), this.result = this.result.replace(regexp$1, x ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), c;
}(AbstractCalculator), NumCalculator = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c(u) {
    var d;
    return _classCallCheck$1(this, c), d = s.call(this), _defineProperty$a(_assertThisInitialized(d), "result", 0), u instanceof c ? d.result = u.result : typeof u == "number" && (d.result = u), d;
  }
  return _createClass$1(c, [{
    key: "add",
    value: function(d) {
      return d instanceof c ? this.result += d.result : typeof d == "number" && (this.result += d), this;
    }
  }, {
    key: "sub",
    value: function(d) {
      return d instanceof c ? this.result -= d.result : typeof d == "number" && (this.result -= d), this;
    }
  }, {
    key: "mul",
    value: function(d) {
      return d instanceof c ? this.result *= d.result : typeof d == "number" && (this.result *= d), this;
    }
  }, {
    key: "div",
    value: function(d) {
      return d instanceof c ? this.result /= d.result : typeof d == "number" && (this.result /= d), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), c;
}(AbstractCalculator), genCalc = function a(s, c) {
  var u = s === "css" ? CSSCalculator : NumCalculator;
  return function(d) {
    return new u(d, c);
  };
}, getCompVarPrefix = function a(s, c) {
  return "".concat([c, s.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function useEvent(a) {
  var s = reactExports.useRef();
  s.current = a;
  var c = reactExports.useCallback(function() {
    for (var u, d = arguments.length, p = new Array(d), v = 0; v < d; v++)
      p[v] = arguments[v];
    return (u = s.current) === null || u === void 0 ? void 0 : u.call.apply(u, [s].concat(p));
  }, []);
  return c;
}
function useSafeState(a) {
  var s = reactExports.useRef(!1), c = reactExports.useState(a), u = _slicedToArray$e(c, 2), d = u[0], p = u[1];
  reactExports.useEffect(function() {
    return s.current = !1, function() {
      s.current = !0;
    };
  }, []);
  function v(A, x) {
    x && s.current || p(A);
  }
  return [d, v];
}
function hasValue$1(a) {
  return a !== void 0;
}
function useMergedState(a, s) {
  var c = s || {}, u = c.defaultValue, d = c.value, p = c.onChange, v = c.postState, A = useSafeState(function() {
    return hasValue$1(d) ? d : hasValue$1(u) ? typeof u == "function" ? u() : u : typeof a == "function" ? a() : a;
  }), x = _slicedToArray$e(A, 2), g = x[0], b = x[1], y = d !== void 0 ? d : g, f = v ? v(y) : y, m = useEvent(p), C = useSafeState([y]), w = _slicedToArray$e(C, 2), S = w[0], $ = w[1];
  useLayoutUpdateEffect(function() {
    var I = S[0];
    g !== I && m(g, I);
  }, [S]), useLayoutUpdateEffect(function() {
    hasValue$1(d) || b(d);
  }, [d]);
  var T = useEvent(function(I, _) {
    b(I, _), $([y], _);
  });
  return [f, T];
}
function getComponentToken(a, s, c, u) {
  var d = _objectSpread2$1({}, s[a]);
  if (u != null && u.deprecatedTokens) {
    var p = u.deprecatedTokens;
    p.forEach(function(A) {
      var x = _slicedToArray$e(A, 2), g = x[0], b = x[1];
      if (d != null && d[g] || d != null && d[b]) {
        var y;
        (y = d[b]) !== null && y !== void 0 || (d[b] = d?.[g]);
      }
    });
  }
  var v = _objectSpread2$1(_objectSpread2$1({}, c), d);
  return Object.keys(v).forEach(function(A) {
    v[A] === s[A] && delete v[A];
  }), v;
}
var enableStatistic = typeof CSSINJS_STATISTIC < "u", recording = !0;
function merge() {
  for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
    s[c] = arguments[c];
  if (!enableStatistic)
    return Object.assign.apply(Object, [{}].concat(s));
  recording = !1;
  var u = {};
  return s.forEach(function(d) {
    if (_typeof$h(d) === "object") {
      var p = Object.keys(d);
      p.forEach(function(v) {
        Object.defineProperty(u, v, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return d[v];
          }
        });
      });
    }
  }), recording = !0, u;
}
var statistic = {};
function noop$4() {
}
var statisticToken = function a(s) {
  var c, u = s, d = noop$4;
  return enableStatistic && typeof Proxy < "u" && (c = /* @__PURE__ */ new Set(), u = new Proxy(s, {
    get: function(v, A) {
      if (recording) {
        var x;
        (x = c) === null || x === void 0 || x.add(A);
      }
      return v[A];
    }
  }), d = function(v, A) {
    var x;
    statistic[v] = {
      global: Array.from(c),
      component: _objectSpread2$1(_objectSpread2$1({}, (x = statistic[v]) === null || x === void 0 ? void 0 : x.component), A)
    };
  }), {
    token: u,
    keys: c,
    flush: d
  };
};
function getDefaultComponentToken(a, s, c) {
  if (typeof c == "function") {
    var u;
    return c(merge(s, (u = s[a]) !== null && u !== void 0 ? u : {}));
  }
  return c ?? {};
}
function genMaxMin(a) {
  return a === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return "max(".concat(u.map(function(p) {
        return unit$1(p);
      }).join(","), ")");
    },
    min: function() {
      for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return "min(".concat(u.map(function(p) {
        return unit$1(p);
      }).join(","), ")");
    }
  };
}
var BEAT_LIMIT = 1e3 * 60 * 10, ArrayKeyMap = /* @__PURE__ */ function() {
  function a() {
    _classCallCheck$1(this, a), _defineProperty$a(this, "map", /* @__PURE__ */ new Map()), _defineProperty$a(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), _defineProperty$a(this, "nextID", 0), _defineProperty$a(this, "lastAccessBeat", /* @__PURE__ */ new Map()), _defineProperty$a(this, "accessBeat", 0);
  }
  return _createClass$1(a, [{
    key: "set",
    value: function(c, u) {
      this.clear();
      var d = this.getCompositeKey(c);
      this.map.set(d, u), this.lastAccessBeat.set(d, Date.now());
    }
  }, {
    key: "get",
    value: function(c) {
      var u = this.getCompositeKey(c), d = this.map.get(u);
      return this.lastAccessBeat.set(u, Date.now()), this.accessBeat += 1, d;
    }
  }, {
    key: "getCompositeKey",
    value: function(c) {
      var u = this, d = c.map(function(p) {
        return p && _typeof$h(p) === "object" ? "obj_".concat(u.getObjectID(p)) : "".concat(_typeof$h(p), "_").concat(p);
      });
      return d.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(c) {
      if (this.objectIDMap.has(c))
        return this.objectIDMap.get(c);
      var u = this.nextID;
      return this.objectIDMap.set(c, u), this.nextID += 1, u;
    }
  }, {
    key: "clear",
    value: function() {
      var c = this;
      if (this.accessBeat > 1e4) {
        var u = Date.now();
        this.lastAccessBeat.forEach(function(d, p) {
          u - d > BEAT_LIMIT && (c.map.delete(p), c.lastAccessBeat.delete(p));
        }), this.accessBeat = 0;
      }
    }
  }]), a;
}(), uniqueMap = new ArrayKeyMap();
function useUniqueMemo(a, s) {
  return React.useMemo(function() {
    var c = uniqueMap.get(s);
    if (c)
      return c;
    var u = a();
    return uniqueMap.set(s, u), u;
  }, s);
}
var useDefaultCSP = function a() {
  return {};
};
function genStyleUtils(a) {
  var s = a.useCSP, c = s === void 0 ? useDefaultCSP : s, u = a.useToken, d = a.usePrefix, p = a.getResetStyles, v = a.getCommonStyle, A = a.getCompUnitless;
  function x(f, m, C, w) {
    var S = Array.isArray(f) ? f[0] : f;
    function $(L) {
      return "".concat(String(S)).concat(L.slice(0, 1).toUpperCase()).concat(L.slice(1));
    }
    var T = w?.unitless || {}, I = typeof A == "function" ? A(f) : {}, _ = _objectSpread2$1(_objectSpread2$1({}, I), {}, _defineProperty$a({}, $("zIndexPopup"), !0));
    Object.keys(T).forEach(function(L) {
      _[$(L)] = T[L];
    });
    var E = _objectSpread2$1(_objectSpread2$1({}, w), {}, {
      unitless: _,
      prefixToken: $
    }), R = b(f, m, C, E), O = g(S, C, E);
    return function(L) {
      var B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : L, F = R(L, B), M = _slicedToArray$e(F, 2), W = M[1], j = O(B), G = _slicedToArray$e(j, 2), U = G[0], k = G[1];
      return [U, W, k];
    };
  }
  function g(f, m, C) {
    var w = C.unitless, S = C.injectStyle, $ = S === void 0 ? !0 : S, T = C.prefixToken, I = C.ignore, _ = function(O) {
      var L = O.rootCls, B = O.cssVar, F = B === void 0 ? {} : B, M = u(), W = M.realToken;
      return useCSSVarRegister({
        path: [f],
        prefix: F.prefix,
        key: F.key,
        unitless: w,
        ignore: I,
        token: W,
        scope: L
      }, function() {
        var j = getDefaultComponentToken(f, W, m), G = getComponentToken(f, W, j, {
          deprecatedTokens: C?.deprecatedTokens
        });
        return Object.keys(j).forEach(function(U) {
          G[T(U)] = G[U], delete G[U];
        }), G;
      }), null;
    }, E = function(O) {
      var L = u(), B = L.cssVar;
      return [function(F) {
        return $ && B ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(_, {
          rootCls: O,
          cssVar: B,
          component: f
        }), F) : F;
      }, B?.key];
    };
    return E;
  }
  function b(f, m, C) {
    var w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, S = Array.isArray(f) ? f : [f, f], $ = _slicedToArray$e(S, 1), T = $[0], I = S.join("-"), _ = a.layer || {
      name: "antd"
    };
    return function(E) {
      var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : E, O = u(), L = O.theme, B = O.realToken, F = O.hashId, M = O.token, W = O.cssVar, j = d(), G = j.rootPrefixCls, U = j.iconPrefixCls, k = c(), N = W ? "css" : "js", P = useUniqueMemo(function() {
        var K = /* @__PURE__ */ new Set();
        return W && Object.keys(w.unitless || {}).forEach(function(q) {
          K.add(token2CSSVar(q, W.prefix)), K.add(token2CSSVar(q, getCompVarPrefix(T, W.prefix)));
        }), genCalc(N, K);
      }, [N, T, W?.prefix]), D = genMaxMin(N), H = D.max, V = D.min, Z = {
        theme: L,
        token: M,
        hashId: F,
        nonce: function() {
          return k.nonce;
        },
        clientOnly: w.clientOnly,
        layer: _,
        // antd is always at top of styles
        order: w.order || -999
      };
      typeof p == "function" && useStyleRegister(_objectSpread2$1(_objectSpread2$1({}, Z), {}, {
        clientOnly: !1,
        path: ["Shared", G]
      }), function() {
        return p(M, {
          prefix: {
            rootPrefixCls: G,
            iconPrefixCls: U
          },
          csp: k
        });
      });
      var ne = useStyleRegister(_objectSpread2$1(_objectSpread2$1({}, Z), {}, {
        path: [I, E, U]
      }), function() {
        if (w.injectStyle === !1)
          return [];
        var K = statisticToken(M), q = K.token, Y = K.flush, ee = getDefaultComponentToken(T, B, C), Q = ".".concat(E), J = getComponentToken(T, B, ee, {
          deprecatedTokens: w.deprecatedTokens
        });
        W && ee && _typeof$h(ee) === "object" && Object.keys(ee).forEach(function(ie) {
          ee[ie] = "var(".concat(token2CSSVar(ie, getCompVarPrefix(T, W.prefix)), ")");
        });
        var te = merge(q, {
          componentCls: Q,
          prefixCls: E,
          iconCls: ".".concat(U),
          antCls: ".".concat(G),
          calc: P,
          // @ts-ignore
          max: H,
          // @ts-ignore
          min: V
        }, W ? ee : J), ae = m(te, {
          hashId: F,
          prefixCls: E,
          rootPrefixCls: G,
          iconPrefixCls: U
        });
        Y(T, J);
        var se = typeof v == "function" ? v(te, E, R, w.resetFont) : null;
        return [w.resetStyle === !1 ? null : se, ae];
      });
      return [ne, F];
    };
  }
  function y(f, m, C) {
    var w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, S = b(f, m, C, _objectSpread2$1({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, w)), $ = function(I) {
      var _ = I.prefixCls, E = I.rootCls, R = E === void 0 ? _ : E;
      return S(_, R), null;
    };
    return $;
  }
  return {
    genStyleHooks: x,
    genSubStyleComponent: y,
    genComponentStyleHook: b
  };
}
const PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], version$1 = "5.26.3";
function isStableColor(a) {
  return a >= 0 && a <= 255;
}
function getAlphaColor$1(a, s) {
  const {
    r: c,
    g: u,
    b: d,
    a: p
  } = new FastColor(a).toRgb();
  if (p < 1)
    return a;
  const {
    r: v,
    g: A,
    b: x
  } = new FastColor(s).toRgb();
  for (let g = 0.01; g <= 1; g += 0.01) {
    const b = Math.round((c - v * (1 - g)) / g), y = Math.round((u - A * (1 - g)) / g), f = Math.round((d - x * (1 - g)) / g);
    if (isStableColor(b) && isStableColor(y) && isStableColor(f))
      return new FastColor({
        r: b,
        g: y,
        b: f,
        a: Math.round(g * 100) / 100
      }).toRgbString();
  }
  return new FastColor({
    r: c,
    g: u,
    b: d,
    a: 1
  }).toRgbString();
}
var __rest$14 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function formatToken(a) {
  const {
    override: s
  } = a, c = __rest$14(a, ["override"]), u = Object.assign({}, s);
  Object.keys(seedToken).forEach((f) => {
    delete u[f];
  });
  const d = Object.assign(Object.assign({}, c), u), p = 480, v = 576, A = 768, x = 992, g = 1200, b = 1600;
  if (d.motion === !1) {
    const f = "0s";
    d.motionDurationFast = f, d.motionDurationMid = f, d.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, d), {
    // ============== Background ============== //
    colorFillContent: d.colorFillSecondary,
    colorFillContentHover: d.colorFill,
    colorFillAlter: d.colorFillQuaternary,
    colorBgContainerDisabled: d.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: d.colorBgContainer,
    colorSplit: getAlphaColor$1(d.colorBorderSecondary, d.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: d.colorTextQuaternary,
    colorTextDisabled: d.colorTextQuaternary,
    colorTextHeading: d.colorText,
    colorTextLabel: d.colorTextSecondary,
    colorTextDescription: d.colorTextTertiary,
    colorTextLightSolid: d.colorWhite,
    colorHighlight: d.colorError,
    colorBgTextHover: d.colorFillSecondary,
    colorBgTextActive: d.colorFill,
    colorIcon: d.colorTextTertiary,
    colorIconHover: d.colorText,
    colorErrorOutline: getAlphaColor$1(d.colorErrorBg, d.colorBgContainer),
    colorWarningOutline: getAlphaColor$1(d.colorWarningBg, d.colorBgContainer),
    // Font
    fontSizeIcon: d.fontSizeSM,
    // Line
    lineWidthFocus: d.lineWidth * 3,
    // Control
    lineWidth: d.lineWidth,
    controlOutlineWidth: d.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: d.controlHeight / 2,
    controlItemBgHover: d.colorFillTertiary,
    controlItemBgActive: d.colorPrimaryBg,
    controlItemBgActiveHover: d.colorPrimaryBgHover,
    controlItemBgActiveDisabled: d.colorFill,
    controlTmpOutline: d.colorFillQuaternary,
    controlOutline: getAlphaColor$1(d.colorPrimaryBg, d.colorBgContainer),
    lineType: d.lineType,
    borderRadius: d.borderRadius,
    borderRadiusXS: d.borderRadiusXS,
    borderRadiusSM: d.borderRadiusSM,
    borderRadiusLG: d.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: d.sizeXXS,
    paddingXS: d.sizeXS,
    paddingSM: d.sizeSM,
    padding: d.size,
    paddingMD: d.sizeMD,
    paddingLG: d.sizeLG,
    paddingXL: d.sizeXL,
    paddingContentHorizontalLG: d.sizeLG,
    paddingContentVerticalLG: d.sizeMS,
    paddingContentHorizontal: d.sizeMS,
    paddingContentVertical: d.sizeSM,
    paddingContentHorizontalSM: d.size,
    paddingContentVerticalSM: d.sizeXS,
    marginXXS: d.sizeXXS,
    marginXS: d.sizeXS,
    marginSM: d.sizeSM,
    margin: d.size,
    marginMD: d.sizeMD,
    marginLG: d.sizeLG,
    marginXL: d.sizeXL,
    marginXXL: d.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: p,
    screenXSMin: p,
    screenXSMax: v - 1,
    screenSM: v,
    screenSMMin: v,
    screenSMMax: A - 1,
    screenMD: A,
    screenMDMin: A,
    screenMDMax: x - 1,
    screenLG: x,
    screenLGMin: x,
    screenLGMax: g - 1,
    screenXL: g,
    screenXLMin: g,
    screenXLMax: b - 1,
    screenXXL: b,
    screenXXLMin: b,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new FastColor("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new FastColor("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new FastColor("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), u);
}
var __rest$13 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const unitless = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, ignore = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, preserve = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, getComputedToken = (a, s, c) => {
  const u = c.getDerivativeToken(a), {
    override: d
  } = s, p = __rest$13(s, ["override"]);
  let v = Object.assign(Object.assign({}, u), {
    override: d
  });
  return v = formatToken(v), p && Object.entries(p).forEach(([A, x]) => {
    const {
      theme: g
    } = x, b = __rest$13(x, ["theme"]);
    let y = b;
    g && (y = getComputedToken(Object.assign(Object.assign({}, v), b), {
      override: b
    }, g)), v[A] = y;
  }), v;
};
function useToken$1() {
  const {
    token: a,
    hashed: s,
    theme: c,
    override: u,
    cssVar: d
  } = React.useContext(DesignTokenContext), p = `${version$1}-${s || ""}`, v = c || defaultTheme$1, [A, x, g] = useCacheToken(v, [seedToken, a], {
    salt: p,
    override: u,
    getComputedToken,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken,
    cssVar: d && {
      prefix: d.prefix,
      key: d.key,
      unitless,
      ignore,
      preserve
    }
  });
  return [v, g, s ? x : "", A, d];
}
const textEllipsis = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, resetComponent = (a, s = !1) => ({
  boxSizing: "border-box",
  margin: 0,
  padding: 0,
  color: a.colorText,
  fontSize: a.fontSize,
  // font-variant: @font-variant-base;
  lineHeight: a.lineHeight,
  listStyle: "none",
  // font-feature-settings: @font-feature-settings-base;
  fontFamily: s ? "inherit" : a.fontFamily
}), resetIcon = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), clearFix = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), genLinkStyle$1 = (a) => ({
  a: {
    color: a.colorLink,
    textDecoration: a.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${a.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: a.colorLinkHover
    },
    "&:active": {
      color: a.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: a.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: a.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: a.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), genCommonStyle = (a, s, c, u) => {
  const d = `[class^="${s}"], [class*=" ${s}"]`, p = c ? `.${c}` : d, v = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let A = {};
  return u !== !1 && (A = {
    fontFamily: a.fontFamily,
    fontSize: a.fontSize
  }), {
    [p]: Object.assign(Object.assign(Object.assign({}, A), v), {
      [d]: v
    })
  };
}, genFocusOutline = (a, s) => ({
  outline: `${unit$1(a.lineWidthFocus)} solid ${a.colorPrimaryBorder}`,
  outlineOffset: s ?? 1,
  transition: "outline-offset 0s, outline 0s"
}), genFocusStyle = (a, s) => ({
  "&:focus-visible": Object.assign({}, genFocusOutline(a, s))
}), genIconStyle = (a) => ({
  [`.${a}`]: Object.assign(Object.assign({}, resetIcon()), {
    [`.${a} .${a}-icon`]: {
      display: "block"
    }
  })
}), operationUnit = (a) => Object.assign(Object.assign({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: a.colorLink,
  textDecoration: a.linkDecoration,
  outline: "none",
  cursor: "pointer",
  transition: `all ${a.motionDurationSlow}`,
  border: 0,
  padding: 0,
  background: "none",
  userSelect: "none"
}, genFocusStyle(a)), {
  "&:focus, &:hover": {
    color: a.colorLinkHover
  },
  "&:active": {
    color: a.colorLinkActive
  }
}), {
  genStyleHooks,
  genComponentStyleHook,
  genSubStyleComponent
} = genStyleUtils({
  usePrefix: () => {
    const {
      getPrefixCls: a,
      iconPrefixCls: s
    } = reactExports.useContext(ConfigContext$1);
    return {
      rootPrefixCls: a(),
      iconPrefixCls: s
    };
  },
  useToken: () => {
    const [a, s, c, u, d] = useToken$1();
    return {
      theme: a,
      realToken: s,
      hashId: c,
      token: u,
      cssVar: d
    };
  },
  useCSP: () => {
    const {
      csp: a
    } = reactExports.useContext(ConfigContext$1);
    return a ?? {};
  },
  getResetStyles: (a, s) => {
    var c;
    const u = genLinkStyle$1(a);
    return [u, {
      "&": u
    }, genIconStyle((c = s?.prefix.iconPrefixCls) !== null && c !== void 0 ? c : defaultIconPrefixCls)];
  },
  getCommonStyle: genCommonStyle,
  getCompUnitless: () => unitless
});
function genPresetColor(a, s) {
  return PresetColors.reduce((c, u) => {
    const d = a[`${u}1`], p = a[`${u}3`], v = a[`${u}6`], A = a[`${u}7`];
    return Object.assign(Object.assign({}, c), s(u, {
      lightColor: d,
      lightBorderColor: p,
      darkColor: v,
      textColor: A
    }));
  }, {});
}
const useResetIconStyle = (a, s) => {
  const [c, u] = useToken$1();
  return useStyleRegister({
    token: u,
    hashId: "",
    path: ["ant-design-icons", a],
    nonce: () => s?.nonce,
    layer: {
      name: "antd"
    }
  }, () => [genIconStyle(a)]);
}, fullClone$1 = Object.assign({}, React$1), {
  useId: useId$3
} = fullClone$1, useEmptyId = () => "", useThemeKey = typeof useId$3 > "u" ? useEmptyId : useId$3;
function useTheme(a, s, c) {
  var u;
  devUseWarning();
  const d = a || {}, p = d.inherit === !1 || !s ? Object.assign(Object.assign({}, defaultConfig), {
    hashed: (u = s?.hashed) !== null && u !== void 0 ? u : defaultConfig.hashed,
    cssVar: s?.cssVar
  }) : s, v = useThemeKey();
  return useMemo(() => {
    var A, x;
    if (!a)
      return s;
    const g = Object.assign({}, p.components);
    Object.keys(a.components || {}).forEach((f) => {
      g[f] = Object.assign(Object.assign({}, g[f]), a.components[f]);
    });
    const b = `css-var-${v.replace(/:/g, "")}`, y = ((A = d.cssVar) !== null && A !== void 0 ? A : p.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: c?.prefixCls
    }, typeof p.cssVar == "object" ? p.cssVar : {}), typeof d.cssVar == "object" ? d.cssVar : {}), {
      key: typeof d.cssVar == "object" && ((x = d.cssVar) === null || x === void 0 ? void 0 : x.key) || b
    });
    return Object.assign(Object.assign(Object.assign({}, p), d), {
      token: Object.assign(Object.assign({}, p.token), d.token),
      components: g,
      cssVar: y
    });
  }, [d, p], (A, x) => A.some((g, b) => {
    const y = x[b];
    return !isEqual(g, y, !0);
  }));
}
var _excluded$14 = ["children"], Context$3 = /* @__PURE__ */ reactExports.createContext({});
function MotionProvider(a) {
  var s = a.children, c = _objectWithoutProperties$2(a, _excluded$14);
  return /* @__PURE__ */ reactExports.createElement(Context$3.Provider, {
    value: c
  }, s);
}
var DomWrapper = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c() {
    return _classCallCheck$1(this, c), s.apply(this, arguments);
  }
  return _createClass$1(c, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), c;
}(reactExports.Component);
function useSyncState$3(a) {
  var s = reactExports.useReducer(function(A) {
    return A + 1;
  }, 0), c = _slicedToArray$e(s, 2), u = c[1], d = reactExports.useRef(a), p = useEvent(function() {
    return d.current;
  }), v = useEvent(function(A) {
    d.current = typeof A == "function" ? A(d.current) : A, u();
  });
  return [p, v];
}
var STATUS_NONE = "none", STATUS_APPEAR = "appear", STATUS_ENTER = "enter", STATUS_LEAVE = "leave", STEP_NONE = "none", STEP_PREPARE = "prepare", STEP_START = "start", STEP_ACTIVE = "active", STEP_ACTIVATED = "end", STEP_PREPARED = "prepared";
function makePrefixMap(a, s) {
  var c = {};
  return c[a.toLowerCase()] = s.toLowerCase(), c["Webkit".concat(a)] = "webkit".concat(s), c["Moz".concat(a)] = "moz".concat(s), c["ms".concat(a)] = "MS".concat(s), c["O".concat(a)] = "o".concat(s.toLowerCase()), c;
}
function getVendorPrefixes(a, s) {
  var c = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  return a && ("AnimationEvent" in s || delete c.animationend.animation, "TransitionEvent" in s || delete c.transitionend.transition), c;
}
var vendorPrefixes = getVendorPrefixes(canUseDom$1(), typeof window < "u" ? window : {}), style = {};
if (canUseDom$1()) {
  var _document$createEleme = document.createElement("div");
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(a) {
  if (prefixedEventNames[a])
    return prefixedEventNames[a];
  var s = vendorPrefixes[a];
  if (s)
    for (var c = Object.keys(s), u = c.length, d = 0; d < u; d += 1) {
      var p = c[d];
      if (Object.prototype.hasOwnProperty.call(s, p) && p in style)
        return prefixedEventNames[a] = s[p], prefixedEventNames[a];
    }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend"), internalTransitionEndName = getVendorPrefixedEventName("transitionend"), supportTransition = !!(internalAnimationEndName && internalTransitionEndName), animationEndName = internalAnimationEndName || "animationend", transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName$2(a, s) {
  if (!a) return null;
  if (_typeof$h(a) === "object") {
    var c = s.replace(/-\w/g, function(u) {
      return u[1].toUpperCase();
    });
    return a[c];
  }
  return "".concat(a, "-").concat(s);
}
const useDomMotionEvents = function(a) {
  var s = reactExports.useRef();
  function c(d) {
    d && (d.removeEventListener(transitionEndName, a), d.removeEventListener(animationEndName, a));
  }
  function u(d) {
    s.current && s.current !== d && c(s.current), d && d !== s.current && (d.addEventListener(transitionEndName, a), d.addEventListener(animationEndName, a), s.current = d);
  }
  return reactExports.useEffect(function() {
    return function() {
      c(s.current);
    };
  }, []), [u, c];
};
var useIsomorphicLayoutEffect = canUseDom$1() ? reactExports.useLayoutEffect : reactExports.useEffect;
const useNextFrame = function() {
  var a = reactExports.useRef(null);
  function s() {
    wrapperRaf.cancel(a.current);
  }
  function c(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    s();
    var p = wrapperRaf(function() {
      d <= 1 ? u({
        isCanceled: function() {
          return p !== a.current;
        }
      }) : c(u, d - 1);
    });
    a.current = p;
  }
  return reactExports.useEffect(function() {
    return function() {
      s();
    };
  }, []), [c, s];
};
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED], SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED], SkipStep = !1, DoStep = !0;
function isActive(a) {
  return a === STEP_ACTIVE || a === STEP_ACTIVATED;
}
const useStepQueue = function(a, s, c) {
  var u = useSafeState(STEP_NONE), d = _slicedToArray$e(u, 2), p = d[0], v = d[1], A = useNextFrame(), x = _slicedToArray$e(A, 2), g = x[0], b = x[1];
  function y() {
    v(STEP_PREPARE, !0);
  }
  var f = s ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  return useIsomorphicLayoutEffect(function() {
    if (p !== STEP_NONE && p !== STEP_ACTIVATED) {
      var m = f.indexOf(p), C = f[m + 1], w = c(p);
      w === SkipStep ? v(C, !0) : C && g(function(S) {
        function $() {
          S.isCanceled() || v(C, !0);
        }
        w === !0 ? $() : Promise.resolve(w).then($);
      });
    }
  }, [a, p]), reactExports.useEffect(function() {
    return function() {
      b();
    };
  }, []), [y, p];
};
function useStatus$1(a, s, c, u) {
  var d = u.motionEnter, p = d === void 0 ? !0 : d, v = u.motionAppear, A = v === void 0 ? !0 : v, x = u.motionLeave, g = x === void 0 ? !0 : x, b = u.motionDeadline, y = u.motionLeaveImmediately, f = u.onAppearPrepare, m = u.onEnterPrepare, C = u.onLeavePrepare, w = u.onAppearStart, S = u.onEnterStart, $ = u.onLeaveStart, T = u.onAppearActive, I = u.onEnterActive, _ = u.onLeaveActive, E = u.onAppearEnd, R = u.onEnterEnd, O = u.onLeaveEnd, L = u.onVisibleChanged, B = useSafeState(), F = _slicedToArray$e(B, 2), M = F[0], W = F[1], j = useSyncState$3(STATUS_NONE), G = _slicedToArray$e(j, 2), U = G[0], k = G[1], N = useSafeState(null), P = _slicedToArray$e(N, 2), D = P[0], H = P[1], V = U(), Z = reactExports.useRef(!1), ne = reactExports.useRef(null);
  function K() {
    return c();
  }
  var q = reactExports.useRef(!1);
  function Y() {
    k(STATUS_NONE), H(null, !0);
  }
  var ee = useEvent(function(he) {
    var ye = U();
    if (ye !== STATUS_NONE) {
      var Ce = K();
      if (!(he && !he.deadline && he.target !== Ce)) {
        var xe = q.current, we;
        ye === STATUS_APPEAR && xe ? we = E?.(Ce, he) : ye === STATUS_ENTER && xe ? we = R?.(Ce, he) : ye === STATUS_LEAVE && xe && (we = O?.(Ce, he)), xe && we !== !1 && Y();
      }
    }
  }), Q = useDomMotionEvents(ee), J = _slicedToArray$e(Q, 1), te = J[0], ae = function(ye) {
    switch (ye) {
      case STATUS_APPEAR:
        return _defineProperty$a(_defineProperty$a(_defineProperty$a({}, STEP_PREPARE, f), STEP_START, w), STEP_ACTIVE, T);
      case STATUS_ENTER:
        return _defineProperty$a(_defineProperty$a(_defineProperty$a({}, STEP_PREPARE, m), STEP_START, S), STEP_ACTIVE, I);
      case STATUS_LEAVE:
        return _defineProperty$a(_defineProperty$a(_defineProperty$a({}, STEP_PREPARE, C), STEP_START, $), STEP_ACTIVE, _);
      default:
        return {};
    }
  }, se = reactExports.useMemo(function() {
    return ae(V);
  }, [V]), ie = useStepQueue(V, !a, function(he) {
    if (he === STEP_PREPARE) {
      var ye = se[STEP_PREPARE];
      return ye ? ye(K()) : SkipStep;
    }
    if (me in se) {
      var Ce;
      H(((Ce = se[me]) === null || Ce === void 0 ? void 0 : Ce.call(se, K(), null)) || null);
    }
    return me === STEP_ACTIVE && V !== STATUS_NONE && (te(K()), b > 0 && (clearTimeout(ne.current), ne.current = setTimeout(function() {
      ee({
        deadline: !0
      });
    }, b))), me === STEP_PREPARED && Y(), DoStep;
  }), fe = _slicedToArray$e(ie, 2), ge = fe[0], me = fe[1], pe = isActive(me);
  q.current = pe;
  var be = reactExports.useRef(null);
  useIsomorphicLayoutEffect(function() {
    if (!(Z.current && be.current === s)) {
      W(s);
      var he = Z.current;
      Z.current = !0;
      var ye;
      !he && s && A && (ye = STATUS_APPEAR), he && s && p && (ye = STATUS_ENTER), (he && !s && g || !he && y && !s && g) && (ye = STATUS_LEAVE);
      var Ce = ae(ye);
      ye && (a || Ce[STEP_PREPARE]) ? (k(ye), ge()) : k(STATUS_NONE), be.current = s;
    }
  }, [s]), reactExports.useEffect(function() {
    // Cancel appear
    (V === STATUS_APPEAR && !A || // Cancel enter
    V === STATUS_ENTER && !p || // Cancel leave
    V === STATUS_LEAVE && !g) && k(STATUS_NONE);
  }, [A, p, g]), reactExports.useEffect(function() {
    return function() {
      Z.current = !1, clearTimeout(ne.current);
    };
  }, []);
  var le = reactExports.useRef(!1);
  reactExports.useEffect(function() {
    M && (le.current = !0), M !== void 0 && V === STATUS_NONE && ((le.current || M) && L?.(M), le.current = !0);
  }, [M, V]);
  var ve = D;
  return se[STEP_PREPARE] && me === STEP_START && (ve = _objectSpread2$1({
    transition: "none"
  }, ve)), [V, me, ve, M ?? s];
}
function genCSSMotion(a) {
  var s = a;
  _typeof$h(a) === "object" && (s = a.transitionSupport);
  function c(d, p) {
    return !!(d.motionName && s && p !== !1);
  }
  var u = /* @__PURE__ */ reactExports.forwardRef(function(d, p) {
    var v = d.visible, A = v === void 0 ? !0 : v, x = d.removeOnLeave, g = x === void 0 ? !0 : x, b = d.forceRender, y = d.children, f = d.motionName, m = d.leavedClassName, C = d.eventProps, w = reactExports.useContext(Context$3), S = w.motion, $ = c(d, S), T = reactExports.useRef(), I = reactExports.useRef();
    function _() {
      try {
        return T.current instanceof HTMLElement ? T.current : findDOMNode(I.current);
      } catch {
        return null;
      }
    }
    var E = useStatus$1($, A, _, d), R = _slicedToArray$e(E, 4), O = R[0], L = R[1], B = R[2], F = R[3], M = reactExports.useRef(F);
    F && (M.current = !0);
    var W = reactExports.useCallback(function(P) {
      T.current = P, fillRef(p, P);
    }, [p]), j, G = _objectSpread2$1(_objectSpread2$1({}, C), {}, {
      visible: A
    });
    if (!y)
      j = null;
    else if (O === STATUS_NONE)
      F ? j = y(_objectSpread2$1({}, G), W) : !g && M.current && m ? j = y(_objectSpread2$1(_objectSpread2$1({}, G), {}, {
        className: m
      }), W) : b || !g && !m ? j = y(_objectSpread2$1(_objectSpread2$1({}, G), {}, {
        style: {
          display: "none"
        }
      }), W) : j = null;
    else {
      var U;
      L === STEP_PREPARE ? U = "prepare" : isActive(L) ? U = "active" : L === STEP_START && (U = "start");
      var k = getTransitionName$2(f, "".concat(O, "-").concat(U));
      j = y(_objectSpread2$1(_objectSpread2$1({}, G), {}, {
        className: classnames(getTransitionName$2(f, O), _defineProperty$a(_defineProperty$a({}, k, k && U), f, typeof f == "string")),
        style: B
      }), W);
    }
    if (/* @__PURE__ */ reactExports.isValidElement(j) && supportRef(j)) {
      var N = getNodeRef(j);
      N || (j = /* @__PURE__ */ reactExports.cloneElement(j, {
        ref: W
      }));
    }
    return /* @__PURE__ */ reactExports.createElement(DomWrapper, {
      ref: I
    }, j);
  });
  return u.displayName = "CSSMotion", u;
}
const CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add", STATUS_KEEP = "keep", STATUS_REMOVE = "remove", STATUS_REMOVED = "removed";
function wrapKeyToObject(a) {
  var s;
  return a && _typeof$h(a) === "object" && "key" in a ? s = a : s = {
    key: a
  }, _objectSpread2$1(_objectSpread2$1({}, s), {}, {
    key: String(s.key)
  });
}
function parseKeys() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return a.map(wrapKeyToObject);
}
function diffKeys() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], c = [], u = 0, d = s.length, p = parseKeys(a), v = parseKeys(s);
  p.forEach(function(g) {
    for (var b = !1, y = u; y < d; y += 1) {
      var f = v[y];
      if (f.key === g.key) {
        u < y && (c = c.concat(v.slice(u, y).map(function(m) {
          return _objectSpread2$1(_objectSpread2$1({}, m), {}, {
            status: STATUS_ADD
          });
        })), u = y), c.push(_objectSpread2$1(_objectSpread2$1({}, f), {}, {
          status: STATUS_KEEP
        })), u += 1, b = !0;
        break;
      }
    }
    b || c.push(_objectSpread2$1(_objectSpread2$1({}, g), {}, {
      status: STATUS_REMOVE
    }));
  }), u < d && (c = c.concat(v.slice(u).map(function(g) {
    return _objectSpread2$1(_objectSpread2$1({}, g), {}, {
      status: STATUS_ADD
    });
  })));
  var A = {};
  c.forEach(function(g) {
    var b = g.key;
    A[b] = (A[b] || 0) + 1;
  });
  var x = Object.keys(A).filter(function(g) {
    return A[g] > 1;
  });
  return x.forEach(function(g) {
    c = c.filter(function(b) {
      var y = b.key, f = b.status;
      return y !== g || f !== STATUS_REMOVE;
    }), c.forEach(function(b) {
      b.key === g && (b.status = STATUS_KEEP);
    });
  }), c;
}
var _excluded$13 = ["component", "children", "onVisibleChanged", "onAllRemoved"], _excluded2$e = ["status"], MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion, c = /* @__PURE__ */ function(u) {
    _inherits$1(p, u);
    var d = _createSuper(p);
    function p() {
      var v;
      _classCallCheck$1(this, p);
      for (var A = arguments.length, x = new Array(A), g = 0; g < A; g++)
        x[g] = arguments[g];
      return v = d.call.apply(d, [this].concat(x)), _defineProperty$a(_assertThisInitialized(v), "state", {
        keyEntities: []
      }), _defineProperty$a(_assertThisInitialized(v), "removeKey", function(b) {
        v.setState(function(y) {
          var f = y.keyEntities.map(function(m) {
            return m.key !== b ? m : _objectSpread2$1(_objectSpread2$1({}, m), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: f
          };
        }, function() {
          var y = v.state.keyEntities, f = y.filter(function(m) {
            var C = m.status;
            return C !== STATUS_REMOVED;
          }).length;
          f === 0 && v.props.onAllRemoved && v.props.onAllRemoved();
        });
      }), v;
    }
    return _createClass$1(p, [{
      key: "render",
      value: function() {
        var A = this, x = this.state.keyEntities, g = this.props, b = g.component, y = g.children, f = g.onVisibleChanged;
        g.onAllRemoved;
        var m = _objectWithoutProperties$2(g, _excluded$13), C = b || reactExports.Fragment, w = {};
        return MOTION_PROP_NAMES.forEach(function(S) {
          w[S] = m[S], delete m[S];
        }), delete m.keys, /* @__PURE__ */ reactExports.createElement(C, m, x.map(function(S, $) {
          var T = S.status, I = _objectWithoutProperties$2(S, _excluded2$e), _ = T === STATUS_ADD || T === STATUS_KEEP;
          return /* @__PURE__ */ reactExports.createElement(s, _extends$3({}, w, {
            key: I.key,
            visible: _,
            eventProps: I,
            onVisibleChanged: function(R) {
              f?.(R, {
                key: I.key
              }), R || A.removeKey(I.key);
            }
          }), function(E, R) {
            return y(_objectSpread2$1(_objectSpread2$1({}, E), {}, {
              index: $
            }), R);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(A, x) {
        var g = A.keys, b = x.keyEntities, y = parseKeys(g), f = diffKeys(b, y);
        return {
          keyEntities: f.filter(function(m) {
            var C = b.find(function(w) {
              var S = w.key;
              return m.key === S;
            });
            return !(C && C.status === STATUS_REMOVED && m.status === STATUS_REMOVE);
          })
        };
      }
    }]), p;
  }(reactExports.Component);
  return _defineProperty$a(c, "defaultProps", {
    component: "div"
  }), c;
}
const CSSMotionList = genCSSMotionList(supportTransition), MotionCacheContext = /* @__PURE__ */ reactExports.createContext(!0);
function MotionWrapper(a) {
  const s = reactExports.useContext(MotionCacheContext), {
    children: c
  } = a, [, u] = useToken$1(), {
    motion: d
  } = u, p = reactExports.useRef(!1);
  return p.current || (p.current = s !== d), p.current ? /* @__PURE__ */ reactExports.createElement(MotionCacheContext.Provider, {
    value: d
  }, /* @__PURE__ */ reactExports.createElement(MotionProvider, {
    motion: d
  }, c)) : c;
}
const PropWarning = () => null;
var __rest$12 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const PASSED_PROPS = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let globalPrefixCls, globalIconPrefixCls, globalTheme, globalHolderRender;
function getGlobalPrefixCls() {
  return globalPrefixCls || defaultPrefixCls;
}
function getGlobalIconPrefixCls() {
  return globalIconPrefixCls || defaultIconPrefixCls;
}
function isLegacyTheme(a) {
  return Object.keys(a).some((s) => s.endsWith("Color"));
}
const setGlobalConfig = (a) => {
  const {
    prefixCls: s,
    iconPrefixCls: c,
    theme: u,
    holderRender: d
  } = a;
  s !== void 0 && (globalPrefixCls = s), c !== void 0 && (globalIconPrefixCls = c), "holderRender" in a && (globalHolderRender = d), u && (isLegacyTheme(u) ? registerTheme(getGlobalPrefixCls(), u) : globalTheme = u);
}, globalConfig = () => ({
  getPrefixCls: (a, s) => s || (a ? `${getGlobalPrefixCls()}-${a}` : getGlobalPrefixCls()),
  getIconPrefixCls: getGlobalIconPrefixCls,
  getRootPrefixCls: () => globalPrefixCls || getGlobalPrefixCls(),
  getTheme: () => globalTheme,
  holderRender: globalHolderRender
}), ProviderChildren = (a) => {
  const {
    children: s,
    csp: c,
    autoInsertSpaceInButton: u,
    alert: d,
    anchor: p,
    form: v,
    locale: A,
    componentSize: x,
    direction: g,
    space: b,
    splitter: y,
    virtual: f,
    dropdownMatchSelectWidth: m,
    popupMatchSelectWidth: C,
    popupOverflow: w,
    legacyLocale: S,
    parentContext: $,
    iconPrefixCls: T,
    theme: I,
    componentDisabled: _,
    segmented: E,
    statistic: R,
    spin: O,
    calendar: L,
    carousel: B,
    cascader: F,
    collapse: M,
    typography: W,
    checkbox: j,
    descriptions: G,
    divider: U,
    drawer: k,
    skeleton: N,
    steps: P,
    image: D,
    layout: H,
    list: V,
    mentions: Z,
    modal: ne,
    progress: K,
    result: q,
    slider: Y,
    breadcrumb: ee,
    menu: Q,
    pagination: J,
    input: te,
    textArea: ae,
    empty: se,
    badge: ie,
    radio: fe,
    rate: ge,
    switch: me,
    transfer: pe,
    avatar: be,
    message: le,
    tag: ve,
    table: he,
    card: ye,
    tabs: Ce,
    timeline: xe,
    timePicker: we,
    upload: $e,
    notification: Ae,
    tree: ue,
    colorPicker: ce,
    datePicker: Ee,
    rangePicker: _e,
    flex: Te,
    wave: ke,
    dropdown: Re,
    warning: Be,
    tour: Oe,
    tooltip: Me,
    popover: Fe,
    popconfirm: Ue,
    floatButtonGroup: je,
    variant: Le,
    inputNumber: De,
    treeSelect: Ne
  } = a, Ge = reactExports.useCallback((vt, Pt) => {
    const {
      prefixCls: dt
    } = a;
    if (Pt)
      return Pt;
    const mt = dt || $.getPrefixCls("");
    return vt ? `${mt}-${vt}` : mt;
  }, [$.getPrefixCls, a.prefixCls]), Xe = T || $.iconPrefixCls || defaultIconPrefixCls, nt = c || $.csp;
  useResetIconStyle(Xe, nt);
  const ct = useTheme(I, $.theme, {
    prefixCls: Ge("")
  }), it = {
    csp: nt,
    autoInsertSpaceInButton: u,
    alert: d,
    anchor: p,
    locale: A || S,
    direction: g,
    space: b,
    splitter: y,
    virtual: f,
    popupMatchSelectWidth: C ?? m,
    popupOverflow: w,
    getPrefixCls: Ge,
    iconPrefixCls: Xe,
    theme: ct,
    segmented: E,
    statistic: R,
    spin: O,
    calendar: L,
    carousel: B,
    cascader: F,
    collapse: M,
    typography: W,
    checkbox: j,
    descriptions: G,
    divider: U,
    drawer: k,
    skeleton: N,
    steps: P,
    image: D,
    input: te,
    textArea: ae,
    layout: H,
    list: V,
    mentions: Z,
    modal: ne,
    progress: K,
    result: q,
    slider: Y,
    breadcrumb: ee,
    menu: Q,
    pagination: J,
    empty: se,
    badge: ie,
    radio: fe,
    rate: ge,
    switch: me,
    transfer: pe,
    avatar: be,
    message: le,
    tag: ve,
    table: he,
    card: ye,
    tabs: Ce,
    timeline: xe,
    timePicker: we,
    upload: $e,
    notification: Ae,
    tree: ue,
    colorPicker: ce,
    datePicker: Ee,
    rangePicker: _e,
    flex: Te,
    wave: ke,
    dropdown: Re,
    warning: Be,
    tour: Oe,
    tooltip: Me,
    popover: Fe,
    popconfirm: Ue,
    floatButtonGroup: je,
    variant: Le,
    inputNumber: De,
    treeSelect: Ne
  }, We = Object.assign({}, $);
  Object.keys(it).forEach((vt) => {
    it[vt] !== void 0 && (We[vt] = it[vt]);
  }), PASSED_PROPS.forEach((vt) => {
    const Pt = a[vt];
    Pt && (We[vt] = Pt);
  }), typeof u < "u" && (We.button = Object.assign({
    autoInsertSpace: u
  }, We.button));
  const Ve = useMemo(() => We, We, (vt, Pt) => {
    const dt = Object.keys(vt), mt = Object.keys(Pt);
    return dt.length !== mt.length || dt.some((pt) => vt[pt] !== Pt[pt]);
  }), {
    layer: ut
  } = reactExports.useContext(StyleContext), at = reactExports.useMemo(() => ({
    prefixCls: Xe,
    csp: nt,
    layer: ut ? "antd" : void 0
  }), [Xe, nt, ut]);
  let Qe = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(PropWarning, {
    dropdownMatchSelectWidth: m
  }), s);
  const st = reactExports.useMemo(() => {
    var vt, Pt, dt, mt;
    return merge$1(((vt = localeValues.Form) === null || vt === void 0 ? void 0 : vt.defaultValidateMessages) || {}, ((dt = (Pt = Ve.locale) === null || Pt === void 0 ? void 0 : Pt.Form) === null || dt === void 0 ? void 0 : dt.defaultValidateMessages) || {}, ((mt = Ve.form) === null || mt === void 0 ? void 0 : mt.validateMessages) || {}, v?.validateMessages || {});
  }, [Ve, v?.validateMessages]);
  Object.keys(st).length > 0 && (Qe = /* @__PURE__ */ reactExports.createElement(ValidateMessagesContext.Provider, {
    value: st
  }, Qe)), A && (Qe = /* @__PURE__ */ reactExports.createElement(LocaleProvider, {
    locale: A,
    _ANT_MARK__: ANT_MARK
  }, Qe)), Qe = /* @__PURE__ */ reactExports.createElement(IconContext.Provider, {
    value: at
  }, Qe), x && (Qe = /* @__PURE__ */ reactExports.createElement(SizeContextProvider, {
    size: x
  }, Qe)), Qe = /* @__PURE__ */ reactExports.createElement(MotionWrapper, null, Qe);
  const ft = reactExports.useMemo(() => {
    const vt = ct || {}, {
      algorithm: Pt,
      token: dt,
      components: mt,
      cssVar: pt
    } = vt, Et = __rest$12(vt, ["algorithm", "token", "components", "cssVar"]), Mt = Pt && (!Array.isArray(Pt) || Pt.length > 0) ? createTheme(Pt) : defaultTheme$1, Nt = {};
    Object.entries(mt || {}).forEach(([Ot, rt]) => {
      const et = Object.assign({}, rt);
      "algorithm" in et && (et.algorithm === !0 ? et.theme = Mt : (Array.isArray(et.algorithm) || typeof et.algorithm == "function") && (et.theme = createTheme(et.algorithm)), delete et.algorithm), Nt[Ot] = et;
    });
    const _t = Object.assign(Object.assign({}, seedToken), dt);
    return Object.assign(Object.assign({}, Et), {
      theme: Mt,
      token: _t,
      components: Nt,
      override: Object.assign({
        override: _t
      }, Nt),
      cssVar: pt
    });
  }, [ct]);
  return I && (Qe = /* @__PURE__ */ reactExports.createElement(DesignTokenContext.Provider, {
    value: ft
  }, Qe)), Ve.warning && (Qe = /* @__PURE__ */ reactExports.createElement(WarningContext.Provider, {
    value: Ve.warning
  }, Qe)), _ !== void 0 && (Qe = /* @__PURE__ */ reactExports.createElement(DisabledContextProvider, {
    disabled: _
  }, Qe)), /* @__PURE__ */ reactExports.createElement(ConfigContext$1.Provider, {
    value: Ve
  }, Qe);
}, ConfigProvider = (a) => {
  const s = reactExports.useContext(ConfigContext$1), c = reactExports.useContext(LocaleContext);
  return /* @__PURE__ */ reactExports.createElement(ProviderChildren, Object.assign({
    parentContext: s,
    legacyLocale: c
  }, a));
};
ConfigProvider.ConfigContext = ConfigContext$1;
ConfigProvider.SizeContext = SizeContext;
ConfigProvider.config = setGlobalConfig;
ConfigProvider.useConfig = useConfig;
Object.defineProperty(ConfigProvider, "SizeContext", {
  get: () => SizeContext
});
var CheckCircleFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
function getRoot(a) {
  var s;
  return a == null || (s = a.getRootNode) === null || s === void 0 ? void 0 : s.call(a);
}
function inShadow(a) {
  return getRoot(a) instanceof ShadowRoot;
}
function getShadowRoot$2(a) {
  return inShadow(a) ? getRoot(a) : null;
}
function camelCase(a) {
  return a.replace(/-(.)/g, function(s, c) {
    return c.toUpperCase();
  });
}
function warning$2(a, s) {
  warningOnce(a, "[@ant-design/icons] ".concat(s));
}
function isIconDefinition(a) {
  return _typeof$h(a) === "object" && typeof a.name == "string" && typeof a.theme == "string" && (_typeof$h(a.icon) === "object" || typeof a.icon == "function");
}
function normalizeAttrs() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(a).reduce(function(s, c) {
    var u = a[c];
    switch (c) {
      case "class":
        s.className = u, delete s.class;
        break;
      default:
        delete s[c], s[camelCase(c)] = u;
    }
    return s;
  }, {});
}
function generate$1(a, s, c) {
  return c ? /* @__PURE__ */ React.createElement(a.tag, _objectSpread2$1(_objectSpread2$1({
    key: s
  }, normalizeAttrs(a.attrs)), c), (a.children || []).map(function(u, d) {
    return generate$1(u, "".concat(s, "-").concat(a.tag, "-").concat(d));
  })) : /* @__PURE__ */ React.createElement(a.tag, _objectSpread2$1({
    key: s
  }, normalizeAttrs(a.attrs)), (a.children || []).map(function(u, d) {
    return generate$1(u, "".concat(s, "-").concat(a.tag, "-").concat(d));
  }));
}
function getSecondaryColor(a) {
  return generate$2(a)[0];
}
function normalizeTwoToneColors(a) {
  return a ? Array.isArray(a) ? a : [a] : [];
}
var iconStyles = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, useInsertStyles = function a(s) {
  var c = reactExports.useContext(IconContext), u = c.csp, d = c.prefixCls, p = c.layer, v = iconStyles;
  d && (v = v.replace(/anticon/g, d)), p && (v = "@layer ".concat(p, ` {
`).concat(v, `
}`)), reactExports.useEffect(function() {
    var A = s.current, x = getShadowRoot$2(A);
    updateCSS(v, "@ant-design-icons", {
      prepend: !p,
      csp: u,
      attachTo: x
    });
  }, []);
}, _excluded$12 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function setTwoToneColors(a) {
  var s = a.primaryColor, c = a.secondaryColor;
  twoToneColorPalette.primaryColor = s, twoToneColorPalette.secondaryColor = c || getSecondaryColor(s), twoToneColorPalette.calculated = !!c;
}
function getTwoToneColors() {
  return _objectSpread2$1({}, twoToneColorPalette);
}
var IconBase$1 = function a(s) {
  var c = s.icon, u = s.className, d = s.onClick, p = s.style, v = s.primaryColor, A = s.secondaryColor, x = _objectWithoutProperties$2(s, _excluded$12), g = reactExports.useRef(), b = twoToneColorPalette;
  if (v && (b = {
    primaryColor: v,
    secondaryColor: A || getSecondaryColor(v)
  }), useInsertStyles(g), warning$2(isIconDefinition(c), "icon should be icon definiton, but got ".concat(c)), !isIconDefinition(c))
    return null;
  var y = c;
  return y && typeof y.icon == "function" && (y = _objectSpread2$1(_objectSpread2$1({}, y), {}, {
    icon: y.icon(b.primaryColor, b.secondaryColor)
  })), generate$1(y.icon, "svg-".concat(y.name), _objectSpread2$1(_objectSpread2$1({
    className: u,
    onClick: d,
    style: p,
    "data-icon": y.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, x), {}, {
    ref: g
  }));
};
IconBase$1.displayName = "IconReact";
IconBase$1.getTwoToneColors = getTwoToneColors;
IconBase$1.setTwoToneColors = setTwoToneColors;
function setTwoToneColor(a) {
  var s = normalizeTwoToneColors(a), c = _slicedToArray$e(s, 2), u = c[0], d = c[1];
  return IconBase$1.setTwoToneColors({
    primaryColor: u,
    secondaryColor: d
  });
}
function getTwoToneColor() {
  var a = IconBase$1.getTwoToneColors();
  return a.calculated ? [a.primaryColor, a.secondaryColor] : a.primaryColor;
}
var _excluded$11 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
setTwoToneColor(blue$1.primary);
var Icon$4 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.className, u = a.icon, d = a.spin, p = a.rotate, v = a.tabIndex, A = a.onClick, x = a.twoToneColor, g = _objectWithoutProperties$2(a, _excluded$11), b = reactExports.useContext(IconContext), y = b.prefixCls, f = y === void 0 ? "anticon" : y, m = b.rootClassName, C = classnames(m, f, _defineProperty$a(_defineProperty$a({}, "".concat(f, "-").concat(u.name), !!u.name), "".concat(f, "-spin"), !!d || u.name === "loading"), c), w = v;
  w === void 0 && A && (w = -1);
  var S = p ? {
    msTransform: "rotate(".concat(p, "deg)"),
    transform: "rotate(".concat(p, "deg)")
  } : void 0, $ = normalizeTwoToneColors(x), T = _slicedToArray$e($, 2), I = T[0], _ = T[1];
  return /* @__PURE__ */ reactExports.createElement("span", _extends$3({
    role: "img",
    "aria-label": u.name
  }, g, {
    ref: s,
    tabIndex: w,
    onClick: A,
    className: C
  }), /* @__PURE__ */ reactExports.createElement(IconBase$1, {
    icon: u,
    primaryColor: I,
    secondaryColor: _,
    style: S
  }));
});
Icon$4.displayName = "AntdIcon";
Icon$4.getTwoToneColor = getTwoToneColor;
Icon$4.setTwoToneColor = setTwoToneColor;
var CheckCircleFilled = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CheckCircleFilled$1
  }));
}, RefIcon$K = /* @__PURE__ */ reactExports.forwardRef(CheckCircleFilled), CloseCircleFilled$1 = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" }, CloseCircleFilled = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CloseCircleFilled$1
  }));
}, RefIcon$J = /* @__PURE__ */ reactExports.forwardRef(CloseCircleFilled), CloseOutlined$3 = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" }, CloseOutlined$2 = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CloseOutlined$3
  }));
}, RefIcon$I = /* @__PURE__ */ reactExports.forwardRef(CloseOutlined$2), ExclamationCircleFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" }, ExclamationCircleFilled = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: ExclamationCircleFilled$1
  }));
}, RefIcon$H = /* @__PURE__ */ reactExports.forwardRef(ExclamationCircleFilled), InfoCircleFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" }, InfoCircleFilled = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: InfoCircleFilled$1
  }));
}, RefIcon$G = /* @__PURE__ */ reactExports.forwardRef(InfoCircleFilled), attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/), ariaPrefix = "aria-", dataPrefix = "data-";
function match(a, s) {
  return a.indexOf(s) === 0;
}
function pickAttrs(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c;
  s === !1 ? c = {
    aria: !0,
    data: !0,
    attr: !0
  } : s === !0 ? c = {
    aria: !0
  } : c = _objectSpread2$1({}, s);
  var u = {};
  return Object.keys(a).forEach(function(d) {
    // Aria
    (c.aria && (d === "role" || match(d, ariaPrefix)) || // Data
    c.data && match(d, dataPrefix) || // Attr
    c.attr && propList.includes(d)) && (u[d] = a[d]);
  }), u;
}
function isFragment(a) {
  return a && /* @__PURE__ */ React.isValidElement(a) && a.type === React.Fragment;
}
const replaceElement = (a, s, c) => /* @__PURE__ */ React.isValidElement(a) ? /* @__PURE__ */ React.cloneElement(a, typeof c == "function" ? c(a.props || {}) : c) : s;
function cloneElement(a, s) {
  return replaceElement(a, a, s);
}
const t = (a) => typeof a == "object" && a != null && a.nodeType === 1, e$1 = (a, s) => (!s || a !== "hidden") && a !== "visible" && a !== "clip", n = (a, s) => {
  if (a.clientHeight < a.scrollHeight || a.clientWidth < a.scrollWidth) {
    const c = getComputedStyle(a, null);
    return e$1(c.overflowY, s) || e$1(c.overflowX, s) || ((u) => {
      const d = ((p) => {
        if (!p.ownerDocument || !p.ownerDocument.defaultView) return null;
        try {
          return p.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(u);
      return !!d && (d.clientHeight < u.scrollHeight || d.clientWidth < u.scrollWidth);
    })(a);
  }
  return !1;
}, o$1 = (a, s, c, u, d, p, v, A) => p < a && v > s || p > a && v < s ? 0 : p <= a && A <= c || v >= s && A >= c ? p - a - u : v > s && A < c || p < a && A > c ? v - s + d : 0, l = (a) => {
  const s = a.parentElement;
  return s ?? (a.getRootNode().host || null);
}, r = (a, s) => {
  var c, u, d, p;
  if (typeof document > "u") return [];
  const { scrollMode: v, block: A, inline: x, boundary: g, skipOverflowHiddenElements: b } = s, y = typeof g == "function" ? g : (k) => k !== g;
  if (!t(a)) throw new TypeError("Invalid target");
  const f = document.scrollingElement || document.documentElement, m = [];
  let C = a;
  for (; t(C) && y(C); ) {
    if (C = l(C), C === f) {
      m.push(C);
      break;
    }
    C != null && C === document.body && n(C) && !n(document.documentElement) || C != null && n(C, b) && m.push(C);
  }
  const w = (u = (c = window.visualViewport) == null ? void 0 : c.width) != null ? u : innerWidth, S = (p = (d = window.visualViewport) == null ? void 0 : d.height) != null ? p : innerHeight, { scrollX: $, scrollY: T } = window, { height: I, width: _, top: E, right: R, bottom: O, left: L } = a.getBoundingClientRect(), { top: B, right: F, bottom: M, left: W } = ((k) => {
    const N = window.getComputedStyle(k);
    return { top: parseFloat(N.scrollMarginTop) || 0, right: parseFloat(N.scrollMarginRight) || 0, bottom: parseFloat(N.scrollMarginBottom) || 0, left: parseFloat(N.scrollMarginLeft) || 0 };
  })(a);
  let j = A === "start" || A === "nearest" ? E - B : A === "end" ? O + M : E + I / 2 - B + M, G = x === "center" ? L + _ / 2 - W + F : x === "end" ? R + F : L - W;
  const U = [];
  for (let k = 0; k < m.length; k++) {
    const N = m[k], { height: P, width: D, top: H, right: V, bottom: Z, left: ne } = N.getBoundingClientRect();
    if (v === "if-needed" && E >= 0 && L >= 0 && O <= S && R <= w && (N === f && !n(N) || E >= H && O <= Z && L >= ne && R <= V)) return U;
    const K = getComputedStyle(N), q = parseInt(K.borderLeftWidth, 10), Y = parseInt(K.borderTopWidth, 10), ee = parseInt(K.borderRightWidth, 10), Q = parseInt(K.borderBottomWidth, 10);
    let J = 0, te = 0;
    const ae = "offsetWidth" in N ? N.offsetWidth - N.clientWidth - q - ee : 0, se = "offsetHeight" in N ? N.offsetHeight - N.clientHeight - Y - Q : 0, ie = "offsetWidth" in N ? N.offsetWidth === 0 ? 0 : D / N.offsetWidth : 0, fe = "offsetHeight" in N ? N.offsetHeight === 0 ? 0 : P / N.offsetHeight : 0;
    if (f === N) J = A === "start" ? j : A === "end" ? j - S : A === "nearest" ? o$1(T, T + S, S, Y, Q, T + j, T + j + I, I) : j - S / 2, te = x === "start" ? G : x === "center" ? G - w / 2 : x === "end" ? G - w : o$1($, $ + w, w, q, ee, $ + G, $ + G + _, _), J = Math.max(0, J + T), te = Math.max(0, te + $);
    else {
      J = A === "start" ? j - H - Y : A === "end" ? j - Z + Q + se : A === "nearest" ? o$1(H, Z, P, Y, Q + se, j, j + I, I) : j - (H + P / 2) + se / 2, te = x === "start" ? G - ne - q : x === "center" ? G - (ne + D / 2) + ae / 2 : x === "end" ? G - V + ee + ae : o$1(ne, V, D, q, ee + ae, G, G + _, _);
      const { scrollLeft: ge, scrollTop: me } = N;
      J = fe === 0 ? 0 : Math.max(0, Math.min(me + J / fe, N.scrollHeight - P / fe + se)), te = ie === 0 ? 0 : Math.max(0, Math.min(ge + te / ie, N.scrollWidth - D / ie + ae)), j += me - J, G += ge - te;
    }
    U.push({ el: N, top: J, left: te });
  }
  return U;
}, o = (a) => a === !1 ? { block: "end", inline: "nearest" } : ((s) => s === Object(s) && Object.keys(s).length !== 0)(a) ? a : { block: "start", inline: "nearest" };
function e(a, s) {
  if (!a.isConnected || !((d) => {
    let p = d;
    for (; p && p.parentNode; ) {
      if (p.parentNode === document) return !0;
      p = p.parentNode instanceof ShadowRoot ? p.parentNode.host : p.parentNode;
    }
    return !1;
  })(a)) return;
  const c = ((d) => {
    const p = window.getComputedStyle(d);
    return { top: parseFloat(p.scrollMarginTop) || 0, right: parseFloat(p.scrollMarginRight) || 0, bottom: parseFloat(p.scrollMarginBottom) || 0, left: parseFloat(p.scrollMarginLeft) || 0 };
  })(a);
  if (((d) => typeof d == "object" && typeof d.behavior == "function")(s)) return s.behavior(r(a, s));
  const u = typeof s == "boolean" || s == null ? void 0 : s.behavior;
  for (const { el: d, top: p, left: v } of r(a, o(s))) {
    const A = p - c.top + c.bottom, x = v - c.left + c.right;
    d.scroll({ top: A, left: x, behavior: u });
  }
}
function isWindow$3(a) {
  return a != null && a === a.window;
}
const getScroll$3 = (a) => {
  var s, c;
  if (typeof window > "u")
    return 0;
  let u = 0;
  return isWindow$3(a) ? u = a.pageYOffset : a instanceof Document ? u = a.documentElement.scrollTop : (a instanceof HTMLElement || a) && (u = a.scrollTop), a && !isWindow$3(a) && typeof u != "number" && (u = (c = ((s = a.ownerDocument) !== null && s !== void 0 ? s : a).documentElement) === null || c === void 0 ? void 0 : c.scrollTop), u;
};
function easeInOutCubic(a, s, c, u) {
  const d = c - s;
  return a /= u / 2, a < 1 ? d / 2 * a * a * a + s : d / 2 * ((a -= 2) * a * a + 2) + s;
}
function scrollTo(a, s = {}) {
  const {
    getContainer: c = () => window,
    callback: u,
    duration: d = 450
  } = s, p = c(), v = getScroll$3(p), A = Date.now(), x = () => {
    const b = Date.now() - A, y = easeInOutCubic(b > d ? d : b, v, a, d);
    isWindow$3(p) ? p.scrollTo(window.pageXOffset, y) : p instanceof Document || p.constructor.name === "HTMLDocument" ? p.documentElement.scrollTop = y : p.scrollTop = y, b < d ? wrapperRaf(x) : typeof u == "function" && u();
  };
  wrapperRaf(x);
}
const useCSSVarCls = (a) => {
  const [, , , , s] = useToken$1();
  return s ? `${a}-css-var` : "";
};
var KeyCode = {
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  /**
   * N
   */
  N: 78,
  /**
   * P
   */
  P: 80,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224
}, Notify = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.style, d = a.className, p = a.duration, v = p === void 0 ? 4.5 : p, A = a.showProgress, x = a.pauseOnHover, g = x === void 0 ? !0 : x, b = a.eventKey, y = a.content, f = a.closable, m = a.closeIcon, C = m === void 0 ? "x" : m, w = a.props, S = a.onClick, $ = a.onNoticeClose, T = a.times, I = a.hovering, _ = reactExports.useState(!1), E = _slicedToArray$e(_, 2), R = E[0], O = E[1], L = reactExports.useState(0), B = _slicedToArray$e(L, 2), F = B[0], M = B[1], W = reactExports.useState(0), j = _slicedToArray$e(W, 2), G = j[0], U = j[1], k = I || R, N = v > 0 && A, P = function() {
    $(b);
  }, D = function(q) {
    (q.key === "Enter" || q.code === "Enter" || q.keyCode === KeyCode.ENTER) && P();
  };
  reactExports.useEffect(function() {
    if (!k && v > 0) {
      var K = Date.now() - G, q = setTimeout(function() {
        P();
      }, v * 1e3 - G);
      return function() {
        g && clearTimeout(q), U(Date.now() - K);
      };
    }
  }, [v, k, T]), reactExports.useEffect(function() {
    if (!k && N && (g || G === 0)) {
      var K = performance.now(), q, Y = function ee() {
        cancelAnimationFrame(q), q = requestAnimationFrame(function(Q) {
          var J = Q + G - K, te = Math.min(J / (v * 1e3), 1);
          M(te * 100), te < 1 && ee();
        });
      };
      return Y(), function() {
        g && cancelAnimationFrame(q);
      };
    }
  }, [v, G, k, N, T]);
  var H = reactExports.useMemo(function() {
    return _typeof$h(f) === "object" && f !== null ? f : f ? {
      closeIcon: C
    } : {};
  }, [f, C]), V = pickAttrs(H, !0), Z = 100 - (!F || F < 0 ? 0 : F > 100 ? 100 : F), ne = "".concat(c, "-notice");
  return /* @__PURE__ */ reactExports.createElement("div", _extends$3({}, w, {
    ref: s,
    className: classnames(ne, d, _defineProperty$a({}, "".concat(ne, "-closable"), f)),
    style: u,
    onMouseEnter: function(q) {
      var Y;
      O(!0), w == null || (Y = w.onMouseEnter) === null || Y === void 0 || Y.call(w, q);
    },
    onMouseLeave: function(q) {
      var Y;
      O(!1), w == null || (Y = w.onMouseLeave) === null || Y === void 0 || Y.call(w, q);
    },
    onClick: S
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(ne, "-content")
  }, y), f && /* @__PURE__ */ reactExports.createElement("a", _extends$3({
    tabIndex: 0,
    className: "".concat(ne, "-close"),
    onKeyDown: D,
    "aria-label": "Close"
  }, V, {
    onClick: function(q) {
      q.preventDefault(), q.stopPropagation(), P();
    }
  }), H.closeIcon), N && /* @__PURE__ */ reactExports.createElement("progress", {
    className: "".concat(ne, "-progress"),
    max: "100",
    value: Z
  }, Z + "%"));
}), NotificationContext = /* @__PURE__ */ React.createContext({}), NotificationProvider = function a(s) {
  var c = s.children, u = s.classNames;
  return /* @__PURE__ */ React.createElement(NotificationContext.Provider, {
    value: {
      classNames: u
    }
  }, c);
}, DEFAULT_OFFSET$1 = 8, DEFAULT_THRESHOLD = 3, DEFAULT_GAP = 16, useStack = function a(s) {
  var c = {
    offset: DEFAULT_OFFSET$1,
    threshold: DEFAULT_THRESHOLD,
    gap: DEFAULT_GAP
  };
  if (s && _typeof$h(s) === "object") {
    var u, d, p;
    c.offset = (u = s.offset) !== null && u !== void 0 ? u : DEFAULT_OFFSET$1, c.threshold = (d = s.threshold) !== null && d !== void 0 ? d : DEFAULT_THRESHOLD, c.gap = (p = s.gap) !== null && p !== void 0 ? p : DEFAULT_GAP;
  }
  return [!!s, c];
}, _excluded$10 = ["className", "style", "classNames", "styles"], NoticeList = function a(s) {
  var c = s.configList, u = s.placement, d = s.prefixCls, p = s.className, v = s.style, A = s.motion, x = s.onAllNoticeRemoved, g = s.onNoticeClose, b = s.stack, y = reactExports.useContext(NotificationContext), f = y.classNames, m = reactExports.useRef({}), C = reactExports.useState(null), w = _slicedToArray$e(C, 2), S = w[0], $ = w[1], T = reactExports.useState([]), I = _slicedToArray$e(T, 2), _ = I[0], E = I[1], R = c.map(function(k) {
    return {
      config: k,
      key: String(k.key)
    };
  }), O = useStack(b), L = _slicedToArray$e(O, 2), B = L[0], F = L[1], M = F.offset, W = F.threshold, j = F.gap, G = B && (_.length > 0 || R.length <= W), U = typeof A == "function" ? A(u) : A;
  return reactExports.useEffect(function() {
    B && _.length > 1 && E(function(k) {
      return k.filter(function(N) {
        return R.some(function(P) {
          var D = P.key;
          return N === D;
        });
      });
    });
  }, [_, R, B]), reactExports.useEffect(function() {
    var k;
    if (B && m.current[(k = R[R.length - 1]) === null || k === void 0 ? void 0 : k.key]) {
      var N;
      $(m.current[(N = R[R.length - 1]) === null || N === void 0 ? void 0 : N.key]);
    }
  }, [R, B]), /* @__PURE__ */ React.createElement(CSSMotionList, _extends$3({
    key: u,
    className: classnames(d, "".concat(d, "-").concat(u), f?.list, p, _defineProperty$a(_defineProperty$a({}, "".concat(d, "-stack"), !!B), "".concat(d, "-stack-expanded"), G)),
    style: v,
    keys: R,
    motionAppear: !0
  }, U, {
    onAllRemoved: function() {
      x(u);
    }
  }), function(k, N) {
    var P = k.config, D = k.className, H = k.style, V = k.index, Z = P, ne = Z.key, K = Z.times, q = String(ne), Y = P, ee = Y.className, Q = Y.style, J = Y.classNames, te = Y.styles, ae = _objectWithoutProperties$2(Y, _excluded$10), se = R.findIndex(function(xe) {
      return xe.key === q;
    }), ie = {};
    if (B) {
      var fe = R.length - 1 - (se > -1 ? se : V - 1), ge = u === "top" || u === "bottom" ? "-50%" : "0";
      if (fe > 0) {
        var me, pe, be;
        ie.height = G ? (me = m.current[q]) === null || me === void 0 ? void 0 : me.offsetHeight : S?.offsetHeight;
        for (var le = 0, ve = 0; ve < fe; ve++) {
          var he;
          le += ((he = m.current[R[R.length - 1 - ve].key]) === null || he === void 0 ? void 0 : he.offsetHeight) + j;
        }
        var ye = (G ? le : fe * M) * (u.startsWith("top") ? 1 : -1), Ce = !G && S !== null && S !== void 0 && S.offsetWidth && (pe = m.current[q]) !== null && pe !== void 0 && pe.offsetWidth ? (S?.offsetWidth - M * 2 * (fe < 3 ? fe : 3)) / ((be = m.current[q]) === null || be === void 0 ? void 0 : be.offsetWidth) : 1;
        ie.transform = "translate3d(".concat(ge, ", ").concat(ye, "px, 0) scaleX(").concat(Ce, ")");
      } else
        ie.transform = "translate3d(".concat(ge, ", 0, 0)");
    }
    return /* @__PURE__ */ React.createElement("div", {
      ref: N,
      className: classnames("".concat(d, "-notice-wrapper"), D, J?.wrapper),
      style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, H), ie), te?.wrapper),
      onMouseEnter: function() {
        return E(function(we) {
          return we.includes(q) ? we : [].concat(_toConsumableArray$e(we), [q]);
        });
      },
      onMouseLeave: function() {
        return E(function(we) {
          return we.filter(function($e) {
            return $e !== q;
          });
        });
      }
    }, /* @__PURE__ */ React.createElement(Notify, _extends$3({}, ae, {
      ref: function(we) {
        se > -1 ? m.current[q] = we : delete m.current[q];
      },
      prefixCls: d,
      classNames: J,
      styles: te,
      className: classnames(ee, f?.notice),
      style: Q,
      times: K,
      key: ne,
      eventKey: ne,
      onNoticeClose: g,
      hovering: B && _.length > 0
    })));
  });
}, Notifications = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = c === void 0 ? "rc-notification" : c, d = a.container, p = a.motion, v = a.maxCount, A = a.className, x = a.style, g = a.onAllRemoved, b = a.stack, y = a.renderNotifications, f = reactExports.useState([]), m = _slicedToArray$e(f, 2), C = m[0], w = m[1], S = function(B) {
    var F, M = C.find(function(W) {
      return W.key === B;
    });
    M == null || (F = M.onClose) === null || F === void 0 || F.call(M), w(function(W) {
      return W.filter(function(j) {
        return j.key !== B;
      });
    });
  };
  reactExports.useImperativeHandle(s, function() {
    return {
      open: function(B) {
        w(function(F) {
          var M = _toConsumableArray$e(F), W = M.findIndex(function(U) {
            return U.key === B.key;
          }), j = _objectSpread2$1({}, B);
          if (W >= 0) {
            var G;
            j.times = (((G = F[W]) === null || G === void 0 ? void 0 : G.times) || 0) + 1, M[W] = j;
          } else
            j.times = 0, M.push(j);
          return v > 0 && M.length > v && (M = M.slice(-v)), M;
        });
      },
      close: function(B) {
        S(B);
      },
      destroy: function() {
        w([]);
      }
    };
  });
  var $ = reactExports.useState({}), T = _slicedToArray$e($, 2), I = T[0], _ = T[1];
  reactExports.useEffect(function() {
    var L = {};
    C.forEach(function(B) {
      var F = B.placement, M = F === void 0 ? "topRight" : F;
      M && (L[M] = L[M] || [], L[M].push(B));
    }), Object.keys(I).forEach(function(B) {
      L[B] = L[B] || [];
    }), _(L);
  }, [C]);
  var E = function(B) {
    _(function(F) {
      var M = _objectSpread2$1({}, F), W = M[B] || [];
      return W.length || delete M[B], M;
    });
  }, R = reactExports.useRef(!1);
  if (reactExports.useEffect(function() {
    Object.keys(I).length > 0 ? R.current = !0 : R.current && (g?.(), R.current = !1);
  }, [I]), !d)
    return null;
  var O = Object.keys(I);
  return /* @__PURE__ */ reactDomExports.createPortal(/* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, O.map(function(L) {
    var B = I[L], F = /* @__PURE__ */ reactExports.createElement(NoticeList, {
      key: L,
      configList: B,
      placement: L,
      prefixCls: u,
      className: A?.(L),
      style: x?.(L),
      motion: p,
      onNoticeClose: S,
      onAllNoticeRemoved: E,
      stack: b
    });
    return y ? y(F, {
      prefixCls: u,
      key: L
    }) : F;
  })), d);
}), _excluded$$ = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], defaultGetContainer = function a() {
  return document.body;
}, uniqueKey = 0;
function mergeConfig() {
  for (var a = {}, s = arguments.length, c = new Array(s), u = 0; u < s; u++)
    c[u] = arguments[u];
  return c.forEach(function(d) {
    d && Object.keys(d).forEach(function(p) {
      var v = d[p];
      v !== void 0 && (a[p] = v);
    });
  }), a;
}
function useNotification() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = a.getContainer, c = s === void 0 ? defaultGetContainer : s, u = a.motion, d = a.prefixCls, p = a.maxCount, v = a.className, A = a.style, x = a.onAllRemoved, g = a.stack, b = a.renderNotifications, y = _objectWithoutProperties$2(a, _excluded$$), f = reactExports.useState(), m = _slicedToArray$e(f, 2), C = m[0], w = m[1], S = reactExports.useRef(), $ = /* @__PURE__ */ reactExports.createElement(Notifications, {
    container: C,
    ref: S,
    prefixCls: d,
    motion: u,
    maxCount: p,
    className: v,
    style: A,
    onAllRemoved: x,
    stack: g,
    renderNotifications: b
  }), T = reactExports.useState([]), I = _slicedToArray$e(T, 2), _ = I[0], E = I[1], R = useEvent(function(L) {
    var B = mergeConfig(y, L);
    (B.key === null || B.key === void 0) && (B.key = "rc-notification-".concat(uniqueKey), uniqueKey += 1), E(function(F) {
      return [].concat(_toConsumableArray$e(F), [{
        type: "open",
        config: B
      }]);
    });
  }), O = reactExports.useMemo(function() {
    return {
      open: R,
      close: function(B) {
        E(function(F) {
          return [].concat(_toConsumableArray$e(F), [{
            type: "close",
            key: B
          }]);
        });
      },
      destroy: function() {
        E(function(B) {
          return [].concat(_toConsumableArray$e(B), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return reactExports.useEffect(function() {
    w(c());
  }), reactExports.useEffect(function() {
    if (S.current && _.length) {
      _.forEach(function(F) {
        switch (F.type) {
          case "open":
            S.current.open(F.config);
            break;
          case "close":
            S.current.close(F.key);
            break;
          case "destroy":
            S.current.destroy();
            break;
        }
      });
      var L, B;
      E(function(F) {
        return (L !== F || !B) && (L = F, B = F.filter(function(M) {
          return !_.includes(M);
        })), B;
      });
    }
  }, [_]), [O, $];
}
var LoadingOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" }, LoadingOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: LoadingOutlined$1
  }));
}, RefIcon$F = /* @__PURE__ */ reactExports.forwardRef(LoadingOutlined);
const zIndexContext = /* @__PURE__ */ React.createContext(void 0), CONTAINER_OFFSET = 100, CONTAINER_OFFSET_MAX_COUNT = 10, CONTAINER_MAX_OFFSET = CONTAINER_OFFSET * CONTAINER_OFFSET_MAX_COUNT, containerBaseZIndexOffset = {
  Modal: CONTAINER_OFFSET,
  Drawer: CONTAINER_OFFSET,
  Popover: CONTAINER_OFFSET,
  Popconfirm: CONTAINER_OFFSET,
  Tooltip: CONTAINER_OFFSET,
  Tour: CONTAINER_OFFSET,
  FloatButton: CONTAINER_OFFSET
}, consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function isContainerType(a) {
  return a in containerBaseZIndexOffset;
}
const useZIndex = (a, s) => {
  const [, c] = useToken$1(), u = React.useContext(zIndexContext), d = isContainerType(a);
  let p;
  if (s !== void 0)
    p = [s, s];
  else {
    let v = u ?? 0;
    d ? v += // Use preset token zIndex by default but not stack when has parent container
    (u ? 0 : c.zIndexPopupBase) + // Container offset
    containerBaseZIndexOffset[a] : v += consumerBaseZIndexOffset[a], p = [u === void 0 ? s : v, v];
  }
  return p;
}, genMessageStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    boxShadow: u,
    colorText: d,
    colorSuccess: p,
    colorError: v,
    colorWarning: A,
    colorInfo: x,
    fontSizeLG: g,
    motionEaseInOutCirc: b,
    motionDurationSlow: y,
    marginXS: f,
    paddingXS: m,
    borderRadiusLG: C,
    zIndexPopup: w,
    // Custom token
    contentPadding: S,
    contentBg: $
  } = a, T = `${s}-notice`, I = new Keyframe("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: m,
      transform: "translateY(0)",
      opacity: 1
    }
  }), _ = new Keyframe("MessageMoveOut", {
    "0%": {
      maxHeight: a.height,
      padding: m,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  }), E = {
    padding: m,
    textAlign: "center",
    [`${s}-custom-content`]: {
      display: "flex",
      alignItems: "center"
    },
    [`${s}-custom-content > ${c}`]: {
      marginInlineEnd: f,
      // affected by ltr or rtl
      fontSize: g
    },
    [`${T}-content`]: {
      display: "inline-block",
      padding: S,
      background: $,
      borderRadius: C,
      boxShadow: u,
      pointerEvents: "all"
    },
    [`${s}-success > ${c}`]: {
      color: p
    },
    [`${s}-error > ${c}`]: {
      color: v
    },
    [`${s}-warning > ${c}`]: {
      color: A
    },
    [`${s}-info > ${c},
      ${s}-loading > ${c}`]: {
      color: x
    }
  };
  return [
    // ============================ Holder ============================
    {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        color: d,
        position: "fixed",
        top: f,
        width: "100%",
        pointerEvents: "none",
        zIndex: w,
        [`${s}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${s}-move-up-appear,
        ${s}-move-up-enter
      `]: {
          animationName: I,
          animationDuration: y,
          animationPlayState: "paused",
          animationTimingFunction: b
        },
        [`
        ${s}-move-up-appear${s}-move-up-appear-active,
        ${s}-move-up-enter${s}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${s}-move-up-leave`]: {
          animationName: _,
          animationDuration: y,
          animationPlayState: "paused",
          animationTimingFunction: b
        },
        [`${s}-move-up-leave${s}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [s]: {
        [`${T}-wrapper`]: Object.assign({}, E)
      }
    },
    // ============================= Pure =============================
    {
      [`${s}-notice-pure-panel`]: Object.assign(Object.assign({}, E), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
}, prepareComponentToken$u = (a) => ({
  zIndexPopup: a.zIndexPopupBase + CONTAINER_MAX_OFFSET + 10,
  contentBg: a.colorBgElevated,
  contentPadding: `${(a.controlHeightLG - a.fontSize * a.lineHeight) / 2}px ${a.paddingSM}px`
}), useStyle$z = genStyleHooks("Message", (a) => {
  const s = merge(a, {
    height: 150
  });
  return [genMessageStyle(s)];
}, prepareComponentToken$u);
var __rest$11 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const TypeIcon = {
  info: /* @__PURE__ */ reactExports.createElement(RefIcon$G, null),
  success: /* @__PURE__ */ reactExports.createElement(RefIcon$K, null),
  error: /* @__PURE__ */ reactExports.createElement(RefIcon$J, null),
  warning: /* @__PURE__ */ reactExports.createElement(RefIcon$H, null),
  loading: /* @__PURE__ */ reactExports.createElement(RefIcon$F, null)
}, PureContent = ({
  prefixCls: a,
  type: s,
  icon: c,
  children: u
}) => /* @__PURE__ */ reactExports.createElement("div", {
  className: classnames(`${a}-custom-content`, `${a}-${s}`)
}, c || TypeIcon[s], /* @__PURE__ */ reactExports.createElement("span", null, u)), PurePanel$7 = (a) => {
  const {
    prefixCls: s,
    className: c,
    type: u,
    icon: d,
    content: p
  } = a, v = __rest$11(a, ["prefixCls", "className", "type", "icon", "content"]), {
    getPrefixCls: A
  } = reactExports.useContext(ConfigContext$1), x = s || A("message"), g = useCSSVarCls(x), [b, y, f] = useStyle$z(x, g);
  return b(/* @__PURE__ */ reactExports.createElement(Notify, Object.assign({}, v, {
    prefixCls: x,
    className: classnames(c, y, `${x}-notice-pure-panel`, f, g),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ reactExports.createElement(PureContent, {
      prefixCls: x,
      type: u,
      icon: d
    }, p)
  })));
};
function getMotion$2(a, s) {
  return {
    motionName: s ?? `${a}-move-up`
  };
}
function wrapPromiseFn(a) {
  let s;
  const c = new Promise((d) => {
    s = a(() => {
      d(!0);
    });
  }), u = () => {
    s?.();
  };
  return u.then = (d, p) => c.then(d, p), u.promise = c, u;
}
var __rest$10 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const DEFAULT_OFFSET = 8, DEFAULT_DURATION = 3, Wrapper$1 = ({
  children: a,
  prefixCls: s
}) => {
  const c = useCSSVarCls(s), [u, d, p] = useStyle$z(s, c);
  return u(/* @__PURE__ */ reactExports.createElement(NotificationProvider, {
    classNames: {
      list: classnames(d, p, c)
    }
  }, a));
}, renderNotifications = (a, {
  prefixCls: s,
  key: c
}) => /* @__PURE__ */ reactExports.createElement(Wrapper$1, {
  prefixCls: s,
  key: c
}, a), Holder = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    top: c,
    prefixCls: u,
    getContainer: d,
    maxCount: p,
    duration: v = DEFAULT_DURATION,
    rtl: A,
    transitionName: x,
    onAllRemoved: g
  } = a, {
    getPrefixCls: b,
    getPopupContainer: y,
    message: f,
    direction: m
  } = reactExports.useContext(ConfigContext$1), C = u || b("message"), w = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: c ?? DEFAULT_OFFSET
  }), S = () => classnames({
    [`${C}-rtl`]: A ?? m === "rtl"
  }), $ = () => getMotion$2(C, x), T = /* @__PURE__ */ reactExports.createElement("span", {
    className: `${C}-close-x`
  }, /* @__PURE__ */ reactExports.createElement(RefIcon$I, {
    className: `${C}-close-icon`
  })), [I, _] = useNotification({
    prefixCls: C,
    style: w,
    className: S,
    motion: $,
    closable: !1,
    closeIcon: T,
    duration: v,
    getContainer: () => d?.() || y?.() || document.body,
    maxCount: p,
    onAllRemoved: g,
    renderNotifications
  });
  return reactExports.useImperativeHandle(s, () => Object.assign(Object.assign({}, I), {
    prefixCls: C,
    message: f
  })), _;
});
let keyIndex = 0;
function useInternalMessage(a) {
  const s = reactExports.useRef(null);
  return devUseWarning(), [reactExports.useMemo(() => {
    const u = (x) => {
      var g;
      (g = s.current) === null || g === void 0 || g.close(x);
    }, d = (x) => {
      if (!s.current) {
        const R = () => {
        };
        return R.then = () => {
        }, R;
      }
      const {
        open: g,
        prefixCls: b,
        message: y
      } = s.current, f = `${b}-notice`, {
        content: m,
        icon: C,
        type: w,
        key: S,
        className: $,
        style: T,
        onClose: I
      } = x, _ = __rest$10(x, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let E = S;
      return E == null && (keyIndex += 1, E = `antd-message-${keyIndex}`), wrapPromiseFn((R) => (g(Object.assign(Object.assign({}, _), {
        key: E,
        content: /* @__PURE__ */ reactExports.createElement(PureContent, {
          prefixCls: b,
          type: w,
          icon: C
        }, m),
        placement: "top",
        className: classnames(w && `${f}-${w}`, $, y?.className),
        style: Object.assign(Object.assign({}, y?.style), T),
        onClose: () => {
          I?.(), R();
        }
      })), () => {
        u(E);
      }));
    }, v = {
      open: d,
      destroy: (x) => {
        var g;
        x !== void 0 ? u(x) : (g = s.current) === null || g === void 0 || g.destroy();
      }
    };
    return ["info", "success", "warning", "error", "loading"].forEach((x) => {
      const g = (b, y, f) => {
        let m;
        b && typeof b == "object" && "content" in b ? m = b : m = {
          content: b
        };
        let C, w;
        typeof y == "function" ? w = y : (C = y, w = f);
        const S = Object.assign(Object.assign({
          onClose: w,
          duration: C
        }, m), {
          type: x
        });
        return d(S);
      };
      v[x] = g;
    }), v;
  }, []), /* @__PURE__ */ reactExports.createElement(Holder, Object.assign({
    key: "message-holder"
  }, a, {
    ref: s
  }))];
}
function useMessage(a) {
  return useInternalMessage(a);
}
function _OverloadYield(a, s) {
  this.v = a, this.k = s;
}
function _regeneratorDefine(a, s, c, u) {
  var d = Object.defineProperty;
  try {
    d({}, "", {});
  } catch {
    d = 0;
  }
  _regeneratorDefine = function(v, A, x, g) {
    if (A) d ? d(v, A, {
      value: x,
      enumerable: !g,
      configurable: !g,
      writable: !g
    }) : v[A] = x;
    else {
      var b = function(f, m) {
        _regeneratorDefine(v, f, function(C) {
          return this._invoke(f, m, C);
        });
      };
      b("next", 0), b("throw", 1), b("return", 2);
    }
  }, _regeneratorDefine(a, s, c, u);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var a, s, c = typeof Symbol == "function" ? Symbol : {}, u = c.iterator || "@@iterator", d = c.toStringTag || "@@toStringTag";
  function p(m, C, w, S) {
    var $ = C && C.prototype instanceof A ? C : A, T = Object.create($.prototype);
    return _regeneratorDefine(T, "_invoke", function(I, _, E) {
      var R, O, L, B = 0, F = E || [], M = !1, W = {
        p: 0,
        n: 0,
        v: a,
        a: j,
        f: j.bind(a, 4),
        d: function(U, k) {
          return R = U, O = 0, L = a, W.n = k, v;
        }
      };
      function j(G, U) {
        for (O = G, L = U, s = 0; !M && B && !k && s < F.length; s++) {
          var k, N = F[s], P = W.p, D = N[2];
          G > 3 ? (k = D === U) && (L = N[(O = N[4]) ? 5 : (O = 3, 3)], N[4] = N[5] = a) : N[0] <= P && ((k = G < 2 && P < N[1]) ? (O = 0, W.v = U, W.n = N[1]) : P < D && (k = G < 3 || N[0] > U || U > D) && (N[4] = G, N[5] = U, W.n = D, O = 0));
        }
        if (k || G > 1) return v;
        throw M = !0, U;
      }
      return function(G, U, k) {
        if (B > 1) throw TypeError("Generator is already running");
        for (M && U === 1 && j(U, k), O = U, L = k; (s = O < 2 ? a : L) || !M; ) {
          R || (O ? O < 3 ? (O > 1 && (W.n = -1), j(O, L)) : W.n = L : W.v = L);
          try {
            if (B = 2, R) {
              if (O || (G = "next"), s = R[G]) {
                if (!(s = s.call(R, L))) throw TypeError("iterator result is not an object");
                if (!s.done) return s;
                L = s.value, O < 2 && (O = 0);
              } else O === 1 && (s = R.return) && s.call(R), O < 2 && (L = TypeError("The iterator does not provide a '" + G + "' method"), O = 1);
              R = a;
            } else if ((s = (M = W.n < 0) ? L : I.call(_, W)) !== v) break;
          } catch (N) {
            R = a, O = 1, L = N;
          } finally {
            B = 1;
          }
        }
        return {
          value: s,
          done: M
        };
      };
    }(m, w, S), !0), T;
  }
  var v = {};
  function A() {
  }
  function x() {
  }
  function g() {
  }
  s = Object.getPrototypeOf;
  var b = [][u] ? s(s([][u]())) : (_regeneratorDefine(s = {}, u, function() {
    return this;
  }), s), y = g.prototype = A.prototype = Object.create(b);
  function f(m) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(m, g) : (m.__proto__ = g, _regeneratorDefine(m, d, "GeneratorFunction")), m.prototype = Object.create(y), m;
  }
  return x.prototype = g, _regeneratorDefine(y, "constructor", g), _regeneratorDefine(g, "constructor", x), x.displayName = "GeneratorFunction", _regeneratorDefine(g, d, "GeneratorFunction"), _regeneratorDefine(y), _regeneratorDefine(y, d, "Generator"), _regeneratorDefine(y, u, function() {
    return this;
  }), _regeneratorDefine(y, "toString", function() {
    return "[object Generator]";
  }), (_regenerator = function() {
    return {
      w: p,
      m: f
    };
  })();
}
function AsyncIterator(a, s) {
  function c(d, p, v, A) {
    try {
      var x = a[d](p), g = x.value;
      return g instanceof _OverloadYield ? s.resolve(g.v).then(function(b) {
        c("next", b, v, A);
      }, function(b) {
        c("throw", b, v, A);
      }) : s.resolve(g).then(function(b) {
        x.value = b, v(x);
      }, function(b) {
        return c("throw", b, v, A);
      });
    } catch (b) {
      A(b);
    }
  }
  var u;
  this.next || (_regeneratorDefine(AsyncIterator.prototype), _regeneratorDefine(AsyncIterator.prototype, typeof Symbol == "function" && Symbol.asyncIterator || "@asyncIterator", function() {
    return this;
  })), _regeneratorDefine(this, "_invoke", function(d, p, v) {
    function A() {
      return new s(function(x, g) {
        c(d, v, x, g);
      });
    }
    return u = u ? u.then(A, A) : A();
  }, !0);
}
function _regeneratorAsyncGen(a, s, c, u, d) {
  return new AsyncIterator(_regenerator().w(a, s, c, u), d || Promise);
}
function _regeneratorAsync(a, s, c, u, d) {
  var p = _regeneratorAsyncGen(a, s, c, u, d);
  return p.next().then(function(v) {
    return v.done ? v.value : p.next();
  });
}
function _regeneratorKeys(a) {
  var s = Object(a), c = [];
  for (var u in s) c.unshift(u);
  return function d() {
    for (; c.length; ) if ((u = c.pop()) in s) return d.value = u, d.done = !1, d;
    return d.done = !0, d;
  };
}
function _regeneratorValues(a) {
  if (a != null) {
    var s = a[typeof Symbol == "function" && Symbol.iterator || "@@iterator"], c = 0;
    if (s) return s.call(a);
    if (typeof a.next == "function") return a;
    if (!isNaN(a.length)) return {
      next: function() {
        return a && c >= a.length && (a = void 0), {
          value: a && a[c++],
          done: !a
        };
      }
    };
  }
  throw new TypeError(_typeof$h(a) + " is not iterable");
}
function _regeneratorRuntime$3() {
  var a = _regenerator(), s = a.m(_regeneratorRuntime$3), c = (Object.getPrototypeOf ? Object.getPrototypeOf(s) : s.__proto__).constructor;
  function u(v) {
    var A = typeof v == "function" && v.constructor;
    return !!A && (A === c || (A.displayName || A.name) === "GeneratorFunction");
  }
  var d = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function p(v) {
    var A, x;
    return function(g) {
      A || (A = {
        stop: function() {
          return x(g.a, 2);
        },
        catch: function() {
          return g.v;
        },
        abrupt: function(y, f) {
          return x(g.a, d[y], f);
        },
        delegateYield: function(y, f, m) {
          return A.resultName = f, x(g.d, _regeneratorValues(y), m);
        },
        finish: function(y) {
          return x(g.f, y);
        }
      }, x = function(y, f, m) {
        g.p = A.prev, g.n = A.next;
        try {
          return y(f, m);
        } finally {
          A.next = g.n;
        }
      }), A.resultName && (A[A.resultName] = g.v, A.resultName = void 0), A.sent = g.v, A.next = g.n;
      try {
        return v.call(this, A);
      } finally {
        g.p = A.prev, g.n = A.next;
      }
    };
  }
  return (_regeneratorRuntime$3 = function() {
    return {
      wrap: function(x, g, b, y) {
        return a.w(p(x), g, b, y && y.reverse());
      },
      isGeneratorFunction: u,
      mark: a.m,
      awrap: function(x, g) {
        return new _OverloadYield(x, g);
      },
      AsyncIterator,
      async: function(x, g, b, y, f) {
        return (u(g) ? _regeneratorAsyncGen : _regeneratorAsync)(p(x), g, b, y, f);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function asyncGeneratorStep(a, s, c, u, d, p, v) {
  try {
    var A = a[p](v), x = A.value;
  } catch (g) {
    return void c(g);
  }
  A.done ? s(x) : Promise.resolve(x).then(u, d);
}
function _asyncToGenerator(a) {
  return function() {
    var s = this, c = arguments;
    return new Promise(function(u, d) {
      var p = a.apply(s, c);
      function v(x) {
        asyncGeneratorStep(p, u, d, v, A, "next", x);
      }
      function A(x) {
        asyncGeneratorStep(p, u, d, v, A, "throw", x);
      }
      v(void 0);
    });
  };
}
var fullClone = _objectSpread2$1({}, ReactDOM$1), version = fullClone.version, reactRender = fullClone.render, unmountComponentAtNode = fullClone.unmountComponentAtNode, createRoot;
try {
  var mainVersion = Number((version || "").split(".")[0]);
  mainVersion >= 18 && (createRoot = fullClone.createRoot);
} catch (a) {
}
function toggleWarning(a) {
  var s = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  s && _typeof$h(s) === "object" && (s.usingClientEntryPoint = a);
}
var MARK = "__rc_react_root__";
function modernRender(a, s) {
  toggleWarning(!0);
  var c = s[MARK] || createRoot(s);
  toggleWarning(!1), c.render(a), s[MARK] = c;
}
function legacyRender(a, s) {
  reactRender?.(a, s);
}
function render(a, s) {
  if (createRoot) {
    modernRender(a, s);
    return;
  }
  legacyRender(a, s);
}
function modernUnmount(a) {
  return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
  return _modernUnmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s) {
    return _regeneratorRuntime$3().wrap(function(u) {
      for (; ; ) switch (u.prev = u.next) {
        case 0:
          return u.abrupt("return", Promise.resolve().then(function() {
            var d;
            (d = s[MARK]) === null || d === void 0 || d.unmount(), delete s[MARK];
          }));
        case 1:
        case "end":
          return u.stop();
      }
    }, a);
  })), _modernUnmount.apply(this, arguments);
}
function legacyUnmount(a) {
  unmountComponentAtNode(a);
}
function unmount(a) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  return _unmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s) {
    return _regeneratorRuntime$3().wrap(function(u) {
      for (; ; ) switch (u.prev = u.next) {
        case 0:
          if (createRoot === void 0) {
            u.next = 2;
            break;
          }
          return u.abrupt("return", modernUnmount(s));
        case 2:
          legacyUnmount(s);
        case 3:
        case "end":
          return u.stop();
      }
    }, a);
  })), _unmount.apply(this, arguments);
}
const defaultReactRender = (a, s) => (render(a, s), () => unmount(s));
let unstableRender = defaultReactRender;
function unstableSetRender(a) {
  return unstableRender;
}
const getCollapsedHeight = () => ({
  height: 0,
  opacity: 0
}), getRealHeight = (a) => {
  const {
    scrollHeight: s
  } = a;
  return {
    height: s,
    opacity: 1
  };
}, getCurrentHeight = (a) => ({
  height: a ? a.offsetHeight : 0
}), skipOpacityTransition = (a, s) => s?.deadline === !0 || s.propertyName === "height", initCollapseMotion = (a = defaultPrefixCls) => ({
  motionName: `${a}-motion-collapse`,
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
}), getTransitionName$1 = (a, s, c) => c !== void 0 ? c : `${a}-${s}`;
function omit(a, s) {
  var c = Object.assign({}, a);
  return Array.isArray(s) && s.forEach(function(u) {
    delete c[u];
  }), c;
}
const isVisible = function(a) {
  if (!a)
    return !1;
  if (a instanceof Element) {
    if (a.offsetParent)
      return !0;
    if (a.getBBox) {
      var s = a.getBBox(), c = s.width, u = s.height;
      if (c || u)
        return !0;
    }
    if (a.getBoundingClientRect) {
      var d = a.getBoundingClientRect(), p = d.width, v = d.height;
      if (p || v)
        return !0;
    }
  }
  return !1;
}, genWaveStyle = (a) => {
  const {
    componentCls: s,
    colorPrimary: c
  } = a;
  return {
    [s]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${c})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${a.motionEaseOutCirc}`, `opacity 2s ${a.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${a.motionDurationSlow} ${a.motionEaseInOut}`, `opacity ${a.motionDurationSlow} ${a.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, useStyle$y = genComponentStyleHook("Wave", (a) => [genWaveStyle(a)]), TARGET_CLS = `${defaultPrefixCls}-wave-target`;
function isValidWaveColor(a) {
  return a && a !== "#fff" && a !== "#ffffff" && a !== "rgb(255, 255, 255)" && a !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(a) && // any transparent rgba color
  a !== "transparent";
}
function getTargetWaveColor(a) {
  const {
    borderTopColor: s,
    borderColor: c,
    backgroundColor: u
  } = getComputedStyle(a);
  return isValidWaveColor(s) ? s : isValidWaveColor(c) ? c : isValidWaveColor(u) ? u : null;
}
function validateNum(a) {
  return Number.isNaN(a) ? 0 : a;
}
const WaveEffect = (a) => {
  const {
    className: s,
    target: c,
    component: u,
    registerUnmount: d
  } = a, p = reactExports.useRef(null), v = reactExports.useRef(null);
  reactExports.useEffect(() => {
    v.current = d();
  }, []);
  const [A, x] = reactExports.useState(null), [g, b] = reactExports.useState([]), [y, f] = reactExports.useState(0), [m, C] = reactExports.useState(0), [w, S] = reactExports.useState(0), [$, T] = reactExports.useState(0), [I, _] = reactExports.useState(!1), E = {
    left: y,
    top: m,
    width: w,
    height: $,
    borderRadius: g.map((L) => `${L}px`).join(" ")
  };
  A && (E["--wave-color"] = A);
  function R() {
    const L = getComputedStyle(c);
    x(getTargetWaveColor(c));
    const B = L.position === "static", {
      borderLeftWidth: F,
      borderTopWidth: M
    } = L;
    f(B ? c.offsetLeft : validateNum(-parseFloat(F))), C(B ? c.offsetTop : validateNum(-parseFloat(M))), S(c.offsetWidth), T(c.offsetHeight);
    const {
      borderTopLeftRadius: W,
      borderTopRightRadius: j,
      borderBottomLeftRadius: G,
      borderBottomRightRadius: U
    } = L;
    b([W, j, U, G].map((k) => validateNum(parseFloat(k))));
  }
  if (reactExports.useEffect(() => {
    if (c) {
      const L = wrapperRaf(() => {
        R(), _(!0);
      });
      let B;
      return typeof ResizeObserver < "u" && (B = new ResizeObserver(R), B.observe(c)), () => {
        wrapperRaf.cancel(L), B?.disconnect();
      };
    }
  }, []), !I)
    return null;
  const O = (u === "Checkbox" || u === "Radio") && c?.classList.contains(TARGET_CLS);
  return /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (L, B) => {
      var F, M;
      if (B.deadline || B.propertyName === "opacity") {
        const W = (F = p.current) === null || F === void 0 ? void 0 : F.parentElement;
        (M = v.current) === null || M === void 0 || M.call(v).then(() => {
          W?.remove();
        });
      }
      return !1;
    }
  }, ({
    className: L
  }, B) => /* @__PURE__ */ reactExports.createElement("div", {
    ref: composeRef(p, B),
    className: classnames(s, L, {
      "wave-quick": O
    }),
    style: E
  }));
}, showWaveEffect = (a, s) => {
  var c;
  const {
    component: u
  } = s;
  if (u === "Checkbox" && !(!((c = a.querySelector("input")) === null || c === void 0) && c.checked))
    return;
  const d = document.createElement("div");
  d.style.position = "absolute", d.style.left = "0px", d.style.top = "0px", a?.insertBefore(d, a?.firstChild);
  const p = unstableSetRender();
  let v = null;
  function A() {
    return v;
  }
  v = p(/* @__PURE__ */ reactExports.createElement(WaveEffect, Object.assign({}, s, {
    target: a,
    registerUnmount: A
  })), d);
}, useWave = (a, s, c) => {
  const {
    wave: u
  } = reactExports.useContext(ConfigContext$1), [, d, p] = useToken$1(), v = useEvent((g) => {
    const b = a.current;
    if (u?.disabled || !b)
      return;
    const y = b.querySelector(`.${TARGET_CLS}`) || b, {
      showEffect: f
    } = u || {};
    (f || showWaveEffect)(y, {
      className: s,
      token: d,
      component: c,
      event: g,
      hashId: p
    });
  }), A = reactExports.useRef(null);
  return (g) => {
    wrapperRaf.cancel(A.current), A.current = wrapperRaf(() => {
      v(g);
    });
  };
}, Wave = (a) => {
  const {
    children: s,
    disabled: c,
    component: u
  } = a, {
    getPrefixCls: d
  } = reactExports.useContext(ConfigContext$1), p = reactExports.useRef(null), v = d("wave"), [, A] = useStyle$y(v), x = useWave(p, classnames(v, A), u);
  if (React.useEffect(() => {
    const b = p.current;
    if (!b || b.nodeType !== 1 || c)
      return;
    const y = (f) => {
      !isVisible(f.target) || // No need wave
      !b.getAttribute || b.getAttribute("disabled") || b.disabled || b.className.includes("disabled") || b.className.includes("-leave") || x(f);
    };
    return b.addEventListener("click", y, !0), () => {
      b.removeEventListener("click", y, !0);
    };
  }, [c]), !/* @__PURE__ */ React.isValidElement(s))
    return s ?? null;
  const g = supportRef(s) ? composeRef(getNodeRef(s), p) : p;
  return cloneElement(s, {
    ref: g
  });
}, useSize = (a) => {
  const s = React.useContext(SizeContext);
  return React.useMemo(() => a ? typeof a == "string" ? a ?? s : typeof a == "function" ? a(s) : s : s, [a, s]);
}, genSpaceCompactStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, genSpaceStyle = (a) => {
  const {
    componentCls: s,
    antCls: c
  } = a;
  return {
    [s]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${s}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${s}-item > ${c}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
}, genSpaceGapStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      "&-gap-row-small": {
        rowGap: a.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: a.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: a.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: a.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: a.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: a.spaceGapLargeSize
      }
    }
  };
}, useStyle$x = genStyleHooks("Space", (a) => {
  const s = merge(a, {
    spaceGapSmallSize: a.paddingXS,
    spaceGapMiddleSize: a.padding,
    spaceGapLargeSize: a.paddingLG
  });
  return [genSpaceStyle(s), genSpaceGapStyle(s), genSpaceCompactStyle(s)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var __rest$$ = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const SpaceCompactItemContext = /* @__PURE__ */ reactExports.createContext(null), useCompactItemContext = (a, s) => {
  const c = reactExports.useContext(SpaceCompactItemContext), u = reactExports.useMemo(() => {
    if (!c)
      return "";
    const {
      compactDirection: d,
      isFirstItem: p,
      isLastItem: v
    } = c, A = d === "vertical" ? "-vertical-" : "-";
    return classnames(`${a}-compact${A}item`, {
      [`${a}-compact${A}first-item`]: p,
      [`${a}-compact${A}last-item`]: v,
      [`${a}-compact${A}item-rtl`]: s === "rtl"
    });
  }, [a, s, c]);
  return {
    compactSize: c?.compactSize,
    compactDirection: c?.compactDirection,
    compactItemClassnames: u
  };
}, NoCompactStyle = (a) => {
  const {
    children: s
  } = a;
  return /* @__PURE__ */ reactExports.createElement(SpaceCompactItemContext.Provider, {
    value: null
  }, s);
}, CompactItem = (a) => {
  const {
    children: s
  } = a, c = __rest$$(a, ["children"]);
  return /* @__PURE__ */ reactExports.createElement(SpaceCompactItemContext.Provider, {
    value: reactExports.useMemo(() => c, [c])
  }, s);
}, Compact$1 = (a) => {
  const {
    getPrefixCls: s,
    direction: c
  } = reactExports.useContext(ConfigContext$1), {
    size: u,
    direction: d,
    block: p,
    prefixCls: v,
    className: A,
    rootClassName: x,
    children: g
  } = a, b = __rest$$(a, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), y = useSize((I) => u ?? I), f = s("space-compact", v), [m, C] = useStyle$x(f), w = classnames(f, C, {
    [`${f}-rtl`]: c === "rtl",
    [`${f}-block`]: p,
    [`${f}-vertical`]: d === "vertical"
  }, A, x), S = reactExports.useContext(SpaceCompactItemContext), $ = toArray$8(g), T = reactExports.useMemo(() => $.map((I, _) => {
    const E = I?.key || `${f}-item-${_}`;
    return /* @__PURE__ */ reactExports.createElement(CompactItem, {
      key: E,
      compactSize: y,
      compactDirection: d,
      isFirstItem: _ === 0 && (!S || S?.isFirstItem),
      isLastItem: _ === $.length - 1 && (!S || S?.isLastItem)
    }, I);
  }), [u, $, S]);
  return $.length === 0 ? null : m(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    className: w
  }, b), T));
};
var __rest$_ = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const GroupSizeContext = /* @__PURE__ */ reactExports.createContext(void 0), ButtonGroup = (a) => {
  const {
    getPrefixCls: s,
    direction: c
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: u,
    size: d,
    className: p
  } = a, v = __rest$_(a, ["prefixCls", "size", "className"]), A = s("btn-group", u), [, , x] = useToken$1(), g = reactExports.useMemo(() => {
    switch (d) {
      case "large":
        return "lg";
      case "small":
        return "sm";
      default:
        return "";
    }
  }, [d]), b = classnames(A, {
    [`${A}-${g}`]: g,
    [`${A}-rtl`]: c === "rtl"
  }, p, x);
  return /* @__PURE__ */ reactExports.createElement(GroupSizeContext.Provider, {
    value: d
  }, /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, v, {
    className: b
  })));
}, rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/, isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function convertLegacyProps(a) {
  return a === "danger" ? {
    danger: !0
  } : {
    type: a
  };
}
function isString$1(a) {
  return typeof a == "string";
}
function isUnBorderedButtonVariant(a) {
  return a === "text" || a === "link";
}
function splitCNCharsBySpace(a, s) {
  if (a == null)
    return;
  const c = s ? " " : "";
  return typeof a != "string" && typeof a != "number" && isString$1(a.type) && isTwoCNChar(a.props.children) ? cloneElement(a, {
    children: a.props.children.split("").join(c)
  }) : isString$1(a) ? isTwoCNChar(a) ? /* @__PURE__ */ React.createElement("span", null, a.split("").join(c)) : /* @__PURE__ */ React.createElement("span", null, a) : isFragment(a) ? /* @__PURE__ */ React.createElement("span", null, a) : a;
}
function spaceChildren(a, s) {
  let c = !1;
  const u = [];
  return React.Children.forEach(a, (d) => {
    const p = typeof d, v = p === "string" || p === "number";
    if (c && v) {
      const A = u.length - 1, x = u[A];
      u[A] = `${x}${d}`;
    } else
      u.push(d);
    c = v;
  }), React.Children.map(u, (d) => splitCNCharsBySpace(d, s));
}
["default", "primary", "danger"].concat(_toConsumableArray$e(PresetColors));
const IconWrapper = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    className: c,
    style: u,
    children: d,
    prefixCls: p
  } = a, v = classnames(`${p}-icon`, c);
  return /* @__PURE__ */ React.createElement("span", {
    ref: s,
    className: v,
    style: u
  }, d);
}), InnerLoadingIcon = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    className: u,
    style: d,
    iconClassName: p
  } = a, v = classnames(`${c}-loading-icon`, u);
  return /* @__PURE__ */ React.createElement(IconWrapper, {
    prefixCls: c,
    className: v,
    style: d,
    ref: s
  }, /* @__PURE__ */ React.createElement(RefIcon$F, {
    className: p
  }));
}), getCollapsedWidth = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), getRealWidth = (a) => ({
  width: a.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), DefaultLoadingIcon = (a) => {
  const {
    prefixCls: s,
    loading: c,
    existIcon: u,
    className: d,
    style: p,
    mount: v
  } = a, A = !!c;
  return u ? /* @__PURE__ */ React.createElement(InnerLoadingIcon, {
    prefixCls: s,
    className: d,
    style: p
  }) : /* @__PURE__ */ React.createElement(CSSMotion, {
    visible: A,
    // Used for minus flex gap style only
    motionName: `${s}-loading-icon-motion`,
    motionAppear: !v,
    motionEnter: !v,
    motionLeave: !v,
    removeOnLeave: !0,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, ({
    className: x,
    style: g
  }, b) => {
    const y = Object.assign(Object.assign({}, p), g);
    return /* @__PURE__ */ React.createElement(InnerLoadingIcon, {
      prefixCls: s,
      className: classnames(d, x),
      style: y,
      ref: b
    });
  });
}, genButtonBorderStyle = (a, s) => ({
  // Border
  [`> span, > ${a}`]: {
    "&:not(:last-child)": {
      [`&, & > ${a}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: s
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${a}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: s
        }
      }
    }
  }
}), genGroupStyle$1 = (a) => {
  const {
    componentCls: s,
    fontSize: c,
    lineWidth: u,
    groupBorderColor: d,
    colorErrorHover: p
  } = a;
  return {
    [`${s}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${s}`]: {
          "&:not(:last-child)": {
            [`&, & > ${s}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: a.calc(u).mul(-1).equal(),
            [`&, & > ${s}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [s]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${s}-icon-only`]: {
          fontSize: c
        }
      },
      // Border Color
      genButtonBorderStyle(`${s}-primary`, d),
      genButtonBorderStyle(`${s}-danger`, p)
    ]
  };
};
var _excluded$_ = ["b"], _excluded2$d = ["v"], getRoundNumber = function a(s) {
  return Math.round(Number(s || 0));
}, convertHsb2Hsv = function a(s) {
  if (s instanceof FastColor)
    return s;
  if (s && _typeof$h(s) === "object" && "h" in s && "b" in s) {
    var c = s, u = c.b, d = _objectWithoutProperties$2(c, _excluded$_);
    return _objectSpread2$1(_objectSpread2$1({}, d), {}, {
      v: u
    });
  }
  return typeof s == "string" && /hsb/.test(s) ? s.replace(/hsb/, "hsv") : s;
}, Color$2 = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c(u) {
    return _classCallCheck$1(this, c), s.call(this, convertHsb2Hsv(u));
  }
  return _createClass$1(c, [{
    key: "toHsbString",
    value: function() {
      var d = this.toHsb(), p = getRoundNumber(d.s * 100), v = getRoundNumber(d.b * 100), A = getRoundNumber(d.h), x = d.a, g = "hsb(".concat(A, ", ").concat(p, "%, ").concat(v, "%)"), b = "hsba(".concat(A, ", ").concat(p, "%, ").concat(v, "%, ").concat(x.toFixed(x === 0 ? 0 : 2), ")");
      return x === 1 ? g : b;
    }
  }, {
    key: "toHsb",
    value: function() {
      var d = this.toHsv(), p = d.v, v = _objectWithoutProperties$2(d, _excluded2$d);
      return _objectSpread2$1(_objectSpread2$1({}, v), {}, {
        b: p,
        a: this.a
      });
    }
  }]), c;
}(FastColor), generateColor = function a(s) {
  return s instanceof Color$2 ? s : new Color$2(s);
};
generateColor("#1677ff");
const toHexFormat = (a, s) => a?.replace(/[^\w/]/g, "").slice(0, s ? 8 : 6) || "", getHex = (a, s) => a ? toHexFormat(a, s) : "";
let AggregationColor = /* @__PURE__ */ function() {
  function a(s) {
    _classCallCheck$1(this, a);
    var c;
    if (this.cleared = !1, s instanceof a) {
      this.metaColor = s.metaColor.clone(), this.colors = (c = s.colors) === null || c === void 0 ? void 0 : c.map((d) => ({
        color: new a(d.color),
        percent: d.percent
      })), this.cleared = s.cleared;
      return;
    }
    const u = Array.isArray(s);
    u && s.length ? (this.colors = s.map(({
      color: d,
      percent: p
    }) => ({
      color: new a(d),
      percent: p
    })), this.metaColor = new Color$2(this.colors[0].color.metaColor)) : this.metaColor = new Color$2(u ? "" : s), (!s || u && !this.colors) && (this.metaColor = this.metaColor.setA(0), this.cleared = !0);
  }
  return _createClass$1(a, [{
    key: "toHsb",
    value: function() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function() {
      return getHex(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function() {
      const {
        colors: c
      } = this;
      return c ? `linear-gradient(90deg, ${c.map((d) => `${d.color.toRgbString()} ${d.percent}%`).join(", ")})` : this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function(c) {
      return !c || this.isGradient() !== c.isGradient() ? !1 : this.isGradient() ? this.colors.length === c.colors.length && this.colors.every((u, d) => {
        const p = c.colors[d];
        return u.percent === p.percent && u.color.equals(p.color);
      }) : this.toHexString() === c.toHexString();
    }
  }]);
}();
var RightOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" }, RightOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: RightOutlined$1
  }));
}, RefIcon$E = /* @__PURE__ */ reactExports.forwardRef(RightOutlined), PanelContent = /* @__PURE__ */ React.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.forceRender, d = a.className, p = a.style, v = a.children, A = a.isActive, x = a.role, g = a.classNames, b = a.styles, y = React.useState(A || u), f = _slicedToArray$e(y, 2), m = f[0], C = f[1];
  return React.useEffect(function() {
    (u || A) && C(!0);
  }, [u, A]), m ? /* @__PURE__ */ React.createElement("div", {
    ref: s,
    className: classnames("".concat(c, "-content"), _defineProperty$a(_defineProperty$a({}, "".concat(c, "-content-active"), A), "".concat(c, "-content-inactive"), !A), d),
    style: p,
    role: x
  }, /* @__PURE__ */ React.createElement("div", {
    className: classnames("".concat(c, "-content-box"), g?.body),
    style: b?.body
  }, v)) : null;
});
PanelContent.displayName = "PanelContent";
var _excluded$Z = ["showArrow", "headerClass", "isActive", "onItemClick", "forceRender", "className", "classNames", "styles", "prefixCls", "collapsible", "accordion", "panelKey", "extra", "header", "expandIcon", "openMotion", "destroyInactivePanel", "children"], CollapsePanel$1 = /* @__PURE__ */ React.forwardRef(function(a, s) {
  var c = a.showArrow, u = c === void 0 ? !0 : c, d = a.headerClass, p = a.isActive, v = a.onItemClick, A = a.forceRender, x = a.className, g = a.classNames, b = g === void 0 ? {} : g, y = a.styles, f = y === void 0 ? {} : y, m = a.prefixCls, C = a.collapsible, w = a.accordion, S = a.panelKey, $ = a.extra, T = a.header, I = a.expandIcon, _ = a.openMotion, E = a.destroyInactivePanel, R = a.children, O = _objectWithoutProperties$2(a, _excluded$Z), L = C === "disabled", B = $ != null && typeof $ != "boolean", F = _defineProperty$a(_defineProperty$a(_defineProperty$a({
    onClick: function() {
      v?.(S);
    },
    onKeyDown: function(N) {
      (N.key === "Enter" || N.keyCode === KeyCode.ENTER || N.which === KeyCode.ENTER) && v?.(S);
    },
    role: w ? "tab" : "button"
  }, "aria-expanded", p), "aria-disabled", L), "tabIndex", L ? -1 : 0), M = typeof I == "function" ? I(a) : /* @__PURE__ */ React.createElement("i", {
    className: "arrow"
  }), W = M && /* @__PURE__ */ React.createElement("div", _extends$3({
    className: "".concat(m, "-expand-icon")
  }, ["header", "icon"].includes(C) ? F : {}), M), j = classnames("".concat(m, "-item"), _defineProperty$a(_defineProperty$a({}, "".concat(m, "-item-active"), p), "".concat(m, "-item-disabled"), L), x), G = classnames(d, "".concat(m, "-header"), _defineProperty$a({}, "".concat(m, "-collapsible-").concat(C), !!C), b.header), U = _objectSpread2$1({
    className: G,
    style: f.header
  }, ["header", "icon"].includes(C) ? {} : F);
  return /* @__PURE__ */ React.createElement("div", _extends$3({}, O, {
    ref: s,
    className: j
  }), /* @__PURE__ */ React.createElement("div", U, u && W, /* @__PURE__ */ React.createElement("span", _extends$3({
    className: "".concat(m, "-header-text")
  }, C === "header" ? F : {}), T), B && /* @__PURE__ */ React.createElement("div", {
    className: "".concat(m, "-extra")
  }, $)), /* @__PURE__ */ React.createElement(CSSMotion, _extends$3({
    visible: p,
    leavedClassName: "".concat(m, "-content-hidden")
  }, _, {
    forceRender: A,
    removeOnLeave: E
  }), function(k, N) {
    var P = k.className, D = k.style;
    return /* @__PURE__ */ React.createElement(PanelContent, {
      ref: N,
      prefixCls: m,
      className: P,
      classNames: b,
      style: D,
      styles: f,
      isActive: p,
      forceRender: A,
      role: w ? "tabpanel" : void 0
    }, R);
  }));
}), _excluded$Y = ["children", "label", "key", "collapsible", "onItemClick", "destroyInactivePanel"], convertItemsToNodes$1 = function a(s, c) {
  var u = c.prefixCls, d = c.accordion, p = c.collapsible, v = c.destroyInactivePanel, A = c.onItemClick, x = c.activeKey, g = c.openMotion, b = c.expandIcon;
  return s.map(function(y, f) {
    var m = y.children, C = y.label, w = y.key, S = y.collapsible, $ = y.onItemClick, T = y.destroyInactivePanel, I = _objectWithoutProperties$2(y, _excluded$Y), _ = String(w ?? f), E = S ?? p, R = T ?? v, O = function(F) {
      E !== "disabled" && (A(F), $?.(F));
    }, L = !1;
    return d ? L = x[0] === _ : L = x.indexOf(_) > -1, /* @__PURE__ */ React.createElement(CollapsePanel$1, _extends$3({}, I, {
      prefixCls: u,
      key: _,
      panelKey: _,
      isActive: L,
      accordion: d,
      openMotion: g,
      expandIcon: b,
      header: C,
      collapsible: E,
      onItemClick: O,
      destroyInactivePanel: R
    }), m);
  });
}, getNewChild = function a(s, c, u) {
  if (!s) return null;
  var d = u.prefixCls, p = u.accordion, v = u.collapsible, A = u.destroyInactivePanel, x = u.onItemClick, g = u.activeKey, b = u.openMotion, y = u.expandIcon, f = s.key || String(c), m = s.props, C = m.header, w = m.headerClass, S = m.destroyInactivePanel, $ = m.collapsible, T = m.onItemClick, I = !1;
  p ? I = g[0] === f : I = g.indexOf(f) > -1;
  var _ = $ ?? v, E = function(L) {
    _ !== "disabled" && (x(L), T?.(L));
  }, R = {
    key: f,
    panelKey: f,
    header: C,
    headerClass: w,
    isActive: I,
    prefixCls: d,
    destroyInactivePanel: S ?? A,
    openMotion: b,
    accordion: p,
    children: s.props.children,
    onItemClick: E,
    expandIcon: y,
    collapsible: _
  };
  return typeof s.type == "string" ? s : (Object.keys(R).forEach(function(O) {
    typeof R[O] > "u" && delete R[O];
  }), /* @__PURE__ */ React.cloneElement(s, R));
};
function useItems(a, s, c) {
  return Array.isArray(a) ? convertItemsToNodes$1(a, c) : toArray$8(s).map(function(u, d) {
    return getNewChild(u, d, c);
  });
}
function getActiveKeysArray(a) {
  var s = a;
  if (!Array.isArray(s)) {
    var c = _typeof$h(s);
    s = c === "number" || c === "string" ? [s] : [];
  }
  return s.map(function(u) {
    return String(u);
  });
}
var Collapse$2 = /* @__PURE__ */ React.forwardRef(function(a, s) {
  var c = a.prefixCls, u = c === void 0 ? "rc-collapse" : c, d = a.destroyInactivePanel, p = d === void 0 ? !1 : d, v = a.style, A = a.accordion, x = a.className, g = a.children, b = a.collapsible, y = a.openMotion, f = a.expandIcon, m = a.activeKey, C = a.defaultActiveKey, w = a.onChange, S = a.items, $ = classnames(u, x), T = useMergedState([], {
    value: m,
    onChange: function(B) {
      return w?.(B);
    },
    defaultValue: C,
    postState: getActiveKeysArray
  }), I = _slicedToArray$e(T, 2), _ = I[0], E = I[1], R = function(B) {
    return E(function() {
      if (A)
        return _[0] === B ? [] : [B];
      var F = _.indexOf(B), M = F > -1;
      return M ? _.filter(function(W) {
        return W !== B;
      }) : [].concat(_toConsumableArray$e(_), [B]);
    });
  };
  warningOnce(!g, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
  var O = useItems(S, g, {
    prefixCls: u,
    accordion: A,
    openMotion: y,
    expandIcon: f,
    collapsible: b,
    destroyInactivePanel: p,
    onItemClick: R,
    activeKey: _
  });
  return /* @__PURE__ */ React.createElement("div", _extends$3({
    ref: s,
    className: $,
    style: v,
    role: A ? "tablist" : void 0
  }, pickAttrs(a, {
    aria: !0,
    data: !0
  })), O);
});
const Collapse$3 = Object.assign(Collapse$2, {
  /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */
  Panel: CollapsePanel$1
});
Collapse$3.Panel;
const CollapsePanel = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: c
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: u,
    className: d,
    showArrow: p = !0
  } = a, v = c("collapse", u), A = classnames({
    [`${v}-no-arrow`]: !p
  }, d);
  return /* @__PURE__ */ reactExports.createElement(Collapse$3.Panel, Object.assign({
    ref: s
  }, a, {
    prefixCls: v,
    className: A
  }));
}), genCollapseMotion = (a) => ({
  [a.componentCls]: {
    // For common/openAnimation
    [`${a.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${a.motionDurationMid} ${a.motionEaseInOut},
        opacity ${a.motionDurationMid} ${a.motionEaseInOut} !important`
      }
    },
    [`${a.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${a.motionDurationMid} ${a.motionEaseInOut},
        opacity ${a.motionDurationMid} ${a.motionEaseInOut} !important`
    }
  }
}), initMotionCommon = (a) => ({
  animationDuration: a,
  animationFillMode: "both"
}), initMotionCommonLeave = (a) => ({
  animationDuration: a,
  animationFillMode: "both"
}), initMotion = (a, s, c, u, d = !1) => {
  const p = d ? "&" : "";
  return {
    [`
      ${p}${a}-enter,
      ${p}${a}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(u)), {
      animationPlayState: "paused"
    }),
    [`${p}${a}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(u)), {
      animationPlayState: "paused"
    }),
    [`
      ${p}${a}-enter${a}-enter-active,
      ${p}${a}-appear${a}-appear-active
    `]: {
      animationName: s,
      animationPlayState: "running"
    },
    [`${p}${a}-leave${a}-leave-active`]: {
      animationName: c,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, fadeIn = new Keyframe("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), fadeOut = new Keyframe("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), initFadeMotion = (a, s = !1) => {
  const {
    antCls: c
  } = a, u = `${c}-fade`, d = s ? "&" : "";
  return [initMotion(u, fadeIn, fadeOut, a.motionDurationMid, s), {
    [`
        ${d}${u}-enter,
        ${d}${u}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${d}${u}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, moveDownIn = new Keyframe("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), moveDownOut = new Keyframe("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), moveLeftIn = new Keyframe("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), moveLeftOut = new Keyframe("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), moveRightIn = new Keyframe("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), moveRightOut = new Keyframe("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), moveUpIn = new Keyframe("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), moveUpOut = new Keyframe("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), moveMotion = {
  "move-up": {
    inKeyframes: moveUpIn,
    outKeyframes: moveUpOut
  },
  "move-down": {
    inKeyframes: moveDownIn,
    outKeyframes: moveDownOut
  },
  "move-left": {
    inKeyframes: moveLeftIn,
    outKeyframes: moveLeftOut
  },
  "move-right": {
    inKeyframes: moveRightIn,
    outKeyframes: moveRightOut
  }
}, initMoveMotion = (a, s) => {
  const {
    antCls: c
  } = a, u = `${c}-${s}`, {
    inKeyframes: d,
    outKeyframes: p
  } = moveMotion[s];
  return [initMotion(u, d, p, a.motionDurationMid), {
    [`
        ${u}-enter,
        ${u}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: a.motionEaseOutCirc
    },
    [`${u}-leave`]: {
      animationTimingFunction: a.motionEaseInOutCirc
    }
  }];
}, slideUpIn = new Keyframe("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), slideUpOut = new Keyframe("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), slideDownIn = new Keyframe("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), slideDownOut = new Keyframe("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), slideLeftIn = new Keyframe("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), slideLeftOut = new Keyframe("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), slideRightIn = new Keyframe("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), slideRightOut = new Keyframe("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), slideMotion = {
  "slide-up": {
    inKeyframes: slideUpIn,
    outKeyframes: slideUpOut
  },
  "slide-down": {
    inKeyframes: slideDownIn,
    outKeyframes: slideDownOut
  },
  "slide-left": {
    inKeyframes: slideLeftIn,
    outKeyframes: slideLeftOut
  },
  "slide-right": {
    inKeyframes: slideRightIn,
    outKeyframes: slideRightOut
  }
}, initSlideMotion = (a, s) => {
  const {
    antCls: c
  } = a, u = `${c}-${s}`, {
    inKeyframes: d,
    outKeyframes: p
  } = slideMotion[s];
  return [initMotion(u, d, p, a.motionDurationMid), {
    [`
      ${u}-enter,
      ${u}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: a.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${u}-leave`]: {
      animationTimingFunction: a.motionEaseInQuint
    }
  }];
}, zoomIn = new Keyframe("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zoomOut = new Keyframe("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), zoomBigIn = new Keyframe("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zoomBigOut = new Keyframe("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), zoomUpIn = new Keyframe("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), zoomUpOut = new Keyframe("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), zoomLeftIn = new Keyframe("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), zoomLeftOut = new Keyframe("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), zoomRightIn = new Keyframe("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), zoomRightOut = new Keyframe("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), zoomDownIn = new Keyframe("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), zoomDownOut = new Keyframe("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), zoomMotion = {
  zoom: {
    inKeyframes: zoomIn,
    outKeyframes: zoomOut
  },
  "zoom-big": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-big-fast": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-left": {
    inKeyframes: zoomLeftIn,
    outKeyframes: zoomLeftOut
  },
  "zoom-right": {
    inKeyframes: zoomRightIn,
    outKeyframes: zoomRightOut
  },
  "zoom-up": {
    inKeyframes: zoomUpIn,
    outKeyframes: zoomUpOut
  },
  "zoom-down": {
    inKeyframes: zoomDownIn,
    outKeyframes: zoomDownOut
  }
}, initZoomMotion = (a, s) => {
  const {
    antCls: c
  } = a, u = `${c}-${s}`, {
    inKeyframes: d,
    outKeyframes: p
  } = zoomMotion[s];
  return [initMotion(u, d, p, s === "zoom-big-fast" ? a.motionDurationFast : a.motionDurationMid), {
    [`
        ${u}-enter,
        ${u}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: a.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${u}-leave`]: {
      animationTimingFunction: a.motionEaseInOutCirc
    }
  }];
}, genBaseStyle$b = (a) => {
  const {
    componentCls: s,
    contentBg: c,
    padding: u,
    headerBg: d,
    headerPadding: p,
    collapseHeaderPaddingSM: v,
    collapseHeaderPaddingLG: A,
    collapsePanelBorderRadius: x,
    lineWidth: g,
    lineType: b,
    colorBorder: y,
    colorText: f,
    colorTextHeading: m,
    colorTextDisabled: C,
    fontSizeLG: w,
    lineHeight: S,
    lineHeightLG: $,
    marginSM: T,
    paddingSM: I,
    paddingLG: _,
    paddingXS: E,
    motionDurationSlow: R,
    fontSizeIcon: O,
    contentPadding: L,
    fontHeight: B,
    fontHeightLG: F
  } = a, M = `${unit$1(g)} ${b} ${y}`;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      backgroundColor: d,
      border: M,
      borderRadius: x,
      "&-rtl": {
        direction: "rtl"
      },
      [`& > ${s}-item`]: {
        borderBottom: M,
        "&:first-child": {
          [`
            &,
            & > ${s}-header`]: {
            borderRadius: `${unit$1(x)} ${unit$1(x)} 0 0`
          }
        },
        "&:last-child": {
          [`
            &,
            & > ${s}-header`]: {
            borderRadius: `0 0 ${unit$1(x)} ${unit$1(x)}`
          }
        },
        [`> ${s}-header`]: Object.assign(Object.assign({
          position: "relative",
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "flex-start",
          padding: p,
          color: m,
          lineHeight: S,
          cursor: "pointer",
          transition: `all ${R}, visibility 0s`
        }, genFocusStyle(a)), {
          [`> ${s}-header-text`]: {
            flex: "auto"
          },
          // >>>>> Arrow
          [`${s}-expand-icon`]: {
            height: B,
            display: "flex",
            alignItems: "center",
            paddingInlineEnd: T
          },
          [`${s}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
            fontSize: O,
            // when `transform: rotate()` is applied to icon's root element
            transition: `transform ${R}`,
            // when `transform: rotate()` is applied to icon's child element
            svg: {
              transition: `transform ${R}`
            }
          }),
          // >>>>> Text
          [`${s}-header-text`]: {
            marginInlineEnd: "auto"
          }
        }),
        [`${s}-collapsible-header`]: {
          cursor: "default",
          [`${s}-header-text`]: {
            flex: "none",
            cursor: "pointer"
          }
        },
        [`${s}-collapsible-icon`]: {
          cursor: "unset",
          [`${s}-expand-icon`]: {
            cursor: "pointer"
          }
        }
      },
      [`${s}-content`]: {
        color: f,
        backgroundColor: c,
        borderTop: M,
        [`& > ${s}-content-box`]: {
          padding: L
        },
        "&-hidden": {
          display: "none"
        }
      },
      "&-small": {
        [`> ${s}-item`]: {
          [`> ${s}-header`]: {
            padding: v,
            paddingInlineStart: E,
            [`> ${s}-expand-icon`]: {
              // Arrow offset
              marginInlineStart: a.calc(I).sub(E).equal()
            }
          },
          [`> ${s}-content > ${s}-content-box`]: {
            padding: I
          }
        }
      },
      "&-large": {
        [`> ${s}-item`]: {
          fontSize: w,
          lineHeight: $,
          [`> ${s}-header`]: {
            padding: A,
            paddingInlineStart: u,
            [`> ${s}-expand-icon`]: {
              height: F,
              // Arrow offset
              marginInlineStart: a.calc(_).sub(u).equal()
            }
          },
          [`> ${s}-content > ${s}-content-box`]: {
            padding: _
          }
        }
      },
      [`${s}-item:last-child`]: {
        borderBottom: 0,
        [`> ${s}-content`]: {
          borderRadius: `0 0 ${unit$1(x)} ${unit$1(x)}`
        }
      },
      [`& ${s}-item-disabled > ${s}-header`]: {
        "\n          &,\n          & > .arrow\n        ": {
          color: C,
          cursor: "not-allowed"
        }
      },
      // ========================== Icon Position ==========================
      [`&${s}-icon-position-end`]: {
        [`& > ${s}-item`]: {
          [`> ${s}-header`]: {
            [`${s}-expand-icon`]: {
              order: 1,
              paddingInlineEnd: 0,
              paddingInlineStart: T
            }
          }
        }
      }
    })
  };
}, genArrowStyle = (a) => {
  const {
    componentCls: s
  } = a, c = `> ${s}-item > ${s}-header ${s}-arrow`;
  return {
    [`${s}-rtl`]: {
      [c]: {
        transform: "rotate(180deg)"
      }
    }
  };
}, genBorderlessStyle$2 = (a) => {
  const {
    componentCls: s,
    headerBg: c,
    borderlessContentPadding: u,
    borderlessContentBg: d,
    colorBorder: p
  } = a;
  return {
    [`${s}-borderless`]: {
      backgroundColor: c,
      border: 0,
      [`> ${s}-item`]: {
        borderBottom: `1px solid ${p}`
      },
      [`
        > ${s}-item:last-child,
        > ${s}-item:last-child ${s}-header
      `]: {
        borderRadius: 0
      },
      [`> ${s}-item:last-child`]: {
        borderBottom: 0
      },
      [`> ${s}-item > ${s}-content`]: {
        backgroundColor: d,
        borderTop: 0
      },
      [`> ${s}-item > ${s}-content > ${s}-content-box`]: {
        padding: u
      }
    }
  };
}, genGhostStyle = (a) => {
  const {
    componentCls: s,
    paddingSM: c
  } = a;
  return {
    [`${s}-ghost`]: {
      backgroundColor: "transparent",
      border: 0,
      [`> ${s}-item`]: {
        borderBottom: 0,
        [`> ${s}-content`]: {
          backgroundColor: "transparent",
          border: 0,
          [`> ${s}-content-box`]: {
            paddingBlock: c
          }
        }
      }
    }
  };
}, prepareComponentToken$t = (a) => ({
  headerPadding: `${a.paddingSM}px ${a.padding}px`,
  headerBg: a.colorFillAlter,
  contentPadding: `${a.padding}px 16px`,
  // Fixed Value
  contentBg: a.colorBgContainer,
  borderlessContentPadding: `${a.paddingXXS}px 16px ${a.padding}px`,
  borderlessContentBg: "transparent"
}), useStyle$w = genStyleHooks("Collapse", (a) => {
  const s = merge(a, {
    collapseHeaderPaddingSM: `${unit$1(a.paddingXS)} ${unit$1(a.paddingSM)}`,
    collapseHeaderPaddingLG: `${unit$1(a.padding)} ${unit$1(a.paddingLG)}`,
    collapsePanelBorderRadius: a.borderRadiusLG
  });
  return [genBaseStyle$b(s), genBorderlessStyle$2(s), genGhostStyle(s), genArrowStyle(s), genCollapseMotion(s)];
}, prepareComponentToken$t), Collapse = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: c,
    direction: u,
    expandIcon: d,
    className: p,
    style: v
  } = useComponentConfig("collapse"), {
    prefixCls: A,
    className: x,
    rootClassName: g,
    style: b,
    bordered: y = !0,
    ghost: f,
    size: m,
    expandIconPosition: C = "start",
    children: w,
    destroyInactivePanel: S,
    destroyOnHidden: $,
    expandIcon: T
  } = a, I = useSize((U) => {
    var k;
    return (k = m ?? U) !== null && k !== void 0 ? k : "middle";
  }), _ = c("collapse", A), E = c(), [R, O, L] = useStyle$w(_), B = reactExports.useMemo(() => C === "left" ? "start" : C === "right" ? "end" : C, [C]), F = T ?? d, M = reactExports.useCallback((U = {}) => {
    const k = typeof F == "function" ? F(U) : /* @__PURE__ */ reactExports.createElement(RefIcon$E, {
      rotate: U.isActive ? u === "rtl" ? -90 : 90 : void 0,
      "aria-label": U.isActive ? "expanded" : "collapsed"
    });
    return cloneElement(k, () => {
      var N;
      return {
        className: classnames((N = k?.props) === null || N === void 0 ? void 0 : N.className, `${_}-arrow`)
      };
    });
  }, [F, _]), W = classnames(`${_}-icon-position-${B}`, {
    [`${_}-borderless`]: !y,
    [`${_}-rtl`]: u === "rtl",
    [`${_}-ghost`]: !!f,
    [`${_}-${I}`]: I !== "middle"
  }, p, x, g, O, L), j = Object.assign(Object.assign({}, initCollapseMotion(E)), {
    motionAppear: !1,
    leavedClassName: `${_}-content-hidden`
  }), G = reactExports.useMemo(() => w ? toArray$8(w).map((U, k) => {
    var N, P;
    const D = U.props;
    if (D?.disabled) {
      const H = (N = U.key) !== null && N !== void 0 ? N : String(k), V = Object.assign(Object.assign({}, omit(U.props, ["disabled"])), {
        key: H,
        collapsible: (P = D.collapsible) !== null && P !== void 0 ? P : "disabled"
      });
      return cloneElement(U, V);
    }
    return U;
  }) : null, [w]);
  return R(
    // @ts-ignore
    /* @__PURE__ */ reactExports.createElement(Collapse$3, Object.assign({
      ref: s,
      openMotion: j
    }, omit(a, ["rootClassName"]), {
      expandIcon: M,
      prefixCls: _,
      className: W,
      style: Object.assign(Object.assign({}, v), b),
      // TODO: In the future, destroyInactivePanel in rc-collapse needs to be upgrade to destroyOnHidden
      destroyInactivePanel: $ ?? S
    }), G)
  );
}), Collapse$1 = Object.assign(Collapse, {
  Panel: CollapsePanel
}), isBright = (a, s) => {
  const {
    r: c,
    g: u,
    b: d,
    a: p
  } = a.toRgb(), v = new Color$2(a.toRgbString()).onBackground(s).toHsv();
  return p <= 0.5 ? v.v > 0.5 : c * 0.299 + u * 0.587 + d * 0.114 > 192;
}, prepareToken$3 = (a) => {
  const {
    paddingInline: s,
    onlyIconSize: c
  } = a;
  return merge(a, {
    buttonPaddingHorizontal: s,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: c
  });
}, prepareComponentToken$s = (a) => {
  var s, c, u, d, p, v;
  const A = (s = a.contentFontSize) !== null && s !== void 0 ? s : a.fontSize, x = (c = a.contentFontSizeSM) !== null && c !== void 0 ? c : a.fontSize, g = (u = a.contentFontSizeLG) !== null && u !== void 0 ? u : a.fontSizeLG, b = (d = a.contentLineHeight) !== null && d !== void 0 ? d : getLineHeight(A), y = (p = a.contentLineHeightSM) !== null && p !== void 0 ? p : getLineHeight(x), f = (v = a.contentLineHeightLG) !== null && v !== void 0 ? v : getLineHeight(g), m = isBright(new AggregationColor(a.colorBgSolid), "#fff") ? "#000" : "#fff", C = PresetColors.reduce((w, S) => Object.assign(Object.assign({}, w), {
    [`${S}ShadowColor`]: `0 ${unit$1(a.controlOutlineWidth)} 0 ${getAlphaColor$1(a[`${S}1`], a.colorBgContainer)}`
  }), {});
  return Object.assign(Object.assign({}, C), {
    fontWeight: 400,
    defaultShadow: `0 ${a.controlOutlineWidth}px 0 ${a.controlTmpOutline}`,
    primaryShadow: `0 ${a.controlOutlineWidth}px 0 ${a.controlOutline}`,
    dangerShadow: `0 ${a.controlOutlineWidth}px 0 ${a.colorErrorOutline}`,
    primaryColor: a.colorTextLightSolid,
    dangerColor: a.colorTextLightSolid,
    borderColorDisabled: a.colorBorder,
    defaultGhostColor: a.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: a.colorBgContainer,
    paddingInline: a.paddingContentHorizontal - a.lineWidth,
    paddingInlineLG: a.paddingContentHorizontal - a.lineWidth,
    paddingInlineSM: 8 - a.lineWidth,
    onlyIconSize: "inherit",
    onlyIconSizeSM: "inherit",
    onlyIconSizeLG: "inherit",
    groupBorderColor: a.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: a.colorText,
    textTextHoverColor: a.colorText,
    textTextActiveColor: a.colorText,
    textHoverBg: a.colorFillTertiary,
    defaultColor: a.colorText,
    defaultBg: a.colorBgContainer,
    defaultBorderColor: a.colorBorder,
    defaultBorderColorDisabled: a.colorBorder,
    defaultHoverBg: a.colorBgContainer,
    defaultHoverColor: a.colorPrimaryHover,
    defaultHoverBorderColor: a.colorPrimaryHover,
    defaultActiveBg: a.colorBgContainer,
    defaultActiveColor: a.colorPrimaryActive,
    defaultActiveBorderColor: a.colorPrimaryActive,
    solidTextColor: m,
    contentFontSize: A,
    contentFontSizeSM: x,
    contentFontSizeLG: g,
    contentLineHeight: b,
    contentLineHeightSM: y,
    contentLineHeightLG: f,
    paddingBlock: Math.max((a.controlHeight - A * b) / 2 - a.lineWidth, 0),
    paddingBlockSM: Math.max((a.controlHeightSM - x * y) / 2 - a.lineWidth, 0),
    paddingBlockLG: Math.max((a.controlHeightLG - g * f) / 2 - a.lineWidth, 0)
  });
}, genSharedButtonStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    fontWeight: u,
    opacityLoading: d,
    motionDurationSlow: p,
    motionEaseInOut: v,
    marginXS: A,
    calc: x
  } = a;
  return {
    [s]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: a.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: u,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${a.motionDurationMid} ${a.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: a.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${s}-icon > svg`]: resetIcon(),
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": genFocusStyle(a),
      [`&${s}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${s}-two-chinese-chars > *:not(${c})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      [`&${s}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${s}-compact-item`]: {
          flex: "none"
        },
        [`&${s}-round`]: {
          width: "auto"
        }
      },
      // Loading
      [`&${s}-loading`]: {
        opacity: d,
        cursor: "default"
      },
      [`${s}-loading-icon`]: {
        transition: ["width", "opacity", "margin"].map((g) => `${g} ${p} ${v}`).join(",")
      },
      // iconPosition
      [`&:not(${s}-icon-end)`]: {
        [`${s}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineEnd: x(A).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineEnd: 0
          },
          "&-leave-start": {
            marginInlineEnd: 0
          },
          "&-leave-active": {
            marginInlineEnd: x(A).mul(-1).equal()
          }
        }
      },
      "&-icon-end": {
        flexDirection: "row-reverse",
        [`${s}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineStart: x(A).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineStart: 0
          },
          "&-leave-start": {
            marginInlineStart: 0
          },
          "&-leave-active": {
            marginInlineStart: x(A).mul(-1).equal()
          }
        }
      }
    }
  };
}, genHoverActiveButtonStyle = (a, s, c) => ({
  [`&:not(:disabled):not(${a}-disabled)`]: {
    "&:hover": s,
    "&:active": c
  }
}), genCircleButtonStyle = (a) => ({
  minWidth: a.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), genRoundButtonStyle = (a) => ({
  borderRadius: a.controlHeight,
  paddingInlineStart: a.calc(a.controlHeight).div(2).equal(),
  paddingInlineEnd: a.calc(a.controlHeight).div(2).equal()
}), genDisabledStyle$1 = (a) => ({
  cursor: "not-allowed",
  borderColor: a.borderColorDisabled,
  color: a.colorTextDisabled,
  background: a.colorBgContainerDisabled,
  boxShadow: "none"
}), genGhostButtonStyle = (a, s, c, u, d, p, v, A) => ({
  [`&${a}-background-ghost`]: Object.assign(Object.assign({
    color: c || void 0,
    background: s,
    borderColor: u || void 0,
    boxShadow: "none"
  }, genHoverActiveButtonStyle(a, Object.assign({
    background: s
  }, v), Object.assign({
    background: s
  }, A))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: d || void 0,
      borderColor: p || void 0
    }
  })
}), genSolidDisabledButtonStyle = (a) => ({
  [`&:disabled, &${a.componentCls}-disabled`]: Object.assign({}, genDisabledStyle$1(a))
}), genPureDisabledButtonStyle = (a) => ({
  [`&:disabled, &${a.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: a.colorTextDisabled
  }
}), genVariantButtonStyle = (a, s, c, u) => {
  const p = u && ["link", "text"].includes(u) ? genPureDisabledButtonStyle : genSolidDisabledButtonStyle;
  return Object.assign(Object.assign({}, p(a)), genHoverActiveButtonStyle(a.componentCls, s, c));
}, genSolidButtonStyle = (a, s, c, u, d) => ({
  [`&${a.componentCls}-variant-solid`]: Object.assign({
    color: s,
    background: c
  }, genVariantButtonStyle(a, u, d))
}), genOutlinedDashedButtonStyle = (a, s, c, u, d) => ({
  [`&${a.componentCls}-variant-outlined, &${a.componentCls}-variant-dashed`]: Object.assign({
    borderColor: s,
    background: c
  }, genVariantButtonStyle(a, u, d))
}), genDashedButtonStyle = (a) => ({
  [`&${a.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
}), genFilledButtonStyle = (a, s, c, u) => ({
  [`&${a.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background: s
  }, genVariantButtonStyle(a, c, u))
}), genTextLinkButtonStyle = (a, s, c, u, d) => ({
  [`&${a.componentCls}-variant-${c}`]: Object.assign({
    color: s,
    boxShadow: "none"
  }, genVariantButtonStyle(a, u, d, c))
}), genPresetColorStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return PresetColors.reduce((c, u) => {
    const d = a[`${u}6`], p = a[`${u}1`], v = a[`${u}5`], A = a[`${u}2`], x = a[`${u}3`], g = a[`${u}7`];
    return Object.assign(Object.assign({}, c), {
      [`&${s}-color-${u}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: d,
        boxShadow: a[`${u}ShadowColor`]
      }, genSolidButtonStyle(a, a.colorTextLightSolid, d, {
        background: v
      }, {
        background: g
      })), genOutlinedDashedButtonStyle(a, d, a.colorBgContainer, {
        color: v,
        borderColor: v,
        background: a.colorBgContainer
      }, {
        color: g,
        borderColor: g,
        background: a.colorBgContainer
      })), genDashedButtonStyle(a)), genFilledButtonStyle(a, p, {
        background: A
      }, {
        background: x
      })), genTextLinkButtonStyle(a, d, "link", {
        color: v
      }, {
        color: g
      })), genTextLinkButtonStyle(a, d, "text", {
        color: v,
        background: p
      }, {
        color: g,
        background: x
      }))
    });
  }, {});
}, genDefaultButtonStyle = (a) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: a.defaultColor,
  boxShadow: a.defaultShadow
}, genSolidButtonStyle(a, a.solidTextColor, a.colorBgSolid, {
  color: a.solidTextColor,
  background: a.colorBgSolidHover
}, {
  color: a.solidTextColor,
  background: a.colorBgSolidActive
})), genDashedButtonStyle(a)), genFilledButtonStyle(a, a.colorFillTertiary, {
  background: a.colorFillSecondary
}, {
  background: a.colorFill
})), genGhostButtonStyle(a.componentCls, a.ghostBg, a.defaultGhostColor, a.defaultGhostBorderColor, a.colorTextDisabled, a.colorBorder)), genTextLinkButtonStyle(a, a.textTextColor, "link", {
  color: a.colorLinkHover,
  background: a.linkHoverBg
}, {
  color: a.colorLinkActive
})), genPrimaryButtonStyle = (a) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: a.colorPrimary,
  boxShadow: a.primaryShadow
}, genOutlinedDashedButtonStyle(a, a.colorPrimary, a.colorBgContainer, {
  color: a.colorPrimaryTextHover,
  borderColor: a.colorPrimaryHover,
  background: a.colorBgContainer
}, {
  color: a.colorPrimaryTextActive,
  borderColor: a.colorPrimaryActive,
  background: a.colorBgContainer
})), genDashedButtonStyle(a)), genFilledButtonStyle(a, a.colorPrimaryBg, {
  background: a.colorPrimaryBgHover
}, {
  background: a.colorPrimaryBorder
})), genTextLinkButtonStyle(a, a.colorPrimaryText, "text", {
  color: a.colorPrimaryTextHover,
  background: a.colorPrimaryBg
}, {
  color: a.colorPrimaryTextActive,
  background: a.colorPrimaryBorder
})), genTextLinkButtonStyle(a, a.colorPrimaryText, "link", {
  color: a.colorPrimaryTextHover,
  background: a.linkHoverBg
}, {
  color: a.colorPrimaryTextActive
})), genGhostButtonStyle(a.componentCls, a.ghostBg, a.colorPrimary, a.colorPrimary, a.colorTextDisabled, a.colorBorder, {
  color: a.colorPrimaryHover,
  borderColor: a.colorPrimaryHover
}, {
  color: a.colorPrimaryActive,
  borderColor: a.colorPrimaryActive
})), genDangerousStyle = (a) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: a.colorError,
  boxShadow: a.dangerShadow
}, genSolidButtonStyle(a, a.dangerColor, a.colorError, {
  background: a.colorErrorHover
}, {
  background: a.colorErrorActive
})), genOutlinedDashedButtonStyle(a, a.colorError, a.colorBgContainer, {
  color: a.colorErrorHover,
  borderColor: a.colorErrorBorderHover
}, {
  color: a.colorErrorActive,
  borderColor: a.colorErrorActive
})), genDashedButtonStyle(a)), genFilledButtonStyle(a, a.colorErrorBg, {
  background: a.colorErrorBgFilledHover
}, {
  background: a.colorErrorBgActive
})), genTextLinkButtonStyle(a, a.colorError, "text", {
  color: a.colorErrorHover,
  background: a.colorErrorBg
}, {
  color: a.colorErrorHover,
  background: a.colorErrorBgActive
})), genTextLinkButtonStyle(a, a.colorError, "link", {
  color: a.colorErrorHover
}, {
  color: a.colorErrorActive
})), genGhostButtonStyle(a.componentCls, a.ghostBg, a.colorError, a.colorError, a.colorTextDisabled, a.colorBorder, {
  color: a.colorErrorHover,
  borderColor: a.colorErrorHover
}, {
  color: a.colorErrorActive,
  borderColor: a.colorErrorActive
})), genLinkStyle = (a) => Object.assign(Object.assign({}, genTextLinkButtonStyle(a, a.colorLink, "link", {
  color: a.colorLinkHover
}, {
  color: a.colorLinkActive
})), genGhostButtonStyle(a.componentCls, a.ghostBg, a.colorInfo, a.colorInfo, a.colorTextDisabled, a.colorBorder, {
  color: a.colorInfoHover,
  borderColor: a.colorInfoHover
}, {
  color: a.colorInfoActive,
  borderColor: a.colorInfoActive
})), genColorButtonStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return Object.assign({
    [`${s}-color-default`]: genDefaultButtonStyle(a),
    [`${s}-color-primary`]: genPrimaryButtonStyle(a),
    [`${s}-color-dangerous`]: genDangerousStyle(a),
    [`${s}-color-link`]: genLinkStyle(a)
  }, genPresetColorStyle(a));
}, genCompatibleButtonStyle = (a) => Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedDashedButtonStyle(a, a.defaultBorderColor, a.defaultBg, {
  color: a.defaultHoverColor,
  borderColor: a.defaultHoverBorderColor,
  background: a.defaultHoverBg
}, {
  color: a.defaultActiveColor,
  borderColor: a.defaultActiveBorderColor,
  background: a.defaultActiveBg
})), genTextLinkButtonStyle(a, a.textTextColor, "text", {
  color: a.textTextHoverColor,
  background: a.textHoverBg
}, {
  color: a.textTextActiveColor,
  background: a.colorBgTextActive
})), genSolidButtonStyle(a, a.primaryColor, a.colorPrimary, {
  background: a.colorPrimaryHover,
  color: a.primaryColor
}, {
  background: a.colorPrimaryActive,
  color: a.primaryColor
})), genTextLinkButtonStyle(a, a.colorLink, "link", {
  color: a.colorLinkHover,
  background: a.linkHoverBg
}, {
  color: a.colorLinkActive
})), genButtonStyle = (a, s = "") => {
  const {
    componentCls: c,
    controlHeight: u,
    fontSize: d,
    borderRadius: p,
    buttonPaddingHorizontal: v,
    iconCls: A,
    buttonPaddingVertical: x,
    buttonIconOnlyFontSize: g
  } = a;
  return [
    {
      [s]: {
        fontSize: d,
        height: u,
        padding: `${unit$1(x)} ${unit$1(v)}`,
        borderRadius: p,
        [`&${c}-icon-only`]: {
          width: u,
          [A]: {
            fontSize: g
          }
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${c}${c}-circle${s}`]: genCircleButtonStyle(a)
    },
    {
      [`${c}${c}-round${s}`]: genRoundButtonStyle(a)
    }
  ];
}, genSizeBaseButtonStyle = (a) => {
  const s = merge(a, {
    fontSize: a.contentFontSize
  });
  return genButtonStyle(s, a.componentCls);
}, genSizeSmallButtonStyle = (a) => {
  const s = merge(a, {
    controlHeight: a.controlHeightSM,
    fontSize: a.contentFontSizeSM,
    padding: a.paddingXS,
    buttonPaddingHorizontal: a.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: a.borderRadiusSM,
    buttonIconOnlyFontSize: a.onlyIconSizeSM
  });
  return genButtonStyle(s, `${a.componentCls}-sm`);
}, genSizeLargeButtonStyle = (a) => {
  const s = merge(a, {
    controlHeight: a.controlHeightLG,
    fontSize: a.contentFontSizeLG,
    buttonPaddingHorizontal: a.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: a.borderRadiusLG,
    buttonIconOnlyFontSize: a.onlyIconSizeLG
  });
  return genButtonStyle(s, `${a.componentCls}-lg`);
}, genBlockButtonStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      [`&${s}-block`]: {
        width: "100%"
      }
    }
  };
}, useStyle$v = genStyleHooks("Button", (a) => {
  const s = prepareToken$3(a);
  return [
    // Shared
    genSharedButtonStyle(s),
    // Size
    genSizeBaseButtonStyle(s),
    genSizeSmallButtonStyle(s),
    genSizeLargeButtonStyle(s),
    // Block
    genBlockButtonStyle(s),
    // Color
    genColorButtonStyle(s),
    // https://github.com/ant-design/ant-design/issues/50969
    genCompatibleButtonStyle(s),
    // Button Group
    genGroupStyle$1(s)
  ];
}, prepareComponentToken$s, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function compactItemBorder(a, s, c) {
  const {
    focusElCls: u,
    focus: d,
    borderElCls: p
  } = c, v = p ? "> *" : "", A = ["hover", d ? "focus" : null, "active"].filter(Boolean).map((x) => `&:${x} ${v}`).join(",");
  return {
    [`&-item:not(${s}-last-item)`]: {
      marginInlineEnd: a.calc(a.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [A]: {
        zIndex: 2
      }
    }, u ? {
      [`&${u}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${v}`]: {
        zIndex: 0
      }
    })
  };
}
function compactItemBorderRadius(a, s, c) {
  const {
    borderElCls: u
  } = c, d = u ? `> ${u}` : "";
  return {
    [`&-item:not(${s}-first-item):not(${s}-last-item) ${d}`]: {
      borderRadius: 0
    },
    [`&-item:not(${s}-last-item)${s}-first-item`]: {
      [`& ${d}, &${a}-sm ${d}, &${a}-lg ${d}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${s}-first-item)${s}-last-item`]: {
      [`& ${d}, &${a}-sm ${d}, &${a}-lg ${d}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(a, s = {
  focus: !0
}) {
  const {
    componentCls: c
  } = a, u = `${c}-compact`;
  return {
    [u]: Object.assign(Object.assign({}, compactItemBorder(a, u, s)), compactItemBorderRadius(c, u, s))
  };
}
function compactItemVerticalBorder(a, s) {
  return {
    // border collapse
    [`&-item:not(${s}-last-item)`]: {
      marginBottom: a.calc(a.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(a, s) {
  return {
    [`&-item:not(${s}-first-item):not(${s}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${s}-first-item:not(${s}-last-item)`]: {
      [`&, &${a}-sm, &${a}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${s}-last-item:not(${s}-first-item)`]: {
      [`&, &${a}-sm, &${a}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(a) {
  const s = `${a.componentCls}-compact-vertical`;
  return {
    [s]: Object.assign(Object.assign({}, compactItemVerticalBorder(a, s)), compactItemBorderVerticalRadius(a.componentCls, s))
  };
}
const genButtonCompactStyle = (a) => {
  const {
    componentCls: s,
    colorPrimaryHover: c,
    lineWidth: u,
    calc: d
  } = a, p = d(u).mul(-1).equal(), v = (A) => {
    const x = `${s}-compact${A ? "-vertical" : ""}-item${s}-primary:not([disabled])`;
    return {
      [`${x} + ${x}::before`]: {
        position: "absolute",
        top: A ? p : 0,
        insetInlineStart: A ? 0 : p,
        backgroundColor: c,
        content: '""',
        width: A ? "100%" : u,
        height: A ? u : "100%"
      }
    };
  };
  return Object.assign(Object.assign({}, v()), v(!0));
}, Compact = genSubStyleComponent(["Button", "compact"], (a) => {
  const s = prepareToken$3(a);
  return [
    // Space Compact
    genCompactItemStyle(s),
    genCompactItemVerticalStyle(s),
    genButtonCompactStyle(s)
  ];
}, prepareComponentToken$s);
var __rest$Z = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function getLoadingConfig(a) {
  if (typeof a == "object" && a) {
    let s = a?.delay;
    return s = !Number.isNaN(s) && typeof s == "number" ? s : 0, {
      loading: s <= 0,
      delay: s
    };
  }
  return {
    loading: !!a,
    delay: 0
  };
}
const ButtonTypeMap = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  // `link` is not a real color but we should compatible with it
  link: ["link", "link"],
  text: ["default", "text"]
}, InternalCompoundedButton = /* @__PURE__ */ React.forwardRef((a, s) => {
  var c, u;
  const {
    loading: d = !1,
    prefixCls: p,
    color: v,
    variant: A,
    type: x,
    danger: g = !1,
    shape: b = "default",
    size: y,
    styles: f,
    disabled: m,
    className: C,
    rootClassName: w,
    children: S,
    icon: $,
    iconPosition: T = "start",
    ghost: I = !1,
    block: _ = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: E = "button",
    classNames: R,
    style: O = {},
    autoInsertSpace: L,
    autoFocus: B
  } = a, F = __rest$Z(a, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]), M = x || "default", {
    button: W
  } = React.useContext(ConfigContext$1), [j, G] = reactExports.useMemo(() => {
    if (v && A)
      return [v, A];
    if (x || g) {
      const Oe = ButtonTypeMap[M] || [];
      return g ? ["danger", Oe[1]] : Oe;
    }
    return W?.color && W?.variant ? [W.color, W.variant] : ["default", "outlined"];
  }, [x, v, A, g, W?.variant, W?.color]), k = j === "danger" ? "dangerous" : j, {
    getPrefixCls: N,
    direction: P,
    autoInsertSpace: D,
    className: H,
    style: V,
    classNames: Z,
    styles: ne
  } = useComponentConfig("button"), K = (c = L ?? D) !== null && c !== void 0 ? c : !0, q = N("btn", p), [Y, ee, Q] = useStyle$v(q), J = reactExports.useContext(DisabledContext), te = m ?? J, ae = reactExports.useContext(GroupSizeContext), se = reactExports.useMemo(() => getLoadingConfig(d), [d]), [ie, fe] = reactExports.useState(se.loading), [ge, me] = reactExports.useState(!1), pe = reactExports.useRef(null), be = useComposeRef(s, pe), le = reactExports.Children.count(S) === 1 && !$ && !isUnBorderedButtonVariant(G), ve = reactExports.useRef(!0);
  React.useEffect(() => (ve.current = !1, () => {
    ve.current = !0;
  }), []), reactExports.useLayoutEffect(() => {
    let Oe = null;
    se.delay > 0 ? Oe = setTimeout(() => {
      Oe = null, fe(!0);
    }, se.delay) : fe(se.loading);
    function Me() {
      Oe && (clearTimeout(Oe), Oe = null);
    }
    return Me;
  }, [se.delay, se.loading]), reactExports.useEffect(() => {
    if (!pe.current || !K)
      return;
    const Oe = pe.current.textContent || "";
    le && isTwoCNChar(Oe) ? ge || me(!0) : ge && me(!1);
  }), reactExports.useEffect(() => {
    B && pe.current && pe.current.focus();
  }, []);
  const he = React.useCallback((Oe) => {
    var Me;
    if (ie || te) {
      Oe.preventDefault();
      return;
    }
    (Me = a.onClick) === null || Me === void 0 || Me.call(a, ("href" in a, Oe));
  }, [a.onClick, ie, te]), {
    compactSize: ye,
    compactItemClassnames: Ce
  } = useCompactItemContext(q, P), xe = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, we = useSize((Oe) => {
    var Me, Fe;
    return (Fe = (Me = y ?? ye) !== null && Me !== void 0 ? Me : ae) !== null && Fe !== void 0 ? Fe : Oe;
  }), $e = we && (u = xe[we]) !== null && u !== void 0 ? u : "", Ae = ie ? "loading" : $, ue = omit(F, ["navigate"]), ce = classnames(q, ee, Q, {
    [`${q}-${b}`]: b !== "default" && b,
    // Compatible with versions earlier than 5.21.0
    [`${q}-${M}`]: M,
    [`${q}-dangerous`]: g,
    [`${q}-color-${k}`]: k,
    [`${q}-variant-${G}`]: G,
    [`${q}-${$e}`]: $e,
    [`${q}-icon-only`]: !S && S !== 0 && !!Ae,
    [`${q}-background-ghost`]: I && !isUnBorderedButtonVariant(G),
    [`${q}-loading`]: ie,
    [`${q}-two-chinese-chars`]: ge && K && !ie,
    [`${q}-block`]: _,
    [`${q}-rtl`]: P === "rtl",
    [`${q}-icon-end`]: T === "end"
  }, Ce, C, w, H), Ee = Object.assign(Object.assign({}, V), O), _e = classnames(R?.icon, Z.icon), Te = Object.assign(Object.assign({}, f?.icon || {}), ne.icon || {}), ke = $ && !ie ? /* @__PURE__ */ React.createElement(IconWrapper, {
    prefixCls: q,
    className: _e,
    style: Te
  }, $) : d && typeof d == "object" && d.icon ? /* @__PURE__ */ React.createElement(IconWrapper, {
    prefixCls: q,
    className: _e,
    style: Te
  }, d.icon) : /* @__PURE__ */ React.createElement(DefaultLoadingIcon, {
    existIcon: !!$,
    prefixCls: q,
    loading: ie,
    mount: ve.current
  }), Re = S || S === 0 ? spaceChildren(S, le && K) : null;
  if (ue.href !== void 0)
    return Y(/* @__PURE__ */ React.createElement("a", Object.assign({}, ue, {
      className: classnames(ce, {
        [`${q}-disabled`]: te
      }),
      href: te ? void 0 : ue.href,
      style: Ee,
      onClick: he,
      ref: be,
      tabIndex: te ? -1 : 0
    }), ke, Re));
  let Be = /* @__PURE__ */ React.createElement("button", Object.assign({}, F, {
    type: E,
    className: ce,
    style: Ee,
    onClick: he,
    disabled: te,
    ref: be
  }), ke, Re, Ce && /* @__PURE__ */ React.createElement(Compact, {
    prefixCls: q
  }));
  return isUnBorderedButtonVariant(G) || (Be = /* @__PURE__ */ React.createElement(Wave, {
    component: "Button",
    disabled: ie
  }, Be)), Y(Be);
}), Button$1 = InternalCompoundedButton;
Button$1.Group = ButtonGroup;
Button$1.__ANT_BUTTON = !0;
function isThenable(a) {
  return !!a?.then;
}
const ActionButton = (a) => {
  const {
    type: s,
    children: c,
    prefixCls: u,
    buttonProps: d,
    close: p,
    autoFocus: v,
    emitEvent: A,
    isSilent: x,
    quitOnNullishReturnValue: g,
    actionFn: b
  } = a, y = reactExports.useRef(!1), f = reactExports.useRef(null), [m, C] = useSafeState(!1), w = (...T) => {
    p?.apply(void 0, T);
  };
  reactExports.useEffect(() => {
    let T = null;
    return v && (T = setTimeout(() => {
      var I;
      (I = f.current) === null || I === void 0 || I.focus({
        preventScroll: !0
      });
    })), () => {
      T && clearTimeout(T);
    };
  }, []);
  const S = (T) => {
    isThenable(T) && (C(!0), T.then((...I) => {
      C(!1, !0), w.apply(void 0, I), y.current = !1;
    }, (I) => {
      if (C(!1, !0), y.current = !1, !x?.())
        return Promise.reject(I);
    }));
  }, $ = (T) => {
    if (y.current)
      return;
    if (y.current = !0, !b) {
      w();
      return;
    }
    let I;
    if (A) {
      if (I = b(T), g && !isThenable(I)) {
        y.current = !1, w(T);
        return;
      }
    } else if (b.length)
      I = b(p), y.current = !1;
    else if (I = b(), !isThenable(I)) {
      w();
      return;
    }
    S(I);
  };
  return /* @__PURE__ */ reactExports.createElement(Button$1, Object.assign({}, convertLegacyProps(s), {
    onClick: $,
    loading: m,
    prefixCls: u
  }, d, {
    ref: f
  }), c);
};
var OrderContext = /* @__PURE__ */ reactExports.createContext(null), EMPTY_LIST$5 = [];
function useDom(a, s) {
  var c = reactExports.useState(function() {
    if (!canUseDom$1())
      return null;
    var C = document.createElement("div");
    return C;
  }), u = _slicedToArray$e(c, 1), d = u[0], p = reactExports.useRef(!1), v = reactExports.useContext(OrderContext), A = reactExports.useState(EMPTY_LIST$5), x = _slicedToArray$e(A, 2), g = x[0], b = x[1], y = v || (p.current ? void 0 : function(C) {
    b(function(w) {
      var S = [C].concat(_toConsumableArray$e(w));
      return S;
    });
  });
  function f() {
    d.parentElement || document.body.appendChild(d), p.current = !0;
  }
  function m() {
    var C;
    (C = d.parentElement) === null || C === void 0 || C.removeChild(d), p.current = !1;
  }
  return useLayoutEffect$1(function() {
    return a ? v ? v(f) : f() : m(), m;
  }, [a]), useLayoutEffect$1(function() {
    g.length && (g.forEach(function(C) {
      return C();
    }), b(EMPTY_LIST$5));
  }, [g]), [d, y];
}
var cached;
function measureScrollbarSize(a) {
  var s = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), c = document.createElement("div");
  c.id = s;
  var u = c.style;
  u.position = "absolute", u.left = "0", u.top = "0", u.width = "100px", u.height = "100px", u.overflow = "scroll";
  var d, p;
  if (a) {
    var v = getComputedStyle(a);
    u.scrollbarColor = v.scrollbarColor, u.scrollbarWidth = v.scrollbarWidth;
    var A = getComputedStyle(a, "::-webkit-scrollbar"), x = parseInt(A.width, 10), g = parseInt(A.height, 10);
    try {
      var b = x ? "width: ".concat(A.width, ";") : "", y = g ? "height: ".concat(A.height, ";") : "";
      updateCSS(`
#`.concat(s, `::-webkit-scrollbar {
`).concat(b, `
`).concat(y, `
}`), s);
    } catch (C) {
      console.error(C), d = x, p = g;
    }
  }
  document.body.appendChild(c);
  var f = a && d && !isNaN(d) ? d : c.offsetWidth - c.clientWidth, m = a && p && !isNaN(p) ? p : c.offsetHeight - c.clientHeight;
  return document.body.removeChild(c), removeCSS(s), {
    width: f,
    height: m
  };
}
function getScrollBarSize(a) {
  return typeof document > "u" ? 0 : (cached === void 0 && (cached = measureScrollbarSize()), cached.width);
}
function getTargetScrollBarSize(a) {
  return typeof document > "u" || !a || !(a instanceof Element) ? {
    width: 0,
    height: 0
  } : measureScrollbarSize(a);
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var UNIQUE_ID = "rc-util-locker-".concat(Date.now()), uuid$4 = 0;
function useScrollLocker(a) {
  var s = !!a, c = reactExports.useState(function() {
    return uuid$4 += 1, "".concat(UNIQUE_ID, "_").concat(uuid$4);
  }), u = _slicedToArray$e(c, 1), d = u[0];
  useLayoutEffect$1(function() {
    if (s) {
      var p = getTargetScrollBarSize(document.body).width, v = isBodyOverflowing();
      updateCSS(`
html body {
  overflow-y: hidden;
  `.concat(v ? "width: calc(100% - ".concat(p, "px);") : "", `
}`), d);
    } else
      removeCSS(d);
    return function() {
      removeCSS(d);
    };
  }, [s, d]);
}
var inline = !1;
function inlineMock(a) {
  return inline;
}
var getPortalContainer = function a(s) {
  return s === !1 ? !1 : !canUseDom$1() || !s ? null : typeof s == "string" ? document.querySelector(s) : typeof s == "function" ? s() : s;
}, Portal = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.open, u = a.autoLock, d = a.getContainer;
  a.debug;
  var p = a.autoDestroy, v = p === void 0 ? !0 : p, A = a.children, x = reactExports.useState(c), g = _slicedToArray$e(x, 2), b = g[0], y = g[1], f = b || c;
  reactExports.useEffect(function() {
    (v || c) && y(c);
  }, [c, v]);
  var m = reactExports.useState(function() {
    return getPortalContainer(d);
  }), C = _slicedToArray$e(m, 2), w = C[0], S = C[1];
  reactExports.useEffect(function() {
    var M = getPortalContainer(d);
    S(M ?? null);
  });
  var $ = useDom(f && !w), T = _slicedToArray$e($, 2), I = T[0], _ = T[1], E = w ?? I;
  useScrollLocker(u && c && canUseDom$1() && (E === I || E === document.body));
  var R = null;
  if (A && supportRef(A) && s) {
    var O = A;
    R = O.ref;
  }
  var L = useComposeRef(R, s);
  if (!f || !canUseDom$1() || w === void 0)
    return null;
  var B = E === !1 || inlineMock(), F = A;
  return s && (F = /* @__PURE__ */ reactExports.cloneElement(A, {
    ref: L
  })), /* @__PURE__ */ reactExports.createElement(OrderContext.Provider, {
    value: _
  }, B ? F : /* @__PURE__ */ reactDomExports.createPortal(F, E));
}), RefContext$1 = /* @__PURE__ */ reactExports.createContext({});
function getUseId() {
  var a = _objectSpread2$1({}, React$1);
  return a.useId;
}
var uuid$3 = 0, useOriginId = getUseId();
const useId$2 = useOriginId ? (
  // Use React `useId`
  function a(s) {
    var c = useOriginId();
    return s || c;
  }
) : (
  // Use compatible of `useId`
  function a(s) {
    var c = reactExports.useState("ssr-id"), u = _slicedToArray$e(c, 2), d = u[0], p = u[1];
    return reactExports.useEffect(function() {
      var v = uuid$3;
      uuid$3 += 1, p("rc_unique_".concat(v));
    }, []), s || d;
  }
);
function getMotionName(a, s, c) {
  var u = s;
  return !u && c && (u = "".concat(a, "-").concat(c)), u;
}
function getScroll$2(a, s) {
  var c = a["page".concat(s ? "Y" : "X", "Offset")], u = "scroll".concat(s ? "Top" : "Left");
  if (typeof c != "number") {
    var d = a.document;
    c = d.documentElement[u], typeof c != "number" && (c = d.body[u]);
  }
  return c;
}
function offset$1(a) {
  var s = a.getBoundingClientRect(), c = {
    left: s.left,
    top: s.top
  }, u = a.ownerDocument, d = u.defaultView || u.parentWindow;
  return c.left += getScroll$2(d), c.top += getScroll$2(d, !0), c;
}
const MemoChildren = /* @__PURE__ */ reactExports.memo(function(a) {
  var s = a.children;
  return s;
}, function(a, s) {
  var c = s.shouldUpdate;
  return !c;
});
var sentinelStyle$1 = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, entityStyle = {
  outline: "none"
}, Panel$3 = /* @__PURE__ */ React.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.className, d = a.style, p = a.title, v = a.ariaId, A = a.footer, x = a.closable, g = a.closeIcon, b = a.onClose, y = a.children, f = a.bodyStyle, m = a.bodyProps, C = a.modalRender, w = a.onMouseDown, S = a.onMouseUp, $ = a.holderRef, T = a.visible, I = a.forceRender, _ = a.width, E = a.height, R = a.classNames, O = a.styles, L = React.useContext(RefContext$1), B = L.panel, F = useComposeRef($, B), M = reactExports.useRef(), W = reactExports.useRef();
  React.useImperativeHandle(s, function() {
    return {
      focus: function() {
        var Z;
        (Z = M.current) === null || Z === void 0 || Z.focus({
          preventScroll: !0
        });
      },
      changeActive: function(Z) {
        var ne = document, K = ne.activeElement;
        Z && K === W.current ? M.current.focus({
          preventScroll: !0
        }) : !Z && K === M.current && W.current.focus({
          preventScroll: !0
        });
      }
    };
  });
  var j = {};
  _ !== void 0 && (j.width = _), E !== void 0 && (j.height = E);
  var G = A ? /* @__PURE__ */ React.createElement("div", {
    className: classnames("".concat(c, "-footer"), R?.footer),
    style: _objectSpread2$1({}, O?.footer)
  }, A) : null, U = p ? /* @__PURE__ */ React.createElement("div", {
    className: classnames("".concat(c, "-header"), R?.header),
    style: _objectSpread2$1({}, O?.header)
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(c, "-title"),
    id: v
  }, p)) : null, k = reactExports.useMemo(function() {
    return _typeof$h(x) === "object" && x !== null ? x : x ? {
      closeIcon: g ?? /* @__PURE__ */ React.createElement("span", {
        className: "".concat(c, "-close-x")
      })
    } : {};
  }, [x, g, c]), N = pickAttrs(k, !0), P = _typeof$h(x) === "object" && x.disabled, D = x ? /* @__PURE__ */ React.createElement("button", _extends$3({
    type: "button",
    onClick: b,
    "aria-label": "Close"
  }, N, {
    className: "".concat(c, "-close"),
    disabled: P
  }), k.closeIcon) : null, H = /* @__PURE__ */ React.createElement("div", {
    className: classnames("".concat(c, "-content"), R?.content),
    style: O?.content
  }, D, U, /* @__PURE__ */ React.createElement("div", _extends$3({
    className: classnames("".concat(c, "-body"), R?.body),
    style: _objectSpread2$1(_objectSpread2$1({}, f), O?.body)
  }, m), y), G);
  return /* @__PURE__ */ React.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": p ? v : null,
    "aria-modal": "true",
    ref: F,
    style: _objectSpread2$1(_objectSpread2$1({}, d), j),
    className: classnames(c, u),
    onMouseDown: w,
    onMouseUp: S
  }, /* @__PURE__ */ React.createElement("div", {
    ref: M,
    tabIndex: 0,
    style: entityStyle
  }, /* @__PURE__ */ React.createElement(MemoChildren, {
    shouldUpdate: T || I
  }, C ? C(H) : H)), /* @__PURE__ */ React.createElement("div", {
    tabIndex: 0,
    ref: W,
    style: sentinelStyle$1
  }));
}), Content = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.title, d = a.style, p = a.className, v = a.visible, A = a.forceRender, x = a.destroyOnClose, g = a.motionName, b = a.ariaId, y = a.onVisibleChanged, f = a.mousePosition, m = reactExports.useRef(), C = reactExports.useState(), w = _slicedToArray$e(C, 2), S = w[0], $ = w[1], T = {};
  S && (T.transformOrigin = S);
  function I() {
    var _ = offset$1(m.current);
    $(f && (f.x || f.y) ? "".concat(f.x - _.left, "px ").concat(f.y - _.top, "px") : "");
  }
  return /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    visible: v,
    onVisibleChanged: y,
    onAppearPrepare: I,
    onEnterPrepare: I,
    forceRender: A,
    motionName: g,
    removeOnLeave: x,
    ref: m
  }, function(_, E) {
    var R = _.className, O = _.style;
    return /* @__PURE__ */ reactExports.createElement(Panel$3, _extends$3({}, a, {
      ref: s,
      title: u,
      ariaId: b,
      prefixCls: c,
      holderRef: E,
      style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, O), d), T),
      className: classnames(p, R)
    }));
  });
});
Content.displayName = "Content";
var Mask$2 = function a(s) {
  var c = s.prefixCls, u = s.style, d = s.visible, p = s.maskProps, v = s.motionName, A = s.className;
  return /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    key: "mask",
    visible: d,
    motionName: v,
    leavedClassName: "".concat(c, "-mask-hidden")
  }, function(x, g) {
    var b = x.className, y = x.style;
    return /* @__PURE__ */ reactExports.createElement("div", _extends$3({
      ref: g,
      style: _objectSpread2$1(_objectSpread2$1({}, y), u),
      className: classnames("".concat(c, "-mask"), b, A)
    }, p));
  });
}, Dialog = function a(s) {
  var c = s.prefixCls, u = c === void 0 ? "rc-dialog" : c, d = s.zIndex, p = s.visible, v = p === void 0 ? !1 : p, A = s.keyboard, x = A === void 0 ? !0 : A, g = s.focusTriggerAfterClose, b = g === void 0 ? !0 : g, y = s.wrapStyle, f = s.wrapClassName, m = s.wrapProps, C = s.onClose, w = s.afterOpenChange, S = s.afterClose, $ = s.transitionName, T = s.animation, I = s.closable, _ = I === void 0 ? !0 : I, E = s.mask, R = E === void 0 ? !0 : E, O = s.maskTransitionName, L = s.maskAnimation, B = s.maskClosable, F = B === void 0 ? !0 : B, M = s.maskStyle, W = s.maskProps, j = s.rootClassName, G = s.classNames, U = s.styles, k = reactExports.useRef(), N = reactExports.useRef(), P = reactExports.useRef(), D = reactExports.useState(v), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = useId$2();
  function K() {
    contains$3(N.current, document.activeElement) || (k.current = document.activeElement);
  }
  function q() {
    if (!contains$3(N.current, document.activeElement)) {
      var ge;
      (ge = P.current) === null || ge === void 0 || ge.focus();
    }
  }
  function Y(ge) {
    if (ge)
      q();
    else {
      if (Z(!1), R && k.current && b) {
        try {
          k.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        k.current = null;
      }
      V && S?.();
    }
    w?.(ge);
  }
  function ee(ge) {
    C?.(ge);
  }
  var Q = reactExports.useRef(!1), J = reactExports.useRef(), te = function() {
    clearTimeout(J.current), Q.current = !0;
  }, ae = function() {
    J.current = setTimeout(function() {
      Q.current = !1;
    });
  }, se = null;
  F && (se = function(me) {
    Q.current ? Q.current = !1 : N.current === me.target && ee(me);
  });
  function ie(ge) {
    if (x && ge.keyCode === KeyCode.ESC) {
      ge.stopPropagation(), ee(ge);
      return;
    }
    v && ge.keyCode === KeyCode.TAB && P.current.changeActive(!ge.shiftKey);
  }
  reactExports.useEffect(function() {
    v && (Z(!0), K());
  }, [v]), reactExports.useEffect(function() {
    return function() {
      clearTimeout(J.current);
    };
  }, []);
  var fe = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
    zIndex: d
  }, y), U?.wrapper), {}, {
    display: V ? null : "none"
  });
  return /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    className: classnames("".concat(u, "-root"), j)
  }, pickAttrs(s, {
    data: !0
  })), /* @__PURE__ */ reactExports.createElement(Mask$2, {
    prefixCls: u,
    visible: R && v,
    motionName: getMotionName(u, O, L),
    style: _objectSpread2$1(_objectSpread2$1({
      zIndex: d
    }, M), U?.mask),
    maskProps: W,
    className: G?.mask
  }), /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    tabIndex: -1,
    onKeyDown: ie,
    className: classnames("".concat(u, "-wrap"), f, G?.wrapper),
    ref: N,
    onClick: se,
    style: fe
  }, m), /* @__PURE__ */ reactExports.createElement(Content, _extends$3({}, s, {
    onMouseDown: te,
    onMouseUp: ae,
    ref: P,
    closable: _,
    ariaId: ne,
    prefixCls: u,
    visible: v && V,
    onClose: ee,
    onVisibleChanged: Y,
    motionName: getMotionName(u, $, T)
  }))));
}, DialogWrap = function a(s) {
  var c = s.visible, u = s.getContainer, d = s.forceRender, p = s.destroyOnClose, v = p === void 0 ? !1 : p, A = s.afterClose, x = s.panelRef, g = reactExports.useState(c), b = _slicedToArray$e(g, 2), y = b[0], f = b[1], m = reactExports.useMemo(function() {
    return {
      panel: x
    };
  }, [x]);
  return reactExports.useEffect(function() {
    c && f(!0);
  }, [c]), !d && v && !y ? null : /* @__PURE__ */ reactExports.createElement(RefContext$1.Provider, {
    value: m
  }, /* @__PURE__ */ reactExports.createElement(Portal, {
    open: c || d || y,
    autoDestroy: !1,
    getContainer: u,
    autoLock: c || y
  }, /* @__PURE__ */ reactExports.createElement(Dialog, _extends$3({}, s, {
    destroyOnClose: v,
    afterClose: function() {
      A?.(), f(!1);
    }
  }))));
};
DialogWrap.displayName = "Dialog";
var HOOK_MARK = "RC_FORM_INTERNAL_HOOKS", warningFunc = function a() {
  warningOnce(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Context$2 = /* @__PURE__ */ reactExports.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldValue: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function a() {
    return warningFunc(), {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
}), ListContext = /* @__PURE__ */ reactExports.createContext(null);
function toArray$7(a) {
  return a == null ? [] : Array.isArray(a) ? a : [a];
}
function isFormInstance(a) {
  return a && !!a._init;
}
function newMessages() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var s = JSON.parse(JSON.stringify(this));
      return s.clone = this.clone, s;
    }
  };
}
var messages = newMessages();
function _isNativeFunction(a) {
  try {
    return Function.toString.call(a).indexOf("[native code]") !== -1;
  } catch {
    return typeof a == "function";
  }
}
function _construct(a, s, c) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var u = [null];
  u.push.apply(u, s);
  var d = new (a.bind.apply(a, u))();
  return c && _setPrototypeOf(d, c.prototype), d;
}
function _wrapNativeSuper(a) {
  var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function(u) {
    if (u === null || !_isNativeFunction(u)) return u;
    if (typeof u != "function") throw new TypeError("Super expression must either be null or a function");
    if (s !== void 0) {
      if (s.has(u)) return s.get(u);
      s.set(u, d);
    }
    function d() {
      return _construct(u, arguments, _getPrototypeOf(this).constructor);
    }
    return d.prototype = Object.create(u.prototype, {
      constructor: {
        value: d,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(d, u);
  }, _wrapNativeSuper(a);
}
var formatRegExp = /%[sdj%]/g, warning$1 = function a() {
};
typeof process < "u" && process.env;
function convertFieldsError(a) {
  if (!a || !a.length) return null;
  var s = {};
  return a.forEach(function(c) {
    var u = c.field;
    s[u] = s[u] || [], s[u].push(c);
  }), s;
}
function format(a) {
  for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++)
    c[u - 1] = arguments[u];
  var d = 0, p = c.length;
  if (typeof a == "function")
    return a.apply(null, c);
  if (typeof a == "string") {
    var v = a.replace(formatRegExp, function(A) {
      if (A === "%%")
        return "%";
      if (d >= p)
        return A;
      switch (A) {
        case "%s":
          return String(c[d++]);
        case "%d":
          return Number(c[d++]);
        case "%j":
          try {
            return JSON.stringify(c[d++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return A;
      }
    });
    return v;
  }
  return a;
}
function isNativeStringType(a) {
  return a === "string" || a === "url" || a === "hex" || a === "email" || a === "date" || a === "pattern";
}
function isEmptyValue(a, s) {
  return !!(a == null || s === "array" && Array.isArray(a) && !a.length || isNativeStringType(s) && typeof a == "string" && !a);
}
function asyncParallelArray(a, s, c) {
  var u = [], d = 0, p = a.length;
  function v(A) {
    u.push.apply(u, _toConsumableArray$e(A || [])), d++, d === p && c(u);
  }
  a.forEach(function(A) {
    s(A, v);
  });
}
function asyncSerialArray(a, s, c) {
  var u = 0, d = a.length;
  function p(v) {
    if (v && v.length) {
      c(v);
      return;
    }
    var A = u;
    u = u + 1, A < d ? s(a[A], p) : c([]);
  }
  p([]);
}
function flattenObjArr(a) {
  var s = [];
  return Object.keys(a).forEach(function(c) {
    s.push.apply(s, _toConsumableArray$e(a[c] || []));
  }), s;
}
var AsyncValidationError = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c(u, d) {
    var p;
    return _classCallCheck$1(this, c), p = s.call(this, "Async Validation Error"), _defineProperty$a(_assertThisInitialized(p), "errors", void 0), _defineProperty$a(_assertThisInitialized(p), "fields", void 0), p.errors = u, p.fields = d, p;
  }
  return _createClass$1(c);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(a, s, c, u, d) {
  if (s.first) {
    var p = new Promise(function(f, m) {
      var C = function($) {
        return u($), $.length ? m(new AsyncValidationError($, convertFieldsError($))) : f(d);
      }, w = flattenObjArr(a);
      asyncSerialArray(w, c, C);
    });
    return p.catch(function(f) {
      return f;
    }), p;
  }
  var v = s.firstFields === !0 ? Object.keys(a) : s.firstFields || [], A = Object.keys(a), x = A.length, g = 0, b = [], y = new Promise(function(f, m) {
    var C = function(S) {
      if (b.push.apply(b, S), g++, g === x)
        return u(b), b.length ? m(new AsyncValidationError(b, convertFieldsError(b))) : f(d);
    };
    A.length || (u(b), f(d)), A.forEach(function(w) {
      var S = a[w];
      v.indexOf(w) !== -1 ? asyncSerialArray(S, c, C) : asyncParallelArray(S, c, C);
    });
  });
  return y.catch(function(f) {
    return f;
  }), y;
}
function isErrorObj(a) {
  return !!(a && a.message !== void 0);
}
function getValue$2(a, s) {
  for (var c = a, u = 0; u < s.length; u++) {
    if (c == null)
      return c;
    c = c[s[u]];
  }
  return c;
}
function complementError(a, s) {
  return function(c) {
    var u;
    return a.fullFields ? u = getValue$2(s, a.fullFields) : u = s[c.field || a.fullField], isErrorObj(c) ? (c.field = c.field || a.fullField, c.fieldValue = u, c) : {
      message: typeof c == "function" ? c() : c,
      fieldValue: u,
      field: c.field || a.fullField
    };
  };
}
function deepMerge$1(a, s) {
  if (s) {
    for (var c in s)
      if (s.hasOwnProperty(c)) {
        var u = s[c];
        _typeof$h(u) === "object" && _typeof$h(a[c]) === "object" ? a[c] = _objectSpread2$1(_objectSpread2$1({}, a[c]), u) : a[c] = u;
      }
  }
  return a;
}
var ENUM$1 = "enum", enumerable$1 = function a(s, c, u, d, p) {
  s[ENUM$1] = Array.isArray(s[ENUM$1]) ? s[ENUM$1] : [], s[ENUM$1].indexOf(c) === -1 && d.push(format(p.messages[ENUM$1], s.fullField, s[ENUM$1].join(", ")));
}, pattern$2 = function a(s, c, u, d, p) {
  if (s.pattern) {
    if (s.pattern instanceof RegExp)
      s.pattern.lastIndex = 0, s.pattern.test(c) || d.push(format(p.messages.pattern.mismatch, s.fullField, c, s.pattern));
    else if (typeof s.pattern == "string") {
      var v = new RegExp(s.pattern);
      v.test(c) || d.push(format(p.messages.pattern.mismatch, s.fullField, c, s.pattern));
    }
  }
}, range = function a(s, c, u, d, p) {
  var v = typeof s.len == "number", A = typeof s.min == "number", x = typeof s.max == "number", g = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, b = c, y = null, f = typeof c == "number", m = typeof c == "string", C = Array.isArray(c);
  if (f ? y = "number" : m ? y = "string" : C && (y = "array"), !y)
    return !1;
  C && (b = c.length), m && (b = c.replace(g, "_").length), v ? b !== s.len && d.push(format(p.messages[y].len, s.fullField, s.len)) : A && !x && b < s.min ? d.push(format(p.messages[y].min, s.fullField, s.min)) : x && !A && b > s.max ? d.push(format(p.messages[y].max, s.fullField, s.max)) : A && x && (b < s.min || b > s.max) && d.push(format(p.messages[y].range, s.fullField, s.min, s.max));
}, required$1 = function a(s, c, u, d, p, v) {
  s.required && (!u.hasOwnProperty(s.field) || isEmptyValue(c, v || s.type)) && d.push(format(p.messages.required, s.fullField));
}, urlReg;
const getUrlRegex = function() {
  if (urlReg)
    return urlReg;
  var a = "[a-fA-F\\d:]", s = function(R) {
    return R && R.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(a, ")|(?<=").concat(a, ")(?=\\s|$))") : "";
  }, c = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", u = "[a-fA-F\\d]{1,4}", d = [
    "(?:".concat(u, ":){7}(?:").concat(u, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(u, ":){6}(?:").concat(c, "|:").concat(u, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(u, ":){5}(?::").concat(c, "|(?::").concat(u, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(u, ":){4}(?:(?::").concat(u, "){0,1}:").concat(c, "|(?::").concat(u, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(u, ":){3}(?:(?::").concat(u, "){0,2}:").concat(c, "|(?::").concat(u, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(u, ":){2}(?:(?::").concat(u, "){0,3}:").concat(c, "|(?::").concat(u, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(u, ":){1}(?:(?::").concat(u, "){0,4}:").concat(c, "|(?::").concat(u, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(u, "){0,5}:").concat(c, "|(?::").concat(u, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], p = "(?:%[0-9a-zA-Z]{1,})?", v = "(?:".concat(d.join("|"), ")").concat(p), A = new RegExp("(?:^".concat(c, "$)|(?:^").concat(v, "$)")), x = new RegExp("^".concat(c, "$")), g = new RegExp("^".concat(v, "$")), b = function(R) {
    return R && R.exact ? A : new RegExp("(?:".concat(s(R)).concat(c).concat(s(R), ")|(?:").concat(s(R)).concat(v).concat(s(R), ")"), "g");
  };
  b.v4 = function(E) {
    return E && E.exact ? x : new RegExp("".concat(s(E)).concat(c).concat(s(E)), "g");
  }, b.v6 = function(E) {
    return E && E.exact ? g : new RegExp("".concat(s(E)).concat(v).concat(s(E)), "g");
  };
  var y = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", m = b.v4().source, C = b.v6().source, w = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", S = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", $ = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", T = "(?::\\d{2,5})?", I = '(?:[/?#][^\\s"]*)?', _ = "(?:".concat(y, "|www\\.)").concat(f, "(?:localhost|").concat(m, "|").concat(C, "|").concat(w).concat(S).concat($, ")").concat(T).concat(I);
  return urlReg = new RegExp("(?:^".concat(_, "$)"), "i"), urlReg;
};
var pattern$1 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, types = {
  integer: function a(s) {
    return types.number(s) && parseInt(s, 10) === s;
  },
  float: function a(s) {
    return types.number(s) && !types.integer(s);
  },
  array: function a(s) {
    return Array.isArray(s);
  },
  regexp: function a(s) {
    if (s instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(s);
    } catch {
      return !1;
    }
  },
  date: function a(s) {
    return typeof s.getTime == "function" && typeof s.getMonth == "function" && typeof s.getYear == "function" && !isNaN(s.getTime());
  },
  number: function a(s) {
    return isNaN(s) ? !1 : typeof s == "number";
  },
  object: function a(s) {
    return _typeof$h(s) === "object" && !types.array(s);
  },
  method: function a(s) {
    return typeof s == "function";
  },
  email: function a(s) {
    return typeof s == "string" && s.length <= 320 && !!s.match(pattern$1.email);
  },
  url: function a(s) {
    return typeof s == "string" && s.length <= 2048 && !!s.match(getUrlRegex());
  },
  hex: function a(s) {
    return typeof s == "string" && !!s.match(pattern$1.hex);
  }
}, type$1 = function a(s, c, u, d, p) {
  if (s.required && c === void 0) {
    required$1(s, c, u, d, p);
    return;
  }
  var v = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], A = s.type;
  v.indexOf(A) > -1 ? types[A](c) || d.push(format(p.messages.types[A], s.fullField, s.type)) : A && _typeof$h(c) !== s.type && d.push(format(p.messages.types[A], s.fullField, s.type));
}, whitespace = function a(s, c, u, d, p) {
  (/^\s+$/.test(c) || c === "") && d.push(format(p.messages.whitespace, s.fullField));
};
const rules = {
  required: required$1,
  whitespace,
  type: type$1,
  range,
  enum: enumerable$1,
  pattern: pattern$2
};
var any = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p);
  }
  u(v);
}, array = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (c == null && !s.required)
      return u();
    rules.required(s, c, d, v, p, "array"), c != null && (rules.type(s, c, d, v, p), rules.range(s, c, d, v, p));
  }
  u(v);
}, boolean = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p), c !== void 0 && rules.type(s, c, d, v, p);
  }
  u(v);
}, date = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c, "date") && !s.required)
      return u();
    if (rules.required(s, c, d, v, p), !isEmptyValue(c, "date")) {
      var x;
      c instanceof Date ? x = c : x = new Date(c), rules.type(s, x, d, v, p), x && rules.range(s, x.getTime(), d, v, p);
    }
  }
  u(v);
}, ENUM = "enum", enumerable = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p), c !== void 0 && rules[ENUM](s, c, d, v, p);
  }
  u(v);
}, floatFn = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p), c !== void 0 && (rules.type(s, c, d, v, p), rules.range(s, c, d, v, p));
  }
  u(v);
}, integer = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p), c !== void 0 && (rules.type(s, c, d, v, p), rules.range(s, c, d, v, p));
  }
  u(v);
}, method = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p), c !== void 0 && rules.type(s, c, d, v, p);
  }
  u(v);
}, number = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (c === "" && (c = void 0), isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p), c !== void 0 && (rules.type(s, c, d, v, p), rules.range(s, c, d, v, p));
  }
  u(v);
}, object = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p), c !== void 0 && rules.type(s, c, d, v, p);
  }
  u(v);
}, pattern = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c, "string") && !s.required)
      return u();
    rules.required(s, c, d, v, p), isEmptyValue(c, "string") || rules.pattern(s, c, d, v, p);
  }
  u(v);
}, regexp = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c) && !s.required)
      return u();
    rules.required(s, c, d, v, p), isEmptyValue(c) || rules.type(s, c, d, v, p);
  }
  u(v);
}, required = function a(s, c, u, d, p) {
  var v = [], A = Array.isArray(c) ? "array" : _typeof$h(c);
  rules.required(s, c, d, v, p, A), u(v);
}, string = function a(s, c, u, d, p) {
  var v = [], A = s.required || !s.required && d.hasOwnProperty(s.field);
  if (A) {
    if (isEmptyValue(c, "string") && !s.required)
      return u();
    rules.required(s, c, d, v, p, "string"), isEmptyValue(c, "string") || (rules.type(s, c, d, v, p), rules.range(s, c, d, v, p), rules.pattern(s, c, d, v, p), s.whitespace === !0 && rules.whitespace(s, c, d, v, p));
  }
  u(v);
}, type = function a(s, c, u, d, p) {
  var v = s.type, A = [], x = s.required || !s.required && d.hasOwnProperty(s.field);
  if (x) {
    if (isEmptyValue(c, v) && !s.required)
      return u();
    rules.required(s, c, d, A, p, v), isEmptyValue(c, v) || rules.type(s, c, d, A, p);
  }
  u(A);
};
const validators = {
  string,
  method,
  number,
  boolean,
  regexp,
  integer,
  float: floatFn,
  array,
  object,
  enum: enumerable,
  pattern,
  date,
  url: type,
  hex: type,
  email: type,
  required,
  any
};
var Schema = /* @__PURE__ */ function() {
  function a(s) {
    _classCallCheck$1(this, a), _defineProperty$a(this, "rules", null), _defineProperty$a(this, "_messages", messages), this.define(s);
  }
  return _createClass$1(a, [{
    key: "define",
    value: function(c) {
      var u = this;
      if (!c)
        throw new Error("Cannot configure a schema with no rules");
      if (_typeof$h(c) !== "object" || Array.isArray(c))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(c).forEach(function(d) {
        var p = c[d];
        u.rules[d] = Array.isArray(p) ? p : [p];
      });
    }
  }, {
    key: "messages",
    value: function(c) {
      return c && (this._messages = deepMerge$1(newMessages(), c)), this._messages;
    }
  }, {
    key: "validate",
    value: function(c) {
      var u = this, d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, v = c, A = d, x = p;
      if (typeof A == "function" && (x = A, A = {}), !this.rules || Object.keys(this.rules).length === 0)
        return x && x(null, v), Promise.resolve(v);
      function g(C) {
        var w = [], S = {};
        function $(I) {
          if (Array.isArray(I)) {
            var _;
            w = (_ = w).concat.apply(_, _toConsumableArray$e(I));
          } else
            w.push(I);
        }
        for (var T = 0; T < C.length; T++)
          $(C[T]);
        w.length ? (S = convertFieldsError(w), x(w, S)) : x(null, v);
      }
      if (A.messages) {
        var b = this.messages();
        b === messages && (b = newMessages()), deepMerge$1(b, A.messages), A.messages = b;
      } else
        A.messages = this.messages();
      var y = {}, f = A.keys || Object.keys(this.rules);
      f.forEach(function(C) {
        var w = u.rules[C], S = v[C];
        w.forEach(function($) {
          var T = $;
          typeof T.transform == "function" && (v === c && (v = _objectSpread2$1({}, v)), S = v[C] = T.transform(S), S != null && (T.type = T.type || (Array.isArray(S) ? "array" : _typeof$h(S)))), typeof T == "function" ? T = {
            validator: T
          } : T = _objectSpread2$1({}, T), T.validator = u.getValidationMethod(T), T.validator && (T.field = C, T.fullField = T.fullField || C, T.type = u.getType(T), y[C] = y[C] || [], y[C].push({
            rule: T,
            value: S,
            source: v,
            field: C
          }));
        });
      });
      var m = {};
      return asyncMap(y, A, function(C, w) {
        var S = C.rule, $ = (S.type === "object" || S.type === "array") && (_typeof$h(S.fields) === "object" || _typeof$h(S.defaultField) === "object");
        $ = $ && (S.required || !S.required && C.value), S.field = C.field;
        function T(O, L) {
          return _objectSpread2$1(_objectSpread2$1({}, L), {}, {
            fullField: "".concat(S.fullField, ".").concat(O),
            fullFields: S.fullFields ? [].concat(_toConsumableArray$e(S.fullFields), [O]) : [O]
          });
        }
        function I() {
          var O = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], L = Array.isArray(O) ? O : [O];
          !A.suppressWarning && L.length && a.warning("async-validator:", L), L.length && S.message !== void 0 && (L = [].concat(S.message));
          var B = L.map(complementError(S, v));
          if (A.first && B.length)
            return m[S.field] = 1, w(B);
          if (!$)
            w(B);
          else {
            if (S.required && !C.value)
              return S.message !== void 0 ? B = [].concat(S.message).map(complementError(S, v)) : A.error && (B = [A.error(S, format(A.messages.required, S.field))]), w(B);
            var F = {};
            S.defaultField && Object.keys(C.value).map(function(j) {
              F[j] = S.defaultField;
            }), F = _objectSpread2$1(_objectSpread2$1({}, F), C.rule.fields);
            var M = {};
            Object.keys(F).forEach(function(j) {
              var G = F[j], U = Array.isArray(G) ? G : [G];
              M[j] = U.map(T.bind(null, j));
            });
            var W = new a(M);
            W.messages(A.messages), C.rule.options && (C.rule.options.messages = A.messages, C.rule.options.error = A.error), W.validate(C.value, C.rule.options || A, function(j) {
              var G = [];
              B && B.length && G.push.apply(G, _toConsumableArray$e(B)), j && j.length && G.push.apply(G, _toConsumableArray$e(j)), w(G.length ? G : null);
            });
          }
        }
        var _;
        if (S.asyncValidator)
          _ = S.asyncValidator(S, C.value, I, C.source, A);
        else if (S.validator) {
          try {
            _ = S.validator(S, C.value, I, C.source, A);
          } catch (O) {
            var E, R;
            (E = (R = console).error) === null || E === void 0 || E.call(R, O), A.suppressValidatorError || setTimeout(function() {
              throw O;
            }, 0), I(O.message);
          }
          _ === !0 ? I() : _ === !1 ? I(typeof S.message == "function" ? S.message(S.fullField || S.field) : S.message || "".concat(S.fullField || S.field, " fails")) : _ instanceof Array ? I(_) : _ instanceof Error && I(_.message);
        }
        _ && _.then && _.then(function() {
          return I();
        }, function(O) {
          return I(O);
        });
      }, function(C) {
        g(C);
      }, v);
    }
  }, {
    key: "getType",
    value: function(c) {
      if (c.type === void 0 && c.pattern instanceof RegExp && (c.type = "pattern"), typeof c.validator != "function" && c.type && !validators.hasOwnProperty(c.type))
        throw new Error(format("Unknown rule type %s", c.type));
      return c.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(c) {
      if (typeof c.validator == "function")
        return c.validator;
      var u = Object.keys(c), d = u.indexOf("message");
      return d !== -1 && u.splice(d, 1), u.length === 1 && u[0] === "required" ? validators.required : validators[this.getType(c)] || void 0;
    }
  }]), a;
}();
_defineProperty$a(Schema, "register", function a(s, c) {
  if (typeof c != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  validators[s] = c;
});
_defineProperty$a(Schema, "warning", warning$1);
_defineProperty$a(Schema, "messages", messages);
_defineProperty$a(Schema, "validators", validators);
var typeTemplate$1 = "'${name}' is not a valid ${type}", defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate$1,
    method: typeTemplate$1,
    array: typeTemplate$1,
    object: typeTemplate$1,
    number: typeTemplate$1,
    date: typeTemplate$1,
    boolean: typeTemplate$1,
    integer: typeTemplate$1,
    float: typeTemplate$1,
    regexp: typeTemplate$1,
    email: typeTemplate$1,
    url: typeTemplate$1,
    hex: typeTemplate$1
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, AsyncValidator = Schema;
function replaceMessage(a, s) {
  return a.replace(/\\?\$\{\w+\}/g, function(c) {
    if (c.startsWith("\\"))
      return c.slice(1);
    var u = c.slice(2, -1);
    return s[u];
  });
}
var CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function validateRule(a, s, c, u, d) {
  return _validateRule.apply(this, arguments);
}
function _validateRule() {
  return _validateRule = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s, c, u, d, p) {
    var v, A, x, g, b, y, f, m, C;
    return _regeneratorRuntime$3().wrap(function(S) {
      for (; ; ) switch (S.prev = S.next) {
        case 0:
          return v = _objectSpread2$1({}, u), delete v.ruleIndex, AsyncValidator.warning = function() {
          }, v.validator && (A = v.validator, v.validator = function() {
            try {
              return A.apply(void 0, arguments);
            } catch ($) {
              return console.error($), Promise.reject(CODE_LOGIC_ERROR);
            }
          }), x = null, v && v.type === "array" && v.defaultField && (x = v.defaultField, delete v.defaultField), g = new AsyncValidator(_defineProperty$a({}, s, [v])), b = merge$1(defaultValidateMessages, d.validateMessages), g.messages(b), y = [], S.prev = 10, S.next = 13, Promise.resolve(g.validate(_defineProperty$a({}, s, c), _objectSpread2$1({}, d)));
        case 13:
          S.next = 18;
          break;
        case 15:
          S.prev = 15, S.t0 = S.catch(10), S.t0.errors && (y = S.t0.errors.map(function($, T) {
            var I = $.message, _ = I === CODE_LOGIC_ERROR ? b.default : I;
            return /* @__PURE__ */ reactExports.isValidElement(_) ? (
              // Wrap ReactNode with `key`
              /* @__PURE__ */ reactExports.cloneElement(_, {
                key: "error_".concat(T)
              })
            ) : _;
          }));
        case 18:
          if (!(!y.length && x)) {
            S.next = 23;
            break;
          }
          return S.next = 21, Promise.all(c.map(function($, T) {
            return validateRule("".concat(s, ".").concat(T), $, x, d, p);
          }));
        case 21:
          return f = S.sent, S.abrupt("return", f.reduce(function($, T) {
            return [].concat(_toConsumableArray$e($), _toConsumableArray$e(T));
          }, []));
        case 23:
          return m = _objectSpread2$1(_objectSpread2$1({}, u), {}, {
            name: s,
            enum: (u.enum || []).join(", ")
          }, p), C = y.map(function($) {
            return typeof $ == "string" ? replaceMessage($, m) : $;
          }), S.abrupt("return", C);
        case 26:
        case "end":
          return S.stop();
      }
    }, a, null, [[10, 15]]);
  })), _validateRule.apply(this, arguments);
}
function validateRules(a, s, c, u, d, p) {
  var v = a.join("."), A = c.map(function(b, y) {
    var f = b.validator, m = _objectSpread2$1(_objectSpread2$1({}, b), {}, {
      ruleIndex: y
    });
    return f && (m.validator = function(C, w, S) {
      var $ = !1, T = function() {
        for (var E = arguments.length, R = new Array(E), O = 0; O < E; O++)
          R[O] = arguments[O];
        Promise.resolve().then(function() {
          warningOnce(!$, "Your validator function has already return a promise. `callback` will be ignored."), $ || S.apply(void 0, R);
        });
      }, I = f(C, w, T);
      $ = I && typeof I.then == "function" && typeof I.catch == "function", warningOnce($, "`callback` is deprecated. Please return a promise instead."), $ && I.then(function() {
        S();
      }).catch(function(_) {
        S(_ || " ");
      });
    }), m;
  }).sort(function(b, y) {
    var f = b.warningOnly, m = b.ruleIndex, C = y.warningOnly, w = y.ruleIndex;
    return !!f == !!C ? m - w : f ? 1 : -1;
  }), x;
  if (d === !0)
    x = new Promise(/* @__PURE__ */ function() {
      var b = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function y(f, m) {
        var C, w, S;
        return _regeneratorRuntime$3().wrap(function(T) {
          for (; ; ) switch (T.prev = T.next) {
            case 0:
              C = 0;
            case 1:
              if (!(C < A.length)) {
                T.next = 12;
                break;
              }
              return w = A[C], T.next = 5, validateRule(v, s, w, u, p);
            case 5:
              if (S = T.sent, !S.length) {
                T.next = 9;
                break;
              }
              return m([{
                errors: S,
                rule: w
              }]), T.abrupt("return");
            case 9:
              C += 1, T.next = 1;
              break;
            case 12:
              f([]);
            case 13:
            case "end":
              return T.stop();
          }
        }, y);
      }));
      return function(y, f) {
        return b.apply(this, arguments);
      };
    }());
  else {
    var g = A.map(function(b) {
      return validateRule(v, s, b, u, p).then(function(y) {
        return {
          errors: y,
          rule: b
        };
      });
    });
    x = (d ? finishOnFirstFailed(g) : finishOnAllFailed(g)).then(function(b) {
      return Promise.reject(b);
    });
  }
  return x.catch(function(b) {
    return b;
  }), x;
}
function finishOnAllFailed(a) {
  return _finishOnAllFailed.apply(this, arguments);
}
function _finishOnAllFailed() {
  return _finishOnAllFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s) {
    return _regeneratorRuntime$3().wrap(function(u) {
      for (; ; ) switch (u.prev = u.next) {
        case 0:
          return u.abrupt("return", Promise.all(s).then(function(d) {
            var p, v = (p = []).concat.apply(p, _toConsumableArray$e(d));
            return v;
          }));
        case 1:
        case "end":
          return u.stop();
      }
    }, a);
  })), _finishOnAllFailed.apply(this, arguments);
}
function finishOnFirstFailed(a) {
  return _finishOnFirstFailed.apply(this, arguments);
}
function _finishOnFirstFailed() {
  return _finishOnFirstFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s) {
    var c;
    return _regeneratorRuntime$3().wrap(function(d) {
      for (; ; ) switch (d.prev = d.next) {
        case 0:
          return c = 0, d.abrupt("return", new Promise(function(p) {
            s.forEach(function(v) {
              v.then(function(A) {
                A.errors.length && p([A]), c += 1, c === s.length && p([]);
              });
            });
          }));
        case 2:
        case "end":
          return d.stop();
      }
    }, a);
  })), _finishOnFirstFailed.apply(this, arguments);
}
function getNamePath(a) {
  return toArray$7(a);
}
function cloneByNamePathList(a, s) {
  var c = {};
  return s.forEach(function(u) {
    var d = get$1(a, u);
    c = set$1(c, u, d);
  }), c;
}
function containsNamePath(a, s) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return a && a.some(function(u) {
    return matchNamePath(s, u, c);
  });
}
function matchNamePath(a, s) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !a || !s || !c && a.length !== s.length ? !1 : s.every(function(u, d) {
    return a[d] === u;
  });
}
function isSimilar(a, s) {
  if (a === s)
    return !0;
  if (!a && s || a && !s || !a || !s || _typeof$h(a) !== "object" || _typeof$h(s) !== "object")
    return !1;
  var c = Object.keys(a), u = Object.keys(s), d = new Set([].concat(c, u));
  return _toConsumableArray$e(d).every(function(p) {
    var v = a[p], A = s[p];
    return typeof v == "function" && typeof A == "function" ? !0 : v === A;
  });
}
function defaultGetValueFromEvent(a) {
  var s = arguments.length <= 1 ? void 0 : arguments[1];
  return s && s.target && _typeof$h(s.target) === "object" && a in s.target ? s.target[a] : s;
}
function move(a, s, c) {
  var u = a.length;
  if (s < 0 || s >= u || c < 0 || c >= u)
    return a;
  var d = a[s], p = s - c;
  return p > 0 ? [].concat(_toConsumableArray$e(a.slice(0, c)), [d], _toConsumableArray$e(a.slice(c, s)), _toConsumableArray$e(a.slice(s + 1, u))) : p < 0 ? [].concat(_toConsumableArray$e(a.slice(0, s)), _toConsumableArray$e(a.slice(s + 1, c + 1)), [d], _toConsumableArray$e(a.slice(c + 1, u))) : a;
}
var _excluded$X = ["name"], EMPTY_ERRORS = [];
function requireUpdate(a, s, c, u, d, p) {
  return typeof a == "function" ? a(s, c, "source" in p ? {
    source: p.source
  } : {}) : u !== d;
}
var Field = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c(u) {
    var d;
    if (_classCallCheck$1(this, c), d = s.call(this, u), _defineProperty$a(_assertThisInitialized(d), "state", {
      resetCount: 0
    }), _defineProperty$a(_assertThisInitialized(d), "cancelRegisterFunc", null), _defineProperty$a(_assertThisInitialized(d), "mounted", !1), _defineProperty$a(_assertThisInitialized(d), "touched", !1), _defineProperty$a(_assertThisInitialized(d), "dirty", !1), _defineProperty$a(_assertThisInitialized(d), "validatePromise", void 0), _defineProperty$a(_assertThisInitialized(d), "prevValidating", void 0), _defineProperty$a(_assertThisInitialized(d), "errors", EMPTY_ERRORS), _defineProperty$a(_assertThisInitialized(d), "warnings", EMPTY_ERRORS), _defineProperty$a(_assertThisInitialized(d), "cancelRegister", function() {
      var x = d.props, g = x.preserve, b = x.isListField, y = x.name;
      d.cancelRegisterFunc && d.cancelRegisterFunc(b, g, getNamePath(y)), d.cancelRegisterFunc = null;
    }), _defineProperty$a(_assertThisInitialized(d), "getNamePath", function() {
      var x = d.props, g = x.name, b = x.fieldContext, y = b.prefixName, f = y === void 0 ? [] : y;
      return g !== void 0 ? [].concat(_toConsumableArray$e(f), _toConsumableArray$e(g)) : [];
    }), _defineProperty$a(_assertThisInitialized(d), "getRules", function() {
      var x = d.props, g = x.rules, b = g === void 0 ? [] : g, y = x.fieldContext;
      return b.map(function(f) {
        return typeof f == "function" ? f(y) : f;
      });
    }), _defineProperty$a(_assertThisInitialized(d), "refresh", function() {
      d.mounted && d.setState(function(x) {
        var g = x.resetCount;
        return {
          resetCount: g + 1
        };
      });
    }), _defineProperty$a(_assertThisInitialized(d), "metaCache", null), _defineProperty$a(_assertThisInitialized(d), "triggerMetaEvent", function(x) {
      var g = d.props.onMetaChange;
      if (g) {
        var b = _objectSpread2$1(_objectSpread2$1({}, d.getMeta()), {}, {
          destroy: x
        });
        isEqual(d.metaCache, b) || g(b), d.metaCache = b;
      } else
        d.metaCache = null;
    }), _defineProperty$a(_assertThisInitialized(d), "onStoreChange", function(x, g, b) {
      var y = d.props, f = y.shouldUpdate, m = y.dependencies, C = m === void 0 ? [] : m, w = y.onReset, S = b.store, $ = d.getNamePath(), T = d.getValue(x), I = d.getValue(S), _ = g && containsNamePath(g, $);
      switch (b.type === "valueUpdate" && b.source === "external" && !isEqual(T, I) && (d.touched = !0, d.dirty = !0, d.validatePromise = null, d.errors = EMPTY_ERRORS, d.warnings = EMPTY_ERRORS, d.triggerMetaEvent()), b.type) {
        case "reset":
          if (!g || _) {
            d.touched = !1, d.dirty = !1, d.validatePromise = void 0, d.errors = EMPTY_ERRORS, d.warnings = EMPTY_ERRORS, d.triggerMetaEvent(), w?.(), d.refresh();
            return;
          }
          break;
        /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */
        case "remove": {
          if (f && requireUpdate(f, x, S, T, I, b)) {
            d.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var E = b.data;
          if (_) {
            "touched" in E && (d.touched = E.touched), "validating" in E && !("originRCField" in E) && (d.validatePromise = E.validating ? Promise.resolve([]) : null), "errors" in E && (d.errors = E.errors || EMPTY_ERRORS), "warnings" in E && (d.warnings = E.warnings || EMPTY_ERRORS), d.dirty = !0, d.triggerMetaEvent(), d.reRender();
            return;
          } else if ("value" in E && containsNamePath(g, $, !0)) {
            d.reRender();
            return;
          }
          if (f && !$.length && requireUpdate(f, x, S, T, I, b)) {
            d.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var R = C.map(getNamePath);
          if (R.some(function(O) {
            return containsNamePath(b.relatedFields, O);
          })) {
            d.reRender();
            return;
          }
          break;
        }
        default:
          if (_ || (!C.length || $.length || f) && requireUpdate(f, x, S, T, I, b)) {
            d.reRender();
            return;
          }
          break;
      }
      f === !0 && d.reRender();
    }), _defineProperty$a(_assertThisInitialized(d), "validateRules", function(x) {
      var g = d.getNamePath(), b = d.getValue(), y = x || {}, f = y.triggerName, m = y.validateOnly, C = m === void 0 ? !1 : m, w = Promise.resolve().then(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function S() {
        var $, T, I, _, E, R, O;
        return _regeneratorRuntime$3().wrap(function(B) {
          for (; ; ) switch (B.prev = B.next) {
            case 0:
              if (d.mounted) {
                B.next = 2;
                break;
              }
              return B.abrupt("return", []);
            case 2:
              if ($ = d.props, T = $.validateFirst, I = T === void 0 ? !1 : T, _ = $.messageVariables, E = $.validateDebounce, R = d.getRules(), f && (R = R.filter(function(F) {
                return F;
              }).filter(function(F) {
                var M = F.validateTrigger;
                if (!M)
                  return !0;
                var W = toArray$7(M);
                return W.includes(f);
              })), !(E && f)) {
                B.next = 10;
                break;
              }
              return B.next = 8, new Promise(function(F) {
                setTimeout(F, E);
              });
            case 8:
              if (d.validatePromise === w) {
                B.next = 10;
                break;
              }
              return B.abrupt("return", []);
            case 10:
              return O = validateRules(g, b, R, x, I, _), O.catch(function(F) {
                return F;
              }).then(function() {
                var F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_ERRORS;
                if (d.validatePromise === w) {
                  var M;
                  d.validatePromise = null;
                  var W = [], j = [];
                  (M = F.forEach) === null || M === void 0 || M.call(F, function(G) {
                    var U = G.rule.warningOnly, k = G.errors, N = k === void 0 ? EMPTY_ERRORS : k;
                    U ? j.push.apply(j, _toConsumableArray$e(N)) : W.push.apply(W, _toConsumableArray$e(N));
                  }), d.errors = W, d.warnings = j, d.triggerMetaEvent(), d.reRender();
                }
              }), B.abrupt("return", O);
            case 13:
            case "end":
              return B.stop();
          }
        }, S);
      })));
      return C || (d.validatePromise = w, d.dirty = !0, d.errors = EMPTY_ERRORS, d.warnings = EMPTY_ERRORS, d.triggerMetaEvent(), d.reRender()), w;
    }), _defineProperty$a(_assertThisInitialized(d), "isFieldValidating", function() {
      return !!d.validatePromise;
    }), _defineProperty$a(_assertThisInitialized(d), "isFieldTouched", function() {
      return d.touched;
    }), _defineProperty$a(_assertThisInitialized(d), "isFieldDirty", function() {
      if (d.dirty || d.props.initialValue !== void 0)
        return !0;
      var x = d.props.fieldContext, g = x.getInternalHooks(HOOK_MARK), b = g.getInitialValue;
      return b(d.getNamePath()) !== void 0;
    }), _defineProperty$a(_assertThisInitialized(d), "getErrors", function() {
      return d.errors;
    }), _defineProperty$a(_assertThisInitialized(d), "getWarnings", function() {
      return d.warnings;
    }), _defineProperty$a(_assertThisInitialized(d), "isListField", function() {
      return d.props.isListField;
    }), _defineProperty$a(_assertThisInitialized(d), "isList", function() {
      return d.props.isList;
    }), _defineProperty$a(_assertThisInitialized(d), "isPreserve", function() {
      return d.props.preserve;
    }), _defineProperty$a(_assertThisInitialized(d), "getMeta", function() {
      d.prevValidating = d.isFieldValidating();
      var x = {
        touched: d.isFieldTouched(),
        validating: d.prevValidating,
        errors: d.errors,
        warnings: d.warnings,
        name: d.getNamePath(),
        validated: d.validatePromise === null
      };
      return x;
    }), _defineProperty$a(_assertThisInitialized(d), "getOnlyChild", function(x) {
      if (typeof x == "function") {
        var g = d.getMeta();
        return _objectSpread2$1(_objectSpread2$1({}, d.getOnlyChild(x(d.getControlled(), g, d.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var b = toArray$8(x);
      return b.length !== 1 || !/* @__PURE__ */ reactExports.isValidElement(b[0]) ? {
        child: b,
        isFunction: !1
      } : {
        child: b[0],
        isFunction: !1
      };
    }), _defineProperty$a(_assertThisInitialized(d), "getValue", function(x) {
      var g = d.props.fieldContext.getFieldsValue, b = d.getNamePath();
      return get$1(x || g(!0), b);
    }), _defineProperty$a(_assertThisInitialized(d), "getControlled", function() {
      var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = d.props, b = g.name, y = g.trigger, f = g.validateTrigger, m = g.getValueFromEvent, C = g.normalize, w = g.valuePropName, S = g.getValueProps, $ = g.fieldContext, T = f !== void 0 ? f : $.validateTrigger, I = d.getNamePath(), _ = $.getInternalHooks, E = $.getFieldsValue, R = _(HOOK_MARK), O = R.dispatch, L = d.getValue(), B = S || function(G) {
        return _defineProperty$a({}, w, G);
      }, F = x[y], M = b !== void 0 ? B(L) : {}, W = _objectSpread2$1(_objectSpread2$1({}, x), M);
      W[y] = function() {
        d.touched = !0, d.dirty = !0, d.triggerMetaEvent();
        for (var G, U = arguments.length, k = new Array(U), N = 0; N < U; N++)
          k[N] = arguments[N];
        m ? G = m.apply(void 0, k) : G = defaultGetValueFromEvent.apply(void 0, [w].concat(k)), C && (G = C(G, L, E(!0))), G !== L && O({
          type: "updateValue",
          namePath: I,
          value: G
        }), F && F.apply(void 0, k);
      };
      var j = toArray$7(T || []);
      return j.forEach(function(G) {
        var U = W[G];
        W[G] = function() {
          U && U.apply(void 0, arguments);
          var k = d.props.rules;
          k && k.length && O({
            type: "validateField",
            namePath: I,
            triggerName: G
          });
        };
      }), W;
    }), u.fieldContext) {
      var p = u.fieldContext.getInternalHooks, v = p(HOOK_MARK), A = v.initEntityValue;
      A(_assertThisInitialized(d));
    }
    return d;
  }
  return _createClass$1(c, [{
    key: "componentDidMount",
    value: function() {
      var d = this.props, p = d.shouldUpdate, v = d.fieldContext;
      if (this.mounted = !0, v) {
        var A = v.getInternalHooks, x = A(HOOK_MARK), g = x.registerField;
        this.cancelRegisterFunc = g(this);
      }
      p === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var d = this.state.resetCount, p = this.props.children, v = this.getOnlyChild(p), A = v.child, x = v.isFunction, g;
      return x ? g = A : /* @__PURE__ */ reactExports.isValidElement(A) ? g = /* @__PURE__ */ reactExports.cloneElement(A, this.getControlled(A.props)) : (warningOnce(!A, "`children` of Field is not validate ReactElement."), g = A), /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, {
        key: d
      }, g);
    }
  }]), c;
}(reactExports.Component);
_defineProperty$a(Field, "contextType", Context$2);
_defineProperty$a(Field, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function WrapperField(a) {
  var s, c = a.name, u = _objectWithoutProperties$2(a, _excluded$X), d = reactExports.useContext(Context$2), p = reactExports.useContext(ListContext), v = c !== void 0 ? getNamePath(c) : void 0, A = (s = u.isListField) !== null && s !== void 0 ? s : !!p, x = "keep";
  return A || (x = "_".concat((v || []).join("_"))), /* @__PURE__ */ reactExports.createElement(Field, _extends$3({
    key: x,
    name: v,
    isListField: A
  }, u, {
    fieldContext: d
  }));
}
function List$1(a) {
  var s = a.name, c = a.initialValue, u = a.children, d = a.rules, p = a.validateTrigger, v = a.isListField, A = reactExports.useContext(Context$2), x = reactExports.useContext(ListContext), g = reactExports.useRef({
    keys: [],
    id: 0
  }), b = g.current, y = reactExports.useMemo(function() {
    var w = getNamePath(A.prefixName) || [];
    return [].concat(_toConsumableArray$e(w), _toConsumableArray$e(getNamePath(s)));
  }, [A.prefixName, s]), f = reactExports.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, A), {}, {
      prefixName: y
    });
  }, [A, y]), m = reactExports.useMemo(function() {
    return {
      getKey: function(S) {
        var $ = y.length, T = S[$];
        return [b.keys[T], S.slice($ + 1)];
      }
    };
  }, [y]);
  if (typeof u != "function")
    return warningOnce(!1, "Form.List only accepts function as children."), null;
  var C = function(S, $, T) {
    var I = T.source;
    return I === "internal" ? !1 : S !== $;
  };
  return /* @__PURE__ */ reactExports.createElement(ListContext.Provider, {
    value: m
  }, /* @__PURE__ */ reactExports.createElement(Context$2.Provider, {
    value: f
  }, /* @__PURE__ */ reactExports.createElement(WrapperField, {
    name: [],
    shouldUpdate: C,
    rules: d,
    validateTrigger: p,
    initialValue: c,
    isList: !0,
    isListField: v ?? !!x
  }, function(w, S) {
    var $ = w.value, T = $ === void 0 ? [] : $, I = w.onChange, _ = A.getFieldValue, E = function() {
      var B = _(y || []);
      return B || [];
    }, R = {
      add: function(B, F) {
        var M = E();
        F >= 0 && F <= M.length ? (b.keys = [].concat(_toConsumableArray$e(b.keys.slice(0, F)), [b.id], _toConsumableArray$e(b.keys.slice(F))), I([].concat(_toConsumableArray$e(M.slice(0, F)), [B], _toConsumableArray$e(M.slice(F))))) : (b.keys = [].concat(_toConsumableArray$e(b.keys), [b.id]), I([].concat(_toConsumableArray$e(M), [B]))), b.id += 1;
      },
      remove: function(B) {
        var F = E(), M = new Set(Array.isArray(B) ? B : [B]);
        M.size <= 0 || (b.keys = b.keys.filter(function(W, j) {
          return !M.has(j);
        }), I(F.filter(function(W, j) {
          return !M.has(j);
        })));
      },
      move: function(B, F) {
        if (B !== F) {
          var M = E();
          B < 0 || B >= M.length || F < 0 || F >= M.length || (b.keys = move(b.keys, B, F), I(move(M, B, F)));
        }
      }
    }, O = T || [];
    return Array.isArray(O) || (O = []), u(O.map(function(L, B) {
      var F = b.keys[B];
      return F === void 0 && (b.keys[B] = b.id, F = b.keys[B], b.id += 1), {
        name: B,
        key: F,
        isListField: !0
      };
    }), R, S);
  })));
}
function allPromiseFinish(a) {
  var s = !1, c = a.length, u = [];
  return a.length ? new Promise(function(d, p) {
    a.forEach(function(v, A) {
      v.catch(function(x) {
        return s = !0, x;
      }).then(function(x) {
        c -= 1, u[A] = x, !(c > 0) && (s && p(u), d(u));
      });
    });
  }) : Promise.resolve([]);
}
var SPLIT = "__@field_split__";
function normalize(a) {
  return a.map(function(s) {
    return "".concat(_typeof$h(s), ":").concat(s);
  }).join(SPLIT);
}
var NameMap = /* @__PURE__ */ function() {
  function a() {
    _classCallCheck$1(this, a), _defineProperty$a(this, "kvs", /* @__PURE__ */ new Map());
  }
  return _createClass$1(a, [{
    key: "set",
    value: function(c, u) {
      this.kvs.set(normalize(c), u);
    }
  }, {
    key: "get",
    value: function(c) {
      return this.kvs.get(normalize(c));
    }
  }, {
    key: "update",
    value: function(c, u) {
      var d = this.get(c), p = u(d);
      p ? this.set(c, p) : this.delete(c);
    }
  }, {
    key: "delete",
    value: function(c) {
      this.kvs.delete(normalize(c));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(c) {
      return _toConsumableArray$e(this.kvs.entries()).map(function(u) {
        var d = _slicedToArray$e(u, 2), p = d[0], v = d[1], A = p.split(SPLIT);
        return c({
          key: A.map(function(x) {
            var g = x.match(/^([^:]*):(.*)$/), b = _slicedToArray$e(g, 3), y = b[1], f = b[2];
            return y === "number" ? Number(f) : f;
          }),
          value: v
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var c = {};
      return this.map(function(u) {
        var d = u.key, p = u.value;
        return c[d.join(".")] = p, null;
      }), c;
    }
  }]), a;
}(), _excluded$W = ["name"], FormStore = /* @__PURE__ */ _createClass$1(function a(s) {
  var c = this;
  _classCallCheck$1(this, a), _defineProperty$a(this, "formHooked", !1), _defineProperty$a(this, "forceRootUpdate", void 0), _defineProperty$a(this, "subscribable", !0), _defineProperty$a(this, "store", {}), _defineProperty$a(this, "fieldEntities", []), _defineProperty$a(this, "initialValues", {}), _defineProperty$a(this, "callbacks", {}), _defineProperty$a(this, "validateMessages", null), _defineProperty$a(this, "preserve", null), _defineProperty$a(this, "lastValidatePromise", null), _defineProperty$a(this, "getForm", function() {
    return {
      getFieldValue: c.getFieldValue,
      getFieldsValue: c.getFieldsValue,
      getFieldError: c.getFieldError,
      getFieldWarning: c.getFieldWarning,
      getFieldsError: c.getFieldsError,
      isFieldsTouched: c.isFieldsTouched,
      isFieldTouched: c.isFieldTouched,
      isFieldValidating: c.isFieldValidating,
      isFieldsValidating: c.isFieldsValidating,
      resetFields: c.resetFields,
      setFields: c.setFields,
      setFieldValue: c.setFieldValue,
      setFieldsValue: c.setFieldsValue,
      validateFields: c.validateFields,
      submit: c.submit,
      _init: !0,
      getInternalHooks: c.getInternalHooks
    };
  }), _defineProperty$a(this, "getInternalHooks", function(u) {
    return u === HOOK_MARK ? (c.formHooked = !0, {
      dispatch: c.dispatch,
      initEntityValue: c.initEntityValue,
      registerField: c.registerField,
      useSubscribe: c.useSubscribe,
      setInitialValues: c.setInitialValues,
      destroyForm: c.destroyForm,
      setCallbacks: c.setCallbacks,
      setValidateMessages: c.setValidateMessages,
      getFields: c.getFields,
      setPreserve: c.setPreserve,
      getInitialValue: c.getInitialValue,
      registerWatch: c.registerWatch
    }) : (warningOnce(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), _defineProperty$a(this, "useSubscribe", function(u) {
    c.subscribable = u;
  }), _defineProperty$a(this, "prevWithoutPreserves", null), _defineProperty$a(this, "setInitialValues", function(u, d) {
    if (c.initialValues = u || {}, d) {
      var p, v = merge$1(u, c.store);
      (p = c.prevWithoutPreserves) === null || p === void 0 || p.map(function(A) {
        var x = A.key;
        v = set$1(v, x, get$1(u, x));
      }), c.prevWithoutPreserves = null, c.updateStore(v);
    }
  }), _defineProperty$a(this, "destroyForm", function(u) {
    if (u)
      c.updateStore({});
    else {
      var d = new NameMap();
      c.getFieldEntities(!0).forEach(function(p) {
        c.isMergedPreserve(p.isPreserve()) || d.set(p.getNamePath(), !0);
      }), c.prevWithoutPreserves = d;
    }
  }), _defineProperty$a(this, "getInitialValue", function(u) {
    var d = get$1(c.initialValues, u);
    return u.length ? merge$1(d) : d;
  }), _defineProperty$a(this, "setCallbacks", function(u) {
    c.callbacks = u;
  }), _defineProperty$a(this, "setValidateMessages", function(u) {
    c.validateMessages = u;
  }), _defineProperty$a(this, "setPreserve", function(u) {
    c.preserve = u;
  }), _defineProperty$a(this, "watchList", []), _defineProperty$a(this, "registerWatch", function(u) {
    return c.watchList.push(u), function() {
      c.watchList = c.watchList.filter(function(d) {
        return d !== u;
      });
    };
  }), _defineProperty$a(this, "notifyWatch", function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (c.watchList.length) {
      var d = c.getFieldsValue(), p = c.getFieldsValue(!0);
      c.watchList.forEach(function(v) {
        v(d, p, u);
      });
    }
  }), _defineProperty$a(this, "timeoutId", null), _defineProperty$a(this, "warningUnhooked", function() {
  }), _defineProperty$a(this, "updateStore", function(u) {
    c.store = u;
  }), _defineProperty$a(this, "getFieldEntities", function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return u ? c.fieldEntities.filter(function(d) {
      return d.getNamePath().length;
    }) : c.fieldEntities;
  }), _defineProperty$a(this, "getFieldsMap", function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, d = new NameMap();
    return c.getFieldEntities(u).forEach(function(p) {
      var v = p.getNamePath();
      d.set(v, p);
    }), d;
  }), _defineProperty$a(this, "getFieldEntitiesForNamePathList", function(u) {
    if (!u)
      return c.getFieldEntities(!0);
    var d = c.getFieldsMap(!0);
    return u.map(function(p) {
      var v = getNamePath(p);
      return d.get(v) || {
        INVALIDATE_NAME_PATH: getNamePath(p)
      };
    });
  }), _defineProperty$a(this, "getFieldsValue", function(u, d) {
    c.warningUnhooked();
    var p, v, A;
    if (u === !0 || Array.isArray(u) ? (p = u, v = d) : u && _typeof$h(u) === "object" && (A = u.strict, v = u.filter), p === !0 && !v)
      return c.store;
    var x = c.getFieldEntitiesForNamePathList(Array.isArray(p) ? p : null), g = [];
    return x.forEach(function(b) {
      var y, f, m = "INVALIDATE_NAME_PATH" in b ? b.INVALIDATE_NAME_PATH : b.getNamePath();
      if (A) {
        var C, w;
        if ((C = (w = b).isList) !== null && C !== void 0 && C.call(w))
          return;
      } else if (!p && (y = (f = b).isListField) !== null && y !== void 0 && y.call(f))
        return;
      if (!v)
        g.push(m);
      else {
        var S = "getMeta" in b ? b.getMeta() : null;
        v(S) && g.push(m);
      }
    }), cloneByNamePathList(c.store, g.map(getNamePath));
  }), _defineProperty$a(this, "getFieldValue", function(u) {
    c.warningUnhooked();
    var d = getNamePath(u);
    return get$1(c.store, d);
  }), _defineProperty$a(this, "getFieldsError", function(u) {
    c.warningUnhooked();
    var d = c.getFieldEntitiesForNamePathList(u);
    return d.map(function(p, v) {
      return p && !("INVALIDATE_NAME_PATH" in p) ? {
        name: p.getNamePath(),
        errors: p.getErrors(),
        warnings: p.getWarnings()
      } : {
        name: getNamePath(u[v]),
        errors: [],
        warnings: []
      };
    });
  }), _defineProperty$a(this, "getFieldError", function(u) {
    c.warningUnhooked();
    var d = getNamePath(u), p = c.getFieldsError([d])[0];
    return p.errors;
  }), _defineProperty$a(this, "getFieldWarning", function(u) {
    c.warningUnhooked();
    var d = getNamePath(u), p = c.getFieldsError([d])[0];
    return p.warnings;
  }), _defineProperty$a(this, "isFieldsTouched", function() {
    c.warningUnhooked();
    for (var u = arguments.length, d = new Array(u), p = 0; p < u; p++)
      d[p] = arguments[p];
    var v = d[0], A = d[1], x, g = !1;
    d.length === 0 ? x = null : d.length === 1 ? Array.isArray(v) ? (x = v.map(getNamePath), g = !1) : (x = null, g = v) : (x = v.map(getNamePath), g = A);
    var b = c.getFieldEntities(!0), y = function(S) {
      return S.isFieldTouched();
    };
    if (!x)
      return g ? b.every(function(w) {
        return y(w) || w.isList();
      }) : b.some(y);
    var f = new NameMap();
    x.forEach(function(w) {
      f.set(w, []);
    }), b.forEach(function(w) {
      var S = w.getNamePath();
      x.forEach(function($) {
        $.every(function(T, I) {
          return S[I] === T;
        }) && f.update($, function(T) {
          return [].concat(_toConsumableArray$e(T), [w]);
        });
      });
    });
    var m = function(S) {
      return S.some(y);
    }, C = f.map(function(w) {
      var S = w.value;
      return S;
    });
    return g ? C.every(m) : C.some(m);
  }), _defineProperty$a(this, "isFieldTouched", function(u) {
    return c.warningUnhooked(), c.isFieldsTouched([u]);
  }), _defineProperty$a(this, "isFieldsValidating", function(u) {
    c.warningUnhooked();
    var d = c.getFieldEntities();
    if (!u)
      return d.some(function(v) {
        return v.isFieldValidating();
      });
    var p = u.map(getNamePath);
    return d.some(function(v) {
      var A = v.getNamePath();
      return containsNamePath(p, A) && v.isFieldValidating();
    });
  }), _defineProperty$a(this, "isFieldValidating", function(u) {
    return c.warningUnhooked(), c.isFieldsValidating([u]);
  }), _defineProperty$a(this, "resetWithFieldInitialValue", function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = new NameMap(), p = c.getFieldEntities(!0);
    p.forEach(function(x) {
      var g = x.props.initialValue, b = x.getNamePath();
      if (g !== void 0) {
        var y = d.get(b) || /* @__PURE__ */ new Set();
        y.add({
          entity: x,
          value: g
        }), d.set(b, y);
      }
    });
    var v = function(g) {
      g.forEach(function(b) {
        var y = b.props.initialValue;
        if (y !== void 0) {
          var f = b.getNamePath(), m = c.getInitialValue(f);
          if (m !== void 0)
            warningOnce(!1, "Form already set 'initialValues' with path '".concat(f.join("."), "'. Field can not overwrite it."));
          else {
            var C = d.get(f);
            if (C && C.size > 1)
              warningOnce(!1, "Multiple Field with path '".concat(f.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (C) {
              var w = c.getFieldValue(f), S = b.isListField();
              !S && (!u.skipExist || w === void 0) && c.updateStore(set$1(c.store, f, _toConsumableArray$e(C)[0].value));
            }
          }
        }
      });
    }, A;
    u.entities ? A = u.entities : u.namePathList ? (A = [], u.namePathList.forEach(function(x) {
      var g = d.get(x);
      if (g) {
        var b;
        (b = A).push.apply(b, _toConsumableArray$e(_toConsumableArray$e(g).map(function(y) {
          return y.entity;
        })));
      }
    })) : A = p, v(A);
  }), _defineProperty$a(this, "resetFields", function(u) {
    c.warningUnhooked();
    var d = c.store;
    if (!u) {
      c.updateStore(merge$1(c.initialValues)), c.resetWithFieldInitialValue(), c.notifyObservers(d, null, {
        type: "reset"
      }), c.notifyWatch();
      return;
    }
    var p = u.map(getNamePath);
    p.forEach(function(v) {
      var A = c.getInitialValue(v);
      c.updateStore(set$1(c.store, v, A));
    }), c.resetWithFieldInitialValue({
      namePathList: p
    }), c.notifyObservers(d, p, {
      type: "reset"
    }), c.notifyWatch(p);
  }), _defineProperty$a(this, "setFields", function(u) {
    c.warningUnhooked();
    var d = c.store, p = [];
    u.forEach(function(v) {
      var A = v.name, x = _objectWithoutProperties$2(v, _excluded$W), g = getNamePath(A);
      p.push(g), "value" in x && c.updateStore(set$1(c.store, g, x.value)), c.notifyObservers(d, [g], {
        type: "setField",
        data: v
      });
    }), c.notifyWatch(p);
  }), _defineProperty$a(this, "getFields", function() {
    var u = c.getFieldEntities(!0), d = u.map(function(p) {
      var v = p.getNamePath(), A = p.getMeta(), x = _objectSpread2$1(_objectSpread2$1({}, A), {}, {
        name: v,
        value: c.getFieldValue(v)
      });
      return Object.defineProperty(x, "originRCField", {
        value: !0
      }), x;
    });
    return d;
  }), _defineProperty$a(this, "initEntityValue", function(u) {
    var d = u.props.initialValue;
    if (d !== void 0) {
      var p = u.getNamePath(), v = get$1(c.store, p);
      v === void 0 && c.updateStore(set$1(c.store, p, d));
    }
  }), _defineProperty$a(this, "isMergedPreserve", function(u) {
    var d = u !== void 0 ? u : c.preserve;
    return d ?? !0;
  }), _defineProperty$a(this, "registerField", function(u) {
    c.fieldEntities.push(u);
    var d = u.getNamePath();
    if (c.notifyWatch([d]), u.props.initialValue !== void 0) {
      var p = c.store;
      c.resetWithFieldInitialValue({
        entities: [u],
        skipExist: !0
      }), c.notifyObservers(p, [u.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(v, A) {
      var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (c.fieldEntities = c.fieldEntities.filter(function(y) {
        return y !== u;
      }), !c.isMergedPreserve(A) && (!v || x.length > 1)) {
        var g = v ? void 0 : c.getInitialValue(d);
        if (d.length && c.getFieldValue(d) !== g && c.fieldEntities.every(function(y) {
          return (
            // Only reset when no namePath exist
            !matchNamePath(y.getNamePath(), d)
          );
        })) {
          var b = c.store;
          c.updateStore(set$1(b, d, g, !0)), c.notifyObservers(b, [d], {
            type: "remove"
          }), c.triggerDependenciesUpdate(b, d);
        }
      }
      c.notifyWatch([d]);
    };
  }), _defineProperty$a(this, "dispatch", function(u) {
    switch (u.type) {
      case "updateValue": {
        var d = u.namePath, p = u.value;
        c.updateValue(d, p);
        break;
      }
      case "validateField": {
        var v = u.namePath, A = u.triggerName;
        c.validateFields([v], {
          triggerName: A
        });
        break;
      }
    }
  }), _defineProperty$a(this, "notifyObservers", function(u, d, p) {
    if (c.subscribable) {
      var v = _objectSpread2$1(_objectSpread2$1({}, p), {}, {
        store: c.getFieldsValue(!0)
      });
      c.getFieldEntities().forEach(function(A) {
        var x = A.onStoreChange;
        x(u, d, v);
      });
    } else
      c.forceRootUpdate();
  }), _defineProperty$a(this, "triggerDependenciesUpdate", function(u, d) {
    var p = c.getDependencyChildrenFields(d);
    return p.length && c.validateFields(p), c.notifyObservers(u, p, {
      type: "dependenciesUpdate",
      relatedFields: [d].concat(_toConsumableArray$e(p))
    }), p;
  }), _defineProperty$a(this, "updateValue", function(u, d) {
    var p = getNamePath(u), v = c.store;
    c.updateStore(set$1(c.store, p, d)), c.notifyObservers(v, [p], {
      type: "valueUpdate",
      source: "internal"
    }), c.notifyWatch([p]);
    var A = c.triggerDependenciesUpdate(v, p), x = c.callbacks.onValuesChange;
    if (x) {
      var g = cloneByNamePathList(c.store, [p]);
      x(g, c.getFieldsValue());
    }
    c.triggerOnFieldsChange([p].concat(_toConsumableArray$e(A)));
  }), _defineProperty$a(this, "setFieldsValue", function(u) {
    c.warningUnhooked();
    var d = c.store;
    if (u) {
      var p = merge$1(c.store, u);
      c.updateStore(p);
    }
    c.notifyObservers(d, null, {
      type: "valueUpdate",
      source: "external"
    }), c.notifyWatch();
  }), _defineProperty$a(this, "setFieldValue", function(u, d) {
    c.setFields([{
      name: u,
      value: d,
      errors: [],
      warnings: []
    }]);
  }), _defineProperty$a(this, "getDependencyChildrenFields", function(u) {
    var d = /* @__PURE__ */ new Set(), p = [], v = new NameMap();
    c.getFieldEntities().forEach(function(x) {
      var g = x.props.dependencies;
      (g || []).forEach(function(b) {
        var y = getNamePath(b);
        v.update(y, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(x), f;
        });
      });
    });
    var A = function x(g) {
      var b = v.get(g) || /* @__PURE__ */ new Set();
      b.forEach(function(y) {
        if (!d.has(y)) {
          d.add(y);
          var f = y.getNamePath();
          y.isFieldDirty() && f.length && (p.push(f), x(f));
        }
      });
    };
    return A(u), p;
  }), _defineProperty$a(this, "triggerOnFieldsChange", function(u, d) {
    var p = c.callbacks.onFieldsChange;
    if (p) {
      var v = c.getFields();
      if (d) {
        var A = new NameMap();
        d.forEach(function(g) {
          var b = g.name, y = g.errors;
          A.set(b, y);
        }), v.forEach(function(g) {
          g.errors = A.get(g.name) || g.errors;
        });
      }
      var x = v.filter(function(g) {
        var b = g.name;
        return containsNamePath(u, b);
      });
      x.length && p(x, v);
    }
  }), _defineProperty$a(this, "validateFields", function(u, d) {
    c.warningUnhooked();
    var p, v;
    Array.isArray(u) || typeof u == "string" || typeof d == "string" ? (p = u, v = d) : v = u;
    var A = !!p, x = A ? p.map(getNamePath) : [], g = [], b = String(Date.now()), y = /* @__PURE__ */ new Set(), f = v || {}, m = f.recursive, C = f.dirty;
    c.getFieldEntities(!0).forEach(function(T) {
      if (A || x.push(T.getNamePath()), !(!T.props.rules || !T.props.rules.length) && !(C && !T.isFieldDirty())) {
        var I = T.getNamePath();
        if (y.add(I.join(b)), !A || containsNamePath(x, I, m)) {
          var _ = T.validateRules(_objectSpread2$1({
            validateMessages: _objectSpread2$1(_objectSpread2$1({}, defaultValidateMessages), c.validateMessages)
          }, v));
          g.push(_.then(function() {
            return {
              name: I,
              errors: [],
              warnings: []
            };
          }).catch(function(E) {
            var R, O = [], L = [];
            return (R = E.forEach) === null || R === void 0 || R.call(E, function(B) {
              var F = B.rule.warningOnly, M = B.errors;
              F ? L.push.apply(L, _toConsumableArray$e(M)) : O.push.apply(O, _toConsumableArray$e(M));
            }), O.length ? Promise.reject({
              name: I,
              errors: O,
              warnings: L
            }) : {
              name: I,
              errors: O,
              warnings: L
            };
          }));
        }
      }
    });
    var w = allPromiseFinish(g);
    c.lastValidatePromise = w, w.catch(function(T) {
      return T;
    }).then(function(T) {
      var I = T.map(function(_) {
        var E = _.name;
        return E;
      });
      c.notifyObservers(c.store, I, {
        type: "validateFinish"
      }), c.triggerOnFieldsChange(I, T);
    });
    var S = w.then(function() {
      return c.lastValidatePromise === w ? Promise.resolve(c.getFieldsValue(x)) : Promise.reject([]);
    }).catch(function(T) {
      var I = T.filter(function(_) {
        return _ && _.errors.length;
      });
      return Promise.reject({
        values: c.getFieldsValue(x),
        errorFields: I,
        outOfDate: c.lastValidatePromise !== w
      });
    });
    S.catch(function(T) {
      return T;
    });
    var $ = x.filter(function(T) {
      return y.has(T.join(b));
    });
    return c.triggerOnFieldsChange($), S;
  }), _defineProperty$a(this, "submit", function() {
    c.warningUnhooked(), c.validateFields().then(function(u) {
      var d = c.callbacks.onFinish;
      if (d)
        try {
          d(u);
        } catch (p) {
          console.error(p);
        }
    }).catch(function(u) {
      var d = c.callbacks.onFinishFailed;
      d && d(u);
    });
  }), this.forceRootUpdate = s;
});
function useForm$2(a) {
  var s = reactExports.useRef(), c = reactExports.useState({}), u = _slicedToArray$e(c, 2), d = u[1];
  if (!s.current)
    if (a)
      s.current = a;
    else {
      var p = function() {
        d({});
      }, v = new FormStore(p);
      s.current = v.getForm();
    }
  return [s.current];
}
var FormContext$1 = /* @__PURE__ */ reactExports.createContext({
  triggerFormChange: function a() {
  },
  triggerFormFinish: function a() {
  },
  registerForm: function a() {
  },
  unregisterForm: function a() {
  }
}), FormProvider$1 = function a(s) {
  var c = s.validateMessages, u = s.onFormChange, d = s.onFormFinish, p = s.children, v = reactExports.useContext(FormContext$1), A = reactExports.useRef({});
  return /* @__PURE__ */ reactExports.createElement(FormContext$1.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, v), {}, {
      validateMessages: _objectSpread2$1(_objectSpread2$1({}, v.validateMessages), c),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(g, b) {
        u && u(g, {
          changedFields: b,
          forms: A.current
        }), v.triggerFormChange(g, b);
      },
      triggerFormFinish: function(g, b) {
        d && d(g, {
          values: b,
          forms: A.current
        }), v.triggerFormFinish(g, b);
      },
      registerForm: function(g, b) {
        g && (A.current = _objectSpread2$1(_objectSpread2$1({}, A.current), {}, _defineProperty$a({}, g, b))), v.registerForm(g, b);
      },
      unregisterForm: function(g) {
        var b = _objectSpread2$1({}, A.current);
        delete b[g], A.current = b, v.unregisterForm(g);
      }
    })
  }, p);
}, _excluded$V = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], Form$3 = function a(s, c) {
  var u = s.name, d = s.initialValues, p = s.fields, v = s.form, A = s.preserve, x = s.children, g = s.component, b = g === void 0 ? "form" : g, y = s.validateMessages, f = s.validateTrigger, m = f === void 0 ? "onChange" : f, C = s.onValuesChange, w = s.onFieldsChange, S = s.onFinish, $ = s.onFinishFailed, T = s.clearOnDestroy, I = _objectWithoutProperties$2(s, _excluded$V), _ = reactExports.useRef(null), E = reactExports.useContext(FormContext$1), R = useForm$2(v), O = _slicedToArray$e(R, 1), L = O[0], B = L.getInternalHooks(HOOK_MARK), F = B.useSubscribe, M = B.setInitialValues, W = B.setCallbacks, j = B.setValidateMessages, G = B.setPreserve, U = B.destroyForm;
  reactExports.useImperativeHandle(c, function() {
    return _objectSpread2$1(_objectSpread2$1({}, L), {}, {
      nativeElement: _.current
    });
  }), reactExports.useEffect(function() {
    return E.registerForm(u, L), function() {
      E.unregisterForm(u);
    };
  }, [E, L, u]), j(_objectSpread2$1(_objectSpread2$1({}, E.validateMessages), y)), W({
    onValuesChange: C,
    onFieldsChange: function(K) {
      if (E.triggerFormChange(u, K), w) {
        for (var q = arguments.length, Y = new Array(q > 1 ? q - 1 : 0), ee = 1; ee < q; ee++)
          Y[ee - 1] = arguments[ee];
        w.apply(void 0, [K].concat(Y));
      }
    },
    onFinish: function(K) {
      E.triggerFormFinish(u, K), S && S(K);
    },
    onFinishFailed: $
  }), G(A);
  var k = reactExports.useRef(null);
  M(d, !k.current), k.current || (k.current = !0), reactExports.useEffect(
    function() {
      return function() {
        return U(T);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var N, P = typeof x == "function";
  if (P) {
    var D = L.getFieldsValue(!0);
    N = x(D, L);
  } else
    N = x;
  F(!P);
  var H = reactExports.useRef();
  reactExports.useEffect(function() {
    isSimilar(H.current || [], p || []) || L.setFields(p || []), H.current = p;
  }, [p, L]);
  var V = reactExports.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, L), {}, {
      validateTrigger: m
    });
  }, [L, m]), Z = /* @__PURE__ */ reactExports.createElement(ListContext.Provider, {
    value: null
  }, /* @__PURE__ */ reactExports.createElement(Context$2.Provider, {
    value: V
  }, N));
  return b === !1 ? Z : /* @__PURE__ */ reactExports.createElement(b, _extends$3({}, I, {
    ref: _,
    onSubmit: function(K) {
      K.preventDefault(), K.stopPropagation(), L.submit();
    },
    onReset: function(K) {
      var q;
      K.preventDefault(), L.resetFields(), (q = I.onReset) === null || q === void 0 || q.call(I, K);
    }
  }), Z);
};
function stringify$1(a) {
  try {
    return JSON.stringify(a);
  } catch {
    return Math.random();
  }
}
function useWatch$1() {
  for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
    s[c] = arguments[c];
  var u = s[0], d = s[1], p = d === void 0 ? {} : d, v = isFormInstance(p) ? {
    form: p
  } : p, A = v.form, x = reactExports.useState(), g = _slicedToArray$e(x, 2), b = g[0], y = g[1], f = reactExports.useMemo(function() {
    return stringify$1(b);
  }, [b]), m = reactExports.useRef(f);
  m.current = f;
  var C = reactExports.useContext(Context$2), w = A || C, S = w && w._init, $ = getNamePath(u), T = reactExports.useRef($);
  return T.current = $, reactExports.useEffect(
    function() {
      if (S) {
        var I = w.getFieldsValue, _ = w.getInternalHooks, E = _(HOOK_MARK), R = E.registerWatch, O = function(M, W) {
          var j = v.preserve ? W : M;
          return typeof u == "function" ? u(j) : get$1(j, T.current);
        }, L = R(function(F, M) {
          var W = O(F, M), j = stringify$1(W);
          m.current !== j && (m.current = j, y(W));
        }), B = O(I(), I(!0));
        return b !== B && y(B), L;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S]
  ), b;
}
var InternalForm$1 = /* @__PURE__ */ reactExports.forwardRef(Form$3), RefForm = InternalForm$1;
RefForm.FormProvider = FormProvider$1;
RefForm.Field = WrapperField;
RefForm.List = List$1;
RefForm.useForm = useForm$2;
RefForm.useWatch = useWatch$1;
const FormContext = /* @__PURE__ */ reactExports.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: () => {
  }
}), NoStyleItemContext = /* @__PURE__ */ reactExports.createContext(null), FormProvider = (a) => {
  const s = omit(a, ["prefixCls"]);
  return /* @__PURE__ */ reactExports.createElement(FormProvider$1, Object.assign({}, s));
}, FormItemPrefixContext = /* @__PURE__ */ reactExports.createContext({
  prefixCls: ""
}), FormItemInputContext = /* @__PURE__ */ reactExports.createContext({}), NoFormStyle = ({
  children: a,
  status: s,
  override: c
}) => {
  const u = reactExports.useContext(FormItemInputContext), d = reactExports.useMemo(() => {
    const p = Object.assign({}, u);
    return c && delete p.isFormItemInput, s && (delete p.status, delete p.hasFeedback, delete p.feedbackIcon), p;
  }, [s, c, u]);
  return /* @__PURE__ */ reactExports.createElement(FormItemInputContext.Provider, {
    value: d
  }, a);
}, VariantContext = /* @__PURE__ */ reactExports.createContext(void 0), ContextIsolator = (a) => {
  const {
    space: s,
    form: c,
    children: u
  } = a;
  if (u == null)
    return null;
  let d = u;
  return c && (d = /* @__PURE__ */ React.createElement(NoFormStyle, {
    override: !0,
    status: !0
  }, d)), s && (d = /* @__PURE__ */ React.createElement(NoCompactStyle, null, d)), d;
};
function mergeProps$1(...a) {
  const s = {};
  return a.forEach((c) => {
    c && Object.keys(c).forEach((u) => {
      c[u] !== void 0 && (s[u] = c[u]);
    });
  }), s;
}
function pickClosable(a) {
  if (a)
    return {
      closable: a.closable,
      closeIcon: a.closeIcon
    };
}
function useClosableConfig(a) {
  const {
    closable: s,
    closeIcon: c
  } = a || {};
  return React.useMemo(() => {
    if (
      // If `closable`, whatever rest be should be true
      !s && (s === !1 || c === !1 || c === null)
    )
      return !1;
    if (s === void 0 && c === void 0)
      return null;
    let u = {
      closeIcon: typeof c != "boolean" && c !== null ? c : void 0
    };
    return s && typeof s == "object" && (u = Object.assign(Object.assign({}, u), s)), u;
  }, [s, c]);
}
const EmptyFallbackCloseCollection = {};
function useClosable(a, s, c = EmptyFallbackCloseCollection) {
  const u = useClosableConfig(a), d = useClosableConfig(s), [p] = useLocale$1("global", localeValues.global), v = typeof u != "boolean" ? !!u?.disabled : !1, A = React.useMemo(() => Object.assign({
    closeIcon: /* @__PURE__ */ React.createElement(RefIcon$I, null)
  }, c), [c]), x = React.useMemo(() => u === !1 ? !1 : u ? mergeProps$1(A, d, u) : d === !1 ? !1 : d ? mergeProps$1(A, d) : A.closable ? A : !1, [u, d, A]);
  return React.useMemo(() => {
    if (x === !1)
      return [!1, null, v, {}];
    const {
      closeIconRender: g
    } = A, {
      closeIcon: b
    } = x;
    let y = b;
    const f = pickAttrs(x, !0);
    return y != null && (g && (y = g(b)), y = /* @__PURE__ */ React.isValidElement(y) ? /* @__PURE__ */ React.cloneElement(y, Object.assign({
      "aria-label": p.close
    }, f)) : /* @__PURE__ */ React.createElement("span", Object.assign({
      "aria-label": p.close
    }, f), y)), [!0, y, v, f];
  }, [x, A]);
}
var isStyleNameSupport = function a(s) {
  if (canUseDom$1() && window.document.documentElement) {
    var c = Array.isArray(s) ? s : [s], u = window.document.documentElement;
    return c.some(function(d) {
      return d in u.style;
    });
  }
  return !1;
}, isStyleValueSupport = function a(s, c) {
  if (!isStyleNameSupport(s))
    return !1;
  var u = document.createElement("div"), d = u.style[s];
  return u.style[s] = c, u.style[s] !== d;
};
function isStyleSupport(a, s) {
  return !Array.isArray(a) && s !== void 0 ? isStyleValueSupport(a, s) : isStyleNameSupport(a);
}
const Element$1 = (a) => {
  const {
    prefixCls: s,
    className: c,
    style: u,
    size: d,
    shape: p
  } = a, v = classnames({
    [`${s}-lg`]: d === "large",
    [`${s}-sm`]: d === "small"
  }), A = classnames({
    [`${s}-circle`]: p === "circle",
    [`${s}-square`]: p === "square",
    [`${s}-round`]: p === "round"
  }), x = reactExports.useMemo(() => typeof d == "number" ? {
    width: d,
    height: d,
    lineHeight: `${d}px`
  } : {}, [d]);
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(s, v, A, c),
    style: Object.assign(Object.assign({}, x), u)
  });
}, skeletonClsLoading = new Keyframe("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), genSkeletonElementCommonSize = (a) => ({
  height: a,
  lineHeight: unit$1(a)
}), genSkeletonElementAvatarSize = (a) => Object.assign({
  width: a
}, genSkeletonElementCommonSize(a)), genSkeletonColor = (a) => ({
  background: a.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: skeletonClsLoading,
  animationDuration: a.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), genSkeletonElementInputSize = (a, s) => Object.assign({
  width: s(a).mul(5).equal(),
  minWidth: s(a).mul(5).equal()
}, genSkeletonElementCommonSize(a)), genSkeletonElementAvatar = (a) => {
  const {
    skeletonAvatarCls: s,
    gradientFromColor: c,
    controlHeight: u,
    controlHeightLG: d,
    controlHeightSM: p
  } = a;
  return {
    [s]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: c
    }, genSkeletonElementAvatarSize(u)),
    [`${s}${s}-circle`]: {
      borderRadius: "50%"
    },
    [`${s}${s}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(d)),
    [`${s}${s}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(p))
  };
}, genSkeletonElementInput = (a) => {
  const {
    controlHeight: s,
    borderRadiusSM: c,
    skeletonInputCls: u,
    controlHeightLG: d,
    controlHeightSM: p,
    gradientFromColor: v,
    calc: A
  } = a;
  return {
    [u]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: v,
      borderRadius: c
    }, genSkeletonElementInputSize(s, A)),
    [`${u}-lg`]: Object.assign({}, genSkeletonElementInputSize(d, A)),
    [`${u}-sm`]: Object.assign({}, genSkeletonElementInputSize(p, A))
  };
}, genSkeletonElementImageSize = (a) => Object.assign({
  width: a
}, genSkeletonElementCommonSize(a)), genSkeletonElementImage = (a) => {
  const {
    skeletonImageCls: s,
    imageSizeBase: c,
    gradientFromColor: u,
    borderRadiusSM: d,
    calc: p
  } = a;
  return {
    [s]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: u,
      borderRadius: d
    }, genSkeletonElementImageSize(p(c).mul(2).equal())), {
      [`${s}-path`]: {
        fill: "#bfbfbf"
      },
      [`${s}-svg`]: Object.assign(Object.assign({}, genSkeletonElementImageSize(c)), {
        maxWidth: p(c).mul(4).equal(),
        maxHeight: p(c).mul(4).equal()
      }),
      [`${s}-svg${s}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${s}${s}-circle`]: {
      borderRadius: "50%"
    }
  };
}, genSkeletonElementButtonShape = (a, s, c) => {
  const {
    skeletonButtonCls: u
  } = a;
  return {
    [`${c}${u}-circle`]: {
      width: s,
      minWidth: s,
      borderRadius: "50%"
    },
    [`${c}${u}-round`]: {
      borderRadius: s
    }
  };
}, genSkeletonElementButtonSize = (a, s) => Object.assign({
  width: s(a).mul(2).equal(),
  minWidth: s(a).mul(2).equal()
}, genSkeletonElementCommonSize(a)), genSkeletonElementButton = (a) => {
  const {
    borderRadiusSM: s,
    skeletonButtonCls: c,
    controlHeight: u,
    controlHeightLG: d,
    controlHeightSM: p,
    gradientFromColor: v,
    calc: A
  } = a;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [c]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: v,
      borderRadius: s,
      width: A(u).mul(2).equal(),
      minWidth: A(u).mul(2).equal()
    }, genSkeletonElementButtonSize(u, A))
  }, genSkeletonElementButtonShape(a, u, c)), {
    [`${c}-lg`]: Object.assign({}, genSkeletonElementButtonSize(d, A))
  }), genSkeletonElementButtonShape(a, d, `${c}-lg`)), {
    [`${c}-sm`]: Object.assign({}, genSkeletonElementButtonSize(p, A))
  }), genSkeletonElementButtonShape(a, p, `${c}-sm`));
}, genBaseStyle$a = (a) => {
  const {
    componentCls: s,
    skeletonAvatarCls: c,
    skeletonTitleCls: u,
    skeletonParagraphCls: d,
    skeletonButtonCls: p,
    skeletonInputCls: v,
    skeletonImageCls: A,
    controlHeight: x,
    controlHeightLG: g,
    controlHeightSM: b,
    gradientFromColor: y,
    padding: f,
    marginSM: m,
    borderRadius: C,
    titleHeight: w,
    blockRadius: S,
    paragraphLiHeight: $,
    controlHeightXS: T,
    paragraphMarginTop: I
  } = a;
  return {
    [s]: {
      display: "table",
      width: "100%",
      [`${s}-header`]: {
        display: "table-cell",
        paddingInlineEnd: f,
        verticalAlign: "top",
        // Avatar
        [c]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: y
        }, genSkeletonElementAvatarSize(x)),
        [`${c}-circle`]: {
          borderRadius: "50%"
        },
        [`${c}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(g)),
        [`${c}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(b))
      },
      [`${s}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [u]: {
          width: "100%",
          height: w,
          background: y,
          borderRadius: S,
          [`+ ${d}`]: {
            marginBlockStart: b
          }
        },
        // paragraph
        [d]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: $,
            listStyle: "none",
            background: y,
            borderRadius: S,
            "+ li": {
              marginBlockStart: T
            }
          }
        },
        [`${d}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${s}-content`]: {
        [`${u}, ${d} > li`]: {
          borderRadius: C
        }
      }
    },
    [`${s}-with-avatar ${s}-content`]: {
      // Title
      [u]: {
        marginBlockStart: m,
        [`+ ${d}`]: {
          marginBlockStart: I
        }
      }
    },
    // Skeleton element
    [`${s}${s}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, genSkeletonElementButton(a)), genSkeletonElementAvatar(a)), genSkeletonElementInput(a)), genSkeletonElementImage(a)),
    // Skeleton Block Button, Input
    [`${s}${s}-block`]: {
      width: "100%",
      [p]: {
        width: "100%"
      },
      [v]: {
        width: "100%"
      }
    },
    // With active animation
    [`${s}${s}-active`]: {
      [`
        ${u},
        ${d} > li,
        ${c},
        ${p},
        ${v},
        ${A}
      `]: Object.assign({}, genSkeletonColor(a))
    }
  };
}, prepareComponentToken$r = (a) => {
  const {
    colorFillContent: s,
    colorFill: c
  } = a, u = s, d = c;
  return {
    color: u,
    colorGradientEnd: d,
    gradientFromColor: u,
    gradientToColor: d,
    titleHeight: a.controlHeight / 2,
    blockRadius: a.borderRadiusSM,
    paragraphMarginTop: a.marginLG + a.marginXXS,
    paragraphLiHeight: a.controlHeight / 2
  };
}, useStyle$u = genStyleHooks("Skeleton", (a) => {
  const {
    componentCls: s,
    calc: c
  } = a, u = merge(a, {
    skeletonAvatarCls: `${s}-avatar`,
    skeletonTitleCls: `${s}-title`,
    skeletonParagraphCls: `${s}-paragraph`,
    skeletonButtonCls: `${s}-button`,
    skeletonInputCls: `${s}-input`,
    skeletonImageCls: `${s}-image`,
    imageSizeBase: c(a.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${a.gradientFromColor} 25%, ${a.gradientToColor} 37%, ${a.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [genBaseStyle$a(u)];
}, prepareComponentToken$r, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), SkeletonAvatar = (a) => {
  const {
    prefixCls: s,
    className: c,
    rootClassName: u,
    active: d,
    shape: p = "circle",
    size: v = "default"
  } = a, {
    getPrefixCls: A
  } = reactExports.useContext(ConfigContext$1), x = A("skeleton", s), [g, b, y] = useStyle$u(x), f = omit(a, ["prefixCls", "className"]), m = classnames(x, `${x}-element`, {
    [`${x}-active`]: d
  }, c, u, b, y);
  return g(/* @__PURE__ */ reactExports.createElement("div", {
    className: m
  }, /* @__PURE__ */ reactExports.createElement(Element$1, Object.assign({
    prefixCls: `${x}-avatar`,
    shape: p,
    size: v
  }, f))));
}, SkeletonButton = (a) => {
  const {
    prefixCls: s,
    className: c,
    rootClassName: u,
    active: d,
    block: p = !1,
    size: v = "default"
  } = a, {
    getPrefixCls: A
  } = reactExports.useContext(ConfigContext$1), x = A("skeleton", s), [g, b, y] = useStyle$u(x), f = omit(a, ["prefixCls"]), m = classnames(x, `${x}-element`, {
    [`${x}-active`]: d,
    [`${x}-block`]: p
  }, c, u, b, y);
  return g(/* @__PURE__ */ reactExports.createElement("div", {
    className: m
  }, /* @__PURE__ */ reactExports.createElement(Element$1, Object.assign({
    prefixCls: `${x}-button`,
    size: v
  }, f))));
}, path = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", SkeletonImage = (a) => {
  const {
    prefixCls: s,
    className: c,
    rootClassName: u,
    style: d,
    active: p
  } = a, {
    getPrefixCls: v
  } = reactExports.useContext(ConfigContext$1), A = v("skeleton", s), [x, g, b] = useStyle$u(A), y = classnames(A, `${A}-element`, {
    [`${A}-active`]: p
  }, c, u, g, b);
  return x(/* @__PURE__ */ reactExports.createElement("div", {
    className: y
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${A}-image`, c),
    style: d
  }, /* @__PURE__ */ reactExports.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${A}-image-svg`
  }, /* @__PURE__ */ reactExports.createElement("title", null, "Image placeholder"), /* @__PURE__ */ reactExports.createElement("path", {
    d: path,
    className: `${A}-image-path`
  })))));
}, SkeletonInput = (a) => {
  const {
    prefixCls: s,
    className: c,
    rootClassName: u,
    active: d,
    block: p,
    size: v = "default"
  } = a, {
    getPrefixCls: A
  } = reactExports.useContext(ConfigContext$1), x = A("skeleton", s), [g, b, y] = useStyle$u(x), f = omit(a, ["prefixCls"]), m = classnames(x, `${x}-element`, {
    [`${x}-active`]: d,
    [`${x}-block`]: p
  }, c, u, b, y);
  return g(/* @__PURE__ */ reactExports.createElement("div", {
    className: m
  }, /* @__PURE__ */ reactExports.createElement(Element$1, Object.assign({
    prefixCls: `${x}-input`,
    size: v
  }, f))));
}, SkeletonNode = (a) => {
  const {
    prefixCls: s,
    className: c,
    rootClassName: u,
    style: d,
    active: p,
    children: v
  } = a, {
    getPrefixCls: A
  } = reactExports.useContext(ConfigContext$1), x = A("skeleton", s), [g, b, y] = useStyle$u(x), f = classnames(x, `${x}-element`, {
    [`${x}-active`]: p
  }, b, c, u, y);
  return g(/* @__PURE__ */ reactExports.createElement("div", {
    className: f
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${x}-image`, c),
    style: d
  }, v)));
}, getWidth = (a, s) => {
  const {
    width: c,
    rows: u = 2
  } = s;
  if (Array.isArray(c))
    return c[a];
  if (u - 1 === a)
    return c;
}, Paragraph$1 = (a) => {
  const {
    prefixCls: s,
    className: c,
    style: u,
    rows: d = 0
  } = a, p = Array.from({
    length: d
  }).map((v, A) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ reactExports.createElement("li", {
      key: A,
      style: {
        width: getWidth(A, a)
      }
    })
  ));
  return /* @__PURE__ */ reactExports.createElement("ul", {
    className: classnames(s, c),
    style: u
  }, p);
}, Title$1 = ({
  prefixCls: a,
  className: s,
  width: c,
  style: u
}) => (
  // biome-ignore lint/a11y/useHeadingContent: HOC here
  /* @__PURE__ */ reactExports.createElement("h3", {
    className: classnames(a, s),
    style: Object.assign({
      width: c
    }, u)
  })
);
function getComponentProps(a) {
  return a && typeof a == "object" ? a : {};
}
function getAvatarBasicProps(a, s) {
  return a && !s ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function getTitleBasicProps(a, s) {
  return !a && s ? {
    width: "38%"
  } : a && s ? {
    width: "50%"
  } : {};
}
function getParagraphBasicProps(a, s) {
  const c = {};
  return (!a || !s) && (c.width = "61%"), !a && s ? c.rows = 3 : c.rows = 2, c;
}
const Skeleton = (a) => {
  const {
    prefixCls: s,
    loading: c,
    className: u,
    rootClassName: d,
    style: p,
    children: v,
    avatar: A = !1,
    title: x = !0,
    paragraph: g = !0,
    active: b,
    round: y
  } = a, {
    getPrefixCls: f,
    direction: m,
    className: C,
    style: w
  } = useComponentConfig("skeleton"), S = f("skeleton", s), [$, T, I] = useStyle$u(S);
  if (c || !("loading" in a)) {
    const _ = !!A, E = !!x, R = !!g;
    let O;
    if (_) {
      const F = Object.assign(Object.assign({
        prefixCls: `${S}-avatar`
      }, getAvatarBasicProps(E, R)), getComponentProps(A));
      O = /* @__PURE__ */ reactExports.createElement("div", {
        className: `${S}-header`
      }, /* @__PURE__ */ reactExports.createElement(Element$1, Object.assign({}, F)));
    }
    let L;
    if (E || R) {
      let F;
      if (E) {
        const W = Object.assign(Object.assign({
          prefixCls: `${S}-title`
        }, getTitleBasicProps(_, R)), getComponentProps(x));
        F = /* @__PURE__ */ reactExports.createElement(Title$1, Object.assign({}, W));
      }
      let M;
      if (R) {
        const W = Object.assign(Object.assign({
          prefixCls: `${S}-paragraph`
        }, getParagraphBasicProps(_, E)), getComponentProps(g));
        M = /* @__PURE__ */ reactExports.createElement(Paragraph$1, Object.assign({}, W));
      }
      L = /* @__PURE__ */ reactExports.createElement("div", {
        className: `${S}-content`
      }, F, M);
    }
    const B = classnames(S, {
      [`${S}-with-avatar`]: _,
      [`${S}-active`]: b,
      [`${S}-rtl`]: m === "rtl",
      [`${S}-round`]: y
    }, C, u, d, T, I);
    return $(/* @__PURE__ */ reactExports.createElement("div", {
      className: B,
      style: Object.assign(Object.assign({}, w), p)
    }, O, L));
  }
  return v ?? null;
};
Skeleton.Button = SkeletonButton;
Skeleton.Avatar = SkeletonAvatar;
Skeleton.Input = SkeletonInput;
Skeleton.Image = SkeletonImage;
Skeleton.Node = SkeletonNode;
function voidFunc() {
}
const WatermarkContext = /* @__PURE__ */ reactExports.createContext({
  add: voidFunc,
  remove: voidFunc
});
function usePanelRef(a) {
  const s = reactExports.useContext(WatermarkContext), c = reactExports.useRef(null);
  return useEvent((d) => {
    if (d) {
      const p = d;
      s.add(p), c.current = p;
    } else
      s.remove(c.current);
  });
}
const genGridRowStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    // Grid system
    [s]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, genGridColStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    // Grid system
    [s]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, genLoopGridColumnsStyle = (a, s) => {
  const {
    prefixCls: c,
    componentCls: u,
    gridColumns: d
  } = a, p = {};
  for (let v = d; v >= 0; v--)
    v === 0 ? (p[`${u}${s}-${v}`] = {
      display: "none"
    }, p[`${u}-push-${v}`] = {
      insetInlineStart: "auto"
    }, p[`${u}-pull-${v}`] = {
      insetInlineEnd: "auto"
    }, p[`${u}${s}-push-${v}`] = {
      insetInlineStart: "auto"
    }, p[`${u}${s}-pull-${v}`] = {
      insetInlineEnd: "auto"
    }, p[`${u}${s}-offset-${v}`] = {
      marginInlineStart: 0
    }, p[`${u}${s}-order-${v}`] = {
      order: 0
    }) : (p[`${u}${s}-${v}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        "--ant-display": "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${v / d * 100}%`,
        maxWidth: `${v / d * 100}%`
      }
    ], p[`${u}${s}-push-${v}`] = {
      insetInlineStart: `${v / d * 100}%`
    }, p[`${u}${s}-pull-${v}`] = {
      insetInlineEnd: `${v / d * 100}%`
    }, p[`${u}${s}-offset-${v}`] = {
      marginInlineStart: `${v / d * 100}%`
    }, p[`${u}${s}-order-${v}`] = {
      order: v
    });
  return p[`${u}${s}-flex`] = {
    flex: `var(--${c}${s}-flex)`
  }, p;
}, genGridStyle = (a, s) => genLoopGridColumnsStyle(a, s), genGridMediaStyle = (a, s, c) => ({
  [`@media (min-width: ${unit$1(s)})`]: Object.assign({}, genGridStyle(a, c))
}), prepareRowComponentToken = () => ({}), prepareColComponentToken = () => ({}), useRowStyle = genStyleHooks("Grid", genGridRowStyle, prepareRowComponentToken), getMediaSize = (a) => ({
  xs: a.screenXSMin,
  sm: a.screenSMMin,
  md: a.screenMDMin,
  lg: a.screenLGMin,
  xl: a.screenXLMin,
  xxl: a.screenXXLMin
}), useColStyle = genStyleHooks("Grid", (a) => {
  const s = merge(a, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), c = getMediaSize(s);
  return delete c.xs, [genGridColStyle(s), genGridStyle(s, ""), genGridStyle(s, "-xs"), Object.keys(c).map((u) => genGridMediaStyle(s, c[u], `-${u}`)).reduce((u, d) => Object.assign(Object.assign({}, u), d), {})];
}, prepareColComponentToken);
function box(a) {
  return {
    position: a,
    inset: 0
  };
}
const genModalMaskStyle = (a) => {
  const {
    componentCls: s,
    antCls: c
  } = a;
  return [{
    [`${s}-root`]: {
      [`${s}${c}-zoom-enter, ${s}${c}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: a.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${s}${c}-zoom-leave ${s}-content`]: {
        pointerEvents: "none"
      },
      [`${s}-mask`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: a.zIndexPopupBase,
        height: "100%",
        backgroundColor: a.colorBgMask,
        pointerEvents: "none",
        [`${s}-hidden`]: {
          display: "none"
        }
      }),
      [`${s}-wrap`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: a.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch"
      })
    }
  }, {
    [`${s}-root`]: initFadeMotion(a)
  }];
}, genModalStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return [
    // ======================== Root =========================
    {
      [`${s}-root`]: {
        [`${s}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${s}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [s]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${a.screenSMMax}px)`]: {
          [s]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${unit$1(a.marginXS)} auto`
          },
          [`${s}-centered`]: {
            [s]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${unit$1(a.calc(a.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: a.paddingLG,
        [`${s}-title`]: {
          margin: 0,
          color: a.titleColor,
          fontWeight: a.fontWeightStrong,
          fontSize: a.titleFontSize,
          lineHeight: a.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${s}-content`]: {
          position: "relative",
          backgroundColor: a.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: a.borderRadiusLG,
          boxShadow: a.boxShadow,
          pointerEvents: "auto",
          padding: a.contentPadding
        },
        [`${s}-close`]: Object.assign({
          position: "absolute",
          top: a.calc(a.modalHeaderHeight).sub(a.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: a.calc(a.modalHeaderHeight).sub(a.modalCloseBtnSize).div(2).equal(),
          zIndex: a.calc(a.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: a.modalCloseIconColor,
          fontWeight: a.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: a.borderRadiusSM,
          width: a.modalCloseBtnSize,
          height: a.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${a.motionDurationMid}, background-color ${a.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: a.fontSizeLG,
            fontStyle: "normal",
            lineHeight: unit$1(a.modalCloseBtnSize),
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:disabled": {
            pointerEvents: "none"
          },
          "&:hover": {
            color: a.modalCloseIconHoverColor,
            backgroundColor: a.colorBgTextHover,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: a.colorBgTextActive
          }
        }, genFocusStyle(a)),
        [`${s}-header`]: {
          color: a.colorText,
          background: a.headerBg,
          borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`,
          marginBottom: a.headerMarginBottom,
          padding: a.headerPadding,
          borderBottom: a.headerBorderBottom
        },
        [`${s}-body`]: {
          fontSize: a.fontSize,
          lineHeight: a.lineHeight,
          wordWrap: "break-word",
          padding: a.bodyPadding,
          [`${s}-body-skeleton`]: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: `${unit$1(a.margin)} auto`
          }
        },
        [`${s}-footer`]: {
          textAlign: "end",
          background: a.footerBg,
          marginTop: a.footerMarginTop,
          padding: a.footerPadding,
          borderTop: a.footerBorderTop,
          borderRadius: a.footerBorderRadius,
          [`> ${a.antCls}-btn + ${a.antCls}-btn`]: {
            marginInlineStart: a.marginXS
          }
        },
        [`${s}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${s}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${s}-content,
          ${s}-body,
          ${s}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${s}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, genRTLStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-root`]: {
      [`${s}-wrap-rtl`]: {
        direction: "rtl",
        [`${s}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, genResponsiveWidthStyle = (a) => {
  const {
    componentCls: s
  } = a, c = getMediaSize(a);
  delete c.xs;
  const u = Object.keys(c).map((d) => ({
    [`@media (min-width: ${unit$1(c[d])})`]: {
      width: `var(--${s.replace(".", "")}-${d}-width)`
    }
  }));
  return {
    [`${s}-root`]: {
      [s]: [{
        width: `var(--${s.replace(".", "")}-xs-width)`
      }].concat(_toConsumableArray$e(u))
    }
  };
}, prepareToken$2 = (a) => {
  const s = a.padding, c = a.fontSizeHeading5, u = a.lineHeightHeading5;
  return merge(a, {
    modalHeaderHeight: a.calc(a.calc(u).mul(c).equal()).add(a.calc(s).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: a.colorSplit,
    modalFooterBorderStyle: a.lineType,
    modalFooterBorderWidth: a.lineWidth,
    modalCloseIconColor: a.colorIcon,
    modalCloseIconHoverColor: a.colorIconHover,
    modalCloseBtnSize: a.controlHeight,
    modalConfirmIconSize: a.fontHeight,
    modalTitleHeight: a.calc(a.titleFontSize).mul(a.titleLineHeight).equal()
  });
}, prepareComponentToken$q = (a) => ({
  footerBg: "transparent",
  headerBg: a.colorBgElevated,
  titleLineHeight: a.lineHeightHeading5,
  titleFontSize: a.fontSizeHeading5,
  contentBg: a.colorBgElevated,
  titleColor: a.colorTextHeading,
  // internal
  contentPadding: a.wireframe ? 0 : `${unit$1(a.paddingMD)} ${unit$1(a.paddingContentHorizontalLG)}`,
  headerPadding: a.wireframe ? `${unit$1(a.padding)} ${unit$1(a.paddingLG)}` : 0,
  headerBorderBottom: a.wireframe ? `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorSplit}` : "none",
  headerMarginBottom: a.wireframe ? 0 : a.marginXS,
  bodyPadding: a.wireframe ? a.paddingLG : 0,
  footerPadding: a.wireframe ? `${unit$1(a.paddingXS)} ${unit$1(a.padding)}` : 0,
  footerBorderTop: a.wireframe ? `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorSplit}` : "none",
  footerBorderRadius: a.wireframe ? `0 0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)}` : 0,
  footerMarginTop: a.wireframe ? 0 : a.marginSM,
  confirmBodyPadding: a.wireframe ? `${unit$1(a.padding * 2)} ${unit$1(a.padding * 2)} ${unit$1(a.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: a.wireframe ? a.margin : a.marginSM,
  confirmBtnsMarginTop: a.wireframe ? a.marginLG : a.marginSM
});
genStyleHooks("Modal", (a) => {
  const s = prepareToken$2(a);
  return [genModalStyle(s), genRTLStyle(s), genModalMaskStyle(s), initZoomMotion(s, "zoom"), genResponsiveWidthStyle(s)];
}, prepareComponentToken$q, {
  unitless: {
    titleLineHeight: !0
  }
});
const AppConfigContext = /* @__PURE__ */ React.createContext({});
function withPureRenderTheme(a) {
  return (s) => /* @__PURE__ */ reactExports.createElement(ConfigProvider, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ reactExports.createElement(a, Object.assign({}, s)));
}
const genPurePanel = (a, s, c, u, d) => withPureRenderTheme((v) => {
  const {
    prefixCls: A,
    style: x
  } = v, g = reactExports.useRef(null), [b, y] = reactExports.useState(0), [f, m] = reactExports.useState(0), [C, w] = useMergedState(!1, {
    value: v.open
  }), {
    getPrefixCls: S
  } = reactExports.useContext(ConfigContext$1), $ = S(u || "select", A);
  reactExports.useEffect(() => {
    if (w(!0), typeof ResizeObserver < "u") {
      const _ = new ResizeObserver((R) => {
        const O = R[0].target;
        y(O.offsetHeight + 8), m(O.offsetWidth);
      }), E = setInterval(() => {
        var R;
        const O = d ? `.${d($)}` : `.${$}-dropdown`, L = (R = g.current) === null || R === void 0 ? void 0 : R.querySelector(O);
        L && (clearInterval(E), _.observe(L));
      }, 10);
      return () => {
        clearInterval(E), _.disconnect();
      };
    }
  }, []);
  let T = Object.assign(Object.assign({}, v), {
    style: Object.assign(Object.assign({}, x), {
      margin: 0
    }),
    open: C,
    visible: C,
    getPopupContainer: () => g.current
  });
  c && (T = c(T)), s && Object.assign(T, {
    [s]: {
      overflow: {
        adjustX: !1,
        adjustY: !1
      }
    }
  });
  const I = {
    paddingBottom: b,
    position: "relative",
    minWidth: f
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: g,
    style: I
  }, /* @__PURE__ */ reactExports.createElement(a, Object.assign({}, T)));
}), isMobile$1 = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var a = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a?.substr(0, 4));
};
var TransBtn = function a(s) {
  var c = s.className, u = s.customizeIcon, d = s.customizeIconProps, p = s.children, v = s.onMouseDown, A = s.onClick, x = typeof u == "function" ? u(d) : u;
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: c,
    onMouseDown: function(b) {
      b.preventDefault(), v?.(b);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: A,
    "aria-hidden": !0
  }, x !== void 0 ? x : /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(c.split(/\s+/).map(function(g) {
      return "".concat(g, "-icon");
    }))
  }, p));
}, useAllowClear = function a(s, c, u, d, p) {
  var v = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, A = arguments.length > 6 ? arguments[6] : void 0, x = arguments.length > 7 ? arguments[7] : void 0, g = React.useMemo(function() {
    if (_typeof$h(d) === "object")
      return d.clearIcon;
    if (p)
      return p;
  }, [d, p]), b = React.useMemo(function() {
    return !!(!v && d && (u.length || A) && !(x === "combobox" && A === ""));
  }, [d, v, u.length, A, x]);
  return {
    allowClear: b,
    clearIcon: /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(s, "-clear"),
      onMouseDown: c,
      customizeIcon: g
    }, "×")
  };
}, BaseSelectContext = /* @__PURE__ */ reactExports.createContext(null);
function useBaseProps() {
  return reactExports.useContext(BaseSelectContext);
}
function useDelayReset() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, s = reactExports.useState(!1), c = _slicedToArray$e(s, 2), u = c[0], d = c[1], p = reactExports.useRef(null), v = function() {
    window.clearTimeout(p.current);
  };
  reactExports.useEffect(function() {
    return v;
  }, []);
  var A = function(g, b) {
    v(), p.current = window.setTimeout(function() {
      d(g), b && b();
    }, a);
  };
  return [u, A, v];
}
function useLock() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, s = reactExports.useRef(null), c = reactExports.useRef(null);
  reactExports.useEffect(function() {
    return function() {
      window.clearTimeout(c.current);
    };
  }, []);
  function u(d) {
    (d || s.current === null) && (s.current = d), window.clearTimeout(c.current), c.current = window.setTimeout(function() {
      s.current = null;
    }, a);
  }
  return [function() {
    return s.current;
  }, u];
}
function useSelectTriggerControl(a, s, c, u) {
  var d = reactExports.useRef(null);
  d.current = {
    open: s,
    triggerOpen: c,
    customizedTrigger: u
  }, reactExports.useEffect(function() {
    function p(v) {
      var A;
      if (!((A = d.current) !== null && A !== void 0 && A.customizedTrigger)) {
        var x = v.target;
        x.shadowRoot && v.composed && (x = v.composedPath()[0] || x), d.current.open && a().filter(function(g) {
          return g;
        }).every(function(g) {
          return !g.contains(x) && g !== x;
        }) && d.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", p), function() {
      return window.removeEventListener("mousedown", p);
    };
  }, []);
}
function isValidateOpenKey(a) {
  return (
    // Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    a && // Other keys
    ![
      // System function button
      KeyCode.ESC,
      KeyCode.SHIFT,
      KeyCode.BACKSPACE,
      KeyCode.TAB,
      KeyCode.WIN_KEY,
      KeyCode.ALT,
      KeyCode.META,
      KeyCode.WIN_KEY_RIGHT,
      KeyCode.CTRL,
      KeyCode.SEMICOLON,
      KeyCode.EQUALS,
      KeyCode.CAPS_LOCK,
      KeyCode.CONTEXT_MENU,
      // F1-F12
      KeyCode.F1,
      KeyCode.F2,
      KeyCode.F3,
      KeyCode.F4,
      KeyCode.F5,
      KeyCode.F6,
      KeyCode.F7,
      KeyCode.F8,
      KeyCode.F9,
      KeyCode.F10,
      KeyCode.F11,
      KeyCode.F12
    ].includes(a)
  );
}
var _excluded$U = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED$1 = void 0;
function InternalItem(a, s) {
  var c = a.prefixCls, u = a.invalidate, d = a.item, p = a.renderItem, v = a.responsive, A = a.responsiveDisabled, x = a.registerSize, g = a.itemKey, b = a.className, y = a.style, f = a.children, m = a.display, C = a.order, w = a.component, S = w === void 0 ? "div" : w, $ = _objectWithoutProperties$2(a, _excluded$U), T = v && !m;
  function I(L) {
    x(g, L);
  }
  reactExports.useEffect(function() {
    return function() {
      I(null);
    };
  }, []);
  var _ = p && d !== UNDEFINED$1 ? p(d, {
    index: C
  }) : f, E;
  u || (E = {
    opacity: T ? 0 : 1,
    height: T ? 0 : UNDEFINED$1,
    overflowY: T ? "hidden" : UNDEFINED$1,
    order: v ? C : UNDEFINED$1,
    pointerEvents: T ? "none" : UNDEFINED$1,
    position: T ? "absolute" : UNDEFINED$1
  });
  var R = {};
  T && (R["aria-hidden"] = !0);
  var O = /* @__PURE__ */ reactExports.createElement(S, _extends$3({
    className: classnames(!u && c, b),
    style: _objectSpread2$1(_objectSpread2$1({}, E), y)
  }, R, $, {
    ref: s
  }), _);
  return v && (O = /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: function(B) {
      var F = B.offsetWidth;
      I(F);
    },
    disabled: A
  }, O)), O;
}
var Item$3 = /* @__PURE__ */ reactExports.forwardRef(InternalItem);
Item$3.displayName = "Item";
function channelUpdate(a) {
  if (typeof MessageChannel > "u")
    wrapperRaf(a);
  else {
    var s = new MessageChannel();
    s.port1.onmessage = function() {
      return a();
    }, s.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var a = reactExports.useRef(null), s = function(u) {
    a.current || (a.current = [], channelUpdate(function() {
      reactDomExports.unstable_batchedUpdates(function() {
        a.current.forEach(function(d) {
          d();
        }), a.current = null;
      });
    })), a.current.push(u);
  };
  return s;
}
function useEffectState(a, s) {
  var c = reactExports.useState(s), u = _slicedToArray$e(c, 2), d = u[0], p = u[1], v = useEvent(function(A) {
    a(function() {
      p(A);
    });
  });
  return [d, v];
}
var OverflowContext = /* @__PURE__ */ React.createContext(null), _excluded$T = ["component"], _excluded2$c = ["className"], _excluded3$1 = ["className"], InternalRawItem = function a(s, c) {
  var u = reactExports.useContext(OverflowContext);
  if (!u) {
    var d = s.component, p = d === void 0 ? "div" : d, v = _objectWithoutProperties$2(s, _excluded$T);
    return /* @__PURE__ */ reactExports.createElement(p, _extends$3({}, v, {
      ref: c
    }));
  }
  var A = u.className, x = _objectWithoutProperties$2(u, _excluded2$c), g = s.className, b = _objectWithoutProperties$2(s, _excluded3$1);
  return /* @__PURE__ */ reactExports.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ reactExports.createElement(Item$3, _extends$3({
    ref: c,
    className: classnames(A, g)
  }, x, b)));
}, RawItem = /* @__PURE__ */ reactExports.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$S = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(a) {
  return "+ ".concat(a.length, " ...");
}
function Overflow(a, s) {
  var c = a.prefixCls, u = c === void 0 ? "rc-overflow" : c, d = a.data, p = d === void 0 ? [] : d, v = a.renderItem, A = a.renderRawItem, x = a.itemKey, g = a.itemWidth, b = g === void 0 ? 10 : g, y = a.ssr, f = a.style, m = a.className, C = a.maxCount, w = a.renderRest, S = a.renderRawRest, $ = a.suffix, T = a.component, I = T === void 0 ? "div" : T, _ = a.itemComponent, E = a.onVisibleChange, R = _objectWithoutProperties$2(a, _excluded$S), O = y === "full", L = useBatcher(), B = useEffectState(L, null), F = _slicedToArray$e(B, 2), M = F[0], W = F[1], j = M || 0, G = useEffectState(L, /* @__PURE__ */ new Map()), U = _slicedToArray$e(G, 2), k = U[0], N = U[1], P = useEffectState(L, 0), D = _slicedToArray$e(P, 2), H = D[0], V = D[1], Z = useEffectState(L, 0), ne = _slicedToArray$e(Z, 2), K = ne[0], q = ne[1], Y = useEffectState(L, 0), ee = _slicedToArray$e(Y, 2), Q = ee[0], J = ee[1], te = reactExports.useState(null), ae = _slicedToArray$e(te, 2), se = ae[0], ie = ae[1], fe = reactExports.useState(null), ge = _slicedToArray$e(fe, 2), me = ge[0], pe = ge[1], be = reactExports.useMemo(function() {
    return me === null && O ? Number.MAX_SAFE_INTEGER : me || 0;
  }, [me, M]), le = reactExports.useState(!1), ve = _slicedToArray$e(le, 2), he = ve[0], ye = ve[1], Ce = "".concat(u, "-item"), xe = Math.max(H, K), we = C === RESPONSIVE, $e = p.length && we, Ae = C === INVALIDATE, ue = $e || typeof C == "number" && p.length > C, ce = reactExports.useMemo(function() {
    var ct = p;
    return $e ? M === null && O ? ct = p : ct = p.slice(0, Math.min(p.length, j / b)) : typeof C == "number" && (ct = p.slice(0, C)), ct;
  }, [p, b, M, C, $e]), Ee = reactExports.useMemo(function() {
    return $e ? p.slice(be + 1) : p.slice(ce.length);
  }, [p, ce, $e, be]), _e = reactExports.useCallback(function(ct, it) {
    var We;
    return typeof x == "function" ? x(ct) : (We = x && ct?.[x]) !== null && We !== void 0 ? We : it;
  }, [x]), Te = reactExports.useCallback(v || function(ct) {
    return ct;
  }, [v]);
  function ke(ct, it, We) {
    me === ct && (it === void 0 || it === se) || (pe(ct), We || (ye(ct < p.length - 1), E?.(ct)), it !== void 0 && ie(it));
  }
  function Re(ct, it) {
    W(it.clientWidth);
  }
  function Be(ct, it) {
    N(function(We) {
      var Ve = new Map(We);
      return it === null ? Ve.delete(ct) : Ve.set(ct, it), Ve;
    });
  }
  function Oe(ct, it) {
    q(it), V(K);
  }
  function Me(ct, it) {
    J(it);
  }
  function Fe(ct) {
    return k.get(_e(ce[ct], ct));
  }
  useLayoutEffect$1(function() {
    if (j && typeof xe == "number" && ce) {
      var ct = Q, it = ce.length, We = it - 1;
      if (!it) {
        ke(0, null);
        return;
      }
      for (var Ve = 0; Ve < it; Ve += 1) {
        var ut = Fe(Ve);
        if (O && (ut = ut || 0), ut === void 0) {
          ke(Ve - 1, void 0, !0);
          break;
        }
        if (ct += ut, // Only one means `totalWidth` is the final width
        We === 0 && ct <= j || // Last two width will be the final width
        Ve === We - 1 && ct + Fe(We) <= j) {
          ke(We, null);
          break;
        } else if (ct + xe > j) {
          ke(Ve - 1, ct - ut - Q + K);
          break;
        }
      }
      $ && Fe(0) + Q > j && ie(null);
    }
  }, [j, k, K, Q, _e, ce]);
  var Ue = he && !!Ee.length, je = {};
  se !== null && $e && (je = {
    position: "absolute",
    left: se,
    top: 0
  });
  var Le = {
    prefixCls: Ce,
    responsive: $e,
    component: _,
    invalidate: Ae
  }, De = A ? function(ct, it) {
    var We = _e(ct, it);
    return /* @__PURE__ */ reactExports.createElement(OverflowContext.Provider, {
      key: We,
      value: _objectSpread2$1(_objectSpread2$1({}, Le), {}, {
        order: it,
        item: ct,
        itemKey: We,
        registerSize: Be,
        display: it <= be
      })
    }, A(ct, it));
  } : function(ct, it) {
    var We = _e(ct, it);
    return /* @__PURE__ */ reactExports.createElement(Item$3, _extends$3({}, Le, {
      order: it,
      key: We,
      item: ct,
      renderItem: Te,
      itemKey: We,
      registerSize: Be,
      display: it <= be
    }));
  }, Ne = {
    order: Ue ? be : Number.MAX_SAFE_INTEGER,
    className: "".concat(Ce, "-rest"),
    registerSize: Oe,
    display: Ue
  }, Ge = w || defaultRenderRest, Xe = S ? /* @__PURE__ */ reactExports.createElement(OverflowContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, Le), Ne)
  }, S(Ee)) : /* @__PURE__ */ reactExports.createElement(Item$3, _extends$3({}, Le, Ne), typeof Ge == "function" ? Ge(Ee) : Ge), nt = /* @__PURE__ */ reactExports.createElement(I, _extends$3({
    className: classnames(!Ae && u, m),
    style: f,
    ref: s
  }, R), ce.map(De), ue ? Xe : null, $ && /* @__PURE__ */ reactExports.createElement(Item$3, _extends$3({}, Le, {
    responsive: we,
    responsiveDisabled: !$e,
    order: be,
    className: "".concat(Ce, "-suffix"),
    registerSize: Me,
    display: !0,
    style: je
  }), $));
  return we ? /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Re,
    disabled: !$e
  }, nt) : nt;
}
var ForwardOverflow = /* @__PURE__ */ reactExports.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
function composeProps(a, s, c) {
  var u = _objectSpread2$1(_objectSpread2$1({}, a), s);
  return Object.keys(s).forEach(function(d) {
    var p = s[d];
    typeof p == "function" && (u[d] = function() {
      for (var v, A = arguments.length, x = new Array(A), g = 0; g < A; g++)
        x[g] = arguments[g];
      return p.apply(void 0, x), (v = a[d]) === null || v === void 0 ? void 0 : v.call.apply(v, [a].concat(x));
    });
  }), u;
}
var _excluded$R = ["prefixCls", "id", "inputElement", "autoFocus", "autoComplete", "editable", "activeDescendantId", "value", "open", "attrs"], Input$5 = function a(s, c) {
  var u = s.prefixCls, d = s.id, p = s.inputElement, v = s.autoFocus, A = s.autoComplete, x = s.editable, g = s.activeDescendantId, b = s.value, y = s.open, f = s.attrs, m = _objectWithoutProperties$2(s, _excluded$R), C = p || /* @__PURE__ */ reactExports.createElement("input", null), w = C, S = w.ref, $ = w.props;
  return "maxLength" in C.props, C = /* @__PURE__ */ reactExports.cloneElement(C, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
    type: "search"
  }, composeProps(m, $)), {}, {
    // Override over origin props
    id: d,
    ref: composeRef(c, S),
    autoComplete: A || "off",
    autoFocus: v,
    className: classnames("".concat(u, "-selection-search-input"), $?.className),
    role: "combobox",
    "aria-expanded": y || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(d, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(d, "_list"),
    "aria-activedescendant": y ? g : void 0
  }, f), {}, {
    value: x ? b : "",
    readOnly: !x,
    unselectable: x ? null : "on",
    style: _objectSpread2$1(_objectSpread2$1({}, $.style), {}, {
      opacity: x ? null : 0
    })
  })), C;
}, RefInput = /* @__PURE__ */ reactExports.forwardRef(Input$5);
function toArray$6(a) {
  return Array.isArray(a) ? a : a !== void 0 ? [a] : [];
}
var isClient = typeof window < "u" && window.document && window.document.documentElement, isBrowserClient$2 = isClient;
function hasValue(a) {
  return a != null;
}
function isComboNoValue(a) {
  return !a && a !== 0;
}
function isTitleType$1(a) {
  return ["string", "number"].includes(_typeof$h(a));
}
function getTitle(a) {
  var s = void 0;
  return a && (isTitleType$1(a.title) ? s = a.title.toString() : isTitleType$1(a.label) && (s = a.label.toString())), s;
}
function useLayoutEffect(a, s) {
  isBrowserClient$2 ? reactExports.useLayoutEffect(a, s) : reactExports.useEffect(a, s);
}
function itemKey$1(a) {
  var s;
  return (s = a.key) !== null && s !== void 0 ? s : a.value;
}
var onPreventMouseDown = function a(s) {
  s.preventDefault(), s.stopPropagation();
}, SelectSelector = function a(s) {
  var c = s.id, u = s.prefixCls, d = s.values, p = s.open, v = s.searchValue, A = s.autoClearSearchValue, x = s.inputRef, g = s.placeholder, b = s.disabled, y = s.mode, f = s.showSearch, m = s.autoFocus, C = s.autoComplete, w = s.activeDescendantId, S = s.tabIndex, $ = s.removeIcon, T = s.maxTagCount, I = s.maxTagTextLength, _ = s.maxTagPlaceholder, E = _ === void 0 ? function(fe) {
    return "+ ".concat(fe.length, " ...");
  } : _, R = s.tagRender, O = s.onToggleOpen, L = s.onRemove, B = s.onInputChange, F = s.onInputPaste, M = s.onInputKeyDown, W = s.onInputMouseDown, j = s.onInputCompositionStart, G = s.onInputCompositionEnd, U = s.onInputBlur, k = reactExports.useRef(null), N = reactExports.useState(0), P = _slicedToArray$e(N, 2), D = P[0], H = P[1], V = reactExports.useState(!1), Z = _slicedToArray$e(V, 2), ne = Z[0], K = Z[1], q = "".concat(u, "-selection"), Y = p || y === "multiple" && A === !1 || y === "tags" ? v : "", ee = y === "tags" || y === "multiple" && A === !1 || f && (p || ne);
  useLayoutEffect(function() {
    H(k.current.scrollWidth);
  }, [Y]);
  var Q = function(ge, me, pe, be, le) {
    return /* @__PURE__ */ reactExports.createElement("span", {
      title: getTitle(ge),
      className: classnames("".concat(q, "-item"), _defineProperty$a({}, "".concat(q, "-item-disabled"), pe))
    }, /* @__PURE__ */ reactExports.createElement("span", {
      className: "".concat(q, "-item-content")
    }, me), be && /* @__PURE__ */ reactExports.createElement(TransBtn, {
      className: "".concat(q, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: le,
      customizeIcon: $
    }, "×"));
  }, J = function(ge, me, pe, be, le, ve) {
    var he = function(Ce) {
      onPreventMouseDown(Ce), O(!p);
    };
    return /* @__PURE__ */ reactExports.createElement("span", {
      onMouseDown: he
    }, R({
      label: me,
      value: ge,
      disabled: pe,
      closable: be,
      onClose: le,
      isMaxTag: !!ve
    }));
  }, te = function(ge) {
    var me = ge.disabled, pe = ge.label, be = ge.value, le = !b && !me, ve = pe;
    if (typeof I == "number" && (typeof pe == "string" || typeof pe == "number")) {
      var he = String(ve);
      he.length > I && (ve = "".concat(he.slice(0, I), "..."));
    }
    var ye = function(xe) {
      xe && xe.stopPropagation(), L(ge);
    };
    return typeof R == "function" ? J(be, ve, me, le, ye) : Q(ge, ve, me, le, ye);
  }, ae = function(ge) {
    if (!d.length)
      return null;
    var me = typeof E == "function" ? E(ge) : E;
    return typeof R == "function" ? J(void 0, me, !1, !1, void 0, !0) : Q({
      title: me
    }, me, !1);
  }, se = /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(q, "-search"),
    style: {
      width: D
    },
    onFocus: function() {
      K(!0);
    },
    onBlur: function() {
      K(!1);
    }
  }, /* @__PURE__ */ reactExports.createElement(RefInput, {
    ref: x,
    open: p,
    prefixCls: u,
    id: c,
    inputElement: null,
    disabled: b,
    autoFocus: m,
    autoComplete: C,
    editable: ee,
    activeDescendantId: w,
    value: Y,
    onKeyDown: M,
    onMouseDown: W,
    onChange: B,
    onPaste: F,
    onCompositionStart: j,
    onCompositionEnd: G,
    onBlur: U,
    tabIndex: S,
    attrs: pickAttrs(s, !0)
  }), /* @__PURE__ */ reactExports.createElement("span", {
    ref: k,
    className: "".concat(q, "-search-mirror"),
    "aria-hidden": !0
  }, Y, " ")), ie = /* @__PURE__ */ reactExports.createElement(ForwardOverflow, {
    prefixCls: "".concat(q, "-overflow"),
    data: d,
    renderItem: te,
    renderRest: ae,
    suffix: se,
    itemKey: itemKey$1,
    maxCount: T
  });
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(q, "-wrap")
  }, ie, !d.length && !Y && /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(q, "-placeholder")
  }, g));
}, SingleSelector$1 = function a(s) {
  var c = s.inputElement, u = s.prefixCls, d = s.id, p = s.inputRef, v = s.disabled, A = s.autoFocus, x = s.autoComplete, g = s.activeDescendantId, b = s.mode, y = s.open, f = s.values, m = s.placeholder, C = s.tabIndex, w = s.showSearch, S = s.searchValue, $ = s.activeValue, T = s.maxLength, I = s.onInputKeyDown, _ = s.onInputMouseDown, E = s.onInputChange, R = s.onInputPaste, O = s.onInputCompositionStart, L = s.onInputCompositionEnd, B = s.onInputBlur, F = s.title, M = reactExports.useState(!1), W = _slicedToArray$e(M, 2), j = W[0], G = W[1], U = b === "combobox", k = U || w, N = f[0], P = S || "";
  U && $ && !j && (P = $), reactExports.useEffect(function() {
    U && G(!1);
  }, [U, $]);
  var D = b !== "combobox" && !y && !w ? !1 : !!P, H = F === void 0 ? getTitle(N) : F, V = reactExports.useMemo(function() {
    return N ? null : /* @__PURE__ */ reactExports.createElement("span", {
      className: "".concat(u, "-selection-placeholder"),
      style: D ? {
        visibility: "hidden"
      } : void 0
    }, m);
  }, [N, D, m, u]);
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(u, "-selection-wrap")
  }, /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(u, "-selection-search")
  }, /* @__PURE__ */ reactExports.createElement(RefInput, {
    ref: p,
    prefixCls: u,
    id: d,
    open: y,
    inputElement: c,
    disabled: v,
    autoFocus: A,
    autoComplete: x,
    editable: k,
    activeDescendantId: g,
    value: P,
    onKeyDown: I,
    onMouseDown: _,
    onChange: function(ne) {
      G(!0), E(ne);
    },
    onPaste: R,
    onCompositionStart: O,
    onCompositionEnd: L,
    onBlur: B,
    tabIndex: C,
    attrs: pickAttrs(s, !0),
    maxLength: U ? T : void 0
  })), !U && N ? /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(u, "-selection-item"),
    title: H,
    style: D ? {
      visibility: "hidden"
    } : void 0
  }, N.label) : null, V);
}, Selector = function a(s, c) {
  var u = reactExports.useRef(null), d = reactExports.useRef(!1), p = s.prefixCls, v = s.open, A = s.mode, x = s.showSearch, g = s.tokenWithEnter, b = s.disabled, y = s.prefix, f = s.autoClearSearchValue, m = s.onSearch, C = s.onSearchSubmit, w = s.onToggleOpen, S = s.onInputKeyDown, $ = s.onInputBlur, T = s.domRef;
  reactExports.useImperativeHandle(c, function() {
    return {
      focus: function(H) {
        u.current.focus(H);
      },
      blur: function() {
        u.current.blur();
      }
    };
  });
  var I = useLock(0), _ = _slicedToArray$e(I, 2), E = _[0], R = _[1], O = function(H) {
    var V = H.which, Z = u.current instanceof HTMLTextAreaElement;
    !Z && v && (V === KeyCode.UP || V === KeyCode.DOWN) && H.preventDefault(), S && S(H), V === KeyCode.ENTER && A === "tags" && !d.current && !v && C?.(H.target.value), !(Z && !v && ~[KeyCode.UP, KeyCode.DOWN, KeyCode.LEFT, KeyCode.RIGHT].indexOf(V)) && isValidateOpenKey(V) && w(!0);
  }, L = function() {
    R(!0);
  }, B = reactExports.useRef(null), F = function(H) {
    m(H, !0, d.current) !== !1 && w(!0);
  }, M = function() {
    d.current = !0;
  }, W = function(H) {
    d.current = !1, A !== "combobox" && F(H.target.value);
  }, j = function(H) {
    var V = H.target.value;
    if (g && B.current && /[\r\n]/.test(B.current)) {
      var Z = B.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      V = V.replace(Z, B.current);
    }
    B.current = null, F(V);
  }, G = function(H) {
    var V = H.clipboardData, Z = V?.getData("text");
    B.current = Z || "";
  }, U = function(H) {
    var V = H.target;
    if (V !== u.current) {
      var Z = document.body.style.msTouchAction !== void 0;
      Z ? setTimeout(function() {
        u.current.focus();
      }) : u.current.focus();
    }
  }, k = function(H) {
    var V = E();
    H.target !== u.current && !V && !(A === "combobox" && b) && H.preventDefault(), (A !== "combobox" && (!x || !V) || !v) && (v && f !== !1 && m("", !0, !1), w());
  }, N = {
    inputRef: u,
    onInputKeyDown: O,
    onInputMouseDown: L,
    onInputChange: j,
    onInputPaste: G,
    onInputCompositionStart: M,
    onInputCompositionEnd: W,
    onInputBlur: $
  }, P = A === "multiple" || A === "tags" ? /* @__PURE__ */ reactExports.createElement(SelectSelector, _extends$3({}, s, N)) : /* @__PURE__ */ reactExports.createElement(SingleSelector$1, _extends$3({}, s, N));
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: T,
    className: "".concat(p, "-selector"),
    onClick: U,
    onMouseDown: k
  }, y && /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(p, "-prefix")
  }, y), P);
}, ForwardSelector = /* @__PURE__ */ reactExports.forwardRef(Selector);
function Arrow(a) {
  var s = a.prefixCls, c = a.align, u = a.arrow, d = a.arrowPos, p = u || {}, v = p.className, A = p.content, x = d.x, g = x === void 0 ? 0 : x, b = d.y, y = b === void 0 ? 0 : b, f = reactExports.useRef();
  if (!c || !c.points)
    return null;
  var m = {
    position: "absolute"
  };
  if (c.autoArrow !== !1) {
    var C = c.points[0], w = c.points[1], S = C[0], $ = C[1], T = w[0], I = w[1];
    S === T || !["t", "b"].includes(S) ? m.top = y : S === "t" ? m.top = 0 : m.bottom = 0, $ === I || !["l", "r"].includes($) ? m.left = g : $ === "l" ? m.left = 0 : m.right = 0;
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: f,
    className: classnames("".concat(s, "-arrow"), v),
    style: m
  }, A);
}
function Mask$1(a) {
  var s = a.prefixCls, c = a.open, u = a.zIndex, d = a.mask, p = a.motion;
  return d ? /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$3({}, p, {
    motionAppear: !0,
    visible: c,
    removeOnLeave: !0
  }), function(v) {
    var A = v.className;
    return /* @__PURE__ */ reactExports.createElement("div", {
      style: {
        zIndex: u
      },
      className: classnames("".concat(s, "-mask"), A)
    });
  }) : null;
}
var PopupContent = /* @__PURE__ */ reactExports.memo(function(a) {
  var s = a.children;
  return s;
}, function(a, s) {
  return s.cache;
}), Popup$3 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.popup, u = a.className, d = a.prefixCls, p = a.style, v = a.target, A = a.onVisibleChanged, x = a.open, g = a.keepDom, b = a.fresh, y = a.onClick, f = a.mask, m = a.arrow, C = a.arrowPos, w = a.align, S = a.motion, $ = a.maskMotion, T = a.forceRender, I = a.getPopupContainer, _ = a.autoDestroy, E = a.portal, R = a.zIndex, O = a.onMouseEnter, L = a.onMouseLeave, B = a.onPointerEnter, F = a.onPointerDownCapture, M = a.ready, W = a.offsetX, j = a.offsetY, G = a.offsetR, U = a.offsetB, k = a.onAlign, N = a.onPrepare, P = a.stretch, D = a.targetWidth, H = a.targetHeight, V = typeof c == "function" ? c() : c, Z = x || g, ne = I?.length > 0, K = reactExports.useState(!I || !ne), q = _slicedToArray$e(K, 2), Y = q[0], ee = q[1];
  if (useLayoutEffect$1(function() {
    !Y && ne && v && ee(!0);
  }, [Y, ne, v]), !Y)
    return null;
  var Q = "auto", J = {
    left: "-1000vw",
    top: "-1000vh",
    right: Q,
    bottom: Q
  };
  if (M || !x) {
    var te, ae = w.points, se = w.dynamicInset || ((te = w._experimental) === null || te === void 0 ? void 0 : te.dynamicInset), ie = se && ae[0][1] === "r", fe = se && ae[0][0] === "b";
    ie ? (J.right = G, J.left = Q) : (J.left = W, J.right = Q), fe ? (J.bottom = U, J.top = Q) : (J.top = j, J.bottom = Q);
  }
  var ge = {};
  return P && (P.includes("height") && H ? ge.height = H : P.includes("minHeight") && H && (ge.minHeight = H), P.includes("width") && D ? ge.width = D : P.includes("minWidth") && D && (ge.minWidth = D)), x || (ge.pointerEvents = "none"), /* @__PURE__ */ reactExports.createElement(E, {
    open: T || Z,
    getContainer: I && function() {
      return I(v);
    },
    autoDestroy: _
  }, /* @__PURE__ */ reactExports.createElement(Mask$1, {
    prefixCls: d,
    open: x,
    zIndex: R,
    mask: f,
    motion: $
  }), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: k,
    disabled: !x
  }, function(me) {
    return /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$3({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: T,
      leavedClassName: "".concat(d, "-hidden")
    }, S, {
      onAppearPrepare: N,
      onEnterPrepare: N,
      visible: x,
      onVisibleChanged: function(be) {
        var le;
        S == null || (le = S.onVisibleChanged) === null || le === void 0 || le.call(S, be), A(be);
      }
    }), function(pe, be) {
      var le = pe.className, ve = pe.style, he = classnames(d, le, u);
      return /* @__PURE__ */ reactExports.createElement("div", {
        ref: composeRef(me, s, be),
        className: he,
        style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
          "--arrow-x": "".concat(C.x || 0, "px"),
          "--arrow-y": "".concat(C.y || 0, "px")
        }, J), ge), ve), {}, {
          boxSizing: "border-box",
          zIndex: R
        }, p),
        onMouseEnter: O,
        onMouseLeave: L,
        onPointerEnter: B,
        onClick: y,
        onPointerDownCapture: F
      }, m && /* @__PURE__ */ reactExports.createElement(Arrow, {
        prefixCls: d,
        arrow: m,
        arrowPos: C,
        align: w
      }), /* @__PURE__ */ reactExports.createElement(PopupContent, {
        cache: !x && !b
      }, V));
    });
  }));
}), TriggerWrapper = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.children, u = a.getTriggerDOMNode, d = supportRef(c), p = reactExports.useCallback(function(A) {
    fillRef(s, u ? u(A) : A);
  }, [u]), v = useComposeRef(p, getNodeRef(c));
  return d ? /* @__PURE__ */ reactExports.cloneElement(c, {
    ref: v
  }) : c;
}), TriggerContext = /* @__PURE__ */ reactExports.createContext(null);
function toArray$5(a) {
  return a ? Array.isArray(a) ? a : [a] : [];
}
function useAction(a, s, c, u) {
  return reactExports.useMemo(function() {
    var d = toArray$5(c ?? s), p = toArray$5(u ?? s), v = new Set(d), A = new Set(p);
    return a && (v.has("hover") && (v.delete("hover"), v.add("click")), A.has("hover") && (A.delete("hover"), A.add("click"))), [v, A];
  }, [a, s, c, u]);
}
function isPointsEq$1() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], c = arguments.length > 2 ? arguments[2] : void 0;
  return c ? a[0] === s[0] : a[0] === s[0] && a[1] === s[1];
}
function getAlignPopupClassName(a, s, c, u) {
  for (var d = c.points, p = Object.keys(a), v = 0; v < p.length; v += 1) {
    var A, x = p[v];
    if (isPointsEq$1((A = a[x]) === null || A === void 0 ? void 0 : A.points, d, u))
      return "".concat(s, "-placement-").concat(x);
  }
  return "";
}
function getMotion$1(a, s, c, u) {
  return s || (c ? {
    motionName: "".concat(a, "-").concat(c)
  } : u ? {
    motionName: u
  } : null);
}
function getWin(a) {
  return a.ownerDocument.defaultView;
}
function collectScroller(a) {
  for (var s = [], c = a?.parentElement, u = ["hidden", "scroll", "clip", "auto"]; c; ) {
    var d = getWin(c).getComputedStyle(c), p = d.overflowX, v = d.overflowY, A = d.overflow;
    [p, v, A].some(function(x) {
      return u.includes(x);
    }) && s.push(c), c = c.parentElement;
  }
  return s;
}
function toNum(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(a) ? s : a;
}
function getPxValue(a) {
  return toNum(parseFloat(a), 0);
}
function getVisibleArea(a, s) {
  var c = _objectSpread2$1({}, a);
  return (s || []).forEach(function(u) {
    if (!(u instanceof HTMLBodyElement || u instanceof HTMLHtmlElement)) {
      var d = getWin(u).getComputedStyle(u), p = d.overflow, v = d.overflowClipMargin, A = d.borderTopWidth, x = d.borderBottomWidth, g = d.borderLeftWidth, b = d.borderRightWidth, y = u.getBoundingClientRect(), f = u.offsetHeight, m = u.clientHeight, C = u.offsetWidth, w = u.clientWidth, S = getPxValue(A), $ = getPxValue(x), T = getPxValue(g), I = getPxValue(b), _ = toNum(Math.round(y.width / C * 1e3) / 1e3), E = toNum(Math.round(y.height / f * 1e3) / 1e3), R = (C - w - T - I) * _, O = (f - m - S - $) * E, L = S * E, B = $ * E, F = T * _, M = I * _, W = 0, j = 0;
      if (p === "clip") {
        var G = getPxValue(v);
        W = G * _, j = G * E;
      }
      var U = y.x + F - W, k = y.y + L - j, N = U + y.width + 2 * W - F - M - R, P = k + y.height + 2 * j - L - B - O;
      c.left = Math.max(c.left, U), c.top = Math.max(c.top, k), c.right = Math.min(c.right, N), c.bottom = Math.min(c.bottom, P);
    }
  }), c;
}
function getUnitOffset(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, c = "".concat(s), u = c.match(/^(.*)\%$/);
  return u ? a * (parseFloat(u[1]) / 100) : parseFloat(c);
}
function getNumberOffset(a, s) {
  var c = s || [], u = _slicedToArray$e(c, 2), d = u[0], p = u[1];
  return [getUnitOffset(a.width, d), getUnitOffset(a.height, p)];
}
function splitPoints() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [a[0], a[1]];
}
function getAlignPoint(a, s) {
  var c = s[0], u = s[1], d, p;
  return c === "t" ? p = a.y : c === "b" ? p = a.y + a.height : p = a.y + a.height / 2, u === "l" ? d = a.x : u === "r" ? d = a.x + a.width : d = a.x + a.width / 2, {
    x: d,
    y: p
  };
}
function reversePoints(a, s) {
  var c = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return a.map(function(u, d) {
    return d === s ? c[u] || "c" : u;
  }).join("");
}
function useAlign(a, s, c, u, d, p, v) {
  var A = reactExports.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: d[u] || {}
  }), x = _slicedToArray$e(A, 2), g = x[0], b = x[1], y = reactExports.useRef(0), f = reactExports.useMemo(function() {
    return s ? collectScroller(s) : [];
  }, [s]), m = reactExports.useRef({}), C = function() {
    m.current = {};
  };
  a || C();
  var w = useEvent(function() {
    if (s && c && a) {
      let lr = function(Wr, Fr) {
        var Qr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : we, an = Z.x + Wr, cn = Z.y + Fr, yn = an + fe, _n = cn + ie, Xt = Math.max(an, Qr.left), sr = Math.max(cn, Qr.top), Tr = Math.min(yn, Qr.right), Lr = Math.min(_n, Qr.bottom);
        return Math.max(0, (Tr - Xt) * (Lr - sr));
      }, Nr = function() {
        Nt = Z.y + Ve, _t = Nt + ie, Ot = Z.x + We, rt = Ot + fe;
      };
      var T, I, _, E, R = s, O = R.ownerDocument, L = getWin(R), B = L.getComputedStyle(R), F = B.position, M = R.style.left, W = R.style.top, j = R.style.right, G = R.style.bottom, U = R.style.overflow, k = _objectSpread2$1(_objectSpread2$1({}, d[u]), p), N = O.createElement("div");
      (T = R.parentElement) === null || T === void 0 || T.appendChild(N), N.style.left = "".concat(R.offsetLeft, "px"), N.style.top = "".concat(R.offsetTop, "px"), N.style.position = F, N.style.height = "".concat(R.offsetHeight, "px"), N.style.width = "".concat(R.offsetWidth, "px"), R.style.left = "0", R.style.top = "0", R.style.right = "auto", R.style.bottom = "auto", R.style.overflow = "hidden";
      var P;
      if (Array.isArray(c))
        P = {
          x: c[0],
          y: c[1],
          width: 0,
          height: 0
        };
      else {
        var D, H, V = c.getBoundingClientRect();
        V.x = (D = V.x) !== null && D !== void 0 ? D : V.left, V.y = (H = V.y) !== null && H !== void 0 ? H : V.top, P = {
          x: V.x,
          y: V.y,
          width: V.width,
          height: V.height
        };
      }
      var Z = R.getBoundingClientRect(), ne = L.getComputedStyle(R), K = ne.height, q = ne.width;
      Z.x = (I = Z.x) !== null && I !== void 0 ? I : Z.left, Z.y = (_ = Z.y) !== null && _ !== void 0 ? _ : Z.top;
      var Y = O.documentElement, ee = Y.clientWidth, Q = Y.clientHeight, J = Y.scrollWidth, te = Y.scrollHeight, ae = Y.scrollTop, se = Y.scrollLeft, ie = Z.height, fe = Z.width, ge = P.height, me = P.width, pe = {
        left: 0,
        top: 0,
        right: ee,
        bottom: Q
      }, be = {
        left: -se,
        top: -ae,
        right: J - se,
        bottom: te - ae
      }, le = k.htmlRegion, ve = "visible", he = "visibleFirst";
      le !== "scroll" && le !== he && (le = ve);
      var ye = le === he, Ce = getVisibleArea(be, f), xe = getVisibleArea(pe, f), we = le === ve ? xe : Ce, $e = ye ? xe : we;
      R.style.left = "auto", R.style.top = "auto", R.style.right = "0", R.style.bottom = "0";
      var Ae = R.getBoundingClientRect();
      R.style.left = M, R.style.top = W, R.style.right = j, R.style.bottom = G, R.style.overflow = U, (E = R.parentElement) === null || E === void 0 || E.removeChild(N);
      var ue = toNum(Math.round(fe / parseFloat(q) * 1e3) / 1e3), ce = toNum(Math.round(ie / parseFloat(K) * 1e3) / 1e3);
      if (ue === 0 || ce === 0 || isDOM(c) && !isVisible(c))
        return;
      var Ee = k.offset, _e = k.targetOffset, Te = getNumberOffset(Z, Ee), ke = _slicedToArray$e(Te, 2), Re = ke[0], Be = ke[1], Oe = getNumberOffset(P, _e), Me = _slicedToArray$e(Oe, 2), Fe = Me[0], Ue = Me[1];
      P.x -= Fe, P.y -= Ue;
      var je = k.points || [], Le = _slicedToArray$e(je, 2), De = Le[0], Ne = Le[1], Ge = splitPoints(Ne), Xe = splitPoints(De), nt = getAlignPoint(P, Ge), ct = getAlignPoint(Z, Xe), it = _objectSpread2$1({}, k), We = nt.x - ct.x + Re, Ve = nt.y - ct.y + Be, ut = lr(We, Ve), at = lr(We, Ve, xe), Qe = getAlignPoint(P, ["t", "l"]), st = getAlignPoint(Z, ["t", "l"]), ft = getAlignPoint(P, ["b", "r"]), vt = getAlignPoint(Z, ["b", "r"]), Pt = k.overflow || {}, dt = Pt.adjustX, mt = Pt.adjustY, pt = Pt.shiftX, Et = Pt.shiftY, Mt = function(Fr) {
        return typeof Fr == "boolean" ? Fr : Fr >= 0;
      }, Nt, _t, Ot, rt;
      Nr();
      var et = Mt(mt), Ye = Xe[0] === Ge[0];
      if (et && Xe[0] === "t" && (_t > $e.bottom || m.current.bt)) {
        var tt = Ve;
        Ye ? tt -= ie - ge : tt = Qe.y - vt.y - Be;
        var Ke = lr(We, tt), qe = lr(We, tt, xe);
        // Of course use larger one
        Ke > ut || Ke === ut && (!ye || // Choose recommend one
        qe >= at) ? (m.current.bt = !0, Ve = tt, Be = -Be, it.points = [reversePoints(Xe, 0), reversePoints(Ge, 0)]) : m.current.bt = !1;
      }
      if (et && Xe[0] === "b" && (Nt < $e.top || m.current.tb)) {
        var ot = Ve;
        Ye ? ot += ie - ge : ot = ft.y - st.y - Be;
        var Je = lr(We, ot), Ct = lr(We, ot, xe);
        // Of course use larger one
        Je > ut || Je === ut && (!ye || // Choose recommend one
        Ct >= at) ? (m.current.tb = !0, Ve = ot, Be = -Be, it.points = [reversePoints(Xe, 0), reversePoints(Ge, 0)]) : m.current.tb = !1;
      }
      var Tt = Mt(dt), yt = Xe[1] === Ge[1];
      if (Tt && Xe[1] === "l" && (rt > $e.right || m.current.rl)) {
        var bt = We;
        yt ? bt -= fe - me : bt = Qe.x - vt.x - Re;
        var It = lr(bt, Ve), kt = lr(bt, Ve, xe);
        // Of course use larger one
        It > ut || It === ut && (!ye || // Choose recommend one
        kt >= at) ? (m.current.rl = !0, We = bt, Re = -Re, it.points = [reversePoints(Xe, 1), reversePoints(Ge, 1)]) : m.current.rl = !1;
      }
      if (Tt && Xe[1] === "r" && (Ot < $e.left || m.current.lr)) {
        var $t = We;
        yt ? $t += fe - me : $t = ft.x - st.x - Re;
        var Lt = lr($t, Ve), Ft = lr($t, Ve, xe);
        // Of course use larger one
        Lt > ut || Lt === ut && (!ye || // Choose recommend one
        Ft >= at) ? (m.current.lr = !0, We = $t, Re = -Re, it.points = [reversePoints(Xe, 1), reversePoints(Ge, 1)]) : m.current.lr = !1;
      }
      Nr();
      var Vt = pt === !0 ? 0 : pt;
      typeof Vt == "number" && (Ot < xe.left && (We -= Ot - xe.left - Re, P.x + me < xe.left + Vt && (We += P.x - xe.left + me - Vt)), rt > xe.right && (We -= rt - xe.right - Re, P.x > xe.right - Vt && (We += P.x - xe.right + Vt)));
      var rr = Et === !0 ? 0 : Et;
      typeof rr == "number" && (Nt < xe.top && (Ve -= Nt - xe.top - Be, P.y + ge < xe.top + rr && (Ve += P.y - xe.top + ge - rr)), _t > xe.bottom && (Ve -= _t - xe.bottom - Be, P.y > xe.bottom - rr && (Ve += P.y - xe.bottom + rr)));
      var br = Z.x + We, Gt = br + fe, qt = Z.y + Ve, Jt = qt + ie, jt = P.x, Ht = jt + me, ur = P.y, Qt = ur + ge, Yt = Math.max(br, jt), dr = Math.min(Gt, Ht), Ar = (Yt + dr) / 2, wr = Ar - br, Ir = Math.max(qt, ur), _r = Math.min(Jt, Qt), kr = (Ir + _r) / 2, zt = kr - qt;
      v?.(s, it);
      var Dt = Ae.right - Z.x - (We + Z.width), nr = Ae.bottom - Z.y - (Ve + Z.height);
      ue === 1 && (We = Math.round(We), Dt = Math.round(Dt)), ce === 1 && (Ve = Math.round(Ve), nr = Math.round(nr));
      var gr = {
        ready: !0,
        offsetX: We / ue,
        offsetY: Ve / ce,
        offsetR: Dt / ue,
        offsetB: nr / ce,
        arrowX: wr / ue,
        arrowY: zt / ce,
        scaleX: ue,
        scaleY: ce,
        align: it
      };
      b(gr);
    }
  }), S = function() {
    y.current += 1;
    var I = y.current;
    Promise.resolve().then(function() {
      y.current === I && w();
    });
  }, $ = function() {
    b(function(I) {
      return _objectSpread2$1(_objectSpread2$1({}, I), {}, {
        ready: !1
      });
    });
  };
  return useLayoutEffect$1($, [u]), useLayoutEffect$1(function() {
    a || $();
  }, [a]), [g.ready, g.offsetX, g.offsetY, g.offsetR, g.offsetB, g.arrowX, g.arrowY, g.scaleX, g.scaleY, g.align, S];
}
function useWatch(a, s, c, u, d) {
  useLayoutEffect$1(function() {
    if (a && s && c) {
      let y = function() {
        u(), d();
      };
      var p = s, v = c, A = collectScroller(p), x = collectScroller(v), g = getWin(v), b = new Set([g].concat(_toConsumableArray$e(A), _toConsumableArray$e(x)));
      return b.forEach(function(f) {
        f.addEventListener("scroll", y, {
          passive: !0
        });
      }), g.addEventListener("resize", y, {
        passive: !0
      }), u(), function() {
        b.forEach(function(f) {
          f.removeEventListener("scroll", y), g.removeEventListener("resize", y);
        });
      };
    }
  }, [a, s, c]);
}
function useWinClick(a, s, c, u, d, p, v, A) {
  var x = reactExports.useRef(a);
  x.current = a;
  var g = reactExports.useRef(!1);
  reactExports.useEffect(function() {
    if (s && u && (!d || p)) {
      var y = function() {
        g.current = !1;
      }, f = function(S) {
        var $;
        x.current && !v((($ = S.composedPath) === null || $ === void 0 || ($ = $.call(S)) === null || $ === void 0 ? void 0 : $[0]) || S.target) && !g.current && A(!1);
      }, m = getWin(u);
      m.addEventListener("pointerdown", y, !0), m.addEventListener("mousedown", f, !0), m.addEventListener("contextmenu", f, !0);
      var C = getShadowRoot$2(c);
      return C && (C.addEventListener("mousedown", f, !0), C.addEventListener("contextmenu", f, !0)), function() {
        m.removeEventListener("pointerdown", y, !0), m.removeEventListener("mousedown", f, !0), m.removeEventListener("contextmenu", f, !0), C && (C.removeEventListener("mousedown", f, !0), C.removeEventListener("contextmenu", f, !0));
      };
    }
  }, [s, c, u, d, p]);
  function b() {
    g.current = !0;
  }
  return b;
}
var _excluded$Q = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Portal, s = /* @__PURE__ */ reactExports.forwardRef(function(c, u) {
    var d = c.prefixCls, p = d === void 0 ? "rc-trigger-popup" : d, v = c.children, A = c.action, x = A === void 0 ? "hover" : A, g = c.showAction, b = c.hideAction, y = c.popupVisible, f = c.defaultPopupVisible, m = c.onPopupVisibleChange, C = c.afterPopupVisibleChange, w = c.mouseEnterDelay, S = c.mouseLeaveDelay, $ = S === void 0 ? 0.1 : S, T = c.focusDelay, I = c.blurDelay, _ = c.mask, E = c.maskClosable, R = E === void 0 ? !0 : E, O = c.getPopupContainer, L = c.forceRender, B = c.autoDestroy, F = c.destroyPopupOnHide, M = c.popup, W = c.popupClassName, j = c.popupStyle, G = c.popupPlacement, U = c.builtinPlacements, k = U === void 0 ? {} : U, N = c.popupAlign, P = c.zIndex, D = c.stretch, H = c.getPopupClassNameFromAlign, V = c.fresh, Z = c.alignPoint, ne = c.onPopupClick, K = c.onPopupAlign, q = c.arrow, Y = c.popupMotion, ee = c.maskMotion, Q = c.popupTransitionName, J = c.popupAnimation, te = c.maskTransitionName, ae = c.maskAnimation, se = c.className, ie = c.getTriggerDOMNode, fe = _objectWithoutProperties$2(c, _excluded$Q), ge = B || F || !1, me = reactExports.useState(!1), pe = _slicedToArray$e(me, 2), be = pe[0], le = pe[1];
    useLayoutEffect$1(function() {
      le(isMobile$1());
    }, []);
    var ve = reactExports.useRef({}), he = reactExports.useContext(TriggerContext), ye = reactExports.useMemo(function() {
      return {
        registerSubPopup: function(sr, Tr) {
          ve.current[sr] = Tr, he?.registerSubPopup(sr, Tr);
        }
      };
    }, [he]), Ce = useId$2(), xe = reactExports.useState(null), we = _slicedToArray$e(xe, 2), $e = we[0], Ae = we[1], ue = reactExports.useRef(null), ce = useEvent(function(Xt) {
      ue.current = Xt, isDOM(Xt) && $e !== Xt && Ae(Xt), he?.registerSubPopup(Ce, Xt);
    }), Ee = reactExports.useState(null), _e = _slicedToArray$e(Ee, 2), Te = _e[0], ke = _e[1], Re = reactExports.useRef(null), Be = useEvent(function(Xt) {
      isDOM(Xt) && Te !== Xt && (ke(Xt), Re.current = Xt);
    }), Oe = reactExports.Children.only(v), Me = Oe?.props || {}, Fe = {}, Ue = useEvent(function(Xt) {
      var sr, Tr, Lr = Te;
      return Lr?.contains(Xt) || ((sr = getShadowRoot$2(Lr)) === null || sr === void 0 ? void 0 : sr.host) === Xt || Xt === Lr || $e?.contains(Xt) || ((Tr = getShadowRoot$2($e)) === null || Tr === void 0 ? void 0 : Tr.host) === Xt || Xt === $e || Object.values(ve.current).some(function(Rr) {
        return Rr?.contains(Xt) || Xt === Rr;
      });
    }), je = getMotion$1(p, Y, J, Q), Le = getMotion$1(p, ee, ae, te), De = reactExports.useState(f || !1), Ne = _slicedToArray$e(De, 2), Ge = Ne[0], Xe = Ne[1], nt = y ?? Ge, ct = useEvent(function(Xt) {
      y === void 0 && Xe(Xt);
    });
    useLayoutEffect$1(function() {
      Xe(y || !1);
    }, [y]);
    var it = reactExports.useRef(nt);
    it.current = nt;
    var We = reactExports.useRef([]);
    We.current = [];
    var Ve = useEvent(function(Xt) {
      var sr;
      ct(Xt), ((sr = We.current[We.current.length - 1]) !== null && sr !== void 0 ? sr : nt) !== Xt && (We.current.push(Xt), m?.(Xt));
    }), ut = reactExports.useRef(), at = function() {
      clearTimeout(ut.current);
    }, Qe = function(sr) {
      var Tr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      at(), Tr === 0 ? Ve(sr) : ut.current = setTimeout(function() {
        Ve(sr);
      }, Tr * 1e3);
    };
    reactExports.useEffect(function() {
      return at;
    }, []);
    var st = reactExports.useState(!1), ft = _slicedToArray$e(st, 2), vt = ft[0], Pt = ft[1];
    useLayoutEffect$1(function(Xt) {
      (!Xt || nt) && Pt(!0);
    }, [nt]);
    var dt = reactExports.useState(null), mt = _slicedToArray$e(dt, 2), pt = mt[0], Et = mt[1], Mt = reactExports.useState(null), Nt = _slicedToArray$e(Mt, 2), _t = Nt[0], Ot = Nt[1], rt = function(sr) {
      Ot([sr.clientX, sr.clientY]);
    }, et = useAlign(nt, $e, Z && _t !== null ? _t : Te, G, k, N, K), Ye = _slicedToArray$e(et, 11), tt = Ye[0], Ke = Ye[1], qe = Ye[2], ot = Ye[3], Je = Ye[4], Ct = Ye[5], Tt = Ye[6], yt = Ye[7], bt = Ye[8], It = Ye[9], kt = Ye[10], $t = useAction(be, x, g, b), Lt = _slicedToArray$e($t, 2), Ft = Lt[0], Vt = Lt[1], rr = Ft.has("click"), br = Vt.has("click") || Vt.has("contextMenu"), Gt = useEvent(function() {
      vt || kt();
    }), qt = function() {
      it.current && Z && br && Qe(!1);
    };
    useWatch(nt, Te, $e, Gt, qt), useLayoutEffect$1(function() {
      Gt();
    }, [_t, G]), useLayoutEffect$1(function() {
      nt && !(k != null && k[G]) && Gt();
    }, [JSON.stringify(N)]);
    var Jt = reactExports.useMemo(function() {
      var Xt = getAlignPopupClassName(k, p, It, Z);
      return classnames(Xt, H?.(It));
    }, [It, H, k, p, Z]);
    reactExports.useImperativeHandle(u, function() {
      return {
        nativeElement: Re.current,
        popupElement: ue.current,
        forceAlign: Gt
      };
    });
    var jt = reactExports.useState(0), Ht = _slicedToArray$e(jt, 2), ur = Ht[0], Qt = Ht[1], Yt = reactExports.useState(0), dr = _slicedToArray$e(Yt, 2), Ar = dr[0], wr = dr[1], Ir = function() {
      if (D && Te) {
        var sr = Te.getBoundingClientRect();
        Qt(sr.width), wr(sr.height);
      }
    }, _r = function() {
      Ir(), Gt();
    }, kr = function(sr) {
      Pt(!1), kt(), C?.(sr);
    }, zt = function() {
      return new Promise(function(sr) {
        Ir(), Et(function() {
          return sr;
        });
      });
    };
    useLayoutEffect$1(function() {
      pt && (kt(), pt(), Et(null));
    }, [pt]);
    function Dt(Xt, sr, Tr, Lr) {
      Fe[Xt] = function(Rr) {
        var ht;
        Lr?.(Rr), Qe(sr, Tr);
        for (var oe = arguments.length, Ie = new Array(oe > 1 ? oe - 1 : 0), lt = 1; lt < oe; lt++)
          Ie[lt - 1] = arguments[lt];
        (ht = Me[Xt]) === null || ht === void 0 || ht.call.apply(ht, [Me, Rr].concat(Ie));
      };
    }
    (rr || br) && (Fe.onClick = function(Xt) {
      var sr;
      it.current && br ? Qe(!1) : !it.current && rr && (rt(Xt), Qe(!0));
      for (var Tr = arguments.length, Lr = new Array(Tr > 1 ? Tr - 1 : 0), Rr = 1; Rr < Tr; Rr++)
        Lr[Rr - 1] = arguments[Rr];
      (sr = Me.onClick) === null || sr === void 0 || sr.call.apply(sr, [Me, Xt].concat(Lr));
    });
    var nr = useWinClick(nt, br, Te, $e, _, R, Ue, Qe), gr = Ft.has("hover"), lr = Vt.has("hover"), Nr, Wr;
    gr && (Dt("onMouseEnter", !0, w, function(Xt) {
      rt(Xt);
    }), Dt("onPointerEnter", !0, w, function(Xt) {
      rt(Xt);
    }), Nr = function(sr) {
      (nt || vt) && $e !== null && $e !== void 0 && $e.contains(sr.target) && Qe(!0, w);
    }, Z && (Fe.onMouseMove = function(Xt) {
      var sr;
      (sr = Me.onMouseMove) === null || sr === void 0 || sr.call(Me, Xt);
    })), lr && (Dt("onMouseLeave", !1, $), Dt("onPointerLeave", !1, $), Wr = function() {
      Qe(!1, $);
    }), Ft.has("focus") && Dt("onFocus", !0, T), Vt.has("focus") && Dt("onBlur", !1, I), Ft.has("contextMenu") && (Fe.onContextMenu = function(Xt) {
      var sr;
      it.current && Vt.has("contextMenu") ? Qe(!1) : (rt(Xt), Qe(!0)), Xt.preventDefault();
      for (var Tr = arguments.length, Lr = new Array(Tr > 1 ? Tr - 1 : 0), Rr = 1; Rr < Tr; Rr++)
        Lr[Rr - 1] = arguments[Rr];
      (sr = Me.onContextMenu) === null || sr === void 0 || sr.call.apply(sr, [Me, Xt].concat(Lr));
    }), se && (Fe.className = classnames(Me.className, se));
    var Fr = _objectSpread2$1(_objectSpread2$1({}, Me), Fe), Qr = {}, an = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    an.forEach(function(Xt) {
      fe[Xt] && (Qr[Xt] = function() {
        for (var sr, Tr = arguments.length, Lr = new Array(Tr), Rr = 0; Rr < Tr; Rr++)
          Lr[Rr] = arguments[Rr];
        (sr = Fr[Xt]) === null || sr === void 0 || sr.call.apply(sr, [Fr].concat(Lr)), fe[Xt].apply(fe, Lr);
      });
    });
    var cn = /* @__PURE__ */ reactExports.cloneElement(Oe, _objectSpread2$1(_objectSpread2$1({}, Fr), Qr)), yn = {
      x: Ct,
      y: Tt
    }, _n = q ? _objectSpread2$1({}, q !== !0 ? q : {}) : null;
    return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
      disabled: !nt,
      ref: Be,
      onResize: _r
    }, /* @__PURE__ */ reactExports.createElement(TriggerWrapper, {
      getTriggerDOMNode: ie
    }, cn)), /* @__PURE__ */ reactExports.createElement(TriggerContext.Provider, {
      value: ye
    }, /* @__PURE__ */ reactExports.createElement(Popup$3, {
      portal: a,
      ref: ce,
      prefixCls: p,
      popup: M,
      className: classnames(W, Jt),
      style: j,
      target: Te,
      onMouseEnter: Nr,
      onMouseLeave: Wr,
      onPointerEnter: Nr,
      zIndex: P,
      open: nt,
      keepDom: vt,
      fresh: V,
      onClick: ne,
      onPointerDownCapture: nr,
      mask: _,
      motion: je,
      maskMotion: Le,
      onVisibleChanged: kr,
      onPrepare: zt,
      forceRender: L,
      autoDestroy: ge,
      getPopupContainer: O,
      align: It,
      arrow: _n,
      arrowPos: yn,
      ready: tt,
      offsetX: Ke,
      offsetY: qe,
      offsetR: ot,
      offsetB: Je,
      onAlign: Gt,
      stretch: D,
      targetWidth: ur / yt,
      targetHeight: Ar / bt
    })));
  });
  return s;
}
const Trigger$1 = generateTrigger(Portal);
var _excluded$P = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], getBuiltInPlacements$1 = function a(s) {
  var c = s === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: c,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: c,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: c,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: c,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, SelectTrigger = function a(s, c) {
  var u = s.prefixCls;
  s.disabled;
  var d = s.visible, p = s.children, v = s.popupElement, A = s.animation, x = s.transitionName, g = s.dropdownStyle, b = s.dropdownClassName, y = s.direction, f = y === void 0 ? "ltr" : y, m = s.placement, C = s.builtinPlacements, w = s.dropdownMatchSelectWidth, S = s.dropdownRender, $ = s.dropdownAlign, T = s.getPopupContainer, I = s.empty, _ = s.getTriggerDOMNode, E = s.onPopupVisibleChange, R = s.onPopupMouseEnter, O = _objectWithoutProperties$2(s, _excluded$P), L = "".concat(u, "-dropdown"), B = v;
  S && (B = S(v));
  var F = reactExports.useMemo(function() {
    return C || getBuiltInPlacements$1(w);
  }, [C, w]), M = A ? "".concat(L, "-").concat(A) : x, W = typeof w == "number", j = reactExports.useMemo(function() {
    return W ? null : w === !1 ? "minWidth" : "width";
  }, [w, W]), G = g;
  W && (G = _objectSpread2$1(_objectSpread2$1({}, G), {}, {
    width: w
  }));
  var U = reactExports.useRef(null);
  return reactExports.useImperativeHandle(c, function() {
    return {
      getPopupElement: function() {
        var N;
        return (N = U.current) === null || N === void 0 ? void 0 : N.popupElement;
      }
    };
  }), /* @__PURE__ */ reactExports.createElement(Trigger$1, _extends$3({}, O, {
    showAction: E ? ["click"] : [],
    hideAction: E ? ["click"] : [],
    popupPlacement: m || (f === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: F,
    prefixCls: L,
    popupTransitionName: M,
    popup: /* @__PURE__ */ reactExports.createElement("div", {
      onMouseEnter: R
    }, B),
    ref: U,
    stretch: j,
    popupAlign: $,
    popupVisible: d,
    getPopupContainer: T,
    popupClassName: classnames(b, _defineProperty$a({}, "".concat(L, "-empty"), I)),
    popupStyle: G,
    getTriggerDOMNode: _,
    onPopupVisibleChange: E
  }), p);
}, RefSelectTrigger = /* @__PURE__ */ reactExports.forwardRef(SelectTrigger);
function getKey$2(a, s) {
  var c = a.key, u;
  return "value" in a && (u = a.value), c ?? (u !== void 0 ? u : "rc-index-key-".concat(s));
}
function isValidCount(a) {
  return typeof a < "u" && !Number.isNaN(a);
}
function fillFieldNames$2(a, s) {
  var c = a || {}, u = c.label, d = c.value, p = c.options, v = c.groupLabel, A = u || (s ? "children" : "label");
  return {
    label: A,
    value: d || "value",
    options: p || "options",
    groupLabel: v || A
  };
}
function flattenOptions(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = s.fieldNames, u = s.childrenAsData, d = [], p = fillFieldNames$2(c, !1), v = p.label, A = p.value, x = p.options, g = p.groupLabel;
  function b(y, f) {
    Array.isArray(y) && y.forEach(function(m) {
      if (f || !(x in m)) {
        var C = m[A];
        d.push({
          key: getKey$2(m, d.length),
          groupOption: f,
          data: m,
          label: m[v],
          value: C
        });
      } else {
        var w = m[g];
        w === void 0 && u && (w = m.label), d.push({
          key: getKey$2(m, d.length),
          group: !0,
          data: m,
          label: w
        }), b(m[x], !0);
      }
    });
  }
  return b(a, !1), d;
}
function injectPropsWithOption(a) {
  var s = _objectSpread2$1({}, a);
  return "props" in s || Object.defineProperty(s, "props", {
    get: function() {
      return warningOnce(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), s;
    }
  }), s;
}
var getSeparatedContent = function a(s, c, u) {
  if (!c || !c.length)
    return null;
  var d = !1, p = function A(x, g) {
    var b = _toArray$1(g), y = b[0], f = b.slice(1);
    if (!y)
      return [x];
    var m = x.split(y);
    return d = d || m.length > 1, m.reduce(function(C, w) {
      return [].concat(_toConsumableArray$e(C), _toConsumableArray$e(A(w, f)));
    }, []).filter(Boolean);
  }, v = p(s, c);
  return d ? typeof u < "u" ? v.slice(0, u) : v : null;
}, SelectContext = /* @__PURE__ */ reactExports.createContext(null);
function Polite(a) {
  var s = a.visible, c = a.values;
  if (!s)
    return null;
  var u = 50;
  return /* @__PURE__ */ reactExports.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(c.slice(0, u).map(function(d) {
    var p = d.label, v = d.value;
    return ["number", "string"].includes(_typeof$h(p)) ? p : v;
  }).join(", ")), c.length > u ? ", ..." : null);
}
var _excluded$O = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], isMultiple = function a(s) {
  return s === "tags" || s === "multiple";
}, BaseSelect = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c, u = a.id, d = a.prefixCls, p = a.className, v = a.showSearch, A = a.tagRender, x = a.direction, g = a.omitDomProps, b = a.displayValues, y = a.onDisplayValuesChange, f = a.emptyOptions, m = a.notFoundContent, C = m === void 0 ? "Not Found" : m, w = a.onClear, S = a.mode, $ = a.disabled, T = a.loading, I = a.getInputElement, _ = a.getRawInputElement, E = a.open, R = a.defaultOpen, O = a.onDropdownVisibleChange, L = a.activeValue, B = a.onActiveValueChange, F = a.activeDescendantId, M = a.searchValue, W = a.autoClearSearchValue, j = a.onSearch, G = a.onSearchSplit, U = a.tokenSeparators, k = a.allowClear, N = a.prefix, P = a.suffixIcon, D = a.clearIcon, H = a.OptionList, V = a.animation, Z = a.transitionName, ne = a.dropdownStyle, K = a.dropdownClassName, q = a.dropdownMatchSelectWidth, Y = a.dropdownRender, ee = a.dropdownAlign, Q = a.placement, J = a.builtinPlacements, te = a.getPopupContainer, ae = a.showAction, se = ae === void 0 ? [] : ae, ie = a.onFocus, fe = a.onBlur, ge = a.onKeyUp, me = a.onKeyDown, pe = a.onMouseDown, be = _objectWithoutProperties$2(a, _excluded$O), le = isMultiple(S), ve = (v !== void 0 ? v : le) || S === "combobox", he = _objectSpread2$1({}, be);
  DEFAULT_OMIT_PROPS.forEach(function(jt) {
    delete he[jt];
  }), g?.forEach(function(jt) {
    delete he[jt];
  });
  var ye = reactExports.useState(!1), Ce = _slicedToArray$e(ye, 2), xe = Ce[0], we = Ce[1];
  reactExports.useEffect(function() {
    we(isMobile$1());
  }, []);
  var $e = reactExports.useRef(null), Ae = reactExports.useRef(null), ue = reactExports.useRef(null), ce = reactExports.useRef(null), Ee = reactExports.useRef(null), _e = reactExports.useRef(!1), Te = useDelayReset(), ke = _slicedToArray$e(Te, 3), Re = ke[0], Be = ke[1], Oe = ke[2];
  reactExports.useImperativeHandle(s, function() {
    var jt, Ht;
    return {
      focus: (jt = ce.current) === null || jt === void 0 ? void 0 : jt.focus,
      blur: (Ht = ce.current) === null || Ht === void 0 ? void 0 : Ht.blur,
      scrollTo: function(Qt) {
        var Yt;
        return (Yt = Ee.current) === null || Yt === void 0 ? void 0 : Yt.scrollTo(Qt);
      },
      nativeElement: $e.current || Ae.current
    };
  });
  var Me = reactExports.useMemo(function() {
    var jt;
    if (S !== "combobox")
      return M;
    var Ht = (jt = b[0]) === null || jt === void 0 ? void 0 : jt.value;
    return typeof Ht == "string" || typeof Ht == "number" ? String(Ht) : "";
  }, [M, S, b]), Fe = S === "combobox" && typeof I == "function" && I() || null, Ue = typeof _ == "function" && _(), je = useComposeRef(Ae, Ue == null || (c = Ue.props) === null || c === void 0 ? void 0 : c.ref), Le = reactExports.useState(!1), De = _slicedToArray$e(Le, 2), Ne = De[0], Ge = De[1];
  useLayoutEffect$1(function() {
    Ge(!0);
  }, []);
  var Xe = useMergedState(!1, {
    defaultValue: R,
    value: E
  }), nt = _slicedToArray$e(Xe, 2), ct = nt[0], it = nt[1], We = Ne ? ct : !1, Ve = !C && f;
  ($ || Ve && We && S === "combobox") && (We = !1);
  var ut = Ve ? !1 : We, at = reactExports.useCallback(function(jt) {
    var Ht = jt !== void 0 ? jt : !We;
    $ || (it(Ht), We !== Ht && O?.(Ht));
  }, [$, We, it, O]), Qe = reactExports.useMemo(function() {
    return (U || []).some(function(jt) {
      return [`
`, `\r
`].includes(jt);
    });
  }, [U]), st = reactExports.useContext(SelectContext) || {}, ft = st.maxCount, vt = st.rawValues, Pt = function(Ht, ur, Qt) {
    if (!(le && isValidCount(ft) && vt?.size >= ft)) {
      var Yt = !0, dr = Ht;
      B?.(null);
      var Ar = getSeparatedContent(Ht, U, isValidCount(ft) ? ft - vt.size : void 0), wr = Qt ? null : Ar;
      return S !== "combobox" && wr && (dr = "", G?.(wr), at(!1), Yt = !1), j && Me !== dr && j(dr, {
        source: ur ? "typing" : "effect"
      }), Yt;
    }
  }, dt = function(Ht) {
    !Ht || !Ht.trim() || j(Ht, {
      source: "submit"
    });
  };
  reactExports.useEffect(function() {
    !We && !le && S !== "combobox" && Pt("", !1, !1);
  }, [We]), reactExports.useEffect(function() {
    ct && $ && it(!1), $ && !_e.current && Be(!1);
  }, [$]);
  var mt = useLock(), pt = _slicedToArray$e(mt, 2), Et = pt[0], Mt = pt[1], Nt = reactExports.useRef(!1), _t = function(Ht) {
    var ur = Et(), Qt = Ht.key, Yt = Qt === "Enter";
    if (Yt && (S !== "combobox" && Ht.preventDefault(), We || at(!0)), Mt(!!Me), Qt === "Backspace" && !ur && le && !Me && b.length) {
      for (var dr = _toConsumableArray$e(b), Ar = null, wr = dr.length - 1; wr >= 0; wr -= 1) {
        var Ir = dr[wr];
        if (!Ir.disabled) {
          dr.splice(wr, 1), Ar = Ir;
          break;
        }
      }
      Ar && y(dr, {
        type: "remove",
        values: [Ar]
      });
    }
    for (var _r = arguments.length, kr = new Array(_r > 1 ? _r - 1 : 0), zt = 1; zt < _r; zt++)
      kr[zt - 1] = arguments[zt];
    if (We && (!Yt || !Nt.current)) {
      var Dt;
      Yt && (Nt.current = !0), (Dt = Ee.current) === null || Dt === void 0 || Dt.onKeyDown.apply(Dt, [Ht].concat(kr));
    }
    me?.apply(void 0, [Ht].concat(kr));
  }, Ot = function(Ht) {
    for (var ur = arguments.length, Qt = new Array(ur > 1 ? ur - 1 : 0), Yt = 1; Yt < ur; Yt++)
      Qt[Yt - 1] = arguments[Yt];
    if (We) {
      var dr;
      (dr = Ee.current) === null || dr === void 0 || dr.onKeyUp.apply(dr, [Ht].concat(Qt));
    }
    Ht.key === "Enter" && (Nt.current = !1), ge?.apply(void 0, [Ht].concat(Qt));
  }, rt = function(Ht) {
    var ur = b.filter(function(Qt) {
      return Qt !== Ht;
    });
    y(ur, {
      type: "remove",
      values: [Ht]
    });
  }, et = function() {
    Nt.current = !1;
  }, Ye = reactExports.useRef(!1), tt = function() {
    Be(!0), $ || (ie && !Ye.current && ie.apply(void 0, arguments), se.includes("focus") && at(!0)), Ye.current = !0;
  }, Ke = function() {
    _e.current = !0, Be(!1, function() {
      Ye.current = !1, _e.current = !1, at(!1);
    }), !$ && (Me && (S === "tags" ? j(Me, {
      source: "submit"
    }) : S === "multiple" && j("", {
      source: "blur"
    })), fe && fe.apply(void 0, arguments));
  }, qe = [];
  reactExports.useEffect(function() {
    return function() {
      qe.forEach(function(jt) {
        return clearTimeout(jt);
      }), qe.splice(0, qe.length);
    };
  }, []);
  var ot = function(Ht) {
    var ur, Qt = Ht.target, Yt = (ur = ue.current) === null || ur === void 0 ? void 0 : ur.getPopupElement();
    if (Yt && Yt.contains(Qt)) {
      var dr = setTimeout(function() {
        var _r = qe.indexOf(dr);
        if (_r !== -1 && qe.splice(_r, 1), Oe(), !xe && !Yt.contains(document.activeElement)) {
          var kr;
          (kr = ce.current) === null || kr === void 0 || kr.focus();
        }
      });
      qe.push(dr);
    }
    for (var Ar = arguments.length, wr = new Array(Ar > 1 ? Ar - 1 : 0), Ir = 1; Ir < Ar; Ir++)
      wr[Ir - 1] = arguments[Ir];
    pe?.apply(void 0, [Ht].concat(wr));
  }, Je = reactExports.useState({}), Ct = _slicedToArray$e(Je, 2), Tt = Ct[1];
  function yt() {
    Tt({});
  }
  var bt;
  Ue && (bt = function(Ht) {
    at(Ht);
  }), useSelectTriggerControl(function() {
    var jt;
    return [$e.current, (jt = ue.current) === null || jt === void 0 ? void 0 : jt.getPopupElement()];
  }, ut, at, !!Ue);
  var It = reactExports.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, a), {}, {
      notFoundContent: C,
      open: We,
      triggerOpen: ut,
      id: u,
      showSearch: ve,
      multiple: le,
      toggleOpen: at
    });
  }, [a, C, ut, We, u, ve, le, at]), kt = !!P || T, $t;
  kt && ($t = /* @__PURE__ */ reactExports.createElement(TransBtn, {
    className: classnames("".concat(d, "-arrow"), _defineProperty$a({}, "".concat(d, "-arrow-loading"), T)),
    customizeIcon: P,
    customizeIconProps: {
      loading: T,
      searchValue: Me,
      open: We,
      focused: Re,
      showSearch: ve
    }
  }));
  var Lt = function() {
    var Ht;
    w?.(), (Ht = ce.current) === null || Ht === void 0 || Ht.focus(), y([], {
      type: "clear",
      values: b
    }), Pt("", !1, !1);
  }, Ft = useAllowClear(d, Lt, b, k, D, $, Me, S), Vt = Ft.allowClear, rr = Ft.clearIcon, br = /* @__PURE__ */ reactExports.createElement(H, {
    ref: Ee
  }), Gt = classnames(d, p, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(d, "-focused"), Re), "".concat(d, "-multiple"), le), "".concat(d, "-single"), !le), "".concat(d, "-allow-clear"), k), "".concat(d, "-show-arrow"), kt), "".concat(d, "-disabled"), $), "".concat(d, "-loading"), T), "".concat(d, "-open"), We), "".concat(d, "-customize-input"), Fe), "".concat(d, "-show-search"), ve)), qt = /* @__PURE__ */ reactExports.createElement(RefSelectTrigger, {
    ref: ue,
    disabled: $,
    prefixCls: d,
    visible: ut,
    popupElement: br,
    animation: V,
    transitionName: Z,
    dropdownStyle: ne,
    dropdownClassName: K,
    direction: x,
    dropdownMatchSelectWidth: q,
    dropdownRender: Y,
    dropdownAlign: ee,
    placement: Q,
    builtinPlacements: J,
    getPopupContainer: te,
    empty: f,
    getTriggerDOMNode: function(Ht) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        Ae.current || Ht
      );
    },
    onPopupVisibleChange: bt,
    onPopupMouseEnter: yt
  }, Ue ? /* @__PURE__ */ reactExports.cloneElement(Ue, {
    ref: je
  }) : /* @__PURE__ */ reactExports.createElement(ForwardSelector, _extends$3({}, a, {
    domRef: Ae,
    prefixCls: d,
    inputElement: Fe,
    ref: ce,
    id: u,
    prefix: N,
    showSearch: ve,
    autoClearSearchValue: W,
    mode: S,
    activeDescendantId: F,
    tagRender: A,
    values: b,
    open: We,
    onToggleOpen: at,
    activeValue: L,
    searchValue: Me,
    onSearch: Pt,
    onSearchSubmit: dt,
    onRemove: rt,
    tokenWithEnter: Qe,
    onInputBlur: et
  }))), Jt;
  return Ue ? Jt = qt : Jt = /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    className: Gt
  }, he, {
    ref: $e,
    onMouseDown: ot,
    onKeyDown: _t,
    onKeyUp: Ot,
    onFocus: tt,
    onBlur: Ke
  }), /* @__PURE__ */ reactExports.createElement(Polite, {
    visible: Re && !We,
    values: b
  }), qt, $t, Vt && rr), /* @__PURE__ */ reactExports.createElement(BaseSelectContext.Provider, {
    value: It
  }, Jt);
}), OptGroup = function a() {
  return null;
};
OptGroup.isSelectOptGroup = !0;
var Option = function a() {
  return null;
};
Option.isSelectOption = !0;
var Filler = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.height, u = a.offsetY, d = a.offsetX, p = a.children, v = a.prefixCls, A = a.onInnerResize, x = a.innerProps, g = a.rtl, b = a.extra, y = {}, f = {
    display: "flex",
    flexDirection: "column"
  };
  return u !== void 0 && (y = {
    height: c,
    position: "relative",
    overflow: "hidden"
  }, f = _objectSpread2$1(_objectSpread2$1({}, f), {}, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({
    transform: "translateY(".concat(u, "px)")
  }, g ? "marginRight" : "marginLeft", -d), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ reactExports.createElement("div", {
    style: y
  }, /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: function(C) {
      var w = C.offsetHeight;
      w && A && A();
    }
  }, /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    style: f,
    className: classnames(_defineProperty$a({}, "".concat(v, "-holder-inner"), v)),
    ref: s
  }, x), p, b)));
});
Filler.displayName = "Filler";
function Item$2(a) {
  var s = a.children, c = a.setRef, u = reactExports.useCallback(function(d) {
    c(d);
  }, []);
  return /* @__PURE__ */ reactExports.cloneElement(s, {
    ref: u
  });
}
function useChildren$1(a, s, c, u, d, p, v, A) {
  var x = A.getKey;
  return a.slice(s, c + 1).map(function(g, b) {
    var y = s + b, f = v(g, y, {
      style: {
        width: u
      },
      offsetX: d
    }), m = x(g);
    return /* @__PURE__ */ reactExports.createElement(Item$2, {
      key: m,
      setRef: function(w) {
        return p(g, w);
      }
    }, f);
  });
}
function findListDiffIndex(a, s, c) {
  var u = a.length, d = s.length, p, v;
  if (u === 0 && d === 0)
    return null;
  u < d ? (p = a, v = s) : (p = s, v = a);
  var A = {
    __EMPTY_ITEM__: !0
  };
  function x(C) {
    return C !== void 0 ? c(C) : A;
  }
  for (var g = null, b = Math.abs(u - d) !== 1, y = 0; y < v.length; y += 1) {
    var f = x(p[y]), m = x(v[y]);
    if (f !== m) {
      g = y, b = b || f !== x(v[y + 1]);
      break;
    }
  }
  return g === null ? null : {
    index: g,
    multiple: b
  };
}
function useDiffItem(a, s, c) {
  var u = reactExports.useState(a), d = _slicedToArray$e(u, 2), p = d[0], v = d[1], A = reactExports.useState(null), x = _slicedToArray$e(A, 2), g = x[0], b = x[1];
  return reactExports.useEffect(function() {
    var y = findListDiffIndex(p || [], a || [], s);
    y?.index !== void 0 && b(a[y.index]), v(a);
  }, [a]), [g];
}
var isFF = (typeof navigator > "u" ? "undefined" : _typeof$h(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const useOriginScroll = function(a, s, c, u) {
  var d = reactExports.useRef(!1), p = reactExports.useRef(null);
  function v() {
    clearTimeout(p.current), d.current = !0, p.current = setTimeout(function() {
      d.current = !1;
    }, 50);
  }
  var A = reactExports.useRef({
    top: a,
    bottom: s,
    left: c,
    right: u
  });
  return A.current.top = a, A.current.bottom = s, A.current.left = c, A.current.right = u, function(x, g) {
    var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, y = x ? (
      // Pass origin wheel when on the left
      g < 0 && A.current.left || // Pass origin wheel when on the right
      g > 0 && A.current.right
    ) : g < 0 && A.current.top || // Pass origin wheel when on the bottom
    g > 0 && A.current.bottom;
    return b && y ? (clearTimeout(p.current), d.current = !1) : (!y || d.current) && v(), !d.current && y;
  };
};
function useFrameWheel(a, s, c, u, d, p, v) {
  var A = reactExports.useRef(0), x = reactExports.useRef(null), g = reactExports.useRef(null), b = reactExports.useRef(!1), y = useOriginScroll(s, c, u, d);
  function f(T, I) {
    if (wrapperRaf.cancel(x.current), !y(!1, I)) {
      var _ = T;
      if (!_._virtualHandled)
        _._virtualHandled = !0;
      else
        return;
      A.current += I, g.current = I, isFF || _.preventDefault(), x.current = wrapperRaf(function() {
        var E = b.current ? 10 : 1;
        v(A.current * E, !1), A.current = 0;
      });
    }
  }
  function m(T, I) {
    v(I, !0), isFF || T.preventDefault();
  }
  var C = reactExports.useRef(null), w = reactExports.useRef(null);
  function S(T) {
    if (a) {
      wrapperRaf.cancel(w.current), w.current = wrapperRaf(function() {
        C.current = null;
      }, 2);
      var I = T.deltaX, _ = T.deltaY, E = T.shiftKey, R = I, O = _;
      (C.current === "sx" || !C.current && E && _ && !I) && (R = _, O = 0, C.current = "sx");
      var L = Math.abs(R), B = Math.abs(O);
      C.current === null && (C.current = p && L > B ? "x" : "y"), C.current === "y" ? f(T, O) : m(T, R);
    }
  }
  function $(T) {
    a && (b.current = T.detail === g.current);
  }
  return [S, $];
}
function useGetSize(a, s, c, u) {
  var d = reactExports.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [a, c.id, u]), p = _slicedToArray$e(d, 2), v = p[0], A = p[1], x = function(b) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b, f = v.get(b), m = v.get(y);
    if (f === void 0 || m === void 0)
      for (var C = a.length, w = A.length; w < C; w += 1) {
        var S, $ = a[w], T = s($);
        v.set(T, w);
        var I = (S = c.get(T)) !== null && S !== void 0 ? S : u;
        if (A[w] = (A[w - 1] || 0) + I, T === b && (f = w), T === y && (m = w), f !== void 0 && m !== void 0)
          break;
      }
    return {
      top: A[f - 1] || 0,
      bottom: A[m]
    };
  };
  return x;
}
var CacheMap = /* @__PURE__ */ function() {
  function a() {
    _classCallCheck$1(this, a), _defineProperty$a(this, "maps", void 0), _defineProperty$a(this, "id", 0), _defineProperty$a(this, "diffRecords", /* @__PURE__ */ new Map()), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return _createClass$1(a, [{
    key: "set",
    value: function(c, u) {
      this.diffRecords.set(c, this.maps[c]), this.maps[c] = u, this.id += 1;
    }
  }, {
    key: "get",
    value: function(c) {
      return this.maps[c];
    }
    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function() {
      this.diffRecords.clear();
    }
  }, {
    key: "getRecord",
    value: function() {
      return this.diffRecords;
    }
  }]), a;
}();
function parseNumber(a) {
  var s = parseFloat(a);
  return isNaN(s) ? 0 : s;
}
function useHeights(a, s, c) {
  var u = reactExports.useState(0), d = _slicedToArray$e(u, 2), p = d[0], v = d[1], A = reactExports.useRef(/* @__PURE__ */ new Map()), x = reactExports.useRef(new CacheMap()), g = reactExports.useRef(0);
  function b() {
    g.current += 1;
  }
  function y() {
    var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    b();
    var C = function() {
      var $ = !1;
      A.current.forEach(function(T, I) {
        if (T && T.offsetParent) {
          var _ = T.offsetHeight, E = getComputedStyle(T), R = E.marginTop, O = E.marginBottom, L = parseNumber(R), B = parseNumber(O), F = _ + L + B;
          x.current.get(I) !== F && (x.current.set(I, F), $ = !0);
        }
      }), $ && v(function(T) {
        return T + 1;
      });
    };
    if (m)
      C();
    else {
      g.current += 1;
      var w = g.current;
      Promise.resolve().then(function() {
        w === g.current && C();
      });
    }
  }
  function f(m, C) {
    var w = a(m);
    A.current.get(w), C ? (A.current.set(w, C), y()) : A.current.delete(w);
  }
  return reactExports.useEffect(function() {
    return b;
  }, []), [f, y, x.current, p];
}
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(a, s, c) {
  var u = reactExports.useRef(!1), d = reactExports.useRef(0), p = reactExports.useRef(0), v = reactExports.useRef(null), A = reactExports.useRef(null), x, g = function(m) {
    if (u.current) {
      var C = Math.ceil(m.touches[0].pageX), w = Math.ceil(m.touches[0].pageY), S = d.current - C, $ = p.current - w, T = Math.abs(S) > Math.abs($);
      T ? d.current = C : p.current = w;
      var I = c(T, T ? S : $, !1, m);
      I && m.preventDefault(), clearInterval(A.current), I && (A.current = setInterval(function() {
        T ? S *= SMOOTH_PTG : $ *= SMOOTH_PTG;
        var _ = Math.floor(T ? S : $);
        (!c(T, _, !0) || Math.abs(_) <= 0.1) && clearInterval(A.current);
      }, 16));
    }
  }, b = function() {
    u.current = !1, x();
  }, y = function(m) {
    x(), m.touches.length === 1 && !u.current && (u.current = !0, d.current = Math.ceil(m.touches[0].pageX), p.current = Math.ceil(m.touches[0].pageY), v.current = m.target, v.current.addEventListener("touchmove", g, {
      passive: !1
    }), v.current.addEventListener("touchend", b, {
      passive: !0
    }));
  };
  x = function() {
    v.current && (v.current.removeEventListener("touchmove", g), v.current.removeEventListener("touchend", b));
  }, useLayoutEffect$1(function() {
    return a && s.current.addEventListener("touchstart", y, {
      passive: !0
    }), function() {
      var f;
      (f = s.current) === null || f === void 0 || f.removeEventListener("touchstart", y), x(), clearInterval(A.current);
    };
  }, [a]);
}
function smoothScrollOffset(a) {
  return Math.floor(Math.pow(a, 0.5));
}
function getPageXY(a, s) {
  var c = "touches" in a ? a.touches[0] : a;
  return c[s ? "pageX" : "pageY"] - window[s ? "scrollX" : "scrollY"];
}
function useScrollDrag(a, s, c) {
  reactExports.useEffect(function() {
    var u = s.current;
    if (a && u) {
      var d = !1, p, v, A = function() {
        wrapperRaf.cancel(p);
      }, x = function f() {
        A(), p = wrapperRaf(function() {
          c(v), f();
        });
      }, g = function(m) {
        if (!(m.target.draggable || m.button !== 0)) {
          var C = m;
          C._virtualHandled || (C._virtualHandled = !0, d = !0);
        }
      }, b = function() {
        d = !1, A();
      }, y = function(m) {
        if (d) {
          var C = getPageXY(m, !1), w = u.getBoundingClientRect(), S = w.top, $ = w.bottom;
          if (C <= S) {
            var T = S - C;
            v = -smoothScrollOffset(T), x();
          } else if (C >= $) {
            var I = C - $;
            v = smoothScrollOffset(I), x();
          } else
            A();
        }
      };
      return u.addEventListener("mousedown", g), u.ownerDocument.addEventListener("mouseup", b), u.ownerDocument.addEventListener("mousemove", y), function() {
        u.removeEventListener("mousedown", g), u.ownerDocument.removeEventListener("mouseup", b), u.ownerDocument.removeEventListener("mousemove", y), A();
      };
    }
  }, [a]);
}
var MAX_TIMES = 10;
function useScrollTo$1(a, s, c, u, d, p, v, A) {
  var x = reactExports.useRef(), g = reactExports.useState(null), b = _slicedToArray$e(g, 2), y = b[0], f = b[1];
  return useLayoutEffect$1(function() {
    if (y && y.times < MAX_TIMES) {
      if (!a.current) {
        f(function(D) {
          return _objectSpread2$1({}, D);
        });
        return;
      }
      p();
      var m = y.targetAlign, C = y.originAlign, w = y.index, S = y.offset, $ = a.current.clientHeight, T = !1, I = m, _ = null;
      if ($) {
        for (var E = m || C, R = 0, O = 0, L = 0, B = Math.min(s.length - 1, w), F = 0; F <= B; F += 1) {
          var M = d(s[F]);
          O = R;
          var W = c.get(M);
          L = O + (W === void 0 ? u : W), R = L;
        }
        for (var j = E === "top" ? S : $ - S, G = B; G >= 0; G -= 1) {
          var U = d(s[G]), k = c.get(U);
          if (k === void 0) {
            T = !0;
            break;
          }
          if (j -= k, j <= 0)
            break;
        }
        switch (E) {
          case "top":
            _ = O - S;
            break;
          case "bottom":
            _ = L - $ + S;
            break;
          default: {
            var N = a.current.scrollTop, P = N + $;
            O < N ? I = "top" : L > P && (I = "bottom");
          }
        }
        _ !== null && v(_), _ !== y.lastTop && (T = !0);
      }
      T && f(_objectSpread2$1(_objectSpread2$1({}, y), {}, {
        times: y.times + 1,
        targetAlign: I,
        lastTop: _
      }));
    }
  }, [y, a.current]), function(m) {
    if (m == null) {
      A();
      return;
    }
    if (wrapperRaf.cancel(x.current), typeof m == "number")
      v(m);
    else if (m && _typeof$h(m) === "object") {
      var C, w = m.align;
      "index" in m ? C = m.index : C = s.findIndex(function(T) {
        return d(T) === m.key;
      });
      var S = m.offset, $ = S === void 0 ? 0 : S;
      f({
        times: 0,
        index: C,
        offset: $,
        originAlign: w
      });
    }
  };
}
var ScrollBar = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.rtl, d = a.scrollOffset, p = a.scrollRange, v = a.onStartMove, A = a.onStopMove, x = a.onScroll, g = a.horizontal, b = a.spinSize, y = a.containerSize, f = a.style, m = a.thumbStyle, C = a.showScrollBar, w = reactExports.useState(!1), S = _slicedToArray$e(w, 2), $ = S[0], T = S[1], I = reactExports.useState(null), _ = _slicedToArray$e(I, 2), E = _[0], R = _[1], O = reactExports.useState(null), L = _slicedToArray$e(O, 2), B = L[0], F = L[1], M = !u, W = reactExports.useRef(), j = reactExports.useRef(), G = reactExports.useState(C), U = _slicedToArray$e(G, 2), k = U[0], N = U[1], P = reactExports.useRef(), D = function() {
    C === !0 || C === !1 || (clearTimeout(P.current), N(!0), P.current = setTimeout(function() {
      N(!1);
    }, 3e3));
  }, H = p - y || 0, V = y - b || 0, Z = reactExports.useMemo(function() {
    if (d === 0 || H === 0)
      return 0;
    var ae = d / H;
    return ae * V;
  }, [d, H, V]), ne = function(se) {
    se.stopPropagation(), se.preventDefault();
  }, K = reactExports.useRef({
    top: Z,
    dragging: $,
    pageY: E,
    startTop: B
  });
  K.current = {
    top: Z,
    dragging: $,
    pageY: E,
    startTop: B
  };
  var q = function(se) {
    T(!0), R(getPageXY(se, g)), F(K.current.top), v(), se.stopPropagation(), se.preventDefault();
  };
  reactExports.useEffect(function() {
    var ae = function(ge) {
      ge.preventDefault();
    }, se = W.current, ie = j.current;
    return se.addEventListener("touchstart", ae, {
      passive: !1
    }), ie.addEventListener("touchstart", q, {
      passive: !1
    }), function() {
      se.removeEventListener("touchstart", ae), ie.removeEventListener("touchstart", q);
    };
  }, []);
  var Y = reactExports.useRef();
  Y.current = H;
  var ee = reactExports.useRef();
  ee.current = V, reactExports.useEffect(function() {
    if ($) {
      var ae, se = function(ge) {
        var me = K.current, pe = me.dragging, be = me.pageY, le = me.startTop;
        wrapperRaf.cancel(ae);
        var ve = W.current.getBoundingClientRect(), he = y / (g ? ve.width : ve.height);
        if (pe) {
          var ye = (getPageXY(ge, g) - be) * he, Ce = le;
          !M && g ? Ce -= ye : Ce += ye;
          var xe = Y.current, we = ee.current, $e = we ? Ce / we : 0, Ae = Math.ceil($e * xe);
          Ae = Math.max(Ae, 0), Ae = Math.min(Ae, xe), ae = wrapperRaf(function() {
            x(Ae, g);
          });
        }
      }, ie = function() {
        T(!1), A();
      };
      return window.addEventListener("mousemove", se, {
        passive: !0
      }), window.addEventListener("touchmove", se, {
        passive: !0
      }), window.addEventListener("mouseup", ie, {
        passive: !0
      }), window.addEventListener("touchend", ie, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", se), window.removeEventListener("touchmove", se), window.removeEventListener("mouseup", ie), window.removeEventListener("touchend", ie), wrapperRaf.cancel(ae);
      };
    }
  }, [$]), reactExports.useEffect(function() {
    return D(), function() {
      clearTimeout(P.current);
    };
  }, [d]), reactExports.useImperativeHandle(s, function() {
    return {
      delayHidden: D
    };
  });
  var Q = "".concat(c, "-scrollbar"), J = {
    position: "absolute",
    visibility: k ? null : "hidden"
  }, te = {
    position: "absolute",
    borderRadius: 99,
    background: "var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))",
    cursor: "pointer",
    userSelect: "none"
  };
  return g ? (Object.assign(J, {
    height: 8,
    left: 0,
    right: 0,
    bottom: 0
  }), Object.assign(te, _defineProperty$a({
    height: "100%",
    width: b
  }, M ? "left" : "right", Z))) : (Object.assign(J, _defineProperty$a({
    width: 8,
    top: 0,
    bottom: 0
  }, M ? "right" : "left", 0)), Object.assign(te, {
    width: "100%",
    height: b,
    top: Z
  })), /* @__PURE__ */ reactExports.createElement("div", {
    ref: W,
    className: classnames(Q, _defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(Q, "-horizontal"), g), "".concat(Q, "-vertical"), !g), "".concat(Q, "-visible"), k)),
    style: _objectSpread2$1(_objectSpread2$1({}, J), f),
    onMouseDown: ne,
    onMouseMove: D
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: j,
    className: classnames("".concat(Q, "-thumb"), _defineProperty$a({}, "".concat(Q, "-thumb-moving"), $)),
    style: _objectSpread2$1(_objectSpread2$1({}, te), m),
    onMouseDown: q
  }));
}), MIN_SIZE = 20;
function getSpinSize() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, c = a / s * a;
  return isNaN(c) && (c = 0), c = Math.max(c, MIN_SIZE), Math.floor(c);
}
var _excluded$N = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"], EMPTY_DATA$1 = [], ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function RawList(a, s) {
  var c = a.prefixCls, u = c === void 0 ? "rc-virtual-list" : c, d = a.className, p = a.height, v = a.itemHeight, A = a.fullHeight, x = A === void 0 ? !0 : A, g = a.style, b = a.data, y = a.children, f = a.itemKey, m = a.virtual, C = a.direction, w = a.scrollWidth, S = a.component, $ = S === void 0 ? "div" : S, T = a.onScroll, I = a.onVirtualScroll, _ = a.onVisibleChange, E = a.innerProps, R = a.extraRender, O = a.styles, L = a.showScrollBar, B = L === void 0 ? "optional" : L, F = _objectWithoutProperties$2(a, _excluded$N), M = reactExports.useCallback(function(Ye) {
    return typeof f == "function" ? f(Ye) : Ye?.[f];
  }, [f]), W = useHeights(M), j = _slicedToArray$e(W, 4), G = j[0], U = j[1], k = j[2], N = j[3], P = !!(m !== !1 && p && v), D = reactExports.useMemo(function() {
    return Object.values(k.maps).reduce(function(Ye, tt) {
      return Ye + tt;
    }, 0);
  }, [k.id, k.maps]), H = P && b && (Math.max(v * b.length, D) > p || !!w), V = C === "rtl", Z = classnames(u, _defineProperty$a({}, "".concat(u, "-rtl"), V), d), ne = b || EMPTY_DATA$1, K = reactExports.useRef(), q = reactExports.useRef(), Y = reactExports.useRef(), ee = reactExports.useState(0), Q = _slicedToArray$e(ee, 2), J = Q[0], te = Q[1], ae = reactExports.useState(0), se = _slicedToArray$e(ae, 2), ie = se[0], fe = se[1], ge = reactExports.useState(!1), me = _slicedToArray$e(ge, 2), pe = me[0], be = me[1], le = function() {
    be(!0);
  }, ve = function() {
    be(!1);
  }, he = {
    getKey: M
  };
  function ye(Ye) {
    te(function(tt) {
      var Ke;
      typeof Ye == "function" ? Ke = Ye(tt) : Ke = Ye;
      var qe = Ge(Ke);
      return K.current.scrollTop = qe, qe;
    });
  }
  var Ce = reactExports.useRef({
    start: 0,
    end: ne.length
  }), xe = reactExports.useRef(), we = useDiffItem(ne, M), $e = _slicedToArray$e(we, 1), Ae = $e[0];
  xe.current = Ae;
  var ue = reactExports.useMemo(function() {
    if (!P)
      return {
        scrollHeight: void 0,
        start: 0,
        end: ne.length - 1,
        offset: void 0
      };
    if (!H) {
      var Ye;
      return {
        scrollHeight: ((Ye = q.current) === null || Ye === void 0 ? void 0 : Ye.offsetHeight) || 0,
        start: 0,
        end: ne.length - 1,
        offset: void 0
      };
    }
    for (var tt = 0, Ke, qe, ot, Je = ne.length, Ct = 0; Ct < Je; Ct += 1) {
      var Tt = ne[Ct], yt = M(Tt), bt = k.get(yt), It = tt + (bt === void 0 ? v : bt);
      It >= J && Ke === void 0 && (Ke = Ct, qe = tt), It > J + p && ot === void 0 && (ot = Ct), tt = It;
    }
    return Ke === void 0 && (Ke = 0, qe = 0, ot = Math.ceil(p / v)), ot === void 0 && (ot = ne.length - 1), ot = Math.min(ot + 1, ne.length - 1), {
      scrollHeight: tt,
      start: Ke,
      end: ot,
      offset: qe
    };
  }, [H, P, J, ne, N, p]), ce = ue.scrollHeight, Ee = ue.start, _e = ue.end, Te = ue.offset;
  Ce.current.start = Ee, Ce.current.end = _e, reactExports.useLayoutEffect(function() {
    var Ye = k.getRecord();
    if (Ye.size === 1) {
      var tt = Array.from(Ye.keys())[0], Ke = Ye.get(tt), qe = ne[Ee];
      if (qe && Ke === void 0) {
        var ot = M(qe);
        if (ot === tt) {
          var Je = k.get(tt), Ct = Je - v;
          ye(function(Tt) {
            return Tt + Ct;
          });
        }
      }
    }
    k.resetRecord();
  }, [ce]);
  var ke = reactExports.useState({
    width: 0,
    height: p
  }), Re = _slicedToArray$e(ke, 2), Be = Re[0], Oe = Re[1], Me = function(tt) {
    Oe({
      width: tt.offsetWidth,
      height: tt.offsetHeight
    });
  }, Fe = reactExports.useRef(), Ue = reactExports.useRef(), je = reactExports.useMemo(function() {
    return getSpinSize(Be.width, w);
  }, [Be.width, w]), Le = reactExports.useMemo(function() {
    return getSpinSize(Be.height, ce);
  }, [Be.height, ce]), De = ce - p, Ne = reactExports.useRef(De);
  Ne.current = De;
  function Ge(Ye) {
    var tt = Ye;
    return Number.isNaN(Ne.current) || (tt = Math.min(tt, Ne.current)), tt = Math.max(tt, 0), tt;
  }
  var Xe = J <= 0, nt = J >= De, ct = ie <= 0, it = ie >= w, We = useOriginScroll(Xe, nt, ct, it), Ve = function() {
    return {
      x: V ? -ie : ie,
      y: J
    };
  }, ut = reactExports.useRef(Ve()), at = useEvent(function(Ye) {
    if (I) {
      var tt = _objectSpread2$1(_objectSpread2$1({}, Ve()), Ye);
      (ut.current.x !== tt.x || ut.current.y !== tt.y) && (I(tt), ut.current = tt);
    }
  });
  function Qe(Ye, tt) {
    var Ke = Ye;
    tt ? (reactDomExports.flushSync(function() {
      fe(Ke);
    }), at()) : ye(Ke);
  }
  function st(Ye) {
    var tt = Ye.currentTarget.scrollTop;
    tt !== J && ye(tt), T?.(Ye), at();
  }
  var ft = function(tt) {
    var Ke = tt, qe = w ? w - Be.width : 0;
    return Ke = Math.max(Ke, 0), Ke = Math.min(Ke, qe), Ke;
  }, vt = useEvent(function(Ye, tt) {
    tt ? (reactDomExports.flushSync(function() {
      fe(function(Ke) {
        var qe = Ke + (V ? -Ye : Ye);
        return ft(qe);
      });
    }), at()) : ye(function(Ke) {
      var qe = Ke + Ye;
      return qe;
    });
  }), Pt = useFrameWheel(P, Xe, nt, ct, it, !!w, vt), dt = _slicedToArray$e(Pt, 2), mt = dt[0], pt = dt[1];
  useMobileTouchMove(P, K, function(Ye, tt, Ke, qe) {
    var ot = qe;
    return We(Ye, tt, Ke) ? !1 : !ot || !ot._virtualHandled ? (ot && (ot._virtualHandled = !0), mt({
      preventDefault: function() {
      },
      deltaX: Ye ? tt : 0,
      deltaY: Ye ? 0 : tt
    }), !0) : !1;
  }), useScrollDrag(H, K, function(Ye) {
    ye(function(tt) {
      return tt + Ye;
    });
  }), useLayoutEffect$1(function() {
    function Ye(Ke) {
      var qe = Xe && Ke.detail < 0, ot = nt && Ke.detail > 0;
      P && !qe && !ot && Ke.preventDefault();
    }
    var tt = K.current;
    return tt.addEventListener("wheel", mt, {
      passive: !1
    }), tt.addEventListener("DOMMouseScroll", pt, {
      passive: !0
    }), tt.addEventListener("MozMousePixelScroll", Ye, {
      passive: !1
    }), function() {
      tt.removeEventListener("wheel", mt), tt.removeEventListener("DOMMouseScroll", pt), tt.removeEventListener("MozMousePixelScroll", Ye);
    };
  }, [P, Xe, nt]), useLayoutEffect$1(function() {
    if (w) {
      var Ye = ft(ie);
      fe(Ye), at({
        x: Ye
      });
    }
  }, [Be.width, w]);
  var Et = function() {
    var tt, Ke;
    (tt = Fe.current) === null || tt === void 0 || tt.delayHidden(), (Ke = Ue.current) === null || Ke === void 0 || Ke.delayHidden();
  }, Mt = useScrollTo$1(K, ne, k, v, M, function() {
    return U(!0);
  }, ye, Et);
  reactExports.useImperativeHandle(s, function() {
    return {
      nativeElement: Y.current,
      getScrollInfo: Ve,
      scrollTo: function(tt) {
        function Ke(qe) {
          return qe && _typeof$h(qe) === "object" && ("left" in qe || "top" in qe);
        }
        Ke(tt) ? (tt.left !== void 0 && fe(ft(tt.left)), Mt(tt.top)) : Mt(tt);
      }
    };
  }), useLayoutEffect$1(function() {
    if (_) {
      var Ye = ne.slice(Ee, _e + 1);
      _(Ye, ne);
    }
  }, [Ee, _e, ne]);
  var Nt = useGetSize(ne, M, k, v), _t = R?.({
    start: Ee,
    end: _e,
    virtual: H,
    offsetX: ie,
    offsetY: Te,
    rtl: V,
    getSize: Nt
  }), Ot = useChildren$1(ne, Ee, _e, w, ie, G, y, he), rt = null;
  p && (rt = _objectSpread2$1(_defineProperty$a({}, x ? "height" : "maxHeight", p), ScrollStyle), P && (rt.overflowY = "hidden", w && (rt.overflowX = "hidden"), pe && (rt.pointerEvents = "none")));
  var et = {};
  return V && (et.dir = "rtl"), /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    ref: Y,
    style: _objectSpread2$1(_objectSpread2$1({}, g), {}, {
      position: "relative"
    }),
    className: Z
  }, et, F), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Me
  }, /* @__PURE__ */ reactExports.createElement($, {
    className: "".concat(u, "-holder"),
    style: rt,
    ref: K,
    onScroll: st,
    onMouseEnter: Et
  }, /* @__PURE__ */ reactExports.createElement(Filler, {
    prefixCls: u,
    height: ce,
    offsetX: ie,
    offsetY: Te,
    scrollWidth: w,
    onInnerResize: U,
    ref: q,
    innerProps: E,
    rtl: V,
    extra: _t
  }, Ot))), H && ce > p && /* @__PURE__ */ reactExports.createElement(ScrollBar, {
    ref: Fe,
    prefixCls: u,
    scrollOffset: J,
    scrollRange: ce,
    rtl: V,
    onScroll: Qe,
    onStartMove: le,
    onStopMove: ve,
    spinSize: Le,
    containerSize: Be.height,
    style: O?.verticalScrollBar,
    thumbStyle: O?.verticalScrollBarThumb,
    showScrollBar: B
  }), H && w > Be.width && /* @__PURE__ */ reactExports.createElement(ScrollBar, {
    ref: Ue,
    prefixCls: u,
    scrollOffset: ie,
    scrollRange: w,
    rtl: V,
    onScroll: Qe,
    onStartMove: le,
    onStopMove: ve,
    spinSize: je,
    containerSize: Be.width,
    horizontal: !0,
    style: O?.horizontalScrollBar,
    thumbStyle: O?.horizontalScrollBarThumb,
    showScrollBar: B
  }));
}
var List = /* @__PURE__ */ reactExports.forwardRef(RawList);
List.displayName = "List";
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var _excluded$M = ["disabled", "title", "children", "style", "className"];
function isTitleType(a) {
  return typeof a == "string" || typeof a == "number";
}
var OptionList$1 = function a(s, c) {
  var u = useBaseProps(), d = u.prefixCls, p = u.id, v = u.open, A = u.multiple, x = u.mode, g = u.searchValue, b = u.toggleOpen, y = u.notFoundContent, f = u.onPopupScroll, m = reactExports.useContext(SelectContext), C = m.maxCount, w = m.flattenOptions, S = m.onActiveValue, $ = m.defaultActiveFirstOption, T = m.onSelect, I = m.menuItemSelectedIcon, _ = m.rawValues, E = m.fieldNames, R = m.virtual, O = m.direction, L = m.listHeight, B = m.listItemHeight, F = m.optionRender, M = "".concat(d, "-item"), W = useMemo(function() {
    return w;
  }, [v, w], function(ae, se) {
    return se[0] && ae[1] !== se[1];
  }), j = reactExports.useRef(null), G = reactExports.useMemo(function() {
    return A && isValidCount(C) && _?.size >= C;
  }, [A, C, _?.size]), U = function(se) {
    se.preventDefault();
  }, k = function(se) {
    var ie;
    (ie = j.current) === null || ie === void 0 || ie.scrollTo(typeof se == "number" ? {
      index: se
    } : se);
  }, N = reactExports.useCallback(function(ae) {
    return x === "combobox" ? !1 : _.has(ae);
  }, [x, _toConsumableArray$e(_).toString(), _.size]), P = function(se) {
    for (var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, fe = W.length, ge = 0; ge < fe; ge += 1) {
      var me = (se + ge * ie + fe) % fe, pe = W[me] || {}, be = pe.group, le = pe.data;
      if (!be && !(le != null && le.disabled) && (N(le.value) || !G))
        return me;
    }
    return -1;
  }, D = reactExports.useState(function() {
    return P(0);
  }), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = function(se) {
    var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    Z(se);
    var fe = {
      source: ie ? "keyboard" : "mouse"
    }, ge = W[se];
    if (!ge) {
      S(null, -1, fe);
      return;
    }
    S(ge.value, se, fe);
  };
  reactExports.useEffect(function() {
    ne($ !== !1 ? P(0) : -1);
  }, [W.length, g]);
  var K = reactExports.useCallback(function(ae) {
    return x === "combobox" ? String(ae).toLowerCase() === g.toLowerCase() : _.has(ae);
  }, [x, g, _toConsumableArray$e(_).toString(), _.size]);
  reactExports.useEffect(function() {
    var ae = setTimeout(function() {
      if (!A && v && _.size === 1) {
        var ie = Array.from(_)[0], fe = W.findIndex(function(ge) {
          var me = ge.data;
          return g ? String(me.value).startsWith(g) : me.value === ie;
        });
        fe !== -1 && (ne(fe), k(fe));
      }
    });
    if (v) {
      var se;
      (se = j.current) === null || se === void 0 || se.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(ae);
    };
  }, [v, g]);
  var q = function(se) {
    se !== void 0 && T(se, {
      selected: !_.has(se)
    }), A || b(!1);
  };
  if (reactExports.useImperativeHandle(c, function() {
    return {
      onKeyDown: function(se) {
        var ie = se.which, fe = se.ctrlKey;
        switch (ie) {
          // >>> Arrow keys & ctrl + n/p on Mac
          case KeyCode.N:
          case KeyCode.P:
          case KeyCode.UP:
          case KeyCode.DOWN: {
            var ge = 0;
            if (ie === KeyCode.UP ? ge = -1 : ie === KeyCode.DOWN ? ge = 1 : isPlatformMac() && fe && (ie === KeyCode.N ? ge = 1 : ie === KeyCode.P && (ge = -1)), ge !== 0) {
              var me = P(V + ge, ge);
              k(me), ne(me, !0);
            }
            break;
          }
          // >>> Select (Tab / Enter)
          case KeyCode.TAB:
          case KeyCode.ENTER: {
            var pe, be = W[V];
            be && !(be != null && (pe = be.data) !== null && pe !== void 0 && pe.disabled) && !G ? q(be.value) : q(void 0), v && se.preventDefault();
            break;
          }
          // >>> Close
          case KeyCode.ESC:
            b(!1), v && se.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(se) {
        k(se);
      }
    };
  }), W.length === 0)
    return /* @__PURE__ */ reactExports.createElement("div", {
      role: "listbox",
      id: "".concat(p, "_list"),
      className: "".concat(M, "-empty"),
      onMouseDown: U
    }, y);
  var Y = Object.keys(E).map(function(ae) {
    return E[ae];
  }), ee = function(se) {
    return se.label;
  };
  function Q(ae, se) {
    var ie = ae.group;
    return {
      role: ie ? "presentation" : "option",
      id: "".concat(p, "_list_").concat(se)
    };
  }
  var J = function(se) {
    var ie = W[se];
    if (!ie)
      return null;
    var fe = ie.data || {}, ge = fe.value, me = ie.group, pe = pickAttrs(fe, !0), be = ee(ie);
    return ie ? /* @__PURE__ */ reactExports.createElement("div", _extends$3({
      "aria-label": typeof be == "string" && !me ? be : null
    }, pe, {
      key: se
    }, Q(ie, se), {
      "aria-selected": K(ge)
    }), ge) : null;
  }, te = {
    role: "listbox",
    id: "".concat(p, "_list")
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, R && /* @__PURE__ */ reactExports.createElement("div", _extends$3({}, te, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), J(V - 1), J(V), J(V + 1)), /* @__PURE__ */ reactExports.createElement(List, {
    itemKey: "key",
    ref: j,
    data: W,
    height: L,
    itemHeight: B,
    fullHeight: !1,
    onMouseDown: U,
    onScroll: f,
    virtual: R,
    direction: O,
    innerProps: R ? null : te
  }, function(ae, se) {
    var ie = ae.group, fe = ae.groupOption, ge = ae.data, me = ae.label, pe = ae.value, be = ge.key;
    if (ie) {
      var le, ve = (le = ge.title) !== null && le !== void 0 ? le : isTitleType(me) ? me.toString() : void 0;
      return /* @__PURE__ */ reactExports.createElement("div", {
        className: classnames(M, "".concat(M, "-group"), ge.className),
        title: ve
      }, me !== void 0 ? me : be);
    }
    var he = ge.disabled, ye = ge.title;
    ge.children;
    var Ce = ge.style, xe = ge.className, we = _objectWithoutProperties$2(ge, _excluded$M), $e = omit(we, Y), Ae = N(pe), ue = he || !Ae && G, ce = "".concat(M, "-option"), Ee = classnames(M, ce, xe, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(ce, "-grouped"), fe), "".concat(ce, "-active"), V === se && !ue), "".concat(ce, "-disabled"), ue), "".concat(ce, "-selected"), Ae)), _e = ee(ae), Te = !I || typeof I == "function" || Ae, ke = typeof _e == "number" ? _e : _e || pe, Re = isTitleType(ke) ? ke.toString() : void 0;
    return ye !== void 0 && (Re = ye), /* @__PURE__ */ reactExports.createElement("div", _extends$3({}, pickAttrs($e), R ? {} : Q(ae, se), {
      "aria-selected": K(pe),
      className: Ee,
      title: Re,
      onMouseMove: function() {
        V === se || ue || ne(se);
      },
      onClick: function() {
        ue || q(pe);
      },
      style: Ce
    }), /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(ce, "-content")
    }, typeof F == "function" ? F(ae, {
      index: se
    }) : ke), /* @__PURE__ */ reactExports.isValidElement(I) || Ae, Te && /* @__PURE__ */ reactExports.createElement(TransBtn, {
      className: "".concat(M, "-option-state"),
      customizeIcon: I,
      customizeIconProps: {
        value: pe,
        disabled: ue,
        isSelected: Ae
      }
    }, Ae ? "✓" : null));
  }));
}, RefOptionList$1 = /* @__PURE__ */ reactExports.forwardRef(OptionList$1);
const useCache$1 = function(a, s) {
  var c = reactExports.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), u = reactExports.useMemo(function() {
    var p = c.current, v = p.values, A = p.options, x = a.map(function(y) {
      if (y.label === void 0) {
        var f;
        return _objectSpread2$1(_objectSpread2$1({}, y), {}, {
          label: (f = v.get(y.value)) === null || f === void 0 ? void 0 : f.label
        });
      }
      return y;
    }), g = /* @__PURE__ */ new Map(), b = /* @__PURE__ */ new Map();
    return x.forEach(function(y) {
      g.set(y.value, y), b.set(y.value, s.get(y.value) || A.get(y.value));
    }), c.current.values = g, c.current.options = b, x;
  }, [a, s]), d = reactExports.useCallback(function(p) {
    return s.get(p) || c.current.options.get(p);
  }, [s]);
  return [u, d];
};
function includes(a, s) {
  return toArray$6(a).join("").toUpperCase().includes(s);
}
const useFilterOptions = function(a, s, c, u, d) {
  return reactExports.useMemo(function() {
    if (!c || u === !1)
      return a;
    var p = s.options, v = s.label, A = s.value, x = [], g = typeof u == "function", b = c.toUpperCase(), y = g ? u : function(m, C) {
      return d ? includes(C[d], b) : C[p] ? includes(C[v !== "children" ? v : "label"], b) : includes(C[A], b);
    }, f = g ? function(m) {
      return injectPropsWithOption(m);
    } : function(m) {
      return m;
    };
    return a.forEach(function(m) {
      if (m[p]) {
        var C = y(c, f(m));
        if (C)
          x.push(m);
        else {
          var w = m[p].filter(function(S) {
            return y(c, f(S));
          });
          w.length && x.push(_objectSpread2$1(_objectSpread2$1({}, m), {}, _defineProperty$a({}, p, w)));
        }
        return;
      }
      y(c, f(m)) && x.push(m);
    }), x;
  }, [a, u, d, c, s]);
};
var uuid$2 = 0, isBrowserClient$1 = canUseDom$1();
function getUUID$1() {
  var a;
  return isBrowserClient$1 ? (a = uuid$2, uuid$2 += 1) : a = "TEST_OR_SSR", a;
}
function useId$1(a) {
  var s = reactExports.useState(), c = _slicedToArray$e(s, 2), u = c[0], d = c[1];
  return reactExports.useEffect(function() {
    d("rc_select_".concat(getUUID$1()));
  }, []), a || u;
}
var _excluded$L = ["children", "value"], _excluded2$b = ["children"];
function convertNodeToOption(a) {
  var s = a, c = s.key, u = s.props, d = u.children, p = u.value, v = _objectWithoutProperties$2(u, _excluded$L);
  return _objectSpread2$1({
    key: c,
    value: p !== void 0 ? p : c,
    children: d
  }, v);
}
function convertChildrenToData$1(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return toArray$8(a).map(function(c, u) {
    if (!/* @__PURE__ */ reactExports.isValidElement(c) || !c.type)
      return null;
    var d = c, p = d.type.isSelectOptGroup, v = d.key, A = d.props, x = A.children, g = _objectWithoutProperties$2(A, _excluded2$b);
    return s || !p ? convertNodeToOption(c) : _objectSpread2$1(_objectSpread2$1({
      key: "__RC_SELECT_GRP__".concat(v === null ? u : v, "__"),
      label: v
    }, g), {}, {
      options: convertChildrenToData$1(x)
    });
  }).filter(function(c) {
    return c;
  });
}
var useOptions = function a(s, c, u, d, p) {
  return reactExports.useMemo(function() {
    var v = s, A = !s;
    A && (v = convertChildrenToData$1(c));
    var x = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), b = function(m, C, w) {
      w && typeof w == "string" && m.set(C[w], C);
    }, y = function f(m) {
      for (var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, w = 0; w < m.length; w += 1) {
        var S = m[w];
        !S[u.options] || C ? (x.set(S[u.value], S), b(g, S, u.label), b(g, S, d), b(g, S, p)) : f(S[u.options], !0);
      }
    };
    return y(v), {
      options: v,
      valueOptions: x,
      labelOptions: g
    };
  }, [s, c, u, d, p]);
};
function useRefFunc$1(a) {
  var s = reactExports.useRef();
  s.current = a;
  var c = reactExports.useCallback(function() {
    return s.current.apply(s, arguments);
  }, []);
  return c;
}
var _excluded$K = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], OMIT_DOM_PROPS = ["inputValue"];
function isRawValue$1(a) {
  return !a || _typeof$h(a) !== "object";
}
var Select$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.id, u = a.mode, d = a.prefixCls, p = d === void 0 ? "rc-select" : d, v = a.backfill, A = a.fieldNames, x = a.inputValue, g = a.searchValue, b = a.onSearch, y = a.autoClearSearchValue, f = y === void 0 ? !0 : y, m = a.onSelect, C = a.onDeselect, w = a.dropdownMatchSelectWidth, S = w === void 0 ? !0 : w, $ = a.filterOption, T = a.filterSort, I = a.optionFilterProp, _ = a.optionLabelProp, E = a.options, R = a.optionRender, O = a.children, L = a.defaultActiveFirstOption, B = a.menuItemSelectedIcon, F = a.virtual, M = a.direction, W = a.listHeight, j = W === void 0 ? 200 : W, G = a.listItemHeight, U = G === void 0 ? 20 : G, k = a.labelRender, N = a.value, P = a.defaultValue, D = a.labelInValue, H = a.onChange, V = a.maxCount, Z = _objectWithoutProperties$2(a, _excluded$K), ne = useId$1(c), K = isMultiple(u), q = !!(!E && O), Y = reactExports.useMemo(function() {
    return $ === void 0 && u === "combobox" ? !1 : $;
  }, [$, u]), ee = reactExports.useMemo(
    function() {
      return fillFieldNames$2(A, q);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(A),
      q
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), Q = useMergedState("", {
    value: g !== void 0 ? g : x,
    postState: function(Qe) {
      return Qe || "";
    }
  }), J = _slicedToArray$e(Q, 2), te = J[0], ae = J[1], se = useOptions(E, O, ee, I, _), ie = se.valueOptions, fe = se.labelOptions, ge = se.options, me = reactExports.useCallback(function(at) {
    var Qe = toArray$6(at);
    return Qe.map(function(st) {
      var ft, vt, Pt, dt, mt;
      if (isRawValue$1(st))
        ft = st;
      else {
        var pt;
        Pt = st.key, vt = st.label, ft = (pt = st.value) !== null && pt !== void 0 ? pt : Pt;
      }
      var Et = ie.get(ft);
      if (Et) {
        var Mt;
        vt === void 0 && (vt = Et?.[_ || ee.label]), Pt === void 0 && (Pt = (Mt = Et?.key) !== null && Mt !== void 0 ? Mt : ft), dt = Et?.disabled, mt = Et?.title;
      }
      return {
        label: vt,
        value: ft,
        key: Pt,
        disabled: dt,
        title: mt
      };
    });
  }, [ee, _, ie]), pe = useMergedState(P, {
    value: N
  }), be = _slicedToArray$e(pe, 2), le = be[0], ve = be[1], he = reactExports.useMemo(function() {
    var at, Qe = K && le === null ? [] : le, st = me(Qe);
    return u === "combobox" && isComboNoValue((at = st[0]) === null || at === void 0 ? void 0 : at.value) ? [] : st;
  }, [le, me, u, K]), ye = useCache$1(he, ie), Ce = _slicedToArray$e(ye, 2), xe = Ce[0], we = Ce[1], $e = reactExports.useMemo(function() {
    if (!u && xe.length === 1) {
      var at = xe[0];
      if (at.value === null && (at.label === null || at.label === void 0))
        return [];
    }
    return xe.map(function(Qe) {
      var st;
      return _objectSpread2$1(_objectSpread2$1({}, Qe), {}, {
        label: (st = typeof k == "function" ? k(Qe) : Qe.label) !== null && st !== void 0 ? st : Qe.value
      });
    });
  }, [u, xe, k]), Ae = reactExports.useMemo(function() {
    return new Set(xe.map(function(at) {
      return at.value;
    }));
  }, [xe]);
  reactExports.useEffect(function() {
    if (u === "combobox") {
      var at, Qe = (at = xe[0]) === null || at === void 0 ? void 0 : at.value;
      ae(hasValue(Qe) ? String(Qe) : "");
    }
  }, [xe]);
  var ue = useRefFunc$1(function(at, Qe) {
    var st = Qe ?? at;
    return _defineProperty$a(_defineProperty$a({}, ee.value, at), ee.label, st);
  }), ce = reactExports.useMemo(function() {
    if (u !== "tags")
      return ge;
    var at = _toConsumableArray$e(ge), Qe = function(ft) {
      return ie.has(ft);
    };
    return _toConsumableArray$e(xe).sort(function(st, ft) {
      return st.value < ft.value ? -1 : 1;
    }).forEach(function(st) {
      var ft = st.value;
      Qe(ft) || at.push(ue(ft, st.label));
    }), at;
  }, [ue, ge, ie, xe, u]), Ee = useFilterOptions(ce, ee, te, Y, I), _e = reactExports.useMemo(function() {
    return u !== "tags" || !te || Ee.some(function(at) {
      return at[I || "value"] === te;
    }) || Ee.some(function(at) {
      return at[ee.value] === te;
    }) ? Ee : [ue(te)].concat(_toConsumableArray$e(Ee));
  }, [ue, I, u, Ee, te, ee]), Te = function at(Qe) {
    var st = _toConsumableArray$e(Qe).sort(function(ft, vt) {
      return T(ft, vt, {
        searchValue: te
      });
    });
    return st.map(function(ft) {
      return Array.isArray(ft.options) ? _objectSpread2$1(_objectSpread2$1({}, ft), {}, {
        options: ft.options.length > 0 ? at(ft.options) : ft.options
      }) : ft;
    });
  }, ke = reactExports.useMemo(function() {
    return T ? Te(_e) : _e;
  }, [_e, T, te]), Re = reactExports.useMemo(function() {
    return flattenOptions(ke, {
      fieldNames: ee,
      childrenAsData: q
    });
  }, [ke, ee, q]), Be = function(Qe) {
    var st = me(Qe);
    if (ve(st), H && // Trigger event only when value changed
    (st.length !== xe.length || st.some(function(Pt, dt) {
      var mt;
      return ((mt = xe[dt]) === null || mt === void 0 ? void 0 : mt.value) !== Pt?.value;
    }))) {
      var ft = D ? st : st.map(function(Pt) {
        return Pt.value;
      }), vt = st.map(function(Pt) {
        return injectPropsWithOption(we(Pt.value));
      });
      H(
        // Value
        K ? ft : ft[0],
        // Option
        K ? vt : vt[0]
      );
    }
  }, Oe = reactExports.useState(null), Me = _slicedToArray$e(Oe, 2), Fe = Me[0], Ue = Me[1], je = reactExports.useState(0), Le = _slicedToArray$e(je, 2), De = Le[0], Ne = Le[1], Ge = L !== void 0 ? L : u !== "combobox", Xe = reactExports.useCallback(function(at, Qe) {
    var st = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ft = st.source, vt = ft === void 0 ? "keyboard" : ft;
    Ne(Qe), v && u === "combobox" && at !== null && vt === "keyboard" && Ue(String(at));
  }, [v, u]), nt = function(Qe, st, ft) {
    var vt = function() {
      var rt, et = we(Qe);
      return [D ? {
        label: et?.[ee.label],
        value: Qe,
        key: (rt = et?.key) !== null && rt !== void 0 ? rt : Qe
      } : Qe, injectPropsWithOption(et)];
    };
    if (st && m) {
      var Pt = vt(), dt = _slicedToArray$e(Pt, 2), mt = dt[0], pt = dt[1];
      m(mt, pt);
    } else if (!st && C && ft !== "clear") {
      var Et = vt(), Mt = _slicedToArray$e(Et, 2), Nt = Mt[0], _t = Mt[1];
      C(Nt, _t);
    }
  }, ct = useRefFunc$1(function(at, Qe) {
    var st, ft = K ? Qe.selected : !0;
    ft ? st = K ? [].concat(_toConsumableArray$e(xe), [at]) : [at] : st = xe.filter(function(vt) {
      return vt.value !== at;
    }), Be(st), nt(at, ft), u === "combobox" ? Ue("") : (!isMultiple || f) && (ae(""), Ue(""));
  }), it = function(Qe, st) {
    Be(Qe);
    var ft = st.type, vt = st.values;
    (ft === "remove" || ft === "clear") && vt.forEach(function(Pt) {
      nt(Pt.value, !1, ft);
    });
  }, We = function(Qe, st) {
    if (ae(Qe), Ue(null), st.source === "submit") {
      var ft = (Qe || "").trim();
      if (ft) {
        var vt = Array.from(new Set([].concat(_toConsumableArray$e(Ae), [ft])));
        Be(vt), nt(ft, !0), ae("");
      }
      return;
    }
    st.source !== "blur" && (u === "combobox" && Be(Qe), b?.(Qe));
  }, Ve = function(Qe) {
    var st = Qe;
    u !== "tags" && (st = Qe.map(function(vt) {
      var Pt = fe.get(vt);
      return Pt?.value;
    }).filter(function(vt) {
      return vt !== void 0;
    }));
    var ft = Array.from(new Set([].concat(_toConsumableArray$e(Ae), _toConsumableArray$e(st))));
    Be(ft), ft.forEach(function(vt) {
      nt(vt, !0);
    });
  }, ut = reactExports.useMemo(function() {
    var at = F !== !1 && S !== !1;
    return _objectSpread2$1(_objectSpread2$1({}, se), {}, {
      flattenOptions: Re,
      onActiveValue: Xe,
      defaultActiveFirstOption: Ge,
      onSelect: ct,
      menuItemSelectedIcon: B,
      rawValues: Ae,
      fieldNames: ee,
      virtual: at,
      direction: M,
      listHeight: j,
      listItemHeight: U,
      childrenAsData: q,
      maxCount: V,
      optionRender: R
    });
  }, [V, se, Re, Xe, Ge, ct, B, Ae, ee, F, S, M, j, U, q, R]);
  return /* @__PURE__ */ reactExports.createElement(SelectContext.Provider, {
    value: ut
  }, /* @__PURE__ */ reactExports.createElement(BaseSelect, _extends$3({}, Z, {
    // >>> MISC
    id: ne,
    prefixCls: p,
    ref: s,
    omitDomProps: OMIT_DOM_PROPS,
    mode: u,
    displayValues: $e,
    onDisplayValuesChange: it,
    direction: M,
    searchValue: te,
    onSearch: We,
    autoClearSearchValue: f,
    onSearchSplit: Ve,
    dropdownMatchSelectWidth: S,
    OptionList: RefOptionList$1,
    emptyOptions: !Re.length,
    activeValue: Fe,
    activeDescendantId: "".concat(ne, "_list_").concat(De)
  })));
}), TypedSelect = Select$1;
TypedSelect.Option = Option;
TypedSelect.OptGroup = OptGroup;
function getStatusClassNames(a, s, c) {
  return classnames({
    [`${a}-status-success`]: s === "success",
    [`${a}-status-warning`]: s === "warning",
    [`${a}-status-error`]: s === "error",
    [`${a}-status-validating`]: s === "validating",
    [`${a}-has-feedback`]: c
  });
}
const getMergedStatus = (a, s) => s || a, Empty$1 = () => {
  const [, a] = useToken$1(), [s] = useLocale$1("Empty"), u = new FastColor(a.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ reactExports.createElement("svg", {
    style: u,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ reactExports.createElement("title", null, s?.description || "Empty"), /* @__PURE__ */ reactExports.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ reactExports.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ reactExports.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ reactExports.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ reactExports.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
}, Simple = () => {
  const [, a] = useToken$1(), [s] = useLocale$1("Empty"), {
    colorFill: c,
    colorFillTertiary: u,
    colorFillQuaternary: d,
    colorBgContainer: p
  } = a, {
    borderColor: v,
    shadowColor: A,
    contentColor: x
  } = reactExports.useMemo(() => ({
    borderColor: new FastColor(c).onBackground(p).toHexString(),
    shadowColor: new FastColor(u).onBackground(p).toHexString(),
    contentColor: new FastColor(d).onBackground(p).toHexString()
  }), [c, u, d, p]);
  return /* @__PURE__ */ reactExports.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ reactExports.createElement("title", null, s?.description || "Empty"), /* @__PURE__ */ reactExports.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ reactExports.createElement("ellipse", {
    fill: A,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ reactExports.createElement("g", {
    fillRule: "nonzero",
    stroke: v
  }, /* @__PURE__ */ reactExports.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: x
  }))));
}, genSharedEmptyStyle = (a) => {
  const {
    componentCls: s,
    margin: c,
    marginXS: u,
    marginXL: d,
    fontSize: p,
    lineHeight: v
  } = a;
  return {
    [s]: {
      marginInline: u,
      fontSize: p,
      lineHeight: v,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${s}-image`]: {
        height: a.emptyImgHeight,
        marginBottom: u,
        opacity: a.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${s}-description`]: {
        color: a.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${s}-footer`]: {
        marginTop: c
      },
      "&-normal": {
        marginBlock: d,
        color: a.colorTextDescription,
        [`${s}-description`]: {
          color: a.colorTextDescription
        },
        [`${s}-image`]: {
          height: a.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: u,
        color: a.colorTextDescription,
        [`${s}-image`]: {
          height: a.emptyImgHeightSM
        }
      }
    }
  };
}, useStyle$t = genStyleHooks("Empty", (a) => {
  const {
    componentCls: s,
    controlHeightLG: c,
    calc: u
  } = a, d = merge(a, {
    emptyImgCls: `${s}-img`,
    emptyImgHeight: u(c).mul(2.5).equal(),
    emptyImgHeightMD: c,
    emptyImgHeightSM: u(c).mul(0.875).equal()
  });
  return [genSharedEmptyStyle(d)];
});
var __rest$Y = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const defaultEmptyImg = /* @__PURE__ */ reactExports.createElement(Empty$1, null), simpleEmptyImg = /* @__PURE__ */ reactExports.createElement(Simple, null), Empty = (a) => {
  const {
    className: s,
    rootClassName: c,
    prefixCls: u,
    image: d = defaultEmptyImg,
    description: p,
    children: v,
    imageStyle: A,
    style: x,
    classNames: g,
    styles: b
  } = a, y = __rest$Y(a, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style", "classNames", "styles"]), {
    getPrefixCls: f,
    direction: m,
    className: C,
    style: w,
    classNames: S,
    styles: $
  } = useComponentConfig("empty"), T = f("empty", u), [I, _, E] = useStyle$t(T), [R] = useLocale$1("Empty"), O = typeof p < "u" ? p : R?.description, L = typeof O == "string" ? O : "empty";
  let B = null;
  return typeof d == "string" ? B = /* @__PURE__ */ reactExports.createElement("img", {
    alt: L,
    src: d
  }) : B = d, I(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    className: classnames(_, E, T, C, {
      [`${T}-normal`]: d === simpleEmptyImg,
      [`${T}-rtl`]: m === "rtl"
    }, s, c, S.root, g?.root),
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, $.root), w), b?.root), x)
  }, y), /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${T}-image`, S.image, g?.image),
    style: Object.assign(Object.assign(Object.assign({}, A), $.image), b?.image)
  }, B), O && /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${T}-description`, S.description, g?.description),
    style: Object.assign(Object.assign({}, $.description), b?.description)
  }, O), v && /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${T}-footer`, S.footer, g?.footer),
    style: Object.assign(Object.assign({}, $.footer), b?.footer)
  }, v)));
};
Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
const DefaultRenderEmpty = (a) => {
  const {
    componentName: s
  } = a, {
    getPrefixCls: c
  } = reactExports.useContext(ConfigContext$1), u = c("empty");
  switch (s) {
    case "Table":
    case "List":
      return /* @__PURE__ */ React.createElement(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ React.createElement(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE,
        className: `${u}-small`
      });
    /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */
    case "Table.filter":
      return null;
    default:
      return /* @__PURE__ */ React.createElement(Empty, null);
  }
}, useVariant = (a, s, c = void 0) => {
  var u, d;
  const {
    variant: p,
    [a]: v
  } = reactExports.useContext(ConfigContext$1), A = reactExports.useContext(VariantContext), x = v?.variant;
  let g;
  typeof s < "u" ? g = s : c === !1 ? g = "borderless" : g = (d = (u = A ?? x) !== null && u !== void 0 ? u : p) !== null && d !== void 0 ? d : "outlined";
  const b = Variants.includes(g);
  return [g, b];
}, getBuiltInPlacements = (a) => {
  const c = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: a === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, c), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, c), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, c), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, c), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function mergedBuiltinPlacements(a, s) {
  return a || getBuiltInPlacements(s);
}
const genItemStyle = (a) => {
  const {
    optionHeight: s,
    optionFontSize: c,
    optionLineHeight: u,
    optionPadding: d
  } = a;
  return {
    position: "relative",
    display: "block",
    minHeight: s,
    padding: d,
    color: a.colorText,
    fontWeight: "normal",
    fontSize: c,
    lineHeight: u,
    boxSizing: "border-box"
  };
}, genSingleStyle$1 = (a) => {
  const {
    antCls: s,
    componentCls: c
  } = a, u = `${c}-item`, d = `&${s}-slide-up-enter${s}-slide-up-enter-active`, p = `&${s}-slide-up-appear${s}-slide-up-appear-active`, v = `&${s}-slide-up-leave${s}-slide-up-leave-active`, A = `${c}-dropdown-placement-`, x = `${u}-option-selected`;
  return [
    {
      [`${c}-dropdown`]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "absolute",
        top: -9999,
        zIndex: a.zIndexPopup,
        boxSizing: "border-box",
        padding: a.paddingXXS,
        overflow: "hidden",
        fontSize: a.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: a.colorBgElevated,
        borderRadius: a.borderRadiusLG,
        outline: "none",
        boxShadow: a.boxShadowSecondary,
        [`
          ${d}${A}bottomLeft,
          ${p}${A}bottomLeft
        `]: {
          animationName: slideUpIn
        },
        [`
          ${d}${A}topLeft,
          ${p}${A}topLeft,
          ${d}${A}topRight,
          ${p}${A}topRight
        `]: {
          animationName: slideDownIn
        },
        [`${v}${A}bottomLeft`]: {
          animationName: slideUpOut
        },
        [`
          ${v}${A}topLeft,
          ${v}${A}topRight
        `]: {
          animationName: slideDownOut
        },
        "&-hidden": {
          display: "none"
        },
        [u]: Object.assign(Object.assign({}, genItemStyle(a)), {
          cursor: "pointer",
          transition: `background ${a.motionDurationSlow} ease`,
          borderRadius: a.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: a.colorTextDescription,
            fontSize: a.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, textEllipsis),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${u}-option-disabled)`]: {
              backgroundColor: a.optionActiveBg
            },
            [`&-selected:not(${u}-option-disabled)`]: {
              color: a.optionSelectedColor,
              fontWeight: a.optionSelectedFontWeight,
              backgroundColor: a.optionSelectedBg,
              [`${u}-option-state`]: {
                color: a.colorPrimary
              }
            },
            "&-disabled": {
              [`&${u}-option-selected`]: {
                backgroundColor: a.colorBgContainerDisabled
              },
              color: a.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: a.calc(a.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, genItemStyle(a)), {
            color: a.colorTextDisabled
          })
        }),
        // https://github.com/ant-design/ant-design/pull/46646
        [`${x}:has(+ ${x})`]: {
          borderEndStartRadius: 0,
          borderEndEndRadius: 0,
          [`& + ${x}`]: {
            borderStartStartRadius: 0,
            borderStartEndRadius: 0
          }
        },
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    initSlideMotion(a, "slide-up"),
    initSlideMotion(a, "slide-down"),
    initMoveMotion(a, "move-up"),
    initMoveMotion(a, "move-down")
  ];
}, getMultipleSelectorUnit = (a) => {
  const {
    multipleSelectItemHeight: s,
    paddingXXS: c,
    lineWidth: u,
    INTERNAL_FIXED_ITEM_MARGIN: d
  } = a, p = a.max(a.calc(c).sub(u).equal(), 0), v = a.max(a.calc(p).sub(d).equal(), 0);
  return {
    basePadding: p,
    containerPadding: v,
    itemHeight: unit$1(s),
    itemLineHeight: unit$1(a.calc(s).sub(a.calc(a.lineWidth).mul(2)).equal())
  };
}, getSelectItemStyle = (a) => {
  const {
    multipleSelectItemHeight: s,
    selectHeight: c,
    lineWidth: u
  } = a;
  return a.calc(c).sub(s).div(2).sub(u).equal();
}, genOverflowStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    borderRadiusSM: u,
    motionDurationSlow: d,
    paddingXS: p,
    multipleItemColorDisabled: v,
    multipleItemBorderColorDisabled: A,
    colorIcon: x,
    colorIconHover: g,
    INTERNAL_FIXED_ITEM_MARGIN: b
  } = a;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [`${s}-selection-overflow`]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        // https://github.com/ant-design/ant-design/issues/54179
        maxWidth: "calc(100% - 4px)",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${s}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: b,
        borderRadius: u,
        cursor: "default",
        transition: `font-size ${d}, line-height ${d}, height ${d}`,
        marginInlineEnd: a.calc(b).mul(2).equal(),
        paddingInlineStart: p,
        paddingInlineEnd: a.calc(p).div(2).equal(),
        [`${s}-disabled&`]: {
          color: v,
          borderColor: A,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: a.calc(p).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, resetIcon()), {
          display: "inline-flex",
          alignItems: "center",
          color: x,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${c}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: g
          }
        })
      }
    }
  };
}, genSelectionStyle$1 = (a, s) => {
  const {
    componentCls: c,
    INTERNAL_FIXED_ITEM_MARGIN: u
  } = a, d = `${c}-selection-overflow`, p = a.multipleSelectItemHeight, v = getSelectItemStyle(a), A = s ? `${c}-${s}` : "", x = getMultipleSelectorUnit(a);
  return {
    [`${c}-multiple${A}`]: Object.assign(Object.assign({}, genOverflowStyle(a)), {
      // ========================= Selector =========================
      [`${c}-selector`]: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: x.basePadding,
        paddingBlock: x.containerPadding,
        borderRadius: a.borderRadius,
        [`${c}-disabled&`]: {
          background: a.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${unit$1(u)} 0`,
          lineHeight: unit$1(p),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${c}-selection-item`]: {
        height: x.itemHeight,
        lineHeight: unit$1(x.itemLineHeight)
      },
      // ========================== Wrap ===========================
      [`${c}-selection-wrap`]: {
        alignSelf: "flex-start",
        "&:after": {
          lineHeight: unit$1(p),
          marginBlock: u
        }
      },
      // ========================== Input ==========================
      [`${c}-prefix`]: {
        marginInlineStart: a.calc(a.inputPaddingHorizontalBase).sub(x.basePadding).equal()
      },
      [`${d}-item + ${d}-item,
        ${c}-prefix + ${c}-selection-wrap
      `]: {
        [`${c}-selection-search`]: {
          marginInlineStart: 0
        },
        [`${c}-selection-placeholder`]: {
          insetInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      // Same as `wrap:after`
      [`${d}-item-suffix`]: {
        minHeight: x.itemHeight,
        marginBlock: u
      },
      [`${c}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: a.calc(a.inputPaddingHorizontalBase).sub(v).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: p,
          fontFamily: a.fontFamily,
          lineHeight: unit$1(p),
          transition: `all ${a.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${c}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: a.calc(a.inputPaddingHorizontalBase).sub(x.basePadding).equal(),
        insetInlineEnd: a.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${a.motionDurationSlow}`
      }
    })
  };
};
function genSizeStyle$3(a, s) {
  const {
    componentCls: c
  } = a, u = s ? `${c}-${s}` : "", d = {
    [`${c}-multiple${u}`]: {
      fontSize: a.fontSize,
      // ========================= Selector =========================
      [`${c}-selector`]: {
        [`${c}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${c}-show-arrow ${c}-selector,
        &${c}-allow-clear ${c}-selector
      `]: {
        paddingInlineEnd: a.calc(a.fontSizeIcon).add(a.controlPaddingHorizontal).equal()
      }
    }
  };
  return [genSelectionStyle$1(a, s), d];
}
const genMultipleStyle = (a) => {
  const {
    componentCls: s
  } = a, c = merge(a, {
    selectHeight: a.controlHeightSM,
    multipleSelectItemHeight: a.multipleItemHeightSM,
    borderRadius: a.borderRadiusSM,
    borderRadiusSM: a.borderRadiusXS
  }), u = merge(a, {
    fontSize: a.fontSizeLG,
    selectHeight: a.controlHeightLG,
    multipleSelectItemHeight: a.multipleItemHeightLG,
    borderRadius: a.borderRadiusLG,
    borderRadiusSM: a.borderRadius
  });
  return [
    genSizeStyle$3(a),
    // ======================== Small ========================
    genSizeStyle$3(c, "sm"),
    // Padding
    {
      [`${s}-multiple${s}-sm`]: {
        [`${s}-selection-placeholder`]: {
          insetInline: a.calc(a.controlPaddingHorizontalSM).sub(a.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${s}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    genSizeStyle$3(u, "lg")
  ];
};
function genSizeStyle$2(a, s) {
  const {
    componentCls: c,
    inputPaddingHorizontalBase: u,
    borderRadius: d
  } = a, p = a.calc(a.controlHeight).sub(a.calc(a.lineWidth).mul(2)).equal(), v = s ? `${c}-${s}` : "";
  return {
    [`${c}-single${v}`]: {
      fontSize: a.fontSize,
      height: a.controlHeight,
      // ========================= Selector =========================
      [`${c}-selector`]: Object.assign(Object.assign({}, resetComponent(a, !0)), {
        display: "flex",
        borderRadius: d,
        flex: "1 1 auto",
        [`${c}-selection-wrap:after`]: {
          lineHeight: unit$1(p)
        },
        [`${c}-selection-search`]: {
          position: "absolute",
          inset: 0,
          width: "100%",
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${c}-selection-item,
          ${c}-selection-placeholder
        `]: {
          display: "block",
          padding: 0,
          lineHeight: unit$1(p),
          transition: `all ${a.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${c}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${c}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${c}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${c}-show-arrow ${c}-selection-item,
        &${c}-show-arrow ${c}-selection-search,
        &${c}-show-arrow ${c}-selection-placeholder
      `]: {
        paddingInlineEnd: a.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${c}-open ${c}-selection-item`]: {
        color: a.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${c}-customize-input)`]: {
        [`${c}-selector`]: {
          width: "100%",
          height: "100%",
          alignItems: "center",
          padding: `0 ${unit$1(u)}`,
          [`${c}-selection-search-input`]: {
            height: p,
            fontSize: a.fontSize
          },
          "&:after": {
            lineHeight: unit$1(p)
          }
        }
      },
      [`&${c}-customize-input`]: {
        [`${c}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${c}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${c}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${unit$1(u)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function genSingleStyle(a) {
  const {
    componentCls: s
  } = a, c = a.calc(a.controlPaddingHorizontalSM).sub(a.lineWidth).equal();
  return [
    genSizeStyle$2(a),
    // ======================== Small ========================
    // Shared
    genSizeStyle$2(merge(a, {
      controlHeight: a.controlHeightSM,
      borderRadius: a.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${s}-single${s}-sm`]: {
        [`&:not(${s}-customize-input)`]: {
          [`${s}-selector`]: {
            padding: `0 ${unit$1(c)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${s}-show-arrow ${s}-selection-search`]: {
            insetInlineEnd: a.calc(c).add(a.calc(a.fontSize).mul(1.5)).equal()
          },
          [`
            &${s}-show-arrow ${s}-selection-item,
            &${s}-show-arrow ${s}-selection-placeholder
          `]: {
            paddingInlineEnd: a.calc(a.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    genSizeStyle$2(merge(a, {
      controlHeight: a.singleItemHeightLG,
      fontSize: a.fontSizeLG,
      borderRadius: a.borderRadiusLG
    }), "lg")
  ];
}
const prepareComponentToken$p = (a) => {
  const {
    fontSize: s,
    lineHeight: c,
    lineWidth: u,
    controlHeight: d,
    controlHeightSM: p,
    controlHeightLG: v,
    paddingXXS: A,
    controlPaddingHorizontal: x,
    zIndexPopupBase: g,
    colorText: b,
    fontWeightStrong: y,
    controlItemBgActive: f,
    controlItemBgHover: m,
    colorBgContainer: C,
    colorFillSecondary: w,
    colorBgContainerDisabled: S,
    colorTextDisabled: $,
    colorPrimaryHover: T,
    colorPrimary: I,
    controlOutline: _
  } = a, E = A * 2, R = u * 2, O = Math.min(d - E, d - R), L = Math.min(p - E, p - R), B = Math.min(v - E, v - R);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(A / 2),
    zIndexPopup: g + 50,
    optionSelectedColor: b,
    optionSelectedFontWeight: y,
    optionSelectedBg: f,
    optionActiveBg: m,
    optionPadding: `${(d - s * c) / 2}px ${x}px`,
    optionFontSize: s,
    optionLineHeight: c,
    optionHeight: d,
    selectorBg: C,
    clearBg: C,
    singleItemHeightLG: v,
    multipleItemBg: w,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: O,
    multipleItemHeightSM: L,
    multipleItemHeightLG: B,
    multipleSelectorBgDisabled: S,
    multipleItemColorDisabled: $,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(a.fontSize * 1.25),
    hoverBorderColor: T,
    activeBorderColor: I,
    activeOutlineColor: _,
    selectAffixPadding: A
  };
}, genBaseOutlinedStyle$1 = (a, s) => {
  const {
    componentCls: c,
    antCls: u,
    controlOutlineWidth: d
  } = a;
  return {
    [`&:not(${c}-customize-input) ${c}-selector`]: {
      border: `${unit$1(a.lineWidth)} ${a.lineType} ${s.borderColor}`,
      background: a.selectorBg
    },
    [`&:not(${c}-disabled):not(${c}-customize-input):not(${u}-pagination-size-changer)`]: {
      [`&:hover ${c}-selector`]: {
        borderColor: s.hoverBorderHover
      },
      [`${c}-focused& ${c}-selector`]: {
        borderColor: s.activeBorderColor,
        boxShadow: `0 0 0 ${unit$1(d)} ${s.activeOutlineColor}`,
        outline: 0
      },
      [`${c}-prefix`]: {
        color: s.color
      }
    }
  };
}, genOutlinedStatusStyle$1 = (a, s) => ({
  [`&${a.componentCls}-status-${s.status}`]: Object.assign({}, genBaseOutlinedStyle$1(a, s))
}), genOutlinedStyle$1 = (a) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle$1(a, {
    borderColor: a.colorBorder,
    hoverBorderHover: a.hoverBorderColor,
    activeBorderColor: a.activeBorderColor,
    activeOutlineColor: a.activeOutlineColor,
    color: a.colorText
  })), genOutlinedStatusStyle$1(a, {
    status: "error",
    borderColor: a.colorError,
    hoverBorderHover: a.colorErrorHover,
    activeBorderColor: a.colorError,
    activeOutlineColor: a.colorErrorOutline,
    color: a.colorError
  })), genOutlinedStatusStyle$1(a, {
    status: "warning",
    borderColor: a.colorWarning,
    hoverBorderHover: a.colorWarningHover,
    activeBorderColor: a.colorWarning,
    activeOutlineColor: a.colorWarningOutline,
    color: a.colorWarning
  })), {
    [`&${a.componentCls}-disabled`]: {
      [`&:not(${a.componentCls}-customize-input) ${a.componentCls}-selector`]: {
        background: a.colorBgContainerDisabled,
        color: a.colorTextDisabled
      }
    },
    [`&${a.componentCls}-multiple ${a.componentCls}-selection-item`]: {
      background: a.multipleItemBg,
      border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.multipleItemBorderColor}`
    }
  })
}), genBaseFilledStyle$1 = (a, s) => {
  const {
    componentCls: c,
    antCls: u
  } = a;
  return {
    [`&:not(${c}-customize-input) ${c}-selector`]: {
      background: s.bg,
      border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
      color: s.color
    },
    [`&:not(${c}-disabled):not(${c}-customize-input):not(${u}-pagination-size-changer)`]: {
      [`&:hover ${c}-selector`]: {
        background: s.hoverBg
      },
      [`${c}-focused& ${c}-selector`]: {
        background: a.selectorBg,
        borderColor: s.activeBorderColor,
        outline: 0
      }
    }
  };
}, genFilledStatusStyle$1 = (a, s) => ({
  [`&${a.componentCls}-status-${s.status}`]: Object.assign({}, genBaseFilledStyle$1(a, s))
}), genFilledStyle$1 = (a) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle$1(a, {
    bg: a.colorFillTertiary,
    hoverBg: a.colorFillSecondary,
    activeBorderColor: a.activeBorderColor,
    color: a.colorText
  })), genFilledStatusStyle$1(a, {
    status: "error",
    bg: a.colorErrorBg,
    hoverBg: a.colorErrorBgHover,
    activeBorderColor: a.colorError,
    color: a.colorError
  })), genFilledStatusStyle$1(a, {
    status: "warning",
    bg: a.colorWarningBg,
    hoverBg: a.colorWarningBgHover,
    activeBorderColor: a.colorWarning,
    color: a.colorWarning
  })), {
    [`&${a.componentCls}-disabled`]: {
      [`&:not(${a.componentCls}-customize-input) ${a.componentCls}-selector`]: {
        borderColor: a.colorBorder,
        background: a.colorBgContainerDisabled,
        color: a.colorTextDisabled
      }
    },
    [`&${a.componentCls}-multiple ${a.componentCls}-selection-item`]: {
      background: a.colorBgContainer,
      border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorSplit}`
    }
  })
}), genBorderlessStyle$1 = (a) => ({
  "&-borderless": {
    [`${a.componentCls}-selector`]: {
      background: "transparent",
      border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`
    },
    [`&${a.componentCls}-disabled`]: {
      [`&:not(${a.componentCls}-customize-input) ${a.componentCls}-selector`]: {
        color: a.colorTextDisabled
      }
    },
    [`&${a.componentCls}-multiple ${a.componentCls}-selection-item`]: {
      background: a.multipleItemBg,
      border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.multipleItemBorderColor}`
    },
    // Status
    [`&${a.componentCls}-status-error`]: {
      [`${a.componentCls}-prefix, ${a.componentCls}-selection-item`]: {
        color: a.colorError
      }
    },
    [`&${a.componentCls}-status-warning`]: {
      [`${a.componentCls}-prefix, ${a.componentCls}-selection-item`]: {
        color: a.colorWarning
      }
    }
  }
}), genBaseUnderlinedStyle$1 = (a, s) => {
  const {
    componentCls: c,
    antCls: u
  } = a;
  return {
    [`&:not(${c}-customize-input) ${c}-selector`]: {
      borderWidth: `0 0 ${unit$1(a.lineWidth)} 0`,
      borderStyle: `none none ${a.lineType} none`,
      borderColor: s.borderColor,
      background: a.selectorBg,
      borderRadius: 0
    },
    [`&:not(${c}-disabled):not(${c}-customize-input):not(${u}-pagination-size-changer)`]: {
      [`&:hover ${c}-selector`]: {
        borderColor: s.hoverBorderHover
      },
      [`${c}-focused& ${c}-selector`]: {
        borderColor: s.activeBorderColor,
        outline: 0
      },
      [`${c}-prefix`]: {
        color: s.color
      }
    }
  };
}, genUnderlinedStatusStyle$1 = (a, s) => ({
  [`&${a.componentCls}-status-${s.status}`]: Object.assign({}, genBaseUnderlinedStyle$1(a, s))
}), genUnderlinedStyle$1 = (a) => ({
  "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseUnderlinedStyle$1(a, {
    borderColor: a.colorBorder,
    hoverBorderHover: a.hoverBorderColor,
    activeBorderColor: a.activeBorderColor,
    activeOutlineColor: a.activeOutlineColor,
    color: a.colorText
  })), genUnderlinedStatusStyle$1(a, {
    status: "error",
    borderColor: a.colorError,
    hoverBorderHover: a.colorErrorHover,
    activeBorderColor: a.colorError,
    activeOutlineColor: a.colorErrorOutline,
    color: a.colorError
  })), genUnderlinedStatusStyle$1(a, {
    status: "warning",
    borderColor: a.colorWarning,
    hoverBorderHover: a.colorWarningHover,
    activeBorderColor: a.colorWarning,
    activeOutlineColor: a.colorWarningOutline,
    color: a.colorWarning
  })), {
    [`&${a.componentCls}-disabled`]: {
      [`&:not(${a.componentCls}-customize-input) ${a.componentCls}-selector`]: {
        color: a.colorTextDisabled
      }
    },
    [`&${a.componentCls}-multiple ${a.componentCls}-selection-item`]: {
      background: a.multipleItemBg,
      border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.multipleItemBorderColor}`
    }
  })
}), genVariantsStyle$1 = (a) => ({
  [a.componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedStyle$1(a)), genFilledStyle$1(a)), genBorderlessStyle$1(a)), genUnderlinedStyle$1(a))
}), genSelectorStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    position: "relative",
    transition: `all ${a.motionDurationMid} ${a.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${s}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${s}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, getSearchInputWithoutBorderStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        appearance: "none"
      }
    }
  };
}, genBaseStyle$9 = (a) => {
  const {
    antCls: s,
    componentCls: c,
    inputPaddingHorizontalBase: u,
    iconCls: d
  } = a, p = {
    [`${c}-clear`]: {
      opacity: 1,
      background: a.colorBgBase,
      borderRadius: "50%"
    }
  };
  return {
    [c]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "relative",
      display: "inline-flex",
      cursor: "pointer",
      [`&:not(${c}-customize-input) ${c}-selector`]: Object.assign(Object.assign({}, genSelectorStyle(a)), getSearchInputWithoutBorderStyle(a)),
      // ======================== Selection ========================
      [`${c}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, textEllipsis), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${s}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${c}-selection-placeholder`]: Object.assign(Object.assign({}, textEllipsis), {
        flex: 1,
        color: a.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${c}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: u,
        height: a.fontSizeIcon,
        marginTop: a.calc(a.fontSizeIcon).mul(-1).div(2).equal(),
        color: a.colorTextQuaternary,
        fontSize: a.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${a.motionDurationSlow} ease`,
        [d]: {
          verticalAlign: "top",
          transition: `transform ${a.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${c}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${c}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Wrap ===========================
      [`${c}-selection-wrap`]: {
        display: "flex",
        width: "100%",
        position: "relative",
        minWidth: 0,
        // https://github.com/ant-design/ant-design/issues/51669
        "&:after": {
          content: '"\\a0"',
          width: 0,
          overflow: "hidden"
        }
      },
      // ========================= Prefix ==========================
      [`${c}-prefix`]: {
        flex: "none",
        marginInlineEnd: a.selectAffixPadding
      },
      // ========================== Clear ==========================
      [`${c}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: u,
        zIndex: 1,
        display: "inline-block",
        width: a.fontSizeIcon,
        height: a.fontSizeIcon,
        marginTop: a.calc(a.fontSizeIcon).mul(-1).div(2).equal(),
        color: a.colorTextQuaternary,
        fontSize: a.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${a.motionDurationMid} ease, opacity ${a.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: a.colorIcon
        }
      },
      "@media(hover:none)": p,
      "&:hover": p
    }),
    // ========================= Feedback ==========================
    [`${c}-status`]: {
      "&-error, &-warning, &-success, &-validating": {
        [`&${c}-has-feedback`]: {
          [`${c}-clear`]: {
            insetInlineEnd: a.calc(u).add(a.fontSize).add(a.paddingXS).equal()
          }
        }
      }
    }
  };
}, genSelectStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return [
    {
      [s]: {
        // ==================== In Form ====================
        [`&${s}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    genBaseStyle$9(a),
    // Single
    genSingleStyle(a),
    // Multiple
    genMultipleStyle(a),
    // Dropdown
    genSingleStyle$1(a),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${s}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(a, {
      borderElCls: `${s}-selector`,
      focusElCls: `${s}-focused`
    })
  ];
}, useSelectStyle = genStyleHooks("Select", (a, {
  rootPrefixCls: s
}) => {
  const c = merge(a, {
    rootPrefixCls: s,
    inputPaddingHorizontalBase: a.calc(a.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: a.multipleItemHeight,
    selectHeight: a.controlHeight
  });
  return [genSelectStyle(c), genVariantsStyle$1(c)];
}, prepareComponentToken$p, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var CheckOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" }, CheckOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CheckOutlined$1
  }));
}, RefIcon$D = /* @__PURE__ */ reactExports.forwardRef(CheckOutlined), DownOutlined$3 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" }, DownOutlined$2 = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: DownOutlined$3
  }));
}, RefIcon$C = /* @__PURE__ */ reactExports.forwardRef(DownOutlined$2), SearchOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" }, SearchOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: SearchOutlined$1
  }));
}, RefIcon$B = /* @__PURE__ */ reactExports.forwardRef(SearchOutlined);
function useIcons$1({
  suffixIcon: a,
  clearIcon: s,
  menuItemSelectedIcon: c,
  removeIcon: u,
  loading: d,
  multiple: p,
  hasFeedback: v,
  prefixCls: A,
  showSuffixIcon: x,
  feedbackIcon: g,
  showArrow: b,
  componentName: y
}) {
  const f = s ?? /* @__PURE__ */ reactExports.createElement(RefIcon$J, null), m = ($) => a === null && !v && !b ? null : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, x !== !1 && $, v && g);
  let C = null;
  if (a !== void 0)
    C = m(a);
  else if (d)
    C = m(/* @__PURE__ */ reactExports.createElement(RefIcon$F, {
      spin: !0
    }));
  else {
    const $ = `${A}-suffix`;
    C = ({
      open: T,
      showSearch: I
    }) => m(T && I ? /* @__PURE__ */ reactExports.createElement(RefIcon$B, {
      className: $
    }) : /* @__PURE__ */ reactExports.createElement(RefIcon$C, {
      className: $
    }));
  }
  let w = null;
  c !== void 0 ? w = c : p ? w = /* @__PURE__ */ reactExports.createElement(RefIcon$D, null) : w = null;
  let S = null;
  return u !== void 0 ? S = u : S = /* @__PURE__ */ reactExports.createElement(RefIcon$I, null), {
    clearIcon: f,
    suffixIcon: C,
    itemIcon: w,
    removeIcon: S
  };
}
function useShowArrow(a, s) {
  return s !== void 0 ? s : a !== null;
}
var __rest$X = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE", InternalSelect = (a, s) => {
  var c, u, d, p, v;
  const {
    prefixCls: A,
    bordered: x,
    className: g,
    rootClassName: b,
    getPopupContainer: y,
    popupClassName: f,
    dropdownClassName: m,
    listHeight: C = 256,
    placement: w,
    listItemHeight: S,
    size: $,
    disabled: T,
    notFoundContent: I,
    status: _,
    builtinPlacements: E,
    dropdownMatchSelectWidth: R,
    popupMatchSelectWidth: O,
    direction: L,
    style: B,
    allowClear: F,
    variant: M,
    dropdownStyle: W,
    transitionName: j,
    tagRender: G,
    maxCount: U,
    prefix: k,
    dropdownRender: N,
    popupRender: P,
    onDropdownVisibleChange: D,
    onOpenChange: H,
    styles: V,
    classNames: Z
  } = a, ne = __rest$X(a, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount", "prefix", "dropdownRender", "popupRender", "onDropdownVisibleChange", "onOpenChange", "styles", "classNames"]), {
    getPopupContainer: K,
    getPrefixCls: q,
    renderEmpty: Y,
    direction: ee,
    virtual: Q,
    popupMatchSelectWidth: J,
    popupOverflow: te
  } = reactExports.useContext(ConfigContext$1), {
    showSearch: ae,
    style: se,
    styles: ie,
    className: fe,
    classNames: ge
  } = useComponentConfig("select"), [, me] = useToken$1(), pe = S ?? me?.controlHeight, be = q("select", A), le = q(), ve = L ?? ee, {
    compactSize: he,
    compactItemClassnames: ye
  } = useCompactItemContext(be, ve), [Ce, xe] = useVariant("select", M, x), we = useCSSVarCls(be), [$e, Ae, ue] = useSelectStyle(be, we), ce = reactExports.useMemo(() => {
    const {
      mode: ft
    } = a;
    if (ft !== "combobox")
      return ft === SECRET_COMBOBOX_MODE_DO_NOT_USE ? "combobox" : ft;
  }, [a.mode]), Ee = ce === "multiple" || ce === "tags", _e = useShowArrow(a.suffixIcon, a.showArrow), Te = (c = O ?? R) !== null && c !== void 0 ? c : J, ke = ((u = V?.popup) === null || u === void 0 ? void 0 : u.root) || ((d = ie.popup) === null || d === void 0 ? void 0 : d.root) || W, Re = P || N, Be = H || D, {
    status: Oe,
    hasFeedback: Me,
    isFormItemInput: Fe,
    feedbackIcon: Ue
  } = reactExports.useContext(FormItemInputContext), je = getMergedStatus(Oe, _);
  let Le;
  I !== void 0 ? Le = I : ce === "combobox" ? Le = null : Le = Y?.("Select") || /* @__PURE__ */ reactExports.createElement(DefaultRenderEmpty, {
    componentName: "Select"
  });
  const {
    suffixIcon: De,
    itemIcon: Ne,
    removeIcon: Ge,
    clearIcon: Xe
  } = useIcons$1(Object.assign(Object.assign({}, ne), {
    multiple: Ee,
    hasFeedback: Me,
    feedbackIcon: Ue,
    showSuffixIcon: _e,
    prefixCls: be,
    componentName: "Select"
  })), nt = F === !0 ? {
    clearIcon: Xe
  } : F, ct = omit(ne, ["suffixIcon", "itemIcon"]), it = classnames(((p = Z?.popup) === null || p === void 0 ? void 0 : p.root) || ((v = ge?.popup) === null || v === void 0 ? void 0 : v.root) || f || m, {
    [`${be}-dropdown-${ve}`]: ve === "rtl"
  }, b, ge.root, Z?.root, ue, we, Ae), We = useSize((ft) => {
    var vt;
    return (vt = $ ?? he) !== null && vt !== void 0 ? vt : ft;
  }), Ve = reactExports.useContext(DisabledContext), ut = T ?? Ve, at = classnames({
    [`${be}-lg`]: We === "large",
    [`${be}-sm`]: We === "small",
    [`${be}-rtl`]: ve === "rtl",
    [`${be}-${Ce}`]: xe,
    [`${be}-in-form-item`]: Fe
  }, getStatusClassNames(be, je, Me), ye, fe, g, ge.root, Z?.root, b, ue, we, Ae), Qe = reactExports.useMemo(() => w !== void 0 ? w : ve === "rtl" ? "bottomRight" : "bottomLeft", [w, ve]), [st] = useZIndex("SelectLike", ke?.zIndex);
  return $e(/* @__PURE__ */ reactExports.createElement(TypedSelect, Object.assign({
    ref: s,
    virtual: Q,
    showSearch: ae
  }, ct, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, ie.root), V?.root), se), B),
    dropdownMatchSelectWidth: Te,
    transitionName: getTransitionName$1(le, "slide-up", j),
    builtinPlacements: mergedBuiltinPlacements(E, te),
    listHeight: C,
    listItemHeight: pe,
    mode: ce,
    prefixCls: be,
    placement: Qe,
    direction: ve,
    prefix: k,
    suffixIcon: De,
    menuItemSelectedIcon: Ne,
    removeIcon: Ge,
    allowClear: nt,
    notFoundContent: Le,
    className: at,
    getPopupContainer: y || K,
    dropdownClassName: it,
    disabled: ut,
    dropdownStyle: Object.assign(Object.assign({}, ke), {
      zIndex: st
    }),
    maxCount: Ee ? U : void 0,
    tagRender: Ee ? G : void 0,
    dropdownRender: Re,
    onDropdownVisibleChange: Be
  })));
}, Select = /* @__PURE__ */ reactExports.forwardRef(InternalSelect), PurePanel$6 = genPurePanel(Select, "dropdownAlign");
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select.Option = Option;
Select.OptGroup = OptGroup;
Select._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$6;
const addMediaQueryListener = (a, s) => {
  typeof a?.addEventListener < "u" ? a.addEventListener("change", s) : typeof a?.addListener < "u" && a.addListener(s);
}, removeMediaQueryListener = (a, s) => {
  typeof a?.removeEventListener < "u" ? a.removeEventListener("change", s) : typeof a?.removeListener < "u" && a.removeListener(s);
}, responsiveArray = ["xxl", "xl", "lg", "md", "sm", "xs"], getResponsiveMap = (a) => ({
  xs: `(max-width: ${a.screenXSMax}px)`,
  sm: `(min-width: ${a.screenSM}px)`,
  md: `(min-width: ${a.screenMD}px)`,
  lg: `(min-width: ${a.screenLG}px)`,
  xl: `(min-width: ${a.screenXL}px)`,
  xxl: `(min-width: ${a.screenXXL}px)`
}), validateBreakpoints = (a) => {
  const s = a, c = [].concat(responsiveArray).reverse();
  return c.forEach((u, d) => {
    const p = u.toUpperCase(), v = `screen${p}Min`, A = `screen${p}`;
    if (!(s[v] <= s[A]))
      throw new Error(`${v}<=${A} fails : !(${s[v]}<=${s[A]})`);
    if (d < c.length - 1) {
      const x = `screen${p}Max`;
      if (!(s[A] <= s[x]))
        throw new Error(`${A}<=${x} fails : !(${s[A]}<=${s[x]})`);
      const b = `screen${c[d + 1].toUpperCase()}Min`;
      if (!(s[x] <= s[b]))
        throw new Error(`${x}<=${b} fails : !(${s[x]}<=${s[b]})`);
    }
  }), a;
}, useResponsiveObserver = () => {
  const [, a] = useToken$1(), s = getResponsiveMap(validateBreakpoints(a));
  return React.useMemo(() => {
    const c = /* @__PURE__ */ new Map();
    let u = -1, d = {};
    return {
      responsiveMap: s,
      matchHandlers: {},
      dispatch(p) {
        return d = p, c.forEach((v) => v(d)), c.size >= 1;
      },
      subscribe(p) {
        return c.size || this.register(), u += 1, c.set(u, p), p(d), u;
      },
      unsubscribe(p) {
        c.delete(p), c.size || this.unregister();
      },
      register() {
        Object.entries(s).forEach(([p, v]) => {
          const A = ({
            matches: g
          }) => {
            this.dispatch(Object.assign(Object.assign({}, d), {
              [p]: g
            }));
          }, x = window.matchMedia(v);
          addMediaQueryListener(x, A), this.matchHandlers[v] = {
            mql: x,
            listener: A
          }, A(x);
        });
      },
      unregister() {
        Object.values(s).forEach((p) => {
          const v = this.matchHandlers[p];
          removeMediaQueryListener(v?.mql, v?.listener);
        }), c.clear();
      }
    };
  }, [a]);
};
function useForceUpdate() {
  const [, a] = reactExports.useReducer((s) => s + 1, 0);
  return a;
}
function useBreakpoint(a = !0, s = {}) {
  const c = reactExports.useRef(s), u = useForceUpdate(), d = useResponsiveObserver();
  return useLayoutEffect$1(() => {
    const p = d.subscribe((v) => {
      c.current = v, a && u();
    });
    return () => d.unsubscribe(p);
  }, []), c.current;
}
const getRenderPropValue = (a) => a ? typeof a == "function" ? a() : a : null;
function Popup$2(a) {
  var s = a.children, c = a.prefixCls, u = a.id, d = a.overlayInnerStyle, p = a.bodyClassName, v = a.className, A = a.style;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(c, "-content"), v),
    style: A
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(c, "-inner"), p),
    id: u,
    role: "tooltip",
    style: d
  }, typeof s == "function" ? s() : s));
}
var autoAdjustOverflowTopBottom = {
  shiftX: 64,
  adjustY: 1
}, autoAdjustOverflowLeftRight = {
  adjustX: 1,
  shiftY: !0
}, targetOffset$1 = [0, 0], placements$3 = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  }
}, _excluded$J = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "classNames", "styles"], Tooltip$1 = function a(s, c) {
  var u = s.overlayClassName, d = s.trigger, p = d === void 0 ? ["hover"] : d, v = s.mouseEnterDelay, A = v === void 0 ? 0 : v, x = s.mouseLeaveDelay, g = x === void 0 ? 0.1 : x, b = s.overlayStyle, y = s.prefixCls, f = y === void 0 ? "rc-tooltip" : y, m = s.children, C = s.onVisibleChange, w = s.afterVisibleChange, S = s.transitionName, $ = s.animation, T = s.motion, I = s.placement, _ = I === void 0 ? "right" : I, E = s.align, R = E === void 0 ? {} : E, O = s.destroyTooltipOnHide, L = O === void 0 ? !1 : O, B = s.defaultVisible, F = s.getTooltipContainer, M = s.overlayInnerStyle;
  s.arrowContent;
  var W = s.overlay, j = s.id, G = s.showArrow, U = G === void 0 ? !0 : G, k = s.classNames, N = s.styles, P = _objectWithoutProperties$2(s, _excluded$J), D = useId$2(j), H = reactExports.useRef(null);
  reactExports.useImperativeHandle(c, function() {
    return H.current;
  });
  var V = _objectSpread2$1({}, P);
  "visible" in s && (V.popupVisible = s.visible);
  var Z = function() {
    return /* @__PURE__ */ reactExports.createElement(Popup$2, {
      key: "content",
      prefixCls: f,
      id: D,
      bodyClassName: k?.body,
      overlayInnerStyle: _objectSpread2$1(_objectSpread2$1({}, M), N?.body)
    }, W);
  }, ne = function() {
    var q = reactExports.Children.only(m), Y = q?.props || {}, ee = _objectSpread2$1(_objectSpread2$1({}, Y), {}, {
      "aria-describedby": W ? D : null
    });
    return /* @__PURE__ */ reactExports.cloneElement(m, ee);
  };
  return /* @__PURE__ */ reactExports.createElement(Trigger$1, _extends$3({
    popupClassName: classnames(u, k?.root),
    prefixCls: f,
    popup: Z,
    action: p,
    builtinPlacements: placements$3,
    popupPlacement: _,
    ref: H,
    popupAlign: R,
    getPopupContainer: F,
    onPopupVisibleChange: C,
    afterPopupVisibleChange: w,
    popupTransitionName: S,
    popupAnimation: $,
    popupMotion: T,
    defaultPopupVisible: B,
    autoDestroy: L,
    mouseLeaveDelay: g,
    popupStyle: _objectSpread2$1(_objectSpread2$1({}, b), N?.root),
    mouseEnterDelay: A,
    arrow: U
  }, V), ne());
};
const Tooltip$2 = /* @__PURE__ */ reactExports.forwardRef(Tooltip$1);
function getArrowToken(a) {
  const {
    sizePopupArrow: s,
    borderRadiusXS: c,
    borderRadiusOuter: u
  } = a, d = s / 2, p = 0, v = d, A = u * 1 / Math.sqrt(2), x = d - u * (1 - 1 / Math.sqrt(2)), g = d - c * (1 / Math.sqrt(2)), b = u * (Math.sqrt(2) - 1) + c * (1 / Math.sqrt(2)), y = 2 * d - g, f = b, m = 2 * d - A, C = x, w = 2 * d - p, S = v, $ = d * Math.sqrt(2) + u * (Math.sqrt(2) - 2), T = u * (Math.sqrt(2) - 1), I = `polygon(${T}px 100%, 50% ${T}px, ${2 * d - T}px 100%, ${T}px 100%)`, _ = `path('M ${p} ${v} A ${u} ${u} 0 0 0 ${A} ${x} L ${g} ${b} A ${c} ${c} 0 0 1 ${y} ${f} L ${m} ${C} A ${u} ${u} 0 0 0 ${w} ${S} Z')`;
  return {
    arrowShadowWidth: $,
    arrowPath: _,
    arrowPolygon: I
  };
}
const genRoundedArrow = (a, s, c) => {
  const {
    sizePopupArrow: u,
    arrowPolygon: d,
    arrowPath: p,
    arrowShadowWidth: v,
    borderRadiusXS: A,
    calc: x
  } = a;
  return {
    pointerEvents: "none",
    width: u,
    height: u,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: u,
      height: x(u).div(2).equal(),
      background: s,
      clipPath: {
        _multi_value_: !0,
        value: [d, p]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: v,
      height: v,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${unit$1(A)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: c,
      zIndex: 0,
      background: "transparent"
    }
  };
}, MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(a) {
  const {
    contentRadius: s,
    limitVerticalRadius: c
  } = a, u = s > 12 ? s + 2 : 12;
  return {
    arrowOffsetHorizontal: u,
    arrowOffsetVertical: c ? MAX_VERTICAL_CONTENT_RADIUS : u
  };
}
function isInject(a, s) {
  return a ? s : {};
}
function getArrowStyle(a, s, c) {
  const {
    componentCls: u,
    boxShadowPopoverArrow: d,
    arrowOffsetVertical: p,
    arrowOffsetHorizontal: v
  } = a, {
    arrowDistance: A = 0,
    arrowPlacement: x = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = c || {};
  return {
    [u]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${u}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, genRoundedArrow(a, s, d)), {
        "&:before": {
          background: s
        }
      })]
    }, isInject(!!x.top, {
      [[`&-placement-top > ${u}-arrow`, `&-placement-topLeft > ${u}-arrow`, `&-placement-topRight > ${u}-arrow`].join(",")]: {
        bottom: A,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${u}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      "&-placement-topLeft": {
        "--arrow-offset-horizontal": v,
        [`> ${u}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: v
          }
        }
      },
      "&-placement-topRight": {
        "--arrow-offset-horizontal": `calc(100% - ${unit$1(v)})`,
        [`> ${u}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: v
          }
        }
      }
    })), isInject(!!x.bottom, {
      [[`&-placement-bottom > ${u}-arrow`, `&-placement-bottomLeft > ${u}-arrow`, `&-placement-bottomRight > ${u}-arrow`].join(",")]: {
        top: A,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${u}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      "&-placement-bottomLeft": {
        "--arrow-offset-horizontal": v,
        [`> ${u}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: v
          }
        }
      },
      "&-placement-bottomRight": {
        "--arrow-offset-horizontal": `calc(100% - ${unit$1(v)})`,
        [`> ${u}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: v
          }
        }
      }
    })), isInject(!!x.left, {
      [[`&-placement-left > ${u}-arrow`, `&-placement-leftTop > ${u}-arrow`, `&-placement-leftBottom > ${u}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: A
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${u}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${u}-arrow`]: {
        top: p
      },
      [`&-placement-leftBottom > ${u}-arrow`]: {
        bottom: p
      }
    })), isInject(!!x.right, {
      [[`&-placement-right > ${u}-arrow`, `&-placement-rightTop > ${u}-arrow`, `&-placement-rightBottom > ${u}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: A
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${u}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${u}-arrow`]: {
        top: p
      },
      [`&-placement-rightBottom > ${u}-arrow`]: {
        bottom: p
      }
    }))
  };
}
function getOverflowOptions(a, s, c, u) {
  if (u === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const d = u && typeof u == "object" ? u : {}, p = {};
  switch (a) {
    case "top":
    case "bottom":
      p.shiftX = s.arrowOffsetHorizontal * 2 + c, p.shiftY = !0, p.adjustY = !0;
      break;
    case "left":
    case "right":
      p.shiftY = s.arrowOffsetVertical * 2 + c, p.shiftX = !0, p.adjustX = !0;
      break;
  }
  const v = Object.assign(Object.assign({}, p), d);
  return v.shiftX || (v.adjustX = !0), v.shiftY || (v.adjustY = !0), v;
}
const PlacementAlignMap = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, ArrowCenterPlacementAlignMap = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, DisableAutoArrowList = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function getPlacements(a) {
  const {
    arrowWidth: s,
    autoAdjustOverflow: c,
    arrowPointAtCenter: u,
    offset: d,
    borderRadius: p,
    visibleFirst: v
  } = a, A = s / 2, x = {};
  return Object.keys(PlacementAlignMap).forEach((g) => {
    const b = u && ArrowCenterPlacementAlignMap[g] || PlacementAlignMap[g], y = Object.assign(Object.assign({}, b), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (x[g] = y, DisableAutoArrowList.has(g) && (y.autoArrow = !1), g) {
      case "top":
      case "topLeft":
      case "topRight":
        y.offset[1] = -A - d;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        y.offset[1] = A + d;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        y.offset[0] = -A - d;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        y.offset[0] = A + d;
        break;
    }
    const f = getArrowOffsetToken({
      contentRadius: p,
      limitVerticalRadius: !0
    });
    if (u)
      switch (g) {
        case "topLeft":
        case "bottomLeft":
          y.offset[0] = -f.arrowOffsetHorizontal - A;
          break;
        case "topRight":
        case "bottomRight":
          y.offset[0] = f.arrowOffsetHorizontal + A;
          break;
        case "leftTop":
        case "rightTop":
          y.offset[1] = -f.arrowOffsetHorizontal * 2 + A;
          break;
        case "leftBottom":
        case "rightBottom":
          y.offset[1] = f.arrowOffsetHorizontal * 2 - A;
          break;
      }
    y.overflow = getOverflowOptions(g, f, s, c), v && (y.htmlRegion = "visibleFirst");
  }), x;
}
const genTooltipStyle = (a) => {
  const {
    calc: s,
    componentCls: c,
    // ant-tooltip
    tooltipMaxWidth: u,
    tooltipColor: d,
    tooltipBg: p,
    tooltipBorderRadius: v,
    zIndexPopup: A,
    controlHeight: x,
    boxShadowSecondary: g,
    paddingSM: b,
    paddingXS: y,
    arrowOffsetHorizontal: f,
    sizePopupArrow: m
  } = a, C = s(v).add(m).add(f).equal(), w = s(v).mul(2).add(m).equal();
  return [
    {
      [c]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
        position: "absolute",
        zIndex: A,
        display: "block",
        width: "max-content",
        maxWidth: u,
        visibility: "visible",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": p,
        // Wrapper for the tooltip content
        [`${c}-inner`]: {
          minWidth: w,
          minHeight: x,
          padding: `${unit$1(a.calc(b).div(2).equal())} ${unit$1(y)}`,
          color: d,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: p,
          borderRadius: v,
          boxShadow: g,
          boxSizing: "border-box"
        },
        // Align placement should have another min width
        [["&-placement-topLeft", "&-placement-topRight", "&-placement-bottomLeft", "&-placement-bottomRight"].join(",")]: {
          minWidth: C
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${c}-inner`]: {
            borderRadius: a.min(v, MAX_VERTICAL_CONTENT_RADIUS)
          }
        },
        [`${c}-content`]: {
          position: "relative"
        }
      }), genPresetColor(a, (S, {
        darkColor: $
      }) => ({
        [`&${c}-${S}`]: {
          [`${c}-inner`]: {
            backgroundColor: $
          },
          [`${c}-arrow`]: {
            "--antd-arrow-background-color": $
          }
        }
      }))), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    getArrowStyle(a, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${c}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: a.sizePopupArrow
      }
    }
  ];
}, prepareComponentToken$o = (a) => Object.assign(Object.assign({
  zIndexPopup: a.zIndexPopupBase + 70
}, getArrowOffsetToken({
  contentRadius: a.borderRadius,
  limitVerticalRadius: !0
})), getArrowToken(merge(a, {
  borderRadiusOuter: Math.min(a.borderRadiusOuter, 4)
}))), useStyle$s = (a, s = !0) => genStyleHooks("Tooltip", (u) => {
  const {
    borderRadius: d,
    colorTextLightSolid: p,
    colorBgSpotlight: v
  } = u, A = merge(u, {
    // default variables
    tooltipMaxWidth: 250,
    tooltipColor: p,
    tooltipBorderRadius: d,
    tooltipBg: v
  });
  return [genTooltipStyle(A), initZoomMotion(u, "zoom-big-fast")];
}, prepareComponentToken$o, {
  resetStyle: !1,
  // Popover use Tooltip as internal component. We do not need to handle this.
  injectStyle: s
})(a), inverseColors = PresetColors.map((a) => `${a}-inverse`);
function isPresetColor(a, s = !0) {
  return s ? [].concat(_toConsumableArray$e(inverseColors), _toConsumableArray$e(PresetColors)).includes(a) : PresetColors.includes(a);
}
function parseColor(a, s) {
  const c = isPresetColor(s), u = classnames({
    [`${a}-${s}`]: s && c
  }), d = {}, p = {};
  return s && !c && (d.background = s, p["--antd-arrow-background-color"] = s), {
    className: u,
    overlayStyle: d,
    arrowStyle: p
  };
}
const PurePanel$5 = (a) => {
  const {
    prefixCls: s,
    className: c,
    placement: u = "top",
    title: d,
    color: p,
    overlayInnerStyle: v
  } = a, {
    getPrefixCls: A
  } = reactExports.useContext(ConfigContext$1), x = A("tooltip", s), [g, b, y] = useStyle$s(x), f = parseColor(x, p), m = f.arrowStyle, C = Object.assign(Object.assign({}, v), f.overlayStyle), w = classnames(b, y, x, `${x}-pure`, `${x}-placement-${u}`, c, f.className);
  return g(/* @__PURE__ */ reactExports.createElement("div", {
    className: w,
    style: m
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${x}-arrow`
  }), /* @__PURE__ */ reactExports.createElement(Popup$2, Object.assign({}, a, {
    className: b,
    prefixCls: x,
    overlayInnerStyle: C
  }), d)));
};
var __rest$W = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalTooltip = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var c, u;
  const {
    prefixCls: d,
    openClassName: p,
    getTooltipContainer: v,
    color: A,
    overlayInnerStyle: x,
    children: g,
    afterOpenChange: b,
    afterVisibleChange: y,
    destroyTooltipOnHide: f,
    destroyOnHidden: m,
    arrow: C = !0,
    title: w,
    overlay: S,
    builtinPlacements: $,
    arrowPointAtCenter: T = !1,
    autoAdjustOverflow: I = !0,
    motion: _,
    getPopupContainer: E,
    placement: R = "top",
    mouseEnterDelay: O = 0.1,
    mouseLeaveDelay: L = 0.1,
    overlayStyle: B,
    rootClassName: F,
    overlayClassName: M,
    styles: W,
    classNames: j
  } = a, G = __rest$W(a, ["prefixCls", "openClassName", "getTooltipContainer", "color", "overlayInnerStyle", "children", "afterOpenChange", "afterVisibleChange", "destroyTooltipOnHide", "destroyOnHidden", "arrow", "title", "overlay", "builtinPlacements", "arrowPointAtCenter", "autoAdjustOverflow", "motion", "getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName", "overlayClassName", "styles", "classNames"]), U = !!C, [, k] = useToken$1(), {
    getPopupContainer: N,
    getPrefixCls: P,
    direction: D,
    className: H,
    style: V,
    classNames: Z,
    styles: ne
  } = useComponentConfig("tooltip"), K = devUseWarning(), q = reactExports.useRef(null), Y = () => {
    var _e;
    (_e = q.current) === null || _e === void 0 || _e.forceAlign();
  };
  reactExports.useImperativeHandle(s, () => {
    var _e, Te;
    return {
      forceAlign: Y,
      forcePopupAlign: () => {
        K.deprecated(!1, "forcePopupAlign", "forceAlign"), Y();
      },
      nativeElement: (_e = q.current) === null || _e === void 0 ? void 0 : _e.nativeElement,
      popupElement: (Te = q.current) === null || Te === void 0 ? void 0 : Te.popupElement
    };
  });
  const [ee, Q] = useMergedState(!1, {
    value: (c = a.open) !== null && c !== void 0 ? c : a.visible,
    defaultValue: (u = a.defaultOpen) !== null && u !== void 0 ? u : a.defaultVisible
  }), J = !w && !S && w !== 0, te = (_e) => {
    var Te, ke;
    Q(J ? !1 : _e), J || ((Te = a.onOpenChange) === null || Te === void 0 || Te.call(a, _e), (ke = a.onVisibleChange) === null || ke === void 0 || ke.call(a, _e));
  }, ae = reactExports.useMemo(() => {
    var _e, Te;
    let ke = T;
    return typeof C == "object" && (ke = (Te = (_e = C.pointAtCenter) !== null && _e !== void 0 ? _e : C.arrowPointAtCenter) !== null && Te !== void 0 ? Te : T), $ || getPlacements({
      arrowPointAtCenter: ke,
      autoAdjustOverflow: I,
      arrowWidth: U ? k.sizePopupArrow : 0,
      borderRadius: k.borderRadius,
      offset: k.marginXXS,
      visibleFirst: !0
    });
  }, [T, C, $, k]), se = reactExports.useMemo(() => w === 0 ? w : S || w || "", [S, w]), ie = /* @__PURE__ */ reactExports.createElement(ContextIsolator, {
    space: !0
  }, typeof se == "function" ? se() : se), fe = P("tooltip", d), ge = P(), me = a["data-popover-inject"];
  let pe = ee;
  !("open" in a) && !("visible" in a) && J && (pe = !1);
  const be = /* @__PURE__ */ reactExports.isValidElement(g) && !isFragment(g) ? g : /* @__PURE__ */ reactExports.createElement("span", null, g), le = be.props, ve = !le.className || typeof le.className == "string" ? classnames(le.className, p || `${fe}-open`) : le.className, [he, ye, Ce] = useStyle$s(fe, !me), xe = parseColor(fe, A), we = xe.arrowStyle, $e = classnames(M, {
    [`${fe}-rtl`]: D === "rtl"
  }, xe.className, F, ye, Ce, H, Z.root, j?.root), Ae = classnames(Z.body, j?.body), [ue, ce] = useZIndex("Tooltip", G.zIndex), Ee = /* @__PURE__ */ reactExports.createElement(Tooltip$2, Object.assign({}, G, {
    zIndex: ue,
    showArrow: U,
    placement: R,
    mouseEnterDelay: O,
    mouseLeaveDelay: L,
    prefixCls: fe,
    classNames: {
      root: $e,
      body: Ae
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, we), ne.root), V), B), W?.root),
      body: Object.assign(Object.assign(Object.assign(Object.assign({}, ne.body), x), W?.body), xe.overlayStyle)
    },
    getTooltipContainer: E || v || N,
    ref: q,
    builtinPlacements: ae,
    overlay: ie,
    visible: pe,
    onVisibleChange: te,
    afterVisibleChange: b ?? y,
    arrowContent: /* @__PURE__ */ reactExports.createElement("span", {
      className: `${fe}-arrow-content`
    }),
    motion: {
      motionName: getTransitionName$1(ge, "zoom-big-fast", a.transitionName),
      motionDeadline: 1e3
    },
    // TODO: In the future, destroyTooltipOnHide in rc-tooltip needs to be upgrade to destroyOnHidden
    destroyTooltipOnHide: m ?? !!f
  }), pe ? cloneElement(be, {
    className: ve
  }) : be);
  return he(/* @__PURE__ */ reactExports.createElement(zIndexContext.Provider, {
    value: ce
  }, Ee));
}), Tooltip = InternalTooltip;
Tooltip._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$5;
const genBaseStyle$8 = (a) => {
  const {
    componentCls: s,
    popoverColor: c,
    titleMinWidth: u,
    fontWeightStrong: d,
    innerPadding: p,
    boxShadowSecondary: v,
    colorTextHeading: A,
    borderRadiusLG: x,
    zIndexPopup: g,
    titleMarginBottom: b,
    colorBgElevated: y,
    popoverBg: f,
    titleBorderBottom: m,
    innerContentPadding: C,
    titlePadding: w
  } = a;
  return [
    {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: g,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "--antd-arrow-background-color": y,
        width: "max-content",
        maxWidth: "100vw",
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${s}-content`]: {
          position: "relative"
        },
        [`${s}-inner`]: {
          backgroundColor: f,
          backgroundClip: "padding-box",
          borderRadius: x,
          boxShadow: v,
          padding: p
        },
        [`${s}-title`]: {
          minWidth: u,
          marginBottom: b,
          color: A,
          fontWeight: d,
          borderBottom: m,
          padding: w
        },
        [`${s}-inner-content`]: {
          color: c,
          padding: C
        }
      })
    },
    // Arrow Style
    getArrowStyle(a, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${s}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: a.sizePopupArrow,
        display: "inline-block",
        [`${s}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, genColorStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: PresetColors.map((c) => {
      const u = a[`${c}6`];
      return {
        [`&${s}-${c}`]: {
          "--antd-arrow-background-color": u,
          [`${s}-inner`]: {
            backgroundColor: u
          },
          [`${s}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, prepareComponentToken$n = (a) => {
  const {
    lineWidth: s,
    controlHeight: c,
    fontHeight: u,
    padding: d,
    wireframe: p,
    zIndexPopupBase: v,
    borderRadiusLG: A,
    marginXS: x,
    lineType: g,
    colorSplit: b,
    paddingSM: y
  } = a, f = c - u, m = f / 2, C = f / 2 - s, w = d;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: v + 30
  }, getArrowToken(a)), getArrowOffsetToken({
    contentRadius: A,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: p ? 0 : 12,
    titleMarginBottom: p ? 0 : x,
    titlePadding: p ? `${m}px ${w}px ${C}px` : 0,
    titleBorderBottom: p ? `${s}px ${g} ${b}` : "none",
    innerContentPadding: p ? `${y}px ${w}px` : 0
  });
}, useStyle$r = genStyleHooks("Popover", (a) => {
  const {
    colorBgElevated: s,
    colorText: c
  } = a, u = merge(a, {
    popoverBg: s,
    popoverColor: c
  });
  return [genBaseStyle$8(u), genColorStyle(u), initZoomMotion(u, "zoom-big")];
}, prepareComponentToken$n, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var __rest$V = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Overlay$2 = ({
  title: a,
  content: s,
  prefixCls: c
}) => !a && !s ? null : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, a && /* @__PURE__ */ reactExports.createElement("div", {
  className: `${c}-title`
}, a), s && /* @__PURE__ */ reactExports.createElement("div", {
  className: `${c}-inner-content`
}, s)), RawPurePanel = (a) => {
  const {
    hashId: s,
    prefixCls: c,
    className: u,
    style: d,
    placement: p = "top",
    title: v,
    content: A,
    children: x
  } = a, g = getRenderPropValue(v), b = getRenderPropValue(A), y = classnames(s, c, `${c}-pure`, `${c}-placement-${p}`, u);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: y,
    style: d
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${c}-arrow`
  }), /* @__PURE__ */ reactExports.createElement(Popup$2, Object.assign({}, a, {
    className: s,
    prefixCls: c
  }), x || /* @__PURE__ */ reactExports.createElement(Overlay$2, {
    prefixCls: c,
    title: g,
    content: b
  })));
}, PurePanel$4 = (a) => {
  const {
    prefixCls: s,
    className: c
  } = a, u = __rest$V(a, ["prefixCls", "className"]), {
    getPrefixCls: d
  } = reactExports.useContext(ConfigContext$1), p = d("popover", s), [v, A, x] = useStyle$r(p);
  return v(/* @__PURE__ */ reactExports.createElement(RawPurePanel, Object.assign({}, u, {
    prefixCls: p,
    hashId: A,
    className: classnames(c, x)
  })));
};
var __rest$U = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalPopover = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var c, u;
  const {
    prefixCls: d,
    title: p,
    content: v,
    overlayClassName: A,
    placement: x = "top",
    trigger: g = "hover",
    children: b,
    mouseEnterDelay: y = 0.1,
    mouseLeaveDelay: f = 0.1,
    onOpenChange: m,
    overlayStyle: C = {},
    styles: w,
    classNames: S
  } = a, $ = __rest$U(a, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle", "styles", "classNames"]), {
    getPrefixCls: T,
    className: I,
    style: _,
    classNames: E,
    styles: R
  } = useComponentConfig("popover"), O = T("popover", d), [L, B, F] = useStyle$r(O), M = T(), W = classnames(A, B, F, I, E.root, S?.root), j = classnames(E.body, S?.body), [G, U] = useMergedState(!1, {
    value: (c = a.open) !== null && c !== void 0 ? c : a.visible,
    defaultValue: (u = a.defaultOpen) !== null && u !== void 0 ? u : a.defaultVisible
  }), k = (V, Z) => {
    U(V, !0), m?.(V, Z);
  }, N = (V) => {
    V.keyCode === KeyCode.ESC && k(!1, V);
  }, P = (V) => {
    k(V);
  }, D = getRenderPropValue(p), H = getRenderPropValue(v);
  return L(/* @__PURE__ */ reactExports.createElement(Tooltip, Object.assign({
    placement: x,
    trigger: g,
    mouseEnterDelay: y,
    mouseLeaveDelay: f
  }, $, {
    prefixCls: O,
    classNames: {
      root: W,
      body: j
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, R.root), _), C), w?.root),
      body: Object.assign(Object.assign({}, R.body), w?.body)
    },
    ref: s,
    open: G,
    onOpenChange: P,
    overlay: D || H ? /* @__PURE__ */ reactExports.createElement(Overlay$2, {
      prefixCls: O,
      title: D,
      content: H
    }) : null,
    transitionName: getTransitionName$1(M, "zoom-big", $.transitionName),
    "data-popover-inject": !0
  }), cloneElement(b, {
    onKeyDown: (V) => {
      var Z, ne;
      /* @__PURE__ */ reactExports.isValidElement(b) && ((ne = b == null ? void 0 : (Z = b.props).onKeyDown) === null || ne === void 0 || ne.call(Z, V)), N(V);
    }
  })));
}), Popover = InternalPopover;
Popover._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$4;
var LeftOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" }, LeftOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: LeftOutlined$1
  }));
}, RefIcon$A = /* @__PURE__ */ reactExports.forwardRef(LeftOutlined), ESC$1 = KeyCode.ESC, TAB = KeyCode.TAB;
function useAccessibility$1(a) {
  var s = a.visible, c = a.triggerRef, u = a.onVisibleChange, d = a.autoFocus, p = a.overlayRef, v = reactExports.useRef(!1), A = function() {
    if (s) {
      var y, f;
      (y = c.current) === null || y === void 0 || (f = y.focus) === null || f === void 0 || f.call(y), u?.(!1);
    }
  }, x = function() {
    var y;
    return (y = p.current) !== null && y !== void 0 && y.focus ? (p.current.focus(), v.current = !0, !0) : !1;
  }, g = function(y) {
    switch (y.keyCode) {
      case ESC$1:
        A();
        break;
      case TAB: {
        var f = !1;
        v.current || (f = x()), f ? y.preventDefault() : A();
        break;
      }
    }
  };
  reactExports.useEffect(function() {
    return s ? (window.addEventListener("keydown", g), d && wrapperRaf(x, 3), function() {
      window.removeEventListener("keydown", g), v.current = !1;
    }) : function() {
      v.current = !1;
    };
  }, [s]);
}
var Overlay$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.overlay, u = a.arrow, d = a.prefixCls, p = reactExports.useMemo(function() {
    var A;
    return typeof c == "function" ? A = c() : A = c, A;
  }, [c]), v = composeRef(s, getNodeRef(p));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, u && /* @__PURE__ */ React.createElement("div", {
    className: "".concat(d, "-arrow")
  }), /* @__PURE__ */ React.cloneElement(p, {
    ref: supportRef(p) ? v : void 0
  }));
}), autoAdjustOverflow$1 = {
  adjustX: 1,
  adjustY: 1
}, targetOffset = [0, 0], placements$2 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  }
}, _excluded$I = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function Dropdown$2(a, s) {
  var c, u = a.arrow, d = u === void 0 ? !1 : u, p = a.prefixCls, v = p === void 0 ? "rc-dropdown" : p, A = a.transitionName, x = a.animation, g = a.align, b = a.placement, y = b === void 0 ? "bottomLeft" : b, f = a.placements, m = f === void 0 ? placements$2 : f, C = a.getPopupContainer, w = a.showAction, S = a.hideAction, $ = a.overlayClassName, T = a.overlayStyle, I = a.visible, _ = a.trigger, E = _ === void 0 ? ["hover"] : _, R = a.autoFocus, O = a.overlay, L = a.children, B = a.onVisibleChange, F = _objectWithoutProperties$2(a, _excluded$I), M = React.useState(), W = _slicedToArray$e(M, 2), j = W[0], G = W[1], U = "visible" in a ? I : j, k = React.useRef(null), N = React.useRef(null), P = React.useRef(null);
  React.useImperativeHandle(s, function() {
    return k.current;
  });
  var D = function(Q) {
    G(Q), B?.(Q);
  };
  useAccessibility$1({
    visible: U,
    triggerRef: P,
    onVisibleChange: D,
    autoFocus: R,
    overlayRef: N
  });
  var H = function(Q) {
    var J = a.onOverlayClick;
    G(!1), J && J(Q);
  }, V = function() {
    return /* @__PURE__ */ React.createElement(Overlay$1, {
      ref: N,
      overlay: O,
      prefixCls: v,
      arrow: d
    });
  }, Z = function() {
    return typeof O == "function" ? V : V();
  }, ne = function() {
    var Q = a.minOverlayWidthMatchTrigger, J = a.alignPoint;
    return "minOverlayWidthMatchTrigger" in a ? Q : !J;
  }, K = function() {
    var Q = a.openClassName;
    return Q !== void 0 ? Q : "".concat(v, "-open");
  }, q = /* @__PURE__ */ React.cloneElement(L, {
    className: classnames((c = L.props) === null || c === void 0 ? void 0 : c.className, U && K()),
    ref: supportRef(L) ? composeRef(P, getNodeRef(L)) : void 0
  }), Y = S;
  return !Y && E.indexOf("contextMenu") !== -1 && (Y = ["click"]), /* @__PURE__ */ React.createElement(Trigger$1, _extends$3({
    builtinPlacements: m
  }, F, {
    prefixCls: v,
    ref: k,
    popupClassName: classnames($, _defineProperty$a({}, "".concat(v, "-show-arrow"), d)),
    popupStyle: T,
    action: E,
    showAction: w,
    hideAction: Y,
    popupPlacement: y,
    popupAlign: g,
    popupTransitionName: A,
    popupAnimation: x,
    popupVisible: U,
    stretch: ne() ? "minWidth" : "",
    popup: Z(),
    onPopupVisibleChange: D,
    onPopupClick: H,
    getPopupContainer: C
  }), q);
}
const Dropdown$3 = /* @__PURE__ */ React.forwardRef(Dropdown$2), isPrimitive = (a) => typeof a != "object" && typeof a != "function" || a === null;
var IdContext = /* @__PURE__ */ reactExports.createContext(null);
function getMenuId(a, s) {
  return a === void 0 ? null : "".concat(a, "-").concat(s);
}
function useMenuId(a) {
  var s = reactExports.useContext(IdContext);
  return getMenuId(s, a);
}
var _excluded$H = ["children", "locked"], MenuContext$1 = /* @__PURE__ */ reactExports.createContext(null);
function mergeProps(a, s) {
  var c = _objectSpread2$1({}, a);
  return Object.keys(s).forEach(function(u) {
    var d = s[u];
    d !== void 0 && (c[u] = d);
  }), c;
}
function InheritableContextProvider(a) {
  var s = a.children, c = a.locked, u = _objectWithoutProperties$2(a, _excluded$H), d = reactExports.useContext(MenuContext$1), p = useMemo(function() {
    return mergeProps(d, u);
  }, [d, u], function(v, A) {
    return !c && (v[0] !== A[0] || !isEqual(v[1], A[1], !0));
  });
  return /* @__PURE__ */ reactExports.createElement(MenuContext$1.Provider, {
    value: p
  }, s);
}
var EmptyList = [], PathRegisterContext = /* @__PURE__ */ reactExports.createContext(null);
function useMeasure() {
  return reactExports.useContext(PathRegisterContext);
}
var PathTrackerContext = /* @__PURE__ */ reactExports.createContext(EmptyList);
function useFullPath(a) {
  var s = reactExports.useContext(PathTrackerContext);
  return reactExports.useMemo(function() {
    return a !== void 0 ? [].concat(_toConsumableArray$e(s), [a]) : s;
  }, [s, a]);
}
var PathUserContext = /* @__PURE__ */ reactExports.createContext(null), PrivateContext = /* @__PURE__ */ reactExports.createContext({});
function focusable(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (isVisible(a)) {
    var c = a.nodeName.toLowerCase(), u = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(c) || // Editable element
      a.isContentEditable || // Anchor with href element
      c === "a" && !!a.getAttribute("href")
    ), d = a.getAttribute("tabindex"), p = Number(d), v = null;
    return d && !Number.isNaN(p) ? v = p : u && v === null && (v = 0), u && a.disabled && (v = null), v !== null && (v >= 0 || s && v < 0);
  }
  return !1;
}
function getFocusNodeList(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = _toConsumableArray$e(a.querySelectorAll("*")).filter(function(u) {
    return focusable(u, s);
  });
  return focusable(a, s) && c.unshift(a), c;
}
var LEFT$1 = KeyCode.LEFT, RIGHT = KeyCode.RIGHT, UP = KeyCode.UP, DOWN = KeyCode.DOWN, ENTER = KeyCode.ENTER, ESC = KeyCode.ESC, HOME = KeyCode.HOME, END = KeyCode.END, ArrowKeys = [UP, DOWN, LEFT$1, RIGHT];
function getOffset$4(a, s, c, u) {
  var d, p = "prev", v = "next", A = "children", x = "parent";
  if (a === "inline" && u === ENTER)
    return {
      inlineTrigger: !0
    };
  var g = _defineProperty$a(_defineProperty$a({}, UP, p), DOWN, v), b = _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, LEFT$1, c ? v : p), RIGHT, c ? p : v), DOWN, A), ENTER, A), y = _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, UP, p), DOWN, v), ENTER, A), ESC, x), LEFT$1, c ? A : x), RIGHT, c ? x : A), f = {
    inline: g,
    horizontal: b,
    vertical: y,
    inlineSub: g,
    horizontalSub: y,
    verticalSub: y
  }, m = (d = f["".concat(a).concat(s ? "" : "Sub")]) === null || d === void 0 ? void 0 : d[u];
  switch (m) {
    case p:
      return {
        offset: -1,
        sibling: !0
      };
    case v:
      return {
        offset: 1,
        sibling: !0
      };
    case x:
      return {
        offset: -1,
        sibling: !1
      };
    case A:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function findContainerUL(a) {
  for (var s = a; s; ) {
    if (s.getAttribute("data-menu-list"))
      return s;
    s = s.parentElement;
  }
  return null;
}
function getFocusElement(a, s) {
  for (var c = a || document.activeElement; c; ) {
    if (s.has(c))
      return c;
    c = c.parentElement;
  }
  return null;
}
function getFocusableElements(a, s) {
  var c = getFocusNodeList(a, !0);
  return c.filter(function(u) {
    return s.has(u);
  });
}
function getNextFocusElement(a, s, c) {
  var u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!a)
    return null;
  var d = getFocusableElements(a, s), p = d.length, v = d.findIndex(function(A) {
    return c === A;
  });
  return u < 0 ? v === -1 ? v = p - 1 : v -= 1 : u > 0 && (v += 1), v = (v + p) % p, d[v];
}
var refreshElements = function a(s, c) {
  var u = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map();
  return s.forEach(function(v) {
    var A = document.querySelector("[data-menu-id='".concat(getMenuId(c, v), "']"));
    A && (u.add(A), p.set(A, v), d.set(v, A));
  }), {
    elements: u,
    key2element: d,
    element2key: p
  };
};
function useAccessibility(a, s, c, u, d, p, v, A, x, g) {
  var b = reactExports.useRef(), y = reactExports.useRef();
  y.current = s;
  var f = function() {
    wrapperRaf.cancel(b.current);
  };
  return reactExports.useEffect(function() {
    return function() {
      f();
    };
  }, []), function(m) {
    var C = m.which;
    if ([].concat(ArrowKeys, [ENTER, ESC, HOME, END]).includes(C)) {
      var w = p(), S = refreshElements(w, u), $ = S, T = $.elements, I = $.key2element, _ = $.element2key, E = I.get(s), R = getFocusElement(E, T), O = _.get(R), L = getOffset$4(a, v(O, !0).length === 1, c, C);
      if (!L && C !== HOME && C !== END)
        return;
      (ArrowKeys.includes(C) || [HOME, END].includes(C)) && m.preventDefault();
      var B = function(N) {
        if (N) {
          var P = N, D = N.querySelector("a");
          D != null && D.getAttribute("href") && (P = D);
          var H = _.get(N);
          A(H), f(), b.current = wrapperRaf(function() {
            y.current === H && P.focus();
          });
        }
      };
      if ([HOME, END].includes(C) || L.sibling || !R) {
        var F;
        !R || a === "inline" ? F = d.current : F = findContainerUL(R);
        var M, W = getFocusableElements(F, T);
        C === HOME ? M = W[0] : C === END ? M = W[W.length - 1] : M = getNextFocusElement(F, T, R, L.offset), B(M);
      } else if (L.inlineTrigger)
        x(O);
      else if (L.offset > 0)
        x(O, !0), f(), b.current = wrapperRaf(function() {
          S = refreshElements(w, u);
          var k = R.getAttribute("aria-controls"), N = document.getElementById(k), P = getNextFocusElement(N, S.elements);
          B(P);
        }, 5);
      else if (L.offset < 0) {
        var j = v(O, !0), G = j[j.length - 2], U = I.get(G);
        x(G, !1), B(U);
      }
    }
    g?.(m);
  };
}
function nextSlice(a) {
  Promise.resolve().then(a);
}
var PATH_SPLIT = "__RC_UTIL_PATH_SPLIT__", getPathStr = function a(s) {
  return s.join(PATH_SPLIT);
}, getPathKeys = function a(s) {
  return s.split(PATH_SPLIT);
}, OVERFLOW_KEY = "rc-menu-more";
function useKeyRecords() {
  var a = reactExports.useState({}), s = _slicedToArray$e(a, 2), c = s[1], u = reactExports.useRef(/* @__PURE__ */ new Map()), d = reactExports.useRef(/* @__PURE__ */ new Map()), p = reactExports.useState([]), v = _slicedToArray$e(p, 2), A = v[0], x = v[1], g = reactExports.useRef(0), b = reactExports.useRef(!1), y = function() {
    b.current || c({});
  }, f = reactExports.useCallback(function(I, _) {
    var E = getPathStr(_);
    d.current.set(E, I), u.current.set(I, E), g.current += 1;
    var R = g.current;
    nextSlice(function() {
      R === g.current && y();
    });
  }, []), m = reactExports.useCallback(function(I, _) {
    var E = getPathStr(_);
    d.current.delete(E), u.current.delete(I);
  }, []), C = reactExports.useCallback(function(I) {
    x(I);
  }, []), w = reactExports.useCallback(function(I, _) {
    var E = u.current.get(I) || "", R = getPathKeys(E);
    return _ && A.includes(R[0]) && R.unshift(OVERFLOW_KEY), R;
  }, [A]), S = reactExports.useCallback(function(I, _) {
    return I.filter(function(E) {
      return E !== void 0;
    }).some(function(E) {
      var R = w(E, !0);
      return R.includes(_);
    });
  }, [w]), $ = function() {
    var _ = _toConsumableArray$e(u.current.keys());
    return A.length && _.push(OVERFLOW_KEY), _;
  }, T = reactExports.useCallback(function(I) {
    var _ = "".concat(u.current.get(I)).concat(PATH_SPLIT), E = /* @__PURE__ */ new Set();
    return _toConsumableArray$e(d.current.keys()).forEach(function(R) {
      R.startsWith(_) && E.add(d.current.get(R));
    }), E;
  }, []);
  return reactExports.useEffect(function() {
    return function() {
      b.current = !0;
    };
  }, []), {
    // Register
    registerPath: f,
    unregisterPath: m,
    refreshOverflowKeys: C,
    // Util
    isSubPathKey: S,
    getKeyPath: w,
    getKeys: $,
    getSubPathKeys: T
  };
}
function useMemoCallback(a) {
  var s = reactExports.useRef(a);
  s.current = a;
  var c = reactExports.useCallback(function() {
    for (var u, d = arguments.length, p = new Array(d), v = 0; v < d; v++)
      p[v] = arguments[v];
    return (u = s.current) === null || u === void 0 ? void 0 : u.call.apply(u, [s].concat(p));
  }, []);
  return a ? c : void 0;
}
var uniquePrefix = Math.random().toFixed(5).toString().slice(2), internalId = 0;
function useUUID(a) {
  var s = useMergedState(a, {
    value: a
  }), c = _slicedToArray$e(s, 2), u = c[0], d = c[1];
  return reactExports.useEffect(function() {
    internalId += 1;
    var p = "".concat(uniquePrefix, "-").concat(internalId);
    d("rc-menu-uuid-".concat(p));
  }, []), u;
}
function useActive(a, s, c, u) {
  var d = reactExports.useContext(MenuContext$1), p = d.activeKey, v = d.onActive, A = d.onInactive, x = {
    active: p === a
  };
  return s || (x.onMouseEnter = function(g) {
    c?.({
      key: a,
      domEvent: g
    }), v(a);
  }, x.onMouseLeave = function(g) {
    u?.({
      key: a,
      domEvent: g
    }), A(a);
  }), x;
}
function useDirectionStyle(a) {
  var s = reactExports.useContext(MenuContext$1), c = s.mode, u = s.rtl, d = s.inlineIndent;
  if (c !== "inline")
    return null;
  var p = a;
  return u ? {
    paddingRight: p * d
  } : {
    paddingLeft: p * d
  };
}
function Icon$3(a) {
  var s = a.icon, c = a.props, u = a.children, d;
  return s === null || s === !1 ? null : (typeof s == "function" ? d = /* @__PURE__ */ reactExports.createElement(s, _objectSpread2$1({}, c)) : typeof s != "boolean" && (d = s), d || u || null);
}
var _excluded$G = ["item"];
function warnItemProp(a) {
  var s = a.item, c = _objectWithoutProperties$2(a, _excluded$G);
  return Object.defineProperty(c, "item", {
    get: function() {
      return warningOnce(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), s;
    }
  }), c;
}
var _excluded$F = ["title", "attribute", "elementRef"], _excluded2$a = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], _excluded3 = ["active"], LegacyMenuItem = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c() {
    return _classCallCheck$1(this, c), s.apply(this, arguments);
  }
  return _createClass$1(c, [{
    key: "render",
    value: function() {
      var d = this.props, p = d.title, v = d.attribute, A = d.elementRef, x = _objectWithoutProperties$2(d, _excluded$F), g = omit(x, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return warningOnce(!v, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ reactExports.createElement(ForwardOverflow.Item, _extends$3({}, v, {
        title: typeof p == "string" ? p : void 0
      }, g, {
        ref: A
      }));
    }
  }]), c;
}(reactExports.Component), InternalMenuItem = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.style, u = a.className, d = a.eventKey;
  a.warnKey;
  var p = a.disabled, v = a.itemIcon, A = a.children, x = a.role, g = a.onMouseEnter, b = a.onMouseLeave, y = a.onClick, f = a.onKeyDown, m = a.onFocus, C = _objectWithoutProperties$2(a, _excluded2$a), w = useMenuId(d), S = reactExports.useContext(MenuContext$1), $ = S.prefixCls, T = S.onItemClick, I = S.disabled, _ = S.overflowDisabled, E = S.itemIcon, R = S.selectedKeys, O = S.onActive, L = reactExports.useContext(PrivateContext), B = L._internalRenderMenuItem, F = "".concat($, "-item"), M = reactExports.useRef(), W = reactExports.useRef(), j = I || p, G = useComposeRef(s, W), U = useFullPath(d), k = function(J) {
    return {
      key: d,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: _toConsumableArray$e(U).reverse(),
      item: M.current,
      domEvent: J
    };
  }, N = v || E, P = useActive(d, j, g, b), D = P.active, H = _objectWithoutProperties$2(P, _excluded3), V = R.includes(d), Z = useDirectionStyle(U.length), ne = function(J) {
    if (!j) {
      var te = k(J);
      y?.(warnItemProp(te)), T(te);
    }
  }, K = function(J) {
    if (f?.(J), J.which === KeyCode.ENTER) {
      var te = k(J);
      y?.(warnItemProp(te)), T(te);
    }
  }, q = function(J) {
    O(d), m?.(J);
  }, Y = {};
  a.role === "option" && (Y["aria-selected"] = V);
  var ee = /* @__PURE__ */ reactExports.createElement(LegacyMenuItem, _extends$3({
    ref: M,
    elementRef: G,
    role: x === null ? "none" : x || "menuitem",
    tabIndex: p ? null : -1,
    "data-menu-id": _ && w ? null : w
  }, omit(C, ["extra"]), H, Y, {
    component: "li",
    "aria-disabled": p,
    style: _objectSpread2$1(_objectSpread2$1({}, Z), c),
    className: classnames(F, _defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(F, "-active"), D), "".concat(F, "-selected"), V), "".concat(F, "-disabled"), j), u),
    onClick: ne,
    onKeyDown: K,
    onFocus: q
  }), A, /* @__PURE__ */ reactExports.createElement(Icon$3, {
    props: _objectSpread2$1(_objectSpread2$1({}, a), {}, {
      isSelected: V
    }),
    icon: N
  }));
  return B && (ee = B(ee, a, {
    selected: V
  })), ee;
});
function MenuItem$1(a, s) {
  var c = a.eventKey, u = useMeasure(), d = useFullPath(c);
  return reactExports.useEffect(function() {
    if (u)
      return u.registerPath(c, d), function() {
        u.unregisterPath(c, d);
      };
  }, [d]), u ? null : /* @__PURE__ */ reactExports.createElement(InternalMenuItem, _extends$3({}, a, {
    ref: s
  }));
}
const MenuItem$2 = /* @__PURE__ */ reactExports.forwardRef(MenuItem$1);
var _excluded$E = ["className", "children"], InternalSubMenuList = function a(s, c) {
  var u = s.className, d = s.children, p = _objectWithoutProperties$2(s, _excluded$E), v = reactExports.useContext(MenuContext$1), A = v.prefixCls, x = v.mode, g = v.rtl;
  return /* @__PURE__ */ reactExports.createElement("ul", _extends$3({
    className: classnames(A, g && "".concat(A, "-rtl"), "".concat(A, "-sub"), "".concat(A, "-").concat(x === "inline" ? "inline" : "vertical"), u),
    role: "menu"
  }, p, {
    "data-menu-list": !0,
    ref: c
  }), d);
}, SubMenuList = /* @__PURE__ */ reactExports.forwardRef(InternalSubMenuList);
SubMenuList.displayName = "SubMenuList";
function parseChildren(a, s) {
  return toArray$8(a).map(function(c, u) {
    if (/* @__PURE__ */ reactExports.isValidElement(c)) {
      var d, p, v = c.key, A = (d = (p = c.props) === null || p === void 0 ? void 0 : p.eventKey) !== null && d !== void 0 ? d : v, x = A == null;
      x && (A = "tmp_key-".concat([].concat(_toConsumableArray$e(s), [u]).join("-")));
      var g = {
        key: A,
        eventKey: A
      };
      return /* @__PURE__ */ reactExports.cloneElement(c, g);
    }
    return c;
  });
}
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
}, placements$1 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow
  }
}, placementsRtl = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow
  }
};
function getMotion(a, s, c) {
  if (s)
    return s;
  if (c)
    return c[a] || c.other;
}
var popupPlacementMap = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function PopupTrigger(a) {
  var s = a.prefixCls, c = a.visible, u = a.children, d = a.popup, p = a.popupStyle, v = a.popupClassName, A = a.popupOffset, x = a.disabled, g = a.mode, b = a.onVisibleChange, y = reactExports.useContext(MenuContext$1), f = y.getPopupContainer, m = y.rtl, C = y.subMenuOpenDelay, w = y.subMenuCloseDelay, S = y.builtinPlacements, $ = y.triggerSubMenuAction, T = y.forceSubMenuRender, I = y.rootClassName, _ = y.motion, E = y.defaultMotions, R = reactExports.useState(!1), O = _slicedToArray$e(R, 2), L = O[0], B = O[1], F = _objectSpread2$1(m ? _objectSpread2$1({}, placementsRtl) : _objectSpread2$1({}, placements$1), S), M = popupPlacementMap[g], W = getMotion(g, _, E), j = reactExports.useRef(W);
  g !== "inline" && (j.current = W);
  var G = _objectSpread2$1(_objectSpread2$1({}, j.current), {}, {
    leavedClassName: "".concat(s, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), U = reactExports.useRef();
  return reactExports.useEffect(function() {
    return U.current = wrapperRaf(function() {
      B(c);
    }), function() {
      wrapperRaf.cancel(U.current);
    };
  }, [c]), /* @__PURE__ */ reactExports.createElement(Trigger$1, {
    prefixCls: s,
    popupClassName: classnames("".concat(s, "-popup"), _defineProperty$a({}, "".concat(s, "-rtl"), m), v, I),
    stretch: g === "horizontal" ? "minWidth" : null,
    getPopupContainer: f,
    builtinPlacements: F,
    popupPlacement: M,
    popupVisible: L,
    popup: d,
    popupStyle: p,
    popupAlign: A && {
      offset: A
    },
    action: x ? [] : [$],
    mouseEnterDelay: C,
    mouseLeaveDelay: w,
    onPopupVisibleChange: b,
    forceRender: T,
    popupMotion: G,
    fresh: !0
  }, u);
}
function InlineSubMenuList(a) {
  var s = a.id, c = a.open, u = a.keyPath, d = a.children, p = "inline", v = reactExports.useContext(MenuContext$1), A = v.prefixCls, x = v.forceSubMenuRender, g = v.motion, b = v.defaultMotions, y = v.mode, f = reactExports.useRef(!1);
  f.current = y === p;
  var m = reactExports.useState(!f.current), C = _slicedToArray$e(m, 2), w = C[0], S = C[1], $ = f.current ? c : !1;
  reactExports.useEffect(function() {
    f.current && S(!1);
  }, [y]);
  var T = _objectSpread2$1({}, getMotion(p, g, b));
  u.length > 1 && (T.motionAppear = !1);
  var I = T.onVisibleChanged;
  return T.onVisibleChanged = function(_) {
    return !f.current && !_ && S(!0), I?.(_);
  }, w ? null : /* @__PURE__ */ reactExports.createElement(InheritableContextProvider, {
    mode: p,
    locked: !f.current
  }, /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$3({
    visible: $
  }, T, {
    forceRender: x,
    removeOnLeave: !1,
    leavedClassName: "".concat(A, "-hidden")
  }), function(_) {
    var E = _.className, R = _.style;
    return /* @__PURE__ */ reactExports.createElement(SubMenuList, {
      id: s,
      className: E,
      style: R
    }, d);
  }));
}
var _excluded$D = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], _excluded2$9 = ["active"], InternalSubMenu = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.style, u = a.className, d = a.title, p = a.eventKey;
  a.warnKey;
  var v = a.disabled, A = a.internalPopupClose, x = a.children, g = a.itemIcon, b = a.expandIcon, y = a.popupClassName, f = a.popupOffset, m = a.popupStyle, C = a.onClick, w = a.onMouseEnter, S = a.onMouseLeave, $ = a.onTitleClick, T = a.onTitleMouseEnter, I = a.onTitleMouseLeave, _ = _objectWithoutProperties$2(a, _excluded$D), E = useMenuId(p), R = reactExports.useContext(MenuContext$1), O = R.prefixCls, L = R.mode, B = R.openKeys, F = R.disabled, M = R.overflowDisabled, W = R.activeKey, j = R.selectedKeys, G = R.itemIcon, U = R.expandIcon, k = R.onItemClick, N = R.onOpenChange, P = R.onActive, D = reactExports.useContext(PrivateContext), H = D._internalRenderSubMenuItem, V = reactExports.useContext(PathUserContext), Z = V.isSubPathKey, ne = useFullPath(), K = "".concat(O, "-submenu"), q = F || v, Y = reactExports.useRef(), ee = reactExports.useRef(), Q = g ?? G, J = b ?? U, te = B.includes(p), ae = !M && te, se = Z(j, p), ie = useActive(p, q, T, I), fe = ie.active, ge = _objectWithoutProperties$2(ie, _excluded2$9), me = reactExports.useState(!1), pe = _slicedToArray$e(me, 2), be = pe[0], le = pe[1], ve = function(Oe) {
    q || le(Oe);
  }, he = function(Oe) {
    ve(!0), w?.({
      key: p,
      domEvent: Oe
    });
  }, ye = function(Oe) {
    ve(!1), S?.({
      key: p,
      domEvent: Oe
    });
  }, Ce = reactExports.useMemo(function() {
    return fe || (L !== "inline" ? be || Z([W], p) : !1);
  }, [L, fe, W, be, p, Z]), xe = useDirectionStyle(ne.length), we = function(Oe) {
    q || ($?.({
      key: p,
      domEvent: Oe
    }), L === "inline" && N(p, !te));
  }, $e = useMemoCallback(function(Be) {
    C?.(warnItemProp(Be)), k(Be);
  }), Ae = function(Oe) {
    L !== "inline" && N(p, Oe);
  }, ue = function() {
    P(p);
  }, ce = E && "".concat(E, "-popup"), Ee = reactExports.useMemo(function() {
    return /* @__PURE__ */ reactExports.createElement(Icon$3, {
      icon: L !== "horizontal" ? J : void 0,
      props: _objectSpread2$1(_objectSpread2$1({}, a), {}, {
        isOpen: ae,
        // [Legacy] Not sure why need this mark
        isSubMenu: !0
      })
    }, /* @__PURE__ */ reactExports.createElement("i", {
      className: "".concat(K, "-arrow")
    }));
  }, [L, J, a, ae, K]), _e = /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    role: "menuitem",
    style: xe,
    className: "".concat(K, "-title"),
    tabIndex: q ? null : -1,
    ref: Y,
    title: typeof d == "string" ? d : null,
    "data-menu-id": M && E ? null : E,
    "aria-expanded": ae,
    "aria-haspopup": !0,
    "aria-controls": ce,
    "aria-disabled": q,
    onClick: we,
    onFocus: ue
  }, ge), d, Ee), Te = reactExports.useRef(L);
  if (L !== "inline" && ne.length > 1 ? Te.current = "vertical" : Te.current = L, !M) {
    var ke = Te.current;
    _e = /* @__PURE__ */ reactExports.createElement(PopupTrigger, {
      mode: ke,
      prefixCls: K,
      visible: !A && ae && L !== "inline",
      popupClassName: y,
      popupOffset: f,
      popupStyle: m,
      popup: /* @__PURE__ */ reactExports.createElement(
        InheritableContextProvider,
        {
          mode: ke === "horizontal" ? "vertical" : ke
        },
        /* @__PURE__ */ reactExports.createElement(SubMenuList, {
          id: ce,
          ref: ee
        }, x)
      ),
      disabled: q,
      onVisibleChange: Ae
    }, _e);
  }
  var Re = /* @__PURE__ */ reactExports.createElement(ForwardOverflow.Item, _extends$3({
    ref: s,
    role: "none"
  }, _, {
    component: "li",
    style: c,
    className: classnames(K, "".concat(K, "-").concat(L), u, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(K, "-open"), ae), "".concat(K, "-active"), Ce), "".concat(K, "-selected"), se), "".concat(K, "-disabled"), q)),
    onMouseEnter: he,
    onMouseLeave: ye
  }), _e, !M && /* @__PURE__ */ reactExports.createElement(InlineSubMenuList, {
    id: ce,
    open: ae,
    keyPath: ne
  }, x));
  return H && (Re = H(Re, a, {
    selected: se,
    active: Ce,
    open: ae,
    disabled: q
  })), /* @__PURE__ */ reactExports.createElement(InheritableContextProvider, {
    onItemClick: $e,
    mode: L === "horizontal" ? "vertical" : L,
    itemIcon: Q,
    expandIcon: J
  }, Re);
}), SubMenu$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.eventKey, u = a.children, d = useFullPath(c), p = parseChildren(u, d), v = useMeasure();
  reactExports.useEffect(function() {
    if (v)
      return v.registerPath(c, d), function() {
        v.unregisterPath(c, d);
      };
  }, [d]);
  var A;
  return v ? A = p : A = /* @__PURE__ */ reactExports.createElement(InternalSubMenu, _extends$3({
    ref: s
  }, a), p), /* @__PURE__ */ reactExports.createElement(PathTrackerContext.Provider, {
    value: d
  }, A);
});
function Divider$1(a) {
  var s = a.className, c = a.style, u = reactExports.useContext(MenuContext$1), d = u.prefixCls, p = useMeasure();
  return p ? null : /* @__PURE__ */ reactExports.createElement("li", {
    role: "separator",
    className: classnames("".concat(d, "-item-divider"), s),
    style: c
  });
}
var _excluded$C = ["className", "title", "eventKey", "children"], InternalMenuItemGroup = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.className, u = a.title;
  a.eventKey;
  var d = a.children, p = _objectWithoutProperties$2(a, _excluded$C), v = reactExports.useContext(MenuContext$1), A = v.prefixCls, x = "".concat(A, "-item-group");
  return /* @__PURE__ */ reactExports.createElement("li", _extends$3({
    ref: s,
    role: "presentation"
  }, p, {
    onClick: function(b) {
      return b.stopPropagation();
    },
    className: classnames(x, c)
  }), /* @__PURE__ */ reactExports.createElement("div", {
    role: "presentation",
    className: "".concat(x, "-title"),
    title: typeof u == "string" ? u : void 0
  }, u), /* @__PURE__ */ reactExports.createElement("ul", {
    role: "group",
    className: "".concat(x, "-list")
  }, d));
}), MenuItemGroup = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.eventKey, u = a.children, d = useFullPath(c), p = parseChildren(u, d), v = useMeasure();
  return v ? p : /* @__PURE__ */ reactExports.createElement(InternalMenuItemGroup, _extends$3({
    ref: s
  }, omit(a, ["warnKey"])), p);
}), _excluded$B = ["label", "children", "key", "type", "extra"];
function convertItemsToNodes(a, s, c) {
  var u = s.item, d = s.group, p = s.submenu, v = s.divider;
  return (a || []).map(function(A, x) {
    if (A && _typeof$h(A) === "object") {
      var g = A, b = g.label, y = g.children, f = g.key, m = g.type, C = g.extra, w = _objectWithoutProperties$2(g, _excluded$B), S = f ?? "tmp-".concat(x);
      return y || m === "group" ? m === "group" ? /* @__PURE__ */ reactExports.createElement(d, _extends$3({
        key: S
      }, w, {
        title: b
      }), convertItemsToNodes(y, s, c)) : /* @__PURE__ */ reactExports.createElement(p, _extends$3({
        key: S
      }, w, {
        title: b
      }), convertItemsToNodes(y, s, c)) : m === "divider" ? /* @__PURE__ */ reactExports.createElement(v, _extends$3({
        key: S
      }, w)) : /* @__PURE__ */ reactExports.createElement(u, _extends$3({
        key: S
      }, w, {
        extra: C
      }), b, (!!C || C === 0) && /* @__PURE__ */ reactExports.createElement("span", {
        className: "".concat(c, "-item-extra")
      }, C));
    }
    return null;
  }).filter(function(A) {
    return A;
  });
}
function parseItems(a, s, c, u, d) {
  var p = a, v = _objectSpread2$1({
    divider: Divider$1,
    item: MenuItem$2,
    group: MenuItemGroup,
    submenu: SubMenu$1
  }, u);
  return s && (p = convertItemsToNodes(s, v, d)), parseChildren(p, c);
}
var _excluded$A = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"], EMPTY_LIST$4 = [], Menu$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c, u = a, d = u.prefixCls, p = d === void 0 ? "rc-menu" : d, v = u.rootClassName, A = u.style, x = u.className, g = u.tabIndex, b = g === void 0 ? 0 : g, y = u.items, f = u.children, m = u.direction, C = u.id, w = u.mode, S = w === void 0 ? "vertical" : w, $ = u.inlineCollapsed, T = u.disabled, I = u.disabledOverflow, _ = u.subMenuOpenDelay, E = _ === void 0 ? 0.1 : _, R = u.subMenuCloseDelay, O = R === void 0 ? 0.1 : R, L = u.forceSubMenuRender, B = u.defaultOpenKeys, F = u.openKeys, M = u.activeKey, W = u.defaultActiveFirst, j = u.selectable, G = j === void 0 ? !0 : j, U = u.multiple, k = U === void 0 ? !1 : U, N = u.defaultSelectedKeys, P = u.selectedKeys, D = u.onSelect, H = u.onDeselect, V = u.inlineIndent, Z = V === void 0 ? 24 : V, ne = u.motion, K = u.defaultMotions, q = u.triggerSubMenuAction, Y = q === void 0 ? "hover" : q, ee = u.builtinPlacements, Q = u.itemIcon, J = u.expandIcon, te = u.overflowedIndicator, ae = te === void 0 ? "..." : te, se = u.overflowedIndicatorPopupClassName, ie = u.getPopupContainer, fe = u.onClick, ge = u.onOpenChange, me = u.onKeyDown;
  u.openAnimation, u.openTransitionName;
  var pe = u._internalRenderMenuItem, be = u._internalRenderSubMenuItem, le = u._internalComponents, ve = _objectWithoutProperties$2(u, _excluded$A), he = reactExports.useMemo(function() {
    return [parseItems(f, y, EMPTY_LIST$4, le, p), parseItems(f, y, EMPTY_LIST$4, {}, p)];
  }, [f, y, le]), ye = _slicedToArray$e(he, 2), Ce = ye[0], xe = ye[1], we = reactExports.useState(!1), $e = _slicedToArray$e(we, 2), Ae = $e[0], ue = $e[1], ce = reactExports.useRef(), Ee = useUUID(C), _e = m === "rtl", Te = useMergedState(B, {
    value: F,
    postState: function(jt) {
      return jt || EMPTY_LIST$4;
    }
  }), ke = _slicedToArray$e(Te, 2), Re = ke[0], Be = ke[1], Oe = function(jt) {
    var Ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function ur() {
      Be(jt), ge?.(jt);
    }
    Ht ? reactDomExports.flushSync(ur) : ur();
  }, Me = reactExports.useState(Re), Fe = _slicedToArray$e(Me, 2), Ue = Fe[0], je = Fe[1], Le = reactExports.useRef(!1), De = reactExports.useMemo(function() {
    return (S === "inline" || S === "vertical") && $ ? ["vertical", $] : [S, !1];
  }, [S, $]), Ne = _slicedToArray$e(De, 2), Ge = Ne[0], Xe = Ne[1], nt = Ge === "inline", ct = reactExports.useState(Ge), it = _slicedToArray$e(ct, 2), We = it[0], Ve = it[1], ut = reactExports.useState(Xe), at = _slicedToArray$e(ut, 2), Qe = at[0], st = at[1];
  reactExports.useEffect(function() {
    Ve(Ge), st(Xe), Le.current && (nt ? Be(Ue) : Oe(EMPTY_LIST$4));
  }, [Ge, Xe]);
  var ft = reactExports.useState(0), vt = _slicedToArray$e(ft, 2), Pt = vt[0], dt = vt[1], mt = Pt >= Ce.length - 1 || We !== "horizontal" || I;
  reactExports.useEffect(function() {
    nt && je(Re);
  }, [Re]), reactExports.useEffect(function() {
    return Le.current = !0, function() {
      Le.current = !1;
    };
  }, []);
  var pt = useKeyRecords(), Et = pt.registerPath, Mt = pt.unregisterPath, Nt = pt.refreshOverflowKeys, _t = pt.isSubPathKey, Ot = pt.getKeyPath, rt = pt.getKeys, et = pt.getSubPathKeys, Ye = reactExports.useMemo(function() {
    return {
      registerPath: Et,
      unregisterPath: Mt
    };
  }, [Et, Mt]), tt = reactExports.useMemo(function() {
    return {
      isSubPathKey: _t
    };
  }, [_t]);
  reactExports.useEffect(function() {
    Nt(mt ? EMPTY_LIST$4 : Ce.slice(Pt + 1).map(function(Jt) {
      return Jt.key;
    }));
  }, [Pt, mt]);
  var Ke = useMergedState(M || W && ((c = Ce[0]) === null || c === void 0 ? void 0 : c.key), {
    value: M
  }), qe = _slicedToArray$e(Ke, 2), ot = qe[0], Je = qe[1], Ct = useMemoCallback(function(Jt) {
    Je(Jt);
  }), Tt = useMemoCallback(function() {
    Je(void 0);
  });
  reactExports.useImperativeHandle(s, function() {
    return {
      list: ce.current,
      focus: function(jt) {
        var Ht, ur = rt(), Qt = refreshElements(ur, Ee), Yt = Qt.elements, dr = Qt.key2element, Ar = Qt.element2key, wr = getFocusableElements(ce.current, Yt), Ir = ot ?? (wr[0] ? Ar.get(wr[0]) : (Ht = Ce.find(function(zt) {
          return !zt.props.disabled;
        })) === null || Ht === void 0 ? void 0 : Ht.key), _r = dr.get(Ir);
        if (Ir && _r) {
          var kr;
          _r == null || (kr = _r.focus) === null || kr === void 0 || kr.call(_r, jt);
        }
      }
    };
  });
  var yt = useMergedState(N || [], {
    value: P,
    // Legacy convert key to array
    postState: function(jt) {
      return Array.isArray(jt) ? jt : jt == null ? EMPTY_LIST$4 : [jt];
    }
  }), bt = _slicedToArray$e(yt, 2), It = bt[0], kt = bt[1], $t = function(jt) {
    if (G) {
      var Ht = jt.key, ur = It.includes(Ht), Qt;
      k ? ur ? Qt = It.filter(function(dr) {
        return dr !== Ht;
      }) : Qt = [].concat(_toConsumableArray$e(It), [Ht]) : Qt = [Ht], kt(Qt);
      var Yt = _objectSpread2$1(_objectSpread2$1({}, jt), {}, {
        selectedKeys: Qt
      });
      ur ? H?.(Yt) : D?.(Yt);
    }
    !k && Re.length && We !== "inline" && Oe(EMPTY_LIST$4);
  }, Lt = useMemoCallback(function(Jt) {
    fe?.(warnItemProp(Jt)), $t(Jt);
  }), Ft = useMemoCallback(function(Jt, jt) {
    var Ht = Re.filter(function(Qt) {
      return Qt !== Jt;
    });
    if (jt)
      Ht.push(Jt);
    else if (We !== "inline") {
      var ur = et(Jt);
      Ht = Ht.filter(function(Qt) {
        return !ur.has(Qt);
      });
    }
    isEqual(Re, Ht, !0) || Oe(Ht, !0);
  }), Vt = function(jt, Ht) {
    var ur = Ht ?? !Re.includes(jt);
    Ft(jt, ur);
  }, rr = useAccessibility(We, ot, _e, Ee, ce, rt, Ot, Je, Vt, me);
  reactExports.useEffect(function() {
    ue(!0);
  }, []);
  var br = reactExports.useMemo(function() {
    return {
      _internalRenderMenuItem: pe,
      _internalRenderSubMenuItem: be
    };
  }, [pe, be]), Gt = We !== "horizontal" || I ? Ce : (
    // Need wrap for overflow dropdown that do not response for open
    Ce.map(function(Jt, jt) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ reactExports.createElement(InheritableContextProvider, {
          key: Jt.key,
          overflowDisabled: jt > Pt
        }, Jt)
      );
    })
  ), qt = /* @__PURE__ */ reactExports.createElement(ForwardOverflow, _extends$3({
    id: C,
    ref: ce,
    prefixCls: "".concat(p, "-overflow"),
    component: "ul",
    itemComponent: MenuItem$2,
    className: classnames(p, "".concat(p, "-root"), "".concat(p, "-").concat(We), x, _defineProperty$a(_defineProperty$a({}, "".concat(p, "-inline-collapsed"), Qe), "".concat(p, "-rtl"), _e), v),
    dir: m,
    style: A,
    role: "menu",
    tabIndex: b,
    data: Gt,
    renderRawItem: function(jt) {
      return jt;
    },
    renderRawRest: function(jt) {
      var Ht = jt.length, ur = Ht ? Ce.slice(-Ht) : null;
      return /* @__PURE__ */ reactExports.createElement(SubMenu$1, {
        eventKey: OVERFLOW_KEY,
        title: ae,
        disabled: mt,
        internalPopupClose: Ht === 0,
        popupClassName: se
      }, ur);
    },
    maxCount: We !== "horizontal" || I ? ForwardOverflow.INVALIDATE : ForwardOverflow.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(jt) {
      dt(jt);
    },
    onKeyDown: rr
  }, ve));
  return /* @__PURE__ */ reactExports.createElement(PrivateContext.Provider, {
    value: br
  }, /* @__PURE__ */ reactExports.createElement(IdContext.Provider, {
    value: Ee
  }, /* @__PURE__ */ reactExports.createElement(InheritableContextProvider, {
    prefixCls: p,
    rootClassName: v,
    mode: We,
    openKeys: Re,
    rtl: _e,
    disabled: T,
    motion: Ae ? ne : null,
    defaultMotions: Ae ? K : null,
    activeKey: ot,
    onActive: Ct,
    onInactive: Tt,
    selectedKeys: It,
    inlineIndent: Z,
    subMenuOpenDelay: E,
    subMenuCloseDelay: O,
    forceSubMenuRender: L,
    builtinPlacements: ee,
    triggerSubMenuAction: Y,
    getPopupContainer: ie,
    itemIcon: Q,
    expandIcon: J,
    onItemClick: Lt,
    onOpenChange: Ft
  }, /* @__PURE__ */ reactExports.createElement(PathUserContext.Provider, {
    value: tt
  }, qt), /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ reactExports.createElement(PathRegisterContext.Provider, {
    value: Ye
  }, xe)))));
}), ExportMenu = Menu$2;
ExportMenu.Item = MenuItem$2;
ExportMenu.SubMenu = SubMenu$1;
ExportMenu.ItemGroup = MenuItemGroup;
ExportMenu.Divider = Divider$1;
const SiderContext = /* @__PURE__ */ reactExports.createContext({});
var EllipsisOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, EllipsisOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: EllipsisOutlined$1
  }));
}, RefIcon$z = /* @__PURE__ */ reactExports.forwardRef(EllipsisOutlined);
const MenuContext = /* @__PURE__ */ reactExports.createContext({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
});
var __rest$T = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const MenuDivider = (a) => {
  const {
    prefixCls: s,
    className: c,
    dashed: u
  } = a, d = __rest$T(a, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: p
  } = reactExports.useContext(ConfigContext$1), v = p("menu", s), A = classnames({
    [`${v}-item-divider-dashed`]: !!u
  }, c);
  return /* @__PURE__ */ reactExports.createElement(Divider$1, Object.assign({
    className: A
  }, d));
}, MenuItem = (a) => {
  var s;
  const {
    className: c,
    children: u,
    icon: d,
    title: p,
    danger: v,
    extra: A
  } = a, {
    prefixCls: x,
    firstLevel: g,
    direction: b,
    disableMenuItemTitleTooltip: y,
    inlineCollapsed: f
  } = reactExports.useContext(MenuContext), m = (I) => {
    const _ = u?.[0], E = /* @__PURE__ */ reactExports.createElement("span", {
      className: classnames(`${x}-title-content`, {
        [`${x}-title-content-with-extra`]: !!A || A === 0
      })
    }, u);
    return (!d || /* @__PURE__ */ reactExports.isValidElement(u) && u.type === "span") && u && I && g && typeof _ == "string" ? /* @__PURE__ */ reactExports.createElement("div", {
      className: `${x}-inline-collapsed-noicon`
    }, _.charAt(0)) : E;
  }, {
    siderCollapsed: C
  } = reactExports.useContext(SiderContext);
  let w = p;
  typeof p > "u" ? w = g ? u : "" : p === !1 && (w = "");
  const S = {
    title: w
  };
  !C && !f && (S.title = null, S.open = !1);
  const $ = toArray$8(u).length;
  let T = /* @__PURE__ */ reactExports.createElement(MenuItem$2, Object.assign({}, omit(a, ["title", "icon", "danger"]), {
    className: classnames({
      [`${x}-item-danger`]: v,
      [`${x}-item-only-child`]: (d ? $ + 1 : $) === 1
    }, c),
    title: typeof p == "string" ? p : void 0
  }), cloneElement(d, {
    className: classnames(/* @__PURE__ */ reactExports.isValidElement(d) ? (s = d.props) === null || s === void 0 ? void 0 : s.className : void 0, `${x}-item-icon`)
  }), m(f));
  return y || (T = /* @__PURE__ */ reactExports.createElement(Tooltip, Object.assign({}, S, {
    placement: b === "rtl" ? "left" : "right",
    classNames: {
      root: `${x}-inline-collapsed-tooltip`
    }
  }), T)), T;
};
var __rest$S = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const OverrideContext = /* @__PURE__ */ reactExports.createContext(null), OverrideProvider = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    children: c
  } = a, u = __rest$S(a, ["children"]), d = reactExports.useContext(OverrideContext), p = reactExports.useMemo(() => Object.assign(Object.assign({}, d), u), [
    d,
    u.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    u.mode,
    u.selectable,
    u.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]), v = supportNodeRef(c), A = useComposeRef(s, v ? getNodeRef(c) : null);
  return /* @__PURE__ */ reactExports.createElement(OverrideContext.Provider, {
    value: p
  }, /* @__PURE__ */ reactExports.createElement(ContextIsolator, {
    space: !0
  }, v ? /* @__PURE__ */ reactExports.cloneElement(c, {
    ref: A
  }) : c));
}), getHorizontalStyle = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: c,
    horizontalLineHeight: u,
    colorSplit: d,
    lineWidth: p,
    lineType: v,
    itemPaddingInline: A
  } = a;
  return {
    [`${s}-horizontal`]: {
      lineHeight: u,
      border: 0,
      borderBottom: `${unit$1(p)} ${v} ${d}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${s}-item, ${s}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: A
      },
      [`> ${s}-item:hover,
        > ${s}-item-active,
        > ${s}-submenu ${s}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${s}-item, ${s}-submenu-title`]: {
        transition: [`border-color ${c}`, `background ${c}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${s}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, getRTLStyle = ({
  componentCls: a,
  menuArrowOffset: s,
  calc: c
}) => ({
  [`${a}-rtl`]: {
    direction: "rtl"
  },
  [`${a}-submenu-rtl`]: {
    transformOrigin: "100% 0"
  },
  // Vertical Arrow
  [`${a}-rtl${a}-vertical,
    ${a}-submenu-rtl ${a}-vertical`]: {
    [`${a}-submenu-arrow`]: {
      "&::before": {
        transform: `rotate(-45deg) translateY(${unit$1(c(s).mul(-1).equal())})`
      },
      "&::after": {
        transform: `rotate(45deg) translateY(${unit$1(s)})`
      }
    }
  }
}), accessibilityFocus = (a) => Object.assign({}, genFocusOutline(a)), getThemeStyle = (a, s) => {
  const {
    componentCls: c,
    itemColor: u,
    itemSelectedColor: d,
    subMenuItemSelectedColor: p,
    groupTitleColor: v,
    itemBg: A,
    subMenuItemBg: x,
    itemSelectedBg: g,
    activeBarHeight: b,
    activeBarWidth: y,
    activeBarBorderWidth: f,
    motionDurationSlow: m,
    motionEaseInOut: C,
    motionEaseOut: w,
    itemPaddingInline: S,
    motionDurationMid: $,
    itemHoverColor: T,
    lineType: I,
    colorSplit: _,
    // Disabled
    itemDisabledColor: E,
    // Danger
    dangerItemColor: R,
    dangerItemHoverColor: O,
    dangerItemSelectedColor: L,
    dangerItemActiveBg: B,
    dangerItemSelectedBg: F,
    // Bg
    popupBg: M,
    itemHoverBg: W,
    itemActiveBg: j,
    menuSubMenuBg: G,
    // Horizontal
    horizontalItemSelectedColor: U,
    horizontalItemSelectedBg: k,
    horizontalItemBorderRadius: N,
    horizontalItemHoverBg: P
  } = a;
  return {
    [`${c}-${s}, ${c}-${s} > ${c}`]: {
      color: u,
      background: A,
      [`&${c}-root:focus-visible`]: Object.assign({}, accessibilityFocus(a)),
      // ======================== Item ========================
      [`${c}-item`]: {
        "&-group-title, &-extra": {
          color: v
        }
      },
      [`${c}-submenu-selected > ${c}-submenu-title`]: {
        color: p
      },
      [`${c}-item, ${c}-submenu-title`]: {
        color: u,
        [`&:not(${c}-item-disabled):focus-visible`]: Object.assign({}, accessibilityFocus(a))
      },
      // Disabled
      [`${c}-item-disabled, ${c}-submenu-disabled`]: {
        color: `${E} !important`
      },
      // Hover
      [`${c}-item:not(${c}-item-selected):not(${c}-submenu-selected)`]: {
        [`&:hover, > ${c}-submenu-title:hover`]: {
          color: T
        }
      },
      [`&:not(${c}-horizontal)`]: {
        [`${c}-item:not(${c}-item-selected)`]: {
          "&:hover": {
            backgroundColor: W
          },
          "&:active": {
            backgroundColor: j
          }
        },
        [`${c}-submenu-title`]: {
          "&:hover": {
            backgroundColor: W
          },
          "&:active": {
            backgroundColor: j
          }
        }
      },
      // Danger - only Item has
      [`${c}-item-danger`]: {
        color: R,
        [`&${c}-item:hover`]: {
          [`&:not(${c}-item-selected):not(${c}-submenu-selected)`]: {
            color: O
          }
        },
        [`&${c}-item:active`]: {
          background: B
        }
      },
      [`${c}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${c}-item-selected`]: {
        color: d,
        // Danger
        [`&${c}-item-danger`]: {
          color: L
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${c}-item-selected`]: {
        backgroundColor: g,
        // Danger
        [`&${c}-item-danger`]: {
          backgroundColor: F
        }
      },
      [`&${c}-submenu > ${c}`]: {
        backgroundColor: G
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${c}-popup > ${c}`]: {
        backgroundColor: M
      },
      [`&${c}-submenu-popup > ${c}`]: {
        backgroundColor: M
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${c}-horizontal`]: Object.assign(Object.assign({}, s === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${c}-item, > ${c}-submenu`]: {
          top: f,
          marginTop: a.calc(f).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: N,
          "&::after": {
            position: "absolute",
            insetInline: S,
            bottom: 0,
            borderBottom: `${unit$1(b)} solid transparent`,
            transition: `border-color ${m} ${C}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: P,
            "&::after": {
              borderBottomWidth: b,
              borderBottomColor: U
            }
          },
          "&-selected": {
            color: U,
            backgroundColor: k,
            "&:hover": {
              backgroundColor: k
            },
            "&::after": {
              borderBottomWidth: b,
              borderBottomColor: U
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${c}-root`]: {
        [`&${c}-inline, &${c}-vertical`]: {
          borderInlineEnd: `${unit$1(f)} ${I} ${_}`
        }
      },
      // ======================== Inline ========================
      [`&${c}-inline`]: {
        // Sub
        [`${c}-sub${c}-inline`]: {
          background: x
        },
        [`${c}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${unit$1(y)} solid ${d}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${$} ${w}`, `opacity ${$} ${w}`].join(","),
            content: '""'
          },
          // Danger
          [`&${c}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: L
            }
          }
        },
        [`${c}-selected, ${c}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${$} ${C}`, `opacity ${$} ${C}`].join(",")
          }
        }
      }
    }
  };
}, getVerticalInlineStyle = (a) => {
  const {
    componentCls: s,
    itemHeight: c,
    itemMarginInline: u,
    padding: d,
    menuArrowSize: p,
    marginXS: v,
    itemMarginBlock: A,
    itemWidth: x,
    itemPaddingInline: g
  } = a, b = a.calc(p).add(d).add(v).equal();
  return {
    [`${s}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${s}-item, ${s}-submenu-title`]: {
      height: c,
      lineHeight: unit$1(c),
      paddingInline: g,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: u,
      marginBlock: A,
      width: x
    },
    [`> ${s}-item,
            > ${s}-submenu > ${s}-submenu-title`]: {
      height: c,
      lineHeight: unit$1(c)
    },
    [`${s}-item-group-list ${s}-submenu-title,
            ${s}-submenu-title`]: {
      paddingInlineEnd: b
    }
  };
}, getVerticalStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    itemHeight: u,
    colorTextLightSolid: d,
    dropdownWidth: p,
    controlHeightLG: v,
    motionEaseOut: A,
    paddingXL: x,
    itemMarginInline: g,
    fontSizeLG: b,
    motionDurationFast: y,
    motionDurationSlow: f,
    paddingXS: m,
    boxShadowSecondary: C,
    collapsedWidth: w,
    collapsedIconSize: S
  } = a, $ = {
    height: u,
    lineHeight: unit$1(u),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [s]: {
        "&-inline, &-vertical": Object.assign({
          [`&${s}-root`]: {
            boxShadow: "none"
          }
        }, getVerticalInlineStyle(a))
      },
      [`${s}-submenu-popup`]: {
        [`${s}-vertical`]: Object.assign(Object.assign({}, getVerticalInlineStyle(a)), {
          boxShadow: C
        })
      }
    },
    // Vertical only
    {
      [`${s}-submenu-popup ${s}-vertical${s}-sub`]: {
        minWidth: p,
        maxHeight: `calc(100vh - ${unit$1(a.calc(v).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${s}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${s}-root`]: {
          [`${s}-item, ${s}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${f}`, `background ${f}`, `padding ${y} ${A}`].join(","),
            [`> ${s}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${s}-sub${s}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${s}-submenu > ${s}-submenu-title`]: $,
          [`& ${s}-item-group-title`]: {
            paddingInlineStart: x
          }
        },
        // >>>>> Item
        [`${s}-item`]: $
      }
    },
    // Inline Collapse Only
    {
      [`${s}-inline-collapsed`]: {
        width: w,
        [`&${s}-root`]: {
          [`${s}-item, ${s}-submenu ${s}-submenu-title`]: {
            [`> ${s}-inline-collapsed-noicon`]: {
              fontSize: b,
              textAlign: "center"
            }
          }
        },
        [`> ${s}-item,
          > ${s}-item-group > ${s}-item-group-list > ${s}-item,
          > ${s}-item-group > ${s}-item-group-list > ${s}-submenu > ${s}-submenu-title,
          > ${s}-submenu > ${s}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${unit$1(a.calc(S).div(2).equal())} - ${unit$1(g)})`,
          textOverflow: "clip",
          [`
            ${s}-submenu-arrow,
            ${s}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${s}-item-icon, ${c}`]: {
            margin: 0,
            fontSize: S,
            lineHeight: unit$1(u),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${s}-item-icon, ${c}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${s}-item-icon, ${c}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: d
          }
        },
        [`${s}-item-group-title`]: Object.assign(Object.assign({}, textEllipsis), {
          paddingInline: m
        })
      }
    }
  ];
}, genMenuItemStyle = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: c,
    motionDurationMid: u,
    motionEaseInOut: d,
    motionEaseOut: p,
    iconCls: v,
    iconSize: A,
    iconMarginInlineEnd: x
  } = a;
  return {
    // >>>>> Item
    [`${s}-item, ${s}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${c}`, `background ${c}`, `padding calc(${c} + 0.1s) ${d}`].join(","),
      [`${s}-item-icon, ${v}`]: {
        minWidth: A,
        fontSize: A,
        transition: [`font-size ${u} ${p}`, `margin ${c} ${d}`, `color ${c}`].join(","),
        "+ span": {
          marginInlineStart: x,
          opacity: 1,
          transition: [`opacity ${c} ${d}`, `margin ${c}`, `color ${c}`].join(",")
        }
      },
      [`${s}-item-icon`]: Object.assign({}, resetIcon()),
      [`&${s}-item-only-child`]: {
        [`> ${v}, > ${s}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${s}-item-disabled, ${s}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important",
        cursor: "not-allowed",
        pointerEvents: "none"
      },
      [`> ${s}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, genSubMenuArrowStyle = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: c,
    motionEaseInOut: u,
    borderRadius: d,
    menuArrowSize: p,
    menuArrowOffset: v
  } = a;
  return {
    [`${s}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: a.margin,
        width: p,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${c} ${u}, opacity ${c}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: a.calc(p).mul(0.6).equal(),
          height: a.calc(p).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: d,
          transition: [`background ${c} ${u}`, `transform ${c} ${u}`, `top ${c} ${u}`, `color ${c} ${u}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${unit$1(a.calc(v).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${unit$1(v)})`
        }
      }
    }
  };
}, getBaseStyle = (a) => {
  const {
    antCls: s,
    componentCls: c,
    fontSize: u,
    motionDurationSlow: d,
    motionDurationMid: p,
    motionEaseInOut: v,
    paddingXS: A,
    padding: x,
    colorSplit: g,
    lineWidth: b,
    zIndexPopup: y,
    borderRadiusLG: f,
    subMenuItemBorderRadius: m,
    menuArrowSize: C,
    menuArrowOffset: w,
    lineType: S,
    groupTitleLineHeight: $,
    groupTitleFontSize: T
  } = a;
  return [
    // Misc
    {
      "": {
        [c]: Object.assign(Object.assign({}, clearFix()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${c}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [c]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), clearFix()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: u,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${d} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${c}-item`]: {
            flex: "none"
          }
        },
        [`${c}-item, ${c}-submenu, ${c}-submenu-title`]: {
          borderRadius: a.itemBorderRadius
        },
        [`${c}-item-group-title`]: {
          padding: `${unit$1(A)} ${unit$1(x)}`,
          fontSize: T,
          lineHeight: $,
          transition: `all ${d}`
        },
        [`&-horizontal ${c}-submenu`]: {
          transition: [`border-color ${d} ${v}`, `background ${d} ${v}`].join(",")
        },
        [`${c}-submenu, ${c}-submenu-inline`]: {
          transition: [`border-color ${d} ${v}`, `background ${d} ${v}`, `padding ${p} ${v}`].join(",")
        },
        [`${c}-submenu ${c}-sub`]: {
          cursor: "initial",
          transition: [`background ${d} ${v}`, `padding ${d} ${v}`].join(",")
        },
        [`${c}-title-content`]: {
          transition: `color ${d}`,
          "&-with-extra": {
            display: "inline-flex",
            alignItems: "center",
            width: "100%"
          },
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${s}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          },
          [`${c}-item-extra`]: {
            marginInlineStart: "auto",
            paddingInlineStart: a.padding
          }
        },
        [`${c}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${c}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: g,
          borderStyle: S,
          borderWidth: 0,
          borderTopWidth: b,
          marginBlock: b,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), genMenuItemStyle(a)), {
        [`${c}-item-group`]: {
          [`${c}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${c}-item, ${c}-submenu-title`]: {
              paddingInline: `${unit$1(a.calc(u).mul(2).equal())} ${unit$1(x)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: y,
            borderRadius: f,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${c}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            },
            [`> ${c}`]: Object.assign(Object.assign(Object.assign({
              borderRadius: f
            }, genMenuItemStyle(a)), genSubMenuArrowStyle(a)), {
              [`${c}-item, ${c}-submenu > ${c}-submenu-title`]: {
                borderRadius: m
              },
              [`${c}-submenu-title::after`]: {
                transition: `transform ${d} ${v}`
              }
            })
          },
          "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ": {
            transformOrigin: "100% 0"
          },
          "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ": {
            transformOrigin: "100% 100%"
          },
          "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ": {
            transformOrigin: "0 100%"
          },
          "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ": {
            transformOrigin: "0 0"
          },
          "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ": {
            paddingInlineEnd: a.paddingXS
          },
          "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ": {
            paddingInlineStart: a.paddingXS
          },
          "\n          &-placement-topRight,\n          &-placement-topLeft\n          ": {
            paddingBottom: a.paddingXS
          },
          "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ": {
            paddingTop: a.paddingXS
          }
        }
      }), genSubMenuArrowStyle(a)), {
        [`&-inline-collapsed ${c}-submenu-arrow,
        &-inline ${c}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${unit$1(w)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${unit$1(a.calc(w).mul(-1).equal())})`
          }
        },
        [`${c}-submenu-open${c}-submenu-inline > ${c}-submenu-title > ${c}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${unit$1(a.calc(C).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${unit$1(a.calc(w).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${unit$1(w)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${s}-layout-header`]: {
        [c]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, prepareComponentToken$m = (a) => {
  var s, c, u;
  const {
    colorPrimary: d,
    colorError: p,
    colorTextDisabled: v,
    colorErrorBg: A,
    colorText: x,
    colorTextDescription: g,
    colorBgContainer: b,
    colorFillAlter: y,
    colorFillContent: f,
    lineWidth: m,
    lineWidthBold: C,
    controlItemBgActive: w,
    colorBgTextHover: S,
    controlHeightLG: $,
    lineHeight: T,
    colorBgElevated: I,
    marginXXS: _,
    padding: E,
    fontSize: R,
    controlHeightSM: O,
    fontSizeLG: L,
    colorTextLightSolid: B,
    colorErrorHover: F
  } = a, M = (s = a.activeBarWidth) !== null && s !== void 0 ? s : 0, W = (c = a.activeBarBorderWidth) !== null && c !== void 0 ? c : m, j = (u = a.itemMarginInline) !== null && u !== void 0 ? u : a.marginXXS, G = new FastColor(B).setA(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: a.zIndexPopupBase + 50,
    radiusItem: a.borderRadiusLG,
    itemBorderRadius: a.borderRadiusLG,
    radiusSubMenuItem: a.borderRadiusSM,
    subMenuItemBorderRadius: a.borderRadiusSM,
    colorItemText: x,
    itemColor: x,
    colorItemTextHover: x,
    itemHoverColor: x,
    colorItemTextHoverHorizontal: d,
    horizontalItemHoverColor: d,
    colorGroupTitle: g,
    groupTitleColor: g,
    colorItemTextSelected: d,
    itemSelectedColor: d,
    subMenuItemSelectedColor: d,
    colorItemTextSelectedHorizontal: d,
    horizontalItemSelectedColor: d,
    colorItemBg: b,
    itemBg: b,
    colorItemBgHover: S,
    itemHoverBg: S,
    colorItemBgActive: f,
    itemActiveBg: w,
    colorSubItemBg: y,
    subMenuItemBg: y,
    colorItemBgSelected: w,
    itemSelectedBg: w,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: M,
    colorActiveBarHeight: C,
    activeBarHeight: C,
    colorActiveBarBorderSize: m,
    activeBarBorderWidth: W,
    // Disabled
    colorItemTextDisabled: v,
    itemDisabledColor: v,
    // Danger
    colorDangerItemText: p,
    dangerItemColor: p,
    colorDangerItemTextHover: p,
    dangerItemHoverColor: p,
    colorDangerItemTextSelected: p,
    dangerItemSelectedColor: p,
    colorDangerItemBgActive: A,
    dangerItemActiveBg: A,
    colorDangerItemBgSelected: A,
    dangerItemSelectedBg: A,
    itemMarginInline: j,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: $,
    groupTitleLineHeight: T,
    collapsedWidth: $ * 2,
    popupBg: I,
    itemMarginBlock: _,
    itemPaddingInline: E,
    horizontalLineHeight: `${$ * 1.15}px`,
    iconSize: R,
    iconMarginInlineEnd: O - R,
    collapsedIconSize: L,
    groupTitleFontSize: R,
    // Disabled
    darkItemDisabledColor: new FastColor(B).setA(0.25).toRgbString(),
    // Dark
    darkItemColor: G,
    darkDangerItemColor: p,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: B,
    darkItemSelectedBg: d,
    darkDangerItemSelectedBg: p,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: G,
    darkItemHoverColor: B,
    darkDangerItemHoverColor: F,
    darkDangerItemSelectedColor: B,
    darkDangerItemActiveBg: p,
    // internal
    itemWidth: M ? `calc(100% + ${W}px)` : `calc(100% - ${j * 2}px)`
  };
}, useStyle$q = (a, s = a, c = !0) => genStyleHooks("Menu", (d) => {
  const {
    colorBgElevated: p,
    controlHeightLG: v,
    fontSize: A,
    darkItemColor: x,
    darkDangerItemColor: g,
    darkItemBg: b,
    darkSubMenuItemBg: y,
    darkItemSelectedColor: f,
    darkItemSelectedBg: m,
    darkDangerItemSelectedBg: C,
    darkItemHoverBg: w,
    darkGroupTitleColor: S,
    darkItemHoverColor: $,
    darkItemDisabledColor: T,
    darkDangerItemHoverColor: I,
    darkDangerItemSelectedColor: _,
    darkDangerItemActiveBg: E,
    popupBg: R,
    darkPopupBg: O
  } = d, L = d.calc(A).div(7).mul(5).equal(), B = merge(d, {
    menuArrowSize: L,
    menuHorizontalHeight: d.calc(v).mul(1.15).equal(),
    menuArrowOffset: d.calc(L).mul(0.25).equal(),
    menuSubMenuBg: p,
    calc: d.calc,
    popupBg: R
  }), F = merge(B, {
    itemColor: x,
    itemHoverColor: $,
    groupTitleColor: S,
    itemSelectedColor: f,
    subMenuItemSelectedColor: f,
    itemBg: b,
    popupBg: O,
    subMenuItemBg: y,
    itemActiveBg: "transparent",
    itemSelectedBg: m,
    activeBarHeight: 0,
    activeBarBorderWidth: 0,
    itemHoverBg: w,
    // Disabled
    itemDisabledColor: T,
    // Danger
    dangerItemColor: g,
    dangerItemHoverColor: I,
    dangerItemSelectedColor: _,
    dangerItemActiveBg: E,
    dangerItemSelectedBg: C,
    menuSubMenuBg: y,
    // Horizontal
    horizontalItemSelectedColor: f,
    horizontalItemSelectedBg: m
  });
  return [
    // Basic
    getBaseStyle(B),
    // Horizontal
    getHorizontalStyle(B),
    // Hard code for some light style
    // Vertical
    getVerticalStyle(B),
    // Hard code for some light style
    // Theme
    getThemeStyle(B, "light"),
    getThemeStyle(F, "dark"),
    // RTL
    getRTLStyle(B),
    // Motion
    genCollapseMotion(B),
    initSlideMotion(B, "slide-up"),
    initSlideMotion(B, "slide-down"),
    initZoomMotion(B, "zoom-big")
  ];
}, prepareComponentToken$m, {
  deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
  // Dropdown will handle menu style self. We do not need to handle this.
  injectStyle: c,
  unitless: {
    groupTitleLineHeight: !0
  }
})(a, s), SubMenu = (a) => {
  var s;
  const {
    popupClassName: c,
    icon: u,
    title: d,
    theme: p
  } = a, v = reactExports.useContext(MenuContext), {
    prefixCls: A,
    inlineCollapsed: x,
    theme: g
  } = v, b = useFullPath();
  let y;
  if (!u)
    y = x && !b.length && d && typeof d == "string" ? /* @__PURE__ */ reactExports.createElement("div", {
      className: `${A}-inline-collapsed-noicon`
    }, d.charAt(0)) : /* @__PURE__ */ reactExports.createElement("span", {
      className: `${A}-title-content`
    }, d);
  else {
    const C = /* @__PURE__ */ reactExports.isValidElement(d) && d.type === "span";
    y = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, cloneElement(u, {
      className: classnames(/* @__PURE__ */ reactExports.isValidElement(u) ? (s = u.props) === null || s === void 0 ? void 0 : s.className : void 0, `${A}-item-icon`)
    }), C ? d : /* @__PURE__ */ reactExports.createElement("span", {
      className: `${A}-title-content`
    }, d));
  }
  const f = reactExports.useMemo(() => Object.assign(Object.assign({}, v), {
    firstLevel: !1
  }), [v]), [m] = useZIndex("Menu");
  return /* @__PURE__ */ reactExports.createElement(MenuContext.Provider, {
    value: f
  }, /* @__PURE__ */ reactExports.createElement(SubMenu$1, Object.assign({}, omit(a, ["icon"]), {
    title: y,
    popupClassName: classnames(A, c, `${A}-${p || g}`),
    popupStyle: Object.assign({
      zIndex: m
    }, a.popupStyle)
  })));
};
var __rest$R = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function isEmptyIcon(a) {
  return a === null || a === !1;
}
const MENU_COMPONENTS = {
  item: MenuItem,
  submenu: SubMenu,
  divider: MenuDivider
}, InternalMenu = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var c;
  const u = reactExports.useContext(OverrideContext), d = u || {}, {
    getPrefixCls: p,
    getPopupContainer: v,
    direction: A,
    menu: x
  } = reactExports.useContext(ConfigContext$1), g = p(), {
    prefixCls: b,
    className: y,
    style: f,
    theme: m = "light",
    expandIcon: C,
    _internalDisableMenuItemTitleTooltip: w,
    inlineCollapsed: S,
    siderCollapsed: $,
    rootClassName: T,
    mode: I,
    selectable: _,
    onClick: E,
    overflowedIndicatorPopupClassName: R
  } = a, O = __rest$R(a, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), L = omit(O, ["collapsedWidth"]);
  (c = d.validator) === null || c === void 0 || c.call(d, {
    mode: I
  });
  const B = useEvent((...Z) => {
    var ne;
    E?.apply(void 0, Z), (ne = d.onClick) === null || ne === void 0 || ne.call(d);
  }), F = d.mode || I, M = _ ?? d.selectable, W = S ?? $, j = {
    horizontal: {
      motionName: `${g}-slide-up`
    },
    inline: initCollapseMotion(g),
    other: {
      motionName: `${g}-zoom-big`
    }
  }, G = p("menu", b || d.prefixCls), U = useCSSVarCls(G), [k, N, P] = useStyle$q(G, U, !u), D = classnames(`${G}-${m}`, x?.className, y), H = reactExports.useMemo(() => {
    var Z, ne;
    if (typeof C == "function" || isEmptyIcon(C))
      return C || null;
    if (typeof d.expandIcon == "function" || isEmptyIcon(d.expandIcon))
      return d.expandIcon || null;
    if (typeof x?.expandIcon == "function" || isEmptyIcon(x?.expandIcon))
      return x?.expandIcon || null;
    const K = (Z = C ?? d?.expandIcon) !== null && Z !== void 0 ? Z : x?.expandIcon;
    return cloneElement(K, {
      className: classnames(`${G}-submenu-expand-icon`, /* @__PURE__ */ reactExports.isValidElement(K) ? (ne = K.props) === null || ne === void 0 ? void 0 : ne.className : void 0)
    });
  }, [C, d?.expandIcon, x?.expandIcon, G]), V = reactExports.useMemo(() => ({
    prefixCls: G,
    inlineCollapsed: W || !1,
    direction: A,
    firstLevel: !0,
    theme: m,
    mode: F,
    disableMenuItemTitleTooltip: w
  }), [G, W, A, w, m]);
  return k(/* @__PURE__ */ reactExports.createElement(OverrideContext.Provider, {
    value: null
  }, /* @__PURE__ */ reactExports.createElement(MenuContext.Provider, {
    value: V
  }, /* @__PURE__ */ reactExports.createElement(ExportMenu, Object.assign({
    getPopupContainer: v,
    overflowedIndicator: /* @__PURE__ */ reactExports.createElement(RefIcon$z, null),
    overflowedIndicatorPopupClassName: classnames(G, `${G}-${m}`, R),
    mode: F,
    selectable: M,
    onClick: B
  }, L, {
    inlineCollapsed: W,
    style: Object.assign(Object.assign({}, x?.style), f),
    className: D,
    prefixCls: G,
    direction: A,
    defaultMotions: j,
    expandIcon: H,
    ref: s,
    rootClassName: classnames(T, N, d.rootClassName, P, U),
    _internalComponents: MENU_COMPONENTS
  })))));
}), Menu$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const c = reactExports.useRef(null), u = reactExports.useContext(SiderContext);
  return reactExports.useImperativeHandle(s, () => ({
    menu: c.current,
    focus: (d) => {
      var p;
      (p = c.current) === null || p === void 0 || p.focus(d);
    }
  })), /* @__PURE__ */ reactExports.createElement(InternalMenu, Object.assign({
    ref: c
  }, a, u));
});
Menu$1.Item = MenuItem;
Menu$1.SubMenu = SubMenu;
Menu$1.Divider = MenuDivider;
Menu$1.ItemGroup = MenuItemGroup;
const genStatusStyle = (a) => {
  const {
    componentCls: s,
    menuCls: c,
    colorError: u,
    colorTextLightSolid: d
  } = a, p = `${c}-item`;
  return {
    [`${s}, ${s}-menu-submenu`]: {
      [`${c} ${p}`]: {
        [`&${p}-danger:not(${p}-disabled)`]: {
          color: u,
          "&:hover": {
            color: d,
            backgroundColor: u
          }
        }
      }
    }
  };
}, genBaseStyle$7 = (a) => {
  const {
    componentCls: s,
    menuCls: c,
    zIndexPopup: u,
    dropdownArrowDistance: d,
    sizePopupArrow: p,
    antCls: v,
    iconCls: A,
    motionDurationMid: x,
    paddingBlock: g,
    fontSize: b,
    dropdownEdgeChildPadding: y,
    colorTextDisabled: f,
    fontSizeIcon: m,
    controlPaddingHorizontal: C,
    colorBgElevated: w
  } = a;
  return [
    {
      [s]: {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: u,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: a.calc(p).div(2).sub(d).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
        "&-menu-vertical": {
          maxHeight: "100vh",
          overflowY: "auto"
        },
        [`&-trigger${v}-btn`]: {
          [`& > ${A}-down, & > ${v}-btn-icon > ${A}-down`]: {
            fontSize: m
          }
        },
        [`${s}-wrap`]: {
          position: "relative",
          [`${v}-btn > ${A}-down`]: {
            fontSize: m
          },
          [`${A}-down::before`]: {
            transition: `transform ${x}`
          }
        },
        [`${s}-wrap-open`]: {
          [`${A}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${v}-slide-down-enter${v}-slide-down-enter-active${s}-placement-bottomLeft,
          &${v}-slide-down-appear${v}-slide-down-appear-active${s}-placement-bottomLeft,
          &${v}-slide-down-enter${v}-slide-down-enter-active${s}-placement-bottom,
          &${v}-slide-down-appear${v}-slide-down-appear-active${s}-placement-bottom,
          &${v}-slide-down-enter${v}-slide-down-enter-active${s}-placement-bottomRight,
          &${v}-slide-down-appear${v}-slide-down-appear-active${s}-placement-bottomRight`]: {
          animationName: slideUpIn
        },
        [`&${v}-slide-up-enter${v}-slide-up-enter-active${s}-placement-topLeft,
          &${v}-slide-up-appear${v}-slide-up-appear-active${s}-placement-topLeft,
          &${v}-slide-up-enter${v}-slide-up-enter-active${s}-placement-top,
          &${v}-slide-up-appear${v}-slide-up-appear-active${s}-placement-top,
          &${v}-slide-up-enter${v}-slide-up-enter-active${s}-placement-topRight,
          &${v}-slide-up-appear${v}-slide-up-appear-active${s}-placement-topRight`]: {
          animationName: slideDownIn
        },
        [`&${v}-slide-down-leave${v}-slide-down-leave-active${s}-placement-bottomLeft,
          &${v}-slide-down-leave${v}-slide-down-leave-active${s}-placement-bottom,
          &${v}-slide-down-leave${v}-slide-down-leave-active${s}-placement-bottomRight`]: {
          animationName: slideUpOut
        },
        [`&${v}-slide-up-leave${v}-slide-up-leave-active${s}-placement-topLeft,
          &${v}-slide-up-leave${v}-slide-up-leave-active${s}-placement-top,
          &${v}-slide-up-leave${v}-slide-up-leave-active${s}-placement-topRight`]: {
          animationName: slideDownOut
        }
      }
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    getArrowStyle(a, w, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${s} ${c}`]: {
        position: "relative",
        margin: 0
      },
      [`${c}-submenu-popup`]: {
        position: "absolute",
        zIndex: u,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${s}, ${s}-menu-submenu`]: Object.assign(Object.assign({}, resetComponent(a)), {
        [c]: Object.assign(Object.assign({
          padding: y,
          listStyleType: "none",
          backgroundColor: w,
          backgroundClip: "padding-box",
          borderRadius: a.borderRadiusLG,
          outline: "none",
          boxShadow: a.boxShadowSecondary
        }, genFocusStyle(a)), {
          "&:empty": {
            padding: 0,
            boxShadow: "none"
          },
          [`${c}-item-group-title`]: {
            padding: `${unit$1(g)} ${unit$1(C)}`,
            color: a.colorTextDescription,
            transition: `all ${x}`
          },
          // ======================= Item Content =======================
          [`${c}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${c}-item-icon`]: {
            minWidth: b,
            marginInlineEnd: a.marginXS,
            fontSize: a.fontSizeSM
          },
          [`${c}-title-content`]: {
            flex: "auto",
            "&-with-extra": {
              display: "inline-flex",
              alignItems: "center",
              width: "100%"
            },
            "> a": {
              color: "inherit",
              transition: `all ${x}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            },
            [`${c}-item-extra`]: {
              paddingInlineStart: a.padding,
              marginInlineStart: "auto",
              fontSize: a.fontSizeSM,
              color: a.colorTextDescription
            }
          },
          // =========================== Item ===========================
          [`${c}-item, ${c}-submenu-title`]: Object.assign(Object.assign({
            display: "flex",
            margin: 0,
            padding: `${unit$1(g)} ${unit$1(C)}`,
            color: a.colorText,
            fontWeight: "normal",
            fontSize: b,
            lineHeight: a.lineHeight,
            cursor: "pointer",
            transition: `all ${x}`,
            borderRadius: a.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: a.controlItemBgHover
            }
          }, genFocusStyle(a)), {
            "&-selected": {
              color: a.colorPrimary,
              backgroundColor: a.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: a.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: f,
              cursor: "not-allowed",
              "&:hover": {
                color: f,
                backgroundColor: w,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${unit$1(a.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: a.colorSplit
            },
            [`${s}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: a.paddingXS,
              [`${s}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: a.colorIcon,
                fontSize: m,
                fontStyle: "normal"
              }
            }
          }),
          [`${c}-item-group-list`]: {
            margin: `0 ${unit$1(a.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${c}-submenu-title`]: {
            paddingInlineEnd: a.calc(C).add(a.fontSizeSM).equal()
          },
          [`${c}-submenu-vertical`]: {
            position: "relative"
          },
          [`${c}-submenu${c}-submenu-disabled ${s}-menu-submenu-title`]: {
            [`&, ${s}-menu-submenu-arrow-icon`]: {
              color: f,
              backgroundColor: w,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${c}-submenu-selected ${s}-menu-submenu-title`]: {
            color: a.colorPrimary
          }
        })
      })
    },
    // Follow code may reuse in other components
    [initSlideMotion(a, "slide-up"), initSlideMotion(a, "slide-down"), initMoveMotion(a, "move-up"), initMoveMotion(a, "move-down"), initZoomMotion(a, "zoom-big")]
  ];
}, prepareComponentToken$l = (a) => Object.assign(Object.assign({
  zIndexPopup: a.zIndexPopupBase + 50,
  paddingBlock: (a.controlHeight - a.fontSize * a.lineHeight) / 2
}, getArrowOffsetToken({
  contentRadius: a.borderRadiusLG,
  limitVerticalRadius: !0
})), getArrowToken(a)), useStyle$p = genStyleHooks("Dropdown", (a) => {
  const {
    marginXXS: s,
    sizePopupArrow: c,
    paddingXXS: u,
    componentCls: d
  } = a, p = merge(a, {
    menuCls: `${d}-menu`,
    dropdownArrowDistance: a.calc(c).div(2).add(s).equal(),
    dropdownEdgeChildPadding: u
  });
  return [genBaseStyle$7(p), genStatusStyle(p)];
}, prepareComponentToken$l, {
  resetStyle: !1
}), Dropdown$1 = (a) => {
  var s;
  const {
    menu: c,
    arrow: u,
    prefixCls: d,
    children: p,
    trigger: v,
    disabled: A,
    dropdownRender: x,
    popupRender: g,
    getPopupContainer: b,
    overlayClassName: y,
    rootClassName: f,
    overlayStyle: m,
    open: C,
    onOpenChange: w,
    // Deprecated
    visible: S,
    onVisibleChange: $,
    mouseEnterDelay: T = 0.15,
    mouseLeaveDelay: I = 0.1,
    autoAdjustOverflow: _ = !0,
    placement: E = "",
    overlay: R,
    transitionName: O,
    destroyOnHidden: L,
    destroyPopupOnHide: B
  } = a, {
    getPopupContainer: F,
    getPrefixCls: M,
    direction: W,
    dropdown: j
  } = reactExports.useContext(ConfigContext$1), G = g || x;
  devUseWarning();
  const U = reactExports.useMemo(() => {
    const pe = M();
    return O !== void 0 ? O : E.includes("top") ? `${pe}-slide-down` : `${pe}-slide-up`;
  }, [M, E, O]), k = reactExports.useMemo(() => E ? E.includes("Center") ? E.slice(0, E.indexOf("Center")) : E : W === "rtl" ? "bottomRight" : "bottomLeft", [E, W]), N = M("dropdown", d), P = useCSSVarCls(N), [D, H, V] = useStyle$p(N, P), [, Z] = useToken$1(), ne = reactExports.Children.only(isPrimitive(p) ? /* @__PURE__ */ reactExports.createElement("span", null, p) : p), K = cloneElement(ne, {
    className: classnames(`${N}-trigger`, {
      [`${N}-rtl`]: W === "rtl"
    }, ne.props.className),
    disabled: (s = ne.props.disabled) !== null && s !== void 0 ? s : A
  }), q = A ? [] : v, Y = !!q?.includes("contextMenu"), [ee, Q] = useMergedState(!1, {
    value: C ?? S
  }), J = useEvent((pe) => {
    w?.(pe, {
      source: "trigger"
    }), $?.(pe), Q(pe);
  }), te = classnames(y, f, H, V, P, j?.className, {
    [`${N}-rtl`]: W === "rtl"
  }), ae = getPlacements({
    arrowPointAtCenter: typeof u == "object" && u.pointAtCenter,
    autoAdjustOverflow: _,
    offset: Z.marginXXS,
    arrowWidth: u ? Z.sizePopupArrow : 0,
    borderRadius: Z.borderRadius
  }), se = reactExports.useCallback(() => {
    c?.selectable && c?.multiple || (w?.(!1, {
      source: "menu"
    }), Q(!1));
  }, [c?.selectable, c?.multiple]), ie = () => {
    let pe;
    return c?.items ? pe = /* @__PURE__ */ reactExports.createElement(Menu$1, Object.assign({}, c)) : typeof R == "function" ? pe = R() : pe = R, G && (pe = G(pe)), pe = reactExports.Children.only(typeof pe == "string" ? /* @__PURE__ */ reactExports.createElement("span", null, pe) : pe), /* @__PURE__ */ reactExports.createElement(OverrideProvider, {
      prefixCls: `${N}-menu`,
      rootClassName: classnames(V, P),
      expandIcon: /* @__PURE__ */ reactExports.createElement("span", {
        className: `${N}-menu-submenu-arrow`
      }, W === "rtl" ? /* @__PURE__ */ reactExports.createElement(RefIcon$A, {
        className: `${N}-menu-submenu-arrow-icon`
      }) : /* @__PURE__ */ reactExports.createElement(RefIcon$E, {
        className: `${N}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: se,
      validator: ({
        mode: be
      }) => {
      }
    }, pe);
  }, [fe, ge] = useZIndex("Dropdown", m?.zIndex);
  let me = /* @__PURE__ */ reactExports.createElement(Dropdown$3, Object.assign({
    alignPoint: Y
  }, omit(a, ["rootClassName"]), {
    mouseEnterDelay: T,
    mouseLeaveDelay: I,
    visible: ee,
    builtinPlacements: ae,
    arrow: !!u,
    overlayClassName: te,
    prefixCls: N,
    getPopupContainer: b || F,
    transitionName: U,
    trigger: q,
    overlay: ie,
    placement: k,
    onVisibleChange: J,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, j?.style), m), {
      zIndex: fe
    }),
    autoDestroy: L ?? B
  }), K);
  return fe && (me = /* @__PURE__ */ reactExports.createElement(zIndexContext.Provider, {
    value: ge
  }, me)), D(me);
}, PurePanel$3 = genPurePanel(Dropdown$1, "align", void 0, "dropdown", (a) => a), WrapPurePanel = (a) => /* @__PURE__ */ reactExports.createElement(PurePanel$3, Object.assign({}, a), /* @__PURE__ */ reactExports.createElement("span", null));
Dropdown$1._InternalPanelDoNotUseOrYouWillBeFired = WrapPurePanel;
var dayjs_min$1 = { exports: {} }, dayjs_min = dayjs_min$1.exports, hasRequiredDayjs_min;
function requireDayjs_min() {
  return hasRequiredDayjs_min || (hasRequiredDayjs_min = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(dayjs_min, function() {
      var c = 1e3, u = 6e4, d = 36e5, p = "millisecond", v = "second", A = "minute", x = "hour", g = "day", b = "week", y = "month", f = "quarter", m = "year", C = "date", w = "Invalid Date", S = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, $ = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(G) {
        var U = ["th", "st", "nd", "rd"], k = G % 100;
        return "[" + G + (U[(k - 20) % 10] || U[k] || U[0]) + "]";
      } }, I = function(G, U, k) {
        var N = String(G);
        return !N || N.length >= U ? G : "" + Array(U + 1 - N.length).join(k) + G;
      }, _ = { s: I, z: function(G) {
        var U = -G.utcOffset(), k = Math.abs(U), N = Math.floor(k / 60), P = k % 60;
        return (U <= 0 ? "+" : "-") + I(N, 2, "0") + ":" + I(P, 2, "0");
      }, m: function G(U, k) {
        if (U.date() < k.date()) return -G(k, U);
        var N = 12 * (k.year() - U.year()) + (k.month() - U.month()), P = U.clone().add(N, y), D = k - P < 0, H = U.clone().add(N + (D ? -1 : 1), y);
        return +(-(N + (k - P) / (D ? P - H : H - P)) || 0);
      }, a: function(G) {
        return G < 0 ? Math.ceil(G) || 0 : Math.floor(G);
      }, p: function(G) {
        return { M: y, y: m, w: b, d: g, D: C, h: x, m: A, s: v, ms: p, Q: f }[G] || String(G || "").toLowerCase().replace(/s$/, "");
      }, u: function(G) {
        return G === void 0;
      } }, E = "en", R = {};
      R[E] = T;
      var O = "$isDayjsObject", L = function(G) {
        return G instanceof W || !(!G || !G[O]);
      }, B = function G(U, k, N) {
        var P;
        if (!U) return E;
        if (typeof U == "string") {
          var D = U.toLowerCase();
          R[D] && (P = D), k && (R[D] = k, P = D);
          var H = U.split("-");
          if (!P && H.length > 1) return G(H[0]);
        } else {
          var V = U.name;
          R[V] = U, P = V;
        }
        return !N && P && (E = P), P || !N && E;
      }, F = function(G, U) {
        if (L(G)) return G.clone();
        var k = typeof U == "object" ? U : {};
        return k.date = G, k.args = arguments, new W(k);
      }, M = _;
      M.l = B, M.i = L, M.w = function(G, U) {
        return F(G, { locale: U.$L, utc: U.$u, x: U.$x, $offset: U.$offset });
      };
      var W = function() {
        function G(k) {
          this.$L = B(k.locale, null, !0), this.parse(k), this.$x = this.$x || k.x || {}, this[O] = !0;
        }
        var U = G.prototype;
        return U.parse = function(k) {
          this.$d = function(N) {
            var P = N.date, D = N.utc;
            if (P === null) return /* @__PURE__ */ new Date(NaN);
            if (M.u(P)) return /* @__PURE__ */ new Date();
            if (P instanceof Date) return new Date(P);
            if (typeof P == "string" && !/Z$/i.test(P)) {
              var H = P.match(S);
              if (H) {
                var V = H[2] - 1 || 0, Z = (H[7] || "0").substring(0, 3);
                return D ? new Date(Date.UTC(H[1], V, H[3] || 1, H[4] || 0, H[5] || 0, H[6] || 0, Z)) : new Date(H[1], V, H[3] || 1, H[4] || 0, H[5] || 0, H[6] || 0, Z);
              }
            }
            return new Date(P);
          }(k), this.init();
        }, U.init = function() {
          var k = this.$d;
          this.$y = k.getFullYear(), this.$M = k.getMonth(), this.$D = k.getDate(), this.$W = k.getDay(), this.$H = k.getHours(), this.$m = k.getMinutes(), this.$s = k.getSeconds(), this.$ms = k.getMilliseconds();
        }, U.$utils = function() {
          return M;
        }, U.isValid = function() {
          return this.$d.toString() !== w;
        }, U.isSame = function(k, N) {
          var P = F(k);
          return this.startOf(N) <= P && P <= this.endOf(N);
        }, U.isAfter = function(k, N) {
          return F(k) < this.startOf(N);
        }, U.isBefore = function(k, N) {
          return this.endOf(N) < F(k);
        }, U.$g = function(k, N, P) {
          return M.u(k) ? this[N] : this.set(P, k);
        }, U.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, U.valueOf = function() {
          return this.$d.getTime();
        }, U.startOf = function(k, N) {
          var P = this, D = !!M.u(N) || N, H = M.p(k), V = function(J, te) {
            var ae = M.w(P.$u ? Date.UTC(P.$y, te, J) : new Date(P.$y, te, J), P);
            return D ? ae : ae.endOf(g);
          }, Z = function(J, te) {
            return M.w(P.toDate()[J].apply(P.toDate("s"), (D ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(te)), P);
          }, ne = this.$W, K = this.$M, q = this.$D, Y = "set" + (this.$u ? "UTC" : "");
          switch (H) {
            case m:
              return D ? V(1, 0) : V(31, 11);
            case y:
              return D ? V(1, K) : V(0, K + 1);
            case b:
              var ee = this.$locale().weekStart || 0, Q = (ne < ee ? ne + 7 : ne) - ee;
              return V(D ? q - Q : q + (6 - Q), K);
            case g:
            case C:
              return Z(Y + "Hours", 0);
            case x:
              return Z(Y + "Minutes", 1);
            case A:
              return Z(Y + "Seconds", 2);
            case v:
              return Z(Y + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, U.endOf = function(k) {
          return this.startOf(k, !1);
        }, U.$set = function(k, N) {
          var P, D = M.p(k), H = "set" + (this.$u ? "UTC" : ""), V = (P = {}, P[g] = H + "Date", P[C] = H + "Date", P[y] = H + "Month", P[m] = H + "FullYear", P[x] = H + "Hours", P[A] = H + "Minutes", P[v] = H + "Seconds", P[p] = H + "Milliseconds", P)[D], Z = D === g ? this.$D + (N - this.$W) : N;
          if (D === y || D === m) {
            var ne = this.clone().set(C, 1);
            ne.$d[V](Z), ne.init(), this.$d = ne.set(C, Math.min(this.$D, ne.daysInMonth())).$d;
          } else V && this.$d[V](Z);
          return this.init(), this;
        }, U.set = function(k, N) {
          return this.clone().$set(k, N);
        }, U.get = function(k) {
          return this[M.p(k)]();
        }, U.add = function(k, N) {
          var P, D = this;
          k = Number(k);
          var H = M.p(N), V = function(K) {
            var q = F(D);
            return M.w(q.date(q.date() + Math.round(K * k)), D);
          };
          if (H === y) return this.set(y, this.$M + k);
          if (H === m) return this.set(m, this.$y + k);
          if (H === g) return V(1);
          if (H === b) return V(7);
          var Z = (P = {}, P[A] = u, P[x] = d, P[v] = c, P)[H] || 1, ne = this.$d.getTime() + k * Z;
          return M.w(ne, this);
        }, U.subtract = function(k, N) {
          return this.add(-1 * k, N);
        }, U.format = function(k) {
          var N = this, P = this.$locale();
          if (!this.isValid()) return P.invalidDate || w;
          var D = k || "YYYY-MM-DDTHH:mm:ssZ", H = M.z(this), V = this.$H, Z = this.$m, ne = this.$M, K = P.weekdays, q = P.months, Y = P.meridiem, ee = function(te, ae, se, ie) {
            return te && (te[ae] || te(N, D)) || se[ae].slice(0, ie);
          }, Q = function(te) {
            return M.s(V % 12 || 12, te, "0");
          }, J = Y || function(te, ae, se) {
            var ie = te < 12 ? "AM" : "PM";
            return se ? ie.toLowerCase() : ie;
          };
          return D.replace($, function(te, ae) {
            return ae || function(se) {
              switch (se) {
                case "YY":
                  return String(N.$y).slice(-2);
                case "YYYY":
                  return M.s(N.$y, 4, "0");
                case "M":
                  return ne + 1;
                case "MM":
                  return M.s(ne + 1, 2, "0");
                case "MMM":
                  return ee(P.monthsShort, ne, q, 3);
                case "MMMM":
                  return ee(q, ne);
                case "D":
                  return N.$D;
                case "DD":
                  return M.s(N.$D, 2, "0");
                case "d":
                  return String(N.$W);
                case "dd":
                  return ee(P.weekdaysMin, N.$W, K, 2);
                case "ddd":
                  return ee(P.weekdaysShort, N.$W, K, 3);
                case "dddd":
                  return K[N.$W];
                case "H":
                  return String(V);
                case "HH":
                  return M.s(V, 2, "0");
                case "h":
                  return Q(1);
                case "hh":
                  return Q(2);
                case "a":
                  return J(V, Z, !0);
                case "A":
                  return J(V, Z, !1);
                case "m":
                  return String(Z);
                case "mm":
                  return M.s(Z, 2, "0");
                case "s":
                  return String(N.$s);
                case "ss":
                  return M.s(N.$s, 2, "0");
                case "SSS":
                  return M.s(N.$ms, 3, "0");
                case "Z":
                  return H;
              }
              return null;
            }(te) || H.replace(":", "");
          });
        }, U.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, U.diff = function(k, N, P) {
          var D, H = this, V = M.p(N), Z = F(k), ne = (Z.utcOffset() - this.utcOffset()) * u, K = this - Z, q = function() {
            return M.m(H, Z);
          };
          switch (V) {
            case m:
              D = q() / 12;
              break;
            case y:
              D = q();
              break;
            case f:
              D = q() / 3;
              break;
            case b:
              D = (K - ne) / 6048e5;
              break;
            case g:
              D = (K - ne) / 864e5;
              break;
            case x:
              D = K / d;
              break;
            case A:
              D = K / u;
              break;
            case v:
              D = K / c;
              break;
            default:
              D = K;
          }
          return P ? D : M.a(D);
        }, U.daysInMonth = function() {
          return this.endOf(y).$D;
        }, U.$locale = function() {
          return R[this.$L];
        }, U.locale = function(k, N) {
          if (!k) return this.$L;
          var P = this.clone(), D = B(k, N, !0);
          return D && (P.$L = D), P;
        }, U.clone = function() {
          return M.w(this.$d, this);
        }, U.toDate = function() {
          return new Date(this.valueOf());
        }, U.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, U.toISOString = function() {
          return this.$d.toISOString();
        }, U.toString = function() {
          return this.$d.toUTCString();
        }, G;
      }(), j = W.prototype;
      return F.prototype = j, [["$ms", p], ["$s", v], ["$m", A], ["$H", x], ["$W", g], ["$M", y], ["$y", m], ["$D", C]].forEach(function(G) {
        j[G[1]] = function(U) {
          return this.$g(U, G[0], G[1]);
        };
      }), F.extend = function(G, U) {
        return G.$i || (G(U, W, F), G.$i = !0), F;
      }, F.locale = B, F.isDayjs = L, F.unix = function(G) {
        return F(1e3 * G);
      }, F.en = R[E], F.Ls = R, F.p = {}, F;
    });
  }(dayjs_min$1)), dayjs_min$1.exports;
}
var dayjs_minExports = requireDayjs_min();
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
var weekday$2 = { exports: {} }, weekday$1 = weekday$2.exports, hasRequiredWeekday;
function requireWeekday() {
  return hasRequiredWeekday || (hasRequiredWeekday = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(weekday$1, function() {
      return function(c, u) {
        u.prototype.weekday = function(d) {
          var p = this.$locale().weekStart || 0, v = this.$W, A = (v < p ? v + 7 : v) - p;
          return this.$utils().u(d) ? A : this.subtract(A, "day").add(d, "day");
        };
      };
    });
  }(weekday$2)), weekday$2.exports;
}
var weekdayExports = requireWeekday();
const weekday = /* @__PURE__ */ getDefaultExportFromCjs(weekdayExports);
var localeData$2 = { exports: {} }, localeData$1 = localeData$2.exports, hasRequiredLocaleData;
function requireLocaleData() {
  return hasRequiredLocaleData || (hasRequiredLocaleData = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(localeData$1, function() {
      return function(c, u, d) {
        var p = u.prototype, v = function(y) {
          return y && (y.indexOf ? y : y.s);
        }, A = function(y, f, m, C, w) {
          var S = y.name ? y : y.$locale(), $ = v(S[f]), T = v(S[m]), I = $ || T.map(function(E) {
            return E.slice(0, C);
          });
          if (!w) return I;
          var _ = S.weekStart;
          return I.map(function(E, R) {
            return I[(R + (_ || 0)) % 7];
          });
        }, x = function() {
          return d.Ls[d.locale()];
        }, g = function(y, f) {
          return y.formats[f] || function(m) {
            return m.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(C, w, S) {
              return w || S.slice(1);
            });
          }(y.formats[f.toUpperCase()]);
        }, b = function() {
          var y = this;
          return { months: function(f) {
            return f ? f.format("MMMM") : A(y, "months");
          }, monthsShort: function(f) {
            return f ? f.format("MMM") : A(y, "monthsShort", "months", 3);
          }, firstDayOfWeek: function() {
            return y.$locale().weekStart || 0;
          }, weekdays: function(f) {
            return f ? f.format("dddd") : A(y, "weekdays");
          }, weekdaysMin: function(f) {
            return f ? f.format("dd") : A(y, "weekdaysMin", "weekdays", 2);
          }, weekdaysShort: function(f) {
            return f ? f.format("ddd") : A(y, "weekdaysShort", "weekdays", 3);
          }, longDateFormat: function(f) {
            return g(y.$locale(), f);
          }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
        };
        p.localeData = function() {
          return b.bind(this)();
        }, d.localeData = function() {
          var y = x();
          return { firstDayOfWeek: function() {
            return y.weekStart || 0;
          }, weekdays: function() {
            return d.weekdays();
          }, weekdaysShort: function() {
            return d.weekdaysShort();
          }, weekdaysMin: function() {
            return d.weekdaysMin();
          }, months: function() {
            return d.months();
          }, monthsShort: function() {
            return d.monthsShort();
          }, longDateFormat: function(f) {
            return g(y, f);
          }, meridiem: y.meridiem, ordinal: y.ordinal };
        }, d.months = function() {
          return A(x(), "months");
        }, d.monthsShort = function() {
          return A(x(), "monthsShort", "months", 3);
        }, d.weekdays = function(y) {
          return A(x(), "weekdays", null, null, y);
        }, d.weekdaysShort = function(y) {
          return A(x(), "weekdaysShort", "weekdays", 3, y);
        }, d.weekdaysMin = function(y) {
          return A(x(), "weekdaysMin", "weekdays", 2, y);
        };
      };
    });
  }(localeData$2)), localeData$2.exports;
}
var localeDataExports = requireLocaleData();
const localeData = /* @__PURE__ */ getDefaultExportFromCjs(localeDataExports);
var weekOfYear$2 = { exports: {} }, weekOfYear$1 = weekOfYear$2.exports, hasRequiredWeekOfYear;
function requireWeekOfYear() {
  return hasRequiredWeekOfYear || (hasRequiredWeekOfYear = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(weekOfYear$1, function() {
      var c = "week", u = "year";
      return function(d, p, v) {
        var A = p.prototype;
        A.week = function(x) {
          if (x === void 0 && (x = null), x !== null) return this.add(7 * (x - this.week()), "day");
          var g = this.$locale().yearStart || 1;
          if (this.month() === 11 && this.date() > 25) {
            var b = v(this).startOf(u).add(1, u).date(g), y = v(this).endOf(c);
            if (b.isBefore(y)) return 1;
          }
          var f = v(this).startOf(u).date(g).startOf(c).subtract(1, "millisecond"), m = this.diff(f, c, !0);
          return m < 0 ? v(this).startOf("week").week() : Math.ceil(m);
        }, A.weeks = function(x) {
          return x === void 0 && (x = null), this.week(x);
        };
      };
    });
  }(weekOfYear$2)), weekOfYear$2.exports;
}
var weekOfYearExports = requireWeekOfYear();
const weekOfYear = /* @__PURE__ */ getDefaultExportFromCjs(weekOfYearExports);
var weekYear$2 = { exports: {} }, weekYear$1 = weekYear$2.exports, hasRequiredWeekYear;
function requireWeekYear() {
  return hasRequiredWeekYear || (hasRequiredWeekYear = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(weekYear$1, function() {
      return function(c, u) {
        u.prototype.weekYear = function() {
          var d = this.month(), p = this.week(), v = this.year();
          return p === 1 && d === 11 ? v + 1 : d === 0 && p >= 52 ? v - 1 : v;
        };
      };
    });
  }(weekYear$2)), weekYear$2.exports;
}
var weekYearExports = requireWeekYear();
const weekYear = /* @__PURE__ */ getDefaultExportFromCjs(weekYearExports);
var advancedFormat$2 = { exports: {} }, advancedFormat$1 = advancedFormat$2.exports, hasRequiredAdvancedFormat;
function requireAdvancedFormat() {
  return hasRequiredAdvancedFormat || (hasRequiredAdvancedFormat = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(advancedFormat$1, function() {
      return function(c, u) {
        var d = u.prototype, p = d.format;
        d.format = function(v) {
          var A = this, x = this.$locale();
          if (!this.isValid()) return p.bind(this)(v);
          var g = this.$utils(), b = (v || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(y) {
            switch (y) {
              case "Q":
                return Math.ceil((A.$M + 1) / 3);
              case "Do":
                return x.ordinal(A.$D);
              case "gggg":
                return A.weekYear();
              case "GGGG":
                return A.isoWeekYear();
              case "wo":
                return x.ordinal(A.week(), "W");
              case "w":
              case "ww":
                return g.s(A.week(), y === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return g.s(A.isoWeek(), y === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return g.s(String(A.$H === 0 ? 24 : A.$H), y === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(A.$d.getTime() / 1e3);
              case "x":
                return A.$d.getTime();
              case "z":
                return "[" + A.offsetName() + "]";
              case "zzz":
                return "[" + A.offsetName("long") + "]";
              default:
                return y;
            }
          });
          return p.bind(this)(b);
        };
      };
    });
  }(advancedFormat$2)), advancedFormat$2.exports;
}
var advancedFormatExports = requireAdvancedFormat();
const advancedFormat = /* @__PURE__ */ getDefaultExportFromCjs(advancedFormatExports);
var customParseFormat$2 = { exports: {} }, customParseFormat$1 = customParseFormat$2.exports, hasRequiredCustomParseFormat;
function requireCustomParseFormat() {
  return hasRequiredCustomParseFormat || (hasRequiredCustomParseFormat = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(customParseFormat$1, function() {
      var c = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, u = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, d = /\d/, p = /\d\d/, v = /\d\d?/, A = /\d*[^-_:/,()\s\d]+/, x = {}, g = function(S) {
        return (S = +S) + (S > 68 ? 1900 : 2e3);
      }, b = function(S) {
        return function($) {
          this[S] = +$;
        };
      }, y = [/[+-]\d\d:?(\d\d)?|Z/, function(S) {
        (this.zone || (this.zone = {})).offset = function($) {
          if (!$ || $ === "Z") return 0;
          var T = $.match(/([+-]|\d\d)/g), I = 60 * T[1] + (+T[2] || 0);
          return I === 0 ? 0 : T[0] === "+" ? -I : I;
        }(S);
      }], f = function(S) {
        var $ = x[S];
        return $ && ($.indexOf ? $ : $.s.concat($.f));
      }, m = function(S, $) {
        var T, I = x.meridiem;
        if (I) {
          for (var _ = 1; _ <= 24; _ += 1) if (S.indexOf(I(_, 0, $)) > -1) {
            T = _ > 12;
            break;
          }
        } else T = S === ($ ? "pm" : "PM");
        return T;
      }, C = { A: [A, function(S) {
        this.afternoon = m(S, !1);
      }], a: [A, function(S) {
        this.afternoon = m(S, !0);
      }], Q: [d, function(S) {
        this.month = 3 * (S - 1) + 1;
      }], S: [d, function(S) {
        this.milliseconds = 100 * +S;
      }], SS: [p, function(S) {
        this.milliseconds = 10 * +S;
      }], SSS: [/\d{3}/, function(S) {
        this.milliseconds = +S;
      }], s: [v, b("seconds")], ss: [v, b("seconds")], m: [v, b("minutes")], mm: [v, b("minutes")], H: [v, b("hours")], h: [v, b("hours")], HH: [v, b("hours")], hh: [v, b("hours")], D: [v, b("day")], DD: [p, b("day")], Do: [A, function(S) {
        var $ = x.ordinal, T = S.match(/\d+/);
        if (this.day = T[0], $) for (var I = 1; I <= 31; I += 1) $(I).replace(/\[|\]/g, "") === S && (this.day = I);
      }], w: [v, b("week")], ww: [p, b("week")], M: [v, b("month")], MM: [p, b("month")], MMM: [A, function(S) {
        var $ = f("months"), T = (f("monthsShort") || $.map(function(I) {
          return I.slice(0, 3);
        })).indexOf(S) + 1;
        if (T < 1) throw new Error();
        this.month = T % 12 || T;
      }], MMMM: [A, function(S) {
        var $ = f("months").indexOf(S) + 1;
        if ($ < 1) throw new Error();
        this.month = $ % 12 || $;
      }], Y: [/[+-]?\d+/, b("year")], YY: [p, function(S) {
        this.year = g(S);
      }], YYYY: [/\d{4}/, b("year")], Z: y, ZZ: y };
      function w(S) {
        var $, T;
        $ = S, T = x && x.formats;
        for (var I = (S = $.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(F, M, W) {
          var j = W && W.toUpperCase();
          return M || T[W] || c[W] || T[j].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(G, U, k) {
            return U || k.slice(1);
          });
        })).match(u), _ = I.length, E = 0; E < _; E += 1) {
          var R = I[E], O = C[R], L = O && O[0], B = O && O[1];
          I[E] = B ? { regex: L, parser: B } : R.replace(/^\[|\]$/g, "");
        }
        return function(F) {
          for (var M = {}, W = 0, j = 0; W < _; W += 1) {
            var G = I[W];
            if (typeof G == "string") j += G.length;
            else {
              var U = G.regex, k = G.parser, N = F.slice(j), P = U.exec(N)[0];
              k.call(M, P), F = F.replace(P, "");
            }
          }
          return function(D) {
            var H = D.afternoon;
            if (H !== void 0) {
              var V = D.hours;
              H ? V < 12 && (D.hours += 12) : V === 12 && (D.hours = 0), delete D.afternoon;
            }
          }(M), M;
        };
      }
      return function(S, $, T) {
        T.p.customParseFormat = !0, S && S.parseTwoDigitYear && (g = S.parseTwoDigitYear);
        var I = $.prototype, _ = I.parse;
        I.parse = function(E) {
          var R = E.date, O = E.utc, L = E.args;
          this.$u = O;
          var B = L[1];
          if (typeof B == "string") {
            var F = L[2] === !0, M = L[3] === !0, W = F || M, j = L[2];
            M && (j = L[2]), x = this.$locale(), !F && j && (x = T.Ls[j]), this.$d = function(N, P, D, H) {
              try {
                if (["x", "X"].indexOf(P) > -1) return new Date((P === "X" ? 1e3 : 1) * N);
                var V = w(P)(N), Z = V.year, ne = V.month, K = V.day, q = V.hours, Y = V.minutes, ee = V.seconds, Q = V.milliseconds, J = V.zone, te = V.week, ae = /* @__PURE__ */ new Date(), se = K || (Z || ne ? 1 : ae.getDate()), ie = Z || ae.getFullYear(), fe = 0;
                Z && !ne || (fe = ne > 0 ? ne - 1 : ae.getMonth());
                var ge, me = q || 0, pe = Y || 0, be = ee || 0, le = Q || 0;
                return J ? new Date(Date.UTC(ie, fe, se, me, pe, be, le + 60 * J.offset * 1e3)) : D ? new Date(Date.UTC(ie, fe, se, me, pe, be, le)) : (ge = new Date(ie, fe, se, me, pe, be, le), te && (ge = H(ge).week(te).toDate()), ge);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            }(R, B, O, T), this.init(), j && j !== !0 && (this.$L = this.locale(j).$L), W && R != this.format(B) && (this.$d = /* @__PURE__ */ new Date("")), x = {};
          } else if (B instanceof Array) for (var G = B.length, U = 1; U <= G; U += 1) {
            L[1] = B[U - 1];
            var k = T.apply(this, L);
            if (k.isValid()) {
              this.$d = k.$d, this.$L = k.$L, this.init();
              break;
            }
            U === G && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else _.call(this, E);
        };
      };
    });
  }(customParseFormat$2)), customParseFormat$2.exports;
}
var customParseFormatExports = requireCustomParseFormat();
const customParseFormat = /* @__PURE__ */ getDefaultExportFromCjs(customParseFormatExports);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(function(a, s) {
  var c = s.prototype, u = c.format;
  c.format = function(p) {
    var v = (p || "").replace("Wo", "wo");
    return u.bind(this)(v);
  };
});
var localeMap = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, parseLocale = function a(s) {
  var c = localeMap[s];
  return c || s.split("_")[0];
}, generateConfig = {
  // get
  getNow: function a() {
    var s = dayjs();
    return typeof s.tz == "function" ? s.tz() : s;
  },
  getFixedDate: function a(s) {
    return dayjs(s, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function a(s) {
    return s.endOf("month");
  },
  getWeekDay: function a(s) {
    var c = s.locale("en");
    return c.weekday() + c.localeData().firstDayOfWeek();
  },
  getYear: function a(s) {
    return s.year();
  },
  getMonth: function a(s) {
    return s.month();
  },
  getDate: function a(s) {
    return s.date();
  },
  getHour: function a(s) {
    return s.hour();
  },
  getMinute: function a(s) {
    return s.minute();
  },
  getSecond: function a(s) {
    return s.second();
  },
  getMillisecond: function a(s) {
    return s.millisecond();
  },
  // set
  addYear: function a(s, c) {
    return s.add(c, "year");
  },
  addMonth: function a(s, c) {
    return s.add(c, "month");
  },
  addDate: function a(s, c) {
    return s.add(c, "day");
  },
  setYear: function a(s, c) {
    return s.year(c);
  },
  setMonth: function a(s, c) {
    return s.month(c);
  },
  setDate: function a(s, c) {
    return s.date(c);
  },
  setHour: function a(s, c) {
    return s.hour(c);
  },
  setMinute: function a(s, c) {
    return s.minute(c);
  },
  setSecond: function a(s, c) {
    return s.second(c);
  },
  setMillisecond: function a(s, c) {
    return s.millisecond(c);
  },
  // Compare
  isAfter: function a(s, c) {
    return s.isAfter(c);
  },
  isValidate: function a(s) {
    return s.isValid();
  },
  locale: {
    getWeekFirstDay: function a(s) {
      return dayjs().locale(parseLocale(s)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function a(s, c) {
      return c.locale(parseLocale(s)).weekday(0);
    },
    getWeek: function a(s, c) {
      return c.locale(parseLocale(s)).week();
    },
    getShortWeekDays: function a(s) {
      return dayjs().locale(parseLocale(s)).localeData().weekdaysMin();
    },
    getShortMonths: function a(s) {
      return dayjs().locale(parseLocale(s)).localeData().monthsShort();
    },
    format: function a(s, c, u) {
      return c.locale(parseLocale(s)).format(u);
    },
    parse: function a(s, c, u) {
      for (var d = parseLocale(s), p = 0; p < u.length; p += 1) {
        var v = u[p], A = c;
        if (v.includes("wo") || v.includes("Wo")) {
          for (var x = A.split("-")[0], g = A.split("-")[1], b = dayjs(x, "YYYY").startOf("year").locale(d), y = 0; y <= 52; y += 1) {
            var f = b.add(y, "week");
            if (f.format("Wo") === g)
              return f;
          }
          return null;
        }
        var m = dayjs(A, v, !0).locale(d);
        if (m.isValid())
          return m;
      }
      return null;
    }
  }
};
function getRealPlacement(a, s) {
  return a !== void 0 ? a : s ? "bottomRight" : "bottomLeft";
}
var PickerContext = /* @__PURE__ */ reactExports.createContext(null), BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function PickerTrigger(a) {
  var s = a.popupElement, c = a.popupStyle, u = a.popupClassName, d = a.popupAlign, p = a.transitionName, v = a.getPopupContainer, A = a.children, x = a.range, g = a.placement, b = a.builtinPlacements, y = b === void 0 ? BUILT_IN_PLACEMENTS : b, f = a.direction, m = a.visible, C = a.onClose, w = reactExports.useContext(PickerContext), S = w.prefixCls, $ = "".concat(S, "-dropdown"), T = getRealPlacement(g, f === "rtl");
  return /* @__PURE__ */ reactExports.createElement(Trigger$1, {
    showAction: [],
    hideAction: ["click"],
    popupPlacement: T,
    builtinPlacements: y,
    prefixCls: $,
    popupTransitionName: p,
    popup: s,
    popupAlign: d,
    popupVisible: m,
    popupClassName: classnames(u, _defineProperty$a(_defineProperty$a({}, "".concat($, "-range"), x), "".concat($, "-rtl"), f === "rtl")),
    popupStyle: c,
    stretch: "minWidth",
    getPopupContainer: v,
    onPopupVisibleChange: function(_) {
      _ || C();
    }
  }, A);
}
function leftPad(a, s) {
  for (var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", u = String(a); u.length < s; )
    u = "".concat(c).concat(u);
  return u;
}
function toArray$4(a) {
  return a == null ? [] : Array.isArray(a) ? a : [a];
}
function fillIndex(a, s, c) {
  var u = _toConsumableArray$e(a);
  return u[s] = c, u;
}
function pickProps(a, s) {
  var c = {}, u = s || Object.keys(a);
  return u.forEach(function(d) {
    a[d] !== void 0 && (c[d] = a[d]);
  }), c;
}
function getRowFormat(a, s, c) {
  if (c)
    return c;
  switch (a) {
    // All from the `locale.fieldXXXFormat` first
    case "time":
      return s.fieldTimeFormat;
    case "datetime":
      return s.fieldDateTimeFormat;
    case "month":
      return s.fieldMonthFormat;
    case "year":
      return s.fieldYearFormat;
    case "quarter":
      return s.fieldQuarterFormat;
    case "week":
      return s.fieldWeekFormat;
    default:
      return s.fieldDateFormat;
  }
}
function getFromDate(a, s, c) {
  var u = c !== void 0 ? c : s[s.length - 1], d = s.find(function(p) {
    return a[p];
  });
  return u !== d ? a[d] : void 0;
}
function pickTriggerProps(a) {
  return pickProps(a, ["placement", "builtinPlacements", "popupAlign", "getPopupContainer", "transitionName", "direction"]);
}
function useCellRender$1(a, s, c, u) {
  var d = reactExports.useMemo(function() {
    return a || function(v, A) {
      var x = v;
      return s && A.type === "date" ? s(x, A.today) : c && A.type === "month" ? c(x, A.locale) : A.originNode;
    };
  }, [a, c, s]), p = reactExports.useCallback(function(v, A) {
    return d(v, _objectSpread2$1(_objectSpread2$1({}, A), {}, {
      range: u
    }));
  }, [d, u]);
  return p;
}
function useFieldsInvalidate(a, s) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], u = reactExports.useState([!1, !1]), d = _slicedToArray$e(u, 2), p = d[0], v = d[1], A = function(b, y) {
    v(function(f) {
      return fillIndex(f, y, b);
    });
  }, x = reactExports.useMemo(function() {
    return p.map(function(g, b) {
      if (g)
        return !0;
      var y = a[b];
      return y ? !!(!c[b] && !y || y && s(y, {
        activeIndex: b
      })) : !1;
    });
  }, [a, p, s, c]);
  return [x, A];
}
function fillTimeFormat(a, s, c, u, d) {
  var p = "", v = [];
  return a && v.push(d ? "hh" : "HH"), s && v.push("mm"), c && v.push("ss"), p = v.join(":"), u && (p += ".SSS"), d && (p += " A"), p;
}
function fillLocale(a, s, c, u, d, p) {
  var v = a.fieldDateTimeFormat, A = a.fieldDateFormat, x = a.fieldTimeFormat, g = a.fieldMonthFormat, b = a.fieldYearFormat, y = a.fieldWeekFormat, f = a.fieldQuarterFormat, m = a.yearFormat, C = a.cellYearFormat, w = a.cellQuarterFormat, S = a.dayFormat, $ = a.cellDateFormat, T = fillTimeFormat(s, c, u, d, p);
  return _objectSpread2$1(_objectSpread2$1({}, a), {}, {
    fieldDateTimeFormat: v || "YYYY-MM-DD ".concat(T),
    fieldDateFormat: A || "YYYY-MM-DD",
    fieldTimeFormat: x || T,
    fieldMonthFormat: g || "YYYY-MM",
    fieldYearFormat: b || "YYYY",
    fieldWeekFormat: y || "gggg-wo",
    fieldQuarterFormat: f || "YYYY-[Q]Q",
    yearFormat: m || "YYYY",
    cellYearFormat: C || "YYYY",
    cellQuarterFormat: w || "[Q]Q",
    cellDateFormat: $ || S || "D"
  });
}
function useLocale(a, s) {
  var c = s.showHour, u = s.showMinute, d = s.showSecond, p = s.showMillisecond, v = s.use12Hours;
  return React.useMemo(function() {
    return fillLocale(a, c, u, d, p, v);
  }, [a, c, u, d, p, v]);
}
function checkShow(a, s, c) {
  return c ?? s.some(function(u) {
    return a.includes(u);
  });
}
var showTimeKeys = [
  // 'format',
  "showNow",
  "showHour",
  "showMinute",
  "showSecond",
  "showMillisecond",
  "use12Hours",
  "hourStep",
  "minuteStep",
  "secondStep",
  "millisecondStep",
  "hideDisabledOptions",
  "defaultValue",
  "disabledHours",
  "disabledMinutes",
  "disabledSeconds",
  "disabledMilliseconds",
  "disabledTime",
  "changeOnScroll",
  "defaultOpenValue"
];
function pickTimeProps(a) {
  var s = pickProps(a, showTimeKeys), c = a.format, u = a.picker, d = null;
  return c && (d = c, Array.isArray(d) && (d = d[0]), d = _typeof$h(d) === "object" ? d.format : d), u === "time" && (s.format = d), [s, d];
}
function isStringFormat(a) {
  return a && typeof a == "string";
}
function existShowConfig(a, s, c, u) {
  return [a, s, c, u].some(function(d) {
    return d !== void 0;
  });
}
function fillShowConfig(a, s, c, u, d) {
  var p = s, v = c, A = u;
  if (!a && !p && !v && !A && !d)
    p = !0, v = !0, A = !0;
  else if (a) {
    var x, g, b, y = [p, v, A].some(function(C) {
      return C === !1;
    }), f = [p, v, A].some(function(C) {
      return C === !0;
    }), m = y ? !0 : !f;
    p = (x = p) !== null && x !== void 0 ? x : m, v = (g = v) !== null && g !== void 0 ? g : m, A = (b = A) !== null && b !== void 0 ? b : m;
  }
  return [p, v, A, d];
}
function getTimeProps(a) {
  var s = a.showTime, c = pickTimeProps(a), u = _slicedToArray$e(c, 2), d = u[0], p = u[1], v = s && _typeof$h(s) === "object" ? s : {}, A = _objectSpread2$1(_objectSpread2$1({
    defaultOpenValue: v.defaultOpenValue || v.defaultValue
  }, d), v), x = A.showMillisecond, g = A.showHour, b = A.showMinute, y = A.showSecond, f = existShowConfig(g, b, y, x), m = fillShowConfig(f, g, b, y, x), C = _slicedToArray$e(m, 3);
  return g = C[0], b = C[1], y = C[2], [A, _objectSpread2$1(_objectSpread2$1({}, A), {}, {
    showHour: g,
    showMinute: b,
    showSecond: y,
    showMillisecond: x
  }), A.format, p];
}
function fillShowTimeConfig(a, s, c, u, d) {
  var p = a === "time";
  if (a === "datetime" || p) {
    for (var v = u, A = getRowFormat(a, d, null), x = A, g = [s, c], b = 0; b < g.length; b += 1) {
      var y = toArray$4(g[b])[0];
      if (isStringFormat(y)) {
        x = y;
        break;
      }
    }
    var f = v.showHour, m = v.showMinute, C = v.showSecond, w = v.showMillisecond, S = v.use12Hours, $ = checkShow(x, ["a", "A", "LT", "LLL", "LTS"], S), T = existShowConfig(f, m, C, w);
    T || (f = checkShow(x, ["H", "h", "k", "LT", "LLL"]), m = checkShow(x, ["m", "LT", "LLL"]), C = checkShow(x, ["s", "LTS"]), w = checkShow(x, ["SSS"]));
    var I = fillShowConfig(T, f, m, C, w), _ = _slicedToArray$e(I, 3);
    f = _[0], m = _[1], C = _[2];
    var E = s || fillTimeFormat(f, m, C, w, $);
    return _objectSpread2$1(_objectSpread2$1({}, v), {}, {
      // Format
      format: E,
      // Show Config
      showHour: f,
      showMinute: m,
      showSecond: C,
      showMillisecond: w,
      use12Hours: $
    });
  }
  return null;
}
function fillClearIcon(a, s, c) {
  if (s === !1)
    return null;
  var u = s && _typeof$h(s) === "object" ? s : {};
  return u.clearIcon || c || /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(a, "-clear-btn")
  });
}
var WEEK_DAY_COUNT = 7;
function nullableCompare(a, s, c) {
  return !a && !s || a === s ? !0 : !a || !s ? !1 : c();
}
function isSameDecade(a, s, c) {
  return nullableCompare(s, c, function() {
    var u = Math.floor(a.getYear(s) / 10), d = Math.floor(a.getYear(c) / 10);
    return u === d;
  });
}
function isSameYear(a, s, c) {
  return nullableCompare(s, c, function() {
    return a.getYear(s) === a.getYear(c);
  });
}
function getQuarter(a, s) {
  var c = Math.floor(a.getMonth(s) / 3);
  return c + 1;
}
function isSameQuarter(a, s, c) {
  return nullableCompare(s, c, function() {
    return isSameYear(a, s, c) && getQuarter(a, s) === getQuarter(a, c);
  });
}
function isSameMonth(a, s, c) {
  return nullableCompare(s, c, function() {
    return isSameYear(a, s, c) && a.getMonth(s) === a.getMonth(c);
  });
}
function isSameDate(a, s, c) {
  return nullableCompare(s, c, function() {
    return isSameYear(a, s, c) && isSameMonth(a, s, c) && a.getDate(s) === a.getDate(c);
  });
}
function isSameTime(a, s, c) {
  return nullableCompare(s, c, function() {
    return a.getHour(s) === a.getHour(c) && a.getMinute(s) === a.getMinute(c) && a.getSecond(s) === a.getSecond(c);
  });
}
function isSameTimestamp(a, s, c) {
  return nullableCompare(s, c, function() {
    return isSameDate(a, s, c) && isSameTime(a, s, c) && a.getMillisecond(s) === a.getMillisecond(c);
  });
}
function isSameWeek(a, s, c, u) {
  return nullableCompare(c, u, function() {
    var d = a.locale.getWeekFirstDate(s, c), p = a.locale.getWeekFirstDate(s, u);
    return isSameYear(a, d, p) && a.locale.getWeek(s, c) === a.locale.getWeek(s, u);
  });
}
function isSame(a, s, c, u, d) {
  switch (d) {
    case "date":
      return isSameDate(a, c, u);
    case "week":
      return isSameWeek(a, s.locale, c, u);
    case "month":
      return isSameMonth(a, c, u);
    case "quarter":
      return isSameQuarter(a, c, u);
    case "year":
      return isSameYear(a, c, u);
    case "decade":
      return isSameDecade(a, c, u);
    case "time":
      return isSameTime(a, c, u);
    default:
      return isSameTimestamp(a, c, u);
  }
}
function isInRange(a, s, c, u) {
  return !s || !c || !u ? !1 : a.isAfter(u, s) && a.isAfter(c, u);
}
function isSameOrAfter(a, s, c, u, d) {
  return isSame(a, s, c, u, d) ? !0 : a.isAfter(c, u);
}
function getWeekStartDate(a, s, c) {
  var u = s.locale.getWeekFirstDay(a), d = s.setDate(c, 1), p = s.getWeekDay(d), v = s.addDate(d, u - p);
  return s.getMonth(v) === s.getMonth(c) && s.getDate(v) > 1 && (v = s.addDate(v, -7)), v;
}
function formatValue(a, s) {
  var c = s.generateConfig, u = s.locale, d = s.format;
  return a ? typeof d == "function" ? d(a) : c.locale.format(u.locale, a, d) : "";
}
function fillTime(a, s, c) {
  var u = s, d = ["getHour", "getMinute", "getSecond", "getMillisecond"], p = ["setHour", "setMinute", "setSecond", "setMillisecond"];
  return p.forEach(function(v, A) {
    c ? u = a[v](u, a[d[A]](c)) : u = a[v](u, 0);
  }), u;
}
function useDisabledBoundary(a, s, c, u, d) {
  var p = useEvent(function(v, A) {
    return !!(c && c(v, A) || u && a.isAfter(u, v) && !isSame(a, s, u, v, A.type) || d && a.isAfter(v, d) && !isSame(a, s, d, v, A.type));
  });
  return p;
}
function useFieldFormat(a, s, c) {
  return reactExports.useMemo(function() {
    var u = getRowFormat(a, s, c), d = toArray$4(u), p = d[0], v = _typeof$h(p) === "object" && p.type === "mask" ? p.format : null;
    return [
      // Format list
      d.map(function(A) {
        return typeof A == "string" || typeof A == "function" ? A : A.format;
      }),
      // Mask Format
      v
    ];
  }, [a, s, c]);
}
function useInputReadOnly(a, s, c) {
  return typeof a[0] == "function" || c ? !0 : s;
}
function useInvalidate(a, s, c, u) {
  var d = useEvent(function(p, v) {
    var A = _objectSpread2$1({
      type: s
    }, v);
    if (delete A.activeIndex, // Date object is invalid
    !a.isValidate(p) || // Date is disabled by `disabledDate`
    c && c(p, A))
      return !0;
    if ((s === "date" || s === "time") && u) {
      var x, g = v && v.activeIndex === 1 ? "end" : "start", b = ((x = u.disabledTime) === null || x === void 0 ? void 0 : x.call(u, p, g, {
        from: A.from
      })) || {}, y = b.disabledHours, f = b.disabledMinutes, m = b.disabledSeconds, C = b.disabledMilliseconds, w = u.disabledHours, S = u.disabledMinutes, $ = u.disabledSeconds, T = y || w, I = f || S, _ = m || $, E = a.getHour(p), R = a.getMinute(p), O = a.getSecond(p), L = a.getMillisecond(p);
      if (T && T().includes(E) || I && I(E).includes(R) || _ && _(E, R).includes(O) || C && C(E, R, O).includes(L))
        return !0;
    }
    return !1;
  });
  return d;
}
function useList(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = reactExports.useMemo(function() {
    var u = a && toArray$4(a);
    return s && u && (u[1] = u[1] || u[0]), u;
  }, [a, s]);
  return c;
}
function useFilledProps(a, s) {
  var c = a.generateConfig, u = a.locale, d = a.picker, p = d === void 0 ? "date" : d, v = a.prefixCls, A = v === void 0 ? "rc-picker" : v, x = a.styles, g = x === void 0 ? {} : x, b = a.classNames, y = b === void 0 ? {} : b, f = a.order, m = f === void 0 ? !0 : f, C = a.components, w = C === void 0 ? {} : C, S = a.inputRender, $ = a.allowClear, T = a.clearIcon, I = a.needConfirm, _ = a.multiple, E = a.format, R = a.inputReadOnly, O = a.disabledDate, L = a.minDate, B = a.maxDate, F = a.showTime, M = a.value, W = a.defaultValue, j = a.pickerValue, G = a.defaultPickerValue, U = useList(M), k = useList(W), N = useList(j), P = useList(G), D = p === "date" && F ? "datetime" : p, H = D === "time" || D === "datetime", V = H || _, Z = I ?? H, ne = getTimeProps(a), K = _slicedToArray$e(ne, 4), q = K[0], Y = K[1], ee = K[2], Q = K[3], J = useLocale(u, Y), te = reactExports.useMemo(function() {
    return fillShowTimeConfig(D, ee, Q, q, J);
  }, [D, ee, Q, q, J]), ae = reactExports.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, a), {}, {
      prefixCls: A,
      locale: J,
      picker: p,
      styles: g,
      classNames: y,
      order: m,
      components: _objectSpread2$1({
        input: S
      }, w),
      clearIcon: fillClearIcon(A, $, T),
      showTime: te,
      value: U,
      defaultValue: k,
      pickerValue: N,
      defaultPickerValue: P
    }, s?.());
  }, [a]), se = useFieldFormat(D, J, E), ie = _slicedToArray$e(se, 2), fe = ie[0], ge = ie[1], me = useInputReadOnly(fe, R, _), pe = useDisabledBoundary(c, u, O, L, B), be = useInvalidate(c, p, pe, te), le = reactExports.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, ae), {}, {
      needConfirm: Z,
      inputReadOnly: me,
      disabledDate: pe
    });
  }, [ae, Z, me, pe]);
  return [le, D, V, fe, ge, be];
}
function useDelayState(a, s, c) {
  var u = useMergedState(s, {
    value: a
  }), d = _slicedToArray$e(u, 2), p = d[0], v = d[1], A = React.useRef(a), x = React.useRef(), g = function() {
    wrapperRaf.cancel(x.current);
  }, b = useEvent(function() {
    v(A.current), c && p !== A.current && c(A.current);
  }), y = useEvent(function(f, m) {
    g(), A.current = f, f || m ? b() : x.current = wrapperRaf(b);
  });
  return React.useEffect(function() {
    return g;
  }, []), [p, y];
}
function useOpen(a, s) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], u = arguments.length > 3 ? arguments[3] : void 0, d = c.every(function(b) {
    return b;
  }) ? !1 : a, p = useDelayState(d, s || !1, u), v = _slicedToArray$e(p, 2), A = v[0], x = v[1];
  function g(b) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (!y.inherit || A) && x(b, y.force);
  }
  return [A, g];
}
function usePickerRef(a) {
  var s = reactExports.useRef();
  return reactExports.useImperativeHandle(a, function() {
    var c;
    return {
      nativeElement: (c = s.current) === null || c === void 0 ? void 0 : c.nativeElement,
      focus: function(d) {
        var p;
        (p = s.current) === null || p === void 0 || p.focus(d);
      },
      blur: function() {
        var d;
        (d = s.current) === null || d === void 0 || d.blur();
      }
    };
  }), s;
}
function usePresets(a, s) {
  return reactExports.useMemo(function() {
    return a || (s ? (warningOnce(!1, "`ranges` is deprecated. Please use `presets` instead."), Object.entries(s).map(function(c) {
      var u = _slicedToArray$e(c, 2), d = u[0], p = u[1];
      return {
        label: d,
        value: p
      };
    })) : []);
  }, [a, s]);
}
function useLockEffect(a, s) {
  var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, u = reactExports.useRef(s);
  u.current = s, useLayoutUpdateEffect(function() {
    if (a)
      u.current(a);
    else {
      var d = wrapperRaf(function() {
        u.current(a);
      }, c);
      return function() {
        wrapperRaf.cancel(d);
      };
    }
  }, [a]);
}
function useRangeActive(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, u = reactExports.useState(0), d = _slicedToArray$e(u, 2), p = d[0], v = d[1], A = reactExports.useState(!1), x = _slicedToArray$e(A, 2), g = x[0], b = x[1], y = reactExports.useRef([]), f = reactExports.useRef(null), m = reactExports.useRef(null), C = function(_) {
    f.current = _;
  }, w = function(_) {
    return f.current === _;
  }, S = function(_) {
    b(_);
  }, $ = function(_) {
    return _ && (m.current = _), m.current;
  }, T = function(_) {
    var E = y.current, R = new Set(E.filter(function(L) {
      return _[L] || s[L];
    })), O = E[E.length - 1] === 0 ? 1 : 0;
    return R.size >= 2 || a[O] ? null : O;
  };
  return useLockEffect(g || c, function() {
    g || (y.current = [], C(null));
  }), reactExports.useEffect(function() {
    g && y.current.push(p);
  }, [g, p]), [g, S, $, p, v, T, y.current, C, w];
}
function useRangeDisabledDate(a, s, c, u, d, p) {
  var v = c[c.length - 1], A = function(g, b) {
    var y = _slicedToArray$e(a, 2), f = y[0], m = y[1], C = _objectSpread2$1(_objectSpread2$1({}, b), {}, {
      from: getFromDate(a, c)
    });
    return v === 1 && s[0] && f && // Same date isOK
    !isSame(u, d, f, g, C.type) && // Before start date
    u.isAfter(f, g) || v === 0 && s[1] && m && // Same date isOK
    !isSame(u, d, m, g, C.type) && // After end date
    u.isAfter(g, m) ? !0 : p?.(g, C);
  };
  return A;
}
function offsetPanelDate(a, s, c, u) {
  switch (s) {
    case "date":
    case "week":
      return a.addMonth(c, u);
    case "month":
    case "quarter":
      return a.addYear(c, u);
    case "year":
      return a.addYear(c, u * 10);
    case "decade":
      return a.addYear(c, u * 100);
    default:
      return c;
  }
}
var EMPTY_LIST$3 = [];
function useRangePickerValue(a, s, c, u, d, p, v, A) {
  var x = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : EMPTY_LIST$3, g = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : EMPTY_LIST$3, b = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : EMPTY_LIST$3, y = arguments.length > 11 ? arguments[11] : void 0, f = arguments.length > 12 ? arguments[12] : void 0, m = arguments.length > 13 ? arguments[13] : void 0, C = v === "time", w = p || 0, S = function(N) {
    var P = a.getNow();
    return C && (P = fillTime(a, P)), x[N] || c[N] || P;
  }, $ = _slicedToArray$e(g, 2), T = $[0], I = $[1], _ = useMergedState(function() {
    return S(0);
  }, {
    value: T
  }), E = _slicedToArray$e(_, 2), R = E[0], O = E[1], L = useMergedState(function() {
    return S(1);
  }, {
    value: I
  }), B = _slicedToArray$e(L, 2), F = B[0], M = B[1], W = reactExports.useMemo(function() {
    var k = [R, F][w];
    return C ? k : fillTime(a, k, b[w]);
  }, [C, R, F, w, a, b]), j = function(N) {
    var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "panel", D = [O, M][w];
    D(N);
    var H = [R, F];
    H[w] = N, y && (!isSame(a, s, R, H[0], v) || !isSame(a, s, F, H[1], v)) && y(H, {
      source: P,
      range: w === 1 ? "end" : "start",
      mode: u
    });
  }, G = function(N, P) {
    if (A) {
      var D = {
        date: "month",
        week: "month",
        month: "year",
        quarter: "year"
      }, H = D[v];
      if (H && !isSame(a, s, N, P, H))
        return offsetPanelDate(a, v, P, -1);
      if (v === "year" && N) {
        var V = Math.floor(a.getYear(N) / 10), Z = Math.floor(a.getYear(P) / 10);
        if (V !== Z)
          return offsetPanelDate(a, v, P, -1);
      }
    }
    return P;
  }, U = reactExports.useRef(null);
  return useLayoutEffect$1(function() {
    if (d && !x[w]) {
      var k = C ? null : a.getNow();
      if (U.current !== null && U.current !== w ? k = [R, F][w ^ 1] : c[w] ? k = w === 0 ? c[0] : G(c[0], c[1]) : c[w ^ 1] && (k = c[w ^ 1]), k) {
        f && a.isAfter(f, k) && (k = f);
        var N = A ? offsetPanelDate(a, v, k, 1) : k;
        m && a.isAfter(N, m) && (k = A ? offsetPanelDate(a, v, m, -1) : m), j(k, "reset");
      }
    }
  }, [d, w, c[w]]), reactExports.useEffect(function() {
    d ? U.current = w : U.current = null;
  }, [d, w]), useLayoutEffect$1(function() {
    d && x && x[w] && j(x[w], "reset");
  }, [d, w]), [W, j];
}
function useSyncState$2(a, s) {
  var c = reactExports.useRef(a), u = reactExports.useState({}), d = _slicedToArray$e(u, 2), p = d[1], v = function(g) {
    return g && s !== void 0 ? s : c.current;
  }, A = function(g) {
    c.current = g, p({});
  };
  return [v, A, v(!0)];
}
var EMPTY_VALUE = [];
function useUtil(a, s, c) {
  var u = function(v) {
    return v.map(function(A) {
      return formatValue(A, {
        generateConfig: a,
        locale: s,
        format: c[0]
      });
    });
  }, d = function(v, A) {
    for (var x = Math.max(v.length, A.length), g = -1, b = 0; b < x; b += 1) {
      var y = v[b] || null, f = A[b] || null;
      if (y !== f && !isSameTimestamp(a, y, f)) {
        g = b;
        break;
      }
    }
    return [g < 0, g !== 0];
  };
  return [u, d];
}
function orderDates(a, s) {
  return _toConsumableArray$e(a).sort(function(c, u) {
    return s.isAfter(c, u) ? 1 : -1;
  });
}
function useCalendarValue(a) {
  var s = useSyncState$2(a), c = _slicedToArray$e(s, 2), u = c[0], d = c[1], p = useEvent(function() {
    d(a);
  });
  return reactExports.useEffect(function() {
    p();
  }, [a]), [u, d];
}
function useInnerValue(a, s, c, u, d, p, v, A, x) {
  var g = useMergedState(p, {
    value: v
  }), b = _slicedToArray$e(g, 2), y = b[0], f = b[1], m = y || EMPTY_VALUE, C = useCalendarValue(m), w = _slicedToArray$e(C, 2), S = w[0], $ = w[1], T = useUtil(a, s, c), I = _slicedToArray$e(T, 2), _ = I[0], E = I[1], R = useEvent(function(L) {
    var B = _toConsumableArray$e(L);
    if (u)
      for (var F = 0; F < 2; F += 1)
        B[F] = B[F] || null;
    else d && (B = orderDates(B.filter(function(k) {
      return k;
    }), a));
    var M = E(S(), B), W = _slicedToArray$e(M, 2), j = W[0], G = W[1];
    if (!j && ($(B), A)) {
      var U = _(B);
      A(B, U, {
        range: G ? "end" : "start"
      });
    }
  }), O = function() {
    x && x(S());
  };
  return [m, f, S, R, O];
}
function useRangeValue(a, s, c, u, d, p, v, A, x, g) {
  var b = a.generateConfig, y = a.locale, f = a.picker, m = a.onChange, C = a.allowEmpty, w = a.order, S = p.some(function(j) {
    return j;
  }) ? !1 : w, $ = useUtil(b, y, v), T = _slicedToArray$e($, 2), I = T[0], _ = T[1], E = useSyncState$2(s), R = _slicedToArray$e(E, 2), O = R[0], L = R[1], B = useEvent(function() {
    L(s);
  });
  reactExports.useEffect(function() {
    B();
  }, [s]);
  var F = useEvent(function(j) {
    var G = j === null, U = _toConsumableArray$e(j || O());
    if (G)
      for (var k = Math.max(p.length, U.length), N = 0; N < k; N += 1)
        p[N] || (U[N] = null);
    S && U[0] && U[1] && (U = orderDates(U, b)), d(U);
    var P = U, D = _slicedToArray$e(P, 2), H = D[0], V = D[1], Z = !H, ne = !V, K = C ? (
      // Validate empty start
      (!Z || C[0]) && // Validate empty end
      (!ne || C[1])
    ) : !0, q = !w || Z || ne || isSame(b, y, H, V, f) || b.isAfter(V, H), Y = (
      // Validate start
      (p[0] || !H || !g(H, {
        activeIndex: 0
      })) && // Validate end
      (p[1] || !V || !g(V, {
        from: H,
        activeIndex: 1
      }))
    ), ee = (
      // Null value is from clear button
      G || // Normal check
      K && q && Y
    );
    if (ee) {
      c(U);
      var Q = _(U, s), J = _slicedToArray$e(Q, 1), te = J[0];
      m && !te && m(
        // Return null directly if all date are empty
        G && U.every(function(ae) {
          return !ae;
        }) ? null : U,
        I(U)
      );
    }
    return ee;
  }), M = useEvent(function(j, G) {
    var U = fillIndex(O(), j, u()[j]);
    L(U), G && F();
  }), W = !A && !x;
  return useLockEffect(!W, function() {
    W && (F(), d(s), B());
  }, 2), [M, F];
}
function useShowNow(a, s, c, u, d) {
  return s !== "date" && s !== "time" ? !1 : c !== void 0 ? c : u !== void 0 ? u : !d && (a === "date" || a === "time");
}
function findValidateTime(a, s, c, u, d, p) {
  var v = a;
  function A(y, f, m) {
    var C = p[y](v), w = m.find(function(I) {
      return I.value === C;
    });
    if (!w || w.disabled) {
      var S = m.filter(function(I) {
        return !I.disabled;
      }), $ = _toConsumableArray$e(S).reverse(), T = $.find(function(I) {
        return I.value <= C;
      }) || S[0];
      T && (C = T.value, v = p[f](v, C));
    }
    return C;
  }
  var x = A("getHour", "setHour", s()), g = A("getMinute", "setMinute", c(x)), b = A("getSecond", "setSecond", u(x, g));
  return A("getMillisecond", "setMillisecond", d(x, g, b)), v;
}
function emptyDisabled() {
  return [];
}
function generateUnits(a, s) {
  for (var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, d = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], p = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2, v = [], A = c >= 1 ? c | 0 : 1, x = a; x <= s; x += A) {
    var g = d.includes(x);
    (!g || !u) && v.push({
      label: leftPad(x, p),
      value: x,
      disabled: g
    });
  }
  return v;
}
function useTimeInfo(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = arguments.length > 2 ? arguments[2] : void 0, u = s || {}, d = u.use12Hours, p = u.hourStep, v = p === void 0 ? 1 : p, A = u.minuteStep, x = A === void 0 ? 1 : A, g = u.secondStep, b = g === void 0 ? 1 : g, y = u.millisecondStep, f = y === void 0 ? 100 : y, m = u.hideDisabledOptions, C = u.disabledTime, w = u.disabledHours, S = u.disabledMinutes, $ = u.disabledSeconds, T = reactExports.useMemo(function() {
    return c || a.getNow();
  }, [c, a]), I = reactExports.useCallback(function(P) {
    var D = C?.(P) || {};
    return [D.disabledHours || w || emptyDisabled, D.disabledMinutes || S || emptyDisabled, D.disabledSeconds || $ || emptyDisabled, D.disabledMilliseconds || emptyDisabled];
  }, [C, w, S, $]), _ = reactExports.useMemo(function() {
    return I(T);
  }, [T, I]), E = _slicedToArray$e(_, 4), R = E[0], O = E[1], L = E[2], B = E[3], F = reactExports.useCallback(function(P, D, H, V) {
    var Z = generateUnits(0, 23, v, m, P()), ne = d ? Z.map(function(ee) {
      return _objectSpread2$1(_objectSpread2$1({}, ee), {}, {
        label: leftPad(ee.value % 12 || 12, 2)
      });
    }) : Z, K = function(Q) {
      return generateUnits(0, 59, x, m, D(Q));
    }, q = function(Q, J) {
      return generateUnits(0, 59, b, m, H(Q, J));
    }, Y = function(Q, J, te) {
      return generateUnits(0, 999, f, m, V(Q, J, te), 3);
    };
    return [ne, K, q, Y];
  }, [m, v, d, f, x, b]), M = reactExports.useMemo(function() {
    return F(R, O, L, B);
  }, [F, R, O, L, B]), W = _slicedToArray$e(M, 4), j = W[0], G = W[1], U = W[2], k = W[3], N = function(D, H) {
    var V = function() {
      return j;
    }, Z = G, ne = U, K = k;
    if (H) {
      var q = I(H), Y = _slicedToArray$e(q, 4), ee = Y[0], Q = Y[1], J = Y[2], te = Y[3], ae = F(ee, Q, J, te), se = _slicedToArray$e(ae, 4), ie = se[0], fe = se[1], ge = se[2], me = se[3];
      V = function() {
        return ie;
      }, Z = fe, ne = ge, K = me;
    }
    var pe = findValidateTime(D, V, Z, ne, K, a);
    return pe;
  };
  return [
    // getValidTime
    N,
    // Units
    j,
    G,
    U,
    k
  ];
}
function Footer$2(a) {
  var s = a.mode, c = a.internalMode, u = a.renderExtraFooter, d = a.showNow, p = a.showTime, v = a.onSubmit, A = a.onNow, x = a.invalid, g = a.needConfirm, b = a.generateConfig, y = a.disabledDate, f = reactExports.useContext(PickerContext), m = f.prefixCls, C = f.locale, w = f.button, S = w === void 0 ? "button" : w, $ = b.getNow(), T = useTimeInfo(b, p, $), I = _slicedToArray$e(T, 1), _ = I[0], E = u?.(s), R = y($, {
    type: s
  }), O = function() {
    if (!R) {
      var G = _($);
      A(G);
    }
  }, L = "".concat(m, "-now"), B = "".concat(L, "-btn"), F = d && /* @__PURE__ */ reactExports.createElement("li", {
    className: L
  }, /* @__PURE__ */ reactExports.createElement("a", {
    className: classnames(B, R && "".concat(B, "-disabled")),
    "aria-disabled": R,
    onClick: O
  }, c === "date" ? C.today : C.now)), M = g && /* @__PURE__ */ reactExports.createElement("li", {
    className: "".concat(m, "-ok")
  }, /* @__PURE__ */ reactExports.createElement(S, {
    disabled: x,
    onClick: v
  }, C.ok)), W = (F || M) && /* @__PURE__ */ reactExports.createElement("ul", {
    className: "".concat(m, "-ranges")
  }, F, M);
  return !E && !W ? null : /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(m, "-footer")
  }, E && /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(m, "-footer-extra")
  }, E), W);
}
function useToggleDates(a, s, c) {
  function u(d, p) {
    var v = d.findIndex(function(x) {
      return isSame(a, s, x, p, c);
    });
    if (v === -1)
      return [].concat(_toConsumableArray$e(d), [p]);
    var A = _toConsumableArray$e(d);
    return A.splice(v, 1), A;
  }
  return u;
}
var PanelContext = /* @__PURE__ */ reactExports.createContext(null);
function usePanelContext() {
  return reactExports.useContext(PanelContext);
}
function useInfo(a, s) {
  var c = a.prefixCls, u = a.generateConfig, d = a.locale, p = a.disabledDate, v = a.minDate, A = a.maxDate, x = a.cellRender, g = a.hoverValue, b = a.hoverRangeValue, y = a.onHover, f = a.values, m = a.pickerValue, C = a.onSelect, w = a.prevIcon, S = a.nextIcon, $ = a.superPrevIcon, T = a.superNextIcon, I = u.getNow(), _ = {
    now: I,
    values: f,
    pickerValue: m,
    prefixCls: c,
    disabledDate: p,
    minDate: v,
    maxDate: A,
    cellRender: x,
    hoverValue: g,
    hoverRangeValue: b,
    onHover: y,
    locale: d,
    generateConfig: u,
    onSelect: C,
    panelType: s,
    // Icons
    prevIcon: w,
    nextIcon: S,
    superPrevIcon: $,
    superNextIcon: T
  };
  return [_, I];
}
var PickerHackContext = /* @__PURE__ */ reactExports.createContext({});
function PanelBody(a) {
  for (var s = a.rowNum, c = a.colNum, u = a.baseDate, d = a.getCellDate, p = a.prefixColumn, v = a.rowClassName, A = a.titleFormat, x = a.getCellText, g = a.getCellClassName, b = a.headerCells, y = a.cellSelection, f = y === void 0 ? !0 : y, m = a.disabledDate, C = usePanelContext(), w = C.prefixCls, S = C.panelType, $ = C.now, T = C.disabledDate, I = C.cellRender, _ = C.onHover, E = C.hoverValue, R = C.hoverRangeValue, O = C.generateConfig, L = C.values, B = C.locale, F = C.onSelect, M = m || T, W = "".concat(w, "-cell"), j = reactExports.useContext(PickerHackContext), G = j.onCellDblClick, U = function(ne) {
    return L.some(function(K) {
      return K && isSame(O, B, ne, K, S);
    });
  }, k = [], N = 0; N < s; N += 1) {
    for (var P = [], D = void 0, H = function() {
      var ne = N * c + V, K = d(u, ne), q = M?.(K, {
        type: S
      });
      V === 0 && (D = K, p && P.push(p(D)));
      var Y = !1, ee = !1, Q = !1;
      if (f && R) {
        var J = _slicedToArray$e(R, 2), te = J[0], ae = J[1];
        Y = isInRange(O, te, ae, K), ee = isSame(O, B, K, te, S), Q = isSame(O, B, K, ae, S);
      }
      var se = A ? formatValue(K, {
        locale: B,
        format: A,
        generateConfig: O
      }) : void 0, ie = /* @__PURE__ */ reactExports.createElement("div", {
        className: "".concat(W, "-inner")
      }, x(K));
      P.push(/* @__PURE__ */ reactExports.createElement("td", {
        key: V,
        title: se,
        className: classnames(W, _objectSpread2$1(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(W, "-disabled"), q), "".concat(W, "-hover"), (E || []).some(function(fe) {
          return isSame(O, B, K, fe, S);
        })), "".concat(W, "-in-range"), Y && !ee && !Q), "".concat(W, "-range-start"), ee), "".concat(W, "-range-end"), Q), "".concat(w, "-cell-selected"), !R && // WeekPicker use row instead
        S !== "week" && U(K)), g(K))),
        onClick: function() {
          q || F(K);
        },
        onDoubleClick: function() {
          !q && G && G();
        },
        onMouseEnter: function() {
          q || _?.(K);
        },
        onMouseLeave: function() {
          q || _?.(null);
        }
      }, I ? I(K, {
        prefixCls: w,
        originNode: ie,
        today: $,
        type: S,
        locale: B
      }) : ie));
    }, V = 0; V < c; V += 1)
      H();
    k.push(/* @__PURE__ */ reactExports.createElement("tr", {
      key: N,
      className: v?.(D)
    }, P));
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(w, "-body")
  }, /* @__PURE__ */ reactExports.createElement("table", {
    className: "".concat(w, "-content")
  }, b && /* @__PURE__ */ reactExports.createElement("thead", null, /* @__PURE__ */ reactExports.createElement("tr", null, b)), /* @__PURE__ */ reactExports.createElement("tbody", null, k)));
}
var HIDDEN_STYLE$2 = {
  visibility: "hidden"
};
function PanelHeader(a) {
  var s = a.offset, c = a.superOffset, u = a.onChange, d = a.getStart, p = a.getEnd, v = a.children, A = usePanelContext(), x = A.prefixCls, g = A.prevIcon, b = g === void 0 ? "‹" : g, y = A.nextIcon, f = y === void 0 ? "›" : y, m = A.superPrevIcon, C = m === void 0 ? "«" : m, w = A.superNextIcon, S = w === void 0 ? "»" : w, $ = A.minDate, T = A.maxDate, I = A.generateConfig, _ = A.locale, E = A.pickerValue, R = A.panelType, O = "".concat(x, "-header"), L = reactExports.useContext(PickerHackContext), B = L.hidePrev, F = L.hideNext, M = L.hideHeader, W = reactExports.useMemo(function() {
    if (!$ || !s || !p)
      return !1;
    var Z = p(s(-1, E));
    return !isSameOrAfter(I, _, Z, $, R);
  }, [$, s, E, p, I, _, R]), j = reactExports.useMemo(function() {
    if (!$ || !c || !p)
      return !1;
    var Z = p(c(-1, E));
    return !isSameOrAfter(I, _, Z, $, R);
  }, [$, c, E, p, I, _, R]), G = reactExports.useMemo(function() {
    if (!T || !s || !d)
      return !1;
    var Z = d(s(1, E));
    return !isSameOrAfter(I, _, T, Z, R);
  }, [T, s, E, d, I, _, R]), U = reactExports.useMemo(function() {
    if (!T || !c || !d)
      return !1;
    var Z = d(c(1, E));
    return !isSameOrAfter(I, _, T, Z, R);
  }, [T, c, E, d, I, _, R]), k = function(ne) {
    s && u(s(ne, E));
  }, N = function(ne) {
    c && u(c(ne, E));
  };
  if (M)
    return null;
  var P = "".concat(O, "-prev-btn"), D = "".concat(O, "-next-btn"), H = "".concat(O, "-super-prev-btn"), V = "".concat(O, "-super-next-btn");
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: O
  }, c && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    "aria-label": _.previousYear,
    onClick: function() {
      return N(-1);
    },
    tabIndex: -1,
    className: classnames(H, j && "".concat(H, "-disabled")),
    disabled: j,
    style: B ? HIDDEN_STYLE$2 : {}
  }, C), s && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    "aria-label": _.previousMonth,
    onClick: function() {
      return k(-1);
    },
    tabIndex: -1,
    className: classnames(P, W && "".concat(P, "-disabled")),
    disabled: W,
    style: B ? HIDDEN_STYLE$2 : {}
  }, b), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(O, "-view")
  }, v), s && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    "aria-label": _.nextMonth,
    onClick: function() {
      return k(1);
    },
    tabIndex: -1,
    className: classnames(D, G && "".concat(D, "-disabled")),
    disabled: G,
    style: F ? HIDDEN_STYLE$2 : {}
  }, f), c && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    "aria-label": _.nextYear,
    onClick: function() {
      return N(1);
    },
    tabIndex: -1,
    className: classnames(V, U && "".concat(V, "-disabled")),
    disabled: U,
    style: F ? HIDDEN_STYLE$2 : {}
  }, S));
}
function DatePanel(a) {
  var s = a.prefixCls, c = a.panelName, u = c === void 0 ? "date" : c, d = a.locale, p = a.generateConfig, v = a.pickerValue, A = a.onPickerValueChange, x = a.onModeChange, g = a.mode, b = g === void 0 ? "date" : g, y = a.disabledDate, f = a.onSelect, m = a.onHover, C = a.showWeek, w = "".concat(s, "-").concat(u, "-panel"), S = "".concat(s, "-cell"), $ = b === "week", T = useInfo(a, b), I = _slicedToArray$e(T, 2), _ = I[0], E = I[1], R = p.locale.getWeekFirstDay(d.locale), O = p.setDate(v, 1), L = getWeekStartDate(d.locale, p, O), B = p.getMonth(v), F = C === void 0 ? $ : C, M = F ? function(Z) {
    var ne = y?.(Z, {
      type: "week"
    });
    return /* @__PURE__ */ reactExports.createElement("td", {
      key: "week",
      className: classnames(S, "".concat(S, "-week"), _defineProperty$a({}, "".concat(S, "-disabled"), ne)),
      onClick: function() {
        ne || f(Z);
      },
      onMouseEnter: function() {
        ne || m?.(Z);
      },
      onMouseLeave: function() {
        ne || m?.(null);
      }
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(S, "-inner")
    }, p.locale.getWeek(d.locale, Z)));
  } : null, W = [], j = d.shortWeekDays || (p.locale.getShortWeekDays ? p.locale.getShortWeekDays(d.locale) : []);
  M && W.push(/* @__PURE__ */ reactExports.createElement("th", {
    key: "empty"
  }, /* @__PURE__ */ reactExports.createElement("span", {
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, d.week)));
  for (var G = 0; G < WEEK_DAY_COUNT; G += 1)
    W.push(/* @__PURE__ */ reactExports.createElement("th", {
      key: G
    }, j[(G + R) % WEEK_DAY_COUNT]));
  var U = function(ne, K) {
    return p.addDate(ne, K);
  }, k = function(ne) {
    return formatValue(ne, {
      locale: d,
      format: d.cellDateFormat,
      generateConfig: p
    });
  }, N = function(ne) {
    var K = _defineProperty$a(_defineProperty$a({}, "".concat(s, "-cell-in-view"), isSameMonth(p, ne, v)), "".concat(s, "-cell-today"), isSameDate(p, ne, E));
    return K;
  }, P = d.shortMonths || (p.locale.getShortMonths ? p.locale.getShortMonths(d.locale) : []), D = /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    "aria-label": d.yearSelect,
    key: "year",
    onClick: function() {
      x("year", v);
    },
    tabIndex: -1,
    className: "".concat(s, "-year-btn")
  }, formatValue(v, {
    locale: d,
    format: d.yearFormat,
    generateConfig: p
  })), H = /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    "aria-label": d.monthSelect,
    key: "month",
    onClick: function() {
      x("month", v);
    },
    tabIndex: -1,
    className: "".concat(s, "-month-btn")
  }, d.monthFormat ? formatValue(v, {
    locale: d,
    format: d.monthFormat,
    generateConfig: p
  }) : P[B]), V = d.monthBeforeYear ? [H, D] : [D, H];
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: _
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(w, C && "".concat(w, "-show-week"))
  }, /* @__PURE__ */ reactExports.createElement(PanelHeader, {
    offset: function(ne) {
      return p.addMonth(v, ne);
    },
    superOffset: function(ne) {
      return p.addYear(v, ne);
    },
    onChange: A,
    getStart: function(ne) {
      return p.setDate(ne, 1);
    },
    getEnd: function(ne) {
      var K = p.setDate(ne, 1);
      return K = p.addMonth(K, 1), p.addDate(K, -1);
    }
  }, V), /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$3({
    titleFormat: d.fieldDateFormat
  }, a, {
    colNum: WEEK_DAY_COUNT,
    rowNum: 6,
    baseDate: L,
    headerCells: W,
    getCellDate: U,
    getCellText: k,
    getCellClassName: N,
    prefixColumn: M,
    cellSelection: !$
  }))));
}
var SPEED_PTG = 1 / 3;
function useScrollTo(a, s) {
  var c = reactExports.useRef(!1), u = reactExports.useRef(null), d = reactExports.useRef(null), p = function() {
    return c.current;
  }, v = function() {
    wrapperRaf.cancel(u.current), c.current = !1;
  }, A = reactExports.useRef(), x = function() {
    var y = a.current;
    if (d.current = null, A.current = 0, y) {
      var f = y.querySelector('[data-value="'.concat(s, '"]')), m = y.querySelector("li"), C = function w() {
        v(), c.current = !0, A.current += 1;
        var S = y.scrollTop, $ = m.offsetTop, T = f.offsetTop, I = T - $;
        if (T === 0 && f !== m || !isVisible(y)) {
          A.current <= 5 && (u.current = wrapperRaf(w));
          return;
        }
        var _ = S + (I - S) * SPEED_PTG, E = Math.abs(I - _);
        if (d.current !== null && d.current < E) {
          v();
          return;
        }
        if (d.current = E, E <= 1) {
          y.scrollTop = I, v();
          return;
        }
        y.scrollTop = _, u.current = wrapperRaf(w);
      };
      f && m && C();
    }
  }, g = useEvent(x);
  return [g, v, p];
}
var SCROLL_DELAY = 300;
function flattenUnits(a) {
  return a.map(function(s) {
    var c = s.value, u = s.label, d = s.disabled;
    return [c, u, d].join(",");
  }).join(";");
}
function TimeColumn(a) {
  var s = a.units, c = a.value, u = a.optionalValue, d = a.type, p = a.onChange, v = a.onHover, A = a.onDblClick, x = a.changeOnScroll, g = usePanelContext(), b = g.prefixCls, y = g.cellRender, f = g.now, m = g.locale, C = "".concat(b, "-time-panel"), w = "".concat(b, "-time-panel-cell"), S = reactExports.useRef(null), $ = reactExports.useRef(), T = function() {
    clearTimeout($.current);
  }, I = useScrollTo(S, c ?? u), _ = _slicedToArray$e(I, 3), E = _[0], R = _[1], O = _[2];
  useLayoutEffect$1(function() {
    return E(), T(), function() {
      R(), T();
    };
  }, [c, u, flattenUnits(s)]);
  var L = function(M) {
    T();
    var W = M.target;
    !O() && x && ($.current = setTimeout(function() {
      var j = S.current, G = j.querySelector("li").offsetTop, U = Array.from(j.querySelectorAll("li")), k = U.map(function(V) {
        return V.offsetTop - G;
      }), N = k.map(function(V, Z) {
        return s[Z].disabled ? Number.MAX_SAFE_INTEGER : Math.abs(V - W.scrollTop);
      }), P = Math.min.apply(Math, _toConsumableArray$e(N)), D = N.findIndex(function(V) {
        return V === P;
      }), H = s[D];
      H && !H.disabled && p(H.value);
    }, SCROLL_DELAY));
  }, B = "".concat(C, "-column");
  return /* @__PURE__ */ reactExports.createElement("ul", {
    className: B,
    ref: S,
    "data-type": d,
    onScroll: L
  }, s.map(function(F) {
    var M = F.label, W = F.value, j = F.disabled, G = /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(w, "-inner")
    }, M);
    return /* @__PURE__ */ reactExports.createElement("li", {
      key: W,
      className: classnames(w, _defineProperty$a(_defineProperty$a({}, "".concat(w, "-selected"), c === W), "".concat(w, "-disabled"), j)),
      onClick: function() {
        j || p(W);
      },
      onDoubleClick: function() {
        !j && A && A();
      },
      onMouseEnter: function() {
        v(W);
      },
      onMouseLeave: function() {
        v(null);
      },
      "data-value": W
    }, y ? y(W, {
      prefixCls: b,
      originNode: G,
      today: f,
      type: "time",
      subType: d,
      locale: m
    }) : G);
  }));
}
function isAM(a) {
  return a < 12;
}
function TimePanelBody(a) {
  var s = a.showHour, c = a.showMinute, u = a.showSecond, d = a.showMillisecond, p = a.use12Hours, v = a.changeOnScroll, A = usePanelContext(), x = A.prefixCls, g = A.values, b = A.generateConfig, y = A.locale, f = A.onSelect, m = A.onHover, C = m === void 0 ? function() {
  } : m, w = A.pickerValue, S = g?.[0] || null, $ = reactExports.useContext(PickerHackContext), T = $.onCellDblClick, I = useTimeInfo(b, a, S), _ = _slicedToArray$e(I, 5), E = _[0], R = _[1], O = _[2], L = _[3], B = _[4], F = function(Fe) {
    var Ue = S && b[Fe](S), je = w && b[Fe](w);
    return [Ue, je];
  }, M = F("getHour"), W = _slicedToArray$e(M, 2), j = W[0], G = W[1], U = F("getMinute"), k = _slicedToArray$e(U, 2), N = k[0], P = k[1], D = F("getSecond"), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = F("getMillisecond"), K = _slicedToArray$e(ne, 2), q = K[0], Y = K[1], ee = j === null ? null : isAM(j) ? "am" : "pm", Q = reactExports.useMemo(function() {
    return p ? isAM(j) ? R.filter(function(Me) {
      return isAM(Me.value);
    }) : R.filter(function(Me) {
      return !isAM(Me.value);
    }) : R;
  }, [j, R, p]), J = function(Fe, Ue) {
    var je, Le = Fe.filter(function(De) {
      return !De.disabled;
    });
    return Ue ?? // Fallback to enabled value
    (Le == null || (je = Le[0]) === null || je === void 0 ? void 0 : je.value);
  }, te = J(R, j), ae = reactExports.useMemo(function() {
    return O(te);
  }, [O, te]), se = J(ae, N), ie = reactExports.useMemo(function() {
    return L(te, se);
  }, [L, te, se]), fe = J(ie, V), ge = reactExports.useMemo(function() {
    return B(te, se, fe);
  }, [B, te, se, fe]), me = J(ge, q), pe = reactExports.useMemo(function() {
    if (!p)
      return [];
    var Me = b.getNow(), Fe = b.setHour(Me, 6), Ue = b.setHour(Me, 18), je = function(De, Ne) {
      var Ge = y.cellMeridiemFormat;
      return Ge ? formatValue(De, {
        generateConfig: b,
        locale: y,
        format: Ge
      }) : Ne;
    };
    return [{
      label: je(Fe, "AM"),
      value: "am",
      disabled: R.every(function(Le) {
        return Le.disabled || !isAM(Le.value);
      })
    }, {
      label: je(Ue, "PM"),
      value: "pm",
      disabled: R.every(function(Le) {
        return Le.disabled || isAM(Le.value);
      })
    }];
  }, [R, p, b, y]), be = function(Fe) {
    var Ue = E(Fe);
    f(Ue);
  }, le = reactExports.useMemo(function() {
    var Me = S || w || b.getNow(), Fe = function(je) {
      return je != null;
    };
    return Fe(j) ? (Me = b.setHour(Me, j), Me = b.setMinute(Me, N), Me = b.setSecond(Me, V), Me = b.setMillisecond(Me, q)) : Fe(G) ? (Me = b.setHour(Me, G), Me = b.setMinute(Me, P), Me = b.setSecond(Me, Z), Me = b.setMillisecond(Me, Y)) : Fe(te) && (Me = b.setHour(Me, te), Me = b.setMinute(Me, se), Me = b.setSecond(Me, fe), Me = b.setMillisecond(Me, me)), Me;
  }, [S, w, j, N, V, q, te, se, fe, me, G, P, Z, Y, b]), ve = function(Fe, Ue) {
    return Fe === null ? null : b[Ue](le, Fe);
  }, he = function(Fe) {
    return ve(Fe, "setHour");
  }, ye = function(Fe) {
    return ve(Fe, "setMinute");
  }, Ce = function(Fe) {
    return ve(Fe, "setSecond");
  }, xe = function(Fe) {
    return ve(Fe, "setMillisecond");
  }, we = function(Fe) {
    return Fe === null ? null : Fe === "am" && !isAM(j) ? b.setHour(le, j - 12) : Fe === "pm" && isAM(j) ? b.setHour(le, j + 12) : le;
  }, $e = function(Fe) {
    be(he(Fe));
  }, Ae = function(Fe) {
    be(ye(Fe));
  }, ue = function(Fe) {
    be(Ce(Fe));
  }, ce = function(Fe) {
    be(xe(Fe));
  }, Ee = function(Fe) {
    be(we(Fe));
  }, _e = function(Fe) {
    C(he(Fe));
  }, Te = function(Fe) {
    C(ye(Fe));
  }, ke = function(Fe) {
    C(Ce(Fe));
  }, Re = function(Fe) {
    C(xe(Fe));
  }, Be = function(Fe) {
    C(we(Fe));
  }, Oe = {
    onDblClick: T,
    changeOnScroll: v
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(x, "-content")
  }, s && /* @__PURE__ */ reactExports.createElement(TimeColumn, _extends$3({
    units: Q,
    value: j,
    optionalValue: G,
    type: "hour",
    onChange: $e,
    onHover: _e
  }, Oe)), c && /* @__PURE__ */ reactExports.createElement(TimeColumn, _extends$3({
    units: ae,
    value: N,
    optionalValue: P,
    type: "minute",
    onChange: Ae,
    onHover: Te
  }, Oe)), u && /* @__PURE__ */ reactExports.createElement(TimeColumn, _extends$3({
    units: ie,
    value: V,
    optionalValue: Z,
    type: "second",
    onChange: ue,
    onHover: ke
  }, Oe)), d && /* @__PURE__ */ reactExports.createElement(TimeColumn, _extends$3({
    units: ge,
    value: q,
    optionalValue: Y,
    type: "millisecond",
    onChange: ce,
    onHover: Re
  }, Oe)), p && /* @__PURE__ */ reactExports.createElement(TimeColumn, _extends$3({
    units: pe,
    value: ee,
    type: "meridiem",
    onChange: Ee,
    onHover: Be
  }, Oe)));
}
function TimePanel(a) {
  var s = a.prefixCls, c = a.value, u = a.locale, d = a.generateConfig, p = a.showTime, v = p || {}, A = v.format, x = "".concat(s, "-time-panel"), g = useInfo(a, "time"), b = _slicedToArray$e(g, 1), y = b[0];
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: y
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(x)
  }, /* @__PURE__ */ reactExports.createElement(PanelHeader, null, c ? formatValue(c, {
    locale: u,
    format: A,
    generateConfig: d
  }) : " "), /* @__PURE__ */ reactExports.createElement(TimePanelBody, p)));
}
function DateTimePanel(a) {
  var s = a.prefixCls, c = a.generateConfig, u = a.showTime, d = a.onSelect, p = a.value, v = a.pickerValue, A = a.onHover, x = "".concat(s, "-datetime-panel"), g = useTimeInfo(c, u), b = _slicedToArray$e(g, 1), y = b[0], f = function(S) {
    return p ? fillTime(c, S, p) : fillTime(c, S, v);
  }, m = function(S) {
    A?.(S && f(S));
  }, C = function(S) {
    var $ = f(S);
    d(y($, $));
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: x
  }, /* @__PURE__ */ reactExports.createElement(DatePanel, _extends$3({}, a, {
    onSelect: C,
    onHover: m
  })), /* @__PURE__ */ reactExports.createElement(TimePanel, a));
}
function DecadePanel(a) {
  var s = a.prefixCls, c = a.locale, u = a.generateConfig, d = a.pickerValue, p = a.disabledDate, v = a.onPickerValueChange, A = "".concat(s, "-decade-panel"), x = useInfo(a, "decade"), g = _slicedToArray$e(x, 1), b = g[0], y = function(R) {
    var O = Math.floor(u.getYear(R) / 100) * 100;
    return u.setYear(R, O);
  }, f = function(R) {
    var O = y(R);
    return u.addYear(O, 99);
  }, m = y(d), C = f(d), w = u.addYear(m, -10), S = function(R, O) {
    return u.addYear(R, O * 10);
  }, $ = function(R) {
    var O = c.cellYearFormat, L = formatValue(R, {
      locale: c,
      format: O,
      generateConfig: u
    }), B = formatValue(u.addYear(R, 9), {
      locale: c,
      format: O,
      generateConfig: u
    });
    return "".concat(L, "-").concat(B);
  }, T = function(R) {
    return _defineProperty$a({}, "".concat(s, "-cell-in-view"), isSameDecade(u, R, m) || isSameDecade(u, R, C) || isInRange(u, m, C, R));
  }, I = p ? function(E, R) {
    var O = u.setDate(E, 1), L = u.setMonth(O, 0), B = u.setYear(L, Math.floor(u.getYear(L) / 10) * 10), F = u.addYear(B, 10), M = u.addDate(F, -1);
    return p(B, R) && p(M, R);
  } : null, _ = "".concat(formatValue(m, {
    locale: c,
    format: c.yearFormat,
    generateConfig: u
  }), "-").concat(formatValue(C, {
    locale: c,
    format: c.yearFormat,
    generateConfig: u
  }));
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: b
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: A
  }, /* @__PURE__ */ reactExports.createElement(PanelHeader, {
    superOffset: function(R) {
      return u.addYear(d, R * 100);
    },
    onChange: v,
    getStart: y,
    getEnd: f
  }, _), /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$3({}, a, {
    disabledDate: I,
    colNum: 3,
    rowNum: 4,
    baseDate: w,
    getCellDate: S,
    getCellText: $,
    getCellClassName: T
  }))));
}
function MonthPanel(a) {
  var s = a.prefixCls, c = a.locale, u = a.generateConfig, d = a.pickerValue, p = a.disabledDate, v = a.onPickerValueChange, A = a.onModeChange, x = "".concat(s, "-month-panel"), g = useInfo(a, "month"), b = _slicedToArray$e(g, 1), y = b[0], f = u.setMonth(d, 0), m = c.shortMonths || (u.locale.getShortMonths ? u.locale.getShortMonths(c.locale) : []), C = function(_, E) {
    return u.addMonth(_, E);
  }, w = function(_) {
    var E = u.getMonth(_);
    return c.monthFormat ? formatValue(_, {
      locale: c,
      format: c.monthFormat,
      generateConfig: u
    }) : m[E];
  }, S = function() {
    return _defineProperty$a({}, "".concat(s, "-cell-in-view"), !0);
  }, $ = p ? function(I, _) {
    var E = u.setDate(I, 1), R = u.setMonth(E, u.getMonth(E) + 1), O = u.addDate(R, -1);
    return p(E, _) && p(O, _);
  } : null, T = /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": c.yearSelect,
    onClick: function() {
      A("year");
    },
    tabIndex: -1,
    className: "".concat(s, "-year-btn")
  }, formatValue(d, {
    locale: c,
    format: c.yearFormat,
    generateConfig: u
  }));
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: y
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: x
  }, /* @__PURE__ */ reactExports.createElement(PanelHeader, {
    superOffset: function(_) {
      return u.addYear(d, _);
    },
    onChange: v,
    getStart: function(_) {
      return u.setMonth(_, 0);
    },
    getEnd: function(_) {
      return u.setMonth(_, 11);
    }
  }, T), /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$3({}, a, {
    disabledDate: $,
    titleFormat: c.fieldMonthFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: f,
    getCellDate: C,
    getCellText: w,
    getCellClassName: S
  }))));
}
function QuarterPanel(a) {
  var s = a.prefixCls, c = a.locale, u = a.generateConfig, d = a.pickerValue, p = a.onPickerValueChange, v = a.onModeChange, A = "".concat(s, "-quarter-panel"), x = useInfo(a, "quarter"), g = _slicedToArray$e(x, 1), b = g[0], y = u.setMonth(d, 0), f = function($, T) {
    return u.addMonth($, T * 3);
  }, m = function($) {
    return formatValue($, {
      locale: c,
      format: c.cellQuarterFormat,
      generateConfig: u
    });
  }, C = function() {
    return _defineProperty$a({}, "".concat(s, "-cell-in-view"), !0);
  }, w = /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": c.yearSelect,
    onClick: function() {
      v("year");
    },
    tabIndex: -1,
    className: "".concat(s, "-year-btn")
  }, formatValue(d, {
    locale: c,
    format: c.yearFormat,
    generateConfig: u
  }));
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: b
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: A
  }, /* @__PURE__ */ reactExports.createElement(PanelHeader, {
    superOffset: function($) {
      return u.addYear(d, $);
    },
    onChange: p,
    getStart: function($) {
      return u.setMonth($, 0);
    },
    getEnd: function($) {
      return u.setMonth($, 11);
    }
  }, w), /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$3({}, a, {
    titleFormat: c.fieldQuarterFormat,
    colNum: 4,
    rowNum: 1,
    baseDate: y,
    getCellDate: f,
    getCellText: m,
    getCellClassName: C
  }))));
}
function WeekPanel(a) {
  var s = a.prefixCls, c = a.generateConfig, u = a.locale, d = a.value, p = a.hoverValue, v = a.hoverRangeValue, A = u.locale, x = "".concat(s, "-week-panel-row"), g = function(y) {
    var f = {};
    if (v) {
      var m = _slicedToArray$e(v, 2), C = m[0], w = m[1], S = isSameWeek(c, A, C, y), $ = isSameWeek(c, A, w, y);
      f["".concat(x, "-range-start")] = S, f["".concat(x, "-range-end")] = $, f["".concat(x, "-range-hover")] = !S && !$ && isInRange(c, C, w, y);
    }
    return p && (f["".concat(x, "-hover")] = p.some(function(T) {
      return isSameWeek(c, A, y, T);
    })), classnames(
      x,
      _defineProperty$a({}, "".concat(x, "-selected"), !v && isSameWeek(c, A, d, y)),
      // Patch for hover range
      f
    );
  };
  return /* @__PURE__ */ reactExports.createElement(DatePanel, _extends$3({}, a, {
    mode: "week",
    panelName: "week",
    rowClassName: g
  }));
}
function YearPanel(a) {
  var s = a.prefixCls, c = a.locale, u = a.generateConfig, d = a.pickerValue, p = a.disabledDate, v = a.onPickerValueChange, A = a.onModeChange, x = "".concat(s, "-year-panel"), g = useInfo(a, "year"), b = _slicedToArray$e(g, 1), y = b[0], f = function(O) {
    var L = Math.floor(u.getYear(O) / 10) * 10;
    return u.setYear(O, L);
  }, m = function(O) {
    var L = f(O);
    return u.addYear(L, 9);
  }, C = f(d), w = m(d), S = u.addYear(C, -1), $ = function(O, L) {
    return u.addYear(O, L);
  }, T = function(O) {
    return formatValue(O, {
      locale: c,
      format: c.cellYearFormat,
      generateConfig: u
    });
  }, I = function(O) {
    return _defineProperty$a({}, "".concat(s, "-cell-in-view"), isSameYear(u, O, C) || isSameYear(u, O, w) || isInRange(u, C, w, O));
  }, _ = p ? function(R, O) {
    var L = u.setMonth(R, 0), B = u.setDate(L, 1), F = u.addYear(B, 1), M = u.addDate(F, -1);
    return p(B, O) && p(M, O);
  } : null, E = /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    key: "decade",
    "aria-label": c.decadeSelect,
    onClick: function() {
      A("decade");
    },
    tabIndex: -1,
    className: "".concat(s, "-decade-btn")
  }, formatValue(C, {
    locale: c,
    format: c.yearFormat,
    generateConfig: u
  }), "-", formatValue(w, {
    locale: c,
    format: c.yearFormat,
    generateConfig: u
  }));
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: y
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: x
  }, /* @__PURE__ */ reactExports.createElement(PanelHeader, {
    superOffset: function(O) {
      return u.addYear(d, O * 10);
    },
    onChange: v,
    getStart: f,
    getEnd: m
  }, E), /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$3({}, a, {
    disabledDate: _,
    titleFormat: c.fieldYearFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: S,
    getCellDate: $,
    getCellText: T,
    getCellClassName: I
  }))));
}
var DefaultComponents = {
  date: DatePanel,
  datetime: DateTimePanel,
  week: WeekPanel,
  month: MonthPanel,
  quarter: QuarterPanel,
  year: YearPanel,
  decade: DecadePanel,
  time: TimePanel
};
function PickerPanel(a, s) {
  var c, u = a.locale, d = a.generateConfig, p = a.direction, v = a.prefixCls, A = a.tabIndex, x = A === void 0 ? 0 : A, g = a.multiple, b = a.defaultValue, y = a.value, f = a.onChange, m = a.onSelect, C = a.defaultPickerValue, w = a.pickerValue, S = a.onPickerValueChange, $ = a.mode, T = a.onPanelChange, I = a.picker, _ = I === void 0 ? "date" : I, E = a.showTime, R = a.hoverValue, O = a.hoverRangeValue, L = a.cellRender, B = a.dateRender, F = a.monthCellRender, M = a.components, W = M === void 0 ? {} : M, j = a.hideHeader, G = ((c = reactExports.useContext(PickerContext)) === null || c === void 0 ? void 0 : c.prefixCls) || v || "rc-picker", U = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return {
      nativeElement: U.current
    };
  });
  var k = getTimeProps(a), N = _slicedToArray$e(k, 4), P = N[0], D = N[1], H = N[2], V = N[3], Z = useLocale(u, D), ne = _ === "date" && E ? "datetime" : _, K = reactExports.useMemo(function() {
    return fillShowTimeConfig(ne, H, V, P, Z);
  }, [ne, H, V, P, Z]), q = d.getNow(), Y = useMergedState(_, {
    value: $,
    postState: function(Be) {
      return Be || "date";
    }
  }), ee = _slicedToArray$e(Y, 2), Q = ee[0], J = ee[1], te = Q === "date" && K ? "datetime" : Q, ae = useToggleDates(d, u, ne), se = useMergedState(b, {
    value: y
  }), ie = _slicedToArray$e(se, 2), fe = ie[0], ge = ie[1], me = reactExports.useMemo(function() {
    var Re = toArray$4(fe).filter(function(Be) {
      return Be;
    });
    return g ? Re : Re.slice(0, 1);
  }, [fe, g]), pe = useEvent(function(Re) {
    ge(Re), f && (Re === null || me.length !== Re.length || me.some(function(Be, Oe) {
      return !isSame(d, u, Be, Re[Oe], ne);
    })) && f?.(g ? Re : Re[0]);
  }), be = useEvent(function(Re) {
    if (m?.(Re), Q === _) {
      var Be = g ? ae(me, Re) : [Re];
      pe(Be);
    }
  }), le = useMergedState(C || me[0] || q, {
    value: w
  }), ve = _slicedToArray$e(le, 2), he = ve[0], ye = ve[1];
  reactExports.useEffect(function() {
    me[0] && !w && ye(me[0]);
  }, [me[0]]);
  var Ce = function(Be, Oe) {
    T?.(Be || w, Oe || Q);
  }, xe = function(Be) {
    var Oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    ye(Be), S?.(Be), Oe && Ce(Be);
  }, we = function(Be, Oe) {
    J(Be), Oe && xe(Oe), Ce(Oe, Be);
  }, $e = function(Be) {
    if (be(Be), xe(Be), Q !== _) {
      var Oe = ["decade", "year"], Me = [].concat(Oe, ["month"]), Fe = {
        quarter: [].concat(Oe, ["quarter"]),
        week: [].concat(_toConsumableArray$e(Me), ["week"]),
        date: [].concat(_toConsumableArray$e(Me), ["date"])
      }, Ue = Fe[_] || Me, je = Ue.indexOf(Q), Le = Ue[je + 1];
      Le && we(Le, Be);
    }
  }, Ae = reactExports.useMemo(function() {
    var Re, Be;
    if (Array.isArray(O)) {
      var Oe = _slicedToArray$e(O, 2);
      Re = Oe[0], Be = Oe[1];
    } else
      Re = O;
    return !Re && !Be ? null : (Re = Re || Be, Be = Be || Re, d.isAfter(Re, Be) ? [Be, Re] : [Re, Be]);
  }, [O, d]), ue = useCellRender$1(L, B, F), ce = W[te] || DefaultComponents[te] || DatePanel, Ee = reactExports.useContext(PickerHackContext), _e = reactExports.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, Ee), {}, {
      hideHeader: j
    });
  }, [Ee, j]), Te = "".concat(G, "-panel"), ke = pickProps(a, [
    // Week
    "showWeek",
    // Icons
    "prevIcon",
    "nextIcon",
    "superPrevIcon",
    "superNextIcon",
    // Disabled
    "disabledDate",
    "minDate",
    "maxDate",
    // Hover
    "onHover"
  ]);
  return /* @__PURE__ */ reactExports.createElement(PickerHackContext.Provider, {
    value: _e
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: U,
    tabIndex: x,
    className: classnames(Te, _defineProperty$a({}, "".concat(Te, "-rtl"), p === "rtl"))
  }, /* @__PURE__ */ reactExports.createElement(ce, _extends$3({}, ke, {
    // Time
    showTime: K,
    prefixCls: G,
    locale: Z,
    generateConfig: d,
    onModeChange: we,
    pickerValue: he,
    onPickerValueChange: function(Be) {
      xe(Be, !0);
    },
    value: me[0],
    onSelect: $e,
    values: me,
    cellRender: ue,
    hoverRangeValue: Ae,
    hoverValue: R
  }))));
}
var RefPanelPicker = /* @__PURE__ */ reactExports.memo(/* @__PURE__ */ reactExports.forwardRef(PickerPanel));
function PopupPanel(a) {
  var s = a.picker, c = a.multiplePanel, u = a.pickerValue, d = a.onPickerValueChange, p = a.needConfirm, v = a.onSubmit, A = a.range, x = a.hoverValue, g = reactExports.useContext(PickerContext), b = g.prefixCls, y = g.generateConfig, f = reactExports.useCallback(function(T, I) {
    return offsetPanelDate(y, s, T, I);
  }, [y, s]), m = reactExports.useMemo(function() {
    return f(u, 1);
  }, [u, f]), C = function(I) {
    d(f(I, -1));
  }, w = {
    onCellDblClick: function() {
      p && v();
    }
  }, S = s === "time", $ = _objectSpread2$1(_objectSpread2$1({}, a), {}, {
    hoverValue: null,
    hoverRangeValue: null,
    hideHeader: S
  });
  return A ? $.hoverRangeValue = x : $.hoverValue = x, c ? /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(b, "-panels")
  }, /* @__PURE__ */ reactExports.createElement(PickerHackContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, w), {}, {
      hideNext: !0
    })
  }, /* @__PURE__ */ reactExports.createElement(RefPanelPicker, $)), /* @__PURE__ */ reactExports.createElement(PickerHackContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, w), {}, {
      hidePrev: !0
    })
  }, /* @__PURE__ */ reactExports.createElement(RefPanelPicker, _extends$3({}, $, {
    pickerValue: m,
    onPickerValueChange: C
  })))) : /* @__PURE__ */ reactExports.createElement(PickerHackContext.Provider, {
    value: _objectSpread2$1({}, w)
  }, /* @__PURE__ */ reactExports.createElement(RefPanelPicker, $));
}
function executeValue(a) {
  return typeof a == "function" ? a() : a;
}
function PresetPanel(a) {
  var s = a.prefixCls, c = a.presets, u = a.onClick, d = a.onHover;
  return c.length ? /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(s, "-presets")
  }, /* @__PURE__ */ reactExports.createElement("ul", null, c.map(function(p, v) {
    var A = p.label, x = p.value;
    return /* @__PURE__ */ reactExports.createElement("li", {
      key: v,
      onClick: function() {
        u(executeValue(x));
      },
      onMouseEnter: function() {
        d(executeValue(x));
      },
      onMouseLeave: function() {
        d(null);
      }
    }, A);
  }))) : null;
}
function Popup$1(a) {
  var s = a.panelRender, c = a.internalMode, u = a.picker, d = a.showNow, p = a.range, v = a.multiple, A = a.activeInfo, x = A === void 0 ? [0, 0, 0] : A, g = a.presets, b = a.onPresetHover, y = a.onPresetSubmit, f = a.onFocus, m = a.onBlur, C = a.onPanelMouseDown, w = a.direction, S = a.value, $ = a.onSelect, T = a.isInvalid, I = a.defaultOpenValue, _ = a.onOk, E = a.onSubmit, R = reactExports.useContext(PickerContext), O = R.prefixCls, L = "".concat(O, "-panel"), B = w === "rtl", F = reactExports.useRef(null), M = reactExports.useRef(null), W = reactExports.useState(0), j = _slicedToArray$e(W, 2), G = j[0], U = j[1], k = reactExports.useState(0), N = _slicedToArray$e(k, 2), P = N[0], D = N[1], H = reactExports.useState(0), V = _slicedToArray$e(H, 2), Z = V[0], ne = V[1], K = function($e) {
    $e.width && U($e.width);
  }, q = _slicedToArray$e(x, 3), Y = q[0], ee = q[1], Q = q[2], J = reactExports.useState(0), te = _slicedToArray$e(J, 2), ae = te[0], se = te[1];
  reactExports.useEffect(function() {
    se(10);
  }, [Y]), reactExports.useEffect(function() {
    if (p && M.current) {
      var we, $e = ((we = F.current) === null || we === void 0 ? void 0 : we.offsetWidth) || 0, Ae = M.current.getBoundingClientRect();
      if (!Ae.height || Ae.right < 0) {
        se(function(_e) {
          return Math.max(0, _e - 1);
        });
        return;
      }
      var ue = (B ? ee - $e : Y) - Ae.left;
      if (ne(ue), G && G < Q) {
        var ce = B ? Ae.right - (ee - $e + G) : Y + $e - Ae.left - G, Ee = Math.max(0, ce);
        D(Ee);
      } else
        D(0);
    }
  }, [ae, B, G, Y, ee, Q, p]);
  function ie(we) {
    return we.filter(function($e) {
      return $e;
    });
  }
  var fe = reactExports.useMemo(function() {
    return ie(toArray$4(S));
  }, [S]), ge = u === "time" && !fe.length, me = reactExports.useMemo(function() {
    return ge ? ie([I]) : fe;
  }, [ge, fe, I]), pe = ge ? I : fe, be = reactExports.useMemo(function() {
    return me.length ? me.some(function(we) {
      return T(we);
    }) : !0;
  }, [me, T]), le = function() {
    ge && $(I), _(), E();
  }, ve = /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(O, "-panel-layout")
  }, /* @__PURE__ */ reactExports.createElement(PresetPanel, {
    prefixCls: O,
    presets: g,
    onClick: y,
    onHover: b
  }), /* @__PURE__ */ reactExports.createElement("div", null, /* @__PURE__ */ reactExports.createElement(PopupPanel, _extends$3({}, a, {
    value: pe
  })), /* @__PURE__ */ reactExports.createElement(Footer$2, _extends$3({}, a, {
    showNow: v ? !1 : d,
    invalid: be,
    onSubmit: le
  }))));
  s && (ve = s(ve));
  var he = "".concat(L, "-container"), ye = "marginLeft", Ce = "marginRight", xe = /* @__PURE__ */ reactExports.createElement("div", {
    onMouseDown: C,
    tabIndex: -1,
    className: classnames(
      he,
      // Used for Today Button style, safe to remove if no need
      "".concat(O, "-").concat(c, "-panel-container")
    ),
    style: _defineProperty$a(_defineProperty$a({}, B ? Ce : ye, P), B ? ye : Ce, "auto"),
    onFocus: f,
    onBlur: m
  }, ve);
  return p && (xe = /* @__PURE__ */ reactExports.createElement("div", {
    onMouseDown: C,
    ref: M,
    className: classnames("".concat(O, "-range-wrapper"), "".concat(O, "-").concat(u, "-range-wrapper"))
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: F,
    className: "".concat(O, "-range-arrow"),
    style: {
      left: Z
    }
  }), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: K
  }, xe))), xe;
}
function useInputProps(a, s) {
  var c = a.format, u = a.maskFormat, d = a.generateConfig, p = a.locale, v = a.preserveInvalidOnBlur, A = a.inputReadOnly, x = a.required, g = a["aria-required"], b = a.onSubmit, y = a.onFocus, f = a.onBlur, m = a.onInputChange, C = a.onInvalid, w = a.open, S = a.onOpenChange, $ = a.onKeyDown, T = a.onChange, I = a.activeHelp, _ = a.name, E = a.autoComplete, R = a.id, O = a.value, L = a.invalid, B = a.placeholder, F = a.disabled, M = a.activeIndex, W = a.allHelp, j = a.picker, G = function(Z, ne) {
    var K = d.locale.parse(p.locale, Z, [ne]);
    return K && d.isValidate(K) ? K : null;
  }, U = c[0], k = reactExports.useCallback(function(V) {
    return formatValue(V, {
      locale: p,
      format: U,
      generateConfig: d
    });
  }, [p, d, U]), N = reactExports.useMemo(function() {
    return O.map(k);
  }, [O, k]), P = reactExports.useMemo(function() {
    var V = j === "time" ? 8 : 10, Z = typeof U == "function" ? U(d.getNow()).length : U.length;
    return Math.max(V, Z) + 2;
  }, [U, j, d]), D = function(Z) {
    for (var ne = 0; ne < c.length; ne += 1) {
      var K = c[ne];
      if (typeof K == "string") {
        var q = G(Z, K);
        if (q)
          return q;
      }
    }
    return !1;
  }, H = function(Z) {
    function ne(Y) {
      return Z !== void 0 ? Y[Z] : Y;
    }
    var K = pickAttrs(a, {
      aria: !0,
      data: !0
    }), q = _objectSpread2$1(_objectSpread2$1({}, K), {}, {
      // ============== Shared ==============
      format: u,
      validateFormat: function(ee) {
        return !!D(ee);
      },
      preserveInvalidOnBlur: v,
      readOnly: A,
      required: x,
      "aria-required": g,
      name: _,
      autoComplete: E,
      size: P,
      // ============= By Index =============
      id: ne(R),
      value: ne(N) || "",
      invalid: ne(L),
      placeholder: ne(B),
      active: M === Z,
      helped: W || I && M === Z,
      disabled: ne(F),
      onFocus: function(ee) {
        y(ee, Z);
      },
      onBlur: function(ee) {
        f(ee, Z);
      },
      onSubmit: b,
      // Get validate text value
      onChange: function(ee) {
        m();
        var Q = D(ee);
        if (Q) {
          C(!1, Z), T(Q, Z);
          return;
        }
        C(!!ee, Z);
      },
      onHelp: function() {
        S(!0, {
          index: Z
        });
      },
      onKeyDown: function(ee) {
        var Q = !1;
        if ($?.(ee, function() {
          Q = !0;
        }), !ee.defaultPrevented && !Q)
          switch (ee.key) {
            case "Escape":
              S(!1, {
                index: Z
              });
              break;
            case "Enter":
              w || S(!0);
              break;
          }
      }
    }, s?.({
      valueTexts: N
    }));
    return Object.keys(q).forEach(function(Y) {
      q[Y] === void 0 && delete q[Y];
    }), q;
  };
  return [H, k];
}
var propNames = ["onMouseEnter", "onMouseLeave"];
function useRootProps(a) {
  return reactExports.useMemo(function() {
    return pickProps(a, propNames);
  }, [a]);
}
var _excluded$z = ["icon", "type"], _excluded2$8 = ["onClear"];
function Icon$2(a) {
  var s = a.icon, c = a.type, u = _objectWithoutProperties$2(a, _excluded$z), d = reactExports.useContext(PickerContext), p = d.prefixCls;
  return s ? /* @__PURE__ */ reactExports.createElement("span", _extends$3({
    className: "".concat(p, "-").concat(c)
  }, u), s) : null;
}
function ClearIcon(a) {
  var s = a.onClear, c = _objectWithoutProperties$2(a, _excluded2$8);
  return /* @__PURE__ */ reactExports.createElement(Icon$2, _extends$3({}, c, {
    type: "clear",
    role: "button",
    onMouseDown: function(d) {
      d.preventDefault();
    },
    onClick: function(d) {
      d.stopPropagation(), s();
    }
  }));
}
var FORMAT_KEYS = ["YYYY", "MM", "DD", "HH", "mm", "ss", "SSS"], REPLACE_KEY = "顧", MaskFormat = /* @__PURE__ */ function() {
  function a(s) {
    _classCallCheck$1(this, a), _defineProperty$a(this, "format", void 0), _defineProperty$a(this, "maskFormat", void 0), _defineProperty$a(this, "cells", void 0), _defineProperty$a(this, "maskCells", void 0), this.format = s;
    var c = FORMAT_KEYS.map(function(A) {
      return "(".concat(A, ")");
    }).join("|"), u = new RegExp(c, "g");
    this.maskFormat = s.replace(
      u,
      // Use Chinese character to avoid user use it in format
      function(A) {
        return REPLACE_KEY.repeat(A.length);
      }
    );
    var d = new RegExp("(".concat(FORMAT_KEYS.join("|"), ")")), p = (s.split(d) || []).filter(function(A) {
      return A;
    }), v = 0;
    this.cells = p.map(function(A) {
      var x = FORMAT_KEYS.includes(A), g = v, b = v + A.length;
      return v = b, {
        text: A,
        mask: x,
        start: g,
        end: b
      };
    }), this.maskCells = this.cells.filter(function(A) {
      return A.mask;
    });
  }
  return _createClass$1(a, [{
    key: "getSelection",
    value: function(c) {
      var u = this.maskCells[c] || {}, d = u.start, p = u.end;
      return [d || 0, p || 0];
    }
    /** Check given text match format */
  }, {
    key: "match",
    value: function(c) {
      for (var u = 0; u < this.maskFormat.length; u += 1) {
        var d = this.maskFormat[u], p = c[u];
        if (!p || d !== REPLACE_KEY && d !== p)
          return !1;
      }
      return !0;
    }
    /** Get mask cell count */
  }, {
    key: "size",
    value: function() {
      return this.maskCells.length;
    }
  }, {
    key: "getMaskCellIndex",
    value: function(c) {
      for (var u = Number.MAX_SAFE_INTEGER, d = 0, p = 0; p < this.maskCells.length; p += 1) {
        var v = this.maskCells[p], A = v.start, x = v.end;
        if (c >= A && c <= x)
          return p;
        var g = Math.min(Math.abs(c - A), Math.abs(c - x));
        g < u && (u = g, d = p);
      }
      return d;
    }
  }]), a;
}();
function getMaskRange(a) {
  var s = {
    YYYY: [0, 9999, (/* @__PURE__ */ new Date()).getFullYear()],
    MM: [1, 12],
    DD: [1, 31],
    HH: [0, 23],
    mm: [0, 59],
    ss: [0, 59],
    SSS: [0, 999]
  };
  return s[a];
}
var _excluded$y = ["active", "showActiveCls", "suffixIcon", "format", "validateFormat", "onChange", "onInput", "helped", "onHelp", "onSubmit", "onKeyDown", "preserveInvalidOnBlur", "invalid", "clearIcon"], Input$4 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.active, u = a.showActiveCls, d = u === void 0 ? !0 : u, p = a.suffixIcon, v = a.format, A = a.validateFormat, x = a.onChange;
  a.onInput;
  var g = a.helped, b = a.onHelp, y = a.onSubmit, f = a.onKeyDown, m = a.preserveInvalidOnBlur, C = m === void 0 ? !1 : m, w = a.invalid, S = a.clearIcon, $ = _objectWithoutProperties$2(a, _excluded$y), T = a.value, I = a.onFocus, _ = a.onBlur, E = a.onMouseUp, R = reactExports.useContext(PickerContext), O = R.prefixCls, L = R.input, B = L === void 0 ? "input" : L, F = "".concat(O, "-input"), M = reactExports.useState(!1), W = _slicedToArray$e(M, 2), j = W[0], G = W[1], U = reactExports.useState(T), k = _slicedToArray$e(U, 2), N = k[0], P = k[1], D = reactExports.useState(""), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = reactExports.useState(null), K = _slicedToArray$e(ne, 2), q = K[0], Y = K[1], ee = reactExports.useState(null), Q = _slicedToArray$e(ee, 2), J = Q[0], te = Q[1], ae = N || "";
  reactExports.useEffect(function() {
    P(T);
  }, [T]);
  var se = reactExports.useRef(), ie = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return {
      nativeElement: se.current,
      inputElement: ie.current,
      focus: function(Re) {
        ie.current.focus(Re);
      },
      blur: function() {
        ie.current.blur();
      }
    };
  });
  var fe = reactExports.useMemo(function() {
    return new MaskFormat(v || "");
  }, [v]), ge = reactExports.useMemo(function() {
    return g ? [0, 0] : fe.getSelection(q);
  }, [fe, q, g]), me = _slicedToArray$e(ge, 2), pe = me[0], be = me[1], le = function(Re) {
    Re && Re !== v && Re !== T && b();
  }, ve = useEvent(function(ke) {
    A(ke) && x(ke), P(ke), le(ke);
  }), he = function(Re) {
    if (!v) {
      var Be = Re.target.value;
      le(Be), P(Be), x(Be);
    }
  }, ye = function(Re) {
    var Be = Re.clipboardData.getData("text");
    A(Be) && ve(Be);
  }, Ce = reactExports.useRef(!1), xe = function() {
    Ce.current = !0;
  }, we = function(Re) {
    var Be = Re.target, Oe = Be.selectionStart, Me = fe.getMaskCellIndex(Oe);
    Y(Me), te({}), E?.(Re), Ce.current = !1;
  }, $e = function(Re) {
    G(!0), Y(0), Z(""), I(Re);
  }, Ae = function(Re) {
    _(Re);
  }, ue = function(Re) {
    G(!1), Ae(Re);
  };
  useLockEffect(c, function() {
    !c && !C && P(T);
  });
  var ce = function(Re) {
    Re.key === "Enter" && A(ae) && y(), f?.(Re);
  }, Ee = function(Re) {
    ce(Re);
    var Be = Re.key, Oe = null, Me = null, Fe = be - pe, Ue = v.slice(pe, be), je = function(Ge) {
      Y(function(Xe) {
        var nt = Xe + Ge;
        return nt = Math.max(nt, 0), nt = Math.min(nt, fe.size() - 1), nt;
      });
    }, Le = function(Ge) {
      var Xe = getMaskRange(Ue), nt = _slicedToArray$e(Xe, 3), ct = nt[0], it = nt[1], We = nt[2], Ve = ae.slice(pe, be), ut = Number(Ve);
      if (isNaN(ut))
        return String(We || (Ge > 0 ? ct : it));
      var at = ut + Ge, Qe = it - ct + 1;
      return String(ct + (Qe + at - ct) % Qe);
    };
    switch (Be) {
      // =============== Remove ===============
      case "Backspace":
      case "Delete":
        Oe = "", Me = Ue;
        break;
      // =============== Arrows ===============
      // Left key
      case "ArrowLeft":
        Oe = "", je(-1);
        break;
      // Right key
      case "ArrowRight":
        Oe = "", je(1);
        break;
      // Up key
      case "ArrowUp":
        Oe = "", Me = Le(1);
        break;
      // Down key
      case "ArrowDown":
        Oe = "", Me = Le(-1);
        break;
      // =============== Number ===============
      default:
        isNaN(Number(Be)) || (Oe = V + Be, Me = Oe);
        break;
    }
    if (Oe !== null && (Z(Oe), Oe.length >= Fe && (je(1), Z(""))), Me !== null) {
      var De = (
        // before
        ae.slice(0, pe) + // replace
        leftPad(Me, Fe) + // after
        ae.slice(be)
      );
      ve(De.slice(0, v.length));
    }
    te({});
  }, _e = reactExports.useRef();
  useLayoutEffect$1(function() {
    if (!(!j || !v || Ce.current)) {
      if (!fe.match(ae)) {
        ve(v);
        return;
      }
      return ie.current.setSelectionRange(pe, be), _e.current = wrapperRaf(function() {
        ie.current.setSelectionRange(pe, be);
      }), function() {
        wrapperRaf.cancel(_e.current);
      };
    }
  }, [fe, v, j, ae, q, pe, be, J, ve]);
  var Te = v ? {
    onFocus: $e,
    onBlur: ue,
    onKeyDown: Ee,
    onMouseDown: xe,
    onMouseUp: we,
    onPaste: ye
  } : {};
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: se,
    className: classnames(F, _defineProperty$a(_defineProperty$a({}, "".concat(F, "-active"), c && d), "".concat(F, "-placeholder"), g))
  }, /* @__PURE__ */ reactExports.createElement(B, _extends$3({
    ref: ie,
    "aria-invalid": w,
    autoComplete: "off"
  }, $, {
    onKeyDown: ce,
    onBlur: Ae
    // Replace with format
  }, Te, {
    // Value
    value: ae,
    onChange: he
  })), /* @__PURE__ */ reactExports.createElement(Icon$2, {
    type: "suffix",
    icon: p
  }), S);
}), _excluded$x = ["id", "prefix", "clearIcon", "suffixIcon", "separator", "activeIndex", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "value", "onChange", "onSubmit", "onInputChange", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onActiveInfo", "placement", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex"], _excluded2$7 = ["index"];
function RangeSelector(a, s) {
  var c = a.id, u = a.prefix, d = a.clearIcon, p = a.suffixIcon, v = a.separator, A = v === void 0 ? "~" : v, x = a.activeIndex;
  a.activeHelp, a.allHelp;
  var g = a.focused;
  a.onFocus, a.onBlur, a.onKeyDown, a.locale, a.generateConfig;
  var b = a.placeholder, y = a.className, f = a.style, m = a.onClick, C = a.onClear, w = a.value;
  a.onChange, a.onSubmit, a.onInputChange, a.format, a.maskFormat, a.preserveInvalidOnBlur, a.onInvalid;
  var S = a.disabled, $ = a.invalid;
  a.inputReadOnly;
  var T = a.direction;
  a.onOpenChange;
  var I = a.onActiveInfo;
  a.placement;
  var _ = a.onMouseDown;
  a.required, a["aria-required"];
  var E = a.autoFocus, R = a.tabIndex, O = _objectWithoutProperties$2(a, _excluded$x), L = T === "rtl", B = reactExports.useContext(PickerContext), F = B.prefixCls, M = reactExports.useMemo(function() {
    if (typeof c == "string")
      return [c];
    var J = c || {};
    return [J.start, J.end];
  }, [c]), W = reactExports.useRef(), j = reactExports.useRef(), G = reactExports.useRef(), U = function(te) {
    var ae;
    return (ae = [j, G][te]) === null || ae === void 0 ? void 0 : ae.current;
  };
  reactExports.useImperativeHandle(s, function() {
    return {
      nativeElement: W.current,
      focus: function(te) {
        if (_typeof$h(te) === "object") {
          var ae, se = te || {}, ie = se.index, fe = ie === void 0 ? 0 : ie, ge = _objectWithoutProperties$2(se, _excluded2$7);
          (ae = U(fe)) === null || ae === void 0 || ae.focus(ge);
        } else {
          var me;
          (me = U(te ?? 0)) === null || me === void 0 || me.focus();
        }
      },
      blur: function() {
        var te, ae;
        (te = U(0)) === null || te === void 0 || te.blur(), (ae = U(1)) === null || ae === void 0 || ae.blur();
      }
    };
  });
  var k = useRootProps(O), N = reactExports.useMemo(function() {
    return Array.isArray(b) ? b : [b, b];
  }, [b]), P = useInputProps(_objectSpread2$1(_objectSpread2$1({}, a), {}, {
    id: M,
    placeholder: N
  })), D = _slicedToArray$e(P, 1), H = D[0], V = reactExports.useState({
    position: "absolute",
    width: 0
  }), Z = _slicedToArray$e(V, 2), ne = Z[0], K = Z[1], q = useEvent(function() {
    var J = U(x);
    if (J) {
      var te = J.nativeElement.getBoundingClientRect(), ae = W.current.getBoundingClientRect(), se = te.left - ae.left;
      K(function(ie) {
        return _objectSpread2$1(_objectSpread2$1({}, ie), {}, {
          width: te.width,
          left: se
        });
      }), I([te.left, te.right, ae.width]);
    }
  });
  reactExports.useEffect(function() {
    q();
  }, [x]);
  var Y = d && (w[0] && !S[0] || w[1] && !S[1]), ee = E && !S[0], Q = E && !ee && !S[1];
  return /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: q
  }, /* @__PURE__ */ reactExports.createElement("div", _extends$3({}, k, {
    className: classnames(F, "".concat(F, "-range"), _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(F, "-focused"), g), "".concat(F, "-disabled"), S.every(function(J) {
      return J;
    })), "".concat(F, "-invalid"), $.some(function(J) {
      return J;
    })), "".concat(F, "-rtl"), L), y),
    style: f,
    ref: W,
    onClick: m,
    onMouseDown: function(te) {
      var ae = te.target;
      ae !== j.current.inputElement && ae !== G.current.inputElement && te.preventDefault(), _?.(te);
    }
  }), u && /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(F, "-prefix")
  }, u), /* @__PURE__ */ reactExports.createElement(Input$4, _extends$3({
    ref: j
  }, H(0), {
    autoFocus: ee,
    tabIndex: R,
    "date-range": "start"
  })), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(F, "-range-separator")
  }, A), /* @__PURE__ */ reactExports.createElement(Input$4, _extends$3({
    ref: G
  }, H(1), {
    autoFocus: Q,
    tabIndex: R,
    "date-range": "end"
  })), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(F, "-active-bar"),
    style: ne
  }), /* @__PURE__ */ reactExports.createElement(Icon$2, {
    type: "suffix",
    icon: p
  }), Y && /* @__PURE__ */ reactExports.createElement(ClearIcon, {
    icon: d,
    onClear: C
  })));
}
var RefRangeSelector = /* @__PURE__ */ reactExports.forwardRef(RangeSelector);
function separateConfig(a, s) {
  var c = a ?? s;
  return Array.isArray(c) ? c : [c, c];
}
function getActiveRange(a) {
  return a === 1 ? "end" : "start";
}
function RangePicker$2(a, s) {
  var c = useFilledProps(a, function() {
    var zt = a.disabled, Dt = a.allowEmpty, nr = separateConfig(zt, !1), gr = separateConfig(Dt, !1);
    return {
      disabled: nr,
      allowEmpty: gr
    };
  }), u = _slicedToArray$e(c, 6), d = u[0], p = u[1], v = u[2], A = u[3], x = u[4], g = u[5], b = d.prefixCls, y = d.styles, f = d.classNames, m = d.defaultValue, C = d.value, w = d.needConfirm, S = d.onKeyDown, $ = d.disabled, T = d.allowEmpty, I = d.disabledDate, _ = d.minDate, E = d.maxDate, R = d.defaultOpen, O = d.open, L = d.onOpenChange, B = d.locale, F = d.generateConfig, M = d.picker, W = d.showNow, j = d.showToday, G = d.showTime, U = d.mode, k = d.onPanelChange, N = d.onCalendarChange, P = d.onOk, D = d.defaultPickerValue, H = d.pickerValue, V = d.onPickerValueChange, Z = d.inputReadOnly, ne = d.suffixIcon, K = d.onFocus, q = d.onBlur, Y = d.presets, ee = d.ranges, Q = d.components, J = d.cellRender, te = d.dateRender, ae = d.monthCellRender, se = d.onClick, ie = usePickerRef(s), fe = useOpen(O, R, $, L), ge = _slicedToArray$e(fe, 2), me = ge[0], pe = ge[1], be = function(Dt, nr) {
    ($.some(function(gr) {
      return !gr;
    }) || !Dt) && pe(Dt, nr);
  }, le = useInnerValue(F, B, A, !0, !1, m, C, N, P), ve = _slicedToArray$e(le, 5), he = ve[0], ye = ve[1], Ce = ve[2], xe = ve[3], we = ve[4], $e = Ce(), Ae = useRangeActive($, T, me), ue = _slicedToArray$e(Ae, 9), ce = ue[0], Ee = ue[1], _e = ue[2], Te = ue[3], ke = ue[4], Re = ue[5], Be = ue[6], Oe = ue[7], Me = ue[8], Fe = function(Dt, nr) {
    Ee(!0), K?.(Dt, {
      range: getActiveRange(nr ?? Te)
    });
  }, Ue = function(Dt, nr) {
    Ee(!1), q?.(Dt, {
      range: getActiveRange(nr ?? Te)
    });
  }, je = reactExports.useMemo(function() {
    if (!G)
      return null;
    var zt = G.disabledTime, Dt = zt ? function(nr) {
      var gr = getActiveRange(Te), lr = getFromDate($e, Be, Te);
      return zt(nr, gr, {
        from: lr
      });
    } : void 0;
    return _objectSpread2$1(_objectSpread2$1({}, G), {}, {
      disabledTime: Dt
    });
  }, [G, Te, $e, Be]), Le = useMergedState([M, M], {
    value: U
  }), De = _slicedToArray$e(Le, 2), Ne = De[0], Ge = De[1], Xe = Ne[Te] || M, nt = Xe === "date" && je ? "datetime" : Xe, ct = nt === M && nt !== "time", it = useShowNow(M, Xe, W, j, !0), We = useRangeValue(d, he, ye, Ce, xe, $, A, ce, me, g), Ve = _slicedToArray$e(We, 2), ut = Ve[0], at = Ve[1], Qe = useRangeDisabledDate($e, $, Be, F, B, I), st = useFieldsInvalidate($e, g, T), ft = _slicedToArray$e(st, 2), vt = ft[0], Pt = ft[1], dt = useRangePickerValue(F, B, $e, Ne, me, Te, p, ct, D, H, je?.defaultOpenValue, V, _, E), mt = _slicedToArray$e(dt, 2), pt = mt[0], Et = mt[1], Mt = useEvent(function(zt, Dt, nr) {
    var gr = fillIndex(Ne, Te, Dt);
    if ((gr[0] !== Ne[0] || gr[1] !== Ne[1]) && Ge(gr), k && nr !== !1) {
      var lr = _toConsumableArray$e($e);
      zt && (lr[Te] = zt), k(lr, gr);
    }
  }), Nt = function(Dt, nr) {
    return (
      // Trigger change only when date changed
      fillIndex($e, nr, Dt)
    );
  }, _t = function(Dt, nr) {
    var gr = $e;
    Dt && (gr = Nt(Dt, Te)), Oe(Te);
    var lr = Re(gr);
    xe(gr), ut(Te, lr === null), lr === null ? be(!1, {
      force: !0
    }) : nr || ie.current.focus({
      index: lr
    });
  }, Ot = function(Dt) {
    var nr, gr = Dt.target.getRootNode();
    if (!ie.current.nativeElement.contains((nr = gr.activeElement) !== null && nr !== void 0 ? nr : document.activeElement)) {
      var lr = $.findIndex(function(Nr) {
        return !Nr;
      });
      lr >= 0 && ie.current.focus({
        index: lr
      });
    }
    be(!0), se?.(Dt);
  }, rt = function() {
    at(null), be(!1, {
      force: !0
    });
  }, et = reactExports.useState(null), Ye = _slicedToArray$e(et, 2), tt = Ye[0], Ke = Ye[1], qe = reactExports.useState(null), ot = _slicedToArray$e(qe, 2), Je = ot[0], Ct = ot[1], Tt = reactExports.useMemo(function() {
    return Je || $e;
  }, [$e, Je]);
  reactExports.useEffect(function() {
    me || Ct(null);
  }, [me]);
  var yt = reactExports.useState([0, 0, 0]), bt = _slicedToArray$e(yt, 2), It = bt[0], kt = bt[1], $t = usePresets(Y, ee), Lt = function(Dt) {
    Ct(Dt), Ke("preset");
  }, Ft = function(Dt) {
    var nr = at(Dt);
    nr && be(!1, {
      force: !0
    });
  }, Vt = function(Dt) {
    _t(Dt);
  }, rr = function(Dt) {
    Ct(Dt ? Nt(Dt, Te) : null), Ke("cell");
  }, br = function(Dt) {
    be(!0), Fe(Dt);
  }, Gt = function() {
    _e("panel");
  }, qt = function(Dt) {
    var nr = fillIndex($e, Te, Dt);
    xe(nr), !w && !v && p === nt && _t(Dt);
  }, Jt = function() {
    be(!1);
  }, jt = useCellRender$1(J, te, ae, getActiveRange(Te)), Ht = $e[Te] || null, ur = useEvent(function(zt) {
    return g(zt, {
      activeIndex: Te
    });
  }), Qt = reactExports.useMemo(function() {
    var zt = pickAttrs(d, !1), Dt = omit(d, [].concat(_toConsumableArray$e(Object.keys(zt)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange", "disabledTime"]));
    return Dt;
  }, [d]), Yt = /* @__PURE__ */ reactExports.createElement(Popup$1, _extends$3({}, Qt, {
    showNow: it,
    showTime: je,
    range: !0,
    multiplePanel: ct,
    activeInfo: It,
    disabledDate: Qe,
    onFocus: br,
    onBlur: Ue,
    onPanelMouseDown: Gt,
    picker: M,
    mode: Xe,
    internalMode: nt,
    onPanelChange: Mt,
    format: x,
    value: Ht,
    isInvalid: ur,
    onChange: null,
    onSelect: qt,
    pickerValue: pt,
    defaultOpenValue: toArray$4(G?.defaultOpenValue)[Te],
    onPickerValueChange: Et,
    hoverValue: Tt,
    onHover: rr,
    needConfirm: w,
    onSubmit: _t,
    onOk: we,
    presets: $t,
    onPresetHover: Lt,
    onPresetSubmit: Ft,
    onNow: Vt,
    cellRender: jt
  })), dr = function(Dt, nr) {
    var gr = Nt(Dt, nr);
    xe(gr);
  }, Ar = function() {
    _e("input");
  }, wr = function(Dt, nr) {
    var gr = Be.length, lr = Be[gr - 1];
    if (gr && lr !== nr && w && // Not change index if is not filled
    !T[lr] && !Me(lr) && $e[lr]) {
      ie.current.focus({
        index: lr
      });
      return;
    }
    _e("input"), be(!0, {
      inherit: !0
    }), Te !== nr && me && !w && v && _t(null, !0), ke(nr), Fe(Dt, nr);
  }, Ir = function(Dt, nr) {
    if (be(!1), !w && _e() === "input") {
      var gr = Re($e);
      ut(Te, gr === null);
    }
    Ue(Dt, nr);
  }, _r = function(Dt, nr) {
    Dt.key === "Tab" && _t(null, !0), S?.(Dt, nr);
  }, kr = reactExports.useMemo(function() {
    return {
      prefixCls: b,
      locale: B,
      generateConfig: F,
      button: Q.button,
      input: Q.input
    };
  }, [b, B, F, Q.button, Q.input]);
  return useLayoutEffect$1(function() {
    me && Te !== void 0 && Mt(null, M, !1);
  }, [me, Te, M]), useLayoutEffect$1(function() {
    var zt = _e();
    !me && zt === "input" && (be(!1), _t(null, !0)), !me && v && !w && zt === "panel" && (be(!0), _t());
  }, [me]), /* @__PURE__ */ reactExports.createElement(PickerContext.Provider, {
    value: kr
  }, /* @__PURE__ */ reactExports.createElement(PickerTrigger, _extends$3({}, pickTriggerProps(d), {
    popupElement: Yt,
    popupStyle: y.popup,
    popupClassName: f.popup,
    visible: me,
    onClose: Jt,
    range: !0
  }), /* @__PURE__ */ reactExports.createElement(
    RefRangeSelector,
    _extends$3({}, d, {
      // Ref
      ref: ie,
      suffixIcon: ne,
      activeIndex: ce || me ? Te : null,
      activeHelp: !!Je,
      allHelp: !!Je && tt === "preset",
      focused: ce,
      onFocus: wr,
      onBlur: Ir,
      onKeyDown: _r,
      onSubmit: _t,
      value: Tt,
      maskFormat: x,
      onChange: dr,
      onInputChange: Ar,
      format: A,
      inputReadOnly: Z,
      disabled: $,
      open: me,
      onOpenChange: be,
      onClick: Ot,
      onClear: rt,
      invalid: vt,
      onInvalid: Pt,
      onActiveInfo: kt
    })
  )));
}
var RefRangePicker = /* @__PURE__ */ reactExports.forwardRef(RangePicker$2);
function MultipleDates(a) {
  var s = a.prefixCls, c = a.value, u = a.onRemove, d = a.removeIcon, p = d === void 0 ? "×" : d, v = a.formatDate, A = a.disabled, x = a.maxTagCount, g = a.placeholder, b = "".concat(s, "-selector"), y = "".concat(s, "-selection"), f = "".concat(y, "-overflow");
  function m(S, $) {
    return /* @__PURE__ */ reactExports.createElement("span", {
      className: classnames("".concat(y, "-item")),
      title: typeof S == "string" ? S : null
    }, /* @__PURE__ */ reactExports.createElement("span", {
      className: "".concat(y, "-item-content")
    }, S), !A && $ && /* @__PURE__ */ reactExports.createElement("span", {
      onMouseDown: function(I) {
        I.preventDefault();
      },
      onClick: $,
      className: "".concat(y, "-item-remove")
    }, p));
  }
  function C(S) {
    var $ = v(S), T = function(_) {
      _ && _.stopPropagation(), u(S);
    };
    return m($, T);
  }
  function w(S) {
    var $ = "+ ".concat(S.length, " ...");
    return m($);
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: b
  }, /* @__PURE__ */ reactExports.createElement(ForwardOverflow, {
    prefixCls: f,
    data: c,
    renderItem: C,
    renderRest: w,
    itemKey: function($) {
      return v($);
    },
    maxCount: x
  }), !c.length && /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(s, "-selection-placeholder")
  }, g));
}
var _excluded$w = ["id", "open", "prefix", "clearIcon", "suffixIcon", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "internalPicker", "value", "onChange", "onSubmit", "onInputChange", "multiple", "maxTagCount", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex", "removeIcon"];
function SingleSelector(a, s) {
  a.id;
  var c = a.open, u = a.prefix, d = a.clearIcon, p = a.suffixIcon;
  a.activeHelp, a.allHelp;
  var v = a.focused;
  a.onFocus, a.onBlur, a.onKeyDown;
  var A = a.locale, x = a.generateConfig, g = a.placeholder, b = a.className, y = a.style, f = a.onClick, m = a.onClear, C = a.internalPicker, w = a.value, S = a.onChange, $ = a.onSubmit;
  a.onInputChange;
  var T = a.multiple, I = a.maxTagCount;
  a.format, a.maskFormat, a.preserveInvalidOnBlur, a.onInvalid;
  var _ = a.disabled, E = a.invalid;
  a.inputReadOnly;
  var R = a.direction;
  a.onOpenChange;
  var O = a.onMouseDown;
  a.required, a["aria-required"];
  var L = a.autoFocus, B = a.tabIndex, F = a.removeIcon, M = _objectWithoutProperties$2(a, _excluded$w), W = R === "rtl", j = reactExports.useContext(PickerContext), G = j.prefixCls, U = reactExports.useRef(), k = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return {
      nativeElement: U.current,
      focus: function(ee) {
        var Q;
        (Q = k.current) === null || Q === void 0 || Q.focus(ee);
      },
      blur: function() {
        var ee;
        (ee = k.current) === null || ee === void 0 || ee.blur();
      }
    };
  });
  var N = useRootProps(M), P = function(ee) {
    S([ee]);
  }, D = function(ee) {
    var Q = w.filter(function(J) {
      return J && !isSame(x, A, J, ee, C);
    });
    S(Q), c || $();
  }, H = useInputProps(_objectSpread2$1(_objectSpread2$1({}, a), {}, {
    onChange: P
  }), function(Y) {
    var ee = Y.valueTexts;
    return {
      value: ee[0] || "",
      active: v
    };
  }), V = _slicedToArray$e(H, 2), Z = V[0], ne = V[1], K = !!(d && w.length && !_), q = T ? /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(MultipleDates, {
    prefixCls: G,
    value: w,
    onRemove: D,
    formatDate: ne,
    maxTagCount: I,
    disabled: _,
    removeIcon: F,
    placeholder: g
  }), /* @__PURE__ */ reactExports.createElement("input", {
    className: "".concat(G, "-multiple-input"),
    value: w.map(ne).join(","),
    ref: k,
    readOnly: !0,
    autoFocus: L,
    tabIndex: B
  }), /* @__PURE__ */ reactExports.createElement(Icon$2, {
    type: "suffix",
    icon: p
  }), K && /* @__PURE__ */ reactExports.createElement(ClearIcon, {
    icon: d,
    onClear: m
  })) : /* @__PURE__ */ reactExports.createElement(Input$4, _extends$3({
    ref: k
  }, Z(), {
    autoFocus: L,
    tabIndex: B,
    suffixIcon: p,
    clearIcon: K && /* @__PURE__ */ reactExports.createElement(ClearIcon, {
      icon: d,
      onClear: m
    }),
    showActiveCls: !1
  }));
  return /* @__PURE__ */ reactExports.createElement("div", _extends$3({}, N, {
    className: classnames(G, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(G, "-multiple"), T), "".concat(G, "-focused"), v), "".concat(G, "-disabled"), _), "".concat(G, "-invalid"), E), "".concat(G, "-rtl"), W), b),
    style: y,
    ref: U,
    onClick: f,
    onMouseDown: function(ee) {
      var Q, J = ee.target;
      J !== ((Q = k.current) === null || Q === void 0 ? void 0 : Q.inputElement) && ee.preventDefault(), O?.(ee);
    }
  }), u && /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(G, "-prefix")
  }, u), q);
}
var RefSingleSelector = /* @__PURE__ */ reactExports.forwardRef(SingleSelector);
function Picker(a, s) {
  var c = useFilledProps(a), u = _slicedToArray$e(c, 6), d = u[0], p = u[1], v = u[2], A = u[3], x = u[4], g = u[5], b = d, y = b.prefixCls, f = b.styles, m = b.classNames, C = b.order, w = b.defaultValue, S = b.value, $ = b.needConfirm, T = b.onChange, I = b.onKeyDown, _ = b.disabled, E = b.disabledDate, R = b.minDate, O = b.maxDate, L = b.defaultOpen, B = b.open, F = b.onOpenChange, M = b.locale, W = b.generateConfig, j = b.picker, G = b.showNow, U = b.showToday, k = b.showTime, N = b.mode, P = b.onPanelChange, D = b.onCalendarChange, H = b.onOk, V = b.multiple, Z = b.defaultPickerValue, ne = b.pickerValue, K = b.onPickerValueChange, q = b.inputReadOnly, Y = b.suffixIcon, ee = b.removeIcon, Q = b.onFocus, J = b.onBlur, te = b.presets, ae = b.components, se = b.cellRender, ie = b.dateRender, fe = b.monthCellRender, ge = b.onClick, me = usePickerRef(s);
  function pe(Qt) {
    return Qt === null ? null : V ? Qt : Qt[0];
  }
  var be = useToggleDates(W, M, p), le = useOpen(B, L, [_], F), ve = _slicedToArray$e(le, 2), he = ve[0], ye = ve[1], Ce = function(Yt, dr, Ar) {
    if (D) {
      var wr = _objectSpread2$1({}, Ar);
      delete wr.range, D(pe(Yt), pe(dr), wr);
    }
  }, xe = function(Yt) {
    H?.(pe(Yt));
  }, we = useInnerValue(W, M, A, !1, C, w, S, Ce, xe), $e = _slicedToArray$e(we, 5), Ae = $e[0], ue = $e[1], ce = $e[2], Ee = $e[3], _e = $e[4], Te = ce(), ke = useRangeActive([_]), Re = _slicedToArray$e(ke, 4), Be = Re[0], Oe = Re[1], Me = Re[2], Fe = Re[3], Ue = function(Yt) {
    Oe(!0), Q?.(Yt, {});
  }, je = function(Yt) {
    Oe(!1), J?.(Yt, {});
  }, Le = useMergedState(j, {
    value: N
  }), De = _slicedToArray$e(Le, 2), Ne = De[0], Ge = De[1], Xe = Ne === "date" && k ? "datetime" : Ne, nt = useShowNow(j, Ne, G, U), ct = T && function(Qt, Yt) {
    T(pe(Qt), pe(Yt));
  }, it = useRangeValue(
    _objectSpread2$1(_objectSpread2$1({}, d), {}, {
      onChange: ct
    }),
    Ae,
    ue,
    ce,
    Ee,
    [],
    //disabled,
    A,
    Be,
    he,
    g
  ), We = _slicedToArray$e(it, 2), Ve = We[1], ut = useFieldsInvalidate(Te, g), at = _slicedToArray$e(ut, 2), Qe = at[0], st = at[1], ft = reactExports.useMemo(function() {
    return Qe.some(function(Qt) {
      return Qt;
    });
  }, [Qe]), vt = function(Yt, dr) {
    if (K) {
      var Ar = _objectSpread2$1(_objectSpread2$1({}, dr), {}, {
        mode: dr.mode[0]
      });
      delete Ar.range, K(Yt[0], Ar);
    }
  }, Pt = useRangePickerValue(
    W,
    M,
    Te,
    [Ne],
    he,
    Fe,
    p,
    !1,
    // multiplePanel,
    Z,
    ne,
    toArray$4(k?.defaultOpenValue),
    vt,
    R,
    O
  ), dt = _slicedToArray$e(Pt, 2), mt = dt[0], pt = dt[1], Et = useEvent(function(Qt, Yt, dr) {
    if (Ge(Yt), P && dr !== !1) {
      var Ar = Qt || Te[Te.length - 1];
      P(Ar, Yt);
    }
  }), Mt = function() {
    Ve(ce()), ye(!1, {
      force: !0
    });
  }, Nt = function(Yt) {
    !_ && !me.current.nativeElement.contains(document.activeElement) && me.current.focus(), ye(!0), ge?.(Yt);
  }, _t = function() {
    Ve(null), ye(!1, {
      force: !0
    });
  }, Ot = reactExports.useState(null), rt = _slicedToArray$e(Ot, 2), et = rt[0], Ye = rt[1], tt = reactExports.useState(null), Ke = _slicedToArray$e(tt, 2), qe = Ke[0], ot = Ke[1], Je = reactExports.useMemo(function() {
    var Qt = [qe].concat(_toConsumableArray$e(Te)).filter(function(Yt) {
      return Yt;
    });
    return V ? Qt : Qt.slice(0, 1);
  }, [Te, qe, V]), Ct = reactExports.useMemo(function() {
    return !V && qe ? [qe] : Te.filter(function(Qt) {
      return Qt;
    });
  }, [Te, qe, V]);
  reactExports.useEffect(function() {
    he || ot(null);
  }, [he]);
  var Tt = usePresets(te), yt = function(Yt) {
    ot(Yt), Ye("preset");
  }, bt = function(Yt) {
    var dr = V ? be(ce(), Yt) : [Yt], Ar = Ve(dr);
    Ar && !V && ye(!1, {
      force: !0
    });
  }, It = function(Yt) {
    bt(Yt);
  }, kt = function(Yt) {
    ot(Yt), Ye("cell");
  }, $t = function(Yt) {
    ye(!0), Ue(Yt);
  }, Lt = function(Yt) {
    if (Me("panel"), !(V && Xe !== j)) {
      var dr = V ? be(ce(), Yt) : [Yt];
      Ee(dr), !$ && !v && p === Xe && Mt();
    }
  }, Ft = function() {
    ye(!1);
  }, Vt = useCellRender$1(se, ie, fe), rr = reactExports.useMemo(function() {
    var Qt = pickAttrs(d, !1), Yt = omit(d, [].concat(_toConsumableArray$e(Object.keys(Qt)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange"]));
    return _objectSpread2$1(_objectSpread2$1({}, Yt), {}, {
      multiple: d.multiple
    });
  }, [d]), br = /* @__PURE__ */ reactExports.createElement(Popup$1, _extends$3({}, rr, {
    showNow: nt,
    showTime: k,
    disabledDate: E,
    onFocus: $t,
    onBlur: je,
    picker: j,
    mode: Ne,
    internalMode: Xe,
    onPanelChange: Et,
    format: x,
    value: Te,
    isInvalid: g,
    onChange: null,
    onSelect: Lt,
    pickerValue: mt,
    defaultOpenValue: k?.defaultOpenValue,
    onPickerValueChange: pt,
    hoverValue: Je,
    onHover: kt,
    needConfirm: $,
    onSubmit: Mt,
    onOk: _e,
    presets: Tt,
    onPresetHover: yt,
    onPresetSubmit: bt,
    onNow: It,
    cellRender: Vt
  })), Gt = function(Yt) {
    Ee(Yt);
  }, qt = function() {
    Me("input");
  }, Jt = function(Yt) {
    Me("input"), ye(!0, {
      inherit: !0
    }), Ue(Yt);
  }, jt = function(Yt) {
    ye(!1), je(Yt);
  }, Ht = function(Yt, dr) {
    Yt.key === "Tab" && Mt(), I?.(Yt, dr);
  }, ur = reactExports.useMemo(function() {
    return {
      prefixCls: y,
      locale: M,
      generateConfig: W,
      button: ae.button,
      input: ae.input
    };
  }, [y, M, W, ae.button, ae.input]);
  return useLayoutEffect$1(function() {
    he && Fe !== void 0 && Et(null, j, !1);
  }, [he, Fe, j]), useLayoutEffect$1(function() {
    var Qt = Me();
    !he && Qt === "input" && (ye(!1), Mt()), !he && v && !$ && Qt === "panel" && Mt();
  }, [he]), /* @__PURE__ */ reactExports.createElement(PickerContext.Provider, {
    value: ur
  }, /* @__PURE__ */ reactExports.createElement(PickerTrigger, _extends$3({}, pickTriggerProps(d), {
    popupElement: br,
    popupStyle: f.popup,
    popupClassName: m.popup,
    visible: he,
    onClose: Ft
  }), /* @__PURE__ */ reactExports.createElement(
    RefSingleSelector,
    _extends$3({}, d, {
      // Ref
      ref: me,
      suffixIcon: Y,
      removeIcon: ee,
      activeHelp: !!qe,
      allHelp: !!qe && et === "preset",
      focused: Be,
      onFocus: Jt,
      onBlur: jt,
      onKeyDown: Ht,
      onSubmit: Mt,
      value: Ct,
      maskFormat: x,
      onChange: Gt,
      onInputChange: qt,
      internalPicker: p,
      format: A,
      inputReadOnly: q,
      disabled: _,
      open: he,
      onOpenChange: ye,
      onClick: Nt,
      onClear: _t,
      invalid: ft,
      onInvalid: function(Yt) {
        st(Yt, 0);
      }
    })
  )));
}
var RefPicker = /* @__PURE__ */ reactExports.forwardRef(Picker);
const RadioGroupContext = /* @__PURE__ */ reactExports.createContext(null), RadioGroupContextProvider = RadioGroupContext.Provider, RadioOptionTypeContext = /* @__PURE__ */ reactExports.createContext(null), RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;
var _excluded$v = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], Checkbox$3 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = c === void 0 ? "rc-checkbox" : c, d = a.className, p = a.style, v = a.checked, A = a.disabled, x = a.defaultChecked, g = x === void 0 ? !1 : x, b = a.type, y = b === void 0 ? "checkbox" : b, f = a.title, m = a.onChange, C = _objectWithoutProperties$2(a, _excluded$v), w = reactExports.useRef(null), S = reactExports.useRef(null), $ = useMergedState(g, {
    value: v
  }), T = _slicedToArray$e($, 2), I = T[0], _ = T[1];
  reactExports.useImperativeHandle(s, function() {
    return {
      focus: function(L) {
        var B;
        (B = w.current) === null || B === void 0 || B.focus(L);
      },
      blur: function() {
        var L;
        (L = w.current) === null || L === void 0 || L.blur();
      },
      input: w.current,
      nativeElement: S.current
    };
  });
  var E = classnames(u, d, _defineProperty$a(_defineProperty$a({}, "".concat(u, "-checked"), I), "".concat(u, "-disabled"), A)), R = function(L) {
    A || ("checked" in a || _(L.target.checked), m?.({
      target: _objectSpread2$1(_objectSpread2$1({}, a), {}, {
        type: y,
        checked: L.target.checked
      }),
      stopPropagation: function() {
        L.stopPropagation();
      },
      preventDefault: function() {
        L.preventDefault();
      },
      nativeEvent: L.nativeEvent
    }));
  };
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: E,
    title: f,
    style: p,
    ref: S
  }, /* @__PURE__ */ reactExports.createElement("input", _extends$3({}, C, {
    className: "".concat(u, "-input"),
    ref: w,
    onChange: R,
    disabled: A,
    checked: !!I,
    type: y
  })), /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(u, "-inner")
  }));
});
function useBubbleLock(a) {
  const s = React.useRef(null), c = () => {
    wrapperRaf.cancel(s.current), s.current = null;
  };
  return [() => {
    c(), s.current = wrapperRaf(() => {
      s.current = null;
    });
  }, (p) => {
    s.current && (p.stopPropagation(), c()), a?.(p);
  }];
}
const getGroupRadioStyle = (a) => {
  const {
    componentCls: s,
    antCls: c
  } = a, u = `${s}-group`;
  return {
    [u]: Object.assign(Object.assign({}, resetComponent(a)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${u}-rtl`]: {
        direction: "rtl"
      },
      [`&${u}-block`]: {
        display: "flex"
      },
      [`${c}-badge ${c}-badge-count`]: {
        zIndex: 1
      },
      [`> ${c}-badge:not(:first-child) > ${c}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
}, getRadioBasicStyle = (a) => {
  const {
    componentCls: s,
    wrapperMarginInlineEnd: c,
    colorPrimary: u,
    radioSize: d,
    motionDurationSlow: p,
    motionDurationMid: v,
    motionEaseInOutCirc: A,
    colorBgContainer: x,
    colorBorder: g,
    lineWidth: b,
    colorBgContainerDisabled: y,
    colorTextDisabled: f,
    paddingXS: m,
    dotColorDisabled: C,
    lineType: w,
    radioColor: S,
    radioBgColor: $,
    calc: T
  } = a, I = `${s}-inner`, E = T(d).sub(T(4).mul(2)), R = T(1).mul(d).equal({
    unit: !0
  });
  return {
    [`${s}-wrapper`]: Object.assign(Object.assign({}, resetComponent(a)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: c,
      cursor: "pointer",
      "&:last-child": {
        marginInlineEnd: 0
      },
      // RTL
      [`&${s}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: a.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      "&-block": {
        flex: 1,
        justifyContent: "center"
      },
      // hashId 在 wrapper 上，只能铺平
      [`${s}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${unit$1(b)} ${w} ${u}`,
        borderRadius: "50%",
        visibility: "hidden",
        opacity: 0,
        content: '""'
      },
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${s}-wrapper:hover &,
        &:hover ${I}`]: {
        borderColor: u
      },
      [`${s}-input:focus-visible + ${I}`]: Object.assign({}, genFocusOutline(a)),
      [`${s}:hover::after, ${s}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${s}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: R,
          height: R,
          marginBlockStart: T(1).mul(d).div(-2).equal({
            unit: !0
          }),
          marginInlineStart: T(1).mul(d).div(-2).equal({
            unit: !0
          }),
          backgroundColor: S,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: R,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${p} ${A}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: R,
        height: R,
        backgroundColor: x,
        borderColor: g,
        borderStyle: "solid",
        borderWidth: b,
        borderRadius: "50%",
        transition: `all ${v}`
      },
      [`${s}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${s}-checked`]: {
        [I]: {
          borderColor: u,
          backgroundColor: $,
          "&::after": {
            transform: `scale(${a.calc(a.dotSize).div(d).equal()})`,
            opacity: 1,
            transition: `all ${p} ${A}`
          }
        }
      },
      [`${s}-disabled`]: {
        cursor: "not-allowed",
        [I]: {
          backgroundColor: y,
          borderColor: g,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: C
          }
        },
        [`${s}-input`]: {
          cursor: "not-allowed"
        },
        [`${s}-disabled + span`]: {
          color: f,
          cursor: "not-allowed"
        },
        [`&${s}-checked`]: {
          [I]: {
            "&::after": {
              transform: `scale(${T(E).div(d).equal()})`
            }
          }
        }
      },
      [`span${s} + *`]: {
        paddingInlineStart: m,
        paddingInlineEnd: m
      }
    })
  };
}, getRadioButtonStyle = (a) => {
  const {
    buttonColor: s,
    controlHeight: c,
    componentCls: u,
    lineWidth: d,
    lineType: p,
    colorBorder: v,
    motionDurationSlow: A,
    motionDurationMid: x,
    buttonPaddingInline: g,
    fontSize: b,
    buttonBg: y,
    fontSizeLG: f,
    controlHeightLG: m,
    controlHeightSM: C,
    paddingXS: w,
    borderRadius: S,
    borderRadiusSM: $,
    borderRadiusLG: T,
    buttonCheckedBg: I,
    buttonSolidCheckedColor: _,
    colorTextDisabled: E,
    colorBgContainerDisabled: R,
    buttonCheckedBgDisabled: O,
    buttonCheckedColorDisabled: L,
    colorPrimary: B,
    colorPrimaryHover: F,
    colorPrimaryActive: M,
    buttonSolidCheckedBg: W,
    buttonSolidCheckedHoverBg: j,
    buttonSolidCheckedActiveBg: G,
    calc: U
  } = a;
  return {
    [`${u}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: c,
      margin: 0,
      paddingInline: g,
      paddingBlock: 0,
      color: s,
      fontSize: b,
      lineHeight: unit$1(U(c).sub(U(d).mul(2)).equal()),
      background: y,
      border: `${unit$1(d)} ${p} ${v}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: U(d).add(0.02).equal(),
      borderInlineStartWidth: 0,
      borderInlineEndWidth: d,
      cursor: "pointer",
      transition: [`color ${x}`, `background ${x}`, `box-shadow ${x}`].join(","),
      a: {
        color: s
      },
      [`> ${u}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:first-child)": {
        "&::before": {
          position: "absolute",
          insetBlockStart: U(d).mul(-1).equal(),
          insetInlineStart: U(d).mul(-1).equal(),
          display: "block",
          boxSizing: "content-box",
          width: 1,
          height: "100%",
          paddingBlock: d,
          paddingInline: 0,
          backgroundColor: v,
          transition: `background-color ${A}`,
          content: '""'
        }
      },
      "&:first-child": {
        borderInlineStart: `${unit$1(d)} ${p} ${v}`,
        borderStartStartRadius: S,
        borderEndStartRadius: S
      },
      "&:last-child": {
        borderStartEndRadius: S,
        borderEndEndRadius: S
      },
      "&:first-child:last-child": {
        borderRadius: S
      },
      [`${u}-group-large &`]: {
        height: m,
        fontSize: f,
        lineHeight: unit$1(U(m).sub(U(d).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: T,
          borderEndStartRadius: T
        },
        "&:last-child": {
          borderStartEndRadius: T,
          borderEndEndRadius: T
        }
      },
      [`${u}-group-small &`]: {
        height: C,
        paddingInline: U(w).sub(d).equal(),
        paddingBlock: 0,
        lineHeight: unit$1(U(C).sub(U(d).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: $,
          borderEndStartRadius: $
        },
        "&:last-child": {
          borderStartEndRadius: $,
          borderEndEndRadius: $
        }
      },
      "&:hover": {
        position: "relative",
        color: B
      },
      "&:has(:focus-visible)": Object.assign({}, genFocusOutline(a)),
      [`${u}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${u}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: B,
        background: I,
        borderColor: B,
        "&::before": {
          backgroundColor: B
        },
        "&:first-child": {
          borderColor: B
        },
        "&:hover": {
          color: F,
          borderColor: F,
          "&::before": {
            backgroundColor: F
          }
        },
        "&:active": {
          color: M,
          borderColor: M,
          "&::before": {
            backgroundColor: M
          }
        }
      },
      [`${u}-group-solid &-checked:not(${u}-button-wrapper-disabled)`]: {
        color: _,
        background: W,
        borderColor: W,
        "&:hover": {
          color: _,
          background: j,
          borderColor: j
        },
        "&:active": {
          color: _,
          background: G,
          borderColor: G
        }
      },
      "&-disabled": {
        color: E,
        backgroundColor: R,
        borderColor: v,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: E,
          backgroundColor: R,
          borderColor: v
        }
      },
      [`&-disabled${u}-button-wrapper-checked`]: {
        color: L,
        backgroundColor: O,
        borderColor: v,
        boxShadow: "none"
      },
      "&-block": {
        flex: 1,
        textAlign: "center"
      }
    }
  };
}, prepareComponentToken$k = (a) => {
  const {
    wireframe: s,
    padding: c,
    marginXS: u,
    lineWidth: d,
    fontSizeLG: p,
    colorText: v,
    colorBgContainer: A,
    colorTextDisabled: x,
    controlItemBgActiveDisabled: g,
    colorTextLightSolid: b,
    colorPrimary: y,
    colorPrimaryHover: f,
    colorPrimaryActive: m,
    colorWhite: C
  } = a, w = 4, S = p, $ = s ? S - w * 2 : S - (w + d) * 2;
  return {
    // Radio
    radioSize: S,
    dotSize: $,
    dotColorDisabled: x,
    // Radio buttons
    buttonSolidCheckedColor: b,
    buttonSolidCheckedBg: y,
    buttonSolidCheckedHoverBg: f,
    buttonSolidCheckedActiveBg: m,
    buttonBg: A,
    buttonCheckedBg: A,
    buttonColor: v,
    buttonCheckedBgDisabled: g,
    buttonCheckedColorDisabled: x,
    buttonPaddingInline: c - d,
    wrapperMarginInlineEnd: u,
    // internal
    radioColor: s ? y : C,
    radioBgColor: s ? A : y
  };
}, useStyle$o = genStyleHooks("Radio", (a) => {
  const {
    controlOutline: s,
    controlOutlineWidth: c
  } = a, u = `0 0 0 ${unit$1(c)} ${s}`, p = merge(a, {
    radioFocusShadow: u,
    radioButtonFocusShadow: u
  });
  return [getGroupRadioStyle(p), getRadioBasicStyle(p), getRadioButtonStyle(p)];
}, prepareComponentToken$k, {
  unitless: {
    radioSize: !0,
    dotSize: !0
  }
});
var __rest$Q = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalRadio = (a, s) => {
  var c, u;
  const d = reactExports.useContext(RadioGroupContext), p = reactExports.useContext(RadioOptionTypeContext), {
    getPrefixCls: v,
    direction: A,
    radio: x
  } = reactExports.useContext(ConfigContext$1), g = reactExports.useRef(null), b = composeRef(s, g), {
    isFormItemInput: y
  } = reactExports.useContext(FormItemInputContext), f = (k) => {
    var N, P;
    (N = a.onChange) === null || N === void 0 || N.call(a, k), (P = d?.onChange) === null || P === void 0 || P.call(d, k);
  }, {
    prefixCls: m,
    className: C,
    rootClassName: w,
    children: S,
    style: $,
    title: T
  } = a, I = __rest$Q(a, ["prefixCls", "className", "rootClassName", "children", "style", "title"]), _ = v("radio", m), E = (d?.optionType || p) === "button", R = E ? `${_}-button` : _, O = useCSSVarCls(_), [L, B, F] = useStyle$o(_, O), M = Object.assign({}, I), W = reactExports.useContext(DisabledContext);
  d && (M.name = d.name, M.onChange = f, M.checked = a.value === d.value, M.disabled = (c = M.disabled) !== null && c !== void 0 ? c : d.disabled), M.disabled = (u = M.disabled) !== null && u !== void 0 ? u : W;
  const j = classnames(`${R}-wrapper`, {
    [`${R}-wrapper-checked`]: M.checked,
    [`${R}-wrapper-disabled`]: M.disabled,
    [`${R}-wrapper-rtl`]: A === "rtl",
    [`${R}-wrapper-in-form-item`]: y,
    [`${R}-wrapper-block`]: !!d?.block
  }, x?.className, C, w, B, F, O), [G, U] = useBubbleLock(M.onClick);
  return L(/* @__PURE__ */ reactExports.createElement(Wave, {
    component: "Radio",
    disabled: M.disabled
  }, /* @__PURE__ */ reactExports.createElement("label", {
    className: j,
    style: Object.assign(Object.assign({}, x?.style), $),
    onMouseEnter: a.onMouseEnter,
    onMouseLeave: a.onMouseLeave,
    title: T,
    onClick: G
  }, /* @__PURE__ */ reactExports.createElement(Checkbox$3, Object.assign({}, M, {
    className: classnames(M.className, {
      [TARGET_CLS]: !E
    }),
    type: "radio",
    prefixCls: R,
    ref: b,
    onClick: U
  })), S !== void 0 ? /* @__PURE__ */ reactExports.createElement("span", {
    className: `${R}-label`
  }, S) : null)));
}, Radio$2 = /* @__PURE__ */ reactExports.forwardRef(InternalRadio), RadioGroup = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: c,
    direction: u
  } = reactExports.useContext(ConfigContext$1), d = useId$2(), {
    prefixCls: p,
    className: v,
    rootClassName: A,
    options: x,
    buttonStyle: g = "outline",
    disabled: b,
    children: y,
    size: f,
    style: m,
    id: C,
    optionType: w,
    name: S = d,
    defaultValue: $,
    value: T,
    block: I = !1,
    onChange: _,
    onMouseEnter: E,
    onMouseLeave: R,
    onFocus: O,
    onBlur: L
  } = a, [B, F] = useMergedState($, {
    value: T
  }), M = reactExports.useCallback((Z) => {
    const ne = B, K = Z.target.value;
    "value" in a || F(K), K !== ne && _?.(Z);
  }, [B, F, _]), W = c("radio", p), j = `${W}-group`, G = useCSSVarCls(W), [U, k, N] = useStyle$o(W, G);
  let P = y;
  x && x.length > 0 && (P = x.map((Z) => typeof Z == "string" || typeof Z == "number" ? /* @__PURE__ */ reactExports.createElement(Radio$2, {
    key: Z.toString(),
    prefixCls: W,
    disabled: b,
    value: Z,
    checked: B === Z
  }, Z) : /* @__PURE__ */ reactExports.createElement(Radio$2, {
    key: `radio-group-value-options-${Z.value}`,
    prefixCls: W,
    disabled: Z.disabled || b,
    value: Z.value,
    checked: B === Z.value,
    title: Z.title,
    style: Z.style,
    className: Z.className,
    id: Z.id,
    required: Z.required
  }, Z.label)));
  const D = useSize(f), H = classnames(j, `${j}-${g}`, {
    [`${j}-${D}`]: D,
    [`${j}-rtl`]: u === "rtl",
    [`${j}-block`]: I
  }, v, A, k, N, G), V = reactExports.useMemo(() => ({
    onChange: M,
    value: B,
    disabled: b,
    name: S,
    optionType: w,
    block: I
  }), [M, B, b, S, w, I]);
  return U(/* @__PURE__ */ reactExports.createElement("div", Object.assign({}, pickAttrs(a, {
    aria: !0,
    data: !0
  }), {
    className: H,
    style: m,
    onMouseEnter: E,
    onMouseLeave: R,
    onFocus: O,
    onBlur: L,
    id: C,
    ref: s
  }), /* @__PURE__ */ reactExports.createElement(RadioGroupContextProvider, {
    value: V
  }, P)));
}), Group$2 = /* @__PURE__ */ reactExports.memo(RadioGroup);
var __rest$P = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const RadioButton = (a, s) => {
  const {
    getPrefixCls: c
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: u
  } = a, d = __rest$P(a, ["prefixCls"]), p = c("radio", u);
  return /* @__PURE__ */ reactExports.createElement(RadioOptionTypeContextProvider, {
    value: "button"
  }, /* @__PURE__ */ reactExports.createElement(Radio$2, Object.assign({
    prefixCls: p
  }, d, {
    type: "radio",
    ref: s
  })));
}, Button = /* @__PURE__ */ reactExports.forwardRef(RadioButton), Radio$1 = Radio$2;
Radio$1.Button = Button;
Radio$1.Group = Group$2;
Radio$1.__ANT_RADIO = !0;
function initInputToken(a) {
  return merge(a, {
    inputAffixPadding: a.paddingXXS
  });
}
const initComponentToken$1 = (a) => {
  const {
    controlHeight: s,
    fontSize: c,
    lineHeight: u,
    lineWidth: d,
    controlHeightSM: p,
    controlHeightLG: v,
    fontSizeLG: A,
    lineHeightLG: x,
    paddingSM: g,
    controlPaddingHorizontalSM: b,
    controlPaddingHorizontal: y,
    colorFillAlter: f,
    colorPrimaryHover: m,
    colorPrimary: C,
    controlOutlineWidth: w,
    controlOutline: S,
    colorErrorOutline: $,
    colorWarningOutline: T,
    colorBgContainer: I,
    inputFontSize: _,
    inputFontSizeLG: E,
    inputFontSizeSM: R
  } = a, O = _ || c, L = R || O, B = E || A, F = Math.round((s - O * u) / 2 * 10) / 10 - d, M = Math.round((p - L * u) / 2 * 10) / 10 - d, W = Math.ceil((v - B * x) / 2 * 10) / 10 - d;
  return {
    paddingBlock: Math.max(F, 0),
    paddingBlockSM: Math.max(M, 0),
    paddingBlockLG: Math.max(W, 0),
    paddingInline: g - d,
    paddingInlineSM: b - d,
    paddingInlineLG: y - d,
    addonBg: f,
    activeBorderColor: C,
    hoverBorderColor: m,
    activeShadow: `0 0 0 ${w}px ${S}`,
    errorActiveShadow: `0 0 0 ${w}px ${$}`,
    warningActiveShadow: `0 0 0 ${w}px ${T}`,
    hoverBg: I,
    activeBg: I,
    inputFontSize: O,
    inputFontSizeLG: B,
    inputFontSizeSM: L
  };
}, genHoverStyle = (a) => ({
  borderColor: a.hoverBorderColor,
  backgroundColor: a.hoverBg
}), genDisabledStyle = (a) => ({
  color: a.colorTextDisabled,
  backgroundColor: a.colorBgContainerDisabled,
  borderColor: a.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, genHoverStyle(merge(a, {
    hoverBorderColor: a.colorBorder,
    hoverBg: a.colorBgContainerDisabled
  })))
}), genBaseOutlinedStyle = (a, s) => ({
  background: a.colorBgContainer,
  borderWidth: a.lineWidth,
  borderStyle: a.lineType,
  borderColor: s.borderColor,
  "&:hover": {
    borderColor: s.hoverBorderColor,
    backgroundColor: a.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: s.activeBorderColor,
    boxShadow: s.activeShadow,
    outline: 0,
    backgroundColor: a.activeBg
  }
}), genOutlinedStatusStyle = (a, s) => ({
  [`&${a.componentCls}-status-${s.status}:not(${a.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseOutlinedStyle(a, s)), {
    [`${a.componentCls}-prefix, ${a.componentCls}-suffix`]: {
      color: s.affixColor
    }
  }),
  [`&${a.componentCls}-status-${s.status}${a.componentCls}-disabled`]: {
    borderColor: s.borderColor
  }
}), genOutlinedStyle = (a, s) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle(a, {
    borderColor: a.colorBorder,
    hoverBorderColor: a.hoverBorderColor,
    activeBorderColor: a.activeBorderColor,
    activeShadow: a.activeShadow
  })), {
    [`&${a.componentCls}-disabled, &[disabled]`]: Object.assign({}, genDisabledStyle(a))
  }), genOutlinedStatusStyle(a, {
    status: "error",
    borderColor: a.colorError,
    hoverBorderColor: a.colorErrorBorderHover,
    activeBorderColor: a.colorError,
    activeShadow: a.errorActiveShadow,
    affixColor: a.colorError
  })), genOutlinedStatusStyle(a, {
    status: "warning",
    borderColor: a.colorWarning,
    hoverBorderColor: a.colorWarningBorderHover,
    activeBorderColor: a.colorWarning,
    activeShadow: a.warningActiveShadow,
    affixColor: a.colorWarning
  })), s)
}), genOutlinedGroupStatusStyle = (a, s) => ({
  [`&${a.componentCls}-group-wrapper-status-${s.status}`]: {
    [`${a.componentCls}-group-addon`]: {
      borderColor: s.addonBorderColor,
      color: s.addonColor
    }
  }
}), genOutlinedGroupStyle = (a) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${a.componentCls}-group`]: {
      "&-addon": {
        background: a.addonBg,
        border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, genOutlinedGroupStatusStyle(a, {
    status: "error",
    addonBorderColor: a.colorError,
    addonColor: a.colorErrorText
  })), genOutlinedGroupStatusStyle(a, {
    status: "warning",
    addonBorderColor: a.colorWarning,
    addonColor: a.colorWarningText
  })), {
    [`&${a.componentCls}-group-wrapper-disabled`]: {
      [`${a.componentCls}-group-addon`]: Object.assign({}, genDisabledStyle(a))
    }
  })
}), genBorderlessStyle = (a, s) => {
  const {
    componentCls: c
  } = a;
  return {
    "&-borderless": Object.assign({
      background: "transparent",
      border: "none",
      "&:focus, &:focus-within": {
        outline: "none"
      },
      // >>>>> Disabled
      [`&${c}-disabled, &[disabled]`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed"
      },
      // >>>>> Status
      [`&${c}-status-error`]: {
        "&, & input, & textarea": {
          color: a.colorError
        }
      },
      [`&${c}-status-warning`]: {
        "&, & input, & textarea": {
          color: a.colorWarning
        }
      }
    }, s)
  };
}, genBaseFilledStyle = (a, s) => {
  var c;
  return {
    background: s.bg,
    borderWidth: a.lineWidth,
    borderStyle: a.lineType,
    borderColor: "transparent",
    "input&, & input, textarea&, & textarea": {
      color: (c = s?.inputColor) !== null && c !== void 0 ? c : "unset"
    },
    "&:hover": {
      background: s.hoverBg
    },
    "&:focus, &:focus-within": {
      outline: 0,
      borderColor: s.activeBorderColor,
      backgroundColor: a.activeBg
    }
  };
}, genFilledStatusStyle = (a, s) => ({
  [`&${a.componentCls}-status-${s.status}:not(${a.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseFilledStyle(a, s)), {
    [`${a.componentCls}-prefix, ${a.componentCls}-suffix`]: {
      color: s.affixColor
    }
  })
}), genFilledStyle = (a, s) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle(a, {
    bg: a.colorFillTertiary,
    hoverBg: a.colorFillSecondary,
    activeBorderColor: a.activeBorderColor
  })), {
    [`&${a.componentCls}-disabled, &[disabled]`]: Object.assign({}, genDisabledStyle(a))
  }), genFilledStatusStyle(a, {
    status: "error",
    bg: a.colorErrorBg,
    hoverBg: a.colorErrorBgHover,
    activeBorderColor: a.colorError,
    inputColor: a.colorErrorText,
    affixColor: a.colorError
  })), genFilledStatusStyle(a, {
    status: "warning",
    bg: a.colorWarningBg,
    hoverBg: a.colorWarningBgHover,
    activeBorderColor: a.colorWarning,
    inputColor: a.colorWarningText,
    affixColor: a.colorWarning
  })), s)
}), genFilledGroupStatusStyle = (a, s) => ({
  [`&${a.componentCls}-group-wrapper-status-${s.status}`]: {
    [`${a.componentCls}-group-addon`]: {
      background: s.addonBg,
      color: s.addonColor
    }
  }
}), genFilledGroupStyle = (a) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${a.componentCls}-group-addon`]: {
      background: a.colorFillTertiary,
      "&:last-child": {
        position: "static"
      }
    }
  }, genFilledGroupStatusStyle(a, {
    status: "error",
    addonBg: a.colorErrorBg,
    addonColor: a.colorErrorText
  })), genFilledGroupStatusStyle(a, {
    status: "warning",
    addonBg: a.colorWarningBg,
    addonColor: a.colorWarningText
  })), {
    [`&${a.componentCls}-group-wrapper-disabled`]: {
      [`${a.componentCls}-group`]: {
        "&-addon": {
          background: a.colorFillTertiary,
          color: a.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
          borderTop: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
          borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
          borderTop: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
          borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
        }
      }
    }
  })
}), genBaseUnderlinedStyle = (a, s) => ({
  background: a.colorBgContainer,
  borderWidth: `${unit$1(a.lineWidth)} 0`,
  borderStyle: `${a.lineType} none`,
  borderColor: `transparent transparent ${s.borderColor} transparent`,
  borderRadius: 0,
  "&:hover": {
    borderColor: `transparent transparent ${s.borderColor} transparent`,
    backgroundColor: a.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: `transparent transparent ${s.borderColor} transparent`,
    outline: 0,
    backgroundColor: a.activeBg
  }
}), genUnderlinedStatusStyle = (a, s) => ({
  [`&${a.componentCls}-status-${s.status}:not(${a.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseUnderlinedStyle(a, s)), {
    [`${a.componentCls}-prefix, ${a.componentCls}-suffix`]: {
      color: s.affixColor
    }
  }),
  [`&${a.componentCls}-status-${s.status}${a.componentCls}-disabled`]: {
    borderColor: `transparent transparent ${s.borderColor} transparent`
  }
}), genUnderlinedStyle = (a, s) => ({
  "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseUnderlinedStyle(a, {
    borderColor: a.colorBorder,
    hoverBorderColor: a.hoverBorderColor,
    activeBorderColor: a.activeBorderColor,
    activeShadow: a.activeShadow
  })), {
    // >>>>> Disabled
    [`&${a.componentCls}-disabled, &[disabled]`]: {
      color: a.colorTextDisabled,
      boxShadow: "none",
      cursor: "not-allowed",
      "&:hover": {
        borderColor: `transparent transparent ${a.colorBorder} transparent`
      }
    },
    "input[disabled], textarea[disabled]": {
      cursor: "not-allowed"
    }
  }), genUnderlinedStatusStyle(a, {
    status: "error",
    borderColor: a.colorError,
    hoverBorderColor: a.colorErrorBorderHover,
    activeBorderColor: a.colorError,
    activeShadow: a.errorActiveShadow,
    affixColor: a.colorError
  })), genUnderlinedStatusStyle(a, {
    status: "warning",
    borderColor: a.colorWarning,
    hoverBorderColor: a.colorWarningBorderHover,
    activeBorderColor: a.colorWarning,
    activeShadow: a.warningActiveShadow,
    affixColor: a.colorWarning
  })), s)
}), genPlaceholderStyle = (a) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: a,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), genInputLargeStyle = (a) => {
  const {
    paddingBlockLG: s,
    lineHeightLG: c,
    borderRadiusLG: u,
    paddingInlineLG: d
  } = a;
  return {
    padding: `${unit$1(s)} ${unit$1(d)}`,
    fontSize: a.inputFontSizeLG,
    lineHeight: c,
    borderRadius: u
  };
}, genInputSmallStyle = (a) => ({
  padding: `${unit$1(a.paddingBlockSM)} ${unit$1(a.paddingInlineSM)}`,
  fontSize: a.inputFontSizeSM,
  borderRadius: a.borderRadiusSM
}), genBasicInputStyle = (a) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${unit$1(a.paddingBlock)} ${unit$1(a.paddingInline)}`,
  color: a.colorText,
  fontSize: a.inputFontSize,
  lineHeight: a.lineHeight,
  borderRadius: a.borderRadius,
  transition: `all ${a.motionDurationMid}`
}, genPlaceholderStyle(a.colorTextPlaceholder)), {
  // Size
  "&-lg": Object.assign({}, genInputLargeStyle(a)),
  "&-sm": Object.assign({}, genInputSmallStyle(a)),
  // RTL
  "&-rtl, &-textarea-rtl": {
    direction: "rtl"
  }
}), genInputGroupStyle = (a) => {
  const {
    componentCls: s,
    antCls: c
  } = a;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: a.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${s}, &-lg > ${s}-group-addon`]: Object.assign({}, genInputLargeStyle(a)),
    [`&-sm ${s}, &-sm > ${s}-group-addon`]: Object.assign({}, genInputSmallStyle(a)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${c}-select-single ${c}-select-selector`]: {
      height: a.controlHeightLG
    },
    [`&-sm ${c}-select-single ${c}-select-selector`]: {
      height: a.controlHeightSM
    },
    [`> ${s}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${s}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${unit$1(a.paddingInline)}`,
        color: a.colorText,
        fontWeight: "normal",
        fontSize: a.inputFontSize,
        textAlign: "center",
        borderRadius: a.borderRadius,
        transition: `all ${a.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${c}-select`]: {
          margin: `${unit$1(a.calc(a.paddingBlock).add(1).mul(-1).equal())} ${unit$1(a.calc(a.paddingInline).mul(-1).equal())}`,
          [`&${c}-select-single:not(${c}-select-customize-input):not(${c}-pagination-size-changer)`]: {
            [`${c}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
              boxShadow: "none"
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${c}-cascader-picker`]: {
          margin: `-9px ${unit$1(a.calc(a.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${c}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [s]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${s}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${s}:first-child, ${s}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${c}-select ${c}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${s}-affix-wrapper`]: {
      [`&:not(:first-child) ${s}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${s}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${s}:last-child, ${s}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${c}-select ${c}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${s}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${s}-search &`]: {
          borderStartStartRadius: a.borderRadius,
          borderEndStartRadius: a.borderRadius
        }
      },
      [`&:not(:first-child), ${s}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${s}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, clearFix()), {
      [`${s}-group-addon, ${s}-group-wrap, > ${s}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: a.lineWidth,
          "&:hover, &:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-flex",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${s}-affix-wrapper,
        & > ${s}-number-affix-wrapper,
        & > ${c}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: a.calc(a.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: a.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [s]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${c}-select > ${c}-select-selector,
      & > ${c}-select-auto-complete ${s},
      & > ${c}-cascader-picker ${s},
      & > ${s}-group-wrapper ${s}`]: {
        borderInlineEndWidth: a.lineWidth,
        borderRadius: 0,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`& > ${c}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${c}-select > ${c}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${c}-select:first-child > ${c}-select-selector,
      & > ${c}-select-auto-complete:first-child ${s},
      & > ${c}-cascader-picker:first-child ${s}`]: {
        borderStartStartRadius: a.borderRadius,
        borderEndStartRadius: a.borderRadius
      },
      [`& > *:last-child,
      & > ${c}-select:last-child > ${c}-select-selector,
      & > ${c}-cascader-picker:last-child ${s},
      & > ${c}-cascader-picker-focused:last-child ${s}`]: {
        borderInlineEndWidth: a.lineWidth,
        borderStartEndRadius: a.borderRadius,
        borderEndEndRadius: a.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${c}-select-auto-complete ${s}`]: {
        verticalAlign: "top"
      },
      [`${s}-group-wrapper + ${s}-group-wrapper`]: {
        marginInlineStart: a.calc(a.lineWidth).mul(-1).equal(),
        [`${s}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${s}-group-wrapper:not(:last-child)`]: {
        [`&${s}-search > ${s}-group`]: {
          [`& > ${s}-group-addon > ${s}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${s}`]: {
            borderStartStartRadius: a.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: a.borderRadius
          }
        }
      }
    })
  };
}, genInputStyle = (a) => {
  const {
    componentCls: s,
    controlHeightSM: c,
    lineWidth: u,
    calc: d
  } = a, v = d(c).sub(d(u).mul(2)).sub(16).div(2).equal();
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genBasicInputStyle(a)), genOutlinedStyle(a)), genFilledStyle(a)), genBorderlessStyle(a)), genUnderlinedStyle(a)), {
      '&[type="color"]': {
        height: a.controlHeight,
        [`&${s}-lg`]: {
          height: a.controlHeightLG
        },
        [`&${s}-sm`]: {
          height: c,
          paddingTop: v,
          paddingBottom: v
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        appearance: "none"
      }
    })
  };
}, genAllowClearStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    // ========================= Input =========================
    [`${s}-clear-icon`]: {
      margin: 0,
      padding: 0,
      lineHeight: 0,
      color: a.colorTextQuaternary,
      fontSize: a.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${a.motionDurationSlow}`,
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      "&:hover": {
        color: a.colorIcon
      },
      "&:active": {
        color: a.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${unit$1(a.inputAffixPadding)}`
      }
    }
  };
}, genAffixStyle = (a) => {
  const {
    componentCls: s,
    inputAffixPadding: c,
    colorTextDescription: u,
    motionDurationSlow: d,
    colorIcon: p,
    colorIconHover: v,
    iconCls: A
  } = a, x = `${s}-affix-wrapper`, g = `${s}-affix-wrapper-disabled`;
  return {
    [x]: Object.assign(Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(a)), {
      display: "inline-flex",
      [`&:not(${s}-disabled):hover`]: {
        zIndex: 1,
        [`${s}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${s}`]: {
        padding: 0
      },
      [`> input${s}, > textarea${s}`]: {
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [s]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: a.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: u,
          direction: "ltr"
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: a.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: c
        },
        "&-suffix": {
          marginInlineStart: c
        }
      }
    }), genAllowClearStyle(a)), {
      // password
      [`${A}${s}-password-icon`]: {
        color: p,
        cursor: "pointer",
        transition: `all ${d}`,
        "&:hover": {
          color: v
        }
      }
    }),
    // 覆盖 affix-wrapper borderRadius！
    [`${s}-underlined`]: {
      borderRadius: 0
    },
    [g]: {
      // password disabled
      [`${A}${s}-password-icon`]: {
        color: p,
        cursor: "not-allowed",
        "&:hover": {
          color: p
        }
      }
    }
  };
}, genGroupStyle = (a) => {
  const {
    componentCls: s,
    borderRadiusLG: c,
    borderRadiusSM: u
  } = a;
  return {
    [`${s}-group`]: Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genInputGroupStyle(a)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${s}-group-addon`]: {
            borderRadius: c,
            fontSize: a.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${s}-group-addon`]: {
            borderRadius: u
          }
        }
      }, genOutlinedGroupStyle(a)), genFilledGroupStyle(a)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${s}-compact-first-item):not(${s}-compact-last-item)${s}-compact-item`]: {
          [`${s}, ${s}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${s}-compact-last-item)${s}-compact-first-item`]: {
          [`${s}, ${s}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${s}-compact-first-item)${s}-compact-last-item`]: {
          [`${s}, ${s}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${s}-compact-last-item)${s}-compact-item`]: {
          [`${s}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        // Fix the issue of input use `addonAfter` param in space compact mode
        // https://github.com/ant-design/ant-design/issues/52483
        [`&:not(${s}-compact-first-item)${s}-compact-item`]: {
          [`${s}-affix-wrapper`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      })
    })
  };
}, genSearchInputStyle = (a) => {
  const {
    componentCls: s,
    antCls: c
  } = a, u = `${s}-search`;
  return {
    [u]: {
      [s]: {
        "&:hover, &:focus": {
          [`+ ${s}-group-addon ${u}-button:not(${c}-btn-color-primary):not(${c}-btn-variant-text)`]: {
            borderInlineStartColor: a.colorPrimaryHover
          }
        }
      },
      [`${s}-affix-wrapper`]: {
        height: a.controlHeight,
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
      [`${s}-lg`]: {
        lineHeight: a.calc(a.lineHeightLG).sub(2e-4).equal()
      },
      [`> ${s}-group`]: {
        [`> ${s}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${u}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${u}-button:not(${c}-btn-color-primary)`]: {
            color: a.colorTextDescription,
            "&:hover": {
              color: a.colorPrimaryHover
            },
            "&:active": {
              color: a.colorPrimaryActive
            },
            [`&${c}-btn-loading::before`]: {
              inset: 0
            }
          }
        }
      },
      [`${u}-button`]: {
        height: a.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      "&-large": {
        [`${s}-affix-wrapper, ${u}-button`]: {
          height: a.controlHeightLG
        }
      },
      "&-small": {
        [`${s}-affix-wrapper, ${u}-button`]: {
          height: a.controlHeightSM
        }
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${s}-compact-item`]: {
        [`&:not(${s}-compact-last-item)`]: {
          [`${s}-group-addon`]: {
            [`${s}-search-button`]: {
              marginInlineEnd: a.calc(a.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${s}-compact-first-item)`]: {
          [`${s},${s}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${s}-group-addon ${s}-search-button,
        > ${s},
        ${s}-affix-wrapper`]: {
          "&:hover, &:focus, &:active": {
            zIndex: 2
          }
        },
        [`> ${s}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, genRangeStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-out-of-range`]: {
      [`&, & input, & textarea, ${s}-show-count-suffix, ${s}-data-count`]: {
        color: a.colorError
      }
    }
  };
}, useSharedStyle = genStyleHooks(["Input", "Shared"], (a) => {
  const s = merge(a, initInputToken(a));
  return [genInputStyle(s), genAffixStyle(s)];
}, initComponentToken$1, {
  resetFont: !1
}), useStyle$n = genStyleHooks(["Input", "Component"], (a) => {
  const s = merge(a, initInputToken(a));
  return [
    genGroupStyle(s),
    genSearchInputStyle(s),
    genRangeStyle(s),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(s)
  ];
}, initComponentToken$1, {
  resetFont: !1
}), genSize = (a, s) => {
  const {
    componentCls: c,
    controlHeight: u
  } = a, d = s ? `${c}-${s}` : "", p = getMultipleSelectorUnit(a);
  return [
    // genSelectionStyle(token, suffix),
    {
      [`${c}-multiple${d}`]: {
        paddingBlock: p.containerPadding,
        paddingInlineStart: p.basePadding,
        minHeight: u,
        // ======================== Selections ========================
        [`${c}-selection-item`]: {
          height: p.itemHeight,
          lineHeight: unit$1(p.itemLineHeight)
        }
      }
    }
  ];
}, genPickerMultipleStyle = (a) => {
  const {
    componentCls: s,
    calc: c,
    lineWidth: u
  } = a, d = merge(a, {
    fontHeight: a.fontSize,
    selectHeight: a.controlHeightSM,
    multipleSelectItemHeight: a.multipleItemHeightSM,
    borderRadius: a.borderRadiusSM,
    borderRadiusSM: a.borderRadiusXS,
    controlHeight: a.controlHeightSM
  }), p = merge(a, {
    fontHeight: c(a.multipleItemHeightLG).sub(c(u).mul(2).equal()).equal(),
    fontSize: a.fontSizeLG,
    selectHeight: a.controlHeightLG,
    multipleSelectItemHeight: a.multipleItemHeightLG,
    borderRadius: a.borderRadiusLG,
    borderRadiusSM: a.borderRadius,
    controlHeight: a.controlHeightLG
  });
  return [
    // ======================== Size ========================
    genSize(d, "small"),
    genSize(a),
    genSize(p, "large"),
    // ====================== Selection ======================
    {
      [`${s}${s}-multiple`]: Object.assign(Object.assign({
        width: "100%",
        cursor: "text",
        // ==================== Selector =====================
        [`${s}-selector`]: {
          flex: "auto",
          padding: 0,
          position: "relative",
          "&:after": {
            margin: 0
          },
          // ================== placeholder ==================
          [`${s}-selection-placeholder`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: a.inputPaddingHorizontalBase,
            insetInlineEnd: 0,
            transform: "translateY(-50%)",
            transition: `all ${a.motionDurationSlow}`,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            flex: 1,
            color: a.colorTextPlaceholder,
            pointerEvents: "none"
          }
        }
      }, genOverflowStyle(a)), {
        // ====================== Input ======================
        // Input is `readonly`, which is used for a11y only
        [`${s}-multiple-input`]: {
          width: 0,
          height: 0,
          border: 0,
          visibility: "hidden",
          position: "absolute",
          zIndex: -1
        }
      })
    }
  ];
}, genPickerCellInnerStyle = (a) => {
  const {
    pickerCellCls: s,
    pickerCellInnerCls: c,
    cellHeight: u,
    borderRadiusSM: d,
    motionDurationMid: p,
    cellHoverBg: v,
    lineWidth: A,
    lineType: x,
    colorPrimary: g,
    cellActiveWithRangeBg: b,
    colorTextLightSolid: y,
    colorTextDisabled: f,
    cellBgDisabled: m,
    colorFillSecondary: C
  } = a;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: u,
      transform: "translateY(-50%)",
      content: '""',
      pointerEvents: "none"
    },
    // >>> Default
    [c]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: u,
      height: u,
      lineHeight: unit$1(u),
      borderRadius: d,
      transition: `background ${p}`
    },
    // >>> Hover
    [`&:hover:not(${s}-in-view):not(${s}-disabled),
    &:hover:not(${s}-selected):not(${s}-range-start):not(${s}-range-end):not(${s}-disabled)`]: {
      [c]: {
        background: v
      }
    },
    // >>> Today
    [`&-in-view${s}-today ${c}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${unit$1(A)} ${x} ${g}`,
        borderRadius: d,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${s}-in-range,
      &-in-view${s}-range-start,
      &-in-view${s}-range-end`]: {
      position: "relative",
      [`&:not(${s}-disabled):before`]: {
        background: b
      }
    },
    // >>> Selected
    [`&-in-view${s}-selected,
      &-in-view${s}-range-start,
      &-in-view${s}-range-end`]: {
      [`&:not(${s}-disabled) ${c}`]: {
        color: y,
        background: g
      },
      [`&${s}-disabled ${c}`]: {
        background: C
      }
    },
    [`&-in-view${s}-range-start:not(${s}-disabled):before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${s}-range-end:not(${s}-disabled):before`]: {
      insetInlineEnd: "50%"
    },
    // range start border-radius
    [`&-in-view${s}-range-start:not(${s}-range-end) ${c}`]: {
      borderStartStartRadius: d,
      borderEndStartRadius: d,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${s}-range-end:not(${s}-range-start) ${c}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: d,
      borderEndEndRadius: d
    },
    // >>> Disabled
    "&-disabled": {
      color: f,
      cursor: "not-allowed",
      [c]: {
        background: "transparent"
      },
      "&::before": {
        background: m
      }
    },
    [`&-disabled${s}-today ${c}::before`]: {
      borderColor: f
    }
  };
}, genPanelStyle = (a) => {
  const {
    componentCls: s,
    pickerCellCls: c,
    pickerCellInnerCls: u,
    pickerYearMonthCellWidth: d,
    pickerControlIconSize: p,
    cellWidth: v,
    paddingSM: A,
    paddingXS: x,
    paddingXXS: g,
    colorBgContainer: b,
    lineWidth: y,
    lineType: f,
    borderRadiusLG: m,
    colorPrimary: C,
    colorTextHeading: w,
    colorSplit: S,
    pickerControlIconBorderWidth: $,
    colorIcon: T,
    textHeight: I,
    motionDurationMid: _,
    colorIconHover: E,
    fontWeightStrong: R,
    cellHeight: O,
    pickerCellPaddingVertical: L,
    colorTextDisabled: B,
    colorText: F,
    fontSize: M,
    motionDurationSlow: W,
    withoutTimeCellHeight: j,
    pickerQuarterPanelContentHeight: G,
    borderRadiusSM: U,
    colorTextLightSolid: k,
    cellHoverBg: N,
    timeColumnHeight: P,
    timeColumnWidth: D,
    timeCellHeight: H,
    controlItemBgActive: V,
    marginXXS: Z,
    pickerDatePanelPaddingHorizontal: ne,
    pickerControlIconMargin: K
  } = a, q = a.calc(v).mul(7).add(a.calc(ne).mul(2)).equal();
  return {
    [s]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: b,
        borderRadius: m,
        outline: "none",
        "&-focused": {
          borderColor: C
        },
        "&-rtl": {
          [`${s}-prev-icon,
              ${s}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${s}-next-icon,
              ${s}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          },
          [`${s}-time-panel`]: {
            [`${s}-content`]: {
              direction: "ltr",
              "> *": {
                direction: "rtl"
              }
            }
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel,\n        &-week-panel,\n        &-date-panel,\n        &-time-panel": {
        display: "flex",
        flexDirection: "column",
        width: q
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${unit$1(x)}`,
        color: w,
        borderBottom: `${unit$1(y)} ${f} ${S}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: T,
          lineHeight: unit$1(I),
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${_}`,
          fontSize: "inherit",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          "&:empty": {
            display: "none"
          }
        },
        "> button": {
          minWidth: "1.6em",
          fontSize: M,
          "&:hover": {
            color: E
          },
          "&:disabled": {
            opacity: 0.25,
            pointerEvents: "none"
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: R,
          lineHeight: unit$1(I),
          "> button": {
            color: "inherit",
            fontWeight: "inherit",
            verticalAlign: "top",
            "&:not(:first-child)": {
              marginInlineStart: x
            },
            "&:hover": {
              color: C
            }
          }
        }
      },
      // Arrow button
      "&-prev-icon,\n        &-next-icon,\n        &-super-prev-icon,\n        &-super-next-icon": {
        position: "relative",
        width: p,
        height: p,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          width: p,
          height: p,
          border: "0 solid currentcolor",
          borderBlockStartWidth: $,
          borderInlineStartWidth: $,
          content: '""'
        }
      },
      "&-super-prev-icon,\n        &-super-next-icon": {
        "&::after": {
          position: "absolute",
          top: K,
          insetInlineStart: K,
          display: "inline-block",
          width: p,
          height: p,
          border: "0 solid currentcolor",
          borderBlockStartWidth: $,
          borderInlineStartWidth: $,
          content: '""'
        }
      },
      "&-prev-icon, &-super-prev-icon": {
        transform: "rotate(-45deg)"
      },
      "&-next-icon, &-super-next-icon": {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: O,
          fontWeight: "normal"
        },
        th: {
          height: a.calc(O).add(a.calc(L).mul(2)).equal(),
          color: F,
          verticalAlign: "middle"
        }
      },
      "&-cell": Object.assign({
        padding: `${unit$1(L)} 0`,
        color: B,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: F
        }
      }, genPickerCellInnerStyle(a)),
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${s}-content`]: {
          height: a.calc(j).mul(4).equal()
        },
        [u]: {
          padding: `0 ${unit$1(x)}`
        }
      },
      "&-quarter-panel": {
        [`${s}-content`]: {
          height: G
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [u]: {
          padding: `0 ${unit$1(a.calc(x).div(2).equal())}`
        },
        [`${s}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      "&-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${s}-body`]: {
          padding: `0 ${unit$1(x)}`
        },
        [u]: {
          width: d
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${s}-body`]: {
          padding: `${unit$1(x)} ${unit$1(ne)}`
        },
        [`${s}-content th`]: {
          boxSizing: "border-box",
          padding: 0
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel": {
        // Clear cell style
        [`${s}-cell`]: {
          [`&:hover ${u},
            &-selected ${u},
            ${u}`]: {
            background: "transparent !important"
          }
        },
        "&-row": {
          td: {
            "&:before": {
              transition: `background ${_}`
            },
            "&:first-child:before": {
              borderStartStartRadius: U,
              borderEndStartRadius: U
            },
            "&:last-child:before": {
              borderStartEndRadius: U,
              borderEndEndRadius: U
            }
          },
          "&:hover td:before": {
            background: N
          },
          "&-range-start td, &-range-end td, &-selected td, &-hover td": {
            // Rise priority to override hover style
            [`&${c}`]: {
              "&:before": {
                background: C
              },
              [`&${s}-cell-week`]: {
                color: new FastColor(k).setA(0.5).toHexString()
              },
              [u]: {
                color: k
              }
            }
          },
          "&-range-hover td:before": {
            background: V
          }
        }
      },
      // >>> ShowWeek
      "&-week-panel, &-date-panel-show-week": {
        [`${s}-body`]: {
          padding: `${unit$1(x)} ${unit$1(A)}`
        },
        [`${s}-content th`]: {
          width: "auto"
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${s}-time-panel`]: {
          borderInlineStart: `${unit$1(y)} ${f} ${S}`
        },
        [`${s}-date-panel,
          ${s}-time-panel`]: {
          transition: `opacity ${W}`
        },
        // Keyboard
        "&-active": {
          [`${s}-date-panel,
            ${s}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        [`${s}-content`]: {
          display: "flex",
          flex: "auto",
          height: P
        },
        "&-column": {
          flex: "1 0 auto",
          width: D,
          margin: `${unit$1(g)} 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${_}`,
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: 8,
            backgroundColor: "transparent"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: a.colorTextTertiary,
            borderRadius: a.borderRadiusSM
          },
          // For Firefox
          "&": {
            scrollbarWidth: "thin",
            scrollbarColor: `${a.colorTextTertiary} transparent`
          },
          "&::after": {
            display: "block",
            height: `calc(100% - ${unit$1(H)})`,
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${unit$1(y)} ${f} ${S}`
          },
          "&-active": {
            background: new FastColor(V).setA(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${s}-time-panel-cell`]: {
              marginInline: Z,
              [`${s}-time-panel-cell-inner`]: {
                display: "block",
                width: a.calc(D).sub(a.calc(Z).mul(2)).equal(),
                height: H,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: a.calc(D).sub(H).div(2).equal(),
                color: F,
                lineHeight: unit$1(H),
                borderRadius: U,
                cursor: "pointer",
                transition: `background ${_}`,
                "&:hover": {
                  background: N
                }
              },
              "&-selected": {
                [`${s}-time-panel-cell-inner`]: {
                  background: V
                }
              },
              "&-disabled": {
                [`${s}-time-panel-cell-inner`]: {
                  color: B,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      }
    }
  };
}, genPickerPanelStyle = (a) => {
  const {
    componentCls: s,
    textHeight: c,
    lineWidth: u,
    paddingSM: d,
    antCls: p,
    colorPrimary: v,
    cellActiveWithRangeBg: A,
    colorPrimaryBorder: x,
    lineType: g,
    colorSplit: b
  } = a;
  return {
    [`${s}-dropdown`]: {
      // ======================== Footer ========================
      [`${s}-footer`]: {
        borderTop: `${unit$1(u)} ${g} ${b}`,
        "&-extra": {
          padding: `0 ${unit$1(d)}`,
          lineHeight: unit$1(a.calc(c).sub(a.calc(u).mul(2)).equal()),
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${unit$1(u)} ${g} ${b}`
          }
        }
      },
      // ==================== Footer > Ranges ===================
      [`${s}-panels + ${s}-footer ${s}-ranges`]: {
        justifyContent: "space-between"
      },
      [`${s}-ranges`]: {
        marginBlock: 0,
        paddingInline: unit$1(d),
        overflow: "hidden",
        textAlign: "start",
        listStyle: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "> li": {
          lineHeight: unit$1(a.calc(c).sub(a.calc(u).mul(2)).equal()),
          display: "inline-block"
        },
        [`${s}-now-btn-disabled`]: {
          pointerEvents: "none",
          color: a.colorTextDisabled
        },
        // https://github.com/ant-design/ant-design/issues/23687
        [`${s}-preset > ${p}-tag-blue`]: {
          color: v,
          background: A,
          borderColor: x,
          cursor: "pointer"
        },
        [`${s}-ok`]: {
          paddingBlock: a.calc(u).mul(2).equal(),
          marginInlineStart: "auto"
        }
      }
    }
  };
}, initPickerPanelToken = (a) => {
  const {
    componentCls: s,
    controlHeightLG: c,
    paddingXXS: u,
    padding: d
  } = a;
  return {
    pickerCellCls: `${s}-cell`,
    pickerCellInnerCls: `${s}-cell-inner`,
    pickerYearMonthCellWidth: a.calc(c).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: a.calc(c).mul(1.4).equal(),
    pickerCellPaddingVertical: a.calc(u).add(a.calc(u).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: a.calc(d).add(a.calc(u).div(2)).equal()
    // 18 in normal
  };
}, initPanelComponentToken = (a) => {
  const {
    colorBgContainerDisabled: s,
    controlHeight: c,
    controlHeightSM: u,
    controlHeightLG: d,
    paddingXXS: p,
    lineWidth: v
  } = a, A = p * 2, x = v * 2, g = Math.min(c - A, c - x), b = Math.min(u - A, u - x), y = Math.min(d - A, d - x);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(p / 2),
    cellHoverBg: a.controlItemBgHover,
    cellActiveWithRangeBg: a.controlItemBgActive,
    cellHoverWithRangeBg: new FastColor(a.colorPrimary).lighten(35).toHexString(),
    cellRangeBorderColor: new FastColor(a.colorPrimary).lighten(20).toHexString(),
    cellBgDisabled: s,
    timeColumnWidth: d * 1.4,
    timeColumnHeight: 28 * 8,
    timeCellHeight: 28,
    cellWidth: u * 1.5,
    cellHeight: u,
    textHeight: d,
    withoutTimeCellHeight: d * 1.65,
    multipleItemBg: a.colorFillSecondary,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: g,
    multipleItemHeightSM: b,
    multipleItemHeightLG: y,
    multipleSelectorBgDisabled: s,
    multipleItemColorDisabled: a.colorTextDisabled,
    multipleItemBorderColorDisabled: "transparent"
  };
}, prepareComponentToken$j = (a) => Object.assign(Object.assign(Object.assign(Object.assign({}, initComponentToken$1(a)), initPanelComponentToken(a)), getArrowToken(a)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: a.zIndexPopupBase + 50
}), genVariantsStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: [
      Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedStyle(a)), genUnderlinedStyle(a)), genFilledStyle(a)), genBorderlessStyle(a)),
      // ========================= Multiple =========================
      {
        "&-outlined": {
          [`&${s}-multiple ${s}-selection-item`]: {
            background: a.multipleItemBg,
            border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.multipleItemBorderColor}`
          }
        },
        "&-filled": {
          [`&${s}-multiple ${s}-selection-item`]: {
            background: a.colorBgContainer,
            border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorSplit}`
          }
        },
        "&-borderless": {
          [`&${s}-multiple ${s}-selection-item`]: {
            background: a.multipleItemBg,
            border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.multipleItemBorderColor}`
          }
        },
        "&-underlined": {
          [`&${s}-multiple ${s}-selection-item`]: {
            background: a.multipleItemBg,
            border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.multipleItemBorderColor}`
          }
        }
      }
    ]
  };
}, genPickerPadding = (a, s) => ({
  padding: `${unit$1(a)} ${unit$1(s)}`
}), genPickerStatusStyle = (a) => {
  const {
    componentCls: s,
    colorError: c,
    colorWarning: u
  } = a;
  return {
    [`${s}:not(${s}-disabled):not([disabled])`]: {
      [`&${s}-status-error`]: {
        [`${s}-active-bar`]: {
          background: c
        }
      },
      [`&${s}-status-warning`]: {
        [`${s}-active-bar`]: {
          background: u
        }
      }
    }
  };
}, genPickerStyle = (a) => {
  var s;
  const {
    componentCls: c,
    antCls: u,
    paddingInline: d,
    lineWidth: p,
    lineType: v,
    colorBorder: A,
    borderRadius: x,
    motionDurationMid: g,
    colorTextDisabled: b,
    colorTextPlaceholder: y,
    fontSizeLG: f,
    inputFontSizeLG: m,
    fontSizeSM: C,
    inputFontSizeSM: w,
    controlHeightSM: S,
    paddingInlineSM: $,
    paddingXS: T,
    marginXS: I,
    colorIcon: _,
    lineWidthBold: E,
    colorPrimary: R,
    motionDurationSlow: O,
    zIndexPopup: L,
    paddingXXS: B,
    sizePopupArrow: F,
    colorBgElevated: M,
    borderRadiusLG: W,
    boxShadowSecondary: j,
    borderRadiusSM: G,
    colorSplit: U,
    cellHoverBg: k,
    presetsWidth: N,
    presetsMaxWidth: P,
    boxShadowPopoverArrow: D,
    fontHeight: H,
    lineHeightLG: V
  } = a;
  return [
    {
      [c]: Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genPickerPadding(a.paddingBlock, a.paddingInline)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
        borderRadius: x,
        transition: `border ${g}, box-shadow ${g}, background ${g}`,
        [`${c}-prefix`]: {
          flex: "0 0 auto",
          marginInlineEnd: a.inputAffixPadding
        },
        // ======================== Input =========================
        [`${c}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": Object.assign(Object.assign({
            position: "relative",
            display: "inline-block",
            width: "100%",
            color: "inherit",
            fontSize: (s = a.inputFontSize) !== null && s !== void 0 ? s : a.fontSize,
            lineHeight: a.lineHeight,
            transition: `all ${g}`
          }, genPlaceholderStyle(y)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            fontFamily: "inherit",
            "&:focus": {
              boxShadow: "none",
              outline: 0
            },
            "&[disabled]": {
              background: "transparent",
              color: b,
              cursor: "not-allowed"
            }
          }),
          "&-placeholder": {
            "> input": {
              color: y
            }
          }
        },
        // Size
        "&-large": Object.assign(Object.assign({}, genPickerPadding(a.paddingBlockLG, a.paddingInlineLG)), {
          [`${c}-input > input`]: {
            fontSize: m ?? f,
            lineHeight: V
          }
        }),
        "&-small": Object.assign(Object.assign({}, genPickerPadding(a.paddingBlockSM, a.paddingInlineSM)), {
          [`${c}-input > input`]: {
            fontSize: w ?? C
          }
        }),
        [`${c}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: a.calc(T).div(2).equal(),
          color: b,
          lineHeight: 1,
          pointerEvents: "none",
          transition: `opacity ${g}, color ${g}`,
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: I
            }
          }
        },
        [`${c}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: b,
          lineHeight: 1,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${g}, color ${g}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: _
          }
        },
        "&:hover": {
          [`${c}-clear`]: {
            opacity: 1
          },
          // Should use the following selector, but since `:has` has poor compatibility,
          // we use `:not(:last-child)` instead, which may cause some problems in some cases.
          // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
          [`${c}-suffix:not(:last-child)`]: {
            opacity: 0
          }
        },
        [`${c}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: f,
          color: b,
          fontSize: f,
          verticalAlign: "top",
          cursor: "default",
          [`${c}-focused &`]: {
            color: _
          },
          [`${c}-range-separator &`]: {
            [`${c}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Active bar
          [`${c}-active-bar`]: {
            bottom: a.calc(p).mul(-1).equal(),
            height: E,
            background: R,
            opacity: 0,
            transition: `all ${O} ease-out`,
            pointerEvents: "none"
          },
          [`&${c}-focused`]: {
            [`${c}-active-bar`]: {
              opacity: 1
            }
          },
          [`${c}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${unit$1(T)}`,
            lineHeight: 1
          }
        },
        // ======================== Clear =========================
        "&-range, &-multiple": {
          // Clear
          [`${c}-clear`]: {
            insetInlineEnd: d
          },
          [`&${c}-small`]: {
            [`${c}-clear`]: {
              insetInlineEnd: $
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genPanelStyle(a)), {
          pointerEvents: "none",
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: !0,
            value: -9999
          },
          zIndex: L,
          [`&${c}-dropdown-hidden`]: {
            display: "none"
          },
          "&-rtl": {
            direction: "rtl"
          },
          [`&${c}-dropdown-placement-bottomLeft,
            &${c}-dropdown-placement-bottomRight`]: {
            [`${c}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${c}-dropdown-placement-topLeft,
            &${c}-dropdown-placement-topRight`]: {
            [`${c}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${u}-slide-up-appear, &${u}-slide-up-enter`]: {
            [`${c}-range-arrow${c}-range-arrow`]: {
              transition: "none"
            }
          },
          [`&${u}-slide-up-enter${u}-slide-up-enter-active${c}-dropdown-placement-topLeft,
          &${u}-slide-up-enter${u}-slide-up-enter-active${c}-dropdown-placement-topRight,
          &${u}-slide-up-appear${u}-slide-up-appear-active${c}-dropdown-placement-topLeft,
          &${u}-slide-up-appear${u}-slide-up-appear-active${c}-dropdown-placement-topRight`]: {
            animationName: slideDownIn
          },
          [`&${u}-slide-up-enter${u}-slide-up-enter-active${c}-dropdown-placement-bottomLeft,
          &${u}-slide-up-enter${u}-slide-up-enter-active${c}-dropdown-placement-bottomRight,
          &${u}-slide-up-appear${u}-slide-up-appear-active${c}-dropdown-placement-bottomLeft,
          &${u}-slide-up-appear${u}-slide-up-appear-active${c}-dropdown-placement-bottomRight`]: {
            animationName: slideUpIn
          },
          // https://github.com/ant-design/ant-design/issues/48727
          [`&${u}-slide-up-leave ${c}-panel-container`]: {
            pointerEvents: "none"
          },
          [`&${u}-slide-up-leave${u}-slide-up-leave-active${c}-dropdown-placement-topLeft,
          &${u}-slide-up-leave${u}-slide-up-leave-active${c}-dropdown-placement-topRight`]: {
            animationName: slideDownOut
          },
          [`&${u}-slide-up-leave${u}-slide-up-leave-active${c}-dropdown-placement-bottomLeft,
          &${u}-slide-up-leave${u}-slide-up-leave-active${c}-dropdown-placement-bottomRight`]: {
            animationName: slideUpOut
          },
          // Time picker with additional style
          [`${c}-panel > ${c}-time-panel`]: {
            paddingTop: B
          },
          // ======================== Ranges ========================
          [`${c}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${c}-range-arrow`]: Object.assign(Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "none",
            paddingInline: a.calc(d).mul(1.5).equal(),
            boxSizing: "content-box",
            transition: `all ${O} ease-out`
          }, genRoundedArrow(a, M, D)), {
            "&:before": {
              insetInlineStart: a.calc(d).mul(1.5).equal()
            }
          }),
          [`${c}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: M,
            borderRadius: W,
            boxShadow: j,
            transition: `margin ${O}`,
            display: "inline-block",
            pointerEvents: "auto",
            // ======================== Layout ========================
            [`${c}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${c}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: N,
              maxWidth: P,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: T,
                borderInlineEnd: `${unit$1(p)} ${v} ${U}`,
                li: Object.assign(Object.assign({}, textEllipsis), {
                  borderRadius: G,
                  paddingInline: T,
                  paddingBlock: a.calc(S).sub(H).div(2).equal(),
                  cursor: "pointer",
                  transition: `all ${O}`,
                  "+ li": {
                    marginTop: I
                  },
                  "&:hover": {
                    background: k
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${c}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              // [`${componentCls}-panel`]: {
              //   borderWidth: `0 0 ${unit(lineWidth)}`,
              // },
              "&:last-child": {
                [`${c}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${c}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${c}-content, table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: A
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${unit$1(a.calc(F).mul(2).div(3).equal())} 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${c}-separator`]: {
            transform: "scale(-1, 1)"
          },
          [`${c}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    initSlideMotion(a, "slide-up"),
    initSlideMotion(a, "slide-down"),
    initMoveMotion(a, "move-up"),
    initMoveMotion(a, "move-down")
  ];
}, useStyle$m = genStyleHooks("DatePicker", (a) => {
  const s = merge(initInputToken(a), initPickerPanelToken(a), {
    inputPaddingHorizontalBase: a.calc(a.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: a.multipleItemHeight,
    selectHeight: a.controlHeight
  });
  return [
    genPickerPanelStyle(s),
    genPickerStyle(s),
    genVariantsStyle(s),
    genPickerStatusStyle(s),
    genPickerMultipleStyle(s),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(a, {
      focusElCls: `${a.componentCls}-focused`
    })
  ];
}, prepareComponentToken$j);
var PlusOutlined$3 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" }, PlusOutlined$2 = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: PlusOutlined$3
  }));
}, RefIcon$y = /* @__PURE__ */ reactExports.forwardRef(PlusOutlined$2);
const TabContext = /* @__PURE__ */ reactExports.createContext(null);
var useIndicator = function a(s) {
  var c = s.activeTabOffset, u = s.horizontal, d = s.rtl, p = s.indicator, v = p === void 0 ? {} : p, A = v.size, x = v.align, g = x === void 0 ? "center" : x, b = reactExports.useState(), y = _slicedToArray$e(b, 2), f = y[0], m = y[1], C = reactExports.useRef(), w = React.useCallback(function($) {
    return typeof A == "function" ? A($) : typeof A == "number" ? A : $;
  }, [A]);
  function S() {
    wrapperRaf.cancel(C.current);
  }
  return reactExports.useEffect(function() {
    var $ = {};
    if (c)
      if (u) {
        $.width = w(c.width);
        var T = d ? "right" : "left";
        g === "start" && ($[T] = c[T]), g === "center" && ($[T] = c[T] + c.width / 2, $.transform = d ? "translateX(50%)" : "translateX(-50%)"), g === "end" && ($[T] = c[T] + c.width, $.transform = "translateX(-100%)");
      } else
        $.height = w(c.height), g === "start" && ($.top = c.top), g === "center" && ($.top = c.top + c.height / 2, $.transform = "translateY(-50%)"), g === "end" && ($.top = c.top + c.height, $.transform = "translateY(-100%)");
    return S(), C.current = wrapperRaf(function() {
      var I = f && $ && Object.keys($).every(function(_) {
        var E = $[_], R = f[_];
        return typeof E == "number" && typeof R == "number" ? Math.round(E) === Math.round(R) : E === R;
      });
      I || m($);
    }), S;
  }, [JSON.stringify(c), u, d, g, w]), {
    style: f
  };
}, DEFAULT_SIZE$1 = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function useOffsets(a, s, c) {
  return reactExports.useMemo(function() {
    for (var u, d = /* @__PURE__ */ new Map(), p = s.get((u = a[0]) === null || u === void 0 ? void 0 : u.key) || DEFAULT_SIZE$1, v = p.left + p.width, A = 0; A < a.length; A += 1) {
      var x = a[A].key, g = s.get(x);
      if (!g) {
        var b;
        g = s.get((b = a[A - 1]) === null || b === void 0 ? void 0 : b.key) || DEFAULT_SIZE$1;
      }
      var y = d.get(x) || _objectSpread2$1({}, g);
      y.right = v - y.left - y.width, d.set(x, y);
    }
    return d;
  }, [a.map(function(u) {
    return u.key;
  }).join("_"), s, c]);
}
function useSyncState$1(a, s) {
  var c = reactExports.useRef(a), u = reactExports.useState({}), d = _slicedToArray$e(u, 2), p = d[1];
  function v(A) {
    var x = typeof A == "function" ? A(c.current) : A;
    x !== c.current && s(x, c.current), c.current = x, p({});
  }
  return [c.current, v];
}
var MIN_SWIPE_DISTANCE = 0.1, STOP_SWIPE_DISTANCE = 0.01, REFRESH_INTERVAL = 20, SPEED_OFF_MULTIPLE = Math.pow(0.995, REFRESH_INTERVAL);
function useTouchMove(a, s) {
  var c = reactExports.useState(), u = _slicedToArray$e(c, 2), d = u[0], p = u[1], v = reactExports.useState(0), A = _slicedToArray$e(v, 2), x = A[0], g = A[1], b = reactExports.useState(0), y = _slicedToArray$e(b, 2), f = y[0], m = y[1], C = reactExports.useState(), w = _slicedToArray$e(C, 2), S = w[0], $ = w[1], T = reactExports.useRef();
  function I(B) {
    var F = B.touches[0], M = F.screenX, W = F.screenY;
    p({
      x: M,
      y: W
    }), window.clearInterval(T.current);
  }
  function _(B) {
    if (d) {
      var F = B.touches[0], M = F.screenX, W = F.screenY;
      p({
        x: M,
        y: W
      });
      var j = M - d.x, G = W - d.y;
      s(j, G);
      var U = Date.now();
      g(U), m(U - x), $({
        x: j,
        y: G
      });
    }
  }
  function E() {
    if (d && (p(null), $(null), S)) {
      var B = S.x / f, F = S.y / f, M = Math.abs(B), W = Math.abs(F);
      if (Math.max(M, W) < MIN_SWIPE_DISTANCE) return;
      var j = B, G = F;
      T.current = window.setInterval(function() {
        if (Math.abs(j) < STOP_SWIPE_DISTANCE && Math.abs(G) < STOP_SWIPE_DISTANCE) {
          window.clearInterval(T.current);
          return;
        }
        j *= SPEED_OFF_MULTIPLE, G *= SPEED_OFF_MULTIPLE, s(j * REFRESH_INTERVAL, G * REFRESH_INTERVAL);
      }, REFRESH_INTERVAL);
    }
  }
  var R = reactExports.useRef();
  function O(B) {
    var F = B.deltaX, M = B.deltaY, W = 0, j = Math.abs(F), G = Math.abs(M);
    j === G ? W = R.current === "x" ? F : M : j > G ? (W = F, R.current = "x") : (W = M, R.current = "y"), s(-W, -W) && B.preventDefault();
  }
  var L = reactExports.useRef(null);
  L.current = {
    onTouchStart: I,
    onTouchMove: _,
    onTouchEnd: E,
    onWheel: O
  }, reactExports.useEffect(function() {
    function B(j) {
      L.current.onTouchStart(j);
    }
    function F(j) {
      L.current.onTouchMove(j);
    }
    function M(j) {
      L.current.onTouchEnd(j);
    }
    function W(j) {
      L.current.onWheel(j);
    }
    return document.addEventListener("touchmove", F, {
      passive: !1
    }), document.addEventListener("touchend", M, {
      passive: !0
    }), a.current.addEventListener("touchstart", B, {
      passive: !0
    }), a.current.addEventListener("wheel", W, {
      passive: !1
    }), function() {
      document.removeEventListener("touchmove", F), document.removeEventListener("touchend", M);
    };
  }, []);
}
function useUpdate(a) {
  var s = reactExports.useState(0), c = _slicedToArray$e(s, 2), u = c[0], d = c[1], p = reactExports.useRef(0), v = reactExports.useRef();
  return v.current = a, useLayoutUpdateEffect(function() {
    var A;
    (A = v.current) === null || A === void 0 || A.call(v);
  }, [u]), function() {
    p.current === u && (p.current += 1, d(p.current));
  };
}
function useUpdateState(a) {
  var s = reactExports.useRef([]), c = reactExports.useState({}), u = _slicedToArray$e(c, 2), d = u[1], p = reactExports.useRef(typeof a == "function" ? a() : a), v = useUpdate(function() {
    var x = p.current;
    s.current.forEach(function(g) {
      x = g(x);
    }), s.current = [], p.current = x, d({});
  });
  function A(x) {
    s.current.push(x), v();
  }
  return [p.current, A];
}
var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function useVisibleRange(a, s, c, u, d, p, v) {
  var A = v.tabs, x = v.tabPosition, g = v.rtl, b, y, f;
  return ["top", "bottom"].includes(x) ? (b = "width", y = g ? "right" : "left", f = Math.abs(c)) : (b = "height", y = "top", f = -c), reactExports.useMemo(function() {
    if (!A.length)
      return [0, 0];
    for (var m = A.length, C = m, w = 0; w < m; w += 1) {
      var S = a.get(A[w].key) || DEFAULT_SIZE;
      if (Math.floor(S[y] + S[b]) > Math.floor(f + s)) {
        C = w - 1;
        break;
      }
    }
    for (var $ = 0, T = m - 1; T >= 0; T -= 1) {
      var I = a.get(A[T].key) || DEFAULT_SIZE;
      if (I[y] < f) {
        $ = T + 1;
        break;
      }
    }
    return $ >= C ? [0, 0] : [$, C];
  }, [a, s, u, d, p, f, x, A.map(function(m) {
    return m.key;
  }).join("_"), g]);
}
function stringify(a) {
  var s;
  return a instanceof Map ? (s = {}, a.forEach(function(c, u) {
    s[u] = c;
  })) : s = a, JSON.stringify(s);
}
var RC_TABS_DOUBLE_QUOTE = "TABS_DQ";
function genDataNodeKey(a) {
  return String(a).replace(/"/g, RC_TABS_DOUBLE_QUOTE);
}
function getRemovable(a, s, c, u) {
  return (
    // Only editable tabs can be removed
    !(!c || // Tabs cannot be removed when disabled
    u || // closable is false
    a === !1 || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    a === void 0 && (s === !1 || s === null))
  );
}
var AddButton = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.editable, d = a.locale, p = a.style;
  return !u || u.showAdd === !1 ? null : /* @__PURE__ */ reactExports.createElement("button", {
    ref: s,
    type: "button",
    className: "".concat(c, "-nav-add"),
    style: p,
    "aria-label": d?.addAriaLabel || "Add tab",
    onClick: function(A) {
      u.onEdit("add", {
        event: A
      });
    }
  }, u.addIcon || "+");
}), ExtraContent = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.position, u = a.prefixCls, d = a.extra;
  if (!d)
    return null;
  var p, v = {};
  return _typeof$h(d) === "object" && !/* @__PURE__ */ reactExports.isValidElement(d) ? v = d : v.right = d, c === "right" && (p = v.right), c === "left" && (p = v.left), p ? /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(u, "-extra-content"),
    ref: s
  }, p) : null;
}), OperationNode = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.id, d = a.tabs, p = a.locale, v = a.mobile, A = a.more, x = A === void 0 ? {} : A, g = a.style, b = a.className, y = a.editable, f = a.tabBarGutter, m = a.rtl, C = a.removeAriaLabel, w = a.onTabClick, S = a.getPopupContainer, $ = a.popupClassName, T = reactExports.useState(!1), I = _slicedToArray$e(T, 2), _ = I[0], E = I[1], R = reactExports.useState(null), O = _slicedToArray$e(R, 2), L = O[0], B = O[1], F = x.icon, M = F === void 0 ? "More" : F, W = "".concat(u, "-more-popup"), j = "".concat(c, "-dropdown"), G = L !== null ? "".concat(W, "-").concat(L) : null, U = p?.dropdownAriaLabel;
  function k(ne, K) {
    ne.preventDefault(), ne.stopPropagation(), y.onEdit("remove", {
      key: K,
      event: ne
    });
  }
  var N = /* @__PURE__ */ reactExports.createElement(ExportMenu, {
    onClick: function(K) {
      var q = K.key, Y = K.domEvent;
      w(q, Y), E(!1);
    },
    prefixCls: "".concat(j, "-menu"),
    id: W,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": G,
    selectedKeys: [L],
    "aria-label": U !== void 0 ? U : "expanded dropdown"
  }, d.map(function(ne) {
    var K = ne.closable, q = ne.disabled, Y = ne.closeIcon, ee = ne.key, Q = ne.label, J = getRemovable(K, Y, y, q);
    return /* @__PURE__ */ reactExports.createElement(MenuItem$2, {
      key: ee,
      id: "".concat(W, "-").concat(ee),
      role: "option",
      "aria-controls": u && "".concat(u, "-panel-").concat(ee),
      disabled: q
    }, /* @__PURE__ */ reactExports.createElement("span", null, Q), J && /* @__PURE__ */ reactExports.createElement("button", {
      type: "button",
      "aria-label": C || "remove",
      tabIndex: 0,
      className: "".concat(j, "-menu-item-remove"),
      onClick: function(ae) {
        ae.stopPropagation(), k(ae, ee);
      }
    }, Y || y.removeIcon || "×"));
  }));
  function P(ne) {
    for (var K = d.filter(function(J) {
      return !J.disabled;
    }), q = K.findIndex(function(J) {
      return J.key === L;
    }) || 0, Y = K.length, ee = 0; ee < Y; ee += 1) {
      q = (q + ne + Y) % Y;
      var Q = K[q];
      if (!Q.disabled) {
        B(Q.key);
        return;
      }
    }
  }
  function D(ne) {
    var K = ne.which;
    if (!_) {
      [KeyCode.DOWN, KeyCode.SPACE, KeyCode.ENTER].includes(K) && (E(!0), ne.preventDefault());
      return;
    }
    switch (K) {
      case KeyCode.UP:
        P(-1), ne.preventDefault();
        break;
      case KeyCode.DOWN:
        P(1), ne.preventDefault();
        break;
      case KeyCode.ESC:
        E(!1);
        break;
      case KeyCode.SPACE:
      case KeyCode.ENTER:
        L !== null && w(L, ne);
        break;
    }
  }
  reactExports.useEffect(function() {
    var ne = document.getElementById(G);
    ne && ne.scrollIntoView && ne.scrollIntoView(!1);
  }, [L]), reactExports.useEffect(function() {
    _ || B(null);
  }, [_]);
  var H = _defineProperty$a({}, m ? "marginRight" : "marginLeft", f);
  d.length || (H.visibility = "hidden", H.order = 1);
  var V = classnames(_defineProperty$a({}, "".concat(j, "-rtl"), m)), Z = v ? null : /* @__PURE__ */ reactExports.createElement(Dropdown$3, _extends$3({
    prefixCls: j,
    overlay: N,
    visible: d.length ? _ : !1,
    onVisibleChange: E,
    overlayClassName: classnames(V, $),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: S
  }, x), /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    className: "".concat(c, "-nav-more"),
    style: H,
    "aria-haspopup": "listbox",
    "aria-controls": W,
    id: "".concat(u, "-more"),
    "aria-expanded": _,
    onKeyDown: D
  }, M));
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(c, "-nav-operations"), b),
    style: g,
    ref: s
  }, Z, /* @__PURE__ */ reactExports.createElement(AddButton, {
    prefixCls: c,
    locale: p,
    editable: y
  }));
});
const OperationNode$1 = /* @__PURE__ */ reactExports.memo(OperationNode, function(a, s) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    s.tabMoving
  );
});
var TabNode = function a(s) {
  var c = s.prefixCls, u = s.id, d = s.active, p = s.focus, v = s.tab, A = v.key, x = v.label, g = v.disabled, b = v.closeIcon, y = v.icon, f = s.closable, m = s.renderWrapper, C = s.removeAriaLabel, w = s.editable, S = s.onClick, $ = s.onFocus, T = s.onBlur, I = s.onKeyDown, _ = s.onMouseDown, E = s.onMouseUp, R = s.style, O = s.tabCount, L = s.currentPosition, B = "".concat(c, "-tab"), F = getRemovable(f, b, w, g);
  function M(k) {
    g || S(k);
  }
  function W(k) {
    k.preventDefault(), k.stopPropagation(), w.onEdit("remove", {
      key: A,
      event: k
    });
  }
  var j = reactExports.useMemo(function() {
    return y && typeof x == "string" ? /* @__PURE__ */ reactExports.createElement("span", null, x) : x;
  }, [x, y]), G = reactExports.useRef(null);
  reactExports.useEffect(function() {
    p && G.current && G.current.focus();
  }, [p]);
  var U = /* @__PURE__ */ reactExports.createElement("div", {
    key: A,
    "data-node-key": genDataNodeKey(A),
    className: classnames(B, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(B, "-with-remove"), F), "".concat(B, "-active"), d), "".concat(B, "-disabled"), g), "".concat(B, "-focus"), p)),
    style: R,
    onClick: M
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: G,
    role: "tab",
    "aria-selected": d,
    id: u && "".concat(u, "-tab-").concat(A),
    className: "".concat(B, "-btn"),
    "aria-controls": u && "".concat(u, "-panel-").concat(A),
    "aria-disabled": g,
    tabIndex: g ? null : d ? 0 : -1,
    onClick: function(N) {
      N.stopPropagation(), M(N);
    },
    onKeyDown: I,
    onMouseDown: _,
    onMouseUp: E,
    onFocus: $,
    onBlur: T
  }, p && /* @__PURE__ */ reactExports.createElement("div", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "Tab ".concat(L, " of ").concat(O)), y && /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(B, "-icon")
  }, y), x && j), F && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    role: "tab",
    "aria-label": C || "remove",
    tabIndex: d ? 0 : -1,
    className: "".concat(B, "-remove"),
    onClick: function(N) {
      N.stopPropagation(), W(N);
    }
  }, b || w.removeIcon || "×"));
  return m ? m(U) : U;
}, getTabSize = function a(s, c) {
  var u = s.offsetWidth, d = s.offsetHeight, p = s.offsetTop, v = s.offsetLeft, A = s.getBoundingClientRect(), x = A.width, g = A.height, b = A.left, y = A.top;
  return Math.abs(x - u) < 1 ? [x, g, b - c.left, y - c.top] : [u, d, v, p];
}, getSize$2 = function a(s) {
  var c = s.current || {}, u = c.offsetWidth, d = u === void 0 ? 0 : u, p = c.offsetHeight, v = p === void 0 ? 0 : p;
  if (s.current) {
    var A = s.current.getBoundingClientRect(), x = A.width, g = A.height;
    if (Math.abs(x - d) < 1)
      return [x, g];
  }
  return [d, v];
}, getUnitValue = function a(s, c) {
  return s[c ? 0 : 1];
}, TabNavList = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.className, u = a.style, d = a.id, p = a.animated, v = a.activeKey, A = a.rtl, x = a.extra, g = a.editable, b = a.locale, y = a.tabPosition, f = a.tabBarGutter, m = a.children, C = a.onTabClick, w = a.onTabScroll, S = a.indicator, $ = reactExports.useContext(TabContext), T = $.prefixCls, I = $.tabs, _ = reactExports.useRef(null), E = reactExports.useRef(null), R = reactExports.useRef(null), O = reactExports.useRef(null), L = reactExports.useRef(null), B = reactExports.useRef(null), F = reactExports.useRef(null), M = y === "top" || y === "bottom", W = useSyncState$1(0, function(Ke, qe) {
    M && w && w({
      direction: Ke > qe ? "left" : "right"
    });
  }), j = _slicedToArray$e(W, 2), G = j[0], U = j[1], k = useSyncState$1(0, function(Ke, qe) {
    !M && w && w({
      direction: Ke > qe ? "top" : "bottom"
    });
  }), N = _slicedToArray$e(k, 2), P = N[0], D = N[1], H = reactExports.useState([0, 0]), V = _slicedToArray$e(H, 2), Z = V[0], ne = V[1], K = reactExports.useState([0, 0]), q = _slicedToArray$e(K, 2), Y = q[0], ee = q[1], Q = reactExports.useState([0, 0]), J = _slicedToArray$e(Q, 2), te = J[0], ae = J[1], se = reactExports.useState([0, 0]), ie = _slicedToArray$e(se, 2), fe = ie[0], ge = ie[1], me = useUpdateState(/* @__PURE__ */ new Map()), pe = _slicedToArray$e(me, 2), be = pe[0], le = pe[1], ve = useOffsets(I, be, Y[0]), he = getUnitValue(Z, M), ye = getUnitValue(Y, M), Ce = getUnitValue(te, M), xe = getUnitValue(fe, M), we = Math.floor(he) < Math.floor(ye + Ce), $e = we ? he - xe : he - Ce, Ae = "".concat(T, "-nav-operations-hidden"), ue = 0, ce = 0;
  M && A ? (ue = 0, ce = Math.max(0, ye - $e)) : (ue = Math.min(0, $e - ye), ce = 0);
  function Ee(Ke) {
    return Ke < ue ? ue : Ke > ce ? ce : Ke;
  }
  var _e = reactExports.useRef(null), Te = reactExports.useState(), ke = _slicedToArray$e(Te, 2), Re = ke[0], Be = ke[1];
  function Oe() {
    Be(Date.now());
  }
  function Me() {
    _e.current && clearTimeout(_e.current);
  }
  useTouchMove(O, function(Ke, qe) {
    function ot(Je, Ct) {
      Je(function(Tt) {
        var yt = Ee(Tt + Ct);
        return yt;
      });
    }
    return we ? (M ? ot(U, Ke) : ot(D, qe), Me(), Oe(), !0) : !1;
  }), reactExports.useEffect(function() {
    return Me(), Re && (_e.current = setTimeout(function() {
      Be(0);
    }, 100)), Me;
  }, [Re]);
  var Fe = useVisibleRange(
    ve,
    // Container
    $e,
    // Transform
    M ? G : P,
    // Tabs
    ye,
    // Add
    Ce,
    // Operation
    xe,
    _objectSpread2$1(_objectSpread2$1({}, a), {}, {
      tabs: I
    })
  ), Ue = _slicedToArray$e(Fe, 2), je = Ue[0], Le = Ue[1], De = useEvent(function() {
    var Ke = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : v, qe = ve.get(Ke) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (M) {
      var ot = G;
      A ? qe.right < G ? ot = qe.right : qe.right + qe.width > G + $e && (ot = qe.right + qe.width - $e) : qe.left < -G ? ot = -qe.left : qe.left + qe.width > -G + $e && (ot = -(qe.left + qe.width - $e)), D(0), U(Ee(ot));
    } else {
      var Je = P;
      qe.top < -P ? Je = -qe.top : qe.top + qe.height > -P + $e && (Je = -(qe.top + qe.height - $e)), U(0), D(Ee(Je));
    }
  }), Ne = reactExports.useState(), Ge = _slicedToArray$e(Ne, 2), Xe = Ge[0], nt = Ge[1], ct = reactExports.useState(!1), it = _slicedToArray$e(ct, 2), We = it[0], Ve = it[1], ut = I.filter(function(Ke) {
    return !Ke.disabled;
  }).map(function(Ke) {
    return Ke.key;
  }), at = function(qe) {
    var ot = ut.indexOf(Xe || v), Je = ut.length, Ct = (ot + qe + Je) % Je, Tt = ut[Ct];
    nt(Tt);
  }, Qe = function(qe) {
    var ot = qe.code, Je = A && M, Ct = ut[0], Tt = ut[ut.length - 1];
    switch (ot) {
      // LEFT
      case "ArrowLeft": {
        M && at(Je ? 1 : -1);
        break;
      }
      // RIGHT
      case "ArrowRight": {
        M && at(Je ? -1 : 1);
        break;
      }
      // UP
      case "ArrowUp": {
        qe.preventDefault(), M || at(-1);
        break;
      }
      // DOWN
      case "ArrowDown": {
        qe.preventDefault(), M || at(1);
        break;
      }
      // HOME
      case "Home": {
        qe.preventDefault(), nt(Ct);
        break;
      }
      // END
      case "End": {
        qe.preventDefault(), nt(Tt);
        break;
      }
      // Enter & Space
      case "Enter":
      case "Space": {
        qe.preventDefault(), C(Xe ?? v, qe);
        break;
      }
      // Backspace
      case "Backspace":
      case "Delete": {
        var yt = ut.indexOf(Xe), bt = I.find(function(kt) {
          return kt.key === Xe;
        }), It = getRemovable(bt?.closable, bt?.closeIcon, g, bt?.disabled);
        It && (qe.preventDefault(), qe.stopPropagation(), g.onEdit("remove", {
          key: Xe,
          event: qe
        }), yt === ut.length - 1 ? at(-1) : at(1));
        break;
      }
    }
  }, st = {};
  M ? st[A ? "marginRight" : "marginLeft"] = f : st.marginTop = f;
  var ft = I.map(function(Ke, qe) {
    var ot = Ke.key;
    return /* @__PURE__ */ reactExports.createElement(TabNode, {
      id: d,
      prefixCls: T,
      key: ot,
      tab: Ke,
      style: qe === 0 ? void 0 : st,
      closable: Ke.closable,
      editable: g,
      active: ot === v,
      focus: ot === Xe,
      renderWrapper: m,
      removeAriaLabel: b?.removeAriaLabel,
      tabCount: ut.length,
      currentPosition: qe + 1,
      onClick: function(Ct) {
        C(ot, Ct);
      },
      onKeyDown: Qe,
      onFocus: function() {
        We || nt(ot), De(ot), Oe(), O.current && (A || (O.current.scrollLeft = 0), O.current.scrollTop = 0);
      },
      onBlur: function() {
        nt(void 0);
      },
      onMouseDown: function() {
        Ve(!0);
      },
      onMouseUp: function() {
        Ve(!1);
      }
    });
  }), vt = function() {
    return le(function() {
      var qe, ot = /* @__PURE__ */ new Map(), Je = (qe = L.current) === null || qe === void 0 ? void 0 : qe.getBoundingClientRect();
      return I.forEach(function(Ct) {
        var Tt, yt = Ct.key, bt = (Tt = L.current) === null || Tt === void 0 ? void 0 : Tt.querySelector('[data-node-key="'.concat(genDataNodeKey(yt), '"]'));
        if (bt) {
          var It = getTabSize(bt, Je), kt = _slicedToArray$e(It, 4), $t = kt[0], Lt = kt[1], Ft = kt[2], Vt = kt[3];
          ot.set(yt, {
            width: $t,
            height: Lt,
            left: Ft,
            top: Vt
          });
        }
      }), ot;
    });
  };
  reactExports.useEffect(function() {
    vt();
  }, [I.map(function(Ke) {
    return Ke.key;
  }).join("_")]);
  var Pt = useUpdate(function() {
    var Ke = getSize$2(_), qe = getSize$2(E), ot = getSize$2(R);
    ne([Ke[0] - qe[0] - ot[0], Ke[1] - qe[1] - ot[1]]);
    var Je = getSize$2(F);
    ae(Je);
    var Ct = getSize$2(B);
    ge(Ct);
    var Tt = getSize$2(L);
    ee([Tt[0] - Je[0], Tt[1] - Je[1]]), vt();
  }), dt = I.slice(0, je), mt = I.slice(Le + 1), pt = [].concat(_toConsumableArray$e(dt), _toConsumableArray$e(mt)), Et = ve.get(v), Mt = useIndicator({
    activeTabOffset: Et,
    horizontal: M,
    indicator: S,
    rtl: A
  }), Nt = Mt.style;
  reactExports.useEffect(function() {
    De();
  }, [v, ue, ce, stringify(Et), stringify(ve), M]), reactExports.useEffect(function() {
    Pt();
  }, [A]);
  var _t = !!pt.length, Ot = "".concat(T, "-nav-wrap"), rt, et, Ye, tt;
  return M ? A ? (et = G > 0, rt = G !== ce) : (rt = G < 0, et = G !== ue) : (Ye = P < 0, tt = P !== ue), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Pt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: useComposeRef(s, _),
    role: "tablist",
    "aria-orientation": M ? "horizontal" : "vertical",
    className: classnames("".concat(T, "-nav"), c),
    style: u,
    onKeyDown: function() {
      Oe();
    }
  }, /* @__PURE__ */ reactExports.createElement(ExtraContent, {
    ref: E,
    position: "left",
    extra: x,
    prefixCls: T
  }), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Pt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(Ot, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(Ot, "-ping-left"), rt), "".concat(Ot, "-ping-right"), et), "".concat(Ot, "-ping-top"), Ye), "".concat(Ot, "-ping-bottom"), tt)),
    ref: O
  }, /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Pt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: L,
    className: "".concat(T, "-nav-list"),
    style: {
      transform: "translate(".concat(G, "px, ").concat(P, "px)"),
      transition: Re ? "none" : void 0
    }
  }, ft, /* @__PURE__ */ reactExports.createElement(AddButton, {
    ref: F,
    prefixCls: T,
    locale: b,
    editable: g,
    style: _objectSpread2$1(_objectSpread2$1({}, ft.length === 0 ? void 0 : st), {}, {
      visibility: _t ? "hidden" : null
    })
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(T, "-ink-bar"), _defineProperty$a({}, "".concat(T, "-ink-bar-animated"), p.inkBar)),
    style: Nt
  }))))), /* @__PURE__ */ reactExports.createElement(OperationNode$1, _extends$3({}, a, {
    removeAriaLabel: b?.removeAriaLabel,
    ref: B,
    prefixCls: T,
    tabs: pt,
    className: !_t && Ae,
    tabMoving: !!Re
  })), /* @__PURE__ */ reactExports.createElement(ExtraContent, {
    ref: R,
    position: "right",
    extra: x,
    prefixCls: T
  })));
}), TabPane$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.className, d = a.style, p = a.id, v = a.active, A = a.tabKey, x = a.children;
  return /* @__PURE__ */ reactExports.createElement("div", {
    id: p && "".concat(p, "-panel-").concat(A),
    role: "tabpanel",
    tabIndex: v ? 0 : -1,
    "aria-labelledby": p && "".concat(p, "-tab-").concat(A),
    "aria-hidden": !v,
    style: d,
    className: classnames(c, v && "".concat(c, "-active"), u),
    ref: s
  }, x);
}), _excluded$u = ["renderTabBar"], _excluded2$6 = ["label", "key"], TabNavListWrapper = function a(s) {
  var c = s.renderTabBar, u = _objectWithoutProperties$2(s, _excluded$u), d = reactExports.useContext(TabContext), p = d.tabs;
  if (c) {
    var v = _objectSpread2$1(_objectSpread2$1({}, u), {}, {
      // Legacy support. We do not use this actually
      panes: p.map(function(A) {
        var x = A.label, g = A.key, b = _objectWithoutProperties$2(A, _excluded2$6);
        return /* @__PURE__ */ reactExports.createElement(TabPane$1, _extends$3({
          tab: x,
          key: g,
          tabKey: g
        }, b));
      })
    });
    return c(v, TabNavList);
  }
  return /* @__PURE__ */ reactExports.createElement(TabNavList, u);
}, _excluded$t = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"], TabPanelList = function a(s) {
  var c = s.id, u = s.activeKey, d = s.animated, p = s.tabPosition, v = s.destroyInactiveTabPane, A = reactExports.useContext(TabContext), x = A.prefixCls, g = A.tabs, b = d.tabPane, y = "".concat(x, "-tabpane");
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(x, "-content-holder"))
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(x, "-content"), "".concat(x, "-content-").concat(p), _defineProperty$a({}, "".concat(x, "-content-animated"), b))
  }, g.map(function(f) {
    var m = f.key, C = f.forceRender, w = f.style, S = f.className, $ = f.destroyInactiveTabPane, T = _objectWithoutProperties$2(f, _excluded$t), I = m === u;
    return /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$3({
      key: m,
      visible: I,
      forceRender: C,
      removeOnLeave: !!(v || $),
      leavedClassName: "".concat(y, "-hidden")
    }, d.tabPaneMotion), function(_, E) {
      var R = _.style, O = _.className;
      return /* @__PURE__ */ reactExports.createElement(TabPane$1, _extends$3({}, T, {
        prefixCls: y,
        id: c,
        tabKey: m,
        animated: b,
        active: I,
        style: _objectSpread2$1(_objectSpread2$1({}, w), R),
        className: classnames(S, O),
        ref: E
      }));
    });
  })));
};
function useAnimateConfig$1() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: !0,
    tabPane: !1
  }, s;
  return a === !1 ? s = {
    inkBar: !1,
    tabPane: !1
  } : a === !0 ? s = {
    inkBar: !0,
    tabPane: !1
  } : s = _objectSpread2$1({
    inkBar: !0
  }, _typeof$h(a) === "object" ? a : {}), s.tabPaneMotion && s.tabPane === void 0 && (s.tabPane = !0), !s.tabPaneMotion && s.tabPane && (s.tabPane = !1), s;
}
var _excluded$s = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "more", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"], uuid$1 = 0, Tabs$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.id, u = a.prefixCls, d = u === void 0 ? "rc-tabs" : u, p = a.className, v = a.items, A = a.direction, x = a.activeKey, g = a.defaultActiveKey, b = a.editable, y = a.animated, f = a.tabPosition, m = f === void 0 ? "top" : f, C = a.tabBarGutter, w = a.tabBarStyle, S = a.tabBarExtraContent, $ = a.locale, T = a.more, I = a.destroyInactiveTabPane, _ = a.renderTabBar, E = a.onChange, R = a.onTabClick, O = a.onTabScroll, L = a.getPopupContainer, B = a.popupClassName, F = a.indicator, M = _objectWithoutProperties$2(a, _excluded$s), W = reactExports.useMemo(function() {
    return (v || []).filter(function(fe) {
      return fe && _typeof$h(fe) === "object" && "key" in fe;
    });
  }, [v]), j = A === "rtl", G = useAnimateConfig$1(y), U = reactExports.useState(!1), k = _slicedToArray$e(U, 2), N = k[0], P = k[1];
  reactExports.useEffect(function() {
    P(isMobile$1());
  }, []);
  var D = useMergedState(function() {
    var fe;
    return (fe = W[0]) === null || fe === void 0 ? void 0 : fe.key;
  }, {
    value: x,
    defaultValue: g
  }), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = reactExports.useState(function() {
    return W.findIndex(function(fe) {
      return fe.key === V;
    });
  }), K = _slicedToArray$e(ne, 2), q = K[0], Y = K[1];
  reactExports.useEffect(function() {
    var fe = W.findIndex(function(me) {
      return me.key === V;
    });
    if (fe === -1) {
      var ge;
      fe = Math.max(0, Math.min(q, W.length - 1)), Z((ge = W[fe]) === null || ge === void 0 ? void 0 : ge.key);
    }
    Y(fe);
  }, [W.map(function(fe) {
    return fe.key;
  }).join("_"), V, q]);
  var ee = useMergedState(null, {
    value: c
  }), Q = _slicedToArray$e(ee, 2), J = Q[0], te = Q[1];
  reactExports.useEffect(function() {
    c || (te("rc-tabs-".concat(uuid$1)), uuid$1 += 1);
  }, []);
  function ae(fe, ge) {
    R?.(fe, ge);
    var me = fe !== V;
    Z(fe), me && E?.(fe);
  }
  var se = {
    id: J,
    activeKey: V,
    animated: G,
    tabPosition: m,
    rtl: j,
    mobile: N
  }, ie = _objectSpread2$1(_objectSpread2$1({}, se), {}, {
    editable: b,
    locale: $,
    more: T,
    tabBarGutter: C,
    onTabClick: ae,
    onTabScroll: O,
    extra: S,
    style: w,
    panes: null,
    getPopupContainer: L,
    popupClassName: B,
    indicator: F
  });
  return /* @__PURE__ */ reactExports.createElement(TabContext.Provider, {
    value: {
      tabs: W,
      prefixCls: d
    }
  }, /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    ref: s,
    id: c,
    className: classnames(d, "".concat(d, "-").concat(m), _defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(d, "-mobile"), N), "".concat(d, "-editable"), b), "".concat(d, "-rtl"), j), p)
  }, M), /* @__PURE__ */ reactExports.createElement(TabNavListWrapper, _extends$3({}, ie, {
    renderTabBar: _
  })), /* @__PURE__ */ reactExports.createElement(TabPanelList, _extends$3({
    destroyInactiveTabPane: I
  }, se, {
    animated: G
  }))));
});
const motion = {
  motionAppear: !1,
  motionEnter: !0,
  motionLeave: !0
};
function useAnimateConfig(a, s = {
  inkBar: !0,
  tabPane: !1
}) {
  let c;
  return s === !1 ? c = {
    inkBar: !1,
    tabPane: !1
  } : s === !0 ? c = {
    inkBar: !0,
    tabPane: !0
  } : c = Object.assign({
    inkBar: !0
  }, typeof s == "object" ? s : {}), c.tabPane && (c.tabPaneMotion = Object.assign(Object.assign({}, motion), {
    motionName: getTransitionName$1(a, "switch")
  })), c;
}
var __rest$O = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function filter(a) {
  return a.filter((s) => s);
}
function useLegacyItems(a, s) {
  if (a)
    return a.map((u) => {
      var d;
      const p = (d = u.destroyOnHidden) !== null && d !== void 0 ? d : u.destroyInactiveTabPane;
      return Object.assign(Object.assign({}, u), {
        // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
        destroyInactiveTabPane: p
      });
    });
  const c = toArray$8(s).map((u) => {
    if (/* @__PURE__ */ reactExports.isValidElement(u)) {
      const {
        key: d,
        props: p
      } = u, v = p || {}, {
        tab: A
      } = v, x = __rest$O(v, ["tab"]);
      return Object.assign(Object.assign({
        key: String(d)
      }, x), {
        label: A
      });
    }
    return null;
  });
  return filter(c);
}
const genMotionStyle$2 = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: c
  } = a;
  return [
    {
      [s]: {
        [`${s}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${c}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${c}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [initSlideMotion(a, "slide-up"), initSlideMotion(a, "slide-down")]
  ];
}, genCardStyle$1 = (a) => {
  const {
    componentCls: s,
    tabsCardPadding: c,
    cardBg: u,
    cardGutter: d,
    colorBorderSecondary: p,
    itemSelectedColor: v
  } = a;
  return {
    [`${s}-card`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        [`${s}-tab`]: {
          margin: 0,
          padding: c,
          background: u,
          border: `${unit$1(a.lineWidth)} ${a.lineType} ${p}`,
          transition: `all ${a.motionDurationSlow} ${a.motionEaseInOut}`
        },
        [`${s}-tab-active`]: {
          color: v,
          background: a.colorBgContainer
        },
        [`${s}-tab-focus:has(${s}-tab-btn:focus-visible)`]: genFocusOutline(a, -3),
        [`& ${s}-tab${s}-tab-focus ${s}-tab-btn:focus-visible`]: {
          outline: "none"
        },
        [`${s}-ink-bar`]: {
          visibility: "hidden"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${s}-top, &${s}-bottom`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab + ${s}-tab`]: {
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(d)
            }
          }
        }
      },
      [`&${s}-top`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab`]: {
            borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`
          },
          [`${s}-tab-active`]: {
            borderBottomColor: a.colorBgContainer
          }
        }
      },
      [`&${s}-bottom`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab`]: {
            borderRadius: `0 0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)}`
          },
          [`${s}-tab-active`]: {
            borderTopColor: a.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${s}-left, &${s}-right`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab + ${s}-tab`]: {
            marginTop: unit$1(d)
          }
        }
      },
      [`&${s}-left`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${unit$1(a.borderRadiusLG)} 0 0 ${unit$1(a.borderRadiusLG)}`
            }
          },
          [`${s}-tab-active`]: {
            borderRightColor: {
              _skip_check_: !0,
              value: a.colorBgContainer
            }
          }
        }
      },
      [`&${s}-right`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0`
            }
          },
          [`${s}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: !0,
              value: a.colorBgContainer
            }
          }
        }
      }
    }
  };
}, genDropdownStyle = (a) => {
  const {
    componentCls: s,
    itemHoverColor: c,
    dropdownEdgeChildVerticalPadding: u
  } = a;
  return {
    [`${s}-dropdown`]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: !0,
        value: -9999
      },
      zIndex: a.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${s}-dropdown-menu`]: {
        maxHeight: a.tabsDropdownHeight,
        margin: 0,
        padding: `${unit$1(u)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: !0,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: a.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: a.borderRadiusLG,
        outline: "none",
        boxShadow: a.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, textEllipsis), {
          display: "flex",
          alignItems: "center",
          minWidth: a.tabsDropdownWidth,
          margin: 0,
          padding: `${unit$1(a.paddingXXS)} ${unit$1(a.paddingSM)}`,
          color: a.colorText,
          fontWeight: "normal",
          fontSize: a.fontSize,
          lineHeight: a.lineHeight,
          cursor: "pointer",
          transition: `all ${a.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: !0,
              value: a.marginSM
            },
            color: a.colorIcon,
            fontSize: a.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: c
            }
          },
          "&:hover": {
            background: a.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: a.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
}, genPositionStyle = (a) => {
  const {
    componentCls: s,
    margin: c,
    colorBorderSecondary: u,
    horizontalMargin: d,
    verticalItemPadding: p,
    verticalItemMargin: v,
    calc: A
  } = a;
  return {
    // ========================== Top & Bottom ==========================
    [`${s}-top, ${s}-bottom`]: {
      flexDirection: "column",
      [`> ${s}-nav, > div > ${s}-nav`]: {
        margin: d,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: !0,
            value: 0
          },
          left: {
            _skip_check_: !0,
            value: 0
          },
          borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${u}`,
          content: "''"
        },
        [`${s}-ink-bar`]: {
          height: a.lineWidthBold,
          "&-animated": {
            transition: `width ${a.motionDurationSlow}, left ${a.motionDurationSlow},
            right ${a.motionDurationSlow}`
          }
        },
        [`${s}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: a.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: a.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: a.boxShadowTabsOverflowRight
          },
          [`&${s}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${s}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${s}-top`]: {
      [`> ${s}-nav,
        > div > ${s}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${s}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${s}-bottom`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        order: 1,
        marginTop: c,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${s}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${s}-content-holder, > div > ${s}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${s}-left, ${s}-right`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        flexDirection: "column",
        minWidth: A(a.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${s}-tab`]: {
          padding: p,
          textAlign: "center"
        },
        [`${s}-tab + ${s}-tab`]: {
          margin: v
        },
        // >>>>>>>>>>> Nav
        [`${s}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: a.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: a.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: a.boxShadowTabsOverflowBottom
          },
          [`&${s}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${s}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${s}-ink-bar`]: {
          width: a.lineWidthBold,
          "&-animated": {
            transition: `height ${a.motionDurationSlow}, top ${a.motionDurationSlow}`
          }
        },
        [`${s}-nav-list, ${s}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${s}-left`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        [`${s}-ink-bar`]: {
          right: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${s}-content-holder, > div > ${s}-content-holder`]: {
        marginLeft: {
          _skip_check_: !0,
          value: unit$1(A(a.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: !0,
          value: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
        },
        [`> ${s}-content > ${s}-tabpane`]: {
          paddingLeft: {
            _skip_check_: !0,
            value: a.paddingLG
          }
        }
      }
    },
    [`${s}-right`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        order: 1,
        [`${s}-ink-bar`]: {
          left: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${s}-content-holder, > div > ${s}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: !0,
          value: A(a.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: !0,
          value: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
        },
        [`> ${s}-content > ${s}-tabpane`]: {
          paddingRight: {
            _skip_check_: !0,
            value: a.paddingLG
          }
        }
      }
    }
  };
}, genSizeStyle$1 = (a) => {
  const {
    componentCls: s,
    cardPaddingSM: c,
    cardPaddingLG: u,
    cardHeightSM: d,
    cardHeightLG: p,
    horizontalItemPaddingSM: v,
    horizontalItemPaddingLG: A
  } = a;
  return {
    // >>>>> shared
    [s]: {
      "&-small": {
        [`> ${s}-nav`]: {
          [`${s}-tab`]: {
            padding: v,
            fontSize: a.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${s}-nav`]: {
          [`${s}-tab`]: {
            padding: A,
            fontSize: a.titleFontSizeLG,
            lineHeight: a.lineHeightLG
          }
        }
      }
    },
    // >>>>> card
    [`${s}-card`]: {
      // Small
      [`&${s}-small`]: {
        [`> ${s}-nav`]: {
          [`${s}-tab`]: {
            padding: c
          },
          [`${s}-nav-add`]: {
            minWidth: d,
            minHeight: d
          }
        },
        [`&${s}-bottom`]: {
          [`> ${s}-nav ${s}-tab`]: {
            borderRadius: `0 0 ${unit$1(a.borderRadius)} ${unit$1(a.borderRadius)}`
          }
        },
        [`&${s}-top`]: {
          [`> ${s}-nav ${s}-tab`]: {
            borderRadius: `${unit$1(a.borderRadius)} ${unit$1(a.borderRadius)} 0 0`
          }
        },
        [`&${s}-right`]: {
          [`> ${s}-nav ${s}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${unit$1(a.borderRadius)} ${unit$1(a.borderRadius)} 0`
            }
          }
        },
        [`&${s}-left`]: {
          [`> ${s}-nav ${s}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${unit$1(a.borderRadius)} 0 0 ${unit$1(a.borderRadius)}`
            }
          }
        }
      },
      // Large
      [`&${s}-large`]: {
        [`> ${s}-nav`]: {
          [`${s}-tab`]: {
            padding: u
          },
          [`${s}-nav-add`]: {
            minWidth: p,
            minHeight: p
          }
        }
      }
    }
  };
}, genTabStyle = (a) => {
  const {
    componentCls: s,
    itemActiveColor: c,
    itemHoverColor: u,
    iconCls: d,
    tabsHorizontalItemMargin: p,
    horizontalItemPadding: v,
    itemSelectedColor: A,
    itemColor: x
  } = a, g = `${s}-tab`;
  return {
    [g]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: v,
      fontSize: a.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: x,
      "&-btn, &-remove": {
        "&:focus:not(:focus-visible), &:active": {
          color: c
        }
      },
      "&-btn": {
        outline: "none",
        transition: `all ${a.motionDurationSlow}`,
        [`${g}-icon:not(:last-child)`]: {
          marginInlineEnd: a.marginSM
        }
      },
      "&-remove": Object.assign({
        flex: "none",
        marginRight: {
          _skip_check_: !0,
          value: a.calc(a.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: !0,
          value: a.marginXS
        },
        color: a.colorIcon,
        fontSize: a.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${a.motionDurationSlow}`,
        "&:hover": {
          color: a.colorTextHeading
        }
      }, genFocusStyle(a)),
      "&:hover": {
        color: u
      },
      [`&${g}-active ${g}-btn`]: {
        color: A,
        textShadow: a.tabsActiveTextShadow
      },
      [`&${g}-focus ${g}-btn:focus-visible`]: genFocusOutline(a),
      [`&${g}-disabled`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${g}-disabled ${g}-btn, &${g}-disabled ${s}-remove`]: {
        "&:focus, &:active": {
          color: a.colorTextDisabled
        }
      },
      [`& ${g}-remove ${d}`]: {
        margin: 0
      },
      [`${d}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: !0,
          value: a.marginSM
        }
      }
    },
    [`${g} + ${g}`]: {
      margin: {
        _skip_check_: !0,
        value: p
      }
    }
  };
}, genRtlStyle$1 = (a) => {
  const {
    componentCls: s,
    tabsHorizontalItemMarginRTL: c,
    iconCls: u,
    cardGutter: d,
    calc: p
  } = a;
  return {
    [`${s}-rtl`]: {
      direction: "rtl",
      [`${s}-nav`]: {
        [`${s}-tab`]: {
          margin: {
            _skip_check_: !0,
            value: c
          },
          [`${s}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          },
          [u]: {
            marginRight: {
              _skip_check_: !0,
              value: 0
            },
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(a.marginSM)
            }
          },
          [`${s}-tab-remove`]: {
            marginRight: {
              _skip_check_: !0,
              value: unit$1(a.marginXS)
            },
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(p(a.marginXXS).mul(-1).equal())
            },
            [u]: {
              margin: 0
            }
          }
        }
      },
      [`&${s}-left`]: {
        [`> ${s}-nav`]: {
          order: 1
        },
        [`> ${s}-content-holder`]: {
          order: 0
        }
      },
      [`&${s}-right`]: {
        [`> ${s}-nav`]: {
          order: 0
        },
        [`> ${s}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${s}-card${s}-top, &${s}-card${s}-bottom`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab + ${s}-tab`]: {
            marginRight: {
              _skip_check_: !0,
              value: d
            },
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          }
        }
      }
    },
    [`${s}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${s}-menu-item`]: {
      [`${s}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: !0,
          value: "right"
        }
      }
    }
  };
}, genTabsStyle = (a) => {
  const {
    componentCls: s,
    tabsCardPadding: c,
    cardHeight: u,
    cardGutter: d,
    itemHoverColor: p,
    itemActiveColor: v,
    colorBorderSecondary: A
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${s}-nav, > div > ${s}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${s}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${a.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${s}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${a.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${s}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${s}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${s}-nav-more`]: {
          position: "relative",
          padding: c,
          background: "transparent",
          border: 0,
          color: a.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: !0,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: a.calc(a.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${s}-nav-add`]: Object.assign({
          minWidth: u,
          minHeight: u,
          marginLeft: {
            _skip_check_: !0,
            value: d
          },
          background: "transparent",
          border: `${unit$1(a.lineWidth)} ${a.lineType} ${A}`,
          borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: a.colorText,
          transition: `all ${a.motionDurationSlow} ${a.motionEaseInOut}`,
          "&:hover": {
            color: p
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: v
          }
        }, genFocusStyle(a, -3))
      },
      [`${s}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${s}-ink-bar`]: {
        position: "absolute",
        background: a.inkBarColor,
        pointerEvents: "none"
      }
    }), genTabStyle(a)), {
      // =========================== TabPanes ===========================
      [`${s}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${s}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${s}-tabpane`]: Object.assign(Object.assign({}, genFocusStyle(a)), {
        "&-hidden": {
          display: "none"
        }
      })
    }),
    [`${s}-centered`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        [`${s}-nav-wrap`]: {
          [`&:not([class*='${s}-nav-wrap-ping']) > ${s}-nav-list`]: {
            margin: "auto"
          }
        }
      }
    }
  };
}, prepareComponentToken$i = (a) => {
  const {
    cardHeight: s,
    cardHeightSM: c,
    cardHeightLG: u,
    controlHeight: d,
    controlHeightLG: p
  } = a, v = s || p, A = c || d, x = u || p + 8;
  return {
    zIndexPopup: a.zIndexPopupBase + 50,
    cardBg: a.colorFillAlter,
    // We can not pass this as valid value,
    // Since `cardHeight` will lock nav add button height.
    cardHeight: v,
    cardHeightSM: A,
    cardHeightLG: x,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(v - a.fontHeight) / 2 - a.lineWidth}px ${a.padding}px`,
    cardPaddingSM: `${(A - a.fontHeight) / 2 - a.lineWidth}px ${a.paddingXS}px`,
    cardPaddingLG: `${(x - a.fontHeightLG) / 2 - a.lineWidth}px ${a.padding}px`,
    titleFontSize: a.fontSize,
    titleFontSizeLG: a.fontSizeLG,
    titleFontSizeSM: a.fontSize,
    inkBarColor: a.colorPrimary,
    horizontalMargin: `0 0 ${a.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: "",
    horizontalItemMarginRTL: "",
    horizontalItemPadding: `${a.paddingSM}px 0`,
    horizontalItemPaddingSM: `${a.paddingXS}px 0`,
    horizontalItemPaddingLG: `${a.padding}px 0`,
    verticalItemPadding: `${a.paddingXS}px ${a.paddingLG}px`,
    verticalItemMargin: `${a.margin}px 0 0 0`,
    itemColor: a.colorText,
    itemSelectedColor: a.colorPrimary,
    itemHoverColor: a.colorPrimaryHover,
    itemActiveColor: a.colorPrimaryActive,
    cardGutter: a.marginXXS / 2
  };
}, useStyle$l = genStyleHooks("Tabs", (a) => {
  const s = merge(a, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: a.cardPadding,
    dropdownEdgeChildVerticalPadding: a.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${unit$1(a.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${unit$1(a.horizontalItemGutter)}`
  });
  return [genSizeStyle$1(s), genRtlStyle$1(s), genPositionStyle(s), genDropdownStyle(s), genCardStyle$1(s), genTabsStyle(s), genMotionStyle$2(s)];
}, prepareComponentToken$i), TabPane = () => null;
var __rest$N = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Tabs = (a) => {
  var s, c, u, d, p, v, A, x, g, b, y;
  const {
    type: f,
    className: m,
    rootClassName: C,
    size: w,
    onEdit: S,
    hideAdd: $,
    centered: T,
    addIcon: I,
    removeIcon: _,
    moreIcon: E,
    more: R,
    popupClassName: O,
    children: L,
    items: B,
    animated: F,
    style: M,
    indicatorSize: W,
    indicator: j,
    destroyInactiveTabPane: G,
    destroyOnHidden: U
  } = a, k = __rest$N(a, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "removeIcon", "moreIcon", "more", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator", "destroyInactiveTabPane", "destroyOnHidden"]), {
    prefixCls: N
  } = k, {
    direction: P,
    tabs: D,
    getPrefixCls: H,
    getPopupContainer: V
  } = reactExports.useContext(ConfigContext$1), Z = H("tabs", N), ne = useCSSVarCls(Z), [K, q, Y] = useStyle$l(Z, ne);
  let ee;
  f === "editable-card" && (ee = {
    onEdit: (fe, {
      key: ge,
      event: me
    }) => {
      S?.(fe === "add" ? me : ge, fe);
    },
    removeIcon: (s = _ ?? D?.removeIcon) !== null && s !== void 0 ? s : /* @__PURE__ */ reactExports.createElement(RefIcon$I, null),
    addIcon: (I ?? D?.addIcon) || /* @__PURE__ */ reactExports.createElement(RefIcon$y, null),
    showAdd: $ !== !0
  });
  const Q = H(), J = useSize(w), te = useLegacyItems(B, L), ae = useAnimateConfig(Z, F), se = Object.assign(Object.assign({}, D?.style), M), ie = {
    align: (c = j?.align) !== null && c !== void 0 ? c : (u = D?.indicator) === null || u === void 0 ? void 0 : u.align,
    size: (A = (p = (d = j?.size) !== null && d !== void 0 ? d : W) !== null && p !== void 0 ? p : (v = D?.indicator) === null || v === void 0 ? void 0 : v.size) !== null && A !== void 0 ? A : D?.indicatorSize
  };
  return K(/* @__PURE__ */ reactExports.createElement(Tabs$1, Object.assign({
    direction: P,
    getPopupContainer: V
  }, k, {
    items: te,
    className: classnames({
      [`${Z}-${J}`]: J,
      [`${Z}-card`]: ["card", "editable-card"].includes(f),
      [`${Z}-editable-card`]: f === "editable-card",
      [`${Z}-centered`]: T
    }, D?.className, m, C, q, Y, ne),
    popupClassName: classnames(O, q, Y, ne),
    style: se,
    editable: ee,
    more: Object.assign({
      icon: (y = (b = (g = (x = D?.more) === null || x === void 0 ? void 0 : x.icon) !== null && g !== void 0 ? g : D?.moreIcon) !== null && b !== void 0 ? b : E) !== null && y !== void 0 ? y : /* @__PURE__ */ reactExports.createElement(RefIcon$z, null),
      transitionName: `${Q}-slide-up`
    }, R),
    prefixCls: Z,
    animated: ae,
    indicator: ie,
    // TODO: In the future, destroyInactiveTabPane in rc-tabs needs to be upgrade to destroyOnHidden
    destroyInactiveTabPane: U ?? G
  })));
};
Tabs.TabPane = TabPane;
var __rest$M = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Grid$1 = (a) => {
  var {
    prefixCls: s,
    className: c,
    hoverable: u = !0
  } = a, d = __rest$M(a, ["prefixCls", "className", "hoverable"]);
  const {
    getPrefixCls: p
  } = reactExports.useContext(ConfigContext$1), v = p("card", s), A = classnames(`${v}-grid`, c, {
    [`${v}-grid-hoverable`]: u
  });
  return /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, d, {
    className: A
  }));
}, genCardHeadStyle = (a) => {
  const {
    antCls: s,
    componentCls: c,
    headerHeight: u,
    headerPadding: d,
    tabsMarginBottom: p
  } = a;
  return Object.assign(Object.assign({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: u,
    marginBottom: -1,
    padding: `0 ${unit$1(d)}`,
    color: a.colorTextHeading,
    fontWeight: a.fontWeightStrong,
    fontSize: a.headerFontSize,
    background: a.headerBg,
    borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorderSecondary}`,
    borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`
  }, clearFix()), {
    "&-wrapper": {
      width: "100%",
      display: "flex",
      alignItems: "center"
    },
    "&-title": Object.assign(Object.assign({
      display: "inline-block",
      flex: 1
    }, textEllipsis), {
      [`
          > ${c}-typography,
          > ${c}-typography-edit-content
        `]: {
        insetInlineStart: 0,
        marginTop: 0,
        marginBottom: 0
      }
    }),
    [`${s}-tabs-top`]: {
      clear: "both",
      marginBottom: p,
      color: a.colorText,
      fontWeight: "normal",
      fontSize: a.fontSize,
      "&-bar": {
        borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorderSecondary}`
      }
    }
  });
}, genCardGridStyle = (a) => {
  const {
    cardPaddingBase: s,
    colorBorderSecondary: c,
    cardShadow: u,
    lineWidth: d
  } = a;
  return {
    width: "33.33%",
    padding: s,
    border: 0,
    borderRadius: 0,
    boxShadow: `
      ${unit$1(d)} 0 0 0 ${c},
      0 ${unit$1(d)} 0 0 ${c},
      ${unit$1(d)} ${unit$1(d)} 0 0 ${c},
      ${unit$1(d)} 0 0 0 ${c} inset,
      0 ${unit$1(d)} 0 0 ${c} inset;
    `,
    transition: `all ${a.motionDurationMid}`,
    "&-hoverable:hover": {
      position: "relative",
      zIndex: 1,
      boxShadow: u
    }
  };
}, genCardActionsStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    actionsLiMargin: u,
    cardActionsIconSize: d,
    colorBorderSecondary: p,
    actionsBg: v
  } = a;
  return Object.assign(Object.assign({
    margin: 0,
    padding: 0,
    listStyle: "none",
    background: v,
    borderTop: `${unit$1(a.lineWidth)} ${a.lineType} ${p}`,
    display: "flex",
    borderRadius: `0 0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)}`
  }, clearFix()), {
    "& > li": {
      margin: u,
      color: a.colorTextDescription,
      textAlign: "center",
      "> span": {
        position: "relative",
        display: "block",
        minWidth: a.calc(a.cardActionsIconSize).mul(2).equal(),
        fontSize: a.fontSize,
        lineHeight: a.lineHeight,
        cursor: "pointer",
        "&:hover": {
          color: a.colorPrimary,
          transition: `color ${a.motionDurationMid}`
        },
        [`a:not(${s}-btn), > ${c}`]: {
          display: "inline-block",
          width: "100%",
          color: a.colorIcon,
          lineHeight: unit$1(a.fontHeight),
          transition: `color ${a.motionDurationMid}`,
          "&:hover": {
            color: a.colorPrimary
          }
        },
        [`> ${c}`]: {
          fontSize: d,
          lineHeight: unit$1(a.calc(d).mul(a.lineHeight).equal())
        }
      },
      "&:not(:last-child)": {
        borderInlineEnd: `${unit$1(a.lineWidth)} ${a.lineType} ${p}`
      }
    }
  });
}, genCardMetaStyle = (a) => Object.assign(Object.assign({
  margin: `${unit$1(a.calc(a.marginXXS).mul(-1).equal())} 0`,
  display: "flex"
}, clearFix()), {
  "&-avatar": {
    paddingInlineEnd: a.padding
  },
  "&-detail": {
    overflow: "hidden",
    flex: 1,
    "> div:not(:last-child)": {
      marginBottom: a.marginXS
    }
  },
  "&-title": Object.assign({
    color: a.colorTextHeading,
    fontWeight: a.fontWeightStrong,
    fontSize: a.fontSizeLG
  }, textEllipsis),
  "&-description": {
    color: a.colorTextDescription
  }
}), genCardTypeInnerStyle = (a) => {
  const {
    componentCls: s,
    colorFillAlter: c,
    headerPadding: u,
    bodyPadding: d
  } = a;
  return {
    [`${s}-head`]: {
      padding: `0 ${unit$1(u)}`,
      background: c,
      "&-title": {
        fontSize: a.fontSize
      }
    },
    [`${s}-body`]: {
      padding: `${unit$1(a.padding)} ${unit$1(d)}`
    }
  };
}, genCardLoadingStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    overflow: "hidden",
    [`${s}-body`]: {
      userSelect: "none"
    }
  };
}, genCardStyle = (a) => {
  const {
    componentCls: s,
    cardShadow: c,
    cardHeadPadding: u,
    colorBorderSecondary: d,
    boxShadowTertiary: p,
    bodyPadding: v,
    extraColor: A
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "relative",
      background: a.colorBgContainer,
      borderRadius: a.borderRadiusLG,
      [`&:not(${s}-bordered)`]: {
        boxShadow: p
      },
      [`${s}-head`]: genCardHeadStyle(a),
      [`${s}-extra`]: {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: "auto",
        color: A,
        fontWeight: "normal",
        fontSize: a.fontSize
      },
      [`${s}-body`]: Object.assign({
        padding: v,
        borderRadius: `0 0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)}`
      }, clearFix()),
      [`${s}-grid`]: genCardGridStyle(a),
      [`${s}-cover`]: {
        "> *": {
          display: "block",
          width: "100%",
          borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`
        }
      },
      [`${s}-actions`]: genCardActionsStyle(a),
      [`${s}-meta`]: genCardMetaStyle(a)
    }),
    [`${s}-bordered`]: {
      border: `${unit$1(a.lineWidth)} ${a.lineType} ${d}`,
      [`${s}-cover`]: {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
      }
    },
    [`${s}-hoverable`]: {
      cursor: "pointer",
      transition: `box-shadow ${a.motionDurationMid}, border-color ${a.motionDurationMid}`,
      "&:hover": {
        borderColor: "transparent",
        boxShadow: c
      }
    },
    [`${s}-contain-grid`]: {
      borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0 `,
      [`${s}-body`]: {
        display: "flex",
        flexWrap: "wrap"
      },
      [`&:not(${s}-loading) ${s}-body`]: {
        marginBlockStart: a.calc(a.lineWidth).mul(-1).equal(),
        marginInlineStart: a.calc(a.lineWidth).mul(-1).equal(),
        padding: 0
      }
    },
    [`${s}-contain-tabs`]: {
      [`> div${s}-head`]: {
        minHeight: 0,
        [`${s}-head-title, ${s}-extra`]: {
          paddingTop: u
        }
      }
    },
    [`${s}-type-inner`]: genCardTypeInnerStyle(a),
    [`${s}-loading`]: genCardLoadingStyle(a),
    [`${s}-rtl`]: {
      direction: "rtl"
    }
  };
}, genCardSizeStyle = (a) => {
  const {
    componentCls: s,
    bodyPaddingSM: c,
    headerPaddingSM: u,
    headerHeightSM: d,
    headerFontSizeSM: p
  } = a;
  return {
    [`${s}-small`]: {
      [`> ${s}-head`]: {
        minHeight: d,
        padding: `0 ${unit$1(u)}`,
        fontSize: p,
        [`> ${s}-head-wrapper`]: {
          [`> ${s}-extra`]: {
            fontSize: a.fontSize
          }
        }
      },
      [`> ${s}-body`]: {
        padding: c
      }
    },
    [`${s}-small${s}-contain-tabs`]: {
      [`> ${s}-head`]: {
        [`${s}-head-title, ${s}-extra`]: {
          paddingTop: 0,
          display: "flex",
          alignItems: "center"
        }
      }
    }
  };
}, prepareComponentToken$h = (a) => {
  var s, c;
  return {
    headerBg: "transparent",
    headerFontSize: a.fontSizeLG,
    headerFontSizeSM: a.fontSize,
    headerHeight: a.fontSizeLG * a.lineHeightLG + a.padding * 2,
    headerHeightSM: a.fontSize * a.lineHeight + a.paddingXS * 2,
    actionsBg: a.colorBgContainer,
    actionsLiMargin: `${a.paddingSM}px 0`,
    tabsMarginBottom: -a.padding - a.lineWidth,
    extraColor: a.colorText,
    bodyPaddingSM: 12,
    // Fixed padding.
    headerPaddingSM: 12,
    bodyPadding: (s = a.bodyPadding) !== null && s !== void 0 ? s : a.paddingLG,
    headerPadding: (c = a.headerPadding) !== null && c !== void 0 ? c : a.paddingLG
  };
}, useStyle$k = genStyleHooks("Card", (a) => {
  const s = merge(a, {
    cardShadow: a.boxShadowCard,
    cardHeadPadding: a.padding,
    cardPaddingBase: a.paddingLG,
    cardActionsIconSize: a.fontSize
  });
  return [
    // Style
    genCardStyle(s),
    // Size
    genCardSizeStyle(s)
  ];
}, prepareComponentToken$h);
var __rest$L = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const ActionNode = (a) => {
  const {
    actionClasses: s,
    actions: c = [],
    actionStyle: u
  } = a;
  return /* @__PURE__ */ reactExports.createElement("ul", {
    className: s,
    style: u
  }, c.map((d, p) => {
    const v = `action-${p}`;
    return /* @__PURE__ */ reactExports.createElement("li", {
      style: {
        width: `${100 / c.length}%`
      },
      key: v
    }, /* @__PURE__ */ reactExports.createElement("span", null, d));
  }));
}, Card$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    className: u,
    rootClassName: d,
    style: p,
    extra: v,
    headStyle: A = {},
    bodyStyle: x = {},
    title: g,
    loading: b,
    bordered: y,
    variant: f,
    size: m,
    type: C,
    cover: w,
    actions: S,
    tabList: $,
    children: T,
    activeTabKey: I,
    defaultActiveTabKey: _,
    tabBarExtraContent: E,
    hoverable: R,
    tabProps: O = {},
    classNames: L,
    styles: B
  } = a, F = __rest$L(a, ["prefixCls", "className", "rootClassName", "style", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "variant", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "classNames", "styles"]), {
    getPrefixCls: M,
    direction: W,
    card: j
  } = reactExports.useContext(ConfigContext$1), [G] = useVariant("card", f, y), U = (ve) => {
    var he;
    (he = a.onTabChange) === null || he === void 0 || he.call(a, ve);
  }, k = (ve) => {
    var he;
    return classnames((he = j?.classNames) === null || he === void 0 ? void 0 : he[ve], L?.[ve]);
  }, N = (ve) => {
    var he;
    return Object.assign(Object.assign({}, (he = j?.styles) === null || he === void 0 ? void 0 : he[ve]), B?.[ve]);
  }, P = reactExports.useMemo(() => {
    let ve = !1;
    return reactExports.Children.forEach(T, (he) => {
      he?.type === Grid$1 && (ve = !0);
    }), ve;
  }, [T]), D = M("card", c), [H, V, Z] = useStyle$k(D), ne = /* @__PURE__ */ reactExports.createElement(Skeleton, {
    loading: !0,
    active: !0,
    paragraph: {
      rows: 4
    },
    title: !1
  }, T), K = I !== void 0, q = Object.assign(Object.assign({}, O), {
    [K ? "activeKey" : "defaultActiveKey"]: K ? I : _,
    tabBarExtraContent: E
  });
  let Y;
  const ee = useSize(m), Q = !ee || ee === "default" ? "large" : ee, J = $ ? /* @__PURE__ */ reactExports.createElement(Tabs, Object.assign({
    size: Q
  }, q, {
    className: `${D}-head-tabs`,
    onChange: U,
    items: $.map((ve) => {
      var {
        tab: he
      } = ve, ye = __rest$L(ve, ["tab"]);
      return Object.assign({
        label: he
      }, ye);
    })
  })) : null;
  if (g || v || J) {
    const ve = classnames(`${D}-head`, k("header")), he = classnames(`${D}-head-title`, k("title")), ye = classnames(`${D}-extra`, k("extra")), Ce = Object.assign(Object.assign({}, A), N("header"));
    Y = /* @__PURE__ */ reactExports.createElement("div", {
      className: ve,
      style: Ce
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: `${D}-head-wrapper`
    }, g && /* @__PURE__ */ reactExports.createElement("div", {
      className: he,
      style: N("title")
    }, g), v && /* @__PURE__ */ reactExports.createElement("div", {
      className: ye,
      style: N("extra")
    }, v)), J);
  }
  const te = classnames(`${D}-cover`, k("cover")), ae = w ? /* @__PURE__ */ reactExports.createElement("div", {
    className: te,
    style: N("cover")
  }, w) : null, se = classnames(`${D}-body`, k("body")), ie = Object.assign(Object.assign({}, x), N("body")), fe = /* @__PURE__ */ reactExports.createElement("div", {
    className: se,
    style: ie
  }, b ? ne : T), ge = classnames(`${D}-actions`, k("actions")), me = S?.length ? /* @__PURE__ */ reactExports.createElement(ActionNode, {
    actionClasses: ge,
    actionStyle: N("actions"),
    actions: S
  }) : null, pe = omit(F, ["onTabChange"]), be = classnames(D, j?.className, {
    [`${D}-loading`]: b,
    [`${D}-bordered`]: G !== "borderless",
    [`${D}-hoverable`]: R,
    [`${D}-contain-grid`]: P,
    [`${D}-contain-tabs`]: $?.length,
    [`${D}-${ee}`]: ee,
    [`${D}-type-${C}`]: !!C,
    [`${D}-rtl`]: W === "rtl"
  }, u, d, V, Z), le = Object.assign(Object.assign({}, j?.style), p);
  return H(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    ref: s
  }, pe, {
    className: be,
    style: le
  }), Y, ae, fe, me));
});
var __rest$K = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Meta = (a) => {
  const {
    prefixCls: s,
    className: c,
    avatar: u,
    title: d,
    description: p
  } = a, v = __rest$K(a, ["prefixCls", "className", "avatar", "title", "description"]), {
    getPrefixCls: A
  } = reactExports.useContext(ConfigContext$1), x = A("card", s), g = classnames(`${x}-meta`, c), b = u ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${x}-meta-avatar`
  }, u) : null, y = d ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${x}-meta-title`
  }, d) : null, f = p ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${x}-meta-description`
  }, p) : null, m = y || f ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${x}-meta-detail`
  }, y, f) : null;
  return /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, v, {
    className: g
  }), b, m);
}, Card = Card$1;
Card.Grid = Grid$1;
Card.Meta = Meta;
function throttle$1(a, s, c) {
  var u = c || {}, d = u.noTrailing, p = d === void 0 ? !1 : d, v = u.noLeading, A = v === void 0 ? !1 : v, x = u.debounceMode, g = x === void 0 ? void 0 : x, b, y = !1, f = 0;
  function m() {
    b && clearTimeout(b);
  }
  function C(S) {
    var $ = S || {}, T = $.upcomingOnly, I = T === void 0 ? !1 : T;
    m(), y = !I;
  }
  function w() {
    for (var S = arguments.length, $ = new Array(S), T = 0; T < S; T++)
      $[T] = arguments[T];
    var I = this, _ = Date.now() - f;
    if (y)
      return;
    function E() {
      f = Date.now(), s.apply(I, $);
    }
    function R() {
      b = void 0;
    }
    !A && g && !b && E(), m(), g === void 0 && _ > a ? A ? (f = Date.now(), p || (b = setTimeout(g ? R : E, a))) : E() : p !== !0 && (b = setTimeout(g ? R : E, g === void 0 ? a - _ : a));
  }
  return w.cancel = C, w;
}
function debounce(a, s, c) {
  var u = {}, d = u.atBegin, p = d === void 0 ? !1 : d;
  return throttle$1(a, s, {
    debounceMode: p !== !1
  });
}
function getEntity(a, s) {
  return a[s];
}
var _excluded$r = ["children"];
function getPosition$2(a, s) {
  return "".concat(a, "-").concat(s);
}
function isTreeNode(a) {
  return a && a.type && a.type.isTreeNode;
}
function getKey$1(a, s) {
  return a ?? s;
}
function fillFieldNames$1(a) {
  var s = a || {}, c = s.title, u = s._title, d = s.key, p = s.children, v = c || "title";
  return {
    title: v,
    _title: u || [v],
    key: d || "key",
    children: p || "children"
  };
}
function convertTreeToData(a) {
  function s(c) {
    var u = toArray$8(c);
    return u.map(function(d) {
      if (!isTreeNode(d))
        return warningOnce(!d, "Tree/TreeNode can only accept TreeNode as children."), null;
      var p = d.key, v = d.props, A = v.children, x = _objectWithoutProperties$2(v, _excluded$r), g = _objectSpread2$1({
        key: p
      }, x), b = s(A);
      return b.length && (g.children = b), g;
    }).filter(function(d) {
      return d;
    });
  }
  return s(a);
}
function flattenTreeData(a, s, c) {
  var u = fillFieldNames$1(c), d = u._title, p = u.key, v = u.children, A = new Set(s === !0 ? [] : s), x = [];
  function g(b) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return b.map(function(f, m) {
      for (var C = getPosition$2(y ? y.pos : "0", m), w = getKey$1(f[p], C), S, $ = 0; $ < d.length; $ += 1) {
        var T = d[$];
        if (f[T] !== void 0) {
          S = f[T];
          break;
        }
      }
      var I = Object.assign(omit(f, [].concat(_toConsumableArray$e(d), [p, v])), {
        title: S,
        key: w,
        parent: y,
        pos: C,
        children: null,
        data: f,
        isStart: [].concat(_toConsumableArray$e(y ? y.isStart : []), [m === 0]),
        isEnd: [].concat(_toConsumableArray$e(y ? y.isEnd : []), [m === b.length - 1])
      });
      return x.push(I), s === !0 || A.has(w) ? I.children = g(f[v] || [], I) : I.children = [], I;
    });
  }
  return g(a), x;
}
function traverseDataNodes(a, s, c) {
  var u = {};
  _typeof$h(c) === "object" ? u = c : u = {
    externalGetKey: c
  }, u = u || {};
  var d = u, p = d.childrenPropName, v = d.externalGetKey, A = d.fieldNames, x = fillFieldNames$1(A), g = x.key, b = x.children, y = p || b, f;
  v ? typeof v == "string" ? f = function(w) {
    return w[v];
  } : typeof v == "function" && (f = function(w) {
    return v(w);
  }) : f = function(w, S) {
    return getKey$1(w[g], S);
  };
  function m(C, w, S, $) {
    var T = C ? C[y] : a, I = C ? getPosition$2(S.pos, w) : "0", _ = C ? [].concat(_toConsumableArray$e($), [C]) : [];
    if (C) {
      var E = f(C, I), R = {
        node: C,
        index: w,
        pos: I,
        key: E,
        parentPos: S.node ? S.pos : null,
        level: S.level + 1,
        nodes: _
      };
      s(R);
    }
    T && T.forEach(function(O, L) {
      m(O, L, {
        node: C,
        pos: I,
        level: S ? S.level + 1 : -1
      }, _);
    });
  }
  m(null);
}
function convertDataToEntities(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = s.initWrapper, u = s.processEntity, d = s.onProcessFinished, p = s.externalGetKey, v = s.childrenPropName, A = s.fieldNames, x = arguments.length > 2 ? arguments[2] : void 0, g = p || x, b = {}, y = {}, f = {
    posEntities: b,
    keyEntities: y
  };
  return c && (f = c(f) || f), traverseDataNodes(a, function(m) {
    var C = m.node, w = m.index, S = m.pos, $ = m.key, T = m.parentPos, I = m.level, _ = m.nodes, E = {
      node: C,
      nodes: _,
      index: w,
      key: $,
      pos: S,
      level: I
    }, R = getKey$1($, S);
    b[S] = E, y[R] = E, E.parent = b[T], E.parent && (E.parent.children = E.parent.children || [], E.parent.children.push(E)), u && u(E, f);
  }, {
    externalGetKey: g,
    childrenPropName: v,
    fieldNames: A
  }), d && d(f), f;
}
function getTreeNodeProps(a, s) {
  var c = s.expandedKeys, u = s.selectedKeys, d = s.loadedKeys, p = s.loadingKeys, v = s.checkedKeys, A = s.halfCheckedKeys, x = s.dragOverNodeKey, g = s.dropPosition, b = s.keyEntities, y = getEntity(b, a), f = {
    eventKey: a,
    expanded: c.indexOf(a) !== -1,
    selected: u.indexOf(a) !== -1,
    loaded: d.indexOf(a) !== -1,
    loading: p.indexOf(a) !== -1,
    checked: v.indexOf(a) !== -1,
    halfChecked: A.indexOf(a) !== -1,
    pos: String(y ? y.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: x === a && g === 0,
    dragOverGapTop: x === a && g === -1,
    dragOverGapBottom: x === a && g === 1
  };
  return f;
}
function convertNodePropsToEventData(a) {
  var s = a.data, c = a.expanded, u = a.selected, d = a.checked, p = a.loaded, v = a.loading, A = a.halfChecked, x = a.dragOver, g = a.dragOverGapTop, b = a.dragOverGapBottom, y = a.pos, f = a.active, m = a.eventKey, C = _objectSpread2$1(_objectSpread2$1({}, s), {}, {
    expanded: c,
    selected: u,
    checked: d,
    loaded: p,
    loading: v,
    halfChecked: A,
    dragOver: x,
    dragOverGapTop: g,
    dragOverGapBottom: b,
    pos: y,
    active: f,
    key: m
  });
  return "props" in C || Object.defineProperty(C, "props", {
    get: function() {
      return warningOnce(!1, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`."), a;
    }
  }), C;
}
function removeFromCheckedKeys(a, s) {
  var c = /* @__PURE__ */ new Set();
  return a.forEach(function(u) {
    s.has(u) || c.add(u);
  }), c;
}
function isCheckDisabled$1(a) {
  var s = a || {}, c = s.disabled, u = s.disableCheckbox, d = s.checkable;
  return !!(c || u) || d === !1;
}
function fillConductCheck(a, s, c, u) {
  for (var d = new Set(a), p = /* @__PURE__ */ new Set(), v = 0; v <= c; v += 1) {
    var A = s.get(v) || /* @__PURE__ */ new Set();
    A.forEach(function(y) {
      var f = y.key, m = y.node, C = y.children, w = C === void 0 ? [] : C;
      d.has(f) && !u(m) && w.filter(function(S) {
        return !u(S.node);
      }).forEach(function(S) {
        d.add(S.key);
      });
    });
  }
  for (var x = /* @__PURE__ */ new Set(), g = c; g >= 0; g -= 1) {
    var b = s.get(g) || /* @__PURE__ */ new Set();
    b.forEach(function(y) {
      var f = y.parent, m = y.node;
      if (!(u(m) || !y.parent || x.has(y.parent.key))) {
        if (u(y.parent.node)) {
          x.add(f.key);
          return;
        }
        var C = !0, w = !1;
        (f.children || []).filter(function(S) {
          return !u(S.node);
        }).forEach(function(S) {
          var $ = S.key, T = d.has($);
          C && !T && (C = !1), !w && (T || p.has($)) && (w = !0);
        }), C && d.add(f.key), w && p.add(f.key), x.add(f.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(d),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(p, d))
  };
}
function cleanConductCheck(a, s, c, u, d) {
  for (var p = new Set(a), v = new Set(s), A = 0; A <= u; A += 1) {
    var x = c.get(A) || /* @__PURE__ */ new Set();
    x.forEach(function(f) {
      var m = f.key, C = f.node, w = f.children, S = w === void 0 ? [] : w;
      !p.has(m) && !v.has(m) && !d(C) && S.filter(function($) {
        return !d($.node);
      }).forEach(function($) {
        p.delete($.key);
      });
    });
  }
  v = /* @__PURE__ */ new Set();
  for (var g = /* @__PURE__ */ new Set(), b = u; b >= 0; b -= 1) {
    var y = c.get(b) || /* @__PURE__ */ new Set();
    y.forEach(function(f) {
      var m = f.parent, C = f.node;
      if (!(d(C) || !f.parent || g.has(f.parent.key))) {
        if (d(f.parent.node)) {
          g.add(m.key);
          return;
        }
        var w = !0, S = !1;
        (m.children || []).filter(function($) {
          return !d($.node);
        }).forEach(function($) {
          var T = $.key, I = p.has(T);
          w && !I && (w = !1), !S && (I || v.has(T)) && (S = !0);
        }), w || p.delete(m.key), S && v.add(m.key), g.add(m.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(p),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(v, p))
  };
}
function conductCheck(a, s, c, u) {
  var d = [], p;
  u ? p = u : p = isCheckDisabled$1;
  var v = new Set(a.filter(function(b) {
    var y = !!getEntity(c, b);
    return y || d.push(b), y;
  })), A = /* @__PURE__ */ new Map(), x = 0;
  Object.keys(c).forEach(function(b) {
    var y = c[b], f = y.level, m = A.get(f);
    m || (m = /* @__PURE__ */ new Set(), A.set(f, m)), m.add(y), x = Math.max(x, f);
  }), warningOnce(!d.length, "Tree missing follow keys: ".concat(d.slice(0, 100).map(function(b) {
    return "'".concat(b, "'");
  }).join(", ")));
  var g;
  return s === !0 ? g = fillConductCheck(v, A, x, p) : g = cleanConductCheck(v, s.halfCheckedKeys, A, x, p), g;
}
const genCheckboxStyle = (a) => {
  const {
    checkboxCls: s
  } = a, c = `${s}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${s}-group`]: Object.assign(Object.assign({}, resetComponent(a)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: a.marginXS,
        // Group > Grid
        [`> ${a.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [c]: Object.assign(Object.assign({}, resetComponent(a)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${c}`]: {
          marginInlineStart: 0
        },
        [`&${c}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            // FIXME: magic
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        borderRadius: a.borderRadiusSM,
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${s}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${s}-inner`]: Object.assign({}, genFocusOutline(a))
        },
        // Wrapper > Checkbox > inner
        [`${s}-inner`]: {
          boxSizing: "border-box",
          display: "block",
          width: a.checkboxSize,
          height: a.checkboxSize,
          direction: "ltr",
          backgroundColor: a.colorBgContainer,
          border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
          borderRadius: a.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${a.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "25%",
            display: "table",
            width: a.calc(a.checkboxSize).div(14).mul(5).equal(),
            height: a.calc(a.checkboxSize).div(14).mul(8).equal(),
            border: `${unit$1(a.lineWidthBold)} solid ${a.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${a.motionDurationFast} ${a.motionEaseInBack}, opacity ${a.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: a.paddingXS,
          paddingInlineEnd: a.paddingXS
        }
      })
    },
    // ===================== Hover =====================
    {
      // Wrapper & Wrapper > Checkbox
      [`
        ${c}:not(${c}-disabled),
        ${s}:not(${s}-disabled)
      `]: {
        [`&:hover ${s}-inner`]: {
          borderColor: a.colorPrimary
        }
      },
      [`${c}:not(${c}-disabled)`]: {
        [`&:hover ${s}-checked:not(${s}-disabled) ${s}-inner`]: {
          backgroundColor: a.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${s}-checked:not(${s}-disabled):after`]: {
          borderColor: a.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${s}-checked`]: {
        [`${s}-inner`]: {
          backgroundColor: a.colorPrimary,
          borderColor: a.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${a.motionDurationMid} ${a.motionEaseOutBack} ${a.motionDurationFast}`
          }
        }
      },
      [`
        ${c}-checked:not(${c}-disabled),
        ${s}-checked:not(${s}-disabled)
      `]: {
        [`&:hover ${s}-inner`]: {
          backgroundColor: a.colorPrimaryHover,
          borderColor: "transparent"
        }
      }
    },
    // ================= Indeterminate =================
    {
      [s]: {
        "&-indeterminate": {
          "&": {
            // Wrapper > Checkbox > inner
            [`${s}-inner`]: {
              backgroundColor: `${a.colorBgContainer}`,
              borderColor: `${a.colorBorder}`,
              "&:after": {
                top: "50%",
                insetInlineStart: "50%",
                width: a.calc(a.fontSizeLG).div(2).equal(),
                height: a.calc(a.fontSizeLG).div(2).equal(),
                backgroundColor: a.colorPrimary,
                border: 0,
                transform: "translate(-50%, -50%) scale(1)",
                opacity: 1,
                content: '""'
              }
            },
            // https://github.com/ant-design/ant-design/issues/50074
            [`&:hover ${s}-inner`]: {
              backgroundColor: `${a.colorBgContainer}`,
              borderColor: `${a.colorPrimary}`
            }
          }
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${c}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${s}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${s}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${s}-inner`]: {
          background: a.colorBgContainerDisabled,
          borderColor: a.colorBorder,
          "&:after": {
            borderColor: a.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: a.colorTextDisabled
        },
        [`&${s}-indeterminate ${s}-inner::after`]: {
          background: a.colorTextDisabled
        }
      }
    }
  ];
};
function getStyle$1(a, s) {
  const c = merge(s, {
    checkboxCls: `.${a}`,
    checkboxSize: s.controlInteractiveSize
  });
  return [genCheckboxStyle(c)];
}
const useStyle$j = genStyleHooks("Checkbox", (a, {
  prefixCls: s
}) => [getStyle$1(s, a)]), GroupContext = /* @__PURE__ */ React.createContext(null);
var __rest$J = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalCheckbox = (a, s) => {
  var c;
  const {
    prefixCls: u,
    className: d,
    rootClassName: p,
    children: v,
    indeterminate: A = !1,
    style: x,
    onMouseEnter: g,
    onMouseLeave: b,
    skipGroup: y = !1,
    disabled: f
  } = a, m = __rest$J(a, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), {
    getPrefixCls: C,
    direction: w,
    checkbox: S
  } = reactExports.useContext(ConfigContext$1), $ = reactExports.useContext(GroupContext), {
    isFormItemInput: T
  } = reactExports.useContext(FormItemInputContext), I = reactExports.useContext(DisabledContext), _ = (c = $?.disabled || f) !== null && c !== void 0 ? c : I, E = reactExports.useRef(m.value), R = reactExports.useRef(null), O = composeRef(s, R);
  reactExports.useEffect(() => {
    $?.registerValue(m.value);
  }, []), reactExports.useEffect(() => {
    if (!y)
      return m.value !== E.current && ($?.cancelValue(E.current), $?.registerValue(m.value), E.current = m.value), () => $?.cancelValue(m.value);
  }, [m.value]), reactExports.useEffect(() => {
    var P;
    !((P = R.current) === null || P === void 0) && P.input && (R.current.input.indeterminate = A);
  }, [A]);
  const L = C("checkbox", u), B = useCSSVarCls(L), [F, M, W] = useStyle$j(L, B), j = Object.assign({}, m);
  $ && !y && (j.onChange = (...P) => {
    m.onChange && m.onChange.apply(m, P), $.toggleOption && $.toggleOption({
      label: v,
      value: m.value
    });
  }, j.name = $.name, j.checked = $.value.includes(m.value));
  const G = classnames(`${L}-wrapper`, {
    [`${L}-rtl`]: w === "rtl",
    [`${L}-wrapper-checked`]: j.checked,
    [`${L}-wrapper-disabled`]: _,
    [`${L}-wrapper-in-form-item`]: T
  }, S?.className, d, p, W, B, M), U = classnames({
    [`${L}-indeterminate`]: A
  }, TARGET_CLS, M), [k, N] = useBubbleLock(j.onClick);
  return F(/* @__PURE__ */ reactExports.createElement(Wave, {
    component: "Checkbox",
    disabled: _
  }, /* @__PURE__ */ reactExports.createElement("label", {
    className: G,
    style: Object.assign(Object.assign({}, S?.style), x),
    onMouseEnter: g,
    onMouseLeave: b,
    onClick: k
  }, /* @__PURE__ */ reactExports.createElement(Checkbox$3, Object.assign({}, j, {
    onClick: N,
    prefixCls: L,
    className: U,
    disabled: _,
    ref: O
  })), v != null && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${L}-label`
  }, v))));
}, Checkbox$2 = /* @__PURE__ */ reactExports.forwardRef(InternalCheckbox);
var __rest$I = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const CheckboxGroup = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    defaultValue: c,
    children: u,
    options: d = [],
    prefixCls: p,
    className: v,
    rootClassName: A,
    style: x,
    onChange: g
  } = a, b = __rest$I(a, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]), {
    getPrefixCls: y,
    direction: f
  } = reactExports.useContext(ConfigContext$1), [m, C] = reactExports.useState(b.value || c || []), [w, S] = reactExports.useState([]);
  reactExports.useEffect(() => {
    "value" in b && C(b.value || []);
  }, [b.value]);
  const $ = reactExports.useMemo(() => d.map((U) => typeof U == "string" || typeof U == "number" ? {
    label: U,
    value: U
  } : U), [d]), T = (U) => {
    S((k) => k.filter((N) => N !== U));
  }, I = (U) => {
    S((k) => [].concat(_toConsumableArray$e(k), [U]));
  }, _ = (U) => {
    const k = m.indexOf(U.value), N = _toConsumableArray$e(m);
    k === -1 ? N.push(U.value) : N.splice(k, 1), "value" in b || C(N), g?.(N.filter((P) => w.includes(P)).sort((P, D) => {
      const H = $.findIndex((Z) => Z.value === P), V = $.findIndex((Z) => Z.value === D);
      return H - V;
    }));
  }, E = y("checkbox", p), R = `${E}-group`, O = useCSSVarCls(E), [L, B, F] = useStyle$j(E, O), M = omit(b, ["value", "disabled"]), W = d.length ? $.map((U) => /* @__PURE__ */ reactExports.createElement(Checkbox$2, {
    prefixCls: E,
    key: U.value.toString(),
    disabled: "disabled" in U ? U.disabled : b.disabled,
    value: U.value,
    checked: m.includes(U.value),
    onChange: U.onChange,
    className: classnames(`${R}-item`, U.className),
    style: U.style,
    title: U.title,
    id: U.id,
    required: U.required
  }, U.label)) : u, j = reactExports.useMemo(() => ({
    toggleOption: _,
    value: m,
    disabled: b.disabled,
    name: b.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: I,
    cancelValue: T
  }), [_, m, b.disabled, b.name, I, T]), G = classnames(R, {
    [`${R}-rtl`]: f === "rtl"
  }, v, A, F, O, B);
  return L(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    className: G,
    style: x
  }, M, {
    ref: s
  }), /* @__PURE__ */ reactExports.createElement(GroupContext.Provider, {
    value: j
  }, W)));
}), Checkbox$1 = Checkbox$2;
Checkbox$1.Group = CheckboxGroup;
Checkbox$1.__ANT_CHECKBOX = !0;
const RowContext = /* @__PURE__ */ reactExports.createContext({});
var __rest$H = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function parseFlex(a) {
  return typeof a == "number" ? `${a} ${a} auto` : /^\d+(\.\d+)?(px|em|rem|%)$/.test(a) ? `0 0 ${a}` : a;
}
const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"], Col = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: c,
    direction: u
  } = reactExports.useContext(ConfigContext$1), {
    gutter: d,
    wrap: p
  } = reactExports.useContext(RowContext), {
    prefixCls: v,
    span: A,
    order: x,
    offset: g,
    push: b,
    pull: y,
    className: f,
    children: m,
    flex: C,
    style: w
  } = a, S = __rest$H(a, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]), $ = c("col", v), [T, I, _] = useColStyle($), E = {};
  let R = {};
  sizes.forEach((B) => {
    let F = {};
    const M = a[B];
    typeof M == "number" ? F.span = M : typeof M == "object" && (F = M || {}), delete S[B], R = Object.assign(Object.assign({}, R), {
      [`${$}-${B}-${F.span}`]: F.span !== void 0,
      [`${$}-${B}-order-${F.order}`]: F.order || F.order === 0,
      [`${$}-${B}-offset-${F.offset}`]: F.offset || F.offset === 0,
      [`${$}-${B}-push-${F.push}`]: F.push || F.push === 0,
      [`${$}-${B}-pull-${F.pull}`]: F.pull || F.pull === 0,
      [`${$}-rtl`]: u === "rtl"
    }), F.flex && (R[`${$}-${B}-flex`] = !0, E[`--${$}-${B}-flex`] = parseFlex(F.flex));
  });
  const O = classnames($, {
    [`${$}-${A}`]: A !== void 0,
    [`${$}-order-${x}`]: x,
    [`${$}-offset-${g}`]: g,
    [`${$}-push-${b}`]: b,
    [`${$}-pull-${y}`]: y
  }, f, R, I, _), L = {};
  if (d && d[0] > 0) {
    const B = d[0] / 2;
    L.paddingLeft = B, L.paddingRight = B;
  }
  return C && (L.flex = parseFlex(C), p === !1 && !L.minWidth && (L.minWidth = 0)), T(/* @__PURE__ */ reactExports.createElement("div", Object.assign({}, S, {
    style: Object.assign(Object.assign(Object.assign({}, L), w), E),
    className: O,
    ref: s
  }), m));
});
function useGutter(a, s) {
  const c = [void 0, void 0], u = Array.isArray(a) ? a : [a, void 0], d = s || {
    xs: !0,
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0,
    xxl: !0
  };
  return u.forEach((p, v) => {
    if (typeof p == "object" && p !== null)
      for (let A = 0; A < responsiveArray.length; A++) {
        const x = responsiveArray[A];
        if (d[x] && p[x] !== void 0) {
          c[v] = p[x];
          break;
        }
      }
    else
      c[v] = p;
  }), c;
}
var __rest$G = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function useMergedPropByScreen(a, s) {
  const [c, u] = reactExports.useState(typeof a == "string" ? a : ""), d = () => {
    if (typeof a == "string" && u(a), typeof a == "object")
      for (let p = 0; p < responsiveArray.length; p++) {
        const v = responsiveArray[p];
        if (!s || !s[v])
          continue;
        const A = a[v];
        if (A !== void 0) {
          u(A);
          return;
        }
      }
  };
  return reactExports.useEffect(() => {
    d();
  }, [JSON.stringify(a), s]), c;
}
const Row = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    justify: u,
    align: d,
    className: p,
    style: v,
    children: A,
    gutter: x = 0,
    wrap: g
  } = a, b = __rest$G(a, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]), {
    getPrefixCls: y,
    direction: f
  } = reactExports.useContext(ConfigContext$1), m = useBreakpoint(!0, null), C = useMergedPropByScreen(d, m), w = useMergedPropByScreen(u, m), S = y("row", c), [$, T, I] = useRowStyle(S), _ = useGutter(x, m), E = classnames(S, {
    [`${S}-no-wrap`]: g === !1,
    [`${S}-${w}`]: w,
    [`${S}-${C}`]: C,
    [`${S}-rtl`]: f === "rtl"
  }, p, T, I), R = {}, O = _[0] != null && _[0] > 0 ? _[0] / -2 : void 0;
  O && (R.marginLeft = O, R.marginRight = O);
  const [L, B] = _;
  R.rowGap = B;
  const F = reactExports.useMemo(() => ({
    gutter: [L, B],
    wrap: g
  }), [L, B, g]);
  return $(/* @__PURE__ */ reactExports.createElement(RowContext.Provider, {
    value: F
  }, /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, b, {
    className: E,
    style: Object.assign(Object.assign({}, R), v),
    ref: s
  }), A)));
}), genSizeDividerStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      "&-horizontal": {
        [`&${s}`]: {
          "&-sm": {
            marginBlock: a.marginXS
          },
          "&-md": {
            marginBlock: a.margin
          }
        }
      }
    }
  };
}, genSharedDividerStyle = (a) => {
  const {
    componentCls: s,
    sizePaddingEdgeHorizontal: c,
    colorSplit: u,
    lineWidth: d,
    textPaddingInline: p,
    orientationMargin: v,
    verticalMarginInline: A
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      borderBlockStart: `${unit$1(d)} solid ${u}`,
      // vertical
      "&-vertical": {
        position: "relative",
        top: "-0.06em",
        display: "inline-block",
        height: "0.9em",
        marginInline: A,
        marginBlock: 0,
        verticalAlign: "middle",
        borderTop: 0,
        borderInlineStart: `${unit$1(d)} solid ${u}`
      },
      "&-horizontal": {
        display: "flex",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        // Fix https://github.com/ant-design/ant-design/issues/10914
        margin: `${unit$1(a.marginLG)} 0`
      },
      [`&-horizontal${s}-with-text`]: {
        display: "flex",
        alignItems: "center",
        margin: `${unit$1(a.dividerHorizontalWithTextGutterMargin)} 0`,
        color: a.colorTextHeading,
        fontWeight: 500,
        fontSize: a.fontSizeLG,
        whiteSpace: "nowrap",
        textAlign: "center",
        borderBlockStart: `0 ${u}`,
        "&::before, &::after": {
          position: "relative",
          width: "50%",
          borderBlockStart: `${unit$1(d)} solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: "inherit",
          borderBlockEnd: 0,
          transform: "translateY(50%)",
          content: "''"
        }
      },
      [`&-horizontal${s}-with-text-start`]: {
        "&::before": {
          width: `calc(${v} * 100%)`
        },
        "&::after": {
          width: `calc(100% - ${v} * 100%)`
        }
      },
      [`&-horizontal${s}-with-text-end`]: {
        "&::before": {
          width: `calc(100% - ${v} * 100%)`
        },
        "&::after": {
          width: `calc(${v} * 100%)`
        }
      },
      [`${s}-inner-text`]: {
        display: "inline-block",
        paddingBlock: 0,
        paddingInline: p
      },
      "&-dashed": {
        background: "none",
        borderColor: u,
        borderStyle: "dashed",
        borderWidth: `${unit$1(d)} 0 0`
      },
      [`&-horizontal${s}-with-text${s}-dashed`]: {
        "&::before, &::after": {
          borderStyle: "dashed none none"
        }
      },
      [`&-vertical${s}-dashed`]: {
        borderInlineStartWidth: d,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      "&-dotted": {
        background: "none",
        borderColor: u,
        borderStyle: "dotted",
        borderWidth: `${unit$1(d)} 0 0`
      },
      [`&-horizontal${s}-with-text${s}-dotted`]: {
        "&::before, &::after": {
          borderStyle: "dotted none none"
        }
      },
      [`&-vertical${s}-dotted`]: {
        borderInlineStartWidth: d,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${s}-with-text`]: {
        color: a.colorText,
        fontWeight: "normal",
        fontSize: a.fontSize
      },
      [`&-horizontal${s}-with-text-start${s}-no-default-orientation-margin-start`]: {
        "&::before": {
          width: 0
        },
        "&::after": {
          width: "100%"
        },
        [`${s}-inner-text`]: {
          paddingInlineStart: c
        }
      },
      [`&-horizontal${s}-with-text-end${s}-no-default-orientation-margin-end`]: {
        "&::before": {
          width: "100%"
        },
        "&::after": {
          width: 0
        },
        [`${s}-inner-text`]: {
          paddingInlineEnd: c
        }
      }
    })
  };
}, prepareComponentToken$g = (a) => ({
  textPaddingInline: "1em",
  orientationMargin: 0.05,
  verticalMarginInline: a.marginXS
}), useStyle$i = genStyleHooks("Divider", (a) => {
  const s = merge(a, {
    dividerHorizontalWithTextGutterMargin: a.margin,
    sizePaddingEdgeHorizontal: 0
  });
  return [genSharedDividerStyle(s), genSizeDividerStyle(s)];
}, prepareComponentToken$g, {
  unitless: {
    orientationMargin: !0
  }
});
var __rest$F = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const sizeClassNameMap = {
  small: "sm",
  middle: "md"
}, Divider = (a) => {
  const {
    getPrefixCls: s,
    direction: c,
    className: u,
    style: d
  } = useComponentConfig("divider"), {
    prefixCls: p,
    type: v = "horizontal",
    orientation: A = "center",
    orientationMargin: x,
    className: g,
    rootClassName: b,
    children: y,
    dashed: f,
    variant: m = "solid",
    plain: C,
    style: w,
    size: S
  } = a, $ = __rest$F(a, ["prefixCls", "type", "orientation", "orientationMargin", "className", "rootClassName", "children", "dashed", "variant", "plain", "style", "size"]), T = s("divider", p), [I, _, E] = useStyle$i(T), R = useSize(S), O = sizeClassNameMap[R], L = !!y, B = reactExports.useMemo(() => A === "left" ? c === "rtl" ? "end" : "start" : A === "right" ? c === "rtl" ? "start" : "end" : A, [c, A]), F = B === "start" && x != null, M = B === "end" && x != null, W = classnames(T, u, _, E, `${T}-${v}`, {
    [`${T}-with-text`]: L,
    [`${T}-with-text-${B}`]: L,
    [`${T}-dashed`]: !!f,
    [`${T}-${m}`]: m !== "solid",
    [`${T}-plain`]: !!C,
    [`${T}-rtl`]: c === "rtl",
    [`${T}-no-default-orientation-margin-start`]: F,
    [`${T}-no-default-orientation-margin-end`]: M,
    [`${T}-${O}`]: !!O
  }, g, b), j = reactExports.useMemo(() => typeof x == "number" ? x : /^\d+$/.test(x) ? Number(x) : x, [x]), G = {
    marginInlineStart: F ? j : void 0,
    marginInlineEnd: M ? j : void 0
  };
  return I(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    className: W,
    style: Object.assign(Object.assign({}, d), w)
  }, $, {
    role: "separator"
  }), y && v !== "vertical" && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${T}-inner-text`,
    style: G
  }, y)));
};
var UpOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, name: "up", theme: "outlined" }, UpOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: UpOutlined$1
  }));
}, RefIcon$x = /* @__PURE__ */ reactExports.forwardRef(UpOutlined);
function supportBigInt() {
  return typeof BigInt == "function";
}
function isEmpty(a) {
  return !a && a !== 0 && !Number.isNaN(a) || !String(a).trim();
}
function trimNumber(a) {
  var s = a.trim(), c = s.startsWith("-");
  c && (s = s.slice(1)), s = s.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, ""), s.startsWith(".") && (s = "0".concat(s));
  var u = s || "0", d = u.split("."), p = d[0] || "0", v = d[1] || "0";
  p === "0" && v === "0" && (c = !1);
  var A = c ? "-" : "";
  return {
    negative: c,
    negativeStr: A,
    trimStr: u,
    integerStr: p,
    decimalStr: v,
    fullStr: "".concat(A).concat(u)
  };
}
function isE(a) {
  var s = String(a);
  return !Number.isNaN(Number(s)) && s.includes("e");
}
function getNumberPrecision(a) {
  var s = String(a);
  if (isE(a)) {
    var c = Number(s.slice(s.indexOf("e-") + 2)), u = s.match(/\.(\d+)/);
    return u != null && u[1] && (c += u[1].length), c;
  }
  return s.includes(".") && validateNumber(s) ? s.length - s.indexOf(".") - 1 : 0;
}
function num2str(a) {
  var s = String(a);
  if (isE(a)) {
    if (a > Number.MAX_SAFE_INTEGER)
      return String(supportBigInt() ? BigInt(a).toString() : Number.MAX_SAFE_INTEGER);
    if (a < Number.MIN_SAFE_INTEGER)
      return String(supportBigInt() ? BigInt(a).toString() : Number.MIN_SAFE_INTEGER);
    s = a.toFixed(getNumberPrecision(s));
  }
  return trimNumber(s).fullStr;
}
function validateNumber(a) {
  return typeof a == "number" ? !Number.isNaN(a) : a ? (
    // Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(a) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(a) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(a)
  ) : !1;
}
var BigIntDecimal = /* @__PURE__ */ function() {
  function a(s) {
    if (_classCallCheck$1(this, a), _defineProperty$a(this, "origin", ""), _defineProperty$a(this, "negative", void 0), _defineProperty$a(this, "integer", void 0), _defineProperty$a(this, "decimal", void 0), _defineProperty$a(this, "decimalLen", void 0), _defineProperty$a(this, "empty", void 0), _defineProperty$a(this, "nan", void 0), isEmpty(s)) {
      this.empty = !0;
      return;
    }
    if (this.origin = String(s), s === "-" || Number.isNaN(s)) {
      this.nan = !0;
      return;
    }
    var c = s;
    if (isE(c) && (c = Number(c)), c = typeof c == "string" ? c : num2str(c), validateNumber(c)) {
      var u = trimNumber(c);
      this.negative = u.negative;
      var d = u.trimStr.split(".");
      this.integer = BigInt(d[0]);
      var p = d[1] || "0";
      this.decimal = BigInt(p), this.decimalLen = p.length;
    } else
      this.nan = !0;
  }
  return _createClass$1(a, [{
    key: "getMark",
    value: function() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function() {
      return this.integer.toString();
    }
    /**
     * @private get decimal string
     */
  }, {
    key: "getDecimalStr",
    value: function() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
    /**
     * @private Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */
  }, {
    key: "alignDecimal",
    value: function(c) {
      var u = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(c, "0"));
      return BigInt(u);
    }
  }, {
    key: "negate",
    value: function() {
      var c = new a(this.toString());
      return c.negative = !c.negative, c;
    }
  }, {
    key: "cal",
    value: function(c, u, d) {
      var p = Math.max(this.getDecimalStr().length, c.getDecimalStr().length), v = this.alignDecimal(p), A = c.alignDecimal(p), x = u(v, A).toString(), g = d(p), b = trimNumber(x), y = b.negativeStr, f = b.trimStr, m = "".concat(y).concat(f.padStart(g + 1, "0"));
      return new a("".concat(m.slice(0, -g), ".").concat(m.slice(-g)));
    }
  }, {
    key: "add",
    value: function(c) {
      if (this.isInvalidate())
        return new a(c);
      var u = new a(c);
      return u.isInvalidate() ? this : this.cal(u, function(d, p) {
        return d + p;
      }, function(d) {
        return d;
      });
    }
  }, {
    key: "multi",
    value: function(c) {
      var u = new a(c);
      return this.isInvalidate() || u.isInvalidate() ? new a(NaN) : this.cal(u, function(d, p) {
        return d * p;
      }, function(d) {
        return d * 2;
      });
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(c) {
      return this.toString() === c?.toString();
    }
  }, {
    key: "lessEquals",
    value: function(c) {
      return this.add(c.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.isNaN() ? NaN : Number(this.toString());
    }
  }, {
    key: "toString",
    value: function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return c ? this.isInvalidate() ? "" : trimNumber("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr : this.origin;
    }
  }]), a;
}(), NumberDecimal = /* @__PURE__ */ function() {
  function a(s) {
    if (_classCallCheck$1(this, a), _defineProperty$a(this, "origin", ""), _defineProperty$a(this, "number", void 0), _defineProperty$a(this, "empty", void 0), isEmpty(s)) {
      this.empty = !0;
      return;
    }
    this.origin = String(s), this.number = Number(s);
  }
  return _createClass$1(a, [{
    key: "negate",
    value: function() {
      return new a(-this.toNumber());
    }
  }, {
    key: "add",
    value: function(c) {
      if (this.isInvalidate())
        return new a(c);
      var u = Number(c);
      if (Number.isNaN(u))
        return this;
      var d = this.number + u;
      if (d > Number.MAX_SAFE_INTEGER)
        return new a(Number.MAX_SAFE_INTEGER);
      if (d < Number.MIN_SAFE_INTEGER)
        return new a(Number.MIN_SAFE_INTEGER);
      var p = Math.max(getNumberPrecision(this.number), getNumberPrecision(u));
      return new a(d.toFixed(p));
    }
  }, {
    key: "multi",
    value: function(c) {
      var u = Number(c);
      if (this.isInvalidate() || Number.isNaN(u))
        return new a(NaN);
      var d = this.number * u;
      if (d > Number.MAX_SAFE_INTEGER)
        return new a(Number.MAX_SAFE_INTEGER);
      if (d < Number.MIN_SAFE_INTEGER)
        return new a(Number.MIN_SAFE_INTEGER);
      var p = Math.max(getNumberPrecision(this.number), getNumberPrecision(u));
      return new a(d.toFixed(p));
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(c) {
      return this.toNumber() === c?.toNumber();
    }
  }, {
    key: "lessEquals",
    value: function(c) {
      return this.add(c.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return c ? this.isInvalidate() ? "" : num2str(this.number) : this.origin;
    }
  }]), a;
}();
function getMiniDecimal(a) {
  return supportBigInt() ? new BigIntDecimal(a) : new NumberDecimal(a);
}
function toFixed(a, s, c) {
  var u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (a === "")
    return "";
  var d = trimNumber(a), p = d.negativeStr, v = d.integerStr, A = d.decimalStr, x = "".concat(s).concat(A), g = "".concat(p).concat(v);
  if (c >= 0) {
    var b = Number(A[c]);
    if (b >= 5 && !u) {
      var y = getMiniDecimal(a).add("".concat(p, "0.").concat("0".repeat(c)).concat(10 - b));
      return toFixed(y.toString(), s, c, u);
    }
    return c === 0 ? g : "".concat(g).concat(s).concat(A.padEnd(c, "0").slice(0, c));
  }
  return x === ".0" ? g : "".concat(g).concat(x);
}
function hasAddon(a) {
  return !!(a.addonBefore || a.addonAfter);
}
function hasPrefixSuffix$1(a) {
  return !!(a.prefix || a.suffix || a.allowClear);
}
function cloneEvent(a, s, c) {
  var u = s.cloneNode(!0), d = Object.create(a, {
    target: {
      value: u
    },
    currentTarget: {
      value: u
    }
  });
  return u.value = c, typeof s.selectionStart == "number" && typeof s.selectionEnd == "number" && (u.selectionStart = s.selectionStart, u.selectionEnd = s.selectionEnd), u.setSelectionRange = function() {
    s.setSelectionRange.apply(s, arguments);
  }, d;
}
function resolveOnChange(a, s, c, u) {
  if (c) {
    var d = s;
    if (s.type === "click") {
      d = cloneEvent(s, a, ""), c(d);
      return;
    }
    if (a.type !== "file" && u !== void 0) {
      d = cloneEvent(s, a, u), c(d);
      return;
    }
    c(d);
  }
}
function triggerFocus(a, s) {
  if (a) {
    a.focus(s);
    var c = s || {}, u = c.cursor;
    if (u) {
      var d = a.value.length;
      switch (u) {
        case "start":
          a.setSelectionRange(0, 0);
          break;
        case "end":
          a.setSelectionRange(d, d);
          break;
        default:
          a.setSelectionRange(0, d);
      }
    }
  }
}
var BaseInput = /* @__PURE__ */ React.forwardRef(function(a, s) {
  var c, u, d, p = a.inputElement, v = a.children, A = a.prefixCls, x = a.prefix, g = a.suffix, b = a.addonBefore, y = a.addonAfter, f = a.className, m = a.style, C = a.disabled, w = a.readOnly, S = a.focused, $ = a.triggerFocus, T = a.allowClear, I = a.value, _ = a.handleReset, E = a.hidden, R = a.classes, O = a.classNames, L = a.dataAttrs, B = a.styles, F = a.components, M = a.onClear, W = v ?? p, j = F?.affixWrapper || "span", G = F?.groupWrapper || "span", U = F?.wrapper || "span", k = F?.groupAddon || "span", N = reactExports.useRef(null), P = function(ge) {
    var me;
    (me = N.current) !== null && me !== void 0 && me.contains(ge.target) && $?.();
  }, D = hasPrefixSuffix$1(a), H = /* @__PURE__ */ reactExports.cloneElement(W, {
    value: I,
    className: classnames((c = W.props) === null || c === void 0 ? void 0 : c.className, !D && O?.variant) || null
  }), V = reactExports.useRef(null);
  if (React.useImperativeHandle(s, function() {
    return {
      nativeElement: V.current || N.current
    };
  }), D) {
    var Z = null;
    if (T) {
      var ne = !C && !w && I, K = "".concat(A, "-clear-icon"), q = _typeof$h(T) === "object" && T !== null && T !== void 0 && T.clearIcon ? T.clearIcon : "✖";
      Z = /* @__PURE__ */ React.createElement("button", {
        type: "button",
        tabIndex: -1,
        onClick: function(ge) {
          _?.(ge), M?.();
        },
        onMouseDown: function(ge) {
          return ge.preventDefault();
        },
        className: classnames(K, _defineProperty$a(_defineProperty$a({}, "".concat(K, "-hidden"), !ne), "".concat(K, "-has-suffix"), !!g))
      }, q);
    }
    var Y = "".concat(A, "-affix-wrapper"), ee = classnames(Y, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(A, "-disabled"), C), "".concat(Y, "-disabled"), C), "".concat(Y, "-focused"), S), "".concat(Y, "-readonly"), w), "".concat(Y, "-input-with-clear-btn"), g && T && I), R?.affixWrapper, O?.affixWrapper, O?.variant), Q = (g || T) && /* @__PURE__ */ React.createElement("span", {
      className: classnames("".concat(A, "-suffix"), O?.suffix),
      style: B?.suffix
    }, Z, g);
    H = /* @__PURE__ */ React.createElement(j, _extends$3({
      className: ee,
      style: B?.affixWrapper,
      onClick: P
    }, L?.affixWrapper, {
      ref: N
    }), x && /* @__PURE__ */ React.createElement("span", {
      className: classnames("".concat(A, "-prefix"), O?.prefix),
      style: B?.prefix
    }, x), H, Q);
  }
  if (hasAddon(a)) {
    var J = "".concat(A, "-group"), te = "".concat(J, "-addon"), ae = "".concat(J, "-wrapper"), se = classnames("".concat(A, "-wrapper"), J, R?.wrapper, O?.wrapper), ie = classnames(ae, _defineProperty$a({}, "".concat(ae, "-disabled"), C), R?.group, O?.groupWrapper);
    H = /* @__PURE__ */ React.createElement(G, {
      className: ie,
      ref: V
    }, /* @__PURE__ */ React.createElement(U, {
      className: se
    }, b && /* @__PURE__ */ React.createElement(k, {
      className: te
    }, b), H, y && /* @__PURE__ */ React.createElement(k, {
      className: te
    }, y)));
  }
  return /* @__PURE__ */ React.cloneElement(H, {
    className: classnames((u = H.props) === null || u === void 0 ? void 0 : u.className, f) || null,
    style: _objectSpread2$1(_objectSpread2$1({}, (d = H.props) === null || d === void 0 ? void 0 : d.style), m),
    hidden: E
  });
}), _excluded$q = ["show"];
function useCount(a, s) {
  return reactExports.useMemo(function() {
    var c = {};
    s && (c.show = _typeof$h(s) === "object" && s.formatter ? s.formatter : !!s), c = _objectSpread2$1(_objectSpread2$1({}, c), a);
    var u = c, d = u.show, p = _objectWithoutProperties$2(u, _excluded$q);
    return _objectSpread2$1(_objectSpread2$1({}, p), {}, {
      show: !!d,
      showFormatter: typeof d == "function" ? d : void 0,
      strategy: p.strategy || function(v) {
        return v.length;
      }
    });
  }, [a, s]);
}
var _excluded$p = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "onKeyUp", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], Input$3 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.autoComplete, u = a.onChange, d = a.onFocus, p = a.onBlur, v = a.onPressEnter, A = a.onKeyDown, x = a.onKeyUp, g = a.prefixCls, b = g === void 0 ? "rc-input" : g, y = a.disabled, f = a.htmlSize, m = a.className, C = a.maxLength, w = a.suffix, S = a.showCount, $ = a.count, T = a.type, I = T === void 0 ? "text" : T, _ = a.classes, E = a.classNames, R = a.styles, O = a.onCompositionStart, L = a.onCompositionEnd, B = _objectWithoutProperties$2(a, _excluded$p), F = reactExports.useState(!1), M = _slicedToArray$e(F, 2), W = M[0], j = M[1], G = reactExports.useRef(!1), U = reactExports.useRef(!1), k = reactExports.useRef(null), N = reactExports.useRef(null), P = function(xe) {
    k.current && triggerFocus(k.current, xe);
  }, D = useMergedState(a.defaultValue, {
    value: a.value
  }), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = V == null ? "" : String(V), K = reactExports.useState(null), q = _slicedToArray$e(K, 2), Y = q[0], ee = q[1], Q = useCount($, S), J = Q.max || C, te = Q.strategy(ne), ae = !!J && te > J;
  reactExports.useImperativeHandle(s, function() {
    var Ce;
    return {
      focus: P,
      blur: function() {
        var we;
        (we = k.current) === null || we === void 0 || we.blur();
      },
      setSelectionRange: function(we, $e, Ae) {
        var ue;
        (ue = k.current) === null || ue === void 0 || ue.setSelectionRange(we, $e, Ae);
      },
      select: function() {
        var we;
        (we = k.current) === null || we === void 0 || we.select();
      },
      input: k.current,
      nativeElement: ((Ce = N.current) === null || Ce === void 0 ? void 0 : Ce.nativeElement) || k.current
    };
  }), reactExports.useEffect(function() {
    U.current && (U.current = !1), j(function(Ce) {
      return Ce && y ? !1 : Ce;
    });
  }, [y]);
  var se = function(xe, we, $e) {
    var Ae = we;
    if (!G.current && Q.exceedFormatter && Q.max && Q.strategy(we) > Q.max) {
      if (Ae = Q.exceedFormatter(we, {
        max: Q.max
      }), we !== Ae) {
        var ue, ce;
        ee([((ue = k.current) === null || ue === void 0 ? void 0 : ue.selectionStart) || 0, ((ce = k.current) === null || ce === void 0 ? void 0 : ce.selectionEnd) || 0]);
      }
    } else if ($e.source === "compositionEnd")
      return;
    Z(Ae), k.current && resolveOnChange(k.current, xe, u, Ae);
  };
  reactExports.useEffect(function() {
    if (Y) {
      var Ce;
      (Ce = k.current) === null || Ce === void 0 || Ce.setSelectionRange.apply(Ce, _toConsumableArray$e(Y));
    }
  }, [Y]);
  var ie = function(xe) {
    se(xe, xe.target.value, {
      source: "change"
    });
  }, fe = function(xe) {
    G.current = !1, se(xe, xe.currentTarget.value, {
      source: "compositionEnd"
    }), L?.(xe);
  }, ge = function(xe) {
    v && xe.key === "Enter" && !U.current && (U.current = !0, v(xe)), A?.(xe);
  }, me = function(xe) {
    xe.key === "Enter" && (U.current = !1), x?.(xe);
  }, pe = function(xe) {
    j(!0), d?.(xe);
  }, be = function(xe) {
    U.current && (U.current = !1), j(!1), p?.(xe);
  }, le = function(xe) {
    Z(""), P(), k.current && resolveOnChange(k.current, xe, u);
  }, ve = ae && "".concat(b, "-out-of-range"), he = function() {
    var xe = omit(a, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames",
      "onClear"
    ]);
    return /* @__PURE__ */ React.createElement("input", _extends$3({
      autoComplete: c
    }, xe, {
      onChange: ie,
      onFocus: pe,
      onBlur: be,
      onKeyDown: ge,
      onKeyUp: me,
      className: classnames(b, _defineProperty$a({}, "".concat(b, "-disabled"), y), E?.input),
      style: R?.input,
      ref: k,
      size: f,
      type: I,
      onCompositionStart: function($e) {
        G.current = !0, O?.($e);
      },
      onCompositionEnd: fe
    }));
  }, ye = function() {
    var xe = Number(J) > 0;
    if (w || Q.show) {
      var we = Q.showFormatter ? Q.showFormatter({
        value: ne,
        count: te,
        maxLength: J
      }) : "".concat(te).concat(xe ? " / ".concat(J) : "");
      return /* @__PURE__ */ React.createElement(React.Fragment, null, Q.show && /* @__PURE__ */ React.createElement("span", {
        className: classnames("".concat(b, "-show-count-suffix"), _defineProperty$a({}, "".concat(b, "-show-count-has-suffix"), !!w), E?.count),
        style: _objectSpread2$1({}, R?.count)
      }, we), w);
    }
    return null;
  };
  return /* @__PURE__ */ React.createElement(BaseInput, _extends$3({}, B, {
    prefixCls: b,
    className: classnames(m, ve),
    handleReset: le,
    value: ne,
    focused: W,
    triggerFocus: P,
    suffix: ye(),
    disabled: y,
    classes: _,
    classNames: E,
    styles: R,
    ref: N
  }), he());
});
function proxyObject(a, s) {
  return typeof Proxy < "u" && a ? new Proxy(a, {
    get: function(u, d) {
      if (s[d])
        return s[d];
      var p = u[d];
      return typeof p == "function" ? p.bind(u) : p;
    }
  }) : a;
}
function useCursor(a, s) {
  var c = reactExports.useRef(null);
  function u() {
    try {
      var p = a.selectionStart, v = a.selectionEnd, A = a.value, x = A.substring(0, p), g = A.substring(v);
      c.current = {
        start: p,
        end: v,
        value: A,
        beforeTxt: x,
        afterTxt: g
      };
    } catch {
    }
  }
  function d() {
    if (a && c.current && s)
      try {
        var p = a.value, v = c.current, A = v.beforeTxt, x = v.afterTxt, g = v.start, b = p.length;
        if (p.startsWith(A))
          b = A.length;
        else if (p.endsWith(x))
          b = p.length - c.current.afterTxt.length;
        else {
          var y = A[g - 1], f = p.indexOf(y, g - 1);
          f !== -1 && (b = f + 1);
        }
        a.setSelectionRange(b, b);
      } catch (m) {
        warningOnce(!1, "Something warning of cursor restore. Please fire issue about this: ".concat(m.message));
      }
  }
  return [u, d];
}
var useMobile = function a() {
  var s = reactExports.useState(!1), c = _slicedToArray$e(s, 2), u = c[0], d = c[1];
  return useLayoutEffect$1(function() {
    d(isMobile$1());
  }, []), u;
}, STEP_INTERVAL = 200, STEP_DELAY = 600;
function StepHandler(a) {
  var s = a.prefixCls, c = a.upNode, u = a.downNode, d = a.upDisabled, p = a.downDisabled, v = a.onStep, A = reactExports.useRef(), x = reactExports.useRef([]), g = reactExports.useRef();
  g.current = v;
  var b = function() {
    clearTimeout(A.current);
  }, y = function(I, _) {
    I.preventDefault(), b(), g.current(_);
    function E() {
      g.current(_), A.current = setTimeout(E, STEP_INTERVAL);
    }
    A.current = setTimeout(E, STEP_DELAY);
  };
  reactExports.useEffect(function() {
    return function() {
      b(), x.current.forEach(function(T) {
        return wrapperRaf.cancel(T);
      });
    };
  }, []);
  var f = useMobile();
  if (f)
    return null;
  var m = "".concat(s, "-handler"), C = classnames(m, "".concat(m, "-up"), _defineProperty$a({}, "".concat(m, "-up-disabled"), d)), w = classnames(m, "".concat(m, "-down"), _defineProperty$a({}, "".concat(m, "-down-disabled"), p)), S = function() {
    return x.current.push(wrapperRaf(b));
  }, $ = {
    unselectable: "on",
    role: "button",
    onMouseUp: S,
    onMouseLeave: S
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(m, "-wrap")
  }, /* @__PURE__ */ reactExports.createElement("span", _extends$3({}, $, {
    onMouseDown: function(I) {
      y(I, !0);
    },
    "aria-label": "Increase Value",
    "aria-disabled": d,
    className: C
  }), c || /* @__PURE__ */ reactExports.createElement("span", {
    unselectable: "on",
    className: "".concat(s, "-handler-up-inner")
  })), /* @__PURE__ */ reactExports.createElement("span", _extends$3({}, $, {
    onMouseDown: function(I) {
      y(I, !1);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": p,
    className: w
  }), u || /* @__PURE__ */ reactExports.createElement("span", {
    unselectable: "on",
    className: "".concat(s, "-handler-down-inner")
  })));
}
function getDecupleSteps(a) {
  var s = typeof a == "number" ? num2str(a) : trimNumber(a).fullStr, c = s.includes(".");
  return c ? trimNumber(s.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr : a + "0";
}
const useFrame = function() {
  var a = reactExports.useRef(0), s = function() {
    wrapperRaf.cancel(a.current);
  };
  return reactExports.useEffect(function() {
    return s;
  }, []), function(c) {
    s(), a.current = wrapperRaf(function() {
      c();
    });
  };
};
var _excluded$o = ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "changeOnWheel", "controls", "classNames", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep", "changeOnBlur", "domRef"], _excluded2$5 = ["disabled", "style", "prefixCls", "value", "prefix", "suffix", "addonBefore", "addonAfter", "className", "classNames"], getDecimalValue = function a(s, c) {
  return s || c.isEmpty() ? c.toString() : c.toNumber();
}, getDecimalIfValidate = function a(s) {
  var c = getMiniDecimal(s);
  return c.isInvalidate() ? null : c;
}, InternalInputNumber = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.className, d = a.style, p = a.min, v = a.max, A = a.step, x = A === void 0 ? 1 : A, g = a.defaultValue, b = a.value, y = a.disabled, f = a.readOnly, m = a.upHandler, C = a.downHandler, w = a.keyboard, S = a.changeOnWheel, $ = S === void 0 ? !1 : S, T = a.controls, I = T === void 0 ? !0 : T;
  a.classNames;
  var _ = a.stringMode, E = a.parser, R = a.formatter, O = a.precision, L = a.decimalSeparator, B = a.onChange, F = a.onInput, M = a.onPressEnter, W = a.onStep, j = a.changeOnBlur, G = j === void 0 ? !0 : j, U = a.domRef, k = _objectWithoutProperties$2(a, _excluded$o), N = "".concat(c, "-input"), P = reactExports.useRef(null), D = reactExports.useState(!1), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = reactExports.useRef(!1), K = reactExports.useRef(!1), q = reactExports.useRef(!1), Y = reactExports.useState(function() {
    return getMiniDecimal(b ?? g);
  }), ee = _slicedToArray$e(Y, 2), Q = ee[0], J = ee[1];
  function te(De) {
    b === void 0 && J(De);
  }
  var ae = reactExports.useCallback(function(De, Ne) {
    if (!Ne)
      return O >= 0 ? O : Math.max(getNumberPrecision(De), getNumberPrecision(x));
  }, [O, x]), se = reactExports.useCallback(function(De) {
    var Ne = String(De);
    if (E)
      return E(Ne);
    var Ge = Ne;
    return L && (Ge = Ge.replace(L, ".")), Ge.replace(/[^\w.-]+/g, "");
  }, [E, L]), ie = reactExports.useRef(""), fe = reactExports.useCallback(function(De, Ne) {
    if (R)
      return R(De, {
        userTyping: Ne,
        input: String(ie.current)
      });
    var Ge = typeof De == "number" ? num2str(De) : De;
    if (!Ne) {
      var Xe = ae(Ge, Ne);
      if (validateNumber(Ge) && (L || Xe >= 0)) {
        var nt = L || ".";
        Ge = toFixed(Ge, nt, Xe);
      }
    }
    return Ge;
  }, [R, ae, L]), ge = reactExports.useState(function() {
    var De = g ?? b;
    return Q.isInvalidate() && ["string", "number"].includes(_typeof$h(De)) ? Number.isNaN(De) ? "" : De : fe(Q.toString(), !1);
  }), me = _slicedToArray$e(ge, 2), pe = me[0], be = me[1];
  ie.current = pe;
  function le(De, Ne) {
    be(fe(
      // Invalidate number is sometime passed by external control, we should let it go
      // Otherwise is controlled by internal interactive logic which check by userTyping
      // You can ref 'show limited value when input is not focused' test for more info.
      De.isInvalidate() ? De.toString(!1) : De.toString(!Ne),
      Ne
    ));
  }
  var ve = reactExports.useMemo(function() {
    return getDecimalIfValidate(v);
  }, [v, O]), he = reactExports.useMemo(function() {
    return getDecimalIfValidate(p);
  }, [p, O]), ye = reactExports.useMemo(function() {
    return !ve || !Q || Q.isInvalidate() ? !1 : ve.lessEquals(Q);
  }, [ve, Q]), Ce = reactExports.useMemo(function() {
    return !he || !Q || Q.isInvalidate() ? !1 : Q.lessEquals(he);
  }, [he, Q]), xe = useCursor(P.current, V), we = _slicedToArray$e(xe, 2), $e = we[0], Ae = we[1], ue = function(Ne) {
    return ve && !Ne.lessEquals(ve) ? ve : he && !he.lessEquals(Ne) ? he : null;
  }, ce = function(Ne) {
    return !ue(Ne);
  }, Ee = function(Ne, Ge) {
    var Xe = Ne, nt = ce(Xe) || Xe.isEmpty();
    if (!Xe.isEmpty() && !Ge && (Xe = ue(Xe) || Xe, nt = !0), !f && !y && nt) {
      var ct = Xe.toString(), it = ae(ct, Ge);
      return it >= 0 && (Xe = getMiniDecimal(toFixed(ct, ".", it)), ce(Xe) || (Xe = getMiniDecimal(toFixed(ct, ".", it, !0)))), Xe.equals(Q) || (te(Xe), B?.(Xe.isEmpty() ? null : getDecimalValue(_, Xe)), b === void 0 && le(Xe, Ge)), Xe;
    }
    return Q;
  }, _e = useFrame(), Te = function De(Ne) {
    if ($e(), ie.current = Ne, be(Ne), !K.current) {
      var Ge = se(Ne), Xe = getMiniDecimal(Ge);
      Xe.isNaN() || Ee(Xe, !0);
    }
    F?.(Ne), _e(function() {
      var nt = Ne;
      E || (nt = Ne.replace(/。/g, ".")), nt !== Ne && De(nt);
    });
  }, ke = function() {
    K.current = !0;
  }, Re = function() {
    K.current = !1, Te(P.current.value);
  }, Be = function(Ne) {
    Te(Ne.target.value);
  }, Oe = function(Ne) {
    var Ge;
    if (!(Ne && ye || !Ne && Ce)) {
      ne.current = !1;
      var Xe = getMiniDecimal(q.current ? getDecupleSteps(x) : x);
      Ne || (Xe = Xe.negate());
      var nt = (Q || getMiniDecimal(0)).add(Xe.toString()), ct = Ee(nt, !1);
      W?.(getDecimalValue(_, ct), {
        offset: q.current ? getDecupleSteps(x) : x,
        type: Ne ? "up" : "down"
      }), (Ge = P.current) === null || Ge === void 0 || Ge.focus();
    }
  }, Me = function(Ne) {
    var Ge = getMiniDecimal(se(pe)), Xe;
    Ge.isNaN() ? Xe = Ee(Q, Ne) : Xe = Ee(Ge, Ne), b !== void 0 ? le(Q, !1) : Xe.isNaN() || le(Xe, !1);
  }, Fe = function() {
    ne.current = !0;
  }, Ue = function(Ne) {
    var Ge = Ne.key, Xe = Ne.shiftKey;
    ne.current = !0, q.current = Xe, Ge === "Enter" && (K.current || (ne.current = !1), Me(!1), M?.(Ne)), w !== !1 && !K.current && ["Up", "ArrowUp", "Down", "ArrowDown"].includes(Ge) && (Oe(Ge === "Up" || Ge === "ArrowUp"), Ne.preventDefault());
  }, je = function() {
    ne.current = !1, q.current = !1;
  };
  reactExports.useEffect(function() {
    if ($ && V) {
      var De = function(Xe) {
        Oe(Xe.deltaY < 0), Xe.preventDefault();
      }, Ne = P.current;
      if (Ne)
        return Ne.addEventListener("wheel", De, {
          passive: !1
        }), function() {
          return Ne.removeEventListener("wheel", De);
        };
    }
  });
  var Le = function() {
    G && Me(!1), Z(!1), ne.current = !1;
  };
  return useLayoutUpdateEffect(function() {
    Q.isInvalidate() || le(Q, !1);
  }, [O, R]), useLayoutUpdateEffect(function() {
    var De = getMiniDecimal(b);
    J(De);
    var Ne = getMiniDecimal(se(pe));
    (!De.equals(Ne) || !ne.current || R) && le(De, ne.current);
  }, [b]), useLayoutUpdateEffect(function() {
    R && Ae();
  }, [pe]), /* @__PURE__ */ reactExports.createElement("div", {
    ref: U,
    className: classnames(c, u, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(c, "-focused"), V), "".concat(c, "-disabled"), y), "".concat(c, "-readonly"), f), "".concat(c, "-not-a-number"), Q.isNaN()), "".concat(c, "-out-of-range"), !Q.isInvalidate() && !ce(Q))),
    style: d,
    onFocus: function() {
      Z(!0);
    },
    onBlur: Le,
    onKeyDown: Ue,
    onKeyUp: je,
    onCompositionStart: ke,
    onCompositionEnd: Re,
    onBeforeInput: Fe
  }, I && /* @__PURE__ */ reactExports.createElement(StepHandler, {
    prefixCls: c,
    upNode: m,
    downNode: C,
    upDisabled: ye,
    downDisabled: Ce,
    onStep: Oe
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(N, "-wrap")
  }, /* @__PURE__ */ reactExports.createElement("input", _extends$3({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": p,
    "aria-valuemax": v,
    "aria-valuenow": Q.isInvalidate() ? null : Q.toString(),
    step: x
  }, k, {
    ref: composeRef(P, s),
    className: N,
    value: pe,
    onChange: Be,
    disabled: y,
    readOnly: f
  }))));
}), InputNumber$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.disabled, u = a.style, d = a.prefixCls, p = d === void 0 ? "rc-input-number" : d, v = a.value, A = a.prefix, x = a.suffix, g = a.addonBefore, b = a.addonAfter, y = a.className, f = a.classNames, m = _objectWithoutProperties$2(a, _excluded2$5), C = reactExports.useRef(null), w = reactExports.useRef(null), S = reactExports.useRef(null), $ = function(I) {
    S.current && triggerFocus(S.current, I);
  };
  return reactExports.useImperativeHandle(s, function() {
    return proxyObject(S.current, {
      focus: $,
      nativeElement: C.current.nativeElement || w.current
    });
  }), /* @__PURE__ */ reactExports.createElement(BaseInput, {
    className: y,
    triggerFocus: $,
    prefixCls: p,
    value: v,
    disabled: c,
    style: u,
    prefix: A,
    suffix: x,
    addonAfter: b,
    addonBefore: g,
    classNames: f,
    components: {
      affixWrapper: "div",
      groupWrapper: "div",
      wrapper: "div",
      groupAddon: "div"
    },
    ref: C
  }, /* @__PURE__ */ reactExports.createElement(InternalInputNumber, _extends$3({
    prefixCls: p,
    disabled: c,
    ref: S,
    domRef: w,
    className: f?.input
  }, m)));
});
const prepareComponentToken$f = (a) => {
  var s;
  const c = (s = a.handleVisible) !== null && s !== void 0 ? s : "auto", u = a.controlHeightSM - a.lineWidth * 2;
  return Object.assign(Object.assign({}, initComponentToken$1(a)), {
    controlWidth: 90,
    handleWidth: u,
    handleFontSize: a.fontSize / 2,
    handleVisible: c,
    handleActiveBg: a.colorFillAlter,
    handleBg: a.colorBgContainer,
    filledHandleBg: new FastColor(a.colorFillSecondary).onBackground(a.colorBgContainer).toHexString(),
    handleHoverColor: a.colorPrimary,
    handleBorderColor: a.colorBorder,
    handleOpacity: c === !0 ? 1 : 0,
    handleVisibleWidth: c === !0 ? u : 0
  });
}, genRadiusStyle$1 = ({
  componentCls: a,
  borderRadiusSM: s,
  borderRadiusLG: c
}, u) => {
  const d = u === "lg" ? c : s;
  return {
    [`&-${u}`]: {
      [`${a}-handler-wrap`]: {
        borderStartEndRadius: d,
        borderEndEndRadius: d
      },
      [`${a}-handler-up`]: {
        borderStartEndRadius: d
      },
      [`${a}-handler-down`]: {
        borderEndEndRadius: d
      }
    }
  };
}, genInputNumberStyles = (a) => {
  const {
    componentCls: s,
    lineWidth: c,
    lineType: u,
    borderRadius: d,
    inputFontSizeSM: p,
    inputFontSizeLG: v,
    controlHeightLG: A,
    controlHeightSM: x,
    colorError: g,
    paddingInlineSM: b,
    paddingBlockSM: y,
    paddingBlockLG: f,
    paddingInlineLG: m,
    colorIcon: C,
    motionDurationMid: w,
    handleHoverColor: S,
    handleOpacity: $,
    paddingInline: T,
    paddingBlock: I,
    handleBg: _,
    handleActiveBg: E,
    colorTextDisabled: R,
    borderRadiusSM: O,
    borderRadiusLG: L,
    controlWidth: B,
    handleBorderColor: F,
    filledHandleBg: M,
    lineHeightLG: W,
    calc: j
  } = a;
  return [
    {
      [s]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genBasicInputStyle(a)), {
        display: "inline-block",
        width: B,
        margin: 0,
        padding: 0,
        borderRadius: d
      }), genOutlinedStyle(a, {
        [`${s}-handler-wrap`]: {
          background: _,
          [`${s}-handler-down`]: {
            borderBlockStart: `${unit$1(c)} ${u} ${F}`
          }
        }
      })), genFilledStyle(a, {
        [`${s}-handler-wrap`]: {
          background: M,
          [`${s}-handler-down`]: {
            borderBlockStart: `${unit$1(c)} ${u} ${F}`
          }
        },
        "&:focus-within": {
          [`${s}-handler-wrap`]: {
            background: _
          }
        }
      })), genUnderlinedStyle(a, {
        [`${s}-handler-wrap`]: {
          background: _,
          [`${s}-handler-down`]: {
            borderBlockStart: `${unit$1(c)} ${u} ${F}`
          }
        }
      })), genBorderlessStyle(a)), {
        "&-rtl": {
          direction: "rtl",
          [`${s}-input`]: {
            direction: "rtl"
          }
        },
        "&-lg": {
          padding: 0,
          fontSize: v,
          lineHeight: W,
          borderRadius: L,
          [`input${s}-input`]: {
            height: j(A).sub(j(c).mul(2)).equal(),
            padding: `${unit$1(f)} ${unit$1(m)}`
          }
        },
        "&-sm": {
          padding: 0,
          fontSize: p,
          borderRadius: O,
          [`input${s}-input`]: {
            height: j(x).sub(j(c).mul(2)).equal(),
            padding: `${unit$1(y)} ${unit$1(b)}`
          }
        },
        // ===================== Out Of Range =====================
        "&-out-of-range": {
          [`${s}-input-wrap`]: {
            input: {
              color: g
            }
          }
        },
        // Style for input-group: input with label, with button or dropdown...
        "&-group": Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genInputGroupStyle(a)), {
          "&-wrapper": Object.assign(Object.assign(Object.assign({
            display: "inline-block",
            textAlign: "start",
            verticalAlign: "top",
            [`${s}-affix-wrapper`]: {
              width: "100%"
            },
            // Size
            "&-lg": {
              [`${s}-group-addon`]: {
                borderRadius: L,
                fontSize: a.fontSizeLG
              }
            },
            "&-sm": {
              [`${s}-group-addon`]: {
                borderRadius: O
              }
            }
          }, genOutlinedGroupStyle(a)), genFilledGroupStyle(a)), {
            // Fix the issue of using icons in Space Compact mode
            // https://github.com/ant-design/ant-design/issues/45764
            [`&:not(${s}-compact-first-item):not(${s}-compact-last-item)${s}-compact-item`]: {
              [`${s}, ${s}-group-addon`]: {
                borderRadius: 0
              }
            },
            [`&:not(${s}-compact-last-item)${s}-compact-first-item`]: {
              [`${s}, ${s}-group-addon`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            [`&:not(${s}-compact-first-item)${s}-compact-last-item`]: {
              [`${s}, ${s}-group-addon`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            }
          })
        }),
        [`&-disabled ${s}-input`]: {
          cursor: "not-allowed"
        },
        [s]: {
          "&-input": Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
            width: "100%",
            padding: `${unit$1(I)} ${unit$1(T)}`,
            textAlign: "start",
            backgroundColor: "transparent",
            border: 0,
            borderRadius: d,
            outline: 0,
            transition: `all ${w} linear`,
            appearance: "textfield",
            fontSize: "inherit"
          }), genPlaceholderStyle(a.colorTextPlaceholder)), {
            '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
              margin: 0,
              appearance: "none"
            }
          })
        },
        [`&:hover ${s}-handler-wrap, &-focused ${s}-handler-wrap`]: {
          width: a.handleWidth,
          opacity: 1
        }
      })
    },
    // Handler
    {
      [s]: Object.assign(Object.assign(Object.assign({
        [`${s}-handler-wrap`]: {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineEnd: 0,
          width: a.handleVisibleWidth,
          opacity: $,
          height: "100%",
          borderStartStartRadius: 0,
          borderStartEndRadius: d,
          borderEndEndRadius: d,
          borderEndStartRadius: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          transition: `all ${w}`,
          overflow: "hidden",
          // Fix input number inside Menu makes icon too large
          // We arise the selector priority by nest selector here
          // https://github.com/ant-design/ant-design/issues/14367
          [`${s}-handler`]: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "auto",
            height: "40%",
            [`
              ${s}-handler-up-inner,
              ${s}-handler-down-inner
            `]: {
              marginInlineEnd: 0,
              fontSize: a.handleFontSize
            }
          }
        },
        [`${s}-handler`]: {
          height: "50%",
          overflow: "hidden",
          color: C,
          fontWeight: "bold",
          lineHeight: 0,
          textAlign: "center",
          cursor: "pointer",
          borderInlineStart: `${unit$1(c)} ${u} ${F}`,
          transition: `all ${w} linear`,
          "&:active": {
            background: E
          },
          // Hover
          "&:hover": {
            height: "60%",
            [`
              ${s}-handler-up-inner,
              ${s}-handler-down-inner
            `]: {
              color: S
            }
          },
          "&-up-inner, &-down-inner": Object.assign(Object.assign({}, resetIcon()), {
            color: C,
            transition: `all ${w} linear`,
            userSelect: "none"
          })
        },
        [`${s}-handler-up`]: {
          borderStartEndRadius: d
        },
        [`${s}-handler-down`]: {
          borderEndEndRadius: d
        }
      }, genRadiusStyle$1(a, "lg")), genRadiusStyle$1(a, "sm")), {
        // Disabled
        "&-disabled, &-readonly": {
          [`${s}-handler-wrap`]: {
            display: "none"
          },
          [`${s}-input`]: {
            color: "inherit"
          }
        },
        [`
          ${s}-handler-up-disabled,
          ${s}-handler-down-disabled
        `]: {
          cursor: "not-allowed"
        },
        [`
          ${s}-handler-up-disabled:hover &-handler-up-inner,
          ${s}-handler-down-disabled:hover &-handler-down-inner
        `]: {
          color: R
        }
      })
    }
  ];
}, genAffixWrapperStyles = (a) => {
  const {
    componentCls: s,
    paddingBlock: c,
    paddingInline: u,
    inputAffixPadding: d,
    controlWidth: p,
    borderRadiusLG: v,
    borderRadiusSM: A,
    paddingInlineLG: x,
    paddingInlineSM: g,
    paddingBlockLG: b,
    paddingBlockSM: y,
    motionDurationMid: f
  } = a;
  return {
    [`${s}-affix-wrapper`]: Object.assign(Object.assign({
      [`input${s}-input`]: {
        padding: `${unit$1(c)} 0`
      }
    }, genBasicInputStyle(a)), {
      // or number handler will cover form status
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      width: p,
      padding: 0,
      paddingInlineStart: u,
      "&-lg": {
        borderRadius: v,
        paddingInlineStart: x,
        [`input${s}-input`]: {
          padding: `${unit$1(b)} 0`
        }
      },
      "&-sm": {
        borderRadius: A,
        paddingInlineStart: g,
        [`input${s}-input`]: {
          padding: `${unit$1(y)} 0`
        }
      },
      [`&:not(${s}-disabled):hover`]: {
        zIndex: 1
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`&-disabled > ${s}-disabled`]: {
        background: "transparent"
      },
      [`> div${s}`]: {
        width: "100%",
        border: "none",
        outline: "none",
        [`&${s}-focused`]: {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${s}-handler-wrap`]: {
        zIndex: 2
      },
      [s]: {
        position: "static",
        color: "inherit",
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          pointerEvents: "none"
        },
        "&-prefix": {
          marginInlineEnd: d
        },
        "&-suffix": {
          insetBlockStart: 0,
          insetInlineEnd: 0,
          height: "100%",
          marginInlineEnd: u,
          marginInlineStart: d,
          transition: `margin ${f}`
        }
      },
      [`&:hover ${s}-handler-wrap, &-focused ${s}-handler-wrap`]: {
        width: a.handleWidth,
        opacity: 1
      },
      [`&:not(${s}-affix-wrapper-without-controls):hover ${s}-suffix`]: {
        marginInlineEnd: a.calc(a.handleWidth).add(u).equal()
      }
    }),
    // 覆盖 affix-wrapper borderRadius！
    [`${s}-underlined`]: {
      borderRadius: 0
    }
  };
}, useStyle$h = genStyleHooks("InputNumber", (a) => {
  const s = merge(a, initInputToken(a));
  return [
    genInputNumberStyles(s),
    genAffixWrapperStyles(s),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(s)
  ];
}, prepareComponentToken$f, {
  unitless: {
    handleOpacity: !0
  }
});
var __rest$E = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InputNumber$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: c,
    direction: u
  } = reactExports.useContext(ConfigContext$1), d = reactExports.useRef(null);
  reactExports.useImperativeHandle(s, () => d.current);
  const {
    className: p,
    rootClassName: v,
    size: A,
    disabled: x,
    prefixCls: g,
    addonBefore: b,
    addonAfter: y,
    prefix: f,
    suffix: m,
    bordered: C,
    readOnly: w,
    status: S,
    controls: $,
    variant: T
  } = a, I = __rest$E(a, ["className", "rootClassName", "size", "disabled", "prefixCls", "addonBefore", "addonAfter", "prefix", "suffix", "bordered", "readOnly", "status", "controls", "variant"]), _ = c("input-number", g), E = useCSSVarCls(_), [R, O, L] = useStyle$h(_, E), {
    compactSize: B,
    compactItemClassnames: F
  } = useCompactItemContext(_, u);
  let M = /* @__PURE__ */ reactExports.createElement(RefIcon$x, {
    className: `${_}-handler-up-inner`
  }), W = /* @__PURE__ */ reactExports.createElement(RefIcon$C, {
    className: `${_}-handler-down-inner`
  });
  const j = typeof $ == "boolean" ? $ : void 0;
  typeof $ == "object" && (M = typeof $.upIcon > "u" ? M : /* @__PURE__ */ reactExports.createElement("span", {
    className: `${_}-handler-up-inner`
  }, $.upIcon), W = typeof $.downIcon > "u" ? W : /* @__PURE__ */ reactExports.createElement("span", {
    className: `${_}-handler-down-inner`
  }, $.downIcon));
  const {
    hasFeedback: G,
    status: U,
    isFormItemInput: k,
    feedbackIcon: N
  } = reactExports.useContext(FormItemInputContext), P = getMergedStatus(U, S), D = useSize((Q) => {
    var J;
    return (J = A ?? B) !== null && J !== void 0 ? J : Q;
  }), H = reactExports.useContext(DisabledContext), V = x ?? H, [Z, ne] = useVariant("inputNumber", T, C), K = G && /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, N), q = classnames({
    [`${_}-lg`]: D === "large",
    [`${_}-sm`]: D === "small",
    [`${_}-rtl`]: u === "rtl",
    [`${_}-in-form-item`]: k
  }, O), Y = `${_}-group`, ee = /* @__PURE__ */ reactExports.createElement(InputNumber$2, Object.assign({
    ref: d,
    disabled: V,
    className: classnames(L, E, p, v, F),
    upHandler: M,
    downHandler: W,
    prefixCls: _,
    readOnly: w,
    controls: j,
    prefix: f,
    suffix: K || m,
    addonBefore: b && /* @__PURE__ */ reactExports.createElement(ContextIsolator, {
      form: !0,
      space: !0
    }, b),
    addonAfter: y && /* @__PURE__ */ reactExports.createElement(ContextIsolator, {
      form: !0,
      space: !0
    }, y),
    classNames: {
      input: q,
      variant: classnames({
        [`${_}-${Z}`]: ne
      }, getStatusClassNames(_, P, G)),
      affixWrapper: classnames({
        [`${_}-affix-wrapper-sm`]: D === "small",
        [`${_}-affix-wrapper-lg`]: D === "large",
        [`${_}-affix-wrapper-rtl`]: u === "rtl",
        [`${_}-affix-wrapper-without-controls`]: $ === !1 || V
      }, O),
      wrapper: classnames({
        [`${Y}-rtl`]: u === "rtl"
      }, O),
      groupWrapper: classnames({
        [`${_}-group-wrapper-sm`]: D === "small",
        [`${_}-group-wrapper-lg`]: D === "large",
        [`${_}-group-wrapper-rtl`]: u === "rtl",
        [`${_}-group-wrapper-${Z}`]: ne
      }, getStatusClassNames(`${_}-group-wrapper`, P, G), O)
    }
  }, I));
  return R(ee);
}), TypedInputNumber = InputNumber$1, PureInputNumber = (a) => /* @__PURE__ */ reactExports.createElement(ConfigProvider, {
  theme: {
    components: {
      InputNumber: {
        handleVisible: !0
      }
    }
  }
}, /* @__PURE__ */ reactExports.createElement(InputNumber$1, Object.assign({}, a)));
TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = PureInputNumber;
const getAllowClear = (a) => {
  let s;
  return typeof a == "object" && a?.clearIcon ? s = a : a && (s = {
    clearIcon: /* @__PURE__ */ React.createElement(RefIcon$J, null)
  }), s;
};
function useRemovePasswordTimeout(a, s) {
  const c = reactExports.useRef([]), u = () => {
    c.current.push(setTimeout(() => {
      var d, p, v, A;
      !((d = a.current) === null || d === void 0) && d.input && ((p = a.current) === null || p === void 0 ? void 0 : p.input.getAttribute("type")) === "password" && (!((v = a.current) === null || v === void 0) && v.input.hasAttribute("value")) && ((A = a.current) === null || A === void 0 || A.input.removeAttribute("value"));
    }));
  };
  return reactExports.useEffect(() => (s && u(), () => c.current.forEach((d) => {
    d && clearTimeout(d);
  })), []), u;
}
function hasPrefixSuffix(a) {
  return !!(a.prefix || a.suffix || a.allowClear || a.showCount);
}
var __rest$D = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Input$2 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    bordered: u = !0,
    status: d,
    size: p,
    disabled: v,
    onBlur: A,
    onFocus: x,
    suffix: g,
    allowClear: b,
    addonAfter: y,
    addonBefore: f,
    className: m,
    style: C,
    styles: w,
    rootClassName: S,
    onChange: $,
    classNames: T,
    variant: I
  } = a, _ = __rest$D(a, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]), {
    getPrefixCls: E,
    direction: R,
    allowClear: O,
    autoComplete: L,
    className: B,
    style: F,
    classNames: M,
    styles: W
  } = useComponentConfig("input"), j = E("input", c), G = reactExports.useRef(null), U = useCSSVarCls(j), [k, N, P] = useSharedStyle(j, S), [D] = useStyle$n(j, U), {
    compactSize: H,
    compactItemClassnames: V
  } = useCompactItemContext(j, R), Z = useSize((be) => {
    var le;
    return (le = p ?? H) !== null && le !== void 0 ? le : be;
  }), ne = React.useContext(DisabledContext), K = v ?? ne, {
    status: q,
    hasFeedback: Y,
    feedbackIcon: ee
  } = reactExports.useContext(FormItemInputContext), Q = getMergedStatus(q, d), J = hasPrefixSuffix(a) || !!Y;
  reactExports.useRef(J);
  const te = useRemovePasswordTimeout(G, !0), ae = (be) => {
    te(), A?.(be);
  }, se = (be) => {
    te(), x?.(be);
  }, ie = (be) => {
    te(), $?.(be);
  }, fe = (Y || g) && /* @__PURE__ */ React.createElement(React.Fragment, null, g, Y && ee), ge = getAllowClear(b ?? O), [me, pe] = useVariant("input", I, u);
  return k(D(/* @__PURE__ */ React.createElement(Input$3, Object.assign({
    ref: composeRef(s, G),
    prefixCls: j,
    autoComplete: L
  }, _, {
    disabled: K,
    onBlur: ae,
    onFocus: se,
    style: Object.assign(Object.assign({}, F), C),
    styles: Object.assign(Object.assign({}, W), w),
    suffix: fe,
    allowClear: ge,
    className: classnames(m, S, P, U, V, B),
    onChange: ie,
    addonBefore: f && /* @__PURE__ */ React.createElement(ContextIsolator, {
      form: !0,
      space: !0
    }, f),
    addonAfter: y && /* @__PURE__ */ React.createElement(ContextIsolator, {
      form: !0,
      space: !0
    }, y),
    classNames: Object.assign(Object.assign(Object.assign({}, T), M), {
      input: classnames({
        [`${j}-sm`]: Z === "small",
        [`${j}-lg`]: Z === "large",
        [`${j}-rtl`]: R === "rtl"
      }, T?.input, M.input, N),
      variant: classnames({
        [`${j}-${me}`]: pe
      }, getStatusClassNames(j, Q)),
      affixWrapper: classnames({
        [`${j}-affix-wrapper-sm`]: Z === "small",
        [`${j}-affix-wrapper-lg`]: Z === "large",
        [`${j}-affix-wrapper-rtl`]: R === "rtl"
      }, N),
      wrapper: classnames({
        [`${j}-group-rtl`]: R === "rtl"
      }, N),
      groupWrapper: classnames({
        [`${j}-group-wrapper-sm`]: Z === "small",
        [`${j}-group-wrapper-lg`]: Z === "large",
        [`${j}-group-wrapper-rtl`]: R === "rtl",
        [`${j}-group-wrapper-${me}`]: pe
      }, getStatusClassNames(`${j}-group-wrapper`, Q, Y), N)
    })
  }))));
});
function getOffset$3(a, s, c) {
  return (a - s) / (c - s);
}
function getDirectionStyle(a, s, c, u) {
  var d = getOffset$3(s, c, u), p = {};
  switch (a) {
    case "rtl":
      p.right = "".concat(d * 100, "%"), p.transform = "translateX(50%)";
      break;
    case "btt":
      p.bottom = "".concat(d * 100, "%"), p.transform = "translateY(50%)";
      break;
    case "ttb":
      p.top = "".concat(d * 100, "%"), p.transform = "translateY(-50%)";
      break;
    default:
      p.left = "".concat(d * 100, "%"), p.transform = "translateX(-50%)";
      break;
  }
  return p;
}
function getIndex(a, s) {
  return Array.isArray(a) ? a[s] : a;
}
var SliderContext = /* @__PURE__ */ reactExports.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), UnstableContext$1 = /* @__PURE__ */ reactExports.createContext({}), _excluded$n = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], Handle = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.value, d = a.valueIndex, p = a.onStartMove, v = a.onDelete, A = a.style, x = a.render, g = a.dragging, b = a.draggingDelete, y = a.onOffsetChange, f = a.onChangeComplete, m = a.onFocus, C = a.onMouseEnter, w = _objectWithoutProperties$2(a, _excluded$n), S = reactExports.useContext(SliderContext), $ = S.min, T = S.max, I = S.direction, _ = S.disabled, E = S.keyboard, R = S.range, O = S.tabIndex, L = S.ariaLabelForHandle, B = S.ariaLabelledByForHandle, F = S.ariaRequired, M = S.ariaValueTextFormatterForHandle, W = S.styles, j = S.classNames, G = "".concat(c, "-handle"), U = function(q) {
    _ || p(q, d);
  }, k = function(q) {
    m?.(q, d);
  }, N = function(q) {
    C(q, d);
  }, P = function(q) {
    if (!_ && E) {
      var Y = null;
      switch (q.which || q.keyCode) {
        case KeyCode.LEFT:
          Y = I === "ltr" || I === "btt" ? -1 : 1;
          break;
        case KeyCode.RIGHT:
          Y = I === "ltr" || I === "btt" ? 1 : -1;
          break;
        // Up is plus
        case KeyCode.UP:
          Y = I !== "ttb" ? 1 : -1;
          break;
        // Down is minus
        case KeyCode.DOWN:
          Y = I !== "ttb" ? -1 : 1;
          break;
        case KeyCode.HOME:
          Y = "min";
          break;
        case KeyCode.END:
          Y = "max";
          break;
        case KeyCode.PAGE_UP:
          Y = 2;
          break;
        case KeyCode.PAGE_DOWN:
          Y = -2;
          break;
        case KeyCode.BACKSPACE:
        case KeyCode.DELETE:
          v(d);
          break;
      }
      Y !== null && (q.preventDefault(), y(Y, d));
    }
  }, D = function(q) {
    switch (q.which || q.keyCode) {
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
      case KeyCode.UP:
      case KeyCode.DOWN:
      case KeyCode.HOME:
      case KeyCode.END:
      case KeyCode.PAGE_UP:
      case KeyCode.PAGE_DOWN:
        f?.();
        break;
    }
  }, H = getDirectionStyle(I, u, $, T), V = {};
  if (d !== null) {
    var Z;
    V = {
      tabIndex: _ ? null : getIndex(O, d),
      role: "slider",
      "aria-valuemin": $,
      "aria-valuemax": T,
      "aria-valuenow": u,
      "aria-disabled": _,
      "aria-label": getIndex(L, d),
      "aria-labelledby": getIndex(B, d),
      "aria-required": getIndex(F, d),
      "aria-valuetext": (Z = getIndex(M, d)) === null || Z === void 0 ? void 0 : Z(u),
      "aria-orientation": I === "ltr" || I === "rtl" ? "horizontal" : "vertical",
      onMouseDown: U,
      onTouchStart: U,
      onFocus: k,
      onMouseEnter: N,
      onKeyDown: P,
      onKeyUp: D
    };
  }
  var ne = /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    ref: s,
    className: classnames(G, _defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(G, "-").concat(d + 1), d !== null && R), "".concat(G, "-dragging"), g), "".concat(G, "-dragging-delete"), b), j.handle),
    style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, H), A), W.handle)
  }, V, w));
  return x && (ne = x(ne, {
    index: d,
    prefixCls: c,
    value: u,
    dragging: g,
    draggingDelete: b
  })), ne;
}), _excluded$m = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"], Handles = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.style, d = a.onStartMove, p = a.onOffsetChange, v = a.values, A = a.handleRender, x = a.activeHandleRender, g = a.draggingIndex, b = a.draggingDelete, y = a.onFocus, f = _objectWithoutProperties$2(a, _excluded$m), m = reactExports.useRef({}), C = reactExports.useState(!1), w = _slicedToArray$e(C, 2), S = w[0], $ = w[1], T = reactExports.useState(-1), I = _slicedToArray$e(T, 2), _ = I[0], E = I[1], R = function(M) {
    E(M), $(!0);
  }, O = function(M, W) {
    R(W), y?.(M);
  }, L = function(M, W) {
    R(W);
  };
  reactExports.useImperativeHandle(s, function() {
    return {
      focus: function(M) {
        var W;
        (W = m.current[M]) === null || W === void 0 || W.focus();
      },
      hideHelp: function() {
        reactDomExports.flushSync(function() {
          $(!1);
        });
      }
    };
  });
  var B = _objectSpread2$1({
    prefixCls: c,
    onStartMove: d,
    onOffsetChange: p,
    render: A,
    onFocus: O,
    onMouseEnter: L
  }, f);
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, v.map(function(F, M) {
    var W = g === M;
    return /* @__PURE__ */ reactExports.createElement(Handle, _extends$3({
      ref: function(G) {
        G ? m.current[M] = G : delete m.current[M];
      },
      dragging: W,
      draggingDelete: W && b,
      style: getIndex(u, M),
      key: M,
      value: F,
      valueIndex: M
    }, B));
  }), x && S && /* @__PURE__ */ reactExports.createElement(Handle, _extends$3({
    key: "a11y"
  }, B, {
    value: v[_],
    valueIndex: null,
    dragging: g !== -1,
    draggingDelete: b,
    render: x,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
}), Mark = function a(s) {
  var c = s.prefixCls, u = s.style, d = s.children, p = s.value, v = s.onClick, A = reactExports.useContext(SliderContext), x = A.min, g = A.max, b = A.direction, y = A.includedStart, f = A.includedEnd, m = A.included, C = "".concat(c, "-text"), w = getDirectionStyle(b, p, x, g);
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(C, _defineProperty$a({}, "".concat(C, "-active"), m && y <= p && p <= f)),
    style: _objectSpread2$1(_objectSpread2$1({}, w), u),
    onMouseDown: function($) {
      $.stopPropagation();
    },
    onClick: function() {
      v(p);
    }
  }, d);
}, Marks = function a(s) {
  var c = s.prefixCls, u = s.marks, d = s.onClick, p = "".concat(c, "-mark");
  return u.length ? /* @__PURE__ */ reactExports.createElement("div", {
    className: p
  }, u.map(function(v) {
    var A = v.value, x = v.style, g = v.label;
    return /* @__PURE__ */ reactExports.createElement(Mark, {
      key: A,
      prefixCls: p,
      style: x,
      value: A,
      onClick: d
    }, g);
  })) : null;
}, Dot = function a(s) {
  var c = s.prefixCls, u = s.value, d = s.style, p = s.activeStyle, v = reactExports.useContext(SliderContext), A = v.min, x = v.max, g = v.direction, b = v.included, y = v.includedStart, f = v.includedEnd, m = "".concat(c, "-dot"), C = b && y <= u && u <= f, w = _objectSpread2$1(_objectSpread2$1({}, getDirectionStyle(g, u, A, x)), typeof d == "function" ? d(u) : d);
  return C && (w = _objectSpread2$1(_objectSpread2$1({}, w), typeof p == "function" ? p(u) : p)), /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(m, _defineProperty$a({}, "".concat(m, "-active"), C)),
    style: w
  });
}, Steps$1 = function a(s) {
  var c = s.prefixCls, u = s.marks, d = s.dots, p = s.style, v = s.activeStyle, A = reactExports.useContext(SliderContext), x = A.min, g = A.max, b = A.step, y = reactExports.useMemo(function() {
    var f = /* @__PURE__ */ new Set();
    if (u.forEach(function(C) {
      f.add(C.value);
    }), d && b !== null)
      for (var m = x; m <= g; )
        f.add(m), m += b;
    return Array.from(f);
  }, [x, g, b, d, u]);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(c, "-step")
  }, y.map(function(f) {
    return /* @__PURE__ */ reactExports.createElement(Dot, {
      prefixCls: c,
      key: f,
      value: f,
      style: p,
      activeStyle: v
    });
  }));
}, Track = function a(s) {
  var c = s.prefixCls, u = s.style, d = s.start, p = s.end, v = s.index, A = s.onStartMove, x = s.replaceCls, g = reactExports.useContext(SliderContext), b = g.direction, y = g.min, f = g.max, m = g.disabled, C = g.range, w = g.classNames, S = "".concat(c, "-track"), $ = getOffset$3(d, y, f), T = getOffset$3(p, y, f), I = function(O) {
    !m && A && A(O, -1);
  }, _ = {};
  switch (b) {
    case "rtl":
      _.right = "".concat($ * 100, "%"), _.width = "".concat(T * 100 - $ * 100, "%");
      break;
    case "btt":
      _.bottom = "".concat($ * 100, "%"), _.height = "".concat(T * 100 - $ * 100, "%");
      break;
    case "ttb":
      _.top = "".concat($ * 100, "%"), _.height = "".concat(T * 100 - $ * 100, "%");
      break;
    default:
      _.left = "".concat($ * 100, "%"), _.width = "".concat(T * 100 - $ * 100, "%");
  }
  var E = x || classnames(S, _defineProperty$a(_defineProperty$a({}, "".concat(S, "-").concat(v + 1), v !== null && C), "".concat(c, "-track-draggable"), A), w.track);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: E,
    style: _objectSpread2$1(_objectSpread2$1({}, _), u),
    onMouseDown: I,
    onTouchStart: I
  });
}, Tracks = function a(s) {
  var c = s.prefixCls, u = s.style, d = s.values, p = s.startPoint, v = s.onStartMove, A = reactExports.useContext(SliderContext), x = A.included, g = A.range, b = A.min, y = A.styles, f = A.classNames, m = reactExports.useMemo(function() {
    if (!g) {
      if (d.length === 0)
        return [];
      var w = p ?? b, S = d[0];
      return [{
        start: Math.min(w, S),
        end: Math.max(w, S)
      }];
    }
    for (var $ = [], T = 0; T < d.length - 1; T += 1)
      $.push({
        start: d[T],
        end: d[T + 1]
      });
    return $;
  }, [d, g, p, b]);
  if (!x)
    return null;
  var C = m != null && m.length && (f.tracks || y.tracks) ? /* @__PURE__ */ reactExports.createElement(Track, {
    index: null,
    prefixCls: c,
    start: m[0].start,
    end: m[m.length - 1].end,
    replaceCls: classnames(f.tracks, "".concat(c, "-tracks")),
    style: y.tracks
  }) : null;
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, C, m.map(function(w, S) {
    var $ = w.start, T = w.end;
    return /* @__PURE__ */ reactExports.createElement(Track, {
      index: S,
      prefixCls: c,
      style: _objectSpread2$1(_objectSpread2$1({}, getIndex(u, S)), y.track),
      start: $,
      end: T,
      key: S,
      onStartMove: v
    });
  }));
}, REMOVE_DIST = 130;
function getPosition$1(a) {
  var s = "targetTouches" in a ? a.targetTouches[0] : a;
  return {
    pageX: s.pageX,
    pageY: s.pageY
  };
}
function useDrag(a, s, c, u, d, p, v, A, x, g, b) {
  var y = reactExports.useState(null), f = _slicedToArray$e(y, 2), m = f[0], C = f[1], w = reactExports.useState(-1), S = _slicedToArray$e(w, 2), $ = S[0], T = S[1], I = reactExports.useState(!1), _ = _slicedToArray$e(I, 2), E = _[0], R = _[1], O = reactExports.useState(c), L = _slicedToArray$e(O, 2), B = L[0], F = L[1], M = reactExports.useState(c), W = _slicedToArray$e(M, 2), j = W[0], G = W[1], U = reactExports.useRef(null), k = reactExports.useRef(null), N = reactExports.useRef(null), P = reactExports.useContext(UnstableContext$1), D = P.onDragStart, H = P.onDragChange;
  useLayoutEffect$1(function() {
    $ === -1 && F(c);
  }, [c, $]), reactExports.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", U.current), document.removeEventListener("mouseup", k.current), N.current && (N.current.removeEventListener("touchmove", U.current), N.current.removeEventListener("touchend", k.current));
    };
  }, []);
  var V = function(Y, ee, Q) {
    ee !== void 0 && C(ee), F(Y);
    var J = Y;
    Q && (J = Y.filter(function(te, ae) {
      return ae !== $;
    })), v(J), H && H({
      rawValues: Y,
      deleteIndex: Q ? $ : -1,
      draggingIndex: $,
      draggingValue: ee
    });
  }, Z = useEvent(function(q, Y, ee) {
    if (q === -1) {
      var Q = j[0], J = j[j.length - 1], te = u - Q, ae = d - J, se = Y * (d - u);
      se = Math.max(se, te), se = Math.min(se, ae);
      var ie = p(Q + se);
      se = ie - Q;
      var fe = j.map(function(be) {
        return be + se;
      });
      V(fe);
    } else {
      var ge = (d - u) * Y, me = _toConsumableArray$e(B);
      me[q] = j[q];
      var pe = x(me, ge, q, "dist");
      V(pe.values, pe.value, ee);
    }
  }), ne = function(Y, ee, Q) {
    Y.stopPropagation();
    var J = Q || c, te = J[ee];
    T(ee), C(te), G(J), F(J), R(!1);
    var ae = getPosition$1(Y), se = ae.pageX, ie = ae.pageY, fe = !1;
    D && D({
      rawValues: J,
      draggingIndex: ee,
      draggingValue: te
    });
    var ge = function(be) {
      be.preventDefault();
      var le = getPosition$1(be), ve = le.pageX, he = le.pageY, ye = ve - se, Ce = he - ie, xe = a.current.getBoundingClientRect(), we = xe.width, $e = xe.height, Ae, ue;
      switch (s) {
        case "btt":
          Ae = -Ce / $e, ue = ye;
          break;
        case "ttb":
          Ae = Ce / $e, ue = ye;
          break;
        case "rtl":
          Ae = -ye / we, ue = Ce;
          break;
        default:
          Ae = ye / we, ue = Ce;
      }
      fe = g ? Math.abs(ue) > REMOVE_DIST && b < B.length : !1, R(fe), Z(ee, Ae, fe);
    }, me = function pe(be) {
      be.preventDefault(), document.removeEventListener("mouseup", pe), document.removeEventListener("mousemove", ge), N.current && (N.current.removeEventListener("touchmove", U.current), N.current.removeEventListener("touchend", k.current)), U.current = null, k.current = null, N.current = null, A(fe), T(-1), R(!1);
    };
    document.addEventListener("mouseup", me), document.addEventListener("mousemove", ge), Y.currentTarget.addEventListener("touchend", me), Y.currentTarget.addEventListener("touchmove", ge), U.current = ge, k.current = me, N.current = Y.currentTarget;
  }, K = reactExports.useMemo(function() {
    var q = _toConsumableArray$e(c).sort(function(te, ae) {
      return te - ae;
    }), Y = _toConsumableArray$e(B).sort(function(te, ae) {
      return te - ae;
    }), ee = {};
    Y.forEach(function(te) {
      ee[te] = (ee[te] || 0) + 1;
    }), q.forEach(function(te) {
      ee[te] = (ee[te] || 0) - 1;
    });
    var Q = g ? 1 : 0, J = Object.values(ee).reduce(function(te, ae) {
      return te + Math.abs(ae);
    }, 0);
    return J <= Q ? B : c;
  }, [c, B, g]);
  return [$, m, E, K, ne];
}
function useOffset(a, s, c, u, d, p) {
  var v = reactExports.useCallback(function(m) {
    return Math.max(a, Math.min(s, m));
  }, [a, s]), A = reactExports.useCallback(function(m) {
    if (c !== null) {
      var C = a + Math.round((v(m) - a) / c) * c, w = function(I) {
        return (String(I).split(".")[1] || "").length;
      }, S = Math.max(w(c), w(s), w(a)), $ = Number(C.toFixed(S));
      return a <= $ && $ <= s ? $ : null;
    }
    return null;
  }, [c, a, s, v]), x = reactExports.useCallback(function(m) {
    var C = v(m), w = u.map(function(T) {
      return T.value;
    });
    c !== null && w.push(A(m)), w.push(a, s);
    var S = w[0], $ = s - a;
    return w.forEach(function(T) {
      var I = Math.abs(C - T);
      I <= $ && (S = T, $ = I);
    }), S;
  }, [a, s, u, c, v, A]), g = function m(C, w, S) {
    var $ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof w == "number") {
      var T, I = C[S], _ = I + w, E = [];
      u.forEach(function(F) {
        E.push(F.value);
      }), E.push(a, s), E.push(A(I));
      var R = w > 0 ? 1 : -1;
      $ === "unit" ? E.push(A(I + R * c)) : E.push(A(_)), E = E.filter(function(F) {
        return F !== null;
      }).filter(function(F) {
        return w < 0 ? F <= I : F >= I;
      }), $ === "unit" && (E = E.filter(function(F) {
        return F !== I;
      }));
      var O = $ === "unit" ? I : _;
      T = E[0];
      var L = Math.abs(T - O);
      if (E.forEach(function(F) {
        var M = Math.abs(F - O);
        M < L && (T = F, L = M);
      }), T === void 0)
        return w < 0 ? a : s;
      if ($ === "dist")
        return T;
      if (Math.abs(w) > 1) {
        var B = _toConsumableArray$e(C);
        return B[S] = T, m(B, w - R, S, $);
      }
      return T;
    } else {
      if (w === "min")
        return a;
      if (w === "max")
        return s;
    }
  }, b = function(C, w, S) {
    var $ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", T = C[S], I = g(C, w, S, $);
    return {
      value: I,
      changed: I !== T
    };
  }, y = function(C) {
    return p === null && C === 0 || typeof p == "number" && C < p;
  }, f = function(C, w, S) {
    var $ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", T = C.map(x), I = T[S], _ = g(T, w, S, $);
    if (T[S] = _, d === !1) {
      var E = p || 0;
      S > 0 && T[S - 1] !== I && (T[S] = Math.max(T[S], T[S - 1] + E)), S < T.length - 1 && T[S + 1] !== I && (T[S] = Math.min(T[S], T[S + 1] - E));
    } else if (typeof p == "number" || p === null) {
      for (var R = S + 1; R < T.length; R += 1)
        for (var O = !0; y(T[R] - T[R - 1]) && O; ) {
          var L = b(T, 1, R);
          T[R] = L.value, O = L.changed;
        }
      for (var B = S; B > 0; B -= 1)
        for (var F = !0; y(T[B] - T[B - 1]) && F; ) {
          var M = b(T, -1, B - 1);
          T[B - 1] = M.value, F = M.changed;
        }
      for (var W = T.length - 1; W > 0; W -= 1)
        for (var j = !0; y(T[W] - T[W - 1]) && j; ) {
          var G = b(T, -1, W - 1);
          T[W - 1] = G.value, j = G.changed;
        }
      for (var U = 0; U < T.length - 1; U += 1)
        for (var k = !0; y(T[U + 1] - T[U]) && k; ) {
          var N = b(T, 1, U + 1);
          T[U + 1] = N.value, k = N.changed;
        }
    }
    return {
      value: T[S],
      values: T
    };
  };
  return [x, f];
}
function useRange(a) {
  return reactExports.useMemo(function() {
    if (a === !0 || !a)
      return [!!a, !1, !1, 0];
    var s = a.editable, c = a.draggableTrack, u = a.minCount, d = a.maxCount;
    return [!0, s, !s && c, u || 0, d];
  }, [a]);
}
var Slider$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = c === void 0 ? "rc-slider" : c, d = a.className, p = a.style, v = a.classNames, A = a.styles, x = a.id, g = a.disabled, b = g === void 0 ? !1 : g, y = a.keyboard, f = y === void 0 ? !0 : y, m = a.autoFocus, C = a.onFocus, w = a.onBlur, S = a.min, $ = S === void 0 ? 0 : S, T = a.max, I = T === void 0 ? 100 : T, _ = a.step, E = _ === void 0 ? 1 : _, R = a.value, O = a.defaultValue, L = a.range, B = a.count, F = a.onChange, M = a.onBeforeChange, W = a.onAfterChange, j = a.onChangeComplete, G = a.allowCross, U = G === void 0 ? !0 : G, k = a.pushable, N = k === void 0 ? !1 : k, P = a.reverse, D = a.vertical, H = a.included, V = H === void 0 ? !0 : H, Z = a.startPoint, ne = a.trackStyle, K = a.handleStyle, q = a.railStyle, Y = a.dotStyle, ee = a.activeDotStyle, Q = a.marks, J = a.dots, te = a.handleRender, ae = a.activeHandleRender, se = a.track, ie = a.tabIndex, fe = ie === void 0 ? 0 : ie, ge = a.ariaLabelForHandle, me = a.ariaLabelledByForHandle, pe = a.ariaRequired, be = a.ariaValueTextFormatterForHandle, le = reactExports.useRef(null), ve = reactExports.useRef(null), he = reactExports.useMemo(function() {
    return D ? P ? "ttb" : "btt" : P ? "rtl" : "ltr";
  }, [P, D]), ye = useRange(L), Ce = _slicedToArray$e(ye, 5), xe = Ce[0], we = Ce[1], $e = Ce[2], Ae = Ce[3], ue = Ce[4], ce = reactExports.useMemo(function() {
    return isFinite($) ? $ : 0;
  }, [$]), Ee = reactExports.useMemo(function() {
    return isFinite(I) ? I : 100;
  }, [I]), _e = reactExports.useMemo(function() {
    return E !== null && E <= 0 ? 1 : E;
  }, [E]), Te = reactExports.useMemo(function() {
    return typeof N == "boolean" ? N ? _e : !1 : N >= 0 ? N : !1;
  }, [N, _e]), ke = reactExports.useMemo(function() {
    return Object.keys(Q || {}).map(function(Ke) {
      var qe = Q[Ke], ot = {
        value: Number(Ke)
      };
      return qe && _typeof$h(qe) === "object" && !/* @__PURE__ */ reactExports.isValidElement(qe) && ("label" in qe || "style" in qe) ? (ot.style = qe.style, ot.label = qe.label) : ot.label = qe, ot;
    }).filter(function(Ke) {
      var qe = Ke.label;
      return qe || typeof qe == "number";
    }).sort(function(Ke, qe) {
      return Ke.value - qe.value;
    });
  }, [Q]), Re = useOffset(ce, Ee, _e, ke, U, Te), Be = _slicedToArray$e(Re, 2), Oe = Be[0], Me = Be[1], Fe = useMergedState(O, {
    value: R
  }), Ue = _slicedToArray$e(Fe, 2), je = Ue[0], Le = Ue[1], De = reactExports.useMemo(function() {
    var Ke = je == null ? [] : Array.isArray(je) ? je : [je], qe = _slicedToArray$e(Ke, 1), ot = qe[0], Je = ot === void 0 ? ce : ot, Ct = je === null ? [] : [Je];
    if (xe) {
      if (Ct = _toConsumableArray$e(Ke), B || je === void 0) {
        var Tt = B >= 0 ? B + 1 : 2;
        for (Ct = Ct.slice(0, Tt); Ct.length < Tt; ) {
          var yt;
          Ct.push((yt = Ct[Ct.length - 1]) !== null && yt !== void 0 ? yt : ce);
        }
      }
      Ct.sort(function(bt, It) {
        return bt - It;
      });
    }
    return Ct.forEach(function(bt, It) {
      Ct[It] = Oe(bt);
    }), Ct;
  }, [je, xe, ce, B, Oe]), Ne = function(qe) {
    return xe ? qe : qe[0];
  }, Ge = useEvent(function(Ke) {
    var qe = _toConsumableArray$e(Ke).sort(function(ot, Je) {
      return ot - Je;
    });
    F && !isEqual(qe, De, !0) && F(Ne(qe)), Le(qe);
  }), Xe = useEvent(function(Ke) {
    Ke && le.current.hideHelp();
    var qe = Ne(De);
    W?.(qe), warningOnce(!W, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), j?.(qe);
  }), nt = function(qe) {
    if (!(b || !we || De.length <= Ae)) {
      var ot = _toConsumableArray$e(De);
      ot.splice(qe, 1), M?.(Ne(ot)), Ge(ot);
      var Je = Math.max(0, qe - 1);
      le.current.hideHelp(), le.current.focus(Je);
    }
  }, ct = useDrag(ve, he, De, ce, Ee, Oe, Ge, Xe, Me, we, Ae), it = _slicedToArray$e(ct, 5), We = it[0], Ve = it[1], ut = it[2], at = it[3], Qe = it[4], st = function(qe, ot) {
    if (!b) {
      var Je = _toConsumableArray$e(De), Ct = 0, Tt = 0, yt = Ee - ce;
      De.forEach(function(Lt, Ft) {
        var Vt = Math.abs(qe - Lt);
        Vt <= yt && (yt = Vt, Ct = Ft), Lt < qe && (Tt = Ft);
      });
      var bt = Ct;
      we && yt !== 0 && (!ue || De.length < ue) ? (Je.splice(Tt + 1, 0, qe), bt = Tt + 1) : Je[Ct] = qe, xe && !De.length && B === void 0 && Je.push(qe);
      var It = Ne(Je);
      if (M?.(It), Ge(Je), ot) {
        var kt, $t;
        (kt = document.activeElement) === null || kt === void 0 || ($t = kt.blur) === null || $t === void 0 || $t.call(kt), le.current.focus(bt), Qe(ot, bt, Je);
      } else
        W?.(It), warningOnce(!W, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), j?.(It);
    }
  }, ft = function(qe) {
    qe.preventDefault();
    var ot = ve.current.getBoundingClientRect(), Je = ot.width, Ct = ot.height, Tt = ot.left, yt = ot.top, bt = ot.bottom, It = ot.right, kt = qe.clientX, $t = qe.clientY, Lt;
    switch (he) {
      case "btt":
        Lt = (bt - $t) / Ct;
        break;
      case "ttb":
        Lt = ($t - yt) / Ct;
        break;
      case "rtl":
        Lt = (It - kt) / Je;
        break;
      default:
        Lt = (kt - Tt) / Je;
    }
    var Ft = ce + Lt * (Ee - ce);
    st(Oe(Ft), qe);
  }, vt = reactExports.useState(null), Pt = _slicedToArray$e(vt, 2), dt = Pt[0], mt = Pt[1], pt = function(qe, ot) {
    if (!b) {
      var Je = Me(De, qe, ot);
      M?.(Ne(De)), Ge(Je.values), mt(Je.value);
    }
  };
  reactExports.useEffect(function() {
    if (dt !== null) {
      var Ke = De.indexOf(dt);
      Ke >= 0 && le.current.focus(Ke);
    }
    mt(null);
  }, [dt]);
  var Et = reactExports.useMemo(function() {
    return $e && _e === null ? !1 : $e;
  }, [$e, _e]), Mt = useEvent(function(Ke, qe) {
    Qe(Ke, qe), M?.(Ne(De));
  }), Nt = We !== -1;
  reactExports.useEffect(function() {
    if (!Nt) {
      var Ke = De.lastIndexOf(Ve);
      le.current.focus(Ke);
    }
  }, [Nt]);
  var _t = reactExports.useMemo(function() {
    return _toConsumableArray$e(at).sort(function(Ke, qe) {
      return Ke - qe;
    });
  }, [at]), Ot = reactExports.useMemo(function() {
    return xe ? [_t[0], _t[_t.length - 1]] : [ce, _t[0]];
  }, [_t, xe, ce]), rt = _slicedToArray$e(Ot, 2), et = rt[0], Ye = rt[1];
  reactExports.useImperativeHandle(s, function() {
    return {
      focus: function() {
        le.current.focus(0);
      },
      blur: function() {
        var qe, ot = document, Je = ot.activeElement;
        (qe = ve.current) !== null && qe !== void 0 && qe.contains(Je) && Je?.blur();
      }
    };
  }), reactExports.useEffect(function() {
    m && le.current.focus(0);
  }, []);
  var tt = reactExports.useMemo(function() {
    return {
      min: ce,
      max: Ee,
      direction: he,
      disabled: b,
      keyboard: f,
      step: _e,
      included: V,
      includedStart: et,
      includedEnd: Ye,
      range: xe,
      tabIndex: fe,
      ariaLabelForHandle: ge,
      ariaLabelledByForHandle: me,
      ariaRequired: pe,
      ariaValueTextFormatterForHandle: be,
      styles: A || {},
      classNames: v || {}
    };
  }, [ce, Ee, he, b, f, _e, V, et, Ye, xe, fe, ge, me, pe, be, A, v]);
  return /* @__PURE__ */ reactExports.createElement(SliderContext.Provider, {
    value: tt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: ve,
    className: classnames(u, d, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(u, "-disabled"), b), "".concat(u, "-vertical"), D), "".concat(u, "-horizontal"), !D), "".concat(u, "-with-marks"), ke.length)),
    style: p,
    onMouseDown: ft,
    id: x
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(u, "-rail"), v?.rail),
    style: _objectSpread2$1(_objectSpread2$1({}, q), A?.rail)
  }), se !== !1 && /* @__PURE__ */ reactExports.createElement(Tracks, {
    prefixCls: u,
    style: ne,
    values: De,
    startPoint: Z,
    onStartMove: Et ? Mt : void 0
  }), /* @__PURE__ */ reactExports.createElement(Steps$1, {
    prefixCls: u,
    marks: ke,
    dots: J,
    style: Y,
    activeStyle: ee
  }), /* @__PURE__ */ reactExports.createElement(Handles, {
    ref: le,
    prefixCls: u,
    style: K,
    values: at,
    draggingIndex: We,
    draggingDelete: ut,
    onStartMove: Mt,
    onOffsetChange: pt,
    onFocus: C,
    onBlur: w,
    handleRender: te,
    activeHandleRender: ae,
    onChangeComplete: Xe,
    onDelete: we ? nt : void 0
  }), /* @__PURE__ */ reactExports.createElement(Marks, {
    prefixCls: u,
    marks: ke,
    onClick: st
  })));
});
const SliderInternalContext = /* @__PURE__ */ reactExports.createContext({}), SliderTooltip = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    open: c,
    draggingDelete: u,
    value: d
  } = a, p = reactExports.useRef(null), v = c && !u, A = reactExports.useRef(null);
  function x() {
    wrapperRaf.cancel(A.current), A.current = null;
  }
  function g() {
    A.current = wrapperRaf(() => {
      var b;
      (b = p.current) === null || b === void 0 || b.forceAlign(), A.current = null;
    });
  }
  return reactExports.useEffect(() => (v ? g() : x(), x), [v, a.title, d]), /* @__PURE__ */ reactExports.createElement(Tooltip, Object.assign({
    ref: composeRef(p, s)
  }, a, {
    open: v
  }));
}), genBaseStyle$6 = (a) => {
  const {
    componentCls: s,
    antCls: c,
    controlSize: u,
    dotSize: d,
    marginFull: p,
    marginPart: v,
    colorFillContentHover: A,
    handleColorDisabled: x,
    calc: g,
    handleSize: b,
    handleSizeHover: y,
    handleActiveColor: f,
    handleActiveOutlineColor: m,
    handleLineWidth: C,
    handleLineWidthHover: w,
    motionDurationMid: S
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "relative",
      height: u,
      margin: `${unit$1(v)} ${unit$1(p)}`,
      padding: 0,
      cursor: "pointer",
      touchAction: "none",
      "&-vertical": {
        margin: `${unit$1(p)} ${unit$1(v)}`
      },
      [`${s}-rail`]: {
        position: "absolute",
        backgroundColor: a.railBg,
        borderRadius: a.borderRadiusXS,
        transition: `background-color ${S}`
      },
      [`${s}-track,${s}-tracks`]: {
        position: "absolute",
        transition: `background-color ${S}`
      },
      [`${s}-track`]: {
        backgroundColor: a.trackBg,
        borderRadius: a.borderRadiusXS
      },
      [`${s}-track-draggable`]: {
        boxSizing: "content-box",
        backgroundClip: "content-box",
        border: "solid rgba(0,0,0,0)"
      },
      "&:hover": {
        [`${s}-rail`]: {
          backgroundColor: a.railHoverBg
        },
        [`${s}-track`]: {
          backgroundColor: a.trackHoverBg
        },
        [`${s}-dot`]: {
          borderColor: A
        },
        [`${s}-handle::after`]: {
          boxShadow: `0 0 0 ${unit$1(C)} ${a.colorPrimaryBorderHover}`
        },
        [`${s}-dot-active`]: {
          borderColor: a.dotActiveBorderColor
        }
      },
      [`${s}-handle`]: {
        position: "absolute",
        width: b,
        height: b,
        outline: "none",
        userSelect: "none",
        // Dragging status
        "&-dragging-delete": {
          opacity: 0
        },
        // 扩大选区
        "&::before": {
          content: '""',
          position: "absolute",
          insetInlineStart: g(C).mul(-1).equal(),
          insetBlockStart: g(C).mul(-1).equal(),
          width: g(b).add(g(C).mul(2)).equal(),
          height: g(b).add(g(C).mul(2)).equal(),
          backgroundColor: "transparent"
        },
        "&::after": {
          content: '""',
          position: "absolute",
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: b,
          height: b,
          backgroundColor: a.colorBgElevated,
          boxShadow: `0 0 0 ${unit$1(C)} ${a.handleColor}`,
          outline: "0px solid transparent",
          borderRadius: "50%",
          cursor: "pointer",
          transition: `
            inset-inline-start ${S},
            inset-block-start ${S},
            width ${S},
            height ${S},
            box-shadow ${S},
            outline ${S}
          `
        },
        "&:hover, &:active, &:focus": {
          "&::before": {
            insetInlineStart: g(y).sub(b).div(2).add(w).mul(-1).equal(),
            insetBlockStart: g(y).sub(b).div(2).add(w).mul(-1).equal(),
            width: g(y).add(g(w).mul(2)).equal(),
            height: g(y).add(g(w).mul(2)).equal()
          },
          "&::after": {
            boxShadow: `0 0 0 ${unit$1(w)} ${f}`,
            outline: `6px solid ${m}`,
            width: y,
            height: y,
            insetInlineStart: a.calc(b).sub(y).div(2).equal(),
            insetBlockStart: a.calc(b).sub(y).div(2).equal()
          }
        }
      },
      [`&-lock ${s}-handle`]: {
        "&::before, &::after": {
          transition: "none"
        }
      },
      [`${s}-mark`]: {
        position: "absolute",
        fontSize: a.fontSize
      },
      [`${s}-mark-text`]: {
        position: "absolute",
        display: "inline-block",
        color: a.colorTextDescription,
        textAlign: "center",
        wordBreak: "keep-all",
        cursor: "pointer",
        userSelect: "none",
        "&-active": {
          color: a.colorText
        }
      },
      [`${s}-step`]: {
        position: "absolute",
        background: "transparent",
        pointerEvents: "none"
      },
      [`${s}-dot`]: {
        position: "absolute",
        width: d,
        height: d,
        backgroundColor: a.colorBgElevated,
        border: `${unit$1(C)} solid ${a.dotBorderColor}`,
        borderRadius: "50%",
        cursor: "pointer",
        transition: `border-color ${a.motionDurationSlow}`,
        pointerEvents: "auto",
        "&-active": {
          borderColor: a.dotActiveBorderColor
        }
      },
      [`&${s}-disabled`]: {
        cursor: "not-allowed",
        [`${s}-rail`]: {
          backgroundColor: `${a.railBg} !important`
        },
        [`${s}-track`]: {
          backgroundColor: `${a.trackBgDisabled} !important`
        },
        [`
          ${s}-dot
        `]: {
          backgroundColor: a.colorBgElevated,
          borderColor: a.trackBgDisabled,
          boxShadow: "none",
          cursor: "not-allowed"
        },
        [`${s}-handle::after`]: {
          backgroundColor: a.colorBgElevated,
          cursor: "not-allowed",
          width: b,
          height: b,
          boxShadow: `0 0 0 ${unit$1(C)} ${x}`,
          insetInlineStart: 0,
          insetBlockStart: 0
        },
        [`
          ${s}-mark-text,
          ${s}-dot
        `]: {
          cursor: "not-allowed !important"
        }
      },
      [`&-tooltip ${c}-tooltip-inner`]: {
        minWidth: "unset"
      }
    })
  };
}, genDirectionStyle = (a, s) => {
  const {
    componentCls: c,
    railSize: u,
    handleSize: d,
    dotSize: p,
    marginFull: v,
    calc: A
  } = a, x = s ? "paddingBlock" : "paddingInline", g = s ? "width" : "height", b = s ? "height" : "width", y = s ? "insetBlockStart" : "insetInlineStart", f = s ? "top" : "insetInlineStart", m = A(u).mul(3).sub(d).div(2).equal(), C = A(d).sub(u).div(2).equal(), w = s ? {
    borderWidth: `${unit$1(C)} 0`,
    transform: `translateY(${unit$1(A(C).mul(-1).equal())})`
  } : {
    borderWidth: `0 ${unit$1(C)}`,
    transform: `translateX(${unit$1(a.calc(C).mul(-1).equal())})`
  };
  return {
    [x]: u,
    [b]: A(u).mul(3).equal(),
    [`${c}-rail`]: {
      [g]: "100%",
      [b]: u
    },
    [`${c}-track,${c}-tracks`]: {
      [b]: u
    },
    [`${c}-track-draggable`]: Object.assign({}, w),
    [`${c}-handle`]: {
      [y]: m
    },
    [`${c}-mark`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      // https://github.com/ant-design/ant-design/issues/43731
      [f]: A(u).mul(3).add(s ? 0 : v).equal(),
      [g]: "100%"
    },
    [`${c}-step`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      [f]: u,
      [g]: "100%",
      [b]: u
    },
    [`${c}-dot`]: {
      position: "absolute",
      [y]: A(u).sub(p).div(2).equal()
    }
  };
}, genHorizontalStyle$1 = (a) => {
  const {
    componentCls: s,
    marginPartWithMark: c
  } = a;
  return {
    [`${s}-horizontal`]: Object.assign(Object.assign({}, genDirectionStyle(a, !0)), {
      [`&${s}-with-marks`]: {
        marginBottom: c
      }
    })
  };
}, genVerticalStyle$1 = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-vertical`]: Object.assign(Object.assign({}, genDirectionStyle(a, !1)), {
      height: "100%"
    })
  };
}, prepareComponentToken$e = (a) => {
  const c = a.controlHeightLG / 4, u = a.controlHeightSM / 2, d = a.lineWidth + 1, p = a.lineWidth + 1 * 1.5, v = a.colorPrimary, A = new FastColor(v).setA(0.2).toRgbString();
  return {
    controlSize: c,
    railSize: 4,
    handleSize: c,
    handleSizeHover: u,
    dotSize: 8,
    handleLineWidth: d,
    handleLineWidthHover: p,
    railBg: a.colorFillTertiary,
    railHoverBg: a.colorFillSecondary,
    trackBg: a.colorPrimaryBorder,
    trackHoverBg: a.colorPrimaryBorderHover,
    handleColor: a.colorPrimaryBorder,
    handleActiveColor: v,
    handleActiveOutlineColor: A,
    handleColorDisabled: new FastColor(a.colorTextDisabled).onBackground(a.colorBgContainer).toHexString(),
    dotBorderColor: a.colorBorderSecondary,
    dotActiveBorderColor: a.colorPrimaryBorder,
    trackBgDisabled: a.colorBgContainerDisabled
  };
}, useStyle$g = genStyleHooks("Slider", (a) => {
  const s = merge(a, {
    marginPart: a.calc(a.controlHeight).sub(a.controlSize).div(2).equal(),
    marginFull: a.calc(a.controlSize).div(2).equal(),
    marginPartWithMark: a.calc(a.controlHeightLG).sub(a.controlSize).equal()
  });
  return [genBaseStyle$6(s), genHorizontalStyle$1(s), genVerticalStyle$1(s)];
}, prepareComponentToken$e);
function useRafLock() {
  const [a, s] = reactExports.useState(!1), c = reactExports.useRef(null), u = () => {
    wrapperRaf.cancel(c.current);
  }, d = (p) => {
    u(), p ? s(p) : c.current = wrapperRaf(() => {
      s(p);
    });
  };
  return reactExports.useEffect(() => u, []), [a, d];
}
var __rest$C = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function getTipFormatter(a, s) {
  return a || a === null ? a : s || s === null ? s : (c) => typeof c == "number" ? c.toString() : "";
}
const Slider$1 = /* @__PURE__ */ React.forwardRef((a, s) => {
  const {
    prefixCls: c,
    range: u,
    className: d,
    rootClassName: p,
    style: v,
    disabled: A,
    // Deprecated Props
    tooltipPrefixCls: x,
    tipFormatter: g,
    tooltipVisible: b,
    getTooltipPopupContainer: y,
    tooltipPlacement: f,
    tooltip: m = {},
    onChangeComplete: C,
    classNames: w,
    styles: S
  } = a, $ = __rest$C(a, ["prefixCls", "range", "className", "rootClassName", "style", "disabled", "tooltipPrefixCls", "tipFormatter", "tooltipVisible", "getTooltipPopupContainer", "tooltipPlacement", "tooltip", "onChangeComplete", "classNames", "styles"]), {
    vertical: T
  } = a, {
    getPrefixCls: I,
    direction: _,
    className: E,
    style: R,
    classNames: O,
    styles: L,
    getPopupContainer: B
  } = useComponentConfig("slider"), F = React.useContext(DisabledContext), M = A ?? F, {
    handleRender: W,
    direction: j
  } = React.useContext(SliderInternalContext), U = (j || _) === "rtl", [k, N] = useRafLock(), [P, D] = useRafLock(), H = Object.assign({}, m), {
    open: V,
    placement: Z,
    getPopupContainer: ne,
    prefixCls: K,
    formatter: q
  } = H, Y = V ?? b, ee = (k || P) && Y !== !1, Q = getTipFormatter(q, g), [J, te] = useRafLock(), ae = (xe) => {
    C?.(xe), te(!1);
  }, se = (xe, we) => xe || (we ? U ? "left" : "right" : "top"), ie = I("slider", c), [fe, ge, me] = useStyle$g(ie), pe = classnames(d, E, O.root, w?.root, p, {
    [`${ie}-rtl`]: U,
    [`${ie}-lock`]: J
  }, ge, me);
  U && !$.vertical && ($.reverse = !$.reverse), React.useEffect(() => {
    const xe = () => {
      wrapperRaf(() => {
        D(!1);
      }, 1);
    };
    return document.addEventListener("mouseup", xe), () => {
      document.removeEventListener("mouseup", xe);
    };
  }, []);
  const be = u && !Y, le = W || ((xe, we) => {
    const {
      index: $e
    } = we, Ae = xe.props;
    function ue(Te, ke, Re) {
      var Be, Oe, Me, Fe;
      Re && ((Oe = (Be = $)[Te]) === null || Oe === void 0 || Oe.call(Be, ke)), (Fe = (Me = Ae)[Te]) === null || Fe === void 0 || Fe.call(Me, ke);
    }
    const ce = Object.assign(Object.assign({}, Ae), {
      onMouseEnter: (Te) => {
        N(!0), ue("onMouseEnter", Te);
      },
      onMouseLeave: (Te) => {
        N(!1), ue("onMouseLeave", Te);
      },
      onMouseDown: (Te) => {
        D(!0), te(!0), ue("onMouseDown", Te);
      },
      onFocus: (Te) => {
        var ke;
        D(!0), (ke = $.onFocus) === null || ke === void 0 || ke.call($, Te), ue("onFocus", Te, !0);
      },
      onBlur: (Te) => {
        var ke;
        D(!1), (ke = $.onBlur) === null || ke === void 0 || ke.call($, Te), ue("onBlur", Te, !0);
      }
    }), Ee = /* @__PURE__ */ React.cloneElement(xe, ce), _e = (!!Y || ee) && Q !== null;
    return be ? Ee : /* @__PURE__ */ React.createElement(SliderTooltip, Object.assign({}, H, {
      prefixCls: I("tooltip", K ?? x),
      title: Q ? Q(we.value) : "",
      value: we.value,
      open: _e,
      placement: se(Z ?? f, T),
      key: $e,
      classNames: {
        root: `${ie}-tooltip`
      },
      getPopupContainer: ne || y || B
    }), Ee);
  }), ve = be ? (xe, we) => {
    const $e = /* @__PURE__ */ React.cloneElement(xe, {
      style: Object.assign(Object.assign({}, xe.props.style), {
        visibility: "hidden"
      })
    });
    return /* @__PURE__ */ React.createElement(SliderTooltip, Object.assign({}, H, {
      prefixCls: I("tooltip", K ?? x),
      title: Q ? Q(we.value) : "",
      open: Q !== null && ee,
      placement: se(Z ?? f, T),
      key: "tooltip",
      classNames: {
        root: `${ie}-tooltip`
      },
      getPopupContainer: ne || y || B,
      draggingDelete: we.draggingDelete
    }), $e);
  } : void 0, he = Object.assign(Object.assign(Object.assign(Object.assign({}, L.root), R), S?.root), v), ye = Object.assign(Object.assign({}, L.tracks), S?.tracks), Ce = classnames(O.tracks, w?.tracks);
  return fe(
    // @ts-ignore
    /* @__PURE__ */ React.createElement(Slider$2, Object.assign({}, $, {
      classNames: Object.assign({
        handle: classnames(O.handle, w?.handle),
        rail: classnames(O.rail, w?.rail),
        track: classnames(O.track, w?.track)
      }, Ce ? {
        tracks: Ce
      } : {}),
      styles: Object.assign({
        handle: Object.assign(Object.assign({}, L.handle), S?.handle),
        rail: Object.assign(Object.assign({}, L.rail), S?.rail),
        track: Object.assign(Object.assign({}, L.track), S?.track)
      }, Object.keys(ye).length ? {
        tracks: ye
      } : {}),
      step: $.step,
      range: u,
      className: pe,
      style: he,
      disabled: M,
      ref: s,
      prefixCls: ie,
      handleRender: le,
      activeHandleRender: ve,
      onChangeComplete: ae
    }))
  );
});
var CalendarOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" }, CalendarOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CalendarOutlined$1
  }));
}, RefIcon$w = /* @__PURE__ */ reactExports.forwardRef(CalendarOutlined), ClockCircleOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" }, ClockCircleOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: ClockCircleOutlined$1
  }));
}, RefIcon$v = /* @__PURE__ */ reactExports.forwardRef(ClockCircleOutlined), SwapRightOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" }, SwapRightOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: SwapRightOutlined$1
  }));
}, RefIcon$u = /* @__PURE__ */ reactExports.forwardRef(SwapRightOutlined);
function getPlaceholder(a, s, c) {
  return c !== void 0 ? c : s === "year" && a.lang.yearPlaceholder ? a.lang.yearPlaceholder : s === "quarter" && a.lang.quarterPlaceholder ? a.lang.quarterPlaceholder : s === "month" && a.lang.monthPlaceholder ? a.lang.monthPlaceholder : s === "week" && a.lang.weekPlaceholder ? a.lang.weekPlaceholder : s === "time" && a.timePickerLocale.placeholder ? a.timePickerLocale.placeholder : a.lang.placeholder;
}
function getRangePlaceholder(a, s, c) {
  return c !== void 0 ? c : s === "year" && a.lang.yearPlaceholder ? a.lang.rangeYearPlaceholder : s === "quarter" && a.lang.quarterPlaceholder ? a.lang.rangeQuarterPlaceholder : s === "month" && a.lang.monthPlaceholder ? a.lang.rangeMonthPlaceholder : s === "week" && a.lang.weekPlaceholder ? a.lang.rangeWeekPlaceholder : s === "time" && a.timePickerLocale.placeholder ? a.timePickerLocale.rangePlaceholder : a.lang.rangePlaceholder;
}
function useIcons(a, s) {
  const {
    allowClear: c = !0
  } = a, {
    clearIcon: u,
    removeIcon: d
  } = useIcons$1(Object.assign(Object.assign({}, a), {
    prefixCls: s,
    componentName: "DatePicker"
  }));
  return [reactExports.useMemo(() => c === !1 ? !1 : Object.assign({
    clearIcon: u
  }, c === !0 ? {} : c), [c, u]), d];
}
const [WEEK, WEEKPICKER] = ["week", "WeekPicker"], [MONTH, MONTHPICKER] = ["month", "MonthPicker"], [YEAR, YEARPICKER] = ["year", "YearPicker"], [QUARTER, QUARTERPICKER] = ["quarter", "QuarterPicker"], [TIME, TIMEPICKER] = ["time", "TimePicker"], PickerButton = (a) => /* @__PURE__ */ reactExports.createElement(Button$1, Object.assign({
  size: "small",
  type: "primary"
}, a));
function useComponents(a) {
  return reactExports.useMemo(() => Object.assign({
    button: PickerButton
  }, a), [a]);
}
function mergeClassNames(a, ...s) {
  const c = a || {};
  return s.reduce((u, d) => (Object.keys(d || {}).forEach((p) => {
    const v = c[p], A = d[p];
    if (v && typeof v == "object")
      if (A && typeof A == "object")
        u[p] = mergeClassNames(v, u[p], A);
      else {
        const {
          _default: x
        } = v;
        u[p] = u[p] || {}, u[p][x] = classnames(u[p][x], A);
      }
    else
      u[p] = classnames(u[p], A);
  }), u), {});
}
function useSemanticClassNames(a, ...s) {
  return reactExports.useMemo(() => mergeClassNames.apply(void 0, [a].concat(s)), [s]);
}
function useSemanticStyles(...a) {
  return reactExports.useMemo(() => a.reduce((s, c = {}) => (Object.keys(c).forEach((u) => {
    s[u] = Object.assign(Object.assign({}, s[u]), c[u]);
  }), s), {}), [a]);
}
function fillObjectBySchema(a, s) {
  const c = Object.assign({}, a);
  return Object.keys(s).forEach((u) => {
    if (u !== "_default") {
      const d = s[u], p = c[u] || {};
      c[u] = d ? fillObjectBySchema(p, d) : p;
    }
  }), c;
}
function useMergeSemantic(a, s, c) {
  const u = useSemanticClassNames.apply(void 0, [c].concat(_toConsumableArray$e(a))), d = useSemanticStyles.apply(void 0, _toConsumableArray$e(s));
  return reactExports.useMemo(() => [fillObjectBySchema(u, c), fillObjectBySchema(d, c)], [u, d]);
}
const useMergedPickerSemantic = (a, s, c, u, d) => {
  const {
    classNames: p,
    styles: v
  } = useComponentConfig(a), [A, x] = useMergeSemantic([p, s], [v, c], {
    popup: {
      _default: "root"
    }
  });
  return reactExports.useMemo(() => {
    var g, b;
    const y = Object.assign(Object.assign({}, A), {
      popup: Object.assign(Object.assign({}, A.popup), {
        root: classnames((g = A.popup) === null || g === void 0 ? void 0 : g.root, u)
      })
    }), f = Object.assign(Object.assign({}, x), {
      popup: Object.assign(Object.assign({}, x.popup), {
        root: Object.assign(Object.assign({}, (b = x.popup) === null || b === void 0 ? void 0 : b.root), d)
      })
    });
    return [y, f];
  }, [A, x, u, d]);
};
var __rest$B = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const generateRangePicker = (a) => /* @__PURE__ */ reactExports.forwardRef((c, u) => {
  var d;
  const {
    prefixCls: p,
    getPopupContainer: v,
    components: A,
    className: x,
    style: g,
    placement: b,
    size: y,
    disabled: f,
    bordered: m = !0,
    placeholder: C,
    popupStyle: w,
    popupClassName: S,
    dropdownClassName: $,
    status: T,
    rootClassName: I,
    variant: _,
    picker: E,
    styles: R,
    classNames: O
  } = c, L = __rest$B(c, ["prefixCls", "getPopupContainer", "components", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "status", "rootClassName", "variant", "picker", "styles", "classNames"]), B = E === TIME ? "timePicker" : "datePicker", F = reactExports.useRef(null), {
    getPrefixCls: M,
    direction: W,
    getPopupContainer: j,
    rangePicker: G
  } = reactExports.useContext(ConfigContext$1), U = M("picker", p), {
    compactSize: k,
    compactItemClassnames: N
  } = useCompactItemContext(U, W), P = M(), [D, H] = useVariant("rangePicker", _, m), V = useCSSVarCls(U), [Z, ne, K] = useStyle$m(U, V), [q, Y] = useMergedPickerSemantic(B, O, R, S || $, w), [ee] = useIcons(c, U), Q = useComponents(A), J = useSize((ve) => {
    var he;
    return (he = y ?? k) !== null && he !== void 0 ? he : ve;
  }), te = reactExports.useContext(DisabledContext), ae = f ?? te, se = reactExports.useContext(FormItemInputContext), {
    hasFeedback: ie,
    status: fe,
    feedbackIcon: ge
  } = se, me = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, E === TIME ? /* @__PURE__ */ reactExports.createElement(RefIcon$v, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$w, null), ie && ge);
  reactExports.useImperativeHandle(u, () => F.current);
  const [pe] = useLocale$1("Calendar", locale$1), be = Object.assign(Object.assign({}, pe), c.locale), [le] = useZIndex("DatePicker", (d = Y.popup.root) === null || d === void 0 ? void 0 : d.zIndex);
  return Z(/* @__PURE__ */ reactExports.createElement(ContextIsolator, {
    space: !0
  }, /* @__PURE__ */ reactExports.createElement(RefRangePicker, Object.assign({
    separator: /* @__PURE__ */ reactExports.createElement("span", {
      "aria-label": "to",
      className: `${U}-separator`
    }, /* @__PURE__ */ reactExports.createElement(RefIcon$u, null)),
    disabled: ae,
    ref: F,
    placement: b,
    placeholder: getRangePlaceholder(be, E, C),
    suffixIcon: me,
    prevIcon: /* @__PURE__ */ reactExports.createElement("span", {
      className: `${U}-prev-icon`
    }),
    nextIcon: /* @__PURE__ */ reactExports.createElement("span", {
      className: `${U}-next-icon`
    }),
    superPrevIcon: /* @__PURE__ */ reactExports.createElement("span", {
      className: `${U}-super-prev-icon`
    }),
    superNextIcon: /* @__PURE__ */ reactExports.createElement("span", {
      className: `${U}-super-next-icon`
    }),
    transitionName: `${P}-slide-up`,
    picker: E
  }, L, {
    className: classnames({
      [`${U}-${J}`]: J,
      [`${U}-${D}`]: H
    }, getStatusClassNames(U, getMergedStatus(fe, T), ie), ne, N, x, G?.className, K, V, I, q.root),
    style: Object.assign(Object.assign(Object.assign({}, G?.style), g), Y.root),
    locale: be.lang,
    prefixCls: U,
    getPopupContainer: v || j,
    generateConfig: a,
    components: Q,
    direction: W,
    classNames: {
      popup: classnames(ne, K, V, I, q.popup.root)
    },
    styles: {
      popup: Object.assign(Object.assign({}, Y.popup.root), {
        zIndex: le
      })
    },
    allowClear: ee
  }))));
});
var __rest$A = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const generatePicker$1 = (a) => {
  const s = (x, g) => {
    const b = g === TIMEPICKER ? "timePicker" : "datePicker";
    return /* @__PURE__ */ reactExports.forwardRef((f, m) => {
      var C;
      const {
        prefixCls: w,
        getPopupContainer: S,
        components: $,
        style: T,
        className: I,
        rootClassName: _,
        size: E,
        bordered: R,
        placement: O,
        placeholder: L,
        popupStyle: B,
        popupClassName: F,
        dropdownClassName: M,
        disabled: W,
        status: j,
        variant: G,
        onCalendarChange: U,
        styles: k,
        classNames: N
      } = f, P = __rest$A(f, ["prefixCls", "getPopupContainer", "components", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "disabled", "status", "variant", "onCalendarChange", "styles", "classNames"]), {
        getPrefixCls: D,
        direction: H,
        getPopupContainer: V,
        // Consume different styles according to different names
        [b]: Z
      } = reactExports.useContext(ConfigContext$1), ne = D("picker", w), {
        compactSize: K,
        compactItemClassnames: q
      } = useCompactItemContext(ne, H), Y = reactExports.useRef(null), [ee, Q] = useVariant("datePicker", G, R), J = useCSSVarCls(ne), [te, ae, se] = useStyle$m(ne, J);
      reactExports.useImperativeHandle(m, () => Y.current);
      const ie = {
        showToday: !0
      }, fe = x || f.picker, ge = D(), {
        onSelect: me,
        multiple: pe
      } = P, be = me && x === "time" && !pe, le = (Oe, Me, Fe) => {
        U?.(Oe, Me, Fe), be && me(Oe);
      }, [ve, he] = useMergedPickerSemantic(b, N, k, F || M, B), [ye, Ce] = useIcons(f, ne), xe = useComponents($), we = useSize((Oe) => {
        var Me;
        return (Me = E ?? K) !== null && Me !== void 0 ? Me : Oe;
      }), $e = reactExports.useContext(DisabledContext), Ae = W ?? $e, ue = reactExports.useContext(FormItemInputContext), {
        hasFeedback: ce,
        status: Ee,
        feedbackIcon: _e
      } = ue, Te = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, fe === "time" ? /* @__PURE__ */ reactExports.createElement(RefIcon$v, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$w, null), ce && _e), [ke] = useLocale$1("DatePicker", locale$1), Re = Object.assign(Object.assign({}, ke), f.locale), [Be] = useZIndex("DatePicker", (C = he.popup.root) === null || C === void 0 ? void 0 : C.zIndex);
      return te(/* @__PURE__ */ reactExports.createElement(ContextIsolator, {
        space: !0
      }, /* @__PURE__ */ reactExports.createElement(RefPicker, Object.assign({
        ref: Y,
        placeholder: getPlaceholder(Re, fe, L),
        suffixIcon: Te,
        placement: O,
        prevIcon: /* @__PURE__ */ reactExports.createElement("span", {
          className: `${ne}-prev-icon`
        }),
        nextIcon: /* @__PURE__ */ reactExports.createElement("span", {
          className: `${ne}-next-icon`
        }),
        superPrevIcon: /* @__PURE__ */ reactExports.createElement("span", {
          className: `${ne}-super-prev-icon`
        }),
        superNextIcon: /* @__PURE__ */ reactExports.createElement("span", {
          className: `${ne}-super-next-icon`
        }),
        transitionName: `${ge}-slide-up`,
        picker: x,
        onCalendarChange: le
      }, ie, P, {
        locale: Re.lang,
        className: classnames({
          [`${ne}-${we}`]: we,
          [`${ne}-${ee}`]: Q
        }, getStatusClassNames(ne, getMergedStatus(Ee, j), ce), ae, q, Z?.className, I, se, J, _, ve.root),
        style: Object.assign(Object.assign(Object.assign({}, Z?.style), T), he.root),
        prefixCls: ne,
        getPopupContainer: S || V,
        generateConfig: a,
        components: xe,
        direction: H,
        disabled: Ae,
        classNames: {
          popup: classnames(ae, se, J, _, ve.popup.root)
        },
        styles: {
          popup: Object.assign(Object.assign({}, he.popup.root), {
            zIndex: Be
          })
        },
        allowClear: ye,
        removeIcon: Ce
      }))));
    });
  }, c = s(), u = s(WEEK, WEEKPICKER), d = s(MONTH, MONTHPICKER), p = s(YEAR, YEARPICKER), v = s(QUARTER, QUARTERPICKER), A = s(TIME, TIMEPICKER);
  return {
    DatePicker: c,
    WeekPicker: u,
    MonthPicker: d,
    YearPicker: p,
    TimePicker: A,
    QuarterPicker: v
  };
}, generatePicker = (a) => {
  const {
    DatePicker: s,
    WeekPicker: c,
    MonthPicker: u,
    YearPicker: d,
    TimePicker: p,
    QuarterPicker: v
  } = generatePicker$1(a), A = generateRangePicker(a), x = s;
  return x.WeekPicker = c, x.MonthPicker = u, x.YearPicker = d, x.RangePicker = A, x.TimePicker = p, x.QuarterPicker = v, x;
};
var DrawerContext = /* @__PURE__ */ reactExports.createContext(null), RefContext = /* @__PURE__ */ reactExports.createContext({}), _excluded$l = ["prefixCls", "className", "containerRef"], DrawerPanel$1 = function a(s) {
  var c = s.prefixCls, u = s.className, d = s.containerRef, p = _objectWithoutProperties$2(s, _excluded$l), v = reactExports.useContext(RefContext), A = v.panel, x = useComposeRef(A, d);
  return /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    className: classnames("".concat(c, "-content"), u),
    role: "dialog",
    ref: x
  }, pickAttrs(s, {
    aria: !0
  }), {
    "aria-modal": "true"
  }, p));
};
function parseWidthHeight(a) {
  return typeof a == "string" && String(Number(a)) === a ? (warningOnce(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(a)) : a;
}
var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function DrawerPopup(a, s) {
  var c, u, d, p = a.prefixCls, v = a.open, A = a.placement, x = a.inline, g = a.push, b = a.forceRender, y = a.autoFocus, f = a.keyboard, m = a.classNames, C = a.rootClassName, w = a.rootStyle, S = a.zIndex, $ = a.className, T = a.id, I = a.style, _ = a.motion, E = a.width, R = a.height, O = a.children, L = a.mask, B = a.maskClosable, F = a.maskMotion, M = a.maskClassName, W = a.maskStyle, j = a.afterOpenChange, G = a.onClose, U = a.onMouseEnter, k = a.onMouseOver, N = a.onMouseLeave, P = a.onClick, D = a.onKeyDown, H = a.onKeyUp, V = a.styles, Z = a.drawerRender, ne = reactExports.useRef(), K = reactExports.useRef(), q = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return ne.current;
  });
  var Y = function(ye) {
    var Ce = ye.keyCode, xe = ye.shiftKey;
    switch (Ce) {
      // Tab active
      case KeyCode.TAB: {
        if (Ce === KeyCode.TAB) {
          if (!xe && document.activeElement === q.current) {
            var we;
            (we = K.current) === null || we === void 0 || we.focus({
              preventScroll: !0
            });
          } else if (xe && document.activeElement === K.current) {
            var $e;
            ($e = q.current) === null || $e === void 0 || $e.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      // Close
      case KeyCode.ESC: {
        G && f && (ye.stopPropagation(), G(ye));
        break;
      }
    }
  };
  reactExports.useEffect(function() {
    if (v && y) {
      var he;
      (he = ne.current) === null || he === void 0 || he.focus({
        preventScroll: !0
      });
    }
  }, [v]);
  var ee = reactExports.useState(!1), Q = _slicedToArray$e(ee, 2), J = Q[0], te = Q[1], ae = reactExports.useContext(DrawerContext), se;
  typeof g == "boolean" ? se = g ? {} : {
    distance: 0
  } : se = g || {};
  var ie = (c = (u = (d = se) === null || d === void 0 ? void 0 : d.distance) !== null && u !== void 0 ? u : ae?.pushDistance) !== null && c !== void 0 ? c : 180, fe = reactExports.useMemo(function() {
    return {
      pushDistance: ie,
      push: function() {
        te(!0);
      },
      pull: function() {
        te(!1);
      }
    };
  }, [ie]);
  reactExports.useEffect(function() {
    if (v) {
      var he;
      ae == null || (he = ae.push) === null || he === void 0 || he.call(ae);
    } else {
      var ye;
      ae == null || (ye = ae.pull) === null || ye === void 0 || ye.call(ae);
    }
  }, [v]), reactExports.useEffect(function() {
    return function() {
      var he;
      ae == null || (he = ae.pull) === null || he === void 0 || he.call(ae);
    };
  }, []);
  var ge = /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$3({
    key: "mask"
  }, F, {
    visible: L && v
  }), function(he, ye) {
    var Ce = he.className, xe = he.style;
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(p, "-mask"), Ce, m?.mask, M),
      style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, xe), W), V?.mask),
      onClick: B && v ? G : void 0,
      ref: ye
    });
  }), me = typeof _ == "function" ? _(A) : _, pe = {};
  if (J && ie)
    switch (A) {
      case "top":
        pe.transform = "translateY(".concat(ie, "px)");
        break;
      case "bottom":
        pe.transform = "translateY(".concat(-ie, "px)");
        break;
      case "left":
        pe.transform = "translateX(".concat(ie, "px)");
        break;
      default:
        pe.transform = "translateX(".concat(-ie, "px)");
        break;
    }
  A === "left" || A === "right" ? pe.width = parseWidthHeight(E) : pe.height = parseWidthHeight(R);
  var be = {
    onMouseEnter: U,
    onMouseOver: k,
    onMouseLeave: N,
    onClick: P,
    onKeyDown: D,
    onKeyUp: H
  }, le = /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$3({
    key: "panel"
  }, me, {
    visible: v,
    forceRender: b,
    onVisibleChanged: function(ye) {
      j?.(ye);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(p, "-content-wrapper-hidden")
  }), function(he, ye) {
    var Ce = he.className, xe = he.style, we = /* @__PURE__ */ reactExports.createElement(DrawerPanel$1, _extends$3({
      id: T,
      containerRef: ye,
      prefixCls: p,
      className: classnames($, m?.content),
      style: _objectSpread2$1(_objectSpread2$1({}, I), V?.content)
    }, pickAttrs(a, {
      aria: !0
    }), be), O);
    return /* @__PURE__ */ reactExports.createElement("div", _extends$3({
      className: classnames("".concat(p, "-content-wrapper"), m?.wrapper, Ce),
      style: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, pe), xe), V?.wrapper)
    }, pickAttrs(a, {
      data: !0
    })), Z ? Z(we) : we);
  }), ve = _objectSpread2$1({}, w);
  return S && (ve.zIndex = S), /* @__PURE__ */ reactExports.createElement(DrawerContext.Provider, {
    value: fe
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(p, "".concat(p, "-").concat(A), C, _defineProperty$a(_defineProperty$a({}, "".concat(p, "-open"), v), "".concat(p, "-inline"), x)),
    style: ve,
    tabIndex: -1,
    ref: ne,
    onKeyDown: Y
  }, ge, /* @__PURE__ */ reactExports.createElement("div", {
    tabIndex: 0,
    ref: K,
    style: sentinelStyle,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), le, /* @__PURE__ */ reactExports.createElement("div", {
    tabIndex: 0,
    ref: q,
    style: sentinelStyle,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var RefDrawerPopup = /* @__PURE__ */ reactExports.forwardRef(DrawerPopup), Drawer$1 = function a(s) {
  var c = s.open, u = c === void 0 ? !1 : c, d = s.prefixCls, p = d === void 0 ? "rc-drawer" : d, v = s.placement, A = v === void 0 ? "right" : v, x = s.autoFocus, g = x === void 0 ? !0 : x, b = s.keyboard, y = b === void 0 ? !0 : b, f = s.width, m = f === void 0 ? 378 : f, C = s.mask, w = C === void 0 ? !0 : C, S = s.maskClosable, $ = S === void 0 ? !0 : S, T = s.getContainer, I = s.forceRender, _ = s.afterOpenChange, E = s.destroyOnClose, R = s.onMouseEnter, O = s.onMouseOver, L = s.onMouseLeave, B = s.onClick, F = s.onKeyDown, M = s.onKeyUp, W = s.panelRef, j = reactExports.useState(!1), G = _slicedToArray$e(j, 2), U = G[0], k = G[1], N = reactExports.useState(!1), P = _slicedToArray$e(N, 2), D = P[0], H = P[1];
  useLayoutEffect$1(function() {
    H(!0);
  }, []);
  var V = D ? u : !1, Z = reactExports.useRef(), ne = reactExports.useRef();
  useLayoutEffect$1(function() {
    V && (ne.current = document.activeElement);
  }, [V]);
  var K = function(J) {
    var te;
    if (k(J), _?.(J), !J && ne.current && !((te = Z.current) !== null && te !== void 0 && te.contains(ne.current))) {
      var ae;
      (ae = ne.current) === null || ae === void 0 || ae.focus({
        preventScroll: !0
      });
    }
  }, q = reactExports.useMemo(function() {
    return {
      panel: W
    };
  }, [W]);
  if (!I && !U && !V && E)
    return null;
  var Y = {
    onMouseEnter: R,
    onMouseOver: O,
    onMouseLeave: L,
    onClick: B,
    onKeyDown: F,
    onKeyUp: M
  }, ee = _objectSpread2$1(_objectSpread2$1({}, s), {}, {
    open: V,
    prefixCls: p,
    placement: A,
    autoFocus: g,
    keyboard: y,
    width: m,
    mask: w,
    maskClosable: $,
    inline: T === !1,
    afterOpenChange: K,
    ref: Z
  }, Y);
  return /* @__PURE__ */ reactExports.createElement(RefContext.Provider, {
    value: q
  }, /* @__PURE__ */ reactExports.createElement(Portal, {
    open: V || I || U,
    autoDestroy: !1,
    getContainer: T,
    autoLock: w && (V || U)
  }, /* @__PURE__ */ reactExports.createElement(RefDrawerPopup, ee)));
};
const DrawerPanel = (a) => {
  var s, c;
  const {
    prefixCls: u,
    title: d,
    footer: p,
    extra: v,
    loading: A,
    onClose: x,
    headerStyle: g,
    bodyStyle: b,
    footerStyle: y,
    children: f,
    classNames: m,
    styles: C
  } = a, w = useComponentConfig("drawer"), S = reactExports.useCallback((E) => /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: x,
    className: `${u}-close`
  }, E), [x]), [$, T] = useClosable(pickClosable(a), pickClosable(w), {
    closable: !0,
    closeIconRender: S
  }), I = reactExports.useMemo(() => {
    var E, R;
    return !d && !$ ? null : /* @__PURE__ */ reactExports.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (E = w.styles) === null || E === void 0 ? void 0 : E.header), g), C?.header),
      className: classnames(`${u}-header`, {
        [`${u}-header-close-only`]: $ && !d && !v
      }, (R = w.classNames) === null || R === void 0 ? void 0 : R.header, m?.header)
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: `${u}-header-title`
    }, T, d && /* @__PURE__ */ reactExports.createElement("div", {
      className: `${u}-title`
    }, d)), v && /* @__PURE__ */ reactExports.createElement("div", {
      className: `${u}-extra`
    }, v));
  }, [$, T, v, g, u, d]), _ = reactExports.useMemo(() => {
    var E, R;
    if (!p)
      return null;
    const O = `${u}-footer`;
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames(O, (E = w.classNames) === null || E === void 0 ? void 0 : E.footer, m?.footer),
      style: Object.assign(Object.assign(Object.assign({}, (R = w.styles) === null || R === void 0 ? void 0 : R.footer), y), C?.footer)
    }, p);
  }, [p, y, u]);
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, I, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${u}-body`, m?.body, (s = w.classNames) === null || s === void 0 ? void 0 : s.body),
    style: Object.assign(Object.assign(Object.assign({}, (c = w.styles) === null || c === void 0 ? void 0 : c.body), b), C?.body)
  }, A ? /* @__PURE__ */ reactExports.createElement(Skeleton, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 5
    },
    className: `${u}-body-skeleton`
  }) : f), _);
}, getMoveTranslate = (a) => {
  const s = "100%";
  return {
    left: `translateX(-${s})`,
    right: `translateX(${s})`,
    top: `translateY(-${s})`,
    bottom: `translateY(${s})`
  }[a];
}, getEnterLeaveStyle = (a, s) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, a), {
    "&-active": s
  }),
  "&-leave": Object.assign(Object.assign({}, s), {
    "&-active": a
  })
}), getFadeStyle = (a, s) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${s}`
    }
  }
}, getEnterLeaveStyle({
  opacity: a
}, {
  opacity: 1
})), getPanelMotionStyles = (a, s) => [getFadeStyle(0.7, s), getEnterLeaveStyle({
  transform: getMoveTranslate(a)
}, {
  transform: "none"
})], genMotionStyle$1 = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: c
  } = a;
  return {
    [s]: {
      // ======================== Mask ========================
      [`${s}-mask-motion`]: getFadeStyle(0, c),
      // ======================= Panel ========================
      [`${s}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((u, d) => Object.assign(Object.assign({}, u), {
        [`&-${d}`]: getPanelMotionStyles(d, c)
      }), {})
    }
  };
}, genDrawerStyle = (a) => {
  const {
    borderRadiusSM: s,
    componentCls: c,
    zIndexPopup: u,
    colorBgMask: d,
    colorBgElevated: p,
    motionDurationSlow: v,
    motionDurationMid: A,
    paddingXS: x,
    padding: g,
    paddingLG: b,
    fontSizeLG: y,
    lineHeightLG: f,
    lineWidth: m,
    lineType: C,
    colorSplit: w,
    marginXS: S,
    colorIcon: $,
    colorIconHover: T,
    colorBgTextHover: I,
    colorBgTextActive: _,
    colorText: E,
    fontWeightStrong: R,
    footerPaddingBlock: O,
    footerPaddingInline: L,
    calc: B
  } = a, F = `${c}-content-wrapper`;
  return {
    [c]: {
      position: "fixed",
      inset: 0,
      zIndex: u,
      pointerEvents: "none",
      color: E,
      "&-pure": {
        position: "relative",
        background: p,
        display: "flex",
        flexDirection: "column",
        [`&${c}-left`]: {
          boxShadow: a.boxShadowDrawerLeft
        },
        [`&${c}-right`]: {
          boxShadow: a.boxShadowDrawerRight
        },
        [`&${c}-top`]: {
          boxShadow: a.boxShadowDrawerUp
        },
        [`&${c}-bottom`]: {
          boxShadow: a.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${c}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: u,
        background: d,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [F]: {
        position: "absolute",
        zIndex: u,
        maxWidth: "100vw",
        transition: `all ${v}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${F}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: a.boxShadowDrawerLeft
      },
      [`&-right > ${F}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: a.boxShadowDrawerRight
      },
      [`&-top > ${F}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: a.boxShadowDrawerUp
      },
      [`&-bottom > ${F}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: a.boxShadowDrawerDown
      },
      [`${c}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: p,
        pointerEvents: "auto"
      },
      // Header
      [`${c}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${unit$1(g)} ${unit$1(b)}`,
        fontSize: y,
        lineHeight: f,
        borderBottom: `${unit$1(m)} ${C} ${w}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${c}-extra`]: {
        flex: "none"
      },
      [`${c}-close`]: Object.assign({
        display: "inline-flex",
        width: B(y).add(x).equal(),
        height: B(y).add(x).equal(),
        borderRadius: s,
        justifyContent: "center",
        alignItems: "center",
        marginInlineEnd: S,
        color: $,
        fontWeight: R,
        fontSize: y,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        cursor: "pointer",
        transition: `all ${A}`,
        textRendering: "auto",
        "&:hover": {
          color: T,
          backgroundColor: I,
          textDecoration: "none"
        },
        "&:active": {
          backgroundColor: _
        }
      }, genFocusStyle(a)),
      [`${c}-title`]: {
        flex: 1,
        margin: 0,
        fontWeight: a.fontWeightStrong,
        fontSize: y,
        lineHeight: f
      },
      // Body
      [`${c}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: b,
        overflow: "auto",
        [`${c}-body-skeleton`]: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center"
        }
      },
      // Footer
      [`${c}-footer`]: {
        flexShrink: 0,
        padding: `${unit$1(O)} ${unit$1(L)}`,
        borderTop: `${unit$1(m)} ${C} ${w}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, prepareComponentToken$d = (a) => ({
  zIndexPopup: a.zIndexPopupBase,
  footerPaddingBlock: a.paddingXS,
  footerPaddingInline: a.padding
}), useStyle$f = genStyleHooks("Drawer", (a) => {
  const s = merge(a, {});
  return [genDrawerStyle(s), genMotionStyle$1(s)];
}, prepareComponentToken$d);
var __rest$z = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const defaultPushState = {
  distance: 180
}, Drawer = (a) => {
  const {
    rootClassName: s,
    width: c,
    height: u,
    size: d = "default",
    mask: p = !0,
    push: v = defaultPushState,
    open: A,
    afterOpenChange: x,
    onClose: g,
    prefixCls: b,
    getContainer: y,
    style: f,
    className: m,
    // Deprecated
    visible: C,
    afterVisibleChange: w,
    maskStyle: S,
    drawerStyle: $,
    contentWrapperStyle: T,
    destroyOnClose: I,
    destroyOnHidden: _
  } = a, E = __rest$z(a, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle", "destroyOnClose", "destroyOnHidden"]), {
    getPopupContainer: R,
    getPrefixCls: O,
    direction: L,
    className: B,
    style: F,
    classNames: M,
    styles: W
  } = useComponentConfig("drawer"), j = O("drawer", b), [G, U, k] = useStyle$f(j), N = (
    // 有可能为 false，所以不能直接判断
    y === void 0 && R ? () => R(document.body) : y
  ), P = classnames({
    "no-mask": !p,
    [`${j}-rtl`]: L === "rtl"
  }, s, U, k), D = reactExports.useMemo(() => c ?? (d === "large" ? 736 : 378), [c, d]), H = reactExports.useMemo(() => u ?? (d === "large" ? 736 : 378), [u, d]), V = {
    motionName: getTransitionName$1(j, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, Z = (Q) => ({
    motionName: getTransitionName$1(j, `panel-motion-${Q}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), ne = usePanelRef(), [K, q] = useZIndex("Drawer", E.zIndex), {
    classNames: Y = {},
    styles: ee = {}
  } = E;
  return G(/* @__PURE__ */ reactExports.createElement(ContextIsolator, {
    form: !0,
    space: !0
  }, /* @__PURE__ */ reactExports.createElement(zIndexContext.Provider, {
    value: q
  }, /* @__PURE__ */ reactExports.createElement(Drawer$1, Object.assign({
    prefixCls: j,
    onClose: g,
    maskMotion: V,
    motion: Z
  }, E, {
    classNames: {
      mask: classnames(Y.mask, M.mask),
      content: classnames(Y.content, M.content),
      wrapper: classnames(Y.wrapper, M.wrapper)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, ee.mask), S), W.mask),
      content: Object.assign(Object.assign(Object.assign({}, ee.content), $), W.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, ee.wrapper), T), W.wrapper)
    },
    open: A ?? C,
    mask: p,
    push: v,
    width: D,
    height: H,
    style: Object.assign(Object.assign({}, F), f),
    className: classnames(B, m),
    rootClassName: P,
    getContainer: N,
    afterOpenChange: x ?? w,
    panelRef: ne,
    zIndex: K,
    // TODO: In the future, destroyOnClose in rc-drawer needs to be upgrade to destroyOnHidden
    destroyOnClose: _ ?? I
  }), /* @__PURE__ */ reactExports.createElement(DrawerPanel, Object.assign({
    prefixCls: j
  }, E, {
    onClose: g
  }))))));
}, PurePanel$2 = (a) => {
  const {
    prefixCls: s,
    style: c,
    className: u,
    placement: d = "right"
  } = a, p = __rest$z(a, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: v
  } = reactExports.useContext(ConfigContext$1), A = v("drawer", s), [x, g, b] = useStyle$f(A), y = classnames(A, `${A}-pure`, `${A}-${d}`, g, b, u);
  return x(/* @__PURE__ */ reactExports.createElement("div", {
    className: y,
    style: c
  }, /* @__PURE__ */ reactExports.createElement(DrawerPanel, Object.assign({
    prefixCls: A
  }, p))));
};
Drawer._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$2;
function isPresetSize(a) {
  return ["small", "middle", "large"].includes(a);
}
function isValidGapNumber(a) {
  return a ? typeof a == "number" && !Number.isNaN(a) : !1;
}
const SpaceContext = /* @__PURE__ */ React.createContext({
  latestIndex: 0
}), SpaceContextProvider = SpaceContext.Provider, Item$1 = ({
  className: a,
  index: s,
  children: c,
  split: u,
  style: d
}) => {
  const {
    latestIndex: p
  } = reactExports.useContext(SpaceContext);
  return c == null ? null : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("div", {
    className: a,
    style: d
  }, c), s < p && u && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${a}-split`
  }, u));
};
var __rest$y = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalSpace = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var c;
  const {
    getPrefixCls: u,
    direction: d,
    size: p,
    className: v,
    style: A,
    classNames: x,
    styles: g
  } = useComponentConfig("space"), {
    size: b = p ?? "small",
    align: y,
    className: f,
    rootClassName: m,
    children: C,
    direction: w = "horizontal",
    prefixCls: S,
    split: $,
    style: T,
    wrap: I = !1,
    classNames: _,
    styles: E
  } = a, R = __rest$y(a, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [O, L] = Array.isArray(b) ? b : [b, b], B = isPresetSize(L), F = isPresetSize(O), M = isValidGapNumber(L), W = isValidGapNumber(O), j = toArray$8(C, {
    keepEmpty: !0
  }), G = y === void 0 && w === "horizontal" ? "center" : y, U = u("space", S), [k, N, P] = useStyle$x(U), D = classnames(U, v, N, `${U}-${w}`, {
    [`${U}-rtl`]: d === "rtl",
    [`${U}-align-${G}`]: G,
    [`${U}-gap-row-${L}`]: B,
    [`${U}-gap-col-${O}`]: F
  }, f, m, P), H = classnames(`${U}-item`, (c = _?.item) !== null && c !== void 0 ? c : x.item);
  let V = 0;
  const Z = j.map((q, Y) => {
    var ee;
    q != null && (V = Y);
    const Q = q?.key || `${H}-${Y}`;
    return /* @__PURE__ */ reactExports.createElement(Item$1, {
      className: H,
      key: Q,
      index: Y,
      split: $,
      style: (ee = E?.item) !== null && ee !== void 0 ? ee : g.item
    }, q);
  }), ne = reactExports.useMemo(() => ({
    latestIndex: V
  }), [V]);
  if (j.length === 0)
    return null;
  const K = {};
  return I && (K.flexWrap = "wrap"), !F && W && (K.columnGap = O), !B && M && (K.rowGap = L), k(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    ref: s,
    className: D,
    style: Object.assign(Object.assign(Object.assign({}, K), A), T)
  }, R), /* @__PURE__ */ reactExports.createElement(SpaceContextProvider, {
    value: ne
  }, Z)));
}), Space = InternalSpace;
Space.Compact = Compact$1;
var __rest$x = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const DropdownButton = (a) => {
  const {
    getPopupContainer: s,
    getPrefixCls: c,
    direction: u
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: d,
    type: p = "default",
    danger: v,
    disabled: A,
    loading: x,
    onClick: g,
    htmlType: b,
    children: y,
    className: f,
    menu: m,
    arrow: C,
    autoFocus: w,
    overlay: S,
    trigger: $,
    align: T,
    open: I,
    onOpenChange: _,
    placement: E,
    getPopupContainer: R,
    href: O,
    icon: L = /* @__PURE__ */ reactExports.createElement(RefIcon$z, null),
    title: B,
    buttonsRender: F = (ae) => ae,
    mouseEnterDelay: M,
    mouseLeaveDelay: W,
    overlayClassName: j,
    overlayStyle: G,
    destroyOnHidden: U,
    destroyPopupOnHide: k,
    dropdownRender: N,
    popupRender: P
  } = a, D = __rest$x(a, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyOnHidden", "destroyPopupOnHide", "dropdownRender", "popupRender"]), H = c("dropdown", d), V = `${H}-button`, ne = {
    menu: m,
    arrow: C,
    autoFocus: w,
    align: T,
    disabled: A,
    trigger: A ? [] : $,
    onOpenChange: _,
    getPopupContainer: R || s,
    mouseEnterDelay: M,
    mouseLeaveDelay: W,
    overlayClassName: j,
    overlayStyle: G,
    destroyOnHidden: U,
    popupRender: P || N
  }, {
    compactSize: K,
    compactItemClassnames: q
  } = useCompactItemContext(H, u), Y = classnames(V, q, f);
  "destroyPopupOnHide" in a && (ne.destroyPopupOnHide = k), "overlay" in a && (ne.overlay = S), "open" in a && (ne.open = I), "placement" in a ? ne.placement = E : ne.placement = u === "rtl" ? "bottomLeft" : "bottomRight";
  const ee = /* @__PURE__ */ reactExports.createElement(Button$1, {
    type: p,
    danger: v,
    disabled: A,
    loading: x,
    onClick: g,
    htmlType: b,
    href: O,
    title: B
  }, y), Q = /* @__PURE__ */ reactExports.createElement(Button$1, {
    type: p,
    danger: v,
    icon: L
  }), [J, te] = F([ee, Q]);
  return /* @__PURE__ */ reactExports.createElement(Space.Compact, Object.assign({
    className: Y,
    size: K,
    block: !0
  }, D), J, /* @__PURE__ */ reactExports.createElement(Dropdown$1, Object.assign({}, ne), te));
};
DropdownButton.__ANT_BUTTON = !0;
const Dropdown = Dropdown$1;
Dropdown.Button = DropdownButton;
function convertToTooltipProps(a) {
  return a == null ? null : typeof a == "object" && !/* @__PURE__ */ reactExports.isValidElement(a) ? a : {
    title: a
  };
}
function useDebounce(a) {
  const [s, c] = reactExports.useState(a);
  return reactExports.useEffect(() => {
    const u = setTimeout(() => {
      c(a);
    }, a.length ? 0 : 10);
    return () => {
      clearTimeout(u);
    };
  }, [a]), s;
}
const genFormValidateMotionStyle = (a) => {
  const {
    componentCls: s
  } = a, c = `${s}-show-help`, u = `${s}-show-help-item`;
  return {
    [c]: {
      // Explain holder
      transition: `opacity ${a.motionDurationFast} ${a.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [u]: {
        overflow: "hidden",
        transition: `height ${a.motionDurationFast} ${a.motionEaseInOut},
                     opacity ${a.motionDurationFast} ${a.motionEaseInOut},
                     transform ${a.motionDurationFast} ${a.motionEaseInOut} !important`,
        [`&${u}-appear, &${u}-enter`]: {
          transform: "translateY(-5px)",
          opacity: 0,
          "&-active": {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${u}-leave-active`]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
}, resetForm = (a) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: a.marginLG,
    padding: 0,
    color: a.colorTextDescription,
    fontSize: a.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  "input[type='file']:focus,\n  input[type='radio']:focus,\n  input[type='checkbox']:focus": {
    outline: 0,
    boxShadow: `0 0 0 ${unit$1(a.controlOutlineWidth)} ${a.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: a.colorText,
    fontSize: a.fontSize,
    lineHeight: a.lineHeight
  }
}), genFormSize = (a, s) => {
  const {
    formItemCls: c
  } = a;
  return {
    [c]: {
      [`${c}-label > label`]: {
        height: s
      },
      [`${c}-control-input`]: {
        minHeight: s
      }
    }
  };
}, genFormStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [a.componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(a)), resetForm(a)), {
      [`${s}-text`]: {
        display: "inline-block",
        paddingInlineEnd: a.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": Object.assign({}, genFormSize(a, a.controlHeightSM)),
      "&-large": Object.assign({}, genFormSize(a, a.controlHeightLG))
    })
  };
}, genFormItemStyle = (a) => {
  const {
    formItemCls: s,
    iconCls: c,
    rootPrefixCls: u,
    antCls: d,
    labelRequiredMarkColor: p,
    labelColor: v,
    labelFontSize: A,
    labelHeight: x,
    labelColonMarginInlineStart: g,
    labelColonMarginInlineEnd: b,
    itemMarginBottom: y
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      marginBottom: y,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden${d}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${s}-split`]: {
          color: a.colorError
        }
      },
      "&-has-error": {
        [`${s}-split`]: {
          color: a.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${s}-label`]: {
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: a.lineHeight,
          whiteSpace: "unset",
          "> label": {
            verticalAlign: "middle",
            textWrap: "balance"
          }
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: x,
          color: v,
          fontSize: A,
          [`> ${c}`]: {
            fontSize: a.fontSize,
            verticalAlign: "top"
          },
          [`&${s}-required`]: {
            "&::before": {
              display: "inline-block",
              marginInlineEnd: a.marginXXS,
              color: p,
              fontSize: a.fontSize,
              fontFamily: "SimSun, sans-serif",
              lineHeight: 1,
              content: '"*"'
            },
            [`&${s}-required-mark-hidden, &${s}-required-mark-optional`]: {
              "&::before": {
                display: "none"
              }
            }
          },
          // Optional mark
          [`${s}-optional`]: {
            display: "inline-block",
            marginInlineStart: a.marginXXS,
            color: a.colorTextDescription,
            [`&${s}-required-mark-hidden`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${s}-tooltip`]: {
            color: a.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: a.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: g,
            marginInlineEnd: b
          },
          [`&${s}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${s}-control`]: {
        "--ant-display": "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${u}-col-'"]):not([class*="' ${u}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: a.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%",
            // Fix https://github.com/ant-design/ant-design/issues/54042
            // Remove impact of whitespaces
            [`&:has(> ${d}-switch:only-child, > ${d}-rate:only-child)`]: {
              display: "flex",
              alignItems: "center"
            }
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [s]: {
        "&-additional": {
          display: "flex",
          flexDirection: "column"
        },
        "&-explain, &-extra": {
          clear: "both",
          color: a.colorTextDescription,
          fontSize: a.fontSize,
          lineHeight: a.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: a.controlHeightSM,
          transition: `color ${a.motionDurationMid} ${a.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: a.colorError
          },
          "&-warning": {
            color: a.colorWarning
          }
        }
      },
      [`&-with-help ${s}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${s}-feedback-icon`]: {
        fontSize: a.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: zoomIn,
        animationDuration: a.motionDurationMid,
        animationTimingFunction: a.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: a.colorSuccess
        },
        "&-error": {
          color: a.colorError
        },
        "&-warning": {
          color: a.colorWarning
        },
        "&-validating": {
          color: a.colorPrimary
        }
      }
    })
  };
}, genHorizontalStyle = (a, s) => {
  const {
    formItemCls: c
  } = a;
  return {
    [`${s}-horizontal`]: {
      [`${c}-label`]: {
        flexGrow: 0
      },
      [`${c}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${c}-label[class$='-24'], ${c}-label[class*='-24 ']`]: {
        [`& + ${c}-control`]: {
          minWidth: "unset"
        }
      }
    }
  };
}, genInlineStyle = (a) => {
  const {
    componentCls: s,
    formItemCls: c,
    inlineItemMarginBottom: u
  } = a;
  return {
    [`${s}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [c]: {
        flex: "none",
        marginInlineEnd: a.margin,
        marginBottom: u,
        "&-row": {
          flexWrap: "nowrap"
        },
        [`> ${c}-label,
        > ${c}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${c}-label`]: {
          flex: "none"
        },
        [`${s}-text`]: {
          display: "inline-block"
        },
        [`${c}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
}, makeVerticalLayoutLabel = (a) => ({
  padding: a.verticalLabelPadding,
  margin: a.verticalLabelMargin,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: "hidden"
    }
  }
}), makeVerticalLayout = (a) => {
  const {
    componentCls: s,
    formItemCls: c,
    rootPrefixCls: u
  } = a;
  return {
    [`${c} ${c}-label`]: makeVerticalLayoutLabel(a),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${s}:not(${s}-inline)`]: {
      [c]: {
        flexWrap: "wrap",
        [`${c}-label, ${c}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${u}-col-xs"])`]: {
            flex: "0 0 100%",
            maxWidth: "100%"
          }
        }
      }
    }
  };
}, genVerticalStyle = (a) => {
  const {
    componentCls: s,
    formItemCls: c,
    antCls: u
  } = a;
  return {
    [`${s}-vertical`]: {
      [`${c}:not(${c}-horizontal)`]: {
        [`${c}-row`]: {
          flexDirection: "column"
        },
        [`${c}-label > label`]: {
          height: "auto"
        },
        [`${c}-control`]: {
          width: "100%"
        },
        [`${c}-label,
        ${u}-col-24${c}-label,
        ${u}-col-xl-24${c}-label`]: makeVerticalLayoutLabel(a)
      }
    },
    [`@media (max-width: ${unit$1(a.screenXSMax)})`]: [makeVerticalLayout(a), {
      [s]: {
        [`${c}:not(${c}-horizontal)`]: {
          [`${u}-col-xs-24${c}-label`]: makeVerticalLayoutLabel(a)
        }
      }
    }],
    [`@media (max-width: ${unit$1(a.screenSMMax)})`]: {
      [s]: {
        [`${c}:not(${c}-horizontal)`]: {
          [`${u}-col-sm-24${c}-label`]: makeVerticalLayoutLabel(a)
        }
      }
    },
    [`@media (max-width: ${unit$1(a.screenMDMax)})`]: {
      [s]: {
        [`${c}:not(${c}-horizontal)`]: {
          [`${u}-col-md-24${c}-label`]: makeVerticalLayoutLabel(a)
        }
      }
    },
    [`@media (max-width: ${unit$1(a.screenLGMax)})`]: {
      [s]: {
        [`${c}:not(${c}-horizontal)`]: {
          [`${u}-col-lg-24${c}-label`]: makeVerticalLayoutLabel(a)
        }
      }
    }
  };
}, genItemVerticalStyle = (a) => {
  const {
    formItemCls: s,
    antCls: c
  } = a;
  return {
    [`${s}-vertical`]: {
      [`${s}-row`]: {
        flexDirection: "column"
      },
      [`${s}-label > label`]: {
        height: "auto"
      },
      [`${s}-control`]: {
        width: "100%"
      }
    },
    [`${s}-vertical ${s}-label,
      ${c}-col-24${s}-label,
      ${c}-col-xl-24${s}-label`]: makeVerticalLayoutLabel(a),
    [`@media (max-width: ${unit$1(a.screenXSMax)})`]: [makeVerticalLayout(a), {
      [s]: {
        [`${c}-col-xs-24${s}-label`]: makeVerticalLayoutLabel(a)
      }
    }],
    [`@media (max-width: ${unit$1(a.screenSMMax)})`]: {
      [s]: {
        [`${c}-col-sm-24${s}-label`]: makeVerticalLayoutLabel(a)
      }
    },
    [`@media (max-width: ${unit$1(a.screenMDMax)})`]: {
      [s]: {
        [`${c}-col-md-24${s}-label`]: makeVerticalLayoutLabel(a)
      }
    },
    [`@media (max-width: ${unit$1(a.screenLGMax)})`]: {
      [s]: {
        [`${c}-col-lg-24${s}-label`]: makeVerticalLayoutLabel(a)
      }
    }
  };
}, prepareComponentToken$c = (a) => ({
  labelRequiredMarkColor: a.colorError,
  labelColor: a.colorTextHeading,
  labelFontSize: a.fontSize,
  labelHeight: a.controlHeight,
  labelColonMarginInlineStart: a.marginXXS / 2,
  labelColonMarginInlineEnd: a.marginXS,
  itemMarginBottom: a.marginLG,
  verticalLabelPadding: `0 0 ${a.paddingXS}px`,
  verticalLabelMargin: 0,
  inlineItemMarginBottom: 0
}), prepareToken$1 = (a, s) => merge(a, {
  formItemCls: `${a.componentCls}-item`,
  rootPrefixCls: s
}), useStyle$e = genStyleHooks("Form", (a, {
  rootPrefixCls: s
}) => {
  const c = prepareToken$1(a, s);
  return [genFormStyle(c), genFormItemStyle(c), genFormValidateMotionStyle(c), genHorizontalStyle(c, c.componentCls), genHorizontalStyle(c, c.formItemCls), genInlineStyle(c), genVerticalStyle(c), genItemVerticalStyle(c), genCollapseMotion(c), zoomIn];
}, prepareComponentToken$c, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1e3
}), EMPTY_LIST$2 = [];
function toErrorEntity(a, s, c, u = 0) {
  return {
    key: typeof a == "string" ? a : `${s}-${u}`,
    error: a,
    errorStatus: c
  };
}
const ErrorList = ({
  help: a,
  helpStatus: s,
  errors: c = EMPTY_LIST$2,
  warnings: u = EMPTY_LIST$2,
  className: d,
  fieldId: p,
  onVisibleChanged: v
}) => {
  const {
    prefixCls: A
  } = reactExports.useContext(FormItemPrefixContext), x = `${A}-item-explain`, g = useCSSVarCls(A), [b, y, f] = useStyle$e(A, g), m = reactExports.useMemo(() => initCollapseMotion(A), [A]), C = useDebounce(c), w = useDebounce(u), S = reactExports.useMemo(() => a != null ? [toErrorEntity(a, "help", s)] : [].concat(_toConsumableArray$e(C.map((I, _) => toErrorEntity(I, "error", "error", _))), _toConsumableArray$e(w.map((I, _) => toErrorEntity(I, "warning", "warning", _)))), [a, s, C, w]), $ = reactExports.useMemo(() => {
    const I = {};
    return S.forEach(({
      key: _
    }) => {
      I[_] = (I[_] || 0) + 1;
    }), S.map((_, E) => Object.assign(Object.assign({}, _), {
      key: I[_.key] > 1 ? `${_.key}-fallback-${E}` : _.key
    }));
  }, [S]), T = {};
  return p && (T.id = `${p}_help`), b(/* @__PURE__ */ reactExports.createElement(CSSMotion, {
    motionDeadline: m.motionDeadline,
    motionName: `${A}-show-help`,
    visible: !!$.length,
    onVisibleChanged: v
  }, (I) => {
    const {
      className: _,
      style: E
    } = I;
    return /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, T, {
      className: classnames(x, _, f, g, d, y),
      style: E
    }), /* @__PURE__ */ reactExports.createElement(CSSMotionList, Object.assign({
      keys: $
    }, initCollapseMotion(A), {
      motionName: `${A}-show-help-item`,
      component: !1
    }), (R) => {
      const {
        key: O,
        error: L,
        errorStatus: B,
        className: F,
        style: M
      } = R;
      return /* @__PURE__ */ reactExports.createElement("div", {
        key: O,
        className: classnames(F, {
          [`${x}-${B}`]: B
        }),
        style: M
      }, L);
    }));
  }));
}, formItemNameBlackList = ["parentNode"], defaultItemNamePrefixCls = "form_item";
function toArray$3(a) {
  return a === void 0 || a === !1 ? [] : Array.isArray(a) ? a : [a];
}
function getFieldId(a, s) {
  if (!a.length)
    return;
  const c = a.join("_");
  return s ? `${s}_${c}` : formItemNameBlackList.includes(c) ? `${defaultItemNamePrefixCls}_${c}` : c;
}
function getStatus(a, s, c, u, d, p) {
  let v = u;
  return p !== void 0 ? v = p : c.validating ? v = "validating" : a.length ? v = "error" : s.length ? v = "warning" : (c.touched || d && c.validated) && (v = "success"), v;
}
var __rest$w = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function toNamePathStr(a) {
  return toArray$3(a).join("_");
}
function getFieldDOMNode(a, s) {
  const c = s.getFieldInstance(a), u = getDOM(c);
  if (u)
    return u;
  const d = getFieldId(toArray$3(a), s.__INTERNAL__.name);
  if (d)
    return document.getElementById(d);
}
function useForm$1(a) {
  const [s] = useForm$2(), c = reactExports.useRef({}), u = reactExports.useMemo(() => a ?? Object.assign(Object.assign({}, s), {
    __INTERNAL__: {
      itemRef: (d) => (p) => {
        const v = toNamePathStr(d);
        p ? c.current[v] = p : delete c.current[v];
      }
    },
    scrollToField: (d, p = {}) => {
      const {
        focus: v
      } = p, A = __rest$w(p, ["focus"]), x = getFieldDOMNode(d, u);
      x && (e(x, Object.assign({
        scrollMode: "if-needed",
        block: "nearest"
      }, A)), v && u.focusField(d));
    },
    focusField: (d) => {
      var p, v;
      const A = u.getFieldInstance(d);
      typeof A?.focus == "function" ? A.focus() : (v = (p = getFieldDOMNode(d, u)) === null || p === void 0 ? void 0 : p.focus) === null || v === void 0 || v.call(p);
    },
    getFieldInstance: (d) => {
      const p = toNamePathStr(d);
      return c.current[p];
    }
  }), [a, s]);
  return [u];
}
var __rest$v = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalForm = (a, s) => {
  const c = reactExports.useContext(DisabledContext), {
    getPrefixCls: u,
    direction: d,
    requiredMark: p,
    colon: v,
    scrollToFirstError: A,
    className: x,
    style: g
  } = useComponentConfig("form"), {
    prefixCls: b,
    className: y,
    rootClassName: f,
    size: m,
    disabled: C = c,
    form: w,
    colon: S,
    labelAlign: $,
    labelWrap: T,
    labelCol: I,
    wrapperCol: _,
    hideRequiredMark: E,
    layout: R = "horizontal",
    scrollToFirstError: O,
    requiredMark: L,
    onFinishFailed: B,
    name: F,
    style: M,
    feedbackIcons: W,
    variant: j
  } = a, G = __rest$v(a, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons", "variant"]), U = useSize(m), k = reactExports.useContext(ValidateMessagesContext), N = reactExports.useMemo(() => L !== void 0 ? L : E ? !1 : p !== void 0 ? p : !0, [E, L, p]), P = S ?? v, D = u("form", b), H = useCSSVarCls(D), [V, Z, ne] = useStyle$e(D, H), K = classnames(D, `${D}-${R}`, {
    [`${D}-hide-required-mark`]: N === !1,
    // todo: remove in next major version
    [`${D}-rtl`]: d === "rtl",
    [`${D}-${U}`]: U
  }, ne, H, Z, x, y, f), [q] = useForm$1(w), {
    __INTERNAL__: Y
  } = q;
  Y.name = F;
  const ee = reactExports.useMemo(() => ({
    name: F,
    labelAlign: $,
    labelCol: I,
    labelWrap: T,
    wrapperCol: _,
    vertical: R === "vertical",
    colon: P,
    requiredMark: N,
    itemRef: Y.itemRef,
    form: q,
    feedbackIcons: W
  }), [F, $, I, _, R, P, N, q, W]), Q = reactExports.useRef(null);
  reactExports.useImperativeHandle(s, () => {
    var ae;
    return Object.assign(Object.assign({}, q), {
      nativeElement: (ae = Q.current) === null || ae === void 0 ? void 0 : ae.nativeElement
    });
  });
  const J = (ae, se) => {
    if (ae) {
      let ie = {
        block: "nearest"
      };
      typeof ae == "object" && (ie = Object.assign(Object.assign({}, ie), ae)), q.scrollToField(se, ie);
    }
  }, te = (ae) => {
    if (B?.(ae), ae.errorFields.length) {
      const se = ae.errorFields[0].name;
      if (O !== void 0) {
        J(O, se);
        return;
      }
      A !== void 0 && J(A, se);
    }
  };
  return V(/* @__PURE__ */ reactExports.createElement(VariantContext.Provider, {
    value: j
  }, /* @__PURE__ */ reactExports.createElement(DisabledContextProvider, {
    disabled: C
  }, /* @__PURE__ */ reactExports.createElement(SizeContext.Provider, {
    value: U
  }, /* @__PURE__ */ reactExports.createElement(FormProvider, {
    // This is not list in API, we pass with spread
    validateMessages: k
  }, /* @__PURE__ */ reactExports.createElement(FormContext.Provider, {
    value: ee
  }, /* @__PURE__ */ reactExports.createElement(RefForm, Object.assign({
    id: F
  }, G, {
    name: F,
    onFinishFailed: te,
    form: q,
    ref: Q,
    style: Object.assign(Object.assign({}, g), M),
    className: K
  }))))))));
}, Form$2 = /* @__PURE__ */ reactExports.forwardRef(InternalForm);
function useChildren(a) {
  if (typeof a == "function")
    return a;
  const s = toArray$8(a);
  return s.length <= 1 ? s[0] : s;
}
const useFormItemStatus = () => {
  const {
    status: a,
    errors: s = [],
    warnings: c = []
  } = reactExports.useContext(FormItemInputContext);
  return {
    status: a,
    errors: s,
    warnings: c
  };
};
useFormItemStatus.Context = FormItemInputContext;
function useFrameState(a) {
  const [s, c] = reactExports.useState(a), u = reactExports.useRef(null), d = reactExports.useRef([]), p = reactExports.useRef(!1);
  reactExports.useEffect(() => (p.current = !1, () => {
    p.current = !0, wrapperRaf.cancel(u.current), u.current = null;
  }), []);
  function v(A) {
    p.current || (u.current === null && (d.current = [], u.current = wrapperRaf(() => {
      u.current = null, c((x) => {
        let g = x;
        return d.current.forEach((b) => {
          g = b(g);
        }), g;
      });
    })), d.current.push(A));
  }
  return [s, v];
}
function useItemRef() {
  const {
    itemRef: a
  } = reactExports.useContext(FormContext), s = reactExports.useRef({});
  function c(u, d) {
    const p = d && typeof d == "object" && getNodeRef(d), v = u.join("_");
    return (s.current.name !== v || s.current.originRef !== p) && (s.current.name = v, s.current.originRef = p, s.current.ref = composeRef(a(u), p)), s.current.ref;
  }
  return c;
}
const genFallbackStyle = (a) => {
  const {
    formItemCls: s
  } = a;
  return {
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      // Fallback for IE, safe to remove we not support it anymore
      [`${s}-control`]: {
        display: "flex"
      }
    }
  };
}, FallbackCmp = genSubStyleComponent(["Form", "item-item"], (a, {
  rootPrefixCls: s
}) => {
  const c = prepareToken$1(a, s);
  return [genFallbackStyle(c)];
});
var __rest$u = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const GRID_MAX = 24, FormItemInput = (a) => {
  const {
    prefixCls: s,
    status: c,
    labelCol: u,
    wrapperCol: d,
    children: p,
    errors: v,
    warnings: A,
    _internalItemRender: x,
    extra: g,
    help: b,
    fieldId: y,
    marginBottom: f,
    onErrorVisibleChanged: m,
    label: C
  } = a, w = `${s}-item`, S = reactExports.useContext(FormContext), $ = reactExports.useMemo(() => {
    let G = Object.assign({}, d || S.wrapperCol || {});
    return C === null && !u && !d && S.labelCol && [void 0, "xs", "sm", "md", "lg", "xl", "xxl"].forEach((k) => {
      const N = k ? [k] : [], P = get$1(S.labelCol, N), D = typeof P == "object" ? P : {}, H = get$1(G, N), V = typeof H == "object" ? H : {};
      "span" in D && !("offset" in V) && D.span < GRID_MAX && (G = set$1(G, [].concat(N, ["offset"]), D.span));
    }), G;
  }, [d, S]), T = classnames(`${w}-control`, $.className), I = reactExports.useMemo(() => {
    const {
      labelCol: G,
      wrapperCol: U
    } = S;
    return __rest$u(S, ["labelCol", "wrapperCol"]);
  }, [S]), _ = reactExports.useRef(null), [E, R] = reactExports.useState(0);
  useLayoutEffect$1(() => {
    g && _.current ? R(_.current.clientHeight) : R(0);
  }, [g]);
  const O = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${w}-control-input`
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${w}-control-input-content`
  }, p)), L = reactExports.useMemo(() => ({
    prefixCls: s,
    status: c
  }), [s, c]), B = f !== null || v.length || A.length ? /* @__PURE__ */ reactExports.createElement(FormItemPrefixContext.Provider, {
    value: L
  }, /* @__PURE__ */ reactExports.createElement(ErrorList, {
    fieldId: y,
    errors: v,
    warnings: A,
    help: b,
    helpStatus: c,
    className: `${w}-explain-connected`,
    onVisibleChanged: m
  })) : null, F = {};
  y && (F.id = `${y}_extra`);
  const M = g ? /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, F, {
    className: `${w}-extra`,
    ref: _
  }), g) : null, W = B || M ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${w}-additional`,
    style: f ? {
      minHeight: f + E
    } : {}
  }, B, M) : null, j = x && x.mark === "pro_table_render" && x.render ? x.render(a, {
    input: O,
    errorList: B,
    extra: M
  }) : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, O, W);
  return /* @__PURE__ */ reactExports.createElement(FormContext.Provider, {
    value: I
  }, /* @__PURE__ */ reactExports.createElement(Col, Object.assign({}, $, {
    className: T
  }), j), /* @__PURE__ */ reactExports.createElement(FallbackCmp, {
    prefixCls: s
  }));
};
var QuestionCircleOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" }, QuestionCircleOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: QuestionCircleOutlined$1
  }));
}, RefIcon$t = /* @__PURE__ */ reactExports.forwardRef(QuestionCircleOutlined), __rest$t = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const FormItemLabel = ({
  prefixCls: a,
  label: s,
  htmlFor: c,
  labelCol: u,
  labelAlign: d,
  colon: p,
  required: v,
  requiredMark: A,
  tooltip: x,
  vertical: g
}) => {
  var b;
  const [y] = useLocale$1("Form"), {
    labelAlign: f,
    labelCol: m,
    labelWrap: C,
    colon: w
  } = reactExports.useContext(FormContext);
  if (!s)
    return null;
  const S = u || m || {}, $ = d || f, T = `${a}-item-label`, I = classnames(T, $ === "left" && `${T}-left`, S.className, {
    [`${T}-wrap`]: !!C
  });
  let _ = s;
  const E = p === !0 || w !== !1 && p !== !1;
  E && !g && typeof s == "string" && s.trim() && (_ = s.replace(/[:|：]\s*$/, ""));
  const O = convertToTooltipProps(x);
  if (O) {
    const {
      icon: j = /* @__PURE__ */ reactExports.createElement(RefIcon$t, null)
    } = O, G = __rest$t(O, ["icon"]), U = /* @__PURE__ */ reactExports.createElement(Tooltip, Object.assign({}, G), /* @__PURE__ */ reactExports.cloneElement(j, {
      className: `${a}-item-tooltip`,
      title: "",
      onClick: (k) => {
        k.preventDefault();
      },
      tabIndex: null
    }));
    _ = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, _, U);
  }
  const L = A === "optional", B = typeof A == "function", F = A === !1;
  B ? _ = A(_, {
    required: !!v
  }) : L && !v && (_ = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, _, /* @__PURE__ */ reactExports.createElement("span", {
    className: `${a}-item-optional`,
    title: ""
  }, y?.optional || ((b = localeValues.Form) === null || b === void 0 ? void 0 : b.optional))));
  let M;
  F ? M = "hidden" : (L || B) && (M = "optional");
  const W = classnames({
    [`${a}-item-required`]: v,
    [`${a}-item-required-mark-${M}`]: M,
    [`${a}-item-no-colon`]: !E
  });
  return /* @__PURE__ */ reactExports.createElement(Col, Object.assign({}, S, {
    className: I
  }), /* @__PURE__ */ reactExports.createElement("label", {
    htmlFor: c,
    className: W,
    title: typeof s == "string" ? s : ""
  }, _));
}, iconMap = {
  success: RefIcon$K,
  warning: RefIcon$H,
  error: RefIcon$J,
  validating: RefIcon$F
};
function StatusProvider({
  children: a,
  errors: s,
  warnings: c,
  hasFeedback: u,
  validateStatus: d,
  prefixCls: p,
  meta: v,
  noStyle: A
}) {
  const x = `${p}-item`, {
    feedbackIcons: g
  } = reactExports.useContext(FormContext), b = getStatus(s, c, v, null, !!u, d), {
    isFormItemInput: y,
    status: f,
    hasFeedback: m,
    feedbackIcon: C
  } = reactExports.useContext(FormItemInputContext), w = reactExports.useMemo(() => {
    var S;
    let $;
    if (u) {
      const I = u !== !0 && u.icons || g, _ = b && ((S = I?.({
        status: b,
        errors: s,
        warnings: c
      })) === null || S === void 0 ? void 0 : S[b]), E = b && iconMap[b];
      $ = _ !== !1 && E ? /* @__PURE__ */ reactExports.createElement("span", {
        className: classnames(`${x}-feedback-icon`, `${x}-feedback-icon-${b}`)
      }, _ || /* @__PURE__ */ reactExports.createElement(E, null)) : null;
    }
    const T = {
      status: b || "",
      errors: s,
      warnings: c,
      hasFeedback: !!u,
      feedbackIcon: $,
      isFormItemInput: !0
    };
    return A && (T.status = (b ?? f) || "", T.isFormItemInput = y, T.hasFeedback = !!(u ?? m), T.feedbackIcon = u !== void 0 ? T.feedbackIcon : C), T;
  }, [b, u, A, y, f]);
  return /* @__PURE__ */ reactExports.createElement(FormItemInputContext.Provider, {
    value: w
  }, a);
}
var __rest$s = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function ItemHolder(a) {
  const {
    prefixCls: s,
    className: c,
    rootClassName: u,
    style: d,
    help: p,
    errors: v,
    warnings: A,
    validateStatus: x,
    meta: g,
    hasFeedback: b,
    hidden: y,
    children: f,
    fieldId: m,
    required: C,
    isRequired: w,
    onSubItemMetaChange: S,
    layout: $
  } = a, T = __rest$s(a, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange", "layout"]), I = `${s}-item`, {
    requiredMark: _,
    vertical: E
  } = reactExports.useContext(FormContext), R = E || $ === "vertical", O = reactExports.useRef(null), L = useDebounce(v), B = useDebounce(A), F = p != null, M = !!(F || v.length || A.length), W = !!O.current && isVisible(O.current), [j, G] = reactExports.useState(null);
  useLayoutEffect$1(() => {
    if (M && O.current) {
      const D = getComputedStyle(O.current);
      G(parseInt(D.marginBottom, 10));
    }
  }, [M, W]);
  const U = (D) => {
    D || G(null);
  }, N = ((D = !1) => {
    const H = D ? L : g.errors, V = D ? B : g.warnings;
    return getStatus(H, V, g, "", !!b, x);
  })(), P = classnames(I, c, u, {
    [`${I}-with-help`]: F || L.length || B.length,
    // Status
    [`${I}-has-feedback`]: N && b,
    [`${I}-has-success`]: N === "success",
    [`${I}-has-warning`]: N === "warning",
    [`${I}-has-error`]: N === "error",
    [`${I}-is-validating`]: N === "validating",
    [`${I}-hidden`]: y,
    // Layout
    [`${I}-${$}`]: $
  });
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: P,
    style: d,
    ref: O
  }, /* @__PURE__ */ reactExports.createElement(Row, Object.assign({
    className: `${I}-row`
  }, omit(T, [
    "_internalItemRender",
    "colon",
    "dependencies",
    "extra",
    "fieldKey",
    "getValueFromEvent",
    "getValueProps",
    "htmlFor",
    "id",
    // It is deprecated because `htmlFor` is its replacement.
    "initialValue",
    "isListField",
    "label",
    "labelAlign",
    "labelCol",
    "labelWrap",
    "messageVariables",
    "name",
    "normalize",
    "noStyle",
    "preserve",
    "requiredMark",
    "rules",
    "shouldUpdate",
    "trigger",
    "tooltip",
    "validateFirst",
    "validateTrigger",
    "valuePropName",
    "wrapperCol",
    "validateDebounce"
  ])), /* @__PURE__ */ reactExports.createElement(FormItemLabel, Object.assign({
    htmlFor: m
  }, a, {
    requiredMark: _,
    required: C ?? w,
    prefixCls: s,
    vertical: R
  })), /* @__PURE__ */ reactExports.createElement(FormItemInput, Object.assign({}, a, g, {
    errors: L,
    warnings: B,
    prefixCls: s,
    status: N,
    help: p,
    marginBottom: j,
    onErrorVisibleChanged: U
  }), /* @__PURE__ */ reactExports.createElement(NoStyleItemContext.Provider, {
    value: S
  }, /* @__PURE__ */ reactExports.createElement(StatusProvider, {
    prefixCls: s,
    meta: g,
    errors: g.errors,
    warnings: g.warnings,
    hasFeedback: b,
    // Already calculated
    validateStatus: N
  }, f)))), !!j && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${I}-margin-offset`,
    style: {
      marginBottom: -j
    }
  }));
}
const NAME_SPLIT = "__SPLIT__";
function isSimilarControl(a, s) {
  const c = Object.keys(a), u = Object.keys(s);
  return c.length === u.length && c.every((d) => {
    const p = a[d], v = s[d];
    return p === v || typeof p == "function" || typeof v == "function";
  });
}
const MemoInput = /* @__PURE__ */ reactExports.memo(({
  children: a
}) => a, (a, s) => isSimilarControl(a.control, s.control) && a.update === s.update && a.childProps.length === s.childProps.length && a.childProps.every((c, u) => c === s.childProps[u]));
function genEmptyMeta() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    name: [],
    validated: !1
  };
}
function InternalFormItem(a) {
  const {
    name: s,
    noStyle: c,
    className: u,
    dependencies: d,
    prefixCls: p,
    shouldUpdate: v,
    rules: A,
    children: x,
    required: g,
    label: b,
    messageVariables: y,
    trigger: f = "onChange",
    validateTrigger: m,
    hidden: C,
    help: w,
    layout: S
  } = a, {
    getPrefixCls: $
  } = reactExports.useContext(ConfigContext$1), {
    name: T
  } = reactExports.useContext(FormContext), I = useChildren(x), _ = typeof I == "function", E = reactExports.useContext(NoStyleItemContext), {
    validateTrigger: R
  } = reactExports.useContext(Context$2), O = m !== void 0 ? m : R, L = s != null, B = $("form", p), F = useCSSVarCls(B), [M, W, j] = useStyle$e(B, F);
  devUseWarning();
  const G = reactExports.useContext(ListContext), U = reactExports.useRef(null), [k, N] = useFrameState({}), [P, D] = useSafeState(() => genEmptyMeta()), H = (ee) => {
    const Q = G?.getKey(ee.name);
    if (D(ee.destroy ? genEmptyMeta() : ee, !0), c && w !== !1 && E) {
      let J = ee.name;
      if (ee.destroy)
        J = U.current || J;
      else if (Q !== void 0) {
        const [te, ae] = Q;
        J = [te].concat(_toConsumableArray$e(ae)), U.current = J;
      }
      E(ee, J);
    }
  }, V = (ee, Q) => {
    N((J) => {
      const te = Object.assign({}, J), se = [].concat(_toConsumableArray$e(ee.name.slice(0, -1)), _toConsumableArray$e(Q)).join(NAME_SPLIT);
      return ee.destroy ? delete te[se] : te[se] = ee, te;
    });
  }, [Z, ne] = reactExports.useMemo(() => {
    const ee = _toConsumableArray$e(P.errors), Q = _toConsumableArray$e(P.warnings);
    return Object.values(k).forEach((J) => {
      ee.push.apply(ee, _toConsumableArray$e(J.errors || [])), Q.push.apply(Q, _toConsumableArray$e(J.warnings || []));
    }), [ee, Q];
  }, [k, P.errors, P.warnings]), K = useItemRef();
  function q(ee, Q, J) {
    return c && !C ? /* @__PURE__ */ reactExports.createElement(StatusProvider, {
      prefixCls: B,
      hasFeedback: a.hasFeedback,
      validateStatus: a.validateStatus,
      meta: P,
      errors: Z,
      warnings: ne,
      noStyle: !0
    }, ee) : /* @__PURE__ */ reactExports.createElement(ItemHolder, Object.assign({
      key: "row"
    }, a, {
      className: classnames(u, j, F, W),
      prefixCls: B,
      fieldId: Q,
      isRequired: J,
      errors: Z,
      warnings: ne,
      meta: P,
      onSubItemMetaChange: V,
      layout: S
    }), ee);
  }
  if (!L && !_ && !d)
    return M(q(I));
  let Y = {};
  return typeof b == "string" ? Y.label = b : s && (Y.label = String(s)), y && (Y = Object.assign(Object.assign({}, Y), y)), M(/* @__PURE__ */ reactExports.createElement(WrapperField, Object.assign({}, a, {
    messageVariables: Y,
    trigger: f,
    validateTrigger: O,
    onMetaChange: H
  }), (ee, Q, J) => {
    const te = toArray$3(s).length && Q ? Q.name : [], ae = getFieldId(te, T), se = g !== void 0 ? g : !!A?.some((ge) => {
      if (ge && typeof ge == "object" && ge.required && !ge.warningOnly)
        return !0;
      if (typeof ge == "function") {
        const me = ge(J);
        return me?.required && !me?.warningOnly;
      }
      return !1;
    }), ie = Object.assign({}, ee);
    let fe = null;
    if (Array.isArray(I) && L)
      fe = I;
    else if (!(_ && (!(v || d) || L))) {
      if (!(d && !_ && !L)) if (/* @__PURE__ */ reactExports.isValidElement(I)) {
        const ge = Object.assign(Object.assign({}, I.props), ie);
        if (ge.id || (ge.id = ae), w || Z.length > 0 || ne.length > 0 || a.extra) {
          const be = [];
          (w || Z.length > 0) && be.push(`${ae}_help`), a.extra && be.push(`${ae}_extra`), ge["aria-describedby"] = be.join(" ");
        }
        Z.length > 0 && (ge["aria-invalid"] = "true"), se && (ge["aria-required"] = "true"), supportRef(I) && (ge.ref = K(te, I)), new Set([].concat(_toConsumableArray$e(toArray$3(f)), _toConsumableArray$e(toArray$3(O)))).forEach((be) => {
          ge[be] = (...le) => {
            var ve, he, ye, Ce, xe;
            (ye = ie[be]) === null || ye === void 0 || (ve = ye).call.apply(ve, [ie].concat(le)), (xe = (Ce = I.props)[be]) === null || xe === void 0 || (he = xe).call.apply(he, [Ce].concat(le));
          };
        });
        const pe = [ge["aria-required"], ge["aria-invalid"], ge["aria-describedby"]];
        fe = /* @__PURE__ */ reactExports.createElement(MemoInput, {
          control: ie,
          update: I,
          childProps: pe
        }, cloneElement(I, ge));
      } else _ && (v || d) && !L ? fe = I(J) : fe = I;
    }
    return q(fe, ae, se);
  }));
}
const FormItem = InternalFormItem;
FormItem.useStatus = useFormItemStatus;
var __rest$r = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const FormList = (a) => {
  var {
    prefixCls: s,
    children: c
  } = a, u = __rest$r(a, ["prefixCls", "children"]);
  const {
    getPrefixCls: d
  } = reactExports.useContext(ConfigContext$1), p = d("form", s), v = reactExports.useMemo(() => ({
    prefixCls: p,
    status: "error"
  }), [p]);
  return /* @__PURE__ */ reactExports.createElement(List$1, Object.assign({}, u), (A, x, g) => /* @__PURE__ */ reactExports.createElement(FormItemPrefixContext.Provider, {
    value: v
  }, c(A.map((b) => Object.assign(Object.assign({}, b), {
    fieldKey: b.key
  })), x, {
    errors: g.errors,
    warnings: g.warnings
  })));
};
function useFormInstance() {
  const {
    form: a
  } = reactExports.useContext(FormContext);
  return a;
}
const Form$1 = Form$2;
Form$1.Item = FormItem;
Form$1.List = FormList;
Form$1.ErrorList = ErrorList;
Form$1.useForm = useForm$1;
Form$1.useFormInstance = useFormInstance;
Form$1.useWatch = useWatch$1;
Form$1.Provider = FormProvider;
Form$1.create = () => {
};
var EyeOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" }, EyeOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: EyeOutlined$1
  }));
}, RefIcon$s = /* @__PURE__ */ reactExports.forwardRef(EyeOutlined);
function getClientSize() {
  var a = document.documentElement.clientWidth, s = window.innerHeight || document.documentElement.clientHeight;
  return {
    width: a,
    height: s
  };
}
function getOffset$2(a) {
  var s = a.getBoundingClientRect(), c = document.documentElement;
  return {
    left: s.left + (window.pageXOffset || c.scrollLeft) - (c.clientLeft || document.body.clientLeft || 0),
    top: s.top + (window.pageYOffset || c.scrollTop) - (c.clientTop || document.body.clientTop || 0)
  };
}
function addEventListenerWrap$1(a, s, c, u) {
  var d = ReactDOM.unstable_batchedUpdates ? function(v) {
    ReactDOM.unstable_batchedUpdates(c, v);
  } : c;
  return a != null && a.addEventListener && a.addEventListener(s, d, u), {
    remove: function() {
      a != null && a.removeEventListener && a.removeEventListener(s, d, u);
    }
  };
}
var PreviewGroupContext = /* @__PURE__ */ reactExports.createContext(null), Operations = function a(s) {
  var c = s.visible, u = s.maskTransitionName, d = s.getContainer, p = s.prefixCls, v = s.rootClassName, A = s.icons, x = s.countRender, g = s.showSwitch, b = s.showProgress, y = s.current, f = s.transform, m = s.count, C = s.scale, w = s.minScale, S = s.maxScale, $ = s.closeIcon, T = s.onActive, I = s.onClose, _ = s.onZoomIn, E = s.onZoomOut, R = s.onRotateRight, O = s.onRotateLeft, L = s.onFlipX, B = s.onFlipY, F = s.onReset, M = s.toolbarRender, W = s.zIndex, j = s.image, G = reactExports.useContext(PreviewGroupContext), U = A.rotateLeft, k = A.rotateRight, N = A.zoomIn, P = A.zoomOut, D = A.close, H = A.left, V = A.right, Z = A.flipX, ne = A.flipY, K = "".concat(p, "-operations-operation");
  reactExports.useEffect(function() {
    var me = function(be) {
      be.keyCode === KeyCode.ESC && I();
    };
    return c && window.addEventListener("keydown", me), function() {
      window.removeEventListener("keydown", me);
    };
  }, [c]);
  var q = function(pe, be) {
    pe.preventDefault(), pe.stopPropagation(), T(be);
  }, Y = reactExports.useCallback(function(me) {
    var pe = me.type, be = me.disabled, le = me.onClick, ve = me.icon;
    return /* @__PURE__ */ reactExports.createElement("div", {
      key: pe,
      className: classnames(K, "".concat(p, "-operations-operation-").concat(pe), _defineProperty$a({}, "".concat(p, "-operations-operation-disabled"), !!be)),
      onClick: le
    }, ve);
  }, [K, p]), ee = g ? Y({
    icon: H,
    onClick: function(pe) {
      return q(pe, -1);
    },
    type: "prev",
    disabled: y === 0
  }) : void 0, Q = g ? Y({
    icon: V,
    onClick: function(pe) {
      return q(pe, 1);
    },
    type: "next",
    disabled: y === m - 1
  }) : void 0, J = Y({
    icon: ne,
    onClick: B,
    type: "flipY"
  }), te = Y({
    icon: Z,
    onClick: L,
    type: "flipX"
  }), ae = Y({
    icon: U,
    onClick: O,
    type: "rotateLeft"
  }), se = Y({
    icon: k,
    onClick: R,
    type: "rotateRight"
  }), ie = Y({
    icon: P,
    onClick: E,
    type: "zoomOut",
    disabled: C <= w
  }), fe = Y({
    icon: N,
    onClick: _,
    type: "zoomIn",
    disabled: C === S
  }), ge = /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(p, "-operations")
  }, J, te, ae, se, ie, fe);
  return /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    visible: c,
    motionName: u
  }, function(me) {
    var pe = me.className, be = me.style;
    return /* @__PURE__ */ reactExports.createElement(Portal, {
      open: !0,
      getContainer: d ?? document.body
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(p, "-operations-wrapper"), pe, v),
      style: _objectSpread2$1(_objectSpread2$1({}, be), {}, {
        zIndex: W
      })
    }, $ === null ? null : /* @__PURE__ */ reactExports.createElement("button", {
      className: "".concat(p, "-close"),
      onClick: I
    }, $ || D), g && /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(p, "-switch-left"), _defineProperty$a({}, "".concat(p, "-switch-left-disabled"), y === 0)),
      onClick: function(ve) {
        return q(ve, -1);
      }
    }, H), /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(p, "-switch-right"), _defineProperty$a({}, "".concat(p, "-switch-right-disabled"), y === m - 1)),
      onClick: function(ve) {
        return q(ve, 1);
      }
    }, V)), /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(p, "-footer")
    }, b && /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(p, "-progress")
    }, x ? x(y + 1, m) : /* @__PURE__ */ reactExports.createElement("bdi", null, "".concat(y + 1, " / ").concat(m))), M ? M(ge, _objectSpread2$1(_objectSpread2$1({
      icons: {
        prevIcon: ee,
        nextIcon: Q,
        flipYIcon: J,
        flipXIcon: te,
        rotateLeftIcon: ae,
        rotateRightIcon: se,
        zoomOutIcon: ie,
        zoomInIcon: fe
      },
      actions: {
        onActive: T,
        onFlipY: B,
        onFlipX: L,
        onRotateLeft: O,
        onRotateRight: R,
        onZoomOut: E,
        onZoomIn: _,
        onReset: F,
        onClose: I
      },
      transform: f
    }, G ? {
      current: y,
      total: m
    } : {}), {}, {
      image: j
    })) : ge)));
  });
}, initialTransform = {
  x: 0,
  y: 0,
  rotate: 0,
  scale: 1,
  flipX: !1,
  flipY: !1
};
function useImageTransform(a, s, c, u) {
  var d = reactExports.useRef(null), p = reactExports.useRef([]), v = reactExports.useState(initialTransform), A = _slicedToArray$e(v, 2), x = A[0], g = A[1], b = function(C) {
    g(initialTransform), isEqual(initialTransform, x) || u?.({
      transform: initialTransform,
      action: C
    });
  }, y = function(C, w) {
    d.current === null && (p.current = [], d.current = wrapperRaf(function() {
      g(function(S) {
        var $ = S;
        return p.current.forEach(function(T) {
          $ = _objectSpread2$1(_objectSpread2$1({}, $), T);
        }), d.current = null, u?.({
          transform: $,
          action: w
        }), $;
      });
    })), p.current.push(_objectSpread2$1(_objectSpread2$1({}, x), C));
  }, f = function(C, w, S, $, T) {
    var I = a.current, _ = I.width, E = I.height, R = I.offsetWidth, O = I.offsetHeight, L = I.offsetLeft, B = I.offsetTop, F = C, M = x.scale * C;
    M > c ? (M = c, F = c / x.scale) : M < s && (M = T ? M : s, F = M / x.scale);
    var W = S ?? innerWidth / 2, j = $ ?? innerHeight / 2, G = F - 1, U = G * _ * 0.5, k = G * E * 0.5, N = G * (W - x.x - L), P = G * (j - x.y - B), D = x.x - (N - U), H = x.y - (P - k);
    if (C < 1 && M === 1) {
      var V = R * M, Z = O * M, ne = getClientSize(), K = ne.width, q = ne.height;
      V <= K && Z <= q && (D = 0, H = 0);
    }
    y({
      x: D,
      y: H,
      scale: M
    }, w);
  };
  return {
    transform: x,
    resetTransform: b,
    updateTransform: y,
    dispatchZoomChange: f
  };
}
function fixPoint(a, s, c, u) {
  var d = s + c, p = (c - u) / 2;
  if (c > u) {
    if (s > 0)
      return _defineProperty$a({}, a, p);
    if (s < 0 && d < u)
      return _defineProperty$a({}, a, -p);
  } else if (s < 0 || d > u)
    return _defineProperty$a({}, a, s < 0 ? p : -p);
  return {};
}
function getFixScaleEleTransPosition(a, s, c, u) {
  var d = getClientSize(), p = d.width, v = d.height, A = null;
  return a <= p && s <= v ? A = {
    x: 0,
    y: 0
  } : (a > p || s > v) && (A = _objectSpread2$1(_objectSpread2$1({}, fixPoint("x", c, a, p)), fixPoint("y", u, s, v))), A;
}
var BASE_SCALE_RATIO = 1, WHEEL_MAX_SCALE_RATIO = 1;
function useMouseEvent(a, s, c, u, d, p, v) {
  var A = d.rotate, x = d.scale, g = d.x, b = d.y, y = reactExports.useState(!1), f = _slicedToArray$e(y, 2), m = f[0], C = f[1], w = reactExports.useRef({
    diffX: 0,
    diffY: 0,
    transformX: 0,
    transformY: 0
  }), S = function(E) {
    !s || E.button !== 0 || (E.preventDefault(), E.stopPropagation(), w.current = {
      diffX: E.pageX - g,
      diffY: E.pageY - b,
      transformX: g,
      transformY: b
    }, C(!0));
  }, $ = function(E) {
    c && m && p({
      x: E.pageX - w.current.diffX,
      y: E.pageY - w.current.diffY
    }, "move");
  }, T = function() {
    if (c && m) {
      C(!1);
      var E = w.current, R = E.transformX, O = E.transformY, L = g !== R && b !== O;
      if (!L) return;
      var B = a.current.offsetWidth * x, F = a.current.offsetHeight * x, M = a.current.getBoundingClientRect(), W = M.left, j = M.top, G = A % 180 !== 0, U = getFixScaleEleTransPosition(G ? F : B, G ? B : F, W, j);
      U && p(_objectSpread2$1({}, U), "dragRebound");
    }
  }, I = function(E) {
    if (!(!c || E.deltaY == 0)) {
      var R = Math.abs(E.deltaY / 100), O = Math.min(R, WHEEL_MAX_SCALE_RATIO), L = BASE_SCALE_RATIO + O * u;
      E.deltaY > 0 && (L = BASE_SCALE_RATIO / L), v(L, "wheel", E.clientX, E.clientY);
    }
  };
  return reactExports.useEffect(function() {
    var _, E, R, O;
    if (s) {
      R = addEventListenerWrap$1(window, "mouseup", T, !1), O = addEventListenerWrap$1(window, "mousemove", $, !1);
      try {
        window.top !== window.self && (_ = addEventListenerWrap$1(window.top, "mouseup", T, !1), E = addEventListenerWrap$1(window.top, "mousemove", $, !1));
      } catch {
      }
    }
    return function() {
      var L, B, F, M;
      (L = R) === null || L === void 0 || L.remove(), (B = O) === null || B === void 0 || B.remove(), (F = _) === null || F === void 0 || F.remove(), (M = E) === null || M === void 0 || M.remove();
    };
  }, [c, m, g, b, A, s]), {
    isMoving: m,
    onMouseDown: S,
    onMouseMove: $,
    onMouseUp: T,
    onWheel: I
  };
}
function isImageValid(a) {
  return new Promise(function(s) {
    if (!a) {
      s(!1);
      return;
    }
    var c = document.createElement("img");
    c.onerror = function() {
      return s(!1);
    }, c.onload = function() {
      return s(!0);
    }, c.src = a;
  });
}
function useStatus(a) {
  var s = a.src, c = a.isCustomPlaceholder, u = a.fallback, d = reactExports.useState(c ? "loading" : "normal"), p = _slicedToArray$e(d, 2), v = p[0], A = p[1], x = reactExports.useRef(!1), g = v === "error";
  reactExports.useEffect(function() {
    var m = !0;
    return isImageValid(s).then(function(C) {
      !C && m && A("error");
    }), function() {
      m = !1;
    };
  }, [s]), reactExports.useEffect(function() {
    c && !x.current ? A("loading") : g && A("normal");
  }, [s]);
  var b = function() {
    A("normal");
  }, y = function(C) {
    x.current = !1, v === "loading" && C !== null && C !== void 0 && C.complete && (C.naturalWidth || C.naturalHeight) && (x.current = !0, b());
  }, f = g && u ? {
    src: u
  } : {
    onLoad: b,
    src: s
  };
  return [y, f, v];
}
function getDistance(a, s) {
  var c = a.x - s.x, u = a.y - s.y;
  return Math.hypot(c, u);
}
function getCenter(a, s, c, u) {
  var d = getDistance(a, c), p = getDistance(s, u);
  if (d === 0 && p === 0)
    return [a.x, a.y];
  var v = d / (d + p), A = a.x + v * (s.x - a.x), x = a.y + v * (s.y - a.y);
  return [A, x];
}
function useTouchEvent(a, s, c, u, d, p, v) {
  var A = d.rotate, x = d.scale, g = d.x, b = d.y, y = reactExports.useState(!1), f = _slicedToArray$e(y, 2), m = f[0], C = f[1], w = reactExports.useRef({
    point1: {
      x: 0,
      y: 0
    },
    point2: {
      x: 0,
      y: 0
    },
    eventType: "none"
  }), S = function(E) {
    w.current = _objectSpread2$1(_objectSpread2$1({}, w.current), E);
  }, $ = function(E) {
    if (s) {
      E.stopPropagation(), C(!0);
      var R = E.touches, O = R === void 0 ? [] : R;
      O.length > 1 ? S({
        point1: {
          x: O[0].clientX,
          y: O[0].clientY
        },
        point2: {
          x: O[1].clientX,
          y: O[1].clientY
        },
        eventType: "touchZoom"
      }) : S({
        point1: {
          x: O[0].clientX - g,
          y: O[0].clientY - b
        },
        eventType: "move"
      });
    }
  }, T = function(E) {
    var R = E.touches, O = R === void 0 ? [] : R, L = w.current, B = L.point1, F = L.point2, M = L.eventType;
    if (O.length > 1 && M === "touchZoom") {
      var W = {
        x: O[0].clientX,
        y: O[0].clientY
      }, j = {
        x: O[1].clientX,
        y: O[1].clientY
      }, G = getCenter(B, F, W, j), U = _slicedToArray$e(G, 2), k = U[0], N = U[1], P = getDistance(W, j) / getDistance(B, F);
      v(P, "touchZoom", k, N, !0), S({
        point1: W,
        point2: j,
        eventType: "touchZoom"
      });
    } else M === "move" && (p({
      x: O[0].clientX - B.x,
      y: O[0].clientY - B.y
    }, "move"), S({
      eventType: "move"
    }));
  }, I = function() {
    if (c) {
      if (m && C(!1), S({
        eventType: "none"
      }), u > x)
        return p({
          x: 0,
          y: 0,
          scale: u
        }, "touchZoom");
      var E = a.current.offsetWidth * x, R = a.current.offsetHeight * x, O = a.current.getBoundingClientRect(), L = O.left, B = O.top, F = A % 180 !== 0, M = getFixScaleEleTransPosition(F ? R : E, F ? E : R, L, B);
      M && p(_objectSpread2$1({}, M), "dragRebound");
    }
  };
  return reactExports.useEffect(function() {
    var _;
    return c && s && (_ = addEventListenerWrap$1(window, "touchmove", function(E) {
      return E.preventDefault();
    }, {
      passive: !1
    })), function() {
      var E;
      (E = _) === null || E === void 0 || E.remove();
    };
  }, [c, s]), {
    isTouching: m,
    onTouchStart: $,
    onTouchMove: T,
    onTouchEnd: I
  };
}
var _excluded$k = ["fallback", "src", "imgRef"], _excluded2$4 = ["prefixCls", "src", "alt", "imageInfo", "fallback", "movable", "onClose", "visible", "icons", "rootClassName", "closeIcon", "getContainer", "current", "count", "countRender", "scaleStep", "minScale", "maxScale", "transitionName", "maskTransitionName", "imageRender", "imgCommonProps", "toolbarRender", "onTransform", "onChange"], PreviewImage = function a(s) {
  var c = s.fallback, u = s.src, d = s.imgRef, p = _objectWithoutProperties$2(s, _excluded$k), v = useStatus({
    src: u,
    fallback: c
  }), A = _slicedToArray$e(v, 2), x = A[0], g = A[1];
  return /* @__PURE__ */ React.createElement("img", _extends$3({
    ref: function(y) {
      d.current = y, x(y);
    }
  }, p, g));
}, Preview$2 = function a(s) {
  var c = s.prefixCls, u = s.src, d = s.alt, p = s.imageInfo, v = s.fallback, A = s.movable, x = A === void 0 ? !0 : A, g = s.onClose, b = s.visible, y = s.icons, f = y === void 0 ? {} : y, m = s.rootClassName, C = s.closeIcon, w = s.getContainer, S = s.current, $ = S === void 0 ? 0 : S, T = s.count, I = T === void 0 ? 1 : T, _ = s.countRender, E = s.scaleStep, R = E === void 0 ? 0.5 : E, O = s.minScale, L = O === void 0 ? 1 : O, B = s.maxScale, F = B === void 0 ? 50 : B, M = s.transitionName, W = M === void 0 ? "zoom" : M, j = s.maskTransitionName, G = j === void 0 ? "fade" : j, U = s.imageRender, k = s.imgCommonProps, N = s.toolbarRender, P = s.onTransform, D = s.onChange, H = _objectWithoutProperties$2(s, _excluded2$4), V = reactExports.useRef(), Z = reactExports.useContext(PreviewGroupContext), ne = Z && I > 1, K = Z && I >= 1, q = reactExports.useState(!0), Y = _slicedToArray$e(q, 2), ee = Y[0], Q = Y[1], J = useImageTransform(V, L, F, P), te = J.transform, ae = J.resetTransform, se = J.updateTransform, ie = J.dispatchZoomChange, fe = useMouseEvent(V, x, b, R, te, se, ie), ge = fe.isMoving, me = fe.onMouseDown, pe = fe.onWheel, be = useTouchEvent(V, x, b, L, te, se, ie), le = be.isTouching, ve = be.onTouchStart, he = be.onTouchMove, ye = be.onTouchEnd, Ce = te.rotate, xe = te.scale, we = classnames(_defineProperty$a({}, "".concat(c, "-moving"), ge));
  reactExports.useEffect(function() {
    ee || Q(!0);
  }, [ee]);
  var $e = function() {
    ae("close");
  }, Ae = function() {
    ie(BASE_SCALE_RATIO + R, "zoomIn");
  }, ue = function() {
    ie(BASE_SCALE_RATIO / (BASE_SCALE_RATIO + R), "zoomOut");
  }, ce = function() {
    se({
      rotate: Ce + 90
    }, "rotateRight");
  }, Ee = function() {
    se({
      rotate: Ce - 90
    }, "rotateLeft");
  }, _e = function() {
    se({
      flipX: !te.flipX
    }, "flipX");
  }, Te = function() {
    se({
      flipY: !te.flipY
    }, "flipY");
  }, ke = function() {
    ae("reset");
  }, Re = function(je) {
    var Le = $ + je;
    !Number.isInteger(Le) || Le < 0 || Le > I - 1 || (Q(!1), ae(je < 0 ? "prev" : "next"), D?.(Le, $));
  }, Be = function(je) {
    !b || !ne || (je.keyCode === KeyCode.LEFT ? Re(-1) : je.keyCode === KeyCode.RIGHT && Re(1));
  }, Oe = function(je) {
    b && (xe !== 1 ? se({
      x: 0,
      y: 0,
      scale: 1
    }, "doubleClick") : ie(BASE_SCALE_RATIO + R, "doubleClick", je.clientX, je.clientY));
  };
  reactExports.useEffect(function() {
    var Ue = addEventListenerWrap$1(window, "keydown", Be, !1);
    return function() {
      Ue.remove();
    };
  }, [b, ne, $]);
  var Me = /* @__PURE__ */ React.createElement(PreviewImage, _extends$3({}, k, {
    width: s.width,
    height: s.height,
    imgRef: V,
    className: "".concat(c, "-img"),
    alt: d,
    style: {
      transform: "translate3d(".concat(te.x, "px, ").concat(te.y, "px, 0) scale3d(").concat(te.flipX ? "-" : "").concat(xe, ", ").concat(te.flipY ? "-" : "").concat(xe, ", 1) rotate(").concat(Ce, "deg)"),
      transitionDuration: (!ee || le) && "0s"
    },
    fallback: v,
    src: u,
    onWheel: pe,
    onMouseDown: me,
    onDoubleClick: Oe,
    onTouchStart: ve,
    onTouchMove: he,
    onTouchEnd: ye,
    onTouchCancel: ye
  })), Fe = _objectSpread2$1({
    url: u,
    alt: d
  }, p);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DialogWrap, _extends$3({
    transitionName: W,
    maskTransitionName: G,
    closable: !1,
    keyboard: !0,
    prefixCls: c,
    onClose: g,
    visible: b,
    classNames: {
      wrapper: we
    },
    rootClassName: m,
    getContainer: w
  }, H, {
    afterClose: $e
  }), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(c, "-img-wrapper")
  }, U ? U(Me, _objectSpread2$1({
    transform: te,
    image: Fe
  }, Z ? {
    current: $
  } : {})) : Me)), /* @__PURE__ */ React.createElement(Operations, {
    visible: b,
    transform: te,
    maskTransitionName: G,
    closeIcon: C,
    getContainer: w,
    prefixCls: c,
    rootClassName: m,
    icons: f,
    countRender: _,
    showSwitch: ne,
    showProgress: K,
    current: $,
    count: I,
    scale: xe,
    minScale: L,
    maxScale: F,
    toolbarRender: N,
    onActive: Re,
    onZoomIn: Ae,
    onZoomOut: ue,
    onRotateRight: ce,
    onRotateLeft: Ee,
    onFlipX: _e,
    onFlipY: Te,
    onClose: g,
    onReset: ke,
    zIndex: H.zIndex !== void 0 ? H.zIndex + 1 : void 0,
    image: Fe
  }));
}, COMMON_PROPS = ["crossOrigin", "decoding", "draggable", "loading", "referrerPolicy", "sizes", "srcSet", "useMap", "alt"];
function usePreviewItems(a) {
  var s = reactExports.useState({}), c = _slicedToArray$e(s, 2), u = c[0], d = c[1], p = reactExports.useCallback(function(A, x) {
    return d(function(g) {
      return _objectSpread2$1(_objectSpread2$1({}, g), {}, _defineProperty$a({}, A, x));
    }), function() {
      d(function(g) {
        var b = _objectSpread2$1({}, g);
        return delete b[A], b;
      });
    };
  }, []), v = reactExports.useMemo(function() {
    return a ? a.map(function(A) {
      if (typeof A == "string")
        return {
          data: {
            src: A
          }
        };
      var x = {};
      return Object.keys(A).forEach(function(g) {
        ["src"].concat(_toConsumableArray$e(COMMON_PROPS)).includes(g) && (x[g] = A[g]);
      }), {
        data: x
      };
    }) : Object.keys(u).reduce(function(A, x) {
      var g = u[x], b = g.canPreview, y = g.data;
      return b && A.push({
        data: y,
        id: x
      }), A;
    }, []);
  }, [a, u]);
  return [v, p, !!a];
}
var _excluded$j = ["visible", "onVisibleChange", "getContainer", "current", "movable", "minScale", "maxScale", "countRender", "closeIcon", "onChange", "onTransform", "toolbarRender", "imageRender"], _excluded2$3 = ["src"], Group$1 = function a(s) {
  var c, u = s.previewPrefixCls, d = u === void 0 ? "rc-image-preview" : u, p = s.children, v = s.icons, A = v === void 0 ? {} : v, x = s.items, g = s.preview, b = s.fallback, y = _typeof$h(g) === "object" ? g : {}, f = y.visible, m = y.onVisibleChange, C = y.getContainer, w = y.current, S = y.movable, $ = y.minScale, T = y.maxScale, I = y.countRender, _ = y.closeIcon, E = y.onChange, R = y.onTransform, O = y.toolbarRender, L = y.imageRender, B = _objectWithoutProperties$2(y, _excluded$j), F = usePreviewItems(x), M = _slicedToArray$e(F, 3), W = M[0], j = M[1], G = M[2], U = useMergedState(0, {
    value: w
  }), k = _slicedToArray$e(U, 2), N = k[0], P = k[1], D = reactExports.useState(!1), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = ((c = W[N]) === null || c === void 0 ? void 0 : c.data) || {}, K = ne.src, q = _objectWithoutProperties$2(ne, _excluded2$3), Y = useMergedState(!!f, {
    value: f,
    onChange: function(le, ve) {
      m?.(le, ve, N);
    }
  }), ee = _slicedToArray$e(Y, 2), Q = ee[0], J = ee[1], te = reactExports.useState(null), ae = _slicedToArray$e(te, 2), se = ae[0], ie = ae[1], fe = reactExports.useCallback(function(be, le, ve, he) {
    var ye = G ? W.findIndex(function(Ce) {
      return Ce.data.src === le;
    }) : W.findIndex(function(Ce) {
      return Ce.id === be;
    });
    P(ye < 0 ? 0 : ye), J(!0), ie({
      x: ve,
      y: he
    }), Z(!0);
  }, [W, G]);
  reactExports.useEffect(function() {
    Q ? V || P(0) : Z(!1);
  }, [Q]);
  var ge = function(le, ve) {
    P(le), E?.(le, ve);
  }, me = function() {
    J(!1), ie(null);
  }, pe = reactExports.useMemo(function() {
    return {
      register: j,
      onPreview: fe
    };
  }, [j, fe]);
  return /* @__PURE__ */ reactExports.createElement(PreviewGroupContext.Provider, {
    value: pe
  }, p, /* @__PURE__ */ reactExports.createElement(Preview$2, _extends$3({
    "aria-hidden": !Q,
    movable: S,
    visible: Q,
    prefixCls: d,
    closeIcon: _,
    onClose: me,
    mousePosition: se,
    imgCommonProps: q,
    src: K,
    fallback: b,
    icons: A,
    minScale: $,
    maxScale: T,
    getContainer: C,
    current: N,
    count: W.length,
    countRender: I,
    onTransform: R,
    toolbarRender: O,
    imageRender: L,
    onChange: ge
  }, B)));
}, uid$1 = 0;
function useRegisterImage(a, s) {
  var c = reactExports.useState(function() {
    return uid$1 += 1, String(uid$1);
  }), u = _slicedToArray$e(c, 1), d = u[0], p = reactExports.useContext(PreviewGroupContext), v = {
    data: s,
    canPreview: a
  };
  return reactExports.useEffect(function() {
    if (p)
      return p.register(d, v);
  }, []), reactExports.useEffect(function() {
    p && p.register(d, v);
  }, [a, s]), d;
}
var _excluded$i = ["src", "alt", "onPreviewClose", "prefixCls", "previewPrefixCls", "placeholder", "fallback", "width", "height", "style", "preview", "className", "onClick", "onError", "wrapperClassName", "wrapperStyle", "rootClassName"], _excluded2$2 = ["src", "visible", "onVisibleChange", "getContainer", "mask", "maskClassName", "movable", "icons", "scaleStep", "minScale", "maxScale", "imageRender", "toolbarRender"], ImageInternal = function a(s) {
  var c = s.src, u = s.alt, d = s.onPreviewClose, p = s.prefixCls, v = p === void 0 ? "rc-image" : p, A = s.previewPrefixCls, x = A === void 0 ? "".concat(v, "-preview") : A, g = s.placeholder, b = s.fallback, y = s.width, f = s.height, m = s.style, C = s.preview, w = C === void 0 ? !0 : C, S = s.className, $ = s.onClick, T = s.onError, I = s.wrapperClassName, _ = s.wrapperStyle, E = s.rootClassName, R = _objectWithoutProperties$2(s, _excluded$i), O = g && g !== !0, L = _typeof$h(w) === "object" ? w : {}, B = L.src, F = L.visible, M = F === void 0 ? void 0 : F, W = L.onVisibleChange, j = W === void 0 ? d : W, G = L.getContainer, U = G === void 0 ? void 0 : G, k = L.mask, N = L.maskClassName, P = L.movable, D = L.icons, H = L.scaleStep, V = L.minScale, Z = L.maxScale, ne = L.imageRender, K = L.toolbarRender, q = _objectWithoutProperties$2(L, _excluded2$2), Y = B ?? c, ee = useMergedState(!!M, {
    value: M,
    onChange: j
  }), Q = _slicedToArray$e(ee, 2), J = Q[0], te = Q[1], ae = useStatus({
    src: c,
    isCustomPlaceholder: O,
    fallback: b
  }), se = _slicedToArray$e(ae, 3), ie = se[0], fe = se[1], ge = se[2], me = reactExports.useState(null), pe = _slicedToArray$e(me, 2), be = pe[0], le = pe[1], ve = reactExports.useContext(PreviewGroupContext), he = !!w, ye = function() {
    te(!1), le(null);
  }, Ce = classnames(v, I, E, _defineProperty$a({}, "".concat(v, "-error"), ge === "error")), xe = reactExports.useMemo(function() {
    var ue = {};
    return COMMON_PROPS.forEach(function(ce) {
      s[ce] !== void 0 && (ue[ce] = s[ce]);
    }), ue;
  }, COMMON_PROPS.map(function(ue) {
    return s[ue];
  })), we = reactExports.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, xe), {}, {
      src: Y
    });
  }, [Y, xe]), $e = useRegisterImage(he, we), Ae = function(ce) {
    var Ee = getOffset$2(ce.target), _e = Ee.left, Te = Ee.top;
    ve ? ve.onPreview($e, Y, _e, Te) : (le({
      x: _e,
      y: Te
    }), te(!0)), $?.(ce);
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("div", _extends$3({}, R, {
    className: Ce,
    onClick: he ? Ae : $,
    style: _objectSpread2$1({
      width: y,
      height: f
    }, _)
  }), /* @__PURE__ */ reactExports.createElement("img", _extends$3({}, xe, {
    className: classnames("".concat(v, "-img"), _defineProperty$a({}, "".concat(v, "-img-placeholder"), g === !0), S),
    style: _objectSpread2$1({
      height: f
    }, m),
    ref: ie
  }, fe, {
    width: y,
    height: f,
    onError: T
  })), ge === "loading" && /* @__PURE__ */ reactExports.createElement("div", {
    "aria-hidden": "true",
    className: "".concat(v, "-placeholder")
  }, g), k && he && /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(v, "-mask"), N),
    style: {
      display: m?.display === "none" ? "none" : void 0
    }
  }, k)), !ve && he && /* @__PURE__ */ reactExports.createElement(Preview$2, _extends$3({
    "aria-hidden": !J,
    visible: J,
    prefixCls: x,
    onClose: ye,
    mousePosition: be,
    src: Y,
    alt: u,
    imageInfo: {
      width: y,
      height: f
    },
    fallback: b,
    getContainer: U,
    icons: D,
    movable: P,
    scaleStep: H,
    minScale: V,
    maxScale: Z,
    rootClassName: E,
    imageRender: ne,
    imgCommonProps: xe,
    toolbarRender: K
  }, q)));
};
ImageInternal.PreviewGroup = Group$1;
var RotateLeftOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { tag: "path", attrs: { d: "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, name: "rotate-left", theme: "outlined" }, RotateLeftOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: RotateLeftOutlined$1
  }));
}, RefIcon$r = /* @__PURE__ */ reactExports.forwardRef(RotateLeftOutlined), RotateRightOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { tag: "path", attrs: { d: "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, name: "rotate-right", theme: "outlined" }, RotateRightOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: RotateRightOutlined$1
  }));
}, RefIcon$q = /* @__PURE__ */ reactExports.forwardRef(RotateRightOutlined), SwapOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, name: "swap", theme: "outlined" }, SwapOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: SwapOutlined$1
  }));
}, RefIcon$p = /* @__PURE__ */ reactExports.forwardRef(SwapOutlined), ZoomInOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, name: "zoom-in", theme: "outlined" }, ZoomInOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: ZoomInOutlined$1
  }));
}, RefIcon$o = /* @__PURE__ */ reactExports.forwardRef(ZoomInOutlined), ZoomOutOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, name: "zoom-out", theme: "outlined" }, ZoomOutOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: ZoomOutOutlined$1
  }));
}, RefIcon$n = /* @__PURE__ */ reactExports.forwardRef(ZoomOutOutlined);
const genBoxStyle = (a) => ({
  position: a || "absolute",
  inset: 0
}), genImageMaskStyle = (a) => {
  const {
    iconCls: s,
    motionDurationSlow: c,
    paddingXXS: u,
    marginXXS: d,
    prefixCls: p,
    colorTextLightSolid: v
  } = a;
  return {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: v,
    background: new FastColor("#000").setA(0.5).toRgbString(),
    cursor: "pointer",
    opacity: 0,
    transition: `opacity ${c}`,
    [`.${p}-mask-info`]: Object.assign(Object.assign({}, textEllipsis), {
      padding: `0 ${unit$1(u)}`,
      [s]: {
        marginInlineEnd: d,
        svg: {
          verticalAlign: "baseline"
        }
      }
    })
  };
}, genPreviewOperationsStyle = (a) => {
  const {
    previewCls: s,
    modalMaskBg: c,
    paddingSM: u,
    marginXL: d,
    margin: p,
    paddingLG: v,
    previewOperationColorDisabled: A,
    previewOperationHoverColor: x,
    motionDurationSlow: g,
    iconCls: b,
    colorTextLightSolid: y
  } = a, f = new FastColor(c).setA(0.1), m = f.clone().setA(0.2);
  return {
    [`${s}-footer`]: {
      position: "fixed",
      bottom: d,
      left: {
        _skip_check_: !0,
        value: "50%"
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: a.previewOperationColor,
      transform: "translateX(-50%)"
    },
    [`${s}-progress`]: {
      marginBottom: p
    },
    [`${s}-close`]: {
      position: "fixed",
      top: d,
      right: {
        _skip_check_: !0,
        value: d
      },
      display: "flex",
      color: y,
      backgroundColor: f.toRgbString(),
      borderRadius: "50%",
      padding: u,
      outline: 0,
      border: 0,
      cursor: "pointer",
      transition: `all ${g}`,
      "&:hover": {
        backgroundColor: m.toRgbString()
      },
      [`& > ${b}`]: {
        fontSize: a.previewOperationSize
      }
    },
    [`${s}-operations`]: {
      display: "flex",
      alignItems: "center",
      padding: `0 ${unit$1(v)}`,
      backgroundColor: f.toRgbString(),
      borderRadius: 100,
      "&-operation": {
        marginInlineStart: u,
        padding: u,
        cursor: "pointer",
        transition: `all ${g}`,
        userSelect: "none",
        [`&:not(${s}-operations-operation-disabled):hover > ${b}`]: {
          color: x
        },
        "&-disabled": {
          color: A,
          cursor: "not-allowed"
        },
        "&:first-of-type": {
          marginInlineStart: 0
        },
        [`& > ${b}`]: {
          fontSize: a.previewOperationSize
        }
      }
    }
  };
}, genPreviewSwitchStyle = (a) => {
  const {
    modalMaskBg: s,
    iconCls: c,
    previewOperationColorDisabled: u,
    previewCls: d,
    zIndexPopup: p,
    motionDurationSlow: v
  } = a, A = new FastColor(s).setA(0.1), x = A.clone().setA(0.2);
  return {
    [`${d}-switch-left, ${d}-switch-right`]: {
      position: "fixed",
      insetBlockStart: "50%",
      zIndex: a.calc(p).add(1).equal(),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: a.imagePreviewSwitchSize,
      height: a.imagePreviewSwitchSize,
      marginTop: a.calc(a.imagePreviewSwitchSize).mul(-1).div(2).equal(),
      color: a.previewOperationColor,
      background: A.toRgbString(),
      borderRadius: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      transition: `all ${v}`,
      userSelect: "none",
      "&:hover": {
        background: x.toRgbString()
      },
      "&-disabled": {
        "&, &:hover": {
          color: u,
          background: "transparent",
          cursor: "not-allowed",
          [`> ${c}`]: {
            cursor: "not-allowed"
          }
        }
      },
      [`> ${c}`]: {
        fontSize: a.previewOperationSize
      }
    },
    [`${d}-switch-left`]: {
      insetInlineStart: a.marginSM
    },
    [`${d}-switch-right`]: {
      insetInlineEnd: a.marginSM
    }
  };
}, genImagePreviewStyle = (a) => {
  const {
    motionEaseOut: s,
    previewCls: c,
    motionDurationSlow: u,
    componentCls: d
  } = a;
  return [
    {
      [`${d}-preview-root`]: {
        [c]: {
          height: "100%",
          textAlign: "center",
          pointerEvents: "none"
        },
        [`${c}-body`]: Object.assign(Object.assign({}, genBoxStyle()), {
          overflow: "hidden"
        }),
        [`${c}-img`]: {
          maxWidth: "100%",
          maxHeight: "70%",
          verticalAlign: "middle",
          transform: "scale3d(1, 1, 1)",
          cursor: "grab",
          transition: `transform ${u} ${s} 0s`,
          userSelect: "none",
          "&-wrapper": Object.assign(Object.assign({}, genBoxStyle()), {
            transition: `transform ${u} ${s} 0s`,
            // https://github.com/ant-design/ant-design/issues/39913
            // TailwindCSS will reset img default style.
            // Let's set back.
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& > *": {
              pointerEvents: "auto"
            },
            "&::before": {
              display: "inline-block",
              width: 1,
              height: "50%",
              marginInlineEnd: -1,
              content: '""'
            }
          })
        },
        [`${c}-moving`]: {
          [`${c}-preview-img`]: {
            cursor: "grabbing",
            "&-wrapper": {
              transitionDuration: "0s"
            }
          }
        }
      }
    },
    // Override
    {
      [`${d}-preview-root`]: {
        [`${c}-wrap`]: {
          zIndex: a.zIndexPopup
        }
      }
    },
    // Preview operations & switch
    {
      [`${d}-preview-operations-wrapper`]: {
        position: "fixed",
        zIndex: a.calc(a.zIndexPopup).add(1).equal()
      },
      "&": [genPreviewOperationsStyle(a), genPreviewSwitchStyle(a)]
    }
  ];
}, genImageStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    // ============================== image ==============================
    [s]: {
      position: "relative",
      display: "inline-block",
      [`${s}-img`]: {
        width: "100%",
        height: "auto",
        verticalAlign: "middle"
      },
      [`${s}-img-placeholder`]: {
        backgroundColor: a.colorBgContainerDisabled,
        backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "30%"
      },
      [`${s}-mask`]: Object.assign({}, genImageMaskStyle(a)),
      [`${s}-mask:hover`]: {
        opacity: 1
      },
      [`${s}-placeholder`]: Object.assign({}, genBoxStyle())
    }
  };
}, genPreviewMotion = (a) => {
  const {
    previewCls: s
  } = a;
  return {
    [`${s}-root`]: initZoomMotion(a, "zoom"),
    "&": initFadeMotion(a, !0)
  };
}, prepareComponentToken$b = (a) => ({
  zIndexPopup: a.zIndexPopupBase + 80,
  previewOperationColor: new FastColor(a.colorTextLightSolid).setA(0.65).toRgbString(),
  previewOperationHoverColor: new FastColor(a.colorTextLightSolid).setA(0.85).toRgbString(),
  previewOperationColorDisabled: new FastColor(a.colorTextLightSolid).setA(0.25).toRgbString(),
  previewOperationSize: a.fontSizeIcon * 1.5
  // FIXME: fontSizeIconLG
}), useStyle$d = genStyleHooks("Image", (a) => {
  const s = `${a.componentCls}-preview`, c = merge(a, {
    previewCls: s,
    modalMaskBg: new FastColor("#000").setA(0.45).toRgbString(),
    // FIXME: Shared Token
    imagePreviewSwitchSize: a.controlHeightLG
  });
  return [genImageStyle(c), genImagePreviewStyle(c), genModalMaskStyle(merge(c, {
    componentCls: s
  })), genPreviewMotion(c)];
}, prepareComponentToken$b);
var __rest$q = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const icons$1 = {
  rotateLeft: /* @__PURE__ */ reactExports.createElement(RefIcon$r, null),
  rotateRight: /* @__PURE__ */ reactExports.createElement(RefIcon$q, null),
  zoomIn: /* @__PURE__ */ reactExports.createElement(RefIcon$o, null),
  zoomOut: /* @__PURE__ */ reactExports.createElement(RefIcon$n, null),
  close: /* @__PURE__ */ reactExports.createElement(RefIcon$I, null),
  left: /* @__PURE__ */ reactExports.createElement(RefIcon$A, null),
  right: /* @__PURE__ */ reactExports.createElement(RefIcon$E, null),
  flipX: /* @__PURE__ */ reactExports.createElement(RefIcon$p, null),
  flipY: /* @__PURE__ */ reactExports.createElement(RefIcon$p, {
    rotate: 90
  })
}, InternalPreviewGroup = (a) => {
  var {
    previewPrefixCls: s,
    preview: c
  } = a, u = __rest$q(a, ["previewPrefixCls", "preview"]);
  const {
    getPrefixCls: d,
    direction: p
  } = reactExports.useContext(ConfigContext$1), v = d("image", s), A = `${v}-preview`, x = d(), g = useCSSVarCls(v), [b, y, f] = useStyle$d(v, g), [m] = useZIndex("ImagePreview", typeof c == "object" ? c.zIndex : void 0), C = reactExports.useMemo(() => Object.assign(Object.assign({}, icons$1), {
    left: p === "rtl" ? /* @__PURE__ */ reactExports.createElement(RefIcon$E, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$A, null),
    right: p === "rtl" ? /* @__PURE__ */ reactExports.createElement(RefIcon$A, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$E, null)
  }), [p]), w = reactExports.useMemo(() => {
    var S;
    if (c === !1)
      return c;
    const $ = typeof c == "object" ? c : {}, T = classnames(y, f, g, (S = $.rootClassName) !== null && S !== void 0 ? S : "");
    return Object.assign(Object.assign({}, $), {
      transitionName: getTransitionName$1(x, "zoom", $.transitionName),
      maskTransitionName: getTransitionName$1(x, "fade", $.maskTransitionName),
      rootClassName: T,
      zIndex: m
    });
  }, [c]);
  return b(/* @__PURE__ */ reactExports.createElement(ImageInternal.PreviewGroup, Object.assign({
    preview: w,
    previewPrefixCls: A,
    icons: C
  }, u)));
};
var __rest$p = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Image$1 = (a) => {
  const {
    prefixCls: s,
    preview: c,
    className: u,
    rootClassName: d,
    style: p
  } = a, v = __rest$p(a, ["prefixCls", "preview", "className", "rootClassName", "style"]), {
    getPrefixCls: A,
    getPopupContainer: x,
    className: g,
    style: b,
    preview: y
  } = useComponentConfig("image"), [f] = useLocale$1("Image"), m = A("image", s), C = A(), w = useCSSVarCls(m), [S, $, T] = useStyle$d(m, w), I = classnames(d, $, T, w), _ = classnames(u, $, g), [E] = useZIndex("ImagePreview", typeof c == "object" ? c.zIndex : void 0), R = reactExports.useMemo(() => {
    if (c === !1)
      return c;
    const L = typeof c == "object" ? c : {}, {
      getContainer: B,
      closeIcon: F,
      rootClassName: M,
      destroyOnClose: W,
      destroyOnHidden: j
    } = L, G = __rest$p(L, ["getContainer", "closeIcon", "rootClassName", "destroyOnClose", "destroyOnHidden"]);
    return Object.assign(Object.assign({
      mask: /* @__PURE__ */ reactExports.createElement("div", {
        className: `${m}-mask-info`
      }, /* @__PURE__ */ reactExports.createElement(RefIcon$s, null), f?.preview),
      icons: icons$1
    }, G), {
      // TODO: In the future, destroyOnClose in rc-image needs to be upgrade to destroyOnHidden
      destroyOnClose: j ?? W,
      rootClassName: classnames(I, M),
      getContainer: B ?? x,
      transitionName: getTransitionName$1(C, "zoom", L.transitionName),
      maskTransitionName: getTransitionName$1(C, "fade", L.maskTransitionName),
      zIndex: E,
      closeIcon: F ?? y?.closeIcon
    });
  }, [c, f, y?.closeIcon]), O = Object.assign(Object.assign({}, b), p);
  return S(/* @__PURE__ */ reactExports.createElement(ImageInternal, Object.assign({
    prefixCls: m,
    preview: R,
    rootClassName: I,
    className: _,
    style: O
  }, v)));
};
Image$1.PreviewGroup = InternalPreviewGroup;
const Group = (a) => {
  const {
    getPrefixCls: s,
    direction: c
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: u,
    className: d
  } = a, p = s("input-group", u), v = s("input"), [A, x, g] = useStyle$n(v), b = classnames(p, g, {
    [`${p}-lg`]: a.size === "large",
    [`${p}-sm`]: a.size === "small",
    [`${p}-compact`]: a.compact,
    [`${p}-rtl`]: c === "rtl"
  }, x, d), y = reactExports.useContext(FormItemInputContext), f = reactExports.useMemo(() => Object.assign(Object.assign({}, y), {
    isFormItemInput: !1
  }), [y]);
  return A(/* @__PURE__ */ reactExports.createElement("span", {
    className: b,
    style: a.style,
    onMouseEnter: a.onMouseEnter,
    onMouseLeave: a.onMouseLeave,
    onFocus: a.onFocus,
    onBlur: a.onBlur
  }, /* @__PURE__ */ reactExports.createElement(FormItemInputContext.Provider, {
    value: f
  }, a.children)));
}, genOTPStyle = (a) => {
  const {
    componentCls: s,
    paddingXS: c
  } = a;
  return {
    [s]: {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      columnGap: c,
      [`${s}-input-wrapper`]: {
        position: "relative",
        [`${s}-mask-icon`]: {
          position: "absolute",
          zIndex: "1",
          top: "50%",
          right: "50%",
          transform: "translate(50%, -50%)",
          pointerEvents: "none"
        },
        [`${s}-mask-input`]: {
          color: "transparent",
          caretColor: "var(--ant-color-text)"
        },
        [`${s}-mask-input[type=number]::-webkit-inner-spin-button`]: {
          "-webkit-appearance": "none",
          margin: 0
        },
        [`${s}-mask-input[type=number]`]: {
          "-moz-appearance": "textfield"
        }
      },
      "&-rtl": {
        direction: "rtl"
      },
      [`${s}-input`]: {
        textAlign: "center",
        paddingInline: a.paddingXXS
      },
      // ================= Size =================
      [`&${s}-sm ${s}-input`]: {
        paddingInline: a.calc(a.paddingXXS).div(2).equal()
      },
      [`&${s}-lg ${s}-input`]: {
        paddingInline: a.paddingXS
      }
    }
  };
}, useStyle$c = genStyleHooks(["Input", "OTP"], (a) => {
  const s = merge(a, initInputToken(a));
  return [genOTPStyle(s)];
}, initComponentToken$1);
var __rest$o = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const OTPInput = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    className: c,
    value: u,
    onChange: d,
    onActiveChange: p,
    index: v,
    mask: A
  } = a, x = __rest$o(a, ["className", "value", "onChange", "onActiveChange", "index", "mask"]), {
    getPrefixCls: g
  } = reactExports.useContext(ConfigContext$1), b = g("otp"), y = typeof A == "string" ? A : u, f = reactExports.useRef(null);
  reactExports.useImperativeHandle(s, () => f.current);
  const m = ($) => {
    d(v, $.target.value);
  }, C = () => {
    wrapperRaf(() => {
      var $;
      const T = ($ = f.current) === null || $ === void 0 ? void 0 : $.input;
      document.activeElement === T && T && T.select();
    });
  }, w = ($) => {
    const {
      key: T,
      ctrlKey: I,
      metaKey: _
    } = $;
    T === "ArrowLeft" ? p(v - 1) : T === "ArrowRight" ? p(v + 1) : T === "z" && (I || _) && $.preventDefault(), C();
  }, S = ($) => {
    $.key === "Backspace" && !u && p(v - 1), C();
  };
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: `${b}-input-wrapper`,
    role: "presentation"
  }, A && u !== "" && u !== void 0 && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${b}-mask-icon`,
    "aria-hidden": "true"
  }, y), /* @__PURE__ */ reactExports.createElement(Input$2, Object.assign({
    "aria-label": `OTP Input ${v + 1}`,
    type: A === !0 ? "password" : "text"
  }, x, {
    ref: f,
    value: u,
    onInput: m,
    onFocus: C,
    onKeyDown: w,
    onKeyUp: S,
    onMouseDown: C,
    onMouseUp: C,
    className: classnames(c, {
      [`${b}-mask-input`]: A
    })
  })));
});
var __rest$n = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function strToArr(a) {
  return (a || "").split("");
}
const Separator = (a) => {
  const {
    index: s,
    prefixCls: c,
    separator: u
  } = a, d = typeof u == "function" ? u(s) : u;
  return d ? /* @__PURE__ */ reactExports.createElement("span", {
    className: `${c}-separator`
  }, d) : null;
}, OTP = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    length: u = 6,
    size: d,
    defaultValue: p,
    value: v,
    onChange: A,
    formatter: x,
    separator: g,
    variant: b,
    disabled: y,
    status: f,
    autoFocus: m,
    mask: C,
    type: w,
    onInput: S,
    inputMode: $
  } = a, T = __rest$n(a, ["prefixCls", "length", "size", "defaultValue", "value", "onChange", "formatter", "separator", "variant", "disabled", "status", "autoFocus", "mask", "type", "onInput", "inputMode"]), {
    getPrefixCls: I,
    direction: _
  } = reactExports.useContext(ConfigContext$1), E = I("otp", c), R = pickAttrs(T, {
    aria: !0,
    data: !0,
    attr: !0
  }), [O, L, B] = useStyle$c(E), F = useSize((K) => d ?? K), M = reactExports.useContext(FormItemInputContext), W = getMergedStatus(M.status, f), j = reactExports.useMemo(() => Object.assign(Object.assign({}, M), {
    status: W,
    hasFeedback: !1,
    feedbackIcon: null
  }), [M, W]), G = reactExports.useRef(null), U = reactExports.useRef({});
  reactExports.useImperativeHandle(s, () => ({
    focus: () => {
      var K;
      (K = U.current[0]) === null || K === void 0 || K.focus();
    },
    blur: () => {
      var K;
      for (let q = 0; q < u; q += 1)
        (K = U.current[q]) === null || K === void 0 || K.blur();
    },
    nativeElement: G.current
  }));
  const k = (K) => x ? x(K) : K, [N, P] = reactExports.useState(() => strToArr(k(p || "")));
  reactExports.useEffect(() => {
    v !== void 0 && P(strToArr(v));
  }, [v]);
  const D = useEvent((K) => {
    P(K), S && S(K), A && K.length === u && K.every((q) => q) && K.some((q, Y) => N[Y] !== q) && A(K.join(""));
  }), H = useEvent((K, q) => {
    let Y = _toConsumableArray$e(N);
    for (let Q = 0; Q < K; Q += 1)
      Y[Q] || (Y[Q] = "");
    q.length <= 1 ? Y[K] = q : Y = Y.slice(0, K).concat(strToArr(q)), Y = Y.slice(0, u);
    for (let Q = Y.length - 1; Q >= 0 && !Y[Q]; Q -= 1)
      Y.pop();
    const ee = k(Y.map((Q) => Q || " ").join(""));
    return Y = strToArr(ee).map((Q, J) => Q === " " && !Y[J] ? Y[J] : Q), Y;
  }), V = (K, q) => {
    var Y;
    const ee = H(K, q), Q = Math.min(K + q.length, u - 1);
    Q !== K && ee[K] !== void 0 && ((Y = U.current[Q]) === null || Y === void 0 || Y.focus()), D(ee);
  }, Z = (K) => {
    var q;
    (q = U.current[K]) === null || q === void 0 || q.focus();
  }, ne = {
    variant: b,
    disabled: y,
    status: W,
    mask: C,
    type: w,
    inputMode: $
  };
  return O(/* @__PURE__ */ reactExports.createElement("div", Object.assign({}, R, {
    ref: G,
    className: classnames(E, {
      [`${E}-sm`]: F === "small",
      [`${E}-lg`]: F === "large",
      [`${E}-rtl`]: _ === "rtl"
    }, B, L),
    role: "group"
  }), /* @__PURE__ */ reactExports.createElement(FormItemInputContext.Provider, {
    value: j
  }, Array.from({
    length: u
  }).map((K, q) => {
    const Y = `otp-${q}`, ee = N[q] || "";
    return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, {
      key: Y
    }, /* @__PURE__ */ reactExports.createElement(OTPInput, Object.assign({
      ref: (Q) => {
        U.current[q] = Q;
      },
      index: q,
      size: F,
      htmlSize: 1,
      className: `${E}-input`,
      onChange: V,
      value: ee,
      onActiveChange: Z,
      autoFocus: q === 0 && m
    }, ne)), q < u - 1 && /* @__PURE__ */ reactExports.createElement(Separator, {
      separator: g,
      index: q,
      prefixCls: E
    }));
  }))));
});
var EyeInvisibleOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" }, EyeInvisibleOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: EyeInvisibleOutlined$1
  }));
}, RefIcon$m = /* @__PURE__ */ reactExports.forwardRef(EyeInvisibleOutlined), __rest$m = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const defaultIconRender = (a) => a ? /* @__PURE__ */ reactExports.createElement(RefIcon$s, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$m, null), actionMap = {
  click: "onClick",
  hover: "onMouseOver"
}, Password = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    disabled: c,
    action: u = "click",
    visibilityToggle: d = !0,
    iconRender: p = defaultIconRender
  } = a, v = reactExports.useContext(DisabledContext), A = c ?? v, x = typeof d == "object" && d.visible !== void 0, [g, b] = reactExports.useState(() => x ? d.visible : !1), y = reactExports.useRef(null);
  reactExports.useEffect(() => {
    x && b(d.visible);
  }, [x, d]);
  const f = useRemovePasswordTimeout(y), m = () => {
    var F;
    if (A)
      return;
    g && f();
    const M = !g;
    b(M), typeof d == "object" && ((F = d.onVisibleChange) === null || F === void 0 || F.call(d, M));
  }, C = (F) => {
    const M = actionMap[u] || "", W = p(g), j = {
      [M]: m,
      className: `${F}-icon`,
      key: "passwordIcon",
      onMouseDown: (G) => {
        G.preventDefault();
      },
      onMouseUp: (G) => {
        G.preventDefault();
      }
    };
    return /* @__PURE__ */ reactExports.cloneElement(/* @__PURE__ */ reactExports.isValidElement(W) ? W : /* @__PURE__ */ reactExports.createElement("span", null, W), j);
  }, {
    className: w,
    prefixCls: S,
    inputPrefixCls: $,
    size: T
  } = a, I = __rest$m(a, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: _
  } = reactExports.useContext(ConfigContext$1), E = _("input", $), R = _("input-password", S), O = d && C(R), L = classnames(R, w, {
    [`${R}-${T}`]: !!T
  }), B = Object.assign(Object.assign({}, omit(I, ["suffix", "iconRender", "visibilityToggle"])), {
    type: g ? "text" : "password",
    className: L,
    prefixCls: E,
    suffix: O
  });
  return T && (B.size = T), /* @__PURE__ */ reactExports.createElement(Input$2, Object.assign({
    ref: composeRef(s, y)
  }, B));
});
var __rest$l = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Search = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    inputPrefixCls: u,
    className: d,
    size: p,
    suffix: v,
    enterButton: A = !1,
    addonAfter: x,
    loading: g,
    disabled: b,
    onSearch: y,
    onChange: f,
    onCompositionStart: m,
    onCompositionEnd: C,
    variant: w,
    onPressEnter: S
  } = a, $ = __rest$l(a, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd", "variant", "onPressEnter"]), {
    getPrefixCls: T,
    direction: I
  } = reactExports.useContext(ConfigContext$1), _ = reactExports.useRef(!1), E = T("input-search", c), R = T("input", u), {
    compactSize: O
  } = useCompactItemContext(E, I), L = useSize((ne) => {
    var K;
    return (K = p ?? O) !== null && K !== void 0 ? K : ne;
  }), B = reactExports.useRef(null), F = (ne) => {
    ne?.target && ne.type === "click" && y && y(ne.target.value, ne, {
      source: "clear"
    }), f?.(ne);
  }, M = (ne) => {
    var K;
    document.activeElement === ((K = B.current) === null || K === void 0 ? void 0 : K.input) && ne.preventDefault();
  }, W = (ne) => {
    var K, q;
    y && y((q = (K = B.current) === null || K === void 0 ? void 0 : K.input) === null || q === void 0 ? void 0 : q.value, ne, {
      source: "input"
    });
  }, j = (ne) => {
    _.current || g || (S?.(ne), W(ne));
  }, G = typeof A == "boolean" ? /* @__PURE__ */ reactExports.createElement(RefIcon$B, null) : null, U = `${E}-button`;
  let k;
  const N = A || {}, P = N.type && N.type.__ANT_BUTTON === !0;
  P || N.type === "button" ? k = cloneElement(N, Object.assign({
    onMouseDown: M,
    onClick: (ne) => {
      var K, q;
      (q = (K = N?.props) === null || K === void 0 ? void 0 : K.onClick) === null || q === void 0 || q.call(K, ne), W(ne);
    },
    key: "enterButton"
  }, P ? {
    className: U,
    size: L
  } : {})) : k = /* @__PURE__ */ reactExports.createElement(Button$1, {
    className: U,
    color: A ? "primary" : "default",
    size: L,
    disabled: b,
    key: "enterButton",
    onMouseDown: M,
    onClick: W,
    loading: g,
    icon: G,
    variant: w === "borderless" || w === "filled" || w === "underlined" ? "text" : A ? "solid" : void 0
  }, A), x && (k = [k, cloneElement(x, {
    key: "addonAfter"
  })]);
  const D = classnames(E, {
    [`${E}-rtl`]: I === "rtl",
    [`${E}-${L}`]: !!L,
    [`${E}-with-button`]: !!A
  }, d), H = (ne) => {
    _.current = !0, m?.(ne);
  }, V = (ne) => {
    _.current = !1, C?.(ne);
  }, Z = Object.assign(Object.assign({}, $), {
    className: D,
    prefixCls: R,
    type: "search",
    size: L,
    variant: w,
    onPressEnter: j,
    onCompositionStart: H,
    onCompositionEnd: V,
    addonAfter: k,
    suffix: v,
    onChange: F,
    disabled: b
  });
  return /* @__PURE__ */ reactExports.createElement(Input$2, Object.assign({
    ref: composeRef(B, s)
  }, Z));
});
var HIDDEN_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, SIZING_STYLE = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], computedStyleCache = {}, hiddenTextarea;
function calculateNodeStyling(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = a.getAttribute("id") || a.getAttribute("data-reactid") || a.getAttribute("name");
  if (s && computedStyleCache[c])
    return computedStyleCache[c];
  var u = window.getComputedStyle(a), d = u.getPropertyValue("box-sizing") || u.getPropertyValue("-moz-box-sizing") || u.getPropertyValue("-webkit-box-sizing"), p = parseFloat(u.getPropertyValue("padding-bottom")) + parseFloat(u.getPropertyValue("padding-top")), v = parseFloat(u.getPropertyValue("border-bottom-width")) + parseFloat(u.getPropertyValue("border-top-width")), A = SIZING_STYLE.map(function(g) {
    return "".concat(g, ":").concat(u.getPropertyValue(g));
  }).join(";"), x = {
    sizingStyle: A,
    paddingSize: p,
    borderSize: v,
    boxSizing: d
  };
  return s && c && (computedStyleCache[c] = x), x;
}
function calculateAutoSizeStyle(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  hiddenTextarea || (hiddenTextarea = document.createElement("textarea"), hiddenTextarea.setAttribute("tab-index", "-1"), hiddenTextarea.setAttribute("aria-hidden", "true"), hiddenTextarea.setAttribute("name", "hiddenTextarea"), document.body.appendChild(hiddenTextarea)), a.getAttribute("wrap") ? hiddenTextarea.setAttribute("wrap", a.getAttribute("wrap")) : hiddenTextarea.removeAttribute("wrap");
  var d = calculateNodeStyling(a, s), p = d.paddingSize, v = d.borderSize, A = d.boxSizing, x = d.sizingStyle;
  hiddenTextarea.setAttribute("style", "".concat(x, ";").concat(HIDDEN_TEXTAREA_STYLE)), hiddenTextarea.value = a.value || a.placeholder || "";
  var g = void 0, b = void 0, y, f = hiddenTextarea.scrollHeight;
  if (A === "border-box" ? f += v : A === "content-box" && (f -= p), c !== null || u !== null) {
    hiddenTextarea.value = " ";
    var m = hiddenTextarea.scrollHeight - p;
    c !== null && (g = m * c, A === "border-box" && (g = g + p + v), f = Math.max(g, f)), u !== null && (b = m * u, A === "border-box" && (b = b + p + v), y = f > b ? "" : "hidden", f = Math.min(b, f));
  }
  var C = {
    height: f,
    overflowY: y,
    resize: "none"
  };
  return g && (C.minHeight = g), b && (C.maxHeight = b), C;
}
var _excluded$h = ["prefixCls", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], RESIZE_START = 0, RESIZE_MEASURING = 1, RESIZE_STABLE = 2, ResizableTextArea = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a, u = c.prefixCls, d = c.defaultValue, p = c.value, v = c.autoSize, A = c.onResize, x = c.className, g = c.style, b = c.disabled, y = c.onChange;
  c.onInternalAutoSize;
  var f = _objectWithoutProperties$2(c, _excluded$h), m = useMergedState(d, {
    value: p,
    postState: function(K) {
      return K ?? "";
    }
  }), C = _slicedToArray$e(m, 2), w = C[0], S = C[1], $ = function(K) {
    S(K.target.value), y?.(K);
  }, T = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return {
      textArea: T.current
    };
  });
  var I = reactExports.useMemo(function() {
    return v && _typeof$h(v) === "object" ? [v.minRows, v.maxRows] : [];
  }, [v]), _ = _slicedToArray$e(I, 2), E = _[0], R = _[1], O = !!v, L = function() {
    try {
      if (document.activeElement === T.current) {
        var K = T.current, q = K.selectionStart, Y = K.selectionEnd, ee = K.scrollTop;
        T.current.setSelectionRange(q, Y), T.current.scrollTop = ee;
      }
    } catch {
    }
  }, B = reactExports.useState(RESIZE_STABLE), F = _slicedToArray$e(B, 2), M = F[0], W = F[1], j = reactExports.useState(), G = _slicedToArray$e(j, 2), U = G[0], k = G[1], N = function() {
    W(RESIZE_START);
  };
  useLayoutEffect$1(function() {
    O && N();
  }, [p, E, R, O]), useLayoutEffect$1(function() {
    if (M === RESIZE_START)
      W(RESIZE_MEASURING);
    else if (M === RESIZE_MEASURING) {
      var ne = calculateAutoSizeStyle(T.current, !1, E, R);
      W(RESIZE_STABLE), k(ne);
    } else
      L();
  }, [M]);
  var P = reactExports.useRef(), D = function() {
    wrapperRaf.cancel(P.current);
  }, H = function(K) {
    M === RESIZE_STABLE && (A?.(K), v && (D(), P.current = wrapperRaf(function() {
      N();
    })));
  };
  reactExports.useEffect(function() {
    return D;
  }, []);
  var V = O ? U : null, Z = _objectSpread2$1(_objectSpread2$1({}, g), V);
  return (M === RESIZE_START || M === RESIZE_MEASURING) && (Z.overflowY = "hidden", Z.overflowX = "hidden"), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: H,
    disabled: !(v || A)
  }, /* @__PURE__ */ reactExports.createElement("textarea", _extends$3({}, f, {
    ref: T,
    style: Z,
    className: classnames(u, x, _defineProperty$a({}, "".concat(u, "-disabled"), b)),
    disabled: b,
    value: w,
    onChange: $
  })));
}), _excluded$g = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "onClear", "onPressEnter", "readOnly", "autoSize", "onKeyDown"], TextArea$4 = /* @__PURE__ */ React.forwardRef(function(a, s) {
  var c, u = a.defaultValue, d = a.value, p = a.onFocus, v = a.onBlur, A = a.onChange, x = a.allowClear, g = a.maxLength, b = a.onCompositionStart, y = a.onCompositionEnd, f = a.suffix, m = a.prefixCls, C = m === void 0 ? "rc-textarea" : m, w = a.showCount, S = a.count, $ = a.className, T = a.style, I = a.disabled, _ = a.hidden, E = a.classNames, R = a.styles, O = a.onResize, L = a.onClear, B = a.onPressEnter, F = a.readOnly, M = a.autoSize, W = a.onKeyDown, j = _objectWithoutProperties$2(a, _excluded$g), G = useMergedState(u, {
    value: d,
    defaultValue: u
  }), U = _slicedToArray$e(G, 2), k = U[0], N = U[1], P = k == null ? "" : String(k), D = React.useState(!1), H = _slicedToArray$e(D, 2), V = H[0], Z = H[1], ne = React.useRef(!1), K = React.useState(null), q = _slicedToArray$e(K, 2), Y = q[0], ee = q[1], Q = reactExports.useRef(null), J = reactExports.useRef(null), te = function() {
    var Re;
    return (Re = J.current) === null || Re === void 0 ? void 0 : Re.textArea;
  }, ae = function() {
    te().focus();
  };
  reactExports.useImperativeHandle(s, function() {
    var ke;
    return {
      resizableTextArea: J.current,
      focus: ae,
      blur: function() {
        te().blur();
      },
      nativeElement: ((ke = Q.current) === null || ke === void 0 ? void 0 : ke.nativeElement) || te()
    };
  }), reactExports.useEffect(function() {
    Z(function(ke) {
      return !I && ke;
    });
  }, [I]);
  var se = React.useState(null), ie = _slicedToArray$e(se, 2), fe = ie[0], ge = ie[1];
  React.useEffect(function() {
    if (fe) {
      var ke;
      (ke = te()).setSelectionRange.apply(ke, _toConsumableArray$e(fe));
    }
  }, [fe]);
  var me = useCount(S, w), pe = (c = me.max) !== null && c !== void 0 ? c : g, be = Number(pe) > 0, le = me.strategy(P), ve = !!pe && le > pe, he = function(Re, Be) {
    var Oe = Be;
    !ne.current && me.exceedFormatter && me.max && me.strategy(Be) > me.max && (Oe = me.exceedFormatter(Be, {
      max: me.max
    }), Be !== Oe && ge([te().selectionStart || 0, te().selectionEnd || 0])), N(Oe), resolveOnChange(Re.currentTarget, Re, A, Oe);
  }, ye = function(Re) {
    ne.current = !0, b?.(Re);
  }, Ce = function(Re) {
    ne.current = !1, he(Re, Re.currentTarget.value), y?.(Re);
  }, xe = function(Re) {
    he(Re, Re.target.value);
  }, we = function(Re) {
    Re.key === "Enter" && B && B(Re), W?.(Re);
  }, $e = function(Re) {
    Z(!0), p?.(Re);
  }, Ae = function(Re) {
    Z(!1), v?.(Re);
  }, ue = function(Re) {
    N(""), ae(), resolveOnChange(te(), Re, A);
  }, ce = f, Ee;
  me.show && (me.showFormatter ? Ee = me.showFormatter({
    value: P,
    count: le,
    maxLength: pe
  }) : Ee = "".concat(le).concat(be ? " / ".concat(pe) : ""), ce = /* @__PURE__ */ React.createElement(React.Fragment, null, ce, /* @__PURE__ */ React.createElement("span", {
    className: classnames("".concat(C, "-data-count"), E?.count),
    style: R?.count
  }, Ee)));
  var _e = function(Re) {
    var Be;
    O?.(Re), (Be = te()) !== null && Be !== void 0 && Be.style.height && ee(!0);
  }, Te = !M && !w && !x;
  return /* @__PURE__ */ React.createElement(BaseInput, {
    ref: Q,
    value: P,
    allowClear: x,
    handleReset: ue,
    suffix: ce,
    prefixCls: C,
    classNames: _objectSpread2$1(_objectSpread2$1({}, E), {}, {
      affixWrapper: classnames(E?.affixWrapper, _defineProperty$a(_defineProperty$a({}, "".concat(C, "-show-count"), w), "".concat(C, "-textarea-allow-clear"), x))
    }),
    disabled: I,
    focused: V,
    className: classnames($, ve && "".concat(C, "-out-of-range")),
    style: _objectSpread2$1(_objectSpread2$1({}, T), Y && !Te ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof Ee == "string" ? Ee : void 0
      }
    },
    hidden: _,
    readOnly: F,
    onClear: L
  }, /* @__PURE__ */ React.createElement(ResizableTextArea, _extends$3({}, j, {
    autoSize: M,
    maxLength: g,
    onKeyDown: we,
    onChange: xe,
    onFocus: $e,
    onBlur: Ae,
    onCompositionStart: ye,
    onCompositionEnd: Ce,
    className: classnames(E?.textarea),
    style: _objectSpread2$1(_objectSpread2$1({}, R?.textarea), {}, {
      resize: T?.resize
    }),
    disabled: I,
    prefixCls: C,
    onResize: _e,
    ref: J,
    readOnly: F
  })));
});
const genTextAreaStyle = (a) => {
  const {
    componentCls: s,
    paddingLG: c
  } = a, u = `${s}-textarea`;
  return {
    // Raw Textarea
    [`textarea${s}`]: {
      maxWidth: "100%",
      // prevent textarea resize from coming out of its container
      height: "auto",
      minHeight: a.controlHeight,
      lineHeight: a.lineHeight,
      verticalAlign: "bottom",
      transition: `all ${a.motionDurationSlow}`,
      resize: "vertical",
      [`&${s}-mouse-active`]: {
        transition: `all ${a.motionDurationSlow}, height 0s, width 0s`
      }
    },
    // Wrapper for resize
    [`${s}-textarea-affix-wrapper-resize-dirty`]: {
      width: "auto"
    },
    [u]: {
      position: "relative",
      "&-show-count": {
        [`${s}-data-count`]: {
          position: "absolute",
          bottom: a.calc(a.fontSize).mul(a.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: a.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      [`
        &-allow-clear > ${s},
        &-affix-wrapper${u}-has-feedback ${s}
      `]: {
        paddingInlineEnd: c
      },
      [`&-affix-wrapper${s}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${s}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          minHeight: a.calc(a.controlHeight).sub(a.calc(a.lineWidth).mul(2)).equal(),
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${s}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${s}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: a.paddingInline,
            insetBlockStart: a.paddingXS
          },
          // Feedback Icon
          [`${u}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: a.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      },
      [`&-affix-wrapper${s}-affix-wrapper-rtl`]: {
        [`${s}-suffix`]: {
          [`${s}-data-count`]: {
            direction: "ltr",
            insetInlineStart: 0
          }
        }
      },
      [`&-affix-wrapper${s}-affix-wrapper-sm`]: {
        [`${s}-suffix`]: {
          [`${s}-clear-icon`]: {
            insetInlineEnd: a.paddingInlineSM
          }
        }
      }
    }
  };
}, useStyle$b = genStyleHooks(["Input", "TextArea"], (a) => {
  const s = merge(a, initInputToken(a));
  return [genTextAreaStyle(s)];
}, initComponentToken$1, {
  resetFont: !1
});
var __rest$k = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const TextArea$3 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var c;
  const {
    prefixCls: u,
    bordered: d = !0,
    size: p,
    disabled: v,
    status: A,
    allowClear: x,
    classNames: g,
    rootClassName: b,
    className: y,
    style: f,
    styles: m,
    variant: C,
    showCount: w,
    onMouseDown: S,
    onResize: $
  } = a, T = __rest$k(a, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant", "showCount", "onMouseDown", "onResize"]), {
    getPrefixCls: I,
    direction: _,
    allowClear: E,
    autoComplete: R,
    className: O,
    style: L,
    classNames: B,
    styles: F
  } = useComponentConfig("textArea"), M = reactExports.useContext(DisabledContext), W = v ?? M, {
    status: j,
    hasFeedback: G,
    feedbackIcon: U
  } = reactExports.useContext(FormItemInputContext), k = getMergedStatus(j, A), N = reactExports.useRef(null);
  reactExports.useImperativeHandle(s, () => {
    var me;
    return {
      resizableTextArea: (me = N.current) === null || me === void 0 ? void 0 : me.resizableTextArea,
      focus: (pe) => {
        var be, le;
        triggerFocus((le = (be = N.current) === null || be === void 0 ? void 0 : be.resizableTextArea) === null || le === void 0 ? void 0 : le.textArea, pe);
      },
      blur: () => {
        var pe;
        return (pe = N.current) === null || pe === void 0 ? void 0 : pe.blur();
      }
    };
  });
  const P = I("input", u), D = useCSSVarCls(P), [H, V, Z] = useSharedStyle(P, b), [ne] = useStyle$b(P, D), {
    compactSize: K,
    compactItemClassnames: q
  } = useCompactItemContext(P, _), Y = useSize((me) => {
    var pe;
    return (pe = p ?? K) !== null && pe !== void 0 ? pe : me;
  }), [ee, Q] = useVariant("textArea", C, d), J = getAllowClear(x ?? E), [te, ae] = reactExports.useState(!1), [se, ie] = reactExports.useState(!1), fe = (me) => {
    ae(!0), S?.(me);
    const pe = () => {
      ae(!1), document.removeEventListener("mouseup", pe);
    };
    document.addEventListener("mouseup", pe);
  }, ge = (me) => {
    var pe, be;
    if ($?.(me), te && typeof getComputedStyle == "function") {
      const le = (be = (pe = N.current) === null || pe === void 0 ? void 0 : pe.nativeElement) === null || be === void 0 ? void 0 : be.querySelector("textarea");
      le && getComputedStyle(le).resize === "both" && ie(!0);
    }
  };
  return H(ne(/* @__PURE__ */ reactExports.createElement(TextArea$4, Object.assign({
    autoComplete: R
  }, T, {
    style: Object.assign(Object.assign({}, L), f),
    styles: Object.assign(Object.assign({}, F), m),
    disabled: W,
    allowClear: J,
    className: classnames(
      Z,
      D,
      y,
      b,
      q,
      O,
      // Only for wrapper
      se && `${P}-textarea-affix-wrapper-resize-dirty`
    ),
    classNames: Object.assign(Object.assign(Object.assign({}, g), B), {
      textarea: classnames({
        [`${P}-sm`]: Y === "small",
        [`${P}-lg`]: Y === "large"
      }, V, g?.textarea, B.textarea, te && `${P}-mouse-active`),
      variant: classnames({
        [`${P}-${ee}`]: Q
      }, getStatusClassNames(P, k)),
      affixWrapper: classnames(`${P}-textarea-affix-wrapper`, {
        [`${P}-affix-wrapper-rtl`]: _ === "rtl",
        [`${P}-affix-wrapper-sm`]: Y === "small",
        [`${P}-affix-wrapper-lg`]: Y === "large",
        [`${P}-textarea-show-count`]: w || ((c = a.count) === null || c === void 0 ? void 0 : c.show)
      }, V)
    }),
    prefixCls: P,
    suffix: G && /* @__PURE__ */ reactExports.createElement("span", {
      className: `${P}-textarea-suffix`
    }, U),
    showCount: w,
    ref: N,
    onResize: ge,
    onMouseDown: fe
  }))));
}), Input$1 = Input$2;
Input$1.Group = Group;
Input$1.Search = Search;
Input$1.TextArea = TextArea$3;
Input$1.Password = Password;
Input$1.OTP = OTP;
var DoubleLeftOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" }, DoubleLeftOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: DoubleLeftOutlined$1
  }));
}, RefIcon$l = /* @__PURE__ */ reactExports.forwardRef(DoubleLeftOutlined), DoubleRightOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" }, DoubleRightOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: DoubleRightOutlined$1
  }));
}, RefIcon$k = /* @__PURE__ */ reactExports.forwardRef(DoubleRightOutlined), locale = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
}, defaultPageSizeOptions = [10, 20, 50, 100], Options = function a(s) {
  var c = s.pageSizeOptions, u = c === void 0 ? defaultPageSizeOptions : c, d = s.locale, p = s.changeSize, v = s.pageSize, A = s.goButton, x = s.quickGo, g = s.rootPrefixCls, b = s.disabled, y = s.buildOptionText, f = s.showSizeChanger, m = s.sizeChangerRender, C = React.useState(""), w = _slicedToArray$e(C, 2), S = w[0], $ = w[1], T = function() {
    return !S || Number.isNaN(S) ? void 0 : Number(S);
  }, I = typeof y == "function" ? y : function(W) {
    return "".concat(W, " ").concat(d.items_per_page);
  }, _ = function(j) {
    $(j.target.value);
  }, E = function(j) {
    A || S === "" || ($(""), !(j.relatedTarget && (j.relatedTarget.className.indexOf("".concat(g, "-item-link")) >= 0 || j.relatedTarget.className.indexOf("".concat(g, "-item")) >= 0)) && x?.(T()));
  }, R = function(j) {
    S !== "" && (j.keyCode === KeyCode.ENTER || j.type === "click") && ($(""), x?.(T()));
  }, O = function() {
    return u.some(function(j) {
      return j.toString() === v.toString();
    }) ? u : u.concat([v]).sort(function(j, G) {
      var U = Number.isNaN(Number(j)) ? 0 : Number(j), k = Number.isNaN(Number(G)) ? 0 : Number(G);
      return U - k;
    });
  }, L = "".concat(g, "-options");
  if (!f && !x)
    return null;
  var B = null, F = null, M = null;
  return f && m && (B = m({
    disabled: b,
    size: v,
    onSizeChange: function(j) {
      p?.(Number(j));
    },
    "aria-label": d.page_size,
    className: "".concat(L, "-size-changer"),
    options: O().map(function(W) {
      return {
        label: I(W),
        value: W
      };
    })
  })), x && (A && (M = typeof A == "boolean" ? /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: R,
    onKeyUp: R,
    disabled: b,
    className: "".concat(L, "-quick-jumper-button")
  }, d.jump_to_confirm) : /* @__PURE__ */ React.createElement("span", {
    onClick: R,
    onKeyUp: R
  }, A)), F = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(L, "-quick-jumper")
  }, d.jump_to, /* @__PURE__ */ React.createElement("input", {
    disabled: b,
    type: "text",
    value: S,
    onChange: _,
    onKeyUp: R,
    onBlur: E,
    "aria-label": d.page
  }), d.page, M)), /* @__PURE__ */ React.createElement("li", {
    className: L
  }, B, F);
}, Pager$1 = function a(s) {
  var c = s.rootPrefixCls, u = s.page, d = s.active, p = s.className, v = s.showTitle, A = s.onClick, x = s.onKeyPress, g = s.itemRender, b = "".concat(c, "-item"), y = classnames(b, "".concat(b, "-").concat(u), _defineProperty$a(_defineProperty$a({}, "".concat(b, "-active"), d), "".concat(b, "-disabled"), !u), p), f = function() {
    A(u);
  }, m = function(S) {
    x(S, A, u);
  }, C = g(u, "page", /* @__PURE__ */ React.createElement("a", {
    rel: "nofollow"
  }, u));
  return C ? /* @__PURE__ */ React.createElement("li", {
    title: v ? String(u) : null,
    className: y,
    onClick: f,
    onKeyDown: m,
    tabIndex: 0
  }, C) : null;
}, defaultItemRender = function a(s, c, u) {
  return u;
};
function noop$3() {
}
function isInteger(a) {
  var s = Number(a);
  return typeof s == "number" && !Number.isNaN(s) && isFinite(s) && Math.floor(s) === s;
}
function calculatePage(a, s, c) {
  var u = typeof a > "u" ? s : a;
  return Math.floor((c - 1) / u) + 1;
}
var Pagination$1 = function a(s) {
  var c = s.prefixCls, u = c === void 0 ? "rc-pagination" : c, d = s.selectPrefixCls, p = d === void 0 ? "rc-select" : d, v = s.className, A = s.current, x = s.defaultCurrent, g = x === void 0 ? 1 : x, b = s.total, y = b === void 0 ? 0 : b, f = s.pageSize, m = s.defaultPageSize, C = m === void 0 ? 10 : m, w = s.onChange, S = w === void 0 ? noop$3 : w, $ = s.hideOnSinglePage, T = s.align, I = s.showPrevNextJumpers, _ = I === void 0 ? !0 : I, E = s.showQuickJumper, R = s.showLessItems, O = s.showTitle, L = O === void 0 ? !0 : O, B = s.onShowSizeChange, F = B === void 0 ? noop$3 : B, M = s.locale, W = M === void 0 ? locale : M, j = s.style, G = s.totalBoundaryShowSizeChanger, U = G === void 0 ? 50 : G, k = s.disabled, N = s.simple, P = s.showTotal, D = s.showSizeChanger, H = D === void 0 ? y > U : D, V = s.sizeChangerRender, Z = s.pageSizeOptions, ne = s.itemRender, K = ne === void 0 ? defaultItemRender : ne, q = s.jumpPrevIcon, Y = s.jumpNextIcon, ee = s.prevIcon, Q = s.nextIcon, J = React.useRef(null), te = useMergedState(10, {
    value: f,
    defaultValue: C
  }), ae = _slicedToArray$e(te, 2), se = ae[0], ie = ae[1], fe = useMergedState(1, {
    value: A,
    defaultValue: g,
    postState: function(bt) {
      return Math.max(1, Math.min(bt, calculatePage(void 0, se, y)));
    }
  }), ge = _slicedToArray$e(fe, 2), me = ge[0], pe = ge[1], be = React.useState(me), le = _slicedToArray$e(be, 2), ve = le[0], he = le[1];
  reactExports.useEffect(function() {
    he(me);
  }, [me]);
  var ye = Math.max(1, me - (R ? 3 : 5)), Ce = Math.min(calculatePage(void 0, se, y), me + (R ? 3 : 5));
  function xe(yt, bt) {
    var It = yt || /* @__PURE__ */ React.createElement("button", {
      type: "button",
      "aria-label": bt,
      className: "".concat(u, "-item-link")
    });
    return typeof yt == "function" && (It = /* @__PURE__ */ React.createElement(yt, _objectSpread2$1({}, s))), It;
  }
  function we(yt) {
    var bt = yt.target.value, It = calculatePage(void 0, se, y), kt;
    return bt === "" ? kt = bt : Number.isNaN(Number(bt)) ? kt = ve : bt >= It ? kt = It : kt = Number(bt), kt;
  }
  function $e(yt) {
    return isInteger(yt) && yt !== me && isInteger(y) && y > 0;
  }
  var Ae = y > se ? E : !1;
  function ue(yt) {
    (yt.keyCode === KeyCode.UP || yt.keyCode === KeyCode.DOWN) && yt.preventDefault();
  }
  function ce(yt) {
    var bt = we(yt);
    switch (bt !== ve && he(bt), yt.keyCode) {
      case KeyCode.ENTER:
        Te(bt);
        break;
      case KeyCode.UP:
        Te(bt - 1);
        break;
      case KeyCode.DOWN:
        Te(bt + 1);
        break;
    }
  }
  function Ee(yt) {
    Te(we(yt));
  }
  function _e(yt) {
    var bt = calculatePage(yt, se, y), It = me > bt && bt !== 0 ? bt : me;
    ie(yt), he(It), F?.(me, yt), pe(It), S?.(It, yt);
  }
  function Te(yt) {
    if ($e(yt) && !k) {
      var bt = calculatePage(void 0, se, y), It = yt;
      return yt > bt ? It = bt : yt < 1 && (It = 1), It !== ve && he(It), pe(It), S?.(It, se), It;
    }
    return me;
  }
  var ke = me > 1, Re = me < calculatePage(void 0, se, y);
  function Be() {
    ke && Te(me - 1);
  }
  function Oe() {
    Re && Te(me + 1);
  }
  function Me() {
    Te(ye);
  }
  function Fe() {
    Te(Ce);
  }
  function Ue(yt, bt) {
    if (yt.key === "Enter" || yt.charCode === KeyCode.ENTER || yt.keyCode === KeyCode.ENTER) {
      for (var It = arguments.length, kt = new Array(It > 2 ? It - 2 : 0), $t = 2; $t < It; $t++)
        kt[$t - 2] = arguments[$t];
      bt.apply(void 0, kt);
    }
  }
  function je(yt) {
    Ue(yt, Be);
  }
  function Le(yt) {
    Ue(yt, Oe);
  }
  function De(yt) {
    Ue(yt, Me);
  }
  function Ne(yt) {
    Ue(yt, Fe);
  }
  function Ge(yt) {
    var bt = K(yt, "prev", xe(ee, "prev page"));
    return /* @__PURE__ */ React.isValidElement(bt) ? /* @__PURE__ */ React.cloneElement(bt, {
      disabled: !ke
    }) : bt;
  }
  function Xe(yt) {
    var bt = K(yt, "next", xe(Q, "next page"));
    return /* @__PURE__ */ React.isValidElement(bt) ? /* @__PURE__ */ React.cloneElement(bt, {
      disabled: !Re
    }) : bt;
  }
  function nt(yt) {
    (yt.type === "click" || yt.keyCode === KeyCode.ENTER) && Te(ve);
  }
  var ct = null, it = pickAttrs(s, {
    aria: !0,
    data: !0
  }), We = P && /* @__PURE__ */ React.createElement("li", {
    className: "".concat(u, "-total-text")
  }, P(y, [y === 0 ? 0 : (me - 1) * se + 1, me * se > y ? y : me * se])), Ve = null, ut = calculatePage(void 0, se, y);
  if ($ && y <= se)
    return null;
  var at = [], Qe = {
    rootPrefixCls: u,
    onClick: Te,
    onKeyPress: Ue,
    showTitle: L,
    itemRender: K,
    page: -1
  }, st = me - 1 > 0 ? me - 1 : 0, ft = me + 1 < ut ? me + 1 : ut, vt = E && E.goButton, Pt = _typeof$h(N) === "object" ? N.readOnly : !N, dt = vt, mt = null;
  N && (vt && (typeof vt == "boolean" ? dt = /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: nt,
    onKeyUp: nt
  }, W.jump_to_confirm) : dt = /* @__PURE__ */ React.createElement("span", {
    onClick: nt,
    onKeyUp: nt
  }, vt), dt = /* @__PURE__ */ React.createElement("li", {
    title: L ? "".concat(W.jump_to).concat(me, "/").concat(ut) : null,
    className: "".concat(u, "-simple-pager")
  }, dt)), mt = /* @__PURE__ */ React.createElement("li", {
    title: L ? "".concat(me, "/").concat(ut) : null,
    className: "".concat(u, "-simple-pager")
  }, Pt ? ve : /* @__PURE__ */ React.createElement("input", {
    type: "text",
    "aria-label": W.jump_to,
    value: ve,
    disabled: k,
    onKeyDown: ue,
    onKeyUp: ce,
    onChange: ce,
    onBlur: Ee,
    size: 3
  }), /* @__PURE__ */ React.createElement("span", {
    className: "".concat(u, "-slash")
  }, "/"), ut));
  var pt = R ? 1 : 2;
  if (ut <= 3 + pt * 2) {
    ut || at.push(/* @__PURE__ */ React.createElement(Pager$1, _extends$3({}, Qe, {
      key: "noPager",
      page: 1,
      className: "".concat(u, "-item-disabled")
    })));
    for (var Et = 1; Et <= ut; Et += 1)
      at.push(/* @__PURE__ */ React.createElement(Pager$1, _extends$3({}, Qe, {
        key: Et,
        page: Et,
        active: me === Et
      })));
  } else {
    var Mt = R ? W.prev_3 : W.prev_5, Nt = R ? W.next_3 : W.next_5, _t = K(ye, "jump-prev", xe(q, "prev page")), Ot = K(Ce, "jump-next", xe(Y, "next page"));
    _ && (ct = _t ? /* @__PURE__ */ React.createElement("li", {
      title: L ? Mt : null,
      key: "prev",
      onClick: Me,
      tabIndex: 0,
      onKeyDown: De,
      className: classnames("".concat(u, "-jump-prev"), _defineProperty$a({}, "".concat(u, "-jump-prev-custom-icon"), !!q))
    }, _t) : null, Ve = Ot ? /* @__PURE__ */ React.createElement("li", {
      title: L ? Nt : null,
      key: "next",
      onClick: Fe,
      tabIndex: 0,
      onKeyDown: Ne,
      className: classnames("".concat(u, "-jump-next"), _defineProperty$a({}, "".concat(u, "-jump-next-custom-icon"), !!Y))
    }, Ot) : null);
    var rt = Math.max(1, me - pt), et = Math.min(me + pt, ut);
    me - 1 <= pt && (et = 1 + pt * 2), ut - me <= pt && (rt = ut - pt * 2);
    for (var Ye = rt; Ye <= et; Ye += 1)
      at.push(/* @__PURE__ */ React.createElement(Pager$1, _extends$3({}, Qe, {
        key: Ye,
        page: Ye,
        active: me === Ye
      })));
    if (me - 1 >= pt * 2 && me !== 3 && (at[0] = /* @__PURE__ */ React.cloneElement(at[0], {
      className: classnames("".concat(u, "-item-after-jump-prev"), at[0].props.className)
    }), at.unshift(ct)), ut - me >= pt * 2 && me !== ut - 2) {
      var tt = at[at.length - 1];
      at[at.length - 1] = /* @__PURE__ */ React.cloneElement(tt, {
        className: classnames("".concat(u, "-item-before-jump-next"), tt.props.className)
      }), at.push(Ve);
    }
    rt !== 1 && at.unshift(/* @__PURE__ */ React.createElement(Pager$1, _extends$3({}, Qe, {
      key: 1,
      page: 1
    }))), et !== ut && at.push(/* @__PURE__ */ React.createElement(Pager$1, _extends$3({}, Qe, {
      key: ut,
      page: ut
    })));
  }
  var Ke = Ge(st);
  if (Ke) {
    var qe = !ke || !ut;
    Ke = /* @__PURE__ */ React.createElement("li", {
      title: L ? W.prev_page : null,
      onClick: Be,
      tabIndex: qe ? null : 0,
      onKeyDown: je,
      className: classnames("".concat(u, "-prev"), _defineProperty$a({}, "".concat(u, "-disabled"), qe)),
      "aria-disabled": qe
    }, Ke);
  }
  var ot = Xe(ft);
  if (ot) {
    var Je, Ct;
    N ? (Je = !Re, Ct = ke ? 0 : null) : (Je = !Re || !ut, Ct = Je ? null : 0), ot = /* @__PURE__ */ React.createElement("li", {
      title: L ? W.next_page : null,
      onClick: Oe,
      tabIndex: Ct,
      onKeyDown: Le,
      className: classnames("".concat(u, "-next"), _defineProperty$a({}, "".concat(u, "-disabled"), Je)),
      "aria-disabled": Je
    }, ot);
  }
  var Tt = classnames(u, v, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(u, "-start"), T === "start"), "".concat(u, "-center"), T === "center"), "".concat(u, "-end"), T === "end"), "".concat(u, "-simple"), N), "".concat(u, "-disabled"), k));
  return /* @__PURE__ */ React.createElement("ul", _extends$3({
    className: Tt,
    style: j,
    ref: J
  }, it), We, Ke, N ? mt : at, ot, /* @__PURE__ */ React.createElement(Options, {
    locale: W,
    rootPrefixCls: u,
    disabled: k,
    selectPrefixCls: p,
    changeSize: _e,
    pageSize: se,
    pageSizeOptions: Z,
    quickGo: Ae ? Te : null,
    goButton: dt,
    showSizeChanger: H,
    sizeChangerRender: V
  }));
};
const genPaginationDisabledStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${s}-item-link`]: {
          color: a.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${s}-item-link`]: {
          color: a.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${s}-disabled`]: {
      cursor: "not-allowed",
      [`${s}-item`]: {
        cursor: "not-allowed",
        backgroundColor: "transparent",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: a.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: a.colorBorder,
          backgroundColor: a.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: a.itemActiveBgDisabled
          },
          a: {
            color: a.itemActiveColorDisabled
          }
        }
      },
      [`${s}-item-link`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${s}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${s}-simple-pager`]: {
        color: a.colorTextDisabled
      },
      [`${s}-jump-prev, ${s}-jump-next`]: {
        [`${s}-item-link-icon`]: {
          opacity: 0
        },
        [`${s}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${s}-simple`]: {
      [`${s}-prev, ${s}-next`]: {
        [`&${s}-disabled ${s}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
}, genPaginationMiniStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`&${s}-mini ${s}-total-text, &${s}-mini ${s}-simple-pager`]: {
      height: a.itemSizeSM,
      lineHeight: unit$1(a.itemSizeSM)
    },
    [`&${s}-mini ${s}-item`]: {
      minWidth: a.itemSizeSM,
      height: a.itemSizeSM,
      margin: 0,
      lineHeight: unit$1(a.calc(a.itemSizeSM).sub(2).equal())
    },
    [`&${s}-mini ${s}-prev, &${s}-mini ${s}-next`]: {
      minWidth: a.itemSizeSM,
      height: a.itemSizeSM,
      margin: 0,
      lineHeight: unit$1(a.itemSizeSM)
    },
    [`&${s}-mini:not(${s}-disabled)`]: {
      [`${s}-prev, ${s}-next`]: {
        [`&:hover ${s}-item-link`]: {
          backgroundColor: a.colorBgTextHover
        },
        [`&:active ${s}-item-link`]: {
          backgroundColor: a.colorBgTextActive
        },
        [`&${s}-disabled:hover ${s}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${s}-mini ${s}-prev ${s}-item-link,
    &${s}-mini ${s}-next ${s}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: a.itemSizeSM,
        lineHeight: unit$1(a.itemSizeSM)
      }
    },
    [`&${s}-mini ${s}-jump-prev, &${s}-mini ${s}-jump-next`]: {
      height: a.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: unit$1(a.itemSizeSM)
    },
    [`&${s}-mini ${s}-options`]: {
      marginInlineStart: a.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: a.miniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: a.itemSizeSM,
        lineHeight: unit$1(a.itemSizeSM),
        input: Object.assign(Object.assign({}, genInputSmallStyle(a)), {
          width: a.paginationMiniQuickJumperInputWidth,
          height: a.controlHeightSM
        })
      }
    }
  };
}, genPaginationSimpleStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`
    &${s}-simple ${s}-prev,
    &${s}-simple ${s}-next
    `]: {
      height: a.itemSizeSM,
      lineHeight: unit$1(a.itemSizeSM),
      verticalAlign: "top",
      [`${s}-item-link`]: {
        height: a.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: a.colorBgTextHover
        },
        "&:active": {
          backgroundColor: a.colorBgTextActive
        },
        "&::after": {
          height: a.itemSizeSM,
          lineHeight: unit$1(a.itemSizeSM)
        }
      }
    },
    [`&${s}-simple ${s}-simple-pager`]: {
      display: "inline-block",
      height: a.itemSizeSM,
      marginInlineEnd: a.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        padding: `0 ${unit$1(a.paginationItemPaddingInline)}`,
        textAlign: "center",
        backgroundColor: a.itemInputBg,
        border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
        borderRadius: a.borderRadius,
        outline: "none",
        transition: `border-color ${a.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: a.colorPrimary
        },
        "&:focus": {
          borderColor: a.colorPrimaryHover,
          boxShadow: `${unit$1(a.inputOutlineOffset)} 0 ${unit$1(a.controlOutlineWidth)} ${a.controlOutline}`
        },
        "&[disabled]": {
          color: a.colorTextDisabled,
          backgroundColor: a.colorBgContainerDisabled,
          borderColor: a.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
}, genPaginationJumpStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-jump-prev, ${s}-jump-next`]: {
      outline: 0,
      [`${s}-item-container`]: {
        position: "relative",
        [`${s}-item-link-icon`]: {
          color: a.colorPrimary,
          fontSize: a.fontSizeSM,
          opacity: 0,
          transition: `all ${a.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${s}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: a.colorTextDisabled,
          letterSpacing: a.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: a.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${a.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${s}-item-link-icon`]: {
          opacity: 1
        },
        [`${s}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${s}-prev,
    ${s}-jump-prev,
    ${s}-jump-next
    `]: {
      marginInlineEnd: a.marginXS
    },
    [`
    ${s}-prev,
    ${s}-next,
    ${s}-jump-prev,
    ${s}-jump-next
    `]: {
      display: "inline-block",
      minWidth: a.itemSize,
      height: a.itemSize,
      color: a.colorText,
      fontFamily: a.fontFamily,
      lineHeight: unit$1(a.itemSize),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: a.borderRadius,
      cursor: "pointer",
      transition: `all ${a.motionDurationMid}`
    },
    [`${s}-prev, ${s}-next`]: {
      outline: 0,
      button: {
        color: a.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${s}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: a.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
        borderRadius: a.borderRadius,
        outline: "none",
        transition: `all ${a.motionDurationMid}`
      },
      [`&:hover ${s}-item-link`]: {
        backgroundColor: a.colorBgTextHover
      },
      [`&:active ${s}-item-link`]: {
        backgroundColor: a.colorBgTextActive
      },
      [`&${s}-disabled:hover`]: {
        [`${s}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${s}-slash`]: {
      marginInlineEnd: a.paginationSlashMarginInlineEnd,
      marginInlineStart: a.paginationSlashMarginInlineStart
    },
    [`${s}-options`]: {
      display: "inline-block",
      marginInlineStart: a.margin,
      verticalAlign: "middle",
      "&-size-changer": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: a.controlHeight,
        marginInlineStart: a.marginXS,
        lineHeight: unit$1(a.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(a)), genBaseOutlinedStyle(a, {
          borderColor: a.colorBorder,
          hoverBorderColor: a.colorPrimaryHover,
          activeBorderColor: a.colorPrimary,
          activeShadow: a.activeShadow
        })), {
          "&[disabled]": Object.assign({}, genDisabledStyle(a)),
          width: a.calc(a.controlHeightLG).mul(1.25).equal(),
          height: a.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: a.marginXS,
          marginInlineEnd: a.marginXS
        })
      }
    }
  };
}, genPaginationItemStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-item`]: {
      display: "inline-block",
      minWidth: a.itemSize,
      height: a.itemSize,
      marginInlineEnd: a.marginXS,
      fontFamily: a.fontFamily,
      lineHeight: unit$1(a.calc(a.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: a.itemBg,
      border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
      borderRadius: a.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${unit$1(a.paginationItemPaddingInline)}`,
        color: a.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${s}-item-active)`]: {
        "&:hover": {
          transition: `all ${a.motionDurationMid}`,
          backgroundColor: a.colorBgTextHover
        },
        "&:active": {
          backgroundColor: a.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: a.fontWeightStrong,
        backgroundColor: a.itemActiveBg,
        borderColor: a.colorPrimary,
        a: {
          color: a.colorPrimary
        },
        "&:hover": {
          borderColor: a.colorPrimaryHover
        },
        "&:hover a": {
          color: a.colorPrimaryHover
        }
      }
    }
  };
}, genPaginationStyle$1 = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
      display: "flex",
      "&-start": {
        justifyContent: "start"
      },
      "&-center": {
        justifyContent: "center"
      },
      "&-end": {
        justifyContent: "end"
      },
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${s}-total-text`]: {
        display: "inline-block",
        height: a.itemSize,
        marginInlineEnd: a.marginXS,
        lineHeight: unit$1(a.calc(a.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), genPaginationItemStyle(a)), genPaginationJumpStyle(a)), genPaginationSimpleStyle(a)), genPaginationMiniStyle(a)), genPaginationDisabledStyle(a)), {
      // media query style
      [`@media only screen and (max-width: ${a.screenLG}px)`]: {
        [`${s}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${a.screenSM}px)`]: {
        [`${s}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${a.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, genPaginationFocusStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}:not(${s}-disabled)`]: {
      [`${s}-item`]: Object.assign({}, genFocusStyle(a)),
      [`${s}-jump-prev, ${s}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${s}-item-link-icon`]: {
            opacity: 1
          },
          [`${s}-item-ellipsis`]: {
            opacity: 0
          }
        }, genFocusOutline(a))
      },
      [`${s}-prev, ${s}-next`]: {
        [`&:focus-visible ${s}-item-link`]: Object.assign({}, genFocusOutline(a))
      }
    }
  };
}, prepareComponentToken$a = (a) => Object.assign({
  itemBg: a.colorBgContainer,
  itemSize: a.controlHeight,
  itemSizeSM: a.controlHeightSM,
  itemActiveBg: a.colorBgContainer,
  itemLinkBg: a.colorBgContainer,
  itemActiveColorDisabled: a.colorTextDisabled,
  itemActiveBgDisabled: a.controlItemBgActiveDisabled,
  itemInputBg: a.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, initComponentToken$1(a)), prepareToken = (a) => merge(a, {
  inputOutlineOffset: 0,
  paginationMiniOptionsMarginInlineStart: a.calc(a.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: a.calc(a.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: a.calc(a.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: a.calc(a.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: a.marginSM,
  paginationSlashMarginInlineEnd: a.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, initInputToken(a)), useStyle$a = genStyleHooks("Pagination", (a) => {
  const s = prepareToken(a);
  return [genPaginationStyle$1(s), genPaginationFocusStyle(s)];
}, prepareComponentToken$a), genBorderedStyle$1 = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}${s}-bordered${s}-disabled:not(${s}-mini)`]: {
      "&, &:hover": {
        [`${s}-item-link`]: {
          borderColor: a.colorBorder
        }
      },
      "&:focus-visible": {
        [`${s}-item-link`]: {
          borderColor: a.colorBorder
        }
      },
      [`${s}-item, ${s}-item-link`]: {
        backgroundColor: a.colorBgContainerDisabled,
        borderColor: a.colorBorder,
        [`&:hover:not(${s}-item-active)`]: {
          backgroundColor: a.colorBgContainerDisabled,
          borderColor: a.colorBorder,
          a: {
            color: a.colorTextDisabled
          }
        },
        [`&${s}-item-active`]: {
          backgroundColor: a.itemActiveBgDisabled
        }
      },
      [`${s}-prev, ${s}-next`]: {
        "&:hover button": {
          backgroundColor: a.colorBgContainerDisabled,
          borderColor: a.colorBorder,
          color: a.colorTextDisabled
        },
        [`${s}-item-link`]: {
          backgroundColor: a.colorBgContainerDisabled,
          borderColor: a.colorBorder
        }
      }
    },
    [`${s}${s}-bordered:not(${s}-mini)`]: {
      [`${s}-prev, ${s}-next`]: {
        "&:hover button": {
          borderColor: a.colorPrimaryHover,
          backgroundColor: a.itemBg
        },
        [`${s}-item-link`]: {
          backgroundColor: a.itemLinkBg,
          borderColor: a.colorBorder
        },
        [`&:hover ${s}-item-link`]: {
          borderColor: a.colorPrimary,
          backgroundColor: a.itemBg,
          color: a.colorPrimary
        },
        [`&${s}-disabled`]: {
          [`${s}-item-link`]: {
            borderColor: a.colorBorder,
            color: a.colorTextDisabled
          }
        }
      },
      [`${s}-item`]: {
        backgroundColor: a.itemBg,
        border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
        [`&:hover:not(${s}-item-active)`]: {
          borderColor: a.colorPrimary,
          backgroundColor: a.itemBg,
          a: {
            color: a.colorPrimary
          }
        },
        "&-active": {
          borderColor: a.colorPrimary
        }
      }
    }
  };
}, BorderedStyle = genSubStyleComponent(["Pagination", "bordered"], (a) => {
  const s = prepareToken(a);
  return [genBorderedStyle$1(s)];
}, prepareComponentToken$a);
function useShowSizeChanger(a) {
  return reactExports.useMemo(() => typeof a == "boolean" ? [a, {}] : a && typeof a == "object" ? [!0, a] : [void 0, void 0], [a]);
}
var __rest$j = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Pagination = (a) => {
  const {
    align: s,
    prefixCls: c,
    selectPrefixCls: u,
    className: d,
    rootClassName: p,
    style: v,
    size: A,
    locale: x,
    responsive: g,
    showSizeChanger: b,
    selectComponentClass: y,
    pageSizeOptions: f
  } = a, m = __rest$j(a, ["align", "prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "responsive", "showSizeChanger", "selectComponentClass", "pageSizeOptions"]), {
    xs: C
  } = useBreakpoint(g), [, w] = useToken$1(), {
    getPrefixCls: S,
    direction: $,
    showSizeChanger: T,
    className: I,
    style: _
  } = useComponentConfig("pagination"), E = S("pagination", c), [R, O, L] = useStyle$a(E), B = useSize(A), F = B === "small" || !!(C && !B && g), [M] = useLocale$1("Pagination", locale$4), W = Object.assign(Object.assign({}, M), x), [j, G] = useShowSizeChanger(b), [U, k] = useShowSizeChanger(T), N = j ?? U, P = G ?? k, D = y || Select, H = reactExports.useMemo(() => f ? f.map((Y) => Number(Y)) : void 0, [f]), V = (Y) => {
    var ee;
    const {
      disabled: Q,
      size: J,
      onSizeChange: te,
      "aria-label": ae,
      className: se,
      options: ie
    } = Y, {
      className: fe,
      onChange: ge
    } = P || {}, me = (ee = ie.find((pe) => String(pe.value) === String(J))) === null || ee === void 0 ? void 0 : ee.value;
    return /* @__PURE__ */ reactExports.createElement(D, Object.assign({
      disabled: Q,
      showSearch: !0,
      popupMatchSelectWidth: !1,
      getPopupContainer: (pe) => pe.parentNode,
      "aria-label": ae,
      options: ie
    }, P, {
      value: me,
      onChange: (pe, be) => {
        te?.(pe), ge?.(pe, be);
      },
      size: F ? "small" : "middle",
      className: classnames(se, fe)
    }));
  }, Z = reactExports.useMemo(() => {
    const Y = /* @__PURE__ */ reactExports.createElement("span", {
      className: `${E}-item-ellipsis`
    }, "•••"), ee = /* @__PURE__ */ reactExports.createElement("button", {
      className: `${E}-item-link`,
      type: "button",
      tabIndex: -1
    }, $ === "rtl" ? /* @__PURE__ */ reactExports.createElement(RefIcon$E, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$A, null)), Q = /* @__PURE__ */ reactExports.createElement("button", {
      className: `${E}-item-link`,
      type: "button",
      tabIndex: -1
    }, $ === "rtl" ? /* @__PURE__ */ reactExports.createElement(RefIcon$A, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$E, null)), J = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ reactExports.createElement("a", {
        className: `${E}-item-link`
      }, /* @__PURE__ */ reactExports.createElement("div", {
        className: `${E}-item-container`
      }, $ === "rtl" ? /* @__PURE__ */ reactExports.createElement(RefIcon$k, {
        className: `${E}-item-link-icon`
      }) : /* @__PURE__ */ reactExports.createElement(RefIcon$l, {
        className: `${E}-item-link-icon`
      }), Y))
    ), te = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ reactExports.createElement("a", {
        className: `${E}-item-link`
      }, /* @__PURE__ */ reactExports.createElement("div", {
        className: `${E}-item-container`
      }, $ === "rtl" ? /* @__PURE__ */ reactExports.createElement(RefIcon$l, {
        className: `${E}-item-link-icon`
      }) : /* @__PURE__ */ reactExports.createElement(RefIcon$k, {
        className: `${E}-item-link-icon`
      }), Y))
    );
    return {
      prevIcon: ee,
      nextIcon: Q,
      jumpPrevIcon: J,
      jumpNextIcon: te
    };
  }, [$, E]), ne = S("select", u), K = classnames({
    [`${E}-${s}`]: !!s,
    [`${E}-mini`]: F,
    [`${E}-rtl`]: $ === "rtl",
    [`${E}-bordered`]: w.wireframe
  }, I, d, p, O, L), q = Object.assign(Object.assign({}, _), v);
  return R(/* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, w.wireframe && /* @__PURE__ */ reactExports.createElement(BorderedStyle, {
    prefixCls: E
  }), /* @__PURE__ */ reactExports.createElement(Pagination$1, Object.assign({}, Z, m, {
    style: q,
    prefixCls: E,
    selectPrefixCls: ne,
    className: K,
    locale: W,
    pageSizeOptions: H,
    showSizeChanger: N,
    sizeChangerRender: V
  }))));
}, viewSize = 100, borderWidth = viewSize / 5, radius = viewSize / 2 - borderWidth / 2, circumference = radius * 2 * Math.PI, position = 50, CustomCircle = (a) => {
  const {
    dotClassName: s,
    style: c,
    hasCircleCls: u
  } = a;
  return /* @__PURE__ */ reactExports.createElement("circle", {
    className: classnames(`${s}-circle`, {
      [`${s}-circle-bg`]: u
    }),
    r: radius,
    cx: position,
    cy: position,
    strokeWidth: borderWidth,
    style: c
  });
}, Progress$1 = ({
  percent: a,
  prefixCls: s
}) => {
  const c = `${s}-dot`, u = `${c}-holder`, d = `${u}-hidden`, [p, v] = reactExports.useState(!1);
  useLayoutEffect$1(() => {
    a !== 0 && v(!0);
  }, [a !== 0]);
  const A = Math.max(Math.min(a, 100), 0);
  if (!p)
    return null;
  const x = {
    strokeDashoffset: `${circumference / 4}`,
    strokeDasharray: `${circumference * A / 100} ${circumference * (100 - A) / 100}`
  };
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(u, `${c}-progress`, A <= 0 && d)
  }, /* @__PURE__ */ reactExports.createElement("svg", {
    viewBox: `0 0 ${viewSize} ${viewSize}`,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": A
  }, /* @__PURE__ */ reactExports.createElement(CustomCircle, {
    dotClassName: c,
    hasCircleCls: !0
  }), /* @__PURE__ */ reactExports.createElement(CustomCircle, {
    dotClassName: c,
    style: x
  })));
};
function Looper(a) {
  const {
    prefixCls: s,
    percent: c = 0
  } = a, u = `${s}-dot`, d = `${u}-holder`, p = `${d}-hidden`;
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(d, c > 0 && p)
  }, /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(u, `${s}-dot-spin`)
  }, [1, 2, 3, 4].map((v) => /* @__PURE__ */ reactExports.createElement("i", {
    className: `${s}-dot-item`,
    key: v
  })))), /* @__PURE__ */ reactExports.createElement(Progress$1, {
    prefixCls: s,
    percent: c
  }));
}
function Indicator(a) {
  var s;
  const {
    prefixCls: c,
    indicator: u,
    percent: d
  } = a, p = `${c}-dot`;
  return u && /* @__PURE__ */ reactExports.isValidElement(u) ? cloneElement(u, {
    className: classnames((s = u.props) === null || s === void 0 ? void 0 : s.className, p),
    percent: d
  }) : /* @__PURE__ */ reactExports.createElement(Looper, {
    prefixCls: c,
    percent: d
  });
}
const antSpinMove = new Keyframe("antSpinMove", {
  to: {
    opacity: 1
  }
}), antRotate = new Keyframe("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), genSpinStyle = (a) => {
  const {
    componentCls: s,
    calc: c
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "absolute",
      display: "none",
      color: a.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${a.motionDurationSlow} ${a.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${s}-text`]: {
        fontSize: a.fontSize,
        paddingTop: c(c(a.dotSize).sub(a.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: a.colorBgMask,
        zIndex: a.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${a.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [s]: {
          [`${s}-dot-holder`]: {
            color: a.colorWhite
          },
          [`${s}-text`]: {
            color: a.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${s}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: a.contentHeight,
          [`${s}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: c(a.dotSize).mul(-1).div(2).equal()
          },
          [`${s}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${a.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${s}-show-text ${s}-dot`]: {
            marginTop: c(a.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${s}-dot`]: {
              margin: c(a.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${s}-text`]: {
              paddingTop: c(c(a.dotSizeSM).sub(a.fontSize)).div(2).add(2).equal()
            },
            [`&${s}-show-text ${s}-dot`]: {
              marginTop: c(a.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${s}-dot`]: {
              margin: c(a.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${s}-text`]: {
              paddingTop: c(c(a.dotSizeLG).sub(a.fontSize)).div(2).add(2).equal()
            },
            [`&${s}-show-text ${s}-dot`]: {
              marginTop: c(a.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${s}-container`]: {
          position: "relative",
          transition: `opacity ${a.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: a.colorBgContainer,
            opacity: 0,
            transition: `all ${a.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${s}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: a.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${s}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: a.dotSize,
        display: "inline-block",
        transition: `transform ${a.motionDurationSlow} ease, opacity ${a.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: a.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${s}-dot-progress`]: {
        position: "absolute",
        inset: 0
      },
      // dots
      // ------------------------------
      [`${s}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: a.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: c(a.dotSize).sub(c(a.marginXXS).div(2)).div(2).equal(),
          height: c(a.dotSize).sub(c(a.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: antSpinMove,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: antRotate,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((u) => `${u} ${a.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: a.colorFillSecondary
        }
      },
      // small
      [`&-sm ${s}-dot`]: {
        "&, &-holder": {
          fontSize: a.dotSizeSM
        }
      },
      [`&-sm ${s}-dot-holder`]: {
        i: {
          width: c(c(a.dotSizeSM).sub(c(a.marginXXS).div(2))).div(2).equal(),
          height: c(c(a.dotSizeSM).sub(c(a.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${s}-dot`]: {
        "&, &-holder": {
          fontSize: a.dotSizeLG
        }
      },
      [`&-lg ${s}-dot-holder`]: {
        i: {
          width: c(c(a.dotSizeLG).sub(a.marginXXS)).div(2).equal(),
          height: c(c(a.dotSizeLG).sub(a.marginXXS)).div(2).equal()
        }
      },
      [`&${s}-show-text ${s}-text`]: {
        display: "block"
      }
    })
  };
}, prepareComponentToken$9 = (a) => {
  const {
    controlHeightLG: s,
    controlHeight: c
  } = a;
  return {
    contentHeight: 400,
    dotSize: s / 2,
    dotSizeSM: s * 0.35,
    dotSizeLG: c
  };
}, useStyle$9 = genStyleHooks("Spin", (a) => {
  const s = merge(a, {
    spinDotDefault: a.colorTextDescription
  });
  return [genSpinStyle(s)];
}, prepareComponentToken$9), AUTO_INTERVAL = 200, STEP_BUCKETS = [[30, 0.05], [70, 0.03], [96, 0.01]];
function usePercent(a, s) {
  const [c, u] = reactExports.useState(0), d = reactExports.useRef(null), p = s === "auto";
  return reactExports.useEffect(() => (p && a && (u(0), d.current = setInterval(() => {
    u((v) => {
      const A = 100 - v;
      for (let x = 0; x < STEP_BUCKETS.length; x += 1) {
        const [g, b] = STEP_BUCKETS[x];
        if (v <= g)
          return v + A * b;
      }
      return v;
    });
  }, AUTO_INTERVAL)), () => {
    clearInterval(d.current);
  }), [p, a]), p ? c : s;
}
var __rest$i = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
let defaultIndicator;
function shouldDelay(a, s) {
  return !!a && !!s && !Number.isNaN(Number(s));
}
const Spin = (a) => {
  var s;
  const {
    prefixCls: c,
    spinning: u = !0,
    delay: d = 0,
    className: p,
    rootClassName: v,
    size: A = "default",
    tip: x,
    wrapperClassName: g,
    style: b,
    children: y,
    fullscreen: f = !1,
    indicator: m,
    percent: C
  } = a, w = __rest$i(a, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: S,
    direction: $,
    className: T,
    style: I,
    indicator: _
  } = useComponentConfig("spin"), E = S("spin", c), [R, O, L] = useStyle$9(E), [B, F] = reactExports.useState(() => u && !shouldDelay(u, d)), M = usePercent(B, C);
  reactExports.useEffect(() => {
    if (u) {
      const P = debounce(d, () => {
        F(!0);
      });
      return P(), () => {
        var D;
        (D = P?.cancel) === null || D === void 0 || D.call(P);
      };
    }
    F(!1);
  }, [d, u]);
  const W = reactExports.useMemo(() => typeof y < "u" && !f, [y, f]), j = classnames(E, T, {
    [`${E}-sm`]: A === "small",
    [`${E}-lg`]: A === "large",
    [`${E}-spinning`]: B,
    [`${E}-show-text`]: !!x,
    [`${E}-rtl`]: $ === "rtl"
  }, p, !f && v, O, L), G = classnames(`${E}-container`, {
    [`${E}-blur`]: B
  }), U = (s = m ?? _) !== null && s !== void 0 ? s : defaultIndicator, k = Object.assign(Object.assign({}, I), b), N = /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, w, {
    style: k,
    className: j,
    "aria-live": "polite",
    "aria-busy": B
  }), /* @__PURE__ */ reactExports.createElement(Indicator, {
    prefixCls: E,
    indicator: U,
    percent: M
  }), x && (W || f) ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${E}-text`
  }, x) : null);
  return R(W ? /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, w, {
    className: classnames(`${E}-nested-loading`, g, O, L)
  }), B && /* @__PURE__ */ reactExports.createElement("div", {
    key: "loading"
  }, N), /* @__PURE__ */ reactExports.createElement("div", {
    className: G,
    key: "container"
  }, y)) : f ? /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${E}-fullscreen`, {
      [`${E}-fullscreen-show`]: B
    }, v, O, L)
  }, N) : N);
};
Spin.setDefaultIndicator = (a) => {
  defaultIndicator = a;
};
const toList$1 = (a, s = !1) => s && a == null ? [] : Array.isArray(a) ? a : [a];
let message = null, act = (a) => a(), taskQueue = [], defaultGlobalConfig = {};
function getGlobalContext() {
  const {
    getContainer: a,
    duration: s,
    rtl: c,
    maxCount: u,
    top: d
  } = defaultGlobalConfig, p = a?.() || document.body;
  return {
    getContainer: () => p,
    duration: s,
    rtl: c,
    maxCount: u,
    top: d
  };
}
const GlobalHolder = /* @__PURE__ */ React.forwardRef((a, s) => {
  const {
    messageConfig: c,
    sync: u
  } = a, {
    getPrefixCls: d
  } = reactExports.useContext(ConfigContext$1), p = defaultGlobalConfig.prefixCls || d("message"), v = reactExports.useContext(AppConfigContext), [A, x] = useInternalMessage(Object.assign(Object.assign(Object.assign({}, c), {
    prefixCls: p
  }), v.message));
  return React.useImperativeHandle(s, () => {
    const g = Object.assign({}, A);
    return Object.keys(g).forEach((b) => {
      g[b] = (...y) => (u(), A[b].apply(A, y));
    }), {
      instance: g,
      sync: u
    };
  }), x;
}), GlobalHolderWrapper = /* @__PURE__ */ React.forwardRef((a, s) => {
  const [c, u] = React.useState(getGlobalContext), d = () => {
    u(getGlobalContext);
  };
  React.useEffect(d, []);
  const p = globalConfig(), v = p.getRootPrefixCls(), A = p.getIconPrefixCls(), x = p.getTheme(), g = /* @__PURE__ */ React.createElement(GlobalHolder, {
    ref: s,
    sync: d,
    messageConfig: c
  });
  return /* @__PURE__ */ React.createElement(ConfigProvider, {
    prefixCls: v,
    iconPrefixCls: A,
    theme: x
  }, p.holderRender ? p.holderRender(g) : g);
});
function flushNotice() {
  if (!message) {
    const a = document.createDocumentFragment(), s = {
      fragment: a
    };
    message = s, act(() => {
      unstableSetRender()(/* @__PURE__ */ React.createElement(GlobalHolderWrapper, {
        ref: (u) => {
          const {
            instance: d,
            sync: p
          } = u || {};
          Promise.resolve().then(() => {
            !s.instance && d && (s.instance = d, s.sync = p, flushNotice());
          });
        }
      }), a);
    });
    return;
  }
  message.instance && (taskQueue.forEach((a) => {
    const {
      type: s,
      skipped: c
    } = a;
    if (!c)
      switch (s) {
        case "open": {
          act(() => {
            const u = message.instance.open(Object.assign(Object.assign({}, defaultGlobalConfig), a.config));
            u?.then(a.resolve), a.setCloseFn(u);
          });
          break;
        }
        case "destroy":
          act(() => {
            message?.instance.destroy(a.key);
          });
          break;
        // Other type open
        default:
          act(() => {
            var u;
            const d = (u = message.instance)[s].apply(u, _toConsumableArray$e(a.args));
            d?.then(a.resolve), a.setCloseFn(d);
          });
      }
  }), taskQueue = []);
}
function setMessageGlobalConfig(a) {
  defaultGlobalConfig = Object.assign(Object.assign({}, defaultGlobalConfig), a), act(() => {
    var s;
    (s = message?.sync) === null || s === void 0 || s.call(message);
  });
}
function open(a) {
  const s = wrapPromiseFn((c) => {
    let u;
    const d = {
      type: "open",
      config: a,
      resolve: c,
      setCloseFn: (p) => {
        u = p;
      }
    };
    return taskQueue.push(d), () => {
      u ? act(() => {
        u();
      }) : d.skipped = !0;
    };
  });
  return flushNotice(), s;
}
function typeOpen(a, s) {
  const c = wrapPromiseFn((u) => {
    let d;
    const p = {
      type: a,
      args: s,
      resolve: u,
      setCloseFn: (v) => {
        d = v;
      }
    };
    return taskQueue.push(p), () => {
      d ? act(() => {
        d();
      }) : p.skipped = !0;
    };
  });
  return flushNotice(), c;
}
const destroy = (a) => {
  taskQueue.push({
    type: "destroy",
    key: a
  }), flushNotice();
}, methods = ["success", "info", "warning", "error", "loading"], baseStaticMethods = {
  open,
  destroy,
  config: setMessageGlobalConfig,
  useMessage,
  _InternalPanelDoNotUseOrYouWillBeFired: PurePanel$7
}, staticMethods = baseStaticMethods;
methods.forEach((a) => {
  staticMethods[a] = (...s) => typeOpen(a, s);
});
const genBaseStyle$5 = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    antCls: u,
    zIndexPopup: d,
    colorText: p,
    colorWarning: v,
    marginXXS: A,
    marginXS: x,
    fontSize: g,
    fontWeightStrong: b,
    colorTextHeading: y
  } = a;
  return {
    [s]: {
      zIndex: d,
      [`&${u}-popover`]: {
        fontSize: g
      },
      [`${s}-message`]: {
        marginBottom: x,
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${s}-message-icon ${c}`]: {
          color: v,
          fontSize: g,
          lineHeight: 1,
          marginInlineEnd: x
        },
        [`${s}-title`]: {
          fontWeight: b,
          color: y,
          "&:only-child": {
            fontWeight: "normal"
          }
        },
        [`${s}-description`]: {
          marginTop: A,
          color: p
        }
      },
      [`${s}-buttons`]: {
        textAlign: "end",
        whiteSpace: "nowrap",
        button: {
          marginInlineStart: x
        }
      }
    }
  };
}, prepareComponentToken$8 = (a) => {
  const {
    zIndexPopupBase: s
  } = a;
  return {
    zIndexPopup: s + 60
  };
}, useStyle$8 = genStyleHooks("Popconfirm", (a) => genBaseStyle$5(a), prepareComponentToken$8, {
  resetStyle: !1
});
var __rest$h = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Overlay = (a) => {
  const {
    prefixCls: s,
    okButtonProps: c,
    cancelButtonProps: u,
    title: d,
    description: p,
    cancelText: v,
    okText: A,
    okType: x = "primary",
    icon: g = /* @__PURE__ */ reactExports.createElement(RefIcon$H, null),
    showCancel: b = !0,
    close: y,
    onConfirm: f,
    onCancel: m,
    onPopupClick: C
  } = a, {
    getPrefixCls: w
  } = reactExports.useContext(ConfigContext$1), [S] = useLocale$1("Popconfirm", localeValues.Popconfirm), $ = getRenderPropValue(d), T = getRenderPropValue(p);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-inner-content`,
    onClick: C
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-message`
  }, g && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${s}-message-icon`
  }, g), /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-message-text`
  }, $ && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-title`
  }, $), T && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-description`
  }, T))), /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-buttons`
  }, b && /* @__PURE__ */ reactExports.createElement(Button$1, Object.assign({
    onClick: m,
    size: "small"
  }, u), v || S?.cancelText), /* @__PURE__ */ reactExports.createElement(ActionButton, {
    buttonProps: Object.assign(Object.assign({
      size: "small"
    }, convertLegacyProps(x)), c),
    actionFn: f,
    close: y,
    prefixCls: w("btn"),
    quitOnNullishReturnValue: !0,
    emitEvent: !0
  }, A || S?.okText)));
}, PurePanel$1 = (a) => {
  const {
    prefixCls: s,
    placement: c,
    className: u,
    style: d
  } = a, p = __rest$h(a, ["prefixCls", "placement", "className", "style"]), {
    getPrefixCls: v
  } = reactExports.useContext(ConfigContext$1), A = v("popconfirm", s), [x] = useStyle$8(A);
  return x(/* @__PURE__ */ reactExports.createElement(PurePanel$4, {
    placement: c,
    className: classnames(A, u),
    style: d,
    content: /* @__PURE__ */ reactExports.createElement(Overlay, Object.assign({
      prefixCls: A
    }, p))
  }));
};
var __rest$g = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalPopconfirm = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var c, u;
  const {
    prefixCls: d,
    placement: p = "top",
    trigger: v = "click",
    okType: A = "primary",
    icon: x = /* @__PURE__ */ reactExports.createElement(RefIcon$H, null),
    children: g,
    overlayClassName: b,
    onOpenChange: y,
    onVisibleChange: f,
    overlayStyle: m,
    styles: C,
    classNames: w
  } = a, S = __rest$g(a, ["prefixCls", "placement", "trigger", "okType", "icon", "children", "overlayClassName", "onOpenChange", "onVisibleChange", "overlayStyle", "styles", "classNames"]), {
    getPrefixCls: $,
    className: T,
    style: I,
    classNames: _,
    styles: E
  } = useComponentConfig("popconfirm"), [R, O] = useMergedState(!1, {
    value: (c = a.open) !== null && c !== void 0 ? c : a.visible,
    defaultValue: (u = a.defaultOpen) !== null && u !== void 0 ? u : a.defaultVisible
  }), L = (N, P) => {
    O(N, !0), f?.(N), y?.(N, P);
  }, B = (N) => {
    L(!1, N);
  }, F = (N) => {
    var P;
    return (P = a.onConfirm) === null || P === void 0 ? void 0 : P.call(void 0, N);
  }, M = (N) => {
    var P;
    L(!1, N), (P = a.onCancel) === null || P === void 0 || P.call(void 0, N);
  }, W = (N, P) => {
    const {
      disabled: D = !1
    } = a;
    D || L(N, P);
  }, j = $("popconfirm", d), G = classnames(j, T, b, _.root, w?.root), U = classnames(_.body, w?.body), [k] = useStyle$8(j);
  return k(/* @__PURE__ */ reactExports.createElement(Popover, Object.assign({}, omit(S, ["title"]), {
    trigger: v,
    placement: p,
    onOpenChange: W,
    open: R,
    ref: s,
    classNames: {
      root: G,
      body: U
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, E.root), I), m), C?.root),
      body: Object.assign(Object.assign({}, E.body), C?.body)
    },
    content: /* @__PURE__ */ reactExports.createElement(Overlay, Object.assign({
      okType: A,
      icon: x
    }, a, {
      prefixCls: j,
      close: B,
      onConfirm: F,
      onCancel: M
    })),
    "data-popover-inject": !0
  }), g));
}), Popconfirm = InternalPopconfirm;
Popconfirm._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$1;
var defaultProps = {
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1,
  gapPosition: "bottom"
}, useTransitionDuration = function a() {
  var s = reactExports.useRef([]), c = reactExports.useRef(null);
  return reactExports.useEffect(function() {
    var u = Date.now(), d = !1;
    s.current.forEach(function(p) {
      if (p) {
        d = !0;
        var v = p.style;
        v.transitionDuration = ".3s, .3s, .3s, .06s", c.current && u - c.current < 100 && (v.transitionDuration = "0s, 0s");
      }
    }), d && (c.current = Date.now());
  }), s.current;
}, uuid = 0, isBrowserClient = canUseDom$1();
function getUUID() {
  var a;
  return isBrowserClient ? (a = uuid, uuid += 1) : a = "TEST_OR_SSR", a;
}
const useId = function(a) {
  var s = reactExports.useState(), c = _slicedToArray$e(s, 2), u = c[0], d = c[1];
  return reactExports.useEffect(function() {
    d("rc_progress_".concat(getUUID()));
  }, []), a || u;
};
var Block = function a(s) {
  var c = s.bg, u = s.children;
  return /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      background: c
    }
  }, u);
};
function getPtgColors(a, s) {
  return Object.keys(a).map(function(c) {
    var u = parseFloat(c), d = "".concat(Math.floor(u * s), "%");
    return "".concat(a[c], " ").concat(d);
  });
}
var PtgCircle = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.color, d = a.gradientId, p = a.radius, v = a.style, A = a.ptg, x = a.strokeLinecap, g = a.strokeWidth, b = a.size, y = a.gapDegree, f = u && _typeof$h(u) === "object", m = f ? "#FFF" : void 0, C = b / 2, w = /* @__PURE__ */ reactExports.createElement("circle", {
    className: "".concat(c, "-circle-path"),
    r: p,
    cx: C,
    cy: C,
    stroke: m,
    strokeLinecap: x,
    strokeWidth: g,
    opacity: A === 0 ? 0 : 1,
    style: v,
    ref: s
  });
  if (!f)
    return w;
  var S = "".concat(d, "-conic"), $ = y ? "".concat(180 + y / 2, "deg") : "0deg", T = getPtgColors(u, (360 - y) / 360), I = getPtgColors(u, 1), _ = "conic-gradient(from ".concat($, ", ").concat(T.join(", "), ")"), E = "linear-gradient(to ".concat(y ? "bottom" : "top", ", ").concat(I.join(", "), ")");
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("mask", {
    id: S
  }, w), /* @__PURE__ */ reactExports.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: b,
    height: b,
    mask: "url(#".concat(S, ")")
  }, /* @__PURE__ */ reactExports.createElement(Block, {
    bg: E
  }, /* @__PURE__ */ reactExports.createElement(Block, {
    bg: _
  }))));
}), VIEW_BOX_SIZE = 100, getCircleStyle = function a(s, c, u, d, p, v, A, x, g, b) {
  var y = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 0, f = u / 100 * 360 * ((360 - v) / 360), m = v === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[A], C = (100 - d) / 100 * c;
  g === "round" && d !== 100 && (C += b / 2, C >= c && (C = c - 0.01));
  var w = VIEW_BOX_SIZE / 2;
  return {
    stroke: typeof x == "string" ? x : void 0,
    strokeDasharray: "".concat(c, "px ").concat(s),
    strokeDashoffset: C + y,
    transform: "rotate(".concat(p + f + m, "deg)"),
    transformOrigin: "".concat(w, "px ").concat(w, "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    fillOpacity: 0
  };
}, _excluded$f = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];
function toArray$2(a) {
  var s = a ?? [];
  return Array.isArray(s) ? s : [s];
}
var Circle$1 = function a(s) {
  var c = _objectSpread2$1(_objectSpread2$1({}, defaultProps), s), u = c.id, d = c.prefixCls, p = c.steps, v = c.strokeWidth, A = c.trailWidth, x = c.gapDegree, g = x === void 0 ? 0 : x, b = c.gapPosition, y = c.trailColor, f = c.strokeLinecap, m = c.style, C = c.className, w = c.strokeColor, S = c.percent, $ = _objectWithoutProperties$2(c, _excluded$f), T = VIEW_BOX_SIZE / 2, I = useId(u), _ = "".concat(I, "-gradient"), E = T - v / 2, R = Math.PI * 2 * E, O = g > 0 ? 90 + g / 2 : -90, L = R * ((360 - g) / 360), B = _typeof$h(p) === "object" ? p : {
    count: p,
    gap: 2
  }, F = B.count, M = B.gap, W = toArray$2(S), j = toArray$2(w), G = j.find(function(V) {
    return V && _typeof$h(V) === "object";
  }), U = G && _typeof$h(G) === "object", k = U ? "butt" : f, N = getCircleStyle(R, L, 0, 100, O, g, b, y, k, v), P = useTransitionDuration(), D = function() {
    var Z = 0;
    return W.map(function(ne, K) {
      var q = j[K] || j[j.length - 1], Y = getCircleStyle(R, L, Z, ne, O, g, b, q, k, v);
      return Z += ne, /* @__PURE__ */ reactExports.createElement(PtgCircle, {
        key: K,
        color: q,
        ptg: ne,
        radius: E,
        prefixCls: d,
        gradientId: _,
        style: Y,
        strokeLinecap: k,
        strokeWidth: v,
        gapDegree: g,
        ref: function(Q) {
          P[K] = Q;
        },
        size: VIEW_BOX_SIZE
      });
    }).reverse();
  }, H = function() {
    var Z = Math.round(F * (W[0] / 100)), ne = 100 / F, K = 0;
    return new Array(F).fill(null).map(function(q, Y) {
      var ee = Y <= Z - 1 ? j[0] : y, Q = ee && _typeof$h(ee) === "object" ? "url(#".concat(_, ")") : void 0, J = getCircleStyle(R, L, K, ne, O, g, b, ee, "butt", v, M);
      return K += (L - J.strokeDashoffset + M) * 100 / L, /* @__PURE__ */ reactExports.createElement("circle", {
        key: Y,
        className: "".concat(d, "-circle-path"),
        r: E,
        cx: T,
        cy: T,
        stroke: Q,
        strokeWidth: v,
        opacity: 1,
        style: J,
        ref: function(ae) {
          P[Y] = ae;
        }
      });
    });
  };
  return /* @__PURE__ */ reactExports.createElement("svg", _extends$3({
    className: classnames("".concat(d, "-circle"), C),
    viewBox: "0 0 ".concat(VIEW_BOX_SIZE, " ").concat(VIEW_BOX_SIZE),
    style: m,
    id: u,
    role: "presentation"
  }, $), !F && /* @__PURE__ */ reactExports.createElement("circle", {
    className: "".concat(d, "-circle-trail"),
    r: E,
    cx: T,
    cy: T,
    stroke: y,
    strokeLinecap: k,
    strokeWidth: A || v,
    style: N
  }), F ? H() : D());
};
function validProgress(a) {
  return !a || a < 0 ? 0 : a > 100 ? 100 : a;
}
function getSuccessPercent({
  success: a,
  successPercent: s
}) {
  let c = s;
  return a && "progress" in a && (c = a.progress), a && "percent" in a && (c = a.percent), c;
}
const getPercentage = ({
  percent: a,
  success: s,
  successPercent: c
}) => {
  const u = validProgress(getSuccessPercent({
    success: s,
    successPercent: c
  }));
  return [u, validProgress(validProgress(a) - u)];
}, getStrokeColor = ({
  success: a = {},
  strokeColor: s
}) => {
  const {
    strokeColor: c
  } = a;
  return [c || presetPrimaryColors$1.green, s || null];
}, getSize$1 = (a, s, c) => {
  var u, d, p, v;
  let A = -1, x = -1;
  if (s === "step") {
    const g = c.steps, b = c.strokeWidth;
    typeof a == "string" || typeof a > "u" ? (A = a === "small" ? 2 : 14, x = b ?? 8) : typeof a == "number" ? [A, x] = [a, a] : [A = 14, x = 8] = Array.isArray(a) ? a : [a.width, a.height], A *= g;
  } else if (s === "line") {
    const g = c?.strokeWidth;
    typeof a == "string" || typeof a > "u" ? x = g || (a === "small" ? 6 : 8) : typeof a == "number" ? [A, x] = [a, a] : [A = -1, x = 8] = Array.isArray(a) ? a : [a.width, a.height];
  } else (s === "circle" || s === "dashboard") && (typeof a == "string" || typeof a > "u" ? [A, x] = a === "small" ? [60, 60] : [120, 120] : typeof a == "number" ? [A, x] = [a, a] : Array.isArray(a) && (A = (d = (u = a[0]) !== null && u !== void 0 ? u : a[1]) !== null && d !== void 0 ? d : 120, x = (v = (p = a[0]) !== null && p !== void 0 ? p : a[1]) !== null && v !== void 0 ? v : 120));
  return [A, x];
}, CIRCLE_MIN_STROKE_WIDTH = 3, getMinPercent = (a) => CIRCLE_MIN_STROKE_WIDTH / a * 100, Circle = (a) => {
  const {
    prefixCls: s,
    trailColor: c = null,
    strokeLinecap: u = "round",
    gapPosition: d,
    gapDegree: p,
    width: v = 120,
    type: A,
    children: x,
    success: g,
    size: b = v,
    steps: y
  } = a, [f, m] = getSize$1(b, "circle");
  let {
    strokeWidth: C
  } = a;
  C === void 0 && (C = Math.max(getMinPercent(f), 6));
  const w = {
    width: f,
    height: m,
    fontSize: f * 0.15 + 6
  }, S = reactExports.useMemo(() => {
    if (p || p === 0)
      return p;
    if (A === "dashboard")
      return 75;
  }, [p, A]), $ = getPercentage(a), T = d || A === "dashboard" && "bottom" || void 0, I = Object.prototype.toString.call(a.strokeColor) === "[object Object]", _ = getStrokeColor({
    success: g,
    strokeColor: a.strokeColor
  }), E = classnames(`${s}-inner`, {
    [`${s}-circle-gradient`]: I
  }), R = /* @__PURE__ */ reactExports.createElement(Circle$1, {
    steps: y,
    percent: y ? $[1] : $,
    strokeWidth: C,
    trailWidth: C,
    strokeColor: y ? _[1] : _,
    strokeLinecap: u,
    trailColor: c,
    prefixCls: s,
    gapDegree: S,
    gapPosition: T
  }), O = f <= 20, L = /* @__PURE__ */ reactExports.createElement("div", {
    className: E,
    style: w
  }, R, !O && x);
  return O ? /* @__PURE__ */ reactExports.createElement(Tooltip, {
    title: x
  }, L) : L;
}, LineStrokeColorVar = "--progress-line-stroke-color", Percent = "--progress-percent", genAntProgressActive = (a) => {
  const s = a ? "100%" : "-100%";
  return new Keyframe(`antProgress${a ? "RTL" : "LTR"}Active`, {
    "0%": {
      transform: `translateX(${s}) scaleX(0)`,
      opacity: 0.1
    },
    "20%": {
      transform: `translateX(${s}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: "translateX(0) scaleX(1)",
      opacity: 0
    }
  });
}, genBaseStyle$4 = (a) => {
  const {
    componentCls: s,
    iconCls: c
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      display: "inline-block",
      "&-rtl": {
        direction: "rtl"
      },
      "&-line": {
        position: "relative",
        width: "100%",
        fontSize: a.fontSize
      },
      [`${s}-outer`]: {
        display: "inline-flex",
        alignItems: "center",
        width: "100%"
      },
      [`${s}-inner`]: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        flex: 1,
        overflow: "hidden",
        verticalAlign: "middle",
        backgroundColor: a.remainingColor,
        borderRadius: a.lineBorderRadius
      },
      [`${s}-inner:not(${s}-circle-gradient)`]: {
        [`${s}-circle-path`]: {
          stroke: a.defaultColor
        }
      },
      [`${s}-success-bg, ${s}-bg`]: {
        position: "relative",
        background: a.defaultColor,
        borderRadius: a.lineBorderRadius,
        transition: `all ${a.motionDurationSlow} ${a.motionEaseInOutCirc}`
      },
      [`${s}-layout-bottom`]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        [`${s}-text`]: {
          width: "max-content",
          marginInlineStart: 0,
          marginTop: a.marginXXS
        }
      },
      [`${s}-bg`]: {
        overflow: "hidden",
        "&::after": {
          content: '""',
          background: {
            _multi_value_: !0,
            value: ["inherit", `var(${LineStrokeColorVar})`]
          },
          height: "100%",
          width: `calc(1 / var(${Percent}) * 100%)`,
          display: "block"
        },
        [`&${s}-bg-inner`]: {
          minWidth: "max-content",
          "&::after": {
            content: "none"
          },
          [`${s}-text-inner`]: {
            color: a.colorWhite,
            [`&${s}-text-bright`]: {
              color: "rgba(0, 0, 0, 0.45)"
            }
          }
        }
      },
      [`${s}-success-bg`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: a.colorSuccess
      },
      [`${s}-text`]: {
        display: "inline-block",
        marginInlineStart: a.marginXS,
        color: a.colorText,
        lineHeight: 1,
        width: "2em",
        whiteSpace: "nowrap",
        textAlign: "start",
        verticalAlign: "middle",
        wordBreak: "normal",
        [c]: {
          fontSize: a.fontSize
        },
        [`&${s}-text-outer`]: {
          width: "max-content"
        },
        [`&${s}-text-outer${s}-text-start`]: {
          width: "max-content",
          marginInlineStart: 0,
          marginInlineEnd: a.marginXS
        }
      },
      [`${s}-text-inner`]: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        marginInlineStart: 0,
        padding: `0 ${unit$1(a.paddingXXS)}`,
        [`&${s}-text-start`]: {
          justifyContent: "start"
        },
        [`&${s}-text-end`]: {
          justifyContent: "end"
        }
      },
      [`&${s}-status-active`]: {
        [`${s}-bg::before`]: {
          position: "absolute",
          inset: 0,
          backgroundColor: a.colorBgContainer,
          borderRadius: a.lineBorderRadius,
          opacity: 0,
          animationName: genAntProgressActive(),
          animationDuration: a.progressActiveMotionDuration,
          animationTimingFunction: a.motionEaseOutQuint,
          animationIterationCount: "infinite",
          content: '""'
        }
      },
      [`&${s}-rtl${s}-status-active`]: {
        [`${s}-bg::before`]: {
          animationName: genAntProgressActive(!0)
        }
      },
      [`&${s}-status-exception`]: {
        [`${s}-bg`]: {
          backgroundColor: a.colorError
        },
        [`${s}-text`]: {
          color: a.colorError
        }
      },
      [`&${s}-status-exception ${s}-inner:not(${s}-circle-gradient)`]: {
        [`${s}-circle-path`]: {
          stroke: a.colorError
        }
      },
      [`&${s}-status-success`]: {
        [`${s}-bg`]: {
          backgroundColor: a.colorSuccess
        },
        [`${s}-text`]: {
          color: a.colorSuccess
        }
      },
      [`&${s}-status-success ${s}-inner:not(${s}-circle-gradient)`]: {
        [`${s}-circle-path`]: {
          stroke: a.colorSuccess
        }
      }
    })
  };
}, genCircleStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c
  } = a;
  return {
    [s]: {
      [`${s}-circle-trail`]: {
        stroke: a.remainingColor
      },
      [`&${s}-circle ${s}-inner`]: {
        position: "relative",
        lineHeight: 1,
        backgroundColor: "transparent"
      },
      [`&${s}-circle ${s}-text`]: {
        position: "absolute",
        insetBlockStart: "50%",
        insetInlineStart: 0,
        width: "100%",
        margin: 0,
        padding: 0,
        color: a.circleTextColor,
        fontSize: a.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: "normal",
        textAlign: "center",
        transform: "translateY(-50%)",
        [c]: {
          fontSize: a.circleIconFontSize
        }
      },
      [`${s}-circle&-status-exception`]: {
        [`${s}-text`]: {
          color: a.colorError
        }
      },
      [`${s}-circle&-status-success`]: {
        [`${s}-text`]: {
          color: a.colorSuccess
        }
      }
    },
    [`${s}-inline-circle`]: {
      lineHeight: 1,
      [`${s}-inner`]: {
        verticalAlign: "bottom"
      }
    }
  };
}, genStepStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      [`${s}-steps`]: {
        display: "inline-block",
        "&-outer": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "&-item": {
          flexShrink: 0,
          minWidth: a.progressStepMinWidth,
          marginInlineEnd: a.progressStepMarginInlineEnd,
          backgroundColor: a.remainingColor,
          transition: `all ${a.motionDurationSlow}`,
          "&-active": {
            backgroundColor: a.defaultColor
          }
        }
      }
    }
  };
}, genSmallLine = (a) => {
  const {
    componentCls: s,
    iconCls: c
  } = a;
  return {
    [s]: {
      [`${s}-small&-line, ${s}-small&-line ${s}-text ${c}`]: {
        fontSize: a.fontSizeSM
      }
    }
  };
}, prepareComponentToken$7 = (a) => ({
  circleTextColor: a.colorText,
  defaultColor: a.colorInfo,
  remainingColor: a.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: "1em",
  circleIconFontSize: `${a.fontSize / a.fontSizeSM}em`
}), useStyle$7 = genStyleHooks("Progress", (a) => {
  const s = a.calc(a.marginXXS).div(2).equal(), c = merge(a, {
    progressStepMarginInlineEnd: s,
    progressStepMinWidth: s,
    progressActiveMotionDuration: "2.4s"
  });
  return [genBaseStyle$4(c), genCircleStyle(c), genStepStyle(c), genSmallLine(c)];
}, prepareComponentToken$7);
var __rest$f = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const sortGradient = (a) => {
  let s = [];
  return Object.keys(a).forEach((c) => {
    const u = parseFloat(c.replace(/%/g, ""));
    Number.isNaN(u) || s.push({
      key: u,
      value: a[c]
    });
  }), s = s.sort((c, u) => c.key - u.key), s.map(({
    key: c,
    value: u
  }) => `${u} ${c}%`).join(", ");
}, handleGradient = (a, s) => {
  const {
    from: c = presetPrimaryColors$1.blue,
    to: u = presetPrimaryColors$1.blue,
    direction: d = s === "rtl" ? "to left" : "to right"
  } = a, p = __rest$f(a, ["from", "to", "direction"]);
  if (Object.keys(p).length !== 0) {
    const A = sortGradient(p), x = `linear-gradient(${d}, ${A})`;
    return {
      background: x,
      [LineStrokeColorVar]: x
    };
  }
  const v = `linear-gradient(${d}, ${c}, ${u})`;
  return {
    background: v,
    [LineStrokeColorVar]: v
  };
}, Line = (a) => {
  const {
    prefixCls: s,
    direction: c,
    percent: u,
    size: d,
    strokeWidth: p,
    strokeColor: v,
    strokeLinecap: A = "round",
    children: x,
    trailColor: g = null,
    percentPosition: b,
    success: y
  } = a, {
    align: f,
    type: m
  } = b, C = v && typeof v != "string" ? handleGradient(v, c) : {
    [LineStrokeColorVar]: v,
    background: v
  }, w = A === "square" || A === "butt" ? 0 : void 0, S = d ?? [-1, p || (d === "small" ? 6 : 8)], [$, T] = getSize$1(S, "line", {
    strokeWidth: p
  }), I = {
    backgroundColor: g || void 0,
    borderRadius: w
  }, _ = Object.assign(Object.assign({
    width: `${validProgress(u)}%`,
    height: T,
    borderRadius: w
  }, C), {
    [Percent]: validProgress(u) / 100
  }), E = getSuccessPercent(a), R = {
    width: `${validProgress(E)}%`,
    height: T,
    borderRadius: w,
    backgroundColor: y?.strokeColor
  }, O = {
    width: $ < 0 ? "100%" : $
  }, L = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-inner`,
    style: I
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${s}-bg`, `${s}-bg-${m}`),
    style: _
  }, m === "inner" && x), E !== void 0 && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-success-bg`,
    style: R
  })), B = m === "outer" && f === "start", F = m === "outer" && f === "end";
  return m === "outer" && f === "center" ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-layout-bottom`
  }, L, x) : /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-outer`,
    style: O
  }, B && x, L, F && x);
}, Steps = (a) => {
  const {
    size: s,
    steps: c,
    rounding: u = Math.round,
    percent: d = 0,
    strokeWidth: p = 8,
    strokeColor: v,
    trailColor: A = null,
    prefixCls: x,
    children: g
  } = a, b = u(c * (d / 100)), f = s ?? [s === "small" ? 2 : 14, p], [m, C] = getSize$1(f, "step", {
    steps: c,
    strokeWidth: p
  }), w = m / c, S = Array.from({
    length: c
  });
  for (let $ = 0; $ < c; $++) {
    const T = Array.isArray(v) ? v[$] : v;
    S[$] = /* @__PURE__ */ reactExports.createElement("div", {
      key: $,
      className: classnames(`${x}-steps-item`, {
        [`${x}-steps-item-active`]: $ <= b - 1
      }),
      style: {
        backgroundColor: $ <= b - 1 ? T : A,
        width: w,
        height: C
      }
    });
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: `${x}-steps-outer`
  }, S, g);
};
var __rest$e = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const ProgressStatuses = ["normal", "exception", "active", "success"], Progress = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    className: u,
    rootClassName: d,
    steps: p,
    strokeColor: v,
    percent: A = 0,
    size: x = "default",
    showInfo: g = !0,
    type: b = "line",
    status: y,
    format: f,
    style: m,
    percentPosition: C = {}
  } = a, w = __rest$e(a, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style", "percentPosition"]), {
    align: S = "end",
    type: $ = "outer"
  } = C, T = Array.isArray(v) ? v[0] : v, I = typeof v == "string" || Array.isArray(v) ? v : void 0, _ = reactExports.useMemo(() => {
    if (T) {
      const D = typeof T == "string" ? T : Object.values(T)[0];
      return new FastColor(D).isLight();
    }
    return !1;
  }, [v]), E = reactExports.useMemo(() => {
    var D, H;
    const V = getSuccessPercent(a);
    return parseInt(V !== void 0 ? (D = V ?? 0) === null || D === void 0 ? void 0 : D.toString() : (H = A ?? 0) === null || H === void 0 ? void 0 : H.toString(), 10);
  }, [A, a.success, a.successPercent]), R = reactExports.useMemo(() => !ProgressStatuses.includes(y) && E >= 100 ? "success" : y || "normal", [y, E]), {
    getPrefixCls: O,
    direction: L,
    progress: B
  } = reactExports.useContext(ConfigContext$1), F = O("progress", c), [M, W, j] = useStyle$7(F), G = b === "line", U = G && !p, k = reactExports.useMemo(() => {
    if (!g)
      return null;
    const D = getSuccessPercent(a);
    let H;
    const V = f || ((ne) => `${ne}%`), Z = G && _ && $ === "inner";
    return $ === "inner" || f || R !== "exception" && R !== "success" ? H = V(validProgress(A), validProgress(D)) : R === "exception" ? H = G ? /* @__PURE__ */ reactExports.createElement(RefIcon$J, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$I, null) : R === "success" && (H = G ? /* @__PURE__ */ reactExports.createElement(RefIcon$K, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$D, null)), /* @__PURE__ */ reactExports.createElement("span", {
      className: classnames(`${F}-text`, {
        [`${F}-text-bright`]: Z,
        [`${F}-text-${S}`]: U,
        [`${F}-text-${$}`]: U
      }),
      title: typeof H == "string" ? H : void 0
    }, H);
  }, [g, A, E, R, b, F, f]);
  let N;
  b === "line" ? N = p ? /* @__PURE__ */ reactExports.createElement(Steps, Object.assign({}, a, {
    strokeColor: I,
    prefixCls: F,
    steps: typeof p == "object" ? p.count : p
  }), k) : /* @__PURE__ */ reactExports.createElement(Line, Object.assign({}, a, {
    strokeColor: T,
    prefixCls: F,
    direction: L,
    percentPosition: {
      align: S,
      type: $
    }
  }), k) : (b === "circle" || b === "dashboard") && (N = /* @__PURE__ */ reactExports.createElement(Circle, Object.assign({}, a, {
    strokeColor: T,
    prefixCls: F,
    progressStatus: R
  }), k));
  const P = classnames(F, `${F}-status-${R}`, {
    [`${F}-${b === "dashboard" && "circle" || b}`]: b !== "line",
    [`${F}-inline-circle`]: b === "circle" && getSize$1(x, "circle")[0] <= 20,
    [`${F}-line`]: U,
    [`${F}-line-align-${S}`]: U,
    [`${F}-line-position-${$}`]: U,
    [`${F}-steps`]: p,
    [`${F}-show-info`]: g,
    [`${F}-${x}`]: typeof x == "string",
    [`${F}-rtl`]: L === "rtl"
  }, B?.className, u, d, W, j);
  return M(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    ref: s,
    style: Object.assign(Object.assign({}, B?.style), m),
    className: P,
    role: "progressbar",
    "aria-valuenow": E,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, omit(w, ["trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success", "successPercent"])), N));
});
function _createForOfIteratorHelper(a, s) {
  var c = typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (!c) {
    if (Array.isArray(a) || (c = _unsupportedIterableToArray$m(a)) || s) {
      c && (a = c);
      var u = 0, d = function() {
      };
      return {
        s: d,
        n: function() {
          return u >= a.length ? {
            done: !0
          } : {
            done: !1,
            value: a[u++]
          };
        },
        e: function(g) {
          throw g;
        },
        f: d
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var p, v = !0, A = !1;
  return {
    s: function() {
      c = c.call(a);
    },
    n: function() {
      var g = c.next();
      return v = g.done, g;
    },
    e: function(g) {
      A = !0, p = g;
    },
    f: function() {
      try {
        v || c.return == null || c.return();
      } finally {
        if (A) throw p;
      }
    }
  };
}
var CaretDownFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "filled" }, CaretDownFilled = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CaretDownFilled$1
  }));
}, RefIcon$j = /* @__PURE__ */ reactExports.forwardRef(CaretDownFilled), CaretDownOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "outlined" }, CaretDownOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CaretDownOutlined$1
  }));
}, RefIcon$i = /* @__PURE__ */ reactExports.forwardRef(CaretDownOutlined), CaretUpOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, name: "caret-up", theme: "outlined" }, CaretUpOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CaretUpOutlined$1
  }));
}, RefIcon$h = /* @__PURE__ */ reactExports.forwardRef(CaretUpOutlined), CopyOutlined$3 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" }, CopyOutlined$2 = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: CopyOutlined$3
  }));
}, RefIcon$g = /* @__PURE__ */ reactExports.forwardRef(CopyOutlined$2), DeleteOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" }, DeleteOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: DeleteOutlined$1
  }));
}, RefIcon$f = /* @__PURE__ */ reactExports.forwardRef(DeleteOutlined), DownloadOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "download", theme: "outlined" }, DownloadOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: DownloadOutlined$1
  }));
}, RefIcon$e = /* @__PURE__ */ reactExports.forwardRef(DownloadOutlined), EditOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" }, EditOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: EditOutlined$1
  }));
}, RefIcon$d = /* @__PURE__ */ reactExports.forwardRef(EditOutlined), EnterOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" }, EnterOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: EnterOutlined$1
  }));
}, RefIcon$c = /* @__PURE__ */ reactExports.forwardRef(EnterOutlined), FileOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" }, FileOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: FileOutlined$1
  }));
}, RefIcon$b = /* @__PURE__ */ reactExports.forwardRef(FileOutlined), FileTwoTone$1 = { icon: function a(s, c) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", fill: c } }, { tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", fill: s } }] };
}, name: "file", theme: "twotone" }, FileTwoTone = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: FileTwoTone$1
  }));
}, RefIcon$a = /* @__PURE__ */ reactExports.forwardRef(FileTwoTone), FilterFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, name: "filter", theme: "filled" }, FilterFilled = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: FilterFilled$1
  }));
}, RefIcon$9 = /* @__PURE__ */ reactExports.forwardRef(FilterFilled), FolderOpenOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, name: "folder-open", theme: "outlined" }, FolderOpenOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: FolderOpenOutlined$1
  }));
}, RefIcon$8 = /* @__PURE__ */ reactExports.forwardRef(FolderOpenOutlined), FolderOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, name: "folder", theme: "outlined" }, FolderOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: FolderOutlined$1
  }));
}, RefIcon$7 = /* @__PURE__ */ reactExports.forwardRef(FolderOutlined), HolderOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" }, HolderOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: HolderOutlined$1
  }));
}, RefIcon$6 = /* @__PURE__ */ reactExports.forwardRef(HolderOutlined), MinusSquareOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "minus-square", theme: "outlined" }, MinusSquareOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: MinusSquareOutlined$1
  }));
}, RefIcon$5 = /* @__PURE__ */ reactExports.forwardRef(MinusSquareOutlined), PaperClipOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, name: "paper-clip", theme: "outlined" }, PaperClipOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: PaperClipOutlined$1
  }));
}, RefIcon$4 = /* @__PURE__ */ reactExports.forwardRef(PaperClipOutlined), PictureTwoTone$1 = { icon: function a(s, c) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", fill: s } }, { tag: "path", attrs: { d: "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", fill: c } }, { tag: "path", attrs: { d: "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", fill: c } }, { tag: "path", attrs: { d: "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", fill: c } }, { tag: "path", attrs: { d: "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", fill: s } }] };
}, name: "picture", theme: "twotone" }, PictureTwoTone = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: PictureTwoTone$1
  }));
}, RefIcon$3 = /* @__PURE__ */ reactExports.forwardRef(PictureTwoTone), PlusSquareOutlined$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "plus-square", theme: "outlined" }, PlusSquareOutlined = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: PlusSquareOutlined$1
  }));
}, RefIcon$2 = /* @__PURE__ */ reactExports.forwardRef(PlusSquareOutlined), StarFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, name: "star", theme: "filled" }, StarFilled = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: StarFilled$1
  }));
}, RefIcon$1 = /* @__PURE__ */ reactExports.forwardRef(StarFilled), WarningFilled$1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "warning", theme: "filled" }, WarningFilled = function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement(Icon$4, _extends$3({}, s, {
    ref: c,
    icon: WarningFilled$1
  }));
}, RefIcon = /* @__PURE__ */ reactExports.forwardRef(WarningFilled);
function Star(a, s) {
  var c = a.disabled, u = a.prefixCls, d = a.character, p = a.characterRender, v = a.index, A = a.count, x = a.value, g = a.allowHalf, b = a.focused, y = a.onHover, f = a.onClick, m = function(E) {
    y(E, v);
  }, C = function(E) {
    f(E, v);
  }, w = function(E) {
    E.keyCode === KeyCode.ENTER && f(E, v);
  }, S = v + 1, $ = /* @__PURE__ */ new Set([u]);
  x === 0 && v === 0 && b ? $.add("".concat(u, "-focused")) : g && x + 0.5 >= S && x < S ? ($.add("".concat(u, "-half")), $.add("".concat(u, "-active")), b && $.add("".concat(u, "-focused"))) : (S <= x ? $.add("".concat(u, "-full")) : $.add("".concat(u, "-zero")), S === x && b && $.add("".concat(u, "-focused")));
  var T = typeof d == "function" ? d(a) : d, I = /* @__PURE__ */ React.createElement("li", {
    className: classnames(Array.from($)),
    ref: s
  }, /* @__PURE__ */ React.createElement("div", {
    onClick: c ? null : C,
    onKeyDown: c ? null : w,
    onMouseMove: c ? null : m,
    role: "radio",
    "aria-checked": x > v ? "true" : "false",
    "aria-posinset": v + 1,
    "aria-setsize": A,
    tabIndex: c ? -1 : 0
  }, /* @__PURE__ */ React.createElement("div", {
    className: "".concat(u, "-first")
  }, T), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(u, "-second")
  }, T)));
  return p && (I = p(I, a)), I;
}
const Star$1 = /* @__PURE__ */ React.forwardRef(Star);
function useRefs() {
  var a = reactExports.useRef({});
  function s(u) {
    return a.current[u];
  }
  function c(u) {
    return function(d) {
      a.current[u] = d;
    };
  }
  return [s, c];
}
function getScroll$1(a) {
  var s = a.pageXOffset, c = "scrollLeft";
  if (typeof s != "number") {
    var u = a.document;
    s = u.documentElement[c], typeof s != "number" && (s = u.body[c]);
  }
  return s;
}
function getClientPosition$1(a) {
  var s, c, u = a.ownerDocument, d = u.body, p = u && u.documentElement, v = a.getBoundingClientRect();
  return s = v.left, c = v.top, s -= p.clientLeft || d.clientLeft || 0, c -= p.clientTop || d.clientTop || 0, {
    left: s,
    top: c
  };
}
function getOffsetLeft(a) {
  var s = getClientPosition$1(a), c = a.ownerDocument, u = c.defaultView || c.parentWindow;
  return s.left += getScroll$1(u), s.left;
}
var _excluded$e = ["prefixCls", "className", "defaultValue", "value", "count", "allowHalf", "allowClear", "keyboard", "character", "characterRender", "disabled", "direction", "tabIndex", "autoFocus", "onHoverChange", "onChange", "onFocus", "onBlur", "onKeyDown", "onMouseLeave"];
function Rate$1(a, s) {
  var c = a.prefixCls, u = c === void 0 ? "rc-rate" : c, d = a.className, p = a.defaultValue, v = a.value, A = a.count, x = A === void 0 ? 5 : A, g = a.allowHalf, b = g === void 0 ? !1 : g, y = a.allowClear, f = y === void 0 ? !0 : y, m = a.keyboard, C = m === void 0 ? !0 : m, w = a.character, S = w === void 0 ? "★" : w, $ = a.characterRender, T = a.disabled, I = a.direction, _ = I === void 0 ? "ltr" : I, E = a.tabIndex, R = E === void 0 ? 0 : E, O = a.autoFocus, L = a.onHoverChange, B = a.onChange, F = a.onFocus, M = a.onBlur, W = a.onKeyDown, j = a.onMouseLeave, G = _objectWithoutProperties$2(a, _excluded$e), U = useRefs(), k = _slicedToArray$e(U, 2), N = k[0], P = k[1], D = React.useRef(null), H = function() {
    if (!T) {
      var ue;
      (ue = D.current) === null || ue === void 0 || ue.focus();
    }
  };
  React.useImperativeHandle(s, function() {
    return {
      focus: H,
      blur: function() {
        if (!T) {
          var ue;
          (ue = D.current) === null || ue === void 0 || ue.blur();
        }
      }
    };
  });
  var V = useMergedState(p || 0, {
    value: v
  }), Z = _slicedToArray$e(V, 2), ne = Z[0], K = Z[1], q = useMergedState(null), Y = _slicedToArray$e(q, 2), ee = Y[0], Q = Y[1], J = function(ue, ce) {
    var Ee = _ === "rtl", _e = ue + 1;
    if (b) {
      var Te = N(ue), ke = getOffsetLeft(Te), Re = Te.clientWidth;
      (Ee && ce - ke > Re / 2 || !Ee && ce - ke < Re / 2) && (_e -= 0.5);
    }
    return _e;
  }, te = function(ue) {
    K(ue), B?.(ue);
  }, ae = React.useState(!1), se = _slicedToArray$e(ae, 2), ie = se[0], fe = se[1], ge = function() {
    fe(!0), F?.();
  }, me = function() {
    fe(!1), M?.();
  }, pe = React.useState(null), be = _slicedToArray$e(pe, 2), le = be[0], ve = be[1], he = function(ue, ce) {
    var Ee = J(ce, ue.pageX);
    Ee !== ee && (ve(Ee), Q(null)), L?.(Ee);
  }, ye = function(ue) {
    T || (ve(null), Q(null), L?.(void 0)), ue && j?.(ue);
  }, Ce = function(ue, ce) {
    var Ee = J(ce, ue.pageX), _e = !1;
    f && (_e = Ee === ne), ye(), te(_e ? 0 : Ee), Q(_e ? Ee : null);
  }, xe = function(ue) {
    var ce = ue.keyCode, Ee = _ === "rtl", _e = b ? 0.5 : 1;
    C && (ce === KeyCode.RIGHT && ne < x && !Ee ? (te(ne + _e), ue.preventDefault()) : ce === KeyCode.LEFT && ne > 0 && !Ee || ce === KeyCode.RIGHT && ne > 0 && Ee ? (te(ne - _e), ue.preventDefault()) : ce === KeyCode.LEFT && ne < x && Ee && (te(ne + _e), ue.preventDefault())), W?.(ue);
  };
  React.useEffect(function() {
    O && !T && H();
  }, []);
  var we = new Array(x).fill(0).map(function(Ae, ue) {
    return /* @__PURE__ */ React.createElement(Star$1, {
      ref: P(ue),
      index: ue,
      count: x,
      disabled: T,
      prefixCls: "".concat(u, "-star"),
      allowHalf: b,
      value: le === null ? ne : le,
      onClick: Ce,
      onHover: he,
      key: Ae || ue,
      character: S,
      characterRender: $,
      focused: ie
    });
  }), $e = classnames(u, d, _defineProperty$a(_defineProperty$a({}, "".concat(u, "-disabled"), T), "".concat(u, "-rtl"), _ === "rtl"));
  return /* @__PURE__ */ React.createElement("ul", _extends$3({
    className: $e,
    onMouseLeave: ye,
    tabIndex: T ? -1 : R,
    onFocus: T ? null : ge,
    onBlur: T ? null : me,
    onKeyDown: T ? null : xe,
    ref: D
  }, pickAttrs(G, {
    aria: !0,
    data: !0,
    attr: !0
  })), we);
}
const Rate$2 = /* @__PURE__ */ React.forwardRef(Rate$1), genRateStarStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-star`]: {
      position: "relative",
      display: "inline-block",
      color: "inherit",
      cursor: "pointer",
      "&:not(:last-child)": {
        marginInlineEnd: a.marginXS
      },
      "> div": {
        transition: `all ${a.motionDurationMid}, outline 0s`,
        "&:hover": {
          transform: a.starHoverScale
        },
        "&:focus": {
          outline: 0
        },
        "&:focus-visible": {
          outline: `${unit$1(a.lineWidth)} dashed ${a.starColor}`,
          transform: a.starHoverScale
        }
      },
      "&-first, &-second": {
        color: a.starBg,
        transition: `all ${a.motionDurationMid}`,
        userSelect: "none"
      },
      "&-first": {
        position: "absolute",
        top: 0,
        insetInlineStart: 0,
        width: "50%",
        height: "100%",
        overflow: "hidden",
        opacity: 0
      },
      [`&-half ${s}-star-first, &-half ${s}-star-second`]: {
        opacity: 1
      },
      [`&-half ${s}-star-first, &-full ${s}-star-second`]: {
        color: "inherit"
      }
    }
  };
}, genRateRtlStyle = (a) => ({
  [`&-rtl${a.componentCls}`]: {
    direction: "rtl"
  }
}), genRateStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
      display: "inline-block",
      margin: 0,
      padding: 0,
      color: a.starColor,
      fontSize: a.starSize,
      lineHeight: 1,
      listStyle: "none",
      outline: "none",
      // disable styles
      [`&-disabled${s} ${s}-star`]: {
        cursor: "default",
        "> div:hover": {
          transform: "scale(1)"
        }
      }
    }), genRateStarStyle(a)), genRateRtlStyle(a))
  };
}, prepareComponentToken$6 = (a) => ({
  starColor: a.yellow6,
  starSize: a.controlHeightLG * 0.5,
  starHoverScale: "scale(1.1)",
  starBg: a.colorFillContent
}), useStyle$6 = genStyleHooks("Rate", (a) => {
  const s = merge(a, {});
  return [genRateStyle(s)];
}, prepareComponentToken$6);
var __rest$d = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Rate = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    className: u,
    rootClassName: d,
    style: p,
    tooltips: v,
    character: A = /* @__PURE__ */ reactExports.createElement(RefIcon$1, null),
    disabled: x
  } = a, g = __rest$d(a, ["prefixCls", "className", "rootClassName", "style", "tooltips", "character", "disabled"]), b = (E, {
    index: R
  }) => v ? /* @__PURE__ */ reactExports.createElement(Tooltip, {
    title: v[R]
  }, E) : E, {
    getPrefixCls: y,
    direction: f,
    rate: m
  } = reactExports.useContext(ConfigContext$1), C = y("rate", c), [w, S, $] = useStyle$6(C), T = Object.assign(Object.assign({}, m?.style), p), I = reactExports.useContext(DisabledContext), _ = x ?? I;
  return w(/* @__PURE__ */ reactExports.createElement(Rate$2, Object.assign({
    ref: s,
    character: A,
    characterRender: b,
    disabled: _
  }, g, {
    className: classnames(u, d, S, $, m?.className),
    style: T,
    prefixCls: C,
    direction: f
  })));
}), NoFound = () => /* @__PURE__ */ reactExports.createElement("svg", {
  width: "252",
  height: "294"
}, /* @__PURE__ */ reactExports.createElement("title", null, "No Found"), /* @__PURE__ */ reactExports.createElement("defs", null, /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 .387h251.772v251.772H0z"
})), /* @__PURE__ */ reactExports.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ reactExports.createElement("g", {
  transform: "translate(0 .012)"
}, /* @__PURE__ */ reactExports.createElement("mask", {
  fill: "#fff"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
  fill: "#E4EBF7",
  mask: "url(#b)"
})), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#FFF",
  strokeWidth: "2",
  d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
  fill: "#1677ff"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
  fill: "#7BB2F9"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M107.275 222.1s2.773-1.11 6.102-3.884",
  stroke: "#648BD8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
  fill: "#520038"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
  fill: "#552950"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#DB836E",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M110.846 74.481s1.79-.716 2.506.537",
  stroke: "#5C2552",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
  stroke: "#DB836E",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M103.287 72.93s1.83 1.113 4.137.954",
  stroke: "#5C2552",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
  stroke: "#DB836E",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
  stroke: "#E4EBF7",
  strokeWidth: "1.101",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M119.306 107.329s.452 4.366-2.127 32.062",
  stroke: "#E4EBF7",
  strokeWidth: "1.101",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
  fill: "#F2D7AD"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
  fill: "#F4D19D"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
  fill: "#F2D7AD"
}), /* @__PURE__ */ reactExports.createElement("path", {
  fill: "#CC9B6E",
  d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
  fill: "#F4D19D"
}), /* @__PURE__ */ reactExports.createElement("path", {
  fill: "#CC9B6E",
  d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  fill: "#CC9B6E",
  d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
  stroke: "#DB836E",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
  stroke: "#DB836E",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
  stroke: "#DB836E",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
  fill: "#5BA02E"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
  fill: "#92C110"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
  fill: "#F2D7AD"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M88.979 89.48s7.776 5.384 16.6 2.842",
  stroke: "#E4EBF7",
  strokeWidth: "1.101",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), ServerError = () => /* @__PURE__ */ reactExports.createElement("svg", {
  width: "254",
  height: "294"
}, /* @__PURE__ */ reactExports.createElement("title", null, "Server Error"), /* @__PURE__ */ reactExports.createElement("defs", null, /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 .335h253.49v253.49H0z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 293.665h253.49V.401H0z"
})), /* @__PURE__ */ reactExports.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ reactExports.createElement("g", {
  transform: "translate(0 .067)"
}, /* @__PURE__ */ reactExports.createElement("mask", {
  fill: "#fff"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
  fill: "#E4EBF7",
  mask: "url(#b)"
})), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
  fill: "#FF603B"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
  fill: "#520038"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
  fill: "#552950"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#DB836E",
  strokeWidth: "1.063",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M99.926 73.284s1.8-.72 2.52.54",
  stroke: "#5C2552",
  strokeWidth: "1.117",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
  stroke: "#DB836E",
  strokeWidth: "1.117",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M92.326 71.724s1.84 1.12 4.16.96",
  stroke: "#5C2552",
  strokeWidth: "1.117",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
  stroke: "#DB836E",
  strokeWidth: "1.063",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
  stroke: "#E4EBF7",
  strokeWidth: "1.136",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
  stroke: "#E4EBF7",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
  fill: "#7BB2F9"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
  stroke: "#648BD8",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M96.973 219.373s2.882-1.153 6.34-4.034",
  stroke: "#648BD8",
  strokeWidth: "1.032",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
  stroke: "#648BD8",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
  stroke: "#648BD8",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
  stroke: "#E4EBF7",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
  stroke: "#DB836E",
  strokeWidth: ".774",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
  stroke: "#E59788",
  strokeWidth: ".774",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
  stroke: "#E59788",
  strokeWidth: ".774",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M109.278 112.533s3.38-3.613 7.575-4.662",
  stroke: "#E4EBF7",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M107.375 123.006s9.697-2.745 11.445-.88",
  stroke: "#E59788",
  strokeWidth: ".774",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
  stroke: "#BFCDDD",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
  fill: "#A3B4C6"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
  fill: "#A3B4C6"
}), /* @__PURE__ */ reactExports.createElement("mask", {
  fill: "#fff"
}), /* @__PURE__ */ reactExports.createElement("path", {
  fill: "#A3B4C6",
  mask: "url(#d)",
  d: "M154.098 190.096h70.513v-84.617h-70.513z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
  fill: "#BFCDDD",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
  fill: "#FFF",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
  fill: "#BFCDDD",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
  stroke: "#7C90A5",
  strokeWidth: "1.124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
  fill: "#FFF",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
  fill: "#BFCDDD",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M177.259 207.217v11.52M201.05 207.217v11.52",
  stroke: "#A3B4C6",
  strokeWidth: "1.124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
  fill: "#5BA02E",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
  fill: "#92C110",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
  fill: "#F2D7AD",
  mask: "url(#d)"
}))), genBaseStyle$3 = (a) => {
  const {
    componentCls: s,
    lineHeightHeading3: c,
    iconCls: u,
    padding: d,
    paddingXL: p,
    paddingXS: v,
    paddingLG: A,
    marginXS: x,
    lineHeight: g
  } = a;
  return {
    // Result
    [s]: {
      padding: `${unit$1(a.calc(A).mul(2).equal())} ${unit$1(p)}`,
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    },
    // Exception Status image
    [`${s} ${s}-image`]: {
      width: a.imageWidth,
      height: a.imageHeight,
      margin: "auto"
    },
    [`${s} ${s}-icon`]: {
      marginBottom: A,
      textAlign: "center",
      [`& > ${u}`]: {
        fontSize: a.iconFontSize
      }
    },
    [`${s} ${s}-title`]: {
      color: a.colorTextHeading,
      fontSize: a.titleFontSize,
      lineHeight: c,
      marginBlock: x,
      textAlign: "center"
    },
    [`${s} ${s}-subtitle`]: {
      color: a.colorTextDescription,
      fontSize: a.subtitleFontSize,
      lineHeight: g,
      textAlign: "center"
    },
    [`${s} ${s}-content`]: {
      marginTop: A,
      padding: `${unit$1(A)} ${unit$1(a.calc(d).mul(2.5).equal())}`,
      backgroundColor: a.colorFillAlter
    },
    [`${s} ${s}-extra`]: {
      margin: a.extraMargin,
      textAlign: "center",
      "& > *": {
        marginInlineEnd: v,
        "&:last-child": {
          marginInlineEnd: 0
        }
      }
    }
  };
}, genStatusIconStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c
  } = a;
  return {
    [`${s}-success ${s}-icon > ${c}`]: {
      color: a.resultSuccessIconColor
    },
    [`${s}-error ${s}-icon > ${c}`]: {
      color: a.resultErrorIconColor
    },
    [`${s}-info ${s}-icon > ${c}`]: {
      color: a.resultInfoIconColor
    },
    [`${s}-warning ${s}-icon > ${c}`]: {
      color: a.resultWarningIconColor
    }
  };
}, genResultStyle = (a) => [genBaseStyle$3(a), genStatusIconStyle(a)], getStyle = (a) => genResultStyle(a), prepareComponentToken$5 = (a) => ({
  titleFontSize: a.fontSizeHeading3,
  subtitleFontSize: a.fontSize,
  iconFontSize: a.fontSizeHeading3 * 3,
  extraMargin: `${a.paddingLG}px 0 0 0`
}), useStyle$5 = genStyleHooks("Result", (a) => {
  const s = a.colorInfo, c = a.colorError, u = a.colorSuccess, d = a.colorWarning, p = merge(a, {
    resultInfoIconColor: s,
    resultErrorIconColor: c,
    resultSuccessIconColor: u,
    resultWarningIconColor: d,
    imageWidth: 250,
    imageHeight: 295
  });
  return [getStyle(p)];
}, prepareComponentToken$5), Unauthorized = () => /* @__PURE__ */ reactExports.createElement("svg", {
  width: "251",
  height: "294"
}, /* @__PURE__ */ reactExports.createElement("title", null, "Unauthorized"), /* @__PURE__ */ reactExports.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
  fill: "#E4EBF7"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#FFF",
  strokeWidth: "2",
  d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
  fill: "#A26EF4"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
  fill: "#5BA02E"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
  fill: "#92C110"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
  fill: "#F2D7AD"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M78.18 94.656s.911 7.41-4.914 13.078",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
  stroke: "#E4EBF7",
  strokeWidth: ".932",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
  fill: "#5C2552"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#DB836E",
  strokeWidth: "1.145",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
  fill: "#552950"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M91.132 86.786s5.269 4.957 12.679 2.327",
  stroke: "#DB836E",
  strokeWidth: "1.145",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
  fill: "#DB836E"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
  stroke: "#5C2552",
  strokeWidth: "1.526",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
  stroke: "#DB836E",
  strokeWidth: "1.145",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
  stroke: "#E4EBF7",
  strokeWidth: "1.114",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M128.31 87.934s3.013 4.121 4.06 11.785",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
  stroke: "#DB836E",
  strokeWidth: ".795",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M130.532 85.488s4.588 5.757 11.619 6.214",
  stroke: "#DB836E",
  strokeWidth: ".75",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M121.708 105.73s-.393 8.564-1.34 13.612",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
  fill: "#7BB2F9"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M108.459 220.905s2.759-1.104 6.07-3.863",
  stroke: "#648BD8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), IconMap = {
  success: RefIcon$K,
  error: RefIcon$J,
  info: RefIcon$H,
  warning: RefIcon
}, ExceptionMap = {
  404: NoFound,
  500: ServerError,
  403: Unauthorized
}, ExceptionStatus = Object.keys(ExceptionMap), Icon$1 = ({
  prefixCls: a,
  icon: s,
  status: c
}) => {
  const u = classnames(`${a}-icon`);
  if (ExceptionStatus.includes(`${c}`)) {
    const p = ExceptionMap[c];
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: `${u} ${a}-image`
    }, /* @__PURE__ */ reactExports.createElement(p, null));
  }
  const d = /* @__PURE__ */ reactExports.createElement(IconMap[c]);
  return s === null || s === !1 ? null : /* @__PURE__ */ reactExports.createElement("div", {
    className: u
  }, s || d);
}, Extra = ({
  prefixCls: a,
  extra: s
}) => s ? /* @__PURE__ */ reactExports.createElement("div", {
  className: `${a}-extra`
}, s) : null, Result$1 = ({
  prefixCls: a,
  className: s,
  rootClassName: c,
  subTitle: u,
  title: d,
  style: p,
  children: v,
  status: A = "info",
  icon: x,
  extra: g
}) => {
  const {
    getPrefixCls: b,
    direction: y,
    result: f
  } = reactExports.useContext(ConfigContext$1), m = b("result", a), [C, w, S] = useStyle$5(m), $ = classnames(m, `${m}-${A}`, s, f?.className, c, {
    [`${m}-rtl`]: y === "rtl"
  }, w, S), T = Object.assign(Object.assign({}, f?.style), p);
  return C(/* @__PURE__ */ reactExports.createElement("div", {
    className: $,
    style: T
  }, /* @__PURE__ */ reactExports.createElement(Icon$1, {
    prefixCls: m,
    status: A,
    icon: x
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: `${m}-title`
  }, d), u && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${m}-subtitle`
  }, u), /* @__PURE__ */ reactExports.createElement(Extra, {
    prefixCls: m,
    extra: g
  }), v && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${m}-content`
  }, v)));
};
Result$1.PRESENTED_IMAGE_403 = ExceptionMap[403];
Result$1.PRESENTED_IMAGE_404 = ExceptionMap[404];
Result$1.PRESENTED_IMAGE_500 = ExceptionMap[500];
var _excluded$d = ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"], Switch$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c, u = a.prefixCls, d = u === void 0 ? "rc-switch" : u, p = a.className, v = a.checked, A = a.defaultChecked, x = a.disabled, g = a.loadingIcon, b = a.checkedChildren, y = a.unCheckedChildren, f = a.onClick, m = a.onChange, C = a.onKeyDown, w = _objectWithoutProperties$2(a, _excluded$d), S = useMergedState(!1, {
    value: v,
    defaultValue: A
  }), $ = _slicedToArray$e(S, 2), T = $[0], I = $[1];
  function _(L, B) {
    var F = T;
    return x || (F = L, I(F), m?.(F, B)), F;
  }
  function E(L) {
    L.which === KeyCode.LEFT ? _(!1, L) : L.which === KeyCode.RIGHT && _(!0, L), C?.(L);
  }
  function R(L) {
    var B = _(!T, L);
    f?.(B, L);
  }
  var O = classnames(d, p, (c = {}, _defineProperty$a(c, "".concat(d, "-checked"), T), _defineProperty$a(c, "".concat(d, "-disabled"), x), c));
  return /* @__PURE__ */ reactExports.createElement("button", _extends$3({}, w, {
    type: "button",
    role: "switch",
    "aria-checked": T,
    disabled: x,
    className: O,
    ref: s,
    onKeyDown: E,
    onClick: R
  }), g, /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(d, "-inner")
  }, /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(d, "-inner-checked")
  }, b), /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(d, "-inner-unchecked")
  }, y)));
});
Switch$2.displayName = "Switch";
const genSwitchSmallStyle = (a) => {
  const {
    componentCls: s,
    trackHeightSM: c,
    trackPadding: u,
    trackMinWidthSM: d,
    innerMinMarginSM: p,
    innerMaxMarginSM: v,
    handleSizeSM: A,
    calc: x
  } = a, g = `${s}-inner`, b = unit$1(x(A).add(x(u).mul(2)).equal()), y = unit$1(x(v).mul(2).equal());
  return {
    [s]: {
      [`&${s}-small`]: {
        minWidth: d,
        height: c,
        lineHeight: unit$1(c),
        [`${s}-inner`]: {
          paddingInlineStart: v,
          paddingInlineEnd: p,
          [`${g}-checked, ${g}-unchecked`]: {
            minHeight: c
          },
          [`${g}-checked`]: {
            marginInlineStart: `calc(-100% + ${b} - ${y})`,
            marginInlineEnd: `calc(100% - ${b} + ${y})`
          },
          [`${g}-unchecked`]: {
            marginTop: x(c).mul(-1).equal(),
            marginInlineStart: 0,
            marginInlineEnd: 0
          }
        },
        [`${s}-handle`]: {
          width: A,
          height: A
        },
        [`${s}-loading-icon`]: {
          top: x(x(A).sub(a.switchLoadingIconSize)).div(2).equal(),
          fontSize: a.switchLoadingIconSize
        },
        [`&${s}-checked`]: {
          [`${s}-inner`]: {
            paddingInlineStart: p,
            paddingInlineEnd: v,
            [`${g}-checked`]: {
              marginInlineStart: 0,
              marginInlineEnd: 0
            },
            [`${g}-unchecked`]: {
              marginInlineStart: `calc(100% - ${b} + ${y})`,
              marginInlineEnd: `calc(-100% + ${b} - ${y})`
            }
          },
          [`${s}-handle`]: {
            insetInlineStart: `calc(100% - ${unit$1(x(A).add(u).equal())})`
          }
        },
        [`&:not(${s}-disabled):active`]: {
          [`&:not(${s}-checked) ${g}`]: {
            [`${g}-unchecked`]: {
              marginInlineStart: x(a.marginXXS).div(2).equal(),
              marginInlineEnd: x(a.marginXXS).mul(-1).div(2).equal()
            }
          },
          [`&${s}-checked ${g}`]: {
            [`${g}-checked`]: {
              marginInlineStart: x(a.marginXXS).mul(-1).div(2).equal(),
              marginInlineEnd: x(a.marginXXS).div(2).equal()
            }
          }
        }
      }
    }
  };
}, genSwitchLoadingStyle = (a) => {
  const {
    componentCls: s,
    handleSize: c,
    calc: u
  } = a;
  return {
    [s]: {
      [`${s}-loading-icon${a.iconCls}`]: {
        position: "relative",
        top: u(u(c).sub(a.fontSize)).div(2).equal(),
        color: a.switchLoadingIconColor,
        verticalAlign: "top"
      },
      [`&${s}-checked ${s}-loading-icon`]: {
        color: a.switchColor
      }
    }
  };
}, genSwitchHandleStyle = (a) => {
  const {
    componentCls: s,
    trackPadding: c,
    handleBg: u,
    handleShadow: d,
    handleSize: p,
    calc: v
  } = a, A = `${s}-handle`;
  return {
    [s]: {
      [A]: {
        position: "absolute",
        top: c,
        insetInlineStart: c,
        width: p,
        height: p,
        transition: `all ${a.switchDuration} ease-in-out`,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          backgroundColor: u,
          borderRadius: v(p).div(2).equal(),
          boxShadow: d,
          transition: `all ${a.switchDuration} ease-in-out`,
          content: '""'
        }
      },
      [`&${s}-checked ${A}`]: {
        insetInlineStart: `calc(100% - ${unit$1(v(p).add(c).equal())})`
      },
      [`&:not(${s}-disabled):active`]: {
        [`${A}::before`]: {
          insetInlineEnd: a.switchHandleActiveInset,
          insetInlineStart: 0
        },
        [`&${s}-checked ${A}::before`]: {
          insetInlineEnd: 0,
          insetInlineStart: a.switchHandleActiveInset
        }
      }
    }
  };
}, genSwitchInnerStyle = (a) => {
  const {
    componentCls: s,
    trackHeight: c,
    trackPadding: u,
    innerMinMargin: d,
    innerMaxMargin: p,
    handleSize: v,
    calc: A
  } = a, x = `${s}-inner`, g = unit$1(A(v).add(A(u).mul(2)).equal()), b = unit$1(A(p).mul(2).equal());
  return {
    [s]: {
      [x]: {
        display: "block",
        overflow: "hidden",
        borderRadius: 100,
        height: "100%",
        paddingInlineStart: p,
        paddingInlineEnd: d,
        transition: `padding-inline-start ${a.switchDuration} ease-in-out, padding-inline-end ${a.switchDuration} ease-in-out`,
        [`${x}-checked, ${x}-unchecked`]: {
          display: "block",
          color: a.colorTextLightSolid,
          fontSize: a.fontSizeSM,
          transition: `margin-inline-start ${a.switchDuration} ease-in-out, margin-inline-end ${a.switchDuration} ease-in-out`,
          pointerEvents: "none",
          minHeight: c
        },
        [`${x}-checked`]: {
          marginInlineStart: `calc(-100% + ${g} - ${b})`,
          marginInlineEnd: `calc(100% - ${g} + ${b})`
        },
        [`${x}-unchecked`]: {
          marginTop: A(c).mul(-1).equal(),
          marginInlineStart: 0,
          marginInlineEnd: 0
        }
      },
      [`&${s}-checked ${x}`]: {
        paddingInlineStart: d,
        paddingInlineEnd: p,
        [`${x}-checked`]: {
          marginInlineStart: 0,
          marginInlineEnd: 0
        },
        [`${x}-unchecked`]: {
          marginInlineStart: `calc(100% - ${g} + ${b})`,
          marginInlineEnd: `calc(-100% + ${g} - ${b})`
        }
      },
      [`&:not(${s}-disabled):active`]: {
        [`&:not(${s}-checked) ${x}`]: {
          [`${x}-unchecked`]: {
            marginInlineStart: A(u).mul(2).equal(),
            marginInlineEnd: A(u).mul(-1).mul(2).equal()
          }
        },
        [`&${s}-checked ${x}`]: {
          [`${x}-checked`]: {
            marginInlineStart: A(u).mul(-1).mul(2).equal(),
            marginInlineEnd: A(u).mul(2).equal()
          }
        }
      }
    }
  };
}, genSwitchStyle = (a) => {
  const {
    componentCls: s,
    trackHeight: c,
    trackMinWidth: u
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
      position: "relative",
      display: "inline-block",
      boxSizing: "border-box",
      minWidth: u,
      height: c,
      lineHeight: unit$1(c),
      verticalAlign: "middle",
      background: a.colorTextQuaternary,
      border: "0",
      borderRadius: 100,
      cursor: "pointer",
      transition: `all ${a.motionDurationMid}`,
      userSelect: "none",
      [`&:hover:not(${s}-disabled)`]: {
        background: a.colorTextTertiary
      }
    }), genFocusStyle(a)), {
      [`&${s}-checked`]: {
        background: a.switchColor,
        [`&:hover:not(${s}-disabled)`]: {
          background: a.colorPrimaryHover
        }
      },
      [`&${s}-loading, &${s}-disabled`]: {
        cursor: "not-allowed",
        opacity: a.switchDisabledOpacity,
        "*": {
          boxShadow: "none",
          cursor: "not-allowed"
        }
      },
      // rtl style
      [`&${s}-rtl`]: {
        direction: "rtl"
      }
    })
  };
}, prepareComponentToken$4 = (a) => {
  const {
    fontSize: s,
    lineHeight: c,
    controlHeight: u,
    colorWhite: d
  } = a, p = s * c, v = u / 2, A = 2, x = p - A * 2, g = v - A * 2;
  return {
    trackHeight: p,
    trackHeightSM: v,
    trackMinWidth: x * 2 + A * 4,
    trackMinWidthSM: g * 2 + A * 2,
    trackPadding: A,
    // Fixed value
    handleBg: d,
    handleSize: x,
    handleSizeSM: g,
    handleShadow: `0 2px 4px 0 ${new FastColor("#00230b").setA(0.2).toRgbString()}`,
    innerMinMargin: x / 2,
    innerMaxMargin: x + A + A * 2,
    innerMinMarginSM: g / 2,
    innerMaxMarginSM: g + A + A * 2
  };
}, useStyle$4 = genStyleHooks("Switch", (a) => {
  const s = merge(a, {
    switchDuration: a.motionDurationMid,
    switchColor: a.colorPrimary,
    switchDisabledOpacity: a.opacityLoading,
    switchLoadingIconSize: a.calc(a.fontSizeIcon).mul(0.75).equal(),
    switchLoadingIconColor: `rgba(0, 0, 0, ${a.opacityLoading})`,
    switchHandleActiveInset: "-30%"
  });
  return [
    genSwitchStyle(s),
    // inner style
    genSwitchInnerStyle(s),
    // handle style
    genSwitchHandleStyle(s),
    // loading style
    genSwitchLoadingStyle(s),
    // small style
    genSwitchSmallStyle(s)
  ];
}, prepareComponentToken$4);
var __rest$c = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalSwitch = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    size: u,
    disabled: d,
    loading: p,
    className: v,
    rootClassName: A,
    style: x,
    checked: g,
    value: b,
    defaultChecked: y,
    defaultValue: f,
    onChange: m
  } = a, C = __rest$c(a, ["prefixCls", "size", "disabled", "loading", "className", "rootClassName", "style", "checked", "value", "defaultChecked", "defaultValue", "onChange"]), [w, S] = useMergedState(!1, {
    value: g ?? b,
    defaultValue: y ?? f
  }), {
    getPrefixCls: $,
    direction: T,
    switch: I
  } = reactExports.useContext(ConfigContext$1), _ = reactExports.useContext(DisabledContext), E = (d ?? _) || p, R = $("switch", c), O = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${R}-handle`
  }, p && /* @__PURE__ */ reactExports.createElement(RefIcon$F, {
    className: `${R}-loading-icon`
  })), [L, B, F] = useStyle$4(R), M = useSize(u), W = classnames(I?.className, {
    [`${R}-small`]: M === "small",
    [`${R}-loading`]: p,
    [`${R}-rtl`]: T === "rtl"
  }, v, A, B, F), j = Object.assign(Object.assign({}, I?.style), x), G = (...U) => {
    S(U[0]), m?.apply(void 0, U);
  };
  return L(/* @__PURE__ */ reactExports.createElement(Wave, {
    component: "Switch"
  }, /* @__PURE__ */ reactExports.createElement(Switch$2, Object.assign({}, C, {
    checked: w,
    onChange: G,
    prefixCls: R,
    className: W,
    style: j,
    disabled: E,
    ref: s,
    loadingIcon: O
  }))));
}), Switch$1 = InternalSwitch;
Switch$1.__ANT_SWITCH = !0;
var EXPAND_COLUMN = {}, INTERNAL_HOOKS = "rc-table-internal-hook";
function createContext(a) {
  var s = /* @__PURE__ */ reactExports.createContext(void 0), c = function(d) {
    var p = d.value, v = d.children, A = reactExports.useRef(p);
    A.current = p;
    var x = reactExports.useState(function() {
      return {
        getValue: function() {
          return A.current;
        },
        listeners: /* @__PURE__ */ new Set()
      };
    }), g = _slicedToArray$e(x, 1), b = g[0];
    return useLayoutEffect$1(function() {
      reactDomExports.unstable_batchedUpdates(function() {
        b.listeners.forEach(function(y) {
          y(p);
        });
      });
    }, [p]), /* @__PURE__ */ reactExports.createElement(s.Provider, {
      value: b
    }, v);
  };
  return {
    Context: s,
    Provider: c,
    defaultValue: a
  };
}
function useContext(a, s) {
  var c = useEvent(typeof s == "function" ? s : function(y) {
    if (s === void 0)
      return y;
    if (!Array.isArray(s))
      return y[s];
    var f = {};
    return s.forEach(function(m) {
      f[m] = y[m];
    }), f;
  }), u = reactExports.useContext(a?.Context), d = u || {}, p = d.listeners, v = d.getValue, A = reactExports.useRef();
  A.current = c(u ? v() : a?.defaultValue);
  var x = reactExports.useState({}), g = _slicedToArray$e(x, 2), b = g[1];
  return useLayoutEffect$1(function() {
    if (!u)
      return;
    function y(f) {
      var m = c(f);
      isEqual(A.current, m, !0) || b({});
    }
    return p.add(y), function() {
      p.delete(y);
    };
  }, [u]), A.current;
}
function createImmutable() {
  var a = /* @__PURE__ */ reactExports.createContext(null);
  function s() {
    return reactExports.useContext(a);
  }
  function c(d, p) {
    var v = supportRef(d), A = function(g, b) {
      var y = v ? {
        ref: b
      } : {}, f = reactExports.useRef(0), m = reactExports.useRef(g), C = s();
      return C !== null ? /* @__PURE__ */ reactExports.createElement(d, _extends$3({}, g, y)) : (
        // Always trigger re-render if not provide `notTriggerRender`
        ((!p || p(m.current, g)) && (f.current += 1), m.current = g, /* @__PURE__ */ reactExports.createElement(a.Provider, {
          value: f.current
        }, /* @__PURE__ */ reactExports.createElement(d, _extends$3({}, g, y))))
      );
    };
    return v ? /* @__PURE__ */ reactExports.forwardRef(A) : A;
  }
  function u(d, p) {
    var v = supportRef(d), A = function(g, b) {
      var y = v ? {
        ref: b
      } : {};
      return s(), /* @__PURE__ */ reactExports.createElement(d, _extends$3({}, g, y));
    };
    return v ? /* @__PURE__ */ reactExports.memo(/* @__PURE__ */ reactExports.forwardRef(A), p) : /* @__PURE__ */ reactExports.memo(A, p);
  }
  return {
    makeImmutable: c,
    responseImmutable: u,
    useImmutableMark: s
  };
}
var _createImmutable = createImmutable(), makeImmutable = _createImmutable.makeImmutable, responseImmutable = _createImmutable.responseImmutable, useImmutableMark = _createImmutable.useImmutableMark, TableContext = createContext(), PerfContext = /* @__PURE__ */ reactExports.createContext({
  renderWithProps: !1
}), INTERNAL_KEY_PREFIX = "RC_TABLE_KEY";
function toArray$1(a) {
  return a == null ? [] : Array.isArray(a) ? a : [a];
}
function getColumnsKey(a) {
  var s = [], c = {};
  return a.forEach(function(u) {
    for (var d = u || {}, p = d.key, v = d.dataIndex, A = p || toArray$1(v).join("-") || INTERNAL_KEY_PREFIX; c[A]; )
      A = "".concat(A, "_next");
    c[A] = !0, s.push(A);
  }), s;
}
function validateValue(a) {
  return a != null;
}
function validNumberValue(a) {
  return typeof a == "number" && !Number.isNaN(a);
}
function isRenderCell(a) {
  return a && _typeof$h(a) === "object" && !Array.isArray(a) && !/* @__PURE__ */ reactExports.isValidElement(a);
}
function useCellRender(a, s, c, u, d, p) {
  var v = reactExports.useContext(PerfContext), A = useImmutableMark(), x = useMemo(function() {
    if (validateValue(u))
      return [u];
    var g = s == null || s === "" ? [] : Array.isArray(s) ? s : [s], b = get$1(a, g), y = b, f = void 0;
    if (d) {
      var m = d(b, a, c);
      isRenderCell(m) ? (y = m.children, f = m.props, v.renderWithProps = !0) : y = m;
    }
    return [y, f];
  }, [
    // Force update deps
    A,
    // Normal deps
    a,
    u,
    s,
    d,
    c
  ], function(g, b) {
    if (p) {
      var y = _slicedToArray$e(g, 2), f = y[1], m = _slicedToArray$e(b, 2), C = m[1];
      return p(C, f);
    }
    return v.renderWithProps ? !0 : !isEqual(g, b, !0);
  });
  return x;
}
function inHoverRange(a, s, c, u) {
  var d = a + s - 1;
  return a <= u && d >= c;
}
function useHoverState(a, s) {
  return useContext(TableContext, function(c) {
    var u = inHoverRange(a, s || 1, c.hoverStartRow, c.hoverEndRow);
    return [u, c.onHover];
  });
}
var getTitleFromCellRenderChildren = function a(s) {
  var c = s.ellipsis, u = s.rowType, d = s.children, p, v = c === !0 ? {
    showTitle: !0
  } : c;
  return v && (v.showTitle || u === "header") && (typeof d == "string" || typeof d == "number" ? p = d.toString() : /* @__PURE__ */ reactExports.isValidElement(d) && typeof d.props.children == "string" && (p = d.props.children)), p;
};
function Cell(a) {
  var s, c, u, d, p, v, A, x, g = a.component, b = a.children, y = a.ellipsis, f = a.scope, m = a.prefixCls, C = a.className, w = a.align, S = a.record, $ = a.render, T = a.dataIndex, I = a.renderIndex, _ = a.shouldCellUpdate, E = a.index, R = a.rowType, O = a.colSpan, L = a.rowSpan, B = a.fixLeft, F = a.fixRight, M = a.firstFixLeft, W = a.lastFixLeft, j = a.firstFixRight, G = a.lastFixRight, U = a.appendNode, k = a.additionalProps, N = k === void 0 ? {} : k, P = a.isSticky, D = "".concat(m, "-cell"), H = useContext(TableContext, ["supportSticky", "allColumnsFixedLeft", "rowHoverable"]), V = H.supportSticky, Z = H.allColumnsFixedLeft, ne = H.rowHoverable, K = useCellRender(S, T, I, b, $, _), q = _slicedToArray$e(K, 2), Y = q[0], ee = q[1], Q = {}, J = typeof B == "number" && V, te = typeof F == "number" && V;
  J && (Q.position = "sticky", Q.left = B), te && (Q.position = "sticky", Q.right = F);
  var ae = (s = (c = (u = ee?.colSpan) !== null && u !== void 0 ? u : N.colSpan) !== null && c !== void 0 ? c : O) !== null && s !== void 0 ? s : 1, se = (d = (p = (v = ee?.rowSpan) !== null && v !== void 0 ? v : N.rowSpan) !== null && p !== void 0 ? p : L) !== null && d !== void 0 ? d : 1, ie = useHoverState(E, se), fe = _slicedToArray$e(ie, 2), ge = fe[0], me = fe[1], pe = useEvent(function(xe) {
    var we;
    S && me(E, E + se - 1), N == null || (we = N.onMouseEnter) === null || we === void 0 || we.call(N, xe);
  }), be = useEvent(function(xe) {
    var we;
    S && me(-1, -1), N == null || (we = N.onMouseLeave) === null || we === void 0 || we.call(N, xe);
  });
  if (ae === 0 || se === 0)
    return null;
  var le = (A = N.title) !== null && A !== void 0 ? A : getTitleFromCellRenderChildren({
    rowType: R,
    ellipsis: y,
    children: Y
  }), ve = classnames(D, C, (x = {}, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(x, "".concat(D, "-fix-left"), J && V), "".concat(D, "-fix-left-first"), M && V), "".concat(D, "-fix-left-last"), W && V), "".concat(D, "-fix-left-all"), W && Z && V), "".concat(D, "-fix-right"), te && V), "".concat(D, "-fix-right-first"), j && V), "".concat(D, "-fix-right-last"), G && V), "".concat(D, "-ellipsis"), y), "".concat(D, "-with-append"), U), "".concat(D, "-fix-sticky"), (J || te) && P && V), _defineProperty$a(x, "".concat(D, "-row-hover"), !ee && ge)), N.className, ee?.className), he = {};
  w && (he.textAlign = w);
  var ye = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, ee?.style), Q), he), N.style), Ce = Y;
  return _typeof$h(Ce) === "object" && !Array.isArray(Ce) && !/* @__PURE__ */ reactExports.isValidElement(Ce) && (Ce = null), y && (W || j) && (Ce = /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(D, "-content")
  }, Ce)), /* @__PURE__ */ reactExports.createElement(g, _extends$3({}, ee, N, {
    className: ve,
    style: ye,
    title: le,
    scope: f,
    onMouseEnter: ne ? pe : void 0,
    onMouseLeave: ne ? be : void 0,
    colSpan: ae !== 1 ? ae : null,
    rowSpan: se !== 1 ? se : null
  }), U, Ce);
}
const Cell$1 = /* @__PURE__ */ reactExports.memo(Cell);
function getCellFixedInfo(a, s, c, u, d) {
  var p = c[a] || {}, v = c[s] || {}, A, x;
  p.fixed === "left" ? A = u.left[d === "rtl" ? s : a] : v.fixed === "right" && (x = u.right[d === "rtl" ? a : s]);
  var g = !1, b = !1, y = !1, f = !1, m = c[s + 1], C = c[a - 1], w = m && !m.fixed || C && !C.fixed || c.every(function(_) {
    return _.fixed === "left";
  });
  if (d === "rtl") {
    if (A !== void 0) {
      var S = C && C.fixed === "left";
      f = !S && w;
    } else if (x !== void 0) {
      var $ = m && m.fixed === "right";
      y = !$ && w;
    }
  } else if (A !== void 0) {
    var T = m && m.fixed === "left";
    g = !T && w;
  } else if (x !== void 0) {
    var I = C && C.fixed === "right";
    b = !I && w;
  }
  return {
    fixLeft: A,
    fixRight: x,
    lastFixLeft: g,
    firstFixRight: b,
    lastFixRight: y,
    firstFixLeft: f,
    isSticky: u.isSticky
  };
}
var SummaryContext = /* @__PURE__ */ reactExports.createContext({});
function SummaryCell(a) {
  var s = a.className, c = a.index, u = a.children, d = a.colSpan, p = d === void 0 ? 1 : d, v = a.rowSpan, A = a.align, x = useContext(TableContext, ["prefixCls", "direction"]), g = x.prefixCls, b = x.direction, y = reactExports.useContext(SummaryContext), f = y.scrollColumnIndex, m = y.stickyOffsets, C = y.flattenColumns, w = c + p - 1, S = w + 1 === f ? p + 1 : p, $ = getCellFixedInfo(c, c + S - 1, C, m, b);
  return /* @__PURE__ */ reactExports.createElement(Cell$1, _extends$3({
    className: s,
    index: c,
    component: "td",
    prefixCls: g,
    record: null,
    dataIndex: null,
    align: A,
    colSpan: S,
    rowSpan: v,
    render: function() {
      return u;
    }
  }, $));
}
var _excluded$c = ["children"];
function FooterRow(a) {
  var s = a.children, c = _objectWithoutProperties$2(a, _excluded$c);
  return /* @__PURE__ */ reactExports.createElement("tr", c, s);
}
function Summary(a) {
  var s = a.children;
  return s;
}
Summary.Row = FooterRow;
Summary.Cell = SummaryCell;
function Footer(a) {
  var s = a.children, c = a.stickyOffsets, u = a.flattenColumns, d = useContext(TableContext, "prefixCls"), p = u.length - 1, v = u[p], A = reactExports.useMemo(function() {
    return {
      stickyOffsets: c,
      flattenColumns: u,
      scrollColumnIndex: v != null && v.scrollbar ? p : null
    };
  }, [v, u, p, c]);
  return /* @__PURE__ */ reactExports.createElement(SummaryContext.Provider, {
    value: A
  }, /* @__PURE__ */ reactExports.createElement("tfoot", {
    className: "".concat(d, "-summary")
  }, s));
}
const Footer$1 = responseImmutable(Footer);
var FooterComponents = Summary;
function Column$1(a) {
  return null;
}
function ColumnGroup$1(a) {
  return null;
}
function fillRecords(a, s, c, u, d, p, v) {
  var A = p(s, v);
  a.push({
    record: s,
    indent: c,
    index: v,
    rowKey: A
  });
  var x = d?.has(A);
  if (s && Array.isArray(s[u]) && x)
    for (var g = 0; g < s[u].length; g += 1)
      fillRecords(a, s[u][g], c + 1, u, d, p, g);
}
function useFlattenRecords(a, s, c, u) {
  var d = reactExports.useMemo(function() {
    if (c != null && c.size) {
      for (var p = [], v = 0; v < a?.length; v += 1) {
        var A = a[v];
        fillRecords(p, A, 0, s, c, u, v);
      }
      return p;
    }
    return a?.map(function(x, g) {
      return {
        record: x,
        indent: 0,
        index: g,
        rowKey: u(x, g)
      };
    });
  }, [a, s, c, u]);
  return d;
}
function useRowInfo(a, s, c, u) {
  var d = useContext(TableContext, ["prefixCls", "fixedInfoList", "flattenColumns", "expandableType", "expandRowByClick", "onTriggerExpand", "rowClassName", "expandedRowClassName", "indentSize", "expandIcon", "expandedRowRender", "expandIconColumnIndex", "expandedKeys", "childrenColumnName", "rowExpandable", "onRow"]), p = d.flattenColumns, v = d.expandableType, A = d.expandedKeys, x = d.childrenColumnName, g = d.onTriggerExpand, b = d.rowExpandable, y = d.onRow, f = d.expandRowByClick, m = d.rowClassName, C = v === "nest", w = v === "row" && (!b || b(a)), S = w || C, $ = A && A.has(s), T = x && a && a[x], I = useEvent(g), _ = y?.(a, c), E = _?.onClick, R = function(F) {
    f && S && g(a, F);
    for (var M = arguments.length, W = new Array(M > 1 ? M - 1 : 0), j = 1; j < M; j++)
      W[j - 1] = arguments[j];
    E?.apply(void 0, [F].concat(W));
  }, O;
  typeof m == "string" ? O = m : typeof m == "function" && (O = m(a, c, u));
  var L = getColumnsKey(p);
  return _objectSpread2$1(_objectSpread2$1({}, d), {}, {
    columnsKey: L,
    nestExpandable: C,
    expanded: $,
    hasNestChildren: T,
    record: a,
    onTriggerExpand: I,
    rowSupportExpand: w,
    expandable: S,
    rowProps: _objectSpread2$1(_objectSpread2$1({}, _), {}, {
      className: classnames(O, _?.className),
      onClick: R
    })
  });
}
function ExpandedRow(a) {
  var s = a.prefixCls, c = a.children, u = a.component, d = a.cellComponent, p = a.className, v = a.expanded, A = a.colSpan, x = a.isEmpty, g = a.stickyOffset, b = g === void 0 ? 0 : g, y = useContext(TableContext, ["scrollbarSize", "fixHeader", "fixColumn", "componentWidth", "horizonScroll"]), f = y.scrollbarSize, m = y.fixHeader, C = y.fixColumn, w = y.componentWidth, S = y.horizonScroll, $ = c;
  return (x ? S && w : C) && ($ = /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      width: w - b - (m && !x ? f : 0),
      position: "sticky",
      left: b,
      overflow: "hidden"
    },
    className: "".concat(s, "-expanded-row-fixed")
  }, $)), /* @__PURE__ */ reactExports.createElement(u, {
    className: p,
    style: {
      display: v ? null : "none"
    }
  }, /* @__PURE__ */ reactExports.createElement(Cell$1, {
    component: d,
    prefixCls: s,
    colSpan: A
  }, $));
}
function renderExpandIcon$1(a) {
  var s = a.prefixCls, c = a.record, u = a.onExpand, d = a.expanded, p = a.expandable, v = "".concat(s, "-row-expand-icon");
  if (!p)
    return /* @__PURE__ */ reactExports.createElement("span", {
      className: classnames(v, "".concat(s, "-row-spaced"))
    });
  var A = function(g) {
    u(c, g), g.stopPropagation();
  };
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(v, _defineProperty$a(_defineProperty$a({}, "".concat(s, "-row-expanded"), d), "".concat(s, "-row-collapsed"), !d)),
    onClick: A
  });
}
function findAllChildrenKeys(a, s, c) {
  var u = [];
  function d(p) {
    (p || []).forEach(function(v, A) {
      u.push(s(v, A)), d(v[c]);
    });
  }
  return d(a), u;
}
function computedExpandedClassName(a, s, c, u) {
  return typeof a == "string" ? a : typeof a == "function" ? a(s, c, u) : "";
}
function getCellProps(a, s, c, u, d) {
  var p, v = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], A = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0, x = a.record, g = a.prefixCls, b = a.columnsKey, y = a.fixedInfoList, f = a.expandIconColumnIndex, m = a.nestExpandable, C = a.indentSize, w = a.expandIcon, S = a.expanded, $ = a.hasNestChildren, T = a.onTriggerExpand, I = a.expandable, _ = a.expandedKeys, E = b[c], R = y[c], O;
  c === (f || 0) && m && (O = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("span", {
    style: {
      paddingLeft: "".concat(C * u, "px")
    },
    className: "".concat(g, "-row-indent indent-level-").concat(u)
  }), w({
    prefixCls: g,
    expanded: S,
    expandable: $,
    record: x,
    onExpand: T
  })));
  var L = ((p = s.onCell) === null || p === void 0 ? void 0 : p.call(s, x, d)) || {};
  if (A) {
    var B = L.rowSpan, F = B === void 0 ? 1 : B;
    if (I && F && c < A) {
      for (var M = F, W = d; W < d + F; W += 1) {
        var j = v[W];
        _.has(j) && (M += 1);
      }
      L.rowSpan = M;
    }
  }
  return {
    key: E,
    fixedInfo: R,
    appendCellNode: O,
    additionalCellProps: L
  };
}
function BodyRow(a) {
  var s = a.className, c = a.style, u = a.record, d = a.index, p = a.renderIndex, v = a.rowKey, A = a.rowKeys, x = a.indent, g = x === void 0 ? 0 : x, b = a.rowComponent, y = a.cellComponent, f = a.scopeCellComponent, m = a.expandedRowInfo, C = useRowInfo(u, v, d, g), w = C.prefixCls, S = C.flattenColumns, $ = C.expandedRowClassName, T = C.expandedRowRender, I = C.rowProps, _ = C.expanded, E = C.rowSupportExpand, R = reactExports.useRef(!1);
  R.current || (R.current = _);
  var O = computedExpandedClassName($, u, d, g), L = /* @__PURE__ */ reactExports.createElement(b, _extends$3({}, I, {
    "data-row-key": v,
    className: classnames(s, "".concat(w, "-row"), "".concat(w, "-row-level-").concat(g), I?.className, _defineProperty$a({}, O, g >= 1)),
    style: _objectSpread2$1(_objectSpread2$1({}, c), I?.style)
  }), S.map(function(M, W) {
    var j = M.render, G = M.dataIndex, U = M.className, k = getCellProps(C, M, W, g, d, A, m?.offset), N = k.key, P = k.fixedInfo, D = k.appendCellNode, H = k.additionalCellProps;
    return /* @__PURE__ */ reactExports.createElement(Cell$1, _extends$3({
      className: U,
      ellipsis: M.ellipsis,
      align: M.align,
      scope: M.rowScope,
      component: M.rowScope ? f : y,
      prefixCls: w,
      key: N,
      record: u,
      index: d,
      renderIndex: p,
      dataIndex: G,
      render: j,
      shouldCellUpdate: M.shouldCellUpdate
    }, P, {
      appendNode: D,
      additionalProps: H
    }));
  })), B;
  if (E && (R.current || _)) {
    var F = T(u, d, g + 1, _);
    B = /* @__PURE__ */ reactExports.createElement(ExpandedRow, {
      expanded: _,
      className: classnames("".concat(w, "-expanded-row"), "".concat(w, "-expanded-row-level-").concat(g + 1), O),
      prefixCls: w,
      component: b,
      cellComponent: y,
      colSpan: m ? m.colSpan : S.length,
      stickyOffset: m?.sticky,
      isEmpty: !1
    }, F);
  }
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, L, B);
}
const BodyRow$1 = responseImmutable(BodyRow);
function MeasureCell(a) {
  var s = a.columnKey, c = a.onColumnResize, u = reactExports.useRef();
  return useLayoutEffect$1(function() {
    u.current && c(s, u.current.offsetWidth);
  }, []), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    data: s
  }, /* @__PURE__ */ reactExports.createElement("td", {
    ref: u,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      height: 0,
      overflow: "hidden"
    }
  }, " ")));
}
function MeasureRow(a) {
  var s = a.prefixCls, c = a.columnsKey, u = a.onColumnResize, d = reactExports.useRef(null);
  return /* @__PURE__ */ reactExports.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(s, "-measure-row"),
    style: {
      height: 0,
      fontSize: 0
    },
    ref: d
  }, /* @__PURE__ */ reactExports.createElement(RefResizeObserver.Collection, {
    onBatchResize: function(v) {
      isVisible(d.current) && v.forEach(function(A) {
        var x = A.data, g = A.size;
        u(x, g.offsetWidth);
      });
    }
  }, c.map(function(p) {
    return /* @__PURE__ */ reactExports.createElement(MeasureCell, {
      key: p,
      columnKey: p,
      onColumnResize: u
    });
  })));
}
function Body(a) {
  var s = a.data, c = a.measureColumnWidth, u = useContext(TableContext, ["prefixCls", "getComponent", "onColumnResize", "flattenColumns", "getRowKey", "expandedKeys", "childrenColumnName", "emptyNode", "expandedRowOffset", "fixedInfoList", "colWidths"]), d = u.prefixCls, p = u.getComponent, v = u.onColumnResize, A = u.flattenColumns, x = u.getRowKey, g = u.expandedKeys, b = u.childrenColumnName, y = u.emptyNode, f = u.expandedRowOffset, m = f === void 0 ? 0 : f, C = u.colWidths, w = useFlattenRecords(s, b, g, x), S = reactExports.useMemo(function() {
    return w.map(function(B) {
      return B.rowKey;
    });
  }, [w]), $ = reactExports.useRef({
    renderWithProps: !1
  }), T = reactExports.useMemo(function() {
    for (var B = A.length - m, F = 0, M = 0; M < m; M += 1)
      F += C[M] || 0;
    return {
      offset: m,
      colSpan: B,
      sticky: F
    };
  }, [A.length, m, C]), I = p(["body", "wrapper"], "tbody"), _ = p(["body", "row"], "tr"), E = p(["body", "cell"], "td"), R = p(["body", "cell"], "th"), O;
  s.length ? O = w.map(function(B, F) {
    var M = B.record, W = B.indent, j = B.index, G = B.rowKey;
    return /* @__PURE__ */ reactExports.createElement(BodyRow$1, {
      key: G,
      rowKey: G,
      rowKeys: S,
      record: M,
      index: F,
      renderIndex: j,
      rowComponent: _,
      cellComponent: E,
      scopeCellComponent: R,
      indent: W,
      expandedRowInfo: T
    });
  }) : O = /* @__PURE__ */ reactExports.createElement(ExpandedRow, {
    expanded: !0,
    className: "".concat(d, "-placeholder"),
    prefixCls: d,
    component: _,
    cellComponent: E,
    colSpan: A.length,
    isEmpty: !0
  }, y);
  var L = getColumnsKey(A);
  return /* @__PURE__ */ reactExports.createElement(PerfContext.Provider, {
    value: $.current
  }, /* @__PURE__ */ reactExports.createElement(I, {
    className: "".concat(d, "-tbody")
  }, c && /* @__PURE__ */ reactExports.createElement(MeasureRow, {
    prefixCls: d,
    columnsKey: L,
    onColumnResize: v
  }), O));
}
const Body$1 = responseImmutable(Body);
var _excluded$b = ["expandable"], INTERNAL_COL_DEFINE = "RC_TABLE_INTERNAL_COL_DEFINE";
function getExpandableProps(a) {
  var s = a.expandable, c = _objectWithoutProperties$2(a, _excluded$b), u;
  return "expandable" in a ? u = _objectSpread2$1(_objectSpread2$1({}, c), s) : u = c, u.showExpandColumn === !1 && (u.expandIconColumnIndex = -1), u;
}
var _excluded$a = ["columnType"];
function ColGroup(a) {
  for (var s = a.colWidths, c = a.columns, u = a.columCount, d = useContext(TableContext, ["tableLayout"]), p = d.tableLayout, v = [], A = u || c.length, x = !1, g = A - 1; g >= 0; g -= 1) {
    var b = s[g], y = c && c[g], f = void 0, m = void 0;
    if (y && (f = y[INTERNAL_COL_DEFINE], p === "auto" && (m = y.minWidth)), b || m || f || x) {
      var C = f || {};
      C.columnType;
      var w = _objectWithoutProperties$2(C, _excluded$a);
      v.unshift(/* @__PURE__ */ reactExports.createElement("col", _extends$3({
        key: g,
        style: {
          width: b,
          minWidth: m
        }
      }, w))), x = !0;
    }
  }
  return /* @__PURE__ */ reactExports.createElement("colgroup", null, v);
}
var _excluded$9 = ["className", "noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "onScroll", "maxContentScroll", "children"];
function useColumnWidth(a, s) {
  return reactExports.useMemo(function() {
    for (var c = [], u = 0; u < s; u += 1) {
      var d = a[u];
      if (d !== void 0)
        c[u] = d;
      else
        return null;
    }
    return c;
  }, [a.join("_"), s]);
}
var FixedHolder = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.className, u = a.noData, d = a.columns, p = a.flattenColumns, v = a.colWidths, A = a.columCount, x = a.stickyOffsets, g = a.direction, b = a.fixHeader, y = a.stickyTopOffset, f = a.stickyBottomOffset, m = a.stickyClassName, C = a.onScroll, w = a.maxContentScroll, S = a.children, $ = _objectWithoutProperties$2(a, _excluded$9), T = useContext(TableContext, ["prefixCls", "scrollbarSize", "isSticky", "getComponent"]), I = T.prefixCls, _ = T.scrollbarSize, E = T.isSticky, R = T.getComponent, O = R(["header", "table"], "table"), L = E && !b ? 0 : _, B = reactExports.useRef(null), F = reactExports.useCallback(function(P) {
    fillRef(s, P), fillRef(B, P);
  }, []);
  reactExports.useEffect(function() {
    function P(H) {
      var V = H, Z = V.currentTarget, ne = V.deltaX;
      ne && (C({
        currentTarget: Z,
        scrollLeft: Z.scrollLeft + ne
      }), H.preventDefault());
    }
    var D = B.current;
    return D?.addEventListener("wheel", P, {
      passive: !1
    }), function() {
      D?.removeEventListener("wheel", P);
    };
  }, []);
  var M = reactExports.useMemo(function() {
    return p.every(function(P) {
      return P.width;
    });
  }, [p]), W = p[p.length - 1], j = {
    fixed: W ? W.fixed : null,
    scrollbar: !0,
    onHeaderCell: function() {
      return {
        className: "".concat(I, "-cell-scrollbar")
      };
    }
  }, G = reactExports.useMemo(function() {
    return L ? [].concat(_toConsumableArray$e(d), [j]) : d;
  }, [L, d]), U = reactExports.useMemo(function() {
    return L ? [].concat(_toConsumableArray$e(p), [j]) : p;
  }, [L, p]), k = reactExports.useMemo(function() {
    var P = x.right, D = x.left;
    return _objectSpread2$1(_objectSpread2$1({}, x), {}, {
      left: g === "rtl" ? [].concat(_toConsumableArray$e(D.map(function(H) {
        return H + L;
      })), [0]) : D,
      right: g === "rtl" ? P : [].concat(_toConsumableArray$e(P.map(function(H) {
        return H + L;
      })), [0]),
      isSticky: E
    });
  }, [L, x, E]), N = useColumnWidth(v, A);
  return /* @__PURE__ */ reactExports.createElement("div", {
    style: _objectSpread2$1({
      overflow: "hidden"
    }, E ? {
      top: y,
      bottom: f
    } : {}),
    ref: F,
    className: classnames(c, _defineProperty$a({}, m, !!m))
  }, /* @__PURE__ */ reactExports.createElement(O, {
    style: {
      tableLayout: "fixed",
      visibility: u || N ? null : "hidden"
    }
  }, (!u || !w || M) && /* @__PURE__ */ reactExports.createElement(ColGroup, {
    colWidths: N ? [].concat(_toConsumableArray$e(N), [L]) : [],
    columCount: A + 1,
    columns: U
  }), S(_objectSpread2$1(_objectSpread2$1({}, $), {}, {
    stickyOffsets: k,
    columns: G,
    flattenColumns: U
  }))));
});
const FixedHolder$1 = /* @__PURE__ */ reactExports.memo(FixedHolder);
var HeaderRow = function a(s) {
  var c = s.cells, u = s.stickyOffsets, d = s.flattenColumns, p = s.rowComponent, v = s.cellComponent, A = s.onHeaderRow, x = s.index, g = useContext(TableContext, ["prefixCls", "direction"]), b = g.prefixCls, y = g.direction, f;
  A && (f = A(c.map(function(C) {
    return C.column;
  }), x));
  var m = getColumnsKey(c.map(function(C) {
    return C.column;
  }));
  return /* @__PURE__ */ reactExports.createElement(p, f, c.map(function(C, w) {
    var S = C.column, $ = getCellFixedInfo(C.colStart, C.colEnd, d, u, y), T;
    return S && S.onHeaderCell && (T = C.column.onHeaderCell(S)), /* @__PURE__ */ reactExports.createElement(Cell$1, _extends$3({}, C, {
      scope: S.title ? C.colSpan > 1 ? "colgroup" : "col" : null,
      ellipsis: S.ellipsis,
      align: S.align,
      component: v,
      prefixCls: b,
      key: m[w]
    }, $, {
      additionalProps: T,
      rowType: "header"
    }));
  }));
};
function parseHeaderRows(a) {
  var s = [];
  function c(v, A) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    s[x] = s[x] || [];
    var g = A, b = v.filter(Boolean).map(function(y) {
      var f = {
        key: y.key,
        className: y.className || "",
        children: y.title,
        column: y,
        colStart: g
      }, m = 1, C = y.children;
      return C && C.length > 0 && (m = c(C, g, x + 1).reduce(function(w, S) {
        return w + S;
      }, 0), f.hasSubColumns = !0), "colSpan" in y && (m = y.colSpan), "rowSpan" in y && (f.rowSpan = y.rowSpan), f.colSpan = m, f.colEnd = f.colStart + m - 1, s[x].push(f), g += m, m;
    });
    return b;
  }
  c(a, 0);
  for (var u = s.length, d = function(A) {
    s[A].forEach(function(x) {
      !("rowSpan" in x) && !x.hasSubColumns && (x.rowSpan = u - A);
    });
  }, p = 0; p < u; p += 1)
    d(p);
  return s;
}
var Header = function a(s) {
  var c = s.stickyOffsets, u = s.columns, d = s.flattenColumns, p = s.onHeaderRow, v = useContext(TableContext, ["prefixCls", "getComponent"]), A = v.prefixCls, x = v.getComponent, g = reactExports.useMemo(function() {
    return parseHeaderRows(u);
  }, [u]), b = x(["header", "wrapper"], "thead"), y = x(["header", "row"], "tr"), f = x(["header", "cell"], "th");
  return /* @__PURE__ */ reactExports.createElement(b, {
    className: "".concat(A, "-thead")
  }, g.map(function(m, C) {
    var w = /* @__PURE__ */ reactExports.createElement(HeaderRow, {
      key: C,
      flattenColumns: d,
      cells: m,
      stickyOffsets: c,
      rowComponent: y,
      cellComponent: f,
      onHeaderRow: p,
      index: C
    });
    return w;
  }));
};
const Header$1 = responseImmutable(Header);
function parseColWidth(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return typeof s == "number" ? s : s.endsWith("%") ? a * parseFloat(s) / 100 : null;
}
function useWidthColumns(a, s, c) {
  return reactExports.useMemo(function() {
    if (s && s > 0) {
      var u = 0, d = 0;
      a.forEach(function(f) {
        var m = parseColWidth(s, f.width);
        m ? u += m : d += 1;
      });
      var p = Math.max(s, c), v = Math.max(p - u, d), A = d, x = v / d, g = 0, b = a.map(function(f) {
        var m = _objectSpread2$1({}, f), C = parseColWidth(s, m.width);
        if (C)
          m.width = C;
        else {
          var w = Math.floor(x);
          m.width = A === 1 ? v : w, v -= w, A -= 1;
        }
        return g += m.width, m;
      });
      if (g < p) {
        var y = p / g;
        v = p, b.forEach(function(f, m) {
          var C = Math.floor(f.width * y);
          f.width = m === b.length - 1 ? v : C, v -= C;
        });
      }
      return [b, Math.max(g, p)];
    }
    return [a, s];
  }, [a, s, c]);
}
var _excluded$8 = ["children"], _excluded2$1 = ["fixed"];
function convertChildrenToColumns(a) {
  return toArray$8(a).filter(function(s) {
    return /* @__PURE__ */ reactExports.isValidElement(s);
  }).map(function(s) {
    var c = s.key, u = s.props, d = u.children, p = _objectWithoutProperties$2(u, _excluded$8), v = _objectSpread2$1({
      key: c
    }, p);
    return d && (v.children = convertChildrenToColumns(d)), v;
  });
}
function filterHiddenColumns(a) {
  return a.filter(function(s) {
    return s && _typeof$h(s) === "object" && !s.hidden;
  }).map(function(s) {
    var c = s.children;
    return c && c.length > 0 ? _objectSpread2$1(_objectSpread2$1({}, s), {}, {
      children: filterHiddenColumns(c)
    }) : s;
  });
}
function flatColumns(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "key";
  return a.filter(function(c) {
    return c && _typeof$h(c) === "object";
  }).reduce(function(c, u, d) {
    var p = u.fixed, v = p === !0 ? "left" : p, A = "".concat(s, "-").concat(d), x = u.children;
    return x && x.length > 0 ? [].concat(_toConsumableArray$e(c), _toConsumableArray$e(flatColumns(x, A).map(function(g) {
      return _objectSpread2$1({
        fixed: v
      }, g);
    }))) : [].concat(_toConsumableArray$e(c), [_objectSpread2$1(_objectSpread2$1({
      key: A
    }, u), {}, {
      fixed: v
    })]);
  }, []);
}
function revertForRtl(a) {
  return a.map(function(s) {
    var c = s.fixed, u = _objectWithoutProperties$2(s, _excluded2$1), d = c;
    return c === "left" ? d = "right" : c === "right" && (d = "left"), _objectSpread2$1({
      fixed: d
    }, u);
  });
}
function useColumns(a, s) {
  var c = a.prefixCls, u = a.columns, d = a.children, p = a.expandable, v = a.expandedKeys, A = a.columnTitle, x = a.getRowKey, g = a.onTriggerExpand, b = a.expandIcon, y = a.rowExpandable, f = a.expandIconColumnIndex, m = a.expandedRowOffset, C = m === void 0 ? 0 : m, w = a.direction, S = a.expandRowByClick, $ = a.columnWidth, T = a.fixed, I = a.scrollWidth, _ = a.clientWidth, E = reactExports.useMemo(function() {
    var G = u || convertChildrenToColumns(d) || [];
    return filterHiddenColumns(G.slice());
  }, [u, d]), R = reactExports.useMemo(function() {
    if (p) {
      var G = E.slice();
      if (!G.includes(EXPAND_COLUMN)) {
        var U = f || 0;
        U >= 0 && (U || T === "left" || !T) && G.splice(U, 0, EXPAND_COLUMN), T === "right" && G.splice(E.length, 0, EXPAND_COLUMN);
      }
      var k = G.indexOf(EXPAND_COLUMN);
      G = G.filter(function(H, V) {
        return H !== EXPAND_COLUMN || V === k;
      });
      var N = E[k], P;
      T ? P = T : P = N ? N.fixed : null;
      var D = _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, INTERNAL_COL_DEFINE, {
        className: "".concat(c, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), "title", A), "fixed", P), "className", "".concat(c, "-row-expand-icon-cell")), "width", $), "render", function(V, Z, ne) {
        var K = x(Z, ne), q = v.has(K), Y = y ? y(Z) : !0, ee = b({
          prefixCls: c,
          expanded: q,
          expandable: Y,
          record: Z,
          onExpand: g
        });
        return S ? /* @__PURE__ */ reactExports.createElement("span", {
          onClick: function(J) {
            return J.stopPropagation();
          }
        }, ee) : ee;
      });
      return G.map(function(H, V) {
        var Z = H === EXPAND_COLUMN ? D : H;
        return V < C ? _objectSpread2$1(_objectSpread2$1({}, Z), {}, {
          fixed: Z.fixed || "left"
        }) : Z;
      });
    }
    return E.filter(function(H) {
      return H !== EXPAND_COLUMN;
    });
  }, [p, E, x, v, b, w, C]), O = reactExports.useMemo(function() {
    var G = R;
    return s && (G = s(G)), G.length || (G = [{
      render: function() {
        return null;
      }
    }]), G;
  }, [s, R, w]), L = reactExports.useMemo(function() {
    return w === "rtl" ? revertForRtl(flatColumns(O)) : flatColumns(O);
  }, [O, w, I]), B = reactExports.useMemo(function() {
    for (var G = -1, U = L.length - 1; U >= 0; U -= 1) {
      var k = L[U].fixed;
      if (k === "left" || k === !0) {
        G = U;
        break;
      }
    }
    if (G >= 0)
      for (var N = 0; N <= G; N += 1) {
        var P = L[N].fixed;
        if (P !== "left" && P !== !0)
          return !0;
      }
    var D = L.findIndex(function(Z) {
      var ne = Z.fixed;
      return ne === "right";
    });
    if (D >= 0)
      for (var H = D; H < L.length; H += 1) {
        var V = L[H].fixed;
        if (V !== "right")
          return !0;
      }
    return !1;
  }, [L]), F = useWidthColumns(L, I, _), M = _slicedToArray$e(F, 2), W = M[0], j = M[1];
  return [O, W, j, B];
}
function useExpand(a, s, c) {
  var u = getExpandableProps(a), d = u.expandIcon, p = u.expandedRowKeys, v = u.defaultExpandedRowKeys, A = u.defaultExpandAllRows, x = u.expandedRowRender, g = u.onExpand, b = u.onExpandedRowsChange, y = u.childrenColumnName, f = d || renderExpandIcon$1, m = y || "children", C = reactExports.useMemo(function() {
    return x ? "row" : a.expandable && a.internalHooks === INTERNAL_HOOKS && a.expandable.__PARENT_RENDER_ICON__ || s.some(function(E) {
      return E && _typeof$h(E) === "object" && E[m];
    }) ? "nest" : !1;
  }, [!!x, s]), w = reactExports.useState(function() {
    return v || (A ? findAllChildrenKeys(s, c, m) : []);
  }), S = _slicedToArray$e(w, 2), $ = S[0], T = S[1], I = reactExports.useMemo(function() {
    return new Set(p || $ || []);
  }, [p, $]), _ = reactExports.useCallback(function(E) {
    var R = c(E, s.indexOf(E)), O, L = I.has(R);
    L ? (I.delete(R), O = _toConsumableArray$e(I)) : O = [].concat(_toConsumableArray$e(I), [R]), T(O), g && g(!L, E), b && b(O);
  }, [c, I, s, g, b]);
  return [u, C, I, f, m, _];
}
function useFixedInfo(a, s, c) {
  var u = a.map(function(d, p) {
    return getCellFixedInfo(p, p, a, s, c);
  });
  return useMemo(function() {
    return u;
  }, [u], function(d, p) {
    return !isEqual(d, p);
  });
}
function useLayoutState(a) {
  var s = reactExports.useRef(a), c = reactExports.useState({}), u = _slicedToArray$e(c, 2), d = u[1], p = reactExports.useRef(null), v = reactExports.useRef([]);
  function A(x) {
    v.current.push(x);
    var g = Promise.resolve();
    p.current = g, g.then(function() {
      if (p.current === g) {
        var b = v.current, y = s.current;
        v.current = [], b.forEach(function(f) {
          s.current = f(s.current);
        }), p.current = null, y !== s.current && d({});
      }
    });
  }
  return reactExports.useEffect(function() {
    return function() {
      p.current = null;
    };
  }, []), [s.current, A];
}
function useTimeoutLock(a) {
  var s = reactExports.useRef(null), c = reactExports.useRef();
  function u() {
    window.clearTimeout(c.current);
  }
  function d(v) {
    s.current = v, u(), c.current = window.setTimeout(function() {
      s.current = null, c.current = void 0;
    }, 100);
  }
  function p() {
    return s.current;
  }
  return reactExports.useEffect(function() {
    return u;
  }, []), [d, p];
}
function useHover() {
  var a = reactExports.useState(-1), s = _slicedToArray$e(a, 2), c = s[0], u = s[1], d = reactExports.useState(-1), p = _slicedToArray$e(d, 2), v = p[0], A = p[1], x = reactExports.useCallback(function(g, b) {
    u(g), A(b);
  }, []);
  return [c, v, x];
}
var defaultContainer = canUseDom$1() ? window : null;
function useSticky(a, s) {
  var c = _typeof$h(a) === "object" ? a : {}, u = c.offsetHeader, d = u === void 0 ? 0 : u, p = c.offsetSummary, v = p === void 0 ? 0 : p, A = c.offsetScroll, x = A === void 0 ? 0 : A, g = c.getContainer, b = g === void 0 ? function() {
    return defaultContainer;
  } : g, y = b() || defaultContainer, f = !!a;
  return reactExports.useMemo(function() {
    return {
      isSticky: f,
      stickyClassName: f ? "".concat(s, "-sticky-holder") : "",
      offsetHeader: d,
      offsetSummary: v,
      offsetScroll: x,
      container: y
    };
  }, [f, x, d, v, s, y]);
}
function useStickyOffsets(a, s, c) {
  var u = reactExports.useMemo(function() {
    var d = s.length, p = function(g, b, y) {
      for (var f = [], m = 0, C = g; C !== b; C += y)
        f.push(m), s[C].fixed && (m += a[C] || 0);
      return f;
    }, v = p(0, d, 1), A = p(d - 1, -1, -1).reverse();
    return c === "rtl" ? {
      left: A,
      right: v
    } : {
      left: v,
      right: A
    };
  }, [a, s, c]);
  return u;
}
function Panel$2(a) {
  var s = a.className, c = a.children;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: s
  }, c);
}
function getOffset$1(a) {
  var s = getDOM(a), c = s.getBoundingClientRect(), u = document.documentElement;
  return {
    left: c.left + (window.pageXOffset || u.scrollLeft) - (u.clientLeft || document.body.clientLeft || 0),
    top: c.top + (window.pageYOffset || u.scrollTop) - (u.clientTop || document.body.clientTop || 0)
  };
}
var StickyScrollBar = function a(s, c) {
  var u, d, p = s.scrollBodyRef, v = s.onScroll, A = s.offsetScroll, x = s.container, g = s.direction, b = useContext(TableContext, "prefixCls"), y = ((u = p.current) === null || u === void 0 ? void 0 : u.scrollWidth) || 0, f = ((d = p.current) === null || d === void 0 ? void 0 : d.clientWidth) || 0, m = y && f * (f / y), C = reactExports.useRef(), w = useLayoutState({
    scrollLeft: 0,
    isHiddenScrollBar: !0
  }), S = _slicedToArray$e(w, 2), $ = S[0], T = S[1], I = reactExports.useRef({
    delta: 0,
    x: 0
  }), _ = reactExports.useState(!1), E = _slicedToArray$e(_, 2), R = E[0], O = E[1], L = reactExports.useRef(null);
  reactExports.useEffect(function() {
    return function() {
      wrapperRaf.cancel(L.current);
    };
  }, []);
  var B = function() {
    O(!1);
  }, F = function(U) {
    U.persist(), I.current.delta = U.pageX - $.scrollLeft, I.current.x = 0, O(!0), U.preventDefault();
  }, M = function(U) {
    var k, N = U || ((k = window) === null || k === void 0 ? void 0 : k.event), P = N.buttons;
    if (!R || P === 0) {
      R && O(!1);
      return;
    }
    var D = I.current.x + U.pageX - I.current.x - I.current.delta, H = g === "rtl";
    D = Math.max(H ? m - f : 0, Math.min(H ? 0 : f - m, D));
    var V = !H || Math.abs(D) + Math.abs(m) < f;
    V && (v({
      scrollLeft: D / f * (y + 2)
    }), I.current.x = U.pageX);
  }, W = function() {
    wrapperRaf.cancel(L.current), L.current = wrapperRaf(function() {
      if (p.current) {
        var U = getOffset$1(p.current).top, k = U + p.current.offsetHeight, N = x === window ? document.documentElement.scrollTop + window.innerHeight : getOffset$1(x).top + x.clientHeight;
        k - getScrollBarSize() <= N || U >= N - A ? T(function(P) {
          return _objectSpread2$1(_objectSpread2$1({}, P), {}, {
            isHiddenScrollBar: !0
          });
        }) : T(function(P) {
          return _objectSpread2$1(_objectSpread2$1({}, P), {}, {
            isHiddenScrollBar: !1
          });
        });
      }
    });
  }, j = function(U) {
    T(function(k) {
      return _objectSpread2$1(_objectSpread2$1({}, k), {}, {
        scrollLeft: U / y * f || 0
      });
    });
  };
  return reactExports.useImperativeHandle(c, function() {
    return {
      setScrollLeft: j,
      checkScrollBarVisible: W
    };
  }), reactExports.useEffect(function() {
    var G = addEventListenerWrap$1(document.body, "mouseup", B, !1), U = addEventListenerWrap$1(document.body, "mousemove", M, !1);
    return W(), function() {
      G.remove(), U.remove();
    };
  }, [m, R]), reactExports.useEffect(function() {
    if (p.current) {
      for (var G = [], U = getDOM(p.current); U; )
        G.push(U), U = U.parentElement;
      return G.forEach(function(k) {
        return k.addEventListener("scroll", W, !1);
      }), window.addEventListener("resize", W, !1), window.addEventListener("scroll", W, !1), x.addEventListener("scroll", W, !1), function() {
        G.forEach(function(k) {
          return k.removeEventListener("scroll", W);
        }), window.removeEventListener("resize", W), window.removeEventListener("scroll", W), x.removeEventListener("scroll", W);
      };
    }
  }, [x]), reactExports.useEffect(function() {
    $.isHiddenScrollBar || T(function(G) {
      var U = p.current;
      return U ? _objectSpread2$1(_objectSpread2$1({}, G), {}, {
        scrollLeft: U.scrollLeft / U.scrollWidth * U.clientWidth
      }) : G;
    });
  }, [$.isHiddenScrollBar]), y <= f || !m || $.isHiddenScrollBar ? null : /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      height: getScrollBarSize(),
      width: f,
      bottom: A
    },
    className: "".concat(b, "-sticky-scroll")
  }, /* @__PURE__ */ reactExports.createElement("div", {
    onMouseDown: F,
    ref: C,
    className: classnames("".concat(b, "-sticky-scroll-bar"), _defineProperty$a({}, "".concat(b, "-sticky-scroll-bar-active"), R)),
    style: {
      width: "".concat(m, "px"),
      transform: "translate3d(".concat($.scrollLeft, "px, 0, 0)")
    }
  }));
};
const StickyScrollBar$1 = /* @__PURE__ */ reactExports.forwardRef(StickyScrollBar);
var DEFAULT_PREFIX = "rc-table", EMPTY_DATA = [], EMPTY_SCROLL_TARGET = {};
function defaultEmpty() {
  return "No Data";
}
function Table$1(a, s) {
  var c = _objectSpread2$1({
    rowKey: "key",
    prefixCls: DEFAULT_PREFIX,
    emptyText: defaultEmpty
  }, a), u = c.prefixCls, d = c.className, p = c.rowClassName, v = c.style, A = c.data, x = c.rowKey, g = c.scroll, b = c.tableLayout, y = c.direction, f = c.title, m = c.footer, C = c.summary, w = c.caption, S = c.id, $ = c.showHeader, T = c.components, I = c.emptyText, _ = c.onRow, E = c.onHeaderRow, R = c.onScroll, O = c.internalHooks, L = c.transformColumns, B = c.internalRefs, F = c.tailor, M = c.getContainerWidth, W = c.sticky, j = c.rowHoverable, G = j === void 0 ? !0 : j, U = A || EMPTY_DATA, k = !!U.length, N = O === INTERNAL_HOOKS, P = reactExports.useCallback(function(zt, Dt) {
    return get$1(T, zt) || Dt;
  }, [T]), D = reactExports.useMemo(function() {
    return typeof x == "function" ? x : function(zt) {
      var Dt = zt && zt[x];
      return Dt;
    };
  }, [x]), H = P(["body"]), V = useHover(), Z = _slicedToArray$e(V, 3), ne = Z[0], K = Z[1], q = Z[2], Y = useExpand(c, U, D), ee = _slicedToArray$e(Y, 6), Q = ee[0], J = ee[1], te = ee[2], ae = ee[3], se = ee[4], ie = ee[5], fe = g?.x, ge = reactExports.useState(0), me = _slicedToArray$e(ge, 2), pe = me[0], be = me[1], le = useColumns(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, c), Q), {}, {
    expandable: !!Q.expandedRowRender,
    columnTitle: Q.columnTitle,
    expandedKeys: te,
    getRowKey: D,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: ie,
    expandIcon: ae,
    expandIconColumnIndex: Q.expandIconColumnIndex,
    direction: y,
    scrollWidth: N && F && typeof fe == "number" ? fe : null,
    clientWidth: pe
  }), N ? L : null), ve = _slicedToArray$e(le, 4), he = ve[0], ye = ve[1], Ce = ve[2], xe = ve[3], we = Ce ?? fe, $e = reactExports.useMemo(function() {
    return {
      columns: he,
      flattenColumns: ye
    };
  }, [he, ye]), Ae = reactExports.useRef(), ue = reactExports.useRef(), ce = reactExports.useRef(), Ee = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return {
      nativeElement: Ae.current,
      scrollTo: function(Dt) {
        var nr;
        if (ce.current instanceof HTMLElement) {
          var gr = Dt.index, lr = Dt.top, Nr = Dt.key;
          if (validNumberValue(lr)) {
            var Wr;
            (Wr = ce.current) === null || Wr === void 0 || Wr.scrollTo({
              top: lr
            });
          } else {
            var Fr, Qr = Nr ?? D(U[gr]);
            (Fr = ce.current.querySelector('[data-row-key="'.concat(Qr, '"]'))) === null || Fr === void 0 || Fr.scrollIntoView();
          }
        } else (nr = ce.current) !== null && nr !== void 0 && nr.scrollTo && ce.current.scrollTo(Dt);
      }
    };
  });
  var _e = reactExports.useRef(), Te = reactExports.useState(!1), ke = _slicedToArray$e(Te, 2), Re = ke[0], Be = ke[1], Oe = reactExports.useState(!1), Me = _slicedToArray$e(Oe, 2), Fe = Me[0], Ue = Me[1], je = reactExports.useState(/* @__PURE__ */ new Map()), Le = _slicedToArray$e(je, 2), De = Le[0], Ne = Le[1], Ge = getColumnsKey(ye), Xe = Ge.map(function(zt) {
    return De.get(zt);
  }), nt = reactExports.useMemo(function() {
    return Xe;
  }, [Xe.join("_")]), ct = useStickyOffsets(nt, ye, y), it = g && validateValue(g.y), We = g && validateValue(we) || !!Q.fixed, Ve = We && ye.some(function(zt) {
    var Dt = zt.fixed;
    return Dt;
  }), ut = reactExports.useRef(), at = useSticky(W, u), Qe = at.isSticky, st = at.offsetHeader, ft = at.offsetSummary, vt = at.offsetScroll, Pt = at.stickyClassName, dt = at.container, mt = reactExports.useMemo(function() {
    return C?.(U);
  }, [C, U]), pt = (it || Qe) && /* @__PURE__ */ reactExports.isValidElement(mt) && mt.type === Summary && mt.props.fixed, Et, Mt, Nt;
  it && (Mt = {
    overflowY: k ? "scroll" : "auto",
    maxHeight: g.y
  }), We && (Et = {
    overflowX: "auto"
  }, it || (Mt = {
    overflowY: "hidden"
  }), Nt = {
    width: we === !0 ? "auto" : we,
    minWidth: "100%"
  });
  var _t = reactExports.useCallback(function(zt, Dt) {
    Ne(function(nr) {
      if (nr.get(zt) !== Dt) {
        var gr = new Map(nr);
        return gr.set(zt, Dt), gr;
      }
      return nr;
    });
  }, []), Ot = useTimeoutLock(), rt = _slicedToArray$e(Ot, 2), et = rt[0], Ye = rt[1];
  function tt(zt, Dt) {
    Dt && (typeof Dt == "function" ? Dt(zt) : Dt.scrollLeft !== zt && (Dt.scrollLeft = zt, Dt.scrollLeft !== zt && setTimeout(function() {
      Dt.scrollLeft = zt;
    }, 0)));
  }
  var Ke = useEvent(function(zt) {
    var Dt = zt.currentTarget, nr = zt.scrollLeft, gr = y === "rtl", lr = typeof nr == "number" ? nr : Dt.scrollLeft, Nr = Dt || EMPTY_SCROLL_TARGET;
    if (!Ye() || Ye() === Nr) {
      var Wr;
      et(Nr), tt(lr, ue.current), tt(lr, ce.current), tt(lr, _e.current), tt(lr, (Wr = ut.current) === null || Wr === void 0 ? void 0 : Wr.setScrollLeft);
    }
    var Fr = Dt || ue.current;
    if (Fr) {
      var Qr = (
        // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
        N && F && typeof we == "number" ? we : Fr.scrollWidth
      ), an = Fr.clientWidth;
      if (Qr === an) {
        Be(!1), Ue(!1);
        return;
      }
      gr ? (Be(-lr < Qr - an), Ue(-lr > 0)) : (Be(lr > 0), Ue(lr < Qr - an));
    }
  }), qe = useEvent(function(zt) {
    Ke(zt), R?.(zt);
  }), ot = function() {
    if (We && ce.current) {
      var Dt;
      Ke({
        currentTarget: getDOM(ce.current),
        scrollLeft: (Dt = ce.current) === null || Dt === void 0 ? void 0 : Dt.scrollLeft
      });
    } else
      Be(!1), Ue(!1);
  }, Je = function(Dt) {
    var nr, gr = Dt.width;
    (nr = ut.current) === null || nr === void 0 || nr.checkScrollBarVisible();
    var lr = Ae.current ? Ae.current.offsetWidth : gr;
    N && M && Ae.current && (lr = M(Ae.current, lr) || lr), lr !== pe && (ot(), be(lr));
  }, Ct = reactExports.useRef(!1);
  reactExports.useEffect(function() {
    Ct.current && ot();
  }, [We, A, he.length]), reactExports.useEffect(function() {
    Ct.current = !0;
  }, []);
  var Tt = reactExports.useState(0), yt = _slicedToArray$e(Tt, 2), bt = yt[0], It = yt[1], kt = reactExports.useState(!0), $t = _slicedToArray$e(kt, 2), Lt = $t[0], Ft = $t[1];
  useLayoutEffect$1(function() {
    (!F || !N) && (ce.current instanceof Element ? It(getTargetScrollBarSize(ce.current).width) : It(getTargetScrollBarSize(Ee.current).width)), Ft(isStyleSupport("position", "sticky"));
  }, []), reactExports.useEffect(function() {
    N && B && (B.body.current = ce.current);
  });
  var Vt = reactExports.useCallback(function(zt) {
    return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(Header$1, zt), pt === "top" && /* @__PURE__ */ reactExports.createElement(Footer$1, zt, mt));
  }, [pt, mt]), rr = reactExports.useCallback(function(zt) {
    return /* @__PURE__ */ reactExports.createElement(Footer$1, zt, mt);
  }, [mt]), br = P(["table"], "table"), Gt = reactExports.useMemo(function() {
    return b || (Ve ? we === "max-content" ? "auto" : "fixed" : it || Qe || ye.some(function(zt) {
      var Dt = zt.ellipsis;
      return Dt;
    }) ? "fixed" : "auto");
  }, [it, Ve, ye, b, Qe]), qt, Jt = {
    colWidths: nt,
    columCount: ye.length,
    stickyOffsets: ct,
    onHeaderRow: E,
    fixHeader: it,
    scroll: g
  }, jt = reactExports.useMemo(function() {
    return k ? null : typeof I == "function" ? I() : I;
  }, [k, I]), Ht = /* @__PURE__ */ reactExports.createElement(Body$1, {
    data: U,
    measureColumnWidth: it || We || Qe
  }), ur = /* @__PURE__ */ reactExports.createElement(ColGroup, {
    colWidths: ye.map(function(zt) {
      var Dt = zt.width;
      return Dt;
    }),
    columns: ye
  }), Qt = w != null ? /* @__PURE__ */ reactExports.createElement("caption", {
    className: "".concat(u, "-caption")
  }, w) : void 0, Yt = pickAttrs(c, {
    data: !0
  }), dr = pickAttrs(c, {
    aria: !0
  });
  if (it || Qe) {
    var Ar;
    typeof H == "function" ? (Ar = H(U, {
      scrollbarSize: bt,
      ref: ce,
      onScroll: Ke
    }), Jt.colWidths = ye.map(function(zt, Dt) {
      var nr = zt.width, gr = Dt === ye.length - 1 ? nr - bt : nr;
      return typeof gr == "number" && !Number.isNaN(gr) ? gr : 0;
    })) : Ar = /* @__PURE__ */ reactExports.createElement("div", {
      style: _objectSpread2$1(_objectSpread2$1({}, Et), Mt),
      onScroll: qe,
      ref: ce,
      className: classnames("".concat(u, "-body"))
    }, /* @__PURE__ */ reactExports.createElement(br, _extends$3({
      style: _objectSpread2$1(_objectSpread2$1({}, Nt), {}, {
        tableLayout: Gt
      })
    }, dr), Qt, ur, Ht, !pt && mt && /* @__PURE__ */ reactExports.createElement(Footer$1, {
      stickyOffsets: ct,
      flattenColumns: ye
    }, mt)));
    var wr = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
      noData: !U.length,
      maxContentScroll: We && we === "max-content"
    }, Jt), $e), {}, {
      direction: y,
      stickyClassName: Pt,
      onScroll: Ke
    });
    qt = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, $ !== !1 && /* @__PURE__ */ reactExports.createElement(FixedHolder$1, _extends$3({}, wr, {
      stickyTopOffset: st,
      className: "".concat(u, "-header"),
      ref: ue
    }), Vt), Ar, pt && pt !== "top" && /* @__PURE__ */ reactExports.createElement(FixedHolder$1, _extends$3({}, wr, {
      stickyBottomOffset: ft,
      className: "".concat(u, "-summary"),
      ref: _e
    }), rr), Qe && ce.current && ce.current instanceof Element && /* @__PURE__ */ reactExports.createElement(StickyScrollBar$1, {
      ref: ut,
      offsetScroll: vt,
      scrollBodyRef: ce,
      onScroll: Ke,
      container: dt,
      direction: y
    }));
  } else
    qt = /* @__PURE__ */ reactExports.createElement("div", {
      style: _objectSpread2$1(_objectSpread2$1({}, Et), Mt),
      className: classnames("".concat(u, "-content")),
      onScroll: Ke,
      ref: ce
    }, /* @__PURE__ */ reactExports.createElement(br, _extends$3({
      style: _objectSpread2$1(_objectSpread2$1({}, Nt), {}, {
        tableLayout: Gt
      })
    }, dr), Qt, ur, $ !== !1 && /* @__PURE__ */ reactExports.createElement(Header$1, _extends$3({}, Jt, $e)), Ht, mt && /* @__PURE__ */ reactExports.createElement(Footer$1, {
      stickyOffsets: ct,
      flattenColumns: ye
    }, mt)));
  var Ir = /* @__PURE__ */ reactExports.createElement("div", _extends$3({
    className: classnames(u, d, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(u, "-rtl"), y === "rtl"), "".concat(u, "-ping-left"), Re), "".concat(u, "-ping-right"), Fe), "".concat(u, "-layout-fixed"), b === "fixed"), "".concat(u, "-fixed-header"), it), "".concat(u, "-fixed-column"), Ve), "".concat(u, "-fixed-column-gapped"), Ve && xe), "".concat(u, "-scroll-horizontal"), We), "".concat(u, "-has-fix-left"), ye[0] && ye[0].fixed), "".concat(u, "-has-fix-right"), ye[ye.length - 1] && ye[ye.length - 1].fixed === "right")),
    style: v,
    id: S,
    ref: Ae
  }, Yt), f && /* @__PURE__ */ reactExports.createElement(Panel$2, {
    className: "".concat(u, "-title")
  }, f(U)), /* @__PURE__ */ reactExports.createElement("div", {
    ref: Ee,
    className: "".concat(u, "-container")
  }, qt), m && /* @__PURE__ */ reactExports.createElement(Panel$2, {
    className: "".concat(u, "-footer")
  }, m(U)));
  We && (Ir = /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Je
  }, Ir));
  var _r = useFixedInfo(ye, ct, y), kr = reactExports.useMemo(function() {
    return {
      // Scroll
      scrollX: we,
      // Table
      prefixCls: u,
      getComponent: P,
      scrollbarSize: bt,
      direction: y,
      fixedInfoList: _r,
      isSticky: Qe,
      supportSticky: Lt,
      componentWidth: pe,
      fixHeader: it,
      fixColumn: Ve,
      horizonScroll: We,
      // Body
      tableLayout: Gt,
      rowClassName: p,
      expandedRowClassName: Q.expandedRowClassName,
      expandIcon: ae,
      expandableType: J,
      expandRowByClick: Q.expandRowByClick,
      expandedRowRender: Q.expandedRowRender,
      expandedRowOffset: Q.expandedRowOffset,
      onTriggerExpand: ie,
      expandIconColumnIndex: Q.expandIconColumnIndex,
      indentSize: Q.indentSize,
      allColumnsFixedLeft: ye.every(function(zt) {
        return zt.fixed === "left";
      }),
      emptyNode: jt,
      // Column
      columns: he,
      flattenColumns: ye,
      onColumnResize: _t,
      colWidths: nt,
      // Row
      hoverStartRow: ne,
      hoverEndRow: K,
      onHover: q,
      rowExpandable: Q.rowExpandable,
      onRow: _,
      getRowKey: D,
      expandedKeys: te,
      childrenColumnName: se,
      rowHoverable: G
    };
  }, [
    // Scroll
    we,
    // Table
    u,
    P,
    bt,
    y,
    _r,
    Qe,
    Lt,
    pe,
    it,
    Ve,
    We,
    // Body
    Gt,
    p,
    Q.expandedRowClassName,
    ae,
    J,
    Q.expandRowByClick,
    Q.expandedRowRender,
    Q.expandedRowOffset,
    ie,
    Q.expandIconColumnIndex,
    Q.indentSize,
    jt,
    // Column
    he,
    ye,
    _t,
    nt,
    // Row
    ne,
    K,
    q,
    Q.rowExpandable,
    _,
    D,
    te,
    se,
    G
  ]);
  return /* @__PURE__ */ reactExports.createElement(TableContext.Provider, {
    value: kr
  }, Ir);
}
var RefTable = /* @__PURE__ */ reactExports.forwardRef(Table$1);
function genTable(a) {
  return makeImmutable(RefTable, a);
}
var ImmutableTable = genTable();
ImmutableTable.EXPAND_COLUMN = EXPAND_COLUMN;
ImmutableTable.INTERNAL_HOOKS = INTERNAL_HOOKS;
ImmutableTable.Column = Column$1;
ImmutableTable.ColumnGroup = ColumnGroup$1;
ImmutableTable.Summary = FooterComponents;
var StaticContext = createContext(null), GridContext = createContext(null);
function getColumnWidth(a, s, c) {
  var u = s || 1;
  return c[a + u] - (c[a] || 0);
}
function VirtualCell$1(a) {
  var s = a.rowInfo, c = a.column, u = a.colIndex, d = a.indent, p = a.index, v = a.component, A = a.renderIndex, x = a.record, g = a.style, b = a.className, y = a.inverse, f = a.getHeight, m = c.render, C = c.dataIndex, w = c.className, S = c.width, $ = useContext(GridContext, ["columnsOffset"]), T = $.columnsOffset, I = getCellProps(s, c, u, d, p), _ = I.key, E = I.fixedInfo, R = I.appendCellNode, O = I.additionalCellProps, L = O.style, B = O.colSpan, F = B === void 0 ? 1 : B, M = O.rowSpan, W = M === void 0 ? 1 : M, j = u - 1, G = getColumnWidth(j, F, T), U = F > 1 ? S - G : 0, k = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, L), g), {}, {
    flex: "0 0 ".concat(G, "px"),
    width: "".concat(G, "px"),
    marginRight: U,
    pointerEvents: "auto"
  }), N = reactExports.useMemo(function() {
    return y ? W <= 1 : F === 0 || W === 0 || W > 1;
  }, [W, F, y]);
  N ? k.visibility = "hidden" : y && (k.height = f?.(W));
  var P = N ? function() {
    return null;
  } : m, D = {};
  return (W === 0 || F === 0) && (D.rowSpan = 1, D.colSpan = 1), /* @__PURE__ */ reactExports.createElement(Cell$1, _extends$3({
    className: classnames(w, b),
    ellipsis: c.ellipsis,
    align: c.align,
    scope: c.rowScope,
    component: v,
    prefixCls: s.prefixCls,
    key: _,
    record: x,
    index: p,
    renderIndex: A,
    dataIndex: C,
    render: P,
    shouldCellUpdate: c.shouldCellUpdate
  }, E, {
    appendNode: R,
    additionalProps: _objectSpread2$1(_objectSpread2$1({}, O), {}, {
      style: k
    }, D)
  }));
}
var _excluded$7 = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"], BodyLine = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.data, u = a.index, d = a.className, p = a.rowKey, v = a.style, A = a.extra, x = a.getHeight, g = _objectWithoutProperties$2(a, _excluded$7), b = c.record, y = c.indent, f = c.index, m = useContext(TableContext, ["prefixCls", "flattenColumns", "fixColumn", "componentWidth", "scrollX"]), C = m.scrollX, w = m.flattenColumns, S = m.prefixCls, $ = m.fixColumn, T = m.componentWidth, I = useContext(StaticContext, ["getComponent"]), _ = I.getComponent, E = useRowInfo(b, p, u, y), R = _(["body", "row"], "div"), O = _(["body", "cell"], "div"), L = E.rowSupportExpand, B = E.expanded, F = E.rowProps, M = E.expandedRowRender, W = E.expandedRowClassName, j;
  if (L && B) {
    var G = M(b, u, y + 1, B), U = computedExpandedClassName(W, b, u, y), k = {};
    $ && (k = {
      style: _defineProperty$a({}, "--virtual-width", "".concat(T, "px"))
    });
    var N = "".concat(S, "-expanded-row-cell");
    j = /* @__PURE__ */ reactExports.createElement(R, {
      className: classnames("".concat(S, "-expanded-row"), "".concat(S, "-expanded-row-level-").concat(y + 1), U)
    }, /* @__PURE__ */ reactExports.createElement(Cell$1, {
      component: O,
      prefixCls: S,
      className: classnames(N, _defineProperty$a({}, "".concat(N, "-fixed"), $)),
      additionalProps: k
    }, G));
  }
  var P = _objectSpread2$1(_objectSpread2$1({}, v), {}, {
    width: C
  });
  A && (P.position = "absolute", P.pointerEvents = "none");
  var D = /* @__PURE__ */ reactExports.createElement(R, _extends$3({}, F, g, {
    "data-row-key": p,
    ref: L ? null : s,
    className: classnames(d, "".concat(S, "-row"), F?.className, _defineProperty$a({}, "".concat(S, "-row-extra"), A)),
    style: _objectSpread2$1(_objectSpread2$1({}, P), F?.style)
  }), w.map(function(H, V) {
    return /* @__PURE__ */ reactExports.createElement(VirtualCell$1, {
      key: V,
      component: O,
      rowInfo: E,
      column: H,
      colIndex: V,
      indent: y,
      index: u,
      renderIndex: f,
      record: b,
      inverse: A,
      getHeight: x
    });
  }));
  return L ? /* @__PURE__ */ reactExports.createElement("div", {
    ref: s
  }, D, j) : D;
}), ResponseBodyLine = responseImmutable(BodyLine), Grid = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.data, u = a.onScroll, d = useContext(TableContext, ["flattenColumns", "onColumnResize", "getRowKey", "prefixCls", "expandedKeys", "childrenColumnName", "scrollX", "direction"]), p = d.flattenColumns, v = d.onColumnResize, A = d.getRowKey, x = d.expandedKeys, g = d.prefixCls, b = d.childrenColumnName, y = d.scrollX, f = d.direction, m = useContext(StaticContext), C = m.sticky, w = m.scrollY, S = m.listItemHeight, $ = m.getComponent, T = m.onScroll, I = reactExports.useRef(), _ = useFlattenRecords(c, b, x, A), E = reactExports.useMemo(function() {
    var j = 0;
    return p.map(function(G) {
      var U = G.width, k = G.key;
      return j += U, [k, U, j];
    });
  }, [p]), R = reactExports.useMemo(function() {
    return E.map(function(j) {
      return j[2];
    });
  }, [E]);
  reactExports.useEffect(function() {
    E.forEach(function(j) {
      var G = _slicedToArray$e(j, 2), U = G[0], k = G[1];
      v(U, k);
    });
  }, [E]), reactExports.useImperativeHandle(s, function() {
    var j, G = {
      scrollTo: function(k) {
        var N;
        (N = I.current) === null || N === void 0 || N.scrollTo(k);
      },
      nativeElement: (j = I.current) === null || j === void 0 ? void 0 : j.nativeElement
    };
    return Object.defineProperty(G, "scrollLeft", {
      get: function() {
        var k;
        return ((k = I.current) === null || k === void 0 ? void 0 : k.getScrollInfo().x) || 0;
      },
      set: function(k) {
        var N;
        (N = I.current) === null || N === void 0 || N.scrollTo({
          left: k
        });
      }
    }), G;
  });
  var O = function(G, U) {
    var k, N = (k = _[U]) === null || k === void 0 ? void 0 : k.record, P = G.onCell;
    if (P) {
      var D, H = P(N, U);
      return (D = H?.rowSpan) !== null && D !== void 0 ? D : 1;
    }
    return 1;
  }, L = function(G) {
    var U = G.start, k = G.end, N = G.getSize, P = G.offsetY;
    if (k < 0)
      return null;
    for (var D = p.filter(
      // rowSpan is 0
      function(ae) {
        return O(ae, U) === 0;
      }
    ), H = U, V = function(se) {
      if (D = D.filter(function(ie) {
        return O(ie, se) === 0;
      }), !D.length)
        return H = se, 1;
    }, Z = U; Z >= 0 && !V(Z); Z -= 1)
      ;
    for (var ne = p.filter(
      // rowSpan is not 1
      function(ae) {
        return O(ae, k) !== 1;
      }
    ), K = k, q = function(se) {
      if (ne = ne.filter(function(ie) {
        return O(ie, se) !== 1;
      }), !ne.length)
        return K = Math.max(se - 1, k), 1;
    }, Y = k; Y < _.length && !q(Y); Y += 1)
      ;
    for (var ee = [], Q = function(se) {
      var ie = _[se];
      if (!ie)
        return 1;
      p.some(function(fe) {
        return O(fe, se) > 1;
      }) && ee.push(se);
    }, J = H; J <= K; J += 1)
      Q(J);
    var te = ee.map(function(ae) {
      var se = _[ae], ie = A(se.record, ae), fe = function(pe) {
        var be = ae + pe - 1, le = A(_[be].record, be), ve = N(ie, le);
        return ve.bottom - ve.top;
      }, ge = N(ie);
      return /* @__PURE__ */ reactExports.createElement(ResponseBodyLine, {
        key: ae,
        data: se,
        rowKey: ie,
        index: ae,
        style: {
          top: -P + ge.top
        },
        extra: !0,
        getHeight: fe
      });
    });
    return te;
  }, B = reactExports.useMemo(function() {
    return {
      columnsOffset: R
    };
  }, [R]), F = "".concat(g, "-tbody"), M = $(["body", "wrapper"]), W = {};
  return C && (W.position = "sticky", W.bottom = 0, _typeof$h(C) === "object" && C.offsetScroll && (W.bottom = C.offsetScroll)), /* @__PURE__ */ reactExports.createElement(GridContext.Provider, {
    value: B
  }, /* @__PURE__ */ reactExports.createElement(List, {
    fullHeight: !1,
    ref: I,
    prefixCls: "".concat(F, "-virtual"),
    styles: {
      horizontalScrollBar: W
    },
    className: F,
    height: w,
    itemHeight: S || 24,
    data: _,
    itemKey: function(G) {
      return A(G.record);
    },
    component: M,
    scrollWidth: y,
    direction: f,
    onVirtualScroll: function(G) {
      var U, k = G.x;
      u({
        currentTarget: (U = I.current) === null || U === void 0 ? void 0 : U.nativeElement,
        scrollLeft: k
      });
    },
    onScroll: T,
    extraRender: L
  }, function(j, G, U) {
    var k = A(j.record, G);
    return /* @__PURE__ */ reactExports.createElement(ResponseBodyLine, {
      data: j,
      rowKey: k,
      index: G,
      style: U.style
    });
  }));
}), ResponseGrid = responseImmutable(Grid), renderBody = function a(s, c) {
  var u = c.ref, d = c.onScroll;
  return /* @__PURE__ */ reactExports.createElement(ResponseGrid, {
    ref: u,
    data: s,
    onScroll: d
  });
};
function VirtualTable(a, s) {
  var c = a.data, u = a.columns, d = a.scroll, p = a.sticky, v = a.prefixCls, A = v === void 0 ? DEFAULT_PREFIX : v, x = a.className, g = a.listItemHeight, b = a.components, y = a.onScroll, f = d || {}, m = f.x, C = f.y;
  typeof m != "number" && (m = 1), typeof C != "number" && (C = 500);
  var w = useEvent(function(T, I) {
    return get$1(b, T) || I;
  }), S = useEvent(y), $ = reactExports.useMemo(function() {
    return {
      sticky: p,
      scrollY: C,
      listItemHeight: g,
      getComponent: w,
      onScroll: S
    };
  }, [p, C, g, w, S]);
  return /* @__PURE__ */ reactExports.createElement(StaticContext.Provider, {
    value: $
  }, /* @__PURE__ */ reactExports.createElement(ImmutableTable, _extends$3({}, a, {
    className: classnames(x, "".concat(A, "-virtual")),
    scroll: _objectSpread2$1(_objectSpread2$1({}, d), {}, {
      x: m
    }),
    components: _objectSpread2$1(_objectSpread2$1({}, b), {}, {
      // fix https://github.com/ant-design/ant-design/issues/48991
      body: c != null && c.length ? renderBody : void 0
    }),
    columns: u,
    internalHooks: INTERNAL_HOOKS,
    tailor: !0,
    ref: s
  })));
}
var RefVirtualTable = /* @__PURE__ */ reactExports.forwardRef(VirtualTable);
function genVirtualTable(a) {
  return makeImmutable(RefVirtualTable, a);
}
genVirtualTable();
const Column = (a) => null, ColumnGroup = (a) => null;
var TreeContext = /* @__PURE__ */ reactExports.createContext(null), UnstableContext = /* @__PURE__ */ reactExports.createContext({}), Indent = function a(s) {
  for (var c = s.prefixCls, u = s.level, d = s.isStart, p = s.isEnd, v = "".concat(c, "-indent-unit"), A = [], x = 0; x < u; x += 1)
    A.push(/* @__PURE__ */ reactExports.createElement("span", {
      key: x,
      className: classnames(v, _defineProperty$a(_defineProperty$a({}, "".concat(v, "-start"), d[x]), "".concat(v, "-end"), p[x]))
    }));
  return /* @__PURE__ */ reactExports.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(c, "-indent")
  }, A);
};
const Indent$1 = /* @__PURE__ */ reactExports.memo(Indent);
var _excluded$6 = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"], ICON_OPEN = "open", ICON_CLOSE = "close", defaultTitle = "---", TreeNode$1 = function a(s) {
  var c, u, d, p = s.eventKey, v = s.className, A = s.style, x = s.dragOver, g = s.dragOverGapTop, b = s.dragOverGapBottom, y = s.isLeaf, f = s.isStart, m = s.isEnd, C = s.expanded, w = s.selected, S = s.checked, $ = s.halfChecked, T = s.loading, I = s.domRef, _ = s.active, E = s.data, R = s.onMouseMove, O = s.selectable, L = _objectWithoutProperties$2(s, _excluded$6), B = React.useContext(TreeContext), F = React.useContext(UnstableContext), M = React.useRef(null), W = React.useState(!1), j = _slicedToArray$e(W, 2), G = j[0], U = j[1], k = !!(B.disabled || s.disabled || (c = F.nodeDisabled) !== null && c !== void 0 && c.call(F, E)), N = React.useMemo(function() {
    return !B.checkable || s.checkable === !1 ? !1 : B.checkable;
  }, [B.checkable, s.checkable]), P = function(Te) {
    k || B.onNodeSelect(Te, convertNodePropsToEventData(s));
  }, D = function(Te) {
    k || !N || s.disableCheckbox || B.onNodeCheck(Te, convertNodePropsToEventData(s), !S);
  }, H = React.useMemo(function() {
    return typeof O == "boolean" ? O : B.selectable;
  }, [O, B.selectable]), V = function(Te) {
    B.onNodeClick(Te, convertNodePropsToEventData(s)), H ? P(Te) : D(Te);
  }, Z = function(Te) {
    B.onNodeDoubleClick(Te, convertNodePropsToEventData(s));
  }, ne = function(Te) {
    B.onNodeMouseEnter(Te, convertNodePropsToEventData(s));
  }, K = function(Te) {
    B.onNodeMouseLeave(Te, convertNodePropsToEventData(s));
  }, q = function(Te) {
    B.onNodeContextMenu(Te, convertNodePropsToEventData(s));
  }, Y = React.useMemo(function() {
    return !!(B.draggable && (!B.draggable.nodeDraggable || B.draggable.nodeDraggable(E)));
  }, [B.draggable, E]), ee = function(Te) {
    Te.stopPropagation(), U(!0), B.onNodeDragStart(Te, s);
    try {
      Te.dataTransfer.setData("text/plain", "");
    } catch {
    }
  }, Q = function(Te) {
    Te.preventDefault(), Te.stopPropagation(), B.onNodeDragEnter(Te, s);
  }, J = function(Te) {
    Te.preventDefault(), Te.stopPropagation(), B.onNodeDragOver(Te, s);
  }, te = function(Te) {
    Te.stopPropagation(), B.onNodeDragLeave(Te, s);
  }, ae = function(Te) {
    Te.stopPropagation(), U(!1), B.onNodeDragEnd(Te, s);
  }, se = function(Te) {
    Te.preventDefault(), Te.stopPropagation(), U(!1), B.onNodeDrop(Te, s);
  }, ie = function(Te) {
    T || B.onNodeExpand(Te, convertNodePropsToEventData(s));
  }, fe = React.useMemo(function() {
    var _e = getEntity(B.keyEntities, p) || {}, Te = _e.children;
    return !!(Te || []).length;
  }, [B.keyEntities, p]), ge = React.useMemo(function() {
    return y === !1 ? !1 : y || !B.loadData && !fe || B.loadData && s.loaded && !fe;
  }, [y, B.loadData, fe, s.loaded]);
  React.useEffect(function() {
    T || typeof B.loadData == "function" && C && !ge && !s.loaded && B.onNodeLoad(convertNodePropsToEventData(s));
  }, [T, B.loadData, B.onNodeLoad, C, ge, s]);
  var me = React.useMemo(function() {
    var _e;
    return (_e = B.draggable) !== null && _e !== void 0 && _e.icon ? /* @__PURE__ */ React.createElement("span", {
      className: "".concat(B.prefixCls, "-draggable-icon")
    }, B.draggable.icon) : null;
  }, [B.draggable]), pe = function(Te) {
    var ke = s.switcherIcon || B.switcherIcon;
    return typeof ke == "function" ? ke(_objectSpread2$1(_objectSpread2$1({}, s), {}, {
      isLeaf: Te
    })) : ke;
  }, be = function() {
    if (ge) {
      var Te = pe(!0);
      return Te !== !1 ? /* @__PURE__ */ React.createElement("span", {
        className: classnames("".concat(B.prefixCls, "-switcher"), "".concat(B.prefixCls, "-switcher-noop"))
      }, Te) : null;
    }
    var ke = pe(!1);
    return ke !== !1 ? /* @__PURE__ */ React.createElement("span", {
      onClick: ie,
      className: classnames("".concat(B.prefixCls, "-switcher"), "".concat(B.prefixCls, "-switcher_").concat(C ? ICON_OPEN : ICON_CLOSE))
    }, ke) : null;
  }, le = React.useMemo(function() {
    if (!N)
      return null;
    var _e = typeof N != "boolean" ? N : null;
    return /* @__PURE__ */ React.createElement("span", {
      className: classnames("".concat(B.prefixCls, "-checkbox"), _defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat(B.prefixCls, "-checkbox-checked"), S), "".concat(B.prefixCls, "-checkbox-indeterminate"), !S && $), "".concat(B.prefixCls, "-checkbox-disabled"), k || s.disableCheckbox)),
      onClick: D,
      role: "checkbox",
      "aria-checked": $ ? "mixed" : S,
      "aria-disabled": k || s.disableCheckbox,
      "aria-label": "Select ".concat(typeof s.title == "string" ? s.title : "tree node")
    }, _e);
  }, [N, S, $, k, s.disableCheckbox, s.title]), ve = React.useMemo(function() {
    return ge ? null : C ? ICON_OPEN : ICON_CLOSE;
  }, [ge, C]), he = React.useMemo(function() {
    return /* @__PURE__ */ React.createElement("span", {
      className: classnames("".concat(B.prefixCls, "-iconEle"), "".concat(B.prefixCls, "-icon__").concat(ve || "docu"), _defineProperty$a({}, "".concat(B.prefixCls, "-icon_loading"), T))
    });
  }, [B.prefixCls, ve, T]), ye = React.useMemo(function() {
    var _e = !!B.draggable, Te = !s.disabled && _e && B.dragOverNodeKey === p;
    return Te ? B.dropIndicatorRender({
      dropPosition: B.dropPosition,
      dropLevelOffset: B.dropLevelOffset,
      indent: B.indent,
      prefixCls: B.prefixCls,
      direction: B.direction
    }) : null;
  }, [B.dropPosition, B.dropLevelOffset, B.indent, B.prefixCls, B.direction, B.draggable, B.dragOverNodeKey, B.dropIndicatorRender]), Ce = React.useMemo(function() {
    var _e = s.title, Te = _e === void 0 ? defaultTitle : _e, ke = "".concat(B.prefixCls, "-node-content-wrapper"), Re;
    if (B.showIcon) {
      var Be = s.icon || B.icon;
      Re = Be ? /* @__PURE__ */ React.createElement("span", {
        className: classnames("".concat(B.prefixCls, "-iconEle"), "".concat(B.prefixCls, "-icon__customize"))
      }, typeof Be == "function" ? Be(s) : Be) : he;
    } else B.loadData && T && (Re = he);
    var Oe;
    return typeof Te == "function" ? Oe = Te(E) : B.titleRender ? Oe = B.titleRender(E) : Oe = Te, /* @__PURE__ */ React.createElement("span", {
      ref: M,
      title: typeof Te == "string" ? Te : "",
      className: classnames(ke, "".concat(ke, "-").concat(ve || "normal"), _defineProperty$a({}, "".concat(B.prefixCls, "-node-selected"), !k && (w || G))),
      onMouseEnter: ne,
      onMouseLeave: K,
      onContextMenu: q,
      onClick: V,
      onDoubleClick: Z
    }, Re, /* @__PURE__ */ React.createElement("span", {
      className: "".concat(B.prefixCls, "-title")
    }, Oe), ye);
  }, [B.prefixCls, B.showIcon, s, B.icon, he, B.titleRender, E, ve, ne, K, q, V, Z]), xe = pickAttrs(L, {
    aria: !0,
    data: !0
  }), we = getEntity(B.keyEntities, p) || {}, $e = we.level, Ae = m[m.length - 1], ue = !k && Y, ce = B.draggingNodeKey === p, Ee = O !== void 0 ? {
    "aria-selected": !!O
  } : void 0;
  return /* @__PURE__ */ React.createElement("div", _extends$3({
    ref: I,
    role: "treeitem",
    "aria-expanded": y ? void 0 : C,
    className: classnames(v, "".concat(B.prefixCls, "-treenode"), (d = {}, _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(d, "".concat(B.prefixCls, "-treenode-disabled"), k), "".concat(B.prefixCls, "-treenode-switcher-").concat(C ? "open" : "close"), !y), "".concat(B.prefixCls, "-treenode-checkbox-checked"), S), "".concat(B.prefixCls, "-treenode-checkbox-indeterminate"), $), "".concat(B.prefixCls, "-treenode-selected"), w), "".concat(B.prefixCls, "-treenode-loading"), T), "".concat(B.prefixCls, "-treenode-active"), _), "".concat(B.prefixCls, "-treenode-leaf-last"), Ae), "".concat(B.prefixCls, "-treenode-draggable"), Y), "dragging", ce), _defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(_defineProperty$a(d, "drop-target", B.dropTargetKey === p), "drop-container", B.dropContainerKey === p), "drag-over", !k && x), "drag-over-gap-top", !k && g), "drag-over-gap-bottom", !k && b), "filter-node", (u = B.filterTreeNode) === null || u === void 0 ? void 0 : u.call(B, convertNodePropsToEventData(s))), "".concat(B.prefixCls, "-treenode-leaf"), ge))),
    style: A,
    draggable: ue,
    onDragStart: ue ? ee : void 0,
    onDragEnter: Y ? Q : void 0,
    onDragOver: Y ? J : void 0,
    onDragLeave: Y ? te : void 0,
    onDrop: Y ? se : void 0,
    onDragEnd: Y ? ae : void 0,
    onMouseMove: R
  }, Ee, xe), /* @__PURE__ */ React.createElement(Indent$1, {
    prefixCls: B.prefixCls,
    level: $e,
    isStart: f,
    isEnd: m
  }), me, be(), le, Ce);
};
TreeNode$1.isTreeNode = 1;
function arrDel(a, s) {
  if (!a) return [];
  var c = a.slice(), u = c.indexOf(s);
  return u >= 0 && c.splice(u, 1), c;
}
function arrAdd(a, s) {
  var c = (a || []).slice();
  return c.indexOf(s) === -1 && c.push(s), c;
}
function posToArr(a) {
  return a.split("-");
}
function getDragChildrenKeys(a, s) {
  var c = [], u = getEntity(s, a);
  function d() {
    var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    p.forEach(function(v) {
      var A = v.key, x = v.children;
      c.push(A), d(x);
    });
  }
  return d(u.children), c;
}
function isLastChild(a) {
  if (a.parent) {
    var s = posToArr(a.pos);
    return Number(s[s.length - 1]) === a.parent.children.length - 1;
  }
  return !1;
}
function isFirstChild(a) {
  var s = posToArr(a.pos);
  return Number(s[s.length - 1]) === 0;
}
function calcDropPosition(a, s, c, u, d, p, v, A, x, g) {
  var b, y = a.clientX, f = a.clientY, m = a.target.getBoundingClientRect(), C = m.top, w = m.height, S = (g === "rtl" ? -1 : 1) * ((d?.x || 0) - y), $ = (S - 12) / u, T = x.filter(function(k) {
    var N;
    return (N = A[k]) === null || N === void 0 || (N = N.children) === null || N === void 0 ? void 0 : N.length;
  }), I = getEntity(A, c.eventKey);
  if (f < C + w / 2) {
    var _ = v.findIndex(function(k) {
      return k.key === I.key;
    }), E = _ <= 0 ? 0 : _ - 1, R = v[E].key;
    I = getEntity(A, R);
  }
  var O = I.key, L = I, B = I.key, F = 0, M = 0;
  if (!T.includes(O))
    for (var W = 0; W < $ && isLastChild(I); W += 1)
      I = I.parent, M += 1;
  var j = s.data, G = I.node, U = !0;
  return isFirstChild(I) && I.level === 0 && f < C + w / 2 && p({
    dragNode: j,
    dropNode: G,
    dropPosition: -1
  }) && I.key === c.eventKey ? F = -1 : (L.children || []).length && T.includes(B) ? p({
    dragNode: j,
    dropNode: G,
    dropPosition: 0
  }) ? F = 0 : U = !1 : M === 0 ? $ > -1.5 ? p({
    dragNode: j,
    dropNode: G,
    dropPosition: 1
  }) ? F = 1 : U = !1 : p({
    dragNode: j,
    dropNode: G,
    dropPosition: 0
  }) ? F = 0 : p({
    dragNode: j,
    dropNode: G,
    dropPosition: 1
  }) ? F = 1 : U = !1 : p({
    dragNode: j,
    dropNode: G,
    dropPosition: 1
  }) ? F = 1 : U = !1, {
    dropPosition: F,
    dropLevelOffset: M,
    dropTargetKey: I.key,
    dropTargetPos: I.pos,
    dragOverNodeKey: B,
    dropContainerKey: F === 0 ? null : ((b = I.parent) === null || b === void 0 ? void 0 : b.key) || null,
    dropAllowed: U
  };
}
function calcSelectedKeys(a, s) {
  if (a) {
    var c = s.multiple;
    return c ? a.slice() : a.length ? [a[0]] : a;
  }
}
function parseCheckedKeys(a) {
  if (!a)
    return null;
  var s;
  if (Array.isArray(a))
    s = {
      checkedKeys: a,
      halfCheckedKeys: void 0
    };
  else if (_typeof$h(a) === "object")
    s = {
      checkedKeys: a.checked || void 0,
      halfCheckedKeys: a.halfChecked || void 0
    };
  else
    return warningOnce(!1, "`checkedKeys` is not an array or an object"), null;
  return s;
}
function conductExpandParent(a, s) {
  var c = /* @__PURE__ */ new Set();
  function u(d) {
    if (!c.has(d)) {
      var p = getEntity(s, d);
      if (p) {
        c.add(d);
        var v = p.parent, A = p.node;
        A.disabled || v && u(v.key);
      }
    }
  }
  return (a || []).forEach(function(d) {
    u(d);
  }), _toConsumableArray$e(c);
}
function useMultipleSelect(a) {
  const [s, c] = reactExports.useState(null);
  return [reactExports.useCallback((p, v, A) => {
    const x = s ?? p, g = Math.min(x || 0, p), b = Math.max(x || 0, p), y = v.slice(g, b + 1).map((C) => a(C)), f = y.some((C) => !A.has(C)), m = [];
    return y.forEach((C) => {
      f ? (A.has(C) || m.push(C), A.add(C)) : (A.delete(C), m.push(C));
    }), c(f ? b : null), m;
  }, [s]), (p) => {
    c(p);
  }];
}
const SELECTION_COLUMN = {}, SELECTION_ALL = "SELECT_ALL", SELECTION_INVERT = "SELECT_INVERT", SELECTION_NONE = "SELECT_NONE", EMPTY_LIST$1 = [], flattenData = (a, s) => {
  let c = [];
  return (s || []).forEach((u) => {
    c.push(u), u && typeof u == "object" && a in u && (c = [].concat(_toConsumableArray$e(c), _toConsumableArray$e(flattenData(a, u[a]))));
  }), c;
}, useSelection = (a, s) => {
  const {
    preserveSelectedRowKeys: c,
    selectedRowKeys: u,
    defaultSelectedRowKeys: d,
    getCheckboxProps: p,
    onChange: v,
    onSelect: A,
    onSelectAll: x,
    onSelectInvert: g,
    onSelectNone: b,
    onSelectMultiple: y,
    columnWidth: f,
    type: m,
    selections: C,
    fixed: w,
    renderCell: S,
    hideSelectAll: $,
    checkStrictly: T = !0
  } = s || {}, {
    prefixCls: I,
    data: _,
    pageData: E,
    getRecordByKey: R,
    getRowKey: O,
    expandType: L,
    childrenColumnName: B,
    locale: F,
    getPopupContainer: M
  } = a, W = devUseWarning(), [j, G] = useMultipleSelect((ae) => ae), [U, k] = useMergedState(u || d || EMPTY_LIST$1, {
    value: u
  }), N = reactExports.useRef(/* @__PURE__ */ new Map()), P = reactExports.useCallback((ae) => {
    if (c) {
      const se = /* @__PURE__ */ new Map();
      ae.forEach((ie) => {
        let fe = R(ie);
        !fe && N.current.has(ie) && (fe = N.current.get(ie)), se.set(ie, fe);
      }), N.current = se;
    }
  }, [R, c]);
  reactExports.useEffect(() => {
    P(U);
  }, [U]);
  const D = reactExports.useMemo(() => flattenData(B, E), [B, E]), {
    keyEntities: H
  } = reactExports.useMemo(() => {
    if (T)
      return {
        keyEntities: null
      };
    let ae = _;
    if (c) {
      const se = new Set(D.map((fe, ge) => O(fe, ge))), ie = Array.from(N.current).reduce((fe, [ge, me]) => se.has(ge) ? fe : fe.concat(me), []);
      ae = [].concat(_toConsumableArray$e(ae), _toConsumableArray$e(ie));
    }
    return convertDataToEntities(ae, {
      externalGetKey: O,
      childrenPropName: B
    });
  }, [_, O, T, B, c, D]), V = reactExports.useMemo(() => {
    const ae = /* @__PURE__ */ new Map();
    return D.forEach((se, ie) => {
      const fe = O(se, ie), ge = (p ? p(se) : null) || {};
      ae.set(fe, ge);
    }), ae;
  }, [D, O, p]), Z = reactExports.useCallback((ae) => {
    const se = O(ae);
    let ie;
    return V.has(se) ? ie = V.get(O(ae)) : ie = p ? p(ae) : void 0, !!ie?.disabled;
  }, [V, O]), [ne, K] = reactExports.useMemo(() => {
    if (T)
      return [U || [], []];
    const {
      checkedKeys: ae,
      halfCheckedKeys: se
    } = conductCheck(U, !0, H, Z);
    return [ae || [], se];
  }, [U, T, H, Z]), q = reactExports.useMemo(() => {
    const ae = m === "radio" ? ne.slice(0, 1) : ne;
    return new Set(ae);
  }, [ne, m]), Y = reactExports.useMemo(() => m === "radio" ? /* @__PURE__ */ new Set() : new Set(K), [K, m]);
  reactExports.useEffect(() => {
    s || k(EMPTY_LIST$1);
  }, [!!s]);
  const ee = reactExports.useCallback((ae, se) => {
    let ie, fe;
    P(ae), c ? (ie = ae, fe = ae.map((ge) => N.current.get(ge))) : (ie = [], fe = [], ae.forEach((ge) => {
      const me = R(ge);
      me !== void 0 && (ie.push(ge), fe.push(me));
    })), k(ie), v?.(ie, fe, {
      type: se
    });
  }, [k, R, v, c]), Q = reactExports.useCallback((ae, se, ie, fe) => {
    if (A) {
      const ge = ie.map((me) => R(me));
      A(R(ae), se, ge, fe);
    }
    ee(ie, "single");
  }, [A, R, ee]), J = reactExports.useMemo(() => !C || $ ? null : (C === !0 ? [SELECTION_ALL, SELECTION_INVERT, SELECTION_NONE] : C).map((se) => se === SELECTION_ALL ? {
    key: "all",
    text: F.selectionAll,
    onSelect() {
      ee(_.map((ie, fe) => O(ie, fe)).filter((ie) => {
        const fe = V.get(ie);
        return !fe?.disabled || q.has(ie);
      }), "all");
    }
  } : se === SELECTION_INVERT ? {
    key: "invert",
    text: F.selectInvert,
    onSelect() {
      const ie = new Set(q);
      E.forEach((ge, me) => {
        const pe = O(ge, me), be = V.get(pe);
        be?.disabled || (ie.has(pe) ? ie.delete(pe) : ie.add(pe));
      });
      const fe = Array.from(ie);
      g && (W.deprecated(!1, "onSelectInvert", "onChange"), g(fe)), ee(fe, "invert");
    }
  } : se === SELECTION_NONE ? {
    key: "none",
    text: F.selectNone,
    onSelect() {
      b?.(), ee(Array.from(q).filter((ie) => {
        const fe = V.get(ie);
        return fe?.disabled;
      }), "none");
    }
  } : se).map((se) => Object.assign(Object.assign({}, se), {
    onSelect: (...ie) => {
      var fe, ge;
      (ge = se.onSelect) === null || ge === void 0 || (fe = ge).call.apply(fe, [se].concat(ie)), G(null);
    }
  })), [C, q, E, O, g, ee]);
  return [reactExports.useCallback((ae) => {
    var se;
    if (!s)
      return ae.filter((Ee) => Ee !== SELECTION_COLUMN);
    let ie = _toConsumableArray$e(ae);
    const fe = new Set(q), ge = D.map(O).filter((Ee) => !V.get(Ee).disabled), me = ge.every((Ee) => fe.has(Ee)), pe = ge.some((Ee) => fe.has(Ee)), be = () => {
      const Ee = [];
      me ? ge.forEach((Te) => {
        fe.delete(Te), Ee.push(Te);
      }) : ge.forEach((Te) => {
        fe.has(Te) || (fe.add(Te), Ee.push(Te));
      });
      const _e = Array.from(fe);
      x?.(!me, _e.map((Te) => R(Te)), Ee.map((Te) => R(Te))), ee(_e, "all"), G(null);
    };
    let le, ve;
    if (m !== "radio") {
      let Ee;
      if (J) {
        const Be = {
          getPopupContainer: M,
          items: J.map((Oe, Me) => {
            const {
              key: Fe,
              text: Ue,
              onSelect: je
            } = Oe;
            return {
              key: Fe ?? Me,
              onClick: () => {
                je?.(ge);
              },
              label: Ue
            };
          })
        };
        Ee = /* @__PURE__ */ reactExports.createElement("div", {
          className: `${I}-selection-extra`
        }, /* @__PURE__ */ reactExports.createElement(Dropdown, {
          menu: Be,
          getPopupContainer: M
        }, /* @__PURE__ */ reactExports.createElement("span", null, /* @__PURE__ */ reactExports.createElement(RefIcon$C, null))));
      }
      const _e = D.map((Be, Oe) => {
        const Me = O(Be, Oe), Fe = V.get(Me) || {};
        return Object.assign({
          checked: fe.has(Me)
        }, Fe);
      }).filter(({
        disabled: Be
      }) => Be), Te = !!_e.length && _e.length === D.length, ke = Te && _e.every(({
        checked: Be
      }) => Be), Re = Te && _e.some(({
        checked: Be
      }) => Be);
      ve = /* @__PURE__ */ reactExports.createElement(Checkbox$1, {
        checked: Te ? ke : !!D.length && me,
        indeterminate: Te ? !ke && Re : !me && pe,
        onChange: be,
        disabled: D.length === 0 || Te,
        "aria-label": Ee ? "Custom selection" : "Select all",
        skipGroup: !0
      }), le = !$ && /* @__PURE__ */ reactExports.createElement("div", {
        className: `${I}-selection`
      }, ve, Ee);
    }
    let he;
    m === "radio" ? he = (Ee, _e, Te) => {
      const ke = O(_e, Te), Re = fe.has(ke), Be = V.get(ke);
      return {
        node: /* @__PURE__ */ reactExports.createElement(Radio$1, Object.assign({}, Be, {
          checked: Re,
          onClick: (Oe) => {
            var Me;
            Oe.stopPropagation(), (Me = Be?.onClick) === null || Me === void 0 || Me.call(Be, Oe);
          },
          onChange: (Oe) => {
            var Me;
            fe.has(ke) || Q(ke, !0, [ke], Oe.nativeEvent), (Me = Be?.onChange) === null || Me === void 0 || Me.call(Be, Oe);
          }
        })),
        checked: Re
      };
    } : he = (Ee, _e, Te) => {
      var ke;
      const Re = O(_e, Te), Be = fe.has(Re), Oe = Y.has(Re), Me = V.get(Re);
      let Fe;
      return L === "nest" ? Fe = Oe : Fe = (ke = Me?.indeterminate) !== null && ke !== void 0 ? ke : Oe, {
        node: /* @__PURE__ */ reactExports.createElement(Checkbox$1, Object.assign({}, Me, {
          indeterminate: Fe,
          checked: Be,
          skipGroup: !0,
          onClick: (Ue) => {
            var je;
            Ue.stopPropagation(), (je = Me?.onClick) === null || je === void 0 || je.call(Me, Ue);
          },
          onChange: (Ue) => {
            var je;
            const {
              nativeEvent: Le
            } = Ue, {
              shiftKey: De
            } = Le, Ne = ge.findIndex((Xe) => Xe === Re), Ge = ne.some((Xe) => ge.includes(Xe));
            if (De && T && Ge) {
              const Xe = j(Ne, ge, fe), nt = Array.from(fe);
              y?.(!Be, nt.map((ct) => R(ct)), Xe.map((ct) => R(ct))), ee(nt, "multiple");
            } else {
              const Xe = ne;
              if (T) {
                const nt = Be ? arrDel(Xe, Re) : arrAdd(Xe, Re);
                Q(Re, !Be, nt, Le);
              } else {
                const nt = conductCheck([].concat(_toConsumableArray$e(Xe), [Re]), !0, H, Z), {
                  checkedKeys: ct,
                  halfCheckedKeys: it
                } = nt;
                let We = ct;
                if (Be) {
                  const Ve = new Set(ct);
                  Ve.delete(Re), We = conductCheck(Array.from(Ve), {
                    halfCheckedKeys: it
                  }, H, Z).checkedKeys;
                }
                Q(Re, !Be, We, Le);
              }
            }
            G(Be ? null : Ne), (je = Me?.onChange) === null || je === void 0 || je.call(Me, Ue);
          }
        })),
        checked: Be
      };
    };
    const ye = (Ee, _e, Te) => {
      const {
        node: ke,
        checked: Re
      } = he(Ee, _e, Te);
      return S ? S(Re, _e, Te, ke) : ke;
    };
    if (!ie.includes(SELECTION_COLUMN))
      if (ie.findIndex((Ee) => {
        var _e;
        return ((_e = Ee[INTERNAL_COL_DEFINE]) === null || _e === void 0 ? void 0 : _e.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        const [Ee, ..._e] = ie;
        ie = [Ee, SELECTION_COLUMN].concat(_toConsumableArray$e(_e));
      } else
        ie = [SELECTION_COLUMN].concat(_toConsumableArray$e(ie));
    const Ce = ie.indexOf(SELECTION_COLUMN);
    ie = ie.filter((Ee, _e) => Ee !== SELECTION_COLUMN || _e === Ce);
    const xe = ie[Ce - 1], we = ie[Ce + 1];
    let $e = w;
    $e === void 0 && (we?.fixed !== void 0 ? $e = we.fixed : xe?.fixed !== void 0 && ($e = xe.fixed)), $e && xe && ((se = xe[INTERNAL_COL_DEFINE]) === null || se === void 0 ? void 0 : se.columnType) === "EXPAND_COLUMN" && xe.fixed === void 0 && (xe.fixed = $e);
    const Ae = classnames(`${I}-selection-col`, {
      [`${I}-selection-col-with-dropdown`]: C && m === "checkbox"
    }), ue = () => s?.columnTitle ? typeof s.columnTitle == "function" ? s.columnTitle(ve) : s.columnTitle : le, ce = {
      fixed: $e,
      width: f,
      className: `${I}-selection-column`,
      title: ue(),
      render: ye,
      onCell: s.onCell,
      align: s.align,
      [INTERNAL_COL_DEFINE]: {
        className: Ae
      }
    };
    return ie.map((Ee) => Ee === SELECTION_COLUMN ? ce : Ee);
  }, [O, D, s, ne, q, Y, f, J, L, V, y, Q, Z]), q];
};
function fillProxy(a, s) {
  return a._antProxy = a._antProxy || {}, Object.keys(s).forEach((c) => {
    if (!(c in a._antProxy)) {
      const u = a[c];
      a._antProxy[c] = u, a[c] = s[c];
    }
  }), a;
}
function useProxyImperativeHandle(a, s) {
  return reactExports.useImperativeHandle(a, () => {
    const c = s(), {
      nativeElement: u
    } = c;
    return typeof Proxy < "u" ? new Proxy(u, {
      get(d, p) {
        return c[p] ? c[p] : Reflect.get(d, p);
      }
    }) : fillProxy(u, c);
  });
}
function renderExpandIcon(a) {
  return (s) => {
    const {
      prefixCls: c,
      onExpand: u,
      record: d,
      expanded: p,
      expandable: v
    } = s, A = `${c}-row-expand-icon`;
    return /* @__PURE__ */ reactExports.createElement("button", {
      type: "button",
      onClick: (x) => {
        u(d, x), x.stopPropagation();
      },
      className: classnames(A, {
        [`${A}-spaced`]: !v,
        [`${A}-expanded`]: v && p,
        [`${A}-collapsed`]: v && !p
      }),
      "aria-label": p ? a.collapse : a.expand,
      "aria-expanded": p
    });
  };
}
function useContainerWidth(a) {
  return (c, u) => {
    const d = c.querySelector(`.${a}-container`);
    let p = u;
    if (d) {
      const v = getComputedStyle(d), A = parseInt(v.borderLeftWidth, 10), x = parseInt(v.borderRightWidth, 10);
      p = u - A - x;
    }
    return p;
  };
}
const getColumnKey = (a, s) => "key" in a && a.key !== void 0 && a.key !== null ? a.key : a.dataIndex ? Array.isArray(a.dataIndex) ? a.dataIndex.join(".") : a.dataIndex : s;
function getColumnPos(a, s) {
  return s ? `${s}-${a}` : `${a}`;
}
const renderColumnTitle = (a, s) => typeof a == "function" ? a(s) : a, safeColumnTitle = (a, s) => {
  const c = renderColumnTitle(a, s);
  return Object.prototype.toString.call(c) === "[object Object]" ? "" : c;
};
function useSyncState(a) {
  const s = reactExports.useRef(a), c = useForceUpdate();
  return [() => s.current, (u) => {
    s.current = u, c();
  }];
}
var DropIndicator = function a(s) {
  var c = s.dropPosition, u = s.dropLevelOffset, d = s.indent, p = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (c) {
    case -1:
      p.top = 0, p.left = -u * d;
      break;
    case 1:
      p.bottom = 0, p.left = -u * d;
      break;
    case 0:
      p.bottom = 0, p.left = d;
      break;
  }
  return /* @__PURE__ */ React.createElement("div", {
    style: p
  });
};
function _objectDestructuringEmpty(a) {
  if (a == null) throw new TypeError("Cannot destructure " + a);
}
function useUnmount$1(a, s) {
  var c = reactExports.useState(!1), u = _slicedToArray$e(c, 2), d = u[0], p = u[1];
  useLayoutEffect$1(function() {
    if (d)
      return a(), function() {
        s();
      };
  }, [d]), useLayoutEffect$1(function() {
    return p(!0), function() {
      p(!1);
    };
  }, []);
}
var _excluded$5 = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"], MotionTreeNode = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.className, u = a.style, d = a.motion, p = a.motionNodes, v = a.motionType, A = a.onMotionStart, x = a.onMotionEnd, g = a.active, b = a.treeNodeRequiredProps, y = _objectWithoutProperties$2(a, _excluded$5), f = reactExports.useState(!0), m = _slicedToArray$e(f, 2), C = m[0], w = m[1], S = reactExports.useContext(TreeContext), $ = S.prefixCls, T = p && v !== "hide";
  useLayoutEffect$1(function() {
    p && T !== C && w(T);
  }, [p]);
  var I = function() {
    p && A();
  }, _ = reactExports.useRef(!1), E = function() {
    p && !_.current && (_.current = !0, x());
  };
  useUnmount$1(I, E);
  var R = function(L) {
    T === L && E();
  };
  return p ? /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$3({
    ref: s,
    visible: C
  }, d, {
    motionAppear: v === "show",
    onVisibleChanged: R
  }), function(O, L) {
    var B = O.className, F = O.style;
    return /* @__PURE__ */ reactExports.createElement("div", {
      ref: L,
      className: classnames("".concat($, "-treenode-motion"), B),
      style: F
    }, p.map(function(M) {
      var W = Object.assign({}, (_objectDestructuringEmpty(M.data), M.data)), j = M.title, G = M.key, U = M.isStart, k = M.isEnd;
      delete W.children;
      var N = getTreeNodeProps(G, b);
      return /* @__PURE__ */ reactExports.createElement(TreeNode$1, _extends$3({}, W, N, {
        title: j,
        active: g,
        data: M.data,
        key: G,
        isStart: U,
        isEnd: k
      }));
    }));
  }) : /* @__PURE__ */ reactExports.createElement(TreeNode$1, _extends$3({
    domRef: s,
    className: c,
    style: u
  }, y, {
    active: g
  }));
});
function findExpandedKeys() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], c = a.length, u = s.length;
  if (Math.abs(c - u) !== 1)
    return {
      add: !1,
      key: null
    };
  function d(p, v) {
    var A = /* @__PURE__ */ new Map();
    p.forEach(function(g) {
      A.set(g, !0);
    });
    var x = v.filter(function(g) {
      return !A.has(g);
    });
    return x.length === 1 ? x[0] : null;
  }
  return c < u ? {
    add: !0,
    key: d(a, s)
  } : {
    add: !1,
    key: d(s, a)
  };
}
function getExpandRange(a, s, c) {
  var u = a.findIndex(function(A) {
    return A.key === c;
  }), d = a[u + 1], p = s.findIndex(function(A) {
    return A.key === c;
  });
  if (d) {
    var v = s.findIndex(function(A) {
      return A.key === d.key;
    });
    return s.slice(p + 1, v);
  }
  return s.slice(p + 1);
}
var _excluded$4 = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "scrollWidth", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"], HIDDEN_STYLE$1 = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, noop$2 = function a() {
}, MOTION_KEY = "RC_TREE_MOTION_".concat(Math.random()), MotionNode = {
  key: MOTION_KEY
}, MotionEntity = {
  key: MOTION_KEY,
  level: 0,
  index: 0,
  pos: "0",
  node: MotionNode,
  nodes: [MotionNode]
}, MotionFlattenData = {
  parent: null,
  children: [],
  pos: MotionEntity.pos,
  data: MotionNode,
  title: null,
  key: MOTION_KEY,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function getMinimumRangeTransitionRange(a, s, c, u) {
  return s === !1 || !c ? a : a.slice(0, Math.ceil(c / u) + 1);
}
function itemKey(a) {
  var s = a.key, c = a.pos;
  return getKey$1(s, c);
}
function getAccessibilityPath(a) {
  for (var s = String(a.data.key), c = a; c.parent; )
    c = c.parent, s = "".concat(c.data.key, " > ").concat(s);
  return s;
}
var NodeList = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.prefixCls, u = a.data;
  a.selectable, a.checkable;
  var d = a.expandedKeys, p = a.selectedKeys, v = a.checkedKeys, A = a.loadedKeys, x = a.loadingKeys, g = a.halfCheckedKeys, b = a.keyEntities, y = a.disabled, f = a.dragging, m = a.dragOverNodeKey, C = a.dropPosition, w = a.motion, S = a.height, $ = a.itemHeight, T = a.virtual, I = a.scrollWidth, _ = a.focusable, E = a.activeItem, R = a.focused, O = a.tabIndex, L = a.onKeyDown, B = a.onFocus, F = a.onBlur, M = a.onActiveChange, W = a.onListChangeStart, j = a.onListChangeEnd, G = _objectWithoutProperties$2(a, _excluded$4), U = reactExports.useRef(null), k = reactExports.useRef(null);
  reactExports.useImperativeHandle(s, function() {
    return {
      scrollTo: function(ye) {
        U.current.scrollTo(ye);
      },
      getIndentWidth: function() {
        return k.current.offsetWidth;
      }
    };
  });
  var N = reactExports.useState(d), P = _slicedToArray$e(N, 2), D = P[0], H = P[1], V = reactExports.useState(u), Z = _slicedToArray$e(V, 2), ne = Z[0], K = Z[1], q = reactExports.useState(u), Y = _slicedToArray$e(q, 2), ee = Y[0], Q = Y[1], J = reactExports.useState([]), te = _slicedToArray$e(J, 2), ae = te[0], se = te[1], ie = reactExports.useState(null), fe = _slicedToArray$e(ie, 2), ge = fe[0], me = fe[1], pe = reactExports.useRef(u);
  pe.current = u;
  function be() {
    var he = pe.current;
    K(he), Q(he), se([]), me(null), j();
  }
  useLayoutEffect$1(function() {
    H(d);
    var he = findExpandedKeys(D, d);
    if (he.key !== null)
      if (he.add) {
        var ye = ne.findIndex(function(ue) {
          var ce = ue.key;
          return ce === he.key;
        }), Ce = getMinimumRangeTransitionRange(getExpandRange(ne, u, he.key), T, S, $), xe = ne.slice();
        xe.splice(ye + 1, 0, MotionFlattenData), Q(xe), se(Ce), me("show");
      } else {
        var we = u.findIndex(function(ue) {
          var ce = ue.key;
          return ce === he.key;
        }), $e = getMinimumRangeTransitionRange(getExpandRange(u, ne, he.key), T, S, $), Ae = u.slice();
        Ae.splice(we + 1, 0, MotionFlattenData), Q(Ae), se($e), me("hide");
      }
    else ne !== u && (K(u), Q(u));
  }, [d, u]), reactExports.useEffect(function() {
    f || be();
  }, [f]);
  var le = w ? ee : u, ve = {
    expandedKeys: d,
    selectedKeys: p,
    loadedKeys: A,
    loadingKeys: x,
    checkedKeys: v,
    halfCheckedKeys: g,
    dragOverNodeKey: m,
    dropPosition: C,
    keyEntities: b
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, R && E && /* @__PURE__ */ reactExports.createElement("span", {
    style: HIDDEN_STYLE$1,
    "aria-live": "assertive"
  }, getAccessibilityPath(E)), /* @__PURE__ */ reactExports.createElement("div", null, /* @__PURE__ */ reactExports.createElement("input", {
    style: HIDDEN_STYLE$1,
    disabled: _ === !1 || y,
    tabIndex: _ !== !1 ? O : null,
    onKeyDown: L,
    onFocus: B,
    onBlur: F,
    value: "",
    onChange: noop$2,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(c, "-treenode"),
    "aria-hidden": !0,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(c, "-indent")
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: k,
    className: "".concat(c, "-indent-unit")
  }))), /* @__PURE__ */ reactExports.createElement(List, _extends$3({}, G, {
    data: le,
    itemKey,
    height: S,
    fullHeight: !1,
    virtual: T,
    itemHeight: $,
    scrollWidth: I,
    prefixCls: "".concat(c, "-list"),
    ref: U,
    role: "tree",
    onVisibleChange: function(ye) {
      ye.every(function(Ce) {
        return itemKey(Ce) !== MOTION_KEY;
      }) && be();
    }
  }), function(he) {
    var ye = he.pos, Ce = Object.assign({}, (_objectDestructuringEmpty(he.data), he.data)), xe = he.title, we = he.key, $e = he.isStart, Ae = he.isEnd, ue = getKey$1(we, ye);
    delete Ce.key, delete Ce.children;
    var ce = getTreeNodeProps(ue, ve);
    return /* @__PURE__ */ reactExports.createElement(MotionTreeNode, _extends$3({}, Ce, ce, {
      title: xe,
      active: !!E && we === E.key,
      pos: ye,
      data: he.data,
      isStart: $e,
      isEnd: Ae,
      motion: w,
      motionNodes: we === MOTION_KEY ? ae : null,
      motionType: ge,
      onMotionStart: W,
      onMotionEnd: be,
      treeNodeRequiredProps: ve,
      onMouseMove: function() {
        M(null);
      }
    }));
  }));
}), MAX_RETRY_TIMES = 10, Tree$2 = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c() {
    var u;
    _classCallCheck$1(this, c);
    for (var d = arguments.length, p = new Array(d), v = 0; v < d; v++)
      p[v] = arguments[v];
    return u = s.call.apply(s, [this].concat(p)), _defineProperty$a(_assertThisInitialized(u), "destroyed", !1), _defineProperty$a(_assertThisInitialized(u), "delayedDragEnterLogic", void 0), _defineProperty$a(_assertThisInitialized(u), "loadingRetryTimes", {}), _defineProperty$a(_assertThisInitialized(u), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: !0,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: !1,
      activeKey: null,
      listChanging: !1,
      prevProps: null,
      fieldNames: fillFieldNames$1()
    }), _defineProperty$a(_assertThisInitialized(u), "dragStartMousePosition", null), _defineProperty$a(_assertThisInitialized(u), "dragNodeProps", null), _defineProperty$a(_assertThisInitialized(u), "currentMouseOverDroppableNodeKey", null), _defineProperty$a(_assertThisInitialized(u), "listRef", /* @__PURE__ */ reactExports.createRef()), _defineProperty$a(_assertThisInitialized(u), "onNodeDragStart", function(A, x) {
      var g = u.state, b = g.expandedKeys, y = g.keyEntities, f = u.props.onDragStart, m = x.eventKey;
      u.dragNodeProps = x, u.dragStartMousePosition = {
        x: A.clientX,
        y: A.clientY
      };
      var C = arrDel(b, m);
      u.setState({
        draggingNodeKey: m,
        dragChildrenKeys: getDragChildrenKeys(m, y),
        indent: u.listRef.current.getIndentWidth()
      }), u.setExpandedKeys(C), window.addEventListener("dragend", u.onWindowDragEnd), f?.({
        event: A,
        node: convertNodePropsToEventData(x)
      });
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeDragEnter", function(A, x) {
      var g = u.state, b = g.expandedKeys, y = g.keyEntities, f = g.dragChildrenKeys, m = g.flattenNodes, C = g.indent, w = u.props, S = w.onDragEnter, $ = w.onExpand, T = w.allowDrop, I = w.direction, _ = x.pos, E = x.eventKey;
      if (u.currentMouseOverDroppableNodeKey !== E && (u.currentMouseOverDroppableNodeKey = E), !u.dragNodeProps) {
        u.resetDragState();
        return;
      }
      var R = calcDropPosition(A, u.dragNodeProps, x, C, u.dragStartMousePosition, T, m, y, b, I), O = R.dropPosition, L = R.dropLevelOffset, B = R.dropTargetKey, F = R.dropContainerKey, M = R.dropTargetPos, W = R.dropAllowed, j = R.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        f.includes(B) || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !W
      ) {
        u.resetDragState();
        return;
      }
      if (u.delayedDragEnterLogic || (u.delayedDragEnterLogic = {}), Object.keys(u.delayedDragEnterLogic).forEach(function(G) {
        clearTimeout(u.delayedDragEnterLogic[G]);
      }), u.dragNodeProps.eventKey !== x.eventKey && (A.persist(), u.delayedDragEnterLogic[_] = window.setTimeout(function() {
        if (u.state.draggingNodeKey !== null) {
          var G = _toConsumableArray$e(b), U = getEntity(y, x.eventKey);
          U && (U.children || []).length && (G = arrAdd(b, x.eventKey)), u.props.hasOwnProperty("expandedKeys") || u.setExpandedKeys(G), $?.(G, {
            node: convertNodePropsToEventData(x),
            expanded: !0,
            nativeEvent: A.nativeEvent
          });
        }
      }, 800)), u.dragNodeProps.eventKey === B && L === 0) {
        u.resetDragState();
        return;
      }
      u.setState({
        dragOverNodeKey: j,
        dropPosition: O,
        dropLevelOffset: L,
        dropTargetKey: B,
        dropContainerKey: F,
        dropTargetPos: M,
        dropAllowed: W
      }), S?.({
        event: A,
        node: convertNodePropsToEventData(x),
        expandedKeys: b
      });
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeDragOver", function(A, x) {
      var g = u.state, b = g.dragChildrenKeys, y = g.flattenNodes, f = g.keyEntities, m = g.expandedKeys, C = g.indent, w = u.props, S = w.onDragOver, $ = w.allowDrop, T = w.direction;
      if (u.dragNodeProps) {
        var I = calcDropPosition(A, u.dragNodeProps, x, C, u.dragStartMousePosition, $, y, f, m, T), _ = I.dropPosition, E = I.dropLevelOffset, R = I.dropTargetKey, O = I.dropContainerKey, L = I.dropTargetPos, B = I.dropAllowed, F = I.dragOverNodeKey;
        b.includes(R) || !B || (u.dragNodeProps.eventKey === R && E === 0 ? u.state.dropPosition === null && u.state.dropLevelOffset === null && u.state.dropTargetKey === null && u.state.dropContainerKey === null && u.state.dropTargetPos === null && u.state.dropAllowed === !1 && u.state.dragOverNodeKey === null || u.resetDragState() : _ === u.state.dropPosition && E === u.state.dropLevelOffset && R === u.state.dropTargetKey && O === u.state.dropContainerKey && L === u.state.dropTargetPos && B === u.state.dropAllowed && F === u.state.dragOverNodeKey || u.setState({
          dropPosition: _,
          dropLevelOffset: E,
          dropTargetKey: R,
          dropContainerKey: O,
          dropTargetPos: L,
          dropAllowed: B,
          dragOverNodeKey: F
        }), S?.({
          event: A,
          node: convertNodePropsToEventData(x)
        }));
      }
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeDragLeave", function(A, x) {
      u.currentMouseOverDroppableNodeKey === x.eventKey && !A.currentTarget.contains(A.relatedTarget) && (u.resetDragState(), u.currentMouseOverDroppableNodeKey = null);
      var g = u.props.onDragLeave;
      g?.({
        event: A,
        node: convertNodePropsToEventData(x)
      });
    }), _defineProperty$a(_assertThisInitialized(u), "onWindowDragEnd", function(A) {
      u.onNodeDragEnd(A, null, !0), window.removeEventListener("dragend", u.onWindowDragEnd);
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeDragEnd", function(A, x) {
      var g = u.props.onDragEnd;
      u.setState({
        dragOverNodeKey: null
      }), u.cleanDragState(), g?.({
        event: A,
        node: convertNodePropsToEventData(x)
      }), u.dragNodeProps = null, window.removeEventListener("dragend", u.onWindowDragEnd);
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeDrop", function(A, x) {
      var g, b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, y = u.state, f = y.dragChildrenKeys, m = y.dropPosition, C = y.dropTargetKey, w = y.dropTargetPos, S = y.dropAllowed;
      if (S) {
        var $ = u.props.onDrop;
        if (u.setState({
          dragOverNodeKey: null
        }), u.cleanDragState(), C !== null) {
          var T = _objectSpread2$1(_objectSpread2$1({}, getTreeNodeProps(C, u.getTreeNodeRequiredProps())), {}, {
            active: ((g = u.getActiveItem()) === null || g === void 0 ? void 0 : g.key) === C,
            data: getEntity(u.state.keyEntities, C).node
          }), I = f.includes(C);
          warningOnce(!I, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
          var _ = posToArr(w), E = {
            event: A,
            node: convertNodePropsToEventData(T),
            dragNode: u.dragNodeProps ? convertNodePropsToEventData(u.dragNodeProps) : null,
            dragNodesKeys: [u.dragNodeProps.eventKey].concat(f),
            dropToGap: m !== 0,
            dropPosition: m + Number(_[_.length - 1])
          };
          b || $?.(E), u.dragNodeProps = null;
        }
      }
    }), _defineProperty$a(_assertThisInitialized(u), "cleanDragState", function() {
      var A = u.state.draggingNodeKey;
      A !== null && u.setState({
        draggingNodeKey: null,
        dropPosition: null,
        dropContainerKey: null,
        dropTargetKey: null,
        dropLevelOffset: null,
        dropAllowed: !0,
        dragOverNodeKey: null
      }), u.dragStartMousePosition = null, u.currentMouseOverDroppableNodeKey = null;
    }), _defineProperty$a(_assertThisInitialized(u), "triggerExpandActionExpand", function(A, x) {
      var g = u.state, b = g.expandedKeys, y = g.flattenNodes, f = x.expanded, m = x.key, C = x.isLeaf;
      if (!(C || A.shiftKey || A.metaKey || A.ctrlKey)) {
        var w = y.filter(function($) {
          return $.key === m;
        })[0], S = convertNodePropsToEventData(_objectSpread2$1(_objectSpread2$1({}, getTreeNodeProps(m, u.getTreeNodeRequiredProps())), {}, {
          data: w.data
        }));
        u.setExpandedKeys(f ? arrDel(b, m) : arrAdd(b, m)), u.onNodeExpand(A, S);
      }
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeClick", function(A, x) {
      var g = u.props, b = g.onClick, y = g.expandAction;
      y === "click" && u.triggerExpandActionExpand(A, x), b?.(A, x);
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeDoubleClick", function(A, x) {
      var g = u.props, b = g.onDoubleClick, y = g.expandAction;
      y === "doubleClick" && u.triggerExpandActionExpand(A, x), b?.(A, x);
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeSelect", function(A, x) {
      var g = u.state.selectedKeys, b = u.state, y = b.keyEntities, f = b.fieldNames, m = u.props, C = m.onSelect, w = m.multiple, S = x.selected, $ = x[f.key], T = !S;
      T ? w ? g = arrAdd(g, $) : g = [$] : g = arrDel(g, $);
      var I = g.map(function(_) {
        var E = getEntity(y, _);
        return E ? E.node : null;
      }).filter(Boolean);
      u.setUncontrolledState({
        selectedKeys: g
      }), C?.(g, {
        event: "select",
        selected: T,
        node: x,
        selectedNodes: I,
        nativeEvent: A.nativeEvent
      });
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeCheck", function(A, x, g) {
      var b = u.state, y = b.keyEntities, f = b.checkedKeys, m = b.halfCheckedKeys, C = u.props, w = C.checkStrictly, S = C.onCheck, $ = x.key, T, I = {
        event: "check",
        node: x,
        checked: g,
        nativeEvent: A.nativeEvent
      };
      if (w) {
        var _ = g ? arrAdd(f, $) : arrDel(f, $), E = arrDel(m, $);
        T = {
          checked: _,
          halfChecked: E
        }, I.checkedNodes = _.map(function(M) {
          return getEntity(y, M);
        }).filter(Boolean).map(function(M) {
          return M.node;
        }), u.setUncontrolledState({
          checkedKeys: _
        });
      } else {
        var R = conductCheck([].concat(_toConsumableArray$e(f), [$]), !0, y), O = R.checkedKeys, L = R.halfCheckedKeys;
        if (!g) {
          var B = new Set(O);
          B.delete($);
          var F = conductCheck(Array.from(B), {
            halfCheckedKeys: L
          }, y);
          O = F.checkedKeys, L = F.halfCheckedKeys;
        }
        T = O, I.checkedNodes = [], I.checkedNodesPositions = [], I.halfCheckedKeys = L, O.forEach(function(M) {
          var W = getEntity(y, M);
          if (W) {
            var j = W.node, G = W.pos;
            I.checkedNodes.push(j), I.checkedNodesPositions.push({
              node: j,
              pos: G
            });
          }
        }), u.setUncontrolledState({
          checkedKeys: O
        }, !1, {
          halfCheckedKeys: L
        });
      }
      S?.(T, I);
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeLoad", function(A) {
      var x, g = A.key, b = u.state.keyEntities, y = getEntity(b, g);
      if (!(y != null && (x = y.children) !== null && x !== void 0 && x.length)) {
        var f = new Promise(function(m, C) {
          u.setState(function(w) {
            var S = w.loadedKeys, $ = S === void 0 ? [] : S, T = w.loadingKeys, I = T === void 0 ? [] : T, _ = u.props, E = _.loadData, R = _.onLoad;
            if (!E || $.includes(g) || I.includes(g))
              return null;
            var O = E(A);
            return O.then(function() {
              var L = u.state.loadedKeys, B = arrAdd(L, g);
              R?.(B, {
                event: "load",
                node: A
              }), u.setUncontrolledState({
                loadedKeys: B
              }), u.setState(function(F) {
                return {
                  loadingKeys: arrDel(F.loadingKeys, g)
                };
              }), m();
            }).catch(function(L) {
              if (u.setState(function(F) {
                return {
                  loadingKeys: arrDel(F.loadingKeys, g)
                };
              }), u.loadingRetryTimes[g] = (u.loadingRetryTimes[g] || 0) + 1, u.loadingRetryTimes[g] >= MAX_RETRY_TIMES) {
                var B = u.state.loadedKeys;
                warningOnce(!1, "Retry for `loadData` many times but still failed. No more retry."), u.setUncontrolledState({
                  loadedKeys: arrAdd(B, g)
                }), m();
              }
              C(L);
            }), {
              loadingKeys: arrAdd(I, g)
            };
          });
        });
        return f.catch(function() {
        }), f;
      }
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeMouseEnter", function(A, x) {
      var g = u.props.onMouseEnter;
      g?.({
        event: A,
        node: x
      });
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeMouseLeave", function(A, x) {
      var g = u.props.onMouseLeave;
      g?.({
        event: A,
        node: x
      });
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeContextMenu", function(A, x) {
      var g = u.props.onRightClick;
      g && (A.preventDefault(), g({
        event: A,
        node: x
      }));
    }), _defineProperty$a(_assertThisInitialized(u), "onFocus", function() {
      var A = u.props.onFocus;
      u.setState({
        focused: !0
      });
      for (var x = arguments.length, g = new Array(x), b = 0; b < x; b++)
        g[b] = arguments[b];
      A?.apply(void 0, g);
    }), _defineProperty$a(_assertThisInitialized(u), "onBlur", function() {
      var A = u.props.onBlur;
      u.setState({
        focused: !1
      }), u.onActiveChange(null);
      for (var x = arguments.length, g = new Array(x), b = 0; b < x; b++)
        g[b] = arguments[b];
      A?.apply(void 0, g);
    }), _defineProperty$a(_assertThisInitialized(u), "getTreeNodeRequiredProps", function() {
      var A = u.state, x = A.expandedKeys, g = A.selectedKeys, b = A.loadedKeys, y = A.loadingKeys, f = A.checkedKeys, m = A.halfCheckedKeys, C = A.dragOverNodeKey, w = A.dropPosition, S = A.keyEntities;
      return {
        expandedKeys: x || [],
        selectedKeys: g || [],
        loadedKeys: b || [],
        loadingKeys: y || [],
        checkedKeys: f || [],
        halfCheckedKeys: m || [],
        dragOverNodeKey: C,
        dropPosition: w,
        keyEntities: S
      };
    }), _defineProperty$a(_assertThisInitialized(u), "setExpandedKeys", function(A) {
      var x = u.state, g = x.treeData, b = x.fieldNames, y = flattenTreeData(g, A, b);
      u.setUncontrolledState({
        expandedKeys: A,
        flattenNodes: y
      }, !0);
    }), _defineProperty$a(_assertThisInitialized(u), "onNodeExpand", function(A, x) {
      var g = u.state.expandedKeys, b = u.state, y = b.listChanging, f = b.fieldNames, m = u.props, C = m.onExpand, w = m.loadData, S = x.expanded, $ = x[f.key];
      if (!y) {
        var T = g.includes($), I = !S;
        if (warningOnce(S && T || !S && !T, "Expand state not sync with index check"), g = I ? arrAdd(g, $) : arrDel(g, $), u.setExpandedKeys(g), C?.(g, {
          node: x,
          expanded: I,
          nativeEvent: A.nativeEvent
        }), I && w) {
          var _ = u.onNodeLoad(x);
          _ && _.then(function() {
            var E = flattenTreeData(u.state.treeData, g, f);
            u.setUncontrolledState({
              flattenNodes: E
            });
          }).catch(function() {
            var E = u.state.expandedKeys, R = arrDel(E, $);
            u.setExpandedKeys(R);
          });
        }
      }
    }), _defineProperty$a(_assertThisInitialized(u), "onListChangeStart", function() {
      u.setUncontrolledState({
        listChanging: !0
      });
    }), _defineProperty$a(_assertThisInitialized(u), "onListChangeEnd", function() {
      setTimeout(function() {
        u.setUncontrolledState({
          listChanging: !1
        });
      });
    }), _defineProperty$a(_assertThisInitialized(u), "onActiveChange", function(A) {
      var x = u.state.activeKey, g = u.props, b = g.onActiveChange, y = g.itemScrollOffset, f = y === void 0 ? 0 : y;
      x !== A && (u.setState({
        activeKey: A
      }), A !== null && u.scrollTo({
        key: A,
        offset: f
      }), b?.(A));
    }), _defineProperty$a(_assertThisInitialized(u), "getActiveItem", function() {
      var A = u.state, x = A.activeKey, g = A.flattenNodes;
      return x === null ? null : g.find(function(b) {
        var y = b.key;
        return y === x;
      }) || null;
    }), _defineProperty$a(_assertThisInitialized(u), "offsetActiveKey", function(A) {
      var x = u.state, g = x.flattenNodes, b = x.activeKey, y = g.findIndex(function(C) {
        var w = C.key;
        return w === b;
      });
      y === -1 && A < 0 && (y = g.length), y = (y + A + g.length) % g.length;
      var f = g[y];
      if (f) {
        var m = f.key;
        u.onActiveChange(m);
      } else
        u.onActiveChange(null);
    }), _defineProperty$a(_assertThisInitialized(u), "onKeyDown", function(A) {
      var x = u.state, g = x.activeKey, b = x.expandedKeys, y = x.checkedKeys, f = x.fieldNames, m = u.props, C = m.onKeyDown, w = m.checkable, S = m.selectable;
      switch (A.which) {
        case KeyCode.UP: {
          u.offsetActiveKey(-1), A.preventDefault();
          break;
        }
        case KeyCode.DOWN: {
          u.offsetActiveKey(1), A.preventDefault();
          break;
        }
      }
      var $ = u.getActiveItem();
      if ($ && $.data) {
        var T = u.getTreeNodeRequiredProps(), I = $.data.isLeaf === !1 || !!($.data[f.children] || []).length, _ = convertNodePropsToEventData(_objectSpread2$1(_objectSpread2$1({}, getTreeNodeProps(g, T)), {}, {
          data: $.data,
          active: !0
        }));
        switch (A.which) {
          // >>> Expand
          case KeyCode.LEFT: {
            I && b.includes(g) ? u.onNodeExpand({}, _) : $.parent && u.onActiveChange($.parent.key), A.preventDefault();
            break;
          }
          case KeyCode.RIGHT: {
            I && !b.includes(g) ? u.onNodeExpand({}, _) : $.children && $.children.length && u.onActiveChange($.children[0].key), A.preventDefault();
            break;
          }
          // Selection
          case KeyCode.ENTER:
          case KeyCode.SPACE: {
            w && !_.disabled && _.checkable !== !1 && !_.disableCheckbox ? u.onNodeCheck({}, _, !y.includes(g)) : !w && S && !_.disabled && _.selectable !== !1 && u.onNodeSelect({}, _);
            break;
          }
        }
      }
      C?.(A);
    }), _defineProperty$a(_assertThisInitialized(u), "setUncontrolledState", function(A) {
      var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!u.destroyed) {
        var b = !1, y = !0, f = {};
        Object.keys(A).forEach(function(m) {
          if (u.props.hasOwnProperty(m)) {
            y = !1;
            return;
          }
          b = !0, f[m] = A[m];
        }), b && (!x || y) && u.setState(_objectSpread2$1(_objectSpread2$1({}, f), g));
      }
    }), _defineProperty$a(_assertThisInitialized(u), "scrollTo", function(A) {
      u.listRef.current.scrollTo(A);
    }), u;
  }
  return _createClass$1(c, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1, this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function() {
      var d = this.props, p = d.activeKey, v = d.itemScrollOffset, A = v === void 0 ? 0 : v;
      p !== void 0 && p !== this.state.activeKey && (this.setState({
        activeKey: p
      }), p !== null && this.scrollTo({
        key: p,
        offset: A
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("dragend", this.onWindowDragEnd), this.destroyed = !0;
    }
  }, {
    key: "resetDragState",
    value: function() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var d = this.state, p = d.focused, v = d.flattenNodes, A = d.keyEntities, x = d.draggingNodeKey, g = d.activeKey, b = d.dropLevelOffset, y = d.dropContainerKey, f = d.dropTargetKey, m = d.dropPosition, C = d.dragOverNodeKey, w = d.indent, S = this.props, $ = S.prefixCls, T = S.className, I = S.style, _ = S.showLine, E = S.focusable, R = S.tabIndex, O = R === void 0 ? 0 : R, L = S.selectable, B = S.showIcon, F = S.icon, M = S.switcherIcon, W = S.draggable, j = S.checkable, G = S.checkStrictly, U = S.disabled, k = S.motion, N = S.loadData, P = S.filterTreeNode, D = S.height, H = S.itemHeight, V = S.scrollWidth, Z = S.virtual, ne = S.titleRender, K = S.dropIndicatorRender, q = S.onContextMenu, Y = S.onScroll, ee = S.direction, Q = S.rootClassName, J = S.rootStyle, te = pickAttrs(this.props, {
        aria: !0,
        data: !0
      }), ae;
      W && (_typeof$h(W) === "object" ? ae = W : typeof W == "function" ? ae = {
        nodeDraggable: W
      } : ae = {});
      var se = {
        prefixCls: $,
        selectable: L,
        showIcon: B,
        icon: F,
        switcherIcon: M,
        draggable: ae,
        draggingNodeKey: x,
        checkable: j,
        checkStrictly: G,
        disabled: U,
        keyEntities: A,
        dropLevelOffset: b,
        dropContainerKey: y,
        dropTargetKey: f,
        dropPosition: m,
        dragOverNodeKey: C,
        indent: w,
        direction: ee,
        dropIndicatorRender: K,
        loadData: N,
        filterTreeNode: P,
        titleRender: ne,
        onNodeClick: this.onNodeClick,
        onNodeDoubleClick: this.onNodeDoubleClick,
        onNodeExpand: this.onNodeExpand,
        onNodeSelect: this.onNodeSelect,
        onNodeCheck: this.onNodeCheck,
        onNodeLoad: this.onNodeLoad,
        onNodeMouseEnter: this.onNodeMouseEnter,
        onNodeMouseLeave: this.onNodeMouseLeave,
        onNodeContextMenu: this.onNodeContextMenu,
        onNodeDragStart: this.onNodeDragStart,
        onNodeDragEnter: this.onNodeDragEnter,
        onNodeDragOver: this.onNodeDragOver,
        onNodeDragLeave: this.onNodeDragLeave,
        onNodeDragEnd: this.onNodeDragEnd,
        onNodeDrop: this.onNodeDrop
      };
      return /* @__PURE__ */ reactExports.createElement(TreeContext.Provider, {
        value: se
      }, /* @__PURE__ */ reactExports.createElement("div", {
        className: classnames($, T, Q, _defineProperty$a(_defineProperty$a(_defineProperty$a({}, "".concat($, "-show-line"), _), "".concat($, "-focused"), p), "".concat($, "-active-focused"), g !== null)),
        style: J
      }, /* @__PURE__ */ reactExports.createElement(NodeList, _extends$3({
        ref: this.listRef,
        prefixCls: $,
        style: I,
        data: v,
        disabled: U,
        selectable: L,
        checkable: !!j,
        motion: k,
        dragging: x !== null,
        height: D,
        itemHeight: H,
        virtual: Z,
        focusable: E,
        focused: p,
        tabIndex: O,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: q,
        onScroll: Y,
        scrollWidth: V
      }, this.getTreeNodeRequiredProps(), te))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(d, p) {
      var v = p.prevProps, A = {
        prevProps: d
      };
      function x(O) {
        return !v && d.hasOwnProperty(O) || v && v[O] !== d[O];
      }
      var g, b = p.fieldNames;
      if (x("fieldNames") && (b = fillFieldNames$1(d.fieldNames), A.fieldNames = b), x("treeData") ? g = d.treeData : x("children") && (warningOnce(!1, "`children` of Tree is deprecated. Please use `treeData` instead."), g = convertTreeToData(d.children)), g) {
        A.treeData = g;
        var y = convertDataToEntities(g, {
          fieldNames: b
        });
        A.keyEntities = _objectSpread2$1(_defineProperty$a({}, MOTION_KEY, MotionEntity), y.keyEntities);
      }
      var f = A.keyEntities || p.keyEntities;
      if (x("expandedKeys") || v && x("autoExpandParent"))
        A.expandedKeys = d.autoExpandParent || !v && d.defaultExpandParent ? conductExpandParent(d.expandedKeys, f) : d.expandedKeys;
      else if (!v && d.defaultExpandAll) {
        var m = _objectSpread2$1({}, f);
        delete m[MOTION_KEY];
        var C = [];
        Object.keys(m).forEach(function(O) {
          var L = m[O];
          L.children && L.children.length && C.push(L.key);
        }), A.expandedKeys = C;
      } else !v && d.defaultExpandedKeys && (A.expandedKeys = d.autoExpandParent || d.defaultExpandParent ? conductExpandParent(d.defaultExpandedKeys, f) : d.defaultExpandedKeys);
      if (A.expandedKeys || delete A.expandedKeys, g || A.expandedKeys) {
        var w = flattenTreeData(g || p.treeData, A.expandedKeys || p.expandedKeys, b);
        A.flattenNodes = w;
      }
      if (d.selectable && (x("selectedKeys") ? A.selectedKeys = calcSelectedKeys(d.selectedKeys, d) : !v && d.defaultSelectedKeys && (A.selectedKeys = calcSelectedKeys(d.defaultSelectedKeys, d))), d.checkable) {
        var S;
        if (x("checkedKeys") ? S = parseCheckedKeys(d.checkedKeys) || {} : !v && d.defaultCheckedKeys ? S = parseCheckedKeys(d.defaultCheckedKeys) || {} : g && (S = parseCheckedKeys(d.checkedKeys) || {
          checkedKeys: p.checkedKeys,
          halfCheckedKeys: p.halfCheckedKeys
        }), S) {
          var $ = S, T = $.checkedKeys, I = T === void 0 ? [] : T, _ = $.halfCheckedKeys, E = _ === void 0 ? [] : _;
          if (!d.checkStrictly) {
            var R = conductCheck(I, !0, f);
            I = R.checkedKeys, E = R.halfCheckedKeys;
          }
          A.checkedKeys = I, A.halfCheckedKeys = E;
        }
      }
      return x("loadedKeys") && (A.loadedKeys = d.loadedKeys), A;
    }
  }]), c;
}(reactExports.Component);
_defineProperty$a(Tree$2, "defaultProps", {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: DropIndicator,
  allowDrop: function a() {
    return !0;
  },
  expandAction: !1
});
_defineProperty$a(Tree$2, "TreeNode", TreeNode$1);
const genDirectoryStyle = ({
  treeCls: a,
  treeNodeCls: s,
  directoryNodeSelectedBg: c,
  directoryNodeSelectedColor: u,
  motionDurationMid: d,
  borderRadius: p,
  controlItemBgHover: v
}) => ({
  [`${a}${a}-directory ${s}`]: {
    // >>> Title
    [`${a}-node-content-wrapper`]: {
      position: "static",
      [`&:has(${a}-drop-indicator)`]: {
        position: "relative"
      },
      [`> *:not(${a}-drop-indicator)`]: {
        position: "relative"
      },
      "&:hover": {
        background: "transparent"
      },
      // Expand interactive area to whole line
      "&:before": {
        position: "absolute",
        inset: 0,
        transition: `background-color ${d}`,
        content: '""',
        borderRadius: p
      },
      "&:hover:before": {
        background: v
      }
    },
    [`${a}-switcher, ${a}-checkbox, ${a}-draggable-icon`]: {
      zIndex: 1
    },
    // ============= Selected =============
    "&-selected": {
      background: c,
      borderRadius: p,
      [`${a}-switcher, ${a}-draggable-icon`]: {
        color: u
      },
      // >>> Title
      [`${a}-node-content-wrapper`]: {
        color: u,
        background: "transparent",
        "&:before, &:hover:before": {
          background: c
        }
      }
    }
  }
}), treeNodeFX = new Keyframe("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), getSwitchStyle = (a, s) => ({
  [`.${a}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${s.motionDurationSlow}`
    }
  }
}), getDropIndicatorStyle = (a, s) => ({
  [`.${a}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: s.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${unit$1(s.lineWidthBold)} solid ${s.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
}), genBaseStyle$2 = (a, s) => {
  const {
    treeCls: c,
    treeNodeCls: u,
    treeNodePadding: d,
    titleHeight: p,
    indentSize: v,
    nodeSelectedBg: A,
    nodeHoverBg: x,
    colorTextQuaternary: g,
    controlItemBgActiveDisabled: b
  } = s;
  return {
    [c]: Object.assign(Object.assign({}, resetComponent(s)), {
      // fix https://github.com/ant-design/ant-design/issues/50316
      "--rc-virtual-list-scrollbar-bg": s.colorSplit,
      background: s.colorBgContainer,
      borderRadius: s.borderRadius,
      transition: `background-color ${s.motionDurationSlow}`,
      "&-rtl": {
        direction: "rtl"
      },
      [`&${c}-rtl ${c}-switcher_close ${c}-switcher-icon svg`]: {
        transform: "rotate(90deg)"
      },
      [`&-focused:not(:hover):not(${c}-active-focused)`]: Object.assign({}, genFocusOutline(s)),
      // =================== Virtual List ===================
      [`${c}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${c}-block-node`]: {
        [`${c}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${c}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${u}.dragging:after`]: {
            position: "absolute",
            inset: 0,
            border: `1px solid ${s.colorPrimary}`,
            opacity: 0,
            animationName: treeNodeFX,
            animationDuration: s.motionDurationSlow,
            animationPlayState: "running",
            animationFillMode: "forwards",
            content: '""',
            pointerEvents: "none",
            borderRadius: s.borderRadius
          }
        }
      },
      // ===================== TreeNode =====================
      [u]: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: d,
        lineHeight: unit$1(p),
        position: "relative",
        // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
        "&:before": {
          content: '""',
          position: "absolute",
          zIndex: 1,
          insetInlineStart: 0,
          width: "100%",
          top: "100%",
          height: d
        },
        // Disabled
        [`&-disabled ${c}-node-content-wrapper`]: {
          color: s.colorTextDisabled,
          cursor: "not-allowed",
          "&:hover": {
            background: "transparent"
          }
        },
        [`${c}-checkbox-disabled + ${c}-node-selected,&${u}-disabled${u}-selected ${c}-node-content-wrapper`]: {
          backgroundColor: b
        },
        // we can not set pointer-events to none for checkbox in tree
        // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
        [`${c}-checkbox-disabled`]: {
          pointerEvents: "unset"
        },
        // not disable
        [`&:not(${u}-disabled)`]: {
          // >>> Title
          [`${c}-node-content-wrapper`]: {
            "&:hover": {
              color: s.nodeHoverColor
            }
          }
        },
        [`&-active ${c}-node-content-wrapper`]: {
          background: s.controlItemBgHover
        },
        [`&:not(${u}-disabled).filter-node ${c}-title`]: {
          color: s.colorPrimary,
          fontWeight: s.fontWeightStrong
        },
        "&-draggable": {
          cursor: "grab",
          [`${c}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: p,
            textAlign: "center",
            visibility: "visible",
            color: g
          },
          [`&${u}-disabled ${c}-draggable-icon`]: {
            visibility: "hidden"
          }
        }
      },
      // >>> Indent
      [`${c}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: v
        }
      },
      // >>> Drag Handler
      [`${c}-draggable-icon`]: {
        visibility: "hidden"
      },
      // Switcher / Checkbox
      [`${c}-switcher, ${c}-checkbox`]: {
        marginInlineEnd: s.calc(s.calc(p).sub(s.controlInteractiveSize)).div(2).equal()
      },
      // >>> Switcher
      [`${c}-switcher`]: Object.assign(Object.assign({}, getSwitchStyle(a, s)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: p,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: `all ${s.motionDurationSlow}`,
        "&-noop": {
          cursor: "unset"
        },
        "&:before": {
          pointerEvents: "none",
          content: '""',
          width: p,
          height: p,
          position: "absolute",
          left: {
            _skip_check_: !0,
            value: 0
          },
          top: 0,
          borderRadius: s.borderRadius,
          transition: `all ${s.motionDurationSlow}`
        },
        [`&:not(${c}-switcher-noop):hover:before`]: {
          backgroundColor: s.colorBgTextHover
        },
        [`&_close ${c}-switcher-icon svg`]: {
          transform: "rotate(-90deg)"
        },
        "&-loading-icon": {
          color: s.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: s.calc(p).div(2).equal(),
            bottom: s.calc(d).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${s.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: s.calc(s.calc(p).div(2).equal()).mul(0.8).equal(),
            height: s.calc(p).div(2).equal(),
            borderBottom: `1px solid ${s.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${c}-node-content-wrapper`]: Object.assign(Object.assign({
        position: "relative",
        minHeight: p,
        paddingBlock: 0,
        paddingInline: s.paddingXS,
        background: "transparent",
        borderRadius: s.borderRadius,
        cursor: "pointer",
        transition: `all ${s.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`
      }, getDropIndicatorStyle(a, s)), {
        "&:hover": {
          backgroundColor: x
        },
        [`&${c}-node-selected`]: {
          color: s.nodeSelectedColor,
          backgroundColor: A
        },
        // Icon
        [`${c}-iconEle`]: {
          display: "inline-block",
          width: p,
          height: p,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      }),
      // https://github.com/ant-design/ant-design/issues/28217
      [`${c}-unselectable ${c}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      [`${u}.drop-container > [draggable]`]: {
        boxShadow: `0 0 0 2px ${s.colorPrimary}`
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${c}-indent-unit`]: {
          position: "relative",
          height: "100%",
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: s.calc(p).div(2).equal(),
            bottom: s.calc(d).mul(-1).equal(),
            borderInlineEnd: `1px solid ${s.colorBorder}`,
            content: '""'
          },
          "&-end:before": {
            display: "none"
          }
        },
        // ============== Cover Background ==============
        [`${c}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${u}-leaf-last ${c}-switcher-leaf-line:before`]: {
        top: "auto !important",
        bottom: "auto !important",
        height: `${unit$1(s.calc(p).div(2).equal())} !important`
      }
    })
  };
}, genTreeStyle = (a, s, c = !0) => {
  const u = `.${a}`, d = `${u}-treenode`, p = s.calc(s.paddingXS).div(2).equal(), v = merge(s, {
    treeCls: u,
    treeNodeCls: d,
    treeNodePadding: p
  });
  return [
    // Basic
    genBaseStyle$2(a, v),
    // Directory
    c && genDirectoryStyle(v)
  ].filter(Boolean);
}, initComponentToken = (a) => {
  const {
    controlHeightSM: s,
    controlItemBgHover: c,
    controlItemBgActive: u
  } = a, d = s;
  return {
    titleHeight: d,
    indentSize: d,
    nodeHoverBg: c,
    nodeHoverColor: a.colorText,
    nodeSelectedBg: u,
    nodeSelectedColor: a.colorText
  };
}, prepareComponentToken$3 = (a) => {
  const {
    colorTextLightSolid: s,
    colorPrimary: c
  } = a;
  return Object.assign(Object.assign({}, initComponentToken(a)), {
    directoryNodeSelectedColor: s,
    directoryNodeSelectedBg: c
  });
}, useStyle$3 = genStyleHooks("Tree", (a, {
  prefixCls: s
}) => [{
  [a.componentCls]: getStyle$1(`${s}-checkbox`, a)
}, genTreeStyle(s, a), genCollapseMotion(a)], prepareComponentToken$3), offset = 4;
function dropIndicatorRender(a) {
  const {
    dropPosition: s,
    dropLevelOffset: c,
    prefixCls: u,
    indent: d,
    direction: p = "ltr"
  } = a, v = p === "ltr" ? "left" : "right", A = p === "ltr" ? "right" : "left", x = {
    [v]: -c * d + offset,
    [A]: 0
  };
  switch (s) {
    case -1:
      x.top = -3;
      break;
    case 1:
      x.bottom = -3;
      break;
    default:
      x.bottom = -3, x[v] = d + offset;
      break;
  }
  return /* @__PURE__ */ React.createElement("div", {
    style: x,
    className: `${u}-drop-indicator`
  });
}
const SwitcherIconCom = (a) => {
  var s, c;
  const {
    prefixCls: u,
    switcherIcon: d,
    treeNodeProps: p,
    showLine: v,
    switcherLoadingIcon: A
  } = a, {
    isLeaf: x,
    expanded: g,
    loading: b
  } = p;
  if (b)
    return /* @__PURE__ */ reactExports.isValidElement(A) ? A : /* @__PURE__ */ reactExports.createElement(RefIcon$F, {
      className: `${u}-switcher-loading-icon`
    });
  let y;
  if (v && typeof v == "object" && (y = v.showLeafIcon), x) {
    if (!v)
      return null;
    if (typeof y != "boolean" && y) {
      const C = typeof y == "function" ? y(p) : y, w = `${u}-switcher-line-custom-icon`;
      return /* @__PURE__ */ reactExports.isValidElement(C) ? cloneElement(C, {
        className: classnames((s = C.props) === null || s === void 0 ? void 0 : s.className, w)
      }) : C;
    }
    return y ? /* @__PURE__ */ reactExports.createElement(RefIcon$b, {
      className: `${u}-switcher-line-icon`
    }) : /* @__PURE__ */ reactExports.createElement("span", {
      className: `${u}-switcher-leaf-line`
    });
  }
  const f = `${u}-switcher-icon`, m = typeof d == "function" ? d(p) : d;
  return /* @__PURE__ */ reactExports.isValidElement(m) ? cloneElement(m, {
    className: classnames((c = m.props) === null || c === void 0 ? void 0 : c.className, f)
  }) : m !== void 0 ? m : v ? g ? /* @__PURE__ */ reactExports.createElement(RefIcon$5, {
    className: `${u}-switcher-line-icon`
  }) : /* @__PURE__ */ reactExports.createElement(RefIcon$2, {
    className: `${u}-switcher-line-icon`
  }) : /* @__PURE__ */ reactExports.createElement(RefIcon$j, {
    className: f
  });
}, Tree$1 = /* @__PURE__ */ React.forwardRef((a, s) => {
  var c;
  const {
    getPrefixCls: u,
    direction: d,
    virtual: p,
    tree: v
  } = React.useContext(ConfigContext$1), {
    prefixCls: A,
    className: x,
    showIcon: g = !1,
    showLine: b,
    switcherIcon: y,
    switcherLoadingIcon: f,
    blockNode: m = !1,
    children: C,
    checkable: w = !1,
    selectable: S = !0,
    draggable: $,
    motion: T,
    style: I
  } = a, _ = u("tree", A), E = u(), R = T ?? Object.assign(Object.assign({}, initCollapseMotion(E)), {
    motionAppear: !1
  }), O = Object.assign(Object.assign({}, a), {
    checkable: w,
    selectable: S,
    showIcon: g,
    motion: R,
    blockNode: m,
    showLine: !!b,
    dropIndicatorRender
  }), [L, B, F] = useStyle$3(_), [, M] = useToken$1(), W = M.paddingXS / 2 + (((c = M.Tree) === null || c === void 0 ? void 0 : c.titleHeight) || M.controlHeightSM), j = React.useMemo(() => {
    if (!$)
      return !1;
    let U = {};
    switch (typeof $) {
      case "function":
        U.nodeDraggable = $;
        break;
      case "object":
        U = Object.assign({}, $);
        break;
    }
    return U.icon !== !1 && (U.icon = U.icon || /* @__PURE__ */ React.createElement(RefIcon$6, null)), U;
  }, [$]), G = (U) => /* @__PURE__ */ React.createElement(SwitcherIconCom, {
    prefixCls: _,
    switcherIcon: y,
    switcherLoadingIcon: f,
    treeNodeProps: U,
    showLine: b
  });
  return L(
    // @ts-ignore
    /* @__PURE__ */ React.createElement(Tree$2, Object.assign({
      itemHeight: W,
      ref: s,
      virtual: p
    }, O, {
      // newProps may contain style so declare style below it
      style: Object.assign(Object.assign({}, v?.style), I),
      prefixCls: _,
      className: classnames({
        [`${_}-icon-hide`]: !g,
        [`${_}-block-node`]: m,
        [`${_}-unselectable`]: !S,
        [`${_}-rtl`]: d === "rtl"
      }, v?.className, x, B, F),
      direction: d,
      checkable: w && /* @__PURE__ */ React.createElement("span", {
        className: `${_}-checkbox-inner`
      }),
      selectable: S,
      switcherIcon: G,
      draggable: j
    }), C)
  );
}), RECORD_NONE = 0, RECORD_START = 1, RECORD_END = 2;
function traverseNodesKey(a, s, c) {
  const {
    key: u,
    children: d
  } = c;
  function p(v) {
    const A = v[u], x = v[d];
    s(A, v) !== !1 && traverseNodesKey(x || [], s, c);
  }
  a.forEach(p);
}
function calcRangeKeys({
  treeData: a,
  expandedKeys: s,
  startKey: c,
  endKey: u,
  fieldNames: d
}) {
  const p = [];
  let v = RECORD_NONE;
  if (c && c === u)
    return [c];
  if (!c || !u)
    return [];
  function A(x) {
    return x === c || x === u;
  }
  return traverseNodesKey(a, (x) => {
    if (v === RECORD_END)
      return !1;
    if (A(x)) {
      if (p.push(x), v === RECORD_NONE)
        v = RECORD_START;
      else if (v === RECORD_START)
        return v = RECORD_END, !1;
    } else v === RECORD_START && p.push(x);
    return s.includes(x);
  }, fillFieldNames$1(d)), p;
}
function convertDirectoryKeysToNodes(a, s, c) {
  const u = _toConsumableArray$e(s), d = [];
  return traverseNodesKey(a, (p, v) => {
    const A = u.indexOf(p);
    return A !== -1 && (d.push(v), u.splice(A, 1)), !!u.length;
  }, fillFieldNames$1(c)), d;
}
var __rest$b = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function getIcon(a) {
  const {
    isLeaf: s,
    expanded: c
  } = a;
  return s ? /* @__PURE__ */ reactExports.createElement(RefIcon$b, null) : c ? /* @__PURE__ */ reactExports.createElement(RefIcon$8, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$7, null);
}
function getTreeData({
  treeData: a,
  children: s
}) {
  return a || convertTreeToData(s);
}
const DirectoryTree = (a, s) => {
  var {
    defaultExpandAll: c,
    defaultExpandParent: u,
    defaultExpandedKeys: d
  } = a, p = __rest$b(a, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const v = reactExports.useRef(null), A = reactExports.useRef(null), x = () => {
    const {
      keyEntities: L
    } = convertDataToEntities(getTreeData(p));
    let B;
    return c ? B = Object.keys(L) : u ? B = conductExpandParent(p.expandedKeys || d || [], L) : B = p.expandedKeys || d || [], B;
  }, [g, b] = reactExports.useState(p.selectedKeys || p.defaultSelectedKeys || []), [y, f] = reactExports.useState(() => x());
  reactExports.useEffect(() => {
    "selectedKeys" in p && b(p.selectedKeys);
  }, [p.selectedKeys]), reactExports.useEffect(() => {
    "expandedKeys" in p && f(p.expandedKeys);
  }, [p.expandedKeys]);
  const m = (L, B) => {
    var F;
    return "expandedKeys" in p || f(L), (F = p.onExpand) === null || F === void 0 ? void 0 : F.call(p, L, B);
  }, C = (L, B) => {
    var F;
    const {
      multiple: M,
      fieldNames: W
    } = p, {
      node: j,
      nativeEvent: G
    } = B, {
      key: U = ""
    } = j, k = getTreeData(p), N = Object.assign(Object.assign({}, B), {
      selected: !0
    }), P = G?.ctrlKey || G?.metaKey, D = G?.shiftKey;
    let H;
    M && P ? (H = L, v.current = U, A.current = H, N.selectedNodes = convertDirectoryKeysToNodes(k, H, W)) : M && D ? (H = Array.from(new Set([].concat(_toConsumableArray$e(A.current || []), _toConsumableArray$e(calcRangeKeys({
      treeData: k,
      expandedKeys: y,
      startKey: U,
      endKey: v.current,
      fieldNames: W
    }))))), N.selectedNodes = convertDirectoryKeysToNodes(k, H, W)) : (H = [U], v.current = U, A.current = H, N.selectedNodes = convertDirectoryKeysToNodes(k, H, W)), (F = p.onSelect) === null || F === void 0 || F.call(p, H, N), "selectedKeys" in p || b(H);
  }, {
    getPrefixCls: w,
    direction: S
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: $,
    className: T,
    showIcon: I = !0,
    expandAction: _ = "click"
  } = p, E = __rest$b(p, ["prefixCls", "className", "showIcon", "expandAction"]), R = w("tree", $), O = classnames(`${R}-directory`, {
    [`${R}-directory-rtl`]: S === "rtl"
  }, T);
  return /* @__PURE__ */ reactExports.createElement(Tree$1, Object.assign({
    icon: getIcon,
    ref: s,
    blockNode: !0
  }, E, {
    showIcon: I,
    expandAction: _,
    prefixCls: R,
    className: O,
    expandedKeys: y,
    selectedKeys: g,
    onSelect: C,
    onExpand: m
  }));
}, ForwardDirectoryTree = /* @__PURE__ */ reactExports.forwardRef(DirectoryTree), Tree = Tree$1;
Tree.DirectoryTree = ForwardDirectoryTree;
Tree.TreeNode = TreeNode$1;
const FilterSearch = (a) => {
  const {
    value: s,
    filterSearch: c,
    tablePrefixCls: u,
    locale: d,
    onChange: p
  } = a;
  return c ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${u}-filter-dropdown-search`
  }, /* @__PURE__ */ reactExports.createElement(Input$2, {
    prefix: /* @__PURE__ */ reactExports.createElement(RefIcon$B, null),
    placeholder: d.filterSearchPlaceholder,
    onChange: p,
    value: s,
    // for skip min-width of input
    htmlSize: 1,
    className: `${u}-filter-dropdown-search-input`
  })) : null;
}, onKeyDown = (a) => {
  const {
    keyCode: s
  } = a;
  s === KeyCode.ENTER && a.stopPropagation();
}, FilterDropdownMenuWrapper = /* @__PURE__ */ reactExports.forwardRef((a, s) => /* @__PURE__ */ reactExports.createElement("div", {
  className: a.className,
  onClick: (c) => c.stopPropagation(),
  onKeyDown,
  ref: s
}, a.children));
function flattenKeys(a) {
  let s = [];
  return (a || []).forEach(({
    value: c,
    children: u
  }) => {
    s.push(c), u && (s = [].concat(_toConsumableArray$e(s), _toConsumableArray$e(flattenKeys(u))));
  }), s;
}
function hasSubMenu(a) {
  return a.some(({
    children: s
  }) => s);
}
function searchValueMatched(a, s) {
  return typeof s == "string" || typeof s == "number" ? s?.toString().toLowerCase().includes(a.trim().toLowerCase()) : !1;
}
function renderFilterItems({
  filters: a,
  prefixCls: s,
  filteredKeys: c,
  filterMultiple: u,
  searchValue: d,
  filterSearch: p
}) {
  return a.map((v, A) => {
    const x = String(v.value);
    if (v.children)
      return {
        key: x || A,
        label: v.text,
        popupClassName: `${s}-dropdown-submenu`,
        children: renderFilterItems({
          filters: v.children,
          prefixCls: s,
          filteredKeys: c,
          filterMultiple: u,
          searchValue: d,
          filterSearch: p
        })
      };
    const g = u ? Checkbox$1 : Radio$1, b = {
      key: v.value !== void 0 ? x : A,
      label: /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(g, {
        checked: c.includes(x)
      }), /* @__PURE__ */ reactExports.createElement("span", null, v.text))
    };
    return d.trim() ? typeof p == "function" ? p(d, v) ? b : null : searchValueMatched(d, v.text) ? b : null : b;
  });
}
function wrapStringListType(a) {
  return a || [];
}
const FilterDropdown = (a) => {
  var s, c, u, d;
  const {
    tablePrefixCls: p,
    prefixCls: v,
    column: A,
    dropdownPrefixCls: x,
    columnKey: g,
    filterOnClose: b,
    filterMultiple: y,
    filterMode: f = "menu",
    filterSearch: m = !1,
    filterState: C,
    triggerFilter: w,
    locale: S,
    children: $,
    getPopupContainer: T,
    rootClassName: I
  } = a, {
    filterResetToDefaultFilteredValue: _,
    defaultFilteredValue: E,
    filterDropdownProps: R = {},
    // Deprecated
    filterDropdownOpen: O,
    filterDropdownVisible: L,
    onFilterDropdownVisibleChange: B,
    onFilterDropdownOpenChange: F
  } = A, [M, W] = reactExports.useState(!1), j = !!(C && (!((s = C.filteredKeys) === null || s === void 0) && s.length || C.forceFiltered)), G = (he) => {
    var ye;
    W(he), (ye = R.onOpenChange) === null || ye === void 0 || ye.call(R, he), F?.(he), B?.(he);
  }, U = (d = (u = (c = R.open) !== null && c !== void 0 ? c : O) !== null && u !== void 0 ? u : L) !== null && d !== void 0 ? d : M, k = C?.filteredKeys, [N, P] = useSyncState(wrapStringListType(k)), D = ({
    selectedKeys: he
  }) => {
    P(he);
  }, H = (he, {
    node: ye,
    checked: Ce
  }) => {
    D(y ? {
      selectedKeys: he
    } : {
      selectedKeys: Ce && ye.key ? [ye.key] : []
    });
  };
  reactExports.useEffect(() => {
    M && D({
      selectedKeys: wrapStringListType(k)
    });
  }, [k]);
  const [V, Z] = reactExports.useState([]), ne = (he) => {
    Z(he);
  }, [K, q] = reactExports.useState(""), Y = (he) => {
    const {
      value: ye
    } = he.target;
    q(ye);
  };
  reactExports.useEffect(() => {
    M || q("");
  }, [M]);
  const ee = (he) => {
    const ye = he?.length ? he : null;
    if (ye === null && (!C || !C.filteredKeys) || isEqual(ye, C?.filteredKeys, !0))
      return null;
    w({
      column: A,
      key: g,
      filteredKeys: ye
    });
  }, Q = () => {
    G(!1), ee(N());
  }, J = ({
    confirm: he,
    closeDropdown: ye
  } = {
    confirm: !1,
    closeDropdown: !1
  }) => {
    he && ee([]), ye && G(!1), q(""), P(_ ? (E || []).map((Ce) => String(Ce)) : []);
  }, te = ({
    closeDropdown: he
  } = {
    closeDropdown: !0
  }) => {
    he && G(!1), ee(N());
  }, ae = (he, ye) => {
    ye.source === "trigger" && (he && k !== void 0 && P(wrapStringListType(k)), G(he), !he && !A.filterDropdown && b && Q());
  }, se = classnames({
    [`${x}-menu-without-submenu`]: !hasSubMenu(A.filters || [])
  }), ie = (he) => {
    if (he.target.checked) {
      const ye = flattenKeys(A?.filters).map((Ce) => String(Ce));
      P(ye);
    } else
      P([]);
  }, fe = ({
    filters: he
  }) => (he || []).map((ye, Ce) => {
    const xe = String(ye.value), we = {
      title: ye.text,
      key: ye.value !== void 0 ? xe : String(Ce)
    };
    return ye.children && (we.children = fe({
      filters: ye.children
    })), we;
  }), ge = (he) => {
    var ye;
    return Object.assign(Object.assign({}, he), {
      text: he.title,
      value: he.key,
      children: ((ye = he.children) === null || ye === void 0 ? void 0 : ye.map((Ce) => ge(Ce))) || []
    });
  };
  let me;
  const {
    direction: pe,
    renderEmpty: be
  } = reactExports.useContext(ConfigContext$1);
  if (typeof A.filterDropdown == "function")
    me = A.filterDropdown({
      prefixCls: `${x}-custom`,
      setSelectedKeys: (he) => D({
        selectedKeys: he
      }),
      selectedKeys: N(),
      confirm: te,
      clearFilters: J,
      filters: A.filters,
      visible: U,
      close: () => {
        G(!1);
      }
    });
  else if (A.filterDropdown)
    me = A.filterDropdown;
  else {
    const he = N() || [], ye = () => {
      var xe, we;
      const $e = (xe = be?.("Table.filter")) !== null && xe !== void 0 ? xe : /* @__PURE__ */ reactExports.createElement(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE,
        description: S.filterEmptyText,
        styles: {
          image: {
            height: 24
          }
        },
        style: {
          margin: 0,
          padding: "16px 0"
        }
      });
      if ((A.filters || []).length === 0)
        return $e;
      if (f === "tree")
        return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(FilterSearch, {
          filterSearch: m,
          value: K,
          onChange: Y,
          tablePrefixCls: p,
          locale: S
        }), /* @__PURE__ */ reactExports.createElement("div", {
          className: `${p}-filter-dropdown-tree`
        }, y ? /* @__PURE__ */ reactExports.createElement(Checkbox$1, {
          checked: he.length === flattenKeys(A.filters).length,
          indeterminate: he.length > 0 && he.length < flattenKeys(A.filters).length,
          className: `${p}-filter-dropdown-checkall`,
          onChange: ie
        }, (we = S?.filterCheckall) !== null && we !== void 0 ? we : S?.filterCheckAll) : null, /* @__PURE__ */ reactExports.createElement(Tree, {
          checkable: !0,
          selectable: !1,
          blockNode: !0,
          multiple: y,
          checkStrictly: !y,
          className: `${x}-menu`,
          onCheck: H,
          checkedKeys: he,
          selectedKeys: he,
          showIcon: !1,
          treeData: fe({
            filters: A.filters
          }),
          autoExpandParent: !0,
          defaultExpandAll: !0,
          filterTreeNode: K.trim() ? (ce) => typeof m == "function" ? m(K, ge(ce)) : searchValueMatched(K, ce.title) : void 0
        })));
      const Ae = renderFilterItems({
        filters: A.filters || [],
        filterSearch: m,
        prefixCls: v,
        filteredKeys: N(),
        filterMultiple: y,
        searchValue: K
      }), ue = Ae.every((ce) => ce === null);
      return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(FilterSearch, {
        filterSearch: m,
        value: K,
        onChange: Y,
        tablePrefixCls: p,
        locale: S
      }), ue ? $e : /* @__PURE__ */ reactExports.createElement(Menu$1, {
        selectable: !0,
        multiple: y,
        prefixCls: `${x}-menu`,
        className: se,
        onSelect: D,
        onDeselect: D,
        selectedKeys: he,
        getPopupContainer: T,
        openKeys: V,
        onOpenChange: ne,
        items: Ae
      }));
    }, Ce = () => _ ? isEqual((E || []).map((xe) => String(xe)), he, !0) : he.length === 0;
    me = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, ye(), /* @__PURE__ */ reactExports.createElement("div", {
      className: `${v}-dropdown-btns`
    }, /* @__PURE__ */ reactExports.createElement(Button$1, {
      type: "link",
      size: "small",
      disabled: Ce(),
      onClick: () => J()
    }, S.filterReset), /* @__PURE__ */ reactExports.createElement(Button$1, {
      type: "primary",
      size: "small",
      onClick: Q
    }, S.filterConfirm)));
  }
  A.filterDropdown && (me = /* @__PURE__ */ reactExports.createElement(OverrideProvider, {
    selectable: void 0
  }, me)), me = /* @__PURE__ */ reactExports.createElement(FilterDropdownMenuWrapper, {
    className: `${v}-dropdown`
  }, me);
  const ve = mergeProps$1({
    trigger: ["click"],
    placement: pe === "rtl" ? "bottomLeft" : "bottomRight",
    children: (() => {
      let he;
      return typeof A.filterIcon == "function" ? he = A.filterIcon(j) : A.filterIcon ? he = A.filterIcon : he = /* @__PURE__ */ reactExports.createElement(RefIcon$9, null), /* @__PURE__ */ reactExports.createElement("span", {
        role: "button",
        tabIndex: -1,
        className: classnames(`${v}-trigger`, {
          active: j
        }),
        onClick: (ye) => {
          ye.stopPropagation();
        }
      }, he);
    })(),
    getPopupContainer: T
  }, Object.assign(Object.assign({}, R), {
    rootClassName: classnames(I, R.rootClassName),
    open: U,
    onOpenChange: ae,
    popupRender: () => typeof R?.dropdownRender == "function" ? R.dropdownRender(me) : me
  }));
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: `${v}-column`
  }, /* @__PURE__ */ reactExports.createElement("span", {
    className: `${p}-column-title`
  }, $), /* @__PURE__ */ reactExports.createElement(Dropdown, Object.assign({}, ve)));
}, collectFilterStates = (a, s, c) => {
  let u = [];
  return (a || []).forEach((d, p) => {
    var v;
    const A = getColumnPos(p, c), x = d.filterDropdown !== void 0;
    if (d.filters || x || "onFilter" in d)
      if ("filteredValue" in d) {
        let g = d.filteredValue;
        x || (g = (v = g?.map(String)) !== null && v !== void 0 ? v : g), u.push({
          column: d,
          key: getColumnKey(d, A),
          filteredKeys: g,
          forceFiltered: d.filtered
        });
      } else
        u.push({
          column: d,
          key: getColumnKey(d, A),
          filteredKeys: s && d.defaultFilteredValue ? d.defaultFilteredValue : void 0,
          forceFiltered: d.filtered
        });
    "children" in d && (u = [].concat(_toConsumableArray$e(u), _toConsumableArray$e(collectFilterStates(d.children, s, A))));
  }), u;
};
function injectFilter(a, s, c, u, d, p, v, A, x) {
  return c.map((g, b) => {
    const y = getColumnPos(b, A), {
      filterOnClose: f = !0,
      filterMultiple: m = !0,
      filterMode: C,
      filterSearch: w
    } = g;
    let S = g;
    if (S.filters || S.filterDropdown) {
      const $ = getColumnKey(S, y), T = u.find(({
        key: I
      }) => $ === I);
      S = Object.assign(Object.assign({}, S), {
        title: (I) => /* @__PURE__ */ reactExports.createElement(FilterDropdown, {
          tablePrefixCls: a,
          prefixCls: `${a}-filter`,
          dropdownPrefixCls: s,
          column: S,
          columnKey: $,
          filterState: T,
          filterOnClose: f,
          filterMultiple: m,
          filterMode: C,
          filterSearch: w,
          triggerFilter: p,
          locale: d,
          getPopupContainer: v,
          rootClassName: x
        }, renderColumnTitle(g.title, I))
      });
    }
    return "children" in S && (S = Object.assign(Object.assign({}, S), {
      children: injectFilter(a, s, S.children, u, d, p, v, y, x)
    })), S;
  });
}
const generateFilterInfo = (a) => {
  const s = {};
  return a.forEach(({
    key: c,
    filteredKeys: u,
    column: d
  }) => {
    const p = c, {
      filters: v,
      filterDropdown: A
    } = d;
    if (A)
      s[p] = u || null;
    else if (Array.isArray(u)) {
      const x = flattenKeys(v);
      s[p] = x.filter((g) => u.includes(String(g)));
    } else
      s[p] = null;
  }), s;
}, getFilterData = (a, s, c) => s.reduce((d, p) => {
  const {
    column: {
      onFilter: v,
      filters: A
    },
    filteredKeys: x
  } = p;
  return v && x && x.length ? d.map((g) => Object.assign({}, g)).filter((g) => x.some((b) => {
    const y = flattenKeys(A), f = y.findIndex((C) => String(C) === String(b)), m = f !== -1 ? y[f] : b;
    return g[c] && (g[c] = getFilterData(g[c], s, c)), v(m, g);
  })) : d;
}, a), getMergedColumns = (a) => a.flatMap((s) => "children" in s ? [s].concat(_toConsumableArray$e(getMergedColumns(s.children || []))) : [s]), useFilter = (a) => {
  const {
    prefixCls: s,
    dropdownPrefixCls: c,
    mergedColumns: u,
    onFilterChange: d,
    getPopupContainer: p,
    locale: v,
    rootClassName: A
  } = a;
  devUseWarning();
  const x = reactExports.useMemo(() => getMergedColumns(u || []), [u]), [g, b] = reactExports.useState(() => collectFilterStates(x, !0)), y = reactExports.useMemo(() => {
    const w = collectFilterStates(x, !1);
    if (w.length === 0)
      return w;
    let S = !0;
    if (w.forEach(({
      filteredKeys: $
    }) => {
      $ !== void 0 && (S = !1);
    }), S) {
      const $ = (x || []).map((T, I) => getColumnKey(T, getColumnPos(I)));
      return g.filter(({
        key: T
      }) => $.includes(T)).map((T) => {
        const I = x[$.findIndex((_) => _ === T.key)];
        return Object.assign(Object.assign({}, T), {
          column: Object.assign(Object.assign({}, T.column), I),
          forceFiltered: I.filtered
        });
      });
    }
    return w;
  }, [x, g]), f = reactExports.useMemo(() => generateFilterInfo(y), [y]), m = (w) => {
    const S = y.filter(({
      key: $
    }) => $ !== w.key);
    S.push(w), b(S), d(generateFilterInfo(S), S);
  };
  return [(w) => injectFilter(s, c, w, y, v, m, p, void 0, A), y, f];
}, useLazyKVMap = (a, s, c) => {
  const u = reactExports.useRef({});
  function d(p) {
    var v;
    if (!u.current || u.current.data !== a || u.current.childrenColumnName !== s || u.current.getRowKey !== c) {
      let x = function(g) {
        g.forEach((b, y) => {
          const f = c(b, y);
          A.set(f, b), b && typeof b == "object" && s in b && x(b[s] || []);
        });
      };
      const A = /* @__PURE__ */ new Map();
      x(a), u.current = {
        data: a,
        childrenColumnName: s,
        kvMap: A,
        getRowKey: c
      };
    }
    return (v = u.current.kvMap) === null || v === void 0 ? void 0 : v.get(p);
  }
  return [d];
};
var __rest$a = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const DEFAULT_PAGE_SIZE = 10;
function getPaginationParam(a, s) {
  const c = {
    current: a.current,
    pageSize: a.pageSize
  };
  return Object.keys(s && typeof s == "object" ? s : {}).forEach((d) => {
    const p = a[d];
    typeof p != "function" && (c[d] = p);
  }), c;
}
function usePagination(a, s, c) {
  const u = c && typeof c == "object" ? c : {}, {
    total: d = 0
  } = u, p = __rest$a(u, ["total"]), [v, A] = reactExports.useState(() => ({
    current: "defaultCurrent" in p ? p.defaultCurrent : 1,
    pageSize: "defaultPageSize" in p ? p.defaultPageSize : DEFAULT_PAGE_SIZE
  })), x = mergeProps$1(v, p, {
    total: d > 0 ? d : a
  }), g = Math.ceil((d || a) / x.pageSize);
  x.current > g && (x.current = g || 1);
  const b = (f, m) => {
    A({
      current: f ?? 1,
      pageSize: m || x.pageSize
    });
  }, y = (f, m) => {
    var C;
    c && ((C = c.onChange) === null || C === void 0 || C.call(c, f, m)), b(f, m), s(f, m || x?.pageSize);
  };
  return c === !1 ? [{}, () => {
  }] : [Object.assign(Object.assign({}, x), {
    onChange: y
  }), b];
}
const ASCEND = "ascend", DESCEND = "descend", getMultiplePriority = (a) => typeof a.sorter == "object" && typeof a.sorter.multiple == "number" ? a.sorter.multiple : !1, getSortFunction = (a) => typeof a == "function" ? a : a && typeof a == "object" && a.compare ? a.compare : !1, nextSortDirection = (a, s) => s ? a[a.indexOf(s) + 1] : a[0], collectSortStates = (a, s, c) => {
  let u = [];
  const d = (p, v) => {
    u.push({
      column: p,
      key: getColumnKey(p, v),
      multiplePriority: getMultiplePriority(p),
      sortOrder: p.sortOrder
    });
  };
  return (a || []).forEach((p, v) => {
    const A = getColumnPos(v, c);
    p.children ? ("sortOrder" in p && d(p, A), u = [].concat(_toConsumableArray$e(u), _toConsumableArray$e(collectSortStates(p.children, s, A)))) : p.sorter && ("sortOrder" in p ? d(p, A) : s && p.defaultSortOrder && u.push({
      column: p,
      key: getColumnKey(p, A),
      multiplePriority: getMultiplePriority(p),
      sortOrder: p.defaultSortOrder
    }));
  }), u;
}, injectSorter = (a, s, c, u, d, p, v, A) => (s || []).map((g, b) => {
  const y = getColumnPos(b, A);
  let f = g;
  if (f.sorter) {
    const m = f.sortDirections || d, C = f.showSorterTooltip === void 0 ? v : f.showSorterTooltip, w = getColumnKey(f, y), S = c.find(({
      key: B
    }) => B === w), $ = S ? S.sortOrder : null, T = nextSortDirection(m, $);
    let I;
    if (g.sortIcon)
      I = g.sortIcon({
        sortOrder: $
      });
    else {
      const B = m.includes(ASCEND) && /* @__PURE__ */ reactExports.createElement(RefIcon$h, {
        className: classnames(`${a}-column-sorter-up`, {
          active: $ === ASCEND
        })
      }), F = m.includes(DESCEND) && /* @__PURE__ */ reactExports.createElement(RefIcon$i, {
        className: classnames(`${a}-column-sorter-down`, {
          active: $ === DESCEND
        })
      });
      I = /* @__PURE__ */ reactExports.createElement("span", {
        className: classnames(`${a}-column-sorter`, {
          [`${a}-column-sorter-full`]: !!(B && F)
        })
      }, /* @__PURE__ */ reactExports.createElement("span", {
        className: `${a}-column-sorter-inner`,
        "aria-hidden": "true"
      }, B, F));
    }
    const {
      cancelSort: _,
      triggerAsc: E,
      triggerDesc: R
    } = p || {};
    let O = _;
    T === DESCEND ? O = R : T === ASCEND && (O = E);
    const L = typeof C == "object" ? Object.assign({
      title: O
    }, C) : {
      title: O
    };
    f = Object.assign(Object.assign({}, f), {
      className: classnames(f.className, {
        [`${a}-column-sort`]: $
      }),
      title: (B) => {
        const F = `${a}-column-sorters`, M = /* @__PURE__ */ reactExports.createElement("span", {
          className: `${a}-column-title`
        }, renderColumnTitle(g.title, B)), W = /* @__PURE__ */ reactExports.createElement("div", {
          className: F
        }, M, I);
        return C ? typeof C != "boolean" && C?.target === "sorter-icon" ? /* @__PURE__ */ reactExports.createElement("div", {
          className: `${F} ${a}-column-sorters-tooltip-target-sorter`
        }, M, /* @__PURE__ */ reactExports.createElement(Tooltip, Object.assign({}, L), I)) : /* @__PURE__ */ reactExports.createElement(Tooltip, Object.assign({}, L), W) : W;
      },
      onHeaderCell: (B) => {
        var F;
        const M = ((F = g.onHeaderCell) === null || F === void 0 ? void 0 : F.call(g, B)) || {}, W = M.onClick, j = M.onKeyDown;
        M.onClick = (k) => {
          u({
            column: g,
            key: w,
            sortOrder: T,
            multiplePriority: getMultiplePriority(g)
          }), W?.(k);
        }, M.onKeyDown = (k) => {
          k.keyCode === KeyCode.ENTER && (u({
            column: g,
            key: w,
            sortOrder: T,
            multiplePriority: getMultiplePriority(g)
          }), j?.(k));
        };
        const G = safeColumnTitle(g.title, {}), U = G?.toString();
        return $ && (M["aria-sort"] = $ === "ascend" ? "ascending" : "descending"), M["aria-label"] = U || "", M.className = classnames(M.className, `${a}-column-has-sorters`), M.tabIndex = 0, g.ellipsis && (M.title = (G ?? "").toString()), M;
      }
    });
  }
  return "children" in f && (f = Object.assign(Object.assign({}, f), {
    children: injectSorter(a, f.children, c, u, d, p, v, y)
  })), f;
}), stateToInfo = (a) => {
  const {
    column: s,
    sortOrder: c
  } = a;
  return {
    column: s,
    order: c,
    field: s.dataIndex,
    columnKey: s.key
  };
}, generateSorterInfo = (a) => {
  const s = a.filter(({
    sortOrder: c
  }) => c).map(stateToInfo);
  if (s.length === 0 && a.length) {
    const c = a.length - 1;
    return Object.assign(Object.assign({}, stateToInfo(a[c])), {
      column: void 0,
      order: void 0,
      field: void 0,
      columnKey: void 0
    });
  }
  return s.length <= 1 ? s[0] || {} : s;
}, getSortData = (a, s, c) => {
  const u = s.slice().sort((v, A) => A.multiplePriority - v.multiplePriority), d = a.slice(), p = u.filter(({
    column: {
      sorter: v
    },
    sortOrder: A
  }) => getSortFunction(v) && A);
  return p.length ? d.sort((v, A) => {
    for (let x = 0; x < p.length; x += 1) {
      const g = p[x], {
        column: {
          sorter: b
        },
        sortOrder: y
      } = g, f = getSortFunction(b);
      if (f && y) {
        const m = f(v, A, y);
        if (m !== 0)
          return y === ASCEND ? m : -m;
      }
    }
    return 0;
  }).map((v) => {
    const A = v[c];
    return A ? Object.assign(Object.assign({}, v), {
      [c]: getSortData(A, s, c)
    }) : v;
  }) : d;
}, useFilterSorter = (a) => {
  const {
    prefixCls: s,
    mergedColumns: c,
    sortDirections: u,
    tableLocale: d,
    showSorterTooltip: p,
    onSorterChange: v
  } = a, [A, x] = reactExports.useState(() => collectSortStates(c, !0)), g = (w, S) => {
    const $ = [];
    return w.forEach((T, I) => {
      const _ = getColumnPos(I, S);
      if ($.push(getColumnKey(T, _)), Array.isArray(T.children)) {
        const E = g(T.children, _);
        $.push.apply($, _toConsumableArray$e(E));
      }
    }), $;
  }, b = reactExports.useMemo(() => {
    let w = !0;
    const S = collectSortStates(c, !1);
    if (!S.length) {
      const _ = g(c);
      return A.filter(({
        key: E
      }) => _.includes(E));
    }
    const $ = [];
    function T(_) {
      w ? $.push(_) : $.push(Object.assign(Object.assign({}, _), {
        sortOrder: null
      }));
    }
    let I = null;
    return S.forEach((_) => {
      I === null ? (T(_), _.sortOrder && (_.multiplePriority === !1 ? w = !1 : I = !0)) : (I && _.multiplePriority !== !1 || (w = !1), T(_));
    }), $;
  }, [c, A]), y = reactExports.useMemo(() => {
    var w, S;
    const $ = b.map(({
      column: T,
      sortOrder: I
    }) => ({
      column: T,
      order: I
    }));
    return {
      sortColumns: $,
      // Legacy
      sortColumn: (w = $[0]) === null || w === void 0 ? void 0 : w.column,
      sortOrder: (S = $[0]) === null || S === void 0 ? void 0 : S.order
    };
  }, [b]), f = (w) => {
    let S;
    w.multiplePriority === !1 || !b.length || b[0].multiplePriority === !1 ? S = [w] : S = [].concat(_toConsumableArray$e(b.filter(({
      key: $
    }) => $ !== w.key)), [w]), x(S), v(generateSorterInfo(S), S);
  };
  return [(w) => injectSorter(s, w, b, f, u, d, p), b, y, () => generateSorterInfo(b)];
}, fillTitle = (a, s) => a.map((u) => {
  const d = Object.assign({}, u);
  return d.title = renderColumnTitle(u.title, s), "children" in d && (d.children = fillTitle(d.children, s)), d;
}), useTitleColumns = (a) => [reactExports.useCallback((c) => fillTitle(c, a), [a])], RcTable = genTable((a, s) => {
  const {
    _renderTimes: c
  } = a, {
    _renderTimes: u
  } = s;
  return c !== u;
}), RcVirtualTable = genVirtualTable((a, s) => {
  const {
    _renderTimes: c
  } = a, {
    _renderTimes: u
  } = s;
  return c !== u;
}), genBorderedStyle = (a) => {
  const {
    componentCls: s,
    lineWidth: c,
    lineType: u,
    tableBorderColor: d,
    tableHeaderBg: p,
    tablePaddingVertical: v,
    tablePaddingHorizontal: A,
    calc: x
  } = a, g = `${unit$1(c)} ${u} ${d}`, b = (y, f, m) => ({
    [`&${s}-${y}`]: {
      [`> ${s}-container`]: {
        [`> ${s}-content, > ${s}-body`]: {
          "\n            > table > tbody > tr > th,\n            > table > tbody > tr > td\n          ": {
            [`> ${s}-expanded-row-fixed`]: {
              margin: `${unit$1(x(f).mul(-1).equal())}
              ${unit$1(x(x(m).add(c)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${s}-wrapper`]: {
      [`${s}${s}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${s}-title`]: {
          border: g,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${s}-container`]: {
          borderInlineStart: g,
          borderTop: g,
          [`
            > ${s}-content,
            > ${s}-header,
            > ${s}-body,
            > ${s}-summary
          `]: {
            "> table": {
              // ============================= Cell =============================
              "\n                > thead > tr > th,\n                > thead > tr > td,\n                > tbody > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              ": {
                borderInlineEnd: g
              },
              // ============================ Header ============================
              "> thead": {
                "> tr:not(:last-child) > th": {
                  borderBottom: g
                },
                "> tr > th::before": {
                  backgroundColor: "transparent !important"
                }
              },
              // Fixed right should provides additional border
              "\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              ": {
                [`> ${s}-cell-fix-right-first::after`]: {
                  borderInlineEnd: g
                }
              },
              // ========================== Expandable ==========================
              "\n                > tbody > tr > th,\n                > tbody > tr > td\n              ": {
                [`> ${s}-expanded-row-fixed`]: {
                  margin: `${unit$1(x(v).mul(-1).equal())} ${unit$1(x(x(A).add(c)).mul(-1).equal())}`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: c,
                    bottom: 0,
                    borderInlineEnd: g,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${s}-scroll-horizontal`]: {
          [`> ${s}-container > ${s}-body`]: {
            "> table > tbody": {
              [`
                > tr${s}-expanded-row,
                > tr${s}-placeholder
              `]: {
                "> th, > td": {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, b("middle", a.tablePaddingVerticalMiddle, a.tablePaddingHorizontalMiddle)), b("small", a.tablePaddingVerticalSmall, a.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${s}-footer`]: {
          border: g,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${s}-cell`]: {
        [`${s}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        "&-scrollbar:not([rowspan])": {
          boxShadow: `0 ${unit$1(c)} 0 ${unit$1(c)} ${p}`
        }
      },
      [`${s}-bordered ${s}-cell-scrollbar`]: {
        borderInlineEnd: g
      }
    }
  };
}, genEllipsisStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-wrapper`]: {
      [`${s}-cell-ellipsis`]: Object.assign(Object.assign({}, textEllipsis), {
        wordBreak: "keep-all",
        // Fixed first or last should special process
        [`
          &${s}-cell-fix-left-last,
          &${s}-cell-fix-right-first
        `]: {
          overflow: "visible",
          [`${s}-cell-content`]: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        [`${s}-column-title`]: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "keep-all"
        }
      })
    }
  };
}, genEmptyStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-wrapper`]: {
      [`${s}-tbody > tr${s}-placeholder`]: {
        textAlign: "center",
        color: a.colorTextDisabled,
        "\n          &:hover > th,\n          &:hover > td,\n        ": {
          background: a.colorBgContainer
        }
      }
    }
  };
}, genExpandStyle = (a) => {
  const {
    componentCls: s,
    antCls: c,
    motionDurationSlow: u,
    lineWidth: d,
    paddingXS: p,
    lineType: v,
    tableBorderColor: A,
    tableExpandIconBg: x,
    tableExpandColumnWidth: g,
    borderRadius: b,
    tablePaddingVertical: y,
    tablePaddingHorizontal: f,
    tableExpandedRowBg: m,
    paddingXXS: C,
    expandIconMarginTop: w,
    expandIconSize: S,
    expandIconHalfInner: $,
    expandIconScale: T,
    calc: I
  } = a, _ = `${unit$1(d)} ${v} ${A}`, E = I(C).sub(d).equal();
  return {
    [`${s}-wrapper`]: {
      [`${s}-expand-icon-col`]: {
        width: g
      },
      [`${s}-row-expand-icon-cell`]: {
        textAlign: "center",
        [`${s}-row-expand-icon`]: {
          display: "inline-flex",
          float: "none",
          verticalAlign: "sub"
        }
      },
      [`${s}-row-indent`]: {
        height: 1,
        float: "left"
      },
      [`${s}-row-expand-icon`]: Object.assign(Object.assign({}, operationUnit(a)), {
        position: "relative",
        float: "left",
        width: S,
        height: S,
        color: "inherit",
        lineHeight: unit$1(S),
        background: x,
        border: _,
        borderRadius: b,
        transform: `scale(${T})`,
        "&:focus, &:hover, &:active": {
          borderColor: "currentcolor"
        },
        "&::before, &::after": {
          position: "absolute",
          background: "currentcolor",
          transition: `transform ${u} ease-out`,
          content: '""'
        },
        "&::before": {
          top: $,
          insetInlineEnd: E,
          insetInlineStart: E,
          height: d
        },
        "&::after": {
          top: E,
          bottom: E,
          insetInlineStart: $,
          width: d,
          transform: "rotate(90deg)"
        },
        // Motion effect
        "&-collapsed::before": {
          transform: "rotate(-180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        },
        "&-spaced": {
          "&::before, &::after": {
            display: "none",
            content: "none"
          },
          background: "transparent",
          border: 0,
          visibility: "hidden"
        }
      }),
      [`${s}-row-indent + ${s}-row-expand-icon`]: {
        marginTop: w,
        marginInlineEnd: p
      },
      [`tr${s}-expanded-row`]: {
        "&, &:hover": {
          "> th, > td": {
            background: m
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${c}-descriptions-view`]: {
          display: "flex",
          table: {
            flex: "auto",
            width: "100%"
          }
        }
      },
      // With fixed
      [`${s}-expanded-row-fixed`]: {
        position: "relative",
        margin: `${unit$1(I(y).mul(-1).equal())} ${unit$1(I(f).mul(-1).equal())}`,
        padding: `${unit$1(y)} ${unit$1(f)}`
      }
    }
  };
}, genFilterStyle = (a) => {
  const {
    componentCls: s,
    antCls: c,
    iconCls: u,
    tableFilterDropdownWidth: d,
    tableFilterDropdownSearchWidth: p,
    paddingXXS: v,
    paddingXS: A,
    colorText: x,
    lineWidth: g,
    lineType: b,
    tableBorderColor: y,
    headerIconColor: f,
    fontSizeSM: m,
    tablePaddingHorizontal: C,
    borderRadius: w,
    motionDurationSlow: S,
    colorIcon: $,
    colorPrimary: T,
    tableHeaderFilterActiveBg: I,
    colorTextDisabled: _,
    tableFilterDropdownBg: E,
    tableFilterDropdownHeight: R,
    controlItemBgHover: O,
    controlItemBgActive: L,
    boxShadowSecondary: B,
    filterDropdownMenuBg: F,
    calc: M
  } = a, W = `${c}-dropdown`, j = `${s}-filter-dropdown`, G = `${c}-tree`, U = `${unit$1(g)} ${b} ${y}`;
  return [
    {
      [`${s}-wrapper`]: {
        [`${s}-filter-column`]: {
          display: "flex",
          justifyContent: "space-between"
        },
        [`${s}-filter-trigger`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginBlock: M(v).mul(-1).equal(),
          marginInline: `${unit$1(v)} ${unit$1(M(C).div(2).mul(-1).equal())}`,
          padding: `0 ${unit$1(v)}`,
          color: f,
          fontSize: m,
          borderRadius: w,
          cursor: "pointer",
          transition: `all ${S}`,
          "&:hover": {
            color: $,
            background: I
          },
          "&.active": {
            color: T
          }
        }
      }
    },
    {
      // Dropdown
      [`${c}-dropdown`]: {
        [j]: Object.assign(Object.assign({}, resetComponent(a)), {
          minWidth: d,
          backgroundColor: E,
          borderRadius: w,
          boxShadow: B,
          overflow: "hidden",
          // Reset menu
          [`${W}-menu`]: {
            // https://github.com/ant-design/ant-design/issues/4916
            // https://github.com/ant-design/ant-design/issues/19542
            maxHeight: R,
            overflowX: "hidden",
            border: 0,
            boxShadow: "none",
            borderRadius: "unset",
            backgroundColor: F,
            "&:empty::after": {
              display: "block",
              padding: `${unit$1(A)} 0`,
              color: _,
              fontSize: m,
              textAlign: "center",
              content: '"Not Found"'
            }
          },
          [`${j}-tree`]: {
            paddingBlock: `${unit$1(A)} 0`,
            paddingInline: A,
            [G]: {
              padding: 0
            },
            [`${G}-treenode ${G}-node-content-wrapper:hover`]: {
              backgroundColor: O
            },
            [`${G}-treenode-checkbox-checked ${G}-node-content-wrapper`]: {
              "&, &:hover": {
                backgroundColor: L
              }
            }
          },
          [`${j}-search`]: {
            padding: A,
            borderBottom: U,
            "&-input": {
              input: {
                minWidth: p
              },
              [u]: {
                color: _
              }
            }
          },
          [`${j}-checkall`]: {
            width: "100%",
            marginBottom: v,
            marginInlineStart: v
          },
          // Operation
          [`${j}-btns`]: {
            display: "flex",
            justifyContent: "space-between",
            padding: `${unit$1(M(A).sub(g).equal())} ${unit$1(A)}`,
            overflow: "hidden",
            borderTop: U
          }
        })
      }
    },
    // Dropdown Menu & SubMenu
    {
      // submenu of table filter dropdown
      [`${c}-dropdown ${j}, ${j}-submenu`]: {
        // Checkbox
        [`${c}-checkbox-wrapper + span`]: {
          paddingInlineStart: A,
          color: x
        },
        "> ul": {
          maxHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    }
  ];
}, genFixedStyle = (a) => {
  const {
    componentCls: s,
    lineWidth: c,
    colorSplit: u,
    motionDurationSlow: d,
    zIndexTableFixed: p,
    tableBg: v,
    zIndexTableSticky: A,
    calc: x
  } = a, g = u;
  return {
    [`${s}-wrapper`]: {
      [`
        ${s}-cell-fix-left,
        ${s}-cell-fix-right
      `]: {
        position: "sticky !important",
        zIndex: p,
        background: v
      },
      [`
        ${s}-cell-fix-left-first::after,
        ${s}-cell-fix-left-last::after
      `]: {
        position: "absolute",
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: x(c).mul(-1).equal(),
        width: 30,
        transform: "translateX(100%)",
        transition: `box-shadow ${d}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${s}-cell-fix-left-all::after`]: {
        display: "none"
      },
      [`
        ${s}-cell-fix-right-first::after,
        ${s}-cell-fix-right-last::after
      `]: {
        position: "absolute",
        top: 0,
        bottom: x(c).mul(-1).equal(),
        left: {
          _skip_check_: !0,
          value: 0
        },
        width: 30,
        transform: "translateX(-100%)",
        transition: `box-shadow ${d}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${s}-container`]: {
        position: "relative",
        "&::before, &::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: x(A).add(1).equal({
            unit: !1
          }),
          width: 30,
          transition: `box-shadow ${d}`,
          content: '""',
          pointerEvents: "none"
        },
        "&::before": {
          insetInlineStart: 0
        },
        "&::after": {
          insetInlineEnd: 0
        }
      },
      [`${s}-ping-left`]: {
        [`&:not(${s}-has-fix-left) ${s}-container::before`]: {
          boxShadow: `inset 10px 0 8px -8px ${g}`
        },
        [`
          ${s}-cell-fix-left-first::after,
          ${s}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${g}`
        },
        [`${s}-cell-fix-left-last::before`]: {
          backgroundColor: "transparent !important"
        }
      },
      [`${s}-ping-right`]: {
        [`&:not(${s}-has-fix-right) ${s}-container::after`]: {
          boxShadow: `inset -10px 0 8px -8px ${g}`
        },
        [`
          ${s}-cell-fix-right-first::after,
          ${s}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${g}`
        }
      },
      // Gapped fixed Columns do not show the shadow
      [`${s}-fixed-column-gapped`]: {
        [`
        ${s}-cell-fix-left-first::after,
        ${s}-cell-fix-left-last::after,
        ${s}-cell-fix-right-first::after,
        ${s}-cell-fix-right-last::after
      `]: {
          boxShadow: "none"
        }
      }
    }
  };
}, genPaginationStyle = (a) => {
  const {
    componentCls: s,
    antCls: c,
    margin: u
  } = a;
  return {
    [`${s}-wrapper`]: {
      // ========================== Pagination ==========================
      [`${s}-pagination${c}-pagination`]: {
        margin: `${unit$1(u)} 0`
      },
      [`${s}-pagination`]: {
        display: "flex",
        flexWrap: "wrap",
        rowGap: a.paddingXS,
        "> *": {
          flex: "none"
        },
        "&-left": {
          justifyContent: "flex-start"
        },
        "&-center": {
          justifyContent: "center"
        },
        "&-right": {
          justifyContent: "flex-end"
        }
      }
    }
  };
}, genRadiusStyle = (a) => {
  const {
    componentCls: s,
    tableRadius: c
  } = a;
  return {
    [`${s}-wrapper`]: {
      [s]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${s}-title, ${s}-header`]: {
          borderRadius: `${unit$1(c)} ${unit$1(c)} 0 0`
        },
        [`${s}-title + ${s}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${s}-header, table`]: {
            borderRadius: 0
          },
          "table > thead > tr:first-child": {
            "th:first-child, th:last-child, td:first-child, td:last-child": {
              borderRadius: 0
            }
          }
        },
        "&-container": {
          borderStartStartRadius: c,
          borderStartEndRadius: c,
          "table > thead > tr:first-child": {
            "> *:first-child": {
              borderStartStartRadius: c
            },
            "> *:last-child": {
              borderStartEndRadius: c
            }
          }
        },
        "&-footer": {
          borderRadius: `0 0 ${unit$1(c)} ${unit$1(c)}`
        }
      }
    }
  };
}, genStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-wrapper-rtl`]: {
      direction: "rtl",
      table: {
        direction: "rtl"
      },
      [`${s}-pagination-left`]: {
        justifyContent: "flex-end"
      },
      [`${s}-pagination-right`]: {
        justifyContent: "flex-start"
      },
      [`${s}-row-expand-icon`]: {
        float: "right",
        "&::after": {
          transform: "rotate(-90deg)"
        },
        "&-collapsed::before": {
          transform: "rotate(180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        }
      },
      [`${s}-container`]: {
        "&::before": {
          insetInlineStart: "unset",
          insetInlineEnd: 0
        },
        "&::after": {
          insetInlineStart: 0,
          insetInlineEnd: "unset"
        },
        [`${s}-row-indent`]: {
          float: "right"
        }
      }
    }
  };
}, genSelectionStyle = (a) => {
  const {
    componentCls: s,
    antCls: c,
    iconCls: u,
    fontSizeIcon: d,
    padding: p,
    paddingXS: v,
    headerIconColor: A,
    headerIconHoverColor: x,
    tableSelectionColumnWidth: g,
    tableSelectedRowBg: b,
    tableSelectedRowHoverBg: y,
    tableRowHoverBg: f,
    tablePaddingHorizontal: m,
    calc: C
  } = a;
  return {
    [`${s}-wrapper`]: {
      // ========================== Selections ==========================
      [`${s}-selection-col`]: {
        width: g,
        [`&${s}-selection-col-with-dropdown`]: {
          width: C(g).add(d).add(C(p).div(4)).equal()
        }
      },
      [`${s}-bordered ${s}-selection-col`]: {
        width: C(g).add(C(v).mul(2)).equal(),
        [`&${s}-selection-col-with-dropdown`]: {
          width: C(g).add(d).add(C(p).div(4)).add(C(v).mul(2)).equal()
        }
      },
      [`
        table tr th${s}-selection-column,
        table tr td${s}-selection-column,
        ${s}-selection-column
      `]: {
        paddingInlineEnd: a.paddingXS,
        paddingInlineStart: a.paddingXS,
        textAlign: "center",
        [`${c}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${s}-selection-column${s}-cell-fix-left`]: {
        zIndex: C(a.zIndexTableFixed).add(1).equal({
          unit: !1
        })
      },
      [`table tr th${s}-selection-column::after`]: {
        backgroundColor: "transparent !important"
      },
      [`${s}-selection`]: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column"
      },
      [`${s}-selection-extra`]: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
        transition: `all ${a.motionDurationSlow}`,
        marginInlineStart: "100%",
        paddingInlineStart: unit$1(C(m).div(4).equal()),
        [u]: {
          color: A,
          fontSize: d,
          verticalAlign: "baseline",
          "&:hover": {
            color: x
          }
        }
      },
      // ============================= Rows =============================
      [`${s}-tbody`]: {
        [`${s}-row`]: {
          [`&${s}-row-selected`]: {
            [`> ${s}-cell`]: {
              background: b,
              "&-row-hover": {
                background: y
              }
            }
          },
          [`> ${s}-cell-row-hover`]: {
            background: f
          }
        }
      }
    }
  };
}, genSizeStyle = (a) => {
  const {
    componentCls: s,
    tableExpandColumnWidth: c,
    calc: u
  } = a, d = (p, v, A, x) => ({
    [`${s}${s}-${p}`]: {
      fontSize: x,
      [`
        ${s}-title,
        ${s}-footer,
        ${s}-cell,
        ${s}-thead > tr > th,
        ${s}-tbody > tr > th,
        ${s}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${unit$1(v)} ${unit$1(A)}`
      },
      [`${s}-filter-trigger`]: {
        marginInlineEnd: unit$1(u(A).div(2).mul(-1).equal())
      },
      [`${s}-expanded-row-fixed`]: {
        margin: `${unit$1(u(v).mul(-1).equal())} ${unit$1(u(A).mul(-1).equal())}`
      },
      [`${s}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${s}-wrapper:only-child ${s}`]: {
          marginBlock: unit$1(u(v).mul(-1).equal()),
          marginInline: `${unit$1(u(c).sub(A).equal())} ${unit$1(u(A).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${s}-selection-extra`]: {
        paddingInlineStart: unit$1(u(A).div(4).equal())
      }
    }
  });
  return {
    [`${s}-wrapper`]: Object.assign(Object.assign({}, d("middle", a.tablePaddingVerticalMiddle, a.tablePaddingHorizontalMiddle, a.tableFontSizeMiddle)), d("small", a.tablePaddingVerticalSmall, a.tablePaddingHorizontalSmall, a.tableFontSizeSmall))
  };
}, genSorterStyle = (a) => {
  const {
    componentCls: s,
    marginXXS: c,
    fontSizeIcon: u,
    headerIconColor: d,
    headerIconHoverColor: p
  } = a;
  return {
    [`${s}-wrapper`]: {
      [`${s}-thead th${s}-column-has-sorters`]: {
        outline: "none",
        cursor: "pointer",
        // why left 0s? Avoid column header move with transition when left is changed
        // https://github.com/ant-design/ant-design/issues/50588
        transition: `all ${a.motionDurationSlow}, left 0s`,
        "&:hover": {
          background: a.tableHeaderSortHoverBg,
          "&::before": {
            backgroundColor: "transparent !important"
          }
        },
        "&:focus-visible": {
          color: a.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${s}-cell-fix-left:hover,
          &${s}-cell-fix-right:hover
        `]: {
          background: a.tableFixedHeaderSortActiveBg
        }
      },
      [`${s}-thead th${s}-column-sort`]: {
        background: a.tableHeaderSortBg,
        "&::before": {
          backgroundColor: "transparent !important"
        }
      },
      [`td${s}-column-sort`]: {
        background: a.tableBodySortBg
      },
      [`${s}-column-title`]: {
        position: "relative",
        zIndex: 1,
        flex: 1,
        minWidth: 0
      },
      [`${s}-column-sorters`]: {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        justifyContent: "space-between",
        "&::after": {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          content: '""'
        }
      },
      [`${s}-column-sorters-tooltip-target-sorter`]: {
        "&::after": {
          content: "none"
        }
      },
      [`${s}-column-sorter`]: {
        marginInlineStart: c,
        color: d,
        fontSize: 0,
        transition: `color ${a.motionDurationSlow}`,
        "&-inner": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center"
        },
        "&-up, &-down": {
          fontSize: u,
          "&.active": {
            color: a.colorPrimary
          }
        },
        [`${s}-column-sorter-up + ${s}-column-sorter-down`]: {
          marginTop: "-0.3em"
        }
      },
      [`${s}-column-sorters:hover ${s}-column-sorter`]: {
        color: p
      }
    }
  };
}, genStickyStyle = (a) => {
  const {
    componentCls: s,
    opacityLoading: c,
    tableScrollThumbBg: u,
    tableScrollThumbBgHover: d,
    tableScrollThumbSize: p,
    tableScrollBg: v,
    zIndexTableSticky: A,
    stickyScrollBarBorderRadius: x,
    lineWidth: g,
    lineType: b,
    tableBorderColor: y
  } = a, f = `${unit$1(g)} ${b} ${y}`;
  return {
    [`${s}-wrapper`]: {
      [`${s}-sticky`]: {
        "&-holder": {
          position: "sticky",
          zIndex: A,
          background: a.colorBgContainer
        },
        "&-scroll": {
          position: "sticky",
          bottom: 0,
          height: `${unit$1(p)} !important`,
          zIndex: A,
          display: "flex",
          alignItems: "center",
          background: v,
          borderTop: f,
          opacity: c,
          "&:hover": {
            transformOrigin: "center bottom"
          },
          // fake scrollbar style of sticky
          "&-bar": {
            height: p,
            backgroundColor: u,
            borderRadius: x,
            transition: `all ${a.motionDurationSlow}, transform 0s`,
            position: "absolute",
            bottom: 0,
            "&:hover, &-active": {
              backgroundColor: d
            }
          }
        }
      }
    }
  };
}, genSummaryStyle = (a) => {
  const {
    componentCls: s,
    lineWidth: c,
    tableBorderColor: u,
    calc: d
  } = a, p = `${unit$1(c)} ${a.lineType} ${u}`;
  return {
    [`${s}-wrapper`]: {
      [`${s}-summary`]: {
        position: "relative",
        zIndex: a.zIndexTableFixed,
        background: a.tableBg,
        "> tr": {
          "> th, > td": {
            borderBottom: p
          }
        }
      },
      [`div${s}-summary`]: {
        boxShadow: `0 ${unit$1(d(c).mul(-1).equal())} 0 ${u}`
      }
    }
  };
}, genVirtualStyle = (a) => {
  const {
    componentCls: s,
    motionDurationMid: c,
    lineWidth: u,
    lineType: d,
    tableBorderColor: p,
    calc: v
  } = a, A = `${unit$1(u)} ${d} ${p}`, x = `${s}-expanded-row-cell`;
  return {
    [`${s}-wrapper`]: {
      // ========================== Row ==========================
      [`${s}-tbody-virtual`]: {
        [`${s}-tbody-virtual-holder-inner`]: {
          [`
            & > ${s}-row, 
            & > div:not(${s}-row) > ${s}-row
          `]: {
            display: "flex",
            boxSizing: "border-box",
            width: "100%"
          }
        },
        [`${s}-cell`]: {
          borderBottom: A,
          transition: `background ${c}`
        },
        [`${s}-expanded-row`]: {
          [`${x}${x}-fixed`]: {
            position: "sticky",
            insetInlineStart: 0,
            overflow: "hidden",
            width: `calc(var(--virtual-width) - ${unit$1(u)})`,
            borderInlineEnd: "none"
          }
        }
      },
      // ======================== Border =========================
      [`${s}-bordered`]: {
        [`${s}-tbody-virtual`]: {
          "&:after": {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: A,
            position: "absolute"
          },
          [`${s}-cell`]: {
            borderInlineEnd: A,
            [`&${s}-cell-fix-right-first:before`]: {
              content: '""',
              position: "absolute",
              insetBlock: 0,
              insetInlineStart: v(u).mul(-1).equal(),
              borderInlineStart: A
            }
          }
        },
        // Empty placeholder
        [`&${s}-virtual`]: {
          [`${s}-placeholder ${s}-cell`]: {
            borderInlineEnd: A,
            borderBottom: A
          }
        }
      }
    }
  };
}, genTableStyle = (a) => {
  const {
    componentCls: s,
    fontWeightStrong: c,
    tablePaddingVertical: u,
    tablePaddingHorizontal: d,
    tableExpandColumnWidth: p,
    lineWidth: v,
    lineType: A,
    tableBorderColor: x,
    tableFontSize: g,
    tableBg: b,
    tableRadius: y,
    tableHeaderTextColor: f,
    motionDurationMid: m,
    tableHeaderBg: C,
    tableHeaderCellSplitColor: w,
    tableFooterTextColor: S,
    tableFooterBg: $,
    calc: T
  } = a, I = `${unit$1(v)} ${A} ${x}`;
  return {
    [`${s}-wrapper`]: Object.assign(Object.assign({
      clear: "both",
      maxWidth: "100%",
      // fix https://github.com/ant-design/ant-design/issues/46177
      "--rc-virtual-list-scrollbar-bg": a.tableScrollBg
    }, clearFix()), {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        fontSize: g,
        background: b,
        borderRadius: `${unit$1(y)} ${unit$1(y)} 0 0`,
        // https://github.com/ant-design/ant-design/issues/47486
        scrollbarColor: `${a.tableScrollThumbBg} ${a.tableScrollBg}`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: "100%",
        textAlign: "start",
        borderRadius: `${unit$1(y)} ${unit$1(y)} 0 0`,
        borderCollapse: "separate",
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${s}-cell,
          ${s}-thead > tr > th,
          ${s}-tbody > tr > th,
          ${s}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: "relative",
        padding: `${unit$1(u)} ${unit$1(d)}`,
        overflowWrap: "break-word"
      },
      // ============================ Title =============================
      [`${s}-title`]: {
        padding: `${unit$1(u)} ${unit$1(d)}`
      },
      // ============================ Header ============================
      [`${s}-thead`]: {
        "\n          > tr > th,\n          > tr > td\n        ": {
          position: "relative",
          color: f,
          fontWeight: c,
          textAlign: "start",
          background: C,
          borderBottom: I,
          transition: `background ${m} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: "center"
          },
          [`&:not(:last-child):not(${s}-selection-column):not(${s}-row-expand-icon-cell):not([colspan])::before`]: {
            position: "absolute",
            top: "50%",
            insetInlineEnd: 0,
            width: 1,
            height: "1.6em",
            backgroundColor: w,
            transform: "translateY(-50%)",
            transition: `background-color ${m}`,
            content: '""'
          }
        },
        "> tr:not(:last-child) > th[colspan]": {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${s}-tbody`]: {
        "> tr": {
          "> th, > td": {
            transition: `background ${m}, border-color ${m}`,
            borderBottom: I,
            // ========================= Nest Table ===========================
            [`
              > ${s}-wrapper:only-child,
              > ${s}-expanded-row-fixed > ${s}-wrapper:only-child
            `]: {
              [s]: {
                marginBlock: unit$1(T(u).mul(-1).equal()),
                marginInline: `${unit$1(T(p).sub(d).equal())}
                ${unit$1(T(d).mul(-1).equal())}`,
                [`${s}-tbody > tr:last-child > td`]: {
                  borderBottomWidth: 0,
                  "&:first-child, &:last-child": {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          "> th": {
            position: "relative",
            color: f,
            fontWeight: c,
            textAlign: "start",
            background: C,
            borderBottom: I,
            transition: `background ${m} ease`
          }
        }
      },
      // ============================ Footer ============================
      [`${s}-footer`]: {
        padding: `${unit$1(u)} ${unit$1(d)}`,
        color: S,
        background: $
      }
    })
  };
}, prepareComponentToken$2 = (a) => {
  const {
    colorFillAlter: s,
    colorBgContainer: c,
    colorTextHeading: u,
    colorFillSecondary: d,
    colorFillContent: p,
    controlItemBgActive: v,
    controlItemBgActiveHover: A,
    padding: x,
    paddingSM: g,
    paddingXS: b,
    colorBorderSecondary: y,
    borderRadiusLG: f,
    controlHeight: m,
    colorTextPlaceholder: C,
    fontSize: w,
    fontSizeSM: S,
    lineHeight: $,
    lineWidth: T,
    colorIcon: I,
    colorIconHover: _,
    opacityLoading: E,
    controlInteractiveSize: R
  } = a, O = new FastColor(d).onBackground(c).toHexString(), L = new FastColor(p).onBackground(c).toHexString(), B = new FastColor(s).onBackground(c).toHexString(), F = new FastColor(I), M = new FastColor(_), W = R / 2 - T, j = W * 2 + T * 3;
  return {
    headerBg: B,
    headerColor: u,
    headerSortActiveBg: O,
    headerSortHoverBg: L,
    bodySortBg: B,
    rowHoverBg: B,
    rowSelectedBg: v,
    rowSelectedHoverBg: A,
    rowExpandedBg: s,
    cellPaddingBlock: x,
    cellPaddingInline: x,
    cellPaddingBlockMD: g,
    cellPaddingInlineMD: b,
    cellPaddingBlockSM: b,
    cellPaddingInlineSM: b,
    borderColor: y,
    headerBorderRadius: f,
    footerBg: B,
    footerColor: u,
    cellFontSize: w,
    cellFontSizeMD: w,
    cellFontSizeSM: w,
    headerSplitColor: y,
    fixedHeaderSortActiveBg: O,
    headerFilterHoverBg: p,
    filterDropdownMenuBg: c,
    filterDropdownBg: c,
    expandIconBg: c,
    selectionColumnWidth: m,
    stickyScrollBarBg: C,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (w * $ - T * 3) / 2 - Math.ceil((S * 1.4 - T * 3) / 2),
    headerIconColor: F.clone().setA(F.a * E).toRgbString(),
    headerIconHoverColor: M.clone().setA(M.a * E).toRgbString(),
    expandIconHalfInner: W,
    expandIconSize: j,
    expandIconScale: R / j
  };
}, zIndexTableFixed = 2, useStyle$2 = genStyleHooks("Table", (a) => {
  const {
    colorTextHeading: s,
    colorSplit: c,
    colorBgContainer: u,
    controlInteractiveSize: d,
    headerBg: p,
    headerColor: v,
    headerSortActiveBg: A,
    headerSortHoverBg: x,
    bodySortBg: g,
    rowHoverBg: b,
    rowSelectedBg: y,
    rowSelectedHoverBg: f,
    rowExpandedBg: m,
    cellPaddingBlock: C,
    cellPaddingInline: w,
    cellPaddingBlockMD: S,
    cellPaddingInlineMD: $,
    cellPaddingBlockSM: T,
    cellPaddingInlineSM: I,
    borderColor: _,
    footerBg: E,
    footerColor: R,
    headerBorderRadius: O,
    cellFontSize: L,
    cellFontSizeMD: B,
    cellFontSizeSM: F,
    headerSplitColor: M,
    fixedHeaderSortActiveBg: W,
    headerFilterHoverBg: j,
    filterDropdownBg: G,
    expandIconBg: U,
    selectionColumnWidth: k,
    stickyScrollBarBg: N,
    calc: P
  } = a, D = merge(a, {
    tableFontSize: L,
    tableBg: u,
    tableRadius: O,
    tablePaddingVertical: C,
    tablePaddingHorizontal: w,
    tablePaddingVerticalMiddle: S,
    tablePaddingHorizontalMiddle: $,
    tablePaddingVerticalSmall: T,
    tablePaddingHorizontalSmall: I,
    tableBorderColor: _,
    tableHeaderTextColor: v,
    tableHeaderBg: p,
    tableFooterTextColor: R,
    tableFooterBg: E,
    tableHeaderCellSplitColor: M,
    tableHeaderSortBg: A,
    tableHeaderSortHoverBg: x,
    tableBodySortBg: g,
    tableFixedHeaderSortActiveBg: W,
    tableHeaderFilterActiveBg: j,
    tableFilterDropdownBg: G,
    tableRowHoverBg: b,
    tableSelectedRowBg: y,
    tableSelectedRowHoverBg: f,
    zIndexTableFixed,
    zIndexTableSticky: P(zIndexTableFixed).add(1).equal({
      unit: !1
    }),
    tableFontSizeMiddle: B,
    tableFontSizeSmall: F,
    tableSelectionColumnWidth: k,
    tableExpandIconBg: U,
    tableExpandColumnWidth: P(d).add(P(a.padding).mul(2)).equal(),
    tableExpandedRowBg: m,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: N,
    tableScrollThumbBgHover: s,
    tableScrollBg: c
  });
  return [genTableStyle(D), genPaginationStyle(D), genSummaryStyle(D), genSorterStyle(D), genFilterStyle(D), genBorderedStyle(D), genRadiusStyle(D), genExpandStyle(D), genSummaryStyle(D), genEmptyStyle(D), genSelectionStyle(D), genFixedStyle(D), genStickyStyle(D), genEllipsisStyle(D), genSizeStyle(D), genStyle(D), genVirtualStyle(D)];
}, prepareComponentToken$2, {
  unitless: {
    expandIconScale: !0
  }
}), EMPTY_LIST = [], InternalTable = (a, s) => {
  var c, u;
  const {
    prefixCls: d,
    className: p,
    rootClassName: v,
    style: A,
    size: x,
    bordered: g,
    dropdownPrefixCls: b,
    dataSource: y,
    pagination: f,
    rowSelection: m,
    rowKey: C = "key",
    rowClassName: w,
    columns: S,
    children: $,
    childrenColumnName: T,
    onChange: I,
    getPopupContainer: _,
    loading: E,
    expandIcon: R,
    expandable: O,
    expandedRowRender: L,
    expandIconColumnIndex: B,
    indentSize: F,
    scroll: M,
    sortDirections: W,
    locale: j,
    showSorterTooltip: G = {
      target: "full-header"
    },
    virtual: U
  } = a;
  devUseWarning();
  const k = reactExports.useMemo(() => S || convertChildrenToColumns($), [S, $]), N = reactExports.useMemo(() => k.some((dt) => dt.responsive), [k]), P = useBreakpoint(N), D = reactExports.useMemo(() => {
    const dt = new Set(Object.keys(P).filter((mt) => P[mt]));
    return k.filter((mt) => !mt.responsive || mt.responsive.some((pt) => dt.has(pt)));
  }, [k, P]), H = omit(a, ["className", "style", "columns"]), {
    locale: V = localeValues,
    direction: Z,
    table: ne,
    renderEmpty: K,
    getPrefixCls: q,
    getPopupContainer: Y
  } = reactExports.useContext(ConfigContext$1), ee = useSize(x), Q = Object.assign(Object.assign({}, V.Table), j), J = y || EMPTY_LIST, te = q("table", d), ae = q("dropdown", b), [, se] = useToken$1(), ie = useCSSVarCls(te), [fe, ge, me] = useStyle$2(te, ie), pe = Object.assign(Object.assign({
    childrenColumnName: T,
    expandIconColumnIndex: B
  }, O), {
    expandIcon: (c = O?.expandIcon) !== null && c !== void 0 ? c : (u = ne?.expandable) === null || u === void 0 ? void 0 : u.expandIcon
  }), {
    childrenColumnName: be = "children"
  } = pe, le = reactExports.useMemo(() => J.some((dt) => dt?.[be]) ? "nest" : L || O?.expandedRowRender ? "row" : null, [J]), ve = {
    body: reactExports.useRef(null)
  }, he = useContainerWidth(te), ye = reactExports.useRef(null), Ce = reactExports.useRef(null);
  useProxyImperativeHandle(s, () => Object.assign(Object.assign({}, Ce.current), {
    nativeElement: ye.current
  }));
  const xe = reactExports.useMemo(() => typeof C == "function" ? C : (dt) => dt?.[C], [C]), [we] = useLazyKVMap(J, be, xe), $e = {}, Ae = (dt, mt, pt = !1) => {
    var Et, Mt, Nt, _t;
    const Ot = Object.assign(Object.assign({}, $e), dt);
    pt && ((Et = $e.resetPagination) === null || Et === void 0 || Et.call($e), !((Mt = Ot.pagination) === null || Mt === void 0) && Mt.current && (Ot.pagination.current = 1), f && ((Nt = f.onChange) === null || Nt === void 0 || Nt.call(f, 1, (_t = Ot.pagination) === null || _t === void 0 ? void 0 : _t.pageSize))), M && M.scrollToFirstRowOnChange !== !1 && ve.body.current && scrollTo(0, {
      getContainer: () => ve.body.current
    }), I?.(Ot.pagination, Ot.filters, Ot.sorter, {
      currentDataSource: getFilterData(getSortData(J, Ot.sorterStates, be), Ot.filterStates, be),
      action: mt
    });
  }, ue = (dt, mt) => {
    Ae({
      sorter: dt,
      sorterStates: mt
    }, "sort", !1);
  }, [ce, Ee, _e, Te] = useFilterSorter({
    prefixCls: te,
    mergedColumns: D,
    onSorterChange: ue,
    sortDirections: W || ["ascend", "descend"],
    tableLocale: Q,
    showSorterTooltip: G
  }), ke = reactExports.useMemo(() => getSortData(J, Ee, be), [J, Ee]);
  $e.sorter = Te(), $e.sorterStates = Ee;
  const Re = (dt, mt) => {
    Ae({
      filters: dt,
      filterStates: mt
    }, "filter", !0);
  }, [Be, Oe, Me] = useFilter({
    prefixCls: te,
    locale: Q,
    dropdownPrefixCls: ae,
    mergedColumns: D,
    onFilterChange: Re,
    getPopupContainer: _ || Y,
    rootClassName: classnames(v, ie)
  }), Fe = getFilterData(ke, Oe, be);
  $e.filters = Me, $e.filterStates = Oe;
  const Ue = reactExports.useMemo(() => {
    const dt = {};
    return Object.keys(Me).forEach((mt) => {
      Me[mt] !== null && (dt[mt] = Me[mt]);
    }), Object.assign(Object.assign({}, _e), {
      filters: dt
    });
  }, [_e, Me]), [je] = useTitleColumns(Ue), Le = (dt, mt) => {
    Ae({
      pagination: Object.assign(Object.assign({}, $e.pagination), {
        current: dt,
        pageSize: mt
      })
    }, "paginate");
  }, [De, Ne] = usePagination(Fe.length, Le, f);
  $e.pagination = f === !1 ? {} : getPaginationParam(De, f), $e.resetPagination = Ne;
  const Ge = reactExports.useMemo(() => {
    if (f === !1 || !De.pageSize)
      return Fe;
    const {
      current: dt = 1,
      total: mt,
      pageSize: pt = DEFAULT_PAGE_SIZE
    } = De;
    return Fe.length < mt ? Fe.length > pt ? Fe.slice((dt - 1) * pt, dt * pt) : Fe : Fe.slice((dt - 1) * pt, dt * pt);
  }, [!!f, Fe, De?.current, De?.pageSize, De?.total]), [Xe, nt] = useSelection({
    prefixCls: te,
    data: Fe,
    pageData: Ge,
    getRowKey: xe,
    getRecordByKey: we,
    expandType: le,
    childrenColumnName: be,
    locale: Q,
    getPopupContainer: _ || Y
  }, m), ct = (dt, mt, pt) => {
    let Et;
    return typeof w == "function" ? Et = classnames(w(dt, mt, pt)) : Et = classnames(w), classnames({
      [`${te}-row-selected`]: nt.has(xe(dt, mt))
    }, Et);
  };
  pe.__PARENT_RENDER_ICON__ = pe.expandIcon, pe.expandIcon = pe.expandIcon || R || renderExpandIcon(Q), le === "nest" && pe.expandIconColumnIndex === void 0 ? pe.expandIconColumnIndex = m ? 1 : 0 : pe.expandIconColumnIndex > 0 && m && (pe.expandIconColumnIndex -= 1), typeof pe.indentSize != "number" && (pe.indentSize = typeof F == "number" ? F : 15);
  const it = reactExports.useCallback((dt) => je(Xe(Be(ce(dt)))), [ce, Be, Xe]);
  let We, Ve;
  if (f !== !1 && De?.total) {
    let dt;
    De.size ? dt = De.size : dt = ee === "small" || ee === "middle" ? "small" : void 0;
    const mt = (Mt) => /* @__PURE__ */ reactExports.createElement(Pagination, Object.assign({}, De, {
      className: classnames(`${te}-pagination ${te}-pagination-${Mt}`, De.className),
      size: dt
    })), pt = Z === "rtl" ? "left" : "right", {
      position: Et
    } = De;
    if (Et !== null && Array.isArray(Et)) {
      const Mt = Et.find((Ot) => Ot.includes("top")), Nt = Et.find((Ot) => Ot.includes("bottom")), _t = Et.every((Ot) => `${Ot}` == "none");
      !Mt && !Nt && !_t && (Ve = mt(pt)), Mt && (We = mt(Mt.toLowerCase().replace("top", ""))), Nt && (Ve = mt(Nt.toLowerCase().replace("bottom", "")));
    } else
      Ve = mt(pt);
  }
  let ut;
  typeof E == "boolean" ? ut = {
    spinning: E
  } : typeof E == "object" && (ut = Object.assign({
    spinning: !0
  }, E));
  const at = classnames(me, ie, `${te}-wrapper`, ne?.className, {
    [`${te}-wrapper-rtl`]: Z === "rtl"
  }, p, v, ge), Qe = Object.assign(Object.assign({}, ne?.style), A), st = typeof j?.emptyText < "u" ? j.emptyText : K?.("Table") || /* @__PURE__ */ reactExports.createElement(DefaultRenderEmpty, {
    componentName: "Table"
  }), ft = U ? RcVirtualTable : RcTable, vt = {}, Pt = reactExports.useMemo(() => {
    const {
      fontSize: dt,
      lineHeight: mt,
      lineWidth: pt,
      padding: Et,
      paddingXS: Mt,
      paddingSM: Nt
    } = se, _t = Math.floor(dt * mt);
    switch (ee) {
      case "middle":
        return Nt * 2 + _t + pt;
      case "small":
        return Mt * 2 + _t + pt;
      default:
        return Et * 2 + _t + pt;
    }
  }, [se, ee]);
  return U && (vt.listItemHeight = Pt), fe(/* @__PURE__ */ reactExports.createElement("div", {
    ref: ye,
    className: at,
    style: Qe
  }, /* @__PURE__ */ reactExports.createElement(Spin, Object.assign({
    spinning: !1
  }, ut), We, /* @__PURE__ */ reactExports.createElement(ft, Object.assign({}, vt, H, {
    ref: Ce,
    columns: D,
    direction: Z,
    expandable: pe,
    prefixCls: te,
    className: classnames({
      [`${te}-middle`]: ee === "middle",
      [`${te}-small`]: ee === "small",
      [`${te}-bordered`]: g,
      [`${te}-empty`]: J.length === 0
    }, me, ie, ge),
    data: Ge,
    rowKey: xe,
    rowClassName: ct,
    emptyText: st,
    // Internal
    internalHooks: INTERNAL_HOOKS,
    internalRefs: ve,
    transformColumns: it,
    getContainerWidth: he
  })), Ve)));
}, InternalTable$1 = /* @__PURE__ */ reactExports.forwardRef(InternalTable), Table = (a, s) => {
  const c = reactExports.useRef(0);
  return c.current += 1, /* @__PURE__ */ reactExports.createElement(InternalTable$1, Object.assign({}, a, {
    ref: s,
    _renderTimes: c.current
  }));
}, ForwardTable = /* @__PURE__ */ reactExports.forwardRef(Table);
ForwardTable.SELECTION_COLUMN = SELECTION_COLUMN;
ForwardTable.EXPAND_COLUMN = EXPAND_COLUMN;
ForwardTable.SELECTION_ALL = SELECTION_ALL;
ForwardTable.SELECTION_INVERT = SELECTION_INVERT;
ForwardTable.SELECTION_NONE = SELECTION_NONE;
ForwardTable.Column = Column;
ForwardTable.ColumnGroup = ColumnGroup;
ForwardTable.Summary = FooterComponents;
const getDesignToken = (a) => {
  const s = a?.algorithm ? createTheme(a.algorithm) : defaultTheme$1, c = Object.assign(Object.assign({}, seedToken), a?.token);
  return getComputedToken$1(c, {
    override: a?.token
  }, s, formatToken);
};
function genSizeMapToken(a) {
  const {
    sizeUnit: s,
    sizeStep: c
  } = a, u = c - 2;
  return {
    sizeXXL: s * (u + 10),
    sizeXL: s * (u + 6),
    sizeLG: s * (u + 2),
    sizeMD: s * (u + 2),
    sizeMS: s * (u + 1),
    size: s * u,
    sizeSM: s * u,
    sizeXS: s * (u - 1),
    sizeXXS: s * (u - 1)
  };
}
const derivative$1 = (a, s) => {
  const c = s ?? derivative$2(a), u = c.fontSizeSM, d = c.controlHeight - 4;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, c), genSizeMapToken(s ?? a)), genFontMapToken(u)), {
    // controlHeight
    controlHeight: d
  }), genControlHeight(Object.assign(Object.assign({}, c), {
    controlHeight: d
  })));
}, getAlphaColor = (a, s) => new FastColor(a).setA(s).toRgbString(), getSolidColor = (a, s) => new FastColor(a).lighten(s).toHexString(), generateColorPalettes = (a) => {
  const s = generate$2(a, {
    theme: "dark"
  });
  return {
    1: s[0],
    2: s[1],
    3: s[2],
    4: s[3],
    5: s[6],
    6: s[5],
    7: s[4],
    8: s[6],
    9: s[5],
    10: s[4]
    // 8: colors[9],
    // 9: colors[8],
    // 10: colors[7],
  };
}, generateNeutralColorPalettes = (a, s) => {
  const c = a || "#000", u = s || "#fff";
  return {
    colorBgBase: c,
    colorTextBase: u,
    colorText: getAlphaColor(u, 0.85),
    colorTextSecondary: getAlphaColor(u, 0.65),
    colorTextTertiary: getAlphaColor(u, 0.45),
    colorTextQuaternary: getAlphaColor(u, 0.25),
    colorFill: getAlphaColor(u, 0.18),
    colorFillSecondary: getAlphaColor(u, 0.12),
    colorFillTertiary: getAlphaColor(u, 0.08),
    colorFillQuaternary: getAlphaColor(u, 0.04),
    colorBgSolid: getAlphaColor(u, 0.95),
    colorBgSolidHover: getAlphaColor(u, 1),
    colorBgSolidActive: getAlphaColor(u, 0.9),
    colorBgElevated: getSolidColor(c, 12),
    colorBgContainer: getSolidColor(c, 8),
    colorBgLayout: getSolidColor(c, 0),
    colorBgSpotlight: getSolidColor(c, 26),
    colorBgBlur: getAlphaColor(u, 0.04),
    colorBorder: getSolidColor(c, 26),
    colorBorderSecondary: getSolidColor(c, 19)
  };
}, derivative = (a, s) => {
  const c = Object.keys(defaultPresetColors).map((p) => {
    const v = generate$2(a[p], {
      theme: "dark"
    });
    return Array.from({
      length: 10
    }, () => 1).reduce((A, x, g) => (A[`${p}-${g + 1}`] = v[g], A[`${p}${g + 1}`] = v[g], A), {});
  }).reduce((p, v) => (p = Object.assign(Object.assign({}, p), v), p), {}), u = s ?? derivative$2(a), d = genColorMapToken(a, {
    generateColorPalettes,
    generateNeutralColorPalettes
  });
  return Object.assign(Object.assign(Object.assign(Object.assign({}, u), c), d), {
    // Customize selected item background color
    // https://github.com/ant-design/ant-design/issues/30524#issuecomment-871961867
    colorPrimaryBg: d.colorPrimaryBorder,
    colorPrimaryBgHover: d.colorPrimaryBorderHover
  });
};
function useToken() {
  const [a, s, c] = useToken$1();
  return {
    theme: a,
    token: s,
    hashId: c
  };
}
const theme = {
  /** Default seedToken */
  defaultSeed: defaultConfig.token,
  useToken,
  defaultAlgorithm: derivative$2,
  darkAlgorithm: derivative,
  compactAlgorithm: derivative$1,
  getDesignToken,
  /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */
  defaultConfig,
  /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */
  _internalContext: DesignTokenContext
}, useCache = function(a) {
  var s = reactExports.useRef({
    valueLabels: /* @__PURE__ */ new Map()
  });
  return reactExports.useMemo(function() {
    var c = s.current.valueLabels, u = /* @__PURE__ */ new Map(), d = a.map(function(p) {
      var v = p.value, A = p.label, x = A ?? c.get(v);
      return u.set(v, x), _objectSpread2$1(_objectSpread2$1({}, p), {}, {
        label: x
      });
    });
    return s.current.valueLabels = u, [d];
  }, [a]);
};
var useCheckedKeys = function a(s, c, u, d) {
  return reactExports.useMemo(function() {
    var p = function(m) {
      return m.map(function(C) {
        var w = C.value;
        return w;
      });
    }, v = p(s), A = p(c), x = v.filter(function(f) {
      return !d[f];
    }), g = v, b = A;
    if (u) {
      var y = conductCheck(v, !0, d);
      g = y.checkedKeys, b = y.halfCheckedKeys;
    }
    return [Array.from(new Set([].concat(_toConsumableArray$e(x), _toConsumableArray$e(g)))), b];
  }, [s, c, u, d]);
}, toArray = function a(s) {
  return Array.isArray(s) ? s : s !== void 0 ? [s] : [];
}, fillFieldNames = function a(s) {
  var c = s || {}, u = c.label, d = c.value, p = c.children;
  return {
    _title: u ? [u] : ["title", "label"],
    value: d || "value",
    key: d || "value",
    children: p || "children"
  };
}, isCheckDisabled = function a(s) {
  return !s || s.disabled || s.disableCheckbox || s.checkable === !1;
}, getAllKeys$1 = function a(s, c) {
  var u = [], d = function p(v) {
    v.forEach(function(A) {
      var x = A[c.children];
      x && (u.push(A[c.value]), p(x));
    });
  };
  return d(s), u;
}, isNil = function a(s) {
  return s == null;
};
const useDataEntities = function(a, s) {
  return reactExports.useMemo(function() {
    var c = convertDataToEntities(a, {
      fieldNames: s,
      initWrapper: function(d) {
        return _objectSpread2$1(_objectSpread2$1({}, d), {}, {
          valueEntities: /* @__PURE__ */ new Map()
        });
      },
      processEntity: function(d, p) {
        var v = d.node[s.value];
        p.valueEntities.set(v, d);
      }
    });
    return c;
  }, [a, s]);
};
var TreeNode = function a() {
  return null;
}, _excluded$3 = ["children", "value"];
function convertChildrenToData(a) {
  return toArray$8(a).map(function(s) {
    if (!/* @__PURE__ */ reactExports.isValidElement(s) || !s.type)
      return null;
    var c = s, u = c.key, d = c.props, p = d.children, v = d.value, A = _objectWithoutProperties$2(d, _excluded$3), x = _objectSpread2$1({
      key: u,
      value: v
    }, A), g = convertChildrenToData(p);
    return g.length && (x.children = g), x;
  }).filter(function(s) {
    return s;
  });
}
function fillLegacyProps(a) {
  if (!a)
    return a;
  var s = _objectSpread2$1({}, a);
  return "props" in s || Object.defineProperty(s, "props", {
    get: function() {
      return warningOnce(!1, "New `rc-tree-select` not support return node instance as argument anymore. Please consider to remove `props` access."), s;
    }
  }), s;
}
function fillAdditionalInfo(a, s, c, u, d, p) {
  var v = null, A = null;
  function x() {
    function g(b) {
      var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0", f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      return b.map(function(m, C) {
        var w = "".concat(y, "-").concat(C), S = m[p.value], $ = c.includes(S), T = g(m[p.children] || [], w, $), I = /* @__PURE__ */ reactExports.createElement(TreeNode, m, T.map(function(E) {
          return E.node;
        }));
        if (s === S && (v = I), $) {
          var _ = {
            pos: w,
            node: I,
            children: T
          };
          return f || A.push(_), _;
        }
        return null;
      }).filter(function(m) {
        return m;
      });
    }
    A || (A = [], g(u), A.sort(function(b, y) {
      var f = b.node.props.value, m = y.node.props.value, C = c.indexOf(f), w = c.indexOf(m);
      return C - w;
    }));
  }
  Object.defineProperty(a, "triggerNode", {
    get: function() {
      return warningOnce(!1, "`triggerNode` is deprecated. Please consider decoupling data with node."), x(), v;
    }
  }), Object.defineProperty(a, "allCheckedNodes", {
    get: function() {
      return warningOnce(!1, "`allCheckedNodes` is deprecated. Please consider decoupling data with node."), x(), d ? A : A.map(function(b) {
        var y = b.node;
        return y;
      });
    }
  });
}
var useFilterTreeData = function a(s, c, u) {
  var d = u.fieldNames, p = u.treeNodeFilterProp, v = u.filterTreeNode, A = d.children;
  return reactExports.useMemo(function() {
    if (!c || v === !1)
      return s;
    var x = typeof v == "function" ? v : function(b, y) {
      return String(y[p]).toUpperCase().includes(c.toUpperCase());
    }, g = function b(y) {
      var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return y.reduce(function(m, C) {
        var w = C[A], S = f || x(c, fillLegacyProps(C)), $ = b(w || [], S);
        return (S || $.length) && m.push(_objectSpread2$1(_objectSpread2$1({}, C), {}, _defineProperty$a({
          isLeaf: void 0
        }, A, $))), m;
      }, []);
    };
    return g(s);
  }, [s, c, A, p, v]);
};
function useRefFunc(a) {
  var s = reactExports.useRef();
  s.current = a;
  var c = reactExports.useCallback(function() {
    return s.current.apply(s, arguments);
  }, []);
  return c;
}
function buildTreeStructure(a, s) {
  var c = s.id, u = s.pId, d = s.rootPId, p = /* @__PURE__ */ new Map(), v = [];
  return a.forEach(function(A) {
    var x = A[c], g = _objectSpread2$1(_objectSpread2$1({}, A), {}, {
      key: A.key || x
    });
    p.set(x, g);
  }), p.forEach(function(A) {
    var x = A[u], g = p.get(x);
    g ? (g.children = g.children || [], g.children.push(A)) : (x === d || d === null) && v.push(A);
  }), v;
}
function useTreeData(a, s, c) {
  return reactExports.useMemo(function() {
    if (a) {
      if (c) {
        var u = _objectSpread2$1({
          id: "id",
          pId: "pId",
          rootPId: null
        }, _typeof$h(c) === "object" ? c : {});
        return buildTreeStructure(a, u);
      }
      return a;
    }
    return convertChildrenToData(s);
  }, [s, c, a]);
}
var LegacySelectContext = /* @__PURE__ */ reactExports.createContext(null), TreeSelectContext = /* @__PURE__ */ reactExports.createContext(null), HIDDEN_STYLE = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, OptionList = function a(s, c) {
  var u = useBaseProps(), d = u.prefixCls, p = u.multiple, v = u.searchValue, A = u.toggleOpen, x = u.open, g = u.notFoundContent, b = reactExports.useContext(TreeSelectContext), y = b.virtual, f = b.listHeight, m = b.listItemHeight, C = b.listItemScrollOffset, w = b.treeData, S = b.fieldNames, $ = b.onSelect, T = b.dropdownMatchSelectWidth, I = b.treeExpandAction, _ = b.treeTitleRender, E = b.onPopupScroll, R = b.leftMaxCount, O = b.leafCountOnly, L = b.valueEntities, B = reactExports.useContext(LegacySelectContext), F = B.checkable, M = B.checkedKeys, W = B.halfCheckedKeys, j = B.treeExpandedKeys, G = B.treeDefaultExpandAll, U = B.treeDefaultExpandedKeys, k = B.onTreeExpand, N = B.treeIcon, P = B.showTreeIcon, D = B.switcherIcon, H = B.treeLine, V = B.treeNodeFilterProp, Z = B.loadData, ne = B.treeLoadedKeys, K = B.treeMotion, q = B.onTreeLoad, Y = B.keyEntities, ee = reactExports.useRef(), Q = useMemo(
    function() {
      return w;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [x, w],
    function(Ue, je) {
      return je[0] && Ue[1] !== je[1];
    }
  ), J = reactExports.useMemo(function() {
    return F ? {
      checked: M,
      halfChecked: W
    } : null;
  }, [F, M, W]);
  reactExports.useEffect(function() {
    if (x && !p && M.length) {
      var Ue;
      (Ue = ee.current) === null || Ue === void 0 || Ue.scrollTo({
        key: M[0]
      });
    }
  }, [x]);
  var te = function(je) {
    je.preventDefault();
  }, ae = function(je, Le) {
    var De = Le.node;
    F && isCheckDisabled(De) || ($(De.key, {
      selected: !M.includes(De.key)
    }), p || A(!1));
  }, se = reactExports.useState(U), ie = _slicedToArray$e(se, 2), fe = ie[0], ge = ie[1], me = reactExports.useState(null), pe = _slicedToArray$e(me, 2), be = pe[0], le = pe[1], ve = reactExports.useMemo(function() {
    return j ? _toConsumableArray$e(j) : v ? be : fe;
  }, [fe, be, j, v]), he = function(je) {
    ge(je), le(je), k && k(je);
  }, ye = String(v).toLowerCase(), Ce = function(je) {
    return ye ? String(je[V]).toLowerCase().includes(ye) : !1;
  };
  reactExports.useEffect(function() {
    v && le(getAllKeys$1(w, S));
  }, [v]);
  var xe = reactExports.useState(function() {
    return /* @__PURE__ */ new Map();
  }), we = _slicedToArray$e(xe, 2), $e = we[0], Ae = we[1];
  reactExports.useEffect(function() {
    R && Ae(/* @__PURE__ */ new Map());
  }, [R]);
  function ue(Ue) {
    var je = Ue[S.value];
    if (!$e.has(je)) {
      var Le = L.get(je), De = (Le.children || []).length === 0;
      if (De)
        $e.set(je, !1);
      else {
        var Ne = Le.children.filter(function(Xe) {
          return !Xe.node.disabled && !Xe.node.disableCheckbox && !M.includes(Xe.node[S.value]);
        }), Ge = Ne.length;
        $e.set(je, Ge > R);
      }
    }
    return $e.get(je);
  }
  var ce = useEvent(function(Ue) {
    var je = Ue[S.value];
    return M.includes(je) || R === null ? !1 : R <= 0 ? !0 : O && R ? ue(Ue) : !1;
  }), Ee = function Ue(je) {
    var Le = _createForOfIteratorHelper(je), De;
    try {
      for (Le.s(); !(De = Le.n()).done; ) {
        var Ne = De.value;
        if (!(Ne.disabled || Ne.selectable === !1)) {
          if (v) {
            if (Ce(Ne))
              return Ne;
          } else
            return Ne;
          if (Ne[S.children]) {
            var Ge = Ue(Ne[S.children]);
            if (Ge)
              return Ge;
          }
        }
      }
    } catch (Xe) {
      Le.e(Xe);
    } finally {
      Le.f();
    }
    return null;
  }, _e = reactExports.useState(null), Te = _slicedToArray$e(_e, 2), ke = Te[0], Re = Te[1], Be = Y[ke];
  reactExports.useEffect(function() {
    if (x) {
      var Ue = null, je = function() {
        var De = Ee(Q);
        return De ? De[S.value] : null;
      };
      !p && M.length && !v ? Ue = M[0] : Ue = je(), Re(Ue);
    }
  }, [x, v]), reactExports.useImperativeHandle(c, function() {
    var Ue;
    return {
      scrollTo: (Ue = ee.current) === null || Ue === void 0 ? void 0 : Ue.scrollTo,
      onKeyDown: function(Le) {
        var De, Ne = Le.which;
        switch (Ne) {
          // >>> Arrow keys
          case KeyCode.UP:
          case KeyCode.DOWN:
          case KeyCode.LEFT:
          case KeyCode.RIGHT:
            (De = ee.current) === null || De === void 0 || De.onKeyDown(Le);
            break;
          // >>> Select item
          case KeyCode.ENTER: {
            if (Be) {
              var Ge = ce(Be.node), Xe = Be?.node || {}, nt = Xe.selectable, ct = Xe.value, it = Xe.disabled;
              nt !== !1 && !it && !Ge && ae(null, {
                node: {
                  key: ke
                },
                selected: !M.includes(ct)
              });
            }
            break;
          }
          // >>> Close
          case KeyCode.ESC:
            A(!1);
        }
      },
      onKeyUp: function() {
      }
    };
  });
  var Oe = useMemo(function() {
    return !v;
  }, [v, j || fe], function(Ue, je) {
    var Le = _slicedToArray$e(Ue, 1), De = Le[0], Ne = _slicedToArray$e(je, 2), Ge = Ne[0], Xe = Ne[1];
    return De !== Ge && !!(Ge || Xe);
  }), Me = Oe ? Z : null;
  if (Q.length === 0)
    return /* @__PURE__ */ reactExports.createElement("div", {
      role: "listbox",
      className: "".concat(d, "-empty"),
      onMouseDown: te
    }, g);
  var Fe = {
    fieldNames: S
  };
  return ne && (Fe.loadedKeys = ne), ve && (Fe.expandedKeys = ve), /* @__PURE__ */ reactExports.createElement("div", {
    onMouseDown: te
  }, Be && x && /* @__PURE__ */ reactExports.createElement("span", {
    style: HIDDEN_STYLE,
    "aria-live": "assertive"
  }, Be.node.value), /* @__PURE__ */ reactExports.createElement(UnstableContext.Provider, {
    value: {
      nodeDisabled: ce
    }
  }, /* @__PURE__ */ reactExports.createElement(Tree$2, _extends$3({
    ref: ee,
    focusable: !1,
    prefixCls: "".concat(d, "-tree"),
    treeData: Q,
    height: f,
    itemHeight: m,
    itemScrollOffset: C,
    virtual: y !== !1 && T !== !1,
    multiple: p,
    icon: N,
    showIcon: P,
    switcherIcon: D,
    showLine: H,
    loadData: Me,
    motion: K,
    activeKey: ke,
    checkable: F,
    checkStrictly: !0,
    checkedKeys: J,
    selectedKeys: F ? [] : M,
    defaultExpandAll: G,
    titleRender: _
  }, Fe, {
    // Proxy event out
    onActiveChange: Re,
    onSelect: ae,
    onCheck: ae,
    onExpand: he,
    onLoad: q,
    filterTreeNode: Ce,
    expandAction: I,
    onScroll: E
  }))));
}, RefOptionList = /* @__PURE__ */ reactExports.forwardRef(OptionList), SHOW_ALL = "SHOW_ALL", SHOW_PARENT = "SHOW_PARENT", SHOW_CHILD = "SHOW_CHILD";
function formatStrategyValues(a, s, c, u) {
  var d = new Set(a);
  return s === SHOW_CHILD ? a.filter(function(p) {
    var v = c[p];
    return !v || !v.children || !v.children.some(function(A) {
      var x = A.node;
      return d.has(x[u.value]);
    }) || !v.children.every(function(A) {
      var x = A.node;
      return isCheckDisabled(x) || d.has(x[u.value]);
    });
  }) : s === SHOW_PARENT ? a.filter(function(p) {
    var v = c[p], A = v ? v.parent : null;
    return !A || isCheckDisabled(A.node) || !d.has(A.key);
  }) : a;
}
var _excluded$2 = ["id", "prefixCls", "value", "defaultValue", "onChange", "onSelect", "onDeselect", "searchValue", "inputValue", "onSearch", "autoClearSearchValue", "filterTreeNode", "treeNodeFilterProp", "showCheckedStrategy", "treeNodeLabelProp", "multiple", "treeCheckable", "treeCheckStrictly", "labelInValue", "maxCount", "fieldNames", "treeDataSimpleMode", "treeData", "children", "loadData", "treeLoadedKeys", "onTreeLoad", "treeDefaultExpandAll", "treeExpandedKeys", "treeDefaultExpandedKeys", "onTreeExpand", "treeExpandAction", "virtual", "listHeight", "listItemHeight", "listItemScrollOffset", "onDropdownVisibleChange", "dropdownMatchSelectWidth", "treeLine", "treeIcon", "showTreeIcon", "switcherIcon", "treeMotion", "treeTitleRender", "onPopupScroll"];
function isRawValue(a) {
  return !a || _typeof$h(a) !== "object";
}
var TreeSelect$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var c = a.id, u = a.prefixCls, d = u === void 0 ? "rc-tree-select" : u, p = a.value, v = a.defaultValue, A = a.onChange, x = a.onSelect, g = a.onDeselect, b = a.searchValue, y = a.inputValue, f = a.onSearch, m = a.autoClearSearchValue, C = m === void 0 ? !0 : m, w = a.filterTreeNode, S = a.treeNodeFilterProp, $ = S === void 0 ? "value" : S, T = a.showCheckedStrategy, I = a.treeNodeLabelProp, _ = a.multiple, E = a.treeCheckable, R = a.treeCheckStrictly, O = a.labelInValue, L = a.maxCount, B = a.fieldNames, F = a.treeDataSimpleMode, M = a.treeData, W = a.children, j = a.loadData, G = a.treeLoadedKeys, U = a.onTreeLoad, k = a.treeDefaultExpandAll, N = a.treeExpandedKeys, P = a.treeDefaultExpandedKeys, D = a.onTreeExpand, H = a.treeExpandAction, V = a.virtual, Z = a.listHeight, ne = Z === void 0 ? 200 : Z, K = a.listItemHeight, q = K === void 0 ? 20 : K, Y = a.listItemScrollOffset, ee = Y === void 0 ? 0 : Y, Q = a.onDropdownVisibleChange, J = a.dropdownMatchSelectWidth, te = J === void 0 ? !0 : J, ae = a.treeLine, se = a.treeIcon, ie = a.showTreeIcon, fe = a.switcherIcon, ge = a.treeMotion, me = a.treeTitleRender, pe = a.onPopupScroll, be = _objectWithoutProperties$2(a, _excluded$2), le = useId$1(c), ve = E && !R, he = E || R, ye = R || O, Ce = he || _, xe = useMergedState(v, {
    value: p
  }), we = _slicedToArray$e(xe, 2), $e = we[0], Ae = we[1], ue = reactExports.useMemo(function() {
    return E ? T || SHOW_CHILD : SHOW_ALL;
  }, [T, E]), ce = reactExports.useMemo(
    function() {
      return fillFieldNames(B);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [JSON.stringify(B)]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), Ee = useMergedState("", {
    value: b !== void 0 ? b : y,
    postState: function(rt) {
      return rt || "";
    }
  }), _e = _slicedToArray$e(Ee, 2), Te = _e[0], ke = _e[1], Re = function(rt) {
    ke(rt), f?.(rt);
  }, Be = useTreeData(M, W, F), Oe = useDataEntities(Be, ce), Me = Oe.keyEntities, Fe = Oe.valueEntities, Ue = reactExports.useCallback(function(Ot) {
    var rt = [], et = [];
    return Ot.forEach(function(Ye) {
      Fe.has(Ye) ? et.push(Ye) : rt.push(Ye);
    }), {
      missingRawValues: rt,
      existRawValues: et
    };
  }, [Fe]), je = useFilterTreeData(Be, Te, {
    fieldNames: ce,
    treeNodeFilterProp: $,
    filterTreeNode: w
  }), Le = reactExports.useCallback(function(Ot) {
    if (Ot) {
      if (I)
        return Ot[I];
      for (var rt = ce._title, et = 0; et < rt.length; et += 1) {
        var Ye = Ot[rt[et]];
        if (Ye !== void 0)
          return Ye;
      }
    }
  }, [ce, I]), De = reactExports.useCallback(function(Ot) {
    var rt = toArray(Ot);
    return rt.map(function(et) {
      return isRawValue(et) ? {
        value: et
      } : et;
    });
  }, []), Ne = reactExports.useCallback(function(Ot) {
    var rt = De(Ot);
    return rt.map(function(et) {
      var Ye = et.label, tt = et.value, Ke = et.halfChecked, qe, ot = Fe.get(tt);
      if (ot) {
        var Je;
        Ye = me ? me(ot.node) : (Je = Ye) !== null && Je !== void 0 ? Je : Le(ot.node), qe = ot.node.disabled;
      } else if (Ye === void 0) {
        var Ct = De($e).find(function(Tt) {
          return Tt.value === tt;
        });
        Ye = Ct.label;
      }
      return {
        label: Ye,
        value: tt,
        halfChecked: Ke,
        disabled: qe
      };
    });
  }, [Fe, Le, De, $e]), Ge = reactExports.useMemo(function() {
    return De($e === null ? [] : $e);
  }, [De, $e]), Xe = reactExports.useMemo(function() {
    var Ot = [], rt = [];
    return Ge.forEach(function(et) {
      et.halfChecked ? rt.push(et) : Ot.push(et);
    }), [Ot, rt];
  }, [Ge]), nt = _slicedToArray$e(Xe, 2), ct = nt[0], it = nt[1], We = reactExports.useMemo(function() {
    return ct.map(function(Ot) {
      return Ot.value;
    });
  }, [ct]), Ve = useCheckedKeys(ct, it, ve, Me), ut = _slicedToArray$e(Ve, 2), at = ut[0], Qe = ut[1], st = reactExports.useMemo(function() {
    var Ot = formatStrategyValues(at, ue, Me, ce), rt = Ot.map(function(Ke) {
      var qe, ot;
      return (qe = (ot = Me[Ke]) === null || ot === void 0 || (ot = ot.node) === null || ot === void 0 ? void 0 : ot[ce.value]) !== null && qe !== void 0 ? qe : Ke;
    }), et = rt.map(function(Ke) {
      var qe = ct.find(function(Je) {
        return Je.value === Ke;
      }), ot = O ? qe?.label : me?.(qe);
      return {
        value: Ke,
        label: ot
      };
    }), Ye = Ne(et), tt = Ye[0];
    return !Ce && tt && isNil(tt.value) && isNil(tt.label) ? [] : Ye.map(function(Ke) {
      var qe;
      return _objectSpread2$1(_objectSpread2$1({}, Ke), {}, {
        label: (qe = Ke.label) !== null && qe !== void 0 ? qe : Ke.value
      });
    });
  }, [ce, Ce, at, ct, Ne, ue, Me]), ft = useCache(st), vt = _slicedToArray$e(ft, 1), Pt = vt[0], dt = reactExports.useMemo(function() {
    return Ce && (ue === "SHOW_CHILD" || R || !E) ? L : null;
  }, [L, Ce, R, ue, E]), mt = useRefFunc(function(Ot, rt, et) {
    var Ye = formatStrategyValues(Ot, ue, Me, ce);
    if (!(dt && Ye.length > dt)) {
      var tt = Ne(Ot);
      if (Ae(tt), C && ke(""), A) {
        var Ke = Ot;
        ve && (Ke = Ye.map(function($t) {
          var Lt = Fe.get($t);
          return Lt ? Lt.node[ce.value] : $t;
        }));
        var qe = rt || {
          triggerValue: void 0,
          selected: void 0
        }, ot = qe.triggerValue, Je = qe.selected, Ct = Ke;
        if (R) {
          var Tt = it.filter(function($t) {
            return !Ke.includes($t.value);
          });
          Ct = [].concat(_toConsumableArray$e(Ct), _toConsumableArray$e(Tt));
        }
        var yt = Ne(Ct), bt = {
          // [Legacy] Always return as array contains label & value
          preValue: ct,
          triggerValue: ot
        }, It = !0;
        (R || et === "selection" && !Je) && (It = !1), fillAdditionalInfo(bt, ot, Ot, Be, It, ce), he ? bt.checked = Je : bt.selected = Je;
        var kt = ye ? yt : yt.map(function($t) {
          return $t.value;
        });
        A(Ce ? kt : kt[0], ye ? null : yt.map(function($t) {
          return $t.label;
        }), bt);
      }
    }
  }), pt = reactExports.useCallback(function(Ot, rt) {
    var et, Ye = rt.selected, tt = rt.source, Ke = Me[Ot], qe = Ke?.node, ot = (et = qe?.[ce.value]) !== null && et !== void 0 ? et : Ot;
    if (!Ce)
      mt([ot], {
        selected: !0,
        triggerValue: ot
      }, "option");
    else {
      var Je = Ye ? [].concat(_toConsumableArray$e(We), [ot]) : at.filter(function(Lt) {
        return Lt !== ot;
      });
      if (ve) {
        var Ct = Ue(Je), Tt = Ct.missingRawValues, yt = Ct.existRawValues, bt = yt.map(function(Lt) {
          return Fe.get(Lt).key;
        }), It;
        if (Ye) {
          var kt = conductCheck(bt, !0, Me);
          It = kt.checkedKeys;
        } else {
          var $t = conductCheck(bt, {
            halfCheckedKeys: Qe
          }, Me);
          It = $t.checkedKeys;
        }
        Je = [].concat(_toConsumableArray$e(Tt), _toConsumableArray$e(It.map(function(Lt) {
          return Me[Lt].node[ce.value];
        })));
      }
      mt(Je, {
        selected: Ye,
        triggerValue: ot
      }, tt || "option");
    }
    Ye || !Ce ? x?.(ot, fillLegacyProps(qe)) : g?.(ot, fillLegacyProps(qe));
  }, [Ue, Fe, Me, ce, Ce, We, mt, ve, x, g, at, Qe, L]), Et = reactExports.useCallback(function(Ot) {
    if (Q) {
      var rt = {};
      Object.defineProperty(rt, "documentClickClose", {
        get: function() {
          return warningOnce(!1, "Second param of `onDropdownVisibleChange` has been removed."), !1;
        }
      }), Q(Ot, rt);
    }
  }, [Q]), Mt = useRefFunc(function(Ot, rt) {
    var et = Ot.map(function(Ye) {
      return Ye.value;
    });
    if (rt.type === "clear") {
      mt(et, {}, "selection");
      return;
    }
    rt.values.length && pt(rt.values[0].value, {
      selected: !1,
      source: "selection"
    });
  }), Nt = reactExports.useMemo(function() {
    return {
      virtual: V,
      dropdownMatchSelectWidth: te,
      listHeight: ne,
      listItemHeight: q,
      listItemScrollOffset: ee,
      treeData: je,
      fieldNames: ce,
      onSelect: pt,
      treeExpandAction: H,
      treeTitleRender: me,
      onPopupScroll: pe,
      leftMaxCount: L === void 0 ? null : L - Pt.length,
      leafCountOnly: ue === "SHOW_CHILD" && !R && !!E,
      valueEntities: Fe
    };
  }, [V, te, ne, q, ee, je, ce, pt, H, me, pe, L, Pt.length, ue, R, E, Fe]), _t = reactExports.useMemo(function() {
    return {
      checkable: he,
      loadData: j,
      treeLoadedKeys: G,
      onTreeLoad: U,
      checkedKeys: at,
      halfCheckedKeys: Qe,
      treeDefaultExpandAll: k,
      treeExpandedKeys: N,
      treeDefaultExpandedKeys: P,
      onTreeExpand: D,
      treeIcon: se,
      treeMotion: ge,
      showTreeIcon: ie,
      switcherIcon: fe,
      treeLine: ae,
      treeNodeFilterProp: $,
      keyEntities: Me
    };
  }, [he, j, G, U, at, Qe, k, N, P, D, se, ge, ie, fe, ae, $, Me]);
  return /* @__PURE__ */ reactExports.createElement(TreeSelectContext.Provider, {
    value: Nt
  }, /* @__PURE__ */ reactExports.createElement(LegacySelectContext.Provider, {
    value: _t
  }, /* @__PURE__ */ reactExports.createElement(BaseSelect, _extends$3({
    ref: s
  }, be, {
    // >>> MISC
    id: le,
    prefixCls: d,
    mode: Ce ? "multiple" : void 0,
    displayValues: Pt,
    onDisplayValuesChange: Mt,
    searchValue: Te,
    onSearch: Re,
    OptionList: RefOptionList,
    emptyOptions: !Be.length,
    onDropdownVisibleChange: Et,
    dropdownMatchSelectWidth: te
  }))));
}), GenericTreeSelect = TreeSelect$2;
GenericTreeSelect.TreeNode = TreeNode;
GenericTreeSelect.SHOW_ALL = SHOW_ALL;
GenericTreeSelect.SHOW_PARENT = SHOW_PARENT;
GenericTreeSelect.SHOW_CHILD = SHOW_CHILD;
const genBaseStyle$1 = (a) => {
  const {
    componentCls: s,
    treePrefixCls: c,
    colorBgElevated: u
  } = a, d = `.${c}`;
  return [
    // ======================================================
    // ==                     Dropdown                     ==
    // ======================================================
    {
      [`${s}-dropdown`]: [
        {
          padding: `${unit$1(a.paddingXS)} ${unit$1(a.calc(a.paddingXS).div(2).equal())}`
        },
        // ====================== Tree ======================
        genTreeStyle(c, merge(a, {
          colorBgContainer: u
        }), !1),
        {
          [d]: {
            borderRadius: 0,
            [`${d}-list-holder-inner`]: {
              alignItems: "stretch",
              [`${d}-treenode`]: {
                [`${d}-node-content-wrapper`]: {
                  flex: "auto"
                }
              }
            }
          }
        },
        // ==================== Checkbox ====================
        getStyle$1(`${c}-checkbox`, a),
        // ====================== RTL =======================
        {
          "&-rtl": {
            direction: "rtl",
            [`${d}-switcher${d}-switcher_close`]: {
              [`${d}-switcher-icon svg`]: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      ]
    }
  ];
};
function useTreeSelectStyle(a, s, c) {
  return genStyleHooks("TreeSelect", (u) => {
    const d = merge(u, {
      treePrefixCls: s
    });
    return [genBaseStyle$1(d)];
  }, initComponentToken)(a, c);
}
var __rest$9 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const InternalTreeSelect = (a, s) => {
  var c, u, d, p, v;
  const {
    prefixCls: A,
    size: x,
    disabled: g,
    bordered: b = !0,
    style: y,
    className: f,
    rootClassName: m,
    treeCheckable: C,
    multiple: w,
    listHeight: S = 256,
    listItemHeight: $,
    placement: T,
    notFoundContent: I,
    switcherIcon: _,
    treeLine: E,
    getPopupContainer: R,
    popupClassName: O,
    dropdownClassName: L,
    treeIcon: B = !1,
    transitionName: F,
    choiceTransitionName: M = "",
    status: W,
    treeExpandAction: j,
    builtinPlacements: G,
    dropdownMatchSelectWidth: U,
    popupMatchSelectWidth: k,
    allowClear: N,
    variant: P,
    dropdownStyle: D,
    dropdownRender: H,
    popupRender: V,
    onDropdownVisibleChange: Z,
    onOpenChange: ne,
    tagRender: K,
    maxCount: q,
    showCheckedStrategy: Y,
    treeCheckStrictly: ee,
    styles: Q,
    classNames: J
  } = a, te = __rest$9(a, ["prefixCls", "size", "disabled", "bordered", "style", "className", "rootClassName", "treeCheckable", "multiple", "listHeight", "listItemHeight", "placement", "notFoundContent", "switcherIcon", "treeLine", "getPopupContainer", "popupClassName", "dropdownClassName", "treeIcon", "transitionName", "choiceTransitionName", "status", "treeExpandAction", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "allowClear", "variant", "dropdownStyle", "dropdownRender", "popupRender", "onDropdownVisibleChange", "onOpenChange", "tagRender", "maxCount", "showCheckedStrategy", "treeCheckStrictly", "styles", "classNames"]), {
    getPopupContainer: ae,
    getPrefixCls: se,
    renderEmpty: ie,
    direction: fe,
    virtual: ge,
    popupMatchSelectWidth: me,
    popupOverflow: pe
  } = reactExports.useContext(ConfigContext$1), {
    styles: be,
    classNames: le
  } = useComponentConfig("treeSelect"), [, ve] = useToken$1(), he = $ ?? ve?.controlHeightSM + ve?.paddingXXS, ye = se(), Ce = se("select", A), xe = se("select-tree", A), we = se("tree-select", A), {
    compactSize: $e,
    compactItemClassnames: Ae
  } = useCompactItemContext(Ce, fe), ue = useCSSVarCls(Ce), ce = useCSSVarCls(we), [Ee, _e, Te] = useSelectStyle(Ce, ue), [ke] = useTreeSelectStyle(we, xe, ce), [Re, Be] = useVariant("treeSelect", P, b), Oe = classnames(((c = J?.popup) === null || c === void 0 ? void 0 : c.root) || ((u = le?.popup) === null || u === void 0 ? void 0 : u.root) || O || L, `${we}-dropdown`, {
    [`${we}-dropdown-rtl`]: fe === "rtl"
  }, m, le.root, J?.root, Te, ue, ce, _e), Me = ((d = Q?.popup) === null || d === void 0 ? void 0 : d.root) || ((p = be?.popup) === null || p === void 0 ? void 0 : p.root) || D, Fe = V || H, Ue = ne || Z, je = !!(C || w), Le = reactExports.useMemo(() => {
    if (!(q && (Y === "SHOW_ALL" && !ee || Y === "SHOW_PARENT")))
      return q;
  }, [q, Y, ee]), De = useShowArrow(a.suffixIcon, a.showArrow), Ne = (v = k ?? U) !== null && v !== void 0 ? v : me, {
    status: Ge,
    hasFeedback: Xe,
    isFormItemInput: nt,
    feedbackIcon: ct
  } = reactExports.useContext(FormItemInputContext), it = getMergedStatus(Ge, W), {
    suffixIcon: We,
    removeIcon: Ve,
    clearIcon: ut
  } = useIcons$1(Object.assign(Object.assign({}, te), {
    multiple: je,
    showSuffixIcon: De,
    hasFeedback: Xe,
    feedbackIcon: ct,
    prefixCls: Ce,
    componentName: "TreeSelect"
  })), at = N === !0 ? {
    clearIcon: ut
  } : N;
  let Qe;
  I !== void 0 ? Qe = I : Qe = ie?.("Select") || /* @__PURE__ */ reactExports.createElement(DefaultRenderEmpty, {
    componentName: "Select"
  });
  const st = omit(te, ["suffixIcon", "removeIcon", "clearIcon", "itemIcon", "switcherIcon", "style"]), ft = reactExports.useMemo(() => T !== void 0 ? T : fe === "rtl" ? "bottomRight" : "bottomLeft", [T, fe]), vt = useSize((Nt) => {
    var _t;
    return (_t = x ?? $e) !== null && _t !== void 0 ? _t : Nt;
  }), Pt = reactExports.useContext(DisabledContext), dt = g ?? Pt, mt = classnames(!A && we, {
    [`${Ce}-lg`]: vt === "large",
    [`${Ce}-sm`]: vt === "small",
    [`${Ce}-rtl`]: fe === "rtl",
    [`${Ce}-${Re}`]: Be,
    [`${Ce}-in-form-item`]: nt
  }, getStatusClassNames(Ce, it, Xe), Ae, f, m, le.root, J?.root, Te, ue, ce, _e), pt = (Nt) => /* @__PURE__ */ reactExports.createElement(SwitcherIconCom, {
    prefixCls: xe,
    switcherIcon: _,
    treeNodeProps: Nt,
    showLine: E
  }), [Et] = useZIndex("SelectLike", Me?.zIndex), Mt = /* @__PURE__ */ reactExports.createElement(GenericTreeSelect, Object.assign({
    virtual: ge,
    disabled: dt
  }, st, {
    dropdownMatchSelectWidth: Ne,
    builtinPlacements: mergedBuiltinPlacements(G, pe),
    ref: s,
    prefixCls: Ce,
    className: mt,
    style: Object.assign(Object.assign({}, Q?.root), y),
    listHeight: S,
    listItemHeight: he,
    treeCheckable: C && /* @__PURE__ */ reactExports.createElement("span", {
      className: `${Ce}-tree-checkbox-inner`
    }),
    treeLine: !!E,
    suffixIcon: We,
    multiple: je,
    placement: ft,
    removeIcon: Ve,
    allowClear: at,
    switcherIcon: pt,
    showTreeIcon: B,
    notFoundContent: Qe,
    getPopupContainer: R || ae,
    treeMotion: null,
    dropdownClassName: Oe,
    dropdownStyle: Object.assign(Object.assign({}, Me), {
      zIndex: Et
    }),
    dropdownRender: Fe,
    onDropdownVisibleChange: Ue,
    choiceTransitionName: getTransitionName$1(ye, "", M),
    transitionName: getTransitionName$1(ye, "slide-up", F),
    treeExpandAction: j,
    tagRender: je ? K : void 0,
    maxCount: Le,
    showCheckedStrategy: Y,
    treeCheckStrictly: ee
  }));
  return Ee(ke(Mt));
}, TreeSelectRef = /* @__PURE__ */ reactExports.forwardRef(InternalTreeSelect), TreeSelect$1 = TreeSelectRef, PurePanel = genPurePanel(TreeSelect$1, "dropdownAlign", (a) => omit(a, ["visible"]));
TreeSelect$1.TreeNode = TreeNode;
TreeSelect$1.SHOW_ALL = SHOW_ALL;
TreeSelect$1.SHOW_PARENT = SHOW_PARENT;
TreeSelect$1.SHOW_CHILD = SHOW_CHILD;
TreeSelect$1._InternalPanelDoNotUseOrYouWillBeFired = PurePanel;
const getTitleStyle = (a, s, c, u) => {
  const {
    titleMarginBottom: d,
    fontWeightStrong: p
  } = u;
  return {
    marginBottom: d,
    color: c,
    fontWeight: p,
    fontSize: a,
    lineHeight: s
  };
}, getTitleStyles = (a) => {
  const s = [1, 2, 3, 4, 5], c = {};
  return s.forEach((u) => {
    c[`
      h${u}&,
      div&-h${u},
      div&-h${u} > textarea,
      h${u}
    `] = getTitleStyle(a[`fontSizeHeading${u}`], a[`lineHeightHeading${u}`], a.colorTextHeading, a);
  }), c;
}, getLinkStyles = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    "a&, a": Object.assign(Object.assign({}, operationUnit(a)), {
      userSelect: "text",
      [`&[disabled], &${s}-disabled`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: a.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, getResetStyles = (a) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: a.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: a.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: gold$1[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: a.fontWeightStrong
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: a.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), getEditableStyles = (a) => {
  const {
    componentCls: s,
    paddingSM: c
  } = a, u = c;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: a.calc(a.paddingSM).mul(-1).equal(),
        marginTop: a.calc(u).mul(-1).equal(),
        marginBottom: `calc(1em - ${unit$1(u)})`
      },
      [`${s}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: a.calc(a.marginXS).add(2).equal(),
        insetBlockEnd: a.marginXS,
        color: a.colorIcon,
        // default style
        fontWeight: "normal",
        fontSize: a.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, getCopyableStyles = (a) => ({
  [`${a.componentCls}-copy-success`]: {
    "\n    &,\n    &:hover,\n    &:focus": {
      color: a.colorSuccess
    }
  },
  [`${a.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
}), getEllipsisStyles = () => ({
  "\n  a&-ellipsis,\n  span&-ellipsis\n  ": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-ellipsis-single-line": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), genTypographyStyle = (a) => {
  const {
    componentCls: s,
    titleMarginTop: c
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: a.colorText,
      wordBreak: "break-word",
      lineHeight: a.lineHeight,
      [`&${s}-secondary`]: {
        color: a.colorTextDescription
      },
      [`&${s}-success`]: {
        color: a.colorSuccessText
      },
      [`&${s}-warning`]: {
        color: a.colorWarningText
      },
      [`&${s}-danger`]: {
        color: a.colorErrorText,
        "a&:active, a&:focus": {
          color: a.colorErrorTextActive
        },
        "a&:hover": {
          color: a.colorErrorTextHover
        }
      },
      [`&${s}-disabled`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      "\n        div&,\n        p\n      ": {
        marginBottom: "1em"
      }
    }, getTitleStyles(a)), {
      [`
      & + h1${s},
      & + h2${s},
      & + h3${s},
      & + h4${s},
      & + h5${s}
      `]: {
        marginTop: c
      },
      "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5": {
        "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ": {
          marginTop: c
        }
      }
    }), getResetStyles(a)), getLinkStyles(a)), {
      // Operation
      [`
        ${s}-expand,
        ${s}-collapse,
        ${s}-edit,
        ${s}-copy
      `]: Object.assign(Object.assign({}, operationUnit(a)), {
        marginInlineStart: a.marginXXS
      })
    }), getEditableStyles(a)), getCopyableStyles(a)), getEllipsisStyles()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, prepareComponentToken$1 = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), useStyle$1 = genStyleHooks("Typography", (a) => [genTypographyStyle(a)], prepareComponentToken$1), Editable = (a) => {
  const {
    prefixCls: s,
    "aria-label": c,
    className: u,
    style: d,
    direction: p,
    maxLength: v,
    autoSize: A = !0,
    value: x,
    onSave: g,
    onCancel: b,
    onEnd: y,
    component: f,
    enterIcon: m = /* @__PURE__ */ reactExports.createElement(RefIcon$c, null)
  } = a, C = reactExports.useRef(null), w = reactExports.useRef(!1), S = reactExports.useRef(null), [$, T] = reactExports.useState(x);
  reactExports.useEffect(() => {
    T(x);
  }, [x]), reactExports.useEffect(() => {
    var G;
    if (!((G = C.current) === null || G === void 0) && G.resizableTextArea) {
      const {
        textArea: U
      } = C.current.resizableTextArea;
      U.focus();
      const {
        length: k
      } = U.value;
      U.setSelectionRange(k, k);
    }
  }, []);
  const I = ({
    target: G
  }) => {
    T(G.value.replace(/[\n\r]/g, ""));
  }, _ = () => {
    w.current = !0;
  }, E = () => {
    w.current = !1;
  }, R = ({
    keyCode: G
  }) => {
    w.current || (S.current = G);
  }, O = () => {
    g($.trim());
  }, L = ({
    keyCode: G,
    ctrlKey: U,
    altKey: k,
    metaKey: N,
    shiftKey: P
  }) => {
    S.current !== G || w.current || U || k || N || P || (G === KeyCode.ENTER ? (O(), y?.()) : G === KeyCode.ESC && b());
  }, B = () => {
    O();
  }, [F, M, W] = useStyle$1(s), j = classnames(s, `${s}-edit-content`, {
    [`${s}-rtl`]: p === "rtl",
    [`${s}-${f}`]: !!f
  }, u, M, W);
  return F(/* @__PURE__ */ reactExports.createElement("div", {
    className: j,
    style: d
  }, /* @__PURE__ */ reactExports.createElement(TextArea$3, {
    ref: C,
    maxLength: v,
    value: $,
    onChange: I,
    onKeyDown: R,
    onKeyUp: L,
    onCompositionStart: _,
    onCompositionEnd: E,
    onBlur: B,
    "aria-label": c,
    rows: 1,
    autoSize: A
  }), m !== null ? cloneElement(m, {
    className: `${s}-edit-content-confirm`
  }) : null));
};
var toggleSelection, hasRequiredToggleSelection;
function requireToggleSelection() {
  return hasRequiredToggleSelection || (hasRequiredToggleSelection = 1, toggleSelection = function() {
    var a = document.getSelection();
    if (!a.rangeCount)
      return function() {
      };
    for (var s = document.activeElement, c = [], u = 0; u < a.rangeCount; u++)
      c.push(a.getRangeAt(u));
    switch (s.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        s.blur();
        break;
      default:
        s = null;
        break;
    }
    return a.removeAllRanges(), function() {
      a.type === "Caret" && a.removeAllRanges(), a.rangeCount || c.forEach(function(d) {
        a.addRange(d);
      }), s && s.focus();
    };
  }), toggleSelection;
}
var copyToClipboard, hasRequiredCopyToClipboard;
function requireCopyToClipboard() {
  if (hasRequiredCopyToClipboard) return copyToClipboard;
  hasRequiredCopyToClipboard = 1;
  var a = requireToggleSelection(), s = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, c = "Copy to clipboard: #{key}, Enter";
  function u(p) {
    var v = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return p.replace(/#{\s*key\s*}/g, v);
  }
  function d(p, v) {
    var A, x, g, b, y, f, m = !1;
    v || (v = {}), A = v.debug || !1;
    try {
      g = a(), b = document.createRange(), y = document.getSelection(), f = document.createElement("span"), f.textContent = p, f.ariaHidden = "true", f.style.all = "unset", f.style.position = "fixed", f.style.top = 0, f.style.clip = "rect(0, 0, 0, 0)", f.style.whiteSpace = "pre", f.style.webkitUserSelect = "text", f.style.MozUserSelect = "text", f.style.msUserSelect = "text", f.style.userSelect = "text", f.addEventListener("copy", function(w) {
        if (w.stopPropagation(), v.format)
          if (w.preventDefault(), typeof w.clipboardData > "u") {
            A && console.warn("unable to use e.clipboardData"), A && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var S = s[v.format] || s.default;
            window.clipboardData.setData(S, p);
          } else
            w.clipboardData.clearData(), w.clipboardData.setData(v.format, p);
        v.onCopy && (w.preventDefault(), v.onCopy(w.clipboardData));
      }), document.body.appendChild(f), b.selectNodeContents(f), y.addRange(b);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      m = !0;
    } catch (w) {
      A && console.error("unable to copy using execCommand: ", w), A && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(v.format || "text", p), v.onCopy && v.onCopy(window.clipboardData), m = !0;
      } catch (S) {
        A && console.error("unable to copy using clipboardData: ", S), A && console.error("falling back to prompt"), x = u("message" in v ? v.message : c), window.prompt(x, p);
      }
    } finally {
      y && (typeof y.removeRange == "function" ? y.removeRange(b) : y.removeAllRanges()), f && document.body.removeChild(f), g();
    }
    return m;
  }
  return copyToClipboard = d, copyToClipboard;
}
var copyToClipboardExports = requireCopyToClipboard();
const copy = /* @__PURE__ */ getDefaultExportFromCjs(copyToClipboardExports);
var __awaiter$1 = function(a, s, c, u) {
  function d(p) {
    return p instanceof c ? p : new c(function(v) {
      v(p);
    });
  }
  return new (c || (c = Promise))(function(p, v) {
    function A(b) {
      try {
        g(u.next(b));
      } catch (y) {
        v(y);
      }
    }
    function x(b) {
      try {
        g(u.throw(b));
      } catch (y) {
        v(y);
      }
    }
    function g(b) {
      b.done ? p(b.value) : d(b.value).then(A, x);
    }
    g((u = u.apply(a, s || [])).next());
  });
};
const useCopyClick = ({
  copyConfig: a,
  children: s
}) => {
  const [c, u] = reactExports.useState(!1), [d, p] = reactExports.useState(!1), v = reactExports.useRef(null), A = () => {
    v.current && clearTimeout(v.current);
  }, x = {};
  a.format && (x.format = a.format), reactExports.useEffect(() => A, []);
  const g = useEvent((b) => __awaiter$1(void 0, void 0, void 0, function* () {
    var y;
    b?.preventDefault(), b?.stopPropagation(), p(!0);
    try {
      const f = typeof a.text == "function" ? yield a.text() : a.text;
      copy(f || toList$1(s, !0).join("") || "", x), p(!1), u(!0), A(), v.current = setTimeout(() => {
        u(!1);
      }, 3e3), (y = a.onCopy) === null || y === void 0 || y.call(a, b);
    } catch (f) {
      throw p(!1), f;
    }
  }));
  return {
    copied: c,
    copyLoading: d,
    onClick: g
  };
};
function useMergedConfig(a, s) {
  return reactExports.useMemo(() => {
    const c = !!a;
    return [c, Object.assign(Object.assign({}, s), c && typeof a == "object" ? a : null)];
  }, [a]);
}
const usePrevious$1 = (a) => {
  const s = reactExports.useRef(void 0);
  return reactExports.useEffect(() => {
    s.current = a;
  }), s.current;
}, useTooltipProps = (a, s, c) => reactExports.useMemo(() => a === !0 ? {
  title: s ?? c
} : /* @__PURE__ */ reactExports.isValidElement(a) ? {
  title: a
} : typeof a == "object" ? Object.assign({
  title: s ?? c
}, a) : {
  title: a
}, [a, s, c]);
var __rest$8 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Typography$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: c,
    component: u = "article",
    className: d,
    rootClassName: p,
    setContentRef: v,
    children: A,
    direction: x,
    style: g
  } = a, b = __rest$8(a, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: y,
    direction: f,
    className: m,
    style: C
  } = useComponentConfig("typography"), w = x ?? f, S = v ? composeRef(s, v) : s, $ = y("typography", c), [T, I, _] = useStyle$1($), E = classnames($, m, {
    [`${$}-rtl`]: w === "rtl"
  }, d, p, I, _), R = Object.assign(Object.assign({}, C), g);
  return T(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ reactExports.createElement(u, Object.assign({
      className: E,
      style: R,
      ref: S
    }, b), A)
  );
});
function toList(a) {
  return a === !1 ? [!1, !1] : Array.isArray(a) ? a : [a];
}
function getNode(a, s, c) {
  return a === !0 || a === void 0 ? s : a || c && s;
}
function isEleEllipsis(a) {
  const s = document.createElement("em");
  a.appendChild(s);
  const c = a.getBoundingClientRect(), u = s.getBoundingClientRect();
  return a.removeChild(s), // Horizontal out of range
  c.left > u.left || u.right > c.right || // Vertical out of range
  c.top > u.top || u.bottom > c.bottom;
}
const isValidText = (a) => ["string", "number"].includes(typeof a), CopyBtn = ({
  prefixCls: a,
  copied: s,
  locale: c,
  iconOnly: u,
  tooltips: d,
  icon: p,
  tabIndex: v,
  onCopy: A,
  loading: x
}) => {
  const g = toList(d), b = toList(p), {
    copied: y,
    copy: f
  } = c ?? {}, m = s ? y : f, C = getNode(g[s ? 1 : 0], m), w = typeof C == "string" ? C : m;
  return /* @__PURE__ */ reactExports.createElement(Tooltip, {
    title: C
  }, /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    className: classnames(`${a}-copy`, {
      [`${a}-copy-success`]: s,
      [`${a}-copy-icon-only`]: u
    }),
    onClick: A,
    "aria-label": w,
    tabIndex: v
  }, s ? getNode(b[1], /* @__PURE__ */ reactExports.createElement(RefIcon$D, null), !0) : getNode(b[0], x ? /* @__PURE__ */ reactExports.createElement(RefIcon$F, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$g, null), !0)));
}, MeasureText = /* @__PURE__ */ reactExports.forwardRef(({
  style: a,
  children: s
}, c) => {
  const u = reactExports.useRef(null);
  return reactExports.useImperativeHandle(c, () => ({
    isExceed: () => {
      const d = u.current;
      return d.scrollHeight > d.clientHeight;
    },
    getHeight: () => u.current.clientHeight
  })), /* @__PURE__ */ reactExports.createElement("span", {
    "aria-hidden": !0,
    ref: u,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      pointerEvents: "none",
      backgroundColor: "rgba(255, 0, 0, 0.65)"
    }, a)
  }, s);
}), getNodesLen = (a) => a.reduce((s, c) => s + (isValidText(c) ? String(c).length : 1), 0);
function sliceNodes(a, s) {
  let c = 0;
  const u = [];
  for (let d = 0; d < a.length; d += 1) {
    if (c === s)
      return u;
    const p = a[d], A = isValidText(p) ? String(p).length : 1, x = c + A;
    if (x > s) {
      const g = s - c;
      return u.push(String(p).slice(0, g)), u;
    }
    u.push(p), c = x;
  }
  return a;
}
const STATUS_MEASURE_NONE = 0, STATUS_MEASURE_PREPARE = 1, STATUS_MEASURE_START = 2, STATUS_MEASURE_NEED_ELLIPSIS = 3, STATUS_MEASURE_NO_NEED_ELLIPSIS = 4, lineClipStyle = {
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical"
};
function EllipsisMeasure(a) {
  const {
    enableMeasure: s,
    width: c,
    text: u,
    children: d,
    rows: p,
    expanded: v,
    miscDeps: A,
    onEllipsis: x
  } = a, g = reactExports.useMemo(() => toArray$8(u), [u]), b = reactExports.useMemo(() => getNodesLen(g), [u]), y = reactExports.useMemo(() => d(g, !1), [u]), [f, m] = reactExports.useState(null), C = reactExports.useRef(null), w = reactExports.useRef(null), S = reactExports.useRef(null), $ = reactExports.useRef(null), T = reactExports.useRef(null), [I, _] = reactExports.useState(!1), [E, R] = reactExports.useState(STATUS_MEASURE_NONE), [O, L] = reactExports.useState(0), [B, F] = reactExports.useState(null);
  useLayoutEffect$1(() => {
    R(s && c && b ? STATUS_MEASURE_PREPARE : STATUS_MEASURE_NONE);
  }, [c, u, p, s, g]), useLayoutEffect$1(() => {
    var G, U, k, N;
    if (E === STATUS_MEASURE_PREPARE) {
      R(STATUS_MEASURE_START);
      const P = w.current && getComputedStyle(w.current).whiteSpace;
      F(P);
    } else if (E === STATUS_MEASURE_START) {
      const P = !!(!((G = S.current) === null || G === void 0) && G.isExceed());
      R(P ? STATUS_MEASURE_NEED_ELLIPSIS : STATUS_MEASURE_NO_NEED_ELLIPSIS), m(P ? [0, b] : null), _(P);
      const D = ((U = S.current) === null || U === void 0 ? void 0 : U.getHeight()) || 0, H = p === 1 ? 0 : ((k = $.current) === null || k === void 0 ? void 0 : k.getHeight()) || 0, V = ((N = T.current) === null || N === void 0 ? void 0 : N.getHeight()) || 0, Z = Math.max(
        D,
        // height of rows with ellipsis
        H + V
      );
      L(Z + 1), x(P);
    }
  }, [E]);
  const M = f ? Math.ceil((f[0] + f[1]) / 2) : 0;
  useLayoutEffect$1(() => {
    var G;
    const [U, k] = f || [0, 0];
    if (U !== k) {
      const P = (((G = C.current) === null || G === void 0 ? void 0 : G.getHeight()) || 0) > O;
      let D = M;
      k - U === 1 && (D = P ? U : k), m(P ? [U, D] : [D, k]);
    }
  }, [f, M]);
  const W = reactExports.useMemo(() => {
    if (!s)
      return d(g, !1);
    if (E !== STATUS_MEASURE_NEED_ELLIPSIS || !f || f[0] !== f[1]) {
      const G = d(g, !1);
      return [STATUS_MEASURE_NO_NEED_ELLIPSIS, STATUS_MEASURE_NONE].includes(E) ? G : /* @__PURE__ */ reactExports.createElement("span", {
        style: Object.assign(Object.assign({}, lineClipStyle), {
          WebkitLineClamp: p
        })
      }, G);
    }
    return d(v ? g : sliceNodes(g, f[0]), I);
  }, [v, E, f, g].concat(_toConsumableArray$e(A))), j = {
    width: c,
    margin: 0,
    padding: 0,
    whiteSpace: B === "nowrap" ? "normal" : "inherit"
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, W, E === STATUS_MEASURE_START && /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, j), lineClipStyle), {
      WebkitLineClamp: p
    }),
    ref: S
  }, y), /* @__PURE__ */ reactExports.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, j), lineClipStyle), {
      WebkitLineClamp: p - 1
    }),
    ref: $
  }, y), /* @__PURE__ */ reactExports.createElement(MeasureText, {
    style: Object.assign(Object.assign(Object.assign({}, j), lineClipStyle), {
      WebkitLineClamp: 1
    }),
    ref: T
  }, d([], !0))), E === STATUS_MEASURE_NEED_ELLIPSIS && f && f[0] !== f[1] && /* @__PURE__ */ reactExports.createElement(MeasureText, {
    style: Object.assign(Object.assign({}, j), {
      top: 400
    }),
    ref: C
  }, d(sliceNodes(g, M), !0)), E === STATUS_MEASURE_PREPARE && /* @__PURE__ */ reactExports.createElement("span", {
    style: {
      whiteSpace: "inherit"
    },
    ref: w
  }));
}
const EllipsisTooltip = ({
  enableEllipsis: a,
  isEllipsis: s,
  children: c,
  tooltipProps: u
}) => !u?.title || !a ? c : /* @__PURE__ */ reactExports.createElement(Tooltip, Object.assign({
  open: s ? void 0 : !1
}, u), c);
var __rest$7 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
function wrapperDecorations({
  mark: a,
  code: s,
  underline: c,
  delete: u,
  strong: d,
  keyboard: p,
  italic: v
}, A) {
  let x = A;
  function g(b, y) {
    y && (x = /* @__PURE__ */ reactExports.createElement(b, {}, x));
  }
  return g("strong", d), g("u", c), g("del", u), g("code", s), g("mark", a), g("kbd", p), g("i", v), x;
}
const ELLIPSIS_STR = "...", DECORATION_PROPS = ["delete", "mark", "code", "underline", "strong", "keyboard", "italic"], Base = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var c;
  const {
    prefixCls: u,
    className: d,
    style: p,
    type: v,
    disabled: A,
    children: x,
    ellipsis: g,
    editable: b,
    copyable: y,
    component: f,
    title: m
  } = a, C = __rest$7(a, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: w,
    direction: S
  } = reactExports.useContext(ConfigContext$1), [$] = useLocale$1("Text"), T = reactExports.useRef(null), I = reactExports.useRef(null), _ = w("typography", u), E = omit(C, DECORATION_PROPS), [R, O] = useMergedConfig(b), [L, B] = useMergedState(!1, {
    value: O.editing
  }), {
    triggerType: F = ["icon"]
  } = O, M = (Oe) => {
    var Me;
    Oe && ((Me = O.onStart) === null || Me === void 0 || Me.call(O)), B(Oe);
  }, W = usePrevious$1(L);
  useLayoutEffect$1(() => {
    var Oe;
    !L && W && ((Oe = I.current) === null || Oe === void 0 || Oe.focus());
  }, [L]);
  const j = (Oe) => {
    Oe?.preventDefault(), M(!0);
  }, G = (Oe) => {
    var Me;
    (Me = O.onChange) === null || Me === void 0 || Me.call(O, Oe), M(!1);
  }, U = () => {
    var Oe;
    (Oe = O.onCancel) === null || Oe === void 0 || Oe.call(O), M(!1);
  }, [k, N] = useMergedConfig(y), {
    copied: P,
    copyLoading: D,
    onClick: H
  } = useCopyClick({
    copyConfig: N,
    children: x
  }), [V, Z] = reactExports.useState(!1), [ne, K] = reactExports.useState(!1), [q, Y] = reactExports.useState(!1), [ee, Q] = reactExports.useState(!1), [J, te] = reactExports.useState(!0), [ae, se] = useMergedConfig(g, {
    expandable: !1,
    symbol: (Oe) => Oe ? $?.collapse : $?.expand
  }), [ie, fe] = useMergedState(se.defaultExpanded || !1, {
    value: se.expanded
  }), ge = ae && (!ie || se.expandable === "collapsible"), {
    rows: me = 1
  } = se, pe = reactExports.useMemo(() => (
    // Disable ellipsis
    ge && // Provide suffix
    (se.suffix !== void 0 || se.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    se.expandable || R || k)
  ), [ge, se, R, k]);
  useLayoutEffect$1(() => {
    ae && !pe && (Z(isStyleSupport("webkitLineClamp")), K(isStyleSupport("textOverflow")));
  }, [pe, ae]);
  const [be, le] = reactExports.useState(ge), ve = reactExports.useMemo(() => pe ? !1 : me === 1 ? ne : V, [pe, ne, V]);
  useLayoutEffect$1(() => {
    le(ve && ge);
  }, [ve, ge]);
  const he = ge && (be ? ee : q), ye = ge && me === 1 && be, Ce = ge && me > 1 && be, xe = (Oe, Me) => {
    var Fe;
    fe(Me.expanded), (Fe = se.onExpand) === null || Fe === void 0 || Fe.call(se, Oe, Me);
  }, [we, $e] = reactExports.useState(0), Ae = ({
    offsetWidth: Oe
  }) => {
    $e(Oe);
  }, ue = (Oe) => {
    var Me;
    Y(Oe), q !== Oe && ((Me = se.onEllipsis) === null || Me === void 0 || Me.call(se, Oe));
  };
  reactExports.useEffect(() => {
    const Oe = T.current;
    if (ae && be && Oe) {
      const Me = isEleEllipsis(Oe);
      ee !== Me && Q(Me);
    }
  }, [ae, be, x, Ce, J, we]), reactExports.useEffect(() => {
    const Oe = T.current;
    if (typeof IntersectionObserver > "u" || !Oe || !be || !ge)
      return;
    const Me = new IntersectionObserver(() => {
      te(!!Oe.offsetParent);
    });
    return Me.observe(Oe), () => {
      Me.disconnect();
    };
  }, [be, ge]);
  const ce = useTooltipProps(se.tooltip, O.text, x), Ee = reactExports.useMemo(() => {
    if (!(!ae || be))
      return [O.text, x, m, ce.title].find(isValidText);
  }, [ae, be, m, ce.title, he]);
  if (L)
    return /* @__PURE__ */ reactExports.createElement(Editable, {
      value: (c = O.text) !== null && c !== void 0 ? c : typeof x == "string" ? x : "",
      onSave: G,
      onCancel: U,
      onEnd: O.onEnd,
      prefixCls: _,
      className: d,
      style: p,
      direction: S,
      component: f,
      maxLength: O.maxLength,
      autoSize: O.autoSize,
      enterIcon: O.enterIcon
    });
  const _e = () => {
    const {
      expandable: Oe,
      symbol: Me
    } = se;
    return Oe ? /* @__PURE__ */ reactExports.createElement("button", {
      type: "button",
      key: "expand",
      className: `${_}-${ie ? "collapse" : "expand"}`,
      onClick: (Fe) => xe(Fe, {
        expanded: !ie
      }),
      "aria-label": ie ? $.collapse : $?.expand
    }, typeof Me == "function" ? Me(ie) : Me) : null;
  }, Te = () => {
    if (!R)
      return;
    const {
      icon: Oe,
      tooltip: Me,
      tabIndex: Fe
    } = O, Ue = toArray$8(Me)[0] || $?.edit, je = typeof Ue == "string" ? Ue : "";
    return F.includes("icon") ? /* @__PURE__ */ reactExports.createElement(Tooltip, {
      key: "edit",
      title: Me === !1 ? "" : Ue
    }, /* @__PURE__ */ reactExports.createElement("button", {
      type: "button",
      ref: I,
      className: `${_}-edit`,
      onClick: j,
      "aria-label": je,
      tabIndex: Fe
    }, Oe || /* @__PURE__ */ reactExports.createElement(RefIcon$d, {
      role: "button"
    }))) : null;
  }, ke = () => k ? /* @__PURE__ */ reactExports.createElement(CopyBtn, Object.assign({
    key: "copy"
  }, N, {
    prefixCls: _,
    copied: P,
    locale: $,
    onCopy: H,
    loading: D,
    iconOnly: x == null
  })) : null, Re = (Oe) => [Oe && _e(), Te(), ke()], Be = (Oe) => [Oe && !ie && /* @__PURE__ */ reactExports.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, ELLIPSIS_STR), se.suffix, Re(Oe)];
  return /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Ae,
    disabled: !ge
  }, (Oe) => /* @__PURE__ */ reactExports.createElement(EllipsisTooltip, {
    tooltipProps: ce,
    enableEllipsis: ge,
    isEllipsis: he
  }, /* @__PURE__ */ reactExports.createElement(Typography$1, Object.assign({
    className: classnames({
      [`${_}-${v}`]: v,
      [`${_}-disabled`]: A,
      [`${_}-ellipsis`]: ae,
      [`${_}-ellipsis-single-line`]: ye,
      [`${_}-ellipsis-multiple-line`]: Ce
    }, d),
    prefixCls: u,
    style: Object.assign(Object.assign({}, p), {
      WebkitLineClamp: Ce ? me : void 0
    }),
    component: f,
    ref: composeRef(Oe, T, s),
    direction: S,
    onClick: F.includes("text") ? j : void 0,
    "aria-label": Ee?.toString(),
    title: m
  }, E), /* @__PURE__ */ reactExports.createElement(EllipsisMeasure, {
    enableMeasure: ge && !be,
    text: x,
    rows: me,
    width: we,
    onEllipsis: ue,
    expanded: ie,
    miscDeps: [P, ie, D, R, k, $].concat(_toConsumableArray$e(DECORATION_PROPS.map((Me) => a[Me])))
  }, (Me, Fe) => wrapperDecorations(a, /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, Me.length > 0 && Fe && !ie && Ee ? /* @__PURE__ */ reactExports.createElement("span", {
    key: "show-content",
    "aria-hidden": !0
  }, Me) : Me, Be(Fe)))))));
});
var __rest$6 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Link$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var {
    ellipsis: c,
    rel: u
  } = a, d = __rest$6(a, ["ellipsis", "rel"]);
  const p = Object.assign(Object.assign({}, d), {
    rel: u === void 0 && d.target === "_blank" ? "noopener noreferrer" : u
  });
  return delete p.navigate, /* @__PURE__ */ reactExports.createElement(Base, Object.assign({}, p, {
    ref: s,
    ellipsis: !!c,
    component: "a"
  }));
}), Paragraph = /* @__PURE__ */ reactExports.forwardRef((a, s) => /* @__PURE__ */ reactExports.createElement(Base, Object.assign({
  ref: s
}, a, {
  component: "div"
})));
var __rest$5 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Text$5 = (a, s) => {
  var {
    ellipsis: c
  } = a, u = __rest$5(a, ["ellipsis"]);
  const d = reactExports.useMemo(() => c && typeof c == "object" ? omit(c, ["expandable", "rows"]) : c, [c]);
  return /* @__PURE__ */ reactExports.createElement(Base, Object.assign({
    ref: s
  }, u, {
    ellipsis: d,
    component: "span"
  }));
}, Text$6 = /* @__PURE__ */ reactExports.forwardRef(Text$5);
var __rest$4 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const TITLE_ELE_LIST = [1, 2, 3, 4, 5], Title = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    level: c = 1
  } = a, u = __rest$4(a, ["level"]), d = TITLE_ELE_LIST.includes(c) ? `h${c}` : "h1";
  return /* @__PURE__ */ reactExports.createElement(Base, Object.assign({
    ref: s
  }, u, {
    component: d
  }));
}), Typography = Typography$1;
Typography.Text = Text$6;
Typography.Link = Link$1;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
const attrAccept = function(a, s) {
  if (a && s) {
    var c = Array.isArray(s) ? s : s.split(","), u = a.name || "", d = a.type || "", p = d.replace(/\/.*$/, "");
    return c.some(function(v) {
      var A = v.trim();
      if (/^\*(\/\*)?$/.test(v))
        return !0;
      if (A.charAt(0) === ".") {
        var x = u.toLowerCase(), g = A.toLowerCase(), b = [g];
        return (g === ".jpg" || g === ".jpeg") && (b = [".jpg", ".jpeg"]), b.some(function(y) {
          return x.endsWith(y);
        });
      }
      return /\/\*$/.test(A) ? p === A.replace(/\/.*$/, "") : d === A ? !0 : /^\w+$/.test(A) ? (warningOnce(!1, "Upload takes an invalidate 'accept' type '".concat(A, "'.Skip for check.")), !0) : !1;
    });
  }
  return !0;
};
function getError(a, s) {
  var c = "cannot ".concat(a.method, " ").concat(a.action, " ").concat(s.status, "'"), u = new Error(c);
  return u.status = s.status, u.method = a.method, u.url = a.action, u;
}
function getBody(a) {
  var s = a.responseText || a.response;
  if (!s)
    return s;
  try {
    return JSON.parse(s);
  } catch {
    return s;
  }
}
function upload(a) {
  var s = new XMLHttpRequest();
  a.onProgress && s.upload && (s.upload.onprogress = function(p) {
    p.total > 0 && (p.percent = p.loaded / p.total * 100), a.onProgress(p);
  });
  var c = new FormData();
  a.data && Object.keys(a.data).forEach(function(d) {
    var p = a.data[d];
    if (Array.isArray(p)) {
      p.forEach(function(v) {
        c.append("".concat(d, "[]"), v);
      });
      return;
    }
    c.append(d, p);
  }), a.file instanceof Blob ? c.append(a.filename, a.file, a.file.name) : c.append(a.filename, a.file), s.onerror = function(p) {
    a.onError(p);
  }, s.onload = function() {
    return s.status < 200 || s.status >= 300 ? a.onError(getError(a, s), getBody(s)) : a.onSuccess(getBody(s), s);
  }, s.open(a.method, a.action, !0), a.withCredentials && "withCredentials" in s && (s.withCredentials = !0);
  var u = a.headers || {};
  return u["X-Requested-With"] !== null && s.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(u).forEach(function(d) {
    u[d] !== null && s.setRequestHeader(d, u[d]);
  }), s.send(c), {
    abort: function() {
      s.abort();
    }
  };
}
var traverseFileTree = /* @__PURE__ */ function() {
  var a = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function s(c, u) {
    var d, p, v, A, x, g, b, y;
    return _regeneratorRuntime$3().wrap(function(m) {
      for (; ; ) switch (m.prev = m.next) {
        case 0:
          g = function() {
            return g = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function w(S) {
              return _regeneratorRuntime$3().wrap(function(T) {
                for (; ; ) switch (T.prev = T.next) {
                  case 0:
                    return T.abrupt("return", new Promise(function(I) {
                      S.file(function(_) {
                        u(_) ? (S.fullPath && !_.webkitRelativePath && (Object.defineProperties(_, {
                          webkitRelativePath: {
                            writable: !0
                          }
                        }), _.webkitRelativePath = S.fullPath.replace(/^\//, ""), Object.defineProperties(_, {
                          webkitRelativePath: {
                            writable: !1
                          }
                        })), I(_)) : I(null);
                      });
                    }));
                  case 1:
                  case "end":
                    return T.stop();
                }
              }, w);
            })), g.apply(this, arguments);
          }, x = function(w) {
            return g.apply(this, arguments);
          }, A = function() {
            return A = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function w(S) {
              var $, T, I, _, E;
              return _regeneratorRuntime$3().wrap(function(O) {
                for (; ; ) switch (O.prev = O.next) {
                  case 0:
                    $ = S.createReader(), T = [];
                  case 2:
                    return O.next = 5, new Promise(function(L) {
                      $.readEntries(L, function() {
                        return L([]);
                      });
                    });
                  case 5:
                    if (I = O.sent, _ = I.length, _) {
                      O.next = 9;
                      break;
                    }
                    return O.abrupt("break", 12);
                  case 9:
                    for (E = 0; E < _; E++)
                      T.push(I[E]);
                    O.next = 2;
                    break;
                  case 12:
                    return O.abrupt("return", T);
                  case 13:
                  case "end":
                    return O.stop();
                }
              }, w);
            })), A.apply(this, arguments);
          }, v = function(w) {
            return A.apply(this, arguments);
          }, d = [], p = [], c.forEach(function(C) {
            return p.push(C.webkitGetAsEntry());
          }), b = /* @__PURE__ */ function() {
            var C = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function w(S, $) {
              var T, I;
              return _regeneratorRuntime$3().wrap(function(E) {
                for (; ; ) switch (E.prev = E.next) {
                  case 0:
                    if (S) {
                      E.next = 2;
                      break;
                    }
                    return E.abrupt("return");
                  case 2:
                    if (S.path = $ || "", !S.isFile) {
                      E.next = 10;
                      break;
                    }
                    return E.next = 6, x(S);
                  case 6:
                    T = E.sent, T && d.push(T), E.next = 15;
                    break;
                  case 10:
                    if (!S.isDirectory) {
                      E.next = 15;
                      break;
                    }
                    return E.next = 13, v(S);
                  case 13:
                    I = E.sent, p.push.apply(p, _toConsumableArray$e(I));
                  case 15:
                  case "end":
                    return E.stop();
                }
              }, w);
            }));
            return function(S, $) {
              return C.apply(this, arguments);
            };
          }(), y = 0;
        case 9:
          if (!(y < p.length)) {
            m.next = 15;
            break;
          }
          return m.next = 12, b(p[y]);
        case 12:
          y++, m.next = 9;
          break;
        case 15:
          return m.abrupt("return", d);
        case 16:
        case "end":
          return m.stop();
      }
    }, s);
  }));
  return function(c, u) {
    return a.apply(this, arguments);
  };
}(), now$1 = +/* @__PURE__ */ new Date(), index$2 = 0;
function uid() {
  return "rc-upload-".concat(now$1, "-").concat(++index$2);
}
var _excluded$1 = ["component", "prefixCls", "className", "classNames", "disabled", "id", "name", "style", "styles", "multiple", "accept", "capture", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave", "hasControlInside"], AjaxUploader = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c() {
    var u;
    _classCallCheck$1(this, c);
    for (var d = arguments.length, p = new Array(d), v = 0; v < d; v++)
      p[v] = arguments[v];
    return u = s.call.apply(s, [this].concat(p)), _defineProperty$a(_assertThisInitialized(u), "state", {
      uid: uid()
    }), _defineProperty$a(_assertThisInitialized(u), "reqs", {}), _defineProperty$a(_assertThisInitialized(u), "fileInput", void 0), _defineProperty$a(_assertThisInitialized(u), "_isMounted", void 0), _defineProperty$a(_assertThisInitialized(u), "onChange", function(A) {
      var x = u.props, g = x.accept, b = x.directory, y = A.target.files, f = _toConsumableArray$e(y).filter(function(m) {
        return !b || attrAccept(m, g);
      });
      u.uploadFiles(f), u.reset();
    }), _defineProperty$a(_assertThisInitialized(u), "onClick", function(A) {
      var x = u.fileInput;
      if (x) {
        var g = A.target, b = u.props.onClick;
        if (g && g.tagName === "BUTTON") {
          var y = x.parentNode;
          y.focus(), g.blur();
        }
        x.click(), b && b(A);
      }
    }), _defineProperty$a(_assertThisInitialized(u), "onKeyDown", function(A) {
      A.key === "Enter" && u.onClick(A);
    }), _defineProperty$a(_assertThisInitialized(u), "onDataTransferFiles", /* @__PURE__ */ function() {
      var A = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function x(g, b) {
        var y, f, m, C, w, S, $;
        return _regeneratorRuntime$3().wrap(function(I) {
          for (; ; ) switch (I.prev = I.next) {
            case 0:
              if (y = u.props, f = y.multiple, m = y.accept, C = y.directory, w = _toConsumableArray$e(g.items || []), S = _toConsumableArray$e(g.files || []), (S.length > 0 || w.some(function(_) {
                return _.kind === "file";
              })) && b?.(), !C) {
                I.next = 11;
                break;
              }
              return I.next = 7, traverseFileTree(Array.prototype.slice.call(w), function(_) {
                return attrAccept(_, u.props.accept);
              });
            case 7:
              S = I.sent, u.uploadFiles(S), I.next = 14;
              break;
            case 11:
              $ = _toConsumableArray$e(S).filter(function(_) {
                return attrAccept(_, m);
              }), f === !1 && ($ = S.slice(0, 1)), u.uploadFiles($);
            case 14:
            case "end":
              return I.stop();
          }
        }, x);
      }));
      return function(x, g) {
        return A.apply(this, arguments);
      };
    }()), _defineProperty$a(_assertThisInitialized(u), "onFilePaste", /* @__PURE__ */ function() {
      var A = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function x(g) {
        var b, y;
        return _regeneratorRuntime$3().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if (b = u.props.pastable, b) {
                m.next = 3;
                break;
              }
              return m.abrupt("return");
            case 3:
              if (g.type !== "paste") {
                m.next = 6;
                break;
              }
              return y = g.clipboardData, m.abrupt("return", u.onDataTransferFiles(y, function() {
                g.preventDefault();
              }));
            case 6:
            case "end":
              return m.stop();
          }
        }, x);
      }));
      return function(x) {
        return A.apply(this, arguments);
      };
    }()), _defineProperty$a(_assertThisInitialized(u), "onFileDragOver", function(A) {
      A.preventDefault();
    }), _defineProperty$a(_assertThisInitialized(u), "onFileDrop", /* @__PURE__ */ function() {
      var A = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function x(g) {
        var b;
        return _regeneratorRuntime$3().wrap(function(f) {
          for (; ; ) switch (f.prev = f.next) {
            case 0:
              if (g.preventDefault(), g.type !== "drop") {
                f.next = 4;
                break;
              }
              return b = g.dataTransfer, f.abrupt("return", u.onDataTransferFiles(b));
            case 4:
            case "end":
              return f.stop();
          }
        }, x);
      }));
      return function(x) {
        return A.apply(this, arguments);
      };
    }()), _defineProperty$a(_assertThisInitialized(u), "uploadFiles", function(A) {
      var x = _toConsumableArray$e(A), g = x.map(function(b) {
        return b.uid = uid(), u.processFile(b, x);
      });
      Promise.all(g).then(function(b) {
        var y = u.props.onBatchStart;
        y?.(b.map(function(f) {
          var m = f.origin, C = f.parsedFile;
          return {
            file: m,
            parsedFile: C
          };
        })), b.filter(function(f) {
          return f.parsedFile !== null;
        }).forEach(function(f) {
          u.post(f);
        });
      });
    }), _defineProperty$a(_assertThisInitialized(u), "processFile", /* @__PURE__ */ function() {
      var A = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function x(g, b) {
        var y, f, m, C, w, S, $, T, I;
        return _regeneratorRuntime$3().wrap(function(E) {
          for (; ; ) switch (E.prev = E.next) {
            case 0:
              if (y = u.props.beforeUpload, f = g, !y) {
                E.next = 14;
                break;
              }
              return E.prev = 3, E.next = 6, y(g, b);
            case 6:
              f = E.sent, E.next = 12;
              break;
            case 9:
              E.prev = 9, E.t0 = E.catch(3), f = !1;
            case 12:
              if (f !== !1) {
                E.next = 14;
                break;
              }
              return E.abrupt("return", {
                origin: g,
                parsedFile: null,
                action: null,
                data: null
              });
            case 14:
              if (m = u.props.action, typeof m != "function") {
                E.next = 21;
                break;
              }
              return E.next = 18, m(g);
            case 18:
              C = E.sent, E.next = 22;
              break;
            case 21:
              C = m;
            case 22:
              if (w = u.props.data, typeof w != "function") {
                E.next = 29;
                break;
              }
              return E.next = 26, w(g);
            case 26:
              S = E.sent, E.next = 30;
              break;
            case 29:
              S = w;
            case 30:
              return $ = // string type is from legacy `transformFile`.
              // Not sure if this will work since no related test case works with it
              (_typeof$h(f) === "object" || typeof f == "string") && f ? f : g, $ instanceof File ? T = $ : T = new File([$], g.name, {
                type: g.type
              }), I = T, I.uid = g.uid, E.abrupt("return", {
                origin: g,
                data: S,
                parsedFile: I,
                action: C
              });
            case 35:
            case "end":
              return E.stop();
          }
        }, x, null, [[3, 9]]);
      }));
      return function(x, g) {
        return A.apply(this, arguments);
      };
    }()), _defineProperty$a(_assertThisInitialized(u), "saveFileInput", function(A) {
      u.fileInput = A;
    }), u;
  }
  return _createClass$1(c, [{
    key: "componentDidMount",
    value: function() {
      this._isMounted = !0;
      var d = this.props.pastable;
      d && document.addEventListener("paste", this.onFilePaste);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._isMounted = !1, this.abort(), document.removeEventListener("paste", this.onFilePaste);
    }
  }, {
    key: "componentDidUpdate",
    value: function(d) {
      var p = this.props.pastable;
      p && !d.pastable ? document.addEventListener("paste", this.onFilePaste) : !p && d.pastable && document.removeEventListener("paste", this.onFilePaste);
    }
  }, {
    key: "post",
    value: function(d) {
      var p = this, v = d.data, A = d.origin, x = d.action, g = d.parsedFile;
      if (this._isMounted) {
        var b = this.props, y = b.onStart, f = b.customRequest, m = b.name, C = b.headers, w = b.withCredentials, S = b.method, $ = A.uid, T = f || upload, I = {
          action: x,
          filename: m,
          data: v,
          file: g,
          headers: C,
          withCredentials: w,
          method: S || "post",
          onProgress: function(E) {
            var R = p.props.onProgress;
            R?.(E, g);
          },
          onSuccess: function(E, R) {
            var O = p.props.onSuccess;
            O?.(E, g, R), delete p.reqs[$];
          },
          onError: function(E, R) {
            var O = p.props.onError;
            O?.(E, R, g), delete p.reqs[$];
          }
        };
        y(A), this.reqs[$] = T(I);
      }
    }
  }, {
    key: "reset",
    value: function() {
      this.setState({
        uid: uid()
      });
    }
  }, {
    key: "abort",
    value: function(d) {
      var p = this.reqs;
      if (d) {
        var v = d.uid ? d.uid : d;
        p[v] && p[v].abort && p[v].abort(), delete p[v];
      } else
        Object.keys(p).forEach(function(A) {
          p[A] && p[A].abort && p[A].abort(), delete p[A];
        });
    }
  }, {
    key: "render",
    value: function() {
      var d = this.props, p = d.component, v = d.prefixCls, A = d.className, x = d.classNames, g = x === void 0 ? {} : x, b = d.disabled, y = d.id, f = d.name, m = d.style, C = d.styles, w = C === void 0 ? {} : C, S = d.multiple, $ = d.accept, T = d.capture, I = d.children, _ = d.directory, E = d.openFileDialogOnClick, R = d.onMouseEnter, O = d.onMouseLeave, L = d.hasControlInside, B = _objectWithoutProperties$2(d, _excluded$1), F = classnames(_defineProperty$a(_defineProperty$a(_defineProperty$a({}, v, !0), "".concat(v, "-disabled"), b), A, A)), M = _ ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {}, W = b ? {} : {
        onClick: E ? this.onClick : function() {
        },
        onKeyDown: E ? this.onKeyDown : function() {
        },
        onMouseEnter: R,
        onMouseLeave: O,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDragOver,
        tabIndex: L ? void 0 : "0"
      };
      return /* @__PURE__ */ React.createElement(p, _extends$3({}, W, {
        className: F,
        role: L ? void 0 : "button",
        style: m
      }), /* @__PURE__ */ React.createElement("input", _extends$3({}, pickAttrs(B, {
        aria: !0,
        data: !0
      }), {
        id: y,
        name: f,
        disabled: b,
        type: "file",
        ref: this.saveFileInput,
        onClick: function(G) {
          return G.stopPropagation();
        },
        key: this.state.uid,
        style: _objectSpread2$1({
          display: "none"
        }, w.input),
        className: g.input,
        accept: $
      }, M, {
        multiple: S,
        onChange: this.onChange
      }, T != null ? {
        capture: T
      } : {})), I);
    }
  }]), c;
}(reactExports.Component);
function empty() {
}
var Upload$2 = /* @__PURE__ */ function(a) {
  _inherits$1(c, a);
  var s = _createSuper(c);
  function c() {
    var u;
    _classCallCheck$1(this, c);
    for (var d = arguments.length, p = new Array(d), v = 0; v < d; v++)
      p[v] = arguments[v];
    return u = s.call.apply(s, [this].concat(p)), _defineProperty$a(_assertThisInitialized(u), "uploader", void 0), _defineProperty$a(_assertThisInitialized(u), "saveUploader", function(A) {
      u.uploader = A;
    }), u;
  }
  return _createClass$1(c, [{
    key: "abort",
    value: function(d) {
      this.uploader.abort(d);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ React.createElement(AjaxUploader, _extends$3({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]), c;
}(reactExports.Component);
_defineProperty$a(Upload$2, "defaultProps", {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: !1,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  multiple: !1,
  beforeUpload: null,
  customRequest: null,
  withCredentials: !1,
  openFileDialogOnClick: !0,
  hasControlInside: !1
});
const genDraggerStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c
  } = a;
  return {
    [`${s}-wrapper`]: {
      [`${s}-drag`]: {
        position: "relative",
        width: "100%",
        height: "100%",
        textAlign: "center",
        background: a.colorFillAlter,
        border: `${unit$1(a.lineWidth)} dashed ${a.colorBorder}`,
        borderRadius: a.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${a.motionDurationSlow}`,
        [s]: {
          padding: a.padding
        },
        [`${s}-btn`]: {
          display: "table",
          width: "100%",
          height: "100%",
          outline: "none",
          borderRadius: a.borderRadiusLG,
          "&:focus-visible": {
            outline: `${unit$1(a.lineWidthFocus)} solid ${a.colorPrimaryBorder}`
          }
        },
        [`${s}-drag-container`]: {
          display: "table-cell",
          verticalAlign: "middle"
        },
        [`
          &:not(${s}-disabled):hover,
          &-hover:not(${s}-disabled)
        `]: {
          borderColor: a.colorPrimaryHover
        },
        [`p${s}-drag-icon`]: {
          marginBottom: a.margin,
          [c]: {
            color: a.colorPrimary,
            fontSize: a.uploadThumbnailSize
          }
        },
        [`p${s}-text`]: {
          margin: `0 0 ${unit$1(a.marginXXS)}`,
          color: a.colorTextHeading,
          fontSize: a.fontSizeLG
        },
        [`p${s}-hint`]: {
          color: a.colorTextDescription,
          fontSize: a.fontSize
        },
        // ===================== Disabled =====================
        [`&${s}-disabled`]: {
          [`p${s}-drag-icon ${c},
            p${s}-text,
            p${s}-hint
          `]: {
            color: a.colorTextDisabled
          }
        }
      }
    }
  };
}, genListStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    fontSize: u,
    lineHeight: d,
    calc: p
  } = a, v = `${s}-list-item`, A = `${v}-actions`, x = `${v}-action`;
  return {
    [`${s}-wrapper`]: {
      [`${s}-list`]: Object.assign(Object.assign({}, clearFix()), {
        lineHeight: a.lineHeight,
        [v]: {
          position: "relative",
          height: p(a.lineHeight).mul(u).equal(),
          marginTop: a.marginXS,
          fontSize: u,
          display: "flex",
          alignItems: "center",
          transition: `background-color ${a.motionDurationSlow}`,
          borderRadius: a.borderRadiusSM,
          "&:hover": {
            backgroundColor: a.controlItemBgHover
          },
          [`${v}-name`]: Object.assign(Object.assign({}, textEllipsis), {
            padding: `0 ${unit$1(a.paddingXS)}`,
            lineHeight: d,
            flex: "auto",
            transition: `all ${a.motionDurationSlow}`
          }),
          [A]: {
            whiteSpace: "nowrap",
            [x]: {
              opacity: 0
            },
            [c]: {
              color: a.actionsColor,
              transition: `all ${a.motionDurationSlow}`
            },
            [`
              ${x}:focus-visible,
              &.picture ${x}
            `]: {
              opacity: 1
            }
          },
          [`${s}-icon ${c}`]: {
            color: a.colorIcon,
            fontSize: u
          },
          [`${v}-progress`]: {
            position: "absolute",
            bottom: a.calc(a.uploadProgressOffset).mul(-1).equal(),
            width: "100%",
            paddingInlineStart: p(u).add(a.paddingXS).equal(),
            fontSize: u,
            lineHeight: 0,
            pointerEvents: "none",
            "> div": {
              margin: 0
            }
          }
        },
        [`${v}:hover ${x}`]: {
          opacity: 1
        },
        [`${v}-error`]: {
          color: a.colorError,
          [`${v}-name, ${s}-icon ${c}`]: {
            color: a.colorError
          },
          [A]: {
            [`${c}, ${c}:hover`]: {
              color: a.colorError
            },
            [x]: {
              opacity: 1
            }
          }
        },
        [`${s}-list-item-container`]: {
          transition: `opacity ${a.motionDurationSlow}, height ${a.motionDurationSlow}`,
          // For smooth removing animation
          "&::before": {
            display: "table",
            width: 0,
            height: 0,
            content: '""'
          }
        }
      })
    }
  };
}, genMotionStyle = (a) => {
  const {
    componentCls: s
  } = a, c = new Keyframe("uploadAnimateInlineIn", {
    from: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: a.calc(a.marginXS).div(-2).equal()
    }
  }), u = new Keyframe("uploadAnimateInlineOut", {
    to: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: a.calc(a.marginXS).div(-2).equal()
    }
  }), d = `${s}-animate-inline`;
  return [{
    [`${s}-wrapper`]: {
      [`${d}-appear, ${d}-enter, ${d}-leave`]: {
        animationDuration: a.motionDurationSlow,
        animationTimingFunction: a.motionEaseInOutCirc,
        animationFillMode: "forwards"
      },
      [`${d}-appear, ${d}-enter`]: {
        animationName: c
      },
      [`${d}-leave`]: {
        animationName: u
      }
    }
  }, {
    [`${s}-wrapper`]: initFadeMotion(a)
  }, c, u];
}, genPictureStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    uploadThumbnailSize: u,
    uploadProgressOffset: d,
    calc: p
  } = a, v = `${s}-list`, A = `${v}-item`;
  return {
    [`${s}-wrapper`]: {
      // ${listCls} 增加优先级
      [`
        ${v}${v}-picture,
        ${v}${v}-picture-card,
        ${v}${v}-picture-circle
      `]: {
        [A]: {
          position: "relative",
          height: p(u).add(p(a.lineWidth).mul(2)).add(p(a.paddingXS).mul(2)).equal(),
          padding: a.paddingXS,
          border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
          borderRadius: a.borderRadiusLG,
          "&:hover": {
            background: "transparent"
          },
          [`${A}-thumbnail`]: Object.assign(Object.assign({}, textEllipsis), {
            width: u,
            height: u,
            lineHeight: unit$1(p(u).add(a.paddingSM).equal()),
            textAlign: "center",
            flex: "none",
            [c]: {
              fontSize: a.fontSizeHeading2,
              color: a.colorPrimary
            },
            img: {
              display: "block",
              width: "100%",
              height: "100%",
              overflow: "hidden"
            }
          }),
          [`${A}-progress`]: {
            bottom: d,
            width: `calc(100% - ${unit$1(p(a.paddingSM).mul(2).equal())})`,
            marginTop: 0,
            paddingInlineStart: p(u).add(a.paddingXS).equal()
          }
        },
        [`${A}-error`]: {
          borderColor: a.colorError,
          // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
          [`${A}-thumbnail ${c}`]: {
            [`svg path[fill='${blue$1[0]}']`]: {
              fill: a.colorErrorBg
            },
            [`svg path[fill='${blue$1.primary}']`]: {
              fill: a.colorError
            }
          }
        },
        [`${A}-uploading`]: {
          borderStyle: "dashed",
          [`${A}-name`]: {
            marginBottom: d
          }
        }
      },
      [`${v}${v}-picture-circle ${A}`]: {
        [`&, &::before, ${A}-thumbnail`]: {
          borderRadius: "50%"
        }
      }
    }
  };
}, genPictureCardStyle = (a) => {
  const {
    componentCls: s,
    iconCls: c,
    fontSizeLG: u,
    colorTextLightSolid: d,
    calc: p
  } = a, v = `${s}-list`, A = `${v}-item`, x = a.uploadPicCardSize;
  return {
    [`
      ${s}-wrapper${s}-picture-card-wrapper,
      ${s}-wrapper${s}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, clearFix()), {
      display: "block",
      [`${s}${s}-select`]: {
        width: x,
        height: x,
        textAlign: "center",
        verticalAlign: "top",
        backgroundColor: a.colorFillAlter,
        border: `${unit$1(a.lineWidth)} dashed ${a.colorBorder}`,
        borderRadius: a.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${a.motionDurationSlow}`,
        [`> ${s}`]: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center"
        },
        [`&:not(${s}-disabled):hover`]: {
          borderColor: a.colorPrimary
        }
      },
      // list
      [`${v}${v}-picture-card, ${v}${v}-picture-circle`]: {
        display: "flex",
        flexWrap: "wrap",
        "@supports not (gap: 1px)": {
          "& > *": {
            marginBlockEnd: a.marginXS,
            marginInlineEnd: a.marginXS
          }
        },
        "@supports (gap: 1px)": {
          gap: a.marginXS
        },
        [`${v}-item-container`]: {
          display: "inline-block",
          width: x,
          height: x,
          verticalAlign: "top"
        },
        "&::after": {
          display: "none"
        },
        "&::before": {
          display: "none"
        },
        [A]: {
          height: "100%",
          margin: 0,
          "&::before": {
            position: "absolute",
            zIndex: 1,
            width: `calc(100% - ${unit$1(p(a.paddingXS).mul(2).equal())})`,
            height: `calc(100% - ${unit$1(p(a.paddingXS).mul(2).equal())})`,
            backgroundColor: a.colorBgMask,
            opacity: 0,
            transition: `all ${a.motionDurationSlow}`,
            content: '" "'
          }
        },
        [`${A}:hover`]: {
          [`&::before, ${A}-actions`]: {
            opacity: 1
          }
        },
        [`${A}-actions`]: {
          position: "absolute",
          insetInlineStart: 0,
          zIndex: 10,
          width: "100%",
          whiteSpace: "nowrap",
          textAlign: "center",
          opacity: 0,
          transition: `all ${a.motionDurationSlow}`,
          [`
            ${c}-eye,
            ${c}-download,
            ${c}-delete
          `]: {
            zIndex: 10,
            width: u,
            margin: `0 ${unit$1(a.marginXXS)}`,
            fontSize: u,
            cursor: "pointer",
            transition: `all ${a.motionDurationSlow}`,
            color: d,
            "&:hover": {
              color: d
            },
            svg: {
              verticalAlign: "baseline"
            }
          }
        },
        [`${A}-thumbnail, ${A}-thumbnail img`]: {
          position: "static",
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain"
        },
        [`${A}-name`]: {
          display: "none",
          textAlign: "center"
        },
        [`${A}-file + ${A}-name`]: {
          position: "absolute",
          bottom: a.margin,
          display: "block",
          width: `calc(100% - ${unit$1(p(a.paddingXS).mul(2).equal())})`
        },
        [`${A}-uploading`]: {
          [`&${A}`]: {
            backgroundColor: a.colorFillAlter
          },
          [`&::before, ${c}-eye, ${c}-download, ${c}-delete`]: {
            display: "none"
          }
        },
        [`${A}-progress`]: {
          bottom: a.marginXL,
          width: `calc(100% - ${unit$1(p(a.paddingXS).mul(2).equal())})`,
          paddingInlineStart: 0
        }
      }
    }),
    [`${s}-wrapper${s}-picture-circle-wrapper`]: {
      [`${s}${s}-select`]: {
        borderRadius: "50%"
      }
    }
  };
}, genRtlStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-rtl`]: {
      direction: "rtl"
    }
  };
}, genBaseStyle = (a) => {
  const {
    componentCls: s,
    colorTextDisabled: c
  } = a;
  return {
    [`${s}-wrapper`]: Object.assign(Object.assign({}, resetComponent(a)), {
      [s]: {
        outline: 0,
        "input[type='file']": {
          cursor: "pointer"
        }
      },
      [`${s}-select`]: {
        display: "inline-block"
      },
      [`${s}-hidden`]: {
        display: "none"
      },
      [`${s}-disabled`]: {
        color: c,
        cursor: "not-allowed"
      }
    })
  };
}, prepareComponentToken = (a) => ({
  actionsColor: a.colorIcon
}), useStyle = genStyleHooks("Upload", (a) => {
  const {
    fontSizeHeading3: s,
    fontHeight: c,
    lineWidth: u,
    controlHeightLG: d,
    calc: p
  } = a, v = merge(a, {
    uploadThumbnailSize: p(s).mul(2).equal(),
    uploadProgressOffset: p(p(c).div(2)).add(u).equal(),
    uploadPicCardSize: p(d).mul(2.55).equal()
  });
  return [genBaseStyle(v), genDraggerStyle(v), genPictureStyle(v), genPictureCardStyle(v), genListStyle(v), genMotionStyle(v), genRtlStyle(v), genCollapseMotion(v)];
}, prepareComponentToken);
function file2Obj(a) {
  return Object.assign(Object.assign({}, a), {
    lastModified: a.lastModified,
    lastModifiedDate: a.lastModifiedDate,
    name: a.name,
    size: a.size,
    type: a.type,
    uid: a.uid,
    percent: 0,
    originFileObj: a
  });
}
function updateFileList(a, s) {
  const c = _toConsumableArray$e(s), u = c.findIndex(({
    uid: d
  }) => d === a.uid);
  return u === -1 ? c.push(a) : c[u] = a, c;
}
function getFileItem(a, s) {
  const c = a.uid !== void 0 ? "uid" : "name";
  return s.filter((u) => u[c] === a[c])[0];
}
function removeFileItem(a, s) {
  const c = a.uid !== void 0 ? "uid" : "name", u = s.filter((d) => d[c] !== a[c]);
  return u.length === s.length ? null : u;
}
const extname = (a = "") => {
  const s = a.split("/"), u = s[s.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(u) || [""])[0];
}, isImageFileType = (a) => a.indexOf("image/") === 0, isImageUrl = (a) => {
  if (a.type && !a.thumbUrl)
    return isImageFileType(a.type);
  const s = a.thumbUrl || a.url || "", c = extname(s);
  return /^data:image\//.test(s) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(c) ? !0 : !(/^data:/.test(s) || c);
}, MEASURE_SIZE = 200;
function previewImage(a) {
  return new Promise((s) => {
    if (!a.type || !isImageFileType(a.type)) {
      s("");
      return;
    }
    const c = document.createElement("canvas");
    c.width = MEASURE_SIZE, c.height = MEASURE_SIZE, c.style.cssText = `position: fixed; left: 0; top: 0; width: ${MEASURE_SIZE}px; height: ${MEASURE_SIZE}px; z-index: 9999; display: none;`, document.body.appendChild(c);
    const u = c.getContext("2d"), d = new Image();
    if (d.onload = () => {
      const {
        width: p,
        height: v
      } = d;
      let A = MEASURE_SIZE, x = MEASURE_SIZE, g = 0, b = 0;
      p > v ? (x = v * (MEASURE_SIZE / p), b = -(x - A) / 2) : (A = p * (MEASURE_SIZE / v), g = -(A - x) / 2), u.drawImage(d, g, b, A, x);
      const y = c.toDataURL();
      document.body.removeChild(c), window.URL.revokeObjectURL(d.src), s(y);
    }, d.crossOrigin = "anonymous", a.type.startsWith("image/svg+xml")) {
      const p = new FileReader();
      p.onload = () => {
        p.result && typeof p.result == "string" && (d.src = p.result);
      }, p.readAsDataURL(a);
    } else if (a.type.startsWith("image/gif")) {
      const p = new FileReader();
      p.onload = () => {
        p.result && s(p.result);
      }, p.readAsDataURL(a);
    } else
      d.src = window.URL.createObjectURL(a);
  });
}
const ListItem = /* @__PURE__ */ reactExports.forwardRef(({
  prefixCls: a,
  className: s,
  style: c,
  locale: u,
  listType: d,
  file: p,
  items: v,
  progress: A,
  iconRender: x,
  actionIconRender: g,
  itemRender: b,
  isImgUrl: y,
  showPreviewIcon: f,
  showRemoveIcon: m,
  showDownloadIcon: C,
  previewIcon: w,
  removeIcon: S,
  downloadIcon: $,
  extra: T,
  onPreview: I,
  onDownload: _,
  onClose: E
}, R) => {
  var O, L;
  const {
    status: B
  } = p, [F, M] = reactExports.useState(B);
  reactExports.useEffect(() => {
    B !== "removed" && M(B);
  }, [B]);
  const [W, j] = reactExports.useState(!1);
  reactExports.useEffect(() => {
    const se = setTimeout(() => {
      j(!0);
    }, 300);
    return () => {
      clearTimeout(se);
    };
  }, []);
  const G = x(p);
  let U = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${a}-icon`
  }, G);
  if (d === "picture" || d === "picture-card" || d === "picture-circle")
    if (F === "uploading" || !p.thumbUrl && !p.url) {
      const se = classnames(`${a}-list-item-thumbnail`, {
        [`${a}-list-item-file`]: F !== "uploading"
      });
      U = /* @__PURE__ */ reactExports.createElement("div", {
        className: se
      }, G);
    } else {
      const se = y?.(p) ? /* @__PURE__ */ reactExports.createElement("img", {
        src: p.thumbUrl || p.url,
        alt: p.name,
        className: `${a}-list-item-image`,
        crossOrigin: p.crossOrigin
      }) : G, ie = classnames(`${a}-list-item-thumbnail`, {
        [`${a}-list-item-file`]: y && !y(p)
      });
      U = /* @__PURE__ */ reactExports.createElement("a", {
        className: ie,
        onClick: (fe) => I(p, fe),
        href: p.url || p.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, se);
    }
  const k = classnames(`${a}-list-item`, `${a}-list-item-${F}`), N = typeof p.linkProps == "string" ? JSON.parse(p.linkProps) : p.linkProps, P = (typeof m == "function" ? m(p) : m) ? g(
    (typeof S == "function" ? S(p) : S) || /* @__PURE__ */ reactExports.createElement(RefIcon$f, null),
    () => E(p),
    a,
    u.removeFile,
    // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    !0
  ) : null, D = (typeof C == "function" ? C(p) : C) && F === "done" ? g((typeof $ == "function" ? $(p) : $) || /* @__PURE__ */ reactExports.createElement(RefIcon$e, null), () => _(p), a, u.downloadFile) : null, H = d !== "picture-card" && d !== "picture-circle" && /* @__PURE__ */ reactExports.createElement("span", {
    key: "download-delete",
    className: classnames(`${a}-list-item-actions`, {
      picture: d === "picture"
    })
  }, D, P), V = typeof T == "function" ? T(p) : T, Z = V && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${a}-list-item-extra`
  }, V), ne = classnames(`${a}-list-item-name`), K = p.url ? /* @__PURE__ */ reactExports.createElement("a", Object.assign({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: ne,
    title: p.name
  }, N, {
    href: p.url,
    onClick: (se) => I(p, se)
  }), p.name, Z) : /* @__PURE__ */ reactExports.createElement("span", {
    key: "view",
    className: ne,
    onClick: (se) => I(p, se),
    title: p.name
  }, p.name, Z), q = (typeof f == "function" ? f(p) : f) && (p.url || p.thumbUrl) ? /* @__PURE__ */ reactExports.createElement("a", {
    href: p.url || p.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (se) => I(p, se),
    title: u.previewFile
  }, typeof w == "function" ? w(p) : w || /* @__PURE__ */ reactExports.createElement(RefIcon$s, null)) : null, Y = (d === "picture-card" || d === "picture-circle") && F !== "uploading" && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${a}-list-item-actions`
  }, q, F === "done" && D, P), {
    getPrefixCls: ee
  } = reactExports.useContext(ConfigContext$1), Q = ee(), J = /* @__PURE__ */ reactExports.createElement("div", {
    className: k
  }, U, K, H, Y, W && /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    motionName: `${Q}-fade`,
    visible: F === "uploading",
    motionDeadline: 2e3
  }, ({
    className: se
  }) => {
    const ie = "percent" in p ? /* @__PURE__ */ reactExports.createElement(Progress, Object.assign({
      type: "line",
      percent: p.percent,
      "aria-label": p["aria-label"],
      "aria-labelledby": p["aria-labelledby"]
    }, A)) : null;
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames(`${a}-list-item-progress`, se)
    }, ie);
  })), te = p.response && typeof p.response == "string" ? p.response : ((O = p.error) === null || O === void 0 ? void 0 : O.statusText) || ((L = p.error) === null || L === void 0 ? void 0 : L.message) || u.uploadError, ae = F === "error" ? /* @__PURE__ */ reactExports.createElement(Tooltip, {
    title: te,
    getPopupContainer: (se) => se.parentNode
  }, J) : J;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${a}-list-item-container`, s),
    style: c,
    ref: R
  }, b ? b(ae, p, v, {
    download: _.bind(null, p),
    preview: I.bind(null, p),
    remove: E.bind(null, p)
  }) : ae);
}), InternalUploadList = (a, s) => {
  const {
    listType: c = "text",
    previewFile: u = previewImage,
    onPreview: d,
    onDownload: p,
    onRemove: v,
    locale: A,
    iconRender: x,
    isImageUrl: g = isImageUrl,
    prefixCls: b,
    items: y = [],
    showPreviewIcon: f = !0,
    showRemoveIcon: m = !0,
    showDownloadIcon: C = !1,
    removeIcon: w,
    previewIcon: S,
    downloadIcon: $,
    extra: T,
    progress: I = {
      size: [-1, 2],
      showInfo: !1
    },
    appendAction: _,
    appendActionVisible: E = !0,
    itemRender: R,
    disabled: O
  } = a, L = useForceUpdate(), [B, F] = reactExports.useState(!1), M = ["picture-card", "picture-circle"].includes(c);
  reactExports.useEffect(() => {
    c.startsWith("picture") && (y || []).forEach((ne) => {
      !(ne.originFileObj instanceof File || ne.originFileObj instanceof Blob) || ne.thumbUrl !== void 0 || (ne.thumbUrl = "", u?.(ne.originFileObj).then((K) => {
        ne.thumbUrl = K || "", L();
      }));
    });
  }, [c, y, u]), reactExports.useEffect(() => {
    F(!0);
  }, []);
  const W = (ne, K) => {
    if (d)
      return K?.preventDefault(), d(ne);
  }, j = (ne) => {
    typeof p == "function" ? p(ne) : ne.url && window.open(ne.url);
  }, G = (ne) => {
    v?.(ne);
  }, U = (ne) => {
    if (x)
      return x(ne, c);
    const K = ne.status === "uploading";
    if (c.startsWith("picture")) {
      const q = c === "picture" ? /* @__PURE__ */ reactExports.createElement(RefIcon$F, null) : A.uploading, Y = g?.(ne) ? /* @__PURE__ */ reactExports.createElement(RefIcon$3, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$a, null);
      return K ? q : Y;
    }
    return K ? /* @__PURE__ */ reactExports.createElement(RefIcon$F, null) : /* @__PURE__ */ reactExports.createElement(RefIcon$4, null);
  }, k = (ne, K, q, Y, ee) => {
    const Q = {
      type: "text",
      size: "small",
      title: Y,
      onClick: (J) => {
        var te, ae;
        K(), /* @__PURE__ */ reactExports.isValidElement(ne) && ((ae = (te = ne.props).onClick) === null || ae === void 0 || ae.call(te, J));
      },
      className: `${q}-list-item-action`,
      disabled: ee ? O : !1
    };
    return /* @__PURE__ */ reactExports.isValidElement(ne) ? /* @__PURE__ */ reactExports.createElement(Button$1, Object.assign({}, Q, {
      icon: cloneElement(ne, Object.assign(Object.assign({}, ne.props), {
        onClick: () => {
        }
      }))
    })) : /* @__PURE__ */ reactExports.createElement(Button$1, Object.assign({}, Q), /* @__PURE__ */ reactExports.createElement("span", null, ne));
  };
  reactExports.useImperativeHandle(s, () => ({
    handlePreview: W,
    handleDownload: j
  }));
  const {
    getPrefixCls: N
  } = reactExports.useContext(ConfigContext$1), P = N("upload", b), D = N(), H = classnames(`${P}-list`, `${P}-list-${c}`), V = reactExports.useMemo(() => omit(initCollapseMotion(D), ["onAppearEnd", "onEnterEnd", "onLeaveEnd"]), [D]), Z = Object.assign(Object.assign({}, M ? {} : V), {
    motionDeadline: 2e3,
    motionName: `${P}-${M ? "animate-inline" : "animate"}`,
    keys: _toConsumableArray$e(y.map((ne) => ({
      key: ne.uid,
      file: ne
    }))),
    motionAppear: B
  });
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: H
  }, /* @__PURE__ */ reactExports.createElement(CSSMotionList, Object.assign({}, Z, {
    component: !1
  }), ({
    key: ne,
    file: K,
    className: q,
    style: Y
  }) => /* @__PURE__ */ reactExports.createElement(ListItem, {
    key: ne,
    locale: A,
    prefixCls: P,
    className: q,
    style: Y,
    file: K,
    items: y,
    progress: I,
    listType: c,
    isImgUrl: g,
    showPreviewIcon: f,
    showRemoveIcon: m,
    showDownloadIcon: C,
    removeIcon: w,
    previewIcon: S,
    downloadIcon: $,
    extra: T,
    iconRender: U,
    actionIconRender: k,
    itemRender: R,
    onPreview: W,
    onDownload: j,
    onClose: G
  })), _ && /* @__PURE__ */ reactExports.createElement(CSSMotion, Object.assign({}, Z, {
    visible: E,
    forceRender: !0
  }), ({
    className: ne,
    style: K
  }) => cloneElement(_, (q) => ({
    className: classnames(q.className, ne),
    style: Object.assign(Object.assign(Object.assign({}, K), {
      // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
      pointerEvents: ne ? "none" : void 0
    }), q.style)
  }))));
}, UploadList = /* @__PURE__ */ reactExports.forwardRef(InternalUploadList);
var __awaiter = function(a, s, c, u) {
  function d(p) {
    return p instanceof c ? p : new c(function(v) {
      v(p);
    });
  }
  return new (c || (c = Promise))(function(p, v) {
    function A(b) {
      try {
        g(u.next(b));
      } catch (y) {
        v(y);
      }
    }
    function x(b) {
      try {
        g(u.throw(b));
      } catch (y) {
        v(y);
      }
    }
    function g(b) {
      b.done ? p(b.value) : d(b.value).then(A, x);
    }
    g((u = u.apply(a, [])).next());
  });
};
const LIST_IGNORE = `__LIST_IGNORE_${Date.now()}__`, InternalUpload = (a, s) => {
  const {
    fileList: c,
    defaultFileList: u,
    onRemove: d,
    showUploadList: p = !0,
    listType: v = "text",
    onPreview: A,
    onDownload: x,
    onChange: g,
    onDrop: b,
    previewFile: y,
    disabled: f,
    locale: m,
    iconRender: C,
    isImageUrl: w,
    progress: S,
    prefixCls: $,
    className: T,
    type: I = "select",
    children: _,
    style: E,
    itemRender: R,
    maxCount: O,
    data: L = {},
    multiple: B = !1,
    hasControlInside: F = !0,
    action: M = "",
    accept: W = "",
    supportServerRender: j = !0,
    rootClassName: G
  } = a, U = reactExports.useContext(DisabledContext), k = f ?? U, [N, P] = useMergedState(u || [], {
    value: c,
    postState: (Re) => Re ?? []
  }), [D, H] = reactExports.useState("drop"), V = reactExports.useRef(null), Z = reactExports.useRef(null);
  reactExports.useMemo(() => {
    const Re = Date.now();
    (c || []).forEach((Be, Oe) => {
      !Be.uid && !Object.isFrozen(Be) && (Be.uid = `__AUTO__${Re}_${Oe}__`);
    });
  }, [c]);
  const ne = (Re, Be, Oe) => {
    let Me = _toConsumableArray$e(Be), Fe = !1;
    O === 1 ? Me = Me.slice(-1) : O && (Fe = Me.length > O, Me = Me.slice(0, O)), reactDomExports.flushSync(() => {
      P(Me);
    });
    const Ue = {
      file: Re,
      fileList: Me
    };
    Oe && (Ue.event = Oe), (!Fe || Re.status === "removed" || // We should ignore event if current file is exceed `maxCount`
    Me.some((je) => je.uid === Re.uid)) && reactDomExports.flushSync(() => {
      g?.(Ue);
    });
  }, K = (Re, Be) => __awaiter(void 0, void 0, void 0, function* () {
    const {
      beforeUpload: Oe,
      transformFile: Me
    } = a;
    let Fe = Re;
    if (Oe) {
      const Ue = yield Oe(Re, Be);
      if (Ue === !1)
        return !1;
      if (delete Re[LIST_IGNORE], Ue === LIST_IGNORE)
        return Object.defineProperty(Re, LIST_IGNORE, {
          value: !0,
          configurable: !0
        }), !1;
      typeof Ue == "object" && Ue && (Fe = Ue);
    }
    return Me && (Fe = yield Me(Fe)), Fe;
  }), q = (Re) => {
    const Be = Re.filter((Fe) => !Fe.file[LIST_IGNORE]);
    if (!Be.length)
      return;
    const Oe = Be.map((Fe) => file2Obj(Fe.file));
    let Me = _toConsumableArray$e(N);
    Oe.forEach((Fe) => {
      Me = updateFileList(Fe, Me);
    }), Oe.forEach((Fe, Ue) => {
      let je = Fe;
      if (Be[Ue].parsedFile)
        Fe.status = "uploading";
      else {
        const {
          originFileObj: Le
        } = Fe;
        let De;
        try {
          De = new File([Le], Le.name, {
            type: Le.type
          });
        } catch {
          De = new Blob([Le], {
            type: Le.type
          }), De.name = Le.name, De.lastModifiedDate = /* @__PURE__ */ new Date(), De.lastModified = (/* @__PURE__ */ new Date()).getTime();
        }
        De.uid = Fe.uid, je = De;
      }
      ne(je, Me);
    });
  }, Y = (Re, Be, Oe) => {
    try {
      typeof Re == "string" && (Re = JSON.parse(Re));
    } catch {
    }
    if (!getFileItem(Be, N))
      return;
    const Me = file2Obj(Be);
    Me.status = "done", Me.percent = 100, Me.response = Re, Me.xhr = Oe;
    const Fe = updateFileList(Me, N);
    ne(Me, Fe);
  }, ee = (Re, Be) => {
    if (!getFileItem(Be, N))
      return;
    const Oe = file2Obj(Be);
    Oe.status = "uploading", Oe.percent = Re.percent;
    const Me = updateFileList(Oe, N);
    ne(Oe, Me, Re);
  }, Q = (Re, Be, Oe) => {
    if (!getFileItem(Oe, N))
      return;
    const Me = file2Obj(Oe);
    Me.error = Re, Me.response = Be, Me.status = "error";
    const Fe = updateFileList(Me, N);
    ne(Me, Fe);
  }, J = (Re) => {
    let Be;
    Promise.resolve(typeof d == "function" ? d(Re) : d).then((Oe) => {
      var Me;
      if (Oe === !1)
        return;
      const Fe = removeFileItem(Re, N);
      Fe && (Be = Object.assign(Object.assign({}, Re), {
        status: "removed"
      }), N?.forEach((Ue) => {
        const je = Be.uid !== void 0 ? "uid" : "name";
        Ue[je] === Be[je] && !Object.isFrozen(Ue) && (Ue.status = "removed");
      }), (Me = V.current) === null || Me === void 0 || Me.abort(Be), ne(Be, Fe));
    });
  }, te = (Re) => {
    H(Re.type), Re.type === "drop" && b?.(Re);
  };
  reactExports.useImperativeHandle(s, () => ({
    onBatchStart: q,
    onSuccess: Y,
    onProgress: ee,
    onError: Q,
    fileList: N,
    upload: V.current,
    nativeElement: Z.current
  }));
  const {
    getPrefixCls: ae,
    direction: se,
    upload: ie
  } = reactExports.useContext(ConfigContext$1), fe = ae("upload", $), ge = Object.assign(Object.assign({
    onBatchStart: q,
    onError: Q,
    onProgress: ee,
    onSuccess: Y
  }, a), {
    data: L,
    multiple: B,
    action: M,
    accept: W,
    supportServerRender: j,
    prefixCls: fe,
    disabled: k,
    beforeUpload: K,
    onChange: void 0,
    hasControlInside: F
  });
  delete ge.className, delete ge.style, (!_ || k) && delete ge.id;
  const me = `${fe}-wrapper`, [pe, be, le] = useStyle(fe, me), [ve] = useLocale$1("Upload", localeValues.Upload), {
    showRemoveIcon: he,
    showPreviewIcon: ye,
    showDownloadIcon: Ce,
    removeIcon: xe,
    previewIcon: we,
    downloadIcon: $e,
    extra: Ae
  } = typeof p == "boolean" ? {} : p, ue = typeof he > "u" ? !k : he, ce = (Re, Be) => p ? /* @__PURE__ */ reactExports.createElement(UploadList, {
    prefixCls: fe,
    listType: v,
    items: N,
    previewFile: y,
    onPreview: A,
    onDownload: x,
    onRemove: J,
    showRemoveIcon: ue,
    showPreviewIcon: ye,
    showDownloadIcon: Ce,
    removeIcon: xe,
    previewIcon: we,
    downloadIcon: $e,
    iconRender: C,
    extra: Ae,
    locale: Object.assign(Object.assign({}, ve), m),
    isImageUrl: w,
    progress: S,
    appendAction: Re,
    appendActionVisible: Be,
    itemRender: R,
    disabled: k
  }) : Re, Ee = classnames(me, T, G, be, le, ie?.className, {
    [`${fe}-rtl`]: se === "rtl",
    [`${fe}-picture-card-wrapper`]: v === "picture-card",
    [`${fe}-picture-circle-wrapper`]: v === "picture-circle"
  }), _e = Object.assign(Object.assign({}, ie?.style), E);
  if (I === "drag") {
    const Re = classnames(be, fe, `${fe}-drag`, {
      [`${fe}-drag-uploading`]: N.some((Be) => Be.status === "uploading"),
      [`${fe}-drag-hover`]: D === "dragover",
      [`${fe}-disabled`]: k,
      [`${fe}-rtl`]: se === "rtl"
    });
    return pe(/* @__PURE__ */ reactExports.createElement("span", {
      className: Ee,
      ref: Z
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: Re,
      style: _e,
      onDrop: te,
      onDragOver: te,
      onDragLeave: te
    }, /* @__PURE__ */ reactExports.createElement(Upload$2, Object.assign({}, ge, {
      ref: V,
      className: `${fe}-btn`
    }), /* @__PURE__ */ reactExports.createElement("div", {
      className: `${fe}-drag-container`
    }, _))), ce()));
  }
  const Te = classnames(fe, `${fe}-select`, {
    [`${fe}-disabled`]: k,
    [`${fe}-hidden`]: !_
  }), ke = /* @__PURE__ */ reactExports.createElement("div", {
    className: Te,
    style: _e
  }, /* @__PURE__ */ reactExports.createElement(Upload$2, Object.assign({}, ge, {
    ref: V
  })));
  return pe(v === "picture-card" || v === "picture-circle" ? /* @__PURE__ */ reactExports.createElement("span", {
    className: Ee,
    ref: Z
  }, ce(ke, !!_)) : /* @__PURE__ */ reactExports.createElement("span", {
    className: Ee,
    ref: Z
  }, ke, ce()));
}, Upload$1 = /* @__PURE__ */ reactExports.forwardRef(InternalUpload);
var __rest$3 = function(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
};
const Dragger = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var {
    style: c,
    height: u,
    hasControlInside: d = !1
  } = a, p = __rest$3(a, ["style", "height", "hasControlInside"]);
  return /* @__PURE__ */ reactExports.createElement(Upload$1, Object.assign({
    ref: s,
    hasControlInside: d
  }, p, {
    type: "drag",
    style: Object.assign(Object.assign({}, c), {
      height: u
    })
  }));
}), Upload = Upload$1;
Upload.Dragger = Dragger;
Upload.LIST_IGNORE = LIST_IGNORE;
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const toKebabCase = (a) => a.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), toCamelCase = (a) => a.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (s, c, u) => u ? u.toUpperCase() : c.toLowerCase()
), toPascalCase = (a) => {
  const s = toCamelCase(a);
  return s.charAt(0).toUpperCase() + s.slice(1);
}, mergeClasses = (...a) => a.filter((s, c, u) => !!s && s.trim() !== "" && u.indexOf(s) === c).join(" ").trim(), hasA11yProp = (a) => {
  for (const s in a)
    if (s.startsWith("aria-") || s === "role" || s === "title")
      return !0;
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var defaultAttributes$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Icon = reactExports.forwardRef(
  ({
    color: a = "currentColor",
    size: s = 24,
    strokeWidth: c = 2,
    absoluteStrokeWidth: u,
    className: d = "",
    children: p,
    iconNode: v,
    ...A
  }, x) => reactExports.createElement(
    "svg",
    {
      ref: x,
      ...defaultAttributes$1,
      width: s,
      height: s,
      stroke: a,
      strokeWidth: u ? Number(c) * 24 / Number(s) : c,
      className: mergeClasses("lucide", d),
      ...!p && !hasA11yProp(A) && { "aria-hidden": "true" },
      ...A
    },
    [
      ...v.map(([g, b]) => reactExports.createElement(g, b)),
      ...Array.isArray(p) ? p : [p]
    ]
  )
);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const createLucideIcon = (a, s) => {
  const c = reactExports.forwardRef(
    ({ className: u, ...d }, p) => reactExports.createElement(Icon, {
      ref: p,
      iconNode: s,
      className: mergeClasses(
        `lucide-${toKebabCase(toPascalCase(a))}`,
        `lucide-${a}`,
        u
      ),
      ...d
    })
  );
  return c.displayName = toPascalCase(a), c;
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$m = [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
], AlignCenterHorizontal = createLucideIcon("align-center-horizontal", __iconNode$m);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$l = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
], AlignCenterVertical = createLucideIcon("align-center-vertical", __iconNode$l);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$k = [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
], AlignEndHorizontal = createLucideIcon("align-end-horizontal", __iconNode$k);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$j = [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
], AlignEndVertical = createLucideIcon("align-end-vertical", __iconNode$j);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$i = [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
], AlignHorizontalSpaceAround = createLucideIcon("align-horizontal-space-around", __iconNode$i);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$h = [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
], AlignStartHorizontal = createLucideIcon("align-start-horizontal", __iconNode$h);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$g = [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
], AlignStartVertical = createLucideIcon("align-start-vertical", __iconNode$g);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$f = [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
], AlignVerticalSpaceAround = createLucideIcon("align-vertical-space-around", __iconNode$f);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$e = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], ArrowLeft = createLucideIcon("arrow-left", __iconNode$e);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$d = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], ArrowRight = createLucideIcon("arrow-right", __iconNode$d);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$c = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], ChevronLeft = createLucideIcon("chevron-left", __iconNode$c);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$b = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], ChevronRight = createLucideIcon("chevron-right", __iconNode$b);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$a = [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
], ChevronsLeft = createLucideIcon("chevrons-left", __iconNode$a);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$9 = [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
], ChevronsRight = createLucideIcon("chevrons-right", __iconNode$9);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$8 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], CircleAlert = createLucideIcon("circle-alert", __iconNode$8);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$7 = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], Ellipsis = createLucideIcon("ellipsis", __iconNode$7);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$6 = [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
], GripVertical = createLucideIcon("grip-vertical", __iconNode$6);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$5 = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], LoaderCircle = createLucideIcon("loader-circle", __iconNode$5);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$4 = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], Lock = createLucideIcon("lock", __iconNode$4);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$3 = [
  ["path", { d: "M4 12h16", key: "1lakjw" }],
  ["path", { d: "M4 18h16", key: "19g7jn" }],
  ["path", { d: "M4 6h16", key: "1o0s65" }]
], Menu = createLucideIcon("menu", __iconNode$3);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$2 = [["path", { d: "M5 12h14", key: "1ays0h" }]], Minus = createLucideIcon("minus", __iconNode$2);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$1 = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], Plus = createLucideIcon("plus", __iconNode$1);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], X = createLucideIcon("x", __iconNode);
function arrayMove(a, s, c) {
  const u = a.slice();
  return u.splice(c < 0 ? u.length + c : c, 0, u.splice(s, 1)[0]), u;
}
function getSortedRects(a, s) {
  return a.reduce((c, u, d) => {
    const p = s.get(u);
    return p && (c[d] = p), c;
  }, Array(a.length));
}
function isValidIndex(a) {
  return a !== null && a >= 0;
}
function itemsEqual(a, s) {
  if (a === s)
    return !0;
  if (a.length !== s.length)
    return !1;
  for (let c = 0; c < a.length; c++)
    if (a[c] !== s[c])
      return !1;
  return !0;
}
function normalizeDisabled(a) {
  return typeof a == "boolean" ? {
    draggable: a,
    droppable: a
  } : a;
}
const rectSortingStrategy = (a) => {
  let {
    rects: s,
    activeIndex: c,
    overIndex: u,
    index: d
  } = a;
  const p = arrayMove(s, u, c), v = s[d], A = p[d];
  return !A || !v ? null : {
    x: A.left - v.left,
    y: A.top - v.top,
    scaleX: A.width / v.width,
    scaleY: A.height / v.height
  };
}, defaultScale$1 = {
  scaleX: 1,
  scaleY: 1
}, verticalListSortingStrategy = (a) => {
  var s;
  let {
    activeIndex: c,
    activeNodeRect: u,
    index: d,
    rects: p,
    overIndex: v
  } = a;
  const A = (s = p[c]) != null ? s : u;
  if (!A)
    return null;
  if (d === c) {
    const g = p[v];
    return g ? {
      x: 0,
      y: c < v ? g.top + g.height - (A.top + A.height) : g.top - A.top,
      ...defaultScale$1
    } : null;
  }
  const x = getItemGap$1(p, d, c);
  return d > c && d <= v ? {
    x: 0,
    y: -A.height - x,
    ...defaultScale$1
  } : d < c && d >= v ? {
    x: 0,
    y: A.height + x,
    ...defaultScale$1
  } : {
    x: 0,
    y: 0,
    ...defaultScale$1
  };
};
function getItemGap$1(a, s, c) {
  const u = a[s], d = a[s - 1], p = a[s + 1];
  return u ? c < s ? d ? u.top - (d.top + d.height) : p ? p.top - (u.top + u.height) : 0 : p ? p.top - (u.top + u.height) : d ? u.top - (d.top + d.height) : 0 : 0;
}
const ID_PREFIX = "Sortable", Context$1 = /* @__PURE__ */ React.createContext({
  activeIndex: -1,
  containerId: ID_PREFIX,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: rectSortingStrategy,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function SortableContext(a) {
  let {
    children: s,
    id: c,
    items: u,
    strategy: d = rectSortingStrategy,
    disabled: p = !1
  } = a;
  const {
    active: v,
    dragOverlay: A,
    droppableRects: x,
    over: g,
    measureDroppableContainers: b
  } = useDndContext(), y = useUniqueId(ID_PREFIX, c), f = A.rect !== null, m = reactExports.useMemo(() => u.map((R) => typeof R == "object" && "id" in R ? R.id : R), [u]), C = v != null, w = v ? m.indexOf(v.id) : -1, S = g ? m.indexOf(g.id) : -1, $ = reactExports.useRef(m), T = !itemsEqual(m, $.current), I = S !== -1 && w === -1 || T, _ = normalizeDisabled(p);
  useIsomorphicLayoutEffect$1(() => {
    T && C && b(m);
  }, [T, m, C, b]), reactExports.useEffect(() => {
    $.current = m;
  }, [m]);
  const E = reactExports.useMemo(
    () => ({
      activeIndex: w,
      containerId: y,
      disabled: _,
      disableTransforms: I,
      items: m,
      overIndex: S,
      useDragOverlay: f,
      sortedRects: getSortedRects(m, x),
      strategy: d
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [w, y, _.draggable, _.droppable, I, m, S, x, f, d]
  );
  return React.createElement(Context$1.Provider, {
    value: E
  }, s);
}
const defaultNewIndexGetter = (a) => {
  let {
    id: s,
    items: c,
    activeIndex: u,
    overIndex: d
  } = a;
  return arrayMove(c, u, d).indexOf(s);
}, defaultAnimateLayoutChanges = (a) => {
  let {
    containerId: s,
    isSorting: c,
    wasDragging: u,
    index: d,
    items: p,
    newIndex: v,
    previousItems: A,
    previousContainerId: x,
    transition: g
  } = a;
  return !g || !u || A !== p && d === v ? !1 : c ? !0 : v !== d && s === x;
}, defaultTransition = {
  duration: 200,
  easing: "ease"
}, transitionProperty = "transform", disabledTransition = /* @__PURE__ */ CSS$1.Transition.toString({
  property: transitionProperty,
  duration: 0,
  easing: "linear"
}), defaultAttributes = {
  roleDescription: "sortable"
};
function useDerivedTransform(a) {
  let {
    disabled: s,
    index: c,
    node: u,
    rect: d
  } = a;
  const [p, v] = reactExports.useState(null), A = reactExports.useRef(c);
  return useIsomorphicLayoutEffect$1(() => {
    if (!s && c !== A.current && u.current) {
      const x = d.current;
      if (x) {
        const g = getClientRect$1(u.current, {
          ignoreTransform: !0
        }), b = {
          x: x.left - g.left,
          y: x.top - g.top,
          scaleX: x.width / g.width,
          scaleY: x.height / g.height
        };
        (b.x || b.y) && v(b);
      }
    }
    c !== A.current && (A.current = c);
  }, [s, c, u, d]), reactExports.useEffect(() => {
    p && v(null);
  }, [p]), p;
}
function useSortable(a) {
  let {
    animateLayoutChanges: s = defaultAnimateLayoutChanges,
    attributes: c,
    disabled: u,
    data: d,
    getNewIndex: p = defaultNewIndexGetter,
    id: v,
    strategy: A,
    resizeObserverConfig: x,
    transition: g = defaultTransition
  } = a;
  const {
    items: b,
    containerId: y,
    activeIndex: f,
    disabled: m,
    disableTransforms: C,
    sortedRects: w,
    overIndex: S,
    useDragOverlay: $,
    strategy: T
  } = reactExports.useContext(Context$1), I = normalizeLocalDisabled(u, m), _ = b.indexOf(v), E = reactExports.useMemo(() => ({
    sortable: {
      containerId: y,
      index: _,
      items: b
    },
    ...d
  }), [y, d, _, b]), R = reactExports.useMemo(() => b.slice(b.indexOf(v)), [b, v]), {
    rect: O,
    node: L,
    isOver: B,
    setNodeRef: F
  } = useDroppable({
    id: v,
    data: E,
    disabled: I.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: R,
      ...x
    }
  }), {
    active: M,
    activatorEvent: W,
    activeNodeRect: j,
    attributes: G,
    setNodeRef: U,
    listeners: k,
    isDragging: N,
    over: P,
    setActivatorNodeRef: D,
    transform: H
  } = useDraggable({
    id: v,
    data: E,
    attributes: {
      ...defaultAttributes,
      ...c
    },
    disabled: I.draggable
  }), V = useCombinedRefs(F, U), Z = !!M, ne = Z && !C && isValidIndex(f) && isValidIndex(S), K = !$ && N, q = K && ne ? H : null, ee = ne ? q ?? (A ?? T)({
    rects: w,
    activeNodeRect: j,
    activeIndex: f,
    overIndex: S,
    index: _
  }) : null, Q = isValidIndex(f) && isValidIndex(S) ? p({
    id: v,
    items: b,
    activeIndex: f,
    overIndex: S
  }) : _, J = M?.id, te = reactExports.useRef({
    activeId: J,
    items: b,
    newIndex: Q,
    containerId: y
  }), ae = b !== te.current.items, se = s({
    active: M,
    containerId: y,
    isDragging: N,
    isSorting: Z,
    id: v,
    index: _,
    items: b,
    newIndex: te.current.newIndex,
    previousItems: te.current.items,
    previousContainerId: te.current.containerId,
    transition: g,
    wasDragging: te.current.activeId != null
  }), ie = useDerivedTransform({
    disabled: !se,
    index: _,
    node: L,
    rect: O
  });
  return reactExports.useEffect(() => {
    Z && te.current.newIndex !== Q && (te.current.newIndex = Q), y !== te.current.containerId && (te.current.containerId = y), b !== te.current.items && (te.current.items = b);
  }, [Z, Q, y, b]), reactExports.useEffect(() => {
    if (J === te.current.activeId)
      return;
    if (J != null && te.current.activeId == null) {
      te.current.activeId = J;
      return;
    }
    const ge = setTimeout(() => {
      te.current.activeId = J;
    }, 50);
    return () => clearTimeout(ge);
  }, [J]), {
    active: M,
    activeIndex: f,
    attributes: G,
    data: E,
    rect: O,
    index: _,
    newIndex: Q,
    items: b,
    isOver: B,
    isSorting: Z,
    isDragging: N,
    listeners: k,
    node: L,
    overIndex: S,
    over: P,
    setNodeRef: V,
    setActivatorNodeRef: D,
    setDroppableNodeRef: F,
    setDraggableNodeRef: U,
    transform: ie ?? ee,
    transition: fe()
  };
  function fe() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      ie || // Or to prevent items jumping to back to their "new" position when items change
      ae && te.current.newIndex === _
    )
      return disabledTransition;
    if (!(K && !isKeyboardEvent(W) || !g) && (Z || se))
      return CSS$1.Transition.toString({
        ...g,
        property: transitionProperty
      });
  }
}
function normalizeLocalDisabled(a, s) {
  var c, u;
  return typeof a == "boolean" ? {
    draggable: a,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (c = a?.draggable) != null ? c : s.draggable,
    droppable: (u = a?.droppable) != null ? u : s.droppable
  };
}
function hasSortableData(a) {
  if (!a)
    return !1;
  const s = a.data.current;
  return !!(s && "sortable" in s && typeof s.sortable == "object" && "containerId" in s.sortable && "items" in s.sortable && "index" in s.sortable);
}
const directions = [KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left], sortableKeyboardCoordinates = (a, s) => {
  let {
    context: {
      active: c,
      collisionRect: u,
      droppableRects: d,
      droppableContainers: p,
      over: v,
      scrollableAncestors: A
    }
  } = s;
  if (directions.includes(a.code)) {
    if (a.preventDefault(), !c || !u)
      return;
    const x = [];
    p.getEnabled().forEach((y) => {
      if (!y || y != null && y.disabled)
        return;
      const f = d.get(y.id);
      if (f)
        switch (a.code) {
          case KeyboardCode.Down:
            u.top < f.top && x.push(y);
            break;
          case KeyboardCode.Up:
            u.top > f.top && x.push(y);
            break;
          case KeyboardCode.Left:
            u.left > f.left && x.push(y);
            break;
          case KeyboardCode.Right:
            u.left < f.left && x.push(y);
            break;
        }
    });
    const g = closestCorners({
      collisionRect: u,
      droppableRects: d,
      droppableContainers: x
    });
    let b = getFirstCollision(g, "id");
    if (b === v?.id && g.length > 1 && (b = g[1].id), b != null) {
      const y = p.get(c.id), f = p.get(b), m = f ? d.get(f.id) : null, C = f?.node.current;
      if (C && m && y && f) {
        const S = getScrollableAncestors(C).some((R, O) => A[O] !== R), $ = isSameContainer(y, f), T = isAfter(y, f), I = S || !$ ? {
          x: 0,
          y: 0
        } : {
          x: T ? u.width - m.width : 0,
          y: T ? u.height - m.height : 0
        }, _ = {
          x: m.left,
          y: m.top
        };
        return I.x && I.y ? _ : subtract(_, I);
      }
    }
  }
};
function isSameContainer(a, s) {
  return !hasSortableData(a) || !hasSortableData(s) ? !1 : a.data.current.sortable.containerId === s.data.current.sortable.containerId;
}
function isAfter(a, s) {
  return !hasSortableData(a) || !hasSortableData(s) || !isSameContainer(a, s) ? !1 : a.data.current.sortable.index < s.data.current.sortable.index;
}
const { Text: Text$4 } = Typography, Item = React.memo(
  /* eslint-disable react/prop-types */
  React.forwardRef(function a({
    icon: s,
    value: c,
    status: u,
    title: d,
    required: p,
    readOnly: v,
    style: A,
    dragOverlay: x,
    onClick: g,
    onMouseEnter: b,
    onMouseLeave: y,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dragging: f,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fadeIn: m,
    listeners: C,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sorting: w,
    transition: S,
    transform: $,
    ...T
  }, I) {
    const _ = reactExports.useContext(I18nContext);
    reactExports.useEffect(() => {
      if (x)
        return document.body.style.cursor = "grabbing", () => {
          document.body.style.cursor = "";
        };
    }, [x]);
    const { x: E, y: R, scaleX: O, scaleY: L } = $ || { x: 0, y: 0, scaleX: 1, scaleY: 1 };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "li",
      {
        style: {
          marginTop: 10,
          transition: S,
          transform: `translate(${E}px, ${R}px) scale(${O}, ${L})`
        },
        onMouseEnter: b,
        onMouseLeave: y,
        ref: I,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              gap: "0.5rem",
              ...A
            },
            ...T,
            onClick: () => g && g(),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button$1,
                {
                  ...C,
                  style: {
                    display: "flex",
                    alignItems: "center",
                    background: "none",
                    boxShadow: "none",
                    border: "none",
                    paddingLeft: "0.25rem"
                  },
                  icon: /* @__PURE__ */ jsxRuntimeExports.jsx(GripVertical, { size: 15, style: { cursor: "grab" } })
                }
              ),
              s,
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Text$4,
                {
                  style: {
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    width: "100%"
                  },
                  title: d || "",
                  children: u === void 0 ? c : /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { style: { display: "flex", alignItems: "center" }, children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(CircleAlert, { size: 15, style: { marginRight: "0.25rem" } }),
                    u === "is-warning" ? _("noKeyName") : c,
                    u === "is-danger" ? _("notUniq") : ""
                  ] })
                }
              ),
              v && /* @__PURE__ */ jsxRuntimeExports.jsx(Lock, { size: 15, style: { marginRight: "0.5rem" } }),
              p && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { color: "red", marginRight: "0.5rem" }, children: "*" })
            ]
          }
        )
      }
    );
  })
);
Item.displayName = "Item";
const usePrevious = (a) => {
  const s = reactExports.useRef(null);
  return reactExports.useEffect(() => {
    s.current = a;
  }), s.current;
}, getScale = (a, s) => Math.floor((a / s > 1 ? 1 : a / s) * 100) / 100, useUIPreProcessor = ({ template: a, size: s, zoomLevel: c, maxZoom: u }) => {
  const [d, p] = reactExports.useState([]), [v, A] = reactExports.useState([]), [x, g] = reactExports.useState(0), [b, y] = reactExports.useState(null), f = async (m) => {
    const {
      template: { basePdf: C, schemas: w },
      size: S
    } = m;
    let $, T, I, _;
    if (isBlankPdf(C)) {
      const { width: R, height: O } = C;
      $ = R * ZOOM, T = O * ZOOM, I = w.map(
        () => "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+P///38ACfsD/QVDRcoAAAAASUVORK5CYII="
      ), _ = w.map(() => ({ width: R, height: O }));
    } else {
      const R = await getB64BasePdf(C), O = b64toUint8Array(R), L = new ArrayBuffer(O.byteLength);
      new Uint8Array(L).set(O);
      const [B, F] = await Promise.all([
        pdf2size(L),
        pdf2img(L.slice(), { scale: u })
      ]);
      _ = B, $ = _[0].width * ZOOM, T = _[0].height * ZOOM, I = F.map(arrayBufferToBase64);
    }
    const E = Math.min(
      getScale(S.width, $),
      getScale(S.height - RULER_HEIGHT, T)
    );
    return {
      backgrounds: I,
      pageSizes: _,
      scale: E
    };
  };
  return reactExports.useEffect(() => {
    f({ template: a, size: s }).then(({ pageSizes: m, scale: C, backgrounds: w }) => {
      A(m), g(C), p(w);
    }).catch((m) => {
      y(m), console.error("[@pdfme/ui]", m);
    });
  }, [a, s]), {
    backgrounds: d,
    pageSizes: v,
    scale: x * c,
    error: b,
    refresh: (m) => f({ template: m, size: s }).then(({ pageSizes: C, scale: w, backgrounds: S }) => {
      A(C), g(w), p(S);
    })
  };
}, useScrollPageCursor = ({
  ref: a,
  pageSizes: s,
  scale: c,
  pageCursor: u,
  onChangePageCursor: d
}) => {
  const p = reactExports.useCallback(() => {
    if (!s[0] || !a.current)
      return;
    const v = a.current.scrollTop, { top: A } = a.current.getBoundingClientRect(), x = s.reduce((b, y, f) => {
      let m = (y.height * ZOOM + RULER_HEIGHT) * c;
      return f === 0 ? m += A - m / 2 : m += b[f - 1], b.concat(m);
    }, []);
    let g = 0;
    x.forEach((b, y) => {
      v > b && (g = y + 1 >= x.length ? x.length - 1 : y + 1);
    }), g !== u && d(g);
  }, [d, u, s, a, c]);
  reactExports.useEffect(() => (a.current?.addEventListener("scroll", p), () => {
    a.current?.removeEventListener("scroll", p);
  }), [a, p]);
}, useMountStatus = () => {
  const [a, s] = reactExports.useState(!1);
  return reactExports.useEffect(() => {
    const c = setTimeout(() => s(!0), 500);
    return () => clearTimeout(c);
  }, []), a;
}, useInitEvents = ({
  pageCursor: a,
  pageSizes: s,
  activeElements: c,
  template: u,
  schemasList: d,
  changeSchemas: p,
  commitSchemas: v,
  removeSchemas: A,
  onSaveTemplate: x,
  past: g,
  future: b,
  setSchemasList: y,
  onEdit: f,
  onEditEnd: m
}) => {
  const C = reactExports.useRef(null), w = reactExports.useCallback(() => {
    const $ = () => {
      const I = c.map((_) => _.id);
      return d[a].filter((_) => I.includes(_.id));
    }, T = (I) => {
      const _ = I === "undo", E = _ ? g : b;
      if (E.current.length <= 0) return;
      (_ ? b : g).current.push(cloneDeep$1(d[a]));
      const R = cloneDeep$1(d);
      R[a] = E.current.pop(), y(R);
    };
    initShortCuts({
      move: (I, _) => {
        const E = s[a], R = $(), O = moveCommandToChangeSchemasArg({ command: I, activeSchemas: R, pageSize: E, isShift: _ });
        p(O);
      },
      copy: () => {
        const I = $();
        I.length !== 0 && (C.current = I);
      },
      paste: () => {
        if (!C.current || C.current.length === 0) return;
        const I = d[a], _ = [], E = C.current.map((R) => {
          const O = uuid$6(), L = getUniqueSchemaName({
            copiedSchemaName: R.name,
            schema: I,
            stackUniqueSchemaNames: _
          }), { height: B, width: F, position: M } = R, W = s[a], j = {
            x: M.x + 10 > W.width - F ? W.width - F : M.x + 10,
            y: M.y + 10 > W.height - B ? W.height - B : M.y + 10
          };
          return Object.assign(cloneDeep$1(R), { id: O, name: L, position: j });
        });
        v(d[a].concat(E)), f(E.map((R) => document.getElementById(R.id))), C.current = E;
      },
      redo: () => T("redo"),
      undo: () => T("undo"),
      save: () => x && x(schemasList2template(d, u.basePdf)),
      remove: () => A($().map((I) => I.id)),
      esc: m,
      selectAll: () => f(d[a].map((I) => document.getElementById(I.id)))
    });
  }, [
    u,
    c,
    a,
    s,
    p,
    v,
    d,
    x,
    A,
    g,
    b,
    y,
    C,
    f,
    m
  ]), S = reactExports.useCallback(() => {
    destroyShortCuts();
  }, []);
  reactExports.useEffect(() => (w(), S), [w, S]);
}, getWithModifiedSize = (a, s, c, u) => {
  const p = new DOMParser().parseFromString(a, "text/html"), v = (A) => {
    (A.tagName === "SVG" || A.tagName === "svg") && (A.setAttribute("width", c.toString()), A.setAttribute("height", c.toString())), Array.from(A.children).forEach((x) => v(x));
  };
  return Array.from(p.body.children).forEach((A) => v(A)), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: u, title: s, dangerouslySetInnerHTML: { __html: p.body.innerHTML } });
}, PluginIcon = (a) => {
  const { plugin: s, label: c, size: u, styles: d } = a, { token: p } = theme.useToken(), v = reactExports.useContext(OptionsContext), A = s.propPanel.defaultSchema?.type ?? "", x = v.icons?.[A] ?? s.icon, g = {
    ...d,
    color: p.colorText,
    display: "flex",
    justifyContent: "center"
  };
  return x ? u ? getWithModifiedSize(x, c, u, g) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: g, title: c, dangerouslySetInnerHTML: { __html: x } }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ...d, overflow: "hidden", fontSize: 10 }, title: c, children: c });
}, SelectableSortableItem = ({
  isSelected: a,
  style: s,
  onSelect: c,
  onEdit: u,
  schema: d,
  schemas: p,
  onMouseEnter: v,
  onMouseLeave: A
}) => {
  const { token: x } = theme.useToken(), g = reactExports.useContext(I18nContext), b = reactExports.useContext(PluginsRegistry), { setNodeRef: y, listeners: f, isDragging: m, isSorting: C, transform: w, transition: S } = useSortable({
    id: d.id
  }), $ = useMountStatus(), T = m && !$, I = {
    ...f,
    onClick: (B) => c(d.id, B.shiftKey)
  }, [_, E] = b.findWithLabelByType(d.type);
  let R;
  d.name ? p.find((B) => d.name && B.name === d.name && B.id !== d.id) && (R = "is-danger") : R = "is-warning";
  let O = g("edit");
  R === "is-warning" ? O = g("plsInputName") : R === "is-danger" && (O = g("fieldMustUniq"));
  const L = a ? { background: x.colorPrimary, opacity: C || m ? 0.5 : 1 } : {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Item,
    {
      ref: y,
      onMouseEnter: v,
      onMouseLeave: A,
      onClick: () => u(d.id),
      icon: E && /* @__PURE__ */ jsxRuntimeExports.jsx(PluginIcon, { plugin: E, label: _, size: 20 }),
      value: d.name,
      status: R,
      title: O,
      required: d.required,
      readOnly: d.readOnly,
      style: { ...L, ...s },
      dragging: m,
      sorting: C,
      transition: S,
      transform: w,
      fadeIn: T,
      listeners: I
    }
  );
}, SelectableSortableContainer = (a) => {
  const { token: s } = theme.useToken(), { schemas: c, onEdit: u, onSortEnd: d, hoveringSchemaId: p, onChangeHoveringSchemaId: v } = a, [A, x] = reactExports.useState([]), [g, b] = reactExports.useState(null), [y, f] = reactExports.useState(null), m = reactExports.useContext(PluginsRegistry), C = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 15 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  ), w = (T) => A.map((I) => I.id).includes(T), S = (T, I) => {
    if (I)
      if (w(T)) {
        const _ = A.filter((E) => E.id !== T);
        x(_);
      } else {
        const _ = c.find((R) => R.id === T), E = A.concat(_);
        x(E);
      }
    else
      x([]);
  }, $ = (T) => {
    const I = typeof T == "string" ? c.find((R) => R.id === T) : T;
    if (!I) return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    const [_, E] = m.findWithLabelByType(I.type);
    return E ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      PluginIcon,
      {
        plugin: E,
        label: _,
        size: 20,
        styles: { marginRight: "0.5rem" }
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DndContext,
    {
      sensors: C,
      collisionDetection: closestCorners,
      onDragStart: ({ active: T }) => {
        f(String(T.id)), b(c), w(String(T.id)) ? A.length > 0 && d(
          A.reduce((I, _) => _.id === String(T.id) ? I : I.filter((E) => E !== _), c)
        ) : x([]);
      },
      onDragEnd: ({ active: T, over: I }) => {
        const _ = I?.id || "", E = c.map((O) => O.id).indexOf(String(T.id)), R = c.map((O) => O.id).indexOf(String(_));
        if (A.length) {
          let O = [...c];
          O = arrayMove(O, E, R), O.splice(
            R + 1,
            0,
            ...A.filter((L) => L.id !== y)
          ), d(O), x([]);
        } else E !== R && d(arrayMove(c, E, R));
        f(null);
      },
      onDragCancel: () => {
        g && d(g), f(null), b(null);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: "100%", overflowY: "auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SortableContext, { items: c, strategy: verticalListSortingStrategy, children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { margin: 0, padding: 0, listStyle: "none", borderRadius: 5 }, children: c.map((T) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          SelectableSortableItem,
          {
            style: {
              border: `1px solid ${T.id === p ? s.colorPrimary : "transparent"}`
            },
            schema: T,
            schemas: c,
            isSelected: w(T.id) || y === T.id,
            onEdit: u,
            onSelect: S,
            onMouseEnter: () => v(T.id),
            onMouseLeave: () => v(null)
          },
          T.id
        )) }) }) }),
        reactDomExports.createPortal(
          /* @__PURE__ */ jsxRuntimeExports.jsx(DragOverlay, { adjustScale: !0, children: y ? (() => {
            const T = c.find((I) => I.id === y);
            return T ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { margin: 0, padding: 0, listStyle: "none" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Item,
                {
                  icon: $(y),
                  value: T.name,
                  required: T.required,
                  readOnly: T.readOnly,
                  style: { background: s.colorPrimary },
                  dragOverlay: !0
                }
              ) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { margin: 0, padding: 0, listStyle: "none" }, children: A.filter((I) => I.id !== y).map((I) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                Item,
                {
                  icon: $(I),
                  value: I.name,
                  required: I.required,
                  readOnly: I.readOnly,
                  style: { background: s.colorPrimary },
                  dragOverlay: !0
                },
                I.id
              )) })
            ] }) : null;
          })() : null }),
          document.body
        )
      ] })
    }
  );
}, { Text: Text$3 } = Typography, { TextArea: TextArea$2 } = Input$1, headHeight = 40, ListView = (a) => {
  const {
    schemas: s,
    onSortEnd: c,
    onEdit: u,
    size: d,
    hoveringSchemaId: p,
    onChangeHoveringSchemaId: v,
    changeSchemas: A
  } = a, { token: x } = theme.useToken(), g = reactExports.useContext(I18nContext), [b, y] = reactExports.useState(!1), [f, m] = reactExports.useState(""), C = getSidebarContentHeight(d.height), w = () => {
    const $ = f.split(`
`);
    $.length !== s.length ? alert(g("errorBulkUpdateFieldName")) : (A(
      $.map((T, I) => ({
        key: "name",
        value: T,
        schemaId: s[I].id
      }))
    ), y(!1));
  }, S = () => {
    m(s.map(($) => $.name).join(`
`)), y(!0);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: headHeight, display: "flex", alignItems: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { strong: !0, style: { textAlign: "center", width: "100%" }, children: g("fieldsList") }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: { marginTop: x.marginXS, marginBottom: x.marginXS } }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { height: C - headHeight }, children: [
      b ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextArea$2,
        {
          wrap: "off",
          value: f,
          onChange: ($) => m($.target.value),
          style: {
            paddingLeft: 30,
            height: C - headHeight,
            width: RIGHT_SIDEBAR_WIDTH - 35,
            lineHeight: "2.75rem"
          }
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        SelectableSortableContainer,
        {
          schemas: s,
          hoveringSchemaId: p,
          onChangeHoveringSchemaId: v,
          onSortEnd: c,
          onEdit: u
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          style: {
            paddingTop: "0.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end"
          },
          children: b ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { size: "small", type: "text", onClick: w, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("u", { children: [
              " ",
              g("commitBulkUpdateFieldName")
            ] }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { margin: "0 1rem" }, children: "/" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { size: "small", type: "text", onClick: () => y(!1), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("u", { children: [
              " ",
              g("cancel")
            ] }) })
          ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { size: "small", type: "text", onClick: S, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("u", { children: [
            " ",
            g("bulkUpdateFieldName")
          ] }) })
        }
      )
    ] })
  ] });
};
var freeGlobal = typeof global == "object" && global && global.Object === Object && global, freeSelf = typeof self == "object" && self && self.Object === Object && self, root = freeGlobal || freeSelf || Function("return this")(), Symbol$1 = root.Symbol, objectProto$f = Object.prototype, hasOwnProperty$c = objectProto$f.hasOwnProperty, nativeObjectToString$1 = objectProto$f.toString, symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(a) {
  var s = hasOwnProperty$c.call(a, symToStringTag$1), c = a[symToStringTag$1];
  try {
    a[symToStringTag$1] = void 0;
    var u = !0;
  } catch {
  }
  var d = nativeObjectToString$1.call(a);
  return u && (s ? a[symToStringTag$1] = c : delete a[symToStringTag$1]), d;
}
var objectProto$e = Object.prototype, nativeObjectToString = objectProto$e.toString;
function objectToString(a) {
  return nativeObjectToString.call(a);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(a) {
  return a == null ? a === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(a) ? getRawTag(a) : objectToString(a);
}
function isObjectLike(a) {
  return a != null && typeof a == "object";
}
var symbolTag$3 = "[object Symbol]";
function isSymbol(a) {
  return typeof a == "symbol" || isObjectLike(a) && baseGetTag(a) == symbolTag$3;
}
function arrayMap(a, s) {
  for (var c = -1, u = a == null ? 0 : a.length, d = Array(u); ++c < u; )
    d[c] = s(a[c], c, a);
  return d;
}
var isArray$2 = Array.isArray, symbolProto$2 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
function baseToString(a) {
  if (typeof a == "string")
    return a;
  if (isArray$2(a))
    return arrayMap(a, baseToString) + "";
  if (isSymbol(a))
    return symbolToString ? symbolToString.call(a) : "";
  var s = a + "";
  return s == "0" && 1 / a == -1 / 0 ? "-0" : s;
}
function isObject$3(a) {
  var s = typeof a;
  return a != null && (s == "object" || s == "function");
}
function identity$1(a) {
  return a;
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(a) {
  if (!isObject$3(a))
    return !1;
  var s = baseGetTag(a);
  return s == funcTag$2 || s == genTag$1 || s == asyncTag || s == proxyTag;
}
var coreJsData = root["__core-js_shared__"], maskSrcKey = function() {
  var a = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return a ? "Symbol(src)_1." + a : "";
}();
function isMasked(a) {
  return !!maskSrcKey && maskSrcKey in a;
}
var funcProto$1 = Function.prototype, funcToString$1 = funcProto$1.toString;
function toSource(a) {
  if (a != null) {
    try {
      return funcToString$1.call(a);
    } catch {
    }
    try {
      return a + "";
    } catch {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto = Function.prototype, objectProto$d = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$b = objectProto$d.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$b).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(a) {
  if (!isObject$3(a) || isMasked(a))
    return !1;
  var s = isFunction$2(a) ? reIsNative : reIsHostCtor;
  return s.test(toSource(a));
}
function getValue$1(a, s) {
  return a?.[s];
}
function getNative(a, s) {
  var c = getValue$1(a, s);
  return baseIsNative(c) ? c : void 0;
}
var WeakMap$1 = getNative(root, "WeakMap"), objectCreate = Object.create, baseCreate = /* @__PURE__ */ function() {
  function a() {
  }
  return function(s) {
    if (!isObject$3(s))
      return {};
    if (objectCreate)
      return objectCreate(s);
    a.prototype = s;
    var c = new a();
    return a.prototype = void 0, c;
  };
}(), defineProperty$4 = function() {
  try {
    var a = getNative(Object, "defineProperty");
    return a({}, "", {}), a;
  } catch {
  }
}();
function arrayEach(a, s) {
  for (var c = -1, u = a == null ? 0 : a.length; ++c < u && s(a[c], c, a) !== !1; )
    ;
  return a;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(a, s) {
  var c = typeof a;
  return s = s ?? MAX_SAFE_INTEGER$1, !!s && (c == "number" || c != "symbol" && reIsUint.test(a)) && a > -1 && a % 1 == 0 && a < s;
}
function baseAssignValue(a, s, c) {
  s == "__proto__" && defineProperty$4 ? defineProperty$4(a, s, {
    configurable: !0,
    enumerable: !0,
    value: c,
    writable: !0
  }) : a[s] = c;
}
function eq(a, s) {
  return a === s || a !== a && s !== s;
}
var objectProto$c = Object.prototype, hasOwnProperty$a = objectProto$c.hasOwnProperty;
function assignValue(a, s, c) {
  var u = a[s];
  (!(hasOwnProperty$a.call(a, s) && eq(u, c)) || c === void 0 && !(s in a)) && baseAssignValue(a, s, c);
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(a) {
  return typeof a == "number" && a > -1 && a % 1 == 0 && a <= MAX_SAFE_INTEGER;
}
function isArrayLike(a) {
  return a != null && isLength(a.length) && !isFunction$2(a);
}
function isIterateeCall(a, s, c) {
  if (!isObject$3(c))
    return !1;
  var u = typeof s;
  return (u == "number" ? isArrayLike(c) && isIndex(s, c.length) : u == "string" && s in c) ? eq(c[s], a) : !1;
}
var objectProto$b = Object.prototype;
function isPrototype(a) {
  var s = a && a.constructor, c = typeof s == "function" && s.prototype || objectProto$b;
  return a === c;
}
function baseTimes(a, s) {
  for (var c = -1, u = Array(a); ++c < a; )
    u[c] = s(c);
  return u;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(a) {
  return isObjectLike(a) && baseGetTag(a) == argsTag$3;
}
var objectProto$a = Object.prototype, hasOwnProperty$9 = objectProto$a.hasOwnProperty, propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable, isArguments = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(a) {
  return isObjectLike(a) && hasOwnProperty$9.call(a, "callee") && !propertyIsEnumerable$1.call(a, "callee");
};
function stubFalse() {
  return !1;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$2 = moduleExports$2 ? root.Buffer : void 0, nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0, isBuffer = nativeIsBuffer || stubFalse, argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = !0;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = !1;
function baseIsTypedArray(a) {
  return isObjectLike(a) && isLength(a.length) && !!typedArrayTags[baseGetTag(a)];
}
function baseUnary(a) {
  return function(s) {
    return a(s);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, freeProcess = moduleExports$1 && freeGlobal.process, nodeUtil = function() {
  try {
    var a = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    return a || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
}(), nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, objectProto$9 = Object.prototype, hasOwnProperty$8 = objectProto$9.hasOwnProperty;
function arrayLikeKeys(a, s) {
  var c = isArray$2(a), u = !c && isArguments(a), d = !c && !u && isBuffer(a), p = !c && !u && !d && isTypedArray(a), v = c || u || d || p, A = v ? baseTimes(a.length, String) : [], x = A.length;
  for (var g in a)
    (s || hasOwnProperty$8.call(a, g)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
    (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    d && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    p && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
    isIndex(g, x))) && A.push(g);
  return A;
}
function overArg(a, s) {
  return function(c) {
    return a(s(c));
  };
}
var nativeKeys = overArg(Object.keys, Object), objectProto$8 = Object.prototype, hasOwnProperty$7 = objectProto$8.hasOwnProperty;
function baseKeys(a) {
  if (!isPrototype(a))
    return nativeKeys(a);
  var s = [];
  for (var c in Object(a))
    hasOwnProperty$7.call(a, c) && c != "constructor" && s.push(c);
  return s;
}
function keys(a) {
  return isArrayLike(a) ? arrayLikeKeys(a) : baseKeys(a);
}
function nativeKeysIn(a) {
  var s = [];
  if (a != null)
    for (var c in Object(a))
      s.push(c);
  return s;
}
var objectProto$7 = Object.prototype, hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function baseKeysIn(a) {
  if (!isObject$3(a))
    return nativeKeysIn(a);
  var s = isPrototype(a), c = [];
  for (var u in a)
    u == "constructor" && (s || !hasOwnProperty$6.call(a, u)) || c.push(u);
  return c;
}
function keysIn(a) {
  return isArrayLike(a) ? arrayLikeKeys(a, !0) : baseKeysIn(a);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(a, s) {
  if (isArray$2(a))
    return !1;
  var c = typeof a;
  return c == "number" || c == "symbol" || c == "boolean" || a == null || isSymbol(a) ? !0 : reIsPlainProp.test(a) || !reIsDeepProp.test(a) || s != null && a in Object(s);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}
function hashDelete(a) {
  var s = this.has(a) && delete this.__data__[a];
  return this.size -= s ? 1 : 0, s;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$6 = Object.prototype, hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function hashGet(a) {
  var s = this.__data__;
  if (nativeCreate) {
    var c = s[a];
    return c === HASH_UNDEFINED$2 ? void 0 : c;
  }
  return hasOwnProperty$5.call(s, a) ? s[a] : void 0;
}
var objectProto$5 = Object.prototype, hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function hashHas(a) {
  var s = this.__data__;
  return nativeCreate ? s[a] !== void 0 : hasOwnProperty$4.call(s, a);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(a, s) {
  var c = this.__data__;
  return this.size += this.has(a) ? 0 : 1, c[a] = nativeCreate && s === void 0 ? HASH_UNDEFINED$1 : s, this;
}
function Hash(a) {
  var s = -1, c = a == null ? 0 : a.length;
  for (this.clear(); ++s < c; ) {
    var u = a[s];
    this.set(u[0], u[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
function assocIndexOf(a, s) {
  for (var c = a.length; c--; )
    if (eq(a[c][0], s))
      return c;
  return -1;
}
var arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete(a) {
  var s = this.__data__, c = assocIndexOf(s, a);
  if (c < 0)
    return !1;
  var u = s.length - 1;
  return c == u ? s.pop() : splice.call(s, c, 1), --this.size, !0;
}
function listCacheGet(a) {
  var s = this.__data__, c = assocIndexOf(s, a);
  return c < 0 ? void 0 : s[c][1];
}
function listCacheHas(a) {
  return assocIndexOf(this.__data__, a) > -1;
}
function listCacheSet(a, s) {
  var c = this.__data__, u = assocIndexOf(c, a);
  return u < 0 ? (++this.size, c.push([a, s])) : c[u][1] = s, this;
}
function ListCache(a) {
  var s = -1, c = a == null ? 0 : a.length;
  for (this.clear(); ++s < c; ) {
    var u = a[s];
    this.set(u[0], u[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root, "Map");
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$1 || ListCache)(),
    string: new Hash()
  };
}
function isKeyable(a) {
  var s = typeof a;
  return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? a !== "__proto__" : a === null;
}
function getMapData(a, s) {
  var c = a.__data__;
  return isKeyable(s) ? c[typeof s == "string" ? "string" : "hash"] : c.map;
}
function mapCacheDelete(a) {
  var s = getMapData(this, a).delete(a);
  return this.size -= s ? 1 : 0, s;
}
function mapCacheGet(a) {
  return getMapData(this, a).get(a);
}
function mapCacheHas(a) {
  return getMapData(this, a).has(a);
}
function mapCacheSet(a, s) {
  var c = getMapData(this, a), u = c.size;
  return c.set(a, s), this.size += c.size == u ? 0 : 1, this;
}
function MapCache(a) {
  var s = -1, c = a == null ? 0 : a.length;
  for (this.clear(); ++s < c; ) {
    var u = a[s];
    this.set(u[0], u[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize(a, s) {
  if (typeof a != "function" || s != null && typeof s != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  var c = function() {
    var u = arguments, d = s ? s.apply(this, u) : u[0], p = c.cache;
    if (p.has(d))
      return p.get(d);
    var v = a.apply(this, u);
    return c.cache = p.set(d, v) || p, v;
  };
  return c.cache = new (memoize.Cache || MapCache)(), c;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(a) {
  var s = memoize(a, function(u) {
    return c.size === MAX_MEMOIZE_SIZE && c.clear(), u;
  }), c = s.cache;
  return s;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(a) {
  var s = [];
  return a.charCodeAt(0) === 46 && s.push(""), a.replace(rePropName, function(c, u, d, p) {
    s.push(d ? p.replace(reEscapeChar, "$1") : u || c);
  }), s;
});
function toString(a) {
  return a == null ? "" : baseToString(a);
}
function castPath(a, s) {
  return isArray$2(a) ? a : isKey(a, s) ? [a] : stringToPath(toString(a));
}
function toKey(a) {
  if (typeof a == "string" || isSymbol(a))
    return a;
  var s = a + "";
  return s == "0" && 1 / a == -1 / 0 ? "-0" : s;
}
function baseGet(a, s) {
  s = castPath(s, a);
  for (var c = 0, u = s.length; a != null && c < u; )
    a = a[toKey(s[c++])];
  return c && c == u ? a : void 0;
}
function get(a, s, c) {
  var u = a == null ? void 0 : baseGet(a, s);
  return u === void 0 ? c : u;
}
function arrayPush(a, s) {
  for (var c = -1, u = s.length, d = a.length; ++c < u; )
    a[d + c] = s[c];
  return a;
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
function baseSlice(a, s, c) {
  var u = -1, d = a.length;
  s < 0 && (s = -s > d ? 0 : d + s), c = c > d ? d : c, c < 0 && (c += d), d = s > c ? 0 : c - s >>> 0, s >>>= 0;
  for (var p = Array(d); ++u < d; )
    p[u] = a[u + s];
  return p;
}
function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}
function stackDelete(a) {
  var s = this.__data__, c = s.delete(a);
  return this.size = s.size, c;
}
function stackGet(a) {
  return this.__data__.get(a);
}
function stackHas(a) {
  return this.__data__.has(a);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(a, s) {
  var c = this.__data__;
  if (c instanceof ListCache) {
    var u = c.__data__;
    if (!Map$1 || u.length < LARGE_ARRAY_SIZE - 1)
      return u.push([a, s]), this.size = ++c.size, this;
    c = this.__data__ = new MapCache(u);
  }
  return c.set(a, s), this.size = c.size, this;
}
function Stack(a) {
  var s = this.__data__ = new ListCache(a);
  this.size = s.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer$1 = moduleExports ? root.Buffer : void 0, allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : void 0;
function cloneBuffer(a, s) {
  if (s)
    return a.slice();
  var c = a.length, u = allocUnsafe ? allocUnsafe(c) : new a.constructor(c);
  return a.copy(u), u;
}
function arrayFilter(a, s) {
  for (var c = -1, u = a == null ? 0 : a.length, d = 0, p = []; ++c < u; ) {
    var v = a[c];
    s(v, c, a) && (p[d++] = v);
  }
  return p;
}
function stubArray() {
  return [];
}
var objectProto$4 = Object.prototype, propertyIsEnumerable = objectProto$4.propertyIsEnumerable, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols$1 ? function(a) {
  return a == null ? [] : (a = Object(a), arrayFilter(nativeGetSymbols$1(a), function(s) {
    return propertyIsEnumerable.call(a, s);
  }));
} : stubArray, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbolsIn = nativeGetSymbols ? function(a) {
  for (var s = []; a; )
    arrayPush(s, getSymbols(a)), a = getPrototype(a);
  return s;
} : stubArray;
function baseGetAllKeys(a, s, c) {
  var u = s(a);
  return isArray$2(a) ? u : arrayPush(u, c(a));
}
function getAllKeys(a) {
  return baseGetAllKeys(a, keys, getSymbols);
}
function getAllKeysIn(a) {
  return baseGetAllKeys(a, keysIn, getSymbolsIn);
}
var DataView$1 = getNative(root, "DataView"), Promise$1 = getNative(root, "Promise"), Set$1 = getNative(root, "Set"), mapTag$4 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$4 = "[object Set]", weakMapTag$1 = "[object WeakMap]", dataViewTag$3 = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag = baseGetTag;
(DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag(new Map$1()) != mapTag$4 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$4 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) && (getTag = function(a) {
  var s = baseGetTag(a), c = s == objectTag$2 ? a.constructor : void 0, u = c ? toSource(c) : "";
  if (u)
    switch (u) {
      case dataViewCtorString:
        return dataViewTag$3;
      case mapCtorString:
        return mapTag$4;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag$4;
      case weakMapCtorString:
        return weakMapTag$1;
    }
  return s;
});
var objectProto$3 = Object.prototype, hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function initCloneArray(a) {
  var s = a.length, c = new a.constructor(s);
  return s && typeof a[0] == "string" && hasOwnProperty$3.call(a, "index") && (c.index = a.index, c.input = a.input), c;
}
var Uint8Array$1 = root.Uint8Array;
function cloneArrayBuffer(a) {
  var s = new a.constructor(a.byteLength);
  return new Uint8Array$1(s).set(new Uint8Array$1(a)), s;
}
function cloneDataView(a, s) {
  var c = cloneArrayBuffer(a.buffer);
  return new a.constructor(c, a.byteOffset, a.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(a) {
  var s = new a.constructor(a.source, reFlags.exec(a));
  return s.lastIndex = a.lastIndex, s;
}
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(a) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(a)) : {};
}
function cloneTypedArray(a, s) {
  var c = s ? cloneArrayBuffer(a.buffer) : a.buffer;
  return new a.constructor(c, a.byteOffset, a.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(a, s, c) {
  var u = a.constructor;
  switch (s) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(a);
    case boolTag$2:
    case dateTag$2:
      return new u(+a);
    case dataViewTag$2:
      return cloneDataView(a);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(a, c);
    case mapTag$3:
      return new u();
    case numberTag$2:
    case stringTag$2:
      return new u(a);
    case regexpTag$2:
      return cloneRegExp(a);
    case setTag$3:
      return new u();
    case symbolTag$2:
      return cloneSymbol(a);
  }
}
function initCloneObject(a) {
  return typeof a.constructor == "function" && !isPrototype(a) ? baseCreate(getPrototype(a)) : {};
}
var mapTag$2 = "[object Map]";
function baseIsMap(a) {
  return isObjectLike(a) && getTag(a) == mapTag$2;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap, isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap, setTag$2 = "[object Set]";
function baseIsSet(a) {
  return isObjectLike(a) && getTag(a) == setTag$2;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet, isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet, CLONE_DEEP_FLAG$1 = 1, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]", weakMapTag = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = !0;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = !1;
function baseClone(a, s, c, u, d, p) {
  var v, A = s & CLONE_DEEP_FLAG$1;
  if (v !== void 0)
    return v;
  if (!isObject$3(a))
    return a;
  var x = isArray$2(a);
  if (x)
    v = initCloneArray(a);
  else {
    var g = getTag(a), b = g == funcTag || g == genTag;
    if (isBuffer(a))
      return cloneBuffer(a, A);
    if (g == objectTag$1 || g == argsTag$1 || b && !d)
      v = b ? {} : initCloneObject(a);
    else {
      if (!cloneableTags[g])
        return d ? a : {};
      v = initCloneByTag(a, g, A);
    }
  }
  p || (p = new Stack());
  var y = p.get(a);
  if (y)
    return y;
  p.set(a, v), isSet(a) ? a.forEach(function(C) {
    v.add(baseClone(C, s, c, C, a, p));
  }) : isMap(a) && a.forEach(function(C, w) {
    v.set(w, baseClone(C, s, c, w, a, p));
  });
  var f = getAllKeys, m = x ? void 0 : f(a);
  return arrayEach(m || a, function(C, w) {
    m && (w = C, C = a[w]), assignValue(v, w, baseClone(C, s, c, w, a, p));
  }), v;
}
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(a) {
  return baseClone(a, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(a) {
  return this.__data__.set(a, HASH_UNDEFINED), this;
}
function setCacheHas(a) {
  return this.__data__.has(a);
}
function SetCache(a) {
  var s = -1, c = a == null ? 0 : a.length;
  for (this.__data__ = new MapCache(); ++s < c; )
    this.add(a[s]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(a, s) {
  for (var c = -1, u = a == null ? 0 : a.length; ++c < u; )
    if (s(a[c], c, a))
      return !0;
  return !1;
}
function cacheHas(a, s) {
  return a.has(s);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(a, s, c, u, d, p) {
  var v = c & COMPARE_PARTIAL_FLAG$5, A = a.length, x = s.length;
  if (A != x && !(v && x > A))
    return !1;
  var g = p.get(a), b = p.get(s);
  if (g && b)
    return g == s && b == a;
  var y = -1, f = !0, m = c & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (p.set(a, s), p.set(s, a); ++y < A; ) {
    var C = a[y], w = s[y];
    if (u)
      var S = v ? u(w, C, y, s, a, p) : u(C, w, y, a, s, p);
    if (S !== void 0) {
      if (S)
        continue;
      f = !1;
      break;
    }
    if (m) {
      if (!arraySome(s, function($, T) {
        if (!cacheHas(m, T) && (C === $ || d(C, $, c, u, p)))
          return m.push(T);
      })) {
        f = !1;
        break;
      }
    } else if (!(C === w || d(C, w, c, u, p))) {
      f = !1;
      break;
    }
  }
  return p.delete(a), p.delete(s), f;
}
function mapToArray(a) {
  var s = -1, c = Array(a.size);
  return a.forEach(function(u, d) {
    c[++s] = [d, u];
  }), c;
}
function setToArray(a) {
  var s = -1, c = Array(a.size);
  return a.forEach(function(u) {
    c[++s] = u;
  }), c;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(a, s, c, u, d, p, v) {
  switch (c) {
    case dataViewTag:
      if (a.byteLength != s.byteLength || a.byteOffset != s.byteOffset)
        return !1;
      a = a.buffer, s = s.buffer;
    case arrayBufferTag:
      return !(a.byteLength != s.byteLength || !p(new Uint8Array$1(a), new Uint8Array$1(s)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+a, +s);
    case errorTag:
      return a.name == s.name && a.message == s.message;
    case regexpTag:
    case stringTag:
      return a == s + "";
    case mapTag:
      var A = mapToArray;
    case setTag:
      var x = u & COMPARE_PARTIAL_FLAG$4;
      if (A || (A = setToArray), a.size != s.size && !x)
        return !1;
      var g = v.get(a);
      if (g)
        return g == s;
      u |= COMPARE_UNORDERED_FLAG$2, v.set(a, s);
      var b = equalArrays(A(a), A(s), u, d, p, v);
      return v.delete(a), b;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(a) == symbolValueOf.call(s);
  }
  return !1;
}
var COMPARE_PARTIAL_FLAG$3 = 1, objectProto$2 = Object.prototype, hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function equalObjects(a, s, c, u, d, p) {
  var v = c & COMPARE_PARTIAL_FLAG$3, A = getAllKeys(a), x = A.length, g = getAllKeys(s), b = g.length;
  if (x != b && !v)
    return !1;
  for (var y = x; y--; ) {
    var f = A[y];
    if (!(v ? f in s : hasOwnProperty$2.call(s, f)))
      return !1;
  }
  var m = p.get(a), C = p.get(s);
  if (m && C)
    return m == s && C == a;
  var w = !0;
  p.set(a, s), p.set(s, a);
  for (var S = v; ++y < x; ) {
    f = A[y];
    var $ = a[f], T = s[f];
    if (u)
      var I = v ? u(T, $, f, s, a, p) : u($, T, f, a, s, p);
    if (!(I === void 0 ? $ === T || d($, T, c, u, p) : I)) {
      w = !1;
      break;
    }
    S || (S = f == "constructor");
  }
  if (w && !S) {
    var _ = a.constructor, E = s.constructor;
    _ != E && "constructor" in a && "constructor" in s && !(typeof _ == "function" && _ instanceof _ && typeof E == "function" && E instanceof E) && (w = !1);
  }
  return p.delete(a), p.delete(s), w;
}
var COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep(a, s, c, u, d, p) {
  var v = isArray$2(a), A = isArray$2(s), x = v ? arrayTag : getTag(a), g = A ? arrayTag : getTag(s);
  x = x == argsTag ? objectTag : x, g = g == argsTag ? objectTag : g;
  var b = x == objectTag, y = g == objectTag, f = x == g;
  if (f && isBuffer(a)) {
    if (!isBuffer(s))
      return !1;
    v = !0, b = !1;
  }
  if (f && !b)
    return p || (p = new Stack()), v || isTypedArray(a) ? equalArrays(a, s, c, u, d, p) : equalByTag(a, s, x, c, u, d, p);
  if (!(c & COMPARE_PARTIAL_FLAG$2)) {
    var m = b && hasOwnProperty$1.call(a, "__wrapped__"), C = y && hasOwnProperty$1.call(s, "__wrapped__");
    if (m || C) {
      var w = m ? a.value() : a, S = C ? s.value() : s;
      return p || (p = new Stack()), d(w, S, c, u, p);
    }
  }
  return f ? (p || (p = new Stack()), equalObjects(a, s, c, u, d, p)) : !1;
}
function baseIsEqual(a, s, c, u, d) {
  return a === s ? !0 : a == null || s == null || !isObjectLike(a) && !isObjectLike(s) ? a !== a && s !== s : baseIsEqualDeep(a, s, c, u, baseIsEqual, d);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(a, s, c, u) {
  var d = c.length, p = d;
  if (a == null)
    return !p;
  for (a = Object(a); d--; ) {
    var v = c[d];
    if (v[2] ? v[1] !== a[v[0]] : !(v[0] in a))
      return !1;
  }
  for (; ++d < p; ) {
    v = c[d];
    var A = v[0], x = a[A], g = v[1];
    if (v[2]) {
      if (x === void 0 && !(A in a))
        return !1;
    } else {
      var b = new Stack(), y;
      if (!(y === void 0 ? baseIsEqual(g, x, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, u, b) : y))
        return !1;
    }
  }
  return !0;
}
function isStrictComparable(a) {
  return a === a && !isObject$3(a);
}
function getMatchData(a) {
  for (var s = keys(a), c = s.length; c--; ) {
    var u = s[c], d = a[u];
    s[c] = [u, d, isStrictComparable(d)];
  }
  return s;
}
function matchesStrictComparable(a, s) {
  return function(c) {
    return c == null ? !1 : c[a] === s && (s !== void 0 || a in Object(c));
  };
}
function baseMatches(a) {
  var s = getMatchData(a);
  return s.length == 1 && s[0][2] ? matchesStrictComparable(s[0][0], s[0][1]) : function(c) {
    return c === a || baseIsMatch(c, a, s);
  };
}
function baseHasIn(a, s) {
  return a != null && s in Object(a);
}
function hasPath(a, s, c) {
  s = castPath(s, a);
  for (var u = -1, d = s.length, p = !1; ++u < d; ) {
    var v = toKey(s[u]);
    if (!(p = a != null && c(a, v)))
      break;
    a = a[v];
  }
  return p || ++u != d ? p : (d = a == null ? 0 : a.length, !!d && isLength(d) && isIndex(v, d) && (isArray$2(a) || isArguments(a)));
}
function hasIn(a, s) {
  return a != null && hasPath(a, s, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(a, s) {
  return isKey(a) && isStrictComparable(s) ? matchesStrictComparable(toKey(a), s) : function(c) {
    var u = get(c, a);
    return u === void 0 && u === s ? hasIn(c, a) : baseIsEqual(s, u, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(a) {
  return function(s) {
    return s?.[a];
  };
}
function basePropertyDeep(a) {
  return function(s) {
    return baseGet(s, a);
  };
}
function property(a) {
  return isKey(a) ? baseProperty(toKey(a)) : basePropertyDeep(a);
}
function baseIteratee(a) {
  return typeof a == "function" ? a : a == null ? identity$1 : typeof a == "object" ? isArray$2(a) ? baseMatchesProperty(a[0], a[1]) : baseMatches(a) : property(a);
}
function createBaseFor(a) {
  return function(s, c, u) {
    for (var d = -1, p = Object(s), v = u(s), A = v.length; A--; ) {
      var x = v[++d];
      if (c(p[x], x, p) === !1)
        break;
    }
    return s;
  };
}
var baseFor = createBaseFor();
function baseForOwn(a, s) {
  return a && baseFor(a, s, keys);
}
function createBaseEach(a, s) {
  return function(c, u) {
    if (c == null)
      return c;
    if (!isArrayLike(c))
      return a(c, u);
    for (var d = c.length, p = -1, v = Object(c); ++p < d && u(v[p], p, v) !== !1; )
      ;
    return c;
  };
}
var baseEach = createBaseEach(baseForOwn);
function last(a) {
  var s = a == null ? 0 : a.length;
  return s ? a[s - 1] : void 0;
}
var objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseHas(a, s) {
  return a != null && hasOwnProperty.call(a, s);
}
function has(a, s) {
  return a != null && hasPath(a, s, baseHas);
}
function parent(a, s) {
  return s.length < 2 ? a : baseGet(a, baseSlice(s, 0, -1));
}
function isMatch(a, s) {
  return a === s || baseIsMatch(a, s, getMatchData(s));
}
function isUndefined$1(a) {
  return a === void 0;
}
var FUNC_ERROR_TEXT = "Expected a function";
function negate(a) {
  if (typeof a != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return function() {
    var s = arguments;
    switch (s.length) {
      case 0:
        return !a.call(this);
      case 1:
        return !a.call(this, s[0]);
      case 2:
        return !a.call(this, s[0], s[1]);
      case 3:
        return !a.call(this, s[0], s[1], s[2]);
    }
    return !a.apply(this, s);
  };
}
function baseUnset(a, s) {
  return s = castPath(s, a), a = parent(a, s), a == null || delete a[toKey(last(s))];
}
function baseSet(a, s, c, u) {
  if (!isObject$3(a))
    return a;
  s = castPath(s, a);
  for (var d = -1, p = s.length, v = p - 1, A = a; A != null && ++d < p; ) {
    var x = toKey(s[d]), g = c;
    if (x === "__proto__" || x === "constructor" || x === "prototype")
      return a;
    if (d != v) {
      var b = A[x];
      g = void 0, g === void 0 && (g = isObject$3(b) ? b : isIndex(s[d + 1]) ? [] : {});
    }
    assignValue(A, x, g), A = A[x];
  }
  return a;
}
function basePickBy(a, s, c) {
  for (var u = -1, d = s.length, p = {}; ++u < d; ) {
    var v = s[u], A = baseGet(a, v);
    c(A, v) && baseSet(p, castPath(v, a), A);
  }
  return p;
}
function pickBy(a, s) {
  if (a == null)
    return {};
  var c = arrayMap(getAllKeysIn(a), function(u) {
    return [u];
  });
  return s = baseIteratee(s), basePickBy(a, c, function(u, d) {
    return s(u, d[0]);
  });
}
function omitBy(a, s) {
  return pickBy(a, negate(baseIteratee(s)));
}
function set(a, s, c) {
  return a == null ? a : baseSet(a, s, c);
}
function baseSome(a, s) {
  var c;
  return baseEach(a, function(u, d, p) {
    return c = s(u, d, p), !c;
  }), !!c;
}
function some$1(a, s, c) {
  var u = isArray$2(a) ? arraySome : baseSome;
  return c && isIterateeCall(a, s, c) && (s = void 0), u(a, baseIteratee(s));
}
function unset(a, s) {
  return a == null ? !0 : baseUnset(a, s);
}
const __vite_import_meta_env__ = {}, createStoreImpl = (a) => {
  let s;
  const c = /* @__PURE__ */ new Set(), u = (b, y) => {
    const f = typeof b == "function" ? b(s) : b;
    if (!Object.is(f, s)) {
      const m = s;
      s = y ?? (typeof f != "object" || f === null) ? f : Object.assign({}, s, f), c.forEach((C) => C(s, m));
    }
  }, d = () => s, x = { setState: u, getState: d, getInitialState: () => g, subscribe: (b) => (c.add(b), () => c.delete(b)), destroy: () => {
    (__vite_import_meta_env__ ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), c.clear();
  } }, g = s = a(u, d, x);
  return x;
}, createStore$1 = (a) => a ? createStoreImpl(a) : createStoreImpl;
var withSelector = { exports: {} }, withSelector_production = {}, shim = { exports: {} }, useSyncExternalStoreShim_production = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var a = requireReact();
  function s(y, f) {
    return y === f && (y !== 0 || 1 / y === 1 / f) || y !== y && f !== f;
  }
  var c = typeof Object.is == "function" ? Object.is : s, u = a.useState, d = a.useEffect, p = a.useLayoutEffect, v = a.useDebugValue;
  function A(y, f) {
    var m = f(), C = u({ inst: { value: m, getSnapshot: f } }), w = C[0].inst, S = C[1];
    return p(
      function() {
        w.value = m, w.getSnapshot = f, x(w) && S({ inst: w });
      },
      [y, m, f]
    ), d(
      function() {
        return x(w) && S({ inst: w }), y(function() {
          x(w) && S({ inst: w });
        });
      },
      [y]
    ), v(m), m;
  }
  function x(y) {
    var f = y.getSnapshot;
    y = y.value;
    try {
      var m = f();
      return !c(y, m);
    } catch {
      return !0;
    }
  }
  function g(y, f) {
    return f();
  }
  var b = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? g : A;
  return useSyncExternalStoreShim_production.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : b, useSyncExternalStoreShim_production;
}
var hasRequiredShim;
function requireShim() {
  return hasRequiredShim || (hasRequiredShim = 1, shim.exports = requireUseSyncExternalStoreShim_production()), shim.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production;
function requireWithSelector_production() {
  if (hasRequiredWithSelector_production) return withSelector_production;
  hasRequiredWithSelector_production = 1;
  var a = requireReact(), s = requireShim();
  function c(g, b) {
    return g === b && (g !== 0 || 1 / g === 1 / b) || g !== g && b !== b;
  }
  var u = typeof Object.is == "function" ? Object.is : c, d = s.useSyncExternalStore, p = a.useRef, v = a.useEffect, A = a.useMemo, x = a.useDebugValue;
  return withSelector_production.useSyncExternalStoreWithSelector = function(g, b, y, f, m) {
    var C = p(null);
    if (C.current === null) {
      var w = { hasValue: !1, value: null };
      C.current = w;
    } else w = C.current;
    C = A(
      function() {
        function $(R) {
          if (!T) {
            if (T = !0, I = R, R = f(R), m !== void 0 && w.hasValue) {
              var O = w.value;
              if (m(O, R))
                return _ = O;
            }
            return _ = R;
          }
          if (O = _, u(I, R)) return O;
          var L = f(R);
          return m !== void 0 && m(O, L) ? (I = R, O) : (I = R, _ = L);
        }
        var T = !1, I, _, E = y === void 0 ? null : y;
        return [
          function() {
            return $(b());
          },
          E === null ? void 0 : function() {
            return $(E());
          }
        ];
      },
      [b, y, f, m]
    );
    var S = d(g, C[0], C[1]);
    return v(
      function() {
        w.hasValue = !0, w.value = S;
      },
      [S]
    ), x(S), S;
  }, withSelector_production;
}
var hasRequiredWithSelector;
function requireWithSelector() {
  return hasRequiredWithSelector || (hasRequiredWithSelector = 1, withSelector.exports = requireWithSelector_production()), withSelector.exports;
}
var withSelectorExports = requireWithSelector();
const useSyncExternalStoreExports = /* @__PURE__ */ getDefaultExportFromCjs(withSelectorExports), { useDebugValue } = React, { useSyncExternalStoreWithSelector } = useSyncExternalStoreExports, identity = (a) => a;
function useStore(a, s = identity, c) {
  const u = useSyncExternalStoreWithSelector(
    a.subscribe,
    a.getState,
    a.getServerState || a.getInitialState,
    s,
    c
  );
  return useDebugValue(u), u;
}
var FRContext = /* @__PURE__ */ reactExports.createContext(null), ConfigContext = /* @__PURE__ */ reactExports.createContext(null), displayTypeEnum = {
  column: "vertical",
  row: "horizontal",
  inline: "inline"
}, transformProps = function a(s) {
  var c = s.schema, u = s.beforeFinish, d = s.onMount, p = s.displayType, v = p === void 0 ? "column" : p, A = s.watch, x = s.removeHiddenData, g = x === void 0 ? !0 : x, b = s.readOnly, y = s.column, f = y === void 0 ? 1 : y, m = s.mapping, C = s.debugCss, w = s.locale, S = s.configProvider, $ = s.validateMessages, T = s.debug, I = s.id, _ = s.labelWidth, E = s.maxWidth, R = s.form, O = s.onFinish, L = s.onFinishFailed, B = s.footer, F = s.operateExtra, M = s.logOnMount, W = s.logOnSubmit, j = s.labelCol, G = s.fieldCol, U = s.disabled, k = s.className, N = s.validateTrigger, P = s.antdVersion, D = __rest$15(s, ["schema", "beforeFinish", "onMount", "displayType", "watch", "removeHiddenData", "readOnly", "column", "mapping", "debugCss", "locale", "configProvider", "validateMessages", "debug", "id", "labelWidth", "maxWidth", "form", "onFinish", "onFinishFailed", "footer", "operateExtra", "logOnMount", "logOnSubmit", "labelCol", "fieldCol", "disabled", "className", "validateTrigger", "antdVersion"]), H = Object.assign({}, D);
  return v && (H.layout = displayTypeEnum[v] || "horizontal"), {
    formProps: H,
    schema: c,
    displayType: v,
    onFinish: O,
    beforeFinish: u,
    onMount: d,
    watch: A,
    readOnly: b,
    disabled: U,
    column: f,
    mapping: m,
    debugCss: C,
    locale: w,
    configProvider: S,
    footer: B,
    form: R,
    labelWidth: _,
    validateMessages: $,
    debug: T,
    id: I,
    onFinishFailed: L,
    removeHiddenData: g,
    operateExtra: F,
    logOnMount: M,
    logOnSubmit: W,
    labelCol: j,
    fieldCol: G,
    maxWidth: E,
    className: k,
    validateTrigger: N,
    antdVersion: P
  };
}, _set = set, _get = get, _cloneDeep = cloneDeep, _some = some$1, _isMatch = isMatch, isObject$2 = function a(s) {
  var c = Object.prototype.toString.call(s);
  return c.indexOf("Object") > -1;
}, isArray$1 = function a(s) {
  var c = Object.prototype.toString.call(s);
  return c.indexOf("Array") > -1;
}, isFunction$1 = function a(s) {
  return typeof s == "function";
};
function isUrl$1(a) {
  var s = /^(?:\w+:)?\/\/(\S+)$/;
  return typeof a != "string" ? !1 : s.test(a);
}
var isNumber$1 = function a(s) {
  return !isNaN(Number(s));
}, getArray = function a(s) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Array.isArray(s) ? s : c;
};
function isObjType(a) {
  return a?.type === "object" && a?.properties && a?.widgetType !== "field";
}
function isListType(a) {
  return a?.type === "array" && isObjType(a?.items) && a?.enum === void 0;
}
function isCheckBoxType(a, s) {
  if (s) return !1;
  if (a.widget === "checkbox") return !0;
  if (a && a.type === "boolean")
    return a.enum ? !1 : a.widget === void 0;
}
var translation$1 = function a(s) {
  return function(c) {
    var u = s?.locale.FormRender;
    return u[c];
  };
}, _hasFuncProperty = function a(s) {
  return _some(s, function(c) {
    return isFunction$1(c) ? !0 : isObject$2(c) ? _hasFuncProperty(c) : !1;
  });
}, safeGet = function a(s, c, u) {
  var d;
  return (d = get(s, c, u)) !== null && d !== void 0 ? d : u;
};
function _typeof$g(a) {
  "@babel/helpers - typeof";
  return _typeof$g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$g(a);
}
function _defineProperty$9(a, s, c) {
  return (s = _toPropertyKey$7(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function _toPropertyKey$7(a) {
  var s = _toPrimitive$8(a, "string");
  return _typeof$g(s) == "symbol" ? s : s + "";
}
function _toPrimitive$8(a, s) {
  if (_typeof$g(a) != "object" || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof$g(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _toConsumableArray$d(a) {
  return _arrayWithoutHoles$d(a) || _iterableToArray$d(a) || _unsupportedIterableToArray$l(a) || _nonIterableSpread$d();
}
function _nonIterableSpread$d() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _arrayWithoutHoles$d(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$l(a);
}
function _toArray(a) {
  return _arrayWithHoles$e(a) || _iterableToArray$d(a) || _unsupportedIterableToArray$l(a) || _nonIterableRest$e();
}
function _nonIterableRest$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$l(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$l(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$l(a, s) : void 0;
  }
}
function _arrayLikeToArray$l(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArray$d(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithHoles$e(a) {
  if (Array.isArray(a)) return a;
}
var isMultiBind = function a(s) {
  return isArray$1(s) && s.every(function(c) {
    return typeof c == "string";
  });
}, transformPath = function a(s) {
  var c = [], u = function(p) {
    var v = p.indexOf("[]");
    if (v === -1) {
      c.push(p);
      return;
    }
    c.push(p.substring(0, v)), u(p.substring(v + 3));
  };
  return u(s), c.length === 1 ? c[0] : c;
}, transformValueToBind = function a(s, c, u) {
  if (u === !1) {
    unset(s, c);
    return;
  }
  if (typeof u == "string") {
    var d = get(s, c), p = get(s, u);
    isObject$2(p) && (d = Object.assign(Object.assign({}, p), d)), set(s, u, d), unset(s, c);
    return;
  }
  if (isMultiBind(u)) {
    var v = get(s, c);
    unset(s, c), Array.isArray(v) && v.forEach(function(A, x) {
      var g = u[x];
      g && set(s, g, A);
    });
  }
}, transformBindToValue = function a(s, c, u) {
  if (typeof u == "string") {
    var d = get(s, u), p = get(s, c);
    isObject$2(p) && (d = Object.assign(Object.assign({}, p), d)), set(s, c, d), unset(s, u);
    return;
  }
  if (isMultiBind(u)) {
    var v = [];
    u.forEach(function(A) {
      var x = get(s, A);
      v.push(x), unset(s, A);
    }), v.length > 0 && set(s, c, v);
  }
}, parseValuesToBind = function a(s, c) {
  if (!JSON.stringify(c).includes("bind"))
    return s;
  var u = _cloneDeep(s), d = function(v, A, x) {
    var g = _toArray(A), b = g[0], y = g.slice(1);
    if (y.length === 1) {
      var f = get(v, b, []) || [];
      f.forEach(function(C, w) {
        var S = get(C, y[0]);
        if (x === "root") {
          f[w] = S;
          return;
        }
        transformValueToBind(C, y[0], x);
      });
    }
    if (isArray$1(v))
      v.forEach(function(C) {
        return d(C, [b].concat(_toConsumableArray$d(y)), x);
      });
    else if (isObject$2(v)) {
      var m = get(v, b);
      d(m, y, x);
    }
  };
  return Object.keys(c).forEach(function(p) {
    var v, A, x = (A = (v = c[p]) === null || v === void 0 ? void 0 : v.schema) === null || A === void 0 ? void 0 : A.bind;
    if (x !== void 0) {
      var g = transformPath(p);
      isArray$1(g) ? d(u, g, x) : transformValueToBind(u, g, x);
    }
  }), u;
}, parseBindToValues = function a(s, c) {
  if (!JSON.stringify(c).includes("bind"))
    return s;
  var u = _cloneDeep(s), d = function(v, A, x) {
    var g = _toArray(A), b = g[0], y = g.slice(1);
    if (y.length === 1) {
      var f = safeGet(v, b, []);
      f.forEach(function(C, w) {
        if (x === "root") {
          f[w] = _defineProperty$9({}, y[0], C);
          return;
        }
        transformBindToValue(C, y[0], x);
      });
    }
    if (isArray$1(v))
      v.forEach(function(C) {
        return d(C, [b].concat(_toConsumableArray$d(y)), x);
      });
    else if (isObject$2(v)) {
      var m = get(v, b);
      d(m, y, x);
    }
  };
  return Object.keys(c).forEach(function(p) {
    var v, A, x = (A = (v = c[p]) === null || v === void 0 ? void 0 : v.schema) === null || A === void 0 ? void 0 : A.bind;
    if (x !== void 0) {
      var g = transformPath(p);
      isArray$1(g) ? d(u, g, x) : transformBindToValue(u, g, x);
    }
  }), u;
}, transformHidden = function a(s) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof s != "string")
    return !!s;
  var d = s.replace(/^{\s*{/g, "").replace(/}\s*}$/g, "").trim(), p = `
    return `.concat(d.replace(/formData/g, JSON.stringify(c)).replace(/rootValue/g, JSON.stringify(u)), `
  `);
  try {
    var v = Function(p)();
    return v;
  } catch {
    return !1;
  }
};
const filterValuesHidden = function(a, s) {
  var c = function(p, v) {
    return p.map(function(A) {
      return isObject$2(A) ? u(A, v, A) : A;
    });
  }, u = function(p, v, A) {
    for (var x, g, b = 0, y = Object.keys(p); b < y.length; b++) {
      var f = y[b], m = p[f], C = v ? "".concat(v, ".").concat(f) : f, w = (x = s[C]) === null || x === void 0 ? void 0 : x.schema;
      if (isArray$1(m) && !w && (C = v ? "".concat(v, ".").concat(f, "[]") : "".concat(f, "[]"), w = (g = s[C]) === null || g === void 0 ? void 0 : g.schema), w?.hidden) {
        var S = transformHidden(w.hidden, a, A);
        if (S) {
          p[f] = void 0;
          continue;
        }
      }
      if (isObject$2(m)) {
        p[f] = u(m, C, A);
        continue;
      }
      if (isArray$1(m) && w?.items) {
        p[f] = c(m, C) || [];
        continue;
      }
      p[f] = m;
    }
    return p;
  };
  return u(a) || {};
}, filterValuesUndefined = function(a, s) {
  var c = function(p) {
    var v = p.map(function(A) {
      return isObject$2(A) ? u(A, !1) : isArray$1(A) ? c(A) : A;
    });
    if (Object.keys(v).length !== 0)
      return v;
  }, u = function(p) {
    var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    if (p._isAMomentObject)
      return p;
    var A = omitBy(p, isUndefined$1);
    if (Object.keys(A).forEach(function(x) {
      var g = A[x];
      if (isObject$2(g) && (A[x] = u(g)), isArray$1(g)) {
        var b = c(g);
        A[x] = b, !s && b && (A[x] = b.filter(function(y) {
          return y !== void 0;
        }));
      }
    }), A = omitBy(A, isUndefined$1), !(Object.keys(A).length === 0 && v))
      return A;
  };
  return u(a) || {};
};
var getFormItemLayout = function a(s, c, u) {
  var d = u.labelWidth, p = u.displayType, v = u._labelCol, A = u._fieldCol, x = {
    span: 5
  }, g = {
    span: 9
  };
  return s === 2 && (x = {
    span: 6
  }, g = {
    span: 14
  }), s > 2 && (x = {
    span: 7
  }, g = {
    span: 16
  }), p === "column" && (x = {}, g = {}), v && (x = v, p === "column" && (x = {})), A && (g = A, typeof A == "number" && (g = {
    span: A
  })), p === "inline" && (x = {}, g = {}), (d || d === 0) && p !== "column" && (x = {
    flex: d + "px"
  }, g = {
    flex: "auto"
  }), c.cellSpan && (g = {}), (c.labelCol || c.labelCol === 0) && (x = c.labelCol), (c.fieldCol || c.fieldCol === 0) && (g = c.fieldCol), typeof x == "number" && (x = {
    span: x
  }), typeof g == "number" && (g = {
    span: g
  }), {
    labelCol: x,
    fieldCol: g
  };
};
function _toConsumableArray$c(a) {
  return _arrayWithoutHoles$c(a) || _iterableToArray$c(a) || _unsupportedIterableToArray$k(a) || _nonIterableSpread$c();
}
function _nonIterableSpread$c() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$k(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$k(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$k(a, s) : void 0;
  }
}
function _iterableToArray$c(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$c(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$k(a);
}
function _arrayLikeToArray$k(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
var executeCallBack = function a(s, c, u, d) {
  if (isFunction$1(s))
    try {
      s(c, d);
    } catch (p) {
      console.log("".concat(u, "对应的watch函数执行报错："), p);
    }
  if (isFunction$1(s?.handler))
    try {
      s.handler(c, d);
    } catch (p) {
      console.log("".concat(u, "对应的watch函数执行报错："), p);
    }
}, traverseValues = function a(s) {
  var c = s.changedValues, u = s.allValues, d = s.flatValues, p = function(x, g, b, y) {
    if (x.length) {
      var f = b += "[]", m = x.filter(function(S) {
        return S || S === void 0;
      }).length, C = m !== g.length || x.length === 1, w = !1;
      m > 1 && m < g.length && (C = !1, w = !0), x.forEach(function(S, $) {
        w || (d[f] = {
          value: g[$],
          index: y
        }), isObject$2(S) && v(S, g[$], f, [].concat(_toConsumableArray$c(y), [$]), !C), isArray$1(S) && p(S, g[$], f, [].concat(_toConsumableArray$c(y), [$]));
      });
    }
  }, v = function(x, g, b, y, f) {
    Object.keys(x).forEach(function(m) {
      var C = x[m], w = g?.[m], S = C, $ = b ? b + "." + m : m, T = !0;
      isArray$1(C) && (S = w && _toConsumableArray$c(w), T = !1, p(C, w, $, y)), isObject$2(C) && (T = !1, v(C, w, $, y, f)), (!T || !f) && (d[$] = {
        value: S,
        index: y
      });
    });
  };
  v(c, u, null, []);
}, valuesWatch = function a(s, c, u) {
  var d;
  if (((d = Object.keys(u || {})) === null || d === void 0 ? void 0 : d.length) !== 0) {
    var p = {
      "#": {
        value: c,
        index: s
      }
    };
    traverseValues({
      changedValues: s,
      allValues: c,
      flatValues: p
    }), Object.keys(u).forEach(function(v) {
      if (has(p, v)) {
        var A = _get(p, v), x = A.value, g = A.index, b = u[v];
        executeCallBack(b, x, v, g);
      }
    });
  }
}, transformFieldsData = function a(s, c) {
  var u = s;
  if (isObject$2(u) && (u = [u]), !!(isArray$1(u) && u.length > 0))
    return u.map(function(d) {
      return Object.assign(Object.assign({
        errors: d.error
      }, d), {
        name: c(d.name)
      });
    });
}, immediateWatch = function a(s, c) {
  var u;
  if (((u = Object.keys(s || {})) === null || u === void 0 ? void 0 : u.length) !== 0) {
    var d = {};
    Object.keys(s).forEach(function(p) {
      var v = s[p];
      v?.immediate && isFunction$1(v?.handler) && (d[p] = v);
    }), valuesWatch(c, c, d);
  }
}, getSchemaFullPath = function a(s, c) {
  if (!s || !s.includes("."))
    return "properties." + s;
  for (; s.includes("[]"); ) {
    var u = s.indexOf("[]");
    s = s.substring(0, u) + ".items" + s.substring(u + 2);
  }
  var d = "properties", p = s.split(".");
  return p.forEach(function(v, A) {
    var x = d + "." + v, g = _get(c, x, {});
    if (isObjType(g) && A !== p.length - 1) {
      d = x + ".properties";
      return;
    }
    d = x;
  }), d;
};
function yymmdd(a) {
  var s = new Date(Number(a)), c = function(b) {
    return ("0" + b).slice(-2);
  }, u = c(s.getDate()), d = c(s.getMonth()), p = s.getFullYear(), v = c(s.getHours()), A = c(s.getMinutes()), x = c(s.getSeconds());
  return "".concat(p, "-").concat(d, "-").concat(u, " ").concat(v, ":").concat(A, ":").concat(x);
}
function msToTime(a) {
  var s = Math.floor(a / 1e3 % 60), c = Math.floor(a / (1e3 * 60) % 60), u = Math.floor(a / (1e3 * 60 * 60) % 24);
  return u = u < 10 ? "0" + u : u, c = c < 10 ? "0" + c : c, s = s < 10 ? "0" + s : s, u + ":" + c + ":" + s;
}
var getSessionItem = function a(s) {
  return Number(sessionStorage.getItem(s) || 0);
}, setSessionItem = function a(s, c) {
  sessionStorage.setItem(s, c + "");
};
function _toConsumableArray$b(a) {
  return _arrayWithoutHoles$b(a) || _iterableToArray$b(a) || _unsupportedIterableToArray$j(a) || _nonIterableSpread$b();
}
function _nonIterableSpread$b() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$j(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$j(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$j(a, s) : void 0;
  }
}
function _iterableToArray$b(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$b(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$j(a);
}
function _arrayLikeToArray$j(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
var _filterHiddenData = function a(s) {
  if (!isArray$1(s))
    return s;
  for (var c = [], u = 0; u < s.length; u++) {
    var d = s[u];
    if (!d.hidden) {
      var p = Object.assign({}, d);
      if (d.children) {
        var v = _filterHiddenData(d.children);
        v.length > 0 && (p.children = v);
      }
      if (d.items) {
        var A = _filterHiddenData(d.items);
        A.length > 0 && (p.items = A);
      }
      c.push(p);
    }
  }
  return c;
}, getPathObj = function a(s) {
  var c = s.rootPath, u = c === void 0 ? [] : c, d = s.path, p = (d || "").split("."), v = [], A = [], x = [];
  u.forEach(function(m, C) {
    if (isNumber$1(m)) {
      v.push(m);
      return;
    }
    isNumber$1(u[C + 1]) ? A.push("".concat(m, "[]")) : A.push(m);
  });
  var g = _toConsumableArray$b(u);
  g.pop(), g = [].concat(_toConsumableArray$b(g), _toConsumableArray$b(p)), g.forEach(function(m, C) {
    isNumber$1(m) ? x.push("[".concat(m, "]")) : x.push(m);
  });
  var b = x.join("."), y = p;
  y[0] && isNumber$1(y[0]) && y.splice(0, 1);
  var f = [].concat(A, [y]).join(".");
  return {
    dataIndex: v,
    dataPath: b,
    schemaPath: f
  };
}, getPath = function a(s) {
  return s ? isArray$1(s) ? s.join(".") : s : null;
}, getLabel$1 = function a(s, c, u, d) {
  var p = s.title, v = s.description, A = s.descWidget, x = s.labelWidget, g = u[x];
  if (g)
    return /* @__PURE__ */ React.createElement(g, {
      schema: s,
      addons: d
    });
  if (!v && !A)
    return p;
  var b = function() {
    var f = u[A];
    return f ? /* @__PURE__ */ React.createElement(f, {
      schema: s,
      addons: d
    }) : v ? /* @__PURE__ */ React.createElement("span", {
      className: "fr-desc"
    }, "(", v, ")") : null;
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, p, /* @__PURE__ */ React.createElement(b, null));
}, getTooltip$4 = function a(s, c) {
  var u = s.descType, d = s.description, p = s.tooltip;
  return p ? typeof p == "string" ? {
    title: /* @__PURE__ */ React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: p
      }
    })
  } : Object.assign(Object.assign({}, p), {
    title: /* @__PURE__ */ React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: p.title
      }
    })
  }) : u === "widget" || !d ? null : c === "column" && u === "icon" ? {
    title: d
  } : null;
}, getExtraView = function a(s, c, u, d) {
  var p = c[s];
  if (p) {
    var v = p?.widget || p, A = u[v];
    if (A)
      return /* @__PURE__ */ React.createElement(A, {
        schema: c,
        addons: d
      });
    if (!(!A && p?.widget)) {
      var x = "";
      if (typeof p == "string" && (x = p), p?.text && (x = p.text), !!x)
        return /* @__PURE__ */ React.createElement("div", {
          className: "fr-form-item-extra",
          dangerouslySetInnerHTML: {
            __html: x
          }
        });
    }
  }
}, getColSpan = function a(s, c, u) {
  var d = 24, p = getParamValue$1(s, c, u)("column");
  return p && (d = 24 / p), u.width && (u.width === "100%" ? d = 24 : u.width === "50%" ? d = 12 : u.width === "20%" ? d = 5 : u.width < "50%" && (d = 8)), u.cellSpan && (d = u.cellSpan * d), u.span && (d = u.span), d > 24 ? 24 : d;
}, getParamValue$1 = function a(s, c, u) {
  return function(d) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, v, A, x;
    return p ? (A = (v = u[d]) !== null && v !== void 0 ? v : c[d]) !== null && A !== void 0 ? A : s[d] : (x = u[d]) !== null && x !== void 0 ? x : c[d];
  };
}, getFieldProps = function a(s, c, u) {
  var d = u.widgets, p = u.methods, v = u.form, A = u.dependValues, x = u.globalProps, g = u.path, b = u.rootPath, y = u.fieldRef, f, m = getPathObj({
    path: g,
    rootPath: b
  }), C = Object.assign(Object.assign({}, c.props), {
    addons: Object.assign(Object.assign(Object.assign({}, v), {
      globalProps: x,
      dependValues: A,
      fieldRef: y
    }), m)
  });
  if (A?.length > 0 && (C.dependValues = A), ["placeholder", "disabled", "format", "onStatusChange"].forEach(function(T) {
    c[T] && (C[T] = c[T]);
  }), c.enum && !(!((f = c.props) === null || f === void 0) && f.options)) {
    var w = c.enum, S = c.enumNames;
    C.options = getArray(w).map(function(T, I) {
      var _ = S && Array.isArray(S) ? S[I] : T, E = typeof _ == "string" && _[0] === "<";
      return E && (_ = /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: _
        }
      })), {
        label: _,
        value: T
      };
    });
  }
  if (isArray$1(C.options) && (C = Object.assign(Object.assign({}, C), {
    options: _filterHiddenData(C.options)
  })), Object.keys(c).forEach(function(T) {
    typeof T == "string" && T.toLowerCase().indexOf("props") > -1 && T.length > 5 && (C[T] = c[T]);
  }), isObject$2(C.addonAfter) && C.addonAfter.widget) {
    var $ = d[C.addonAfter.widget];
    C.addonAfter = /* @__PURE__ */ React.createElement($, Object.assign({}, c));
  }
  return ["treeSelect", "inputNumber", "multiSelect", "select"].includes(s) && (C.style = Object.assign({
    width: "100%"
  }, C.style)), s === "multiSelect" && (C.mode = "multiple"), isObject$2(c.methods) && Object.keys(c.methods).forEach(function(T) {
    var I = c.methods[T];
    C[T] = p[I];
  }), C.schema = c, C;
}, _getDependValues = function a(s, c, u, d) {
  var p = /\[[0-9]*\]/;
  if (p.test(c)) {
    var v = _get(u, "path.0"), A = c.match(p)[0].replace("[", "").replace("]", ""), x = c.split(p)[0], g = A || v, b = c.replace("".concat(x, "[").concat(A, "]."), ""), y = _get(s, "".concat(x, "[").concat(g, "]"));
    return d.push(x, g), _getDependValues(y, b, u, d);
  }
  return d.push.apply(d, _toConsumableArray$b(c.split("."))), _get(s, c);
};
function _typeof$f(a) {
  "@babel/helpers - typeof";
  return _typeof$f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$f(a);
}
var _createDataSkeleton = function a(s, c) {
  var u = _cloneDeep(c), d = u;
  return isObjType(s) ? ((u === void 0 || _typeof$f(u) !== "object") && (u = {}, d = {}), Object.keys(s.properties).forEach(function(p) {
    var v = s.properties[p], A = u[p], x = _createDataSkeleton(v, A);
    d[p] = x;
  })) : u !== void 0 || (s.default !== void 0 ? d = _cloneDeep(s.default) : isListType(s) ? d = [_createDataSkeleton(s.items)] : (s.type === "boolean" && s.widget, d = void 0)), d;
};
function _toConsumableArray$a(a) {
  return _arrayWithoutHoles$a(a) || _iterableToArray$a(a) || _unsupportedIterableToArray$i(a) || _nonIterableSpread$a();
}
function _nonIterableSpread$a() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$i(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$i(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$i(a, s) : void 0;
  }
}
function _iterableToArray$a(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$a(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$i(a);
}
function _arrayLikeToArray$i(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
var isExpression = function a(s) {
  if (typeof s != "string")
    return !1;
  var c = /^{\s*{([^]+)}\s*}$/, u = /^{\s*{function\(.+}\s*}$/;
  return s.match(c) && !s.match(u);
}, _isHasExpression = function a(s) {
  var c = Object.keys(s).some(function(u) {
    var d = s[u];
    if (u === "properties")
      return !1;
    var p = function(A) {
      var x = A.some(function(g) {
        return isArray$1(g) ? p(g) : isObject$2(g) ? _isHasExpression(g) : isExpression(g);
      });
      return x;
    };
    return isArray$1(d) ? p(d) : isObject$2(d) ? _isHasExpression(d) : isExpression(d);
  });
  return c;
}, parseFunc = function a(s) {
  var c = s.replace(/(\.|\?\.)/g, "?."), u = c.replace(/(\d+)\?\.(\d+)/g, "$1.$2"), d = _toConsumableArray$a(u).reduce(function(p, v, A) {
    return v === "[" && A > 0 && u[A - 1] !== `
` ? "".concat(p, "?.").concat(v) : "".concat(p).concat(v);
  }, "");
  return d;
}, parseExpression = function a(s) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = arguments.length > 2 ? arguments[2] : void 0, d = get(c, u) || {};
  if (typeof s == "string") {
    var p = s.replace(/^{\s*{/g, "").replace(/}\s*}$/g, "").trim(), v = p?.startsWith("formData") || p?.startsWith("rootValue"), A = v ? parseFunc(p) : p, x = `
      return `.concat(A.replace(/formData/g, JSON.stringify(c)).replace(/rootValue/g, JSON.stringify(d)), `
    `);
    try {
      var g = Function(x)();
      return g;
    } catch (b) {
      return console.log(b, x, u), null;
    }
  }
  return s;
}, _parseAllExpression = function a(s, c, u, d) {
  var p = _cloneDeep(s), v = c;
  d && (v = _createDataSkeleton(d, v));
  var A = function(g) {
    var b = g.map(function(y) {
      return isArray$1(y) ? A(y) : isObject$2(y) ? _parseAllExpression(y, v, u) : isExpression(y) ? parseExpression(y, v, u) : y;
    });
    return b;
  };
  return Object.keys(p).forEach(function(x) {
    var g, b = p[x];
    isArray$1(b) && (p[x] = A(b)), isObject$2(b) && (!((g = b.mustacheParse) !== null && g !== void 0) || g) ? p[x] = _parseAllExpression(b, v, u) : isExpression(b) && (p[x] = parseExpression(b, v, u));
  }), p;
}, extractFormDataStrings = function a(s) {
  var c = [];
  return s.forEach(function(u) {
    var d = /formData(\.\w+|\[(['"])?\w+\2?\])*(\.\w+)?/g, p = u.match(d);
    p && (c = c.concat(p));
  }), c;
}, extractRootValueStrings = function a(s) {
  var c = [];
  return s.forEach(function(u) {
    var d = /rootValue(\.\w+|\[(['"])?\w+\2?\])*(\.\w+)?/g, p = u.match(d);
    p && (c = c.concat(p));
  }), c;
}, findStrList = function a(s, c) {
  for (var u = /{{(.*?)}}/g, d = [], p; (p = u.exec(s)) !== null; )
    d.push(p[1]);
  return c === "formData" ? extractFormDataStrings(d) : c === "rootValue" ? extractRootValueStrings(d) : [];
}, getListEveryResult = function a(s, c, u, d) {
  return s.every(function(p) {
    var v = parseExpression(p, c, d), A = parseExpression(p, u, d);
    return v === A;
  });
};
const fieldShouldUpdate = function(a, s, c, u) {
  return function(d, p) {
    if (c)
      return !0;
    var v = findStrList(a, "formData"), A = findStrList(a, "rootValue"), x = getListEveryResult(v, d, p, s), g = getListEveryResult(A, d, p, s);
    return !(x && g);
  };
};
var mapping = {
  default: "input",
  string: "input",
  array: "list",
  boolean: "checkbox",
  integer: "number",
  number: "inputNumber",
  object: "map",
  html: "html",
  card: "card",
  collapse: "collapse",
  lineTitle: "lineTitle",
  line: "line",
  subItem: "subItem",
  panel: "panel",
  "string:upload": "upload",
  "string:url": "urlInput",
  "string:dateTime": "datePicker",
  "string:date": "datePicker",
  "string:year": "datePicker",
  "string:month": "datePicker",
  "string:week": "datePicker",
  "string:quarter": "datePicker",
  "string:time": "timePicker",
  "string:textarea": "textArea",
  "string:color": "color",
  "string:image": "imageInput",
  "range:time": "timeRange",
  "range:dateTime": "dateRange",
  "range:date": "dateRange",
  "range:year": "dateRange",
  "range:month": "dateRange",
  "range:week": "dateRange",
  "range:quarter": "dateRange",
  "*?enum": "radio",
  "*?enum_long": "select",
  "array?enum": "checkboxes",
  "array?enum_long": "multiSelect",
  "*?readOnly": "html"
  // TODO: html widgets for list / object
};
function getWidgetName(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : mapping, c = a.type, u = a.format, d = a.enum, p = a.readOnly;
  a.widget;
  var v = a.props;
  if (a["ui:widget"] || a.widget)
    return a["ui:widget"] || a.widget;
  var A = [];
  p && (A.push("".concat(c, "?readOnly")), A.push("*?readOnly")), d && (Array.isArray(d) && (c === "array" && d.length > 6 || c !== "array" && d.length > 2) ? (A.push("".concat(c, "?enum_long")), A.push("*?enum_long")) : (A.push("".concat(c, "?enum")), A.push("*?enum"))), v?.options && (c === "array" && v.options.length > 6 || c !== "array" && v.options.length > 2 ? (A.push("".concat(c, "?enum_long")), A.push("*?enum_long")) : (A.push("".concat(c, "?enum")), A.push("*?enum")));
  var x = u;
  x && A.push("".concat(c, ":").concat(x)), c === "object" ? A.push((a.theme === "tile" ? "lineTitle" : a.theme) || "collapse") : A.push(c);
  var g = "";
  return A.some(function(b) {
    return g = s[b], !!g;
  }), g;
}
function capitalizeFirstLetter(a) {
  return a && a.charAt(0).toUpperCase() + a.slice(1);
}
var getWidget = function a(s, c) {
  var u = c[s];
  return u || (u = c[capitalizeFirstLetter(s)]), u || (u = c.Html || null), u;
}, conversions = { exports: {} }, colorName, hasRequiredColorName;
function requireColorName() {
  return hasRequiredColorName || (hasRequiredColorName = 1, colorName = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  }), colorName;
}
var hasRequiredConversions;
function requireConversions() {
  if (hasRequiredConversions) return conversions.exports;
  hasRequiredConversions = 1;
  var a = requireColorName(), s = {};
  for (var c in a)
    a.hasOwnProperty(c) && (s[a[c]] = c);
  var u = conversions.exports = {
    rgb: { channels: 3, labels: "rgb" },
    hsl: { channels: 3, labels: "hsl" },
    hsv: { channels: 3, labels: "hsv" },
    hwb: { channels: 3, labels: "hwb" },
    cmyk: { channels: 4, labels: "cmyk" },
    xyz: { channels: 3, labels: "xyz" },
    lab: { channels: 3, labels: "lab" },
    lch: { channels: 3, labels: "lch" },
    hex: { channels: 1, labels: ["hex"] },
    keyword: { channels: 1, labels: ["keyword"] },
    ansi16: { channels: 1, labels: ["ansi16"] },
    ansi256: { channels: 1, labels: ["ansi256"] },
    hcg: { channels: 3, labels: ["h", "c", "g"] },
    apple: { channels: 3, labels: ["r16", "g16", "b16"] },
    gray: { channels: 1, labels: ["gray"] }
  };
  for (var d in u)
    if (u.hasOwnProperty(d)) {
      if (!("channels" in u[d]))
        throw new Error("missing channels property: " + d);
      if (!("labels" in u[d]))
        throw new Error("missing channel labels property: " + d);
      if (u[d].labels.length !== u[d].channels)
        throw new Error("channel and label counts mismatch: " + d);
      var p = u[d].channels, v = u[d].labels;
      delete u[d].channels, delete u[d].labels, Object.defineProperty(u[d], "channels", { value: p }), Object.defineProperty(u[d], "labels", { value: v });
    }
  u.rgb.hsl = function(x) {
    var g = x[0] / 255, b = x[1] / 255, y = x[2] / 255, f = Math.min(g, b, y), m = Math.max(g, b, y), C = m - f, w, S, $;
    return m === f ? w = 0 : g === m ? w = (b - y) / C : b === m ? w = 2 + (y - g) / C : y === m && (w = 4 + (g - b) / C), w = Math.min(w * 60, 360), w < 0 && (w += 360), $ = (f + m) / 2, m === f ? S = 0 : $ <= 0.5 ? S = C / (m + f) : S = C / (2 - m - f), [w, S * 100, $ * 100];
  }, u.rgb.hsv = function(x) {
    var g, b, y, f, m, C = x[0] / 255, w = x[1] / 255, S = x[2] / 255, $ = Math.max(C, w, S), T = $ - Math.min(C, w, S), I = function(_) {
      return ($ - _) / 6 / T + 1 / 2;
    };
    return T === 0 ? f = m = 0 : (m = T / $, g = I(C), b = I(w), y = I(S), C === $ ? f = y - b : w === $ ? f = 1 / 3 + g - y : S === $ && (f = 2 / 3 + b - g), f < 0 ? f += 1 : f > 1 && (f -= 1)), [
      f * 360,
      m * 100,
      $ * 100
    ];
  }, u.rgb.hwb = function(x) {
    var g = x[0], b = x[1], y = x[2], f = u.rgb.hsl(x)[0], m = 1 / 255 * Math.min(g, Math.min(b, y));
    return y = 1 - 1 / 255 * Math.max(g, Math.max(b, y)), [f, m * 100, y * 100];
  }, u.rgb.cmyk = function(x) {
    var g = x[0] / 255, b = x[1] / 255, y = x[2] / 255, f, m, C, w;
    return w = Math.min(1 - g, 1 - b, 1 - y), f = (1 - g - w) / (1 - w) || 0, m = (1 - b - w) / (1 - w) || 0, C = (1 - y - w) / (1 - w) || 0, [f * 100, m * 100, C * 100, w * 100];
  };
  function A(x, g) {
    return Math.pow(x[0] - g[0], 2) + Math.pow(x[1] - g[1], 2) + Math.pow(x[2] - g[2], 2);
  }
  return u.rgb.keyword = function(x) {
    var g = s[x];
    if (g)
      return g;
    var b = 1 / 0, y;
    for (var f in a)
      if (a.hasOwnProperty(f)) {
        var m = a[f], C = A(x, m);
        C < b && (b = C, y = f);
      }
    return y;
  }, u.keyword.rgb = function(x) {
    return a[x];
  }, u.rgb.xyz = function(x) {
    var g = x[0] / 255, b = x[1] / 255, y = x[2] / 255;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92, b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92, y = y > 0.04045 ? Math.pow((y + 0.055) / 1.055, 2.4) : y / 12.92;
    var f = g * 0.4124 + b * 0.3576 + y * 0.1805, m = g * 0.2126 + b * 0.7152 + y * 0.0722, C = g * 0.0193 + b * 0.1192 + y * 0.9505;
    return [f * 100, m * 100, C * 100];
  }, u.rgb.lab = function(x) {
    var g = u.rgb.xyz(x), b = g[0], y = g[1], f = g[2], m, C, w;
    return b /= 95.047, y /= 100, f /= 108.883, b = b > 8856e-6 ? Math.pow(b, 1 / 3) : 7.787 * b + 16 / 116, y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116, f = f > 8856e-6 ? Math.pow(f, 1 / 3) : 7.787 * f + 16 / 116, m = 116 * y - 16, C = 500 * (b - y), w = 200 * (y - f), [m, C, w];
  }, u.hsl.rgb = function(x) {
    var g = x[0] / 360, b = x[1] / 100, y = x[2] / 100, f, m, C, w, S;
    if (b === 0)
      return S = y * 255, [S, S, S];
    y < 0.5 ? m = y * (1 + b) : m = y + b - y * b, f = 2 * y - m, w = [0, 0, 0];
    for (var $ = 0; $ < 3; $++)
      C = g + 1 / 3 * -($ - 1), C < 0 && C++, C > 1 && C--, 6 * C < 1 ? S = f + (m - f) * 6 * C : 2 * C < 1 ? S = m : 3 * C < 2 ? S = f + (m - f) * (2 / 3 - C) * 6 : S = f, w[$] = S * 255;
    return w;
  }, u.hsl.hsv = function(x) {
    var g = x[0], b = x[1] / 100, y = x[2] / 100, f = b, m = Math.max(y, 0.01), C, w;
    return y *= 2, b *= y <= 1 ? y : 2 - y, f *= m <= 1 ? m : 2 - m, w = (y + b) / 2, C = y === 0 ? 2 * f / (m + f) : 2 * b / (y + b), [g, C * 100, w * 100];
  }, u.hsv.rgb = function(x) {
    var g = x[0] / 60, b = x[1] / 100, y = x[2] / 100, f = Math.floor(g) % 6, m = g - Math.floor(g), C = 255 * y * (1 - b), w = 255 * y * (1 - b * m), S = 255 * y * (1 - b * (1 - m));
    switch (y *= 255, f) {
      case 0:
        return [y, S, C];
      case 1:
        return [w, y, C];
      case 2:
        return [C, y, S];
      case 3:
        return [C, w, y];
      case 4:
        return [S, C, y];
      case 5:
        return [y, C, w];
    }
  }, u.hsv.hsl = function(x) {
    var g = x[0], b = x[1] / 100, y = x[2] / 100, f = Math.max(y, 0.01), m, C, w;
    return w = (2 - b) * y, m = (2 - b) * f, C = b * f, C /= m <= 1 ? m : 2 - m, C = C || 0, w /= 2, [g, C * 100, w * 100];
  }, u.hwb.rgb = function(x) {
    var g = x[0] / 360, b = x[1] / 100, y = x[2] / 100, f = b + y, m, C, w, S;
    f > 1 && (b /= f, y /= f), m = Math.floor(6 * g), C = 1 - y, w = 6 * g - m, (m & 1) !== 0 && (w = 1 - w), S = b + w * (C - b);
    var $, T, I;
    switch (m) {
      default:
      case 6:
      case 0:
        $ = C, T = S, I = b;
        break;
      case 1:
        $ = S, T = C, I = b;
        break;
      case 2:
        $ = b, T = C, I = S;
        break;
      case 3:
        $ = b, T = S, I = C;
        break;
      case 4:
        $ = S, T = b, I = C;
        break;
      case 5:
        $ = C, T = b, I = S;
        break;
    }
    return [$ * 255, T * 255, I * 255];
  }, u.cmyk.rgb = function(x) {
    var g = x[0] / 100, b = x[1] / 100, y = x[2] / 100, f = x[3] / 100, m, C, w;
    return m = 1 - Math.min(1, g * (1 - f) + f), C = 1 - Math.min(1, b * (1 - f) + f), w = 1 - Math.min(1, y * (1 - f) + f), [m * 255, C * 255, w * 255];
  }, u.xyz.rgb = function(x) {
    var g = x[0] / 100, b = x[1] / 100, y = x[2] / 100, f, m, C;
    return f = g * 3.2406 + b * -1.5372 + y * -0.4986, m = g * -0.9689 + b * 1.8758 + y * 0.0415, C = g * 0.0557 + b * -0.204 + y * 1.057, f = f > 31308e-7 ? 1.055 * Math.pow(f, 1 / 2.4) - 0.055 : f * 12.92, m = m > 31308e-7 ? 1.055 * Math.pow(m, 1 / 2.4) - 0.055 : m * 12.92, C = C > 31308e-7 ? 1.055 * Math.pow(C, 1 / 2.4) - 0.055 : C * 12.92, f = Math.min(Math.max(0, f), 1), m = Math.min(Math.max(0, m), 1), C = Math.min(Math.max(0, C), 1), [f * 255, m * 255, C * 255];
  }, u.xyz.lab = function(x) {
    var g = x[0], b = x[1], y = x[2], f, m, C;
    return g /= 95.047, b /= 100, y /= 108.883, g = g > 8856e-6 ? Math.pow(g, 1 / 3) : 7.787 * g + 16 / 116, b = b > 8856e-6 ? Math.pow(b, 1 / 3) : 7.787 * b + 16 / 116, y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116, f = 116 * b - 16, m = 500 * (g - b), C = 200 * (b - y), [f, m, C];
  }, u.lab.xyz = function(x) {
    var g = x[0], b = x[1], y = x[2], f, m, C;
    m = (g + 16) / 116, f = b / 500 + m, C = m - y / 200;
    var w = Math.pow(m, 3), S = Math.pow(f, 3), $ = Math.pow(C, 3);
    return m = w > 8856e-6 ? w : (m - 16 / 116) / 7.787, f = S > 8856e-6 ? S : (f - 16 / 116) / 7.787, C = $ > 8856e-6 ? $ : (C - 16 / 116) / 7.787, f *= 95.047, m *= 100, C *= 108.883, [f, m, C];
  }, u.lab.lch = function(x) {
    var g = x[0], b = x[1], y = x[2], f, m, C;
    return f = Math.atan2(y, b), m = f * 360 / 2 / Math.PI, m < 0 && (m += 360), C = Math.sqrt(b * b + y * y), [g, C, m];
  }, u.lch.lab = function(x) {
    var g = x[0], b = x[1], y = x[2], f, m, C;
    return C = y / 360 * 2 * Math.PI, f = b * Math.cos(C), m = b * Math.sin(C), [g, f, m];
  }, u.rgb.ansi16 = function(x) {
    var g = x[0], b = x[1], y = x[2], f = 1 in arguments ? arguments[1] : u.rgb.hsv(x)[2];
    if (f = Math.round(f / 50), f === 0)
      return 30;
    var m = 30 + (Math.round(y / 255) << 2 | Math.round(b / 255) << 1 | Math.round(g / 255));
    return f === 2 && (m += 60), m;
  }, u.hsv.ansi16 = function(x) {
    return u.rgb.ansi16(u.hsv.rgb(x), x[2]);
  }, u.rgb.ansi256 = function(x) {
    var g = x[0], b = x[1], y = x[2];
    if (g === b && b === y)
      return g < 8 ? 16 : g > 248 ? 231 : Math.round((g - 8) / 247 * 24) + 232;
    var f = 16 + 36 * Math.round(g / 255 * 5) + 6 * Math.round(b / 255 * 5) + Math.round(y / 255 * 5);
    return f;
  }, u.ansi16.rgb = function(x) {
    var g = x % 10;
    if (g === 0 || g === 7)
      return x > 50 && (g += 3.5), g = g / 10.5 * 255, [g, g, g];
    var b = (~~(x > 50) + 1) * 0.5, y = (g & 1) * b * 255, f = (g >> 1 & 1) * b * 255, m = (g >> 2 & 1) * b * 255;
    return [y, f, m];
  }, u.ansi256.rgb = function(x) {
    if (x >= 232) {
      var g = (x - 232) * 10 + 8;
      return [g, g, g];
    }
    x -= 16;
    var b, y = Math.floor(x / 36) / 5 * 255, f = Math.floor((b = x % 36) / 6) / 5 * 255, m = b % 6 / 5 * 255;
    return [y, f, m];
  }, u.rgb.hex = function(x) {
    var g = ((Math.round(x[0]) & 255) << 16) + ((Math.round(x[1]) & 255) << 8) + (Math.round(x[2]) & 255), b = g.toString(16).toUpperCase();
    return "000000".substring(b.length) + b;
  }, u.hex.rgb = function(x) {
    var g = x.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!g)
      return [0, 0, 0];
    var b = g[0];
    g[0].length === 3 && (b = b.split("").map(function(w) {
      return w + w;
    }).join(""));
    var y = parseInt(b, 16), f = y >> 16 & 255, m = y >> 8 & 255, C = y & 255;
    return [f, m, C];
  }, u.rgb.hcg = function(x) {
    var g = x[0] / 255, b = x[1] / 255, y = x[2] / 255, f = Math.max(Math.max(g, b), y), m = Math.min(Math.min(g, b), y), C = f - m, w, S;
    return C < 1 ? w = m / (1 - C) : w = 0, C <= 0 ? S = 0 : f === g ? S = (b - y) / C % 6 : f === b ? S = 2 + (y - g) / C : S = 4 + (g - b) / C + 4, S /= 6, S %= 1, [S * 360, C * 100, w * 100];
  }, u.hsl.hcg = function(x) {
    var g = x[1] / 100, b = x[2] / 100, y = 1, f = 0;
    return b < 0.5 ? y = 2 * g * b : y = 2 * g * (1 - b), y < 1 && (f = (b - 0.5 * y) / (1 - y)), [x[0], y * 100, f * 100];
  }, u.hsv.hcg = function(x) {
    var g = x[1] / 100, b = x[2] / 100, y = g * b, f = 0;
    return y < 1 && (f = (b - y) / (1 - y)), [x[0], y * 100, f * 100];
  }, u.hcg.rgb = function(x) {
    var g = x[0] / 360, b = x[1] / 100, y = x[2] / 100;
    if (b === 0)
      return [y * 255, y * 255, y * 255];
    var f = [0, 0, 0], m = g % 1 * 6, C = m % 1, w = 1 - C, S = 0;
    switch (Math.floor(m)) {
      case 0:
        f[0] = 1, f[1] = C, f[2] = 0;
        break;
      case 1:
        f[0] = w, f[1] = 1, f[2] = 0;
        break;
      case 2:
        f[0] = 0, f[1] = 1, f[2] = C;
        break;
      case 3:
        f[0] = 0, f[1] = w, f[2] = 1;
        break;
      case 4:
        f[0] = C, f[1] = 0, f[2] = 1;
        break;
      default:
        f[0] = 1, f[1] = 0, f[2] = w;
    }
    return S = (1 - b) * y, [
      (b * f[0] + S) * 255,
      (b * f[1] + S) * 255,
      (b * f[2] + S) * 255
    ];
  }, u.hcg.hsv = function(x) {
    var g = x[1] / 100, b = x[2] / 100, y = g + b * (1 - g), f = 0;
    return y > 0 && (f = g / y), [x[0], f * 100, y * 100];
  }, u.hcg.hsl = function(x) {
    var g = x[1] / 100, b = x[2] / 100, y = b * (1 - g) + 0.5 * g, f = 0;
    return y > 0 && y < 0.5 ? f = g / (2 * y) : y >= 0.5 && y < 1 && (f = g / (2 * (1 - y))), [x[0], f * 100, y * 100];
  }, u.hcg.hwb = function(x) {
    var g = x[1] / 100, b = x[2] / 100, y = g + b * (1 - g);
    return [x[0], (y - g) * 100, (1 - y) * 100];
  }, u.hwb.hcg = function(x) {
    var g = x[1] / 100, b = x[2] / 100, y = 1 - b, f = y - g, m = 0;
    return f < 1 && (m = (y - f) / (1 - f)), [x[0], f * 100, m * 100];
  }, u.apple.rgb = function(x) {
    return [x[0] / 65535 * 255, x[1] / 65535 * 255, x[2] / 65535 * 255];
  }, u.rgb.apple = function(x) {
    return [x[0] / 255 * 65535, x[1] / 255 * 65535, x[2] / 255 * 65535];
  }, u.gray.rgb = function(x) {
    return [x[0] / 100 * 255, x[0] / 100 * 255, x[0] / 100 * 255];
  }, u.gray.hsl = u.gray.hsv = function(x) {
    return [0, 0, x[0]];
  }, u.gray.hwb = function(x) {
    return [0, 100, x[0]];
  }, u.gray.cmyk = function(x) {
    return [0, 0, 0, x[0]];
  }, u.gray.lab = function(x) {
    return [x[0], 0, 0];
  }, u.gray.hex = function(x) {
    var g = Math.round(x[0] / 100 * 255) & 255, b = (g << 16) + (g << 8) + g, y = b.toString(16).toUpperCase();
    return "000000".substring(y.length) + y;
  }, u.rgb.gray = function(x) {
    var g = (x[0] + x[1] + x[2]) / 3;
    return [g / 255 * 100];
  }, conversions.exports;
}
var route, hasRequiredRoute;
function requireRoute() {
  if (hasRequiredRoute) return route;
  hasRequiredRoute = 1;
  var a = requireConversions();
  function s() {
    for (var p = {}, v = Object.keys(a), A = v.length, x = 0; x < A; x++)
      p[v[x]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
      };
    return p;
  }
  function c(p) {
    var v = s(), A = [p];
    for (v[p].distance = 0; A.length; )
      for (var x = A.pop(), g = Object.keys(a[x]), b = g.length, y = 0; y < b; y++) {
        var f = g[y], m = v[f];
        m.distance === -1 && (m.distance = v[x].distance + 1, m.parent = x, A.unshift(f));
      }
    return v;
  }
  function u(p, v) {
    return function(A) {
      return v(p(A));
    };
  }
  function d(p, v) {
    for (var A = [v[p].parent, p], x = a[v[p].parent][p], g = v[p].parent; v[g].parent; )
      A.unshift(v[g].parent), x = u(a[v[g].parent][g], x), g = v[g].parent;
    return x.conversion = A, x;
  }
  return route = function(p) {
    for (var v = c(p), A = {}, x = Object.keys(v), g = x.length, b = 0; b < g; b++) {
      var y = x[b], f = v[y];
      f.parent !== null && (A[y] = d(y, v));
    }
    return A;
  }, route;
}
var colorConvert, hasRequiredColorConvert;
function requireColorConvert() {
  if (hasRequiredColorConvert) return colorConvert;
  hasRequiredColorConvert = 1;
  var a = requireConversions(), s = requireRoute(), c = {}, u = Object.keys(a);
  function d(v) {
    var A = function(x) {
      return x == null ? x : (arguments.length > 1 && (x = Array.prototype.slice.call(arguments)), v(x));
    };
    return "conversion" in v && (A.conversion = v.conversion), A;
  }
  function p(v) {
    var A = function(x) {
      if (x == null)
        return x;
      arguments.length > 1 && (x = Array.prototype.slice.call(arguments));
      var g = v(x);
      if (typeof g == "object")
        for (var b = g.length, y = 0; y < b; y++)
          g[y] = Math.round(g[y]);
      return g;
    };
    return "conversion" in v && (A.conversion = v.conversion), A;
  }
  return u.forEach(function(v) {
    c[v] = {}, Object.defineProperty(c[v], "channels", { value: a[v].channels }), Object.defineProperty(c[v], "labels", { value: a[v].labels });
    var A = s(v), x = Object.keys(A);
    x.forEach(function(g) {
      var b = A[g];
      c[v][g] = p(b), c[v][g].raw = d(b);
    });
  }), colorConvert = c, colorConvert;
}
var color$1, hasRequiredColor$1;
function requireColor$1() {
  if (hasRequiredColor$1) return color$1;
  hasRequiredColor$1 = 1;
  var a = requireColorString(), s = requireColorConvert(), c = [].slice, u = [
    // to be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // gray conflicts with some method names, and has its own method defined.
    "gray",
    // shouldn't really be in color-convert either...
    "hex"
  ], d = {};
  Object.keys(s).forEach(function(m) {
    d[c.call(s[m].labels).sort().join("")] = m;
  });
  var p = {};
  function v(m, C) {
    if (!(this instanceof v))
      return new v(m, C);
    if (C && C in u && (C = null), C && !(C in s))
      throw new Error("Unknown model: " + C);
    var w, S;
    if (m == null)
      this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
    else if (m instanceof v)
      this.model = m.model, this.color = m.color.slice(), this.valpha = m.valpha;
    else if (typeof m == "string") {
      var $ = a.get(m);
      if ($ === null)
        throw new Error("Unable to parse color from string: " + m);
      this.model = $.model, S = s[this.model].channels, this.color = $.value.slice(0, S), this.valpha = typeof $.value[S] == "number" ? $.value[S] : 1;
    } else if (m.length) {
      this.model = C || "rgb", S = s[this.model].channels;
      var T = c.call(m, 0, S);
      this.color = f(T, S), this.valpha = typeof m[S] == "number" ? m[S] : 1;
    } else if (typeof m == "number")
      m &= 16777215, this.model = "rgb", this.color = [
        m >> 16 & 255,
        m >> 8 & 255,
        m & 255
      ], this.valpha = 1;
    else {
      this.valpha = 1;
      var I = Object.keys(m);
      "alpha" in m && (I.splice(I.indexOf("alpha"), 1), this.valpha = typeof m.alpha == "number" ? m.alpha : 0);
      var _ = I.sort().join("");
      if (!(_ in d))
        throw new Error("Unable to parse color from object: " + JSON.stringify(m));
      this.model = d[_];
      var E = s[this.model].labels, R = [];
      for (w = 0; w < E.length; w++)
        R.push(m[E[w]]);
      this.color = f(R);
    }
    if (p[this.model])
      for (S = s[this.model].channels, w = 0; w < S; w++) {
        var O = p[this.model][w];
        O && (this.color[w] = O(this.color[w]));
      }
    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
  }
  v.prototype = {
    toString: function() {
      return this.string();
    },
    toJSON: function() {
      return this[this.model]();
    },
    string: function(m) {
      var C = this.model in a.to ? this : this.rgb();
      C = C.round(typeof m == "number" ? m : 1);
      var w = C.valpha === 1 ? C.color : C.color.concat(this.valpha);
      return a.to[C.model](w);
    },
    percentString: function(m) {
      var C = this.rgb().round(typeof m == "number" ? m : 1), w = C.valpha === 1 ? C.color : C.color.concat(this.valpha);
      return a.to.rgb.percent(w);
    },
    array: function() {
      return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
      for (var m = {}, C = s[this.model].channels, w = s[this.model].labels, S = 0; S < C; S++)
        m[w[S]] = this.color[S];
      return this.valpha !== 1 && (m.alpha = this.valpha), m;
    },
    unitArray: function() {
      var m = this.rgb().color;
      return m[0] /= 255, m[1] /= 255, m[2] /= 255, this.valpha !== 1 && m.push(this.valpha), m;
    },
    unitObject: function() {
      var m = this.rgb().object();
      return m.r /= 255, m.g /= 255, m.b /= 255, this.valpha !== 1 && (m.alpha = this.valpha), m;
    },
    round: function(m) {
      return m = Math.max(m || 0, 0), new v(this.color.map(x(m)).concat(this.valpha), this.model);
    },
    alpha: function(m) {
      return arguments.length ? new v(this.color.concat(Math.max(0, Math.min(1, m))), this.model) : this.valpha;
    },
    // rgb
    red: g("rgb", 0, b(255)),
    green: g("rgb", 1, b(255)),
    blue: g("rgb", 2, b(255)),
    hue: g(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function(m) {
      return (m % 360 + 360) % 360;
    }),
    // eslint-disable-line brace-style
    saturationl: g("hsl", 1, b(100)),
    lightness: g("hsl", 2, b(100)),
    saturationv: g("hsv", 1, b(100)),
    value: g("hsv", 2, b(100)),
    chroma: g("hcg", 1, b(100)),
    gray: g("hcg", 2, b(100)),
    white: g("hwb", 1, b(100)),
    wblack: g("hwb", 2, b(100)),
    cyan: g("cmyk", 0, b(100)),
    magenta: g("cmyk", 1, b(100)),
    yellow: g("cmyk", 2, b(100)),
    black: g("cmyk", 3, b(100)),
    x: g("xyz", 0, b(100)),
    y: g("xyz", 1, b(100)),
    z: g("xyz", 2, b(100)),
    l: g("lab", 0, b(100)),
    a: g("lab", 1),
    b: g("lab", 2),
    keyword: function(m) {
      return arguments.length ? new v(m) : s[this.model].keyword(this.color);
    },
    hex: function(m) {
      return arguments.length ? new v(m) : a.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
      var m = this.rgb().color;
      return (m[0] & 255) << 16 | (m[1] & 255) << 8 | m[2] & 255;
    },
    luminosity: function() {
      for (var m = this.rgb().color, C = [], w = 0; w < m.length; w++) {
        var S = m[w] / 255;
        C[w] = S <= 0.03928 ? S / 12.92 : Math.pow((S + 0.055) / 1.055, 2.4);
      }
      return 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2];
    },
    contrast: function(m) {
      var C = this.luminosity(), w = m.luminosity();
      return C > w ? (C + 0.05) / (w + 0.05) : (w + 0.05) / (C + 0.05);
    },
    level: function(m) {
      var C = this.contrast(m);
      return C >= 7.1 ? "AAA" : C >= 4.5 ? "AA" : "";
    },
    isDark: function() {
      var m = this.rgb().color, C = (m[0] * 299 + m[1] * 587 + m[2] * 114) / 1e3;
      return C < 128;
    },
    isLight: function() {
      return !this.isDark();
    },
    negate: function() {
      for (var m = this.rgb(), C = 0; C < 3; C++)
        m.color[C] = 255 - m.color[C];
      return m;
    },
    lighten: function(m) {
      var C = this.hsl();
      return C.color[2] += C.color[2] * m, C;
    },
    darken: function(m) {
      var C = this.hsl();
      return C.color[2] -= C.color[2] * m, C;
    },
    saturate: function(m) {
      var C = this.hsl();
      return C.color[1] += C.color[1] * m, C;
    },
    desaturate: function(m) {
      var C = this.hsl();
      return C.color[1] -= C.color[1] * m, C;
    },
    whiten: function(m) {
      var C = this.hwb();
      return C.color[1] += C.color[1] * m, C;
    },
    blacken: function(m) {
      var C = this.hwb();
      return C.color[2] += C.color[2] * m, C;
    },
    grayscale: function() {
      var m = this.rgb().color, C = m[0] * 0.3 + m[1] * 0.59 + m[2] * 0.11;
      return v.rgb(C, C, C);
    },
    fade: function(m) {
      return this.alpha(this.valpha - this.valpha * m);
    },
    opaquer: function(m) {
      return this.alpha(this.valpha + this.valpha * m);
    },
    rotate: function(m) {
      var C = this.hsl(), w = C.color[0];
      return w = (w + m) % 360, w = w < 0 ? 360 + w : w, C.color[0] = w, C;
    },
    mix: function(m, C) {
      if (!m || !m.rgb)
        throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof m);
      var w = m.rgb(), S = this.rgb(), $ = C === void 0 ? 0.5 : C, T = 2 * $ - 1, I = w.alpha() - S.alpha(), _ = ((T * I === -1 ? T : (T + I) / (1 + T * I)) + 1) / 2, E = 1 - _;
      return v.rgb(
        _ * w.red() + E * S.red(),
        _ * w.green() + E * S.green(),
        _ * w.blue() + E * S.blue(),
        w.alpha() * $ + S.alpha() * (1 - $)
      );
    }
  }, Object.keys(s).forEach(function(m) {
    if (u.indexOf(m) === -1) {
      var C = s[m].channels;
      v.prototype[m] = function() {
        if (this.model === m)
          return new v(this);
        if (arguments.length)
          return new v(arguments, m);
        var w = typeof arguments[C] == "number" ? C : this.valpha;
        return new v(y(s[this.model][m].raw(this.color)).concat(w), m);
      }, v[m] = function(w) {
        return typeof w == "number" && (w = f(c.call(arguments), C)), new v(w, m);
      };
    }
  });
  function A(m, C) {
    return Number(m.toFixed(C));
  }
  function x(m) {
    return function(C) {
      return A(C, m);
    };
  }
  function g(m, C, w) {
    return m = Array.isArray(m) ? m : [m], m.forEach(function(S) {
      (p[S] || (p[S] = []))[C] = w;
    }), m = m[0], function(S) {
      var $;
      return arguments.length ? (w && (S = w(S)), $ = this[m](), $.color[C] = S, $) : ($ = this[m]().color[C], w && ($ = w($)), $);
    };
  }
  function b(m) {
    return function(C) {
      return Math.max(0, Math.min(m, C));
    };
  }
  function y(m) {
    return Array.isArray(m) ? m : [m];
  }
  function f(m, C) {
    for (var w = 0; w < C; w++)
      typeof m[w] != "number" && (m[w] = 0);
    return m;
  }
  return color$1 = v, color$1;
}
var colorExports = requireColor$1();
const Color$1 = /* @__PURE__ */ getDefaultExportFromCjs(colorExports);
function _typeof$e(a) {
  "@babel/helpers - typeof";
  return _typeof$e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$e(a);
}
function _toConsumableArray$9(a) {
  return _arrayWithoutHoles$9(a) || _iterableToArray$9(a) || _unsupportedIterableToArray$h(a) || _nonIterableSpread$9();
}
function _nonIterableSpread$9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$h(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$h(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$h(a, s) : void 0;
  }
}
function _iterableToArray$9(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$9(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$h(a);
}
function _arrayLikeToArray$h(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _regeneratorRuntime$2() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime$2 = function() {
    return s;
  };
  var a, s = {}, c = Object.prototype, u = c.hasOwnProperty, d = Object.defineProperty || function(k, N, P) {
    k[N] = P.value;
  }, p = typeof Symbol == "function" ? Symbol : {}, v = p.iterator || "@@iterator", A = p.asyncIterator || "@@asyncIterator", x = p.toStringTag || "@@toStringTag";
  function g(k, N, P) {
    return Object.defineProperty(k, N, { value: P, enumerable: !0, configurable: !0, writable: !0 }), k[N];
  }
  try {
    g({}, "");
  } catch {
    g = function(P, D, H) {
      return P[D] = H;
    };
  }
  function b(k, N, P, D) {
    var H = N && N.prototype instanceof $ ? N : $, V = Object.create(H.prototype), Z = new G(D || []);
    return d(V, "_invoke", { value: F(k, P, Z) }), V;
  }
  function y(k, N, P) {
    try {
      return { type: "normal", arg: k.call(N, P) };
    } catch (D) {
      return { type: "throw", arg: D };
    }
  }
  s.wrap = b;
  var f = "suspendedStart", m = "suspendedYield", C = "executing", w = "completed", S = {};
  function $() {
  }
  function T() {
  }
  function I() {
  }
  var _ = {};
  g(_, v, function() {
    return this;
  });
  var E = Object.getPrototypeOf, R = E && E(E(U([])));
  R && R !== c && u.call(R, v) && (_ = R);
  var O = I.prototype = $.prototype = Object.create(_);
  function L(k) {
    ["next", "throw", "return"].forEach(function(N) {
      g(k, N, function(P) {
        return this._invoke(N, P);
      });
    });
  }
  function B(k, N) {
    function P(H, V, Z, ne) {
      var K = y(k[H], k, V);
      if (K.type !== "throw") {
        var q = K.arg, Y = q.value;
        return Y && _typeof$e(Y) == "object" && u.call(Y, "__await") ? N.resolve(Y.__await).then(function(ee) {
          P("next", ee, Z, ne);
        }, function(ee) {
          P("throw", ee, Z, ne);
        }) : N.resolve(Y).then(function(ee) {
          q.value = ee, Z(q);
        }, function(ee) {
          return P("throw", ee, Z, ne);
        });
      }
      ne(K.arg);
    }
    var D;
    d(this, "_invoke", { value: function(V, Z) {
      function ne() {
        return new N(function(K, q) {
          P(V, Z, K, q);
        });
      }
      return D = D ? D.then(ne, ne) : ne();
    } });
  }
  function F(k, N, P) {
    var D = f;
    return function(H, V) {
      if (D === C) throw Error("Generator is already running");
      if (D === w) {
        if (H === "throw") throw V;
        return { value: a, done: !0 };
      }
      for (P.method = H, P.arg = V; ; ) {
        var Z = P.delegate;
        if (Z) {
          var ne = M(Z, P);
          if (ne) {
            if (ne === S) continue;
            return ne;
          }
        }
        if (P.method === "next") P.sent = P._sent = P.arg;
        else if (P.method === "throw") {
          if (D === f) throw D = w, P.arg;
          P.dispatchException(P.arg);
        } else P.method === "return" && P.abrupt("return", P.arg);
        D = C;
        var K = y(k, N, P);
        if (K.type === "normal") {
          if (D = P.done ? w : m, K.arg === S) continue;
          return { value: K.arg, done: P.done };
        }
        K.type === "throw" && (D = w, P.method = "throw", P.arg = K.arg);
      }
    };
  }
  function M(k, N) {
    var P = N.method, D = k.iterator[P];
    if (D === a) return N.delegate = null, P === "throw" && k.iterator.return && (N.method = "return", N.arg = a, M(k, N), N.method === "throw") || P !== "return" && (N.method = "throw", N.arg = new TypeError("The iterator does not provide a '" + P + "' method")), S;
    var H = y(D, k.iterator, N.arg);
    if (H.type === "throw") return N.method = "throw", N.arg = H.arg, N.delegate = null, S;
    var V = H.arg;
    return V ? V.done ? (N[k.resultName] = V.value, N.next = k.nextLoc, N.method !== "return" && (N.method = "next", N.arg = a), N.delegate = null, S) : V : (N.method = "throw", N.arg = new TypeError("iterator result is not an object"), N.delegate = null, S);
  }
  function W(k) {
    var N = { tryLoc: k[0] };
    1 in k && (N.catchLoc = k[1]), 2 in k && (N.finallyLoc = k[2], N.afterLoc = k[3]), this.tryEntries.push(N);
  }
  function j(k) {
    var N = k.completion || {};
    N.type = "normal", delete N.arg, k.completion = N;
  }
  function G(k) {
    this.tryEntries = [{ tryLoc: "root" }], k.forEach(W, this), this.reset(!0);
  }
  function U(k) {
    if (k || k === "") {
      var N = k[v];
      if (N) return N.call(k);
      if (typeof k.next == "function") return k;
      if (!isNaN(k.length)) {
        var P = -1, D = function H() {
          for (; ++P < k.length; ) if (u.call(k, P)) return H.value = k[P], H.done = !1, H;
          return H.value = a, H.done = !0, H;
        };
        return D.next = D;
      }
    }
    throw new TypeError(_typeof$e(k) + " is not iterable");
  }
  return T.prototype = I, d(O, "constructor", { value: I, configurable: !0 }), d(I, "constructor", { value: T, configurable: !0 }), T.displayName = g(I, x, "GeneratorFunction"), s.isGeneratorFunction = function(k) {
    var N = typeof k == "function" && k.constructor;
    return !!N && (N === T || (N.displayName || N.name) === "GeneratorFunction");
  }, s.mark = function(k) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(k, I) : (k.__proto__ = I, g(k, x, "GeneratorFunction")), k.prototype = Object.create(O), k;
  }, s.awrap = function(k) {
    return { __await: k };
  }, L(B.prototype), g(B.prototype, A, function() {
    return this;
  }), s.AsyncIterator = B, s.async = function(k, N, P, D, H) {
    H === void 0 && (H = Promise);
    var V = new B(b(k, N, P, D), H);
    return s.isGeneratorFunction(N) ? V : V.next().then(function(Z) {
      return Z.done ? Z.value : V.next();
    });
  }, L(O), g(O, x, "Generator"), g(O, v, function() {
    return this;
  }), g(O, "toString", function() {
    return "[object Generator]";
  }), s.keys = function(k) {
    var N = Object(k), P = [];
    for (var D in N) P.push(D);
    return P.reverse(), function H() {
      for (; P.length; ) {
        var V = P.pop();
        if (V in N) return H.value = V, H.done = !1, H;
      }
      return H.done = !0, H;
    };
  }, s.values = U, G.prototype = { constructor: G, reset: function(N) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(j), !N) for (var P in this) P.charAt(0) === "t" && u.call(this, P) && !isNaN(+P.slice(1)) && (this[P] = a);
  }, stop: function() {
    this.done = !0;
    var N = this.tryEntries[0].completion;
    if (N.type === "throw") throw N.arg;
    return this.rval;
  }, dispatchException: function(N) {
    if (this.done) throw N;
    var P = this;
    function D(q, Y) {
      return Z.type = "throw", Z.arg = N, P.next = q, Y && (P.method = "next", P.arg = a), !!Y;
    }
    for (var H = this.tryEntries.length - 1; H >= 0; --H) {
      var V = this.tryEntries[H], Z = V.completion;
      if (V.tryLoc === "root") return D("end");
      if (V.tryLoc <= this.prev) {
        var ne = u.call(V, "catchLoc"), K = u.call(V, "finallyLoc");
        if (ne && K) {
          if (this.prev < V.catchLoc) return D(V.catchLoc, !0);
          if (this.prev < V.finallyLoc) return D(V.finallyLoc);
        } else if (ne) {
          if (this.prev < V.catchLoc) return D(V.catchLoc, !0);
        } else {
          if (!K) throw Error("try statement without catch or finally");
          if (this.prev < V.finallyLoc) return D(V.finallyLoc);
        }
      }
    }
  }, abrupt: function(N, P) {
    for (var D = this.tryEntries.length - 1; D >= 0; --D) {
      var H = this.tryEntries[D];
      if (H.tryLoc <= this.prev && u.call(H, "finallyLoc") && this.prev < H.finallyLoc) {
        var V = H;
        break;
      }
    }
    V && (N === "break" || N === "continue") && V.tryLoc <= P && P <= V.finallyLoc && (V = null);
    var Z = V ? V.completion : {};
    return Z.type = N, Z.arg = P, V ? (this.method = "next", this.next = V.finallyLoc, S) : this.complete(Z);
  }, complete: function(N, P) {
    if (N.type === "throw") throw N.arg;
    return N.type === "break" || N.type === "continue" ? this.next = N.arg : N.type === "return" ? (this.rval = this.arg = N.arg, this.method = "return", this.next = "end") : N.type === "normal" && P && (this.next = P), S;
  }, finish: function(N) {
    for (var P = this.tryEntries.length - 1; P >= 0; --P) {
      var D = this.tryEntries[P];
      if (D.finallyLoc === N) return this.complete(D.completion, D.afterLoc), j(D), S;
    }
  }, catch: function(N) {
    for (var P = this.tryEntries.length - 1; P >= 0; --P) {
      var D = this.tryEntries[P];
      if (D.tryLoc === N) {
        var H = D.completion;
        if (H.type === "throw") {
          var V = H.arg;
          j(D);
        }
        return V;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function(N, P, D) {
    return this.delegate = { iterator: U(N), resultName: P, nextLoc: D }, this.method === "next" && (this.arg = a), S;
  } }, s;
}
var insertLengthRule = function a(s, c) {
  var u = s.type, d = s.max, p = s.min, v = s.message;
  (d || d === 0) && c.push({
    type: u,
    max: d,
    message: v?.max
  }), (p || p === 0) && c.push({
    type: u,
    min: p,
    message: v?.min
  });
}, insertRequiredRule = function a(s, c) {
  var u, d = s.type, p = s.format, v = s.required, A = s.message, x = s.widget, g = s.title, b = (u = s?.rules) === null || u === void 0 ? void 0 : u.some(function(f) {
    return f?.required;
  });
  if (!(!v || b)) {
    var y = {
      required: !0,
      message: A?.required
    };
    ["year", "quarter", "month", "week", "date", "dateTime", "time"].includes(p) && d === "range" ? y = {
      type: "array",
      required: !0,
      len: 2,
      fields: {
        0: {
          type: "string",
          required: !0
        },
        1: {
          type: "string",
          required: !0
        }
      }
    } : x === "checkbox" ? y = {
      type: d,
      required: !0,
      whitespace: !0,
      message: g + "必填"
    } : d === "string" && (y = {
      type: "string",
      required: !0,
      whitespace: !0,
      message: A?.required || (g ? void 0 : "内容必填")
    }), c.push(y);
  }
}, transformRules = function a() {
  var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], c = arguments.length > 1 ? arguments[1] : void 0, u = arguments.length > 2 ? arguments[2] : void 0;
  return s.map(function(d) {
    if (d.validator && !d.transformed) {
      var p = isFunction$1(d.validator) ? d.validator : c[d.validator];
      d.validator = function(v, A) {
        return __awaiter$2(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime$2().mark(function x() {
          var g;
          return _regeneratorRuntime$2().wrap(function(y) {
            for (; ; ) switch (y.prev = y.next) {
              case 0:
                return y.next = 2, p(v, A, {
                  form: u
                });
              case 2:
                if (g = y.sent, !isObject$2(g)) {
                  y.next = 5;
                  break;
                }
                return y.abrupt("return", g?.status ? Promise.resolve() : Promise.reject(new Error(g.message || d.message)));
              case 5:
                return y.abrupt("return", g ? Promise.resolve() : Promise.reject(new Error(d.message)));
              case 6:
              case "end":
                return y.stop();
            }
          }, x);
        }));
      }, d.transformed = !0;
    }
    return d;
  });
};
const getRuleList = function(a, s, c, u) {
  var d, p, v = cloneDeep(a), A = v.format, x = v.rules, g = x === void 0 ? [] : x, b = v.pattern, y = v.message, f = _toConsumableArray$9(g);
  return insertRequiredRule(v, f), insertLengthRule(v, f), f.push({
    validator: function(C) {
      return __awaiter$2(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime$2().mark(function w() {
        var S, $, T;
        return _regeneratorRuntime$2().wrap(function(_) {
          for (; ; ) switch (_.prev = _.next) {
            case 0:
              if (isFunction$1((S = u?.current) === null || S === void 0 ? void 0 : S.validator)) {
                _.next = 2;
                break;
              }
              return _.abrupt("return", !0);
            case 2:
              return _.next = 4, ($ = u.current) === null || $ === void 0 ? void 0 : $.validator();
            case 4:
              return T = _.sent, _.abrupt("return", T);
            case 6:
            case "end":
              return _.stop();
          }
        }, w);
      }));
    }
  }), b && f.push({
    pattern: b,
    message: y?.pattern
  }), A === "url" && f.push({
    type: "url",
    message: y?.url
  }), A === "email" && f.push({
    type: "email",
    message: y?.email
  }), A === "image" && f.push({
    validator: function(C, w) {
      if (!w)
        return !0;
      var S = "([/|.|w|s|-])*.(?:jpg|gif|png|bmp|apng|webp|jpeg|json)", $ = isUrl$1(w), T = new RegExp(S).test(w);
      return $ || T;
    },
    message: (d = y?.email) !== null && d !== void 0 ? d : "请输入正确的图片格式"
  }), A === "color" && f.push({
    validator: function(C, w) {
      try {
        return Color$1(w || null), !0;
      } catch {
        return !1;
      }
    },
    message: (p = y?.color) !== null && p !== void 0 ? p : "请填写正确的颜色格式"
  }), transformRules(f, c, s);
};
var createUpdateEffect = function(a) {
  return function(s, c) {
    var u = reactExports.useRef(!1);
    a(function() {
      return function() {
        u.current = !1;
      };
    }, []), a(function() {
      if (!u.current)
        u.current = !0;
      else
        return s();
    }, c);
  };
};
const useUpdateEffect = createUpdateEffect(reactExports.useEffect);
function useLatest(a) {
  var s = reactExports.useRef(a);
  return s.current = a, s;
}
var useUnmount = function(a) {
  var s = useLatest(a);
  reactExports.useEffect(function() {
    return function() {
      s.current();
    };
  }, []);
}, _freeGlobal, hasRequired_freeGlobal;
function require_freeGlobal() {
  if (hasRequired_freeGlobal) return _freeGlobal;
  hasRequired_freeGlobal = 1;
  var a = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  return _freeGlobal = a, _freeGlobal;
}
var _root, hasRequired_root;
function require_root() {
  if (hasRequired_root) return _root;
  hasRequired_root = 1;
  var a = require_freeGlobal(), s = typeof self == "object" && self && self.Object === Object && self, c = a || s || Function("return this")();
  return _root = c, _root;
}
var _Symbol, hasRequired_Symbol;
function require_Symbol() {
  if (hasRequired_Symbol) return _Symbol;
  hasRequired_Symbol = 1;
  var a = require_root(), s = a.Symbol;
  return _Symbol = s, _Symbol;
}
var _getRawTag, hasRequired_getRawTag;
function require_getRawTag() {
  if (hasRequired_getRawTag) return _getRawTag;
  hasRequired_getRawTag = 1;
  var a = require_Symbol(), s = Object.prototype, c = s.hasOwnProperty, u = s.toString, d = a ? a.toStringTag : void 0;
  function p(v) {
    var A = c.call(v, d), x = v[d];
    try {
      v[d] = void 0;
      var g = !0;
    } catch {
    }
    var b = u.call(v);
    return g && (A ? v[d] = x : delete v[d]), b;
  }
  return _getRawTag = p, _getRawTag;
}
var _objectToString, hasRequired_objectToString;
function require_objectToString() {
  if (hasRequired_objectToString) return _objectToString;
  hasRequired_objectToString = 1;
  var a = Object.prototype, s = a.toString;
  function c(u) {
    return s.call(u);
  }
  return _objectToString = c, _objectToString;
}
var _baseGetTag, hasRequired_baseGetTag;
function require_baseGetTag() {
  if (hasRequired_baseGetTag) return _baseGetTag;
  hasRequired_baseGetTag = 1;
  var a = require_Symbol(), s = require_getRawTag(), c = require_objectToString(), u = "[object Null]", d = "[object Undefined]", p = a ? a.toStringTag : void 0;
  function v(A) {
    return A == null ? A === void 0 ? d : u : p && p in Object(A) ? s(A) : c(A);
  }
  return _baseGetTag = v, _baseGetTag;
}
var isObjectLike_1, hasRequiredIsObjectLike;
function requireIsObjectLike() {
  if (hasRequiredIsObjectLike) return isObjectLike_1;
  hasRequiredIsObjectLike = 1;
  function a(s) {
    return s != null && typeof s == "object";
  }
  return isObjectLike_1 = a, isObjectLike_1;
}
var isSymbol_1, hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol) return isSymbol_1;
  hasRequiredIsSymbol = 1;
  var a = require_baseGetTag(), s = requireIsObjectLike(), c = "[object Symbol]";
  function u(d) {
    return typeof d == "symbol" || s(d) && a(d) == c;
  }
  return isSymbol_1 = u, isSymbol_1;
}
var FieldWrapperStatus = function a(s) {
  var c = s.Field, u = s.fieldProps, d = s.maxWidth, p = s.initialValue, v = s.acitonRender, A = __rest$15(s, ["Field", "fieldProps", "maxWidth", "initialValue", "acitonRender"]), x = u.onStatusChange, g = u.addons, b = __rest$15(u, ["onStatusChange", "addons"]), y = Object.assign(d ? {
    maxWidth: d
  } : {}, u?.style), f = Form$1.Item.useStatus(), m = f.status, C = g.getFieldError(g.dataPath);
  return reactExports.useEffect(function() {
    x && x(m, C);
  }, [JSON.stringify(C)]), useUpdateEffect(function() {
    A.onChange(p);
  }, [JSON.stringify(p)]), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(c, Object.assign({}, A, b, {
    style: y,
    addons: g
  })), v && /* @__PURE__ */ React.createElement("span", {
    className: "ant-form-item-actions"
  }, v()));
}, FieldWrapper = function a(s) {
  var c = s.Field, u = s.fieldProps, d = s.maxWidth, p = s.initialValue, v = s.acitonRender, A = __rest$15(s, ["Field", "fieldProps", "maxWidth", "initialValue", "acitonRender"]), x = u.addons, g = u.schema, b = Object.assign(d ? {
    maxWidth: d
  } : {}, u?.style), y = g.removeBtn, f = reactExports.useContext(ConfigProvider.ConfigContext), m = translation$1(f);
  useUpdateEffect(function() {
    A.onChange(p);
  }, [JSON.stringify(p)]);
  var C = function() {
    if (isFunction$1(y?.onClick)) {
      y.onClick(function() {
        x.setSchemaByPath(x.schemaPath, {
          hidden: !0
        });
      });
      return;
    }
    x.setSchemaByPath(x.schemaPath, {
      hidden: !0
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(c, Object.assign({}, A, u, {
    style: b
  })), y && /* @__PURE__ */ React.createElement(Button$1, Object.assign({
    type: "link",
    danger: !0
  }, y, {
    onClick: C
  }), y?.text || m("delete")), v && /* @__PURE__ */ React.createElement("span", {
    className: "fr-item-actions"
  }, v()));
};
function _typeof$d(a) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$d(a);
}
function _defineProperty$8(a, s, c) {
  return (s = _toPropertyKey$6(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function _toPropertyKey$6(a) {
  var s = _toPrimitive$7(a, "string");
  return _typeof$d(s) == "symbol" ? s : s + "";
}
function _toPrimitive$7(a, s) {
  if (_typeof$d(a) != "object" || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof$d(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
var UpperContext$1 = /* @__PURE__ */ reactExports.createContext(function() {
}), valuePropNameMap = {
  checkbox: "checked",
  switch: "checked",
  Checkbox: "checked",
  Switch: "checked"
};
const Main$2 = function(a) {
  var s, c, u = a.configCtx, d = a.store, p = a.schema, v = a.path, A = a.children, x = a.dependValues, g = a.rootPath, b = reactExports.useRef(null), y = useStore(d, function(he) {
    return he.context;
  }), f = reactExports.useContext(UpperContext$1), m = u.form, C = u.widgets, w = u.methods, S = u.globalProps, $ = p.reserveLabel, T = p.hidden;
  p.properties;
  var I = p.dependencies, _ = p.inlineMode;
  p.remove, p.removeText;
  var E = p.visible, R = E === void 0 ? !0 : E, O = __rest$15(p, ["reserveLabel", "hidden", "properties", "dependencies", "inlineMode", "remove", "removeText", "visible"]), L = getParamValue$1(y, f, p), B = getWidgetName(p), F = getWidget(B, C), M = getFieldProps(B, p, {
    widgets: C,
    methods: w,
    form: m,
    dependValues: x,
    globalProps: S,
    path: getPath(v),
    rootPath: g,
    fieldRef: b
  });
  if (reactExports.useEffect(function() {
    m.setFieldRef(M.addons.dataPath, b);
  }, []), p?.hidden)
    return null;
  if (!B) {
    var W = C.errorSchema || C.ErrorSchema;
    return /* @__PURE__ */ React.createElement(W, {
      schema: p
    });
  }
  if (p.type === "void")
    return /* @__PURE__ */ React.createElement(Col, {
      span: 24
    }, /* @__PURE__ */ React.createElement(F, Object.assign({}, M)));
  var j = L("displayType"), G = _ || f?.displayType === "inline";
  f.exist || (G = _ || y?.displayType === "inline");
  var U = j === "inline", k = L("labelWidth");
  if (A) {
    var N = /* @__PURE__ */ React.createElement("div", {
      className: "fr-inline-container"
    }, A);
    if (!U) {
      var P = {
        row: 16,
        column: 24
      }[j];
      N = /* @__PURE__ */ React.createElement(Row, {
        gutter: P
      }, A);
    }
    M.children = N;
    var D = /* @__PURE__ */ React.createElement(F, Object.assign({
      labelWidth: k,
      displayType: p.displayType
    }, M, O));
    return /* @__PURE__ */ React.createElement(UpperContext$1.Provider, {
      value: {
        column: p.column,
        labelCol: p.labelCol,
        fieldCol: p.fieldCol,
        displayType: p.displayType,
        labelWidth: p.labelWidth,
        noStyle: p.noStyle,
        exist: !0
      }
    }, G ? D : /* @__PURE__ */ React.createElement(Col, {
      span: 24,
      className: classnames("fr-obj-col", _defineProperty$8({}, p.className, !!p.className))
    }, D));
  }
  var H = getLabel$1(p, j, C, M.addons), V = L("noStyle"), Z = getColSpan(y, f, p), ne = getExtraView("extra", p, C, M.addons), K = getExtraView("help", p, C, M.addons), q = getExtraView("action", p, C, M.addons), Y = getTooltip$4(p, j), ee = getRuleList(p, m, w, b), Q = L("readOnly"), J = L("disabled"), te = L("validateTrigger"), ae = L("labelCol"), se = L("fieldCol"), ie = L("maxWidth"), fe = getFormItemLayout(Math.floor(24 / Z * 1), p, {
    displayType: j,
    labelWidth: k,
    _labelCol: ae,
    _fieldCol: se
  }), ge = fe.labelCol, me = fe.fieldCol, pe = p.valuePropName || valuePropNameMap[B] || void 0;
  Q && (M.readOnly = Q), J && (M.disabled = J), $ && !H && j !== "column" && (H = "fr-hide-label"), Q && (F = C[p.readOnlyWidget] || C.Html), isCheckBoxType(p, Q) && (M.title = H, H = null, j === "row" && (H = "fr-hide-label"));
  var be = (s = p.default) !== null && s !== void 0 ? s : p.defaultValue, le = _defineProperty$8({
    "fr-hide-label": H === "fr-hide-label",
    "fr-inline-field": G,
    "fr-field-visibility": !R
  }, p.className, !!p.className), ve = /* @__PURE__ */ React.createElement(Form$1.Item, {
    className: classnames("fr-field", le),
    label: H,
    name: v,
    valuePropName: pe,
    rules: Q ? [] : ee,
    hidden: T,
    tooltip: Y,
    extra: ne,
    help: K,
    initialValue: be,
    labelCol: ge,
    wrapperCol: me,
    noStyle: V,
    dependencies: I,
    validateTrigger: te ?? (!((c = b?.current) === null || c === void 0) && c.validator ? "onSubmit" : "onChange")
  }, M.onStatusChange ? /* @__PURE__ */ React.createElement(FieldWrapperStatus, {
    Field: F,
    fieldProps: M,
    maxWidth: ie,
    initialValue: be,
    acitonRender: q ? function() {
      return q;
    } : void 0
  }) : /* @__PURE__ */ React.createElement(FieldWrapper, {
    Field: F,
    fieldProps: M,
    maxWidth: ie,
    initialValue: be,
    acitonRender: q ? function() {
      return q;
    } : void 0
  }));
  return G ? V ? /* @__PURE__ */ React.createElement("div", {
    className: classnames("fr-inline-field", _defineProperty$8({
      "fr-field-visibility": !R
    }, p.className, !!p.className))
  }, ve) : ve : /* @__PURE__ */ React.createElement(Col, {
    span: Z,
    className: classnames(null, {
      "fr-field-visibility": !R
    })
  }, ve);
}, FieldItem = function(a) {
  var s, c, u = a.schema, d = a.rootPath, p = __rest$15(a, ["schema", "rootPath"]), v = reactExports.useContext(FRContext), A = v.getState(), x = A.schema, g = reactExports.useContext(ConfigContext), b = (s = g?.globalConfig) === null || s === void 0 ? void 0 : s.mustacheDisabled;
  (c = g?.globalConfig) === null || c === void 0 || c.shouldUpdateOpen;
  var y = u?.dependencies;
  if (!_isHasExpression(u) && !b && (!y || !y?.length))
    return /* @__PURE__ */ React.createElement(Main$2, Object.assign({}, a, {
      store: v,
      configCtx: g
    }));
  var f = JSON.stringify(u);
  return /* @__PURE__ */ React.createElement(Form$1.Item, {
    noStyle: !0,
    shouldUpdate: fieldShouldUpdate(f, d, y)
  }, function(m) {
    var C = m.getFieldsValue(!0), w = [], S = (y || []).map(function(T) {
      var I = [];
      return w.push(I), _getDependValues(C, T, a, I);
    }), $ = b ? u : _parseAllExpression(u, C, d, x);
    return /* @__PURE__ */ React.createElement(Main$2, Object.assign({
      schema: Object.assign(Object.assign({}, $), {
        dependencies: w
      }),
      rootPath: d
    }, p, {
      dependValues: S,
      store: v,
      configCtx: g
    }));
  });
};
var getParamValue = function a(s, c, u) {
  return function(d) {
    var p, v;
    return (v = (p = u[d]) !== null && p !== void 0 ? p : c[d]) !== null && v !== void 0 ? v : s[d];
  };
}, getFormListLayout = function a(s, c) {
  var u = s("labelCol"), d = s("fieldCol"), p = s("labelWidth"), v = {
    span: 5
  }, A = {
    flex: 1
  };
  return p && c !== "column" && (v = {
    flex: p + "px"
  }), u && (v = u), d && (A = d), typeof u == "number" && (v = {
    span: u
  }), typeof d == "number" && (A = {
    span: d
  }), {
    labelCol: v,
    fieldCol: A
  };
}, getLabel = function a(s, c, u) {
  var d = s.title, p = s.description, v = s.descWidget, A = s.labelWidget, x = u[A];
  if (x)
    return /* @__PURE__ */ React.createElement(x, {
      schema: s
    });
  if (!p && !v)
    return d;
  var g = function() {
    var y = u[v];
    return y ? /* @__PURE__ */ React.createElement(y, {
      schema: s
    }) : p ? /* @__PURE__ */ React.createElement("span", {
      className: "fr-desc"
    }, "(", p, ")") : null;
  };
  return c === "inline" ? d : /* @__PURE__ */ React.createElement(React.Fragment, null, d, /* @__PURE__ */ React.createElement(g, null));
}, getTooltip$3 = function a(s, c) {
  var u = s.descType, d = s.description, p = s.tooltip;
  return p ? typeof p == "string" ? {
    title: /* @__PURE__ */ React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: p
      }
    })
  } : Object.assign(Object.assign({}, p), {
    title: /* @__PURE__ */ React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: p.title
      }
    })
  }) : u === "widget" || !d ? null : c === "column" && u === "icon" ? {
    title: d
  } : null;
};
function _typeof$c(a) {
  "@babel/helpers - typeof";
  return _typeof$c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$c(a);
}
function _regeneratorRuntime$1() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime$1 = function() {
    return s;
  };
  var a, s = {}, c = Object.prototype, u = c.hasOwnProperty, d = Object.defineProperty || function(k, N, P) {
    k[N] = P.value;
  }, p = typeof Symbol == "function" ? Symbol : {}, v = p.iterator || "@@iterator", A = p.asyncIterator || "@@asyncIterator", x = p.toStringTag || "@@toStringTag";
  function g(k, N, P) {
    return Object.defineProperty(k, N, { value: P, enumerable: !0, configurable: !0, writable: !0 }), k[N];
  }
  try {
    g({}, "");
  } catch {
    g = function(P, D, H) {
      return P[D] = H;
    };
  }
  function b(k, N, P, D) {
    var H = N && N.prototype instanceof $ ? N : $, V = Object.create(H.prototype), Z = new G(D || []);
    return d(V, "_invoke", { value: F(k, P, Z) }), V;
  }
  function y(k, N, P) {
    try {
      return { type: "normal", arg: k.call(N, P) };
    } catch (D) {
      return { type: "throw", arg: D };
    }
  }
  s.wrap = b;
  var f = "suspendedStart", m = "suspendedYield", C = "executing", w = "completed", S = {};
  function $() {
  }
  function T() {
  }
  function I() {
  }
  var _ = {};
  g(_, v, function() {
    return this;
  });
  var E = Object.getPrototypeOf, R = E && E(E(U([])));
  R && R !== c && u.call(R, v) && (_ = R);
  var O = I.prototype = $.prototype = Object.create(_);
  function L(k) {
    ["next", "throw", "return"].forEach(function(N) {
      g(k, N, function(P) {
        return this._invoke(N, P);
      });
    });
  }
  function B(k, N) {
    function P(H, V, Z, ne) {
      var K = y(k[H], k, V);
      if (K.type !== "throw") {
        var q = K.arg, Y = q.value;
        return Y && _typeof$c(Y) == "object" && u.call(Y, "__await") ? N.resolve(Y.__await).then(function(ee) {
          P("next", ee, Z, ne);
        }, function(ee) {
          P("throw", ee, Z, ne);
        }) : N.resolve(Y).then(function(ee) {
          q.value = ee, Z(q);
        }, function(ee) {
          return P("throw", ee, Z, ne);
        });
      }
      ne(K.arg);
    }
    var D;
    d(this, "_invoke", { value: function(V, Z) {
      function ne() {
        return new N(function(K, q) {
          P(V, Z, K, q);
        });
      }
      return D = D ? D.then(ne, ne) : ne();
    } });
  }
  function F(k, N, P) {
    var D = f;
    return function(H, V) {
      if (D === C) throw Error("Generator is already running");
      if (D === w) {
        if (H === "throw") throw V;
        return { value: a, done: !0 };
      }
      for (P.method = H, P.arg = V; ; ) {
        var Z = P.delegate;
        if (Z) {
          var ne = M(Z, P);
          if (ne) {
            if (ne === S) continue;
            return ne;
          }
        }
        if (P.method === "next") P.sent = P._sent = P.arg;
        else if (P.method === "throw") {
          if (D === f) throw D = w, P.arg;
          P.dispatchException(P.arg);
        } else P.method === "return" && P.abrupt("return", P.arg);
        D = C;
        var K = y(k, N, P);
        if (K.type === "normal") {
          if (D = P.done ? w : m, K.arg === S) continue;
          return { value: K.arg, done: P.done };
        }
        K.type === "throw" && (D = w, P.method = "throw", P.arg = K.arg);
      }
    };
  }
  function M(k, N) {
    var P = N.method, D = k.iterator[P];
    if (D === a) return N.delegate = null, P === "throw" && k.iterator.return && (N.method = "return", N.arg = a, M(k, N), N.method === "throw") || P !== "return" && (N.method = "throw", N.arg = new TypeError("The iterator does not provide a '" + P + "' method")), S;
    var H = y(D, k.iterator, N.arg);
    if (H.type === "throw") return N.method = "throw", N.arg = H.arg, N.delegate = null, S;
    var V = H.arg;
    return V ? V.done ? (N[k.resultName] = V.value, N.next = k.nextLoc, N.method !== "return" && (N.method = "next", N.arg = a), N.delegate = null, S) : V : (N.method = "throw", N.arg = new TypeError("iterator result is not an object"), N.delegate = null, S);
  }
  function W(k) {
    var N = { tryLoc: k[0] };
    1 in k && (N.catchLoc = k[1]), 2 in k && (N.finallyLoc = k[2], N.afterLoc = k[3]), this.tryEntries.push(N);
  }
  function j(k) {
    var N = k.completion || {};
    N.type = "normal", delete N.arg, k.completion = N;
  }
  function G(k) {
    this.tryEntries = [{ tryLoc: "root" }], k.forEach(W, this), this.reset(!0);
  }
  function U(k) {
    if (k || k === "") {
      var N = k[v];
      if (N) return N.call(k);
      if (typeof k.next == "function") return k;
      if (!isNaN(k.length)) {
        var P = -1, D = function H() {
          for (; ++P < k.length; ) if (u.call(k, P)) return H.value = k[P], H.done = !1, H;
          return H.value = a, H.done = !0, H;
        };
        return D.next = D;
      }
    }
    throw new TypeError(_typeof$c(k) + " is not iterable");
  }
  return T.prototype = I, d(O, "constructor", { value: I, configurable: !0 }), d(I, "constructor", { value: T, configurable: !0 }), T.displayName = g(I, x, "GeneratorFunction"), s.isGeneratorFunction = function(k) {
    var N = typeof k == "function" && k.constructor;
    return !!N && (N === T || (N.displayName || N.name) === "GeneratorFunction");
  }, s.mark = function(k) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(k, I) : (k.__proto__ = I, g(k, x, "GeneratorFunction")), k.prototype = Object.create(O), k;
  }, s.awrap = function(k) {
    return { __await: k };
  }, L(B.prototype), g(B.prototype, A, function() {
    return this;
  }), s.AsyncIterator = B, s.async = function(k, N, P, D, H) {
    H === void 0 && (H = Promise);
    var V = new B(b(k, N, P, D), H);
    return s.isGeneratorFunction(N) ? V : V.next().then(function(Z) {
      return Z.done ? Z.value : V.next();
    });
  }, L(O), g(O, x, "Generator"), g(O, v, function() {
    return this;
  }), g(O, "toString", function() {
    return "[object Generator]";
  }), s.keys = function(k) {
    var N = Object(k), P = [];
    for (var D in N) P.push(D);
    return P.reverse(), function H() {
      for (; P.length; ) {
        var V = P.pop();
        if (V in N) return H.value = V, H.done = !1, H;
      }
      return H.done = !0, H;
    };
  }, s.values = U, G.prototype = { constructor: G, reset: function(N) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(j), !N) for (var P in this) P.charAt(0) === "t" && u.call(this, P) && !isNaN(+P.slice(1)) && (this[P] = a);
  }, stop: function() {
    this.done = !0;
    var N = this.tryEntries[0].completion;
    if (N.type === "throw") throw N.arg;
    return this.rval;
  }, dispatchException: function(N) {
    if (this.done) throw N;
    var P = this;
    function D(q, Y) {
      return Z.type = "throw", Z.arg = N, P.next = q, Y && (P.method = "next", P.arg = a), !!Y;
    }
    for (var H = this.tryEntries.length - 1; H >= 0; --H) {
      var V = this.tryEntries[H], Z = V.completion;
      if (V.tryLoc === "root") return D("end");
      if (V.tryLoc <= this.prev) {
        var ne = u.call(V, "catchLoc"), K = u.call(V, "finallyLoc");
        if (ne && K) {
          if (this.prev < V.catchLoc) return D(V.catchLoc, !0);
          if (this.prev < V.finallyLoc) return D(V.finallyLoc);
        } else if (ne) {
          if (this.prev < V.catchLoc) return D(V.catchLoc, !0);
        } else {
          if (!K) throw Error("try statement without catch or finally");
          if (this.prev < V.finallyLoc) return D(V.finallyLoc);
        }
      }
    }
  }, abrupt: function(N, P) {
    for (var D = this.tryEntries.length - 1; D >= 0; --D) {
      var H = this.tryEntries[D];
      if (H.tryLoc <= this.prev && u.call(H, "finallyLoc") && this.prev < H.finallyLoc) {
        var V = H;
        break;
      }
    }
    V && (N === "break" || N === "continue") && V.tryLoc <= P && P <= V.finallyLoc && (V = null);
    var Z = V ? V.completion : {};
    return Z.type = N, Z.arg = P, V ? (this.method = "next", this.next = V.finallyLoc, S) : this.complete(Z);
  }, complete: function(N, P) {
    if (N.type === "throw") throw N.arg;
    return N.type === "break" || N.type === "continue" ? this.next = N.arg : N.type === "return" ? (this.rval = this.arg = N.arg, this.method = "return", this.next = "end") : N.type === "normal" && P && (this.next = P), S;
  }, finish: function(N) {
    for (var P = this.tryEntries.length - 1; P >= 0; --P) {
      var D = this.tryEntries[P];
      if (D.finallyLoc === N) return this.complete(D.completion, D.afterLoc), j(D), S;
    }
  }, catch: function(N) {
    for (var P = this.tryEntries.length - 1; P >= 0; --P) {
      var D = this.tryEntries[P];
      if (D.tryLoc === N) {
        var H = D.completion;
        if (H.type === "throw") {
          var V = H.arg;
          j(D);
        }
        return V;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function(N, P, D) {
    return this.delegate = { iterator: U(N), resultName: P, nextLoc: D }, this.method === "next" && (this.arg = a), S;
  } }, s;
}
function _toConsumableArray$8(a) {
  return _arrayWithoutHoles$8(a) || _iterableToArray$8(a) || _unsupportedIterableToArray$g(a) || _nonIterableSpread$8();
}
function _nonIterableSpread$8() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$g(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$g(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$g(a, s) : void 0;
  }
}
function _iterableToArray$8(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$8(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$g(a);
}
function _arrayLikeToArray$g(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
const Main$1 = function(a) {
  var s, c, u = a.form, d = a.schema, p = a.path, v = a.parentLitPath, A = a.renderCore, x = a.rootPath, g = a.methods, b = a.upperCtx, y = a.formCtx, f = a.configContext, m = a.setListData, C = f.widgets, w = f.globalConfig, S = reactExports.useContext(ConfigProvider.ConfigContext), $ = translation$1(S), T = {
    type: "dashed",
    block: !0,
    children: $("add_item")
  }, I = {
    title: $("confirm_delete"),
    okText: $("confirm"),
    cancelText: $("cancel")
  }, _ = {
    colHeaderText: $("operate")
  }, E = d.widget || "cardList", R = getWidget(E, C), O = d.props, L = d.removeBtn, B = d.rules, F = B === void 0 ? [] : B, M = __rest$15(d, ["props", "removeBtn", "rules"]), W = O || {}, j = W.addBtnProps, G = W.delConfirmProps, U = W.actionColumnProps, k = W.hideAdd, N = W.hideCopy, P = W.hideMove, D = W.hideDelete, H = W.onAdd, V = W.onRemove, Z = W.onMove, ne = W.onCopy, K = __rest$15(W, ["addBtnProps", "delConfirmProps", "actionColumnProps", "hideAdd", "hideCopy", "hideMove", "hideDelete", "onAdd", "onRemove", "onMove", "onCopy"]), q = getParamValue(y, b, d), Y = q("readOnly"), ee = _toConsumableArray$8(x || []).splice(0, x.length - 1), Q = q("displayType");
  P === void 0 && (!((s = w?.listOperate) === null || s === void 0) && s.hideMove) && (P = w?.listOperate.hideMove);
  var J = u.getFieldValue([].concat(_toConsumableArray$8(ee), _toConsumableArray$8(p))) || [];
  M?.min > 0 && J.length <= M?.min && (D = !0), M?.max > 0 && M?.max <= J.length && (k = !0), k && (N = !0), Y && (k = !0, N = !0, D = !0, P = !0);
  var te = reactExports.useMemo(function() {
    var be, le = (be = d.default) !== null && be !== void 0 ? be : d.defaultValue;
    return le === void 0 && (le = u.getFieldValue([].concat(_toConsumableArray$8(ee), _toConsumableArray$8(p))), !le && !["drawerList", "list1"].includes(E) && (le = [{}])), le;
  }, []);
  reactExports.useEffect(function() {
    m(te || []);
  }, []);
  var ae = function(le) {
    return function(ve) {
      var he = H;
      if (typeof H == "string" && (he = g[H]), isFunction$1(he)) {
        he(function(ye) {
          return le(ye || ve);
        }, {
          schema: d,
          data: ve
        });
        return;
      }
      le(ve);
    };
  }, se = function(le) {
    return function(ve) {
      var he = V;
      if (typeof V == "string" && (he = g[V]), isFunction$1(he)) {
        var ye = u.getFieldValue([].concat(_toConsumableArray$8(ee), _toConsumableArray$8(p), [ve]));
        he(function() {
          return le(ve);
        }, {
          schema: d,
          index: ve,
          data: ye
        });
        return;
      }
      le(ve);
    };
  }, ie = function(le) {
    return function(ve, he) {
      var ye = Z;
      if (typeof ye == "string" && (ye = g[Z]), isFunction$1(ye)) {
        ye(function() {
          return le(ve, he);
        }, {
          schema: d,
          from: ve,
          to: he
        });
        return;
      }
      le(ve, he);
    };
  }, fe = function(le, ve) {
    return function(he, ye) {
      if (d.max && ve.length === d.max)
        return staticMethods.warning($("copy_max_tip"));
      var Ce = ne;
      if (typeof ne == "string" && (Ce = g[ne]), isFunction$1(Ce)) {
        console.log(ye, "copyIndex"), Ce(function(xe) {
          return le(xe || he);
        }, {
          schema: d,
          data: he,
          copyIndex: ye
        });
        return;
      }
      le(he);
    };
  }, ge = function() {
    if (isFunction$1(L?.onClick)) {
      L.onClick(function() {
        u.setSchemaByPath(p, {
          hidden: !0
        });
      });
      return;
    }
    u.setSchemaByPath(p, {
      hidden: !0
    });
  }, me = (c = w?.listOperate) === null || c === void 0 ? void 0 : c.btnType, pe = [];
  return Y || (pe = [{
    validator: function(le, ve) {
      return __awaiter$2(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime$1().mark(function he() {
        var ye;
        return _regeneratorRuntime$1().wrap(function(xe) {
          for (; ; ) switch (xe.prev = xe.next) {
            case 0:
              if (m(ve), M?.min) {
                xe.next = 3;
                break;
              }
              return xe.abrupt("return");
            case 3:
              if (!(!ve || ve.length < M.min)) {
                xe.next = 5;
                break;
              }
              return xe.abrupt("return", Promise.reject(new Error(((ye = M?.message) === null || ye === void 0 ? void 0 : ye.min) || "数据长度必须大于等于".concat(M.min))));
            case 5:
            case "end":
              return xe.stop();
          }
        }, he);
      }));
    }
  }].concat(_toConsumableArray$8(transformRules(F || [], g, u)))), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Form$1.List, {
    name: p,
    initialValue: te,
    rules: pe
  }, function(be, le, ve) {
    var he = ve.errors;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(R, Object.assign({}, K, {
      configContext: f,
      form: u,
      schema: M,
      fields: be,
      operation: le,
      path: p,
      listName: p,
      parentLitPath: v,
      rootPath: [].concat(_toConsumableArray$8(ee), _toConsumableArray$8(p)),
      readOnly: Y,
      methods: g,
      renderCore: A,
      widgets: C,
      hideAdd: k,
      hideCopy: N,
      hideDelete: D,
      hideMove: P,
      addItem: ae(le.add),
      removeItem: se(le.remove),
      moveItem: ie(le.move),
      copyItem: fe(le.add, be),
      temporary: {
        displayType: Q
      },
      addBtnProps: Object.assign(Object.assign({}, T), j),
      delConfirmProps: Object.assign(Object.assign({}, I), G),
      actionColumnProps: Object.assign(Object.assign({}, _), U),
      copyBtnProps: {
        children: $("copy"),
        btnType: me
      },
      editorBtnProps: {
        children: $("edit"),
        btnType: me
      },
      deleteBtnProps: {
        children: $("delete"),
        btnType: me
      },
      moveUpBtnProps: {
        children: $("moveUp"),
        btnType: me
      },
      moveDownBtnProps: {
        children: $("moveDown"),
        btnType: me
      }
    })), he?.length !== 0 && /* @__PURE__ */ React.createElement("div", {
      style: {
        marginBottom: "12px"
      }
    }, /* @__PURE__ */ React.createElement(Form$1.ErrorList, {
      errors: he
    })));
  }), L && /* @__PURE__ */ React.createElement(Button$1, Object.assign({
    type: "link",
    danger: !0
  }, L, {
    onClick: ge
  }), L?.text || $("delete")));
};
function _toConsumableArray$7(a) {
  return _arrayWithoutHoles$7(a) || _iterableToArray$7(a) || _unsupportedIterableToArray$f(a) || _nonIterableSpread$7();
}
function _nonIterableSpread$7() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$7(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$7(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$f(a);
}
function _slicedToArray$d(a, s) {
  return _arrayWithHoles$d(a) || _iterableToArrayLimit$d(a, s) || _unsupportedIterableToArray$f(a, s) || _nonIterableRest$d();
}
function _nonIterableRest$d() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$f(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$f(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$f(a, s) : void 0;
  }
}
function _arrayLikeToArray$f(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$d(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$d(a) {
  if (Array.isArray(a)) return a;
}
var UpperContext = /* @__PURE__ */ reactExports.createContext(function() {
});
const Main = function(a) {
  var s = reactExports.useState([]), c = _slicedToArray$d(s, 2);
  c[0];
  var u = c[1], d = a.configContext, p = reactExports.useContext(FRContext), v = useStore(p, function(N) {
    return N.context;
  }), A = reactExports.useContext(UpperContext), x = d.form, g = d.widgets, b = d.methods, y = d.globalConfig, f = v.displayType, m = f === "column", C = a.schema, w = x.getFieldsValue(!0), S = p.getState(), $ = S.schema, T = C.items, I = C.className, _ = __rest$15(C, ["items", "className"]), E = y?.mustacheDisabled ? C : Object.assign({
    items: T
  }, _parseAllExpression(_, w, a.rootPath, $)), R = E.widget, O = R || "list1", L = getParamValue(v, A, E), B = getLabel(E, f, g), F = getTooltip$3(E, f), M = getFormListLayout(L, f), W = M.labelCol, j = M.fieldCol, G = E.display === "inline", U = _toConsumableArray$7(a.rootPath || []).splice(0, a.rootPath.length - 1), k = x.getFieldValue([].concat(_toConsumableArray$7(U), _toConsumableArray$7(a.path)));
  return !k?.length && O !== "drawerList" && (G = !0), E.hidden ? null : /* @__PURE__ */ React.createElement(Col, {
    span: 24,
    className: I
  }, !G && !m && B && /* @__PURE__ */ React.createElement(Form$1.Item, {
    className: "ant-form-item-optional-hide",
    label: B,
    labelAlign: "left",
    colon: !1,
    tooltip: F,
    style: {
      marginBottom: 0
    },
    labelCol: {
      span: 24
    }
  }), /* @__PURE__ */ React.createElement(Form$1.Item, {
    label: B,
    labelCol: m ? {
      span: 24
    } : W,
    wrapperCol: j,
    noStyle: !G && !m,
    tooltip: F
  }, /* @__PURE__ */ React.createElement(Main$1, Object.assign({}, a, {
    form: x,
    methods: b,
    formCtx: v,
    upperCtx: A,
    widgets: g,
    configContext: d,
    setListData: u
  }))));
}, FieldList = function(a) {
  var s, c = a.schema, u = a.rootPath, d = c || {}, p = d.items, v = __rest$15(d, ["items"]), A = reactExports.useContext(FRContext), x = A.getState(), g = x.schema, b = reactExports.useContext(ConfigContext), y = (s = b?.globalConfig) === null || s === void 0 ? void 0 : s.mustacheDisabled, f = c?.dependencies;
  return !_isHasExpression(c) && !y && (!f || !f?.length) ? /* @__PURE__ */ React.createElement(Main, Object.assign({
    configContext: b
  }, a)) : /* @__PURE__ */ React.createElement(Form$1.Item, {
    noStyle: !0,
    shouldUpdate: fieldShouldUpdate(JSON.stringify(v || {}), u, f)
  }, function(m) {
    var C = m.getFieldsValue(!0), w = y ? c : _parseAllExpression(v, C, u, g);
    return /* @__PURE__ */ React.createElement(Main, Object.assign({
      configContext: b
    }, a, {
      schema: Object.assign({
        items: p
      }, w),
      rootPath: u
    }));
  });
};
function _slicedToArray$c(a, s) {
  return _arrayWithHoles$c(a) || _iterableToArrayLimit$c(a, s) || _unsupportedIterableToArray$e(a, s) || _nonIterableRest$c();
}
function _nonIterableRest$c() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$e(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$e(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$e(a, s) : void 0;
  }
}
function _arrayLikeToArray$e(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$c(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s === 0) {
        if (Object(c) !== c) return;
        x = !1;
      } else for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$c(a) {
  if (Array.isArray(a)) return a;
}
const sortProperties = function(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "order", c = /* @__PURE__ */ new Map(), u = [], d = function(A) {
    var x = _slicedToArray$c(A, 2), g = x[1];
    if (typeof g[s] != "number") {
      u.push(A);
      return;
    }
    c.has(g[s]) ? c.get(g[s]).push(A) : c.set(g[s], [A]);
  };
  a.forEach(function(v) {
    return d(v);
  });
  var p = Array.from(c.entries()).sort(function(v, A) {
    var x = _slicedToArray$c(v, 1), g = x[0], b = _slicedToArray$c(A, 1), y = b[0];
    return g - y;
  }).flatMap(function(v) {
    var A = _slicedToArray$c(v, 2), x = A[1];
    return x;
  });
  return p.concat(u);
};
function _toConsumableArray$6(a) {
  return _arrayWithoutHoles$6(a) || _iterableToArray$6(a) || _unsupportedIterableToArray$d(a) || _nonIterableSpread$6();
}
function _nonIterableSpread$6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$6(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$6(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$d(a);
}
function _slicedToArray$b(a, s) {
  return _arrayWithHoles$b(a) || _iterableToArrayLimit$b(a, s) || _unsupportedIterableToArray$d(a, s) || _nonIterableRest$b();
}
function _nonIterableRest$b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$d(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$d(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$d(a, s) : void 0;
  }
}
function _arrayLikeToArray$d(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$b(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$b(a) {
  if (Array.isArray(a)) return a;
}
var renderItem = function a(s) {
  var c, u = s.schema, d = s.key, p = s.path, v = s.rootPath;
  if (u.type === "array" && ((c = u.items) === null || c === void 0 ? void 0 : c.type) === "object")
    return /* @__PURE__ */ React.createElement(FieldList, {
      key: d,
      schema: u,
      path: p,
      rootPath: v,
      renderCore: RenderCore
    });
  var A = null;
  return u?.properties && u?.widgetType !== "field" && (A = RenderCore({
    schema: u,
    parentPath: p,
    rootPath: v
  })), /* @__PURE__ */ React.createElement(FieldItem, {
    key: d,
    schema: u,
    path: p,
    rootPath: v,
    children: A,
    renderCore: RenderCore
  });
}, RenderCore = function a(s) {
  var c = s.schema, u = s.parentPath, d = u === void 0 ? [] : u, p = s.rootPath, v = p === void 0 ? [] : p;
  return !c || Object.keys(c).length === 0 ? null : c?.items ? renderItem({
    schema: c.items,
    path: d,
    rootPath: v
  }) : sortProperties(Object.entries(c.properties || {})).map(function(A) {
    var x = _slicedToArray$b(A, 2), g = x[0], b = x[1], y = [].concat(_toConsumableArray$6(d), [g]);
    return renderItem({
      schema: b,
      path: y,
      key: g,
      rootPath: v
    });
  });
};
function _typeof$b(a) {
  "@babel/helpers - typeof";
  return _typeof$b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$b(a);
}
function _defineProperty$7(a, s, c) {
  return (s = _toPropertyKey$5(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function _toPropertyKey$5(a) {
  var s = _toPrimitive$6(a, "string");
  return _typeof$b(s) == "symbol" ? s : s + "";
}
function _toPrimitive$6(a, s) {
  if (_typeof$b(a) != "object" || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof$b(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function() {
    return s;
  };
  var a, s = {}, c = Object.prototype, u = c.hasOwnProperty, d = Object.defineProperty || function(k, N, P) {
    k[N] = P.value;
  }, p = typeof Symbol == "function" ? Symbol : {}, v = p.iterator || "@@iterator", A = p.asyncIterator || "@@asyncIterator", x = p.toStringTag || "@@toStringTag";
  function g(k, N, P) {
    return Object.defineProperty(k, N, { value: P, enumerable: !0, configurable: !0, writable: !0 }), k[N];
  }
  try {
    g({}, "");
  } catch {
    g = function(P, D, H) {
      return P[D] = H;
    };
  }
  function b(k, N, P, D) {
    var H = N && N.prototype instanceof $ ? N : $, V = Object.create(H.prototype), Z = new G(D || []);
    return d(V, "_invoke", { value: F(k, P, Z) }), V;
  }
  function y(k, N, P) {
    try {
      return { type: "normal", arg: k.call(N, P) };
    } catch (D) {
      return { type: "throw", arg: D };
    }
  }
  s.wrap = b;
  var f = "suspendedStart", m = "suspendedYield", C = "executing", w = "completed", S = {};
  function $() {
  }
  function T() {
  }
  function I() {
  }
  var _ = {};
  g(_, v, function() {
    return this;
  });
  var E = Object.getPrototypeOf, R = E && E(E(U([])));
  R && R !== c && u.call(R, v) && (_ = R);
  var O = I.prototype = $.prototype = Object.create(_);
  function L(k) {
    ["next", "throw", "return"].forEach(function(N) {
      g(k, N, function(P) {
        return this._invoke(N, P);
      });
    });
  }
  function B(k, N) {
    function P(H, V, Z, ne) {
      var K = y(k[H], k, V);
      if (K.type !== "throw") {
        var q = K.arg, Y = q.value;
        return Y && _typeof$b(Y) == "object" && u.call(Y, "__await") ? N.resolve(Y.__await).then(function(ee) {
          P("next", ee, Z, ne);
        }, function(ee) {
          P("throw", ee, Z, ne);
        }) : N.resolve(Y).then(function(ee) {
          q.value = ee, Z(q);
        }, function(ee) {
          return P("throw", ee, Z, ne);
        });
      }
      ne(K.arg);
    }
    var D;
    d(this, "_invoke", { value: function(V, Z) {
      function ne() {
        return new N(function(K, q) {
          P(V, Z, K, q);
        });
      }
      return D = D ? D.then(ne, ne) : ne();
    } });
  }
  function F(k, N, P) {
    var D = f;
    return function(H, V) {
      if (D === C) throw Error("Generator is already running");
      if (D === w) {
        if (H === "throw") throw V;
        return { value: a, done: !0 };
      }
      for (P.method = H, P.arg = V; ; ) {
        var Z = P.delegate;
        if (Z) {
          var ne = M(Z, P);
          if (ne) {
            if (ne === S) continue;
            return ne;
          }
        }
        if (P.method === "next") P.sent = P._sent = P.arg;
        else if (P.method === "throw") {
          if (D === f) throw D = w, P.arg;
          P.dispatchException(P.arg);
        } else P.method === "return" && P.abrupt("return", P.arg);
        D = C;
        var K = y(k, N, P);
        if (K.type === "normal") {
          if (D = P.done ? w : m, K.arg === S) continue;
          return { value: K.arg, done: P.done };
        }
        K.type === "throw" && (D = w, P.method = "throw", P.arg = K.arg);
      }
    };
  }
  function M(k, N) {
    var P = N.method, D = k.iterator[P];
    if (D === a) return N.delegate = null, P === "throw" && k.iterator.return && (N.method = "return", N.arg = a, M(k, N), N.method === "throw") || P !== "return" && (N.method = "throw", N.arg = new TypeError("The iterator does not provide a '" + P + "' method")), S;
    var H = y(D, k.iterator, N.arg);
    if (H.type === "throw") return N.method = "throw", N.arg = H.arg, N.delegate = null, S;
    var V = H.arg;
    return V ? V.done ? (N[k.resultName] = V.value, N.next = k.nextLoc, N.method !== "return" && (N.method = "next", N.arg = a), N.delegate = null, S) : V : (N.method = "throw", N.arg = new TypeError("iterator result is not an object"), N.delegate = null, S);
  }
  function W(k) {
    var N = { tryLoc: k[0] };
    1 in k && (N.catchLoc = k[1]), 2 in k && (N.finallyLoc = k[2], N.afterLoc = k[3]), this.tryEntries.push(N);
  }
  function j(k) {
    var N = k.completion || {};
    N.type = "normal", delete N.arg, k.completion = N;
  }
  function G(k) {
    this.tryEntries = [{ tryLoc: "root" }], k.forEach(W, this), this.reset(!0);
  }
  function U(k) {
    if (k || k === "") {
      var N = k[v];
      if (N) return N.call(k);
      if (typeof k.next == "function") return k;
      if (!isNaN(k.length)) {
        var P = -1, D = function H() {
          for (; ++P < k.length; ) if (u.call(k, P)) return H.value = k[P], H.done = !1, H;
          return H.value = a, H.done = !0, H;
        };
        return D.next = D;
      }
    }
    throw new TypeError(_typeof$b(k) + " is not iterable");
  }
  return T.prototype = I, d(O, "constructor", { value: I, configurable: !0 }), d(I, "constructor", { value: T, configurable: !0 }), T.displayName = g(I, x, "GeneratorFunction"), s.isGeneratorFunction = function(k) {
    var N = typeof k == "function" && k.constructor;
    return !!N && (N === T || (N.displayName || N.name) === "GeneratorFunction");
  }, s.mark = function(k) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(k, I) : (k.__proto__ = I, g(k, x, "GeneratorFunction")), k.prototype = Object.create(O), k;
  }, s.awrap = function(k) {
    return { __await: k };
  }, L(B.prototype), g(B.prototype, A, function() {
    return this;
  }), s.AsyncIterator = B, s.async = function(k, N, P, D, H) {
    H === void 0 && (H = Promise);
    var V = new B(b(k, N, P, D), H);
    return s.isGeneratorFunction(N) ? V : V.next().then(function(Z) {
      return Z.done ? Z.value : V.next();
    });
  }, L(O), g(O, x, "Generator"), g(O, v, function() {
    return this;
  }), g(O, "toString", function() {
    return "[object Generator]";
  }), s.keys = function(k) {
    var N = Object(k), P = [];
    for (var D in N) P.push(D);
    return P.reverse(), function H() {
      for (; P.length; ) {
        var V = P.pop();
        if (V in N) return H.value = V, H.done = !1, H;
      }
      return H.done = !0, H;
    };
  }, s.values = U, G.prototype = { constructor: G, reset: function(N) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(j), !N) for (var P in this) P.charAt(0) === "t" && u.call(this, P) && !isNaN(+P.slice(1)) && (this[P] = a);
  }, stop: function() {
    this.done = !0;
    var N = this.tryEntries[0].completion;
    if (N.type === "throw") throw N.arg;
    return this.rval;
  }, dispatchException: function(N) {
    if (this.done) throw N;
    var P = this;
    function D(q, Y) {
      return Z.type = "throw", Z.arg = N, P.next = q, Y && (P.method = "next", P.arg = a), !!Y;
    }
    for (var H = this.tryEntries.length - 1; H >= 0; --H) {
      var V = this.tryEntries[H], Z = V.completion;
      if (V.tryLoc === "root") return D("end");
      if (V.tryLoc <= this.prev) {
        var ne = u.call(V, "catchLoc"), K = u.call(V, "finallyLoc");
        if (ne && K) {
          if (this.prev < V.catchLoc) return D(V.catchLoc, !0);
          if (this.prev < V.finallyLoc) return D(V.finallyLoc);
        } else if (ne) {
          if (this.prev < V.catchLoc) return D(V.catchLoc, !0);
        } else {
          if (!K) throw Error("try statement without catch or finally");
          if (this.prev < V.finallyLoc) return D(V.finallyLoc);
        }
      }
    }
  }, abrupt: function(N, P) {
    for (var D = this.tryEntries.length - 1; D >= 0; --D) {
      var H = this.tryEntries[D];
      if (H.tryLoc <= this.prev && u.call(H, "finallyLoc") && this.prev < H.finallyLoc) {
        var V = H;
        break;
      }
    }
    V && (N === "break" || N === "continue") && V.tryLoc <= P && P <= V.finallyLoc && (V = null);
    var Z = V ? V.completion : {};
    return Z.type = N, Z.arg = P, V ? (this.method = "next", this.next = V.finallyLoc, S) : this.complete(Z);
  }, complete: function(N, P) {
    if (N.type === "throw") throw N.arg;
    return N.type === "break" || N.type === "continue" ? this.next = N.arg : N.type === "return" ? (this.rval = this.arg = N.arg, this.method = "return", this.next = "end") : N.type === "normal" && P && (this.next = P), S;
  }, finish: function(N) {
    for (var P = this.tryEntries.length - 1; P >= 0; --P) {
      var D = this.tryEntries[P];
      if (D.finallyLoc === N) return this.complete(D.completion, D.afterLoc), j(D), S;
    }
  }, catch: function(N) {
    for (var P = this.tryEntries.length - 1; P >= 0; --P) {
      var D = this.tryEntries[P];
      if (D.tryLoc === N) {
        var H = D.completion;
        if (H.type === "throw") {
          var V = H.arg;
          j(D);
        }
        return V;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function(N, P, D) {
    return this.delegate = { iterator: U(N), resultName: P, nextLoc: D }, this.method === "next" && (this.arg = a), S;
  } }, s;
}
var FormCore = function a(s) {
  var c, u, d, p, v, A = reactExports.useContext(FRContext), x = useStore(A, function(ie) {
    return ie.schema;
  }), g = useStore(A, function(ie) {
    return ie.flattenSchema;
  }), b = useStore(A, function(ie) {
    return ie.setContext;
  }), y = reactExports.useContext(ConfigProvider.ConfigContext), f = translation$1(y), m = x || {};
  m.type, m.properties;
  var C = __rest$15(m, ["type", "properties"]), w = transformProps(Object.assign(Object.assign({}, s), C)), S = w.formProps, $ = w.displayType, T = w.beforeFinish, I = w.watch, _ = w.onMount, E = w.column, R = w.labelWidth, O = w.labelCol, L = w.fieldCol, B = w.maxWidth, F = w.form, M = w.onFinish, W = w.onFinishFailed, j = w.readOnly, G = w.disabled, U = w.footer, k = w.removeHiddenData, N = w.operateExtra, P = w.logOnMount, D = w.logOnSubmit, H = w.id, V = w.className, Z = w.validateTrigger, ne = w.antdVersion;
  reactExports.useEffect(function() {
    F.__initStore(A), setTimeout(K, 0), window.antdVersion = ne;
  }, []), reactExports.useEffect(function() {
    F.setSchema(s.schema, !0);
  }, [JSON.stringify(s.schema || {})]), reactExports.useEffect(function() {
    A.setState({
      removeHiddenData: k
    });
  }, [k]), reactExports.useEffect(function() {
    var ie = {
      column: E,
      readOnly: j,
      disabled: G,
      labelWidth: R,
      displayType: $,
      labelCol: O,
      fieldCol: L,
      maxWidth: B,
      validateTrigger: Z
    };
    b(ie);
  }, [E, O, L, $, R, B, j, G, Z]);
  var K = function() {
    return __awaiter$2(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime().mark(function fe() {
      return _regeneratorRuntime().wrap(function(me) {
        for (; ; ) switch (me.prev = me.next) {
          case 0:
            if (me.t0 = _, !me.t0) {
              me.next = 4;
              break;
            }
            return me.next = 4, _();
          case 4:
            q(), setTimeout(function() {
              var pe = F.getValues();
              immediateWatch(I, pe);
            }, 0);
          case 6:
          case "end":
            return me.stop();
        }
      }, fe);
    }));
  }, q = function() {
    var fe = (/* @__PURE__ */ new Date()).getTime();
    if ((isFunction$1(P) || isFunction$1(D)) && (setSessionItem("FORM_MOUNT_TIME", fe), setSessionItem("FORM_START", fe)), isFunction$1(P)) {
      var ge = {
        schema: s.schema,
        url: location.href,
        formData: JSON.stringify(F.getValues()),
        formMount: yymmdd(fe)
      };
      H && (ge.id = H), P(ge);
    }
    isFunction$1(D) && (setSessionItem("NUMBER_OF_SUBMITS", 0), setSessionItem("FAILED_ATTEMPTS", 0));
  }, Y = function(fe) {
    if (isFunction$1(D)) {
      var ge = getSessionItem("FORM_START"), me = getSessionItem("FORM_MOUNT_TIME"), pe = getSessionItem("NUMBER_OF_SUBMITS") + 1, be = (/* @__PURE__ */ new Date()).getTime(), le = getSessionItem("FAILED_ATTEMPTS");
      fe.errorFields.length > 0 && (le = le + 1);
      var ve = {
        formMount: yymmdd(me),
        ms: be - ge,
        duration: msToTime(be - ge),
        numberOfSubmits: pe,
        failedAttempts: le,
        url: location.href,
        formData: JSON.stringify(fe.values),
        errors: JSON.stringify(fe.errorFields),
        schema: JSON.stringify(x)
      };
      H && (ve.id = H), D(ve), setSessionItem("FORM_START", be), setSessionItem("NUMBER_OF_SUBMITS", pe), setSessionItem("FAILED_ATTEMPTS", le);
    }
  }, ee = function(fe, ge) {
    var me = filterValuesUndefined(ge, !0);
    valuesWatch(fe, me, I);
  }, Q = function(fe) {
    var ge = cloneDeep(fe);
    return ge = k ? filterValuesHidden(ge, g) : cloneDeep(F.getFieldsValue(!0)), ge = parseValuesToBind(ge, g), ge = filterValuesUndefined(ge), ge;
  }, J = function(fe) {
    return __awaiter$2(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime().mark(function ge() {
      var me, pe;
      return _regeneratorRuntime().wrap(function(le) {
        for (; ; ) switch (le.prev = le.next) {
          case 0:
            if (me = Q(fe), !T) {
              le.next = 7;
              break;
            }
            return le.next = 4, T({
              data: me,
              schema: x,
              errors: []
            });
          case 4:
            le.t0 = le.sent, le.next = 8;
            break;
          case 7:
            le.t0 = null;
          case 8:
            if (pe = le.t0, !(pe?.length > 0)) {
              le.next = 12;
              break;
            }
            return F.setFields(pe), le.abrupt("return");
          case 12:
            Y({
              values: me
            }), M && M(me, []);
          case 14:
          case "end":
            return le.stop();
        }
      }, ge);
    }));
  }, te = function(fe) {
    return __awaiter$2(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime().mark(function ge() {
      var me;
      return _regeneratorRuntime().wrap(function(be) {
        for (; ; ) switch (be.prev = be.next) {
          case 0:
            if (me = Q(fe.values), Y(Object.assign(Object.assign({}, fe), {
              values: me
            })), W) {
              be.next = 4;
              break;
            }
            return be.abrupt("return");
          case 4:
            W(Object.assign(Object.assign({}, fe), {
              values: me
            }));
          case 5:
          case "end":
            return be.stop();
        }
      }, ge);
    }));
  }, ae = (c = getFormItemLayout(E, {}, {
    labelWidth: R
  })) === null || c === void 0 ? void 0 : c.labelCol, se = [];
  return !((u = U?.reset) === null || u === void 0) && u.hide || se.push(/* @__PURE__ */ React.createElement(Button$1, Object.assign({
    key: "reset"
  }, U?.reset, {
    onClick: function() {
      return F.resetFields();
    }
  }), ((d = U?.reset) === null || d === void 0 ? void 0 : d.text) || f("reset"))), !((p = U?.submit) === null || p === void 0) && p.hide || se.push(/* @__PURE__ */ React.createElement(Button$1, Object.assign({
    key: "submit",
    type: "primary",
    onClick: F.submit
  }, U?.submit), ((v = U?.submit) === null || v === void 0 ? void 0 : v.text) || f("submit"))), /* @__PURE__ */ React.createElement(Form$1, Object.assign({
    className: classnames("fr-form", _defineProperty$7({}, V, !!V)),
    labelWrap: !0
  }, S, {
    disabled: G,
    form: F,
    onFinish: J,
    onFinishFailed: te,
    onValuesChange: ee
  }), /* @__PURE__ */ React.createElement(Row, {
    gutter: $ === "row" ? 16 : 24
  }, /* @__PURE__ */ React.createElement(RenderCore, {
    schema: x
  }), N), x && !!U && /* @__PURE__ */ React.createElement(Row, {
    gutter: $ === "row" ? 16 : 24
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 24 / E
  }, /* @__PURE__ */ React.createElement(Form$1.Item, {
    label: $ !== "column" ? "hideLabel" : null,
    labelCol: ae,
    className: "fr-hide-label"
  }, isFunction$1(U) ? /* @__PURE__ */ React.createElement(Space, null, U(se)) : /* @__PURE__ */ React.createElement(Space, null, se)))));
}, zh_CN$5 = {}, interopRequireDefault = { exports: {} }, hasRequiredInteropRequireDefault;
function requireInteropRequireDefault() {
  return hasRequiredInteropRequireDefault || (hasRequiredInteropRequireDefault = 1, function(a) {
    function s(c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(interopRequireDefault)), interopRequireDefault.exports;
}
var zh_CN$4 = {}, hasRequiredZh_CN$5;
function requireZh_CN$5() {
  if (hasRequiredZh_CN$5) return zh_CN$4;
  hasRequiredZh_CN$5 = 1, Object.defineProperty(zh_CN$4, "__esModule", {
    value: !0
  }), zh_CN$4.default = void 0;
  var a = {
    // Options
    items_per_page: "条/页",
    jump_to: "跳至",
    jump_to_confirm: "确定",
    page: "页",
    // Pagination
    prev_page: "上一页",
    next_page: "下一页",
    prev_5: "向前 5 页",
    next_5: "向后 5 页",
    prev_3: "向前 3 页",
    next_3: "向后 3 页",
    page_size: "页码"
  };
  return zh_CN$4.default = a, zh_CN$4;
}
var zh_CN$3 = {}, zh_CN$2 = {}, zh_CN$1 = {}, objectSpread2 = { exports: {} }, defineProperty$3 = { exports: {} }, toPropertyKey = { exports: {} }, _typeof$a = { exports: {} }, hasRequired_typeof$1;
function require_typeof$1() {
  return hasRequired_typeof$1 || (hasRequired_typeof$1 = 1, function(a) {
    function s(c) {
      "@babel/helpers - typeof";
      return a.exports = s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
        return typeof u;
      } : function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, a.exports.__esModule = !0, a.exports.default = a.exports, s(c);
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(_typeof$a)), _typeof$a.exports;
}
var toPrimitive = { exports: {} }, hasRequiredToPrimitive;
function requireToPrimitive() {
  return hasRequiredToPrimitive || (hasRequiredToPrimitive = 1, function(a) {
    var s = require_typeof$1().default;
    function c(u, d) {
      if (s(u) != "object" || !u) return u;
      var p = u[Symbol.toPrimitive];
      if (p !== void 0) {
        var v = p.call(u, d || "default");
        if (s(v) != "object") return v;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (d === "string" ? String : Number)(u);
    }
    a.exports = c, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(toPrimitive)), toPrimitive.exports;
}
var hasRequiredToPropertyKey;
function requireToPropertyKey() {
  return hasRequiredToPropertyKey || (hasRequiredToPropertyKey = 1, function(a) {
    var s = require_typeof$1().default, c = requireToPrimitive();
    function u(d) {
      var p = c(d, "string");
      return s(p) == "symbol" ? p : p + "";
    }
    a.exports = u, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(toPropertyKey)), toPropertyKey.exports;
}
var hasRequiredDefineProperty$3;
function requireDefineProperty$3() {
  return hasRequiredDefineProperty$3 || (hasRequiredDefineProperty$3 = 1, function(a) {
    var s = requireToPropertyKey();
    function c(u, d, p) {
      return (d = s(d)) in u ? Object.defineProperty(u, d, {
        value: p,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : u[d] = p, u;
    }
    a.exports = c, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(defineProperty$3)), defineProperty$3.exports;
}
var hasRequiredObjectSpread2;
function requireObjectSpread2() {
  return hasRequiredObjectSpread2 || (hasRequiredObjectSpread2 = 1, function(a) {
    var s = requireDefineProperty$3();
    function c(d, p) {
      var v = Object.keys(d);
      if (Object.getOwnPropertySymbols) {
        var A = Object.getOwnPropertySymbols(d);
        p && (A = A.filter(function(x) {
          return Object.getOwnPropertyDescriptor(d, x).enumerable;
        })), v.push.apply(v, A);
      }
      return v;
    }
    function u(d) {
      for (var p = 1; p < arguments.length; p++) {
        var v = arguments[p] != null ? arguments[p] : {};
        p % 2 ? c(Object(v), !0).forEach(function(A) {
          s(d, A, v[A]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(v)) : c(Object(v)).forEach(function(A) {
          Object.defineProperty(d, A, Object.getOwnPropertyDescriptor(v, A));
        });
      }
      return d;
    }
    a.exports = u, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(objectSpread2)), objectSpread2.exports;
}
var common = {}, hasRequiredCommon;
function requireCommon() {
  return hasRequiredCommon || (hasRequiredCommon = 1, Object.defineProperty(common, "__esModule", {
    value: !0
  }), common.commonLocale = void 0, common.commonLocale = {
    yearFormat: "YYYY",
    dayFormat: "D",
    cellMeridiemFormat: "A",
    monthBeforeYear: !0
  }), common;
}
var hasRequiredZh_CN$4;
function requireZh_CN$4() {
  if (hasRequiredZh_CN$4) return zh_CN$1;
  hasRequiredZh_CN$4 = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(zh_CN$1, "__esModule", {
    value: !0
  }), zh_CN$1.default = void 0;
  var s = a(requireObjectSpread2()), c = requireCommon(), u = (0, s.default)((0, s.default)({}, c.commonLocale), {}, {
    locale: "zh_CN",
    today: "今天",
    now: "此刻",
    backToToday: "返回今天",
    ok: "确定",
    timeSelect: "选择时间",
    dateSelect: "选择日期",
    weekSelect: "选择周",
    clear: "清除",
    week: "周",
    month: "月",
    year: "年",
    previousMonth: "上个月 (翻页上键)",
    nextMonth: "下个月 (翻页下键)",
    monthSelect: "选择月份",
    yearSelect: "选择年份",
    decadeSelect: "选择年代",
    previousYear: "上一年 (Control键加左方向键)",
    nextYear: "下一年 (Control键加右方向键)",
    previousDecade: "上一年代",
    nextDecade: "下一年代",
    previousCentury: "上一世纪",
    nextCentury: "下一世纪",
    yearFormat: "YYYY年",
    cellDateFormat: "D",
    monthBeforeYear: !1
  });
  return zh_CN$1.default = u, zh_CN$1;
}
var zh_CN = {}, hasRequiredZh_CN$3;
function requireZh_CN$3() {
  if (hasRequiredZh_CN$3) return zh_CN;
  hasRequiredZh_CN$3 = 1, Object.defineProperty(zh_CN, "__esModule", {
    value: !0
  }), zh_CN.default = void 0;
  const a = {
    placeholder: "请选择时间",
    rangePlaceholder: ["开始时间", "结束时间"]
  };
  return zh_CN.default = a, zh_CN;
}
var hasRequiredZh_CN$2;
function requireZh_CN$2() {
  if (hasRequiredZh_CN$2) return zh_CN$2;
  hasRequiredZh_CN$2 = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(zh_CN$2, "__esModule", {
    value: !0
  }), zh_CN$2.default = void 0;
  var s = a(requireZh_CN$4()), c = a(/* @__PURE__ */ requireZh_CN$3());
  const u = {
    lang: Object.assign({
      placeholder: "请选择日期",
      yearPlaceholder: "请选择年份",
      quarterPlaceholder: "请选择季度",
      monthPlaceholder: "请选择月份",
      weekPlaceholder: "请选择周",
      rangePlaceholder: ["开始日期", "结束日期"],
      rangeYearPlaceholder: ["开始年份", "结束年份"],
      rangeMonthPlaceholder: ["开始月份", "结束月份"],
      rangeQuarterPlaceholder: ["开始季度", "结束季度"],
      rangeWeekPlaceholder: ["开始周", "结束周"]
    }, s.default),
    timePickerLocale: Object.assign({}, c.default)
  };
  return u.lang.ok = "确定", zh_CN$2.default = u, zh_CN$2;
}
var hasRequiredZh_CN$1;
function requireZh_CN$1() {
  if (hasRequiredZh_CN$1) return zh_CN$3;
  hasRequiredZh_CN$1 = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(zh_CN$3, "__esModule", {
    value: !0
  }), zh_CN$3.default = void 0;
  var s = a(/* @__PURE__ */ requireZh_CN$2());
  return zh_CN$3.default = s.default, zh_CN$3;
}
var hasRequiredZh_CN;
function requireZh_CN() {
  if (hasRequiredZh_CN) return zh_CN$5;
  hasRequiredZh_CN = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(zh_CN$5, "__esModule", {
    value: !0
  }), zh_CN$5.default = void 0;
  var s = a(requireZh_CN$5()), c = a(/* @__PURE__ */ requireZh_CN$1()), u = a(/* @__PURE__ */ requireZh_CN$2()), d = a(/* @__PURE__ */ requireZh_CN$3());
  const p = "${label}不是一个有效的${type}", v = {
    locale: "zh-cn",
    Pagination: s.default,
    DatePicker: u.default,
    TimePicker: d.default,
    Calendar: c.default,
    // locales for all components
    global: {
      placeholder: "请选择",
      close: "关闭"
    },
    Table: {
      filterTitle: "筛选",
      filterConfirm: "确定",
      filterReset: "重置",
      filterEmptyText: "无筛选项",
      filterCheckAll: "全选",
      filterSearchPlaceholder: "在筛选项中搜索",
      emptyText: "暂无数据",
      selectAll: "全选当页",
      selectInvert: "反选当页",
      selectNone: "清空所有",
      selectionAll: "全选所有",
      sortTitle: "排序",
      expand: "展开行",
      collapse: "关闭行",
      triggerDesc: "点击降序",
      triggerAsc: "点击升序",
      cancelSort: "取消排序"
    },
    Modal: {
      okText: "确定",
      cancelText: "取消",
      justOkText: "知道了"
    },
    Tour: {
      Next: "下一步",
      Previous: "上一步",
      Finish: "结束导览"
    },
    Popconfirm: {
      cancelText: "取消",
      okText: "确定"
    },
    Transfer: {
      titles: ["", ""],
      searchPlaceholder: "请输入搜索内容",
      itemUnit: "项",
      itemsUnit: "项",
      remove: "删除",
      selectCurrent: "全选当页",
      removeCurrent: "删除当页",
      selectAll: "全选所有",
      deselectAll: "取消全选",
      removeAll: "删除全部",
      selectInvert: "反选当页"
    },
    Upload: {
      uploading: "文件上传中",
      removeFile: "删除文件",
      uploadError: "上传错误",
      previewFile: "预览文件",
      downloadFile: "下载文件"
    },
    Empty: {
      description: "暂无数据"
    },
    Icon: {
      icon: "图标"
    },
    Text: {
      edit: "编辑",
      copy: "复制",
      copied: "复制成功",
      expand: "展开",
      collapse: "收起"
    },
    Form: {
      optional: "（可选）",
      defaultValidateMessages: {
        default: "字段验证错误${label}",
        required: "请输入${label}",
        enum: "${label}必须是其中一个[${enum}]",
        whitespace: "${label}不能为空字符",
        date: {
          format: "${label}日期格式无效",
          parse: "${label}不能转换为日期",
          invalid: "${label}是一个无效日期"
        },
        types: {
          string: p,
          method: p,
          array: p,
          object: p,
          number: p,
          date: p,
          boolean: p,
          integer: p,
          float: p,
          regexp: p,
          email: p,
          url: p,
          hex: p
        },
        string: {
          len: "${label}须为${len}个字符",
          min: "${label}最少${min}个字符",
          max: "${label}最多${max}个字符",
          range: "${label}须在${min}-${max}字符之间"
        },
        number: {
          len: "${label}必须等于${len}",
          min: "${label}最小值为${min}",
          max: "${label}最大值为${max}",
          range: "${label}须在${min}-${max}之间"
        },
        array: {
          len: "须为${len}个${label}",
          min: "最少${min}个${label}",
          max: "最多${max}个${label}",
          range: "${label}数量须在${min}-${max}之间"
        },
        pattern: {
          mismatch: "${label}与模式不匹配${pattern}"
        }
      }
    },
    Image: {
      preview: "预览"
    },
    QRCode: {
      expired: "二维码过期",
      refresh: "点击刷新",
      scanned: "已扫描"
    },
    ColorPicker: {
      presetEmpty: "暂无",
      transparent: "无色",
      singleColor: "单色",
      gradientColor: "渐变色"
    }
  };
  return zh_CN$5.default = v, zh_CN$5;
}
var zh_CNExports = /* @__PURE__ */ requireZh_CN();
const zhCN$1 = /* @__PURE__ */ getDefaultExportFromCjs(zh_CNExports);
var en_US$5 = {}, en_US$4 = {}, hasRequiredEn_US$5;
function requireEn_US$5() {
  if (hasRequiredEn_US$5) return en_US$4;
  hasRequiredEn_US$5 = 1, Object.defineProperty(en_US$4, "__esModule", {
    value: !0
  }), en_US$4.default = void 0;
  var a = {
    // Options
    items_per_page: "/ page",
    jump_to: "Go to",
    jump_to_confirm: "confirm",
    page: "Page",
    // Pagination
    prev_page: "Previous Page",
    next_page: "Next Page",
    prev_5: "Previous 5 Pages",
    next_5: "Next 5 Pages",
    prev_3: "Previous 3 Pages",
    next_3: "Next 3 Pages",
    page_size: "Page Size"
  };
  return en_US$4.default = a, en_US$4;
}
var en_US$3 = {}, en_US$2 = {}, en_US$1 = {}, hasRequiredEn_US$4;
function requireEn_US$4() {
  if (hasRequiredEn_US$4) return en_US$1;
  hasRequiredEn_US$4 = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(en_US$1, "__esModule", {
    value: !0
  }), en_US$1.default = void 0;
  var s = a(requireObjectSpread2()), c = requireCommon(), u = (0, s.default)((0, s.default)({}, c.commonLocale), {}, {
    locale: "en_US",
    today: "Today",
    now: "Now",
    backToToday: "Back to today",
    ok: "OK",
    clear: "Clear",
    week: "Week",
    month: "Month",
    year: "Year",
    timeSelect: "select time",
    dateSelect: "select date",
    weekSelect: "Choose a week",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    dateFormat: "M/D/YYYY",
    dateTimeFormat: "M/D/YYYY HH:mm:ss",
    previousMonth: "Previous month (PageUp)",
    nextMonth: "Next month (PageDown)",
    previousYear: "Last year (Control + left)",
    nextYear: "Next year (Control + right)",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century"
  });
  return en_US$1.default = u, en_US$1;
}
var en_US = {}, hasRequiredEn_US$3;
function requireEn_US$3() {
  if (hasRequiredEn_US$3) return en_US;
  hasRequiredEn_US$3 = 1, Object.defineProperty(en_US, "__esModule", {
    value: !0
  }), en_US.default = void 0;
  const a = {
    placeholder: "Select time",
    rangePlaceholder: ["Start time", "End time"]
  };
  return en_US.default = a, en_US;
}
var hasRequiredEn_US$2;
function requireEn_US$2() {
  if (hasRequiredEn_US$2) return en_US$2;
  hasRequiredEn_US$2 = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(en_US$2, "__esModule", {
    value: !0
  }), en_US$2.default = void 0;
  var s = a(requireEn_US$4()), c = a(/* @__PURE__ */ requireEn_US$3());
  const u = {
    lang: Object.assign({
      placeholder: "Select date",
      yearPlaceholder: "Select year",
      quarterPlaceholder: "Select quarter",
      monthPlaceholder: "Select month",
      weekPlaceholder: "Select week",
      rangePlaceholder: ["Start date", "End date"],
      rangeYearPlaceholder: ["Start year", "End year"],
      rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
      rangeMonthPlaceholder: ["Start month", "End month"],
      rangeWeekPlaceholder: ["Start week", "End week"]
    }, s.default),
    timePickerLocale: Object.assign({}, c.default)
  };
  return en_US$2.default = u, en_US$2;
}
var hasRequiredEn_US$1;
function requireEn_US$1() {
  if (hasRequiredEn_US$1) return en_US$3;
  hasRequiredEn_US$1 = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(en_US$3, "__esModule", {
    value: !0
  }), en_US$3.default = void 0;
  var s = a(/* @__PURE__ */ requireEn_US$2());
  return en_US$3.default = s.default, en_US$3;
}
var hasRequiredEn_US;
function requireEn_US() {
  if (hasRequiredEn_US) return en_US$5;
  hasRequiredEn_US = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(en_US$5, "__esModule", {
    value: !0
  }), en_US$5.default = void 0;
  var s = a(requireEn_US$5()), c = a(/* @__PURE__ */ requireEn_US$1()), u = a(/* @__PURE__ */ requireEn_US$2()), d = a(/* @__PURE__ */ requireEn_US$3());
  const p = "${label} is not a valid ${type}", v = {
    locale: "en",
    Pagination: s.default,
    DatePicker: u.default,
    TimePicker: d.default,
    Calendar: c.default,
    global: {
      placeholder: "Please select",
      close: "Close"
    },
    Table: {
      filterTitle: "Filter menu",
      filterConfirm: "OK",
      filterReset: "Reset",
      filterEmptyText: "No filters",
      filterCheckAll: "Select all items",
      filterSearchPlaceholder: "Search in filters",
      emptyText: "No data",
      selectAll: "Select current page",
      selectInvert: "Invert current page",
      selectNone: "Clear all data",
      selectionAll: "Select all data",
      sortTitle: "Sort",
      expand: "Expand row",
      collapse: "Collapse row",
      triggerDesc: "Click to sort descending",
      triggerAsc: "Click to sort ascending",
      cancelSort: "Click to cancel sorting"
    },
    Tour: {
      Next: "Next",
      Previous: "Previous",
      Finish: "Finish"
    },
    Modal: {
      okText: "OK",
      cancelText: "Cancel",
      justOkText: "OK"
    },
    Popconfirm: {
      okText: "OK",
      cancelText: "Cancel"
    },
    Transfer: {
      titles: ["", ""],
      searchPlaceholder: "Search here",
      itemUnit: "item",
      itemsUnit: "items",
      remove: "Remove",
      selectCurrent: "Select current page",
      removeCurrent: "Remove current page",
      selectAll: "Select all data",
      deselectAll: "Deselect all data",
      removeAll: "Remove all data",
      selectInvert: "Invert current page"
    },
    Upload: {
      uploading: "Uploading...",
      removeFile: "Remove file",
      uploadError: "Upload error",
      previewFile: "Preview file",
      downloadFile: "Download file"
    },
    Empty: {
      description: "No data"
    },
    Icon: {
      icon: "icon"
    },
    Text: {
      edit: "Edit",
      copy: "Copy",
      copied: "Copied",
      expand: "Expand",
      collapse: "Collapse"
    },
    Form: {
      optional: "(optional)",
      defaultValidateMessages: {
        default: "Field validation error for ${label}",
        required: "Please enter ${label}",
        enum: "${label} must be one of [${enum}]",
        whitespace: "${label} cannot be a blank character",
        date: {
          format: "${label} date format is invalid",
          parse: "${label} cannot be converted to a date",
          invalid: "${label} is an invalid date"
        },
        types: {
          string: p,
          method: p,
          array: p,
          object: p,
          number: p,
          date: p,
          boolean: p,
          integer: p,
          float: p,
          regexp: p,
          email: p,
          url: p,
          hex: p
        },
        string: {
          len: "${label} must be ${len} characters",
          min: "${label} must be at least ${min} characters",
          max: "${label} must be up to ${max} characters",
          range: "${label} must be between ${min}-${max} characters"
        },
        number: {
          len: "${label} must be equal to ${len}",
          min: "${label} must be minimum ${min}",
          max: "${label} must be maximum ${max}",
          range: "${label} must be between ${min}-${max}"
        },
        array: {
          len: "Must be ${len} ${label}",
          min: "At least ${min} ${label}",
          max: "At most ${max} ${label}",
          range: "The amount of ${label} must be between ${min}-${max}"
        },
        pattern: {
          mismatch: "${label} does not match the pattern ${pattern}"
        }
      }
    },
    Image: {
      preview: "Preview"
    },
    QRCode: {
      expired: "QR code expired",
      refresh: "Refresh",
      scanned: "Scanned"
    },
    ColorPicker: {
      presetEmpty: "Empty",
      transparent: "Transparent",
      singleColor: "Single",
      gradientColor: "Gradient"
    }
  };
  return en_US$5.default = v, en_US$5;
}
var en_USExports = /* @__PURE__ */ requireEn_US();
const enUS$1 = /* @__PURE__ */ getDefaultExportFromCjs(en_USExports), enUS = {
  copy_max_tip: "The maximum number of table items has been reached and cannot be copied",
  copy: "Copy",
  add_item: "Add a new line",
  confirm_delete: "Are you sure to delete?",
  confirm: "Yes",
  cancel: "No",
  operate: "Operate",
  delete: "Delete",
  edit: "Edit",
  img_src_error: "Image address error",
  upload: "Upload",
  upload_success: "upload success",
  upload_fail: "upload failed",
  uploaded_address: "Uploaded address",
  test_src: "Test address",
  schema_not_match: "Schema does not match the display component：",
  item: "Item",
  search: "Search",
  reset: "Reset",
  expand: "Expand",
  fold: "Fold",
  submit: "Submit",
  save: "Save",
  moveDown: "Move Down",
  moveUp: "Move Up"
}, zhCN = {
  copy_max_tip: "已达表单项数量上限，无法复制！",
  copy: "复制",
  add_item: "新增一条",
  confirm_delete: "确定删除?",
  confirm: "确定",
  cancel: "取消",
  operate: "操作",
  delete: "删除",
  edit: "编辑",
  img_src_error: "图片地址错误",
  upload: "上传",
  upload_success: "上传成功",
  upload_fail: "上传失败",
  uploaded_address: "已上传地址",
  test_src: "测试链接",
  schema_not_match: "schema未匹配到展示组件：",
  item: "项目",
  search: "查询",
  reset: "重置",
  expand: "展开",
  fold: "收起",
  submit: "提交",
  save: "保存",
  moveDown: "下移",
  moveUp: "上移"
}, locales = {
  "en-US": enUS,
  "zh-CN": zhCN
};
var zhCn$1 = { exports: {} }, zhCn = zhCn$1.exports, hasRequiredZhCn;
function requireZhCn() {
  return hasRequiredZhCn || (hasRequiredZhCn = 1, function(a, s) {
    (function(c, u) {
      a.exports = u(requireDayjs_min());
    })(zhCn, function(c) {
      function u(v) {
        return v && typeof v == "object" && "default" in v ? v : { default: v };
      }
      var d = u(c), p = { name: "zh-cn", weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"), weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"), weekdaysMin: "日_一_二_三_四_五_六".split("_"), months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(v, A) {
        return A === "W" ? v + "周" : v + "日";
      }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日Ah点mm分", LLLL: "YYYY年M月D日ddddAh点mm分", l: "YYYY/M/D", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日dddd HH:mm" }, relativeTime: { future: "%s内", past: "%s前", s: "几秒", m: "1 分钟", mm: "%d 分钟", h: "1 小时", hh: "%d 小时", d: "1 天", dd: "%d 天", M: "1 个月", MM: "%d 个月", y: "1 年", yy: "%d 年" }, meridiem: function(v, A) {
        var x = 100 * v + A;
        return x < 600 ? "凌晨" : x < 900 ? "早上" : x < 1100 ? "上午" : x < 1300 ? "中午" : x < 1800 ? "下午" : "晚上";
      } };
      return d.default.locale(p, null, !0), p;
    });
  }(zhCn$1)), zhCn$1.exports;
}
requireZhCn();
var createStore = function a() {
  return createStore$1(function(s, c) {
    return {
      initialized: !1,
      schema: {},
      flattenSchema: {},
      context: {},
      init: function(d) {
        return s(Object.assign({
          initialized: !0
        }, d));
      },
      setContext: function(d) {
        return s({
          context: d
        });
      }
    };
  });
}, typeTemplate = "'${label}' is not a valid ${type}", typeTemplateCN = "数据类型必须是 ${type}", validateMessagesEN = {
  default: "Validation error on field '${label}'",
  required: "'${label}' is required",
  enum: "'${label}' must be one of [${enum}]",
  whitespace: "'${label}' cannot be empty",
  date: {
    format: "'${label}' is invalid for format date",
    parse: "'${label}' could not be parsed as date",
    invalid: "'${label}' is invalid date"
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate
  },
  string: {
    len: "'${label}' must be exactly ${len} characters",
    min: "'${label}' must be at least ${min} characters",
    max: "'${label}' cannot be longer than ${max} characters",
    range: "'${label}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${label}' must equal ${len}",
    min: "'${label}' cannot be less than ${min}",
    max: "'${label}' cannot be greater than ${max}",
    range: "'${label}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${label}' must be exactly ${len} in length",
    min: "'${label}' cannot be less than ${min} in length",
    max: "'${label}' cannot be greater than ${max} in length",
    range: "'${label}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${label}' does not match pattern ${pattern}"
  }
}, validateMessagesCN = {
  default: "${label}未通过校验",
  required: "${label}必填",
  whitespace: "${label}不能为空",
  date: {
    format: "${label}的格式错误",
    parse: "${label}无法被解析",
    invalid: "${label}数据不合法"
  },
  types: {
    string: typeTemplateCN,
    method: typeTemplateCN,
    array: typeTemplateCN,
    object: typeTemplateCN,
    number: typeTemplateCN,
    date: typeTemplateCN,
    boolean: typeTemplateCN,
    integer: typeTemplateCN,
    float: typeTemplateCN,
    regexp: typeTemplateCN,
    email: typeTemplateCN,
    url: typeTemplateCN,
    hex: typeTemplateCN
  },
  string: {
    len: "${label}长度不是${len}",
    min: "${label}长度不能小于${min}",
    max: "${label}长度不能大于${max}",
    range: "${label}长度需在${min}与${max}之间"
  },
  number: {
    len: "${label}不等于${len}",
    min: "${label}不能小于${min}",
    max: "${label}不能大于${max}",
    range: "${label}需在${min}与${max}之间"
  },
  array: {
    len: "${label}长度不是${len}",
    min: "${label}长度不能小于${min}",
    max: "${label}长度不能大于${max}",
    range: "${label}长度需在${min}与${max}之间"
  },
  pattern: {
    mismatch: "${label}未通过正则判断${pattern}"
  }
};
function withProvider(a, s) {
  return function(c) {
    var u = c.configProvider, d = c.locale, p = d === void 0 ? "zh-CN" : d, v = c.widgets, A = c.methods, x = c.form, g = c.validateMessages, b = c.globalProps, y = b === void 0 ? {} : b, f = c.globalConfig, m = f === void 0 ? {} : f, C = __rest$15(c, ["configProvider", "locale", "widgets", "methods", "form", "validateMessages", "globalProps", "globalConfig"]), w = reactExports.useRef(createStore()), S = w.current;
    if (reactExports.useEffect(function() {
      if (p === "en-US") {
        dayjs.locale("en");
        return;
      }
      dayjs.locale("zh-cn");
    }, [p]), useUnmount(function() {
      x.resetFields();
    }), !x)
      return console.warn("Please provide a form instance to FormRender"), null;
    var $ = p === "zh-CN" ? zhCN$1 : enUS$1, T = p === "zh-CN" ? validateMessagesCN : validateMessagesEN, I = {
      locale: p,
      widgets: Object.assign(Object.assign({}, s), v),
      methods: A,
      form: x,
      globalProps: y,
      globalConfig: m
    }, _ = Object.assign(Object.assign(Object.assign({}, $), {
      FormRender: locales[p]
    }), u?.locale);
    return /* @__PURE__ */ React.createElement(ConfigProvider, Object.assign({}, u, {
      locale: _,
      form: {
        validateMessages: Object.assign(Object.assign({}, T), g)
      }
    }), /* @__PURE__ */ React.createElement(ConfigContext.Provider, {
      value: I
    }, /* @__PURE__ */ React.createElement(FRContext.Provider, {
      value: S
    }, /* @__PURE__ */ React.createElement(a, Object.assign({
      form: x
    }, C)))));
  };
}
var getProps$1 = function a(s, c) {
  var u = {};
  return Object.keys(s).forEach(function(d) {
    c.includes(d) || (u[d] = s[d]);
  }), u;
};
const withFieldWrap = function(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ["addons", "schema", "dependValues"];
  return function(c) {
    return /* @__PURE__ */ React.createElement(a, Object.assign({}, getProps$1(c, s)));
  };
}, Input = withFieldWrap(Input$1), InputNumber = withFieldWrap(TypedInputNumber);
var TextArea = function a(s) {
  var c = Object.assign({
    autoSize: {
      minRows: 3
    }
  }, s);
  return c.rows && delete c.autoSize, /* @__PURE__ */ React.createElement(Input$1.TextArea, Object.assign({}, c));
};
const TextArea$1 = withFieldWrap(TextArea), MultiSelect = withFieldWrap(Select), Switch = withFieldWrap(Switch$1);
var RadioComp = function a(s) {
  var c = s.direction, u = c === void 0 ? "row" : c, d = s.options, p = d === void 0 ? [] : d, v = __rest$15(s, ["direction", "options"]);
  return u === "column" ? /* @__PURE__ */ React.createElement(Radio$1.Group, Object.assign({}, v), /* @__PURE__ */ React.createElement(Space, {
    direction: "vertical"
  }, p.map(function(A) {
    var x = A.value, g = A.label, b = __rest$15(A, ["value", "label"]);
    return /* @__PURE__ */ React.createElement(Radio$1, Object.assign({
      key: x,
      value: x
    }, b), g);
  }))) : /* @__PURE__ */ React.createElement(Radio$1.Group, Object.assign({}, v, {
    options: p
  }));
};
const Radio = withFieldWrap(RadioComp), index$1 = withFieldWrap(Rate), TreeSelect = withFieldWrap(TreeSelect$1);
var CheckBox = function a(s) {
  var c = s.title, u = __rest$15(s, ["title"]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Checkbox$1, Object.assign({}, u)), /* @__PURE__ */ React.createElement("span", {
    style: {
      marginLeft: "12px"
    }
  }, c));
};
const Checkbox = withFieldWrap(CheckBox);
var Checkboxes = function a(s) {
  var c = s.direction, u = c === void 0 ? "row" : c, d = s.options, p = d === void 0 ? [] : d, v = __rest$15(s, ["direction", "options"]);
  return u === "column" ? /* @__PURE__ */ React.createElement(Checkbox$1.Group, Object.assign({}, v), /* @__PURE__ */ React.createElement(Space, {
    direction: "vertical"
  }, p.map(function(A) {
    var x = A.value, g = A.label, b = __rest$15(A, ["value", "label"]);
    return /* @__PURE__ */ React.createElement(Checkbox$1, Object.assign({
      key: x,
      value: x
    }, b), g);
  }))) : /* @__PURE__ */ React.createElement(Checkbox$1.Group, Object.assign({}, v, {
    options: p
  }));
};
const Checkboxes$1 = withFieldWrap(Checkboxes);
var lib$1 = { exports: {} }, ColorPicker$1 = { exports: {} }, propTypes = { exports: {} }, ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = a, ReactPropTypesSecret_1;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var a = /* @__PURE__ */ requireReactPropTypesSecret();
  function s() {
  }
  function c() {
  }
  return c.resetWarningCache = s, factoryWithThrowingShims = function() {
    function u(v, A, x, g, b, y) {
      if (y !== a) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    u.isRequired = u;
    function d() {
      return u;
    }
    var p = {
      array: u,
      bigint: u,
      bool: u,
      func: u,
      number: u,
      object: u,
      string: u,
      symbol: u,
      any: u,
      arrayOf: d,
      element: u,
      elementType: u,
      instanceOf: d,
      node: u,
      objectOf: d,
      oneOf: d,
      oneOfType: d,
      shape: d,
      exact: d,
      checkPropTypes: c,
      resetWarningCache: s
    };
    return p.PropTypes = p, p;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  return hasRequiredPropTypes || (hasRequiredPropTypes = 1, propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()()), propTypes.exports;
}
var _extends$2 = {}, es6_object_assign = {}, _global = { exports: {} }, hasRequired_global;
function require_global() {
  if (hasRequired_global) return _global.exports;
  hasRequired_global = 1;
  var a = _global.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  return typeof __g == "number" && (__g = a), _global.exports;
}
var _core = { exports: {} }, hasRequired_core;
function require_core() {
  if (hasRequired_core) return _core.exports;
  hasRequired_core = 1;
  var a = _core.exports = { version: "2.6.12" };
  return typeof __e == "number" && (__e = a), _core.exports;
}
var _aFunction, hasRequired_aFunction;
function require_aFunction() {
  return hasRequired_aFunction || (hasRequired_aFunction = 1, _aFunction = function(a) {
    if (typeof a != "function") throw TypeError(a + " is not a function!");
    return a;
  }), _aFunction;
}
var _ctx, hasRequired_ctx;
function require_ctx() {
  if (hasRequired_ctx) return _ctx;
  hasRequired_ctx = 1;
  var a = require_aFunction();
  return _ctx = function(s, c, u) {
    if (a(s), c === void 0) return s;
    switch (u) {
      case 1:
        return function(d) {
          return s.call(c, d);
        };
      case 2:
        return function(d, p) {
          return s.call(c, d, p);
        };
      case 3:
        return function(d, p, v) {
          return s.call(c, d, p, v);
        };
    }
    return function() {
      return s.apply(c, arguments);
    };
  }, _ctx;
}
var _objectDp = {}, _isObject, hasRequired_isObject;
function require_isObject() {
  return hasRequired_isObject || (hasRequired_isObject = 1, _isObject = function(a) {
    return typeof a == "object" ? a !== null : typeof a == "function";
  }), _isObject;
}
var _anObject, hasRequired_anObject;
function require_anObject() {
  if (hasRequired_anObject) return _anObject;
  hasRequired_anObject = 1;
  var a = require_isObject();
  return _anObject = function(s) {
    if (!a(s)) throw TypeError(s + " is not an object!");
    return s;
  }, _anObject;
}
var _fails, hasRequired_fails;
function require_fails() {
  return hasRequired_fails || (hasRequired_fails = 1, _fails = function(a) {
    try {
      return !!a();
    } catch {
      return !0;
    }
  }), _fails;
}
var _descriptors, hasRequired_descriptors;
function require_descriptors() {
  return hasRequired_descriptors || (hasRequired_descriptors = 1, _descriptors = !require_fails()(function() {
    return Object.defineProperty({}, "a", { get: function() {
      return 7;
    } }).a != 7;
  })), _descriptors;
}
var _domCreate, hasRequired_domCreate;
function require_domCreate() {
  if (hasRequired_domCreate) return _domCreate;
  hasRequired_domCreate = 1;
  var a = require_isObject(), s = require_global().document, c = a(s) && a(s.createElement);
  return _domCreate = function(u) {
    return c ? s.createElement(u) : {};
  }, _domCreate;
}
var _ie8DomDefine, hasRequired_ie8DomDefine;
function require_ie8DomDefine() {
  return hasRequired_ie8DomDefine || (hasRequired_ie8DomDefine = 1, _ie8DomDefine = !require_descriptors() && !require_fails()(function() {
    return Object.defineProperty(require_domCreate()("div"), "a", { get: function() {
      return 7;
    } }).a != 7;
  })), _ie8DomDefine;
}
var _toPrimitive$5, hasRequired_toPrimitive;
function require_toPrimitive() {
  if (hasRequired_toPrimitive) return _toPrimitive$5;
  hasRequired_toPrimitive = 1;
  var a = require_isObject();
  return _toPrimitive$5 = function(s, c) {
    if (!a(s)) return s;
    var u, d;
    if (c && typeof (u = s.toString) == "function" && !a(d = u.call(s)) || typeof (u = s.valueOf) == "function" && !a(d = u.call(s)) || !c && typeof (u = s.toString) == "function" && !a(d = u.call(s))) return d;
    throw TypeError("Can't convert object to primitive value");
  }, _toPrimitive$5;
}
var hasRequired_objectDp;
function require_objectDp() {
  if (hasRequired_objectDp) return _objectDp;
  hasRequired_objectDp = 1;
  var a = require_anObject(), s = require_ie8DomDefine(), c = require_toPrimitive(), u = Object.defineProperty;
  return _objectDp.f = require_descriptors() ? Object.defineProperty : function(p, v, A) {
    if (a(p), v = c(v, !0), a(A), s) try {
      return u(p, v, A);
    } catch {
    }
    if ("get" in A || "set" in A) throw TypeError("Accessors not supported!");
    return "value" in A && (p[v] = A.value), p;
  }, _objectDp;
}
var _propertyDesc, hasRequired_propertyDesc;
function require_propertyDesc() {
  return hasRequired_propertyDesc || (hasRequired_propertyDesc = 1, _propertyDesc = function(a, s) {
    return {
      enumerable: !(a & 1),
      configurable: !(a & 2),
      writable: !(a & 4),
      value: s
    };
  }), _propertyDesc;
}
var _hide, hasRequired_hide;
function require_hide() {
  if (hasRequired_hide) return _hide;
  hasRequired_hide = 1;
  var a = require_objectDp(), s = require_propertyDesc();
  return _hide = require_descriptors() ? function(c, u, d) {
    return a.f(c, u, s(1, d));
  } : function(c, u, d) {
    return c[u] = d, c;
  }, _hide;
}
var _has, hasRequired_has;
function require_has() {
  if (hasRequired_has) return _has;
  hasRequired_has = 1;
  var a = {}.hasOwnProperty;
  return _has = function(s, c) {
    return a.call(s, c);
  }, _has;
}
var _export, hasRequired_export;
function require_export() {
  if (hasRequired_export) return _export;
  hasRequired_export = 1;
  var a = require_global(), s = require_core(), c = require_ctx(), u = require_hide(), d = require_has(), p = "prototype", v = function(A, x, g) {
    var b = A & v.F, y = A & v.G, f = A & v.S, m = A & v.P, C = A & v.B, w = A & v.W, S = y ? s : s[x] || (s[x] = {}), $ = S[p], T = y ? a : f ? a[x] : (a[x] || {})[p], I, _, E;
    y && (g = x);
    for (I in g)
      _ = !b && T && T[I] !== void 0, !(_ && d(S, I)) && (E = _ ? T[I] : g[I], S[I] = y && typeof T[I] != "function" ? g[I] : C && _ ? c(E, a) : w && T[I] == E ? function(R) {
        var O = function(L, B, F) {
          if (this instanceof R) {
            switch (arguments.length) {
              case 0:
                return new R();
              case 1:
                return new R(L);
              case 2:
                return new R(L, B);
            }
            return new R(L, B, F);
          }
          return R.apply(this, arguments);
        };
        return O[p] = R[p], O;
      }(E) : m && typeof E == "function" ? c(Function.call, E) : E, m && ((S.virtual || (S.virtual = {}))[I] = E, A & v.R && $ && !$[I] && u($, I, E)));
  };
  return v.F = 1, v.G = 2, v.S = 4, v.P = 8, v.B = 16, v.W = 32, v.U = 64, v.R = 128, _export = v, _export;
}
var _cof, hasRequired_cof;
function require_cof() {
  if (hasRequired_cof) return _cof;
  hasRequired_cof = 1;
  var a = {}.toString;
  return _cof = function(s) {
    return a.call(s).slice(8, -1);
  }, _cof;
}
var _iobject, hasRequired_iobject;
function require_iobject() {
  if (hasRequired_iobject) return _iobject;
  hasRequired_iobject = 1;
  var a = require_cof();
  return _iobject = Object("z").propertyIsEnumerable(0) ? Object : function(s) {
    return a(s) == "String" ? s.split("") : Object(s);
  }, _iobject;
}
var _defined, hasRequired_defined;
function require_defined() {
  return hasRequired_defined || (hasRequired_defined = 1, _defined = function(a) {
    if (a == null) throw TypeError("Can't call method on  " + a);
    return a;
  }), _defined;
}
var _toIobject, hasRequired_toIobject;
function require_toIobject() {
  if (hasRequired_toIobject) return _toIobject;
  hasRequired_toIobject = 1;
  var a = require_iobject(), s = require_defined();
  return _toIobject = function(c) {
    return a(s(c));
  }, _toIobject;
}
var _toInteger, hasRequired_toInteger;
function require_toInteger() {
  if (hasRequired_toInteger) return _toInteger;
  hasRequired_toInteger = 1;
  var a = Math.ceil, s = Math.floor;
  return _toInteger = function(c) {
    return isNaN(c = +c) ? 0 : (c > 0 ? s : a)(c);
  }, _toInteger;
}
var _toLength, hasRequired_toLength;
function require_toLength() {
  if (hasRequired_toLength) return _toLength;
  hasRequired_toLength = 1;
  var a = require_toInteger(), s = Math.min;
  return _toLength = function(c) {
    return c > 0 ? s(a(c), 9007199254740991) : 0;
  }, _toLength;
}
var _toAbsoluteIndex, hasRequired_toAbsoluteIndex;
function require_toAbsoluteIndex() {
  if (hasRequired_toAbsoluteIndex) return _toAbsoluteIndex;
  hasRequired_toAbsoluteIndex = 1;
  var a = require_toInteger(), s = Math.max, c = Math.min;
  return _toAbsoluteIndex = function(u, d) {
    return u = a(u), u < 0 ? s(u + d, 0) : c(u, d);
  }, _toAbsoluteIndex;
}
var _arrayIncludes, hasRequired_arrayIncludes;
function require_arrayIncludes() {
  if (hasRequired_arrayIncludes) return _arrayIncludes;
  hasRequired_arrayIncludes = 1;
  var a = require_toIobject(), s = require_toLength(), c = require_toAbsoluteIndex();
  return _arrayIncludes = function(u) {
    return function(d, p, v) {
      var A = a(d), x = s(A.length), g = c(v, x), b;
      if (u && p != p) {
        for (; x > g; )
          if (b = A[g++], b != b) return !0;
      } else for (; x > g; g++) if ((u || g in A) && A[g] === p)
        return u || g || 0;
      return !u && -1;
    };
  }, _arrayIncludes;
}
var _shared = { exports: {} }, _library, hasRequired_library;
function require_library() {
  return hasRequired_library || (hasRequired_library = 1, _library = !0), _library;
}
var hasRequired_shared;
function require_shared() {
  if (hasRequired_shared) return _shared.exports;
  hasRequired_shared = 1;
  var a = require_core(), s = require_global(), c = "__core-js_shared__", u = s[c] || (s[c] = {});
  return (_shared.exports = function(d, p) {
    return u[d] || (u[d] = p !== void 0 ? p : {});
  })("versions", []).push({
    version: a.version,
    mode: require_library() ? "pure" : "global",
    copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
  }), _shared.exports;
}
var _uid, hasRequired_uid;
function require_uid() {
  if (hasRequired_uid) return _uid;
  hasRequired_uid = 1;
  var a = 0, s = Math.random();
  return _uid = function(c) {
    return "Symbol(".concat(c === void 0 ? "" : c, ")_", (++a + s).toString(36));
  }, _uid;
}
var _sharedKey, hasRequired_sharedKey;
function require_sharedKey() {
  if (hasRequired_sharedKey) return _sharedKey;
  hasRequired_sharedKey = 1;
  var a = require_shared()("keys"), s = require_uid();
  return _sharedKey = function(c) {
    return a[c] || (a[c] = s(c));
  }, _sharedKey;
}
var _objectKeysInternal, hasRequired_objectKeysInternal;
function require_objectKeysInternal() {
  if (hasRequired_objectKeysInternal) return _objectKeysInternal;
  hasRequired_objectKeysInternal = 1;
  var a = require_has(), s = require_toIobject(), c = require_arrayIncludes()(!1), u = require_sharedKey()("IE_PROTO");
  return _objectKeysInternal = function(d, p) {
    var v = s(d), A = 0, x = [], g;
    for (g in v) g != u && a(v, g) && x.push(g);
    for (; p.length > A; ) a(v, g = p[A++]) && (~c(x, g) || x.push(g));
    return x;
  }, _objectKeysInternal;
}
var _enumBugKeys, hasRequired_enumBugKeys;
function require_enumBugKeys() {
  return hasRequired_enumBugKeys || (hasRequired_enumBugKeys = 1, _enumBugKeys = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")), _enumBugKeys;
}
var _objectKeys, hasRequired_objectKeys;
function require_objectKeys() {
  if (hasRequired_objectKeys) return _objectKeys;
  hasRequired_objectKeys = 1;
  var a = require_objectKeysInternal(), s = require_enumBugKeys();
  return _objectKeys = Object.keys || function(u) {
    return a(u, s);
  }, _objectKeys;
}
var _objectGops = {}, hasRequired_objectGops;
function require_objectGops() {
  return hasRequired_objectGops || (hasRequired_objectGops = 1, _objectGops.f = Object.getOwnPropertySymbols), _objectGops;
}
var _objectPie = {}, hasRequired_objectPie;
function require_objectPie() {
  return hasRequired_objectPie || (hasRequired_objectPie = 1, _objectPie.f = {}.propertyIsEnumerable), _objectPie;
}
var _toObject, hasRequired_toObject;
function require_toObject() {
  if (hasRequired_toObject) return _toObject;
  hasRequired_toObject = 1;
  var a = require_defined();
  return _toObject = function(s) {
    return Object(a(s));
  }, _toObject;
}
var _objectAssign, hasRequired_objectAssign;
function require_objectAssign() {
  if (hasRequired_objectAssign) return _objectAssign;
  hasRequired_objectAssign = 1;
  var a = require_descriptors(), s = require_objectKeys(), c = require_objectGops(), u = require_objectPie(), d = require_toObject(), p = require_iobject(), v = Object.assign;
  return _objectAssign = !v || require_fails()(function() {
    var A = {}, x = {}, g = Symbol(), b = "abcdefghijklmnopqrst";
    return A[g] = 7, b.split("").forEach(function(y) {
      x[y] = y;
    }), v({}, A)[g] != 7 || Object.keys(v({}, x)).join("") != b;
  }) ? function(x, g) {
    for (var b = d(x), y = arguments.length, f = 1, m = c.f, C = u.f; y > f; )
      for (var w = p(arguments[f++]), S = m ? s(w).concat(m(w)) : s(w), $ = S.length, T = 0, I; $ > T; )
        I = S[T++], (!a || C.call(w, I)) && (b[I] = w[I]);
    return b;
  } : v, _objectAssign;
}
var hasRequiredEs6_object_assign;
function requireEs6_object_assign() {
  if (hasRequiredEs6_object_assign) return es6_object_assign;
  hasRequiredEs6_object_assign = 1;
  var a = require_export();
  return a(a.S + a.F, "Object", { assign: require_objectAssign() }), es6_object_assign;
}
var assign$1, hasRequiredAssign$1;
function requireAssign$1() {
  return hasRequiredAssign$1 || (hasRequiredAssign$1 = 1, requireEs6_object_assign(), assign$1 = require_core().Object.assign), assign$1;
}
var assign, hasRequiredAssign;
function requireAssign() {
  return hasRequiredAssign || (hasRequiredAssign = 1, assign = { default: requireAssign$1(), __esModule: !0 }), assign;
}
var hasRequired_extends;
function require_extends() {
  if (hasRequired_extends) return _extends$2;
  hasRequired_extends = 1, _extends$2.__esModule = !0;
  var a = requireAssign(), s = c(a);
  function c(u) {
    return u && u.__esModule ? u : { default: u };
  }
  return _extends$2.default = s.default || function(u) {
    for (var d = 1; d < arguments.length; d++) {
      var p = arguments[d];
      for (var v in p)
        Object.prototype.hasOwnProperty.call(p, v) && (u[v] = p[v]);
    }
    return u;
  }, _extends$2;
}
var _extendsExports = require_extends();
const _extends$1 = /* @__PURE__ */ getDefaultExportFromCjs(_extendsExports);
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var factory_1, hasRequiredFactory;
function requireFactory() {
  if (hasRequiredFactory) return factory_1;
  hasRequiredFactory = 1;
  var a = requireObjectAssign(), s = {};
  function c(v, A, x, g, b, y, f, m) {
    if (!v) {
      var C;
      if (A === void 0)
        C = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var w = [x, g, b, y, f, m], S = 0;
        C = new Error(A.replace(/%s/g, function() {
          return w[S++];
        })), C.name = "Invariant Violation";
      }
      throw C.framesToPop = 1, C;
    }
  }
  var u = "mixins";
  function d(v) {
    return v;
  }
  function p(v, A, x) {
    var g = [], b = {
      /**
       * An array of Mixin objects to include when defining your component.
       *
       * @type {array}
       * @optional
       */
      mixins: "DEFINE_MANY",
      /**
       * An object containing properties and methods that should be defined on
       * the component's constructor instead of its prototype (static methods).
       *
       * @type {object}
       * @optional
       */
      statics: "DEFINE_MANY",
      /**
       * Definition of prop types for this component.
       *
       * @type {object}
       * @optional
       */
      propTypes: "DEFINE_MANY",
      /**
       * Definition of context types for this component.
       *
       * @type {object}
       * @optional
       */
      contextTypes: "DEFINE_MANY",
      /**
       * Definition of context types this component sets for its children.
       *
       * @type {object}
       * @optional
       */
      childContextTypes: "DEFINE_MANY",
      // ==== Definition methods ====
      /**
       * Invoked when the component is mounted. Values in the mapping will be set on
       * `this.props` if that prop is not specified (i.e. using an `in` check).
       *
       * This method is invoked before `getInitialState` and therefore cannot rely
       * on `this.state` or use `this.setState`.
       *
       * @return {object}
       * @optional
       */
      getDefaultProps: "DEFINE_MANY_MERGED",
      /**
       * Invoked once before the component is mounted. The return value will be used
       * as the initial value of `this.state`.
       *
       *   getInitialState: function() {
       *     return {
       *       isOn: false,
       *       fooBaz: new BazFoo()
       *     }
       *   }
       *
       * @return {object}
       * @optional
       */
      getInitialState: "DEFINE_MANY_MERGED",
      /**
       * @return {object}
       * @optional
       */
      getChildContext: "DEFINE_MANY_MERGED",
      /**
       * Uses props from `this.props` and state from `this.state` to render the
       * structure of the component.
       *
       * No guarantees are made about when or how often this method is invoked, so
       * it must not have side effects.
       *
       *   render: function() {
       *     var name = this.props.name;
       *     return <div>Hello, {name}!</div>;
       *   }
       *
       * @return {ReactComponent}
       * @required
       */
      render: "DEFINE_ONCE",
      // ==== Delegate methods ====
      /**
       * Invoked when the component is initially created and about to be mounted.
       * This may have side effects, but any external subscriptions or data created
       * by this method must be cleaned up in `componentWillUnmount`.
       *
       * @optional
       */
      componentWillMount: "DEFINE_MANY",
      /**
       * Invoked when the component has been mounted and has a DOM representation.
       * However, there is no guarantee that the DOM node is in the document.
       *
       * Use this as an opportunity to operate on the DOM when the component has
       * been mounted (initialized and rendered) for the first time.
       *
       * @param {DOMElement} rootNode DOM element representing the component.
       * @optional
       */
      componentDidMount: "DEFINE_MANY",
      /**
       * Invoked before the component receives new props.
       *
       * Use this as an opportunity to react to a prop transition by updating the
       * state using `this.setState`. Current props are accessed via `this.props`.
       *
       *   componentWillReceiveProps: function(nextProps, nextContext) {
       *     this.setState({
       *       likesIncreasing: nextProps.likeCount > this.props.likeCount
       *     });
       *   }
       *
       * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
       * transition may cause a state change, but the opposite is not true. If you
       * need it, you are probably looking for `componentWillUpdate`.
       *
       * @param {object} nextProps
       * @optional
       */
      componentWillReceiveProps: "DEFINE_MANY",
      /**
       * Invoked while deciding if the component should be updated as a result of
       * receiving new props, state and/or context.
       *
       * Use this as an opportunity to `return false` when you're certain that the
       * transition to the new props/state/context will not require a component
       * update.
       *
       *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
       *     return !equal(nextProps, this.props) ||
       *       !equal(nextState, this.state) ||
       *       !equal(nextContext, this.context);
       *   }
       *
       * @param {object} nextProps
       * @param {?object} nextState
       * @param {?object} nextContext
       * @return {boolean} True if the component should update.
       * @optional
       */
      shouldComponentUpdate: "DEFINE_ONCE",
      /**
       * Invoked when the component is about to update due to a transition from
       * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
       * and `nextContext`.
       *
       * Use this as an opportunity to perform preparation before an update occurs.
       *
       * NOTE: You **cannot** use `this.setState()` in this method.
       *
       * @param {object} nextProps
       * @param {?object} nextState
       * @param {?object} nextContext
       * @param {ReactReconcileTransaction} transaction
       * @optional
       */
      componentWillUpdate: "DEFINE_MANY",
      /**
       * Invoked when the component's DOM representation has been updated.
       *
       * Use this as an opportunity to operate on the DOM when the component has
       * been updated.
       *
       * @param {object} prevProps
       * @param {?object} prevState
       * @param {?object} prevContext
       * @param {DOMElement} rootNode DOM element representing the component.
       * @optional
       */
      componentDidUpdate: "DEFINE_MANY",
      /**
       * Invoked when the component is about to be removed from its parent and have
       * its DOM representation destroyed.
       *
       * Use this as an opportunity to deallocate any external resources.
       *
       * NOTE: There is no `componentDidUnmount` since your component will have been
       * destroyed by that point.
       *
       * @optional
       */
      componentWillUnmount: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillMount`.
       *
       * @optional
       */
      UNSAFE_componentWillMount: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillReceiveProps`.
       *
       * @optional
       */
      UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillUpdate`.
       *
       * @optional
       */
      UNSAFE_componentWillUpdate: "DEFINE_MANY",
      // ==== Advanced methods ====
      /**
       * Updates the component's currently mounted DOM representation.
       *
       * By default, this implements React's rendering and reconciliation algorithm.
       * Sophisticated clients may wish to override this.
       *
       * @param {ReactReconcileTransaction} transaction
       * @internal
       * @overridable
       */
      updateComponent: "OVERRIDE_BASE"
    }, y = {
      /**
       * This method is invoked after a component is instantiated and when it
       * receives new props. Return an object to update state in response to
       * prop changes. Return null to indicate no change to state.
       *
       * If an object is returned, its keys will be merged into the existing state.
       *
       * @return {object || null}
       * @optional
       */
      getDerivedStateFromProps: "DEFINE_MANY_MERGED"
    }, f = {
      displayName: function(F, M) {
        F.displayName = M;
      },
      mixins: function(F, M) {
        if (M)
          for (var W = 0; W < M.length; W++)
            C(F, M[W]);
      },
      childContextTypes: function(F, M) {
        F.childContextTypes = a(
          {},
          F.childContextTypes,
          M
        );
      },
      contextTypes: function(F, M) {
        F.contextTypes = a(
          {},
          F.contextTypes,
          M
        );
      },
      /**
       * Special case getDefaultProps which should move into statics but requires
       * automatic merging.
       */
      getDefaultProps: function(F, M) {
        F.getDefaultProps ? F.getDefaultProps = $(
          F.getDefaultProps,
          M
        ) : F.getDefaultProps = M;
      },
      propTypes: function(F, M) {
        F.propTypes = a({}, F.propTypes, M);
      },
      statics: function(F, M) {
        w(F, M);
      },
      autobind: function() {
      }
    };
    function m(F, M) {
      var W = b.hasOwnProperty(M) ? b[M] : null;
      O.hasOwnProperty(M) && c(
        W === "OVERRIDE_BASE",
        "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",
        M
      ), F && c(
        W === "DEFINE_MANY" || W === "DEFINE_MANY_MERGED",
        "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
        M
      );
    }
    function C(F, M) {
      if (M) {
        c(
          typeof M != "function",
          "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."
        ), c(
          !A(M),
          "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object."
        );
        var W = F.prototype, j = W.__reactAutoBindPairs;
        M.hasOwnProperty(u) && f.mixins(F, M.mixins);
        for (var G in M)
          if (M.hasOwnProperty(G) && G !== u) {
            var U = M[G], k = W.hasOwnProperty(G);
            if (m(k, G), f.hasOwnProperty(G))
              f[G](F, U);
            else {
              var N = b.hasOwnProperty(G), P = typeof U == "function", D = P && !N && !k && M.autobind !== !1;
              if (D)
                j.push(G, U), W[G] = U;
              else if (k) {
                var H = b[G];
                c(
                  N && (H === "DEFINE_MANY_MERGED" || H === "DEFINE_MANY"),
                  "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",
                  H,
                  G
                ), H === "DEFINE_MANY_MERGED" ? W[G] = $(W[G], U) : H === "DEFINE_MANY" && (W[G] = T(W[G], U));
              } else
                W[G] = U;
            }
          }
      }
    }
    function w(F, M) {
      if (M)
        for (var W in M) {
          var j = M[W];
          if (M.hasOwnProperty(W)) {
            var G = W in f;
            c(
              !G,
              'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',
              W
            );
            var U = W in F;
            if (U) {
              var k = y.hasOwnProperty(W) ? y[W] : null;
              c(
                k === "DEFINE_MANY_MERGED",
                "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
                W
              ), F[W] = $(F[W], j);
              return;
            }
            F[W] = j;
          }
        }
    }
    function S(F, M) {
      c(
        F && M && typeof F == "object" && typeof M == "object",
        "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects."
      );
      for (var W in M)
        M.hasOwnProperty(W) && (c(
          F[W] === void 0,
          "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",
          W
        ), F[W] = M[W]);
      return F;
    }
    function $(F, M) {
      return function() {
        var j = F.apply(this, arguments), G = M.apply(this, arguments);
        if (j == null)
          return G;
        if (G == null)
          return j;
        var U = {};
        return S(U, j), S(U, G), U;
      };
    }
    function T(F, M) {
      return function() {
        F.apply(this, arguments), M.apply(this, arguments);
      };
    }
    function I(F, M) {
      var W = M.bind(F);
      return W;
    }
    function _(F) {
      for (var M = F.__reactAutoBindPairs, W = 0; W < M.length; W += 2) {
        var j = M[W], G = M[W + 1];
        F[j] = I(F, G);
      }
    }
    var E = {
      componentDidMount: function() {
        this.__isMounted = !0;
      }
    }, R = {
      componentWillUnmount: function() {
        this.__isMounted = !1;
      }
    }, O = {
      /**
       * TODO: This will be deprecated because state should always keep a consistent
       * type signature and the only use case for this, is to avoid that.
       */
      replaceState: function(F, M) {
        this.updater.enqueueReplaceState(this, F, M);
      },
      /**
       * Checks whether or not this composite component is mounted.
       * @return {boolean} True if mounted, false otherwise.
       * @protected
       * @final
       */
      isMounted: function() {
        return !!this.__isMounted;
      }
    }, L = function() {
    };
    a(
      L.prototype,
      v.prototype,
      O
    );
    function B(F) {
      var M = function(j, G, U) {
        this.__reactAutoBindPairs.length && _(this), this.props = j, this.context = G, this.refs = s, this.updater = U || x, this.state = null;
        var k = this.getInitialState ? this.getInitialState() : null;
        c(
          typeof k == "object" && !Array.isArray(k),
          "%s.getInitialState(): must return an object or null",
          M.displayName || "ReactCompositeComponent"
        ), this.state = k;
      };
      M.prototype = new L(), M.prototype.constructor = M, M.prototype.__reactAutoBindPairs = [], g.forEach(C.bind(null, M)), C(M, E), C(M, F), C(M, R), M.getDefaultProps && (M.defaultProps = M.getDefaultProps()), c(
        M.prototype.render,
        "createClass(...): Class specification must implement a `render` method."
      );
      for (var W in b)
        M.prototype[W] || (M.prototype[W] = null);
      return M;
    }
    return B;
  }
  return factory_1 = p, factory_1;
}
var createReactClass$1, hasRequiredCreateReactClass;
function requireCreateReactClass() {
  if (hasRequiredCreateReactClass) return createReactClass$1;
  hasRequiredCreateReactClass = 1;
  var a = requireReact(), s = requireFactory();
  if (typeof a > "u")
    throw Error(
      "create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class."
    );
  var c = new a.Component().updater;
  return createReactClass$1 = s(
    a.Component,
    a.isValidElement,
    c
  ), createReactClass$1;
}
var createReactClassExports = requireCreateReactClass();
const createReactClass = /* @__PURE__ */ getDefaultExportFromCjs(createReactClassExports);
function contains$2(a, s) {
  for (var c = s; c; ) {
    if (c === a)
      return !0;
    c = c.parentNode;
  }
  return !1;
}
var addEventListener$3 = {}, lib = { exports: {} }, EventObject = { exports: {} }, EventBaseObject = { exports: {} }, hasRequiredEventBaseObject;
function requireEventBaseObject() {
  return hasRequiredEventBaseObject || (hasRequiredEventBaseObject = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    function c() {
      return !1;
    }
    function u() {
      return !0;
    }
    function d() {
      this.timeStamp = Date.now(), this.target = void 0, this.currentTarget = void 0;
    }
    d.prototype = {
      isEventObject: 1,
      constructor: d,
      isDefaultPrevented: c,
      isPropagationStopped: c,
      isImmediatePropagationStopped: c,
      preventDefault: function() {
        this.isDefaultPrevented = u;
      },
      stopPropagation: function() {
        this.isPropagationStopped = u;
      },
      stopImmediatePropagation: function() {
        this.isImmediatePropagationStopped = u, this.stopPropagation();
      },
      halt: function(v) {
        v ? this.stopImmediatePropagation() : this.stopPropagation(), this.preventDefault();
      }
    }, s.default = d, a.exports = s.default;
  }(EventBaseObject, EventBaseObject.exports)), EventBaseObject.exports;
}
var hasRequiredEventObject;
function requireEventObject() {
  return hasRequiredEventObject || (hasRequiredEventObject = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    function c(S) {
      return S && S.__esModule ? S : { default: S };
    }
    var u = requireEventBaseObject(), d = c(u), p = requireObjectAssign(), v = c(p), A = !0, x = !1, g = ["altKey", "bubbles", "cancelable", "ctrlKey", "currentTarget", "eventPhase", "metaKey", "shiftKey", "target", "timeStamp", "view", "type"];
    function b(S) {
      return S == null;
    }
    var y = [{
      reg: /^key/,
      props: ["char", "charCode", "key", "keyCode", "which"],
      fix: function($, T) {
        b($.which) && ($.which = b(T.charCode) ? T.keyCode : T.charCode), $.metaKey === void 0 && ($.metaKey = $.ctrlKey);
      }
    }, {
      reg: /^touch/,
      props: ["touches", "changedTouches", "targetTouches"]
    }, {
      reg: /^hashchange$/,
      props: ["newURL", "oldURL"]
    }, {
      reg: /^gesturechange$/i,
      props: ["rotation", "scale"]
    }, {
      reg: /^(mousewheel|DOMMouseScroll)$/,
      props: [],
      fix: function($, T) {
        var I = void 0, _ = void 0, E = void 0, R = T.wheelDelta, O = T.axis, L = T.wheelDeltaY, B = T.wheelDeltaX, F = T.detail;
        R && (E = R / 120), F && (E = 0 - (F % 3 === 0 ? F / 3 : F)), O !== void 0 && (O === $.HORIZONTAL_AXIS ? (_ = 0, I = 0 - E) : O === $.VERTICAL_AXIS && (I = 0, _ = E)), L !== void 0 && (_ = L / 120), B !== void 0 && (I = -1 * B / 120), !I && !_ && (_ = E), I !== void 0 && ($.deltaX = I), _ !== void 0 && ($.deltaY = _), E !== void 0 && ($.delta = E);
      }
    }, {
      reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
      props: ["buttons", "clientX", "clientY", "button", "offsetX", "relatedTarget", "which", "fromElement", "toElement", "offsetY", "pageX", "pageY", "screenX", "screenY"],
      fix: function($, T) {
        var I = void 0, _ = void 0, E = void 0, R = $.target, O = T.button;
        return R && b($.pageX) && !b(T.clientX) && (I = R.ownerDocument || document, _ = I.documentElement, E = I.body, $.pageX = T.clientX + (_ && _.scrollLeft || E && E.scrollLeft || 0) - (_ && _.clientLeft || E && E.clientLeft || 0), $.pageY = T.clientY + (_ && _.scrollTop || E && E.scrollTop || 0) - (_ && _.clientTop || E && E.clientTop || 0)), !$.which && O !== void 0 && (O & 1 ? $.which = 1 : O & 2 ? $.which = 3 : O & 4 ? $.which = 2 : $.which = 0), !$.relatedTarget && $.fromElement && ($.relatedTarget = $.fromElement === R ? $.toElement : $.fromElement), $;
      }
    }];
    function f() {
      return A;
    }
    function m() {
      return x;
    }
    function C(S) {
      var $ = S.type, T = typeof S.stopPropagation == "function" || typeof S.cancelBubble == "boolean";
      d.default.call(this), this.nativeEvent = S;
      var I = m;
      "defaultPrevented" in S ? I = S.defaultPrevented ? f : m : "getPreventDefault" in S ? I = S.getPreventDefault() ? f : m : "returnValue" in S && (I = S.returnValue === x ? f : m), this.isDefaultPrevented = I;
      var _ = [], E = void 0, R = void 0, O = void 0, L = g.concat();
      for (y.forEach(function(B) {
        $.match(B.reg) && (L = L.concat(B.props), B.fix && _.push(B.fix));
      }), R = L.length; R; )
        O = L[--R], this[O] = S[O];
      for (!this.target && T && (this.target = S.srcElement || document), this.target && this.target.nodeType === 3 && (this.target = this.target.parentNode), R = _.length; R; )
        E = _[--R], E(this, S);
      this.timeStamp = S.timeStamp || Date.now();
    }
    var w = d.default.prototype;
    (0, v.default)(C.prototype, w, {
      constructor: C,
      preventDefault: function() {
        var $ = this.nativeEvent;
        $.preventDefault ? $.preventDefault() : $.returnValue = x, w.preventDefault.call(this);
      },
      stopPropagation: function() {
        var $ = this.nativeEvent;
        $.stopPropagation ? $.stopPropagation() : $.cancelBubble = A, w.stopPropagation.call(this);
      }
    }), s.default = C, a.exports = s.default;
  }(EventObject, EventObject.exports)), EventObject.exports;
}
var hasRequiredLib$1;
function requireLib$1() {
  return hasRequiredLib$1 || (hasRequiredLib$1 = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    }), s.default = p;
    function c(v) {
      return v && v.__esModule ? v : { default: v };
    }
    var u = requireEventObject(), d = c(u);
    function p(v, A, x, g) {
      function b(f) {
        var m = new d.default(f);
        x.call(v, m);
      }
      if (v.addEventListener) {
        var y = function() {
          var f = !1;
          return typeof g == "object" ? f = g.capture || !1 : typeof g == "boolean" && (f = g), v.addEventListener(A, b, g || !1), {
            v: {
              remove: function() {
                v.removeEventListener(A, b, f);
              }
            }
          };
        }();
        if (typeof y == "object") return y.v;
      } else if (v.attachEvent)
        return v.attachEvent("on" + A, b), {
          remove: function() {
            v.detachEvent("on" + A, b);
          }
        };
    }
    a.exports = s.default;
  }(lib, lib.exports)), lib.exports;
}
var hasRequiredAddEventListener$1;
function requireAddEventListener$1() {
  if (hasRequiredAddEventListener$1) return addEventListener$3;
  hasRequiredAddEventListener$1 = 1, Object.defineProperty(addEventListener$3, "__esModule", {
    value: !0
  }), addEventListener$3.default = u;
  var a = c(requireLib$1()), s = c(requireReactDom());
  function c(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function u(d, p, v, A) {
    var x = s.default.unstable_batchedUpdates ? function(b) {
      s.default.unstable_batchedUpdates(v, b);
    } : v;
    return (0, a.default)(d, p, x, A);
  }
  return addEventListener$3;
}
var addEventListenerExports = requireAddEventListener$1();
const addEventListener$2 = /* @__PURE__ */ getDefaultExportFromCjs(addEventListenerExports);
var classCallCheck = {}, hasRequiredClassCallCheck;
function requireClassCallCheck() {
  return hasRequiredClassCallCheck || (hasRequiredClassCallCheck = 1, classCallCheck.__esModule = !0, classCallCheck.default = function(a, s) {
    if (!(a instanceof s))
      throw new TypeError("Cannot call a class as a function");
  }), classCallCheck;
}
var classCallCheckExports = requireClassCallCheck();
const _classCallCheck = /* @__PURE__ */ getDefaultExportFromCjs(classCallCheckExports);
var createClass = {}, es6_object_defineProperty = {}, hasRequiredEs6_object_defineProperty;
function requireEs6_object_defineProperty() {
  if (hasRequiredEs6_object_defineProperty) return es6_object_defineProperty;
  hasRequiredEs6_object_defineProperty = 1;
  var a = require_export();
  return a(a.S + a.F * !require_descriptors(), "Object", { defineProperty: require_objectDp().f }), es6_object_defineProperty;
}
var defineProperty$2, hasRequiredDefineProperty$2;
function requireDefineProperty$2() {
  if (hasRequiredDefineProperty$2) return defineProperty$2;
  hasRequiredDefineProperty$2 = 1, requireEs6_object_defineProperty();
  var a = require_core().Object;
  return defineProperty$2 = function(c, u, d) {
    return a.defineProperty(c, u, d);
  }, defineProperty$2;
}
var defineProperty$1, hasRequiredDefineProperty$1;
function requireDefineProperty$1() {
  return hasRequiredDefineProperty$1 || (hasRequiredDefineProperty$1 = 1, defineProperty$1 = { default: requireDefineProperty$2(), __esModule: !0 }), defineProperty$1;
}
var hasRequiredCreateClass;
function requireCreateClass() {
  if (hasRequiredCreateClass) return createClass;
  hasRequiredCreateClass = 1, createClass.__esModule = !0;
  var a = requireDefineProperty$1(), s = c(a);
  function c(u) {
    return u && u.__esModule ? u : { default: u };
  }
  return createClass.default = /* @__PURE__ */ function() {
    function u(d, p) {
      for (var v = 0; v < p.length; v++) {
        var A = p[v];
        A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), (0, s.default)(d, A.key, A);
      }
    }
    return function(d, p, v) {
      return p && u(d.prototype, p), v && u(d, v), d;
    };
  }(), createClass;
}
var createClassExports = requireCreateClass();
const _createClass = /* @__PURE__ */ getDefaultExportFromCjs(createClassExports);
var possibleConstructorReturn = {}, _typeof$9 = {}, es6_string_iterator = {}, _stringAt, hasRequired_stringAt;
function require_stringAt() {
  if (hasRequired_stringAt) return _stringAt;
  hasRequired_stringAt = 1;
  var a = require_toInteger(), s = require_defined();
  return _stringAt = function(c) {
    return function(u, d) {
      var p = String(s(u)), v = a(d), A = p.length, x, g;
      return v < 0 || v >= A ? c ? "" : void 0 : (x = p.charCodeAt(v), x < 55296 || x > 56319 || v + 1 === A || (g = p.charCodeAt(v + 1)) < 56320 || g > 57343 ? c ? p.charAt(v) : x : c ? p.slice(v, v + 2) : (x - 55296 << 10) + (g - 56320) + 65536);
    };
  }, _stringAt;
}
var _redefine, hasRequired_redefine;
function require_redefine() {
  return hasRequired_redefine || (hasRequired_redefine = 1, _redefine = require_hide()), _redefine;
}
var _iterators, hasRequired_iterators;
function require_iterators() {
  return hasRequired_iterators || (hasRequired_iterators = 1, _iterators = {}), _iterators;
}
var _objectDps, hasRequired_objectDps;
function require_objectDps() {
  if (hasRequired_objectDps) return _objectDps;
  hasRequired_objectDps = 1;
  var a = require_objectDp(), s = require_anObject(), c = require_objectKeys();
  return _objectDps = require_descriptors() ? Object.defineProperties : function(d, p) {
    s(d);
    for (var v = c(p), A = v.length, x = 0, g; A > x; ) a.f(d, g = v[x++], p[g]);
    return d;
  }, _objectDps;
}
var _html, hasRequired_html;
function require_html() {
  if (hasRequired_html) return _html;
  hasRequired_html = 1;
  var a = require_global().document;
  return _html = a && a.documentElement, _html;
}
var _objectCreate, hasRequired_objectCreate;
function require_objectCreate() {
  if (hasRequired_objectCreate) return _objectCreate;
  hasRequired_objectCreate = 1;
  var a = require_anObject(), s = require_objectDps(), c = require_enumBugKeys(), u = require_sharedKey()("IE_PROTO"), d = function() {
  }, p = "prototype", v = function() {
    var A = require_domCreate()("iframe"), x = c.length, g = "<", b = ">", y;
    for (A.style.display = "none", require_html().appendChild(A), A.src = "javascript:", y = A.contentWindow.document, y.open(), y.write(g + "script" + b + "document.F=Object" + g + "/script" + b), y.close(), v = y.F; x--; ) delete v[p][c[x]];
    return v();
  };
  return _objectCreate = Object.create || function(x, g) {
    var b;
    return x !== null ? (d[p] = a(x), b = new d(), d[p] = null, b[u] = x) : b = v(), g === void 0 ? b : s(b, g);
  }, _objectCreate;
}
var _wks = { exports: {} }, hasRequired_wks;
function require_wks() {
  if (hasRequired_wks) return _wks.exports;
  hasRequired_wks = 1;
  var a = require_shared()("wks"), s = require_uid(), c = require_global().Symbol, u = typeof c == "function", d = _wks.exports = function(p) {
    return a[p] || (a[p] = u && c[p] || (u ? c : s)("Symbol." + p));
  };
  return d.store = a, _wks.exports;
}
var _setToStringTag, hasRequired_setToStringTag;
function require_setToStringTag() {
  if (hasRequired_setToStringTag) return _setToStringTag;
  hasRequired_setToStringTag = 1;
  var a = require_objectDp().f, s = require_has(), c = require_wks()("toStringTag");
  return _setToStringTag = function(u, d, p) {
    u && !s(u = p ? u : u.prototype, c) && a(u, c, { configurable: !0, value: d });
  }, _setToStringTag;
}
var _iterCreate, hasRequired_iterCreate;
function require_iterCreate() {
  if (hasRequired_iterCreate) return _iterCreate;
  hasRequired_iterCreate = 1;
  var a = require_objectCreate(), s = require_propertyDesc(), c = require_setToStringTag(), u = {};
  return require_hide()(u, require_wks()("iterator"), function() {
    return this;
  }), _iterCreate = function(d, p, v) {
    d.prototype = a(u, { next: s(1, v) }), c(d, p + " Iterator");
  }, _iterCreate;
}
var _objectGpo, hasRequired_objectGpo;
function require_objectGpo() {
  if (hasRequired_objectGpo) return _objectGpo;
  hasRequired_objectGpo = 1;
  var a = require_has(), s = require_toObject(), c = require_sharedKey()("IE_PROTO"), u = Object.prototype;
  return _objectGpo = Object.getPrototypeOf || function(d) {
    return d = s(d), a(d, c) ? d[c] : typeof d.constructor == "function" && d instanceof d.constructor ? d.constructor.prototype : d instanceof Object ? u : null;
  }, _objectGpo;
}
var _iterDefine, hasRequired_iterDefine;
function require_iterDefine() {
  if (hasRequired_iterDefine) return _iterDefine;
  hasRequired_iterDefine = 1;
  var a = require_library(), s = require_export(), c = require_redefine(), u = require_hide(), d = require_iterators(), p = require_iterCreate(), v = require_setToStringTag(), A = require_objectGpo(), x = require_wks()("iterator"), g = !([].keys && "next" in [].keys()), b = "@@iterator", y = "keys", f = "values", m = function() {
    return this;
  };
  return _iterDefine = function(C, w, S, $, T, I, _) {
    p(S, w, $);
    var E = function(N) {
      if (!g && N in B) return B[N];
      switch (N) {
        case y:
          return function() {
            return new S(this, N);
          };
        case f:
          return function() {
            return new S(this, N);
          };
      }
      return function() {
        return new S(this, N);
      };
    }, R = w + " Iterator", O = T == f, L = !1, B = C.prototype, F = B[x] || B[b] || T && B[T], M = F || E(T), W = T ? O ? E("entries") : M : void 0, j = w == "Array" && B.entries || F, G, U, k;
    if (j && (k = A(j.call(new C())), k !== Object.prototype && k.next && (v(k, R, !0), !a && typeof k[x] != "function" && u(k, x, m))), O && F && F.name !== f && (L = !0, M = function() {
      return F.call(this);
    }), (!a || _) && (g || L || !B[x]) && u(B, x, M), d[w] = M, d[R] = m, T)
      if (G = {
        values: O ? M : E(f),
        keys: I ? M : E(y),
        entries: W
      }, _) for (U in G)
        U in B || c(B, U, G[U]);
      else s(s.P + s.F * (g || L), w, G);
    return G;
  }, _iterDefine;
}
var hasRequiredEs6_string_iterator;
function requireEs6_string_iterator() {
  if (hasRequiredEs6_string_iterator) return es6_string_iterator;
  hasRequiredEs6_string_iterator = 1;
  var a = require_stringAt()(!0);
  return require_iterDefine()(String, "String", function(s) {
    this._t = String(s), this._i = 0;
  }, function() {
    var s = this._t, c = this._i, u;
    return c >= s.length ? { value: void 0, done: !0 } : (u = a(s, c), this._i += u.length, { value: u, done: !1 });
  }), es6_string_iterator;
}
var web_dom_iterable = {}, _addToUnscopables, hasRequired_addToUnscopables;
function require_addToUnscopables() {
  return hasRequired_addToUnscopables || (hasRequired_addToUnscopables = 1, _addToUnscopables = function() {
  }), _addToUnscopables;
}
var _iterStep, hasRequired_iterStep;
function require_iterStep() {
  return hasRequired_iterStep || (hasRequired_iterStep = 1, _iterStep = function(a, s) {
    return { value: s, done: !!a };
  }), _iterStep;
}
var es6_array_iterator, hasRequiredEs6_array_iterator;
function requireEs6_array_iterator() {
  if (hasRequiredEs6_array_iterator) return es6_array_iterator;
  hasRequiredEs6_array_iterator = 1;
  var a = require_addToUnscopables(), s = require_iterStep(), c = require_iterators(), u = require_toIobject();
  return es6_array_iterator = require_iterDefine()(Array, "Array", function(d, p) {
    this._t = u(d), this._i = 0, this._k = p;
  }, function() {
    var d = this._t, p = this._k, v = this._i++;
    return !d || v >= d.length ? (this._t = void 0, s(1)) : p == "keys" ? s(0, v) : p == "values" ? s(0, d[v]) : s(0, [v, d[v]]);
  }, "values"), c.Arguments = c.Array, a("keys"), a("values"), a("entries"), es6_array_iterator;
}
var hasRequiredWeb_dom_iterable;
function requireWeb_dom_iterable() {
  if (hasRequiredWeb_dom_iterable) return web_dom_iterable;
  hasRequiredWeb_dom_iterable = 1, requireEs6_array_iterator();
  for (var a = require_global(), s = require_hide(), c = require_iterators(), u = require_wks()("toStringTag"), d = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), p = 0; p < d.length; p++) {
    var v = d[p], A = a[v], x = A && A.prototype;
    x && !x[u] && s(x, u, v), c[v] = c.Array;
  }
  return web_dom_iterable;
}
var _wksExt = {}, hasRequired_wksExt;
function require_wksExt() {
  return hasRequired_wksExt || (hasRequired_wksExt = 1, _wksExt.f = require_wks()), _wksExt;
}
var iterator$1, hasRequiredIterator$1;
function requireIterator$1() {
  return hasRequiredIterator$1 || (hasRequiredIterator$1 = 1, requireEs6_string_iterator(), requireWeb_dom_iterable(), iterator$1 = require_wksExt().f("iterator")), iterator$1;
}
var iterator, hasRequiredIterator;
function requireIterator() {
  return hasRequiredIterator || (hasRequiredIterator = 1, iterator = { default: requireIterator$1(), __esModule: !0 }), iterator;
}
var es6_symbol = {}, _meta = { exports: {} }, hasRequired_meta;
function require_meta() {
  if (hasRequired_meta) return _meta.exports;
  hasRequired_meta = 1;
  var a = require_uid()("meta"), s = require_isObject(), c = require_has(), u = require_objectDp().f, d = 0, p = Object.isExtensible || function() {
    return !0;
  }, v = !require_fails()(function() {
    return p(Object.preventExtensions({}));
  }), A = function(f) {
    u(f, a, { value: {
      i: "O" + ++d,
      // object ID
      w: {}
      // weak collections IDs
    } });
  }, x = function(f, m) {
    if (!s(f)) return typeof f == "symbol" ? f : (typeof f == "string" ? "S" : "P") + f;
    if (!c(f, a)) {
      if (!p(f)) return "F";
      if (!m) return "E";
      A(f);
    }
    return f[a].i;
  }, g = function(f, m) {
    if (!c(f, a)) {
      if (!p(f)) return !0;
      if (!m) return !1;
      A(f);
    }
    return f[a].w;
  }, b = function(f) {
    return v && y.NEED && p(f) && !c(f, a) && A(f), f;
  }, y = _meta.exports = {
    KEY: a,
    NEED: !1,
    fastKey: x,
    getWeak: g,
    onFreeze: b
  };
  return _meta.exports;
}
var _wksDefine, hasRequired_wksDefine;
function require_wksDefine() {
  if (hasRequired_wksDefine) return _wksDefine;
  hasRequired_wksDefine = 1;
  var a = require_global(), s = require_core(), c = require_library(), u = require_wksExt(), d = require_objectDp().f;
  return _wksDefine = function(p) {
    var v = s.Symbol || (s.Symbol = c ? {} : a.Symbol || {});
    p.charAt(0) != "_" && !(p in v) && d(v, p, { value: u.f(p) });
  }, _wksDefine;
}
var _enumKeys, hasRequired_enumKeys;
function require_enumKeys() {
  if (hasRequired_enumKeys) return _enumKeys;
  hasRequired_enumKeys = 1;
  var a = require_objectKeys(), s = require_objectGops(), c = require_objectPie();
  return _enumKeys = function(u) {
    var d = a(u), p = s.f;
    if (p)
      for (var v = p(u), A = c.f, x = 0, g; v.length > x; ) A.call(u, g = v[x++]) && d.push(g);
    return d;
  }, _enumKeys;
}
var _isArray, hasRequired_isArray;
function require_isArray() {
  if (hasRequired_isArray) return _isArray;
  hasRequired_isArray = 1;
  var a = require_cof();
  return _isArray = Array.isArray || function(c) {
    return a(c) == "Array";
  }, _isArray;
}
var _objectGopnExt = {}, _objectGopn = {}, hasRequired_objectGopn;
function require_objectGopn() {
  if (hasRequired_objectGopn) return _objectGopn;
  hasRequired_objectGopn = 1;
  var a = require_objectKeysInternal(), s = require_enumBugKeys().concat("length", "prototype");
  return _objectGopn.f = Object.getOwnPropertyNames || function(u) {
    return a(u, s);
  }, _objectGopn;
}
var hasRequired_objectGopnExt;
function require_objectGopnExt() {
  if (hasRequired_objectGopnExt) return _objectGopnExt;
  hasRequired_objectGopnExt = 1;
  var a = require_toIobject(), s = require_objectGopn().f, c = {}.toString, u = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], d = function(p) {
    try {
      return s(p);
    } catch {
      return u.slice();
    }
  };
  return _objectGopnExt.f = function(v) {
    return u && c.call(v) == "[object Window]" ? d(v) : s(a(v));
  }, _objectGopnExt;
}
var _objectGopd = {}, hasRequired_objectGopd;
function require_objectGopd() {
  if (hasRequired_objectGopd) return _objectGopd;
  hasRequired_objectGopd = 1;
  var a = require_objectPie(), s = require_propertyDesc(), c = require_toIobject(), u = require_toPrimitive(), d = require_has(), p = require_ie8DomDefine(), v = Object.getOwnPropertyDescriptor;
  return _objectGopd.f = require_descriptors() ? v : function(x, g) {
    if (x = c(x), g = u(g, !0), p) try {
      return v(x, g);
    } catch {
    }
    if (d(x, g)) return s(!a.f.call(x, g), x[g]);
  }, _objectGopd;
}
var hasRequiredEs6_symbol;
function requireEs6_symbol() {
  if (hasRequiredEs6_symbol) return es6_symbol;
  hasRequiredEs6_symbol = 1;
  var a = require_global(), s = require_has(), c = require_descriptors(), u = require_export(), d = require_redefine(), p = require_meta().KEY, v = require_fails(), A = require_shared(), x = require_setToStringTag(), g = require_uid(), b = require_wks(), y = require_wksExt(), f = require_wksDefine(), m = require_enumKeys(), C = require_isArray(), w = require_anObject(), S = require_isObject(), $ = require_toObject(), T = require_toIobject(), I = require_toPrimitive(), _ = require_propertyDesc(), E = require_objectCreate(), R = require_objectGopnExt(), O = require_objectGopd(), L = require_objectGops(), B = require_objectDp(), F = require_objectKeys(), M = O.f, W = B.f, j = R.f, G = a.Symbol, U = a.JSON, k = U && U.stringify, N = "prototype", P = b("_hidden"), D = b("toPrimitive"), H = {}.propertyIsEnumerable, V = A("symbol-registry"), Z = A("symbols"), ne = A("op-symbols"), K = Object[N], q = typeof G == "function" && !!L.f, Y = a.QObject, ee = !Y || !Y[N] || !Y[N].findChild, Q = c && v(function() {
    return E(W({}, "a", {
      get: function() {
        return W(this, "a", { value: 7 }).a;
      }
    })).a != 7;
  }) ? function(Ce, xe, we) {
    var $e = M(K, xe);
    $e && delete K[xe], W(Ce, xe, we), $e && Ce !== K && W(K, xe, $e);
  } : W, J = function(Ce) {
    var xe = Z[Ce] = E(G[N]);
    return xe._k = Ce, xe;
  }, te = q && typeof G.iterator == "symbol" ? function(Ce) {
    return typeof Ce == "symbol";
  } : function(Ce) {
    return Ce instanceof G;
  }, ae = function(xe, we, $e) {
    return xe === K && ae(ne, we, $e), w(xe), we = I(we, !0), w($e), s(Z, we) ? ($e.enumerable ? (s(xe, P) && xe[P][we] && (xe[P][we] = !1), $e = E($e, { enumerable: _(0, !1) })) : (s(xe, P) || W(xe, P, _(1, {})), xe[P][we] = !0), Q(xe, we, $e)) : W(xe, we, $e);
  }, se = function(xe, we) {
    w(xe);
    for (var $e = m(we = T(we)), Ae = 0, ue = $e.length, ce; ue > Ae; ) ae(xe, ce = $e[Ae++], we[ce]);
    return xe;
  }, ie = function(xe, we) {
    return we === void 0 ? E(xe) : se(E(xe), we);
  }, fe = function(xe) {
    var we = H.call(this, xe = I(xe, !0));
    return this === K && s(Z, xe) && !s(ne, xe) ? !1 : we || !s(this, xe) || !s(Z, xe) || s(this, P) && this[P][xe] ? we : !0;
  }, ge = function(xe, we) {
    if (xe = T(xe), we = I(we, !0), !(xe === K && s(Z, we) && !s(ne, we))) {
      var $e = M(xe, we);
      return $e && s(Z, we) && !(s(xe, P) && xe[P][we]) && ($e.enumerable = !0), $e;
    }
  }, me = function(xe) {
    for (var we = j(T(xe)), $e = [], Ae = 0, ue; we.length > Ae; )
      !s(Z, ue = we[Ae++]) && ue != P && ue != p && $e.push(ue);
    return $e;
  }, pe = function(xe) {
    for (var we = xe === K, $e = j(we ? ne : T(xe)), Ae = [], ue = 0, ce; $e.length > ue; )
      s(Z, ce = $e[ue++]) && (!we || s(K, ce)) && Ae.push(Z[ce]);
    return Ae;
  };
  q || (G = function() {
    if (this instanceof G) throw TypeError("Symbol is not a constructor!");
    var xe = g(arguments.length > 0 ? arguments[0] : void 0), we = function($e) {
      this === K && we.call(ne, $e), s(this, P) && s(this[P], xe) && (this[P][xe] = !1), Q(this, xe, _(1, $e));
    };
    return c && ee && Q(K, xe, { configurable: !0, set: we }), J(xe);
  }, d(G[N], "toString", function() {
    return this._k;
  }), O.f = ge, B.f = ae, require_objectGopn().f = R.f = me, require_objectPie().f = fe, L.f = pe, c && !require_library() && d(K, "propertyIsEnumerable", fe, !0), y.f = function(Ce) {
    return J(b(Ce));
  }), u(u.G + u.W + u.F * !q, { Symbol: G });
  for (var be = (
    // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
    "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(",")
  ), le = 0; be.length > le; ) b(be[le++]);
  for (var ve = F(b.store), he = 0; ve.length > he; ) f(ve[he++]);
  u(u.S + u.F * !q, "Symbol", {
    // 19.4.2.1 Symbol.for(key)
    for: function(Ce) {
      return s(V, Ce += "") ? V[Ce] : V[Ce] = G(Ce);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function(xe) {
      if (!te(xe)) throw TypeError(xe + " is not a symbol!");
      for (var we in V) if (V[we] === xe) return we;
    },
    useSetter: function() {
      ee = !0;
    },
    useSimple: function() {
      ee = !1;
    }
  }), u(u.S + u.F * !q, "Object", {
    // 19.1.2.2 Object.create(O [, Properties])
    create: ie,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: ae,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: se,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: ge,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: me,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: pe
  });
  var ye = v(function() {
    L.f(1);
  });
  return u(u.S + u.F * ye, "Object", {
    getOwnPropertySymbols: function(xe) {
      return L.f($(xe));
    }
  }), U && u(u.S + u.F * (!q || v(function() {
    var Ce = G();
    return k([Ce]) != "[null]" || k({ a: Ce }) != "{}" || k(Object(Ce)) != "{}";
  })), "JSON", {
    stringify: function(xe) {
      for (var we = [xe], $e = 1, Ae, ue; arguments.length > $e; ) we.push(arguments[$e++]);
      if (ue = Ae = we[1], !(!S(Ae) && xe === void 0 || te(xe)))
        return C(Ae) || (Ae = function(ce, Ee) {
          if (typeof ue == "function" && (Ee = ue.call(this, ce, Ee)), !te(Ee)) return Ee;
        }), we[1] = Ae, k.apply(U, we);
    }
  }), G[N][D] || require_hide()(G[N], D, G[N].valueOf), x(G, "Symbol"), x(Math, "Math", !0), x(a.JSON, "JSON", !0), es6_symbol;
}
var es7_symbol_asyncIterator = {}, hasRequiredEs7_symbol_asyncIterator;
function requireEs7_symbol_asyncIterator() {
  return hasRequiredEs7_symbol_asyncIterator || (hasRequiredEs7_symbol_asyncIterator = 1, require_wksDefine()("asyncIterator")), es7_symbol_asyncIterator;
}
var es7_symbol_observable = {}, hasRequiredEs7_symbol_observable;
function requireEs7_symbol_observable() {
  return hasRequiredEs7_symbol_observable || (hasRequiredEs7_symbol_observable = 1, require_wksDefine()("observable")), es7_symbol_observable;
}
var symbol$1, hasRequiredSymbol$1;
function requireSymbol$1() {
  return hasRequiredSymbol$1 || (hasRequiredSymbol$1 = 1, requireEs6_symbol(), requireEs7_symbol_asyncIterator(), requireEs7_symbol_observable(), symbol$1 = require_core().Symbol), symbol$1;
}
var symbol, hasRequiredSymbol;
function requireSymbol() {
  return hasRequiredSymbol || (hasRequiredSymbol = 1, symbol = { default: requireSymbol$1(), __esModule: !0 }), symbol;
}
var hasRequired_typeof;
function require_typeof() {
  if (hasRequired_typeof) return _typeof$9;
  hasRequired_typeof = 1, _typeof$9.__esModule = !0;
  var a = requireIterator(), s = p(a), c = requireSymbol(), u = p(c), d = typeof u.default == "function" && typeof s.default == "symbol" ? function(v) {
    return typeof v;
  } : function(v) {
    return v && typeof u.default == "function" && v.constructor === u.default && v !== u.default.prototype ? "symbol" : typeof v;
  };
  function p(v) {
    return v && v.__esModule ? v : { default: v };
  }
  return _typeof$9.default = typeof u.default == "function" && d(s.default) === "symbol" ? function(v) {
    return typeof v > "u" ? "undefined" : d(v);
  } : function(v) {
    return v && typeof u.default == "function" && v.constructor === u.default && v !== u.default.prototype ? "symbol" : typeof v > "u" ? "undefined" : d(v);
  }, _typeof$9;
}
var hasRequiredPossibleConstructorReturn;
function requirePossibleConstructorReturn() {
  if (hasRequiredPossibleConstructorReturn) return possibleConstructorReturn;
  hasRequiredPossibleConstructorReturn = 1, possibleConstructorReturn.__esModule = !0;
  var a = require_typeof(), s = c(a);
  function c(u) {
    return u && u.__esModule ? u : { default: u };
  }
  return possibleConstructorReturn.default = function(u, d) {
    if (!u)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return d && ((typeof d > "u" ? "undefined" : (0, s.default)(d)) === "object" || typeof d == "function") ? d : u;
  }, possibleConstructorReturn;
}
var possibleConstructorReturnExports = requirePossibleConstructorReturn();
const _possibleConstructorReturn = /* @__PURE__ */ getDefaultExportFromCjs(possibleConstructorReturnExports);
var inherits = {}, es6_object_setPrototypeOf = {}, _setProto, hasRequired_setProto;
function require_setProto() {
  if (hasRequired_setProto) return _setProto;
  hasRequired_setProto = 1;
  var a = require_isObject(), s = require_anObject(), c = function(u, d) {
    if (s(u), !a(d) && d !== null) throw TypeError(d + ": can't set as prototype!");
  };
  return _setProto = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? (
      // eslint-disable-line
      function(u, d, p) {
        try {
          p = require_ctx()(Function.call, require_objectGopd().f(Object.prototype, "__proto__").set, 2), p(u, []), d = !(u instanceof Array);
        } catch {
          d = !0;
        }
        return function(A, x) {
          return c(A, x), d ? A.__proto__ = x : p(A, x), A;
        };
      }({}, !1)
    ) : void 0),
    check: c
  }, _setProto;
}
var hasRequiredEs6_object_setPrototypeOf;
function requireEs6_object_setPrototypeOf() {
  if (hasRequiredEs6_object_setPrototypeOf) return es6_object_setPrototypeOf;
  hasRequiredEs6_object_setPrototypeOf = 1;
  var a = require_export();
  return a(a.S, "Object", { setPrototypeOf: require_setProto().set }), es6_object_setPrototypeOf;
}
var setPrototypeOf$1, hasRequiredSetPrototypeOf$1;
function requireSetPrototypeOf$1() {
  return hasRequiredSetPrototypeOf$1 || (hasRequiredSetPrototypeOf$1 = 1, requireEs6_object_setPrototypeOf(), setPrototypeOf$1 = require_core().Object.setPrototypeOf), setPrototypeOf$1;
}
var setPrototypeOf, hasRequiredSetPrototypeOf;
function requireSetPrototypeOf() {
  return hasRequiredSetPrototypeOf || (hasRequiredSetPrototypeOf = 1, setPrototypeOf = { default: requireSetPrototypeOf$1(), __esModule: !0 }), setPrototypeOf;
}
var es6_object_create = {}, hasRequiredEs6_object_create;
function requireEs6_object_create() {
  if (hasRequiredEs6_object_create) return es6_object_create;
  hasRequiredEs6_object_create = 1;
  var a = require_export();
  return a(a.S, "Object", { create: require_objectCreate() }), es6_object_create;
}
var create$1, hasRequiredCreate$1;
function requireCreate$1() {
  if (hasRequiredCreate$1) return create$1;
  hasRequiredCreate$1 = 1, requireEs6_object_create();
  var a = require_core().Object;
  return create$1 = function(c, u) {
    return a.create(c, u);
  }, create$1;
}
var create, hasRequiredCreate;
function requireCreate() {
  return hasRequiredCreate || (hasRequiredCreate = 1, create = { default: requireCreate$1(), __esModule: !0 }), create;
}
var hasRequiredInherits;
function requireInherits() {
  if (hasRequiredInherits) return inherits;
  hasRequiredInherits = 1, inherits.__esModule = !0;
  var a = requireSetPrototypeOf(), s = v(a), c = requireCreate(), u = v(c), d = require_typeof(), p = v(d);
  function v(A) {
    return A && A.__esModule ? A : { default: A };
  }
  return inherits.default = function(A, x) {
    if (typeof x != "function" && x !== null)
      throw new TypeError("Super expression must either be null or a function, not " + (typeof x > "u" ? "undefined" : (0, p.default)(x)));
    A.prototype = (0, u.default)(x && x.prototype, {
      constructor: {
        value: A,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), x && (s.default ? (0, s.default)(A, x) : A.__proto__ = x);
  }, inherits;
}
var inheritsExports = requireInherits();
const _inherits = /* @__PURE__ */ getDefaultExportFromCjs(inheritsExports);
function ownKeys$1(a, s) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(a);
    s && (u = u.filter(function(d) {
      return Object.getOwnPropertyDescriptor(a, d).enumerable;
    })), c.push.apply(c, u);
  }
  return c;
}
function _objectSpread2(a) {
  for (var s = 1; s < arguments.length; s++) {
    var c = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$1(Object(c), !0).forEach(function(u) {
      _defineProperty$6(a, u, c[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(c)) : ownKeys$1(Object(c)).forEach(function(u) {
      Object.defineProperty(a, u, Object.getOwnPropertyDescriptor(c, u));
    });
  }
  return a;
}
function _typeof$8(a) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$8(a);
}
function _defineProperty$6(a, s, c) {
  return s in a ? Object.defineProperty(a, s, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[s] = c, a;
}
var vendorPrefix, jsCssMap = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function getVendorPrefix() {
  if (vendorPrefix !== void 0)
    return vendorPrefix;
  vendorPrefix = "";
  var a = document.createElement("p").style, s = "Transform";
  for (var c in jsCssMap)
    c + s in a && (vendorPrefix = c);
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
}
function setTransitionProperty(a, s) {
  var c = getTransitionName();
  c && (a.style[c] = s, c !== "transitionProperty" && (a.style.transitionProperty = s));
}
function setTransform(a, s) {
  var c = getTransformName();
  c && (a.style[c] = s, c !== "transform" && (a.style.transform = s));
}
function getTransitionProperty(a) {
  return a.style.transitionProperty || a.style[getTransitionName()];
}
function getTransformXY(a) {
  var s = window.getComputedStyle(a, null), c = s.getPropertyValue("transform") || s.getPropertyValue(getTransformName());
  if (c && c !== "none") {
    var u = c.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(u[12] || u[4], 0),
      y: parseFloat(u[13] || u[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/, matrix3d$1 = /matrix3d\((.*)\)/;
function setTransformXY(a, s) {
  var c = window.getComputedStyle(a, null), u = c.getPropertyValue("transform") || c.getPropertyValue(getTransformName());
  if (u && u !== "none") {
    var d, p = u.match(matrix2d);
    if (p)
      p = p[1], d = p.split(",").map(function(A) {
        return parseFloat(A, 10);
      }), d[4] = s.x, d[5] = s.y, setTransform(a, "matrix(".concat(d.join(","), ")"));
    else {
      var v = u.match(matrix3d$1)[1];
      d = v.split(",").map(function(A) {
        return parseFloat(A, 10);
      }), d[12] = s.x, d[13] = s.y, setTransform(a, "matrix3d(".concat(d.join(","), ")"));
    }
  } else
    setTransform(a, "translateX(".concat(s.x, "px) translateY(").concat(s.y, "px) translateZ(0)"));
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, getComputedStyleX;
function forceRelayout(a) {
  var s = a.style.display;
  a.style.display = "none", a.offsetHeight, a.style.display = s;
}
function css$1(a, s, c) {
  var u = c;
  if (_typeof$8(s) === "object") {
    for (var d in s)
      s.hasOwnProperty(d) && css$1(a, d, s[d]);
    return;
  }
  if (typeof u < "u") {
    typeof u == "number" && (u = "".concat(u, "px")), a.style[s] = u;
    return;
  }
  return getComputedStyleX(a, s);
}
function getClientPosition(a) {
  var s, c, u, d = a.ownerDocument, p = d.body, v = d && d.documentElement;
  return s = a.getBoundingClientRect(), c = Math.floor(s.left), u = Math.floor(s.top), c -= v.clientLeft || p.clientLeft || 0, u -= v.clientTop || p.clientTop || 0, {
    left: c,
    top: u
  };
}
function getScroll(a, s) {
  var c = a["page".concat(s ? "Y" : "X", "Offset")], u = "scroll".concat(s ? "Top" : "Left");
  if (typeof c != "number") {
    var d = a.document;
    c = d.documentElement[u], typeof c != "number" && (c = d.body[u]);
  }
  return c;
}
function getScrollLeft(a) {
  return getScroll(a);
}
function getScrollTop(a) {
  return getScroll(a, !0);
}
function getOffset(a) {
  var s = getClientPosition(a), c = a.ownerDocument, u = c.defaultView || c.parentWindow;
  return s.left += getScrollLeft(u), s.top += getScrollTop(u), s;
}
function isWindow$2(a) {
  return a != null && a == a.window;
}
function getDocument$1(a) {
  return isWindow$2(a) ? a.document : a.nodeType === 9 ? a : a.ownerDocument;
}
function _getComputedStyle(a, s, c) {
  var u = c, d = "", p = getDocument$1(a);
  return u = u || p.defaultView.getComputedStyle(a, null), u && (d = u.getPropertyValue(s) || u[s]), d;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i"), RE_POS = /^(top|right|bottom|left)$/, CURRENT_STYLE = "currentStyle", RUNTIME_STYLE = "runtimeStyle", LEFT = "left", PX = "px";
function _getComputedStyleIE(a, s) {
  var c = a[CURRENT_STYLE] && a[CURRENT_STYLE][s];
  if (_RE_NUM_NO_PX.test(c) && !RE_POS.test(s)) {
    var u = a.style, d = u[LEFT], p = a[RUNTIME_STYLE][LEFT];
    a[RUNTIME_STYLE][LEFT] = a[CURRENT_STYLE][LEFT], u[LEFT] = s === "fontSize" ? "1em" : c || 0, c = u.pixelLeft + PX, u[LEFT] = d, a[RUNTIME_STYLE][LEFT] = p;
  }
  return c === "" ? "auto" : c;
}
typeof window < "u" && (getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE);
function getOffsetDirection(a, s) {
  return a === "left" ? s.useCssRight ? "right" : a : s.useCssBottom ? "bottom" : a;
}
function oppositeOffsetDirection(a) {
  if (a === "left")
    return "right";
  if (a === "right")
    return "left";
  if (a === "top")
    return "bottom";
  if (a === "bottom")
    return "top";
}
function setLeftTop(a, s, c) {
  css$1(a, "position") === "static" && (a.style.position = "relative");
  var u = -999, d = -999, p = getOffsetDirection("left", c), v = getOffsetDirection("top", c), A = oppositeOffsetDirection(p), x = oppositeOffsetDirection(v);
  p !== "left" && (u = 999), v !== "top" && (d = 999);
  var g = "", b = getOffset(a);
  ("left" in s || "top" in s) && (g = getTransitionProperty(a) || "", setTransitionProperty(a, "none")), "left" in s && (a.style[A] = "", a.style[p] = "".concat(u, "px")), "top" in s && (a.style[x] = "", a.style[v] = "".concat(d, "px")), forceRelayout(a);
  var y = getOffset(a), f = {};
  for (var m in s)
    if (s.hasOwnProperty(m)) {
      var C = getOffsetDirection(m, c), w = m === "left" ? u : d, S = b[m] - y[m];
      C === m ? f[C] = w + S : f[C] = w - S;
    }
  css$1(a, f), forceRelayout(a), ("left" in s || "top" in s) && setTransitionProperty(a, g);
  var $ = {};
  for (var T in s)
    if (s.hasOwnProperty(T)) {
      var I = getOffsetDirection(T, c), _ = s[T] - b[T];
      T === I ? $[I] = f[I] + _ : $[I] = f[I] - _;
    }
  css$1(a, $);
}
function setTransform$1(a, s) {
  var c = getOffset(a), u = getTransformXY(a), d = {
    x: u.x,
    y: u.y
  };
  "left" in s && (d.x = u.x + s.left - c.left), "top" in s && (d.y = u.y + s.top - c.top), setTransformXY(a, d);
}
function setOffset(a, s, c) {
  if (c.ignoreShake) {
    var u = getOffset(a), d = u.left.toFixed(0), p = u.top.toFixed(0), v = s.left.toFixed(0), A = s.top.toFixed(0);
    if (d === v && p === A)
      return;
  }
  c.useCssRight || c.useCssBottom ? setLeftTop(a, s, c) : c.useCssTransform && getTransformName() in document.body.style ? setTransform$1(a, s) : setLeftTop(a, s, c);
}
function each(a, s) {
  for (var c = 0; c < a.length; c++)
    s(a[c]);
}
function isBorderBoxFn(a) {
  return getComputedStyleX(a, "boxSizing") === "border-box";
}
var BOX_MODELS = ["margin", "border", "padding"], CONTENT_INDEX = -1, PADDING_INDEX = 2, BORDER_INDEX = 1, MARGIN_INDEX = 0;
function swap$1(a, s, c) {
  var u = {}, d = a.style, p;
  for (p in s)
    s.hasOwnProperty(p) && (u[p] = d[p], d[p] = s[p]);
  c.call(a);
  for (p in s)
    s.hasOwnProperty(p) && (d[p] = u[p]);
}
function getPBMWidth(a, s, c) {
  var u = 0, d, p, v;
  for (p = 0; p < s.length; p++)
    if (d = s[p], d)
      for (v = 0; v < c.length; v++) {
        var A = void 0;
        d === "border" ? A = "".concat(d).concat(c[v], "Width") : A = d + c[v], u += parseFloat(getComputedStyleX(a, A)) || 0;
      }
  return u;
}
var domUtils = {
  getParent: function a(s) {
    var c = s;
    do
      c.nodeType === 11 && c.host ? c = c.host : c = c.parentNode;
    while (c && c.nodeType !== 1 && c.nodeType !== 9);
    return c;
  }
};
each(["Width", "Height"], function(a) {
  domUtils["doc".concat(a)] = function(s) {
    var c = s.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      c.documentElement["scroll".concat(a)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      c.body["scroll".concat(a)],
      domUtils["viewport".concat(a)](c)
    );
  }, domUtils["viewport".concat(a)] = function(s) {
    var c = "client".concat(a), u = s.document, d = u.body, p = u.documentElement, v = p[c];
    return u.compatMode === "CSS1Compat" && v || d && d[c] || v;
  };
});
function getWH(a, s, c) {
  var u = c;
  if (isWindow$2(a))
    return s === "width" ? domUtils.viewportWidth(a) : domUtils.viewportHeight(a);
  if (a.nodeType === 9)
    return s === "width" ? domUtils.docWidth(a) : domUtils.docHeight(a);
  var d = s === "width" ? ["Left", "Right"] : ["Top", "Bottom"], p = Math.floor(s === "width" ? a.getBoundingClientRect().width : a.getBoundingClientRect().height), v = isBorderBoxFn(a), A = 0;
  (p == null || p <= 0) && (p = void 0, A = getComputedStyleX(a, s), (A == null || Number(A) < 0) && (A = a.style[s] || 0), A = Math.floor(parseFloat(A)) || 0), u === void 0 && (u = v ? BORDER_INDEX : CONTENT_INDEX);
  var x = p !== void 0 || v, g = p || A;
  return u === CONTENT_INDEX ? x ? g - getPBMWidth(a, ["border", "padding"], d) : A : x ? u === BORDER_INDEX ? g : g + (u === PADDING_INDEX ? -getPBMWidth(a, ["border"], d) : getPBMWidth(a, ["margin"], d)) : A + getPBMWidth(a, BOX_MODELS.slice(u), d);
}
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function getWHIgnoreDisplay() {
  for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
    s[c] = arguments[c];
  var u, d = s[0];
  return d.offsetWidth !== 0 ? u = getWH.apply(void 0, s) : swap$1(d, cssShow, function() {
    u = getWH.apply(void 0, s);
  }), u;
}
each(["width", "height"], function(a) {
  var s = a.charAt(0).toUpperCase() + a.slice(1);
  domUtils["outer".concat(s)] = function(u, d) {
    return u && getWHIgnoreDisplay(u, a, d ? MARGIN_INDEX : BORDER_INDEX);
  };
  var c = a === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  domUtils[a] = function(u, d) {
    var p = d;
    if (p !== void 0) {
      if (u) {
        var v = isBorderBoxFn(u);
        return v && (p += getPBMWidth(u, ["padding", "border"], c)), css$1(u, a, p);
      }
      return;
    }
    return u && getWHIgnoreDisplay(u, a, CONTENT_INDEX);
  };
});
function mix$1(a, s) {
  for (var c in s)
    s.hasOwnProperty(c) && (a[c] = s[c]);
  return a;
}
var utils$1 = {
  getWindow: function a(s) {
    if (s && s.document && s.setTimeout)
      return s;
    var c = s.ownerDocument || s;
    return c.defaultView || c.parentWindow;
  },
  getDocument: getDocument$1,
  offset: function a(s, c, u) {
    if (typeof c < "u")
      setOffset(s, c, u || {});
    else
      return getOffset(s);
  },
  isWindow: isWindow$2,
  each,
  css: css$1,
  clone: function a(s) {
    var c, u = {};
    for (c in s)
      s.hasOwnProperty(c) && (u[c] = s[c]);
    var d = s.overflow;
    if (d)
      for (c in s)
        s.hasOwnProperty(c) && (u.overflow[c] = s.overflow[c]);
    return u;
  },
  mix: mix$1,
  getWindowScrollLeft: function a(s) {
    return getScrollLeft(s);
  },
  getWindowScrollTop: function a(s) {
    return getScrollTop(s);
  },
  merge: function a() {
    for (var s = {}, c = 0; c < arguments.length; c++)
      utils$1.mix(s, c < 0 || arguments.length <= c ? void 0 : arguments[c]);
    return s;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix$1(utils$1, domUtils);
var getParent = utils$1.getParent;
function getOffsetParent(a) {
  if (utils$1.isWindow(a) || a.nodeType === 9)
    return null;
  var s = utils$1.getDocument(a), c = s.body, u, d = utils$1.css(a, "position"), p = d === "fixed" || d === "absolute";
  if (!p)
    return a.nodeName.toLowerCase() === "html" ? null : getParent(a);
  for (u = getParent(a); u && u !== c && u.nodeType !== 9; u = getParent(u))
    if (d = utils$1.css(u, "position"), d !== "static")
      return u;
  return null;
}
var getParent$1 = utils$1.getParent;
function isAncestorFixed(a) {
  if (utils$1.isWindow(a) || a.nodeType === 9)
    return !1;
  var s = utils$1.getDocument(a), c = s.body, u = null;
  for (
    u = getParent$1(a);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    u && u !== c && u !== s;
    u = getParent$1(u)
  ) {
    var d = utils$1.css(u, "position");
    if (d === "fixed")
      return !0;
  }
  return !1;
}
function getVisibleRectForElement(a, s) {
  for (var c = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, u = getOffsetParent(a), d = utils$1.getDocument(a), p = d.defaultView || d.parentWindow, v = d.body, A = d.documentElement; u; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || u.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    u !== v && u !== A && utils$1.css(u, "overflow") !== "visible") {
      var x = utils$1.offset(u);
      x.left += u.clientLeft, x.top += u.clientTop, c.top = Math.max(c.top, x.top), c.right = Math.min(
        c.right,
        // consider area without scrollBar
        x.left + u.clientWidth
      ), c.bottom = Math.min(c.bottom, x.top + u.clientHeight), c.left = Math.max(c.left, x.left);
    } else if (u === v || u === A)
      break;
    u = getOffsetParent(u);
  }
  var g = null;
  if (!utils$1.isWindow(a) && a.nodeType !== 9) {
    g = a.style.position;
    var b = utils$1.css(a, "position");
    b === "absolute" && (a.style.position = "fixed");
  }
  var y = utils$1.getWindowScrollLeft(p), f = utils$1.getWindowScrollTop(p), m = utils$1.viewportWidth(p), C = utils$1.viewportHeight(p), w = A.scrollWidth, S = A.scrollHeight, $ = window.getComputedStyle(v);
  if ($.overflowX === "hidden" && (w = p.innerWidth), $.overflowY === "hidden" && (S = p.innerHeight), a.style && (a.style.position = g), s || isAncestorFixed(a))
    c.left = Math.max(c.left, y), c.top = Math.max(c.top, f), c.right = Math.min(c.right, y + m), c.bottom = Math.min(c.bottom, f + C);
  else {
    var T = Math.max(w, y + m);
    c.right = Math.min(c.right, T);
    var I = Math.max(S, f + C);
    c.bottom = Math.min(c.bottom, I);
  }
  return c.top >= 0 && c.left >= 0 && c.bottom > c.top && c.right > c.left ? c : null;
}
function adjustForViewport(a, s, c, u) {
  var d = utils$1.clone(a), p = {
    width: s.width,
    height: s.height
  };
  return u.adjustX && d.left < c.left && (d.left = c.left), u.resizeWidth && d.left >= c.left && d.left + p.width > c.right && (p.width -= d.left + p.width - c.right), u.adjustX && d.left + p.width > c.right && (d.left = Math.max(c.right - p.width, c.left)), u.adjustY && d.top < c.top && (d.top = c.top), u.resizeHeight && d.top >= c.top && d.top + p.height > c.bottom && (p.height -= d.top + p.height - c.bottom), u.adjustY && d.top + p.height > c.bottom && (d.top = Math.max(c.bottom - p.height, c.top)), utils$1.mix(d, p);
}
function getRegion(a) {
  var s, c, u;
  if (!utils$1.isWindow(a) && a.nodeType !== 9)
    s = utils$1.offset(a), c = utils$1.outerWidth(a), u = utils$1.outerHeight(a);
  else {
    var d = utils$1.getWindow(a);
    s = {
      left: utils$1.getWindowScrollLeft(d),
      top: utils$1.getWindowScrollTop(d)
    }, c = utils$1.viewportWidth(d), u = utils$1.viewportHeight(d);
  }
  return s.width = c, s.height = u, s;
}
function getAlignOffset(a, s) {
  var c = s.charAt(0), u = s.charAt(1), d = a.width, p = a.height, v = a.left, A = a.top;
  return c === "c" ? A += p / 2 : c === "b" && (A += p), u === "c" ? v += d / 2 : u === "r" && (v += d), {
    left: v,
    top: A
  };
}
function getElFuturePos(a, s, c, u, d) {
  var p = getAlignOffset(s, c[1]), v = getAlignOffset(a, c[0]), A = [v.left - p.left, v.top - p.top];
  return {
    left: Math.round(a.left - A[0] + u[0] - d[0]),
    top: Math.round(a.top - A[1] + u[1] - d[1])
  };
}
function isFailX(a, s, c) {
  return a.left < c.left || a.left + s.width > c.right;
}
function isFailY(a, s, c) {
  return a.top < c.top || a.top + s.height > c.bottom;
}
function isCompleteFailX(a, s, c) {
  return a.left > c.right || a.left + s.width < c.left;
}
function isCompleteFailY(a, s, c) {
  return a.top > c.bottom || a.top + s.height < c.top;
}
function flip(a, s, c) {
  var u = [];
  return utils$1.each(a, function(d) {
    u.push(d.replace(s, function(p) {
      return c[p];
    }));
  }), u;
}
function flipOffset(a, s) {
  return a[s] = -a[s], a;
}
function convertOffset(a, s) {
  var c;
  return /%$/.test(a) ? c = parseInt(a.substring(0, a.length - 1), 10) / 100 * s : c = parseInt(a, 10), c || 0;
}
function normalizeOffset(a, s) {
  a[0] = convertOffset(a[0], s.width), a[1] = convertOffset(a[1], s.height);
}
function doAlign(a, s, c, u) {
  var d = c.points, p = c.offset || [0, 0], v = c.targetOffset || [0, 0], A = c.overflow, x = c.source || a;
  p = [].concat(p), v = [].concat(v), A = A || {};
  var g = {}, b = 0, y = !!(A && A.alwaysByViewport), f = getVisibleRectForElement(x, y), m = getRegion(x);
  normalizeOffset(p, m), normalizeOffset(v, s);
  var C = getElFuturePos(m, s, d, p, v), w = utils$1.merge(m, C);
  if (f && (A.adjustX || A.adjustY) && u) {
    if (A.adjustX && isFailX(C, m, f)) {
      var S = flip(d, /[lr]/gi, {
        l: "r",
        r: "l"
      }), $ = flipOffset(p, 0), T = flipOffset(v, 0), I = getElFuturePos(m, s, S, $, T);
      isCompleteFailX(I, m, f) || (b = 1, d = S, p = $, v = T);
    }
    if (A.adjustY && isFailY(C, m, f)) {
      var _ = flip(d, /[tb]/gi, {
        t: "b",
        b: "t"
      }), E = flipOffset(p, 1), R = flipOffset(v, 1), O = getElFuturePos(m, s, _, E, R);
      isCompleteFailY(O, m, f) || (b = 1, d = _, p = E, v = R);
    }
    b && (C = getElFuturePos(m, s, d, p, v), utils$1.mix(w, C));
    var L = isFailX(C, m, f), B = isFailY(C, m, f);
    if (L || B) {
      var F = d;
      L && (F = flip(d, /[lr]/gi, {
        l: "r",
        r: "l"
      })), B && (F = flip(d, /[tb]/gi, {
        t: "b",
        b: "t"
      })), d = F, p = c.offset || [0, 0], v = c.targetOffset || [0, 0];
    }
    g.adjustX = A.adjustX && L, g.adjustY = A.adjustY && B, (g.adjustX || g.adjustY) && (w = adjustForViewport(C, m, f, g));
  }
  return w.width !== m.width && utils$1.css(x, "width", utils$1.width(x) + w.width - m.width), w.height !== m.height && utils$1.css(x, "height", utils$1.height(x) + w.height - m.height), utils$1.offset(x, {
    left: w.left,
    top: w.top
  }, {
    useCssRight: c.useCssRight,
    useCssBottom: c.useCssBottom,
    useCssTransform: c.useCssTransform,
    ignoreShake: c.ignoreShake
  }), {
    points: d,
    offset: p,
    targetOffset: v,
    overflow: g
  };
}
function isOutOfVisibleRect(a, s) {
  var c = getVisibleRectForElement(a, s), u = getRegion(a);
  return !c || u.left + u.width <= c.left || u.top + u.height <= c.top || u.left >= c.right || u.top >= c.bottom;
}
function alignElement(a, s, c) {
  var u = c.target || s, d = getRegion(u), p = !isOutOfVisibleRect(u, c.overflow && c.overflow.alwaysByViewport);
  return doAlign(a, d, c, p);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
function alignPoint(a, s, c) {
  var u, d, p = utils$1.getDocument(a), v = p.defaultView || p.parentWindow, A = utils$1.getWindowScrollLeft(v), x = utils$1.getWindowScrollTop(v), g = utils$1.viewportWidth(v), b = utils$1.viewportHeight(v);
  "pageX" in s ? u = s.pageX : u = A + s.clientX, "pageY" in s ? d = s.pageY : d = x + s.clientY;
  var y = {
    left: u,
    top: d,
    width: 0,
    height: 0
  }, f = u >= 0 && u <= A + g && d >= 0 && d <= x + b, m = [c.points[0], "cc"];
  return doAlign(a, y, _objectSpread2(_objectSpread2({}, c), {}, {
    points: m
  }), f);
}
var libExports$1 = requireLib$1();
const addDOMEventListener = /* @__PURE__ */ getDefaultExportFromCjs(libExports$1);
function addEventListenerWrap(a, s, c, u) {
  var d = ReactDOM.unstable_batchedUpdates ? function(v) {
    ReactDOM.unstable_batchedUpdates(c, v);
  } : c;
  return addDOMEventListener(a, s, d, u);
}
function contains$1(a, s) {
  for (var c = s; c; ) {
    if (c === a)
      return !0;
    c = c.parentNode;
  }
  return !1;
}
function buffer(a, s) {
  var c = void 0;
  function u() {
    c && (clearTimeout(c), c = null);
  }
  function d() {
    u(), c = setTimeout(a, s);
  }
  return d.clear = u, d;
}
function isSamePoint$1(a, s) {
  return a === s ? !0 : !a || !s ? !1 : "pageX" in s && "pageY" in s ? a.pageX === s.pageX && a.pageY === s.pageY : "clientX" in s && "clientY" in s ? a.clientX === s.clientX && a.clientY === s.clientY : !1;
}
function isWindow$1(a) {
  return a && typeof a == "object" && a.window === a;
}
function isSimilarValue(a, s) {
  var c = Math.floor(a), u = Math.floor(s);
  return Math.abs(c - u) <= 1;
}
function restoreFocus(a, s) {
  a !== document.activeElement && contains$1(s, a) && a.focus();
}
function getElement(a) {
  return typeof a != "function" || !a ? null : a();
}
function getPoint(a) {
  return typeof a != "object" || !a ? null : a;
}
var Align = function(a) {
  _inherits(s, a);
  function s() {
    var c, u, d, p;
    _classCallCheck(this, s);
    for (var v = arguments.length, A = Array(v), x = 0; x < v; x++)
      A[x] = arguments[x];
    return p = (u = (d = _possibleConstructorReturn(this, (c = s.__proto__ || Object.getPrototypeOf(s)).call.apply(c, [this].concat(A))), d), d.forceAlign = function() {
      var g = d.props, b = g.disabled, y = g.target, f = g.align, m = g.onAlign;
      if (!b && y) {
        var C = ReactDOM.findDOMNode(d), w = void 0, S = getElement(y), $ = getPoint(y), T = document.activeElement;
        S ? w = alignElement(C, S, f) : $ && (w = alignPoint(C, $, f)), restoreFocus(T, C), m && m(C, w);
      }
    }, u), _possibleConstructorReturn(d, p);
  }
  return _createClass(s, [{
    key: "componentDidMount",
    value: function() {
      var u = this.props;
      this.forceAlign(), !u.disabled && u.monitorWindowResize && this.startMonitorWindowResize();
    }
  }, {
    key: "componentDidUpdate",
    value: function(u) {
      var d = !1, p = this.props;
      if (!p.disabled) {
        var v = ReactDOM.findDOMNode(this), A = v ? v.getBoundingClientRect() : null;
        if (u.disabled)
          d = !0;
        else {
          var x = getElement(u.target), g = getElement(p.target), b = getPoint(u.target), y = getPoint(p.target);
          isWindow$1(x) && isWindow$1(g) ? d = !1 : (x !== g || // Element change
          x && !g && y || // Change from element to point
          b && y && g || // Change from point to element
          y && !isSamePoint$1(b, y)) && (d = !0);
          var f = this.sourceRect || {};
          !d && v && (!isSimilarValue(f.width, A.width) || !isSimilarValue(f.height, A.height)) && (d = !0);
        }
        this.sourceRect = A;
      }
      d && this.forceAlign(), p.monitorWindowResize && !p.disabled ? this.startMonitorWindowResize() : this.stopMonitorWindowResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: "startMonitorWindowResize",
    value: function() {
      this.resizeHandler || (this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime), this.resizeHandler = addEventListenerWrap(window, "resize", this.bufferMonitor));
    }
  }, {
    key: "stopMonitorWindowResize",
    value: function() {
      this.resizeHandler && (this.bufferMonitor.clear(), this.resizeHandler.remove(), this.resizeHandler = null);
    }
  }, {
    key: "render",
    value: function() {
      var u = this, d = this.props, p = d.childrenProps, v = d.children, A = React.Children.only(v);
      if (p) {
        var x = {}, g = Object.keys(p);
        return g.forEach(function(b) {
          x[b] = u.props[p[b]];
        }), React.cloneElement(A, x);
      }
      return A;
    }
  }]), s;
}(reactExports.Component);
Align.propTypes = {
  childrenProps: PropTypes.object,
  align: PropTypes.object.isRequired,
  target: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    clientX: PropTypes.number,
    clientY: PropTypes.number,
    pageX: PropTypes.number,
    pageY: PropTypes.number
  })]),
  onAlign: PropTypes.func,
  monitorBufferTime: PropTypes.number,
  monitorWindowResize: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.any
};
Align.defaultProps = {
  target: function a() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: !1,
  disabled: !1
};
var defineProperty = {}, hasRequiredDefineProperty;
function requireDefineProperty() {
  if (hasRequiredDefineProperty) return defineProperty;
  hasRequiredDefineProperty = 1, defineProperty.__esModule = !0;
  var a = requireDefineProperty$1(), s = c(a);
  function c(u) {
    return u && u.__esModule ? u : { default: u };
  }
  return defineProperty.default = function(u, d, p) {
    return d in u ? (0, s.default)(u, d, {
      value: p,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : u[d] = p, u;
  }, defineProperty;
}
var definePropertyExports = requireDefineProperty();
const _defineProperty$5 = /* @__PURE__ */ getDefaultExportFromCjs(definePropertyExports);
var unsafeLifecyclesPolyfill = function a(s) {
  var c = s.prototype;
  if (!c || !c.isReactComponent)
    throw new Error("Can only polyfill class components");
  return typeof c.componentWillReceiveProps != "function" || !React.Profiler || (c.UNSAFE_componentWillReceiveProps = c.componentWillReceiveProps, delete c.componentWillReceiveProps), s;
};
function toArrayChildren(a) {
  var s = [];
  return React.Children.forEach(a, function(c) {
    s.push(c);
  }), s;
}
function findChildInChildrenByKey(a, s) {
  var c = null;
  return a && a.forEach(function(u) {
    c || u && u.key === s && (c = u);
  }), c;
}
function findShownChildInChildrenByKey(a, s, c) {
  var u = null;
  return a && a.forEach(function(d) {
    if (d && d.key === s && d.props[c]) {
      if (u)
        throw new Error("two child with same key for <rc-animate> children");
      u = d;
    }
  }), u;
}
function isSameChildren(a, s, c) {
  var u = a.length === s.length;
  return u && a.forEach(function(d, p) {
    var v = s[p];
    d && v && (d && !v || !d && v || d.key !== v.key || c && d.props[c] !== v.props[c]) && (u = !1);
  }), u;
}
function mergeChildren(a, s) {
  var c = [], u = {}, d = [];
  return a.forEach(function(p) {
    p && findChildInChildrenByKey(s, p.key) ? d.length && (u[p.key] = d, d = []) : d.push(p);
  }), s.forEach(function(p) {
    p && Object.prototype.hasOwnProperty.call(u, p.key) && (c = c.concat(u[p.key])), c.push(p);
  }), c = c.concat(d), c;
}
var _typeofExports = require_typeof();
const _typeof$7 = /* @__PURE__ */ getDefaultExportFromCjs(_typeofExports);
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: "transitionstart",
    WebkitTransition: "webkitTransitionStart",
    MozTransition: "mozTransitionStart",
    OTransition: "oTransitionStart",
    msTransition: "MSTransitionStart"
  },
  animationstart: {
    animation: "animationstart",
    WebkitAnimation: "webkitAnimationStart",
    MozAnimation: "mozAnimationStart",
    OAnimation: "oAnimationStart",
    msAnimation: "MSAnimationStart"
  }
}, END_EVENT_NAME_MAP = {
  transitionend: {
    transition: "transitionend",
    WebkitTransition: "webkitTransitionEnd",
    MozTransition: "mozTransitionEnd",
    OTransition: "oTransitionEnd",
    msTransition: "MSTransitionEnd"
  },
  animationend: {
    animation: "animationend",
    WebkitAnimation: "webkitAnimationEnd",
    MozAnimation: "mozAnimationEnd",
    OAnimation: "oAnimationEnd",
    msAnimation: "MSAnimationEnd"
  }
}, startEvents = [], endEvents = [];
function detectEvents() {
  var a = document.createElement("div"), s = a.style;
  "AnimationEvent" in window || (delete START_EVENT_NAME_MAP.animationstart.animation, delete END_EVENT_NAME_MAP.animationend.animation), "TransitionEvent" in window || (delete START_EVENT_NAME_MAP.transitionstart.transition, delete END_EVENT_NAME_MAP.transitionend.transition);
  function c(u, d) {
    for (var p in u)
      if (u.hasOwnProperty(p)) {
        var v = u[p];
        for (var A in v)
          if (A in s) {
            d.push(v[A]);
            break;
          }
      }
  }
  c(START_EVENT_NAME_MAP, startEvents), c(END_EVENT_NAME_MAP, endEvents);
}
typeof window < "u" && typeof document < "u" && detectEvents();
function addEventListener$1(a, s, c) {
  a.addEventListener(s, c, !1);
}
function removeEventListener(a, s, c) {
  a.removeEventListener(s, c, !1);
}
var TransitionEvents = {
  // Start events
  startEvents,
  addStartEventListener: function a(s, c) {
    if (startEvents.length === 0) {
      window.setTimeout(c, 0);
      return;
    }
    startEvents.forEach(function(u) {
      addEventListener$1(s, u, c);
    });
  },
  removeStartEventListener: function a(s, c) {
    startEvents.length !== 0 && startEvents.forEach(function(u) {
      removeEventListener(s, u, c);
    });
  },
  // End events
  endEvents,
  addEndEventListener: function a(s, c) {
    if (endEvents.length === 0) {
      window.setTimeout(c, 0);
      return;
    }
    endEvents.forEach(function(u) {
      addEventListener$1(s, u, c);
    });
  },
  removeEndEventListener: function a(s, c) {
    endEvents.length !== 0 && endEvents.forEach(function(u) {
      removeEventListener(s, u, c);
    });
  }
}, componentIndexof, hasRequiredComponentIndexof;
function requireComponentIndexof() {
  return hasRequiredComponentIndexof || (hasRequiredComponentIndexof = 1, componentIndexof = function(a, s) {
    if (a.indexOf) return a.indexOf(s);
    for (var c = 0; c < a.length; ++c)
      if (a[c] === s) return c;
    return -1;
  }), componentIndexof;
}
var componentClasses, hasRequiredComponentClasses;
function requireComponentClasses() {
  if (hasRequiredComponentClasses) return componentClasses;
  hasRequiredComponentClasses = 1;
  try {
    var a = requireComponentIndexof();
  } catch {
    var a = requireComponentIndexof();
  }
  var s = /\s+/, c = Object.prototype.toString;
  componentClasses = function(d) {
    return new u(d);
  };
  function u(d) {
    if (!d || !d.nodeType)
      throw new Error("A DOM element reference is required");
    this.el = d, this.list = d.classList;
  }
  return u.prototype.add = function(d) {
    if (this.list)
      return this.list.add(d), this;
    var p = this.array(), v = a(p, d);
    return ~v || p.push(d), this.el.className = p.join(" "), this;
  }, u.prototype.remove = function(d) {
    if (c.call(d) == "[object RegExp]")
      return this.removeMatching(d);
    if (this.list)
      return this.list.remove(d), this;
    var p = this.array(), v = a(p, d);
    return ~v && p.splice(v, 1), this.el.className = p.join(" "), this;
  }, u.prototype.removeMatching = function(d) {
    for (var p = this.array(), v = 0; v < p.length; v++)
      d.test(p[v]) && this.remove(p[v]);
    return this;
  }, u.prototype.toggle = function(d, p) {
    return this.list ? (typeof p < "u" ? p !== this.list.toggle(d, p) && this.list.toggle(d) : this.list.toggle(d), this) : (typeof p < "u" ? p ? this.add(d) : this.remove(d) : this.has(d) ? this.remove(d) : this.add(d), this);
  }, u.prototype.array = function() {
    var d = this.el.getAttribute("class") || "", p = d.replace(/^\s+|\s+$/g, ""), v = p.split(s);
    return v[0] === "" && v.shift(), v;
  }, u.prototype.has = u.prototype.contains = function(d) {
    return this.list ? this.list.contains(d) : !!~a(this.array(), d);
  }, componentClasses;
}
var componentClassesExports = requireComponentClasses();
const classes = /* @__PURE__ */ getDefaultExportFromCjs(componentClassesExports);
var isCssAnimationSupported = TransitionEvents.endEvents.length !== 0, capitalPrefixes = [
  "Webkit",
  "Moz",
  "O",
  // ms is special .... !
  "ms"
], prefixes = ["-webkit-", "-moz-", "-o-", "ms-", ""];
function getStyleProperty(a, s) {
  for (var c = window.getComputedStyle(a, null), u = "", d = 0; d < prefixes.length && (u = c.getPropertyValue(prefixes[d] + s), !u); d++)
    ;
  return u;
}
function fixBrowserByTimeout(a) {
  if (isCssAnimationSupported) {
    var s = parseFloat(getStyleProperty(a, "transition-delay")) || 0, c = parseFloat(getStyleProperty(a, "transition-duration")) || 0, u = parseFloat(getStyleProperty(a, "animation-delay")) || 0, d = parseFloat(getStyleProperty(a, "animation-duration")) || 0, p = Math.max(c + s, d + u);
    a.rcEndAnimTimeout = setTimeout(function() {
      a.rcEndAnimTimeout = null, a.rcEndListener && a.rcEndListener();
    }, p * 1e3 + 200);
  }
}
function clearBrowserBugTimeout(a) {
  a.rcEndAnimTimeout && (clearTimeout(a.rcEndAnimTimeout), a.rcEndAnimTimeout = null);
}
var cssAnimation = function a(s, c, u) {
  var d = (typeof c > "u" ? "undefined" : _typeof$7(c)) === "object", p = d ? c.name : c, v = d ? c.active : c + "-active", A = u, x = void 0, g = void 0, b = classes(s);
  return u && Object.prototype.toString.call(u) === "[object Object]" && (A = u.end, x = u.start, g = u.active), s.rcEndListener && s.rcEndListener(), s.rcEndListener = function(y) {
    y && y.target !== s || (s.rcAnimTimeout && (clearTimeout(s.rcAnimTimeout), s.rcAnimTimeout = null), clearBrowserBugTimeout(s), b.remove(p), b.remove(v), TransitionEvents.removeEndEventListener(s, s.rcEndListener), s.rcEndListener = null, A && A());
  }, TransitionEvents.addEndEventListener(s, s.rcEndListener), x && x(), b.add(p), s.rcAnimTimeout = setTimeout(function() {
    s.rcAnimTimeout = null, b.add(v), g && setTimeout(g, 0), fixBrowserByTimeout(s);
  }, 30), {
    stop: function() {
      s.rcEndListener && s.rcEndListener();
    }
  };
};
cssAnimation.style = function(a, s, c) {
  a.rcEndListener && a.rcEndListener(), a.rcEndListener = function(u) {
    u && u.target !== a || (a.rcAnimTimeout && (clearTimeout(a.rcAnimTimeout), a.rcAnimTimeout = null), clearBrowserBugTimeout(a), TransitionEvents.removeEndEventListener(a, a.rcEndListener), a.rcEndListener = null, c && c());
  }, TransitionEvents.addEndEventListener(a, a.rcEndListener), a.rcAnimTimeout = setTimeout(function() {
    for (var u in s)
      s.hasOwnProperty(u) && (a.style[u] = s[u]);
    a.rcAnimTimeout = null, fixBrowserByTimeout(a);
  }, 0);
};
cssAnimation.setTransition = function(a, s, c) {
  var u = s, d = c;
  c === void 0 && (d = u, u = ""), u = u || "", capitalPrefixes.forEach(function(p) {
    a.style[p + "Transition" + u] = d;
  });
};
cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
var util = {
  isAppearSupported: function a(s) {
    return s.transitionName && s.transitionAppear || s.animation.appear;
  },
  isEnterSupported: function a(s) {
    return s.transitionName && s.transitionEnter || s.animation.enter;
  },
  isLeaveSupported: function a(s) {
    return s.transitionName && s.transitionLeave || s.animation.leave;
  },
  allowAppearCallback: function a(s) {
    return s.transitionAppear || s.animation.appear;
  },
  allowEnterCallback: function a(s) {
    return s.transitionEnter || s.animation.enter;
  },
  allowLeaveCallback: function a(s) {
    return s.transitionLeave || s.animation.leave;
  }
}, transitionMap = {
  enter: "transitionEnter",
  appear: "transitionAppear",
  leave: "transitionLeave"
}, AnimateChild = function(a) {
  _inherits(s, a);
  function s() {
    return _classCallCheck(this, s), _possibleConstructorReturn(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
  }
  return _createClass(s, [{
    key: "componentWillUnmount",
    value: function() {
      this.stop();
    }
  }, {
    key: "componentWillEnter",
    value: function(u) {
      util.isEnterSupported(this.props) ? this.transition("enter", u) : u();
    }
  }, {
    key: "componentWillAppear",
    value: function(u) {
      util.isAppearSupported(this.props) ? this.transition("appear", u) : u();
    }
  }, {
    key: "componentWillLeave",
    value: function(u) {
      util.isLeaveSupported(this.props) ? this.transition("leave", u) : u();
    }
  }, {
    key: "transition",
    value: function(u, d) {
      var p = this, v = ReactDOM.findDOMNode(this), A = this.props, x = A.transitionName, g = typeof x == "object";
      this.stop();
      var b = function() {
        p.stopper = null, d();
      };
      if ((isCssAnimationSupported || !A.animation[u]) && x && A[transitionMap[u]]) {
        var y = g ? x[u] : x + "-" + u, f = y + "-active";
        g && x[u + "Active"] && (f = x[u + "Active"]), this.stopper = cssAnimation(v, {
          name: y,
          active: f
        }, b);
      } else
        this.stopper = A.animation[u](v, b);
    }
  }, {
    key: "stop",
    value: function() {
      var u = this.stopper;
      u && (this.stopper = null, u.stop());
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), s;
}(React.Component);
AnimateChild.propTypes = {
  children: PropTypes.any,
  animation: PropTypes.any,
  transitionName: PropTypes.any
};
var defaultKey = "rc_animate_" + Date.now();
function getChildrenFromProps(a) {
  var s = a.children;
  return React.isValidElement(s) && !s.key ? React.cloneElement(s, {
    key: defaultKey
  }) : s;
}
function noop$1() {
}
var Animate = function(a) {
  _inherits(s, a);
  function s(c) {
    _classCallCheck(this, s);
    var u = _possibleConstructorReturn(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this, c));
    return _initialiseProps$1.call(u), u.currentlyAnimatingKeys = {}, u.keysToEnter = [], u.keysToLeave = [], u.state = {
      children: toArrayChildren(getChildrenFromProps(c))
    }, u.childrenRefs = {}, u;
  }
  return _createClass(s, [{
    key: "componentDidMount",
    value: function() {
      var u = this, d = this.props.showProp, p = this.state.children;
      d && (p = p.filter(function(v) {
        return !!v.props[d];
      })), p.forEach(function(v) {
        v && u.performAppear(v.key);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function(u) {
      var d = this;
      this.nextProps = u;
      var p = toArrayChildren(getChildrenFromProps(u)), v = this.props;
      v.exclusive && Object.keys(this.currentlyAnimatingKeys).forEach(function(y) {
        d.stop(y);
      });
      var A = v.showProp, x = this.currentlyAnimatingKeys, g = v.exclusive ? toArrayChildren(getChildrenFromProps(v)) : this.state.children, b = [];
      A ? (g.forEach(function(y) {
        var f = y && findChildInChildrenByKey(p, y.key), m = void 0;
        (!f || !f.props[A]) && y.props[A] ? m = React.cloneElement(f || y, _defineProperty$5({}, A, !0)) : m = f, m && b.push(m);
      }), p.forEach(function(y) {
        (!y || !findChildInChildrenByKey(g, y.key)) && b.push(y);
      })) : b = mergeChildren(g, p), this.setState({
        children: b
      }), p.forEach(function(y) {
        var f = y && y.key;
        if (!(y && x[f])) {
          var m = y && findChildInChildrenByKey(g, f);
          if (A) {
            var C = y.props[A];
            if (m) {
              var w = findShownChildInChildrenByKey(g, f, A);
              !w && C && d.keysToEnter.push(f);
            } else C && d.keysToEnter.push(f);
          } else m || d.keysToEnter.push(f);
        }
      }), g.forEach(function(y) {
        var f = y && y.key;
        if (!(y && x[f])) {
          var m = y && findChildInChildrenByKey(p, f);
          if (A) {
            var C = y.props[A];
            if (m) {
              var w = findShownChildInChildrenByKey(p, f, A);
              !w && C && d.keysToLeave.push(f);
            } else C && d.keysToLeave.push(f);
          } else m || d.keysToLeave.push(f);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var u = this.keysToEnter;
      this.keysToEnter = [], u.forEach(this.performEnter);
      var d = this.keysToLeave;
      this.keysToLeave = [], d.forEach(this.performLeave);
    }
  }, {
    key: "isValidChildByKey",
    value: function(u, d) {
      var p = this.props.showProp;
      return p ? findShownChildInChildrenByKey(u, d, p) : findChildInChildrenByKey(u, d);
    }
  }, {
    key: "stop",
    value: function(u) {
      delete this.currentlyAnimatingKeys[u];
      var d = this.childrenRefs[u];
      d && d.stop();
    }
  }, {
    key: "render",
    value: function() {
      var u = this, d = this.props;
      this.nextProps = d;
      var p = this.state.children, v = null;
      p && (v = p.map(function(g) {
        if (g == null)
          return g;
        if (!g.key)
          throw new Error("must set key for <rc-animate> children");
        return React.createElement(
          AnimateChild,
          {
            key: g.key,
            ref: function(y) {
              u.childrenRefs[g.key] = y;
            },
            animation: d.animation,
            transitionName: d.transitionName,
            transitionEnter: d.transitionEnter,
            transitionAppear: d.transitionAppear,
            transitionLeave: d.transitionLeave
          },
          g
        );
      }));
      var A = d.component;
      if (A) {
        var x = d;
        return typeof A == "string" && (x = _extends$1({
          className: d.className,
          style: d.style
        }, d.componentProps)), React.createElement(
          A,
          x,
          v
        );
      }
      return v[0] || null;
    }
  }]), s;
}(React.Component);
Animate.isAnimate = !0;
Animate.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  component: PropTypes.any,
  componentProps: PropTypes.object,
  animation: PropTypes.object,
  transitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  transitionEnter: PropTypes.bool,
  transitionAppear: PropTypes.bool,
  exclusive: PropTypes.bool,
  transitionLeave: PropTypes.bool,
  onEnd: PropTypes.func,
  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  onAppear: PropTypes.func,
  showProp: PropTypes.string,
  children: PropTypes.node
};
Animate.defaultProps = {
  animation: {},
  component: "span",
  componentProps: {},
  transitionEnter: !0,
  transitionLeave: !0,
  transitionAppear: !1,
  onEnd: noop$1,
  onEnter: noop$1,
  onLeave: noop$1,
  onAppear: noop$1
};
var _initialiseProps$1 = function a() {
  var s = this;
  this.performEnter = function(c) {
    s.childrenRefs[c] && (s.currentlyAnimatingKeys[c] = !0, s.childrenRefs[c].componentWillEnter(s.handleDoneAdding.bind(s, c, "enter")));
  }, this.performAppear = function(c) {
    s.childrenRefs[c] && (s.currentlyAnimatingKeys[c] = !0, s.childrenRefs[c].componentWillAppear(s.handleDoneAdding.bind(s, c, "appear")));
  }, this.handleDoneAdding = function(c, u) {
    var d = s.props;
    if (delete s.currentlyAnimatingKeys[c], !(d.exclusive && d !== s.nextProps)) {
      var p = toArrayChildren(getChildrenFromProps(d));
      s.isValidChildByKey(p, c) ? u === "appear" ? util.allowAppearCallback(d) && (d.onAppear(c), d.onEnd(c, !0)) : util.allowEnterCallback(d) && (d.onEnter(c), d.onEnd(c, !0)) : s.performLeave(c);
    }
  }, this.performLeave = function(c) {
    s.childrenRefs[c] && (s.currentlyAnimatingKeys[c] = !0, s.childrenRefs[c].componentWillLeave(s.handleDoneLeaving.bind(s, c)));
  }, this.handleDoneLeaving = function(c) {
    var u = s.props;
    if (delete s.currentlyAnimatingKeys[c], !(u.exclusive && u !== s.nextProps)) {
      var d = toArrayChildren(getChildrenFromProps(u));
      if (s.isValidChildByKey(d, c))
        s.performEnter(c);
      else {
        var p = function() {
          util.allowLeaveCallback(u) && (u.onLeave(c), u.onEnd(c, !1));
        };
        isSameChildren(s.state.children, d, u.showProp) ? p() : s.setState({
          children: d
        }, p);
      }
    }
  };
};
const Animate$1 = unsafeLifecyclesPolyfill(Animate);
var objectWithoutProperties$1 = {}, hasRequiredObjectWithoutProperties$1;
function requireObjectWithoutProperties$1() {
  return hasRequiredObjectWithoutProperties$1 || (hasRequiredObjectWithoutProperties$1 = 1, objectWithoutProperties$1.__esModule = !0, objectWithoutProperties$1.default = function(a, s) {
    var c = {};
    for (var u in a)
      s.indexOf(u) >= 0 || Object.prototype.hasOwnProperty.call(a, u) && (c[u] = a[u]);
    return c;
  }), objectWithoutProperties$1;
}
var objectWithoutPropertiesExports = requireObjectWithoutProperties$1();
const _objectWithoutProperties$1 = /* @__PURE__ */ getDefaultExportFromCjs(objectWithoutPropertiesExports);
var LazyRenderBox = function(a) {
  _inherits(s, a);
  function s() {
    return _classCallCheck(this, s), _possibleConstructorReturn(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
  }
  return _createClass(s, [{
    key: "shouldComponentUpdate",
    value: function(u) {
      return u.hiddenClassName || u.visible;
    }
  }, {
    key: "render",
    value: function() {
      var u = this.props, d = u.hiddenClassName, p = u.visible, v = _objectWithoutProperties$1(u, ["hiddenClassName", "visible"]);
      return d || React.Children.count(v.children) > 1 ? (!p && d && (v.className += " " + d), React.createElement("div", v)) : React.Children.only(v.children);
    }
  }]), s;
}(reactExports.Component);
LazyRenderBox.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  visible: PropTypes.bool,
  hiddenClassName: PropTypes.string
};
var PopupInner = function(a) {
  _inherits(s, a);
  function s() {
    return _classCallCheck(this, s), _possibleConstructorReturn(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
  }
  return _createClass(s, [{
    key: "render",
    value: function() {
      var u = this.props, d = u.className;
      return u.visible || (d += " " + u.hiddenClassName), React.createElement(
        "div",
        {
          className: d,
          onMouseEnter: u.onMouseEnter,
          onMouseLeave: u.onMouseLeave,
          style: u.style
        },
        React.createElement(
          LazyRenderBox,
          { className: u.prefixCls + "-content", visible: u.visible },
          u.children
        )
      );
    }
  }]), s;
}(reactExports.Component);
PopupInner.propTypes = {
  hiddenClassName: PropTypes.string,
  className: PropTypes.string,
  prefixCls: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.any
};
function isPointsEq(a, s) {
  return a[0] === s[0] && a[1] === s[1];
}
function getAlignFromPlacement(a, s, c) {
  var u = a[s] || {};
  return _extends$1({}, u, c);
}
function getPopupClassNameFromAlign(a, s, c) {
  var u = c.points;
  for (var d in a)
    if (a.hasOwnProperty(d) && isPointsEq(a[d].points, u))
      return s + "-placement-" + d;
  return "";
}
function saveRef(a, s) {
  this[a] = s;
}
var Popup = function(a) {
  _inherits(s, a);
  function s(c) {
    _classCallCheck(this, s);
    var u = _possibleConstructorReturn(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this, c));
    return _initialiseProps.call(u), u.savePopupRef = saveRef.bind(u, "popupInstance"), u.saveAlignRef = saveRef.bind(u, "alignInstance"), u;
  }
  return _createClass(s, [{
    key: "componentDidMount",
    value: function() {
      this.rootNode = this.getPopupDomNode();
    }
  }, {
    key: "getPopupDomNode",
    value: function() {
      return ReactDOM.findDOMNode(this.popupInstance);
    }
  }, {
    key: "getMaskTransitionName",
    value: function() {
      var u = this.props, d = u.maskTransitionName, p = u.maskAnimation;
      return !d && p && (d = u.prefixCls + "-" + p), d;
    }
  }, {
    key: "getTransitionName",
    value: function() {
      var u = this.props, d = u.transitionName;
      return !d && u.animation && (d = u.prefixCls + "-" + u.animation), d;
    }
  }, {
    key: "getClassName",
    value: function(u) {
      return this.props.prefixCls + " " + this.props.className + " " + u;
    }
  }, {
    key: "getPopupElement",
    value: function() {
      var u = this.savePopupRef, d = this.props, p = d.align, v = d.style, A = d.visible, x = d.prefixCls, g = d.destroyPopupOnHide, b = this.getClassName(this.currentAlignClassName || d.getClassNameFromAlign(p)), y = x + "-hidden";
      A || (this.currentAlignClassName = null);
      var f = _extends$1({}, v, this.getZIndexStyle()), m = {
        className: b,
        prefixCls: x,
        ref: u,
        onMouseEnter: d.onMouseEnter,
        onMouseLeave: d.onMouseLeave,
        style: f
      };
      return g ? React.createElement(
        Animate$1,
        {
          component: "",
          exclusive: !0,
          transitionAppear: !0,
          transitionName: this.getTransitionName()
        },
        A ? React.createElement(
          Align,
          {
            target: this.getTarget,
            key: "popup",
            ref: this.saveAlignRef,
            monitorWindowResize: !0,
            align: p,
            onAlign: this.onAlign
          },
          React.createElement(
            PopupInner,
            _extends$1({
              visible: !0
            }, m),
            d.children
          )
        ) : null
      ) : React.createElement(
        Animate$1,
        {
          component: "",
          exclusive: !0,
          transitionAppear: !0,
          transitionName: this.getTransitionName(),
          showProp: "xVisible"
        },
        React.createElement(
          Align,
          {
            target: this.getTarget,
            key: "popup",
            ref: this.saveAlignRef,
            monitorWindowResize: !0,
            xVisible: A,
            childrenProps: { visible: "xVisible" },
            disabled: !A,
            align: p,
            onAlign: this.onAlign
          },
          React.createElement(
            PopupInner,
            _extends$1({
              hiddenClassName: y
            }, m),
            d.children
          )
        )
      );
    }
  }, {
    key: "getZIndexStyle",
    value: function() {
      var u = {}, d = this.props;
      return d.zIndex !== void 0 && (u.zIndex = d.zIndex), u;
    }
  }, {
    key: "getMaskElement",
    value: function() {
      var u = this.props, d = void 0;
      if (u.mask) {
        var p = this.getMaskTransitionName();
        d = React.createElement(LazyRenderBox, {
          style: this.getZIndexStyle(),
          key: "mask",
          className: u.prefixCls + "-mask",
          hiddenClassName: u.prefixCls + "-mask-hidden",
          visible: u.visible
        }), p && (d = React.createElement(
          Animate$1,
          {
            key: "mask",
            showProp: "visible",
            transitionAppear: !0,
            component: "",
            transitionName: p
          },
          d
        ));
      }
      return d;
    }
  }, {
    key: "render",
    value: function() {
      return React.createElement(
        "div",
        null,
        this.getMaskElement(),
        this.getPopupElement()
      );
    }
  }]), s;
}(reactExports.Component);
Popup.propTypes = {
  visible: PropTypes.bool,
  style: PropTypes.object,
  getClassNameFromAlign: PropTypes.func,
  onAlign: PropTypes.func,
  getRootDomNode: PropTypes.func,
  onMouseEnter: PropTypes.func,
  align: PropTypes.any,
  destroyPopupOnHide: PropTypes.bool,
  className: PropTypes.string,
  prefixCls: PropTypes.string,
  onMouseLeave: PropTypes.func
};
var _initialiseProps = function a() {
  var s = this;
  this.onAlign = function(c, u) {
    var d = s.props, p = d.getClassNameFromAlign(u);
    s.currentAlignClassName !== p && (s.currentAlignClassName = p, c.className = s.getClassName(p)), d.onAlign(c, u);
  }, this.getTarget = function() {
    return s.props.getRootDomNode();
  };
}, getContainerRenderMixin$1 = {}, hasRequiredGetContainerRenderMixin;
function requireGetContainerRenderMixin() {
  if (hasRequiredGetContainerRenderMixin) return getContainerRenderMixin$1;
  hasRequiredGetContainerRenderMixin = 1, Object.defineProperty(getContainerRenderMixin$1, "__esModule", {
    value: !0
  }), getContainerRenderMixin$1.default = v;
  var a = s(requireReactDom());
  function s(A) {
    return A && A.__esModule ? A : { default: A };
  }
  function c(A, x) {
    var g = Object.keys(A);
    if (Object.getOwnPropertySymbols) {
      var b = Object.getOwnPropertySymbols(A);
      x && (b = b.filter(function(y) {
        return Object.getOwnPropertyDescriptor(A, y).enumerable;
      })), g.push.apply(g, b);
    }
    return g;
  }
  function u(A) {
    for (var x = 1; x < arguments.length; x++) {
      var g = arguments[x] != null ? arguments[x] : {};
      x % 2 ? c(Object(g), !0).forEach(function(b) {
        d(A, b, g[b]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(g)) : c(Object(g)).forEach(function(b) {
        Object.defineProperty(A, b, Object.getOwnPropertyDescriptor(g, b));
      });
    }
    return A;
  }
  function d(A, x, g) {
    return x in A ? Object.defineProperty(A, x, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : A[x] = g, A;
  }
  function p() {
    var A = document.createElement("div");
    return document.body.appendChild(A), A;
  }
  function v(A) {
    var x = A.autoMount, g = x === void 0 ? !0 : x, b = A.autoDestroy, y = b === void 0 ? !0 : b, f = A.isVisible, m = A.isForceRender, C = A.getComponent, w = A.getContainer, S = w === void 0 ? p : w, $;
    function T(_, E, R) {
      if (!f || _._component || f(_) || m && m(_)) {
        _._container || (_._container = S(_));
        var O;
        _.getComponent ? O = _.getComponent(E) : O = C(_, E), a.default.unstable_renderSubtreeIntoContainer(_, O, _._container, function() {
          _._component = this, R && R.call(this);
        });
      }
    }
    g && ($ = u(u({}, $), {}, {
      componentDidMount: function() {
        T(this);
      },
      componentDidUpdate: function() {
        T(this);
      }
    })), (!g || !y) && ($ = u(u({}, $), {}, {
      renderComponent: function(E, R) {
        T(this, E, R);
      }
    }));
    function I(_) {
      if (_._container) {
        var E = _._container;
        a.default.unmountComponentAtNode(E), E.parentNode.removeChild(E), _._container = null;
      }
    }
    return y ? $ = u(u({}, $), {}, {
      componentWillUnmount: function() {
        I(this);
      }
    }) : $ = u(u({}, $), {}, {
      removeContainer: function() {
        I(this);
      }
    }), $;
  }
  return getContainerRenderMixin$1;
}
var getContainerRenderMixinExports = requireGetContainerRenderMixin();
const getContainerRenderMixin = /* @__PURE__ */ getDefaultExportFromCjs(getContainerRenderMixinExports);
function noop() {
}
function returnEmptyString() {
  return "";
}
function returnDocument() {
  return window.document;
}
var isMobile = typeof navigator < "u" && !!navigator.userAgent.match(/(Android|iPhone|iPad|iPod|iOS|UCWEB)/i), ALL_HANDLERS = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"], Trigger = createReactClass({
  displayName: "Trigger",
  propTypes: {
    children: PropTypes.any,
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    showAction: PropTypes.any,
    hideAction: PropTypes.any,
    getPopupClassNameFromAlign: PropTypes.any,
    onPopupVisibleChange: PropTypes.func,
    afterPopupVisibleChange: PropTypes.func,
    popup: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    popupStyle: PropTypes.object,
    prefixCls: PropTypes.string,
    popupClassName: PropTypes.string,
    popupPlacement: PropTypes.string,
    builtinPlacements: PropTypes.object,
    popupTransitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    popupAnimation: PropTypes.any,
    mouseEnterDelay: PropTypes.number,
    mouseLeaveDelay: PropTypes.number,
    zIndex: PropTypes.number,
    focusDelay: PropTypes.number,
    blurDelay: PropTypes.number,
    getPopupContainer: PropTypes.func,
    getDocument: PropTypes.func,
    destroyPopupOnHide: PropTypes.bool,
    mask: PropTypes.bool,
    maskClosable: PropTypes.bool,
    onPopupAlign: PropTypes.func,
    popupAlign: PropTypes.object,
    popupVisible: PropTypes.bool,
    maskTransitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    maskAnimation: PropTypes.string
  },
  mixins: [getContainerRenderMixin({
    autoMount: !1,
    isVisible: function a(s) {
      return s.state.popupVisible;
    },
    getContainer: function a(s) {
      var c = s.props, u = document.createElement("div");
      u.style.position = "absolute", u.style.top = "0", u.style.left = "0", u.style.width = "100%";
      var d = c.getPopupContainer ? c.getPopupContainer(reactDomExports.findDOMNode(s)) : c.getDocument().body;
      return d.appendChild(u), u;
    }
  })],
  getDefaultProps: function a() {
    return {
      prefixCls: "rc-trigger-popup",
      getPopupClassNameFromAlign: returnEmptyString,
      getDocument: returnDocument,
      onPopupVisibleChange: noop,
      afterPopupVisibleChange: noop,
      onPopupAlign: noop,
      popupClassName: "",
      mouseEnterDelay: 0,
      mouseLeaveDelay: 0.1,
      focusDelay: 0,
      blurDelay: 0.15,
      popupStyle: {},
      destroyPopupOnHide: !1,
      popupAlign: {},
      defaultPopupVisible: !1,
      mask: !1,
      maskClosable: !0,
      action: [],
      showAction: [],
      hideAction: []
    };
  },
  getInitialState: function a() {
    var s = this.props, c = void 0;
    return "popupVisible" in s ? c = !!s.popupVisible : c = !!s.defaultPopupVisible, {
      popupVisible: c
    };
  },
  componentWillMount: function a() {
    var s = this;
    ALL_HANDLERS.forEach(function(c) {
      s["fire" + c] = function(u) {
        s.fireEvents(c, u);
      };
    });
  },
  componentDidMount: function a() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  },
  componentWillReceiveProps: function a(s) {
    var c = s.popupVisible;
    c !== void 0 && this.setState({
      popupVisible: c
    });
  },
  componentDidUpdate: function a(s, c) {
    var u = this.props, d = this.state;
    if (this.renderComponent(null, function() {
      c.popupVisible !== d.popupVisible && u.afterPopupVisibleChange(d.popupVisible);
    }), d.popupVisible) {
      var p = void 0;
      !this.clickOutsideHandler && this.isClickToHide() && (p = u.getDocument(), this.clickOutsideHandler = addEventListener$2(p, "mousedown", this.onDocumentClick)), !this.touchOutsideHandler && isMobile && (p = p || u.getDocument(), this.touchOutsideHandler = addEventListener$2(p, "click", this.onDocumentClick));
      return;
    }
    this.clearOutsideHandler();
  },
  componentWillUnmount: function a() {
    this.clearDelayTimer(), this.clearOutsideHandler();
  },
  onMouseEnter: function a(s) {
    this.fireEvents("onMouseEnter", s), this.delaySetPopupVisible(!0, this.props.mouseEnterDelay);
  },
  onMouseLeave: function a(s) {
    this.fireEvents("onMouseLeave", s), this.delaySetPopupVisible(!1, this.props.mouseLeaveDelay);
  },
  onPopupMouseEnter: function a() {
    this.clearDelayTimer();
  },
  onPopupMouseLeave: function a(s) {
    s.relatedTarget && !s.relatedTarget.setTimeout && this._component && this._component.getPopupDomNode && contains$2(this._component.getPopupDomNode(), s.relatedTarget) || this.delaySetPopupVisible(!1, this.props.mouseLeaveDelay);
  },
  onFocus: function a(s) {
    this.fireEvents("onFocus", s), this.clearDelayTimer(), this.isFocusToShow() && (this.focusTime = Date.now(), this.delaySetPopupVisible(!0, this.props.focusDelay));
  },
  onMouseDown: function a(s) {
    this.fireEvents("onMouseDown", s), this.preClickTime = Date.now();
  },
  onTouchStart: function a(s) {
    this.fireEvents("onTouchStart", s), this.preTouchTime = Date.now();
  },
  onBlur: function a(s) {
    this.fireEvents("onBlur", s), this.clearDelayTimer(), this.isBlurToHide() && this.delaySetPopupVisible(!1, this.props.blurDelay);
  },
  onClick: function a(s) {
    if (this.fireEvents("onClick", s), this.focusTime) {
      var c = void 0;
      if (this.preClickTime && this.preTouchTime ? c = Math.min(this.preClickTime, this.preTouchTime) : this.preClickTime ? c = this.preClickTime : this.preTouchTime && (c = this.preTouchTime), Math.abs(c - this.focusTime) < 20)
        return;
      this.focusTime = 0;
    }
    this.preClickTime = 0, this.preTouchTime = 0, s.preventDefault();
    var u = !this.state.popupVisible;
    (this.isClickToHide() && !u || u && this.isClickToShow()) && this.setPopupVisible(!this.state.popupVisible);
  },
  onDocumentClick: function a(s) {
    if (!(this.props.mask && !this.props.maskClosable)) {
      var c = s.target, u = reactDomExports.findDOMNode(this), d = this.getPopupDomNode();
      !contains$2(u, c) && !contains$2(d, c) && this.close();
    }
  },
  getPopupDomNode: function a() {
    return this._component && this._component.getPopupDomNode ? this._component.getPopupDomNode() : null;
  },
  getRootDomNode: function a() {
    return reactDomExports.findDOMNode(this);
  },
  getPopupClassNameFromAlign: function a(s) {
    var c = [], u = this.props, d = u.popupPlacement, p = u.builtinPlacements, v = u.prefixCls;
    return d && p && c.push(getPopupClassNameFromAlign(p, v, s)), u.getPopupClassNameFromAlign && c.push(u.getPopupClassNameFromAlign(s)), c.join(" ");
  },
  getPopupAlign: function a() {
    var s = this.props, c = s.popupPlacement, u = s.popupAlign, d = s.builtinPlacements;
    return c && d ? getAlignFromPlacement(d, c, u) : u;
  },
  getComponent: function a() {
    var s = this.props, c = this.state, u = {};
    return this.isMouseEnterToShow() && (u.onMouseEnter = this.onPopupMouseEnter), this.isMouseLeaveToHide() && (u.onMouseLeave = this.onPopupMouseLeave), React.createElement(
      Popup,
      _extends$1({
        prefixCls: s.prefixCls,
        destroyPopupOnHide: s.destroyPopupOnHide,
        visible: c.popupVisible,
        className: s.popupClassName,
        action: s.action,
        align: this.getPopupAlign(),
        onAlign: s.onPopupAlign,
        animation: s.popupAnimation,
        getClassNameFromAlign: this.getPopupClassNameFromAlign
      }, u, {
        getRootDomNode: this.getRootDomNode,
        style: s.popupStyle,
        mask: s.mask,
        zIndex: s.zIndex,
        transitionName: s.popupTransitionName,
        maskAnimation: s.maskAnimation,
        maskTransitionName: s.maskTransitionName
      }),
      typeof s.popup == "function" ? s.popup() : s.popup
    );
  },
  setPopupVisible: function a(s) {
    this.clearDelayTimer(), this.state.popupVisible !== s && ("popupVisible" in this.props || this.setState({
      popupVisible: s
    }), this.props.onPopupVisibleChange(s));
  },
  delaySetPopupVisible: function a(s, c) {
    var u = this, d = c * 1e3;
    this.clearDelayTimer(), d ? this.delayTimer = setTimeout(function() {
      u.setPopupVisible(s), u.clearDelayTimer();
    }, d) : this.setPopupVisible(s);
  },
  clearDelayTimer: function a() {
    this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
  },
  clearOutsideHandler: function a() {
    this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
  },
  createTwoChains: function a(s) {
    var c = this.props.children.props, u = this.props;
    return c[s] && u[s] ? this["fire" + s] : c[s] || u[s];
  },
  isClickToShow: function a() {
    var s = this.props, c = s.action, u = s.showAction;
    return c.indexOf("click") !== -1 || u.indexOf("click") !== -1;
  },
  isClickToHide: function a() {
    var s = this.props, c = s.action, u = s.hideAction;
    return c.indexOf("click") !== -1 || u.indexOf("click") !== -1;
  },
  isMouseEnterToShow: function a() {
    var s = this.props, c = s.action, u = s.showAction;
    return c.indexOf("hover") !== -1 || u.indexOf("mouseEnter") !== -1;
  },
  isMouseLeaveToHide: function a() {
    var s = this.props, c = s.action, u = s.hideAction;
    return c.indexOf("hover") !== -1 || u.indexOf("mouseLeave") !== -1;
  },
  isFocusToShow: function a() {
    var s = this.props, c = s.action, u = s.showAction;
    return c.indexOf("focus") !== -1 || u.indexOf("focus") !== -1;
  },
  isBlurToHide: function a() {
    var s = this.props, c = s.action, u = s.hideAction;
    return c.indexOf("focus") !== -1 || u.indexOf("blur") !== -1;
  },
  forcePopupAlign: function a() {
    this.state.popupVisible && this._component && this._component.alignInstance && this._component.alignInstance.forceAlign();
  },
  fireEvents: function a(s, c) {
    var u = this.props.children.props[s];
    u && u(c);
    var d = this.props[s];
    d && d(c);
  },
  close: function a() {
    this.setPopupVisible(!1);
  },
  render: function a() {
    var s = this.props, c = s.children, u = React.Children.only(c), d = {};
    return this.isClickToHide() || this.isClickToShow() ? (d.onClick = this.onClick, d.onMouseDown = this.onMouseDown, d.onTouchStart = this.onTouchStart) : (d.onClick = this.createTwoChains("onClick"), d.onMouseDown = this.createTwoChains("onMouseDown"), d.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? d.onMouseEnter = this.onMouseEnter : d.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? d.onMouseLeave = this.onMouseLeave : d.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (d.onFocus = this.onFocus, d.onBlur = this.onBlur) : (d.onFocus = this.createTwoChains("onFocus"), d.onBlur = this.createTwoChains("onBlur")), React.cloneElement(u, d);
  }
});
const es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Trigger
}, Symbol.toStringTag, { value: "Module" })), require$$3$1 = /* @__PURE__ */ getAugmentedNamespace(es);
var Panel$1 = { exports: {} }, color = { exports: {} }, tinycolor$1 = { exports: {} }, tinycolor = tinycolor$1.exports, hasRequiredTinycolor;
function requireTinycolor() {
  return hasRequiredTinycolor || (hasRequiredTinycolor = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(tinycolor, function() {
      function c(Q) {
        "@babel/helpers - typeof";
        return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(J) {
          return typeof J;
        } : function(J) {
          return J && typeof Symbol == "function" && J.constructor === Symbol && J !== Symbol.prototype ? "symbol" : typeof J;
        }, c(Q);
      }
      var u = /^\s+/, d = /\s+$/;
      function p(Q, J) {
        if (Q = Q || "", J = J || {}, Q instanceof p)
          return Q;
        if (!(this instanceof p))
          return new p(Q, J);
        var te = v(Q);
        this._originalInput = Q, this._r = te.r, this._g = te.g, this._b = te.b, this._a = te.a, this._roundA = Math.round(100 * this._a) / 100, this._format = J.format || te.format, this._gradientType = J.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = te.ok;
      }
      p.prototype = {
        isDark: function() {
          return this.getBrightness() < 128;
        },
        isLight: function() {
          return !this.isDark();
        },
        isValid: function() {
          return this._ok;
        },
        getOriginalInput: function() {
          return this._originalInput;
        },
        getFormat: function() {
          return this._format;
        },
        getAlpha: function() {
          return this._a;
        },
        getBrightness: function() {
          var J = this.toRgb();
          return (J.r * 299 + J.g * 587 + J.b * 114) / 1e3;
        },
        getLuminance: function() {
          var J = this.toRgb(), te, ae, se, ie, fe, ge;
          return te = J.r / 255, ae = J.g / 255, se = J.b / 255, te <= 0.03928 ? ie = te / 12.92 : ie = Math.pow((te + 0.055) / 1.055, 2.4), ae <= 0.03928 ? fe = ae / 12.92 : fe = Math.pow((ae + 0.055) / 1.055, 2.4), se <= 0.03928 ? ge = se / 12.92 : ge = Math.pow((se + 0.055) / 1.055, 2.4), 0.2126 * ie + 0.7152 * fe + 0.0722 * ge;
        },
        setAlpha: function(J) {
          return this._a = G(J), this._roundA = Math.round(100 * this._a) / 100, this;
        },
        toHsv: function() {
          var J = b(this._r, this._g, this._b);
          return {
            h: J.h * 360,
            s: J.s,
            v: J.v,
            a: this._a
          };
        },
        toHsvString: function() {
          var J = b(this._r, this._g, this._b), te = Math.round(J.h * 360), ae = Math.round(J.s * 100), se = Math.round(J.v * 100);
          return this._a == 1 ? "hsv(" + te + ", " + ae + "%, " + se + "%)" : "hsva(" + te + ", " + ae + "%, " + se + "%, " + this._roundA + ")";
        },
        toHsl: function() {
          var J = x(this._r, this._g, this._b);
          return {
            h: J.h * 360,
            s: J.s,
            l: J.l,
            a: this._a
          };
        },
        toHslString: function() {
          var J = x(this._r, this._g, this._b), te = Math.round(J.h * 360), ae = Math.round(J.s * 100), se = Math.round(J.l * 100);
          return this._a == 1 ? "hsl(" + te + ", " + ae + "%, " + se + "%)" : "hsla(" + te + ", " + ae + "%, " + se + "%, " + this._roundA + ")";
        },
        toHex: function(J) {
          return f(this._r, this._g, this._b, J);
        },
        toHexString: function(J) {
          return "#" + this.toHex(J);
        },
        toHex8: function(J) {
          return m(this._r, this._g, this._b, this._a, J);
        },
        toHex8String: function(J) {
          return "#" + this.toHex8(J);
        },
        toRgb: function() {
          return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
          };
        },
        toRgbString: function() {
          return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
          return {
            r: Math.round(U(this._r, 255) * 100) + "%",
            g: Math.round(U(this._g, 255) * 100) + "%",
            b: Math.round(U(this._b, 255) * 100) + "%",
            a: this._a
          };
        },
        toPercentageRgbString: function() {
          return this._a == 1 ? "rgb(" + Math.round(U(this._r, 255) * 100) + "%, " + Math.round(U(this._g, 255) * 100) + "%, " + Math.round(U(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(U(this._r, 255) * 100) + "%, " + Math.round(U(this._g, 255) * 100) + "%, " + Math.round(U(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
          return this._a === 0 ? "transparent" : this._a < 1 ? !1 : W[f(this._r, this._g, this._b, !0)] || !1;
        },
        toFilter: function(J) {
          var te = "#" + C(this._r, this._g, this._b, this._a), ae = te, se = this._gradientType ? "GradientType = 1, " : "";
          if (J) {
            var ie = p(J);
            ae = "#" + C(ie._r, ie._g, ie._b, ie._a);
          }
          return "progid:DXImageTransform.Microsoft.gradient(" + se + "startColorstr=" + te + ",endColorstr=" + ae + ")";
        },
        toString: function(J) {
          var te = !!J;
          J = J || this._format;
          var ae = !1, se = this._a < 1 && this._a >= 0, ie = !te && se && (J === "hex" || J === "hex6" || J === "hex3" || J === "hex4" || J === "hex8" || J === "name");
          return ie ? J === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (J === "rgb" && (ae = this.toRgbString()), J === "prgb" && (ae = this.toPercentageRgbString()), (J === "hex" || J === "hex6") && (ae = this.toHexString()), J === "hex3" && (ae = this.toHexString(!0)), J === "hex4" && (ae = this.toHex8String(!0)), J === "hex8" && (ae = this.toHex8String()), J === "name" && (ae = this.toName()), J === "hsl" && (ae = this.toHslString()), J === "hsv" && (ae = this.toHsvString()), ae || this.toHexString());
        },
        clone: function() {
          return p(this.toString());
        },
        _applyModification: function(J, te) {
          var ae = J.apply(null, [this].concat([].slice.call(te)));
          return this._r = ae._r, this._g = ae._g, this._b = ae._b, this.setAlpha(ae._a), this;
        },
        lighten: function() {
          return this._applyModification(T, arguments);
        },
        brighten: function() {
          return this._applyModification(I, arguments);
        },
        darken: function() {
          return this._applyModification(_, arguments);
        },
        desaturate: function() {
          return this._applyModification(w, arguments);
        },
        saturate: function() {
          return this._applyModification(S, arguments);
        },
        greyscale: function() {
          return this._applyModification($, arguments);
        },
        spin: function() {
          return this._applyModification(E, arguments);
        },
        _applyCombination: function(J, te) {
          return J.apply(null, [this].concat([].slice.call(te)));
        },
        analogous: function() {
          return this._applyCombination(B, arguments);
        },
        complement: function() {
          return this._applyCombination(R, arguments);
        },
        monochromatic: function() {
          return this._applyCombination(F, arguments);
        },
        splitcomplement: function() {
          return this._applyCombination(L, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function() {
          return this._applyCombination(O, [3]);
        },
        tetrad: function() {
          return this._applyCombination(O, [4]);
        }
      }, p.fromRatio = function(Q, J) {
        if (c(Q) == "object") {
          var te = {};
          for (var ae in Q)
            Q.hasOwnProperty(ae) && (ae === "a" ? te[ae] = Q[ae] : te[ae] = V(Q[ae]));
          Q = te;
        }
        return p(Q, J);
      };
      function v(Q) {
        var J = {
          r: 0,
          g: 0,
          b: 0
        }, te = 1, ae = null, se = null, ie = null, fe = !1, ge = !1;
        return typeof Q == "string" && (Q = Y(Q)), c(Q) == "object" && (q(Q.r) && q(Q.g) && q(Q.b) ? (J = A(Q.r, Q.g, Q.b), fe = !0, ge = String(Q.r).substr(-1) === "%" ? "prgb" : "rgb") : q(Q.h) && q(Q.s) && q(Q.v) ? (ae = V(Q.s), se = V(Q.v), J = y(Q.h, ae, se), fe = !0, ge = "hsv") : q(Q.h) && q(Q.s) && q(Q.l) && (ae = V(Q.s), ie = V(Q.l), J = g(Q.h, ae, ie), fe = !0, ge = "hsl"), Q.hasOwnProperty("a") && (te = Q.a)), te = G(te), {
          ok: fe,
          format: Q.format || ge,
          r: Math.min(255, Math.max(J.r, 0)),
          g: Math.min(255, Math.max(J.g, 0)),
          b: Math.min(255, Math.max(J.b, 0)),
          a: te
        };
      }
      function A(Q, J, te) {
        return {
          r: U(Q, 255) * 255,
          g: U(J, 255) * 255,
          b: U(te, 255) * 255
        };
      }
      function x(Q, J, te) {
        Q = U(Q, 255), J = U(J, 255), te = U(te, 255);
        var ae = Math.max(Q, J, te), se = Math.min(Q, J, te), ie, fe, ge = (ae + se) / 2;
        if (ae == se)
          ie = fe = 0;
        else {
          var me = ae - se;
          switch (fe = ge > 0.5 ? me / (2 - ae - se) : me / (ae + se), ae) {
            case Q:
              ie = (J - te) / me + (J < te ? 6 : 0);
              break;
            case J:
              ie = (te - Q) / me + 2;
              break;
            case te:
              ie = (Q - J) / me + 4;
              break;
          }
          ie /= 6;
        }
        return {
          h: ie,
          s: fe,
          l: ge
        };
      }
      function g(Q, J, te) {
        var ae, se, ie;
        Q = U(Q, 360), J = U(J, 100), te = U(te, 100);
        function fe(pe, be, le) {
          return le < 0 && (le += 1), le > 1 && (le -= 1), le < 1 / 6 ? pe + (be - pe) * 6 * le : le < 1 / 2 ? be : le < 2 / 3 ? pe + (be - pe) * (2 / 3 - le) * 6 : pe;
        }
        if (J === 0)
          ae = se = ie = te;
        else {
          var ge = te < 0.5 ? te * (1 + J) : te + J - te * J, me = 2 * te - ge;
          ae = fe(me, ge, Q + 1 / 3), se = fe(me, ge, Q), ie = fe(me, ge, Q - 1 / 3);
        }
        return {
          r: ae * 255,
          g: se * 255,
          b: ie * 255
        };
      }
      function b(Q, J, te) {
        Q = U(Q, 255), J = U(J, 255), te = U(te, 255);
        var ae = Math.max(Q, J, te), se = Math.min(Q, J, te), ie, fe, ge = ae, me = ae - se;
        if (fe = ae === 0 ? 0 : me / ae, ae == se)
          ie = 0;
        else {
          switch (ae) {
            case Q:
              ie = (J - te) / me + (J < te ? 6 : 0);
              break;
            case J:
              ie = (te - Q) / me + 2;
              break;
            case te:
              ie = (Q - J) / me + 4;
              break;
          }
          ie /= 6;
        }
        return {
          h: ie,
          s: fe,
          v: ge
        };
      }
      function y(Q, J, te) {
        Q = U(Q, 360) * 6, J = U(J, 100), te = U(te, 100);
        var ae = Math.floor(Q), se = Q - ae, ie = te * (1 - J), fe = te * (1 - se * J), ge = te * (1 - (1 - se) * J), me = ae % 6, pe = [te, fe, ie, ie, ge, te][me], be = [ge, te, te, fe, ie, ie][me], le = [ie, ie, ge, te, te, fe][me];
        return {
          r: pe * 255,
          g: be * 255,
          b: le * 255
        };
      }
      function f(Q, J, te, ae) {
        var se = [H(Math.round(Q).toString(16)), H(Math.round(J).toString(16)), H(Math.round(te).toString(16))];
        return ae && se[0].charAt(0) == se[0].charAt(1) && se[1].charAt(0) == se[1].charAt(1) && se[2].charAt(0) == se[2].charAt(1) ? se[0].charAt(0) + se[1].charAt(0) + se[2].charAt(0) : se.join("");
      }
      function m(Q, J, te, ae, se) {
        var ie = [H(Math.round(Q).toString(16)), H(Math.round(J).toString(16)), H(Math.round(te).toString(16)), H(Z(ae))];
        return se && ie[0].charAt(0) == ie[0].charAt(1) && ie[1].charAt(0) == ie[1].charAt(1) && ie[2].charAt(0) == ie[2].charAt(1) && ie[3].charAt(0) == ie[3].charAt(1) ? ie[0].charAt(0) + ie[1].charAt(0) + ie[2].charAt(0) + ie[3].charAt(0) : ie.join("");
      }
      function C(Q, J, te, ae) {
        var se = [H(Z(ae)), H(Math.round(Q).toString(16)), H(Math.round(J).toString(16)), H(Math.round(te).toString(16))];
        return se.join("");
      }
      p.equals = function(Q, J) {
        return !Q || !J ? !1 : p(Q).toRgbString() == p(J).toRgbString();
      }, p.random = function() {
        return p.fromRatio({
          r: Math.random(),
          g: Math.random(),
          b: Math.random()
        });
      };
      function w(Q, J) {
        J = J === 0 ? 0 : J || 10;
        var te = p(Q).toHsl();
        return te.s -= J / 100, te.s = k(te.s), p(te);
      }
      function S(Q, J) {
        J = J === 0 ? 0 : J || 10;
        var te = p(Q).toHsl();
        return te.s += J / 100, te.s = k(te.s), p(te);
      }
      function $(Q) {
        return p(Q).desaturate(100);
      }
      function T(Q, J) {
        J = J === 0 ? 0 : J || 10;
        var te = p(Q).toHsl();
        return te.l += J / 100, te.l = k(te.l), p(te);
      }
      function I(Q, J) {
        J = J === 0 ? 0 : J || 10;
        var te = p(Q).toRgb();
        return te.r = Math.max(0, Math.min(255, te.r - Math.round(255 * -(J / 100)))), te.g = Math.max(0, Math.min(255, te.g - Math.round(255 * -(J / 100)))), te.b = Math.max(0, Math.min(255, te.b - Math.round(255 * -(J / 100)))), p(te);
      }
      function _(Q, J) {
        J = J === 0 ? 0 : J || 10;
        var te = p(Q).toHsl();
        return te.l -= J / 100, te.l = k(te.l), p(te);
      }
      function E(Q, J) {
        var te = p(Q).toHsl(), ae = (te.h + J) % 360;
        return te.h = ae < 0 ? 360 + ae : ae, p(te);
      }
      function R(Q) {
        var J = p(Q).toHsl();
        return J.h = (J.h + 180) % 360, p(J);
      }
      function O(Q, J) {
        if (isNaN(J) || J <= 0)
          throw new Error("Argument to polyad must be a positive number");
        for (var te = p(Q).toHsl(), ae = [p(Q)], se = 360 / J, ie = 1; ie < J; ie++)
          ae.push(p({
            h: (te.h + ie * se) % 360,
            s: te.s,
            l: te.l
          }));
        return ae;
      }
      function L(Q) {
        var J = p(Q).toHsl(), te = J.h;
        return [p(Q), p({
          h: (te + 72) % 360,
          s: J.s,
          l: J.l
        }), p({
          h: (te + 216) % 360,
          s: J.s,
          l: J.l
        })];
      }
      function B(Q, J, te) {
        J = J || 6, te = te || 30;
        var ae = p(Q).toHsl(), se = 360 / te, ie = [p(Q)];
        for (ae.h = (ae.h - (se * J >> 1) + 720) % 360; --J; )
          ae.h = (ae.h + se) % 360, ie.push(p(ae));
        return ie;
      }
      function F(Q, J) {
        J = J || 6;
        for (var te = p(Q).toHsv(), ae = te.h, se = te.s, ie = te.v, fe = [], ge = 1 / J; J--; )
          fe.push(p({
            h: ae,
            s: se,
            v: ie
          })), ie = (ie + ge) % 1;
        return fe;
      }
      p.mix = function(Q, J, te) {
        te = te === 0 ? 0 : te || 50;
        var ae = p(Q).toRgb(), se = p(J).toRgb(), ie = te / 100, fe = {
          r: (se.r - ae.r) * ie + ae.r,
          g: (se.g - ae.g) * ie + ae.g,
          b: (se.b - ae.b) * ie + ae.b,
          a: (se.a - ae.a) * ie + ae.a
        };
        return p(fe);
      }, p.readability = function(Q, J) {
        var te = p(Q), ae = p(J);
        return (Math.max(te.getLuminance(), ae.getLuminance()) + 0.05) / (Math.min(te.getLuminance(), ae.getLuminance()) + 0.05);
      }, p.isReadable = function(Q, J, te) {
        var ae = p.readability(Q, J), se, ie;
        switch (ie = !1, se = ee(te), se.level + se.size) {
          case "AAsmall":
          case "AAAlarge":
            ie = ae >= 4.5;
            break;
          case "AAlarge":
            ie = ae >= 3;
            break;
          case "AAAsmall":
            ie = ae >= 7;
            break;
        }
        return ie;
      }, p.mostReadable = function(Q, J, te) {
        var ae = null, se = 0, ie, fe, ge, me;
        te = te || {}, fe = te.includeFallbackColors, ge = te.level, me = te.size;
        for (var pe = 0; pe < J.length; pe++)
          ie = p.readability(Q, J[pe]), ie > se && (se = ie, ae = p(J[pe]));
        return p.isReadable(Q, ae, {
          level: ge,
          size: me
        }) || !fe ? ae : (te.includeFallbackColors = !1, p.mostReadable(Q, ["#fff", "#000"], te));
      };
      var M = p.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
      }, W = p.hexNames = j(M);
      function j(Q) {
        var J = {};
        for (var te in Q)
          Q.hasOwnProperty(te) && (J[Q[te]] = te);
        return J;
      }
      function G(Q) {
        return Q = parseFloat(Q), (isNaN(Q) || Q < 0 || Q > 1) && (Q = 1), Q;
      }
      function U(Q, J) {
        P(Q) && (Q = "100%");
        var te = D(Q);
        return Q = Math.min(J, Math.max(0, parseFloat(Q))), te && (Q = parseInt(Q * J, 10) / 100), Math.abs(Q - J) < 1e-6 ? 1 : Q % J / parseFloat(J);
      }
      function k(Q) {
        return Math.min(1, Math.max(0, Q));
      }
      function N(Q) {
        return parseInt(Q, 16);
      }
      function P(Q) {
        return typeof Q == "string" && Q.indexOf(".") != -1 && parseFloat(Q) === 1;
      }
      function D(Q) {
        return typeof Q == "string" && Q.indexOf("%") != -1;
      }
      function H(Q) {
        return Q.length == 1 ? "0" + Q : "" + Q;
      }
      function V(Q) {
        return Q <= 1 && (Q = Q * 100 + "%"), Q;
      }
      function Z(Q) {
        return Math.round(parseFloat(Q) * 255).toString(16);
      }
      function ne(Q) {
        return N(Q) / 255;
      }
      var K = function() {
        var Q = "[-\\+]?\\d+%?", J = "[-\\+]?\\d*\\.\\d+%?", te = "(?:" + J + ")|(?:" + Q + ")", ae = "[\\s|\\(]+(" + te + ")[,|\\s]+(" + te + ")[,|\\s]+(" + te + ")\\s*\\)?", se = "[\\s|\\(]+(" + te + ")[,|\\s]+(" + te + ")[,|\\s]+(" + te + ")[,|\\s]+(" + te + ")\\s*\\)?";
        return {
          CSS_UNIT: new RegExp(te),
          rgb: new RegExp("rgb" + ae),
          rgba: new RegExp("rgba" + se),
          hsl: new RegExp("hsl" + ae),
          hsla: new RegExp("hsla" + se),
          hsv: new RegExp("hsv" + ae),
          hsva: new RegExp("hsva" + se),
          hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
      }();
      function q(Q) {
        return !!K.CSS_UNIT.exec(Q);
      }
      function Y(Q) {
        Q = Q.replace(u, "").replace(d, "").toLowerCase();
        var J = !1;
        if (M[Q])
          Q = M[Q], J = !0;
        else if (Q == "transparent")
          return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
          };
        var te;
        return (te = K.rgb.exec(Q)) ? {
          r: te[1],
          g: te[2],
          b: te[3]
        } : (te = K.rgba.exec(Q)) ? {
          r: te[1],
          g: te[2],
          b: te[3],
          a: te[4]
        } : (te = K.hsl.exec(Q)) ? {
          h: te[1],
          s: te[2],
          l: te[3]
        } : (te = K.hsla.exec(Q)) ? {
          h: te[1],
          s: te[2],
          l: te[3],
          a: te[4]
        } : (te = K.hsv.exec(Q)) ? {
          h: te[1],
          s: te[2],
          v: te[3]
        } : (te = K.hsva.exec(Q)) ? {
          h: te[1],
          s: te[2],
          v: te[3],
          a: te[4]
        } : (te = K.hex8.exec(Q)) ? {
          r: N(te[1]),
          g: N(te[2]),
          b: N(te[3]),
          a: ne(te[4]),
          format: J ? "name" : "hex8"
        } : (te = K.hex6.exec(Q)) ? {
          r: N(te[1]),
          g: N(te[2]),
          b: N(te[3]),
          format: J ? "name" : "hex"
        } : (te = K.hex4.exec(Q)) ? {
          r: N(te[1] + "" + te[1]),
          g: N(te[2] + "" + te[2]),
          b: N(te[3] + "" + te[3]),
          a: ne(te[4] + "" + te[4]),
          format: J ? "name" : "hex8"
        } : (te = K.hex3.exec(Q)) ? {
          r: N(te[1] + "" + te[1]),
          g: N(te[2] + "" + te[2]),
          b: N(te[3] + "" + te[3]),
          format: J ? "name" : "hex"
        } : !1;
      }
      function ee(Q) {
        var J, te;
        return Q = Q || {
          level: "AA",
          size: "small"
        }, J = (Q.level || "AA").toUpperCase(), te = (Q.size || "small").toLowerCase(), J !== "AA" && J !== "AAA" && (J = "AA"), te !== "small" && te !== "large" && (te = "small"), {
          level: J,
          size: te
        };
      }
      return p;
    });
  }(tinycolor$1)), tinycolor$1.exports;
}
var hasRequiredColor;
function requireColor() {
  return hasRequiredColor || (hasRequiredColor = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = Object.assign || function(g) {
      for (var b = 1; b < arguments.length; b++) {
        var y = arguments[b];
        for (var f in y)
          Object.prototype.hasOwnProperty.call(y, f) && (g[f] = y[f]);
      }
      return g;
    }, u = /* @__PURE__ */ function() {
      function g(b, y) {
        for (var f = 0; f < y.length; f++) {
          var m = y[f];
          m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(b, m.key, m);
        }
      }
      return function(b, y, f) {
        return y && g(b.prototype, y), f && g(b, f), b;
      };
    }(), d = requireTinycolor(), p = v(d);
    function v(g) {
      return g && g.__esModule ? g : { default: g };
    }
    function A(g, b) {
      if (!(g instanceof b))
        throw new TypeError("Cannot call a class as a function");
    }
    var x = function() {
      function g(b) {
        var y = this;
        A(this, g), this.initRgb = function() {
          var m = y.color.toRgb(), C = m.r, w = m.g, S = m.b;
          y.redValue = C, y.greenValue = w, y.blueValue = S;
        }, this.initHsb = function() {
          var m = y.color.toHsv(), C = m.h, w = m.s, S = m.v;
          y.hueValue = C, y.saturationValue = w, y.brightnessValue = S;
        }, this.toHexString = function() {
          return y.color.toHexString();
        }, this.toRgbString = function() {
          return y.color.toRgbString();
        }, this.color = (0, p.default)(b), this.initRgb(), this.initHsb();
        var f = b && b.alpha || this.color.toRgb().a;
        this.alphaValue = Math.min(1, f) * 100;
      }
      return g.isValidHex = function(y) {
        return (0, p.default)(y).isValid();
      }, u(g, [{
        key: "hex",
        get: function() {
          return this.color.toHex();
        }
        // 色调
      }, {
        key: "hue",
        set: function(y) {
          this.color = (0, p.default)({
            h: y,
            s: this.saturation,
            v: this.brightness
          }), this.initRgb(), this.hueValue = y;
        },
        get: function() {
          return this.hueValue;
        }
        // 饱和度
      }, {
        key: "saturation",
        set: function(y) {
          this.color = (0, p.default)({
            h: this.hue,
            s: y,
            v: this.brightness
          }), this.initRgb(), this.saturationValue = y;
        },
        get: function() {
          return this.saturationValue;
        }
        // 亮度
      }, {
        key: "lightness",
        set: function(y) {
          this.color = (0, p.default)({
            h: this.hue,
            s: this.saturation,
            l: y
          }), this.initRgb(), this.lightnessValue = y;
        },
        get: function() {
          return this.lightnessValue;
        }
      }, {
        key: "brightness",
        set: function(y) {
          this.color = (0, p.default)({
            h: this.hue,
            s: this.saturation,
            v: y
          }), this.initRgb(), this.brightnessValue = y;
        },
        get: function() {
          return this.brightnessValue;
        }
        // red
      }, {
        key: "red",
        set: function(y) {
          var f = this.color.toRgb();
          this.color = (0, p.default)(c({}, f, {
            r: y
          })), this.initHsb(), this.redValue = y;
        },
        get: function() {
          return this.redValue;
        }
        // green
      }, {
        key: "green",
        set: function(y) {
          var f = this.color.toRgb();
          this.color = (0, p.default)(c({}, f, {
            g: y
          })), this.initHsb(), this.greenValue = y;
        },
        get: function() {
          return this.greenValue;
        }
        // blue
      }, {
        key: "blue",
        set: function(y) {
          var f = this.color.toRgb();
          this.color = (0, p.default)(c({}, f, {
            b: y
          })), this.initHsb(), this.blueValue = y;
        },
        get: function() {
          return this.blueValue;
        }
        // alpha
      }, {
        key: "alpha",
        set: function(y) {
          this.color.setAlpha(y / 100);
        },
        get: function() {
          return this.color.getAlpha() * 100;
        }
      }, {
        key: "RGB",
        get: function() {
          return [this.red, this.green, this.blue];
        }
      }, {
        key: "HSB",
        get: function() {
          return [this.hue, this.saturation, this.brightness];
        }
      }]), g;
    }();
    s.default = x, a.exports = s.default;
  }(color, color.exports)), color.exports;
}
var Board = { exports: {} }, addEventListener = {}, hasRequiredAddEventListener;
function requireAddEventListener() {
  if (hasRequiredAddEventListener) return addEventListener;
  hasRequiredAddEventListener = 1, Object.defineProperty(addEventListener, "__esModule", {
    value: !0
  }), addEventListener.default = u;
  var a = c(requireLib$1()), s = c(requireReactDom());
  function c(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function u(d, p, v, A) {
    var x = s.default.unstable_batchedUpdates ? function(b) {
      s.default.unstable_batchedUpdates(v, b);
    } : v;
    return (0, a.default)(d, p, x, A);
  }
  return addEventListener;
}
var hasRequiredBoard;
function requireBoard() {
  return hasRequiredBoard || (hasRequiredBoard = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = requireReact(), u = f(c), d = requireReactDom(), p = f(d), v = /* @__PURE__ */ requirePropTypes(), A = f(v), x = requireAddEventListener(), g = f(x), b = requireColor(), y = f(b);
    function f(_) {
      return _ && _.__esModule ? _ : { default: _ };
    }
    function m(_, E) {
      for (var R = Object.getOwnPropertyNames(E), O = 0; O < R.length; O++) {
        var L = R[O], B = Object.getOwnPropertyDescriptor(E, L);
        B && B.configurable && _[L] === void 0 && Object.defineProperty(_, L, B);
      }
      return _;
    }
    function C(_, E) {
      if (!(_ instanceof E))
        throw new TypeError("Cannot call a class as a function");
    }
    function w(_, E) {
      if (!_)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return E && (typeof E == "object" || typeof E == "function") ? E : _;
    }
    function S(_, E) {
      if (typeof E != "function" && E !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof E);
      _.prototype = Object.create(E && E.prototype, { constructor: { value: _, enumerable: !1, writable: !0, configurable: !0 } }), E && (Object.setPrototypeOf ? Object.setPrototypeOf(_, E) : m(_, E));
    }
    var $ = 200, T = 150, I = function(_) {
      S(E, _);
      function E(R) {
        C(this, E);
        var O = w(this, _.call(this, R));
        return O.onBoardMouseDown = function(L) {
          var B = L.buttons;
          if (B === 1) {
            var F = L.clientX, M = L.clientY;
            O.pointMoveTo({
              x: F,
              y: M
            }), O.removeListeners(), O.dragListener = (0, g.default)(window, "mousemove", O.onBoardDrag), O.dragUpListener = (0, g.default)(window, "mouseup", O.onBoardDragEnd);
          }
        }, O.onBoardTouchStart = function(L) {
          if (L.touches.length === 1) {
            O.removeTouchListeners();
            var B = L.targetTouches[0].clientX, F = L.targetTouches[0].clientY;
            O.pointMoveTo({
              x: B,
              y: F
            }), O.touchMoveListener = (0, g.default)(window, "touchmove", O.onBoardTouchMove), O.touchEndListener = (0, g.default)(window, "touchend", O.onBoardTouchEnd);
          }
        }, O.onBoardTouchMove = function(L) {
          L.preventDefault && L.preventDefault();
          var B = L.targetTouches[0].clientX, F = L.targetTouches[0].clientY;
          O.pointMoveTo({
            x: B,
            y: F
          });
        }, O.onBoardTouchEnd = function() {
          O.removeTouchListeners();
        }, O.onBoardDrag = function(L) {
          var B = L.clientX, F = L.clientY;
          O.pointMoveTo({
            x: B,
            y: F
          });
        }, O.onBoardDragEnd = function(L) {
          var B = L.clientX, F = L.clientY;
          O.pointMoveTo({
            x: B,
            y: F
          }), O.removeListeners();
        }, O.getPrefixCls = function() {
          return O.props.rootPrefixCls + "-board";
        }, O.removeTouchListeners = function() {
          O.touchMoveListener && (O.touchMoveListener.remove(), O.touchMoveListener = null), O.touchEndListener && (O.touchEndListener.remove(), O.touchEndListener = null);
        }, O.removeListeners = function() {
          O.dragListener && (O.dragListener.remove(), O.dragListener = null), O.dragUpListener && (O.dragUpListener.remove(), O.dragUpListener = null);
        }, O.pointMoveTo = function(L) {
          var B = p.default.findDOMNode(O).getBoundingClientRect(), F = L.x - B.left, M = L.y - B.top, W = B.width || $, j = B.height || T;
          F = Math.max(0, F), F = Math.min(F, W), M = Math.max(0, M), M = Math.min(M, j);
          var G = O.props.color;
          G.saturation = F / W, G.brightness = 1 - M / j, O.props.onChange(G);
        }, O;
      }
      return E.prototype.componentWillUnmount = function() {
        this.removeListeners(), this.removeTouchListeners();
      }, E.prototype.render = function() {
        var O = this.getPrefixCls(), L = this.props.color, B = {
          h: L.hue,
          s: 1,
          v: 1
        }, F = new y.default(B).toHexString(), M = L.saturation * 100, W = (1 - L.brightness) * 100;
        return u.default.createElement(
          "div",
          { className: O },
          u.default.createElement(
            "div",
            { className: O + "-hsv", style: { backgroundColor: F } },
            u.default.createElement("div", { className: O + "-value" }),
            u.default.createElement("div", { className: O + "-saturation" })
          ),
          u.default.createElement("span", { style: { left: M + "%", top: W + "%" } }),
          u.default.createElement("div", {
            className: O + "-handler",
            onMouseDown: this.onBoardMouseDown,
            onTouchStart: this.onBoardTouchStart
          })
        );
      }, E;
    }(u.default.Component);
    s.default = I, I.propTypes = {
      color: A.default.object,
      onChange: A.default.func,
      rootPrefixCls: A.default.string
    }, a.exports = s.default;
  }(Board, Board.exports)), Board.exports;
}
var Preview$1 = { exports: {} }, hasRequiredPreview;
function requirePreview() {
  return hasRequiredPreview || (hasRequiredPreview = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = requireReact(), u = x(c), d = /* @__PURE__ */ requirePropTypes(), p = x(d), v = requireColor(), A = x(v);
    function x(C) {
      return C && C.__esModule ? C : { default: C };
    }
    function g(C, w) {
      for (var S = Object.getOwnPropertyNames(w), $ = 0; $ < S.length; $++) {
        var T = S[$], I = Object.getOwnPropertyDescriptor(w, T);
        I && I.configurable && C[T] === void 0 && Object.defineProperty(C, T, I);
      }
      return C;
    }
    function b(C, w) {
      if (!(C instanceof w))
        throw new TypeError("Cannot call a class as a function");
    }
    function y(C, w) {
      if (!C)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return w && (typeof w == "object" || typeof w == "function") ? w : C;
    }
    function f(C, w) {
      if (typeof w != "function" && w !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof w);
      C.prototype = Object.create(w && w.prototype, { constructor: { value: C, enumerable: !1, writable: !0, configurable: !0 } }), w && (Object.setPrototypeOf ? Object.setPrototypeOf(C, w) : g(C, w));
    }
    var m = function(C) {
      f(w, C);
      function w() {
        var S, $, T;
        b(this, w);
        for (var I = arguments.length, _ = Array(I), E = 0; E < I; E++)
          _[E] = arguments[E];
        return T = (S = ($ = y(this, C.call.apply(C, [this].concat(_))), $), $.onChange = function(R) {
          var O = R.target.value, L = new A.default(O);
          $.props.onChange(L), R.stopPropagation();
        }, $.getPrefixCls = function() {
          return $.props.rootPrefixCls + "-preview";
        }, S), y($, T);
      }
      return w.prototype.render = function() {
        var $ = this.getPrefixCls(), T = this.props.color.toHexString();
        return u.default.createElement(
          "div",
          { className: $ },
          u.default.createElement("span", {
            style: {
              backgroundColor: T,
              opacity: this.props.alpha / 100
            }
          }),
          u.default.createElement("input", {
            type: "color",
            value: T,
            onChange: this.onChange,
            onClick: this.props.onInputClick
          })
        );
      }, w;
    }(u.default.Component);
    s.default = m, m.propTypes = {
      rootPrefixCls: p.default.string,
      color: p.default.object,
      alpha: p.default.number,
      onChange: p.default.func,
      onInputClick: p.default.func
    }, a.exports = s.default;
  }(Preview$1, Preview$1.exports)), Preview$1.exports;
}
var Ribbon = { exports: {} }, hasRequiredRibbon;
function requireRibbon() {
  return hasRequiredRibbon || (hasRequiredRibbon = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = requireReact(), u = b(c), d = requireReactDom(), p = b(d), v = /* @__PURE__ */ requirePropTypes(), A = b(v), x = requireAddEventListener(), g = b(x);
    function b(S) {
      return S && S.__esModule ? S : { default: S };
    }
    function y(S, $) {
      for (var T = Object.getOwnPropertyNames($), I = 0; I < T.length; I++) {
        var _ = T[I], E = Object.getOwnPropertyDescriptor($, _);
        E && E.configurable && S[_] === void 0 && Object.defineProperty(S, _, E);
      }
      return S;
    }
    function f(S, $) {
      if (!(S instanceof $))
        throw new TypeError("Cannot call a class as a function");
    }
    function m(S, $) {
      if (!S)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return $ && (typeof $ == "object" || typeof $ == "function") ? $ : S;
    }
    function C(S, $) {
      if (typeof $ != "function" && $ !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof $);
      S.prototype = Object.create($ && $.prototype, { constructor: { value: S, enumerable: !1, writable: !0, configurable: !0 } }), $ && (Object.setPrototypeOf ? Object.setPrototypeOf(S, $) : y(S, $));
    }
    var w = function(S) {
      C($, S);
      function $(T) {
        f(this, $);
        var I = m(this, S.call(this, T));
        return I.onMouseDown = function(_) {
          var E = _.clientX, R = _.clientY;
          I.pointMoveTo({
            x: E,
            y: R
          }), I.dragListener = (0, g.default)(window, "mousemove", I.onDrag), I.dragUpListener = (0, g.default)(window, "mouseup", I.onDragEnd);
        }, I.onDrag = function(_) {
          var E = _.clientX, R = _.clientY;
          I.pointMoveTo({
            x: E,
            y: R
          });
        }, I.onDragEnd = function(_) {
          var E = _.clientX, R = _.clientY;
          I.pointMoveTo({
            x: E,
            y: R
          }), I.removeListeners();
        }, I.getPrefixCls = function() {
          return I.props.rootPrefixCls + "-ribbon";
        }, I.pointMoveTo = function(_) {
          var E = p.default.findDOMNode(I).getBoundingClientRect(), R = E.width, O = _.x - E.left;
          O = Math.max(0, O), O = Math.min(O, R);
          var L = O / R, B = L * 360, F = I.props.color;
          F.hue = B, I.props.onChange(F);
        }, I.removeListeners = function() {
          I.dragListener && (I.dragListener.remove(), I.dragListener = null), I.dragUpListener && (I.dragUpListener.remove(), I.dragUpListener = null);
        }, I;
      }
      return $.prototype.componentWillUnmount = function() {
        this.removeListeners();
      }, $.prototype.render = function() {
        var I = this.getPrefixCls(), _ = this.props.color.hue, E = _ / 360 * 100;
        return u.default.createElement(
          "div",
          { className: I },
          u.default.createElement("span", { ref: "point", style: { left: E + "%" } }),
          u.default.createElement("div", { className: I + "-handler", onMouseDown: this.onMouseDown })
        );
      }, $;
    }(u.default.Component);
    s.default = w, w.propTypes = {
      rootPrefixCls: A.default.string,
      color: A.default.object,
      onChange: A.default.func
    }, a.exports = s.default;
  }(Ribbon, Ribbon.exports)), Ribbon.exports;
}
var Alpha = { exports: {} }, hasRequiredAlpha;
function requireAlpha() {
  return hasRequiredAlpha || (hasRequiredAlpha = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = requireReact(), u = g(c), d = requireReactDom(), p = /* @__PURE__ */ requirePropTypes(), v = g(p), A = requireAddEventListener(), x = g(A);
    function g(S) {
      return S && S.__esModule ? S : { default: S };
    }
    function b(S, $) {
      for (var T = Object.getOwnPropertyNames($), I = 0; I < T.length; I++) {
        var _ = T[I], E = Object.getOwnPropertyDescriptor($, _);
        E && E.configurable && S[_] === void 0 && Object.defineProperty(S, _, E);
      }
      return S;
    }
    function y(S, $) {
      if (!(S instanceof $))
        throw new TypeError("Cannot call a class as a function");
    }
    function f(S, $) {
      if (!S)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return $ && (typeof $ == "object" || typeof $ == "function") ? $ : S;
    }
    function m(S, $) {
      if (typeof $ != "function" && $ !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof $);
      S.prototype = Object.create($ && $.prototype, { constructor: { value: S, enumerable: !1, writable: !0, configurable: !0 } }), $ && (Object.setPrototypeOf ? Object.setPrototypeOf(S, $) : b(S, $));
    }
    function C(S, $, T, I) {
      return "rgba(" + [S, $, T, I / 100].join(",") + ")";
    }
    var w = function(S) {
      m($, S);
      function $(T) {
        y(this, $);
        var I = f(this, S.call(this, T));
        return I.onMouseDown = function(_) {
          var E = _.clientX, R = _.clientY;
          I.pointMoveTo({
            x: E,
            y: R
          }), I.dragListener = (0, x.default)(window, "mousemove", I.onDrag), I.dragUpListener = (0, x.default)(window, "mouseup", I.onDragEnd);
        }, I.onDrag = function(_) {
          var E = _.clientX, R = _.clientY;
          I.pointMoveTo({
            x: E,
            y: R
          });
        }, I.onDragEnd = function(_) {
          var E = _.clientX, R = _.clientY;
          I.pointMoveTo({
            x: E,
            y: R
          }), I.removeListeners();
        }, I.getBackground = function() {
          var _ = I.props.color, E = _.red, R = _.green, O = _.blue, L = "linear-gradient(to right, " + C(E, R, O, 0) + " , " + C(E, R, O, 100) + ")";
          return L;
        }, I.getPrefixCls = function() {
          return I.props.rootPrefixCls + "-alpha";
        }, I.pointMoveTo = function(_) {
          var E = (0, d.findDOMNode)(I).getBoundingClientRect(), R = E.width, O = _.x - E.left;
          O = Math.max(0, O), O = Math.min(O, R);
          var L = Math.round(O / R * 100);
          I.props.onChange(L);
        }, I.removeListeners = function() {
          I.dragListener && (I.dragListener.remove(), I.dragListener = null), I.dragUpListener && (I.dragUpListener.remove(), I.dragUpListener = null);
        }, I;
      }
      return $.prototype.componentWillUnmount = function() {
        this.removeListeners();
      }, $.prototype.render = function() {
        var I = this.getPrefixCls();
        return u.default.createElement(
          "div",
          { className: I },
          u.default.createElement("div", { ref: "bg", className: I + "-bg", style: { background: this.getBackground() } }),
          u.default.createElement("span", { style: { left: this.props.alpha + "%" } }),
          u.default.createElement("div", { className: I + "-handler", onMouseDown: this.onMouseDown })
        );
      }, $;
    }(u.default.Component);
    s.default = w, w.propTypes = {
      color: v.default.object,
      onChange: v.default.func,
      rootPrefixCls: v.default.string,
      alpha: v.default.number
    }, a.exports = s.default;
  }(Alpha, Alpha.exports)), Alpha.exports;
}
var Params = { exports: {} }, percentage = { exports: {} }, hasRequiredPercentage;
function requirePercentage() {
  return hasRequiredPercentage || (hasRequiredPercentage = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    }), s.default = c;
    function c(u) {
      return Math.round(u * 100);
    }
    a.exports = s.default;
  }(percentage, percentage.exports)), percentage.exports;
}
var hasRequiredParams;
function requireParams() {
  return hasRequiredParams || (hasRequiredParams = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = requireReact(), u = f(c), d = /* @__PURE__ */ requirePropTypes(), p = f(d), v = requireClassnames(), A = f(v), x = requireColor(), g = f(x), b = requirePercentage(), y = f(b);
    function f(_) {
      return _ && _.__esModule ? _ : { default: _ };
    }
    function m(_, E) {
      for (var R = Object.getOwnPropertyNames(E), O = 0; O < R.length; O++) {
        var L = R[O], B = Object.getOwnPropertyDescriptor(E, L);
        B && B.configurable && _[L] === void 0 && Object.defineProperty(_, L, B);
      }
      return _;
    }
    function C(_, E, R) {
      return E in _ ? Object.defineProperty(_, E, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : _[E] = R, _;
    }
    function w(_, E) {
      if (!(_ instanceof E))
        throw new TypeError("Cannot call a class as a function");
    }
    function S(_, E) {
      if (!_)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return E && (typeof E == "object" || typeof E == "function") ? E : _;
    }
    function $(_, E) {
      if (typeof E != "function" && E !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof E);
      _.prototype = Object.create(E && E.prototype, { constructor: { value: _, enumerable: !1, writable: !0, configurable: !0 } }), E && (Object.setPrototypeOf ? Object.setPrototypeOf(_, E) : m(_, E));
    }
    var T = ["RGB", "HSB"], I = function(_) {
      $(E, _);
      function E(R) {
        w(this, E);
        var O = S(this, _.call(this, R));
        return O.getChannelInRange = function(L, B) {
          var F = {
            RGB: [[0, 255], [0, 255], [0, 255]],
            HSB: [[0, 359], [0, 100], [0, 100]]
          }, M = O.state.mode, W = F[M][B], j = parseInt(L, 10);
          return isNaN(j) && (j = 0), j = Math.max(W[0], j), j = Math.min(j, W[1]), j;
        }, O.getPrefixCls = function() {
          return O.props.rootPrefixCls + "-params";
        }, O.handleHexBlur = function() {
          var L = O.state.hex, B = null;
          g.default.isValidHex(L) && (B = new g.default(L)), B !== null && (O.setState({
            color: B,
            hex: L
          }), O.props.onChange(B, !1));
        }, O.handleHexPress = function(L) {
          var B = O.state.hex;
          if (L.nativeEvent.which === 13) {
            var F = null;
            g.default.isValidHex(B) && (F = new g.default(B)), F !== null && (O.setState({
              color: F,
              hex: B
            }), O.props.onChange(F, !1));
          }
        }, O.handleHexChange = function(L) {
          var B = L.target.value;
          O.setState({
            hex: B
          });
        }, O.handleModeChange = function() {
          var L = O.state.mode, B = (T.indexOf(L) + 1) % T.length;
          L = T[B], O.setState({
            mode: L
          });
        }, O.handleAlphaHandler = function(L) {
          var B = parseInt(L.target.value, 10);
          isNaN(B) && (B = 0), B = Math.max(0, B), B = Math.min(B, 100), O.props.onAlphaChange(B);
        }, O.updateColorByChanel = function(L, B) {
          var F = O.props.color, M = O.state.mode;
          return M === "HSB" ? L === "H" ? F.hue = parseInt(B, 10) : L === "S" ? F.saturation = parseInt(B, 10) / 100 : L === "B" && (F.brightness = parseInt(B, 10) / 100) : L === "R" ? F.red = parseInt(B, 10) : L === "G" ? F.green = parseInt(B, 10) : L === "B" && (F.blue = parseInt(B, 10)), F;
        }, O.handleColorChannelChange = function(L, B) {
          var F = O.getChannelInRange(B.target.value, L), M = O.state.mode, W = M[L], j = O.updateColorByChanel(W, F);
          O.setState({
            hex: j.hex,
            color: j
          }, function() {
            O.props.onChange(j, !1);
          });
        }, O.state = {
          mode: R.mode,
          hex: R.color.hex,
          color: R.color
          // instanceof tinycolor
        }, O;
      }
      return E.prototype.componentWillReceiveProps = function(O) {
        var L = O.color;
        this.setState({
          color: L,
          hex: L.hex
        });
      }, E.prototype.render = function() {
        var O, L = this.getPrefixCls(), B = this.props.enableAlpha, F = this.state, M = F.mode, W = F.color, j = W[M];
        M === "HSB" && (j[0] = parseInt(j[0], 10), j[1] = (0, y.default)(j[1]), j[2] = (0, y.default)(j[2]));
        var G = (0, A.default)((O = {}, C(O, L, !0), C(O, L + "-has-alpha", B), O));
        return u.default.createElement(
          "div",
          { className: G },
          u.default.createElement(
            "div",
            { className: L + "-input" },
            u.default.createElement("input", {
              className: L + "-hex",
              type: "text",
              maxLength: "6",
              onKeyPress: this.handleHexPress,
              onBlur: this.handleHexBlur,
              onChange: this.handleHexChange,
              value: this.state.hex.toLowerCase()
            }),
            u.default.createElement("input", {
              type: "number",
              ref: "channel_0",
              value: j[0],
              onChange: this.handleColorChannelChange.bind(null, 0)
            }),
            u.default.createElement("input", {
              type: "number",
              ref: "channel_1",
              value: j[1],
              onChange: this.handleColorChannelChange.bind(null, 1)
            }),
            u.default.createElement("input", {
              type: "number",
              ref: "channel_2",
              value: j[2],
              onChange: this.handleColorChannelChange.bind(null, 2)
            }),
            B && u.default.createElement("input", {
              type: "number",
              value: Math.round(this.props.alpha),
              onChange: this.handleAlphaHandler
            })
          ),
          u.default.createElement(
            "div",
            { className: L + "-lable" },
            u.default.createElement(
              "label",
              { className: L + "-lable-hex" },
              "Hex"
            ),
            u.default.createElement(
              "label",
              { className: L + "-lable-number", onClick: this.handleModeChange },
              M[0]
            ),
            u.default.createElement(
              "label",
              { className: L + "-lable-number", onClick: this.handleModeChange },
              M[1]
            ),
            u.default.createElement(
              "label",
              { className: L + "-lable-number", onClick: this.handleModeChange },
              M[2]
            ),
            B && u.default.createElement(
              "label",
              { className: L + "-lable-alpha" },
              "A"
            )
          )
        );
      }, E;
    }(u.default.Component);
    s.default = I, I.propTypes = {
      alpha: p.default.number,
      enableAlpha: p.default.bool,
      color: p.default.object.isRequired,
      mode: p.default.oneOf(T),
      onAlphaChange: p.default.func,
      onChange: p.default.func,
      rootPrefixCls: p.default.string
    }, I.defaultProps = {
      mode: T[0],
      enableAlpha: !0
    }, a.exports = s.default;
  }(Params, Params.exports)), Params.exports;
}
var validationColor, hasRequiredValidationColor;
function requireValidationColor() {
  return hasRequiredValidationColor || (hasRequiredValidationColor = 1, validationColor = function(s, c, u) {
    if (s[c] && !/^#[0-9a-fA-F]{3,6}$/.test(s[c]))
      return new Error(u + ".props." + c + " Validation failed!");
  }), validationColor;
}
var hasRequiredPanel;
function requirePanel() {
  return hasRequiredPanel || (hasRequiredPanel = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = requireReact(), u = R(c), d = /* @__PURE__ */ requirePropTypes(), p = R(d), v = requireColor(), A = R(v), x = requireBoard(), g = R(x), b = requirePreview(), y = R(b), f = requireRibbon(), m = R(f), C = requireAlpha(), w = R(C), S = requireParams(), $ = R(S), T = requireClassnames(), I = R(T), _ = requireValidationColor(), E = R(_);
    function R(U) {
      return U && U.__esModule ? U : { default: U };
    }
    function O(U, k) {
      for (var N = Object.getOwnPropertyNames(k), P = 0; P < N.length; P++) {
        var D = N[P], H = Object.getOwnPropertyDescriptor(k, D);
        H && H.configurable && U[D] === void 0 && Object.defineProperty(U, D, H);
      }
      return U;
    }
    function L(U, k, N) {
      return k in U ? Object.defineProperty(U, k, { value: N, enumerable: !0, configurable: !0, writable: !0 }) : U[k] = N, U;
    }
    function B(U, k) {
      if (!(U instanceof k))
        throw new TypeError("Cannot call a class as a function");
    }
    function F(U, k) {
      if (!U)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return k && (typeof k == "object" || typeof k == "function") ? k : U;
    }
    function M(U, k) {
      if (typeof k != "function" && k !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof k);
      U.prototype = Object.create(k && k.prototype, { constructor: { value: U, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(U, k) : O(U, k));
    }
    function W() {
    }
    var j = function(U) {
      M(k, U);
      function k(N) {
        B(this, k);
        var P = F(this, U.call(this, N));
        G.call(P);
        var D = typeof N.alpha > "u" ? N.defaultAlpha : Math.min(N.alpha, N.defaultAlpha), H = new A.default(N.color || N.defaultColor);
        return P.state = {
          color: H,
          alpha: D
        }, P;
      }
      return k.prototype.componentDidMount = function() {
        this.props.onMount(this.ref);
      }, k.prototype.componentWillReceiveProps = function(P) {
        if (P.color) {
          var D = new A.default(P.color);
          this.setState({
            color: D
          });
        }
        P.alpha !== void 0 && this.setState({
          alpha: P.alpha
        });
      }, k.prototype.render = function() {
        var P, D = this, H = this.props, V = H.prefixCls, Z = H.enableAlpha, ne = this.state, K = ne.color, q = ne.alpha, Y = (0, I.default)((P = {}, L(P, V + "-wrap", !0), L(P, V + "-wrap-has-alpha", Z), P));
        return u.default.createElement(
          "div",
          {
            ref: function(Q) {
              return D.ref = Q;
            },
            className: [V, this.props.className].join(" "),
            style: this.props.style,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            tabIndex: "0"
          },
          u.default.createElement(
            "div",
            { className: V + "-inner" },
            u.default.createElement(g.default, { rootPrefixCls: V, color: K, onChange: this.handleChange }),
            u.default.createElement(
              "div",
              { className: Y },
              u.default.createElement(
                "div",
                { className: V + "-wrap-ribbon" },
                u.default.createElement(m.default, { rootPrefixCls: V, color: K, onChange: this.handleChange })
              ),
              Z && u.default.createElement(
                "div",
                { className: V + "-wrap-alpha" },
                u.default.createElement(w.default, {
                  rootPrefixCls: V,
                  alpha: q,
                  color: K,
                  onChange: this.handleAlphaChange
                })
              ),
              u.default.createElement(
                "div",
                { className: V + "-wrap-preview" },
                u.default.createElement(y.default, {
                  rootPrefixCls: V,
                  alpha: q,
                  onChange: this.handleChange,
                  onInputClick: this.onSystemColorPickerOpen,
                  color: K
                })
              )
            ),
            u.default.createElement(
              "div",
              { className: V + "-wrap", style: { height: 40, marginTop: 6 } },
              u.default.createElement($.default, {
                rootPrefixCls: V,
                color: K,
                alpha: q,
                onAlphaChange: this.handleAlphaChange,
                onChange: this.handleChange,
                mode: this.props.mode,
                enableAlpha: this.props.enableAlpha
              })
            )
          )
        );
      }, k;
    }(u.default.Component), G = function() {
      var k = this;
      this.onSystemColorPickerOpen = function(N) {
        N.target.type === "color" && (k.systemColorPickerOpen = !0);
      }, this.onFocus = function() {
        k._blurTimer ? (clearTimeout(k._blurTimer), k._blurTimer = null) : k.props.onFocus();
      }, this.onBlur = function() {
        k._blurTimer && clearTimeout(k._blurTimer), k._blurTimer = setTimeout(function() {
          if (k.systemColorPickerOpen) {
            k.systemColorPickerOpen = !1;
            return;
          }
          k.props.onBlur();
        }, 100);
      }, this.handleAlphaChange = function(N) {
        var P = k.state.color;
        P.alpha = N, k.setState({
          alpha: N,
          color: P
        }), k.props.onChange({
          color: P.toHexString(),
          alpha: N
        });
      }, this.handleChange = function(N) {
        var P = k.state.alpha;
        N.alpha = P, k.setState({ color: N }), k.props.onChange({
          color: N.toHexString(),
          alpha: N.alpha
        });
      };
    };
    s.default = j, j.propTypes = {
      alpha: p.default.number,
      className: p.default.string,
      color: E.default,
      // Hex string
      defaultAlpha: p.default.number,
      defaultColor: E.default,
      // Hex string
      enableAlpha: p.default.bool,
      mode: p.default.oneOf(["RGB", "HSL", "HSB"]),
      onBlur: p.default.func,
      onChange: p.default.func,
      onFocus: p.default.func,
      onMount: p.default.func,
      prefixCls: p.default.string,
      style: p.default.object
    }, j.defaultProps = {
      className: "",
      defaultAlpha: 100,
      defaultColor: "#ff0000",
      enableAlpha: !0,
      mode: "RGB",
      onBlur: W,
      onChange: W,
      onFocus: W,
      onMount: W,
      prefixCls: "rc-color-picker-panel",
      style: {}
    }, a.exports = s.default;
  }(Panel$1, Panel$1.exports)), Panel$1.exports;
}
var placements = { exports: {} }, hasRequiredPlacements;
function requirePlacements() {
  return hasRequiredPlacements || (hasRequiredPlacements = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = {
      adjustX: 1,
      adjustY: 1
    }, u = [0, 0], d = {
      topLeft: {
        points: ["bl", "tl"],
        overflow: c,
        offset: [0, -5],
        targetOffset: u
      },
      topRight: {
        points: ["br", "tr"],
        overflow: c,
        offset: [0, -5],
        targetOffset: u
      },
      bottomLeft: {
        points: ["tl", "bl"],
        overflow: c,
        offset: [0, 5],
        targetOffset: u
      },
      bottomRight: {
        points: ["tr", "br"],
        overflow: c,
        offset: [0, 5],
        targetOffset: u
      }
    };
    s.default = d, a.exports = s.default;
  }(placements, placements.exports)), placements.exports;
}
var hasRequiredColorPicker;
function requireColorPicker() {
  return hasRequiredColorPicker || (hasRequiredColorPicker = 1, function(a, s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    });
    var c = /* @__PURE__ */ function() {
      function B(F, M) {
        var W = [], j = !0, G = !1, U = void 0;
        try {
          for (var k = F[Symbol.iterator](), N; !(j = (N = k.next()).done) && (W.push(N.value), !(M && W.length === M)); j = !0)
            ;
        } catch (P) {
          G = !0, U = P;
        } finally {
          try {
            !j && k.return && k.return();
          } finally {
            if (G) throw U;
          }
        }
        return W;
      }
      return function(F, M) {
        if (Array.isArray(F))
          return F;
        if (Symbol.iterator in Object(F))
          return B(F, M);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }(), u = Object.assign || function(B) {
      for (var F = 1; F < arguments.length; F++) {
        var M = arguments[F];
        for (var W in M)
          Object.prototype.hasOwnProperty.call(M, W) && (B[W] = M[W]);
      }
      return B;
    }, d = requireReact(), p = $(d), v = requireReactDom(), A = /* @__PURE__ */ requirePropTypes(), x = $(A), g = require$$3$1, b = $(g), y = requirePanel(), f = $(y), m = requirePlacements(), C = $(m), w = requireColor(), S = $(w);
    function $(B) {
      return B && B.__esModule ? B : { default: B };
    }
    function T(B, F) {
      for (var M = Object.getOwnPropertyNames(F), W = 0; W < M.length; W++) {
        var j = M[W], G = Object.getOwnPropertyDescriptor(F, j);
        G && G.configurable && B[j] === void 0 && Object.defineProperty(B, j, G);
      }
      return B;
    }
    function I(B, F) {
      if (!(B instanceof F))
        throw new TypeError("Cannot call a class as a function");
    }
    function _(B, F) {
      if (!B)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return F && (typeof F == "object" || typeof F == "function") ? F : B;
    }
    function E(B, F) {
      if (typeof F != "function" && F !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof F);
      B.prototype = Object.create(F && F.prototype, { constructor: { value: B, enumerable: !1, writable: !0, configurable: !0 } }), F && (Object.setPrototypeOf ? Object.setPrototypeOf(B, F) : T(B, F));
    }
    function R(B, F) {
      this[B] = F;
    }
    function O(B) {
      B.preventDefault();
    }
    var L = function(B) {
      E(F, B);
      function F(M) {
        I(this, F);
        var W = _(this, B.call(this, M)), j = typeof M.alpha > "u" ? M.defaultAlpha : Math.min(M.alpha, M.defaultAlpha);
        W.state = {
          color: M.color || M.defaultColor,
          alpha: j,
          open: !1
        };
        var G = ["onTriggerClick", "onChange", "onBlur", "getPickerElement", "getRootDOMNode", "getTriggerDOMNode", "onVisibleChange", "onPanelMount", "setOpen", "open", "close", "focus"];
        return G.forEach(function(U) {
          W[U] = W[U].bind(W);
        }), W.saveTriggerRef = R.bind(W, "triggerInstance"), W;
      }
      return F.prototype.componentWillReceiveProps = function(W) {
        W.color && this.setState({
          color: W.color
        }), W.alpha !== null && W.alpha !== void 0 && this.setState({
          alpha: W.alpha
        });
      }, F.prototype.onTriggerClick = function() {
        this.setState({
          open: !this.state.open
        });
      }, F.prototype.onChange = function(W) {
        var j = this;
        this.setState(u({}, W), function() {
          j.props.onChange(j.state);
        });
      }, F.prototype.onBlur = function() {
        this.setOpen(!1);
      }, F.prototype.onVisibleChange = function(W) {
        this.setOpen(W);
      }, F.prototype.onPanelMount = function(W) {
        this.state.open && setTimeout(function() {
          W.focus();
        }, 1);
      }, F.prototype.setOpen = function(W, j) {
        var G = this;
        this.state.open !== W && this.setState({
          open: W
        }, function() {
          typeof j == "function" && j();
          var U = G.props, k = U.onOpen, N = U.onClose;
          G.state.open ? k(G.state) : N(G.state);
        });
      }, F.prototype.getRootDOMNode = function() {
        return (0, v.findDOMNode)(this);
      }, F.prototype.getTriggerDOMNode = function() {
        return (0, v.findDOMNode)(this.triggerInstance);
      }, F.prototype.getPickerElement = function() {
        return p.default.createElement(f.default, {
          onMount: this.onPanelMount,
          defaultColor: this.state.color,
          alpha: this.state.alpha,
          enableAlpha: this.props.enableAlpha,
          prefixCls: this.props.prefixCls + "-panel",
          onChange: this.onChange,
          onBlur: this.onBlur,
          mode: this.props.mode,
          className: this.props.className
        });
      }, F.prototype.open = function(W) {
        this.setOpen(!0, W);
      }, F.prototype.close = function(W) {
        this.setOpen(!1, W);
      }, F.prototype.focus = function() {
        this.state.open || (0, v.findDOMNode)(this).focus();
      }, F.prototype.render = function() {
        var W = this.props, j = this.state, G = [W.prefixCls + "-wrap", W.className];
        j.open && G.push(W.prefixCls + "-open");
        var U = W.children, k = c(new S.default(this.state.color).RGB, 3), N = k[0], P = k[1], D = k[2], H = [N, P, D];
        H.push(this.state.alpha / 100), U && (U = p.default.cloneElement(U, {
          ref: this.saveTriggerRef,
          unselectable: "unselectable",
          style: {
            backgroundColor: "rgba(" + H.join(",") + ")"
          },
          onClick: this.onTriggerClick,
          onMouseDown: O
        }));
        var V = W.prefixCls, Z = W.placement, ne = W.style, K = W.getCalendarContainer, q = W.align, Y = W.animation, ee = W.disabled, Q = W.transitionName;
        return p.default.createElement(
          "div",
          { className: G.join(" ") },
          p.default.createElement(
            b.default,
            {
              popup: this.getPickerElement(),
              popupAlign: q,
              builtinPlacements: C.default,
              popupPlacement: Z,
              action: ee ? [] : ["click"],
              destroyPopupOnHide: !0,
              getPopupContainer: K,
              popupStyle: ne,
              popupAnimation: Y,
              popupTransitionName: Q,
              popupVisible: j.open,
              onPopupVisibleChange: this.onVisibleChange,
              prefixCls: V
            },
            U
          )
        );
      }, F;
    }(p.default.Component);
    s.default = L, L.propTypes = {
      defaultColor: x.default.string,
      defaultAlpha: x.default.number,
      // can custom
      alpha: x.default.number,
      children: x.default.node.isRequired,
      className: x.default.string,
      color: x.default.string,
      enableAlpha: x.default.bool,
      mode: x.default.oneOf(["RGB", "HSL", "HSB"]),
      onChange: x.default.func,
      onClose: x.default.func,
      onOpen: x.default.func,
      placement: x.default.oneOf(["topLeft", "topRight", "bottomLeft", "bottomRight"]),
      prefixCls: x.default.string.isRequired,
      style: x.default.object
    }, L.defaultProps = {
      defaultColor: "#F00",
      defaultAlpha: 100,
      onChange: function() {
      },
      onOpen: function() {
      },
      onClose: function() {
      },
      children: p.default.createElement("span", { className: "rc-color-picker-trigger" }),
      className: "",
      enableAlpha: !0,
      placement: "topLeft",
      prefixCls: "rc-color-picker",
      style: {}
    }, a.exports = s.default;
  }(ColorPicker$1, ColorPicker$1.exports)), ColorPicker$1.exports;
}
var hasRequiredLib;
function requireLib() {
  return hasRequiredLib || (hasRequiredLib = 1, lib$1.exports = requireColorPicker(), lib$1.exports.Panel = requirePanel()), lib$1.exports;
}
var libExports = requireLib();
const ColorPicker = /* @__PURE__ */ getDefaultExportFromCjs(libExports), alphaHexMap = {
  "1.00": "FF",
  0.99: "FC",
  0.98: "FA",
  0.97: "F7",
  0.96: "F5",
  0.95: "F2",
  0.94: "F0",
  0.93: "ED",
  0.92: "EB",
  0.91: "E8",
  "0.90": "E6",
  0.89: "E3",
  0.88: "E0",
  0.87: "DE",
  0.86: "DB",
  0.85: "D9",
  0.84: "D6",
  0.83: "D4",
  0.82: "D1",
  0.81: "CF",
  "0.80": "CC",
  0.79: "C9",
  0.78: "C7",
  0.77: "C4",
  0.76: "C2",
  0.75: "BF",
  0.74: "BD",
  0.73: "BA",
  0.72: "B8",
  0.71: "B5",
  "0.70": "B3",
  0.69: "B0",
  0.68: "AD",
  0.67: "AB",
  0.66: "A8",
  0.65: "A6",
  0.64: "A3",
  0.63: "A1",
  0.62: "9E",
  0.61: "9C",
  "0.60": "99",
  0.59: "96",
  0.58: "94",
  0.57: "91",
  0.56: "8F",
  0.55: "8C",
  0.54: "8A",
  0.53: "87",
  0.52: "85",
  0.51: "82",
  "0.50": "80",
  0.49: "7D",
  0.48: "7A",
  0.47: "78",
  0.46: "75",
  0.45: "73",
  0.44: "70",
  0.43: "6E",
  0.42: "6B",
  0.41: "69",
  "0.40": "66",
  0.39: "63",
  0.38: "61",
  0.37: "5E",
  0.36: "5C",
  0.35: "59",
  0.34: "57",
  0.33: "54",
  0.32: "52",
  0.31: "4F",
  "0.30": "4D",
  0.29: "4A",
  0.28: "47",
  0.27: "45",
  0.26: "42",
  0.25: "40",
  0.24: "3D",
  0.23: "3B",
  0.22: "38",
  0.21: "36",
  "0.20": "33",
  0.19: "30",
  0.18: "2E",
  0.17: "2B",
  0.16: "29",
  0.15: "26",
  0.14: "24",
  0.13: "21",
  0.12: "1F",
  0.11: "1C",
  "0.10": "1A",
  0.09: "17",
  0.08: "14",
  0.07: "12",
  0.06: "0F",
  0.05: "0D",
  0.04: "0A",
  0.03: "08",
  0.02: "05",
  0.01: "03",
  "0.00": "00"
};
var getAlphaFromHex = function a() {
  var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "#ffffff", c = s.slice(7), u = 100;
  for (var d in alphaHexMap)
    alphaHexMap[d] === c.toUpperCase() && (u = Number(d) * 100);
  return u;
}, Color = function a(s) {
  var c = s.className, u = s.schema, d = s.disabled, p = s.disabledAlpha, v = s.readOnly, A = s.value, x = s.onChange, g = s.style, b = function(m) {
    if (!(d || v)) {
      var C = alphaHexMap[(m.alpha / 100).toFixed(2)], w = m.color + (m.alpha === 100 ? "" : C);
      x(w);
    }
  }, y = function(m) {
    x(m.target.value);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "fr-color-picker",
    style: g
  }, d || v ? /* @__PURE__ */ React.createElement("span", {
    className: "rc-color-picker-trigger",
    style: {
      backgroundColor: A || "#ffffff"
    }
  }) : /* @__PURE__ */ React.createElement(ColorPicker, {
    type: u?.format,
    animation: "slide-up",
    color: A && A.slice(0, 7) || "#ffffff",
    alpha: getAlphaFromHex(A),
    enableAlpha: !p,
    onChange: b,
    disabled: !0
  }), v ? /* @__PURE__ */ React.createElement("span", null, A || "#ffffff") : /* @__PURE__ */ React.createElement(Input$1, {
    className: c,
    placeholder: "#ffffff",
    disabled: d,
    value: A,
    onChange: y
  }));
}, quarterOfYear$2 = { exports: {} }, quarterOfYear$1 = quarterOfYear$2.exports, hasRequiredQuarterOfYear;
function requireQuarterOfYear() {
  return hasRequiredQuarterOfYear || (hasRequiredQuarterOfYear = 1, function(a, s) {
    (function(c, u) {
      a.exports = u();
    })(quarterOfYear$1, function() {
      var c = "month", u = "quarter";
      return function(d, p) {
        var v = p.prototype;
        v.quarter = function(g) {
          return this.$utils().u(g) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (g - 1));
        };
        var A = v.add;
        v.add = function(g, b) {
          return g = Number(g), this.$utils().p(b) === u ? this.add(3 * g, c) : A.bind(this)(g, b);
        };
        var x = v.startOf;
        v.startOf = function(g, b) {
          var y = this.$utils(), f = !!y.u(b) || b;
          if (y.p(g) === u) {
            var m = this.quarter() - 1;
            return f ? this.month(3 * m).startOf(c).startOf("day") : this.month(3 * m + 2).endOf(c).endOf("day");
          }
          return x.bind(this)(g, b);
        };
      };
    });
  }(quarterOfYear$2)), quarterOfYear$2.exports;
}
var quarterOfYearExports = requireQuarterOfYear();
const quarterOfYear = /* @__PURE__ */ getDefaultExportFromCjs(quarterOfYearExports);
function _slicedToArray$a(a, s) {
  return _arrayWithHoles$a(a) || _iterableToArrayLimit$a(a, s) || _unsupportedIterableToArray$c(a, s) || _nonIterableRest$a();
}
function _nonIterableRest$a() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$c(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$c(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$c(a, s) : void 0;
  }
}
function _arrayLikeToArray$c(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$a(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$a(a) {
  if (Array.isArray(a)) return a;
}
dayjs.extend(weekOfYear);
function isUrl(a) {
  var s = /^(?:\w+:)?\/\/(\S+)$/;
  return typeof a != "string" ? !1 : s.test(a);
}
function getFormat(a) {
  var s;
  switch (a) {
    case "date":
      s = "YYYY-MM-DD";
      break;
    case "time":
      s = "HH:mm:ss";
      break;
    case "dateTime":
      s = "YYYY-MM-DD HH:mm:ss";
      break;
    case "week":
      s = "YYYY-w";
      break;
    case "year":
      s = "YYYY";
      break;
    case "quarter":
      s = "YYYY-Q";
      break;
    case "month":
      s = "YYYY-MM";
      break;
    default:
      typeof a == "string" ? s = a : s = "YYYY-MM-DD";
  }
  return s;
}
var transformDateValue = function a(s, c, u) {
  var d, p = s || void 0;
  if (typeof s == "string") {
    if (c === "week") {
      var v = s.split("-"), A = _slicedToArray$a(v, 2), x = A[0], g = A[1];
      p = (d = dayjs(x)) === null || d === void 0 ? void 0 : d.week(Number(g));
    }
    if (c === "quarter") {
      var b = s.split("-"), y = _slicedToArray$a(b, 2), f = y[0], m = y[1];
      p = dayjs(f).quarter(m);
    }
  }
  return p && (p = dayjs(p, u)), p;
}, translation = function a(s) {
  return function(c) {
    var u, d = (u = s?.locale) === null || u === void 0 ? void 0 : u.FormRender;
    return d[c];
  };
}, DatePicker$1 = generatePicker(generateConfig);
dayjs.extend(quarterOfYear);
var DateCmpt = function a(s) {
  var c = s.onChange, u = s.format, d = s.value, p = s.style, v = __rest$15(s, ["onChange", "format", "value", "style"]), A = getFormat(u), x = reactExports.useMemo(function() {
    return transformDateValue(d, u, A);
  }, [d]), g = function(f, m) {
    var C = m;
    (u === "week" || u === "quarter") && (C = dayjs(f).format(A)), c(C);
  }, b = {
    value: x,
    style: Object.assign({
      width: "100%"
    }, p),
    onChange: g
  };
  return u === "dateTime" && (b.showTime = !0), ["week", "month", "quarter", "year"].indexOf(u) > -1 && (b.picker = u), A === u && (b.format = u), /* @__PURE__ */ React.createElement(DatePicker$1, Object.assign({}, b, v));
};
const DatePicker = withFieldWrap(DateCmpt);
dayjs.extend(quarterOfYear);
var RangePicker$1 = DatePicker$1.RangePicker, DateRange = function a(s) {
  var c = s.onChange, u = s.format, d = s.value, p = s.style, v = __rest$15(s, ["onChange", "format", "value", "style"]), A = getFormat(u), x = reactExports.useMemo(function() {
    return d && d.map(function(y) {
      return transformDateValue(y, u, A);
    });
  }, [d]), g = function(f, m) {
    var C = m;
    ["week", "quarter"].includes(u) && (C = (f || []).map(function(S) {
      return dayjs(S).format(A);
    }));
    var w = C.every(function(S) {
      return !!S;
    });
    w || (C = null), c(C);
  }, b = {
    value: x,
    style: Object.assign({
      width: "100%"
    }, p),
    onChange: g
  };
  return u === "dateTime" && (b.showTime = !0), ["week", "month", "quarter", "year"].indexOf(u) > -1 && (b.picker = u), b = Object.assign(Object.assign({}, b), v), A === u && (b.format = u), /* @__PURE__ */ React.createElement(RangePicker$1, Object.assign({}, b));
};
const DateRange$1 = withFieldWrap(DateRange);
var TimePicker$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  return /* @__PURE__ */ reactExports.createElement(DatePicker$1, Object.assign({}, a, {
    picker: "time",
    mode: void 0,
    ref: s
  }));
});
TimePicker$1.displayName = "TimePicker";
TimePicker$1.RangePicker = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  return /* @__PURE__ */ reactExports.createElement(DatePicker$1.RangePicker, Object.assign({}, a, {
    picker: "time",
    mode: void 0,
    ref: s
  }));
});
var Time = function a(s) {
  var c = s.onChange, u = s.format, d = u === void 0 ? "time" : u, p = s.value, v = s.style, A = __rest$15(s, ["onChange", "format", "value", "style"]), x = getFormat(d), g = p ? dayjs(p, x) : void 0, b = function(m, C) {
    c(C);
  }, y = Object.assign({
    value: g,
    style: Object.assign({
      width: "100%"
    }, v),
    onChange: b,
    format: x
  }, A);
  return /* @__PURE__ */ React.createElement(TimePicker$1, Object.assign({}, y));
};
const TimePicker = withFieldWrap(Time);
function _slicedToArray$9(a, s) {
  return _arrayWithHoles$9(a) || _iterableToArrayLimit$9(a, s) || _unsupportedIterableToArray$b(a, s) || _nonIterableRest$9();
}
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$b(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$b(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$b(a, s) : void 0;
  }
}
function _arrayLikeToArray$b(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$9(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$9(a) {
  if (Array.isArray(a)) return a;
}
var RangePicker = TimePicker$1.RangePicker, TimeRange = function a(s) {
  var c = s.onChange, u = s.format, d = u === void 0 ? "time" : u, p = s.value, v = s.style, A = s.schema, x, g, b = getFormat(d), y = Array.isArray(p) ? p : [], f = _slicedToArray$9(y, 2), m = f[0], C = f[1], w = m && C ? [dayjs(m, ((x = A?.props) === null || x === void 0 ? void 0 : x.format) || b), dayjs(C, ((g = A?.props) === null || g === void 0 ? void 0 : g.format) || b)] : [], S = function(I, _) {
    var E = _[0] === "" || _[1] === "", R = _[0] === void 0 || _[1] === void 0;
    c(E || R ? void 0 : _);
  }, $ = Object.assign({
    style: Object.assign({
      width: "100%"
    }, v),
    value: w,
    onChange: S
  }, A.props || {});
  return /* @__PURE__ */ React.createElement(RangePicker, Object.assign({}, $));
}, PictureOutlined$1 = {}, PictureOutlined = {}, hasRequiredPictureOutlined$1;
function requirePictureOutlined$1() {
  if (hasRequiredPictureOutlined$1) return PictureOutlined;
  hasRequiredPictureOutlined$1 = 1, Object.defineProperty(PictureOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] }, name: "picture", theme: "outlined" };
  return PictureOutlined.default = a, PictureOutlined;
}
var AntdIcon = {}, slicedToArray = { exports: {} }, arrayWithHoles = { exports: {} }, hasRequiredArrayWithHoles;
function requireArrayWithHoles() {
  return hasRequiredArrayWithHoles || (hasRequiredArrayWithHoles = 1, function(a) {
    function s(c) {
      if (Array.isArray(c)) return c;
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(arrayWithHoles)), arrayWithHoles.exports;
}
var iterableToArrayLimit = { exports: {} }, hasRequiredIterableToArrayLimit;
function requireIterableToArrayLimit() {
  return hasRequiredIterableToArrayLimit || (hasRequiredIterableToArrayLimit = 1, function(a) {
    function s(c, u) {
      var d = c == null ? null : typeof Symbol < "u" && c[Symbol.iterator] || c["@@iterator"];
      if (d != null) {
        var p, v, A, x, g = [], b = !0, y = !1;
        try {
          if (A = (d = d.call(c)).next, u === 0) {
            if (Object(d) !== d) return;
            b = !1;
          } else for (; !(b = (p = A.call(d)).done) && (g.push(p.value), g.length !== u); b = !0) ;
        } catch (f) {
          y = !0, v = f;
        } finally {
          try {
            if (!b && d.return != null && (x = d.return(), Object(x) !== x)) return;
          } finally {
            if (y) throw v;
          }
        }
        return g;
      }
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(iterableToArrayLimit)), iterableToArrayLimit.exports;
}
var unsupportedIterableToArray = { exports: {} }, arrayLikeToArray = { exports: {} }, hasRequiredArrayLikeToArray;
function requireArrayLikeToArray() {
  return hasRequiredArrayLikeToArray || (hasRequiredArrayLikeToArray = 1, function(a) {
    function s(c, u) {
      (u == null || u > c.length) && (u = c.length);
      for (var d = 0, p = Array(u); d < u; d++) p[d] = c[d];
      return p;
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(arrayLikeToArray)), arrayLikeToArray.exports;
}
var hasRequiredUnsupportedIterableToArray;
function requireUnsupportedIterableToArray() {
  return hasRequiredUnsupportedIterableToArray || (hasRequiredUnsupportedIterableToArray = 1, function(a) {
    var s = requireArrayLikeToArray();
    function c(u, d) {
      if (u) {
        if (typeof u == "string") return s(u, d);
        var p = {}.toString.call(u).slice(8, -1);
        return p === "Object" && u.constructor && (p = u.constructor.name), p === "Map" || p === "Set" ? Array.from(u) : p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p) ? s(u, d) : void 0;
      }
    }
    a.exports = c, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(unsupportedIterableToArray)), unsupportedIterableToArray.exports;
}
var nonIterableRest = { exports: {} }, hasRequiredNonIterableRest;
function requireNonIterableRest() {
  return hasRequiredNonIterableRest || (hasRequiredNonIterableRest = 1, function(a) {
    function s() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(nonIterableRest)), nonIterableRest.exports;
}
var hasRequiredSlicedToArray;
function requireSlicedToArray() {
  return hasRequiredSlicedToArray || (hasRequiredSlicedToArray = 1, function(a) {
    var s = requireArrayWithHoles(), c = requireIterableToArrayLimit(), u = requireUnsupportedIterableToArray(), d = requireNonIterableRest();
    function p(v, A) {
      return s(v) || c(v, A) || u(v, A) || d();
    }
    a.exports = p, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(slicedToArray)), slicedToArray.exports;
}
var objectWithoutProperties = { exports: {} }, objectWithoutPropertiesLoose = { exports: {} }, hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  return hasRequiredObjectWithoutPropertiesLoose || (hasRequiredObjectWithoutPropertiesLoose = 1, function(a) {
    function s(c, u) {
      if (c == null) return {};
      var d = {};
      for (var p in c) if ({}.hasOwnProperty.call(c, p)) {
        if (u.indexOf(p) !== -1) continue;
        d[p] = c[p];
      }
      return d;
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(objectWithoutPropertiesLoose)), objectWithoutPropertiesLoose.exports;
}
var hasRequiredObjectWithoutProperties;
function requireObjectWithoutProperties() {
  return hasRequiredObjectWithoutProperties || (hasRequiredObjectWithoutProperties = 1, function(a) {
    var s = requireObjectWithoutPropertiesLoose();
    function c(u, d) {
      if (u == null) return {};
      var p, v, A = s(u, d);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(u);
        for (v = 0; v < x.length; v++) p = x[v], d.indexOf(p) === -1 && {}.propertyIsEnumerable.call(u, p) && (A[p] = u[p]);
      }
      return A;
    }
    a.exports = c, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(objectWithoutProperties)), objectWithoutProperties.exports;
}
var Context = {}, hasRequiredContext;
function requireContext() {
  if (hasRequiredContext) return Context;
  hasRequiredContext = 1, Object.defineProperty(Context, "__esModule", {
    value: !0
  }), Context.default = void 0;
  var a = requireReact(), s = /* @__PURE__ */ (0, a.createContext)({});
  return Context.default = s, Context;
}
var IconBase = {}, utils = {};
function bound01(a, s) {
  isOnePointZero(a) && (a = "100%");
  var c = isPercentage(a);
  return a = s === 360 ? a : Math.min(s, Math.max(0, parseFloat(a))), c && (a = parseInt(String(a * s), 10) / 100), Math.abs(a - s) < 1e-6 ? 1 : (s === 360 ? a = (a < 0 ? a % s + s : a % s) / parseFloat(String(s)) : a = a % s / parseFloat(String(s)), a);
}
function isOnePointZero(a) {
  return typeof a == "string" && a.indexOf(".") !== -1 && parseFloat(a) === 1;
}
function isPercentage(a) {
  return typeof a == "string" && a.indexOf("%") !== -1;
}
function boundAlpha(a) {
  return a = parseFloat(a), (isNaN(a) || a < 0 || a > 1) && (a = 1), a;
}
function convertToPercentage(a) {
  return a <= 1 ? "".concat(Number(a) * 100, "%") : a;
}
function pad2(a) {
  return a.length === 1 ? "0" + a : String(a);
}
function rgbToRgb(a, s, c) {
  return {
    r: bound01(a, 255) * 255,
    g: bound01(s, 255) * 255,
    b: bound01(c, 255) * 255
  };
}
function hue2rgb(a, s, c) {
  return c < 0 && (c += 1), c > 1 && (c -= 1), c < 1 / 6 ? a + (s - a) * (6 * c) : c < 1 / 2 ? s : c < 2 / 3 ? a + (s - a) * (2 / 3 - c) * 6 : a;
}
function hslToRgb(a, s, c) {
  var u, d, p;
  if (a = bound01(a, 360), s = bound01(s, 100), c = bound01(c, 100), s === 0)
    d = c, p = c, u = c;
  else {
    var v = c < 0.5 ? c * (1 + s) : c + s - c * s, A = 2 * c - v;
    u = hue2rgb(A, v, a + 1 / 3), d = hue2rgb(A, v, a), p = hue2rgb(A, v, a - 1 / 3);
  }
  return { r: u * 255, g: d * 255, b: p * 255 };
}
function rgbToHsv(a, s, c) {
  a = bound01(a, 255), s = bound01(s, 255), c = bound01(c, 255);
  var u = Math.max(a, s, c), d = Math.min(a, s, c), p = 0, v = u, A = u - d, x = u === 0 ? 0 : A / u;
  if (u === d)
    p = 0;
  else {
    switch (u) {
      case a:
        p = (s - c) / A + (s < c ? 6 : 0);
        break;
      case s:
        p = (c - a) / A + 2;
        break;
      case c:
        p = (a - s) / A + 4;
        break;
    }
    p /= 6;
  }
  return { h: p, s: x, v };
}
function hsvToRgb(a, s, c) {
  a = bound01(a, 360) * 6, s = bound01(s, 100), c = bound01(c, 100);
  var u = Math.floor(a), d = a - u, p = c * (1 - s), v = c * (1 - d * s), A = c * (1 - (1 - d) * s), x = u % 6, g = [c, v, p, p, A, c][x], b = [A, c, c, v, p, p][x], y = [p, p, A, c, c, v][x];
  return { r: g * 255, g: b * 255, b: y * 255 };
}
function rgbToHex(a, s, c, u) {
  var d = [
    pad2(Math.round(a).toString(16)),
    pad2(Math.round(s).toString(16)),
    pad2(Math.round(c).toString(16))
  ];
  return d.join("");
}
function convertHexToDecimal(a) {
  return parseIntFromHex(a) / 255;
}
function parseIntFromHex(a) {
  return parseInt(a, 16);
}
var names = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function inputToRGB(a) {
  var s = { r: 0, g: 0, b: 0 }, c = 1, u = null, d = null, p = null, v = !1, A = !1;
  return typeof a == "string" && (a = stringInputToObject(a)), typeof a == "object" && (isValidCSSUnit(a.r) && isValidCSSUnit(a.g) && isValidCSSUnit(a.b) ? (s = rgbToRgb(a.r, a.g, a.b), v = !0, A = String(a.r).substr(-1) === "%" ? "prgb" : "rgb") : isValidCSSUnit(a.h) && isValidCSSUnit(a.s) && isValidCSSUnit(a.v) ? (u = convertToPercentage(a.s), d = convertToPercentage(a.v), s = hsvToRgb(a.h, u, d), v = !0, A = "hsv") : isValidCSSUnit(a.h) && isValidCSSUnit(a.s) && isValidCSSUnit(a.l) && (u = convertToPercentage(a.s), p = convertToPercentage(a.l), s = hslToRgb(a.h, u, p), v = !0, A = "hsl"), Object.prototype.hasOwnProperty.call(a, "a") && (c = a.a)), c = boundAlpha(c), {
    ok: v,
    format: a.format || A,
    r: Math.min(255, Math.max(s.r, 0)),
    g: Math.min(255, Math.max(s.g, 0)),
    b: Math.min(255, Math.max(s.b, 0)),
    a: c
  };
}
var CSS_INTEGER = "[-\\+]?\\d+%?", CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?", CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")"), PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?"), PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?"), matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
  rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
  hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
  hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
  hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
  hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function stringInputToObject(a) {
  if (a = a.trim().toLowerCase(), a.length === 0)
    return !1;
  var s = !1;
  if (names[a])
    a = names[a], s = !0;
  else if (a === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var c = matchers.rgb.exec(a);
  return c ? { r: c[1], g: c[2], b: c[3] } : (c = matchers.rgba.exec(a), c ? { r: c[1], g: c[2], b: c[3], a: c[4] } : (c = matchers.hsl.exec(a), c ? { h: c[1], s: c[2], l: c[3] } : (c = matchers.hsla.exec(a), c ? { h: c[1], s: c[2], l: c[3], a: c[4] } : (c = matchers.hsv.exec(a), c ? { h: c[1], s: c[2], v: c[3] } : (c = matchers.hsva.exec(a), c ? { h: c[1], s: c[2], v: c[3], a: c[4] } : (c = matchers.hex8.exec(a), c ? {
    r: parseIntFromHex(c[1]),
    g: parseIntFromHex(c[2]),
    b: parseIntFromHex(c[3]),
    a: convertHexToDecimal(c[4]),
    format: s ? "name" : "hex8"
  } : (c = matchers.hex6.exec(a), c ? {
    r: parseIntFromHex(c[1]),
    g: parseIntFromHex(c[2]),
    b: parseIntFromHex(c[3]),
    format: s ? "name" : "hex"
  } : (c = matchers.hex4.exec(a), c ? {
    r: parseIntFromHex(c[1] + c[1]),
    g: parseIntFromHex(c[2] + c[2]),
    b: parseIntFromHex(c[3] + c[3]),
    a: convertHexToDecimal(c[4] + c[4]),
    format: s ? "name" : "hex8"
  } : (c = matchers.hex3.exec(a), c ? {
    r: parseIntFromHex(c[1] + c[1]),
    g: parseIntFromHex(c[2] + c[2]),
    b: parseIntFromHex(c[3] + c[3]),
    format: s ? "name" : "hex"
  } : !1)))))))));
}
function isValidCSSUnit(a) {
  return !!matchers.CSS_UNIT.exec(String(a));
}
var hueStep = 2, saturationStep = 0.16, saturationStep2 = 0.05, brightnessStep1 = 0.05, brightnessStep2 = 0.15, lightColorCount = 5, darkColorCount = 4, darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function toHsv(a) {
  var s = a.r, c = a.g, u = a.b, d = rgbToHsv(s, c, u);
  return {
    h: d.h * 360,
    s: d.s,
    v: d.v
  };
}
function toHex(a) {
  var s = a.r, c = a.g, u = a.b;
  return "#".concat(rgbToHex(s, c, u));
}
function mix(a, s, c) {
  var u = c / 100, d = {
    r: (s.r - a.r) * u + a.r,
    g: (s.g - a.g) * u + a.g,
    b: (s.b - a.b) * u + a.b
  };
  return d;
}
function getHue(a, s, c) {
  var u;
  return Math.round(a.h) >= 60 && Math.round(a.h) <= 240 ? u = c ? Math.round(a.h) - hueStep * s : Math.round(a.h) + hueStep * s : u = c ? Math.round(a.h) + hueStep * s : Math.round(a.h) - hueStep * s, u < 0 ? u += 360 : u >= 360 && (u -= 360), u;
}
function getSaturation(a, s, c) {
  if (a.h === 0 && a.s === 0)
    return a.s;
  var u;
  return c ? u = a.s - saturationStep * s : s === darkColorCount ? u = a.s + saturationStep : u = a.s + saturationStep2 * s, u > 1 && (u = 1), c && s === lightColorCount && u > 0.1 && (u = 0.1), u < 0.06 && (u = 0.06), Number(u.toFixed(2));
}
function getValue(a, s, c) {
  var u;
  return c ? u = a.v + brightnessStep1 * s : u = a.v - brightnessStep2 * s, u > 1 && (u = 1), Number(u.toFixed(2));
}
function generate(a) {
  for (var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = [], u = inputToRGB(a), d = lightColorCount; d > 0; d -= 1) {
    var p = toHsv(u), v = toHex(inputToRGB({
      h: getHue(p, d, !0),
      s: getSaturation(p, d, !0),
      v: getValue(p, d, !0)
    }));
    c.push(v);
  }
  c.push(toHex(u));
  for (var A = 1; A <= darkColorCount; A += 1) {
    var x = toHsv(u), g = toHex(inputToRGB({
      h: getHue(x, A),
      s: getSaturation(x, A),
      v: getValue(x, A)
    }));
    c.push(g);
  }
  return s.theme === "dark" ? darkColorMap.map(function(b) {
    var y = b.index, f = b.opacity, m = toHex(mix(inputToRGB(s.backgroundColor || "#141414"), inputToRGB(c[y]), f * 100));
    return m;
  }) : c;
}
var presetPrimaryColors = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, presetPalettes = {}, presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function(a) {
  presetPalettes[a] = generate(presetPrimaryColors[a]), presetPalettes[a].primary = presetPalettes[a][5], presetDarkPalettes[a] = generate(presetPrimaryColors[a], {
    theme: "dark",
    backgroundColor: "#141414"
  }), presetDarkPalettes[a].primary = presetDarkPalettes[a][5];
});
var red = presetPalettes.red, volcano = presetPalettes.volcano, gold = presetPalettes.gold, orange = presetPalettes.orange, yellow = presetPalettes.yellow, lime = presetPalettes.lime, green = presetPalettes.green, cyan = presetPalettes.cyan, blue = presetPalettes.blue, geekblue = presetPalettes.geekblue, purple = presetPalettes.purple, magenta = presetPalettes.magenta, grey = presetPalettes.grey;
const index_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  blue,
  cyan,
  geekblue,
  generate,
  gold,
  green,
  grey,
  lime,
  magenta,
  orange,
  presetDarkPalettes,
  presetPalettes,
  presetPrimaryColors,
  purple,
  red,
  volcano,
  yellow
}, Symbol.toStringTag, { value: "Module" })), require$$3 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
var warning = {}, hasRequiredWarning;
function requireWarning() {
  if (hasRequiredWarning) return warning;
  hasRequiredWarning = 1, Object.defineProperty(warning, "__esModule", {
    value: !0
  }), warning.call = p, warning.default = void 0, warning.note = u, warning.noteOnce = A, warning.preMessage = void 0, warning.resetWarned = d, warning.warning = c, warning.warningOnce = v;
  var a = {}, s = warning.preMessage = function(g) {
  };
  function c(x, g) {
  }
  function u(x, g) {
  }
  function d() {
    a = {};
  }
  function p(x, g, b) {
    !g && !a[b] && (x(!1, b), a[b] = !0);
  }
  function v(x, g) {
    p(c, x, g);
  }
  function A(x, g) {
    p(u, x, g);
  }
  return v.preMessage = s, v.resetWarned = d, v.noteOnce = A, warning.default = v, warning;
}
var dynamicCSS = {}, canUseDom = {}, hasRequiredCanUseDom;
function requireCanUseDom() {
  if (hasRequiredCanUseDom) return canUseDom;
  hasRequiredCanUseDom = 1, Object.defineProperty(canUseDom, "__esModule", {
    value: !0
  }), canUseDom.default = a;
  function a() {
    return !!(typeof window < "u" && window.document && window.document.createElement);
  }
  return canUseDom;
}
var contains = {}, hasRequiredContains;
function requireContains() {
  if (hasRequiredContains) return contains;
  hasRequiredContains = 1, Object.defineProperty(contains, "__esModule", {
    value: !0
  }), contains.default = a;
  function a(s, c) {
    if (!s)
      return !1;
    if (s.contains)
      return s.contains(c);
    for (var u = c; u; ) {
      if (u === s)
        return !0;
      u = u.parentNode;
    }
    return !1;
  }
  return contains;
}
var hasRequiredDynamicCSS;
function requireDynamicCSS() {
  if (hasRequiredDynamicCSS) return dynamicCSS;
  hasRequiredDynamicCSS = 1;
  var a = requireInteropRequireDefault().default;
  Object.defineProperty(dynamicCSS, "__esModule", {
    value: !0
  }), dynamicCSS.clearContainerCache = S, dynamicCSS.injectCSS = f, dynamicCSS.removeCSS = C, dynamicCSS.updateCSS = $;
  var s = a(requireObjectSpread2()), c = a(requireCanUseDom()), u = a(requireContains()), d = "data-rc-order", p = "data-rc-priority", v = "rc-util-key", A = /* @__PURE__ */ new Map();
  function x() {
    var T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, I = T.mark;
    return I ? I.startsWith("data-") ? I : "data-".concat(I) : v;
  }
  function g(T) {
    if (T.attachTo)
      return T.attachTo;
    var I = document.querySelector("head");
    return I || document.body;
  }
  function b(T) {
    return T === "queue" ? "prependQueue" : T ? "prepend" : "append";
  }
  function y(T) {
    return Array.from((A.get(T) || T).children).filter(function(I) {
      return I.tagName === "STYLE";
    });
  }
  function f(T) {
    var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!(0, c.default)())
      return null;
    var _ = I.csp, E = I.prepend, R = I.priority, O = R === void 0 ? 0 : R, L = b(E), B = L === "prependQueue", F = document.createElement("style");
    F.setAttribute(d, L), B && O && F.setAttribute(p, "".concat(O)), _ != null && _.nonce && (F.nonce = _?.nonce), F.innerHTML = T;
    var M = g(I), W = M.firstChild;
    if (E) {
      if (B) {
        var j = (I.styles || y(M)).filter(function(G) {
          if (!["prepend", "prependQueue"].includes(G.getAttribute(d)))
            return !1;
          var U = Number(G.getAttribute(p) || 0);
          return O >= U;
        });
        if (j.length)
          return M.insertBefore(F, j[j.length - 1].nextSibling), F;
      }
      M.insertBefore(F, W);
    } else
      M.appendChild(F);
    return F;
  }
  function m(T) {
    var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = g(I);
    return (I.styles || y(_)).find(function(E) {
      return E.getAttribute(x(I)) === T;
    });
  }
  function C(T) {
    var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = m(T, I);
    if (_) {
      var E = g(I);
      E.removeChild(_);
    }
  }
  function w(T, I) {
    var _ = A.get(T);
    if (!_ || !(0, u.default)(document, _)) {
      var E = f("", I), R = E.parentNode;
      A.set(T, R), T.removeChild(E);
    }
  }
  function S() {
    A.clear();
  }
  function $(T, I) {
    var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, E = g(_), R = y(E), O = (0, s.default)((0, s.default)({}, _), {}, {
      styles: R
    });
    w(E, O);
    var L = m(I, O);
    if (L) {
      var B, F;
      if ((B = O.csp) !== null && B !== void 0 && B.nonce && L.nonce !== ((F = O.csp) === null || F === void 0 ? void 0 : F.nonce)) {
        var M;
        L.nonce = (M = O.csp) === null || M === void 0 ? void 0 : M.nonce;
      }
      return L.innerHTML !== T && (L.innerHTML = T), L;
    }
    var W = f(T, O);
    return W.setAttribute(x(O), I), W;
  }
  return dynamicCSS;
}
var _arrayMap, hasRequired_arrayMap;
function require_arrayMap() {
  if (hasRequired_arrayMap) return _arrayMap;
  hasRequired_arrayMap = 1;
  function a(s, c) {
    for (var u = -1, d = s == null ? 0 : s.length, p = Array(d); ++u < d; )
      p[u] = c(s[u], u, s);
    return p;
  }
  return _arrayMap = a, _arrayMap;
}
var isArray_1, hasRequiredIsArray;
function requireIsArray() {
  if (hasRequiredIsArray) return isArray_1;
  hasRequiredIsArray = 1;
  var a = Array.isArray;
  return isArray_1 = a, isArray_1;
}
var _baseToString, hasRequired_baseToString;
function require_baseToString() {
  if (hasRequired_baseToString) return _baseToString;
  hasRequired_baseToString = 1;
  var a = require_Symbol(), s = require_arrayMap(), c = requireIsArray(), u = requireIsSymbol(), d = a ? a.prototype : void 0, p = d ? d.toString : void 0;
  function v(A) {
    if (typeof A == "string")
      return A;
    if (c(A))
      return s(A, v) + "";
    if (u(A))
      return p ? p.call(A) : "";
    var x = A + "";
    return x == "0" && 1 / A == -1 / 0 ? "-0" : x;
  }
  return _baseToString = v, _baseToString;
}
var toString_1, hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return toString_1;
  hasRequiredToString = 1;
  var a = require_baseToString();
  function s(c) {
    return c == null ? "" : a(c);
  }
  return toString_1 = s, toString_1;
}
var _baseSlice, hasRequired_baseSlice;
function require_baseSlice() {
  if (hasRequired_baseSlice) return _baseSlice;
  hasRequired_baseSlice = 1;
  function a(s, c, u) {
    var d = -1, p = s.length;
    c < 0 && (c = -c > p ? 0 : p + c), u = u > p ? p : u, u < 0 && (u += p), p = c > u ? 0 : u - c >>> 0, c >>>= 0;
    for (var v = Array(p); ++d < p; )
      v[d] = s[d + c];
    return v;
  }
  return _baseSlice = a, _baseSlice;
}
var _castSlice, hasRequired_castSlice;
function require_castSlice() {
  if (hasRequired_castSlice) return _castSlice;
  hasRequired_castSlice = 1;
  var a = require_baseSlice();
  function s(c, u, d) {
    var p = c.length;
    return d = d === void 0 ? p : d, !u && d >= p ? c : a(c, u, d);
  }
  return _castSlice = s, _castSlice;
}
var _hasUnicode, hasRequired_hasUnicode;
function require_hasUnicode() {
  if (hasRequired_hasUnicode) return _hasUnicode;
  hasRequired_hasUnicode = 1;
  var a = "\\ud800-\\udfff", s = "\\u0300-\\u036f", c = "\\ufe20-\\ufe2f", u = "\\u20d0-\\u20ff", d = s + c + u, p = "\\ufe0e\\ufe0f", v = "\\u200d", A = RegExp("[" + v + a + d + p + "]");
  function x(g) {
    return A.test(g);
  }
  return _hasUnicode = x, _hasUnicode;
}
var _asciiToArray, hasRequired_asciiToArray;
function require_asciiToArray() {
  if (hasRequired_asciiToArray) return _asciiToArray;
  hasRequired_asciiToArray = 1;
  function a(s) {
    return s.split("");
  }
  return _asciiToArray = a, _asciiToArray;
}
var _unicodeToArray, hasRequired_unicodeToArray;
function require_unicodeToArray() {
  if (hasRequired_unicodeToArray) return _unicodeToArray;
  hasRequired_unicodeToArray = 1;
  var a = "\\ud800-\\udfff", s = "\\u0300-\\u036f", c = "\\ufe20-\\ufe2f", u = "\\u20d0-\\u20ff", d = s + c + u, p = "\\ufe0e\\ufe0f", v = "[" + a + "]", A = "[" + d + "]", x = "\\ud83c[\\udffb-\\udfff]", g = "(?:" + A + "|" + x + ")", b = "[^" + a + "]", y = "(?:\\ud83c[\\udde6-\\uddff]){2}", f = "[\\ud800-\\udbff][\\udc00-\\udfff]", m = "\\u200d", C = g + "?", w = "[" + p + "]?", S = "(?:" + m + "(?:" + [b, y, f].join("|") + ")" + w + C + ")*", $ = w + C + S, T = "(?:" + [b + A + "?", A, y, f, v].join("|") + ")", I = RegExp(x + "(?=" + x + ")|" + T + $, "g");
  function _(E) {
    return E.match(I) || [];
  }
  return _unicodeToArray = _, _unicodeToArray;
}
var _stringToArray, hasRequired_stringToArray;
function require_stringToArray() {
  if (hasRequired_stringToArray) return _stringToArray;
  hasRequired_stringToArray = 1;
  var a = require_asciiToArray(), s = require_hasUnicode(), c = require_unicodeToArray();
  function u(d) {
    return s(d) ? c(d) : a(d);
  }
  return _stringToArray = u, _stringToArray;
}
var _createCaseFirst, hasRequired_createCaseFirst;
function require_createCaseFirst() {
  if (hasRequired_createCaseFirst) return _createCaseFirst;
  hasRequired_createCaseFirst = 1;
  var a = require_castSlice(), s = require_hasUnicode(), c = require_stringToArray(), u = requireToString();
  function d(p) {
    return function(v) {
      v = u(v);
      var A = s(v) ? c(v) : void 0, x = A ? A[0] : v.charAt(0), g = A ? a(A, 1).join("") : v.slice(1);
      return x[p]() + g;
    };
  }
  return _createCaseFirst = d, _createCaseFirst;
}
var upperFirst_1, hasRequiredUpperFirst;
function requireUpperFirst() {
  if (hasRequiredUpperFirst) return upperFirst_1;
  hasRequiredUpperFirst = 1;
  var a = require_createCaseFirst(), s = a("toUpperCase");
  return upperFirst_1 = s, upperFirst_1;
}
var capitalize_1, hasRequiredCapitalize;
function requireCapitalize() {
  if (hasRequiredCapitalize) return capitalize_1;
  hasRequiredCapitalize = 1;
  var a = requireToString(), s = requireUpperFirst();
  function c(u) {
    return s(a(u).toLowerCase());
  }
  return capitalize_1 = c, capitalize_1;
}
var _arrayReduce, hasRequired_arrayReduce;
function require_arrayReduce() {
  if (hasRequired_arrayReduce) return _arrayReduce;
  hasRequired_arrayReduce = 1;
  function a(s, c, u, d) {
    var p = -1, v = s == null ? 0 : s.length;
    for (d && v && (u = s[++p]); ++p < v; )
      u = c(u, s[p], p, s);
    return u;
  }
  return _arrayReduce = a, _arrayReduce;
}
var _basePropertyOf, hasRequired_basePropertyOf;
function require_basePropertyOf() {
  if (hasRequired_basePropertyOf) return _basePropertyOf;
  hasRequired_basePropertyOf = 1;
  function a(s) {
    return function(c) {
      return s?.[c];
    };
  }
  return _basePropertyOf = a, _basePropertyOf;
}
var _deburrLetter, hasRequired_deburrLetter;
function require_deburrLetter() {
  if (hasRequired_deburrLetter) return _deburrLetter;
  hasRequired_deburrLetter = 1;
  var a = require_basePropertyOf(), s = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, c = a(s);
  return _deburrLetter = c, _deburrLetter;
}
var deburr_1, hasRequiredDeburr;
function requireDeburr() {
  if (hasRequiredDeburr) return deburr_1;
  hasRequiredDeburr = 1;
  var a = require_deburrLetter(), s = requireToString(), c = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, u = "\\u0300-\\u036f", d = "\\ufe20-\\ufe2f", p = "\\u20d0-\\u20ff", v = u + d + p, A = "[" + v + "]", x = RegExp(A, "g");
  function g(b) {
    return b = s(b), b && b.replace(c, a).replace(x, "");
  }
  return deburr_1 = g, deburr_1;
}
var _asciiWords, hasRequired_asciiWords;
function require_asciiWords() {
  if (hasRequired_asciiWords) return _asciiWords;
  hasRequired_asciiWords = 1;
  var a = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function s(c) {
    return c.match(a) || [];
  }
  return _asciiWords = s, _asciiWords;
}
var _hasUnicodeWord, hasRequired_hasUnicodeWord;
function require_hasUnicodeWord() {
  if (hasRequired_hasUnicodeWord) return _hasUnicodeWord;
  hasRequired_hasUnicodeWord = 1;
  var a = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function s(c) {
    return a.test(c);
  }
  return _hasUnicodeWord = s, _hasUnicodeWord;
}
var _unicodeWords, hasRequired_unicodeWords;
function require_unicodeWords() {
  if (hasRequired_unicodeWords) return _unicodeWords;
  hasRequired_unicodeWords = 1;
  var a = "\\ud800-\\udfff", s = "\\u0300-\\u036f", c = "\\ufe20-\\ufe2f", u = "\\u20d0-\\u20ff", d = s + c + u, p = "\\u2700-\\u27bf", v = "a-z\\xdf-\\xf6\\xf8-\\xff", A = "\\xac\\xb1\\xd7\\xf7", x = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", g = "\\u2000-\\u206f", b = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", y = "A-Z\\xc0-\\xd6\\xd8-\\xde", f = "\\ufe0e\\ufe0f", m = A + x + g + b, C = "['’]", w = "[" + m + "]", S = "[" + d + "]", $ = "\\d+", T = "[" + p + "]", I = "[" + v + "]", _ = "[^" + a + m + $ + p + v + y + "]", E = "\\ud83c[\\udffb-\\udfff]", R = "(?:" + S + "|" + E + ")", O = "[^" + a + "]", L = "(?:\\ud83c[\\udde6-\\uddff]){2}", B = "[\\ud800-\\udbff][\\udc00-\\udfff]", F = "[" + y + "]", M = "\\u200d", W = "(?:" + I + "|" + _ + ")", j = "(?:" + F + "|" + _ + ")", G = "(?:" + C + "(?:d|ll|m|re|s|t|ve))?", U = "(?:" + C + "(?:D|LL|M|RE|S|T|VE))?", k = R + "?", N = "[" + f + "]?", P = "(?:" + M + "(?:" + [O, L, B].join("|") + ")" + N + k + ")*", D = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", H = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", V = N + k + P, Z = "(?:" + [T, L, B].join("|") + ")" + V, ne = RegExp([
    F + "?" + I + "+" + G + "(?=" + [w, F, "$"].join("|") + ")",
    j + "+" + U + "(?=" + [w, F + W, "$"].join("|") + ")",
    F + "?" + W + "+" + G,
    F + "+" + U,
    H,
    D,
    $,
    Z
  ].join("|"), "g");
  function K(q) {
    return q.match(ne) || [];
  }
  return _unicodeWords = K, _unicodeWords;
}
var words_1, hasRequiredWords;
function requireWords() {
  if (hasRequiredWords) return words_1;
  hasRequiredWords = 1;
  var a = require_asciiWords(), s = require_hasUnicodeWord(), c = requireToString(), u = require_unicodeWords();
  function d(p, v, A) {
    return p = c(p), v = A ? void 0 : v, v === void 0 ? s(p) ? u(p) : a(p) : p.match(v) || [];
  }
  return words_1 = d, words_1;
}
var _createCompounder, hasRequired_createCompounder;
function require_createCompounder() {
  if (hasRequired_createCompounder) return _createCompounder;
  hasRequired_createCompounder = 1;
  var a = require_arrayReduce(), s = requireDeburr(), c = requireWords(), u = "['’]", d = RegExp(u, "g");
  function p(v) {
    return function(A) {
      return a(c(s(A).replace(d, "")), v, "");
    };
  }
  return _createCompounder = p, _createCompounder;
}
var camelCase_1, hasRequiredCamelCase;
function requireCamelCase() {
  if (hasRequiredCamelCase) return camelCase_1;
  hasRequiredCamelCase = 1;
  var a = requireCapitalize(), s = require_createCompounder(), c = s(function(u, d, p) {
    return d = d.toLowerCase(), u + (p ? a(d) : d);
  });
  return camelCase_1 = c, camelCase_1;
}
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils;
  hasRequiredUtils = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(utils, "__esModule", {
    value: !0
  }), utils.generate = w, utils.getSecondaryColor = S, utils.iconStyles = void 0, utils.isIconDefinition = m, utils.normalizeAttrs = C, utils.normalizeTwoToneColors = $, utils.useInsertStyles = utils.svgBaseProps = void 0, utils.warning = f;
  var c = a(requireObjectSpread2()), u = a(require_typeof$1()), d = require$$3, p = y(requireReact()), v = a(requireWarning()), A = requireDynamicCSS(), x = a(/* @__PURE__ */ requireContext()), g = a(requireCamelCase());
  function b(I) {
    if (typeof WeakMap != "function") return null;
    var _ = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap();
    return (b = function(O) {
      return O ? E : _;
    })(I);
  }
  function y(I, _) {
    if (I && I.__esModule) return I;
    if (I === null || s(I) != "object" && typeof I != "function") return { default: I };
    var E = b(_);
    if (E && E.has(I)) return E.get(I);
    var R = { __proto__: null }, O = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var L in I) if (L !== "default" && {}.hasOwnProperty.call(I, L)) {
      var B = O ? Object.getOwnPropertyDescriptor(I, L) : null;
      B && (B.get || B.set) ? Object.defineProperty(R, L, B) : R[L] = I[L];
    }
    return R.default = I, E && E.set(I, R), R;
  }
  function f(I, _) {
    (0, v.default)(I, "[@ant-design/icons] ".concat(_));
  }
  function m(I) {
    return (0, u.default)(I) === "object" && typeof I.name == "string" && typeof I.theme == "string" && ((0, u.default)(I.icon) === "object" || typeof I.icon == "function");
  }
  function C() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.keys(I).reduce(function(_, E) {
      var R = I[E];
      switch (E) {
        case "class":
          _.className = R, delete _.class;
          break;
        default:
          delete _[E], _[(0, g.default)(E)] = R;
      }
      return _;
    }, {});
  }
  function w(I, _, E) {
    return E ? /* @__PURE__ */ p.default.createElement(I.tag, (0, c.default)((0, c.default)({
      key: _
    }, C(I.attrs)), E), (I.children || []).map(function(R, O) {
      return w(R, "".concat(_, "-").concat(I.tag, "-").concat(O));
    })) : /* @__PURE__ */ p.default.createElement(I.tag, (0, c.default)({
      key: _
    }, C(I.attrs)), (I.children || []).map(function(R, O) {
      return w(R, "".concat(_, "-").concat(I.tag, "-").concat(O));
    }));
  }
  function S(I) {
    return (0, d.generate)(I)[0];
  }
  function $(I) {
    return I ? Array.isArray(I) ? I : [I] : [];
  }
  utils.svgBaseProps = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
  };
  var T = utils.iconStyles = `
.anticon {
  display: inline-flex;
  alignItems: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
  return utils.useInsertStyles = function() {
    var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : T, E = (0, p.useContext)(x.default), R = E.csp;
    (0, p.useEffect)(function() {
      (0, A.updateCSS)(_, "@ant-design-icons", {
        prepend: !0,
        csp: R
      });
    }, []);
  }, utils;
}
var hasRequiredIconBase;
function requireIconBase() {
  if (hasRequiredIconBase) return IconBase;
  hasRequiredIconBase = 1;
  var a = requireInteropRequireDefault();
  Object.defineProperty(IconBase, "__esModule", {
    value: !0
  }), IconBase.default = void 0;
  var s = a(requireObjectWithoutProperties()), c = a(requireObjectSpread2()), u = /* @__PURE__ */ requireUtils(), d = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], p = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: !1
  };
  function v(g) {
    var b = g.primaryColor, y = g.secondaryColor;
    p.primaryColor = b, p.secondaryColor = y || (0, u.getSecondaryColor)(b), p.calculated = !!y;
  }
  function A() {
    return (0, c.default)({}, p);
  }
  var x = function(b) {
    var y = b.icon, f = b.className, m = b.onClick, C = b.style, w = b.primaryColor, S = b.secondaryColor, $ = (0, s.default)(b, d), T = p;
    if (w && (T = {
      primaryColor: w,
      secondaryColor: S || (0, u.getSecondaryColor)(w)
    }), (0, u.useInsertStyles)(), (0, u.warning)((0, u.isIconDefinition)(y), "icon should be icon definiton, but got ".concat(y)), !(0, u.isIconDefinition)(y))
      return null;
    var I = y;
    return I && typeof I.icon == "function" && (I = (0, c.default)((0, c.default)({}, I), {}, {
      icon: I.icon(T.primaryColor, T.secondaryColor)
    })), (0, u.generate)(I.icon, "svg-".concat(I.name), (0, c.default)({
      className: f,
      onClick: m,
      style: C,
      "data-icon": I.name,
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true"
    }, $));
  };
  return x.displayName = "IconReact", x.getTwoToneColors = A, x.setTwoToneColors = v, IconBase.default = x, IconBase;
}
var twoTonePrimaryColor = {}, hasRequiredTwoTonePrimaryColor;
function requireTwoTonePrimaryColor() {
  if (hasRequiredTwoTonePrimaryColor) return twoTonePrimaryColor;
  hasRequiredTwoTonePrimaryColor = 1;
  var a = requireInteropRequireDefault();
  Object.defineProperty(twoTonePrimaryColor, "__esModule", {
    value: !0
  }), twoTonePrimaryColor.getTwoToneColor = p, twoTonePrimaryColor.setTwoToneColor = d;
  var s = a(requireSlicedToArray()), c = a(/* @__PURE__ */ requireIconBase()), u = /* @__PURE__ */ requireUtils();
  function d(v) {
    var A = (0, u.normalizeTwoToneColors)(v), x = (0, s.default)(A, 2), g = x[0], b = x[1];
    return c.default.setTwoToneColors({
      primaryColor: g,
      secondaryColor: b
    });
  }
  function p() {
    var v = c.default.getTwoToneColors();
    return v.calculated ? [v.primaryColor, v.secondaryColor] : v.primaryColor;
  }
  return twoTonePrimaryColor;
}
var hasRequiredAntdIcon;
function requireAntdIcon() {
  if (hasRequiredAntdIcon) return AntdIcon;
  hasRequiredAntdIcon = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(AntdIcon, "__esModule", {
    value: !0
  }), AntdIcon.default = void 0;
  var c = a(requireObjectSpread2()), u = a(requireSlicedToArray()), d = a(requireDefineProperty$3()), p = a(requireObjectWithoutProperties()), v = C(requireReact()), A = a(requireClassnames()), x = a(/* @__PURE__ */ requireContext()), g = a(/* @__PURE__ */ requireIconBase()), b = /* @__PURE__ */ requireTwoTonePrimaryColor(), y = /* @__PURE__ */ requireUtils(), f = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
  function m(S) {
    if (typeof WeakMap != "function") return null;
    var $ = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
    return (m = function(_) {
      return _ ? T : $;
    })(S);
  }
  function C(S, $) {
    if (S && S.__esModule) return S;
    if (S === null || s(S) != "object" && typeof S != "function") return { default: S };
    var T = m($);
    if (T && T.has(S)) return T.get(S);
    var I = { __proto__: null }, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var E in S) if (E !== "default" && {}.hasOwnProperty.call(S, E)) {
      var R = _ ? Object.getOwnPropertyDescriptor(S, E) : null;
      R && (R.get || R.set) ? Object.defineProperty(I, E, R) : I[E] = S[E];
    }
    return I.default = S, T && T.set(S, I), I;
  }
  (0, b.setTwoToneColor)("#1890ff");
  var w = /* @__PURE__ */ v.forwardRef(function(S, $) {
    var T = S.className, I = S.icon, _ = S.spin, E = S.rotate, R = S.tabIndex, O = S.onClick, L = S.twoToneColor, B = (0, p.default)(S, f), F = v.useContext(x.default), M = F.prefixCls, W = M === void 0 ? "anticon" : M, j = F.rootClassName, G = (0, A.default)(j, W, (0, d.default)((0, d.default)({}, "".concat(W, "-").concat(I.name), !!I.name), "".concat(W, "-spin"), !!_ || I.name === "loading"), T), U = R;
    U === void 0 && O && (U = -1);
    var k = E ? {
      msTransform: "rotate(".concat(E, "deg)"),
      transform: "rotate(".concat(E, "deg)")
    } : void 0, N = (0, y.normalizeTwoToneColors)(L), P = (0, u.default)(N, 2), D = P[0], H = P[1];
    return /* @__PURE__ */ v.createElement("span", (0, c.default)((0, c.default)({
      role: "img",
      "aria-label": I.name
    }, B), {}, {
      ref: $,
      tabIndex: U,
      onClick: O,
      className: G
    }), /* @__PURE__ */ v.createElement(g.default, {
      icon: I,
      primaryColor: D,
      secondaryColor: H,
      style: k
    }));
  });
  return w.displayName = "AntdIcon", w.getTwoToneColor = b.getTwoToneColor, w.setTwoToneColor = b.setTwoToneColor, AntdIcon.default = w, AntdIcon;
}
var hasRequiredPictureOutlined;
function requirePictureOutlined() {
  if (hasRequiredPictureOutlined) return PictureOutlined$1;
  hasRequiredPictureOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(PictureOutlined$1, "__esModule", {
    value: !0
  }), PictureOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requirePictureOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return PictureOutlined$1.default = g, PictureOutlined$1;
}
var PictureOutlinedExports = /* @__PURE__ */ requirePictureOutlined();
const _PictureOutlined = /* @__PURE__ */ getDefaultExportFromCjs(PictureOutlinedExports);
var DEFAULT_IMG = "https://img.alicdn.com/tfs/TB14tSiKhTpK1RjSZFKXXa2wXXa-354-330.png", PreviewNode = function a(s) {
  var c = s.value, u = reactExports.useContext(ConfigProvider.ConfigContext), d = translation(u);
  return /* @__PURE__ */ React.createElement(Popover, {
    content: /* @__PURE__ */ React.createElement("img", {
      src: c || DEFAULT_IMG,
      alt: d("img_src_error"),
      className: "fr-preview-image"
    }),
    className: "fr-preview",
    placement: "bottom"
  }, /* @__PURE__ */ React.createElement(_PictureOutlined, null));
}, ImageInput = function a(s) {
  var c = s.value, u = __rest$15(s, ["value"]);
  return /* @__PURE__ */ React.createElement(Input$1, Object.assign({
    value: c,
    addonAfter: /* @__PURE__ */ React.createElement(PreviewNode, {
      value: c
    })
  }, u));
};
const ImageInput$1 = withFieldWrap(ImageInput);
var UrlNode = function a(s) {
  var c = reactExports.useContext(ConfigProvider.ConfigContext), u = translation(c), d = s.value, p = s.addonText, v = p === void 0 ? u("test_src") : p, A = isUrl(d);
  return A ? /* @__PURE__ */ React.createElement("a", {
    target: "_blank",
    href: d
  }, v) : /* @__PURE__ */ React.createElement("div", null, v);
}, UrlInput = function a(s) {
  var c = s.value, u = s.prefix, d = s.suffix, p = s.addonText, v = s.onChange, A = __rest$15(s, ["value", "prefix", "suffix", "addonText", "onChange"]), x = c || "";
  u && (x = x.replace(u, "")), d && (x = x.replace(d, ""));
  var g = function(y) {
    var f = y.target.value;
    if (!f) {
      v?.(f);
      return;
    }
    u && (f = u + f), d && (f = f + d), v?.(f);
  };
  return /* @__PURE__ */ React.createElement(Input$1, Object.assign({
    value: x,
    prefix: u,
    suffix: d,
    onChange: g,
    addonAfter: /* @__PURE__ */ React.createElement(UrlNode, {
      value: c,
      addonText: p
    })
  }, A));
};
const UrlInput$1 = withFieldWrap(UrlInput);
var SliderWithNumber = function a(s) {
  var c = s.schema, u = s.value, d = s.onChange, p = s.hideInput, v = s.inputProps, A = s.style, x = __rest$15(s, ["schema", "value", "onChange", "hideInput", "inputProps", "style"]), g = c.max, b = c.min, y = c.step, f = {};
  return (g || g === 0) && (f = {
    max: g
  }), (b || b === 0) && (f = Object.assign(Object.assign({}, f), {
    min: b
  })), y && (f = Object.assign(Object.assign({}, f), {
    step: y
  })), /* @__PURE__ */ React.createElement("div", {
    className: "fr-slider",
    style: A
  }, /* @__PURE__ */ React.createElement(Slider$1, Object.assign({
    style: {
      flexGrow: 1,
      marginRight: p ? 0 : 12
    }
  }, f, {
    onChange: d,
    value: typeof u == "number" ? u : b || 0
  }, x)), p ? null : /* @__PURE__ */ React.createElement(TypedInputNumber, Object.assign({}, f, v, {
    style: {
      width: "90px"
    },
    value: u,
    onChange: d
  })));
};
const Slider = withFieldWrap(SliderWithNumber, ["addons", "dependValues"]);
var UploadOutlined$1 = {}, UploadOutlined = {}, hasRequiredUploadOutlined$1;
function requireUploadOutlined$1() {
  if (hasRequiredUploadOutlined$1) return UploadOutlined;
  hasRequiredUploadOutlined$1 = 1, Object.defineProperty(UploadOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "upload", theme: "outlined" };
  return UploadOutlined.default = a, UploadOutlined;
}
var hasRequiredUploadOutlined;
function requireUploadOutlined() {
  if (hasRequiredUploadOutlined) return UploadOutlined$1;
  hasRequiredUploadOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(UploadOutlined$1, "__esModule", {
    value: !0
  }), UploadOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requireUploadOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return UploadOutlined$1.default = g, UploadOutlined$1;
}
var UploadOutlinedExports = /* @__PURE__ */ requireUploadOutlined();
const _UploadOutlined = /* @__PURE__ */ getDefaultExportFromCjs(UploadOutlinedExports);
var FrUpload = function a(s) {
  var c = s.action, u = s.value, d = s.onChange, p = s.uploadProps, v = s.buttonProps, A = s.schema, x = reactExports.useContext(ConfigProvider.ConfigContext), g = translation(x), b = Object.assign({
    name: "file",
    type: "file",
    action: c,
    onChange: function(C) {
      if (C.file.status === "done") {
        staticMethods.success("".concat(C.file.name, " ").concat(g("upload_success")));
        var w = get(A, "props.path", ""), S = w ? get(C.file.response, w) : C.file.response.url;
        d(S);
      } else C.file.status === "error" && staticMethods.error("".concat(C.file.name, " ").concat(g("upload_fail")));
    },
    onRemove: function() {
      d("");
    }
  }, p), y = {
    icon: /* @__PURE__ */ React.createElement(_UploadOutlined, null),
    children: g("upload")
  }, f = Object.assign(Object.assign({}, y), v);
  return /* @__PURE__ */ React.createElement("div", {
    className: "fr-upload-mod"
  }, /* @__PURE__ */ React.createElement(Upload, Object.assign({}, b, {
    className: "fr-upload-file"
  }), /* @__PURE__ */ React.createElement(Button$1, Object.assign({}, f))), u && /* @__PURE__ */ React.createElement("a", {
    href: u,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "fr-upload-preview"
  }, g("uploaded_address")));
};
function _typeof$6(a) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$6(a);
}
function html(a) {
  var s = a.value, c = a.checked, u = a.options, d = a.schema, p = d === void 0 ? {} : d, v = "-";
  if (p.type === "boolean")
    v = s === !0 || c === !0 ? "✔" : "✘";
  else if (u?.length > 0) {
    if (["string", "number"].indexOf(_typeof$6(s)) > -1) {
      var A = u.find(function(g) {
        return g.value === s;
      });
      v = A?.label || "-";
    } else if (Array.isArray(s)) {
      var x = "-";
      s.forEach(function(g) {
        var b = u.find(function(f) {
          return f.value === g;
        }), y = b.label;
        y && (x += "," + y);
      }), v = x.replace("-,", "");
    }
  } else typeof s == "number" ? v = String(s) : typeof s == "string" ? v = s : p.type === "range" && Array.isArray(s) && s[0] && s[1] ? v = "".concat(s[0], " - ").concat(s[1]) : s && ["number", "string"].indexOf(_typeof$6(s)) === -1 && (v = JSON.stringify(s));
  return p.format === "image" ? /* @__PURE__ */ React.createElement(Image$1, Object.assign({
    height: 56,
    src: s
  }, p.imageProps)) : /* @__PURE__ */ React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: v
    }
  });
}
var PercentSlider = function a(s) {
  var c = s.schema, u = c.max, d = c.min, p = c.step, v = {};
  (u || u === 0) && (v = {
    max: u
  }), (d || d === 0) && (v = Object.assign(Object.assign({}, v), {
    min: d
  })), p && (v = Object.assign(Object.assign({}, v), {
    step: p
  }));
  var A = !1;
  s.options && s.options.hideNumber && (A = !0);
  var x = function(m) {
    return typeof m == "string" && m.endsWith("%");
  }, g = 100;
  if (x(s.value))
    try {
      g = Number(s.value.split("%")[0]), Number.isNaN(g) && (g = 100);
    } catch {
    }
  var b = function(m) {
    var C = m + "%";
    s.onChange(C);
  }, y = s.readonly ? /* @__PURE__ */ reactExports.createElement("span", {
    style: {
      width: "80px"
    }
  }, s.value === "" ? "-" : s.value + "%") : /* @__PURE__ */ reactExports.createElement(TypedInputNumber, Object.assign({}, s.options, v, {
    style: {
      width: "80px"
    },
    value: g,
    disabled: s.disabled,
    onChange: b,
    formatter: function(m) {
      return "".concat(m, "%");
    },
    parser: function(m) {
      return Number(m.replace("%", ""));
    }
  }));
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "fr-slider"
  }, /* @__PURE__ */ reactExports.createElement(Slider$1, Object.assign({
    style: {
      flexGrow: 1,
      marginRight: A ? 0 : 12
    }
  }, v, {
    onChange: b,
    max: 100,
    tooltip: {
      formatter: function(m) {
        return m + "%";
      }
    },
    value: g || 100,
    disabled: s.disabled || s.readonly
  })), A ? null : y);
}, PanelView = function a(s) {
  var c = s.children, u = s.bordered;
  return /* @__PURE__ */ React.createElement("div", {
    className: classnames("fr-panel", {
      "fr-panel-bordered": u
    })
  }, c);
}, BoxCard = function a(s) {
  var c = s.children, u = s.title, d = s.description;
  return u ? /* @__PURE__ */ React.createElement(Card, {
    className: "fr-obj-card",
    title: /* @__PURE__ */ React.createElement(React.Fragment, null, u, d && /* @__PURE__ */ React.createElement("span", {
      className: "fr-header-desc "
    }, d))
  }, c) : /* @__PURE__ */ React.createElement(PanelView, null, c);
}, DownOutlined$1 = {}, DownOutlined = {}, hasRequiredDownOutlined$1;
function requireDownOutlined$1() {
  if (hasRequiredDownOutlined$1) return DownOutlined;
  hasRequiredDownOutlined$1 = 1, Object.defineProperty(DownOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
  return DownOutlined.default = a, DownOutlined;
}
var hasRequiredDownOutlined;
function requireDownOutlined() {
  if (hasRequiredDownOutlined) return DownOutlined$1;
  hasRequiredDownOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(DownOutlined$1, "__esModule", {
    value: !0
  }), DownOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requireDownOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return DownOutlined$1.default = g, DownOutlined$1;
}
var DownOutlinedExports = /* @__PURE__ */ requireDownOutlined();
const _DownOutlined = /* @__PURE__ */ getDefaultExportFromCjs(DownOutlinedExports);
function _slicedToArray$8(a, s) {
  return _arrayWithHoles$8(a) || _iterableToArrayLimit$8(a, s) || _unsupportedIterableToArray$a(a, s) || _nonIterableRest$8();
}
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$a(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$a(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$a(a, s) : void 0;
  }
}
function _arrayLikeToArray$a(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$8(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$8(a) {
  if (Array.isArray(a)) return a;
}
var Panel = Collapse$1.Panel, BoxCollapse = function a(s) {
  var c = s.style, u = s.children, d = s.title, p = s.description, v = s.collapsed, A = v === void 0 ? !0 : v, x = s.displayType, g = s.bordered, b = g === void 0 ? !1 : g, y = s.ghost, f = y === void 0 ? !0 : y;
  if (!d)
    return /* @__PURE__ */ React.createElement(PanelView, {
      bordered: x !== "inline"
    }, u);
  var m = reactExports.useState(A ? "single" : ""), C = _slicedToArray$8(m, 2), w = C[0], S = C[1], $ = /* @__PURE__ */ React.createElement(React.Fragment, null, d && /* @__PURE__ */ React.createElement("div", {
    className: "collapse-title"
  }, d), p && /* @__PURE__ */ React.createElement("span", {
    className: "fr-header-desc "
  }, p)), T = function(_) {
    var E = _.isActive;
    return /* @__PURE__ */ React.createElement("div", {
      className: "expand-icon-box"
    }, /* @__PURE__ */ React.createElement(_DownOutlined, {
      rotate: E ? 0 : -90,
      style: {
        fontSize: "16px"
      }
    }));
  };
  return /* @__PURE__ */ React.createElement(Collapse$1, {
    className: "fr-obj-collapse",
    style: c,
    bordered: b,
    ghost: f,
    activeKey: [w],
    expandIcon: T,
    onChange: function() {
      return S(w ? "" : "single");
    }
  }, /* @__PURE__ */ React.createElement(Panel, {
    key: "single",
    header: $,
    forceRender: !0
  }, u));
}, BoxSubInline = function a(s) {
  var c = s.children, u = s.title, d = s.hasBackground, p = d === void 0 ? !0 : d, v = s.description, A = s.tooltip, x = s.fieldCol, g = s.labelCol, b = s.labelWidth;
  s.displayType;
  var y = __rest$15(s, ["children", "title", "hasBackground", "description", "tooltip", "fieldCol", "labelCol", "labelWidth", "displayType"]), f = null, m = {
    span: 3
  }, C = {
    flex: 1
  };
  return v && (f = {
    title: v
  }), A && (f = A), b && (m = {
    flex: b + "px"
  }), g && (m = g), x && (C = x), /* @__PURE__ */ React.createElement(Form$1.Item, Object.assign({}, y, {
    className: classnames("fr-obj-subinline", {
      "fr-obj-subinline-label-hidden": !u,
      "fr-obj-subinline-background": p
    }),
    label: u || "notitle",
    labelCol: m,
    wrapperCol: C,
    tooltip: f
  }), c);
}, FLineTitle = function a(s) {
  var c = s.children, u = s.title, d = s.description;
  return u ? /* @__PURE__ */ React.createElement("div", {
    className: "fr-obj-line-title"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "fr-obj-header"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "fr-header-title"
  }, u), d && /* @__PURE__ */ React.createElement("span", {
    className: "fr-header-desc"
  }, d)), /* @__PURE__ */ React.createElement("div", {
    className: "fr-obj-content"
  }, c)) : /* @__PURE__ */ React.createElement(PanelView, null, c);
}, PlusOutlined$1 = {}, PlusOutlined = {}, hasRequiredPlusOutlined$1;
function requirePlusOutlined$1() {
  if (hasRequiredPlusOutlined$1) return PlusOutlined;
  hasRequiredPlusOutlined$1 = 1, Object.defineProperty(PlusOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" };
  return PlusOutlined.default = a, PlusOutlined;
}
var hasRequiredPlusOutlined;
function requirePlusOutlined() {
  if (hasRequiredPlusOutlined) return PlusOutlined$1;
  hasRequiredPlusOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(PlusOutlined$1, "__esModule", {
    value: !0
  }), PlusOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requirePlusOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return PlusOutlined$1.default = g, PlusOutlined$1;
}
var PlusOutlinedExports = /* @__PURE__ */ requirePlusOutlined();
const _PlusOutlined = /* @__PURE__ */ getDefaultExportFromCjs(PlusOutlinedExports);
var CopyOutlined$1 = {}, CopyOutlined = {}, hasRequiredCopyOutlined$1;
function requireCopyOutlined$1() {
  if (hasRequiredCopyOutlined$1) return CopyOutlined;
  hasRequiredCopyOutlined$1 = 1, Object.defineProperty(CopyOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
  return CopyOutlined.default = a, CopyOutlined;
}
var hasRequiredCopyOutlined;
function requireCopyOutlined() {
  if (hasRequiredCopyOutlined) return CopyOutlined$1;
  hasRequiredCopyOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(CopyOutlined$1, "__esModule", {
    value: !0
  }), CopyOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requireCopyOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return CopyOutlined$1.default = g, CopyOutlined$1;
}
var CopyOutlinedExports = /* @__PURE__ */ requireCopyOutlined();
const _CopyOutlined = /* @__PURE__ */ getDefaultExportFromCjs(CopyOutlinedExports);
var CloseOutlined$1 = {}, CloseOutlined = {}, hasRequiredCloseOutlined$1;
function requireCloseOutlined$1() {
  if (hasRequiredCloseOutlined$1) return CloseOutlined;
  hasRequiredCloseOutlined$1 = 1, Object.defineProperty(CloseOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
  return CloseOutlined.default = a, CloseOutlined;
}
var hasRequiredCloseOutlined;
function requireCloseOutlined() {
  if (hasRequiredCloseOutlined) return CloseOutlined$1;
  hasRequiredCloseOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(CloseOutlined$1, "__esModule", {
    value: !0
  }), CloseOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requireCloseOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return CloseOutlined$1.default = g, CloseOutlined$1;
}
var CloseOutlinedExports = /* @__PURE__ */ requireCloseOutlined();
const _CloseOutlined = /* @__PURE__ */ getDefaultExportFromCjs(CloseOutlinedExports);
var ArrowDownOutlined$1 = {}, ArrowDownOutlined = {}, hasRequiredArrowDownOutlined$1;
function requireArrowDownOutlined$1() {
  if (hasRequiredArrowDownOutlined$1) return ArrowDownOutlined;
  hasRequiredArrowDownOutlined$1 = 1, Object.defineProperty(ArrowDownOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z" } }] }, name: "arrow-down", theme: "outlined" };
  return ArrowDownOutlined.default = a, ArrowDownOutlined;
}
var hasRequiredArrowDownOutlined;
function requireArrowDownOutlined() {
  if (hasRequiredArrowDownOutlined) return ArrowDownOutlined$1;
  hasRequiredArrowDownOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(ArrowDownOutlined$1, "__esModule", {
    value: !0
  }), ArrowDownOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requireArrowDownOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return ArrowDownOutlined$1.default = g, ArrowDownOutlined$1;
}
var ArrowDownOutlinedExports = /* @__PURE__ */ requireArrowDownOutlined();
const _ArrowDownOutlined = /* @__PURE__ */ getDefaultExportFromCjs(ArrowDownOutlinedExports);
var ArrowUpOutlined$1 = {}, ArrowUpOutlined = {}, hasRequiredArrowUpOutlined$1;
function requireArrowUpOutlined$1() {
  if (hasRequiredArrowUpOutlined$1) return ArrowUpOutlined;
  hasRequiredArrowUpOutlined$1 = 1, Object.defineProperty(ArrowUpOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z" } }] }, name: "arrow-up", theme: "outlined" };
  return ArrowUpOutlined.default = a, ArrowUpOutlined;
}
var hasRequiredArrowUpOutlined;
function requireArrowUpOutlined() {
  if (hasRequiredArrowUpOutlined) return ArrowUpOutlined$1;
  hasRequiredArrowUpOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(ArrowUpOutlined$1, "__esModule", {
    value: !0
  }), ArrowUpOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requireArrowUpOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return ArrowUpOutlined$1.default = g, ArrowUpOutlined$1;
}
var ArrowUpOutlinedExports = /* @__PURE__ */ requireArrowUpOutlined();
const _ArrowUpOutlined = /* @__PURE__ */ getDefaultExportFromCjs(ArrowUpOutlinedExports);
var HeaderTitle = function a(s) {
  var c = s.icon, u = s.children, d = s.btnType, p = __rest$15(s, ["icon", "children", "btnType"]), v = Object.assign({}, p);
  return d === "icon" ? (v.icon = c, v.size = "small") : v.children = u, /* @__PURE__ */ React.createElement(Button$1, Object.assign({
    type: "link",
    style: {
      padding: 0
    }
  }, v));
};
function _toConsumableArray$5(a) {
  return _arrayWithoutHoles$5(a) || _iterableToArray$5(a) || _unsupportedIterableToArray$9(a) || _nonIterableSpread$5();
}
function _nonIterableSpread$5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$9(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$9(a, s) : void 0;
  }
}
function _iterableToArray$5(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$5(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$9(a);
}
function _arrayLikeToArray$9(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
var getHasBackground = function a(s, c) {
  var u = c;
  return s.length === 0 && (u = !1), u;
}, SimpleList = function a(s) {
  var c = s.form, u = s.schema, d = s.fields, p = s.rootPath, v = s.renderCore, A = s.hasBackground, x = s.operateBtnType, g = s.addBtnProps, b = s.delConfirmProps, y = s.copyBtnProps, f = s.deleteBtnProps, m = s.moveUpBtnProps, C = s.moveDownBtnProps, w = s.hideDelete, S = s.hideCopy, $ = s.hideMove, T = s.hideAdd, I = s.addItem, _ = s.copyItem, E = s.moveItem, R = s.removeItem, O = s.temporary, L = Object.assign(Object.assign({}, u), {
    items: Object.assign({}, u.items)
  });
  L.items.displayType || (L.items.displayType = "inline", L.items.inlineMode = !0);
  var B = function(W) {
    var j = c.getFieldValue(p.concat(W));
    _(j, W);
  }, F = O.displayType === "column";
  return /* @__PURE__ */ React.createElement("div", {
    className: classnames("fr-list-simple", {
      "fr-list-simple-background": getHasBackground(d, A),
      "fr-list-simple-column": F
    })
  }, d.map(function(M) {
    var W = M.key, j = M.name, G = d.length;
    return /* @__PURE__ */ React.createElement("div", {
      key: W,
      className: "fr-list-item"
    }, v({
      schema: L,
      parentPath: [j],
      rootPath: [].concat(_toConsumableArray$5(p), [j])
    }), /* @__PURE__ */ React.createElement(Space, {
      className: classnames("fr-list-item-operate"),
      split: x !== "icon" && /* @__PURE__ */ React.createElement(Divider, {
        type: "vertical"
      })
    }, !$ && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
      disabled: j === 0,
      onClick: function() {
        return E(j, j - 1);
      },
      icon: /* @__PURE__ */ React.createElement(_ArrowUpOutlined, null)
    }, m)), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
      disabled: j === G - 1,
      onClick: function() {
        return E(j, j + 1);
      },
      icon: /* @__PURE__ */ React.createElement(_ArrowDownOutlined, null),
      children: "下移"
    }, C))), !w && /* @__PURE__ */ React.createElement(Popconfirm, Object.assign({
      onConfirm: function() {
        return R(j);
      }
    }, b), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
      icon: /* @__PURE__ */ React.createElement(_CloseOutlined, null),
      children: "删除",
      btnType: x
    }, f))), !S && /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
      onClick: function() {
        return B(j);
      },
      icon: /* @__PURE__ */ React.createElement(_CopyOutlined, null),
      children: "复制"
    }, y))));
  }), (!L.max || d.length < L.max) && !T && /* @__PURE__ */ React.createElement(Button$1, Object.assign({
    className: "add-btn",
    icon: /* @__PURE__ */ React.createElement(_PlusOutlined, null),
    onClick: function() {
      return I();
    },
    block: d.length > 0
  }, g)));
};
function _toConsumableArray$4(a) {
  return _arrayWithoutHoles$4(a) || _iterableToArray$4(a) || _unsupportedIterableToArray$8(a) || _nonIterableSpread$4();
}
function _nonIterableSpread$4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$8(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$8(a, s) : void 0;
  }
}
function _iterableToArray$4(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$4(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$8(a);
}
function _arrayLikeToArray$8(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
var getOperateFixed = function a(s) {
  var c, u, d = !0;
  return !((u = (c = s?.items) === null || c === void 0 ? void 0 : c.props) === null || u === void 0) && u.extra && (d = !1), d;
}, getOperateStyle = function a(s) {
  var c, u, d, p, v, A = {}, x = ((c = s?.items) === null || c === void 0 ? void 0 : c.theme) || ((u = s?.items) === null || u === void 0 ? void 0 : u.widget) || "collapse";
  return ["card", "collapse", "lineTitle"].includes(x) && !(!((p = (d = s?.items) === null || d === void 0 ? void 0 : d.props) === null || p === void 0) && p.extra) && (A.top = "14px", ["lineTitle"].includes(x) && (A.top = "3px", A.padding = 0), !((v = s?.items) === null || v === void 0) && v.title || (A.right = "0")), A;
}, CardList = function a(s) {
  var c = s.form, u = s.schema, d = s.fields, p = s.rootPath, v = s.renderCore, A = s.hasBackground, x = s.operateBtnType, g = s.addBtnProps, b = s.delConfirmProps, y = s.copyBtnProps, f = s.deleteBtnProps, m = s.moveUpBtnProps, C = s.moveDownBtnProps, w = s.hideDelete, S = s.hideCopy, $ = s.hideMove, T = s.hideAdd, I = s.addItem, _ = s.copyItem, E = s.moveItem, R = s.removeItem, O = function(B) {
    var F = c.getFieldValue(p.concat(B));
    _(F, B);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    className: classnames("fr-list-card", {
      "fr-list-card-background": A
    })
  }, d.map(function(L) {
    var B = L.key, F = L.name, M = d.length, W = cloneDeep(u);
    return W.items.title && typeof W.items.title == "string" && (W.items.title += " ".concat(F + 1)), /* @__PURE__ */ React.createElement("div", {
      key: B,
      className: "fr-list-item"
    }, /* @__PURE__ */ React.createElement("div", {
      style: {
        width: 0,
        flex: 1
      }
    }, v({
      schema: W,
      parentPath: [F],
      rootPath: [].concat(_toConsumableArray$4(p), [F])
    })), /* @__PURE__ */ React.createElement(Space, {
      className: classnames("fr-list-item-operate", {
        "fr-list-item-operate-fixed": getOperateFixed(u)
      }),
      style: getOperateStyle(u),
      split: x !== "icon" && /* @__PURE__ */ React.createElement(Divider, {
        type: "vertical"
      })
    }, !$ && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
      disabled: F === 0,
      onClick: function() {
        return E(F, F - 1);
      },
      icon: /* @__PURE__ */ React.createElement(_ArrowUpOutlined, null)
    }, m)), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
      disabled: F === M - 1,
      onClick: function() {
        return E(F, F + 1);
      },
      icon: /* @__PURE__ */ React.createElement(_ArrowDownOutlined, null)
    }, C))), !w && /* @__PURE__ */ React.createElement(Popconfirm, Object.assign({
      onConfirm: function() {
        return R(F);
      }
    }, b), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
      icon: /* @__PURE__ */ React.createElement(_CloseOutlined, null)
    }, f))), !S && /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
      onClick: function() {
        return O(F);
      },
      icon: /* @__PURE__ */ React.createElement(_CopyOutlined, null)
    }, y))));
  }), (!u.max || d.length < u.max) && !T && /* @__PURE__ */ React.createElement("div", {
    className: "fr-list-add-btn"
  }, /* @__PURE__ */ React.createElement(Button$1, Object.assign({}, g, {
    onClick: function() {
      return I();
    },
    icon: /* @__PURE__ */ React.createElement(_PlusOutlined, null),
    block: d.length > 0
  })))));
}, InfoCircleOutlined$1 = {}, InfoCircleOutlined = {}, hasRequiredInfoCircleOutlined$1;
function requireInfoCircleOutlined$1() {
  if (hasRequiredInfoCircleOutlined$1) return InfoCircleOutlined;
  hasRequiredInfoCircleOutlined$1 = 1, Object.defineProperty(InfoCircleOutlined, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" };
  return InfoCircleOutlined.default = a, InfoCircleOutlined;
}
var hasRequiredInfoCircleOutlined;
function requireInfoCircleOutlined() {
  if (hasRequiredInfoCircleOutlined) return InfoCircleOutlined$1;
  hasRequiredInfoCircleOutlined = 1;
  var a = requireInteropRequireDefault(), s = require_typeof$1();
  Object.defineProperty(InfoCircleOutlined$1, "__esModule", {
    value: !0
  }), InfoCircleOutlined$1.default = void 0;
  var c = a(requireObjectSpread2()), u = A(requireReact()), d = a(/* @__PURE__ */ requireInfoCircleOutlined$1()), p = a(/* @__PURE__ */ requireAntdIcon());
  function v(b) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (v = function(C) {
      return C ? f : y;
    })(b);
  }
  function A(b, y) {
    if (b && b.__esModule) return b;
    if (b === null || s(b) != "object" && typeof b != "function") return { default: b };
    var f = v(y);
    if (f && f.has(b)) return f.get(b);
    var m = { __proto__: null }, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b) if (w !== "default" && {}.hasOwnProperty.call(b, w)) {
      var S = C ? Object.getOwnPropertyDescriptor(b, w) : null;
      S && (S.get || S.set) ? Object.defineProperty(m, w, S) : m[w] = b[w];
    }
    return m.default = b, f && f.set(b, m), m;
  }
  var x = function(y, f) {
    return /* @__PURE__ */ u.createElement(p.default, (0, c.default)((0, c.default)({}, y), {}, {
      ref: f,
      icon: d.default
    }));
  }, g = /* @__PURE__ */ u.forwardRef(x);
  return InfoCircleOutlined$1.default = g, InfoCircleOutlined$1;
}
var InfoCircleOutlinedExports = /* @__PURE__ */ requireInfoCircleOutlined();
const _InfoCircleOutlined = /* @__PURE__ */ getDefaultExportFromCjs(InfoCircleOutlinedExports);
function _slicedToArray$7(a, s) {
  return _arrayWithHoles$7(a) || _iterableToArrayLimit$7(a, s) || _unsupportedIterableToArray$7(a, s) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$7(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$7(a, s) : void 0;
  }
}
function _arrayLikeToArray$7(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$7(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$7(a) {
  if (Array.isArray(a)) return a;
}
var TableCell = function a(s) {
  var c = s.renderCore, u = s.schema, d = s.dataIndex, p = __rest$15(s, ["renderCore", "schema", "dataIndex"]), v = reactExports.useState(null), A = _slicedToArray$7(v, 2), x = A[0], g = A[1], b = reactExports.useState(), y = _slicedToArray$7(b, 2), f = y[0], m = y[1], C = reactExports.useRef(null), w = function(I, _) {
    var E = _[0] || null;
    g(E), C.current && E && m(!0);
  };
  u.properties[d].onStatusChange || (u.properties[d].onStatusChange = w);
  var S = f && x, $ = {
    open: S
  };
  return window.antdVersion === "v4" && ($ = {
    visible: S
  }), /* @__PURE__ */ React.createElement("div", {
    className: "fr-table-cell-content",
    onMouseEnter: function() {
      C.current = !0, m(!0);
    },
    onMouseLeave: function() {
      C.current = !1, m(!1);
    }
  }, /* @__PURE__ */ React.createElement(Popover, Object.assign({
    overlayClassName: "fr-popover-error",
    content: x,
    placement: "topRight"
  }, $), c(Object.assign(Object.assign({}, p), {
    schema: u
  }))));
};
function _typeof$5(a) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$5(a);
}
function _toConsumableArray$3(a) {
  return _arrayWithoutHoles$3(a) || _iterableToArray$3(a) || _unsupportedIterableToArray$6(a) || _nonIterableSpread$3();
}
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$3(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$3(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$6(a);
}
function _defineProperty$4(a, s, c) {
  return (s = _toPropertyKey$4(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function _toPropertyKey$4(a) {
  var s = _toPrimitive$4(a, "string");
  return _typeof$5(s) == "symbol" ? s : s + "";
}
function _toPrimitive$4(a, s) {
  if (_typeof$5(a) != "object" || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof$5(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _slicedToArray$6(a, s) {
  return _arrayWithHoles$6(a) || _iterableToArrayLimit$6(a, s) || _unsupportedIterableToArray$6(a, s) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$6(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$6(a, s) : void 0;
  }
}
function _arrayLikeToArray$6(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$6(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$6(a) {
  if (Array.isArray(a)) return a;
}
var getTooltip$2 = function a(s) {
  if (s)
    return typeof s == "string" ? {
      title: /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s
        }
      })
    } : Object.assign(Object.assign({}, s), {
      title: /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s.title
        }
      })
    });
}, TableList$1 = function a(s) {
  var c, u, d = s.form, p = s.schema, v = s.fields, A = s.rootPath, x = s.renderCore, g = s.readOnly, b = s.operateBtnType, y = s.addBtnProps, f = s.delConfirmProps, m = s.copyBtnProps, C = s.deleteBtnProps, w = s.moveUpBtnProps, S = s.moveDownBtnProps, $ = s.actionColumnProps, T = s.pagination, I = s.hideDelete, _ = s.hideCopy, E = s.hideMove, R = s.hideAdd, O = s.hideOperate, L = s.hideEmptyTable, B = s.addItem, F = s.copyItem, M = s.moveItem, W = s.removeItem, j = s.configContext, G = s.validatePopover, U = __rest$15(s, ["form", "schema", "fields", "rootPath", "renderCore", "readOnly", "operateBtnType", "addBtnProps", "delConfirmProps", "copyBtnProps", "deleteBtnProps", "moveUpBtnProps", "moveDownBtnProps", "actionColumnProps", "pagination", "hideDelete", "hideCopy", "hideMove", "hideAdd", "hideOperate", "hideEmptyTable", "addItem", "copyItem", "moveItem", "removeItem", "configContext", "validatePopover"]), k = j.globalConfig, N = (c = G ?? k?.listValidatePopover) !== null && c !== void 0 ? c : !0, P = $.colHeaderText, D = __rest$15($, ["colHeaderText"]), H = ((u = p?.items) === null || u === void 0 ? void 0 : u.properties) || {}, V = Object.assign({
    size: "small",
    hideOnSinglePage: !0
  }, T), Z = function(Y) {
    var ee = d.getFieldValue(A.concat(Y));
    F(ee, Y);
  }, ne = sortProperties(Object.entries(H)).map(function(q) {
    var Y = _slicedToArray$6(q, 2), ee = Y[0], Q = Y[1], J = Q.required, te = Q.title, ae = Q.width, se = Q.tooltip, ie = Q.columnHidden;
    if (ie)
      return null;
    var fe = getTooltip$2(se);
    return {
      dataIndex: ee,
      width: ae,
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, J && /* @__PURE__ */ React.createElement("span", {
        style: {
          color: "red",
          marginRight: "3px"
        }
      }, "*"), /* @__PURE__ */ React.createElement("span", null, te), fe && /* @__PURE__ */ React.createElement(Tooltip, Object.assign({
        placement: "top"
      }, fe), /* @__PURE__ */ React.createElement(_InfoCircleOutlined, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function(me, pe) {
        var be = {
          type: "object",
          properties: _defineProperty$4({}, ee, Object.assign(Object.assign({}, H[ee]), {
            fieldCol: 24
          }))
        };
        return N ? /* @__PURE__ */ React.createElement(TableCell, {
          renderCore: x,
          schema: be,
          parentPath: [pe.name],
          rootPath: [].concat(_toConsumableArray$3(A), [pe.name]),
          dataIndex: ee
        }) : /* @__PURE__ */ React.createElement("div", {
          className: "fr-table-cell-content"
        }, x({
          parentPath: [pe.name],
          rootPath: [].concat(_toConsumableArray$3(A), [pe.name]),
          schema: be
        }));
      }
    };
  }).filter(function(q) {
    return q;
  });
  !g && !O && ne.push(Object.assign(Object.assign({
    title: P,
    width: "190px",
    fixed: "right"
  }, D), {
    render: function(Y, ee) {
      return /* @__PURE__ */ React.createElement(Form$1.Item, null, /* @__PURE__ */ React.createElement(Space, {
        className: "fr-list-item-operate",
        split: b !== "icon" && /* @__PURE__ */ React.createElement(Divider, {
          type: "vertical"
        })
      }, !E && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        disabled: ee.name === 0,
        onClick: function() {
          return M(ee.name, ee.name - 1);
        },
        icon: /* @__PURE__ */ React.createElement(_ArrowUpOutlined, null)
      }, w)), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        disabled: ee.name === v.length - 1,
        onClick: function() {
          return M(ee.name, ee.name + 1);
        },
        icon: /* @__PURE__ */ React.createElement(_ArrowDownOutlined, null)
      }, S))), !I && /* @__PURE__ */ React.createElement(Popconfirm, Object.assign({
        onConfirm: function() {
          return W(ee.name);
        }
      }, f), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        icon: /* @__PURE__ */ React.createElement(_CloseOutlined, null),
        btnType: b
      }, C))), !_ && /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        onClick: function() {
          return Z(ee.name);
        },
        icon: /* @__PURE__ */ React.createElement(_CopyOutlined, null)
      }, m))));
    }
  }));
  var K = v.length > 0 ? !0 : !L;
  return /* @__PURE__ */ React.createElement("div", {
    className: classnames("fr-table-list", {
      "fr-table-list-no-popover": !N
    })
  }, K && /* @__PURE__ */ React.createElement(ForwardTable, Object.assign({
    size: "middle",
    scroll: {
      x: "max-content"
    },
    style: {
      marginBottom: "12px"
    }
  }, U, {
    columns: ne,
    dataSource: v,
    pagination: V
  })), (!p.max || v.length < p.max) && !R && /* @__PURE__ */ React.createElement(Button$1, Object.assign({
    icon: /* @__PURE__ */ React.createElement(_PlusOutlined, null),
    onClick: function() {
      return B();
    }
  }, y)));
}, DrawerForm = function a(s) {
  var c = s.children, u = s.onConfirm, d = s.onClose, p = __rest$15(s, ["children", "onConfirm", "onClose"]), v = reactExports.useContext(ConfigProvider.ConfigContext), A = translation(v), x = Object.assign(Object.assign({}, p), {
    open: !0
  });
  return window.antdVersion === "v4" && (x = Object.assign(Object.assign({}, p), {
    visible: !0
  })), /* @__PURE__ */ React.createElement(Drawer, Object.assign({
    width: 600,
    title: A("operate")
  }, x, {
    onClose: d,
    extra: /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement(Button$1, {
      onClick: d
    }, A("cancel")), /* @__PURE__ */ React.createElement(Button$1, {
      type: "primary",
      onClick: u
    }, A("confirm")))
  }), c);
};
function _typeof$4(a) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$4(a);
}
function _defineProperty$3(a, s, c) {
  return (s = _toPropertyKey$3(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function _toPropertyKey$3(a) {
  var s = _toPrimitive$3(a, "string");
  return _typeof$4(s) == "symbol" ? s : s + "";
}
function _toPrimitive$3(a, s) {
  if (_typeof$4(a) != "object" || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof$4(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _toConsumableArray$2(a) {
  return _arrayWithoutHoles$2(a) || _iterableToArray$2(a) || _unsupportedIterableToArray$5(a) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$2(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$2(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$5(a);
}
function _slicedToArray$5(a, s) {
  return _arrayWithHoles$5(a) || _iterableToArrayLimit$5(a, s) || _unsupportedIterableToArray$5(a, s) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$5(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$5(a, s) : void 0;
  }
}
function _arrayLikeToArray$5(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$5(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$5(a) {
  if (Array.isArray(a)) return a;
}
var getTooltip$1 = function a(s) {
  if (s)
    return typeof s == "string" ? {
      title: /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s
        }
      })
    } : Object.assign(Object.assign({}, s), {
      title: /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s.title
        }
      })
    });
}, TableList = function a(s) {
  var c, u, d = s.form, p = s.schema, v = s.fields, A = s.rootPath, x = s.renderCore, g = s.readOnly, b = s.widgets, y = s.pagination, f = s.operateBtnType, m = s.addBtnProps, C = s.delConfirmProps, w = s.copyBtnProps, S = s.deleteBtnProps, $ = s.moveUpBtnProps, T = s.moveDownBtnProps, I = s.actionColumnProps, _ = s.editorBtnProps, E = s.drawerProps, R = s.hideOperate, O = s.hideDelete, L = s.hideCopy, B = s.hideMove, F = s.hideAdd, M = s.hideEdit, W = s.hideColumnNestedObject, j = s.operation, G = s.addItem, U = s.copyItem, k = s.moveItem, N = s.removeItem, P = s.configContext, D = I.colHeaderText, H = __rest$15(I, ["colHeaderText"]), V = Object.assign({
    size: "small",
    hideOnSinglePage: !0
  }, y), Z = ((c = p?.items) === null || c === void 0 ? void 0 : c.properties) || {}, ne = reactExports.useState(!1), K = _slicedToArray$5(ne, 2), q = K[0], Y = K[1], ee = reactExports.useState(null), Q = _slicedToArray$5(ee, 2), J = Q[0], te = Q[1], ae = reactExports.useRef(null), se = function(ve) {
    var he = d.getFieldValue(A.concat(ve));
    U(he, ve);
  }, ie = function() {
    Y(!0), G();
  }, fe = function() {
    !ae.current && ae.current !== 0 ? j.remove(v.length - 1) : d.setFieldValue([].concat(_toConsumableArray$2(A), [ae.current]), J), ge();
  }, ge = function() {
    te(null), Y(!1), ae.current = null;
  }, me = sortProperties(Object.entries(Z)).map(function(le) {
    var ve = _slicedToArray$5(le, 2), he = ve[0], ye = ve[1], Ce = ye.required, xe = ye.title, we = ye.tooltip, $e = ye.width, Ae = ye.columnHidden;
    if (Ae)
      return null;
    var ue = getTooltip$1(we);
    return {
      dataIndex: he,
      width: $e,
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, Ce && /* @__PURE__ */ React.createElement("span", {
        style: {
          color: "red",
          marginRight: "3px"
        }
      }, "*"), /* @__PURE__ */ React.createElement("span", null, xe), ue && /* @__PURE__ */ React.createElement(Tooltip, Object.assign({
        placement: "top"
      }, ue), /* @__PURE__ */ React.createElement(_InfoCircleOutlined, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function(Ee, _e) {
        var Te, ke = {
          type: "object",
          properties: _defineProperty$3({}, he, Object.assign(Object.assign({}, Z[he]), {
            noStyle: !0,
            readOnly: !0
          }))
        }, Re = ke.properties[he], Be = x({
          schema: ke,
          parentPath: [_e.name],
          rootPath: [].concat(_toConsumableArray$2(A), [_e.name])
        });
        return Re?.type === "array" && ((Te = Re?.items) === null || Te === void 0 ? void 0 : Te.type) === "object" || Re?.type === "object" ? W === "hide" ? "-" : W === "collapse" ? /* @__PURE__ */ React.createElement(Collapse$1, {
          ghost: !0,
          items: [{
            key: "detail",
            label: "查看详情",
            children: Be
          }]
        }) : Be : Be;
      }
    };
  }).filter(function(le) {
    return le;
  });
  !g && !R && me.push(Object.assign(Object.assign({
    title: D,
    width: "190px",
    fixed: "right"
  }, H), {
    render: function(ve, he) {
      return /* @__PURE__ */ React.createElement(Form$1.Item, null, /* @__PURE__ */ React.createElement(Space, {
        className: "fr-list-item-operate",
        split: f !== "icon" && /* @__PURE__ */ React.createElement(Divider, {
          type: "vertical"
        })
      }, !B && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        disabled: he.name === 0,
        onClick: function() {
          return k(he.name, he.name - 1);
        },
        icon: /* @__PURE__ */ React.createElement(_ArrowUpOutlined, null)
      }, $)), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        disabled: he.name === v.length - 1,
        onClick: function() {
          return k(he.name, he.name + 1);
        },
        icon: /* @__PURE__ */ React.createElement(_ArrowDownOutlined, null)
      }, T))), !O && /* @__PURE__ */ React.createElement(Popconfirm, Object.assign({
        onConfirm: function() {
          return N(he.name);
        }
      }, C), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        icon: /* @__PURE__ */ React.createElement(_CloseOutlined, null),
        btnType: f
      }, S))), !L && /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        onClick: function() {
          return se(he.name);
        },
        icon: /* @__PURE__ */ React.createElement(_CopyOutlined, null)
      }, w)), !M && /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        onClick: function() {
          Y(!0), ae.current = he.name, te(d.getFieldValue(A.concat(he.name)));
        },
        icon: /* @__PURE__ */ React.createElement(_CopyOutlined, null)
      }, _))));
    }
  }));
  var pe = (u = ae.current) !== null && u !== void 0 ? u : v.length - 1, be = function() {
    var ve, he = (ve = [].concat(_toConsumableArray$2(A), [pe])) === null || ve === void 0 ? void 0 : ve.join(".");
    d.validateFields([he], {
      recursive: !0
    }).then(function(ye) {
      ge();
    }).catch(function(ye) {
      console.log("表单校验错误", ye);
    });
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "fr-list-drawer"
  }, /* @__PURE__ */ React.createElement(ForwardTable, {
    size: "middle",
    dataSource: v,
    columns: me,
    style: {
      marginBottom: "12px"
    },
    scroll: {
      x: "max-content"
    },
    pagination: V
  }), (!p.max || v.length < p.max) && !F && /* @__PURE__ */ React.createElement(Button$1, Object.assign({
    icon: /* @__PURE__ */ React.createElement(_PlusOutlined, null),
    onClick: ie
  }, m)), q && /* @__PURE__ */ React.createElement(DrawerForm, Object.assign({}, E, {
    schema: p,
    data: J,
    widgets: b,
    configContext: P,
    onClose: fe,
    onConfirm: be
  }), x({
    schema: p.items,
    parentPath: [pe],
    rootPath: [].concat(_toConsumableArray$2(A), [pe])
  })));
};
function _slicedToArray$4(a, s) {
  return _arrayWithHoles$4(a) || _iterableToArrayLimit$4(a, s) || _unsupportedIterableToArray$4(a, s) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$4(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$4(a, s) : void 0;
  }
}
function _arrayLikeToArray$4(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$4(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$4(a) {
  if (Array.isArray(a)) return a;
}
var VirtualCell = function a(s) {
  var c = s.renderCore, u = s.schema, d = s.dataIndex, p = __rest$15(s, ["renderCore", "schema", "dataIndex"]), v = reactExports.useState(null), A = _slicedToArray$4(v, 2), x = A[0], g = A[1], b = reactExports.useState(), y = _slicedToArray$4(b, 2), f = y[0], m = y[1], C = reactExports.useRef(null), w = function(I, _) {
    var E = _[0] || null;
    g(E), C.current && E && m(!0);
  };
  u.properties[d].onStatusChange || (u.properties[d].onStatusChange = w);
  var S = f && x, $ = {
    open: S
  };
  return window.antdVersion === "v4" && ($ = {
    visible: S
  }), /* @__PURE__ */ React.createElement("div", {
    onMouseEnter: function() {
      C.current = !0, m(!0);
    },
    onMouseLeave: function() {
      C.current = !1, m(!1);
    }
  }, /* @__PURE__ */ React.createElement(Popover, Object.assign({
    overlayClassName: "fr-popover-error",
    content: x,
    placement: "topRight"
  }, $), c(Object.assign(Object.assign({}, p), {
    schema: u
  }))));
};
function _typeof$3(a) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$3(a);
}
var _excluded = ["style", "context"], _excluded2 = ["ctx"];
function ownKeys(a, s) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(a);
    s && (u = u.filter(function(d) {
      return Object.getOwnPropertyDescriptor(a, d).enumerable;
    })), c.push.apply(c, u);
  }
  return c;
}
function _objectSpread(a) {
  for (var s = 1; s < arguments.length; s++) {
    var c = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys(Object(c), !0).forEach(function(u) {
      _defineProperty$2(a, u, c[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(c)) : ownKeys(Object(c)).forEach(function(u) {
      Object.defineProperty(a, u, Object.getOwnPropertyDescriptor(c, u));
    });
  }
  return a;
}
function _defineProperty$2(a, s, c) {
  return s = _toPropertyKey$2(s), s in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function _toPropertyKey$2(a) {
  var s = _toPrimitive$2(a, "string");
  return _typeof$3(s) === "symbol" ? s : String(s);
}
function _toPrimitive$2(a, s) {
  if (_typeof$3(a) !== "object" || a === null) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof$3(u) !== "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _objectWithoutProperties(a, s) {
  if (a == null) return {};
  var c = _objectWithoutPropertiesLoose(a, s), u, d;
  if (Object.getOwnPropertySymbols) {
    var p = Object.getOwnPropertySymbols(a);
    for (d = 0; d < p.length; d++)
      u = p[d], !(s.indexOf(u) >= 0) && Object.prototype.propertyIsEnumerable.call(a, u) && (c[u] = a[u]);
  }
  return c;
}
function _objectWithoutPropertiesLoose(a, s) {
  if (a == null) return {};
  var c = {}, u = Object.keys(a), d, p;
  for (p = 0; p < u.length; p++)
    d = u[p], !(s.indexOf(d) >= 0) && (c[d] = a[d]);
  return c;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(a) {
    for (var s = 1; s < arguments.length; s++) {
      var c = arguments[s];
      for (var u in c)
        Object.prototype.hasOwnProperty.call(c, u) && (a[u] = c[u]);
    }
    return a;
  }, _extends.apply(this, arguments);
}
var SCROLLEVT_NULL = 0, SCROLLEVT_INIT = 1, SCROLLEVT_RECOMPUTE = 2, SCROLLEVT_NATIVE = 8, SCROLLEVT_BY_HOOK = 64, TOP_CONTINUE = 0, TOP_DONE = 1, e_VT_STATE;
(function(a) {
  a[a.INIT = 1] = "INIT", a[a.LOADED = 2] = "LOADED", a[a.RUNNING = 4] = "RUNNING";
})(e_VT_STATE || (e_VT_STATE = {}));
function default_context() {
  return {
    vt_state: e_VT_STATE.INIT,
    possible_hight_per_tr: -1,
    computed_h: 0,
    re_computed: 0,
    row_height: [],
    row_count: 0,
    prev_row_count: 0,
    _offset_top: 0,
    _offset_head: 0,
    _offset_tail: 1,
    WH: 0,
    // the wrapper's height
    top: 0,
    left: 0,
    evt: SCROLLEVT_NULL,
    end: !1,
    final_top: 0,
    f_final_top: TOP_DONE,
    update_count: 0,
    indexMap: /* @__PURE__ */ new WeakMap(),
    HND_PAINT: 0,
    retry_count: 5
  };
}
function log_debug(a, s) {
  if (a.debug) {
    if (s[0] === "+")
      return console.debug(s.slice(1));
    var c = /* @__PURE__ */ new Date(), u = "".concat(c.toLocaleTimeString(), ".").concat(c.getMilliseconds());
    console.debug("%c[".concat(a.id, "][").concat(u, "][").concat(s, "]"), "color:#a00", a);
  }
}
var TableImpl = /* @__PURE__ */ reactExports.forwardRef(function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement("table", _extends({
    ref: c
  }, s));
});
function WrapperImpl(a) {
  return /* @__PURE__ */ reactExports.createElement("tbody", a);
}
var RowImpl = /* @__PURE__ */ reactExports.forwardRef(function a(s, c) {
  return /* @__PURE__ */ reactExports.createElement("tr", _extends({
    ref: c
  }, s));
});
function scroll_with_offset(a, s) {
  var c = a.row_height, u = a.row_count, d = a.overscanRowCount;
  a._scroll_y = a.scroll.y, typeof a._scroll_y == "number" ? a._y = a._scroll_y : (typeof a._scroll_y == "string" || console.assert(!1, "VT: did you forget to set `scroll.y`?"), a._y = a.wrap_inst.current.parentElement.offsetHeight), console.assert(a._y >= 0);
  var p = 0, v = 0, A = 0, x = 0;
  if (s === -1 && u > 0) {
    for (v = u; v > 0 && x < a._y; )
      x += c[--v];
    return [0 | v, 0 | u, 0 | a.computed_h - x];
  }
  for (; v < u && p < s; ++v)
    p += c[v];
  for (A = v; A < u && x < a._y; ++A)
    x += c[A];
  for (var g = d < 0 ? 0 : d; v > 0 && g--; )
    p -= c[--v];
  return A += d, A > u && (A = u), [0 | v, 0 | A, 0 | p];
}
function set_offset(a, s, c, u) {
  a._offset_top = 0 | s, a._offset_head = 0 | c, a._offset_tail = 0 | u;
}
function set_scroll(a, s, c, u, d) {
  a.top = s, a.left = c, a.evt = u, a.end = d;
}
function scroll_to(a, s, c) {
  if (a.wrap_inst.current) {
    var u = a.wrap_inst.current.parentElement;
    u.scrollTop = s, u.scrollLeft = Math.max(c, u.scrollLeft);
  }
}
function repainting(a) {
  if (!a.HND_PAINT) {
    var s = a.cq, c = a.wrap_inst, u = function() {
      a.HND_PAINT = 0;
      for (var p = 0; p < s.length; ++p)
        s[p].index >= a._offset_head && s[p].index < a._offset_tail && s[p].func();
      if (!(a.vt_state !== e_VT_STATE.RUNNING || !c.current)) {
        var v = a.computed_h;
        if (a.WH !== v) {
          a.WH = v;
          var A = c.current.style;
          A.height = v ? (A.maxHeight = v + "px", A.maxHeight) : (A.maxHeight = "unset", A.maxHeight), a.on_update_wrap_style();
        }
      }
    };
    a.HND_PAINT = a.evt === SCROLLEVT_NATIVE ? window.requestAnimationFrame(u) : window.setTimeout(u);
  }
}
function srs_expand(a, s, c, u) {
  var d = s - c, p = new Array(d).fill(u);
  a.row_height = a.row_height.concat(p), a.computed_h += d * u;
}
function srs_shrink(a, s, c) {
  if (s === 0) {
    a.computed_h = 0, a.row_height.length = 0, a.top = 0;
    return;
  }
  for (var u = a.row_height, d = 0, p = s; p < c; ++p)
    d += u[p];
  a.computed_h -= d;
}
function set_tr_cnt(a, s) {
  a.re_computed = s - a.row_count, a.prev_row_count = a.row_count, a.row_count = s;
}
var VTable = function a(s, c) {
  var u = s.style, d = s.context, p = _objectWithoutProperties(s, _excluded), v = reactExports.useState(0), A = reactExports.useRef(function() {
  }), x, g = reactExports.useMemo(function() {
    return /* @__PURE__ */ reactExports.createRef();
  }, []), b = reactExports.useContext(d);
  reactExports.useMemo(function() {
    Object.assign(b, default_context()), b.wrap_inst && b.wrap_inst.current && b.wrap_inst.current.parentElement.removeEventListener("scroll", x), b.wrap_inst = g, b.top = b.initTop, b.on_update_wrap_style = function() {
      b._y === 0 && "".concat(b._scroll_y).length && x({
        flag: SCROLLEVT_BY_HOOK,
        target: {
          scrollTop: b.top,
          scrollLeft: b.left
        }
      });
    }, b.cq = [];
    var $ = 0, T = 0;
    b.cq.push = function(I) {
      if (b.vt_state === e_VT_STATE.RUNNING) {
        var _ = b._offset_tail - b._offset_head + b.overscanRowCount * 2 + 10;
        return T = Math.max(T, _), $ > T && ($ = 0), b.cq[$++] = I, 0;
      }
    };
  }, []);
  var y = reactExports.useRef([]).current, f;
  x = reactExports.useCallback(function($) {
    if (b.vt_state === e_VT_STATE.RUNNING) {
      var T = performance.now();
      if ($) {
        if ("flag" in $)
          y.push($);
        else {
          var I = $.target, _ = Math.max(I.scrollTop, 0);
          y.push({
            target: {
              scrollTop: _,
              scrollLeft: I.scrollLeft
            },
            end: Math.abs(I.scrollHeight - I.clientHeight - Math.round(_)) <= (b.offset || 0),
            flag: SCROLLEVT_NATIVE
          });
        }
        if (b.f_final_top === TOP_CONTINUE)
          return f(T);
      }
      b.HND_RAF || (b.HND_RAF = window.setTimeout(function() {
        return Promise.resolve().then(function() {
          return f(T);
        });
      }));
    }
  }, []), f = reactExports.useCallback(function($) {
    b.HND_RAF = 0;
    var T = performance.now();
    if (T - $ > 10 && b.retry_count-- > 0) {
      x();
      return;
    }
    if (b.retry_count = 5, b.vt_state === e_VT_STATE.RUNNING) {
      var I = y, _;
      if (I.length) {
        _ = I.pop(), I.length = 0;
        var E = _.target.scrollTop, R = _.target.scrollLeft, O = _.flag;
        log_debug(b, "top: ".concat(E, ", left: ").concat(R));
        var L = scroll_with_offset(b, b.f_final_top === TOP_CONTINUE ? b.final_top : E), B = L[0], F = L[1], M = L[2], W = b._offset_head, j = b._offset_tail, G = b._offset_top, U = !1;
        switch (O) {
          case SCROLLEVT_INIT:
            log_debug(b, "SCROLLEVT_INIT");
            break;
          case SCROLLEVT_BY_HOOK:
            log_debug(b, "SCROLLEVT_BY_HOOK"), B === W && F === j && M === G ? (b.f_final_top = TOP_DONE, b.final_top === -1 && (E = b.computed_h - b._y), U = !0) : b.final_top === -1 && (E = M);
            break;
          case SCROLLEVT_RECOMPUTE:
            if (B === W && F === j && M === G)
              return;
            log_debug(b, "SCROLLEVT_RECOMPUTE");
            break;
          case SCROLLEVT_NATIVE:
            if (B === W && F === j && M === G)
              return;
            log_debug(b, "SCROLLEVT_NATIVE"), b.onScroll && b.onScroll({
              top: E,
              left: R,
              isEnd: _.end
            }), U = _.end;
            break;
        }
        set_offset(b, M, B, F), set_scroll(b, E, R, O, U), v[1](++b.update_count);
      }
    }
  }, []), reactExports.useImperativeHandle(c, function() {
    var $ = function(I) {
      b.f_final_top = TOP_CONTINUE, b.final_top = I, x({
        target: {
          scrollTop: I,
          scrollLeft: -1
        },
        flag: SCROLLEVT_BY_HOOK
      });
    };
    return {
      scrollTo: function(I) {
        A.current = function() {
          return $(I);
        }, A.current();
      },
      scrollToIndex: function(I) {
        A.current = function() {
          I > b.row_count - 1 && (I = b.row_count - 1), I < 0 && (I = 0);
          for (var _ = 0, E = 0; E < I; ++E)
            _ += b.row_height[E];
          $(_);
        }, A.current();
      }
    };
  }, []), reactExports.useEffect(function() {
    var $ = g.current.parentElement;
    try {
      $.addEventListener("scroll", x, {
        passive: !0
      });
    } catch {
      $.addEventListener("scroll", x, !1);
    }
  }, [g.current]), reactExports.useEffect(function() {
    x({
      flag: SCROLLEVT_BY_HOOK,
      target: {
        scrollLeft: b.left,
        scrollTop: b.top
      }
    });
  }, [b.scroll.y]), reactExports.useEffect(function() {
    switch (b.evt) {
      case SCROLLEVT_BY_HOOK:
        b.f_final_top === TOP_CONTINUE ? A.current() : scroll_to(b, b.top, b.left);
        break;
      case SCROLLEVT_INIT:
      case SCROLLEVT_RECOMPUTE:
        scroll_to(b, b.top, b.left);
        break;
    }
  }, [
    v[0]
    /* for performance. */
  ]), reactExports.useEffect(function() {
    switch (b.vt_state) {
      case e_VT_STATE.LOADED:
        b.vt_state = e_VT_STATE.RUNNING, x({
          target: {
            scrollTop: b.top,
            scrollLeft: 0
          },
          flag: SCROLLEVT_BY_HOOK
        });
        break;
      case e_VT_STATE.RUNNING:
        b.re_computed !== 0 && (b.re_computed = 0, x({
          target: {
            scrollTop: b.top,
            scrollLeft: b.left
          },
          flag: SCROLLEVT_RECOMPUTE
        }));
        break;
    }
  });
  var m = reactExports.useMemo(function() {
    return {
      width: u.width,
      minWidth: "100%",
      position: "relative",
      transform: "translate(0)"
    };
  }, [u.width]), C = reactExports.useMemo(function() {
    return _objectSpread(_objectSpread({}, u), {}, {
      width: void 0,
      position: "relative",
      top: b._offset_top,
      transform: "translate(0)"
    });
  }, [b._offset_top]), w = reactExports.useMemo(function() {
    return _objectSpread({}, b);
  }, [b.update_count]), S = b.components.table;
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: g,
    style: m
  }, /* @__PURE__ */ reactExports.createElement(d.Provider, {
    value: w
  }, /* @__PURE__ */ reactExports.createElement(S, _extends({}, p, {
    style: C
  }))));
}, VWrapper = function a(s) {
  var c = s.children, u = s.className, d = s.ctx, p = c[0], v = c[1], A = Array.isArray(v) ? v.length : 0, x = d._offset_head, g = d._offset_tail, b = [];
  switch (d.vt_state) {
    case e_VT_STATE.INIT:
      A >= 0 && (console.assert(x === 0), console.assert(g === 1), Array.isArray(v) ? (b = v.slice(x, g), d.indexMap.set(b[0].props.record, 0)) : b = v, d.re_computed = A, d.prev_row_count = A, d.row_count = A);
      break;
    case e_VT_STATE.RUNNING:
      {
        if (g > A) {
          var y = g - A;
          g -= y, x -= y, x < 0 && (x = 0), g < 0 && (g = 0), set_offset(d, d._offset_top, x, g);
        }
        d.row_count !== A && set_tr_cnt(d, A), A = d.row_count;
        var f = d.prev_row_count;
        if (A < f)
          srs_shrink(d, A, f);
        else if (A > f) {
          var m = d.row_height;
          A - m.length > 0 ? srs_expand(d, A, f, d.possible_hight_per_tr) : (m.fill(d.possible_hight_per_tr, f, A), d.computed_h += d.possible_hight_per_tr * (A - f));
        }
        if (A) {
          var C = x;
          b = v.slice(C, g), b.forEach(function(S) {
            return d.indexMap.set(S.props.record, C++);
          });
        } else
          b = v;
        d.prev_row_count = d.row_count;
      }
      break;
    case e_VT_STATE.LOADED:
      console.assert(!1);
      break;
  }
  var w = d.components.body.wrapper;
  return /* @__PURE__ */ reactExports.createElement(w, {
    className: u
  }, p, b);
}, VTRow = function a(s) {
  var c = /* @__PURE__ */ reactExports.createRef(), u = s.ctx, d = _objectWithoutProperties(s, _excluded2), p = s.children, v = u.components.body.row;
  if (!Array.isArray(p))
    return /* @__PURE__ */ reactExports.createElement(v, d, p);
  var A = p[0].props, x = u.indexMap.get(A.record), g = reactExports.useRef(x), b = reactExports.useMemo(function() {
    return ".".concat(A.prefixCls, "-expanded-row");
  }, [A.prefixCls]), y = performance.now();
  return reactExports.useLayoutEffect(function() {
    var f = performance.now();
    return log_debug(u, "+idx ".concat(x, " tooks ").concat(f - y, " ms")), u.vt_state === e_VT_STATE.RUNNING ? repainting(u) : (u.possible_hight_per_tr = c.current.offsetHeight, srs_expand(u, u.row_count, 0, u.possible_hight_per_tr), repainting(u), u.vt_state = e_VT_STATE.LOADED), function() {
      repainting(u);
    };
  }, []), reactExports.useEffect(function() {
    u.cq.push({
      index: x,
      func: function() {
        var m = c.current;
        if (m) {
          for (var C = m.offsetHeight, w = m.nextSibling; w && w.matches(b); )
            C += w.offsetHeight, w = w.nextSibling;
          var S = u.row_height[x], $ = u.row_height[g.current];
          u.computed_h -= S, u.computed_h += $, u.computed_h += C - $, u.row_height[x] = C;
        }
      }
    }), repainting(u);
  }), /* @__PURE__ */ reactExports.createElement(v, _extends({}, d, {
    ref: c
  }));
};
function _set_components(a, s) {
  var c = s.table, u = s.body, d = s.header;
  a.components.body = _objectSpread(_objectSpread({}, a.components.body), u), u && u.cell && (a._vtcomponents.body.cell = u.cell), d && (a.components.header = d, a._vtcomponents.header = d), c && (a.components.table = c);
}
function init(a, s) {
  var c = reactExports.useRef(/* @__PURE__ */ reactExports.createContext({})).current, u = reactExports.useContext(c), d = reactExports.useRef({
    scrollTo: function(v) {
    },
    scrollToIndex: function(v) {
    }
  });
  return reactExports.useMemo(function() {
    return Object.assign(u, {
      id: (+/* @__PURE__ */ new Date()).toString(36).slice(4),
      initTop: 0,
      overscanRowCount: 5,
      debug: !1,
      ref: d
    }, a());
  }, s), reactExports.useMemo(function() {
    var p = /* @__PURE__ */ reactExports.forwardRef(VTable);
    u._vtcomponents = {
      table: function(A) {
        return /* @__PURE__ */ reactExports.createElement(p, _extends({}, A, {
          context: c,
          ref: u.ref
        }));
      },
      body: {
        // https://github.com/react-component/table/blob/master/src/Body/index.tsx#L114
        wrapper: function(A) {
          return /* @__PURE__ */ reactExports.createElement(c.Consumer, null, function() {
            return /* @__PURE__ */ reactExports.createElement(VWrapper, _extends({}, A, {
              ctx: u
            }));
          });
        },
        row: function(A) {
          return /* @__PURE__ */ reactExports.createElement(VTRow, _extends({}, A, {
            ctx: u
          }));
        }
      }
    }, u.components = {}, _set_components(u, {
      table: TableImpl,
      body: {
        wrapper: WrapperImpl,
        row: RowImpl
      }
    }), u.vt_state = e_VT_STATE.INIT;
  }, []), u;
}
function _typeof$2(a) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$2(a);
}
var _brower = 1, _node = 2;
(function() {
  var a = (typeof window > "u" ? "undefined" : _typeof$2(window)) === "object" && window instanceof Window ? _brower : _node;
  if (a & _brower && !Object.hasOwnProperty.call(window, "requestAnimationFrame") && !window.requestAnimationFrame)
    throw new Error("Please using the modern browers or appropriate polyfill!");
})();
function useVT(a, s) {
  var c = init(a, s || []);
  return [c._vtcomponents, function(u) {
    return _set_components(c, u);
  }, c.ref];
}
function _typeof$1(a) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$1(a);
}
function _toConsumableArray$1(a) {
  return _arrayWithoutHoles$1(a) || _iterableToArray$1(a) || _unsupportedIterableToArray$3(a) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles$1(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$3(a);
}
function _defineProperty$1(a, s, c) {
  return (s = _toPropertyKey$1(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function _toPropertyKey$1(a) {
  var s = _toPrimitive$1(a, "string");
  return _typeof$1(s) == "symbol" ? s : s + "";
}
function _toPrimitive$1(a, s) {
  if (_typeof$1(a) != "object" || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof$1(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _slicedToArray$3(a, s) {
  return _arrayWithHoles$3(a) || _iterableToArrayLimit$3(a, s) || _unsupportedIterableToArray$3(a, s) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$3(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$3(a, s) : void 0;
  }
}
function _arrayLikeToArray$3(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$3(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$3(a) {
  if (Array.isArray(a)) return a;
}
var getTooltip = function a(s) {
  if (s)
    return typeof s == "string" ? {
      title: /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s
        }
      })
    } : Object.assign(Object.assign({}, s), {
      title: /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s.title
        }
      })
    });
}, VirtualList = function a(s) {
  var c, u, d = s.form, p = s.schema, v = s.fields, A = s.rootPath, x = s.renderCore, g = s.readOnly, b = s.operateBtnType, y = s.addBtnProps, f = s.delConfirmProps, m = s.copyBtnProps, C = s.deleteBtnProps, w = s.moveUpBtnProps, S = s.moveDownBtnProps, $ = s.actionColumnProps, T = s.scrollY, I = T === void 0 ? 600 : T, _ = s.hideDelete, E = s.hideCopy, R = s.hideMove, O = s.hideAdd, L = s.hideOperate, B = s.hideEmptyTable, F = s.addItem, M = s.copyItem, W = s.moveItem, j = s.removeItem, G = s.configContext, U = s.validatePopover, k = G.globalConfig, N = (c = U ?? k?.listValidatePopover) !== null && c !== void 0 ? c : !0, P = $.colHeaderText, D = __rest$15($, ["colHeaderText"]), H = ((u = p?.items) === null || u === void 0 ? void 0 : u.properties) || {}, V = useVT(function() {
    return {
      scroll: {
        y: I
      }
    };
  }, []), Z = _slicedToArray$3(V, 2), ne = Z[0];
  Z[1];
  var K = function(Q) {
    var J = d.getFieldValue(A.concat(Q));
    M(J, Q);
  }, q = sortProperties(Object.entries(H)).map(function(ee) {
    var Q = _slicedToArray$3(ee, 2), J = Q[0], te = Q[1], ae = te.required, se = te.title, ie = te.width, fe = te.tooltip, ge = getTooltip(fe);
    return {
      dataIndex: J,
      width: ie,
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, ae && /* @__PURE__ */ React.createElement("span", {
        style: {
          color: "red",
          marginRight: "3px"
        }
      }, "*"), /* @__PURE__ */ React.createElement("span", null, se), ge && /* @__PURE__ */ React.createElement(Tooltip, Object.assign({
        placement: "top"
      }, ge), /* @__PURE__ */ React.createElement(_InfoCircleOutlined, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function(pe, be) {
        var le = {
          type: "object",
          properties: _defineProperty$1({}, J, Object.assign(Object.assign({}, H[J]), {
            fieldCol: 24
          }))
        };
        return N ? /* @__PURE__ */ React.createElement(VirtualCell, {
          renderCore: x,
          schema: le,
          parentPath: [be.name],
          rootPath: [].concat(_toConsumableArray$1(A), [be.name]),
          dataIndex: J
        }) : /* @__PURE__ */ React.createElement("div", {
          className: "fr-table-cell-content"
        }, x({
          parentPath: [be.name],
          rootPath: [].concat(_toConsumableArray$1(A), [be.name]),
          schema: le
        }));
      }
    };
  });
  !g && !L && q.push(Object.assign(Object.assign({
    title: P,
    width: "190px",
    fixed: "right"
  }, D), {
    render: function(Q, J) {
      return /* @__PURE__ */ React.createElement(Form$1.Item, null, /* @__PURE__ */ React.createElement(Space, {
        className: "fr-list-item-operate",
        split: b !== "icon" && /* @__PURE__ */ React.createElement(Divider, {
          type: "vertical"
        })
      }, !R && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        disabled: J.name === 0,
        onClick: function() {
          return W(J.name, J.name - 1);
        },
        icon: /* @__PURE__ */ React.createElement(_ArrowUpOutlined, null)
      }, w)), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        disabled: J.name === v.length - 1,
        onClick: function() {
          return W(J.name, J.name + 1);
        },
        icon: /* @__PURE__ */ React.createElement(_ArrowDownOutlined, null)
      }, S))), !_ && /* @__PURE__ */ React.createElement(Popconfirm, Object.assign({
        onConfirm: function() {
          return j(J.name);
        }
      }, f), /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        icon: /* @__PURE__ */ React.createElement(_CloseOutlined, null),
        btnType: b
      }, C))), !E && /* @__PURE__ */ React.createElement(HeaderTitle, Object.assign({
        onClick: function() {
          return K(J.name);
        },
        icon: /* @__PURE__ */ React.createElement(_CopyOutlined, null)
      }, m))));
    }
  }));
  var Y = v.length > 0 ? !0 : !B;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, Y && /* @__PURE__ */ React.createElement(ForwardTable, {
    className: classnames("fr-virtual-list", {
      "fr-virtual-list-no-popover": !N
    }),
    size: "middle",
    columns: q,
    dataSource: v,
    pagination: !1,
    scroll: {
      y: I
    },
    components: ne
  }), (!p.max || v.length < p.max) && !O && /* @__PURE__ */ React.createElement(Button$1, Object.assign({
    icon: /* @__PURE__ */ React.createElement(_PlusOutlined, null),
    onClick: function() {
      return F();
    }
  }, y)));
};
function _slicedToArray$2(a, s) {
  return _arrayWithHoles$2(a) || _iterableToArrayLimit$2(a, s) || _unsupportedIterableToArray$2(a, s) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$2(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$2(a) {
  if (Array.isArray(a)) return a;
}
function _toConsumableArray(a) {
  return _arrayWithoutHoles(a) || _iterableToArray(a) || _unsupportedIterableToArray$2(a) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$2(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$2(a, s) : void 0;
  }
}
function _iterableToArray(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function _arrayWithoutHoles(a) {
  if (Array.isArray(a)) return _arrayLikeToArray$2(a);
}
function _arrayLikeToArray$2(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
var TabPaneContent = function a(s) {
  var c = s.renderCore, u = s.name, d = s.schema, p = s.rootPath;
  return reactExports.useMemo(function() {
    return /* @__PURE__ */ React.createElement("div", {
      style: {
        flex: 1
      }
    }, c({
      schema: d,
      parentPath: [u],
      rootPath: [].concat(_toConsumableArray(p), [u])
    }));
  }, [JSON.stringify(s)]);
}, TabList = function a(s) {
  var c = s.schema, u = s.fields, d = s.rootPath, p = s.renderCore, v = s.readOnly, A = s.delConfirmProps, x = s.tabName, g = s.hideDelete, b = s.hideAdd, y = s.addItem, f = s.removeItem, m = s.tabItemProps, C = m === void 0 ? {} : m, w = s.activeKey, S = __rest$15(s, ["schema", "fields", "rootPath", "renderCore", "readOnly", "delConfirmProps", "tabName", "hideDelete", "hideAdd", "addItem", "removeItem", "tabItemProps", "activeKey"]), $ = reactExports.useState("0"), T = _slicedToArray$2($, 2), I = T[0], _ = T[1], E = reactExports.useContext(ConfigProvider.ConfigContext), R = translation(E);
  reactExports.useEffect(function() {
    _(w || "0");
  }, [w]);
  var O = function(W) {
    return x instanceof Array ? x[W] || W + 1 : "".concat(x || R("item"), " ").concat(W + 1);
  }, L = function(W) {
    f(W), _("".concat(W > 1 ? W - 1 : 0));
  }, B = function(W, j) {
    if (j === "add" && (!c.max || u.length < c.max) && !v && !b) {
      y();
      var G = u.length;
      _("".concat(G));
    }
  }, F = function(W) {
    return !v && !g ? /* @__PURE__ */ React.createElement(Popconfirm, Object.assign({
      onConfirm: function() {
        return L(W);
      }
    }, A), /* @__PURE__ */ React.createElement(_CloseOutlined, null)) : /* @__PURE__ */ React.createElement(React.Fragment, null);
  };
  return /* @__PURE__ */ React.createElement(Tabs, Object.assign({
    className: "fr-tab-list",
    type: "editable-card"
  }, S, {
    onChange: _,
    activeKey: "".concat(I),
    onEdit: B,
    hideAdd: v || b
  }), u.map(function(M) {
    var W = M.key, j = M.name;
    return /* @__PURE__ */ React.createElement(Tabs.TabPane, Object.assign({
      key: W,
      className: "fr-list-item"
    }, C, {
      tab: O(j),
      closeIcon: F(j)
    }), /* @__PURE__ */ React.createElement(TabPaneContent, {
      name: j,
      rootPath: d,
      schema: c,
      renderCore: p
    }));
  }));
};
function _typeof(a) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof(a);
}
function _defineProperty(a, s, c) {
  return (s = _toPropertyKey(s)) in a ? Object.defineProperty(a, s, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = c, a;
}
function _toPropertyKey(a) {
  var s = _toPrimitive(a, "string");
  return _typeof(s) == "symbol" ? s : s + "";
}
function _toPrimitive(a, s) {
  if (_typeof(a) != "object" || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, s);
    if (_typeof(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
const index = function(a) {
  var s = a.schema;
  return /* @__PURE__ */ React.createElement("div", {
    className: classnames("fr-void-title", _defineProperty({}, s?.className, !!s?.className))
  }, s.title);
};
var ErrorSchema = function a(s) {
  var c = reactExports.useContext(ConfigProvider.ConfigContext), u = translation(c);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    style: {
      color: "red"
    }
  }, u("schema_not_match")), /* @__PURE__ */ React.createElement("div", null, JSON.stringify(s)));
};
const defaultWidgets = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Card: BoxCard,
  CardList,
  Checkbox,
  Checkboxes: Checkboxes$1,
  Collapse: BoxCollapse,
  Color,
  DatePicker,
  DateRange: DateRange$1,
  DrawerList: TableList,
  ErrorSchema,
  Html: html,
  ImageInput: ImageInput$1,
  Input,
  InputNumber,
  LineTitle: FLineTitle,
  MultiSelect,
  PercentSlider,
  Radio,
  Rate: index$1,
  Select: MultiSelect,
  SimpleList,
  Slider,
  SubInline: BoxSubInline,
  Switch,
  TabList,
  TableList: TableList$1,
  TextArea: TextArea$1,
  TimePicker,
  TimeRange,
  TreeSelect,
  Upload: FrUpload,
  UrlInput: UrlInput$1,
  VirtualList,
  VoidTitle: index
}, Symbol.toStringTag, { value: "Module" }));
function _slicedToArray$1(a, s) {
  return _arrayWithHoles$1(a) || _iterableToArrayLimit$1(a, s) || _unsupportedIterableToArray$1(a, s) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray$1(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray$1(a, s) : void 0;
  }
}
function _arrayLikeToArray$1(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit$1(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles$1(a) {
  if (Array.isArray(a)) return a;
}
function flattenSchema() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 ? arguments[1] : void 0, c = arguments.length > 2 ? arguments[2] : void 0, u = arguments.length > 3 ? arguments[3] : void 0, d = u || {}, p = _cloneDeep(a) || {}, v = s || "#";
  p.$id || (p.$id = v);
  var A = [];
  return isObjType(p) && (sortProperties(Object.entries(p.properties)).forEach(function(x) {
    var g = _slicedToArray$1(x, 2), b = g[0], y = g[1], f = isListType(y) ? b + "[]" : b, m = v === "#" ? f : v + "." + f;
    A.push(m), flattenSchema(y, m, v, d);
  }), p.properties = {}), isListType(p) && (sortProperties(Object.entries(p.items.properties)).forEach(function(x) {
    var g = _slicedToArray$1(x, 2), b = g[0], y = g[1], f = isListType(y) ? b + "[]" : b, m = v === "#" ? f : v + "." + f;
    A.push(m), flattenSchema(y, m, v, d);
  }), p.items.properties = {}), p.type && (d[v] = {
    parent: c,
    schema: p,
    children: A
  }), d;
}
function _slicedToArray(a, s) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, s) || _unsupportedIterableToArray(a, s) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(a, s) {
  if (a) {
    if (typeof a == "string") return _arrayLikeToArray(a, s);
    var c = {}.toString.call(a).slice(8, -1);
    return c === "Object" && a.constructor && (c = a.constructor.name), c === "Map" || c === "Set" ? Array.from(a) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray(a, s) : void 0;
  }
}
function _arrayLikeToArray(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var c = 0, u = Array(s); c < s; c++) u[c] = a[c];
  return u;
}
function _iterableToArrayLimit(a, s) {
  var c = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (c != null) {
    var u, d, p, v, A = [], x = !0, g = !1;
    try {
      if (p = (c = c.call(a)).next, s !== 0) for (; !(x = (u = p.call(c)).done) && (A.push(u.value), A.length !== s); x = !0) ;
    } catch (b) {
      g = !0, d = b;
    } finally {
      try {
        if (!x && c.return != null && (v = c.return(), Object(v) !== v)) return;
      } finally {
        if (g) throw d;
      }
    }
    return A;
  }
}
function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}
var updateSchemaByPath = function a(s, c, u) {
  var d = getSchemaFullPath(s, u), p = _get(u, d, {}), v = isFunction$1(c) ? c(p) : c, A = Object.assign(Object.assign({}, p), v);
  v.props && (A.props = Object.assign(Object.assign({}, p?.props), v.props)), _set(u, d, A);
}, getFieldName = function a(s) {
  if (s) {
    if (typeof s == "boolean")
      return s;
    var c = [];
    return isArray$1(s) && (c = s.map(function(u) {
      return u.split(".").map(function(d) {
        return isNaN(Number(d)) ? d : d * 1;
      });
    })), c = s.split(".").map(function(u) {
      return isNaN(Number(u)) ? u : u * 1;
    }), c = c.map(function(u) {
      return typeof u == "string" && u?.indexOf("[") === 0 && u?.indexOf("]") === u?.length - 1 ? Number(u.substring(1, u.length - 1)) : u;
    }), c;
  }
}, useForm = function a() {
  var s = Form$1.useForm(), c = _slicedToArray(s, 1), u = c[0], d = reactExports.useRef({}), p = reactExports.useRef(null), v = reactExports.useRef({}), A = reactExports.useRef({});
  u.getFieldError;
  var x = u.getFieldsError, g = u.getFieldInstance, b = u.setFieldsValue, y = u.setFields, f = u.scrollToField, m = u.isFieldsTouched, C = u.isFieldTouched, w = u.isFieldValidating, S = u.resetFields, $ = u.validateFields, T = __rest$15(u, ["getFieldError", "getFieldsError", "getFieldInstance", "setFieldsValue", "setFields", "scrollToField", "isFieldsTouched", "isFieldTouched", "isFieldValidating", "resetFields", "validateFields"]), I = T, _ = function(O) {
    var L = p.current.setState;
    L || setTimeout(function() {
      L({
        schema: v.current,
        flattenSchema: d.current
      });
    }, 0), L(O);
  }, E = function(O) {
    d.current = flattenSchema(O) || {}, v.current = O, _({
      schema: O,
      flattenSchema: d.current
    });
  };
  return I.setSchema = function(R) {
    var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (isObject$2(R)) {
      if (O) {
        E(R);
        return;
      }
      var L = cloneDeep(v.current);
      Object.keys(R || {}).forEach(function(B) {
        updateSchemaByPath(B, R[B], L);
      }), E(L);
    }
  }, I.setSchemaByPath = function(R, O) {
    if (!(!_hasFuncProperty(O) && _isMatch(O, I.getSchemaByPath(R)))) {
      var L = cloneDeep(v.current);
      updateSchemaByPath(R, O, L), E(L);
    }
  }, I.setValues = function(R) {
    var O = parseBindToValues(R, d.current);
    b(O);
  }, I.getValues = function(R, O, L) {
    var B = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, F, M = cloneDeep(u.getFieldsValue(getFieldName(R), O)), W = ((F = p.current) === null || F === void 0 ? void 0 : F.getState()) || {}, j = W.removeHiddenData;
    return B && j && (M = filterValuesHidden(M, d.current)), L || (M = filterValuesUndefined(M)), parseValuesToBind(M, d.current);
  }, I.getValueByPath = function(R) {
    var O = getFieldName(R);
    return u.getFieldValue(O);
  }, I.setValueByPath = function(R, O) {
    if (!u.setFieldValue) {
      var L = u.getFieldsValue();
      _set(L, R, O), I.setValues(L);
      return;
    }
    var B = getFieldName(R);
    u.setFieldValue(B, O);
    try {
      JSON.stringify(u.getFieldValue(B)) !== JSON.stringify(O) && u.setFieldValue(B, O);
    } catch {
    }
  }, I.getSchemaByPath = function(R) {
    typeof R != "string" && console.warn("请输入正确的路径");
    var O = getSchemaFullPath(R, v.current);
    return _get(v.current, O);
  }, I.getSchema = function() {
    return v.current;
  }, I.setErrorFields = function(R) {
    var O = transformFieldsData(R, getFieldName);
    O && y(O);
  }, I.removeErrorField = function(R) {
    y([{
      name: getFieldName(R),
      errors: []
    }]);
  }, I.getFieldError = function(R) {
    var O = getFieldName(R);
    return u.getFieldError(O);
  }, I.getFieldsError = function(R) {
    var O = getFieldName(R);
    return x(O);
  }, I.getFieldInstance = function(R) {
    var O = getFieldName(R);
    return g(O);
  }, I.getHiddenValues = function() {
    var R = I.getValues(), O = I.getValues(!0), L = {}, B = function(M, W, j) {
      Object.keys(M).forEach(function(G) {
        var U = M[G], k = j ? "".concat(j, ".").concat(G) : G;
        if (!W.hasOwnProperty(G)) {
          _set(L, k, U);
          return;
        }
        isObject$2(U) && B(U, W[G], k), isArray$1(U) && U.map(function(N, P) {
          B(N, _get(W, "".concat(G, "[").concat(P, "]"), []), "".concat(k, "[").concat(P, "]"));
        });
      });
    };
    return B(O, R, null), L;
  }, I.setFields = function(R) {
    var O = transformFieldsData(R, getFieldName);
    O && y(O);
  }, I.__initStore = function(R) {
    p.current = R;
  }, I.scrollToPath = function(R) {
    for (var O = getFieldName(R), L = arguments.length, B = new Array(L > 1 ? L - 1 : 0), F = 1; F < L; F++)
      B[F - 1] = arguments[F];
    f.apply(void 0, [O].concat(B));
  }, I.isFieldsTouched = function(R, O) {
    var L = (R || []).map(function(B) {
      return getFieldName(B);
    });
    return m(L, O);
  }, I.isFieldTouched = function(R) {
    var O = getFieldName(R);
    return C(O);
  }, I.isFieldValidating = function(R) {
    var O = getFieldName(R);
    return w(O);
  }, I.resetFields = function(R) {
    var O = (R || []).map(function(L) {
      return getFieldName(L);
    });
    O.length > 0 ? S(O) : S();
  }, I.validateFields = function(R, O) {
    var L = (R || []).map(function(B) {
      return getFieldName(B);
    });
    return L.length > 0 ? $(L, O) : $();
  }, I.getFlattenSchema = function(R) {
    var O;
    return R ? (O = d.current) === null || O === void 0 ? void 0 : O[R] : d.current;
  }, I.onItemChange = I.setValueByPath, I.setFieldRef = function(R, O) {
    R && (A.current[R] = O);
  }, I.getFieldRef = function(R) {
    return A.current[R];
  }, I;
};
const FormRenderComponent = withProvider(FormCore, defaultWidgets), AlignWidget = (a) => {
  const { activeElements: s, changeSchemas: c, schemas: u, pageSize: d, schema: p } = a, v = (g) => {
    const b = s.map((E) => E.id), y = u.filter((E) => b.includes(E.id)), f = ["left", "center", "right"].includes(g), m = f ? "x" : "y", C = f ? "width" : "height", w = y.length === 1, S = d && typeof d == "object" ? C === "width" ? d.width : d.height : 0, $ = w ? 0 : Math.min(
      ...y.map((E) => {
        const R = E.position && typeof E.position == "object" ? E.position : { x: 0, y: 0 };
        return m === "x" ? R.x : R.y;
      })
    ), T = w ? S : Math.max(
      ...y.map((E) => {
        const R = E.position && typeof E.position == "object" ? E.position : { x: 0, y: 0 }, O = m === "x" ? R.x : R.y, L = E, B = C === "width" ? L.width || 0 : L.height || 0;
        return O + B;
      })
    );
    let I = $, _ = (E) => 0;
    ["center", "middle"].includes(g) ? (I = ($ + T) / 2, _ = (E) => E / 2) : ["right", "bottom"].includes(g) && (I = T, _ = (E) => E), c(
      y.map((E) => {
        const R = E, O = C === "width" ? R.width || 0 : R.height || 0;
        return {
          key: `position.${m}`,
          value: round$1(I - _(O), 2),
          schemaId: R.id
        };
      })
    );
  }, A = (g) => {
    const b = s.map((O) => O.id), y = u.filter((O) => b.includes(O.id)), f = g === "vertical", m = f ? "y" : "x", C = f ? "height" : "width", w = Math.min(
      ...y.map((O) => {
        const L = O.position && typeof O.position == "object" ? O.position : { x: 0, y: 0 };
        return m === "x" ? L.x : L.y;
      })
    ), S = Math.max(
      ...y.map((O) => {
        const L = O.position && typeof O.position == "object" ? O.position : { x: 0, y: 0 }, B = m === "x" ? L.x : L.y, F = O, M = C === "width" ? F.width || 0 : F.height || 0;
        return B + M;
      })
    );
    if (y.length < 3) return;
    const $ = w, T = S - w, I = y.reduce((O, L) => {
      const B = L, F = C === "width" ? B.width || 0 : B.height || 0;
      return O + F;
    }, 0), E = (T - I) / (y.length - 1);
    let R = 0;
    c(
      y.map((O, L) => {
        const B = L === 0 ? 0 : (() => {
          const W = y[L - 1];
          return C === "width" ? W.width || 0 : W.height || 0;
        })();
        R += L === 0 ? 0 : B + E;
        const F = round$1($ + R, 2), M = O;
        return { key: `position.${m}`, value: F, schemaId: M.id };
      })
    );
  }, x = [
    {
      id: "left",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(AlignStartVertical, { size: 15 }),
      onClick: () => v("left")
    },
    {
      id: "center",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(AlignCenterVertical, { size: 15 }),
      onClick: () => v("center")
    },
    {
      id: "right",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(AlignEndVertical, { size: 15 }),
      onClick: () => v("right")
    },
    {
      id: "top",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(AlignStartHorizontal, { size: 15 }),
      onClick: () => v("top")
    },
    {
      id: "middle",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(AlignCenterHorizontal, { size: 15 }),
      onClick: () => v("middle")
    },
    {
      id: "bottom",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(AlignEndHorizontal, { size: 15 }),
      onClick: () => v("bottom")
    },
    {
      id: "vertical",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(AlignVerticalSpaceAround, { size: 15 }),
      onClick: () => A("vertical")
    },
    {
      id: "horizontal",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(AlignHorizontalSpaceAround, { size: 15 }),
      onClick: () => A("horizontal")
    }
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Form$1.Item, { label: p.title, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Space.Compact, { children: x.map((g) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$1,
    {
      style: { padding: 7 },
      disabled: s.length <= 2 && ["vertical", "horizontal"].includes(g.id),
      ...g
    },
    g.id
  )) }) });
}, WidgetRenderer = (a) => {
  const { widget: s, ...c } = a, u = reactExports.useRef(null);
  return reactExports.useEffect(() => (u.current && (u.current.innerHTML = "", s({ ...c, rootElement: u.current })), () => {
    u.current && (u.current.innerHTML = "");
  }), [a.activeSchema]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: u });
}, ButtonGroupWidget = (a) => {
  const { activeElements: s, changeSchemas: c, schemas: u, schema: d } = a, { token: p } = theme.useToken(), v = (b) => {
    const y = b.key, f = b.type, m = s.map((w) => w.id), C = u.filter((w) => m.includes(w.id));
    c(
      C.map((w) => {
        const S = !!(w[y] ?? !1), $ = f === "boolean" ? !S : b.value;
        return { key: y, value: $, schemaId: w.id };
      })
    );
  }, A = (b) => {
    const y = b.key, f = b.type;
    let m = !1;
    const C = s.map((S) => S.id);
    return u.filter((S) => C.includes(S.id)).forEach((S) => {
      const $ = S;
      m = f === "boolean" ? !!($[y] ?? !1) : $[y] === b.value;
    }), m;
  }, x = (b, y) => y ? b.replace(/="currentColor"/g, `="${y}"`) : b, g = (b) => {
    const y = `data:image/svg+xml;utf8,${encodeURIComponent(
      x(b, p.colorText)
    )}`;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { width: 17, height: 17, src: y, alt: "" });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Form$1.Item, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Space.Compact, { children: d.buttons.map((b, y) => {
    const f = A(b);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        type: f ? "primary" : void 0,
        ghost: f,
        onClick: () => v(b),
        style: {
          padding: 7,
          zIndex: f ? 2 : 0
        },
        icon: g(b.icon)
      },
      y
    );
  }) }) });
}, { Text: Text$2 } = Typography, DetailView = (a) => {
  const { token: s } = theme.useToken(), { size: c, schemasList: u, changeSchemas: d, deselectSchema: p, activeSchema: v } = a, A = useForm(), x = reactExports.useContext(I18nContext), g = reactExports.useContext(PluginsRegistry), b = reactExports.useContext(OptionsContext), y = (L) => typeof x == "function" ? x(L) : L, [f, m] = reactExports.useState({});
  reactExports.useEffect(() => {
    const L = {
      AlignWidget: (B) => /* @__PURE__ */ jsxRuntimeExports.jsx(AlignWidget, { ...B, ...a, options: b }),
      Divider: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: { marginTop: s.marginXS, marginBottom: s.marginXS } }),
      ButtonGroup: (B) => /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupWidget, { ...B, ...a, options: b })
    };
    for (const B of g.values()) {
      const F = B.propPanel.widgets || {};
      Object.entries(F).forEach(([M, W]) => {
        L[M] = (j) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          WidgetRenderer,
          {
            ...j,
            ...a,
            options: b,
            theme: s,
            i18n: y,
            widget: W
          }
        );
      });
    }
    m(L);
  }, [v, g, JSON.stringify(b)]), reactExports.useEffect(() => {
    const L = { ...v }, B = typeof L.readOnly == "boolean" ? L.readOnly : !1;
    L.editable = !B, A.setValues(L);
  }, [v, A]), reactExports.useEffect(() => A.resetFields(), [v.id]), reactExports.useEffect(() => {
    C.current = (L) => {
      for (const B of u)
        for (const F of Object.values(B))
          if (F.name === L && F.id !== v.id)
            return !1;
      return !0;
    };
  }, [u, v]);
  const C = reactExports.useRef(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (L) => !0
  ), w = (L, B) => C.current(B), S = debounce$1(function(...L) {
    const B = L[0], F = (W, j) => typeof W == "object" && W !== null ? JSON.stringify(W) !== JSON.stringify(j) : W !== j;
    let M = [];
    for (const W in B) {
      if (["id", "content"].includes(W)) continue;
      let j = B[W];
      if (F(j, v[W])) {
        if (j === null && ["rotate", "opacity"].includes(W) && (j = void 0), W === "editable") {
          const G = !j;
          M.push({ key: "readOnly", value: G, schemaId: v.id }), G && M.push({ key: "required", value: !1, schemaId: v.id });
          continue;
        }
        M.push({ key: W, value: j, schemaId: v.id });
      }
    }
    M.length && A.validateFields().then(() => d(M)).catch((W) => {
      W.errorFields.length && (M = M.filter(
        (j) => !W.errorFields.find(
          (G) => G.name.includes(j.key)
        )
      )), M.length && d(M);
    });
  }, 100), $ = g.findByType(v.type);
  if (!$)
    throw Error(`[@pdfme/ui] Failed to find plugin used for ${v.type}`);
  const T = $.propPanel.schema, I = [];
  g.entries().forEach(([L, B]) => {
    I.push({ label: L, value: B.propPanel.defaultSchema?.type ?? void 0 });
  });
  const _ = {}, E = $?.propPanel?.defaultSchema ? (
    // Create a safe copy of the schema
    (() => {
      const L = {};
      for (const B in $.propPanel.defaultSchema)
        Object.prototype.hasOwnProperty.call($.propPanel.defaultSchema, B) && (L[B] = $.propPanel.defaultSchema[B]);
      return L;
    })()
  ) : _, R = {
    type: "object",
    column: 2,
    properties: {
      type: {
        title: y("type"),
        type: "string",
        widget: "select",
        props: { options: I },
        required: !0,
        span: 12
      },
      name: {
        title: y("fieldName"),
        type: "string",
        required: !0,
        span: 12,
        rules: [
          {
            validator: w,
            message: y("validation.uniqueName")
          }
        ],
        props: { autoComplete: "off" }
      },
      editable: {
        title: y("editable"),
        type: "boolean",
        span: 8,
        hidden: typeof E.readOnly < "u"
      },
      required: {
        title: y("required"),
        type: "boolean",
        span: 16,
        hidden: "{{!formData.editable}}"
      },
      "-": { type: "void", widget: "Divider" },
      align: { title: y("align"), type: "void", widget: "AlignWidget" },
      position: {
        type: "object",
        widget: "card",
        properties: {
          x: { title: "X", type: "number", widget: "inputNumber", required: !0, span: 8, min: 0 },
          y: { title: "Y", type: "number", widget: "inputNumber", required: !0, span: 8, min: 0 }
        }
      },
      width: {
        title: y("width"),
        type: "number",
        widget: "inputNumber",
        required: !0,
        span: 6,
        props: { min: 0 }
      },
      height: {
        title: y("height"),
        type: "number",
        widget: "inputNumber",
        required: !0,
        span: 6,
        props: { min: 0 }
      },
      rotate: {
        title: y("rotate"),
        type: "number",
        widget: "inputNumber",
        disabled: typeof E.rotate > "u",
        max: 360,
        props: { min: 0 },
        span: 6
      },
      opacity: {
        title: y("opacity"),
        type: "number",
        widget: "inputNumber",
        disabled: typeof E.opacity > "u",
        props: { step: 0.1, min: 0, max: 1 },
        span: 6
      }
    }
  }, O = { ...R.properties };
  if (typeof T == "function") {
    const { size: L, schemas: B, pageSize: F, changeSchemas: M, activeElements: W, deselectSchema: j, activeSchema: G } = a, k = T({
      ...{
        size: L,
        schemas: B,
        pageSize: F,
        changeSchemas: M,
        activeElements: W,
        deselectSchema: j,
        activeSchema: G
      },
      options: b,
      theme: s,
      i18n: y
    }), N = k && typeof k == "object" ? k : {}, P = Object.keys(N).length === 0 ? {} : { "--": { type: "void", widget: "Divider" } };
    R.properties = {
      ...O,
      ...P,
      ...N
    };
  } else {
    const L = T && typeof T == "object" ? T : {}, B = Object.keys(L).length === 0 ? {} : { "--": { type: "void", widget: "Divider" } };
    R.properties = {
      ...O,
      ...B,
      ...L
    };
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { height: 40, display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          style: {
            position: "absolute",
            zIndex: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          onClick: p,
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, { strokeWidth: 1.5, size: 20 })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { strong: !0, style: { textAlign: "center", width: "100%" }, children: y("editField") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: { marginTop: s.marginXS, marginBottom: s.marginXS } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        style: {
          height: getSidebarContentHeight(c.height),
          overflowY: "auto",
          overflowX: "hidden"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormRenderComponent,
          {
            form: A,
            schema: R,
            widgets: f,
            watch: { "#": S },
            locale: "en-US"
          }
        )
      }
    )
  ] });
}, propsAreUnchanged = (a, s) => JSON.stringify(a.activeSchema) == JSON.stringify(s.activeSchema), DetailView$1 = React.memo(DetailView, propsAreUnchanged), Sidebar = (a) => {
  const { sidebarOpen: s, setSidebarOpen: c, activeElements: u, schemas: d } = a, { token: p } = theme.useToken(), v = () => d.filter((g) => u.map((b) => b.id).includes(g.id)), A = () => {
    const g = v();
    return g[g.length - 1];
  }, x = { strokeWidth: 1.5, size: 20 };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        position: "absolute",
        right: 0,
        zIndex: 1,
        height: "100%",
        width: s ? RIGHT_SIDEBAR_WIDTH : 0
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            style: {
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              top: "1rem",
              right: "1rem",
              zIndex: 100
            },
            icon: s ? /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowRight, { ...x }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowLeft, { ...x }),
            onClick: () => c(!s)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            style: {
              width: RIGHT_SIDEBAR_WIDTH,
              height: "100%",
              display: s ? "block" : "none",
              top: 0,
              right: 0,
              position: "absolute",
              padding: "0.7rem 1rem",
              overflowY: "auto",
              fontFamily: "'Open Sans', sans-serif",
              boxSizing: "border-box",
              background: p.colorBgLayout
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: v().length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ListView, { ...a }) : /* @__PURE__ */ jsxRuntimeExports.jsx(DetailView$1, { ...a, activeSchema: A() }) })
          }
        )
      ] })
    }
  );
}, useRerenderDependencies = (a) => {
  const { plugin: s, value: c, mode: u, scale: d, schema: p, options: v } = a, A = cloneDeep$1(v);
  A.font && Object.values(A.font).forEach((g) => {
    g.data = "...";
  });
  const x = JSON.stringify(A);
  return reactExports.useMemo(() => s?.uninterruptedEditMode && u === "designer" ? [u] : [c, u, d, JSON.stringify(p), x], [c, u, d, p, x, s]);
}, Wrapper = ({
  children: a,
  outline: s,
  onChangeHoveringSchemaId: c,
  schema: u,
  selectable: d = !0
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    title: u.name,
    onMouseEnter: () => c && c(u.id),
    onMouseLeave: () => c && c(null),
    className: d ? SELECTABLE_CLASSNAME : "",
    id: u.id,
    style: {
      position: "absolute",
      cursor: u.readOnly ? "initial" : "pointer",
      height: u.height * ZOOM,
      width: u.width * ZOOM,
      top: u.position.y * ZOOM,
      left: u.position.x * ZOOM,
      transform: `rotate(${u.rotate ?? 0}deg)`,
      opacity: u.opacity ?? 1,
      outline: s
    },
    children: [
      u.required && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          style: {
            color: "red",
            position: "absolute",
            top: -12,
            left: -12,
            fontSize: 18,
            fontWeight: 700
          },
          children: "*"
        }
      ),
      a
    ]
  }
), Renderer = (a) => {
  const { schema: s, basePdf: c, value: u, mode: d, onChange: p, stopEditing: v, tabIndex: A, placeholder: x, scale: g } = a, b = reactExports.useContext(PluginsRegistry), y = reactExports.useContext(OptionsContext), f = reactExports.useContext(I18nContext), { token: m } = theme.useToken(), C = reactExports.useRef(null), w = reactExports.useContext(CacheContext), S = b.findByType(s.type), $ = useRerenderDependencies({
    plugin: S,
    value: u,
    mode: d,
    scale: g,
    schema: s,
    options: y
  });
  return reactExports.useEffect(() => {
    if (!S?.ui || !C.current || !s.type) return;
    C.current.innerHTML = "";
    const T = S.ui;
    return T({
      value: u,
      schema: s,
      basePdf: c,
      rootElement: C.current,
      mode: d,
      onChange: p,
      stopEditing: v,
      tabIndex: A,
      placeholder: x,
      options: y,
      theme: m,
      i18n: f,
      scale: g,
      _cache: w
    }), () => {
      C.current && (C.current.innerHTML = "");
    };
  }, $), S ? /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper, { ...a, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: "100%", width: "100%" }, ref: C }) }) : (console.error(`[@pdfme/ui] Renderer for type ${s.type} not found. 
Check this document: https://pdfme.com/docs/custom-schemas`), /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}));
}, Draggable$1 = (a) => {
  const { scale: s, basePdf: c, plugin: u } = a, { token: d } = theme.useToken(), p = reactExports.useContext(OptionsContext), v = u.propPanel.defaultSchema;
  if (p.font) {
    const w = getFallbackFontName(p.font);
    setFontNameRecursively(v, w);
  }
  const A = useDraggable({ id: v.type, data: v }), { listeners: x, setNodeRef: g, attributes: b, transform: y, isDragging: f } = A, m = { transform: CSS$1.Translate.toString(y) }, C = React.useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { transform: `scale(${s})` }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Renderer,
      {
        schema: { ...v, id: v.type },
        basePdf: c,
        value: v.content || "",
        onChangeHoveringSchemaId: () => {
        },
        mode: "viewer",
        outline: `1px solid ${d.colorPrimary}`,
        scale: s
      }
    ) }),
    [v, c, s, d.colorPrimary]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: g, style: m, ...x, ...b, children: [
    f && C,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { visibility: f ? "hidden" : "visible" }, children: a.children })
  ] });
}, LeftSidebar = ({
  height: a,
  scale: s,
  basePdf: c
}) => {
  const { token: u } = theme.useToken(), d = reactExports.useContext(PluginsRegistry), [p, v] = reactExports.useState(!1);
  return reactExports.useEffect(() => {
    const A = () => {
      p && v(!1);
    };
    return document.addEventListener("mouseup", A), () => {
      document.removeEventListener("mouseup", A);
    };
  }, [p]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        left: 0,
        right: 0,
        position: "absolute",
        zIndex: 1,
        height: a,
        width: LEFT_SIDEBAR_WIDTH,
        background: u.colorBgLayout,
        textAlign: "center",
        overflow: p ? "visible" : "auto"
      },
      children: d.entries().map(([A, x]) => x?.propPanel.defaultSchema ? /* @__PURE__ */ jsxRuntimeExports.jsx(Draggable$1, { scale: s, basePdf: c, plugin: x, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          onMouseDown: () => v(!0),
          style: { width: 35, height: 35, marginTop: "0.25rem", padding: "0.25rem" },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(PluginIcon, { plugin: x, label: A })
        }
      ) }, A) : null)
    }
  );
}, Paper = (a) => {
  const {
    paperRefs: s,
    scale: c,
    size: u,
    schemasList: d,
    pageSizes: p,
    backgrounds: v,
    renderPaper: A,
    renderSchema: x,
    hasRulers: g
  } = a, b = reactExports.useContext(FontContext), y = g ? RULER_HEIGHT : 0;
  return p.length !== v.length || p.length !== d.length ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        transform: `scale(${c})`,
        transformOrigin: "top left",
        // NOTE: These values do not impact the UI unless they exceed the Paper sizes.
        // We set them to the scale value to ensure the container is redrawn when you zoom in/out.
        height: c,
        width: c
      },
      children: v.map((f, m) => {
        const C = p[m], w = { width: C.width * ZOOM, height: C.height * ZOOM }, S = w.width * c + y < u.width ? `${(u.width / c - w.width) / 2}px` : `${y}px`;
        let $ = m > 0 ? (y + PAGE_GAP) * (m + 1) : y;
        return g || ($ += PAGE_GAP * 2), /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            ref: (T) => {
              T && (s.current[m] = T);
            },
            onMouseDown: (T) => {
              T.currentTarget === T.target && document && document.hasFocus() && document.activeElement instanceof HTMLElement && document.activeElement.blur();
            },
            style: {
              fontFamily: `'${getFallbackFontName(b)}'`,
              top: `${$}px`,
              left: S,
              position: "relative",
              backgroundImage: `url(${f})`,
              backgroundSize: `${w.width}px ${w.height}px`,
              ...w
            },
            children: [
              A({ paperSize: w, index: m }),
              d[m].map((T, I) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: x({
                schema: T,
                index: m === 0 ? I : I + d[m - 1].length
              }) }, T.id))
            ]
          },
          String(m) + JSON.stringify(w)
        );
      })
    }
  );
};
var FUNCTION = "function", OBJECT = "object", STRING = "string", NUMBER = "number", UNDEFINED = "undefined", IS_WINDOW = typeof window !== UNDEFINED, doc = typeof document !== UNDEFINED && document, OPEN_CLOSED_CHARACTERS = [{
  open: "(",
  close: ")"
}, {
  open: '"',
  close: '"'
}, {
  open: "'",
  close: "'"
}, {
  open: '\\"',
  close: '\\"'
}, {
  open: "\\'",
  close: "\\'"
}], TINY_NUM$1 = 1e-7, DEFAULT_UNIT_PRESETS = {
  cm: function(a) {
    return a * 96 / 2.54;
  },
  mm: function(a) {
    return a * 96 / 254;
  },
  in: function(a) {
    return a * 96;
  },
  pt: function(a) {
    return a * 96 / 72;
  },
  pc: function(a) {
    return a * 96 / 6;
  },
  "%": function(a, s) {
    return a * s / 100;
  },
  vw: function(a, s) {
    return s === void 0 && (s = window.innerWidth), a / 100 * s;
  },
  vh: function(a, s) {
    return s === void 0 && (s = window.innerHeight), a / 100 * s;
  },
  vmax: function(a, s) {
    return s === void 0 && (s = Math.max(window.innerWidth, window.innerHeight)), a / 100 * s;
  },
  vmin: function(a, s) {
    return s === void 0 && (s = Math.min(window.innerWidth, window.innerHeight)), a / 100 * s;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __spreadArrays$2() {
  for (var a = 0, s = 0, c = arguments.length; s < c; s++) a += arguments[s].length;
  for (var u = Array(a), d = 0, s = 0; s < c; s++) for (var p = arguments[s], v = 0, A = p.length; v < A; v++, d++) u[d] = p[v];
  return u;
}
function dot(a, s, c, u) {
  return (a * u + s * c) / (c + u);
}
function isUndefined(a) {
  return typeof a === UNDEFINED;
}
function isObject$1(a) {
  return a && typeof a === OBJECT;
}
function isArray(a) {
  return Array.isArray(a);
}
function isString(a) {
  return typeof a === STRING;
}
function isNumber(a) {
  return typeof a === NUMBER;
}
function isFunction(a) {
  return typeof a === FUNCTION;
}
function isEqualSeparator(a, s) {
  var c = a === "" || a == " ", u = s === "" || s == " ";
  return u && c || a === s;
}
function findOpen(a, s, c, u, d) {
  var p = findIgnore(a, s, c);
  return p ? c : findClose(a, s, c + 1, u, d);
}
function findIgnore(a, s, c) {
  if (!a.ignore)
    return null;
  var u = s.slice(Math.max(c - 3, 0), c + 3).join("");
  return new RegExp(a.ignore).exec(u);
}
function findClose(a, s, c, u, d) {
  for (var p = function(g) {
    var b = s[g].trim();
    if (b === a.close && !findIgnore(a, s, g))
      return {
        value: g
      };
    var y = g, f = find$1(d, function(m) {
      var C = m.open;
      return C === b;
    });
    if (f && (y = findOpen(f, s, g, u, d)), y === -1)
      return v = g, "break";
    g = y, v = g;
  }, v, A = c; A < u; ++A) {
    var x = p(A);
    if (A = v, typeof x == "object") return x.value;
    if (x === "break") break;
  }
  return -1;
}
function splitText(a, s) {
  var c = isString(s) ? {
    separator: s
  } : s, u = c.separator, d = u === void 0 ? "," : u, p = c.isSeparateFirst, v = c.isSeparateOnlyOpenClose, A = c.isSeparateOpenClose, x = A === void 0 ? v : A, g = c.openCloseCharacters, b = g === void 0 ? OPEN_CLOSED_CHARACTERS : g, y = b.map(function(O) {
    var L = O.open, B = O.close;
    return L === B ? L : L + "|" + B;
  }).join("|"), f = "(\\s*" + d + "\\s*|" + y + "|\\s+)", m = new RegExp(f, "g"), C = a.split(m).filter(function(O) {
    return O && O !== "undefined";
  }), w = C.length, S = [], $ = [];
  function T() {
    return $.length ? (S.push($.join("")), $ = [], !0) : !1;
  }
  for (var I = function(O) {
    var L = C[O].trim(), B = O, F = find$1(b, function(j) {
      var G = j.open;
      return G === L;
    }), M = find$1(b, function(j) {
      var G = j.close;
      return G === L;
    });
    if (F) {
      if (B = findOpen(F, C, O, w, b), B !== -1 && x)
        return T() && p || (S.push(C.slice(O, B + 1).join("")), O = B, p) ? (_ = O, "break") : (_ = O, "continue");
    } else if (M && !findIgnore(M, C, O)) {
      var W = __spreadArrays$2(b);
      return W.splice(b.indexOf(M), 1), {
        value: splitText(a, {
          separator: d,
          isSeparateFirst: p,
          isSeparateOnlyOpenClose: v,
          isSeparateOpenClose: x,
          openCloseCharacters: W
        })
      };
    } else if (isEqualSeparator(L, d) && !v)
      return T(), p ? (_ = O, "break") : (_ = O, "continue");
    B === -1 && (B = w - 1), $.push(C.slice(O, B + 1).join("")), O = B, _ = O;
  }, _, E = 0; E < w; ++E) {
    var R = I(E);
    if (E = _, typeof R == "object") return R.value;
    if (R === "break") break;
  }
  return $.length && S.push($.join("")), S;
}
function splitSpace(a) {
  return splitText(a, "");
}
function splitComma(a) {
  return splitText(a, ",");
}
function splitBracket(a) {
  var s = /([^(]*)\(([\s\S]*)\)([\s\S]*)/g.exec(a);
  return !s || s.length < 4 ? {} : {
    prefix: s[1],
    value: s[2],
    suffix: s[3]
  };
}
function splitUnit(a) {
  var s = /^([^\d|e|\-|\+]*)((?:\d|\.|-|e-|e\+)+)(\S*)$/g.exec(a);
  if (!s)
    return {
      prefix: "",
      unit: "",
      value: NaN
    };
  var c = s[1], u = s[2], d = s[3];
  return {
    prefix: c,
    unit: d,
    value: parseFloat(u)
  };
}
function camelize(a) {
  return a.replace(/[\s-_]+([^\s-_])/g, function(s, c) {
    return c.toUpperCase();
  });
}
function decamelize(a, s) {
  return a.replace(/([a-z])([A-Z])/g, function(c, u, d) {
    return "" + u + s + d.toLowerCase();
  });
}
function now() {
  return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).getTime();
}
function findIndex(a, s, c) {
  c === void 0 && (c = -1);
  for (var u = a.length, d = 0; d < u; ++d)
    if (s(a[d], d, a))
      return d;
  return c;
}
function findLastIndex(a, s, c) {
  c === void 0 && (c = -1);
  for (var u = a.length, d = u - 1; d >= 0; --d)
    if (s(a[d], d, a))
      return d;
  return c;
}
function findLast(a, s, c) {
  var u = findLastIndex(a, s);
  return u > -1 ? a[u] : c;
}
function find$1(a, s, c) {
  var u = findIndex(a, s);
  return u > -1 ? a[u] : c;
}
var requestAnimationFrame$1 = /* @__PURE__ */ function() {
  var a = now(), s = IS_WINDOW && (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame);
  return s ? s.bind(window) : function(c) {
    var u = now(), d = setTimeout(function() {
      c(u - a);
    }, 1e3 / 60);
    return d;
  };
}(), cancelAnimationFrame$1 = /* @__PURE__ */ function() {
  var a = IS_WINDOW && (window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.msCancelAnimationFrame);
  return a ? a.bind(window) : function(s) {
    clearTimeout(s);
  };
}();
function getKeys(a) {
  return Object.keys(a);
}
function convertUnitSize(a, s) {
  var c = splitUnit(a), u = c.value, d = c.unit;
  if (isObject$1(s)) {
    var p = s[d];
    if (p) {
      if (isFunction(p))
        return p(u);
      if (DEFAULT_UNIT_PRESETS[d])
        return DEFAULT_UNIT_PRESETS[d](u, p);
    }
  } else if (d === "%")
    return u * s / 100;
  return DEFAULT_UNIT_PRESETS[d] ? DEFAULT_UNIT_PRESETS[d](u) : u;
}
function between(a, s, c) {
  return Math.max(s, Math.min(a, c));
}
function checkBoundSize(a, s, c, u) {
  return u === void 0 && (u = a[0] / a[1]), [[throttle(s[0], TINY_NUM$1), throttle(s[0] / u, TINY_NUM$1)], [throttle(s[1] * u, TINY_NUM$1), throttle(s[1], TINY_NUM$1)]].filter(function(d) {
    return d.every(function(p, v) {
      var A = s[v], x = throttle(A, TINY_NUM$1);
      return c ? p <= A || p <= x : p >= A || p >= x;
    });
  })[0] || a;
}
function calculateBoundSize(a, s, c, u) {
  if (!u)
    return a.map(function(m, C) {
      return between(m, s[C], c[C]);
    });
  var d = a[0], p = a[1], v = u === !0 ? d / p : u, A = checkBoundSize(a, s, !1, v), x = A[0], g = A[1], b = checkBoundSize(a, c, !0, v), y = b[0], f = b[1];
  return d < x || p < g ? (d = x, p = g) : (d > y || p > f) && (d = y, p = f), [d, p];
}
function sum(a) {
  for (var s = a.length, c = 0, u = s - 1; u >= 0; --u)
    c += a[u];
  return c;
}
function average(a) {
  for (var s = a.length, c = 0, u = s - 1; u >= 0; --u)
    c += a[u];
  return s ? c / s : 0;
}
function getRad$1(a, s) {
  var c = s[0] - a[0], u = s[1] - a[1], d = Math.atan2(u, c);
  return d >= 0 ? d : d + Math.PI * 2;
}
function getCenterPoint(a) {
  return [0, 1].map(function(s) {
    return average(a.map(function(c) {
      return c[s];
    }));
  });
}
function getShapeDirection(a) {
  var s = getCenterPoint(a), c = getRad$1(s, a[0]), u = getRad$1(s, a[1]);
  return c < u && u - c < Math.PI || c > u && u - c < -Math.PI ? 1 : -1;
}
function getDist$2(a, s) {
  return Math.sqrt(Math.pow((s ? s[0] : 0) - a[0], 2) + Math.pow((s ? s[1] : 0) - a[1], 2));
}
function throttle(a, s) {
  if (!s)
    return a;
  var c = 1 / s;
  return Math.round(a / s) / c;
}
function throttleArray(a, s) {
  return a.forEach(function(c, u) {
    a[u] = throttle(a[u], s);
  }), a;
}
function counter(a) {
  for (var s = [], c = 0; c < a; ++c)
    s.push(c);
  return s;
}
function flat$1(a) {
  return a.reduce(function(s, c) {
    return s.concat(c);
  }, []);
}
function hasClass(a, s) {
  return a.classList ? a.classList.contains(s) : !!a.className.match(new RegExp("(\\s|^)" + s + "(\\s|$)"));
}
function addClass(a, s) {
  a.classList ? a.classList.add(s) : a.className += " " + s;
}
function removeClass(a, s) {
  if (a.classList)
    a.classList.remove(s);
  else {
    var c = new RegExp("(\\s|^)" + s + "(\\s|$)");
    a.className = a.className.replace(c, " ");
  }
}
function addEvent(a, s, c, u) {
  a.addEventListener(s, c, u);
}
function removeEvent(a, s, c, u) {
  a.removeEventListener(s, c, u);
}
function getDocument(a) {
  return a?.ownerDocument || doc;
}
function getDocumentElement(a) {
  return getDocument(a).documentElement;
}
function getDocumentBody(a) {
  return getDocument(a).body;
}
function getWindow(a) {
  var s;
  return ((s = a?.ownerDocument) === null || s === void 0 ? void 0 : s.defaultView) || window;
}
function isWindow(a) {
  return a && "postMessage" in a && "blur" in a && "self" in a;
}
function isNode(a) {
  return isObject$1(a) && a.nodeName && a.nodeType && "ownerDocument" in a;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$8 = function() {
  return __assign$8 = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign$8.apply(this, arguments);
};
function __spreadArrays$1() {
  for (var a = 0, s = 0, c = arguments.length; s < c; s++) a += arguments[s].length;
  for (var u = Array(a), d = 0, s = 0; s < c; s++) for (var p = arguments[s], v = 0, A = p.length; v < A; v++, d++) u[d] = p[v];
  return u;
}
var EventEmitter = /* @__PURE__ */ function() {
  function a() {
    this._events = {};
  }
  var s = a.prototype;
  return s.on = function(c, u) {
    if (isObject$1(c))
      for (var d in c)
        this.on(d, c[d]);
    else
      this._addEvent(c, u, {});
    return this;
  }, s.off = function(c, u) {
    if (!c)
      this._events = {};
    else if (isObject$1(c))
      for (var d in c)
        this.off(d);
    else if (!u)
      this._events[c] = [];
    else {
      var p = this._events[c];
      if (p) {
        var v = findIndex(p, function(A) {
          return A.listener === u;
        });
        v > -1 && p.splice(v, 1);
      }
    }
    return this;
  }, s.once = function(c, u) {
    var d = this;
    return u && this._addEvent(c, u, {
      once: !0
    }), new Promise(function(p) {
      d._addEvent(c, p, {
        once: !0
      });
    });
  }, s.emit = function(c, u) {
    var d = this;
    u === void 0 && (u = {});
    var p = this._events[c];
    if (!c || !p)
      return !0;
    var v = !1;
    return u.eventType = c, u.stop = function() {
      v = !0;
    }, u.currentTarget = this, __spreadArrays$1(p).forEach(function(A) {
      A.listener(u), A.once && d.off(c, A.listener);
    }), !v;
  }, s.trigger = function(c, u) {
    return u === void 0 && (u = {}), this.emit(c, u);
  }, s._addEvent = function(c, u, d) {
    var p = this._events;
    p[c] = p[c] || [];
    var v = p[c];
    v.push(__assign$8({
      listener: u
    }, d));
  }, a;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics$8 = function(a, s) {
  return extendStatics$8 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) u.hasOwnProperty(d) && (c[d] = u[d]);
  }, extendStatics$8(a, s);
};
function __extends$8(a, s) {
  extendStatics$8(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
var __assign$7 = function() {
  return __assign$7 = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign$7.apply(this, arguments);
};
function getRad(a, s) {
  var c = s[0] - a[0], u = s[1] - a[1], d = Math.atan2(u, c);
  return d >= 0 ? d : d + Math.PI * 2;
}
function getRotatiion(a) {
  return getRad([
    a[0].clientX,
    a[0].clientY
  ], [
    a[1].clientX,
    a[1].clientY
  ]) / Math.PI * 180;
}
function isMultiTouch(a) {
  return a.touches && a.touches.length >= 2;
}
function getEventClients(a) {
  return a ? a.touches ? getClients(a.touches) : [getClient$1(a)] : [];
}
function isMouseEvent(a) {
  return a && (a.type.indexOf("mouse") > -1 || "button" in a);
}
function getPosition(a, s, c) {
  var u = c.length, d = getAverageClient(a, u), p = d.clientX, v = d.clientY, A = d.originalClientX, x = d.originalClientY, g = getAverageClient(s, u), b = g.clientX, y = g.clientY, f = getAverageClient(c, u), m = f.clientX, C = f.clientY, w = p - b, S = v - y, $ = p - m, T = v - C;
  return {
    clientX: A,
    clientY: x,
    deltaX: w,
    deltaY: S,
    distX: $,
    distY: T
  };
}
function getDist$1(a) {
  return Math.sqrt(Math.pow(a[0].clientX - a[1].clientX, 2) + Math.pow(a[0].clientY - a[1].clientY, 2));
}
function getClients(a) {
  for (var s = Math.min(a.length, 2), c = [], u = 0; u < s; ++u)
    c.push(getClient$1(a[u]));
  return c;
}
function getClient$1(a) {
  return {
    clientX: a.clientX,
    clientY: a.clientY
  };
}
function getAverageClient(a, s) {
  s === void 0 && (s = a.length);
  for (var c = {
    clientX: 0,
    clientY: 0,
    originalClientX: 0,
    originalClientY: 0
  }, u = Math.min(a.length, s), d = 0; d < u; ++d) {
    var p = a[d];
    c.originalClientX += "originalClientX" in p ? p.originalClientX : p.clientX, c.originalClientY += "originalClientY" in p ? p.originalClientY : p.clientY, c.clientX += p.clientX, c.clientY += p.clientY;
  }
  return s ? {
    clientX: c.clientX / s,
    clientY: c.clientY / s,
    originalClientX: c.originalClientX / s,
    originalClientY: c.originalClientY / s
  } : c;
}
var ClientStore = /* @__PURE__ */ function() {
  function a(s) {
    this.prevClients = [], this.startClients = [], this.movement = 0, this.length = 0, this.startClients = s, this.prevClients = s, this.length = s.length;
  }
  return a.prototype.getAngle = function(s) {
    return s === void 0 && (s = this.prevClients), getRotatiion(s);
  }, a.prototype.getRotation = function(s) {
    return s === void 0 && (s = this.prevClients), getRotatiion(s) - getRotatiion(this.startClients);
  }, a.prototype.getPosition = function(s, c) {
    s === void 0 && (s = this.prevClients);
    var u = getPosition(s || this.prevClients, this.prevClients, this.startClients), d = u.deltaX, p = u.deltaY;
    return this.movement += Math.sqrt(d * d + p * p), this.prevClients = s, u;
  }, a.prototype.getPositions = function(s) {
    s === void 0 && (s = this.prevClients);
    for (var c = this.prevClients, u = this.startClients, d = Math.min(this.length, c.length), p = [], v = 0; v < d; ++v)
      p[v] = getPosition([s[v]], [c[v]], [u[v]]);
    return p;
  }, a.prototype.getMovement = function(s) {
    var c = this.movement;
    if (!s)
      return c;
    var u = getAverageClient(s, this.length), d = getAverageClient(this.prevClients, this.length), p = u.clientX - d.clientX, v = u.clientY - d.clientY;
    return Math.sqrt(p * p + v * v) + c;
  }, a.prototype.getDistance = function(s) {
    return s === void 0 && (s = this.prevClients), getDist$1(s);
  }, a.prototype.getScale = function(s) {
    return s === void 0 && (s = this.prevClients), getDist$1(s) / getDist$1(this.startClients);
  }, a.prototype.move = function(s, c) {
    this.startClients.forEach(function(u) {
      u.clientX -= s, u.clientY -= c;
    }), this.prevClients.forEach(function(u) {
      u.clientX -= s, u.clientY -= c;
    });
  }, a;
}(), INPUT_TAGNAMES = ["textarea", "input"], Gesto = /* @__PURE__ */ function(a) {
  __extends$8(s, a);
  function s(c, u) {
    u === void 0 && (u = {});
    var d = a.call(this) || this;
    d.options = {}, d.flag = !1, d.pinchFlag = !1, d.data = {}, d.isDrag = !1, d.isPinch = !1, d.clientStores = [], d.targets = [], d.prevTime = 0, d.doubleFlag = !1, d._useMouse = !1, d._useTouch = !1, d._useDrag = !1, d._dragFlag = !1, d._isTrusted = !1, d._isMouseEvent = !1, d._isSecondaryButton = !1, d._preventMouseEvent = !1, d._prevInputEvent = null, d._isDragAPI = !1, d._isIdle = !0, d._preventMouseEventId = 0, d._window = window, d.onDragStart = function(f, m) {
      if (m === void 0 && (m = !0), !(!d.flag && f.cancelable === !1)) {
        var C = f.type.indexOf("drag") >= -1;
        if (!(d.flag && C)) {
          d._isDragAPI = !0;
          var w = d.options, S = w.container, $ = w.pinchOutside, T = w.preventWheelClick, I = w.preventRightClick, _ = w.preventDefault, E = w.checkInput, R = w.dragFocusedInput, O = w.preventClickEventOnDragStart, L = w.preventClickEventOnDrag, B = w.preventClickEventByCondition, F = d._useTouch, M = !d.flag;
          if (d._isSecondaryButton = f.which === 3 || f.button === 2, T && (f.which === 2 || f.button === 1) || I && (f.which === 3 || f.button === 2))
            return d.stop(), !1;
          if (M) {
            var W = d._window.document.activeElement, j = f.target;
            if (j) {
              var G = j.tagName.toLowerCase(), U = INPUT_TAGNAMES.indexOf(G) > -1, k = j.isContentEditable;
              if (U || k) {
                if (E || !R && W === j)
                  return !1;
                if (W && (W === j || k && W.isContentEditable && W.contains(j)))
                  if (R)
                    j.blur();
                  else
                    return !1;
              } else if ((_ || f.type === "touchstart") && W) {
                var N = W.tagName.toLowerCase();
                (W.isContentEditable || INPUT_TAGNAMES.indexOf(N) > -1) && W.blur();
              }
              (O || L || B) && addEvent(d._window, "click", d._onClick, !0);
            }
            d.clientStores = [new ClientStore(getEventClients(f))], d._isIdle = !1, d.flag = !0, d.isDrag = !1, d._isTrusted = m, d._dragFlag = !0, d._prevInputEvent = f, d.data = {}, d.doubleFlag = now() - d.prevTime < 200, d._isMouseEvent = isMouseEvent(f), !d._isMouseEvent && d._preventMouseEvent && d._allowMouseEvent();
            var P = d._preventMouseEvent || d.emit("dragStart", __assign$7(__assign$7({ data: d.data, datas: d.data, inputEvent: f, isMouseEvent: d._isMouseEvent, isSecondaryButton: d._isSecondaryButton, isTrusted: m, isDouble: d.doubleFlag }, d.getCurrentStore().getPosition()), { preventDefault: function() {
              f.preventDefault();
            }, preventDrag: function() {
              d._dragFlag = !1;
            } }));
            P === !1 && d.stop(), d._isMouseEvent && d.flag && _ && f.preventDefault();
          }
          if (!d.flag)
            return !1;
          var D = 0;
          if (M ? (d._attchDragEvent(), F && $ && (D = setTimeout(function() {
            addEvent(S, "touchstart", d.onDragStart, {
              passive: !1
            });
          }))) : F && $ && removeEvent(S, "touchstart", d.onDragStart), d.flag && isMultiTouch(f)) {
            if (clearTimeout(D), M && f.touches.length !== f.changedTouches.length)
              return;
            d.pinchFlag || d.onPinchStart(f);
          }
        }
      }
    }, d.onDrag = function(f, m) {
      if (d.flag) {
        var C = d.options.preventDefault;
        !d._isMouseEvent && C && f.preventDefault(), d._prevInputEvent = f;
        var w = getEventClients(f), S = d.moveClients(w, f, !1);
        if (d._dragFlag) {
          if (d.pinchFlag || S.deltaX || S.deltaY) {
            var $ = d._preventMouseEvent || d.emit("drag", __assign$7(__assign$7({}, S), { isScroll: !!m, inputEvent: f }));
            if ($ === !1) {
              d.stop();
              return;
            }
          }
          d.pinchFlag && d.onPinch(f, w);
        }
        d.getCurrentStore().getPosition(w, !0);
      }
    }, d.onDragEnd = function(f) {
      if (d.flag) {
        var m = d.options, C = m.pinchOutside, w = m.container, S = m.preventClickEventOnDrag, $ = m.preventClickEventOnDragStart, T = m.preventClickEventByCondition, I = d.isDrag;
        (S || $ || T) && requestAnimationFrame(function() {
          d._allowClickEvent();
        }), !T && !$ && S && !I && d._allowClickEvent(), d._useTouch && C && removeEvent(w, "touchstart", d.onDragStart), d.pinchFlag && d.onPinchEnd(f);
        var _ = f?.touches ? getEventClients(f) : [], E = _.length;
        E === 0 || !d.options.keepDragging ? d.flag = !1 : d._addStore(new ClientStore(_));
        var R = d._getPosition(), O = now(), L = !I && d.doubleFlag;
        d._prevInputEvent = null, d.prevTime = I || L ? 0 : O, d.flag || (d._dettachDragEvent(), d._preventMouseEvent || d.emit("dragEnd", __assign$7({ data: d.data, datas: d.data, isDouble: L, isDrag: I, isClick: !I, isMouseEvent: d._isMouseEvent, isSecondaryButton: d._isSecondaryButton, inputEvent: f, isTrusted: d._isTrusted }, R)), d.clientStores = [], d._isMouseEvent || (d._preventMouseEvent = !0, clearTimeout(d._preventMouseEventId), d._preventMouseEventId = setTimeout(function() {
          d._preventMouseEvent = !1;
        }, 200)), d._isIdle = !0);
      }
    }, d.onBlur = function() {
      d.onDragEnd();
    }, d._allowClickEvent = function() {
      removeEvent(d._window, "click", d._onClick, !0);
    }, d._onClick = function(f) {
      d._allowClickEvent(), d._allowMouseEvent();
      var m = d.options.preventClickEventByCondition;
      m?.(f) || (f.stopPropagation(), f.preventDefault());
    }, d._onContextMenu = function(f) {
      var m = d.options;
      m.preventRightClick ? d.onDragEnd(f) : f.preventDefault();
    }, d._passCallback = function() {
    };
    var p = [].concat(c), v = p[0];
    d._window = isWindow(v) ? v : getWindow(v), d.options = __assign$7({ checkInput: !1, container: v && !("document" in v) ? getWindow(v) : v, preventRightClick: !0, preventWheelClick: !0, preventClickEventOnDragStart: !1, preventClickEventOnDrag: !1, preventClickEventByCondition: null, preventDefault: !0, checkWindowBlur: !1, keepDragging: !1, pinchThreshold: 0, events: ["touch", "mouse"] }, u);
    var A = d.options, x = A.container, g = A.events, b = A.checkWindowBlur;
    if (d._useDrag = g.indexOf("drag") > -1, d._useTouch = g.indexOf("touch") > -1, d._useMouse = g.indexOf("mouse") > -1, d.targets = p, d._useDrag && p.forEach(function(f) {
      addEvent(f, "dragstart", d.onDragStart);
    }), d._useMouse && (p.forEach(function(f) {
      addEvent(f, "mousedown", d.onDragStart), addEvent(f, "mousemove", d._passCallback);
    }), addEvent(x, "contextmenu", d._onContextMenu)), b && addEvent(getWindow(), "blur", d.onBlur), d._useTouch) {
      var y = {
        passive: !1
      };
      p.forEach(function(f) {
        addEvent(f, "touchstart", d.onDragStart, y), addEvent(f, "touchmove", d._passCallback, y);
      });
    }
    return d;
  }
  return s.prototype.stop = function() {
    this.isDrag = !1, this.data = {}, this.clientStores = [], this.pinchFlag = !1, this.doubleFlag = !1, this.prevTime = 0, this.flag = !1, this._isIdle = !0, this._allowClickEvent(), this._dettachDragEvent(), this._isDragAPI = !1;
  }, s.prototype.getMovement = function(c) {
    return this.getCurrentStore().getMovement(c) + this.clientStores.slice(1).reduce(function(u, d) {
      return u + d.movement;
    }, 0);
  }, s.prototype.isDragging = function() {
    return this.isDrag;
  }, s.prototype.isIdle = function() {
    return this._isIdle;
  }, s.prototype.isFlag = function() {
    return this.flag;
  }, s.prototype.isPinchFlag = function() {
    return this.pinchFlag;
  }, s.prototype.isDoubleFlag = function() {
    return this.doubleFlag;
  }, s.prototype.isPinching = function() {
    return this.isPinch;
  }, s.prototype.scrollBy = function(c, u, d, p) {
    p === void 0 && (p = !0), this.flag && (this.clientStores[0].move(c, u), p && this.onDrag(d, !0));
  }, s.prototype.move = function(c, u) {
    var d = c[0], p = c[1], v = this.getCurrentStore(), A = v.prevClients;
    return this.moveClients(A.map(function(x) {
      var g = x.clientX, b = x.clientY;
      return {
        clientX: g + d,
        clientY: b + p,
        originalClientX: g,
        originalClientY: b
      };
    }), u, !0);
  }, s.prototype.triggerDragStart = function(c) {
    this.onDragStart(c, !1);
  }, s.prototype.setEventData = function(c) {
    var u = this.data;
    for (var d in c)
      u[d] = c[d];
    return this;
  }, s.prototype.setEventDatas = function(c) {
    return this.setEventData(c);
  }, s.prototype.getCurrentEvent = function(c) {
    return c === void 0 && (c = this._prevInputEvent), __assign$7(__assign$7({ data: this.data, datas: this.data }, this._getPosition()), { movement: this.getMovement(), isDrag: this.isDrag, isPinch: this.isPinch, isScroll: !1, inputEvent: c });
  }, s.prototype.getEventData = function() {
    return this.data;
  }, s.prototype.getEventDatas = function() {
    return this.data;
  }, s.prototype.unset = function() {
    var c = this, u = this.targets, d = this.options.container;
    this.off(), removeEvent(this._window, "blur", this.onBlur), this._useDrag && u.forEach(function(p) {
      removeEvent(p, "dragstart", c.onDragStart);
    }), this._useMouse && (u.forEach(function(p) {
      removeEvent(p, "mousedown", c.onDragStart);
    }), removeEvent(d, "contextmenu", this._onContextMenu)), this._useTouch && (u.forEach(function(p) {
      removeEvent(p, "touchstart", c.onDragStart);
    }), removeEvent(d, "touchstart", this.onDragStart)), this._prevInputEvent = null, this._allowClickEvent(), this._dettachDragEvent();
  }, s.prototype.onPinchStart = function(c) {
    var u = this, d = this.options.pinchThreshold;
    if (!(this.isDrag && this.getMovement() > d)) {
      var p = new ClientStore(getEventClients(c));
      this.pinchFlag = !0, this._addStore(p);
      var v = this.emit("pinchStart", __assign$7(__assign$7({ data: this.data, datas: this.data, angle: p.getAngle(), touches: this.getCurrentStore().getPositions() }, p.getPosition()), { inputEvent: c, isTrusted: this._isTrusted, preventDefault: function() {
        c.preventDefault();
      }, preventDrag: function() {
        u._dragFlag = !1;
      } }));
      v === !1 && (this.pinchFlag = !1);
    }
  }, s.prototype.onPinch = function(c, u) {
    if (!(!this.flag || !this.pinchFlag || u.length < 2)) {
      var d = this.getCurrentStore();
      this.isPinch = !0, this.emit("pinch", __assign$7(__assign$7({ data: this.data, datas: this.data, movement: this.getMovement(u), angle: d.getAngle(u), rotation: d.getRotation(u), touches: d.getPositions(u), scale: d.getScale(u), distance: d.getDistance(u) }, d.getPosition(u)), { inputEvent: c, isTrusted: this._isTrusted }));
    }
  }, s.prototype.onPinchEnd = function(c) {
    if (this.pinchFlag) {
      var u = this.isPinch;
      this.isPinch = !1, this.pinchFlag = !1;
      var d = this.getCurrentStore();
      this.emit("pinchEnd", __assign$7(__assign$7({ data: this.data, datas: this.data, isPinch: u, touches: d.getPositions() }, d.getPosition()), { inputEvent: c }));
    }
  }, s.prototype.getCurrentStore = function() {
    return this.clientStores[0];
  }, s.prototype.moveClients = function(c, u, d) {
    var p = this._getPosition(c, d), v = this.isDrag;
    (p.deltaX || p.deltaY) && (this.isDrag = !0);
    var A = !1;
    return !v && this.isDrag && (A = !0), __assign$7(__assign$7({ data: this.data, datas: this.data }, p), { movement: this.getMovement(c), isDrag: this.isDrag, isPinch: this.isPinch, isScroll: !1, isMouseEvent: this._isMouseEvent, isSecondaryButton: this._isSecondaryButton, inputEvent: u, isTrusted: this._isTrusted, isFirstDrag: A });
  }, s.prototype._addStore = function(c) {
    this.clientStores.splice(0, 0, c);
  }, s.prototype._getPosition = function(c, u) {
    var d = this.getCurrentStore(), p = d.getPosition(c, u), v = this.clientStores.slice(1).reduce(function(g, b) {
      var y = b.getPosition();
      return g.distX += y.distX, g.distY += y.distY, g;
    }, p), A = v.distX, x = v.distY;
    return __assign$7(__assign$7({}, p), { distX: A, distY: x });
  }, s.prototype._attchDragEvent = function() {
    var c = this._window, u = this.options.container, d = {
      passive: !1
    };
    this._isDragAPI && (addEvent(u, "dragover", this.onDrag, d), addEvent(c, "dragend", this.onDragEnd)), this._useMouse && (addEvent(u, "mousemove", this.onDrag), addEvent(c, "mouseup", this.onDragEnd)), this._useTouch && (addEvent(u, "touchmove", this.onDrag, d), addEvent(c, "touchend", this.onDragEnd, d), addEvent(c, "touchcancel", this.onDragEnd, d));
  }, s.prototype._dettachDragEvent = function() {
    var c = this._window, u = this.options.container;
    this._isDragAPI && (removeEvent(u, "dragover", this.onDrag), removeEvent(c, "dragend", this.onDragEnd)), this._useMouse && (removeEvent(u, "mousemove", this.onDrag), removeEvent(c, "mouseup", this.onDragEnd)), this._useTouch && (removeEvent(u, "touchstart", this.onDragStart), removeEvent(u, "touchmove", this.onDrag), removeEvent(c, "touchend", this.onDragEnd), removeEvent(c, "touchcancel", this.onDragEnd));
  }, s.prototype._allowMouseEvent = function() {
    this._preventMouseEvent = !1, clearTimeout(this._preventMouseEventId);
  }, s;
}(EventEmitter);
function prefixNames(a) {
  for (var s = [], c = 1; c < arguments.length; c++)
    s[c - 1] = arguments[c];
  return s.map(function(u) {
    return u.split(" ").map(function(d) {
      return d ? "" + a + d : "";
    }).join(" ");
  }).join(" ");
}
function prefixCSS(a, s) {
  return s.replace(/([^}{]*){/gm, function(c, u) {
    return u.replace(/\.([^{,\s\d.]+)/g, "." + a + "$1") + "{";
  });
}
function ref(a, s) {
  return function(c) {
    c && (a[s] = c);
  };
}
function refs(a, s, c) {
  return function(u) {
    u && (a[s][c] = u);
  };
}
function Properties(a, s) {
  return function(c) {
    var u = c.prototype;
    a.forEach(function(d) {
      s(u, d);
    });
  };
}
function withMethods(a, s) {
  return s === void 0 && (s = {}), function(c, u) {
    a.forEach(function(d) {
      var p = s[d] || d;
      p in c || (c[p] = function() {
        for (var v, A = [], x = 0; x < arguments.length; x++)
          A[x] = arguments[x];
        var g = (v = this[u])[d].apply(v, A);
        return g === this[u] ? this : g;
      });
    });
  };
}
var PolyMap = /* @__PURE__ */ function() {
  function a() {
    this.keys = [], this.values = [];
  }
  var s = a.prototype;
  return s.get = function(c) {
    return this.values[this.keys.indexOf(c)];
  }, s.set = function(c, u) {
    var d = this.keys, p = this.values, v = d.indexOf(c), A = v === -1 ? d.length : v;
    d[A] = c, p[A] = u;
  }, a;
}(), HashMap = /* @__PURE__ */ function() {
  function a() {
    this.object = {};
  }
  var s = a.prototype;
  return s.get = function(c) {
    return this.object[c];
  }, s.set = function(c, u) {
    this.object[c] = u;
  }, a;
}(), SUPPORT_MAP = typeof Map == "function", Link = /* @__PURE__ */ function() {
  function a() {
  }
  var s = a.prototype;
  return s.connect = function(c, u) {
    this.prev = c, this.next = u, c && (c.next = this), u && (u.prev = this);
  }, s.disconnect = function() {
    var c = this.prev, u = this.next;
    c && (c.next = u), u && (u.prev = c);
  }, s.getIndex = function() {
    for (var c = this, u = -1; c; )
      c = c.prev, ++u;
    return u;
  }, a;
}();
function orderChanged(a, s) {
  var c = [], u = [];
  return a.forEach(function(d) {
    var p = d[0], v = d[1], A = new Link();
    c[p] = A, u[v] = A;
  }), c.forEach(function(d, p) {
    d.connect(c[p - 1]);
  }), a.filter(function(d, p) {
    return !s[p];
  }).map(function(d, p) {
    var v = d[0], A = d[1];
    if (v === A)
      return [0, 0];
    var x = c[v], g = u[A - 1], b = x.getIndex();
    x.disconnect(), g ? x.connect(g, g.next) : x.connect(void 0, c[0]);
    var y = x.getIndex();
    return [b, y];
  });
}
var Result = /* @__PURE__ */ function() {
  function a(c, u, d, p, v, A, x, g) {
    this.prevList = c, this.list = u, this.added = d, this.removed = p, this.changed = v, this.maintained = A, this.changedBeforeAdded = x, this.fixed = g;
  }
  var s = a.prototype;
  return Object.defineProperty(s, "ordered", {
    get: function() {
      return this.cacheOrdered || this.caculateOrdered(), this.cacheOrdered;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(s, "pureChanged", {
    get: function() {
      return this.cachePureChanged || this.caculateOrdered(), this.cachePureChanged;
    },
    enumerable: !0,
    configurable: !0
  }), s.caculateOrdered = function() {
    var c = orderChanged(this.changedBeforeAdded, this.fixed), u = this.changed, d = [];
    this.cacheOrdered = c.filter(function(p, v) {
      var A = p[0], x = p[1], g = u[v], b = g[0], y = g[1];
      if (A !== x)
        return d.push([b, y]), !0;
    }), this.cachePureChanged = d;
  }, a;
}();
function diff$1(a, s, c) {
  var u = SUPPORT_MAP ? Map : c ? HashMap : PolyMap, d = c || function(T) {
    return T;
  }, p = [], v = [], A = [], x = a.map(d), g = s.map(d), b = new u(), y = new u(), f = [], m = [], C = {}, w = [], S = 0, $ = 0;
  return x.forEach(function(T, I) {
    b.set(T, I);
  }), g.forEach(function(T, I) {
    y.set(T, I);
  }), x.forEach(function(T, I) {
    var _ = y.get(T);
    typeof _ > "u" ? (++$, v.push(I)) : C[_] = $;
  }), g.forEach(function(T, I) {
    var _ = b.get(T);
    typeof _ > "u" ? (p.push(I), ++S) : (A.push([_, I]), $ = C[I] || 0, f.push([_ - $, I - S]), m.push(I === _), _ !== I && w.push([_, I]));
  }), v.reverse(), new Result(a, s, p, v, w, A, f, m);
}
var ListDiffer = /* @__PURE__ */ function() {
  function a(c, u) {
    c === void 0 && (c = []), this.findKeyCallback = u, this.list = [].slice.call(c);
  }
  var s = a.prototype;
  return s.update = function(c) {
    var u = [].slice.call(c), d = diff$1(this.list, u, this.findKeyCallback);
    return this.list = u, d;
  }, a;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics$7 = function(a, s) {
  return extendStatics$7 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) u.hasOwnProperty(d) && (c[d] = u[d]);
  }, extendStatics$7(a, s);
};
function __extends$7(a, s) {
  extendStatics$7(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
var findKeyCallback = typeof Map == "function" ? void 0 : /* @__PURE__ */ function() {
  var a = 0;
  return function(s) {
    return s.__DIFF_KEY__ || (s.__DIFF_KEY__ = ++a);
  };
}(), ChildrenDiffer = /* @__PURE__ */ function(a) {
  __extends$7(s, a);
  function s(c) {
    return c === void 0 && (c = []), a.call(this, c, findKeyCallback) || this;
  }
  return s;
}(ListDiffer);
function diff(a, s) {
  return diff$1(a, s, findKeyCallback);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics$6 = function(a, s) {
  return extendStatics$6 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) u.hasOwnProperty(d) && (c[d] = u[d]);
  }, extendStatics$6(a, s);
};
function __extends$6(a, s) {
  extendStatics$6(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
var __assign$6 = function() {
  return __assign$6 = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign$6.apply(this, arguments);
};
function getDefaultScrollPosition$1(a) {
  var s = a.container;
  return s === document.body ? [s.scrollLeft || document.documentElement.scrollLeft, s.scrollTop || document.documentElement.scrollTop] : [s.scrollLeft, s.scrollTop];
}
function checkDefaultScrollEvent(a, s) {
  return a.addEventListener("scroll", s), function() {
    a.removeEventListener("scroll", s);
  };
}
function getContainerElement(a) {
  if (a) {
    if (isString(a))
      return document.querySelector(a);
  } else return null;
  if (isFunction(a))
    return a();
  if (a instanceof Element)
    return a;
  if ("current" in a)
    return a.current;
  if ("value" in a)
    return a.value;
}
var DragScroll = /* @__PURE__ */ function(a) {
  __extends$6(s, a);
  function s() {
    var u = a !== null && a.apply(this, arguments) || this;
    return u._startRect = null, u._startPos = [], u._prevTime = 0, u._timer = 0, u._prevScrollPos = [0, 0], u._isWait = !1, u._flag = !1, u._currentOptions = null, u._lock = !1, u._unregister = null, u._onScroll = function() {
      var d = u._currentOptions;
      u._lock || !d || u.emit("scrollDrag", {
        next: function(p) {
          u.checkScroll({
            container: d.container,
            inputEvent: p
          });
        }
      });
    }, u;
  }
  var c = s.prototype;
  return c.dragStart = function(u, d) {
    var p = getContainerElement(d.container);
    if (!p) {
      this._flag = !1;
      return;
    }
    var v = 0, A = 0, x = 0, g = 0;
    if (p === document.body)
      x = window.innerWidth, g = window.innerHeight;
    else {
      var b = p.getBoundingClientRect();
      v = b.top, A = b.left, x = b.width, g = b.height;
    }
    this._flag = !0, this._startPos = [u.clientX, u.clientY], this._startRect = {
      top: v,
      left: A,
      width: x,
      height: g
    }, this._prevScrollPos = this._getScrollPosition([0, 0], d), this._currentOptions = d, this._registerScrollEvent(d);
  }, c.drag = function(u, d) {
    if (clearTimeout(this._timer), !!this._flag) {
      var p = u.clientX, v = u.clientY, A = d.threshold, x = A === void 0 ? 0 : A, g = this, b = g._startRect, y = g._startPos;
      this._currentOptions = d;
      var f = [0, 0];
      return b.top > v - x ? (y[1] > b.top || v < y[1]) && (f[1] = -1) : b.top + b.height < v + x && (y[1] < b.top + b.height || v > y[1]) && (f[1] = 1), b.left > p - x ? (y[0] > b.left || p < y[0]) && (f[0] = -1) : b.left + b.width < p + x && (y[0] < b.left + b.width || p > y[0]) && (f[0] = 1), !f[0] && !f[1] ? !1 : this._continueDrag(__assign$6(__assign$6({}, d), {
        direction: f,
        inputEvent: u,
        isDrag: !0
      }));
    }
  }, c.checkScroll = function(u) {
    var d = this;
    if (this._isWait)
      return !1;
    var p = u.prevScrollPos, v = p === void 0 ? this._prevScrollPos : p, A = u.direction, x = u.throttleTime, g = x === void 0 ? 0 : x, b = u.inputEvent, y = u.isDrag, f = this._getScrollPosition(A || [0, 0], u), m = f[0] - v[0], C = f[1] - v[1], w = A || [m ? Math.abs(m) / m : 0, C ? Math.abs(C) / C : 0];
    return this._prevScrollPos = f, this._lock = !1, !m && !C ? !1 : (this.emit("move", {
      offsetX: w[0] ? m : 0,
      offsetY: w[1] ? C : 0,
      inputEvent: b
    }), g && y && (clearTimeout(this._timer), this._timer = window.setTimeout(function() {
      d._continueDrag(u);
    }, g)), !0);
  }, c.dragEnd = function() {
    this._flag = !1, this._lock = !1, clearTimeout(this._timer), this._unregisterScrollEvent();
  }, c._getScrollPosition = function(u, d) {
    var p = d.container, v = d.getScrollPosition, A = v === void 0 ? getDefaultScrollPosition$1 : v;
    return A({
      container: getContainerElement(p),
      direction: u
    });
  }, c._continueDrag = function(u) {
    var d = this, p, v = u.container, A = u.direction, x = u.throttleTime, g = u.useScroll, b = u.isDrag, y = u.inputEvent;
    if (!(!this._flag || b && this._isWait)) {
      var f = now(), m = Math.max(x + this._prevTime - f, 0);
      if (m > 0)
        return clearTimeout(this._timer), this._timer = window.setTimeout(function() {
          d._continueDrag(u);
        }, m), !1;
      this._prevTime = f;
      var C = this._getScrollPosition(A, u);
      this._prevScrollPos = C, b && (this._isWait = !0), g || (this._lock = !0);
      var w = {
        container: getContainerElement(v),
        direction: A,
        inputEvent: y
      };
      return (p = u.requestScroll) === null || p === void 0 || p.call(u, w), this.emit("scroll", w), this._isWait = !1, g || this.checkScroll(__assign$6(__assign$6({}, u), {
        prevScrollPos: C,
        direction: A,
        inputEvent: y
      }));
    }
  }, c._registerScrollEvent = function(u) {
    this._unregisterScrollEvent();
    var d = u.checkScrollEvent;
    if (d) {
      var p = d === !0 ? checkDefaultScrollEvent : d, v = getContainerElement(u.container);
      d === !0 && (v === document.body || v === document.documentElement) ? this._unregister = checkDefaultScrollEvent(window, this._onScroll) : this._unregister = p(v, this._onScroll);
    }
  }, c._unregisterScrollEvent = function() {
    var u;
    (u = this._unregister) === null || u === void 0 || u.call(this), this._unregister = null;
  }, s;
}(EventEmitter), extendStatics$5 = function(a, s) {
  return extendStatics$5 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
  }, extendStatics$5(a, s);
};
function __extends$5(a, s) {
  if (typeof s != "function" && s !== null) throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$5(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
function createCommonjsModule(a, s) {
  return s = {
    exports: {}
  }, a(s, s.exports), s.exports;
}
var keycode = createCommonjsModule(function(a, s) {
  function c(x) {
    if (x && typeof x == "object") {
      var g = x.which || x.keyCode || x.charCode;
      g && (x = g);
    }
    if (typeof x == "number") return v[x];
    var b = String(x), y = u[b.toLowerCase()];
    if (y) return y;
    var y = d[b.toLowerCase()];
    if (y) return y;
    if (b.length === 1) return b.charCodeAt(0);
  }
  c.isEventKey = function(g, b) {
    if (g && typeof g == "object") {
      var y = g.which || g.keyCode || g.charCode;
      if (y == null)
        return !1;
      if (typeof b == "string") {
        var f = u[b.toLowerCase()];
        if (f)
          return f === y;
        var f = d[b.toLowerCase()];
        if (f)
          return f === y;
      } else if (typeof b == "number")
        return b === y;
      return !1;
    }
  }, s = a.exports = c;
  var u = s.code = s.codes = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    "pause/break": 19,
    "caps lock": 20,
    esc: 27,
    space: 32,
    "page up": 33,
    "page down": 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    delete: 46,
    command: 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
  }, d = s.aliases = {
    windows: 91,
    "⇧": 16,
    "⌥": 18,
    "⌃": 17,
    "⌘": 91,
    ctl: 17,
    control: 17,
    option: 18,
    pause: 19,
    break: 19,
    caps: 20,
    return: 13,
    escape: 27,
    spc: 32,
    spacebar: 32,
    pgup: 33,
    pgdn: 34,
    ins: 45,
    del: 46,
    cmd: 91
  };
  /*!
   * Programatically add the following
   */
  for (p = 97; p < 123; p++) u[String.fromCharCode(p)] = p - 32;
  for (var p = 48; p < 58; p++) u[p - 48] = p;
  for (p = 1; p < 13; p++) u["f" + p] = p + 111;
  for (p = 0; p < 10; p++) u["numpad " + p] = p + 96;
  var v = s.names = s.title = {};
  for (p in u) v[u[p]] = p;
  for (var A in d)
    u[A] = d[A];
});
keycode.code;
keycode.codes;
keycode.aliases;
var keycode_4 = keycode.names;
keycode.title;
var codeData = {
  "+": "plus",
  "left command": "meta",
  "right command": "meta"
}, keysSort = {
  shift: 1,
  ctrl: 2,
  alt: 3,
  meta: 4
};
function getKey(a, s) {
  var c = (keycode_4[a] || s || "").toLowerCase();
  for (var u in codeData)
    c = c.replace(u, codeData[u]);
  return c.replace(/\s/g, "");
}
function getCombi(a, s) {
  s === void 0 && (s = getKey(a.keyCode, a.key));
  var c = getModifierCombi(a);
  return c.indexOf(s) === -1 && c.push(s), c.filter(Boolean);
}
function getModifierCombi(a) {
  var s = [a.shiftKey && "shift", a.ctrlKey && "ctrl", a.altKey && "alt", a.metaKey && "meta"];
  return s.filter(Boolean);
}
function getArrangeCombi(a) {
  var s = a.slice();
  return s.sort(function(c, u) {
    var d = keysSort[c] || 5, p = keysSort[u] || 5;
    return d - p;
  }), s;
}
var globalKeyController, KeyController = /* @__PURE__ */ function(a) {
  __extends$5(s, a);
  function s(u) {
    u === void 0 && (u = window);
    var d = a.call(this) || this;
    return d.container = u, d.ctrlKey = !1, d.altKey = !1, d.shiftKey = !1, d.metaKey = !1, d.clear = function() {
      return d.ctrlKey = !1, d.altKey = !1, d.shiftKey = !1, d.metaKey = !1, d;
    }, d.keydownEvent = function(p) {
      d.triggerEvent("keydown", p);
    }, d.keyupEvent = function(p) {
      d.triggerEvent("keyup", p);
    }, d.blur = function() {
      d.clear(), d.trigger("blur");
    }, addEvent(u, "blur", d.blur), addEvent(u, "keydown", d.keydownEvent), addEvent(u, "keyup", d.keyupEvent), d;
  }
  var c = s.prototype;
  return Object.defineProperty(s, "global", {
    /**
     */
    get: function() {
      return globalKeyController || (globalKeyController = new s());
    },
    enumerable: !1,
    configurable: !0
  }), s.setGlobal = function() {
    return this.global;
  }, c.destroy = function() {
    var u = this.container;
    this.clear(), this.off(), removeEvent(u, "blur", this.blur), removeEvent(u, "keydown", this.keydownEvent), removeEvent(u, "keyup", this.keyupEvent);
  }, c.keydown = function(u, d) {
    return this.addEvent("keydown", u, d);
  }, c.offKeydown = function(u, d) {
    return this.removeEvent("keydown", u, d);
  }, c.offKeyup = function(u, d) {
    return this.removeEvent("keyup", u, d);
  }, c.keyup = function(u, d) {
    return this.addEvent("keyup", u, d);
  }, c.addEvent = function(u, d, p) {
    return isArray(d) ? this.on("".concat(u, ".").concat(getArrangeCombi(d).join(".")), p) : isString(d) ? this.on("".concat(u, ".").concat(d), p) : this.on(u, d), this;
  }, c.removeEvent = function(u, d, p) {
    return isArray(d) ? this.off("".concat(u, ".").concat(getArrangeCombi(d).join(".")), p) : isString(d) ? this.off("".concat(u, ".").concat(d), p) : this.off(u, d), this;
  }, c.triggerEvent = function(u, d) {
    this.ctrlKey = d.ctrlKey, this.shiftKey = d.shiftKey, this.altKey = d.altKey, this.metaKey = d.metaKey;
    var p = getKey(d.keyCode, d.key), v = p === "ctrl" || p === "shift" || p === "meta" || p === "alt", A = {
      key: p,
      isToggle: v,
      inputEvent: d,
      keyCode: d.keyCode,
      ctrlKey: d.ctrlKey,
      altKey: d.altKey,
      shiftKey: d.shiftKey,
      metaKey: d.metaKey
    };
    this.trigger(u, A), this.trigger("".concat(u, ".").concat(p), A);
    var x = getCombi(d, p);
    x.length > 1 && this.trigger("".concat(u, ".").concat(x.join(".")), A);
  }, s;
}(EventEmitter);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __spreadArrays() {
  for (var a = 0, s = 0, c = arguments.length; s < c; s++) a += arguments[s].length;
  for (var u = Array(a), d = 0, s = 0; s < c; s++) for (var p = arguments[s], v = 0, A = p.length; v < A; v++, d++) u[d] = p[v];
  return u;
}
function tinyThrottle(a) {
  return throttle(a, TINY_NUM$1);
}
function isSameConstants(a, s) {
  return a.every(function(c, u) {
    return tinyThrottle(c - s[u]) === 0;
  });
}
function isSamePoint(a, s) {
  return !tinyThrottle(a[0] - s[0]) && !tinyThrottle(a[1] - s[1]);
}
function getAreaSize(a) {
  return a.length < 3 ? 0 : Math.abs(sum(a.map(function(s, c) {
    var u = a[c + 1] || a[0];
    return s[0] * u[1] - u[0] * s[1];
  }))) / 2;
}
function fitPoints(a, s) {
  var c = s.width, u = s.height, d = s.left, p = s.top, v = getMinMaxs(a), A = v.minX, x = v.minY, g = v.maxX, b = v.maxY, y = c / (g - A), f = u / (b - x);
  return a.map(function(m) {
    return [d + (m[0] - A) * y, p + (m[1] - x) * f];
  });
}
function getMinMaxs(a) {
  var s = a.map(function(u) {
    return u[0];
  }), c = a.map(function(u) {
    return u[1];
  });
  return {
    minX: Math.min.apply(Math, s),
    minY: Math.min.apply(Math, c),
    maxX: Math.max.apply(Math, s),
    maxY: Math.max.apply(Math, c)
  };
}
function isInside(a, s, c) {
  var u = a[0], d = a[1], p = getMinMaxs(s), v = p.minX, A = p.maxX, x = [[v, d], [A, d]], g = getLinearConstants(x[0], x[1]), b = convertLines(s), y = [];
  if (b.forEach(function(C) {
    var w = getLinearConstants(C[0], C[1]), S = C[0];
    if (isSameConstants(g, w))
      y.push({
        pos: a,
        line: C,
        type: "line"
      });
    else {
      var $ = getPointsOnLines(getIntersectionPointsByConstants(g, w), [x, C]);
      $.forEach(function(T) {
        C.some(function(I) {
          return isSamePoint(I, T);
        }) ? y.push({
          pos: T,
          line: C,
          type: "point"
        }) : tinyThrottle(S[1] - d) !== 0 && y.push({
          pos: T,
          line: C,
          type: "intersection"
        });
      });
    }
  }), find$1(y, function(C) {
    return C[0] === u;
  }))
    return !0;
  var f = 0, m = {};
  return y.forEach(function(C) {
    var w = C.pos, S = C.type, $ = C.line;
    if (!(w[0] > u))
      if (S === "intersection")
        ++f;
      else {
        if (S === "line")
          return;
        if (S === "point") {
          var T = find$1($, function(E) {
            return E[1] !== d;
          }), I = m[w[0]], _ = T[1] > d ? 1 : -1;
          I ? I !== _ && ++f : m[w[0]] = _;
        }
      }
  }), f % 2 === 1;
}
function getLinearConstants(a, s) {
  var c = a[0], u = a[1], d = s[0], p = s[1], v = d - c, A = p - u;
  Math.abs(v) < TINY_NUM$1 && (v = 0), Math.abs(A) < TINY_NUM$1 && (A = 0);
  var x = 0, g = 0, b = 0;
  return v ? A ? (x = -A / v, g = 1, b = -x * c - u) : (g = 1, b = -u) : A && (x = -1, b = c), [x, g, b];
}
function getIntersectionPointsByConstants(a, s) {
  var c = a[0], u = a[1], d = a[2], p = s[0], v = s[1], A = s[2], x = c === 0 && p === 0, g = u === 0 && v === 0, b = [];
  if (x && g)
    return [];
  if (x) {
    var y = -d / u, f = -A / v;
    return y !== f ? [] : [[-1 / 0, y], [1 / 0, y]];
  } else if (g) {
    var m = -d / c, C = -A / p;
    return m !== C ? [] : [[m, -1 / 0], [m, 1 / 0]];
  } else if (c === 0) {
    var w = -d / u, S = -(v * w + A) / p;
    b = [[S, w]];
  } else if (p === 0) {
    var w = -A / v, S = -(u * w + d) / c;
    b = [[S, w]];
  } else if (u === 0) {
    var S = -d / c, w = -(p * S + A) / v;
    b = [[S, w]];
  } else if (v === 0) {
    var S = -A / p, w = -(c * S + d) / u;
    b = [[S, w]];
  } else {
    var S = (u * A - v * d) / (v * c - u * p), w = -(c * S + d) / u;
    b = [[S, w]];
  }
  return b.map(function($) {
    return [$[0], $[1]];
  });
}
function getPointsOnLines(a, s) {
  var c = s.map(function(y) {
    return [0, 1].map(function(f) {
      return [Math.min(y[0][f], y[1][f]), Math.max(y[0][f], y[1][f])];
    });
  }), u = [];
  if (a.length === 2) {
    var d = a[0], p = d[0], v = d[1];
    if (tinyThrottle(p - a[1][0])) {
      if (!tinyThrottle(v - a[1][1])) {
        var g = Math.max.apply(Math, c.map(function(y) {
          return y[0][0];
        })), b = Math.min.apply(Math, c.map(function(y) {
          return y[0][1];
        }));
        if (tinyThrottle(g - b) > 0)
          return [];
        u = [[g, v], [b, v]];
      }
    } else {
      var A = Math.max.apply(Math, c.map(function(y) {
        return y[1][0];
      })), x = Math.min.apply(Math, c.map(function(y) {
        return y[1][1];
      }));
      if (tinyThrottle(A - x) > 0)
        return [];
      u = [[p, A], [p, x]];
    }
  }
  return u.length || (u = a.filter(function(y) {
    var f = y[0], m = y[1];
    return c.every(function(C) {
      return 0 <= tinyThrottle(f - C[0][0]) && 0 <= tinyThrottle(C[0][1] - f) && 0 <= tinyThrottle(m - C[1][0]) && 0 <= tinyThrottle(C[1][1] - m);
    });
  })), u.map(function(y) {
    return [tinyThrottle(y[0]), tinyThrottle(y[1])];
  });
}
function convertLines(a) {
  return __spreadArrays(a.slice(1), [a[0]]).map(function(s, c) {
    return [a[c], s];
  });
}
function getOverlapPointInfos(a, s) {
  var c = a.slice(), u = s.slice();
  getShapeDirection(c) === -1 && c.reverse(), getShapeDirection(u) === -1 && u.reverse();
  var d = convertLines(c), p = convertLines(u), v = d.map(function(b) {
    return getLinearConstants(b[0], b[1]);
  }), A = p.map(function(b) {
    return getLinearConstants(b[0], b[1]);
  }), x = [];
  v.forEach(function(b, y) {
    var f = d[y], m = [];
    A.forEach(function(C, w) {
      var S = getIntersectionPointsByConstants(b, C), $ = getPointsOnLines(S, [f, p[w]]);
      m.push.apply(m, $.map(function(T) {
        return {
          index1: y,
          index2: w,
          pos: T,
          type: "intersection"
        };
      }));
    }), m.sort(function(C, w) {
      return getDist$2(f[0], C.pos) - getDist$2(f[0], w.pos);
    }), x.push.apply(x, m), isInside(f[1], u) && x.push({
      index1: y,
      index2: -1,
      pos: f[1],
      type: "inside"
    });
  }), p.forEach(function(b, y) {
    if (isInside(b[1], c)) {
      var f = !1, m = findIndex(x, function(C) {
        var w = C.index2;
        return w === y ? (f = !0, !1) : !!f;
      });
      m === -1 && (f = !1, m = findIndex(x, function(C) {
        var w = C.index1, S = C.index2;
        return w === -1 && S + 1 === y ? (f = !0, !1) : !!f;
      })), m === -1 ? x.push({
        index1: -1,
        index2: y,
        pos: b[1],
        type: "inside"
      }) : x.splice(m, 0, {
        index1: -1,
        index2: y,
        pos: b[1],
        type: "inside"
      });
    }
  });
  var g = {};
  return x.filter(function(b) {
    var y = b.pos, f = y[0] + "x" + y[1];
    return g[f] ? !1 : (g[f] = !0, !0);
  });
}
function getOverlapPoints(a, s) {
  var c = getOverlapPointInfos(a, s);
  return c.map(function(u) {
    var d = u.pos;
    return d;
  });
}
function getOverlapSize(a, s) {
  var c = getOverlapPoints(a, s);
  return getAreaSize(c);
}
function add(a, s, c, u, d, p) {
  for (var v = 0; v < d; ++v) {
    var A = c + v * d, x = u + v * d;
    a[A] += a[x] * p, s[A] += s[x] * p;
  }
}
function swap(a, s, c, u, d) {
  for (var p = 0; p < d; ++p) {
    var v = c + p * d, A = u + p * d, x = a[v], g = s[v];
    a[v] = a[A], a[A] = x, s[v] = s[A], s[A] = g;
  }
}
function divide(a, s, c, u, d) {
  for (var p = 0; p < u; ++p) {
    var v = c + p * u;
    a[v] /= d, s[v] /= d;
  }
}
function ignoreDimension(a, s, c) {
  for (var u = a.slice(), d = 0; d < c; ++d)
    u[d * c + s - 1] = 0, u[(s - 1) * c + d] = 0;
  return u[(s - 1) * (c + 1)] = 1, u;
}
function invert(a, s) {
  s === void 0 && (s = Math.sqrt(a.length));
  for (var c = a.slice(), u = createIdentityMatrix(s), d = 0; d < s; ++d) {
    var p = s * d + d;
    if (!throttle(c[p], TINY_NUM$1)) {
      for (var v = d + 1; v < s; ++v)
        if (c[s * d + v]) {
          swap(c, u, d, v, s);
          break;
        }
    }
    if (!throttle(c[p], TINY_NUM$1))
      return [];
    divide(c, u, d, s, c[p]);
    for (var v = 0; v < s; ++v) {
      var A = v, x = v + d * s, g = c[x];
      !throttle(g, TINY_NUM$1) || d === v || add(c, u, A, d, s, -g);
    }
  }
  return u;
}
function transpose(a, s) {
  s === void 0 && (s = Math.sqrt(a.length));
  for (var c = [], u = 0; u < s; ++u)
    for (var d = 0; d < s; ++d)
      c[d * s + u] = a[s * u + d];
  return c;
}
function getOrigin(a, s) {
  s === void 0 && (s = Math.sqrt(a.length));
  for (var c = [], u = a[s * s - 1], d = 0; d < s - 1; ++d)
    c[d] = a[s * (s - 1) + d] / u;
  return c[s - 1] = 0, c;
}
function fromTranslation(a, s) {
  for (var c = createIdentityMatrix(s), u = 0; u < s - 1; ++u)
    c[s * (s - 1) + u] = a[u] || 0;
  return c;
}
function convertPositionMatrix(a, s) {
  for (var c = a.slice(), u = a.length; u < s - 1; ++u)
    c[u] = 0;
  return c[s - 1] = 1, c;
}
function convertDimension(a, s, c) {
  if (s === void 0 && (s = Math.sqrt(a.length)), s === c)
    return a;
  for (var u = createIdentityMatrix(c), d = Math.min(s, c), p = 0; p < d - 1; ++p) {
    for (var v = 0; v < d - 1; ++v)
      u[p * c + v] = a[p * s + v];
    u[(p + 1) * c - 1] = a[(p + 1) * s - 1], u[(c - 1) * c + p] = a[(s - 1) * s + p];
  }
  return u[c * c - 1] = a[s * s - 1], u;
}
function multiplies(a) {
  for (var s = [], c = 1; c < arguments.length; c++)
    s[c - 1] = arguments[c];
  var u = createIdentityMatrix(a);
  return s.forEach(function(d) {
    u = multiply(u, d, a);
  }), u;
}
function multiply(a, s, c) {
  c === void 0 && (c = Math.sqrt(a.length));
  var u = [], d = a.length / c, p = s.length / d;
  if (d) {
    if (!p)
      return a;
  } else return s;
  for (var v = 0; v < c; ++v)
    for (var A = 0; A < p; ++A) {
      u[A * c + v] = 0;
      for (var x = 0; x < d; ++x)
        u[A * c + v] += a[x * c + v] * s[A * d + x];
    }
  return u;
}
function plus(a, s) {
  for (var c = Math.min(a.length, s.length), u = a.slice(), d = 0; d < c; ++d)
    u[d] = u[d] + s[d];
  return u;
}
function minus(a, s) {
  for (var c = Math.min(a.length, s.length), u = a.slice(), d = 0; d < c; ++d)
    u[d] = u[d] - s[d];
  return u;
}
function convertCSStoMatrix(a, s) {
  return s === void 0 && (s = a.length === 6), s ? [a[0], a[1], 0, a[2], a[3], 0, a[4], a[5], 1] : a;
}
function convertMatrixtoCSS(a, s) {
  return s === void 0 && (s = a.length === 9), s ? [a[0], a[1], a[3], a[4], a[6], a[7]] : a;
}
function calculate(a, s, c) {
  c === void 0 && (c = s.length);
  var u = multiply(a, s, c), d = u[c - 1];
  return u.map(function(p) {
    return p / d;
  });
}
function rotateX3d(a, s) {
  return multiply(a, [1, 0, 0, 0, 0, Math.cos(s), Math.sin(s), 0, 0, -Math.sin(s), Math.cos(s), 0, 0, 0, 0, 1], 4);
}
function rotateY3d(a, s) {
  return multiply(a, [Math.cos(s), 0, -Math.sin(s), 0, 0, 1, 0, 0, Math.sin(s), 0, Math.cos(s), 0, 0, 0, 0, 1], 4);
}
function rotateZ3d(a, s) {
  return multiply(a, createRotateMatrix(s, 4));
}
function scale3d(a, s) {
  var c = s[0], u = c === void 0 ? 1 : c, d = s[1], p = d === void 0 ? 1 : d, v = s[2], A = v === void 0 ? 1 : v;
  return multiply(a, [u, 0, 0, 0, 0, p, 0, 0, 0, 0, A, 0, 0, 0, 0, 1], 4);
}
function rotate(a, s) {
  return calculate(createRotateMatrix(s, 3), convertPositionMatrix(a, 3));
}
function translate3d(a, s) {
  var c = s[0], u = c === void 0 ? 0 : c, d = s[1], p = d === void 0 ? 0 : d, v = s[2], A = v === void 0 ? 0 : v;
  return multiply(a, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, u, p, A, 1], 4);
}
function matrix3d(a, s) {
  return multiply(a, s, 4);
}
function createRotateMatrix(a, s) {
  var c = Math.cos(a), u = Math.sin(a), d = createIdentityMatrix(s);
  return d[0] = c, d[1] = u, d[s] = -u, d[s + 1] = c, d;
}
function createIdentityMatrix(a) {
  for (var s = a * a, c = [], u = 0; u < s; ++u)
    c[u] = u % (a + 1) ? 0 : 1;
  return c;
}
function createScaleMatrix(a, s) {
  for (var c = createIdentityMatrix(s), u = Math.min(a.length, s - 1), d = 0; d < u; ++d)
    c[(s + 1) * d] = a[d];
  return c;
}
function createOriginMatrix(a, s) {
  for (var c = createIdentityMatrix(s), u = Math.min(a.length, s - 1), d = 0; d < u; ++d)
    c[s * (s - 1) + d] = a[d];
  return c;
}
function createWarpMatrix(a, s, c, u, d, p, v, A) {
  var x = a[0], g = a[1], b = s[0], y = s[1], f = c[0], m = c[1], C = u[0], w = u[1], S = d[0], $ = d[1], T = p[0], I = p[1], _ = v[0], E = v[1], R = A[0], O = A[1], L = [x, 0, b, 0, f, 0, C, 0, g, 0, y, 0, m, 0, w, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, x, 0, b, 0, f, 0, C, 0, g, 0, y, 0, m, 0, w, 0, 1, 0, 1, 0, 1, 0, 1, -S * x, -$ * x, -T * b, -I * b, -_ * f, -E * f, -R * C, -O * C, -S * g, -$ * g, -T * y, -I * y, -_ * m, -E * m, -R * w, -O * w], B = invert(L, 8);
  if (!B.length)
    return [];
  var F = multiply(B, [S, $, T, I, _, E, R, O], 8);
  return F[8] = 1, convertDimension(transpose(F), 3, 4);
}
var __assign$5 = function() {
  return __assign$5 = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign$5.apply(this, arguments);
};
function createMatrix() {
  return [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
  ];
}
function parseMat(a, s) {
  return s === void 0 && (s = 0), toMat(parse(a, s));
}
function calculateMatrixDist(a, s) {
  var c = calculate(a, [s[0], s[1] || 0, s[2] || 0, 1], 4), u = c[3] || 1;
  return [
    c[0] / u,
    c[1] / u,
    c[2] / u
  ];
}
function getDistElementMatrix(a, s) {
  s === void 0 && (s = document.body);
  for (var c = a, u = createMatrix(); c; ) {
    var d = getComputedStyle(c).transform;
    if (u = matrix3d(parseMat(d), u), c === s)
      break;
    c = c.parentElement;
  }
  return u = invert(u, 4), u[12] = 0, u[13] = 0, u[14] = 0, u;
}
function toMat(a) {
  var s = createMatrix();
  return a.forEach(function(c) {
    var u = c.matrixFunction, d = c.functionValue;
    u && (s = u(s, d));
  }), s;
}
function parse(a, s) {
  s === void 0 && (s = 0);
  var c = isArray(a) ? a : splitSpace(a);
  return c.map(function(u) {
    var d = splitBracket(u), p = d.prefix, v = d.value, A = null, x = p, g = "";
    if (p === "translate" || p === "translateX" || p === "translate3d") {
      var b = isObject$1(s) ? __assign$5(__assign$5({}, s), { "o%": s["%"] }) : {
        "%": s,
        "o%": s
      }, y = splitComma(v).map(function(j, G) {
        return G === 0 && "x%" in b ? b["%"] = s["x%"] : G === 1 && "y%" in b ? b["%"] = s["y%"] : b["%"] = s["o%"], convertUnitSize(j, b);
      }), f = y[0], m = y[1], C = m === void 0 ? 0 : m, w = y[2], S = w === void 0 ? 0 : w;
      A = translate3d, g = [f, C, S];
    } else if (p === "translateY") {
      var $ = isObject$1(s) ? __assign$5({ "%": s["y%"] }, s) : {
        "%": s
      }, C = convertUnitSize(v, $);
      A = translate3d, g = [0, C, 0];
    } else if (p === "translateZ") {
      var S = parseFloat(v);
      A = translate3d, g = [0, 0, S];
    } else if (p === "scale" || p === "scale3d") {
      var T = splitComma(v).map(function(j) {
        return parseFloat(j);
      }), I = T[0], _ = T[1], E = _ === void 0 ? I : _, R = T[2], O = R === void 0 ? 1 : R;
      A = scale3d, g = [I, E, O];
    } else if (p === "scaleX") {
      var I = parseFloat(v);
      A = scale3d, g = [I, 1, 1];
    } else if (p === "scaleY") {
      var E = parseFloat(v);
      A = scale3d, g = [1, E, 1];
    } else if (p === "scaleZ") {
      var O = parseFloat(v);
      A = scale3d, g = [1, 1, O];
    } else if (p === "rotate" || p === "rotateZ" || p === "rotateX" || p === "rotateY") {
      var L = splitUnit(v), B = L.unit, F = L.value, M = B === "rad" ? F : F * Math.PI / 180;
      p === "rotate" || p === "rotateZ" ? (x = "rotateZ", A = rotateZ3d) : p === "rotateX" ? A = rotateX3d : p === "rotateY" && (A = rotateY3d), g = M;
    } else if (p === "matrix3d")
      A = matrix3d, g = splitComma(v).map(function(j) {
        return parseFloat(j);
      });
    else if (p === "matrix") {
      var W = splitComma(v).map(function(j) {
        return parseFloat(j);
      });
      A = matrix3d, g = [
        W[0],
        W[1],
        0,
        0,
        W[2],
        W[3],
        0,
        0,
        0,
        0,
        1,
        0,
        W[4],
        W[5],
        0,
        1
      ];
    } else
      x = "";
    return {
      name: p,
      functionName: x,
      value: v,
      matrixFunction: A,
      functionValue: g
    };
  });
}
function hash(a) {
  for (var s = 5381, c = a.length; c; )
    s = s * 33 ^ a.charCodeAt(--c);
  return s >>> 0;
}
var stringHash = hash;
function getHash(a) {
  return stringHash(a).toString(36);
}
function getShadowRoot$1(a) {
  if (a && a.getRootNode) {
    var s = a.getRootNode();
    if (s.nodeType === 11)
      return s;
  }
}
function replaceStyle(a, s, c) {
  return c.original ? s : s.replace(/([^};{\s}][^};{]*|^\s*){/mg, function(u, d) {
    var p = d.trim();
    return (p ? splitComma(p) : [""]).map(function(v) {
      var A = v.trim();
      return A.indexOf("@") === 0 ? A : A.indexOf(":global") > -1 ? A.replace(/\:global/g, "") : A.indexOf(":host") > -1 ? "".concat(A.replace(/\:host/g, ".".concat(a))) : A ? ".".concat(a, " ").concat(A) : ".".concat(a);
    }).join(", ") + " {";
  });
}
function injectStyle(a, s, c, u, d) {
  var p = getDocument(u), v = p.createElement("style");
  return v.setAttribute("type", "text/css"), v.setAttribute("data-styled-id", a), v.setAttribute("data-styled-count", "1"), c.nonce && v.setAttribute("nonce", c.nonce), v.innerHTML = replaceStyle(a, s, c), (d || p.head || p.body).appendChild(v), v;
}
function styled$1(a) {
  var s = "rCS" + getHash(a);
  return {
    className: s,
    inject: function(c, u) {
      u === void 0 && (u = {});
      var d = getShadowRoot$1(c), p = (d || c.ownerDocument || document).querySelector('style[data-styled-id="'.concat(s, '"]'));
      if (!p)
        p = injectStyle(s, a, u, c, d);
      else {
        var v = parseFloat(p.getAttribute("data-styled-count")) || 0;
        p.setAttribute("data-styled-count", "".concat(v + 1));
      }
      return {
        destroy: function() {
          var A, x = parseFloat(p.getAttribute("data-styled-count")) || 0;
          x <= 1 ? (p.remove ? p.remove() : (A = p.parentNode) === null || A === void 0 || A.removeChild(p), p = null) : p.setAttribute("data-styled-count", "".concat(x - 1));
        }
      };
    }
  };
}
var extendStatics$4 = function(a, s) {
  return extendStatics$4 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
  }, extendStatics$4(a, s);
};
function __extends$4(a, s) {
  if (typeof s != "function" && s !== null) throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$4(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
var __assign$4 = function() {
  return __assign$4 = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign$4.apply(this, arguments);
};
function __rest$2(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
}
function __decorate$2(a, s, c, u) {
  var d = arguments.length, p = d < 3 ? s : u === null ? u = Object.getOwnPropertyDescriptor(s, c) : u, v;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") p = Reflect.decorate(a, s, c, u);
  else for (var A = a.length - 1; A >= 0; A--) (v = a[A]) && (p = (d < 3 ? v(p) : d > 3 ? v(s, c, p) : v(s, c)) || p);
  return d > 3 && p && Object.defineProperty(s, c, p), p;
}
function __spreadArray$2(a, s, c) {
  for (var u = 0, d = s.length, p; u < d; u++)
    (p || !(u in s)) && (p || (p = Array.prototype.slice.call(s, 0, u)), p[u] = s[u]);
  return a.concat(p || Array.prototype.slice.call(s));
}
function getClient(a) {
  if ("touches" in a) {
    var s = a.touches[0] || a.changedTouches[0];
    return {
      clientX: s.clientX,
      clientY: s.clientY
    };
  } else
    return {
      clientX: a.clientX,
      clientY: a.clientY
    };
}
function filterDuplicated(a) {
  if (typeof Map > "u")
    return a.filter(function(c, u) {
      return a.indexOf(c) === u;
    });
  var s = /* @__PURE__ */ new Map();
  return a.filter(function(c) {
    return s.has(c) ? !1 : (s.set(c, !0), !0);
  });
}
function elementFromPoint(a, s, c) {
  var u = getDocument(a);
  return u.elementFromPoint && u.elementFromPoint(s, c) || null;
}
function createElement(a, s, c) {
  var u = a.tag, d = a.children, p = a.attributes, v = a.className, A = a.style, x = s || getDocument(c).createElement(u);
  for (var g in p)
    x.setAttribute(g, p[g]);
  var b = x.children;
  if (d.forEach(function(f, m) {
    createElement(f, b[m], x);
  }), v && v.split(/\s+/g).forEach(function(f) {
    f && !hasClass(x, f) && addClass(x, f);
  }), A) {
    var y = x.style;
    for (var g in A)
      y[g] = A[g];
  }
  return !s && c && c.appendChild(x), x;
}
function h(a, s) {
  for (var c = [], u = 2; u < arguments.length; u++)
    c[u - 2] = arguments[u];
  var d = s || {}, p = d.className, v = p === void 0 ? "" : p, A = d.style, x = A === void 0 ? {} : A, g = __rest$2(d, ["className", "style"]);
  return {
    tag: a,
    className: v,
    style: x,
    attributes: g,
    children: c
  };
}
function diffValue(a, s, c) {
  a !== s && c(a, s);
}
function getRect$1(a, s, c) {
  var u;
  c === void 0 && (c = a.data.boundArea);
  var d = a.distX, p = d === void 0 ? 0 : d, v = a.distY, A = v === void 0 ? 0 : v, x = a.data, g = x.startX, b = x.startY;
  if (s > 0) {
    var y = Math.sqrt((p * p + A * A) / (1 + s * s)), f = s * y;
    p = (p >= 0 ? 1 : -1) * f, A = (A >= 0 ? 1 : -1) * y;
  }
  var m = Math.abs(p), C = Math.abs(A), w = p < 0 ? g - c.left : c.right - g, S = A < 0 ? b - c.top : c.bottom - b;
  u = calculateBoundSize([m, C], [0, 0], [w, S], !!s), m = u[0], C = u[1], p = (p >= 0 ? 1 : -1) * m, A = (A >= 0 ? 1 : -1) * C;
  var $ = Math.min(0, p), T = Math.min(0, A), I = g + $, _ = b + T;
  return {
    left: I,
    top: _,
    right: I + m,
    bottom: _ + C,
    width: m,
    height: C
  };
}
function getDefaultElementRect(a) {
  var s = a.getBoundingClientRect(), c = s.left, u = s.top, d = s.width, p = s.height;
  return {
    pos1: [c, u],
    pos2: [c + d, u],
    pos3: [c, u + p],
    pos4: [c + d, u + p]
  };
}
function passTargets(a, s, c) {
  var u = diff(a, s), d = u.list, p = u.prevList, v = u.added, A = u.removed, x = u.maintained;
  return __spreadArray$2(__spreadArray$2(__spreadArray$2([], v.map(function(g) {
    return d[g];
  }), !0), A.map(function(g) {
    return p[g];
  }), !0), c ? x.map(function(g) {
    var b = g[1];
    return d[b];
  }) : []);
}
function getLineSize(a) {
  for (var s = 0, c = a.length, u = 1; u < c; ++u)
    s = Math.max(getDist$2(a[u], a[u - 1]), s);
  return s;
}
var injector = styled$1(`
:host {
    position: fixed;
    display: none;
    border: 1px solid #4af;
    background: rgba(68, 170, 255, 0.5);
    pointer-events: none;
    will-change: transform;
    z-index: 100;
}
`), CLASS_NAME = "selecto-selection ".concat(injector.className), PROPERTIES$1 = ["className", "boundContainer", "selectableTargets", "selectByClick", "selectFromInside", "continueSelect", "continueSelectWithoutDeselect", "toggleContinueSelect", "toggleContinueSelectWithoutDeselect", "keyContainer", "hitRate", "scrollOptions", "checkInput", "preventDefault", "ratio", "getElementRect", "preventDragFromInside", "rootContainer", "dragCondition", "clickBySelectEnd", "checkOverflow", "innerScrollOptions"], OPTIONS = __spreadArray$2([
  // ignore target, container,
  "dragContainer",
  "cspNonce",
  "preventClickEventOnDrag",
  "preventClickEventOnDragStart",
  "preventRightClick"
], PROPERTIES$1), EVENTS = ["dragStart", "drag", "dragEnd", "selectStart", "select", "selectEnd", "keydown", "keyup", "scroll", "innerScroll"], METHODS = ["clickTarget", "getSelectableElements", "setSelectedTargets", "getElementPoints", "getSelectedTargets", "findSelectableTargets", "triggerDragStart", "checkScroll", "selectTargetsByPoints", "setSelectedTargetsByPoints"], Selecto$2 = /* @__PURE__ */ function(a) {
  __extends$4(s, a);
  function s(u) {
    u === void 0 && (u = {});
    var d = a.call(this) || this;
    d.selectedTargets = [], d.dragScroll = new DragScroll(), d._onDragStart = function(A, x) {
      var g = A.data, b = A.clientX, y = A.clientY, f = A.inputEvent, m = d.options, C = m.selectFromInside, w = m.selectByClick, S = m.rootContainer, $ = m.boundContainer, T = m.preventDragFromInside, I = T === void 0 ? !0 : T, _ = m.clickBySelectEnd, E = m.dragCondition;
      if (E && !E(A)) {
        A.stop();
        return;
      }
      g.data = {};
      var R = getWindow(d.container);
      g.innerWidth = R.innerWidth, g.innerHeight = R.innerHeight, d.findSelectableTargets(g), g.startSelectedTargets = d.selectedTargets, g.scaleMatrix = createMatrix(), g.containerX = 0, g.containerY = 0;
      var O = d.container, L = {
        left: -1 / 0,
        top: -1 / 0,
        right: 1 / 0,
        bottom: 1 / 0
      };
      if (S) {
        var B = d.container.getBoundingClientRect();
        g.containerX = B.left, g.containerY = B.top, g.scaleMatrix = getDistElementMatrix(d.container, S);
      }
      if ($) {
        var F = isObject$1($) && "element" in $ ? __assign$4({
          left: !0,
          top: !0,
          bottom: !0,
          right: !0
        }, $) : {
          element: $,
          left: !0,
          top: !0,
          bottom: !0,
          right: !0
        }, M = F.element, W = void 0;
        if (M) {
          isString(M) ? W = getDocument(O).querySelector(M) : M === !0 ? W = d.container : W = M;
          var j = W.getBoundingClientRect();
          F.left && (L.left = j.left), F.top && (L.top = j.top), F.right && (L.right = j.right), F.bottom && (L.bottom = j.bottom);
        }
      }
      g.boundArea = L;
      var G = {
        left: b,
        top: y,
        right: b,
        bottom: y,
        width: 0,
        height: 0
      }, U = [], k = w && !_, N = !1;
      if (!C || k) {
        var P = d._findElement(
          x || f.target,
          // elementFromPoint(clientX, clientY),
          g.selectableTargets
        );
        N = !!P, k && (U = P ? [P] : []);
      }
      var D = !C && N;
      if (D && !w)
        return A.stop(), !1;
      var H = f.type, V = H === "mousedown" || H === "touchstart", Z = !A.isClick && V ? d.emit("dragStart", __assign$4(__assign$4({}, A), {
        data: g.data
      })) : !0;
      if (!Z)
        return A.stop(), !1;
      if (d.continueSelect ? (U = passTargets(d.selectedTargets, U, d.continueSelectWithoutDeselect), g.startPassedTargets = d.selectedTargets) : g.startPassedTargets = [], d._select(U, G, A, !0, D && w && !_ && I), g.startX = b, g.startY = y, g.selectFlag = !1, g.preventDragFromInside = !1, f.target) {
        var ne = calculateMatrixDist(g.scaleMatrix, [b - g.containerX, y - g.containerY]);
        d.target.style.cssText += "position: ".concat(S ? "absolute" : "fixed", ";") + "left:0px;top:0px;" + "transform: translate(".concat(ne[0], "px, ").concat(ne[1], "px)");
      }
      if (D && w && !_)
        f.preventDefault(), I && (d._selectEnd(g.startSelectedTargets, g.startPassedTargets, G, A, !0), g.preventDragFromInside = !0);
      else {
        g.selectFlag = !0;
        var K = d.options, q = K.scrollOptions, Y = K.innerScrollOptions, ee = !1;
        if (Y) {
          for (var Q = A.inputEvent, J = Q.target, te = null, ae = J; ae && ae !== getDocument(O).body; ) {
            var se = getComputedStyle(ae).overflow !== "visible";
            if (se) {
              te = ae;
              break;
            }
            ae = ae.parentElement;
          }
          te && (g.innerScrollOptions = __assign$4({
            container: te,
            checkScrollEvent: !0
          }, Y === !0 ? {} : Y), d.dragScroll.dragStart(A, g.innerScrollOptions), ee = !0);
        }
        !ee && q && q.container && d.dragScroll.dragStart(A, q), D && w && _ && (g.selectFlag = !1, A.preventDrag());
      }
      return !0;
    }, d._onDrag = function(A) {
      if (A.data.selectFlag) {
        var x = d.scrollOptions, g = A.data.innerScrollOptions, b = g || x?.container;
        if (b && !A.isScroll && d.dragScroll.drag(A, g || x))
          return;
      }
      d._checkSelected(A);
    }, d._onDragEnd = function(A) {
      var x = A.data, g = A.inputEvent, b = getRect$1(A, d.options.ratio), y = x.selectFlag, f = d.container;
      if (g && d.emit("dragEnd", __assign$4(__assign$4({
        isDouble: !!A.isDouble,
        isClick: !!A.isClick,
        isDrag: !1,
        isSelect: y
      }, A), {
        data: x.data,
        rect: b
      })), d.target.style.cssText += "display: none;", y)
        x.selectFlag = !1, d.dragScroll.dragEnd();
      else if (d.selectByClick && d.clickBySelectEnd) {
        var m = d._findElement(g?.target || elementFromPoint(f, A.clientX, A.clientY), x.selectableTargets);
        d._select(m ? [m] : [], b, A);
      }
      x.preventDragFromInside || d._selectEnd(x.startSelectedTargets, x.startPassedTargets, b, A);
    }, d._onKeyDown = function(A) {
      var x = d.options, g = !1;
      if (!d._keydownContinueSelect) {
        var b = d._sameCombiKey(A, x.toggleContinueSelect);
        d._keydownContinueSelect = b, g || (g = b);
      }
      if (!d._keydownContinueSelectWithoutDeselection) {
        var b = d._sameCombiKey(A, x.toggleContinueSelectWithoutDeselect);
        d._keydownContinueSelectWithoutDeselection = b, g || (g = b);
      }
      g && d.emit("keydown", {
        keydownContinueSelect: d._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: d._keydownContinueSelectWithoutDeselection
      });
    }, d._onKeyUp = function(A) {
      var x = d.options, g = !1;
      if (d._keydownContinueSelect) {
        var b = d._sameCombiKey(A, x.toggleContinueSelect, !0);
        d._keydownContinueSelect = !b, g || (g = b);
      }
      if (d._keydownContinueSelectWithoutDeselection) {
        var b = d._sameCombiKey(A, x.toggleContinueSelectWithoutDeselect, !0);
        d._keydownContinueSelectWithoutDeselection = !b, g || (g = b);
      }
      g && d.emit("keyup", {
        keydownContinueSelect: d._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: d._keydownContinueSelectWithoutDeselection
      });
    }, d._onBlur = function() {
      (d._keydownContinueSelect || d._keydownContinueSelectWithoutDeselection) && (d._keydownContinueSelect = !1, d._keydownContinueSelectWithoutDeselection = !1, d.emit("keyup", {
        keydownContinueSelect: d._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: d._keydownContinueSelectWithoutDeselection
      }));
    }, d._onDocumentSelectStart = function(A) {
      var x = getDocument(d.container);
      if (d.gesto.isFlag()) {
        var g = d.dragContainer;
        g === getWindow(d.container) && (g = x.documentElement);
        var b = isNode(g) ? [g] : [].slice.call(g), y = A.target;
        b.some(function(f) {
          if (f === y || f.contains(y))
            return A.preventDefault(), !0;
        });
      }
    }, d.target = u.portalContainer;
    var p = u.container;
    d.options = __assign$4({
      className: "",
      portalContainer: null,
      container: null,
      dragContainer: null,
      selectableTargets: [],
      selectByClick: !0,
      selectFromInside: !0,
      clickBySelectEnd: !1,
      hitRate: 100,
      continueSelect: !1,
      continueSelectWithoutDeselect: !1,
      toggleContinueSelect: null,
      toggleContinueSelectWithoutDeselect: null,
      keyContainer: null,
      scrollOptions: null,
      checkInput: !1,
      preventDefault: !1,
      boundContainer: !1,
      preventDragFromInside: !0,
      dragCondition: null,
      rootContainer: null,
      checkOverflow: !1,
      innerScrollOptions: !1,
      getElementRect: getDefaultElementRect,
      cspNonce: "",
      ratio: 0
    }, u);
    var v = d.options.portalContainer;
    return v && (p = v.parentElement), d.container = p || document.body, d.initElement(), d.initDragScroll(), d.setKeyController(), d;
  }
  var c = s.prototype;
  return c.setSelectedTargets = function(u) {
    var d = this.selectedTargets, p = diff(d, u), v = p.added, A = p.removed, x = p.prevList, g = p.list;
    return this.selectedTargets = u, {
      added: v.map(function(b) {
        return g[b];
      }),
      removed: A.map(function(b) {
        return x[b];
      }),
      beforeSelected: d,
      selected: u
    };
  }, c.setSelectedTargetsByPoints = function(u, d) {
    var p = Math.min(u[0], d[0]), v = Math.min(u[1], d[1]), A = Math.max(u[0], d[0]), x = Math.max(u[1], d[1]), g = {
      left: p,
      top: v,
      right: A,
      bottom: x,
      width: A - p,
      height: x - v
    }, b = {
      ignoreClick: !0
    };
    this.findSelectableTargets(b);
    var y = this.hitTest(g, b, !0, null), f = this.setSelectedTargets(y);
    return __assign$4(__assign$4({}, f), {
      rect: g
    });
  }, c.selectTargetsByPoints = function(u, d) {
    var p = new MouseEvent("mousedown", {
      clientX: u[0],
      clientY: u[1],
      cancelable: !0,
      bubbles: !0
    }), v = new MouseEvent("mousemove", {
      clientX: d[0],
      clientY: d[1],
      cancelable: !0,
      bubbles: !0
    }), A = new MouseEvent("mousemove", {
      clientX: d[0],
      clientY: d[1],
      cancelable: !0,
      bubbles: !0
    }), x = this.gesto, g = x.onDragStart(p);
    g !== !1 && (x.onDrag(v), x.onDragEnd(A));
  }, c.getSelectedTargets = function() {
    return this.selectedTargets;
  }, c.triggerDragStart = function(u) {
    return this.gesto.triggerDragStart(u), this;
  }, c.destroy = function() {
    var u;
    this.off(), this.keycon && this.keycon.destroy(), this.gesto.unset(), this.injectResult.destroy(), this.dragScroll.dragEnd(), removeEvent(document, "selectstart", this._onDocumentSelectStart), this.options.portalContainer || (u = this.target.parentElement) === null || u === void 0 || u.removeChild(this.target), this.keycon = null, this.gesto = null, this.injectResult = null, this.target = null, this.container = null, this.options = null;
  }, c.getElementPoints = function(u) {
    var d = this.getElementRect || getDefaultElementRect, p = d(u), v = [p.pos1, p.pos2, p.pos4, p.pos3];
    if (d !== getDefaultElementRect) {
      var A = u.getBoundingClientRect();
      return fitPoints(v, A);
    }
    return v;
  }, c.getSelectableElements = function() {
    var u = this.container, d = [];
    return this.options.selectableTargets.forEach(function(p) {
      if (isFunction(p)) {
        var v = p();
        v && d.push.apply(d, [].slice.call(v));
      } else if (isNode(p))
        d.push(p);
      else if (isObject$1(p))
        d.push(p.value || p.current);
      else {
        var A = [].slice.call(getDocument(u).querySelectorAll(p));
        d.push.apply(d, A);
      }
    }), d;
  }, c.checkScroll = function() {
    if (this.gesto.isFlag()) {
      var u = this.scrollOptions, d = this.gesto.getEventData().innerScrollOptions, p = d || u?.container;
      p && this.dragScroll.checkScroll(__assign$4({
        inputEvent: this.gesto.getCurrentEvent()
      }, d || u));
    }
  }, c.findSelectableTargets = function(u) {
    var d = this;
    u === void 0 && (u = this.gesto.getEventData());
    var p = this.getSelectableElements(), v = p.map(function(y) {
      return d.getElementPoints(y);
    });
    u.selectableTargets = p, u.selectablePoints = v, u.selectableParentMap = null;
    var A = this.options, x = A.checkOverflow || A.innerScrollOptions, g = getDocument(this.container);
    if (x) {
      var b = /* @__PURE__ */ new Map();
      u.selectableInnerScrollParentMap = b, u.selectableInnerScrollPathsList = p.map(function(y, f) {
        for (var m = y.parentElement, C = [], w = [], S = function() {
          var $ = b.get(m);
          if (!$) {
            var T = getComputedStyle(m).overflow !== "visible";
            if (T) {
              var I = getDefaultElementRect(m);
              $ = {
                parentElement: m,
                indexes: [],
                points: [I.pos1, I.pos2, I.pos4, I.pos3],
                paths: __spreadArray$2([], w)
              }, C.push(m), C.forEach(function(_) {
                b.set(_, $);
              }), C = [];
            }
          }
          $ ? (m = $.parentElement, b.get(m).indexes.push(f), w.push(m)) : C.push(m), m = m.parentElement;
        }; m && m !== g.body; )
          S();
        return w;
      });
    }
    return A.checkOverflow || (u.selectableInners = p.map(function() {
      return !0;
    })), this._refreshGroups(u), p;
  }, c.clickTarget = function(u, d) {
    var p = getClient(u), v = p.clientX, A = p.clientY, x = {
      data: {
        selectFlag: !1
      },
      clientX: v,
      clientY: A,
      inputEvent: u,
      isClick: !0,
      isTrusted: !1,
      stop: function() {
        return !1;
      }
    };
    return this._onDragStart(x, d) && this._onDragEnd(x), this;
  }, c.setKeyController = function() {
    var u = this.options, d = u.keyContainer, p = u.toggleContinueSelect, v = u.toggleContinueSelectWithoutDeselect;
    this.keycon && (this.keycon.destroy(), this.keycon = null), (p || v) && (this.keycon = new KeyController(d || getWindow(this.container)), this.keycon.keydown(this._onKeyDown).keyup(this._onKeyUp).on("blur", this._onBlur));
  }, c.setClassName = function(u) {
    this.options.className = u, this.target.setAttribute("class", "".concat(CLASS_NAME, " ").concat(u || ""));
  }, c.setKeyEvent = function() {
    var u = this.options, d = u.toggleContinueSelect, p = u.toggleContinueSelectWithoutDeselect;
    !d && !p || this.keycon || this.setKeyController();
  }, c.setKeyContainer = function(u) {
    var d = this, p = this.options;
    diffValue(p.keyContainer, u, function() {
      p.keyContainer = u, d.setKeyController();
    });
  }, c.getContinueSelect = function() {
    var u = this.options, d = u.continueSelect, p = u.toggleContinueSelect;
    return !p || !this._keydownContinueSelect ? d : !d;
  }, c.getContinueSelectWithoutDeselect = function() {
    var u = this.options, d = u.continueSelectWithoutDeselect, p = u.toggleContinueSelectWithoutDeselect;
    return !p || !this._keydownContinueSelectWithoutDeselection ? d : !d;
  }, c.setToggleContinueSelect = function(u) {
    var d = this, p = this.options;
    diffValue(p.toggleContinueSelect, u, function() {
      p.toggleContinueSelect = u, d.setKeyEvent();
    });
  }, c.setToggleContinueSelectWithoutDeselect = function(u) {
    var d = this, p = this.options;
    diffValue(p.toggleContinueSelectWithoutDeselect, u, function() {
      p.toggleContinueSelectWithoutDeselect = u, d.setKeyEvent();
    });
  }, c.setPreventDefault = function(u) {
    this.gesto.options.preventDefault = u;
  }, c.setCheckInput = function(u) {
    this.gesto.options.checkInput = u;
  }, c.initElement = function() {
    var u = this.options, d = u.dragContainer, p = u.checkInput, v = u.preventDefault, A = u.preventClickEventOnDragStart, x = u.preventClickEventOnDrag, g = u.preventClickEventByCondition, b = u.preventRightClick, y = b === void 0 ? !0 : b, f = u.className, m = this.container;
    this.target = createElement(h("div", {
      className: "".concat(CLASS_NAME, " ").concat(f || "")
    }), this.target, m);
    var C = this.target;
    this.dragContainer = typeof d == "string" ? [].slice.call(getDocument(m).querySelectorAll(d)) : d || this.target.parentNode, this.gesto = new Gesto(this.dragContainer, {
      checkWindowBlur: !0,
      container: getWindow(m),
      checkInput: p,
      preventDefault: v,
      preventClickEventOnDragStart: A,
      preventClickEventOnDrag: x,
      preventClickEventByCondition: g,
      preventRightClick: y
    }).on({
      dragStart: this._onDragStart,
      drag: this._onDrag,
      dragEnd: this._onDragEnd
    }), addEvent(document, "selectstart", this._onDocumentSelectStart), this.injectResult = injector.inject(C, {
      nonce: this.options.cspNonce
    });
  }, c.hitTest = function(u, d, p, v) {
    var A = this.options, x = A.hitRate, g = A.selectByClick, b = u.left, y = u.top, f = u.right, m = u.bottom, C = d.innerGroups, w = d.innerWidth, S = d.innerHeight, $ = v?.clientX, T = v?.clientY, I = d.ignoreClick, _ = [[b, y], [f, y], [f, m], [b, m]], E = function(P, D) {
      var H = splitUnit(typeof x == "function" ? "".concat(x(D)) : "".concat(x)), V = I ? !1 : isInside([$, T], P);
      if (!p && g && V)
        return !0;
      var Z = getOverlapPoints(_, P);
      if (!Z.length)
        return !1;
      var ne = getAreaSize(Z), K = 0;
      if (ne === 0 && getAreaSize(P) === 0 ? (K = getLineSize(P), ne = getLineSize(Z)) : K = getAreaSize(P), H.unit === "px")
        return ne >= H.value;
      var q = between(Math.round(ne / K * 100), 0, 100);
      return q >= Math.min(100, H.value);
    }, R = d.selectableTargets, O = d.selectablePoints, L = d.selectableInners;
    if (!C)
      return R.filter(function(P, D) {
        return L[D] ? E(O[D], R[D]) : !1;
      });
    for (var B = [], F = Math.floor(b / w), M = Math.floor(f / w), W = Math.floor(y / S), j = Math.floor(m / S), G = F; G <= M; ++G) {
      var U = C[G];
      if (U)
        for (var k = W; k <= j; ++k) {
          var N = U[k];
          N && N.forEach(function(P) {
            var D = O[P], H = L[P], V = R[P];
            H && E(D, V) && B.push(V);
          });
        }
    }
    return filterDuplicated(B);
  }, c.initDragScroll = function() {
    var u = this;
    this.dragScroll.on("scrollDrag", function(d) {
      var p = d.next;
      p(u.gesto.getCurrentEvent());
    }).on("scroll", function(d) {
      var p = d.container, v = d.direction, A = u.gesto.getEventData().innerScrollOptions;
      A ? u.emit("innerScroll", {
        container: p,
        direction: v
      }) : u.emit("scroll", {
        container: p,
        direction: v
      });
    }).on("move", function(d) {
      var p = d.offsetX, v = d.offsetY, A = d.inputEvent, x = u.gesto;
      if (!(!x || !x.isFlag())) {
        var g = u.gesto.getEventData(), b = g.boundArea;
        g.startX -= p, g.startY -= v;
        var y = u.gesto.getEventData().innerScrollOptions, f = y?.container, m = !1;
        if (f) {
          var C = g.selectableInnerScrollParentMap, w = C.get(f);
          w && (w.paths.forEach(function(S) {
            var $ = C.get(S);
            $.points.forEach(function(T) {
              T[0] -= p, T[1] -= v;
            });
          }), w.indexes.forEach(function(S) {
            g.selectablePoints[S].forEach(function($) {
              $[0] -= p, $[1] -= v;
            });
          }), m = !0);
        }
        m || g.selectablePoints.forEach(function(S) {
          S.forEach(function($) {
            $[0] -= p, $[1] -= v;
          });
        }), u._refreshGroups(g), b.left -= p, b.right -= p, b.top -= v, b.bottom -= v, u.gesto.scrollBy(p, v, A.inputEvent), u._checkSelected(u.gesto.getCurrentEvent());
      }
    });
  }, c._select = function(u, d, p, v, A) {
    A === void 0 && (A = !1);
    var x = p.inputEvent, g = p.data, b = this.setSelectedTargets(u), y = diff(g.startSelectedTargets, u), f = y.added, m = y.removed, C = y.prevList, w = y.list, S = {
      startSelected: C,
      startAdded: f.map(function($) {
        return w[$];
      }),
      startRemoved: m.map(function($) {
        return C[$];
      })
    };
    v && this.emit("selectStart", __assign$4(__assign$4(__assign$4({}, b), S), {
      rect: d,
      inputEvent: x,
      data: g.data,
      isTrusted: p.isTrusted,
      isDragStartEnd: A
    })), (b.added.length || b.removed.length) && this.emit("select", __assign$4(__assign$4(__assign$4({}, b), S), {
      rect: d,
      inputEvent: x,
      data: g.data,
      isTrusted: p.isTrusted,
      isDragStartEnd: A
    }));
  }, c._selectEnd = function(u, d, p, v, A) {
    A === void 0 && (A = !1);
    var x = v.inputEvent, g = v.isDouble, b = v.data, y = x && x.type, f = y === "mousedown" || y === "touchstart", m = diff(u, this.selectedTargets), C = m.added, w = m.removed, S = m.prevList, $ = m.list, T = diff(d, this.selectedTargets), I = T.added, _ = T.removed, E = T.prevList, R = T.list;
    this.emit("selectEnd", {
      startSelected: u,
      beforeSelected: d,
      selected: this.selectedTargets,
      added: C.map(function(O) {
        return $[O];
      }),
      removed: w.map(function(O) {
        return S[O];
      }),
      afterAdded: I.map(function(O) {
        return R[O];
      }),
      afterRemoved: _.map(function(O) {
        return E[O];
      }),
      isDragStart: f && A,
      isDragStartEnd: f && A,
      isClick: !!v.isClick,
      isDouble: !!g,
      rect: p,
      inputEvent: x,
      data: b.data,
      isTrusted: v.isTrusted
    });
  }, c._checkSelected = function(u, d) {
    d === void 0 && (d = getRect$1(u, this.options.ratio));
    var p = u.data, v = d.top, A = d.left, x = d.width, g = d.height, b = p.selectFlag, y = p.containerX, f = p.containerY, m = p.scaleMatrix, C = calculateMatrixDist(m, [A - y, v - f]), w = calculateMatrixDist(m, [x, g]), S = [];
    if (b) {
      this.target.style.cssText += "display: block;left:0px;top:0px;" + "transform: translate(".concat(C[0], "px, ").concat(C[1], "px);") + "width:".concat(w[0], "px;height:").concat(w[1], "px;");
      var $ = this.hitTest(d, p, !0, u);
      S = passTargets(p.startPassedTargets, $, this.continueSelect && this.continueSelectWithoutDeselect);
    }
    var T = this.emit("drag", __assign$4(__assign$4({}, u), {
      data: p.data,
      isSelect: b,
      rect: d
    }));
    if (T === !1) {
      this.target.style.cssText += "display: none;", u.stop();
      return;
    }
    b && this._select(S, d, u);
  }, c._sameCombiKey = function(u, d, p) {
    if (!d)
      return !1;
    var v = getCombi(u.inputEvent, u.key), A = [].concat(d), x = isArray(A[0]) ? A : [A];
    if (p) {
      var g = u.key;
      return x.some(function(b) {
        return b.some(function(y) {
          return y === g;
        });
      });
    }
    return x.some(function(b) {
      return b.every(function(y) {
        return v.indexOf(y) > -1;
      });
    });
  }, c._findElement = function(u, d) {
    for (var p = u; p && !(d.indexOf(p) > -1); )
      p = p.parentElement;
    return p;
  }, c._refreshGroups = function(u) {
    var d, p = u.innerWidth, v = u.innerHeight, A = u.selectablePoints;
    if (this.options.checkOverflow) {
      var x = (d = this.gesto.getEventData().innerScrollOptions) === null || d === void 0 ? void 0 : d.container, g = u.selectableInnerScrollParentMap, b = u.selectableInnerScrollPathsList;
      u.selectableInners = b.map(function(m, C) {
        var w = !1;
        return m.every(function(S) {
          if (w)
            return !0;
          if (S === x)
            return w = !0, !0;
          var $ = g.get(S);
          if ($) {
            var T = A[C], I = $.points, _ = getOverlapPoints(T, I);
            if (!_.length)
              return !1;
          }
          return !0;
        });
      });
    }
    if (!p || !v)
      u.innerGroups = null;
    else {
      var y = u.selectablePoints, f = {};
      y.forEach(function(m, C) {
        var w = 1 / 0, S = -1 / 0, $ = 1 / 0, T = -1 / 0;
        m.forEach(function(E) {
          var R = Math.floor(E[0] / p), O = Math.floor(E[1] / v);
          w = Math.min(R, w), S = Math.max(R, S), $ = Math.min(O, $), T = Math.max(O, T);
        });
        for (var I = w; I <= S; ++I)
          for (var _ = $; _ <= T; ++_)
            f[I] = f[I] || {}, f[I][_] = f[I][_] || [], f[I][_].push(C);
      }), u.innerGroups = f;
    }
  }, s = __decorate$2([Properties(PROPERTIES$1, function(u, d) {
    var p = {
      enumerable: !0,
      configurable: !0,
      get: function() {
        return this.options[d];
      }
    }, v = camelize("get ".concat(d));
    u[v] ? p.get = function() {
      return this[v]();
    } : p.get = function() {
      return this.options[d];
    };
    var A = camelize("set ".concat(d));
    u[A] ? p.set = function(x) {
      this[A](x);
    } : p.set = function(x) {
      this.options[d] = x;
    }, Object.defineProperty(u, d, p);
  })], s), s;
}(EventEmitter), Selecto$1$1 = /* @__PURE__ */ function(a) {
  __extends$4(s, a);
  function s() {
    return a !== null && a.apply(this, arguments) || this;
  }
  return s;
}(Selecto$2), extendStatics$3 = function(a, s) {
  return extendStatics$3 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
  }, extendStatics$3(a, s);
};
function __extends$3(a, s) {
  if (typeof s != "function" && s !== null) throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$3(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
var __assign$3 = function() {
  return __assign$3 = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign$3.apply(this, arguments);
};
function __decorate$1(a, s, c, u) {
  var d = arguments.length, p = d < 3 ? s : u, v;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") p = Reflect.decorate(a, s, c, u);
  else for (var A = a.length - 1; A >= 0; A--) (v = a[A]) && (p = (d < 3 ? v(p) : d > 3 ? v(s, c, p) : v(s, c)) || p);
  return d > 3 && p && Object.defineProperty(s, c, p), p;
}
var REACT_EVENTS = EVENTS.map(function(a) {
  return camelize("on ".concat(a));
}), Selecto$1 = /* @__PURE__ */ function(a) {
  __extends$3(s, a);
  function s() {
    return a !== null && a.apply(this, arguments) || this;
  }
  var c = s.prototype;
  return c.render = function() {
    return reactExports.createElement("div", {
      className: CLASS_NAME,
      ref: ref(this, "selectionElement")
    });
  }, c.componentDidMount = function() {
    var u = this, d = this.props, p = {};
    OPTIONS.forEach(function(v) {
      v in d && (p[v] = d[v]);
    }), this.selecto = new Selecto$1$1(__assign$3(__assign$3({}, p), {
      portalContainer: this.selectionElement
    })), EVENTS.forEach(function(v, A) {
      u.selecto.on(v, function(x) {
        var g = u.props, b = g[REACT_EVENTS[A]] && g[REACT_EVENTS[A]](x);
        b === !1 && x.stop();
      });
    });
  }, c.componentDidUpdate = function(u) {
    var d = this.props, p = this.selecto;
    PROPERTIES$1.forEach(function(v) {
      u[v] !== d[v] && (p[v] = d[v]);
    });
  }, c.componentWillUnmount = function() {
    this.selecto.destroy();
  }, __decorate$1([withMethods(METHODS)], s.prototype, "selecto", void 0), s;
}(reactExports.PureComponent);
const className = "pdfme-selecto", Selecto = (a) => {
  const { token: s } = theme.useToken();
  return reactExports.useEffect(() => {
    const c = document.querySelector("." + className);
    c instanceof HTMLElement && (c.style.backgroundColor = s.colorPrimary, c.style.opacity = "0.75", c.style.borderColor = s.colorPrimaryBorder);
  }, [a.container, s.colorPrimary, s.colorPrimaryBorder]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Selecto$1,
    {
      className,
      selectFromInside: !1,
      selectByClick: !0,
      preventDefault: !0,
      hitRate: 0,
      selectableTargets: [`.${SELECTABLE_CLASSNAME}`],
      container: a.container,
      continueSelect: a.continueSelect,
      onDragStart: a.onDragStart,
      onSelect: a.onSelect
    }
  );
};
function some(a, s) {
  for (var c = a.length, u = 0; u < c; ++u)
    if (s(a[u], u))
      return !0;
  return !1;
}
function find(a, s) {
  for (var c = a.length, u = 0; u < c; ++u)
    if (s(a[u], u))
      return a[u];
  return null;
}
function getUserAgentString(a) {
  var s = a;
  if (typeof s > "u") {
    if (typeof navigator > "u" || !navigator)
      return "";
    s = navigator.userAgent || "";
  }
  return s.toLowerCase();
}
function execRegExp(a, s) {
  try {
    return new RegExp(a, "g").exec(s);
  } catch {
    return null;
  }
}
function hasUserAgentData() {
  if (typeof navigator > "u" || !navigator || !navigator.userAgentData)
    return !1;
  var a = navigator.userAgentData, s = a.brands || a.uaList;
  return !!(s && s.length);
}
function findVersion(a, s) {
  var c = execRegExp("(" + a + ")((?:\\/|\\s|:)([0-9|\\.|_]+))", s);
  return c ? c[3] : "";
}
function convertVersion(a) {
  return a.replace(/_/g, ".");
}
function findPreset(a, s) {
  var c = null, u = "-1";
  return some(a, function(d) {
    var p = execRegExp("(" + d.test + ")((?:\\/|\\s|:)([0-9|\\.|_]+))?", s);
    return !p || d.brand ? !1 : (c = d, u = p[3] || "-1", d.versionAlias ? u = d.versionAlias : d.versionTest && (u = findVersion(d.versionTest.toLowerCase(), s) || u), u = convertVersion(u), !0);
  }), {
    preset: c,
    version: u
  };
}
function findPresetBrand(a, s) {
  var c = {
    brand: "",
    version: "-1"
  };
  return some(a, function(u) {
    var d = findBrand(s, u);
    return d ? (c.brand = u.id, c.version = u.versionAlias || d.version, c.version !== "-1") : !1;
  }), c;
}
function findBrand(a, s) {
  return find(a, function(c) {
    var u = c.brand;
    return execRegExp("" + s.test, u.toLowerCase());
  });
}
var BROWSER_PRESETS = [{
  test: "phantomjs",
  id: "phantomjs"
}, {
  test: "whale",
  id: "whale"
}, {
  test: "edgios|edge|edg",
  id: "edge"
}, {
  test: "msie|trident|windows phone",
  id: "ie",
  versionTest: "iemobile|msie|rv"
}, {
  test: "miuibrowser",
  id: "miui browser"
}, {
  test: "samsungbrowser",
  id: "samsung internet"
}, {
  test: "samsung",
  id: "samsung internet",
  versionTest: "version"
}, {
  test: "chrome|crios",
  id: "chrome"
}, {
  test: "firefox|fxios",
  id: "firefox"
}, {
  test: "android",
  id: "android browser",
  versionTest: "version"
}, {
  test: "safari|iphone|ipad|ipod",
  id: "safari",
  versionTest: "version"
}], CHROMIUM_PRESETS = [{
  test: "(?=.*applewebkit/(53[0-7]|5[0-2]|[0-4]))(?=.*\\schrome)",
  id: "chrome",
  versionTest: "chrome"
}, {
  test: "chromium",
  id: "chrome"
}, {
  test: "whale",
  id: "chrome",
  versionAlias: "-1",
  brand: !0
}], WEBKIT_PRESETS = [{
  test: "applewebkit",
  id: "webkit",
  versionTest: "applewebkit|safari"
}], WEBVIEW_PRESETS = [{
  test: "(?=(iphone|ipad))(?!(.*version))",
  id: "webview"
}, {
  test: "(?=(android|iphone|ipad))(?=.*(naver|daum|; wv))",
  id: "webview"
}, {
  // test webview
  test: "webview",
  id: "webview"
}], OS_PRESETS = [{
  test: "windows phone",
  id: "windows phone"
}, {
  test: "windows 2000",
  id: "window",
  versionAlias: "5.0"
}, {
  test: "windows nt",
  id: "window"
}, {
  test: "win32|windows",
  id: "window"
}, {
  test: "iphone|ipad|ipod",
  id: "ios",
  versionTest: "iphone os|cpu os"
}, {
  test: "macos|macintel|mac os x",
  id: "mac"
}, {
  test: "android|linux armv81",
  id: "android"
}, {
  test: "tizen",
  id: "tizen"
}, {
  test: "webos|web0s",
  id: "webos"
}];
function isWebView(a) {
  return !!findPreset(WEBVIEW_PRESETS, a).preset;
}
function getLegacyAgent(a) {
  var s = getUserAgentString(a), c = !!/mobi/g.exec(s), u = {
    name: "unknown",
    version: "-1",
    majorVersion: -1,
    webview: isWebView(s),
    chromium: !1,
    chromiumVersion: "-1",
    webkit: !1,
    webkitVersion: "-1"
  }, d = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  }, p = findPreset(BROWSER_PRESETS, s), v = p.preset, A = p.version, x = findPreset(OS_PRESETS, s), g = x.preset, b = x.version, y = findPreset(CHROMIUM_PRESETS, s);
  if (u.chromium = !!y.preset, u.chromiumVersion = y.version, !u.chromium) {
    var f = findPreset(WEBKIT_PRESETS, s);
    u.webkit = !!f.preset, u.webkitVersion = f.version;
  }
  return g && (d.name = g.id, d.version = b, d.majorVersion = parseInt(b, 10)), v && (u.name = v.id, u.version = A, u.webview && d.name === "ios" && u.name !== "safari" && (u.webview = !1)), u.majorVersion = parseInt(u.version, 10), {
    browser: u,
    os: d,
    isMobile: c,
    isHints: !1
  };
}
function getClientHintsAgent(a) {
  var s = navigator.userAgentData, c = (s.uaList || s.brands).slice(), u = s.mobile || !1, d = c[0], p = (s.platform || navigator.platform).toLowerCase(), v = {
    name: d.brand,
    version: d.version,
    majorVersion: -1,
    webkit: !1,
    webkitVersion: "-1",
    chromium: !1,
    chromiumVersion: "-1",
    webview: !!findPresetBrand(WEBVIEW_PRESETS, c).brand || isWebView(getUserAgentString())
  }, A = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  };
  v.webkit = !v.chromium && some(WEBKIT_PRESETS, function(f) {
    return findBrand(c, f);
  });
  var x = findPresetBrand(CHROMIUM_PRESETS, c);
  if (v.chromium = !!x.brand, v.chromiumVersion = x.version || "-1", !v.chromium) {
    var g = findPresetBrand(WEBKIT_PRESETS, c);
    v.webkit = !!g.brand, v.webkitVersion = g.version || "-1";
  }
  var b = find(OS_PRESETS, function(f) {
    return new RegExp("" + f.test, "g").exec(p);
  });
  A.name = b ? b.id : "";
  {
    var y = findPresetBrand(BROWSER_PRESETS, c);
    v.name = y.brand || v.name, v.version = y.brand && a ? a.uaFullVersion : y.version;
  }
  return v.webkit && (A.name = u ? "ios" : "mac"), A.name === "ios" && v.webview && (v.version = "-1"), A.version = convertVersion(A.version), v.version = convertVersion(v.version), A.majorVersion = parseInt(A.version, 10), v.majorVersion = parseInt(v.version, 10), {
    browser: v,
    os: A,
    isMobile: u,
    isHints: !0
  };
}
function agent$1(a) {
  return hasUserAgentData() ? getClientHintsAgent() : getLegacyAgent(a);
}
var __assign$2 = function() {
  return __assign$2 = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign$2.apply(this, arguments);
};
function __rest$1(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function") for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
    s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
}
function styled(a, s) {
  var c = styled$1(s), u = c.className;
  return reactExports.forwardRef(function(d, p) {
    var v = d.className, A = v === void 0 ? "" : v;
    d.cspNonce;
    var x = __rest$1(d, ["className", "cspNonce"]), g = reactExports.useRef();
    return reactExports.useImperativeHandle(p, function() {
      return g.current;
    }, []), reactExports.useEffect(function() {
      var b = c.inject(g.current, {
        nonce: d.cspNonce
      });
      return function() {
        b.destroy();
      };
    }, []), reactExports.createElement(a, __assign$2({
      ref: g,
      "data-styled-id": u,
      className: "".concat(A, " ").concat(u)
    }, x));
  });
}
var extendStatics$2 = function(a, s) {
  return extendStatics$2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
  }, extendStatics$2(a, s);
};
function __extends$2(a, s) {
  if (typeof s != "function" && s !== null)
    throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$2(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign$1.apply(this, arguments);
};
function __rest(a, s) {
  var c = {};
  for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && s.indexOf(u) < 0 && (c[u] = a[u]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var d = 0, u = Object.getOwnPropertySymbols(a); d < u.length; d++)
      s.indexOf(u[d]) < 0 && Object.prototype.propertyIsEnumerable.call(a, u[d]) && (c[u[d]] = a[u[d]]);
  return c;
}
function __decorate(a, s, c, u) {
  var d = arguments.length, p = d < 3 ? s : u, v;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") p = Reflect.decorate(a, s, c, u);
  else for (var A = a.length - 1; A >= 0; A--) (v = a[A]) && (p = (d < 3 ? v(p) : d > 3 ? v(s, c, p) : v(s, c)) || p);
  return d > 3 && p && Object.defineProperty(s, c, p), p;
}
function __values(a) {
  var s = typeof Symbol == "function" && Symbol.iterator, c = s && a[s], u = 0;
  if (c) return c.call(a);
  if (a && typeof a.length == "number") return {
    next: function() {
      return a && u >= a.length && (a = void 0), { value: a && a[u++], done: !a };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(a, s) {
  var c = typeof Symbol == "function" && a[Symbol.iterator];
  if (!c) return a;
  var u = c.call(a), d, p = [], v;
  try {
    for (; (s === void 0 || s-- > 0) && !(d = u.next()).done; ) p.push(d.value);
  } catch (A) {
    v = { error: A };
  } finally {
    try {
      d && !d.done && (c = u.return) && c.call(u);
    } finally {
      if (v) throw v.error;
    }
  }
  return p;
}
function __spreadArray$1(a, s, c) {
  if (arguments.length === 2) for (var u = 0, d = s.length, p; u < d; u++)
    (p || !(u in s)) && (p || (p = Array.prototype.slice.call(s, 0, u)), p[u] = s[u]);
  return a.concat(p || Array.prototype.slice.call(s));
}
function makeAble(a, s) {
  return __assign$1({ events: [], props: [], name: a }, s);
}
var DIRECTIONS4 = ["n", "w", "s", "e"], DIRECTIONS = ["n", "w", "s", "e", "nw", "ne", "sw", "se"];
function getSVGCursor(a, s) {
  return 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="'.concat(32 * a, 'px" height="').concat(32 * a, 'px" viewBox="0 0 32 32" ><path d="M 16,5 L 12,10 L 14.5,10 L 14.5,22 L 12,22 L 16,27 L 20,22 L 17.5,22 L 17.5,10 L 20, 10 L 16,5 Z" stroke-linejoin="round" stroke-width="1.2" fill="black" stroke="white" style="transform:rotate(').concat(s, 'deg);transform-origin: 16px 16px"></path></svg>');
}
function getCursorCSS(a) {
  var s = getSVGCursor(1, a), c = Math.round(a / 45) * 45 % 180, u = "ns-resize";
  return c === 135 ? u = "nwse-resize" : c === 45 ? u = "nesw-resize" : c === 90 && (u = "ew-resize"), "cursor:".concat(u, ";cursor: url('").concat(s, "') 16 16, ").concat(u, ";");
}
var agent = agent$1(), IS_WEBKIT = agent.browser.webkit, IS_WEBKIT605 = IS_WEBKIT && function() {
  var a = typeof window > "u" ? { userAgent: "" } : window.navigator, s = /applewebkit\/([^\s]+)/g.exec(a.userAgent.toLowerCase());
  return s ? parseFloat(s[1]) < 605 : !1;
}(), browserName = agent.browser.name, browserVersion = parseInt(agent.browser.version, 10), IS_CHROME = browserName === "chrome", IS_CHROMIUM = agent.browser.chromium, chromiumVersion = parseInt(agent.browser.chromiumVersion, 10) || 0, IS_CHROMIUM109 = IS_CHROME && browserVersion >= 109 || IS_CHROMIUM && chromiumVersion >= 109, IS_FIREFOX = browserName === "firefox", IS_SAFARI_ABOVE15 = parseInt(agent.browser.webkitVersion, 10) >= 612 || browserVersion >= 15, PREFIX = "moveable-", directionCSS = DIRECTIONS.map(function(a) {
  var s = "", c = "", u = "center", d = "center", p = "calc(var(--moveable-control-padding, 20) * -1px)";
  return a.indexOf("n") > -1 && (s = "top: ".concat(p, ";"), d = "bottom"), a.indexOf("s") > -1 && (s = "top: 0px;", d = "top"), a.indexOf("w") > -1 && (c = "left: ".concat(p, ";"), u = "right"), a.indexOf("e") > -1 && (c = "left: 0px;", u = "left"), '.around-control[data-direction*="'.concat(a, `"] {
        `).concat(c).concat(s, `
        transform-origin: `).concat(u, " ").concat(d, `;
    }`);
}).join(`
`), MOVEABLE_CSS = `
{
position: absolute;
width: 1px;
height: 1px;
left: 0;
top: 0;
z-index: 3000;
--moveable-color: #4af;
--zoom: 1;
--zoompx: 1px;
--moveable-line-padding: 0;
--moveable-control-padding: 0;
will-change: transform;
outline: 1px solid transparent;
}
.control-box {
z-index: 0;
}
.line, .control {
position: absolute;
left: 0;
top: 0;
will-change: transform;
}
.control {
width: 14px;
height: 14px;
border-radius: 50%;
border: 2px solid #fff;
box-sizing: border-box;
background: #4af;
background: var(--moveable-color);
margin-top: -7px;
margin-left: -7px;
border: 2px solid #fff;
z-index: 10;
}
.around-control {
position: absolute;
will-change: transform;
width: calc(var(--moveable-control-padding, 20) * 1px);
height: calc(var(--moveable-control-padding, 20) * 1px);
left: calc(var(--moveable-control-padding, 20) * -0.5px);
top: calc(var(--moveable-control-padding, 20) * -0.5px);
box-sizing: border-box;
background: transparent;
z-index: 8;
cursor: alias;
transform-origin: center center;
}
`.concat(directionCSS, `
.padding {
position: absolute;
top: 0px;
left: 0px;
width: 100px;
height: 100px;
transform-origin: 0 0;
}
.line {
width: 1px;
height: 1px;
background: #4af;
background: var(--moveable-color);
transform-origin: 0px 50%;
}
.line.edge {
z-index: 1;
background: transparent;
}
.line.dashed {
box-sizing: border-box;
background: transparent;
}
.line.dashed.horizontal {
border-top: 1px dashed #4af;
border-top-color: #4af;
border-top-color: var(--moveable-color);
}
.line.dashed.vertical {
border-left: 1px dashed #4af;
border-left-color: #4af;
border-left-color: var(--moveable-color);
}
.line.vertical {
transform: translateX(-50%);
}
.line.horizontal {
transform: translateY(-50%);
}
.line.vertical.bold {
width: 2px;
}
.line.horizontal.bold {
height: 2px;
}

.control.origin {
border-color: #f55;
background: #fff;
width: 12px;
height: 12px;
margin-top: -6px;
margin-left: -6px;
pointer-events: none;
}
`).concat([0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165].map(function(a) {
  return `
.direction[data-rotation="`.concat(a, '"], :global .view-control-rotation').concat(a, ` {
`).concat(getCursorCSS(a), `
}
`);
}).join(`
`), `

.line.direction:before {
content: "";
position: absolute;
width: 100%;
height: calc(var(--moveable-line-padding, 0) * 1px);
bottom: 0;
left: 0;
}
.group {
z-index: -1;
}
.area {
position: absolute;
}
.area-pieces {
position: absolute;
top: 0;
left: 0;
display: none;
}
.area.avoid, .area.pass {
pointer-events: none;
}
.area.avoid+.area-pieces {
display: block;
}
.area-piece {
position: absolute;
}

`).concat(IS_WEBKIT605 ? `:global svg *:before {
content:"";
transform-origin: inherit;
}` : "", `
`), NEARBY_POS = [
  [0, 1, 2],
  [1, 0, 3],
  [2, 0, 3],
  [3, 1, 2]
], FLOAT_POINT_NUM = 1e-4, TINY_NUM = 1e-7, MIN_SCALE = 1e-9, MAX_NUM = Math.pow(10, 10), MIN_NUM = -MAX_NUM, DIRECTION_REGION_TO_DIRECTION = {
  n: [0, -1],
  e: [1, 0],
  s: [0, 1],
  w: [-1, 0],
  nw: [-1, -1],
  ne: [1, -1],
  sw: [-1, 1],
  se: [1, 1]
}, DIRECTION_INDEXES = {
  n: [0, 1],
  e: [1, 3],
  s: [3, 2],
  w: [2, 0],
  nw: [0],
  ne: [1],
  sw: [2],
  se: [3]
}, DIRECTION_ROTATIONS = {
  n: 0,
  s: 180,
  w: 270,
  e: 90,
  nw: 315,
  ne: 45,
  sw: 225,
  se: 135
}, MOVEABLE_METHODS = [
  "isMoveableElement",
  "updateRect",
  "updateTarget",
  "destroy",
  "dragStart",
  "isInside",
  "hitTest",
  "setState",
  "getRect",
  "request",
  "isDragging",
  "getManager",
  "forceUpdate",
  "waitToChangeTarget",
  "updateSelectors",
  "getTargets",
  "stopDrag",
  "getControlBoxElement",
  "getMoveables",
  "getDragElement"
];
function setCustomDrag(a, s, c, u, d, p) {
  var v, A;
  p === void 0 && (p = "draggable");
  var x = (A = (v = s.gestos[p]) === null || v === void 0 ? void 0 : v.move(c, a.inputEvent)) !== null && A !== void 0 ? A : {}, g = x.originalDatas || x.datas, b = g[p] || (g[p] = {});
  return __assign$1(__assign$1({}, x), { isPinch: !!u, parentEvent: !0, datas: b, originalDatas: a.originalDatas });
}
var CustomGesto = /* @__PURE__ */ function() {
  function a(s) {
    var c;
    s === void 0 && (s = "draggable"), this.ableName = s, this.prevX = 0, this.prevY = 0, this.startX = 0, this.startY = 0, this.isDrag = !1, this.isFlag = !1, this.datas = {
      draggable: {}
    }, this.datas = (c = {}, c[s] = {}, c);
  }
  return a.prototype.dragStart = function(s, c) {
    this.isDrag = !1, this.isFlag = !1;
    var u = c.originalDatas;
    return this.datas = u, u[this.ableName] || (u[this.ableName] = {}), __assign$1(__assign$1({}, this.move(s, c.inputEvent)), { type: "dragstart" });
  }, a.prototype.drag = function(s, c) {
    return this.move([
      s[0] - this.prevX,
      s[1] - this.prevY
    ], c);
  }, a.prototype.move = function(s, c) {
    var u, d, p = !1;
    if (!this.isFlag)
      this.prevX = s[0], this.prevY = s[1], this.startX = s[0], this.startY = s[1], u = s[0], d = s[1], this.isFlag = !0;
    else {
      var v = this.isDrag;
      u = this.prevX + s[0], d = this.prevY + s[1], (s[0] || s[1]) && (this.isDrag = !0), !v && this.isDrag && (p = !0);
    }
    return this.prevX = u, this.prevY = d, {
      type: "drag",
      clientX: u,
      clientY: d,
      inputEvent: c,
      isFirstDrag: p,
      isDrag: this.isDrag,
      distX: u - this.startX,
      distY: d - this.startY,
      deltaX: s[0],
      deltaY: s[1],
      datas: this.datas[this.ableName],
      originalDatas: this.datas,
      parentEvent: !0,
      parentGesto: this
    };
  }, a;
}();
function calculateElementPosition(a, s, c, u) {
  var d = a.length === 16, p = d ? 4 : 3, v = calculatePoses(a, c, u, p), A = __read(v, 4), x = __read(A[0], 2), g = x[0], b = x[1], y = __read(A[1], 2), f = y[0], m = y[1], C = __read(A[2], 2), w = C[0], S = C[1], $ = __read(A[3], 2), T = $[0], I = $[1], _ = __read(calculatePosition(a, s, p), 2), E = _[0], R = _[1], O = Math.min(g, f, w, T), L = Math.min(b, m, S, I), B = Math.max(g, f, w, T), F = Math.max(b, m, S, I);
  g = g - O || 0, f = f - O || 0, w = w - O || 0, T = T - O || 0, b = b - L || 0, m = m - L || 0, S = S - L || 0, I = I - L || 0, E = E - O || 0, R = R - L || 0;
  var M = a[0], W = a[p + 1], j = sign(M * W);
  return {
    left: O,
    top: L,
    right: B,
    bottom: F,
    origin: [E, R],
    pos1: [g, b],
    pos2: [f, m],
    pos3: [w, S],
    pos4: [T, I],
    direction: j
  };
}
function calculatePointerDist(a, s) {
  var c = s.clientX, u = s.clientY, d = s.datas, p = a.state, v = p.moveableClientRect, A = p.rootMatrix, x = p.is3d, g = p.pos1, b = v.left, y = v.top, f = x ? 4 : 3, m = __read(minus(calculateInversePosition(A, [c - b, u - y], f), g), 2), C = m[0], w = m[1], S = __read(getDragDist({ datas: d, distX: C, distY: w }), 2), $ = S[0], T = S[1];
  return [$, T];
}
function setDragStart(a, s) {
  var c = s.datas, u = a.state, d = u.allMatrix, p = u.beforeMatrix, v = u.is3d, A = u.left, x = u.top, g = u.origin, b = u.offsetMatrix, y = u.targetMatrix, f = u.transformOrigin, m = v ? 4 : 3;
  c.is3d = v, c.matrix = d, c.targetMatrix = y, c.beforeMatrix = p, c.offsetMatrix = b, c.transformOrigin = f, c.inverseMatrix = invert(d, m), c.inverseBeforeMatrix = invert(p, m), c.absoluteOrigin = convertPositionMatrix(plus([A, x], g), m), c.startDragBeforeDist = calculate(c.inverseBeforeMatrix, c.absoluteOrigin, m), c.startDragDist = calculate(c.inverseMatrix, c.absoluteOrigin, m);
}
function getTransformDirection(a) {
  return calculateElementPosition(a.datas.beforeTransform, [50, 50], 100, 100).direction;
}
function resolveTransformEvent(a, s, c) {
  var u = s.datas, d = s.originalDatas.beforeRenderable, p = u.transformIndex, v = d.nextTransforms, A = v.length, x = d.nextTransformAppendedIndexes, g = -1;
  p === -1 ? (c === "translate" ? g = 0 : c === "rotate" && (g = findIndex(v, function(m) {
    return m.match(/scale\(/g);
  })), g === -1 && (g = v.length), u.transformIndex = g) : find$1(x, function(m) {
    return m.index === p && m.functionName === c;
  }) ? g = p : g = p + x.filter(function(m) {
    return m.index < p;
  }).length;
  var b = convertTransformInfo(v, a.state, g), y = b.targetFunction, f = c === "rotate" ? "rotateZ" : c;
  u.beforeFunctionTexts = b.beforeFunctionTexts, u.afterFunctionTexts = b.afterFunctionTexts, u.beforeTransform = b.beforeFunctionMatrix, u.beforeTransform2 = b.beforeFunctionMatrix2, u.targetTansform = b.targetFunctionMatrix, u.afterTransform = b.afterFunctionMatrix, u.afterTransform2 = b.afterFunctionMatrix2, u.targetAllTransform = b.allFunctionMatrix, y.functionName === f ? (u.afterFunctionTexts.splice(0, 1), u.isAppendTransform = !1) : A > g && (u.isAppendTransform = !0, d.nextTransformAppendedIndexes = __spreadArray$1(__spreadArray$1([], __read(x), !1), [{
    functionName: c,
    index: g,
    isAppend: !0
  }], !1));
}
function convertTransformFormat(a, s, c) {
  return "".concat(a.beforeFunctionTexts.join(" "), " ").concat(a.isAppendTransform ? c : s, " ").concat(a.afterFunctionTexts.join(" "));
}
function getTransformDist(a) {
  var s = a.datas, c = a.distX, u = a.distY, d = __read(getBeforeDragDist({ datas: s, distX: c, distY: u }), 2), p = d[0], v = d[1], A = getTransfromMatrix(s, fromTranslation([p, v], 4));
  return calculate(A, convertPositionMatrix([0, 0, 0], 4), 4);
}
function getTransfromMatrix(a, s, c) {
  var u = a.beforeTransform, d = a.afterTransform, p = a.beforeTransform2, v = a.afterTransform2, A = a.targetAllTransform, x = c ? multiply(A, s, 4) : multiply(s, A, 4), g = multiply(invert(c ? p : u, 4), x, 4), b = multiply(g, invert(c ? v : d, 4), 4);
  return b;
}
function getBeforeDragDist(a) {
  var s = a.datas, c = a.distX, u = a.distY, d = s.inverseBeforeMatrix, p = s.is3d, v = s.startDragBeforeDist, A = s.absoluteOrigin, x = p ? 4 : 3;
  return minus(calculate(d, plus(A, [c, u]), x), v);
}
function getDragDist(a, s) {
  var c = a.datas, u = a.distX, d = a.distY, p = c.inverseBeforeMatrix, v = c.inverseMatrix, A = c.is3d, x = c.startDragBeforeDist, g = c.startDragDist, b = c.absoluteOrigin, y = A ? 4 : 3;
  return minus(calculate(s ? p : v, plus(b, [u, d]), y), s ? x : g);
}
function getInverseDragDist(a, s) {
  var c = a.datas, u = a.distX, d = a.distY;
  c.beforeMatrix;
  var p = c.matrix, v = c.is3d;
  c.startDragBeforeDist;
  var A = c.startDragDist, x = c.absoluteOrigin, g = v ? 4 : 3;
  return minus(calculate(p, plus(A, [u, d]), g), x);
}
function calculateTransformOrigin(a, s, c, u, d, p) {
  return u === void 0 && (u = s), d === void 0 && (d = c), p === void 0 && (p = [0, 0]), a ? a.map(function(v, A) {
    var x = splitUnit(v), g = x.value, b = x.unit, y = A ? d : u, f = A ? c : s;
    if (v === "%" || isNaN(g)) {
      var m = y ? p[A] / y : 0;
      return f * m;
    } else if (b !== "%")
      return g;
    return f * g / 100;
  }) : p;
}
function getPosIndexesByDirection(a) {
  var s = [];
  return a[1] >= 0 && (a[0] >= 0 && s.push(3), a[0] <= 0 && s.push(2)), a[1] <= 0 && (a[0] >= 0 && s.push(1), a[0] <= 0 && s.push(0)), s;
}
function getPosesByDirection(a, s) {
  return getPosIndexesByDirection(s).map(function(c) {
    return a[c];
  });
}
function getPosBySingleDirection(a, s) {
  var c = (s + 1) / 2;
  return [
    dot(a[0][0], a[1][0], c, 1 - c),
    dot(a[0][1], a[1][1], c, 1 - c)
  ];
}
function getPosByDirection(a, s) {
  var c = getPosBySingleDirection([a[0], a[1]], s[0]), u = getPosBySingleDirection([a[2], a[3]], s[0]);
  return getPosBySingleDirection([c, u], s[1]);
}
function getDist(a, s, c, u, d, p) {
  var v = calculatePoses(s, c, u, d), A = getPosByDirection(v, p), x = a[0] - A[0], g = a[1] - A[1];
  return [x, g];
}
function getNextMatrix(a, s, c, u) {
  return multiply(a, getAbsoluteMatrix(s, u, c), u);
}
function getNextTransformMatrix(a, s, c, u) {
  var d = a.transformOrigin, p = a.offsetMatrix, v = a.is3d, A = v ? 4 : 3, x;
  if (isString(c)) {
    var g = s.beforeTransform, b = s.afterTransform;
    u ? x = convertDimension(parseMat(c), 4, A) : x = convertDimension(multiply(multiply(g, parseMat([c]), 4), b, 4), 4, A);
  } else
    x = c;
  return getNextMatrix(p, x, d, A);
}
function scaleMatrix(a, s) {
  var c = a.transformOrigin, u = a.offsetMatrix, d = a.is3d, p = a.targetMatrix, v = a.targetAllTransform, A = d ? 4 : 3;
  return getNextMatrix(u, multiply(v || p, createScaleMatrix(s, A), A), c, A);
}
function fillTransformStartEvent(a, s) {
  var c = getBeforeRenderableDatas(s);
  return {
    setTransform: function(u, d) {
      d === void 0 && (d = -1), c.startTransforms = isArray(u) ? u : splitSpace(u), setTransformIndex(a, s, d);
    },
    setTransformIndex: function(u) {
      setTransformIndex(a, s, u);
    }
  };
}
function setDefaultTransformIndex(a, s, c) {
  var u = getBeforeRenderableDatas(s), d = u.startTransforms;
  setTransformIndex(a, s, findIndex(d, function(p) {
    return p.indexOf("".concat(c, "(")) === 0;
  }));
}
function setTransformIndex(a, s, c) {
  var u = getBeforeRenderableDatas(s), d = s.datas;
  if (d.transformIndex = c, c !== -1) {
    var p = u.startTransforms[c];
    if (p) {
      var v = a.state, A = parse([p], {
        "x%": function(x) {
          return x / 100 * v.offsetWidth;
        },
        "y%": function(x) {
          return x / 100 * v.offsetHeight;
        }
      });
      d.startValue = A[0].functionValue;
    }
  }
}
function fillOriginalTransform(a, s) {
  var c = getBeforeRenderableDatas(a);
  c.nextTransforms = splitSpace(s);
}
function getBeforeRenderableDatas(a) {
  return a.originalDatas.beforeRenderable;
}
function getNextTransforms(a) {
  var s = a.originalDatas.beforeRenderable;
  return s.nextTransforms;
}
function getNextTransformText(a) {
  return (getNextTransforms(a) || []).join(" ");
}
function getNextStyle(a) {
  return getBeforeRenderableDatas(a).nextStyle;
}
function fillTransformEvent(a, s, c, u, d) {
  fillOriginalTransform(d, s);
  var p = Draggable.drag(a, setCustomDrag(d, a.state, c, u)), v = p ? p.transform : s;
  return __assign$1(__assign$1({ transform: s, drag: p }, fillCSSObject({
    transform: v
  }, d)), { afterTransform: v });
}
function getTranslateFixedPosition(a, s, c, u, d, p) {
  var v = getNextTransformMatrix(a.state, d, s, p), A = getDirectionOffset(a, c, u, v);
  return A;
}
function getTranslateDist(a, s, c, u, d, p, v) {
  var A = getTranslateFixedPosition(a, s, c, d, p, v), x = a.state, g = x.left, b = x.top, y = a.props.groupable, f = y ? g : 0, m = y ? b : 0, C = minus(u, A);
  return minus(C, [f, m]);
}
function getScaleDist(a, s, c, u, d, p, v) {
  var A = getTranslateDist(a, s, c, u, d, p, v);
  return A;
}
function getDirectionByPos(a, s, c) {
  return [
    s ? -1 + a[0] / (s / 2) : 0,
    c ? -1 + a[1] / (c / 2) : 0
  ];
}
function getDirectionOffset(a, s, c, u) {
  u === void 0 && (u = a.state.allMatrix);
  var d = a.state, p = d.width, v = d.height, A = d.is3d, x = A ? 4 : 3, g = [
    p / 2 * (1 + s[0]) + c[0],
    v / 2 * (1 + s[1]) + c[1]
  ];
  return calculatePosition(u, g, x);
}
function getRotateDist(a, s, c) {
  var u = c.fixedDirection, d = c.fixedPosition, p = c.fixedOffset;
  return getTranslateDist(a, "rotate(".concat(s, "deg)"), u, d, p, c);
}
function getResizeDist(a, s, c, u, d, p) {
  var v = a.props.groupable, A = a.state, x = A.transformOrigin, g = A.offsetMatrix, b = A.is3d, y = A.width, f = A.height, m = A.left, C = A.top, w = p.fixedDirection, S = p.nextTargetMatrix || A.targetMatrix, $ = b ? 4 : 3, T = calculateTransformOrigin(d, s, c, y, f, x), I = v ? m : 0, _ = v ? C : 0, E = getNextMatrix(g, S, T, $), R = getDist(u, E, s, c, $, w);
  return minus(R, [I, _]);
}
function getAbsolutePosition(a, s) {
  return getPosByDirection(getAbsolutePosesByState(a.state), s);
}
function getGestoData(a, s) {
  var c = a.targetGesto, u = a.controlGesto, d;
  return c?.isFlag() && (d = c.getEventData()[s]), !d && u?.isFlag() && (d = u.getEventData()[s]), d || {};
}
function getShadowRoot(a) {
  if (a && a.getRootNode) {
    var s = a.getRootNode();
    if (s.nodeType === 11)
      return s;
  }
}
function getIndividualTransforms(a) {
  var s = a("scale"), c = a("rotate"), u = a("translate"), d = [];
  return u && u !== "0px" && u !== "none" && d.push("translate(".concat(u.split(/\s+/).join(","), ")")), c && c !== "1" && c !== "none" && d.push("rotate(".concat(c, ")")), s && s !== "1" && s !== "none" && d.push("scale(".concat(s.split(/\s+/).join(","), ")")), d;
}
function getMatrixStackInfo(a, s, c) {
  for (var u = a, d = [], p = getDocumentElement(a) || getDocumentBody(a), v = !c && a === s || a === p, A = v, x = !1, g = 3, b, y, f, m = !1, C = getOffsetInfo(s, s, !0).offsetParent, w = 1; u && !A; ) {
    A = v;
    var S = getCachedStyle(u), $ = S("position"), T = getElementTransform(u), I = $ === "fixed", _ = getIndividualTransforms(S), E = convertCSStoMatrix(getTransformMatrix(T)), R = void 0, O = !1, L = !1, B = 0, F = 0, M = 0, W = 0, j = {
      hasTransform: !1,
      fixedContainer: null
    };
    I && (m = !0, j = getPositionFixedInfo(u), C = j.fixedContainer);
    var G = E.length;
    !x && (G === 16 || _.length) && (x = !0, g = 4, convert3DMatrixes(d), f && (f = convertDimension(f, 3, 4))), x && G === 9 && (E = convertDimension(E, 3, 4));
    var U = getOffsetPosInfo(u, a), k = U.tagName, N = U.hasOffset, P = U.isSVG, D = U.origin, H = U.targetOrigin, V = U.offset, Z = __read(V, 2), ne = Z[0], K = Z[1];
    k === "svg" && !u.ownerSVGElement && f && (d.push({
      type: "target",
      target: u,
      matrix: getSVGMatrix(u, g)
    }), d.push({
      type: "offset",
      target: u,
      matrix: createIdentityMatrix(g)
    }));
    var q = parseFloat(S("zoom")) || 1;
    if (I)
      R = j.fixedContainer, O = !0;
    else {
      var Y = getOffsetInfo(u, s, !1, !0, S), ee = Y.offsetZoom;
      if (R = Y.offsetParent, O = Y.isEnd, L = Y.isStatic, w *= ee, (Y.isCustomElement || ee !== 1) && L)
        ne -= R.offsetLeft, K -= R.offsetTop;
      else if (IS_FIREFOX || IS_CHROMIUM109) {
        var Q = Y.parentSlotElement;
        if (Q) {
          for (var J = R, te = 0, ae = 0; J && getShadowRoot(J); )
            te += J.offsetLeft, ae += J.offsetTop, J = J.offsetParent;
          ne -= te, K -= ae;
        }
      }
    }
    if (IS_WEBKIT && !IS_SAFARI_ABOVE15 && N && !P && L && ($ === "relative" || $ === "static") && (ne -= R.offsetLeft, K -= R.offsetTop, v = v || O), I)
      N && j.hasTransform && (M = R.clientLeft, W = R.clientTop);
    else if (N && C !== R && (B = R.clientLeft, F = R.clientTop), N && R === p) {
      var se = getBodyOffset(u, !1);
      ne += se[0], K += se[1];
    }
    if (d.push({
      type: "target",
      target: u,
      matrix: getAbsoluteMatrix(E, g, D)
    }), _.length && (d.push({
      type: "offset",
      target: u,
      matrix: createIdentityMatrix(g)
    }), d.push({
      type: "target",
      target: u,
      matrix: getAbsoluteMatrix(parseMat(_), g, D)
    })), N) {
      var ie = u === a, fe = ie ? 0 : u.scrollLeft, ge = ie ? 0 : u.scrollTop;
      d.push({
        type: "offset",
        target: u,
        matrix: createOriginMatrix([
          ne - fe + B - M,
          K - ge + F - W
        ], g)
      });
    } else
      d.push({
        type: "offset",
        target: u,
        origin: D
      });
    if (q !== 1 && d.push({
      type: "zoom",
      target: u,
      matrix: getAbsoluteMatrix(createScaleMatrix([q, q], g), g, [0, 0])
    }), f || (f = E), b || (b = D), y || (y = H), A || I)
      break;
    u = R, v = O, (!c || u === p) && (A = v);
  }
  return f || (f = createIdentityMatrix(g)), b || (b = [0, 0]), y || (y = [0, 0]), {
    zoom: w,
    offsetContainer: C,
    matrixes: d,
    targetMatrix: f,
    transformOrigin: b,
    targetOrigin: y,
    is3d: x,
    hasFixed: m
  };
}
var cacheStyleMap = null, clientRectStyleMap = null, matrixContainerInfos = null;
function setStoreCache(a) {
  a ? (window.Map && (cacheStyleMap = /* @__PURE__ */ new Map(), clientRectStyleMap = /* @__PURE__ */ new Map()), matrixContainerInfos = []) : (cacheStyleMap = null, matrixContainerInfos = null, clientRectStyleMap = null);
}
function getCachedClientRect(a) {
  var s = clientRectStyleMap?.get(a);
  if (s)
    return s;
  var c = getClientRect(a, !0);
  return clientRectStyleMap && clientRectStyleMap.set(a, c), c;
}
function getCachedMatrixContainerInfo(a, s) {
  if (matrixContainerInfos) {
    var c = find$1(matrixContainerInfos, function(d) {
      return d[0][0] == a && d[0][1] == s;
    });
    if (c)
      return c[1];
  }
  var u = getMatrixStackInfo(a, s, !0);
  return matrixContainerInfos && matrixContainerInfos.push([[a, s], u]), u;
}
function getCachedStyle(a) {
  var s = cacheStyleMap?.get(a);
  if (!s) {
    var c = getWindow(a).getComputedStyle(a);
    if (!cacheStyleMap)
      return function(p) {
        return c[p];
      };
    s = {
      style: c,
      cached: {}
    }, cacheStyleMap.set(a, s);
  }
  var u = s.cached, d = s.style;
  return function(p) {
    return p in u || (u[p] = d[p]), u[p];
  };
}
function fillChildEvents(a, s, c) {
  var u = c.originalDatas;
  u.groupable = u.groupable || {};
  var d = u.groupable;
  d.childDatas = d.childDatas || [];
  var p = d.childDatas;
  return a.moveables.map(function(v, A) {
    return p[A] = p[A] || {}, p[A][s] = p[A][s] || {}, __assign$1(__assign$1({}, c), { isRequestChild: !0, datas: p[A][s], originalDatas: p[A] });
  });
}
function triggerChildGesto(a, s, c, u, d, p, v) {
  var A = !!c.match(/Start$/g), x = !!c.match(/End$/g), g = d.isPinch, b = d.datas, y = fillChildEvents(a, s.name, d), f = a.moveables, m = [], C = y.map(function(w, S) {
    var $ = f[S], T = $.state, I = T.gestos, _ = w;
    if (A)
      _ = new CustomGesto(v).dragStart(u, w), m.push(_);
    else {
      if (I[v] || (I[v] = b.childGestos[S]), !I[v])
        return;
      _ = setCustomDrag(w, T, u, g, p, v), m.push(_);
    }
    var E = s[c]($, __assign$1(__assign$1({}, _), { parentFlag: !0 }));
    return x && (I[v] = null), E;
  });
  return A && (b.childGestos = f.map(function(w) {
    return w.state.gestos[v];
  })), {
    eventParams: C,
    childEvents: m
  };
}
function triggerChildAbles(a, s, c, u, d, p) {
  d === void 0 && (d = function(b, y) {
    return y;
  });
  var v = !!c.match(/End$/g), A = fillChildEvents(a, s.name, u), x = a.moveables, g = A.map(function(b, y) {
    var f = x[y], m = b;
    m = d(f, b);
    var C = s[c](f, __assign$1(__assign$1({}, m), { parentFlag: !0 }));
    return v && (f.state.gestos = {}), C;
  });
  return g;
}
function startChildDist(a, s, c, u) {
  var d = c.fixedDirection, p = c.fixedPosition, v = u.datas.startPositions || getAbsolutePosesByState(s.state), A = getPosByDirection(v, d), x = __read(calculate(createRotateMatrix(-a.rotation / 180 * Math.PI, 3), [A[0] - p[0], A[1] - p[1], 1], 3), 2), g = x[0], b = x[1];
  return u.datas.originalX = g, u.datas.originalY = b, u;
}
function renderDirectionControlsByInfos(a, s, c, u) {
  var d = a.getState(), p = d.renderPoses, v = d.rotation, A = d.direction, x = getProps(a.props, s).zoom, g = absDegree(v / Math.PI * 180), b = {}, y = a.renderState;
  y.renderDirectionMap || (y.renderDirectionMap = {});
  var f = y.renderDirectionMap;
  c.forEach(function(C) {
    var w = C.dir;
    b[w] = !0;
  });
  var m = sign(A);
  return c.map(function(C) {
    var w = C.data, S = C.classNames, $ = C.dir, T = DIRECTION_INDEXES[$];
    if (!T || !b[$])
      return null;
    f[$] = !0;
    var I = (throttle(g, 15) + m * DIRECTION_ROTATIONS[$] + 720) % 180, _ = {};
    return getKeys(w).forEach(function(E) {
      _["data-".concat(E)] = w[E];
    }), u.createElement("div", __assign$1({ className: prefix$1.apply(void 0, __spreadArray$1(["control", "direction", $, s], __read(S), !1)), "data-rotation": I, "data-direction": $ }, _, { key: "direction-".concat($), style: getControlTransform.apply(void 0, __spreadArray$1([v, x], __read(T.map(function(E) {
      return p[E];
    })), !1)) }));
  });
}
function renderDirectionControls(a, s, c, u) {
  var d = getProps(a.props, c), p = d.renderDirections, v = p === void 0 ? s : p, A = d.displayAroundControls;
  if (!v)
    return [];
  var x = v === !0 ? DIRECTIONS : v;
  return __spreadArray$1(__spreadArray$1([], __read(A ? renderAroundControls(a, u, c, x) : []), !1), __read(renderDirectionControlsByInfos(a, c, x.map(function(g) {
    return {
      data: {},
      classNames: [],
      dir: g
    };
  }), u)), !1);
}
function renderLine(a, s, c, u, d, p) {
  for (var v = [], A = 6; A < arguments.length; A++)
    v[A - 6] = arguments[A];
  var x = getRad$1(c, u), g = s ? throttle(x / Math.PI * 180, 15) % 180 : -1;
  return a.createElement("div", { key: "line-".concat(p), className: prefix$1.apply(void 0, __spreadArray$1(["line", "direction", s ? "edge" : "", s], __read(v), !1)), "data-rotation": g, "data-line-key": p, "data-direction": s, style: getLineStyle(c, u, d, x) });
}
function renderEdgeLines(a, s, c, u, d) {
  var p = c === !0 ? DIRECTIONS4 : c;
  return p.map(function(v, A) {
    var x = __read(DIRECTION_INDEXES[v], 2), g = x[0], b = x[1];
    if (b != null)
      return renderLine(a, v, u[g], u[b], d, "".concat(s, "Edge").concat(A), s);
  }).filter(Boolean);
}
function getRenderDirections(a) {
  return function(s, c) {
    var u = getProps(s.props, a).edge;
    return u && (u === !0 || u.length) ? __spreadArray$1(__spreadArray$1([], __read(renderEdgeLines(c, a, u, s.getState().renderPoses, s.props.zoom)), !1), __read(renderDiagonalDirections(s, a, c)), !1) : renderAllDirections(s, a, c);
  };
}
function renderAllDirections(a, s, c) {
  return renderDirectionControls(a, DIRECTIONS, s, c);
}
function renderDiagonalDirections(a, s, c) {
  return renderDirectionControls(a, ["nw", "ne", "sw", "se"], s, c);
}
function renderAroundControls(a, s, c, u) {
  var d = a.renderState;
  d.renderDirectionMap || (d.renderDirectionMap = {});
  var p = a.getState(), v = p.renderPoses, A = p.rotation, x = p.direction, g = d.renderDirectionMap, b = a.props.zoom, y = sign(x), f = A / Math.PI * 180;
  return (u || getKeys(g)).map(function(m) {
    var C = DIRECTION_INDEXES[m];
    if (!C)
      return null;
    var w = (throttle(f, 15) + y * DIRECTION_ROTATIONS[m] + 720) % 180, S = ["around-control"];
    return c && S.push("direction", c), s.createElement("div", { className: prefix$1.apply(void 0, __spreadArray$1([], __read(S), !1)), "data-rotation": w, "data-direction": m, key: "direction-around-".concat(m), style: getControlTransform.apply(void 0, __spreadArray$1([A, b], __read(C.map(function($) {
      return v[$];
    })), !1)) });
  });
}
function checkBoundPoses(a, s, c) {
  var u = a || {}, d = u.position, p = d === void 0 ? "client" : d, v = u.left, A = v === void 0 ? -1 / 0 : v, x = u.top, g = x === void 0 ? -1 / 0 : x, b = u.right, y = b === void 0 ? 1 / 0 : b, f = u.bottom, m = f === void 0 ? 1 / 0 : f, C = {
    position: p,
    left: A,
    top: g,
    right: y,
    bottom: m
  };
  return {
    vertical: checkBounds(C, s, !0),
    horizontal: checkBounds(C, c, !1)
  };
}
function getBounds(a, s) {
  var c = a.state, u = c.containerClientRect, d = u.clientHeight, p = u.clientWidth, v = u.clientLeft, A = u.clientTop, x = c.snapOffset, g = x.left, b = x.top, y = x.right, f = x.bottom, m = s || a.props.bounds || {}, C = m.position || "client", w = C === "css", S = m.left, $ = S === void 0 ? -1 / 0 : S, T = m.top, I = T === void 0 ? -1 / 0 : T, _ = m.right, E = _ === void 0 ? w ? -1 / 0 : 1 / 0 : _, R = m.bottom, O = R === void 0 ? w ? -1 / 0 : 1 / 0 : R;
  return w && (E = p + y - g - E, O = d + f - b - O), {
    left: $ + g - v,
    right: E + g - v,
    top: I + b - A,
    bottom: O + b - A
  };
}
function checkBoundKeepRatio(a, s, c) {
  var u = getBounds(a), d = u.left, p = u.top, v = u.right, A = u.bottom, x = __read(c, 2), g = x[0], b = x[1], y = __read(minus(c, s), 2), f = y[0], m = y[1];
  abs(f) < TINY_NUM && (f = 0), abs(m) < TINY_NUM && (m = 0);
  var C = m > 0, w = f > 0, S = {
    isBound: !1,
    offset: 0,
    pos: 0
  }, $ = {
    isBound: !1,
    offset: 0,
    pos: 0
  };
  if (f === 0 && m === 0)
    return {
      vertical: S,
      horizontal: $
    };
  if (f === 0)
    C ? A < b && ($.pos = A, $.offset = b - A) : p > b && ($.pos = p, $.offset = b - p);
  else if (m === 0)
    w ? v < g && (S.pos = v, S.offset = g - v) : d > g && (S.pos = d, S.offset = g - d);
  else {
    var T = m / f, I = c[1] - T * g, _ = 0, E = 0, R = !1;
    w && v <= g ? (_ = T * v + I, E = v, R = !0) : !w && g <= d && (_ = T * d + I, E = d, R = !0), R && (_ < p || _ > A) && (R = !1), R || (C && A <= b ? (_ = A, E = (_ - I) / T, R = !0) : !C && b <= p && (_ = p, E = (_ - I) / T, R = !0)), R && (S.isBound = !0, S.pos = E, S.offset = g - E, $.isBound = !0, $.pos = _, $.offset = b - _);
  }
  return {
    vertical: S,
    horizontal: $
  };
}
function checkBounds(a, s, c) {
  var u = a[c ? "left" : "top"], d = a[c ? "right" : "bottom"], p = Math.min.apply(Math, __spreadArray$1([], __read(s), !1)), v = Math.max.apply(Math, __spreadArray$1([], __read(s), !1)), A = [];
  return u + 1 > p && A.push({
    direction: "start",
    isBound: !0,
    offset: p - u,
    pos: u
  }), d - 1 < v && A.push({
    direction: "end",
    isBound: !0,
    offset: v - d,
    pos: d
  }), A.length || A.push({
    isBound: !1,
    offset: 0,
    pos: 0
  }), A.sort(function(x, g) {
    return abs(g.offset) - abs(x.offset);
  });
}
function isBoundRotate$1(a, s, c) {
  var u = c ? a.map(function(d) {
    return rotate(d, c);
  }) : a;
  return u.some(function(d) {
    return d[0] < s.left && abs(d[0] - s.left) > 0.1 || d[0] > s.right && abs(d[0] - s.right) > 0.1 || d[1] < s.top && abs(d[1] - s.top) > 0.1 || d[1] > s.bottom && abs(d[1] - s.bottom) > 0.1;
  });
}
function boundRotate(a, s, c) {
  var u = getDistSize(a), d = Math.sqrt(u * u - s * s) || 0;
  return [d, -d].sort(function(p, v) {
    return abs(p - a[c ? 0 : 1]) - abs(v - a[c ? 0 : 1]);
  }).map(function(p) {
    return getRad$1([0, 0], c ? [p, s] : [s, p]);
  });
}
function checkRotateBounds(a, s, c, u, d) {
  if (!a.props.bounds)
    return [];
  var p = d * Math.PI / 180, v = getBounds(a), A = v.left, x = v.top, g = v.right, b = v.bottom, y = A - u[0], f = g - u[0], m = x - u[1], C = b - u[1], w = {
    left: y,
    top: m,
    right: f,
    bottom: C
  };
  if (!isBoundRotate$1(c, w, 0))
    return [];
  var S = [];
  return [
    [y, 0],
    [f, 0],
    [m, 1],
    [C, 1]
  ].forEach(function($) {
    var T = __read($, 2), I = T[0], _ = T[1];
    c.forEach(function(E) {
      var R = getRad$1([0, 0], E);
      S.push.apply(S, __spreadArray$1([], __read(boundRotate(E, I, _).map(function(O) {
        return p + O - R;
      }).filter(function(O) {
        return !isBoundRotate$1(s, w, O);
      }).map(function(O) {
        return throttle(O * 180 / Math.PI, TINY_NUM);
      })), !1));
    });
  }), S;
}
var VERTICAL_NAMES = ["left", "right", "center"], HORIZONTAL_NAMES = ["top", "bottom", "middle"], SNAP_SKIP_NAMES_MAP = {
  left: "start",
  right: "end",
  center: "center",
  top: "start",
  bottom: "end",
  middle: "center"
}, VERTICAL_NAMES_MAP = {
  start: "left",
  end: "right",
  center: "center"
}, HORIZONTAL_NAMES_MAP = {
  start: "top",
  end: "bottom",
  center: "middle"
};
function getInitialBounds() {
  return {
    left: !1,
    top: !1,
    right: !1,
    bottom: !1
  };
}
function hasGuidelines(a, s) {
  var c = a.props, u = c.snappable, d = c.bounds, p = c.innerBounds, v = c.verticalGuidelines, A = c.horizontalGuidelines, x = c.snapGridWidth, g = c.snapGridHeight, b = a.state, y = b.guidelines, f = b.enableSnap;
  return !u || !f || s && u !== !0 && u.indexOf(s) < 0 ? !1 : !!(x || g || d || p || y && y.length || v && v.length || A && A.length);
}
function getSnapDirections(a) {
  return a === !1 ? {} : a === !0 || !a ? { left: !0, right: !0, top: !0, bottom: !0 } : a;
}
function mapSnapDirectionPoses(a, s) {
  var c = getSnapDirections(a), u = {};
  for (var d in c)
    d in s && c[d] && (u[d] = s[d]);
  return u;
}
function splitSnapDirectionPoses(a, s) {
  var c = mapSnapDirectionPoses(a, s), u = HORIZONTAL_NAMES.filter(function(p) {
    return p in c;
  }), d = VERTICAL_NAMES.filter(function(p) {
    return p in c;
  });
  return {
    horizontalNames: u,
    verticalNames: d,
    horizontal: u.map(function(p) {
      return c[p];
    }),
    vertical: d.map(function(p) {
      return c[p];
    })
  };
}
function calculateContainerPos(a, s, c) {
  var u = calculatePosition(a, [s.clientLeft, s.clientTop], c);
  return [
    s.left + u[0],
    s.top + u[1]
  ];
}
function solveLineConstants(a) {
  var s = __read(a, 2), c = s[0], u = s[1], d = u[0] - c[0], p = u[1] - c[1];
  Math.abs(d) < TINY_NUM$1 && (d = 0), Math.abs(p) < TINY_NUM$1 && (p = 0);
  var v = 0, A = 0, x = 0;
  return d ? p ? (v = -p / d, A = 1, x = v * c[0] - c[1]) : (A = 1, x = -c[1]) : (v = -1, x = c[0]), [v, A, x].map(function(g) {
    return throttle(g, TINY_NUM$1);
  });
}
var NAME_snapRotationThreshold = "snapRotationThreshold", NAME_snapRotationDegrees = "snapRotationDegrees", NAME_snapHorizontalThreshold = "snapHorizontalThreshold", NAME_snapVerticalThreshold = "snapVerticalThreshold";
function checkMoveableSnapPoses(a, s, c, u, d, p, v) {
  var A;
  u === void 0 && (u = []), d === void 0 && (d = []);
  var x = a.props, g = ((A = a.state.snapThresholdInfo) === null || A === void 0 ? void 0 : A.multiples) || [1, 1], b = selectValue(v, x[NAME_snapHorizontalThreshold], 5), y = selectValue(p, x[NAME_snapVerticalThreshold], 5);
  return checkSnapPoses(a.state.guidelines, s, c, u, d, b, y, g);
}
function checkSnapPoses(a, s, c, u, d, p, v, A) {
  return {
    vertical: checkSnap(a, "vertical", s, v * A[0], u),
    horizontal: checkSnap(a, "horizontal", c, p * A[1], d)
  };
}
function checkSnapKeepRatio(a, s, c) {
  var u = __read(c, 2), d = u[0], p = u[1], v = __read(s, 2), A = v[0], x = v[1], g = __read(minus(c, s), 2), b = g[0], y = g[1], f = y > 0, m = b > 0;
  b = getTinyDist(b), y = getTinyDist(y);
  var C = {
    isSnap: !1,
    offset: 0,
    pos: 0
  }, w = {
    isSnap: !1,
    offset: 0,
    pos: 0
  };
  if (b === 0 && y === 0)
    return {
      vertical: C,
      horizontal: w
    };
  var S = checkMoveableSnapPoses(a, b ? [d] : [], y ? [p] : [], [], [], void 0, void 0), $ = S.vertical, T = S.horizontal;
  $.posInfos.filter(function(k) {
    var N = k.pos;
    return m ? N >= A : N <= A;
  }), T.posInfos.filter(function(k) {
    var N = k.pos;
    return f ? N >= x : N <= x;
  }), $.isSnap = $.posInfos.length > 0, T.isSnap = T.posInfos.length > 0;
  var I = getNearestSnapGuidelineInfo($), _ = I.isSnap, E = I.guideline, R = getNearestSnapGuidelineInfo(T), O = R.isSnap, L = R.guideline, B = O ? L.pos[1] : 0, F = _ ? E.pos[0] : 0;
  if (b === 0)
    O && (w.isSnap = !0, w.pos = L.pos[1], w.offset = p - w.pos);
  else if (y === 0)
    _ && (C.isSnap = !0, C.pos = F, C.offset = d - F);
  else {
    var M = y / b, W = c[1] - M * d, j = 0, G = 0, U = !1;
    _ ? (G = F, j = M * G + W, U = !0) : O && (j = B, G = (j - W) / M, U = !0), U && (C.isSnap = !0, C.pos = G, C.offset = d - G, w.isSnap = !0, w.pos = j, w.offset = p - j);
  }
  return {
    vertical: C,
    horizontal: w
  };
}
function getStringDirection(a) {
  var s = "";
  return a === -1 || a === "top" || a === "left" ? s = "start" : a === 0 || a === "center" || a === "middle" ? s = "center" : (a === 1 || a === "right" || a === "bottom") && (s = "end"), s;
}
function checkSnaps(a, s, c, u) {
  var d = splitSnapDirectionPoses(a.props.snapDirections, s), p = checkMoveableSnapPoses(a, d.vertical, d.horizontal, d.verticalNames.map(function(x) {
    return getStringDirection(x);
  }), d.horizontalNames.map(function(x) {
    return getStringDirection(x);
  }), c, u), v = getStringDirection(d.horizontalNames[p.horizontal.index]), A = getStringDirection(d.verticalNames[p.vertical.index]);
  return {
    vertical: __assign$1(__assign$1({}, p.vertical), { direction: A }),
    horizontal: __assign$1(__assign$1({}, p.horizontal), { direction: v })
  };
}
function getNearestSnapGuidelineInfo(a) {
  var s = a.isSnap;
  if (!s)
    return {
      isSnap: !1,
      offset: 0,
      dist: -1,
      pos: 0,
      guideline: null
    };
  var c = a.posInfos[0], u = c.guidelineInfos[0], d = u.offset, p = u.dist, v = u.guideline;
  return {
    isSnap: s,
    offset: d,
    dist: p,
    pos: c.pos,
    guideline: v
  };
}
function checkSnap(a, s, c, u, d) {
  var p, v;
  if (d === void 0 && (d = []), !a || !a.length)
    return {
      isSnap: !1,
      index: -1,
      direction: "",
      posInfos: []
    };
  var A = s === "vertical", x = A ? 0 : 1, g = c.map(function(y, f) {
    var m = d[f] || "", C = a.map(function(w) {
      var S = w.pos, $ = y - S[x];
      return {
        offset: $,
        dist: abs($),
        guideline: w,
        direction: m
      };
    }).filter(function(w) {
      var S = w.guideline, $ = w.dist, T = S.type;
      return !(T !== s || $ > u);
    }).sort(function(w, S) {
      return w.dist - S.dist;
    });
    return {
      pos: y,
      index: f,
      guidelineInfos: C,
      direction: m
    };
  }).filter(function(y) {
    return y.guidelineInfos.length > 0;
  }).sort(function(y, f) {
    return y.guidelineInfos[0].dist - f.guidelineInfos[0].dist;
  }), b = g.length > 0;
  return {
    isSnap: b,
    index: b ? g[0].index : -1,
    direction: (v = (p = g[0]) === null || p === void 0 ? void 0 : p.direction) !== null && v !== void 0 ? v : "",
    posInfos: g
  };
}
function getSnapInfosByDirection(a, s, c, u, d) {
  var p = [];
  c[0] && c[1] ? p = [
    c,
    [-c[0], c[1]],
    [c[0], -c[1]]
  ] : !c[0] && !c[1] ? [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ].forEach(function(f, m, C) {
    var w = C[m + 1] || C[0];
    p.push(f), p.push([
      (f[0] + w[0]) / 2,
      (f[1] + w[1]) / 2
    ]);
  }) : a.props.keepRatio ? p.push([-1, -1], [-1, 1], [1, -1], [1, 1], c) : (p.push.apply(p, __spreadArray$1([], __read(getPosesByDirection([
    [-1, -1],
    [1, -1],
    [-1, -1],
    [1, 1]
  ], c)), !1)), p.length > 1 && p.push([
    (p[0][0] + p[1][0]) / 2,
    (p[0][1] + p[1][1]) / 2
  ]));
  var v = p.map(function(f) {
    return getPosByDirection(s, f);
  }), A = v.map(function(f) {
    return f[0];
  }), x = v.map(function(f) {
    return f[1];
  }), g = checkMoveableSnapPoses(a, A, x, p.map(function(f) {
    return getStringDirection(f[0]);
  }), p.map(function(f) {
    return getStringDirection(f[1]);
  }), u, d), b = getStringDirection(p.map(function(f) {
    return f[0];
  })[g.vertical.index]), y = getStringDirection(p.map(function(f) {
    return f[1];
  })[g.horizontal.index]);
  return {
    vertical: __assign$1(__assign$1({}, g.vertical), { direction: b }),
    horizontal: __assign$1(__assign$1({}, g.horizontal), { direction: y })
  };
}
function checkSnapBoundPriority(a, s) {
  var c = abs(a.offset), u = abs(s.offset);
  return a.isBound && s.isBound ? u - c : a.isBound ? -1 : s.isBound ? 1 : a.isSnap && s.isSnap ? u - c : a.isSnap ? -1 : s.isSnap || c < TINY_NUM ? 1 : u < TINY_NUM ? -1 : c - u;
}
function getNearOffsetInfo(a, s) {
  return a.slice().sort(function(c, u) {
    var d = c.sign[s], p = u.sign[s], v = c.offset[s], A = u.offset[s];
    if (d) {
      if (!p)
        return -1;
    } else return 1;
    return checkSnapBoundPriority({ isBound: c.isBound, isSnap: c.isSnap, offset: v }, { isBound: u.isBound, isSnap: u.isSnap, offset: A });
  })[0];
}
function getCheckSnapDirections(a, s, c) {
  var u = [];
  if (c)
    abs(s[0]) !== 1 || abs(s[1]) !== 1 ? u.push([s, [-1, -1]], [s, [-1, 1]], [s, [1, -1]], [s, [1, 1]]) : u.push([s, [a[0], -a[1]]], [s, [-a[0], a[1]]]), u.push([s, a]);
  else if (a[0] && a[1] || !a[0] && !a[1]) {
    var d = a[0] ? a : [1, 1];
    [1, -1].forEach(function(v) {
      [1, -1].forEach(function(A) {
        var x = [v * d[0], A * d[1]];
        s[0] === x[0] && s[1] === x[1] || u.push([s, x]);
      });
    });
  } else if (a[0]) {
    var p = abs(s[0]) === 1 ? [1] : [1, -1];
    p.forEach(function(v) {
      u.push([
        [s[0], -1],
        [v * a[0], -1]
      ], [
        [s[0], 0],
        [v * a[0], 0]
      ], [
        [s[0], 1],
        [v * a[0], 1]
      ]);
    });
  } else if (a[1]) {
    var p = abs(s[1]) === 1 ? [1] : [1, -1];
    p.forEach(function(A) {
      u.push([
        [-1, s[1]],
        [-1, A * a[1]]
      ], [
        [0, s[1]],
        [0, A * a[1]]
      ], [
        [1, s[1]],
        [1, A * a[1]]
      ]);
    });
  }
  return u;
}
function isStartLine(a, s) {
  var c = average([s[0][0], s[1][0]]), u = average([s[0][1], s[1][1]]);
  return {
    vertical: c <= a[0],
    horizontal: u <= a[1]
  };
}
function hitTestLine(a, s) {
  var c = __read(s, 2), u = c[0], d = c[1], p = d[0] - u[0], v = d[1] - u[1];
  abs(p) < TINY_NUM && (p = 0), abs(v) < TINY_NUM && (v = 0);
  var A, x;
  if (!p)
    A = u[0], x = a[0];
  else if (!v)
    A = u[1], x = a[1];
  else {
    var g = v / p;
    A = g * (a[0] - u[0]) + u[1], x = a[1];
  }
  return A - x;
}
function isSameStartLine(a, s, c, u) {
  return u === void 0 && (u = TINY_NUM), a.every(function(d) {
    var p = hitTestLine(d, s), v = p <= 0;
    return v === c || abs(p) <= u;
  });
}
function checkInnerBoundDot(a, s, c, u, d) {
  return d === void 0 && (d = 0), u && s - d <= a || !u && a <= c + d ? {
    isBound: !0,
    offset: u ? s - a : c - a
  } : {
    isBound: !1,
    offset: 0
  };
}
function checkInnerBound(a, s) {
  var c = s.line, u = s.centerSign, d = s.verticalSign, p = s.horizontalSign, v = s.lineConstants, A = a.props.innerBounds;
  if (!A)
    return {
      isAllBound: !1,
      isBound: !1,
      isVerticalBound: !1,
      isHorizontalBound: !1,
      offset: [0, 0]
    };
  var x = A.left, g = A.top, b = A.width, y = A.height, f = [[x, g], [x, g + y]], m = [[x, g], [x + b, g]], C = [[x + b, g], [x + b, g + y]], w = [[x, g + y], [x + b, g + y]];
  if (isSameStartLine([
    [x, g],
    [x + b, g],
    [x, g + y],
    [x + b, g + y]
  ], c, u))
    return {
      isAllBound: !1,
      isBound: !1,
      isVerticalBound: !1,
      isHorizontalBound: !1,
      offset: [0, 0]
    };
  var S = checkLineBoundCollision(c, v, m, d), $ = checkLineBoundCollision(c, v, w, d), T = checkLineBoundCollision(c, v, f, p), I = checkLineBoundCollision(c, v, C, p), _ = S.isBound && $.isBound, E = S.isBound || $.isBound, R = T.isBound && I.isBound, O = T.isBound || I.isBound, L = maxOffset(S.offset, $.offset), B = maxOffset(T.offset, I.offset), F = [0, 0], M = !1, W = !1;
  return abs(B) < abs(L) ? (F = [L, 0], M = E, W = _) : (F = [0, B], M = O, W = R), {
    isAllBound: W,
    isVerticalBound: E,
    isHorizontalBound: O,
    isBound: M,
    offset: F
  };
}
function checkLineBoundCollision(a, s, c, u, d, p) {
  var v = __read(s, 2), A = v[0], x = v[1], g = a[0], b = c[0], y = c[1], f = getTinyDist(y[1] - b[1]), m = getTinyDist(y[0] - b[0]), C = x, w = A, S = -A / x;
  if (m) {
    if (!f) {
      if (p && !C)
        return {
          isBound: !1,
          offset: 0
        };
      if (w) {
        var _ = (b[1] - g[1]) / S + g[0];
        return checkInnerBoundDot(_, b[0], y[0], u, d);
      } else {
        var T = b[1] - g[1], I = abs(T) <= (d || 0);
        return {
          isBound: I,
          offset: I ? T : 0
        };
      }
    }
  } else {
    if (p && !w)
      return {
        isBound: !1,
        offset: 0
      };
    if (C) {
      var $ = S * (b[0] - g[0]) + g[1];
      return checkInnerBoundDot($, b[1], y[1], u, d);
    } else {
      var T = b[0] - g[0], I = abs(T) <= (d || 0);
      return {
        isBound: I,
        offset: I ? T : 0
      };
    }
  }
  return {
    isBound: !1,
    offset: 0
  };
}
function getInnerBoundInfo(a, s, c) {
  return s.map(function(u) {
    var d = checkInnerBound(a, u), p = d.isBound, v = d.offset, A = d.isVerticalBound, x = d.isHorizontalBound, g = u.multiple, b = getDragDist({
      datas: c,
      distX: v[0],
      distY: v[1]
    }).map(function(y, f) {
      return y * (g[f] ? 2 / g[f] : 0);
    });
    return {
      sign: g,
      isBound: p,
      isVerticalBound: A,
      isHorizontalBound: x,
      isSnap: !1,
      offset: b
    };
  });
}
function getInnerBoundDragInfo(a, s, c) {
  var u, d = getCheckInnerBoundLineInfos(a, s, [0, 0], !1).map(function(f) {
    return __assign$1(__assign$1({}, f), { multiple: f.multiple.map(function(m) {
      return abs(m) * 2;
    }) });
  }), p = getInnerBoundInfo(a, d, c), v = getNearOffsetInfo(p, 0), A = getNearOffsetInfo(p, 1), x = 0, g = 0, b = v.isVerticalBound || A.isVerticalBound, y = v.isHorizontalBound || A.isHorizontalBound;
  return (b || y) && (u = __read(getInverseDragDist({
    datas: c,
    distX: -v.offset[0],
    distY: -A.offset[1]
  }), 2), x = u[0], g = u[1]), {
    vertical: {
      isBound: b,
      offset: x
    },
    horizontal: {
      isBound: y,
      offset: g
    }
  };
}
function getCheckSnapLineDirections(a, s) {
  var c = [], u = a[0], d = a[1];
  return u && d ? c.push([[0, d * 2], a, [-u, d]], [[u * 2, 0], a, [u, -d]]) : u ? (c.push([[u * 2, 0], [u, 1], [u, -1]]), s && c.push([[0, -1], [u, -1], [-u, -1]], [[0, 1], [u, 1], [-u, 1]])) : d ? (c.push([[0, d * 2], [1, d], [-1, d]]), s && c.push([[-1, 0], [-1, d], [-1, -d]], [[1, 0], [1, d], [1, -d]])) : c.push([[-1, 0], [-1, -1], [-1, 1]], [[1, 0], [1, -1], [1, 1]], [[0, -1], [-1, -1], [1, -1]], [[0, 1], [-1, 1], [1, 1]]), c;
}
function getCheckInnerBoundLineInfos(a, s, c, u) {
  var d = a.state, p = d.allMatrix, v = d.is3d, A = calculatePoses(p, 100, 100, v ? 4 : 3), x = getPosByDirection(A, [0, 0]);
  return getCheckSnapLineDirections(c, u).map(function(g) {
    var b = __read(g, 3), y = b[0], f = b[1], m = b[2], C = [
      getPosByDirection(A, f),
      getPosByDirection(A, m)
    ], w = solveLineConstants(C), S = isStartLine(x, C), $ = S.vertical, T = S.horizontal, I = hitTestLine(x, C) <= 0;
    return {
      multiple: y,
      centerSign: I,
      verticalSign: $,
      horizontalSign: T,
      lineConstants: w,
      line: [
        getPosByDirection(s, f),
        getPosByDirection(s, m)
      ]
    };
  });
}
function isBoundRotate(a, s, c, u) {
  var d = u ? a.map(function(p) {
    return rotate(p, u);
  }) : a;
  return [
    [d[0], d[1]],
    [d[1], d[3]],
    [d[3], d[2]],
    [d[2], d[0]]
  ].some(function(p) {
    var v = hitTestLine(c, p) <= 0;
    return !isSameStartLine(s, p, v);
  });
}
function getDistPointLine(a) {
  var s = __read(a, 2), c = s[0], u = s[1], d = u[0] - c[0], p = u[1] - c[1];
  if (!d)
    return abs(c[0]);
  if (!p)
    return abs(c[1]);
  var v = p / d;
  return abs((-v * c[0] + c[1]) / Math.sqrt(Math.pow(v, 2) + 1));
}
function solveReverseLine(a) {
  var s = __read(a, 2), c = s[0], u = s[1], d = u[0] - c[0], p = u[1] - c[1];
  if (!d)
    return [c[0], 0];
  if (!p)
    return [0, c[1]];
  var v = p / d, A = -v * c[0] + c[1];
  return [
    -A / (v + 1 / v),
    A / (v * v + 1)
  ];
}
function checkRotateInnerBounds(a, s, c, u, d) {
  var p = a.props.innerBounds, v = d * Math.PI / 180;
  if (!p)
    return [];
  var A = p.left, x = p.top, g = p.width, b = p.height, y = A - u[0], f = A + g - u[0], m = x - u[1], C = x + b - u[1], w = [
    [y, m],
    [f, m],
    [y, C],
    [f, C]
  ], S = getPosByDirection(c, [0, 0]);
  if (!isBoundRotate(c, w, S, 0))
    return [];
  var $ = [], T = w.map(function(I) {
    return [
      getDistSize(I),
      getRad$1([0, 0], I)
    ];
  });
  return [
    [c[0], c[1]],
    [c[1], c[3]],
    [c[3], c[2]],
    [c[2], c[0]]
  ].forEach(function(I) {
    var _ = getRad$1([0, 0], solveReverseLine(I)), E = getDistPointLine(I);
    $.push.apply($, __spreadArray$1([], __read(T.filter(function(R) {
      var O = __read(R, 1), L = O[0];
      return L && E <= L;
    }).map(function(R) {
      var O = __read(R, 2), L = O[0], B = O[1], F = Math.acos(L ? E / L : 0), M = B + F, W = B - F;
      return [
        v + M - _,
        v + W - _
      ];
    }).reduce(function(R, O) {
      return R.push.apply(R, __spreadArray$1([], __read(O), !1)), R;
    }, []).filter(function(R) {
      return !isBoundRotate(s, w, S, R);
    }).map(function(R) {
      return throttle(R * 180 / Math.PI, TINY_NUM);
    })), !1));
  }), $;
}
function checkInnerBoundPoses(a) {
  var s = a.props.innerBounds, c = getInitialBounds();
  if (!s)
    return {
      boundMap: c,
      vertical: [],
      horizontal: []
    };
  var u = a.getRect(), d = u.pos1, p = u.pos2, v = u.pos3, A = u.pos4, x = [d, p, v, A], g = getPosByDirection(x, [0, 0]), b = s.left, y = s.top, f = s.width, m = s.height, C = [[b, y], [b, y + m]], w = [[b, y], [b + f, y]], S = [[b + f, y], [b + f, y + m]], $ = [[b, y + m], [b + f, y + m]], T = getCheckInnerBoundLineInfos(a, x, [0, 0], !1), I = [], _ = [];
  return T.forEach(function(E) {
    var R = E.line, O = E.lineConstants, L = isStartLine(g, R), B = L.horizontal, F = L.vertical, M = checkLineBoundCollision(R, O, w, F, 1, !0), W = checkLineBoundCollision(R, O, $, F, 1, !0), j = checkLineBoundCollision(R, O, C, B, 1, !0), G = checkLineBoundCollision(R, O, S, B, 1, !0);
    M.isBound && !c.top && (I.push(y), c.top = !0), W.isBound && !c.bottom && (I.push(y + m), c.bottom = !0), j.isBound && !c.left && (_.push(b), c.left = !0), G.isBound && !c.right && (_.push(b + f), c.right = !0);
  }), {
    boundMap: c,
    horizontal: I,
    vertical: _
  };
}
function solveEquation(a, s, c, u) {
  var d = s[0] - a[0], p = s[1] - a[1];
  if (abs(d) < TINY_NUM$1 && (d = 0), abs(p) < TINY_NUM$1 && (p = 0), !d)
    return u ? [0, 0] : [0, c];
  if (!p)
    return u ? [c, 0] : [0, 0];
  var v = p / d, A = a[1] - v * a[0];
  if (u) {
    var x = v * (s[0] + c) + A;
    return [c, x - s[1]];
  } else {
    var g = (s[1] + c - A) / v;
    return [g - s[0], c];
  }
}
function solveNextOffset(a, s, c, u, d) {
  var p = solveEquation(a, s, c, u);
  if (!p)
    return {
      isOutside: !1,
      offset: [0, 0]
    };
  var v = getDist$2(a, s), A = getDist$2(p, a), x = getDist$2(p, s), g = A > v || x > v, b = __read(getDragDist({
    datas: d,
    distX: p[0],
    distY: p[1]
  }), 2), y = b[0], f = b[1];
  return {
    offset: [y, f],
    isOutside: g
  };
}
function getSnapBound(a, s) {
  return a.isBound ? a.offset : s.isSnap ? getNearestSnapGuidelineInfo(s).offset : 0;
}
function checkThrottleDragRotate(a, s, c, u, d) {
  var p = __read(s, 2), v = p[0], A = p[1], x = __read(c, 2), g = x[0], b = x[1], y = __read(u, 2), f = y[0], m = y[1], C = __read(d, 2), w = C[0], S = C[1], $ = -w, T = -S;
  if (a && v && A) {
    $ = 0, T = 0;
    var I = [];
    if (g && b ? I.push([0, S], [w, 0]) : g ? I.push([w, 0]) : b ? I.push([0, S]) : f && m ? I.push([0, S], [w, 0]) : f ? I.push([w, 0]) : m && I.push([0, S]), I.length) {
      I.sort(function(O, L) {
        return getDistSize(minus([v, A], O)) - getDistSize(minus([v, A], L));
      });
      var _ = I[0];
      if (_[0] && abs(v) > TINY_NUM$1)
        $ = -_[0], T = A * abs(v + $) / abs(v) - A;
      else if (_[1] && abs(A) > TINY_NUM$1) {
        var E = A;
        T = -_[1], $ = v * abs(A + T) / abs(E) - v;
      }
      if (a && b && g)
        if (abs($) > TINY_NUM$1 && abs($) < abs(w)) {
          var R = abs(w) / abs($);
          $ *= R, T *= R;
        } else if (abs(T) > TINY_NUM$1 && abs(T) < abs(S)) {
          var R = abs(S) / abs(T);
          $ *= R, T *= R;
        } else
          $ = maxOffset(-w, $), T = maxOffset(-S, T);
    }
  } else
    $ = v || g ? -w : 0, T = A || b ? -S : 0;
  return [$, T];
}
function checkSnapBoundsDrag(a, s, c, u, d, p) {
  if (!hasGuidelines(a, "draggable"))
    return [
      {
        isSnap: !1,
        isBound: !1,
        offset: 0
      },
      {
        isSnap: !1,
        isBound: !1,
        offset: 0
      }
    ];
  var v = getAbsolutePoses(p.absolutePoses, [s, c]), A = getRect(v), x = A.left, g = A.right, b = A.top, y = A.bottom, f = {
    horizontal: v.map(function(G) {
      return G[1];
    }),
    vertical: v.map(function(G) {
      return G[0];
    })
  }, m = getSnapDirections(a.props.snapDirections), C = splitSnapDirectionPoses(m, {
    left: x,
    right: g,
    top: b,
    bottom: y,
    center: (x + g) / 2,
    middle: (b + y) / 2
  }), w = checkMoveableSnapBounds(a, d, C, f), S = w.vertical, $ = w.horizontal, T = getInnerBoundDragInfo(a, v, p), I = T.vertical, _ = T.horizontal, E = S.isSnap, R = $.isSnap, O = S.isBound || I.isBound, L = $.isBound || _.isBound, B = maxOffset(S.offset, I.offset), F = maxOffset($.offset, _.offset), M = __read(checkThrottleDragRotate(u, [s, c], [O, L], [E, R], [B, F]), 2), W = M[0], j = M[1];
  return [
    {
      isBound: O,
      isSnap: E,
      offset: W
    },
    {
      isBound: L,
      isSnap: R,
      offset: j
    }
  ];
}
function checkMoveableSnapBounds(a, s, c, u) {
  u === void 0 && (u = c);
  var d = checkBoundPoses(getBounds(a), u.vertical, u.horizontal), p = d.horizontal, v = d.vertical, A = s ? {
    horizontal: { isSnap: !1, index: -1 },
    vertical: { isSnap: !1, index: -1 }
  } : checkMoveableSnapPoses(a, c.vertical, c.horizontal, void 0, void 0, void 0, void 0), x = A.horizontal, g = A.vertical, b = getSnapBound(p[0], x), y = getSnapBound(v[0], g), f = abs(b), m = abs(y);
  return {
    horizontal: {
      isBound: p[0].isBound,
      isSnap: x.isSnap,
      snapIndex: x.index,
      offset: b,
      dist: f,
      bounds: p,
      snap: x
    },
    vertical: {
      isBound: v[0].isBound,
      isSnap: g.isSnap,
      snapIndex: g.index,
      offset: y,
      dist: m,
      bounds: v,
      snap: g
    }
  };
}
function checkSnapBounds(a, s, c, u, d, p, v) {
  v === void 0 && (v = [1, 1]);
  var A = checkBoundPoses(s, c, u), x = A.horizontal, g = A.vertical, b = checkSnapPoses(a, c, u, [], [], d, p, v), y = b.horizontal, f = b.vertical, m = getSnapBound(x[0], y), C = getSnapBound(g[0], f), w = abs(m), S = abs(C);
  return {
    horizontal: {
      isBound: x[0].isBound,
      isSnap: y.isSnap,
      snapIndex: y.index,
      offset: m,
      dist: w,
      bounds: x,
      snap: y
    },
    vertical: {
      isBound: g[0].isBound,
      isSnap: f.isSnap,
      snapIndex: f.index,
      offset: C,
      dist: S,
      bounds: g,
      snap: f
    }
  };
}
function checkSnapRightLine(a, s, c, u) {
  var d = getRad$1(a, s) / Math.PI * 180, p = c.vertical, v = p.isBound, A = p.isSnap, x = p.dist, g = c.horizontal, b = g.isBound, y = g.isSnap, f = g.dist, m = d % 180, C = m < 3 || m > 177, w = m > 87 && m < 93;
  return f < x && (v || A && !w && (!u || !C)) ? "vertical" : b || y && !C && (!u || !w) ? "horizontal" : "";
}
function getSnapBoundInfo(a, s, c, u, d, p) {
  return c.map(function(v) {
    var A = __read(v, 2), x = A[0], g = A[1], b = getPosByDirection(s, x), y = getPosByDirection(s, g), f = u ? checkSnapBoundsKeepRatio(a, b, y, d) : checkMoveableSnapBounds(a, d, {
      vertical: [y[0]],
      horizontal: [y[1]]
    }), m = f.horizontal, C = m.offset, w = m.isBound, S = m.isSnap, $ = f.vertical, T = $.offset, I = $.isBound, _ = $.isSnap, E = minus(g, x);
    if (!T && !C)
      return {
        isBound: I || w,
        isSnap: _ || S,
        sign: E,
        offset: [0, 0]
      };
    var R = checkSnapRightLine(b, y, f, u);
    if (!R)
      return {
        sign: E,
        isBound: !1,
        isSnap: !1,
        offset: [0, 0]
      };
    var O = R === "vertical", L = [0, 0];
    return !u && abs(g[0]) === 1 && abs(g[1]) === 1 && x[0] !== g[0] && x[1] !== g[1] ? L = getDragDist({
      datas: p,
      distX: -T,
      distY: -C
    }) : L = solveNextOffset(b, y, -(O ? T : C), O, p).offset, L = L.map(function(B, F) {
      return B * (E[F] ? 2 / E[F] : 0);
    }), {
      sign: E,
      isBound: O ? I : w,
      isSnap: O ? _ : S,
      offset: L
    };
  });
}
function getSnapBoundOffset(a, s) {
  return a.isBound ? a.offset : s.isSnap ? s.offset : 0;
}
function checkSnapBoundsKeepRatio(a, s, c, u) {
  var d = checkBoundKeepRatio(a, s, c), p = d.horizontal, v = d.vertical, A = u ? {
    horizontal: { isSnap: !1 },
    vertical: { isSnap: !1 }
  } : checkSnapKeepRatio(a, s, c), x = A.horizontal, g = A.vertical, b = getSnapBoundOffset(p, x), y = getSnapBoundOffset(v, g), f = abs(b), m = abs(y);
  return {
    horizontal: {
      isBound: p.isBound,
      isSnap: x.isSnap,
      offset: b,
      dist: f
    },
    vertical: {
      isBound: v.isBound,
      isSnap: g.isSnap,
      offset: y,
      dist: m
    }
  };
}
function checkMaxBounds(a, s, c, u, d) {
  var p = [-c[0], -c[1]], v = a.state, A = v.width, x = v.height, g = a.props.bounds, b = 1 / 0, y = 1 / 0;
  if (g) {
    var f = [
      [c[0], -c[1]],
      [-c[0], c[1]]
    ], m = g.left, C = m === void 0 ? -1 / 0 : m, w = g.top, S = w === void 0 ? -1 / 0 : w, $ = g.right, T = $ === void 0 ? 1 / 0 : $, I = g.bottom, _ = I === void 0 ? 1 / 0 : I;
    f.forEach(function(E) {
      var R = E[0] !== p[0], O = E[1] !== p[1], L = getPosByDirection(s, E), B = getRad$1(u, L) * 360 / Math.PI;
      if (O) {
        var F = L.slice();
        (abs(B - 360) < 2 || abs(B - 180) < 2) && (F[1] = u[1]);
        var M = solveNextOffset(u, F, (u[1] < L[1] ? _ : S) - L[1], !1, d), W = __read(M.offset, 2), j = W[1], G = M.isOutside;
        isNaN(j) || (y = x + (G ? 1 : -1) * abs(j));
      }
      if (R) {
        var F = L.slice();
        (abs(B - 90) < 2 || abs(B - 270) < 2) && (F[0] = u[0]);
        var U = solveNextOffset(u, F, (u[0] < L[0] ? T : C) - L[0], !0, d), k = __read(U.offset, 1), N = k[0], P = U.isOutside;
        isNaN(N) || (b = A + (P ? 1 : -1) * abs(N));
      }
    });
  }
  return {
    maxWidth: b,
    maxHeight: y
  };
}
var Draggable = {
  name: "draggable",
  props: [
    "draggable",
    "throttleDrag",
    "throttleDragRotate",
    "hideThrottleDragRotateLine",
    "startDragRotate",
    "edgeDraggable"
  ],
  events: [
    "dragStart",
    "drag",
    "dragEnd",
    "dragGroupStart",
    "dragGroup",
    "dragGroupEnd"
  ],
  requestStyle: function() {
    return ["left", "top", "right", "bottom"];
  },
  requestChildStyle: function() {
    return ["left", "top", "right", "bottom"];
  },
  render: function(a, s) {
    var c = a.props, u = c.hideThrottleDragRotateLine, d = c.throttleDragRotate, p = c.zoom, v = a.getState(), A = v.dragInfo, x = v.beforeOrigin;
    if (u || !d || !A)
      return [];
    var g = A.dist;
    if (!g[0] && !g[1])
      return [];
    var b = getDistSize(g), y = getRad$1(g, [0, 0]);
    return [s.createElement("div", { className: prefix$1("line", "horizontal", "dragline", "dashed"), key: "dragRotateGuideline", style: {
      width: "".concat(b, "px"),
      transform: "translate(".concat(x[0], "px, ").concat(x[1], "px) rotate(").concat(y, "rad) scaleY(").concat(p, ")")
    } })];
  },
  dragStart: function(a, s) {
    var c = s.datas, u = s.parentEvent, d = s.parentGesto, p = a.state, v = p.gestos, A = p.style;
    if (v.draggable)
      return !1;
    v.draggable = d || a.targetGesto, c.datas = {}, c.left = parseFloat(A.left || "") || 0, c.top = parseFloat(A.top || "") || 0, c.bottom = parseFloat(A.bottom || "") || 0, c.right = parseFloat(A.right || "") || 0, c.startValue = [0, 0], setDragStart(a, s), setDefaultTransformIndex(a, s, "translate"), startCheckSnapDrag(a, c), c.prevDist = [0, 0], c.prevBeforeDist = [0, 0], c.isDrag = !1, c.deltaOffset = [0, 0];
    var x = fillParams(a, s, __assign$1({ set: function(b) {
      c.startValue = b;
    } }, fillTransformStartEvent(a, s))), g = u || triggerEvent(a, "onDragStart", x);
    return g !== !1 ? (c.isDrag = !0, a.state.dragInfo = {
      startRect: a.getRect(),
      dist: [0, 0]
    }) : (v.draggable = null, c.isPinch = !1), c.isDrag ? x : !1;
  },
  drag: function(a, s) {
    if (s) {
      resolveTransformEvent(a, s, "translate");
      var c = s.datas, u = s.parentEvent, d = s.parentFlag, p = s.isPinch, v = s.deltaOffset, A = s.useSnap, x = s.isRequest, g = s.isGroup, b = s.parentThrottleDrag, y = s.distX, f = s.distY, m = c.isDrag, C = c.prevDist, w = c.prevBeforeDist, S = c.startValue;
      if (m) {
        v && (y += v[0], f += v[1]);
        var $ = a.props, T = $.parentMoveable, I = g ? 0 : $.throttleDrag || b || 0, _ = u ? 0 : $.throttleDragRotate || 0, E = 0, R = !1, O = !1, L = !1, B = !1;
        if (!u && _ > 0 && (y || f)) {
          var F = $.startDragRotate || 0, M = throttle(F + getRad$1([0, 0], [y, f]) * 180 / Math.PI, _) - F, W = f * Math.abs(Math.cos((M - 90) / 180 * Math.PI)), j = y * Math.abs(Math.cos(M / 180 * Math.PI)), G = getDistSize([j, W]);
          E = M * Math.PI / 180, y = G * Math.cos(E), f = G * Math.sin(E);
        }
        if (!p && !u && !d) {
          var U = __read(checkSnapBoundsDrag(a, y, f, _, !A && x || v, c), 2), k = U[0], N = U[1];
          R = k.isSnap, O = k.isBound, L = N.isSnap, B = N.isBound;
          var P = k.offset, D = N.offset;
          y += P, f += D;
        }
        var H = plus(getBeforeDragDist({ datas: c, distX: y, distY: f }), S), V = plus(getTransformDist({ datas: c, distX: y, distY: f }), S);
        throttleArray(V, TINY_NUM), throttleArray(H, TINY_NUM), _ || (!R && !O && (V[0] = throttle(V[0], I), H[0] = throttle(H[0], I)), !L && !B && (V[1] = throttle(V[1], I), H[1] = throttle(H[1], I)));
        var Z = minus(H, S), ne = minus(V, S), K = minus(ne, C), q = minus(Z, w);
        c.prevDist = ne, c.prevBeforeDist = Z, c.passDelta = K, c.passDist = ne;
        var Y = c.left + Z[0], ee = c.top + Z[1], Q = c.right - Z[0], J = c.bottom - Z[1], te = convertTransformFormat(c, "translate(".concat(V[0], "px, ").concat(V[1], "px)"), "translate(".concat(ne[0], "px, ").concat(ne[1], "px)"));
        if (fillOriginalTransform(s, te), a.state.dragInfo.dist = u ? [0, 0] : ne, !(!u && !T && K.every(function(ge) {
          return !ge;
        }) && q.some(function(ge) {
          return !ge;
        }))) {
          var ae = a.state, se = ae.width, ie = ae.height, fe = fillParams(a, s, __assign$1({ transform: te, dist: ne, delta: K, translate: V, beforeDist: Z, beforeDelta: q, beforeTranslate: H, left: Y, top: ee, right: Q, bottom: J, width: se, height: ie, isPinch: p }, fillCSSObject({
            transform: te
          }, s)));
          return !u && triggerEvent(a, "onDrag", fe), fe;
        }
      }
    }
  },
  dragAfter: function(a, s) {
    var c = s.datas, u = c.deltaOffset;
    return u[0] || u[1] ? (c.deltaOffset = [0, 0], this.drag(a, __assign$1(__assign$1({}, s), { deltaOffset: u }))) : !1;
  },
  dragEnd: function(a, s) {
    var c = s.parentEvent, u = s.datas;
    if (a.state.dragInfo = null, !!u.isDrag) {
      u.isDrag = !1;
      var d = fillEndParams(a, s, {});
      return !c && triggerEvent(a, "onDragEnd", d), d;
    }
  },
  dragGroupStart: function(a, s) {
    var c, u, d = s.datas, p = s.clientX, v = s.clientY, A = this.dragStart(a, s);
    if (!A)
      return !1;
    var x = triggerChildGesto(a, this, "dragStart", [
      p || 0,
      v || 0
    ], s, !1, "draggable"), g = x.childEvents, b = x.eventParams, y = __assign$1(__assign$1({}, A), { targets: a.props.targets, events: b }), f = triggerEvent(a, "onDragGroupStart", y);
    d.isDrag = f !== !1;
    var m = (u = (c = g[0]) === null || c === void 0 ? void 0 : c.datas.startValue) !== null && u !== void 0 ? u : [0, 0];
    return d.throttleOffset = [m[0] % 1, m[1] % 1], d.isDrag ? A : !1;
  },
  dragGroup: function(a, s) {
    var c = s.datas;
    if (c.isDrag) {
      var u = this.drag(a, __assign$1(__assign$1({}, s), { parentThrottleDrag: a.props.throttleDrag })), d = s.datas.passDelta, p = triggerChildGesto(a, this, "drag", d, s, !1, "draggable").eventParams;
      if (u) {
        var v = __assign$1({ targets: a.props.targets, events: p }, u);
        return triggerEvent(a, "onDragGroup", v), v;
      }
    }
  },
  dragGroupEnd: function(a, s) {
    var c = s.isDrag, u = s.datas;
    if (u.isDrag) {
      this.dragEnd(a, s);
      var d = triggerChildGesto(a, this, "dragEnd", [0, 0], s, !1, "draggable").eventParams;
      return triggerEvent(a, "onDragGroupEnd", fillEndParams(a, s, {
        targets: a.props.targets,
        events: d
      })), c;
    }
  },
  /**
       * @method Moveable.Draggable#request
       * @param {object} [e] - the draggable's request parameter
       * @param {number} [e.x] - x position
       * @param {number} [e.y] - y position
       * @param {number} [e.deltaX] - X number to move
       * @param {number} [e.deltaY] - Y number to move
       * @return {Moveable.Requester} Moveable Requester
       * @example
  
       * // Instantly Request (requestStart - request - requestEnd)
       * // Use Relative Value
       * moveable.request("draggable", { deltaX: 10, deltaY: 10 }, true);
       * // Use Absolute Value
       * moveable.request("draggable", { x: 200, y: 100 }, true);
       *
       * // requestStart
       * const requester = moveable.request("draggable");
       *
       * // request
       * // Use Relative Value
       * requester.request({ deltaX: 10, deltaY: 10 });
       * requester.request({ deltaX: 10, deltaY: 10 });
       * requester.request({ deltaX: 10, deltaY: 10 });
       * // Use Absolute Value
       * moveable.request("draggable", { x: 200, y: 100 });
       * moveable.request("draggable", { x: 220, y: 100 });
       * moveable.request("draggable", { x: 240, y: 100 });
       *
       * // requestEnd
       * requester.requestEnd();
       */
  request: function(a) {
    var s = {}, c = a.getRect(), u = 0, d = 0, p = !1;
    return {
      isControl: !1,
      requestStart: function(v) {
        return p = v.useSnap, { datas: s, useSnap: p };
      },
      request: function(v) {
        return "x" in v ? u = v.x - c.left : "deltaX" in v && (u += v.deltaX), "y" in v ? d = v.y - c.top : "deltaY" in v && (d += v.deltaY), { datas: s, distX: u, distY: d, useSnap: p };
      },
      requestEnd: function() {
        return { datas: s, isDrag: !0, useSnap: p };
      }
    };
  },
  unset: function(a) {
    a.state.gestos.draggable = null, a.state.dragInfo = null;
  }
};
function getFixedDirectionInfo(a, s) {
  var c = getPosByDirection(a, s), u = [0, 0];
  return {
    fixedPosition: c,
    fixedDirection: s,
    fixedOffset: u
  };
}
function getOffsetFixedDirectionInfo(a, s) {
  var c = a.allMatrix, u = a.is3d, d = a.width, p = a.height, v = u ? 4 : 3, A = [
    d / 2 * (1 + s[0]),
    p / 2 * (1 + s[1])
  ], x = calculatePosition(c, A, v), g = [0, 0];
  return {
    fixedPosition: x,
    fixedDirection: s,
    fixedOffset: g
  };
}
function getOffsetFixedPositionInfo(a, s) {
  var c = a.allMatrix, u = a.is3d, d = a.width, p = a.height, v = u ? 4 : 3, A = getDirectionByPos(s, d, p), x = calculatePosition(c, s, v), g = [
    d ? 0 : s[0],
    p ? 0 : s[1]
  ];
  return {
    fixedPosition: x,
    fixedDirection: A,
    fixedOffset: g
  };
}
var directionCondition$2 = getDirectionCondition("resizable"), Resizable = {
  name: "resizable",
  ableGroup: "size",
  canPinch: !0,
  props: [
    "resizable",
    "throttleResize",
    "renderDirections",
    "displayAroundControls",
    "keepRatio",
    "resizeFormat",
    "keepRatioFinally",
    "edge",
    "checkResizableError"
  ],
  events: [
    "resizeStart",
    "beforeResize",
    "resize",
    "resizeEnd",
    "resizeGroupStart",
    "beforeResizeGroup",
    "resizeGroup",
    "resizeGroupEnd"
  ],
  render: getRenderDirections("resizable"),
  dragControlCondition: directionCondition$2,
  viewClassName: getDirectionViewClassName("resizable"),
  dragControlStart: function(a, s) {
    var c, u = s.inputEvent, d = s.isPinch, p = s.isGroup, v = s.parentDirection, A = s.parentGesto, x = s.datas, g = s.parentFixedDirection, b = s.parentEvent, y = getTotalDirection(v, d, u, x), f = a.state, m = f.target, C = f.width, w = f.height, S = f.gestos;
    if (!y || !m || S.resizable)
      return !1;
    S.resizable = A || a.controlGesto, !d && setDragStart(a, s), x.datas = {}, x.direction = y, x.startOffsetWidth = C, x.startOffsetHeight = w, x.prevWidth = 0, x.prevHeight = 0, x.minSize = [0, 0], x.startWidth = f.inlineCSSWidth || f.cssWidth, x.startHeight = f.inlineCSSHeight || f.cssHeight, x.maxSize = [1 / 0, 1 / 0], p || (x.minSize = [
      f.minOffsetWidth,
      f.minOffsetHeight
    ], x.maxSize = [
      f.maxOffsetWidth,
      f.maxOffsetHeight
    ]);
    var $ = a.props.transformOrigin || "% %";
    x.transformOrigin = isString($) ? $.split(" ") : $, x.startOffsetMatrix = f.offsetMatrix, x.startTransformOrigin = f.transformOrigin, x.isWidth = (c = s?.parentIsWidth) !== null && c !== void 0 ? c : !y[0] && !y[1] || y[0] || !y[1];
    function T(B) {
      x.ratio = B && isFinite(B) ? B : 0;
    }
    x.startPositions = getAbsolutePosesByState(a.state);
    function I(B) {
      var F = getFixedDirectionInfo(x.startPositions, B);
      x.fixedDirection = F.fixedDirection, x.fixedPosition = F.fixedPosition, x.fixedOffset = F.fixedOffset;
    }
    function _(B) {
      var F = getOffsetFixedPositionInfo(a.state, B);
      x.fixedDirection = F.fixedDirection, x.fixedPosition = F.fixedPosition, x.fixedOffset = F.fixedOffset;
    }
    function E(B) {
      x.minSize = [
        convertUnitSize("".concat(B[0]), 0) || 0,
        convertUnitSize("".concat(B[1]), 0) || 0
      ];
    }
    function R(B) {
      var F = [
        B[0] || 1 / 0,
        B[1] || 1 / 0
      ];
      (!isNumber(F[0]) || isFinite(F[0])) && (F[0] = convertUnitSize("".concat(F[0]), 0) || 1 / 0), (!isNumber(F[1]) || isFinite(F[1])) && (F[1] = convertUnitSize("".concat(F[1]), 0) || 1 / 0), x.maxSize = F;
    }
    T(C / w), I(g || [-y[0], -y[1]]), x.setFixedDirection = I, x.setFixedPosition = _, x.setMin = E, x.setMax = R;
    var O = fillParams(a, s, {
      direction: y,
      startRatio: x.ratio,
      set: function(B) {
        var F = __read(B, 2), M = F[0], W = F[1];
        x.startWidth = M, x.startHeight = W;
      },
      setMin: E,
      setMax: R,
      setRatio: T,
      setFixedDirection: I,
      setFixedPosition: _,
      setOrigin: function(B) {
        x.transformOrigin = B;
      },
      dragStart: Draggable.dragStart(a, new CustomGesto().dragStart([0, 0], s))
    }), L = b || triggerEvent(a, "onResizeStart", O);
    return x.startFixedDirection = x.fixedDirection, x.startFixedPosition = x.fixedPosition, L !== !1 && (x.isResize = !0, a.state.snapRenderInfo = {
      request: s.isRequest,
      direction: y
    }), x.isResize ? O : !1;
  },
  dragControl: function(a, s) {
    var c, u = s.datas, d = s.parentFlag, p = s.isPinch, v = s.parentKeepRatio, A = s.dragClient, x = s.parentDist, g = s.useSnap, b = s.isRequest, y = s.isGroup, f = s.parentEvent, m = s.resolveMatrix, C = u.isResize, w = u.transformOrigin, S = u.startWidth, $ = u.startHeight, T = u.prevWidth, I = u.prevHeight, _ = u.minSize, E = u.maxSize, R = u.ratio, O = u.startOffsetWidth, L = u.startOffsetHeight, B = u.isWidth;
    if (!C)
      return;
    if (m) {
      var F = a.state.is3d, M = u.startOffsetMatrix, W = u.startTransformOrigin, j = F ? 4 : 3, G = parseMat(getNextTransforms(s)), U = Math.sqrt(G.length);
      j !== U && (G = convertDimension(G, U, j));
      var k = getNextMatrix(M, G, W, j), N = calculatePoses(k, O, L, j);
      u.startPositions = N, u.nextTargetMatrix = G, u.nextAllMatrix = k;
    }
    var P = getProps(a.props, "resizable"), D = P.resizeFormat, H = P.throttleResize, V = H === void 0 ? d ? 0 : 1 : H, Z = P.parentMoveable, ne = P.keepRatioFinally, K = u.direction, q = K, Y = 0, ee = 0;
    !K[0] && !K[1] && (q = [1, 1]);
    var Q = R && (v ?? P.keepRatio) || !1;
    function J() {
      var xe = u.fixedDirection, we = getOffsetSizeDist(q, Q, u, s);
      Y = we.distWidth, ee = we.distHeight;
      var $e = q[0] - xe[0] || Q ? Math.max(O + Y, TINY_NUM) : O, Ae = q[1] - xe[1] || Q ? Math.max(L + ee, TINY_NUM) : L;
      return Q && O && L && (B ? Ae = $e / R : $e = Ae * R), [$e, Ae];
    }
    var te = __read(J(), 2), ae = te[0], se = te[1];
    f || (u.setFixedDirection(u.fixedDirection), triggerEvent(a, "onBeforeResize", fillParams(a, s, {
      startFixedDirection: u.startFixedDirection,
      startFixedPosition: u.startFixedPosition,
      setFixedDirection: function(xe) {
        var we;
        return u.setFixedDirection(xe), we = __read(J(), 2), ae = we[0], se = we[1], [ae, se];
      },
      setFixedPosition: function(xe) {
        var we;
        return u.setFixedPosition(xe), we = __read(J(), 2), ae = we[0], se = we[1], [ae, se];
      },
      boundingWidth: ae,
      boundingHeight: se,
      setSize: function(xe) {
        var we;
        we = __read(xe, 2), ae = we[0], se = we[1];
      }
    }, !0)));
    var ie = A;
    A || (!d && p ? ie = getAbsolutePosition(a, [0, 0]) : ie = u.fixedPosition);
    var fe = [0, 0];
    p || (fe = checkSnapResize(a, ae, se, K, ie, !g && b, u)), x && (!x[0] && (fe[0] = 0), !x[1] && (fe[1] = 0));
    function ge() {
      var xe;
      D && (xe = __read(D([ae, se]), 2), ae = xe[0], se = xe[1]), ae = throttle(ae, V), se = throttle(se, V);
    }
    if (Q) {
      q[0] && q[1] && fe[0] && fe[1] && (abs(fe[0]) > abs(fe[1]) ? fe[1] = 0 : fe[0] = 0);
      var me = !fe[0] && !fe[1];
      me && ge(), q[0] && !q[1] || fe[0] && !fe[1] || me && B ? (ae += fe[0], se = ae / R) : (!q[0] && q[1] || !fe[0] && fe[1] || me && !B) && (se += fe[1], ae = se * R);
    } else
      ae += fe[0], se += fe[1], ae = Math.max(0, ae), se = Math.max(0, se);
    c = __read(calculateBoundSize([ae, se], _, E, Q ? R : !1), 2), ae = c[0], se = c[1], ge(), Q && (y || ne) && (B ? se = ae / R : ae = se * R), Y = ae - O, ee = se - L;
    var pe = [Y - T, ee - I];
    u.prevWidth = Y, u.prevHeight = ee;
    var be = getResizeDist(a, ae, se, ie, w, u);
    if (!(!Z && pe.every(function(xe) {
      return !xe;
    }) && be.every(function(xe) {
      return !xe;
    }))) {
      var le = Draggable.drag(a, setCustomDrag(s, a.state, be, !!p, !1, "draggable")), ve = le.transform, he = S + Y, ye = $ + ee, Ce = fillParams(a, s, __assign$1({ width: he, height: ye, offsetWidth: Math.round(ae), offsetHeight: Math.round(se), startRatio: R, boundingWidth: ae, boundingHeight: se, direction: K, dist: [Y, ee], delta: pe, isPinch: !!p, drag: le }, fillAfterTransform({
        style: {
          width: "".concat(he, "px"),
          height: "".concat(ye, "px")
        },
        transform: ve
      }, le, s)));
      return !f && triggerEvent(a, "onResize", Ce), Ce;
    }
  },
  dragControlAfter: function(a, s) {
    var c = s.datas, u = c.isResize, d = c.startOffsetWidth, p = c.startOffsetHeight, v = c.prevWidth, A = c.prevHeight;
    if (!(!u || a.props.checkResizableError === !1)) {
      var x = a.state, g = x.width, b = x.height, y = g - (d + v), f = b - (p + A), m = abs(y) > 3, C = abs(f) > 3;
      if (m && (c.startWidth += y, c.startOffsetWidth += y, c.prevWidth += y), C && (c.startHeight += f, c.startOffsetHeight += f, c.prevHeight += f), m || C)
        return this.dragControl(a, s);
    }
  },
  dragControlEnd: function(a, s) {
    var c = s.datas, u = s.parentEvent;
    if (c.isResize) {
      c.isResize = !1;
      var d = fillEndParams(a, s, {});
      return !u && triggerEvent(a, "onResizeEnd", d), d;
    }
  },
  dragGroupControlCondition: directionCondition$2,
  dragGroupControlStart: function(a, s) {
    var c = s.datas, u = this.dragControlStart(a, __assign$1(__assign$1({}, s), { isGroup: !0 }));
    if (!u)
      return !1;
    var d = fillChildEvents(a, "resizable", s), p = c.startOffsetWidth, v = c.startOffsetHeight;
    function A() {
      var m = c.minSize;
      d.forEach(function(C) {
        var w = C.datas, S = w.minSize, $ = w.startOffsetWidth, T = w.startOffsetHeight, I = p * ($ ? S[0] / $ : 0), _ = v * (T ? S[1] / T : 0);
        m[0] = Math.max(m[0], I), m[1] = Math.max(m[1], _);
      });
    }
    function x() {
      var m = c.maxSize;
      d.forEach(function(C) {
        var w = C.datas, S = w.maxSize, $ = w.startOffsetWidth, T = w.startOffsetHeight, I = p * ($ ? S[0] / $ : 0), _ = v * (T ? S[1] / T : 0);
        m[0] = Math.min(m[0], I), m[1] = Math.min(m[1], _);
      });
    }
    var g = triggerChildAbles(a, this, "dragControlStart", s, function(m, C) {
      return startChildDist(a, m, c, C);
    });
    A(), x();
    var b = function(m) {
      u.setFixedDirection(m), g.forEach(function(C, w) {
        C.setFixedDirection(m), startChildDist(a, C.moveable, c, d[w]);
      });
    };
    c.setFixedDirection = b;
    var y = __assign$1(__assign$1({}, u), { targets: a.props.targets, events: g.map(function(m) {
      return __assign$1(__assign$1({}, m), { setMin: function(C) {
        m.setMin(C), A();
      }, setMax: function(C) {
        m.setMax(C), x();
      } });
    }), setFixedDirection: b, setMin: function(m) {
      u.setMin(m), A();
    }, setMax: function(m) {
      u.setMax(m), x();
    } }), f = triggerEvent(a, "onResizeGroupStart", y);
    return c.isResize = f !== !1, c.isResize ? u : !1;
  },
  dragGroupControl: function(a, s) {
    var c = s.datas;
    if (c.isResize) {
      var u = getProps(a.props, "resizable");
      catchEvent(a, "onBeforeResize", function(m) {
        triggerEvent(a, "onBeforeResizeGroup", fillParams(a, s, __assign$1(__assign$1({}, m), { targets: u.targets }), !0));
      });
      var d = this.dragControl(a, __assign$1(__assign$1({}, s), { isGroup: !0 }));
      if (d) {
        var p = d.boundingWidth, v = d.boundingHeight, A = d.dist, x = u.keepRatio, g = [
          p / (p - A[0]),
          v / (v - A[1])
        ], b = c.fixedPosition, y = triggerChildAbles(a, this, "dragControl", s, function(m, C) {
          var w = __read(calculate(createRotateMatrix(a.rotation / 180 * Math.PI, 3), [
            C.datas.originalX * g[0],
            C.datas.originalY * g[1],
            1
          ], 3), 2), S = w[0], $ = w[1];
          return __assign$1(__assign$1({}, C), { parentDist: null, parentScale: g, dragClient: plus(b, [S, $]), parentKeepRatio: x });
        }), f = __assign$1({ targets: u.targets, events: y }, d);
        return triggerEvent(a, "onResizeGroup", f), f;
      }
    }
  },
  dragGroupControlEnd: function(a, s) {
    var c = s.isDrag, u = s.datas;
    if (u.isResize) {
      this.dragControlEnd(a, s);
      var d = triggerChildAbles(a, this, "dragControlEnd", s), p = fillEndParams(a, s, {
        targets: a.props.targets,
        events: d
      });
      return triggerEvent(a, "onResizeGroupEnd", p), c;
    }
  },
  /**
       * @method Moveable.Resizable#request
       * @param {Moveable.Resizable.ResizableRequestParam} e - the Resizable's request parameter
       * @return {Moveable.Requester} Moveable Requester
       * @example
  
       * // Instantly Request (requestStart - request - requestEnd)
       * // Use Relative Value
       * moveable.request("resizable", { deltaWidth: 10, deltaHeight: 10 }, true);
       *
       * // Use Absolute Value
       * moveable.request("resizable", { offsetWidth: 100, offsetHeight: 100 }, true);
       *
       * // requestStart
       * const requester = moveable.request("resizable");
       *
       * // request
       * // Use Relative Value
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       *
       * // Use Absolute Value
       * moveable.request("resizable", { offsetWidth: 100, offsetHeight: 100 });
       * moveable.request("resizable", { offsetWidth: 110, offsetHeight: 100 });
       * moveable.request("resizable", { offsetWidth: 120, offsetHeight: 100 });
       *
       * // requestEnd
       * requester.requestEnd();
       */
  request: function(a) {
    var s = {}, c = 0, u = 0, d = !1, p = a.getRect();
    return {
      isControl: !0,
      requestStart: function(v) {
        var A;
        return d = v.useSnap, {
          datas: s,
          parentDirection: v.direction || [1, 1],
          parentIsWidth: (A = v?.horizontal) !== null && A !== void 0 ? A : !0,
          useSnap: d
        };
      },
      request: function(v) {
        return "offsetWidth" in v ? c = v.offsetWidth - p.offsetWidth : "deltaWidth" in v && (c += v.deltaWidth), "offsetHeight" in v ? u = v.offsetHeight - p.offsetHeight : "deltaHeight" in v && (u += v.deltaHeight), {
          datas: s,
          parentDist: [c, u],
          parentKeepRatio: v.keepRatio,
          useSnap: d
        };
      },
      requestEnd: function() {
        return { datas: s, isDrag: !0, useSnap: d };
      }
    };
  },
  unset: function(a) {
    a.state.gestos.resizable = null;
  }
};
function setRotateStartInfo(a, s, c, u, d) {
  var p = a.props.groupable, v = a.state, A = v.is3d ? 4 : 3, x = s.origin, g = calculatePosition(
    a.state.rootMatrix,
    // TO-DO #710
    minus([x[0], x[1]], p ? [0, 0] : [v.left, v.top]),
    A
  ), b = plus([d.left, d.top], g);
  s.startAbsoluteOrigin = b, s.prevDeg = getRad$1(b, [c, u]) / Math.PI * 180, s.defaultDeg = s.prevDeg, s.prevSnapDeg = 0, s.loop = 0, s.startDist = getDist$2(b, [c, u]);
}
function getAbsoluteDist(a, s, c) {
  var u = c.defaultDeg, d = c.prevDeg, p = d % 360, v = Math.floor(d / 360);
  p < 0 && (p += 360), p > a && p > 270 && a < 90 ? ++v : p < a && p < 90 && a > 270 && --v;
  var A = s * (v * 360 + a - u);
  return c.prevDeg = u + A, A;
}
function getAbsoluteDistByClient(a, s, c, u) {
  return getAbsoluteDist(getRad$1(u.startAbsoluteOrigin, [a, s]) / Math.PI * 180, c, u);
}
function getRotateInfo(a, s, c, u, d, p) {
  var v = a.props.throttleRotate, A = v === void 0 ? 0 : v, x = c.prevSnapDeg, g = 0, b = !1;
  if (p) {
    var y = checkSnapRotate(a, s, u, d + u);
    b = y.isSnap, g = d + y.dist;
  }
  b || (g = throttle(d + u, A));
  var f = g - d;
  return c.prevSnapDeg = f, [f - x, f, g];
}
function getRotationPositions(a, s, c) {
  var u = __read(s, 4), d = u[0], p = u[1], v = u[2], A = u[3];
  if (a === "none")
    return [];
  if (isArray(a))
    return a.map(function(S) {
      return getRotationPositions(S, [d, p, v, A], c)[0];
    });
  var x = __read((a || "top").split("-"), 2), g = x[0], b = x[1], y = [d, p];
  g === "left" ? y = [v, d] : g === "right" ? y = [p, A] : g === "bottom" && (y = [A, v]);
  var f = [
    (y[0][0] + y[1][0]) / 2,
    (y[0][1] + y[1][1]) / 2
  ], m = getRotationRad(y, c);
  if (b) {
    var C = b === "top" || b === "left", w = g === "bottom" || g === "left";
    f = y[C && !w || !C && w ? 0 : 1];
  }
  return [[f, m]];
}
function dragControlCondition(a, s) {
  if (s.isRequest)
    return s.requestAble === "rotatable";
  var c = s.inputEvent.target;
  if (hasClass(c, prefix$1("rotation-control")) || a.props.rotateAroundControls && hasClass(c, prefix$1("around-control")) || hasClass(c, prefix$1("control")) && hasClass(c, prefix$1("rotatable")))
    return !0;
  var u = a.props.rotationTarget;
  return u ? getRefTargets(u, !0).some(function(d) {
    return d ? c === d || c.contains(d) : !1;
  }) : !1;
}
var css = `.rotation {
position: absolute;
height: 40px;
width: 1px;
transform-origin: 50% 100%;
height: calc(40px * var(--zoom));
top: auto;
left: 0;
bottom: 100%;
will-change: transform;
}
.rotation .rotation-line {
display: block;
width: 100%;
height: 100%;
transform-origin: 50% 50%;
}
.rotation .rotation-control {
border-color: #4af;
border-color: var(--moveable-color);
background:#fff;
cursor: alias;
}
:global .view-rotation-dragging, .rotatable.direction.control {
cursor: alias;
}
.rotatable.direction.control.move {
cursor: move;
}
`, Rotatable = {
  name: "rotatable",
  canPinch: !0,
  props: [
    "rotatable",
    "rotationPosition",
    "throttleRotate",
    "renderDirections",
    "rotationTarget",
    "rotateAroundControls",
    "edge",
    "resolveAblesWithRotatable",
    "displayAroundControls"
  ],
  events: [
    "rotateStart",
    "beforeRotate",
    "rotate",
    "rotateEnd",
    "rotateGroupStart",
    "beforeRotateGroup",
    "rotateGroup",
    "rotateGroupEnd"
  ],
  css: [css],
  viewClassName: function(a) {
    return a.isDragging("rotatable") ? prefix$1("view-rotation-dragging") : "";
  },
  render: function(a, s) {
    var c = getProps(a.props, "rotatable"), u = c.rotatable, d = c.rotationPosition, p = c.zoom, v = c.renderDirections, A = c.rotateAroundControls, x = c.resolveAblesWithRotatable, g = a.getState(), b = g.renderPoses, y = g.direction;
    if (!u)
      return null;
    var f = getRotationPositions(d, b, y), m = [];
    if (f.forEach(function($, T) {
      var I = __read($, 2), _ = I[0], E = I[1];
      m.push(s.createElement(
        "div",
        { key: "rotation".concat(T), className: prefix$1("rotation"), style: {
          // tslint:disable-next-line: max-line-length
          transform: "translate(-50%) translate(".concat(_[0], "px, ").concat(_[1], "px) rotate(").concat(E, "rad)")
        } },
        s.createElement("div", { className: prefix$1("line rotation-line"), style: {
          transform: "scaleX(".concat(p, ")")
        } }),
        s.createElement("div", { className: prefix$1("control rotation-control"), style: {
          transform: "translate(0.5px) scale(".concat(p, ")")
        } })
      ));
    }), v) {
      var C = getKeys(x || {}), w = {};
      C.forEach(function($) {
        x[$].forEach(function(T) {
          w[T] = $;
        });
      });
      var S = [];
      isArray(v) && (S = v.map(function($) {
        var T = w[$];
        return {
          data: T ? { resolve: T } : {},
          classNames: T ? ["move"] : [],
          dir: $
        };
      })), m.push.apply(m, __spreadArray$1([], __read(renderDirectionControlsByInfos(a, "rotatable", S, s)), !1));
    }
    return A && m.push.apply(m, __spreadArray$1([], __read(renderAroundControls(a, s)), !1)), m;
  },
  dragControlCondition,
  dragControlStart: function(a, s) {
    var c, u, d = s.datas, p = s.clientX, v = s.clientY, A = s.parentRotate, x = s.parentFlag, g = s.isPinch, b = s.isRequest, y = a.state, f = y.target, m = y.left, C = y.top, w = y.direction, S = y.beforeDirection, $ = y.targetTransform, T = y.moveableClientRect, I = y.offsetMatrix, _ = y.targetMatrix, E = y.allMatrix, R = y.width, O = y.height;
    if (!b && !f)
      return !1;
    var L = a.getRect();
    d.rect = L, d.transform = $, d.left = m, d.top = C;
    var B = function(q) {
      var Y = getOffsetFixedPositionInfo(a.state, q);
      d.fixedDirection = Y.fixedDirection, d.fixedOffset = Y.fixedOffset, d.fixedPosition = Y.fixedPosition, V && V.setFixedPosition(q);
    }, F = function(q) {
      var Y = getOffsetFixedDirectionInfo(a.state, q);
      d.fixedDirection = Y.fixedDirection, d.fixedOffset = Y.fixedOffset, d.fixedPosition = Y.fixedPosition, V && V.setFixedDirection(q);
    }, M = p, W = v;
    if (b || g || x) {
      var j = A || 0;
      d.beforeInfo = {
        origin: L.beforeOrigin,
        prevDeg: j,
        defaultDeg: j,
        prevSnapDeg: 0,
        startDist: 0
      }, d.afterInfo = __assign$1(__assign$1({}, d.beforeInfo), { origin: L.origin }), d.absoluteInfo = __assign$1(__assign$1({}, d.beforeInfo), { origin: L.origin, startValue: j });
    } else {
      var G = (u = s.inputEvent) === null || u === void 0 ? void 0 : u.target;
      if (G) {
        var U = G.getAttribute("data-direction") || "", k = DIRECTION_REGION_TO_DIRECTION[U];
        if (k) {
          d.isControl = !0, d.isAroundControl = hasClass(G, prefix$1("around-control")), d.controlDirection = k;
          var N = G.getAttribute("data-resolve");
          N && (d.resolveAble = N);
          var P = calculateMoveableClientPositions(y.rootMatrix, y.renderPoses, T);
          c = __read(getPosByDirection(P, k), 2), M = c[0], W = c[1];
        }
      }
      d.beforeInfo = { origin: L.beforeOrigin }, d.afterInfo = { origin: L.origin }, d.absoluteInfo = {
        origin: L.origin,
        startValue: L.rotation
      };
      var D = B;
      B = function(q) {
        var Y = y.is3d ? 4 : 3, ee = __read(plus(getOrigin(_, Y), q), 2), Q = ee[0], J = ee[1], te = calculate(I, convertPositionMatrix([Q, J], Y)), ae = calculate(E, convertPositionMatrix([q[0], q[1]], Y));
        D(q);
        var se = y.posDelta;
        d.beforeInfo.origin = minus(te, se), d.afterInfo.origin = minus(ae, se), d.absoluteInfo.origin = minus(ae, se), setRotateStartInfo(a, d.beforeInfo, M, W, T), setRotateStartInfo(a, d.afterInfo, M, W, T), setRotateStartInfo(a, d.absoluteInfo, M, W, T);
      }, F = function(q) {
        var Y = getPosByDirection([
          [0, 0],
          [R, 0],
          [0, O],
          [R, O]
        ], q);
        B(Y);
      };
    }
    d.startClientX = M, d.startClientY = W, d.direction = w, d.beforeDirection = S, d.startValue = 0, d.datas = {}, setDefaultTransformIndex(a, s, "rotate");
    var H = !1, V = !1;
    if (d.isControl && d.resolveAble) {
      var Z = d.resolveAble;
      Z === "resizable" && (V = Resizable.dragControlStart(a, __assign$1(__assign$1({}, new CustomGesto("resizable").dragStart([0, 0], s)), { parentPosition: d.controlPosition, parentFixedPosition: d.fixedPosition })));
    }
    V || (H = Draggable.dragStart(a, new CustomGesto().dragStart([0, 0], s))), B(getTotalOrigin(a));
    var ne = fillParams(a, s, __assign$1(__assign$1({ set: function(q) {
      d.startValue = q * Math.PI / 180;
    }, setFixedDirection: F, setFixedPosition: B }, fillTransformStartEvent(a, s)), { dragStart: H, resizeStart: V })), K = triggerEvent(a, "onRotateStart", ne);
    return d.isRotate = K !== !1, y.snapRenderInfo = {
      request: s.isRequest
    }, d.isRotate ? ne : !1;
  },
  dragControl: function(a, s) {
    var c, u, d, p = s.datas, v = s.clientDistX, A = s.clientDistY, x = s.parentRotate, g = s.parentFlag, b = s.isPinch, y = s.groupDelta, f = s.resolveMatrix, m = p.beforeDirection, C = p.beforeInfo, w = p.afterInfo, S = p.absoluteInfo, $ = p.isRotate, T = p.startValue, I = p.rect, _ = p.startClientX, E = p.startClientY;
    if ($) {
      resolveTransformEvent(a, s, "rotate");
      var R = getTransformDirection(s), O = m * R, L = a.props.parentMoveable, B = 0, F, M, W = 0, j, G, U = 0, k, N, P = 180 / Math.PI * T, D = S.startValue, H = !1, V = _ + v, Z = E + A;
      if (!g && "parentDist" in s) {
        var ne = s.parentDist;
        F = ne, j = ne, k = ne;
      } else b || g ? (F = getAbsoluteDist(x, m, C), j = getAbsoluteDist(x, O, w), k = getAbsoluteDist(x, O, S)) : (F = getAbsoluteDistByClient(V, Z, m, C), j = getAbsoluteDistByClient(V, Z, O, w), k = getAbsoluteDistByClient(V, Z, O, S), H = !0);
      if (M = P + F, G = P + j, N = D + k, triggerEvent(a, "onBeforeRotate", fillParams(a, s, {
        beforeRotation: M,
        rotation: G,
        absoluteRotation: N,
        setRotation: function(ie) {
          j = ie - P, F = j, k = j;
        }
      }, !0)), c = __read(getRotateInfo(a, I, C, F, P, H), 3), B = c[0], F = c[1], M = c[2], u = __read(getRotateInfo(a, I, w, j, P, H), 3), W = u[0], j = u[1], G = u[2], d = __read(getRotateInfo(a, I, S, k, D, H), 3), U = d[0], k = d[1], N = d[2], !(!U && !W && !B && !L && !f)) {
        var K = convertTransformFormat(p, "rotate(".concat(G, "deg)"), "rotate(".concat(j, "deg)"));
        f && (p.fixedPosition = getTranslateFixedPosition(a, p.targetAllTransform, p.fixedDirection, p.fixedOffset, p));
        var q = getRotateDist(a, j, p), Y = minus(plus(y || [0, 0], q), p.prevInverseDist || [0, 0]);
        p.prevInverseDist = q, p.requestValue = null;
        var ee = fillTransformEvent(a, K, Y, b, s), Q = ee, J = getDist$2([V, Z], S.startAbsoluteOrigin) - S.startDist, te = void 0;
        if (p.resolveAble === "resizable") {
          var ae = Resizable.dragControl(a, __assign$1(__assign$1({}, setCustomDrag(s, a.state, [s.deltaX, s.deltaY], !!b, !1, "resizable")), { resolveMatrix: !0, parentDistance: J }));
          ae && (te = ae, Q = fillAfterTransform(Q, ae, s));
        }
        var se = fillParams(a, s, __assign$1(__assign$1({ delta: W, dist: j, rotate: G, rotation: G, beforeDist: F, beforeDelta: B, beforeRotate: M, beforeRotation: M, absoluteDist: k, absoluteDelta: U, absoluteRotate: N, absoluteRotation: N, isPinch: !!b, resize: te }, ee), Q));
        return triggerEvent(a, "onRotate", se), se;
      }
    }
  },
  dragControlEnd: function(a, s) {
    var c = s.datas;
    if (c.isRotate) {
      c.isRotate = !1;
      var u = fillEndParams(a, s, {});
      return triggerEvent(a, "onRotateEnd", u), u;
    }
  },
  dragGroupControlCondition: dragControlCondition,
  dragGroupControlStart: function(a, s) {
    var c = s.datas, u = a.state, d = u.left, p = u.top, v = u.beforeOrigin, A = this.dragControlStart(a, s);
    if (!A)
      return !1;
    A.set(c.beforeDirection * a.rotation);
    var x = triggerChildAbles(a, this, "dragControlStart", s, function(y, f) {
      var m = y.state, C = m.left, w = m.top, S = m.beforeOrigin, $ = plus(minus([C, w], [d, p]), minus(S, v));
      return f.datas.startGroupClient = $, f.datas.groupClient = $, __assign$1(__assign$1({}, f), { parentRotate: 0 });
    }), g = __assign$1(__assign$1({}, A), { targets: a.props.targets, events: x }), b = triggerEvent(a, "onRotateGroupStart", g);
    return c.isRotate = b !== !1, c.isRotate ? A : !1;
  },
  dragGroupControl: function(a, s) {
    var c = s.datas;
    if (c.isRotate) {
      catchEvent(a, "onBeforeRotate", function(g) {
        triggerEvent(a, "onBeforeRotateGroup", fillParams(a, s, __assign$1(__assign$1({}, g), { targets: a.props.targets }), !0));
      });
      var u = this.dragControl(a, s);
      if (u) {
        var d = c.beforeDirection, p = u.beforeDist, v = p / 180 * Math.PI, A = triggerChildAbles(a, this, "dragControl", s, function(g, b) {
          var y = b.datas.startGroupClient, f = __read(b.datas.groupClient, 2), m = f[0], C = f[1], w = __read(rotate(y, v * d), 2), S = w[0], $ = w[1], T = [S - m, $ - C];
          return b.datas.groupClient = [S, $], __assign$1(__assign$1({}, b), { parentRotate: p, groupDelta: T });
        });
        a.rotation = d * u.beforeRotation;
        var x = __assign$1({ targets: a.props.targets, events: A, set: function(g) {
          a.rotation = g;
        }, setGroupRotation: function(g) {
          a.rotation = g;
        } }, u);
        return triggerEvent(a, "onRotateGroup", x), x;
      }
    }
  },
  dragGroupControlEnd: function(a, s) {
    var c = s.isDrag, u = s.datas;
    if (u.isRotate) {
      this.dragControlEnd(a, s);
      var d = triggerChildAbles(a, this, "dragControlEnd", s), p = fillEndParams(a, s, {
        targets: a.props.targets,
        events: d
      });
      return triggerEvent(a, "onRotateGroupEnd", p), c;
    }
  },
  /**
       * @method Moveable.Rotatable#request
       * @param {object} [e] - the Resizable's request parameter
       * @param {number} [e.deltaRotate=0] -  delta number of rotation
       * @param {number} [e.rotate=0] - absolute number of moveable's rotation
       * @return {Moveable.Requester} Moveable Requester
       * @example
  
       * // Instantly Request (requestStart - request - requestEnd)
       * moveable.request("rotatable", { deltaRotate: 10 }, true);
       *
       * * moveable.request("rotatable", { rotate: 10 }, true);
       *
       * // requestStart
       * const requester = moveable.request("rotatable");
       *
       * // request
       * requester.request({ deltaRotate: 10 });
       * requester.request({ deltaRotate: 10 });
       * requester.request({ deltaRotate: 10 });
       *
       * requester.request({ rotate: 10 });
       * requester.request({ rotate: 20 });
       * requester.request({ rotate: 30 });
       *
       * // requestEnd
       * requester.requestEnd();
       */
  request: function(a) {
    var s = {}, c = 0, u = a.getRotation();
    return {
      isControl: !0,
      requestStart: function() {
        return { datas: s };
      },
      request: function(d) {
        return "deltaRotate" in d ? c += d.deltaRotate : "rotate" in d && (c = d.rotate - u), { datas: s, parentDist: c };
      },
      requestEnd: function() {
        return { datas: s, isDrag: !0 };
      }
    };
  }
};
function renderGuideline(a, s) {
  var c, u = a.direction, d = a.classNames, p = a.size, v = a.pos, A = a.zoom, x = a.key, g = u === "horizontal", b = g ? "Y" : "X";
  return s.createElement("div", {
    key: x,
    className: d.join(" "),
    style: (c = {}, c[g ? "width" : "height"] = "".concat(p), c.transform = "translate(".concat(v[0], ", ").concat(v[1], ") translate").concat(b, "(-50%) scale").concat(b, "(").concat(A, ")"), c)
  });
}
function renderInnerGuideline(a, s) {
  return renderGuideline(__assign$1(__assign$1({}, a), { classNames: __spreadArray$1([
    prefix$1("line", "guideline", a.direction)
  ], __read(a.classNames), !1).filter(function(c) {
    return c;
  }), size: a.size || "".concat(a.sizeValue, "px"), pos: a.pos || a.posValue.map(function(c) {
    return "".concat(throttle(c, 0.1), "px");
  }) }), s);
}
function renderSnapPoses(a, s, c, u, d, p, v, A) {
  var x = a.props.zoom;
  return c.map(function(g, b) {
    var y = g.type, f = g.pos, m = [0, 0];
    return m[v] = u, m[v ? 0 : 1] = -d + f, renderInnerGuideline({
      key: "".concat(s, "TargetGuideline").concat(b),
      classNames: [prefix$1("target", "bold", y)],
      posValue: m,
      sizeValue: p,
      zoom: x,
      direction: s
    }, A);
  });
}
function renderGuidelines(a, s, c, u, d, p) {
  var v = a.props, A = v.zoom, x = v.isDisplayInnerSnapDigit, g = s === "horizontal" ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP, b = d[g.start], y = d[g.end];
  return c.filter(function(f) {
    var m = f.hide, C = f.elementRect;
    if (m)
      return !1;
    if (x && C) {
      var w = C.rect;
      if (w[g.start] <= b && y <= w[g.end])
        return !1;
    }
    return !0;
  }).map(function(f, m) {
    var C = f.pos, w = f.size, S = f.element, $ = f.className, T = [
      -u[0] + C[0],
      -u[1] + C[1]
    ];
    return renderInnerGuideline({
      key: "".concat(s, "-default-guideline-").concat(m),
      classNames: S ? [prefix$1("bold"), $] : [prefix$1("normal"), $],
      direction: s,
      posValue: T,
      sizeValue: w,
      zoom: A
    }, p);
  });
}
function renderDigitLine(a, s, c, u, d, p, v, A) {
  var x, g = a.props, b = g.snapDigit, y = b === void 0 ? 0 : b, f = g.isDisplaySnapDigit, m = f === void 0 ? !0 : f, C = g.snapDistFormat, w = C === void 0 ? function(E, R) {
    return E;
  } : C, S = g.zoom, $ = s === "horizontal" ? "X" : "Y", T = s === "vertical" ? "height" : "width", I = Math.abs(d), _ = m ? parseFloat(I.toFixed(y)) : 0;
  return A.createElement(
    "div",
    { key: "".concat(s, "-").concat(c, "-guideline-").concat(u), className: prefix$1("guideline-group", s), style: (x = {
      left: "".concat(p[0], "px"),
      top: "".concat(p[1], "px")
    }, x[T] = "".concat(I, "px"), x) },
    renderInnerGuideline({
      direction: s,
      classNames: [prefix$1(c), v],
      size: "100%",
      posValue: [0, 0],
      sizeValue: I,
      zoom: S
    }, A),
    A.createElement("div", { className: prefix$1("size-value", "gap"), style: {
      transform: "translate".concat($, "(-50%) scale(").concat(S, ")")
    } }, _ > 0 ? w(_, s) : "")
  );
}
function groupByElementGuidelines(a, s, c, u) {
  var d = a === "vertical" ? 0 : 1, p = a === "vertical" ? 1 : 0, v = d ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP, A = c[v.start], x = c[v.end];
  return groupBy(s, function(g) {
    return g.pos[d];
  }).map(function(g) {
    var b = [], y = [], f = [];
    return g.forEach(function(m) {
      var C, w, S = m.element, $ = m.elementRect.rect;
      if ($[v.end] < A)
        b.push(m);
      else if (x < $[v.start])
        y.push(m);
      else if ($[v.start] <= A && x <= $[v.end] && u) {
        var T = m.pos, I = { element: S, rect: __assign$1(__assign$1({}, $), (C = {}, C[v.end] = $[v.start], C)) }, _ = { element: S, rect: __assign$1(__assign$1({}, $), (w = {}, w[v.start] = $[v.end], w)) }, E = [0, 0], R = [0, 0];
        E[d] = T[d], E[p] = T[p], R[d] = T[d], R[p] = T[p] + m.size, b.push({
          type: a,
          pos: E,
          size: 0,
          elementRect: I,
          direction: "",
          elementDirection: "end"
        }), y.push({
          type: a,
          pos: R,
          size: 0,
          elementRect: _,
          direction: "",
          elementDirection: "start"
        });
      }
    }), b.sort(function(m, C) {
      return C.pos[p] - m.pos[p];
    }), y.sort(function(m, C) {
      return m.pos[p] - C.pos[p];
    }), {
      total: g,
      start: b,
      end: y,
      inner: f
    };
  });
}
function renderDashedGuidelines(a, s, c, u, d) {
  var p = a.props.isDisplayInnerSnapDigit, v = [];
  return ["vertical", "horizontal"].forEach(function(A) {
    var x = s.filter(function(S) {
      return S.type === A;
    }), g = A === "vertical" ? 1 : 0, b = g ? 0 : 1, y = groupByElementGuidelines(A, x, u, p), f = g ? HORIZONTAL_NAMES_MAP : VERTICAL_NAMES_MAP, m = g ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP, C = u[f.start], w = u[f.end];
    y.forEach(function(S) {
      var $ = S.total, T = S.start, I = S.end, _ = S.inner, E = c[b] + $[0].pos[b] - u[m.start], R = u;
      T.forEach(function(O) {
        var L = O.elementRect.rect, B = R[f.start] - L[f.end];
        if (B > 0) {
          var F = [0, 0];
          F[g] = c[g] + R[f.start] - C - B, F[b] = E, v.push(renderDigitLine(a, A, "dashed", v.length, B, F, O.className, d));
        }
        R = L;
      }), R = u, I.forEach(function(O) {
        var L = O.elementRect.rect, B = L[f.start] - R[f.end];
        if (B > 0) {
          var F = [0, 0];
          F[g] = c[g] + R[f.end] - C, F[b] = E, v.push(renderDigitLine(a, A, "dashed", v.length, B, F, O.className, d));
        }
        R = L;
      }), _.forEach(function(O) {
        var L = O.elementRect.rect, B = C - L[f.start], F = L[f.end] - w, M = [0, 0], W = [0, 0];
        M[g] = c[g] - B, M[b] = E, W[g] = c[g] + w - C, W[b] = E, v.push(renderDigitLine(a, A, "dashed", v.length, B, M, O.className, d)), v.push(renderDigitLine(a, A, "dashed", v.length, F, W, O.className, d));
      });
    });
  }), v;
}
function renderGapGuidelines(a, s, c, u, d) {
  var p = [];
  return ["horizontal", "vertical"].forEach(function(v) {
    var A = s.filter(function(S) {
      return S.type === v;
    }).slice(0, 1), x = v === "vertical" ? 0 : 1, g = x ? 0 : 1, b = x ? HORIZONTAL_NAMES_MAP : VERTICAL_NAMES_MAP, y = x ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP, f = u[b.start], m = u[b.end], C = u[y.start], w = u[y.end];
    A.forEach(function(S) {
      var $ = S.gap, T = S.gapRects, I = Math.max.apply(Math, __spreadArray$1([C], __read(T.map(function(R) {
        var O = R.rect;
        return O[y.start];
      })), !1)), _ = Math.min.apply(Math, __spreadArray$1([w], __read(T.map(function(R) {
        var O = R.rect;
        return O[y.end];
      })), !1)), E = (I + _) / 2;
      I === _ || E === (C + w) / 2 || T.forEach(function(R) {
        var O = R.rect, L = R.className, B = [c[0], c[1]];
        if (O[b.end] < f)
          B[x] += O[b.end] - f;
        else if (m < O[b.start])
          B[x] += O[b.start] - f - $;
        else
          return;
        B[g] += E - C, p.push(renderDigitLine(a, x ? "vertical" : "horizontal", "gap", p.length, $, B, L, d));
      });
    });
  }), p;
}
function getTotalGuidelines(a) {
  var s, c, u = a.state, d = u.containerClientRect, p = u.hasFixed, v = d.overflow, A = d.scrollHeight, x = d.scrollWidth, g = d.clientHeight, b = d.clientWidth, y = d.clientLeft, f = d.clientTop, m = a.props, C = m.snapGap, w = C === void 0 ? !0 : C, S = m.verticalGuidelines, $ = m.horizontalGuidelines, T = m.snapThreshold, I = T === void 0 ? 5 : T, _ = m.maxSnapElementGuidelineDistance, E = _ === void 0 ? 1 / 0 : _, R = m.isDisplayGridGuidelines, O = getRect(getAbsolutePosesByState(a.state)), L = O.top, B = O.left, F = O.bottom, M = O.right, W = { top: L, left: B, bottom: F, right: M, center: (B + M) / 2, middle: (L + F) / 2 }, j = getElementGuidelines(a), G = __spreadArray$1([], __read(j), !1), U = ((c = (s = u.snapThresholdInfo) === null || s === void 0 ? void 0 : s.multiples) !== null && c !== void 0 ? c : [1, 1]).map(function(D) {
    return D * I;
  });
  w && G.push.apply(G, __spreadArray$1([], __read(getGapGuidelines(a, W, U)), !1));
  var k = __assign$1({}, u.snapOffset || {
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  });
  if (G.push.apply(G, __spreadArray$1([], __read(getGridGuidelines(a, v ? x : b, v ? A : g, y, f, k, R)), !1)), p) {
    var N = d.left, P = d.top;
    k.left += N, k.top += P, k.right += N, k.bottom += P;
  }
  return G.push.apply(G, __spreadArray$1([], __read(getDefaultGuidelines($ || !1, S || !1, v ? x : b, v ? A : g, y, f, k)), !1)), G = G.filter(function(D) {
    var H = D.element, V = D.elementRect, Z = D.type;
    if (!H || !V)
      return !0;
    var ne = V.rect;
    return checkBetweenRects(W, ne, Z, E);
  }), G;
}
function getGapGuidelines(a, s, c) {
  var u = a.props, d = u.maxSnapElementGuidelineDistance, p = d === void 0 ? 1 / 0 : d, v = u.maxSnapElementGapDistance, A = v === void 0 ? 1 / 0 : v, x = a.state.elementRects, g = [];
  return [
    ["vertical", VERTICAL_NAMES_MAP, HORIZONTAL_NAMES_MAP],
    ["horizontal", HORIZONTAL_NAMES_MAP, VERTICAL_NAMES_MAP]
  ].forEach(function(b) {
    var y = __read(b, 3), f = y[0], m = y[1], C = y[2], w = s[m.start], S = s[m.end], $ = s[m.center], T = s[C.start], I = s[C.end], _ = {
      left: c[0],
      top: c[1]
    };
    function E(L) {
      var B = L.rect, F = _[m.start];
      return B[m.end] < w + F ? w - B[m.end] : S - F < B[m.start] ? B[m.start] - S : -1;
    }
    var R = x.filter(function(L) {
      var B = L.rect;
      return B[C.start] > I || B[C.end] < T ? !1 : E(L) > 0;
    }).sort(function(L, B) {
      return E(L) - E(B);
    }), O = [];
    R.forEach(function(L) {
      R.forEach(function(B) {
        if (L !== B) {
          var F = L.rect, M = B.rect, W = F[C.start], j = F[C.end], G = M[C.start], U = M[C.end];
          W > U || G > j || O.push([L, B]);
        }
      });
    }), O.forEach(function(L) {
      var B = __read(L, 2), F = B[0], M = B[1], W = F.rect, j = M.rect, G = W[m.start], U = W[m.end], k = j[m.start], N = j[m.end], P = _[m.start], D = 0, H = 0, V = !1, Z = !1, ne = !1;
      if (U <= w && S <= k) {
        if (Z = !0, D = (k - U - (S - w)) / 2, H = U + D + (S - w) / 2, abs(H - $) > P)
          return;
      } else if (U < k && N < w + P) {
        if (V = !0, D = k - U, H = N + D, abs(H - w) > P)
          return;
      } else if (U < k && S - P < G) {
        if (ne = !0, D = k - U, H = G - D, abs(H - S) > P)
          return;
      } else
        return;
      D && checkBetweenRects(s, j, f, p) && (D > A || g.push({
        type: f,
        pos: f === "vertical" ? [H, 0] : [0, H],
        element: M.element,
        size: 0,
        className: M.className,
        isStart: V,
        isCenter: Z,
        isEnd: ne,
        gap: D,
        hide: !0,
        gapRects: [F, M],
        direction: "",
        elementDirection: ""
      }));
    });
  }), g;
}
function startGridGroupGuidelines(a, s, c, u) {
  var d, p, v = a.props, A = a.state, x = v.snapGridAll, g = v.snapGridWidth, b = g === void 0 ? 0 : g, y = v.snapGridHeight, f = y === void 0 ? 0 : y, m = A.snapRenderInfo, C = m && (((d = m.direction) === null || d === void 0 ? void 0 : d[0]) || ((p = m.direction) === null || p === void 0 ? void 0 : p[1])), w = a.moveables;
  if (x && w && C && (b || f)) {
    if (A.snapThresholdInfo)
      return;
    A.snapThresholdInfo = {
      multiples: [1, 1],
      offset: [0, 0]
    };
    var S = a.getRect(), $ = S.children, T = m.direction;
    if ($) {
      var I = T.map(function(E, R) {
        var O = R === 0 ? {
          snapSize: b,
          posName: "left",
          sizeName: "width",
          clientOffset: u.left - s
        } : {
          snapSize: f,
          posName: "top",
          sizeName: "height",
          clientOffset: u.top - c
        }, L = O.snapSize, B = O.posName, F = O.sizeName, M = O.clientOffset;
        if (!L)
          return {
            dir: E,
            multiple: 1,
            snapSize: L,
            snapOffset: 0
          };
        var W = S[F], j = S[B], G = flat$1($.map(function(V) {
          return [
            V[B] - j,
            V[F],
            W - V[F] - V[B] + j
          ];
        })).filter(function(V) {
          return V;
        }).sort(function(V, Z) {
          return V - Z;
        }), U = G[0], k = G.map(function(V) {
          return throttle(V / U, 0.1) * L;
        }), N = 1, P = throttle(W / U, 0.1);
        for (N = 1; N <= 10 && !k.every(function(V) {
          return V * N % 1 === 0;
        }); ++N)
          ;
        var D = (-E + 1) / 2, H = dot(j - M, j - M + W, D, 1 - D);
        return {
          multiple: P * N,
          dir: E,
          snapSize: L,
          snapOffset: Math.round(H / L)
        };
      }), _ = I.map(function(E) {
        return E.multiple || 1;
      });
      A.snapThresholdInfo.multiples = _, A.snapThresholdInfo.offset = I.map(function(E) {
        return E.snapOffset;
      }), I.forEach(function(E, R) {
        E.snapSize;
      });
    }
  } else
    A.snapThresholdInfo = null;
}
function getGridGuidelines(a, s, c, u, d, p, v) {
  u === void 0 && (u = 0), d === void 0 && (d = 0);
  var A = a.props, x = a.state, g = A.snapGridWidth, b = g === void 0 ? 0 : g, y = A.snapGridHeight, f = y === void 0 ? 0 : y, m = [], C = p.left, w = p.top, S = [0, 0];
  startGridGroupGuidelines(a, u, d, p);
  var $ = x.snapThresholdInfo, T = b, I = f;
  if ($ && (b *= $.multiples[0] || 1, f *= $.multiples[1] || 1, S = $.offset), f) {
    for (var _ = function(R) {
      m.push({
        type: "horizontal",
        pos: [
          C,
          throttle(S[1] * I + R - d + w, 0.1)
        ],
        className: prefix$1("grid-guideline"),
        size: s,
        hide: !v,
        direction: "",
        grid: !0
      });
    }, E = 0; E <= c * 2; E += f)
      _(E);
    for (var E = -f; E >= -c; E -= f)
      _(E);
  }
  if (b) {
    for (var _ = function(O) {
      m.push({
        type: "vertical",
        pos: [
          throttle(S[0] * T + O - u + C, 0.1),
          w
        ],
        className: prefix$1("grid-guideline"),
        size: c,
        hide: !v,
        direction: "",
        grid: !0
      });
    }, E = 0; E <= s * 2; E += b)
      _(E);
    for (var E = -b; E >= -s; E -= b)
      _(E);
  }
  return m;
}
function checkBetweenRects(a, s, c, u) {
  return c === "horizontal" ? abs(a.right - s.left) <= u || abs(a.left - s.right) <= u || a.left <= s.right && s.left <= a.right : c === "vertical" ? abs(a.bottom - s.top) <= u || abs(a.top - s.bottom) <= u || a.top <= s.bottom && s.top <= a.bottom : !0;
}
function getElementGuidelines(a) {
  var s = a.state, c = a.props.elementGuidelines, u = c === void 0 ? [] : c;
  if (!u.length)
    return s.elementRects = [], [];
  var d = (s.elementRects || []).filter(function(f) {
    return !f.refresh;
  }), p = u.map(function(f) {
    return isObject$1(f) && "element" in f ? __assign$1(__assign$1({}, f), { element: getRefTarget(f.element, !0) }) : {
      element: getRefTarget(f, !0)
    };
  }).filter(function(f) {
    return f.element;
  }), v = diff(d.map(function(f) {
    return f.element;
  }), p.map(function(f) {
    return f.element;
  })), A = v.maintained, x = v.added, g = [];
  A.forEach(function(f) {
    var m = __read(f, 2), C = m[0], w = m[1];
    g[w] = d[C];
  }), getSnapElementRects(a, x.map(function(f) {
    return p[f];
  })).map(function(f, m) {
    g[x[m]] = f;
  }), s.elementRects = g;
  var b = getSnapDirections(a.props.elementSnapDirections), y = [];
  return g.forEach(function(f) {
    var m = f.element, C = f.top, w = C === void 0 ? b.top : C, S = f.left, $ = S === void 0 ? b.left : S, T = f.right, I = T === void 0 ? b.right : T, _ = f.bottom, E = _ === void 0 ? b.bottom : _, R = f.center, O = R === void 0 ? b.center : R, L = f.middle, B = L === void 0 ? b.middle : L, F = f.className, M = f.rect, W = splitSnapDirectionPoses({
      top: w,
      right: I,
      left: $,
      bottom: E,
      center: O,
      middle: B
    }, M), j = W.horizontal, G = W.vertical, U = W.horizontalNames, k = W.verticalNames, N = M.top, P = M.left, D = M.right - P, H = M.bottom - N, V = [D, H];
    G.forEach(function(Z, ne) {
      y.push({
        type: "vertical",
        element: m,
        pos: [
          throttle(Z, 0.1),
          N
        ],
        size: H,
        sizes: V,
        className: F,
        elementRect: f,
        elementDirection: SNAP_SKIP_NAMES_MAP[k[ne]] || k[ne],
        direction: ""
      });
    }), j.forEach(function(Z, ne) {
      y.push({
        type: "horizontal",
        element: m,
        pos: [
          P,
          throttle(Z, 0.1)
        ],
        size: D,
        sizes: V,
        className: F,
        elementRect: f,
        elementDirection: SNAP_SKIP_NAMES_MAP[U[ne]] || U[ne],
        direction: ""
      });
    });
  }), y;
}
function getObjectGuidelines(a, s) {
  return a ? a.map(function(c) {
    var u = isObject$1(c) ? c : { pos: c }, d = u.pos;
    return isNumber(d) ? u : __assign$1(__assign$1({}, u), { pos: convertUnitSize(d, s) });
  }) : [];
}
function getDefaultGuidelines(a, s, c, u, d, p, v) {
  d === void 0 && (d = 0), p === void 0 && (p = 0), v === void 0 && (v = { left: 0, top: 0, right: 0, bottom: 0 });
  var A = [], x = v.left, g = v.top, b = v.bottom, y = v.right, f = c + y - x, m = u + b - g;
  return getObjectGuidelines(a, m).forEach(function(C) {
    A.push({
      type: "horizontal",
      pos: [
        x,
        throttle(C.pos - p + g, 0.1)
      ],
      size: f,
      className: C.className,
      direction: ""
    });
  }), getObjectGuidelines(s, f).forEach(function(C) {
    A.push({
      type: "vertical",
      pos: [
        throttle(C.pos - d + x, 0.1),
        g
      ],
      size: m,
      className: C.className,
      direction: ""
    });
  }), A;
}
function getSnapElementRects(a, s) {
  if (!s.length)
    return [];
  var c = a.props.groupable, u = a.state, d = u.containerClientRect, p = u.rootMatrix, v = u.is3d, A = u.offsetDelta, x = v ? 4 : 3, g = __read(calculateContainerPos(p, d, x), 2), b = g[0], y = g[1], f = c ? 0 : A[0], m = c ? 0 : A[1];
  return s.map(function(C) {
    var w = C.element.getBoundingClientRect(), S = w.left - b - f, $ = w.top - y - m, T = $ + w.height, I = S + w.width, _ = __read(calculateInversePosition(p, [S, $], x), 2), E = _[0], R = _[1], O = __read(calculateInversePosition(p, [I, T], x), 2), L = O[0], B = O[1];
    return __assign$1(__assign$1({}, C), { rect: {
      left: E,
      right: L,
      top: R,
      bottom: B,
      center: (E + L) / 2,
      middle: (R + B) / 2
    } });
  });
}
function checkSnapInfo(a) {
  var s = a.state, c = s.container, u = a.props.snapContainer || c;
  if (s.snapContainer === u && s.guidelines && s.guidelines.length)
    return !1;
  var d = s.containerClientRect, p = {
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  };
  if (c !== u) {
    var v = getRefTarget(u, !0);
    if (v) {
      var A = getClientRect(v), x = getDragDistByState(s, [
        A.left - d.left,
        A.top - d.top
      ]), g = getDragDistByState(s, [
        A.right - d.right,
        A.bottom - d.bottom
      ]);
      p.left = throttle(x[0], 1e-5), p.top = throttle(x[1], 1e-5), p.right = throttle(g[0], 1e-5), p.bottom = throttle(g[1], 1e-5);
    }
  }
  return s.snapContainer = u, s.snapOffset = p, s.guidelines = getTotalGuidelines(a), s.enableSnap = !0, !0;
}
function getNextFixedPoses(a, s, c, u, d, p) {
  var v = calculatePoses(a, s, c, p ? 4 : 3), A = getPosByDirection(v, u);
  return getAbsolutePoses(v, minus(d, A));
}
function normalized(a) {
  return a ? a / abs(a) : 0;
}
function getSizeOffsetInfo(a, s, c, u, d, p) {
  var v = p.fixedDirection, A = getCheckSnapDirections(c, v, u), x = getCheckInnerBoundLineInfos(a, s, c, u), g = __spreadArray$1(__spreadArray$1([], __read(getSnapBoundInfo(a, s, A, u, d, p)), !1), __read(getInnerBoundInfo(a, x, p)), !1), b = getNearOffsetInfo(g, 0), y = getNearOffsetInfo(g, 1);
  return {
    width: {
      isBound: b.isBound,
      offset: b.offset[0]
    },
    height: {
      isBound: y.isBound,
      offset: y.offset[1]
    }
  };
}
function recheckSizeByTwoDirection(a, s, c, u, d, p, v, A, x) {
  var g = getPosByDirection(s, v), b = checkMoveableSnapBounds(a, A, {
    vertical: [g[0]],
    horizontal: [g[1]]
  }), y = b.horizontal.offset, f = b.vertical.offset;
  if (throttle(f, FLOAT_POINT_NUM) || throttle(y, FLOAT_POINT_NUM)) {
    var m = __read(getDragDist({
      datas: x,
      distX: -f,
      distY: -y
    }), 2), C = m[0], w = m[1], S = Math.min(d || 1 / 0, c + v[0] * C), $ = Math.min(p || 1 / 0, u + v[1] * w);
    return [S - c, $ - u];
  }
  return [0, 0];
}
function checkSizeDist(a, s, c, u, d, p, v, A) {
  for (var x = getAbsolutePosesByState(a.state), g = a.props.keepRatio, b = 0, y = 0, f = 0; f < 2; ++f) {
    var m = s(b, y), C = getSizeOffsetInfo(a, m, d, g, v, A), w = C.width, S = C.height, $ = w.isBound, T = S.isBound, I = w.offset, _ = S.offset;
    if (f === 1 && ($ || (I = 0), T || (_ = 0)), f === 0 && v && !$ && !T)
      return [0, 0];
    if (g) {
      var E = abs(I) * (c ? 1 / c : 1), R = abs(_) * (u ? 1 / u : 1), O = $ && T ? E < R : T || !$ && E < R;
      O ? I = c * _ / u : _ = u * I / c;
    }
    b += I, y += _;
  }
  if (!g && d[0] && d[1]) {
    var L = checkMaxBounds(a, x, d, p, A), B = L.maxWidth, F = L.maxHeight, M = __read(recheckSizeByTwoDirection(a, s(b, y).map(function(G) {
      return G.map(function(U) {
        return throttle(U, FLOAT_POINT_NUM);
      });
    }), c + b, u + y, B, F, d, v, A), 2), I = M[0], _ = M[1];
    b += I, y += _;
  }
  return [b, y];
}
function absDegree(a) {
  return a < 0 && (a = a % 360 + 360), a %= 360, a;
}
function bumpDegree(a, s) {
  s = absDegree(s);
  var c = Math.floor(a / 360), u = c * 360 + 360 - s, d = c * 360 + s;
  return abs(a - u) < abs(a - d) ? u : d;
}
function getMinDegreeDistance(a, s) {
  a = absDegree(a), s = absDegree(s);
  var c = absDegree(a - s);
  return Math.min(c, 360 - c);
}
function checkSnapRotate(a, s, c, u) {
  var d, p = a.props, v = (d = p[NAME_snapRotationThreshold]) !== null && d !== void 0 ? d : 5, A = p[NAME_snapRotationDegrees];
  if (hasGuidelines(a, "rotatable")) {
    var x = s.pos1, g = s.pos2, b = s.pos3, y = s.pos4, f = s.origin, m = c * Math.PI / 180, C = [x, g, b, y].map(function(_) {
      return minus(_, f);
    }), w = C.map(function(_) {
      return rotate(_, m);
    }), S = __spreadArray$1(__spreadArray$1([], __read(checkRotateBounds(a, C, w, f, c)), !1), __read(checkRotateInnerBounds(a, C, w, f, c)), !1);
    S.sort(function(_, E) {
      return abs(_ - c) - abs(E - c);
    });
    var $ = S.length > 0;
    if ($)
      return {
        isSnap: $,
        dist: $ ? S[0] : c
      };
  }
  if (A?.length && v) {
    var T = A.slice().sort(function(_, E) {
      return getMinDegreeDistance(_, u) - getMinDegreeDistance(E, u);
    }), I = T[0];
    if (getMinDegreeDistance(I, u) <= v)
      return {
        isSnap: !0,
        dist: c + bumpDegree(u, I) - u
      };
  }
  return {
    isSnap: !1,
    dist: c
  };
}
function checkSnapResize(a, s, c, u, d, p, v) {
  if (!hasGuidelines(a, "resizable"))
    return [0, 0];
  var A = v.fixedDirection, x = v.nextAllMatrix, g = a.state, b = g.allMatrix, y = g.is3d;
  return checkSizeDist(a, function(f, m) {
    return getNextFixedPoses(x || b, s + f, c + m, A, d, y);
  }, s, c, u, d, p, v);
}
function checkSnapScale(a, s, c, u, d) {
  if (!hasGuidelines(a, "scalable"))
    return [0, 0];
  var p = d.startOffsetWidth, v = d.startOffsetHeight, A = d.fixedPosition, x = d.fixedDirection, g = d.is3d, b = checkSizeDist(a, function(y, f) {
    return getNextFixedPoses(scaleMatrix(d, plus(s, [y / p, f / v])), p, v, x, A, g);
  }, p, v, c, A, u, d);
  return [b[0] / p, b[1] / v];
}
function startCheckSnapDrag(a, s) {
  s.absolutePoses = getAbsolutePosesByState(a.state);
}
function getSnapGuidelines(a) {
  var s = [];
  return a.forEach(function(c) {
    c.guidelineInfos.forEach(function(u) {
      var d = u.guideline;
      find$1(s, function(p) {
        return p.guideline === d;
      }) || (d.direction = "", s.push({ guideline: d, posInfo: c }));
    });
  }), s.map(function(c) {
    var u = c.guideline, d = c.posInfo;
    return __assign$1(__assign$1({}, u), { direction: d.direction });
  });
}
function addBoundGuidelines(a, s, c, u, d, p) {
  var v = checkBoundPoses(getBounds(a, p), s, c), A = v.vertical, x = v.horizontal, g = getInitialBounds();
  A.forEach(function(C) {
    C.isBound && (C.direction === "start" && (g.left = !0), C.direction === "end" && (g.right = !0), u.push({
      type: "bounds",
      pos: C.pos
    }));
  }), x.forEach(function(C) {
    C.isBound && (C.direction === "start" && (g.top = !0), C.direction === "end" && (g.bottom = !0), d.push({
      type: "bounds",
      pos: C.pos
    }));
  });
  var b = checkInnerBoundPoses(a), y = b.boundMap, f = b.vertical, m = b.horizontal;
  return f.forEach(function(C) {
    findIndex(u, function(w) {
      var S = w.type, $ = w.pos;
      return S === "bounds" && $ === C;
    }) >= 0 || u.push({
      type: "bounds",
      pos: C
    });
  }), m.forEach(function(C) {
    findIndex(d, function(w) {
      var S = w.type, $ = w.pos;
      return S === "bounds" && $ === C;
    }) >= 0 || d.push({
      type: "bounds",
      pos: C
    });
  }), {
    boundMap: g,
    innerBoundMap: y
  };
}
var directionCondition$1 = getDirectionCondition("", ["resizable", "scalable"]), Snappable = {
  name: "snappable",
  dragRelation: "strong",
  props: [
    "snappable",
    "snapContainer",
    "snapDirections",
    "elementSnapDirections",
    "snapGap",
    "snapGridWidth",
    "snapGridHeight",
    "isDisplaySnapDigit",
    "isDisplayInnerSnapDigit",
    "isDisplayGridGuidelines",
    "snapDigit",
    "snapThreshold",
    "snapRenderThreshold",
    "snapGridAll",
    NAME_snapRotationThreshold,
    NAME_snapRotationDegrees,
    NAME_snapHorizontalThreshold,
    NAME_snapVerticalThreshold,
    "horizontalGuidelines",
    "verticalGuidelines",
    "elementGuidelines",
    "bounds",
    "innerBounds",
    "snapDistFormat",
    "maxSnapElementGuidelineDistance",
    "maxSnapElementGapDistance"
  ],
  events: ["snap", "bound"],
  css: [
    `:host {
--bounds-color: #d66;
}
.guideline {
pointer-events: none;
z-index: 2;
}
.guideline.bounds {
background: #d66;
background: var(--bounds-color);
}
.guideline-group {
position: absolute;
top: 0;
left: 0;
}
.guideline-group .size-value {
position: absolute;
color: #f55;
font-size: 12px;
font-size: calc(12px * var(--zoom));
font-weight: bold;
}
.guideline-group.horizontal .size-value {
transform-origin: 50% 100%;
transform: translateX(-50%);
left: 50%;
bottom: 5px;
bottom: calc(2px + 3px * var(--zoom));
}
.guideline-group.vertical .size-value {
transform-origin: 0% 50%;
top: 50%;
transform: translateY(-50%);
left: 5px;
left: calc(2px + 3px * var(--zoom));
}
.guideline.gap {
background: #f55;
}
.size-value.gap {
color: #f55;
}
`
  ],
  render: function(a, s) {
    var c = a.state, u = c.top, d = c.left, p = c.pos1, v = c.pos2, A = c.pos3, x = c.pos4, g = c.snapRenderInfo, b = a.props.snapRenderThreshold, y = b === void 0 ? 1 : b;
    if (!g || !g.render || !hasGuidelines(a, ""))
      return watchValue(a, "boundMap", getInitialBounds(), function(K) {
        return JSON.stringify(K);
      }), watchValue(a, "innerBoundMap", getInitialBounds(), function(K) {
        return JSON.stringify(K);
      }), [];
    c.guidelines = getTotalGuidelines(a);
    var f = Math.min(p[0], v[0], A[0], x[0]), m = Math.min(p[1], v[1], A[1], x[1]), C = g.externalPoses || [], w = getAbsolutePosesByState(a.state), S = [], $ = [], T = [], I = [], _ = [], E = getRect(w), R = E.width, O = E.height, L = E.top, B = E.left, F = E.bottom, M = E.right, W = { left: B, right: M, top: L, bottom: F, center: (B + M) / 2, middle: (L + F) / 2 }, j = C.length > 0, G = j ? getRect(C) : {};
    if (!g.request) {
      if (g.direction && _.push(getSnapInfosByDirection(a, w, g.direction, y, y)), g.snap) {
        var U = getRect(w);
        g.center && (U.middle = (U.top + U.bottom) / 2, U.center = (U.left + U.right) / 2), _.push(checkSnaps(a, U, y, y));
      }
      j && (g.center && (G.middle = (G.top + G.bottom) / 2, G.center = (G.left + G.right) / 2), _.push(checkSnaps(a, G, y, y))), _.forEach(function(K) {
        var q = K.vertical.posInfos, Y = K.horizontal.posInfos;
        S.push.apply(S, __spreadArray$1([], __read(q.filter(function(ee) {
          var Q = ee.guidelineInfos;
          return Q.some(function(J) {
            var te = J.guideline;
            return !te.hide;
          });
        }).map(function(ee) {
          return {
            type: "snap",
            pos: ee.pos
          };
        })), !1)), $.push.apply($, __spreadArray$1([], __read(Y.filter(function(ee) {
          var Q = ee.guidelineInfos;
          return Q.some(function(J) {
            var te = J.guideline;
            return !te.hide;
          });
        }).map(function(ee) {
          return {
            type: "snap",
            pos: ee.pos
          };
        })), !1)), T.push.apply(T, __spreadArray$1([], __read(getSnapGuidelines(q)), !1)), I.push.apply(I, __spreadArray$1([], __read(getSnapGuidelines(Y)), !1));
      });
    }
    var k = addBoundGuidelines(a, [B, M], [L, F], S, $), N = k.boundMap, P = k.innerBoundMap;
    j && addBoundGuidelines(a, [G.left, G.right], [G.top, G.bottom], S, $, g.externalBounds);
    var D = __spreadArray$1(__spreadArray$1([], __read(T), !1), __read(I), !1), H = D.filter(function(K) {
      return K.element && !K.gapRects;
    }), V = D.filter(function(K) {
      return K.gapRects;
    }).sort(function(K, q) {
      return K.gap - q.gap;
    });
    triggerEvent(a, "onSnap", {
      guidelines: D.filter(function(K) {
        var q = K.element;
        return !q;
      }),
      elements: H,
      gaps: V
    }, !0);
    var Z = watchValue(a, "boundMap", N, function(K) {
      return JSON.stringify(K);
    }, getInitialBounds()), ne = watchValue(a, "innerBoundMap", P, function(K) {
      return JSON.stringify(K);
    }, getInitialBounds());
    return (N === Z || P === ne) && triggerEvent(a, "onBound", {
      bounds: N,
      innerBounds: P
    }, !0), __spreadArray$1(__spreadArray$1(__spreadArray$1(__spreadArray$1(__spreadArray$1(__spreadArray$1([], __read(renderDashedGuidelines(a, H, [f, m], W, s)), !1), __read(renderGapGuidelines(a, V, [f, m], W, s)), !1), __read(renderGuidelines(a, "horizontal", I, [d, u], W, s)), !1), __read(renderGuidelines(a, "vertical", T, [d, u], W, s)), !1), __read(renderSnapPoses(a, "horizontal", $, f, u, R, 0, s)), !1), __read(renderSnapPoses(a, "vertical", S, m, d, O, 1, s)), !1);
  },
  dragStart: function(a, s) {
    a.state.snapRenderInfo = {
      request: s.isRequest,
      snap: !0,
      center: !0
    }, checkSnapInfo(a);
  },
  drag: function(a) {
    var s = a.state;
    checkSnapInfo(a) || (s.guidelines = getTotalGuidelines(a)), s.snapRenderInfo && (s.snapRenderInfo.render = !0);
  },
  pinchStart: function(a) {
    this.unset(a);
  },
  dragEnd: function(a) {
    this.unset(a);
  },
  dragControlCondition: function(a, s) {
    if (directionCondition$1(a, s) || dragControlCondition(a, s))
      return !0;
    if (!s.isRequest && s.inputEvent)
      return hasClass(s.inputEvent.target, prefix$1("snap-control"));
  },
  dragControlStart: function(a) {
    a.state.snapRenderInfo = null, checkSnapInfo(a);
  },
  dragControl: function(a) {
    this.drag(a);
  },
  dragControlEnd: function(a) {
    this.unset(a);
  },
  dragGroupStart: function(a, s) {
    this.dragStart(a, s);
  },
  dragGroup: function(a) {
    this.drag(a);
  },
  dragGroupEnd: function(a) {
    this.unset(a);
  },
  dragGroupControlStart: function(a) {
    a.state.snapRenderInfo = null, checkSnapInfo(a);
  },
  dragGroupControl: function(a) {
    this.drag(a);
  },
  dragGroupControlEnd: function(a) {
    this.unset(a);
  },
  unset: function(a) {
    var s = a.state;
    s.enableSnap = !1, s.guidelines = [], s.snapRenderInfo = null, s.elementRects = [];
  }
};
function multiply2(a, s) {
  return [
    a[0] * s[0],
    a[1] * s[1]
  ];
}
function prefix$1() {
  for (var a = [], s = 0; s < arguments.length; s++)
    a[s] = arguments[s];
  return prefixNames.apply(void 0, __spreadArray$1([PREFIX], __read(a), !1));
}
function defaultSync(a) {
  a();
}
function getTransformMatrix(a) {
  return !a || a === "none" ? [1, 0, 0, 1, 0, 0] : isObject$1(a) ? a : parseMat(a);
}
function getAbsoluteMatrix(a, s, c) {
  return multiplies(s, createOriginMatrix(c, s), a, createOriginMatrix(c.map(function(u) {
    return -u;
  }), s));
}
function measureSVGSize(a, s, c) {
  if (s === "%") {
    var u = getSVGViewBox(a.ownerSVGElement);
    return u[c ? "width" : "height"] / 100;
  }
  return 1;
}
function getBeforeTransformOrigin(a) {
  var s = getTransformOrigin(getComputedStyle$1(a, ":before"));
  return s.map(function(c, u) {
    var d = splitUnit(c), p = d.value, v = d.unit;
    return p * measureSVGSize(a, v, u === 0);
  });
}
function getTransformOriginArray(a) {
  return a ? a.split(" ") : ["0", "0"];
}
function getTransformOrigin(a) {
  return getTransformOriginArray(a.transformOrigin);
}
function getElementTransform(a) {
  var s = getCachedStyle(a), c = s("transform");
  if (c && c !== "none")
    return c;
  if ("transform" in a) {
    var u = a.transform, d = u.baseVal;
    if (!d)
      return "";
    var p = d.length;
    if (!p)
      return "";
    for (var v = [], A = function(g) {
      var b = d[g].matrix;
      v.push("matrix(".concat(["a", "b", "c", "d", "e", "f"].map(function(y) {
        return b[y];
      }).join(", "), ")"));
    }, x = 0; x < p; ++x)
      A(x);
    return v.join(" ");
  }
  return "";
}
function getOffsetInfo(a, s, c, u, d) {
  var p, v, A = getDocumentElement(a) || getDocumentBody(a), x = !1, g, b;
  if (!a || c)
    g = a;
  else {
    var y = (p = a?.assignedSlot) === null || p === void 0 ? void 0 : p.parentElement, f = a.parentElement;
    y ? (x = !0, b = f, g = y) : g = f;
  }
  for (var m = !1, C = a === s || g === s, w = "relative", S = 1, $ = parseFloat(d?.("zoom")) || 1, T = d?.("position"); g && g !== A; ) {
    s === g && (C = !0);
    var I = getCachedStyle(g), _ = g.tagName.toLowerCase(), E = getElementTransform(g), R = I("willChange"), O = parseFloat(I("zoom")) || 1;
    if (w = I("position"), u && O !== 1) {
      S = O;
      break;
    }
    if (
      // offsetParent is the parentElement if the target's zoom is not 1 and not absolute.
      !c && u && $ !== 1 && T && T !== "absolute" || _ === "svg" || _ === "foreignobject" || w !== "static" || E && E !== "none" || R === "transform"
    )
      break;
    var L = (v = a?.assignedSlot) === null || v === void 0 ? void 0 : v.parentNode, B = g.parentNode;
    L && (x = !0, b = B);
    var F = B;
    if (F && F.nodeType === 11) {
      g = F.host, m = !0, w = getCachedStyle(g)("position");
      break;
    }
    g = F, w = "relative";
  }
  return {
    offsetZoom: S,
    hasSlot: x,
    parentSlotElement: b,
    isCustomElement: m,
    isStatic: w === "static",
    isEnd: C || !g || g === A,
    offsetParent: g || A
  };
}
function getOffsetPosInfo(a, s) {
  var c, u = a.tagName.toLowerCase(), d = a.offsetLeft, p = a.offsetTop, v = getCachedStyle(a), A = isUndefined(d), x = !A, g, b;
  return !x && (u !== "svg" || a.ownerSVGElement) ? (g = IS_WEBKIT605 ? getBeforeTransformOrigin(a) : getTransformOriginArray(v("transformOrigin")).map(function(y) {
    return parseFloat(y);
  }), b = g.slice(), x = !0, u === "svg" ? (d = 0, p = 0) : (c = __read(getSVGGraphicsOffset(a, g, a === s && s.tagName.toLowerCase() === "g"), 4), d = c[0], p = c[1], g[0] = c[2], g[1] = c[3])) : (g = getTransformOriginArray(v("transformOrigin")).map(function(y) {
    return parseFloat(y);
  }), b = g.slice()), {
    tagName: u,
    isSVG: A,
    hasOffset: x,
    offset: [d || 0, p || 0],
    origin: g,
    targetOrigin: b
  };
}
function getBodyOffset(a, s) {
  var c = getCachedStyle(a), u = getCachedStyle(getDocumentBody(a)), d = u("position");
  if (!s && (!d || d === "static"))
    return [0, 0];
  var p = parseInt(u("marginLeft"), 10), v = parseInt(u("marginTop"), 10);
  return c("position") === "absolute" && ((c("top") !== "auto" || c("bottom") !== "auto") && (v = 0), (c("left") !== "auto" || c("right") !== "auto") && (p = 0)), [p, v];
}
function convert3DMatrixes(a) {
  a.forEach(function(s) {
    var c = s.matrix;
    c && (s.matrix = convertDimension(c, 3, 4));
  });
}
function getPositionFixedInfo(a) {
  for (var s = a.parentElement, c = !1, u = getDocumentBody(a); s; ) {
    var d = getComputedStyle$1(s).transform;
    if (d && d !== "none") {
      c = !0;
      break;
    }
    if (s === u)
      break;
    s = s.parentElement;
  }
  return {
    fixedContainer: s || u,
    hasTransform: c
  };
}
function makeMatrixCSS(a, s) {
  return s === void 0 && (s = a.length > 9), "".concat(s ? "matrix3d" : "matrix", "(").concat(convertMatrixtoCSS(a, !s).join(","), ")");
}
function getSVGViewBox(a) {
  var s = a.clientWidth, c = a.clientHeight;
  if (!a)
    return { x: 0, y: 0, width: 0, height: 0, clientWidth: s, clientHeight: c };
  var u = a.viewBox, d = u && u.baseVal || { x: 0, y: 0, width: 0, height: 0 };
  return {
    x: d.x,
    y: d.y,
    width: d.width || s,
    height: d.height || c,
    clientWidth: s,
    clientHeight: c
  };
}
function getSVGMatrix(a, s) {
  var c, u = getSVGViewBox(a), d = u.width, p = u.height, v = u.clientWidth, A = u.clientHeight, x = v / d, g = A / p, b = a.preserveAspectRatio.baseVal, y = b.align, f = b.meetOrSlice, m = [0, 0], C = [x, g], w = [0, 0];
  if (y !== 1) {
    var S = (y - 2) % 3, $ = Math.floor((y - 2) / 3);
    m[0] = d * S / 2, m[1] = p * $ / 2;
    var T = f === 2 ? Math.max(g, x) : Math.min(x, g);
    C[0] = T, C[1] = T, w[0] = (v - d) / 2 * S, w[1] = (A - p) / 2 * $;
  }
  var I = createScaleMatrix(C, s);
  return c = __read(w, 2), I[s * (s - 1)] = c[0], I[s * (s - 1) + 1] = c[1], getAbsoluteMatrix(I, s, m);
}
function getSVGGraphicsOffset(a, s, c) {
  var u = a.tagName.toLowerCase();
  if (!a.getBBox || !c && u === "g")
    return [0, 0, 0, 0];
  var d = getCachedStyle(a), p = d("transform-box") === "fill-box", v = a.getBBox(), A = getSVGViewBox(a.ownerSVGElement), x = v.x, g = v.y;
  u === "foreignobject" && !x && !g && (x = parseFloat(a.getAttribute("x")) || 0, g = parseFloat(a.getAttribute("y")) || 0);
  var b = x - A.x, y = g - A.y, f = p ? s[0] : s[0] - b, m = p ? s[1] : s[1] - y;
  return [b, y, f, m];
}
function calculatePosition(a, s, c) {
  return calculate(a, convertPositionMatrix(s, c), c);
}
function calculatePoses(a, s, c, u) {
  return [[0, 0], [s, 0], [0, c], [s, c]].map(function(d) {
    return calculatePosition(a, d, u);
  });
}
function getRect(a) {
  var s = a.map(function(g) {
    return g[0];
  }), c = a.map(function(g) {
    return g[1];
  }), u = Math.min.apply(Math, __spreadArray$1([], __read(s), !1)), d = Math.min.apply(Math, __spreadArray$1([], __read(c), !1)), p = Math.max.apply(Math, __spreadArray$1([], __read(s), !1)), v = Math.max.apply(Math, __spreadArray$1([], __read(c), !1)), A = p - u, x = v - d;
  return {
    left: u,
    top: d,
    right: p,
    bottom: v,
    width: A,
    height: x
  };
}
function calculateRect(a, s, c, u) {
  var d = calculatePoses(a, s, c, u);
  return getRect(d);
}
function getSVGOffset(a, s, c, u, d) {
  var p, v = a.target, A = a.origin, x = s.matrix, g = getSize(v), b = g.offsetWidth, y = g.offsetHeight, f = c.getBoundingClientRect(), m = [0, 0];
  c === getDocumentBody(c) && (m = getBodyOffset(v, !0));
  for (var C = v.getBoundingClientRect(), w = C.left - f.left + c.scrollLeft - (c.clientLeft || 0) + m[0], S = C.top - f.top + c.scrollTop - (c.clientTop || 0) + m[1], $ = C.width, T = C.height, I = multiplies(u, d, x), _ = calculateRect(I, b, y, u), E = _.left, R = _.top, O = _.width, L = _.height, B = calculatePosition(I, A, u), F = minus(B, [E, R]), M = [
    w + F[0] * $ / O,
    S + F[1] * T / L
  ], W = [0, 0], j = 0; ++j < 10; ) {
    var G = invert(d, u);
    p = __read(minus(calculatePosition(G, M, u), calculatePosition(G, B, u)), 2), W[0] = p[0], W[1] = p[1];
    var U = multiplies(u, d, createOriginMatrix(W, u), x), k = calculateRect(U, b, y, u), N = k.left, P = k.top, D = N - w, H = P - S;
    if (abs(D) < 2 && abs(H) < 2)
      break;
    M[0] -= D, M[1] -= H;
  }
  return W.map(function(V) {
    return Math.round(V);
  });
}
function calculateMoveableClientPositions(a, s, c) {
  var u = a.length === 16, d = u ? 4 : 3, p = s.map(function(x) {
    return calculatePosition(a, x, d);
  }), v = c.left, A = c.top;
  return p.map(function(x) {
    return [x[0] + v, x[1] + A];
  });
}
function getDistSize(a) {
  return Math.sqrt(a[0] * a[0] + a[1] * a[1]);
}
function getDiagonalSize(a, s) {
  return getDistSize([
    s[0] - a[0],
    s[1] - a[1]
  ]);
}
function getLineStyle(a, s, c, u) {
  c === void 0 && (c = 1), u === void 0 && (u = getRad$1(a, s));
  var d = getDiagonalSize(a, s);
  return {
    transform: "translateY(-50%) translate(".concat(a[0], "px, ").concat(a[1], "px) rotate(").concat(u, "rad) scaleY(").concat(c, ")"),
    width: "".concat(d, "px")
  };
}
function getControlTransform(a, s) {
  for (var c = [], u = 2; u < arguments.length; u++)
    c[u - 2] = arguments[u];
  var d = c.length, p = c.reduce(function(A, x) {
    return A + x[0];
  }, 0) / d, v = c.reduce(function(A, x) {
    return A + x[1];
  }, 0) / d;
  return {
    transform: "translateZ(0px) translate(".concat(p, "px, ").concat(v, "px) rotate(").concat(a, "rad) scale(").concat(s, ")")
  };
}
function getProps(a, s) {
  var c = a[s];
  return isObject$1(c) ? __assign$1(__assign$1({}, a), c) : a;
}
function getSize(a) {
  var s = a && !isUndefined(a.offsetWidth), c = 0, u = 0, d = 0, p = 0, v = 0, A = 0, x = 0, g = 0, b = 0, y = 0, f = 0, m = 0, C = 1 / 0, w = 1 / 0, S = 1 / 0, $ = 1 / 0, T = 0, I = 0, _ = !1;
  if (a)
    if (!s && a.ownerSVGElement) {
      var E = a.getBBox();
      _ = !0, c = E.width, u = E.height, v = c, A = u, x = c, g = u, d = c, p = u;
    } else {
      var R = getCachedStyle(a), O = a.style, L = R("boxSizing") === "border-box", B = parseFloat(R("borderLeftWidth")) || 0, F = parseFloat(R("borderRightWidth")) || 0, M = parseFloat(R("borderTopWidth")) || 0, W = parseFloat(R("borderBottomWidth")) || 0, j = parseFloat(R("paddingLeft")) || 0, G = parseFloat(R("paddingRight")) || 0, U = parseFloat(R("paddingTop")) || 0, k = parseFloat(R("paddingBottom")) || 0, N = j + G, P = U + k, D = B + F, H = M + W, V = N + D, Z = P + H, ne = R("position"), K = 0, q = 0;
      if ("clientLeft" in a) {
        var Y = null;
        if (ne === "absolute") {
          var ee = getOffsetInfo(a, getDocumentBody(a));
          Y = ee.offsetParent;
        } else
          Y = a.parentElement;
        if (Y) {
          var Q = getCachedStyle(Y);
          K = parseFloat(Q("width")), q = parseFloat(Q("height"));
        }
      }
      b = Math.max(N, convertUnitSize(R("minWidth"), K) || 0), y = Math.max(P, convertUnitSize(R("minHeight"), q) || 0), C = convertUnitSize(R("maxWidth"), K), w = convertUnitSize(R("maxHeight"), q), isNaN(C) && (C = 1 / 0), isNaN(w) && (w = 1 / 0), T = convertUnitSize(O.width, 0) || 0, I = convertUnitSize(O.height, 0) || 0, v = parseFloat(R("width")) || 0, A = parseFloat(R("height")) || 0, x = abs(v - T) < 1 ? between(b, T || v, C) : v, g = abs(A - I) < 1 ? between(y, I || A, w) : A, c = x, u = g, d = x, p = g, L ? (S = C, $ = w, f = b, m = y, x = c - V, g = u - Z) : (S = C + V, $ = w + Z, f = b + V, m = y + Z, c = x + V, u = g + Z), d = x + N, p = g + P;
    }
  return {
    svg: _,
    offsetWidth: c,
    offsetHeight: u,
    clientWidth: d,
    clientHeight: p,
    contentWidth: x,
    contentHeight: g,
    inlineCSSWidth: T,
    inlineCSSHeight: I,
    cssWidth: v,
    cssHeight: A,
    minWidth: b,
    minHeight: y,
    maxWidth: C,
    maxHeight: w,
    minOffsetWidth: f,
    minOffsetHeight: m,
    maxOffsetWidth: S,
    maxOffsetHeight: $
  };
}
function getRotationRad(a, s) {
  return getRad$1(s > 0 ? a[0] : a[1], s > 0 ? a[1] : a[0]);
}
function resetClientRect() {
  return {
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    right: 0,
    bottom: 0,
    clientLeft: 0,
    clientTop: 0,
    clientWidth: 0,
    clientHeight: 0,
    scrollWidth: 0,
    scrollHeight: 0
  };
}
function getExtendsRect(a, s) {
  var c = a === getDocumentBody(a) || a === getDocumentElement(a), u = {
    clientLeft: a.clientLeft,
    clientTop: a.clientTop,
    clientWidth: a.clientWidth,
    clientHeight: a.clientHeight,
    scrollWidth: a.scrollWidth,
    scrollHeight: a.scrollHeight,
    overflow: !1
  };
  return c && (u.clientHeight = Math.max(s.height, u.clientHeight), u.scrollHeight = Math.max(s.height, u.scrollHeight)), u.overflow = getCachedStyle(a)("overflow") !== "visible", __assign$1(__assign$1({}, s), u);
}
function getClientRectByPosition(a, s, c, u) {
  var d = a.left, p = a.right, v = a.top, A = a.bottom, x = s.top, g = s.left, b = {
    left: g + d,
    top: x + v,
    right: g + p,
    bottom: x + A,
    width: p - d,
    height: A - v
  };
  return c && u ? getExtendsRect(c, b) : b;
}
function getClientRect(a, s) {
  var c = 0, u = 0, d = 0, p = 0;
  if (a) {
    var v = a.getBoundingClientRect();
    c = v.left, u = v.top, d = v.width, p = v.height;
  }
  var A = {
    left: c,
    top: u,
    width: d,
    height: p,
    right: c + d,
    bottom: u + p
  };
  return a && s ? getExtendsRect(a, A) : A;
}
function getTotalOrigin(a) {
  var s = a.props, c = s.groupable, u = s.svgOrigin, d = a.getState(), p = d.offsetWidth, v = d.offsetHeight, A = d.svg, x = d.transformOrigin;
  return !c && A && u ? convertTransformOriginArray(u, p, v) : x;
}
function getTotalDirection(a, s, c, u) {
  var d;
  if (a)
    d = a;
  else if (s)
    d = [0, 0];
  else {
    var p = c.target;
    d = getDirection(p, u);
  }
  return d;
}
function getDirection(a, s) {
  if (a) {
    var c = a.getAttribute("data-rotation") || "", u = a.getAttribute("data-direction");
    if (s.deg = c, !!u) {
      var d = [0, 0];
      return u.indexOf("w") > -1 && (d[0] = -1), u.indexOf("e") > -1 && (d[0] = 1), u.indexOf("n") > -1 && (d[1] = -1), u.indexOf("s") > -1 && (d[1] = 1), d;
    }
  }
}
function getAbsolutePoses(a, s) {
  return [
    plus(s, a[0]),
    plus(s, a[1]),
    plus(s, a[2]),
    plus(s, a[3])
  ];
}
function getAbsolutePosesByState(a) {
  var s = a.left, c = a.top, u = a.pos1, d = a.pos2, p = a.pos3, v = a.pos4;
  return getAbsolutePoses([u, d, p, v], [s, c]);
}
function unsetAbles(a, s) {
  a[s ? "controlAbles" : "targetAbles"].forEach(function(c) {
    c.unset && c.unset(a);
  });
}
function unsetGesto(a, s) {
  var c = s ? "controlGesto" : "targetGesto", u = a[c];
  u?.isIdle() === !1 && unsetAbles(a, s), u?.unset(), a[c] = null;
}
function fillCSSObject(a, s) {
  if (s) {
    var c = getBeforeRenderableDatas(s);
    c.nextStyle = __assign$1(__assign$1({}, c.nextStyle), a);
  }
  return {
    style: a,
    cssText: getKeys(a).map(function(u) {
      return "".concat(decamelize(u, "-"), ": ").concat(a[u], ";");
    }).join("")
  };
}
function fillAfterTransform(a, s, c) {
  var u = s.afterTransform || s.transform;
  return __assign$1(__assign$1({}, fillCSSObject(__assign$1(__assign$1(__assign$1({}, a.style), s.style), { transform: u }), c)), { afterTransform: u, transform: a.transform });
}
function fillParams(a, s, c, u) {
  var d = s.datas;
  d.datas || (d.datas = {});
  var p = __assign$1(__assign$1({}, c), { target: a.state.target, clientX: s.clientX, clientY: s.clientY, inputEvent: s.inputEvent, currentTarget: a, moveable: a, datas: d.datas, isRequest: s.isRequest, isRequestChild: s.isRequestChild, isFirstDrag: !!s.isFirstDrag, isTrusted: s.isTrusted !== !1, stopAble: function() {
    d.isEventStart = !1;
  }, stopDrag: function() {
    var v;
    (v = s.stop) === null || v === void 0 || v.call(s);
  } });
  return d.isStartEvent ? u || (d.lastEvent = p) : d.isStartEvent = !0, p;
}
function fillEndParams(a, s, c) {
  var u = s.datas, d = "isDrag" in c ? c.isDrag : s.isDrag;
  return u.datas || (u.datas = {}), __assign$1(__assign$1({ isDrag: d }, c), { moveable: a, target: a.state.target, clientX: s.clientX, clientY: s.clientY, inputEvent: s.inputEvent, currentTarget: a, lastEvent: u.lastEvent, isDouble: s.isDouble, datas: u.datas, isFirstDrag: !!s.isFirstDrag });
}
function catchEvent(a, s, c) {
  a._emitter.on(s, c);
}
function triggerEvent(a, s, c, u, d) {
  return a.triggerEvent(s, c, u, d);
}
function getComputedStyle$1(a, s) {
  return getWindow(a).getComputedStyle(a, s);
}
function filterAbles(a, s, c) {
  var u = {}, d = {};
  return a.filter(function(p) {
    var v = p.name;
    if (u[v] || !s.some(function(A) {
      return p[A];
    }))
      return !1;
    if (!c && p.ableGroup) {
      if (d[p.ableGroup])
        return !1;
      d[p.ableGroup] = !0;
    }
    return u[v] = !0, !0;
  });
}
function equals(a, s) {
  return a === s || a == null && s == null;
}
function selectValue() {
  for (var a = [], s = 0; s < arguments.length; s++)
    a[s] = arguments[s];
  for (var c = a.length - 1, u = 0; u < c; ++u) {
    var d = a[u];
    if (!isUndefined(d))
      return d;
  }
  return a[c];
}
function groupBy(a, s) {
  var c = [], u = [];
  return a.forEach(function(d, p) {
    var v = s(d, p, a), A = u.indexOf(v), x = c[A] || [];
    A === -1 && (u.push(v), c.push(x)), x.push(d);
  }), c;
}
function groupByMap(a, s) {
  var c = [], u = {};
  return a.forEach(function(d, p) {
    var v = s(d, p, a), A = u[v];
    A || (A = [], u[v] = A, c.push(A)), A.push(d);
  }), c;
}
function flat(a) {
  return a.reduce(function(s, c) {
    return s.concat(c);
  }, []);
}
function maxOffset() {
  for (var a = [], s = 0; s < arguments.length; s++)
    a[s] = arguments[s];
  return a.sort(function(c, u) {
    return abs(u) - abs(c);
  }), a[0];
}
function calculateInversePosition(a, s, c) {
  return calculate(invert(a, c), convertPositionMatrix(s, c), c);
}
function convertDragDist(a, s) {
  var c, u = a.is3d, d = a.rootMatrix, p = u ? 4 : 3;
  return c = __read(calculateInversePosition(d, [s.distX, s.distY], p), 2), s.distX = c[0], s.distY = c[1], s;
}
function calculatePadding(a, s, c, u) {
  if (!c[0] && !c[1])
    return s;
  var d = calculatePosition(a, [normalized(c[0] || 1), 0], u), p = calculatePosition(a, [0, normalized(c[1] || 1)], u), v = calculatePosition(a, [
    c[0] / getDistSize(d),
    c[1] / getDistSize(p)
  ], u);
  return plus(s, v);
}
function convertCSSSize(a, s, c) {
  return c ? "".concat(a / s * 100, "%") : "".concat(a, "px");
}
function getTinyDist(a) {
  return abs(a) <= TINY_NUM ? 0 : a;
}
function getDirectionViewClassName(a) {
  return function(s) {
    if (!s.isDragging(a))
      return "";
    var c = getGestoData(s, a), u = c.deg;
    return u ? prefix$1("view-control-rotation".concat(u)) : "";
  };
}
function getDirectionCondition(a, s) {
  return s === void 0 && (s = [a]), function(c, u) {
    if (u.isRequest)
      return s.some(function(p) {
        return u.requestAble === p;
      }) ? u.parentDirection : !1;
    var d = u.inputEvent.target;
    return hasClass(d, prefix$1("direction")) && (!a || hasClass(d, prefix$1(a)));
  };
}
function convertTransformInfo(a, s, c) {
  var u, d = parse(a, {
    "x%": function(E) {
      return E / 100 * s.offsetWidth;
    },
    "y%": function(E) {
      return E / 100 * s.offsetHeight;
    }
  }), p = a.slice(0, c < 0 ? void 0 : c), v = a.slice(0, c < 0 ? void 0 : c + 1), A = a[c] || "", x = c < 0 ? [] : a.slice(c), g = c < 0 ? [] : a.slice(c + 1), b = d.slice(0, c < 0 ? void 0 : c), y = d.slice(0, c < 0 ? void 0 : c + 1), f = (u = d[c]) !== null && u !== void 0 ? u : parse([""])[0], m = c < 0 ? [] : d.slice(c), C = c < 0 ? [] : d.slice(c + 1), w = f ? [f] : [], S = toMat(b), $ = toMat(y), T = toMat(m), I = toMat(C), _ = multiply(S, T, 4);
  return {
    transforms: a,
    beforeFunctionMatrix: S,
    beforeFunctionMatrix2: $,
    targetFunctionMatrix: toMat(w),
    afterFunctionMatrix: T,
    afterFunctionMatrix2: I,
    allFunctionMatrix: _,
    beforeFunctions: b,
    beforeFunctions2: y,
    targetFunction: w[0],
    afterFunctions: m,
    afterFunctions2: C,
    beforeFunctionTexts: p,
    beforeFunctionTexts2: v,
    targetFunctionText: A,
    afterFunctionTexts: x,
    afterFunctionTexts2: g
  };
}
function isArrayFormat(a) {
  return !a || !isObject$1(a) || isNode(a) ? !1 : isArray(a) || "length" in a;
}
function getRefTarget(a, s) {
  return a ? isNode(a) ? a : isString(a) ? s ? document.querySelector(a) : a : isFunction(a) ? a() : isWindow(a) ? a : "current" in a ? a.current : a : null;
}
function getRefTargets(a, s) {
  if (!a)
    return [];
  var c = isArrayFormat(a) ? [].slice.call(a) : [a];
  return c.reduce(function(u, d) {
    return isString(d) && s ? __spreadArray$1(__spreadArray$1([], __read(u), !1), __read([].slice.call(document.querySelectorAll(d))), !1) : (isArray(d) ? u.push(getRefTargets(d, s)) : u.push(getRefTarget(d, s)), u);
  }, []);
}
function getAbsoluteRotation(a, s, c) {
  var u = getRad$1(a, s) / Math.PI * 180;
  return u = c >= 0 ? u : 180 - u, u = u >= 0 ? u : 360 + u, u;
}
function getDragDistByState(a, s) {
  var c = a.rootMatrix, u = a.is3d, d = u ? 4 : 3, p = invert(c, d);
  return u || (p = convertDimension(p, 3, 4)), p[12] = 0, p[13] = 0, p[14] = 0, calculateMatrixDist(p, s);
}
function getSizeDistByDist(a, s, c, u, d) {
  var p = __read(a, 2), v = p[0], A = p[1], x = 0, g = 0;
  if (d && v && A) {
    var b = getRad$1([0, 0], s), y = getRad$1([0, 0], u), f = getDistSize(s), m = Math.cos(b - y) * f;
    if (!u[0])
      g = m, x = g * c;
    else if (!u[1])
      x = m, g = x / c;
    else {
      var C = u[0] * v, w = u[1] * A, S = Math.atan2(C + s[0], w + s[1]), $ = Math.atan2(C, w);
      S < 0 && (S += Math.PI * 2), $ < 0 && ($ += Math.PI * 2);
      var T = 0;
      abs(S - $) < Math.PI / 2 || abs(S - $) > Math.PI / 2 * 3 || ($ += Math.PI), T = S - $, T > Math.PI * 2 ? T -= Math.PI * 2 : T > Math.PI ? T = 2 * Math.PI - T : T < -Math.PI && (T = -2 * Math.PI - T);
      var I = getDistSize([C + s[0], w + s[1]]) * Math.cos(T);
      x = I * Math.sin($) - C, g = I * Math.cos($) - w, u[0] < 0 && (x *= -1), u[1] < 0 && (g *= -1);
    }
  } else
    x = u[0] * s[0], g = u[1] * s[1];
  return [x, g];
}
function getOffsetSizeDist(a, s, c, u) {
  var d, p = c.ratio, v = c.startOffsetWidth, A = c.startOffsetHeight, x = 0, g = 0, b = u.distX, y = u.distY, f = u.pinchScale, m = u.parentDistance, C = u.parentDist, w = u.parentScale, S = c.fixedDirection, $ = [0, 1].map(function(O) {
    return abs(a[O] - S[O]);
  }), T = [0, 1].map(function(O) {
    var L = $[O];
    return L !== 0 && (L = 2 / L), L;
  });
  if (C)
    x = C[0], g = C[1], s && (x ? g || (g = x / p) : x = g * p);
  else if (isNumber(f))
    x = (f - 1) * v, g = (f - 1) * A;
  else if (w)
    x = (w[0] - 1) * v, g = (w[1] - 1) * A;
  else if (m) {
    var I = v * $[0], _ = A * $[1], E = getDistSize([I, _]);
    x = m / E * I * T[0], g = m / E * _ * T[1];
  } else {
    var R = getDragDist({ datas: c, distX: b, distY: y });
    R = T.map(function(O, L) {
      return R[L] * O;
    }), d = __read(getSizeDistByDist([v, A], R, p, a, s), 2), x = d[0], g = d[1];
  }
  return {
    // direction,
    // sizeDirection,
    distWidth: x,
    distHeight: g
  };
}
function convertTransformUnit(a, s) {
  if (s) {
    if (a === "left")
      return { x: "0%", y: "50%" };
    if (a === "top")
      return { x: "50%", y: "50%" };
    if (a === "center")
      return { x: "50%", y: "50%" };
    if (a === "right")
      return { x: "100%", y: "50%" };
    if (a === "bottom")
      return { x: "50%", y: "100%" };
    var c = __read(a.split(" "), 2), u = c[0], d = c[1], p = convertTransformUnit(u || ""), v = convertTransformUnit(d || ""), A = __assign$1(__assign$1({}, p), v), x = {
      x: "50%",
      y: "50%"
    };
    return A.x && (x.x = A.x), A.y && (x.y = A.y), A.value && (A.x && !A.y && (x.y = A.value), !A.x && A.y && (x.x = A.value)), x;
  }
  return a === "left" ? { x: "0%" } : a === "right" ? { x: "100%" } : a === "top" ? { y: "0%" } : a === "bottom" ? { y: "100%" } : a ? a === "center" ? { value: "50%" } : { value: a } : {};
}
function convertTransformOriginArray(a, s, c) {
  var u = convertTransformUnit(a, !0), d = u.x, p = u.y;
  return [
    convertUnitSize(d, s) || 0,
    convertUnitSize(p, c) || 0
  ];
}
function rotatePosesInfo(a, s, c) {
  var u = a.map(function(p) {
    return minus(p, s);
  }), d = u.map(function(p) {
    return rotate(p, c);
  });
  return {
    prev: u,
    next: d,
    result: d.map(function(p) {
      return plus(p, s);
    })
  };
}
function isDeepArrayEquals(a, s) {
  return a.length === s.length && a.every(function(c, u) {
    var d = s[u], p = isArray(c), v = isArray(d);
    return p && v ? isDeepArrayEquals(c, d) : !p && !v ? c === d : !1;
  });
}
function watchValue(a, s, c, u, d) {
  var p = a._store, v = p[s];
  if (!(s in p))
    if (d != null)
      p[s] = d, v = d;
    else
      return p[s] = c, c;
  return v === c || u(v) === u(c) ? v : (p[s] = c, c);
}
function sign(a) {
  return a >= 0 ? 1 : -1;
}
function abs(a) {
  return Math.abs(a);
}
function countEach(a, s) {
  return counter(a).map(function(c) {
    return s(c);
  });
}
function getPaddingBox(a) {
  return isNumber(a) ? {
    top: a,
    left: a,
    right: a,
    bottom: a
  } : {
    left: a.left || 0,
    top: a.top || 0,
    right: a.right || 0,
    bottom: a.bottom || 0
  };
}
var Pinchable = makeAble("pinchable", {
  props: [
    "pinchable"
  ],
  events: [
    "pinchStart",
    "pinch",
    "pinchEnd",
    "pinchGroupStart",
    "pinchGroup",
    "pinchGroupEnd"
  ],
  dragStart: function() {
    return !0;
  },
  pinchStart: function(a, s) {
    var c = s.datas, u = s.targets, d = s.angle, p = s.originalDatas, v = a.props, A = v.pinchable, x = v.ables;
    if (!A)
      return !1;
    var g = "onPinch".concat(u ? "Group" : "", "Start"), b = "drag".concat(u ? "Group" : "", "ControlStart"), y = (A === !0 ? a.controlAbles : x.filter(function(w) {
      return A.indexOf(w.name) > -1;
    })).filter(function(w) {
      return w.canPinch && w[b];
    }), f = fillParams(a, s, {});
    u && (f.targets = u);
    var m = triggerEvent(a, g, f);
    c.isPinch = m !== !1, c.ables = y;
    var C = c.isPinch;
    return C ? (y.forEach(function(w) {
      if (p[w.name] = p[w.name] || {}, !!w[b]) {
        var S = __assign$1(__assign$1({}, s), { datas: p[w.name], parentRotate: d, isPinch: !0 });
        w[b](a, S);
      }
    }), a.state.snapRenderInfo = {
      request: s.isRequest,
      direction: [0, 0]
    }, C) : !1;
  },
  pinch: function(a, s) {
    var c = s.datas, u = s.scale, d = s.distance, p = s.originalDatas, v = s.inputEvent, A = s.targets, x = s.angle;
    if (c.isPinch) {
      var g = d * (1 - 1 / u), b = fillParams(a, s, {});
      A && (b.targets = A);
      var y = "onPinch".concat(A ? "Group" : "");
      triggerEvent(a, y, b);
      var f = c.ables, m = "drag".concat(A ? "Group" : "", "Control");
      return f.forEach(function(C) {
        C[m] && C[m](a, __assign$1(__assign$1({}, s), { datas: p[C.name], inputEvent: v, resolveMatrix: !0, pinchScale: u, parentDistance: g, parentRotate: x, isPinch: !0 }));
      }), b;
    }
  },
  pinchEnd: function(a, s) {
    var c = s.datas, u = s.isPinch, d = s.inputEvent, p = s.targets, v = s.originalDatas;
    if (c.isPinch) {
      var A = "onPinch".concat(p ? "Group" : "", "End"), x = fillEndParams(a, s, { isDrag: u });
      p && (x.targets = p), triggerEvent(a, A, x);
      var g = c.ables, b = "drag".concat(p ? "Group" : "", "ControlEnd");
      return g.forEach(function(y) {
        y[b] && y[b](a, __assign$1(__assign$1({}, s), { isDrag: u, datas: v[y.name], inputEvent: d, isPinch: !0 }));
      }), u;
    }
  },
  pinchGroupStart: function(a, s) {
    return this.pinchStart(a, __assign$1(__assign$1({}, s), { targets: a.props.targets }));
  },
  pinchGroup: function(a, s) {
    return this.pinch(a, __assign$1(__assign$1({}, s), { targets: a.props.targets }));
  },
  pinchGroupEnd: function(a, s) {
    return this.pinchEnd(a, __assign$1(__assign$1({}, s), { targets: a.props.targets }));
  }
}), directionCondition = getDirectionCondition("scalable"), Scalable = {
  name: "scalable",
  ableGroup: "size",
  canPinch: !0,
  props: [
    "scalable",
    "throttleScale",
    "renderDirections",
    "keepRatio",
    "edge",
    "displayAroundControls"
  ],
  events: [
    "scaleStart",
    "beforeScale",
    "scale",
    "scaleEnd",
    "scaleGroupStart",
    "beforeScaleGroup",
    "scaleGroup",
    "scaleGroupEnd"
  ],
  render: getRenderDirections("scalable"),
  dragControlCondition: directionCondition,
  viewClassName: getDirectionViewClassName("scalable"),
  dragControlStart: function(a, s) {
    var c = s.datas, u = s.isPinch, d = s.inputEvent, p = s.parentDirection, v = getTotalDirection(p, u, d, c), A = a.state, x = A.width, g = A.height, b = A.targetTransform, y = A.target, f = A.pos1, m = A.pos2, C = A.pos4;
    if (!v || !y)
      return !1;
    u || setDragStart(a, s), c.datas = {}, c.transform = b, c.prevDist = [1, 1], c.direction = v, c.startOffsetWidth = x, c.startOffsetHeight = g, c.startValue = [1, 1];
    var w = !v[0] && !v[1] || v[0] || !v[1];
    setDefaultTransformIndex(a, s, "scale"), c.isWidth = w;
    function S(R) {
      c.ratio = R && isFinite(R) ? R : 0;
    }
    c.startPositions = getAbsolutePosesByState(a.state);
    function $(R) {
      var O = getFixedDirectionInfo(c.startPositions, R);
      c.fixedDirection = O.fixedDirection, c.fixedPosition = O.fixedPosition, c.fixedOffset = O.fixedOffset;
    }
    c.setFixedDirection = $, S(getDist$2(f, m) / getDist$2(m, C)), $([-v[0], -v[1]]);
    var T = function(R) {
      c.minScaleSize = R;
    }, I = function(R) {
      c.maxScaleSize = R;
    };
    T([-1 / 0, -1 / 0]), I([1 / 0, 1 / 0]);
    var _ = fillParams(a, s, __assign$1(__assign$1({ direction: v, set: function(R) {
      c.startValue = R;
    }, setRatio: S, setFixedDirection: $, setMinScaleSize: T, setMaxScaleSize: I }, fillTransformStartEvent(a, s)), { dragStart: Draggable.dragStart(a, new CustomGesto().dragStart([0, 0], s)) })), E = triggerEvent(a, "onScaleStart", _);
    return c.startFixedDirection = c.fixedDirection, E !== !1 && (c.isScale = !0, a.state.snapRenderInfo = {
      request: s.isRequest,
      direction: v
    }), c.isScale ? _ : !1;
  },
  dragControl: function(a, s) {
    resolveTransformEvent(a, s, "scale");
    var c = s.datas, u = s.parentKeepRatio, d = s.parentFlag, p = s.isPinch, v = s.dragClient, A = s.isRequest, x = s.useSnap, g = s.resolveMatrix, b = c.prevDist, y = c.direction, f = c.startOffsetWidth, m = c.startOffsetHeight, C = c.isScale, w = c.startValue, S = c.isWidth, $ = c.ratio;
    if (!C)
      return !1;
    var T = a.props, I = T.throttleScale, _ = T.parentMoveable, E = y;
    !y[0] && !y[1] && (E = [1, 1]);
    var R = $ && (u ?? T.keepRatio) || !1, O = a.state, L = [
      w[0],
      w[1]
    ];
    function B() {
      var ae = getOffsetSizeDist(E, R, c, s), se = ae.distWidth, ie = ae.distHeight, fe = f ? (f + se) / f : 1, ge = m ? (m + ie) / m : 1;
      w[0] || (L[0] = se / f), w[1] || (L[1] = ie / m);
      var me = (E[0] || R ? fe : 1) * L[0], pe = (E[1] || R ? ge : 1) * L[1];
      return me === 0 && (me = sign(b[0]) * MIN_SCALE), pe === 0 && (pe = sign(b[1]) * MIN_SCALE), [me, pe];
    }
    var F = B();
    if (!p && a.props.groupable) {
      var M = O.snapRenderInfo || {}, W = M.direction;
      isArray(W) && (W[0] || W[1]) && (O.snapRenderInfo = { direction: y, request: s.isRequest });
    }
    triggerEvent(a, "onBeforeScale", fillParams(a, s, {
      scale: F,
      setFixedDirection: function(ae) {
        return c.setFixedDirection(ae), F = B(), F;
      },
      startFixedDirection: c.startFixedDirection,
      setScale: function(ae) {
        F = ae;
      }
    }, !0));
    var j = [
      F[0] / L[0],
      F[1] / L[1]
    ], G = v, U = [0, 0], k = sign(j[0] * j[1]), N = !v && !d && p;
    if (N || g ? G = getTranslateFixedPosition(a, c.targetAllTransform, [0, 0], [0, 0], c) : v || (G = c.fixedPosition), p || (U = checkSnapScale(a, j, y, !x && A, c)), R) {
      E[0] && E[1] && U[0] && U[1] && (Math.abs(U[0] * f) > Math.abs(U[1] * m) ? U[1] = 0 : U[0] = 0);
      var P = !U[0] && !U[1];
      if (P && (S ? j[0] = throttle(j[0] * L[0], I) / L[0] : j[1] = throttle(j[1] * L[1], I) / L[1]), E[0] && !E[1] || U[0] && !U[1] || P && S) {
        j[0] += U[0];
        var D = f * j[0] * L[0] / $;
        j[1] = sign(k * j[0]) * abs(D / m / L[1]);
      } else if (!E[0] && E[1] || !U[0] && U[1] || P && !S) {
        j[1] += U[1];
        var H = m * j[1] * L[1] * $;
        j[0] = sign(k * j[1]) * abs(H / f / L[0]);
      }
    } else
      j[0] += U[0], j[1] += U[1], U[0] || (j[0] = throttle(j[0] * L[0], I) / L[0]), U[1] || (j[1] = throttle(j[1] * L[1], I) / L[1]);
    j[0] === 0 && (j[0] = sign(b[0]) * MIN_SCALE), j[1] === 0 && (j[1] = sign(b[1]) * MIN_SCALE), F = multiply2(j, [L[0], L[1]]);
    var V = [
      f,
      m
    ], Z = [
      f * F[0],
      m * F[1]
    ];
    Z = calculateBoundSize(Z, c.minScaleSize, c.maxScaleSize, R ? $ : !1), F = countEach(2, function(ae) {
      return V[ae] ? Z[ae] / V[ae] : Z[ae];
    }), j = countEach(2, function(ae) {
      return F[ae] / L[ae];
    });
    var ne = countEach(2, function(ae) {
      return b[ae] ? j[ae] / b[ae] : j[ae];
    }), K = "scale(".concat(j.join(", "), ")"), q = "scale(".concat(F.join(", "), ")"), Y = convertTransformFormat(c, q, K), ee = !w[0] || !w[1], Q = getScaleDist(a, ee ? q : K, c.fixedDirection, G, c.fixedOffset, c, ee), J = N ? Q : minus(Q, c.prevInverseDist || [0, 0]);
    if (c.prevDist = j, c.prevInverseDist = Q, F[0] === b[0] && F[1] === b[1] && J.every(function(ae) {
      return !ae;
    }) && !_ && !N)
      return !1;
    var te = fillParams(a, s, __assign$1({ offsetWidth: f, offsetHeight: m, direction: y, scale: F, dist: j, delta: ne, isPinch: !!p }, fillTransformEvent(a, Y, J, p, s)));
    return triggerEvent(a, "onScale", te), te;
  },
  dragControlEnd: function(a, s) {
    var c = s.datas;
    if (!c.isScale)
      return !1;
    c.isScale = !1;
    var u = fillEndParams(a, s, {});
    return triggerEvent(a, "onScaleEnd", u), u;
  },
  dragGroupControlCondition: directionCondition,
  dragGroupControlStart: function(a, s) {
    var c = s.datas, u = this.dragControlStart(a, s);
    if (!u)
      return !1;
    var d = fillChildEvents(a, "resizable", s);
    c.moveableScale = a.scale;
    var p = triggerChildAbles(a, this, "dragControlStart", s, function(g, b) {
      return startChildDist(a, g, c, b);
    }), v = function(g) {
      u.setFixedDirection(g), p.forEach(function(b, y) {
        b.setFixedDirection(g), startChildDist(a, b.moveable, c, d[y]);
      });
    };
    c.setFixedDirection = v;
    var A = __assign$1(__assign$1({}, u), { targets: a.props.targets, events: p, setFixedDirection: v }), x = triggerEvent(a, "onScaleGroupStart", A);
    return c.isScale = x !== !1, c.isScale ? A : !1;
  },
  dragGroupControl: function(a, s) {
    var c = s.datas;
    if (c.isScale) {
      catchEvent(a, "onBeforeScale", function(b) {
        triggerEvent(a, "onBeforeScaleGroup", fillParams(a, s, __assign$1(__assign$1({}, b), { targets: a.props.targets }), !0));
      });
      var u = this.dragControl(a, s);
      if (u) {
        var d = u.dist, p = c.moveableScale;
        a.scale = [
          d[0] * p[0],
          d[1] * p[1]
        ];
        var v = a.props.keepRatio, A = c.fixedPosition, x = triggerChildAbles(a, this, "dragControl", s, function(b, y) {
          var f = __read(calculate(createRotateMatrix(a.rotation / 180 * Math.PI, 3), [
            y.datas.originalX * d[0],
            y.datas.originalY * d[1],
            1
          ], 3), 2), m = f[0], C = f[1];
          return __assign$1(__assign$1({}, y), {
            parentDist: null,
            parentScale: d,
            parentKeepRatio: v,
            // recalculate child fixed position for parent group's dragging.
            dragClient: plus(A, [m, C])
          });
        }), g = __assign$1({ targets: a.props.targets, events: x }, u);
        return triggerEvent(a, "onScaleGroup", g), g;
      }
    }
  },
  dragGroupControlEnd: function(a, s) {
    var c = s.isDrag, u = s.datas;
    if (u.isScale) {
      this.dragControlEnd(a, s);
      var d = triggerChildAbles(a, this, "dragControlEnd", s), p = fillEndParams(a, s, {
        targets: a.props.targets,
        events: d
      });
      return triggerEvent(a, "onScaleGroupEnd", p), c;
    }
  },
  /**
       * @method Moveable.Scalable#request
       * @param {Moveable.Scalable.ScalableRequestParam} e - the Scalable's request parameter
       * @return {Moveable.Requester} Moveable Requester
       * @example
  
       * // Instantly Request (requestStart - request - requestEnd)
       * moveable.request("scalable", { deltaWidth: 10, deltaHeight: 10 }, true);
       *
       * // requestStart
       * const requester = moveable.request("scalable");
       *
       * // request
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       * requester.request({ deltaWidth: 10, deltaHeight: 10 });
       *
       * // requestEnd
       * requester.requestEnd();
       */
  request: function() {
    var a = {}, s = 0, c = 0, u = !1;
    return {
      isControl: !0,
      requestStart: function(d) {
        return u = d.useSnap, {
          datas: a,
          parentDirection: d.direction || [1, 1],
          useSnap: u
        };
      },
      request: function(d) {
        return s += d.deltaWidth, c += d.deltaHeight, {
          datas: a,
          parentDist: [s, c],
          parentKeepRatio: d.keepRatio,
          useSnap: u
        };
      },
      requestEnd: function() {
        return { datas: a, isDrag: !0, useSnap: u };
      }
    };
  }
};
function getMiddleLinePos(a, s) {
  return a.map(function(c, u) {
    return dot(c, s[u], 1, 2);
  });
}
function getTriangleRad(a, s, c) {
  var u = getRad$1(a, s), d = getRad$1(a, c), p = d - u;
  return p >= 0 ? p : p + 2 * Math.PI;
}
function isValidPos(a, s) {
  var c = getTriangleRad(a[0], a[1], a[2]), u = getTriangleRad(s[0], s[1], s[2]), d = Math.PI;
  return !(c >= d && u <= d || c <= d && u >= d);
}
var Warpable = {
  name: "warpable",
  ableGroup: "size",
  props: [
    "warpable",
    "renderDirections",
    "edge",
    "displayAroundControls"
  ],
  events: [
    "warpStart",
    "warp",
    "warpEnd"
  ],
  viewClassName: getDirectionViewClassName("warpable"),
  render: function(a, s) {
    var c = a.props, u = c.resizable, d = c.scalable, p = c.warpable, v = c.zoom;
    if (u || d || !p)
      return [];
    var A = a.state, x = A.pos1, g = A.pos2, b = A.pos3, y = A.pos4, f = getMiddleLinePos(x, g), m = getMiddleLinePos(g, x), C = getMiddleLinePos(x, b), w = getMiddleLinePos(b, x), S = getMiddleLinePos(b, y), $ = getMiddleLinePos(y, b), T = getMiddleLinePos(g, y), I = getMiddleLinePos(y, g);
    return __spreadArray$1([
      s.createElement("div", { className: prefix$1("line"), key: "middeLine1", style: getLineStyle(f, S, v) }),
      s.createElement("div", { className: prefix$1("line"), key: "middeLine2", style: getLineStyle(m, $, v) }),
      s.createElement("div", { className: prefix$1("line"), key: "middeLine3", style: getLineStyle(C, T, v) }),
      s.createElement("div", { className: prefix$1("line"), key: "middeLine4", style: getLineStyle(w, I, v) })
    ], __read(renderAllDirections(a, "warpable", s)), !1);
  },
  dragControlCondition: function(a, s) {
    if (s.isRequest)
      return !1;
    var c = s.inputEvent.target;
    return hasClass(c, prefix$1("direction")) && hasClass(c, prefix$1("warpable"));
  },
  dragControlStart: function(a, s) {
    var c = s.datas, u = s.inputEvent, d = a.props.target, p = u.target, v = getDirection(p, c);
    if (!v || !d)
      return !1;
    var A = a.state, x = A.transformOrigin, g = A.is3d, b = A.targetTransform, y = A.targetMatrix, f = A.width, m = A.height, C = A.left, w = A.top;
    c.datas = {}, c.targetTransform = b, c.warpTargetMatrix = g ? y : convertDimension(y, 3, 4), c.targetInverseMatrix = ignoreDimension(invert(c.warpTargetMatrix, 4), 3, 4), c.direction = v, c.left = C, c.top = w, c.poses = [
      [0, 0],
      [f, 0],
      [0, m],
      [f, m]
    ].map(function(T) {
      return minus(T, x);
    }), c.nextPoses = c.poses.map(function(T) {
      var I = __read(T, 2), _ = I[0], E = I[1];
      return calculate(c.warpTargetMatrix, [_, E, 0, 1], 4);
    }), c.startValue = createIdentityMatrix(4), c.prevMatrix = createIdentityMatrix(4), c.absolutePoses = getAbsolutePosesByState(A), c.posIndexes = getPosIndexesByDirection(v), setDragStart(a, s), setDefaultTransformIndex(a, s, "matrix3d"), A.snapRenderInfo = {
      request: s.isRequest,
      direction: v
    };
    var S = fillParams(a, s, __assign$1({ set: function(T) {
      c.startValue = T;
    } }, fillTransformStartEvent(a, s))), $ = triggerEvent(a, "onWarpStart", S);
    return $ !== !1 && (c.isWarp = !0), c.isWarp;
  },
  dragControl: function(a, s) {
    var c = s.datas, u = s.isRequest, d = s.distX, p = s.distY, v = c.targetInverseMatrix, A = c.prevMatrix, x = c.isWarp, g = c.startValue, b = c.poses, y = c.posIndexes, f = c.absolutePoses;
    if (!x)
      return !1;
    if (resolveTransformEvent(a, s, "matrix3d"), hasGuidelines(a, "warpable")) {
      var m = y.map(function(B) {
        return f[B];
      });
      m.length > 1 && m.push([
        (m[0][0] + m[1][0]) / 2,
        (m[0][1] + m[1][1]) / 2
      ]);
      var C = checkMoveableSnapBounds(a, u, {
        horizontal: m.map(function(B) {
          return B[1] + p;
        }),
        vertical: m.map(function(B) {
          return B[0] + d;
        })
      }), w = C.horizontal, S = C.vertical;
      p -= w.offset, d -= S.offset;
    }
    var $ = getDragDist({ datas: c, distX: d, distY: p }, !0), T = c.nextPoses.slice();
    if (y.forEach(function(B) {
      T[B] = plus(T[B], $);
    }), !NEARBY_POS.every(function(B) {
      return isValidPos(B.map(function(F) {
        return b[F];
      }), B.map(function(F) {
        return T[F];
      }));
    }))
      return !1;
    var I = createWarpMatrix(b[0], b[2], b[1], b[3], T[0], T[2], T[1], T[3]);
    if (!I.length)
      return !1;
    var _ = multiply(v, I, 4), E = getTransfromMatrix(c, _, !0), R = multiply(invert(A, 4), E, 4);
    c.prevMatrix = E;
    var O = multiply(g, E, 4), L = convertTransformFormat(c, "matrix3d(".concat(O.join(", "), ")"), "matrix3d(".concat(E.join(", "), ")"));
    return fillOriginalTransform(s, L), triggerEvent(a, "onWarp", fillParams(a, s, __assign$1({ delta: R, matrix: O, dist: E, multiply, transform: L }, fillCSSObject({
      transform: L
    }, s)))), !0;
  },
  dragControlEnd: function(a, s) {
    var c = s.datas, u = s.isDrag;
    return c.isWarp ? (c.isWarp = !1, triggerEvent(a, "onWarpEnd", fillEndParams(a, s, {})), u) : !1;
  }
}, AREA_PIECES = /* @__PURE__ */ prefix$1("area-pieces"), AREA_PIECE = /* @__PURE__ */ prefix$1("area-piece"), AVOID = /* @__PURE__ */ prefix$1("avoid"), VIEW_DRAGGING = prefix$1("view-dragging");
function restoreStyle(a) {
  var s = a.areaElement;
  if (s) {
    var c = a.state, u = c.width, d = c.height;
    removeClass(s, AVOID), s.style.cssText += "left: 0px; top: 0px; width: ".concat(u, "px; height: ").concat(d, "px");
  }
}
function renderPieces(a) {
  return a.createElement(
    "div",
    { key: "area_pieces", className: AREA_PIECES },
    a.createElement("div", { className: AREA_PIECE }),
    a.createElement("div", { className: AREA_PIECE }),
    a.createElement("div", { className: AREA_PIECE }),
    a.createElement("div", { className: AREA_PIECE })
  );
}
var DragArea = {
  name: "dragArea",
  props: [
    "dragArea",
    "passDragArea"
  ],
  events: [
    "click",
    "clickGroup"
  ],
  render: function(a, s) {
    var c = a.props, u = c.target, d = c.dragArea, p = c.groupable, v = c.passDragArea, A = a.getState(), x = A.width, g = A.height, b = A.renderPoses, y = v ? prefix$1("area", "pass") : prefix$1("area");
    if (p)
      return [
        s.createElement("div", { key: "area", ref: ref(a, "areaElement"), className: y }),
        renderPieces(s)
      ];
    if (!u || !d)
      return [];
    var f = createWarpMatrix([0, 0], [x, 0], [0, g], [x, g], b[0], b[1], b[2], b[3]), m = f.length ? makeMatrixCSS(f, !0) : "none";
    return [
      s.createElement("div", { key: "area", ref: ref(a, "areaElement"), className: y, style: {
        top: "0px",
        left: "0px",
        width: "".concat(x, "px"),
        height: "".concat(g, "px"),
        transformOrigin: "0 0",
        transform: m
      } }),
      renderPieces(s)
    ];
  },
  dragStart: function(a, s) {
    var c = s.datas, u = s.clientX, d = s.clientY, p = s.inputEvent;
    if (!p)
      return !1;
    c.isDragArea = !1;
    var v = a.areaElement, A = a.state, x = A.moveableClientRect, g = A.renderPoses, b = A.rootMatrix, y = A.is3d, f = x.left, m = x.top, C = getRect(g), w = C.left, S = C.top, $ = C.width, T = C.height, I = y ? 4 : 3, _ = __read(calculateInversePosition(b, [u - f, d - m], I), 2), E = _[0], R = _[1];
    E -= w, R -= S;
    var O = [
      { left: w, top: S, width: $, height: R - 10 },
      { left: w, top: S, width: E - 10, height: T },
      { left: w, top: S + R + 10, width: $, height: T - R - 10 },
      { left: w + E + 10, top: S, width: $ - E - 10, height: T }
    ], L = [].slice.call(v.nextElementSibling.children);
    O.forEach(function(B, F) {
      L[F].style.cssText = "left: ".concat(B.left, "px;top: ").concat(B.top, "px; width: ").concat(B.width, "px; height: ").concat(B.height, "px;");
    }), addClass(v, AVOID), A.disableNativeEvent = !0;
  },
  drag: function(a, s) {
    var c = s.datas, u = s.inputEvent;
    if (this.enableNativeEvent(a), !u)
      return !1;
    c.isDragArea || (c.isDragArea = !0, restoreStyle(a));
  },
  dragEnd: function(a, s) {
    this.enableNativeEvent(a);
    var c = s.inputEvent, u = s.datas;
    if (!c)
      return !1;
    u.isDragArea || restoreStyle(a);
  },
  dragGroupStart: function(a, s) {
    return this.dragStart(a, s);
  },
  dragGroup: function(a, s) {
    return this.drag(a, s);
  },
  dragGroupEnd: function(a, s) {
    return this.dragEnd(a, s);
  },
  unset: function(a) {
    restoreStyle(a), a.state.disableNativeEvent = !1;
  },
  enableNativeEvent: function(a) {
    var s = a.state;
    s.disableNativeEvent && requestAnimationFrame$1(function() {
      s.disableNativeEvent = !1;
    });
  }
}, Origin = makeAble("origin", {
  props: ["origin", "svgOrigin"],
  render: function(a, s) {
    var c = a.props, u = c.zoom, d = c.svgOrigin, p = c.groupable, v = a.getState(), A = v.beforeOrigin, x = v.rotation, g = v.svg, b = v.allMatrix, y = v.is3d, f = v.left, m = v.top, C = v.offsetWidth, w = v.offsetHeight, S;
    if (!p && g && d) {
      var $ = __read(convertTransformOriginArray(d, C, w), 2), T = $[0], I = $[1], _ = y ? 4 : 3, E = calculatePosition(b, [T, I], _);
      S = getControlTransform(x, u, minus(E, [f, m]));
    } else
      S = getControlTransform(x, u, A);
    return [
      s.createElement("div", { className: prefix$1("control", "origin"), style: S, key: "beforeOrigin" })
    ];
  }
});
function getDefaultScrollPosition(a) {
  var s = a.scrollContainer;
  return [
    s.scrollLeft,
    s.scrollTop
  ];
}
var Scrollable = {
  name: "scrollable",
  canPinch: !0,
  props: [
    "scrollable",
    "scrollContainer",
    "scrollThreshold",
    "scrollThrottleTime",
    "getScrollPosition",
    "scrollOptions"
  ],
  events: [
    "scroll",
    "scrollGroup"
  ],
  dragRelation: "strong",
  dragStart: function(a, s) {
    var c = a.props, u = c.scrollContainer, d = u === void 0 ? a.getContainer() : u, p = c.scrollOptions, v = new DragScroll(), A = getRefTarget(d, !0);
    s.datas.dragScroll = v, a.state.dragScroll = v;
    var x = s.isControl ? "controlGesto" : "targetGesto", g = s.targets;
    v.on("scroll", function(b) {
      var y = b.container, f = b.direction, m = fillParams(a, s, {
        scrollContainer: y,
        direction: f
      }), C = g ? "onScrollGroup" : "onScroll";
      g && (m.targets = g), triggerEvent(a, C, m);
    }).on("move", function(b) {
      var y = b.offsetX, f = b.offsetY, m = b.inputEvent;
      a[x].scrollBy(y, f, m.inputEvent, !1);
    }).on("scrollDrag", function(b) {
      var y = b.next;
      y(a[x].getCurrentEvent());
    }), v.dragStart(s, __assign$1({ container: A }, p));
  },
  checkScroll: function(a, s) {
    var c = s.datas.dragScroll;
    if (c) {
      var u = a.props, d = u.scrollContainer, p = d === void 0 ? a.getContainer() : d, v = u.scrollThreshold, A = v === void 0 ? 0 : v, x = u.scrollThrottleTime, g = x === void 0 ? 0 : x, b = u.getScrollPosition, y = b === void 0 ? getDefaultScrollPosition : b, f = u.scrollOptions;
      return c.drag(s, __assign$1({ container: p, threshold: A, throttleTime: g, getScrollPosition: function(m) {
        return y({ scrollContainer: m.container, direction: m.direction });
      } }, f)), !0;
    }
  },
  drag: function(a, s) {
    return this.checkScroll(a, s);
  },
  dragEnd: function(a, s) {
    s.datas.dragScroll.dragEnd(), s.datas.dragScroll = null;
  },
  dragControlStart: function(a, s) {
    return this.dragStart(a, __assign$1(__assign$1({}, s), { isControl: !0 }));
  },
  dragControl: function(a, s) {
    return this.drag(a, s);
  },
  dragControlEnd: function(a, s) {
    return this.dragEnd(a, s);
  },
  dragGroupStart: function(a, s) {
    return this.dragStart(a, __assign$1(__assign$1({}, s), { targets: a.props.targets }));
  },
  dragGroup: function(a, s) {
    return this.drag(a, __assign$1(__assign$1({}, s), { targets: a.props.targets }));
  },
  dragGroupEnd: function(a, s) {
    return this.dragEnd(a, __assign$1(__assign$1({}, s), { targets: a.props.targets }));
  },
  dragGroupControlStart: function(a, s) {
    return this.dragStart(a, __assign$1(__assign$1({}, s), { targets: a.props.targets, isControl: !0 }));
  },
  dragGroupControl: function(a, s) {
    return this.drag(a, __assign$1(__assign$1({}, s), { targets: a.props.targets }));
  },
  dragGroupControEnd: function(a, s) {
    return this.dragEnd(a, __assign$1(__assign$1({}, s), { targets: a.props.targets }));
  },
  unset: function(a) {
    var s, c = a.state;
    (s = c.dragScroll) === null || s === void 0 || s.dragEnd(), c.dragScroll = null;
  }
}, Default = {
  name: "",
  props: [
    "target",
    "dragTargetSelf",
    "dragTarget",
    "dragContainer",
    "container",
    "warpSelf",
    "rootContainer",
    "useResizeObserver",
    "useMutationObserver",
    "zoom",
    "dragFocusedInput",
    "transformOrigin",
    "ables",
    "className",
    "pinchThreshold",
    "pinchOutside",
    "triggerAblesSimultaneously",
    "checkInput",
    "cspNonce",
    "translateZ",
    "hideDefaultLines",
    "props",
    "flushSync",
    "stopPropagation",
    "preventClickEventOnDrag",
    "preventClickDefault",
    "viewContainer",
    "persistData",
    "useAccuratePosition",
    "firstRenderState",
    "linePadding",
    "controlPadding",
    "preventDefault",
    "preventRightClick",
    "preventWheelClick",
    "requestStyles"
  ],
  events: [
    "changeTargets"
  ]
}, Padding$1 = makeAble("padding", {
  props: ["padding"],
  render: function(a, s) {
    var c = a.props;
    if (c.dragArea)
      return [];
    var u = getPaddingBox(c.padding || {}), d = u.left, p = u.top, v = u.right, A = u.bottom, x = a.getState(), g = x.renderPoses, b = x.pos1, y = x.pos2, f = x.pos3, m = x.pos4, C = [b, y, f, m], w = [];
    return d > 0 && w.push([0, 2]), p > 0 && w.push([0, 1]), v > 0 && w.push([1, 3]), A > 0 && w.push([2, 3]), w.map(function(S, $) {
      var T = __read(S, 2), I = T[0], _ = T[1], E = C[I], R = C[_], O = g[I], L = g[_], B = createWarpMatrix([0, 0], [100, 0], [0, 100], [100, 100], E, R, O, L);
      if (B.length)
        return s.createElement("div", { key: "padding".concat($), className: prefix$1("padding"), style: {
          transform: makeMatrixCSS(B, !0)
        } });
    });
  }
}), RADIUS_DIRECTIONS = ["nw", "ne", "se", "sw"];
function calculateRatio(a, s) {
  var c = a[0] + a[1], u = c > s ? s / c : 1;
  return a[0] *= u, a[1] = s - a[1] * u, a;
}
var HORIZONTAL_RADIUS_ORDER = [1, 2, 5, 6], VERTICAL_RADIUS_ORDER = [0, 3, 4, 7], HORIZONTAL_RADIUS_DIRECTIONS = [1, -1, -1, 1], VERTICAL_RADIUS_DIRECTIONS = [1, 1, -1, -1];
function getRadiusStyles(a, s, c, u, d, p, v, A) {
  d === void 0 && (d = 0), p === void 0 && (p = 0), v === void 0 && (v = c), A === void 0 && (A = u);
  var x = [], g = !1, b = a.filter(function(f) {
    return !f.virtual;
  }), y = b.map(function(f) {
    var m = f.horizontal, C = f.vertical, w = f.pos;
    if (C && !g && (g = !0, x.push("/")), g) {
      var S = Math.max(0, C === 1 ? w[1] - p : A - w[1]);
      return x.push(convertCSSSize(S, u, s)), S;
    } else {
      var S = Math.max(0, m === 1 ? w[0] - d : v - w[0]);
      return x.push(convertCSSSize(S, c, s)), S;
    }
  });
  return {
    radiusPoses: b,
    styles: x,
    raws: y
  };
}
function getRadiusRange(a) {
  for (var s = [0, 0], c = [0, 0], u = a.length, d = 0; d < u; ++d) {
    var p = a[d];
    p.sub && (p.horizontal && (s[1] === 0 && (s[0] = d), s[1] = d - s[0] + 1, c[0] = d + 1), p.vertical && (c[1] === 0 && (c[0] = d), c[1] = d - c[0] + 1));
  }
  return {
    horizontalRange: s,
    verticalRange: c
  };
}
function getRadiusValues(a, s, c, u, d, p, v) {
  var A, x, g, b;
  p === void 0 && (p = [0, 0]), v === void 0 && (v = !1);
  var y = a.indexOf("/"), f = (y > -1 ? a.slice(0, y) : a).length, m = a.slice(0, f), C = a.slice(f + 1), w = m.length, S = C.length, $ = S > 0, T = __read(m, 4), I = T[0], _ = I === void 0 ? "0px" : I, E = T[1], R = E === void 0 ? _ : E, O = T[2], L = O === void 0 ? _ : O, B = T[3], F = B === void 0 ? R : B, M = __read(C, 4), W = M[0], j = W === void 0 ? _ : W, G = M[1], U = G === void 0 ? $ ? j : R : G, k = M[2], N = k === void 0 ? $ ? j : L : k, P = M[3], D = P === void 0 ? $ ? U : F : P, H = [_, R, L, F].map(function(Y) {
    return convertUnitSize(Y, s);
  }), V = [j, U, N, D].map(function(Y) {
    return convertUnitSize(Y, c);
  }), Z = H.slice(), ne = V.slice();
  A = __read(calculateRatio([Z[0], Z[1]], s), 2), Z[0] = A[0], Z[1] = A[1], x = __read(calculateRatio([Z[3], Z[2]], s), 2), Z[3] = x[0], Z[2] = x[1], g = __read(calculateRatio([ne[0], ne[3]], c), 2), ne[0] = g[0], ne[3] = g[1], b = __read(calculateRatio([ne[1], ne[2]], c), 2), ne[1] = b[0], ne[2] = b[1];
  var K = v ? Z : Z.slice(0, Math.max(p[0], w)), q = v ? ne : ne.slice(0, Math.max(p[1], S));
  return __spreadArray$1(__spreadArray$1([], __read(K.map(function(Y, ee) {
    var Q = RADIUS_DIRECTIONS[ee];
    return {
      virtual: ee >= w,
      horizontal: HORIZONTAL_RADIUS_DIRECTIONS[ee],
      vertical: 0,
      pos: [u + Y, d + (VERTICAL_RADIUS_DIRECTIONS[ee] === -1 ? c : 0)],
      sub: !0,
      raw: H[ee],
      direction: Q
    };
  })), !1), __read(q.map(function(Y, ee) {
    var Q = RADIUS_DIRECTIONS[ee];
    return {
      virtual: ee >= S,
      horizontal: 0,
      vertical: VERTICAL_RADIUS_DIRECTIONS[ee],
      pos: [u + (HORIZONTAL_RADIUS_DIRECTIONS[ee] === -1 ? s : 0), d + Y],
      sub: !0,
      raw: V[ee],
      direction: Q
    };
  })), !1);
}
function removeRadiusPos(a, s, c, u, d) {
  d === void 0 && (d = s.length);
  var p = getRadiusRange(a.slice(u)), v = p.horizontalRange, A = p.verticalRange, x = c - u, g = 0;
  if (x === 0)
    g = d;
  else if (x > 0 && x < v[1])
    g = v[1] - x;
  else if (x >= A[0])
    g = A[0] + A[1] - x;
  else
    return;
  a.splice(c, g), s.splice(c, g);
}
function addRadiusPos(a, s, c, u, d, p, v, A, x, g, b) {
  g === void 0 && (g = 0), b === void 0 && (b = 0);
  var y = getRadiusRange(a.slice(c)), f = y.horizontalRange, m = y.verticalRange;
  if (u > -1)
    for (var C = HORIZONTAL_RADIUS_DIRECTIONS[u] === 1 ? p - g : A - p, w = f[1]; w <= u; ++w) {
      var S = VERTICAL_RADIUS_DIRECTIONS[w] === 1 ? b : x, $ = 0;
      if (u === w ? $ = p : w === 0 ? $ = g + C : HORIZONTAL_RADIUS_DIRECTIONS[w] === -1 && ($ = A - (s[c][0] - g)), a.splice(c + w, 0, {
        horizontal: HORIZONTAL_RADIUS_DIRECTIONS[w],
        vertical: 0,
        pos: [$, S]
      }), s.splice(c + w, 0, [$, S]), w === 0)
        break;
    }
  else if (d > -1) {
    var T = VERTICAL_RADIUS_DIRECTIONS[d] === 1 ? v - b : x - v;
    if (f[1] === 0 && m[1] === 0) {
      var I = [
        g + T,
        b
      ];
      a.push({
        horizontal: HORIZONTAL_RADIUS_DIRECTIONS[0],
        vertical: 0,
        pos: I
      }), s.push(I);
    }
    for (var _ = m[0], w = m[1]; w <= d; ++w) {
      var $ = HORIZONTAL_RADIUS_DIRECTIONS[w] === 1 ? g : A, S = 0;
      if (d === w ? S = v : w === 0 ? S = b + T : VERTICAL_RADIUS_DIRECTIONS[w] === 1 ? S = s[c + _][1] : VERTICAL_RADIUS_DIRECTIONS[w] === -1 && (S = x - (s[c + _][1] - b)), a.push({
        horizontal: 0,
        vertical: VERTICAL_RADIUS_DIRECTIONS[w],
        pos: [$, S]
      }), s.push([$, S]), w === 0)
        break;
    }
  }
}
function splitRadiusPoses(a, s) {
  s === void 0 && (s = a.map(function(d) {
    return d.raw;
  }));
  var c = a.map(function(d, p) {
    return d.horizontal ? s[p] : null;
  }).filter(function(d) {
    return d != null;
  }), u = a.map(function(d, p) {
    return d.vertical ? s[p] : null;
  }).filter(function(d) {
    return d != null;
  });
  return {
    horizontals: c,
    verticals: u
  };
}
var CLIP_DIRECTIONS = [
  [0, -1, "n"],
  [1, 0, "e"]
], CLIP_RECT_DIRECTIONS = [
  [-1, -1, "nw"],
  [0, -1, "n"],
  [1, -1, "ne"],
  [1, 0, "e"],
  [1, 1, "se"],
  [0, 1, "s"],
  [-1, 1, "sw"],
  [-1, 0, "w"]
];
function getClipStyles(a, s, c) {
  var u = a.props.clipRelative, d = a.state, p = d.width, v = d.height, A = s, x = A.type, g = A.poses, b = x === "rect", y = x === "circle";
  if (x === "polygon")
    return c.map(function(R) {
      return "".concat(convertCSSSize(R[0], p, u), " ").concat(convertCSSSize(R[1], v, u));
    });
  if (b || x === "inset") {
    var f = c[1][1], m = c[3][0], C = c[7][0], w = c[5][1];
    if (b)
      return [
        f,
        m,
        w,
        C
      ].map(function(R) {
        return "".concat(R, "px");
      });
    var S = [f, p - m, v - w, C].map(function(R, O) {
      return convertCSSSize(R, O % 2 ? p : v, u);
    });
    if (c.length > 8) {
      var $ = __read(minus(c[4], c[0]), 2), T = $[0], I = $[1];
      S.push.apply(S, __spreadArray$1(["round"], __read(getRadiusStyles(g.slice(8).map(function(R, O) {
        return __assign$1(__assign$1({}, R), { pos: c[O] });
      }), u, T, I, C, f, m, w).styles), !1));
    }
    return S;
  } else if (y || x === "ellipse") {
    var _ = c[0], E = convertCSSSize(abs(c[1][1] - _[1]), y ? Math.sqrt((p * p + v * v) / 2) : v, u), S = y ? [E] : [convertCSSSize(abs(c[2][0] - _[0]), p, u), E];
    return S.push("at", convertCSSSize(_[0], p, u), convertCSSSize(_[1], v, u)), S;
  }
}
function getRectPoses(a, s, c, u) {
  var d = [u, (u + s) / 2, s], p = [a, (a + c) / 2, c];
  return CLIP_RECT_DIRECTIONS.map(function(v) {
    var A = __read(v, 3), x = A[0], g = A[1], b = A[2], y = d[x + 1], f = p[g + 1];
    return {
      vertical: abs(g),
      horizontal: abs(x),
      direction: b,
      pos: [y, f]
    };
  });
}
function getControlSize(a) {
  var s = [1 / 0, -1 / 0], c = [1 / 0, -1 / 0];
  return a.forEach(function(u) {
    var d = u.pos;
    s[0] = Math.min(s[0], d[0]), s[1] = Math.max(s[1], d[0]), c[0] = Math.min(c[0], d[1]), c[1] = Math.max(c[1], d[1]);
  }), [
    abs(s[1] - s[0]),
    abs(c[1] - c[0])
  ];
}
function getClipPath(a, s, c, u, d) {
  var p, v, A, x, g, b, y, f, m;
  if (a) {
    var C = d;
    if (!C) {
      var w = getCachedStyle(a), S = w("clipPath");
      C = S !== "none" ? S : w("clip");
    }
    if (!((!C || C === "none" || C === "auto") && (C = u, !C))) {
      var $ = splitBracket(C), T = $.prefix, I = T === void 0 ? C : T, _ = $.value, E = _ === void 0 ? "" : _, R = I === "circle", O = " ";
      if (I === "polygon") {
        var L = splitComma(E || "0% 0%, 100% 0%, 100% 100%, 0% 100%");
        O = ",";
        var B = L.map(function(he) {
          var ye = __read(he.split(" "), 2), Ce = ye[0], xe = ye[1];
          return {
            vertical: 1,
            horizontal: 1,
            pos: [
              convertUnitSize(Ce, s),
              convertUnitSize(xe, c)
            ]
          };
        }), F = getMinMaxs(B.map(function(he) {
          return he.pos;
        }));
        return {
          type: I,
          clipText: C,
          poses: B,
          splitter: O,
          left: F.minX,
          right: F.maxX,
          top: F.minY,
          bottom: F.maxY
        };
      } else if (R || I === "ellipse") {
        var M = "", W = "", j = 0, G = 0, L = splitSpace(E);
        if (R) {
          var U = "";
          p = __read(L, 4), v = p[0], U = v === void 0 ? "50%" : v, A = p[2], M = A === void 0 ? "50%" : A, x = p[3], W = x === void 0 ? "50%" : x, j = convertUnitSize(U, Math.sqrt((s * s + c * c) / 2)), G = j;
        } else {
          var k = "", N = "";
          g = __read(L, 5), b = g[0], k = b === void 0 ? "50%" : b, y = g[1], N = y === void 0 ? "50%" : y, f = g[3], M = f === void 0 ? "50%" : f, m = g[4], W = m === void 0 ? "50%" : m, j = convertUnitSize(k, s), G = convertUnitSize(N, c);
        }
        var P = [
          convertUnitSize(M, s),
          convertUnitSize(W, c)
        ], B = __spreadArray$1([
          {
            vertical: 1,
            horizontal: 1,
            pos: P,
            direction: "nesw"
          }
        ], __read(CLIP_DIRECTIONS.slice(0, R ? 1 : 2).map(function(Ce) {
          return {
            vertical: abs(Ce[1]),
            horizontal: Ce[0],
            direction: Ce[2],
            sub: !0,
            pos: [
              P[0] + Ce[0] * j,
              P[1] + Ce[1] * G
            ]
          };
        })), !1);
        return {
          type: I,
          clipText: C,
          radiusX: j,
          radiusY: G,
          left: P[0] - j,
          top: P[1] - G,
          right: P[0] + j,
          bottom: P[1] + G,
          poses: B,
          splitter: O
        };
      } else if (I === "inset") {
        var L = splitSpace(E || "0 0 0 0"), D = L.indexOf("round"), H = (D > -1 ? L.slice(0, D) : L).length, V = L.slice(H + 1), Z = __read(L.slice(0, H), 4), ne = Z[0], K = Z[1], q = K === void 0 ? ne : K, Y = Z[2], ee = Y === void 0 ? ne : Y, Q = Z[3], J = Q === void 0 ? q : Q, te = __read([ne, ee].map(function(Ce) {
          return convertUnitSize(Ce, c);
        }), 2), ae = te[0], se = te[1], ie = __read([J, q].map(function(Ce) {
          return convertUnitSize(Ce, s);
        }), 2), fe = ie[0], ge = ie[1], me = s - ge, pe = c - se, be = getRadiusValues(V, me - fe, pe - ae, fe, ae), B = __spreadArray$1(__spreadArray$1([], __read(getRectPoses(ae, me, pe, fe)), !1), __read(be), !1);
        return {
          type: "inset",
          clipText: C,
          poses: B,
          top: ae,
          left: fe,
          right: me,
          bottom: pe,
          radius: V,
          splitter: O
        };
      } else if (I === "rect") {
        var L = splitComma(E || "0px, ".concat(s, "px, ").concat(c, "px, 0px"));
        O = ",";
        var le = __read(L.map(function($e) {
          var Ae = splitUnit($e).value;
          return Ae;
        }), 4), ve = le[0], ge = le[1], se = le[2], fe = le[3], B = getRectPoses(ve, ge, se, fe);
        return {
          type: "rect",
          clipText: C,
          poses: B,
          top: ve,
          right: ge,
          bottom: se,
          left: fe,
          values: L,
          splitter: O
        };
      }
    }
  }
}
function moveControlPos(a, s, c, u, d) {
  var p = a[s], v = p.direction, A = p.sub, x = a.map(function() {
    return [0, 0];
  }), g = v ? v.split("") : [];
  if (u && s < 8) {
    var b = g.filter(function(j) {
      return j === "w" || j === "e";
    }), y = g.filter(function(j) {
      return j === "n" || j === "s";
    }), f = b[0], m = y[0];
    x[s] = c;
    var C = __read(getControlSize(a), 2), w = C[0], S = C[1], $ = w && S ? w / S : 0;
    if ($ && d) {
      var T = (s + 4) % 8, I = a[T].pos, _ = [0, 0];
      v.indexOf("w") > -1 ? _[0] = -1 : v.indexOf("e") > -1 && (_[0] = 1), v.indexOf("n") > -1 ? _[1] = -1 : v.indexOf("s") > -1 && (_[1] = 1);
      var E = getSizeDistByDist([w, S], c, $, _, !0), R = w + E[0], O = S + E[1], L = I[1], B = I[1], F = I[0], M = I[0];
      _[0] === -1 ? F = M - R : _[0] === 1 ? M = F + R : (F = F - R / 2, M = M + R / 2), _[1] === -1 ? L = B - O : (_[1] === 1 || (L = B - O / 2), B = L + O);
      var W = getRectPoses(L, M, B, F);
      a.forEach(function(j, G) {
        x[G][0] = W[G].pos[0] - j.pos[0], x[G][1] = W[G].pos[1] - j.pos[1];
      });
    } else
      a.forEach(function(j, G) {
        var U = j.direction;
        U && (U.indexOf(f) > -1 && (x[G][0] = c[0]), U.indexOf(m) > -1 && (x[G][1] = c[1]));
      }), f && (x[1][0] = c[0] / 2, x[5][0] = c[0] / 2), m && (x[3][1] = c[1] / 2, x[7][1] = c[1] / 2);
  } else v && !A ? g.forEach(function(j) {
    var G = j === "n" || j === "s";
    a.forEach(function(U, k) {
      var N = U.direction, P = U.horizontal, D = U.vertical;
      !N || N.indexOf(j) === -1 || (x[k] = [
        G || !P ? 0 : c[0],
        !G || !D ? 0 : c[1]
      ]);
    });
  }) : x[s] = c;
  return x;
}
function addClipPath(a, s) {
  var c = __read(calculatePointerDist(a, s), 2), u = c[0], d = c[1], p = s.datas, v = p.clipPath, A = p.clipIndex, x = v, g = x.type, b = x.poses, y = x.splitter, f = b.map(function(T) {
    return T.pos;
  });
  if (g === "polygon")
    f.splice(A, 0, [u, d]);
  else if (g === "inset") {
    var m = HORIZONTAL_RADIUS_ORDER.indexOf(A), C = VERTICAL_RADIUS_ORDER.indexOf(A), w = b.length;
    if (addRadiusPos(b, f, 8, m, C, u, d, f[4][0], f[4][1], f[0][0], f[0][1]), w === b.length)
      return;
  } else
    return;
  var S = getClipStyles(a, v, f), $ = "".concat(g, "(").concat(S.join(y), ")");
  triggerEvent(a, "onClip", fillParams(a, s, __assign$1({ clipEventType: "added", clipType: g, poses: f, clipStyles: S, clipStyle: $, distX: 0, distY: 0 }, fillCSSObject({
    clipPath: $
  }, s))));
}
function removeClipPath(a, s) {
  var c = s.datas, u = c.clipPath, d = c.clipIndex, p = u, v = p.type, A = p.poses, x = p.splitter, g = A.map(function(m) {
    return m.pos;
  }), b = g.length;
  if (v === "polygon")
    A.splice(d, 1), g.splice(d, 1);
  else if (v === "inset") {
    if (d < 8 || (removeRadiusPos(A, g, d, 8, b), b === A.length))
      return;
  } else
    return;
  var y = getClipStyles(a, u, g), f = "".concat(v, "(").concat(y.join(x), ")");
  triggerEvent(a, "onClip", fillParams(a, s, __assign$1({ clipEventType: "removed", clipType: v, poses: g, clipStyles: y, clipStyle: f, distX: 0, distY: 0 }, fillCSSObject({
    clipPath: f
  }, s))));
}
var Clippable = {
  name: "clippable",
  props: [
    "clippable",
    "defaultClipPath",
    "customClipPath",
    "keepRatio",
    "clipRelative",
    "clipArea",
    "dragWithClip",
    "clipTargetBounds",
    "clipVerticalGuidelines",
    "clipHorizontalGuidelines",
    "clipSnapThreshold"
  ],
  events: [
    "clipStart",
    "clip",
    "clipEnd"
  ],
  css: [
    `.control.clip-control {
background: #6d6;
cursor: pointer;
}
.control.clip-control.clip-radius {
background: #d66;
}
.line.clip-line {
background: #6e6;
cursor: move;
z-index: 1;
}
.clip-area {
position: absolute;
top: 0;
left: 0;
}
.clip-ellipse {
position: absolute;
cursor: move;
border: 1px solid #6d6;
border: var(--zoompx) solid #6d6;
border-radius: 50%;
transform-origin: 0px 0px;
}`,
    `:host {
--bounds-color: #d66;
}`,
    `.guideline {
pointer-events: none;
z-index: 2;
}`,
    `.line.guideline.bounds {
background: #d66;
background: var(--bounds-color);
}`
  ],
  render: function(a, s) {
    var c = a.props, u = c.customClipPath, d = c.defaultClipPath, p = c.clipArea, v = c.zoom, A = c.groupable, x = a.getState(), g = x.target, b = x.width, y = x.height, f = x.allMatrix, m = x.is3d, C = x.left, w = x.top, S = x.pos1, $ = x.pos2, T = x.pos3, I = x.pos4, _ = x.clipPathState, E = x.snapBoundInfos, R = x.rotation;
    if (!g || A)
      return [];
    var O = getClipPath(g, b, y, d || "inset", _ || u);
    if (!O)
      return [];
    var L = m ? 4 : 3, B = O.type, F = O.poses, M = F.map(function(ge) {
      var me = calculatePosition(f, ge.pos, L);
      return [
        me[0] - C,
        me[1] - w
      ];
    }), W = [], j = [], G = B === "rect", U = B === "inset", k = B === "polygon";
    if (G || U || k) {
      var N = U ? M.slice(0, 8) : M;
      j = N.map(function(ge, me) {
        var pe = me === 0 ? N[N.length - 1] : N[me - 1], be = getRad$1(pe, ge), le = getDiagonalSize(pe, ge);
        return s.createElement("div", { key: "clipLine".concat(me), className: prefix$1("line", "clip-line", "snap-control"), "data-clip-index": me, style: {
          width: "".concat(le, "px"),
          transform: "translate(".concat(pe[0], "px, ").concat(pe[1], "px) rotate(").concat(be, "rad) scaleY(").concat(v, ")")
        } });
      });
    }
    if (W = M.map(function(ge, me) {
      return s.createElement("div", { key: "clipControl".concat(me), className: prefix$1("control", "clip-control", "snap-control"), "data-clip-index": me, style: {
        transform: "translate(".concat(ge[0], "px, ").concat(ge[1], "px) rotate(").concat(R, "rad) scale(").concat(v, ")")
      } });
    }), U && W.push.apply(W, __spreadArray$1([], __read(M.slice(8).map(function(ge, me) {
      return s.createElement("div", { key: "clipRadiusControl".concat(me), className: prefix$1("control", "clip-control", "clip-radius", "snap-control"), "data-clip-index": 8 + me, style: {
        transform: "translate(".concat(ge[0], "px, ").concat(ge[1], "px) rotate(").concat(R, "rad) scale(").concat(v, ")")
      } });
    })), !1)), B === "circle" || B === "ellipse") {
      var P = O.left, D = O.top, H = O.radiusX, V = O.radiusY, Z = __read(minus(calculatePosition(f, [P, D], L), calculatePosition(f, [0, 0], L)), 2), ne = Z[0], K = Z[1], q = "none";
      if (!p) {
        for (var Y = Math.max(10, H / 5, V / 5), ee = [], Q = 0; Q <= Y; ++Q) {
          var J = Math.PI * 2 / Y * Q;
          ee.push([
            H + (H - v) * Math.cos(J),
            V + (V - v) * Math.sin(J)
          ]);
        }
        ee.push([H, -2]), ee.push([-2, -2]), ee.push([-2, V * 2 + 2]), ee.push([H * 2 + 2, V * 2 + 2]), ee.push([H * 2 + 2, -2]), ee.push([H, -2]), q = "polygon(".concat(ee.map(function(ge) {
          return "".concat(ge[0], "px ").concat(ge[1], "px");
        }).join(", "), ")");
      }
      W.push(s.createElement("div", { key: "clipEllipse", className: prefix$1("clip-ellipse", "snap-control"), style: {
        width: "".concat(H * 2, "px"),
        height: "".concat(V * 2, "px"),
        clipPath: q,
        transform: "translate(".concat(-C + ne, "px, ").concat(-w + K, "px) ").concat(makeMatrixCSS(f))
      } }));
    }
    if (p) {
      var te = getRect(__spreadArray$1([S, $, T, I], __read(M), !1)), ae = te.width, se = te.height, ie = te.left, fe = te.top;
      if (k || G || U) {
        var ee = U ? M.slice(0, 8) : M;
        W.push(s.createElement("div", { key: "clipArea", className: prefix$1("clip-area", "snap-control"), style: {
          width: "".concat(ae, "px"),
          height: "".concat(se, "px"),
          transform: "translate(".concat(ie, "px, ").concat(fe, "px)"),
          clipPath: "polygon(".concat(ee.map(function(me) {
            return "".concat(me[0] - ie, "px ").concat(me[1] - fe, "px");
          }).join(", "), ")")
        } }));
      }
    }
    return E && ["vertical", "horizontal"].forEach(function(ge) {
      var me = E[ge], pe = ge === "horizontal";
      me.isSnap && j.push.apply(j, __spreadArray$1([], __read(me.snap.posInfos.map(function(be, le) {
        var ve = be.pos, he = minus(calculatePosition(f, pe ? [0, ve] : [ve, 0], L), [C, w]), ye = minus(calculatePosition(f, pe ? [b, ve] : [ve, y], L), [C, w]);
        return renderLine(s, "", he, ye, v, "clip".concat(ge, "snap").concat(le), "guideline");
      })), !1)), me.isBound && j.push.apply(j, __spreadArray$1([], __read(me.bounds.map(function(be, le) {
        var ve = be.pos, he = minus(calculatePosition(f, pe ? [0, ve] : [ve, 0], L), [C, w]), ye = minus(calculatePosition(f, pe ? [b, ve] : [ve, y], L), [C, w]);
        return renderLine(s, "", he, ye, v, "clip".concat(ge, "bounds").concat(le), "guideline", "bounds", "bold");
      })), !1));
    }), __spreadArray$1(__spreadArray$1([], __read(W), !1), __read(j), !1);
  },
  dragControlCondition: function(a, s) {
    return s.inputEvent && (s.inputEvent.target.getAttribute("class") || "").indexOf("clip") > -1;
  },
  dragStart: function(a, s) {
    var c = a.props, u = c.dragWithClip, d = u === void 0 ? !0 : u;
    return d ? !1 : this.dragControlStart(a, s);
  },
  drag: function(a, s) {
    return this.dragControl(a, __assign$1(__assign$1({}, s), { isDragTarget: !0 }));
  },
  dragEnd: function(a, s) {
    return this.dragControlEnd(a, s);
  },
  dragControlStart: function(a, s) {
    var c = a.state, u = a.props, d = u.defaultClipPath, p = u.customClipPath, v = c.target, A = c.width, x = c.height, g = s.inputEvent ? s.inputEvent.target : null, b = g && g.getAttribute("class") || "", y = s.datas, f = getClipPath(v, A, x, d || "inset", p);
    if (!f)
      return !1;
    var m = f.clipText, C = f.type, w = f.poses, S = triggerEvent(a, "onClipStart", fillParams(a, s, {
      clipType: C,
      clipStyle: m,
      poses: w.map(function($) {
        return $.pos;
      })
    }));
    return S === !1 ? (y.isClipStart = !1, !1) : (y.isControl = b && b.indexOf("clip-control") > -1, y.isLine = b.indexOf("clip-line") > -1, y.isArea = b.indexOf("clip-area") > -1 || b.indexOf("clip-ellipse") > -1, y.clipIndex = g ? parseInt(g.getAttribute("data-clip-index"), 10) : -1, y.clipPath = f, y.isClipStart = !0, c.clipPathState = m, setDragStart(a, s), !0);
  },
  dragControl: function(a, s) {
    var c, u, d, p = s.datas, v = s.originalDatas, A = s.isDragTarget;
    if (!p.isClipStart)
      return !1;
    var x = p, g = x.isControl, b = x.isLine, y = x.isArea, f = x.clipIndex, m = x.clipPath;
    if (!m)
      return !1;
    var C = getProps(a.props, "clippable"), w = C.keepRatio, S = 0, $ = 0, T = v.draggable, I = getDragDist(s);
    A && T ? (c = __read(T.prevBeforeDist, 2), S = c[0], $ = c[1]) : (u = __read(I, 2), S = u[0], $ = u[1]);
    var _ = [S, $], E = a.state, R = E.width, O = E.height, L = !y && !g && !b, B = m.type, F = m.poses, M = m.splitter, W = F.map(function(je) {
      return je.pos;
    });
    L && (S = -S, $ = -$);
    var j = !g || F[f].direction === "nesw", G = B === "inset" || B === "rect", U = F.map(function() {
      return [0, 0];
    });
    if (g && !j) {
      var k = F[f], N = k.horizontal, P = k.vertical, D = [
        S * abs(N),
        $ * abs(P)
      ];
      U = moveControlPos(F, f, D, G, w);
    } else j && (U = W.map(function() {
      return [S, $];
    }));
    var H = W.map(function(je, Le) {
      return plus(je, U[Le]);
    }), V = __spreadArray$1([], __read(H), !1);
    E.snapBoundInfos = null;
    var Z = m.type === "circle", ne = m.type === "ellipse";
    if (Z || ne) {
      var K = getRect(H), q = abs(K.bottom - K.top), Y = abs(ne ? K.right - K.left : q), ee = H[0][1] + q, Q = H[0][0] - Y, J = H[0][0] + Y;
      Z && (V.push([J, K.bottom]), U.push([1, 0])), V.push([K.left, ee]), U.push([0, 1]), V.push([Q, K.bottom]), U.push([1, 0]);
    }
    var te = getDefaultGuidelines((C.clipHorizontalGuidelines || []).map(function(je) {
      return convertUnitSize("".concat(je), O);
    }), (C.clipVerticalGuidelines || []).map(function(je) {
      return convertUnitSize("".concat(je), R);
    }), R, O), ae = [], se = [];
    if (Z || ne)
      ae = [V[4][0], V[2][0]], se = [V[1][1], V[3][1]];
    else if (G) {
      var ie = [V[0], V[2], V[4], V[6]], fe = [U[0], U[2], U[4], U[6]];
      ae = ie.filter(function(je, Le) {
        return fe[Le][0];
      }).map(function(je) {
        return je[0];
      }), se = ie.filter(function(je, Le) {
        return fe[Le][1];
      }).map(function(je) {
        return je[1];
      });
    } else
      ae = V.filter(function(je, Le) {
        return U[Le][0];
      }).map(function(je) {
        return je[0];
      }), se = V.filter(function(je, Le) {
        return U[Le][1];
      }).map(function(je) {
        return je[1];
      });
    var ge = [0, 0], me = checkSnapBounds(te, C.clipTargetBounds && { left: 0, top: 0, right: R, bottom: O }, ae, se, 5, 5), pe = me.horizontal, be = me.vertical, le = pe.offset, ve = be.offset;
    if (pe.isBound && (ge[1] += le), be.isBound && (ge[0] += ve), (ne || Z) && U[0][0] === 0 && U[0][1] === 0) {
      var K = getRect(H), he = K.bottom - K.top, ye = ne ? K.right - K.left : he, Ce = be.isBound ? abs(ve) : be.snapIndex === 0 ? -ve : ve, xe = pe.isBound ? abs(le) : pe.snapIndex === 0 ? -le : le;
      ye -= Ce, he -= xe, Z && (he = checkSnapBoundPriority(be, pe) > 0 ? he : ye, ye = he);
      var we = V[0];
      V[1][1] = we[1] - he, V[2][0] = we[0] + ye, V[3][1] = we[1] + he, V[4][0] = we[0] - ye;
    } else if (G && w && g) {
      var $e = __read(getControlSize(F), 2), Ae = $e[0], ue = $e[1], ce = Ae && ue ? Ae / ue : 0, Ee = F[f], _e = Ee.direction || "", Te = V[1][1], ee = V[5][1], Q = V[7][0], J = V[3][0];
      abs(le) <= abs(ve) ? le = sign(le) * abs(ve) / ce : ve = sign(ve) * abs(le) * ce, _e.indexOf("w") > -1 ? Q -= ve : _e.indexOf("e") > -1 ? J -= ve : (Q += ve / 2, J -= ve / 2), _e.indexOf("n") > -1 ? Te -= le : _e.indexOf("s") > -1 ? ee -= le : (Te += le / 2, ee -= le / 2);
      var ke = getRectPoses(Te, J, ee, Q);
      V.forEach(function(Ne, Ge) {
        var Xe;
        Xe = __read(ke[Ge].pos, 2), Ne[0] = Xe[0], Ne[1] = Xe[1];
      });
    } else
      V.forEach(function(je, Le) {
        var De = U[Le];
        De[0] && (je[0] -= ve), De[1] && (je[1] -= le);
      });
    var Re = getClipStyles(a, m, H), Be = "".concat(B, "(").concat(Re.join(M), ")");
    if (E.clipPathState = Be, Z || ne)
      ae = [V[4][0], V[2][0]], se = [V[1][1], V[3][1]];
    else if (G) {
      var ie = [V[0], V[2], V[4], V[6]];
      ae = ie.map(function(Le) {
        return Le[0];
      }), se = ie.map(function(Le) {
        return Le[1];
      });
    } else
      ae = V.map(function(je) {
        return je[0];
      }), se = V.map(function(je) {
        return je[1];
      });
    if (E.snapBoundInfos = checkSnapBounds(te, C.clipTargetBounds && { left: 0, top: 0, right: R, bottom: O }, ae, se, 1, 1), T) {
      var Oe = E.is3d, Me = E.allMatrix, Fe = Oe ? 4 : 3, Ue = ge;
      A && (Ue = [
        _[0] + ge[0] - I[0],
        _[1] + ge[1] - I[1]
      ]), T.deltaOffset = multiply(Me, [Ue[0], Ue[1], 0, 0], Fe);
    }
    return triggerEvent(a, "onClip", fillParams(a, s, __assign$1({ clipEventType: "changed", clipType: B, poses: H, clipStyle: Be, clipStyles: Re, distX: S, distY: $ }, fillCSSObject((d = {}, d[B === "rect" ? "clip" : "clipPath"] = Be, d), s)))), !0;
  },
  dragControlEnd: function(a, s) {
    this.unset(a);
    var c = s.isDrag, u = s.datas, d = s.isDouble, p = u.isLine, v = u.isClipStart, A = u.isControl;
    return v ? (triggerEvent(a, "onClipEnd", fillEndParams(a, s, {})), d && (A ? removeClipPath(a, s) : p && addClipPath(a, s)), d || c) : !1;
  },
  unset: function(a) {
    a.state.clipPathState = "", a.state.snapBoundInfos = null;
  }
}, OriginDraggable = {
  name: "originDraggable",
  props: [
    "originDraggable",
    "originRelative"
  ],
  events: [
    "dragOriginStart",
    "dragOrigin",
    "dragOriginEnd"
  ],
  css: [
    `:host[data-able-origindraggable] .control.origin {
pointer-events: auto;
}`
  ],
  dragControlCondition: function(a, s) {
    return s.isRequest ? s.requestAble === "originDraggable" : hasClass(s.inputEvent.target, prefix$1("origin"));
  },
  dragControlStart: function(a, s) {
    var c = s.datas;
    setDragStart(a, s);
    var u = fillParams(a, s, {
      dragStart: Draggable.dragStart(a, new CustomGesto().dragStart([0, 0], s))
    }), d = triggerEvent(a, "onDragOriginStart", u);
    return c.startOrigin = a.state.transformOrigin, c.startTargetOrigin = a.state.targetOrigin, c.prevOrigin = [0, 0], c.isDragOrigin = !0, d === !1 ? (c.isDragOrigin = !1, !1) : u;
  },
  dragControl: function(a, s) {
    var c = s.datas, u = s.isPinch, d = s.isRequest;
    if (!c.isDragOrigin)
      return !1;
    var p = __read(getDragDist(s), 2), v = p[0], A = p[1], x = a.state, g = x.width, b = x.height, y = x.offsetMatrix, f = x.targetMatrix, m = x.is3d, C = a.props.originRelative, w = C === void 0 ? !0 : C, S = m ? 4 : 3, $ = [v, A];
    if (d) {
      var T = s.distOrigin;
      (T[0] || T[1]) && ($ = T);
    }
    var I = plus(c.startOrigin, $), _ = plus(c.startTargetOrigin, $), E = minus($, c.prevOrigin), R = getNextMatrix(y, f, I, S), O = a.getRect(), L = getRect(calculatePoses(R, g, b, S)), B = [
      O.left - L.left,
      O.top - L.top
    ];
    c.prevOrigin = $;
    var F = [
      convertCSSSize(_[0], g, w),
      convertCSSSize(_[1], b, w)
    ].join(" "), M = Draggable.drag(a, setCustomDrag(s, a.state, B, !!u)), W = fillParams(a, s, __assign$1(__assign$1({ width: g, height: b, origin: I, dist: $, delta: E, transformOrigin: F, drag: M }, fillCSSObject({
      transformOrigin: F,
      transform: M.transform
    }, s)), { afterTransform: M.transform }));
    return triggerEvent(a, "onDragOrigin", W), W;
  },
  dragControlEnd: function(a, s) {
    var c = s.datas;
    return c.isDragOrigin ? (triggerEvent(a, "onDragOriginEnd", fillEndParams(a, s, {})), !0) : !1;
  },
  dragGroupControlCondition: function(a, s) {
    return this.dragControlCondition(a, s);
  },
  dragGroupControlStart: function(a, s) {
    var c = this.dragControlStart(a, s);
    return !!c;
  },
  dragGroupControl: function(a, s) {
    var c = this.dragControl(a, s);
    return c ? (a.transformOrigin = c.transformOrigin, !0) : !1;
  },
  /**
      * @method Moveable.OriginDraggable#request
      * @param {object} e - the OriginDraggable's request parameter
      * @param {number} [e.x] - x position
      * @param {number} [e.y] - y position
      * @param {number} [e.deltaX] - x number to move
      * @param {number} [e.deltaY] - y number to move
      * @param {array} [e.deltaOrigin] - left, top number to move transform-origin
      * @param {array} [e.origin] - transform-origin position
      * @param {number} [e.isInstant] - Whether to execute the request instantly
      * @return {Moveable.Requester} Moveable Requester
      * @example
  
      * // Instantly Request (requestStart - request - requestEnd)
      * // Use Relative Value
      * moveable.request("originDraggable", { deltaX: 10, deltaY: 10 }, true);
      * // Use Absolute Value
      * moveable.request("originDraggable", { x: 200, y: 100 }, true);
      * // Use Transform Value
      * moveable.request("originDraggable", { deltaOrigin: [10, 0] }, true);
      * moveable.request("originDraggable", { origin: [100, 0] }, true);
      * // requestStart
      * const requester = moveable.request("originDraggable");
      *
      * // request
      * // Use Relative Value
      * requester.request({ deltaX: 10, deltaY: 10 });
      * requester.request({ deltaX: 10, deltaY: 10 });
      * requester.request({ deltaX: 10, deltaY: 10 });
      * // Use Absolute Value
      * moveable.request("originDraggable", { x: 200, y: 100 });
      * moveable.request("originDraggable", { x: 220, y: 100 });
      * moveable.request("originDraggable", { x: 240, y: 100 });
      *
      * // requestEnd
      * requester.requestEnd();
      */
  request: function(a) {
    var s = {}, c = a.getRect(), u = 0, d = 0, p = c.transformOrigin, v = [0, 0];
    return {
      isControl: !0,
      requestStart: function() {
        return { datas: s };
      },
      request: function(A) {
        return "deltaOrigin" in A ? (v[0] += A.deltaOrigin[0], v[1] += A.deltaOrigin[1]) : "origin" in A ? (v[0] = A.origin[0] - p[0], v[1] = A.origin[1] - p[1]) : ("x" in A ? u = A.x - c.left : "deltaX" in A && (u += A.deltaX), "y" in A ? d = A.y - c.top : "deltaY" in A && (d += A.deltaY)), { datas: s, distX: u, distY: d, distOrigin: v };
      },
      requestEnd: function() {
        return { datas: s, isDrag: !0 };
      }
    };
  }
};
function addBorderRadiusByLine(a, s, c, u) {
  var d = a.filter(function(x) {
    var g = x.virtual, b = x.horizontal;
    return b && !g;
  }).length, p = a.filter(function(x) {
    var g = x.virtual, b = x.vertical;
    return b && !g;
  }).length, v = -1;
  if (s === 0 && (d === 0 ? v = 0 : d === 1 && (v = 1)), s === 2 && (d <= 2 ? v = 2 : d <= 3 && (v = 3)), s === 3 && (p === 0 ? v = 4 : p < 4 && (v = 7)), s === 1 && (p <= 1 ? v = 5 : p <= 2 && (v = 6)), !(v === -1 || !a[v].virtual)) {
    var A = a[v];
    addBorderRadius(a, v), v < 4 ? A.pos[0] = c : A.pos[1] = u;
  }
}
function addBorderRadius(a, s) {
  s < 4 ? a.slice(0, s + 1).forEach(function(c) {
    c.virtual = !1;
  }) : (a[0].virtual && (a[0].virtual = !1), a.slice(4, s + 1).forEach(function(c) {
    c.virtual = !1;
  }));
}
function removeBorderRadius(a, s) {
  s < 4 ? a.slice(s, 4).forEach(function(c) {
    c.virtual = !0;
  }) : a.slice(s).forEach(function(c) {
    c.virtual = !0;
  });
}
function getBorderRadius(a, s, c, u, d) {
  u === void 0 && (u = [0, 0]);
  var p = [];
  return !a || a === "0px" ? p = [] : p = splitSpace(a), getRadiusValues(p, s, c, 0, 0, u, d);
}
function triggerRoundEvent(a, s, c, u, d) {
  var p = a.state, v = p.width, A = p.height, x = getRadiusStyles(d, a.props.roundRelative, v, A), g = x.raws, b = x.styles, y = x.radiusPoses, f = splitRadiusPoses(y, g), m = f.horizontals, C = f.verticals, w = b.join(" ");
  p.borderRadiusState = w;
  var S = fillParams(a, s, __assign$1({ horizontals: m, verticals: C, borderRadius: w, width: v, height: A, delta: u, dist: c }, fillCSSObject({
    borderRadius: w
  }, s)));
  return triggerEvent(a, "onRound", S), S;
}
function getStyleBorderRadius(a) {
  var s, c, u = a.getState().style, d = u.borderRadius || "";
  if (!d && a.props.groupable) {
    var p = a.moveables[0], v = a.getTargets()[0];
    v && (p?.props.target === v ? (d = (c = (s = a.moveables[0]) === null || s === void 0 ? void 0 : s.state.style.borderRadius) !== null && c !== void 0 ? c : "", u.borderRadius = d) : (d = getComputedStyle$1(v).borderRadius, u.borderRadius = d));
  }
  return d;
}
var Roundable = {
  name: "roundable",
  props: [
    "roundable",
    "roundRelative",
    "minRoundControls",
    "maxRoundControls",
    "roundClickable",
    "roundPadding",
    "isDisplayShadowRoundControls"
  ],
  events: [
    "roundStart",
    "round",
    "roundEnd",
    "roundGroupStart",
    "roundGroup",
    "roundGroupEnd"
  ],
  css: [
    `.control.border-radius {
background: #d66;
cursor: pointer;
z-index: 3;
}`,
    `.control.border-radius.vertical {
background: #d6d;
z-index: 2;
}`,
    `.control.border-radius.virtual {
opacity: 0.5;
z-index: 1;
}`,
    `:host.round-line-clickable .line.direction {
cursor: pointer;
}`
  ],
  className: function(a) {
    var s = a.props.roundClickable;
    return s === !0 || s === "line" ? prefix$1("round-line-clickable") : "";
  },
  requestStyle: function() {
    return ["borderRadius"];
  },
  requestChildStyle: function() {
    return ["borderRadius"];
  },
  render: function(a, s) {
    var c = a.getState(), u = c.target, d = c.width, p = c.height, v = c.allMatrix, A = c.is3d, x = c.left, g = c.top, b = c.borderRadiusState, y = a.props, f = y.minRoundControls, m = f === void 0 ? [0, 0] : f, C = y.maxRoundControls, w = C === void 0 ? [4, 4] : C, S = y.zoom, $ = y.roundPadding, T = $ === void 0 ? 0 : $, I = y.isDisplayShadowRoundControls, _ = y.groupable;
    if (!u)
      return null;
    var E = b || getStyleBorderRadius(a), R = A ? 4 : 3, O = getBorderRadius(E, d, p, m, !0);
    if (!O)
      return null;
    var L = 0, B = 0, F = _ ? [0, 0] : [x, g];
    return O.map(function(M, W) {
      var j = M.horizontal, G = M.vertical, U = M.direction || "", k = __spreadArray$1([], __read(M.pos), !1);
      B += Math.abs(j), L += Math.abs(G), j && U.indexOf("n") > -1 && (k[1] -= T), G && U.indexOf("w") > -1 && (k[0] -= T), j && U.indexOf("s") > -1 && (k[1] += T), G && U.indexOf("e") > -1 && (k[0] += T);
      var N = minus(calculatePosition(v, k, R), F), P = I && I !== "horizontal", D = M.vertical ? L <= w[1] && (P || !M.virtual) : B <= w[0] && (I || !M.virtual);
      return s.createElement("div", { key: "borderRadiusControl".concat(W), className: prefix$1("control", "border-radius", M.vertical ? "vertical" : "", M.virtual ? "virtual" : ""), "data-radius-index": W, style: {
        display: D ? "block" : "none",
        transform: "translate(".concat(N[0], "px, ").concat(N[1], "px) scale(").concat(S, ")")
      } });
    });
  },
  dragControlCondition: function(a, s) {
    if (!s.inputEvent || s.isRequest)
      return !1;
    var c = s.inputEvent.target.getAttribute("class") || "";
    return c.indexOf("border-radius") > -1 || c.indexOf("moveable-line") > -1 && c.indexOf("moveable-direction") > -1;
  },
  dragGroupControlCondition: function(a, s) {
    return this.dragControlCondition(a, s);
  },
  dragControlStart: function(a, s) {
    var c = s.inputEvent, u = s.datas, d = c.target, p = d.getAttribute("class") || "", v = p.indexOf("border-radius") > -1, A = p.indexOf("moveable-line") > -1 && p.indexOf("moveable-direction") > -1, x = v ? parseInt(d.getAttribute("data-radius-index"), 10) : -1, g = -1;
    if (A) {
      var b = d.getAttribute("data-line-key") || "";
      b && (g = parseInt(b.replace(/render-line-/g, ""), 10), isNaN(g) && (g = -1));
    }
    if (!v && !A)
      return !1;
    var y = fillParams(a, s, {}), f = triggerEvent(a, "onRoundStart", y);
    if (f === !1)
      return !1;
    u.lineIndex = g, u.controlIndex = x, u.isControl = v, u.isLine = A, setDragStart(a, s);
    var m = a.props, C = m.roundRelative, w = m.minRoundControls, S = w === void 0 ? [0, 0] : w, $ = a.state, T = $.width, I = $.height;
    u.isRound = !0, u.prevDist = [0, 0];
    var _ = getStyleBorderRadius(a), E = getBorderRadius(_ || "", T, I, S, !0) || [];
    return u.controlPoses = E, $.borderRadiusState = getRadiusStyles(E, C, T, I).styles.join(" "), y;
  },
  dragControl: function(a, s) {
    var c = s.datas, u = c.controlPoses;
    if (!c.isRound || !c.isControl || !u.length)
      return !1;
    var d = c.controlIndex, p = __read(getDragDist(s), 2), v = p[0], A = p[1], x = [v, A], g = minus(x, c.prevDist), b = a.props.maxRoundControls, y = b === void 0 ? [4, 4] : b, f = a.state, m = f.width, C = f.height, w = u[d], S = w.vertical, $ = w.horizontal, T = u.map(function(_) {
      var E = _.horizontal, R = _.vertical, O = [
        E * $ * x[0],
        R * S * x[1]
      ];
      if (E) {
        if (y[0] === 1)
          return O;
        if (y[0] < 4 && E !== $)
          return O;
      } else {
        if (y[1] === 0)
          return O[1] = R * $ * x[0] / m * C, O;
        if (S) {
          if (y[1] === 1)
            return O;
          if (y[1] < 4 && R !== S)
            return O;
        }
      }
      return [0, 0];
    });
    T[d] = x;
    var I = u.map(function(_, E) {
      return __assign$1(__assign$1({}, _), { pos: plus(_.pos, T[E]) });
    });
    return d < 4 ? I.slice(0, d + 1).forEach(function(_) {
      _.virtual = !1;
    }) : I.slice(4, d + 1).forEach(function(_) {
      _.virtual = !1;
    }), c.prevDist = [v, A], triggerRoundEvent(a, s, x, g, I);
  },
  dragControlEnd: function(a, s) {
    var c = a.state;
    c.borderRadiusState = "";
    var u = s.datas, d = s.isDouble;
    if (!u.isRound)
      return !1;
    var p = u.isControl, v = u.controlIndex, A = u.isLine, x = u.lineIndex, g = u.controlPoses, b = g.filter(function($) {
      var T = $.virtual;
      return T;
    }).length, y = a.props.roundClickable, f = y === void 0 ? !0 : y;
    if (d && f) {
      if (p && (f === !0 || f === "control"))
        removeBorderRadius(g, v);
      else if (A && (f === !0 || f === "line")) {
        var m = __read(calculatePointerDist(a, s), 2), C = m[0], w = m[1];
        addBorderRadiusByLine(g, x, C, w);
      }
      b !== g.filter(function($) {
        var T = $.virtual;
        return T;
      }).length && triggerRoundEvent(a, s, [0, 0], [0, 0], g);
    }
    var S = fillEndParams(a, s, {});
    return triggerEvent(a, "onRoundEnd", S), c.borderRadiusState = "", S;
  },
  dragGroupControlStart: function(a, s) {
    var c = this.dragControlStart(a, s);
    if (!c)
      return !1;
    var u = a.moveables, d = a.props.targets, p = fillChildEvents(a, "roundable", s), v = __assign$1({ targets: a.props.targets, events: p.map(function(A, x) {
      return __assign$1(__assign$1({}, A), { target: d[x], moveable: u[x], currentTarget: u[x] });
    }) }, c);
    return triggerEvent(a, "onRoundGroupStart", v), c;
  },
  dragGroupControl: function(a, s) {
    var c = this.dragControl(a, s);
    if (!c)
      return !1;
    var u = a.moveables, d = a.props.targets, p = fillChildEvents(a, "roundable", s), v = __assign$1({ targets: a.props.targets, events: p.map(function(A, x) {
      return __assign$1(__assign$1(__assign$1({}, A), { target: d[x], moveable: u[x], currentTarget: u[x] }), fillCSSObject({
        borderRadius: c.borderRadius
      }, A));
    }) }, c);
    return triggerEvent(a, "onRoundGroup", v), v;
  },
  dragGroupControlEnd: function(a, s) {
    var c = a.moveables, u = a.props.targets, d = fillChildEvents(a, "roundable", s);
    catchEvent(a, "onRound", function(A) {
      var x = __assign$1({ targets: a.props.targets, events: d.map(function(g, b) {
        return __assign$1(__assign$1(__assign$1({}, g), { target: u[b], moveable: c[b], currentTarget: c[b] }), fillCSSObject({
          borderRadius: A.borderRadius
        }, g));
      }) }, A);
      triggerEvent(a, "onRoundGroup", x);
    });
    var p = this.dragControlEnd(a, s);
    if (!p)
      return !1;
    var v = __assign$1({ targets: a.props.targets, events: d.map(function(A, x) {
      var g;
      return __assign$1(__assign$1({}, A), { target: u[x], moveable: c[x], currentTarget: c[x], lastEvent: (g = A.datas) === null || g === void 0 ? void 0 : g.lastEvent });
    }) }, p);
    return triggerEvent(a, "onRoundGroupEnd", v), v;
  },
  unset: function(a) {
    a.state.borderRadiusState = "";
  }
};
function isIdentityMatrix(a, s) {
  var c = s ? 4 : 3, u = createIdentityMatrix(c), d = "matrix".concat(s ? "3d" : "", "(").concat(u.join(","), ")");
  return a === d || a === "matrix(1,0,0,1,0,0)";
}
var BeforeRenderable = {
  isPinch: !0,
  name: "beforeRenderable",
  props: [],
  events: [
    "beforeRenderStart",
    "beforeRender",
    "beforeRenderEnd",
    "beforeRenderGroupStart",
    "beforeRenderGroup",
    "beforeRenderGroupEnd"
  ],
  dragRelation: "weak",
  setTransform: function(a, s) {
    var c = a.state, u = c.is3d, d = c.targetMatrix, p = c.inlineTransform, v = u ? "matrix3d(".concat(d.join(","), ")") : "matrix(".concat(convertMatrixtoCSS(d, !0), ")"), A = !p || p === "none" ? v : p;
    s.datas.startTransforms = isIdentityMatrix(A, u) ? [] : splitSpace(A);
  },
  resetStyle: function(a) {
    var s = a.datas;
    s.nextStyle = {}, s.nextTransforms = a.datas.startTransforms, s.nextTransformAppendedIndexes = [];
  },
  fillDragStartParams: function(a, s) {
    return fillParams(a, s, {
      setTransform: function(c) {
        s.datas.startTransforms = isArray(c) ? c : splitSpace(c);
      },
      isPinch: !!s.isPinch
    });
  },
  fillDragParams: function(a, s) {
    return fillParams(a, s, {
      isPinch: !!s.isPinch
    });
  },
  dragStart: function(a, s) {
    this.setTransform(a, s), this.resetStyle(s), triggerEvent(a, "onBeforeRenderStart", this.fillDragStartParams(a, s));
  },
  drag: function(a, s) {
    s.datas.startTransforms || this.setTransform(a, s), this.resetStyle(s), triggerEvent(a, "onBeforeRender", fillParams(a, s, {
      isPinch: !!s.isPinch
    }));
  },
  dragEnd: function(a, s) {
    s.datas.startTransforms || (this.setTransform(a, s), this.resetStyle(s)), triggerEvent(a, "onBeforeRenderEnd", fillParams(a, s, {
      isPinch: !!s.isPinch,
      isDrag: s.isDrag
    }));
  },
  dragGroupStart: function(a, s) {
    var c = this;
    this.dragStart(a, s);
    var u = fillChildEvents(a, "beforeRenderable", s), d = a.moveables, p = u.map(function(v, A) {
      var x = d[A];
      return c.setTransform(x, v), c.resetStyle(v), c.fillDragStartParams(x, v);
    });
    triggerEvent(a, "onBeforeRenderGroupStart", fillParams(a, s, {
      isPinch: !!s.isPinch,
      targets: a.props.targets,
      setTransform: function() {
      },
      events: p
    }));
  },
  dragGroup: function(a, s) {
    var c = this;
    this.drag(a, s);
    var u = fillChildEvents(a, "beforeRenderable", s), d = a.moveables, p = u.map(function(v, A) {
      var x = d[A];
      return c.resetStyle(v), c.fillDragParams(x, v);
    });
    triggerEvent(a, "onBeforeRenderGroup", fillParams(a, s, {
      isPinch: !!s.isPinch,
      targets: a.props.targets,
      events: p
    }));
  },
  dragGroupEnd: function(a, s) {
    this.dragEnd(a, s), triggerEvent(a, "onBeforeRenderGroupEnd", fillParams(a, s, {
      isPinch: !!s.isPinch,
      isDrag: s.isDrag,
      targets: a.props.targets
    }));
  },
  dragControlStart: function(a, s) {
    return this.dragStart(a, s);
  },
  dragControl: function(a, s) {
    return this.drag(a, s);
  },
  dragControlEnd: function(a, s) {
    return this.dragEnd(a, s);
  },
  dragGroupControlStart: function(a, s) {
    return this.dragGroupStart(a, s);
  },
  dragGroupControl: function(a, s) {
    return this.dragGroup(a, s);
  },
  dragGroupControlEnd: function(a, s) {
    return this.dragGroupEnd(a, s);
  }
}, Renderable = {
  name: "renderable",
  props: [],
  events: [
    "renderStart",
    "render",
    "renderEnd",
    "renderGroupStart",
    "renderGroup",
    "renderGroupEnd"
  ],
  dragRelation: "weak",
  dragStart: function(a, s) {
    triggerEvent(a, "onRenderStart", fillParams(a, s, {
      isPinch: !!s.isPinch
    }));
  },
  drag: function(a, s) {
    triggerEvent(a, "onRender", this.fillDragParams(a, s));
  },
  dragAfter: function(a, s) {
    return this.drag(a, s);
  },
  dragEnd: function(a, s) {
    triggerEvent(a, "onRenderEnd", this.fillDragEndParams(a, s));
  },
  dragGroupStart: function(a, s) {
    triggerEvent(a, "onRenderGroupStart", fillParams(a, s, {
      isPinch: !!s.isPinch,
      targets: a.props.targets
    }));
  },
  dragGroup: function(a, s) {
    var c = this, u = fillChildEvents(a, "beforeRenderable", s), d = a.moveables, p = u.map(function(v, A) {
      var x = d[A];
      return c.fillDragParams(x, v);
    });
    triggerEvent(a, "onRenderGroup", fillParams(a, s, __assign$1(__assign$1({ isPinch: !!s.isPinch, targets: a.props.targets, transform: getNextTransformText(s), transformObject: {} }, fillCSSObject(getNextStyle(s))), { events: p })));
  },
  dragGroupEnd: function(a, s) {
    var c = this, u = fillChildEvents(a, "beforeRenderable", s), d = a.moveables, p = u.map(function(v, A) {
      var x = d[A];
      return c.fillDragEndParams(x, v);
    });
    triggerEvent(a, "onRenderGroupEnd", fillParams(a, s, __assign$1({ isPinch: !!s.isPinch, isDrag: s.isDrag, targets: a.props.targets, events: p, transformObject: {}, transform: getNextTransformText(s) }, fillCSSObject(getNextStyle(s)))));
  },
  dragControlStart: function(a, s) {
    return this.dragStart(a, s);
  },
  dragControl: function(a, s) {
    return this.drag(a, s);
  },
  dragControlAfter: function(a, s) {
    return this.dragAfter(a, s);
  },
  dragControlEnd: function(a, s) {
    return this.dragEnd(a, s);
  },
  dragGroupControlStart: function(a, s) {
    return this.dragGroupStart(a, s);
  },
  dragGroupControl: function(a, s) {
    return this.dragGroup(a, s);
  },
  dragGroupControlEnd: function(a, s) {
    return this.dragGroupEnd(a, s);
  },
  fillDragParams: function(a, s) {
    var c = {};
    return parse(getNextTransforms(s) || []).forEach(function(u) {
      c[u.name] = u.functionValue;
    }), fillParams(a, s, __assign$1({ isPinch: !!s.isPinch, transformObject: c, transform: getNextTransformText(s) }, fillCSSObject(getNextStyle(s))));
  },
  fillDragEndParams: function(a, s) {
    var c = {};
    return parse(getNextTransforms(s) || []).forEach(function(u) {
      c[u.name] = u.functionValue;
    }), fillParams(a, s, __assign$1({ isPinch: !!s.isPinch, isDrag: s.isDrag, transformObject: c, transform: getNextTransformText(s) }, fillCSSObject(getNextStyle(s))));
  }
};
function triggerAble(a, s, c, u, d, p, v) {
  p.clientDistX = p.distX, p.clientDistY = p.distY;
  var A = d === "Start", x = d === "End", g = d === "After", b = a.state.target, y = p.isRequest, f = u.indexOf("Control") > -1;
  if (!b || A && f && !y && a.areaElement === p.inputEvent.target)
    return !1;
  var m = __spreadArray$1([], __read(s), !1);
  if (y) {
    var C = p.requestAble;
    m.some(function(W) {
      return W.name === C;
    }) || m.push.apply(m, __spreadArray$1([], __read(a.props.ables.filter(function(W) {
      return W.name === C;
    })), !1));
  }
  if (!m.length || m.every(function(W) {
    return W.dragRelation;
  }))
    return !1;
  var w = p.inputEvent, S;
  x && w && (S = document.elementFromPoint(p.clientX, p.clientY) || w.target);
  var $ = !1, T = function() {
    var W;
    $ = !0, (W = p.stop) === null || W === void 0 || W.call(p);
  }, I = A && (!a.targetGesto || !a.controlGesto || !a.targetGesto.isFlag() || !a.controlGesto.isFlag());
  I && a.updateRect(d, !0, !1);
  var _ = p.datas, E = f ? "controlGesto" : "targetGesto", R = a[E], O = function(W, j, G) {
    if (!(j in W) || R !== a[E])
      return !1;
    var U = W.name, k = _[U] || (_[U] = {});
    if (A && (k.isEventStart = !G || !W[G] || W[G](a, p)), !k.isEventStart)
      return !1;
    var N = W[j](a, __assign$1(__assign$1({}, p), { stop: T, datas: k, originalDatas: _, inputTarget: S }));
    return a._emitter.off(), A && N === !1 && (k.isEventStart = !1), N;
  };
  I && m.forEach(function(W) {
    W.unset && W.unset(a);
  }), O(BeforeRenderable, "drag".concat(u).concat(d));
  var L = 0, B = 0;
  c.forEach(function(W) {
    if ($)
      return !1;
    var j = "".concat(W).concat(u).concat(d), G = "".concat(W).concat(u, "Condition");
    d === "" && !y && convertDragDist(a.state, p);
    var U = m.filter(function(P) {
      return P[j];
    });
    U = U.filter(function(P, D) {
      return P.name && U.indexOf(P) === D;
    });
    var k = U.filter(function(P) {
      return O(P, j, G);
    }), N = k.length;
    $ && ++L, N && ++B, !$ && A && U.length && !N && (L += U.filter(function(P) {
      var D = P.name, H = _[D];
      return H.isEventStart ? P.dragRelation !== "strong" : !1;
    }).length ? 1 : 0);
  }), (!g || B) && O(Renderable, "drag".concat(u).concat(d));
  var F = R !== a[E] || L === c.length;
  if ((x || $ || F) && (a.state.gestos = {}, a.moveables && a.moveables.forEach(function(W) {
    W.state.gestos = {};
  }), m.forEach(function(W) {
    W.unset && W.unset(a);
  })), A && !F && !y && B && a.props.preventDefault && p?.preventDefault(), a.isUnmounted || F)
    return !1;
  if (!A && B && !v || x) {
    var M = a.props.flushSync || defaultSync;
    M(function() {
      a.updateRect(x ? d : "", !0, !1), a.forceUpdate();
    });
  }
  return !A && !x && !g && B && !v && triggerAble(a, s, c, u, d + "After", p), !0;
}
function checkMoveableTarget(a, s) {
  return function(c, u) {
    var d;
    u === void 0 && (u = c.inputEvent.target);
    var p = u, v = a.areaElement, A = a._dragTarget;
    return !A || !s && (!((d = a.controlGesto) === null || d === void 0) && d.isFlag()) ? !1 : p === A || A.contains(p) || p === v || !a.isMoveableElement(p) && !a.controlBox.contains(p) || hasClass(p, "moveable-area") || hasClass(p, "moveable-padding") || hasClass(p, "moveable-edgeDraggable");
  };
}
function getTargetAbleGesto(a, s, c) {
  var u = a.controlBox, d = [], p = a.props, v = p.dragArea, A = a.state.target, x = p.dragTarget;
  d.push(u), (!v || x) && d.push(s), !v && x && A && s !== A && p.dragTargetSelf && d.push(A);
  var g = checkMoveableTarget(a);
  return getAbleGesto(a, d, "targetAbles", c, {
    dragStart: g,
    pinchStart: g
  });
}
function getControlAbleGesto(a, s) {
  var c = a.controlBox, u = [];
  u.push(c);
  var d = checkMoveableTarget(a, !0), p = function(v, A) {
    if (A === void 0 && (A = v.inputEvent.target), A === c)
      return !0;
    var x = d(v, A);
    return !x;
  };
  return getAbleGesto(a, u, "controlAbles", s, {
    dragStart: p,
    pinchStart: p
  });
}
function getAbleGesto(a, s, c, u, d) {
  d === void 0 && (d = {});
  var p = c === "targetAbles", v = a.props, A = v.pinchOutside, x = v.pinchThreshold, g = v.preventClickEventOnDrag, b = v.preventClickDefault, y = v.checkInput, f = v.dragFocusedInput, m = v.preventDefault, C = m === void 0 ? !0 : m, w = v.preventRightClick, S = w === void 0 ? !0 : w, $ = v.preventWheelClick, T = $ === void 0 ? !0 : $, I = v.dragContainer, _ = getRefTarget(I, !0), E = {
    preventDefault: C,
    preventRightClick: S,
    preventWheelClick: T,
    container: _ || getWindow(a.getControlBoxElement()),
    pinchThreshold: x,
    pinchOutside: A,
    preventClickEventOnDrag: p ? g : !1,
    preventClickEventOnDragStart: p ? b : !1,
    preventClickEventByCondition: p ? null : function(L) {
      return a.controlBox.contains(L.target);
    },
    checkInput: p ? y : !1,
    dragFocusedInput: f
  }, R = new Gesto(s, E), O = u === "Control";
  return ["drag", "pinch"].forEach(function(L) {
    ["Start", "", "End"].forEach(function(B) {
      R.on("".concat(L).concat(B), function(F) {
        var M, W = F.eventType, j = L === "drag" && F.isPinch;
        if (d[W] && !d[W](F)) {
          F.stop();
          return;
        }
        if (!j) {
          var G = L === "drag" ? [L] : ["drag", L], U = __spreadArray$1([], __read(a[c]), !1), k = triggerAble(a, U, G, u, B, F);
          k ? (a.props.stopPropagation || B === "Start" && O) && ((M = F?.inputEvent) === null || M === void 0 || M.stopPropagation()) : F.stop();
        }
      });
    });
  }), R;
}
var EventManager = /* @__PURE__ */ function() {
  function a(s, c, u) {
    var d = this;
    this.target = s, this.moveable = c, this.eventName = u, this.ables = [], this._onEvent = function(p) {
      var v = d.eventName, A = d.moveable;
      A.state.disableNativeEvent || d.ables.forEach(function(x) {
        x[v](A, {
          inputEvent: p
        });
      });
    }, s.addEventListener(u.toLowerCase(), this._onEvent);
  }
  return a.prototype.setAbles = function(s) {
    this.ables = s;
  }, a.prototype.destroy = function() {
    this.target.removeEventListener(this.eventName.toLowerCase(), this._onEvent), this.target = null, this.moveable = null;
  }, a;
}();
function calculateMatrixStack(a, s, c, u) {
  var d;
  c === void 0 && (c = s);
  var p = getMatrixStackInfo(a, s), v = p.matrixes, A = p.is3d, x = p.targetMatrix, g = p.transformOrigin, b = p.targetOrigin, y = p.offsetContainer, f = p.hasFixed, m = p.zoom, C = getCachedMatrixContainerInfo(y, c), w = C.matrixes, S = C.is3d, $ = C.offsetContainer, T = C.zoom, I = u, _ = 4, E = a.tagName.toLowerCase() !== "svg" && "ownerSVGElement" in a, R = x, O = createIdentityMatrix(_), L = createIdentityMatrix(_), B = createIdentityMatrix(_), F = createIdentityMatrix(_), M = v.length, W = w.map(function(D) {
    return __assign$1(__assign$1({}, D), { matrix: D.matrix ? __spreadArray$1([], __read(D.matrix), !1) : void 0 });
  }).reverse();
  v.reverse(), !A && I && (R = convertDimension(R, 3, 4), convert3DMatrixes(v)), !S && I && convert3DMatrixes(W), W.forEach(function(D) {
    L = multiply(L, D.matrix, _);
  });
  var j = c || getDocumentBody(a), G = ((d = W[0]) === null || d === void 0 ? void 0 : d.target) || getOffsetInfo(j, j, !0).offsetParent, U = W.slice(1).reduce(function(D, H) {
    return multiply(D, H.matrix, _);
  }, createIdentityMatrix(_));
  v.forEach(function(D, H) {
    if (M - 2 === H && (B = O.slice()), M - 1 === H && (F = O.slice()), !D.matrix) {
      var V = v[H + 1], Z = getSVGOffset(D, V, G, _, multiply(U, O, _));
      D.matrix = createOriginMatrix(Z, _);
    }
    O = multiply(O, D.matrix, _);
  });
  var k = !E && A;
  R || (R = createIdentityMatrix(k ? 4 : 3));
  var N = makeMatrixCSS(E && R.length === 16 ? convertDimension(R, 4, 3) : R, k), P = L;
  return L = ignoreDimension(L, _, _), {
    hasZoom: m !== 1 || T !== 1,
    hasFixed: f,
    matrixes: v,
    rootMatrix: L,
    originalRootMatrix: P,
    beforeMatrix: B,
    offsetMatrix: F,
    allMatrix: O,
    targetMatrix: R,
    targetTransform: N,
    inlineTransform: a.style.transform,
    transformOrigin: g,
    targetOrigin: b,
    is3d: I,
    offsetContainer: y,
    offsetRootContainer: $
  };
}
function calculateElementInfo(a, s, c, u) {
  c === void 0 && (c = s);
  var d = 0, p = 0, v = 0, A = {}, x = getSize(a);
  if (a && (d = x.offsetWidth, p = x.offsetHeight), a) {
    var g = calculateMatrixStack(a, s, c, u), b = calculateElementPosition(g.allMatrix, g.transformOrigin, d, p);
    A = __assign$1(__assign$1({}, g), b);
    var y = calculateElementPosition(g.allMatrix, [50, 50], 100, 100);
    v = getRotationRad([y.pos1, y.pos2], y.direction);
  }
  var f = 4;
  return __assign$1(__assign$1(__assign$1({ hasZoom: !1, width: d, height: p, rotation: v }, x), { originalRootMatrix: createIdentityMatrix(f), rootMatrix: createIdentityMatrix(f), beforeMatrix: createIdentityMatrix(f), offsetMatrix: createIdentityMatrix(f), allMatrix: createIdentityMatrix(f), targetMatrix: createIdentityMatrix(f), targetTransform: "", inlineTransform: "", transformOrigin: [0, 0], targetOrigin: [0, 0], is3d: !0, left: 0, top: 0, right: 0, bottom: 0, origin: [0, 0], pos1: [0, 0], pos2: [0, 0], pos3: [0, 0], pos4: [0, 0], direction: 1, hasFixed: !1, offsetContainer: null, offsetRootContainer: null, matrixes: [] }), A);
}
function getMoveableTargetInfo(a, s, c, u, d, p) {
  p === void 0 && (p = []);
  var v = 1, A = [0, 0], x = resetClientRect(), g = resetClientRect(), b = resetClientRect(), y = resetClientRect(), f = [0, 0], m = {}, C = calculateElementInfo(s, c, d, !0);
  if (s) {
    var w = getCachedStyle(s);
    p.forEach(function(W) {
      m[W] = w(W);
    });
    var S = C.is3d ? 4 : 3, $ = calculateElementPosition(C.offsetMatrix, plus(C.transformOrigin, getOrigin(C.targetMatrix, S)), C.width, C.height);
    v = $.direction, A = plus($.origin, [$.left - C.left, $.top - C.top]), y = getClientRect(C.offsetRootContainer);
    var T = getOffsetInfo(u, u, !0).offsetParent || C.offsetRootContainer;
    if (C.hasZoom) {
      var I = calculateElementPosition(multiply(C.originalRootMatrix, C.allMatrix), C.transformOrigin, C.width, C.height), _ = calculateElementPosition(C.originalRootMatrix, getTransformOriginArray(getCachedStyle(T)("transformOrigin")).map(function(W) {
        return parseFloat(W);
      }), T.offsetWidth, T.offsetHeight);
      if (x = getClientRectByPosition(I, y), b = getClientRectByPosition(_, y, T, !0), a) {
        var E = I.left, R = I.top;
        g = getClientRectByPosition({
          left: E,
          top: R,
          bottom: R,
          right: R
        }, y);
      }
    } else {
      x = getClientRect(s), b = getCachedClientRect(T), a && (g = getClientRect(a));
      var O = b.left, L = b.top, B = b.clientLeft, F = b.clientTop, M = [
        x.left - O,
        x.top - L
      ];
      f = minus(calculateInversePosition(C.rootMatrix, M, 4), [B + C.left, F + C.top]);
    }
  }
  return __assign$1({ targetClientRect: x, containerClientRect: b, moveableClientRect: g, rootContainerClientRect: y, beforeDirection: v, beforeOrigin: A, originalBeforeOrigin: A, target: s, style: m, offsetDelta: f }, C);
}
function getPersistState(a) {
  var s = a.pos1, c = a.pos2, u = a.pos3, d = a.pos4;
  if (!s || !c || !u || !d)
    return null;
  var p = getMinMaxs([s, c, u, d]), v = [p.minX, p.minY], A = minus(a.origin, v);
  return s = minus(s, v), c = minus(c, v), u = minus(u, v), d = minus(d, v), __assign$1(__assign$1({}, a), {
    left: a.left,
    top: a.top,
    posDelta: v,
    pos1: s,
    pos2: c,
    pos3: u,
    pos4: d,
    origin: A,
    beforeOrigin: A,
    // originalBeforeOrigin: origin,
    isPersisted: !0
  });
}
var MoveableManager = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    var c = a !== null && a.apply(this, arguments) || this;
    return c.state = __assign$1({ container: null, gestos: {}, renderLines: [
      [[0, 0], [0, 0]],
      [[0, 0], [0, 0]],
      [[0, 0], [0, 0]],
      [[0, 0], [0, 0]]
    ], renderPoses: [[0, 0], [0, 0], [0, 0], [0, 0]], disableNativeEvent: !1, posDelta: [0, 0] }, getMoveableTargetInfo(null)), c.renderState = {}, c.enabledAbles = [], c.targetAbles = [], c.controlAbles = [], c.rotation = 0, c.scale = [1, 1], c.isMoveableMounted = !1, c.isUnmounted = !1, c.events = {
      mouseEnter: null,
      mouseLeave: null
    }, c._emitter = new EventEmitter(), c._prevOriginalDragTarget = null, c._originalDragTarget = null, c._prevDragTarget = null, c._dragTarget = null, c._prevPropTarget = null, c._propTarget = null, c._prevDragArea = !1, c._isPropTargetChanged = !1, c._hasFirstTarget = !1, c._reiszeObserver = null, c._observerId = 0, c._mutationObserver = null, c._rootContainer = null, c._viewContainer = null, c._viewClassNames = [], c._store = {}, c.checkUpdateRect = function() {
      if (!c.isDragging()) {
        var u = c.props.parentMoveable;
        if (u) {
          u.checkUpdateRect();
          return;
        }
        cancelAnimationFrame$1(c._observerId), c._observerId = requestAnimationFrame$1(function() {
          c.isDragging() || c.updateRect();
        });
      }
    }, c._onPreventClick = function(u) {
      u.stopPropagation(), u.preventDefault();
    }, c;
  }
  return s.prototype.render = function() {
    var c = this.props, u = this.getState(), d = c.parentPosition, p = c.className, v = c.target, A = c.zoom, x = c.cspNonce, g = c.translateZ, b = c.cssStyled, y = c.groupable, f = c.linePadding, m = c.controlPadding;
    this._checkUpdateRootContainer(), this.checkUpdate(), this.updateRenderPoses();
    var C = __read(d || [0, 0], 2), w = C[0], S = C[1], $ = u.left, T = u.top, I = u.target, _ = u.direction, E = u.hasFixed, R = u.offsetDelta, O = c.targets, L = this.isDragging(), B = {};
    this.getEnabledAbles().forEach(function(U) {
      B["data-able-".concat(U.name.toLowerCase())] = !0;
    });
    var F = this._getAbleClassName(), M = O && O.length && (I || y) || v || !this._hasFirstTarget && this.state.isPersisted, W = this.controlBox || this.props.firstRenderState || this.props.persistData, j = [$ - w, T - S];
    !y && c.useAccuratePosition && (j[0] += R[0], j[1] += R[1]);
    var G = {
      position: E ? "fixed" : "absolute",
      display: M ? "block" : "none",
      visibility: W ? "visible" : "hidden",
      transform: "translate3d(".concat(j[0], "px, ").concat(j[1], "px, ").concat(g, ")"),
      "--zoom": A,
      "--zoompx": "".concat(A, "px")
    };
    return f && (G["--moveable-line-padding"] = f), m && (G["--moveable-control-padding"] = m), reactExports.createElement(
      b,
      __assign$1({ cspNonce: x, ref: ref(this, "controlBox"), className: "".concat(prefix$1("control-box", _ === -1 ? "reverse" : "", L ? "dragging" : ""), " ").concat(F, " ").concat(p) }, B, { onClick: this._onPreventClick, style: G }),
      this.renderAbles(),
      this._renderLines()
    );
  }, s.prototype.componentDidMount = function() {
    this.isMoveableMounted = !0, this.isUnmounted = !1;
    var c = this.props, u = c.parentMoveable, d = c.container;
    this._checkUpdateRootContainer(), this._checkUpdateViewContainer(), this._updateTargets(), this._updateNativeEvents(), this._updateEvents(), this.updateCheckInput(), this._updateObserver(this.props), !d && !u && !this.state.isPersisted && (this.updateRect("", !1, !1), this.forceUpdate());
  }, s.prototype.componentDidUpdate = function(c) {
    this._checkUpdateRootContainer(), this._checkUpdateViewContainer(), this._updateNativeEvents(), this._updateTargets(), this._updateEvents(), this.updateCheckInput(), this._updateObserver(c);
  }, s.prototype.componentWillUnmount = function() {
    var c, u;
    this.isMoveableMounted = !1, this.isUnmounted = !0, this._emitter.off(), (c = this._reiszeObserver) === null || c === void 0 || c.disconnect(), (u = this._mutationObserver) === null || u === void 0 || u.disconnect();
    var d = this._viewContainer;
    d && this._changeAbleViewClassNames([]), unsetGesto(this, !1), unsetGesto(this, !0);
    var p = this.events;
    for (var v in p) {
      var A = p[v];
      A && A.destroy();
    }
  }, s.prototype.getTargets = function() {
    var c = this.props.target;
    return c ? [c] : [];
  }, s.prototype.getAble = function(c) {
    var u = this.props.ables || [];
    return find$1(u, function(d) {
      return d.name === c;
    });
  }, s.prototype.getContainer = function() {
    var c = this.props, u = c.parentMoveable, d = c.wrapperMoveable, p = c.container;
    return p || d && d.getContainer() || u && u.getContainer() || this.controlBox.parentElement;
  }, s.prototype.getControlBoxElement = function() {
    return this.controlBox;
  }, s.prototype.getDragElement = function() {
    return this._dragTarget;
  }, s.prototype.isMoveableElement = function(c) {
    var u;
    return c && (((u = c.getAttribute) === null || u === void 0 ? void 0 : u.call(c, "class")) || "").indexOf(PREFIX) > -1;
  }, s.prototype.dragStart = function(c, u) {
    u === void 0 && (u = c.target);
    var d = this.targetGesto, p = this.controlGesto;
    return d && checkMoveableTarget(this)({ inputEvent: c }, u) ? d.isFlag() || d.triggerDragStart(c) : p && this.isMoveableElement(u) && (p.isFlag() || p.triggerDragStart(c)), this;
  }, s.prototype.hitTest = function(c) {
    var u = this.state, d = u.target, p = u.pos1, v = u.pos2, A = u.pos3, x = u.pos4, g = u.targetClientRect;
    if (!d)
      return 0;
    var b;
    if (isNode(c)) {
      var y = c.getBoundingClientRect();
      b = {
        left: y.left,
        top: y.top,
        width: y.width,
        height: y.height
      };
    } else
      b = __assign$1({ width: 0, height: 0 }, c);
    var f = b.left, m = b.top, C = b.width, w = b.height, S = fitPoints([p, v, x, A], g), $ = getOverlapSize(S, [
      [f, m],
      [f + C, m],
      [f + C, m + w],
      [f, m + w]
    ]), T = getAreaSize(S);
    return !$ || !T ? 0 : Math.min(100, $ / T * 100);
  }, s.prototype.isInside = function(c, u) {
    var d = this.state, p = d.target, v = d.pos1, A = d.pos2, x = d.pos3, g = d.pos4, b = d.targetClientRect;
    return p ? isInside([c, u], fitPoints([v, A, g, x], b)) : !1;
  }, s.prototype.updateRect = function(c, u, d) {
    d === void 0 && (d = !0);
    var p = this.props, v = !p.parentPosition && !p.wrapperMoveable;
    v && setStoreCache(!0);
    var A = p.parentMoveable, x = this.state, g = x.target || p.target, b = this.getContainer(), y = A ? A._rootContainer : this._rootContainer, f = getMoveableTargetInfo(this.controlBox, g, b, b, y || b, this._getRequestStyles());
    if (!g && this._hasFirstTarget && p.persistData) {
      var m = getPersistState(p.persistData);
      for (var C in m)
        f[C] = m[C];
    }
    v && setStoreCache(), this.updateState(f, A ? !1 : d);
  }, s.prototype.isDragging = function(c) {
    var u, d, p = this.targetGesto, v = this.controlGesto;
    if (p?.isFlag()) {
      if (!c)
        return !0;
      var A = p.getEventData();
      return !!(!((u = A[c]) === null || u === void 0) && u.isEventStart);
    }
    if (v?.isFlag()) {
      if (!c)
        return !0;
      var A = v.getEventData();
      return !!(!((d = A[c]) === null || d === void 0) && d.isEventStart);
    }
    return !1;
  }, s.prototype.updateTarget = function(c) {
    this.updateRect(c, !0);
  }, s.prototype.getRect = function() {
    var c = this.state, u = getAbsolutePosesByState(this.state), d = __read(u, 4), p = d[0], v = d[1], A = d[2], x = d[3], g = getRect(u), b = c.width, y = c.height, f = g.width, m = g.height, C = g.left, w = g.top, S = [c.left, c.top], $ = plus(S, c.origin), T = plus(S, c.beforeOrigin), I = c.transformOrigin;
    return {
      width: f,
      height: m,
      left: C,
      top: w,
      pos1: p,
      pos2: v,
      pos3: A,
      pos4: x,
      offsetWidth: b,
      offsetHeight: y,
      beforeOrigin: T,
      origin: $,
      transformOrigin: I,
      rotation: this.getRotation()
    };
  }, s.prototype.getManager = function() {
    return this;
  }, s.prototype.stopDrag = function(c) {
    if (!c || c === "target") {
      var u = this.targetGesto;
      u?.isIdle() === !1 && unsetAbles(this, !1), u?.stop();
    }
    if (!c || c === "control") {
      var u = this.controlGesto;
      u?.isIdle() === !1 && unsetAbles(this, !0), u?.stop();
    }
  }, s.prototype.getRotation = function() {
    var c = this.state, u = c.pos1, d = c.pos2, p = c.direction;
    return getAbsoluteRotation(u, d, p);
  }, s.prototype.request = function(c, u, d) {
    u === void 0 && (u = {});
    var p = this, v = p.props, A = v.parentMoveable || v.wrapperMoveable || p, x = A.props.ables, g = v.groupable, b = find$1(x, function($) {
      return $.name === c;
    });
    if (this.isDragging() || !b || !b.request)
      return {
        request: function() {
          return this;
        },
        requestEnd: function() {
          return this;
        }
      };
    var y = b.request(p), f = d || u.isInstant, m = y.isControl ? "controlAbles" : "targetAbles", C = "".concat(g ? "Group" : "").concat(y.isControl ? "Control" : ""), w = __spreadArray$1([], __read(A[m]), !1), S = {
      request: function($) {
        return triggerAble(p, w, ["drag"], C, "", __assign$1(__assign$1({}, y.request($)), { requestAble: c, isRequest: !0 }), f), S;
      },
      requestEnd: function() {
        return triggerAble(p, w, ["drag"], C, "End", __assign$1(__assign$1({}, y.requestEnd()), { requestAble: c, isRequest: !0 }), f), S;
      }
    };
    return triggerAble(p, w, ["drag"], C, "Start", __assign$1(__assign$1({}, y.requestStart(u)), { requestAble: c, isRequest: !0 }), f), f ? S.request(u).requestEnd() : S;
  }, s.prototype.getMoveables = function() {
    return [this];
  }, s.prototype.destroy = function() {
    this.componentWillUnmount();
  }, s.prototype.updateRenderPoses = function() {
    var c = this.getState(), u = this.props, d = u.padding, p = c.originalBeforeOrigin, v = c.transformOrigin, A = c.allMatrix, x = c.is3d, g = c.pos1, b = c.pos2, y = c.pos3, f = c.pos4, m = c.left, C = c.top, w = c.isPersisted, S = u.zoom || 1;
    if (!d && S <= 1) {
      c.renderPoses = [
        g,
        b,
        y,
        f
      ], c.renderLines = [
        [g, b],
        [b, f],
        [f, y],
        [y, g]
      ];
      return;
    }
    var $ = getPaddingBox(d || {}), T = $.left, I = $.top, _ = $.bottom, E = $.right, R = x ? 4 : 3, O = [];
    w ? O = v : this.controlBox && u.groupable ? O = p : O = plus(p, [m, C]);
    var L = multiplies(R, createOriginMatrix(O.map(function(G) {
      return -G;
    }), R), A, createOriginMatrix(v, R)), B = calculatePadding(L, g, [-T, -I], R), F = calculatePadding(L, b, [E, -I], R), M = calculatePadding(L, y, [-T, _], R), W = calculatePadding(L, f, [E, _], R);
    c.renderPoses = [
      B,
      F,
      M,
      W
    ], c.renderLines = [
      [B, F],
      [F, W],
      [W, M],
      [M, B]
    ];
    {
      var j = S / 2;
      c.renderLines = [
        [
          calculatePadding(L, g, [-T - j, -I], R),
          calculatePadding(L, b, [E + j, -I], R)
        ],
        [
          calculatePadding(L, b, [E, -I - j], R),
          calculatePadding(L, f, [E, _ + j], R)
        ],
        [
          calculatePadding(L, f, [E + j, _], R),
          calculatePadding(L, y, [-T - j, _], R)
        ],
        [
          calculatePadding(L, y, [-T, _ + j], R),
          calculatePadding(L, g, [-T, -I - j], R)
        ]
      ];
    }
  }, s.prototype.checkUpdate = function() {
    this._isPropTargetChanged = !1;
    var c = this.props, u = c.target, d = c.container, p = c.parentMoveable, v = this.state, A = v.target, x = v.container;
    if (!(!A && !u)) {
      this.updateAbles();
      var g = !equals(A, u), b = g || !equals(x, d);
      if (b) {
        var y = d || this.controlBox;
        y && this.unsetAbles(), this.updateState({ target: u, container: d }), !p && y && this.updateRect("End", !1, !1), this._isPropTargetChanged = g;
      }
    }
  }, s.prototype.waitToChangeTarget = function() {
    return new Promise(function() {
    });
  }, s.prototype.triggerEvent = function(c, u) {
    var d = this.props;
    if (this._emitter.trigger(c, u), d.parentMoveable && u.isRequest && !u.isRequestChild)
      return d.parentMoveable.triggerEvent(c, u, !0);
    var p = d[c];
    return p && p(u);
  }, s.prototype.useCSS = function(c, u) {
    var d = this.props.customStyledMap, p = c + u;
    return d[p] || (d[p] = styled(c, u)), d[p];
  }, s.prototype.getState = function() {
    var c, u = this.props;
    (u.target || !((c = u.targets) === null || c === void 0) && c.length) && (this._hasFirstTarget = !0);
    var d = this.controlBox, p = u.persistData, v = u.firstRenderState;
    if (v && !d)
      return v;
    if (!this._hasFirstTarget && p) {
      var A = getPersistState(p);
      if (A)
        return this.updateState(A, !1), this.state;
    }
    return this.state.isPersisted = !1, this.state;
  }, s.prototype.updateSelectors = function() {
  }, s.prototype.unsetAbles = function() {
    var c = this;
    this.targetAbles.forEach(function(u) {
      u.unset && u.unset(c);
    });
  }, s.prototype.updateAbles = function(c, u) {
    c === void 0 && (c = this.props.ables), u === void 0 && (u = "");
    var d = this.props, p = d.triggerAblesSimultaneously, v = this.getEnabledAbles(c), A = "drag".concat(u, "Start"), x = "pinch".concat(u, "Start"), g = "drag".concat(u, "ControlStart"), b = filterAbles(v, [A, x], p), y = filterAbles(v, [g], p);
    this.enabledAbles = v, this.targetAbles = b, this.controlAbles = y;
  }, s.prototype.updateState = function(c, u) {
    if (u) {
      if (this.isUnmounted)
        return;
      this.setState(c);
    } else {
      var d = this.state;
      for (var p in c)
        d[p] = c[p];
    }
  }, s.prototype.getEnabledAbles = function(c) {
    c === void 0 && (c = this.props.ables);
    var u = this.props;
    return c.filter(function(d) {
      return d && (d.always && u[d.name] !== !1 || u[d.name]);
    });
  }, s.prototype.renderAbles = function() {
    var c = this, u = this.props, d = u.triggerAblesSimultaneously, p = {
      createElement: reactExports.createElement
    };
    return this.renderState = {}, groupByMap(flat(filterAbles(this.getEnabledAbles(), ["render"], d).map(function(v) {
      var A = v.render;
      return A(c, p) || [];
    })).filter(function(v) {
      return v;
    }), function(v) {
      var A = v.key;
      return A;
    }).map(function(v) {
      return v[0];
    });
  }, s.prototype.updateCheckInput = function() {
    this.targetGesto && (this.targetGesto.options.checkInput = this.props.checkInput);
  }, s.prototype._getRequestStyles = function() {
    var c = this.getEnabledAbles().reduce(function(u, d) {
      var p, v, A = (v = (p = d.requestStyle) === null || p === void 0 ? void 0 : p.call(d)) !== null && v !== void 0 ? v : [];
      return __spreadArray$1(__spreadArray$1([], __read(u), !1), __read(A), !1);
    }, __spreadArray$1([], __read(this.props.requestStyles || []), !1));
    return c;
  }, s.prototype._updateObserver = function(c) {
    this._updateResizeObserver(c), this._updateMutationObserver(c);
  }, s.prototype._updateEvents = function() {
    var c = this.targetAbles.length, u = this.controlAbles.length, d = this._dragTarget, p = !c && this.targetGesto || this._isTargetChanged(!0);
    p && (unsetGesto(this, !1), this.updateState({ gestos: {} })), u || unsetGesto(this, !0), d && c && !this.targetGesto && (this.targetGesto = getTargetAbleGesto(this, d, "")), !this.controlGesto && u && (this.controlGesto = getControlAbleGesto(this, "Control"));
  }, s.prototype._updateTargets = function() {
    var c = this.props;
    this._prevPropTarget = this._propTarget, this._prevDragTarget = this._dragTarget, this._prevOriginalDragTarget = this._originalDragTarget, this._prevDragArea = c.dragArea, this._propTarget = c.target, this._originalDragTarget = c.dragTarget || c.target, this._dragTarget = getRefTarget(this._originalDragTarget, !0);
  }, s.prototype._renderLines = function() {
    var c = this.props, u = c, d = u.zoom, p = u.hideDefaultLines, v = u.hideChildMoveableDefaultLines, A = u.parentMoveable;
    if (p || A && v)
      return [];
    var x = this.getState(), g = {
      createElement: reactExports.createElement
    };
    return x.renderLines.map(function(b, y) {
      return renderLine(g, "", b[0], b[1], d, "render-line-".concat(y));
    });
  }, s.prototype._isTargetChanged = function(c) {
    var u = this.props, d = u.dragTarget || u.target, p = this._prevOriginalDragTarget, v = this._prevDragArea, A = u.dragArea, x = !A && p !== d, g = (c || A) && v !== A;
    return x || g || this._prevPropTarget != this._propTarget;
  }, s.prototype._updateNativeEvents = function() {
    var c = this, u = this.props, d = u.dragArea ? this.areaElement : this.state.target, p = this.events, v = getKeys(p);
    if (this._isTargetChanged())
      for (var A in p) {
        var x = p[A];
        x && x.destroy(), p[A] = null;
      }
    if (d) {
      var g = this.enabledAbles;
      v.forEach(function(b) {
        var y = filterAbles(g, [b]), f = y.length > 0, m = p[b];
        if (!f) {
          m && (m.destroy(), p[b] = null);
          return;
        }
        m || (m = new EventManager(d, c, b), p[b] = m), m.setAbles(y);
      });
    }
  }, s.prototype._checkUpdateRootContainer = function() {
    var c = this.props.rootContainer;
    !this._rootContainer && c && (this._rootContainer = getRefTarget(c, !0));
  }, s.prototype._checkUpdateViewContainer = function() {
    var c = this.props.viewContainer;
    !this._viewContainer && c && (this._viewContainer = getRefTarget(c, !0));
    var u = this._viewContainer;
    u && this._changeAbleViewClassNames(__spreadArray$1(__spreadArray$1([], __read(this._getAbleViewClassNames()), !1), [
      this.isDragging() ? VIEW_DRAGGING : ""
    ], !1));
  }, s.prototype._changeAbleViewClassNames = function(c) {
    var u = this._viewContainer, d = groupBy(c.filter(Boolean), function(g) {
      return g;
    }).map(function(g) {
      var b = __read(g, 1), y = b[0];
      return y;
    }), p = this._viewClassNames, v = diff$1(p, d), A = v.removed, x = v.added;
    A.forEach(function(g) {
      removeClass(u, p[g]);
    }), x.forEach(function(g) {
      addClass(u, d[g]);
    }), this._viewClassNames = d;
  }, s.prototype._getAbleViewClassNames = function() {
    var c = this;
    return (this.getEnabledAbles().map(function(u) {
      var d;
      return ((d = u.viewClassName) === null || d === void 0 ? void 0 : d.call(u, c)) || "";
    }).join(" ") + " ".concat(this._getAbleClassName("-view"))).split(/\s+/g);
  }, s.prototype._getAbleClassName = function(c) {
    var u = this;
    c === void 0 && (c = "");
    var d = this.getEnabledAbles(), p = this.targetGesto, v = this.controlGesto, A = p?.isFlag() ? p.getEventData() : {}, x = v?.isFlag() ? v.getEventData() : {};
    return d.map(function(g) {
      var b, y, f, m = g.name, C = ((b = g.className) === null || b === void 0 ? void 0 : b.call(g, u)) || "";
      return (!((y = A[m]) === null || y === void 0) && y.isEventStart || !((f = x[m]) === null || f === void 0) && f.isEventStart) && (C += " ".concat(prefix$1("".concat(m).concat(c, "-dragging")))), C.trim();
    }).filter(Boolean).join(" ");
  }, s.prototype._updateResizeObserver = function(c) {
    var u, d = this.props, p = d.target, v = getWindow(this.getControlBoxElement());
    if (!v.ResizeObserver || !p || !d.useResizeObserver) {
      (u = this._reiszeObserver) === null || u === void 0 || u.disconnect();
      return;
    }
    if (!(c.target === p && this._reiszeObserver)) {
      var A = new v.ResizeObserver(this.checkUpdateRect);
      A.observe(p, {
        box: "border-box"
      }), this._reiszeObserver = A;
    }
  }, s.prototype._updateMutationObserver = function(c) {
    var u = this, d, p = this.props, v = p.target, A = getWindow(this.getControlBoxElement());
    if (!A.MutationObserver || !v || !p.useMutationObserver) {
      (d = this._mutationObserver) === null || d === void 0 || d.disconnect();
      return;
    }
    if (!(c.target === v && this._mutationObserver)) {
      var x = new A.MutationObserver(function(g) {
        var b, y;
        try {
          for (var f = __values(g), m = f.next(); !m.done; m = f.next()) {
            var C = m.value;
            C.type === "attributes" && C.attributeName === "style" && u.checkUpdateRect();
          }
        } catch (w) {
          b = { error: w };
        } finally {
          try {
            m && !m.done && (y = f.return) && y.call(f);
          } finally {
            if (b) throw b.error;
          }
        }
      });
      x.observe(v, {
        attributes: !0
      }), this._mutationObserver = x;
    }
  }, s.defaultProps = {
    dragTargetSelf: !1,
    target: null,
    dragTarget: null,
    container: null,
    rootContainer: null,
    origin: !0,
    parentMoveable: null,
    wrapperMoveable: null,
    isWrapperMounted: !1,
    parentPosition: null,
    warpSelf: !1,
    svgOrigin: "",
    dragContainer: null,
    useResizeObserver: !1,
    useMutationObserver: !1,
    preventDefault: !0,
    preventRightClick: !0,
    preventWheelClick: !0,
    linePadding: 0,
    controlPadding: 0,
    ables: [],
    pinchThreshold: 20,
    dragArea: !1,
    passDragArea: !1,
    transformOrigin: "",
    className: "",
    zoom: 1,
    triggerAblesSimultaneously: !1,
    padding: {},
    pinchOutside: !0,
    checkInput: !1,
    dragFocusedInput: !1,
    groupable: !1,
    hideDefaultLines: !1,
    cspNonce: "",
    translateZ: 0,
    cssStyled: null,
    customStyledMap: {},
    props: {},
    stopPropagation: !1,
    preventClickDefault: !1,
    preventClickEventOnDrag: !0,
    flushSync: defaultSync,
    firstRenderState: null,
    persistData: null,
    viewContainer: null,
    requestStyles: [],
    useAccuratePosition: !1
  }, s;
}(reactExports.PureComponent), Groupable = {
  name: "groupable",
  props: [
    "defaultGroupRotate",
    "useDefaultGroupRotate",
    "defaultGroupOrigin",
    "groupable",
    "groupableProps",
    "targetGroups",
    "hideChildMoveableDefaultLines"
  ],
  events: [],
  render: function(a, s) {
    var c, u = a.props, d = u.targets || [], p = a.getState(), v = p.left, A = p.top, x = p.isPersisted, g = u.zoom || 1, b = a.renderGroupRects, y = ((c = u.persistData) === null || c === void 0 ? void 0 : c.children) || [];
    x ? d = y.map(function() {
      return null;
    }) : y = [];
    var f = watchValue(a, "parentPosition", [v, A], function(C) {
      return C.join(",");
    }), m = watchValue(a, "requestStyles", a.getRequestChildStyles(), function(C) {
      return C.join(",");
    });
    return a.moveables = a.moveables.slice(0, d.length), __spreadArray$1(__spreadArray$1([], __read(d.map(function(C, w) {
      return s.createElement(MoveableManager, { key: "moveable" + w, ref: refs(a, "moveables", w), target: C, origin: !1, requestStyles: m, cssStyled: u.cssStyled, customStyledMap: u.customStyledMap, useResizeObserver: u.useResizeObserver, useMutationObserver: u.useMutationObserver, hideChildMoveableDefaultLines: u.hideChildMoveableDefaultLines, parentMoveable: a, parentPosition: [v, A], persistData: y[w], zoom: g });
    })), !1), __read(flat(b.map(function(C, w) {
      var S = C.pos1, $ = C.pos2, T = C.pos3, I = C.pos4, _ = [S, $, T, I];
      return [
        [0, 1],
        [1, 3],
        [3, 2],
        [2, 0]
      ].map(function(E, R) {
        var O = __read(E, 2), L = O[0], B = O[1];
        return renderLine(s, "", minus(_[L], f), minus(_[B], f), g, "group-rect-".concat(w, "-").concat(R));
      });
    }))), !1);
  }
}, Clickable = makeAble("clickable", {
  props: [
    "clickable"
  ],
  events: [
    "click",
    "clickGroup"
  ],
  always: !0,
  dragRelation: "weak",
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dragStart: function() {
  },
  dragControlStart: function() {
  },
  dragGroupStart: function(a, s) {
    s.datas.inputTarget = s.inputEvent && s.inputEvent.target;
  },
  dragEnd: function(a, s) {
    var c = a.props.target, u = s.inputEvent, d = s.inputTarget, p = a.isMoveableElement(d), v = !p && a.controlBox.contains(d);
    if (!(!u || !d || s.isDrag || a.isMoveableElement(d) || v)) {
      var A = c.contains(d);
      triggerEvent(a, "onClick", fillParams(a, s, {
        isDouble: s.isDouble,
        inputTarget: d,
        isTarget: c === d,
        moveableTarget: a.props.target,
        containsTarget: A
      }));
    }
  },
  dragGroupEnd: function(a, s) {
    var c = s.inputEvent, u = s.inputTarget;
    if (!(!c || !u || s.isDrag || a.isMoveableElement(u) || s.datas.inputTarget === u)) {
      var d = a.props.targets, p = d.indexOf(u), v = p > -1, A = !1;
      p === -1 && (p = findIndex(d, function(x) {
        return x.contains(u);
      }), A = p > -1), triggerEvent(a, "onClickGroup", fillParams(a, s, {
        isDouble: s.isDouble,
        targets: d,
        inputTarget: u,
        targetIndex: p,
        isTarget: v,
        containsTarget: A,
        moveableTarget: d[p]
      }));
    }
  },
  dragControlEnd: function(a, s) {
    this.dragEnd(a, s);
  },
  dragGroupControlEnd: function(a, s) {
    this.dragEnd(a, s);
  }
});
function getDraggableEvent(a) {
  var s = a.originalDatas.draggable;
  return s || (a.originalDatas.draggable = {}, s = a.originalDatas.draggable), __assign$1(__assign$1({}, a), { datas: s });
}
var edgeDraggable = makeAble("edgeDraggable", {
  css: [
    `.edge.edgeDraggable.line {
cursor: move;
}`
  ],
  render: function(a, s) {
    var c = a.props, u = c.edgeDraggable;
    return u ? renderEdgeLines(s, "edgeDraggable", u, a.getState().renderPoses, c.zoom) : [];
  },
  dragCondition: function(a, s) {
    var c, u = a.props, d = (c = s.inputEvent) === null || c === void 0 ? void 0 : c.target;
    return !u.edgeDraggable || !d ? !1 : !u.draggable && hasClass(d, prefix$1("direction")) && hasClass(d, prefix$1("edge")) && hasClass(d, prefix$1("edgeDraggable"));
  },
  dragStart: function(a, s) {
    return Draggable.dragStart(a, getDraggableEvent(s));
  },
  drag: function(a, s) {
    return Draggable.drag(a, getDraggableEvent(s));
  },
  dragEnd: function(a, s) {
    return Draggable.dragEnd(a, getDraggableEvent(s));
  },
  dragGroupCondition: function(a, s) {
    var c, u = a.props, d = (c = s.inputEvent) === null || c === void 0 ? void 0 : c.target;
    return !u.edgeDraggable || !d ? !1 : !u.draggable && hasClass(d, prefix$1("direction")) && hasClass(d, prefix$1("line"));
  },
  dragGroupStart: function(a, s) {
    return Draggable.dragGroupStart(a, getDraggableEvent(s));
  },
  dragGroup: function(a, s) {
    return Draggable.dragGroup(a, getDraggableEvent(s));
  },
  dragGroupEnd: function(a, s) {
    return Draggable.dragGroupEnd(a, getDraggableEvent(s));
  },
  unset: function(a) {
    return Draggable.unset(a);
  }
}), IndividualGroupable = {
  name: "individualGroupable",
  props: [
    "individualGroupable",
    "individualGroupableProps"
  ],
  events: []
}, MOVEABLE_ABLES = [
  BeforeRenderable,
  Default,
  Snappable,
  Pinchable,
  Draggable,
  edgeDraggable,
  Resizable,
  Scalable,
  Warpable,
  Rotatable,
  Scrollable,
  Padding$1,
  Origin,
  OriginDraggable,
  Clippable,
  Roundable,
  Groupable,
  IndividualGroupable,
  Clickable,
  DragArea,
  Renderable
];
function solveConstantsDistance(a, s) {
  var c = __read(a, 3), u = c[0], d = c[1], p = c[2];
  return (u * s[0] + d * s[1] + p) / Math.sqrt(u * u + d * d);
}
function solveC(a, s) {
  var c = __read(a, 2), u = c[0], d = c[1];
  return -u * s[0] - d * s[1];
}
function getMaxPos(a, s) {
  return Math.max.apply(Math, __spreadArray$1([], __read(a.map(function(c) {
    var u = __read(c, 4), d = u[0], p = u[1], v = u[2], A = u[3];
    return Math.max(d[s], p[s], v[s], A[s]);
  })), !1));
}
function getMinPos(a, s) {
  return Math.min.apply(Math, __spreadArray$1([], __read(a.map(function(c) {
    var u = __read(c, 4), d = u[0], p = u[1], v = u[2], A = u[3];
    return Math.min(d[s], p[s], v[s], A[s]);
  })), !1));
}
function getGroupRect(a, s) {
  var c, u, d, p = [0, 0], v = [0, 0], A = [0, 0], x = [0, 0], g = 0, b = 0;
  if (!a.length)
    return {
      pos1: p,
      pos2: v,
      pos3: A,
      pos4: x,
      minX: 0,
      minY: 0,
      maxX: 0,
      maxY: 0,
      width: g,
      height: b,
      rotation: s
    };
  var y = throttle(s, TINY_NUM);
  if (y % 90) {
    var f = y / 180 * Math.PI, m = Math.tan(f), C = -1 / m, w = [MAX_NUM, MIN_NUM], S = [[0, 0], [0, 0]], $ = [MAX_NUM, MIN_NUM], T = [[0, 0], [0, 0]];
    a.forEach(function(ne) {
      ne.forEach(function(K) {
        var q = solveConstantsDistance([-m, 1, 0], K), Y = solveConstantsDistance([-C, 1, 0], K);
        w[0] > q && (S[0] = K, w[0] = q), w[1] < q && (S[1] = K, w[1] = q), $[0] > Y && (T[0] = K, $[0] = Y), $[1] < Y && (T[1] = K, $[1] = Y);
      });
    });
    var I = __read(S, 2), _ = I[0], E = I[1], R = __read(T, 2), O = R[0], L = R[1], B = [-m, 1, solveC([-m, 1], _)], F = [-m, 1, solveC([-m, 1], E)], M = [-C, 1, solveC([-C, 1], O)], W = [-C, 1, solveC([-C, 1], L)];
    c = __read([
      [B, M],
      [B, W],
      [F, M],
      [F, W]
    ].map(function(ne) {
      var K = __read(ne, 2), q = K[0], Y = K[1];
      return getIntersectionPointsByConstants(q, Y)[0];
    }), 4), p = c[0], v = c[1], A = c[2], x = c[3], g = $[1] - $[0], b = w[1] - w[0];
  } else {
    var j = getMinPos(a, 0), G = getMinPos(a, 1), U = getMaxPos(a, 0), k = getMaxPos(a, 1);
    if (p = [j, G], v = [U, G], A = [j, k], x = [U, k], g = U - j, b = k - G, y % 180) {
      var N = [A, p, x, v];
      u = __read(N, 4), p = u[0], v = u[1], A = u[2], x = u[3], g = k - G, b = U - j;
    }
  }
  if (y % 360 > 180) {
    var N = [x, A, v, p];
    d = __read(N, 4), p = d[0], v = d[1], A = d[2], x = d[3];
  }
  var P = getMinMaxs([p, v, A, x]), D = P.minX, H = P.minY, V = P.maxX, Z = P.maxY;
  return {
    pos1: p,
    pos2: v,
    pos3: A,
    pos4: x,
    width: g,
    height: b,
    minX: D,
    minY: H,
    maxX: V,
    maxY: Z,
    rotation: s
  };
}
function findMoveableGroups(a, s) {
  var c = s.map(function(u) {
    if (isArray(u)) {
      var d = findMoveableGroups(a, u), p = d.length;
      return p > 1 ? d : p === 1 ? d[0] : null;
    } else {
      var v = find$1(a, function(A) {
        var x = A.manager;
        return x.props.target === u;
      });
      return v ? (v.finded = !0, v.manager) : null;
    }
  }).filter(Boolean);
  return c.length === 1 && isArray(c[0]) ? c[0] : c;
}
var MoveableGroup = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    var c = a !== null && a.apply(this, arguments) || this;
    return c.differ = new ChildrenDiffer(), c.moveables = [], c.transformOrigin = "50% 50%", c.renderGroupRects = [], c._targetGroups = [], c._hasFirstTargets = !1, c;
  }
  return s.prototype.componentDidMount = function() {
    a.prototype.componentDidMount.call(this);
  }, s.prototype.checkUpdate = function() {
    this._isPropTargetChanged = !1, this.updateAbles();
  }, s.prototype.getTargets = function() {
    return this.props.targets;
  }, s.prototype.updateRect = function(c, u, d) {
    var p;
    d === void 0 && (d = !0);
    var v = this.state;
    if (!this.controlBox || v.isPersisted)
      return;
    setStoreCache(!0), this.moveables.forEach(function(Q) {
      Q.updateRect(c, !1, !1);
    });
    var A = this.props, x = this.moveables, g = v.target || A.target, b = x.map(function(Q) {
      return { finded: !1, manager: Q };
    }), y = this.props.targetGroups || [], f = findMoveableGroups(b, y), m = A.useDefaultGroupRotate;
    f.push.apply(f, __spreadArray$1([], __read(b.filter(function(Q) {
      var J = Q.finded;
      return !J;
    }).map(function(Q) {
      var J = Q.manager;
      return J;
    })), !1));
    var C = [], w = !u || c !== "" && A.updateGroup, S = A.defaultGroupRotate || 0;
    if (!this._hasFirstTargets) {
      var $ = (p = A.persistData) === null || p === void 0 ? void 0 : p.rotation;
      $ != null && (S = $);
    }
    function T(Q, J, te) {
      var ae = Q.map(function(be) {
        if (isArray(be)) {
          var le = T(be, J), ve = [le.pos1, le.pos2, le.pos3, le.pos4];
          return C.push(le), { poses: ve, rotation: le.rotation };
        } else
          return {
            poses: getAbsolutePosesByState(be.state),
            rotation: be.getRotation()
          };
      }), se = ae.map(function(be) {
        var le = be.rotation;
        return le;
      }), ie = 0, fe = se[0], ge = se.every(function(be) {
        return Math.abs(fe - be) < 0.1;
      });
      w ? ie = !m && ge ? fe : S : ie = !m && !te && ge ? fe : J;
      var me = ae.map(function(be) {
        var le = be.poses;
        return le;
      }), pe = getGroupRect(me, ie);
      return pe;
    }
    var I = T(f, this.rotation, !0);
    w && (this.rotation = I.rotation, this.transformOrigin = A.defaultGroupOrigin || "50% 50%", this.scale = [1, 1]), this._targetGroups = y, this.renderGroupRects = C;
    var _ = this.transformOrigin, E = this.rotation, R = this.scale, O = I.width, L = I.height, B = I.minX, F = I.minY, M = rotatePosesInfo([
      [0, 0],
      [O, 0],
      [0, L],
      [O, L]
    ], convertTransformOriginArray(_, O, L), this.rotation / 180 * Math.PI), W = getMinMaxs(M.result), j = W.minX, G = W.minY, U = " rotate(".concat(E, "deg)") + " scale(".concat(sign(R[0]), ", ").concat(sign(R[1]), ")"), k = "translate(".concat(-j, "px, ").concat(-G, "px)").concat(U);
    this.controlBox.style.transform = "translate3d(".concat(B, "px, ").concat(F, "px, ").concat(this.props.translateZ || 0, ")"), g.style.cssText += "left:0px;top:0px;" + "transform-origin:".concat(_, ";") + "width:".concat(O, "px;height:").concat(L, "px;") + "transform: ".concat(k), v.width = O, v.height = L;
    var N = this.getContainer(), P = getMoveableTargetInfo(this.controlBox, g, this.controlBox, this.getContainer(), this._rootContainer || N, []), D = [P.left, P.top], H = __read(getAbsolutePosesByState(P), 4), V = H[0], Z = H[1], ne = H[2], K = H[3], q = getMinMaxs([V, Z, ne, K]), Y = [q.minX, q.minY], ee = sign(R[0] * R[1]);
    P.pos1 = minus(V, Y), P.pos2 = minus(Z, Y), P.pos3 = minus(ne, Y), P.pos4 = minus(K, Y), P.left = B - P.left + Y[0], P.top = F - P.top + Y[1], P.origin = minus(plus(D, P.origin), Y), P.beforeOrigin = minus(plus(D, P.beforeOrigin), Y), P.originalBeforeOrigin = plus(D, P.originalBeforeOrigin), P.transformOrigin = minus(plus(D, P.transformOrigin), Y), g.style.transform = "translate(".concat(-j - Y[0], "px, ").concat(-G - Y[1], "px)") + U, setStoreCache(), this.updateState(__assign$1(__assign$1({}, P), { posDelta: Y, direction: ee, beforeDirection: ee }), d);
  }, s.prototype.getRect = function() {
    return __assign$1(__assign$1({}, a.prototype.getRect.call(this)), { children: this.moveables.map(function(c) {
      return c.getRect();
    }) });
  }, s.prototype.triggerEvent = function(c, u, d) {
    if (d || c.indexOf("Group") > -1)
      return a.prototype.triggerEvent.call(this, c, u);
    this._emitter.trigger(c, u);
  }, s.prototype.getRequestChildStyles = function() {
    var c = this.getEnabledAbles().reduce(function(u, d) {
      var p, v, A = (v = (p = d.requestChildStyle) === null || p === void 0 ? void 0 : p.call(d)) !== null && v !== void 0 ? v : [];
      return __spreadArray$1(__spreadArray$1([], __read(u), !1), __read(A), !1);
    }, []);
    return c;
  }, s.prototype.getMoveables = function() {
    return __spreadArray$1([], __read(this.moveables), !1);
  }, s.prototype.updateAbles = function() {
    a.prototype.updateAbles.call(this, __spreadArray$1(__spreadArray$1([], __read(this.props.ables), !1), [Groupable], !1), "Group");
  }, s.prototype._updateTargets = function() {
    a.prototype._updateTargets.call(this), this._originalDragTarget = this.props.dragTarget || this.areaElement, this._dragTarget = getRefTarget(this._originalDragTarget, !0);
  }, s.prototype._updateEvents = function() {
    var c = this.state, u = this.props, d = this._prevDragTarget, p = u.dragTarget || this.areaElement, v = u.targets, A = this.differ.update(v), x = A.added, g = A.changed, b = A.removed, y = x.length || b.length;
    (y || this._prevOriginalDragTarget !== this._originalDragTarget) && (unsetGesto(this, !1), unsetGesto(this, !0), this.updateState({ gestos: {} })), d !== p && (c.target = null), c.target || (c.target = this.areaElement, this.controlBox.style.display = "block"), c.target && (this.targetGesto || (this.targetGesto = getTargetAbleGesto(this, this._dragTarget, "Group")), this.controlGesto || (this.controlGesto = getControlAbleGesto(this, "GroupControl")));
    var f = !equals(c.container, u.container);
    f && (c.container = u.container), (f || y || this.transformOrigin !== (u.defaultGroupOrigin || "50% 50%") || g.length || v.length && !isDeepArrayEquals(this._targetGroups, u.targetGroups || [])) && (this.updateRect(), this._hasFirstTargets = !0), this._isPropTargetChanged = !!y;
  }, s.prototype._updateObserver = function() {
  }, s.defaultProps = __assign$1(__assign$1({}, MoveableManager.defaultProps), { transformOrigin: ["50%", "50%"], groupable: !0, dragArea: !0, keepRatio: !0, targets: [], defaultGroupRotate: 0, defaultGroupOrigin: "50% 50%" }), s;
}(MoveableManager), MoveableIndividualGroup = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    var c = a !== null && a.apply(this, arguments) || this;
    return c.moveables = [], c;
  }
  return s.prototype.render = function() {
    var c = this, u, d = this.props, p = d.cspNonce, v = d.cssStyled, A = d.persistData, x = d.targets || [], g = x.length, b = this.isUnmounted || !g, y = (u = A?.children) !== null && u !== void 0 ? u : [];
    return b && !g && y.length ? x = y.map(function() {
      return null;
    }) : b || (y = []), reactExports.createElement(v, { cspNonce: p, ref: ref(this, "controlBox"), className: prefix$1("control-box") }, x.map(function(f, m) {
      var C, w, S = (w = (C = d.individualGroupableProps) === null || C === void 0 ? void 0 : C.call(d, f, m)) !== null && w !== void 0 ? w : {};
      return reactExports.createElement(MoveableManager, __assign$1({ key: "moveable" + m, ref: refs(c, "moveables", m) }, d, S, { target: f, wrapperMoveable: c, isWrapperMounted: c.isMoveableMounted, persistData: y[m] }));
    }));
  }, s.prototype.componentDidMount = function() {
  }, s.prototype.componentDidUpdate = function() {
  }, s.prototype.getTargets = function() {
    return this.props.targets;
  }, s.prototype.updateRect = function(c, u, d) {
    d === void 0 && (d = !0), setStoreCache(!0), this.moveables.forEach(function(p) {
      p.updateRect(c, u, d);
    }), setStoreCache();
  }, s.prototype.getRect = function() {
    return __assign$1(__assign$1({}, a.prototype.getRect.call(this)), { children: this.moveables.map(function(c) {
      return c.getRect();
    }) });
  }, s.prototype.request = function(c, u, d) {
    u === void 0 && (u = {});
    var p = this.moveables.map(function(x) {
      return x.request(c, __assign$1(__assign$1({}, u), { isInstant: !1 }), !1);
    }), v = d || u.isInstant, A = {
      request: function(x) {
        return p.forEach(function(g) {
          return g.request(x);
        }), this;
      },
      requestEnd: function() {
        return p.forEach(function(x) {
          return x.requestEnd();
        }), this;
      }
    };
    return v ? A.request(u).requestEnd() : A;
  }, s.prototype.dragStart = function(c, u) {
    u === void 0 && (u = c.target);
    var d = u, p = find$1(this.moveables, function(v) {
      var A = v.getTargets()[0], x = v.getControlBoxElement(), g = v.getDragElement();
      return !A || !g ? !1 : g === d || g.contains(d) || g !== A && A === d || A.contains(d) || x === d || x.contains(d);
    });
    return p && p.dragStart(c, u), this;
  }, s.prototype.hitTest = function() {
    return 0;
  }, s.prototype.isInside = function() {
    return !1;
  }, s.prototype.isDragging = function() {
    return !1;
  }, s.prototype.getDragElement = function() {
    return null;
  }, s.prototype.getMoveables = function() {
    return __spreadArray$1([], __read(this.moveables), !1);
  }, s.prototype.updateRenderPoses = function() {
  }, s.prototype.checkUpdate = function() {
  }, s.prototype.triggerEvent = function() {
  }, s.prototype.updateAbles = function() {
  }, s.prototype._updateEvents = function() {
  }, s.prototype._updateObserver = function() {
  }, s;
}(MoveableManager);
function getElementTargets(a, s) {
  var c = [];
  return a.forEach(function(u) {
    if (u) {
      if (isString(u)) {
        s[u] && c.push.apply(c, __spreadArray$1([], __read(s[u]), !1));
        return;
      }
      isArray(u) ? c.push.apply(c, __spreadArray$1([], __read(getElementTargets(u, s)), !1)) : c.push(u);
    }
  }), c;
}
function getTargetGroups(a, s) {
  var c = [];
  return a.forEach(function(u) {
    if (u) {
      if (isString(u)) {
        s[u] && c.push.apply(c, __spreadArray$1([], __read(s[u]), !1));
        return;
      }
      isArray(u) ? c.push(getTargetGroups(u, s)) : c.push(u);
    }
  }), c;
}
function compareRefTargets(a, s) {
  return a.length !== s.length || a.some(function(c, u) {
    var d = s[u];
    return !c && !d ? !1 : c != d ? isArray(c) && isArray(d) ? compareRefTargets(c, d) : !0 : !1;
  });
}
var InitialMoveable = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    var c = a !== null && a.apply(this, arguments) || this;
    return c.refTargets = [], c.selectorMap = {}, c._differ = new ChildrenDiffer(), c._elementTargets = [], c._tmpRefTargets = [], c._tmpSelectorMap = {}, c._onChangeTargets = null, c;
  }
  return s.makeStyled = function() {
    var c = {}, u = this.getTotalAbles();
    u.forEach(function(p) {
      var v = p.css;
      v && v.forEach(function(A) {
        c[A] = !0;
      });
    });
    var d = getKeys(c).join(`
`);
    this.defaultStyled = styled("div", prefixCSS(PREFIX, MOVEABLE_CSS + d));
  }, s.getTotalAbles = function() {
    return __spreadArray$1([Default, Groupable, IndividualGroupable, DragArea], __read(this.defaultAbles), !1);
  }, s.prototype.render = function() {
    var c, u = this.constructor;
    u.defaultStyled || u.makeStyled();
    var d = this.props, p = d.ables, v = d.props, A = __rest(d, ["ables", "props"]), x = __read(this._updateRefs(!0), 2), g = x[0], b = x[1], y = getElementTargets(g, b), f = y.length > 1, m = u.getTotalAbles(), C = __spreadArray$1(__spreadArray$1([], __read(m), !1), __read(p || []), !1), w = __assign$1(__assign$1(__assign$1({}, A), v || {}), { ables: C, cssStyled: u.defaultStyled, customStyledMap: u.customStyledMap });
    this._elementTargets = y;
    var S = null, $ = this.moveable, T = A.persistData;
    if (T?.children && (f = !0), A.individualGroupable)
      return reactExports.createElement(MoveableIndividualGroup, __assign$1({ key: "individual-group", ref: ref(this, "moveable") }, w, { target: null, targets: y }));
    if (f) {
      var I = getTargetGroups(g, b);
      if ($ && !$.props.groupable && !$.props.individualGroupable) {
        var _ = $.props.target;
        _ && y.indexOf(_) > -1 && (S = __assign$1({}, $.state));
      }
      return reactExports.createElement(MoveableGroup, __assign$1({ key: "group", ref: ref(this, "moveable") }, w, (c = A.groupableProps) !== null && c !== void 0 ? c : {}, { target: null, targets: y, targetGroups: I, firstRenderState: S }));
    } else {
      var E = y[0];
      if ($ && ($.props.groupable || $.props.individualGroupable)) {
        var R = $.moveables || [], O = find$1(R, function(L) {
          return L.props.target === E;
        });
        O && (S = __assign$1({}, O.state));
      }
      return reactExports.createElement(MoveableManager, __assign$1({ key: "single", ref: ref(this, "moveable") }, w, { target: E, firstRenderState: S }));
    }
  }, s.prototype.componentDidMount = function() {
    this._checkChangeTargets();
  }, s.prototype.componentDidUpdate = function() {
    this._checkChangeTargets();
  }, s.prototype.componentWillUnmount = function() {
    this.selectorMap = {}, this.refTargets = [];
  }, s.prototype.getTargets = function() {
    var c, u;
    return (u = (c = this.moveable) === null || c === void 0 ? void 0 : c.getTargets()) !== null && u !== void 0 ? u : [];
  }, s.prototype.updateSelectors = function() {
    this.selectorMap = {}, this._updateRefs(), this.forceUpdate();
  }, s.prototype.waitToChangeTarget = function() {
    var c = this, u;
    return this._onChangeTargets = function() {
      c._onChangeTargets = null, u();
    }, new Promise(function(d) {
      u = d;
    });
  }, s.prototype.waitToChangeTargets = function() {
    return this.waitToChangeTarget();
  }, s.prototype.getManager = function() {
    return this.moveable;
  }, s.prototype.getMoveables = function() {
    return this.moveable.getMoveables();
  }, s.prototype.getDragElement = function() {
    return this.moveable.getDragElement();
  }, s.prototype._updateRefs = function(c) {
    var u = this.refTargets, d = getRefTargets(this.props.target || this.props.targets), p = typeof document < "u", v = compareRefTargets(u, d), A = this.selectorMap, x = {};
    return this.refTargets.forEach(function g(b) {
      if (isString(b)) {
        var y = A[b];
        y ? x[b] = A[b] : p && (v = !0, x[b] = [].slice.call(document.querySelectorAll(b)));
      } else isArray(b) && b.forEach(g);
    }), this._tmpRefTargets = d, this._tmpSelectorMap = x, [
      d,
      x,
      !c && v
    ];
  }, s.prototype._checkChangeTargets = function() {
    var c, u, d;
    this.refTargets = this._tmpRefTargets, this.selectorMap = this._tmpSelectorMap;
    var p = this._differ.update(this._elementTargets), v = p.added, A = p.removed, x = v.length || A.length;
    x && ((u = (c = this.props).onChangeTargets) === null || u === void 0 || u.call(c, {
      moveable: this.moveable,
      targets: this._elementTargets
    }), (d = this._onChangeTargets) === null || d === void 0 || d.call(this));
    var g = __read(this._updateRefs(), 3), b = g[0], y = g[1], f = g[2];
    this.refTargets = b, this.selectorMap = y, f && this.forceUpdate();
  }, s.defaultAbles = [], s.customStyledMap = {}, s.defaultStyled = null, __decorate([
    withMethods(MOVEABLE_METHODS)
  ], s.prototype, "moveable", void 0), s;
}(reactExports.PureComponent), Moveable$2 = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    return a !== null && a.apply(this, arguments) || this;
  }
  return s.defaultAbles = MOVEABLE_ABLES, s;
}(InitialMoveable);
const baseClassName = "pdfme-moveable", Moveable = (a, s) => {
  const { token: c } = theme.useToken(), u = reactExports.useRef(uuid$6()), d = `${baseClassName}-${u.current}`;
  return reactExports.useEffect(() => {
    const p = document.querySelector(`.${d}`), v = document.querySelectorAll(`.${d} .moveable-line`);
    p instanceof HTMLElement && (p.style.setProperty("--moveable-color", c.colorPrimary), v.forEach((A) => {
      A instanceof HTMLElement && A.style.setProperty("--moveable-color", c.colorPrimary);
    }));
  }, [a.target, c.colorPrimary, d]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Moveable$2,
    {
      className: d,
      rootContainer: document ? document.body : void 0,
      snappable: !0,
      draggable: !0,
      rotatable: a.rotatable,
      resizable: !0,
      throttleDrag: 1,
      throttleRotate: 1,
      throttleResize: 1,
      ref: s,
      target: a.target,
      bounds: a.bounds,
      horizontalGuidelines: a.horizontalGuidelines,
      verticalGuidelines: a.verticalGuidelines,
      keepRatio: a.keepRatio,
      onRotate: a.onRotate,
      onRotateEnd: a.onRotateEnd,
      onRotateGroup: ({ events: p }) => {
        p.forEach(a.onRotate);
      },
      onRotateGroupEnd: a.onRotateGroupEnd,
      onDrag: a.onDrag,
      onDragGroup: ({ events: p }) => {
        p.forEach(a.onDrag);
      },
      onDragEnd: a.onDragEnd,
      onDragGroupEnd: a.onDragGroupEnd,
      onResize: a.onResize,
      onResizeGroup: ({ events: p }) => {
        p.forEach(a.onResize);
      },
      onResizeEnd: a.onResizeEnd,
      onResizeGroupEnd: a.onResizeGroupEnd,
      onClick: a.onClick
    }
  );
}, Moveable$1 = reactExports.forwardRef(Moveable);
var extendStatics$1 = function(a, s) {
  return extendStatics$1 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
  }, extendStatics$1(a, s);
};
function __extends$1(a, s) {
  if (typeof s != "function" && s !== null) throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$1(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
var Ruler = /* @__PURE__ */ function(a) {
  __extends$1(s, a);
  function s() {
    var u = a !== null && a.apply(this, arguments) || this;
    return u.state = {
      scrollPos: 0
    }, u.width = 0, u.height = 0, u._zoom = 0, u._rulerScale = 0, u._observer = null, u._checkResize = function() {
      u.resize();
    }, u;
  }
  var c = s.prototype;
  return c.render = function() {
    var u = this.props;
    return this._zoom = u.zoom, reactExports.createElement("canvas", {
      ref: ref(this, "canvasElement"),
      style: this.props.style
    });
  }, c.componentDidMount = function() {
    var u = this.props;
    this.state.scrollPos = u.defaultScrollPos || 0;
    var d = this.canvasElement, p = d.getContext("2d", {
      alpha: !0
    });
    this.canvasContext = p, u.useResizeObserver ? (this._observer = new ResizeObserver(this._checkResize), this._observer.observe(d, {
      box: "border-box"
    })) : this.resize();
  }, c.componentDidUpdate = function() {
    this.resize();
  }, c.componentWillUnmount = function() {
    var u;
    this.state.scrollPos = 0, (u = this._observer) === null || u === void 0 || u.disconnect();
  }, c.getScrollPos = function() {
    return this.state.scrollPos;
  }, c.scroll = function(u, d) {
    this.draw({
      scrollPos: u,
      zoom: d
    });
  }, c.resize = function(u) {
    var d = this.canvasElement, p = this.props, v = p.width, A = p.height, x = p.scrollPos, g = this._getRulerScale();
    this.width = v || d.offsetWidth, this.height = A || d.offsetHeight, d.width = this.width * g, d.height = this.height * g, this.draw({
      scrollPos: x,
      zoom: u
    });
  }, c.draw = function(u) {
    u === void 0 && (u = {});
    var d = this.props, p = u.zoom, v = p === void 0 ? this._zoom : p, A = u.scrollPos, x = A === void 0 ? this.state.scrollPos : A, g = u.marks, b = g === void 0 ? d.marks : g, y = u.selectedRanges, f = y === void 0 ? d.selectedRanges : y, m = u.segment, C = m === void 0 ? d.segment || 10 : m, w = u.unit, S = w === void 0 ? d.unit : w;
    this._zoom = v;
    var $ = d, T = $.type, I = $.backgroundColor, _ = $.lineColor, E = $.textColor, R = $.textBackgroundColor, O = $.direction, L = $.negativeRuler, B = L === void 0 ? !0 : L, F = $.textFormat, M = $.range, W = M === void 0 ? [-1 / 0, 1 / 0] : M, j = $.rangeBackgroundColor, G = $.selectedBackgroundColor, U = $.lineWidth, k = U === void 0 ? 1 : U, N = $.selectedRangesText, P = $.selectedRangesTextColor, D = P === void 0 ? "#44aaff" : P, H = $.selectedRangesTextOffset, V = H === void 0 ? [0, 0] : H, Z = $.markColor, ne = Z === void 0 ? "#ff5" : Z, K = this._getRulerScale(), q = this.width, Y = this.height, ee = this.state;
    ee.scrollPos = x;
    var Q = this.canvasContext, J = T === "horizontal", te = B !== !1, ae = d.font || "10px sans-serif", se = d.textAlign || "left", ie = d.textOffset || [0, 0], fe = J ? Y : q, ge = convertUnitSize("".concat(d.mainLineSize || "100%"), fe), me = convertUnitSize("".concat(d.longLineSize || 10), fe), pe = convertUnitSize("".concat(d.shortLineSize || 7), fe), be = d.lineOffset || [0, 0];
    switch (I === "transparent" ? Q.clearRect(0, 0, q * K, Y * K) : (Q.rect(0, 0, q * K, Y * K), Q.fillStyle = I, Q.fill()), Q.save(), Q.scale(K, K), Q.strokeStyle = _, Q.lineWidth = k, Q.font = ae, Q.fillStyle = E, Q.textAlign = se, O) {
      case "start":
        Q.textBaseline = "top";
        break;
      case "center":
        Q.textBaseline = "middle";
        break;
      case "end":
        Q.textBaseline = "bottom";
        break;
    }
    Q.translate(0.5, 0), Q.beginPath();
    for (var le = J ? q : Y, ve = v * S, he = Math.floor(x * v / ve), ye = Math.ceil((x * v + le) / ve), Ce = ye - he, xe = Math.max(["left", "center", "right"].indexOf(se) - 1, -1), we = J ? Y : q, $e = [], Ae = 0; Ae <= Ce; ++Ae) {
      var ue = (Ae + he) * S, ce = "".concat(ue);
      F && (ce = F(ue));
      var Ee = Q.measureText(ce).width;
      $e.push({
        color: E,
        offset: ie,
        backgroundColor: R,
        value: ue,
        text: ce,
        textSize: Ee
      });
    }
    if (G !== "transparent" && f?.length && f.forEach(function(nt) {
      var ct = Math.max(nt[0], W[0], B ? -1 / 0 : 0), it = Math.min(nt[1], W[1]), We = (ct - x) * v, Ve = (it - ct) * v;
      N && nt.forEach(function(ut) {
        var at = "".concat(ut);
        F && (at = F(ut));
        var Qe = Q.measureText(at).width, st = ut * v, ft = st + Qe;
        findLast($e, function(vt, Pt) {
          var dt = vt.value, mt = vt.textSize, pt = dt * v, Et = pt + mt;
          pt <= ft && st <= Et && $e.splice(Pt, 1);
        }), $e.push({
          value: ut,
          color: D,
          offset: V,
          text: at,
          textSize: Qe
        });
      }), !(Ve <= 0) && (Q.save(), Q.fillStyle = G, J ? Q.fillRect(We, 0, Ve, we) : Q.fillRect(0, We, we, Ve), Q.restore());
    }), j !== "transparent" && W[0] !== -1 / 0 && W[1] !== 1 / 0) {
      var _e = (W[0] - x) * v, Te = (W[1] - W[0]) * v;
      Q.save(), Q.fillStyle = j, J ? Q.fillRect(_e, 0, Te, we) : Q.fillRect(0, _e, we, Te), Q.restore();
    }
    for (var Ae = 0; Ae <= Ce; ++Ae) {
      var ue = Ae + he;
      if (!(!te && ue < 0))
        for (var ke = ue * S, Re = (ke - x) * v, Be = 0; Be < C; ++Be) {
          var Oe = Re + Be / C * ve, Me = ke + Be / C * S;
          if (!(Oe < 0 || Oe >= le || Me < W[0] || Me > W[1])) {
            var Fe = Be === 0 ? ge : Be % 2 === 0 ? me : pe, Ue = 0;
            switch (O) {
              case "start":
                Ue = 0;
                break;
              case "center":
                Ue = we / 2 - Fe / 2;
                break;
              case "end":
                Ue = we - Fe;
                break;
            }
            var je = J ? [Oe + be[0], Ue + be[1]] : [Ue + be[0], Oe + be[1]], Le = je[0], De = je[1], Ne = J ? [Le, De + Fe] : [Le + Fe, De], Ge = Ne[0], Xe = Ne[1];
            Q.moveTo(Le + be[0], De + be[1]), Q.lineTo(Ge + be[0], Xe + be[1]);
          }
        }
    }
    Q.stroke(), Q.beginPath(), Q.strokeStyle = ne, Q.lineWidth = 1, (b || []).forEach(function(nt) {
      var ct = (-x + nt) * v;
      if (!(ct < 0 || ct >= le || nt < W[0] || nt > W[1])) {
        var it = J ? [ct + be[0], be[1]] : [be[0], ct + be[1]], We = it[0], Ve = it[1], ut = J ? [We, Ve + fe] : [We + fe, Ve], at = ut[0], Qe = ut[1];
        Q.moveTo(We + be[0], Ve + be[1]), Q.lineTo(at + be[0], Qe + be[1]);
      }
    }), Q.stroke(), $e.forEach(function(nt) {
      var ct = nt.value, it = nt.offset, We = nt.backgroundColor, Ve = nt.color, ut = nt.text, at = nt.textSize;
      if (!(!te && ct < 0)) {
        var Qe = (ct - x) * v;
        if (!(Qe < -ve || Qe >= le + S * v || ct < W[0] || ct > W[1])) {
          var st = 0;
          switch (O) {
            case "start":
              st = 17;
              break;
            case "center":
              st = we / 2;
              break;
            case "end":
              st = we - 17;
              break;
          }
          var ft = J ? [Qe + xe * -3, st] : [st, Qe + xe * 3], vt = ft[0], Pt = ft[1];
          if (We) {
            var dt = 0;
            switch (se) {
              case "left":
                dt = 0;
                break;
              case "center":
                dt = -at / 2;
                break;
              case "right":
                dt = -at;
                break;
            }
            Q.save(), Q.fillStyle = We, J ? Q.fillRect(vt + it[0] + dt, 0, at, ge) : (Q.translate(0, Pt + it[1]), Q.rotate(-Math.PI / 2), Q.fillRect(dt, 0, at, ge)), Q.restore();
          }
          Q.save(), Q.fillStyle = Ve, J ? Q.fillText(ut, vt + it[0], Pt + it[1]) : (Q.translate(vt + it[0], Pt + it[1]), Q.rotate(-Math.PI / 2), Q.fillText(ut, 0, 0)), Q.restore();
        }
      }
    }), Q.restore();
  }, c._getRulerScale = function() {
    var u = this.props.defaultPixelScale || 2;
    if (!this._rulerScale) {
      var d = window.devicePixelRatio > 1;
      if (!d && window.matchMedia) {
        var p = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
        d = p && p.matches;
      }
      this._rulerScale = d ? 3 : u;
    }
    return this._rulerScale;
  }, s.defaultProps = {
    type: "horizontal",
    zoom: 1,
    width: 0,
    height: 0,
    unit: 50,
    negativeRuler: !0,
    mainLineSize: "100%",
    longLineSize: 10,
    shortLineSize: 7,
    segment: 10,
    direction: "end",
    style: {
      width: "100%",
      height: "100%"
    },
    backgroundColor: "#333333",
    font: "10px sans-serif",
    textColor: "#ffffff",
    textBackgroundColor: "transparent",
    lineColor: "#777777",
    range: [-1 / 0, 1 / 0],
    rangeBackgroundColor: "transparent",
    lineWidth: 1,
    selectedBackgroundColor: "#555555",
    defaultScrollPos: 0,
    markColor: "#f55",
    marks: []
  }, s;
}(reactExports.PureComponent), PROPERTIES = ["type", "width", "height", "unit", "zoom", "direction", "textAlign", "font", "segment", "mainLineSize", "longLineSize", "shortLineSize", "lineOffset", "textOffset", "negativeRuler", "range", "scrollPos", "defaultScrollPos", "style", "backgroundColor", "rangeBackgroundColor", "lineColor", "textColor", "textBackgroundColor", "textFormat", "warpSelf", "selectedBackgroundColor", "selectedRanges", "defaultPixelScale", "useResizeObserver", "selectedRangesText", "selectedRangesTextColor", "selectedRangesTextOffset", "marks", "markColor"], extendStatics = function(a, s) {
  return extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(c, u) {
    c.__proto__ = u;
  } || function(c, u) {
    for (var d in u) Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
  }, extendStatics(a, s);
};
function __extends(a, s) {
  if (typeof s != "function" && s !== null) throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics(a, s);
  function c() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : (c.prototype = s.prototype, new c());
}
var __assign = function() {
  return __assign = Object.assign || function(s) {
    for (var c, u = 1, d = arguments.length; u < d; u++) {
      c = arguments[u];
      for (var p in c) Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
    }
    return s;
  }, __assign.apply(this, arguments);
};
function __spreadArray(a, s, c) {
  if (c || arguments.length === 2) for (var u = 0, d = s.length, p; u < d; u++)
    (p || !(u in s)) && (p || (p = Array.prototype.slice.call(s, 0, u)), p[u] = s[u]);
  return a.concat(p || Array.prototype.slice.call(s));
}
function prefix() {
  for (var a = [], s = 0; s < arguments.length; s++)
    a[s] = arguments[s];
  return prefixNames.apply(void 0, __spreadArray(["scena-guides-"], a, !1));
}
var ADDER = prefix("guide", "adder"), GUIDES = prefix("guides"), GUIDE = prefix("guide"), DRAGGING = prefix("dragging"), DISPLAY_DRAG = prefix("display-drag"), GUIDES_CSS = prefixCSS("scena-guides-", `
{
    position: relative;
    width: 100%;
    height: 100%;
}
canvas {
    position: relative;
}
.guide-origin {
    position: absolute;
    width: 1px;
    height: 1px;
    top: 0;
    left: 0;
    opacity: 0;
}
.guides {
    position: absolute;
    bottom: 0;
    right: 0;
    will-change: transform;
    z-index: 2000;
}
.guide-pos {
    position: absolute;
    font-weight: bold;
    font-size: 12px;
    color: #f33;
}
.horizontal .guide-pos {
    bottom: 100%;
    left: 50%;
    transform: translate(-50%);
}
.vertical .guide-pos {
    left: calc(100% + 2px);
    top: 50%;
    transform: translateY(-50%);
}
.display-drag {
    position: absolute;
    will-change: transform;
    z-index: 2000;
    font-weight: bold;
    font-size: 12px;
    display: none;
    left: 20px;
    top: -20px;
    color: #f33;
}
:host.horizontal .guides {
    width: 100%;
    height: 0;
}
:host.vertical .guides {
    height: 100%;
    width: 0;
}
:host.horizontal canvas {
    cursor: ns-resize;
}
:host.vertical canvas {
    cursor: ew-resize;
}
.guide {
    position: absolute;
    background: #f33;
    z-index: 2;
}
.guide.dragging:before {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
:host.horizontal .guide {
    width: 100%;
    height: 1px;
    cursor: row-resize;
}
:host.vertical .guide {
    width: 1px;
    height: 100%;
    cursor: col-resize;
}
.mobile :host.horizontal .guide {
    transform: scale(1, 2);
}
.mobile :host.vertical .guide {
    transform: scale(2, 1);
}
:host.horizontal .guide:before {
    height: 20px;
}
:host.vertical .guide:before {
    width: 20px;
}
.adder {
    display: none;
}
.adder.dragging {
    display: block;
}
`);
__spreadArray(["className", "rulerStyle", "snapThreshold", "snaps", "displayDragPos", "cspNonce", "dragPosFormat", "defaultGuides", "showGuides", "scrollOptions", "guideStyle", "guidesOffset", "digit", "defaultGuidesPos", "dragGuideStyle", "displayGuidePos", "guidePosFormat", "guidePosStyle", "lockGuides", "guidesZoom"], PROPERTIES, !0);
var GuidesElement = styled("div", GUIDES_CSS), Guides = /* @__PURE__ */ function(a) {
  __extends(s, a);
  function s(u) {
    var d = a.call(this, u) || this;
    return d.state = {
      guides: []
    }, d.scrollPos = 0, d.managerRef = reactExports.createRef(), d.guideElements = [], d._isFirstMove = !1, d._zoom = 1, d._guidesZoom = 1, d._observer = null, d.onDragStart = function(p) {
      var v = p.datas, A = p.inputEvent;
      d._isFirstMove = !0, d.movePos(p), d.props.onDragStart(__assign(__assign({}, p), {
        dragElement: v.target
      })), d.gesto.isFlag() && (A.stopPropagation(), A.preventDefault(), d._startDragScroll(p));
    }, d._onDrag = function(p) {
      d._isFirstMove && (d._isFirstMove = !1, addClass(p.datas.target, DRAGGING));
      var v = d.movePos(p);
      if (d.props.onDrag(__assign(__assign({}, p), {
        dragElement: p.datas.target
      })), !d.gesto.isFlag()) {
        d._endDragScroll(p);
        return;
      }
      return d._dragScroll(p), v;
    }, d.onDragEnd = function(p) {
      var v = p.datas, A = p.isDouble, x = p.distX, g = p.distY, b = d.movePos(p), y = d.state.guides, f = d.props, m = f.onChangeGuides, C = f.displayDragPos, w = f.digit, S = f.lockGuides, $ = f.guidesOffset, T = d._guidesZoom, I = parseFloat((b / T).toFixed(w || 0)), _ = d.scrollPos - ($ || 0);
      if (C && (d.displayElement.style.cssText += "display: none;"), removeClass(v.target, DRAGGING), d.props.onDragEnd(__assign(__assign({}, p), {
        dragElement: v.target
      })), d._endDragScroll(p), v.fromRuler)
        d._isFirstMove && d.props.onClickRuler(__assign(__assign({}, p), {
          pos: 0
        })), I >= _ && y.indexOf(I) < 0 && d.setState({
          guides: __spreadArray(__spreadArray([], y, !0), [I], !1)
        }, function() {
          m({
            guides: d.state.guides,
            distX: x,
            distY: g,
            index: y.length,
            isAdd: !0,
            isRemove: !1,
            isChange: !1
          });
        });
      else {
        var E = parseFloat(v.target.getAttribute("data-index")), R = !1, O = !1;
        y = __spreadArray([], y, !0);
        var L = y.indexOf(I);
        if (A || I < _ || L > -1 && L !== E) {
          if (S && (S === !0 || S.indexOf("remove") > -1))
            return;
          y.splice(E, 1), R = !0;
        } else {
          if (L > -1)
            return;
          if (S && (S === !0 || S.indexOf("change") > -1))
            return;
          y[E] = I, O = !0;
        }
        d.setState({
          guides: y
        }, function() {
          var B = d.state.guides;
          m({
            distX: x,
            distY: g,
            guides: B,
            isAdd: !1,
            index: E,
            isChange: O,
            isRemove: R
          });
        });
      }
    }, d._onCheck = function() {
      d.resize();
    }, d.state.guides = u.defaultGuides || [], d.scrollPos = u.defaultGuidesPos || 0, d;
  }
  var c = s.prototype;
  return c.render = function() {
    var u = this.props, d = u.className, p = u.type, v = u.zoom, A = u.guidesZoom, x = u.style, g = u.rulerStyle, b = u.displayDragPos, y = u.cspNonce, f = u.dragGuideStyle, m = u.guidePosStyle, C = m === void 0 ? {} : m, w = this.props, S = this.getTranslateName(), $ = {};
    return PROPERTIES.forEach(function(T) {
      T === "style" || T === "warpSelf" || T === "useResizeObserver" || ($[T] = w[T]);
    }), this._zoom = v, this._guidesZoom = A || v, reactExports.createElement(GuidesElement, {
      ref: this.managerRef,
      cspNonce: y,
      className: "".concat(prefix("manager", p), " ").concat(d),
      style: x
    }, reactExports.createElement("div", {
      className: prefix("guide-origin"),
      ref: ref(this, "originElement")
    }), reactExports.createElement(Ruler, __assign({
      ref: ref(this, "ruler"),
      style: g
    }, $)), reactExports.createElement("div", {
      className: GUIDES,
      ref: ref(this, "guidesElement"),
      style: {
        transform: "".concat(S, "(").concat(-this.scrollPos * this._guidesZoom, "px)")
      }
    }, b && reactExports.createElement("div", {
      className: DISPLAY_DRAG,
      ref: ref(this, "displayElement"),
      style: C || {}
    }), reactExports.createElement("div", {
      className: ADDER,
      ref: ref(this, "adderElement"),
      style: f
    }), this.renderGuides()));
  }, c.drawRuler = function(u) {
    this.ruler.draw(u);
  }, c.renderGuides = function() {
    var u = this, d = this.props, p = d, v = p.type, A = p.showGuides, x = p.guideStyle, g = p.displayGuidePos, b = p.guidePosStyle, y = b === void 0 ? {} : b, f = p.guidesOffset, m = this._guidesZoom, C = this.getTranslateName(), w = this.state.guides, S = d.guidePosFormat || d.dragPosFormat || function($) {
      return $;
    };
    if (this.guideElements = [], A)
      return w.map(function($, T) {
        var I = $ + (f || 0);
        return reactExports.createElement("div", {
          className: prefix("guide", v),
          ref: refs(u, "guideElements", T),
          key: T,
          "data-index": T,
          "data-pos": $,
          style: __assign(__assign({}, x), {
            transform: "".concat(C, "(").concat(I * m, "px) translateZ(0px)")
          })
        }, g && reactExports.createElement("div", {
          className: prefix("guide-pos"),
          style: y || {}
        }, S($)));
      });
  }, c.componentDidMount = function() {
    var u = this;
    this.gesto = new Gesto(this.managerRef.current, {
      container: document.body
    }).on("dragStart", function(d) {
      var p = u.props, v = p.type, A = p.lockGuides, x = u._guidesZoom;
      if (A === !0) {
        d.stop();
        return;
      }
      var g = d.inputEvent, b = g.target, y = d.datas, f = u.ruler.canvasElement, m = u.guidesElement, C = v === "horizontal", w = u.originElement.getBoundingClientRect(), S = getDistElementMatrix(u.managerRef.current), $ = calculateMatrixDist(S, [d.clientX - w.left, d.clientY - w.top]);
      $[0] -= m.offsetLeft, $[1] -= m.offsetTop, $[C ? 1 : 0] += u.scrollPos * x, y.offsetPos = $, y.matrix = S;
      var T = A && A.indexOf("add") > -1, I = A && A.indexOf("remove") > -1, _ = A && A.indexOf("change") > -1;
      if (b === f) {
        if (T) {
          d.stop();
          return;
        }
        y.fromRuler = !0, y.target = u.adderElement;
      } else if (hasClass(b, GUIDE)) {
        if (I && _) {
          d.stop();
          return;
        }
        y.target = b;
      } else
        return d.stop(), !1;
      u.onDragStart(d);
    }).on("drag", this._onDrag).on("dragEnd", this.onDragEnd), this.props.useResizeObserver ? (this._observer = new ResizeObserver(this._onCheck), this._observer.observe(this.guidesElement, {
      box: "border-box"
    }), this._observer.observe(this.getRulerElement(), {
      box: "border-box"
    })) : this._onCheck();
  }, c.componentWillUnmount = function() {
    var u;
    this.gesto.unset(), (u = this._observer) === null || u === void 0 || u.disconnect();
  }, c.componentDidUpdate = function(u) {
    var d = this.props.defaultGuides;
    u.defaultGuides !== d && this.setState({
      guides: d || []
    });
  }, c.loadGuides = function(u) {
    this.setState({
      guides: u
    });
  }, c.getGuides = function() {
    return this.state.guides;
  }, c.scrollGuides = function(u, d) {
    d === void 0 && (d = this._guidesZoom), this._setZoom({
      guidesZoom: d
    });
    var p = this.getTranslateName(), v = this.guidesElement;
    this.scrollPos = u, v.style.transform = "".concat(p, "(").concat(-u * d, "px)");
    var A = this.state.guides, x = this.props.guidesOffset || 0;
    this.guideElements.forEach(function(g, b) {
      if (g) {
        var y = A[b] + (x || 0);
        g.style.transform = "".concat(p, "(").concat(y * d, "px) translateZ(0px)"), g.style.display = -u + y < 0 ? "none" : "block";
      }
    });
  }, c.zoomTo = function(u, d) {
    d === void 0 && (d = u), this.scroll(this.getRulerScrollPos(), u), this.scrollGuides(this.getGuideScrollPos(), d);
  }, c.getElement = function() {
    return this.managerRef.current;
  }, c.getRulerElement = function() {
    return this.ruler.canvasElement;
  }, c.getGuideScrollPos = function() {
    return this.scrollPos;
  }, c.getRulerScrollPos = function() {
    return this.ruler.getScrollPos();
  }, c.scroll = function(u, d) {
    d === void 0 && (d = this._zoom), this._setZoom({
      zoom: d
    }), this.ruler.scroll(u, d);
  }, c.resize = function(u) {
    u === void 0 && (u = this._zoom), this._setZoom({
      zoom: u
    }), this.ruler.resize(u);
  }, c.movePos = function(u) {
    var d = u.datas, p = u.distX, v = u.distY, A = this.props, x = A.type, g = A.snaps, b = A.snapThreshold, y = A.displayDragPos, f = A.digit, m = A.guidesOffset || 0, C = this._guidesZoom, w = A.dragPosFormat || function(M) {
      return M;
    }, S = x === "horizontal", $ = calculateMatrixDist(d.matrix, [p, v]), T = d.offsetPos, I = $[0] + T[0], _ = $[1] + T[1], E = m * C, R = Math.round(S ? _ : I) - m, O = parseFloat((R / C).toFixed(f || 0)), L = g.slice().sort(function(M, W) {
      return Math.abs(O - M) - Math.abs(O - W);
    });
    if (L.length && Math.abs(L[0] * C - R) < b && (O = L[0], R = O * C), !d.fromRuler || !this._isFirstMove) {
      if (y) {
        var B = x === "horizontal" ? [I, R + E] : [R + E, _];
        this.displayElement.style.cssText += "display: block;transform: translate(-50%, -50%) " + "translate(".concat(B.map(function(M) {
          return "".concat(M, "px");
        }).join(", "), ")"), this.displayElement.innerHTML = "".concat(w(O));
      }
      var F = d.target;
      F.setAttribute("data-pos", O), F.style.transform = "".concat(this.getTranslateName(), "(").concat(R + m * C, "px)");
    }
    return R;
  }, c.getTranslateName = function() {
    return this.props.type === "horizontal" ? "translateY" : "translateX";
  }, c._startDragScroll = function(u) {
    var d = this, p = this.props.scrollOptions;
    if (p) {
      var v = u.datas, A = new DragScroll();
      v.dragScroll = A, A.on("scroll", function(x) {
        var g, b, y = x.container, f = x.direction;
        (b = (g = d.props).onRequestScroll) === null || b === void 0 || b.call(g, {
          container: y,
          direction: f
        });
      }).on("move", function(x) {
        var g = x.offsetX, b = x.offsetY, y = x.inputEvent;
        d.gesto.scrollBy(g, b, y.inputEvent, !0);
      }), A.dragStart(u, {
        container: p.container
      });
    }
  }, c._dragScroll = function(u) {
    var d = this.props.scrollOptions;
    if (d) {
      var p = u.datas.dragScroll;
      p.drag(u, d);
    }
  }, c._endDragScroll = function(u) {
    var d;
    (d = u.datas.dragScroll) === null || d === void 0 || d.dragEnd(), u.datas.dragScroll = null;
  }, c._setZoom = function(u) {
    var d = u.zoom, p = u.guidesZoom;
    this.props.zoom;
    var v = !!this.props.guidesZoom;
    v ? p && (this._guidesZoom = p) : (p && (this._zoom = p, this._guidesZoom = p), d && (this._guidesZoom = d)), d && (this._zoom = d);
  }, s.defaultProps = {
    className: "",
    type: "horizontal",
    zoom: 1,
    guidesZoom: 0,
    style: {},
    snapThreshold: 5,
    snaps: [],
    digit: 0,
    onClickRuler: function() {
    },
    onChangeGuides: function() {
    },
    onRequestScroll: function() {
    },
    onDragStart: function() {
    },
    onDrag: function() {
    },
    onDragEnd: function() {
    },
    displayDragPos: !1,
    dragPosFormat: function(u) {
      return u;
    },
    defaultGuides: [],
    lockGuides: !1,
    showGuides: !0,
    guideStyle: {},
    dragGuideStyle: {},
    guidePosStyle: {},
    defaultGuidesPos: 0
  }, s;
}(reactExports.PureComponent);
const guideStyle = (a, s, c, u) => ({
  position: "absolute",
  top: a,
  left: s,
  height: c,
  width: u,
  background: "#333333"
}), _Guides = ({
  paperSize: a,
  horizontalRef: s,
  verticalRef: c
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "ruler-container",
      style: guideStyle(-RULER_HEIGHT, -RULER_HEIGHT, RULER_HEIGHT, RULER_HEIGHT)
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Guides,
    {
      zoom: ZOOM,
      style: guideStyle(-RULER_HEIGHT, 0, RULER_HEIGHT, a.width),
      type: "horizontal",
      ref: s
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Guides,
    {
      zoom: ZOOM,
      style: guideStyle(0, -RULER_HEIGHT, a.height, RULER_HEIGHT),
      type: "vertical",
      ref: c
    }
  )
] }), Mask = ({ width: a, height: s }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    style: {
      position: "absolute",
      top: -RULER_HEIGHT,
      left: -RULER_HEIGHT,
      zIndex: 100,
      width: a,
      height: s,
      background: theme.useToken().token.colorBgMask
    }
  }
), getPaddingStyle = (a, s, c) => {
  const u = {
    position: "absolute",
    background: c,
    opacity: 0.25,
    pointerEvents: "none"
  };
  switch (a) {
    case 0:
      u.top = 0, u.height = `${s * ZOOM}px`, u.left = 0, u.right = 0;
      break;
    case 1:
      u.right = 0, u.width = `${s * ZOOM}px`, u.top = 0, u.bottom = 0;
      break;
    case 2:
      u.bottom = 0, u.height = `${s * ZOOM}px`, u.left = 0, u.right = 0;
      break;
    case 3:
      u.left = 0, u.width = `${s * ZOOM}px`, u.top = 0, u.bottom = 0;
      break;
  }
  return u;
}, Padding = ({ basePdf: a }) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: isBlankPdf(a) && a.padding.map((s, c) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: getPaddingStyle(c, s, theme.useToken().token.colorError) }, String(c))) }), StaticSchema = (a) => {
  const {
    template: { schemas: s, basePdf: c },
    input: u,
    scale: d,
    totalPages: p,
    currentPage: v
  } = a;
  return !isBlankPdf(c) || !c.staticSchema ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: c.staticSchema.map((A) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Renderer,
    {
      schema: { ...A, id: uuid$6() },
      basePdf: c,
      value: A.readOnly ? replacePlaceholders({
        content: A.content || "",
        variables: { ...u, totalPages: p, currentPage: v },
        schemas: s
      }) : A.content || "",
      onChangeHoveringSchemaId: () => {
      },
      mode: "viewer",
      outline: "none",
      scale: d,
      selectable: !1
    },
    A.name
  )) });
}, mm2px = (a) => a * 3.7795275591, DELETE_BTN_ID = uuid$6(), fmt4Num = (a) => Number(a.replace("px", "")), fmt = (a) => round$1(fmt4Num(a) / ZOOM, 2), isTopLeftResize = (a) => a === "-1,-1" || a === "-1,0" || a === "0,-1", normalizeRotate = (a) => (a % 360 + 360) % 360, DeleteButton = ({ activeElements: a }) => {
  const { token: s } = theme.useToken(), c = 26, u = Math.min(...a.map(({ style: p }) => fmt4Num(p.top))), d = Math.max(...a.map(({ style: p }) => fmt4Num(p.left) + fmt4Num(p.width))) + 10;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$1,
    {
      id: DELETE_BTN_ID,
      style: {
        position: "absolute",
        zIndex: 1,
        top: u,
        left: d,
        width: c,
        height: c,
        padding: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: s.borderRadius,
        color: s.colorWhite,
        background: s.colorPrimary
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(X, { style: { pointerEvents: "none" } })
    }
  );
}, Canvas = (a, s) => {
  const {
    basePdf: c,
    pageCursor: u,
    scale: d,
    backgrounds: p,
    pageSizes: v,
    size: A,
    activeElements: x,
    schemasList: g,
    hoveringSchemaId: b,
    onEdit: y,
    changeSchemas: f,
    removeSchemas: m,
    onChangeHoveringSchemaId: C,
    paperRefs: w,
    sidebarOpen: S
  } = a, { token: $ } = theme.useToken(), T = reactExports.useContext(PluginsRegistry), I = reactExports.useRef([]), _ = reactExports.useRef([]), E = reactExports.useRef(null), [R, O] = reactExports.useState(!1), [L, B] = reactExports.useState(!1), F = usePrevious(g[u]), M = (ee) => {
    ee.shiftKey && O(!0);
  }, W = (ee) => {
    (ee.key === "Shift" || !ee.shiftKey) && O(!1), (ee.key === "Escape" || ee.key === "Esc") && B(!1);
  }, j = reactExports.useCallback(() => {
    window.addEventListener("keydown", M), window.addEventListener("keyup", W);
  }, []), G = reactExports.useCallback(() => {
    window.removeEventListener("keydown", M), window.removeEventListener("keyup", W);
  }, []);
  reactExports.useEffect(() => (j(), G), [j, G]), reactExports.useEffect(() => {
    if (E.current?.updateRect(), !F)
      return;
    const ee = JSON.stringify(F[u] || {}), Q = JSON.stringify(g[u] || {});
    ee === Q && E.current?.updateRect();
  }, [u, g, F]);
  const U = ({ target: ee, top: Q, left: J }) => {
    const { width: te, height: ae } = ee.style, se = fmt(te), ie = fmt(ae), fe = Q / ZOOM, ge = J / ZOOM, { width: me, height: pe } = v[u];
    let be = 0, le = 0, ve = 0, he = 0;
    if (isBlankPdf(c)) {
      const [ye, Ce, xe, we] = c.padding;
      be = ye * ZOOM, le = Ce, ve = xe, he = we * ZOOM;
    }
    fe + ie > pe - ve ? ee.style.top = `${(pe - ie - ve) * ZOOM}px` : ee.style.top = `${Q < be ? be : Q}px`, ge + se > me - le ? ee.style.left = `${(me - se - le) * ZOOM}px` : ee.style.left = `${J < he ? he : J}px`;
  }, k = ({ target: ee }) => {
    const { top: Q, left: J } = ee.style;
    f([
      { key: "position.y", value: fmt(Q), schemaId: ee.id },
      { key: "position.x", value: fmt(J), schemaId: ee.id }
    ]);
  }, N = ({ targets: ee }) => {
    const Q = ee.map(({ style: { top: J, left: te }, id: ae }) => [
      { key: "position.y", value: fmt(J), schemaId: ae },
      { key: "position.x", value: fmt(te), schemaId: ae }
    ]);
    f(flatten(Q));
  }, P = ({ target: ee, rotate: Q }) => {
    ee.style.transform = `rotate(${Q}deg)`;
  }, D = ({ target: ee }) => {
    const { transform: Q } = ee.style, J = Number(Q.replace("rotate(", "").replace("deg)", "")), te = normalizeRotate(J);
    f([{ key: "rotate", value: te, schemaId: ee.id }]);
  }, H = ({ targets: ee }) => {
    const Q = ee.map(({ style: { transform: J }, id: te }) => {
      const ae = Number(J.replace("rotate(", "").replace("deg)", ""));
      return [{ key: "rotate", value: normalizeRotate(ae), schemaId: te }];
    });
    f(flatten(Q));
  }, V = ({ target: ee }) => {
    const { id: Q, style: J } = ee, { width: te, height: ae, top: se, left: ie } = J;
    f([
      { key: "position.x", value: fmt(ie), schemaId: Q },
      { key: "position.y", value: fmt(se), schemaId: Q },
      { key: "width", value: fmt(te), schemaId: Q },
      { key: "height", value: fmt(ae), schemaId: Q }
    ]);
    const fe = g[u].find((ge) => ge.id === Q);
    fe && (fe.position.x = fmt(ie), fe.position.y = fmt(se), fe.width = fmt(te), fe.height = fmt(ae));
  }, Z = ({ targets: ee }) => {
    const Q = ee.map(({ style: { width: J, height: te, top: ae, left: se }, id: ie }) => [
      { key: "width", value: fmt(J), schemaId: ie },
      { key: "height", value: fmt(te), schemaId: ie },
      { key: "position.y", value: fmt(ae), schemaId: ie },
      { key: "position.x", value: fmt(se), schemaId: ie }
    ]);
    f(flatten(Q));
  }, ne = ({ target: ee, width: Q, height: J, direction: te }) => {
    if (!ee) return;
    let ae = 0, se = 0, ie = 0, fe = 0;
    if (isBlankPdf(c)) {
      const [ye, Ce, xe, we] = c.padding;
      ae = ye * ZOOM, se = mm2px(Ce), ie = mm2px(xe), fe = we * ZOOM;
    }
    const ge = mm2px(v[u].width), me = mm2px(v[u].height), pe = {
      width: `${Q}px`,
      height: `${J}px`
    }, be = ee.style;
    let le = fmt4Num(be.left) + (fmt4Num(be.width) - Q), ve = fmt4Num(be.top) + (fmt4Num(be.height) - J);
    le < fe && (le = fe), ve < ae && (ve = ae), le + Q > ge - se && (pe.width = `${ge - se - le}px`), ve + J > me - ie && (pe.height = `${me - ie - ve}px`);
    const he = te.toString();
    isTopLeftResize(he) ? (pe.top = `${ve}px`, pe.left = `${le}px`) : he === "1,-1" ? pe.top = `${ve}px` : he === "-1,1" && (pe.left = `${le}px`), Object.assign(be, pe);
  }, K = (ee, Q) => ee[Q] && ee[Q].getGuides().map((J) => J * ZOOM), q = () => {
    B(!0);
  }, Y = reactExports.useMemo(() => {
    const Q = (g[u] || []).filter(
      (ae) => x.map((se) => se.id).includes(ae.id)
    ).map((ae) => ae.type), J = [...new Set(Q)], te = [];
    return T.entries().forEach(([, ae]) => {
      ae.propPanel.defaultSchema && te.push(ae.propPanel.defaultSchema);
    }), J.every((ae) => {
      const se = te.find((ie) => ie && "type" in ie && ie.type === ae);
      return se && "rotate" in se;
    });
  }, [x, u, g, T]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        position: "relative",
        overflow: "auto",
        marginRight: S ? RIGHT_SIDEBAR_WIDTH : 0,
        ...A
      },
      ref: s,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Selecto,
          {
            container: w.current[u],
            continueSelect: R,
            onDragStart: (ee) => {
              const Q = ee.inputEvent, J = Q.target, te = E.current?.isMoveableElement(J);
              (Q.type === "touchstart" && ee.isTrusted || te) && ee.stop(), w.current[u] === J && y([]);
              const ae = J;
              ae && ae.id === DELETE_BTN_ID && m(x.map((se) => se.id));
            },
            onSelect: (ee) => {
              const Q = ee.inputEvent, J = ee.added, te = ee.removed, ae = ee.selected, se = Q.type === "mousedown";
              let ie = se ? ae : [];
              !se && J.length > 0 && (ie = x.concat(J)), !se && te.length > 0 && (ie = x.filter((ge) => !te.includes(ge))), y(ie), ie != x && B(!1);
              const fe = Q;
              fe && typeof fe.shiftKey == "boolean" && !fe.shiftKey && O(!1);
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paper,
          {
            paperRefs: w,
            scale: d,
            size: A,
            schemasList: g,
            pageSizes: v,
            backgrounds: p,
            hasRulers: !0,
            renderPaper: ({ index: ee, paperSize: Q }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              !L && x.length > 0 && u === ee && /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteButton, { activeElements: x }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Padding, { basePdf: c }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                StaticSchema,
                {
                  template: { schemas: g, basePdf: c },
                  input: Object.fromEntries(
                    g.flat().map(({ name: J, content: te = "" }) => [J, te])
                  ),
                  scale: d,
                  totalPages: g.length,
                  currentPage: ee + 1
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                _Guides,
                {
                  paperSize: Q,
                  horizontalRef: (J) => {
                    J && (_.current[ee] = J);
                  },
                  verticalRef: (J) => {
                    J && (I.current[ee] = J);
                  }
                }
              ),
              u !== ee ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                Mask,
                {
                  width: Q.width + RULER_HEIGHT,
                  height: Q.height + RULER_HEIGHT
                }
              ) : !L && /* @__PURE__ */ jsxRuntimeExports.jsx(
                Moveable$1,
                {
                  ref: E,
                  target: x,
                  bounds: { left: 0, top: 0, bottom: Q.height, right: Q.width },
                  horizontalGuidelines: K(_.current, ee),
                  verticalGuidelines: K(I.current, ee),
                  keepRatio: R,
                  rotatable: Y,
                  onDrag: U,
                  onDragEnd: k,
                  onDragGroupEnd: N,
                  onRotate: P,
                  onRotateEnd: D,
                  onRotateGroupEnd: H,
                  onResize: ne,
                  onResizeEnd: V,
                  onResizeGroupEnd: Z,
                  onClick: q
                }
              )
            ] }),
            renderSchema: ({ schema: ee, index: Q }) => {
              const J = L && x.map((se) => se.id).includes(ee.id) ? "designer" : "viewer", te = ee.content || "";
              let ae = te;
              if (J !== "designer" && ee.readOnly) {
                const se = {
                  ...g.flat().reduce(
                    (ie, fe) => (ie[fe.name] = fe.content || "", ie),
                    {}
                  ),
                  totalPages: g.length,
                  currentPage: Q + 1
                };
                ae = replacePlaceholders({ content: te, variables: se, schemas: g });
              }
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                Renderer,
                {
                  schema: ee,
                  basePdf: c,
                  value: ae,
                  onChangeHoveringSchemaId: C,
                  mode: J,
                  onChange: (g[u] || []).some((se) => se.id === ee.id) ? (se) => {
                    const ie = Array.isArray(se) ? se : [se];
                    f(
                      ie.map(({ key: fe, value: ge }) => ({ key: fe, value: ge, schemaId: ee.id }))
                    );
                  } : void 0,
                  stopEditing: () => B(!1),
                  outline: `1px ${b === ee.id ? "solid" : "dashed"} ${ee.readOnly && b !== ee.id ? "transparent" : $.colorPrimary}`,
                  scale: d
                },
                ee.id
              );
            }
          }
        )
      ]
    }
  );
}, Canvas$1 = reactExports.forwardRef(Canvas), Spinner = () => {
  const { token: a } = theme.useToken(), s = {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    color: a.colorPrimary
  }, c = {
    animation: "spin 1s linear infinite"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  ` }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: s, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderCircle, { size: 50, style: c }) })
  ] });
}, Root = ({ size: a, scale: s, children: c }, u) => {
  const d = reactExports.useContext(FontContext);
  return reactExports.useEffect(() => {
    if (!document || !document.fonts) return;
    const v = Object.entries(d).map(
      ([A, { data: x }]) => new FontFace(A, typeof x == "string" ? `url(${x})` : x, {
        display: "swap"
      })
    ).filter((A) => !document.fonts.has(A));
    Promise.allSettled(v.map((A) => A.load())).then((A) => {
      A.forEach((x) => {
        x.status === "fulfilled" && document.fonts.add(x.value);
      });
    });
  }, [d]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: u, style: { position: "relative", background: BACKGROUND_COLOR, ...a }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { margin: "0 auto", ...a }, children: s === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}) : c }) });
}, Root$1 = reactExports.forwardRef(Root), ErrorScreen = ({ size: a, error: s }) => {
  const c = reactExports.useContext(I18nContext), { token: u } = theme.useToken();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        background: BACKGROUND_COLOR,
        ...a
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { width: 300, margin: "0 auto", background: u.colorBgLayout }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Result$1,
        {
          icon: null,
          title: "ERROR",
          subTitle: c("errorOccurred"),
          extra: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: s.message })
        }
      ) })
    }
  );
}, { Text: Text$1 } = Typography, Zoom = ({ zoomLevel: a, setZoomLevel: s, style: c }) => {
  const d = useMaxZoom(), p = 0.25, v = a - 0.25, A = a + 0.25;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        type: "text",
        disabled: p >= v,
        onClick: () => s(v),
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Minus, { size: 16, color: c.textStyle.color })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { strong: !0, style: c.textStyle, children: [
      Math.round(a * 100),
      "%"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        type: "text",
        disabled: d < A,
        onClick: () => s(A),
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Plus, { size: 16, color: c.textStyle.color })
      }
    )
  ] });
}, Pager = ({ pageCursor: a, pageNum: s, setPageCursor: c, style: u }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { type: "text", disabled: a <= 0, onClick: () => c(a - 1), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronLeft, { size: 16, color: u.textStyle.color }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { strong: !0, style: u.textStyle, children: [
    a + 1,
    "/",
    s
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$1,
    {
      type: "text",
      disabled: a + 1 >= s,
      onClick: () => c(a + 1),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRight, { size: 16, color: u.textStyle.color })
    }
  )
] }), ContextMenu = ({ items: a, style: s }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { menu: { items: a }, placement: "top", arrow: !0, trigger: ["click"], children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { type: "text", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ellipsis, { size: 16, color: s.textStyle.color }) }) }), CtlBar = (a) => {
  const { token: s } = theme.useToken(), c = reactExports.useContext(I18nContext), {
    size: u,
    pageCursor: d,
    pageNum: p,
    setPageCursor: v,
    zoomLevel: A,
    setZoomLevel: x,
    addPageAfter: g,
    removePage: b
  } = a, y = [];
  g && y.push({
    key: "1",
    label: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: g, children: c("addPageAfter") })
  }), b && p > 1 && d !== 0 && y.push({
    key: "2",
    label: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: b, children: c("removePage") })
  });
  const f = 300, m = y.length > 0 ? 50 : 0, C = (p > 1 ? f : f / 2) + m, w = {
    color: s.colorWhite,
    fontSize: s.fontSize,
    margin: s.marginXS
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { position: "absolute", top: "auto", bottom: "6%", width: u.width }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        position: "relative",
        zIndex: 1,
        left: `calc(50% - ${C / 2}px)`,
        width: C,
        height: 40,
        boxSizing: "border-box",
        padding: s.paddingSM,
        borderRadius: s.borderRadius,
        backgroundColor: s.colorBgMask
      },
      children: [
        p > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Pager,
          {
            style: { textStyle: w },
            pageCursor: d,
            pageNum: p,
            setPageCursor: v
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Zoom, { style: { textStyle: w }, zoomLevel: A, setZoomLevel: x }),
        y.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ContextMenu, { items: y, style: { textStyle: w } })
      ]
    }
  ) });
}, scaleDragPosAdjustment = (a, s) => s > 1 ? a * (s - 1) : s < 1 ? a * -(1 - s) : 0, TemplateEditor = ({
  template: a,
  size: s,
  onSaveTemplate: c,
  onChangeTemplate: u,
  onPageCursorChange: d
}) => {
  const p = reactExports.useRef([]), v = reactExports.useRef([]), A = reactExports.useRef(null), x = reactExports.useRef([]), g = reactExports.useContext(I18nContext), b = reactExports.useContext(PluginsRegistry), y = reactExports.useContext(OptionsContext), f = useMaxZoom(), [m, C] = reactExports.useState(null), [w, S] = reactExports.useState([]), [$, T] = reactExports.useState([[]]), [I, _] = reactExports.useState(0), [E, R] = reactExports.useState(y.zoomLevel ?? 1), [O, L] = reactExports.useState(y.sidebarOpen ?? !0), [B, F] = reactExports.useState(null), { backgrounds: M, pageSizes: W, scale: j, error: G, refresh: U } = useUIPreProcessor({
    template: a,
    size: s,
    zoomLevel: E,
    maxZoom: f
  }), k = (ae) => {
    S(ae), C(null);
  }, N = () => {
    S([]), C(null);
  };
  reactExports.useEffect(() => {
    typeof y.zoomLevel == "number" && y.zoomLevel !== E && R(y.zoomLevel), typeof y.sidebarOpen == "boolean" && y.sidebarOpen !== O && L(y.sidebarOpen);
  }, [y]), useScrollPageCursor({
    ref: A,
    pageSizes: W,
    scale: j,
    pageCursor: I,
    onChangePageCursor: (ae) => {
      _(ae), d(ae), N();
    }
  });
  const P = reactExports.useCallback(
    (ae) => {
      v.current = [], p.current.push(cloneDeep$1($[I]));
      const se = cloneDeep$1($);
      se[I] = ae, T(se), u(schemasList2template(se, a.basePdf));
    },
    [a, $, I, u]
  ), D = reactExports.useCallback(
    (ae) => {
      P($[I].filter((se) => !ae.includes(se.id))), N();
    },
    [$, I, P]
  ), H = reactExports.useCallback(
    (ae) => {
      changeSchemas({
        objs: ae,
        schemas: $[I],
        basePdf: a.basePdf,
        pluginsRegistry: b,
        pageSize: W[I],
        commitSchemas: P
      });
    },
    [P, I, $, b, W, a.basePdf]
  );
  useInitEvents({
    pageCursor: I,
    pageSizes: W,
    activeElements: w,
    template: a,
    schemasList: $,
    changeSchemas: H,
    commitSchemas: P,
    removeSchemas: D,
    onSaveTemplate: c,
    past: p,
    future: v,
    setSchemasList: T,
    onEdit: k,
    onEditEnd: N
  });
  const V = reactExports.useCallback(async (ae) => {
    const se = await template2SchemasList(ae);
    T(se), N(), _(0), A.current?.scroll && A.current.scroll({ top: 0, behavior: "smooth" });
  }, []), Z = (ae) => {
    const [se, ie, fe, ge] = isBlankPdf(a.basePdf) ? a.basePdf.padding : [0, 0, 0, 0], me = W[I], pe = (ve) => {
      let he = $.reduce((Ce, xe) => Ce + xe.length, 1), ye = ve + he;
      for (; $.some((Ce) => Ce.find((xe) => xe.name === ye)); )
        he++, ye = ve + he;
      return ye;
    }, be = (ve, he, ye) => Math.min(Math.max(ve, he), ye), le = {
      id: uuid$6(),
      ...ae,
      name: pe(g("field")),
      position: {
        x: be(
          ge,
          ae.position.x,
          me.width - ie - ae.width
        ),
        y: be(
          se,
          ae.position.y,
          me.height - fe - ae.height
        )
      },
      required: ae.readOnly ? !1 : y.requiredByDefault || ae.required || !1
    };
    if (ae.position.y === 0) {
      const ve = x.current[I], he = ve ? ve.getBoundingClientRect().top : 0;
      le.position.y = he > 0 ? se : W[I].height / 2;
    }
    P($[I].concat(le)), setTimeout(() => k([document.getElementById(le.id)]));
  }, ne = (ae) => {
    P(ae);
  }, K = (ae) => {
    C(ae);
  }, q = async (ae, se) => {
    _(se);
    const ie = schemasList2template(ae, a.basePdf);
    u(ie), await V(ie), U(ie), setTimeout(() => {
      A.current && (A.current.scrollTop = getPagesScrollTopByIndex(W, se, j));
    }, 0);
  }, Y = () => {
    if (I === 0 || !window.confirm(g("removePageConfirm"))) return;
    const ae = cloneDeep$1($);
    ae.splice(I, 1), q(ae, I - 1);
  }, ee = () => {
    const ae = cloneDeep$1($);
    ae.splice(I + 1, 0, []), q(ae, I + 1);
  };
  B !== a && (F(a), V(a));
  const Q = s.width - LEFT_SIDEBAR_WIDTH, J = {
    width: O ? Q - RIGHT_SIDEBAR_WIDTH : Q,
    height: s.height
  };
  if (G)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorScreen, { size: s, error: G });
  const te = isBlankPdf(a.basePdf) ? { addPageAfter: ee, removePage: Y } : {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Root$1, { size: s, scale: j, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    DndContext,
    {
      onDragEnd: (ae) => {
        if (!ae.active) return;
        const se = ae.active, ie = x.current[I].getBoundingClientRect(), fe = se.rect.current.initial?.left || 0, ge = se.rect.current.initial?.top || 0, me = ie.left - fe + scaleDragPosAdjustment(20, j), pe = ie.top - ge, be = (ae.delta.y - pe) / j, le = (ae.delta.x - me) / j, ve = {
          x: round$1(px2mm(Math.max(0, le)), 2),
          y: round$1(px2mm(Math.max(0, be)), 2)
        };
        Z({ ...se.data.current, position: ve });
      },
      onDragStart: N,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          LeftSidebar,
          {
            height: A.current ? A.current.clientHeight : 0,
            scale: j,
            basePdf: a.basePdf
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { position: "absolute", width: Q, marginLeft: LEFT_SIDEBAR_WIDTH }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CtlBar,
            {
              size: J,
              pageCursor: I,
              pageNum: $.length,
              setPageCursor: (ae) => {
                A.current && (A.current.scrollTop = getPagesScrollTopByIndex(W, ae, j), _(ae), N());
              },
              zoomLevel: E,
              setZoomLevel: R,
              ...te
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Sidebar,
            {
              hoveringSchemaId: m,
              onChangeHoveringSchemaId: K,
              height: A.current ? A.current.clientHeight : 0,
              size: s,
              pageSize: W[I] ?? [],
              activeElements: w,
              schemasList: $,
              schemas: $[I] ?? [],
              changeSchemas: H,
              onSortEnd: ne,
              onEdit: (ae) => {
                const se = document.getElementById(ae);
                se && k([se]);
              },
              onEditEnd: N,
              deselectSchema: N,
              sidebarOpen: O,
              setSidebarOpen: L
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Canvas$1,
            {
              ref: A,
              paperRefs: x,
              basePdf: a.basePdf,
              hoveringSchemaId: m,
              onChangeHoveringSchemaId: K,
              height: s.height - RULER_HEIGHT * ZOOM,
              pageCursor: I,
              scale: j,
              size: J,
              pageSizes: W,
              backgrounds: M,
              activeElements: w,
              schemasList: $,
              changeSchemas: H,
              removeSchemas: D,
              sidebarOpen: O,
              onEdit: k
            }
          )
        ] })
      ]
    }
  ) });
}, defaultTheme = {
  token: {
    colorPrimary: "#38a0ff"
  },
  components: {
    Form: {
      fontSize: 12,
      margin: 8,
      marginLG: 12,
      marginXS: 4,
      padding: 8,
      paddingLG: 12,
      paddingXS: 4,
      itemMarginBottom: 4,
      verticalLabelPadding: "0 0 2px"
    }
  }
}, isObject = (a) => !!a && typeof a == "object" && !Array.isArray(a), deepMerge = (a, s) => {
  let c = { ...a };
  return isObject(a) && isObject(s) && Object.keys(s).forEach((u) => {
    const d = s[u];
    if (isObject(d))
      if (!(u in a))
        Object.assign(c, { [u]: d });
      else {
        const p = a[u];
        isObject(p) ? c[u] = deepMerge(p, d) : Object.assign(c, { [u]: d });
      }
    else
      Object.assign(c, { [u]: d });
  }), c;
}, AppContextProvider = ({ children: a, lang: s, font: c, plugins: u, options: d }) => {
  let p = defaultTheme;
  d.theme && (p = deepMerge(
    p,
    d.theme
  ));
  let v = getDict(s);
  return d.labels && (v = deepMerge(
    v,
    d.labels
  )), /* @__PURE__ */ jsxRuntimeExports.jsx(ConfigProvider, { theme: p, children: /* @__PURE__ */ jsxRuntimeExports.jsx(I18nContext.Provider, { value: (A) => i18n(A, v), children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontContext.Provider, { value: c, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PluginsRegistry.Provider, { value: u, children: /* @__PURE__ */ jsxRuntimeExports.jsx(OptionsContext.Provider, { value: d, children: a }) }) }) }) });
};
class Designer extends BaseUIClass {
  constructor(s) {
    super(s), this.pageCursor = 0, checkDesignerProps(s);
  }
  saveTemplate() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    this.onSaveTemplateCallback && this.onSaveTemplateCallback(this.template);
  }
  updateTemplate(s) {
    if (checkTemplate(s), !this.domContainer) throw Error(DESTROYED_ERR_MSG);
    this.template = cloneDeep$1(s), this.onChangeTemplateCallback && this.onChangeTemplateCallback(s), this.render();
  }
  onSaveTemplate(s) {
    this.onSaveTemplateCallback = s;
  }
  onChangeTemplate(s) {
    this.onChangeTemplateCallback = s;
  }
  getPageCursor() {
    return this.pageCursor;
  }
  render() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    ReactDOM.render(
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AppContextProvider,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions(),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            TemplateEditor,
            {
              template: this.template,
              onSaveTemplate: (s) => {
                this.template = s, this.template.pdfmeVersion = PDFME_VERSION, this.onSaveTemplateCallback && this.onSaveTemplateCallback(s);
              },
              onChangeTemplate: (s) => {
                this.template = s, this.template.pdfmeVersion = PDFME_VERSION, this.onChangeTemplateCallback && this.onChangeTemplateCallback(s);
              },
              onPageCursorChange: (s) => {
                this.pageCursor = s;
              },
              size: this.size
            }
          )
        }
      ),
      this.domContainer
    );
  }
}
const { Text } = Typography, icons = {
  left: ChevronLeft,
  right: ChevronRight,
  doubleLeft: ChevronsLeft,
  doubleRight: ChevronsRight
}, UnitButton = ({ type: a, onClick: s, disabled: c, textStyle: u }) => {
  const d = icons[a];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { type: "text", onClick: s, disabled: c, children: /* @__PURE__ */ jsxRuntimeExports.jsx(d, { style: { color: u.color } }) });
}, UnitPager = ({ size: a, unitCursor: s, unitNum: c, setUnitCursor: u }) => {
  if (c <= 1) return null;
  const { token: d } = theme.useToken(), p = {
    pointerEvents: "initial",
    position: "sticky",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    padding: d.paddingSM,
    borderRadius: d.borderRadius,
    backgroundColor: d.colorBgMask
  }, v = {
    color: d.colorWhite,
    fontSize: d.fontSize,
    margin: d.marginXS
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { position: "absolute", ...a }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        position: "sticky",
        width: "100%",
        zIndex: 1,
        top: `calc(50% - ${p.height / 2}px)`,
        display: "flex",
        alignItems: "center"
      },
      children: [
        s > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { left: "1rem", marginLeft: "1rem", ...p }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UnitButton,
            {
              type: "doubleLeft",
              onClick: () => u(0),
              disabled: s <= 0,
              textStyle: v
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UnitButton,
            {
              type: "left",
              onClick: () => u(s - 1),
              disabled: s <= 0,
              textStyle: v
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { strong: !0, style: v, children: [
            s + 1,
            "/",
            c
          ] })
        ] }),
        s + 1 < c && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            style: { right: "1rem", marginLeft: "auto", marginRight: "1rem", ...p },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { strong: !0, style: v, children: [
                s + 1,
                "/",
                c
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                UnitButton,
                {
                  type: "right",
                  onClick: () => u(s + 1),
                  disabled: s + 1 >= c,
                  textStyle: v
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                UnitButton,
                {
                  type: "doubleRight",
                  onClick: () => u(c - 1),
                  disabled: s + 1 >= c,
                  textStyle: v
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, _cache = /* @__PURE__ */ new Map(), Preview = ({
  template: a,
  inputs: s,
  size: c,
  onChangeInput: u
}) => {
  const { token: d } = theme.useToken(), p = reactExports.useContext(FontContext), v = reactExports.useContext(OptionsContext), A = useMaxZoom(), x = reactExports.useRef(null), g = reactExports.useRef([]), [b, y] = reactExports.useState(0), [f, m] = reactExports.useState(0), [C, w] = reactExports.useState(v.zoomLevel ?? 1), [S, $] = reactExports.useState([[]]), { backgrounds: T, pageSizes: I, scale: _, error: E, refresh: R } = useUIPreProcessor({
    template: a,
    size: c,
    zoomLevel: C,
    maxZoom: A
  }), O = !!u, L = s[b], B = (W) => {
    getDynamicTemplate({
      template: W,
      input: L,
      options: { font: p },
      _cache,
      getDynamicHeights: (G, U) => {
        switch (U.schema.type) {
          case "table":
            return getDynamicHeightsForTable(G, U);
          default:
            return Promise.resolve([U.schema.height]);
        }
      }
    }).then(async (G) => {
      const U = await template2SchemasList(G);
      $(U), await R(G);
    }).catch((G) => console.error("[@pdfme/ui] ", G));
  };
  reactExports.useEffect(() => {
    typeof v.zoomLevel == "number" && v.zoomLevel !== C && w(v.zoomLevel);
  }, [v]), reactExports.useEffect(() => {
    b > s.length - 1 && y(s.length - 1), B(a);
  }, [a, s, c]), useScrollPageCursor({
    ref: x,
    pageSizes: I,
    scale: _,
    pageCursor: f,
    onChangePageCursor: m
  });
  const F = ({ name: W, value: j }) => u && u({ index: b, name: W, value: j }), M = (W, j) => {
    let G = !1;
    W.forEach(({ key: U, value: k }) => {
      if (U === "content") {
        const N = k, P = L?.[j.name] || "";
        if (N === P) return;
        F({ name: j.name, value: N }), j.type === "table" && (G = !0);
      } else {
        const N = S[f].find((P) => P.id === j.id);
        if (!N) return;
        N[U] = k;
      }
    }), G && B(a), $([...S]);
  };
  return E ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorScreen, { size: c, error: E }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Root$1, { size: c, scale: _, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CtlBar,
      {
        size: c,
        pageCursor: f,
        pageNum: S.length,
        setPageCursor: (W) => {
          x.current && (x.current.scrollTop = getPagesScrollTopByIndex(I, W, _), m(W));
        },
        zoomLevel: C,
        setZoomLevel: w
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      UnitPager,
      {
        size: c,
        unitCursor: b,
        unitNum: s.length,
        setUnitCursor: y
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: x, style: { ...c, position: "relative", overflow: "auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Paper,
      {
        paperRefs: g,
        scale: _,
        size: c,
        schemasList: S,
        pageSizes: I,
        backgrounds: T,
        renderSchema: ({ schema: W, index: j }) => {
          const G = W.readOnly ? replacePlaceholders({
            content: W.content || "",
            variables: { ...L, totalPages: S.length, currentPage: j + 1 },
            schemas: S
          }) : String(L && L[W.name] || "");
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            Renderer,
            {
              schema: W,
              basePdf: a.basePdf,
              value: G,
              mode: O ? "form" : "viewer",
              placeholder: W.content,
              tabIndex: j + 100,
              onChange: (U) => {
                const k = Array.isArray(U) ? U : [U];
                M(k, W);
              },
              outline: O && !W.readOnly ? `1px dashed ${d.colorPrimary}` : "transparent",
              scale: _
            },
            W.id
          );
        },
        renderPaper: ({ index: W }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          StaticSchema,
          {
            template: a,
            scale: _,
            input: L,
            totalPages: S.length,
            currentPage: W + 1
          }
        )
      }
    ) })
  ] });
};
class Form extends PreviewUI {
  constructor(s) {
    super(s);
  }
  onChangeInput(s) {
    this.onChangeInputCallback = s;
  }
  setInputs(s) {
    const c = this.getInputs();
    super.setInputs(s);
    const u = [];
    s.forEach((d, p) => {
      const v = c[p] || {};
      (/* @__PURE__ */ new Set([...Object.keys(d), ...Object.keys(v)])).forEach((x) => {
        const g = d[x], b = v[x];
        g !== b && u.push({ index: p, name: x, value: g });
      });
    }), u.forEach((d) => {
      this.onChangeInputCallback && this.onChangeInputCallback(d);
    });
  }
  render() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    ReactDOM.render(
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AppContextProvider,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions(),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Preview,
            {
              template: this.template,
              size: this.size,
              inputs: this.inputs,
              onChangeInput: (s) => {
                const { index: c, value: u, name: d } = s;
                this.onChangeInputCallback && this.onChangeInputCallback({ index: c, value: u, name: d }), this.inputs && this.inputs[c] && this.inputs[c][d] !== u && (this.inputs[c][d] = u, this.render());
              }
            }
          )
        }
      ),
      this.domContainer
    );
  }
}
class Viewer extends PreviewUI {
  constructor(s) {
    super(s), console.warn(
      "[@pdfme/ui] Viewer component is deprecated and will be removed in a future version."
    );
  }
  render() {
    if (!this.domContainer) throw Error(DESTROYED_ERR_MSG);
    ReactDOM.render(
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AppContextProvider,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions(),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(Preview, { template: this.template, size: this.size, inputs: this.inputs })
        }
      ),
      this.domContainer
    );
  }
}
export {
  Designer,
  Form,
  Viewer
};
